
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("f3ZL4", function(module, exports) {

$parcel$export(module.exports, "default", () => $af770abdaf769dee$export$2e2bcd8739ae039);

var $2mpFt = parcelRequire("2mpFt");

var $kcGKx = parcelRequire("kcGKx");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $2mpFt.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $kcGKx.default);
var $af770abdaf769dee$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("2mpFt", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b818bf49f333098$export$2e2bcd8739ae039);

var $4kWvg = parcelRequire("4kWvg");
/** Detect free variable `self`. */ var $1b818bf49f333098$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $1b818bf49f333098$var$root = (0, $4kWvg.default) || $1b818bf49f333098$var$freeSelf || Function('return this')();
var $1b818bf49f333098$export$2e2bcd8739ae039 = $1b818bf49f333098$var$root;

});
parcelRegister("4kWvg", function(module, exports) {

$parcel$export(module.exports, "default", () => $32866938ab70cc57$export$2e2bcd8739ae039);
/** Detect free variable `global` from Node.js. */ var $32866938ab70cc57$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $32866938ab70cc57$export$2e2bcd8739ae039 = $32866938ab70cc57$var$freeGlobal;

});


parcelRegister("kcGKx", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb5616d4c933d058$export$2e2bcd8739ae039);
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $eb5616d4c933d058$var$stubFalse() {
    return false;
}
var $eb5616d4c933d058$export$2e2bcd8739ae039 = $eb5616d4c933d058$var$stubFalse;

});


parcelRegister("lFXqE", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc7b86a02b9b077f$export$2e2bcd8739ae039);

var $4kWvg = parcelRequire("4kWvg");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $4kWvg.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
var $fc7b86a02b9b077f$export$2e2bcd8739ae039 = nodeUtil;

});

parcelRegister("39AN4", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("5ygV6").then(()=>parcelRequire('1gLnv'));

});
parcelRegister("Gr8vk", function(module, exports) {
"use strict";

function $07f8f9093a769793$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("27Lyk")).resolve(id));
}
module.exports = $07f8f9093a769793$var$load;

});


var $d4affef42ede28b6$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"9XBCz\",\"index.8310665f.js\",\"5ygV6\",\"core.b58635ba.js\"]"));

/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */ function $a43d996a7aa8a839$var$_defineProperty(e, r, t) {
    return (r = $a43d996a7aa8a839$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $a43d996a7aa8a839$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $a43d996a7aa8a839$var$_setPrototypeOf(t, e);
}
function $a43d996a7aa8a839$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a43d996a7aa8a839$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a43d996a7aa8a839$var$ownKeys(Object(t), !0).forEach(function(r) {
            $a43d996a7aa8a839$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a43d996a7aa8a839$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a43d996a7aa8a839$var$_setPrototypeOf(t, e) {
    return $a43d996a7aa8a839$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $a43d996a7aa8a839$var$_setPrototypeOf(t, e);
}
function $a43d996a7aa8a839$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $a43d996a7aa8a839$var$_toPropertyKey(t) {
    var i = $a43d996a7aa8a839$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $a43d996a7aa8a839$var$_wrapRegExp() {
    $a43d996a7aa8a839$var$_wrapRegExp = function(e, r) {
        return new BabelRegExp(e, void 0, r);
    };
    var e = RegExp.prototype, r = new WeakMap();
    function BabelRegExp(e, t, p) {
        var o = RegExp(e, t);
        return r.set(o, p || r.get(e)), $a43d996a7aa8a839$var$_setPrototypeOf(o, BabelRegExp.prototype);
    }
    function buildGroups(e, t) {
        var p = r.get(t);
        return Object.keys(p).reduce(function(r, t) {
            var o = p[t];
            if ("number" == typeof o) r[t] = e[o];
            else {
                for(var i = 0; void 0 === e[o[i]] && i + 1 < o.length;)i++;
                r[t] = e[o[i]];
            }
            return r;
        }, Object.create(null));
    }
    return $a43d996a7aa8a839$var$_inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function(r) {
        var t = e.exec.call(this, r);
        if (t) {
            t.groups = buildGroups(t, this);
            var p = t.indices;
            p && (p.groups = buildGroups(p, this));
        }
        return t;
    }, BabelRegExp.prototype[Symbol.replace] = function(t, p) {
        if ("string" == typeof p) {
            var o = r.get(this);
            return e[Symbol.replace].call(this, t, p.replace(/\$<([^>]+)>/g, function(e, r) {
                var t = o[r];
                return "$" + (Array.isArray(t) ? t.join("$") : t);
            }));
        }
        if ("function" == typeof p) {
            var i = this;
            return e[Symbol.replace].call(this, t, function() {
                var e = arguments;
                return "object" != typeof e[e.length - 1] && (e = [].slice.call(e)).push(buildGroups(e, i)), p.apply(this, e);
            });
        }
        return e[Symbol.replace].call(this, t, p);
    }, $a43d996a7aa8a839$var$_wrapRegExp.apply(this, arguments);
}
const $a43d996a7aa8a839$var$noop = ()=>{};
let $a43d996a7aa8a839$var$_WINDOW = {};
let $a43d996a7aa8a839$var$_DOCUMENT = {};
let $a43d996a7aa8a839$var$_MUTATION_OBSERVER = null;
let $a43d996a7aa8a839$var$_PERFORMANCE = {
    mark: $a43d996a7aa8a839$var$noop,
    measure: $a43d996a7aa8a839$var$noop
};
try {
    if (typeof window !== 'undefined') $a43d996a7aa8a839$var$_WINDOW = window;
    if (typeof document !== 'undefined') $a43d996a7aa8a839$var$_DOCUMENT = document;
    if (typeof MutationObserver !== 'undefined') $a43d996a7aa8a839$var$_MUTATION_OBSERVER = MutationObserver;
    if (typeof performance !== 'undefined') $a43d996a7aa8a839$var$_PERFORMANCE = performance;
} catch (e) {}
const { userAgent: $a43d996a7aa8a839$var$userAgent = '' } = $a43d996a7aa8a839$var$_WINDOW.navigator || {};
const $a43d996a7aa8a839$var$WINDOW = $a43d996a7aa8a839$var$_WINDOW;
const $a43d996a7aa8a839$var$DOCUMENT = $a43d996a7aa8a839$var$_DOCUMENT;
const $a43d996a7aa8a839$var$MUTATION_OBSERVER = $a43d996a7aa8a839$var$_MUTATION_OBSERVER;
const $a43d996a7aa8a839$var$PERFORMANCE = $a43d996a7aa8a839$var$_PERFORMANCE;
const $a43d996a7aa8a839$var$IS_BROWSER = !!$a43d996a7aa8a839$var$WINDOW.document;
const $a43d996a7aa8a839$var$IS_DOM = !!$a43d996a7aa8a839$var$DOCUMENT.documentElement && !!$a43d996a7aa8a839$var$DOCUMENT.head && typeof $a43d996a7aa8a839$var$DOCUMENT.addEventListener === 'function' && typeof $a43d996a7aa8a839$var$DOCUMENT.createElement === 'function';
const $a43d996a7aa8a839$var$IS_IE = ~$a43d996a7aa8a839$var$userAgent.indexOf('MSIE') || ~$a43d996a7aa8a839$var$userAgent.indexOf('Trident/');
var $a43d996a7aa8a839$var$p = /fa(s|r|l|t|d|dr|dl|dt|b|k|kd|ss|sr|sl|st|sds|sdr|sdl|sdt)?[\-\ ]/, $a43d996a7aa8a839$var$g = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp Duotone|Sharp|Kit)?.*/i;
var $a43d996a7aa8a839$var$S = {
    classic: {
        fa: "solid",
        fas: "solid",
        "fa-solid": "solid",
        far: "regular",
        "fa-regular": "regular",
        fal: "light",
        "fa-light": "light",
        fat: "thin",
        "fa-thin": "thin",
        fab: "brands",
        "fa-brands": "brands"
    },
    duotone: {
        fa: "solid",
        fad: "solid",
        "fa-solid": "solid",
        "fa-duotone": "solid",
        fadr: "regular",
        "fa-regular": "regular",
        fadl: "light",
        "fa-light": "light",
        fadt: "thin",
        "fa-thin": "thin"
    },
    sharp: {
        fa: "solid",
        fass: "solid",
        "fa-solid": "solid",
        fasr: "regular",
        "fa-regular": "regular",
        fasl: "light",
        "fa-light": "light",
        fast: "thin",
        "fa-thin": "thin"
    },
    "sharp-duotone": {
        fa: "solid",
        fasds: "solid",
        "fa-solid": "solid",
        fasdr: "regular",
        "fa-regular": "regular",
        fasdl: "light",
        "fa-light": "light",
        fasdt: "thin",
        "fa-thin": "thin"
    }
}, $a43d996a7aa8a839$var$A = {
    GROUP: "duotone-group",
    SWAP_OPACITY: "swap-opacity",
    PRIMARY: "primary",
    SECONDARY: "secondary"
}, $a43d996a7aa8a839$var$P = [
    "fa-classic",
    "fa-duotone",
    "fa-sharp",
    "fa-sharp-duotone"
];
var $a43d996a7aa8a839$var$s = "classic", $a43d996a7aa8a839$var$t = "duotone", $a43d996a7aa8a839$var$r = "sharp", $a43d996a7aa8a839$var$o = "sharp-duotone", $a43d996a7aa8a839$var$L = [
    $a43d996a7aa8a839$var$s,
    $a43d996a7aa8a839$var$t,
    $a43d996a7aa8a839$var$r,
    $a43d996a7aa8a839$var$o
];
var $a43d996a7aa8a839$var$G = {
    classic: {
        900: "fas",
        400: "far",
        normal: "far",
        300: "fal",
        100: "fat"
    },
    duotone: {
        900: "fad",
        400: "fadr",
        300: "fadl",
        100: "fadt"
    },
    sharp: {
        900: "fass",
        400: "fasr",
        300: "fasl",
        100: "fast"
    },
    "sharp-duotone": {
        900: "fasds",
        400: "fasdr",
        300: "fasdl",
        100: "fasdt"
    }
};
var $a43d996a7aa8a839$var$lt = {
    "Font Awesome 6 Free": {
        900: "fas",
        400: "far"
    },
    "Font Awesome 6 Pro": {
        900: "fas",
        400: "far",
        normal: "far",
        300: "fal",
        100: "fat"
    },
    "Font Awesome 6 Brands": {
        400: "fab",
        normal: "fab"
    },
    "Font Awesome 6 Duotone": {
        900: "fad",
        400: "fadr",
        normal: "fadr",
        300: "fadl",
        100: "fadt"
    },
    "Font Awesome 6 Sharp": {
        900: "fass",
        400: "fasr",
        normal: "fasr",
        300: "fasl",
        100: "fast"
    },
    "Font Awesome 6 Sharp Duotone": {
        900: "fasds",
        400: "fasdr",
        normal: "fasdr",
        300: "fasdl",
        100: "fasdt"
    }
};
var $a43d996a7aa8a839$var$pt = new Map([
    [
        "classic",
        {
            defaultShortPrefixId: "fas",
            defaultStyleId: "solid",
            styleIds: [
                "solid",
                "regular",
                "light",
                "thin",
                "brands"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "sharp",
        {
            defaultShortPrefixId: "fass",
            defaultStyleId: "solid",
            styleIds: [
                "solid",
                "regular",
                "light",
                "thin"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "duotone",
        {
            defaultShortPrefixId: "fad",
            defaultStyleId: "solid",
            styleIds: [
                "solid",
                "regular",
                "light",
                "thin"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "sharp-duotone",
        {
            defaultShortPrefixId: "fasds",
            defaultStyleId: "solid",
            styleIds: [
                "solid",
                "regular",
                "light",
                "thin"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ]
]), $a43d996a7aa8a839$var$xt = {
    classic: {
        solid: "fas",
        regular: "far",
        light: "fal",
        thin: "fat",
        brands: "fab"
    },
    duotone: {
        solid: "fad",
        regular: "fadr",
        light: "fadl",
        thin: "fadt"
    },
    sharp: {
        solid: "fass",
        regular: "fasr",
        light: "fasl",
        thin: "fast"
    },
    "sharp-duotone": {
        solid: "fasds",
        regular: "fasdr",
        light: "fasdl",
        thin: "fasdt"
    }
};
var $a43d996a7aa8a839$var$Ft = [
    "fak",
    "fa-kit",
    "fakd",
    "fa-kit-duotone"
], $a43d996a7aa8a839$var$St = {
    kit: {
        fak: "kit",
        "fa-kit": "kit"
    },
    "kit-duotone": {
        fakd: "kit-duotone",
        "fa-kit-duotone": "kit-duotone"
    }
}, $a43d996a7aa8a839$var$At = [
    "kit"
];
var $a43d996a7aa8a839$var$Ct = {
    kit: {
        "fa-kit": "fak"
    },
    "kit-duotone": {
        "fa-kit-duotone": "fakd"
    }
};
var $a43d996a7aa8a839$var$Lt = [
    "fak",
    "fakd"
], $a43d996a7aa8a839$var$Wt = {
    kit: {
        fak: "fa-kit"
    },
    "kit-duotone": {
        fakd: "fa-kit-duotone"
    }
};
var $a43d996a7aa8a839$var$Et = {
    kit: {
        kit: "fak"
    },
    "kit-duotone": {
        "kit-duotone": "fakd"
    }
};
var $a43d996a7aa8a839$var$t$1 = {
    GROUP: "duotone-group",
    SWAP_OPACITY: "swap-opacity",
    PRIMARY: "primary",
    SECONDARY: "secondary"
}, $a43d996a7aa8a839$var$r$1 = [
    "fa-classic",
    "fa-duotone",
    "fa-sharp",
    "fa-sharp-duotone"
];
var $a43d996a7aa8a839$var$bt$1 = [
    "fak",
    "fa-kit",
    "fakd",
    "fa-kit-duotone"
];
var $a43d996a7aa8a839$var$Yt = {
    "Font Awesome Kit": {
        400: "fak",
        normal: "fak"
    },
    "Font Awesome Kit Duotone": {
        400: "fakd",
        normal: "fakd"
    }
};
var $a43d996a7aa8a839$var$ua = {
    classic: {
        "fa-brands": "fab",
        "fa-duotone": "fad",
        "fa-light": "fal",
        "fa-regular": "far",
        "fa-solid": "fas",
        "fa-thin": "fat"
    },
    duotone: {
        "fa-regular": "fadr",
        "fa-light": "fadl",
        "fa-thin": "fadt"
    },
    sharp: {
        "fa-solid": "fass",
        "fa-regular": "fasr",
        "fa-light": "fasl",
        "fa-thin": "fast"
    },
    "sharp-duotone": {
        "fa-solid": "fasds",
        "fa-regular": "fasdr",
        "fa-light": "fasdl",
        "fa-thin": "fasdt"
    }
}, $a43d996a7aa8a839$var$I$1 = {
    classic: [
        "fas",
        "far",
        "fal",
        "fat",
        "fad"
    ],
    duotone: [
        "fadr",
        "fadl",
        "fadt"
    ],
    sharp: [
        "fass",
        "fasr",
        "fasl",
        "fast"
    ],
    "sharp-duotone": [
        "fasds",
        "fasdr",
        "fasdl",
        "fasdt"
    ]
}, $a43d996a7aa8a839$var$ga = {
    classic: {
        fab: "fa-brands",
        fad: "fa-duotone",
        fal: "fa-light",
        far: "fa-regular",
        fas: "fa-solid",
        fat: "fa-thin"
    },
    duotone: {
        fadr: "fa-regular",
        fadl: "fa-light",
        fadt: "fa-thin"
    },
    sharp: {
        fass: "fa-solid",
        fasr: "fa-regular",
        fasl: "fa-light",
        fast: "fa-thin"
    },
    "sharp-duotone": {
        fasds: "fa-solid",
        fasdr: "fa-regular",
        fasdl: "fa-light",
        fasdt: "fa-thin"
    }
}, $a43d996a7aa8a839$var$x = [
    "fa-solid",
    "fa-regular",
    "fa-light",
    "fa-thin",
    "fa-duotone",
    "fa-brands"
], $a43d996a7aa8a839$var$Ia = [
    "fa",
    "fas",
    "far",
    "fal",
    "fat",
    "fad",
    "fadr",
    "fadl",
    "fadt",
    "fab",
    "fass",
    "fasr",
    "fasl",
    "fast",
    "fasds",
    "fasdr",
    "fasdl",
    "fasdt",
    ...$a43d996a7aa8a839$var$r$1,
    ...$a43d996a7aa8a839$var$x
], $a43d996a7aa8a839$var$m$1 = [
    "solid",
    "regular",
    "light",
    "thin",
    "duotone",
    "brands"
], $a43d996a7aa8a839$var$c$1 = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
], $a43d996a7aa8a839$var$F$1 = $a43d996a7aa8a839$var$c$1.concat([
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20
]), $a43d996a7aa8a839$var$ma = [
    ...Object.keys($a43d996a7aa8a839$var$I$1),
    ...$a43d996a7aa8a839$var$m$1,
    "2xs",
    "xs",
    "sm",
    "lg",
    "xl",
    "2xl",
    "beat",
    "border",
    "fade",
    "beat-fade",
    "bounce",
    "flip-both",
    "flip-horizontal",
    "flip-vertical",
    "flip",
    "fw",
    "inverse",
    "layers-counter",
    "layers-text",
    "layers",
    "li",
    "pull-left",
    "pull-right",
    "pulse",
    "rotate-180",
    "rotate-270",
    "rotate-90",
    "rotate-by",
    "shake",
    "spin-pulse",
    "spin-reverse",
    "spin",
    "stack-1x",
    "stack-2x",
    "stack",
    "ul",
    $a43d996a7aa8a839$var$t$1.GROUP,
    $a43d996a7aa8a839$var$t$1.SWAP_OPACITY,
    $a43d996a7aa8a839$var$t$1.PRIMARY,
    $a43d996a7aa8a839$var$t$1.SECONDARY
].concat($a43d996a7aa8a839$var$c$1.map((a)=>"".concat(a, "x"))).concat($a43d996a7aa8a839$var$F$1.map((a)=>"w-".concat(a)));
var $a43d996a7aa8a839$var$wa = {
    "Font Awesome 5 Free": {
        900: "fas",
        400: "far"
    },
    "Font Awesome 5 Pro": {
        900: "fas",
        400: "far",
        normal: "far",
        300: "fal"
    },
    "Font Awesome 5 Brands": {
        400: "fab",
        normal: "fab"
    },
    "Font Awesome 5 Duotone": {
        900: "fad"
    }
};
const $a43d996a7aa8a839$var$NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
const $a43d996a7aa8a839$var$UNITS_IN_GRID = 16;
const $a43d996a7aa8a839$var$DEFAULT_CSS_PREFIX = 'fa';
const $a43d996a7aa8a839$var$DEFAULT_REPLACEMENT_CLASS = 'svg-inline--fa';
const $a43d996a7aa8a839$var$DATA_FA_I2SVG = 'data-fa-i2svg';
const $a43d996a7aa8a839$var$DATA_FA_PSEUDO_ELEMENT = 'data-fa-pseudo-element';
const $a43d996a7aa8a839$var$DATA_FA_PSEUDO_ELEMENT_PENDING = 'data-fa-pseudo-element-pending';
const $a43d996a7aa8a839$var$DATA_PREFIX = 'data-prefix';
const $a43d996a7aa8a839$var$DATA_ICON = 'data-icon';
const $a43d996a7aa8a839$var$HTML_CLASS_I2SVG_BASE_CLASS = 'fontawesome-i2svg';
const $a43d996a7aa8a839$var$MUTATION_APPROACH_ASYNC = 'async';
const $a43d996a7aa8a839$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = [
    'HTML',
    'HEAD',
    'STYLE',
    'SCRIPT'
];
const $a43d996a7aa8a839$var$PRODUCTION = (()=>{
    try {
        return true;
    } catch (e$$1) {
        return false;
    }
})();
function $a43d996a7aa8a839$var$familyProxy(obj) {
    // Defaults to the classic family if family is not available
    return new Proxy(obj, {
        get (target, prop) {
            return prop in target ? target[prop] : target[$a43d996a7aa8a839$var$s];
        }
    });
}
const $a43d996a7aa8a839$var$_PREFIX_TO_STYLE = $a43d996a7aa8a839$var$_objectSpread2({}, $a43d996a7aa8a839$var$S);
// We changed FACSSClassesToStyleId in the icons repo to be canonical and as such, "classic" family does not have any
// duotone styles.  But we do still need duotone in _PREFIX_TO_STYLE below, so we are manually adding
// {'fa-duotone': 'duotone'}
$a43d996a7aa8a839$var$_PREFIX_TO_STYLE[$a43d996a7aa8a839$var$s] = $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, {
    'fa-duotone': 'duotone'
}), $a43d996a7aa8a839$var$S[$a43d996a7aa8a839$var$s]), $a43d996a7aa8a839$var$St['kit']), $a43d996a7aa8a839$var$St['kit-duotone']);
const $a43d996a7aa8a839$var$PREFIX_TO_STYLE = $a43d996a7aa8a839$var$familyProxy($a43d996a7aa8a839$var$_PREFIX_TO_STYLE);
const $a43d996a7aa8a839$var$_STYLE_TO_PREFIX = $a43d996a7aa8a839$var$_objectSpread2({}, $a43d996a7aa8a839$var$xt);
// We changed FAStyleIdToShortPrefixId in the icons repo to be canonical and as such, "classic" family does not have any
// duotone styles.  But we do still need duotone in _STYLE_TO_PREFIX below, so we are manually adding {duotone: 'fad'}
$a43d996a7aa8a839$var$_STYLE_TO_PREFIX[$a43d996a7aa8a839$var$s] = $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, {
    duotone: 'fad'
}), $a43d996a7aa8a839$var$_STYLE_TO_PREFIX[$a43d996a7aa8a839$var$s]), $a43d996a7aa8a839$var$Et['kit']), $a43d996a7aa8a839$var$Et['kit-duotone']);
const $a43d996a7aa8a839$var$STYLE_TO_PREFIX = $a43d996a7aa8a839$var$familyProxy($a43d996a7aa8a839$var$_STYLE_TO_PREFIX);
const $a43d996a7aa8a839$var$_PREFIX_TO_LONG_STYLE = $a43d996a7aa8a839$var$_objectSpread2({}, $a43d996a7aa8a839$var$ga);
$a43d996a7aa8a839$var$_PREFIX_TO_LONG_STYLE[$a43d996a7aa8a839$var$s] = $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, $a43d996a7aa8a839$var$_PREFIX_TO_LONG_STYLE[$a43d996a7aa8a839$var$s]), $a43d996a7aa8a839$var$Wt['kit']);
const $a43d996a7aa8a839$var$PREFIX_TO_LONG_STYLE = $a43d996a7aa8a839$var$familyProxy($a43d996a7aa8a839$var$_PREFIX_TO_LONG_STYLE);
const $a43d996a7aa8a839$var$_LONG_STYLE_TO_PREFIX = $a43d996a7aa8a839$var$_objectSpread2({}, $a43d996a7aa8a839$var$ua);
$a43d996a7aa8a839$var$_LONG_STYLE_TO_PREFIX[$a43d996a7aa8a839$var$s] = $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, $a43d996a7aa8a839$var$_LONG_STYLE_TO_PREFIX[$a43d996a7aa8a839$var$s]), $a43d996a7aa8a839$var$Ct['kit']);
const $a43d996a7aa8a839$var$LONG_STYLE_TO_PREFIX = $a43d996a7aa8a839$var$familyProxy($a43d996a7aa8a839$var$_LONG_STYLE_TO_PREFIX);
const $a43d996a7aa8a839$var$ICON_SELECTION_SYNTAX_PATTERN = $a43d996a7aa8a839$var$p; // eslint-disable-line no-useless-escape
const $a43d996a7aa8a839$var$LAYERS_TEXT_CLASSNAME = 'fa-layers-text';
const $a43d996a7aa8a839$var$FONT_FAMILY_PATTERN = $a43d996a7aa8a839$var$g;
const $a43d996a7aa8a839$var$_FONT_WEIGHT_TO_PREFIX = $a43d996a7aa8a839$var$_objectSpread2({}, $a43d996a7aa8a839$var$G);
const $a43d996a7aa8a839$var$FONT_WEIGHT_TO_PREFIX = $a43d996a7aa8a839$var$familyProxy($a43d996a7aa8a839$var$_FONT_WEIGHT_TO_PREFIX);
const $a43d996a7aa8a839$var$ATTRIBUTES_WATCHED_FOR_MUTATION = [
    'class',
    'data-prefix',
    'data-icon',
    'data-fa-transform',
    'data-fa-mask'
];
const $a43d996a7aa8a839$var$DUOTONE_CLASSES = $a43d996a7aa8a839$var$A;
const $a43d996a7aa8a839$var$RESERVED_CLASSES = [
    ...$a43d996a7aa8a839$var$At,
    ...$a43d996a7aa8a839$var$ma
];
const $a43d996a7aa8a839$var$initial = $a43d996a7aa8a839$var$WINDOW.FontAwesomeConfig || {};
function $a43d996a7aa8a839$var$getAttrConfig(attr) {
    var element = $a43d996a7aa8a839$var$DOCUMENT.querySelector('script[' + attr + ']');
    if (element) return element.getAttribute(attr);
}
function $a43d996a7aa8a839$var$coerce(val) {
    // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
    // We'll assume that this is an indication that it should be toggled to true
    if (val === '') return true;
    if (val === 'false') return false;
    if (val === 'true') return true;
    return val;
}
if ($a43d996a7aa8a839$var$DOCUMENT && typeof $a43d996a7aa8a839$var$DOCUMENT.querySelector === 'function') {
    const attrs = [
        [
            'data-family-prefix',
            'familyPrefix'
        ],
        [
            'data-css-prefix',
            'cssPrefix'
        ],
        [
            'data-family-default',
            'familyDefault'
        ],
        [
            'data-style-default',
            'styleDefault'
        ],
        [
            'data-replacement-class',
            'replacementClass'
        ],
        [
            'data-auto-replace-svg',
            'autoReplaceSvg'
        ],
        [
            'data-auto-add-css',
            'autoAddCss'
        ],
        [
            'data-auto-a11y',
            'autoA11y'
        ],
        [
            'data-search-pseudo-elements',
            'searchPseudoElements'
        ],
        [
            'data-observe-mutations',
            'observeMutations'
        ],
        [
            'data-mutate-approach',
            'mutateApproach'
        ],
        [
            'data-keep-original-source',
            'keepOriginalSource'
        ],
        [
            'data-measure-performance',
            'measurePerformance'
        ],
        [
            'data-show-missing-icons',
            'showMissingIcons'
        ]
    ];
    attrs.forEach((_ref)=>{
        let [attr, key] = _ref;
        const val = $a43d996a7aa8a839$var$coerce($a43d996a7aa8a839$var$getAttrConfig(attr));
        if (val !== undefined && val !== null) $a43d996a7aa8a839$var$initial[key] = val;
    });
}
const $a43d996a7aa8a839$var$_default = {
    styleDefault: 'solid',
    familyDefault: $a43d996a7aa8a839$var$s,
    cssPrefix: $a43d996a7aa8a839$var$DEFAULT_CSS_PREFIX,
    replacementClass: $a43d996a7aa8a839$var$DEFAULT_REPLACEMENT_CLASS,
    autoReplaceSvg: true,
    autoAddCss: true,
    autoA11y: true,
    searchPseudoElements: false,
    observeMutations: true,
    mutateApproach: 'async',
    keepOriginalSource: true,
    measurePerformance: false,
    showMissingIcons: true
};
// familyPrefix is deprecated but we must still support it if present
if ($a43d996a7aa8a839$var$initial.familyPrefix) $a43d996a7aa8a839$var$initial.cssPrefix = $a43d996a7aa8a839$var$initial.familyPrefix;
const $a43d996a7aa8a839$var$_config = $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, $a43d996a7aa8a839$var$_default), $a43d996a7aa8a839$var$initial);
if (!$a43d996a7aa8a839$var$_config.autoReplaceSvg) $a43d996a7aa8a839$var$_config.observeMutations = false;
const $a43d996a7aa8a839$var$config = {};
Object.keys($a43d996a7aa8a839$var$_default).forEach((key)=>{
    Object.defineProperty($a43d996a7aa8a839$var$config, key, {
        enumerable: true,
        set: function(val) {
            $a43d996a7aa8a839$var$_config[key] = val;
            $a43d996a7aa8a839$var$_onChangeCb.forEach((cb)=>cb($a43d996a7aa8a839$var$config));
        },
        get: function() {
            return $a43d996a7aa8a839$var$_config[key];
        }
    });
});
// familyPrefix is deprecated as of 6.2.0 and should be removed in 7.0.0
Object.defineProperty($a43d996a7aa8a839$var$config, 'familyPrefix', {
    enumerable: true,
    set: function(val) {
        $a43d996a7aa8a839$var$_config.cssPrefix = val;
        $a43d996a7aa8a839$var$_onChangeCb.forEach((cb)=>cb($a43d996a7aa8a839$var$config));
    },
    get: function() {
        return $a43d996a7aa8a839$var$_config.cssPrefix;
    }
});
$a43d996a7aa8a839$var$WINDOW.FontAwesomeConfig = $a43d996a7aa8a839$var$config;
const $a43d996a7aa8a839$var$_onChangeCb = [];
function $a43d996a7aa8a839$var$onChange(cb) {
    $a43d996a7aa8a839$var$_onChangeCb.push(cb);
    return ()=>{
        $a43d996a7aa8a839$var$_onChangeCb.splice($a43d996a7aa8a839$var$_onChangeCb.indexOf(cb), 1);
    };
}
const $a43d996a7aa8a839$var$d$2 = $a43d996a7aa8a839$var$UNITS_IN_GRID;
const $a43d996a7aa8a839$var$meaninglessTransform = {
    size: 16,
    x: 0,
    y: 0,
    rotate: 0,
    flipX: false,
    flipY: false
};
function $a43d996a7aa8a839$var$insertCss(css) {
    if (!css || !$a43d996a7aa8a839$var$IS_DOM) return;
    const style = $a43d996a7aa8a839$var$DOCUMENT.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    const headChildren = $a43d996a7aa8a839$var$DOCUMENT.head.childNodes;
    let beforeChild = null;
    for(let i = headChildren.length - 1; i > -1; i--){
        const child = headChildren[i];
        const tagName = (child.tagName || '').toUpperCase();
        if ([
            'STYLE',
            'LINK'
        ].indexOf(tagName) > -1) beforeChild = child;
    }
    $a43d996a7aa8a839$var$DOCUMENT.head.insertBefore(style, beforeChild);
    return css;
}
const $a43d996a7aa8a839$var$idPool = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
function $a43d996a7aa8a839$var$nextUniqueId() {
    let size = 12;
    let id = '';
    while(size-- > 0)id += $a43d996a7aa8a839$var$idPool[Math.random() * 62 | 0];
    return id;
}
function $a43d996a7aa8a839$var$toArray(obj) {
    const array = [];
    for(let i = (obj || []).length >>> 0; i--;)array[i] = obj[i];
    return array;
}
function $a43d996a7aa8a839$var$classArray(node) {
    if (node.classList) return $a43d996a7aa8a839$var$toArray(node.classList);
    else return (node.getAttribute('class') || '').split(' ').filter((i)=>i);
}
function $a43d996a7aa8a839$var$htmlEscape(str) {
    return "".concat(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function $a43d996a7aa8a839$var$joinAttributes(attributes) {
    return Object.keys(attributes || {}).reduce((acc, attributeName)=>{
        return acc + "".concat(attributeName, "=\"").concat($a43d996a7aa8a839$var$htmlEscape(attributes[attributeName]), "\" ");
    }, '').trim();
}
function $a43d996a7aa8a839$var$joinStyles(styles) {
    return Object.keys(styles || {}).reduce((acc, styleName)=>{
        return acc + "".concat(styleName, ": ").concat(styles[styleName].trim(), ";");
    }, '');
}
function $a43d996a7aa8a839$var$transformIsMeaningful(transform) {
    return transform.size !== $a43d996a7aa8a839$var$meaninglessTransform.size || transform.x !== $a43d996a7aa8a839$var$meaninglessTransform.x || transform.y !== $a43d996a7aa8a839$var$meaninglessTransform.y || transform.rotate !== $a43d996a7aa8a839$var$meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function $a43d996a7aa8a839$var$transformForSvg(_ref) {
    let { transform: transform, containerWidth: containerWidth, iconWidth: iconWidth } = _ref;
    const outer = {
        transform: "translate(".concat(containerWidth / 2, " 256)")
    };
    const innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
    const innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
    const innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
    const inner = {
        transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
    };
    const path = {
        transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
    };
    return {
        outer: outer,
        inner: inner,
        path: path
    };
}
function $a43d996a7aa8a839$var$transformForCss(_ref2) {
    let { transform: transform, width: width = $a43d996a7aa8a839$var$UNITS_IN_GRID, height: height = $a43d996a7aa8a839$var$UNITS_IN_GRID, startCentered: startCentered = false } = _ref2;
    let val = '';
    if (startCentered && $a43d996a7aa8a839$var$IS_IE) val += "translate(".concat(transform.x / $a43d996a7aa8a839$var$d$2 - width / 2, "em, ").concat(transform.y / $a43d996a7aa8a839$var$d$2 - height / 2, "em) ");
    else if (startCentered) val += "translate(calc(-50% + ".concat(transform.x / $a43d996a7aa8a839$var$d$2, "em), calc(-50% + ").concat(transform.y / $a43d996a7aa8a839$var$d$2, "em)) ");
    else val += "translate(".concat(transform.x / $a43d996a7aa8a839$var$d$2, "em, ").concat(transform.y / $a43d996a7aa8a839$var$d$2, "em) ");
    val += "scale(".concat(transform.size / $a43d996a7aa8a839$var$d$2 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / $a43d996a7aa8a839$var$d$2 * (transform.flipY ? -1 : 1), ") ");
    val += "rotate(".concat(transform.rotate, "deg) ");
    return val;
}
var $a43d996a7aa8a839$var$baseStyles = ":root, :host {\n  --fa-font-solid: normal 900 1em/1 \"Font Awesome 6 Free\";\n  --fa-font-regular: normal 400 1em/1 \"Font Awesome 6 Free\";\n  --fa-font-light: normal 300 1em/1 \"Font Awesome 6 Pro\";\n  --fa-font-thin: normal 100 1em/1 \"Font Awesome 6 Pro\";\n  --fa-font-duotone: normal 900 1em/1 \"Font Awesome 6 Duotone\";\n  --fa-font-duotone-regular: normal 400 1em/1 \"Font Awesome 6 Duotone\";\n  --fa-font-duotone-light: normal 300 1em/1 \"Font Awesome 6 Duotone\";\n  --fa-font-duotone-thin: normal 100 1em/1 \"Font Awesome 6 Duotone\";\n  --fa-font-brands: normal 400 1em/1 \"Font Awesome 6 Brands\";\n  --fa-font-sharp-solid: normal 900 1em/1 \"Font Awesome 6 Sharp\";\n  --fa-font-sharp-regular: normal 400 1em/1 \"Font Awesome 6 Sharp\";\n  --fa-font-sharp-light: normal 300 1em/1 \"Font Awesome 6 Sharp\";\n  --fa-font-sharp-thin: normal 100 1em/1 \"Font Awesome 6 Sharp\";\n  --fa-font-sharp-duotone-solid: normal 900 1em/1 \"Font Awesome 6 Sharp Duotone\";\n  --fa-font-sharp-duotone-regular: normal 400 1em/1 \"Font Awesome 6 Sharp Duotone\";\n  --fa-font-sharp-duotone-light: normal 300 1em/1 \"Font Awesome 6 Sharp Duotone\";\n  --fa-font-sharp-duotone-thin: normal 100 1em/1 \"Font Awesome 6 Sharp Duotone\";\n}\n\nsvg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {\n  overflow: visible;\n  box-sizing: content-box;\n}\n\n.svg-inline--fa {\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285705em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  top: 0.25em;\n}\n.svg-inline--fa.fa-fw {\n  width: var(--fa-fw-width, 1.25em);\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  transform: scale(var(--fa-counter-scale, 0.25));\n  transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.0833333337em;\n  vertical-align: 0.125em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.0714285718em;\n  vertical-align: 0.0535714295em;\n}\n\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em;\n}\n\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.0416666682em;\n  vertical-align: -0.125em;\n}\n\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: calc(-1 * var(--fa-li-width, 2em));\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);\n}\n\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  animation-name: fa-beat;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  animation-name: fa-bounce;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  animation-name: fa-fade;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  animation-name: fa-beat-fade;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  animation-name: fa-flip;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  animation-name: fa-shake;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  animation-name: fa-spin;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 2s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  animation-name: fa-spin;\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n.fa-bounce,\n.fa-fade,\n.fa-beat-fade,\n.fa-flip,\n.fa-pulse,\n.fa-shake,\n.fa-spin,\n.fa-spin-pulse {\n    animation-delay: -1ms;\n    animation-duration: 1ms;\n    animation-iteration-count: 1;\n    transition-delay: 0s;\n    transition-duration: 0s;\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    transform: scale(1);\n  }\n  45% {\n    transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-shake {\n  0% {\n    transform: rotate(-15deg);\n  }\n  4% {\n    transform: rotate(15deg);\n  }\n  8%, 24% {\n    transform: rotate(-18deg);\n  }\n  12%, 28% {\n    transform: rotate(18deg);\n  }\n  16% {\n    transform: rotate(-22deg);\n  }\n  20% {\n    transform: rotate(22deg);\n  }\n  32% {\n    transform: rotate(-12deg);\n  }\n  36% {\n    transform: rotate(12deg);\n  }\n  40%, 100% {\n    transform: rotate(0deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  transform: rotate(var(--fa-rotate-angle, 0));\n}\n\n.fa-stack {\n  display: inline-block;\n  vertical-align: middle;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: var(--fa-stack-z-index, auto);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}";
function $a43d996a7aa8a839$var$css() {
    const dcp = $a43d996a7aa8a839$var$DEFAULT_CSS_PREFIX;
    const drc = $a43d996a7aa8a839$var$DEFAULT_REPLACEMENT_CLASS;
    const fp = $a43d996a7aa8a839$var$config.cssPrefix;
    const rc = $a43d996a7aa8a839$var$config.replacementClass;
    let s = $a43d996a7aa8a839$var$baseStyles;
    if (fp !== dcp || rc !== drc) {
        const dPatt = new RegExp("\\.".concat(dcp, "\\-"), 'g');
        const customPropPatt = new RegExp("\\--".concat(dcp, "\\-"), 'g');
        const rPatt = new RegExp("\\.".concat(drc), 'g');
        s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
    }
    return s;
}
let $a43d996a7aa8a839$var$_cssInserted = false;
function $a43d996a7aa8a839$var$ensureCss() {
    if ($a43d996a7aa8a839$var$config.autoAddCss && !$a43d996a7aa8a839$var$_cssInserted) {
        $a43d996a7aa8a839$var$insertCss($a43d996a7aa8a839$var$css());
        $a43d996a7aa8a839$var$_cssInserted = true;
    }
}
var $a43d996a7aa8a839$var$InjectCSS = {
    mixout () {
        return {
            dom: {
                css: $a43d996a7aa8a839$var$css,
                insertCss: $a43d996a7aa8a839$var$ensureCss
            }
        };
    },
    hooks () {
        return {
            beforeDOMElementCreation () {
                $a43d996a7aa8a839$var$ensureCss();
            },
            beforeI2svg () {
                $a43d996a7aa8a839$var$ensureCss();
            }
        };
    }
};
const $a43d996a7aa8a839$var$w = $a43d996a7aa8a839$var$WINDOW || {};
if (!$a43d996a7aa8a839$var$w[$a43d996a7aa8a839$var$NAMESPACE_IDENTIFIER]) $a43d996a7aa8a839$var$w[$a43d996a7aa8a839$var$NAMESPACE_IDENTIFIER] = {};
if (!$a43d996a7aa8a839$var$w[$a43d996a7aa8a839$var$NAMESPACE_IDENTIFIER].styles) $a43d996a7aa8a839$var$w[$a43d996a7aa8a839$var$NAMESPACE_IDENTIFIER].styles = {};
if (!$a43d996a7aa8a839$var$w[$a43d996a7aa8a839$var$NAMESPACE_IDENTIFIER].hooks) $a43d996a7aa8a839$var$w[$a43d996a7aa8a839$var$NAMESPACE_IDENTIFIER].hooks = {};
if (!$a43d996a7aa8a839$var$w[$a43d996a7aa8a839$var$NAMESPACE_IDENTIFIER].shims) $a43d996a7aa8a839$var$w[$a43d996a7aa8a839$var$NAMESPACE_IDENTIFIER].shims = [];
var $a43d996a7aa8a839$var$namespace = $a43d996a7aa8a839$var$w[$a43d996a7aa8a839$var$NAMESPACE_IDENTIFIER];
const $a43d996a7aa8a839$var$functions = [];
const $a43d996a7aa8a839$var$listener = function() {
    $a43d996a7aa8a839$var$DOCUMENT.removeEventListener('DOMContentLoaded', $a43d996a7aa8a839$var$listener);
    $a43d996a7aa8a839$var$loaded = 1;
    $a43d996a7aa8a839$var$functions.map((fn)=>fn());
};
let $a43d996a7aa8a839$var$loaded = false;
if ($a43d996a7aa8a839$var$IS_DOM) {
    $a43d996a7aa8a839$var$loaded = ($a43d996a7aa8a839$var$DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test($a43d996a7aa8a839$var$DOCUMENT.readyState);
    if (!$a43d996a7aa8a839$var$loaded) $a43d996a7aa8a839$var$DOCUMENT.addEventListener('DOMContentLoaded', $a43d996a7aa8a839$var$listener);
}
function $a43d996a7aa8a839$var$domready(fn) {
    if (!$a43d996a7aa8a839$var$IS_DOM) return;
    $a43d996a7aa8a839$var$loaded ? setTimeout(fn, 0) : $a43d996a7aa8a839$var$functions.push(fn);
}
function $a43d996a7aa8a839$var$toHtml(abstractNodes) {
    const { tag: tag, attributes: attributes = {}, children: children = [] } = abstractNodes;
    if (typeof abstractNodes === 'string') return $a43d996a7aa8a839$var$htmlEscape(abstractNodes);
    else return "<".concat(tag, " ").concat($a43d996a7aa8a839$var$joinAttributes(attributes), ">").concat(children.map($a43d996a7aa8a839$var$toHtml).join(''), "</").concat(tag, ">");
}
function $a43d996a7aa8a839$var$iconFromMapping(mapping, prefix, iconName) {
    if (mapping && mapping[prefix] && mapping[prefix][iconName]) return {
        prefix: prefix,
        iconName: iconName,
        icon: mapping[prefix][iconName]
    };
}
/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */ var $a43d996a7aa8a839$var$bindInternal4 = function bindInternal4(func, thisContext) {
    return function(a, b, c, d) {
        return func.call(thisContext, a, b, c, d);
    };
};
/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */ var $a43d996a7aa8a839$var$reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
    var keys = Object.keys(subject), length = keys.length, iterator = thisContext !== undefined ? $a43d996a7aa8a839$var$bindInternal4(fn, thisContext) : fn, i, key, result;
    if (initialValue === undefined) {
        i = 1;
        result = subject[keys[0]];
    } else {
        i = 0;
        result = initialValue;
    }
    for(; i < length; i++){
        key = keys[i];
        result = iterator(result, subject[key], key, subject);
    }
    return result;
};
/**
 * ucs2decode() and codePointAt() are both works of Mathias Bynens and licensed under MIT
 *
 * Copyright Mathias Bynens <https://mathiasbynens.be/>

 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:

 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ function $a43d996a7aa8a839$var$ucs2decode(string) {
    const output = [];
    let counter = 0;
    const length = string.length;
    while(counter < length){
        const value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            const extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) // eslint-disable-line eqeqeq
            output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
function $a43d996a7aa8a839$var$toHex(unicode) {
    const decoded = $a43d996a7aa8a839$var$ucs2decode(unicode);
    return decoded.length === 1 ? decoded[0].toString(16) : null;
}
function $a43d996a7aa8a839$var$codePointAt(string, index) {
    const size = string.length;
    let first = string.charCodeAt(index);
    let second;
    if (first >= 0xD800 && first <= 0xDBFF && size > index + 1) {
        second = string.charCodeAt(index + 1);
        if (second >= 0xDC00 && second <= 0xDFFF) return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
    }
    return first;
}
function $a43d996a7aa8a839$var$normalizeIcons(icons) {
    return Object.keys(icons).reduce((acc, iconName)=>{
        const icon = icons[iconName];
        const expanded = !!icon.icon;
        if (expanded) acc[icon.iconName] = icon.icon;
        else acc[iconName] = icon;
        return acc;
    }, {});
}
function $a43d996a7aa8a839$var$defineIcons(prefix, icons) {
    let params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const { skipHooks: skipHooks = false } = params;
    const normalized = $a43d996a7aa8a839$var$normalizeIcons(icons);
    if (typeof $a43d996a7aa8a839$var$namespace.hooks.addPack === 'function' && !skipHooks) $a43d996a7aa8a839$var$namespace.hooks.addPack(prefix, $a43d996a7aa8a839$var$normalizeIcons(icons));
    else $a43d996a7aa8a839$var$namespace.styles[prefix] = $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, $a43d996a7aa8a839$var$namespace.styles[prefix] || {}), normalized);
    /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll ease the upgrade process for our users by automatically defining
   * this as well.
   */ if (prefix === 'fas') $a43d996a7aa8a839$var$defineIcons('fa', icons);
}
const $a43d996a7aa8a839$var$duotonePathRe = [
    /*#__PURE__*/ $a43d996a7aa8a839$var$_wrapRegExp(/path d="([^"]+)".*path d="([^"]+)"/, {
        d1: 1,
        d2: 2
    }),
    /*#__PURE__*/ $a43d996a7aa8a839$var$_wrapRegExp(/path class="([^"]+)".*d="([^"]+)".*path class="([^"]+)".*d="([^"]+)"/, {
        cls1: 1,
        d1: 2,
        cls2: 3,
        d2: 4
    }),
    /*#__PURE__*/ $a43d996a7aa8a839$var$_wrapRegExp(/path class="([^"]+)".*d="([^"]+)"/, {
        cls1: 1,
        d1: 2
    })
];
const { styles: $a43d996a7aa8a839$var$styles, shims: $a43d996a7aa8a839$var$shims } = $a43d996a7aa8a839$var$namespace;
const $a43d996a7aa8a839$var$FAMILY_NAMES = Object.keys($a43d996a7aa8a839$var$PREFIX_TO_LONG_STYLE);
const $a43d996a7aa8a839$var$PREFIXES_FOR_FAMILY = $a43d996a7aa8a839$var$FAMILY_NAMES.reduce((acc, familyId)=>{
    acc[familyId] = Object.keys($a43d996a7aa8a839$var$PREFIX_TO_LONG_STYLE[familyId]);
    return acc;
}, {});
let $a43d996a7aa8a839$var$_defaultUsablePrefix = null;
let $a43d996a7aa8a839$var$_byUnicode = {};
let $a43d996a7aa8a839$var$_byLigature = {};
let $a43d996a7aa8a839$var$_byOldName = {};
let $a43d996a7aa8a839$var$_byOldUnicode = {};
let $a43d996a7aa8a839$var$_byAlias = {};
function $a43d996a7aa8a839$var$isReserved(name) {
    return ~$a43d996a7aa8a839$var$RESERVED_CLASSES.indexOf(name);
}
function $a43d996a7aa8a839$var$getIconName(cssPrefix, cls) {
    const parts = cls.split('-');
    const prefix = parts[0];
    const iconName = parts.slice(1).join('-');
    if (prefix === cssPrefix && iconName !== '' && !$a43d996a7aa8a839$var$isReserved(iconName)) return iconName;
    else return null;
}
const $a43d996a7aa8a839$var$build = ()=>{
    const lookup = (reducer)=>{
        return $a43d996a7aa8a839$var$reduce($a43d996a7aa8a839$var$styles, (o$$1, style, prefix)=>{
            o$$1[prefix] = $a43d996a7aa8a839$var$reduce(style, reducer, {});
            return o$$1;
        }, {});
    };
    $a43d996a7aa8a839$var$_byUnicode = lookup((acc, icon, iconName)=>{
        if (icon[3]) acc[icon[3]] = iconName;
        if (icon[2]) {
            const aliases = icon[2].filter((a$$1)=>{
                return typeof a$$1 === 'number';
            });
            aliases.forEach((alias)=>{
                acc[alias.toString(16)] = iconName;
            });
        }
        return acc;
    });
    $a43d996a7aa8a839$var$_byLigature = lookup((acc, icon, iconName)=>{
        acc[iconName] = iconName;
        if (icon[2]) {
            const aliases = icon[2].filter((a$$1)=>{
                return typeof a$$1 === 'string';
            });
            aliases.forEach((alias)=>{
                acc[alias] = iconName;
            });
        }
        return acc;
    });
    $a43d996a7aa8a839$var$_byAlias = lookup((acc, icon, iconName)=>{
        const aliases = icon[2];
        acc[iconName] = iconName;
        aliases.forEach((alias)=>{
            acc[alias] = iconName;
        });
        return acc;
    });
    // If we have a Kit, we can't determine if regular is available since we
    // could be auto-fetching it. We'll have to assume that it is available.
    const hasRegular = 'far' in $a43d996a7aa8a839$var$styles || $a43d996a7aa8a839$var$config.autoFetchSvg;
    const shimLookups = $a43d996a7aa8a839$var$reduce($a43d996a7aa8a839$var$shims, (acc, shim)=>{
        const maybeNameMaybeUnicode = shim[0];
        let prefix = shim[1];
        const iconName = shim[2];
        if (prefix === 'far' && !hasRegular) prefix = 'fas';
        if (typeof maybeNameMaybeUnicode === 'string') acc.names[maybeNameMaybeUnicode] = {
            prefix: prefix,
            iconName: iconName
        };
        if (typeof maybeNameMaybeUnicode === 'number') acc.unicodes[maybeNameMaybeUnicode.toString(16)] = {
            prefix: prefix,
            iconName: iconName
        };
        return acc;
    }, {
        names: {},
        unicodes: {}
    });
    $a43d996a7aa8a839$var$_byOldName = shimLookups.names;
    $a43d996a7aa8a839$var$_byOldUnicode = shimLookups.unicodes;
    $a43d996a7aa8a839$var$_defaultUsablePrefix = $a43d996a7aa8a839$var$getCanonicalPrefix($a43d996a7aa8a839$var$config.styleDefault, {
        family: $a43d996a7aa8a839$var$config.familyDefault
    });
};
$a43d996a7aa8a839$var$onChange((c$$1)=>{
    $a43d996a7aa8a839$var$_defaultUsablePrefix = $a43d996a7aa8a839$var$getCanonicalPrefix(c$$1.styleDefault, {
        family: $a43d996a7aa8a839$var$config.familyDefault
    });
});
$a43d996a7aa8a839$var$build();
function $a43d996a7aa8a839$var$byUnicode(prefix, unicode) {
    return ($a43d996a7aa8a839$var$_byUnicode[prefix] || {})[unicode];
}
function $a43d996a7aa8a839$var$byLigature(prefix, ligature) {
    return ($a43d996a7aa8a839$var$_byLigature[prefix] || {})[ligature];
}
function $a43d996a7aa8a839$var$byAlias(prefix, alias) {
    return ($a43d996a7aa8a839$var$_byAlias[prefix] || {})[alias];
}
function $a43d996a7aa8a839$var$byOldName(name) {
    return $a43d996a7aa8a839$var$_byOldName[name] || {
        prefix: null,
        iconName: null
    };
}
function $a43d996a7aa8a839$var$byOldUnicode(unicode) {
    const oldUnicode = $a43d996a7aa8a839$var$_byOldUnicode[unicode];
    const newUnicode = $a43d996a7aa8a839$var$byUnicode('fas', unicode);
    return oldUnicode || (newUnicode ? {
        prefix: 'fas',
        iconName: newUnicode
    } : null) || {
        prefix: null,
        iconName: null
    };
}
function $a43d996a7aa8a839$var$getDefaultUsablePrefix() {
    return $a43d996a7aa8a839$var$_defaultUsablePrefix;
}
const $a43d996a7aa8a839$var$emptyCanonicalIcon = ()=>{
    return {
        prefix: null,
        iconName: null,
        rest: []
    };
};
function $a43d996a7aa8a839$var$getFamilyId(values) {
    let family = $a43d996a7aa8a839$var$s;
    const famProps = $a43d996a7aa8a839$var$FAMILY_NAMES.reduce((acc, familyId)=>{
        acc[familyId] = "".concat($a43d996a7aa8a839$var$config.cssPrefix, "-").concat(familyId);
        return acc;
    }, {});
    $a43d996a7aa8a839$var$L.forEach((familyId)=>{
        if (values.includes(famProps[familyId]) || values.some((v$$1)=>$a43d996a7aa8a839$var$PREFIXES_FOR_FAMILY[familyId].includes(v$$1))) family = familyId;
    });
    return family;
}
function $a43d996a7aa8a839$var$getCanonicalPrefix(styleOrPrefix) {
    let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { family: family = $a43d996a7aa8a839$var$s } = params;
    const style = $a43d996a7aa8a839$var$PREFIX_TO_STYLE[family][styleOrPrefix];
    // handles the exception of passing in only a family of 'duotone' with no style
    if (family === $a43d996a7aa8a839$var$t && !styleOrPrefix) return 'fad';
    const prefix = $a43d996a7aa8a839$var$STYLE_TO_PREFIX[family][styleOrPrefix] || $a43d996a7aa8a839$var$STYLE_TO_PREFIX[family][style];
    const defined = styleOrPrefix in $a43d996a7aa8a839$var$namespace.styles ? styleOrPrefix : null;
    const result = prefix || defined || null;
    return result;
}
function $a43d996a7aa8a839$var$moveNonFaClassesToRest(classNames) {
    let rest = [];
    let iconName = null;
    classNames.forEach((cls)=>{
        const result = $a43d996a7aa8a839$var$getIconName($a43d996a7aa8a839$var$config.cssPrefix, cls);
        if (result) iconName = result;
        else if (cls) rest.push(cls);
    });
    return {
        iconName: iconName,
        rest: rest
    };
}
function $a43d996a7aa8a839$var$sortedUniqueValues(arr) {
    return arr.sort().filter((value, index, arr)=>{
        return arr.indexOf(value) === index;
    });
}
function $a43d996a7aa8a839$var$getCanonicalIcon(values) {
    let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { skipLookups: skipLookups = false } = params;
    let givenPrefix = null;
    const faCombinedClasses = $a43d996a7aa8a839$var$Ia.concat($a43d996a7aa8a839$var$bt$1);
    const faStyleOrFamilyClasses = $a43d996a7aa8a839$var$sortedUniqueValues(values.filter((cls)=>faCombinedClasses.includes(cls)));
    const nonStyleOrFamilyClasses = $a43d996a7aa8a839$var$sortedUniqueValues(values.filter((cls)=>!$a43d996a7aa8a839$var$Ia.includes(cls)));
    const faStyles = faStyleOrFamilyClasses.filter((cls)=>{
        givenPrefix = cls;
        return !$a43d996a7aa8a839$var$P.includes(cls);
    });
    const [styleFromValues = null] = faStyles;
    const family = $a43d996a7aa8a839$var$getFamilyId(faStyleOrFamilyClasses);
    const canonical = $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, $a43d996a7aa8a839$var$moveNonFaClassesToRest(nonStyleOrFamilyClasses)), {}, {
        prefix: $a43d996a7aa8a839$var$getCanonicalPrefix(styleFromValues, {
            family: family
        })
    });
    return $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, canonical), $a43d996a7aa8a839$var$getDefaultCanonicalPrefix({
        values: values,
        family: family,
        styles: $a43d996a7aa8a839$var$styles,
        config: $a43d996a7aa8a839$var$config,
        canonical: canonical,
        givenPrefix: givenPrefix
    })), $a43d996a7aa8a839$var$applyShimAndAlias(skipLookups, givenPrefix, canonical));
}
function $a43d996a7aa8a839$var$applyShimAndAlias(skipLookups, givenPrefix, canonical) {
    let { prefix: prefix, iconName: iconName } = canonical;
    if (skipLookups || !prefix || !iconName) return {
        prefix: prefix,
        iconName: iconName
    };
    const shim = givenPrefix === 'fa' ? $a43d996a7aa8a839$var$byOldName(iconName) : {};
    const aliasIconName = $a43d996a7aa8a839$var$byAlias(prefix, iconName);
    iconName = shim.iconName || aliasIconName || iconName;
    prefix = shim.prefix || prefix;
    if (prefix === 'far' && !$a43d996a7aa8a839$var$styles['far'] && $a43d996a7aa8a839$var$styles['fas'] && !$a43d996a7aa8a839$var$config.autoFetchSvg) // Allow a fallback from the regular style to solid if regular is not available
    // but only if we aren't auto-fetching SVGs
    prefix = 'fas';
    return {
        prefix: prefix,
        iconName: iconName
    };
}
const $a43d996a7aa8a839$var$newCanonicalFamilies = $a43d996a7aa8a839$var$L.filter((familyId)=>{
    return familyId !== $a43d996a7aa8a839$var$s || familyId !== $a43d996a7aa8a839$var$t;
});
const $a43d996a7aa8a839$var$newCanonicalStyles = Object.keys($a43d996a7aa8a839$var$ga).filter((key)=>key !== $a43d996a7aa8a839$var$s).map((key)=>Object.keys($a43d996a7aa8a839$var$ga[key])).flat();
function $a43d996a7aa8a839$var$getDefaultCanonicalPrefix(prefixOptions) {
    const { values: values, family: family, canonical: canonical, givenPrefix: givenPrefix = '', styles: styles = {}, config: config$$1 = {} } = prefixOptions;
    const isDuotoneFamily = family === $a43d996a7aa8a839$var$t;
    const valuesHasDuotone = values.includes('fa-duotone') || values.includes('fad');
    const defaultFamilyIsDuotone = config$$1.familyDefault === 'duotone';
    const canonicalPrefixIsDuotone = canonical.prefix === 'fad' || canonical.prefix === 'fa-duotone';
    if (!isDuotoneFamily && (valuesHasDuotone || defaultFamilyIsDuotone || canonicalPrefixIsDuotone)) canonical.prefix = 'fad';
    if (values.includes('fa-brands') || values.includes('fab')) canonical.prefix = 'fab';
    if (!canonical.prefix && $a43d996a7aa8a839$var$newCanonicalFamilies.includes(family)) {
        const validPrefix = Object.keys(styles).find((key)=>$a43d996a7aa8a839$var$newCanonicalStyles.includes(key));
        if (validPrefix || config$$1.autoFetchSvg) {
            const defaultPrefix = $a43d996a7aa8a839$var$pt.get(family).defaultShortPrefixId;
            canonical.prefix = defaultPrefix;
            canonical.iconName = $a43d996a7aa8a839$var$byAlias(canonical.prefix, canonical.iconName) || canonical.iconName;
        }
    }
    if (canonical.prefix === 'fa' || givenPrefix === 'fa') // The fa prefix is not canonical. So if it has made it through until this point
    // we will shift it to the correct prefix.
    canonical.prefix = $a43d996a7aa8a839$var$getDefaultUsablePrefix() || 'fas';
    return canonical;
}
class $a43d996a7aa8a839$var$Library {
    constructor(){
        this.definitions = {};
    }
    add() {
        for(var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++)definitions[_key] = arguments[_key];
        const additions = definitions.reduce(this._pullDefinitions, {});
        Object.keys(additions).forEach((key)=>{
            this.definitions[key] = $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, this.definitions[key] || {}), additions[key]);
            $a43d996a7aa8a839$var$defineIcons(key, additions[key]);
            // TODO can we stop doing this? We can't get the icons by 'fa-solid' any longer so this probably needs to change
            const longPrefix = $a43d996a7aa8a839$var$PREFIX_TO_LONG_STYLE[$a43d996a7aa8a839$var$s][key];
            if (longPrefix) $a43d996a7aa8a839$var$defineIcons(longPrefix, additions[key]);
            $a43d996a7aa8a839$var$build();
        });
    }
    reset() {
        this.definitions = {};
    }
    _pullDefinitions(additions, definition) {
        const normalized = definition.prefix && definition.iconName && definition.icon ? {
            0: definition
        } : definition;
        Object.keys(normalized).map((key)=>{
            const { prefix: prefix, iconName: iconName, icon: icon } = normalized[key];
            const aliases = icon[2];
            if (!additions[prefix]) additions[prefix] = {};
            if (aliases.length > 0) aliases.forEach((alias)=>{
                if (typeof alias === 'string') additions[prefix][alias] = icon;
            });
            additions[prefix][iconName] = icon;
        });
        return additions;
    }
}
let $a43d996a7aa8a839$var$_plugins = [];
let $a43d996a7aa8a839$var$_hooks = {};
const $a43d996a7aa8a839$var$providers = {};
const $a43d996a7aa8a839$var$defaultProviderKeys = Object.keys($a43d996a7aa8a839$var$providers);
function $a43d996a7aa8a839$var$registerPlugins(nextPlugins, _ref) {
    let { mixoutsTo: obj } = _ref;
    $a43d996a7aa8a839$var$_plugins = nextPlugins;
    $a43d996a7aa8a839$var$_hooks = {};
    Object.keys($a43d996a7aa8a839$var$providers).forEach((k)=>{
        if ($a43d996a7aa8a839$var$defaultProviderKeys.indexOf(k) === -1) delete $a43d996a7aa8a839$var$providers[k];
    });
    $a43d996a7aa8a839$var$_plugins.forEach((plugin)=>{
        const mixout = plugin.mixout ? plugin.mixout() : {};
        Object.keys(mixout).forEach((tk)=>{
            if (typeof mixout[tk] === 'function') obj[tk] = mixout[tk];
            if (typeof mixout[tk] === 'object') Object.keys(mixout[tk]).forEach((sk)=>{
                if (!obj[tk]) obj[tk] = {};
                obj[tk][sk] = mixout[tk][sk];
            });
        });
        if (plugin.hooks) {
            const hooks = plugin.hooks();
            Object.keys(hooks).forEach((hook)=>{
                if (!$a43d996a7aa8a839$var$_hooks[hook]) $a43d996a7aa8a839$var$_hooks[hook] = [];
                $a43d996a7aa8a839$var$_hooks[hook].push(hooks[hook]);
            });
        }
        if (plugin.provides) plugin.provides($a43d996a7aa8a839$var$providers);
    });
    return obj;
}
function $a43d996a7aa8a839$var$chainHooks(hook, accumulator) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    const hookFns = $a43d996a7aa8a839$var$_hooks[hook] || [];
    hookFns.forEach((hookFn)=>{
        accumulator = hookFn.apply(null, [
            accumulator,
            ...args
        ]); // eslint-disable-line no-useless-call
    });
    return accumulator;
}
function $a43d996a7aa8a839$var$callHooks(hook) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    const hookFns = $a43d996a7aa8a839$var$_hooks[hook] || [];
    hookFns.forEach((hookFn)=>{
        hookFn.apply(null, args);
    });
    return undefined;
}
function $a43d996a7aa8a839$var$callProvided() {
    const hook = arguments[0];
    const args = Array.prototype.slice.call(arguments, 1);
    return $a43d996a7aa8a839$var$providers[hook] ? $a43d996a7aa8a839$var$providers[hook].apply(null, args) : undefined;
}
function $a43d996a7aa8a839$var$findIconDefinition(iconLookup) {
    if (iconLookup.prefix === 'fa') iconLookup.prefix = 'fas';
    let { iconName: iconName } = iconLookup;
    const prefix = iconLookup.prefix || $a43d996a7aa8a839$var$getDefaultUsablePrefix();
    if (!iconName) return;
    iconName = $a43d996a7aa8a839$var$byAlias(prefix, iconName) || iconName;
    return $a43d996a7aa8a839$var$iconFromMapping($a43d996a7aa8a839$var$library.definitions, prefix, iconName) || $a43d996a7aa8a839$var$iconFromMapping($a43d996a7aa8a839$var$namespace.styles, prefix, iconName);
}
const $a43d996a7aa8a839$var$library = new $a43d996a7aa8a839$var$Library();
const $a43d996a7aa8a839$var$noAuto = ()=>{
    $a43d996a7aa8a839$var$config.autoReplaceSvg = false;
    $a43d996a7aa8a839$var$config.observeMutations = false;
    $a43d996a7aa8a839$var$callHooks('noAuto');
};
const $a43d996a7aa8a839$var$dom = {
    i2svg: function() {
        let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if ($a43d996a7aa8a839$var$IS_DOM) {
            $a43d996a7aa8a839$var$callHooks('beforeI2svg', params);
            $a43d996a7aa8a839$var$callProvided('pseudoElements2svg', params);
            return $a43d996a7aa8a839$var$callProvided('i2svg', params);
        } else return Promise.reject(new Error('Operation requires a DOM of some kind.'));
    },
    watch: function() {
        let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const { autoReplaceSvgRoot: autoReplaceSvgRoot } = params;
        if ($a43d996a7aa8a839$var$config.autoReplaceSvg === false) $a43d996a7aa8a839$var$config.autoReplaceSvg = true;
        $a43d996a7aa8a839$var$config.observeMutations = true;
        $a43d996a7aa8a839$var$domready(()=>{
            $a43d996a7aa8a839$var$autoReplace({
                autoReplaceSvgRoot: autoReplaceSvgRoot
            });
            $a43d996a7aa8a839$var$callHooks('watch', params);
        });
    }
};
const $a43d996a7aa8a839$var$parse = {
    icon: (icon)=>{
        if (icon === null) return null;
        if (typeof icon === 'object' && icon.prefix && icon.iconName) return {
            prefix: icon.prefix,
            iconName: $a43d996a7aa8a839$var$byAlias(icon.prefix, icon.iconName) || icon.iconName
        };
        if (Array.isArray(icon) && icon.length === 2) {
            const iconName = icon[1].indexOf('fa-') === 0 ? icon[1].slice(3) : icon[1];
            const prefix = $a43d996a7aa8a839$var$getCanonicalPrefix(icon[0]);
            return {
                prefix: prefix,
                iconName: $a43d996a7aa8a839$var$byAlias(prefix, iconName) || iconName
            };
        }
        if (typeof icon === 'string' && (icon.indexOf("".concat($a43d996a7aa8a839$var$config.cssPrefix, "-")) > -1 || icon.match($a43d996a7aa8a839$var$ICON_SELECTION_SYNTAX_PATTERN))) {
            const canonicalIcon = $a43d996a7aa8a839$var$getCanonicalIcon(icon.split(' '), {
                skipLookups: true
            });
            return {
                prefix: canonicalIcon.prefix || $a43d996a7aa8a839$var$getDefaultUsablePrefix(),
                iconName: $a43d996a7aa8a839$var$byAlias(canonicalIcon.prefix, canonicalIcon.iconName) || canonicalIcon.iconName
            };
        }
        if (typeof icon === 'string') {
            const prefix = $a43d996a7aa8a839$var$getDefaultUsablePrefix();
            return {
                prefix: prefix,
                iconName: $a43d996a7aa8a839$var$byAlias(prefix, icon) || icon
            };
        }
    }
};
const $a43d996a7aa8a839$export$644d8ea042df96a6 = {
    noAuto: $a43d996a7aa8a839$var$noAuto,
    config: $a43d996a7aa8a839$var$config,
    dom: $a43d996a7aa8a839$var$dom,
    parse: $a43d996a7aa8a839$var$parse,
    library: $a43d996a7aa8a839$var$library,
    findIconDefinition: $a43d996a7aa8a839$var$findIconDefinition,
    toHtml: $a43d996a7aa8a839$var$toHtml
};
const $a43d996a7aa8a839$var$autoReplace = function() {
    let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const { autoReplaceSvgRoot: autoReplaceSvgRoot = $a43d996a7aa8a839$var$DOCUMENT } = params;
    if ((Object.keys($a43d996a7aa8a839$var$namespace.styles).length > 0 || $a43d996a7aa8a839$var$config.autoFetchSvg) && $a43d996a7aa8a839$var$IS_DOM && $a43d996a7aa8a839$var$config.autoReplaceSvg) $a43d996a7aa8a839$export$644d8ea042df96a6.dom.i2svg({
        node: autoReplaceSvgRoot
    });
};
function $a43d996a7aa8a839$var$domVariants(val, abstractCreator) {
    Object.defineProperty(val, 'abstract', {
        get: abstractCreator
    });
    Object.defineProperty(val, 'html', {
        get: function() {
            return val.abstract.map((a)=>$a43d996a7aa8a839$var$toHtml(a));
        }
    });
    Object.defineProperty(val, 'node', {
        get: function() {
            if (!$a43d996a7aa8a839$var$IS_DOM) return;
            const container = $a43d996a7aa8a839$var$DOCUMENT.createElement('div');
            container.innerHTML = val.html;
            return container.children;
        }
    });
    return val;
}
function $a43d996a7aa8a839$var$asIcon(_ref) {
    let { children: children, main: main, mask: mask, attributes: attributes, styles: styles, transform: transform } = _ref;
    if ($a43d996a7aa8a839$var$transformIsMeaningful(transform) && main.found && !mask.found) {
        const { width: width, height: height } = main;
        const offset = {
            x: width / height / 2,
            y: 0.5
        };
        attributes['style'] = $a43d996a7aa8a839$var$joinStyles($a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, styles), {}, {
            'transform-origin': "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
        }));
    }
    return [
        {
            tag: 'svg',
            attributes: attributes,
            children: children
        }
    ];
}
function $a43d996a7aa8a839$var$asSymbol(_ref) {
    let { prefix: prefix, iconName: iconName, children: children, attributes: attributes, symbol: symbol } = _ref;
    const id = symbol === true ? "".concat(prefix, "-").concat($a43d996a7aa8a839$var$config.cssPrefix, "-").concat(iconName) : symbol;
    return [
        {
            tag: 'svg',
            attributes: {
                style: 'display: none;'
            },
            children: [
                {
                    tag: 'symbol',
                    attributes: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, attributes), {}, {
                        id: id
                    }),
                    children: children
                }
            ]
        }
    ];
}
function $a43d996a7aa8a839$var$makeInlineSvgAbstract(params) {
    const { icons: { main: main, mask: mask }, prefix: prefix, iconName: iconName, transform: transform, symbol: symbol, title: title, maskId: maskId, titleId: titleId, extra: extra, watchable: watchable = false } = params;
    const { width: width, height: height } = mask.found ? mask : main;
    const isUploadedIcon = $a43d996a7aa8a839$var$Lt.includes(prefix);
    const attrClass = [
        $a43d996a7aa8a839$var$config.replacementClass,
        iconName ? "".concat($a43d996a7aa8a839$var$config.cssPrefix, "-").concat(iconName) : ''
    ].filter((c$$1)=>extra.classes.indexOf(c$$1) === -1).filter((c$$1)=>c$$1 !== '' || !!c$$1).concat(extra.classes).join(' ');
    let content = {
        children: [],
        attributes: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, extra.attributes), {}, {
            'data-prefix': prefix,
            'data-icon': iconName,
            'class': attrClass,
            'role': extra.attributes.role || 'img',
            'xmlns': 'http://www.w3.org/2000/svg',
            'viewBox': "0 0 ".concat(width, " ").concat(height)
        })
    };
    const uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf('fa-fw') ? {
        width: "".concat(width / height * 1, "em")
    } : {};
    if (watchable) content.attributes[$a43d996a7aa8a839$var$DATA_FA_I2SVG] = '';
    if (title) {
        content.children.push({
            tag: 'title',
            attributes: {
                id: content.attributes['aria-labelledby'] || "title-".concat(titleId || $a43d996a7aa8a839$var$nextUniqueId())
            },
            children: [
                title
            ]
        });
        delete content.attributes.title;
    }
    const args = $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, content), {}, {
        prefix: prefix,
        iconName: iconName,
        main: main,
        mask: mask,
        maskId: maskId,
        transform: transform,
        symbol: symbol,
        styles: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, uploadedIconWidthStyle), extra.styles)
    });
    const { children: children, attributes: attributes } = mask.found && main.found ? $a43d996a7aa8a839$var$callProvided('generateAbstractMask', args) || {
        children: [],
        attributes: {}
    } : $a43d996a7aa8a839$var$callProvided('generateAbstractIcon', args) || {
        children: [],
        attributes: {}
    };
    args.children = children;
    args.attributes = attributes;
    if (symbol) return $a43d996a7aa8a839$var$asSymbol(args);
    else return $a43d996a7aa8a839$var$asIcon(args);
}
function $a43d996a7aa8a839$var$makeLayersTextAbstract(params) {
    const { content: content, width: width, height: height, transform: transform, title: title, extra: extra, watchable: watchable = false } = params;
    const attributes = $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, extra.attributes), title ? {
        'title': title
    } : {}), {}, {
        'class': extra.classes.join(' ')
    });
    if (watchable) attributes[$a43d996a7aa8a839$var$DATA_FA_I2SVG] = '';
    const styles = $a43d996a7aa8a839$var$_objectSpread2({}, extra.styles);
    if ($a43d996a7aa8a839$var$transformIsMeaningful(transform)) {
        styles['transform'] = $a43d996a7aa8a839$var$transformForCss({
            transform: transform,
            startCentered: true,
            width: width,
            height: height
        });
        styles['-webkit-transform'] = styles['transform'];
    }
    const styleString = $a43d996a7aa8a839$var$joinStyles(styles);
    if (styleString.length > 0) attributes['style'] = styleString;
    const val = [];
    val.push({
        tag: 'span',
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) val.push({
        tag: 'span',
        attributes: {
            class: 'sr-only'
        },
        children: [
            title
        ]
    });
    return val;
}
function $a43d996a7aa8a839$var$makeLayersCounterAbstract(params) {
    const { content: content, title: title, extra: extra } = params;
    const attributes = $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, extra.attributes), title ? {
        'title': title
    } : {}), {}, {
        'class': extra.classes.join(' ')
    });
    const styleString = $a43d996a7aa8a839$var$joinStyles(extra.styles);
    if (styleString.length > 0) attributes['style'] = styleString;
    const val = [];
    val.push({
        tag: 'span',
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) val.push({
        tag: 'span',
        attributes: {
            class: 'sr-only'
        },
        children: [
            title
        ]
    });
    return val;
}
const { styles: $a43d996a7aa8a839$var$styles$1 } = $a43d996a7aa8a839$var$namespace;
function $a43d996a7aa8a839$var$asFoundIcon(icon) {
    const width = icon[0];
    const height = icon[1];
    const [vectorData] = icon.slice(4);
    let element = null;
    if (Array.isArray(vectorData)) element = {
        tag: 'g',
        attributes: {
            class: "".concat($a43d996a7aa8a839$var$config.cssPrefix, "-").concat($a43d996a7aa8a839$var$DUOTONE_CLASSES.GROUP)
        },
        children: [
            {
                tag: 'path',
                attributes: {
                    class: "".concat($a43d996a7aa8a839$var$config.cssPrefix, "-").concat($a43d996a7aa8a839$var$DUOTONE_CLASSES.SECONDARY),
                    fill: 'currentColor',
                    d: vectorData[0]
                }
            },
            {
                tag: 'path',
                attributes: {
                    class: "".concat($a43d996a7aa8a839$var$config.cssPrefix, "-").concat($a43d996a7aa8a839$var$DUOTONE_CLASSES.PRIMARY),
                    fill: 'currentColor',
                    d: vectorData[1]
                }
            }
        ]
    };
    else element = {
        tag: 'path',
        attributes: {
            fill: 'currentColor',
            d: vectorData
        }
    };
    return {
        found: true,
        width: width,
        height: height,
        icon: element
    };
}
const $a43d996a7aa8a839$var$missingIconResolutionMixin = {
    found: false,
    width: 512,
    height: 512
};
function $a43d996a7aa8a839$var$maybeNotifyMissing(iconName, prefix) {
    if (!$a43d996a7aa8a839$var$PRODUCTION && !$a43d996a7aa8a839$var$config.showMissingIcons && iconName) console.error("Icon with name \"".concat(iconName, "\" and prefix \"").concat(prefix, "\" is missing."));
}
function $a43d996a7aa8a839$var$findIcon(iconName, prefix) {
    let givenPrefix = prefix;
    if (prefix === 'fa' && $a43d996a7aa8a839$var$config.styleDefault !== null) prefix = $a43d996a7aa8a839$var$getDefaultUsablePrefix();
    return new Promise((resolve, reject)=>{
        if (givenPrefix === 'fa') {
            const shim = $a43d996a7aa8a839$var$byOldName(iconName) || {};
            iconName = shim.iconName || iconName;
            prefix = shim.prefix || prefix;
        }
        if (iconName && prefix && $a43d996a7aa8a839$var$styles$1[prefix] && $a43d996a7aa8a839$var$styles$1[prefix][iconName]) {
            const icon = $a43d996a7aa8a839$var$styles$1[prefix][iconName];
            return resolve($a43d996a7aa8a839$var$asFoundIcon(icon));
        }
        $a43d996a7aa8a839$var$maybeNotifyMissing(iconName, prefix);
        resolve($a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, $a43d996a7aa8a839$var$missingIconResolutionMixin), {}, {
            icon: $a43d996a7aa8a839$var$config.showMissingIcons && iconName ? $a43d996a7aa8a839$var$callProvided('missingIconAbstract') || {} : {}
        }));
    });
}
const $a43d996a7aa8a839$var$noop$1 = ()=>{};
const $a43d996a7aa8a839$var$p$2 = $a43d996a7aa8a839$var$config.measurePerformance && $a43d996a7aa8a839$var$PERFORMANCE && $a43d996a7aa8a839$var$PERFORMANCE.mark && $a43d996a7aa8a839$var$PERFORMANCE.measure ? $a43d996a7aa8a839$var$PERFORMANCE : {
    mark: $a43d996a7aa8a839$var$noop$1,
    measure: $a43d996a7aa8a839$var$noop$1
};
const $a43d996a7aa8a839$var$preamble = "FA \"6.7.2\"";
const $a43d996a7aa8a839$var$begin = (name)=>{
    $a43d996a7aa8a839$var$p$2.mark("".concat($a43d996a7aa8a839$var$preamble, " ").concat(name, " begins"));
    return ()=>$a43d996a7aa8a839$var$end(name);
};
const $a43d996a7aa8a839$var$end = (name)=>{
    $a43d996a7aa8a839$var$p$2.mark("".concat($a43d996a7aa8a839$var$preamble, " ").concat(name, " ends"));
    $a43d996a7aa8a839$var$p$2.measure("".concat($a43d996a7aa8a839$var$preamble, " ").concat(name), "".concat($a43d996a7aa8a839$var$preamble, " ").concat(name, " begins"), "".concat($a43d996a7aa8a839$var$preamble, " ").concat(name, " ends"));
};
var $a43d996a7aa8a839$var$perf = {
    begin: $a43d996a7aa8a839$var$begin,
    end: $a43d996a7aa8a839$var$end
};
const $a43d996a7aa8a839$var$noop$2 = ()=>{};
function $a43d996a7aa8a839$var$isWatched(node) {
    const i2svg = node.getAttribute ? node.getAttribute($a43d996a7aa8a839$var$DATA_FA_I2SVG) : null;
    return typeof i2svg === 'string';
}
function $a43d996a7aa8a839$var$hasPrefixAndIcon(node) {
    const prefix = node.getAttribute ? node.getAttribute($a43d996a7aa8a839$var$DATA_PREFIX) : null;
    const icon = node.getAttribute ? node.getAttribute($a43d996a7aa8a839$var$DATA_ICON) : null;
    return prefix && icon;
}
function $a43d996a7aa8a839$var$hasBeenReplaced(node) {
    return node && node.classList && node.classList.contains && node.classList.contains($a43d996a7aa8a839$var$config.replacementClass);
}
function $a43d996a7aa8a839$var$getMutator() {
    if ($a43d996a7aa8a839$var$config.autoReplaceSvg === true) return $a43d996a7aa8a839$var$mutators.replace;
    const mutator = $a43d996a7aa8a839$var$mutators[$a43d996a7aa8a839$var$config.autoReplaceSvg];
    return mutator || $a43d996a7aa8a839$var$mutators.replace;
}
function $a43d996a7aa8a839$var$createElementNS(tag) {
    return $a43d996a7aa8a839$var$DOCUMENT.createElementNS('http://www.w3.org/2000/svg', tag);
}
function $a43d996a7aa8a839$var$createElement(tag) {
    return $a43d996a7aa8a839$var$DOCUMENT.createElement(tag);
}
function $a43d996a7aa8a839$var$convertSVG(abstractObj) {
    let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { ceFn: ceFn = abstractObj.tag === 'svg' ? $a43d996a7aa8a839$var$createElementNS : $a43d996a7aa8a839$var$createElement } = params;
    if (typeof abstractObj === 'string') return $a43d996a7aa8a839$var$DOCUMENT.createTextNode(abstractObj);
    const tag = ceFn(abstractObj.tag);
    Object.keys(abstractObj.attributes || []).forEach(function(key) {
        tag.setAttribute(key, abstractObj.attributes[key]);
    });
    const children = abstractObj.children || [];
    children.forEach(function(child) {
        tag.appendChild($a43d996a7aa8a839$var$convertSVG(child, {
            ceFn: ceFn
        }));
    });
    return tag;
}
function $a43d996a7aa8a839$var$nodeAsComment(node) {
    let comment = " ".concat(node.outerHTML, " ");
    /* BEGIN.ATTRIBUTION */ comment = "".concat(comment, "Font Awesome fontawesome.com ");
    /* END.ATTRIBUTION */ return comment;
}
const $a43d996a7aa8a839$var$mutators = {
    replace: function(mutation) {
        const node = mutation[0];
        if (node.parentNode) {
            mutation[1].forEach((abstract)=>{
                node.parentNode.insertBefore($a43d996a7aa8a839$var$convertSVG(abstract), node);
            });
            if (node.getAttribute($a43d996a7aa8a839$var$DATA_FA_I2SVG) === null && $a43d996a7aa8a839$var$config.keepOriginalSource) {
                let comment = $a43d996a7aa8a839$var$DOCUMENT.createComment($a43d996a7aa8a839$var$nodeAsComment(node));
                node.parentNode.replaceChild(comment, node);
            } else node.remove();
        }
    },
    nest: function(mutation) {
        const node = mutation[0];
        const abstract = mutation[1];
        // If we already have a replaced node we do not want to continue nesting within it.
        // Short-circuit to the standard replacement
        if (~$a43d996a7aa8a839$var$classArray(node).indexOf($a43d996a7aa8a839$var$config.replacementClass)) return $a43d996a7aa8a839$var$mutators.replace(mutation);
        const forSvg = new RegExp("".concat($a43d996a7aa8a839$var$config.cssPrefix, "-.*"));
        delete abstract[0].attributes.id;
        if (abstract[0].attributes.class) {
            const splitClasses = abstract[0].attributes.class.split(' ').reduce((acc, cls)=>{
                if (cls === $a43d996a7aa8a839$var$config.replacementClass || cls.match(forSvg)) acc.toSvg.push(cls);
                else acc.toNode.push(cls);
                return acc;
            }, {
                toNode: [],
                toSvg: []
            });
            abstract[0].attributes.class = splitClasses.toSvg.join(' ');
            if (splitClasses.toNode.length === 0) node.removeAttribute('class');
            else node.setAttribute('class', splitClasses.toNode.join(' '));
        }
        const newInnerHTML = abstract.map((a)=>$a43d996a7aa8a839$var$toHtml(a)).join('\n');
        node.setAttribute($a43d996a7aa8a839$var$DATA_FA_I2SVG, '');
        node.innerHTML = newInnerHTML;
    }
};
function $a43d996a7aa8a839$var$performOperationSync(op) {
    op();
}
function $a43d996a7aa8a839$var$perform(mutations, callback) {
    const callbackFunction = typeof callback === 'function' ? callback : $a43d996a7aa8a839$var$noop$2;
    if (mutations.length === 0) callbackFunction();
    else {
        let frame = $a43d996a7aa8a839$var$performOperationSync;
        if ($a43d996a7aa8a839$var$config.mutateApproach === $a43d996a7aa8a839$var$MUTATION_APPROACH_ASYNC) frame = $a43d996a7aa8a839$var$WINDOW.requestAnimationFrame || $a43d996a7aa8a839$var$performOperationSync;
        frame(()=>{
            const mutator = $a43d996a7aa8a839$var$getMutator();
            const mark = $a43d996a7aa8a839$var$perf.begin('mutate');
            mutations.map(mutator);
            mark();
            callbackFunction();
        });
    }
}
let $a43d996a7aa8a839$var$disabled = false;
function $a43d996a7aa8a839$var$disableObservation() {
    $a43d996a7aa8a839$var$disabled = true;
}
function $a43d996a7aa8a839$var$enableObservation() {
    $a43d996a7aa8a839$var$disabled = false;
}
let $a43d996a7aa8a839$var$mo = null;
function $a43d996a7aa8a839$var$observe(options) {
    if (!$a43d996a7aa8a839$var$MUTATION_OBSERVER) return;
    if (!$a43d996a7aa8a839$var$config.observeMutations) return;
    const { treeCallback: treeCallback = $a43d996a7aa8a839$var$noop$2, nodeCallback: nodeCallback = $a43d996a7aa8a839$var$noop$2, pseudoElementsCallback: pseudoElementsCallback = $a43d996a7aa8a839$var$noop$2, observeMutationsRoot: observeMutationsRoot = $a43d996a7aa8a839$var$DOCUMENT } = options;
    $a43d996a7aa8a839$var$mo = new $a43d996a7aa8a839$var$MUTATION_OBSERVER((objects)=>{
        if ($a43d996a7aa8a839$var$disabled) return;
        const defaultPrefix = $a43d996a7aa8a839$var$getDefaultUsablePrefix();
        $a43d996a7aa8a839$var$toArray(objects).forEach((mutationRecord)=>{
            if (mutationRecord.type === 'childList' && mutationRecord.addedNodes.length > 0 && !$a43d996a7aa8a839$var$isWatched(mutationRecord.addedNodes[0])) {
                if ($a43d996a7aa8a839$var$config.searchPseudoElements) pseudoElementsCallback(mutationRecord.target);
                treeCallback(mutationRecord.target);
            }
            if (mutationRecord.type === 'attributes' && mutationRecord.target.parentNode && $a43d996a7aa8a839$var$config.searchPseudoElements) pseudoElementsCallback(mutationRecord.target.parentNode);
            if (mutationRecord.type === 'attributes' && $a43d996a7aa8a839$var$isWatched(mutationRecord.target) && ~$a43d996a7aa8a839$var$ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
                if (mutationRecord.attributeName === 'class' && $a43d996a7aa8a839$var$hasPrefixAndIcon(mutationRecord.target)) {
                    const { prefix: prefix, iconName: iconName } = $a43d996a7aa8a839$var$getCanonicalIcon($a43d996a7aa8a839$var$classArray(mutationRecord.target));
                    mutationRecord.target.setAttribute($a43d996a7aa8a839$var$DATA_PREFIX, prefix || defaultPrefix);
                    if (iconName) mutationRecord.target.setAttribute($a43d996a7aa8a839$var$DATA_ICON, iconName);
                } else if ($a43d996a7aa8a839$var$hasBeenReplaced(mutationRecord.target)) nodeCallback(mutationRecord.target);
            }
        });
    });
    if (!$a43d996a7aa8a839$var$IS_DOM) return;
    $a43d996a7aa8a839$var$mo.observe(observeMutationsRoot, {
        childList: true,
        attributes: true,
        characterData: true,
        subtree: true
    });
}
function $a43d996a7aa8a839$var$disconnect() {
    if (!$a43d996a7aa8a839$var$mo) return;
    $a43d996a7aa8a839$var$mo.disconnect();
}
function $a43d996a7aa8a839$var$styleParser(node) {
    const style = node.getAttribute('style');
    let val = [];
    if (style) val = style.split(';').reduce((acc, style)=>{
        const styles = style.split(':');
        const prop = styles[0];
        const value = styles.slice(1);
        if (prop && value.length > 0) acc[prop] = value.join(':').trim();
        return acc;
    }, {});
    return val;
}
function $a43d996a7aa8a839$var$classParser(node) {
    const existingPrefix = node.getAttribute('data-prefix');
    const existingIconName = node.getAttribute('data-icon');
    const innerText = node.innerText !== undefined ? node.innerText.trim() : '';
    let val = $a43d996a7aa8a839$var$getCanonicalIcon($a43d996a7aa8a839$var$classArray(node));
    if (!val.prefix) val.prefix = $a43d996a7aa8a839$var$getDefaultUsablePrefix();
    if (existingPrefix && existingIconName) {
        val.prefix = existingPrefix;
        val.iconName = existingIconName;
    }
    if (val.iconName && val.prefix) return val;
    if (val.prefix && innerText.length > 0) val.iconName = $a43d996a7aa8a839$var$byLigature(val.prefix, node.innerText) || $a43d996a7aa8a839$var$byUnicode(val.prefix, $a43d996a7aa8a839$var$toHex(node.innerText));
    if (!val.iconName && $a43d996a7aa8a839$var$config.autoFetchSvg && node.firstChild && node.firstChild.nodeType === Node.TEXT_NODE) val.iconName = node.firstChild.data;
    return val;
}
function $a43d996a7aa8a839$var$attributesParser(node) {
    const extraAttributes = $a43d996a7aa8a839$var$toArray(node.attributes).reduce((acc, attr)=>{
        if (acc.name !== 'class' && acc.name !== 'style') acc[attr.name] = attr.value;
        return acc;
    }, {});
    const title = node.getAttribute('title');
    const titleId = node.getAttribute('data-fa-title-id');
    if ($a43d996a7aa8a839$var$config.autoA11y) {
        if (title) extraAttributes['aria-labelledby'] = "".concat($a43d996a7aa8a839$var$config.replacementClass, "-title-").concat(titleId || $a43d996a7aa8a839$var$nextUniqueId());
        else {
            extraAttributes['aria-hidden'] = 'true';
            extraAttributes['focusable'] = 'false';
        }
    }
    return extraAttributes;
}
function $a43d996a7aa8a839$var$blankMeta() {
    return {
        iconName: null,
        title: null,
        titleId: null,
        prefix: null,
        transform: $a43d996a7aa8a839$var$meaninglessTransform,
        symbol: false,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        extra: {
            classes: [],
            styles: {},
            attributes: {}
        }
    };
}
function $a43d996a7aa8a839$var$parseMeta(node) {
    let parser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        styleParser: true
    };
    const { iconName: iconName, prefix: prefix, rest: extraClasses } = $a43d996a7aa8a839$var$classParser(node);
    const extraAttributes = $a43d996a7aa8a839$var$attributesParser(node);
    const pluginMeta = $a43d996a7aa8a839$var$chainHooks('parseNodeAttributes', {}, node);
    let extraStyles = parser.styleParser ? $a43d996a7aa8a839$var$styleParser(node) : [];
    return $a43d996a7aa8a839$var$_objectSpread2({
        iconName: iconName,
        title: node.getAttribute('title'),
        titleId: node.getAttribute('data-fa-title-id'),
        prefix: prefix,
        transform: $a43d996a7aa8a839$var$meaninglessTransform,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        symbol: false,
        extra: {
            classes: extraClasses,
            styles: extraStyles,
            attributes: extraAttributes
        }
    }, pluginMeta);
}
const { styles: $a43d996a7aa8a839$var$styles$2 } = $a43d996a7aa8a839$var$namespace;
function $a43d996a7aa8a839$var$generateMutation(node) {
    const nodeMeta = $a43d996a7aa8a839$var$config.autoReplaceSvg === 'nest' ? $a43d996a7aa8a839$var$parseMeta(node, {
        styleParser: false
    }) : $a43d996a7aa8a839$var$parseMeta(node);
    if (~nodeMeta.extra.classes.indexOf($a43d996a7aa8a839$var$LAYERS_TEXT_CLASSNAME)) return $a43d996a7aa8a839$var$callProvided('generateLayersText', node, nodeMeta);
    else return $a43d996a7aa8a839$var$callProvided('generateSvgReplacementMutation', node, nodeMeta);
}
function $a43d996a7aa8a839$var$getKnownPrefixes() {
    return [
        ...$a43d996a7aa8a839$var$Ft,
        ...$a43d996a7aa8a839$var$Ia
    ];
}
function $a43d996a7aa8a839$var$onTree(root) {
    let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (!$a43d996a7aa8a839$var$IS_DOM) return Promise.resolve();
    const htmlClassList = $a43d996a7aa8a839$var$DOCUMENT.documentElement.classList;
    const hclAdd = (suffix)=>htmlClassList.add("".concat($a43d996a7aa8a839$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    const hclRemove = (suffix)=>htmlClassList.remove("".concat($a43d996a7aa8a839$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    const prefixes = $a43d996a7aa8a839$var$config.autoFetchSvg ? $a43d996a7aa8a839$var$getKnownPrefixes() : $a43d996a7aa8a839$var$P.concat(Object.keys($a43d996a7aa8a839$var$styles$2));
    if (!prefixes.includes('fa')) prefixes.push('fa');
    const prefixesDomQuery = [
        ".".concat($a43d996a7aa8a839$var$LAYERS_TEXT_CLASSNAME, ":not([").concat($a43d996a7aa8a839$var$DATA_FA_I2SVG, "])")
    ].concat(prefixes.map((p$$1)=>".".concat(p$$1, ":not([").concat($a43d996a7aa8a839$var$DATA_FA_I2SVG, "])"))).join(', ');
    if (prefixesDomQuery.length === 0) return Promise.resolve();
    let candidates = [];
    try {
        candidates = $a43d996a7aa8a839$var$toArray(root.querySelectorAll(prefixesDomQuery));
    } catch (e$$1) {
    // noop
    }
    if (candidates.length > 0) {
        hclAdd('pending');
        hclRemove('complete');
    } else return Promise.resolve();
    const mark = $a43d996a7aa8a839$var$perf.begin('onTree');
    const mutations = candidates.reduce((acc, node)=>{
        try {
            const mutation = $a43d996a7aa8a839$var$generateMutation(node);
            if (mutation) acc.push(mutation);
        } catch (e$$1) {
            if (!$a43d996a7aa8a839$var$PRODUCTION) {
                if (e$$1.name === 'MissingIcon') console.error(e$$1);
            }
        }
        return acc;
    }, []);
    return new Promise((resolve, reject)=>{
        Promise.all(mutations).then((resolvedMutations)=>{
            $a43d996a7aa8a839$var$perform(resolvedMutations, ()=>{
                hclAdd('active');
                hclAdd('complete');
                hclRemove('pending');
                if (typeof callback === 'function') callback();
                mark();
                resolve();
            });
        }).catch((e$$1)=>{
            mark();
            reject(e$$1);
        });
    });
}
function $a43d996a7aa8a839$var$onNode(node) {
    let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    $a43d996a7aa8a839$var$generateMutation(node).then((mutation)=>{
        if (mutation) $a43d996a7aa8a839$var$perform([
            mutation
        ], callback);
    });
}
function $a43d996a7aa8a839$var$resolveIcons(next) {
    return function(maybeIconDefinition) {
        let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : $a43d996a7aa8a839$var$findIconDefinition(maybeIconDefinition || {});
        let { mask: mask } = params;
        if (mask) mask = (mask || {}).icon ? mask : $a43d996a7aa8a839$var$findIconDefinition(mask || {});
        return next(iconDefinition, $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, params), {}, {
            mask: mask
        }));
    };
}
const $a43d996a7aa8a839$var$render = function(iconDefinition) {
    let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { transform: transform = $a43d996a7aa8a839$var$meaninglessTransform, symbol: symbol = false, mask: mask = null, maskId: maskId = null, title: title = null, titleId: titleId = null, classes: classes = [], attributes: attributes = {}, styles: styles = {} } = params;
    if (!iconDefinition) return;
    const { prefix: prefix, iconName: iconName, icon: icon } = iconDefinition;
    return $a43d996a7aa8a839$var$domVariants($a43d996a7aa8a839$var$_objectSpread2({
        type: 'icon'
    }, iconDefinition), ()=>{
        $a43d996a7aa8a839$var$callHooks('beforeDOMElementCreation', {
            iconDefinition: iconDefinition,
            params: params
        });
        if ($a43d996a7aa8a839$var$config.autoA11y) {
            if (title) attributes['aria-labelledby'] = "".concat($a43d996a7aa8a839$var$config.replacementClass, "-title-").concat(titleId || $a43d996a7aa8a839$var$nextUniqueId());
            else {
                attributes['aria-hidden'] = 'true';
                attributes['focusable'] = 'false';
            }
        }
        return $a43d996a7aa8a839$var$makeInlineSvgAbstract({
            icons: {
                main: $a43d996a7aa8a839$var$asFoundIcon(icon),
                mask: mask ? $a43d996a7aa8a839$var$asFoundIcon(mask.icon) : {
                    found: false,
                    width: null,
                    height: null,
                    icon: {}
                }
            },
            prefix: prefix,
            iconName: iconName,
            transform: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, $a43d996a7aa8a839$var$meaninglessTransform), transform),
            symbol: symbol,
            title: title,
            maskId: maskId,
            titleId: titleId,
            extra: {
                attributes: attributes,
                styles: styles,
                classes: classes
            }
        });
    });
};
var $a43d996a7aa8a839$var$ReplaceElements = {
    mixout () {
        return {
            icon: $a43d996a7aa8a839$var$resolveIcons($a43d996a7aa8a839$var$render)
        };
    },
    hooks () {
        return {
            mutationObserverCallbacks (accumulator) {
                accumulator.treeCallback = $a43d996a7aa8a839$var$onTree;
                accumulator.nodeCallback = $a43d996a7aa8a839$var$onNode;
                return accumulator;
            }
        };
    },
    provides (providers$$1) {
        providers$$1.i2svg = function(params) {
            const { node: node = $a43d996a7aa8a839$var$DOCUMENT, callback: callback = ()=>{} } = params;
            return $a43d996a7aa8a839$var$onTree(node, callback);
        };
        providers$$1.generateSvgReplacementMutation = function(node, nodeMeta) {
            const { iconName: iconName, title: title, titleId: titleId, prefix: prefix, transform: transform, symbol: symbol, mask: mask, maskId: maskId, extra: extra } = nodeMeta;
            return new Promise((resolve, reject)=>{
                Promise.all([
                    $a43d996a7aa8a839$var$findIcon(iconName, prefix),
                    mask.iconName ? $a43d996a7aa8a839$var$findIcon(mask.iconName, mask.prefix) : Promise.resolve({
                        found: false,
                        width: 512,
                        height: 512,
                        icon: {}
                    })
                ]).then((_ref)=>{
                    let [main, mask] = _ref;
                    resolve([
                        node,
                        $a43d996a7aa8a839$var$makeInlineSvgAbstract({
                            icons: {
                                main: main,
                                mask: mask
                            },
                            prefix: prefix,
                            iconName: iconName,
                            transform: transform,
                            symbol: symbol,
                            maskId: maskId,
                            title: title,
                            titleId: titleId,
                            extra: extra,
                            watchable: true
                        })
                    ]);
                }).catch(reject);
            });
        };
        providers$$1.generateAbstractIcon = function(_ref2) {
            let { children: children, attributes: attributes, main: main, transform: transform, styles: styles } = _ref2;
            const styleString = $a43d996a7aa8a839$var$joinStyles(styles);
            if (styleString.length > 0) attributes['style'] = styleString;
            let nextChild;
            if ($a43d996a7aa8a839$var$transformIsMeaningful(transform)) nextChild = $a43d996a7aa8a839$var$callProvided('generateAbstractTransformGrouping', {
                main: main,
                transform: transform,
                containerWidth: main.width,
                iconWidth: main.width
            });
            children.push(nextChild || main.icon);
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var $a43d996a7aa8a839$var$Layers = {
    mixout () {
        return {
            layer (assembler) {
                let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                const { classes: classes = [] } = params;
                return $a43d996a7aa8a839$var$domVariants({
                    type: 'layer'
                }, ()=>{
                    $a43d996a7aa8a839$var$callHooks('beforeDOMElementCreation', {
                        assembler: assembler,
                        params: params
                    });
                    let children = [];
                    assembler((args)=>{
                        Array.isArray(args) ? args.map((a)=>{
                            children = children.concat(a.abstract);
                        }) : children = children.concat(args.abstract);
                    });
                    return [
                        {
                            tag: 'span',
                            attributes: {
                                class: [
                                    "".concat($a43d996a7aa8a839$var$config.cssPrefix, "-layers"),
                                    ...classes
                                ].join(' ')
                            },
                            children: children
                        }
                    ];
                });
            }
        };
    }
};
var $a43d996a7aa8a839$var$LayersCounter = {
    mixout () {
        return {
            counter (content) {
                let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                const { title: title = null, classes: classes = [], attributes: attributes = {}, styles: styles = {} } = params;
                return $a43d996a7aa8a839$var$domVariants({
                    type: 'counter',
                    content: content
                }, ()=>{
                    $a43d996a7aa8a839$var$callHooks('beforeDOMElementCreation', {
                        content: content,
                        params: params
                    });
                    return $a43d996a7aa8a839$var$makeLayersCounterAbstract({
                        content: content.toString(),
                        title: title,
                        extra: {
                            attributes: attributes,
                            styles: styles,
                            classes: [
                                "".concat($a43d996a7aa8a839$var$config.cssPrefix, "-layers-counter"),
                                ...classes
                            ]
                        }
                    });
                });
            }
        };
    }
};
var $a43d996a7aa8a839$var$LayersText = {
    mixout () {
        return {
            text (content) {
                let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                const { transform: transform = $a43d996a7aa8a839$var$meaninglessTransform, title: title = null, classes: classes = [], attributes: attributes = {}, styles: styles = {} } = params;
                return $a43d996a7aa8a839$var$domVariants({
                    type: 'text',
                    content: content
                }, ()=>{
                    $a43d996a7aa8a839$var$callHooks('beforeDOMElementCreation', {
                        content: content,
                        params: params
                    });
                    return $a43d996a7aa8a839$var$makeLayersTextAbstract({
                        content: content,
                        transform: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, $a43d996a7aa8a839$var$meaninglessTransform), transform),
                        title: title,
                        extra: {
                            attributes: attributes,
                            styles: styles,
                            classes: [
                                "".concat($a43d996a7aa8a839$var$config.cssPrefix, "-layers-text"),
                                ...classes
                            ]
                        }
                    });
                });
            }
        };
    },
    provides (providers$$1) {
        providers$$1.generateLayersText = function(node, nodeMeta) {
            const { title: title, transform: transform, extra: extra } = nodeMeta;
            let width = null;
            let height = null;
            if ($a43d996a7aa8a839$var$IS_IE) {
                const computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
                const boundingClientRect = node.getBoundingClientRect();
                width = boundingClientRect.width / computedFontSize;
                height = boundingClientRect.height / computedFontSize;
            }
            if ($a43d996a7aa8a839$var$config.autoA11y && !title) extra.attributes['aria-hidden'] = 'true';
            return Promise.resolve([
                node,
                $a43d996a7aa8a839$var$makeLayersTextAbstract({
                    content: node.innerHTML,
                    width: width,
                    height: height,
                    transform: transform,
                    title: title,
                    extra: extra,
                    watchable: true
                })
            ]);
        };
    }
};
const $a43d996a7aa8a839$var$CLEAN_CONTENT_PATTERN = new RegExp('\u{22}', 'ug');
const $a43d996a7aa8a839$var$SECONDARY_UNICODE_RANGE = [
    1105920,
    1112319
];
const $a43d996a7aa8a839$var$_FONT_FAMILY_WEIGHT_TO_PREFIX = $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, {
    FontAwesome: {
        normal: 'fas',
        400: 'fas'
    }
}), $a43d996a7aa8a839$var$lt), $a43d996a7aa8a839$var$wa), $a43d996a7aa8a839$var$Yt);
const $a43d996a7aa8a839$var$FONT_FAMILY_WEIGHT_TO_PREFIX = Object.keys($a43d996a7aa8a839$var$_FONT_FAMILY_WEIGHT_TO_PREFIX).reduce((acc, key)=>{
    acc[key.toLowerCase()] = $a43d996a7aa8a839$var$_FONT_FAMILY_WEIGHT_TO_PREFIX[key];
    return acc;
}, {});
const $a43d996a7aa8a839$var$FONT_FAMILY_WEIGHT_FALLBACK = Object.keys($a43d996a7aa8a839$var$FONT_FAMILY_WEIGHT_TO_PREFIX).reduce((acc, fontFamily)=>{
    const weights = $a43d996a7aa8a839$var$FONT_FAMILY_WEIGHT_TO_PREFIX[fontFamily];
    acc[fontFamily] = weights[900] || [
        ...Object.entries(weights)
    ][0][1];
    return acc;
}, {});
function $a43d996a7aa8a839$var$hexValueFromContent(content) {
    const cleaned = content.replace($a43d996a7aa8a839$var$CLEAN_CONTENT_PATTERN, '');
    const codePoint = $a43d996a7aa8a839$var$codePointAt(cleaned, 0);
    const isPrependTen = codePoint >= $a43d996a7aa8a839$var$SECONDARY_UNICODE_RANGE[0] && codePoint <= $a43d996a7aa8a839$var$SECONDARY_UNICODE_RANGE[1];
    const isDoubled = cleaned.length === 2 ? cleaned[0] === cleaned[1] : false;
    return {
        value: isDoubled ? $a43d996a7aa8a839$var$toHex(cleaned[0]) : $a43d996a7aa8a839$var$toHex(cleaned),
        isSecondary: isPrependTen || isDoubled
    };
}
function $a43d996a7aa8a839$var$getPrefix(fontFamily, fontWeight) {
    const fontFamilySanitized = fontFamily.replace(/^['"]|['"]$/g, '').toLowerCase();
    const fontWeightInteger = parseInt(fontWeight);
    const fontWeightSanitized = isNaN(fontWeightInteger) ? 'normal' : fontWeightInteger;
    return ($a43d996a7aa8a839$var$FONT_FAMILY_WEIGHT_TO_PREFIX[fontFamilySanitized] || {})[fontWeightSanitized] || $a43d996a7aa8a839$var$FONT_FAMILY_WEIGHT_FALLBACK[fontFamilySanitized];
}
function $a43d996a7aa8a839$var$replaceForPosition(node, position) {
    const pendingAttribute = "".concat($a43d996a7aa8a839$var$DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(':', '-'));
    return new Promise((resolve, reject)=>{
        if (node.getAttribute(pendingAttribute) !== null) // This node is already being processed
        return resolve();
        const children = $a43d996a7aa8a839$var$toArray(node.children);
        const alreadyProcessedPseudoElement = children.filter((c$$1)=>c$$1.getAttribute($a43d996a7aa8a839$var$DATA_FA_PSEUDO_ELEMENT) === position)[0];
        const styles = $a43d996a7aa8a839$var$WINDOW.getComputedStyle(node, position);
        const fontFamily = styles.getPropertyValue('font-family');
        const fontFamilyMatch = fontFamily.match($a43d996a7aa8a839$var$FONT_FAMILY_PATTERN);
        const fontWeight = styles.getPropertyValue('font-weight');
        const content = styles.getPropertyValue('content');
        if (alreadyProcessedPseudoElement && !fontFamilyMatch) {
            // If we've already processed it but the current computed style does not result in a font-family,
            // that probably means that a class name that was previously present to make the icon has been
            // removed. So we now should delete the icon.
            node.removeChild(alreadyProcessedPseudoElement);
            return resolve();
        } else if (fontFamilyMatch && content !== 'none' && content !== '') {
            const content = styles.getPropertyValue('content');
            let prefix = $a43d996a7aa8a839$var$getPrefix(fontFamily, fontWeight);
            const { value: hexValue, isSecondary: isSecondary } = $a43d996a7aa8a839$var$hexValueFromContent(content);
            const isV4 = fontFamilyMatch[0].startsWith('FontAwesome');
            let iconName = $a43d996a7aa8a839$var$byUnicode(prefix, hexValue);
            let iconIdentifier = iconName;
            if (isV4) {
                const iconName4 = $a43d996a7aa8a839$var$byOldUnicode(hexValue);
                if (iconName4.iconName && iconName4.prefix) {
                    iconName = iconName4.iconName;
                    prefix = iconName4.prefix;
                }
            }
            // Only convert the pseudo element in this ::before/::after position into an icon if we haven't
            // already done so with the same prefix and iconName
            if (iconName && !isSecondary && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute($a43d996a7aa8a839$var$DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute($a43d996a7aa8a839$var$DATA_ICON) !== iconIdentifier)) {
                node.setAttribute(pendingAttribute, iconIdentifier);
                if (alreadyProcessedPseudoElement) // Delete the old one, since we're replacing it with a new one
                node.removeChild(alreadyProcessedPseudoElement);
                const meta = $a43d996a7aa8a839$var$blankMeta();
                const { extra: extra } = meta;
                extra.attributes[$a43d996a7aa8a839$var$DATA_FA_PSEUDO_ELEMENT] = position;
                $a43d996a7aa8a839$var$findIcon(iconName, prefix).then((main)=>{
                    const abstract = $a43d996a7aa8a839$var$makeInlineSvgAbstract($a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, meta), {}, {
                        icons: {
                            main: main,
                            mask: $a43d996a7aa8a839$var$emptyCanonicalIcon()
                        },
                        prefix: prefix,
                        iconName: iconIdentifier,
                        extra: extra,
                        watchable: true
                    }));
                    const element = $a43d996a7aa8a839$var$DOCUMENT.createElementNS('http://www.w3.org/2000/svg', 'svg');
                    if (position === '::before') node.insertBefore(element, node.firstChild);
                    else node.appendChild(element);
                    element.outerHTML = abstract.map((a$$1)=>$a43d996a7aa8a839$var$toHtml(a$$1)).join('\n');
                    node.removeAttribute(pendingAttribute);
                    resolve();
                }).catch(reject);
            } else resolve();
        } else resolve();
    });
}
function $a43d996a7aa8a839$var$replace(node) {
    return Promise.all([
        $a43d996a7aa8a839$var$replaceForPosition(node, '::before'),
        $a43d996a7aa8a839$var$replaceForPosition(node, '::after')
    ]);
}
function $a43d996a7aa8a839$var$processable(node) {
    return node.parentNode !== document.head && !~$a43d996a7aa8a839$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute($a43d996a7aa8a839$var$DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== 'svg');
}
function $a43d996a7aa8a839$var$searchPseudoElements(root) {
    if (!$a43d996a7aa8a839$var$IS_DOM) return;
    return new Promise((resolve, reject)=>{
        const operations = $a43d996a7aa8a839$var$toArray(root.querySelectorAll('*')).filter($a43d996a7aa8a839$var$processable).map($a43d996a7aa8a839$var$replace);
        const end = $a43d996a7aa8a839$var$perf.begin('searchPseudoElements');
        $a43d996a7aa8a839$var$disableObservation();
        Promise.all(operations).then(()=>{
            end();
            $a43d996a7aa8a839$var$enableObservation();
            resolve();
        }).catch(()=>{
            end();
            $a43d996a7aa8a839$var$enableObservation();
            reject();
        });
    });
}
var $a43d996a7aa8a839$var$PseudoElements = {
    hooks () {
        return {
            mutationObserverCallbacks (accumulator) {
                accumulator.pseudoElementsCallback = $a43d996a7aa8a839$var$searchPseudoElements;
                return accumulator;
            }
        };
    },
    provides (providers) {
        providers.pseudoElements2svg = function(params) {
            const { node: node = $a43d996a7aa8a839$var$DOCUMENT } = params;
            if ($a43d996a7aa8a839$var$config.searchPseudoElements) $a43d996a7aa8a839$var$searchPseudoElements(node);
        };
    }
};
let $a43d996a7aa8a839$var$_unwatched = false;
var $a43d996a7aa8a839$var$MutationObserver$1 = {
    mixout () {
        return {
            dom: {
                unwatch () {
                    $a43d996a7aa8a839$var$disableObservation();
                    $a43d996a7aa8a839$var$_unwatched = true;
                }
            }
        };
    },
    hooks () {
        return {
            bootstrap () {
                $a43d996a7aa8a839$var$observe($a43d996a7aa8a839$var$chainHooks('mutationObserverCallbacks', {}));
            },
            noAuto () {
                $a43d996a7aa8a839$var$disconnect();
            },
            watch (params) {
                const { observeMutationsRoot: observeMutationsRoot } = params;
                if ($a43d996a7aa8a839$var$_unwatched) $a43d996a7aa8a839$var$enableObservation();
                else $a43d996a7aa8a839$var$observe($a43d996a7aa8a839$var$chainHooks('mutationObserverCallbacks', {
                    observeMutationsRoot: observeMutationsRoot
                }));
            }
        };
    }
};
const $a43d996a7aa8a839$var$parseTransformString = (transformString)=>{
    let transform = {
        size: 16,
        x: 0,
        y: 0,
        flipX: false,
        flipY: false,
        rotate: 0
    };
    return transformString.toLowerCase().split(' ').reduce((acc, n)=>{
        const parts = n.toLowerCase().split('-');
        const first = parts[0];
        let rest = parts.slice(1).join('-');
        if (first && rest === 'h') {
            acc.flipX = true;
            return acc;
        }
        if (first && rest === 'v') {
            acc.flipY = true;
            return acc;
        }
        rest = parseFloat(rest);
        if (isNaN(rest)) return acc;
        switch(first){
            case 'grow':
                acc.size = acc.size + rest;
                break;
            case 'shrink':
                acc.size = acc.size - rest;
                break;
            case 'left':
                acc.x = acc.x - rest;
                break;
            case 'right':
                acc.x = acc.x + rest;
                break;
            case 'up':
                acc.y = acc.y - rest;
                break;
            case 'down':
                acc.y = acc.y + rest;
                break;
            case 'rotate':
                acc.rotate = acc.rotate + rest;
                break;
        }
        return acc;
    }, transform);
};
var $a43d996a7aa8a839$var$PowerTransforms = {
    mixout () {
        return {
            parse: {
                transform: (transformString)=>{
                    return $a43d996a7aa8a839$var$parseTransformString(transformString);
                }
            }
        };
    },
    hooks () {
        return {
            parseNodeAttributes (accumulator, node) {
                const transformString = node.getAttribute('data-fa-transform');
                if (transformString) accumulator.transform = $a43d996a7aa8a839$var$parseTransformString(transformString);
                return accumulator;
            }
        };
    },
    provides (providers) {
        providers.generateAbstractTransformGrouping = function(_ref) {
            let { main: main, transform: transform, containerWidth: containerWidth, iconWidth: iconWidth } = _ref;
            const outer = {
                transform: "translate(".concat(containerWidth / 2, " 256)")
            };
            const innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
            const innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
            const innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
            const inner = {
                transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
            };
            const path = {
                transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
            };
            const operations = {
                outer: outer,
                inner: inner,
                path: path
            };
            return {
                tag: 'g',
                attributes: $a43d996a7aa8a839$var$_objectSpread2({}, operations.outer),
                children: [
                    {
                        tag: 'g',
                        attributes: $a43d996a7aa8a839$var$_objectSpread2({}, operations.inner),
                        children: [
                            {
                                tag: main.icon.tag,
                                children: main.icon.children,
                                attributes: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, main.icon.attributes), operations.path)
                            }
                        ]
                    }
                ]
            };
        };
    }
};
const $a43d996a7aa8a839$var$ALL_SPACE = {
    x: 0,
    y: 0,
    width: '100%',
    height: '100%'
};
function $a43d996a7aa8a839$var$fillBlack(abstract) {
    let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (abstract.attributes && (abstract.attributes.fill || force)) abstract.attributes.fill = 'black';
    return abstract;
}
function $a43d996a7aa8a839$var$deGroup(abstract) {
    if (abstract.tag === 'g') return abstract.children;
    else return [
        abstract
    ];
}
var $a43d996a7aa8a839$var$Masks = {
    hooks () {
        return {
            parseNodeAttributes (accumulator, node) {
                const maskData = node.getAttribute('data-fa-mask');
                const mask = !maskData ? $a43d996a7aa8a839$var$emptyCanonicalIcon() : $a43d996a7aa8a839$var$getCanonicalIcon(maskData.split(' ').map((i)=>i.trim()));
                if (!mask.prefix) mask.prefix = $a43d996a7aa8a839$var$getDefaultUsablePrefix();
                accumulator.mask = mask;
                accumulator.maskId = node.getAttribute('data-fa-mask-id');
                return accumulator;
            }
        };
    },
    provides (providers) {
        providers.generateAbstractMask = function(_ref) {
            let { children: children, attributes: attributes, main: main, mask: mask, maskId: explicitMaskId, transform: transform } = _ref;
            const { width: mainWidth, icon: mainPath } = main;
            const { width: maskWidth, icon: maskPath } = mask;
            const trans = $a43d996a7aa8a839$var$transformForSvg({
                transform: transform,
                containerWidth: maskWidth,
                iconWidth: mainWidth
            });
            const maskRect = {
                tag: 'rect',
                attributes: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, $a43d996a7aa8a839$var$ALL_SPACE), {}, {
                    fill: 'white'
                })
            };
            const maskInnerGroupChildrenMixin = mainPath.children ? {
                children: mainPath.children.map($a43d996a7aa8a839$var$fillBlack)
            } : {};
            const maskInnerGroup = {
                tag: 'g',
                attributes: $a43d996a7aa8a839$var$_objectSpread2({}, trans.inner),
                children: [
                    $a43d996a7aa8a839$var$fillBlack($a43d996a7aa8a839$var$_objectSpread2({
                        tag: mainPath.tag,
                        attributes: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, mainPath.attributes), trans.path)
                    }, maskInnerGroupChildrenMixin))
                ]
            };
            const maskOuterGroup = {
                tag: 'g',
                attributes: $a43d996a7aa8a839$var$_objectSpread2({}, trans.outer),
                children: [
                    maskInnerGroup
                ]
            };
            const maskId = "mask-".concat(explicitMaskId || $a43d996a7aa8a839$var$nextUniqueId());
            const clipId = "clip-".concat(explicitMaskId || $a43d996a7aa8a839$var$nextUniqueId());
            const maskTag = {
                tag: 'mask',
                attributes: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, $a43d996a7aa8a839$var$ALL_SPACE), {}, {
                    id: maskId,
                    maskUnits: 'userSpaceOnUse',
                    maskContentUnits: 'userSpaceOnUse'
                }),
                children: [
                    maskRect,
                    maskOuterGroup
                ]
            };
            const defs = {
                tag: 'defs',
                children: [
                    {
                        tag: 'clipPath',
                        attributes: {
                            id: clipId
                        },
                        children: $a43d996a7aa8a839$var$deGroup(maskPath)
                    },
                    maskTag
                ]
            };
            children.push(defs, {
                tag: 'rect',
                attributes: $a43d996a7aa8a839$var$_objectSpread2({
                    fill: 'currentColor',
                    'clip-path': "url(#".concat(clipId, ")"),
                    mask: "url(#".concat(maskId, ")")
                }, $a43d996a7aa8a839$var$ALL_SPACE)
            });
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var $a43d996a7aa8a839$var$MissingIconIndicator = {
    provides (providers) {
        let reduceMotion = false;
        if ($a43d996a7aa8a839$var$WINDOW.matchMedia) reduceMotion = $a43d996a7aa8a839$var$WINDOW.matchMedia('(prefers-reduced-motion: reduce)').matches;
        providers.missingIconAbstract = function() {
            const gChildren = [];
            const FILL = {
                fill: 'currentColor'
            };
            const ANIMATION_BASE = {
                attributeType: 'XML',
                repeatCount: 'indefinite',
                dur: '2s'
            };
            // Ring
            gChildren.push({
                tag: 'path',
                attributes: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, FILL), {}, {
                    d: 'M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z'
                })
            });
            const OPACITY_ANIMATE = $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, ANIMATION_BASE), {}, {
                attributeName: 'opacity'
            });
            const dot = {
                tag: 'circle',
                attributes: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, FILL), {}, {
                    cx: '256',
                    cy: '364',
                    r: '28'
                }),
                children: []
            };
            if (!reduceMotion) dot.children.push({
                tag: 'animate',
                attributes: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, ANIMATION_BASE), {}, {
                    attributeName: 'r',
                    values: '28;14;28;28;14;28;'
                })
            }, {
                tag: 'animate',
                attributes: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                    values: '1;0;1;1;0;1;'
                })
            });
            gChildren.push(dot);
            gChildren.push({
                tag: 'path',
                attributes: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, FILL), {}, {
                    opacity: '1',
                    d: 'M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z'
                }),
                children: reduceMotion ? [] : [
                    {
                        tag: 'animate',
                        attributes: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                            values: '1;0;0;0;0;1;'
                        })
                    }
                ]
            });
            if (!reduceMotion) // Exclamation
            gChildren.push({
                tag: 'path',
                attributes: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, FILL), {}, {
                    opacity: '0',
                    d: 'M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z'
                }),
                children: [
                    {
                        tag: 'animate',
                        attributes: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                            values: '0;0;1;1;0;0;'
                        })
                    }
                ]
            });
            return {
                tag: 'g',
                attributes: {
                    'class': 'missing'
                },
                children: gChildren
            };
        };
    }
};
var $a43d996a7aa8a839$var$SvgSymbols = {
    hooks () {
        return {
            parseNodeAttributes (accumulator, node) {
                const symbolData = node.getAttribute('data-fa-symbol');
                const symbol = symbolData === null ? false : symbolData === '' ? true : symbolData;
                accumulator['symbol'] = symbol;
                return accumulator;
            }
        };
    }
};
var $a43d996a7aa8a839$var$plugins = [
    $a43d996a7aa8a839$var$InjectCSS,
    $a43d996a7aa8a839$var$ReplaceElements,
    $a43d996a7aa8a839$var$Layers,
    $a43d996a7aa8a839$var$LayersCounter,
    $a43d996a7aa8a839$var$LayersText,
    $a43d996a7aa8a839$var$PseudoElements,
    $a43d996a7aa8a839$var$MutationObserver$1,
    $a43d996a7aa8a839$var$PowerTransforms,
    $a43d996a7aa8a839$var$Masks,
    $a43d996a7aa8a839$var$MissingIconIndicator,
    $a43d996a7aa8a839$var$SvgSymbols
];
$a43d996a7aa8a839$var$registerPlugins($a43d996a7aa8a839$var$plugins, {
    mixoutsTo: $a43d996a7aa8a839$export$644d8ea042df96a6
});
const $a43d996a7aa8a839$export$4f8e844b2782642c = $a43d996a7aa8a839$export$644d8ea042df96a6.noAuto;
const $a43d996a7aa8a839$export$e506a1d27d1eaa20 = $a43d996a7aa8a839$export$644d8ea042df96a6.config;
const $a43d996a7aa8a839$export$b839f963c7dc0e34 = $a43d996a7aa8a839$export$644d8ea042df96a6.library;
const $a43d996a7aa8a839$export$df3a06d6289f983e = $a43d996a7aa8a839$export$644d8ea042df96a6.dom;
const $a43d996a7aa8a839$export$98e6a39c04603d36 = $a43d996a7aa8a839$export$644d8ea042df96a6.parse;
const $a43d996a7aa8a839$export$221fed4a47f597a5 = $a43d996a7aa8a839$export$644d8ea042df96a6.findIconDefinition;
const $a43d996a7aa8a839$export$a10125c086a4df16 = $a43d996a7aa8a839$export$644d8ea042df96a6.toHtml;
const $a43d996a7aa8a839$export$1ca1ec8b29a4ce27 = $a43d996a7aa8a839$export$644d8ea042df96a6.icon;
const $a43d996a7aa8a839$export$50a222d9023da98b = $a43d996a7aa8a839$export$644d8ea042df96a6.layer;
const $a43d996a7aa8a839$export$6f093cfa640b7166 = $a43d996a7aa8a839$export$644d8ea042df96a6.text;
const $a43d996a7aa8a839$export$e575061ef2a070eb = $a43d996a7aa8a839$export$644d8ea042df96a6.counter;


/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */ const $7435a4b2c8a749a5$export$82e9f45cca5ba907 = "far";
const $7435a4b2c8a749a5$export$864bb8d6c21fb792 = {
    prefix: 'far',
    iconName: 'trash-can',
    icon: [
        448,
        512,
        [
            61460,
            "trash-alt"
        ],
        "f2ed",
        "M170.5 51.6L151.5 80l145 0-19-28.4c-1.5-2.2-4-3.6-6.7-3.6l-93.7 0c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80 368 80l48 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 304c0 44.2-35.8 80-80 80l-224 0c-44.2 0-80-35.8-80-80l0-304-8 0c-13.3 0-24-10.7-24-24S10.7 80 24 80l8 0 48 0 13.8 0 36.7-55.1C140.9 9.4 158.4 0 177.1 0l93.7 0c18.7 0 36.2 9.4 46.6 24.9zM80 128l0 304c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-304L80 128zm80 64l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
const $7435a4b2c8a749a5$export$88df7ff7eb32f9dc = $7435a4b2c8a749a5$export$864bb8d6c21fb792;
const $7435a4b2c8a749a5$export$6563a67224e7f879 = {
    prefix: 'far',
    iconName: 'message',
    icon: [
        512,
        512,
        [
            "comment-alt"
        ],
        "f27a",
        "M160 368c26.5 0 48 21.5 48 48l0 16 72.5-54.4c8.3-6.2 18.4-9.6 28.8-9.6L448 368c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16L64 48c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16l96 0zm48 124l-.2 .2-5.1 3.8-17.1 12.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-21.3 0-6.4 0-.3 0-4 0-48-48 0-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L208 492z"
    ]
};
const $7435a4b2c8a749a5$export$6e96904d9af0ec4a = $7435a4b2c8a749a5$export$6563a67224e7f879;
const $7435a4b2c8a749a5$export$ef565d07efe2b5e9 = {
    prefix: 'far',
    iconName: 'file-lines',
    icon: [
        384,
        512,
        [
            128441,
            128462,
            61686,
            "file-alt",
            "file-text"
        ],
        "f15c",
        "M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm56 256c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z"
    ]
};
const $7435a4b2c8a749a5$export$243b47dca32bf0b8 = $7435a4b2c8a749a5$export$ef565d07efe2b5e9;
const $7435a4b2c8a749a5$export$f466100bf9bf37a5 = $7435a4b2c8a749a5$export$ef565d07efe2b5e9;
const $7435a4b2c8a749a5$export$31c6cf6f5d38dc0 = {
    prefix: 'far',
    iconName: 'calendar-days',
    icon: [
        448,
        512,
        [
            "calendar-alt"
        ],
        "f073",
        "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l80 0 0 56-80 0 0-56zm0 104l80 0 0 64-80 0 0-64zm128 0l96 0 0 64-96 0 0-64zm144 0l80 0 0 64-80 0 0-64zm80-48l-80 0 0-56 80 0 0 56zm0 160l0 40c0 8.8-7.2 16-16 16l-64 0 0-56 80 0zm-128 0l0 56-96 0 0-56 96 0zm-144 0l0 56-64 0c-8.8 0-16-7.2-16-16l0-40 80 0zM272 248l-96 0 0-56 96 0 0 56z"
    ]
};
const $7435a4b2c8a749a5$export$cbc139f33cff356 = $7435a4b2c8a749a5$export$31c6cf6f5d38dc0;
const $7435a4b2c8a749a5$export$f7bc8714c970afa4 = {
    prefix: 'far',
    iconName: 'hand-point-right',
    icon: [
        512,
        512,
        [],
        "f0a4",
        "M448 128l-177.6 0c1 5.2 1.6 10.5 1.6 16l0 16 32 0 144 0c8.8 0 16-7.2 16-16s-7.2-16-16-16zM224 144c0-17.7-14.3-32-32-32c0 0 0 0 0 0l-24 0c-66.3 0-120 53.7-120 120l0 48c0 52.5 33.7 97.1 80.7 113.4c-.5-3.1-.7-6.2-.7-9.4c0-20 9.2-37.9 23.6-49.7c-4.9-9-7.6-19.4-7.6-30.3c0-15.1 5.3-29 14-40c-8.8-11-14-24.9-14-40l0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40c0 8.8 7.2 16 16 16s16-7.2 16-16l0-40 0-40zM192 64s0 0 0 0c18 0 34.6 6 48 16l208 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-82 0c1.3 5.1 2 10.5 2 16c0 25.3-14.7 47.2-36 57.6c2.6 7 4 14.5 4 22.4c0 20-9.2 37.9-23.6 49.7c4.9 9 7.6 19.4 7.6 30.3c0 35.3-28.7 64-64 64l-64 0-24 0C75.2 448 0 372.8 0 280l0-48C0 139.2 75.2 64 168 64l24 0zm64 336c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0zm16-176c0 5.5-.7 10.9-2 16l2 0 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0 16zm-24 64l-40 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-24 0z"
    ]
};
const $7435a4b2c8a749a5$export$e3c56ed54f074063 = {
    prefix: 'far',
    iconName: 'face-smile-beam',
    icon: [
        512,
        512,
        [
            128522,
            "smile-beam"
        ],
        "f5b8",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm177.6 62.1C192.8 334.5 218.8 352 256 352s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zm40-89.3s0 0 0 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0zm160 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0z"
    ]
};
const $7435a4b2c8a749a5$export$54ada6dc9690e0ca = $7435a4b2c8a749a5$export$e3c56ed54f074063;
const $7435a4b2c8a749a5$export$1d1fbac384a76a12 = {
    prefix: 'far',
    iconName: 'face-grin-stars',
    icon: [
        512,
        512,
        [
            129321,
            "grin-stars"
        ],
        "f587",
        "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM183.2 132.6c-1.3-2.8-4.1-4.6-7.2-4.6s-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L176 240.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L242.4 186c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7zm160 0c-1.3-2.8-4.1-4.6-7.2-4.6s-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L336 240.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L402.4 186c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7zm6.3 175.8c-28.9 6.8-60.5 10.5-93.6 10.5s-64.7-3.7-93.6-10.5c-18.7-4.4-35.9 12-25.5 28.1c24.6 38.1 68.7 63.5 119.1 63.5s94.5-25.4 119.1-63.5c10.4-16.1-6.8-32.5-25.5-28.1z"
    ]
};
const $7435a4b2c8a749a5$export$64347a5c8c402ef4 = $7435a4b2c8a749a5$export$1d1fbac384a76a12;
const $7435a4b2c8a749a5$export$853fd1561789e3bb = {
    prefix: 'far',
    iconName: 'address-book',
    icon: [
        512,
        512,
        [
            62138,
            "contact-book"
        ],
        "f2b9",
        "M384 48c8.8 0 16 7.2 16 16l0 384c0 8.8-7.2 16-16 16L96 464c-8.8 0-16-7.2-16-16L80 64c0-8.8 7.2-16 16-16l288 0zM96 0C60.7 0 32 28.7 32 64l0 384c0 35.3 28.7 64 64 64l288 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L96 0zM240 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80l-64 0zM512 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64zM496 192c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16zm16 144c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64z"
    ]
};
const $7435a4b2c8a749a5$export$594b5a5d4d2e156b = $7435a4b2c8a749a5$export$853fd1561789e3bb;
const $7435a4b2c8a749a5$export$932912e74adb8939 = {
    prefix: 'far',
    iconName: 'comments',
    icon: [
        640,
        512,
        [
            128490,
            61670
        ],
        "f086",
        "M88.2 309.1c9.8-18.3 6.8-40.8-7.5-55.8C59.4 230.9 48 204 48 176c0-63.5 63.8-128 160-128s160 64.5 160 128s-63.8 128-160 128c-13.1 0-25.8-1.3-37.8-3.6c-10.4-2-21.2-.6-30.7 4.2c-4.1 2.1-8.3 4.1-12.6 6c-16 7.2-32.9 13.5-49.9 18c2.8-4.6 5.4-9.1 7.9-13.6c1.1-1.9 2.2-3.9 3.2-5.9zM208 352c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176c0 41.8 17.2 80.1 45.9 110.3c-.9 1.7-1.9 3.5-2.8 5.1c-10.3 18.4-22.3 36.5-36.6 52.1c-6.6 7-8.3 17.2-4.6 25.9C5.8 378.3 14.4 384 24 384c43 0 86.5-13.3 122.7-29.7c4.8-2.2 9.6-4.5 14.2-6.8c15.1 3 30.9 4.5 47.1 4.5zM432 480c16.2 0 31.9-1.6 47.1-4.5c4.6 2.3 9.4 4.6 14.2 6.8C529.5 498.7 573 512 616 512c9.6 0 18.2-5.7 22-14.5c3.8-8.8 2-19-4.6-25.9c-14.2-15.6-26.2-33.7-36.6-52.1c-.9-1.7-1.9-3.4-2.8-5.1C622.8 384.1 640 345.8 640 304c0-94.4-87.9-171.5-198.2-175.8c4.1 15.2 6.2 31.2 6.2 47.8l0 .6c87.2 6.7 144 67.5 144 127.4c0 28-11.4 54.9-32.7 77.2c-14.3 15-17.3 37.6-7.5 55.8c1.1 2 2.2 4 3.2 5.9c2.5 4.5 5.2 9 7.9 13.6c-17-4.5-33.9-10.7-49.9-18c-4.3-1.9-8.5-3.9-12.6-6c-9.5-4.8-20.3-6.2-30.7-4.2c-12.1 2.4-24.8 3.6-37.8 3.6c-61.7 0-110-26.5-136.8-62.3c-16 5.4-32.8 9.4-50 11.8C279 439.8 350 480 432 480z"
    ]
};
const $7435a4b2c8a749a5$export$6f95f90dd1f6d86b = {
    prefix: 'far',
    iconName: 'paste',
    icon: [
        512,
        512,
        [
            "file-clipboard"
        ],
        "f0ea",
        "M104.6 48L64 48C28.7 48 0 76.7 0 112L0 384c0 35.3 28.7 64 64 64l96 0 0-48-96 0c-8.8 0-16-7.2-16-16l0-272c0-8.8 7.2-16 16-16l16 0c0 17.7 14.3 32 32 32l72.4 0C202 108.4 227.6 96 256 96l62 0c-7.1-27.6-32.2-48-62-48l-40.6 0C211.6 20.9 188.2 0 160 0s-51.6 20.9-55.4 48zM144 56a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM448 464l-192 0c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l140.1 0L464 243.9 464 448c0 8.8-7.2 16-16 16zM256 512l192 0c35.3 0 64-28.7 64-64l0-204.1c0-12.7-5.1-24.9-14.1-33.9l-67.9-67.9c-9-9-21.2-14.1-33.9-14.1L256 128c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64z"
    ]
};
const $7435a4b2c8a749a5$export$ca3229c47de163fa = $7435a4b2c8a749a5$export$6f95f90dd1f6d86b;
const $7435a4b2c8a749a5$export$8eee2c17ff89e724 = {
    prefix: 'far',
    iconName: 'face-grin-tongue-squint',
    icon: [
        512,
        512,
        [
            128541,
            "grin-tongue-squint"
        ],
        "f58a",
        "M464 256c0-114.9-93.1-208-208-208S48 141.1 48 256c0 81.7 47.1 152.4 115.7 186.4c-2.4-8.4-3.7-17.3-3.7-26.4l0-23.3c-24-17.5-43.1-41.4-54.8-69.2c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7c-11.8 28-31.1 52-55.4 69.6l0 22.9c0 9.2-1.3 18-3.7 26.4C416.9 408.4 464 337.7 464 256zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm116-98.9c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm262.5-10.5c7.9-4.2 17.5 1.5 17.5 10.5c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9zM320 416l0-37.4c0-14.7-11.9-26.6-26.6-26.6l-2 0c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9l-2 0c-14.7 0-26.6 11.9-26.6 26.6l0 37.4c0 35.3 28.7 64 64 64s64-28.7 64-64z"
    ]
};
const $7435a4b2c8a749a5$export$4edf34c3def09a31 = $7435a4b2c8a749a5$export$8eee2c17ff89e724;
const $7435a4b2c8a749a5$export$ba5dc4287853ecbd = {
    prefix: 'far',
    iconName: 'face-flushed',
    icon: [
        512,
        512,
        [
            128563,
            "flushed"
        ],
        "f579",
        "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM160.4 248a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM192 336c-13.3 0-24 10.7-24 24s10.7 24 24 24l128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-128 0zM160 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm144-80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"
    ]
};
const $7435a4b2c8a749a5$export$dfd2bd012685aeac = $7435a4b2c8a749a5$export$ba5dc4287853ecbd;
const $7435a4b2c8a749a5$export$5b1d41cdd118ea6d = {
    prefix: 'far',
    iconName: 'square-caret-right',
    icon: [
        448,
        512,
        [
            "caret-square-right"
        ],
        "f152",
        "M400 96c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM320 256c0 6.7-2.8 13-7.7 17.6l-112 104c-7 6.5-17.2 8.2-25.9 4.4s-14.4-12.5-14.4-22l0-208c0-9.5 5.7-18.2 14.4-22s18.9-2.1 25.9 4.4l112 104c4.9 4.5 7.7 10.9 7.7 17.6z"
    ]
};
const $7435a4b2c8a749a5$export$ae86c9de7e0f62fa = $7435a4b2c8a749a5$export$5b1d41cdd118ea6d;
const $7435a4b2c8a749a5$export$814c9edba7b84aa4 = {
    prefix: 'far',
    iconName: 'square-minus',
    icon: [
        448,
        512,
        [
            61767,
            "minus-square"
        ],
        "f146",
        "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM152 232l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
const $7435a4b2c8a749a5$export$ffe9387966b3e681 = $7435a4b2c8a749a5$export$814c9edba7b84aa4;
const $7435a4b2c8a749a5$export$b4d344633433e50e = {
    prefix: 'far',
    iconName: 'compass',
    icon: [
        512,
        512,
        [
            129517
        ],
        "f14e",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm306.7 69.1L162.4 380.6c-19.4 7.5-38.5-11.6-31-31l55.5-144.3c3.3-8.5 9.9-15.1 18.4-18.4l144.3-55.5c19.4-7.5 38.5 11.6 31 31L325.1 306.7c-3.2 8.5-9.9 15.1-18.4 18.4zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
const $7435a4b2c8a749a5$export$a1ab39cd66c4e50e = {
    prefix: 'far',
    iconName: 'square-caret-down',
    icon: [
        448,
        512,
        [
            "caret-square-down"
        ],
        "f150",
        "M384 432c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0zm64-16c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320zM224 352c-6.7 0-13-2.8-17.6-7.7l-104-112c-6.5-7-8.2-17.2-4.4-25.9s12.5-14.4 22-14.4l208 0c9.5 0 18.2 5.7 22 14.4s2.1 18.9-4.4 25.9l-104 112c-4.5 4.9-10.9 7.7-17.6 7.7z"
    ]
};
const $7435a4b2c8a749a5$export$61aea18df1c84401 = $7435a4b2c8a749a5$export$a1ab39cd66c4e50e;
const $7435a4b2c8a749a5$export$eca99665af566fe1 = {
    prefix: 'far',
    iconName: 'face-kiss-beam',
    icon: [
        512,
        512,
        [
            128537,
            "kiss-beam"
        ],
        "f597",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm304.7 41.7c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 427.1 257.4 432 240 432c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9c0 0 0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zm-87.1-68.9s0 0 0 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0zm160 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0z"
    ]
};
const $7435a4b2c8a749a5$export$d6ff8a73c0812e63 = $7435a4b2c8a749a5$export$eca99665af566fe1;
const $7435a4b2c8a749a5$export$1e80f89fe84a215b = {
    prefix: 'far',
    iconName: 'lightbulb',
    icon: [
        384,
        512,
        [
            128161
        ],
        "f0eb",
        "M297.2 248.9C311.6 228.3 320 203.2 320 176c0-70.7-57.3-128-128-128S64 105.3 64 176c0 27.2 8.4 52.3 22.8 72.9c3.7 5.3 8.1 11.3 12.8 17.7c0 0 0 0 0 0c12.9 17.7 28.3 38.9 39.8 59.8c10.4 19 15.7 38.8 18.3 57.5L109 384c-2.2-12-5.9-23.7-11.8-34.5c-9.9-18-22.2-34.9-34.5-51.8c0 0 0 0 0 0s0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4c0 0 0 0 0 0s0 0 0 0c-12.3 16.8-24.6 33.7-34.5 51.8c-5.9 10.8-9.6 22.5-11.8 34.5l-48.6 0c2.6-18.7 7.9-38.6 18.3-57.5c11.5-20.9 26.9-42.1 39.8-59.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0c4.7-6.4 9-12.4 12.7-17.7zM192 128c-26.5 0-48 21.5-48 48c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16s-7.2 16-16 16zm0 384c-44.2 0-80-35.8-80-80l0-16 160 0 0 16c0 44.2-35.8 80-80 80z"
    ]
};
const $7435a4b2c8a749a5$export$6591b1ea509be9da = {
    prefix: 'far',
    iconName: 'flag',
    icon: [
        448,
        512,
        [
            127988,
            61725
        ],
        "f024",
        "M48 24C48 10.7 37.3 0 24 0S0 10.7 0 24L0 64 0 350.5 0 400l0 88c0 13.3 10.7 24 24 24s24-10.7 24-24l0-100 80.3-20.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30l0-279.7c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L48 52l0-28zm0 77.5l96.6-24.2c27-6.7 55.5-3.6 80.4 8.8c54.9 27.4 118.7 29.7 175 6.8l0 241.8-24.4 9.1c-33.7 12.6-71.2 10.7-103.4-5.4c-48.2-24.1-103.3-30.1-155.6-17.1L48 338.5l0-237z"
    ]
};
const $7435a4b2c8a749a5$export$5bb6a0c94ad2f4bb = {
    prefix: 'far',
    iconName: 'square-check',
    icon: [
        448,
        512,
        [
            9745,
            9989,
            61510,
            "check-square"
        ],
        "f14a",
        "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    ]
};
const $7435a4b2c8a749a5$export$f0c8040f596df7fe = $7435a4b2c8a749a5$export$5bb6a0c94ad2f4bb;
const $7435a4b2c8a749a5$export$aa13d9234890e8d3 = {
    prefix: 'far',
    iconName: 'circle-dot',
    icon: [
        512,
        512,
        [
            128280,
            "dot-circle"
        ],
        "f192",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
    ]
};
const $7435a4b2c8a749a5$export$92bc269cb244d66a = $7435a4b2c8a749a5$export$aa13d9234890e8d3;
const $7435a4b2c8a749a5$export$635e4d8cc8428961 = {
    prefix: 'far',
    iconName: 'face-dizzy',
    icon: [
        512,
        512,
        [
            "dizzy"
        ],
        "f567",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM103 135c9.4-9.4 24.6-9.4 33.9 0l23 23 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-23-23c-9.4-9.4-9.4-24.6 0-33.9zm192 0c9.4-9.4 24.6-9.4 33.9 0l23 23 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-23-23c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
const $7435a4b2c8a749a5$export$89a2b10dabc487e8 = $7435a4b2c8a749a5$export$635e4d8cc8428961;
const $7435a4b2c8a749a5$export$65a345b33858a655 = {
    prefix: 'far',
    iconName: 'futbol',
    icon: [
        512,
        512,
        [
            9917,
            "futbol-ball",
            "soccer-ball"
        ],
        "f1e3",
        "M435.4 361.4l-89.7-6c-5.2-.3-10.3 1.1-14.5 4.2s-7.2 7.4-8.4 12.5l-22 87.2c-14.4 3.2-29.4 4.8-44.8 4.8s-30.3-1.7-44.8-4.8l-22-87.2c-1.3-5-4.3-9.4-8.4-12.5s-9.3-4.5-14.5-4.2l-89.7 6C61.7 335.9 51.9 307 49 276.2L125 228.3c4.4-2.8 7.6-7 9.2-11.9s1.4-10.2-.5-15L100.4 118c19.9-22.4 44.6-40.5 72.4-52.7l69.1 57.6c4 3.3 9 5.1 14.1 5.1s10.2-1.8 14.1-5.1l69.1-57.6c27.8 12.2 52.5 30.3 72.4 52.7l-33.4 83.4c-1.9 4.8-2.1 10.1-.5 15s4.9 9.1 9.2 11.9L463 276.2c-3 30.8-12.7 59.7-27.6 85.2zM256 48l.9 0-1.8 0 .9 0zM56.7 196.2c.9-3 1.9-6.1 2.9-9.1l-2.9 9.1zM132 423l3.8 2.7c-1.3-.9-2.5-1.8-3.8-2.7zm248.1-.1c-1.3 1-2.6 2-4 2.9l4-2.9zm75.2-226.7l-3-9.2c1.1 3 2.1 6.1 3 9.2zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm14.1-325.7c-8.4-6.1-19.8-6.1-28.2 0L194 221c-8.4 6.1-11.9 16.9-8.7 26.8l18.3 56.3c3.2 9.9 12.4 16.6 22.8 16.6l59.2 0c10.4 0 19.6-6.7 22.8-16.6l18.3-56.3c3.2-9.9-.3-20.7-8.7-26.8l-47.9-34.8z"
    ]
};
const $7435a4b2c8a749a5$export$51a344ca0a215620 = $7435a4b2c8a749a5$export$65a345b33858a655;
const $7435a4b2c8a749a5$export$f4a29712c724ba2d = $7435a4b2c8a749a5$export$65a345b33858a655;
const $7435a4b2c8a749a5$export$ba236543926e3569 = {
    prefix: 'far',
    iconName: 'pen-to-square',
    icon: [
        512,
        512,
        [
            "edit"
        ],
        "f044",
        "M441 58.9L453.1 71c9.4 9.4 9.4 24.6 0 33.9L424 134.1 377.9 88 407 58.9c9.4-9.4 24.6-9.4 33.9 0zM209.8 256.2L344 121.9 390.1 168 255.8 302.2c-2.9 2.9-6.5 5-10.4 6.1l-58.5 16.7 16.7-58.5c1.1-3.9 3.2-7.5 6.1-10.4zM373.1 25L175.8 222.2c-8.7 8.7-15 19.4-18.3 31.1l-28.6 100c-2.4 8.4-.1 17.4 6.1 23.6s15.2 8.5 23.6 6.1l100-28.6c11.8-3.4 22.5-9.7 31.1-18.3L487 138.9c28.1-28.1 28.1-73.7 0-101.8L474.9 25C446.8-3.1 401.2-3.1 373.1 25zM88 64C39.4 64 0 103.4 0 152L0 424c0 48.6 39.4 88 88 88l272 0c48.6 0 88-39.4 88-88l0-112c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 22.1-17.9 40-40 40L88 464c-22.1 0-40-17.9-40-40l0-272c0-22.1 17.9-40 40-40l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 64z"
    ]
};
const $7435a4b2c8a749a5$export$7be713e57d023733 = $7435a4b2c8a749a5$export$ba236543926e3569;
const $7435a4b2c8a749a5$export$703272eebf5e3eea = {
    prefix: 'far',
    iconName: 'hourglass-half',
    icon: [
        384,
        512,
        [
            "hourglass-2"
        ],
        "f252",
        "M0 24C0 10.7 10.7 0 24 0L360 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 19c0 40.3-16 79-44.5 107.5L225.9 256l81.5 81.5C336 366 352 404.7 352 445l0 19 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 0-19c0-40.3 16-79 44.5-107.5L158.1 256 76.5 174.5C48 146 32 107.3 32 67l0-19-8 0C10.7 48 0 37.3 0 24zM110.5 371.5c-3.9 3.9-7.5 8.1-10.7 12.5l184.4 0c-3.2-4.4-6.8-8.6-10.7-12.5L192 289.9l-81.5 81.5zM284.2 128C297 110.4 304 89 304 67l0-19L80 48l0 19c0 22.1 7 43.4 19.8 61l184.4 0z"
    ]
};
const $7435a4b2c8a749a5$export$f1052bbf6bf361c0 = $7435a4b2c8a749a5$export$703272eebf5e3eea;
const $7435a4b2c8a749a5$export$ed3f2918429d029a = {
    prefix: 'far',
    iconName: 'eye-slash',
    icon: [
        640,
        512,
        [],
        "f070",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zm151 118.3C226 97.7 269.5 80 320 80c65.2 0 118.8 29.6 159.9 67.7C518.4 183.5 545 226 558.6 256c-12.6 28-36.6 66.8-70.9 100.9l-53.8-42.2c9.1-17.6 14.2-37.5 14.2-58.7c0-70.7-57.3-128-128-128c-32.2 0-61.7 11.9-84.2 31.5l-46.1-36.1zM394.9 284.2l-81.5-63.9c4.2-8.5 6.6-18.2 6.6-28.3c0-5.5-.7-10.9-2-16c.7 0 1.3 0 2 0c44.2 0 80 35.8 80 80c0 9.9-1.8 19.4-5.1 28.2zm9.4 130.3C378.8 425.4 350.7 432 320 432c-65.2 0-118.8-29.6-159.9-67.7C121.6 328.5 95 286 81.4 256c8.3-18.4 21.5-41.5 39.4-64.8L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5l-41.9-33zM192 256c0 70.7 57.3 128 128 128c13.3 0 26.1-2 38.2-5.8L302 334c-23.5-5.4-43.1-21.2-53.7-42.3l-56.1-44.2c-.2 2.8-.3 5.6-.3 8.5z"
    ]
};
const $7435a4b2c8a749a5$export$f69db0b876f7d753 = {
    prefix: 'far',
    iconName: 'hand',
    icon: [
        512,
        512,
        [
            129306,
            9995,
            "hand-paper"
        ],
        "f256",
        "M256 0c-25.3 0-47.2 14.7-57.6 36c-7-2.6-14.5-4-22.4-4c-35.3 0-64 28.7-64 64l0 165.5-2.7-2.7c-25-25-65.5-25-90.5 0s-25 65.5 0 90.5L106.5 437c48 48 113.1 75 181 75l8.5 0 8 0c1.5 0 3-.1 4.5-.4c91.7-6.2 165-79.4 171.1-171.1c.3-1.5 .4-3 .4-4.5l0-176c0-35.3-28.7-64-64-64c-5.5 0-10.9 .7-16 2l0-2c0-35.3-28.7-64-64-64c-7.9 0-15.4 1.4-22.4 4C303.2 14.7 281.3 0 256 0zM240 96.1l0-.1 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 31.9 0 .1 0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-136c0 0 0 0 0-.1c0-8.8 7.2-16 16-16s16 7.2 16 16l0 55.9c0 0 0 .1 0 .1l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-71.9c0 0 0-.1 0-.1c0-8.8 7.2-16 16-16s16 7.2 16 16l0 172.9c-.1 .6-.1 1.3-.2 1.9c-3.4 69.7-59.3 125.6-129 129c-.6 0-1.3 .1-1.9 .2l-4.9 0-8.5 0c-55.2 0-108.1-21.9-147.1-60.9L52.7 315.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L119 336.4c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2L160 96c0-8.8 7.2-16 16-16c8.8 0 16 7.1 16 15.9L192 232c0 13.3 10.7 24 24 24s24-10.7 24-24l0-135.9z"
    ]
};
const $7435a4b2c8a749a5$export$6e6216c8b50471bb = $7435a4b2c8a749a5$export$f69db0b876f7d753;
const $7435a4b2c8a749a5$export$2262d6b626de1120 = {
    prefix: 'far',
    iconName: 'hand-spock',
    icon: [
        576,
        512,
        [
            128406
        ],
        "f259",
        "M170.2 80.8C161 47 180.8 12 214.6 2.4c34-9.6 69.4 10.2 79 44.2l30.3 107.1L337.1 84c6.6-34.7 40.1-57.5 74.8-50.9c31.4 6 53 33.9 52 64.9c10-2.6 20.8-2.8 31.5-.1c34.3 8.6 55.1 43.3 46.6 77.6L486.7 397.2C469.8 464.7 409.2 512 339.6 512l-33.7 0c-56.9 0-112.2-19-157.2-53.9l-92-71.6c-27.9-21.7-32.9-61.9-11.2-89.8s61.9-32.9 89.8-11.2l17 13.2L100.5 167.5c-13-32.9 3.2-70.1 36-83c11.1-4.4 22.7-5.4 33.7-3.7zm77.1-21.2c-2.4-8.5-11.2-13.4-19.7-11s-13.4 11.2-11 19.7l54.8 182.4c3.5 12.3-3.3 25.2-15.4 29.3s-25.3-2-30-13.9L174.9 138.1c-3.2-8.2-12.5-12.3-20.8-9s-12.3 12.5-9 20.8l73.3 185.6c12 30.3-23.7 57-49.4 37l-63.1-49.1c-7-5.4-17-4.2-22.5 2.8s-4.2 17 2.8 22.5l92 71.6c36.5 28.4 81.4 43.8 127.7 43.8l33.7 0c47.5 0 89-32.4 100.5-78.5l55.4-221.6c2.1-8.6-3.1-17.3-11.6-19.4s-17.3 3.1-19.4 11.6l-26 104C435.6 271.8 425 280 413 280c-16.5 0-28.9-15-25.8-31.2L415.7 99c1.7-8.7-4-17.1-12.7-18.7s-17.1 4-18.7 12.7L352.5 260c-2.2 11.6-12.4 20-24.2 20c-11 0-20.7-7.3-23.7-17.9L247.4 59.6z"
    ]
};
const $7435a4b2c8a749a5$export$5a54c83033a0a56a = {
    prefix: 'far',
    iconName: 'face-kiss',
    icon: [
        512,
        512,
        [
            128535,
            "kiss"
        ],
        "f596",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm304.7 25.7c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 411.1 257.4 416 240 416c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9c0 0 0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.8-.5-.1-.1-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $7435a4b2c8a749a5$export$c762a77aabf64fd0 = $7435a4b2c8a749a5$export$5a54c83033a0a56a;
const $7435a4b2c8a749a5$export$95a7394c24f57943 = {
    prefix: 'far',
    iconName: 'face-grin-tongue',
    icon: [
        512,
        512,
        [
            128539,
            "grin-tongue"
        ],
        "f589",
        "M464 256c0-114.9-93.1-208-208-208S48 141.1 48 256c0 81.7 47.1 152.4 115.7 186.4c-2.4-8.4-3.7-17.3-3.7-26.4l0-52.4c-8.9-8-16.7-17.1-23.1-27.1c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5c18.7-4.4 35.9 12 25.5 28.1c-6.4 9.9-14.2 19-23 27l0 52.5c0 9.2-1.3 18-3.7 26.4C416.9 408.4 464 337.7 464 256zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 416l0-37.4c0-14.7-11.9-26.6-26.6-26.6l-2 0c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9l-2 0c-14.7 0-26.6 11.9-26.6 26.6l0 37.4c0 35.3 28.7 64 64 64s64-28.7 64-64z"
    ]
};
const $7435a4b2c8a749a5$export$ef222816a43a4b3a = $7435a4b2c8a749a5$export$95a7394c24f57943;
const $7435a4b2c8a749a5$export$a831eedd2f59c62f = {
    prefix: 'far',
    iconName: 'chess-bishop',
    icon: [
        320,
        512,
        [
            9821
        ],
        "f43a",
        "M104 0C90.7 0 80 10.7 80 24c0 11.2 7.6 20.6 18 23.2c-7.8 8-16.1 17-24.4 27C38.2 116.7 0 178.8 0 250.9c0 44.8 24.6 72.2 48 87.8L48 352l48 0 0-27c0-9-5-17.2-13-21.3c-18-9.3-35-24.7-35-52.7c0-55.5 29.8-106.8 62.4-145.9c16-19.2 32.1-34.8 44.2-45.5c1.9-1.7 3.7-3.2 5.3-4.6c1.7 1.4 3.4 3 5.3 4.6c12.1 10.7 28.2 26.3 44.2 45.5c5.3 6.3 10.5 13 15.5 20L159 191c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57.8-57.8c12.8 25.9 21.2 54.3 21.2 83.8c0 28-17 43.4-35 52.7c-8 4.1-13 12.3-13 21.3l0 27 48 0 0-13.3c23.4-15.6 48-42.9 48-87.8c0-72.1-38.2-134.2-73.6-176.7c-8.3-9.9-16.6-19-24.4-27c10.3-2.7 18-12.1 18-23.2c0-13.3-10.7-24-24-24L160 0 104 0zM52.7 464l16.6-32 181.6 0 16.6 32L52.7 464zm207.9-80l-201 0c-12 0-22.9 6.7-28.4 17.3L4.6 452.5c-3 5.8-4.6 12.2-4.6 18.7C0 493.8 18.2 512 40.8 512l238.5 0c22.5 0 40.8-18.2 40.8-40.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2c-5.5-10.6-16.5-17.3-28.4-17.3z"
    ]
};
const $7435a4b2c8a749a5$export$1dd161850c5bc64e = {
    prefix: 'far',
    iconName: 'face-grin-wink',
    icon: [
        512,
        512,
        [
            "grin-wink"
        ],
        "f58c",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm165.8 21.7c-7.6 8.1-20.2 8.5-28.3 .9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7s-19.9 3.8-25.4 9.7z"
    ]
};
const $7435a4b2c8a749a5$export$2397fcd34eb12177 = $7435a4b2c8a749a5$export$1dd161850c5bc64e;
const $7435a4b2c8a749a5$export$bdbabf493c478cde = {
    prefix: 'far',
    iconName: 'face-grin-wide',
    icon: [
        512,
        512,
        [
            128515,
            "grin-alt"
        ],
        "f581",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM224 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64zm96 64c-17.7 0-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64z"
    ]
};
const $7435a4b2c8a749a5$export$b4abebfe416d36ba = $7435a4b2c8a749a5$export$bdbabf493c478cde;
const $7435a4b2c8a749a5$export$c8a28356e07b9ccb = {
    prefix: 'far',
    iconName: 'face-frown-open',
    icon: [
        512,
        512,
        [
            128550,
            "frown-open"
        ],
        "f57a",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM182.4 382.5c-12.4 5.2-26.5-4.1-21.1-16.4c16-36.6 52.4-62.1 94.8-62.1s78.8 25.6 94.8 62.1c5.4 12.3-8.7 21.6-21.1 16.4c-22.4-9.5-47.4-14.8-73.7-14.8s-51.3 5.3-73.7 14.8zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $7435a4b2c8a749a5$export$c4775e66bed5d96 = $7435a4b2c8a749a5$export$c8a28356e07b9ccb;
const $7435a4b2c8a749a5$export$cdc9f5e7e94e76da = {
    prefix: 'far',
    iconName: 'hand-point-up',
    icon: [
        384,
        512,
        [
            9757
        ],
        "f0a6",
        "M64 64l0 177.6c5.2-1 10.5-1.6 16-1.6l16 0 0-32L96 64c0-8.8-7.2-16-16-16s-16 7.2-16 16zM80 288c-17.7 0-32 14.3-32 32c0 0 0 0 0 0l0 24c0 66.3 53.7 120 120 120l48 0c52.5 0 97.1-33.7 113.4-80.7c-3.1 .5-6.2 .7-9.4 .7c-20 0-37.9-9.2-49.7-23.6c-9 4.9-19.4 7.6-30.3 7.6c-15.1 0-29-5.3-40-14c-11 8.8-24.9 14-40 14l-40 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-40 0-40 0zM0 320s0 0 0 0c0-18 6-34.6 16-48L16 64C16 28.7 44.7 0 80 0s64 28.7 64 64l0 82c5.1-1.3 10.5-2 16-2c25.3 0 47.2 14.7 57.6 36c7-2.6 14.5-4 22.4-4c20 0 37.9 9.2 49.7 23.6c9-4.9 19.4-7.6 30.3-7.6c35.3 0 64 28.7 64 64l0 64 0 24c0 92.8-75.2 168-168 168l-48 0C75.2 512 0 436.8 0 344l0-24zm336-64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64zM160 240c5.5 0 10.9 .7 16 2l0-2 0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32 16 0zm64 24l0 40c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 24z"
    ]
};
const $7435a4b2c8a749a5$export$4ed9da5c3cca0ef1 = {
    prefix: 'far',
    iconName: 'bookmark',
    icon: [
        384,
        512,
        [
            128278,
            61591
        ],
        "f02e",
        "M0 48C0 21.5 21.5 0 48 0l0 48 0 393.4 130.1-92.9c8.3-6 19.6-6 27.9 0L336 441.4 336 48 48 48 48 0 336 0c26.5 0 48 21.5 48 48l0 440c0 9-5 17.2-13 21.3s-17.6 3.4-24.9-1.8L192 397.5 37.9 507.5c-7.3 5.2-16.9 5.9-24.9 1.8S0 497 0 488L0 48z"
    ]
};
const $7435a4b2c8a749a5$export$f6dcbf0a940428f4 = {
    prefix: 'far',
    iconName: 'hand-point-down',
    icon: [
        384,
        512,
        [],
        "f0a7",
        "M64 448l0-177.6c5.2 1 10.5 1.6 16 1.6l16 0 0 32 0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16zM80 224c-17.7 0-32-14.3-32-32c0 0 0 0 0 0l0-24c0-66.3 53.7-120 120-120l48 0c52.5 0 97.1 33.7 113.4 80.7c-3.1-.5-6.2-.7-9.4-.7c-20 0-37.9 9.2-49.7 23.6c-9-4.9-19.4-7.6-30.3-7.6c-15.1 0-29 5.3-40 14c-11-8.8-24.9-14-40-14l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-40 0-40 0zM0 192s0 0 0 0c0 18 6 34.6 16 48l0 208c0 35.3 28.7 64 64 64s64-28.7 64-64l0-82c5.1 1.3 10.5 2 16 2c25.3 0 47.2-14.7 57.6-36c7 2.6 14.5 4 22.4 4c20 0 37.9-9.2 49.7-23.6c9 4.9 19.4 7.6 30.3 7.6c35.3 0 64-28.7 64-64l0-64 0-24C384 75.2 308.8 0 216 0L168 0C75.2 0 0 75.2 0 168l0 24zm336 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64zM160 272c5.5 0 10.9-.7 16-2l0 2 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32 16 0zm64-24l0-40c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-24z"
    ]
};
const $7435a4b2c8a749a5$export$72b780186370e953 = {
    prefix: 'far',
    iconName: 'folder',
    icon: [
        512,
        512,
        [
            128193,
            128447,
            61716,
            "folder-blank"
        ],
        "f07b",
        "M0 96C0 60.7 28.7 32 64 32l132.1 0c19.1 0 37.4 7.6 50.9 21.1L289.9 96 448 96c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-256c0-8.8-7.2-16-16-16l-161.4 0c-10.6 0-20.8-4.2-28.3-11.7L213.1 87c-4.5-4.5-10.6-7-17-7L64 80z"
    ]
};
const $7435a4b2c8a749a5$export$9ef114244d26da0 = $7435a4b2c8a749a5$export$72b780186370e953;
const $7435a4b2c8a749a5$export$f5699fa0844e0188 = {
    prefix: 'far',
    iconName: 'user',
    icon: [
        448,
        512,
        [
            128100,
            62144
        ],
        "f007",
        "M304 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM49.3 464l349.5 0c-8.9-63.3-63.3-112-129-112l-91.4 0c-65.7 0-120.1 48.7-129 112zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3z"
    ]
};
const $7435a4b2c8a749a5$export$2c5163541229363 = {
    prefix: 'far',
    iconName: 'square-caret-left',
    icon: [
        448,
        512,
        [
            "caret-square-left"
        ],
        "f191",
        "M48 416c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320zm16 64c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480zm64-224c0-6.7 2.8-13 7.7-17.6l112-104c7-6.5 17.2-8.2 25.9-4.4s14.4 12.5 14.4 22l0 208c0 9.5-5.7 18.2-14.4 22s-18.9 2.1-25.9-4.4l-112-104c-4.9-4.5-7.7-10.9-7.7-17.6z"
    ]
};
const $7435a4b2c8a749a5$export$d0c8ba444f1f9581 = $7435a4b2c8a749a5$export$2c5163541229363;
const $7435a4b2c8a749a5$export$a3b0eb2cd7942125 = {
    prefix: 'far',
    iconName: 'star',
    icon: [
        576,
        512,
        [
            11088,
            61446
        ],
        "f005",
        "M287.9 0c9.2 0 17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.7 23.5s-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5C270.4 5.2 278.7 0 287.9 0zm0 79L235.4 187.2c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l105.2-56.2c7.1-3.8 15.6-3.8 22.6 0l105.2 56.2L384.2 324.1c-1.3-7.7 1.2-15.5 6.8-21l85.9-85.1L358.6 200.5c-7.8-1.2-14.6-6.1-18.1-13.3L287.9 79z"
    ]
};
const $7435a4b2c8a749a5$export$861b1f13085cf122 = {
    prefix: 'far',
    iconName: 'chess-knight',
    icon: [
        448,
        512,
        [
            9822
        ],
        "f441",
        "M226.6 48L117.3 48l17.1 12.8c6 4.5 9.6 11.6 9.6 19.2s-3.6 14.7-9.6 19.2l-6.5 4.9c-10 7.5-16 19.3-16 31.9l-.3 91c0 10.2 4.9 19.9 13.2 25.8l1.9 1.3c9.9 7.1 23.3 7 33.2-.1l49.9-36.3c10.7-7.8 25.7-5.4 33.5 5.3s5.4 25.7-5.3 33.5l-49.9 36.3-53.8 39.1c-7.3 5.3-13 12.2-16.9 20.1l-50.7 0c5.3-22.1 17.8-41.9 35.9-56.3c-1.3-.8-2.6-1.7-3.8-2.6L97 291.8c-21-15-33.4-39.2-33.3-65l.3-91c.1-19.8 6.7-38.7 18.6-53.9l-.4-.3C70.7 73 64 59.6 64 45.3C64 20.3 84.3 0 109.3 0L226.6 0C331.2 0 416 84.8 416 189.4c0 11.1-1 22.2-2.9 33.2L390.1 352l-48.8 0 24.5-137.8c1.5-8.2 2.2-16.5 2.2-24.8C368 111.3 304.7 48 226.6 48zM85.2 432L68.7 464l310.7 0-16.6-32L85.2 432zm315.7-30.7l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7c0 22.5-18.2 40.8-40.8 40.8L56.8 512C34.2 512 16 493.8 16 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2C52.5 390.7 63.5 384 75.5 384l297 0c12 0 22.9 6.7 28.4 17.3zM172 128a20 20 0 1 1 0 40 20 20 0 1 1 0-40z"
    ]
};
const $7435a4b2c8a749a5$export$67ca89c1ca38d559 = {
    prefix: 'far',
    iconName: 'face-laugh-squint',
    icon: [
        512,
        512,
        [
            "laugh-squint"
        ],
        "f59b",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9l212.5 0c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zm2.8-183.3l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 141.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
    ]
};
const $7435a4b2c8a749a5$export$b206e700cf7084e1 = $7435a4b2c8a749a5$export$67ca89c1ca38d559;
const $7435a4b2c8a749a5$export$2f203616c892d415 = {
    prefix: 'far',
    iconName: 'face-laugh',
    icon: [
        512,
        512,
        [
            "laugh"
        ],
        "f599",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9l212.5 0c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $7435a4b2c8a749a5$export$6c74e314e801a4fe = $7435a4b2c8a749a5$export$2f203616c892d415;
const $7435a4b2c8a749a5$export$ff7e93418af88b78 = {
    prefix: 'far',
    iconName: 'folder-open',
    icon: [
        576,
        512,
        [
            128194,
            128449,
            61717
        ],
        "f07c",
        "M384 480l48 0c11.4 0 21.9-6 27.6-15.9l112-192c5.8-9.9 5.8-22.1 .1-32.1S555.5 224 544 224l-400 0c-11.4 0-21.9 6-27.6 15.9L48 357.1 48 96c0-8.8 7.2-16 16-16l117.5 0c4.2 0 8.3 1.7 11.3 4.7l26.5 26.5c21 21 49.5 32.8 79.2 32.8L416 144c8.8 0 16 7.2 16 16l0 32 48 0 0-32c0-35.3-28.7-64-64-64L298.5 96c-17 0-33.3-6.7-45.3-18.7L226.7 50.7c-12-12-28.3-18.7-45.3-18.7L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l23.7 0L384 480z"
    ]
};
const $7435a4b2c8a749a5$export$97d84347d71ba297 = {
    prefix: 'far',
    iconName: 'clipboard',
    icon: [
        384,
        512,
        [
            128203
        ],
        "f328",
        "M280 64l40 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 128C0 92.7 28.7 64 64 64l40 0 9.6 0C121 27.5 153.3 0 192 0s71 27.5 78.4 64l9.6 0zM64 112c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16l-16 0 0 24c0 13.3-10.7 24-24 24l-88 0-88 0c-13.3 0-24-10.7-24-24l0-24-16 0zm128-8a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
const $7435a4b2c8a749a5$export$7b8ce73615739d30 = {
    prefix: 'far',
    iconName: 'chess-queen',
    icon: [
        512,
        512,
        [
            9819
        ],
        "f445",
        "M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-95.2-8c-18.1 0-31.3 12.8-35.6 26.9c-8 26.2-32.4 45.2-61.2 45.2c-10 0-19.4-2.3-27.7-6.3c-7.6-3.7-16.7-3.3-24 1.2C.7 162.1-3.1 177.1 3.7 188.9L97.6 352l55.4 0-83-144.1c40.5-2.2 75.3-25.9 93.1-59.8c22 26.8 55.4 43.9 92.8 43.9s70.8-17.1 92.8-43.9c17.8 34 52.6 57.7 93.1 59.8L359 352l55.4 0 93.9-163.1c6.8-11.7 3-26.7-8.6-33.8c-7.3-4.5-16.4-4.9-24-1.2c-8.4 4-17.7 6.3-27.7 6.3c-28.8 0-53.2-19-61.2-45.2C382.5 100.8 369.3 88 351.2 88c-14.5 0-26.3 8.5-32.4 19.3c-12.4 22-35.9 36.7-62.8 36.7s-50.4-14.8-62.8-36.7C187.1 96.5 175.4 88 160.8 88zM133.2 432l245.6 0 16.6 32-278.7 0 16.6-32zm283.7-30.7c-5.5-10.6-16.5-17.3-28.4-17.3l-265 0c-12 0-22.9 6.7-28.4 17.3L68.6 452.5c-3 5.8-4.6 12.2-4.6 18.7c0 22.5 18.2 40.8 40.8 40.8l302.5 0c22.5 0 40.8-18.2 40.8-40.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2z"
    ]
};
const $7435a4b2c8a749a5$export$be38a892fe9b4098 = {
    prefix: 'far',
    iconName: 'hand-back-fist',
    icon: [
        448,
        512,
        [
            "hand-rock"
        ],
        "f255",
        "M144 64c0-8.8 7.2-16 16-16s16 7.2 16 16c0 9.1 5.1 17.4 13.3 21.5s17.9 3.2 25.1-2.3c2.7-2 6-3.2 9.6-3.2c8.8 0 16 7.2 16 16c0 9.1 5.1 17.4 13.3 21.5s17.9 3.2 25.1-2.3c2.7-2 6-3.2 9.6-3.2c8.8 0 16 7.2 16 16c0 9.1 5.1 17.4 13.3 21.5s17.9 3.2 25.1-2.3c2.7-2 6-3.2 9.6-3.2c8.8 0 16 7.2 16 16l0 104c0 31.3-20 58-48 67.9c-9.6 3.4-16 12.5-16 22.6L304 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-117.8c38-20.1 64-60.1 64-106.2l0-104c0-35.3-28.7-64-64-64c-2.8 0-5.6 .2-8.3 .5C332.8 77.1 311.9 64 288 64c-2.8 0-5.6 .2-8.3 .5C268.8 45.1 247.9 32 224 32c-2.8 0-5.6 .2-8.3 .5C204.8 13.1 183.9 0 160 0C124.7 0 96 28.7 96 64l0 64.3c-11.7 7.4-22.5 16.4-32 26.9l17.8 16.1L64 155.2l-9.4 10.5C40 181.8 32 202.8 32 224.6l0 12.8c0 49.6 24.2 96.1 64.8 124.5l13.8-19.7L96.8 361.9l8.9 6.2c6.9 4.8 14.4 8.6 22.3 11.3L128 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-128.1c0-12.6-9.8-23.1-22.4-23.9c-7.3-.5-14.3-2.9-20.3-7.1l-13.1 18.7 13.1-18.7-8.9-6.2C96.6 303.1 80 271.3 80 237.4l0-12.8c0-9.9 3.7-19.4 10.3-26.8l9.4-10.5c3.8-4.2 7.9-8.1 12.3-11.6l0 32.3c0 8.8 7.2 16 16 16s16-7.2 16-16l0-65.7 0-14.3 0-64z"
    ]
};
const $7435a4b2c8a749a5$export$97a81eba394c8c44 = $7435a4b2c8a749a5$export$be38a892fe9b4098;
const $7435a4b2c8a749a5$export$66068918abb14406 = {
    prefix: 'far',
    iconName: 'square-caret-up',
    icon: [
        448,
        512,
        [
            "caret-square-up"
        ],
        "f151",
        "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm224 64c6.7 0 13 2.8 17.6 7.7l104 112c6.5 7 8.2 17.2 4.4 25.9s-12.5 14.4-22 14.4l-208 0c-9.5 0-18.2-5.7-22-14.4s-2.1-18.9 4.4-25.9l104-112c4.5-4.9 10.9-7.7 17.6-7.7z"
    ]
};
const $7435a4b2c8a749a5$export$307ae80b26533ce5 = $7435a4b2c8a749a5$export$66068918abb14406;
const $7435a4b2c8a749a5$export$b532f5d25de97633 = {
    prefix: 'far',
    iconName: 'chart-bar',
    icon: [
        512,
        512,
        [
            "bar-chart"
        ],
        "f080",
        "M24 32c13.3 0 24 10.7 24 24l0 352c0 13.3 10.7 24 24 24l416 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L72 480c-39.8 0-72-32.2-72-72L0 56C0 42.7 10.7 32 24 32zM128 136c0-13.3 10.7-24 24-24l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24zm24 72l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96l272 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-272 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
const $7435a4b2c8a749a5$export$2d5f754a5e5738b = $7435a4b2c8a749a5$export$b532f5d25de97633;
const $7435a4b2c8a749a5$export$eccfff9bfd585652 = {
    prefix: 'far',
    iconName: 'window-restore',
    icon: [
        512,
        512,
        [],
        "f2d2",
        "M432 48L208 48c-17.7 0-32 14.3-32 32l0 16-48 0 0-16c0-44.2 35.8-80 80-80L432 0c44.2 0 80 35.8 80 80l0 224c0 44.2-35.8 80-80 80l-16 0 0-48 16 0c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32zM48 448c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-192L48 256l0 192zM64 128l256 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192c0-35.3 28.7-64 64-64z"
    ]
};
const $7435a4b2c8a749a5$export$eaf727acca5a35e4 = {
    prefix: 'far',
    iconName: 'square-plus',
    icon: [
        448,
        512,
        [
            61846,
            "plus-square"
        ],
        "f0fe",
        "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM200 344l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
    ]
};
const $7435a4b2c8a749a5$export$b6359eebfe900c35 = $7435a4b2c8a749a5$export$eaf727acca5a35e4;
const $7435a4b2c8a749a5$export$7e9f0928967e03b = {
    prefix: 'far',
    iconName: 'image',
    icon: [
        512,
        512,
        [],
        "f03e",
        "M448 80c8.8 0 16 7.2 16 16l0 319.8-5-6.5-136-176c-4.5-5.9-11.6-9.3-19-9.3s-14.4 3.4-19 9.3L202 340.7l-30.5-42.7C167 291.7 159.8 288 152 288s-15 3.7-19.5 10.1l-80 112L48 416.3l0-.3L48 96c0-8.8 7.2-16 16-16l384 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm80 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    ]
};
const $7435a4b2c8a749a5$export$5e30548b7f8eeb95 = {
    prefix: 'far',
    iconName: 'folder-closed',
    icon: [
        512,
        512,
        [],
        "e185",
        "M251.7 127.6s0 0 0 0c10.5 10.5 24.7 16.4 39.6 16.4L448 144c8.8 0 16 7.2 16 16l0 32L48 192l0-96c0-8.8 7.2-16 16-16l133.5 0c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zM48 240l416 0 0 176c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-176zM285.7 93.7L242.7 50.7c-12-12-28.3-18.7-45.3-18.7L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L291.3 96c-2.1 0-4.2-.8-5.7-2.3z"
    ]
};
const $7435a4b2c8a749a5$export$4fbda8f64648f3b5 = {
    prefix: 'far',
    iconName: 'lemon',
    icon: [
        448,
        512,
        [
            127819
        ],
        "f094",
        "M368 80c-3.2 0-6.2 .4-8.9 1.3C340 86.8 313 91.9 284.8 84.6C227.4 69.7 160.2 92 110.1 142.1S37.7 259.4 52.6 316.8c7.3 28.2 2.2 55.2-3.3 74.3c-.8 2.8-1.3 5.8-1.3 8.9c0 17.7 14.3 32 32 32c3.2 0 6.2-.4 8.9-1.3c19.1-5.5 46.1-10.7 74.3-3.3c57.4 14.9 124.6-7.4 174.7-57.5s72.4-117.3 57.5-174.7c-7.3-28.2-2.2-55.2 3.3-74.3c.8-2.8 1.3-5.8 1.3-8.9c0-17.7-14.3-32-32-32zm0-48c44.2 0 80 35.8 80 80c0 7.7-1.1 15.2-3.1 22.3c-4.6 15.8-7.1 32.9-3 48.9c20.1 77.6-10.9 161.5-70 220.7s-143.1 90.2-220.7 70c-16-4.1-33-1.6-48.9 3c-7.1 2-14.6 3.1-22.3 3.1c-44.2 0-80-35.8-80-80c0-7.7 1.1-15.2 3.1-22.3c4.6-15.8 7.1-32.9 3-48.9C-14 251.3 17 167.3 76.2 108.2S219.3 18 296.8 38.1c16 4.1 33 1.6 48.9-3c7.1-2 14.6-3.1 22.3-3.1zM246.7 167c-52 15.2-96.5 59.7-111.7 111.7c-3.7 12.7-17.1 20-29.8 16.3s-20-17.1-16.3-29.8c19.8-67.7 76.6-124.5 144.3-144.3c12.7-3.7 26.1 3.6 29.8 16.3s-3.6 26.1-16.3 29.8z"
    ]
};
const $7435a4b2c8a749a5$export$b4c63e9bfc7906f1 = {
    prefix: 'far',
    iconName: 'handshake',
    icon: [
        640,
        512,
        [],
        "f2b5",
        "M272.2 64.6l-51.1 51.1c-15.3 4.2-29.5 11.9-41.5 22.5L153 161.9C142.8 171 129.5 176 115.8 176L96 176l0 128c20.4 .6 39.8 8.9 54.3 23.4l35.6 35.6 7 7c0 0 0 0 0 0L219.9 397c6.2 6.2 16.4 6.2 22.6 0c1.7-1.7 3-3.7 3.7-5.8c2.8-7.7 9.3-13.5 17.3-15.3s16.4 .6 22.2 6.5L296.5 393c11.6 11.6 30.4 11.6 41.9 0c5.4-5.4 8.3-12.3 8.6-19.4c.4-8.8 5.6-16.6 13.6-20.4s17.3-3 24.4 2.1c9.4 6.7 22.5 5.8 30.9-2.6c9.4-9.4 9.4-24.6 0-33.9L340.1 243l-35.8 33c-27.3 25.2-69.2 25.6-97 .9c-31.7-28.2-32.4-77.4-1.6-106.5l70.1-66.2C303.2 78.4 339.4 64 377.1 64c36.1 0 71 13.3 97.9 37.2L505.1 128l38.9 0 40 0 40 0c8.8 0 16 7.2 16 16l0 208c0 17.7-14.3 32-32 32l-32 0c-11.8 0-22.2-6.4-27.7-16l-84.9 0c-3.4 6.7-7.9 13.1-13.5 18.7c-17.1 17.1-40.8 23.8-63 20.1c-3.6 7.3-8.5 14.1-14.6 20.2c-27.3 27.3-70 30-100.4 8.1c-25.1 20.8-62.5 19.5-86-4.1L159 404l-7-7-35.6-35.6c-5.5-5.5-12.7-8.7-20.4-9.3C96 369.7 81.6 384 64 384l-32 0c-17.7 0-32-14.3-32-32L0 144c0-8.8 7.2-16 16-16l40 0 40 0 19.8 0c2 0 3.9-.7 5.3-2l26.5-23.6C175.5 77.7 211.4 64 248.7 64L259 64c4.4 0 8.9 .2 13.2 .6zM544 320l0-144-48 0c-5.9 0-11.6-2.2-15.9-6.1l-36.9-32.8c-18.2-16.2-41.7-25.1-66.1-25.1c-25.4 0-49.8 9.7-68.3 27.1l-70.1 66.2c-10.3 9.8-10.1 26.3 .5 35.7c9.3 8.3 23.4 8.1 32.5-.3l71.9-66.4c9.7-9 24.9-8.4 33.9 1.4s8.4 24.9-1.4 33.9l-.8 .8 74.4 74.4c10 10 16.5 22.3 19.4 35.1l74.8 0zM64 336a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm528 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
const $7435a4b2c8a749a5$export$31ee86ac717db552 = {
    prefix: 'far',
    iconName: 'gem',
    icon: [
        512,
        512,
        [
            128142
        ],
        "f3a5",
        "M168.5 72L256 165l87.5-93-175 0zM383.9 99.1L311.5 176l129 0L383.9 99.1zm50 124.9L256 224 78.1 224 256 420.3 433.9 224zM71.5 176l129 0L128.1 99.1 71.5 176zm434.3 40.1l-232 256c-4.5 5-11 7.9-17.8 7.9s-13.2-2.9-17.8-7.9l-232-256c-7.7-8.5-8.3-21.2-1.5-30.4l112-152c4.5-6.1 11.7-9.8 19.3-9.8l240 0c7.6 0 14.8 3.6 19.3 9.8l112 152c6.8 9.2 6.1 21.9-1.5 30.4z"
    ]
};
const $7435a4b2c8a749a5$export$86c4e45dc3302d15 = {
    prefix: 'far',
    iconName: 'circle-play',
    icon: [
        512,
        512,
        [
            61469,
            "play-circle"
        ],
        "f144",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM188.3 147.1c7.6-4.2 16.8-4.1 24.3 .5l144 88c7.1 4.4 11.5 12.1 11.5 20.5s-4.4 16.1-11.5 20.5l-144 88c-7.4 4.5-16.7 4.7-24.3 .5s-12.3-12.2-12.3-20.9l0-176c0-8.7 4.7-16.7 12.3-20.9z"
    ]
};
const $7435a4b2c8a749a5$export$cf04333781061c5e = $7435a4b2c8a749a5$export$86c4e45dc3302d15;
const $7435a4b2c8a749a5$export$c2e9877668862374 = {
    prefix: 'far',
    iconName: 'circle-check',
    icon: [
        512,
        512,
        [
            61533,
            "check-circle"
        ],
        "f058",
        "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"
    ]
};
const $7435a4b2c8a749a5$export$be9e388158c74f29 = $7435a4b2c8a749a5$export$c2e9877668862374;
const $7435a4b2c8a749a5$export$229de76dfef2687f = {
    prefix: 'far',
    iconName: 'circle-stop',
    icon: [
        512,
        512,
        [
            62094,
            "stop-circle"
        ],
        "f28d",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm192-96l128 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32z"
    ]
};
const $7435a4b2c8a749a5$export$47af2aad60ab3e7c = $7435a4b2c8a749a5$export$229de76dfef2687f;
const $7435a4b2c8a749a5$export$a75288855ea05282 = {
    prefix: 'far',
    iconName: 'id-badge',
    icon: [
        384,
        512,
        [],
        "f2c1",
        "M256 48l0 16c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-16L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16l-64 0zM0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM160 320l64 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16L96 416c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"
    ]
};
const $7435a4b2c8a749a5$export$3f2d51c0547bf984 = {
    prefix: 'far',
    iconName: 'face-laugh-beam',
    icon: [
        512,
        512,
        [
            128513,
            "laugh-beam"
        ],
        "f59a",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9l212.5 0c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zm86.9-85.1s0 0 0 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0zm160 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0z"
    ]
};
const $7435a4b2c8a749a5$export$a88d1f4073ea9369 = $7435a4b2c8a749a5$export$3f2d51c0547bf984;
const $7435a4b2c8a749a5$export$5f519e9ac15ab8c3 = {
    prefix: 'far',
    iconName: 'registered',
    icon: [
        512,
        512,
        [
            174
        ],
        "f25d",
        "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 152l0 112 0 96c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 60.9 0 37.2 81.9c5.5 12.1 19.7 17.4 31.8 11.9s17.4-19.7 11.9-31.8L315.7 275c21.8-14.3 36.3-39 36.3-67c0-44.2-35.8-80-80-80l-88 0c-13.3 0-24 10.7-24 24zm48 88l0-64 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0z"
    ]
};
const $7435a4b2c8a749a5$export$6ea408c7266ed557 = {
    prefix: 'far',
    iconName: 'address-card',
    icon: [
        576,
        512,
        [
            62140,
            "contact-card",
            "vcard"
        ],
        "f2bb",
        "M512 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l448 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM208 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80l-64 0zM376 144c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0z"
    ]
};
const $7435a4b2c8a749a5$export$4ac51eb0b298b190 = $7435a4b2c8a749a5$export$6ea408c7266ed557;
const $7435a4b2c8a749a5$export$91228257deb1bf18 = $7435a4b2c8a749a5$export$6ea408c7266ed557;
const $7435a4b2c8a749a5$export$5352cbdc070ce8d = {
    prefix: 'far',
    iconName: 'face-tired',
    icon: [
        512,
        512,
        [
            128555,
            "tired"
        ],
        "f5c8",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.5 64.3C196.1 302.1 223.8 288 256 288s59.9 14.1 79.5 32.3C354.5 338.1 368 362 368 384c0 5.4-2.7 10.4-7.2 13.4s-10.2 3.4-15.2 1.3l-17.2-7.5c-22.8-10-47.5-15.1-72.4-15.1s-49.6 5.2-72.4 15.1l-17.2 7.5c-4.9 2.2-10.7 1.7-15.2-1.3s-7.2-8-7.2-13.4c0-22 13.5-45.9 32.5-63.7zm-43-173.6l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
    ]
};
const $7435a4b2c8a749a5$export$3d016d62cda18371 = $7435a4b2c8a749a5$export$5352cbdc070ce8d;
const $7435a4b2c8a749a5$export$aa4baaed1c60f58d = {
    prefix: 'far',
    iconName: 'font-awesome',
    icon: [
        512,
        512,
        [
            62501,
            62694,
            "font-awesome-flag",
            "font-awesome-logo-full"
        ],
        "f2b4",
        "M91.7 96C106.3 86.8 116 70.5 116 52C116 23.3 92.7 0 64 0S12 23.3 12 52c0 16.7 7.8 31.5 20 41l0 3 0 48 0 256 0 48 0 64 48 0 0-64 389.6 0c14.6 0 26.4-11.8 26.4-26.4c0-3.7-.8-7.3-2.3-10.7L432 272l61.7-138.9c1.5-3.4 2.3-7 2.3-10.7c0-14.6-11.8-26.4-26.4-26.4L91.7 96zM80 400l0-256 356.4 0L388.1 252.5c-5.5 12.4-5.5 26.6 0 39L436.4 400 80 400z"
    ]
};
const $7435a4b2c8a749a5$export$102c25fde54d4843 = $7435a4b2c8a749a5$export$aa4baaed1c60f58d;
const $7435a4b2c8a749a5$export$6e20d421a2e0f320 = $7435a4b2c8a749a5$export$aa4baaed1c60f58d;
const $7435a4b2c8a749a5$export$6143da800b0e6626 = {
    prefix: 'far',
    iconName: 'face-smile-wink',
    icon: [
        512,
        512,
        [
            128521,
            "smile-wink"
        ],
        "f4da",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm177.6 62.1C192.8 334.5 218.8 352 256 352s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm165.8 21.7c-7.6 8.1-20.2 8.5-28.3 .9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7s-19.9 3.8-25.4 9.7z"
    ]
};
const $7435a4b2c8a749a5$export$f5dbb37f6801ee3f = $7435a4b2c8a749a5$export$6143da800b0e6626;
const $7435a4b2c8a749a5$export$f0858dff6e769cf6 = {
    prefix: 'far',
    iconName: 'file-word',
    icon: [
        384,
        512,
        [],
        "f1c2",
        "M48 448L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm55 241.1c-3.8-12.7-17.2-19.9-29.9-16.1s-19.9 17.2-16.1 29.9l48 160c3 10.2 12.4 17.1 23 17.1s19.9-7 23-17.1l25-83.4 25 83.4c3 10.2 12.4 17.1 23 17.1s19.9-7 23-17.1l48-160c3.8-12.7-3.4-26.1-16.1-29.9s-26.1 3.4-29.9 16.1l-25 83.4-25-83.4c-3-10.2-12.4-17.1-23-17.1s-19.9 7-23 17.1l-25 83.4-25-83.4z"
    ]
};
const $7435a4b2c8a749a5$export$c341daeecdea449a = {
    prefix: 'far',
    iconName: 'file-powerpoint',
    icon: [
        384,
        512,
        [],
        "f1c4",
        "M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm72 208c-13.3 0-24 10.7-24 24l0 104 0 56c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32 44 0c42 0 76-34 76-76s-34-76-76-76l-68 0zm68 104l-44 0 0-56 44 0c15.5 0 28 12.5 28 28s-12.5 28-28 28z"
    ]
};
const $7435a4b2c8a749a5$export$c6c3bd5f7d9b8bf2 = {
    prefix: 'far',
    iconName: 'envelope-open',
    icon: [
        512,
        512,
        [
            62135
        ],
        "f2b6",
        "M255.4 48.2c.2-.1 .4-.2 .6-.2s.4 .1 .6 .2L460.6 194c2.1 1.5 3.4 3.9 3.4 6.5l0 13.6L291.5 355.7c-20.7 17-50.4 17-71.1 0L48 214.1l0-13.6c0-2.6 1.2-5 3.4-6.5L255.4 48.2zM48 276.2L190 392.8c38.4 31.5 93.7 31.5 132 0L464 276.2 464 456c0 4.4-3.6 8-8 8L56 464c-4.4 0-8-3.6-8-8l0-179.8zM256 0c-10.2 0-20.2 3.2-28.5 9.1L23.5 154.9C8.7 165.4 0 182.4 0 200.5L0 456c0 30.9 25.1 56 56 56l400 0c30.9 0 56-25.1 56-56l0-255.5c0-18.1-8.7-35.1-23.4-45.6L284.5 9.1C276.2 3.2 266.2 0 256 0z"
    ]
};
const $7435a4b2c8a749a5$export$7a4a0e4caa1e4e6f = {
    prefix: 'far',
    iconName: 'file-zipper',
    icon: [
        384,
        512,
        [
            "file-archive"
        ],
        "f1c6",
        "M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l48 0c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l48 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm48 112c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm-6.3 71.8L82.1 335.9c-1.4 5.4-2.1 10.9-2.1 16.4c0 35.2 28.8 63.7 64 63.7s64-28.5 64-63.7c0-5.5-.7-11.1-2.1-16.4l-23.5-88.2c-3.7-14-16.4-23.8-30.9-23.8l-14.8 0c-14.5 0-27.2 9.7-30.9 23.8zM128 336l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
const $7435a4b2c8a749a5$export$bf2047a9946b5c3f = $7435a4b2c8a749a5$export$7a4a0e4caa1e4e6f;
const $7435a4b2c8a749a5$export$90b4406457aae8cc = {
    prefix: 'far',
    iconName: 'square',
    icon: [
        448,
        512,
        [
            9632,
            9723,
            9724,
            61590
        ],
        "f0c8",
        "M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z"
    ]
};
const $7435a4b2c8a749a5$export$bab8f3647c394f48 = {
    prefix: 'far',
    iconName: 'snowflake',
    icon: [
        448,
        512,
        [
            10052,
            10054
        ],
        "f2dc",
        "M224 0c13.3 0 24 10.7 24 24l0 46.1 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-57 57 0 76.5 66.2-38.2 20.9-77.8c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4L373 142.2l37.1-21.4c11.5-6.6 26.2-2.7 32.8 8.8s2.7 26.2-8.8 32.8L397 183.8l31.5 8.4c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-77.8-20.9L272 256l66.2 38.2 77.8-20.9c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4L397 328.2l37.1 21.4c11.5 6.6 15.4 21.3 8.8 32.8s-21.3 15.4-32.8 8.8L373 369.8l8.4 31.5c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-20.9-77.8L248 297.6l0 76.5 57 57c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23 0 46.1c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-46.1-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l57-57 0-76.5-66.2 38.2-20.9 77.8c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4L75 369.8 37.9 391.2c-11.5 6.6-26.2 2.7-32.8-8.8s-2.7-26.2 8.8-32.8L51 328.2l-31.5-8.4c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l77.8 20.9L176 256l-66.2-38.2L31.9 238.6c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4L51 183.8 13.9 162.4c-11.5-6.6-15.4-21.3-8.8-32.8s21.3-15.4 32.8-8.8L75 142.2l-8.4-31.5c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l20.9 77.8L200 214.4l0-76.5L143 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23L200 24c0-13.3 10.7-24 24-24z"
    ]
};
const $7435a4b2c8a749a5$export$d91b374112d4f8c1 = {
    prefix: 'far',
    iconName: 'newspaper',
    icon: [
        512,
        512,
        [
            128240
        ],
        "f1ea",
        "M168 80c-13.3 0-24 10.7-24 24l0 304c0 8.4-1.4 16.5-4.1 24L440 432c13.3 0 24-10.7 24-24l0-304c0-13.3-10.7-24-24-24L168 80zM72 480c-39.8 0-72-32.2-72-72L0 112C0 98.7 10.7 88 24 88s24 10.7 24 24l0 296c0 13.3 10.7 24 24 24s24-10.7 24-24l0-304c0-39.8 32.2-72 72-72l272 0c39.8 0 72 32.2 72 72l0 304c0 39.8-32.2 72-72 72L72 480zM176 136c0-13.3 10.7-24 24-24l96 0c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24l0-80zm200-24l32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80l32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM200 272l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
const $7435a4b2c8a749a5$export$611ae61f02de0aa = {
    prefix: 'far',
    iconName: 'face-kiss-wink-heart',
    icon: [
        512,
        512,
        [
            128536,
            "kiss-wink-heart"
        ],
        "f598",
        "M338.9 446.8c-25.4 11-53.4 17.2-82.9 17.2C141.1 464 48 370.9 48 256S141.1 48 256 48s208 93.1 208 208c0 22.4-3.5 43.9-10.1 64.1c3.1 4.5 5.7 9.4 7.8 14.6c12.7-1.6 25.1 .4 36.2 5c9.1-26.2 14-54.4 14-83.7C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c35.4 0 69.1-7.2 99.7-20.2c-4.8-5.5-8.5-12.2-10.4-19.7l-6.5-25.3zM296 316c0-6.9-3.1-13.2-7.3-18.3c-4.3-5.2-10.1-9.7-16.7-13.4C258.7 276.9 241.4 272 224 272c-3.6 0-6.8 2.5-7.7 6s.6 7.2 3.8 9c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2 .1c.2 .1 .5 .3 .9 .5c.8 .5 2 1.2 3.4 2.1c2.8 1.9 6.5 4.5 10.2 7.6c3.7 3.1 7.2 6.6 9.6 10.1c2.5 3.5 3.5 6.4 3.5 8.6s-1 5-3.5 8.6c-2.5 3.5-5.9 6.9-9.6 10.1c-3.7 3.1-7.4 5.7-10.2 7.6c-1.4 .9-2.6 1.6-3.4 2.1c-.4 .2-.7 .4-.9 .5l-.2 .1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c-2.5 1.4-4.1 4.1-4.1 7s1.6 5.6 4.1 7c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2 .1c.2 .1 .5 .3 .9 .5c.8 .5 2 1.2 3.4 2.1c2.8 1.9 6.5 4.5 10.2 7.6c3.7 3.1 7.2 6.6 9.6 10.1c2.5 3.5 3.5 6.4 3.5 8.6s-1 5-3.5 8.6c-2.5 3.5-5.9 6.9-9.6 10.1c-3.7 3.1-7.4 5.7-10.2 7.6c-1.4 .9-2.6 1.6-3.4 2.1c-.4 .2-.7 .4-.9 .5l-.2 .1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-3.2 1.8-4.7 5.5-3.8 9s4.1 6 7.7 6c17.4 0 34.7-4.9 47.9-12.3c6.6-3.7 12.5-8.2 16.7-13.4c4.3-5.1 7.3-11.4 7.3-18.3s-3.1-13.2-7.3-18.3c-4.3-5.2-10.1-9.7-16.7-13.4c-2.7-1.5-5.7-3-8.7-4.3c3.1-1.3 6-2.7 8.7-4.3c6.6-3.7 12.5-8.2 16.7-13.4c4.3-5.1 7.3-11.4 7.3-18.3zM176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm159.3-20c10.6 0 19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C375.7 186.8 355 180 335.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9c5.5-5.8 14.8-9.7 25.4-9.7zM434 352.3c-6-23.2-28.8-37-51.1-30.8s-35.4 30.1-29.5 53.4l22.9 89.3c2.2 8.7 11.2 13.9 19.8 11.4l84.9-23.8c22.2-6.2 35.4-30.1 29.5-53.4s-28.8-37-51.1-30.8l-20.2 5.6-5.4-21z"
    ]
};
const $7435a4b2c8a749a5$export$ebba617701dfb917 = $7435a4b2c8a749a5$export$611ae61f02de0aa;
const $7435a4b2c8a749a5$export$3e4892d8bf919edd = {
    prefix: 'far',
    iconName: 'star-half-stroke',
    icon: [
        576,
        512,
        [
            "star-half-alt"
        ],
        "f5c0",
        "M309.5 13.5C305.5 5.2 297.1 0 287.9 0s-17.6 5.2-21.6 13.5L197.7 154.8 44.5 177.5c-9 1.3-16.5 7.6-19.3 16.3s-.5 18.1 5.9 24.5L142.2 328.4 116 483.9c-1.5 9 2.2 18.1 9.7 23.5s17.3 6 25.3 1.7l137-73.2 137 73.2c8.1 4.3 17.9 3.7 25.3-1.7s11.2-14.5 9.7-23.5L433.6 328.4 544.8 218.2c6.5-6.4 8.7-15.9 5.9-24.5s-10.3-14.9-19.3-16.3L378.1 154.8 309.5 13.5zM288 384.7l0-305.6 52.5 108.1c3.5 7.1 10.2 12.1 18.1 13.3l118.3 17.5L391 303c-5.5 5.5-8.1 13.3-6.8 21l20.2 119.6L299.2 387.5c-3.5-1.9-7.4-2.8-11.2-2.8z"
    ]
};
const $7435a4b2c8a749a5$export$c13575f42532efb3 = $7435a4b2c8a749a5$export$3e4892d8bf919edd;
const $7435a4b2c8a749a5$export$77cb1a465c4fe84 = {
    prefix: 'far',
    iconName: 'file-excel',
    icon: [
        384,
        512,
        [],
        "f1c3",
        "M48 448L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm90.9 233.3c-8.1-10.5-23.2-12.3-33.7-4.2s-12.3 23.2-4.2 33.7L161.6 320l-44.5 57.3c-8.1 10.5-6.3 25.5 4.2 33.7s25.5 6.3 33.7-4.2L192 359.1l37.1 47.6c8.1 10.5 23.2 12.3 33.7 4.2s12.3-23.2 4.2-33.7L222.4 320l44.5-57.3c8.1-10.5 6.3-25.5-4.2-33.7s-25.5-6.3-33.7 4.2L192 280.9l-37.1-47.6z"
    ]
};
const $7435a4b2c8a749a5$export$3de52eeb00462407 = {
    prefix: 'far',
    iconName: 'face-grin-beam',
    icon: [
        512,
        512,
        [
            128516,
            "grin-beam"
        ],
        "f582",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM217.6 228.8s0 0 0 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0zm160 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0z"
    ]
};
const $7435a4b2c8a749a5$export$734da5249381ec7e = $7435a4b2c8a749a5$export$3de52eeb00462407;
const $7435a4b2c8a749a5$export$887f6345573abcac = {
    prefix: 'far',
    iconName: 'object-ungroup',
    icon: [
        640,
        512,
        [],
        "f248",
        "M48.2 66.8c-.1-.8-.2-1.7-.2-2.5l0-.2c0-8.8 7.2-16 16-16c.9 0 1.9 .1 2.8 .2C74.3 49.5 80 56.1 80 64c0 8.8-7.2 16-16 16c-7.9 0-14.5-5.7-15.8-13.2zM0 64c0 26.9 16.5 49.9 40 59.3l0 105.3C16.5 238.1 0 261.1 0 288c0 35.3 28.7 64 64 64c26.9 0 49.9-16.5 59.3-40l201.3 0c9.5 23.5 32.5 40 59.3 40c35.3 0 64-28.7 64-64c0-26.9-16.5-49.9-40-59.3l0-105.3c23.5-9.5 40-32.5 40-59.3c0-35.3-28.7-64-64-64c-26.9 0-49.9 16.5-59.3 40L123.3 40C113.9 16.5 90.9 0 64 0C28.7 0 0 28.7 0 64zm368 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM324.7 88c6.5 16 19.3 28.9 35.3 35.3l0 105.3c-16 6.5-28.9 19.3-35.3 35.3l-201.3 0c-6.5-16-19.3-28.9-35.3-35.3l0-105.3c16-6.5 28.9-19.3 35.3-35.3l201.3 0zM384 272a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM80 288c0 7.9-5.7 14.5-13.2 15.8c-.8 .1-1.7 .2-2.5 .2l-.2 0c-8.8 0-16-7.2-16-16c0-.9 .1-1.9 .2-2.8C49.5 277.7 56.1 272 64 272c8.8 0 16 7.2 16 16zm391.3-40l45.4 0c6.5 16 19.3 28.9 35.3 35.3l0 105.3c-16 6.5-28.9 19.3-35.3 35.3l-201.3 0c-6.5-16-19.3-28.9-35.3-35.3l0-36.7-48 0 0 36.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64c26.9 0 49.9-16.5 59.3-40l201.3 0c9.5 23.5 32.5 40 59.3 40c35.3 0 64-28.7 64-64c0-26.9-16.5-49.9-40-59.3l0-105.3c23.5-9.5 40-32.5 40-59.3c0-35.3-28.7-64-64-64c-26.9 0-49.9 16.5-59.3 40L448 200l0 16.4c9.8 8.8 17.8 19.5 23.3 31.6zm88.9-26.7a16 16 0 1 1 31.5 5.5 16 16 0 1 1 -31.5-5.5zM271.8 450.7a16 16 0 1 1 -31.5-5.5 16 16 0 1 1 31.5 5.5zm307-18.5a16 16 0 1 1 -5.5 31.5 16 16 0 1 1 5.5-31.5z"
    ]
};
const $7435a4b2c8a749a5$export$1fec48c8bdd69c1d = {
    prefix: 'far',
    iconName: 'circle-right',
    icon: [
        512,
        512,
        [
            61838,
            "arrow-alt-circle-right"
        ],
        "f35a",
        "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM294.6 151.2c-4.2-4.6-10.1-7.2-16.4-7.2C266 144 256 154 256 166.3l0 41.7-96 0c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l96 0 0 41.7c0 12.3 10 22.3 22.3 22.3c6.2 0 12.1-2.6 16.4-7.2l84-91c3.5-3.8 5.4-8.7 5.4-13.9s-1.9-10.1-5.4-13.9l-84-91z"
    ]
};
const $7435a4b2c8a749a5$export$88962ffdad8b856d = $7435a4b2c8a749a5$export$1fec48c8bdd69c1d;
const $7435a4b2c8a749a5$export$a6d72a9a068392b5 = {
    prefix: 'far',
    iconName: 'face-rolling-eyes',
    icon: [
        512,
        512,
        [
            128580,
            "meh-rolling-eyes"
        ],
        "f5a5",
        "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM168 376c0 13.3 10.7 24 24 24l128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-128 0c-13.3 0-24 10.7-24 24zm-8-104c-26.5 0-48-21.5-48-48c0-14.3 6.3-27.2 16.2-36c-.2 1.3-.2 2.6-.2 4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1.4-.1-2.7-.2-4c10 8.8 16.2 21.7 16.2 36c0 26.5-21.5 48-48 48zm0 32a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm192-32c-26.5 0-48-21.5-48-48c0-14.3 6.3-27.2 16.2-36c-.2 1.3-.2 2.6-.2 4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1.4-.1-2.7-.2-4c10 8.8 16.2 21.7 16.2 36c0 26.5-21.5 48-48 48zm0 32a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"
    ]
};
const $7435a4b2c8a749a5$export$fdc62a1bea767cc2 = $7435a4b2c8a749a5$export$a6d72a9a068392b5;
const $7435a4b2c8a749a5$export$40cdac24aa94a57a = {
    prefix: 'far',
    iconName: 'object-group',
    icon: [
        576,
        512,
        [],
        "f247",
        "M48 115.8C38.2 107 32 94.2 32 80c0-26.5 21.5-48 48-48c14.2 0 27 6.2 35.8 16l344.4 0c8.8-9.8 21.6-16 35.8-16c26.5 0 48 21.5 48 48c0 14.2-6.2 27-16 35.8l0 280.4c9.8 8.8 16 21.6 16 35.8c0 26.5-21.5 48-48 48c-14.2 0-27-6.2-35.8-16l-344.4 0c-8.8 9.8-21.6 16-35.8 16c-26.5 0-48-21.5-48-48c0-14.2 6.2-27 16-35.8l0-280.4zM125.3 96c-4.8 13.6-15.6 24.4-29.3 29.3l0 261.5c13.6 4.8 24.4 15.6 29.3 29.3l325.5 0c4.8-13.6 15.6-24.4 29.3-29.3l0-261.5c-13.6-4.8-24.4-15.6-29.3-29.3L125.3 96zm2.7 64c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-96zM256 320l32 0c35.3 0 64-28.7 64-64l0-32 64 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-32z"
    ]
};
const $7435a4b2c8a749a5$export$e4b51a47a2f8b9db = {
    prefix: 'far',
    iconName: 'heart',
    icon: [
        512,
        512,
        [
            128153,
            128154,
            128155,
            128156,
            128420,
            129293,
            129294,
            129505,
            9829,
            10084,
            61578
        ],
        "f004",
        "M225.8 468.2l-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8l0-3.3c0-70.4 50-130.8 119.2-144C158.6 37.9 198.9 47 231 69.6c9 6.4 17.4 13.8 25 22.3c4.2-4.8 8.7-9.2 13.5-13.3c3.7-3.2 7.5-6.2 11.5-9c0 0 0 0 0 0C313.1 47 353.4 37.9 392.8 45.4C462 58.6 512 119.1 512 189.5l0 3.3c0 41.9-17.4 81.9-48.1 110.4L288.7 465.9l-2.5 2.3c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM239.1 145c-.4-.3-.7-.7-1-1.1l-17.8-20-.1-.1s0 0 0 0c-23.1-25.9-58-37.7-92-31.2C81.6 101.5 48 142.1 48 189.5l0 3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7 431.2 268c20.9-19.4 32.8-46.7 32.8-75.2l0-3.3c0-47.3-33.6-88-80.1-96.9c-34-6.5-69 5.4-92 31.2c0 0 0 0-.1 .1s0 0-.1 .1l-17.8 20c-.3 .4-.7 .7-1 1.1c-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7z"
    ]
};
const $7435a4b2c8a749a5$export$c938968e28178994 = {
    prefix: 'far',
    iconName: 'face-surprise',
    icon: [
        512,
        512,
        [
            128558,
            "surprise"
        ],
        "f5c2",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM256 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
    ]
};
const $7435a4b2c8a749a5$export$46647c72213f53ba = $7435a4b2c8a749a5$export$c938968e28178994;
const $7435a4b2c8a749a5$export$fbeef2513e05ad08 = {
    prefix: 'far',
    iconName: 'circle-pause',
    icon: [
        512,
        512,
        [
            62092,
            "pause-circle"
        ],
        "f28b",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm224-72l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144c0-13.3 10.7-24 24-24s24 10.7 24 24zm112 0l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
const $7435a4b2c8a749a5$export$d8cf08a0362da8db = $7435a4b2c8a749a5$export$fbeef2513e05ad08;
const $7435a4b2c8a749a5$export$4280b2387fbdad12 = {
    prefix: 'far',
    iconName: 'circle',
    icon: [
        512,
        512,
        [
            128308,
            128309,
            128992,
            128993,
            128994,
            128995,
            128996,
            9679,
            9898,
            9899,
            11044,
            61708,
            61915
        ],
        "f111",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
    ]
};
const $7435a4b2c8a749a5$export$72ea8a5e4e86cd69 = {
    prefix: 'far',
    iconName: 'circle-up',
    icon: [
        512,
        512,
        [
            61467,
            "arrow-alt-circle-up"
        ],
        "f35b",
        "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM151.2 217.4c-4.6 4.2-7.2 10.1-7.2 16.4c0 12.3 10 22.3 22.3 22.3l41.7 0 0 96c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-96 41.7 0c12.3 0 22.3-10 22.3-22.3c0-6.2-2.6-12.1-7.2-16.4l-91-84c-3.8-3.5-8.7-5.4-13.9-5.4s-10.1 1.9-13.9 5.4l-91 84z"
    ]
};
const $7435a4b2c8a749a5$export$3747a8ef0995eadf = $7435a4b2c8a749a5$export$72ea8a5e4e86cd69;
const $7435a4b2c8a749a5$export$b8d24c57c9e64933 = {
    prefix: 'far',
    iconName: 'file-audio',
    icon: [
        384,
        512,
        [],
        "f1c7",
        "M64 464l256 0c8.8 0 16-7.2 16-16l0-288-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM192 272l0 128c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5L129.4 376 112 376c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16l17.4 0 35.3-35.3c4.6-4.6 11.5-5.9 17.4-3.5s9.9 8.3 9.9 14.8zm85.8-4c11.6 20 18.2 43.3 18.2 68s-6.6 48-18.2 68c-6.6 11.5-21.3 15.4-32.8 8.8s-15.4-21.3-8.8-32.8c7.5-12.9 11.8-27.9 11.8-44s-4.3-31.1-11.8-44c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8z"
    ]
};
const $7435a4b2c8a749a5$export$6440b286d3cbac9b = {
    prefix: 'far',
    iconName: 'file-image',
    icon: [
        384,
        512,
        [
            128443
        ],
        "f1c5",
        "M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm96 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm69.2 46.9c-3-4.3-7.9-6.9-13.2-6.9s-10.2 2.6-13.2 6.9l-41.3 59.7-11.9-19.1c-2.9-4.7-8.1-7.5-13.6-7.5s-10.6 2.8-13.6 7.5l-40 64c-3.1 4.9-3.2 11.1-.4 16.2s8.2 8.2 14 8.2l48 0 32 0 40 0 72 0c6 0 11.4-3.3 14.2-8.6s2.4-11.6-1-16.5l-72-104z"
    ]
};
const $7435a4b2c8a749a5$export$d7cf0978afd90002 = {
    prefix: 'far',
    iconName: 'circle-question',
    icon: [
        512,
        512,
        [
            62108,
            "question-circle"
        ],
        "f059",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
const $7435a4b2c8a749a5$export$5ba67d7f2265c1a5 = $7435a4b2c8a749a5$export$d7cf0978afd90002;
const $7435a4b2c8a749a5$export$38c072b870a9e4ab = {
    prefix: 'far',
    iconName: 'face-meh-blank',
    icon: [
        512,
        512,
        [
            128566,
            "meh-blank"
        ],
        "f5a4",
        "M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zM512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $7435a4b2c8a749a5$export$e945435725f71e88 = $7435a4b2c8a749a5$export$38c072b870a9e4ab;
const $7435a4b2c8a749a5$export$b8c3e79e8c99c95b = {
    prefix: 'far',
    iconName: 'eye',
    icon: [
        576,
        512,
        [
            128065
        ],
        "f06e",
        "M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z"
    ]
};
const $7435a4b2c8a749a5$export$e8ea88c55e55be7c = {
    prefix: 'far',
    iconName: 'face-sad-cry',
    icon: [
        512,
        512,
        [
            128557,
            "sad-cry"
        ],
        "f5b3",
        "M400 406.1L400 288c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 152.6c-28.7 15-61.4 23.4-96 23.4s-67.3-8.5-96-23.4L160 288c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 118.1C72.6 368.2 48 315 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 59-24.6 112.2-64 150.1zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM159.6 220c10.6 0 19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C199.7 186.8 179 180 159.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9c5.5-5.8 14.8-9.7 25.4-9.7zm166.6 9.7c5.5-5.8 14.8-9.7 25.4-9.7s19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C391.7 186.8 371 180 351.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9zM208 320l0 32c0 26.5 21.5 48 48 48s48-21.5 48-48l0-32c0-26.5-21.5-48-48-48s-48 21.5-48 48z"
    ]
};
const $7435a4b2c8a749a5$export$8e924e6bd422cef9 = $7435a4b2c8a749a5$export$e8ea88c55e55be7c;
const $7435a4b2c8a749a5$export$143d0ca7d2200f20 = {
    prefix: 'far',
    iconName: 'file-code',
    icon: [
        384,
        512,
        [],
        "f1c9",
        "M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm97 289c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L79 303c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-31-31 31-31zM257 255c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9l-48-48z"
    ]
};
const $7435a4b2c8a749a5$export$703cd98be31ec905 = {
    prefix: 'far',
    iconName: 'window-maximize',
    icon: [
        512,
        512,
        [
            128470
        ],
        "f2d0",
        "M.3 89.5C.1 91.6 0 93.8 0 96L0 224 0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-192 0-128c0-35.3-28.7-64-64-64L64 32c-2.2 0-4.4 .1-6.5 .3c-9.2 .9-17.8 3.8-25.5 8.2C21.8 46.5 13.4 55.1 7.7 65.5c-3.9 7.3-6.5 15.4-7.4 24zM48 224l416 0 0 192c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-192z"
    ]
};
const $7435a4b2c8a749a5$export$e5f78e87efbb0248 = {
    prefix: 'far',
    iconName: 'face-frown',
    icon: [
        512,
        512,
        [
            9785,
            "frown"
        ],
        "f119",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM174.6 384.1c-4.5 12.5-18.2 18.9-30.7 14.4s-18.9-18.2-14.4-30.7C146.9 319.4 198.9 288 256 288s109.1 31.4 126.6 79.9c4.5 12.5-2 26.2-14.4 30.7s-26.2-2-30.7-14.4C328.2 358.5 297.2 336 256 336s-72.2 22.5-81.4 48.1zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $7435a4b2c8a749a5$export$43b7108508aecc5f = $7435a4b2c8a749a5$export$e5f78e87efbb0248;
const $7435a4b2c8a749a5$export$f62f2879ccaea13f = {
    prefix: 'far',
    iconName: 'floppy-disk',
    icon: [
        448,
        512,
        [
            128190,
            128426,
            "save"
        ],
        "f0c7",
        "M48 96l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-245.5c0-4.2-1.7-8.3-4.7-11.3l33.9-33.9c12 12 18.7 28.3 18.7 45.3L448 416c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l245.5 0c17 0 33.3 6.7 45.3 18.7l74.5 74.5-33.9 33.9L320.8 84.7c-.3-.3-.5-.5-.8-.8L320 184c0 13.3-10.7 24-24 24l-192 0c-13.3 0-24-10.7-24-24L80 80 64 80c-8.8 0-16 7.2-16 16zm80-16l0 80 144 0 0-80L128 80zm32 240a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"
    ]
};
const $7435a4b2c8a749a5$export$1aaa83ff70706e1e = $7435a4b2c8a749a5$export$f62f2879ccaea13f;
const $7435a4b2c8a749a5$export$63ffcb3d4e94cb92 = {
    prefix: 'far',
    iconName: 'comment-dots',
    icon: [
        512,
        512,
        [
            128172,
            62075,
            "commenting"
        ],
        "f4ad",
        "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM144 272a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm144-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm80 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
const $7435a4b2c8a749a5$export$49ee382a2425e89c = $7435a4b2c8a749a5$export$63ffcb3d4e94cb92;
const $7435a4b2c8a749a5$export$5d53da7627754bc6 = {
    prefix: 'far',
    iconName: 'face-grin-squint',
    icon: [
        512,
        512,
        [
            128518,
            "grin-squint"
        ],
        "f585",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zm-216-161.7l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
    ]
};
const $7435a4b2c8a749a5$export$243ae757907b1580 = $7435a4b2c8a749a5$export$5d53da7627754bc6;
const $7435a4b2c8a749a5$export$d97ff927c450c87f = {
    prefix: 'far',
    iconName: 'hand-pointer',
    icon: [
        448,
        512,
        [],
        "f25a",
        "M160 64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 136c0 10.3 6.6 19.5 16.4 22.8s20.6-.1 26.8-8.3c3-3.9 7.6-6.4 12.8-6.4c8.8 0 16 7.2 16 16c0 10.3 6.6 19.5 16.4 22.8s20.6-.1 26.8-8.3c3-3.9 7.6-6.4 12.8-6.4c7.8 0 14.3 5.6 15.7 13c1.6 8.2 7.3 15.1 15.1 18s16.7 1.6 23.3-3.6c2.7-2.1 6.1-3.4 9.9-3.4c8.8 0 16 7.2 16 16l0 16 0 104c0 39.8-32.2 72-72 72l-56 0-59.8 0-.9 0c-37.4 0-72.4-18.7-93.2-49.9L50.7 312.9c-4.9-7.4-2.9-17.3 4.4-22.2s17.3-2.9 22.2 4.4L116 353.2c5.9 8.8 16.8 12.7 26.9 9.7s17-12.4 17-23l0-19.9 0-256zM176 0c-35.3 0-64 28.7-64 64l0 197.7C91.2 238 55.5 232.8 28.5 250.7C-.9 270.4-8.9 310.1 10.8 339.5L78.3 440.8c29.7 44.5 79.6 71.2 133.1 71.2l.9 0 59.8 0 56 0c66.3 0 120-53.7 120-120l0-104 0-16c0-35.3-28.7-64-64-64c-4.5 0-8.8 .5-13 1.3c-11.7-15.4-30.2-25.3-51-25.3c-6.9 0-13.5 1.1-19.7 3.1C288.7 170.7 269.6 160 248 160c-2.7 0-5.4 .2-8 .5L240 64c0-35.3-28.7-64-64-64zm48 304c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96zm48-16c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-8.8-7.2-16-16-16zm80 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96z"
    ]
};
const $7435a4b2c8a749a5$export$c578e919f2c5c135 = {
    prefix: 'far',
    iconName: 'hand-scissors',
    icon: [
        512,
        512,
        [],
        "f257",
        "M.2 276.3c-1.2-35.3 26.4-65 61.7-66.2l3.3-.1L57 208.1C22.5 200.5 .7 166.3 8.3 131.8S50.2 75.5 84.7 83.2l173 38.3c2.3-2.9 4.7-5.7 7.1-8.5l18.4-20.3C299.9 74.5 323.5 64 348.3 64l10.2 0c54.1 0 104.1 28.7 131.3 75.4l1.5 2.6c13.6 23.2 20.7 49.7 20.7 76.6L512 344c0 66.3-53.7 120-120 120l-8 0-96 0c-35.3 0-64-28.7-64-64c0-2.8 .2-5.6 .5-8.3c-19.4-11-32.5-31.8-32.5-55.7c0-.8 0-1.6 0-2.4L66.4 338c-35.3 1.2-65-26.4-66.2-61.7zm63.4-18.2c-8.8 .3-15.7 7.7-15.4 16.5s7.7 15.7 16.5 15.4l161.5-5.6c9.8-.3 18.7 5.3 22.7 14.2s2.2 19.3-4.5 26.4c-2.8 2.9-4.4 6.7-4.4 11c0 8.8 7.2 16 16 16c9.1 0 17.4 5.1 21.5 13.3s3.2 17.9-2.3 25.1c-2 2.7-3.2 6-3.2 9.6c0 8.8 7.2 16 16 16l96 0 8 0c39.8 0 72-32.2 72-72l0-125.4c0-18.4-4.9-36.5-14.2-52.4l-1.5-2.6c-18.6-32-52.8-51.6-89.8-51.6l-10.2 0c-11.3 0-22 4.8-29.6 13.1l-17.5-15.9 17.5 15.9-18.4 20.3c-.6 .6-1.1 1.3-1.7 1.9l57 13.2c8.6 2 14 10.6 12 19.2s-10.6 14-19.2 12l-85.6-19.7L74.3 130c-8.6-1.9-17.2 3.5-19.1 12.2s3.5 17.2 12.2 19.1l187.5 41.6c10.2 2.3 17.8 10.9 18.7 21.4l.1 1c.6 6.6-1.5 13.1-5.8 18.1s-10.6 7.9-17.2 8.2L63.6 258.1z"
    ]
};
const $7435a4b2c8a749a5$export$8ac6d81a3d5b40a1 = {
    prefix: 'far',
    iconName: 'face-grin-tears',
    icon: [
        640,
        512,
        [
            128514,
            "grin-tears"
        ],
        "f588",
        "M516.1 325.5c1 3 2.1 6 3.3 8.9c3.3 8.1 8.4 18.5 16.5 26.6c3.9 3.9 8.2 7.4 12.7 10.3C506.4 454.8 419.9 512 320 512s-186.4-57.2-228.6-140.6c4.5-2.9 8.7-6.3 12.7-10.3c8.1-8.1 13.2-18.6 16.5-26.6c1.2-2.9 2.3-5.9 3.3-8.9C152.5 406.2 229.5 464 320 464s167.5-57.8 196.1-138.5zM320 48c-101.4 0-185.8 72.5-204.3 168.5c-6.7-3.1-14.3-4.3-22.3-3.1c-6.8 .9-16.2 2.4-26.6 4.4C85.3 94.5 191.6 0 320 0S554.7 94.5 573.2 217.7c-10.3-2-19.8-3.5-26.6-4.4c-8-1.2-15.7 .1-22.3 3.1C505.8 120.5 421.4 48 320 48zM78.5 341.1C60 356.7 32 355.5 14.3 337.7c-18.7-18.7-19.1-48.8-.7-67.2c8.6-8.6 30.1-15.1 50.5-19.6c13-2.8 25.5-4.8 33.9-6c5.4-.8 9.9 3.7 9 9c-3.1 21.5-11.4 70.2-25.5 84.4c-.9 1-1.9 1.8-2.9 2.7zm483 0c-.8-.6-1.5-1.3-2.3-2c-.2-.2-.5-.4-.7-.7c-14.1-14.1-22.5-62.9-25.5-84.4c-.8-5.4 3.7-9.9 9-9c1 .1 2.2 .3 3.3 .5c8.2 1.2 19.2 3 30.6 5.5c20.4 4.4 41.9 10.9 50.5 19.6c18.4 18.4 18 48.5-.7 67.2c-17.7 17.7-45.7 19-64.2 3.4zM439 336.5C414.4 374.6 370.3 400 319.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5c18.7-4.4 35.9 12 25.5 28.1zM281.6 228.8c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0zm160 0s0 0 0 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0z"
    ]
};
const $7435a4b2c8a749a5$export$b2f7512221512b5b = $7435a4b2c8a749a5$export$8ac6d81a3d5b40a1;
const $7435a4b2c8a749a5$export$3c70ffe5660af060 = {
    prefix: 'far',
    iconName: 'calendar-xmark',
    icon: [
        448,
        512,
        [
            "calendar-times"
        ],
        "f273",
        "M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zM400 192L48 192l0 256c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-256zm-95 89l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    ]
};
const $7435a4b2c8a749a5$export$99b20d7352fbcf08 = $7435a4b2c8a749a5$export$3c70ffe5660af060;
const $7435a4b2c8a749a5$export$b44eb38345c6a964 = {
    prefix: 'far',
    iconName: 'file-video',
    icon: [
        384,
        512,
        [],
        "f1c8",
        "M320 464c8.8 0 16-7.2 16-16l0-288-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l256 0zM0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM80 288c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32l0 16 44.9-29.9c2-1.3 4.4-2.1 6.8-2.1c6.8 0 12.3 5.5 12.3 12.3l0 103.4c0 6.8-5.5 12.3-12.3 12.3c-2.4 0-4.8-.7-6.8-2.1L240 368l0 16c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32l0-96z"
    ]
};
const $7435a4b2c8a749a5$export$38611f1c776aba73 = {
    prefix: 'far',
    iconName: 'file-pdf',
    icon: [
        512,
        512,
        [],
        "f1c1",
        "M64 464l48 0 0 48-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z"
    ]
};
const $7435a4b2c8a749a5$export$805cd88398a70581 = {
    prefix: 'far',
    iconName: 'comment',
    icon: [
        512,
        512,
        [
            128489,
            61669
        ],
        "f075",
        "M123.6 391.3c12.9-9.4 29.6-11.8 44.6-6.4c26.5 9.6 56.2 15.1 87.8 15.1c124.7 0 208-80.5 208-160s-83.3-160-208-160S48 160.5 48 240c0 32 12.4 62.8 35.7 89.2c8.6 9.7 12.8 22.5 11.8 35.5c-1.4 18.1-5.7 34.7-11.3 49.4c17-7.9 31.1-16.7 39.4-22.7zM21.2 431.9c1.8-2.7 3.5-5.4 5.1-8.1c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208s-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6c-15.1 6.6-32.3 12.6-50.1 16.1c-.8 .2-1.6 .3-2.4 .5c-4.4 .8-8.7 1.5-13.2 1.9c-.2 0-.5 .1-.7 .1c-5.1 .5-10.2 .8-15.3 .8c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4c4.1-4.2 7.8-8.7 11.3-13.5c1.7-2.3 3.3-4.6 4.8-6.9l.3-.5z"
    ]
};
const $7435a4b2c8a749a5$export$6f095630677adc = {
    prefix: 'far',
    iconName: 'envelope',
    icon: [
        512,
        512,
        [
            128386,
            9993,
            61443
        ],
        "f0e0",
        "M64 112c-8.8 0-16 7.2-16 16l0 22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1l0-22.1c0-8.8-7.2-16-16-16L64 112zM48 212.2L48 384c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-171.8L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64l384 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128z"
    ]
};
const $7435a4b2c8a749a5$export$b9098a890f61e022 = {
    prefix: 'far',
    iconName: 'hourglass',
    icon: [
        384,
        512,
        [
            9203,
            62032,
            "hourglass-empty"
        ],
        "f254",
        "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l8 0 0 19c0 40.3 16 79 44.5 107.5L158.1 256 76.5 337.5C48 366 32 404.7 32 445l0 19-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l336 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-19c0-40.3-16-79-44.5-107.5L225.9 256l81.5-81.5C336 146 352 107.3 352 67l0-19 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 0zM192 289.9l81.5 81.5C293 391 304 417.4 304 445l0 19L80 464l0-19c0-27.6 11-54 30.5-73.5L192 289.9zm0-67.9l-81.5-81.5C91 121 80 94.6 80 67l0-19 224 0 0 19c0 27.6-11 54-30.5 73.5L192 222.1z"
    ]
};
const $7435a4b2c8a749a5$export$a2f8176a0161e891 = $7435a4b2c8a749a5$export$b9098a890f61e022;
const $7435a4b2c8a749a5$export$5655108e1162ba45 = {
    prefix: 'far',
    iconName: 'calendar-check',
    icon: [
        448,
        512,
        [],
        "f274",
        "M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zM400 192L48 192l0 256c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-256zM329 297L217 409c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 95-95c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    ]
};
const $7435a4b2c8a749a5$export$4cb736b866cbb7ec = {
    prefix: 'far',
    iconName: 'hard-drive',
    icon: [
        512,
        512,
        [
            128436,
            "hdd"
        ],
        "f0a0",
        "M64 80c-8.8 0-16 7.2-16 16l0 162c5.1-1.3 10.5-2 16-2l384 0c5.5 0 10.9 .7 16 2l0-162c0-8.8-7.2-16-16-16L64 80zM48 320l0 96c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16L64 304c-8.8 0-16 7.2-16 16zM0 320L0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 224 0 96c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64l0-96zm280 48a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
const $7435a4b2c8a749a5$export$62551e9c5ba7093f = $7435a4b2c8a749a5$export$4cb736b866cbb7ec;
const $7435a4b2c8a749a5$export$8ff56f5ebb8416a0 = {
    prefix: 'far',
    iconName: 'face-grin-squint-tears',
    icon: [
        512,
        512,
        [
            129315,
            "grin-squint-tears"
        ],
        "f586",
        "M426.8 14.2C446-5 477.5-4.6 497.1 14.9s20 51 .7 70.3c-14.8 14.8-65.7 23.6-88.3 26.7c-5.6 .9-10.3-3.9-9.5-9.5C403.3 79.9 412 29 426.8 14.2zM75 75C158.2-8.3 284.5-22.2 382.2 33.2c-1.5 4.8-2.9 9.6-4.1 14.3c-3.1 12.2-5.5 24.6-7.3 35c-80.8-53.6-190.7-44.8-261.9 26.4C37.7 180.1 28.9 290 82.5 370.8c-10.5 1.8-22.9 4.2-35 7.3c-4.7 1.2-9.5 2.5-14.3 4.1C-22.2 284.5-8.2 158.2 75 75zm389.6 58.9c4.7-1.2 9.5-2.5 14.3-4.1C534.2 227.5 520.2 353.8 437 437c-83.2 83.2-209.5 97.2-307.2 41.8c1.5-4.8 2.8-9.6 4-14.3c3.1-12.2 5.5-24.6 7.3-35c80.8 53.6 190.7 44.8 261.9-26.4c71.2-71.2 80-181.1 26.4-261.9c10.5-1.8 22.9-4.2 35-7.3zm-105.4 93c10.1-16.3 33.9-16.9 37.9 1.9c9.5 44.4-3.7 93.5-39.3 129.1s-84.8 48.8-129.1 39.3c-18.7-4-18.2-27.8-1.9-37.9c25.2-15.7 50.2-35.4 73.6-58.8s43.1-48.4 58.8-73.6zM92 265.3l97.4-29.7c11.6-3.5 22.5 7.3 19 19l-29.7 97.4c-2.6 8.6-13.4 11.3-19.8 4.9c-2-2-3.2-4.6-3.4-7.3l-5.1-56.1-56.1-5.1c-2.8-.3-5.4-1.5-7.3-3.4c-6.3-6.3-3.6-17.2 4.9-19.8zm193-178.2c2 2 3.2 4.6 3.4 7.3l5.1 56.1 56.1 5.1c2.8 .3 5.4 1.5 7.3 3.4c6.3 6.3 3.6 17.2-4.9 19.8l-97.4 29.7c-11.6 3.5-22.5-7.3-19-19L265.3 92c2.6-8.6 13.4-11.3 19.8-4.9zM14.9 497.1c-19.6-19.6-20-51-.7-70.3C29 412 79.8 403.2 102.4 400.1c5.6-.9 10.3 3.9 9.5 9.5c-3.2 22.5-11.9 73.5-26.7 88.3C66 517 34.5 516.6 14.9 497.1z"
    ]
};
const $7435a4b2c8a749a5$export$542206d6a85f3b42 = $7435a4b2c8a749a5$export$8ff56f5ebb8416a0;
const $7435a4b2c8a749a5$export$1f7600fa9fdb3978 = {
    prefix: 'far',
    iconName: 'rectangle-list',
    icon: [
        576,
        512,
        [
            "list-alt"
        ],
        "f022",
        "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm96 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm104 0c0-13.3 10.7-24 24-24l224 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-224 0c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24l224 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-224 0c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24l224 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-224 0c-13.3 0-24-10.7-24-24zm-72-64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM96 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
const $7435a4b2c8a749a5$export$c6327a203ffc65a3 = $7435a4b2c8a749a5$export$1f7600fa9fdb3978;
const $7435a4b2c8a749a5$export$16768a660ae3ca9d = {
    prefix: 'far',
    iconName: 'calendar-plus',
    icon: [
        448,
        512,
        [],
        "f271",
        "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256zm176 40c-13.3 0-24 10.7-24 24l0 48-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0 0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-48c0-13.3-10.7-24-24-24z"
    ]
};
const $7435a4b2c8a749a5$export$5ae86b9da9cca3bd = {
    prefix: 'far',
    iconName: 'circle-left',
    icon: [
        512,
        512,
        [
            61840,
            "arrow-alt-circle-left"
        ],
        "f359",
        "M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM217.4 376.9c4.2 4.5 10.1 7.1 16.3 7.1c12.3 0 22.3-10 22.3-22.3l0-57.7 96 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-96 0 0-57.7c0-12.3-10-22.3-22.3-22.3c-6.2 0-12.1 2.6-16.3 7.1L117.5 242.2c-3.5 3.8-5.5 8.7-5.5 13.8s2 10.1 5.5 13.8l99.9 107.1z"
    ]
};
const $7435a4b2c8a749a5$export$5460a5b11a24996f = $7435a4b2c8a749a5$export$5ae86b9da9cca3bd;
const $7435a4b2c8a749a5$export$a312c7d58dd44a75 = {
    prefix: 'far',
    iconName: 'money-bill-1',
    icon: [
        576,
        512,
        [
            "money-bill-alt"
        ],
        "f3d1",
        "M112 112c0 35.3-28.7 64-64 64l0 160c35.3 0 64 28.7 64 64l352 0c0-35.3 28.7-64 64-64l0-160c-35.3 0-64-28.7-64-64l-352 0zM0 128C0 92.7 28.7 64 64 64l448 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zM176 256a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm80-48c0 8.8 7.2 16 16 16l0 64-8 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l24 0 24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-8 0 0-80c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16z"
    ]
};
const $7435a4b2c8a749a5$export$a35d573395884c3d = $7435a4b2c8a749a5$export$a312c7d58dd44a75;
const $7435a4b2c8a749a5$export$95b9968e7fceb821 = {
    prefix: 'far',
    iconName: 'clock',
    icon: [
        512,
        512,
        [
            128339,
            "clock-four"
        ],
        "f017",
        "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120l0 136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2 280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
    ]
};
const $7435a4b2c8a749a5$export$9a575facf1cab48f = $7435a4b2c8a749a5$export$95b9968e7fceb821;
const $7435a4b2c8a749a5$export$fb61df5d98785fa8 = {
    prefix: 'far',
    iconName: 'keyboard',
    icon: [
        576,
        512,
        [
            9000
        ],
        "f11c",
        "M64 112c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-256c0-8.8-7.2-16-16-16L64 112zM0 128C0 92.7 28.7 64 64 64l448 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zM176 320l224 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zm-72-72c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zm16-96l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zm16-96l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zm16-96l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zm16-96l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zm16-96l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16z"
    ]
};
const $7435a4b2c8a749a5$export$8e047801a8603af7 = {
    prefix: 'far',
    iconName: 'closed-captioning',
    icon: [
        576,
        512,
        [],
        "f20a",
        "M512 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l448 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM200 208c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48s21.5-48 48-48zm144 48c0-26.5 21.5-48 48-48c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48z"
    ]
};
const $7435a4b2c8a749a5$export$74f06b41ed2ca28a = {
    prefix: 'far',
    iconName: 'images',
    icon: [
        576,
        512,
        [],
        "f302",
        "M160 80l352 0c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16l-21.2 0L388.1 178.9c-4.4-6.8-12-10.9-20.1-10.9s-15.7 4.1-20.1 10.9l-52.2 79.8-12.4-16.9c-4.5-6.2-11.7-9.8-19.4-9.8s-14.8 3.6-19.4 9.8L175.6 336 160 336c-8.8 0-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16zM96 96l0 224c0 35.3 28.7 64 64 64l352 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L160 32c-35.3 0-64 28.7-64 64zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 344c0 75.1 60.9 136 136 136l320 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-320 0c-48.6 0-88-39.4-88-88l0-224zm208 24a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
const $7435a4b2c8a749a5$export$92292137ef3cf4c8 = {
    prefix: 'far',
    iconName: 'face-grin',
    icon: [
        512,
        512,
        [
            128512,
            "grin"
        ],
        "f580",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $7435a4b2c8a749a5$export$37e1f10b6de76621 = $7435a4b2c8a749a5$export$92292137ef3cf4c8;
const $7435a4b2c8a749a5$export$dc130582748497c6 = {
    prefix: 'far',
    iconName: 'face-meh',
    icon: [
        512,
        512,
        [
            128528,
            "meh"
        ],
        "f11a",
        "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM184 328c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z"
    ]
};
const $7435a4b2c8a749a5$export$6d2db489aaeeecd2 = $7435a4b2c8a749a5$export$dc130582748497c6;
const $7435a4b2c8a749a5$export$782ac893fc22249b = {
    prefix: 'far',
    iconName: 'id-card',
    icon: [
        576,
        512,
        [
            62147,
            "drivers-license"
        ],
        "f2c2",
        "M528 160l0 256c0 8.8-7.2 16-16 16l-192 0c0-44.2-35.8-80-80-80l-64 0c-44.2 0-80 35.8-80 80l-32 0c-8.8 0-16-7.2-16-16l0-256 480 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM272 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm104-48c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0z"
    ]
};
const $7435a4b2c8a749a5$export$8359c70e609eff64 = $7435a4b2c8a749a5$export$782ac893fc22249b;
const $7435a4b2c8a749a5$export$2fa35dcbc038dbe9 = {
    prefix: 'far',
    iconName: 'sun',
    icon: [
        512,
        512,
        [
            9728
        ],
        "f185",
        "M375.7 19.7c-1.5-8-6.9-14.7-14.4-17.8s-16.1-2.2-22.8 2.4L256 61.1 173.5 4.2c-6.7-4.6-15.3-5.5-22.8-2.4s-12.9 9.8-14.4 17.8l-18.1 98.5L19.7 136.3c-8 1.5-14.7 6.9-17.8 14.4s-2.2 16.1 2.4 22.8L61.1 256 4.2 338.5c-4.6 6.7-5.5 15.3-2.4 22.8s9.8 13 17.8 14.4l98.5 18.1 18.1 98.5c1.5 8 6.9 14.7 14.4 17.8s16.1 2.2 22.8-2.4L256 450.9l82.5 56.9c6.7 4.6 15.3 5.5 22.8 2.4s12.9-9.8 14.4-17.8l18.1-98.5 98.5-18.1c8-1.5 14.7-6.9 17.8-14.4s2.2-16.1-2.4-22.8L450.9 256l56.9-82.5c4.6-6.7 5.5-15.3 2.4-22.8s-9.8-12.9-17.8-14.4l-98.5-18.1L375.7 19.7zM269.6 110l65.6-45.2 14.4 78.3c1.8 9.8 9.5 17.5 19.3 19.3l78.3 14.4L402 242.4c-5.7 8.2-5.7 19 0 27.2l45.2 65.6-78.3 14.4c-9.8 1.8-17.5 9.5-19.3 19.3l-14.4 78.3L269.6 402c-8.2-5.7-19-5.7-27.2 0l-65.6 45.2-14.4-78.3c-1.8-9.8-9.5-17.5-19.3-19.3L64.8 335.2 110 269.6c5.7-8.2 5.7-19 0-27.2L64.8 176.8l78.3-14.4c9.8-1.8 17.5-9.5 19.3-19.3l14.4-78.3L242.4 110c8.2 5.7 19 5.7 27.2 0zM256 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM192 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"
    ]
};
const $7435a4b2c8a749a5$export$600a1b26b33c3d47 = {
    prefix: 'far',
    iconName: 'face-laugh-wink',
    icon: [
        512,
        512,
        [
            "laugh-wink"
        ],
        "f59c",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9l212.5 0c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm165.8 21.7c-7.6 8.1-20.2 8.5-28.3 .9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7s-19.9 3.8-25.4 9.7z"
    ]
};
const $7435a4b2c8a749a5$export$77ac40095f39933e = $7435a4b2c8a749a5$export$600a1b26b33c3d47;
const $7435a4b2c8a749a5$export$531badb89cf01312 = {
    prefix: 'far',
    iconName: 'circle-down',
    icon: [
        512,
        512,
        [
            61466,
            "arrow-alt-circle-down"
        ],
        "f358",
        "M256 464a208 208 0 1 1 0-416 208 208 0 1 1 0 416zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM376.9 294.6c4.5-4.2 7.1-10.1 7.1-16.3c0-12.3-10-22.3-22.3-22.3L304 256l0-96c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32l0 96-57.7 0C138 256 128 266 128 278.3c0 6.2 2.6 12.1 7.1 16.3l107.1 99.9c3.8 3.5 8.7 5.5 13.8 5.5s10.1-2 13.8-5.5l107.1-99.9z"
    ]
};
const $7435a4b2c8a749a5$export$ff3afbc8c0bc5d59 = $7435a4b2c8a749a5$export$531badb89cf01312;
const $7435a4b2c8a749a5$export$aba24ca305bbe8c1 = {
    prefix: 'far',
    iconName: 'thumbs-down',
    icon: [
        512,
        512,
        [
            128078,
            61576
        ],
        "f165",
        "M323.8 477.2c-38.2 10.9-78.1-11.2-89-49.4l-5.7-20c-3.7-13-10.4-25-19.5-35l-51.3-56.4c-8.9-9.8-8.2-25 1.6-33.9s25-8.2 33.9 1.6l51.3 56.4c14.1 15.5 24.4 34 30.1 54.1l5.7 20c3.6 12.7 16.9 20.1 29.7 16.5s20.1-16.9 16.5-29.7l-5.7-20c-5.7-19.9-14.7-38.7-26.6-55.5c-5.2-7.3-5.8-16.9-1.7-24.9s12.3-13 21.3-13L448 288c8.8 0 16-7.2 16-16c0-6.8-4.3-12.7-10.4-15c-7.4-2.8-13-9-14.9-16.7s.1-15.8 5.3-21.7c2.5-2.8 4-6.5 4-10.6c0-7.8-5.6-14.3-13-15.7c-8.2-1.6-15.1-7.3-18-15.2s-1.6-16.7 3.6-23.3c2.1-2.7 3.4-6.1 3.4-9.9c0-6.7-4.2-12.6-10.2-14.9c-11.5-4.5-17.7-16.9-14.4-28.8c.4-1.3 .6-2.8 .6-4.3c0-8.8-7.2-16-16-16l-97.5 0c-12.6 0-25 3.7-35.5 10.7l-61.7 41.1c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l61.7-41.1c18.4-12.3 40-18.8 62.1-18.8L384 32c34.7 0 62.9 27.6 64 62c14.6 11.7 24 29.7 24 50c0 4.5-.5 8.8-1.3 13c15.4 11.7 25.3 30.2 25.3 51c0 6.5-1 12.8-2.8 18.7C504.8 238.3 512 254.3 512 272c0 35.3-28.6 64-64 64l-92.3 0c4.7 10.4 8.7 21.2 11.8 32.2l5.7 20c10.9 38.2-11.2 78.1-49.4 89zM32 384c-17.7 0-32-14.3-32-32L0 128c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 224c0 17.7-14.3 32-32 32l-64 0z"
    ]
};
const $7435a4b2c8a749a5$export$3db75d5ac9e98468 = {
    prefix: 'far',
    iconName: 'chess-pawn',
    icon: [
        320,
        512,
        [
            9823
        ],
        "f443",
        "M232 152A72 72 0 1 0 88 152a72 72 0 1 0 144 0zm24 120l-12.6 0 10.7 80-48.4 0L195 272l-35 0-35 0-10.7 80-48.4 0 10.7-80L64 272c-13.3 0-24-10.7-24-24s10.7-24 24-24c-15.1-20.1-24-45-24-72C40 85.7 93.7 32 160 32s120 53.7 120 120c0 27-8.9 51.9-24 72c13.3 0 24 10.7 24 24s-10.7 24-24 24zM52.7 464l214.7 0-16.6-32L69.2 432 52.7 464zm207.9-80c12 0 22.9 6.7 28.4 17.3l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7c0 22.5-18.2 40.8-40.8 40.8L40.8 512C18.2 512 0 493.8 0 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2C36.5 390.7 47.5 384 59.5 384l201 0z"
    ]
};
const $7435a4b2c8a749a5$export$3e7437bf6535bef0 = {
    prefix: 'far',
    iconName: 'credit-card',
    icon: [
        576,
        512,
        [
            128179,
            62083,
            "credit-card-alt"
        ],
        "f09d",
        "M512 80c8.8 0 16 7.2 16 16l0 32L48 128l0-32c0-8.8 7.2-16 16-16l448 0zm16 144l0 192c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-192 480 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm56 304c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0zm128 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0z"
    ]
};
const $7435a4b2c8a749a5$export$5fffe8e3c36964a2 = $7435a4b2c8a749a5$export$3e7437bf6535bef0;
const $7435a4b2c8a749a5$export$9b6162797ab1b255 = {
    prefix: 'far',
    iconName: 'bell',
    icon: [
        448,
        512,
        [
            128276,
            61602
        ],
        "f0f3",
        "M224 0c-17.7 0-32 14.3-32 32l0 19.2C119 66 64 130.6 64 208l0 25.4c0 45.4-15.5 89.5-43.8 124.9L5.3 377c-5.8 7.2-6.9 17.1-2.9 25.4S14.8 416 24 416l400 0c9.2 0 17.6-5.3 21.6-13.6s2.9-18.2-2.9-25.4l-14.9-18.6C399.5 322.9 384 278.8 384 233.4l0-25.4c0-77.4-55-142-128-156.8L256 32c0-17.7-14.3-32-32-32zm0 96c61.9 0 112 50.1 112 112l0 25.4c0 47.9 13.9 94.6 39.7 134.6L72.3 368C98.1 328 112 281.3 112 233.4l0-25.4c0-61.9 50.1-112 112-112zm64 352l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z"
    ]
};
const $7435a4b2c8a749a5$export$cad54bead856a678 = {
    prefix: 'far',
    iconName: 'file',
    icon: [
        384,
        512,
        [
            128196,
            128459,
            61462
        ],
        "f15b",
        "M320 464c8.8 0 16-7.2 16-16l0-288-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l256 0zM0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64z"
    ]
};
const $7435a4b2c8a749a5$export$7a76c9d35b42d691 = {
    prefix: 'far',
    iconName: 'hospital',
    icon: [
        640,
        512,
        [
            127973,
            62589,
            "hospital-alt",
            "hospital-wide"
        ],
        "f0f8",
        "M232 0c-39.8 0-72 32.2-72 72l0 8L72 80C32.2 80 0 112.2 0 152L0 440c0 39.8 32.2 72 72 72l.2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0s0 0 0 0l272 0 8 0s0 0 0 0l104 0c39.8 0 72-32.2 72-72l0-288c0-39.8-32.2-72-72-72l-88 0 0-8c0-39.8-32.2-72-72-72L232 0zM480 128l88 0c13.3 0 24 10.7 24 24l0 40-56 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l56 0 0 48-56 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l56 0 0 104c0 13.3-10.7 24-24 24l-88 0 0-128 0-208zM72 128l88 0 0 336c0 0 0 0-.1 0l-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0c-13.2 0-24-10.7-24-24l0-104 56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0 0-48 56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0 0-40c0-13.3 10.7-24 24-24zM208 72c0-13.3 10.7-24 24-24l176 0c13.3 0 24 10.7 24 24l0 264 0 128-64 0 0-64c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 64-64 0 0-392zm88 24l0 24-24 0c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l24 0 0 24c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-24 24 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-24 0 0-24c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16z"
    ]
};
const $7435a4b2c8a749a5$export$cea7736417b94a3b = $7435a4b2c8a749a5$export$7a76c9d35b42d691;
const $7435a4b2c8a749a5$export$69c8cc0360f017e8 = $7435a4b2c8a749a5$export$7a76c9d35b42d691;
const $7435a4b2c8a749a5$export$5d65c40a109eb09c = {
    prefix: 'far',
    iconName: 'chess-rook',
    icon: [
        448,
        512,
        [
            9820
        ],
        "f447",
        "M80 80l0 112c0 2.5 1.2 4.9 3.2 6.4l51.2 38.4c6.8 5.1 10.4 13.4 9.5 21.9L133.5 352l-48.3 0 9.4-85L54.4 236.8C40.3 226.2 32 209.6 32 192L32 72c0-22.1 17.9-40 40-40l304 0c22.1 0 40 17.9 40 40l0 120c0 17.6-8.3 34.2-22.4 44.8L353.4 267l9.4 85-48.3 0-10.4-93.3c-.9-8.4 2.7-16.8 9.5-21.9l51.2-38.4c2-1.5 3.2-3.9 3.2-6.4l0-112-64 0 0 24c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-24-64 0 0 24c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-24L80 80zm4.7 384l278.7 0-16.6-32-245.6 0L84.7 464zm271.9-80c12 0 22.9 6.7 28.4 17.3l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7c0 22.5-18.2 40.8-40.8 40.8L72.8 512C50.2 512 32 493.8 32 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2C68.5 390.7 79.5 384 91.5 384l265 0zM208 288c-8.8 0-16-7.2-16-16l0-48c0-17.7 14.3-32 32-32s32 14.3 32 32l0 48c0 8.8-7.2 16-16 16l-32 0z"
    ]
};
const $7435a4b2c8a749a5$export$228008b5e11032fa = {
    prefix: 'far',
    iconName: 'star-half',
    icon: [
        576,
        512,
        [
            61731
        ],
        "f089",
        "M293.3 .6c10.9 2.5 18.6 12.2 18.6 23.4l0 384.7c0 8.9-4.9 17-12.7 21.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.3c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5c4.9-10.1 16.1-15.4 27-12.9zM263.9 128.4l-28.6 58.8c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l92.5-49.4 0-265.9z"
    ]
};
const $7435a4b2c8a749a5$export$d5713874f8fefe1b = {
    prefix: 'far',
    iconName: 'chess-king',
    icon: [
        448,
        512,
        [
            9818
        ],
        "f43f",
        "M248 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 32-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 0 40L59.6 144C26.7 144 0 170.7 0 203.6c0 8.2 1.7 16.3 4.9 23.8L59.1 352l52.3 0L49 208.2c-.6-1.5-1-3-1-4.6c0-6.4 5.2-11.6 11.6-11.6L224 192l164.4 0c6.4 0 11.6 5.2 11.6 11.6c0 1.6-.3 3.2-1 4.6L336.5 352l52.3 0 54.2-124.6c3.3-7.5 4.9-15.6 4.9-23.8c0-32.9-26.7-59.6-59.6-59.6L248 144l0-40 32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0 0-32zM101.2 432l245.6 0 16.6 32L84.7 464l16.6-32zm283.7-30.7c-5.5-10.6-16.5-17.3-28.4-17.3l-265 0c-12 0-22.9 6.7-28.4 17.3L36.6 452.5c-3 5.8-4.6 12.2-4.6 18.7C32 493.8 50.2 512 72.8 512l302.5 0c22.5 0 40.8-18.2 40.8-40.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2z"
    ]
};
const $7435a4b2c8a749a5$export$9a5c11a5e3d7f1e7 = {
    prefix: 'far',
    iconName: 'circle-user',
    icon: [
        512,
        512,
        [
            62142,
            "user-circle"
        ],
        "f2bd",
        "M406.5 399.6C387.4 352.9 341.5 320 288 320l-64 0c-53.5 0-99.4 32.9-118.5 79.6C69.9 362.2 48 311.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 55.7-21.9 106.2-57.5 143.6zm-40.1 32.7C334.4 452.4 296.6 464 256 464s-78.4-11.6-110.5-31.7c7.3-36.7 39.7-64.3 78.5-64.3l64 0c38.8 0 71.2 27.6 78.5 64.3zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-272a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm-88-40a88 88 0 1 0 176 0 88 88 0 1 0 -176 0z"
    ]
};
const $7435a4b2c8a749a5$export$be7d974e9e0dba1a = $7435a4b2c8a749a5$export$9a5c11a5e3d7f1e7;
const $7435a4b2c8a749a5$export$e9bd786d30cb716c = {
    prefix: 'far',
    iconName: 'copy',
    icon: [
        448,
        512,
        [],
        "f0c5",
        "M384 336l-192 0c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l140.1 0L400 115.9 400 320c0 8.8-7.2 16-16 16zM192 384l192 0c35.3 0 64-28.7 64-64l0-204.1c0-12.7-5.1-24.9-14.1-33.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1L192 0c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-32-48 0 0 32c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l32 0 0-48-32 0z"
    ]
};
const $7435a4b2c8a749a5$export$928280bdd54fa173 = {
    prefix: 'far',
    iconName: 'share-from-square',
    icon: [
        576,
        512,
        [
            61509,
            "share-square"
        ],
        "f14d",
        "M400 255.4l0-15.4 0-32c0-8.8-7.2-16-16-16l-32 0-16 0-46.5 0c-50.9 0-93.9 33.5-108.3 79.6c-3.3-9.4-5.2-19.8-5.2-31.6c0-61.9 50.1-112 112-112l48 0 16 0 32 0c8.8 0 16-7.2 16-16l0-32 0-15.4L506 160 400 255.4zM336 240l16 0 0 48c0 17.7 14.3 32 32 32l3.7 0c7.9 0 15.5-2.9 21.4-8.2l139-125.1c7.6-6.8 11.9-16.5 11.9-26.7s-4.3-19.9-11.9-26.7L409.9 8.9C403.5 3.2 395.3 0 386.7 0C367.5 0 352 15.5 352 34.7L352 80l-16 0-32 0-16 0c-88.4 0-160 71.6-160 160c0 60.4 34.6 99.1 63.9 120.9c5.9 4.4 11.5 8.1 16.7 11.2c4.4 2.7 8.5 4.9 11.9 6.6c3.4 1.7 6.2 3 8.2 3.9c2.2 1 4.6 1.4 7.1 1.4l2.5 0c9.8 0 17.8-8 17.8-17.8c0-7.8-5.3-14.7-11.6-19.5c0 0 0 0 0 0c-.4-.3-.7-.5-1.1-.8c-1.7-1.1-3.4-2.5-5-4.1c-.8-.8-1.7-1.6-2.5-2.6s-1.6-1.9-2.4-2.9c-1.8-2.5-3.5-5.3-5-8.5c-2.6-6-4.3-13.3-4.3-22.4c0-36.1 29.3-65.5 65.5-65.5l14.5 0 32 0zM72 32C32.2 32 0 64.2 0 104L0 440c0 39.8 32.2 72 72 72l336 0c39.8 0 72-32.2 72-72l0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64c0 13.3-10.7 24-24 24L72 464c-13.3 0-24-10.7-24-24l0-336c0-13.3 10.7-24 24-24l64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 32z"
    ]
};
const $7435a4b2c8a749a5$export$ae9e1434571f373c = $7435a4b2c8a749a5$export$928280bdd54fa173;
const $7435a4b2c8a749a5$export$da61665fff8aebfe = {
    prefix: 'far',
    iconName: 'copyright',
    icon: [
        512,
        512,
        [
            169
        ],
        "f1f9",
        "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM199.4 312.6c-31.2-31.2-31.2-81.9 0-113.1s81.9-31.2 113.1 0c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9c-50-50-131-50-181 0s-50 131 0 181s131 50 181 0c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0c-31.2 31.2-81.9 31.2-113.1 0z"
    ]
};
const $7435a4b2c8a749a5$export$fc82fb79180cd17c = {
    prefix: 'far',
    iconName: 'map',
    icon: [
        576,
        512,
        [
            128506,
            62072
        ],
        "f279",
        "M565.6 36.2C572.1 40.7 576 48.1 576 56l0 336c0 10-6.2 18.9-15.5 22.4l-168 64c-5.2 2-10.9 2.1-16.1 .3L192.5 417.5l-160 61c-7.4 2.8-15.7 1.8-22.2-2.7S0 463.9 0 456L0 120c0-10 6.1-18.9 15.5-22.4l168-64c5.2-2 10.9-2.1 16.1-.3L383.5 94.5l160-61c7.4-2.8 15.7-1.8 22.2 2.7zM48 136.5l0 284.6 120-45.7 0-284.6L48 136.5zM360 422.7l0-285.4-144-48 0 285.4 144 48zm48-1.5l120-45.7 0-284.6L408 136.5l0 284.6z"
    ]
};
const $7435a4b2c8a749a5$export$6b31a1e5968b2378 = {
    prefix: 'far',
    iconName: 'bell-slash',
    icon: [
        640,
        512,
        [
            128277,
            61943
        ],
        "f1f6",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L542.6 400c2.7-7.8 1.3-16.5-3.9-23l-14.9-18.6C495.5 322.9 480 278.8 480 233.4l0-33.4c0-75.8-55.5-138.6-128-150.1L352 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 17.9c-43.9 7-81.5 32.7-104.4 68.7L38.8 5.1zM221.7 148.4C239.6 117.1 273.3 96 312 96l8 0 8 0c57.4 0 104 46.6 104 104l0 33.4c0 32.7 6.4 64.8 18.7 94.5L221.7 148.4zM406.2 416l-60.9-48-176.9 0c21.2-32.8 34.4-70.3 38.4-109.1L160 222.1l0 11.4c0 45.4-15.5 89.5-43.8 124.9L101.3 377c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6l286.2 0zM384 448l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z"
    ]
};
const $7435a4b2c8a749a5$export$54608d0a883fea4d = {
    prefix: 'far',
    iconName: 'hand-lizard',
    icon: [
        512,
        512,
        [],
        "f258",
        "M72 112c-13.3 0-24 10.7-24 24s10.7 24 24 24l168 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-104 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l152 0c4.5 0 8.9 1.3 12.7 3.6l64 40c7 4.4 11.3 12.1 11.3 20.4l0 24c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-10.7L281.1 384 136 384c-39.8 0-72-32.2-72-72s32.2-72 72-72l104 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L72 208c-39.8 0-72-32.2-72-72S32.2 64 72 64l209.6 0c46.7 0 90.9 21.5 119.7 58.3l78.4 100.1c20.9 26.7 32.3 59.7 32.3 93.7L512 424c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-107.9c0-23.2-7.8-45.8-22.1-64.1L363.5 151.9c-19.7-25.2-49.9-39.9-81.9-39.9L72 112z"
    ]
};
const $7435a4b2c8a749a5$export$b5023c446f10324 = {
    prefix: 'far',
    iconName: 'face-smile',
    icon: [
        512,
        512,
        [
            128578,
            "smile"
        ],
        "f118",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm177.6 62.1C192.8 334.5 218.8 352 256 352s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $7435a4b2c8a749a5$export$c632b2334f0913bc = $7435a4b2c8a749a5$export$b5023c446f10324;
const $7435a4b2c8a749a5$export$e49e3cfceea441cc = {
    prefix: 'far',
    iconName: 'hand-peace',
    icon: [
        512,
        512,
        [
            9996
        ],
        "f25b",
        "M250.8 1.4c-35.2-3.7-66.6 21.8-70.3 57L174 119 156.7 69.6C145 36.3 108.4 18.8 75.1 30.5S24.2 78.8 35.9 112.1L88.7 262.2C73.5 276.7 64 297.3 64 320c0 0 0 0 0 0l0 24c0 92.8 75.2 168 168 168l48 0c92.8 0 168-75.2 168-168l0-72 0-16 0-32c0-35.3-28.7-64-64-64c-7.9 0-15.4 1.4-22.4 4c-10.4-21.3-32.3-36-57.6-36c-.7 0-1.5 0-2.2 0l5.9-56.3c3.7-35.2-21.8-66.6-57-70.3zm-.2 155.4C243.9 166.9 240 179 240 192l0 48c0 .7 0 1.4 0 2c-5.1-1.3-10.5-2-16-2l-7.4 0-5.4-15.3 17-161.3c.9-8.8 8.8-15.2 17.6-14.2s15.2 8.8 14.2 17.6l-9.5 90.1zM111.4 85.6L165.7 240 144 240c-4 0-8 .3-11.9 .9L81.2 96.2c-2.9-8.3 1.5-17.5 9.8-20.4s17.5 1.5 20.4 9.8zM288 192c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48zm38.4 108c10.4 21.3 32.3 36 57.6 36c5.5 0 10.9-.7 16-2l0 10c0 66.3-53.7 120-120 120l-48 0c-66.3 0-120-53.7-120-120l0-24s0 0 0 0c0-17.7 14.3-32 32-32l80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0c35.3 0 64-28.7 64-64c0-.7 0-1.4 0-2c5.1 1.3 10.5 2 16 2c7.9 0 15.4-1.4 22.4-4zM400 272c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32 0 16z"
    ]
};
const $7435a4b2c8a749a5$export$fbb22081b65e4f33 = {
    prefix: 'far',
    iconName: 'face-grin-hearts',
    icon: [
        512,
        512,
        [
            128525,
            "grin-hearts"
        ],
        "f584",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM215.3 137.1c17.8 4.8 28.4 23.1 23.6 40.8l-17.4 65c-2.3 8.5-11.1 13.6-19.6 11.3l-65.1-17.4c-17.8-4.8-28.4-23.1-23.6-40.8s23.1-28.4 40.8-23.6l16.1 4.3 4.3-16.1c4.8-17.8 23.1-28.4 40.8-23.6zm122.3 23.6l4.3 16.1 16.1-4.3c17.8-4.8 36.1 5.8 40.8 23.6s-5.8 36.1-23.6 40.8l-65.1 17.4c-8.5 2.3-17.3-2.8-19.6-11.3l-17.4-65c-4.8-17.8 5.8-36.1 23.6-40.8s36.1 5.8 40.9 23.6z"
    ]
};
const $7435a4b2c8a749a5$export$c56cf0e0c3bc5ed2 = $7435a4b2c8a749a5$export$fbb22081b65e4f33;
const $7435a4b2c8a749a5$export$f26673f8b10c3d46 = {
    prefix: 'far',
    iconName: 'building',
    icon: [
        384,
        512,
        [
            127970,
            61687
        ],
        "f1ad",
        "M64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l80 0 0-64c0-26.5 21.5-48 48-48s48 21.5 48 48l0 64 80 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm88 40c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48zM232 88l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16zM88 232c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48zm144-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16z"
    ]
};
const $7435a4b2c8a749a5$export$2ff38f330c834084 = {
    prefix: 'far',
    iconName: 'face-grin-beam-sweat',
    icon: [
        512,
        512,
        [
            128517,
            "grin-beam-sweat"
        ],
        "f583",
        "M476.8 126.3C497.1 120.8 512 102.7 512 81c0-20-28.6-60.4-41.6-77.7c-3.2-4.4-9.6-4.4-12.8 0c-9.5 12.6-27.1 37.2-36 57.5c-.3 .7-.6 1.4-.9 2.1C417.8 69.7 416 76 416 81c0 26 21.5 47 48 47c4.4 0 8.7-.6 12.8-1.7zM395.4 41.2C355.3 15.2 307.4 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256c0-35.8-7.3-69.9-20.6-100.8c-8.6 3.1-17.8 4.8-27.4 4.8c-8.9 0-17.6-1.5-25.7-4.2C454.7 185.5 464 219.7 464 256c0 114.9-93.1 208-208 208S48 370.9 48 256S141.1 48 256 48c48.7 0 93.4 16.7 128.9 44.7c-.6-3.8-.9-7.7-.9-11.7c0-11.4 3.8-22.4 7.1-30.5c1.3-3.1 2.7-6.2 4.3-9.3zM375 336.5c10.4-16.1-6.8-32.5-25.5-28.1c-28.9 6.8-60.5 10.5-93.6 10.5s-64.7-3.7-93.6-10.5c-18.7-4.4-35.9 12-25.5 28.1c24.6 38.1 68.7 63.5 119.1 63.5s94.5-25.4 119.1-63.5zM217.6 228.8s0 0 0 0s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 188.4 120 206.1 120 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0zm160 0s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 188.4 280 206.1 280 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0c0 0 0 0 0 0z"
    ]
};
const $7435a4b2c8a749a5$export$14d0ccc54c5b6826 = $7435a4b2c8a749a5$export$2ff38f330c834084;
const $7435a4b2c8a749a5$export$c4c2f69a53bab720 = {
    prefix: 'far',
    iconName: 'moon',
    icon: [
        384,
        512,
        [
            127769,
            9214
        ],
        "f186",
        "M144.7 98.7c-21 34.1-33.1 74.3-33.1 117.3c0 98 62.8 181.4 150.4 211.7c-12.4 2.8-25.3 4.3-38.6 4.3C126.6 432 48 353.3 48 256c0-68.9 39.4-128.4 96.8-157.3zm62.1-66C91.1 41.2 0 137.9 0 256C0 379.7 100 480 223.5 480c47.8 0 92-15 128.4-40.6c1.9-1.3 3.7-2.7 5.5-4c4.8-3.6 9.4-7.4 13.9-11.4c2.7-2.4 5.3-4.8 7.9-7.3c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-3.7 .6-7.4 1.2-11.1 1.6c-5 .5-10.1 .9-15.3 1c-1.2 0-2.5 0-3.7 0l-.3 0c-96.8-.2-175.2-78.9-175.2-176c0-54.8 24.9-103.7 64.1-136c1-.9 2.1-1.7 3.2-2.6c4-3.2 8.2-6.2 12.5-9c3.1-2 6.3-4 9.6-5.8c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-3.6-.3-7.1-.5-10.7-.6c-2.7-.1-5.5-.1-8.2-.1c-3.3 0-6.5 .1-9.8 .2c-2.3 .1-4.6 .2-6.9 .4z"
    ]
};
const $7435a4b2c8a749a5$export$34f5c36a3e80efa2 = {
    prefix: 'far',
    iconName: 'calendar',
    icon: [
        448,
        512,
        [
            128197,
            128198
        ],
        "f133",
        "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256z"
    ]
};
const $7435a4b2c8a749a5$export$4272e56f2429da88 = {
    prefix: 'far',
    iconName: 'face-grin-tongue-wink',
    icon: [
        512,
        512,
        [
            128540,
            "grin-tongue-wink"
        ],
        "f58b",
        "M348.3 442.4c2.4-8.4 3.7-17.3 3.7-26.4l0-52.5c8.8-8 16.6-17.1 23-27c10.4-16.1-6.8-32.5-25.5-28.1c-28.9 6.8-60.5 10.5-93.6 10.5s-64.7-3.7-93.6-10.5c-18.7-4.4-35.9 12-25.5 28.1c6.5 10 14.3 19.1 23.1 27.1l0 52.4c0 9.2 1.3 18 3.7 26.4C95.1 408.4 48 337.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 81.7-47.1 152.4-115.7 186.4zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM159.6 220c10.6 0 19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C199.7 186.8 179 180 159.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9c5.5-5.8 14.8-9.7 25.4-9.7zm176.7 12a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-.4-72a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM320 416c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-37.4c0-14.7 11.9-26.6 26.6-26.6l2 0c11.3 0 21.1 7.9 23.6 18.9c2.8 12.6 20.8 12.6 23.6 0c2.5-11.1 12.3-18.9 23.6-18.9l2 0c14.7 0 26.6 11.9 26.6 26.6l0 37.4z"
    ]
};
const $7435a4b2c8a749a5$export$58099903d50aefb3 = $7435a4b2c8a749a5$export$4272e56f2429da88;
const $7435a4b2c8a749a5$export$76c1aa4bf9a39458 = {
    prefix: 'far',
    iconName: 'clone',
    icon: [
        512,
        512,
        [],
        "f24d",
        "M64 464l224 0c8.8 0 16-7.2 16-16l0-64 48 0 0 64c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 224c0-35.3 28.7-64 64-64l64 0 0 48-64 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16zM224 304l224 0c8.8 0 16-7.2 16-16l0-224c0-8.8-7.2-16-16-16L224 48c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16zm-64-16l0-224c0-35.3 28.7-64 64-64L448 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64l-224 0c-35.3 0-64-28.7-64-64z"
    ]
};
const $7435a4b2c8a749a5$export$67a047c738fb34da = {
    prefix: 'far',
    iconName: 'face-angry',
    icon: [
        512,
        512,
        [
            128544,
            "angry"
        ],
        "f556",
        "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm72.4-118.5c9.7-9 10.2-24.2 1.2-33.9C315.3 344.3 290.6 328 256 328s-59.3 16.3-73.5 31.6c-9 9.7-8.5 24.9 1.2 33.9s24.9 8.5 33.9-1.2c7.4-7.9 20-16.4 38.5-16.4s31.1 8.5 38.5 16.4c9 9.7 24.2 10.2 33.9 1.2zM176.4 272c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32z"
    ]
};
const $7435a4b2c8a749a5$export$3c96c08e234498c5 = $7435a4b2c8a749a5$export$67a047c738fb34da;
const $7435a4b2c8a749a5$export$3896694b3e81fba7 = {
    prefix: 'far',
    iconName: 'rectangle-xmark',
    icon: [
        512,
        512,
        [
            62164,
            "rectangle-times",
            "times-rectangle",
            "window-close"
        ],
        "f410",
        "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm175 79c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
const $7435a4b2c8a749a5$export$eaaf26416a51dc1 = $7435a4b2c8a749a5$export$3896694b3e81fba7;
const $7435a4b2c8a749a5$export$10147c0014152a3f = $7435a4b2c8a749a5$export$3896694b3e81fba7;
const $7435a4b2c8a749a5$export$18b7775f78a3e16 = $7435a4b2c8a749a5$export$3896694b3e81fba7;
const $7435a4b2c8a749a5$export$b5378818301da1be = {
    prefix: 'far',
    iconName: 'paper-plane',
    icon: [
        512,
        512,
        [
            61913
        ],
        "f1d8",
        "M16.1 260.2c-22.6 12.9-20.5 47.3 3.6 57.3L160 376l0 103.3c0 18.1 14.6 32.7 32.7 32.7c9.7 0 18.9-4.3 25.1-11.8l62-74.3 123.9 51.6c18.9 7.9 40.8-4.5 43.9-24.7l64-416c1.9-12.1-3.4-24.3-13.5-31.2s-23.3-7.5-34-1.4l-448 256zm52.1 25.5L409.7 90.6 190.1 336l1.2 1L68.2 285.7zM403.3 425.4L236.7 355.9 450.8 116.6 403.3 425.4z"
    ]
};
const $7435a4b2c8a749a5$export$53dd2cacf674142a = {
    prefix: 'far',
    iconName: 'life-ring',
    icon: [
        512,
        512,
        [],
        "f1cd",
        "M385.1 419.1C349.7 447.2 304.8 464 256 464s-93.7-16.8-129.1-44.9l80.4-80.4c14.3 8.4 31 13.3 48.8 13.3s34.5-4.8 48.8-13.3l80.4 80.4zm68.1 .2C489.9 374.9 512 318.1 512 256s-22.1-118.9-58.8-163.3L465 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L419.3 58.8C374.9 22.1 318.1 0 256 0S137.1 22.1 92.7 58.8L81 47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L58.8 92.7C22.1 137.1 0 193.9 0 256s22.1 118.9 58.8 163.3L47 431c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l11.8-11.8C137.1 489.9 193.9 512 256 512s118.9-22.1 163.3-58.8L431 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-11.8-11.8zm-34.1-34.1l-80.4-80.4c8.4-14.3 13.3-31 13.3-48.8s-4.8-34.5-13.3-48.8l80.4-80.4C447.2 162.3 464 207.2 464 256s-16.8 93.7-44.9 129.1zM385.1 92.9l-80.4 80.4c-14.3-8.4-31-13.3-48.8-13.3s-34.5 4.8-48.8 13.3L126.9 92.9C162.3 64.8 207.2 48 256 48s93.7 16.8 129.1 44.9zM173.3 304.8L92.9 385.1C64.8 349.7 48 304.8 48 256s16.8-93.7 44.9-129.1l80.4 80.4c-8.4 14.3-13.3 31-13.3 48.8s4.8 34.5 13.3 48.8zM208 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"
    ]
};
const $7435a4b2c8a749a5$export$bd5bd2ef56b793b1 = {
    prefix: 'far',
    iconName: 'face-grimace',
    icon: [
        512,
        512,
        [
            128556,
            "grimace"
        ],
        "f57f",
        "M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zM512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM168 320c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0-48-8 0zm40 48l32 0 0-48-32 0 0 48zm96 0l0-48-32 0 0 48 32 0zm32 0l8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0 48zM168 288l176 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-176 0c-30.9 0-56-25.1-56-56s25.1-56 56-56zm-23.6-80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $7435a4b2c8a749a5$export$3d08cd36ac1ef231 = $7435a4b2c8a749a5$export$bd5bd2ef56b793b1;
const $7435a4b2c8a749a5$export$23e8b4955c2d951b = {
    prefix: 'far',
    iconName: 'calendar-minus',
    icon: [
        448,
        512,
        [],
        "f272",
        "M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zM400 192L48 192l0 256c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-256zM296 352l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24z"
    ]
};
const $7435a4b2c8a749a5$export$30262489773a79a3 = {
    prefix: 'far',
    iconName: 'circle-xmark',
    icon: [
        512,
        512,
        [
            61532,
            "times-circle",
            "xmark-circle"
        ],
        "f057",
        "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"
    ]
};
const $7435a4b2c8a749a5$export$ab0ec50720a747eb = $7435a4b2c8a749a5$export$30262489773a79a3;
const $7435a4b2c8a749a5$export$90ac4096df8efdee = $7435a4b2c8a749a5$export$30262489773a79a3;
const $7435a4b2c8a749a5$export$47e4e0d519d33497 = {
    prefix: 'far',
    iconName: 'thumbs-up',
    icon: [
        512,
        512,
        [
            128077,
            61575
        ],
        "f164",
        "M323.8 34.8c-38.2-10.9-78.1 11.2-89 49.4l-5.7 20c-3.7 13-10.4 25-19.5 35l-51.3 56.4c-8.9 9.8-8.2 25 1.6 33.9s25 8.2 33.9-1.6l51.3-56.4c14.1-15.5 24.4-34 30.1-54.1l5.7-20c3.6-12.7 16.9-20.1 29.7-16.5s20.1 16.9 16.5 29.7l-5.7 20c-5.7 19.9-14.7 38.7-26.6 55.5c-5.2 7.3-5.8 16.9-1.7 24.9s12.3 13 21.3 13L448 224c8.8 0 16 7.2 16 16c0 6.8-4.3 12.7-10.4 15c-7.4 2.8-13 9-14.9 16.7s.1 15.8 5.3 21.7c2.5 2.8 4 6.5 4 10.6c0 7.8-5.6 14.3-13 15.7c-8.2 1.6-15.1 7.3-18 15.2s-1.6 16.7 3.6 23.3c2.1 2.7 3.4 6.1 3.4 9.9c0 6.7-4.2 12.6-10.2 14.9c-11.5 4.5-17.7 16.9-14.4 28.8c.4 1.3 .6 2.8 .6 4.3c0 8.8-7.2 16-16 16l-97.5 0c-12.6 0-25-3.7-35.5-10.7l-61.7-41.1c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l61.7 41.1c18.4 12.3 40 18.8 62.1 18.8l97.5 0c34.7 0 62.9-27.6 64-62c14.6-11.7 24-29.7 24-50c0-4.5-.5-8.8-1.3-13c15.4-11.7 25.3-30.2 25.3-51c0-6.5-1-12.8-2.8-18.7C504.8 273.7 512 257.7 512 240c0-35.3-28.6-64-64-64l-92.3 0c4.7-10.4 8.7-21.2 11.8-32.2l5.7-20c10.9-38.2-11.2-78.1-49.4-89zM32 192c-17.7 0-32 14.3-32 32L0 448c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32l-64 0z"
    ]
};
const $7435a4b2c8a749a5$export$26a3f9d2784b90d8 = {
    prefix: 'far',
    iconName: 'window-minimize',
    icon: [
        512,
        512,
        [
            128469
        ],
        "f2d1",
        "M24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 432z"
    ]
};
const $7435a4b2c8a749a5$export$7ec6541fee081990 = {
    prefix: 'far',
    iconName: 'square-full',
    icon: [
        512,
        512,
        [
            128997,
            128998,
            128999,
            129000,
            129001,
            129002,
            129003,
            11035,
            11036
        ],
        "f45c",
        "M464 48l0 416L48 464 48 48l416 0zM48 0L0 0 0 48 0 464l0 48 48 0 416 0 48 0 0-48 0-416 0-48L464 0 48 0z"
    ]
};
const $7435a4b2c8a749a5$export$4a4e034527c933f5 = {
    prefix: 'far',
    iconName: 'note-sticky',
    icon: [
        448,
        512,
        [
            62026,
            "sticky-note"
        ],
        "f249",
        "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l224 0 0-80c0-17.7 14.3-32 32-32l80 0 0-224c0-8.8-7.2-16-16-16L64 80zM288 480L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 224 0 5.5c0 17-6.7 33.3-18.7 45.3l-90.5 90.5c-12 12-28.3 18.7-45.3 18.7l-5.5 0z"
    ]
};
const $7435a4b2c8a749a5$export$80889adc5d98bf4a = $7435a4b2c8a749a5$export$4a4e034527c933f5;
const $7435a4b2c8a749a5$export$8a5a0dbb2a17e253 = {
    prefix: 'far',
    iconName: 'face-sad-tear',
    icon: [
        512,
        512,
        [
            128546,
            "sad-tear"
        ],
        "f5b4",
        "M175.9 448c-35-.1-65.5-22.6-76-54.6C67.6 356.8 48 308.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208s-93.1 208-208 208c-28.4 0-55.5-5.7-80.1-16zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM128 369c0 26 21.5 47 48 47s48-21 48-47c0-20-28.4-60.4-41.6-77.7c-3.2-4.4-9.6-4.4-12.8 0C156.6 308.6 128 349 128 369zm128-65c-13.3 0-24 10.7-24 24s10.7 24 24 24c30.7 0 58.7 11.5 80 30.6c9.9 8.8 25 8 33.9-1.9s8-25-1.9-33.9C338.3 320.2 299 304 256 304zm47.6-96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
const $7435a4b2c8a749a5$export$4b5241926f692f91 = $7435a4b2c8a749a5$export$8a5a0dbb2a17e253;
const $7435a4b2c8a749a5$export$b276ec3dc9760d39 = {
    prefix: 'far',
    iconName: 'hand-point-left',
    icon: [
        512,
        512,
        [],
        "f0a5",
        "M64 128l177.6 0c-1 5.2-1.6 10.5-1.6 16l0 16-32 0L64 160c-8.8 0-16-7.2-16-16s7.2-16 16-16zm224 16c0-17.7 14.3-32 32-32c0 0 0 0 0 0l24 0c66.3 0 120 53.7 120 120l0 48c0 52.5-33.7 97.1-80.7 113.4c.5-3.1 .7-6.2 .7-9.4c0-20-9.2-37.9-23.6-49.7c4.9-9 7.6-19.4 7.6-30.3c0-15.1-5.3-29-14-40c8.8-11 14-24.9 14-40l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-40 0-40zm32-80s0 0 0 0c-18 0-34.6 6-48 16L64 80C28.7 80 0 108.7 0 144s28.7 64 64 64l82 0c-1.3 5.1-2 10.5-2 16c0 25.3 14.7 47.2 36 57.6c-2.6 7-4 14.5-4 22.4c0 20 9.2 37.9 23.6 49.7c-4.9 9-7.6 19.4-7.6 30.3c0 35.3 28.7 64 64 64l64 0 24 0c92.8 0 168-75.2 168-168l0-48c0-92.8-75.2-168-168-168l-24 0zM256 400c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0zM240 224c0 5.5 .7 10.9 2 16l-2 0-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0 16zm24 64l40 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l24 0z"
    ]
};
var $7435a4b2c8a749a5$export$f9059ea71e16fa16 = {
    faTrashCan: $7435a4b2c8a749a5$export$864bb8d6c21fb792,
    faTrashAlt: $7435a4b2c8a749a5$export$88df7ff7eb32f9dc,
    faMessage: $7435a4b2c8a749a5$export$6563a67224e7f879,
    faCommentAlt: $7435a4b2c8a749a5$export$6e96904d9af0ec4a,
    faFileLines: $7435a4b2c8a749a5$export$ef565d07efe2b5e9,
    faFileAlt: $7435a4b2c8a749a5$export$243b47dca32bf0b8,
    faFileText: $7435a4b2c8a749a5$export$f466100bf9bf37a5,
    faCalendarDays: $7435a4b2c8a749a5$export$31c6cf6f5d38dc0,
    faCalendarAlt: $7435a4b2c8a749a5$export$cbc139f33cff356,
    faHandPointRight: $7435a4b2c8a749a5$export$f7bc8714c970afa4,
    faFaceSmileBeam: $7435a4b2c8a749a5$export$e3c56ed54f074063,
    faSmileBeam: $7435a4b2c8a749a5$export$54ada6dc9690e0ca,
    faFaceGrinStars: $7435a4b2c8a749a5$export$1d1fbac384a76a12,
    faGrinStars: $7435a4b2c8a749a5$export$64347a5c8c402ef4,
    faAddressBook: $7435a4b2c8a749a5$export$853fd1561789e3bb,
    faContactBook: $7435a4b2c8a749a5$export$594b5a5d4d2e156b,
    faComments: $7435a4b2c8a749a5$export$932912e74adb8939,
    faPaste: $7435a4b2c8a749a5$export$6f95f90dd1f6d86b,
    faFileClipboard: $7435a4b2c8a749a5$export$ca3229c47de163fa,
    faFaceGrinTongueSquint: $7435a4b2c8a749a5$export$8eee2c17ff89e724,
    faGrinTongueSquint: $7435a4b2c8a749a5$export$4edf34c3def09a31,
    faFaceFlushed: $7435a4b2c8a749a5$export$ba5dc4287853ecbd,
    faFlushed: $7435a4b2c8a749a5$export$dfd2bd012685aeac,
    faSquareCaretRight: $7435a4b2c8a749a5$export$5b1d41cdd118ea6d,
    faCaretSquareRight: $7435a4b2c8a749a5$export$ae86c9de7e0f62fa,
    faSquareMinus: $7435a4b2c8a749a5$export$814c9edba7b84aa4,
    faMinusSquare: $7435a4b2c8a749a5$export$ffe9387966b3e681,
    faCompass: $7435a4b2c8a749a5$export$b4d344633433e50e,
    faSquareCaretDown: $7435a4b2c8a749a5$export$a1ab39cd66c4e50e,
    faCaretSquareDown: $7435a4b2c8a749a5$export$61aea18df1c84401,
    faFaceKissBeam: $7435a4b2c8a749a5$export$eca99665af566fe1,
    faKissBeam: $7435a4b2c8a749a5$export$d6ff8a73c0812e63,
    faLightbulb: $7435a4b2c8a749a5$export$1e80f89fe84a215b,
    faFlag: $7435a4b2c8a749a5$export$6591b1ea509be9da,
    faSquareCheck: $7435a4b2c8a749a5$export$5bb6a0c94ad2f4bb,
    faCheckSquare: $7435a4b2c8a749a5$export$f0c8040f596df7fe,
    faCircleDot: $7435a4b2c8a749a5$export$aa13d9234890e8d3,
    faDotCircle: $7435a4b2c8a749a5$export$92bc269cb244d66a,
    faFaceDizzy: $7435a4b2c8a749a5$export$635e4d8cc8428961,
    faDizzy: $7435a4b2c8a749a5$export$89a2b10dabc487e8,
    faFutbol: $7435a4b2c8a749a5$export$65a345b33858a655,
    faFutbolBall: $7435a4b2c8a749a5$export$51a344ca0a215620,
    faSoccerBall: $7435a4b2c8a749a5$export$f4a29712c724ba2d,
    faPenToSquare: $7435a4b2c8a749a5$export$ba236543926e3569,
    faEdit: $7435a4b2c8a749a5$export$7be713e57d023733,
    faHourglassHalf: $7435a4b2c8a749a5$export$703272eebf5e3eea,
    faHourglass2: $7435a4b2c8a749a5$export$f1052bbf6bf361c0,
    faEyeSlash: $7435a4b2c8a749a5$export$ed3f2918429d029a,
    faHand: $7435a4b2c8a749a5$export$f69db0b876f7d753,
    faHandPaper: $7435a4b2c8a749a5$export$6e6216c8b50471bb,
    faHandSpock: $7435a4b2c8a749a5$export$2262d6b626de1120,
    faFaceKiss: $7435a4b2c8a749a5$export$5a54c83033a0a56a,
    faKiss: $7435a4b2c8a749a5$export$c762a77aabf64fd0,
    faFaceGrinTongue: $7435a4b2c8a749a5$export$95a7394c24f57943,
    faGrinTongue: $7435a4b2c8a749a5$export$ef222816a43a4b3a,
    faChessBishop: $7435a4b2c8a749a5$export$a831eedd2f59c62f,
    faFaceGrinWink: $7435a4b2c8a749a5$export$1dd161850c5bc64e,
    faGrinWink: $7435a4b2c8a749a5$export$2397fcd34eb12177,
    faFaceGrinWide: $7435a4b2c8a749a5$export$bdbabf493c478cde,
    faGrinAlt: $7435a4b2c8a749a5$export$b4abebfe416d36ba,
    faFaceFrownOpen: $7435a4b2c8a749a5$export$c8a28356e07b9ccb,
    faFrownOpen: $7435a4b2c8a749a5$export$c4775e66bed5d96,
    faHandPointUp: $7435a4b2c8a749a5$export$cdc9f5e7e94e76da,
    faBookmark: $7435a4b2c8a749a5$export$4ed9da5c3cca0ef1,
    faHandPointDown: $7435a4b2c8a749a5$export$f6dcbf0a940428f4,
    faFolder: $7435a4b2c8a749a5$export$72b780186370e953,
    faFolderBlank: $7435a4b2c8a749a5$export$9ef114244d26da0,
    faUser: $7435a4b2c8a749a5$export$f5699fa0844e0188,
    faSquareCaretLeft: $7435a4b2c8a749a5$export$2c5163541229363,
    faCaretSquareLeft: $7435a4b2c8a749a5$export$d0c8ba444f1f9581,
    faStar: $7435a4b2c8a749a5$export$a3b0eb2cd7942125,
    faChessKnight: $7435a4b2c8a749a5$export$861b1f13085cf122,
    faFaceLaughSquint: $7435a4b2c8a749a5$export$67ca89c1ca38d559,
    faLaughSquint: $7435a4b2c8a749a5$export$b206e700cf7084e1,
    faFaceLaugh: $7435a4b2c8a749a5$export$2f203616c892d415,
    faLaugh: $7435a4b2c8a749a5$export$6c74e314e801a4fe,
    faFolderOpen: $7435a4b2c8a749a5$export$ff7e93418af88b78,
    faClipboard: $7435a4b2c8a749a5$export$97d84347d71ba297,
    faChessQueen: $7435a4b2c8a749a5$export$7b8ce73615739d30,
    faHandBackFist: $7435a4b2c8a749a5$export$be38a892fe9b4098,
    faHandRock: $7435a4b2c8a749a5$export$97a81eba394c8c44,
    faSquareCaretUp: $7435a4b2c8a749a5$export$66068918abb14406,
    faCaretSquareUp: $7435a4b2c8a749a5$export$307ae80b26533ce5,
    faChartBar: $7435a4b2c8a749a5$export$b532f5d25de97633,
    faBarChart: $7435a4b2c8a749a5$export$2d5f754a5e5738b,
    faWindowRestore: $7435a4b2c8a749a5$export$eccfff9bfd585652,
    faSquarePlus: $7435a4b2c8a749a5$export$eaf727acca5a35e4,
    faPlusSquare: $7435a4b2c8a749a5$export$b6359eebfe900c35,
    faImage: $7435a4b2c8a749a5$export$7e9f0928967e03b,
    faFolderClosed: $7435a4b2c8a749a5$export$5e30548b7f8eeb95,
    faLemon: $7435a4b2c8a749a5$export$4fbda8f64648f3b5,
    faHandshake: $7435a4b2c8a749a5$export$b4c63e9bfc7906f1,
    faGem: $7435a4b2c8a749a5$export$31ee86ac717db552,
    faCirclePlay: $7435a4b2c8a749a5$export$86c4e45dc3302d15,
    faPlayCircle: $7435a4b2c8a749a5$export$cf04333781061c5e,
    faCircleCheck: $7435a4b2c8a749a5$export$c2e9877668862374,
    faCheckCircle: $7435a4b2c8a749a5$export$be9e388158c74f29,
    faCircleStop: $7435a4b2c8a749a5$export$229de76dfef2687f,
    faStopCircle: $7435a4b2c8a749a5$export$47af2aad60ab3e7c,
    faIdBadge: $7435a4b2c8a749a5$export$a75288855ea05282,
    faFaceLaughBeam: $7435a4b2c8a749a5$export$3f2d51c0547bf984,
    faLaughBeam: $7435a4b2c8a749a5$export$a88d1f4073ea9369,
    faRegistered: $7435a4b2c8a749a5$export$5f519e9ac15ab8c3,
    faAddressCard: $7435a4b2c8a749a5$export$6ea408c7266ed557,
    faContactCard: $7435a4b2c8a749a5$export$4ac51eb0b298b190,
    faVcard: $7435a4b2c8a749a5$export$91228257deb1bf18,
    faFaceTired: $7435a4b2c8a749a5$export$5352cbdc070ce8d,
    faTired: $7435a4b2c8a749a5$export$3d016d62cda18371,
    faFontAwesome: $7435a4b2c8a749a5$export$aa4baaed1c60f58d,
    faFontAwesomeFlag: $7435a4b2c8a749a5$export$102c25fde54d4843,
    faFontAwesomeLogoFull: $7435a4b2c8a749a5$export$6e20d421a2e0f320,
    faFaceSmileWink: $7435a4b2c8a749a5$export$6143da800b0e6626,
    faSmileWink: $7435a4b2c8a749a5$export$f5dbb37f6801ee3f,
    faFileWord: $7435a4b2c8a749a5$export$f0858dff6e769cf6,
    faFilePowerpoint: $7435a4b2c8a749a5$export$c341daeecdea449a,
    faEnvelopeOpen: $7435a4b2c8a749a5$export$c6c3bd5f7d9b8bf2,
    faFileZipper: $7435a4b2c8a749a5$export$7a4a0e4caa1e4e6f,
    faFileArchive: $7435a4b2c8a749a5$export$bf2047a9946b5c3f,
    faSquare: $7435a4b2c8a749a5$export$90b4406457aae8cc,
    faSnowflake: $7435a4b2c8a749a5$export$bab8f3647c394f48,
    faNewspaper: $7435a4b2c8a749a5$export$d91b374112d4f8c1,
    faFaceKissWinkHeart: $7435a4b2c8a749a5$export$611ae61f02de0aa,
    faKissWinkHeart: $7435a4b2c8a749a5$export$ebba617701dfb917,
    faStarHalfStroke: $7435a4b2c8a749a5$export$3e4892d8bf919edd,
    faStarHalfAlt: $7435a4b2c8a749a5$export$c13575f42532efb3,
    faFileExcel: $7435a4b2c8a749a5$export$77cb1a465c4fe84,
    faFaceGrinBeam: $7435a4b2c8a749a5$export$3de52eeb00462407,
    faGrinBeam: $7435a4b2c8a749a5$export$734da5249381ec7e,
    faObjectUngroup: $7435a4b2c8a749a5$export$887f6345573abcac,
    faCircleRight: $7435a4b2c8a749a5$export$1fec48c8bdd69c1d,
    faArrowAltCircleRight: $7435a4b2c8a749a5$export$88962ffdad8b856d,
    faFaceRollingEyes: $7435a4b2c8a749a5$export$a6d72a9a068392b5,
    faMehRollingEyes: $7435a4b2c8a749a5$export$fdc62a1bea767cc2,
    faObjectGroup: $7435a4b2c8a749a5$export$40cdac24aa94a57a,
    faHeart: $7435a4b2c8a749a5$export$e4b51a47a2f8b9db,
    faFaceSurprise: $7435a4b2c8a749a5$export$c938968e28178994,
    faSurprise: $7435a4b2c8a749a5$export$46647c72213f53ba,
    faCirclePause: $7435a4b2c8a749a5$export$fbeef2513e05ad08,
    faPauseCircle: $7435a4b2c8a749a5$export$d8cf08a0362da8db,
    faCircle: $7435a4b2c8a749a5$export$4280b2387fbdad12,
    faCircleUp: $7435a4b2c8a749a5$export$72ea8a5e4e86cd69,
    faArrowAltCircleUp: $7435a4b2c8a749a5$export$3747a8ef0995eadf,
    faFileAudio: $7435a4b2c8a749a5$export$b8d24c57c9e64933,
    faFileImage: $7435a4b2c8a749a5$export$6440b286d3cbac9b,
    faCircleQuestion: $7435a4b2c8a749a5$export$d7cf0978afd90002,
    faQuestionCircle: $7435a4b2c8a749a5$export$5ba67d7f2265c1a5,
    faFaceMehBlank: $7435a4b2c8a749a5$export$38c072b870a9e4ab,
    faMehBlank: $7435a4b2c8a749a5$export$e945435725f71e88,
    faEye: $7435a4b2c8a749a5$export$b8c3e79e8c99c95b,
    faFaceSadCry: $7435a4b2c8a749a5$export$e8ea88c55e55be7c,
    faSadCry: $7435a4b2c8a749a5$export$8e924e6bd422cef9,
    faFileCode: $7435a4b2c8a749a5$export$143d0ca7d2200f20,
    faWindowMaximize: $7435a4b2c8a749a5$export$703cd98be31ec905,
    faFaceFrown: $7435a4b2c8a749a5$export$e5f78e87efbb0248,
    faFrown: $7435a4b2c8a749a5$export$43b7108508aecc5f,
    faFloppyDisk: $7435a4b2c8a749a5$export$f62f2879ccaea13f,
    faSave: $7435a4b2c8a749a5$export$1aaa83ff70706e1e,
    faCommentDots: $7435a4b2c8a749a5$export$63ffcb3d4e94cb92,
    faCommenting: $7435a4b2c8a749a5$export$49ee382a2425e89c,
    faFaceGrinSquint: $7435a4b2c8a749a5$export$5d53da7627754bc6,
    faGrinSquint: $7435a4b2c8a749a5$export$243ae757907b1580,
    faHandPointer: $7435a4b2c8a749a5$export$d97ff927c450c87f,
    faHandScissors: $7435a4b2c8a749a5$export$c578e919f2c5c135,
    faFaceGrinTears: $7435a4b2c8a749a5$export$8ac6d81a3d5b40a1,
    faGrinTears: $7435a4b2c8a749a5$export$b2f7512221512b5b,
    faCalendarXmark: $7435a4b2c8a749a5$export$3c70ffe5660af060,
    faCalendarTimes: $7435a4b2c8a749a5$export$99b20d7352fbcf08,
    faFileVideo: $7435a4b2c8a749a5$export$b44eb38345c6a964,
    faFilePdf: $7435a4b2c8a749a5$export$38611f1c776aba73,
    faComment: $7435a4b2c8a749a5$export$805cd88398a70581,
    faEnvelope: $7435a4b2c8a749a5$export$6f095630677adc,
    faHourglass: $7435a4b2c8a749a5$export$b9098a890f61e022,
    faHourglassEmpty: $7435a4b2c8a749a5$export$a2f8176a0161e891,
    faCalendarCheck: $7435a4b2c8a749a5$export$5655108e1162ba45,
    faHardDrive: $7435a4b2c8a749a5$export$4cb736b866cbb7ec,
    faHdd: $7435a4b2c8a749a5$export$62551e9c5ba7093f,
    faFaceGrinSquintTears: $7435a4b2c8a749a5$export$8ff56f5ebb8416a0,
    faGrinSquintTears: $7435a4b2c8a749a5$export$542206d6a85f3b42,
    faRectangleList: $7435a4b2c8a749a5$export$1f7600fa9fdb3978,
    faListAlt: $7435a4b2c8a749a5$export$c6327a203ffc65a3,
    faCalendarPlus: $7435a4b2c8a749a5$export$16768a660ae3ca9d,
    faCircleLeft: $7435a4b2c8a749a5$export$5ae86b9da9cca3bd,
    faArrowAltCircleLeft: $7435a4b2c8a749a5$export$5460a5b11a24996f,
    faMoneyBill1: $7435a4b2c8a749a5$export$a312c7d58dd44a75,
    faMoneyBillAlt: $7435a4b2c8a749a5$export$a35d573395884c3d,
    faClock: $7435a4b2c8a749a5$export$95b9968e7fceb821,
    faClockFour: $7435a4b2c8a749a5$export$9a575facf1cab48f,
    faKeyboard: $7435a4b2c8a749a5$export$fb61df5d98785fa8,
    faClosedCaptioning: $7435a4b2c8a749a5$export$8e047801a8603af7,
    faImages: $7435a4b2c8a749a5$export$74f06b41ed2ca28a,
    faFaceGrin: $7435a4b2c8a749a5$export$92292137ef3cf4c8,
    faGrin: $7435a4b2c8a749a5$export$37e1f10b6de76621,
    faFaceMeh: $7435a4b2c8a749a5$export$dc130582748497c6,
    faMeh: $7435a4b2c8a749a5$export$6d2db489aaeeecd2,
    faIdCard: $7435a4b2c8a749a5$export$782ac893fc22249b,
    faDriversLicense: $7435a4b2c8a749a5$export$8359c70e609eff64,
    faSun: $7435a4b2c8a749a5$export$2fa35dcbc038dbe9,
    faFaceLaughWink: $7435a4b2c8a749a5$export$600a1b26b33c3d47,
    faLaughWink: $7435a4b2c8a749a5$export$77ac40095f39933e,
    faCircleDown: $7435a4b2c8a749a5$export$531badb89cf01312,
    faArrowAltCircleDown: $7435a4b2c8a749a5$export$ff3afbc8c0bc5d59,
    faThumbsDown: $7435a4b2c8a749a5$export$aba24ca305bbe8c1,
    faChessPawn: $7435a4b2c8a749a5$export$3db75d5ac9e98468,
    faCreditCard: $7435a4b2c8a749a5$export$3e7437bf6535bef0,
    faCreditCardAlt: $7435a4b2c8a749a5$export$5fffe8e3c36964a2,
    faBell: $7435a4b2c8a749a5$export$9b6162797ab1b255,
    faFile: $7435a4b2c8a749a5$export$cad54bead856a678,
    faHospital: $7435a4b2c8a749a5$export$7a76c9d35b42d691,
    faHospitalAlt: $7435a4b2c8a749a5$export$cea7736417b94a3b,
    faHospitalWide: $7435a4b2c8a749a5$export$69c8cc0360f017e8,
    faChessRook: $7435a4b2c8a749a5$export$5d65c40a109eb09c,
    faStarHalf: $7435a4b2c8a749a5$export$228008b5e11032fa,
    faChessKing: $7435a4b2c8a749a5$export$d5713874f8fefe1b,
    faCircleUser: $7435a4b2c8a749a5$export$9a5c11a5e3d7f1e7,
    faUserCircle: $7435a4b2c8a749a5$export$be7d974e9e0dba1a,
    faCopy: $7435a4b2c8a749a5$export$e9bd786d30cb716c,
    faShareFromSquare: $7435a4b2c8a749a5$export$928280bdd54fa173,
    faShareSquare: $7435a4b2c8a749a5$export$ae9e1434571f373c,
    faCopyright: $7435a4b2c8a749a5$export$da61665fff8aebfe,
    faMap: $7435a4b2c8a749a5$export$fc82fb79180cd17c,
    faBellSlash: $7435a4b2c8a749a5$export$6b31a1e5968b2378,
    faHandLizard: $7435a4b2c8a749a5$export$54608d0a883fea4d,
    faFaceSmile: $7435a4b2c8a749a5$export$b5023c446f10324,
    faSmile: $7435a4b2c8a749a5$export$c632b2334f0913bc,
    faHandPeace: $7435a4b2c8a749a5$export$e49e3cfceea441cc,
    faFaceGrinHearts: $7435a4b2c8a749a5$export$fbb22081b65e4f33,
    faGrinHearts: $7435a4b2c8a749a5$export$c56cf0e0c3bc5ed2,
    faBuilding: $7435a4b2c8a749a5$export$f26673f8b10c3d46,
    faFaceGrinBeamSweat: $7435a4b2c8a749a5$export$2ff38f330c834084,
    faGrinBeamSweat: $7435a4b2c8a749a5$export$14d0ccc54c5b6826,
    faMoon: $7435a4b2c8a749a5$export$c4c2f69a53bab720,
    faCalendar: $7435a4b2c8a749a5$export$34f5c36a3e80efa2,
    faFaceGrinTongueWink: $7435a4b2c8a749a5$export$4272e56f2429da88,
    faGrinTongueWink: $7435a4b2c8a749a5$export$58099903d50aefb3,
    faClone: $7435a4b2c8a749a5$export$76c1aa4bf9a39458,
    faFaceAngry: $7435a4b2c8a749a5$export$67a047c738fb34da,
    faAngry: $7435a4b2c8a749a5$export$3c96c08e234498c5,
    faRectangleXmark: $7435a4b2c8a749a5$export$3896694b3e81fba7,
    faRectangleTimes: $7435a4b2c8a749a5$export$eaaf26416a51dc1,
    faTimesRectangle: $7435a4b2c8a749a5$export$10147c0014152a3f,
    faWindowClose: $7435a4b2c8a749a5$export$18b7775f78a3e16,
    faPaperPlane: $7435a4b2c8a749a5$export$b5378818301da1be,
    faLifeRing: $7435a4b2c8a749a5$export$53dd2cacf674142a,
    faFaceGrimace: $7435a4b2c8a749a5$export$bd5bd2ef56b793b1,
    faGrimace: $7435a4b2c8a749a5$export$3d08cd36ac1ef231,
    faCalendarMinus: $7435a4b2c8a749a5$export$23e8b4955c2d951b,
    faCircleXmark: $7435a4b2c8a749a5$export$30262489773a79a3,
    faTimesCircle: $7435a4b2c8a749a5$export$ab0ec50720a747eb,
    faXmarkCircle: $7435a4b2c8a749a5$export$90ac4096df8efdee,
    faThumbsUp: $7435a4b2c8a749a5$export$47e4e0d519d33497,
    faWindowMinimize: $7435a4b2c8a749a5$export$26a3f9d2784b90d8,
    faSquareFull: $7435a4b2c8a749a5$export$7ec6541fee081990,
    faNoteSticky: $7435a4b2c8a749a5$export$4a4e034527c933f5,
    faStickyNote: $7435a4b2c8a749a5$export$80889adc5d98bf4a,
    faFaceSadTear: $7435a4b2c8a749a5$export$8a5a0dbb2a17e253,
    faSadTear: $7435a4b2c8a749a5$export$4b5241926f692f91,
    faHandPointLeft: $7435a4b2c8a749a5$export$b276ec3dc9760d39
};


/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */ const $d8206b3ab2e65c05$export$82e9f45cca5ba907 = "fas";
const $d8206b3ab2e65c05$export$f22454595d96c106 = {
    prefix: 'fas',
    iconName: '0',
    icon: [
        320,
        512,
        [],
        "30",
        "M0 192C0 103.6 71.6 32 160 32s160 71.6 160 160l0 128c0 88.4-71.6 160-160 160S0 408.4 0 320L0 192zM160 96c-53 0-96 43-96 96l0 128c0 53 43 96 96 96s96-43 96-96l0-128c0-53-43-96-96-96z"
    ]
};
const $d8206b3ab2e65c05$export$8398cb2addc9e182 = {
    prefix: 'fas',
    iconName: '1',
    icon: [
        256,
        512,
        [],
        "31",
        "M160 64c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.8 1.6l-96 64C-.5 111.2-4.4 131 5.4 145.8s29.7 18.7 44.4 8.9L96 123.8 96 416l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0 96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-352z"
    ]
};
const $d8206b3ab2e65c05$export$ed1a0ff7bd680a1d = {
    prefix: 'fas',
    iconName: '2',
    icon: [
        320,
        512,
        [],
        "32",
        "M142.9 96c-21.5 0-42.2 8.5-57.4 23.8L54.6 150.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L40.2 74.5C67.5 47.3 104.4 32 142.9 32C223 32 288 97 288 177.1c0 38.5-15.3 75.4-42.5 102.6L109.3 416 288 416c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L200.2 234.5c15.2-15.2 23.8-35.9 23.8-57.4c0-44.8-36.3-81.1-81.1-81.1z"
    ]
};
const $d8206b3ab2e65c05$export$74b7ff79ce1818d6 = {
    prefix: 'fas',
    iconName: '3',
    icon: [
        320,
        512,
        [],
        "33",
        "M0 64C0 46.3 14.3 32 32 32l240 0c13.2 0 25 8.1 29.8 20.4s1.5 26.3-8.2 35.2L162.3 208l21.7 0c75.1 0 136 60.9 136 136s-60.9 136-136 136l-78.6 0C63 480 24.2 456 5.3 418.1l-1.9-3.8c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l1.9 3.8c8.1 16.3 24.8 26.5 42.9 26.5l78.6 0c39.8 0 72-32.2 72-72s-32.2-72-72-72L80 272c-13.2 0-25-8.1-29.8-20.4s-1.5-26.3 8.2-35.2L189.7 96 32 96C14.3 96 0 81.7 0 64z"
    ]
};
const $d8206b3ab2e65c05$export$969b2215780d58fd = {
    prefix: 'fas',
    iconName: '4',
    icon: [
        384,
        512,
        [],
        "34",
        "M189 77.6c7.5-16 .7-35.1-15.3-42.6s-35.1-.7-42.6 15.3L3 322.4c-4.7 9.9-3.9 21.5 1.9 30.8S21 368 32 368l224 0 0 80c0 17.7 14.3 32 32 32s32-14.3 32-32l0-80 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-144c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L82.4 304 189 77.6z"
    ]
};
const $d8206b3ab2e65c05$export$3919f68a5b3825a9 = {
    prefix: 'fas',
    iconName: '5',
    icon: [
        320,
        512,
        [],
        "35",
        "M32.5 58.3C35.3 43.1 48.5 32 64 32l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L90.7 96 70.3 208 184 208c75.1 0 136 60.9 136 136s-60.9 136-136 136l-83.5 0c-39.4 0-75.4-22.3-93-57.5l-4.1-8.2c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l4.1 8.2c6.8 13.6 20.6 22.1 35.8 22.1l83.5 0c39.8 0 72-32.2 72-72s-32.2-72-72-72L32 272c-9.5 0-18.5-4.2-24.6-11.5s-8.6-16.9-6.9-26.2l32-176z"
    ]
};
const $d8206b3ab2e65c05$export$580ac17b31ffb5c3 = {
    prefix: 'fas',
    iconName: '6',
    icon: [
        320,
        512,
        [],
        "36",
        "M232.4 84.7c11.4-13.5 9.7-33.7-3.8-45.1s-33.7-9.7-45.1 3.8L38.6 214.7C14.7 242.9 1.1 278.4 .1 315.2c0 1.4-.1 2.9-.1 4.3l0 .5c0 88.4 71.6 160 160 160s160-71.6 160-160c0-85.5-67.1-155.4-151.5-159.8l63.9-75.6zM256 320A96 96 0 1 1 64 320a96 96 0 1 1 192 0z"
    ]
};
const $d8206b3ab2e65c05$export$ee79cab31be16d23 = {
    prefix: 'fas',
    iconName: '7',
    icon: [
        320,
        512,
        [],
        "37",
        "M0 64C0 46.3 14.3 32 32 32l256 0c11.5 0 22 6.1 27.7 16.1s5.7 22.2-.1 32.1l-224 384c-8.9 15.3-28.5 20.4-43.8 11.5s-20.4-28.5-11.5-43.8L232.3 96 32 96C14.3 96 0 81.7 0 64z"
    ]
};
const $d8206b3ab2e65c05$export$45d84c4b2c560d2f = {
    prefix: 'fas',
    iconName: '8',
    icon: [
        320,
        512,
        [],
        "38",
        "M304 160c0-70.7-57.3-128-128-128l-32 0C73.3 32 16 89.3 16 160c0 34.6 13.7 66 36 89C20.5 272.3 0 309.8 0 352c0 70.7 57.3 128 128 128l64 0c70.7 0 128-57.3 128-128c0-42.2-20.5-79.7-52-103c22.3-23 36-54.4 36-89zM176.1 288l15.9 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64s28.7-64 64-64l15.9 0c0 0 .1 0 .1 0l32 0c0 0 .1 0 .1 0zm0-64c0 0 0 0 0 0l-32 0c0 0 0 0 0 0c-35.3 0-64-28.7-64-64c0-35.3 28.7-64 64-64l32 0c35.3 0 64 28.7 64 64c0 35.3-28.6 64-64 64z"
    ]
};
const $d8206b3ab2e65c05$export$a120f1e4223629f2 = {
    prefix: 'fas',
    iconName: '9',
    icon: [
        320,
        512,
        [],
        "39",
        "M64 192a96 96 0 1 0 192 0A96 96 0 1 0 64 192zm87.5 159.8C67.1 347.4 0 277.5 0 192C0 103.6 71.6 32 160 32s160 71.6 160 160c0 2.6-.1 5.3-.2 7.9c-1.7 35.7-15.2 70-38.4 97.4l-145 171.4c-11.4 13.5-31.6 15.2-45.1 3.8s-15.2-31.6-3.8-45.1l63.9-75.6z"
    ]
};
const $d8206b3ab2e65c05$export$38320138fc0262d0 = {
    prefix: 'fas',
    iconName: 'fill-drip',
    icon: [
        576,
        512,
        [],
        "f576",
        "M41.4 9.4C53.9-3.1 74.1-3.1 86.6 9.4L168 90.7l53.1-53.1c28.1-28.1 73.7-28.1 101.8 0L474.3 189.1c28.1 28.1 28.1 73.7 0 101.8L283.9 481.4c-37.5 37.5-98.3 37.5-135.8 0L30.6 363.9c-37.5-37.5-37.5-98.3 0-135.8L122.7 136 41.4 54.6c-12.5-12.5-12.5-32.8 0-45.3zm176 221.3L168 181.3 75.9 273.4c-4.2 4.2-7 9.3-8.4 14.6l319.2 0 42.3-42.3c3.1-3.1 3.1-8.2 0-11.3L277.7 82.9c-3.1-3.1-8.2-3.1-11.3 0L213.3 136l49.4 49.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0zM512 512c-35.3 0-64-28.7-64-64c0-25.2 32.6-79.6 51.2-108.7c6-9.4 19.5-9.4 25.5 0C543.4 368.4 576 422.8 576 448c0 35.3-28.7 64-64 64z"
    ]
};
const $d8206b3ab2e65c05$export$917a3d30f6cd766 = {
    prefix: 'fas',
    iconName: 'arrows-to-circle',
    icon: [
        640,
        512,
        [],
        "e4bd",
        "M9.4 9.4C21.9-3.1 42.1-3.1 54.6 9.4L160 114.7 160 96c0-17.7 14.3-32 32-32s32 14.3 32 32l0 96c0 4.3-.9 8.5-2.4 12.2c-1.6 3.7-3.8 7.3-6.9 10.3l-.1 .1c-3.1 3-6.6 5.3-10.3 6.9c-3.8 1.6-7.9 2.4-12.2 2.4l-96 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l18.7 0L9.4 54.6C-3.1 42.1-3.1 21.9 9.4 9.4zM256 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM114.7 352L96 352c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0s0 0 0 0l.1 0c8.8 0 16.7 3.6 22.5 9.3l.1 .1c3 3.1 5.3 6.6 6.9 10.3c1.6 3.8 2.4 7.9 2.4 12.2l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-18.7L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L114.7 352zM416 96c0-17.7 14.3-32 32-32s32 14.3 32 32l0 18.7L585.4 9.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L525.3 160l18.7 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0c-8.8 0-16.8-3.6-22.6-9.3l-.1-.1c-3-3.1-5.3-6.6-6.9-10.3s-2.4-7.8-2.4-12.2l0-.1s0 0 0 0l0-96zM525.3 352L630.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L480 397.3l0 18.7c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96s0 0 0 0l0-.1c0-4.3 .9-8.4 2.4-12.2c1.6-3.8 3.9-7.3 6.9-10.4c5.8-5.8 13.7-9.3 22.5-9.4l.1 0s0 0 0 0l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-18.7 0z"
    ]
};
const $d8206b3ab2e65c05$export$a39bab13d51abfd0 = {
    prefix: 'fas',
    iconName: 'circle-chevron-right',
    icon: [
        512,
        512,
        [
            "chevron-circle-right"
        ],
        "f138",
        "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM241 377c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87-87-87c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L345 239c9.4 9.4 9.4 24.6 0 33.9L241 377z"
    ]
};
const $d8206b3ab2e65c05$export$2a5db4f6eba6f2b = $d8206b3ab2e65c05$export$a39bab13d51abfd0;
const $d8206b3ab2e65c05$export$c115e8063ee02632 = {
    prefix: 'fas',
    iconName: 'at',
    icon: [
        512,
        512,
        [
            61946
        ],
        "40",
        "M256 64C150 64 64 150 64 256s86 192 192 192c17.7 0 32 14.3 32 32s-14.3 32-32 32C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256l0 32c0 53-43 96-96 96c-29.3 0-55.6-13.2-73.2-33.9C320 371.1 289.5 384 256 384c-70.7 0-128-57.3-128-128s57.3-128 128-128c27.9 0 53.7 8.9 74.7 24.1c5.7-5 13.1-8.1 21.3-8.1c17.7 0 32 14.3 32 32l0 80 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32c0-106-86-192-192-192zm64 192a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
    ]
};
const $d8206b3ab2e65c05$export$864bb8d6c21fb792 = {
    prefix: 'fas',
    iconName: 'trash-can',
    icon: [
        448,
        512,
        [
            61460,
            "trash-alt"
        ],
        "f2ed",
        "M135.2 17.7C140.6 6.8 151.7 0 163.8 0L284.2 0c12.1 0 23.2 6.8 28.6 17.7L320 32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l96 0 7.2-14.3zM32 128l384 0 0 320c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-320zm96 64c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16z"
    ]
};
const $d8206b3ab2e65c05$export$88df7ff7eb32f9dc = $d8206b3ab2e65c05$export$864bb8d6c21fb792;
const $d8206b3ab2e65c05$export$3313bce3924ea7da = {
    prefix: 'fas',
    iconName: 'text-height',
    icon: [
        576,
        512,
        [],
        "f034",
        "M64 128l0-32 64 0 0 320-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-320 64 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-48c0-26.5-21.5-48-48-48L160 32 48 32C21.5 32 0 53.5 0 80l0 48c0 17.7 14.3 32 32 32s32-14.3 32-32zM502.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l32 0 0 192-32 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8l-32 0 0-192 32 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64z"
    ]
};
const $d8206b3ab2e65c05$export$e585697127cda27 = {
    prefix: 'fas',
    iconName: 'user-xmark',
    icon: [
        640,
        512,
        [
            "user-times"
        ],
        "f235",
        "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3zM471 143c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
const $d8206b3ab2e65c05$export$45b996d071667753 = $d8206b3ab2e65c05$export$e585697127cda27;
const $d8206b3ab2e65c05$export$acb2d72d28cd92d9 = {
    prefix: 'fas',
    iconName: 'stethoscope',
    icon: [
        576,
        512,
        [
            129658
        ],
        "f0f1",
        "M142.4 21.9c5.6 16.8-3.5 34.9-20.2 40.5L96 71.1 96 192c0 53 43 96 96 96s96-43 96-96l0-120.9-26.1-8.7c-16.8-5.6-25.8-23.7-20.2-40.5s23.7-25.8 40.5-20.2l26.1 8.7C334.4 19.1 352 43.5 352 71.1L352 192c0 77.2-54.6 141.6-127.3 156.7C231 404.6 278.4 448 336 448c61.9 0 112-50.1 112-112l0-70.7c-28.3-12.3-48-40.5-48-73.3c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3l0 70.7c0 97.2-78.8 176-176 176c-92.9 0-168.9-71.9-175.5-163.1C87.2 334.2 32 269.6 32 192L32 71.1c0-27.5 17.6-52 43.8-60.7l26.1-8.7c16.8-5.6 34.9 3.5 40.5 20.2zM480 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
const $d8206b3ab2e65c05$export$6563a67224e7f879 = {
    prefix: 'fas',
    iconName: 'message',
    icon: [
        512,
        512,
        [
            "comment-alt"
        ],
        "f27a",
        "M64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l96 0 0 80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416 448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0z"
    ]
};
const $d8206b3ab2e65c05$export$6e96904d9af0ec4a = $d8206b3ab2e65c05$export$6563a67224e7f879;
const $d8206b3ab2e65c05$export$d469b770895f47ac = {
    prefix: 'fas',
    iconName: 'info',
    icon: [
        192,
        512,
        [],
        "f129",
        "M48 80a48 48 0 1 1 96 0A48 48 0 1 1 48 80zM0 224c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 224 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-192-32 0c-17.7 0-32-14.3-32-32z"
    ]
};
const $d8206b3ab2e65c05$export$d56736f5800b3f0d = {
    prefix: 'fas',
    iconName: 'down-left-and-up-right-to-center',
    icon: [
        512,
        512,
        [
            "compress-alt"
        ],
        "f422",
        "M439 7c9.4-9.4 24.6-9.4 33.9 0l32 32c9.4 9.4 9.4 24.6 0 33.9l-87 87 39 39c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8l-144 0c-13.3 0-24-10.7-24-24l0-144c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l39 39L439 7zM72 272l144 0c13.3 0 24 10.7 24 24l0 144c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39L73 505c-9.4 9.4-24.6 9.4-33.9 0L7 473c-9.4-9.4-9.4-24.6 0-33.9l87-87L55 313c-6.9-6.9-8.9-17.2-5.2-26.2s12.5-14.8 22.2-14.8z"
    ]
};
const $d8206b3ab2e65c05$export$a05650ebe54bede = $d8206b3ab2e65c05$export$d56736f5800b3f0d;
const $d8206b3ab2e65c05$export$36b5fbeae4855055 = {
    prefix: 'fas',
    iconName: 'explosion',
    icon: [
        576,
        512,
        [],
        "e4e9",
        "M499.6 11.3c6.7-10.7 20.5-14.5 31.7-8.5s15.8 19.5 10.6 31L404.8 338.6c2.2 2.3 4.3 4.7 6.3 7.1l97.2-54.7c10.5-5.9 23.6-3.1 30.9 6.4s6.3 23-2.2 31.5l-87 87-71.4 0c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64l-79.6 0L42.3 363.7c-9.7-6.7-13.1-19.6-7.9-30.3s17.4-15.9 28.7-12.4l97.2 30.4c3-3.9 6.1-7.7 9.4-11.3L107.4 236.3c-6.1-10.1-3.9-23.1 5.1-30.7s22.2-7.5 31.1 .1L246 293.6c1.5-.4 3-.8 4.5-1.1l13.6-142.7c1.2-12.3 11.5-21.7 23.9-21.7s22.7 9.4 23.9 21.7l13.5 141.9L499.6 11.3zM64 448s0 0 0 0l448 0s0 0 0 0l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0zM288 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24z"
    ]
};
const $d8206b3ab2e65c05$export$ef565d07efe2b5e9 = {
    prefix: 'fas',
    iconName: 'file-lines',
    icon: [
        384,
        512,
        [
            128441,
            128462,
            61686,
            "file-alt",
            "file-text"
        ],
        "f15c",
        "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM112 256l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
const $d8206b3ab2e65c05$export$243b47dca32bf0b8 = $d8206b3ab2e65c05$export$ef565d07efe2b5e9;
const $d8206b3ab2e65c05$export$f466100bf9bf37a5 = $d8206b3ab2e65c05$export$ef565d07efe2b5e9;
const $d8206b3ab2e65c05$export$c38cf504b3bc58a2 = {
    prefix: 'fas',
    iconName: 'wave-square',
    icon: [
        640,
        512,
        [],
        "f83e",
        "M128 64c0-17.7 14.3-32 32-32l160 0c17.7 0 32 14.3 32 32l0 352 96 0 0-160c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0 0 160c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-352-96 0 0 160c0 17.7-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0 0-160z"
    ]
};
const $d8206b3ab2e65c05$export$a95486586631edc7 = {
    prefix: 'fas',
    iconName: 'ring',
    icon: [
        512,
        512,
        [],
        "f70b",
        "M64 208c0 7.8 4.4 18.7 17.1 30.3C126.5 214.1 188.9 200 256 200s129.5 14.1 174.9 38.3C443.6 226.7 448 215.8 448 208c0-12.3-10.8-32-47.9-50.6C364.9 139.8 314 128 256 128s-108.9 11.8-144.1 29.4C74.8 176 64 195.7 64 208zm192 40c-47 0-89.3 7.6-122.9 19.7C166.3 280.2 208.8 288 256 288s89.7-7.8 122.9-20.3C345.3 255.6 303 248 256 248zM0 208c0-49.6 39.4-85.8 83.3-107.8C129.1 77.3 190.3 64 256 64s126.9 13.3 172.7 36.2c43.9 22 83.3 58.2 83.3 107.8l0 96c0 49.6-39.4 85.8-83.3 107.8C382.9 434.7 321.7 448 256 448s-126.9-13.3-172.7-36.2C39.4 389.8 0 353.6 0 304l0-96z"
    ]
};
const $d8206b3ab2e65c05$export$fbbc7601eb465ac7 = {
    prefix: 'fas',
    iconName: 'building-un',
    icon: [
        384,
        512,
        [],
        "e4d9",
        "M48 0C21.5 0 0 21.5 0 48L0 464c0 26.5 21.5 48 48 48l96 0 0-80c0-26.5 21.5-48 48-48s48 21.5 48 48l0 80 96 0c26.5 0 48-21.5 48-48l0-416c0-26.5-21.5-48-48-48L48 0zM64 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm112-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM237.3 71.1l34.7 52L272 80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52 0 43.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM112 80l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
const $d8206b3ab2e65c05$export$221059e0d5fd8958 = {
    prefix: 'fas',
    iconName: 'dice-three',
    icon: [
        448,
        512,
        [
            9858
        ],
        "f527",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm64 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $d8206b3ab2e65c05$export$31c6cf6f5d38dc0 = {
    prefix: 'fas',
    iconName: 'calendar-days',
    icon: [
        448,
        512,
        [
            "calendar-alt"
        ],
        "f073",
        "M128 0c17.7 0 32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 48 0c26.5 0 48 21.5 48 48l0 48L0 160l0-48C0 85.5 21.5 64 48 64l48 0 0-32c0-17.7 14.3-32 32-32zM0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192zm64 80l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm128 0l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM64 400l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm112 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z"
    ]
};
const $d8206b3ab2e65c05$export$cbc139f33cff356 = $d8206b3ab2e65c05$export$31c6cf6f5d38dc0;
const $d8206b3ab2e65c05$export$8bce49e6ae597af8 = {
    prefix: 'fas',
    iconName: 'anchor-circle-check',
    icon: [
        640,
        512,
        [],
        "e4aa",
        "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80L224 176c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 208-48 0c-53 0-96-43-96-96l0-6.1 7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7 0 6.1c0 88.4 71.6 160 160 160l80 0 80 0c8.2 0 16.3-.6 24.2-1.8c-22.2-16.2-40.4-37.5-53-62.2L320 448l0-80 0-128 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-10.9 0zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
const $d8206b3ab2e65c05$export$37584b1a5e175b47 = {
    prefix: 'fas',
    iconName: 'building-circle-arrow-right',
    icon: [
        640,
        512,
        [],
        "e4d1",
        "M0 48C0 21.5 21.5 0 48 0L336 0c26.5 0 48 21.5 48 48l0 184.2c-39.1 32.3-64 81.1-64 135.8c0 49.5 20.4 94.2 53.3 126.2C364.5 505.1 351.1 512 336 512l-96 0 0-80c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 80-96 0c-26.5 0-48-21.5-48-48L0 48zM80 224c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm80 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM64 112l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16L80 96c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm80 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm96 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm140.7-67.3c-6.2 6.2-6.2 16.4 0 22.6L521.4 352 432 352c-8.8 0-16 7.2-16 16s7.2 16 16 16l89.4 0-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56-56c6.2-6.2 6.2-16.4 0-22.6l-56-56c-6.2-6.2-16.4-6.2-22.6 0z"
    ]
};
const $d8206b3ab2e65c05$export$cc519c9529a46c5c = {
    prefix: 'fas',
    iconName: 'volleyball',
    icon: [
        512,
        512,
        [
            127952,
            "volleyball-ball"
        ],
        "f45f",
        "M511.8 267.4c-26.1 8.7-53.4 13.8-81 15.1c9.2-105.3-31.5-204.2-103.2-272.4C434.1 41.1 512 139.5 512 256c0 3.8-.1 7.6-.2 11.4zm-3.9 34.7c-5.8 32-17.6 62-34.2 88.7c-97.5 48.5-217.7 42.6-311.9-24.5c23.7-36.2 55.4-67.7 94.5-91.8c79.9 43.2 170.1 50.8 251.6 27.6zm-236-55.5c-2.5-90.9-41.1-172.7-101.9-231.7C196.8 5.2 225.8 0 256 0c2.7 0 5.3 0 7.9 .1c90.8 60.2 145.7 167.2 134.7 282.3c-43.1-2.4-86.4-14.1-126.8-35.9zM138 28.8c20.6 18.3 38.7 39.4 53.7 62.6C95.9 136.1 30.6 220.8 7.3 316.9C2.5 297.4 0 277 0 256C0 157.2 56 71.5 138 28.8zm69.6 90.5c19.5 38.6 31 81.9 32.3 127.7C162.5 294.6 110.9 368.9 90.2 451C66 430.4 45.6 405.4 30.4 377.2c6.7-108.7 71.9-209.9 177.1-257.9zM256 512c-50.7 0-98-14.7-137.8-40.2c5.6-27 14.8-53.1 27.4-77.7C232.2 454.6 338.1 468.8 433 441c-46 44-108.3 71-177 71z"
    ]
};
const $d8206b3ab2e65c05$export$a15e6fc8e68a76b0 = $d8206b3ab2e65c05$export$cc519c9529a46c5c;
const $d8206b3ab2e65c05$export$159982ce2622211e = {
    prefix: 'fas',
    iconName: 'arrows-up-to-line',
    icon: [
        576,
        512,
        [],
        "e4c2",
        "M32 96l512 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32C14.3 32 0 46.3 0 64S14.3 96 32 96zM9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L96 237.3 96 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-210.7 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0l-96 96zm320 45.3c12.5 12.5 32.8 12.5 45.3 0L416 237.3 416 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-210.7 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3z"
    ]
};
const $d8206b3ab2e65c05$export$58e2577a373e7d4 = {
    prefix: 'fas',
    iconName: 'sort-down',
    icon: [
        320,
        512,
        [
            "sort-desc"
        ],
        "f0dd",
        "M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l256 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z"
    ]
};
const $d8206b3ab2e65c05$export$e24f016f5f78af6a = $d8206b3ab2e65c05$export$58e2577a373e7d4;
const $d8206b3ab2e65c05$export$d0163707993a8110 = {
    prefix: 'fas',
    iconName: 'circle-minus',
    icon: [
        512,
        512,
        [
            "minus-circle"
        ],
        "f056",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 232l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
const $d8206b3ab2e65c05$export$f3979b49bf57313c = $d8206b3ab2e65c05$export$d0163707993a8110;
const $d8206b3ab2e65c05$export$41821b9a6fd703de = {
    prefix: 'fas',
    iconName: 'door-open',
    icon: [
        576,
        512,
        [],
        "f52b",
        "M320 32c0-9.9-4.5-19.2-12.3-25.2S289.8-1.4 280.2 1l-179.9 45C79 51.3 64 70.5 64 92.5L64 448l-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0 192 0 32 0 0-32 0-448zM256 256c0 17.7-10.7 32-24 32s-24-14.3-24-32s10.7-32 24-32s24 14.3 24 32zm96-128l96 0 0 352c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-320c0-35.3-28.7-64-64-64l-96 0 0 64z"
    ]
};
const $d8206b3ab2e65c05$export$122a80ae0f87f726 = {
    prefix: 'fas',
    iconName: 'right-from-bracket',
    icon: [
        512,
        512,
        [
            "sign-out-alt"
        ],
        "f2f5",
        "M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z"
    ]
};
const $d8206b3ab2e65c05$export$c844d6923b7096c2 = $d8206b3ab2e65c05$export$122a80ae0f87f726;
const $d8206b3ab2e65c05$export$b5bb295e8ad4ab31 = {
    prefix: 'fas',
    iconName: 'atom',
    icon: [
        512,
        512,
        [
            9883
        ],
        "f5d2",
        "M256 398.8c-11.8 5.1-23.4 9.7-34.9 13.5c16.7 33.8 31 35.7 34.9 35.7s18.1-1.9 34.9-35.7c-11.4-3.9-23.1-8.4-34.9-13.5zM446 256c33 45.2 44.3 90.9 23.6 128c-20.2 36.3-62.5 49.3-115.2 43.2c-22 52.1-55.6 84.8-98.4 84.8s-76.4-32.7-98.4-84.8c-52.7 6.1-95-6.8-115.2-43.2C21.7 346.9 33 301.2 66 256c-33-45.2-44.3-90.9-23.6-128c20.2-36.3 62.5-49.3 115.2-43.2C179.6 32.7 213.2 0 256 0s76.4 32.7 98.4 84.8c52.7-6.1 95 6.8 115.2 43.2c20.7 37.1 9.4 82.8-23.6 128zm-65.8 67.4c-1.7 14.2-3.9 28-6.7 41.2c31.8 1.4 38.6-8.7 40.2-11.7c2.3-4.2 7-17.9-11.9-48.1c-6.8 6.3-14 12.5-21.6 18.6zm-6.7-175.9c2.8 13.1 5 26.9 6.7 41.2c7.6 6.1 14.8 12.3 21.6 18.6c18.9-30.2 14.2-44 11.9-48.1c-1.6-2.9-8.4-13-40.2-11.7zM290.9 99.7C274.1 65.9 259.9 64 256 64s-18.1 1.9-34.9 35.7c11.4 3.9 23.1 8.4 34.9 13.5c11.8-5.1 23.4-9.7 34.9-13.5zm-159 88.9c1.7-14.3 3.9-28 6.7-41.2c-31.8-1.4-38.6 8.7-40.2 11.7c-2.3 4.2-7 17.9 11.9 48.1c6.8-6.3 14-12.5 21.6-18.6zM110.2 304.8C91.4 335 96 348.7 98.3 352.9c1.6 2.9 8.4 13 40.2 11.7c-2.8-13.1-5-26.9-6.7-41.2c-7.6-6.1-14.8-12.3-21.6-18.6zM336 256a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-80-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $d8206b3ab2e65c05$export$64f1c53b21f310ac = {
    prefix: 'fas',
    iconName: 'soap',
    icon: [
        512,
        512,
        [
            129532
        ],
        "e06e",
        "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM320 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM416 32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0 160c0 27.6-11.7 52.5-30.4 70.1C422.1 275.7 448 310.8 448 352c0 53-43 96-96 96l-192 0c-53 0-96-43-96-96s43-96 96-96l88.4 0c-15.2-17-24.4-39.4-24.4-64L96 192c-53 0-96 43-96 96L0 416c0 53 43 96 96 96l320 0c53 0 96-43 96-96l0-128c0-53-43-96-96-96zM160 288c-35.3 0-64 28.7-64 64s28.7 64 64 64l192 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-32 0-160 0z"
    ]
};
const $d8206b3ab2e65c05$export$7fe2894454d8eb8a = {
    prefix: 'fas',
    iconName: 'icons',
    icon: [
        512,
        512,
        [
            "heart-music-camera-bolt"
        ],
        "f86d",
        "M500.3 7.3C507.7 13.3 512 22.4 512 32l0 144c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48l0-57L352 90.2 352 208c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48l0-96c0-15.3 10.8-28.4 25.7-31.4l160-32c9.4-1.9 19.1 .6 26.6 6.6zM74.7 304l11.8-17.8c5.9-8.9 15.9-14.2 26.6-14.2l61.7 0c10.7 0 20.7 5.3 26.6 14.2L213.3 304l26.7 0c26.5 0 48 21.5 48 48l0 112c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 352c0-26.5 21.5-48 48-48l26.7 0zM192 408a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM478.7 278.3L440.3 368l55.7 0c6.7 0 12.6 4.1 15 10.4s.6 13.3-4.4 17.7l-128 112c-5.6 4.9-13.9 5.3-19.9 .9s-8.2-12.4-5.3-19.2L391.7 400 336 400c-6.7 0-12.6-4.1-15-10.4s-.6-13.3 4.4-17.7l128-112c5.6-4.9 13.9-5.3 19.9-.9s8.2 12.4 5.3 19.2zm-339-59.2c-6.5 6.5-17 6.5-23 0L19.9 119.2c-28-29-26.5-76.9 5-103.9c27-23.5 68.4-19 93.4 6.5l10 10.5 9.5-10.5c25-25.5 65.9-30 93.9-6.5c31 27 32.5 74.9 4.5 103.9l-96.4 99.9z"
    ]
};
const $d8206b3ab2e65c05$export$ec74c13cedb0791d = $d8206b3ab2e65c05$export$7fe2894454d8eb8a;
const $d8206b3ab2e65c05$export$4be1b324ac8a71ba = {
    prefix: 'fas',
    iconName: 'microphone-lines-slash',
    icon: [
        640,
        512,
        [
            "microphone-alt-slash"
        ],
        "f539",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c15.2-26 23.9-56.3 23.9-88.7l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 24 0 16c0 21.2-5.1 41.1-14.2 58.7L416 300.8l0-44.8-57.1 0-34.5-27c2.9-3.1 7-5 11.6-5l80 0 0-32-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-32-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0c0-53-43-96-96-96s-96 43-96 96l0 54.3L38.8 5.1zm362.5 407l-43.1-33.9C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128l0-8.7L144.7 210c-.5 1.9-.7 3.9-.7 6l0 40c0 89.1 66.2 162.7 152 174.4l0 33.6-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-33.6c20.4-2.8 39.7-9.1 57.3-18.2z"
    ]
};
const $d8206b3ab2e65c05$export$d2a53a388f30780 = $d8206b3ab2e65c05$export$4be1b324ac8a71ba;
const $d8206b3ab2e65c05$export$ea908d3d80c57d08 = {
    prefix: 'fas',
    iconName: 'bridge-circle-check',
    icon: [
        640,
        512,
        [],
        "e4c9",
        "M64 32C46.3 32 32 46.3 32 64s14.3 32 32 32l40 0 0 64-72 0 0 128c53 0 96 43 96 96l0 64c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-64c0-53 43-96 96-96c6.3 0 12.4 .6 18.3 1.7C367.1 231.8 426.9 192 496 192c42.5 0 81.6 15.1 112 40.2l0-72.2-72 0 0-64 40 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L64 32zM488 96l0 64-80 0 0-64 80 0zM360 96l0 64-80 0 0-64 80 0zM232 96l0 64-80 0 0-64 80 0zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
const $d8206b3ab2e65c05$export$f1b881c73328720c = {
    prefix: 'fas',
    iconName: 'pump-medical',
    icon: [
        448,
        512,
        [],
        "e06a",
        "M128 32l0 96 128 0 0-32 60.1 0c4.2 0 8.3 1.7 11.3 4.7l33.9 33.9c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L372.7 55.4c-15-15-35.4-23.4-56.6-23.4L256 32c0-17.7-14.3-32-32-32L160 0c-17.7 0-32 14.3-32 32zM117.4 160c-33.3 0-61 25.5-63.8 58.7L35 442.7C31.9 480 61.3 512 98.8 512l186.4 0c37.4 0 66.9-32 63.8-69.3l-18.7-224c-2.8-33.2-30.5-58.7-63.8-58.7l-149.1 0zM216 280l0 32 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0 0 32c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-32-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l32 0 0-32c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
const $d8206b3ab2e65c05$export$614dc068d88655af = {
    prefix: 'fas',
    iconName: 'fingerprint',
    icon: [
        512,
        512,
        [],
        "f577",
        "M48 256C48 141.1 141.1 48 256 48c63.1 0 119.6 28.1 157.8 72.5c8.6 10.1 23.8 11.2 33.8 2.6s11.2-23.8 2.6-33.8C403.3 34.6 333.7 0 256 0C114.6 0 0 114.6 0 256l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40zm458.5-52.9c-2.7-13-15.5-21.3-28.4-18.5s-21.3 15.5-18.5 28.4c2.9 13.9 4.5 28.3 4.5 43.1l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40c0-18.1-1.9-35.8-5.5-52.9zM256 80c-19 0-37.4 3-54.5 8.6c-15.2 5-18.7 23.7-8.3 35.9c7.1 8.3 18.8 10.8 29.4 7.9c10.6-2.9 21.8-4.4 33.4-4.4c70.7 0 128 57.3 128 128l0 24.9c0 25.2-1.5 50.3-4.4 75.3c-1.7 14.6 9.4 27.8 24.2 27.8c11.8 0 21.9-8.6 23.3-20.3c3.3-27.4 5-55 5-82.7l0-24.9c0-97.2-78.8-176-176-176zM150.7 148.7c-9.1-10.6-25.3-11.4-33.9-.4C93.7 178 80 215.4 80 256l0 24.9c0 24.2-2.6 48.4-7.8 71.9C68.8 368.4 80.1 384 96.1 384c10.5 0 19.9-7 22.2-17.3c6.4-28.1 9.7-56.8 9.7-85.8l0-24.9c0-27.2 8.5-52.4 22.9-73.1c7.2-10.4 8-24.6-.2-34.2zM256 160c-53 0-96 43-96 96l0 24.9c0 35.9-4.6 71.5-13.8 106.1c-3.8 14.3 6.7 29 21.5 29c9.5 0 17.9-6.2 20.4-15.4c10.5-39 15.9-79.2 15.9-119.7l0-24.9c0-28.7 23.3-52 52-52s52 23.3 52 52l0 24.9c0 36.3-3.5 72.4-10.4 107.9c-2.7 13.9 7.7 27.2 21.8 27.2c10.2 0 19-7 21-17c7.7-38.8 11.6-78.3 11.6-118.1l0-24.9c0-53-43-96-96-96zm24 96c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 24.9c0 59.9-11 119.3-32.5 175.2l-5.9 15.3c-4.8 12.4 1.4 26.3 13.8 31s26.3-1.4 31-13.8l5.9-15.3C267.9 411.9 280 346.7 280 280.9l0-24.9z"
    ]
};
const $d8206b3ab2e65c05$export$f7bc8714c970afa4 = {
    prefix: 'fas',
    iconName: 'hand-point-right',
    icon: [
        512,
        512,
        [],
        "f0a4",
        "M480 96c17.7 0 32 14.3 32 32s-14.3 32-32 32l-208 0 0-64 208 0zM320 288c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0zm64-64c0 17.7-14.3 32-32 32l-48 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l48 0c17.7 0 32 14.3 32 32zM288 384c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0zm-88-96l.6 0c-5.4 9.4-8.6 20.3-8.6 32c0 13.2 4 25.4 10.8 35.6C177.9 364.3 160 388.1 160 416c0 11.7 3.1 22.6 8.6 32l-8.6 0C71.6 448 0 376.4 0 288l0-61.7c0-42.4 16.9-83.1 46.9-113.1l11.6-11.6C82.5 77.5 115.1 64 149 64l27 0c35.3 0 64 28.7 64 64l0 88c0 22.1-17.9 40-40 40s-40-17.9-40-40l0-56c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 56c0 39.8 32.2 72 72 72z"
    ]
};
const $d8206b3ab2e65c05$export$234a18b2b4d530a3 = {
    prefix: 'fas',
    iconName: 'magnifying-glass-location',
    icon: [
        512,
        512,
        [
            "search-location"
        ],
        "f689",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM288 176c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 48.8 46.5 111.6 68.6 138.6c6 7.3 16.8 7.3 22.7 0c22.1-27 68.6-89.8 68.6-138.6zm-112 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
const $d8206b3ab2e65c05$export$c33aba6c251a898a = $d8206b3ab2e65c05$export$234a18b2b4d530a3;
const $d8206b3ab2e65c05$export$908d699be6717adc = {
    prefix: 'fas',
    iconName: 'forward-step',
    icon: [
        320,
        512,
        [
            "step-forward"
        ],
        "f051",
        "M52.5 440.6c-9.5 7.9-22.8 9.7-34.1 4.4S0 428.4 0 416L0 96C0 83.6 7.2 72.3 18.4 67s24.5-3.6 34.1 4.4l192 160L256 241l0-145c0-17.7 14.3-32 32-32s32 14.3 32 32l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-145-11.5 9.6-192 160z"
    ]
};
const $d8206b3ab2e65c05$export$b303329afce5de18 = $d8206b3ab2e65c05$export$908d699be6717adc;
const $d8206b3ab2e65c05$export$e3c56ed54f074063 = {
    prefix: 'fas',
    iconName: 'face-smile-beam',
    icon: [
        512,
        512,
        [
            128522,
            "smile-beam"
        ],
        "f5b8",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.1 325.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zm53.5-96.7s0 0 0 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0zm160 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0z"
    ]
};
const $d8206b3ab2e65c05$export$54ada6dc9690e0ca = $d8206b3ab2e65c05$export$e3c56ed54f074063;
const $d8206b3ab2e65c05$export$92fad97e19a9fea = {
    prefix: 'fas',
    iconName: 'flag-checkered',
    icon: [
        448,
        512,
        [
            127937
        ],
        "f11e",
        "M32 0C49.7 0 64 14.3 64 32l0 16 69-17.2c38.1-9.5 78.3-5.1 113.5 12.5c46.3 23.2 100.8 23.2 147.1 0l9.6-4.8C423.8 28.1 448 43.1 448 66.1l0 279.7c0 13.3-8.3 25.3-20.8 30l-34.7 13c-46.2 17.3-97.6 14.6-141.7-7.4c-37.9-19-81.3-23.7-122.5-13.4L64 384l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-80 0-66L0 64 0 32C0 14.3 14.3 0 32 0zM64 187.1l64-13.9 0 65.5L64 252.6 64 318l48.8-12.2c5.1-1.3 10.1-2.4 15.2-3.3l0-63.9 38.9-8.4c8.3-1.8 16.7-2.5 25.1-2.1l0-64c13.6 .4 27.2 2.6 40.4 6.4l23.6 6.9 0 66.7-41.7-12.3c-7.3-2.1-14.8-3.4-22.3-3.8l0 71.4c21.8 1.9 43.3 6.7 64 14.4l0-69.8 22.7 6.7c13.5 4 27.3 6.4 41.3 7.4l0-64.2c-7.8-.8-15.6-2.3-23.2-4.5l-40.8-12 0-62c-13-3.8-25.8-8.8-38.2-15c-8.2-4.1-16.9-7-25.8-8.8l0 72.4c-13-.4-26 .8-38.7 3.6L128 173.2 128 98 64 114l0 73.1zM320 335.7c16.8 1.5 33.9-.7 50-6.8l14-5.2 0-71.7-7.9 1.8c-18.4 4.3-37.3 5.7-56.1 4.5l0 77.4zm64-149.4l0-70.8c-20.9 6.1-42.4 9.1-64 9.1l0 69.4c13.9 1.4 28 .5 41.7-2.6l22.3-5.2z"
    ]
};
const $d8206b3ab2e65c05$export$e15f65e77f717c29 = {
    prefix: 'fas',
    iconName: 'football',
    icon: [
        512,
        512,
        [
            127944,
            "football-ball"
        ],
        "f44e",
        "M247.5 25.4c-13.5 3.3-26.4 7.2-38.6 11.7C142.9 61.6 96.7 103.6 66 153.6C47.8 183.4 35.1 215.9 26.9 249L264.5 486.6c13.5-3.3 26.4-7.2 38.6-11.7c66-24.5 112.2-66.5 142.9-116.5c18.3-29.8 30.9-62.3 39.1-95.3L247.5 25.4zM495.2 205.3c6.1-56.8 1.4-112.2-7.7-156.4c-2.7-12.9-13-22.9-26.1-25.1c-58.2-9.7-109.9-12-155.6-7.9L495.2 205.3zM206.1 496L16.8 306.7c-6.1 56.8-1.4 112.2 7.7 156.4c2.7 12.9 13 22.9 26.1 25.1c58.2 9.7 109.9 12 155.6 7.9zm54.6-331.3c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-48 48c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-48 48c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6z"
    ]
};
const $d8206b3ab2e65c05$export$e8fd664711e31704 = $d8206b3ab2e65c05$export$e15f65e77f717c29;
const $d8206b3ab2e65c05$export$f629fdee00932a01 = {
    prefix: 'fas',
    iconName: 'school-circle-exclamation',
    icon: [
        640,
        512,
        [],
        "e56c",
        "M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96 48 96C21.5 96 0 117.5 0 144L0 464c0 26.5 21.5 48 48 48l272 0s0 0 0 0l-64 0 0-96c0-35.3 28.7-64 64-64l.3 0 .5 0c3.4-37.7 18.7-72.1 42.2-99.1C350.2 260 335.6 264 320 264c-48.6 0-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4c29-21 64.6-33.4 103.1-33.4c59.5 0 112.1 29.6 144 74.8L640 144c0-26.5-21.5-48-48-48L473.7 96 337.8 5.4zM96 192l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zm0 128l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zM320 128c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-16c0-8.8-7.2-16-16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16z"
    ]
};
const $d8206b3ab2e65c05$export$afa58590dfb6fca2 = {
    prefix: 'fas',
    iconName: 'crop',
    icon: [
        512,
        512,
        [],
        "f125",
        "M448 109.3l54.6-54.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L402.7 64 160 64l0 64 178.7 0L128 338.7 128 32c0-17.7-14.3-32-32-32S64 14.3 64 32l0 32L32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l32 0 0 256c0 35.3 28.7 64 64 64l224 0 0-64-178.7 0L384 173.3 384 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-274.7z"
    ]
};
const $d8206b3ab2e65c05$export$52783a541b1bb03 = {
    prefix: 'fas',
    iconName: 'angles-down',
    icon: [
        448,
        512,
        [
            "angle-double-down"
        ],
        "f103",
        "M246.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 402.7 361.4 265.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-160 160zm160-352l-160 160c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 210.7 361.4 73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3z"
    ]
};
const $d8206b3ab2e65c05$export$fd504117f273ca92 = $d8206b3ab2e65c05$export$52783a541b1bb03;
const $d8206b3ab2e65c05$export$a28757068b9a3a9a = {
    prefix: 'fas',
    iconName: 'users-rectangle',
    icon: [
        640,
        512,
        [],
        "e594",
        "M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l448 0c53 0 96-43 96-96l0-320c0-53-43-96-96-96L96 0zM64 96c0-17.7 14.3-32 32-32l448 0c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32L64 96zm159.8 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM96 309.3c0 14.7 11.9 26.7 26.7 26.7l56.1 0c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4l-69.3 0C119.9 256 96 279.9 96 309.3zM461.2 336l56.1 0c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3l-69.3 0c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6zM372 289c-3.9-.7-7.9-1-12-1l-80 0c-4.1 0-8.1 .3-12 1c-26 4.4-47.3 22.7-55.9 47c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24c-8.6-24.3-29.9-42.6-55.9-47zM512 176a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM320 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"
    ]
};
const $d8206b3ab2e65c05$export$b96e695bdcf3f3f5 = {
    prefix: 'fas',
    iconName: 'people-roof',
    icon: [
        640,
        512,
        [],
        "e537",
        "M335.5 4l288 160c15.4 8.6 21 28.1 12.4 43.5s-28.1 21-43.5 12.4L320 68.6 47.5 220c-15.4 8.6-34.9 3-43.5-12.4s-3-34.9 12.4-43.5L304.5 4c9.7-5.4 21.4-5.4 31.1 0zM320 160a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM144 256a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm312 40a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM226.9 491.4L200 441.5l0 38.5c0 17.7-14.3 32-32 32l-48 0c-17.7 0-32-14.3-32-32l0-38.5L61.1 491.4c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l37.9-70.3c15.3-28.5 45.1-46.3 77.5-46.3l19.5 0c16.3 0 31.9 4.5 45.4 12.6l33.6-62.3c15.3-28.5 45.1-46.3 77.5-46.3l19.5 0c32.4 0 62.1 17.8 77.5 46.3l33.6 62.3c13.5-8.1 29.1-12.6 45.4-12.6l19.5 0c32.4 0 62.1 17.8 77.5 46.3l37.9 70.3c6.3 11.7 1.9 26.2-9.8 32.5s-26.2 1.9-32.5-9.8L552 441.5l0 38.5c0 17.7-14.3 32-32 32l-48 0c-17.7 0-32-14.3-32-32l0-38.5-26.9 49.9c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l36.3-67.5c-1.7-1.7-3.2-3.6-4.3-5.8L376 345.5l0 54.5c0 17.7-14.3 32-32 32l-48 0c-17.7 0-32-14.3-32-32l0-54.5-26.9 49.9c-1.2 2.2-2.6 4.1-4.3 5.8l36.3 67.5c6.3 11.7 1.9 26.2-9.8 32.5s-26.2 1.9-32.5-9.8z"
    ]
};
const $d8206b3ab2e65c05$export$d12c2d6def120efe = {
    prefix: 'fas',
    iconName: 'people-line',
    icon: [
        640,
        512,
        [],
        "e534",
        "M360 72a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM144 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l576 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 416zM496 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM200 313.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-36.3-67.5c1.7-1.7 3.2-3.6 4.3-5.8L264 217.5l0 54.5c0 17.7 14.3 32 32 32l48 0c17.7 0 32-14.3 32-32l0-54.5 26.9 49.9c1.2 2.2 2.6 4.1 4.3 5.8l-36.3 67.5c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L440 313.5l0 38.5c0 17.7 14.3 32 32 32l48 0c17.7 0 32-14.3 32-32l0-38.5 26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3l-19.5 0c-16.3 0-31.9 4.5-45.4 12.6l-33.6-62.3c-15.3-28.5-45.1-46.3-77.5-46.3l-19.5 0c-32.4 0-62.1 17.8-77.5 46.3l-33.6 62.3c-13.5-8.1-29.1-12.6-45.4-12.6l-19.5 0c-32.4 0-62.1 17.8-77.5 46.3L18.9 340.6c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L88 313.5 88 352c0 17.7 14.3 32 32 32l48 0c17.7 0 32-14.3 32-32l0-38.5z"
    ]
};
const $d8206b3ab2e65c05$export$b957c27bc5330472 = {
    prefix: 'fas',
    iconName: 'beer-mug-empty',
    icon: [
        512,
        512,
        [
            "beer"
        ],
        "f0fc",
        "M32 64c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32l0 32 51.2 0c42.4 0 76.8 34.4 76.8 76.8l0 102.1c0 30.4-17.9 57.9-45.6 70.2L384 381.7l0 34.3c0 35.3-28.7 64-64 64L96 480c-35.3 0-64-28.7-64-64L32 64zM384 311.6l56.4-25.1c4.6-2.1 7.6-6.6 7.6-11.7l0-102.1c0-7.1-5.7-12.8-12.8-12.8L384 160l0 151.6zM160 144c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224z"
    ]
};
const $d8206b3ab2e65c05$export$f74725691538983b = $d8206b3ab2e65c05$export$b957c27bc5330472;
const $d8206b3ab2e65c05$export$1852c99deca7bee8 = {
    prefix: 'fas',
    iconName: 'diagram-predecessor',
    icon: [
        512,
        512,
        [],
        "e477",
        "M448 416l0-64L64 352l0 64 384 0zm0 64L64 480c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64zM288 160c0 35.3-28.7 64-64 64L64 224c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l144 0 16 0 144 0c44.2 0 80 35.8 80 80l0 16 38.1 0c21.4 0 32.1 25.9 17 41L433 239c-9.4 9.4-24.6 9.4-33.9 0L329 169c-15.1-15.1-4.4-41 17-41l38.1 0 0-16c0-8.8-7.2-16-16-16l-80 0 0 64z"
    ]
};
const $d8206b3ab2e65c05$export$92c58defe6e4c5a7 = {
    prefix: 'fas',
    iconName: 'arrow-up-long',
    icon: [
        384,
        512,
        [
            "long-arrow-up"
        ],
        "f176",
        "M214.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 109.3 160 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-370.7 73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128z"
    ]
};
const $d8206b3ab2e65c05$export$ede1d50ec4b01670 = $d8206b3ab2e65c05$export$92c58defe6e4c5a7;
const $d8206b3ab2e65c05$export$9ebfff5c90672059 = {
    prefix: 'fas',
    iconName: 'fire-flame-simple',
    icon: [
        384,
        512,
        [
            "burn"
        ],
        "f46a",
        "M372.5 256.5l-.7-1.9C337.8 160.8 282 76.5 209.1 8.5l-3.3-3C202.1 2 197.1 0 192 0s-10.1 2-13.8 5.5l-3.3 3C102 76.5 46.2 160.8 12.2 254.6l-.7 1.9C3.9 277.3 0 299.4 0 321.6C0 426.7 86.8 512 192 512s192-85.3 192-190.4c0-22.2-3.9-44.2-11.5-65.1zm-90.8 49.5c4.1 9.3 6.2 19.4 6.2 29.5c0 53-43 96.5-96 96.5s-96-43.5-96-96.5c0-10.1 2.1-20.3 6.2-29.5l1.9-4.3c15.8-35.4 37.9-67.7 65.3-95.1l8.9-8.9c3.6-3.6 8.5-5.6 13.6-5.6s10 2 13.6 5.6l8.9 8.9c27.4 27.4 49.6 59.7 65.3 95.1l1.9 4.3z"
    ]
};
const $d8206b3ab2e65c05$export$80ed4535efc60402 = $d8206b3ab2e65c05$export$9ebfff5c90672059;
const $d8206b3ab2e65c05$export$e6619e43cb090a16 = {
    prefix: 'fas',
    iconName: 'person',
    icon: [
        320,
        512,
        [
            129485,
            "male"
        ],
        "f183",
        "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-223.1L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6l29.7 0c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L232 256.9 232 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128-16 0z"
    ]
};
const $d8206b3ab2e65c05$export$2e21f9dba1630651 = $d8206b3ab2e65c05$export$e6619e43cb090a16;
const $d8206b3ab2e65c05$export$c2dee3bd177275a2 = {
    prefix: 'fas',
    iconName: 'laptop',
    icon: [
        640,
        512,
        [
            128187
        ],
        "f109",
        "M128 32C92.7 32 64 60.7 64 96l0 256 64 0 0-256 384 0 0 256 64 0 0-256c0-35.3-28.7-64-64-64L128 32zM19.2 384C8.6 384 0 392.6 0 403.2C0 445.6 34.4 480 76.8 480l486.4 0c42.4 0 76.8-34.4 76.8-76.8c0-10.6-8.6-19.2-19.2-19.2L19.2 384z"
    ]
};
const $d8206b3ab2e65c05$export$82cea4f586f6ec9 = {
    prefix: 'fas',
    iconName: 'file-csv',
    icon: [
        512,
        512,
        [],
        "f6dd",
        "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM200 352l16 0c22.1 0 40 17.9 40 40l0 8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-8c0-8.8 7.2-16 16-16s16 7.2 16 16l0 8c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80c0-22.1 17.9-40 40-40zm133.1 0l34.9 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-34.9 0c-7.2 0-13.1 5.9-13.1 13.1c0 5.2 3 9.9 7.8 12l37.4 16.6c16.3 7.2 26.8 23.4 26.8 41.2c0 24.9-20.2 45.1-45.1 45.1L304 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l42.9 0c7.2 0 13.1-5.9 13.1-13.1c0-5.2-3-9.9-7.8-12l-37.4-16.6c-16.3-7.2-26.8-23.4-26.8-41.2c0-24.9 20.2-45.1 45.1-45.1zm98.9 0c8.8 0 16 7.2 16 16l0 31.6c0 23 5.5 45.6 16 66c10.5-20.3 16-42.9 16-66l0-31.6c0-8.8 7.2-16 16-16s16 7.2 16 16l0 31.6c0 34.7-10.3 68.7-29.6 97.6l-5.1 7.7c-3 4.5-8 7.1-13.3 7.1s-10.3-2.7-13.3-7.1l-5.1-7.7c-19.3-28.9-29.6-62.9-29.6-97.6l0-31.6c0-8.8 7.2-16 16-16z"
    ]
};
const $d8206b3ab2e65c05$export$232452c59d77c56e = {
    prefix: 'fas',
    iconName: 'menorah',
    icon: [
        640,
        512,
        [],
        "f676",
        "M20.8 7.4C22.8 2.9 27.1 0 32 0s9.2 2.9 11.2 7.4L61.3 49.7c1.8 4.1 2.7 8.6 2.7 13.1L64 64c0 17.7-14.3 32-32 32S0 81.7 0 64l0-1.2c0-4.5 .9-8.9 2.7-13.1L20.8 7.4zm96 0C118.8 2.9 123.1 0 128 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1L116.8 7.4zm77.8 42.4L212.8 7.4C214.8 2.9 219.1 0 224 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1zM308.8 7.4C310.8 2.9 315.1 0 320 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1L308.8 7.4zm77.8 42.4L404.8 7.4C406.8 2.9 411.1 0 416 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1zM500.8 7.4C502.8 2.9 507.1 0 512 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1L500.8 7.4zm77.8 42.4L596.8 7.4C598.8 2.9 603.1 0 608 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1zM32 128c17.7 0 32 14.3 32 32l0 128c0 17.7 14.3 32 32 32l192 0 0-160c0-17.7 14.3-32 32-32s32 14.3 32 32l0 160 192 0c17.7 0 32-14.3 32-32l0-128c0-17.7 14.3-32 32-32s32 14.3 32 32l0 128c0 53-43 96-96 96l-192 0 0 64 128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0-160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l128 0 0-64L96 384c-53 0-96-43-96-96L0 160c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32l0 96 0 32-64 0 0-32 0-96c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32l0 96 0 32-64 0 0-32 0-96c0-17.7 14.3-32 32-32zm192 0c17.7 0 32 14.3 32 32l0 96 0 32-64 0 0-32 0-96c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32l0 96 0 32-64 0 0-32 0-96c0-17.7 14.3-32 32-32z"
    ]
};
const $d8206b3ab2e65c05$export$e1d5ceed99060d76 = {
    prefix: 'fas',
    iconName: 'truck-plane',
    icon: [
        640,
        512,
        [],
        "e58f",
        "M200 0c-30.6 0-56 54.7-56 86.1l0 106.5L7.8 274.3C2.9 277.2 0 282.4 0 288l0 64c0 5.1 2.4 9.8 6.4 12.8s9.3 3.9 14.1 2.5l123.4-37 0 81.2-50 40c-3.8 3-6 7.6-6 12.5l0 32c0 5.1 2.5 10 6.6 13s9.5 3.8 14.4 2.2L200 480.9 290.4 511c-1.6-4.7-2.4-9.8-2.4-15l0-32.6c-18.2-10.5-30.7-29.7-31.9-51.8l-.1-.1 0-3.5 0-82.5L256 184l0-1.1s0 0 0 0l0-96.9C256 54.7 231.5 0 200 0zm88 176l0 224c0 20.9 13.4 38.7 32 45.3l0 42.7c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24l0-40 160 0 0 40c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24l0-42.7c18.6-6.6 32-24.4 32-45.3l0-224c0-26.5-21.5-48-48-48l-256 0c-26.5 0-48 21.5-48 48zm79.8 78.7c3.3-8.7 11.2-14.7 20.5-14.7l151.4 0c9.2 0 17.2 6 20.5 14.7L576 304l-224 0 15.8-49.3zM568 352a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM336 376a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
const $d8206b3ab2e65c05$export$fe2d5012d9982673 = {
    prefix: 'fas',
    iconName: 'record-vinyl',
    icon: [
        512,
        512,
        [],
        "f8d9",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-96a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 224a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
const $d8206b3ab2e65c05$export$1d1fbac384a76a12 = {
    prefix: 'fas',
    iconName: 'face-grin-stars',
    icon: [
        512,
        512,
        [
            129321,
            "grin-stars"
        ],
        "f587",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm407.4 75.5c5-11.8-7-22.5-19.3-18.7c-39.7 12.2-84.5 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7c25 59.1 83.2 100.5 151.1 100.5s126.2-41.4 151.1-100.5zM160 120c-3.1 0-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L160 232.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L226.4 178c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7c-1.3-2.8-4.1-4.6-7.2-4.6zm192 0c-3.1 0-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L352 232.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L418.4 178c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7c-1.3-2.8-4.1-4.6-7.2-4.6z"
    ]
};
const $d8206b3ab2e65c05$export$64347a5c8c402ef4 = $d8206b3ab2e65c05$export$1d1fbac384a76a12;
const $d8206b3ab2e65c05$export$e74974fac77c468e = {
    prefix: 'fas',
    iconName: 'bong',
    icon: [
        448,
        512,
        [],
        "f55c",
        "M160 208.5c0 29.1-15.6 53.9-37.2 67.8c-17.2 11.1-31.5 26.1-41.7 43.7l221.8 0c-10.2-17.6-24.5-32.6-41.7-43.7c-21.6-13.9-37.2-38.7-37.2-67.8L224 64l-64 0 0 144.5zM288 64l0 144.5c0 5.7 3.1 10.9 7.9 14c11.2 7.2 21.5 15.5 30.9 24.8L366.1 208l-7-7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l24 24 24 24c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-7-7-43.3 43.3C374 314.1 384 347.9 384 384c0 39.4-11.9 76.1-32.2 106.5c-9.6 14.4-26.5 21.5-43.8 21.5L76.1 512c-17.3 0-34.2-7.1-43.8-21.5C11.9 460.1 0 423.4 0 384c0-67.8 35.1-127.3 88.1-161.5c4.8-3.1 7.9-8.3 7.9-14L96 64C78.3 64 64 49.7 64 32S78.3 0 96 0l16 0L272 0l16 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z"
    ]
};
const $d8206b3ab2e65c05$export$3c8d5c62d76c33b8 = {
    prefix: 'fas',
    iconName: 'spaghetti-monster-flying',
    icon: [
        640,
        512,
        [
            "pastafarianism"
        ],
        "f67b",
        "M208 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 0c0 16.2-6 31.1-16 42.3l15.6 31.2c18.7-6 39.9-9.5 64.4-9.5s45.8 3.5 64.4 9.5L400 106.3C390 95.1 384 80.2 384 64c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64c-1.7 0-3.4-.1-5.1-.2L427.8 158c21.1 13.6 37.7 30.2 51.4 46.4c7.1 8.3 13.5 16.6 19.3 24l1.4 1.8c6.3 8.1 11.6 14.8 16.7 20.4C527.3 262.3 532.7 264 536 264c2.5 0 4.3-.6 7.1-3.3c3.7-3.5 7.1-8.8 12.5-17.4l.6-.9c4.6-7.4 11-17.6 19.4-25.7c9.7-9.3 22.9-16.7 40.4-16.7c13.3 0 24 10.7 24 24s-10.7 24-24 24c-2.5 0-4.3 .6-7.1 3.3c-3.7 3.5-7.1 8.8-12.5 17.4l-.6 .9c-4.6 7.4-11 17.6-19.4 25.7c-9.7 9.3-22.9 16.7-40.4 16.7c-18.5 0-32.9-8.5-44.3-18.6c-3.1 4-6.6 8.3-10.5 12.7c1.4 4.3 2.8 8.5 4 12.5c.9 3 1.8 5.8 2.6 8.6c3 9.8 5.5 18.2 8.6 25.9c3.9 9.8 7.4 15.4 10.8 18.5c2.6 2.4 5.9 4.3 12.8 4.3c8.7 0 16.9-4.2 33.7-13.2c15-8 35.7-18.8 62.3-18.8c13.3 0 24 10.7 24 24s-10.7 24-24 24c-13.4 0-24.7 5.2-39.7 13.2c-1 .6-2.1 1.1-3.2 1.7C559.9 414 541.4 424 520 424c-18.4 0-33.6-6.1-45.5-17.2c-11.1-10.3-17.9-23.7-22.7-36c-3.6-9-6.7-19.1-9.5-28.5c-16.4 12.3-36.1 23.6-58.9 31.3c3.6 10.8 8.4 23.5 14.4 36.2c7.5 15.9 16.2 30.4 25.8 40.5C433 460.5 441.2 464 448 464c13.3 0 24 10.7 24 24s-10.7 24-24 24c-25.2 0-45-13.5-59.5-28.8c-14.5-15.4-25.7-34.9-34.2-53c-8-17-14.1-33.8-18.3-46.9c-5.2 .4-10.6 .6-16 .6s-10.8-.2-16-.6c-4.2 13-10.3 29.9-18.3 46.9c-8.5 18.1-19.8 37.6-34.2 53C237 498.5 217.2 512 192 512c-13.3 0-24-10.7-24-24s10.7-24 24-24c6.8 0 15-3.5 24.5-13.7c9.5-10.1 18.3-24.6 25.8-40.5c5.9-12.6 10.7-25.4 14.4-36.2c-22.8-7.7-42.5-19-58.9-31.3c-2.9 9.4-6 19.5-9.5 28.5c-4.8 12.2-11.6 25.6-22.7 36C153.6 417.9 138.4 424 120 424c-21.4 0-39.9-10-53.1-17.1c0 0 0 0 0 0c-1.1-.6-2.2-1.2-3.2-1.7c-15-8-26.3-13.2-39.7-13.2c-13.3 0-24-10.7-24-24s10.7-24 24-24c26.6 0 47.3 10.8 62.3 18.8c16.8 9 25 13.2 33.7 13.2c6.8 0 10.2-1.9 12.8-4.3c3.4-3.2 7-8.8 10.8-18.5c3-7.7 5.6-16.1 8.6-25.9c.8-2.7 1.7-5.6 2.6-8.6c1.2-4 2.6-8.2 4-12.5c-3.9-4.5-7.4-8.8-10.5-12.7C136.9 303.5 122.5 312 104 312c-17.5 0-30.7-7.4-40.4-16.7c-8.4-8.1-14.8-18.3-19.4-25.7l-.6-.9c-5.4-8.6-8.8-13.9-12.5-17.4c-2.8-2.7-4.6-3.3-7.1-3.3c-13.3 0-24-10.7-24-24s10.7-24 24-24c17.5 0 30.7 7.4 40.4 16.7c8.4 8.1 14.8 18.3 19.4 25.7l.6 .9c5.4 8.6 8.8 13.9 12.5 17.4c2.8 2.7 4.6 3.3 7.1 3.3c3.3 0 8.7-1.7 19.4-13.4c5.1-5.6 10.4-12.3 16.7-20.4l1.4-1.8c5.8-7.4 12.2-15.7 19.3-24c13.8-16.2 30.3-32.8 51.4-46.4l-15.1-30.2c-1.7 .1-3.4 .2-5.1 .2c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zm208 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
    ]
};
const $d8206b3ab2e65c05$export$733efdaec97447be = $d8206b3ab2e65c05$export$3c8d5c62d76c33b8;
const $d8206b3ab2e65c05$export$9fe0c42ede2dd003 = {
    prefix: 'fas',
    iconName: 'arrow-down-up-across-line',
    icon: [
        576,
        512,
        [],
        "e4af",
        "M137.4 502.6c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 402.7 192 288l352 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0 0-114.7 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L384 109.3 384 224l-192 0-64 0-96 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0 0 114.7L86.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96zM128 192l64 0 0-128c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 128zM448 320l-64 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128z"
    ]
};
const $d8206b3ab2e65c05$export$faf854a434ce6d0c = {
    prefix: 'fas',
    iconName: 'spoon',
    icon: [
        512,
        512,
        [
            129348,
            61873,
            "utensil-spoon"
        ],
        "f2e5",
        "M245.8 220.9c-14.5-17.6-21.8-39.2-21.8-60.8C224 80 320 0 416 0c53 0 96 43 96 96c0 96-80 192-160.2 192c-21.6 0-43.2-7.3-60.8-21.8L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L245.8 220.9z"
    ]
};
const $d8206b3ab2e65c05$export$fb7af5d245fb9053 = $d8206b3ab2e65c05$export$faf854a434ce6d0c;
const $d8206b3ab2e65c05$export$8b503c1d76716ddd = {
    prefix: 'fas',
    iconName: 'jar-wheat',
    icon: [
        320,
        512,
        [],
        "e517",
        "M32 32C32 14.3 46.3 0 64 0L256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L64 64C46.3 64 32 49.7 32 32zM0 160c0-35.3 28.7-64 64-64l192 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 160zm112 0l-42.2 0c-3.2 0-5.8 2.6-5.8 5.8C64 198 90 224 122.2 224l21.8 0 32 0 21.8 0c32.1 0 58.2-26 58.2-58.2c0-3.2-2.6-5.8-5.8-5.8L208 160c-19.1 0-36.3 8.4-48 21.7c-11.7-13.3-28.9-21.7-48-21.7zm48 117.7c-11.7-13.3-28.9-21.7-48-21.7l-42.2 0c-3.2 0-5.8 2.6-5.8 5.8C64 294 90 320 122.2 320l21.8 0 32 0 21.8 0c32.1 0 58.2-26 58.2-58.2c0-3.2-2.6-5.8-5.8-5.8L208 256c-19.1 0-36.3 8.4-48 21.7zM112 352l-42.2 0c-3.2 0-5.8 2.6-5.8 5.8C64 390 90 416 122.2 416l21.8 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 21.8 0c32.1 0 58.2-26 58.2-58.2c0-3.2-2.6-5.8-5.8-5.8L208 352c-19.1 0-36.3 8.4-48 21.7c-11.7-13.3-28.9-21.7-48-21.7z"
    ]
};
const $d8206b3ab2e65c05$export$dc2cce064a1e70bb = {
    prefix: 'fas',
    iconName: 'envelopes-bulk',
    icon: [
        640,
        512,
        [
            "mail-bulk"
        ],
        "f674",
        "M128 0C110.3 0 96 14.3 96 32l0 192 96 0 0-32c0-35.3 28.7-64 64-64l224 0 0-96c0-17.7-14.3-32-32-32L128 0zM256 160c-17.7 0-32 14.3-32 32l0 32 96 0c35.3 0 64 28.7 64 64l0 128 192 0c17.7 0 32-14.3 32-32l0-192c0-17.7-14.3-32-32-32l-320 0zm240 64l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM64 256c-17.7 0-32 14.3-32 32l0 13L187.1 415.9c1.4 1 3.1 1.6 4.9 1.6s3.5-.6 4.9-1.6L352 301l0-13c0-17.7-14.3-32-32-32L64 256zm288 84.8L216 441.6c-6.9 5.1-15.3 7.9-24 7.9s-17-2.8-24-7.9L32 340.8 32 480c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-139.2z"
    ]
};
const $d8206b3ab2e65c05$export$dd24f40c5337e2e1 = $d8206b3ab2e65c05$export$dc2cce064a1e70bb;
const $d8206b3ab2e65c05$export$61fa9809253098e5 = {
    prefix: 'fas',
    iconName: 'file-circle-exclamation',
    icon: [
        576,
        512,
        [],
        "e4eb",
        "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16z"
    ]
};
const $d8206b3ab2e65c05$export$bf5674308c61894f = {
    prefix: 'fas',
    iconName: 'circle-h',
    icon: [
        512,
        512,
        [
            9405,
            "hospital-symbol"
        ],
        "f47e",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM368 152l0 104 0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80-128 0 0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24s24 10.7 24 24l0 80 128 0 0-80c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
const $d8206b3ab2e65c05$export$c8a3c78d99c23fed = $d8206b3ab2e65c05$export$bf5674308c61894f;
const $d8206b3ab2e65c05$export$e1611f373a10a98c = {
    prefix: 'fas',
    iconName: 'pager',
    icon: [
        512,
        512,
        [
            128223
        ],
        "f815",
        "M0 128C0 92.7 28.7 64 64 64l384 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zm64 32l0 64c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L96 128c-17.7 0-32 14.3-32 32zM80 320c-13.3 0-24 10.7-24 24s10.7 24 24 24l56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0zm136 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0z"
    ]
};
const $d8206b3ab2e65c05$export$853fd1561789e3bb = {
    prefix: 'fas',
    iconName: 'address-book',
    icon: [
        512,
        512,
        [
            62138,
            "contact-book"
        ],
        "f2b9",
        "M96 0C60.7 0 32 28.7 32 64l0 384c0 35.3 28.7 64 64 64l288 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L96 0zM208 288l64 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM512 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64zM496 192c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16zm16 144c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64z"
    ]
};
const $d8206b3ab2e65c05$export$594b5a5d4d2e156b = $d8206b3ab2e65c05$export$853fd1561789e3bb;
const $d8206b3ab2e65c05$export$eff51ea25b4de135 = {
    prefix: 'fas',
    iconName: 'strikethrough',
    icon: [
        512,
        512,
        [],
        "f0cc",
        "M161.3 144c3.2-17.2 14-30.1 33.7-38.6c21.1-9 51.8-12.3 88.6-6.5c11.9 1.9 48.8 9.1 60.1 12c17.1 4.5 34.6-5.6 39.2-22.7s-5.6-34.6-22.7-39.2c-14.3-3.8-53.6-11.4-66.6-13.4c-44.7-7-88.3-4.2-123.7 10.9c-36.5 15.6-64.4 44.8-71.8 87.3c-.1 .6-.2 1.1-.2 1.7c-2.8 23.9 .5 45.6 10.1 64.6c4.5 9 10.2 16.9 16.7 23.9L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l448 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-209.9 0-.4-.1-1.1-.3c-36-10.8-65.2-19.6-85.2-33.1c-9.3-6.3-15-12.6-18.2-19.1c-3.1-6.1-5.2-14.6-3.8-27.4zM348.9 337.2c2.7 6.5 4.4 15.8 1.9 30.1c-3 17.6-13.8 30.8-33.9 39.4c-21.1 9-51.7 12.3-88.5 6.5c-18-2.9-49.1-13.5-74.4-22.1c-5.6-1.9-11-3.7-15.9-5.4c-16.8-5.6-34.9 3.5-40.5 20.3s3.5 34.9 20.3 40.5c3.6 1.2 7.9 2.7 12.7 4.3c0 0 0 0 0 0s0 0 0 0c24.9 8.5 63.6 21.7 87.6 25.6c0 0 0 0 0 0l.2 0c44.7 7 88.3 4.2 123.7-10.9c36.5-15.6 64.4-44.8 71.8-87.3c3.6-21 2.7-40.4-3.1-58.1l-75.7 0c7 5.6 11.4 11.2 13.9 17.2z"
    ]
};
const $d8206b3ab2e65c05$export$3f85413cb67e7f67 = {
    prefix: 'fas',
    iconName: 'k',
    icon: [
        320,
        512,
        [
            107
        ],
        "4b",
        "M311 86.3c12.3-12.7 12-32.9-.7-45.2s-32.9-12-45.2 .7l-155.2 160L64 249 64 64c0-17.7-14.3-32-32-32S0 46.3 0 64L0 328 0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-107 64.7-66.7 133 192c10.1 14.5 30 18.1 44.5 8.1s18.1-30 8.1-44.5L174.1 227.4 311 86.3z"
    ]
};
const $d8206b3ab2e65c05$export$f4d472cf47be4096 = {
    prefix: 'fas',
    iconName: 'landmark-flag',
    icon: [
        512,
        512,
        [],
        "e51c",
        "M272 0l80 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-80 0 0 32 192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L48 192c-17.7 0-32-14.3-32-32s14.3-32 32-32l192 0 0-112c0-8.8 7.2-16 16-16l16 0zM64 224l64 0 0 192 40 0 0-192 64 0 0 192 48 0 0-192 64 0 0 192 40 0 0-192 64 0 0 196.3c.6 .3 1.2 .7 1.8 1.1l48 32c11.7 7.8 17 22.4 12.9 35.9S494.1 512 480 512L32 512c-14.1 0-26.5-9.2-30.6-22.7s1.1-28.1 12.9-35.9l48-32c.6-.4 1.2-.7 1.8-1.1L64 224z"
    ]
};
const $d8206b3ab2e65c05$export$c72de95adaca18b8 = {
    prefix: 'fas',
    iconName: 'pencil',
    icon: [
        512,
        512,
        [
            9999,
            61504,
            "pencil-alt"
        ],
        "f303",
        "M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1 0 32c0 8.8 7.2 16 16 16l32 0zM362.7 18.7L348.3 33.2 325.7 55.8 314.3 67.1l33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5L453.3 18.7c-25-25-65.5-25-90.5 0zm-47.4 168l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
const $d8206b3ab2e65c05$export$8210adc172262df = $d8206b3ab2e65c05$export$c72de95adaca18b8;
const $d8206b3ab2e65c05$export$ae65f96ea7a4078d = {
    prefix: 'fas',
    iconName: 'backward',
    icon: [
        512,
        512,
        [
            9194
        ],
        "f04a",
        "M459.5 440.6c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29l0-320c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4L288 214.3l0 41.7 0 41.7L459.5 440.6zM256 352l0-96 0-128 0-32c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4l-192 160C4.2 237.5 0 246.5 0 256s4.2 18.5 11.5 24.6l192 160c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29l0-64z"
    ]
};
const $d8206b3ab2e65c05$export$f1011352b01c1c0 = {
    prefix: 'fas',
    iconName: 'caret-right',
    icon: [
        256,
        512,
        [],
        "f0da",
        "M246.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 256c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128z"
    ]
};
const $d8206b3ab2e65c05$export$932912e74adb8939 = {
    prefix: 'fas',
    iconName: 'comments',
    icon: [
        640,
        512,
        [
            128490,
            61670
        ],
        "f086",
        "M208 352c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176c0 38.6 14.7 74.3 39.6 103.4c-3.5 9.4-8.7 17.7-14.2 24.7c-4.8 6.2-9.7 11-13.3 14.3c-1.8 1.6-3.3 2.9-4.3 3.7c-.5 .4-.9 .7-1.1 .8l-.2 .2s0 0 0 0s0 0 0 0C1 327.2-1.4 334.4 .8 340.9S9.1 352 16 352c21.8 0 43.8-5.6 62.1-12.5c9.2-3.5 17.8-7.4 25.2-11.4C134.1 343.3 169.8 352 208 352zM448 176c0 112.3-99.1 196.9-216.5 207C255.8 457.4 336.4 512 432 512c38.2 0 73.9-8.7 104.7-23.9c7.5 4 16 7.9 25.2 11.4c18.3 6.9 40.3 12.5 62.1 12.5c6.9 0 13.1-4.5 15.2-11.1c2.1-6.6-.2-13.8-5.8-17.9c0 0 0 0 0 0s0 0 0 0l-.2-.2c-.2-.2-.6-.4-1.1-.8c-1-.8-2.5-2-4.3-3.7c-3.6-3.3-8.5-8.1-13.3-14.3c-5.5-7-10.7-15.4-14.2-24.7c24.9-29 39.6-64.7 39.6-103.4c0-92.8-84.9-168.9-192.6-175.5c.4 5.1 .6 10.3 .6 15.5z"
    ]
};
const $d8206b3ab2e65c05$export$6f95f90dd1f6d86b = {
    prefix: 'fas',
    iconName: 'paste',
    icon: [
        512,
        512,
        [
            "file-clipboard"
        ],
        "f0ea",
        "M160 0c-23.7 0-44.4 12.9-55.4 32L48 32C21.5 32 0 53.5 0 80L0 400c0 26.5 21.5 48 48 48l144 0 0-272c0-44.2 35.8-80 80-80l48 0 0-16c0-26.5-21.5-48-48-48l-56.6 0C204.4 12.9 183.7 0 160 0zM272 128c-26.5 0-48 21.5-48 48l0 272 0 16c0 26.5 21.5 48 48 48l192 0c26.5 0 48-21.5 48-48l0-220.1c0-12.7-5.1-24.9-14.1-33.9l-67.9-67.9c-9-9-21.2-14.1-33.9-14.1L320 128l-48 0zM160 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
const $d8206b3ab2e65c05$export$ca3229c47de163fa = $d8206b3ab2e65c05$export$6f95f90dd1f6d86b;
const $d8206b3ab2e65c05$export$37576dfab037d8bf = {
    prefix: 'fas',
    iconName: 'code-pull-request',
    icon: [
        512,
        512,
        [],
        "e13c",
        "M305.8 2.1C314.4 5.9 320 14.5 320 24l0 40 16 0c70.7 0 128 57.3 128 128l0 166.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3L400 192c0-35.3-28.7-64-64-64l-16 0 0 40c0 9.5-5.6 18.1-14.2 21.9s-18.8 2.3-25.8-4.1l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c7-6.3 17.2-7.9 25.8-4.1zM104 80A24 24 0 1 0 56 80a24 24 0 1 0 48 0zm8 73.3l0 205.3c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3l0-205.3C19.7 141 0 112.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80c0 32.8-19.7 61-48 73.3zM104 432a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm328 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
const $d8206b3ab2e65c05$export$2c5a9d8548d8810e = {
    prefix: 'fas',
    iconName: 'clipboard-list',
    icon: [
        384,
        512,
        [],
        "f46d",
        "M192 0c-41.8 0-77.4 26.7-90.5 64L64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-37.5 0C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM72 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM72 368a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 0c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16z"
    ]
};
const $d8206b3ab2e65c05$export$37396c36c76937bc = {
    prefix: 'fas',
    iconName: 'truck-ramp-box',
    icon: [
        640,
        512,
        [
            "truck-loading"
        ],
        "f4de",
        "M640 0l0 400c0 61.9-50.1 112-112 112c-61 0-110.5-48.7-112-109.3L48.4 502.9c-17.1 4.6-34.6-5.4-39.3-22.5s5.4-34.6 22.5-39.3L352 353.8 352 64c0-35.3 28.7-64 64-64L640 0zM576 400a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM23.1 207.7c-4.6-17.1 5.6-34.6 22.6-39.2l46.4-12.4 20.7 77.3c2.3 8.5 11.1 13.6 19.6 11.3l30.9-8.3c8.5-2.3 13.6-11.1 11.3-19.6l-20.7-77.3 46.4-12.4c17.1-4.6 34.6 5.6 39.2 22.6l41.4 154.5c4.6 17.1-5.6 34.6-22.6 39.2L103.7 384.9c-17.1 4.6-34.6-5.6-39.2-22.6L23.1 207.7z"
    ]
};
const $d8206b3ab2e65c05$export$f00c152db7d44638 = $d8206b3ab2e65c05$export$37396c36c76937bc;
const $d8206b3ab2e65c05$export$76de2a120043c9f8 = {
    prefix: 'fas',
    iconName: 'user-check',
    icon: [
        640,
        512,
        [],
        "f4fc",
        "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3zM625 177L497 305c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L591 143c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    ]
};
const $d8206b3ab2e65c05$export$a56b2b0a1073620c = {
    prefix: 'fas',
    iconName: 'vial-virus',
    icon: [
        512,
        512,
        [],
        "e597",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l0 288c0 53 43 96 96 96c28.6 0 54.2-12.5 71.8-32.3c.1-14.2 5.6-28.3 16.4-39.1c.2-.2 .1-.6-.2-.6c-30.9 0-56-25.1-56-56s25.1-56 56-56c.3 0 .4-.4 .2-.6c-21.9-21.9-21.9-57.3 0-79.2c2.4-2.4 5-4.6 7.8-6.5L224 96c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0L96 32 32 32zM96 192l0-96 64 0 0 96-64 0zM216 376c28.8 0 43.2 34.8 22.9 55.2c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0c20.4-20.4 55.2-5.9 55.2 22.9c0 13.3 10.7 24 24 24s24-10.7 24-24c0-28.8 34.8-43.2 55.2-22.9c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9C444.8 410.8 459.2 376 488 376c13.3 0 24-10.7 24-24s-10.7-24-24-24c-28.8 0-43.2-34.8-22.9-55.2c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0C410.8 259.2 376 244.8 376 216c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 28.8-34.8 43.2-55.2 22.9c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c20.4 20.4 5.9 55.2-22.9 55.2c-13.3 0-24 10.7-24 24s10.7 24 24 24zm104-88a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm40 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
const $d8206b3ab2e65c05$export$57f2bcd070bff91a = {
    prefix: 'fas',
    iconName: 'sheet-plastic',
    icon: [
        384,
        512,
        [],
        "e571",
        "M0 448c0 35.3 28.7 64 64 64l160 0 0-128c0-17.7 14.3-32 32-32l128 0 0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448zM171.3 75.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm96 32l-160 160c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l160-160c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM384 384l-128 0 0 128L384 384z"
    ]
};
const $d8206b3ab2e65c05$export$890d5e011054935a = {
    prefix: 'fas',
    iconName: 'blog',
    icon: [
        512,
        512,
        [],
        "f781",
        "M192 32c0 17.7 14.3 32 32 32c123.7 0 224 100.3 224 224c0 17.7 14.3 32 32 32s32-14.3 32-32C512 128.9 383.1 0 224 0c-17.7 0-32 14.3-32 32zm0 96c0 17.7 14.3 32 32 32c70.7 0 128 57.3 128 128c0 17.7 14.3 32 32 32s32-14.3 32-32c0-106-86-192-192-192c-17.7 0-32 14.3-32 32zM96 144c0-26.5-21.5-48-48-48S0 117.5 0 144L0 368c0 79.5 64.5 144 144 144s144-64.5 144-144s-64.5-144-144-144l-16 0 0 96 16 0c26.5 0 48 21.5 48 48s-21.5 48-48 48s-48-21.5-48-48l0-224z"
    ]
};
const $d8206b3ab2e65c05$export$a9174995732e03c5 = {
    prefix: 'fas',
    iconName: 'user-ninja',
    icon: [
        448,
        512,
        [
            129399
        ],
        "f504",
        "M224 256c-57.2 0-105.6-37.5-122-89.3c-1.1 1.3-2.2 2.6-3.5 3.8c-15.8 15.8-38.8 20.7-53.6 22.1c-8.1 .8-14.6-5.7-13.8-13.8c1.4-14.7 6.3-37.8 22.1-53.6c5.8-5.8 12.6-10.1 19.6-13.4c-7-3.2-13.8-7.6-19.6-13.4C37.4 82.7 32.6 59.7 31.1 44.9c-.8-8.1 5.7-14.6 13.8-13.8c14.7 1.4 37.8 6.3 53.6 22.1c4.8 4.8 8.7 10.4 11.7 16.1C131.4 28.2 174.4 0 224 0c70.7 0 128 57.3 128 128s-57.3 128-128 128zM0 482.3C0 399.5 56.4 330 132.8 309.9c6-1.6 12.2 .9 15.9 5.8l62.5 83.3c6.4 8.5 19.2 8.5 25.6 0l62.5-83.3c3.7-4.9 9.9-7.4 15.9-5.8C391.6 330 448 399.5 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3zM160 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L160 96z"
    ]
};
const $d8206b3ab2e65c05$export$5709329dd2b70bdc = {
    prefix: 'fas',
    iconName: 'person-arrow-up-from-line',
    icon: [
        640,
        512,
        [],
        "e539",
        "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 352l0-96 16 0 0 96-16 0zm-64 0l-88 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l120 0 80 0 376 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-344 0 0-191.1 28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6l-29.7 0c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9 120 448zM598.6 121.4l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L464 141.3 464 384c0 17.7 14.3 32 32 32s32-14.3 32-32l0-242.7 25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3z"
    ]
};
const $d8206b3ab2e65c05$export$4e3fe5b42a6cd494 = {
    prefix: 'fas',
    iconName: 'scroll-torah',
    icon: [
        640,
        512,
        [
            "torah"
        ],
        "f6a0",
        "M96 480L96 32C96 14.3 74.5 0 48 0S0 14.3 0 32L0 480c0 17.7 21.5 32 48 32s48-14.3 48-32zM512 32L128 32l0 448 384 0 0-448zM592 0c-26.5 0-48 14.3-48 32l0 448c0 17.7 21.5 32 48 32s48-14.3 48-32l0-448c0-17.7-21.5-32-48-32zM196 313.7c0-3.2 .9-6.4 2.5-9.2L226.7 256l-28.3-48.5c-1.6-2.8-2.5-6-2.5-9.2c0-10.1 8.2-18.3 18.3-18.3l56.7 0 31.4-53.9c3.6-6.3 10.3-10.1 17.6-10.1s13.9 3.8 17.6 10.1L369 180l56.7 0c10.1 0 18.3 8.2 18.3 18.3c0 3.2-.9 6.4-2.5 9.2L413.3 256l28.3 48.5c1.6 2.8 2.5 6 2.5 9.2c0 10.1-8.2 18.3-18.3 18.3L369 332l-31.4 53.9c-3.6 6.3-10.3 10.1-17.6 10.1s-13.9-3.8-17.6-10.1L271 332l-56.7 0c-10.1 0-18.3-8.2-18.3-18.3zm124 54.7L341.2 332l-42.4 0L320 368.4zM254.5 256l30.3 52 70.4 0 30.3-52-30.3-52-70.4 0-30.3 52zm144.9 23.8L383 308l32.8 0-16.4-28.2zM415.8 204L383 204l16.4 28.2L415.8 204zM320 143.6L298.8 180l42.4 0L320 143.6zM224.2 204l16.4 28.2L257 204l-32.8 0zM257 308l-16.4-28.2L224.2 308l32.8 0z"
    ]
};
const $d8206b3ab2e65c05$export$54d07baabd8c2acb = $d8206b3ab2e65c05$export$4e3fe5b42a6cd494;
const $d8206b3ab2e65c05$export$3e1327487ce53231 = {
    prefix: 'fas',
    iconName: 'broom-ball',
    icon: [
        576,
        512,
        [
            "quidditch",
            "quidditch-broom-ball"
        ],
        "f458",
        "M566.6 9.4c12.5 12.5 12.5 32.8 0 45.3l-192 192 34.7 34.7c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6l-29.1 0L256 211.7l0-29.1c0-12.5 10.1-22.6 22.6-22.6c6 0 11.8 2.4 16 6.6l34.7 34.7 192-192c12.5-12.5 32.8-12.5 45.3 0zm-344 225.5L341.1 353.4c3.7 42.7-11.7 85.2-42.3 115.8C271.4 496.6 234.2 512 195.5 512L22.1 512C9.9 512 0 502.1 0 489.9c0-6.3 2.7-12.3 7.3-16.5L133.7 359.7c4.2-3.7-.4-10.4-5.4-7.9L77.2 377.4c-6.1 3-13.2-1.4-13.2-8.2c0-31.5 12.5-61.7 34.8-84l8-8c30.6-30.6 73.1-45.9 115.8-42.3zM464 352a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
    ]
};
const $d8206b3ab2e65c05$export$c00c446e6db1605f = $d8206b3ab2e65c05$export$3e1327487ce53231;
const $d8206b3ab2e65c05$export$791bfe29b97b4d42 = $d8206b3ab2e65c05$export$3e1327487ce53231;
const $d8206b3ab2e65c05$export$d20aaceb882ca545 = {
    prefix: 'fas',
    iconName: 'toggle-off',
    icon: [
        576,
        512,
        [],
        "f204",
        "M384 128c70.7 0 128 57.3 128 128s-57.3 128-128 128l-192 0c-70.7 0-128-57.3-128-128s57.3-128 128-128l192 0zM576 256c0-106-86-192-192-192L192 64C86 64 0 150 0 256S86 448 192 448l192 0c106 0 192-86 192-192zM192 352a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"
    ]
};
const $d8206b3ab2e65c05$export$2a0fcb66c3d79d00 = {
    prefix: 'fas',
    iconName: 'box-archive',
    icon: [
        512,
        512,
        [
            "archive"
        ],
        "f187",
        "M32 32l448 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96L0 64C0 46.3 14.3 32 32 32zm0 128l448 0 0 256c0 35.3-28.7 64-64 64L96 480c-35.3 0-64-28.7-64-64l0-256zm128 80c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16z"
    ]
};
const $d8206b3ab2e65c05$export$26b3e1c454273f34 = $d8206b3ab2e65c05$export$2a0fcb66c3d79d00;
const $d8206b3ab2e65c05$export$bac321083217fd4 = {
    prefix: 'fas',
    iconName: 'person-drowning',
    icon: [
        576,
        512,
        [],
        "e545",
        "M192 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32.2c0 54.1 23.5 104 62.2 138.3l-21 146.7c7.8 2.1 15.5 3.3 22.8 3.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c12.4 8.5 26.1 14.8 39.7 18l17.7-97.6c10.7-1.2 21.3-3.1 31.9-5.5l105-23.9c17.2-3.9 28-21.1 24.1-38.3s-21.1-28-38.3-24.1L400 216.6c-41 9.3-83.7 7.5-123.7-5.2c-50.2-16-84.3-62.6-84.3-115.3L192 64zM320 192a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM306.5 389.9c-11.1-7.9-25.9-7.9-37 0C247 405.4 219.5 416 192 416c-26.9 0-55.3-10.8-77.4-26.1c0 0 0 0 0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 469.7 159 480 192 480c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7c0 0 0 0 0 0C439.4 405.2 410.9 416 384 416c-27.5 0-55-10.6-77.5-26.1z"
    ]
};
const $d8206b3ab2e65c05$export$6cc91ce23eb3fae1 = {
    prefix: 'fas',
    iconName: 'arrow-down-9-1',
    icon: [
        576,
        512,
        [
            "sort-numeric-desc",
            "sort-numeric-down-alt"
        ],
        "f886",
        "M160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7 192 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 301.7L95.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C142.5 476.2 151 480 160 480zM450.7 294c-8.3-6-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2 0 51.6-16 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l48 0 48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0 0-96c0-10.3-4.9-19.9-13.3-26zM418.3 91a32 32 0 1 1 27.4 57.9A32 32 0 1 1 418.3 91zM405.1 203.8l-6.8 9.2c-10.5 14.2-7.5 34.2 6.7 44.8s34.2 7.5 44.8-6.7l48.8-65.8c14-18.9 21.5-41.7 21.5-65.2c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 39.2 25.6 72.4 61.1 83.8z"
    ]
};
const $d8206b3ab2e65c05$export$99f058110e2c82a8 = $d8206b3ab2e65c05$export$6cc91ce23eb3fae1;
const $d8206b3ab2e65c05$export$857385fda7a5a98e = $d8206b3ab2e65c05$export$6cc91ce23eb3fae1;
const $d8206b3ab2e65c05$export$8eee2c17ff89e724 = {
    prefix: 'fas',
    iconName: 'face-grin-tongue-squint',
    icon: [
        512,
        512,
        [
            128541,
            "grin-tongue-squint"
        ],
        "f58a",
        "M0 256C0 368.9 73.1 464.7 174.5 498.8C165.3 484 160 466.6 160 448l0-47.3c-24-17.5-43.1-41.4-54.8-69.2c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7c-11.8 28-31.1 52-55.4 69.6l0 46.9c0 18.6-5.3 36-14.5 50.8C438.9 464.7 512 368.9 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zM116 141.1c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm262.5-10.5c7.9-4.2 17.5 1.5 17.5 10.5c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9zM320 448l0-45.4c0-14.7-11.9-26.6-26.6-26.6l-2 0c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9l-2 0c-14.7 0-26.6 11.9-26.6 26.6l0 45.4c0 35.3 28.7 64 64 64s64-28.7 64-64z"
    ]
};
const $d8206b3ab2e65c05$export$4edf34c3def09a31 = $d8206b3ab2e65c05$export$8eee2c17ff89e724;
const $d8206b3ab2e65c05$export$4952c502f544cf85 = {
    prefix: 'fas',
    iconName: 'spray-can',
    icon: [
        512,
        512,
        [],
        "f5bd",
        "M128 0l64 0c17.7 0 32 14.3 32 32l0 96L96 128l0-96c0-17.7 14.3-32 32-32zM0 256c0-53 43-96 96-96l128 0c53 0 96 43 96 96l0 208c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 256zm240 80A80 80 0 1 0 80 336a80 80 0 1 0 160 0zM256 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM384 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM448 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM384 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $d8206b3ab2e65c05$export$24b8a0147653649a = {
    prefix: 'fas',
    iconName: 'truck-monster',
    icon: [
        640,
        512,
        [],
        "f63b",
        "M288 64l0 64 128 0L368 64l-80 0zM419.2 25.6L496 128l80 0c17.7 0 32 14.3 32 32l0 64c17.7 0 32 14.3 32 32s-14.3 32-32 32c-29.2-38.9-75.7-64-128-64s-98.8 25.1-128 64l-64 0c-29.2-38.9-75.7-64-128-64s-98.8 25.1-128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32l0-64c0-17.7 14.3-32 32-32l160 0 0-80c0-26.5 21.5-48 48-48l96 0c20.1 0 39.1 9.5 51.2 25.6zM152 256l16 0c12.1 0 22.1 8.9 23.8 20.6c7.6 2.2 14.9 5.3 21.7 9c9.4-7 22.8-6.3 31.3 2.3l11.3 11.3c8.6 8.6 9.3 21.9 2.3 31.3c3.7 6.8 6.8 14.1 9 21.7c11.6 1.7 20.6 11.7 20.6 23.8l0 16c0 12.1-8.9 22.1-20.6 23.8c-2.2 7.6-5.3 14.9-9 21.7c7 9.4 6.3 22.8-2.3 31.3l-11.3 11.3c-8.6 8.6-21.9 9.3-31.3 2.2c-6.8 3.7-14.1 6.8-21.7 9C190.1 503.1 180.1 512 168 512l-16 0c-12.1 0-22.1-8.9-23.8-20.6c-7.6-2.2-14.9-5.3-21.7-9c-9.4 7.1-22.8 6.3-31.3-2.2L63.8 468.9c-8.6-8.6-9.3-21.9-2.3-31.3c-3.7-6.9-6.8-14.1-9-21.8C40.9 414.1 32 404.1 32 392l0-16c0-12.1 8.9-22.1 20.6-23.8c2.2-7.6 5.3-14.9 9-21.8c-7-9.4-6.3-22.8 2.3-31.3l11.3-11.3c8.6-8.6 21.9-9.3 31.3-2.3c6.8-3.7 14.1-6.8 21.7-9c1.7-11.6 11.7-20.6 23.8-20.6zm8 176a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM448.2 276.6c1.7-11.6 11.7-20.6 23.8-20.6l16 0c12.1 0 22.1 8.9 23.8 20.6c7.6 2.2 14.9 5.3 21.8 9c9.4-7 22.8-6.3 31.3 2.3l11.3 11.3c8.6 8.6 9.3 21.9 2.2 31.3c3.7 6.8 6.8 14.1 9 21.7c11.6 1.7 20.6 11.7 20.6 23.8l0 16c0 12.1-8.9 22.1-20.6 23.8c-2.2 7.6-5.3 14.9-9 21.7c7 9.4 6.3 22.8-2.2 31.3l-11.3 11.3c-8.6 8.6-21.9 9.3-31.3 2.2c-6.9 3.7-14.1 6.8-21.8 9C510.1 503.1 500.1 512 488 512l-16 0c-12.1 0-22.1-8.9-23.8-20.6c-7.6-2.2-14.9-5.3-21.7-9c-9.4 7.1-22.8 6.3-31.3-2.2l-11.3-11.3c-8.6-8.6-9.3-21.9-2.2-31.3c-3.7-6.9-6.8-14.1-9-21.8C360.9 414.1 352 404.1 352 392l0-16c0-12.1 8.9-22.1 20.6-23.8c2.2-7.6 5.3-14.9 9-21.8c-7-9.4-6.3-22.8 2.2-31.3l11.3-11.3c8.6-8.6 21.9-9.3 31.3-2.3c6.8-3.7 14.1-6.8 21.7-9zM528 384a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
    ]
};
const $d8206b3ab2e65c05$export$c7f24bdea332f90a = {
    prefix: 'fas',
    iconName: 'w',
    icon: [
        576,
        512,
        [
            119
        ],
        "57",
        "M20.8 34c16.5-6.2 35 2.2 41.2 18.7l110.2 294L257.3 55c4-13.7 16.5-23 30.7-23s26.7 9.4 30.7 23l85.1 291.7L514 52.8c6.2-16.5 24.6-24.9 41.2-18.7s24.9 24.7 18.7 41.2l-144 384c-4.8 12.9-17.4 21.3-31.2 20.7s-25.7-9.8-29.5-23L288 178.3 206.7 457c-3.9 13.2-15.8 22.5-29.5 23s-26.3-7.8-31.2-20.7L2 75.2C-4.2 58.7 4.2 40.2 20.8 34z"
    ]
};
const $d8206b3ab2e65c05$export$11afa141d42099d0 = {
    prefix: 'fas',
    iconName: 'earth-africa',
    icon: [
        512,
        512,
        [
            127757,
            "globe-africa"
        ],
        "f57c",
        "M177.8 63.2l10 17.4c2.8 4.8 4.2 10.3 4.2 15.9l0 41.4c0 3.9 1.6 7.7 4.3 10.4c6.2 6.2 16.5 5.7 22-1.2l13.6-17c4.7-5.9 12.9-7.7 19.6-4.3l15.2 7.6c3.4 1.7 7.2 2.6 11 2.6c6.5 0 12.8-2.6 17.4-7.2l3.9-3.9c2.9-2.9 7.3-3.6 11-1.8l29.2 14.6c7.8 3.9 12.6 11.8 12.6 20.5c0 10.5-7.1 19.6-17.3 22.2l-35.4 8.8c-7.4 1.8-15.1 1.5-22.4-.9l-32-10.7c-3.3-1.1-6.7-1.7-10.2-1.7c-7 0-13.8 2.3-19.4 6.5L176 212c-10.1 7.6-16 19.4-16 32l0 28c0 26.5 21.5 48 48 48l32 0c8.8 0 16 7.2 16 16l0 48c0 17.7 14.3 32 32 32c10.1 0 19.6-4.7 25.6-12.8l25.6-34.1c8.3-11.1 12.8-24.6 12.8-38.4l0-12.1c0-3.9 2.6-7.3 6.4-8.2l5.3-1.3c11.9-3 20.3-13.7 20.3-26c0-7.1-2.8-13.9-7.8-18.9l-33.5-33.5c-3.7-3.7-3.7-9.7 0-13.4c5.7-5.7 14.1-7.7 21.8-5.1l14.1 4.7c12.3 4.1 25.7-1.5 31.5-13c3.5-7 11.2-10.8 18.9-9.2l27.4 5.5C432 112.4 351.5 48 256 48c-27.7 0-54 5.4-78.2 15.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
    ]
};
const $d8206b3ab2e65c05$export$64af36f3b403a57c = $d8206b3ab2e65c05$export$11afa141d42099d0;
const $d8206b3ab2e65c05$export$92ab27739d3a91b2 = {
    prefix: 'fas',
    iconName: 'rainbow',
    icon: [
        640,
        512,
        [
            127752
        ],
        "f75b",
        "M320 96C178.6 96 64 210.6 64 352l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96C0 175.3 143.3 32 320 32s320 143.3 320 320l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96C576 210.6 461.4 96 320 96zm0 192c-35.3 0-64 28.7-64 64l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96c0-70.7 57.3-128 128-128s128 57.3 128 128l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96c0-35.3-28.7-64-64-64zM160 352l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96c0-123.7 100.3-224 224-224s224 100.3 224 224l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96c0-88.4-71.6-160-160-160s-160 71.6-160 160z"
    ]
};
const $d8206b3ab2e65c05$export$9429fd8df55155d = {
    prefix: 'fas',
    iconName: 'circle-notch',
    icon: [
        512,
        512,
        [],
        "f1ce",
        "M222.7 32.1c5 16.9-4.6 34.8-21.5 39.8C121.8 95.6 64 169.1 64 256c0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1c-16.9-5-26.6-22.9-21.5-39.8s22.9-26.6 39.8-21.5C434.9 42.1 512 140 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 140 77.1 42.1 182.9 10.6c16.9-5 34.8 4.6 39.8 21.5z"
    ]
};
const $d8206b3ab2e65c05$export$df1e253fc358ade4 = {
    prefix: 'fas',
    iconName: 'tablet-screen-button',
    icon: [
        448,
        512,
        [
            "tablet-alt"
        ],
        "f3fa",
        "M0 64C0 28.7 28.7 0 64 0L384 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM256 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM384 64L64 64l0 320 320 0 0-320z"
    ]
};
const $d8206b3ab2e65c05$export$db0cac088255eacc = $d8206b3ab2e65c05$export$df1e253fc358ade4;
const $d8206b3ab2e65c05$export$7bc6e4d977673e69 = {
    prefix: 'fas',
    iconName: 'paw',
    icon: [
        512,
        512,
        [],
        "f1b0",
        "M226.5 92.9c14.3 42.9-.3 86.2-32.6 96.8s-70.1-15.6-84.4-58.5s.3-86.2 32.6-96.8s70.1 15.6 84.4 58.5zM100.4 198.6c18.9 32.4 14.3 70.1-10.2 84.1s-59.7-.9-78.5-33.3S-2.7 179.3 21.8 165.3s59.7 .9 78.5 33.3zM69.2 401.2C121.6 259.9 214.7 224 256 224s134.4 35.9 186.8 177.2c3.6 9.7 5.2 20.1 5.2 30.5l0 1.6c0 25.8-20.9 46.7-46.7 46.7c-11.5 0-22.9-1.4-34-4.2l-88-22c-15.3-3.8-31.3-3.8-46.6 0l-88 22c-11.1 2.8-22.5 4.2-34 4.2C84.9 480 64 459.1 64 433.3l0-1.6c0-10.4 1.6-20.8 5.2-30.5zM421.8 282.7c-24.5-14-29.1-51.7-10.2-84.1s54-47.3 78.5-33.3s29.1 51.7 10.2 84.1s-54 47.3-78.5 33.3zM310.1 189.7c-32.3-10.6-46.9-53.9-32.6-96.8s52.1-69.1 84.4-58.5s46.9 53.9 32.6 96.8s-52.1 69.1-84.4 58.5z"
    ]
};
const $d8206b3ab2e65c05$export$8bb3c4d5c2f50243 = {
    prefix: 'fas',
    iconName: 'cloud',
    icon: [
        640,
        512,
        [
            9729
        ],
        "f0c2",
        "M0 336c0 79.5 64.5 144 144 144l368 0c70.7 0 128-57.3 128-128c0-61.9-44-113.6-102.4-125.4c4.1-10.7 6.4-22.4 6.4-34.6c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192c0 2.7 .1 5.4 .2 8.1C40.2 219.8 0 273.2 0 336z"
    ]
};
const $d8206b3ab2e65c05$export$b6c20c10ddbd9898 = {
    prefix: 'fas',
    iconName: 'trowel-bricks',
    icon: [
        512,
        512,
        [],
        "e58a",
        "M240.8 4.8C250.3 10.6 256 20.9 256 32l0 72 89 0c3.6-13.8 16.1-24 31-24l88 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-88 0c-14.9 0-27.4-10.2-31-24l-89 0 0 72c0 11.1-5.7 21.4-15.2 27.2s-21.2 6.4-31.1 1.4l-192-96C6.8 151.2 0 140.1 0 128s6.8-23.2 17.7-28.6l192-96c9.9-5 21.7-4.4 31.1 1.4zM288 256c0-17.7 14.3-32 32-32l160 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-64zM32 384l96 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm192 0l256 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32z"
    ]
};
const $d8206b3ab2e65c05$export$ba5dc4287853ecbd = {
    prefix: 'fas',
    iconName: 'face-flushed',
    icon: [
        512,
        512,
        [
            128563,
            "flushed"
        ],
        "f579",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM176 384c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16zm-16-88a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm264-72a72 72 0 1 0 -144 0 72 72 0 1 0 144 0zm-288 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm192 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
const $d8206b3ab2e65c05$export$dfd2bd012685aeac = $d8206b3ab2e65c05$export$ba5dc4287853ecbd;
const $d8206b3ab2e65c05$export$684703c93d630cc5 = {
    prefix: 'fas',
    iconName: 'hospital-user',
    icon: [
        576,
        512,
        [],
        "f80d",
        "M48 0C21.5 0 0 21.5 0 48L0 256l144 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L0 288l0 64 144 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L0 384l0 80c0 26.5 21.5 48 48 48l217.9 0c-6.3-10.2-9.9-22.2-9.9-35.1c0-46.9 25.8-87.8 64-109.2l0-95.9L320 48c0-26.5-21.5-48-48-48L48 0zM152 64l16 0c8.8 0 16 7.2 16 16l0 24 24 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-24 0 0 24c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-24-24 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16l24 0 0-24c0-8.8 7.2-16 16-16zM512 272a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM288 477.1c0 19.3 15.6 34.9 34.9 34.9l218.2 0c19.3 0 34.9-15.6 34.9-34.9c0-51.4-41.7-93.1-93.1-93.1l-101.8 0c-51.4 0-93.1 41.7-93.1 93.1z"
    ]
};
const $d8206b3ab2e65c05$export$fa95eb7418c0e2b8 = {
    prefix: 'fas',
    iconName: 'tent-arrow-left-right',
    icon: [
        576,
        512,
        [],
        "e57f",
        "M488.1 6.2c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9L489.5 72 86.5 72l33.5-30.2c9.9-8.9 10.7-24 1.8-33.9S97.8-2.7 87.9 6.2l-80 72C2.9 82.7 0 89.2 0 96s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L86.5 120l402.9 0-33.5 30.2c-9.9 8.9-10.7 24-1.8 33.9s24 10.7 33.9 1.8l80-72c5.1-4.6 7.9-11 7.9-17.8s-2.9-13.3-7.9-17.8l-80-72zM307.4 166.5c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S86.7 512 96 512l144 0 16 0c17.7 0 32-14.3 32-32l0-118.1c0-5.5 4.4-9.9 9.9-9.9c3.7 0 7.2 2.1 8.8 5.5l68.4 136.8c5.4 10.8 16.5 17.7 28.6 17.7l60.2 0 16 0c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"
    ]
};
const $d8206b3ab2e65c05$export$c36fb40057e2c3aa = {
    prefix: 'fas',
    iconName: 'gavel',
    icon: [
        512,
        512,
        [
            "legal"
        ],
        "f0e3",
        "M318.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-120 120c-12.5 12.5-12.5 32.8 0 45.3l16 16c12.5 12.5 32.8 12.5 45.3 0l4-4L325.4 293.4l-4 4c-12.5 12.5-12.5 32.8 0 45.3l16 16c12.5 12.5 32.8 12.5 45.3 0l120-120c12.5-12.5 12.5-32.8 0-45.3l-16-16c-12.5-12.5-32.8-12.5-45.3 0l-4 4L330.6 74.6l4-4c12.5-12.5 12.5-32.8 0-45.3l-16-16zm-152 288c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l48 48c12.5 12.5 32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-1.4-1.4L272 285.3 226.7 240 168 298.7l-1.4-1.4z"
    ]
};
const $d8206b3ab2e65c05$export$59d593c2dacb3781 = $d8206b3ab2e65c05$export$c36fb40057e2c3aa;
const $d8206b3ab2e65c05$export$8a910017964bb8c2 = {
    prefix: 'fas',
    iconName: 'binoculars',
    icon: [
        512,
        512,
        [],
        "f1e5",
        "M128 32l32 0c17.7 0 32 14.3 32 32l0 32L96 96l0-32c0-17.7 14.3-32 32-32zm64 96l0 320c0 17.7-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32l0-59.1c0-34.6 9.4-68.6 27.2-98.3C40.9 267.8 49.7 242.4 53 216L60.5 156c2-16 15.6-28 31.8-28l99.8 0zm227.8 0c16.1 0 29.8 12 31.8 28L459 216c3.3 26.4 12.1 51.8 25.8 74.6c17.8 29.7 27.2 63.7 27.2 98.3l0 59.1c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-320 99.8 0zM320 64c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 32-96 0 0-32zm-32 64l0 160-64 0 0-160 64 0z"
    ]
};
const $d8206b3ab2e65c05$export$843f63d64e6f7951 = {
    prefix: 'fas',
    iconName: 'microphone-slash',
    icon: [
        640,
        512,
        [],
        "f131",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c15.2-26 23.9-56.3 23.9-88.7l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 21.2-5.1 41.1-14.2 58.7L416 300.8 416 96c0-53-43-96-96-96s-96 43-96 96l0 54.3L38.8 5.1zM344 430.4c20.4-2.8 39.7-9.1 57.3-18.2l-43.1-33.9C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128l0-8.7L144.7 210c-.5 1.9-.7 3.9-.7 6l0 40c0 89.1 66.2 162.7 152 174.4l0 33.6-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-33.6z"
    ]
};
const $d8206b3ab2e65c05$export$f2adc06617bc0c7 = {
    prefix: 'fas',
    iconName: 'box-tissue',
    icon: [
        512,
        512,
        [],
        "e05b",
        "M92.5 0L208 0c40 0 52 24 64 48s24 48 64 48l85.2 0C436 96 448 108 448 122.8c0 3.4-.7 6.8-1.9 10L409.6 224 384 288l-256 0-16-64L64.9 35.4c-.6-2.3-.9-4.6-.9-6.9C64 12.8 76.8 0 92.5 0zM79 224l16 64-15 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 256 0 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-13.5 0 25.6-64 19.9 0c26.5 0 48 21.5 48 48l0 112L0 384 0 272c0-26.5 21.5-48 48-48l31 0zM0 416l512 0 0 48c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48l0-48z"
    ]
};
const $d8206b3ab2e65c05$export$f26017bdca99338d = {
    prefix: 'fas',
    iconName: 'motorcycle',
    icon: [
        640,
        512,
        [
            127949
        ],
        "f21c",
        "M280 32c-13.3 0-24 10.7-24 24s10.7 24 24 24l57.7 0 16.4 30.3L256 192l-45.3-45.3c-12-12-28.3-18.7-45.3-18.7L64 128c-17.7 0-32 14.3-32 32l0 32 96 0c88.4 0 160 71.6 160 160c0 11-1.1 21.7-3.2 32l70.4 0c-2.1-10.3-3.2-21-3.2-32c0-52.2 25-98.6 63.7-127.8l15.4 28.6C402.4 276.3 384 312 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-13.5 0-26.5 2.1-38.7 6L418.2 128l61.8 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-20.4 0c-7.5 0-14.7 2.6-20.5 7.4L391.7 78.9l-14-26c-7-12.9-20.5-21-35.2-21L280 32zM462.7 311.2l28.2 52.2c6.3 11.7 20.9 16 32.5 9.7s16-20.9 9.7-32.5l-28.2-52.2c2.3-.3 4.7-.4 7.1-.4c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-15.5 5.5-29.7 14.7-40.8zM187.3 376c-9.5 23.5-32.5 40-59.3 40c-35.3 0-64-28.7-64-64s28.7-64 64-64c26.9 0 49.9 16.5 59.3 40l66.4 0C242.5 268.8 190.5 224 128 224C57.3 224 0 281.3 0 352s57.3 128 128 128c62.5 0 114.5-44.8 125.8-104l-66.4 0zM128 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
const $d8206b3ab2e65c05$export$e433538b78718fb3 = {
    prefix: 'fas',
    iconName: 'bell-concierge',
    icon: [
        512,
        512,
        [
            128718,
            "concierge-bell"
        ],
        "f562",
        "M216 64c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0 0 33.3C119.6 157.2 32 252.4 32 368l448 0c0-115.6-87.6-210.8-200-222.7l0-33.3 16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0-40 0zM24 400c-13.3 0-24 10.7-24 24s10.7 24 24 24l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 400z"
    ]
};
const $d8206b3ab2e65c05$export$ad92ffbbfbc0fcf3 = $d8206b3ab2e65c05$export$e433538b78718fb3;
const $d8206b3ab2e65c05$export$85ba06027671d290 = {
    prefix: 'fas',
    iconName: 'pen-ruler',
    icon: [
        512,
        512,
        [
            "pencil-ruler"
        ],
        "f5ae",
        "M469.3 19.3l23.4 23.4c25 25 25 65.5 0 90.5l-56.4 56.4L322.3 75.7l56.4-56.4c25-25 65.5-25 90.5 0zM44.9 353.2L299.7 98.3 413.7 212.3 158.8 467.1c-6.7 6.7-15.1 11.6-24.2 14.2l-104 29.7c-8.4 2.4-17.4 .1-23.6-6.1s-8.5-15.2-6.1-23.6l29.7-104c2.6-9.2 7.5-17.5 14.2-24.2zM249.4 103.4L103.4 249.4 16 161.9c-18.7-18.7-18.7-49.1 0-67.9L94.1 16c18.7-18.7 49.1-18.7 67.9 0l19.8 19.8c-.3 .3-.7 .6-1 .9l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c.3-.3 .6-.7 .9-1l45.1 45.1zM408.6 262.6l45.1 45.1c-.3 .3-.7 .6-1 .9l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c.3-.3 .6-.7 .9-1L496 350.1c18.7 18.7 18.7 49.1 0 67.9L417.9 496c-18.7 18.7-49.1 18.7-67.9 0l-87.4-87.4L408.6 262.6z"
    ]
};
const $d8206b3ab2e65c05$export$e3a7a1affea005f5 = $d8206b3ab2e65c05$export$85ba06027671d290;
const $d8206b3ab2e65c05$export$804bfc5c390e1a2a = {
    prefix: 'fas',
    iconName: 'people-arrows',
    icon: [
        640,
        512,
        [
            "people-arrows-left-right"
        ],
        "e068",
        "M64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zM25.9 233.4C29.3 191.9 64 160 105.6 160l44.8 0c27 0 51 13.4 65.5 34.1c-2.7 1.9-5.2 4-7.5 6.3l-64 64c-21.9 21.9-21.9 57.3 0 79.2L192 391.2l0 72.8c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-115.7c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3zM448 64a64 64 0 1 1 128 0A64 64 0 1 1 448 64zM431.6 200.4c-2.3-2.3-4.9-4.4-7.5-6.3c14.5-20.7 38.6-34.1 65.5-34.1l44.8 0c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6L576 464c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-72.8 47.6-47.6c21.9-21.9 21.9-57.3 0-79.2l-64-64zM272 240l0 32 96 0 0-32c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l64 64c9.4 9.4 9.4 24.6 0 33.9l-64 64c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2l0-32-96 0 0 32c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-64-64c-9.4-9.4-9.4-24.6 0-33.9l64-64c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2z"
    ]
};
const $d8206b3ab2e65c05$export$da01f044c59e3598 = $d8206b3ab2e65c05$export$804bfc5c390e1a2a;
const $d8206b3ab2e65c05$export$1dc6221efb867885 = {
    prefix: 'fas',
    iconName: 'mars-and-venus-burst',
    icon: [
        640,
        512,
        [],
        "e523",
        "M504 0c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l39 39-22.2 22.2C475.9 78.4 439.6 64 400 64c-88.4 0-160 71.6-160 160c0 80.2 59.1 146.7 136.1 158.2c0 .6-.1 1.2-.1 1.8l0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .3 0 .4 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3-24 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l24 0 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1c0 0 0 .1 0 .1s0 .1 0 .1l0 .1c0 0 0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0l24 0-24 0c0 13.3 10.7 24 24 24s24-10.7 24-24l-24 0 24 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1l0-.1c0 0 0-.1 0-.1s0-.1 0-.1l0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 24 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-24 0 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.4 0-.3 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4c0-.6 0-1.2-.1-1.8c77-11.6 136.1-78 136.1-158.2c0-31.4-9-60.7-24.7-85.4L560 113.9l39 39c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2l0-112c0-13.3-10.7-24-24-24L504 0zM400 128a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6L176 286.1l58.6 53.9c4.1 3.8 9.9 5.1 15.2 3.6C223.6 310.8 208 269.2 208 224c0-60.8 28.3-115 72.4-150.2L220.3 92.1l-29.4-74z"
    ]
};
const $d8206b3ab2e65c05$export$5b1d41cdd118ea6d = {
    prefix: 'fas',
    iconName: 'square-caret-right',
    icon: [
        448,
        512,
        [
            "caret-square-right"
        ],
        "f152",
        "M448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM320 256c0 6.7-2.8 13-7.7 17.6l-112 104c-7 6.5-17.2 8.2-25.9 4.4s-14.4-12.5-14.4-22l0-208c0-9.5 5.7-18.2 14.4-22s18.9-2.1 25.9 4.4l112 104c4.9 4.5 7.7 10.9 7.7 17.6z"
    ]
};
const $d8206b3ab2e65c05$export$ae86c9de7e0f62fa = $d8206b3ab2e65c05$export$5b1d41cdd118ea6d;
const $d8206b3ab2e65c05$export$b2a906a5928c6404 = {
    prefix: 'fas',
    iconName: 'scissors',
    icon: [
        512,
        512,
        [
            9984,
            9986,
            9988,
            "cut"
        ],
        "f0c4",
        "M256 192l-39.5-39.5c4.9-12.6 7.5-26.2 7.5-40.5C224 50.1 173.9 0 112 0S0 50.1 0 112s50.1 112 112 112c14.3 0 27.9-2.7 40.5-7.5L192 256l-39.5 39.5c-12.6-4.9-26.2-7.5-40.5-7.5C50.1 288 0 338.1 0 400s50.1 112 112 112s112-50.1 112-112c0-14.3-2.7-27.9-7.5-40.5L499.2 76.8c7.1-7.1 7.1-18.5 0-25.6c-28.3-28.3-74.1-28.3-102.4 0L256 192zm22.6 150.6L396.8 460.8c28.3 28.3 74.1 28.3 102.4 0c7.1-7.1 7.1-18.5 0-25.6L342.6 278.6l-64 64zM64 112a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm48 240a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
const $d8206b3ab2e65c05$export$66847f2a71b260e7 = $d8206b3ab2e65c05$export$b2a906a5928c6404;
const $d8206b3ab2e65c05$export$8db7f2f70484e17e = {
    prefix: 'fas',
    iconName: 'sun-plant-wilt',
    icon: [
        640,
        512,
        [],
        "e57a",
        "M160 0c-6.3 0-12 3.7-14.6 9.5L120.6 64.9 63.9 43.2c-5.9-2.3-12.6-.8-17 3.6s-5.9 11.1-3.6 17l21.7 56.7L9.5 145.4C3.7 148 0 153.7 0 160s3.7 12 9.5 14.6l55.4 24.8L43.2 256.1c-2.3 5.9-.8 12.6 3.6 17s11.1 5.9 17 3.6l56.7-21.7 24.8 55.4c2.6 5.8 8.3 9.5 14.6 9.5s12-3.7 14.6-9.5l24.8-55.4 56.7 21.7c5.9 2.3 12.6 .8 17-3.6s5.9-11.1 3.6-17l-21.7-56.7 55.4-24.8c5.8-2.6 9.5-8.3 9.5-14.6s-3.7-12-9.5-14.6l-55.4-24.8 21.7-56.7c2.3-5.9 .8-12.6-3.6-17s-11.1-5.9-17-3.6L199.4 64.9 174.6 9.5C172 3.7 166.3 0 160 0zm0 96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm312 16c0-17.7 14.3-32 32-32s32 14.3 32 32l0 53.4c-14.8 7.7-24 23.1-24 44.6c0 16.8 16 44 37.4 67.2c5.8 6.2 15.5 6.2 21.2 0C624 318 640 290.7 640 274c0-21.5-9.2-37-24-44.6l0-53.4c0-44.2-35.8-80-80-80s-80 35.8-80 80l0 22.7c-9.8-4.3-20.6-6.7-32-6.7c-44.2 0-80 35.8-80 80l0 21.4c-14.8 7.7-24 23.1-24 44.6c0 16.8 16 44 37.4 67.2c5.8 6.2 15.5 6.2 21.2 0C400 382 416 354.7 416 338c0-21.5-9.2-37-24-44.6l0-21.4c0-17.7 14.3-32 32-32s32 14.3 32 32l0 8 0 168L32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l576 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-104 0 0-168 0-8 0-96z"
    ]
};
const $d8206b3ab2e65c05$export$c00f55f36d386cb7 = {
    prefix: 'fas',
    iconName: 'toilets-portable',
    icon: [
        576,
        512,
        [],
        "e584",
        "M32 0L224 0c17.7 0 32 14.3 32 32l0 32L0 64 0 32C0 14.3 14.3 0 32 0zM0 96l24 0 208 0 24 0 0 24 0 368c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8L48 480l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 120 0 96zM192 224c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16zM352 0L544 0c17.7 0 32 14.3 32 32l0 32L320 64l0-32c0-17.7 14.3-32 32-32zM320 96l24 0 208 0 24 0 0 24 0 368c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8-160 0 0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-368 0-24zM512 224c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16z"
    ]
};
const $d8206b3ab2e65c05$export$a274b02dc75663dc = {
    prefix: 'fas',
    iconName: 'hockey-puck',
    icon: [
        512,
        512,
        [],
        "f453",
        "M256 256C114.6 256 0 213 0 160s114.6-96 256-96s256 43 256 96s-114.6 96-256 96zm192.3 1.8c24.7-9.3 46.9-21 63.7-35.6L512 352c0 53-114.6 96-256 96S0 405 0 352L0 222.3c16.8 14.6 39 26.3 63.7 35.6C114.5 276.9 182.5 288 256 288s141.5-11.1 192.3-30.2z"
    ]
};
const $d8206b3ab2e65c05$export$36583f5d3d5a971f = {
    prefix: 'fas',
    iconName: 'table',
    icon: [
        512,
        512,
        [],
        "f0ce",
        "M64 256l0-96 160 0 0 96L64 256zm0 64l160 0 0 96L64 416l0-96zm224 96l0-96 160 0 0 96-160 0zM448 256l-160 0 0-96 160 0 0 96zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z"
    ]
};
const $d8206b3ab2e65c05$export$382d3376c7fc7fc5 = {
    prefix: 'fas',
    iconName: 'magnifying-glass-arrow-right',
    icon: [
        512,
        512,
        [],
        "e521",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM241 119c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31L120 184c-13.3 0-24 10.7-24 24s10.7 24 24 24l118.1 0-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9l-72-72z"
    ]
};
const $d8206b3ab2e65c05$export$73f2bf302381c86a = {
    prefix: 'fas',
    iconName: 'tachograph-digital',
    icon: [
        640,
        512,
        [
            "digital-tachograph"
        ],
        "f566",
        "M64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l512 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64zm32 64l224 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L96 256c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zM64 368c0-8.8 7.2-16 16-16l256 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 384c-8.8 0-16-7.2-16-16zm320 0c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16zM80 288a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
    ]
};
const $d8206b3ab2e65c05$export$b3bf1994f0fefe98 = $d8206b3ab2e65c05$export$73f2bf302381c86a;
const $d8206b3ab2e65c05$export$b71a093b86e3da1f = {
    prefix: 'fas',
    iconName: 'users-slash',
    icon: [
        640,
        512,
        [],
        "e073",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L440.6 320l178.1 0c11.8 0 21.3-9.6 21.3-21.3C640 239.8 592.2 192 533.3 192l-42.7 0c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 30.2-10.5 58-28 79.9l-25.2-19.7C408.1 267.7 416 246.8 416 224c0-53-43-96-96-96c-31.1 0-58.7 14.8-76.3 37.7l-40.6-31.8c13-14.2 20.9-33.1 20.9-53.9c0-44.2-35.8-80-80-80C116.3 0 91.9 14.1 77.5 35.5L38.8 5.1zM106.7 192C47.8 192 0 239.8 0 298.7C0 310.4 9.6 320 21.3 320l213.3 0c.2 0 .4 0 .7 0c-20.6-18.2-35.2-42.8-40.8-70.8L121.8 192l-15.2 0zM261.3 352C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7l330.7 0c10.5 0 19.5-6 23.9-14.8L324.9 352l-63.6 0zM512 160A80 80 0 1 0 512 0a80 80 0 1 0 0 160z"
    ]
};
const $d8206b3ab2e65c05$export$57813571c0e10a0a = {
    prefix: 'fas',
    iconName: 'clover',
    icon: [
        448,
        512,
        [],
        "e139",
        "M216.6 49.9C205.1 38.5 189.5 32 173.3 32C139.4 32 112 59.4 112 93.3l0 4.9c0 12 3.3 23.7 9.4 34l18.8 31.3c1.1 1.8 1.2 3.1 1 4.2c-.2 1.2-.8 2.5-2 3.6s-2.4 1.8-3.6 2c-1 .2-2.4 .1-4.2-1l-31.3-18.8c-10.3-6.2-22-9.4-34-9.4l-4.9 0C27.4 144 0 171.4 0 205.3c0 16.2 6.5 31.8 17.9 43.3l1.2 1.2c3.4 3.4 3.4 9 0 12.4l-1.2 1.2C6.5 274.9 0 290.5 0 306.7C0 340.6 27.4 368 61.3 368l4.9 0c12 0 23.7-3.3 34-9.4l31.3-18.8c1.8-1.1 3.1-1.2 4.2-1c1.2 .2 2.5 .8 3.6 2s1.8 2.4 2 3.6c.2 1 .1 2.4-1 4.2l-18.8 31.3c-6.2 10.3-9.4 22-9.4 34l0 4.9c0 33.8 27.4 61.3 61.3 61.3c16.2 0 31.8-6.5 43.3-17.9l1.2-1.2c3.4-3.4 9-3.4 12.4 0l1.2 1.2c11.5 11.5 27.1 17.9 43.3 17.9c33.8 0 61.3-27.4 61.3-61.3l0-4.9c0-12-3.3-23.7-9.4-34l-18.8-31.3c-1.1-1.8-1.2-3.1-1-4.2c.2-1.2 .8-2.5 2-3.6s2.4-1.8 3.6-2c1-.2 2.4-.1 4.2 1l31.3 18.8c10.3 6.2 22 9.4 34 9.4l4.9 0c33.8 0 61.3-27.4 61.3-61.3c0-16.2-6.5-31.8-17.9-43.3l-1.2-1.2c-3.4-3.4-3.4-9 0-12.4l1.2-1.2c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3l-4.9 0c-12 0-23.7 3.3-34 9.4l-31.3 18.8c-1.8 1.1-3.1 1.2-4.2 1c-1.2-.2-2.5-.8-3.6-2s-1.8-2.4-2-3.6c-.2-1-.1-2.4 1-4.2l18.8-31.3c6.2-10.3 9.4-22 9.4-34l0-4.9C336 59.4 308.6 32 274.7 32c-16.2 0-31.8 6.5-43.3 17.9l-1.2 1.2c-3.4 3.4-9 3.4-12.4 0l-1.2-1.2z"
    ]
};
const $d8206b3ab2e65c05$export$bb06d4a7bb6736fe = {
    prefix: 'fas',
    iconName: 'reply',
    icon: [
        512,
        512,
        [
            61714,
            "mail-reply"
        ],
        "f3e5",
        "M205 34.8c11.5 5.1 19 16.6 19 29.2l0 64 112 0c97.2 0 176 78.8 176 176c0 113.3-81.5 163.9-100.2 174.1c-2.5 1.4-5.3 1.9-8.1 1.9c-10.9 0-19.7-8.9-19.7-19.7c0-7.5 4.3-14.4 9.8-19.5c9.4-8.8 22.2-26.4 22.2-56.7c0-53-43-96-96-96l-96 0 0 64c0 12.6-7.4 24.1-19 29.2s-25 3-34.4-5.4l-160-144C3.9 225.7 0 217.1 0 208s3.9-17.7 10.6-23.8l160-144c9.4-8.5 22.9-10.6 34.4-5.4z"
    ]
};
const $d8206b3ab2e65c05$export$12e45ff70d2646a1 = $d8206b3ab2e65c05$export$bb06d4a7bb6736fe;
const $d8206b3ab2e65c05$export$cafa834c96ebcb1a = {
    prefix: 'fas',
    iconName: 'star-and-crescent',
    icon: [
        512,
        512,
        [
            9770
        ],
        "f699",
        "M0 256C0 114.6 114.6 0 256 0c33 0 64.6 6.3 93.6 17.7c7.4 2.9 11.5 10.7 9.8 18.4s-8.8 13-16.7 12.4c-4.8-.3-9.7-.5-14.6-.5c-114.9 0-208 93.1-208 208s93.1 208 208 208c4.9 0 9.8-.2 14.6-.5c7.9-.5 15 4.7 16.7 12.4s-2.4 15.5-9.8 18.4C320.6 505.7 289 512 256 512C114.6 512 0 397.4 0 256zM375.4 137.4c3.5-7.1 13.7-7.1 17.2 0l31.5 63.8c1.4 2.8 4.1 4.8 7.2 5.3l70.4 10.2c7.9 1.1 11 10.8 5.3 16.4l-50.9 49.6c-2.3 2.2-3.3 5.4-2.8 8.5l12 70.1c1.3 7.8-6.9 13.8-13.9 10.1l-63-33.1c-2.8-1.5-6.1-1.5-8.9 0l-63 33.1c-7 3.7-15.3-2.3-13.9-10.1l12-70.1c.5-3.1-.5-6.3-2.8-8.5L261 233.1c-5.7-5.6-2.6-15.2 5.3-16.4l70.4-10.2c3.1-.5 5.8-2.4 7.2-5.3l31.5-63.8z"
    ]
};
const $d8206b3ab2e65c05$export$947ee033a6942aa8 = {
    prefix: 'fas',
    iconName: 'house-fire',
    icon: [
        640,
        512,
        [],
        "e50c",
        "M288 350.1l0 1.9-32 0c-17.7 0-32 14.3-32 32l0 64 0 24c0 22.1-17.9 40-40 40l-24 0-31.9 0c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2l-16 0c-22.1 0-40-17.9-40-40l0-112c0-.9 0-1.9 .1-2.8l0-69.7-32 0c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L447.3 128.1c-12.3-1-25 3-34.8 11.7c-35.4 31.6-65.6 67.7-87.3 102.8C304.3 276.5 288 314.9 288 350.1zM480 512c-88.4 0-160-71.6-160-160c0-76.7 62.5-144.7 107.2-179.4c5-3.9 10.9-5.8 16.8-5.8c7.9-.1 16 3.1 22 9.2l46 46 11.3-11.3c11.7-11.7 30.6-12.7 42.3-1C624.5 268 640 320.2 640 352c0 88.4-71.6 160-160 160zm64-111.8c0-36.5-37-73-54.8-88.4c-5.4-4.7-13.1-4.7-18.5 0C453 327.1 416 363.6 416 400.2c0 35.3 28.7 64 64 64s64-28.7 64-64z"
    ]
};
const $d8206b3ab2e65c05$export$814c9edba7b84aa4 = {
    prefix: 'fas',
    iconName: 'square-minus',
    icon: [
        448,
        512,
        [
            61767,
            "minus-square"
        ],
        "f146",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm88 200l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
const $d8206b3ab2e65c05$export$ffe9387966b3e681 = $d8206b3ab2e65c05$export$814c9edba7b84aa4;
const $d8206b3ab2e65c05$export$612d3e1afaf45fa5 = {
    prefix: 'fas',
    iconName: 'helicopter',
    icon: [
        640,
        512,
        [
            128641
        ],
        "f533",
        "M128 32c0-17.7 14.3-32 32-32L544 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L384 64l0 64 32 0c88.4 0 160 71.6 160 160l0 64c0 17.7-14.3 32-32 32l-160 0-64 0c-20.1 0-39.1-9.5-51.2-25.6l-71.4-95.2c-3.5-4.7-8.3-8.3-13.7-10.5L47.2 198.1c-9.5-3.8-16.7-12-19.2-22L5 83.9C2.4 73.8 10.1 64 20.5 64L48 64c10.1 0 19.6 4.7 25.6 12.8L112 128l208 0 0-64L160 64c-17.7 0-32-14.3-32-32zM384 320l128 0 0-32c0-53-43-96-96-96l-32 0 0 128zM630.6 425.4c12.5 12.5 12.5 32.8 0 45.3l-3.9 3.9c-24 24-56.6 37.5-90.5 37.5L256 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l280.2 0c17 0 33.3-6.7 45.3-18.7l3.9-3.9c12.5-12.5 32.8-12.5 45.3 0z"
    ]
};
const $d8206b3ab2e65c05$export$b4d344633433e50e = {
    prefix: 'fas',
    iconName: 'compass',
    icon: [
        512,
        512,
        [
            129517
        ],
        "f14e",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm50.7-186.9L162.4 380.6c-19.4 7.5-38.5-11.6-31-31l55.5-144.3c3.3-8.5 9.9-15.1 18.4-18.4l144.3-55.5c19.4-7.5 38.5 11.6 31 31L325.1 306.7c-3.2 8.5-9.9 15.1-18.4 18.4zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
const $d8206b3ab2e65c05$export$a1ab39cd66c4e50e = {
    prefix: 'fas',
    iconName: 'square-caret-down',
    icon: [
        448,
        512,
        [
            "caret-square-down"
        ],
        "f150",
        "M384 480c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0zM224 352c-6.7 0-13-2.8-17.6-7.7l-104-112c-6.5-7-8.2-17.2-4.4-25.9s12.5-14.4 22-14.4l208 0c9.5 0 18.2 5.7 22 14.4s2.1 18.9-4.4 25.9l-104 112c-4.5 4.9-10.9 7.7-17.6 7.7z"
    ]
};
const $d8206b3ab2e65c05$export$61aea18df1c84401 = $d8206b3ab2e65c05$export$a1ab39cd66c4e50e;
const $d8206b3ab2e65c05$export$877d3692c1f94bda = {
    prefix: 'fas',
    iconName: 'file-circle-question',
    icon: [
        576,
        512,
        [],
        "e4ef",
        "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM368 321.6l0 6.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-6.4c0-5.3 4.3-9.6 9.6-9.6l40.5 0c7.7 0 13.9 6.2 13.9 13.9c0 5.2-2.9 9.9-7.4 12.3l-32 16.8c-5.3 2.8-8.6 8.2-8.6 14.2l0 14.8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-5.1 23.5-12.3c15.1-7.9 24.5-23.6 24.5-40.6c0-25.4-20.6-45.9-45.9-45.9l-40.5 0c-23 0-41.6 18.6-41.6 41.6z"
    ]
};
const $d8206b3ab2e65c05$export$94100f4c6ee29932 = {
    prefix: 'fas',
    iconName: 'laptop-code',
    icon: [
        640,
        512,
        [],
        "f5fc",
        "M64 96c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 256-64 0 0-256L128 96l0 256-64 0L64 96zM0 403.2C0 392.6 8.6 384 19.2 384l601.6 0c10.6 0 19.2 8.6 19.2 19.2c0 42.4-34.4 76.8-76.8 76.8L76.8 480C34.4 480 0 445.6 0 403.2zM281 209l-31 31 31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM393 175l48 48c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
    ]
};
const $d8206b3ab2e65c05$export$c74a20c81b957b6a = {
    prefix: 'fas',
    iconName: 'swatchbook',
    icon: [
        512,
        512,
        [],
        "f5c3",
        "M0 32C0 14.3 14.3 0 32 0L160 0c17.7 0 32 14.3 32 32l0 384c0 53-43 96-96 96s-96-43-96-96L0 32zM223.6 425.9c.3-3.3 .4-6.6 .4-9.9l0-262 75.4-75.4c12.5-12.5 32.8-12.5 45.3 0l90.5 90.5c12.5 12.5 12.5 32.8 0 45.3L223.6 425.9zM182.8 512l192-192L480 320c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-297.2 0zM128 64L64 64l0 64 64 0 0-64zM64 192l0 64 64 0 0-64-64 0zM96 440a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
const $d8206b3ab2e65c05$export$214f9ce665590486 = {
    prefix: 'fas',
    iconName: 'prescription-bottle',
    icon: [
        384,
        512,
        [],
        "f485",
        "M0 32C0 14.3 14.3 0 32 0L352 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64L0 32zm32 96l320 0 0 320c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-32 112 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L32 384l0-64 112 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L32 288l0-64 112 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L32 192l0-64z"
    ]
};
const $d8206b3ab2e65c05$export$36e9cf7887265da2 = {
    prefix: 'fas',
    iconName: 'bars',
    icon: [
        448,
        512,
        [
            "navicon"
        ],
        "f0c9",
        "M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z"
    ]
};
const $d8206b3ab2e65c05$export$409fa7bcaa0e4cd9 = $d8206b3ab2e65c05$export$36e9cf7887265da2;
const $d8206b3ab2e65c05$export$be015e72863c3635 = {
    prefix: 'fas',
    iconName: 'people-group',
    icon: [
        640,
        512,
        [],
        "e533",
        "M72 88a56 56 0 1 1 112 0A56 56 0 1 1 72 88zM64 245.7C54 256.9 48 271.8 48 288s6 31.1 16 42.3l0-84.7zm144.4-49.3C178.7 222.7 160 261.2 160 304c0 34.3 12 65.8 32 90.5l0 21.5c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-26.8C26.2 371.2 0 332.7 0 288c0-61.9 50.1-112 112-112l32 0c24 0 46.2 7.5 64.4 20.3zM448 416l0-21.5c20-24.7 32-56.2 32-90.5c0-42.8-18.7-81.3-48.4-107.7C449.8 183.5 472 176 496 176l32 0c61.9 0 112 50.1 112 112c0 44.7-26.2 83.2-64 101.2l0 26.8c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32zm8-328a56 56 0 1 1 112 0A56 56 0 1 1 456 88zM576 245.7l0 84.7c10-11.3 16-26.1 16-42.3s-6-31.1-16-42.3zM320 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM240 304c0 16.2 6 31 16 42.3l0-84.7c-10 11.3-16 26.1-16 42.3zm144-42.3l0 84.7c10-11.3 16-26.1 16-42.3s-6-31.1-16-42.3zM448 304c0 44.7-26.2 83.2-64 101.2l0 42.8c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-42.8c-37.8-18-64-56.5-64-101.2c0-61.9 50.1-112 112-112l32 0c61.9 0 112 50.1 112 112z"
    ]
};
const $d8206b3ab2e65c05$export$52757ecc5b1e25b9 = {
    prefix: 'fas',
    iconName: 'hourglass-end',
    icon: [
        384,
        512,
        [
            8987,
            "hourglass-3"
        ],
        "f253",
        "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64l0 11c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9C48.9 353.9 32 394.6 32 437l0 11c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 256 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-11c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1l0-11c17.7 0 32-14.3 32-32s-14.3-32-32-32L320 0 64 0 32 0zM96 75l0-11 192 0 0 11c0 25.5-10.1 49.9-28.1 67.9L192 210.7l-67.9-67.9C106.1 124.9 96 100.4 96 75z"
    ]
};
const $d8206b3ab2e65c05$export$1ec43c81fef8ffd6 = $d8206b3ab2e65c05$export$52757ecc5b1e25b9;
const $d8206b3ab2e65c05$export$8e521ef33062b00e = {
    prefix: 'fas',
    iconName: 'heart-crack',
    icon: [
        512,
        512,
        [
            128148,
            "heart-broken"
        ],
        "f7a9",
        "M119.4 44.1c23.3-3.9 46.8-1.9 68.6 5.3l49.8 77.5-75.4 75.4c-1.5 1.5-2.4 3.6-2.3 5.8s1 4.2 2.6 5.7l112 104c2.9 2.7 7.4 2.9 10.5 .3s3.8-7 1.7-10.4l-60.4-98.1 90.7-75.6c2.6-2.1 3.5-5.7 2.4-8.8L296.8 61.8c28.5-16.7 62.4-23.2 95.7-17.6C461.5 55.6 512 115.2 512 185.1l0 5.8c0 41.5-17.2 81.2-47.6 109.5L283.7 469.1c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9L47.6 300.4C17.2 272.1 0 232.4 0 190.9l0-5.8c0-69.9 50.5-129.5 119.4-141z"
    ]
};
const $d8206b3ab2e65c05$export$4a565395cb65b282 = $d8206b3ab2e65c05$export$8e521ef33062b00e;
const $d8206b3ab2e65c05$export$a47a20ab7bde8c67 = {
    prefix: 'fas',
    iconName: 'square-up-right',
    icon: [
        448,
        512,
        [
            8599,
            "external-link-square-alt"
        ],
        "f360",
        "M384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM160 160c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l40 40-71 71C114 302 112 306.9 112 312s2 10 5.7 13.7l36.7 36.7c3.6 3.6 8.5 5.7 13.7 5.7s10-2 13.7-5.7l71-71 40 40c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8l0-144c0-8.8-7.2-16-16-16l-144 0z"
    ]
};
const $d8206b3ab2e65c05$export$e4cdf2977151ee26 = $d8206b3ab2e65c05$export$a47a20ab7bde8c67;
const $d8206b3ab2e65c05$export$eca99665af566fe1 = {
    prefix: 'fas',
    iconName: 'face-kiss-beam',
    icon: [
        512,
        512,
        [
            128537,
            "kiss-beam"
        ],
        "f597",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm48.7-198.3c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 443.1 257.4 448 240 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9c0 0 0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1 .3-.2 .6-.4c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.4-.3-.5-.3-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zm-87.1-84.9s0 0 0 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0zm160 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0z"
    ]
};
const $d8206b3ab2e65c05$export$d6ff8a73c0812e63 = $d8206b3ab2e65c05$export$eca99665af566fe1;
const $d8206b3ab2e65c05$export$c03de0cc616e77bb = {
    prefix: 'fas',
    iconName: 'film',
    icon: [
        512,
        512,
        [
            127902
        ],
        "f008",
        "M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM48 368l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm368-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM48 240l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm368-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM48 112l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16L64 96c-8.8 0-16 7.2-16 16zM416 96c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM160 128l0 64c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L192 96c-17.7 0-32 14.3-32 32zm32 160c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-128 0z"
    ]
};
const $d8206b3ab2e65c05$export$46c6347bff3e04a = {
    prefix: 'fas',
    iconName: 'ruler-horizontal',
    icon: [
        640,
        512,
        [],
        "f547",
        "M0 336c0 26.5 21.5 48 48 48l544 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48l-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0c-26.5 0-48 21.5-48 48L0 336z"
    ]
};
const $d8206b3ab2e65c05$export$75ce8513e1f1c5c4 = {
    prefix: 'fas',
    iconName: 'people-robbery',
    icon: [
        576,
        512,
        [],
        "e536",
        "M488.2 59.1C478.1 99.6 441.7 128 400 128s-78.1-28.4-88.2-68.9L303 24.2C298.8 7.1 281.4-3.3 264.2 1S236.7 22.6 241 39.8l8.7 34.9c11 44 40.2 79.6 78.3 99.6L328 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 16 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-305.7c38.1-20 67.3-55.6 78.3-99.6L559 39.8c4.3-17.1-6.1-34.5-23.3-38.8S501.2 7.1 497 24.2l-8.7 34.9zM400 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM80 96A48 48 0 1 0 80 0a48 48 0 1 0 0 96zm-8 32c-35.3 0-64 28.7-64 64l0 96 0 .6L8 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 16 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-227.3 13 20.5c5.9 9.2 16.1 14.9 27 14.9l48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-30.4 0-37.4-58.9C157.6 142 132.1 128 104.7 128L72 128z"
    ]
};
const $d8206b3ab2e65c05$export$1e80f89fe84a215b = {
    prefix: 'fas',
    iconName: 'lightbulb',
    icon: [
        384,
        512,
        [
            128161
        ],
        "f0eb",
        "M272 384c9.6-31.9 29.5-59.1 49.2-86.2c0 0 0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4c0 0 0 0 0 0c19.8 27.1 39.7 54.4 49.2 86.2l160 0zM192 512c44.2 0 80-35.8 80-80l0-16-160 0 0 16c0 44.2 35.8 80 80 80zM112 176c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112c8.8 0 16 7.2 16 16s-7.2 16-16 16c-44.2 0-80 35.8-80 80z"
    ]
};
const $d8206b3ab2e65c05$export$85a918a11b7643c2 = {
    prefix: 'fas',
    iconName: 'caret-left',
    icon: [
        256,
        512,
        [],
        "f0d9",
        "M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 256c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-128-128z"
    ]
};
const $d8206b3ab2e65c05$export$59573943f9eebbd5 = {
    prefix: 'fas',
    iconName: 'circle-exclamation',
    icon: [
        512,
        512,
        [
            "exclamation-circle"
        ],
        "f06a",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
const $d8206b3ab2e65c05$export$220e07e14c5d7e5d = $d8206b3ab2e65c05$export$59573943f9eebbd5;
const $d8206b3ab2e65c05$export$5e17b20e0f6b132b = {
    prefix: 'fas',
    iconName: 'school-circle-xmark',
    icon: [
        640,
        512,
        [],
        "e56d",
        "M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96 48 96C21.5 96 0 117.5 0 144L0 464c0 26.5 21.5 48 48 48l272 0s0 0 0 0l-64 0 0-96c0-35.3 28.7-64 64-64l.3 0 .5 0c3.4-37.7 18.7-72.1 42.2-99.1C350.2 260 335.6 264 320 264c-48.6 0-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4c29-21 64.6-33.4 103.1-33.4c59.5 0 112.1 29.6 144 74.8L640 144c0-26.5-21.5-48-48-48L473.7 96 337.8 5.4zM96 192l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zm0 128l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zM320 128c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-16c0-8.8-7.2-16-16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm22.6-144l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L518.6 368z"
    ]
};
const $d8206b3ab2e65c05$export$ca14f1b4d6afb7aa = {
    prefix: 'fas',
    iconName: 'arrow-right-from-bracket',
    icon: [
        512,
        512,
        [
            "sign-out"
        ],
        "f08b",
        "M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 192 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l210.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128zM160 96c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 32C43 32 0 75 0 128L0 384c0 53 43 96 96 96l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l64 0z"
    ]
};
const $d8206b3ab2e65c05$export$33e2b60243ca6d92 = $d8206b3ab2e65c05$export$ca14f1b4d6afb7aa;
const $d8206b3ab2e65c05$export$aca07924996218d8 = {
    prefix: 'fas',
    iconName: 'circle-chevron-down',
    icon: [
        512,
        512,
        [
            "chevron-circle-down"
        ],
        "f13a",
        "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM135 241c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l87 87 87-87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L273 345c-9.4 9.4-24.6 9.4-33.9 0L135 241z"
    ]
};
const $d8206b3ab2e65c05$export$9926124d75b2ecab = $d8206b3ab2e65c05$export$aca07924996218d8;
const $d8206b3ab2e65c05$export$c98fdd5082b333ec = {
    prefix: 'fas',
    iconName: 'unlock-keyhole',
    icon: [
        448,
        512,
        [
            "unlock-alt"
        ],
        "f13e",
        "M224 64c-44.2 0-80 35.8-80 80l0 48 240 0c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 256c0-35.3 28.7-64 64-64l16 0 0-48C80 64.5 144.5 0 224 0c57.5 0 107 33.7 130.1 82.3c7.6 16 .8 35.1-15.2 42.6s-35.1 .8-42.6-15.2C283.4 82.6 255.9 64 224 64zm32 320c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0z"
    ]
};
const $d8206b3ab2e65c05$export$b19f508797f3d9c3 = $d8206b3ab2e65c05$export$c98fdd5082b333ec;
const $d8206b3ab2e65c05$export$af51c741ee9cc090 = {
    prefix: 'fas',
    iconName: 'cloud-showers-heavy',
    icon: [
        512,
        512,
        [],
        "f740",
        "M96 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96L96 320zM81.5 353.9c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6S-3.3 490.7 1.9 478.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6zm120 0c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6zm244.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6s17.8 19.3 12.6 31.5zM313.5 353.9c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6z"
    ]
};
const $d8206b3ab2e65c05$export$ca47801915e5a685 = {
    prefix: 'fas',
    iconName: 'headphones-simple',
    icon: [
        512,
        512,
        [
            "headphones-alt"
        ],
        "f58f",
        "M256 80C141.1 80 48 173.1 48 288l0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 288C0 146.6 114.6 32 256 32s256 114.6 256 256l0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104c0-114.9-93.1-208-208-208zM80 352c0-35.3 28.7-64 64-64l16 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-16 0c-35.3 0-64-28.7-64-64l0-64zm288-64c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-16 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l16 0z"
    ]
};
const $d8206b3ab2e65c05$export$6f0433fa527dd5be = $d8206b3ab2e65c05$export$ca47801915e5a685;
const $d8206b3ab2e65c05$export$b2ce5e79d0eccaf8 = {
    prefix: 'fas',
    iconName: 'sitemap',
    icon: [
        576,
        512,
        [],
        "f0e8",
        "M208 80c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-8 0 0 40 152 0c30.9 0 56 25.1 56 56l0 32 8 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-64 0c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48l8 0 0-32c0-4.4-3.6-8-8-8l-152 0 0 40 8 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-64 0c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48l8 0 0-40-152 0c-4.4 0-8 3.6-8 8l0 32 8 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-64 0c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48l8 0 0-32c0-30.9 25.1-56 56-56l152 0 0-40-8 0c-26.5 0-48-21.5-48-48l0-64z"
    ]
};
const $d8206b3ab2e65c05$export$5f92ac3e804644e3 = {
    prefix: 'fas',
    iconName: 'circle-dollar-to-slot',
    icon: [
        512,
        512,
        [
            "donate"
        ],
        "f4b9",
        "M326.7 403.7c-22.1 8-45.9 12.3-70.7 12.3s-48.7-4.4-70.7-12.3l-.8-.3c-30-11-56.8-28.7-78.6-51.4C70 314.6 48 263.9 48 208C48 93.1 141.1 0 256 0S464 93.1 464 208c0 55.9-22 106.6-57.9 144c-1 1-2 2.1-3 3.1c-21.4 21.4-47.4 38.1-76.3 48.6zM256 91.9c-11.1 0-20.1 9-20.1 20.1l0 6c-5.6 1.2-10.9 2.9-15.9 5.1c-15 6.8-27.9 19.4-31.1 37.7c-1.8 10.2-.8 20 3.4 29c4.2 8.8 10.7 15 17.3 19.5c11.6 7.9 26.9 12.5 38.6 16l2.2 .7c13.9 4.2 23.4 7.4 29.3 11.7c2.5 1.8 3.4 3.2 3.7 4c.3 .8 .9 2.6 .2 6.7c-.6 3.5-2.5 6.4-8 8.8c-6.1 2.6-16 3.9-28.8 1.9c-6-1-16.7-4.6-26.2-7.9c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-2.2-.7-4.3-1.5-6.4-2.1c-10.5-3.5-21.8 2.2-25.3 12.7s2.2 21.8 12.7 25.3c1.2 .4 2.7 .9 4.4 1.5c7.9 2.7 20.3 6.9 29.8 9.1l0 6.4c0 11.1 9 20.1 20.1 20.1s20.1-9 20.1-20.1l0-5.5c5.3-1 10.5-2.5 15.4-4.6c15.7-6.7 28.4-19.7 31.6-38.7c1.8-10.4 1-20.3-3-29.4c-3.9-9-10.2-15.6-16.9-20.5c-12.2-8.8-28.3-13.7-40.4-17.4l-.8-.2c-14.2-4.3-23.8-7.3-29.9-11.4c-2.6-1.8-3.4-3-3.6-3.5c-.2-.3-.7-1.6-.1-5c.3-1.9 1.9-5.2 8.2-8.1c6.4-2.9 16.4-4.5 28.6-2.6c4.3 .7 17.9 3.3 21.7 4.3c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-4.4-1.2-14.4-3.2-21-4.4l0-6.3c0-11.1-9-20.1-20.1-20.1zM48 352l16 0c19.5 25.9 44 47.7 72.2 64L64 416l0 32 192 0 192 0 0-32-72.2 0c28.2-16.3 52.8-38.1 72.2-64l16 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48z"
    ]
};
const $d8206b3ab2e65c05$export$40050ae52860cde7 = $d8206b3ab2e65c05$export$5f92ac3e804644e3;
const $d8206b3ab2e65c05$export$5f9bd9f6df021f93 = {
    prefix: 'fas',
    iconName: 'memory',
    icon: [
        576,
        512,
        [],
        "f538",
        "M64 64C28.7 64 0 92.7 0 128l0 7.4c0 6.8 4.4 12.6 10.1 16.3C23.3 160.3 32 175.1 32 192s-8.7 31.7-21.9 40.3C4.4 236 0 241.8 0 248.6L0 320l576 0 0-71.4c0-6.8-4.4-12.6-10.1-16.3C552.7 223.7 544 208.9 544 192s8.7-31.7 21.9-40.3c5.7-3.7 10.1-9.5 10.1-16.3l0-7.4c0-35.3-28.7-64-64-64L64 64zM576 352L0 352l0 64c0 17.7 14.3 32 32 32l48 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32 96 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32 96 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32 96 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32 48 0c17.7 0 32-14.3 32-32l0-64zM192 160l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
const $d8206b3ab2e65c05$export$b372a24046126ad8 = {
    prefix: 'fas',
    iconName: 'road-spikes',
    icon: [
        640,
        512,
        [],
        "e568",
        "M64 116.8c0-15.8 20.5-22 29.3-8.9L192 256l0-139.2c0-15.8 20.5-22 29.3-8.9L320 256l0-139.2c0-15.8 20.5-22 29.3-8.9L448 256l0-139.2c0-15.8 20.5-22 29.3-8.9L606.8 302.2c14.2 21.3-1.1 49.7-26.6 49.7L512 352l-64 0-64 0-64 0-64 0-64 0L64 352l0-235.2zM32 384l576 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
const $d8206b3ab2e65c05$export$e4e44f7b1886fef = {
    prefix: 'fas',
    iconName: 'fire-burner',
    icon: [
        640,
        512,
        [],
        "e4f1",
        "M345.7 48.3L358 34.5c5.4-6.1 13.3-8.8 20.9-8.9c7.2 0 14.3 2.6 19.9 7.8c19.7 18.3 39.8 43.2 55 70.6C469 131.2 480 162.2 480 192.2C480 280.8 408.7 352 320 352c-89.6 0-160-71.3-160-159.8c0-37.3 16-73.4 36.8-104.5c20.9-31.3 47.5-59 70.9-80.2C273.4 2.3 280.7-.2 288 0c14.1 .3 23.8 11.4 32.7 21.6c0 0 0 0 0 0c2 2.3 4 4.6 6 6.7l19 19.9zM384 240.2c0-36.5-37-73-54.8-88.4c-5.4-4.7-13.1-4.7-18.5 0C293 167.1 256 203.6 256 240.2c0 35.3 28.7 64 64 64s64-28.7 64-64zM32 288c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 64 448 0 0-64c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 96c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l0-96zM320 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM192 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
const $d8206b3ab2e65c05$export$6591b1ea509be9da = {
    prefix: 'fas',
    iconName: 'flag',
    icon: [
        448,
        512,
        [
            127988,
            61725
        ],
        "f024",
        "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32L0 64 0 368 0 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 64.3-16.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30l0-247.7c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L64 48l0-16z"
    ]
};
const $d8206b3ab2e65c05$export$3dcd4ca3f7108a82 = {
    prefix: 'fas',
    iconName: 'hanukiah',
    icon: [
        640,
        512,
        [
            128334
        ],
        "f6e6",
        "M314.2 3.3C309.1 12.1 296 36.6 296 56c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7C324.6 1.2 322.4 0 320 0s-4.6 1.2-5.8 3.3zm-288 48C21.1 60.1 8 84.6 8 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7C36.6 49.2 34.4 48 32 48s-4.6 1.2-5.8 3.3zM88 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C101.1 60.1 88 84.6 88 104zm82.2-52.7C165.1 60.1 152 84.6 152 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM216 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C229.1 60.1 216 84.6 216 104zM394.2 51.3C389.1 60.1 376 84.6 376 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM440 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C453.1 60.1 440 84.6 440 104zm82.2-52.7C517.1 60.1 504 84.6 504 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM584 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C597.1 60.1 584 84.6 584 104zM112 160c-8.8 0-16 7.2-16 16l0 96 0 16 32 0 0-16 0-96c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16l0 96 0 16 32 0 0-16 0-96c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16l0 96 0 16 32 0 0-16 0-96c0-8.8-7.2-16-16-16zm160 0c-8.8 0-16 7.2-16 16l0 96 0 16 32 0 0-16 0-96c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16l0 96 0 16 32 0 0-16 0-96c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16l0 96 0 16 32 0 0-16 0-96c0-8.8-7.2-16-16-16zM352 144c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 176L96 320c-17.7 0-32-14.3-32-32l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 53 43 96 96 96l192 0 0 64-128 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0 160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-128 0 0-64 192 0c53 0 96-43 96-96l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7-14.3 32-32 32l-192 0 0-176z"
    ]
};
const $d8206b3ab2e65c05$export$5e19aea195b31816 = {
    prefix: 'fas',
    iconName: 'feather',
    icon: [
        512,
        512,
        [
            129718
        ],
        "f52d",
        "M278.5 215.6L23 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57-57 68 0c49.7 0 97.9-14.4 139-41c11.1-7.2 5.5-23-7.8-23c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l81-24.3c2.5-.8 4.8-2.1 6.7-4l22.4-22.4c10.1-10.1 2.9-27.3-11.3-27.3l-32.2 0c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l112-33.6c4-1.2 7.4-3.9 9.3-7.7C506.4 207.6 512 184.1 512 160c0-41-16.3-80.3-45.3-109.3l-5.5-5.5C432.3 16.3 393 0 352 0s-80.3 16.3-109.3 45.3L139 149C91 197 64 262.1 64 330l0 55.3L253.6 195.8c6.2-6.2 16.4-6.2 22.6 0c5.4 5.4 6.1 13.6 2.2 19.8z"
    ]
};
const $d8206b3ab2e65c05$export$2b1464e7557b18eb = {
    prefix: 'fas',
    iconName: 'volume-low',
    icon: [
        448,
        512,
        [
            128264,
            "volume-down"
        ],
        "f027",
        "M301.1 34.8C312.6 40 320 51.4 320 64l0 384c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352 64 352c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l67.8 0L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zM412.6 181.5C434.1 199.1 448 225.9 448 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5z"
    ]
};
const $d8206b3ab2e65c05$export$69fdf57632b6cc29 = $d8206b3ab2e65c05$export$2b1464e7557b18eb;
const $d8206b3ab2e65c05$export$3786a0422a3f33ea = {
    prefix: 'fas',
    iconName: 'comment-slash',
    icon: [
        640,
        512,
        [],
        "f4b3",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512.9 376.7C552.2 340.2 576 292.3 576 240C576 125.1 461.4 32 320 32c-67.7 0-129.3 21.4-175.1 56.3L38.8 5.1zm385.2 425L82.9 161.3C70.7 185.6 64 212.2 64 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c37 0 72.3-6.4 104.1-17.9z"
    ]
};
const $d8206b3ab2e65c05$export$dd9dc9b4227dbe94 = {
    prefix: 'fas',
    iconName: 'cloud-sun-rain',
    icon: [
        640,
        512,
        [
            127782
        ],
        "f743",
        "M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l10.4 62.4c-23.3 10.8-42.9 28.4-56 50.3c-14.6-9-31.8-14.1-50.2-14.1c-53 0-96 43-96 96c0 35.5 19.3 66.6 48 83.2c.8 31.8 13.2 60.7 33.1 82.7l-56 39.2c-4.5 3.2-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1L98.1 317.9 13.4 303.8c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6L98.1 98.1l14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5 278.8 2.9c4.5-3.2 10.3-3.8 15.4-1.6zM208 144c13.8 0 26.7 4.4 37.1 11.9c-1.2 4.1-2.2 8.3-3 12.6c-37.9 14.6-67.2 46.6-77.8 86.4C151.8 243.1 144 226.5 144 208c0-35.3 28.7-64 64-64zm69.4 276c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm74.5-116.1c0 44.2-35.8 80-80 80l-271.9 0c-53 0-96-43-96-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7z"
    ]
};
const $d8206b3ab2e65c05$export$83632d1150d3541f = {
    prefix: 'fas',
    iconName: 'compress',
    icon: [
        448,
        512,
        [],
        "f066",
        "M160 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32l0-96zM32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0 0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l-96 0zM352 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-64zM320 320c-17.7 0-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0z"
    ]
};
const $d8206b3ab2e65c05$export$79d4dac715a51fdf = {
    prefix: 'fas',
    iconName: 'wheat-awn',
    icon: [
        512,
        512,
        [
            "wheat-alt"
        ],
        "e2cd",
        "M505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L383 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l88-88zM305.5 27.3c-6.2-6.2-16.4-6.2-22.6 0L271.5 38.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8L101.8 231c-6.2-6.2-16.4-6.2-22.6 0L67.9 242.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0L486.5 231c6.2-6.2 6.2-16.4 0-22.6L475.2 197c-5.2-5.2-10.6-9.8-16.4-13.9L505 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-59.4 59.4c-20.6-4.4-42-3.7-62.3 2.1c6.1-21.3 6.6-43.8 1.4-65.3L409 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L329.1 52.9c-3.7-5-7.8-9.8-12.4-14.3L305.5 27.3z"
    ]
};
const $d8206b3ab2e65c05$export$deaf03a29aa05e3a = $d8206b3ab2e65c05$export$79d4dac715a51fdf;
const $d8206b3ab2e65c05$export$8736909014b15ca9 = {
    prefix: 'fas',
    iconName: 'ankh',
    icon: [
        320,
        512,
        [
            9765
        ],
        "f644",
        "M96 128c0-35.3 28.7-64 64-64s64 28.7 64 64c0 41.6-20.7 76.6-46.6 104.1c-5.9 6.2-11.8 11.8-17.4 16.7c-5.6-4.9-11.5-10.5-17.4-16.7C116.7 204.6 96 169.6 96 128zM160 0C89.3 0 32 57.3 32 128c0 52.4 21.5 95.5 46.8 128L32 256c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0 0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160 96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-46.8 0c25.4-32.5 46.8-75.6 46.8-128C288 57.3 230.7 0 160 0z"
    ]
};
const $d8206b3ab2e65c05$export$bfb254bf3c0bc50b = {
    prefix: 'fas',
    iconName: 'hands-holding-child',
    icon: [
        640,
        512,
        [],
        "e4fa",
        "M320 0a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm44.7 164.3L375.8 253c1.6 13.2-7.7 25.1-20.8 26.8s-25.1-7.7-26.8-20.8l-4.4-35-7.6 0-4.4 35c-1.6 13.2-13.6 22.5-26.8 20.8s-22.5-13.6-20.8-26.8l11.1-88.8L255.5 181c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l27.9-23.6C271.3 104.8 295.3 96 320 96s48.7 8.8 67.6 24.7l27.9 23.6c10.1 8.6 11.4 23.7 2.8 33.8s-23.7 11.4-33.8 2.8l-19.8-16.7zM40 64c22.1 0 40 17.9 40 40l0 40 0 80 0 40.2c0 17 6.7 33.3 18.7 45.3l51.1 51.1c8.3 8.3 21.3 9.6 31 3.1c12.9-8.6 14.7-26.9 3.7-37.8l-15.2-15.2-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32 15.2 15.2c0 0 0 0 0 0l25.3 25.3c21 21 32.8 49.5 32.8 79.2l0 78.9c0 26.5-21.5 48-48 48l-66.7 0c-17 0-33.3-6.7-45.3-18.7L28.1 393.4C10.1 375.4 0 351 0 325.5L0 224l0-64 0-56C0 81.9 17.9 64 40 64zm560 0c22.1 0 40 17.9 40 40l0 56 0 64 0 101.5c0 25.5-10.1 49.9-28.1 67.9L512 493.3c-12 12-28.3 18.7-45.3 18.7L400 512c-26.5 0-48-21.5-48-48l0-78.9c0-29.7 11.8-58.2 32.8-79.2l25.3-25.3c0 0 0 0 0 0l15.2-15.2 32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32-15.2 15.2c-11 11-9.2 29.2 3.7 37.8c9.7 6.5 22.7 5.2 31-3.1l51.1-51.1c12-12 18.7-28.3 18.7-45.3l0-40.2 0-80 0-40c0-22.1 17.9-40 40-40z"
    ]
};
const $d8206b3ab2e65c05$export$19eff32c0fd4f99f = {
    prefix: 'fas',
    iconName: 'asterisk',
    icon: [
        384,
        512,
        [
            10033,
            61545
        ],
        "2a",
        "M192 32c17.7 0 32 14.3 32 32l0 135.5 111.5-66.9c15.2-9.1 34.8-4.2 43.9 11s4.2 34.8-11 43.9L254.2 256l114.3 68.6c15.2 9.1 20.1 28.7 11 43.9s-28.7 20.1-43.9 11L224 312.5 224 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-135.5L48.5 379.4c-15.2 9.1-34.8 4.2-43.9-11s-4.2-34.8 11-43.9L129.8 256 15.5 187.4c-15.2-9.1-20.1-28.7-11-43.9s28.7-20.1 43.9-11L160 199.5 160 64c0-17.7 14.3-32 32-32z"
    ]
};
const $d8206b3ab2e65c05$export$5bb6a0c94ad2f4bb = {
    prefix: 'fas',
    iconName: 'square-check',
    icon: [
        448,
        512,
        [
            9745,
            9989,
            61510,
            "check-square"
        ],
        "f14a",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    ]
};
const $d8206b3ab2e65c05$export$f0c8040f596df7fe = $d8206b3ab2e65c05$export$5bb6a0c94ad2f4bb;
const $d8206b3ab2e65c05$export$a6f8654bcd49a39f = {
    prefix: 'fas',
    iconName: 'peseta-sign',
    icon: [
        384,
        512,
        [],
        "e221",
        "M64 32C46.3 32 32 46.3 32 64l0 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 96 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96 96 0c77.4 0 142-55 156.8-128l3.2 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-3.2 0C334 87 269.4 32 192 32L64 32zM282.5 160L96 160l0-64 96 0c41.8 0 77.4 26.7 90.5 64zM96 224l186.5 0c-13.2 37.3-48.7 64-90.5 64l-96 0 0-64z"
    ]
};
const $d8206b3ab2e65c05$export$4805b8d175aeb9fb = {
    prefix: 'fas',
    iconName: 'heading',
    icon: [
        448,
        512,
        [
            "header"
        ],
        "f1dc",
        "M0 64C0 46.3 14.3 32 32 32l48 0 48 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-16 0 0 112 224 0 0-112-16 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l48 0 48 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-16 0 0 144 0 176 16 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-48 0-48 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l16 0 0-144-224 0 0 144 16 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-48 0-48 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l16 0 0-176L48 96 32 96C14.3 96 0 81.7 0 64z"
    ]
};
const $d8206b3ab2e65c05$export$579f9604bb10a61a = $d8206b3ab2e65c05$export$4805b8d175aeb9fb;
const $d8206b3ab2e65c05$export$1a989eb1919c64c1 = {
    prefix: 'fas',
    iconName: 'ghost',
    icon: [
        384,
        512,
        [
            128123
        ],
        "f6e2",
        "M40.1 467.1l-11.2 9c-3.2 2.5-7.1 3.9-11.1 3.9C8 480 0 472 0 462.2L0 192C0 86 86 0 192 0S384 86 384 192l0 270.2c0 9.8-8 17.8-17.8 17.8c-4 0-7.9-1.4-11.1-3.9l-11.2-9c-13.4-10.7-32.8-9-44.1 3.9L269.3 506c-3.3 3.8-8.2 6-13.3 6s-9.9-2.2-13.3-6l-26.6-30.5c-12.7-14.6-35.4-14.6-48.2 0L141.3 506c-3.3 3.8-8.2 6-13.3 6s-9.9-2.2-13.3-6L84.2 471c-11.3-12.9-30.7-14.6-44.1-3.9zM160 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
const $d8206b3ab2e65c05$export$6cfc59842fedbc16 = {
    prefix: 'fas',
    iconName: 'list',
    icon: [
        512,
        512,
        [
            "list-squares"
        ],
        "f03a",
        "M40 48C26.7 48 16 58.7 16 72l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24L40 48zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L192 64zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-288 0zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-288 0zM16 232l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0z"
    ]
};
const $d8206b3ab2e65c05$export$e3f160fc949c2b9d = $d8206b3ab2e65c05$export$6cfc59842fedbc16;
const $d8206b3ab2e65c05$export$b627121801cad756 = {
    prefix: 'fas',
    iconName: 'square-phone-flip',
    icon: [
        448,
        512,
        [
            "phone-square-alt"
        ],
        "f87b",
        "M384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zm-90.7 96.7c-9.7-2.6-19.9 2.3-23.7 11.6l-20 48c-3.4 8.2-1 17.6 5.8 23.2L280 231.7c-16.6 35.2-45.1 63.7-80.3 80.3l-20.2-24.7c-5.6-6.8-15-9.2-23.2-5.8l-48 20c-9.3 3.9-14.2 14-11.6 23.7l12 44C111.1 378 119 384 128 384c123.7 0 224-100.3 224-224c0-9-6-16.9-14.7-19.3l-44-12z"
    ]
};
const $d8206b3ab2e65c05$export$a41e77f0de98bba7 = $d8206b3ab2e65c05$export$b627121801cad756;
const $d8206b3ab2e65c05$export$6675e2bf21fdb87e = {
    prefix: 'fas',
    iconName: 'cart-plus',
    icon: [
        576,
        512,
        [],
        "f217",
        "M0 24C0 10.7 10.7 0 24 0L69.5 0c22 0 41.5 12.8 50.6 32l411 0c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3l-288.5 0 5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5L488 336c13.3 0 24 10.7 24 24s-10.7 24-24 24l-288.3 0c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5L24 48C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM252 160c0 11 9 20 20 20l44 0 0 44c0 11 9 20 20 20s20-9 20-20l0-44 44 0c11 0 20-9 20-20s-9-20-20-20l-44 0 0-44c0-11-9-20-20-20s-20 9-20 20l0 44-44 0c-11 0-20 9-20 20z"
    ]
};
const $d8206b3ab2e65c05$export$6a66b1b639455bef = {
    prefix: 'fas',
    iconName: 'gamepad',
    icon: [
        640,
        512,
        [],
        "f11b",
        "M192 64C86 64 0 150 0 256S86 448 192 448l256 0c106 0 192-86 192-192s-86-192-192-192L192 64zM496 168a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM392 304a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM168 200c0-13.3 10.7-24 24-24s24 10.7 24 24l0 32 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0 0 32c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-32-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l32 0 0-32z"
    ]
};
const $d8206b3ab2e65c05$export$aa13d9234890e8d3 = {
    prefix: 'fas',
    iconName: 'circle-dot',
    icon: [
        512,
        512,
        [
            128280,
            "dot-circle"
        ],
        "f192",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-352a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
    ]
};
const $d8206b3ab2e65c05$export$92bc269cb244d66a = $d8206b3ab2e65c05$export$aa13d9234890e8d3;
const $d8206b3ab2e65c05$export$635e4d8cc8428961 = {
    prefix: 'fas',
    iconName: 'face-dizzy',
    icon: [
        512,
        512,
        [
            "dizzy"
        ],
        "f567",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-224a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM100.7 132.7c6.2-6.2 16.4-6.2 22.6 0L160 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L182.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L160 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L137.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6zm192 0c6.2-6.2 16.4-6.2 22.6 0L352 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L374.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L352 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L329.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6z"
    ]
};
const $d8206b3ab2e65c05$export$89a2b10dabc487e8 = $d8206b3ab2e65c05$export$635e4d8cc8428961;
const $d8206b3ab2e65c05$export$1199a8ce85311ab5 = {
    prefix: 'fas',
    iconName: 'egg',
    icon: [
        384,
        512,
        [
            129370
        ],
        "f7fb",
        "M192 496C86 496 0 394 0 288C0 176 64 16 192 16s192 160 192 272c0 106-86 208-192 208zM154.8 134c6.5-6 7-16.1 1-22.6s-16.1-7-22.6-1c-23.9 21.8-41.1 52.7-52.3 84.2C69.7 226.1 64 259.7 64 288c0 8.8 7.2 16 16 16s16-7.2 16-16c0-24.5 5-54.4 15.1-82.8c10.1-28.5 25-54.1 43.7-71.2z"
    ]
};
const $d8206b3ab2e65c05$export$bf221f0e8296233e = {
    prefix: 'fas',
    iconName: 'house-medical-circle-xmark',
    icon: [
        640,
        512,
        [],
        "e513",
        "M320 368c0 59.5 29.5 112.1 74.8 144l-266.7 0c-35.3 0-64-28.7-64-64l0-160.4-32 0c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L522.1 193.9c-8.5-1.3-17.3-1.9-26.1-1.9c-54.7 0-103.5 24.9-135.8 64L320 256l0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm22.6 144l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368z"
    ]
};
const $d8206b3ab2e65c05$export$295287303c0e9c7c = {
    prefix: 'fas',
    iconName: 'campground',
    icon: [
        576,
        512,
        [
            9978
        ],
        "f6bb",
        "M377 52c11-13.8 8.8-33.9-5-45s-33.9-8.8-45 5L288 60.8 249 12c-11-13.8-31.2-16-45-5s-16 31.2-5 45l48 60L12.3 405.4C4.3 415.4 0 427.7 0 440.4L0 464c0 26.5 21.5 48 48 48l240 0 240 0c26.5 0 48-21.5 48-48l0-23.6c0-12.7-4.3-25.1-12.3-35L329 112l48-60zM288 448l-119.5 0L288 291.7 407.5 448 288 448z"
    ]
};
const $d8206b3ab2e65c05$export$e18e05ffa2045d3b = {
    prefix: 'fas',
    iconName: 'folder-plus',
    icon: [
        512,
        512,
        [],
        "f65e",
        "M512 416c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l128 0c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8l160 0c35.3 0 64 28.7 64 64l0 256zM232 376c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64z"
    ]
};
const $d8206b3ab2e65c05$export$65a345b33858a655 = {
    prefix: 'fas',
    iconName: 'futbol',
    icon: [
        512,
        512,
        [
            9917,
            "futbol-ball",
            "soccer-ball"
        ],
        "f1e3",
        "M417.3 360.1l-71.6-4.8c-5.2-.3-10.3 1.1-14.5 4.2s-7.2 7.4-8.4 12.5l-17.6 69.6C289.5 445.8 273 448 256 448s-33.5-2.2-49.2-6.4L189.2 372c-1.3-5-4.3-9.4-8.4-12.5s-9.3-4.5-14.5-4.2l-71.6 4.8c-17.6-27.2-28.5-59.2-30.4-93.6L125 228.3c4.4-2.8 7.6-7 9.2-11.9s1.4-10.2-.5-15l-26.7-66.6C128 109.2 155.3 89 186.7 76.9l55.2 46c4 3.3 9 5.1 14.1 5.1s10.2-1.8 14.1-5.1l55.2-46c31.3 12.1 58.7 32.3 79.6 57.9l-26.7 66.6c-1.9 4.8-2.1 10.1-.5 15s4.9 9.1 9.2 11.9l60.7 38.2c-1.9 34.4-12.8 66.4-30.4 93.6zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm14.1-325.7c-8.4-6.1-19.8-6.1-28.2 0L194 221c-8.4 6.1-11.9 16.9-8.7 26.8l18.3 56.3c3.2 9.9 12.4 16.6 22.8 16.6l59.2 0c10.4 0 19.6-6.7 22.8-16.6l18.3-56.3c3.2-9.9-.3-20.7-8.7-26.8l-47.9-34.8z"
    ]
};
const $d8206b3ab2e65c05$export$51a344ca0a215620 = $d8206b3ab2e65c05$export$65a345b33858a655;
const $d8206b3ab2e65c05$export$f4a29712c724ba2d = $d8206b3ab2e65c05$export$65a345b33858a655;
const $d8206b3ab2e65c05$export$7c8b56f3f296a814 = {
    prefix: 'fas',
    iconName: 'paintbrush',
    icon: [
        576,
        512,
        [
            128396,
            "paint-brush"
        ],
        "f1fc",
        "M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448L64 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"
    ]
};
const $d8206b3ab2e65c05$export$594db3339e212bc9 = $d8206b3ab2e65c05$export$7c8b56f3f296a814;
const $d8206b3ab2e65c05$export$7aa08ad5d562578a = {
    prefix: 'fas',
    iconName: 'lock',
    icon: [
        448,
        512,
        [
            128274
        ],
        "f023",
        "M144 144l0 48 160 0 0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192l0-48C80 64.5 144.5 0 224 0s144 64.5 144 144l0 48 16 0c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 256c0-35.3 28.7-64 64-64l16 0z"
    ]
};
const $d8206b3ab2e65c05$export$84666c793cb2a347 = {
    prefix: 'fas',
    iconName: 'gas-pump',
    icon: [
        512,
        512,
        [
            9981
        ],
        "f52f",
        "M32 64C32 28.7 60.7 0 96 0L256 0c35.3 0 64 28.7 64 64l0 192 8 0c48.6 0 88 39.4 88 88l0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-154c-27.6-7.1-48-32.2-48-62l0-64L384 64c-8.8-8.8-8.8-23.2 0-32s23.2-8.8 32 0l77.3 77.3c12 12 18.7 28.3 18.7 45.3l0 13.5 0 24 0 32 0 152c0 39.8-32.2 72-72 72s-72-32.2-72-72l0-32c0-22.1-17.9-40-40-40l-8 0 0 144c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32L32 64zM96 80l0 96c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16L112 64c-8.8 0-16 7.2-16 16z"
    ]
};
const $d8206b3ab2e65c05$export$6e6bd68568c17bbf = {
    prefix: 'fas',
    iconName: 'hot-tub-person',
    icon: [
        512,
        512,
        [
            "hot-tub"
        ],
        "f593",
        "M272 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 5.2c0 34 14.4 66.4 39.7 89.2l16.4 14.8c15.2 13.7 23.8 33.1 23.8 53.5l0 13.2c0 13.3 10.7 24 24 24s24-10.7 24-24l0-13.2c0-34-14.4-66.4-39.7-89.2L295.8 82.8C280.7 69.1 272 49.7 272 29.2l0-5.2zM0 320l0 16L0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-128c0-35.3-28.7-64-64-64l-170.7 0c-13.8 0-27.3-4.5-38.4-12.8l-85.3-64C137 166.7 116.8 160 96 160c-53 0-96 43-96 96l0 64zm128 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16s16 7.2 16 16zm80-16c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16zm112 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16s16 7.2 16 16zm80-16c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16zM360 0c-13.3 0-24 10.7-24 24l0 5.2c0 34 14.4 66.4 39.7 89.2l16.4 14.8c15.2 13.7 23.8 33.1 23.8 53.5l0 13.2c0 13.3 10.7 24 24 24s24-10.7 24-24l0-13.2c0-34-14.4-66.4-39.7-89.2L407.8 82.8C392.7 69.1 384 49.7 384 29.2l0-5.2c0-13.3-10.7-24-24-24zM64 128A64 64 0 1 0 64 0a64 64 0 1 0 0 128z"
    ]
};
const $d8206b3ab2e65c05$export$4842af92b516c40b = $d8206b3ab2e65c05$export$6e6bd68568c17bbf;
const $d8206b3ab2e65c05$export$9a8788ec0e4a9a0b = {
    prefix: 'fas',
    iconName: 'map-location',
    icon: [
        576,
        512,
        [
            "map-marked"
        ],
        "f59f",
        "M302.8 312C334.9 271.9 408 174.6 408 120C408 53.7 354.3 0 288 0S168 53.7 168 120c0 54.6 73.1 151.9 105.2 192c7.7 9.6 22 9.6 29.6 0zM416 503l144.9-58c9.1-3.6 15.1-12.5 15.1-22.3L576 152c0-17-17.1-28.6-32.9-22.3l-116 46.4c-.5 1.2-1 2.5-1.5 3.7c-2.9 6.8-6.1 13.7-9.6 20.6L416 503zM15.1 187.3C6 191 0 199.8 0 209.6L0 480.4c0 17 17.1 28.6 32.9 22.3L160 451.8l0-251.4c-3.5-6.9-6.7-13.8-9.6-20.6c-5.6-13.2-10.4-27.4-12.8-41.5l-122.6 49zM384 255c-20.5 31.3-42.3 59.6-56.2 77c-20.5 25.6-59.1 25.6-79.6 0c-13.9-17.4-35.7-45.7-56.2-77l0 194.4 192 54.9L384 255z"
    ]
};
const $d8206b3ab2e65c05$export$df04458e7e32352c = $d8206b3ab2e65c05$export$9a8788ec0e4a9a0b;
const $d8206b3ab2e65c05$export$70fd6006b4e54a5 = {
    prefix: 'fas',
    iconName: 'house-flood-water',
    icon: [
        576,
        512,
        [],
        "e50e",
        "M306.8 6.1C295.6-2 280.4-2 269.2 6.1l-176 128c-11.2 8.2-15.9 22.6-11.6 35.8S98.1 192 112 192l16 0 0 73c1.7 1 3.3 2 4.9 3.1c18 12.4 40.1 20.3 59.2 20.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c1.5-1 3-2 4.5-2.9l-.3-73.2 16.6 0c13.9 0 26.1-8.9 30.4-22.1s-.4-27.6-11.6-35.8l-176-128zM269.5 309.9C247 325.4 219.5 336 192 336c-26.9 0-55.3-10.8-77.4-26.1c0 0 0 0 0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 389.7 159 400 192 400c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7c0 0 0 0 0 0C439.4 325.2 410.9 336 384 336c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0zM384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1c0 0 0 0 0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7c0 0 0 0 0 0C439.4 437.2 410.9 448 384 448z"
    ]
};
const $d8206b3ab2e65c05$export$1744430f718caf6b = {
    prefix: 'fas',
    iconName: 'tree',
    icon: [
        448,
        512,
        [
            127794
        ],
        "f1bb",
        "M210.6 5.9L62 169.4c-3.9 4.2-6 9.8-6 15.5C56 197.7 66.3 208 79.1 208l24.9 0L30.6 281.4c-4.2 4.2-6.6 10-6.6 16C24 309.9 34.1 320 46.6 320L80 320 5.4 409.5C1.9 413.7 0 419 0 424.5c0 13 10.5 23.5 23.5 23.5L192 448l0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 168.5 0c13 0 23.5-10.5 23.5-23.5c0-5.5-1.9-10.8-5.4-15L368 320l33.4 0c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L344 208l24.9 0c12.7 0 23.1-10.3 23.1-23.1c0-5.7-2.1-11.3-6-15.5L237.4 5.9C234 2.1 229.1 0 224 0s-10 2.1-13.4 5.9z"
    ]
};
const $d8206b3ab2e65c05$export$cffe7d85a82d8116 = {
    prefix: 'fas',
    iconName: 'bridge-lock',
    icon: [
        640,
        512,
        [],
        "e4cc",
        "M32 64c0-17.7 14.3-32 32-32l512 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-40 0 0 64-8 0c-61.9 0-112 50.1-112 112l0 24.6c-9.9 5.8-18.2 14.1-23.8 24.1c-17.6-20-43.4-32.7-72.2-32.7c-53 0-96 43-96 96l0 64c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-64c0-53-43-96-96-96l0-128 72 0 0-64L64 96C46.3 96 32 81.7 32 64zM408 96l0 64 80 0 0-64-80 0zm-48 64l0-64-80 0 0 64 80 0zM152 96l0 64 80 0 0-64-80 0zM528 240c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48z"
    ]
};
const $d8206b3ab2e65c05$export$15854c4475080853 = {
    prefix: 'fas',
    iconName: 'sack-dollar',
    icon: [
        512,
        512,
        [
            128176
        ],
        "f81d",
        "M320 96L192 96 144.6 24.9C137.5 14.2 145.1 0 157.9 0L354.1 0c12.8 0 20.4 14.2 13.3 24.9L320 96zM192 128l128 0c3.8 2.5 8.1 5.3 13 8.4C389.7 172.7 512 250.9 512 416c0 53-43 96-96 96L96 512c-53 0-96-43-96-96C0 250.9 122.3 172.7 179 136.4c0 0 0 0 0 0s0 0 0 0c4.8-3.1 9.2-5.9 13-8.4zm84 88c0-11-9-20-20-20s-20 9-20 20l0 14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1c0 0 0 0 0 0s0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4l0 14.6c0 11 9 20 20 20s20-9 20-20l0-13.8c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15c0 0 0 0 0 0l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7l0-13.9z"
    ]
};
const $d8206b3ab2e65c05$export$ba236543926e3569 = {
    prefix: 'fas',
    iconName: 'pen-to-square',
    icon: [
        512,
        512,
        [
            "edit"
        ],
        "f044",
        "M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 64z"
    ]
};
const $d8206b3ab2e65c05$export$7be713e57d023733 = $d8206b3ab2e65c05$export$ba236543926e3569;
const $d8206b3ab2e65c05$export$6f7218565b1b8d0e = {
    prefix: 'fas',
    iconName: 'car-side',
    icon: [
        640,
        512,
        [
            128663
        ],
        "f5e4",
        "M171.3 96L224 96l0 96-112.7 0 30.4-75.9C146.5 104 158.2 96 171.3 96zM272 192l0-96 81.2 0c9.7 0 18.9 4.4 25 12l67.2 84L272 192zm256.2 1L428.2 68c-18.2-22.8-45.8-36-75-36L171.3 32c-39.3 0-74.6 23.9-89.1 60.3L40.6 196.4C16.8 205.8 0 228.9 0 256L0 368c0 17.7 14.3 32 32 32l33.3 0c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80l130.7 0c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80l33.3 0c17.7 0 32-14.3 32-32l0-48c0-65.2-48.8-119-111.8-127zM434.7 368a48 48 0 1 1 90.5 32 48 48 0 1 1 -90.5-32zM160 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
const $d8206b3ab2e65c05$export$cdaf45d4e50ac035 = {
    prefix: 'fas',
    iconName: 'share-nodes',
    icon: [
        448,
        512,
        [
            "share-alt"
        ],
        "f1e0",
        "M352 224c53 0 96-43 96-96s-43-96-96-96s-96 43-96 96c0 4 .2 8 .7 11.9l-94.1 47C145.4 170.2 121.9 160 96 160c-53 0-96 43-96 96s43 96 96 96c25.9 0 49.4-10.2 66.6-26.9l94.1 47c-.5 3.9-.7 7.8-.7 11.9c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-25.9 0-49.4 10.2-66.6 26.9l-94.1-47c.5-3.9 .7-7.8 .7-11.9s-.2-8-.7-11.9l94.1-47C302.6 213.8 326.1 224 352 224z"
    ]
};
const $d8206b3ab2e65c05$export$f8e8bb0b3aa8c658 = $d8206b3ab2e65c05$export$cdaf45d4e50ac035;
const $d8206b3ab2e65c05$export$24c21c3ca00f3625 = {
    prefix: 'fas',
    iconName: 'heart-circle-minus',
    icon: [
        576,
        512,
        [],
        "e4ff",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6l0-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1l0 5.8c0 41.5 17.2 81.2 47.6 109.5zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-64 0c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l128 0c8.8 0 16 7.2 16 16z"
    ]
};
const $d8206b3ab2e65c05$export$703272eebf5e3eea = {
    prefix: 'fas',
    iconName: 'hourglass-half',
    icon: [
        384,
        512,
        [
            "hourglass-2"
        ],
        "f252",
        "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64l0 11c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9C48.9 353.9 32 394.6 32 437l0 11c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 256 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-11c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1l0-11c17.7 0 32-14.3 32-32s-14.3-32-32-32L320 0 64 0 32 0zM96 75l0-11 192 0 0 11c0 19-5.6 37.4-16 53L112 128c-10.3-15.6-16-34-16-53zm16 309c3.5-5.3 7.6-10.3 12.1-14.9L192 301.3l67.9 67.9c4.6 4.6 8.6 9.6 12.1 14.9L112 384z"
    ]
};
const $d8206b3ab2e65c05$export$f1052bbf6bf361c0 = $d8206b3ab2e65c05$export$703272eebf5e3eea;
const $d8206b3ab2e65c05$export$6a99139787bf9967 = {
    prefix: 'fas',
    iconName: 'microscope',
    icon: [
        512,
        512,
        [
            128300
        ],
        "f610",
        "M160 32c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32c17.7 0 32 14.3 32 32l0 224c0 17.7-14.3 32-32 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32c-17.7 0-32-14.3-32-32l0-224c0-17.7 14.3-32 32-32zM32 448l288 0c70.7 0 128-57.3 128-128s-57.3-128-128-128l0-64c106 0 192 86 192 192c0 49.2-18.5 94-48.9 128l16.9 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32zm80-64l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
const $d8206b3ab2e65c05$export$2a9dda2096ce792e = {
    prefix: 'fas',
    iconName: 'sink',
    icon: [
        512,
        512,
        [],
        "e06d",
        "M288 96c0-17.7 14.3-32 32-32s32 14.3 32 32s14.3 32 32 32s32-14.3 32-32c0-53-43-96-96-96s-96 43-96 96l0 192-64 0 0-24c0-30.9-25.1-56-56-56l-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c4.4 0 8 3.6 8 8l0 24-80 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l224 0 224 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-80 0 0-24c0-4.4 3.6-8 8-8l56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0c-30.9 0-56 25.1-56 56l0 24-64 0 0-192zM480 416l0-32L32 384l0 32c0 53 43 96 96 96l256 0c53 0 96-43 96-96z"
    ]
};
const $d8206b3ab2e65c05$export$b0137b4600e9ab12 = {
    prefix: 'fas',
    iconName: 'bag-shopping',
    icon: [
        448,
        512,
        [
            "shopping-bag"
        ],
        "f290",
        "M160 112c0-35.3 28.7-64 64-64s64 28.7 64 64l0 48-128 0 0-48zm-48 48l-64 0c-26.5 0-48 21.5-48 48L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-208c0-26.5-21.5-48-48-48l-64 0 0-48C336 50.1 285.9 0 224 0S112 50.1 112 112l0 48zm24 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm152 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
const $d8206b3ab2e65c05$export$5745f8adbc11eb01 = $d8206b3ab2e65c05$export$b0137b4600e9ab12;
const $d8206b3ab2e65c05$export$cf79d63ad07d943a = {
    prefix: 'fas',
    iconName: 'arrow-down-z-a',
    icon: [
        576,
        512,
        [
            "sort-alpha-desc",
            "sort-alpha-down-alt"
        ],
        "f881",
        "M183.6 469.6C177.5 476.2 169 480 160 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L128 365.7 128 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 301.7 32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 64c0-17.7 14.3-32 32-32l128 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9L429.3 160l50.7 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-128 0c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L402.7 96 352 96c-17.7 0-32-14.3-32-32zm96 192c12.1 0 23.2 6.8 28.6 17.7l64 128 16 32c7.9 15.8 1.5 35-14.3 42.9s-35 1.5-42.9-14.3L460.2 448l-88.4 0-7.2 14.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l16-32 64-128c5.4-10.8 16.5-17.7 28.6-17.7zM395.8 400l40.4 0L416 359.6 395.8 400z"
    ]
};
const $d8206b3ab2e65c05$export$7caf99612a55d427 = $d8206b3ab2e65c05$export$cf79d63ad07d943a;
const $d8206b3ab2e65c05$export$e12d23d82d5c8a89 = $d8206b3ab2e65c05$export$cf79d63ad07d943a;
const $d8206b3ab2e65c05$export$5030322c5fc886d7 = {
    prefix: 'fas',
    iconName: 'mitten',
    icon: [
        448,
        512,
        [],
        "f7b5",
        "M352 384L64 384 5.4 178.9C1.8 166.4 0 153.4 0 140.3C0 62.8 62.8 0 140.3 0l3.4 0c66 0 123.5 44.9 139.5 108.9l31.4 125.8 17.6-20.1C344.8 200.2 362.9 192 382 192l2.8 0c34.9 0 63.3 28.3 63.3 63.3c0 15.9-6 31.2-16.8 42.9L352 384zM32 448c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32L64 512c-17.7 0-32-14.3-32-32l0-32z"
    ]
};
const $d8206b3ab2e65c05$export$49577f913f0fe4d2 = {
    prefix: 'fas',
    iconName: 'person-rays',
    icon: [
        512,
        512,
        [],
        "e54d",
        "M208 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-223.1-28.6 47.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6l29.7 0c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L328 256.9 328 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128-16 0zM7 7C16.4-2.3 31.6-2.3 41 7l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 41C-2.3 31.6-2.3 16.4 7 7zM471 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L471 7zM7 505c-9.4-9.4-9.4-24.6 0-33.9l80-80c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L41 505c-9.4 9.4-24.6 9.4-33.9 0zm464 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0z"
    ]
};
const $d8206b3ab2e65c05$export$e5a8f011aef571ac = {
    prefix: 'fas',
    iconName: 'users',
    icon: [
        640,
        512,
        [],
        "f0c0",
        "M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM0 298.7C0 239.8 47.8 192 106.7 192l42.7 0c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0L21.3 320C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7l42.7 0C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3l-213.3 0zM224 224a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM128 485.3C128 411.7 187.7 352 261.3 352l117.3 0C452.3 352 512 411.7 512 485.3c0 14.7-11.9 26.7-26.7 26.7l-330.7 0c-14.7 0-26.7-11.9-26.7-26.7z"
    ]
};
const $d8206b3ab2e65c05$export$ed3f2918429d029a = {
    prefix: 'fas',
    iconName: 'eye-slash',
    icon: [
        640,
        512,
        [],
        "f070",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zM373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5L373 389.9z"
    ]
};
const $d8206b3ab2e65c05$export$a25a266ce0c95019 = {
    prefix: 'fas',
    iconName: 'flask-vial',
    icon: [
        640,
        512,
        [],
        "e4f3",
        "M175 389.4c-9.8 16-15 34.3-15 53.1c-10 3.5-20.8 5.5-32 5.5c-53 0-96-43-96-96L32 64C14.3 64 0 49.7 0 32S14.3 0 32 0L96 0l64 0 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 245.9-49 79.6zM96 64l0 96 64 0 0-96L96 64zM352 0L480 0l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 150.9L629.7 406.2c6.7 10.9 10.3 23.5 10.3 36.4c0 38.3-31.1 69.4-69.4 69.4l-309.2 0c-38.3 0-69.4-31.1-69.4-69.4c0-12.8 3.6-25.4 10.3-36.4L320 214.9 320 64c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0zm32 64l0 160c0 5.9-1.6 11.7-4.7 16.8L330.5 320l171 0-48.8-79.2c-3.1-5-4.7-10.8-4.7-16.8l0-160-64 0z"
    ]
};
const $d8206b3ab2e65c05$export$f69db0b876f7d753 = {
    prefix: 'fas',
    iconName: 'hand',
    icon: [
        512,
        512,
        [
            129306,
            9995,
            "hand-paper"
        ],
        "f256",
        "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-176c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 272c0 1.5 0 3.1 .1 4.6L67.6 283c-16-15.2-41.3-14.6-56.6 1.4s-14.6 41.3 1.4 56.6L124.8 448c43.1 41.1 100.4 64 160 64l19.2 0c97.2 0 176-78.8 176-176l0-208c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-176c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 176c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208z"
    ]
};
const $d8206b3ab2e65c05$export$6e6216c8b50471bb = $d8206b3ab2e65c05$export$f69db0b876f7d753;
const $d8206b3ab2e65c05$export$8de8eb94230028a5 = {
    prefix: 'fas',
    iconName: 'om',
    icon: [
        512,
        512,
        [
            128329
        ],
        "f679",
        "M379.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0l16-16c6.2-6.2 6.2-16.4 0-22.6l-16-16zM281 66.7c-2.2-1.5-4.9-2.5-7.7-2.7c-.6 0-1.3-.1-1.9 0c-3.9 .2-7.4 1.7-10.1 4.2c-.9 .8-1.6 1.7-2.3 2.6c-1.7 2.4-2.7 5.3-2.9 8.5c0 .7 0 1.4 0 2.1c.2 2.2 .9 4.3 1.9 6.2l.3 .6c.3 .6 .8 1.4 1.4 2.4c1.2 2 2.9 4.8 5.1 8.2c4.4 6.7 11.1 15.5 20 24.4C302.4 141.1 330.3 160 368 160c31.2 0 56.6-10.4 73.9-20.2c8.7-5 15.6-9.9 20.4-13.8c2.4-1.9 4.3-3.6 5.7-4.9c.7-.6 1.3-1.2 1.7-1.6l.6-.5 .1-.1 .1-.1s0 0 0 0s0 0 0 0c5.9-5.8 9.5-13.9 9.5-22.8c0-17.7-14.3-32-32-32c-8.7 0-16.7 3.5-22.4 9.2c-.1 .1-.2 .2-.5 .4c-.5 .5-1.5 1.3-2.8 2.4c-2.7 2.2-6.8 5.2-12.1 8.2C399.4 90.4 384.8 96 368 96c-20.8 0-42.4-7-59.5-14.6c-8.4-3.7-15.4-7.5-20.3-10.3c-2.4-1.4-4.3-2.5-5.6-3.3c-.6-.4-1.1-.7-1.4-.9l-.3-.2zM115.2 169.6c8-6 17.9-9.6 28.8-9.6c26.5 0 48 21.5 48 48s-21.5 48-48 48l-34.2 0c-7.6 0-13.8 6.2-13.8 13.8c0 1.5 .2 2.9 .7 4.4l8 24c4.4 13.1 16.6 21.9 30.4 21.9l8.9 0 16 0c35.3 0 64 28.7 64 64s-28.7 64-64 64c-50.8 0-82.7-21.5-102.2-42.8c-9.9-10.8-16.6-21.6-20.9-29.7c-2.1-4-3.6-7.3-4.5-9.6c-.5-1.1-.8-2-1-2.5l-.2-.5c-.3-.9-.7-1.8-1.1-2.6c-1.2-2.2-2.8-4-4.7-5.4c-1.9-1.4-4.1-2.3-6.5-2.8c-1.4-.3-2.9-.3-4.4-.2c-2.5 .2-4.8 1-6.8 2.3c-1.1 .7-2.2 1.5-3.1 2.5c-2.4 2.5-4.1 5.8-4.5 9.5c-.1 .6-.1 1.1-.1 1.7c0 0 0 0 0 0c0 .8 .1 1.7 .2 2.5l0 .1c0 .3 .1 .8 .2 1.3c.2 1.1 .4 2.7 .8 4.6c.8 3.9 2 9.4 3.9 15.9c3.8 13 10.3 30.4 21.3 48C48.7 476.2 89.4 512 160 512c70.7 0 128-57.3 128-128c0-23.3-6.2-45.2-17.1-64l22.6 0c25.5 0 49.9-10.1 67.9-28.1l26.5-26.5c6-6 14.1-9.4 22.6-9.4l5.5 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32c-25.7 0-41.4-12.5-51.2-25.6c-5-6.7-8.4-13.4-10.5-18.6c-1.1-2.5-1.8-4.6-2.2-6c-.2-.7-.4-1.2-.5-1.5l-.1-.2c-.3-1.3-.8-2.6-1.5-3.8c-1.1-2-2.6-3.8-4.4-5.1c-2.7-2-6-3.2-9.6-3.2l-.2 0c-8 .1-14.6 6.1-15.6 13.9c0 0 0 0 0 0c0 .3-.1 .6-.2 1.1c-.1 .9-.3 2.1-.4 3.6c-.3 3-.6 7.3-.6 12.4c0 10.1 1.1 23.9 5.8 38.1c4.8 14.3 13.4 29.3 28.6 40.7C368.7 473.3 389.3 480 416 480c53 0 96-43 96-96l0-96c0-53-43-96-96-96l-5.5 0c-25.5 0-49.9 10.1-67.9 28.1l-26.5 26.5c-6 6-14.1 9.4-22.6 9.4l-48.3 0c6.9-14.5 10.8-30.8 10.8-48c0-61.9-50.1-112-112-112c-25.2 0-48.5 8.3-67.2 22.4c-14.1 10.6-17 30.7-6.4 44.8s30.7 17 44.8 6.4z"
    ]
};
const $d8206b3ab2e65c05$export$2571e33fa6c25993 = {
    prefix: 'fas',
    iconName: 'worm',
    icon: [
        512,
        512,
        [],
        "e599",
        "M256 96c0-53 43-96 96-96l38.4 0C439.9 0 480 40.1 480 89.6l0 86.4 0 16 0 184c0 75.1-60.9 136-136 136s-136-60.9-136-136l0-80c0-22.1-17.9-40-40-40s-40 17.9-40 40l0 168c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-168c0-75.1 60.9-136 136-136s136 60.9 136 136l0 80c0 22.1 17.9 40 40 40s40-17.9 40-40l0-184-32 0c-53 0-96-43-96-96zm144-8a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
    ]
};
const $d8206b3ab2e65c05$export$423555e8708eb4c7 = {
    prefix: 'fas',
    iconName: 'house-circle-xmark',
    icon: [
        640,
        512,
        [],
        "e50b",
        "M320.7 352c8.1-89.7 83.5-160 175.3-160c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1l32 0 0 69.7c-.1 .9-.1 1.8-.1 2.8l0 112c0 22.1 17.9 40 40 40l16 0c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2l31.9 0 24 0c22.1 0 40-17.9 40-40l0-24 0-64c0-17.7 14.3-32 32-32l64 0 .7 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
const $d8206b3ab2e65c05$export$cae5752c3e3b6545 = {
    prefix: 'fas',
    iconName: 'plug',
    icon: [
        384,
        512,
        [
            128268
        ],
        "f1e6",
        "M96 0C78.3 0 64 14.3 64 32l0 96 64 0 0-96c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32l0 96 64 0 0-96c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 32c0 77.4 55 142 128 156.8l0 67.2c0 17.7 14.3 32 32 32s32-14.3 32-32l0-67.2C297 398 352 333.4 352 256l0-32c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 160z"
    ]
};
const $d8206b3ab2e65c05$export$877e5ae47a854215 = {
    prefix: 'fas',
    iconName: 'chevron-up',
    icon: [
        512,
        512,
        [],
        "f077",
        "M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"
    ]
};
const $d8206b3ab2e65c05$export$2262d6b626de1120 = {
    prefix: 'fas',
    iconName: 'hand-spock',
    icon: [
        576,
        512,
        [
            128406
        ],
        "f259",
        "M246.9 23.7C242.3 6.6 224.8-3.5 207.7 1.1s-27.2 22.1-22.6 39.2L238 237.8c2.5 9.2-4.5 18.2-14 18.2c-6.4 0-12-4.2-13.9-10.3L166.6 102.7c-5.1-16.9-23-26.4-39.9-21.3s-26.4 23-21.3 39.9l62.8 206.4c2.4 7.9-7.2 13.8-13.2 8.1L99.6 283c-16-15.2-41.3-14.6-56.6 1.4s-14.6 41.3 1.4 56.6L156.8 448c43.1 41.1 100.4 64 160 64l10.9 0 8.2 0c.1 0 .1-.1 .1-.1s.1-.1 .1-.1c58.3-3.5 108.6-43.2 125.3-99.7l81.2-275c5-16.9-4.7-34.7-21.6-39.8s-34.7 4.7-39.8 21.6L443.5 247.1c-1.6 5.3-6.4 8.9-12 8.9c-7.9 0-13.8-7.3-12.2-15.1l36-170.3c3.7-17.3-7.4-34.3-24.7-37.9s-34.3 7.4-37.9 24.7L355.1 235.1c-2.6 12.2-13.3 20.9-25.8 20.9c-11.9 0-22.4-8-25.4-19.5l-57-212.8z"
    ]
};
const $d8206b3ab2e65c05$export$b85a7300fc7960b6 = {
    prefix: 'fas',
    iconName: 'stopwatch',
    icon: [
        448,
        512,
        [
            9201
        ],
        "f2f2",
        "M176 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l16 0 0 34.4C92.3 113.8 16 200 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-41.8-12.3-80.7-33.5-113.2l24.1-24.1c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L355.7 143c-28.1-23-62.2-38.8-99.7-44.6L256 64l16 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L224 0 176 0zm72 192l0 128c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-128c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
const $d8206b3ab2e65c05$export$5a54c83033a0a56a = {
    prefix: 'fas',
    iconName: 'face-kiss',
    icon: [
        512,
        512,
        [
            128535,
            "kiss"
        ],
        "f596",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm48.7-198.3c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 443.1 257.4 448 240 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9c0 0 0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1 .3-.2 .6-.4c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.4-.3-.5-.3-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $d8206b3ab2e65c05$export$c762a77aabf64fd0 = $d8206b3ab2e65c05$export$5a54c83033a0a56a;
const $d8206b3ab2e65c05$export$834071278537f121 = {
    prefix: 'fas',
    iconName: 'bridge-circle-xmark',
    icon: [
        640,
        512,
        [],
        "e4cb",
        "M64 32C46.3 32 32 46.3 32 64s14.3 32 32 32l40 0 0 64-72 0 0 128c53 0 96 43 96 96l0 64c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-64c0-53 43-96 96-96c6.3 0 12.4 .6 18.3 1.7C367.1 231.8 426.9 192 496 192c42.5 0 81.6 15.1 112 40.2l0-72.2-72 0 0-64 40 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L64 32zM488 96l0 64-80 0 0-64 80 0zM360 96l0 64-80 0 0-64 80 0zM232 96l0 64-80 0 0-64 80 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
const $d8206b3ab2e65c05$export$95a7394c24f57943 = {
    prefix: 'fas',
    iconName: 'face-grin-tongue',
    icon: [
        512,
        512,
        [
            128539,
            "grin-tongue"
        ],
        "f589",
        "M0 256C0 368.9 73.1 464.7 174.5 498.8C165.3 484 160 466.6 160 448l0-47.3c-24-17.5-43.1-41.4-54.8-69.2c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7c-11.8 28-31.1 52-55.4 69.6l0 46.9c0 18.6-5.3 36-14.5 50.8C438.9 464.7 512 368.9 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zm176.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 448l0-45.4c0-14.7-11.9-26.6-26.6-26.6l-2 0c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9l-2 0c-14.7 0-26.6 11.9-26.6 26.6l0 45.4c0 35.3 28.7 64 64 64s64-28.7 64-64z"
    ]
};
const $d8206b3ab2e65c05$export$ef222816a43a4b3a = $d8206b3ab2e65c05$export$95a7394c24f57943;
const $d8206b3ab2e65c05$export$a831eedd2f59c62f = {
    prefix: 'fas',
    iconName: 'chess-bishop',
    icon: [
        320,
        512,
        [
            9821
        ],
        "f43a",
        "M128 0C110.3 0 96 14.3 96 32c0 16.1 11.9 29.4 27.4 31.7C78.4 106.8 8 190 8 288c0 47.4 30.8 72.3 56 84.7L64 400l192 0 0-27.3c25.2-12.5 56-37.4 56-84.7c0-37.3-10.2-72.4-25.3-104.1l-99.4 99.4c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L270.8 154.6c-23.2-38.1-51.8-69.5-74.2-90.9C212.1 61.4 224 48.1 224 32c0-17.7-14.3-32-32-32L128 0zM48 432L6.6 473.4c-4.2 4.2-6.6 10-6.6 16C0 501.9 10.1 512 22.6 512l274.7 0c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L272 432 48 432z"
    ]
};
const $d8206b3ab2e65c05$export$1dd161850c5bc64e = {
    prefix: 'fas',
    iconName: 'face-grin-wink',
    icon: [
        512,
        512,
        [
            "grin-wink"
        ],
        "f58c",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zm-16.9-79.2c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $d8206b3ab2e65c05$export$2397fcd34eb12177 = $d8206b3ab2e65c05$export$1dd161850c5bc64e;
const $d8206b3ab2e65c05$export$c9c5b76ec992eab4 = {
    prefix: 'fas',
    iconName: 'ear-deaf',
    icon: [
        512,
        512,
        [
            "deaf",
            "deafness",
            "hard-of-hearing"
        ],
        "f2a4",
        "M502.6 54.6l-40 40c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l40-40c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zm-320 320l-128 128c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zM240 128c-57.6 0-105.1 43.6-111.3 99.5c-1.9 17.6-17.8 30.2-35.3 28.3s-30.2-17.8-28.3-35.3C74.8 132.5 149.4 64 240 64c97.2 0 176 78.8 176 176c0 46-17.7 87.9-46.6 119.3c-12 13-17.4 24.8-17.4 34.7l0 6.1c0 61.9-50.1 112-112 112c-17.7 0-32-14.3-32-32s14.3-32 32-32c26.5 0 48-21.5 48-48l0-6.1c0-32.9 17.4-59.6 34.4-78c18.4-20 29.6-46.6 29.6-75.9c0-61.9-50.1-112-112-112zm0 80c-17.7 0-32 14.3-32 32c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-44.2 35.8-80 80-80s80 35.8 80 80c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-17.7-14.3-32-32-32z"
    ]
};
const $d8206b3ab2e65c05$export$4b666adf83f0de01 = $d8206b3ab2e65c05$export$c9c5b76ec992eab4;
const $d8206b3ab2e65c05$export$85c6a9ab2fa2631e = $d8206b3ab2e65c05$export$c9c5b76ec992eab4;
const $d8206b3ab2e65c05$export$ebecf90a5676e17a = $d8206b3ab2e65c05$export$c9c5b76ec992eab4;
const $d8206b3ab2e65c05$export$3f22db9ae9b6be1c = {
    prefix: 'fas',
    iconName: 'road-circle-check',
    icon: [
        640,
        512,
        [],
        "e564",
        "M213.2 32L288 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64 74.8 0c27.1 0 51.3 17.1 60.3 42.6l42.7 120.6c-10.9-2.1-22.2-3.2-33.8-3.2c-59.5 0-112.1 29.6-144 74.8l0-42.8c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32c2.3 0 4.6-.3 6.8-.7c-4.5 15.5-6.8 31.8-6.8 48.7c0 5.4 .2 10.7 .7 16l-.7 0c-17.7 0-32 14.3-32 32l0 64L86.6 480C56.5 480 32 455.5 32 425.4c0-6.2 1.1-12.4 3.1-18.2L152.9 74.6C162 49.1 186.1 32 213.2 32zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
    ]
};
const $d8206b3ab2e65c05$export$d9769fb795c2db82 = {
    prefix: 'fas',
    iconName: 'dice-five',
    icon: [
        448,
        512,
        [
            9860
        ],
        "f523",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm64 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM96 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $d8206b3ab2e65c05$export$97d1903b1e012ff7 = {
    prefix: 'fas',
    iconName: 'square-rss',
    icon: [
        448,
        512,
        [
            "rss-square"
        ],
        "f143",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM96 136c0-13.3 10.7-24 24-24c137 0 248 111 248 248c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-110.5-89.5-200-200-200c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24c83.9 0 152 68.1 152 152c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-57.4-46.6-104-104-104c-13.3 0-24-10.7-24-24zm0 120a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
const $d8206b3ab2e65c05$export$89c9b1cca2c11484 = $d8206b3ab2e65c05$export$97d1903b1e012ff7;
const $d8206b3ab2e65c05$export$567a897fc092e403 = {
    prefix: 'fas',
    iconName: 'land-mine-on',
    icon: [
        640,
        512,
        [],
        "e51b",
        "M344 24l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144c0-13.3 10.7-24 24-24s24 10.7 24 24zM192 320c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32l0 32-256 0 0-32zm-77.3 90.5c8.1-16.3 24.8-26.5 42.9-26.5l324.7 0c18.2 0 34.8 10.3 42.9 26.5l27.6 55.2C563.5 487 548 512 524.2 512l-408.4 0c-23.8 0-39.3-25-28.6-46.3l27.6-55.2zM36.3 138.3c7.5-10.9 22.5-13.6 33.4-6.1l104 72c10.9 7.5 13.6 22.5 6.1 33.4s-22.5 13.6-33.4 6.1l-104-72c-10.9-7.5-13.6-22.5-6.1-33.4zm534.1-6.1c10.9-7.5 25.8-4.8 33.4 6.1s4.8 25.8-6.1 33.4l-104 72c-10.9 7.5-25.8 4.8-33.4-6.1s-4.8-25.8 6.1-33.4l104-72z"
    ]
};
const $d8206b3ab2e65c05$export$7fddf76ec23943d8 = {
    prefix: 'fas',
    iconName: 'i-cursor',
    icon: [
        256,
        512,
        [],
        "f246",
        "M.1 29.3C-1.4 47 11.7 62.4 29.3 63.9l8 .7C70.5 67.3 96 95 96 128.3L96 224l-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 95.7c0 33.3-25.5 61-58.7 63.8l-8 .7C11.7 449.6-1.4 465 .1 482.7s16.9 30.7 34.5 29.2l8-.7c34.1-2.8 64.2-18.9 85.4-42.9c21.2 24 51.2 40 85.4 42.9l8 .7c17.6 1.5 33.1-11.6 34.5-29.2s-11.6-33.1-29.2-34.5l-8-.7C185.5 444.7 160 417 160 383.7l0-95.7 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-95.7c0-33.3 25.5-61 58.7-63.8l8-.7c17.6-1.5 30.7-16.9 29.2-34.5S239-1.4 221.3 .1l-8 .7C179.2 3.6 149.2 19.7 128 43.7c-21.2-24-51.2-40-85.4-42.9l-8-.7C17-1.4 1.6 11.7 .1 29.3z"
    ]
};
const $d8206b3ab2e65c05$export$722e92d2d93ffc68 = {
    prefix: 'fas',
    iconName: 'stamp',
    icon: [
        512,
        512,
        [],
        "f5bf",
        "M312 201.8c0-17.4 9.2-33.2 19.9-47C344.5 138.5 352 118.1 352 96c0-53-43-96-96-96s-96 43-96 96c0 22.1 7.5 42.5 20.1 58.8c10.7 13.8 19.9 29.6 19.9 47c0 29.9-24.3 54.2-54.2 54.2L112 256C50.1 256 0 306.1 0 368c0 20.9 13.4 38.7 32 45.3L32 464c0 26.5 21.5 48 48 48l352 0c26.5 0 48-21.5 48-48l0-50.7c18.6-6.6 32-24.4 32-45.3c0-61.9-50.1-112-112-112l-33.8 0c-29.9 0-54.2-24.3-54.2-54.2zM416 416l0 32L96 448l0-32 320 0z"
    ]
};
const $d8206b3ab2e65c05$export$68b3af7444c89df7 = {
    prefix: 'fas',
    iconName: 'stairs',
    icon: [
        576,
        512,
        [],
        "e289",
        "M384 64c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0 0 96c0 17.7-14.3 32-32 32l-96 0 0 96c0 17.7-14.3 32-32 32l-96 0 0 96c0 17.7-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0 0-96c0-17.7 14.3-32 32-32l96 0 0-96c0-17.7 14.3-32 32-32l96 0 0-96z"
    ]
};
const $d8206b3ab2e65c05$export$aee03ca0815b7c38 = {
    prefix: 'fas',
    iconName: 'i',
    icon: [
        320,
        512,
        [
            105
        ],
        "49",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l96 0 0 320-96 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0 0-320 96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L160 32 32 32z"
    ]
};
const $d8206b3ab2e65c05$export$22a9491150c64fef = {
    prefix: 'fas',
    iconName: 'hryvnia-sign',
    icon: [
        384,
        512,
        [
            8372,
            "hryvnia"
        ],
        "f6f2",
        "M121.9 116.2C138.3 103.1 158.7 96 179.6 96L223 96c27.1 0 49 21.9 49 49c0 11.5-4 22.4-11.1 31L32 176c-17.7 0-32 14.3-32 32s14.3 32 32 32l123.5 0-50.6 28.9c-1.7 1-3.4 2-5.1 3.1L32 272c-17.7 0-32 14.3-32 32s14.3 32 32 32l20.3 0c-2.8 9.9-4.3 20.4-4.3 31c0 62.4 50.6 113 113 113l43.4 0c35.5 0 70-12.1 97.7-34.3L308 441c13.8-11 16-31.2 5-45s-31.2-16-45-5l-5.9 4.7c-16.4 13.1-36.7 20.2-57.7 20.2L161 416c-27.1 0-49-21.9-49-49c0-11.5 4-22.4 11.1-31L352 336c17.7 0 32-14.3 32-32s-14.3-32-32-32l-123.5 0 50.6-28.9c1.7-1 3.4-2 5.1-3.1l67.8 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-20.3 0c2.8-10 4.3-20.4 4.3-31c0-62.4-50.6-113-113-113l-43.4 0c-35.5 0-70 12.1-97.7 34.3L76 71c-13.8 11-16 31.2-5 45s31.2 16 45 5l5.9-4.7z"
    ]
};
const $d8206b3ab2e65c05$export$33d5f94bd6f75f59 = $d8206b3ab2e65c05$export$22a9491150c64fef;
const $d8206b3ab2e65c05$export$6380e2ed6e69d350 = {
    prefix: 'fas',
    iconName: 'pills',
    icon: [
        576,
        512,
        [],
        "f484",
        "M112 96c-26.5 0-48 21.5-48 48l0 112 96 0 0-112c0-26.5-21.5-48-48-48zM0 144C0 82.1 50.1 32 112 32s112 50.1 112 112l0 224c0 61.9-50.1 112-112 112S0 429.9 0 368L0 144zM554.9 399.4c-7.1 12.3-23.7 13.1-33.8 3.1L333.5 214.9c-10-10-9.3-26.7 3.1-33.8C360 167.7 387.1 160 416 160c88.4 0 160 71.6 160 160c0 28.9-7.7 56-21.1 79.4zm-59.5 59.5C472 472.3 444.9 480 416 480c-88.4 0-160-71.6-160-160c0-28.9 7.7-56 21.1-79.4c7.1-12.3 23.7-13.1 33.8-3.1L498.5 425.1c10 10 9.3 26.7-3.1 33.8z"
    ]
};
const $d8206b3ab2e65c05$export$bdbabf493c478cde = {
    prefix: 'fas',
    iconName: 'face-grin-wide',
    icon: [
        512,
        512,
        [
            128515,
            "grin-alt"
        ],
        "f581",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM208 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64zm128 64c-17.7 0-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64z"
    ]
};
const $d8206b3ab2e65c05$export$b4abebfe416d36ba = $d8206b3ab2e65c05$export$bdbabf493c478cde;
const $d8206b3ab2e65c05$export$3a1fa2d16f90d635 = {
    prefix: 'fas',
    iconName: 'tooth',
    icon: [
        448,
        512,
        [
            129463
        ],
        "f5c9",
        "M186.1 52.1C169.3 39.1 148.7 32 127.5 32C74.7 32 32 74.7 32 127.5l0 6.2c0 15.8 3.7 31.3 10.7 45.5l23.5 47.1c4.5 8.9 7.6 18.4 9.4 28.2l36.7 205.8c2 11.2 11.6 19.4 22.9 19.8s21.4-7.4 24-18.4l28.9-121.3C192.2 323.7 207 312 224 312s31.8 11.7 35.8 28.3l28.9 121.3c2.6 11.1 12.7 18.8 24 18.4s20.9-8.6 22.9-19.8l36.7-205.8c1.8-9.8 4.9-19.3 9.4-28.2l23.5-47.1c7.1-14.1 10.7-29.7 10.7-45.5l0-2.1c0-55-44.6-99.6-99.6-99.6c-24.1 0-47.4 8.8-65.6 24.6l-3.2 2.8 19.5 15.2c7 5.4 8.2 15.5 2.8 22.5s-15.5 8.2-22.5 2.8l-24.4-19-37-28.8z"
    ]
};
const $d8206b3ab2e65c05$export$6fb446f784f6b9b3 = {
    prefix: 'fas',
    iconName: 'v',
    icon: [
        384,
        512,
        [
            118
        ],
        "56",
        "M19.7 34.5c16.3-6.8 35 .9 41.8 17.2L192 364.8 322.5 51.7c6.8-16.3 25.5-24 41.8-17.2s24 25.5 17.2 41.8l-160 384c-5 11.9-16.6 19.7-29.5 19.7s-24.6-7.8-29.5-19.7L2.5 76.3c-6.8-16.3 .9-35 17.2-41.8z"
    ]
};
const $d8206b3ab2e65c05$export$469d376940e10d37 = {
    prefix: 'fas',
    iconName: 'bangladeshi-taka-sign',
    icon: [
        384,
        512,
        [],
        "e2e6",
        "M36 32.3C18.4 30.1 2.4 42.5 .2 60S10.5 93.6 28 95.8l7.9 1c16 2 28 15.6 28 31.8L64 160l-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 160c0 53 43 96 96 96l32 0c106 0 192-86 192-192l0-32c0-53-43-96-96-96l-16 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l16 0c17.7 0 32 14.3 32 32l0 32c0 70.7-57.3 128-128 128l-32 0c-17.7 0-32-14.3-32-32l0-160 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-31.5c0-48.4-36.1-89.3-84.1-95.3l-7.9-1z"
    ]
};
const $d8206b3ab2e65c05$export$36cb1885ad7a570f = {
    prefix: 'fas',
    iconName: 'bicycle',
    icon: [
        640,
        512,
        [
            128690
        ],
        "f206",
        "M312 32c-13.3 0-24 10.7-24 24s10.7 24 24 24l25.7 0 34.6 64-149.4 0-27.4-38C191 99.7 183.7 96 176 96l-56 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l43.7 0 22.1 30.7-26.6 53.1c-10-2.5-20.5-3.8-31.2-3.8C57.3 224 0 281.3 0 352s57.3 128 128 128c65.3 0 119.1-48.9 127-112l49 0c8.5 0 16.3-4.5 20.7-11.8l84.8-143.5 21.7 40.1C402.4 276.3 384 312 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-13.5 0-26.5 2.1-38.7 6L375.4 48.8C369.8 38.4 359 32 347.2 32L312 32zM458.6 303.7l32.3 59.7c6.3 11.7 20.9 16 32.5 9.7s16-20.9 9.7-32.5l-32.3-59.7c3.6-.6 7.4-.9 11.2-.9c39.8 0 72 32.2 72 72s-32.2 72-72 72s-72-32.2-72-72c0-18.6 7-35.5 18.6-48.3zM133.2 368l65 0c-7.3 32.1-36 56-70.2 56c-39.8 0-72-32.2-72-72s32.2-72 72-72c1.7 0 3.4 .1 5.1 .2l-24.2 48.5c-9 18.1 4.1 39.4 24.3 39.4zm33.7-48l50.7-101.3 72.9 101.2-.1 .1-123.5 0zm90.6-128l108.5 0L317 274.8 257.4 192z"
    ]
};
const $d8206b3ab2e65c05$export$76d998742bc186eb = {
    prefix: 'fas',
    iconName: 'staff-snake',
    icon: [
        384,
        512,
        [
            "rod-asclepius",
            "rod-snake",
            "staff-aesculapius"
        ],
        "e579",
        "M222.6 43.2l-.1 4.8L288 48c53 0 96 43 96 96s-43 96-96 96l-40 0 0-80 40 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-40 0-28 0-4.5 144 40.5 0c53 0 96 43 96 96s-43 96-96 96l-16 0 0-80 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-43 0-3.1 99.5L208.5 495l0 1c-.3 8.9-7.6 16-16.5 16s-16.2-7.1-16.5-16l0-1-1-31L136 464c-22.1 0-40-17.9-40-40s17.9-40 40-40l36 0-1-32-19 0c-53 0-96-43-96-96c0-47.6 34.6-87.1 80-94.7l0 94.7c0 8.8 7.2 16 16 16l16.5 0L164 128l-28 0-13.4 0c-9 18.9-28.3 32-50.6 32l-16 0c-30.9 0-56-25.1-56-56S25.1 48 56 48l8 0 8 0 89.5 0-.1-4.8L161 32c0-.7 0-1.3 0-1.9c.5-16.6 14.1-30 31-30s30.5 13.4 31 30c0 .6 0 1.3 0 1.9l-.4 11.2zM64 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
const $d8206b3ab2e65c05$export$f2c3e92ee37a8d89 = $d8206b3ab2e65c05$export$76d998742bc186eb;
const $d8206b3ab2e65c05$export$5d61dcb598296af0 = $d8206b3ab2e65c05$export$76d998742bc186eb;
const $d8206b3ab2e65c05$export$97c8a2cdba3b7700 = $d8206b3ab2e65c05$export$76d998742bc186eb;
const $d8206b3ab2e65c05$export$b293ee8fb8e6b0c4 = {
    prefix: 'fas',
    iconName: 'head-side-cough-slash',
    icon: [
        640,
        512,
        [],
        "e062",
        "M448 325.8l44 34.5c8.1 1.4 14.8 6.8 18 14.1L552.9 408c10.6 .4 19.5 7.6 22.2 17.4l39.1 30.6c.6 0 1.2-.1 1.8-.1c11.1 0 20.4 7.5 23.2 17.8l-3.9 0c6.2 8.5 6.4 20.4-.4 29c-8.2 10.4-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1L89.6 44.9C127 16.7 173.5 0 224 0l24 0c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8L448 320s0 0 0 0l0 5.8zM0 224.2c0-38.7 9.8-75.1 27.1-106.9L341.8 365.3l-2.5 .3c-11 1.4-19.2 10.7-19.2 21.8c0 11.6 9 21.2 20.6 21.9l62 3.9 43 33.9C439.3 466.2 421.2 480 400 480l-80 0 0 8c0 13.3-10.7 24-24 24l-40 0s0 0 0 0L96 512c-17.7 0-32-14.3-32-32l0-72.7c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zM616 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-64-48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40-24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
const $d8206b3ab2e65c05$export$fb6bd43f079f72e2 = {
    prefix: 'fas',
    iconName: 'truck-medical',
    icon: [
        640,
        512,
        [
            128657,
            "ambulance"
        ],
        "f0f9",
        "M0 48C0 21.5 21.5 0 48 0L368 0c26.5 0 48 21.5 48 48l0 48 50.7 0c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3l0 18.7 0 32 0 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c0 53-43 96-96 96s-96-43-96-96l-128 0c0 53-43 96-96 96s-96-43-96-96l-16 0c-26.5 0-48-21.5-48-48L0 48zM416 256l128 0 0-18.7L466.7 160 416 160l0 96zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM176 80l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z"
    ]
};
const $d8206b3ab2e65c05$export$f5c7042778b51765 = $d8206b3ab2e65c05$export$fb6bd43f079f72e2;
const $d8206b3ab2e65c05$export$e23367e54f665590 = {
    prefix: 'fas',
    iconName: 'wheat-awn-circle-exclamation',
    icon: [
        640,
        512,
        [],
        "e598",
        "M505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L383 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l88-88zM305.5 27.3c-6.2-6.2-16.4-6.2-22.6 0L271.5 38.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8L101.8 231c-6.2-6.2-16.4-6.2-22.6 0L67.9 242.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c22.5 22.5 53.3 31.5 82.4 27c0-1 0-2.1 0-3.1c0-33.1 9.1-64.1 25-90.6c-15.5-8.7-32.5-13.8-49.8-15.5l31.9-31.9 12.2 12.2c6 6 12.6 11.1 19.7 15.2c27.5-34 67.3-57.5 112.6-63.8c-4.1-3.8-8.4-7.3-12.9-10.5L505 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-59.4 59.4c-20.6-4.4-42-3.7-62.3 2.1c6.1-21.3 6.6-43.8 1.4-65.3L409 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L329.1 52.9c-3.7-5-7.8-9.8-12.4-14.3L305.5 27.3zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16z"
    ]
};
const $d8206b3ab2e65c05$export$b23df6bafb174693 = {
    prefix: 'fas',
    iconName: 'snowman',
    icon: [
        512,
        512,
        [
            9731,
            9924
        ],
        "f7d0",
        "M341.1 140.6c-2 3.9-1.6 8.6 1.2 12c7 8.5 12.9 18.1 17.2 28.4L408 160.2l0-40.2c0-13.3 10.7-24 24-24s24 10.7 24 24l0 19.6 22.5-9.7c12.2-5.2 26.3 .4 31.5 12.6s-.4 26.3-12.6 31.5l-56 24-73.6 31.5c-.5 9.5-2.1 18.6-4.8 27.3c-1.2 3.8-.1 8 2.8 10.8C396.7 296.9 416 338.2 416 384c0 44.7-18.3 85-47.8 114.1c-9.9 9.7-23.7 13.9-37.5 13.9l-149.3 0c-13.9 0-27.7-4.2-37.5-13.9C114.3 469 96 428.7 96 384c0-45.8 19.3-87.1 50.1-116.3c2.9-2.8 4-6.9 2.8-10.8c-2.7-8.7-4.3-17.9-4.8-27.3L70.5 198.1l-56-24C2.4 168.8-3.3 154.7 1.9 142.5s19.3-17.8 31.5-12.6L56 139.6 56 120c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40.2L152.6 181c4.3-10.3 10.1-19.9 17.2-28.4c2.8-3.4 3.3-8.1 1.2-12C164 127.2 160 112.1 160 96c0-53 43-96 96-96s96 43 96 96c0 16.1-4 31.2-10.9 44.6zM224 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM288 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-48 24l0 3.2c0 3.2 .8 6.3 2.3 9l9 16.9c.9 1.7 2.7 2.8 4.7 2.8s3.8-1.1 4.7-2.8l9-16.9c1.5-2.8 2.3-5.9 2.3-9l0-3.2c0-8.8-7.2-16-16-16s-16 7.2-16 16z"
    ]
};
const $d8206b3ab2e65c05$export$55ceb5d0c144580a = {
    prefix: 'fas',
    iconName: 'mortar-pestle',
    icon: [
        512,
        512,
        [],
        "f5a7",
        "M504.3 11.1C493.3-1.6 474.5-3.7 461 6.2L252.3 160l144.9 0L502.6 54.6c11.8-11.8 12.6-30.8 1.6-43.5zM32 192c-17.7 0-32 14.3-32 32s14.3 32 32 32c0 82.5 43.4 147.7 123.9 176.2c-11.1 13.9-19.4 30.3-23.9 48.1C127.6 497.4 142.3 512 160 512l192 0c17.7 0 32.4-14.6 28.1-31.7c-4.5-17.8-12.8-34.1-23.9-48.1C436.6 403.7 480 338.5 480 256c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 192z"
    ]
};
const $d8206b3ab2e65c05$export$f3e925217e396f44 = {
    prefix: 'fas',
    iconName: 'road-barrier',
    icon: [
        640,
        512,
        [],
        "e562",
        "M32 32C14.3 32 0 46.3 0 64L0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-181.7L149.2 96 64 96l0-32c0-17.7-14.3-32-32-32zM405.2 96l-74.3 0-5.4 10.7L234.8 288l74.3 0 5.4-10.7L405.2 96zM362.8 288l74.3 0 5.4-10.7L533.2 96l-74.3 0-5.4 10.7L362.8 288zM202.8 96l-5.4 10.7L106.8 288l74.3 0 5.4-10.7L277.2 96l-74.3 0zm288 192l85.2 0 0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-384c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 53.7L490.8 288z"
    ]
};
const $d8206b3ab2e65c05$export$51e9b8434982947d = {
    prefix: 'fas',
    iconName: 'school',
    icon: [
        640,
        512,
        [
            127979
        ],
        "f549",
        "M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96 48 96C21.5 96 0 117.5 0 144L0 464c0 26.5 21.5 48 48 48l208 0 0-96c0-35.3 28.7-64 64-64s64 28.7 64 64l0 96 208 0c26.5 0 48-21.5 48-48l0-320c0-26.5-21.5-48-48-48L473.7 96 337.8 5.4zM96 192l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zm400 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64zM96 320l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zm400 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64zM232 176a88 88 0 1 1 176 0 88 88 0 1 1 -176 0zm88-48c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-16c0-8.8-7.2-16-16-16z"
    ]
};
const $d8206b3ab2e65c05$export$4a284575edd6f1af = {
    prefix: 'fas',
    iconName: 'igloo',
    icon: [
        576,
        512,
        [],
        "f7ae",
        "M320 33.8L320 160 48.5 160C100.2 82.8 188.1 32 288 32c10.8 0 21.5 .6 32 1.8zM352 160l0-120.9C424.9 55.7 487.2 99.8 527.5 160L352 160zM29.9 192L96 192l0 128L0 320c0-46 10.8-89.4 29.9-128zM192 320l-64 0 0-128 320 0 0 128-64 0 0 32 192 0 0 80c0 26.5-21.5 48-48 48l-176 0 0-128c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 128L48 480c-26.5 0-48-21.5-48-48l0-80 192 0 0-32zm288 0l0-128 66.1 0c19.2 38.6 29.9 82 29.9 128l-96 0z"
    ]
};
const $d8206b3ab2e65c05$export$e5a289fb22ffb8cb = {
    prefix: 'fas',
    iconName: 'joint',
    icon: [
        640,
        512,
        [],
        "f595",
        "M448 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 11c0 55.2 21.9 108.1 60.9 147.1l21 21c9 9 14.1 21.2 14.1 33.9l0 11c0 17.7 14.3 32 32 32s32-14.3 32-32l0-11c0-29.7-11.8-58.2-32.8-79.2l-21-21C463.2 117.8 448 81.2 448 43l0-11zM576 256c0 17.7 14.3 32 32 32s32-14.3 32-32l0-11c0-55.2-21.9-108.1-60.9-147.1l-21-21c-9-9-14.1-21.2-14.1-33.9l0-11c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 11c0 29.7 11.8 58.2 32.8 79.2l21 21c27 27 42.2 63.6 42.2 101.8l0 11zM229.8 360c-4.7-2.3-10-2.7-15.2-2c-37.8 5.6-75.2 14.3-106.9 22.8C81.3 388 58.3 395.1 42 400.4c-8.2 2.7-14.7 4.9-19.2 6.5c-2.3 .8-4 1.4-5.2 1.8l-1.3 .5C6.8 412.5 0 421.4 0 432s6.8 19.5 16.3 22.7l1.3 .5c1.2 .4 3 1.1 5.2 1.8c4.5 1.6 11 3.8 19.2 6.5c16.3 5.4 39.2 12.5 65.7 19.6C160.3 497.3 228.8 512 288 512l67.3 0c4.1 0 6.3-5.1 3.6-8.3L256.5 380.8c-7.4-8.9-16.5-15.9-26.7-20.8zM445 512l19 0 51.3 0c4.1 0 6.3-5.1 3.6-8.3L416.5 380.8C401.3 362.5 378.8 352 355 352l-19 0-48 0c-1.1 0-2.3 0-3.4 0c-4.1 0-6.2 5.1-3.5 8.3L383.5 483.2C398.7 501.5 421.2 512 445 512zm-3.9-151.7L543.5 483.2c14.6 17.5 35.9 27.9 58.6 28.7c21.1-1.1 37.9-18.6 37.9-39.9l0-80c0-22.1-17.9-40-40-40l-155.3 0c-4.1 0-6.3 5.1-3.6 8.3z"
    ]
};
const $d8206b3ab2e65c05$export$6bce1afb61f2eb66 = {
    prefix: 'fas',
    iconName: 'angle-right',
    icon: [
        320,
        512,
        [
            8250
        ],
        "f105",
        "M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
    ]
};
const $d8206b3ab2e65c05$export$5b05f097fa38352a = {
    prefix: 'fas',
    iconName: 'horse',
    icon: [
        576,
        512,
        [
            128014
        ],
        "f6f0",
        "M448 238.1l0-78.1 16 0 9.8 19.6c12.5 25.1 42.2 36.4 68.3 26c20.5-8.2 33.9-28 33.9-50.1L576 80c0-19.1-8.4-36.3-21.7-48l5.7 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L480 0 448 0C377.3 0 320 57.3 320 128l-96 0-20.8 0-54.4 0c-30.7 0-57.6 16.3-72.5 40.8C33.2 174.5 0 211.4 0 256l0 56c0 13.3 10.7 24 24 24s24-10.7 24-24l0-56c0-13.4 6.6-25.2 16.7-32.5c1.6 13 6.3 25.4 13.6 36.4l28.2 42.4c8.3 12.4 6.4 28.7-1.2 41.6c-16.5 28-20.6 62.2-10 93.9l17.5 52.4c4.4 13.1 16.6 21.9 30.4 21.9l33.7 0c21.8 0 37.3-21.4 30.4-42.1l-20.8-62.5c-2.1-6.4-.5-13.4 4.3-18.2l12.7-12.7c13.2-13.2 20.6-31.1 20.6-49.7c0-2.3-.1-4.6-.3-6.9l84 24c4.1 1.2 8.2 2.1 12.3 2.8L320 480c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-164.3c19.2-19.2 31.5-45.7 32-75.7c0 0 0 0 0 0l0-1.9zM496 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
    ]
};
const $d8206b3ab2e65c05$export$5a2b164552deda9f = {
    prefix: 'fas',
    iconName: 'q',
    icon: [
        448,
        512,
        [
            113
        ],
        "51",
        "M64 256c0 88.4 71.6 160 160 160c28.9 0 56-7.7 79.4-21.1l-72-86.4c-11.3-13.6-9.5-33.8 4.1-45.1s33.8-9.5 45.1 4.1l70.9 85.1C371.9 325.8 384 292.3 384 256c0-88.4-71.6-160-160-160S64 167.6 64 256zM344.9 444.6C310 467 268.5 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32s224 100.3 224 224c0 56.1-20.6 107.4-54.7 146.7l47.3 56.8c11.3 13.6 9.5 33.8-4.1 45.1s-33.8 9.5-45.1-4.1l-46.6-55.9z"
    ]
};
const $d8206b3ab2e65c05$export$9f5c2b0db8eedeac = {
    prefix: 'fas',
    iconName: 'g',
    icon: [
        448,
        512,
        [
            103
        ],
        "47",
        "M224 96C135.6 96 64 167.6 64 256s71.6 160 160 160c77.4 0 142-55 156.8-128L256 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l144 0c25.8 0 49.6 21.4 47.2 50.6C437.8 389.6 341.4 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32c57.4 0 109.7 21.6 149.3 57c13.2 11.8 14.3 32 2.5 45.2s-32 14.3-45.2 2.5C302.3 111.4 265 96 224 96z"
    ]
};
const $d8206b3ab2e65c05$export$b2d79133c81d6697 = {
    prefix: 'fas',
    iconName: 'notes-medical',
    icon: [
        512,
        512,
        [],
        "f481",
        "M96 352L96 96c0-35.3 28.7-64 64-64l256 0c35.3 0 64 28.7 64 64l0 197.5c0 17-6.7 33.3-18.7 45.3l-58.5 58.5c-12 12-28.3 18.7-45.3 18.7L160 416c-35.3 0-64-28.7-64-64zM272 128c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0zm24 336c13.3 0 24 10.7 24 24s-10.7 24-24 24l-160 0C60.9 512 0 451.1 0 376L0 152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 224c0 48.6 39.4 88 88 88l160 0z"
    ]
};
const $d8206b3ab2e65c05$export$a3f1d7f13c202adc = {
    prefix: 'fas',
    iconName: 'temperature-half',
    icon: [
        320,
        512,
        [
            127777,
            "temperature-2",
            "thermometer-2",
            "thermometer-half"
        ],
        "f2c9",
        "M160 64c-26.5 0-48 21.5-48 48l0 164.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5L208 112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112l0 164.4c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6L48 112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3L144 208c0-8.8 7.2-16 16-16s16 7.2 16 16l0 114.7c18.6 6.6 32 24.4 32 45.3z"
    ]
};
const $d8206b3ab2e65c05$export$8176e649df45b32c = $d8206b3ab2e65c05$export$a3f1d7f13c202adc;
const $d8206b3ab2e65c05$export$4dd764ac8d512682 = $d8206b3ab2e65c05$export$a3f1d7f13c202adc;
const $d8206b3ab2e65c05$export$2090f040324b4449 = $d8206b3ab2e65c05$export$a3f1d7f13c202adc;
const $d8206b3ab2e65c05$export$18659308f17918a5 = {
    prefix: 'fas',
    iconName: 'dong-sign',
    icon: [
        384,
        512,
        [],
        "e169",
        "M288 32c-17.7 0-32 14.3-32 32l-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 49.1c-18.8-10.9-40.7-17.1-64-17.1c-70.7 0-128 57.3-128 128s57.3 128 128 128c24.5 0 47.4-6.9 66.8-18.8c5 11.1 16.2 18.8 29.2 18.8c17.7 0 32-14.3 32-32l0-96 0-160c17.7 0 32-14.3 32-32s-14.3-32-32-32c0-17.7-14.3-32-32-32zM128 288a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l320 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 448z"
    ]
};
const $d8206b3ab2e65c05$export$ba6fd4a436804a48 = {
    prefix: 'fas',
    iconName: 'capsules',
    icon: [
        576,
        512,
        [],
        "f46b",
        "M64 144c0-26.5 21.5-48 48-48s48 21.5 48 48l0 112-96 0 0-112zM0 144L0 368c0 61.9 50.1 112 112 112s112-50.1 112-112l0-178.4c1.8 19.1 8.2 38 19.8 54.8L372.3 431.7c35.5 51.7 105.3 64.3 156 28.1s63-107.5 27.5-159.2L427.3 113.3C391.8 61.5 321.9 49 271.3 85.2c-28 20-44.3 50.8-47.3 83l0-24.2c0-61.9-50.1-112-112-112S0 82.1 0 144zm296.6 64.2c-16-23.3-10-55.3 11.9-71c21.2-15.1 50.5-10.3 66 12.2l67 97.6L361.6 303l-65-94.8zM491 407.7c-.8 .6-1.6 1.1-2.4 1.6l4-2.8c-.5 .4-1 .8-1.6 1.2z"
    ]
};
const $d8206b3ab2e65c05$export$48a38da471b097a2 = {
    prefix: 'fas',
    iconName: 'poo-storm',
    icon: [
        448,
        512,
        [
            "poo-bolt"
        ],
        "f75a",
        "M236.9 .2c-5.5-.7-11 1.4-14.5 5.7s-4.6 10.1-2.8 15.3c2.8 8.2 4.3 16.9 4.3 26.1c0 21.7-8.5 37.2-21.9 47.6c-13.8 10.8-34 17-57.8 17L128 112c-35.3 0-64 28.7-64 64c0 12.2 3.4 23.5 9.3 33.2C31.7 216.2 0 252.4 0 296c0 40.9 28 75.4 65.8 85.2c-5.3-18.5 1-38.5 16.2-50.7l160-128c17.6-14.1 42.6-14 60.2 .2s22.8 38.6 12.8 58.8L285.7 320l18.3 0c20.4 0 38.5 12.9 45.3 32.1c3.7 10.6 3.5 21.8 0 31.9l10.7 0c48.6 0 88-39.4 88-88c0-43.6-31.7-79.8-73.3-86.8c5.9-9.7 9.3-21.1 9.3-33.2c0-35.3-28.7-64-64-64l-1.4 0c.9-5.4 1.4-10.9 1.4-16.6c0-48.7-36.1-88.9-83.1-95.2zm45.1 227.4c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7l70.1 0L129.7 488.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7l-70.1 0 52.4-104.8c3.4-6.7 1.6-14.9-4.3-19.6z"
    ]
};
const $d8206b3ab2e65c05$export$9a24e77f74d9cbd9 = $d8206b3ab2e65c05$export$48a38da471b097a2;
const $d8206b3ab2e65c05$export$c8a28356e07b9ccb = {
    prefix: 'fas',
    iconName: 'face-frown-open',
    icon: [
        512,
        512,
        [
            128550,
            "frown-open"
        ],
        "f57a",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-122 174.5c-12.4 5.2-26.5-4.1-21.1-16.4c16-36.6 52.4-62.1 94.8-62.1s78.8 25.6 94.8 62.1c5.4 12.3-8.7 21.6-21.1 16.4c-22.4-9.5-47.4-14.8-73.7-14.8s-51.3 5.3-73.7 14.8z"
    ]
};
const $d8206b3ab2e65c05$export$c4775e66bed5d96 = $d8206b3ab2e65c05$export$c8a28356e07b9ccb;
const $d8206b3ab2e65c05$export$cdc9f5e7e94e76da = {
    prefix: 'fas',
    iconName: 'hand-point-up',
    icon: [
        384,
        512,
        [
            9757
        ],
        "f0a6",
        "M32 32C32 14.3 46.3 0 64 0S96 14.3 96 32l0 208-64 0L32 32zM224 192c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64zm-64-64c17.7 0 32 14.3 32 32l0 48c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-48c0-17.7 14.3-32 32-32zm160 96c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64zm-96 88l0-.6c9.4 5.4 20.3 8.6 32 8.6c13.2 0 25.4-4 35.6-10.8c8.7 24.9 32.5 42.8 60.4 42.8c11.7 0 22.6-3.1 32-8.6l0 8.6c0 88.4-71.6 160-160 160l-61.7 0c-42.4 0-83.1-16.9-113.1-46.9L37.5 453.5C13.5 429.5 0 396.9 0 363l0-27c0-35.3 28.7-64 64-64l88 0c22.1 0 40 17.9 40 40s-17.9 40-40 40l-56 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l56 0c39.8 0 72-32.2 72-72z"
    ]
};
const $d8206b3ab2e65c05$export$608138a7337b5d1a = {
    prefix: 'fas',
    iconName: 'money-bill',
    icon: [
        576,
        512,
        [],
        "f0d6",
        "M64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64zm64 320l-64 0 0-64c35.3 0 64 28.7 64 64zM64 192l0-64 64 0c0 35.3-28.7 64-64 64zM448 384c0-35.3 28.7-64 64-64l0 64-64 0zm64-192c-35.3 0-64-28.7-64-64l64 0 0 64zM288 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
    ]
};
const $d8206b3ab2e65c05$export$4ed9da5c3cca0ef1 = {
    prefix: 'fas',
    iconName: 'bookmark',
    icon: [
        384,
        512,
        [
            128278,
            61591
        ],
        "f02e",
        "M0 48V487.7C0 501.1 10.9 512 24.3 512c5 0 9.9-1.5 14-4.4L192 400 345.7 507.6c4.1 2.9 9 4.4 14 4.4c13.4 0 24.3-10.9 24.3-24.3V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48z"
    ]
};
const $d8206b3ab2e65c05$export$97c42b56d462df72 = {
    prefix: 'fas',
    iconName: 'align-justify',
    icon: [
        448,
        512,
        [],
        "f039",
        "M448 64c0-17.7-14.3-32-32-32L32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32zm0 256c0-17.7-14.3-32-32-32L32 288c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32zM0 192c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 160c-17.7 0-32 14.3-32 32zM448 448c0-17.7-14.3-32-32-32L32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32z"
    ]
};
const $d8206b3ab2e65c05$export$20932e4d438e4e4c = {
    prefix: 'fas',
    iconName: 'umbrella-beach',
    icon: [
        576,
        512,
        [
            127958
        ],
        "f5ca",
        "M346.3 271.8l-60.1-21.9L214 448 32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l512 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-261.9 0 64.1-176.2zm121.1-.2l-3.3 9.1 67.7 24.6c18.1 6.6 38-4.2 39.6-23.4c6.5-78.5-23.9-155.5-80.8-208.5c2 8 3.2 16.3 3.4 24.8l.2 6c1.8 57-7.3 113.8-26.8 167.4zM462 99.1c-1.1-34.4-22.5-64.8-54.4-77.4c-.9-.4-1.9-.7-2.8-1.1c-33-11.7-69.8-2.4-93.1 23.8l-4 4.5C272.4 88.3 245 134.2 226.8 184l-3.3 9.1L434 269.7l3.3-9.1c18.1-49.8 26.6-102.5 24.9-155.5l-.2-6zM107.2 112.9c-11.1 15.7-2.8 36.8 15.3 43.4l71 25.8 3.3-9.1c19.5-53.6 49.1-103 87.1-145.5l4-4.5c6.2-6.9 13.1-13 20.5-18.2c-79.6 2.5-154.7 42.2-201.2 108z"
    ]
};
const $d8206b3ab2e65c05$export$5e975cb293c48461 = {
    prefix: 'fas',
    iconName: 'helmet-un',
    icon: [
        512,
        512,
        [],
        "e503",
        "M479.5 224C471.2 98.9 367.2 0 240 0C107.5 0 0 107.5 0 240l0 56.3C0 344.8 39.2 384 87.7 384L200 384l14.9 0L343.5 505.4c4.5 4.2 10.4 6.6 16.5 6.6l96 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-86.5 0-1.5-1.5L368 288l80 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-.5 0zM320 417.2l-78-73.7L274.4 288l45.6 0 0 129.2zM285.3 103.1l34.7 52 0-43.2c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52 0 43.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM160 112l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
const $d8206b3ab2e65c05$export$554720e3bf74fe90 = {
    prefix: 'fas',
    iconName: 'bullseye',
    icon: [
        512,
        512,
        [],
        "f140",
        "M448 256A192 192 0 1 0 64 256a192 192 0 1 0 384 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 80a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
const $d8206b3ab2e65c05$export$ab07061fe21a3a8e = {
    prefix: 'fas',
    iconName: 'bacon',
    icon: [
        576,
        512,
        [
            129363
        ],
        "f7e5",
        "M439.2 1.2c11.2-3.2 23.2-.1 31.4 8.1L518 56.7l-26.5 7.9c-58 16.6-98.1 39.6-129.6 67.4c-31.2 27.5-53.2 59.1-75.1 90.9l-2.3 3.3C241.6 288.7 195 356.6 72.8 417.7L37.9 435.2 9.4 406.6c-7.3-7.3-10.6-17.6-9-27.8s8.1-18.9 17.3-23.5C136.1 296.2 180.9 231 223.3 169.3l2.3-3.4c21.8-31.8 44.9-64.9 77.7-93.9c33.4-29.5 75.8-53.6 135.9-70.8zM61.8 459l25.4-12.7c129.5-64.7 179.9-138.1 223.8-202l2.2-3.3c22.1-32.1 42.1-60.5 69.9-85.1c27.5-24.3 63.4-45.2 117.3-60.6c0 0 0 0 0 0l.2-.1 43.1-12.9 23 23c8 8 11.2 19.7 8.3 30.7s-11.3 19.6-22.2 22.7c-51.9 14.8-85.6 34.7-111.1 57.2c-26.1 23-45.1 49.9-67.3 82.1l-2.2 3.2C327.8 365.9 275.5 442 142.3 508.6c-12.3 6.2-27.2 3.7-36.9-6L61.8 459z"
    ]
};
const $d8206b3ab2e65c05$export$f6dcbf0a940428f4 = {
    prefix: 'fas',
    iconName: 'hand-point-down',
    icon: [
        384,
        512,
        [],
        "f0a7",
        "M32 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-208-64 0 0 208zM224 320c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64zm-64 64c17.7 0 32-14.3 32-32l0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 48c0 17.7 14.3 32 32 32zm160-96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64zm-96-88l0 .6c9.4-5.4 20.3-8.6 32-8.6c13.2 0 25.4 4 35.6 10.8c8.7-24.9 32.5-42.8 60.4-42.8c11.7 0 22.6 3.1 32 8.6l0-8.6C384 71.6 312.4 0 224 0L162.3 0C119.8 0 79.1 16.9 49.1 46.9L37.5 58.5C13.5 82.5 0 115.1 0 149l0 27c0 35.3 28.7 64 64 64l88 0c22.1 0 40-17.9 40-40s-17.9-40-40-40l-56 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l56 0c39.8 0 72 32.2 72 72z"
    ]
};
const $d8206b3ab2e65c05$export$c2af1be14cd87640 = {
    prefix: 'fas',
    iconName: 'arrow-up-from-bracket',
    icon: [
        448,
        512,
        [],
        "e09a",
        "M246.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 109.3 192 320c0 17.7 14.3 32 32 32s32-14.3 32-32l0-210.7 73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128zM64 352c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-64z"
    ]
};
const $d8206b3ab2e65c05$export$72b780186370e953 = {
    prefix: 'fas',
    iconName: 'folder',
    icon: [
        512,
        512,
        [
            128193,
            128447,
            61716,
            "folder-blank"
        ],
        "f07b",
        "M64 480H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H288c-10.1 0-19.6-4.7-25.6-12.8L243.2 57.6C231.1 41.5 212.1 32 192 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64z"
    ]
};
const $d8206b3ab2e65c05$export$9ef114244d26da0 = $d8206b3ab2e65c05$export$72b780186370e953;
const $d8206b3ab2e65c05$export$5e0c19cf315ac1bf = {
    prefix: 'fas',
    iconName: 'file-waveform',
    icon: [
        448,
        512,
        [
            "file-medical-alt"
        ],
        "f478",
        "M96 0C60.7 0 32 28.7 32 64l0 224 112 0c6.1 0 11.6 3.4 14.3 8.8L176 332.2l49.7-99.4c2.7-5.4 8.3-8.8 14.3-8.8s11.6 3.4 14.3 8.8L281.9 288l70.1 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0c-6.1 0-11.6-3.4-14.3-8.8L240 275.8l-49.7 99.4c-2.7 5.4-8.3 8.8-14.3 8.8s-11.6-3.4-14.3-8.8L134.1 320 32 320l0 128c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L256 0 96 0zM288 0l0 128 128 0L288 0z"
    ]
};
const $d8206b3ab2e65c05$export$ef02a0f5b39aa61f = $d8206b3ab2e65c05$export$5e0c19cf315ac1bf;
const $d8206b3ab2e65c05$export$4c4e509518093d6d = {
    prefix: 'fas',
    iconName: 'radiation',
    icon: [
        512,
        512,
        [],
        "f7b9",
        "M216 186.7c-23.9 13.8-40 39.7-40 69.3L32 256C14.3 256-.2 241.6 2 224.1C10.7 154 47.8 92.7 101.3 52c14.1-10.7 33.8-5.3 42.7 10l72 124.7zM256 336c14.6 0 28.2-3.9 40-10.7l72 124.8c8.8 15.3 3.7 35.1-12.6 41.9c-30.6 12.9-64.2 20-99.4 20s-68.9-7.1-99.4-20c-16.3-6.9-21.4-26.6-12.6-41.9l72-124.8c11.8 6.8 25.4 10.7 40 10.7zm224-80l-144 0c0-29.6-16.1-55.5-40-69.3L368 62c8.8-15.3 28.6-20.7 42.7-10c53.6 40.7 90.6 102 99.4 172.1c2.2 17.5-12.4 31.9-30 31.9zM256 208a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
const $d8206b3ab2e65c05$export$8760a1de19ea40b9 = {
    prefix: 'fas',
    iconName: 'chart-simple',
    icon: [
        448,
        512,
        [],
        "e473",
        "M160 80c0-26.5 21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l0 352c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-352zM0 272c0-26.5 21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48L0 272zM368 96l32 0c26.5 0 48 21.5 48 48l0 288c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-288c0-26.5 21.5-48 48-48z"
    ]
};
const $d8206b3ab2e65c05$export$aa05fce255a5d269 = {
    prefix: 'fas',
    iconName: 'mars-stroke',
    icon: [
        512,
        512,
        [
            9894
        ],
        "f229",
        "M376 0c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l33.4 33.4L370.3 96.4 345 71c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l25.4 25.4L307.8 159c-28.4-19.5-62.7-31-99.8-31c-97.2 0-176 78.8-176 176s78.8 176 176 176s176-78.8 176-176c0-37-11.4-71.4-31-99.8l28.6-28.6L407 201c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-25.4-25.4 22.1-22.1L471 153c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2l0-112c0-13.3-10.7-24-24-24L376 0zm88 48s0 0 0 0s0 0 0 0s0 0 0 0zM96 304a112 112 0 1 1 224 0A112 112 0 1 1 96 304z"
    ]
};
const $d8206b3ab2e65c05$export$aa014b06d2d70598 = {
    prefix: 'fas',
    iconName: 'vial',
    icon: [
        512,
        512,
        [
            129514
        ],
        "f492",
        "M342.6 9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l9.4 9.4L28.1 342.6C10.1 360.6 0 385 0 410.5L0 416c0 53 43 96 96 96l5.5 0c25.5 0 49.9-10.1 67.9-28.1L448 205.3l9.4 9.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-32-32-96-96-32-32zM205.3 256L352 109.3 402.7 160l-96 96-101.5 0z"
    ]
};
const $d8206b3ab2e65c05$export$dbfb0a9f89ad94a4 = {
    prefix: 'fas',
    iconName: 'gauge',
    icon: [
        512,
        512,
        [
            "dashboard",
            "gauge-med",
            "tachometer-alt-average"
        ],
        "f624",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-26.9-16.5-49.9-40-59.3L280 88c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 204.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64s64-28.7 64-64zM144 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-16 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM400 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
const $d8206b3ab2e65c05$export$b7ce24136743d0f1 = $d8206b3ab2e65c05$export$dbfb0a9f89ad94a4;
const $d8206b3ab2e65c05$export$f948a9dd257979f3 = $d8206b3ab2e65c05$export$dbfb0a9f89ad94a4;
const $d8206b3ab2e65c05$export$6f22c345e5a92d1a = $d8206b3ab2e65c05$export$dbfb0a9f89ad94a4;
const $d8206b3ab2e65c05$export$5325fc72e75360b4 = {
    prefix: 'fas',
    iconName: 'wand-magic-sparkles',
    icon: [
        576,
        512,
        [
            "magic-wand-sparkles"
        ],
        "e2ca",
        "M234.7 42.7L197 56.8c-3 1.1-5 4-5 7.2s2 6.1 5 7.2l37.7 14.1L248.8 123c1.1 3 4 5 7.2 5s6.1-2 7.2-5l14.1-37.7L315 71.2c3-1.1 5-4 5-7.2s-2-6.1-5-7.2L277.3 42.7 263.2 5c-1.1-3-4-5-7.2-5s-6.1 2-7.2 5L234.7 42.7zM46.1 395.4c-18.7 18.7-18.7 49.1 0 67.9l34.6 34.6c18.7 18.7 49.1 18.7 67.9 0L529.9 116.5c18.7-18.7 18.7-49.1 0-67.9L495.3 14.1c-18.7-18.7-49.1-18.7-67.9 0L46.1 395.4zM484.6 82.6l-105 105-23.3-23.3 105-105 23.3 23.3zM7.5 117.2C3 118.9 0 123.2 0 128s3 9.1 7.5 10.8L64 160l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L128 160l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L128 96 106.8 39.5C105.1 35 100.8 32 96 32s-9.1 3-10.8 7.5L64 96 7.5 117.2zm352 256c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L416 416l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L480 416l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L480 352l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L416 352l-56.5 21.2z"
    ]
};
const $d8206b3ab2e65c05$export$c93286938249f0da = $d8206b3ab2e65c05$export$5325fc72e75360b4;
const $d8206b3ab2e65c05$export$86923e6fe1b42f5e = {
    prefix: 'fas',
    iconName: 'e',
    icon: [
        320,
        512,
        [
            101
        ],
        "45",
        "M64 32C28.7 32 0 60.7 0 96L0 256 0 416c0 35.3 28.7 64 64 64l224 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L64 416l0-128 160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L64 224 64 96l224 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L64 32z"
    ]
};
const $d8206b3ab2e65c05$export$eff4bdcafd3b8d1c = {
    prefix: 'fas',
    iconName: 'pen-clip',
    icon: [
        512,
        512,
        [
            "pen-alt"
        ],
        "f305",
        "M453.3 19.3l39.4 39.4c25 25 25 65.5 0 90.5l-52.1 52.1s0 0 0 0l-1-1s0 0 0 0l-16-16-96-96-17-17 52.1-52.1c25-25 65.5-25 90.5 0zM241 114.9c-9.4-9.4-24.6-9.4-33.9 0L105 217c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L173.1 81c28.1-28.1 73.7-28.1 101.8 0L288 94.1l17 17 96 96 16 16 1 1-17 17L229.5 412.5c-48 48-109.2 80.8-175.8 94.1l-25 5c-7.9 1.6-16-.9-21.7-6.6s-8.1-13.8-6.6-21.7l5-25c13.3-66.6 46.1-127.8 94.1-175.8L254.1 128 241 114.9z"
    ]
};
const $d8206b3ab2e65c05$export$a3d3e92e430d3beb = $d8206b3ab2e65c05$export$eff4bdcafd3b8d1c;
const $d8206b3ab2e65c05$export$4f25939fdf728c27 = {
    prefix: 'fas',
    iconName: 'bridge-circle-exclamation',
    icon: [
        640,
        512,
        [],
        "e4ca",
        "M64 32C46.3 32 32 46.3 32 64s14.3 32 32 32l40 0 0 64-72 0 0 128c53 0 96 43 96 96l0 64c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-64c0-53 43-96 96-96c6.3 0 12.4 .6 18.3 1.7C367.1 231.8 426.9 192 496 192c42.5 0 81.6 15.1 112 40.2l0-72.2-72 0 0-64 40 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L64 32zM488 96l0 64-80 0 0-64 80 0zM360 96l0 64-80 0 0-64 80 0zM232 96l0 64-80 0 0-64 80 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16z"
    ]
};
const $d8206b3ab2e65c05$export$f5699fa0844e0188 = {
    prefix: 'fas',
    iconName: 'user',
    icon: [
        448,
        512,
        [
            128100,
            62144
        ],
        "f007",
        "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0z"
    ]
};
const $d8206b3ab2e65c05$export$c8c95c2f9937bf6a = {
    prefix: 'fas',
    iconName: 'school-circle-check',
    icon: [
        640,
        512,
        [],
        "e56b",
        "M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96 48 96C21.5 96 0 117.5 0 144L0 464c0 26.5 21.5 48 48 48l272 0s0 0 0 0l-64 0 0-96c0-35.3 28.7-64 64-64l.3 0 .5 0c3.4-37.7 18.7-72.1 42.2-99.1C350.2 260 335.6 264 320 264c-48.6 0-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4c29-21 64.6-33.4 103.1-33.4c59.5 0 112.1 29.6 144 74.8L640 144c0-26.5-21.5-48-48-48L473.7 96 337.8 5.4zM96 192l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zm0 128l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zM320 128c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-16c0-8.8-7.2-16-16-16zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-99.3-43.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7z"
    ]
};
const $d8206b3ab2e65c05$export$3b934e22d1851a3b = {
    prefix: 'fas',
    iconName: 'dumpster',
    icon: [
        576,
        512,
        [],
        "f793",
        "M49.7 32c-10.5 0-19.8 6.9-22.9 16.9L.9 133c-.6 2-.9 4.1-.9 6.1C0 150.7 9.3 160 20.9 160l94 0L140.5 32 49.7 32zM272 160l0-128-98.9 0L147.5 160 272 160zm32 0l124.5 0L402.9 32 304 32l0 128zm157.1 0l94 0c11.5 0 20.9-9.3 20.9-20.9c0-2.1-.3-4.1-.9-6.1L549.2 48.9C546.1 38.9 536.8 32 526.3 32l-90.8 0 25.6 128zM32 192l4 32-4 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l12 0L64 448c0 17.7 14.3 32 32 32s32-14.3 32-32l320 0c0 17.7 14.3 32 32 32s32-14.3 32-32l20-160 12 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-4 0 4-32L32 192z"
    ]
};
const $d8206b3ab2e65c05$export$ecbd233b96906ee1 = {
    prefix: 'fas',
    iconName: 'van-shuttle',
    icon: [
        640,
        512,
        [
            128656,
            "shuttle-van"
        ],
        "f5b6",
        "M64 104l0 88 96 0 0-96L72 96c-4.4 0-8 3.6-8 8zm482 88L465.1 96 384 96l0 96 162 0zm-226 0l0-96-96 0 0 96 96 0zM592 384l-16 0c0 53-43 96-96 96s-96-43-96-96l-128 0c0 53-43 96-96 96s-96-43-96-96l-16 0c-26.5 0-48-21.5-48-48L0 104C0 64.2 32.2 32 72 32l120 0 160 0 113.1 0c18.9 0 36.8 8.3 49 22.8L625 186.5c9.7 11.5 15 26.1 15 41.2L640 336c0 26.5-21.5 48-48 48zm-64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM160 432a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    ]
};
const $d8206b3ab2e65c05$export$9d63d851db698c09 = $d8206b3ab2e65c05$export$ecbd233b96906ee1;
const $d8206b3ab2e65c05$export$d65aef1ed7db1dae = {
    prefix: 'fas',
    iconName: 'building-user',
    icon: [
        640,
        512,
        [],
        "e4da",
        "M48 0C21.5 0 0 21.5 0 48L0 464c0 26.5 21.5 48 48 48l96 0 0-80c0-26.5 21.5-48 48-48s48 21.5 48 48l0 80 89.9 0c-6.3-10.2-9.9-22.2-9.9-35.1c0-46.9 25.8-87.8 64-109.2l0-95.9L384 48c0-26.5-21.5-48-48-48L48 0zM64 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm112-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM80 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM272 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM576 272a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM352 477.1c0 19.3 15.6 34.9 34.9 34.9l218.2 0c19.3 0 34.9-15.6 34.9-34.9c0-51.4-41.7-93.1-93.1-93.1l-101.8 0c-51.4 0-93.1 41.7-93.1 93.1z"
    ]
};
const $d8206b3ab2e65c05$export$2c5163541229363 = {
    prefix: 'fas',
    iconName: 'square-caret-left',
    icon: [
        448,
        512,
        [
            "caret-square-left"
        ],
        "f191",
        "M0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416zM128 256c0-6.7 2.8-13 7.7-17.6l112-104c7-6.5 17.2-8.2 25.9-4.4s14.4 12.5 14.4 22l0 208c0 9.5-5.7 18.2-14.4 22s-18.9 2.1-25.9-4.4l-112-104c-4.9-4.5-7.7-10.9-7.7-17.6z"
    ]
};
const $d8206b3ab2e65c05$export$d0c8ba444f1f9581 = $d8206b3ab2e65c05$export$2c5163541229363;
const $d8206b3ab2e65c05$export$73801ed54b42fabe = {
    prefix: 'fas',
    iconName: 'highlighter',
    icon: [
        576,
        512,
        [],
        "f591",
        "M315 315l158.4-215L444.1 70.6 229 229 315 315zm-187 5s0 0 0 0l0-71.7c0-15.3 7.2-29.6 19.5-38.6L420.6 8.4C428 2.9 437 0 446.2 0c11.4 0 22.4 4.5 30.5 12.6l54.8 54.8c8.1 8.1 12.6 19 12.6 30.5c0 9.2-2.9 18.2-8.4 25.6L334.4 396.5c-9 12.3-23.4 19.5-38.6 19.5L224 416l-25.4 25.4c-12.5 12.5-32.8 12.5-45.3 0l-50.7-50.7c-12.5-12.5-12.5-32.8 0-45.3L128 320zM7 466.3l63-63 70.6 70.6-31 31c-4.5 4.5-10.6 7-17 7L24 512c-13.3 0-24-10.7-24-24l0-4.7c0-6.4 2.5-12.5 7-17z"
    ]
};
const $d8206b3ab2e65c05$export$fa6ecc35e7315db = {
    prefix: 'fas',
    iconName: 'key',
    icon: [
        512,
        512,
        [
            128273
        ],
        "f084",
        "M336 352c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176c0 18.7 2.9 36.8 8.3 53.7L7 391c-4.5 4.5-7 10.6-7 17l0 80c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24l0-40 40 0c13.3 0 24-10.7 24-24l0-40 40 0c6.4 0 12.5-2.5 17-7l33.3-33.3c16.9 5.4 35 8.3 53.7 8.3zM376 96a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"
    ]
};
const $d8206b3ab2e65c05$export$dacae2b4ec565333 = {
    prefix: 'fas',
    iconName: 'bullhorn',
    icon: [
        512,
        512,
        [
            128226,
            128363
        ],
        "f0a1",
        "M480 32c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9L381.7 53c-48 48-113.1 75-181 75l-8.7 0-32 0-96 0c-35.3 0-64 28.7-64 64l0 96c0 35.3 28.7 64 64 64l0 128c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-128 8.7 0c67.9 0 133 27 181 75l43.6 43.6c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6l0-147.6c18.6-8.8 32-32.5 32-60.4s-13.4-51.6-32-60.4L480 32zm-64 76.7L416 240l0 131.3C357.2 317.8 280.5 288 200.7 288l-8.7 0 0-96 8.7 0c79.8 0 156.5-29.8 215.3-83.3z"
    ]
};
const $d8206b3ab2e65c05$export$b1b1cdce4a19c682 = {
    prefix: 'fas',
    iconName: 'globe',
    icon: [
        512,
        512,
        [
            127760
        ],
        "f0ac",
        "M352 256c0 22.2-1.2 43.6-3.3 64l-185.3 0c-2.2-20.4-3.3-41.8-3.3-64s1.2-43.6 3.3-64l185.3 0c2.2 20.4 3.3 41.8 3.3 64zm28.8-64l123.1 0c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64l-123.1 0c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64zm112.6-32l-116.7 0c-10-63.9-29.8-117.4-55.3-151.6c78.3 20.7 142 77.5 171.9 151.6zm-149.1 0l-176.6 0c6.1-36.4 15.5-68.6 27-94.7c10.5-23.6 22.2-40.7 33.5-51.5C239.4 3.2 248.7 0 256 0s16.6 3.2 27.8 13.8c11.3 10.8 23 27.9 33.5 51.5c11.6 26 20.9 58.2 27 94.7zm-209 0L18.6 160C48.6 85.9 112.2 29.1 190.6 8.4C165.1 42.6 145.3 96.1 135.3 160zM8.1 192l123.1 0c-2.1 20.6-3.2 42-3.2 64s1.1 43.4 3.2 64L8.1 320C2.8 299.5 0 278.1 0 256s2.8-43.5 8.1-64zM194.7 446.6c-11.6-26-20.9-58.2-27-94.6l176.6 0c-6.1 36.4-15.5 68.6-27 94.6c-10.5 23.6-22.2 40.7-33.5 51.5C272.6 508.8 263.3 512 256 512s-16.6-3.2-27.8-13.8c-11.3-10.8-23-27.9-33.5-51.5zM135.3 352c10 63.9 29.8 117.4 55.3 151.6C112.2 482.9 48.6 426.1 18.6 352l116.7 0zm358.1 0c-30 74.1-93.6 130.9-171.9 151.6c25.5-34.2 45.2-87.7 55.3-151.6l116.7 0z"
    ]
};
const $d8206b3ab2e65c05$export$20d991385719b5b4 = {
    prefix: 'fas',
    iconName: 'synagogue',
    icon: [
        640,
        512,
        [
            128333
        ],
        "f69b",
        "M309.8 3.7c5.9-4.9 14.6-4.9 20.5 0l121 100.8C469.5 119.7 480 142.2 480 166l0 114.1L480 512l-16 0-112 0 0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96-112 0-16 0 0-231.9L160 166c0-23.7 10.5-46.3 28.8-61.5L309.8 3.7zM512 512l0-267.5 28.1-31.2c3-3.4 7.4-5.3 11.9-5.3s8.9 1.9 11.9 5.3l63.8 70.9c7.9 8.8 12.3 20.3 12.3 32.1L640 448c0 35.3-28.7 64-64 64l-64 0zM128 244.5L128 512l-64 0c-35.3 0-64-28.7-64-64L0 316.3c0-11.9 4.4-23.3 12.3-32.1l63.8-70.9c3-3.4 7.4-5.3 11.9-5.3s8.9 1.9 11.9 5.3L128 244.5zM327 124.3c-3.1-5.4-10.9-5.4-13.9 0l-15.9 28.1-32.3-.3c-6.2-.1-10.1 6.7-7 12.1L274.3 192l-16.4 27.8c-3.2 5.4 .7 12.1 7 12.1l32.3-.3L313 259.7c3.1 5.4 10.9 5.4 13.9 0l15.9-28.1 32.3 .3c6.2 .1 10.1-6.7 7-12.1L365.7 192l16.4-27.8c3.2-5.4-.7-12.1-7-12.1l-32.3 .3L327 124.3z"
    ]
};
const $d8206b3ab2e65c05$export$f3d75c19191f1688 = {
    prefix: 'fas',
    iconName: 'person-half-dress',
    icon: [
        320,
        512,
        [],
        "e548",
        "M160 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm8 352l0-224 6.9 0c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L232 256.9 232 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128s0 0 0 0zM58.2 182.3c19.9-33.1 55.3-53.5 93.8-54.3l0 256s0 0 0 0l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96-17.8 0c-10.9 0-18.6-10.7-15.2-21.1L93.3 248.1 59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l53.6-89.2z"
    ]
};
const $d8206b3ab2e65c05$export$4d6835e7175dec24 = {
    prefix: 'fas',
    iconName: 'road-bridge',
    icon: [
        640,
        512,
        [],
        "e563",
        "M352 0L608 0c17.7 0 32 14.3 32 32l0 448c0 17.7-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32l0-448c0-17.7 14.3-32 32-32zM480 200c-13.3 0-24 10.7-24 24l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64c0-13.3-10.7-24-24-24zm24 184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64zM480 40c-13.3 0-24 10.7-24 24l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64c0-13.3-10.7-24-24-24zM32 96l256 0 0 64-40 0 0 64 40 0 0 96c-53 0-96 43-96 96l0 64c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-64c0-53-43-96-96-96l0-96 72 0 0-64-40 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zm168 64l-80 0 0 64 80 0 0-64z"
    ]
};
const $d8206b3ab2e65c05$export$4ac9c4c370f7b157 = {
    prefix: 'fas',
    iconName: 'location-arrow',
    icon: [
        448,
        512,
        [],
        "f124",
        "M429.6 92.1c4.9-11.9 2.1-25.6-7-34.7s-22.8-11.9-34.7-7l-352 144c-14.2 5.8-22.2 20.8-19.3 35.8s16.1 25.8 31.4 25.8l176 0 0 176c0 15.3 10.8 28.4 25.8 31.4s30-5.1 35.8-19.3l144-352z"
    ]
};
const $d8206b3ab2e65c05$export$a2c1c457834fc6d8 = {
    prefix: 'fas',
    iconName: 'c',
    icon: [
        384,
        512,
        [
            99
        ],
        "43",
        "M329.1 142.9c-62.5-62.5-155.8-62.5-218.3 0s-62.5 163.8 0 226.3s155.8 62.5 218.3 0c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3c-87.5 87.5-221.3 87.5-308.8 0s-87.5-229.3 0-316.8s221.3-87.5 308.8 0c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0z"
    ]
};
const $d8206b3ab2e65c05$export$2d33c367b2b091ac = {
    prefix: 'fas',
    iconName: 'tablet-button',
    icon: [
        448,
        512,
        [],
        "f10a",
        "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zM224 400a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $d8206b3ab2e65c05$export$6f08294ba8a2459c = {
    prefix: 'fas',
    iconName: 'building-lock',
    icon: [
        576,
        512,
        [],
        "e4d6",
        "M48 0C21.5 0 0 21.5 0 48L0 464c0 26.5 21.5 48 48 48l96 0 0-80c0-26.5 21.5-48 48-48s48 21.5 48 48l0 80 88.6 0c-5.4-9.4-8.6-20.3-8.6-32l0-128c0-23.7 12.9-44.4 32-55.4l0-24.6c0-30.5 12.2-58.2 32-78.4L384 48c0-26.5-21.5-48-48-48L48 0zM64 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm112-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM80 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM272 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM464 240c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
const $d8206b3ab2e65c05$export$c9f93c4667edc585 = {
    prefix: 'fas',
    iconName: 'pizza-slice',
    icon: [
        512,
        512,
        [],
        "f818",
        "M169.7 .9c-22.8-1.6-41.9 14-47.5 34.7L110.4 80c.5 0 1.1 0 1.6 0c176.7 0 320 143.3 320 320c0 .5 0 1.1 0 1.6l44.4-11.8c20.8-5.5 36.3-24.7 34.7-47.5C498.5 159.5 352.5 13.5 169.7 .9zM399.8 410.2c.1-3.4 .2-6.8 .2-10.2c0-159.1-128.9-288-288-288c-3.4 0-6.8 .1-10.2 .2L.5 491.9c-1.5 5.5 .1 11.4 4.1 15.4s9.9 5.6 15.4 4.1L399.8 410.2zM176 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM96 384a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
const $d8206b3ab2e65c05$export$53e23123cc9a6796 = {
    prefix: 'fas',
    iconName: 'money-bill-wave',
    icon: [
        576,
        512,
        [],
        "f53a",
        "M0 112.5L0 422.3c0 18 10.1 35 27 41.3c87 32.5 174 10.3 261-11.9c79.8-20.3 159.6-40.7 239.3-18.9c23 6.3 48.7-9.5 48.7-33.4l0-309.9c0-18-10.1-35-27-41.3C462 15.9 375 38.1 288 60.3C208.2 80.6 128.4 100.9 48.7 79.1C25.6 72.8 0 88.6 0 112.5zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96s80 43 80 96s-35.8 96-80 96zM64 352c35.3 0 64 28.7 64 64l-64 0 0-64zm64-208c0 35.3-28.7 64-64 64l0-64 64 0zM512 304l0 64-64 0c0-35.3 28.7-64 64-64zM448 96l64 0 0 64c-35.3 0-64-28.7-64-64z"
    ]
};
const $d8206b3ab2e65c05$export$2acab8312b7a999b = {
    prefix: 'fas',
    iconName: 'chart-area',
    icon: [
        512,
        512,
        [
            "area-chart"
        ],
        "f1fe",
        "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64L0 400c0 44.2 35.8 80 80 80l400 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 416c-8.8 0-16-7.2-16-16L64 64zm96 288l288 0c17.7 0 32-14.3 32-32l0-68.2c0-7.6-2.7-15-7.7-20.8l-65.8-76.8c-12.1-14.2-33.7-15-46.9-1.8l-21 21c-10 10-26.4 9.2-35.4-1.6l-39.2-47c-12.6-15.1-35.7-15.4-48.7-.6L135.9 215c-5.1 5.8-7.9 13.3-7.9 21.1l0 84c0 17.7 14.3 32 32 32z"
    ]
};
const $d8206b3ab2e65c05$export$fc2e595f0e0612cb = $d8206b3ab2e65c05$export$2acab8312b7a999b;
const $d8206b3ab2e65c05$export$9a3d31c75a465b9a = {
    prefix: 'fas',
    iconName: 'house-flag',
    icon: [
        640,
        512,
        [],
        "e50d",
        "M480 0c-17.7 0-32 14.3-32 32l0 160 0 320 64 0 0-320 112 0c8.8 0 16-7.2 16-16l0-128c0-8.8-7.2-16-16-16L512 32c0-17.7-14.3-32-32-32zM416 159L276.8 39.7c-12-10.3-29.7-10.3-41.7 0l-224 192C1 240.4-2.7 254.5 2 267.1S18.6 288 32 288l32 0 0 192c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-96c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 96c0 17.7 14.3 32 32 32l64.7 0 .2 0-1 0 0-353z"
    ]
};
const $d8206b3ab2e65c05$export$d7ccc6651f90f7cc = {
    prefix: 'fas',
    iconName: 'person-circle-minus',
    icon: [
        576,
        512,
        [],
        "e540",
        "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-223.1L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6l29.7 0c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9 232 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128-16 0zm136 16a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 0c0-8.8-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16z"
    ]
};
const $d8206b3ab2e65c05$export$76f704d256def3c7 = {
    prefix: 'fas',
    iconName: 'ban',
    icon: [
        512,
        512,
        [
            128683,
            "cancel"
        ],
        "f05e",
        "M367.2 412.5L99.5 144.8C77.1 176.1 64 214.5 64 256c0 106 86 192 192 192c41.5 0 79.9-13.1 111.2-35.5zm45.3-45.3C434.9 335.9 448 297.5 448 256c0-106-86-192-192-192c-41.5 0-79.9 13.1-111.2 35.5L412.5 367.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
    ]
};
const $d8206b3ab2e65c05$export$6d25ef56192f6d69 = $d8206b3ab2e65c05$export$76f704d256def3c7;
const $d8206b3ab2e65c05$export$e0ce7d1aba7105e7 = {
    prefix: 'fas',
    iconName: 'camera-rotate',
    icon: [
        640,
        512,
        [],
        "e0d8",
        "M213.1 64.8L202.7 96 128 96c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-74.7 0L426.9 64.8C420.4 45.2 402.1 32 381.4 32L258.6 32c-20.7 0-39 13.2-45.5 32.8zM448 256c0 8.8-7.2 16-16 16l-76.7 0c-6.2 0-11.3-5.1-11.3-11.3c0-3 1.2-5.9 3.3-8L371 229c-13.6-13.4-31.9-21-51-21c-19.2 0-37.7 7.6-51.3 21.3L249 249c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l19.7-19.7C257.4 172.7 288 160 320 160c31.8 0 62.4 12.6 85 35l23.7-23.7c2.1-2.1 5-3.3 8-3.3c6.2 0 11.3 5.1 11.3 11.3l0 76.7zM192 320c0-8.8 7.2-16 16-16l76.7 0c6.2 0 11.3 5.1 11.3 11.3c0 3-1.2 5.9-3.3 8L269 347c13.6 13.4 31.9 21 51 21c19.2 0 37.7-7.6 51.3-21.3L391 327c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-19.7 19.7C382.6 403.3 352 416 320 416c-31.8 0-62.4-12.6-85-35l-23.7 23.7c-2.1 2.1-5 3.3-8 3.3c-6.2 0-11.3-5.1-11.3-11.3l0-76.7z"
    ]
};
const $d8206b3ab2e65c05$export$43832c90c10a7a31 = {
    prefix: 'fas',
    iconName: 'spray-can-sparkles',
    icon: [
        512,
        512,
        [
            "air-freshener"
        ],
        "f5d0",
        "M96 32l0 96 128 0 0-96c0-17.7-14.3-32-32-32L128 0C110.3 0 96 14.3 96 32zm0 128c-53 0-96 43-96 96L0 464c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-208c0-53-43-96-96-96L96 160zm64 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM384 48c0-1.4-1-3-2.2-3.6L352 32 339.6 2.2C339 1 337.4 0 336 0s-3 1-3.6 2.2L320 32 290.2 44.4C289 45 288 46.6 288 48c0 1.4 1 3 2.2 3.6L320 64l12.4 29.8C333 95 334.6 96 336 96s3-1 3.6-2.2L352 64l29.8-12.4C383 51 384 49.4 384 48zm76.4 45.8C461 95 462.6 96 464 96s3-1 3.6-2.2L480 64l29.8-12.4C511 51 512 49.4 512 48c0-1.4-1-3-2.2-3.6L480 32 467.6 2.2C467 1 465.4 0 464 0s-3 1-3.6 2.2L448 32 418.2 44.4C417 45 416 46.6 416 48c0 1.4 1 3 2.2 3.6L448 64l12.4 29.8zm7.2 100.4c-.6-1.2-2.2-2.2-3.6-2.2s-3 1-3.6 2.2L448 224l-29.8 12.4c-1.2 .6-2.2 2.2-2.2 3.6c0 1.4 1 3 2.2 3.6L448 256l12.4 29.8c.6 1.2 2.2 2.2 3.6 2.2s3-1 3.6-2.2L480 256l29.8-12.4c1.2-.6 2.2-2.2 2.2-3.6c0-1.4-1-3-2.2-3.6L480 224l-12.4-29.8zM448 144c0-1.4-1-3-2.2-3.6L416 128 403.6 98.2C403 97 401.4 96 400 96s-3 1-3.6 2.2L384 128l-29.8 12.4c-1.2 .6-2.2 2.2-2.2 3.6c0 1.4 1 3 2.2 3.6L384 160l12.4 29.8c.6 1.2 2.2 2.2 3.6 2.2s3-1 3.6-2.2L416 160l29.8-12.4c1.2-.6 2.2-2.2 2.2-3.6z"
    ]
};
const $d8206b3ab2e65c05$export$a5e63e89b5ccee83 = $d8206b3ab2e65c05$export$43832c90c10a7a31;
const $d8206b3ab2e65c05$export$a3b0eb2cd7942125 = {
    prefix: 'fas',
    iconName: 'star',
    icon: [
        576,
        512,
        [
            11088,
            61446
        ],
        "f005",
        "M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
    ]
};
const $d8206b3ab2e65c05$export$cb8434288c91ae83 = {
    prefix: 'fas',
    iconName: 'repeat',
    icon: [
        512,
        512,
        [
            128257
        ],
        "f363",
        "M0 224c0 17.7 14.3 32 32 32s32-14.3 32-32c0-53 43-96 96-96l160 0 0 32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9S320 19.1 320 32l0 32L160 64C71.6 64 0 135.6 0 224zm512 64c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 53-43 96-96 96l-160 0 0-32c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6l0-32 160 0c88.4 0 160-71.6 160-160z"
    ]
};
const $d8206b3ab2e65c05$export$9d0a89fcd084abb = {
    prefix: 'fas',
    iconName: 'cross',
    icon: [
        384,
        512,
        [
            128327,
            10013
        ],
        "f654",
        "M176 0c-26.5 0-48 21.5-48 48l0 80-80 0c-26.5 0-48 21.5-48 48l0 32c0 26.5 21.5 48 48 48l80 0 0 208c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-208 80 0c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48l-80 0 0-80c0-26.5-21.5-48-48-48L176 0z"
    ]
};
const $d8206b3ab2e65c05$export$6e7cf270cda52323 = {
    prefix: 'fas',
    iconName: 'box',
    icon: [
        448,
        512,
        [
            128230
        ],
        "f466",
        "M50.7 58.5L0 160l208 0 0-128L93.7 32C75.5 32 58.9 42.3 50.7 58.5zM240 160l208 0L397.3 58.5C389.1 42.3 372.5 32 354.3 32L240 32l0 128zm208 32L0 192 0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-224z"
    ]
};
const $d8206b3ab2e65c05$export$63f2d9e5f4689aa8 = {
    prefix: 'fas',
    iconName: 'venus-mars',
    icon: [
        640,
        512,
        [
            9892
        ],
        "f228",
        "M176 288a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM352 176c0 86.3-62.1 158.1-144 173.1l0 34.9 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-34.9C62.1 334.1 0 262.3 0 176C0 78.8 78.8 0 176 0s176 78.8 176 176zM271.9 360.6c19.3-10.1 36.9-23.1 52.1-38.4c20 18.5 46.7 29.8 76.1 29.8c61.9 0 112-50.1 112-112s-50.1-112-112-112c-7.2 0-14.3 .7-21.1 2c-4.9-21.5-13-41.7-24-60.2C369.3 66 384.4 64 400 64c37 0 71.4 11.4 99.8 31l20.6-20.6L487 41c-6.9-6.9-8.9-17.2-5.2-26.2S494.3 0 504 0L616 0c13.3 0 24 10.7 24 24l0 112c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-33.4-33.4L545 140.2c19.5 28.4 31 62.7 31 99.8c0 97.2-78.8 176-176 176c-50.5 0-96-21.3-128.1-55.4z"
    ]
};
const $d8206b3ab2e65c05$export$e4f903bc63db445 = {
    prefix: 'fas',
    iconName: 'arrow-pointer',
    icon: [
        320,
        512,
        [
            "mouse-pointer"
        ],
        "f245",
        "M0 55.2L0 426c0 12.2 9.9 22 22 22c6.3 0 12.4-2.7 16.6-7.5L121.2 346l58.1 116.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9L179.8 320l118.1 0c12.2 0 22.1-9.9 22.1-22.1c0-6.3-2.7-12.3-7.4-16.5L38.6 37.9C34.3 34.1 28.9 32 23.2 32C10.4 32 0 42.4 0 55.2z"
    ]
};
const $d8206b3ab2e65c05$export$2e19a69cc26b147 = $d8206b3ab2e65c05$export$e4f903bc63db445;
const $d8206b3ab2e65c05$export$8d2b1b230601e804 = {
    prefix: 'fas',
    iconName: 'maximize',
    icon: [
        512,
        512,
        [
            "expand-arrows-alt"
        ],
        "f31e",
        "M200 32L56 32C42.7 32 32 42.7 32 56l0 144c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l40-40 79 79-79 79L73 295c-6.9-6.9-17.2-8.9-26.2-5.2S32 302.3 32 312l0 144c0 13.3 10.7 24 24 24l144 0c9.7 0 18.5-5.8 22.2-14.8s1.7-19.3-5.2-26.2l-40-40 79-79 79 79-40 40c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8l144 0c13.3 0 24-10.7 24-24l0-144c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2l-40 40-79-79 79-79 40 40c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2l0-144c0-13.3-10.7-24-24-24L312 32c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l40 40-79 79-79-79 40-40c6.9-6.9 8.9-17.2 5.2-26.2S209.7 32 200 32z"
    ]
};
const $d8206b3ab2e65c05$export$6219dcd88b5fa6c2 = $d8206b3ab2e65c05$export$8d2b1b230601e804;
const $d8206b3ab2e65c05$export$bab2cd86f8c65657 = {
    prefix: 'fas',
    iconName: 'charging-station',
    icon: [
        576,
        512,
        [],
        "f5e7",
        "M96 0C60.7 0 32 28.7 32 64l0 384c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-144 16 0c22.1 0 40 17.9 40 40l0 32c0 39.8 32.2 72 72 72s72-32.2 72-72l0-123.7c32.5-10.2 56-40.5 56-76.3l0-32c0-8.8-7.2-16-16-16l-16 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-32 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-16 0c-8.8 0-16 7.2-16 16l0 32c0 35.8 23.5 66.1 56 76.3L472 376c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-32c0-48.6-39.4-88-88-88l-16 0 0-192c0-35.3-28.7-64-64-64L96 0zM216.9 82.7c6 4 8.5 11.5 6.3 18.3l-25 74.9 57.8 0c6.7 0 12.7 4.2 15 10.4s.5 13.3-4.6 17.7l-112 96c-5.5 4.7-13.4 5.1-19.3 1.1s-8.5-11.5-6.3-18.3l25-74.9L96 208c-6.7 0-12.7-4.2-15-10.4s-.5-13.3 4.6-17.7l112-96c5.5-4.7 13.4-5.1 19.3-1.1z"
    ]
};
const $d8206b3ab2e65c05$export$b17d50542d1fc340 = {
    prefix: 'fas',
    iconName: 'shapes',
    icon: [
        512,
        512,
        [
            "triangle-circle-square"
        ],
        "f61f",
        "M315.4 15.5C309.7 5.9 299.2 0 288 0s-21.7 5.9-27.4 15.5l-96 160c-5.9 9.9-6.1 22.2-.4 32.2s16.3 16.2 27.8 16.2l192 0c11.5 0 22.2-6.2 27.8-16.2s5.5-22.3-.4-32.2l-96-160zM288 312l0 144c0 22.1 17.9 40 40 40l144 0c22.1 0 40-17.9 40-40l0-144c0-22.1-17.9-40-40-40l-144 0c-22.1 0-40 17.9-40 40zM128 512a128 128 0 1 0 0-256 128 128 0 1 0 0 256z"
    ]
};
const $d8206b3ab2e65c05$export$34261e5aea24fc1d = $d8206b3ab2e65c05$export$b17d50542d1fc340;
const $d8206b3ab2e65c05$export$ee94b652453ad208 = {
    prefix: 'fas',
    iconName: 'shuffle',
    icon: [
        512,
        512,
        [
            128256,
            "random"
        ],
        "f074",
        "M403.8 34.4c12-5 25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6l0-32-32 0c-10.1 0-19.6 4.7-25.6 12.8L284 229.3 244 176l31.2-41.6C293.3 110.2 321.8 96 352 96l32 0 0-32c0-12.9 7.8-24.6 19.8-29.6zM164 282.7L204 336l-31.2 41.6C154.7 401.8 126.2 416 96 416l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0c10.1 0 19.6-4.7 25.6-12.8L164 282.7zm274.6 188c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6l0-32-32 0c-30.2 0-58.7-14.2-76.8-38.4L121.6 172.8c-6-8.1-15.5-12.8-25.6-12.8l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0c30.2 0 58.7 14.2 76.8 38.4L326.4 339.2c6 8.1 15.5 12.8 25.6 12.8l32 0 0-32c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64z"
    ]
};
const $d8206b3ab2e65c05$export$8357bf8cc666d5f0 = $d8206b3ab2e65c05$export$ee94b652453ad208;
const $d8206b3ab2e65c05$export$f48814ae62850c74 = {
    prefix: 'fas',
    iconName: 'person-running',
    icon: [
        448,
        512,
        [
            127939,
            "running"
        ],
        "f70c",
        "M320 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM125.7 175.5c9.9-9.9 23.4-15.5 37.5-15.5c1.9 0 3.8 .1 5.6 .3L137.6 254c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9-25.4 88.8c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l28.7-100.4c5.9-20.6-2.6-42.6-20.7-53.9L238 299l30.9-82.4 5.1 12.3C289 264.7 323.9 288 362.7 288l21.3 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-21.3 0c-12.9 0-24.6-7.8-29.5-19.7l-6.3-15c-14.6-35.1-44.1-61.9-80.5-73.1l-48.7-15c-11.1-3.4-22.7-5.2-34.4-5.2c-31 0-60.8 12.3-82.7 34.3L57.4 153.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l23.1-23.1zM91.2 352L32 352c-17.7 0-32 14.3-32 32s14.3 32 32 32l69.6 0c19 0 36.2-11.2 43.9-28.5L157 361.6l-9.5-6c-17.5-10.9-30.5-26.8-37.9-44.9L91.2 352z"
    ]
};
const $d8206b3ab2e65c05$export$5dfd1cb43dc9eadb = $d8206b3ab2e65c05$export$f48814ae62850c74;
const $d8206b3ab2e65c05$export$7955f08360418647 = {
    prefix: 'fas',
    iconName: 'mobile-retro',
    icon: [
        320,
        512,
        [],
        "e527",
        "M0 64C0 28.7 28.7 0 64 0L256 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm64 96l0 64c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L96 128c-17.7 0-32 14.3-32 32zM80 352a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM128 48c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0z"
    ]
};
const $d8206b3ab2e65c05$export$523960de087f5198 = {
    prefix: 'fas',
    iconName: 'grip-lines-vertical',
    icon: [
        192,
        512,
        [],
        "f7a5",
        "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64L0 448c0 17.7 14.3 32 32 32s32-14.3 32-32L64 64zm128 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 384c0 17.7 14.3 32 32 32s32-14.3 32-32l0-384z"
    ]
};
const $d8206b3ab2e65c05$export$6daa96b1986e2ef0 = {
    prefix: 'fas',
    iconName: 'spider',
    icon: [
        512,
        512,
        [
            128375
        ],
        "f717",
        "M158.4 32.6c4.8-12.4-1.4-26.3-13.8-31s-26.3 1.4-31 13.8L81.1 100c-7.9 20.7-3 44.1 12.7 59.7l57.4 57.4L70.8 190.3c-2.4-.8-4.3-2.7-5.1-5.1L46.8 128.4C42.6 115.8 29 109 16.4 113.2S-3 131 1.2 143.6l18.9 56.8c5.6 16.7 18.7 29.8 35.4 35.4L116.1 256 55.6 276.2c-16.7 5.6-29.8 18.7-35.4 35.4L1.2 368.4C-3 381 3.8 394.6 16.4 398.8s26.2-2.6 30.4-15.2l18.9-56.8c.8-2.4 2.7-4.3 5.1-5.1l80.4-26.8L93.7 352.3C78.1 368 73.1 391.4 81.1 412l32.5 84.6c4.8 12.4 18.6 18.5 31 13.8s18.5-18.6 13.8-31l-32.5-84.6c-1.1-3-.4-6.3 1.8-8.5L160 353.9c1 52.1 43.6 94.1 96 94.1s95-41.9 96-94.1l32.3 32.3c2.2 2.2 2.9 5.6 1.8 8.5l-32.5 84.6c-4.8 12.4 1.4 26.3 13.8 31s26.3-1.4 31-13.8L430.9 412c7.9-20.7 3-44.1-12.7-59.7l-57.4-57.4 80.4 26.8c2.4 .8 4.3 2.7 5.1 5.1l18.9 56.8c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-18.9-56.8c-5.6-16.7-18.7-29.8-35.4-35.4L395.9 256l60.5-20.2c16.7-5.6 29.8-18.7 35.4-35.4l18.9-56.8c4.2-12.6-2.6-26.2-15.2-30.4s-26.2 2.6-30.4 15.2l-18.9 56.8c-.8 2.4-2.7 4.3-5.1 5.1l-80.4 26.8 57.4-57.4c15.6-15.6 20.6-39 12.7-59.7L398.4 15.4C393.6 3 379.8-3.2 367.4 1.6s-18.5 18.6-13.8 31l32.5 84.6c1.1 3 .4 6.3-1.8 8.5L336 174.1l0-14.1c0-31.8-18.6-59.3-45.5-72.2c-9.1-4.4-18.5 3.3-18.5 13.4l0 10.8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-10.8c0-10.1-9.4-17.7-18.5-13.4C194.6 100.7 176 128.2 176 160l0 14.1-48.3-48.3c-2.2-2.2-2.9-5.6-1.8-8.5l32.5-84.6z"
    ]
};
const $d8206b3ab2e65c05$export$740142a89118fbc0 = {
    prefix: 'fas',
    iconName: 'hands-bound',
    icon: [
        640,
        512,
        [],
        "e4f9",
        "M96 32C96 14.3 81.7 0 64 0S32 14.3 32 32l0 64 0 59.1 0 .7L32 192l0 21.9c0 14.2 5.1 27.9 14.3 38.7L131.6 352l-3.6 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 128 0 64 0 128 0 32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-3.6 0 85.3-99.5c9.2-10.8 14.3-24.5 14.3-38.7l0-21.9 0-36.2 0-.7L608 96l0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64 0 48.8-69.3 92.4c-5.7 7.6-16.1 9.6-24.2 4.8c-9.7-5.7-12.1-18.7-5.1-27.5L473 180c10.8-13.5 8.9-33.3-4.4-44.5s-33-9.8-44.5 3.2l-46.7 52.5C361 209.7 352 233.4 352 258.1l0 61.9 0 32-64 0 0-32 0-61.9c0-24.6-9-48.4-25.4-66.8l-46.7-52.5c-11.5-13-31.3-14.4-44.5-3.2s-15.2 30.9-4.4 44.5l27.6 34.5c7 8.8 4.7 21.8-5.1 27.5c-8.1 4.8-18.6 2.7-24.2-4.8L96 144.8 96 96l0-64zm64 448l0 32 128 0 0-32 64 0 0 32 128 0 0-32 32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0-128 0-64 0-128 0-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0z"
    ]
};
const $d8206b3ab2e65c05$export$a3dced32d48cb1ea = {
    prefix: 'fas',
    iconName: 'file-invoice-dollar',
    icon: [
        384,
        512,
        [],
        "f571",
        "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM64 80c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 96c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16zm128 72c8.8 0 16 7.2 16 16l0 17.3c8.5 1.2 16.7 3.1 24.1 5.1c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-11.1-3-22-5.2-32.1-5.3c-8.4-.1-17.4 1.8-23.6 5.5c-5.7 3.4-8.1 7.3-8.1 12.8c0 3.7 1.3 6.5 7.3 10.1c6.9 4.1 16.6 7.1 29.2 10.9l.5 .1s0 0 0 0s0 0 0 0c11.3 3.4 25.3 7.6 36.3 14.6c12.1 7.6 22.4 19.7 22.7 38.2c.3 19.3-9.6 33.3-22.9 41.6c-7.7 4.8-16.4 7.6-25.1 9.1l0 17.1c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-17.8c-11.2-2.1-21.7-5.7-30.9-8.9c0 0 0 0 0 0c-2.1-.7-4.2-1.4-6.2-2.1c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c2.5 .8 4.8 1.6 7.1 2.4c0 0 0 0 0 0s0 0 0 0s0 0 0 0c13.6 4.6 24.6 8.4 36.3 8.7c9.1 .3 17.9-1.7 23.7-5.3c5.1-3.2 7.9-7.3 7.8-14c-.1-4.6-1.8-7.8-7.7-11.6c-6.8-4.3-16.5-7.4-29-11.2l-1.6-.5s0 0 0 0c-11-3.3-24.3-7.3-34.8-13.7c-12-7.2-22.6-18.9-22.7-37.3c-.1-19.4 10.8-32.8 23.8-40.5c7.5-4.4 15.8-7.2 24.1-8.7l0-17.3c0-8.8 7.2-16 16-16z"
    ]
};
const $d8206b3ab2e65c05$export$f201ba865ea1b8dc = {
    prefix: 'fas',
    iconName: 'plane-circle-exclamation',
    icon: [
        640,
        512,
        [],
        "e556",
        "M256 0c-35 0-64 59.5-64 93.7l0 84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9l0 65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49 0 70.9-57.6 43.2c-4 3-6.4 7.8-6.4 12.8l0 42c0 7.8 6.3 14 14 14c1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3 .4 2.6 .5 3.9 .5c6 0 11.1-3.7 13.1-9C344.5 470.7 320 422.2 320 368c0-60.6 30.6-114 77.1-145.6L320 178.3l0-84.6C320 59.5 292 0 256 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16z"
    ]
};
const $d8206b3ab2e65c05$export$8cf137aceaaf4de0 = {
    prefix: 'fas',
    iconName: 'x-ray',
    icon: [
        512,
        512,
        [],
        "f497",
        "M0 64C0 46.3 14.3 32 32 32l448 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 320c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32L32 96C14.3 96 0 81.7 0 64zM256 96c-8.8 0-16 7.2-16 16l0 32-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0 48-112 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l112 0 0 70.6L189.1 307c-5.2-2-10.6-3-16.2-3l-2.1 0c-23.6 0-42.8 19.2-42.8 42.8c0 9.6 3.2 18.9 9.1 26.4l18.2 23.2c9.7 12.4 24.6 19.6 40.3 19.6l120.8 0c15.7 0 30.6-7.2 40.3-19.6l18.2-23.2c5.9-7.5 9.1-16.8 9.1-26.4c0-23.6-19.2-42.8-42.8-42.8l-2.2 0c-5.5 0-11 1-16.2 3L272 326.6l0-70.6 112 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-112 0 0-48 80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0 0-32c0-8.8-7.2-16-16-16zM208 352a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"
    ]
};
const $d8206b3ab2e65c05$export$761e747b06ed2e1f = {
    prefix: 'fas',
    iconName: 'spell-check',
    icon: [
        576,
        512,
        [],
        "f891",
        "M112 0C99.1 0 87.4 7.8 82.5 19.7l-66.7 160-13.3 32c-6.8 16.3 .9 35 17.2 41.8s35-.9 41.8-17.2L66.7 224l90.7 0 5.1 12.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8l-13.3-32-66.7-160C136.6 7.8 124.9 0 112 0zm18.7 160l-37.3 0L112 115.2 130.7 160zM256 32l0 96 0 96c0 17.7 14.3 32 32 32l80 0c44.2 0 80-35.8 80-80c0-23.1-9.8-43.8-25.4-58.4c6-11.2 9.4-24 9.4-37.6c0-44.2-35.8-80-80-80L288 0c-17.7 0-32 14.3-32 32zm96 64l-32 0 0-32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-32 64l32 0 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0-32zM566.6 310.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L352 434.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l192-192z"
    ]
};
const $d8206b3ab2e65c05$export$f54d004dd5f1cb5e = {
    prefix: 'fas',
    iconName: 'slash',
    icon: [
        640,
        512,
        [],
        "f715",
        "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"
    ]
};
const $d8206b3ab2e65c05$export$72cf138e5ddda6eb = {
    prefix: 'fas',
    iconName: 'computer-mouse',
    icon: [
        384,
        512,
        [
            128433,
            "mouse"
        ],
        "f8cc",
        "M0 192l176 0L176 0 160 0C71.6 0 0 71.6 0 160l0 32zm0 32L0 352c0 88.4 71.6 160 160 160l64 0c88.4 0 160-71.6 160-160l0-128-192 0L0 224zm384-32l0-32C384 71.6 312.4 0 224 0L208 0l0 192 176 0z"
    ]
};
const $d8206b3ab2e65c05$export$198b96b894c66074 = $d8206b3ab2e65c05$export$72cf138e5ddda6eb;
const $d8206b3ab2e65c05$export$a02c5909359525be = {
    prefix: 'fas',
    iconName: 'arrow-right-to-bracket',
    icon: [
        512,
        512,
        [
            "sign-in"
        ],
        "f090",
        "M352 96l64 0c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c53 0 96-43 96-96l0-256c0-53-43-96-96-96l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32zm-9.4 182.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L242.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l210.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"
    ]
};
const $d8206b3ab2e65c05$export$a55eff0ca4f9c3df = $d8206b3ab2e65c05$export$a02c5909359525be;
const $d8206b3ab2e65c05$export$b3d636689da4a3e5 = {
    prefix: 'fas',
    iconName: 'shop-slash',
    icon: [
        640,
        512,
        [
            "store-alt-slash"
        ],
        "e070",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-54.8-43L576 224l-64 0 0 152L384 275.7l0-51.7-64 0 0 1.5L277.2 192l325.9 0c20.3 0 36.8-16.5 36.8-36.8c0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0L121.7 0c-16 0-31 8-39.9 21.4L74.1 32.8 38.8 5.1zM36.8 192l85 0L21 112.5 6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4C0 175.5 16.5 192 36.8 192zM320 384l-192 0 0-160-64 0 0 160 0 80c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-65.5-64-50.4 0 35.9z"
    ]
};
const $d8206b3ab2e65c05$export$b932a586f6ff48b4 = $d8206b3ab2e65c05$export$b3d636689da4a3e5;
const $d8206b3ab2e65c05$export$1bf820d499b6202e = {
    prefix: 'fas',
    iconName: 'server',
    icon: [
        512,
        512,
        [],
        "f233",
        "M64 32C28.7 32 0 60.7 0 96l0 64c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64L64 32zm280 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm48 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM64 288c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64L64 288zm280 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
const $d8206b3ab2e65c05$export$61c2a6b698f55df6 = {
    prefix: 'fas',
    iconName: 'virus-covid-slash',
    icon: [
        640,
        512,
        [],
        "e4a9",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c11.4-19.5 19.1-41.4 22.3-64.7l33.6 0 0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 16-33.6 0c-4.2-30.7-16.3-58.8-34.1-82.3L484 125.9l11.3 11.3c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L472.7 46.7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L450.1 92l-23.8 23.8C402.8 97.9 374.7 85.8 344 81.6L344 48l16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L280 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0 0 33.6c-30.7 4.2-58.8 16.3-82.3 34.1L189.9 92l11.3-11.3c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L134.1 79.8 38.8 5.1zM149.2 213.5c-1.5 6-2.7 12.2-3.5 18.5L112 232l0-16c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16 33.6 0c4.2 30.7 16.3 58.8 34.1 82.3L156 386.1l-11.3-11.3c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l56.6 56.6c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L189.9 420l23.8-23.8c23.5 17.9 51.7 29.9 82.3 34.1l0 33.6-16 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0-33.6c20.4-2.8 39.7-9.1 57.3-18.2L149.2 213.5z"
    ]
};
const $d8206b3ab2e65c05$export$452410c103c2403b = {
    prefix: 'fas',
    iconName: 'shop-lock',
    icon: [
        640,
        512,
        [],
        "e4a5",
        "M36.8 192l412.8 0c20.2-19.8 47.9-32 78.4-32c30.5 0 58.1 12.2 78.3 31.9c18.9-1.6 33.7-17.4 33.7-36.7c0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0L121.7 0c-16 0-31 8-39.9 21.4L6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4C0 175.5 16.5 192 36.8 192zM384 224l-64 0 0 160-192 0 0-160-64 0 0 160 0 80c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-80 0-32 0-128zm144 16c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
const $d8206b3ab2e65c05$export$f0c28584caa8f4b = {
    prefix: 'fas',
    iconName: 'hourglass-start',
    icon: [
        384,
        512,
        [
            "hourglass-1"
        ],
        "f251",
        "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64l0 11c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9C48.9 353.9 32 394.6 32 437l0 11c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 256 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-11c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1l0-11c17.7 0 32-14.3 32-32s-14.3-32-32-32L320 0 64 0 32 0zM288 437l0 11L96 448l0-11c0-25.5 10.1-49.9 28.1-67.9L192 301.3l67.9 67.9c18 18 28.1 42.4 28.1 67.9z"
    ]
};
const $d8206b3ab2e65c05$export$87929336ab5c59cd = $d8206b3ab2e65c05$export$f0c28584caa8f4b;
const $d8206b3ab2e65c05$export$f35a116a762ef8fc = {
    prefix: 'fas',
    iconName: 'blender-phone',
    icon: [
        576,
        512,
        [],
        "f6b6",
        "M224 352L196.8 52.3C194.2 24.2 216.3 0 244.6 0L534.1 0c21.1 0 36.4 20.1 30.9 40.4L558.5 64 400 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l149.8 0-17.5 64L400 160c-8.8 0-16 7.2-16 16s7.2 16 16 16l123.6 0-17.5 64L400 256c-8.8 0-16 7.2-16 16s7.2 16 16 16l97.5 0L480 352l-256 0zm-16 32l288 0c26.5 0 48 21.5 48 48l0 32c0 26.5-21.5 48-48 48l-288 0c-26.5 0-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48zm144 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM147.5 30.7c10.8 6.7 15.3 21 10.6 33.4l-22 57.8c-4.2 10.9-14.5 17.6-25.3 16.4l-33.3-3.6c-13.6 42.2-13.6 88.4 0 130.7l33.3-3.6c10.9-1.2 21.2 5.5 25.3 16.4l22 57.8c4.7 12.4 .2 26.7-10.6 33.4l-44 27.2c-9.7 6-21.9 4.2-29.8-4.3C-24.6 286-24.6 114 73.7 7.8C81.6-.7 93.8-2.5 103.5 3.5l44 27.2z"
    ]
};
const $d8206b3ab2e65c05$export$6c0cfe6d58faf860 = {
    prefix: 'fas',
    iconName: 'building-wheat',
    icon: [
        640,
        512,
        [],
        "e4db",
        "M0 48C0 21.5 21.5 0 48 0L336 0c26.5 0 48 21.5 48 48l0 416c0 26.5-21.5 48-48 48l-96 0 0-80c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 80-96 0c-26.5 0-48-21.5-48-48L0 48zM80 224c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm80 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM64 112l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16L80 96c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm80 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm384 80l0 16c0 44.2-35.8 80-80 80l-16 0 0-16c0-44.2 35.8-80 80-80l16 0zm0 128c0 44.2-35.8 80-80 80l-16 0 0-16c0-44.2 35.8-80 80-80l16 0 0 16zm0 112c0 44.2-35.8 80-80 80l-16 0 0-16c0-44.2 35.8-80 80-80l16 0 0 16zM512 496l0 16-16 0c-44.2 0-80-35.8-80-80l0-16 16 0c44.2 0 80 35.8 80 80zm0-96l-16 0c-44.2 0-80-35.8-80-80l0-16 16 0c44.2 0 80 35.8 80 80l0 16zm0-128l0 16-16 0c-44.2 0-80-35.8-80-80l0-16 16 0c44.2 0 80 35.8 80 80zM528 32c13.3 0 24 10.7 24 24l0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104c0-13.3 10.7-24 24-24zm96 64l0 32c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-32c0-13.3 10.7-24 24-24s24 10.7 24 24zM456 72c13.3 0 24 10.7 24 24l0 32c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-32c0-13.3 10.7-24 24-24z"
    ]
};
const $d8206b3ab2e65c05$export$9b94ed8d16d281f9 = {
    prefix: 'fas',
    iconName: 'person-breastfeeding',
    icon: [
        448,
        512,
        [],
        "e53a",
        "M224 0a80 80 0 1 1 0 160A80 80 0 1 1 224 0zM436.8 382.8L373.5 462c-16.6 20.7-46.8 24.1-67.5 7.5c-17.6-14.1-22.7-38.1-13.5-57.7l-.8-.1c-38.9-5.6-74.3-25.1-99.7-54.8l0-36.8c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 48c0 .8 0 1.6 .1 2.4l101.4 50.7c23.7 11.9 33.3 40.7 21.5 64.4s-40.7 33.3-64.4 21.5L27.2 427.3c-1.1-.5-2.2-1.1-3.3-1.7c-4.9-2.8-9.2-6.4-12.6-10.6c-4.6-5.4-7.8-11.7-9.6-18.4c-3.3-12-1.9-25.2 4.8-36.6c.6-1.1 1.3-2.2 2-3.2L75.6 256.1c26.7-40.1 71.7-64.1 119.8-64.1l75.2 0c46.5 0 90.1 22.5 117.2 60.3l50.7 70.9c2.2 3 4 6.1 5.5 9.4c2.9 6.7 4.3 13.8 4 20.8c-.3 10.6-4.2 21-11.2 29.4zM320 332a44 44 0 1 0 -88 0 44 44 0 1 0 88 0z"
    ]
};
const $d8206b3ab2e65c05$export$a5fd2acfcb5247c6 = {
    prefix: 'fas',
    iconName: 'right-to-bracket',
    icon: [
        512,
        512,
        [
            "sign-in-alt"
        ],
        "f2f6",
        "M217.9 105.9L340.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L217.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1L32 320c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM352 416l64 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0c53 0 96 43 96 96l0 256c0 53-43 96-96 96l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
const $d8206b3ab2e65c05$export$e6709746115bd2ea = $d8206b3ab2e65c05$export$a5fd2acfcb5247c6;
const $d8206b3ab2e65c05$export$f89d028573ffc0a6 = {
    prefix: 'fas',
    iconName: 'venus',
    icon: [
        384,
        512,
        [
            9792
        ],
        "f221",
        "M80 176a112 112 0 1 1 224 0A112 112 0 1 1 80 176zM224 349.1c81.9-15 144-86.8 144-173.1C368 78.8 289.2 0 192 0S16 78.8 16 176c0 86.3 62.1 158.1 144 173.1l0 34.9-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-34.9z"
    ]
};
const $d8206b3ab2e65c05$export$2c31ca0d9bee400f = {
    prefix: 'fas',
    iconName: 'passport',
    icon: [
        448,
        512,
        [],
        "f5ab",
        "M0 64C0 28.7 28.7 0 64 0L384 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM183 278.8c-27.9-13.2-48.4-39.4-53.7-70.8l39.1 0c1.6 30.4 7.7 53.8 14.6 70.8zm41.3 9.2l-.3 0-.3 0c-2.4-3.5-5.7-8.9-9.1-16.5c-6-13.6-12.4-34.3-14.2-63.5l47.1 0c-1.8 29.2-8.1 49.9-14.2 63.5c-3.4 7.6-6.7 13-9.1 16.5zm40.7-9.2c6.8-17.1 12.9-40.4 14.6-70.8l39.1 0c-5.3 31.4-25.8 57.6-53.7 70.8zM279.6 176c-1.6-30.4-7.7-53.8-14.6-70.8c27.9 13.2 48.4 39.4 53.7 70.8l-39.1 0zM223.7 96l.3 0 .3 0c2.4 3.5 5.7 8.9 9.1 16.5c6 13.6 12.4 34.3 14.2 63.5l-47.1 0c1.8-29.2 8.1-49.9 14.2-63.5c3.4-7.6 6.7-13 9.1-16.5zM183 105.2c-6.8 17.1-12.9 40.4-14.6 70.8l-39.1 0c5.3-31.4 25.8-57.6 53.7-70.8zM352 192A128 128 0 1 0 96 192a128 128 0 1 0 256 0zM112 384c-8.8 0-16 7.2-16 16s7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-224 0z"
    ]
};
const $d8206b3ab2e65c05$export$e1ef956136031821 = {
    prefix: 'fas',
    iconName: 'thumbtack-slash',
    icon: [
        640,
        512,
        [
            "thumb-tack-slash"
        ],
        "e68f",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L481.4 352c9.8-.4 18.9-5.3 24.6-13.3c6-8.3 7.7-19.1 4.4-28.8l-1-3c-13.8-41.5-42.8-74.8-79.5-94.7L418.5 64 448 64c17.7 0 32-14.3 32-32s-14.3-32-32-32L192 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l29.5 0-6.1 79.5L38.8 5.1zM324.9 352L177.1 235.6c-20.9 18.9-37.2 43.3-46.5 71.3l-1 3c-3.3 9.8-1.6 20.5 4.4 28.8s15.7 13.3 26 13.3l164.9 0zM288 384l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96-64 0z"
    ]
};
const $d8206b3ab2e65c05$export$e7a52e4a0831fa96 = $d8206b3ab2e65c05$export$e1ef956136031821;
const $d8206b3ab2e65c05$export$a6d8e50dcd4b4294 = {
    prefix: 'fas',
    iconName: 'heart-pulse',
    icon: [
        512,
        512,
        [
            "heartbeat"
        ],
        "f21e",
        "M228.3 469.1L47.6 300.4c-4.2-3.9-8.2-8.1-11.9-12.4l87 0c22.6 0 43-13.6 51.7-34.5l10.5-25.2 49.3 109.5c3.8 8.5 12.1 14 21.4 14.1s17.8-5 22-13.3L320 253.7l1.7 3.4c9.5 19 28.9 31 50.1 31l104.5 0c-3.7 4.3-7.7 8.5-11.9 12.4L283.7 469.1c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9zM503.7 240l-132 0c-3 0-5.8-1.7-7.2-4.4l-23.2-46.3c-4.1-8.1-12.4-13.3-21.5-13.3s-17.4 5.1-21.5 13.3l-41.4 82.8L205.9 158.2c-3.9-8.7-12.7-14.3-22.2-14.1s-18.1 5.9-21.8 14.8l-31.8 76.3c-1.2 3-4.2 4.9-7.4 4.9L16 240c-2.6 0-5 .4-7.3 1.1C3 225.2 0 208.2 0 190.9l0-5.8c0-69.9 50.5-129.5 119.4-141C165 36.5 211.4 51.4 244 84l12 12 12-12c32.6-32.6 79-47.5 124.6-39.9C461.5 55.6 512 115.2 512 185.1l0 5.8c0 16.9-2.8 33.5-8.3 49.1z"
    ]
};
const $d8206b3ab2e65c05$export$ca880e19206e80aa = $d8206b3ab2e65c05$export$a6d8e50dcd4b4294;
const $d8206b3ab2e65c05$export$7754cc6d5559ff38 = {
    prefix: 'fas',
    iconName: 'people-carry-box',
    icon: [
        640,
        512,
        [
            "people-carry"
        ],
        "f4ce",
        "M80 48a48 48 0 1 1 96 0A48 48 0 1 1 80 48zm64 193.7l0 65.1 51 51c7.1 7.1 11.8 16.2 13.4 26.1l15.2 90.9c2.9 17.4-8.9 33.9-26.3 36.8s-33.9-8.9-36.8-26.3l-14.3-85.9L66.8 320C54.8 308 48 291.7 48 274.7l0-88.1c0-32.4 26.2-58.6 58.6-58.6c24.1 0 46.5 12 59.9 32l47.4 71.1 10.1 5 0-76.2c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 76.2 10.1-5L473.5 160c13.3-20 35.8-32 59.9-32c32.4 0 58.6 26.2 58.6 58.6l0 88.1c0 17-6.7 33.3-18.7 45.3l-79.4 79.4-14.3 85.9c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l15.2-90.9c1.6-9.9 6.3-19 13.4-26.1l51-51 0-65.1-19 28.5c-4.6 7-11 12.6-18.5 16.3l-59.6 29.8c-2.4 1.3-4.9 2.2-7.6 2.8c-2.6 .6-5.3 .9-7.9 .8l-126.7 0c-2.5 .1-5-.2-7.5-.7c-2.9-.6-5.6-1.6-8.1-3l-59.5-29.8c-7.5-3.7-13.8-9.4-18.5-16.3l-19-28.5zM2.3 468.1L50.1 348.6l49.2 49.2-37.6 94c-6.6 16.4-25.2 24.4-41.6 17.8S-4.3 484.5 2.3 468.1zM512 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm77.9 348.6l47.8 119.5c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8l-37.6-94 49.2-49.2z"
    ]
};
const $d8206b3ab2e65c05$export$35fbd4ff1265acd5 = $d8206b3ab2e65c05$export$7754cc6d5559ff38;
const $d8206b3ab2e65c05$export$15d012277c3ecf9a = {
    prefix: 'fas',
    iconName: 'temperature-high',
    icon: [
        512,
        512,
        [],
        "f769",
        "M416 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 128A96 96 0 1 0 416 0a96 96 0 1 0 0 192zM96 112c0-26.5 21.5-48 48-48s48 21.5 48 48l0 164.5c0 17.3 7.1 31.9 15.3 42.5C217.8 332.6 224 349.5 224 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9C88.9 308.4 96 293.8 96 276.5L96 112zM144 0C82.1 0 32 50.2 32 112l0 164.4c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C11.2 304.2 0 334.8 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6L256 112C256 50.2 205.9 0 144 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3L160 112c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 210.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48z"
    ]
};
const $d8206b3ab2e65c05$export$4a7bb4be15f35178 = {
    prefix: 'fas',
    iconName: 'microchip',
    icon: [
        512,
        512,
        [],
        "f2db",
        "M176 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c-35.3 0-64 28.7-64 64l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 56-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 56-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0c0 35.3 28.7 64 64 64l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 56 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 56 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40c35.3 0 64-28.7 64-64l40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-56 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-56 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0c0-35.3-28.7-64-64-64l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-56 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-56 0 0-40zM160 128l192 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32l0-192c0-17.7 14.3-32 32-32zm192 32l-192 0 0 192 192 0 0-192z"
    ]
};
const $d8206b3ab2e65c05$export$dc1083dcd1d7b9d6 = {
    prefix: 'fas',
    iconName: 'crown',
    icon: [
        576,
        512,
        [
            128081
        ],
        "f521",
        "M309 106c11.4-7 19-19.7 19-34c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34L209.7 220.6c-9.1 18.2-32.7 23.4-48.6 10.7L72 160c5-6.7 8-15 8-24c0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40c.2 0 .5 0 .7 0L86.4 427.4c5.5 30.4 32 52.6 63 52.6l277.2 0c30.9 0 57.4-22.1 63-52.6L535.3 176c.2 0 .5 0 .7 0c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 9 3 17.3 8 24l-89.1 71.3c-15.9 12.7-39.5 7.5-48.6-10.7L309 106z"
    ]
};
const $d8206b3ab2e65c05$export$43d1fa6671908715 = {
    prefix: 'fas',
    iconName: 'weight-hanging',
    icon: [
        512,
        512,
        [],
        "f5cd",
        "M224 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm122.5 32c3.5-10 5.5-20.8 5.5-32c0-53-43-96-96-96s-96 43-96 96c0 11.2 1.9 22 5.5 32L120 128c-22 0-41.2 15-46.6 36.4l-72 288c-3.6 14.3-.4 29.5 8.7 41.2S33.2 512 48 512l416 0c14.8 0 28.7-6.8 37.8-18.5s12.3-26.8 8.7-41.2l-72-288C433.2 143 414 128 392 128l-45.5 0z"
    ]
};
const $d8206b3ab2e65c05$export$f4595f012786d346 = {
    prefix: 'fas',
    iconName: 'xmarks-lines',
    icon: [
        640,
        512,
        [],
        "e59a",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l576 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32zm0 384c-17.7 0-32 14.3-32 32s14.3 32 32 32l576 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 416zM7 167c-9.4 9.4-9.4 24.6 0 33.9l55 55L7 311c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55L41 167c-9.4-9.4-24.6-9.4-33.9 0zM265 167c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l55 55-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55-55-55zM455 167c-9.4 9.4-9.4 24.6 0 33.9l55 55-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55-55-55c-9.4-9.4-24.6-9.4-33.9 0z"
    ]
};
const $d8206b3ab2e65c05$export$a20cb90865b6beb8 = {
    prefix: 'fas',
    iconName: 'file-prescription',
    icon: [
        384,
        512,
        [],
        "f572",
        "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM104 196l72 0c33.1 0 60 26.9 60 60c0 25.5-15.9 47.2-38.3 55.9l43 40.3 33.8-31c8.1-7.5 20.8-6.9 28.3 1.2s6.9 20.8-1.2 28.3L270 379.7l31.7 29.7c8.1 7.6 8.5 20.2 .9 28.3s-20.2 8.5-28.3 .9l-33.9-31.8-34.9 32c-8.1 7.5-20.8 6.9-28.3-1.2s-6.9-20.8 1.2-28.3l32.6-29.9-64.8-60.8c-.9-.8-1.6-1.7-2.3-2.6l-20 0 0 44c0 11-9 20-20 20s-20-9-20-20l0-64 0-80c0-11 9-20 20-20zm72 80c11 0 20-9 20-20s-9-20-20-20l-52 0 0 40 52 0z"
    ]
};
const $d8206b3ab2e65c05$export$e521c542d18b85c3 = {
    prefix: 'fas',
    iconName: 'weight-scale',
    icon: [
        512,
        512,
        [
            "weight"
        ],
        "f496",
        "M128 176a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zM391.8 64C359.5 24.9 310.7 0 256 0S152.5 24.9 120.2 64L64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-56.2 0zM296 224c0-10.6-4.1-20.2-10.9-27.4l33.6-78.3c3.5-8.1-.3-17.5-8.4-21s-17.5 .3-21 8.4L255.7 184c-22 .1-39.7 18-39.7 40c0 22.1 17.9 40 40 40s40-17.9 40-40z"
    ]
};
const $d8206b3ab2e65c05$export$cf3bafa68a60bae4 = $d8206b3ab2e65c05$export$e521c542d18b85c3;
const $d8206b3ab2e65c05$export$3d626cfc365a7e36 = {
    prefix: 'fas',
    iconName: 'user-group',
    icon: [
        640,
        512,
        [
            128101,
            "user-friends"
        ],
        "f500",
        "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3zM609.3 512l-137.8 0c5.4-9.4 8.6-20.3 8.6-32l0-8c0-60.7-27.1-115.2-69.8-151.8c2.4-.1 4.7-.2 7.1-.2l61.4 0C567.8 320 640 392.2 640 481.3c0 17-13.8 30.7-30.7 30.7zM432 256c-31 0-59-12.6-79.3-32.9C372.4 196.5 384 163.6 384 128c0-26.8-6.6-52.1-18.3-74.3C384.3 40.1 407.2 32 432 32c61.9 0 112 50.1 112 112s-50.1 112-112 112z"
    ]
};
const $d8206b3ab2e65c05$export$46073bec205635d9 = $d8206b3ab2e65c05$export$3d626cfc365a7e36;
const $d8206b3ab2e65c05$export$fb00fdd8857804c7 = {
    prefix: 'fas',
    iconName: 'arrow-up-a-z',
    icon: [
        576,
        512,
        [
            "sort-alpha-up"
        ],
        "f15e",
        "M183.6 42.4C177.5 35.8 169 32 160 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L128 146.3 128 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-301.7 32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 320c0 17.7 14.3 32 32 32l50.7 0-73.4 73.4c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-50.7 0 73.4-73.4c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8l-128 0c-17.7 0-32 14.3-32 32zM416 32c-12.1 0-23.2 6.8-28.6 17.7l-64 128-16 32c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l7.2-14.3 88.4 0 7.2 14.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9l-16-32-64-128C439.2 38.8 428.1 32 416 32zM395.8 176L416 135.6 436.2 176l-40.4 0z"
    ]
};
const $d8206b3ab2e65c05$export$3c4115b156be730d = $d8206b3ab2e65c05$export$fb00fdd8857804c7;
const $d8206b3ab2e65c05$export$861b1f13085cf122 = {
    prefix: 'fas',
    iconName: 'chess-knight',
    icon: [
        448,
        512,
        [
            9822
        ],
        "f441",
        "M96 48L82.7 61.3C70.7 73.3 64 89.5 64 106.5l0 132.4c0 10.7 5.3 20.7 14.2 26.6l10.6 7c14.3 9.6 32.7 10.7 48.1 3l3.2-1.6c2.6-1.3 5-2.8 7.3-4.5l49.4-37c6.6-5 15.7-5 22.3 0c10.2 7.7 9.9 23.1-.7 30.3L90.4 350C73.9 361.3 64 380 64 400l320 0 28.9-159c2.1-11.3 3.1-22.8 3.1-34.3l0-14.7C416 86 330 0 224 0L83.8 0C72.9 0 64 8.9 64 19.8c0 7.5 4.2 14.3 10.9 17.7L96 48zm24 68a20 20 0 1 1 40 0 20 20 0 1 1 -40 0zM22.6 473.4c-4.2 4.2-6.6 10-6.6 16C16 501.9 26.1 512 38.6 512l370.7 0c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L384 432 64 432 22.6 473.4z"
    ]
};
const $d8206b3ab2e65c05$export$67ca89c1ca38d559 = {
    prefix: 'fas',
    iconName: 'face-laugh-squint',
    icon: [
        512,
        512,
        [
            "laugh-squint"
        ],
        "f59b",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1l275.2 0c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zm36.7-199.4l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 125.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
    ]
};
const $d8206b3ab2e65c05$export$b206e700cf7084e1 = $d8206b3ab2e65c05$export$67ca89c1ca38d559;
const $d8206b3ab2e65c05$export$76a9413fbe130a53 = {
    prefix: 'fas',
    iconName: 'wheelchair',
    icon: [
        512,
        512,
        [],
        "f193",
        "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM120.5 247.2c12.4-4.7 18.7-18.5 14-30.9s-18.5-18.7-30.9-14C43.1 225.1 0 283.5 0 352c0 88.4 71.6 160 160 160c61.2 0 114.3-34.3 141.2-84.7c6.2-11.7 1.8-26.2-9.9-32.5s-26.2-1.8-32.5 9.9C240 440 202.8 464 160 464C98.1 464 48 413.9 48 352c0-47.9 30.1-88.8 72.5-104.8zM259.8 176l-1.9-9.7c-4.5-22.3-24-38.3-46.8-38.3c-30.1 0-52.7 27.5-46.8 57l23.1 115.5c6 29.9 32.2 51.4 62.8 51.4l5.1 0c.4 0 .8 0 1.3 0l94.1 0c6.7 0 12.6 4.1 15 10.4L402 459.2c6 16.1 23.8 24.6 40.1 19.1l48-16c16.8-5.6 25.8-23.7 20.2-40.5s-23.7-25.8-40.5-20.2l-18.7 6.2-25.5-68c-11.7-31.2-41.6-51.9-74.9-51.9l-68.5 0-9.6-48 63.4 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-76.2 0z"
    ]
};
const $d8206b3ab2e65c05$export$a29c8ea43e92771d = {
    prefix: 'fas',
    iconName: 'circle-arrow-up',
    icon: [
        512,
        512,
        [
            "arrow-circle-up"
        ],
        "f0aa",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM385 215c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-71-71L280 392c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-214.1-71 71c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 103c9.4-9.4 24.6-9.4 33.9 0L385 215z"
    ]
};
const $d8206b3ab2e65c05$export$a2f6f3baa50af0b1 = $d8206b3ab2e65c05$export$a29c8ea43e92771d;
const $d8206b3ab2e65c05$export$5cffc34afa81e517 = {
    prefix: 'fas',
    iconName: 'toggle-on',
    icon: [
        576,
        512,
        [],
        "f205",
        "M192 64C86 64 0 150 0 256S86 448 192 448l192 0c106 0 192-86 192-192s-86-192-192-192L192 64zm192 96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
    ]
};
const $d8206b3ab2e65c05$export$6af1cc5998ca52bc = {
    prefix: 'fas',
    iconName: 'person-walking',
    icon: [
        320,
        512,
        [
            128694,
            "walking"
        ],
        "f554",
        "M160 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM126.5 199.3c-1 .4-1.9 .8-2.9 1.2l-8 3.5c-16.4 7.3-29 21.2-34.7 38.2l-2.6 7.8c-5.6 16.8-23.7 25.8-40.5 20.2s-25.8-23.7-20.2-40.5l2.6-7.8c11.4-34.1 36.6-61.9 69.4-76.5l8-3.5c20.8-9.2 43.3-14 66.1-14c44.6 0 84.8 26.8 101.9 67.9L281 232.7l21.4 10.7c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L247 287.3c-10.3-5.2-18.4-13.8-22.8-24.5l-9.6-23-19.3 65.5 49.5 54c5.4 5.9 9.2 13 11.2 20.8l23 92.1c4.3 17.1-6.1 34.5-23.3 38.8s-34.5-6.1-38.8-23.3l-22-88.1-70.7-77.1c-14.8-16.1-20.3-38.6-14.7-59.7l16.9-63.5zM68.7 398l25-62.4c2.1 3 4.5 5.8 7 8.6l40.7 44.4-14.5 36.2c-2.4 6-6 11.5-10.6 16.1L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L68.7 398z"
    ]
};
const $d8206b3ab2e65c05$export$4886811b7174ec35 = $d8206b3ab2e65c05$export$6af1cc5998ca52bc;
const $d8206b3ab2e65c05$export$be32b10ce70a09df = {
    prefix: 'fas',
    iconName: 'l',
    icon: [
        320,
        512,
        [
            108
        ],
        "4c",
        "M64 32c17.7 0 32 14.3 32 32l0 352 192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32z"
    ]
};
const $d8206b3ab2e65c05$export$7b24b34ef6cc130c = {
    prefix: 'fas',
    iconName: 'fire',
    icon: [
        448,
        512,
        [
            128293
        ],
        "f06d",
        "M159.3 5.4c7.8-7.3 19.9-7.2 27.7 .1c27.6 25.9 53.5 53.8 77.7 84c11-14.4 23.5-30.1 37-42.9c7.9-7.4 20.1-7.4 28 .1c34.6 33 63.9 76.6 84.5 118c20.3 40.8 33.8 82.5 33.8 111.9C448 404.2 348.2 512 224 512C98.4 512 0 404.1 0 276.5c0-38.4 17.8-85.3 45.4-131.7C73.3 97.7 112.7 48.6 159.3 5.4zM225.7 416c25.3 0 47.7-7 68.8-21c42.1-29.4 53.4-88.2 28.1-134.4c-4.5-9-16-9.6-22.5-2l-25.2 29.3c-6.6 7.6-18.5 7.4-24.7-.5c-16.5-21-46-58.5-62.8-79.8c-6.3-8-18.3-8.1-24.7-.1c-33.8 42.5-50.8 69.3-50.8 99.4C112 375.4 162.6 416 225.7 416z"
    ]
};
const $d8206b3ab2e65c05$export$580ae0d0bbd809fb = {
    prefix: 'fas',
    iconName: 'bed-pulse',
    icon: [
        640,
        512,
        [
            "procedures"
        ],
        "f487",
        "M483.2 9.6L524 64l92 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-104 0c-7.6 0-14.7-3.6-19.2-9.6L468.7 70.3l-47 99.9c-3.7 7.8-11.3 13.1-19.9 13.7s-16.9-3.4-21.7-10.6L339.2 112 216 112c-13.3 0-24-10.7-24-24s10.7-24 24-24l136 0c8 0 15.5 4 20 10.7l24.4 36.6 45.9-97.5C445.9 6.2 453.2 1 461.6 .1s16.6 2.7 21.6 9.5zM320 160l12.7 0 20.7 31.1c11.2 16.8 30.6 26.3 50.7 24.8s37.9-13.7 46.5-32L461.9 160l82.1 0c53 0 96 43 96 96l0 224c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-224 0-32 0L64 448l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 96C0 78.3 14.3 64 32 64s32 14.3 32 32l0 256 224 0 0-160c0-17.7 14.3-32 32-32zm-144 0a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
    ]
};
const $d8206b3ab2e65c05$export$5f9e1870e1866dde = $d8206b3ab2e65c05$export$580ae0d0bbd809fb;
const $d8206b3ab2e65c05$export$76d92e7f30d064c5 = {
    prefix: 'fas',
    iconName: 'shuttle-space',
    icon: [
        640,
        512,
        [
            "space-shuttle"
        ],
        "f197",
        "M130 480c40.6 0 80.4-11 115.2-31.9L352 384l-224 0 0 96 2 0zM352 128L245.2 63.9C210.4 43 170.6 32 130 32l-2 0 0 96 224 0zM96 128l0-96L80 32C53.5 32 32 53.5 32 80l0 48 8 0c-22.1 0-40 17.9-40 40l0 16L0 328l0 16c0 22.1 17.9 40 40 40l-8 0 0 48c0 26.5 21.5 48 48 48l16 0 0-96 8 0c26.2 0 49.4-12.6 64-32l288 0c69.3 0 135-22.7 179.2-81.6c6.4-8.5 6.4-20.3 0-28.8C591 182.7 525.3 160 456 160l-288 0c-14.6-19.4-37.8-32-64-32l-8 0zM512 243.6l0 24.9c0 19.6-15.9 35.6-35.6 35.6c-2.5 0-4.4-2-4.4-4.4l0-87.1c0-2.5 2-4.4 4.4-4.4c19.6 0 35.6 15.9 35.6 35.6z"
    ]
};
const $d8206b3ab2e65c05$export$4d1c12ba2b4ca565 = $d8206b3ab2e65c05$export$76d92e7f30d064c5;
const $d8206b3ab2e65c05$export$2f203616c892d415 = {
    prefix: 'fas',
    iconName: 'face-laugh',
    icon: [
        512,
        512,
        [
            "laugh"
        ],
        "f599",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1l275.2 0c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $d8206b3ab2e65c05$export$6c74e314e801a4fe = $d8206b3ab2e65c05$export$2f203616c892d415;
const $d8206b3ab2e65c05$export$ff7e93418af88b78 = {
    prefix: 'fas',
    iconName: 'folder-open',
    icon: [
        576,
        512,
        [
            128194,
            128449,
            61717
        ],
        "f07c",
        "M88.7 223.8L0 375.8 0 96C0 60.7 28.7 32 64 32l117.5 0c17 0 33.3 6.7 45.3 18.7l26.5 26.5c12 12 28.3 18.7 45.3 18.7L416 96c35.3 0 64 28.7 64 64l0 32-336 0c-22.8 0-43.8 12.1-55.3 31.8zm27.6 16.1C122.1 230 132.6 224 144 224l400 0c11.5 0 22 6.1 27.7 16.1s5.7 22.2-.1 32.1l-112 192C453.9 474 443.4 480 432 480L32 480c-11.5 0-22-6.1-27.7-16.1s-5.7-22.2 .1-32.1l112-192z"
    ]
};
const $d8206b3ab2e65c05$export$2a155a6e20f64134 = {
    prefix: 'fas',
    iconName: 'heart-circle-plus',
    icon: [
        576,
        512,
        [],
        "e500",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6l0-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1l0 5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208l0 48 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
const $d8206b3ab2e65c05$export$f54081bdbf6d4eb5 = {
    prefix: 'fas',
    iconName: 'code-fork',
    icon: [
        448,
        512,
        [],
        "e13b",
        "M80 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm80-24c0 32.8-19.7 61-48 73.3l0 38.7c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-38.7C307.7 141 288 112.8 288 80c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3l0 38.7c0 53-43 96-96 96l-48 0 0 70.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3l0-70.7-48 0c-53 0-96-43-96-96l0-38.7C19.7 141 0 112.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80zm208 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM248 432a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
    ]
};
const $d8206b3ab2e65c05$export$a9947c2888b3c8fd = {
    prefix: 'fas',
    iconName: 'city',
    icon: [
        640,
        512,
        [
            127961
        ],
        "f64f",
        "M480 48c0-26.5-21.5-48-48-48L336 0c-26.5 0-48 21.5-48 48l0 48-64 0 0-72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72-64 0 0-72c0-13.3-10.7-24-24-24S64 10.7 64 24l0 72L48 96C21.5 96 0 117.5 0 144l0 96L0 464c0 26.5 21.5 48 48 48l256 0 32 0 96 0 160 0c26.5 0 48-21.5 48-48l0-224c0-26.5-21.5-48-48-48l-112 0 0-144zm96 320l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16zM240 416l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16zM128 400c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32zM560 256c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0zM256 176l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16zM112 160c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0zM256 304c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32zM112 320l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16zm304-48l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16zM400 64c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0zm16 112l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16z"
    ]
};
const $d8206b3ab2e65c05$export$417391ae30b5922e = {
    prefix: 'fas',
    iconName: 'microphone-lines',
    icon: [
        384,
        512,
        [
            127897,
            "microphone-alt"
        ],
        "f3c9",
        "M96 96l0 160c0 53 43 96 96 96s96-43 96-96l-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-32-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-32-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0c0-53-43-96-96-96S96 43 96 96zM320 240l0 16c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 89.1 66.2 162.7 152 174.4l0 33.6-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-33.6c85.8-11.7 152-85.3 152-174.4l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 24z"
    ]
};
const $d8206b3ab2e65c05$export$f08ef94fea14f5ac = $d8206b3ab2e65c05$export$417391ae30b5922e;
const $d8206b3ab2e65c05$export$4894bf28f771e1f3 = {
    prefix: 'fas',
    iconName: 'pepper-hot',
    icon: [
        512,
        512,
        [
            127798
        ],
        "f816",
        "M428.3 3c11.6-6.4 26.2-2.3 32.6 9.3l4.8 8.7c19.3 34.7 19.8 75.7 3.4 110C495.8 159.6 512 197.9 512 240c0 18.5-3.1 36.3-8.9 52.8c-6.1 17.3-28.5 16.3-36.8-.1l-11.7-23.4c-4.1-8.1-12.4-13.3-21.5-13.3L360 256c-13.3 0-24-10.7-24-24l0-80c0-13.3-10.7-24-24-24l-17.1 0c-21.3 0-30-23.9-10.8-32.9C304.7 85.4 327.7 80 352 80c28.3 0 54.8 7.3 77.8 20.2c5.5-18.2 3.7-38.4-6-55.8L419 35.7c-6.4-11.6-2.3-26.2 9.3-32.6zM171.2 345.5L264 160l40 0 0 80c0 26.5 21.5 48 48 48l76.2 0 23.9 47.8C372.3 443.9 244.3 512 103.2 512l-58.8 0C19.9 512 0 492.1 0 467.6c0-20.8 14.5-38.8 34.8-43.3l49.8-11.1c37.6-8.4 69.5-33.2 86.7-67.7z"
    ]
};
const $d8206b3ab2e65c05$export$db1382cd406cc506 = {
    prefix: 'fas',
    iconName: 'unlock',
    icon: [
        448,
        512,
        [
            128275
        ],
        "f09c",
        "M144 144c0-44.2 35.8-80 80-80c31.9 0 59.4 18.6 72.3 45.7c7.6 16 26.7 22.8 42.6 15.2s22.8-26.7 15.2-42.6C331 33.7 281.5 0 224 0C144.5 0 80 64.5 80 144l0 48-16 0c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64l-240 0 0-48z"
    ]
};
const $d8206b3ab2e65c05$export$dec10d4c2c113312 = {
    prefix: 'fas',
    iconName: 'colon-sign',
    icon: [
        384,
        512,
        [],
        "e140",
        "M255 39.8c4.3-17.1-6.1-34.5-23.3-38.8S197.2 7.1 193 24.2L181.9 68.6C96.1 87.8 32 164.4 32 256c0 58.1 25.8 110.2 66.7 145.4L81 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l13-52.1c9 3.4 18.4 6.2 28 8.2L177 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l10.4-41.4c33.4-4.4 64.1-17.4 89.8-36.7c14.1-10.6 17-30.7 6.4-44.8s-30.7-17-44.8-6.4c-10.2 7.7-21.7 13.9-34 18.3L321 160c9.4-.3 18.5-4.7 24.6-12.8c10.6-14.1 7.8-34.2-6.4-44.8c-1.1-.8-2.2-1.6-3.3-2.4L351 39.8c4.3-17.1-6.1-34.5-23.3-38.8S293.2 7.1 289 24.2L277.2 71.5c-9.3-2.7-18.8-4.6-28.6-5.9L255 39.8zM163.2 143.3L117.3 326.8C103.9 306.5 96 282.2 96 256c0-48.7 27.2-91 67.2-112.7zm8.6 229.5l61.1-244.6c9.9 .7 19.5 2.5 28.7 5.3l-62 248.1c-9.7-1.9-19-4.8-27.8-8.8z"
    ]
};
const $d8206b3ab2e65c05$export$23b086400a31acfe = {
    prefix: 'fas',
    iconName: 'headset',
    icon: [
        512,
        512,
        [],
        "f590",
        "M256 48C141.1 48 48 141.1 48 256l0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40C0 114.6 114.6 0 256 0S512 114.6 512 256l0 144.1c0 48.6-39.4 88-88.1 88L313.6 488c-8.3 14.3-23.8 24-41.6 24l-32 0c-26.5 0-48-21.5-48-48s21.5-48 48-48l32 0c17.8 0 33.3 9.7 41.6 24l110.4 .1c22.1 0 40-17.9 40-40L464 256c0-114.9-93.1-208-208-208zM144 208l16 0c17.7 0 32 14.3 32 32l0 112c0 17.7-14.3 32-32 32l-16 0c-35.3 0-64-28.7-64-64l0-48c0-35.3 28.7-64 64-64zm224 0c35.3 0 64 28.7 64 64l0 48c0 35.3-28.7 64-64 64l-16 0c-17.7 0-32-14.3-32-32l0-112c0-17.7 14.3-32 32-32l16 0z"
    ]
};
const $d8206b3ab2e65c05$export$4ab2f33219630bad = {
    prefix: 'fas',
    iconName: 'store-slash',
    icon: [
        640,
        512,
        [],
        "e071",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.8-68 0-17.1 0-131.4c-4 1-8 1.8-12.3 2.3c0 0 0 0-.1 0c-5.3 .7-10.7 1.1-16.2 1.1c-12.4 0-24.3-1.9-35.4-5.3l0 100.3L301.2 210.7c7-4.4 13.3-9.7 18.8-15.7c15.9 17.6 39.1 29 65.2 29c26.2 0 49.3-11.4 65.2-29c16 17.6 39.1 29 65.2 29c4.1 0 8.1-.3 12.1-.8c55.5-7.4 81.8-72.5 52.1-119.4L522.3 13.1C517.2 5 508.1 0 498.4 0L141.6 0c-9.7 0-18.8 5-23.9 13.1l-22.7 36L38.8 5.1zm73.4 218.1c4 .5 8.1 .8 12.1 .8c11 0 21.4-2 31-5.6L48.9 134.5c-6.1 40.6 19.5 82.8 63.3 88.7zM160 384l0-133.4c-11.2 3.5-23.2 5.4-35.6 5.4c-5.5 0-11-.4-16.3-1.1l-.1 0c-4.1-.6-8.1-1.3-12-2.3L96 384l0 64c0 35.3 28.7 64 64 64l320 0c12.9 0 24.8-3.8 34.9-10.3L365.5 384 160 384z"
    ]
};
const $d8206b3ab2e65c05$export$2ffc88a4d31e8ffc = {
    prefix: 'fas',
    iconName: 'road-circle-xmark',
    icon: [
        640,
        512,
        [],
        "e566",
        "M213.2 32L288 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64 74.8 0c27.1 0 51.3 17.1 60.3 42.6l42.7 120.6c-10.9-2.1-22.2-3.2-33.8-3.2c-59.5 0-112.1 29.6-144 74.8l0-42.8c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32c2.3 0 4.6-.3 6.8-.7c-4.5 15.5-6.8 31.8-6.8 48.7c0 5.4 .2 10.7 .7 16l-.7 0c-17.7 0-32 14.3-32 32l0 64L86.6 480C56.5 480 32 455.5 32 425.4c0-6.2 1.1-12.4 3.1-18.2L152.9 74.6C162 49.1 186.1 32 213.2 32zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm22.6 144l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368z"
    ]
};
const $d8206b3ab2e65c05$export$d6e17c0df8ed1bf7 = {
    prefix: 'fas',
    iconName: 'user-minus',
    icon: [
        640,
        512,
        [],
        "f503",
        "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3zM472 200l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
const $d8206b3ab2e65c05$export$efc6d53e0dedceee = {
    prefix: 'fas',
    iconName: 'mars-stroke-up',
    icon: [
        320,
        512,
        [
            9896,
            "mars-stroke-v"
        ],
        "f22a",
        "M148.7 4.7c6.2-6.2 16.4-6.2 22.6 0l64 64c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9l-40 0 0 24 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0 0 24c0 .6 0 1.2-.1 1.8c77 11.6 136.1 78 136.1 158.2c0 88.4-71.6 160-160 160S0 440.4 0 352c0-80.2 59.1-146.7 136.1-158.2c0-.6-.1-1.2-.1-1.8l0-24-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l32 0 0-24L96 96c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l64-64zM256 352A96 96 0 1 0 64 352a96 96 0 1 0 192 0z"
    ]
};
const $d8206b3ab2e65c05$export$ed7aa1c25104f333 = $d8206b3ab2e65c05$export$efc6d53e0dedceee;
const $d8206b3ab2e65c05$export$7df1926e9eef8cc3 = {
    prefix: 'fas',
    iconName: 'champagne-glasses',
    icon: [
        640,
        512,
        [
            129346,
            "glass-cheers"
        ],
        "f79f",
        "M155.6 17.3C163 3 179.9-3.6 195 1.9L320 47.5l125-45.6c15.1-5.5 32 1.1 39.4 15.4l78.8 152.9c28.8 55.8 10.3 122.3-38.5 156.6L556.1 413l41-15c16.6-6 35 2.5 41 19.1s-2.5 35-19.1 41l-71.1 25.9L476.8 510c-16.6 6.1-35-2.5-41-19.1s2.5-35 19.1-41l41-15-31.3-86.2c-59.4 5.2-116.2-34-130-95.2L320 188.8l-14.6 64.7c-13.8 61.3-70.6 100.4-130 95.2l-31.3 86.2 41 15c16.6 6 25.2 24.4 19.1 41s-24.4 25.2-41 19.1L92.2 484.1 21.1 458.2c-16.6-6.1-25.2-24.4-19.1-41s24.4-25.2 41-19.1l41 15 31.3-86.2C66.5 292.5 48.1 226 76.9 170.2L155.6 17.3zm44 54.4l-27.2 52.8L261.6 157l13.1-57.9L199.6 71.7zm240.9 0L365.4 99.1 378.5 157l89.2-32.5L440.5 71.7z"
    ]
};
const $d8206b3ab2e65c05$export$20007d7d74cb98fe = $d8206b3ab2e65c05$export$7df1926e9eef8cc3;
const $d8206b3ab2e65c05$export$97d84347d71ba297 = {
    prefix: 'fas',
    iconName: 'clipboard',
    icon: [
        384,
        512,
        [
            128203
        ],
        "f328",
        "M192 0c-41.8 0-77.4 26.7-90.5 64L64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-37.5 0C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM112 192l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
const $d8206b3ab2e65c05$export$8403e4b31e8aa805 = {
    prefix: 'fas',
    iconName: 'house-circle-exclamation',
    icon: [
        640,
        512,
        [],
        "e50a",
        "M320.7 352c8.1-89.7 83.5-160 175.3-160c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1l32 0 0 69.7c-.1 .9-.1 1.8-.1 2.8l0 112c0 22.1 17.9 40 40 40l16 0c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2l31.9 0 24 0c22.1 0 40-17.9 40-40l0-24 0-64c0-17.7 14.3-32 32-32l64 0 .7 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16z"
    ]
};
const $d8206b3ab2e65c05$export$929df388c07f293d = {
    prefix: 'fas',
    iconName: 'file-arrow-up',
    icon: [
        384,
        512,
        [
            "file-upload"
        ],
        "f574",
        "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM216 408c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-102.1-31 31c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l72-72c9.4-9.4 24.6-9.4 33.9 0l72 72c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-31-31L216 408z"
    ]
};
const $d8206b3ab2e65c05$export$dd55ded1264643d2 = $d8206b3ab2e65c05$export$929df388c07f293d;
const $d8206b3ab2e65c05$export$1642419fe3db2857 = {
    prefix: 'fas',
    iconName: 'wifi',
    icon: [
        640,
        512,
        [
            "wifi-3",
            "wifi-strong"
        ],
        "f1eb",
        "M54.2 202.9C123.2 136.7 216.8 96 320 96s196.8 40.7 265.8 106.9c12.8 12.2 33 11.8 45.2-.9s11.8-33-.9-45.2C549.7 79.5 440.4 32 320 32S90.3 79.5 9.8 156.7C-2.9 169-3.3 189.2 8.9 202s32.5 13.2 45.2 .9zM320 256c56.8 0 108.6 21.1 148.2 56c13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2C459.8 219.2 393 192 320 192s-139.8 27.2-190.5 72c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8c39.5-34.9 91.3-56 148.2-56zm64 160a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
    ]
};
const $d8206b3ab2e65c05$export$2349bb04a04f4b2d = $d8206b3ab2e65c05$export$1642419fe3db2857;
const $d8206b3ab2e65c05$export$4b3167c852f4c4aa = $d8206b3ab2e65c05$export$1642419fe3db2857;
const $d8206b3ab2e65c05$export$1ea66a88b8f620c9 = {
    prefix: 'fas',
    iconName: 'bath',
    icon: [
        512,
        512,
        [
            128705,
            "bathtub"
        ],
        "f2cd",
        "M96 77.3c0-7.3 5.9-13.3 13.3-13.3c3.5 0 6.9 1.4 9.4 3.9l14.9 14.9C130 91.8 128 101.7 128 112c0 19.9 7.2 38 19.2 52c-5.3 9.2-4 21.1 3.8 29c9.4 9.4 24.6 9.4 33.9 0L289 89c9.4-9.4 9.4-24.6 0-33.9c-7.9-7.9-19.8-9.1-29-3.8C246 39.2 227.9 32 208 32c-10.3 0-20.2 2-29.2 5.5L163.9 22.6C149.4 8.1 129.7 0 109.3 0C66.6 0 32 34.6 32 77.3L32 256c-17.7 0-32 14.3-32 32s14.3 32 32 32l448 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 256 96 77.3zM32 352l0 16c0 28.4 12.4 54 32 71.6L64 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-16 256 0 0 16c0 17.7 14.3 32 32 32s32-14.3 32-32l0-40.4c19.6-17.6 32-43.1 32-71.6l0-16L32 352z"
    ]
};
const $d8206b3ab2e65c05$export$40ae013b5e6269d8 = $d8206b3ab2e65c05$export$1ea66a88b8f620c9;
const $d8206b3ab2e65c05$export$22346afd6a3cddf8 = {
    prefix: 'fas',
    iconName: 'underline',
    icon: [
        448,
        512,
        [],
        "f0cd",
        "M16 64c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-16 0 0 128c0 53 43 96 96 96s96-43 96-96l0-128-16 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-16 0 0 128c0 88.4-71.6 160-160 160s-160-71.6-160-160L64 96 48 96C30.3 96 16 81.7 16 64zM0 448c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32z"
    ]
};
const $d8206b3ab2e65c05$export$3842882ea09b25af = {
    prefix: 'fas',
    iconName: 'user-pen',
    icon: [
        640,
        512,
        [
            "user-edit"
        ],
        "f4ff",
        "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l293.1 0c-3.1-8.8-3.7-18.4-1.4-27.8l15-60.1c2.8-11.3 8.6-21.5 16.8-29.7l40.3-40.3c-32.1-31-75.7-50.1-123.9-50.1l-91.4 0zm435.5-68.3c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM375.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L576.1 358.7l-71-71L375.9 417z"
    ]
};
const $d8206b3ab2e65c05$export$a68a6960fc8eef82 = $d8206b3ab2e65c05$export$3842882ea09b25af;
const $d8206b3ab2e65c05$export$afa7b53ac8ebcb5d = {
    prefix: 'fas',
    iconName: 'signature',
    icon: [
        640,
        512,
        [],
        "f5b7",
        "M192 128c0-17.7 14.3-32 32-32s32 14.3 32 32l0 7.8c0 27.7-2.4 55.3-7.1 82.5l-84.4 25.3c-40.6 12.2-68.4 49.6-68.4 92l0 71.9c0 40 32.5 72.5 72.5 72.5c26 0 50-13.9 62.9-36.5l13.9-24.3c26.8-47 46.5-97.7 58.4-150.5l94.4-28.3-12.5 37.5c-3.3 9.8-1.6 20.5 4.4 28.8s15.7 13.3 26 13.3l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-83.6 0 18-53.9c3.8-11.3 .9-23.8-7.4-32.4s-20.7-11.8-32.2-8.4L316.4 198.1c2.4-20.7 3.6-41.4 3.6-62.3l0-7.8c0-53-43-96-96-96s-96 43-96 96l0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32zm-9.2 177l49-14.7c-10.4 33.8-24.5 66.4-42.1 97.2l-13.9 24.3c-1.5 2.6-4.3 4.3-7.4 4.3c-4.7 0-8.5-3.8-8.5-8.5l0-71.9c0-14.1 9.3-26.6 22.8-30.7zM24 368c-13.3 0-24 10.7-24 24s10.7 24 24 24l40.3 0c-.2-2.8-.3-5.6-.3-8.5L64 368l-40 0zm592 48c13.3 0 24-10.7 24-24s-10.7-24-24-24l-310.1 0c-6.7 16.3-14.2 32.3-22.3 48L616 416z"
    ]
};
const $d8206b3ab2e65c05$export$195780ddabd8e0c6 = {
    prefix: 'fas',
    iconName: 'stroopwafel',
    icon: [
        512,
        512,
        [],
        "f551",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM312.6 63.7c-6.2-6.2-16.4-6.2-22.6 0L256 97.6 222.1 63.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l33.9 33.9-45.3 45.3-56.6-56.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l56.6 56.6-45.3 45.3L86.3 199.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L97.6 256 63.7 289.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l33.9-33.9 45.3 45.3-56.6 56.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56.6-56.6 45.3 45.3-33.9 33.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 414.4l33.9 33.9c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-33.9-33.9 45.3-45.3 56.6 56.6c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-56.6-56.6 45.3-45.3 33.9 33.9c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L414.4 256l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-33.9 33.9-45.3-45.3 56.6-56.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-56.6 56.6-45.3-45.3 33.9-33.9c6.2-6.2 6.2-16.4 0-22.6zM142.9 256l45.3-45.3L233.4 256l-45.3 45.3L142.9 256zm67.9 67.9L256 278.6l45.3 45.3L256 369.1l-45.3-45.3zM278.6 256l45.3-45.3L369.1 256l-45.3 45.3L278.6 256zm22.6-67.9L256 233.4l-45.3-45.3L256 142.9l45.3 45.3z"
    ]
};
const $d8206b3ab2e65c05$export$7e0c7fd2a2e88823 = {
    prefix: 'fas',
    iconName: 'bold',
    icon: [
        384,
        512,
        [],
        "f032",
        "M0 64C0 46.3 14.3 32 32 32l48 0 16 0 128 0c70.7 0 128 57.3 128 128c0 31.3-11.3 60.1-30 82.3c37.1 22.4 62 63.1 62 109.7c0 70.7-57.3 128-128 128L96 480l-16 0-48 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l16 0 0-160L48 96 32 96C14.3 96 0 81.7 0 64zM224 224c35.3 0 64-28.7 64-64s-28.7-64-64-64L112 96l0 128 112 0zM112 288l0 128 144 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-32 0-112 0z"
    ]
};
const $d8206b3ab2e65c05$export$217195c80db39097 = {
    prefix: 'fas',
    iconName: 'anchor-lock',
    icon: [
        640,
        512,
        [],
        "e4ad",
        "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80L224 176c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 208-48 0c-53 0-96-43-96-96l0-6.1 7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7 0 6.1c0 88.4 71.6 160 160 160l80 0 80 0c8 0 15.9-.6 23.6-1.7c-4.8-9-7.6-19.3-7.6-30.3l0-33.3c-5.2 .9-10.5 1.3-16 1.3l-48 0 0-208 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-10.9 0zM528 240c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
const $d8206b3ab2e65c05$export$374e1dce366a2175 = {
    prefix: 'fas',
    iconName: 'building-ngo',
    icon: [
        384,
        512,
        [],
        "e4d7",
        "M48 0C21.5 0 0 21.5 0 48L0 464c0 26.5 21.5 48 48 48l96 0 0-80c0-26.5 21.5-48 48-48s48 21.5 48 48l0 80 96 0c26.5 0 48-21.5 48-48l0-416c0-26.5-21.5-48-48-48L48 0zM64 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm112-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM168 64l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 64 16 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 24c0 13.3-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24l0-88c0-8.8 7.2-16 16-16zM304 96c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32c0-8.8-7.2-16-16-16zm-48 16c0-26.5 21.5-48 48-48s48 21.5 48 48l0 32c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-32zM61.3 71.1l34.7 52L96 80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4L64 132.8 64 176c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4z"
    ]
};
const $d8206b3ab2e65c05$export$1ff755b523ab2851 = {
    prefix: 'fas',
    iconName: 'manat-sign',
    icon: [
        384,
        512,
        [],
        "e1d5",
        "M192 32c-17.7 0-32 14.3-32 32l0 34.7C69.2 113.9 0 192.9 0 288L0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160c0-59.6 40.8-109.8 96-124l0 284c0 17.7 14.3 32 32 32s32-14.3 32-32l0-284c55.2 14.2 96 64.3 96 124l0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160c0-95.1-69.2-174.1-160-189.3L224 64c0-17.7-14.3-32-32-32z"
    ]
};
const $d8206b3ab2e65c05$export$6a15ccae09bbaf93 = {
    prefix: 'fas',
    iconName: 'not-equal',
    icon: [
        448,
        512,
        [],
        "f53e",
        "M369.8 37.4c14.7 9.8 18.7 29.7 8.9 44.4L337.1 144l62.9 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-105.5 0-64 96L400 304c17.7 0 32 14.3 32 32s-14.3 32-32 32l-212.2 0-65.2 97.7c-9.8 14.7-29.7 18.7-44.4 8.9s-18.7-29.7-8.9-44.4L110.9 368 48 368c-17.7 0-32-14.3-32-32s14.3-32 32-32l105.5 0 64-96L48 208c-17.7 0-32-14.3-32-32s14.3-32 32-32l212.2 0 65.2-97.7c9.8-14.7 29.7-18.7 44.4-8.9z"
    ]
};
const $d8206b3ab2e65c05$export$cf897c3e0abd59e4 = {
    prefix: 'fas',
    iconName: 'border-top-left',
    icon: [
        448,
        512,
        [
            "border-style"
        ],
        "f853",
        "M0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-336c0-8.8 7.2-16 16-16l336 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 32C35.8 32 0 67.8 0 112L0 448zm160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm192 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm192 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM416 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
const $d8206b3ab2e65c05$export$c2867ca78120d644 = $d8206b3ab2e65c05$export$cf897c3e0abd59e4;
const $d8206b3ab2e65c05$export$757f50b8af780c19 = {
    prefix: 'fas',
    iconName: 'map-location-dot',
    icon: [
        576,
        512,
        [
            "map-marked-alt"
        ],
        "f5a0",
        "M408 120c0 54.6-73.1 151.9-105.2 192c-7.7 9.6-22 9.6-29.6 0C241.1 271.9 168 174.6 168 120C168 53.7 221.7 0 288 0s120 53.7 120 120zm8 80.4c3.5-6.9 6.7-13.8 9.6-20.6c.5-1.2 1-2.5 1.5-3.7l116-46.4C558.9 123.4 576 135 576 152l0 270.8c0 9.8-6 18.6-15.1 22.3L416 503l0-302.6zM137.6 138.3c2.4 14.1 7.2 28.3 12.8 41.5c2.9 6.8 6.1 13.7 9.6 20.6l0 251.4L32.9 502.7C17.1 509 0 497.4 0 480.4L0 209.6c0-9.8 6-18.6 15.1-22.3l122.6-49zM327.8 332c13.9-17.4 35.7-45.7 56.2-77l0 249.3L192 449.4 192 255c20.5 31.3 42.3 59.6 56.2 77c20.5 25.6 59.1 25.6 79.6 0zM288 152a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
    ]
};
const $d8206b3ab2e65c05$export$a977d47c74d8e86c = $d8206b3ab2e65c05$export$757f50b8af780c19;
const $d8206b3ab2e65c05$export$859f204e59641ca4 = {
    prefix: 'fas',
    iconName: 'jedi',
    icon: [
        576,
        512,
        [],
        "f669",
        "M246 315.7l-21.2-31.9c-2.1-3.2-1.7-7.4 1-10.1s6.9-3.1 10.1-1l29.5 19.7c2.1 1.4 4.9 0 5-2.6L279.7 8c.1-4.5 3.8-8 8.3-8s8.1 3.5 8.3 8l9.4 281.9c.1 2.5 2.9 3.9 5 2.6l29.5-19.7c3.2-2.1 7.4-1.7 10.1 1s3.1 6.9 1 10.1L330 315.7c-1.3 1.9-.2 4.5 2 4.9l37.6 7.5c3.7 .7 6.4 4 6.4 7.8s-2.7 7.1-6.4 7.8L332 351.4c-2.2 .4-3.3 3-2 4.9l21.2 31.9c2.1 3.2 1.7 7.4-1 10.1s-6.9 3.1-10.1 1l-26.3-17.6c-2.2-1.4-5.1 .2-5 2.8l2.1 61.5C370.6 435.2 416 382.9 416 320c0-37-15.7-70.4-40.8-93.7c-7-6.5-6.5-18.6 1-24.4C410.1 175.5 432 134.3 432 88c0-16.8-2.9-33-8.2-48c-4.6-13 10.2-30 21.4-22c53.5 38 92.7 94.8 107.8 160.7c.5 2.1-.2 4.3-1.7 5.9l-28.4 28.4c-4 4-1.2 10.9 4.5 10.9l26 0c3.4 0 6.2 2.6 6.3 6c.1 3.3 .2 6.6 .2 10c0 17.5-1.7 34.7-4.8 51.3c-.2 1.2-.9 2.4-1.7 3.3l-46.5 46.5c-4 4-1.2 10.9 4.5 10.9l14.6 0c4.6 0 7.7 4.8 5.7 9C487.2 450.5 394.8 512 288 512S88.8 450.5 44.3 361c-2.1-4.2 1-9 5.7-9l14.6 0c5.7 0 8.6-6.9 4.5-10.9L22.6 294.6c-.9-.9-1.5-2-1.7-3.3C17.7 274.7 16 257.5 16 240c0-3.3 .1-6.7 .2-10c.1-3.4 2.9-6 6.3-6l26 0c5.7 0 8.6-6.9 4.5-10.9L24.6 184.6c-1.5-1.5-2.2-3.8-1.7-5.9C38.1 112.8 77.3 56 130.8 18c11.3-8 26 8.9 21.4 22c-5.3 15-8.2 31.2-8.2 48c0 46.3 21.9 87.5 55.8 113.9c7.5 5.8 8 17.9 1 24.4C175.7 249.6 160 283 160 320c0 62.9 45.4 115.2 105.1 126l2.1-61.5c.1-2.6-2.8-4.2-5-2.8l-26.3 17.6c-3.2 2.1-7.4 1.7-10.1-1s-3.1-6.9-1-10.1L246 356.3c1.3-1.9 .2-4.5-2-4.9l-37.6-7.5c-3.7-.7-6.4-4-6.4-7.8s2.7-7.1 6.4-7.8l37.6-7.5c2.2-.4 3.3-3 2-4.9z"
    ]
};
const $d8206b3ab2e65c05$export$91d747e5aabe6fe8 = {
    prefix: 'fas',
    iconName: 'square-poll-vertical',
    icon: [
        448,
        512,
        [
            "poll"
        ],
        "f681",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm64 192c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32zm64-64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 192c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-192zM320 288c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32z"
    ]
};
const $d8206b3ab2e65c05$export$bc8ca14ab51f93db = $d8206b3ab2e65c05$export$91d747e5aabe6fe8;
const $d8206b3ab2e65c05$export$47a822c30184e8af = {
    prefix: 'fas',
    iconName: 'mug-hot',
    icon: [
        512,
        512,
        [
            9749
        ],
        "f7b6",
        "M88 0C74.7 0 64 10.7 64 24c0 38.9 23.4 59.4 39.1 73.1l1.1 1C120.5 112.3 128 119.9 128 136c0 13.3 10.7 24 24 24s24-10.7 24-24c0-38.9-23.4-59.4-39.1-73.1l-1.1-1C119.5 47.7 112 40.1 112 24c0-13.3-10.7-24-24-24zM32 192c-17.7 0-32 14.3-32 32L0 416c0 53 43 96 96 96l192 0c53 0 96-43 96-96l16 0c61.9 0 112-50.1 112-112s-50.1-112-112-112l-48 0L32 192zm352 64l16 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-16 0 0-96zM224 24c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 38.9 23.4 59.4 39.1 73.1l1.1 1C232.5 112.3 240 119.9 240 136c0 13.3 10.7 24 24 24s24-10.7 24-24c0-38.9-23.4-59.4-39.1-73.1l-1.1-1C231.5 47.7 224 40.1 224 24z"
    ]
};
const $d8206b3ab2e65c05$export$a44d0c11093d9c1e = {
    prefix: 'fas',
    iconName: 'car-battery',
    icon: [
        512,
        512,
        [
            "battery-car"
        ],
        "f5df",
        "M80 96c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l96 0c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l16 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 160c0-35.3 28.7-64 64-64l16 0zm304 96c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-32zM80 240c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16z"
    ]
};
const $d8206b3ab2e65c05$export$9133165ca669dd4b = $d8206b3ab2e65c05$export$a44d0c11093d9c1e;
const $d8206b3ab2e65c05$export$b2727de8ccdbb5ec = {
    prefix: 'fas',
    iconName: 'gift',
    icon: [
        512,
        512,
        [
            127873
        ],
        "f06b",
        "M190.5 68.8L225.3 128l-1.3 0-72 0c-22.1 0-40-17.9-40-40s17.9-40 40-40l2.2 0c14.9 0 28.8 7.9 36.3 20.8zM64 88c0 14.4 3.5 28 9.6 40L32 128c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-41.6 0c6.1-12 9.6-25.6 9.6-40c0-48.6-39.4-88-88-88l-2.2 0c-31.9 0-61.5 16.9-77.7 44.4L256 85.5l-24.1-41C215.7 16.9 186.1 0 154.2 0L152 0C103.4 0 64 39.4 64 88zm336 0c0 22.1-17.9 40-40 40l-72 0-1.3 0 34.8-59.2C329.1 55.9 342.9 48 357.8 48l2.2 0c22.1 0 40 17.9 40 40zM32 288l0 176c0 26.5 21.5 48 48 48l144 0 0-224L32 288zM288 512l144 0c26.5 0 48-21.5 48-48l0-176-192 0 0 224z"
    ]
};
const $d8206b3ab2e65c05$export$4d85df590065572f = {
    prefix: 'fas',
    iconName: 'dice-two',
    icon: [
        448,
        512,
        [
            9857
        ],
        "f528",
        "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM352 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
const $d8206b3ab2e65c05$export$7b8ce73615739d30 = {
    prefix: 'fas',
    iconName: 'chess-queen',
    icon: [
        512,
        512,
        [
            9819
        ],
        "f445",
        "M256 0a56 56 0 1 1 0 112A56 56 0 1 1 256 0zM134.1 143.8c3.3-13 15-23.8 30.2-23.8c12.3 0 22.6 7.2 27.7 17c12 23.2 36.2 39 64 39s52-15.8 64-39c5.1-9.8 15.4-17 27.7-17c15.3 0 27 10.8 30.2 23.8c7 27.8 32.2 48.3 62.1 48.3c10.8 0 21-2.7 29.8-7.4c8.4-4.4 18.9-4.5 27.6 .9c13 8 17.1 25 9.2 38L399.7 400 384 400l-40.4 0-175.1 0L128 400l-15.7 0L5.4 223.6c-7.9-13-3.8-30 9.2-38c8.7-5.3 19.2-5.3 27.6-.9c8.9 4.7 19 7.4 29.8 7.4c29.9 0 55.1-20.5 62.1-48.3zM256 224s0 0 0 0s0 0 0 0s0 0 0 0zM112 432l288 0 41.4 41.4c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6L86.6 512C74.1 512 64 501.9 64 489.4c0-6 2.4-11.8 6.6-16L112 432z"
    ]
};
const $d8206b3ab2e65c05$export$58d7d709c0a8ca5f = {
    prefix: 'fas',
    iconName: 'glasses',
    icon: [
        576,
        512,
        [],
        "f530",
        "M118.6 80c-11.5 0-21.4 7.9-24 19.1L57 260.3c20.5-6.2 48.3-12.3 78.7-12.3c32.3 0 61.8 6.9 82.8 13.5c10.6 3.3 19.3 6.7 25.4 9.2c3.1 1.3 5.5 2.4 7.3 3.2c.9 .4 1.6 .7 2.1 1l.6 .3 .2 .1c0 0 .1 0 .1 0c0 0 0 0 0 0s0 0 0 0L247.9 288s0 0 0 0l6.3-12.7c5.8 2.9 10.4 7.3 13.5 12.7l40.6 0c3.1-5.3 7.7-9.8 13.5-12.7l6.3 12.7s0 0 0 0c-6.3-12.7-6.3-12.7-6.3-12.7s0 0 0 0s0 0 0 0c0 0 .1 0 .1 0l.2-.1 .6-.3c.5-.2 1.2-.6 2.1-1c1.8-.8 4.2-1.9 7.3-3.2c6.1-2.6 14.8-5.9 25.4-9.2c21-6.6 50.4-13.5 82.8-13.5c30.4 0 58.2 6.1 78.7 12.3L481.4 99.1c-2.6-11.2-12.6-19.1-24-19.1c-3.1 0-6.2 .6-9.2 1.8L416.9 94.3c-12.3 4.9-26.3-1.1-31.2-13.4s1.1-26.3 13.4-31.2l31.3-12.5c8.6-3.4 17.7-5.2 27-5.2c33.8 0 63.1 23.3 70.8 56.2l43.9 188c1.7 7.3 2.9 14.7 3.5 22.1c.3 1.9 .5 3.8 .5 5.7l0 6.7 0 41.3 0 16c0 61.9-50.1 112-112 112l-44.3 0c-59.4 0-108.5-46.4-111.8-105.8L306.6 352l-37.2 0-1.2 22.2C264.9 433.6 215.8 480 156.3 480L112 480C50.1 480 0 429.9 0 368l0-16 0-41.3L0 304c0-1.9 .2-3.8 .5-5.7c.6-7.4 1.8-14.8 3.5-22.1l43.9-188C55.5 55.3 84.8 32 118.6 32c9.2 0 18.4 1.8 27 5.2l31.3 12.5c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4L127.8 81.8c-2.9-1.2-6-1.8-9.2-1.8zM64 325.4L64 368c0 26.5 21.5 48 48 48l44.3 0c25.5 0 46.5-19.9 47.9-45.3l2.5-45.6c-2.3-.8-4.9-1.7-7.5-2.5c-17.2-5.4-39.9-10.5-63.6-10.5c-23.7 0-46.2 5.1-63.2 10.5c-3.1 1-5.9 1.9-8.5 2.9zM512 368l0-42.6c-2.6-.9-5.5-1.9-8.5-2.9c-17-5.4-39.5-10.5-63.2-10.5c-23.7 0-46.4 5.1-63.6 10.5c-2.7 .8-5.2 1.7-7.5 2.5l2.5 45.6c1.4 25.4 22.5 45.3 47.9 45.3l44.3 0c26.5 0 48-21.5 48-48z"
    ]
};
const $d8206b3ab2e65c05$export$bd301515df6246af = {
    prefix: 'fas',
    iconName: 'chess-board',
    icon: [
        448,
        512,
        [],
        "f43c",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm64 64l0 64 64 0 0-64 64 0 0 64 64 0 0-64 64 0 0 64-64 0 0 64 64 0 0 64-64 0 0 64 64 0 0 64-64 0 0-64-64 0 0 64-64 0 0-64-64 0 0 64-64 0 0-64 64 0 0-64-64 0 0-64 64 0 0-64-64 0 0-64 64 0zm64 128l64 0 0-64-64 0 0 64zm0 64l0-64-64 0 0 64 64 0zm64 0l-64 0 0 64 64 0 0-64zm0 0l64 0 0-64-64 0 0 64z"
    ]
};
const $d8206b3ab2e65c05$export$5559de5f969b9590 = {
    prefix: 'fas',
    iconName: 'building-circle-check',
    icon: [
        640,
        512,
        [],
        "e4d2",
        "M48 0C21.5 0 0 21.5 0 48L0 464c0 26.5 21.5 48 48 48l96 0 0-80c0-26.5 21.5-48 48-48s48 21.5 48 48l0 80 96 0c15.1 0 28.5-6.9 37.3-17.8C340.4 462.2 320 417.5 320 368c0-54.7 24.9-103.5 64-135.8L384 48c0-26.5-21.5-48-48-48L48 0zM64 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm112-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM80 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM272 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
const $d8206b3ab2e65c05$export$c9dc1583b207b7ff = {
    prefix: 'fas',
    iconName: 'person-chalkboard',
    icon: [
        640,
        512,
        [],
        "e53d",
        "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 384l0-128 16 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-288 56 0 64 0 16 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0 0-64 192 0 0 192-192 0 0-32-64 0 0 48c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-224c0-26.5-21.5-48-48-48L368 0c-26.5 0-48 21.5-48 48l0 80-76.9 0-65.9 0c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9 120 480c0 17.7 14.3 32 32 32s32-14.3 32-32z"
    ]
};
const $d8206b3ab2e65c05$export$321e84e6a900c2d6 = {
    prefix: 'fas',
    iconName: 'mars-stroke-right',
    icon: [
        640,
        512,
        [
            9897,
            "mars-stroke-h"
        ],
        "f22b",
        "M208 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm174.4-88C370.7 365.8 297.1 432 208 432c-97.2 0-176-78.8-176-176s78.8-176 176-176c89.1 0 162.7 66.2 174.4 152l33.6 0 0-56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 56 32 0 0-56c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2l0-56-32 0 0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56-33.6 0z"
    ]
};
const $d8206b3ab2e65c05$export$5cb0daeafbcdabe3 = $d8206b3ab2e65c05$export$321e84e6a900c2d6;
const $d8206b3ab2e65c05$export$be38a892fe9b4098 = {
    prefix: 'fas',
    iconName: 'hand-back-fist',
    icon: [
        448,
        512,
        [
            "hand-rock"
        ],
        "f255",
        "M144 0C117.5 0 96 21.5 96 48l0 48 0 28.5L96 176c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-26.7-9 7.5C40.4 169 32 187 32 206L32 244c0 38 16.9 74 46.1 98.3L128 384l0 96c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-105.3c46.9-19 80-65 80-118.7l0-80 0-16 0-16c0-26.5-21.5-48-48-48c-12.4 0-23.6 4.7-32.1 12.3C350 83.5 329.3 64 304 64c-12.4 0-23.6 4.7-32.1 12.3C270 51.5 249.3 32 224 32c-12.4 0-23.6 4.7-32.1 12.3C190 19.5 169.3 0 144 0z"
    ]
};
const $d8206b3ab2e65c05$export$97a81eba394c8c44 = $d8206b3ab2e65c05$export$be38a892fe9b4098;
const $d8206b3ab2e65c05$export$66068918abb14406 = {
    prefix: 'fas',
    iconName: 'square-caret-up',
    icon: [
        448,
        512,
        [
            "caret-square-up"
        ],
        "f151",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM224 160c6.7 0 13 2.8 17.6 7.7l104 112c6.5 7 8.2 17.2 4.4 25.9s-12.5 14.4-22 14.4l-208 0c-9.5 0-18.2-5.7-22-14.4s-2.1-18.9 4.4-25.9l104-112c4.5-4.9 10.9-7.7 17.6-7.7z"
    ]
};
const $d8206b3ab2e65c05$export$307ae80b26533ce5 = $d8206b3ab2e65c05$export$66068918abb14406;
const $d8206b3ab2e65c05$export$b416056e795d2eac = {
    prefix: 'fas',
    iconName: 'cloud-showers-water',
    icon: [
        576,
        512,
        [],
        "e4e4",
        "M224 0c38.6 0 71.9 22.8 87.2 55.7C325.7 41.1 345.8 32 368 32c38.7 0 71 27.5 78.4 64l1.6 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-320 0c-35.3 0-64-28.7-64-64s28.7-64 64-64c0-53 43-96 96-96zM140.6 292.3l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15.1-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2s15.1 21.6 8.2 32.9zm327.8-32.9c11.4 6.8 15 21.6 8.2 32.9l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2zM252.6 292.3l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15.1-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2s15.1 21.6 8.2 32.9zm103.8-32.9c11.4 6.8 15 21.6 8.2 32.9l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15.1-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2zM306.5 421.9C329 437.4 356.5 448 384 448c26.9 0 55.4-10.8 77.4-26.1c0 0 0 0 0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7c0 0 0 0 0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
const $d8206b3ab2e65c05$export$b532f5d25de97633 = {
    prefix: 'fas',
    iconName: 'chart-bar',
    icon: [
        512,
        512,
        [
            "bar-chart"
        ],
        "f080",
        "M32 32c17.7 0 32 14.3 32 32l0 336c0 8.8 7.2 16 16 16l400 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L80 480c-44.2 0-80-35.8-80-80L0 64C0 46.3 14.3 32 32 32zm96 96c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32zm32 64l128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 96l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
const $d8206b3ab2e65c05$export$2d5f754a5e5738b = $d8206b3ab2e65c05$export$b532f5d25de97633;
const $d8206b3ab2e65c05$export$2f78563e14e49916 = {
    prefix: 'fas',
    iconName: 'hands-bubbles',
    icon: [
        576,
        512,
        [
            "hands-wash"
        ],
        "e05e",
        "M416 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM160 464a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM32 160l.1 72.6c.1 52.2 24 101 64 133.1c-.1-1.9-.1-3.8-.1-5.7l0-8c0-71.8 37-138.6 97.9-176.7l60.2-37.6c8.6-5.4 17.9-8.4 27.3-9.4l45.9-79.5c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8l-78 135.1c-3.3 5.7-10.7 7.7-16.4 4.4s-7.7-10.7-4.4-16.4l62-107.4c6.6-11.5 2.7-26.2-8.8-32.8S214 5 207.4 16.5l-68 117.8s0 0 0 0s0 0 0 0l-43.3 75L96 160c0-17.7-14.4-32-32-32s-32 14.4-32 32zM332.1 88.5L307.5 131c13.9 4.5 26.4 13.7 34.7 27c.9 1.5 1.8 2.9 2.5 4.4l28.9-50c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8zm46.4 63.7l-26.8 46.4c-.6 6-2.1 11.8-4.3 17.4l4.7 0 13.3 0s0 0 0 0l31.8 0 23-39.8c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8zM315.1 175c-9.4-15-29.1-19.5-44.1-10.2l-60.2 37.6C159.3 234.7 128 291.2 128 352l0 8c0 8.9 .8 17.6 2.2 26.1c35.4 8.2 61.8 40 61.8 77.9c0 6.3-.7 12.5-2.1 18.4C215.1 501 246.3 512 280 512l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-92 0c-6.6 0-12-5.4-12-12s5.4-12 12-12l124 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-124 0c-6.6 0-12-5.4-12-12s5.4-12 12-12l156 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-156 0c-6.6 0-12-5.4-12-12s5.4-12 12-12l124 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-136 0s0 0 0 0s0 0 0 0l-93.2 0L305 219.1c15-9.4 19.5-29.1 10.2-44.1z"
    ]
};
const $d8206b3ab2e65c05$export$996b5dea53b124e3 = $d8206b3ab2e65c05$export$2f78563e14e49916;
const $d8206b3ab2e65c05$export$b2c723344cff0d8 = {
    prefix: 'fas',
    iconName: 'less-than-equal',
    icon: [
        448,
        512,
        [],
        "f537",
        "M395.9 93.7c16.4-6.6 24.4-25.2 17.8-41.6s-25.2-24.4-41.6-17.8l-320 128C40 167.1 32 178.9 32 192s8 24.9 20.1 29.7l320 128c16.4 6.6 35-1.4 41.6-17.8s-1.4-35-17.8-41.6L150.2 192 395.9 93.7zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 416z"
    ]
};
const $d8206b3ab2e65c05$export$17cde74bf6f1ee89 = {
    prefix: 'fas',
    iconName: 'train',
    icon: [
        448,
        512,
        [
            128646
        ],
        "f238",
        "M96 0C43 0 0 43 0 96L0 352c0 48 35.2 87.7 81.1 94.9l-46 46C28.1 499.9 33.1 512 43 512l39.7 0c8.5 0 16.6-3.4 22.6-9.4L160 448l128 0 54.6 54.6c6 6 14.1 9.4 22.6 9.4l39.7 0c10 0 15-12.1 7.9-19.1l-46-46c46-7.1 81.1-46.9 81.1-94.9l0-256c0-53-43-96-96-96L96 0zM64 96c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32L96 224c-17.7 0-32-14.3-32-32l0-96zM224 288a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
const $d8206b3ab2e65c05$export$23a892b1a4b994bd = {
    prefix: 'fas',
    iconName: 'eye-low-vision',
    icon: [
        640,
        512,
        [
            "low-vision"
        ],
        "f2a8",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223 149.5c48.6-44.3 123-50.8 179.3-11.7c60.8 42.4 78.9 123.2 44.2 186.9L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 10.2-2.4 19.8-6.6 28.3L223 149.5zm223.1 298L83.1 161.5c-11 14.4-20.5 28.7-28.4 42.2l339 265.7c18.7-5.5 36.2-13 52.6-21.8zM34.5 268.3c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c3.1 0 6.1-.1 9.2-.2L33.1 247.8c-1.8 6.8-1.3 14 1.4 20.5z"
    ]
};
const $d8206b3ab2e65c05$export$7a65d2aa54cb4e93 = $d8206b3ab2e65c05$export$23a892b1a4b994bd;
const $d8206b3ab2e65c05$export$bfa312207b788ed9 = {
    prefix: 'fas',
    iconName: 'crow',
    icon: [
        640,
        512,
        [],
        "f520",
        "M456 0c-48.6 0-88 39.4-88 88l0 29.2L12.5 390.6c-14 10.8-16.6 30.9-5.9 44.9s30.9 16.6 44.9 5.9L126.1 384l133.1 0 46.6 113.1c5 12.3 19.1 18.1 31.3 13.1s18.1-19.1 13.1-31.3L311.1 384l40.9 0c1.1 0 2.1 0 3.2 0l46.6 113.2c5 12.3 19.1 18.1 31.3 13.1s18.1-19.1 13.1-31.3l-42-102C484.9 354.1 544 280 544 192l0-64 0-8 80.5-20.1c8.6-2.1 13.8-10.8 11.6-19.4C629 52 603.4 32 574 32l-50.1 0C507.7 12.5 483.3 0 456 0zm0 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
const $d8206b3ab2e65c05$export$e363e74e36cce80c = {
    prefix: 'fas',
    iconName: 'sailboat',
    icon: [
        576,
        512,
        [],
        "e445",
        "M256 16c0-7 4.5-13.2 11.2-15.3s13.9 .4 17.9 6.1l224 320c3.4 4.9 3.8 11.3 1.1 16.6s-8.2 8.6-14.2 8.6l-224 0c-8.8 0-16-7.2-16-16l0-320zM212.1 96.5c7 1.9 11.9 8.2 11.9 15.5l0 224c0 8.8-7.2 16-16 16L80 352c-5.7 0-11-3-13.8-8s-2.9-11-.1-16l128-224c3.6-6.3 11-9.4 18-7.5zM5.7 404.3C2.8 394.1 10.5 384 21.1 384l533.8 0c10.6 0 18.3 10.1 15.4 20.3l-4 14.3C550.7 473.9 500.4 512 443 512L133 512C75.6 512 25.3 473.9 9.7 418.7l-4-14.3z"
    ]
};
const $d8206b3ab2e65c05$export$eccfff9bfd585652 = {
    prefix: 'fas',
    iconName: 'window-restore',
    icon: [
        512,
        512,
        [],
        "f2d2",
        "M432 64L208 64c-8.8 0-16 7.2-16 16l0 16-64 0 0-16c0-44.2 35.8-80 80-80L432 0c44.2 0 80 35.8 80 80l0 224c0 44.2-35.8 80-80 80l-16 0 0-64 16 0c8.8 0 16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zM0 192c0-35.3 28.7-64 64-64l256 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192zm64 32c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 192c-17.7 0-32 14.3-32 32z"
    ]
};
const $d8206b3ab2e65c05$export$eaf727acca5a35e4 = {
    prefix: 'fas',
    iconName: 'square-plus',
    icon: [
        448,
        512,
        [
            61846,
            "plus-square"
        ],
        "f0fe",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM200 344l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
    ]
};
const $d8206b3ab2e65c05$export$b6359eebfe900c35 = $d8206b3ab2e65c05$export$eaf727acca5a35e4;
const $d8206b3ab2e65c05$export$75825a4c2b3375e = {
    prefix: 'fas',
    iconName: 'torii-gate',
    icon: [
        512,
        512,
        [
            9961
        ],
        "f6a1",
        "M0 80c0 26.5 21.5 48 48 48l16 0 0 64 64 0 0-64 96 0 0 64 64 0 0-64 96 0 0 64 64 0 0-64 16 0c26.5 0 48-21.5 48-48l0-66.6C512 6 506 0 498.6 0c-1.7 0-3.4 .3-5 1l-49 19.6C425.7 28.1 405.5 32 385.2 32L126.8 32c-20.4 0-40.5-3.9-59.4-11.4L18.4 1c-1.6-.6-3.3-1-5-1C6 0 0 6 0 13.4L0 80zM64 288l0 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-192 256 0 0 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-192 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0z"
    ]
};
const $d8206b3ab2e65c05$export$fe2358263efac504 = {
    prefix: 'fas',
    iconName: 'frog',
    icon: [
        576,
        512,
        [],
        "f52e",
        "M368 32c41.7 0 75.9 31.8 79.7 72.5l85.6 26.3c25.4 7.8 42.8 31.3 42.8 57.9c0 21.8-11.7 41.9-30.7 52.7L400.8 323.5 493.3 416l50.7 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-8.5 0-16.6-3.4-22.6-9.4L346.9 360.2c11.7-36 3.2-77.1-25.4-105.7c-40.6-40.6-106.3-40.6-146.9-.1L101 324.4c-6.4 6.1-6.7 16.2-.6 22.6s16.2 6.6 22.6 .6l73.8-70.2 .1-.1 .1-.1c3.5-3.5 7.3-6.6 11.3-9.2c27.9-18.5 65.9-15.4 90.5 9.2c24.7 24.7 27.7 62.9 9 90.9c-2.6 3.8-5.6 7.5-9 10.9L261.8 416l90.2 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L64 480c-35.3 0-64-28.7-64-64C0 249.6 127 112.9 289.3 97.5C296.2 60.2 328.8 32 368 32zm0 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
const $d8206b3ab2e65c05$export$2124c7628e573b84 = {
    prefix: 'fas',
    iconName: 'bucket',
    icon: [
        448,
        512,
        [],
        "e4cf",
        "M96 152l0 8-48 0 0-8C48 68.1 116.1 0 200 0l48 0c83.9 0 152 68.1 152 152l0 8-48 0 0-8c0-57.4-46.6-104-104-104l-48 0C142.6 48 96 94.6 96 152zM0 224c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-5.1 0L388.5 469c-2.6 24.4-23.2 43-47.7 43l-233.6 0c-24.6 0-45.2-18.5-47.7-43L37.1 256 32 256c-17.7 0-32-14.3-32-32z"
    ]
};
const $d8206b3ab2e65c05$export$7e9f0928967e03b = {
    prefix: 'fas',
    iconName: 'image',
    icon: [
        512,
        512,
        [],
        "f03e",
        "M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM323.8 202.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L170.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6l96 0 32 0 208 0c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176zM112 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    ]
};
const $d8206b3ab2e65c05$export$eed3c491effe6d12 = {
    prefix: 'fas',
    iconName: 'microphone',
    icon: [
        384,
        512,
        [],
        "f130",
        "M192 0C139 0 96 43 96 96l0 160c0 53 43 96 96 96s96-43 96-96l0-160c0-53-43-96-96-96zM64 216c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 89.1 66.2 162.7 152 174.4l0 33.6-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-33.6c85.8-11.7 152-85.3 152-174.4l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-40z"
    ]
};
const $d8206b3ab2e65c05$export$1da3b2e53dcafa2d = {
    prefix: 'fas',
    iconName: 'cow',
    icon: [
        640,
        512,
        [
            128004
        ],
        "f6c8",
        "M96 224l0 32 0 160c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-88.2c9.9 6.6 20.6 12 32 16.1l0 24.2c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16.9c5.3 .6 10.6 .9 16 .9s10.7-.3 16-.9l0 16.9c0 8.8 7.2 16 16 16s16-7.2 16-16l0-24.2c11.4-4 22.1-9.4 32-16.1l0 88.2c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-160 32 32 0 49.5c0 9.5 2.8 18.7 8.1 26.6L530 427c8.8 13.1 23.5 21 39.3 21c22.5 0 41.9-15.9 46.3-38l20.3-101.6c2.6-13-.3-26.5-8-37.3l-3.9-5.5 0-81.6c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 14.4-52.9-74.1C496 86.5 452.4 64 405.9 64L272 64l-16 0-64 0-48 0C77.7 64 24 117.7 24 184l0 54C9.4 249.8 0 267.8 0 288l0 17.6c0 8 6.4 14.4 14.4 14.4C46.2 320 72 294.2 72 262.4l0-6.4 0-32 0-40c0-24.3 12.1-45.8 30.5-58.9C98.3 135.9 96 147.7 96 160l0 64zM560 336a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM166.6 166.6c-4.2-4.2-6.6-10-6.6-16c0-12.5 10.1-22.6 22.6-22.6l178.7 0c12.5 0 22.6 10.1 22.6 22.6c0 6-2.4 11.8-6.6 16l-23.4 23.4C332.2 211.8 302.7 224 272 224s-60.2-12.2-81.9-33.9l-23.4-23.4z"
    ]
};
const $d8206b3ab2e65c05$export$7de776bdab4e536d = {
    prefix: 'fas',
    iconName: 'caret-up',
    icon: [
        320,
        512,
        [],
        "f0d8",
        "M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l256 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"
    ]
};
const $d8206b3ab2e65c05$export$7484ff654cd6474f = {
    prefix: 'fas',
    iconName: 'screwdriver',
    icon: [
        512,
        512,
        [
            129691
        ],
        "f54a",
        "M465 7c-8.5-8.5-22-9.4-31.6-2.1l-104 80c-5.9 4.5-9.4 11.6-9.4 19l0 54.1-85.6 85.6c6.7 4.2 13 9.3 18.8 15.1s10.9 12.2 15.1 18.8L353.9 192l54.1 0c7.5 0 14.5-3.5 19-9.4l80-104c7.4-9.6 6.5-23.1-2.1-31.6L465 7zM121.4 281.4l-112 112c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l112-112c30.2-30.2 30.2-79.1 0-109.3s-79.1-30.2-109.3 0z"
    ]
};
const $d8206b3ab2e65c05$export$5e30548b7f8eeb95 = {
    prefix: 'fas',
    iconName: 'folder-closed',
    icon: [
        512,
        512,
        [],
        "e185",
        "M448 480L64 480c-35.3 0-64-28.7-64-64L0 192l512 0 0 224c0 35.3-28.7 64-64 64zm64-320L0 160 0 96C0 60.7 28.7 32 64 32l128 0c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8l160 0c35.3 0 64 28.7 64 64z"
    ]
};
const $d8206b3ab2e65c05$export$197b9567e88a0b1d = {
    prefix: 'fas',
    iconName: 'house-tsunami',
    icon: [
        576,
        512,
        [],
        "e515",
        "M80.8 136.5C104.9 93.8 152.6 64 209 64c16.9 0 33.1 2.7 48.2 7.7c16.8 5.5 34.9-3.6 40.4-20.4s-3.6-34.9-20.4-40.4C255.8 3.8 232.8 0 209 0C95.2 0 0 88 0 200c0 91.6 53.5 172.1 142.2 194.1c13.4 3.8 27.5 5.9 42.2 5.9c.7 0 1.4 0 2.1-.1c1.8 0 3.7 .1 5.5 .1c0 0 0 0 0 0c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7c0 0 0 0 0 0C439.4 325.2 410.9 336 384 336c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0c-22.4 15.5-49.9 26.1-77.4 26.1c0 0-.1 0-.1 0c-12.4 0-24-1.5-34.9-4.3C121.6 320.2 96 287 96 248c0-48.5 39.5-88 88.4-88c13.5 0 26.1 3 37.5 8.3c16 7.5 35.1 .6 42.5-15.5s.6-35.1-15.5-42.5C229.3 101.1 207.4 96 184.4 96c-40 0-76.4 15.4-103.6 40.5zm252-18.1c-8.1 6-12.8 15.5-12.8 25.6l0 121c1.6 1 3.3 2 4.8 3.1c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.3 78.1 3.4c10.6 8.8 24.2 15.6 37.3 18.6c5.8 1.4 11.2 3.4 16.2 6.2c.7-2.7 1.1-5.5 1.1-8.4l-.4-144c0-10-4.7-19.4-12.7-25.5l-95.5-72c-11.4-8.6-27.1-8.6-38.5 0l-96 72zM384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1c0 0 0 0 0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7c0 0 0 0 0 0C439.4 437.2 410.9 448 384 448z"
    ]
};
const $d8206b3ab2e65c05$export$5498258519fc5b72 = {
    prefix: 'fas',
    iconName: 'square-nfi',
    icon: [
        448,
        512,
        [],
        "e576",
        "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm75.7 64.6C68.8 162.5 64 168.8 64 176l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-102.2 66.3 110.5c3.7 6.2 11.1 9.1 18 7.2s11.7-8.2 11.7-15.4l0-160c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 102.2L93.7 167.8c-3.7-6.2-11.1-9.1-18-7.2zM224 176l0 64 0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-32 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160z"
    ]
};
const $d8206b3ab2e65c05$export$cbe485a104805f4f = {
    prefix: 'fas',
    iconName: 'arrow-up-from-ground-water',
    icon: [
        576,
        512,
        [],
        "e4b5",
        "M288 352c17.7 0 32-14.3 32-32l0-210.7 25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 109.3 256 320c0 17.7 14.3 32 32 32zm-18.5 69.9C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1c0 0 0 0 0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7c0 0 0 0 0 0C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0zM192 192L48 192c-26.5 0-48 21.5-48 48L0 425c5.3-3.1 11.2-5.4 17.5-6.9c13.1-3.1 26.7-9.8 37.3-18.6c22.2-18.7 54.3-20.1 78.1-3.4c18 12.4 40.1 20.3 59.1 20.3L192 192zm384 48c0-26.5-21.5-48-48-48l-144 0 0 224.5s0 0 0 0c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.4 78.1 3.4c10.6 8.8 24.2 15.6 37.3 18.6c6.3 1.5 12.1 3.8 17.5 6.9l0-185z"
    ]
};
const $d8206b3ab2e65c05$export$98401bb29cff68e0 = {
    prefix: 'fas',
    iconName: 'martini-glass',
    icon: [
        512,
        512,
        [
            127864,
            "glass-martini-alt"
        ],
        "f57b",
        "M32 0C19.1 0 7.4 7.8 2.4 19.8s-2.2 25.7 6.9 34.9L224 269.3 224 448l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0 96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-178.7L502.6 54.6c9.2-9.2 11.9-22.9 6.9-34.9S492.9 0 480 0L32 0zM173.3 128l-64-64 293.5 0-64 64-165.5 0z"
    ]
};
const $d8206b3ab2e65c05$export$2258439b8f4e7acb = $d8206b3ab2e65c05$export$98401bb29cff68e0;
const $d8206b3ab2e65c05$export$3cbda23149da6f11 = {
    prefix: 'fas',
    iconName: 'square-binary',
    icon: [
        448,
        512,
        [],
        "e69b",
        "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm144 4c-24.3 0-44 19.7-44 44l0 48c0 24.3 19.7 44 44 44l32 0c24.3 0 44-19.7 44-44l0-48c0-24.3-19.7-44-44-44l-32 0zm-4 44c0-2.2 1.8-4 4-4l32 0c2.2 0 4 1.8 4 4l0 48c0 2.2-1.8 4-4 4l-32 0c-2.2 0-4-1.8-4-4l0-48zm140-44c-11 0-20 9-20 20c0 9.7 6.9 17.7 16 19.6l0 76.4c0 11 9 20 20 20s20-9 20-20l0-96c0-11-9-20-20-20l-16 0zM132 296c0 9.7 6.9 17.7 16 19.6l0 76.4c0 11 9 20 20 20s20-9 20-20l0-96c0-11-9-20-20-20l-16 0c-11 0-20 9-20 20zm96 24l0 48c0 24.3 19.7 44 44 44l32 0c24.3 0 44-19.7 44-44l0-48c0-24.3-19.7-44-44-44l-32 0c-24.3 0-44 19.7-44 44zm44-4l32 0c2.2 0 4 1.8 4 4l0 48c0 2.2-1.8 4-4 4l-32 0c-2.2 0-4-1.8-4-4l0-48c0-2.2 1.8-4 4-4z"
    ]
};
const $d8206b3ab2e65c05$export$7adaa412bd8eb08f = {
    prefix: 'fas',
    iconName: 'rotate-left',
    icon: [
        512,
        512,
        [
            "rotate-back",
            "rotate-backward",
            "undo-alt"
        ],
        "f2ea",
        "M48.5 224L40 224c-13.3 0-24-10.7-24-24L16 72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8L48.5 224z"
    ]
};
const $d8206b3ab2e65c05$export$9706706f1bc7b12 = $d8206b3ab2e65c05$export$7adaa412bd8eb08f;
const $d8206b3ab2e65c05$export$4ceb0b05fed961a9 = $d8206b3ab2e65c05$export$7adaa412bd8eb08f;
const $d8206b3ab2e65c05$export$c8197b992c46c4a6 = $d8206b3ab2e65c05$export$7adaa412bd8eb08f;
const $d8206b3ab2e65c05$export$ccaa019a3fd4563f = {
    prefix: 'fas',
    iconName: 'table-columns',
    icon: [
        512,
        512,
        [
            "columns"
        ],
        "f0db",
        "M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm64 64l0 256 160 0 0-256L64 160zm384 0l-160 0 0 256 160 0 0-256z"
    ]
};
const $d8206b3ab2e65c05$export$bb861166644ac28a = $d8206b3ab2e65c05$export$ccaa019a3fd4563f;
const $d8206b3ab2e65c05$export$4fbda8f64648f3b5 = {
    prefix: 'fas',
    iconName: 'lemon',
    icon: [
        448,
        512,
        [
            127819
        ],
        "f094",
        "M448 96c0-35.3-28.7-64-64-64c-6.6 0-13 1-19 2.9c-22.5 7-48.1 14.9-71 9c-75.2-19.1-156.4 11-213.7 68.3S-7.2 250.8 11.9 326c5.8 22.9-2 48.4-9 71C1 403 0 409.4 0 416c0 35.3 28.7 64 64 64c6.6 0 13-1 19.1-2.9c22.5-7 48.1-14.9 71-9c75.2 19.1 156.4-11 213.7-68.3s87.5-138.5 68.3-213.7c-5.8-22.9 2-48.4 9-71c1.9-6 2.9-12.4 2.9-19.1zM212.5 127.4c-54.6 16-101.1 62.5-117.1 117.1C92.9 253 84 257.8 75.5 255.4S62.2 244 64.6 235.5c19.1-65.1 73.7-119.8 138.9-138.9c8.5-2.5 17.4 2.4 19.9 10.9s-2.4 17.4-10.9 19.9z"
    ]
};
const $d8206b3ab2e65c05$export$280300af4baa1a3e = {
    prefix: 'fas',
    iconName: 'head-side-mask',
    icon: [
        576,
        512,
        [],
        "e063",
        "M32 224.2c0-22.2 3.2-43.6 9.2-63.9L262.2 321c-4 9.5-6.2 20-6.2 31l0 160-128 0c-17.7 0-32-14.3-32-32l0-72.7c0-16.7-6.9-32.5-17.1-45.8C48.6 322.4 32 274.1 32 224.2zm248.3 70.4L53 129.3C88.7 53 166.2 0 256 0l24 0c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c5.4 6.7 8.6 14.8 9.4 23.2L336 272c-21.7 0-41.3 8.6-55.7 22.6zM336 304l198 0s0 0 0 0l10 0-19.7 64L368 368c-8.8 0-16 7.2-16 16s7.2 16 16 16l146.5 0-9.8 32L368 432c-8.8 0-16 7.2-16 16s7.2 16 16 16l126.8 0-.9 2.8c-8.3 26.9-33.1 45.2-61.2 45.2L288 512l0-160c0-14 6-26.7 15.6-35.4c0 0 0 0 0 0c8.5-7.8 19.9-12.6 32.4-12.6zm48-80a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
const $d8206b3ab2e65c05$export$b4c63e9bfc7906f1 = {
    prefix: 'fas',
    iconName: 'handshake',
    icon: [
        640,
        512,
        [],
        "f2b5",
        "M323.4 85.2l-96.8 78.4c-16.1 13-19.2 36.4-7 53.1c12.9 17.8 38 21.3 55.3 7.8l99.3-77.2c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L512 316.8 512 128l-.7 0-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2zm22.8 124.4l-51.7 40.2C263 274.4 217.3 268 193.7 235.6c-22.2-30.5-16.6-73.1 12.7-96.8l83.2-67.3c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-72 48 0 224 28.2 0 91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c4.5-4.9 7.8-10.6 9.9-16.5c19.4 13 45.8 10.3 62.1-7.5c17.9-19.5 16.6-49.9-2.9-67.8l-134.2-123zM16 128c-8.8 0-16 7.2-16 16L0 352c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-224-80 0zM48 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM544 128l0 224c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-208c0-8.8-7.2-16-16-16l-80 0zm32 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"
    ]
};
const $d8206b3ab2e65c05$export$31ee86ac717db552 = {
    prefix: 'fas',
    iconName: 'gem',
    icon: [
        512,
        512,
        [
            128142
        ],
        "f3a5",
        "M116.7 33.8c4.5-6.1 11.7-9.8 19.3-9.8l240 0c7.6 0 14.8 3.6 19.3 9.8l112 152c6.8 9.2 6.1 21.9-1.5 30.4l-232 256c-4.5 5-11 7.9-17.8 7.9s-13.2-2.9-17.8-7.9l-232-256c-7.7-8.5-8.3-21.2-1.5-30.4l112-152zm38.5 39.8c-3.3 2.5-4.2 7-2.1 10.5l57.4 95.6L63.3 192c-4.1 .3-7.3 3.8-7.3 8s3.2 7.6 7.3 8l192 16c.4 0 .9 0 1.3 0l192-16c4.1-.3 7.3-3.8 7.3-8s-3.2-7.6-7.3-8L301.5 179.8l57.4-95.6c2.1-3.5 1.2-8.1-2.1-10.5s-7.9-2-10.7 1L256 172.2 165.9 74.6c-2.8-3-7.4-3.4-10.7-1z"
    ]
};
const $d8206b3ab2e65c05$export$5879d0bca1aa497b = {
    prefix: 'fas',
    iconName: 'dolly',
    icon: [
        576,
        512,
        [
            "dolly-box"
        ],
        "f472",
        "M0 32C0 14.3 14.3 0 32 0l72.9 0c27.5 0 52 17.6 60.7 43.8L257.7 320c30.1 .5 56.8 14.9 74 37l202.1-67.4c16.8-5.6 34.9 3.5 40.5 20.2s-3.5 34.9-20.2 40.5L352 417.7c-.9 52.2-43.5 94.3-96 94.3c-53 0-96-43-96-96c0-30.8 14.5-58.2 37-75.8L104.9 64 32 64C14.3 64 0 49.7 0 32zM244.8 134.5c-5.5-16.8 3.7-34.9 20.5-40.3L311 79.4l19.8 60.9 60.9-19.8L371.8 59.6l45.7-14.8c16.8-5.5 34.9 3.7 40.3 20.5l49.4 152.2c5.5 16.8-3.7 34.9-20.5 40.3L334.5 307.2c-16.8 5.5-34.9-3.7-40.3-20.5L244.8 134.5z"
    ]
};
const $d8206b3ab2e65c05$export$461bbb9e92cc531b = $d8206b3ab2e65c05$export$5879d0bca1aa497b;
const $d8206b3ab2e65c05$export$c4ab83701fc591a5 = {
    prefix: 'fas',
    iconName: 'smoking',
    icon: [
        640,
        512,
        [
            128684
        ],
        "f48d",
        "M448 32l0 11c0 38.2 15.2 74.8 42.2 101.8l21 21c21 21 32.8 49.5 32.8 79.2l0 11c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-11c0-12.7-5.1-24.9-14.1-33.9l-21-21C405.9 151.1 384 98.1 384 43l0-11c0-17.7 14.3-32 32-32s32 14.3 32 32zM576 256l0-11c0-38.2-15.2-74.8-42.2-101.8l-21-21c-21-21-32.8-49.5-32.8-79.2l0-11c0-17.7 14.3-32 32-32s32 14.3 32 32l0 11c0 12.7 5.1 24.9 14.1 33.9l21 21c39 39 60.9 91.9 60.9 147.1l0 11c0 17.7-14.3 32-32 32s-32-14.3-32-32zM0 416c0-35.3 28.7-64 64-64l352 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32L64 512c-35.3 0-64-28.7-64-64l0-32zm224 0l0 32 160 0 0-32-160 0zm288-64c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32z"
    ]
};
const $d8206b3ab2e65c05$export$e0601b1f239fec74 = {
    prefix: 'fas',
    iconName: 'minimize',
    icon: [
        512,
        512,
        [
            "compress-arrows-alt"
        ],
        "f78c",
        "M456 224l-144 0c-13.3 0-24-10.7-24-24l0-144c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l40 40L442.3 5.7C446 2 450.9 0 456 0s10 2 13.7 5.7l36.7 36.7C510 46 512 50.9 512 56s-2 10-5.7 13.7L433 143l40 40c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8zm0 64c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-40 40 73.4 73.4c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7l-36.7 36.7C466 510 461.1 512 456 512s-10-2-13.7-5.7L369 433l-40 40c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2l0-144c0-13.3 10.7-24 24-24l144 0zm-256 0c13.3 0 24 10.7 24 24l0 144c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-40-40L69.7 506.3C66 510 61.1 512 56 512s-10-2-13.7-5.7L5.7 469.7C2 466 0 461.1 0 456s2-10 5.7-13.7L79 369 39 329c-6.9-6.9-8.9-17.2-5.2-26.2s12.5-14.8 22.2-14.8l144 0zM56 224c-9.7 0-18.5-5.8-22.2-14.8s-1.7-19.3 5.2-26.2l40-40L5.7 69.7C2 66 0 61.1 0 56s2-10 5.7-13.7L42.3 5.7C46 2 50.9 0 56 0s10 2 13.7 5.7L143 79l40-40c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2l0 144c0 13.3-10.7 24-24 24L56 224z"
    ]
};
const $d8206b3ab2e65c05$export$39205db0ea980efd = $d8206b3ab2e65c05$export$e0601b1f239fec74;
const $d8206b3ab2e65c05$export$6f9b0bfc012deb25 = {
    prefix: 'fas',
    iconName: 'monument',
    icon: [
        384,
        512,
        [],
        "f5a6",
        "M180.7 4.7c6.2-6.2 16.4-6.2 22.6 0l80 80c2.5 2.5 4.1 5.8 4.6 9.3l40.2 322L55.9 416 96.1 94c.4-3.5 2-6.8 4.6-9.3l80-80zM152 272c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0zM32 448l320 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
const $d8206b3ab2e65c05$export$695fae58f55c3a87 = {
    prefix: 'fas',
    iconName: 'snowplow',
    icon: [
        640,
        512,
        [],
        "f7d2",
        "M298.9 64l68.6 160L256 224l-64-64 0-96 106.9 0zM445.1 242.7l-87.4-204C347.6 15.3 324.5 0 298.9 0L176 0c-26.5 0-48 21.5-48 48l0 112-32 0c-17.7 0-32 14.3-32 32l0 106.8C26.2 316.8 0 355.3 0 400c0 61.9 50.1 112 112 112l256 0c61.9 0 112-50.1 112-112c0-17.2-3.9-33.5-10.8-48l42.8 0 0 50.7c0 17 6.7 33.3 18.7 45.3l54.6 54.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L576 402.7l0-82.7 0-84.8L633 164c11-13.8 8.8-33.9-5-45s-33.9-8.8-45 5l-57 71.2c-9.1 11.3-14 25.4-14 40l0 52.8-64 0 0-31.3c.1-2.4-.2-4.8-.6-7.1s-1.2-4.7-2.2-6.8zM368 352c26.5 0 48 21.5 48 48s-21.5 48-48 48l-256 0c-26.5 0-48-21.5-48-48s21.5-48 48-48l256 0zM144 400a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm216 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-56-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM200 424a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
const $d8206b3ab2e65c05$export$48b60f1720e09944 = {
    prefix: 'fas',
    iconName: 'angles-right',
    icon: [
        512,
        512,
        [
            187,
            "angle-double-right"
        ],
        "f101",
        "M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 265.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160zm-352 160l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 73.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"
    ]
};
const $d8206b3ab2e65c05$export$792931403404faf0 = $d8206b3ab2e65c05$export$48b60f1720e09944;
const $d8206b3ab2e65c05$export$8ec2f752344b69bd = {
    prefix: 'fas',
    iconName: 'cannabis',
    icon: [
        512,
        512,
        [],
        "f55f",
        "M256 0c5.3 0 10.3 2.7 13.3 7.1c15.8 23.5 36.7 63.7 49.2 109c7.2 26.4 11.8 55.2 10.4 84c11.5-8.8 23.7-16.7 35.8-23.6c41-23.3 84.4-36.9 112.2-42.5c5.2-1 10.7 .6 14.4 4.4s5.4 9.2 4.4 14.5c-5.6 27.7-19.3 70.9-42.7 111.7c-9.1 15.9-19.9 31.7-32.4 46.3c27.8 6.6 52.4 17.3 67.2 25.5c5.1 2.8 8.2 8.2 8.2 14s-3.2 11.2-8.2 14c-15.2 8.4-40.9 19.5-69.8 26.1c-20.2 4.6-42.9 7.2-65.2 4.6l8.3 33.1c1.5 6.1-.6 12.4-5.5 16.4s-11.6 4.6-17.2 1.9L280 417.2l0 70.8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-70.8-58.5 29.1c-5.6 2.8-12.3 2.1-17.2-1.9s-7-10.3-5.5-16.4l8.3-33.1c-22.2 2.6-45 0-65.2-4.6c-28.9-6.6-54.6-17.6-69.8-26.1c-5.1-2.8-8.2-8.2-8.2-14s3.2-11.2 8.2-14c14.8-8.2 39.4-18.8 67.2-25.5C78.9 296.3 68.1 280.5 59 264.6c-23.4-40.8-37.1-84-42.7-111.7c-1.1-5.2 .6-10.7 4.4-14.5s9.2-5.4 14.4-4.4c27.9 5.5 71.2 19.2 112.2 42.5c12.1 6.9 24.3 14.7 35.8 23.6c-1.4-28.7 3.1-57.6 10.4-84c12.5-45.3 33.4-85.5 49.2-109c3-4.4 8-7.1 13.3-7.1z"
    ]
};
const $d8206b3ab2e65c05$export$86c4e45dc3302d15 = {
    prefix: 'fas',
    iconName: 'circle-play',
    icon: [
        512,
        512,
        [
            61469,
            "play-circle"
        ],
        "f144",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM188.3 147.1c-7.6 4.2-12.3 12.3-12.3 20.9l0 176c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88c-7.4-4.5-16.7-4.7-24.3-.5z"
    ]
};
const $d8206b3ab2e65c05$export$cf04333781061c5e = $d8206b3ab2e65c05$export$86c4e45dc3302d15;
const $d8206b3ab2e65c05$export$bed2b0ed4ae45e0d = {
    prefix: 'fas',
    iconName: 'tablets',
    icon: [
        640,
        512,
        [],
        "f490",
        "M614.3 247c-5.2 7.9-16.2 8.5-22.9 1.8L391.2 48.6c-6.7-6.7-6.2-17.8 1.8-22.9C418.1 9.4 447.9 0 480 0c88.4 0 160 71.6 160 160c0 32.1-9.4 61.9-25.7 87zM567 294.3c-25 16.3-54.9 25.7-87 25.7c-88.4 0-160-71.6-160-160c0-32.1 9.4-61.9 25.7-87c5.2-7.9 16.2-8.5 22.9-1.8L568.8 271.4c6.7 6.7 6.2 17.8-1.8 22.9zM301.5 368c9.5 0 16.9 8.2 15 17.5C301.1 457.8 236.9 512 160 512S18.9 457.8 3.5 385.5c-2-9.3 5.5-17.5 15-17.5l283.1 0zm0-32L18.5 336c-9.5 0-16.9-8.2-15-17.5C18.9 246.2 83.1 192 160 192s141.1 54.2 156.5 126.5c2 9.3-5.5 17.5-15 17.5z"
    ]
};
const $d8206b3ab2e65c05$export$6bad2c9f317b52e5 = {
    prefix: 'fas',
    iconName: 'ethernet',
    icon: [
        512,
        512,
        [],
        "f796",
        "M0 224L0 416c0 17.7 14.3 32 32 32l64 0 0-112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 112 64 0 0-112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 112 64 0 0-112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 112 64 0 0-112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 112 64 0c17.7 0 32-14.3 32-32l0-192c0-17.7-14.3-32-32-32l-32 0 0-32c0-17.7-14.3-32-32-32l-32 0 0-32c0-17.7-14.3-32-32-32L160 64c-17.7 0-32 14.3-32 32l0 32-32 0c-17.7 0-32 14.3-32 32l0 32-32 0c-17.7 0-32 14.3-32 32z"
    ]
};
const $d8206b3ab2e65c05$export$902a3969bb113dff = {
    prefix: 'fas',
    iconName: 'euro-sign',
    icon: [
        320,
        512,
        [
            8364,
            "eur",
            "euro"
        ],
        "f153",
        "M48.1 240c-.1 2.7-.1 5.3-.1 8l0 16c0 2.7 0 5.3 .1 8L32 272c-17.7 0-32 14.3-32 32s14.3 32 32 32l28.3 0C89.9 419.9 170 480 264 480l24 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-24 0c-57.9 0-108.2-32.4-133.9-80L256 336c17.7 0 32-14.3 32-32s-14.3-32-32-32l-143.8 0c-.1-2.6-.2-5.3-.2-8l0-16c0-2.7 .1-5.4 .2-8L256 240c17.7 0 32-14.3 32-32s-14.3-32-32-32l-125.9 0c25.7-47.6 76-80 133.9-80l24 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-24 0C170 32 89.9 92.1 60.3 176L32 176c-17.7 0-32 14.3-32 32s14.3 32 32 32l16.1 0z"
    ]
};
const $d8206b3ab2e65c05$export$4b859160cfeb12ff = $d8206b3ab2e65c05$export$902a3969bb113dff;
const $d8206b3ab2e65c05$export$bdabbefede2d3a2 = $d8206b3ab2e65c05$export$902a3969bb113dff;
const $d8206b3ab2e65c05$export$a339864ee3df7e9a = {
    prefix: 'fas',
    iconName: 'chair',
    icon: [
        448,
        512,
        [
            129681
        ],
        "f6c0",
        "M248 48l0 208 48 0 0-197.3c23.9 13.8 40 39.7 40 69.3l0 128 48 0 0-128C384 57.3 326.7 0 256 0L192 0C121.3 0 64 57.3 64 128l0 128 48 0 0-128c0-29.6 16.1-55.5 40-69.3L152 256l48 0 0-208 48 0zM48 288c-12.1 0-23.2 6.8-28.6 17.7l-16 32c-5 9.9-4.4 21.7 1.4 31.1S20.9 384 32 384l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96 256 0 0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c11.1 0 21.4-5.7 27.2-15.2s6.4-21.2 1.4-31.1l-16-32C423.2 294.8 412.1 288 400 288L48 288z"
    ]
};
const $d8206b3ab2e65c05$export$c2e9877668862374 = {
    prefix: 'fas',
    iconName: 'circle-check',
    icon: [
        512,
        512,
        [
            61533,
            "check-circle"
        ],
        "f058",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    ]
};
const $d8206b3ab2e65c05$export$be9e388158c74f29 = $d8206b3ab2e65c05$export$c2e9877668862374;
const $d8206b3ab2e65c05$export$229de76dfef2687f = {
    prefix: 'fas',
    iconName: 'circle-stop',
    icon: [
        512,
        512,
        [
            62094,
            "stop-circle"
        ],
        "f28d",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 160l128 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32z"
    ]
};
const $d8206b3ab2e65c05$export$47af2aad60ab3e7c = $d8206b3ab2e65c05$export$229de76dfef2687f;
const $d8206b3ab2e65c05$export$aaaddd2cf7e20f64 = {
    prefix: 'fas',
    iconName: 'compass-drafting',
    icon: [
        512,
        512,
        [
            "drafting-compass"
        ],
        "f568",
        "M352 96c0 14.3-3.1 27.9-8.8 40.2L396 227.4c-23.7 25.3-54.2 44.1-88.5 53.6L256 192c0 0 0 0 0 0s0 0 0 0l-68 117.5c21.5 6.8 44.3 10.5 68.1 10.5c70.7 0 133.8-32.7 174.9-84c11.1-13.8 31.2-16 45-5s16 31.2 5 45C428.1 341.8 347 384 256 384c-35.4 0-69.4-6.4-100.7-18.1L98.7 463.7C94 471.8 87 478.4 78.6 482.6L23.2 510.3c-5 2.5-10.9 2.2-15.6-.7S0 501.5 0 496l0-55.4c0-8.4 2.2-16.7 6.5-24.1l60-103.7C53.7 301.6 41.8 289.3 31.2 276c-11.1-13.8-8.8-33.9 5-45s33.9-8.8 45 5c5.7 7.1 11.8 13.8 18.2 20.1l69.4-119.9c-5.6-12.2-8.8-25.8-8.8-40.2c0-53 43-96 96-96s96 43 96 96zm21 297.9c32.6-12.8 62.5-30.8 88.9-52.9l43.7 75.5c4.2 7.3 6.5 15.6 6.5 24.1l0 55.4c0 5.5-2.9 10.7-7.6 13.6s-10.6 3.2-15.6 .7l-55.4-27.7c-8.4-4.2-15.4-10.8-20.1-18.9L373 393.9zM256 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
const $d8206b3ab2e65c05$export$c8c2b127d13b9d79 = $d8206b3ab2e65c05$export$aaaddd2cf7e20f64;
const $d8206b3ab2e65c05$export$2eff9f6cbe00a643 = {
    prefix: 'fas',
    iconName: 'plate-wheat',
    icon: [
        512,
        512,
        [],
        "e55a",
        "M176 32c44.2 0 80 35.8 80 80l0 16c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80l0-16c0-8.8 7.2-16 16-16zM56 64l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM24 136l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 184c-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 96c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24zM272 48c0-8.8 7.2-16 16-16c44.2 0 80 35.8 80 80l0 16c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80l0-16zM400 32c44.2 0 80 35.8 80 80l0 16c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80l0-16c0-8.8 7.2-16 16-16zm80 160l0 16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16l0-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM352 176c8.8 0 16 7.2 16 16l0 16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16l0-16c0-44.2 35.8-80 80-80zm-96 16l0 16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16l0-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM3.5 347.6C1.6 332.9 13 320 27.8 320l456.4 0c14.8 0 26.2 12.9 24.4 27.6C502.3 397.8 464.2 437 416 446l0 2c0 17.7-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32l0-2c-48.2-9-86.3-48.2-92.5-98.4z"
    ]
};
const $d8206b3ab2e65c05$export$78792ed87d92a3ad = {
    prefix: 'fas',
    iconName: 'icicles',
    icon: [
        512,
        512,
        [],
        "f7ad",
        "M75.8 304.8L1 35.7c-.7-2.5-1-5-1-7.5C0 12.6 12.6 0 28.2 0H482.4C498.8 0 512 13.2 512 29.6c0 1.6-.1 3.3-.4 4.9L434.6 496.1c-1.5 9.2-9.5 15.9-18.8 15.9c-9.2 0-17.1-6.6-18.7-15.6L336 160 307.2 303.9c-1.9 9.3-10.1 16.1-19.6 16.1c-9.2 0-17.2-6.2-19.4-15.1L240 192 210.6 368.2c-1.5 9.1-9.4 15.8-18.6 15.8s-17.1-6.7-18.6-15.8L144 192 115.9 304.3c-2.3 9.2-10.6 15.7-20.1 15.7c-9.3 0-17.5-6.2-20-15.2z"
    ]
};
const $d8206b3ab2e65c05$export$d359c2cc7640953c = {
    prefix: 'fas',
    iconName: 'person-shelter',
    icon: [
        512,
        512,
        [],
        "e54f",
        "M271.9 4.2c-9.8-5.6-21.9-5.6-31.8 0l-224 128C6.2 137.9 0 148.5 0 160L0 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-301.4L256 68.9 448 178.6 448 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-320c0-11.5-6.2-22.1-16.1-27.8l-224-128zM256 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm-8 280l0-88 16 0 0 88c0 13.3 10.7 24 24 24s24-10.7 24-24l0-174.5 26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3l-19.5 0c-32.4 0-62.1 17.8-77.5 46.3l-37.9 70.3c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L200 313.5 200 488c0 13.3 10.7 24 24 24s24-10.7 24-24z"
    ]
};
const $d8206b3ab2e65c05$export$771cf879fba0cf93 = {
    prefix: 'fas',
    iconName: 'neuter',
    icon: [
        384,
        512,
        [
            9906
        ],
        "f22c",
        "M80 176a112 112 0 1 1 224 0A112 112 0 1 1 80 176zM224 349.1c81.9-15 144-86.8 144-173.1C368 78.8 289.2 0 192 0S16 78.8 16 176c0 86.3 62.1 158.1 144 173.1L160 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-130.9z"
    ]
};
const $d8206b3ab2e65c05$export$a75288855ea05282 = {
    prefix: 'fas',
    iconName: 'id-badge',
    icon: [
        384,
        512,
        [],
        "f2c1",
        "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zm96 320l64 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16L96 416c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM144 64l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
const $d8206b3ab2e65c05$export$e6789173649caa25 = {
    prefix: 'fas',
    iconName: 'marker',
    icon: [
        512,
        512,
        [],
        "f5a1",
        "M481 31C445.1-4.8 386.9-4.8 351 31l-15 15L322.9 33C294.8 4.9 249.2 4.9 221.1 33L135 119c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L255 66.9c9.4-9.4 24.6-9.4 33.9 0L302.1 80 186.3 195.7 316.3 325.7 481 161c35.9-35.9 35.9-94.1 0-129.9zM293.7 348.3L163.7 218.3 99.5 282.5c-48 48-80.8 109.2-94.1 175.8l-5 25c-1.6 7.9 .9 16 6.6 21.7s13.8 8.1 21.7 6.6l25-5c66.6-13.3 127.8-46.1 175.8-94.1l64.2-64.2z"
    ]
};
const $d8206b3ab2e65c05$export$3f2d51c0547bf984 = {
    prefix: 'fas',
    iconName: 'face-laugh-beam',
    icon: [
        512,
        512,
        [
            128513,
            "laugh-beam"
        ],
        "f59a",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1l275.2 0c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zM217.6 212.8s0 0 0 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0zm160 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0z"
    ]
};
const $d8206b3ab2e65c05$export$a88d1f4073ea9369 = $d8206b3ab2e65c05$export$3f2d51c0547bf984;
const $d8206b3ab2e65c05$export$2a66e6044c1f7036 = {
    prefix: 'fas',
    iconName: 'helicopter-symbol',
    icon: [
        512,
        512,
        [],
        "e502",
        "M445.3 224l64.7 0C495.6 108.2 403.8 16.4 288 2l0 64.7C368.4 80.1 431.9 143.6 445.3 224zM510 288l-64.7 0C431.9 368.4 368.4 431.9 288 445.3l0 64.7c115.8-14.4 207.6-106.2 222-222zM2 288C16.4 403.8 108.2 495.6 224 510l0-64.7C143.6 431.9 80.1 368.4 66.7 288L2 288zm0-64l64.7 0C80.1 143.6 143.6 80.1 224 66.7L224 2C108.2 16.4 16.4 108.2 2 224zm206-64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64 96 0 0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-192c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64-96 0 0-64z"
    ]
};
const $d8206b3ab2e65c05$export$e119aada7f690d05 = {
    prefix: 'fas',
    iconName: 'universal-access',
    icon: [
        512,
        512,
        [],
        "f29a",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm161.5-86.1c-12.2-5.2-26.3 .4-31.5 12.6s.4 26.3 12.6 31.5l11.9 5.1c17.3 7.4 35.2 12.9 53.6 16.3l0 50.1c0 4.3-.7 8.6-2.1 12.6l-28.7 86.1c-4.2 12.6 2.6 26.2 15.2 30.4s26.2-2.6 30.4-15.2l24.4-73.2c1.3-3.8 4.8-6.4 8.8-6.4s7.6 2.6 8.8 6.4l24.4 73.2c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-28.7-86.1c-1.4-4.1-2.1-8.3-2.1-12.6l0-50.1c18.4-3.5 36.3-8.9 53.6-16.3l11.9-5.1c12.2-5.2 17.8-19.3 12.6-31.5s-19.3-17.8-31.5-12.6L338.7 175c-26.1 11.2-54.2 17-82.7 17s-56.5-5.8-82.7-17l-11.9-5.1zM256 160a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
    ]
};
const $d8206b3ab2e65c05$export$7b69b3617b84259b = {
    prefix: 'fas',
    iconName: 'circle-chevron-up',
    icon: [
        512,
        512,
        [
            "chevron-circle-up"
        ],
        "f139",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM377 271c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-87-87-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 167c9.4-9.4 24.6-9.4 33.9 0L377 271z"
    ]
};
const $d8206b3ab2e65c05$export$b786cf5db03f2c36 = $d8206b3ab2e65c05$export$7b69b3617b84259b;
const $d8206b3ab2e65c05$export$d317bc452442782d = {
    prefix: 'fas',
    iconName: 'lari-sign',
    icon: [
        384,
        512,
        [],
        "e1c8",
        "M144 32c17.7 0 32 14.3 32 32l0 32.7c5.3-.4 10.6-.7 16-.7s10.7 .2 16 .7L208 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 49.4c54.9 25.2 95.8 75.5 108.2 136.2c3.5 17.3-7.7 34.2-25 37.7s-34.2-7.7-37.7-25c-6.1-29.9-22.5-55.9-45.4-74.3l0 67.9c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-95c-5.2-.7-10.6-1-16-1s-10.8 .3-16 1l0 95c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-67.9C82.7 211.5 64 247.6 64 288c0 70.7 57.3 128 128 128l160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l16.9 0C18.5 382 0 337.2 0 288c0-77.5 45.9-144.3 112-174.6L112 64c0-17.7 14.3-32 32-32z"
    ]
};
const $d8206b3ab2e65c05$export$bae30a76735500e1 = {
    prefix: 'fas',
    iconName: 'volcano',
    icon: [
        512,
        512,
        [
            127755
        ],
        "f770",
        "M160 144c-35.3 0-64-28.7-64-64s28.7-64 64-64c15.7 0 30 5.6 41.2 15C212.4 12.4 232.7 0 256 0s43.6 12.4 54.8 31C322 21.6 336.3 16 352 16c35.3 0 64 28.7 64 64s-28.7 64-64 64c-14.7 0-28.3-5-39.1-13.3l-32 48C275.3 187 266 192 256 192s-19.3-5-24.9-13.3l-32-48C188.3 139 174.7 144 160 144zM144 352l48.4-24.2c10.2-5.1 21.6-7.8 33-7.8c19.6 0 38.4 7.8 52.2 21.6l32.5 32.5c6.3 6.3 14.9 9.9 23.8 9.9c11.3 0 21.8-5.6 28-15l9.7-14.6-58.9-66.3c-9.1-10.2-22.2-16.1-35.9-16.1l-41.8 0c-13.7 0-26.8 5.9-35.9 16.1l-59.9 67.4L144 352zm19.4-95.8c18.2-20.5 44.3-32.2 71.8-32.2l41.8 0c27.4 0 53.5 11.7 71.8 32.2l150.2 169c8.5 9.5 13.2 21.9 13.2 34.7c0 28.8-23.4 52.2-52.2 52.2L52.2 512C23.4 512 0 488.6 0 459.8c0-12.8 4.7-25.1 13.2-34.7l150.2-169z"
    ]
};
const $d8206b3ab2e65c05$export$a1d09c95bee8043b = {
    prefix: 'fas',
    iconName: 'person-walking-dashed-line-arrow-right',
    icon: [
        640,
        512,
        [],
        "e553",
        "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM123.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8C248.5 154.8 208.3 128 163.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1L68.7 398 9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L116.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zM550.6 153.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L530.7 224 384 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l146.7 0-25.4 25.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3l-80-80zM392 0c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48c0-13.3-10.7-24-24-24zm24 152c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16zM392 320c-13.3 0-24 10.7-24 24l0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16c0-13.3-10.7-24-24-24zm24 120c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48z"
    ]
};
const $d8206b3ab2e65c05$export$170c56774c8e7961 = {
    prefix: 'fas',
    iconName: 'sterling-sign',
    icon: [
        320,
        512,
        [
            163,
            "gbp",
            "pound-sign"
        ],
        "f154",
        "M112 160.4c0-35.5 28.8-64.4 64.4-64.4c6.9 0 13.8 1.1 20.4 3.3l81.2 27.1c16.8 5.6 34.9-3.5 40.5-20.2s-3.5-34.9-20.2-40.5L217 38.6c-13.1-4.4-26.8-6.6-40.6-6.6C105.5 32 48 89.5 48 160.4L48 224l-16 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l16 0 0 44.5c0 17.4-4.7 34.5-13.7 49.4L4.6 431.5c-5.9 9.9-6.1 22.2-.4 32.2S20.5 480 32 480l256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L88.5 416l.7-1.1C104.1 390 112 361.5 112 332.5l0-44.5 112 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-112 0 0-63.6z"
    ]
};
const $d8206b3ab2e65c05$export$3d9479ec1d1ae83e = $d8206b3ab2e65c05$export$170c56774c8e7961;
const $d8206b3ab2e65c05$export$9ce041dfec8319b = $d8206b3ab2e65c05$export$170c56774c8e7961;
const $d8206b3ab2e65c05$export$ee194b18f5c6f6b6 = {
    prefix: 'fas',
    iconName: 'viruses',
    icon: [
        640,
        512,
        [],
        "e076",
        "M192 0c13.3 0 24 10.7 24 24l0 13.5c0 35.6 43.1 53.5 68.3 28.3l9.5-9.5c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-9.5 9.5C293 124.9 310.9 168 346.5 168l13.5 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-13.5 0c-35.6 0-53.5 43.1-28.3 68.3l9.5 9.5c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-9.5-9.5C259.1 293 216 310.9 216 346.5l0 13.5c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-13.5c0-35.6-43.1-53.5-68.3-28.3l-9.5 9.5c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l9.5-9.5C91 259.1 73.1 216 37.5 216L24 216c-13.3 0-24-10.7-24-24s10.7-24 24-24l13.5 0c35.6 0 53.5-43.1 28.3-68.3l-9.5-9.5c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l9.5 9.5C124.9 91 168 73.1 168 37.5L168 24c0-13.3 10.7-24 24-24zm48 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-48-64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm320 80c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C574.5 312.1 591 352 624 352c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C551.9 446.5 512 463 512 496c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C417.5 423.9 401 384 368 384c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C440.1 289.5 480 273 480 240c0-8.8 7.2-16 16-16s16 7.2 16 16zm0 112a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
const $d8206b3ab2e65c05$export$8aaca358568da0e0 = {
    prefix: 'fas',
    iconName: 'square-person-confined',
    icon: [
        448,
        512,
        [],
        "e577",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm96 112a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm80 104c0-30.9 25.1-56 56-56s56 25.1 56 56l0 102.1c0 36.4-29.5 65.9-65.9 65.9c-17.5 0-34.3-6.9-46.6-19.3L184.8 342l-28.1 56.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l48-96c4.6-9.2 13.3-15.6 23.5-17.3s20.5 1.7 27.8 9L240 306.7l0-58.7z"
    ]
};
const $d8206b3ab2e65c05$export$48c51dda34e9f04c = {
    prefix: 'fas',
    iconName: 'user-tie',
    icon: [
        448,
        512,
        [],
        "f508",
        "M96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128zm94.5 200.2l18.6 31L175.8 483.1l-36-146.9c-2-8.1-9.8-13.4-17.9-11.3C51.9 342.4 0 405.8 0 481.3c0 17 13.8 30.7 30.7 30.7l131.7 0c0 0 0 0 .1 0l5.5 0 112 0 5.5 0c0 0 0 0 .1 0l131.7 0c17 0 30.7-13.8 30.7-30.7c0-75.5-51.9-138.9-121.9-156.4c-8.1-2-15.9 3.3-17.9 11.3l-36 146.9L238.9 359.2l18.6-31c6.4-10.7-1.3-24.2-13.7-24.2L224 304l-19.7 0c-12.4 0-20.1 13.6-13.7 24.2z"
    ]
};
const $d8206b3ab2e65c05$export$5977e8de7e65b20 = {
    prefix: 'fas',
    iconName: 'arrow-down-long',
    icon: [
        384,
        512,
        [
            "long-arrow-down"
        ],
        "f175",
        "M169.4 502.6c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 402.7 224 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 370.7L86.6 329.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128z"
    ]
};
const $d8206b3ab2e65c05$export$52ecf90b62f3f030 = $d8206b3ab2e65c05$export$5977e8de7e65b20;
const $d8206b3ab2e65c05$export$8a4f323f00a91606 = {
    prefix: 'fas',
    iconName: 'tent-arrow-down-to-line',
    icon: [
        640,
        512,
        [],
        "e57e",
        "M241.8 111.9c8.9 9.9 8.1 25-1.8 33.9l-80 72c-9.1 8.2-23 8.2-32.1 0l-80-72c-9.9-8.9-10.7-24-1.8-33.9s24-10.7 33.9-1.8l39.9 36L120 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 122.1 39.9-36c9.9-8.9 25-8.1 33.9 1.8zm122.8 22.6c11.5-8.7 27.3-8.7 38.8 0l168 128c6.6 5 11 12.5 12.3 20.7l24 160 .7 4.7c17.5 .2 31.6 14.4 31.6 32c0 17.7-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l127.6 0 .7-4.7 24-160c1.2-8.2 5.6-15.7 12.3-20.7l168-128zM384 448l80 0L402.7 325.5c-1.7-3.4-5.1-5.5-8.8-5.5c-5.5 0-9.9 4.4-9.9 9.9L384 448z"
    ]
};
const $d8206b3ab2e65c05$export$a881f37164b11fbf = {
    prefix: 'fas',
    iconName: 'certificate',
    icon: [
        512,
        512,
        [],
        "f0a3",
        "M211 7.3C205 1 196-1.4 187.6 .8s-14.9 8.9-17.1 17.3L154.7 80.6l-62-17.5c-8.4-2.4-17.4 0-23.5 6.1s-8.5 15.1-6.1 23.5l17.5 62L18.1 170.6c-8.4 2.1-15 8.7-17.3 17.1S1 205 7.3 211l46.2 45L7.3 301C1 307-1.4 316 .8 324.4s8.9 14.9 17.3 17.1l62.5 15.8-17.5 62c-2.4 8.4 0 17.4 6.1 23.5s15.1 8.5 23.5 6.1l62-17.5 15.8 62.5c2.1 8.4 8.7 15 17.1 17.3s17.3-.2 23.4-6.4l45-46.2 45 46.2c6.1 6.2 15 8.7 23.4 6.4s14.9-8.9 17.1-17.3l15.8-62.5 62 17.5c8.4 2.4 17.4 0 23.5-6.1s8.5-15.1 6.1-23.5l-17.5-62 62.5-15.8c8.4-2.1 15-8.7 17.3-17.1s-.2-17.4-6.4-23.4l-46.2-45 46.2-45c6.2-6.1 8.7-15 6.4-23.4s-8.9-14.9-17.3-17.1l-62.5-15.8 17.5-62c2.4-8.4 0-17.4-6.1-23.5s-15.1-8.5-23.5-6.1l-62 17.5L341.4 18.1c-2.1-8.4-8.7-15-17.1-17.3S307 1 301 7.3L256 53.5 211 7.3z"
    ]
};
const $d8206b3ab2e65c05$export$ca6fd367f31ecbc5 = {
    prefix: 'fas',
    iconName: 'reply-all',
    icon: [
        576,
        512,
        [
            "mail-reply-all"
        ],
        "f122",
        "M209.4 39.5c-9.1-9.6-24.3-10-33.9-.9L33.8 173.2c-19.9 18.9-19.9 50.7 0 69.6L175.5 377.4c9.6 9.1 24.8 8.7 33.9-.9s8.7-24.8-.9-33.9L66.8 208 208.5 73.4c9.6-9.1 10-24.3 .9-33.9zM352 64c0-12.6-7.4-24.1-19-29.2s-25-3-34.4 5.4l-160 144c-6.7 6.1-10.6 14.7-10.6 23.8s3.9 17.7 10.6 23.8l160 144c9.4 8.5 22.9 10.6 34.4 5.4s19-16.6 19-29.2l0-64 32 0c53 0 96 43 96 96c0 30.4-12.8 47.9-22.2 56.7c-5.5 5.1-9.8 12-9.8 19.5c0 10.9 8.8 19.7 19.7 19.7c2.8 0 5.6-.6 8.1-1.9C494.5 467.9 576 417.3 576 304c0-97.2-78.8-176-176-176l-48 0 0-64z"
    ]
};
const $d8206b3ab2e65c05$export$8274334f3a2c1841 = $d8206b3ab2e65c05$export$ca6fd367f31ecbc5;
const $d8206b3ab2e65c05$export$60710f3921019268 = {
    prefix: 'fas',
    iconName: 'suitcase',
    icon: [
        512,
        512,
        [
            129523
        ],
        "f0f2",
        "M176 56l0 40 160 0 0-40c0-4.4-3.6-8-8-8L184 48c-4.4 0-8 3.6-8 8zM128 96l0-40c0-30.9 25.1-56 56-56L328 0c30.9 0 56 25.1 56 56l0 40 0 32 0 352-256 0 0-352 0-32zM64 96l32 0 0 384-32 0c-35.3 0-64-28.7-64-64L0 160c0-35.3 28.7-64 64-64zM448 480l-32 0 0-384 32 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64z"
    ]
};
const $d8206b3ab2e65c05$export$f3854553fe688388 = {
    prefix: 'fas',
    iconName: 'person-skating',
    icon: [
        448,
        512,
        [
            "skating"
        ],
        "f7c5",
        "M352 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM128 128c0-17.7 14.3-32 32-32l159.4 0c43.6 0 64.6 53.4 32.8 83.1l-74.4 69.4 60.2 60.2c9 9 14.1 21.2 14.1 33.9l0 73.4c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-66.7-77.9-77.8c-26.6-26.6-24.6-70.3 4.3-94.4l20.4-17L160 160c-17.7 0-32-14.3-32-32zM81.4 353.4l86.9-86.9c4.6 10 11 19.3 19.3 27.5l21.8 21.8-82.7 82.7c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3zm322.5 95.1c8.6 2.1 13.8 10.8 11.6 19.4l-.4 1.7c-6.2 24.9-28.6 42.4-54.3 42.4L272 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l88.8 0c11 0 20.6-7.5 23.3-18.2l.4-1.7c2.1-8.6 10.8-13.8 19.4-11.6zM135.2 478.3l-6.2 3.1c-21.6 10.8-47.6 6.6-64.6-10.5L4.7 411.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l59.6 59.6c7.3 7.3 18.5 9.1 27.7 4.5l6.2-3.1c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5z"
    ]
};
const $d8206b3ab2e65c05$export$21bd1d54bd4f2c5a = $d8206b3ab2e65c05$export$f3854553fe688388;
const $d8206b3ab2e65c05$export$3300e4b4d1d1936f = {
    prefix: 'fas',
    iconName: 'filter-circle-dollar',
    icon: [
        576,
        512,
        [
            "funnel-dollar"
        ],
        "f662",
        "M3.9 22.9C10.5 8.9 24.5 0 40 0L472 0c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L396.4 195.6C316.2 212.1 256 283 256 368c0 27.4 6.3 53.4 17.5 76.5c-1.6-.8-3.2-1.8-4.7-2.9l-64-48c-8.1-6-12.8-15.5-12.8-25.6l0-79.1L9 65.3C-.7 53.4-2.8 36.8 3.9 22.9zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm120.8-32.6c.6-.9 1.8-2.1 4.2-3.4c5.1-2.7 12.5-4.1 18.7-4c8.2 .1 17.1 1.8 26.4 4.1c8.6 2.1 17.3-3.1 19.4-11.7s-3.1-17.3-11.7-19.4c-5.6-1.4-11.6-2.7-17.9-3.7l0-9.4c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 9.5c-6.1 1.2-12.3 3.2-18 6.3c-11.8 6.3-23 18.4-21.8 37.2c1 16 11.7 25.3 21.6 30.7c8.8 4.7 19.7 7.8 28.6 10.3l1.8 .5c10.3 2.9 17.9 5.2 23.2 8.3c4.5 2.7 4.7 4.2 4.7 5.6c.1 2.4-.5 3.7-1 4.5c-.6 1-1.8 2.2-4 3.3c-4.7 2.5-11.8 3.8-18.5 3.6c-9.5-.3-18.5-3.1-29.9-6.8c-1.9-.6-3.8-1.2-5.8-1.8c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20c1.6 .5 3.3 1 5 1.6c0 0 0 0 0 0s0 0 0 0c7 2.3 15.1 4.8 23.7 6.6l0 11.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-10.8c6.2-1.1 12.5-3.1 18.3-6.2c12.1-6.5 22.3-18.7 21.7-36.9c-.5-16.2-10.3-26.3-20.5-32.3c-9.4-5.6-21.2-8.9-30.5-11.5l-.2 0c-10.4-2.9-18.3-5.2-23.9-8.2c-4.8-2.6-4.8-4-4.8-4.5c0 0 0 0 0-.1c-.1-1.9 .3-2.9 .8-3.6z"
    ]
};
const $d8206b3ab2e65c05$export$cebe38ad8f0a143d = $d8206b3ab2e65c05$export$3300e4b4d1d1936f;
const $d8206b3ab2e65c05$export$41dbdadc07a89b05 = {
    prefix: 'fas',
    iconName: 'camera-retro',
    icon: [
        512,
        512,
        [
            128247
        ],
        "f083",
        "M220.6 121.2L271.1 96 448 96l0 96-114.8 0c-21.9-15.1-48.5-24-77.2-24s-55.2 8.9-77.2 24L64 192l0-64 128 0c9.9 0 19.7-2.3 28.6-6.8zM0 128L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L271.1 32c-9.9 0-19.7 2.3-28.6 6.8L192 64l-32 0 0-16c0-8.8-7.2-16-16-16L80 32c-8.8 0-16 7.2-16 16l0 16C28.7 64 0 92.7 0 128zM168 304a88 88 0 1 1 176 0 88 88 0 1 1 -176 0z"
    ]
};
const $d8206b3ab2e65c05$export$a30c52cde32bec7e = {
    prefix: 'fas',
    iconName: 'circle-arrow-down',
    icon: [
        512,
        512,
        [
            "arrow-circle-down"
        ],
        "f0ab",
        "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM127 297c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l71 71L232 120c0-13.3 10.7-24 24-24s24 10.7 24 24l0 214.1 71-71c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L273 409c-9.4 9.4-24.6 9.4-33.9 0L127 297z"
    ]
};
const $d8206b3ab2e65c05$export$6cfa36bbb3a057 = $d8206b3ab2e65c05$export$a30c52cde32bec7e;
const $d8206b3ab2e65c05$export$d796c05153b1255c = {
    prefix: 'fas',
    iconName: 'file-import',
    icon: [
        512,
        512,
        [
            "arrow-right-to-file"
        ],
        "f56f",
        "M128 64c0-35.3 28.7-64 64-64L352 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64l-256 0c-35.3 0-64-28.7-64-64l0-112 174.1 0-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39L128 288l0-224zm0 224l0 48L24 336c-13.3 0-24-10.7-24-24s10.7-24 24-24l104 0zM512 128l-128 0L384 0 512 128z"
    ]
};
const $d8206b3ab2e65c05$export$32f14beaf6294476 = $d8206b3ab2e65c05$export$d796c05153b1255c;
const $d8206b3ab2e65c05$export$38150b61dfd06fff = {
    prefix: 'fas',
    iconName: 'square-arrow-up-right',
    icon: [
        448,
        512,
        [
            "external-link-square"
        ],
        "f14c",
        "M384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM160 144c-13.3 0-24 10.7-24 24s10.7 24 24 24l94.1 0L119 327c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l135-135L288 328c0 13.3 10.7 24 24 24s24-10.7 24-24l0-160c0-13.3-10.7-24-24-24l-152 0z"
    ]
};
const $d8206b3ab2e65c05$export$e04d83fed5ebcebf = $d8206b3ab2e65c05$export$38150b61dfd06fff;
const $d8206b3ab2e65c05$export$9010ed816a8b9c97 = {
    prefix: 'fas',
    iconName: 'box-open',
    icon: [
        640,
        512,
        [],
        "f49e",
        "M58.9 42.1c3-6.1 9.6-9.6 16.3-8.7L320 64 564.8 33.4c6.7-.8 13.3 2.7 16.3 8.7l41.7 83.4c9 17.9-.6 39.6-19.8 45.1L439.6 217.3c-13.9 4-28.8-1.9-36.2-14.3L320 64 236.6 203c-7.4 12.4-22.3 18.3-36.2 14.3L37.1 170.6c-19.3-5.5-28.8-27.2-19.8-45.1L58.9 42.1zM321.1 128l54.9 91.4c14.9 24.8 44.6 36.6 72.5 28.6L576 211.6l0 167c0 22-15 41.2-36.4 46.6l-204.1 51c-10.2 2.6-20.9 2.6-31 0l-204.1-51C79 419.7 64 400.5 64 378.5l0-167L191.6 248c27.8 8 57.6-3.8 72.5-28.6L318.9 128l2.2 0z"
    ]
};
const $d8206b3ab2e65c05$export$7c265716d4399676 = {
    prefix: 'fas',
    iconName: 'scroll',
    icon: [
        576,
        512,
        [
            128220
        ],
        "f70e",
        "M0 80l0 48c0 17.7 14.3 32 32 32l16 0 48 0 0-80c0-26.5-21.5-48-48-48S0 53.5 0 80zM112 32c10 13.4 16 30 16 48l0 304c0 35.3 28.7 64 64 64s64-28.7 64-64l0-5.3c0-32.4 26.3-58.7 58.7-58.7L480 320l0-192c0-53-43-96-96-96L112 32zM464 480c61.9 0 112-50.1 112-112c0-8.8-7.2-16-16-16l-245.3 0c-14.7 0-26.7 11.9-26.7 26.7l0 5.3c0 53-43 96-96 96l176 0 96 0z"
    ]
};
const $d8206b3ab2e65c05$export$f9a38ef7b046ab51 = {
    prefix: 'fas',
    iconName: 'spa',
    icon: [
        576,
        512,
        [],
        "f5bb",
        "M183.1 235.3c33.7 20.7 62.9 48.1 85.8 80.5c7 9.9 13.4 20.3 19.1 31c5.7-10.8 12.1-21.1 19.1-31c22.9-32.4 52.1-59.8 85.8-80.5C437.6 207.8 490.1 192 546 192l9.9 0c11.1 0 20.1 9 20.1 20.1C576 360.1 456.1 480 308.1 480L288 480l-20.1 0C119.9 480 0 360.1 0 212.1C0 201 9 192 20.1 192l9.9 0c55.9 0 108.4 15.8 153.1 43.3zM301.5 37.6c15.7 16.9 61.1 71.8 84.4 164.6c-38 21.6-71.4 50.8-97.9 85.6c-26.5-34.8-59.9-63.9-97.9-85.6c23.2-92.8 68.6-147.7 84.4-164.6C278 33.9 282.9 32 288 32s10 1.9 13.5 5.6z"
    ]
};
const $d8206b3ab2e65c05$export$db853fbb474326cc = {
    prefix: 'fas',
    iconName: 'location-pin-lock',
    icon: [
        512,
        512,
        [],
        "e51f",
        "M215.7 499.2c11-13.8 25.1-31.7 40.3-52.3l0-94.8c0-23.7 12.9-44.4 32-55.4l0-24.6c0-55.6 40.5-101.7 93.6-110.5C367 70 287.7 0 192 0C86 0 0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM400 240c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
const $d8206b3ab2e65c05$export$da79f048408b1722 = {
    prefix: 'fas',
    iconName: 'pause',
    icon: [
        320,
        512,
        [
            9208
        ],
        "f04c",
        "M48 64C21.5 64 0 85.5 0 112L0 400c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48L48 64zm192 0c-26.5 0-48 21.5-48 48l0 288c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48l-32 0z"
    ]
};
const $d8206b3ab2e65c05$export$50d11c98c99e3b2d = {
    prefix: 'fas',
    iconName: 'hill-avalanche',
    icon: [
        576,
        512,
        [],
        "e507",
        "M439.7 401.9c34.2 23.1 81.1 19.5 111.4-10.8c34.4-34.4 34.4-90.1 0-124.4c-27.8-27.8-69.5-33.1-102.6-16c-11.8 6.1-16.4 20.6-10.3 32.3s20.6 16.4 32.3 10.3c15.1-7.8 34-5.3 46.6 7.3c15.6 15.6 15.6 40.9 0 56.6s-40.9 15.6-56.6 0l-81.7-81.7C401.2 261.3 416 236.4 416 208c0-33.9-21.1-62.9-50.9-74.5c1.9-6.8 2.9-14 2.9-21.5c0-44.2-35.8-80-80-80c-27.3 0-51.5 13.7-65.9 34.6C216.3 46.6 197.9 32 176 32c-26.5 0-48 21.5-48 48c0 4 .5 7.9 1.4 11.6L439.7 401.9zM480 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM68.3 87C43.1 61.8 0 79.7 0 115.3L0 432c0 44.2 35.8 80 80 80l316.7 0c35.6 0 53.5-43.1 28.3-68.3L68.3 87z"
    ]
};
const $d8206b3ab2e65c05$export$ac389bf5cc37feb5 = {
    prefix: 'fas',
    iconName: 'temperature-empty',
    icon: [
        320,
        512,
        [
            "temperature-0",
            "thermometer-0",
            "thermometer-empty"
        ],
        "f2cb",
        "M112 112c0-26.5 21.5-48 48-48s48 21.5 48 48l0 164.5c0 17.3 7.1 31.9 15.3 42.5C233.8 332.6 240 349.5 240 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5L112 112zM160 0C98.1 0 48 50.2 48 112l0 164.4c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C27.2 304.2 16 334.8 16 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6L272 112C272 50.2 221.9 0 160 0zm0 416a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    ]
};
const $d8206b3ab2e65c05$export$e99b7d2ccc282383 = $d8206b3ab2e65c05$export$ac389bf5cc37feb5;
const $d8206b3ab2e65c05$export$4c13a186ecce3b80 = $d8206b3ab2e65c05$export$ac389bf5cc37feb5;
const $d8206b3ab2e65c05$export$81a2f8298cf523f9 = $d8206b3ab2e65c05$export$ac389bf5cc37feb5;
const $d8206b3ab2e65c05$export$d59078f6e80b4a67 = {
    prefix: 'fas',
    iconName: 'bomb',
    icon: [
        512,
        512,
        [
            128163
        ],
        "f1e2",
        "M459.1 52.4L442.6 6.5C440.7 2.6 436.5 0 432.1 0s-8.5 2.6-10.4 6.5L405.2 52.4l-46 16.8c-4.3 1.6-7.3 5.9-7.2 10.4c0 4.5 3 8.7 7.2 10.2l45.7 16.8 16.8 45.8c1.5 4.4 5.8 7.5 10.4 7.5s8.9-3.1 10.4-7.5l16.5-45.8 45.7-16.8c4.2-1.5 7.2-5.7 7.2-10.2c0-4.6-3-8.9-7.2-10.4L459.1 52.4zm-132.4 53c-12.5-12.5-32.8-12.5-45.3 0l-2.9 2.9C256.5 100.3 232.7 96 208 96C93.1 96 0 189.1 0 304S93.1 512 208 512s208-93.1 208-208c0-24.7-4.3-48.5-12.2-70.5l2.9-2.9c12.5-12.5 12.5-32.8 0-45.3l-80-80zM200 192c-57.4 0-104 46.6-104 104l0 8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8c0-75.1 60.9-136 136-136l8 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-8 0z"
    ]
};
const $d8206b3ab2e65c05$export$5f519e9ac15ab8c3 = {
    prefix: 'fas',
    iconName: 'registered',
    icon: [
        512,
        512,
        [
            174
        ],
        "f25d",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 152c0-13.3 10.7-24 24-24l88 0c44.2 0 80 35.8 80 80c0 28-14.4 52.7-36.3 67l34.1 75.1c5.5 12.1 .1 26.3-11.9 31.8s-26.3 .1-31.8-11.9L268.9 288 208 288l0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96 0-112zm48 88l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0 64z"
    ]
};
const $d8206b3ab2e65c05$export$6ea408c7266ed557 = {
    prefix: 'fas',
    iconName: 'address-card',
    icon: [
        576,
        512,
        [
            62140,
            "contact-card",
            "vcard"
        ],
        "f2bb",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm80 256l64 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16L80 384c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm256-32l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
const $d8206b3ab2e65c05$export$4ac51eb0b298b190 = $d8206b3ab2e65c05$export$6ea408c7266ed557;
const $d8206b3ab2e65c05$export$91228257deb1bf18 = $d8206b3ab2e65c05$export$6ea408c7266ed557;
const $d8206b3ab2e65c05$export$f4d7840209109993 = {
    prefix: 'fas',
    iconName: 'scale-unbalanced-flip',
    icon: [
        640,
        512,
        [
            "balance-scale-right"
        ],
        "f516",
        "M117.9 62.4c-16.8-5.6-25.8-23.7-20.2-40.5s23.7-25.8 40.5-20.2l113 37.7C265 15.8 290.7 0 320 0c44.2 0 80 35.8 80 80c0 3-.2 5.9-.5 8.8l122.6 40.9c16.8 5.6 25.8 23.7 20.2 40.5s-23.7 25.8-40.5 20.2L366.4 145.2c-4.5 3.2-9.3 5.9-14.4 8.2L352 480c0 17.7-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0 0-294.7c-21-9.2-37.2-27-44.2-49l-125.9-42zM200.4 288L128 163.8 55.6 288l144.9 0zM128 384C65.1 384 12.8 350 2 305.1c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1C243.2 350 190.9 384 128 384zm382.8-92.2L438.4 416l144.9 0L510.8 291.8zm126 141.3C626 478 573.7 512 510.8 512s-115.2-34-126-78.9c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1z"
    ]
};
const $d8206b3ab2e65c05$export$2238e05f8920005a = $d8206b3ab2e65c05$export$f4d7840209109993;
const $d8206b3ab2e65c05$export$34c1e678c32ed646 = {
    prefix: 'fas',
    iconName: 'subscript',
    icon: [
        512,
        512,
        [],
        "f12c",
        "M32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l15.3 0 89.6 128L47.3 384 32 384c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0c10.4 0 20.2-5.1 26.2-13.6L176 311.8l85.8 122.6c6 8.6 15.8 13.6 26.2 13.6l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-15.3 0L215.1 256l89.6-128 15.3 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0c-10.4 0-20.2 5.1-26.2 13.6L176 200.2 90.2 77.6C84.2 69.1 74.4 64 64 64L32 64zM480 320c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4l-32 16c-15.8 7.9-22.2 27.1-14.3 42.9C393 361.5 404.3 368 416 368l0 80c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-128z"
    ]
};
const $d8206b3ab2e65c05$export$99749ac517cbef07 = {
    prefix: 'fas',
    iconName: 'diamond-turn-right',
    icon: [
        512,
        512,
        [
            "directions"
        ],
        "f5eb",
        "M227.7 11.7c15.6-15.6 40.9-15.6 56.6 0l216 216c15.6 15.6 15.6 40.9 0 56.6l-216 216c-15.6 15.6-40.9 15.6-56.6 0l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216zm87.6 137c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8l0 56-64 0c-35.3 0-64 28.7-64 64l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48c0-8.8 7.2-16 16-16l64 0 0 56c0 6.5 3.9 12.3 9.9 14.8s12.9 1.1 17.4-3.5l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80z"
    ]
};
const $d8206b3ab2e65c05$export$6a6973de44442fe5 = $d8206b3ab2e65c05$export$99749ac517cbef07;
const $d8206b3ab2e65c05$export$ea2986b45ba5d2cf = {
    prefix: 'fas',
    iconName: 'burst',
    icon: [
        512,
        512,
        [],
        "e4dc",
        "M37.6 4.2C28-2.3 15.2-1.1 7 7s-9.4 21-2.8 30.5l112 163.3L16.6 233.2C6.7 236.4 0 245.6 0 256s6.7 19.6 16.6 22.8l103.1 33.4L66.8 412.8c-4.9 9.3-3.2 20.7 4.3 28.1s18.8 9.2 28.1 4.3l100.6-52.9 33.4 103.1c3.2 9.9 12.4 16.6 22.8 16.6s19.6-6.7 22.8-16.6l33.4-103.1 100.6 52.9c9.3 4.9 20.7 3.2 28.1-4.3s9.2-18.8 4.3-28.1L392.3 312.2l103.1-33.4c9.9-3.2 16.6-12.4 16.6-22.8s-6.7-19.6-16.6-22.8L388.9 198.7l25.7-70.4c3.2-8.8 1-18.6-5.6-25.2s-16.4-8.8-25.2-5.6l-70.4 25.7L278.8 16.6C275.6 6.7 266.4 0 256 0s-19.6 6.7-22.8 16.6l-32.3 99.6L37.6 4.2z"
    ]
};
const $d8206b3ab2e65c05$export$6486d62e77b910 = {
    prefix: 'fas',
    iconName: 'house-laptop',
    icon: [
        640,
        512,
        [
            "laptop-house"
        ],
        "e066",
        "M218.3 8.5c12.3-11.3 31.2-11.3 43.4 0l208 192c6.7 6.2 10.3 14.8 10.3 23.5l-144 0c-19.1 0-36.3 8.4-48 21.7l0-37.7c0-8.8-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l64 0 0 128-160 0c-26.5 0-48-21.5-48-48l0-112-32 0c-13.2 0-25-8.1-29.8-20.3s-1.6-26.2 8.1-35.2l208-192zM352 304l0 144 192 0 0-144-192 0zm-48-16c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32l0 160 32 0c8.8 0 16 7.2 16 16c0 26.5-21.5 48-48 48l-48 0-192 0-48 0c-26.5 0-48-21.5-48-48c0-8.8 7.2-16 16-16l32 0 0-160z"
    ]
};
const $d8206b3ab2e65c05$export$efd983de5e4d6ad3 = $d8206b3ab2e65c05$export$6486d62e77b910;
const $d8206b3ab2e65c05$export$5352cbdc070ce8d = {
    prefix: 'fas',
    iconName: 'face-tired',
    icon: [
        512,
        512,
        [
            128555,
            "tired"
        ],
        "f5c8",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.7 328.7c22-22 53.9-40.7 91.3-40.7s69.3 18.7 91.3 40.7c11.1 11.1 20.1 23.4 26.4 35.4c6.2 11.7 10.3 24.4 10.3 35.9c0 5.2-2.6 10.2-6.9 13.2s-9.8 3.7-14.7 1.8l-20.5-7.7c-26.9-10.1-55.5-15.3-84.3-15.3l-3.2 0c-28.8 0-57.3 5.2-84.3 15.3L149.6 415c-4.9 1.8-10.4 1.2-14.7-1.8s-6.9-7.9-6.9-13.2c0-11.6 4.2-24.2 10.3-35.9c6.3-12 15.3-24.3 26.4-35.4zm-31.2-182l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
    ]
};
const $d8206b3ab2e65c05$export$3d016d62cda18371 = $d8206b3ab2e65c05$export$5352cbdc070ce8d;
const $d8206b3ab2e65c05$export$a822dad6e586ee9e = {
    prefix: 'fas',
    iconName: 'money-bills',
    icon: [
        640,
        512,
        [],
        "e1f3",
        "M96 96l0 224c0 35.3 28.7 64 64 64l416 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L160 32c-35.3 0-64 28.7-64 64zm64 160c35.3 0 64 28.7 64 64l-64 0 0-64zM224 96c0 35.3-28.7 64-64 64l0-64 64 0zM576 256l0 64-64 0c0-35.3 28.7-64 64-64zM512 96l64 0 0 64c-35.3 0-64-28.7-64-64zM288 208a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 360c0 66.3 53.7 120 120 120l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-400 0c-39.8 0-72-32.2-72-72l0-240z"
    ]
};
const $d8206b3ab2e65c05$export$aa11b8edb09fed14 = {
    prefix: 'fas',
    iconName: 'smog',
    icon: [
        640,
        512,
        [],
        "f75f",
        "M32 144c0 79.5 64.5 144 144 144l123.3 0c22.6 19.9 52.2 32 84.7 32s62.1-12.1 84.7-32l27.3 0c61.9 0 112-50.1 112-112s-50.1-112-112-112c-10.7 0-21 1.5-30.8 4.3C443.8 27.7 401.1 0 352 0c-32.6 0-62.4 12.2-85.1 32.3C242.1 12.1 210.5 0 176 0C96.5 0 32 64.5 32 144zM616 368l-336 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l336 0c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-64 96l-112 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-192 0L24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l336 0c13.3 0 24-10.7 24-24s-10.7-24-24-24zM224 392c0-13.3-10.7-24-24-24L96 368c-13.3 0-24 10.7-24 24s10.7 24 24 24l104 0c13.3 0 24-10.7 24-24z"
    ]
};
const $d8206b3ab2e65c05$export$e94134641c0e2 = {
    prefix: 'fas',
    iconName: 'crutch',
    icon: [
        512,
        512,
        [],
        "f7f7",
        "M297.4 9.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0zm-96 144l-34.8 34.8c-12.9 12.9-21.9 29.2-25.8 47.1L116.8 342.9c-1.3 5.9-4.3 11.4-8.6 15.7L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l98.8-98.8c4.3-4.3 9.7-7.3 15.7-8.6l107.6-23.9c17.8-4 34.1-12.9 47.1-25.8l34.7-34.7c0 0 .1-.1 .1-.1s.1-.1 .1-.1l74.6-74.6-45.3-45.3L336 242.7 269.3 176l52.1-52.1L276.1 78.6l-74.7 74.7zM224 221.3L290.7 288l-12.2 12.2c-4.3 4.3-9.7 7.3-15.7 8.6l-76.7 17 17-76.7c1.3-5.9 4.3-11.4 8.6-15.7L224 221.3z"
    ]
};
const $d8206b3ab2e65c05$export$aa4baaed1c60f58d = {
    prefix: 'fas',
    iconName: 'font-awesome',
    icon: [
        512,
        512,
        [
            62501,
            62694,
            "font-awesome-flag",
            "font-awesome-logo-full"
        ],
        "f2b4",
        "M91.7 96C106.3 86.8 116 70.5 116 52C116 23.3 92.7 0 64 0S12 23.3 12 52c0 16.7 7.8 31.5 20 41l0 3 0 352 0 64 64 0 0-64 373.6 0c14.6 0 26.4-11.8 26.4-26.4c0-3.7-.8-7.3-2.3-10.7L432 272l61.7-138.9c1.5-3.4 2.3-7 2.3-10.7c0-14.6-11.8-26.4-26.4-26.4L91.7 96z"
    ]
};
const $d8206b3ab2e65c05$export$102c25fde54d4843 = $d8206b3ab2e65c05$export$aa4baaed1c60f58d;
const $d8206b3ab2e65c05$export$6e20d421a2e0f320 = $d8206b3ab2e65c05$export$aa4baaed1c60f58d;
const $d8206b3ab2e65c05$export$3507214fff1cc655 = {
    prefix: 'fas',
    iconName: 'cloud-arrow-up',
    icon: [
        640,
        512,
        [
            62338,
            "cloud-upload",
            "cloud-upload-alt"
        ],
        "f0ee",
        "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128l-368 0zm79-217c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39L296 392c0 13.3 10.7 24 24 24s24-10.7 24-24l0-134.1 39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80z"
    ]
};
const $d8206b3ab2e65c05$export$a48720e6366f5d9a = $d8206b3ab2e65c05$export$3507214fff1cc655;
const $d8206b3ab2e65c05$export$e73b3e819b9d14a5 = $d8206b3ab2e65c05$export$3507214fff1cc655;
const $d8206b3ab2e65c05$export$5c390baea5db4f77 = {
    prefix: 'fas',
    iconName: 'palette',
    icon: [
        512,
        512,
        [
            127912
        ],
        "f53f",
        "M512 256c0 .9 0 1.8 0 2.7c-.4 36.5-33.6 61.3-70.1 61.3L344 320c-26.5 0-48 21.5-48 48c0 3.4 .4 6.7 1 9.9c2.1 10.2 6.5 20 10.8 29.9c6.1 13.8 12.1 27.5 12.1 42c0 31.8-21.6 60.7-53.4 62c-3.5 .1-7 .2-10.6 .2C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM128 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
const $d8206b3ab2e65c05$export$db9f783f15682c4a = {
    prefix: 'fas',
    iconName: 'arrows-turn-right',
    icon: [
        448,
        512,
        [],
        "e4c0",
        "M297.4 9.4c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L338.7 160 128 160c-35.3 0-64 28.7-64 64l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32C0 153.3 57.3 96 128 96l210.7 0L297.4 54.6c-12.5-12.5-12.5-32.8 0-45.3zm-96 256c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 416 96 416c-17.7 0-32 14.3-32 32l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32c0-53 43-96 96-96l146.7 0-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3z"
    ]
};
const $d8206b3ab2e65c05$export$c8370e53051a657 = {
    prefix: 'fas',
    iconName: 'vest',
    icon: [
        448,
        512,
        [],
        "e085",
        "M207.1 237.4L151.2 69.7C168.6 79.7 192.6 88 224 88s55.4-8.3 72.8-18.3L226.5 280.6c-1.6 4.9-2.5 10-2.5 15.2L224 464c0 26.5 21.5 48 48 48l128 0c26.5 0 48-21.5 48-48l0-193.5c0-9.5-2.8-18.7-8.1-26.6l-47.9-71.8c-5.3-7.9-8.1-17.1-8.1-26.6l0-17.5 0-73.7 0-6.3c0-26.5-21.5-48-48-48l-4.5 0c-.2 0-.4 0-.6 0c-.4 0-.8 0-1.2 0C311 0 295.7 9.7 285.7 18.8C276.4 27.2 257.2 40 224 40s-52.4-12.8-61.7-21.2C152.3 9.7 137 0 118.3 0c-.4 0-.8 0-1.2 0c-.2 0-.4 0-.6 0L112 0C85.5 0 64 21.5 64 48l0 6.3L64 128l0 17.5c0 9.5-2.8 18.7-8.1 26.6L8.1 243.9C2.8 251.8 0 261.1 0 270.5L0 464c0 26.5 21.5 48 48 48l128 0c9.9 0 19-3 26.7-8.1C195.9 492.2 192 478.5 192 464l0-168.2c0-8.6 1.4-17.1 4.1-25.3l11-33.1zM347.3 356.7l48 48c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-48-48c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-294.6 48l48-48c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-48 48c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6z"
    ]
};
const $d8206b3ab2e65c05$export$fd312949b97346ae = {
    prefix: 'fas',
    iconName: 'ferry',
    icon: [
        576,
        512,
        [],
        "e4ea",
        "M224 0L352 0c17.7 0 32 14.3 32 32l75.1 0c20.6 0 31.6 24.3 18.1 39.8L456 96 120 96 98.8 71.8C85.3 56.3 96.3 32 116.9 32L192 32c0-17.7 14.3-32 32-32zM96 128l384 0c17.7 0 32 14.3 32 32l0 123.5c0 13.3-4.2 26.3-11.9 37.2l-51.4 71.9c-1.9 1.1-3.7 2.2-5.5 3.5c-15.5 10.7-34 18-51 19.9l-16.5 0c-17.1-1.8-35-9-50.8-19.9c-22.1-15.5-51.6-15.5-73.7 0c-14.8 10.2-32.5 18-50.6 19.9l-16.6 0c-17-1.8-35.6-9.2-51-19.9c-1.8-1.3-3.7-2.4-5.6-3.5L75.9 320.7C68.2 309.8 64 296.8 64 283.5L64 160c0-17.7 14.3-32 32-32zm32 64l0 96 320 0 0-96-320 0zM306.5 421.9C329 437.4 356.5 448 384 448c26.9 0 55.3-10.8 77.4-26.1c0 0 0 0 0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7c0 0 0 0 0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
const $d8206b3ab2e65c05$export$cfb044c7d35060bb = {
    prefix: 'fas',
    iconName: 'arrows-down-to-people',
    icon: [
        640,
        512,
        [],
        "e4b9",
        "M144 0c-13.3 0-24 10.7-24 24l0 118.1L97 119c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23L168 24c0-13.3-10.7-24-24-24zM360 200a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM184 296a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm312 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM200 441.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-36.3-67.5c1.7-1.7 3.2-3.6 4.3-5.8L264 345.5l0 54.5c0 17.7 14.3 32 32 32l48 0c17.7 0 32-14.3 32-32l0-54.5 26.9 49.9c1.2 2.2 2.6 4.1 4.3 5.8l-36.3 67.5c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L440 441.5l0 38.5c0 17.7 14.3 32 32 32l48 0c17.7 0 32-14.3 32-32l0-38.5 26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3l-19.5 0c-16.3 0-31.9 4.5-45.4 12.6l-33.6-62.3c-15.3-28.5-45.1-46.3-77.5-46.3l-19.5 0c-32.4 0-62.1 17.8-77.5 46.3l-33.6 62.3c-13.5-8.1-29.1-12.6-45.4-12.6l-19.5 0c-32.4 0-62.1 17.8-77.5 46.3L18.9 468.6c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L88 441.5 88 480c0 17.7 14.3 32 32 32l48 0c17.7 0 32-14.3 32-32l0-38.5zM415 153l64 64c9.4 9.4 24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23L520 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 118.1-23-23c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z"
    ]
};
const $d8206b3ab2e65c05$export$d7b60b8dbd03cfe4 = {
    prefix: 'fas',
    iconName: 'seedling',
    icon: [
        512,
        512,
        [
            127793,
            "sprout"
        ],
        "f4d8",
        "M512 32c0 113.6-84.6 207.5-194.2 222c-7.1-53.4-30.6-101.6-65.3-139.3C290.8 46.3 364 0 448 0l32 0c17.7 0 32 14.3 32 32zM0 96C0 78.3 14.3 64 32 64l32 0c123.7 0 224 100.3 224 224l0 32 0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-160C100.3 320 0 219.7 0 96z"
    ]
};
const $d8206b3ab2e65c05$export$9f3035e3a8c62323 = $d8206b3ab2e65c05$export$d7b60b8dbd03cfe4;
const $d8206b3ab2e65c05$export$47d93e9001818ee7 = {
    prefix: 'fas',
    iconName: 'left-right',
    icon: [
        512,
        512,
        [
            8596,
            "arrows-alt-h"
        ],
        "f337",
        "M504.3 273.6c4.9-4.5 7.7-10.9 7.7-17.6s-2.8-13-7.7-17.6l-112-104c-7-6.5-17.2-8.2-25.9-4.4s-14.4 12.5-14.4 22l0 56-192 0 0-56c0-9.5-5.7-18.2-14.4-22s-18.9-2.1-25.9 4.4l-112 104C2.8 243 0 249.3 0 256s2.8 13 7.7 17.6l112 104c7 6.5 17.2 8.2 25.9 4.4s14.4-12.5 14.4-22l0-56 192 0 0 56c0 9.5 5.7 18.2 14.4 22s18.9 2.1 25.9-4.4l112-104z"
    ]
};
const $d8206b3ab2e65c05$export$7937ea574fb1389 = $d8206b3ab2e65c05$export$47d93e9001818ee7;
const $d8206b3ab2e65c05$export$e81e7f3390fe84fe = {
    prefix: 'fas',
    iconName: 'boxes-packing',
    icon: [
        640,
        512,
        [],
        "e4c7",
        "M256 48c0-26.5 21.5-48 48-48L592 0c26.5 0 48 21.5 48 48l0 416c0 26.5-21.5 48-48 48l-210.7 0c1.8-5 2.7-10.4 2.7-16l0-242.7c18.6-6.6 32-24.4 32-45.3l0-32c0-26.5-21.5-48-48-48l-112 0 0-80zM571.3 347.3c6.2-6.2 6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L480 310.6 480 432c0 8.8 7.2 16 16 16s16-7.2 16-16l0-121.4 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0zM0 176c0-8.8 7.2-16 16-16l352 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16L16 224c-8.8 0-16-7.2-16-16l0-32zm352 80l0 224c0 17.7-14.3 32-32 32L64 512c-17.7 0-32-14.3-32-32l0-224 320 0zM144 320c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0z"
    ]
};
const $d8206b3ab2e65c05$export$827fbb87bdbe1028 = {
    prefix: 'fas',
    iconName: 'circle-arrow-left',
    icon: [
        512,
        512,
        [
            "arrow-circle-left"
        ],
        "f0a8",
        "M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM215 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-71 71L392 232c13.3 0 24 10.7 24 24s-10.7 24-24 24l-214.1 0 71 71c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L103 273c-9.4-9.4-9.4-24.6 0-33.9L215 127z"
    ]
};
const $d8206b3ab2e65c05$export$728262abb9f58d0a = $d8206b3ab2e65c05$export$827fbb87bdbe1028;
const $d8206b3ab2e65c05$export$88a8383ecdd39a54 = {
    prefix: 'fas',
    iconName: 'group-arrows-rotate',
    icon: [
        512,
        512,
        [],
        "e4f6",
        "M201.1 71.9c16.9-5 26.6-22.9 21.5-39.8s-22.9-26.6-39.8-21.5c-21.5 6.4-41.8 15.5-60.6 27C114.3 34 105.4 32 96 32C60.7 32 32 60.7 32 96c0 9.4 2 18.3 5.6 26.3c-11.5 18.7-20.6 39-27 60.6c-5 16.9 4.6 34.8 21.5 39.8s34.8-4.6 39.8-21.5c4.3-14.6 10.4-28.5 17.9-41.4c2 .2 4.1 .3 6.1 .3c35.3 0 64-28.7 64-64c0-2.1-.1-4.1-.3-6.1c12.9-7.5 26.8-13.6 41.4-17.9zm128-61.3c-16.9-5-34.8 4.6-39.8 21.5s4.6 34.8 21.5 39.8c14.6 4.3 28.5 10.4 41.4 17.9c-.2 2-.3 4.1-.3 6.1c0 35.3 28.7 64 64 64c2.1 0 4.1-.1 6.2-.3c7.5 12.9 13.6 26.8 17.9 41.4c5 16.9 22.9 26.6 39.8 21.5s26.6-22.9 21.5-39.8c-6.4-21.5-15.5-41.8-27-60.6c3.6-8 5.6-16.9 5.6-26.3c0-35.3-28.7-64-64-64c-9.4 0-18.3 2-26.3 5.6c-18.7-11.5-39-20.6-60.6-27zM71.9 310.9c-5-16.9-22.9-26.6-39.8-21.5s-26.6 22.9-21.5 39.8c6.4 21.5 15.5 41.8 27 60.6C34 397.7 32 406.6 32 416c0 35.3 28.7 64 64 64c9.4 0 18.3-2 26.3-5.6c18.7 11.5 39 20.6 60.6 27c16.9 5 34.8-4.6 39.8-21.5s-4.6-34.8-21.5-39.8c-14.6-4.3-28.5-10.4-41.4-17.9c.2-2 .3-4.1 .3-6.2c0-35.3-28.7-64-64-64c-2.1 0-4.1 .1-6.2 .3c-7.5-12.9-13.6-26.8-17.9-41.4zm429.4 18.3c5-16.9-4.6-34.8-21.5-39.8s-34.8 4.6-39.8 21.5c-4.3 14.6-10.4 28.5-17.9 41.4c-2-.2-4.1-.3-6.2-.3c-35.3 0-64 28.7-64 64c0 2.1 .1 4.1 .3 6.2c-12.9 7.5-26.8 13.6-41.4 17.9c-16.9 5-26.6 22.9-21.5 39.8s22.9 26.6 39.8 21.5c21.5-6.4 41.8-15.5 60.6-27c8 3.6 16.9 5.6 26.3 5.6c35.3 0 64-28.7 64-64c0-9.4-2-18.3-5.6-26.3c11.5-18.7 20.6-39 27-60.6zM192.8 256.8c0-15.6 5.6-29.9 14.9-41.1L223 231c6.6 6.6 17.8 1.9 17.8-7.4l0-60.5c0-5.7-4.7-10.4-10.4-10.4l-60.5 0c-9.3 0-13.9 11.2-7.4 17.8l11.2 11.2c-17.9 19.8-28.9 46.2-28.9 75.1c0 43.6 24.9 81.3 61.1 99.8c11.8 6 26.3 1.4 32.3-10.4s1.4-26.3-10.4-32.3c-20.8-10.6-34.9-32.2-34.9-57zm93.1-58.6c20.8 10.6 34.9 32.2 34.9 57c0 15.6-5.6 29.9-14.9 41.1L290.6 281c-6.6-6.6-17.8-1.9-17.8 7.4l0 60.5c0 5.7 4.7 10.4 10.4 10.4l60.5 0c9.3 0 13.9-11.2 7.4-17.8l-11.2-11.2c17.9-19.8 28.9-46.2 28.9-75.1c0-43.6-24.9-81.3-61.1-99.8c-11.8-6-26.3-1.4-32.3 10.4s-1.4 26.3 10.4 32.3z"
    ]
};
const $d8206b3ab2e65c05$export$8b89ca3201039376 = {
    prefix: 'fas',
    iconName: 'bowl-food',
    icon: [
        512,
        512,
        [],
        "e4c6",
        "M0 192c0-35.3 28.7-64 64-64c.5 0 1.1 0 1.6 0C73 91.5 105.3 64 144 64c15 0 29 4.1 40.9 11.2C198.2 49.6 225.1 32 256 32s57.8 17.6 71.1 43.2C339 68.1 353 64 368 64c38.7 0 71 27.5 78.4 64c.5 0 1.1 0 1.6 0c35.3 0 64 28.7 64 64c0 11.7-3.1 22.6-8.6 32L8.6 224C3.1 214.6 0 203.7 0 192zm0 91.4C0 268.3 12.3 256 27.4 256l457.1 0c15.1 0 27.4 12.3 27.4 27.4c0 70.5-44.4 130.7-106.7 154.1L403.5 452c-2 16-15.6 28-31.8 28l-231.5 0c-16.1 0-29.8-12-31.8-28l-1.8-14.4C44.4 414.1 0 353.9 0 283.4z"
    ]
};
const $d8206b3ab2e65c05$export$14d66ba7571ae0b9 = {
    prefix: 'fas',
    iconName: 'candy-cane',
    icon: [
        512,
        512,
        [],
        "f786",
        "M348.8 131.5c3.7-2.3 7.9-3.5 12.2-3.5c12.7 0 23 10.3 23 23l0 5.6c0 9.9-5.1 19.1-13.5 24.3L30.1 393.7C.1 412.5-9 451.9 9.7 481.9s58.2 39.1 88.2 20.4L438.4 289.5c45.8-28.6 73.6-78.8 73.6-132.8l0-5.6C512 67.6 444.4 0 361 0c-28.3 0-56 8-80.1 23L254.1 39.7c-30 18.7-39.1 58.2-20.4 88.2s58.2 39.1 88.2 20.4l26.8-16.8zM298.4 49.8c9.2-5.7 19.1-10.1 29.4-13.1L348 97.5c-5.7 1.4-11.2 3.7-16.3 6.8l-12.6 7.9L298.4 49.8zm88.5 52.7l46.2-46.2c8.5 6.5 16.1 14.1 22.6 22.6l-46.2 46.2c-5.1-9.6-13-17.5-22.6-22.6zm28.9 59.3l61.6 20.5c-2.2 10.5-5.8 20.7-10.5 30.2l-62-20.7c6.2-8.8 10.1-19.1 11-30.1zm-86.1 82.5l60.4 37.7-30.2 18.9-60.4-37.7 30.2-18.9zm-107.2 67l60.4 37.7-30.2 18.9-60.4-37.7 30.2-18.9zM119.3 375.7l60.4 37.7-30.2 18.9L89.1 394.6l30.2-18.9z"
    ]
};
const $d8206b3ab2e65c05$export$4229d00802c33062 = {
    prefix: 'fas',
    iconName: 'arrow-down-wide-short',
    icon: [
        576,
        512,
        [
            "sort-amount-asc",
            "sort-amount-down"
        ],
        "f160",
        "M151.6 469.6C145.5 476.2 137 480 128 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L96 365.7 96 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 301.7 32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32l224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L320 96z"
    ]
};
const $d8206b3ab2e65c05$export$ddf8b8dd5983367d = $d8206b3ab2e65c05$export$4229d00802c33062;
const $d8206b3ab2e65c05$export$4b2a02d50e417b5f = $d8206b3ab2e65c05$export$4229d00802c33062;
const $d8206b3ab2e65c05$export$cdd116afa0309c17 = {
    prefix: 'fas',
    iconName: 'cloud-bolt',
    icon: [
        512,
        512,
        [
            127785,
            "thunderstorm"
        ],
        "f76c",
        "M0 224c0 53 43 96 96 96l47.2 0L290 202.5c17.6-14.1 42.6-14 60.2 .2s22.8 38.6 12.8 58.8L333.7 320l18.3 0 64 0c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112c0 7.1 .7 14.1 1.9 20.8C27.6 145.4 0 181.5 0 224zm330.1 3.6c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7l70.1 0L177.7 488.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7l-70.1 0 52.4-104.8c3.4-6.7 1.6-14.9-4.2-19.6z"
    ]
};
const $d8206b3ab2e65c05$export$bbf9e3d433f8f6de = $d8206b3ab2e65c05$export$cdd116afa0309c17;
const $d8206b3ab2e65c05$export$ec658c0f040c3e1a = {
    prefix: 'fas',
    iconName: 'text-slash',
    icon: [
        640,
        512,
        [
            "remove-format"
        ],
        "f87d",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L355.7 253.5 400.2 96 503 96 497 120.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l11-44.1C577.6 61.3 554.7 32 523.5 32L376.1 32l-.3 0L204.5 32c-22 0-41.2 15-46.6 36.4l-6.3 25.2L38.8 5.1zm168 131.7c.1-.3 .2-.7 .3-1L217 96l116.7 0L301.3 210.8l-94.5-74.1zM243.3 416L192 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-42.2 0 17.6-62.1L272.9 311 243.3 416z"
    ]
};
const $d8206b3ab2e65c05$export$d91179f327329532 = $d8206b3ab2e65c05$export$ec658c0f040c3e1a;
const $d8206b3ab2e65c05$export$6143da800b0e6626 = {
    prefix: 'fas',
    iconName: 'face-smile-wink',
    icon: [
        512,
        512,
        [
            128521,
            "smile-wink"
        ],
        "f4da",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.1 325.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm156.4 25.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"
    ]
};
const $d8206b3ab2e65c05$export$f5dbb37f6801ee3f = $d8206b3ab2e65c05$export$6143da800b0e6626;
const $d8206b3ab2e65c05$export$f0858dff6e769cf6 = {
    prefix: 'fas',
    iconName: 'file-word',
    icon: [
        384,
        512,
        [],
        "f1c2",
        "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM111 257.1l26.8 89.2 31.6-90.3c3.4-9.6 12.5-16.1 22.7-16.1s19.3 6.4 22.7 16.1l31.6 90.3L273 257.1c3.8-12.7 17.2-19.9 29.9-16.1s19.9 17.2 16.1 29.9l-48 160c-3 10-12 16.9-22.4 17.1s-19.8-6.2-23.2-16.1L192 336.6l-33.3 95.3c-3.4 9.8-12.8 16.3-23.2 16.1s-19.5-7.1-22.4-17.1l-48-160c-3.8-12.7 3.4-26.1 16.1-29.9s26.1 3.4 29.9 16.1z"
    ]
};
const $d8206b3ab2e65c05$export$c341daeecdea449a = {
    prefix: 'fas',
    iconName: 'file-powerpoint',
    icon: [
        384,
        512,
        [],
        "f1c4",
        "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM136 240l68 0c42 0 76 34 76 76s-34 76-76 76l-44 0 0 32c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56 0-104c0-13.3 10.7-24 24-24zm68 104c15.5 0 28-12.5 28-28s-12.5-28-28-28l-44 0 0 56 44 0z"
    ]
};
const $d8206b3ab2e65c05$export$672e2f590b189583 = {
    prefix: 'fas',
    iconName: 'arrows-left-right',
    icon: [
        512,
        512,
        [
            "arrows-h"
        ],
        "f07e",
        "M406.6 374.6l96-96c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224l-293.5 0 41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 288l293.5 0-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"
    ]
};
const $d8206b3ab2e65c05$export$de517642cdb40354 = $d8206b3ab2e65c05$export$672e2f590b189583;
const $d8206b3ab2e65c05$export$aa54b16c409e882f = {
    prefix: 'fas',
    iconName: 'house-lock',
    icon: [
        640,
        512,
        [],
        "e510",
        "M384 480c0 11.7 3.1 22.6 8.6 32l-.6 0c-22.1 0-40-17.9-40-40l0-24 0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 64 0 24c0 22.1-17.9 40-40 40l-24 0-31.9 0c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2l-16 0c-22.1 0-40-17.9-40-40l0-112c0-.9 0-1.9 .1-2.8l0-69.7-32 0c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L490.7 166.3C447.2 181.7 416 223.2 416 272l0 24.6c-19.1 11.1-32 31.7-32 55.4l0 128zM528 240c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48z"
    ]
};
const $d8206b3ab2e65c05$export$542a9676c5286e01 = {
    prefix: 'fas',
    iconName: 'cloud-arrow-down',
    icon: [
        640,
        512,
        [
            62337,
            "cloud-download",
            "cloud-download-alt"
        ],
        "f0ed",
        "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128l-368 0zm79-167l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39L344 184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 134.1-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z"
    ]
};
const $d8206b3ab2e65c05$export$b318977f29260464 = $d8206b3ab2e65c05$export$542a9676c5286e01;
const $d8206b3ab2e65c05$export$351357a14c41f824 = $d8206b3ab2e65c05$export$542a9676c5286e01;
const $d8206b3ab2e65c05$export$f2819bf60df55912 = {
    prefix: 'fas',
    iconName: 'children',
    icon: [
        640,
        512,
        [],
        "e4e1",
        "M160 0a64 64 0 1 1 0 128A64 64 0 1 1 160 0zM88 480l0-80-17.8 0c-10.9 0-18.6-10.7-15.2-21.1l31.1-93.4L57.5 323.3c-10.7 14.1-30.8 16.8-44.8 6.2s-16.8-30.7-6.2-44.8L65.4 207c22.4-29.6 57.5-47 94.6-47s72.2 17.4 94.6 47l58.9 77.7c10.7 14.1 7.9 34.2-6.2 44.8s-34.2 7.9-44.8-6.2l-28.6-37.8L265 378.9c3.5 10.4-4.3 21.1-15.2 21.1L232 400l0 80c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-80-16 0 0 80c0 17.7-14.3 32-32 32s-32-14.3-32-32zM480 0a64 64 0 1 1 0 128A64 64 0 1 1 480 0zm-8 384l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-179.5L395.1 321c-9.4 15-29.2 19.4-44.1 10s-19.4-29.2-10-44.1l51.7-82.1c17.6-27.9 48.3-44.9 81.2-44.9l12.3 0c33 0 63.7 16.9 81.2 44.9L619.1 287c9.4 15 4.9 34.7-10 44.1s-34.7 4.9-44.1-10L552 300.5 552 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96-16 0z"
    ]
};
const $d8206b3ab2e65c05$export$49a36efd66df775 = {
    prefix: 'fas',
    iconName: 'chalkboard',
    icon: [
        576,
        512,
        [
            "blackboard"
        ],
        "f51b",
        "M96 32C60.7 32 32 60.7 32 96l0 288 64 0L96 96l384 0 0 288 64 0 0-288c0-35.3-28.7-64-64-64L96 32zM224 384l0 32L32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l512 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-128 0 0-32c0-17.7-14.3-32-32-32l-128 0c-17.7 0-32 14.3-32 32z"
    ]
};
const $d8206b3ab2e65c05$export$f497e01bf522fd9c = $d8206b3ab2e65c05$export$49a36efd66df775;
const $d8206b3ab2e65c05$export$ae7fc6b7f0534be9 = {
    prefix: 'fas',
    iconName: 'user-large-slash',
    icon: [
        640,
        512,
        [
            "user-alt-slash"
        ],
        "f4fa",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L381.9 274c48.5-23.2 82.1-72.7 82.1-130C464 64.5 399.5 0 320 0C250.4 0 192.4 49.3 178.9 114.9L38.8 5.1zM545.5 512L528 512 284.3 320l-59 0C136.2 320 64 392.2 64 481.3c0 17 13.8 30.7 30.7 30.7l450.6 0 .3 0z"
    ]
};
const $d8206b3ab2e65c05$export$46185fab4772ada6 = $d8206b3ab2e65c05$export$ae7fc6b7f0534be9;
const $d8206b3ab2e65c05$export$c6c3bd5f7d9b8bf2 = {
    prefix: 'fas',
    iconName: 'envelope-open',
    icon: [
        512,
        512,
        [
            62135
        ],
        "f2b6",
        "M64 208.1L256 65.9 448 208.1l0 47.4L289.5 373c-9.7 7.2-21.4 11-33.5 11s-23.8-3.9-33.5-11L64 255.5l0-47.4zM256 0c-12.1 0-23.8 3.9-33.5 11L25.9 156.7C9.6 168.8 0 187.8 0 208.1L0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-239.9c0-20.3-9.6-39.4-25.9-51.4L289.5 11C279.8 3.9 268.1 0 256 0z"
    ]
};
const $d8206b3ab2e65c05$export$e99ae494101c5e91 = {
    prefix: 'fas',
    iconName: 'handshake-simple-slash',
    icon: [
        640,
        512,
        [
            "handshake-alt-slash"
        ],
        "e05f",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-135-105.8c-1.1-11.4-6.3-22.3-15.3-30.7l-134.2-123-23.4 18.2-26-20.3 77.2-60.1c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L550.2 352l41.8 0c26.5 0 48-21.5 48-48l0-128c0-26.5-21.5-48-48-48l-76 0-4 0-.7 0-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2l-89.7 72.6-25.8-20.3 81.8-66.2c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-35.5 23.7L38.8 5.1zM0 176L0 304c0 26.5 21.5 48 48 48l108.2 0 91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c.8-.8 1.5-1.7 2.2-2.6L41.2 128.5C17.9 131.8 0 151.8 0 176z"
    ]
};
const $d8206b3ab2e65c05$export$ca302f956ae9f1bf = $d8206b3ab2e65c05$export$e99ae494101c5e91;
const $d8206b3ab2e65c05$export$f042d3e458efa721 = {
    prefix: 'fas',
    iconName: 'mattress-pillow',
    icon: [
        640,
        512,
        [],
        "e525",
        "M256 64L64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l192 0 0-384zm32 384l288 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L288 64l0 384zM64 160c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-192z"
    ]
};
const $d8206b3ab2e65c05$export$b731a51acb74b00c = {
    prefix: 'fas',
    iconName: 'guarani-sign',
    icon: [
        384,
        512,
        [],
        "e19a",
        "M192 0c-17.7 0-32 14.3-32 32l0 34.7C69.2 81.9 0 160.9 0 256s69.2 174.1 160 189.3l0 34.7c0 17.7 14.3 32 32 32s32-14.3 32-32l0-34.7c90.8-15.2 160-94.2 160-189.3c0-17.7-14.3-32-32-32l-128 0 0-92c22.1 5.7 41.8 17.1 57.6 32.6c12.6 12.4 32.9 12.2 45.3-.4s12.2-32.9-.5-45.3C299 92 263.5 73.3 224 66.7L224 32c0-17.7-14.3-32-32-32zM160 132L160 380c-55.2-14.2-96-64.3-96-124s40.8-109.8 96-124zM224 380l0-92 92 0c-11.6 45-47 80.4-92 92z"
    ]
};
const $d8206b3ab2e65c05$export$2fd091cb98dc8ab8 = {
    prefix: 'fas',
    iconName: 'arrows-rotate',
    icon: [
        512,
        512,
        [
            128472,
            "refresh",
            "sync"
        ],
        "f021",
        "M105.1 202.6c7.7-21.8 20.2-42.3 37.8-59.8c62.5-62.5 163.8-62.5 226.3 0L386.3 160 352 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l111.5 0c0 0 0 0 0 0l.4 0c17.7 0 32-14.3 32-32l0-112c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 35.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5zM39 289.3c-5 1.5-9.8 4.2-13.7 8.2c-4 4-6.7 8.8-8.1 14c-.3 1.2-.6 2.5-.8 3.8c-.3 1.7-.4 3.4-.4 5.1L16 432c0 17.7 14.3 32 32 32s32-14.3 32-32l0-35.1 17.6 17.5c0 0 0 0 0 0c87.5 87.4 229.3 87.4 316.7 0c24.4-24.4 42.1-53.1 52.9-83.8c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.5 62.5-163.8 62.5-226.3 0l-.1-.1L125.6 352l34.4 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L48.4 288c-1.6 0-3.2 .1-4.8 .3s-3.1 .5-4.6 1z"
    ]
};
const $d8206b3ab2e65c05$export$fd4359e93d7b3d14 = $d8206b3ab2e65c05$export$2fd091cb98dc8ab8;
const $d8206b3ab2e65c05$export$ff87319002e3dae9 = $d8206b3ab2e65c05$export$2fd091cb98dc8ab8;
const $d8206b3ab2e65c05$export$d75fb6743634a0a = {
    prefix: 'fas',
    iconName: 'fire-extinguisher',
    icon: [
        512,
        512,
        [
            129519
        ],
        "f134",
        "M500.3 7.3C507.7 13.3 512 22.4 512 32l0 96c0 9.6-4.3 18.7-11.7 24.7s-17.2 8.5-26.6 6.6l-160-32C301.5 124.9 292 115.7 289 104l-65 0 0 34.8c37.8 18 64 56.5 64 101.2l0 144L64 384l0-144c0-44.7 26.2-83.2 64-101.2l0-28.8c-36.2 11.1-66 36.9-82.3 70.5c-5.8 11.9-20.2 16.9-32.1 11.1S-3.3 171.4 2.5 159.5C26.7 109.8 72.7 72.6 128 60.4L128 32c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 24 65 0c3-11.7 12.5-20.9 24.7-23.4l160-32c9.4-1.9 19.1 .6 26.6 6.6zM288 416l0 32c0 35.3-28.7 64-64 64l-96 0c-35.3 0-64-28.7-64-64l0-32 224 0zM176 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
const $d8206b3ab2e65c05$export$64dd1b27affb6572 = {
    prefix: 'fas',
    iconName: 'cruzeiro-sign',
    icon: [
        448,
        512,
        [],
        "e152",
        "M96 256c0-88.4 71.6-160 160-160c41 0 78.3 15.4 106.7 40.7c13.2 11.8 33.4 10.7 45.2-2.5s10.7-33.4-2.5-45.2c-39.6-35.5-92-57-149.3-57C132.3 32 32 132.3 32 256s100.3 224 224 224c57.4 0 109.7-21.6 149.3-57c13.2-11.8 14.3-32 2.5-45.2s-32-14.3-45.2-2.5C334.3 400.6 297 416 256 416l0-96 0-8.7c0-12.8 10.4-23.3 23.3-23.3c4.6 0 9.1 1.4 12.9 3.9l10.1 6.7c14.7 9.8 34.6 5.8 44.4-8.9s5.8-34.6-8.9-44.4l-10.1-6.7c-14.3-9.6-31.2-14.7-48.4-14.7c-12.4 0-24.2 2.6-34.9 7.3c-5.5-4.5-12.6-7.3-20.3-7.3c-17.7 0-32 14.3-32 32l0 55.3 0 8.7 0 82.7C135.5 378 96 321.6 96 256z"
    ]
};
const $d8206b3ab2e65c05$export$7bf8dfe2e6661a54 = {
    prefix: 'fas',
    iconName: 'greater-than-equal',
    icon: [
        448,
        512,
        [],
        "f532",
        "M52.1 93.7C35.7 87.1 27.7 68.5 34.3 52.1s25.2-24.4 41.6-17.8l320 128C408 167.1 416 178.9 416 192s-8 24.9-20.1 29.7l-320 128c-16.4 6.6-35-1.4-41.6-17.8s1.4-35 17.8-41.6L297.8 192 52.1 93.7zM416 416c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0z"
    ]
};
const $d8206b3ab2e65c05$export$36e034ccc72554a9 = {
    prefix: 'fas',
    iconName: 'shield-halved',
    icon: [
        512,
        512,
        [
            "shield-alt"
        ],
        "f3ed",
        "M256 0c4.6 0 9.2 1 13.4 2.9L457.7 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0zm0 66.8l0 378.1C394 378 431.1 230.1 432 141.4L256 66.8s0 0 0 0z"
    ]
};
const $d8206b3ab2e65c05$export$d6508d18a824f291 = $d8206b3ab2e65c05$export$36e034ccc72554a9;
const $d8206b3ab2e65c05$export$7fb8daedae341012 = {
    prefix: 'fas',
    iconName: 'book-atlas',
    icon: [
        448,
        512,
        [
            "atlas"
        ],
        "f558",
        "M0 96C0 43 43 0 96 0L384 0l32 0c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32l0 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0L96 512c-53 0-96-43-96-96L0 96zM64 416c0 17.7 14.3 32 32 32l256 0 0-64L96 384c-17.7 0-32 14.3-32 32zM247.4 283.8c-3.7 3.7-6.2 4.2-7.4 4.2s-3.7-.5-7.4-4.2c-3.8-3.7-8-10-11.8-18.9c-6.2-14.5-10.8-34.3-12.2-56.9l63 0c-1.5 22.6-6 42.4-12.2 56.9c-3.8 8.9-8 15.2-11.8 18.9zm42.7-9.9c7.3-18.3 12-41.1 13.4-65.9l31.1 0c-4.7 27.9-21.4 51.7-44.5 65.9zm0-163.8c23.2 14.2 39.9 38 44.5 65.9l-31.1 0c-1.4-24.7-6.1-47.5-13.4-65.9zM368 192a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zM145.3 208l31.1 0c1.4 24.7 6.1 47.5 13.4 65.9c-23.2-14.2-39.9-38-44.5-65.9zm31.1-32l-31.1 0c4.7-27.9 21.4-51.7 44.5-65.9c-7.3 18.3-12 41.1-13.4 65.9zm56.1-75.8c3.7-3.7 6.2-4.2 7.4-4.2s3.7 .5 7.4 4.2c3.8 3.7 8 10 11.8 18.9c6.2 14.5 10.8 34.3 12.2 56.9l-63 0c1.5-22.6 6-42.4 12.2-56.9c3.8-8.9 8-15.2 11.8-18.9z"
    ]
};
const $d8206b3ab2e65c05$export$380a9050e42fe5d7 = $d8206b3ab2e65c05$export$7fb8daedae341012;
const $d8206b3ab2e65c05$export$37c67e0b3dc6bd1b = {
    prefix: 'fas',
    iconName: 'virus',
    icon: [
        512,
        512,
        [],
        "e074",
        "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 11.5c0 49.9-60.3 74.9-95.6 39.6L120.2 75C107.7 62.5 87.5 62.5 75 75s-12.5 32.8 0 45.3l8.2 8.2C118.4 163.7 93.4 224 43.5 224L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l11.5 0c49.9 0 74.9 60.3 39.6 95.6L75 391.8c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6l0 11.5c0 17.7 14.3 32 32 32s32-14.3 32-32l0-11.5c0-49.9 60.3-74.9 95.6-39.6l8.2 8.2c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-8.2-8.2c-35.3-35.3-10.3-95.6 39.6-95.6l11.5 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-11.5 0c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C348.3 118.4 288 93.4 288 43.5L288 32zM176 224a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
const $d8206b3ab2e65c05$export$74d890536dbd21b7 = {
    prefix: 'fas',
    iconName: 'envelope-circle-check',
    icon: [
        640,
        512,
        [],
        "e4e8",
        "M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0l57.4-43c23.9-59.8 79.7-103.3 146.3-109.8l13.9-10.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48L48 64zM294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176 0 384c0 35.3 28.7 64 64 64l296.2 0C335.1 417.6 320 378.5 320 336c0-5.6 .3-11.1 .8-16.6l-26.4 19.8zM640 336a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 353.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
const $d8206b3ab2e65c05$export$a137712e11e257dd = {
    prefix: 'fas',
    iconName: 'layer-group',
    icon: [
        576,
        512,
        [],
        "f5fd",
        "M264.5 5.2c14.9-6.9 32.1-6.9 47 0l218.6 101c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 149.8C37.4 145.8 32 137.3 32 128s5.4-17.9 13.9-21.8L264.5 5.2zM476.9 209.6l53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 277.8C37.4 273.8 32 265.3 32 256s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0l152-70.2zm-152 198.2l152-70.2 53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 405.8C37.4 401.8 32 393.3 32 384s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0z"
    ]
};
const $d8206b3ab2e65c05$export$ab3a06d4b53c0fc0 = {
    prefix: 'fas',
    iconName: 'arrows-to-dot',
    icon: [
        512,
        512,
        [],
        "e4be",
        "M256 0c17.7 0 32 14.3 32 32l0 32 32 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-64 64c-12.5 12.5-32.8 12.5-45.3 0l-64-64c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l32 0 0-32c0-17.7 14.3-32 32-32zM169.4 393.4l64-64c12.5-12.5 32.8-12.5 45.3 0l64 64c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8l-32 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-32 0c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9zM32 224l32 0 0-32c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c12.5 12.5 12.5 32.8 0 45.3l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6l0-32-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zm297.4 54.6c-12.5-12.5-12.5-32.8 0-45.3l64-64c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 32 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0 0 32c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-64-64zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $d8206b3ab2e65c05$export$d56753dd2eb5c323 = {
    prefix: 'fas',
    iconName: 'archway',
    icon: [
        512,
        512,
        [],
        "f557",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l448 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32zm0 384c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0 64 0 0-128c0-53 43-96 96-96s96 43 96 96l0 128 64 0 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-288L32 128l0 288z"
    ]
};
const $d8206b3ab2e65c05$export$5e4b6785eedecc1a = {
    prefix: 'fas',
    iconName: 'heart-circle-check',
    icon: [
        576,
        512,
        [],
        "e4fd",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6l0-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1l0 5.8c0 41.5 17.2 81.2 47.6 109.5zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
const $d8206b3ab2e65c05$export$e824540f5a6a8a57 = {
    prefix: 'fas',
    iconName: 'house-chimney-crack',
    icon: [
        576,
        512,
        [
            "house-damage"
        ],
        "f6f1",
        "M575.8 255.5c0 18-15 32.1-32 32.1l-32 0 .7 160.2c.2 35.5-28.5 64.3-64 64.3l-122.1 0L288 448l80.8-67.3c7.8-6.5 7.6-18.6-.4-24.9L250.6 263.2c-14.6-11.5-33.8 7-22.8 22L288 368l-85.5 71.2c-6.1 5-7.5 13.8-3.5 20.5L230.4 512l-102.3 0c-35.3 0-64-28.7-64-64l0-160.4-32 0c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7 416 64c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 121 52.8 46.4c8 7 12 15 11 24z"
    ]
};
const $d8206b3ab2e65c05$export$8d7e943005ce0b49 = $d8206b3ab2e65c05$export$e824540f5a6a8a57;
const $d8206b3ab2e65c05$export$7a4a0e4caa1e4e6f = {
    prefix: 'fas',
    iconName: 'file-zipper',
    icon: [
        384,
        512,
        [
            "file-archive"
        ],
        "f1c6",
        "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM96 48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16zm-6.3 71.8c3.7-14 16.4-23.8 30.9-23.8l14.8 0c14.5 0 27.2 9.7 30.9 23.8l23.5 88.2c1.4 5.4 2.1 10.9 2.1 16.4c0 35.2-28.8 63.7-64 63.7s-64-28.5-64-63.7c0-5.5 .7-11.1 2.1-16.4l23.5-88.2zM112 336c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0z"
    ]
};
const $d8206b3ab2e65c05$export$bf2047a9946b5c3f = $d8206b3ab2e65c05$export$7a4a0e4caa1e4e6f;
const $d8206b3ab2e65c05$export$90b4406457aae8cc = {
    prefix: 'fas',
    iconName: 'square',
    icon: [
        448,
        512,
        [
            9632,
            9723,
            9724,
            61590
        ],
        "f0c8",
        "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"
    ]
};
const $d8206b3ab2e65c05$export$a8a0de30198815a3 = {
    prefix: 'fas',
    iconName: 'martini-glass-empty',
    icon: [
        512,
        512,
        [
            "glass-martini"
        ],
        "f000",
        "M32 0C19.1 0 7.4 7.8 2.4 19.8s-2.2 25.7 6.9 34.9L224 269.3 224 448l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0 96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-178.7L502.6 54.6c9.2-9.2 11.9-22.9 6.9-34.9S492.9 0 480 0L32 0zM256 210.7L109.3 64l293.5 0L256 210.7z"
    ]
};
const $d8206b3ab2e65c05$export$e96f280e39af4a91 = $d8206b3ab2e65c05$export$a8a0de30198815a3;
const $d8206b3ab2e65c05$export$ce96e32767a7dd51 = {
    prefix: 'fas',
    iconName: 'couch',
    icon: [
        640,
        512,
        [],
        "f4b8",
        "M64 160C64 89.3 121.3 32 192 32l256 0c70.7 0 128 57.3 128 128l0 33.6c-36.5 7.4-64 39.7-64 78.4l0 48-384 0 0-48c0-38.7-27.5-71-64-78.4L64 160zM544 272c0-20.9 13.4-38.7 32-45.3c5-1.8 10.4-2.7 16-2.7c26.5 0 48 21.5 48 48l0 176c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32L96 448c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32L0 272c0-26.5 21.5-48 48-48c5.6 0 11 1 16 2.7c18.6 6.6 32 24.4 32 45.3l0 48 0 32 32 0 384 0 32 0 0-32 0-48z"
    ]
};
const $d8206b3ab2e65c05$export$66c557f70914132c = {
    prefix: 'fas',
    iconName: 'cedi-sign',
    icon: [
        384,
        512,
        [],
        "e0df",
        "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 34.7C101.2 81.9 32 160.9 32 256s69.2 174.1 160 189.3l0 34.7c0 17.7 14.3 32 32 32s32-14.3 32-32l0-34.7c30.9-5.2 59.2-17.7 83.2-35.8c14.1-10.6 17-30.7 6.4-44.8s-30.7-17-44.8-6.4c-13.2 9.9-28.3 17.3-44.8 21.6L256 132c16.4 4.2 31.6 11.6 44.8 21.6c14.1 10.6 34.2 7.8 44.8-6.4s7.8-34.2-6.4-44.8c-24-18-52.4-30.6-83.2-35.8L256 32zM192 132L192 380c-55.2-14.2-96-64.3-96-124s40.8-109.8 96-124z"
    ]
};
const $d8206b3ab2e65c05$export$16e344bae4d495ed = {
    prefix: 'fas',
    iconName: 'italic',
    icon: [
        384,
        512,
        [],
        "f033",
        "M128 64c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-58.7 0L160 416l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l58.7 0L224 96l-64 0c-17.7 0-32-14.3-32-32z"
    ]
};
const $d8206b3ab2e65c05$export$257af4c5fc557105 = {
    prefix: 'fas',
    iconName: 'table-cells-column-lock',
    icon: [
        640,
        512,
        [],
        "e678",
        "M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 65.1c-37.8 5.4-69.4 29.6-85.2 62.9L360 224l0 64 56 0 0 8.6c-19.1 11.1-32 31.7-32 55.4l-24 0 0 64 24 0 0 64L64 480c-35.3 0-64-28.7-64-64L0 96zm208 0l0 64 88 0 0-64-88 0zm240 0l-88 0 0 64 88 0 0-64zM208 224l0 64 88 0 0-64-88 0zm0 128l0 64 88 0 0-64-88 0zM528 240c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48z"
    ]
};
const $d8206b3ab2e65c05$export$16a3f12c6ae9650 = {
    prefix: 'fas',
    iconName: 'church',
    icon: [
        640,
        512,
        [
            9962
        ],
        "f51d",
        "M344 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 24-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 0 46.4L183.3 210c-14.5 8.7-23.3 24.3-23.3 41.2L160 512l96 0 0-96c0-35.3 28.7-64 64-64s64 28.7 64 64l0 96 96 0 0-260.8c0-16.9-8.8-32.5-23.3-41.2L344 142.4 344 96l32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0 0-24zM24.9 330.3C9.5 338.8 0 354.9 0 372.4L0 464c0 26.5 21.5 48 48 48l80 0 0-238.4L24.9 330.3zM592 512c26.5 0 48-21.5 48-48l0-91.6c0-17.5-9.5-33.6-24.9-42.1L512 273.6 512 512l80 0z"
    ]
};
const $d8206b3ab2e65c05$export$d477129b070e5ac4 = {
    prefix: 'fas',
    iconName: 'comments-dollar',
    icon: [
        640,
        512,
        [],
        "f653",
        "M416 176c0 97.2-93.1 176-208 176c-38.2 0-73.9-8.7-104.7-23.9c-7.5 4-16 7.9-25.2 11.4C59.8 346.4 37.8 352 16 352c-6.9 0-13.1-4.5-15.2-11.1s.2-13.8 5.8-17.9c0 0 0 0 0 0s0 0 0 0l.2-.2c.2-.2 .6-.4 1.1-.8c1-.8 2.5-2 4.3-3.7c3.6-3.3 8.5-8.1 13.3-14.3c5.5-7 10.7-15.4 14.2-24.7C14.7 250.3 0 214.6 0 176C0 78.8 93.1 0 208 0S416 78.8 416 176zM231.5 383C348.9 372.9 448 288.3 448 176c0-5.2-.2-10.4-.6-15.5C555.1 167.1 640 243.2 640 336c0 38.6-14.7 74.3-39.6 103.4c3.5 9.4 8.7 17.7 14.2 24.7c4.8 6.2 9.7 11 13.3 14.3c1.8 1.6 3.3 2.9 4.3 3.7c.5 .4 .9 .7 1.1 .8l.2 .2s0 0 0 0s0 0 0 0c5.6 4.1 7.9 11.3 5.8 17.9c-2.1 6.6-8.3 11.1-15.2 11.1c-21.8 0-43.8-5.6-62.1-12.5c-9.2-3.5-17.8-7.4-25.2-11.4C505.9 503.3 470.2 512 432 512c-95.6 0-176.2-54.6-200.5-129zM228 72c0-11-9-20-20-20s-20 9-20 20l0 14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1c0 0 0 0 0 0s0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4l0 14.6c0 11 9 20 20 20s20-9 20-20l0-13.8c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7L228 72z"
    ]
};
const $d8206b3ab2e65c05$export$a1672d808fbed0bd = {
    prefix: 'fas',
    iconName: 'democrat',
    icon: [
        640,
        512,
        [],
        "f747",
        "M64 32c0-8.9 3.8-20.9 6.2-27.3C71.2 1.8 74 0 77 0c1.9 0 3.8 .7 5.2 2.1L128 45.7 173.8 2.1C175.2 .7 177.1 0 179 0c3 0 5.8 1.8 6.8 4.7c2.4 6.5 6.2 18.4 6.2 27.3c0 26.5-21.9 42-29.5 46.6l76.2 72.6c6 5.7 13.9 8.8 22.1 8.8L480 160l32 0c40.3 0 78.2 19 102.4 51.2l19.2 25.6c10.6 14.1 7.7 34.2-6.4 44.8s-34.2 7.7-44.8-6.4l-19.2-25.6c-5.3-7-11.8-12.8-19.2-17l0 87.4-352 0-40.4-94.3c-3.9-9.2-15.3-12.6-23.6-7l-42.1 28c-9.1 6.1-19.7 9.3-30.7 9.3l-2 0C23.9 256 0 232.1 0 202.7c0-12.1 4.1-23.8 11.7-33.3L87.6 74.6C78.1 67.4 64 53.2 64 32zM448 352l96 0 0 64 0 64c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-64-160 0 0 64c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-64 0-64 96 0 160 0zM260.9 210.9c-.9-1.8-2.8-2.9-4.8-2.9s-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9 .5 3.9 2.1 5s3.8 1.3 5.6 .4l21-10.7 21 10.7c1.8 .9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.3-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5zM368.1 208c-2 0-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9 .5 3.9 2.1 5s3.8 1.3 5.6 .4l21-10.7 21 10.7c1.8 .9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.4-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5c-.9-1.8-2.8-2.9-4.8-2.9zm116.8 2.9c-.9-1.8-2.8-2.9-4.8-2.9s-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9 .5 3.9 2.1 5s3.8 1.3 5.6 .4l21-10.7 21 10.7c1.8 .9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.4-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5z"
    ]
};
const $d8206b3ab2e65c05$export$3481c1aa28972f9b = {
    prefix: 'fas',
    iconName: 'z',
    icon: [
        384,
        512,
        [
            122
        ],
        "5a",
        "M0 64C0 46.3 14.3 32 32 32l320 0c12.4 0 23.7 7.2 29 18.4s3.6 24.5-4.4 34.1L100.3 416 352 416c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-12.4 0-23.7-7.2-29-18.4s-3.6-24.5 4.4-34.1L283.7 96 32 96C14.3 96 0 81.7 0 64z"
    ]
};
const $d8206b3ab2e65c05$export$5ebd3cd0630e3ae7 = {
    prefix: 'fas',
    iconName: 'person-skiing',
    icon: [
        512,
        512,
        [
            9975,
            "skiing"
        ],
        "f7c9",
        "M380.7 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM2.7 268.9c6.1-11.8 20.6-16.3 32.4-10.2L232.7 361.3l46.2-69.2-75.1-75.1c-14.6-14.6-20.4-33.9-18.4-52.1l108.8 52 39.3 39.3c16.2 16.2 18.7 41.5 6 60.6L289.8 391l128.7 66.8c13.6 7.1 29.8 7.2 43.6 .3l15.2-7.6c11.9-5.9 26.3-1.1 32.2 10.7s1.1 26.3-10.7 32.2l-15.2 7.6c-27.5 13.7-59.9 13.5-87.2-.7L12.9 301.3C1.2 295.2-3.4 280.7 2.7 268.9zM118.9 65.6L137 74.2l8.7-17.4c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-8.5 16.9 54.7 26.2c1.5-.7 3.1-1.4 4.7-2.1l83.4-33.4c34.2-13.7 72.8 4.2 84.5 39.2l17.1 51.2 52.1 26.1c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-58.1-29c-11.4-5.7-20-15.7-24.1-27.8l-5.8-17.3-27.3 12.1-6.8 3-6.7-3.2L151.5 116.7l-9.2 18.4c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l9-18-17.6-8.4c-8-3.8-11.3-13.4-7.5-21.3s13.4-11.3 21.3-7.5z"
    ]
};
const $d8206b3ab2e65c05$export$eae1acab6fb96708 = $d8206b3ab2e65c05$export$5ebd3cd0630e3ae7;
const $d8206b3ab2e65c05$export$b81a894d5bc3eb17 = {
    prefix: 'fas',
    iconName: 'road-lock',
    icon: [
        640,
        512,
        [],
        "e567",
        "M288 32l-74.8 0c-27.1 0-51.3 17.1-60.3 42.6L35.1 407.2c-2.1 5.9-3.1 12-3.1 18.2C32 455.5 56.5 480 86.6 480L288 480l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64 32 0 0-128c0-23.7 12.9-44.4 32-55.4l0-24.6c0-58.3 44.6-106.2 101.5-111.5L487.1 74.6C478 49.1 453.9 32 426.8 32L352 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64zm64 192l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32zm176 16c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
const $d8206b3ab2e65c05$export$406fe05808a3753e = {
    prefix: 'fas',
    iconName: 'a',
    icon: [
        384,
        512,
        [
            97
        ],
        "41",
        "M221.5 51.7C216.6 39.8 204.9 32 192 32s-24.6 7.8-29.5 19.7l-120 288-40 96c-6.8 16.3 .9 35 17.2 41.8s35-.9 41.8-17.2L93.3 384l197.3 0 31.8 76.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8l-40-96-120-288zM264 320l-144 0 72-172.8L264 320z"
    ]
};
const $d8206b3ab2e65c05$export$4520eb1840c4e110 = {
    prefix: 'fas',
    iconName: 'temperature-arrow-down',
    icon: [
        576,
        512,
        [
            "temperature-down"
        ],
        "e03f",
        "M128 112c0-26.5 21.5-48 48-48s48 21.5 48 48l0 164.5c0 17.3 7.1 31.9 15.3 42.5C249.8 332.6 256 349.5 256 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5L128 112zM176 0C114.1 0 64 50.1 64 112l0 164.4c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C43.2 304.2 32 334.8 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6L288 112C288 50.1 237.9 0 176 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3l0-50.7c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 50.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48zm336-64l-32 0 0-288c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 288-32 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c6 6 14.1 9.4 22.6 9.4s16.6-3.4 22.6-9.4l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8z"
    ]
};
const $d8206b3ab2e65c05$export$f0b2aca3866f00f6 = $d8206b3ab2e65c05$export$4520eb1840c4e110;
const $d8206b3ab2e65c05$export$2a9d3e120019c92d = {
    prefix: 'fas',
    iconName: 'feather-pointed',
    icon: [
        512,
        512,
        [
            "feather-alt"
        ],
        "f56b",
        "M278.5 215.6L23 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l74.8-74.8c7.4 4.6 15.3 8.2 23.8 10.5C200.3 452.8 270 454.5 338 409.4c12.2-8.1 5.8-25.4-8.8-25.4l-16.1 0c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l97.7-29.3c3.4-1 6.4-3.1 8.4-6.1c4.4-6.4 8.6-12.9 12.6-19.6c6.2-10.3-1.5-23-13.5-23l-38.6 0c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l80.9-24.3c4.6-1.4 8.4-4.8 10.2-9.3C494.5 163 507.8 86.1 511.9 36.8c.8-9.9-3-19.6-10-26.6s-16.7-10.8-26.6-10C391.5 7 228.5 40.5 137.4 131.6C57.3 211.7 56.7 302.3 71.3 356.4c2.1 7.9 12 9.6 17.8 3.8L253.6 195.8c6.2-6.2 16.4-6.2 22.6 0c5.4 5.4 6.1 13.6 2.2 19.8z"
    ]
};
const $d8206b3ab2e65c05$export$68cf766c786bcd78 = $d8206b3ab2e65c05$export$2a9d3e120019c92d;
const $d8206b3ab2e65c05$export$bcb419f1cd5beac3 = {
    prefix: 'fas',
    iconName: 'p',
    icon: [
        320,
        512,
        [
            112
        ],
        "50",
        "M0 96C0 60.7 28.7 32 64 32l96 0c88.4 0 160 71.6 160 160s-71.6 160-160 160l-96 0 0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 320 0 96zM64 288l96 0c53 0 96-43 96-96s-43-96-96-96L64 96l0 192z"
    ]
};
const $d8206b3ab2e65c05$export$bab8f3647c394f48 = {
    prefix: 'fas',
    iconName: 'snowflake',
    icon: [
        448,
        512,
        [
            10052,
            10054
        ],
        "f2dc",
        "M224 0c17.7 0 32 14.3 32 32l0 30.1 15-15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-49 49 0 70.3 61.4-35.8 17.7-66.1c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4l-5.2 19.3 23.6-13.8c15.3-8.9 34.9-3.7 43.8 11.5s3.8 34.9-11.5 43.8l-25.3 14.8 21.7 5.8c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-67.7-18.1L287.5 256l60.9 35.5 67.7-18.1c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4l-21.7 5.8 25.3 14.8c15.3 8.9 20.4 28.5 11.5 43.8s-28.5 20.4-43.8 11.5l-23.6-13.8 5.2 19.3c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-17.7-66.1L256 311.7l0 70.3 49 49c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15 0 30.1c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-30.1-15 15c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l49-49 0-70.3-61.4 35.8-17.7 66.1c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4l5.2-19.3L48.1 395.6c-15.3 8.9-34.9 3.7-43.8-11.5s-3.7-34.9 11.5-43.8l25.3-14.8-21.7-5.8c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l67.7 18.1L160.5 256 99.6 220.5 31.9 238.6c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4l21.7-5.8L15.9 171.6C.6 162.7-4.5 143.1 4.4 127.9s28.5-20.4 43.8-11.5l23.6 13.8-5.2-19.3c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l17.7 66.1L192 200.3l0-70.3L143 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l15 15L192 32c0-17.7 14.3-32 32-32z"
    ]
};
const $d8206b3ab2e65c05$export$d91b374112d4f8c1 = {
    prefix: 'fas',
    iconName: 'newspaper',
    icon: [
        512,
        512,
        [
            128240
        ],
        "f1ea",
        "M96 96c0-35.3 28.7-64 64-64l288 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L80 480c-44.2 0-80-35.8-80-80L0 128c0-17.7 14.3-32 32-32s32 14.3 32 32l0 272c0 8.8 7.2 16 16 16s16-7.2 16-16L96 96zm64 24l0 80c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24l0-80c0-13.3-10.7-24-24-24L184 96c-13.3 0-24 10.7-24 24zm208-8c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zM160 304c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-256 0c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-256 0c-8.8 0-16 7.2-16 16z"
    ]
};
const $d8206b3ab2e65c05$export$d0ccaddca9e06d1e = {
    prefix: 'fas',
    iconName: 'rectangle-ad',
    icon: [
        576,
        512,
        [
            "ad"
        ],
        "f641",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM229.5 173.3l72 144c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7L253.2 328l-90.3 0-5.4 10.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l72-144c4.1-8.1 12.4-13.3 21.5-13.3s17.4 5.1 21.5 13.3zM208 237.7L186.8 280l42.3 0L208 237.7zM392 256a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm24-43.9l0-28.1c0-13.3 10.7-24 24-24s24 10.7 24 24l0 96 0 48c0 13.3-10.7 24-24 24c-6.6 0-12.6-2.7-17-7c-9.4 4.5-19.9 7-31 7c-39.8 0-72-32.2-72-72s32.2-72 72-72c8.4 0 16.5 1.4 24 4.1z"
    ]
};
const $d8206b3ab2e65c05$export$7af266c3465b1ff2 = $d8206b3ab2e65c05$export$d0ccaddca9e06d1e;
const $d8206b3ab2e65c05$export$2f1e22e081a1ad05 = {
    prefix: 'fas',
    iconName: 'circle-arrow-right',
    icon: [
        512,
        512,
        [
            "arrow-circle-right"
        ],
        "f0a9",
        "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM297 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L120 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l214.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L409 239c9.4 9.4 9.4 24.6 0 33.9L297 385z"
    ]
};
const $d8206b3ab2e65c05$export$7d3d828103aa3be7 = $d8206b3ab2e65c05$export$2f1e22e081a1ad05;
const $d8206b3ab2e65c05$export$fb5ab619c34ea613 = {
    prefix: 'fas',
    iconName: 'filter-circle-xmark',
    icon: [
        576,
        512,
        [],
        "e17b",
        "M3.9 22.9C10.5 8.9 24.5 0 40 0L472 0c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L396.4 195.6C316.2 212.1 256 283 256 368c0 27.4 6.3 53.4 17.5 76.5c-1.6-.8-3.2-1.8-4.7-2.9l-64-48c-8.1-6-12.8-15.5-12.8-25.6l0-79.1L9 65.3C-.7 53.4-2.8 36.8 3.9 22.9zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"
    ]
};
const $d8206b3ab2e65c05$export$4982360d3b844c19 = {
    prefix: 'fas',
    iconName: 'locust',
    icon: [
        576,
        512,
        [],
        "e520",
        "M312 32c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0c98.7 0 180.6 71.4 197 165.4c-9-3.5-18.8-5.4-29-5.4l-64.2 0-41.8-97.5c-3.4-7.9-10.8-13.4-19.3-14.4s-17 2.7-22.1 9.6l-40.9 55.5-21.7-50.7c-3.3-7.8-10.5-13.2-18.9-14.3s-16.7 2.3-22 8.9l-240 304c-8.2 10.4-6.4 25.5 4 33.7s25.5 6.4 33.7-4l79.4-100.5 43 16.4-40.5 55c-7.9 10.7-5.6 25.7 5.1 33.6s25.7 5.6 33.6-5.1L215.1 400l74.5 0-29.3 42.3c-7.5 10.9-4.8 25.8 6.1 33.4s25.8 4.8 33.4-6.1L348 400l80.4 0 38.8 67.9c6.6 11.5 21.2 15.5 32.7 8.9s15.5-21.2 8.9-32.7L483.6 400l12.4 0c44.1 0 79.8-35.7 80-79.7c0-.1 0-.2 0-.3l0-40C576 143 465 32 328 32l-16 0zm50.5 168l17.1 40L333 240l29.5-40zm-87.7 38.1l-1.4 1.9-48.2 0 32.7-41.5 16.9 39.5zM88.8 240C57.4 240 32 265.4 32 296.8c0 15.5 6.3 30 16.9 40.4L126.7 240l-37.9 0zM496 288a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
    ]
};
const $d8206b3ab2e65c05$export$4941c5969d5399b = {
    prefix: 'fas',
    iconName: 'sort',
    icon: [
        320,
        512,
        [
            "unsorted"
        ],
        "f0dc",
        "M137.4 41.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8L32 224c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128zm0 429.3l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l256 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128c-12.5 12.5-32.8 12.5-45.3 0z"
    ]
};
const $d8206b3ab2e65c05$export$418597748f0fe52d = $d8206b3ab2e65c05$export$4941c5969d5399b;
const $d8206b3ab2e65c05$export$3db8f67cd0fc963b = {
    prefix: 'fas',
    iconName: 'list-ol',
    icon: [
        512,
        512,
        [
            "list-1-2",
            "list-numeric"
        ],
        "f0cb",
        "M24 56c0-13.3 10.7-24 24-24l32 0c13.3 0 24 10.7 24 24l0 120 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l16 0 0-96-8 0C34.7 80 24 69.3 24 56zM86.7 341.2c-6.5-7.4-18.3-6.9-24 1.2L51.5 357.9c-7.7 10.8-22.7 13.3-33.5 5.6s-13.3-22.7-5.6-33.5l11.1-15.6c23.7-33.2 72.3-35.6 99.2-4.9c21.3 24.4 20.8 60.9-1.1 84.7L86.8 432l33.2 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-88 0c-9.5 0-18.2-5.6-22-14.4s-2.1-18.9 4.3-25.9l72-78c5.3-5.8 5.4-14.6 .3-20.5zM224 64l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
const $d8206b3ab2e65c05$export$7e3d894cd55296b = $d8206b3ab2e65c05$export$3db8f67cd0fc963b;
const $d8206b3ab2e65c05$export$cf51408faadac277 = $d8206b3ab2e65c05$export$3db8f67cd0fc963b;
const $d8206b3ab2e65c05$export$523180e731928397 = {
    prefix: 'fas',
    iconName: 'person-dress-burst',
    icon: [
        640,
        512,
        [],
        "e544",
        "M528 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM390.2 384l17.8 0 0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96 16 0 0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96 17.8 0c10.9 0 18.6-10.7 15.2-21.1L546.7 248.1l33.9 56.3c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-53.6-89.2c-20.2-33.7-56.7-54.3-96-54.3l-11.6 0c-39.3 0-75.7 20.6-96 54.3l-53.6 89.2c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9l33.9-56.3L375 362.9c-3.5 10.4 4.3 21.1 15.2 21.1zM190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6L176 286.1l58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 50.5-7.8 24.4-40.5-55.2-38L315 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3L220.3 92.1l-29.4-74z"
    ]
};
const $d8206b3ab2e65c05$export$eeb59dd1825c6a65 = {
    prefix: 'fas',
    iconName: 'money-check-dollar',
    icon: [
        576,
        512,
        [
            "money-check-alt"
        ],
        "f53d",
        "M64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64zM272 192l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM256 304c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16zM164 152l0 13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9l0 13.8c0 11-9 20-20 20s-20-9-20-20l0-14.6c-10.3-2.2-20-5.5-28.2-8.4c0 0 0 0 0 0s0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5l0-14c0-11 9-20 20-20s20 9 20 20z"
    ]
};
const $d8206b3ab2e65c05$export$8c6ccc9745897cb2 = $d8206b3ab2e65c05$export$eeb59dd1825c6a65;
const $d8206b3ab2e65c05$export$567d5631a7b0599f = {
    prefix: 'fas',
    iconName: 'vector-square',
    icon: [
        448,
        512,
        [],
        "f5cb",
        "M368 80l32 0 0 32-32 0 0-32zM352 32c-17.7 0-32 14.3-32 32L128 64c0-17.7-14.3-32-32-32L32 32C14.3 32 0 46.3 0 64l0 64c0 17.7 14.3 32 32 32l0 192c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l192 0c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l0-192c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0zM96 160c17.7 0 32-14.3 32-32l192 0c0 17.7 14.3 32 32 32l0 192c-17.7 0-32 14.3-32 32l-192 0c0-17.7-14.3-32-32-32l0-192zM48 400l32 0 0 32-32 0 0-32zm320 32l0-32 32 0 0 32-32 0zM48 112l0-32 32 0 0 32-32 0z"
    ]
};
const $d8206b3ab2e65c05$export$d78e8b0681279167 = {
    prefix: 'fas',
    iconName: 'bread-slice',
    icon: [
        512,
        512,
        [],
        "f7ec",
        "M256 32C192 32 0 64 0 192c0 35.3 28.7 64 64 64V432c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V256c35.3 0 64-28.7 64-64C512 64 320 32 256 32z"
    ]
};
const $d8206b3ab2e65c05$export$8a7bee49fdf8c954 = {
    prefix: 'fas',
    iconName: 'language',
    icon: [
        640,
        512,
        [],
        "f1ab",
        "M0 128C0 92.7 28.7 64 64 64l192 0 48 0 16 0 256 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64l-256 0-16 0-48 0L64 448c-35.3 0-64-28.7-64-64L0 128zm320 0l0 256 256 0 0-256-256 0zM178.3 175.9c-3.2-7.2-10.4-11.9-18.3-11.9s-15.1 4.7-18.3 11.9l-64 144c-4.5 10.1 .1 21.9 10.2 26.4s21.9-.1 26.4-10.2l8.9-20.1 73.6 0 8.9 20.1c4.5 10.1 16.3 14.6 26.4 10.2s14.6-16.3 10.2-26.4l-64-144zM160 233.2L179 276l-38 0 19-42.8zM448 164c11 0 20 9 20 20l0 4 44 0 16 0c11 0 20 9 20 20s-9 20-20 20l-2 0-1.6 4.5c-8.9 24.4-22.4 46.6-39.6 65.4c.9 .6 1.8 1.1 2.7 1.6l18.9 11.3c9.5 5.7 12.5 18 6.9 27.4s-18 12.5-27.4 6.9l-18.9-11.3c-4.5-2.7-8.8-5.5-13.1-8.5c-10.6 7.5-21.9 14-34 19.4l-3.6 1.6c-10.1 4.5-21.9-.1-26.4-10.2s.1-21.9 10.2-26.4l3.6-1.6c6.4-2.9 12.6-6.1 18.5-9.8l-12.2-12.2c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0l14.6 14.6 .5 .5c12.4-13.1 22.5-28.3 29.8-45L448 228l-72 0c-11 0-20-9-20-20s9-20 20-20l52 0 0-4c0-11 9-20 20-20z"
    ]
};
const $d8206b3ab2e65c05$export$611ae61f02de0aa = {
    prefix: 'fas',
    iconName: 'face-kiss-wink-heart',
    icon: [
        512,
        512,
        [
            128536,
            "kiss-wink-heart"
        ],
        "f598",
        "M498 339.7c9.1-26.2 14-54.4 14-83.7C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c35.4 0 69.1-7.2 99.7-20.2c-4.8-5.5-8.5-12.2-10.4-19.7l-22.9-89.3c-10-39 11.8-80.9 51.8-92.1c37.2-10.4 73.8 10.1 87.5 44c12.7-1.6 25.1 .4 36.2 5zM296 332c0 6.9-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C258.7 443.1 241.4 448 224 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9c0 0 0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.6-.4-.3-.2-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm194.8 57.6c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zM434 352.3c-6-23.2-28.8-37-51.1-30.8s-35.4 30.1-29.5 53.4l22.9 89.3c2.2 8.7 11.2 13.9 19.8 11.4l84.9-23.8c22.2-6.2 35.4-30.1 29.5-53.4s-28.8-37-51.1-30.8l-20.2 5.6-5.4-21z"
    ]
};
const $d8206b3ab2e65c05$export$ebba617701dfb917 = $d8206b3ab2e65c05$export$611ae61f02de0aa;
const $d8206b3ab2e65c05$export$f253a38d7142e29f = {
    prefix: 'fas',
    iconName: 'filter',
    icon: [
        512,
        512,
        [],
        "f0b0",
        "M3.9 54.9C10.5 40.9 24.5 32 40 32l432 0c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L320 320.9 320 448c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48c-8.1-6-12.8-15.5-12.8-25.6l0-79.1L9 97.3C-.7 85.4-2.8 68.8 3.9 54.9z"
    ]
};
const $d8206b3ab2e65c05$export$d96973f90e8f6e47 = {
    prefix: 'fas',
    iconName: 'question',
    icon: [
        320,
        512,
        [
            10067,
            10068,
            61736
        ],
        "3f",
        "M80 160c0-35.3 28.7-64 64-64l32 0c35.3 0 64 28.7 64 64l0 3.6c0 21.8-11.1 42.1-29.4 53.8l-42.2 27.1c-25.2 16.2-40.4 44.1-40.4 74l0 1.4c0 17.7 14.3 32 32 32s32-14.3 32-32l0-1.4c0-8.2 4.2-15.8 11-20.2l42.2-27.1c36.6-23.6 58.8-64.1 58.8-107.7l0-3.6c0-70.7-57.3-128-128-128l-32 0C73.3 32 16 89.3 16 160c0 17.7 14.3 32 32 32s32-14.3 32-32zm80 320a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
    ]
};
const $d8206b3ab2e65c05$export$d0de575ac166712b = {
    prefix: 'fas',
    iconName: 'file-signature',
    icon: [
        576,
        512,
        [],
        "f573",
        "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-19.3c-2.7 1.1-5.4 2-8.2 2.7l-60.1 15c-3 .7-6 1.2-9 1.4c-.9 .1-1.8 .2-2.7 .2l-64 0c-6.1 0-11.6-3.4-14.3-8.8l-8.8-17.7c-1.7-3.4-5.1-5.5-8.8-5.5s-7.2 2.1-8.8 5.5l-8.8 17.7c-2.9 5.9-9.2 9.4-15.7 8.8s-12.1-5.1-13.9-11.3L144 381l-9.8 32.8c-6.1 20.3-24.8 34.2-46 34.2L80 448c-8.8 0-16-7.2-16-16s7.2-16 16-16l8.2 0c7.1 0 13.3-4.6 15.3-11.4l14.9-49.5c3.4-11.3 13.8-19.1 25.6-19.1s22.2 7.8 25.6 19.1l11.6 38.6c7.4-6.2 16.8-9.7 26.8-9.7c15.9 0 30.4 9 37.5 23.2l4.4 8.8 8.9 0c-3.1-8.8-3.7-18.4-1.4-27.8l15-60.1c2.8-11.3 8.6-21.5 16.8-29.7L384 203.6l0-43.6-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM549.8 139.7c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM311.9 321c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L512.1 262.7l-71-71L311.9 321z"
    ]
};
const $d8206b3ab2e65c05$export$cd7b22f4e6e3834b = {
    prefix: 'fas',
    iconName: 'up-down-left-right',
    icon: [
        512,
        512,
        [
            "arrows-alt"
        ],
        "f0b2",
        "M278.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l32 0 0 96-96 0 0-32c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6l0-32 96 0 0 96-32 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8l-32 0 0-96 96 0 0 32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 32-96 0 0-96 32 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64z"
    ]
};
const $d8206b3ab2e65c05$export$3cdabfff52cfc73a = $d8206b3ab2e65c05$export$cd7b22f4e6e3834b;
const $d8206b3ab2e65c05$export$1ddbaebce033a0d = {
    prefix: 'fas',
    iconName: 'house-chimney-user',
    icon: [
        576,
        512,
        [],
        "e065",
        "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L512 185l0-121c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32l0 36.7L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1l32 0 0 160.4c0 35.3 28.7 64 64 64l320.4 0c35.5 0 64.2-28.8 64-64.3l-.7-160.2 32 0zM288 160a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM176 400c0-44.2 35.8-80 80-80l64 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16z"
    ]
};
const $d8206b3ab2e65c05$export$97e5ef3e80a0fbef = {
    prefix: 'fas',
    iconName: 'hand-holding-heart',
    icon: [
        576,
        512,
        [],
        "f4be",
        "M163.9 136.9c-29.4-29.8-29.4-78.2 0-108s77-29.8 106.4 0l17.7 18 17.7-18c29.4-29.8 77-29.8 106.4 0s29.4 78.2 0 108L310.5 240.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4L163.9 136.9zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5L192 512 32 512c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l36.8 0 44.9-36c22.7-18.2 50.9-28 80-28l78.3 0 16 0 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l120.6 0 119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384c0 0 0 0 0 0l-.9 0c.3 0 .6 0 .9 0z"
    ]
};
const $d8206b3ab2e65c05$export$7ee0dbd1e92e2859 = {
    prefix: 'fas',
    iconName: 'puzzle-piece',
    icon: [
        512,
        512,
        [
            129513
        ],
        "f12e",
        "M192 104.8c0-9.2-5.8-17.3-13.2-22.8C167.2 73.3 160 61.3 160 48c0-26.5 28.7-48 64-48s64 21.5 64 48c0 13.3-7.2 25.3-18.8 34c-7.4 5.5-13.2 13.6-13.2 22.8c0 12.8 10.4 23.2 23.2 23.2l56.8 0c26.5 0 48 21.5 48 48l0 56.8c0 12.8 10.4 23.2 23.2 23.2c9.2 0 17.3-5.8 22.8-13.2c8.7-11.6 20.7-18.8 34-18.8c26.5 0 48 28.7 48 64s-21.5 64-48 64c-13.3 0-25.3-7.2-34-18.8c-5.5-7.4-13.6-13.2-22.8-13.2c-12.8 0-23.2 10.4-23.2 23.2L384 464c0 26.5-21.5 48-48 48l-56.8 0c-12.8 0-23.2-10.4-23.2-23.2c0-9.2 5.8-17.3 13.2-22.8c11.6-8.7 18.8-20.7 18.8-34c0-26.5-28.7-48-64-48s-64 21.5-64 48c0 13.3 7.2 25.3 18.8 34c7.4 5.5 13.2 13.6 13.2 22.8c0 12.8-10.4 23.2-23.2 23.2L48 512c-26.5 0-48-21.5-48-48L0 343.2C0 330.4 10.4 320 23.2 320c9.2 0 17.3 5.8 22.8 13.2C54.7 344.8 66.7 352 80 352c26.5 0 48-28.7 48-64s-21.5-64-48-64c-13.3 0-25.3 7.2-34 18.8C40.5 250.2 32.4 256 23.2 256C10.4 256 0 245.6 0 232.8L0 176c0-26.5 21.5-48 48-48l120.8 0c12.8 0 23.2-10.4 23.2-23.2z"
    ]
};
const $d8206b3ab2e65c05$export$be069f641c85d0b3 = {
    prefix: 'fas',
    iconName: 'money-check',
    icon: [
        576,
        512,
        [],
        "f53c",
        "M64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64zm48 160l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM96 336c0-8.8 7.2-16 16-16l352 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-352 0c-8.8 0-16-7.2-16-16zM376 160l80 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24z"
    ]
};
const $d8206b3ab2e65c05$export$3e4892d8bf919edd = {
    prefix: 'fas',
    iconName: 'star-half-stroke',
    icon: [
        576,
        512,
        [
            "star-half-alt"
        ],
        "f5c0",
        "M288 376.4l.1-.1 26.4 14.1 85.2 45.5-16.5-97.6-4.8-28.7 20.7-20.5 70.1-69.3-96.1-14.2-29.3-4.3-12.9-26.6L288.1 86.9l-.1 .3 0 289.2zm175.1 98.3c2 12-3 24.2-12.9 31.3s-23 8-33.8 2.3L288.1 439.8 159.8 508.3C149 514 135.9 513.1 126 506s-14.9-19.3-12.9-31.3L137.8 329 33.6 225.9c-8.6-8.5-11.7-21.2-7.9-32.7s13.7-19.9 25.7-21.7L195 150.3 259.4 18c5.4-11 16.5-18 28.8-18s23.4 7 28.8 18l64.3 132.3 143.6 21.2c12 1.8 22 10.2 25.7 21.7s.7 24.2-7.9 32.7L438.5 329l24.6 145.7z"
    ]
};
const $d8206b3ab2e65c05$export$c13575f42532efb3 = $d8206b3ab2e65c05$export$3e4892d8bf919edd;
const $d8206b3ab2e65c05$export$eba095993e51cc97 = {
    prefix: 'fas',
    iconName: 'code',
    icon: [
        640,
        512,
        [],
        "f121",
        "M392.8 1.2c-17-4.9-34.7 5-39.6 22l-128 448c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l128-448c4.9-17-5-34.7-22-39.6zm80.6 120.1c-12.5 12.5-12.5 32.8 0 45.3L562.7 256l-89.4 89.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-112-112c-12.5-12.5-32.8-12.5-45.3 0zm-306.7 0c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l112 112c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256l89.4-89.4c12.5-12.5 12.5-32.8 0-45.3z"
    ]
};
const $d8206b3ab2e65c05$export$f1304dd34ea2afbd = {
    prefix: 'fas',
    iconName: 'whiskey-glass',
    icon: [
        512,
        512,
        [
            129347,
            "glass-whiskey"
        ],
        "f7a0",
        "M32 32c-9.3 0-18.1 4-24.2 11.1S-1 59.4 .3 68.6l50 342.9c5.7 39.3 39.4 68.5 79.2 68.5l253 0c39.7 0 73.4-29.1 79.2-68.5l50-342.9c1.3-9.2-1.4-18.5-7.5-25.5S489.3 32 480 32L32 32zM87.7 224L69 96l374 0L424.3 224 87.7 224z"
    ]
};
const $d8206b3ab2e65c05$export$fdec0f5f1a169419 = $d8206b3ab2e65c05$export$f1304dd34ea2afbd;
const $d8206b3ab2e65c05$export$c49f030b19083ebe = {
    prefix: 'fas',
    iconName: 'building-circle-exclamation',
    icon: [
        640,
        512,
        [],
        "e4d3",
        "M48 0C21.5 0 0 21.5 0 48L0 464c0 26.5 21.5 48 48 48l96 0 0-80c0-26.5 21.5-48 48-48s48 21.5 48 48l0 80 96 0c15.1 0 28.5-6.9 37.3-17.8C340.4 462.2 320 417.5 320 368c0-54.7 24.9-103.5 64-135.8L384 48c0-26.5-21.5-48-48-48L48 0zM64 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm112-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM80 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM272 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16z"
    ]
};
const $d8206b3ab2e65c05$export$6a1e4cdbb8ca10c5 = {
    prefix: 'fas',
    iconName: 'magnifying-glass-chart',
    icon: [
        512,
        512,
        [],
        "e522",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zm-312 8l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80-96l0 160c0 13.3 10.7 24 24 24s24-10.7 24-24l0-160c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80 64l0 96c0 13.3 10.7 24 24 24s24-10.7 24-24l0-96c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
    ]
};
const $d8206b3ab2e65c05$export$5ad84e891223f2c3 = {
    prefix: 'fas',
    iconName: 'arrow-up-right-from-square',
    icon: [
        512,
        512,
        [
            "external-link"
        ],
        "f08e",
        "M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l82.7 0L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3l0 82.7c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160c0-17.7-14.3-32-32-32L320 0zM80 32C35.8 32 0 67.8 0 112L0 432c0 44.2 35.8 80 80 80l320 0c44.2 0 80-35.8 80-80l0-112c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 112c0 8.8-7.2 16-16 16L80 448c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l112 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 32z"
    ]
};
const $d8206b3ab2e65c05$export$f4c613289034e5ef = $d8206b3ab2e65c05$export$5ad84e891223f2c3;
const $d8206b3ab2e65c05$export$b1f00c433aabac05 = {
    prefix: 'fas',
    iconName: 'cubes-stacked',
    icon: [
        448,
        512,
        [],
        "e4e6",
        "M192 64l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32zM82.7 207c-15.3 8.8-20.5 28.4-11.7 43.7l32 55.4c8.8 15.3 28.4 20.5 43.7 11.7l55.4-32c15.3-8.8 20.5-28.4 11.7-43.7l-32-55.4c-8.8-15.3-28.4-20.5-43.7-11.7L82.7 207zM288 192c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0zm64 160c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0zM160 384l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32zM32 352c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0z"
    ]
};
const $d8206b3ab2e65c05$export$51790ddd26e431bc = {
    prefix: 'fas',
    iconName: 'won-sign',
    icon: [
        512,
        512,
        [
            8361,
            "krw",
            "won"
        ],
        "f159",
        "M62.4 53.9C56.8 37.1 38.6 28.1 21.9 33.6S-3.9 57.4 1.6 74.1L51.6 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l40.9 0 56.7 170.1c4.5 13.5 17.4 22.4 31.6 21.9s26.4-10.4 29.8-24.2L233 288l46 0L321 455.8c3.4 13.8 15.6 23.7 29.8 24.2s27.1-8.4 31.6-21.9L439.1 288l40.9 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-19.6 0 50-149.9c5.6-16.8-3.5-34.9-20.2-40.5s-34.9 3.5-40.5 20.2L392.9 224l-64 0L287 56.2C283.5 42 270.7 32 256 32s-27.5 10-31 24.2L183 224l-64 0L62.4 53.9zm78 234.1l26.6 0-11.4 45.6L140.4 288zM249 224l7-28.1 7 28.1-14 0zm96 64l26.6 0-15.2 45.6L345 288z"
    ]
};
const $d8206b3ab2e65c05$export$2f65e07a45b95b50 = $d8206b3ab2e65c05$export$51790ddd26e431bc;
const $d8206b3ab2e65c05$export$5a1fd3ed9564d7fa = $d8206b3ab2e65c05$export$51790ddd26e431bc;
const $d8206b3ab2e65c05$export$1df4e031b8ee4f84 = {
    prefix: 'fas',
    iconName: 'virus-covid',
    icon: [
        512,
        512,
        [],
        "e4a8",
        "M192 24c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0 0 33.6c30.7 4.2 58.8 16.3 82.3 34.1L386.1 92 374.8 80.6c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l56.6 56.6c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L420 125.9l-23.8 23.8c17.9 23.5 29.9 51.7 34.1 82.3l33.6 0 0-16c0-13.3 10.7-24 24-24s24 10.7 24 24l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16-33.6 0c-4.2 30.7-16.3 58.8-34.1 82.3L420 386.1l11.3-11.3c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-56.6 56.6c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L386.1 420l-23.8-23.8c-23.5 17.9-51.7 29.9-82.3 34.1l0 33.6 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l16 0 0-33.6c-30.7-4.2-58.8-16.3-82.3-34.1L125.9 420l11.3 11.3c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L46.7 408.7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L92 386.1l23.8-23.8C97.9 338.8 85.8 310.7 81.6 280L48 280l0 16c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24s24 10.7 24 24l0 16 33.6 0c4.2-30.7 16.3-58.8 34.1-82.3L92 125.9 80.6 137.2c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l56.6-56.6c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L125.9 92l23.8 23.8c23.5-17.9 51.7-29.9 82.3-34.1L232 48l-16 0c-13.3 0-24-10.7-24-24zm48 200a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm64 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
const $d8206b3ab2e65c05$export$299c200ad3db97b4 = {
    prefix: 'fas',
    iconName: 'austral-sign',
    icon: [
        448,
        512,
        [],
        "e0a9",
        "M253.5 51.7C248.6 39.8 236.9 32 224 32s-24.6 7.8-29.5 19.7L122.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0L82.7 320 32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32l24 0L34.5 435.7c-6.8 16.3 .9 35 17.2 41.8s35-.9 41.8-17.2L125.3 384l197.3 0 31.8 76.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8L392 384l24 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-50.7 0L352 288l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-90.7 0L253.5 51.7zM256 224l-64 0 32-76.8L256 224zm-90.7 64l117.3 0L296 320l-144 0 13.3-32z"
    ]
};
const $d8206b3ab2e65c05$export$a2f384a559654618 = {
    prefix: 'fas',
    iconName: 'f',
    icon: [
        320,
        512,
        [
            102
        ],
        "46",
        "M64 32C28.7 32 0 60.7 0 96L0 256 0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160 160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L64 224 64 96l224 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L64 32z"
    ]
};
const $d8206b3ab2e65c05$export$7c497bae2754a087 = {
    prefix: 'fas',
    iconName: 'leaf',
    icon: [
        512,
        512,
        [],
        "f06c",
        "M272 96c-78.6 0-145.1 51.5-167.7 122.5c33.6-17 71.5-26.5 111.7-26.5l88 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0-72 0s0 0 0 0c-16.6 0-32.7 1.9-48.3 5.4c-25.9 5.9-49.9 16.4-71.4 30.7c0 0 0 0 0 0C38.3 298.8 0 364.9 0 440l0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16c0-48.7 20.7-92.5 53.8-123.2C121.6 392.3 190.3 448 272 448l1 0c132.1-.7 239-130.9 239-291.4c0-42.6-7.5-83.1-21.1-119.6c-2.6-6.9-12.7-6.6-16.2-.1C455.9 72.1 418.7 96 376 96L272 96z"
    ]
};
const $d8206b3ab2e65c05$export$f224567a4851a5e9 = {
    prefix: 'fas',
    iconName: 'road',
    icon: [
        576,
        512,
        [
            128739
        ],
        "f018",
        "M256 32l-74.8 0c-27.1 0-51.3 17.1-60.3 42.6L3.1 407.2C1.1 413 0 419.2 0 425.4C0 455.5 24.5 480 54.6 480L256 480l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64 201.4 0c30.2 0 54.6-24.5 54.6-54.6c0-6.2-1.1-12.4-3.1-18.2L455.1 74.6C446 49.1 421.9 32 394.8 32L320 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64zm64 192l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
const $d8206b3ab2e65c05$export$9958afcdfece1b58 = {
    prefix: 'fas',
    iconName: 'taxi',
    icon: [
        512,
        512,
        [
            128662,
            "cab"
        ],
        "f1ba",
        "M192 0c-17.7 0-32 14.3-32 32l0 32 0 .2c-38.6 2.2-72.3 27.3-85.2 64.1L39.6 228.8C16.4 238.4 0 261.3 0 288L0 432l0 48c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-48 320 0 0 48c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-48 0-144c0-26.7-16.4-49.6-39.6-59.2L437.2 128.3c-12.9-36.8-46.6-62-85.2-64.1l0-.2 0-32c0-17.7-14.3-32-32-32L192 0zM165.4 128l181.2 0c13.6 0 25.7 8.6 30.2 21.4L402.9 224l-293.8 0 26.1-74.6c4.5-12.8 16.6-21.4 30.2-21.4zM96 288a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm288 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
const $d8206b3ab2e65c05$export$7bf12d9380f0971b = $d8206b3ab2e65c05$export$9958afcdfece1b58;
const $d8206b3ab2e65c05$export$55686b1eb7d00307 = {
    prefix: 'fas',
    iconName: 'person-circle-plus',
    icon: [
        576,
        512,
        [],
        "e541",
        "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-223.1L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6l29.7 0c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9 232 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128-16 0zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48z"
    ]
};
const $d8206b3ab2e65c05$export$1de7b9cf7d1b153b = {
    prefix: 'fas',
    iconName: 'chart-pie',
    icon: [
        576,
        512,
        [
            "pie-chart"
        ],
        "f200",
        "M304 240l0-223.4c0-9 7-16.6 16-16.6C443.7 0 544 100.3 544 224c0 9-7.6 16-16.6 16L304 240zM32 272C32 150.7 122.1 50.3 239 34.3c9.2-1.3 17 6.1 17 15.4L256 288 412.5 444.5c6.7 6.7 6.2 17.7-1.5 23.1C371.8 495.6 323.8 512 272 512C139.5 512 32 404.6 32 272zm526.4 16c9.3 0 16.6 7.8 15.4 17c-7.7 55.9-34.6 105.6-73.9 142.3c-6 5.6-15.4 5.2-21.2-.7L320 288l238.4 0z"
    ]
};
const $d8206b3ab2e65c05$export$7877286cd337de81 = $d8206b3ab2e65c05$export$1de7b9cf7d1b153b;
const $d8206b3ab2e65c05$export$b16dcd08f3da1ba2 = {
    prefix: 'fas',
    iconName: 'bolt-lightning',
    icon: [
        384,
        512,
        [],
        "e0b7",
        "M0 256L28.5 28c2-16 15.6-28 31.8-28H228.9c15 0 27.1 12.1 27.1 27.1c0 3.2-.6 6.5-1.7 9.5L208 160H347.3c20.2 0 36.7 16.4 36.7 36.7c0 7.4-2.2 14.6-6.4 20.7l-192.2 281c-5.9 8.6-15.6 13.7-25.9 13.7h-2.9c-15.7 0-28.5-12.8-28.5-28.5c0-2.3 .3-4.6 .9-6.9L176 288H32c-17.7 0-32-14.3-32-32z"
    ]
};
const $d8206b3ab2e65c05$export$2bad98c38bea5994 = {
    prefix: 'fas',
    iconName: 'sack-xmark',
    icon: [
        512,
        512,
        [],
        "e56a",
        "M192 96l128 0 47.4-71.1C374.5 14.2 366.9 0 354.1 0L157.9 0c-12.8 0-20.4 14.2-13.3 24.9L192 96zm128 32l-128 0c-3.8 2.5-8.1 5.3-13 8.4c0 0 0 0 0 0s0 0 0 0C122.3 172.7 0 250.9 0 416c0 53 43 96 96 96l320 0c53 0 96-43 96-96c0-165.1-122.3-243.3-179-279.6c-4.8-3.1-9.2-5.9-13-8.4zM289.9 336l47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47z"
    ]
};
const $d8206b3ab2e65c05$export$77cb1a465c4fe84 = {
    prefix: 'fas',
    iconName: 'file-excel',
    icon: [
        384,
        512,
        [],
        "f1c3",
        "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM155.7 250.2L192 302.1l36.3-51.9c7.6-10.9 22.6-13.5 33.4-5.9s13.5 22.6 5.9 33.4L221.3 344l46.4 66.2c7.6 10.9 5 25.8-5.9 33.4s-25.8 5-33.4-5.9L192 385.8l-36.3 51.9c-7.6 10.9-22.6 13.5-33.4 5.9s-13.5-22.6-5.9-33.4L162.7 344l-46.4-66.2c-7.6-10.9-5-25.8 5.9-33.4s25.8-5 33.4 5.9z"
    ]
};
const $d8206b3ab2e65c05$export$70fde3f3fdaa6a6a = {
    prefix: 'fas',
    iconName: 'file-contract',
    icon: [
        384,
        512,
        [],
        "f56c",
        "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM80 64l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm54.2 253.8c-6.1 20.3-24.8 34.2-46 34.2L80 416c-8.8 0-16-7.2-16-16s7.2-16 16-16l8.2 0c7.1 0 13.3-4.6 15.3-11.4l14.9-49.5c3.4-11.3 13.8-19.1 25.6-19.1s22.2 7.7 25.6 19.1l11.6 38.6c7.4-6.2 16.8-9.7 26.8-9.7c15.9 0 30.4 9 37.5 23.2l4.4 8.8 54.1 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-6.1 0-11.6-3.4-14.3-8.8l-8.8-17.7c-1.7-3.4-5.1-5.5-8.8-5.5s-7.2 2.1-8.8 5.5l-8.8 17.7c-2.9 5.9-9.2 9.4-15.7 8.8s-12.1-5.1-13.9-11.3L144 349l-9.8 32.8z"
    ]
};
const $d8206b3ab2e65c05$export$e7af4f0123222b6f = {
    prefix: 'fas',
    iconName: 'fish-fins',
    icon: [
        576,
        512,
        [],
        "e4f2",
        "M275.2 38.4c-10.6-8-25-8.5-36.3-1.5S222 57.3 224.6 70.3l9.7 48.6c-19.4 9-36.9 19.9-52.4 31.5c-15.3 11.5-29 23.9-40.7 36.3L48.1 132.4c-12.5-7.3-28.4-5.3-38.6 4.9S-3 163.3 4.2 175.9L50 256 4.2 336.1c-7.2 12.6-5 28.4 5.3 38.6s26.1 12.2 38.6 4.9l93.1-54.3c11.8 12.3 25.4 24.8 40.7 36.3c15.5 11.6 33 22.5 52.4 31.5l-9.7 48.6c-2.6 13 3.1 26.3 14.3 33.3s25.6 6.5 36.3-1.5l77.6-58.2c54.9-4 101.5-27 137.2-53.8c39.2-29.4 67.2-64.7 81.6-89.5c5.8-9.9 5.8-22.2 0-32.1c-14.4-24.8-42.5-60.1-81.6-89.5c-35.8-26.8-82.3-49.8-137.2-53.8L275.2 38.4zM384 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
const $d8206b3ab2e65c05$export$592422b29ab0a914 = {
    prefix: 'fas',
    iconName: 'building-flag',
    icon: [
        640,
        512,
        [],
        "e4d5",
        "M48 0C21.5 0 0 21.5 0 48L0 464c0 26.5 21.5 48 48 48l96 0 0-80c0-26.5 21.5-48 48-48s48 21.5 48 48l0 80 96 0c26.5 0 48-21.5 48-48l0-416c0-26.5-21.5-48-48-48L48 0zM64 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm112-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM80 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM272 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM448 0c-17.7 0-32 14.3-32 32l0 480 64 0 0-320 144 0c8.8 0 16-7.2 16-16l0-128c0-8.8-7.2-16-16-16L480 32c0-17.7-14.3-32-32-32z"
    ]
};
const $d8206b3ab2e65c05$export$3de52eeb00462407 = {
    prefix: 'fas',
    iconName: 'face-grin-beam',
    icon: [
        512,
        512,
        [
            128516,
            "grin-beam"
        ],
        "f582",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zm-170.5-84s0 0 0 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0zm160 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0z"
    ]
};
const $d8206b3ab2e65c05$export$734da5249381ec7e = $d8206b3ab2e65c05$export$3de52eeb00462407;
const $d8206b3ab2e65c05$export$887f6345573abcac = {
    prefix: 'fas',
    iconName: 'object-ungroup',
    icon: [
        640,
        512,
        [],
        "f248",
        "M32 119.4C12.9 108.4 0 87.7 0 64C0 28.7 28.7 0 64 0c23.7 0 44.4 12.9 55.4 32l209.1 0C339.6 12.9 360.3 0 384 0c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4l0 113.1c19.1 11.1 32 31.7 32 55.4c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32l-209.1 0c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4l0-113.1zM119.4 96c-5.6 9.7-13.7 17.8-23.4 23.4l0 113.1c9.7 5.6 17.8 13.7 23.4 23.4l209.1 0c5.6-9.7 13.7-17.8 23.4-23.4l0-113.1c-9.7-5.6-17.8-13.7-23.4-23.4L119.4 96zm192 384c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4l0-40.6 64 0 0 40.6c9.7 5.6 17.8 13.7 23.4 23.4l209.1 0c5.6-9.7 13.7-17.8 23.4-23.4l0-113.1c-9.7-5.6-17.8-13.7-23.4-23.4l-46 0c-5.4-15.4-14.6-28.9-26.5-39.6l0-24.4 72.6 0c11.1-19.1 31.7-32 55.4-32c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4l0 113.1c19.1 11.1 32 31.7 32 55.4c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32l-209.1 0z"
    ]
};
const $d8206b3ab2e65c05$export$bb45b6b87d1adf27 = {
    prefix: 'fas',
    iconName: 'poop',
    icon: [
        512,
        512,
        [],
        "f619",
        "M254.4 6.6c3.5-4.3 9-6.5 14.5-5.7C315.8 7.2 352 47.4 352 96c0 11.2-1.9 22-5.5 32l5.5 0c35.3 0 64 28.7 64 64c0 19.1-8.4 36.3-21.7 48l13.7 0c39.8 0 72 32.2 72 72c0 23.2-11 43.8-28 57c34.1 5.7 60 35.3 60 71c0 39.8-32.2 72-72 72L72 512c-39.8 0-72-32.2-72-72c0-35.7 25.9-65.3 60-71c-17-13.2-28-33.8-28-57c0-39.8 32.2-72 72-72l13.7 0C104.4 228.3 96 211.1 96 192c0-35.3 28.7-64 64-64l16.2 0c44.1-.1 79.8-35.9 79.8-80c0-9.2-1.5-17.9-4.3-26.1c-1.8-5.2-.8-11.1 2.8-15.4z"
    ]
};
const $d8206b3ab2e65c05$export$c0b7617de95c0c05 = {
    prefix: 'fas',
    iconName: 'location-pin',
    icon: [
        384,
        512,
        [
            "map-marker"
        ],
        "f041",
        "M384 192c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192z"
    ]
};
const $d8206b3ab2e65c05$export$10d360e4f1a554dd = $d8206b3ab2e65c05$export$c0b7617de95c0c05;
const $d8206b3ab2e65c05$export$ab1408bfbe914cc9 = {
    prefix: 'fas',
    iconName: 'kaaba',
    icon: [
        576,
        512,
        [
            128331
        ],
        "f66b",
        "M60 120l228 71.2L516 120 288 48.8 60 120zM278.5 1.5c6.2-1.9 12.9-1.9 19.1 0l256 80C566.9 85.6 576 98 576 112l0 16s0 0 0 0l0 21.2L292.8 237.7c-3.1 1-6.4 1-9.5 0L0 149.2 0 128l0-16C0 98 9.1 85.6 22.5 81.5l256-80zm23.9 266.8L576 182.8l0 46.5-52.8 16.5c-8.4 2.6-13.1 11.6-10.5 20s11.6 13.1 20 10.5L576 262.8 576 400c0 14-9.1 26.4-22.5 30.5l-256 80c-6.2 1.9-12.9 1.9-19.1 0l-256-80C9.1 426.4 0 414 0 400L0 262.8l43.2 13.5c8.4 2.6 17.4-2.1 20-10.5s-2.1-17.4-10.5-20L0 229.2l0-46.5 273.7 85.5c9.3 2.9 19.3 2.9 28.6 0zm-185.5-2.6c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l64 20c8.4 2.6 17.4-2.1 20-10.5s-2.1-17.4-10.5-20l-64-20zm352 30.5c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-64 20c-8.4 2.6-13.1 11.6-10.5 20s11.6 13.1 20 10.5l64-20zm-224 9.5c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l38.5 12c9.3 2.9 19.3 2.9 28.6 0l38.5-12c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-38.5 12c-3.1 1-6.4 1-9.5 0l-38.5-12z"
    ]
};
const $d8206b3ab2e65c05$export$c8cc083ccc72b17 = {
    prefix: 'fas',
    iconName: 'toilet-paper',
    icon: [
        640,
        512,
        [
            129531
        ],
        "f71e",
        "M444.2 0C397.2 49.6 384 126.5 384 192c0 158.8-27.3 247-42.7 283.9c-10 24-33.2 36.1-55.4 36.1L48 512c-11.5 0-22.2-6.2-27.8-16.2s-5.6-22.3 .4-32.2c9.8-17.7 15.4-38.2 20.5-57.7C52.3 362.8 64 293.5 64 192C64 86 107 0 160 0L444.2 0zM512 384c-53 0-96-86-96-192S459 0 512 0s96 86 96 192s-43 192-96 192zm0-128c17.7 0 32-28.7 32-64s-14.3-64-32-64s-32 28.7-32 64s14.3 64 32 64zM144 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm64 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
    ]
};
const $d8206b3ab2e65c05$export$aacaf42fba617981 = {
    prefix: 'fas',
    iconName: 'helmet-safety',
    icon: [
        576,
        512,
        [
            "hard-hat",
            "hat-hard"
        ],
        "f807",
        "M256 32c-17.7 0-32 14.3-32 32l0 2.3 0 99.6c0 5.6-4.5 10.1-10.1 10.1c-3.6 0-7-1.9-8.8-5.1L157.1 87C83 123.5 32 199.8 32 288l0 64 512 0 0-66.4c-.9-87.2-51.7-162.4-125.1-198.6l-48 83.9c-1.8 3.2-5.2 5.1-8.8 5.1c-5.6 0-10.1-4.5-10.1-10.1l0-99.6 0-2.3c0-17.7-14.3-32-32-32l-64 0zM16.6 384C7.4 384 0 391.4 0 400.6c0 4.7 2 9.2 5.8 11.9C27.5 428.4 111.8 480 288 480s260.5-51.6 282.2-67.5c3.8-2.8 5.8-7.2 5.8-11.9c0-9.2-7.4-16.6-16.6-16.6L16.6 384z"
    ]
};
const $d8206b3ab2e65c05$export$7b72177558a98b6f = $d8206b3ab2e65c05$export$aacaf42fba617981;
const $d8206b3ab2e65c05$export$c0e235dbf1644a2f = $d8206b3ab2e65c05$export$aacaf42fba617981;
const $d8206b3ab2e65c05$export$8484041d5b209494 = {
    prefix: 'fas',
    iconName: 'eject',
    icon: [
        448,
        512,
        [
            9167
        ],
        "f052",
        "M224 32c13.5 0 26.3 5.6 35.4 15.6l176 192c12.9 14 16.2 34.3 8.6 51.8S419 320 400 320L48 320c-19 0-36.3-11.2-43.9-28.7s-4.3-37.7 8.6-51.8l176-192C197.7 37.6 210.5 32 224 32zM0 432c0-26.5 21.5-48 48-48l352 0c26.5 0 48 21.5 48 48s-21.5 48-48 48L48 480c-26.5 0-48-21.5-48-48z"
    ]
};
const $d8206b3ab2e65c05$export$1fec48c8bdd69c1d = {
    prefix: 'fas',
    iconName: 'circle-right',
    icon: [
        512,
        512,
        [
            61838,
            "arrow-alt-circle-right"
        ],
        "f35a",
        "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm395.3 11.3l-112 112c-4.6 4.6-11.5 5.9-17.4 3.5s-9.9-8.3-9.9-14.8l0-64-96 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32l96 0 0-64c0-6.5 3.9-12.3 9.9-14.8s12.9-1.1 17.4 3.5l112 112c6.2 6.2 6.2 16.4 0 22.6z"
    ]
};
const $d8206b3ab2e65c05$export$88962ffdad8b856d = $d8206b3ab2e65c05$export$1fec48c8bdd69c1d;
const $d8206b3ab2e65c05$export$9cbf8612c6cadc74 = {
    prefix: 'fas',
    iconName: 'plane-circle-check',
    icon: [
        640,
        512,
        [],
        "e555",
        "M256 0c-35 0-64 59.5-64 93.7l0 84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9l0 65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49 0 70.9-57.6 43.2c-4 3-6.4 7.8-6.4 12.8l0 42c0 7.8 6.3 14 14 14c1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3 .4 2.6 .5 3.9 .5c6 0 11.1-3.7 13.1-9C344.5 470.7 320 422.2 320 368c0-60.6 30.6-114 77.1-145.6L320 178.3l0-84.6C320 59.5 292 0 256 0zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
const $d8206b3ab2e65c05$export$a6d72a9a068392b5 = {
    prefix: 'fas',
    iconName: 'face-rolling-eyes',
    icon: [
        512,
        512,
        [
            128580,
            "meh-rolling-eyes"
        ],
        "f5a5",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 368l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm32-144c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26 15.5-48.4 37.8-58.4c-3.7 5.2-5.8 11.6-5.8 18.4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.9-2.2-13.2-5.8-18.4C208.5 175.6 224 198 224 224zm128 64c-35.3 0-64-28.7-64-64c0-26 15.5-48.4 37.8-58.4c-3.7 5.2-5.8 11.6-5.8 18.4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.9-2.2-13.2-5.8-18.4C400.5 175.6 416 198 416 224c0 35.3-28.7 64-64 64z"
    ]
};
const $d8206b3ab2e65c05$export$fdc62a1bea767cc2 = $d8206b3ab2e65c05$export$a6d72a9a068392b5;
const $d8206b3ab2e65c05$export$40cdac24aa94a57a = {
    prefix: 'fas',
    iconName: 'object-group',
    icon: [
        576,
        512,
        [],
        "f247",
        "M32 119.4C12.9 108.4 0 87.7 0 64C0 28.7 28.7 0 64 0c23.7 0 44.4 12.9 55.4 32l337.1 0C467.6 12.9 488.3 0 512 0c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4l0 273.1c19.1 11.1 32 31.7 32 55.4c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32l-337.1 0c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4l0-273.1zM456.6 96L119.4 96c-5.6 9.7-13.7 17.8-23.4 23.4l0 273.1c9.7 5.6 17.8 13.7 23.4 23.4l337.1 0c5.6-9.7 13.7-17.8 23.4-23.4l0-273.1c-9.7-5.6-17.8-13.7-23.4-23.4zM128 160c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-96zM256 320l32 0c35.3 0 64-28.7 64-64l0-32 64 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-32z"
    ]
};
const $d8206b3ab2e65c05$export$e022f62a119e1d93 = {
    prefix: 'fas',
    iconName: 'chart-line',
    icon: [
        512,
        512,
        [
            "line-chart"
        ],
        "f201",
        "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64L0 400c0 44.2 35.8 80 80 80l400 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 416c-8.8 0-16-7.2-16-16L64 64zm406.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L320 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L240 221.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l128-128z"
    ]
};
const $d8206b3ab2e65c05$export$f729617a20de475b = $d8206b3ab2e65c05$export$e022f62a119e1d93;
const $d8206b3ab2e65c05$export$122c8413a0dc5ff6 = {
    prefix: 'fas',
    iconName: 'mask-ventilator',
    icon: [
        640,
        512,
        [],
        "e524",
        "M159.1 176C139.4 219.2 128 264.7 128 300.8c0 15.9 2.2 31.4 6.3 46l-31.8-7.9C70.5 330.9 48 302.1 48 269l0-85c0-4.4 3.6-8 8-8l103.1 0zm26-48L56 128c-30.9 0-56 25.1-56 56l0 85c0 55.1 37.5 103.1 90.9 116.4l71.3 17.8c22.7 30.5 55.4 54.1 93.8 66.6l0-76.6c-19.7-16.4-32-40.3-32-66.9c0-49.5 43-134.4 96-134.4c52.5 0 96 84.9 96 134.4c0 26.7-12.4 50.4-32 66.8l0 76.6c38-12.6 70.6-36 93.5-66.4l71.6-17.9C602.5 372.1 640 324.1 640 269l0-85c0-30.9-25.1-56-56-56l-129.5 0C419.7 73.8 372.1 32 320 32c-52.6 0-100.2 41.8-134.9 96zm295.6 48L584 176c4.4 0 8 3.6 8 8l0 85c0 33-22.5 61.8-54.5 69.9l-31.8 8c4.2-14.7 6.4-30.1 6.4-46.1c0-36.1-11.6-81.6-31.3-124.8zM288 320l0 192 64 0 0-192c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
    ]
};
const $d8206b3ab2e65c05$export$b4da69a0247f3620 = {
    prefix: 'fas',
    iconName: 'arrow-right',
    icon: [
        448,
        512,
        [
            8594
        ],
        "f061",
        "M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"
    ]
};
const $d8206b3ab2e65c05$export$905f45f8ffd6b8e5 = {
    prefix: 'fas',
    iconName: 'signs-post',
    icon: [
        512,
        512,
        [
            "map-signs"
        ],
        "f277",
        "M224 32L64 32C46.3 32 32 46.3 32 64l0 64c0 17.7 14.3 32 32 32l377.4 0c4.2 0 8.3-1.7 11.3-4.7l48-48c6.2-6.2 6.2-16.4 0-22.6l-48-48c-3-3-7.1-4.7-11.3-4.7L288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32zM480 256c0-17.7-14.3-32-32-32l-160 0 0-32-64 0 0 32L70.6 224c-4.2 0-8.3 1.7-11.3 4.7l-48 48c-6.2 6.2-6.2 16.4 0 22.6l48 48c3 3 7.1 4.7 11.3 4.7L448 352c17.7 0 32-14.3 32-32l0-64zM288 480l0-96-64 0 0 96c0 17.7 14.3 32 32 32s32-14.3 32-32z"
    ]
};
const $d8206b3ab2e65c05$export$743f4b1071b3333a = $d8206b3ab2e65c05$export$905f45f8ffd6b8e5;
const $d8206b3ab2e65c05$export$6357093f67788b33 = {
    prefix: 'fas',
    iconName: 'cash-register',
    icon: [
        512,
        512,
        [],
        "f788",
        "M64 0C46.3 0 32 14.3 32 32l0 64c0 17.7 14.3 32 32 32l80 0 0 32-57 0c-31.6 0-58.5 23.1-63.3 54.4L1.1 364.1C.4 368.8 0 373.6 0 378.4L0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-69.6c0-4.8-.4-9.6-1.1-14.4L488.2 214.4C483.5 183.1 456.6 160 425 160l-217 0 0-32 80 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L64 0zM96 48l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L96 80c-8.8 0-16-7.2-16-16s7.2-16 16-16zM64 432c0-8.8 7.2-16 16-16l352 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 448c-8.8 0-16-7.2-16-16zm48-168a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm120-24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM160 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM328 240a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM256 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM424 240a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM352 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48z"
    ]
};
const $d8206b3ab2e65c05$export$c8f8a597ffd676c0 = {
    prefix: 'fas',
    iconName: 'person-circle-question',
    icon: [
        576,
        512,
        [],
        "e542",
        "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-223.1L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6l29.7 0c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9 232 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128-16 0zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM368 321.6l0 6.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-6.4c0-5.3 4.3-9.6 9.6-9.6l40.5 0c7.7 0 13.9 6.2 13.9 13.9c0 5.2-2.9 9.9-7.4 12.3l-32 16.8c-5.3 2.8-8.6 8.2-8.6 14.2l0 14.8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-5.1 23.5-12.3c15.1-7.9 24.5-23.6 24.5-40.6c0-25.4-20.6-45.9-45.9-45.9l-40.5 0c-23 0-41.6 18.6-41.6 41.6z"
    ]
};
const $d8206b3ab2e65c05$export$d762b7b66d5875e1 = {
    prefix: 'fas',
    iconName: 'h',
    icon: [
        384,
        512,
        [
            104
        ],
        "48",
        "M320 256l0 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-224 0-160c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 128L64 192 64 64c0-17.7-14.3-32-32-32S0 46.3 0 64L0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-192 256 0z"
    ]
};
const $d8206b3ab2e65c05$export$2305b1a41b3f914 = {
    prefix: 'fas',
    iconName: 'tarp',
    icon: [
        576,
        512,
        [],
        "e57b",
        "M576 128c0-35.3-28.7-64-64-64L64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l352 0 0-128c0-17.7 14.3-32 32-32l128 0 0-160zM448 448L576 320l-128 0 0 128zM96 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $d8206b3ab2e65c05$export$158a12f36bbecf9 = {
    prefix: 'fas',
    iconName: 'screwdriver-wrench',
    icon: [
        512,
        512,
        [
            "tools"
        ],
        "f7d9",
        "M78.6 5C69.1-2.4 55.6-1.5 47 7L7 47c-8.5 8.5-9.4 22-2.1 31.6l80 104c4.5 5.9 11.6 9.4 19 9.4l54.1 0 109 109c-14.7 29-10 65.4 14.3 89.6l112 112c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-112-112c-24.2-24.2-60.6-29-89.6-14.3l-109-109 0-54.1c0-7.5-3.5-14.5-9.4-19L78.6 5zM19.9 396.1C7.2 408.8 0 426.1 0 444.1C0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9L233.7 374.3c-7.8-20.9-9-43.6-3.6-65.1l-61.7-61.7L19.9 396.1zM512 144c0-10.5-1.1-20.7-3.2-30.5c-2.4-11.2-16.1-14.1-24.2-6l-63.9 63.9c-3 3-7.1 4.7-11.3 4.7L352 176c-8.8 0-16-7.2-16-16l0-57.4c0-4.2 1.7-8.3 4.7-11.3l63.9-63.9c8.1-8.1 5.2-21.8-6-24.2C388.7 1.1 378.5 0 368 0C288.5 0 224 64.5 224 144l0 .8 85.3 85.3c36-9.1 75.8 .5 104 28.7L429 274.5c49-23 83-72.8 83-130.5zM56 432a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
const $d8206b3ab2e65c05$export$646e4e7a8c6172aa = $d8206b3ab2e65c05$export$158a12f36bbecf9;
const $d8206b3ab2e65c05$export$9adae865350879af = {
    prefix: 'fas',
    iconName: 'arrows-to-eye',
    icon: [
        640,
        512,
        [],
        "e4bf",
        "M15 15C24.4 5.7 39.6 5.7 49 15l63 63L112 40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 96c0 13.3-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l38.1 0L15 49C5.7 39.6 5.7 24.4 15 15zM133.5 243.9C158.6 193.6 222.7 112 320 112s161.4 81.6 186.5 131.9c3.8 7.6 3.8 16.5 0 24.2C481.4 318.4 417.3 400 320 400s-161.4-81.6-186.5-131.9c-3.8-7.6-3.8-16.5 0-24.2zM320 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM591 15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-63 63 38.1 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24l0-96c0-13.3 10.7-24 24-24s24 10.7 24 24l0 38.1 63-63zM15 497c-9.4-9.4-9.4-24.6 0-33.9l63-63L40 400c-13.3 0-24-10.7-24-24s10.7-24 24-24l96 0c13.3 0 24 10.7 24 24l0 96c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-38.1L49 497c-9.4 9.4-24.6 9.4-33.9 0zm576 0l-63-63 0 38.1c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96c0-13.3 10.7-24 24-24l96 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-38.1 0 63 63c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0z"
    ]
};
const $d8206b3ab2e65c05$export$4f3b3144ce966486 = {
    prefix: 'fas',
    iconName: 'plug-circle-bolt',
    icon: [
        576,
        512,
        [],
        "e55b",
        "M96 0C78.3 0 64 14.3 64 32l0 96 64 0 0-96c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32l0 96 64 0 0-96c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 32c0 77.4 55 142 128 156.8l0 67.2c0 17.7 14.3 32 32 32s32-14.3 32-32l0-67.2c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32L32 160zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm47.9-225c4.3 3.7 5.4 9.9 2.6 14.9L452.4 356l35.6 0c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9L411.6 380 376 380c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1 .6z"
    ]
};
const $d8206b3ab2e65c05$export$e4b51a47a2f8b9db = {
    prefix: 'fas',
    iconName: 'heart',
    icon: [
        512,
        512,
        [
            128153,
            128154,
            128155,
            128156,
            128420,
            129293,
            129294,
            129505,
            9829,
            10084,
            61578
        ],
        "f004",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z"
    ]
};
const $d8206b3ab2e65c05$export$808b88e8735e31e8 = {
    prefix: 'fas',
    iconName: 'mars-and-venus',
    icon: [
        512,
        512,
        [
            9893
        ],
        "f224",
        "M337.8 14.8C341.5 5.8 350.3 0 360 0L472 0c13.3 0 24 10.7 24 24l0 112c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-24.7 24.7C407 163.3 416 192.6 416 224c0 80.2-59 146.6-136 158.2l0 25.8 24 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-24 0 0 32c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-32-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l24 0 0-25.8C155 370.6 96 304.2 96 224c0-88.4 71.6-160 160-160c39.6 0 75.9 14.4 103.8 38.2L382.1 80 343 41c-6.9-6.9-8.9-17.2-5.2-26.2zM448 48s0 0 0 0s0 0 0 0s0 0 0 0zM352 224a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z"
    ]
};
const $d8206b3ab2e65c05$export$9a513ee921e8e885 = {
    prefix: 'fas',
    iconName: 'house-user',
    icon: [
        576,
        512,
        [
            "home-user"
        ],
        "e1b0",
        "M575.8 255.5c0 18-15 32.1-32 32.1l-32 0 .7 160.2c.2 35.5-28.5 64.3-64 64.3l-320.4 0c-35.3 0-64-28.7-64-64l0-160.4-32 0c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24zM352 224a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-96 96c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80l-64 0z"
    ]
};
const $d8206b3ab2e65c05$export$e732fa55ae5bbdf0 = $d8206b3ab2e65c05$export$9a513ee921e8e885;
const $d8206b3ab2e65c05$export$25e9b29b3f2230b5 = {
    prefix: 'fas',
    iconName: 'dumpster-fire',
    icon: [
        640,
        512,
        [],
        "f794",
        "M49.7 32l90.8 0L114.9 160l-94 0C9.3 160 0 150.7 0 139.1c0-2.1 .3-4.1 .9-6.1L26.8 48.9C29.9 38.9 39.2 32 49.7 32zM272 160l-124.5 0L173.1 32 272 32l0 128zm32 0l0-128 98.9 0 14.4 72.1c-1.7 1.1-3.3 2.4-4.8 3.8c-18.4 16.4-35.4 34-50.5 52.1l-58 0zm209.9-23.7c-1.7 1.6-3.4 3.2-5 4.8C498 129.6 486.7 118.6 475 108c-7.6-6.9-17-10.8-26.6-11.8L435.5 32l90.8 0c10.5 0 19.8 6.9 22.9 16.9L575.1 133c.2 .7 .4 1.4 .5 2.1c-17.8-15-44.3-14.6-61.7 1.2zM325.2 210.7C304.3 244.5 288 282.9 288 318.1c0 49.3 18.6 95.2 49.6 129.9L128 448c0 17.7-14.3 32-32 32s-32-14.3-32-32L44 288l-12 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l4 0-4-32 305.5 0c-4.4 6.2-8.5 12.5-12.3 18.7zm180.6-34.5L518 162.5c5.4-6.1 13.3-8.8 20.9-8.9c7.2 0 14.3 2.6 19.9 7.8c19.7 18.3 39.8 43.2 55 70.6C629 259.2 640 290.2 640 320.2C640 408.8 568.7 480 480 480c-89.6 0-160-71.3-160-159.8c0-37.3 16-73.4 36.8-104.5c20.9-31.3 47.5-59 70.9-80.2c5.7-5.2 13.1-7.7 20.3-7.5c14.1 .3 23.8 11.4 32.7 21.6c0 0 0 0 0 0c2 2.3 4 4.6 6 6.7l19 19.9zM544 368.2c0-36.5-37-73-54.8-88.4c-5.4-4.7-13.1-4.7-18.5 0C453 295.1 416 331.6 416 368.2c0 35.3 28.7 64 64 64s64-28.7 64-64z"
    ]
};
const $d8206b3ab2e65c05$export$baa3c215534dbf2a = {
    prefix: 'fas',
    iconName: 'house-crack',
    icon: [
        576,
        512,
        [],
        "e3b1",
        "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1l32 0 0 160.4c0 35.3 28.7 64 64 64l102.3 0-31.3-52.2c-4.1-6.8-2.6-15.5 3.5-20.5L288 368l-60.2-82.8c-10.9-15 8.2-33.5 22.8-22l117.9 92.6c8 6.3 8.2 18.4 .4 24.9L288 448l38.4 64 122.1 0c35.5 0 64.2-28.8 64-64.3l-.7-160.2 32 0z"
    ]
};
const $d8206b3ab2e65c05$export$c6e76550bdc0255d = {
    prefix: 'fas',
    iconName: 'martini-glass-citrus',
    icon: [
        576,
        512,
        [
            "cocktail"
        ],
        "f561",
        "M432 240c53 0 96-43 96-96s-43-96-96-96c-35.5 0-66.6 19.3-83.2 48l-52.6 0C316 40.1 369.3 0 432 0c79.5 0 144 64.5 144 144s-64.5 144-144 144c-27.7 0-53.5-7.8-75.5-21.3l35.4-35.4c12.2 5.6 25.8 8.7 40.1 8.7zM1.8 142.8C5.5 133.8 14.3 128 24 128l368 0c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-177 177L232 464l64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-88 0-88 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-118.1L7 169c-6.9-6.9-8.9-17.2-5.2-26.2z"
    ]
};
const $d8206b3ab2e65c05$export$4be708f1e41d387b = $d8206b3ab2e65c05$export$c6e76550bdc0255d;
const $d8206b3ab2e65c05$export$c938968e28178994 = {
    prefix: 'fas',
    iconName: 'face-surprise',
    icon: [
        512,
        512,
        [
            128558,
            "surprise"
        ],
        "f5c2",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM256 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
    ]
};
const $d8206b3ab2e65c05$export$46647c72213f53ba = $d8206b3ab2e65c05$export$c938968e28178994;
const $d8206b3ab2e65c05$export$3ee278c67519eeeb = {
    prefix: 'fas',
    iconName: 'bottle-water',
    icon: [
        320,
        512,
        [],
        "e4c5",
        "M120 0l80 0c13.3 0 24 10.7 24 24l0 40L96 64l0-40c0-13.3 10.7-24 24-24zM32 167.5c0-19.5 10-37.6 26.6-47.9l15.8-9.9C88.7 100.7 105.2 96 122.1 96l75.8 0c16.9 0 33.4 4.7 47.7 13.7l15.8 9.9C278 129.9 288 148 288 167.5c0 17-7.5 32.3-19.4 42.6C280.6 221.7 288 238 288 256c0 19.1-8.4 36.3-21.7 48c13.3 11.7 21.7 28.9 21.7 48s-8.4 36.3-21.7 48c13.3 11.7 21.7 28.9 21.7 48c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64c0-19.1 8.4-36.3 21.7-48C40.4 388.3 32 371.1 32 352s8.4-36.3 21.7-48C40.4 292.3 32 275.1 32 256c0-18 7.4-34.3 19.4-45.9C39.5 199.7 32 184.5 32 167.5zM96 240c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16zm16 112c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0z"
    ]
};
const $d8206b3ab2e65c05$export$fbeef2513e05ad08 = {
    prefix: 'fas',
    iconName: 'circle-pause',
    icon: [
        512,
        512,
        [
            62092,
            "pause-circle"
        ],
        "f28b",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM224 192l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
const $d8206b3ab2e65c05$export$d8cf08a0362da8db = $d8206b3ab2e65c05$export$fbeef2513e05ad08;
const $d8206b3ab2e65c05$export$7a494edbf9b65575 = {
    prefix: 'fas',
    iconName: 'toilet-paper-slash',
    icon: [
        640,
        512,
        [],
        "e072",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-109.7-86C569.9 374 608 291.9 608 192C608 86 565 0 512 0s-96 86-96 192c0 49.1 9.2 93.9 24.4 127.9l-59-46.2c1.6-24.8 2.6-52 2.6-81.6c0-65.5 13.2-142.4 60.2-192L160 0c-24.8 0-47.4 18.8-64.4 49.6L38.8 5.1zM367.3 385.4L66.5 148.4C64.9 162.4 64 177 64 192c0 101.5-11.7 170.8-23 213.9c-5.1 19.4-10.7 39.9-20.5 57.7c-5.9 9.9-6.1 22.1-.4 32.2S36.5 512 48 512l237.9 0c22.3 0 45.4-12.1 55.4-36.1c7.4-17.7 17.5-47.2 26-90.6zM544 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64z"
    ]
};
const $d8206b3ab2e65c05$export$12de8220d30453a3 = {
    prefix: 'fas',
    iconName: 'apple-whole',
    icon: [
        448,
        512,
        [
            127822,
            127823,
            "apple-alt"
        ],
        "f5d1",
        "M224 112c-8.8 0-16-7.2-16-16l0-16c0-44.2 35.8-80 80-80l16 0c8.8 0 16 7.2 16 16l0 16c0 44.2-35.8 80-80 80l-16 0zM0 288c0-76.3 35.7-160 112-160c27.3 0 59.7 10.3 82.7 19.3c18.8 7.3 39.9 7.3 58.7 0c22.9-8.9 55.4-19.3 82.7-19.3c76.3 0 112 83.7 112 160c0 128-80 224-160 224c-16.5 0-38.1-6.6-51.5-11.3c-8.1-2.8-16.9-2.8-25 0c-13.4 4.7-35 11.3-51.5 11.3C80 512 0 416 0 288z"
    ]
};
const $d8206b3ab2e65c05$export$bcdd94f3977a0884 = $d8206b3ab2e65c05$export$12de8220d30453a3;
const $d8206b3ab2e65c05$export$64c1570509eaf40d = {
    prefix: 'fas',
    iconName: 'kitchen-set',
    icon: [
        576,
        512,
        [],
        "e51a",
        "M240 144A96 96 0 1 0 48 144a96 96 0 1 0 192 0zm44.4 32C269.9 240.1 212.5 288 144 288C64.5 288 0 223.5 0 144S64.5 0 144 0c68.5 0 125.9 47.9 140.4 112l71.8 0c8.8-9.8 21.6-16 35.8-16l104 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-104 0c-14.2 0-27-6.2-35.8-16l-71.8 0zM144 80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM400 240c13.3 0 24 10.7 24 24l0 8 96 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-240 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l96 0 0-8c0-13.3 10.7-24 24-24zM288 464l0-112 224 0 0 112c0 26.5-21.5 48-48 48l-128 0c-26.5 0-48-21.5-48-48zM48 320l80 0 16 0 32 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-16 0c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-80c0-8.8 7.2-16 16-16zm128 64c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0 32 16 0zM24 464l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
const $d8206b3ab2e65c05$export$eb4c616de6eef46f = {
    prefix: 'fas',
    iconName: 'r',
    icon: [
        320,
        512,
        [
            114
        ],
        "52",
        "M64 32C28.7 32 0 60.7 0 96L0 288 0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 95.3 0L261.8 466.4c10.1 14.5 30.1 18 44.6 7.9s18-30.1 7.9-44.6L230.1 309.5C282.8 288.1 320 236.4 320 176c0-79.5-64.5-144-144-144L64 32zM176 256L64 256 64 96l112 0c44.2 0 80 35.8 80 80s-35.8 80-80 80z"
    ]
};
const $d8206b3ab2e65c05$export$f9d1c19925fd7fa8 = {
    prefix: 'fas',
    iconName: 'temperature-quarter',
    icon: [
        320,
        512,
        [
            "temperature-1",
            "thermometer-1",
            "thermometer-quarter"
        ],
        "f2ca",
        "M160 64c-26.5 0-48 21.5-48 48l0 164.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5L208 112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112l0 164.4c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6L48 112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3l0-50.7c0-8.8 7.2-16 16-16s16 7.2 16 16l0 50.7c18.6 6.6 32 24.4 32 45.3z"
    ]
};
const $d8206b3ab2e65c05$export$d4f1cd380bde2129 = $d8206b3ab2e65c05$export$f9d1c19925fd7fa8;
const $d8206b3ab2e65c05$export$3f77fbe2dabe285b = $d8206b3ab2e65c05$export$f9d1c19925fd7fa8;
const $d8206b3ab2e65c05$export$ed05754fcbec6e46 = $d8206b3ab2e65c05$export$f9d1c19925fd7fa8;
const $d8206b3ab2e65c05$export$973ae4f1e4d2ce78 = {
    prefix: 'fas',
    iconName: 'cube',
    icon: [
        512,
        512,
        [],
        "f1b2",
        "M234.5 5.7c13.9-5 29.1-5 43.1 0l192 68.6C495 83.4 512 107.5 512 134.6l0 242.9c0 27-17 51.2-42.5 60.3l-192 68.6c-13.9 5-29.1 5-43.1 0l-192-68.6C17 428.6 0 404.5 0 377.4L0 134.6c0-27 17-51.2 42.5-60.3l192-68.6zM256 66L82.3 128 256 190l173.7-62L256 66zm32 368.6l160-57.1 0-188L288 246.6l0 188z"
    ]
};
const $d8206b3ab2e65c05$export$441bfc8058328ce8 = {
    prefix: 'fas',
    iconName: 'bitcoin-sign',
    icon: [
        320,
        512,
        [],
        "e0b4",
        "M48 32C48 14.3 62.3 0 80 0s32 14.3 32 32l0 32 32 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32c0 1.5-.1 3.1-.3 4.5C254.1 82.2 288 125.1 288 176c0 24.2-7.7 46.6-20.7 64.9c31.7 19.8 52.7 55 52.7 95.1c0 61.9-50.1 112-112 112l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-32 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-6.3 0C18.7 448 0 429.3 0 406.3L0 288l0-22.3L0 224 0 101.6C0 80.8 16.8 64 37.6 64L48 64l0-32zM64 224l112 0c26.5 0 48-21.5 48-48s-21.5-48-48-48L64 128l0 96zm112 64L64 288l0 96 144 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-32 0z"
    ]
};
const $d8206b3ab2e65c05$export$2a5c6f182c0cbcb = {
    prefix: 'fas',
    iconName: 'shield-dog',
    icon: [
        512,
        512,
        [],
        "e573",
        "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM160.9 286.2c4.8 1.2 9.9 1.8 15.1 1.8c35.3 0 64-28.7 64-64l0-64 44.2 0c12.1 0 23.2 6.8 28.6 17.7L320 192l64 0c8.8 0 16 7.2 16 16l0 32c0 44.2-35.8 80-80 80l-48 0 0 50.7c0 7.3-5.9 13.3-13.3 13.3c-1.8 0-3.6-.4-5.2-1.1l-98.7-42.3c-6.6-2.8-10.8-9.3-10.8-16.4c0-2.8 .6-5.5 1.9-8l15-30zM160 160l40 0 8 0 0 32 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-48c0-8.8 7.2-16 16-16zm128 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
    ]
};
const $d8206b3ab2e65c05$export$b9c649c5e37017f3 = {
    prefix: 'fas',
    iconName: 'solar-panel',
    icon: [
        640,
        512,
        [],
        "f5ba",
        "M122.2 0C91.7 0 65.5 21.5 59.5 51.4L8.3 307.4C.4 347 30.6 384 71 384l217 0 0 64-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-64 217 0c40.4 0 70.7-36.9 62.8-76.6l-51.2-256C574.5 21.5 548.3 0 517.8 0L122.2 0zM260.9 64l118.2 0 10.4 104-139 0L260.9 64zM202.3 168l-100.8 0L122.2 64l90.4 0L202.3 168zM91.8 216l105.6 0L187.1 320 71 320 91.8 216zm153.9 0l148.6 0 10.4 104-169.4 0 10.4-104zm196.8 0l105.6 0L569 320l-116 0L442.5 216zm96-48l-100.8 0L427.3 64l90.4 0 31.4-6.3L517.8 64l20.8 104z"
    ]
};
const $d8206b3ab2e65c05$export$84b5acad4436d02a = {
    prefix: 'fas',
    iconName: 'lock-open',
    icon: [
        576,
        512,
        [],
        "f3c1",
        "M352 144c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c0 17.7 14.3 32 32 32s32-14.3 32-32l0-48C576 64.5 511.5 0 432 0S288 64.5 288 144l0 48L64 192c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64l-32 0 0-48z"
    ]
};
const $d8206b3ab2e65c05$export$c7a833ce065e0ea4 = {
    prefix: 'fas',
    iconName: 'elevator',
    icon: [
        512,
        512,
        [],
        "e16d",
        "M132.7 4.7l-64 64c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9l128 0c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-64-64c-6.2-6.2-16.4-6.2-22.6 0zM64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 128zm96 96a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM80 400c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 16c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32l0-16zm192 0c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 16c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32l0-16zm32-128a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM356.7 91.3c6.2 6.2 16.4 6.2 22.6 0l64-64c4.6-4.6 5.9-11.5 3.5-17.4S438.5 0 432 0L304 0c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l64 64z"
    ]
};
const $d8206b3ab2e65c05$export$1b71392d9effbe = {
    prefix: 'fas',
    iconName: 'money-bill-transfer',
    icon: [
        640,
        512,
        [],
        "e528",
        "M535 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l64 64c4.5 4.5 7 10.6 7 17s-2.5 12.5-7 17l-64 64c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23L384 112c-13.3 0-24-10.7-24-24s10.7-24 24-24l174.1 0L535 41zM105 377l-23 23L256 400c13.3 0 24 10.7 24 24s-10.7 24-24 24L81.9 448l23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 441c-4.5-4.5-7-10.6-7-17s2.5-12.5 7-17l64-64c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM96 64l241.9 0c-3.7 7.2-5.9 15.3-5.9 24c0 28.7 23.3 52 52 52l117.4 0c-4 17 .6 35.5 13.8 48.8c20.3 20.3 53.2 20.3 73.5 0L608 169.5 608 384c0 35.3-28.7 64-64 64l-241.9 0c3.7-7.2 5.9-15.3 5.9-24c0-28.7-23.3-52-52-52l-117.4 0c4-17-.6-35.5-13.8-48.8c-20.3-20.3-53.2-20.3-73.5 0L32 342.5 32 128c0-35.3 28.7-64 64-64zm64 64l-64 0 0 64c35.3 0 64-28.7 64-64zM544 320c-35.3 0-64 28.7-64 64l64 0 0-64zM320 352a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"
    ]
};
const $d8206b3ab2e65c05$export$18ab80cba7d5044f = {
    prefix: 'fas',
    iconName: 'money-bill-trend-up',
    icon: [
        512,
        512,
        [],
        "e529",
        "M470.7 9.4c3 3.1 5.3 6.6 6.9 10.3s2.4 7.8 2.4 12.2c0 0 0 .1 0 .1c0 0 0 0 0 0l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-18.7L310.6 214.6c-11.8 11.8-30.8 12.6-43.5 1.7L176 138.1 84.8 216.3c-13.4 11.5-33.6 9.9-45.1-3.5s-9.9-33.6 3.5-45.1l112-96c12-10.3 29.7-10.3 41.7 0l89.5 76.7L370.7 64 352 64c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0s0 0 0 0c8.8 0 16.8 3.6 22.6 9.3l.1 .1zM0 304c0-26.5 21.5-48 48-48l416 0c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 304zM48 416l0 48 48 0c0-26.5-21.5-48-48-48zM96 304l-48 0 0 48c26.5 0 48-21.5 48-48zM464 416c-26.5 0-48 21.5-48 48l48 0 0-48zM416 304c0 26.5 21.5 48 48 48l0-48-48 0zm-96 80a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
    ]
};
const $d8206b3ab2e65c05$export$30d3e64480aa266b = {
    prefix: 'fas',
    iconName: 'house-flood-water-circle-arrow-right',
    icon: [
        640,
        512,
        [],
        "e50f",
        "M288 144A144 144 0 1 0 0 144a144 144 0 1 0 288 0zM140.7 76.7c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L169.4 160 80 160c-8.8 0-16-7.2-16-16s7.2-16 16-16l89.4 0L140.7 99.3c-6.2-6.2-6.2-16.4 0-22.6zM320 144c0 57.3-27.4 108.2-69.8 140.3c11.8-3.6 23-9.4 33-16.2c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.4 78.1 3.4c2.1 1.7 4.2 3.3 6.5 4.9l-.3-84.4 16.6 0c13.9 0 26.1-8.9 30.4-22.1s-.4-27.6-11.6-35.8l-176-128C407.6-2 392.4-2 381.2 6.1L301 64.4c12.1 23.9 19 50.9 19 79.6zm18.5 165.9c-11.1-7.9-25.9-7.9-37 0C279 325.4 251.5 336 224 336c-26.9 0-55.3-10.8-77.4-26.1c0 0 0 0 0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C158.5 389.7 191 400 224 400c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.6 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7c0 0 0 0 0 0C471.4 325.2 442.9 336 416 336c-27.5 0-55-10.6-77.5-26.1zm0 112c-11.1-7.9-25.9-7.9-37 0C279 437.4 251.5 448 224 448c-26.9 0-55.3-10.8-77.4-26.1c0 0 0 0 0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C158.5 501.7 191 512 224 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.6 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7c0 0 0 0 0 0C471.4 437.2 442.9 448 416 448c-27.5 0-55-10.6-77.5-26.1z"
    ]
};
const $d8206b3ab2e65c05$export$287bdd70ab874659 = {
    prefix: 'fas',
    iconName: 'square-poll-horizontal',
    icon: [
        448,
        512,
        [
            "poll-h"
        ],
        "f682",
        "M448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM256 160c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0c17.7 0 32 14.3 32 32zm64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l192 0zM192 352c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0c17.7 0 32 14.3 32 32z"
    ]
};
const $d8206b3ab2e65c05$export$456a238f0144d430 = $d8206b3ab2e65c05$export$287bdd70ab874659;
const $d8206b3ab2e65c05$export$4280b2387fbdad12 = {
    prefix: 'fas',
    iconName: 'circle',
    icon: [
        512,
        512,
        [
            128308,
            128309,
            128992,
            128993,
            128994,
            128995,
            128996,
            9679,
            9898,
            9899,
            11044,
            61708,
            61915
        ],
        "f111",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"
    ]
};
const $d8206b3ab2e65c05$export$662cbc6ed5a3c5e8 = {
    prefix: 'fas',
    iconName: 'backward-fast',
    icon: [
        512,
        512,
        [
            9198,
            "fast-backward"
        ],
        "f049",
        "M493.6 445c-11.2 5.3-24.5 3.6-34.1-4.4L288 297.7 288 416c0 12.4-7.2 23.7-18.4 29s-24.5 3.6-34.1-4.4L64 297.7 64 416c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 96C0 78.3 14.3 64 32 64s32 14.3 32 32l0 118.3L235.5 71.4c9.5-7.9 22.8-9.7 34.1-4.4S288 83.6 288 96l0 118.3L459.5 71.4c9.5-7.9 22.8-9.7 34.1-4.4S512 83.6 512 96l0 320c0 12.4-7.2 23.7-18.4 29z"
    ]
};
const $d8206b3ab2e65c05$export$e6246a3279a379b8 = $d8206b3ab2e65c05$export$662cbc6ed5a3c5e8;
const $d8206b3ab2e65c05$export$a65c441f12cb6bd = {
    prefix: 'fas',
    iconName: 'recycle',
    icon: [
        512,
        512,
        [
            9842,
            9850,
            9851
        ],
        "f1b8",
        "M174.7 45.1C192.2 17 223 0 256 0s63.8 17 81.3 45.1l38.6 61.7 27-15.6c8.4-4.9 18.9-4.2 26.6 1.7s11.1 15.9 8.6 25.3l-23.4 87.4c-3.4 12.8-16.6 20.4-29.4 17l-87.4-23.4c-9.4-2.5-16.3-10.4-17.6-20s3.4-19.1 11.8-23.9l28.4-16.4L283 79c-5.8-9.3-16-15-27-15s-21.2 5.7-27 15l-17.5 28c-9.2 14.8-28.6 19.5-43.6 10.5c-15.3-9.2-20.2-29.2-10.7-44.4l17.5-28zM429.5 251.9c15-9 34.4-4.3 43.6 10.5l24.4 39.1c9.4 15.1 14.4 32.4 14.6 50.2c.3 53.1-42.7 96.4-95.8 96.4L320 448l0 32c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-64-64c-9.4-9.4-9.4-24.6 0-33.9l64-64c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2l0 32 96.2 0c17.6 0 31.9-14.4 31.8-32c0-5.9-1.7-11.7-4.8-16.7l-24.4-39.1c-9.5-15.2-4.7-35.2 10.7-44.4zm-364.6-31L36 204.2c-8.4-4.9-13.1-14.3-11.8-23.9s8.2-17.5 17.6-20l87.4-23.4c12.8-3.4 26 4.2 29.4 17L182 241.2c2.5 9.4-.9 19.3-8.6 25.3s-18.2 6.6-26.6 1.7l-26.5-15.3L68.8 335.3c-3.1 5-4.8 10.8-4.8 16.7c-.1 17.6 14.2 32 31.8 32l32.2 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32.2 0C42.7 448-.3 404.8 0 351.6c.1-17.8 5.1-35.1 14.6-50.2l50.3-80.5z"
    ]
};
const $d8206b3ab2e65c05$export$94363e983c225a04 = {
    prefix: 'fas',
    iconName: 'user-astronaut',
    icon: [
        448,
        512,
        [],
        "f4fb",
        "M370.7 96.1C346.1 39.5 289.7 0 224 0S101.9 39.5 77.3 96.1C60.9 97.5 48 111.2 48 128l0 64c0 16.8 12.9 30.5 29.3 31.9C101.9 280.5 158.3 320 224 320s122.1-39.5 146.7-96.1c16.4-1.4 29.3-15.1 29.3-31.9l0-64c0-16.8-12.9-30.5-29.3-31.9zM336 144l0 16c0 53-43 96-96 96l-32 0c-53 0-96-43-96-96l0-16c0-26.5 21.5-48 48-48l128 0c26.5 0 48 21.5 48 48zM189.3 162.7l-6-21.2c-.9-3.3-3.9-5.5-7.3-5.5s-6.4 2.2-7.3 5.5l-6 21.2-21.2 6c-3.3 .9-5.5 3.9-5.5 7.3s2.2 6.4 5.5 7.3l21.2 6 6 21.2c.9 3.3 3.9 5.5 7.3 5.5s6.4-2.2 7.3-5.5l6-21.2 21.2-6c3.3-.9 5.5-3.9 5.5-7.3s-2.2-6.4-5.5-7.3l-21.2-6zM112.7 316.5C46.7 342.6 0 407 0 482.3C0 498.7 13.3 512 29.7 512l98.3 0 0-64c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 64 98.3 0c16.4 0 29.7-13.3 29.7-29.7c0-75.3-46.7-139.7-112.7-165.8C303.9 338.8 265.5 352 224 352s-79.9-13.2-111.3-35.5zM176 448c-8.8 0-16 7.2-16 16l0 48 32 0 0-48c0-8.8-7.2-16-16-16zm96 32a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
const $d8206b3ab2e65c05$export$cfee4df0d5df6d21 = {
    prefix: 'fas',
    iconName: 'plane-slash',
    icon: [
        640,
        512,
        [],
        "e069",
        "M514.3 192c34.2 0 93.7 29 93.7 64c0 36-59.5 64-93.7 64l-73.8 0L630.8 469.1c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1L238.1 161.3 197.8 20.4C194.9 10.2 202.6 0 213.2 0l56.2 0c11.5 0 22.1 6.2 27.8 16.1L397.7 192l116.6 0zM41.5 128.7l321 252.9L297.2 495.9c-5.7 10-16.3 16.1-27.8 16.1l-56.2 0c-10.6 0-18.3-10.2-15.4-20.4l49-171.6L144 320l-43.2 57.6c-3 4-7.8 6.4-12.8 6.4l-42 0c-7.8 0-14-6.3-14-14c0-1.3 .2-2.6 .5-3.9L64 256 32.5 145.9c-.4-1.3-.5-2.6-.5-3.9c0-6.2 4-11.4 9.5-13.3z"
    ]
};
const $d8206b3ab2e65c05$export$9c9b2fbddd59047d = {
    prefix: 'fas',
    iconName: 'trademark',
    icon: [
        640,
        512,
        [
            8482
        ],
        "f25c",
        "M345.6 108.8c-8.3-11-22.7-15.5-35.7-11.2S288 114.2 288 128l0 256c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160 86.4 115.2c6 8.1 15.5 12.8 25.6 12.8s19.6-4.7 25.6-12.8L576 224l0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-256c0-13.8-8.8-26-21.9-30.4s-27.5 .1-35.7 11.2L464 266.7 345.6 108.8zM0 128c0 17.7 14.3 32 32 32l64 0 0 224c0 17.7 14.3 32 32 32s32-14.3 32-32l0-224 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 96C14.3 96 0 110.3 0 128z"
    ]
};
const $d8206b3ab2e65c05$export$44dee69e3a29b0e = {
    prefix: 'fas',
    iconName: 'basketball',
    icon: [
        512,
        512,
        [
            127936,
            "basketball-ball"
        ],
        "f434",
        "M86.6 64l85.2 85.2C194.5 121.7 208 86.4 208 48c0-14.7-2-28.9-5.7-42.4C158.6 15 119 35.5 86.6 64zM64 86.6C35.5 119 15 158.6 5.6 202.3C19.1 206 33.3 208 48 208c38.4 0 73.7-13.5 101.3-36.1L64 86.6zM256 0c-7.3 0-14.6 .3-21.8 .9C238 16 240 31.8 240 48c0 47.3-17.1 90.5-45.4 124L256 233.4 425.4 64C380.2 24.2 320.9 0 256 0zM48 240c-16.2 0-32-2-47.1-5.8C.3 241.4 0 248.7 0 256c0 64.9 24.2 124.2 64 169.4L233.4 256 172 194.6C138.5 222.9 95.3 240 48 240zm463.1 37.8c.6-7.2 .9-14.5 .9-21.8c0-64.9-24.2-124.2-64-169.4L278.6 256 340 317.4c33.4-28.3 76.7-45.4 124-45.4c16.2 0 32 2 47.1 5.8zm-4.7 31.9C492.9 306 478.7 304 464 304c-38.4 0-73.7 13.5-101.3 36.1L448 425.4c28.5-32.3 49.1-71.9 58.4-115.7zM340.1 362.7C317.5 390.3 304 425.6 304 464c0 14.7 2 28.9 5.7 42.4C353.4 497 393 476.5 425.4 448l-85.2-85.2zM317.4 340L256 278.6 86.6 448c45.1 39.8 104.4 64 169.4 64c7.3 0 14.6-.3 21.8-.9C274 496 272 480.2 272 464c0-47.3 17.1-90.5 45.4-124z"
    ]
};
const $d8206b3ab2e65c05$export$36550ab8ffcc5b28 = $d8206b3ab2e65c05$export$44dee69e3a29b0e;
const $d8206b3ab2e65c05$export$219ccae0e4da3c92 = {
    prefix: 'fas',
    iconName: 'satellite-dish',
    icon: [
        512,
        512,
        [
            128225
        ],
        "f7c0",
        "M192 32c0-17.7 14.3-32 32-32C383.1 0 512 128.9 512 288c0 17.7-14.3 32-32 32s-32-14.3-32-32C448 164.3 347.7 64 224 64c-17.7 0-32-14.3-32-32zM60.6 220.6L164.7 324.7l28.4-28.4c-.7-2.6-1.1-5.4-1.1-8.3c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32c-2.9 0-5.6-.4-8.3-1.1l-28.4 28.4L291.4 451.4c14.5 14.5 11.8 38.8-7.3 46.3C260.5 506.9 234.9 512 208 512C93.1 512 0 418.9 0 304c0-26.9 5.1-52.5 14.4-76.1c7.5-19 31.8-21.8 46.3-7.3zM224 96c106 0 192 86 192 192c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-70.7-57.3-128-128-128c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
const $d8206b3ab2e65c05$export$72ea8a5e4e86cd69 = {
    prefix: 'fas',
    iconName: 'circle-up',
    icon: [
        512,
        512,
        [
            61467,
            "arrow-alt-circle-up"
        ],
        "f35b",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm11.3-395.3l112 112c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9l-64 0 0 96c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-96-64 0c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l112-112c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
const $d8206b3ab2e65c05$export$3747a8ef0995eadf = $d8206b3ab2e65c05$export$72ea8a5e4e86cd69;
const $d8206b3ab2e65c05$export$da39ed20699ee2d7 = {
    prefix: 'fas',
    iconName: 'mobile-screen-button',
    icon: [
        384,
        512,
        [
            "mobile-alt"
        ],
        "f3cd",
        "M16 64C16 28.7 44.7 0 80 0L304 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L80 512c-35.3 0-64-28.7-64-64L16 64zM224 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM304 64L80 64l0 320 224 0 0-320z"
    ]
};
const $d8206b3ab2e65c05$export$e9599bc6cd92234d = $d8206b3ab2e65c05$export$da39ed20699ee2d7;
const $d8206b3ab2e65c05$export$39461921e738be65 = {
    prefix: 'fas',
    iconName: 'volume-high',
    icon: [
        640,
        512,
        [
            128266,
            "volume-up"
        ],
        "f028",
        "M533.6 32.5C598.5 85.2 640 165.8 640 256s-41.5 170.7-106.4 223.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C557.5 398.2 592 331.2 592 256s-34.5-142.2-88.7-186.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM473.1 107c43.2 35.2 70.9 88.9 70.9 149s-27.7 113.8-70.9 149c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C475.3 341.3 496 301.1 496 256s-20.7-85.3-53.2-111.8c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zm-60.5 74.5C434.1 199.1 448 225.9 448 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM301.1 34.8C312.6 40 320 51.4 320 64l0 384c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352 64 352c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l67.8 0L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3z"
    ]
};
const $d8206b3ab2e65c05$export$5940d3e475d90cc4 = $d8206b3ab2e65c05$export$39461921e738be65;
const $d8206b3ab2e65c05$export$9c0b63b698611d06 = {
    prefix: 'fas',
    iconName: 'users-rays',
    icon: [
        640,
        512,
        [],
        "e593",
        "M41 7C31.6-2.3 16.4-2.3 7 7S-2.3 31.6 7 41l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L41 7zM599 7L527 79c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0zM7 505c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 471c-9.4 9.4-9.4 24.6 0 33.9zm592 0c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72zM320 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM212.1 336c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24c-.5-1.4-1-2.7-1.6-4c-9.4-22.3-29.8-38.9-54.3-43c-3.9-.7-7.9-1-12-1l-80 0c-4.1 0-8.1 .3-12 1c-.8 .1-1.7 .3-2.5 .5c-24.9 5.1-45.1 23-53.4 46.5zM175.8 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-26.5 32C119.9 256 96 279.9 96 309.3c0 14.7 11.9 26.7 26.7 26.7l56.1 0c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4l-69.3 0zm368 80c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3l-69.3 0c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6l56.1 0zM464 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    ]
};
const $d8206b3ab2e65c05$export$79204db8777905c8 = {
    prefix: 'fas',
    iconName: 'wallet',
    icon: [
        512,
        512,
        [],
        "f555",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L80 128c-8.8 0-16-7.2-16-16s7.2-16 16-16l368 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L64 32zM416 272a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $d8206b3ab2e65c05$export$7babcb2c90eb609a = {
    prefix: 'fas',
    iconName: 'clipboard-check',
    icon: [
        384,
        512,
        [],
        "f46c",
        "M192 0c-41.8 0-77.4 26.7-90.5 64L64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-37.5 0C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM305 273L177 401c-9.4 9.4-24.6 9.4-33.9 0L79 337c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L271 239c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    ]
};
const $d8206b3ab2e65c05$export$b8d24c57c9e64933 = {
    prefix: 'fas',
    iconName: 'file-audio',
    icon: [
        384,
        512,
        [],
        "f1c7",
        "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zm2 226.3c37.1 22.4 62 63.1 62 109.7s-24.9 87.3-62 109.7c-7.6 4.6-17.4 2.1-22-5.4s-2.1-17.4 5.4-22C269.4 401.5 288 370.9 288 336s-18.6-65.5-46.5-82.3c-7.6-4.6-10-14.4-5.4-22s14.4-10 22-5.4zm-91.9 30.9c6 2.5 9.9 8.3 9.9 14.8l0 128c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5L113.4 376 80 376c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16l33.4 0 35.3-35.3c4.6-4.6 11.5-5.9 17.4-3.5zm51 34.9c6.6-5.9 16.7-5.3 22.6 1.3C249.8 304.6 256 319.6 256 336s-6.2 31.4-16.3 42.7c-5.9 6.6-16 7.1-22.6 1.3s-7.1-16-1.3-22.6c5.1-5.7 8.1-13.1 8.1-21.3s-3.1-15.7-8.1-21.3c-5.9-6.6-5.3-16.7 1.3-22.6z"
    ]
};
const $d8206b3ab2e65c05$export$128a6cab12423493 = {
    prefix: 'fas',
    iconName: 'burger',
    icon: [
        512,
        512,
        [
            "hamburger"
        ],
        "f805",
        "M61.1 224C45 224 32 211 32 194.9c0-1.9 .2-3.7 .6-5.6C37.9 168.3 78.8 32 256 32s218.1 136.3 223.4 157.3c.5 1.9 .6 3.7 .6 5.6c0 16.1-13 29.1-29.1 29.1L61.1 224zM144 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm240 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM272 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM16 304c0-26.5 21.5-48 48-48l384 0c26.5 0 48 21.5 48 48s-21.5 48-48 48L64 352c-26.5 0-48-21.5-48-48zm16 96c0-8.8 7.2-16 16-16l416 0c8.8 0 16 7.2 16 16l0 16c0 35.3-28.7 64-64 64L96 480c-35.3 0-64-28.7-64-64l0-16z"
    ]
};
const $d8206b3ab2e65c05$export$bab3bb9f4f59363 = $d8206b3ab2e65c05$export$128a6cab12423493;
const $d8206b3ab2e65c05$export$3c6c0c8185296ac5 = {
    prefix: 'fas',
    iconName: 'wrench',
    icon: [
        512,
        512,
        [
            128295
        ],
        "f0ad",
        "M352 320c88.4 0 160-71.6 160-160c0-15.3-2.2-30.1-6.2-44.2c-3.1-10.8-16.4-13.2-24.3-5.3l-76.8 76.8c-3 3-7.1 4.7-11.3 4.7L336 192c-8.8 0-16-7.2-16-16l0-57.4c0-4.2 1.7-8.3 4.7-11.3l76.8-76.8c7.9-7.9 5.4-21.2-5.3-24.3C382.1 2.2 367.3 0 352 0C263.6 0 192 71.6 192 160c0 19.1 3.4 37.5 9.5 54.5L19.9 396.1C7.2 408.8 0 426.1 0 444.1C0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9L297.5 310.5c17 6.2 35.4 9.5 54.5 9.5zM80 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
const $d8206b3ab2e65c05$export$f5bfd1271b8b71d1 = {
    prefix: 'fas',
    iconName: 'bugs',
    icon: [
        576,
        512,
        [],
        "e4d0",
        "M164.5 107.4l33.4-73.5c5.5-12.1 .1-26.3-11.9-31.8s-26.3-.1-31.8 11.9L128 71.7 101.9 14.1C96.4 2 82.1-3.3 70.1 2.1S52.7 21.9 58.1 33.9l33.4 73.5c-10.2 7.1-18.2 17-22.9 28.6l-17 0-4.1-20.7c-2.6-13-15.2-21.4-28.2-18.8S-2.1 111.7 .5 124.7l8 40C10.7 175.9 20.6 184 32 184l32 0 0 23.3-37.8 9.5c-9.5 2.4-16.6 10.2-17.9 19.9l-8 56c-1.9 13.1 7.2 25.3 20.4 27.2s25.3-7.2 27.2-20.4l5.7-40 18.4-4.6C82.7 274.6 103.8 288 128 288s45.3-13.4 56.1-33.2l18.4 4.6 5.7 40c1.9 13.1 14 22.2 27.2 20.4s22.2-14 20.4-27.2l-8-56c-1.4-9.7-8.5-17.5-17.9-19.9L192 207.3l0-23.3 32 0c11.4 0 21.3-8.1 23.5-19.3l8-40c2.6-13-5.8-25.6-18.8-28.2s-25.6 5.8-28.2 18.8L204.3 136l-17 0c-4.7-11.6-12.7-21.5-22.9-28.6zM496 286.5l65.6-47c10.8-7.7 13.3-22.7 5.6-33.5s-22.7-13.3-33.5-5.6l-51.4 36.8 6.1-62.9c1.3-13.2-8.4-24.9-21.6-26.2s-24.9 8.4-26.2 21.6L432.8 250c-12.3 1-24.2 5.6-34.1 13.3L384 254.8l6.8-20c4.2-12.6-2.5-26.2-15-30.4s-26.2 2.5-30.4 15l-13.1 38.6c-3.7 10.8 .8 22.8 10.7 28.5l27.7 16L359 322.7 321.5 312c-9.4-2.7-19.5 .6-25.5 8.3l-34.9 44.5c-8.2 10.4-6.4 25.5 4.1 33.7s25.5 6.4 33.7-4.1l25-31.8 18.2 5.2c-.5 22.6 11 44.7 32 56.8s45.9 11 65.2-.7l13.6 13.2-15.1 37.5c-4.9 12.3 1 26.3 13.3 31.2s26.3-1 31.2-13.3L503.5 440c3.6-9.1 1.4-19.4-5.6-26.2l-28-27.1 11.6-20.1 27.7 16c9.9 5.7 22.5 3.7 30-4.9L566.2 347c8.7-10 7.8-25.1-2.2-33.9s-25.1-7.8-33.9 2.2l-13.9 15.9-14.7-8.5c1.7-12.4-.2-25-5.5-36.2z"
    ]
};
const $d8206b3ab2e65c05$export$8bf9e3f7f57d486a = {
    prefix: 'fas',
    iconName: 'rupee-sign',
    icon: [
        448,
        512,
        [
            8360,
            "rupee"
        ],
        "f156",
        "M0 64C0 46.3 14.3 32 32 32l80 0c79.5 0 144 64.5 144 144c0 58.8-35.2 109.3-85.7 131.7l51.4 128.4c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8L106.3 320 64 320l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 288 0 64zM64 256l48 0c44.2 0 80-35.8 80-80s-35.8-80-80-80L64 96l0 160zm256.5 16.4c-.9 6 0 8.7 .4 9.8c.4 1.1 1.4 2.6 4.2 4.9c7.2 5.7 18.7 10 37.9 16.8l1.3 .5c16 5.6 38.7 13.6 55.7 28.1c9.5 8.1 17.9 18.6 23.1 32.3c5.1 13.7 6.1 28.5 3.8 44c-4.2 28.1-20.5 49.3-43.8 60.9c-22.1 11-48.1 12.5-73.2 8l-.2 0s0 0 0 0c-9.3-1.8-20.5-5.7-29.3-9c-6-2.3-12.6-4.9-17.7-6.9c0 0 0 0 0 0c-2.5-1-4.6-1.8-6.3-2.5c-16.5-6.4-24.6-25-18.2-41.4s24.9-24.6 41.4-18.2c2.6 1 5.2 2 7.9 3.1c0 0 0 0 0 0c4.8 1.9 9.8 3.9 15.4 6c8.8 3.3 15.3 5.4 18.7 6c15.7 2.8 26.7 .8 32.9-2.3c5-2.5 8-6 9.1-13c1-6.9 .2-10.5-.5-12.3c-.6-1.7-1.8-3.6-4.5-5.9c-6.9-5.8-18.2-10.4-36.9-17l-3-1.1c-15.5-5.4-37-13-53.3-25.9c-9.5-7.5-18.3-17.6-23.7-31c-5.5-13.4-6.6-28-4.4-43.2c8.4-57.1 67-78 116.9-68.9c6.9 1.3 27.3 5.8 35.4 8.4c16.9 5.2 26.3 23.2 21.1 40.1s-23.2 26.3-40.1 21.1c-4.7-1.4-22.3-5.5-27.9-6.5c-14.6-2.7-25.8-.4-32.6 3.2c-6.3 3.3-8.9 7.6-9.5 12z"
    ]
};
const $d8206b3ab2e65c05$export$9da25a46cfcb6fa4 = $d8206b3ab2e65c05$export$8bf9e3f7f57d486a;
const $d8206b3ab2e65c05$export$6440b286d3cbac9b = {
    prefix: 'fas',
    iconName: 'file-image',
    icon: [
        384,
        512,
        [
            128443
        ],
        "f1c5",
        "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM64 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm152 32c5.3 0 10.2 2.6 13.2 6.9l88 128c3.4 4.9 3.7 11.3 1 16.5s-8.2 8.6-14.2 8.6l-88 0-40 0-48 0-48 0c-5.8 0-11.1-3.1-13.9-8.1s-2.8-11.2 .2-16.1l48-80c2.9-4.8 8.1-7.8 13.7-7.8s10.8 2.9 13.7 7.8l12.8 21.4 48.3-70.2c3-4.3 7.9-6.9 13.2-6.9z"
    ]
};
const $d8206b3ab2e65c05$export$d7cf0978afd90002 = {
    prefix: 'fas',
    iconName: 'circle-question',
    icon: [
        512,
        512,
        [
            62108,
            "question-circle"
        ],
        "f059",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
const $d8206b3ab2e65c05$export$5ba67d7f2265c1a5 = $d8206b3ab2e65c05$export$d7cf0978afd90002;
const $d8206b3ab2e65c05$export$6ccbeeccfea6dc8a = {
    prefix: 'fas',
    iconName: 'plane-departure',
    icon: [
        640,
        512,
        [
            128747
        ],
        "f5b0",
        "M381 114.9L186.1 41.8c-16.7-6.2-35.2-5.3-51.1 2.7L89.1 67.4C78 73 77.2 88.5 87.6 95.2l146.9 94.5L136 240 77.8 214.1c-8.7-3.9-18.8-3.7-27.3 .6L18.3 230.8c-9.3 4.7-11.8 16.8-5 24.7l73.1 85.3c6.1 7.1 15 11.2 24.3 11.2l137.7 0c5 0 9.9-1.2 14.3-3.4L535.6 212.2c46.5-23.3 82.5-63.3 100.8-112C645.9 75 627.2 48 600.2 48l-57.4 0c-20.2 0-40.2 4.8-58.2 14L381 114.9zM0 480c0 17.7 14.3 32 32 32l576 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 448c-17.7 0-32 14.3-32 32z"
    ]
};
const $d8206b3ab2e65c05$export$2cef3f81ad90fb76 = {
    prefix: 'fas',
    iconName: 'handshake-slash',
    icon: [
        640,
        512,
        [],
        "e060",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-135-105.8c-1.1-11.4-6.3-22.3-15.3-30.7l-134.2-123-23.4 18.2-26-20.3 77.2-60.1c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L512 316.8 512 128l-.7 0-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2l-89.7 72.6-25.8-20.3 81.8-66.2c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-35.5 23.7L38.8 5.1zM96 171.6L40.6 128 0 128 0 352c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-180.4zM413.6 421.9L128 196.9 128 352l28.2 0 91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c.8-.8 1.5-1.7 2.2-2.6zM48 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM544 128l0 224c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-224-96 0zm32 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"
    ]
};
const $d8206b3ab2e65c05$export$3d177ecdf7fc50ec = {
    prefix: 'fas',
    iconName: 'book-bookmark',
    icon: [
        448,
        512,
        [],
        "e0bb",
        "M0 96C0 43 43 0 96 0l96 0 0 190.7c0 13.4 15.5 20.9 26 12.5L272 160l54 43.2c10.5 8.4 26 .9 26-12.5L352 0l32 0 32 0c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32l0 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0L96 512c-53 0-96-43-96-96L0 96zM64 416c0 17.7 14.3 32 32 32l256 0 0-64L96 384c-17.7 0-32 14.3-32 32z"
    ]
};
const $d8206b3ab2e65c05$export$aa054a78ab078db3 = {
    prefix: 'fas',
    iconName: 'code-branch',
    icon: [
        448,
        512,
        [],
        "f126",
        "M80 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm80-24c0 32.8-19.7 61-48 73.3l0 87.8c18.8-10.9 40.7-17.1 64-17.1l96 0c35.3 0 64-28.7 64-64l0-6.7C307.7 141 288 112.8 288 80c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3l0 6.7c0 70.7-57.3 128-128 128l-96 0c-35.3 0-64 28.7-64 64l0 6.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3l0-6.7 0-198.7C19.7 141 0 112.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80zm232 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM80 456a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
const $d8206b3ab2e65c05$export$37672611144b857b = {
    prefix: 'fas',
    iconName: 'hat-cowboy',
    icon: [
        640,
        512,
        [],
        "f8c0",
        "M320 64c14.4 0 22.3-7 30.8-14.4C360.4 41.1 370.7 32 392 32c49.3 0 84.4 152.2 97.9 221.9C447.8 272.1 390.9 288 320 288s-127.8-15.9-169.9-34.1C163.6 184.2 198.7 32 248 32c21.3 0 31.6 9.1 41.2 17.6C297.7 57 305.6 64 320 64zM111.1 270.7c47.2 24.5 117.5 49.3 209 49.3s161.8-24.8 208.9-49.3c24.8-12.9 49.8-28.3 70.1-47.7c7.9-7.9 20.2-9.2 29.6-3.3c9.5 5.9 13.5 17.9 9.9 28.5c-13.5 37.7-38.4 72.3-66.1 100.6C523.7 398.9 443.6 448 320 448s-203.6-49.1-252.5-99.2C39.8 320.4 14.9 285.8 1.4 248.1c-3.6-10.6 .4-22.6 9.9-28.5c9.5-5.9 21.7-4.5 29.6 3.3c20.4 19.4 45.3 34.8 70.1 47.7z"
    ]
};
const $d8206b3ab2e65c05$export$f402c7c97f3383f0 = {
    prefix: 'fas',
    iconName: 'bridge',
    icon: [
        576,
        512,
        [],
        "e4c8",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l40 0 0 64L0 160 0 288c53 0 96 43 96 96l0 64c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-64c0-53 43-96 96-96s96 43 96 96l0 64c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-64c0-53 43-96 96-96l0-128-72 0 0-64 40 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32zM456 96l0 64-80 0 0-64 80 0zM328 96l0 64-80 0 0-64 80 0zM200 96l0 64-80 0 0-64 80 0z"
    ]
};
const $d8206b3ab2e65c05$export$d86c56ab43eb0deb = {
    prefix: 'fas',
    iconName: 'phone-flip',
    icon: [
        512,
        512,
        [
            128381,
            "phone-alt"
        ],
        "f879",
        "M347.1 24.6c7.7-18.6 28-28.5 47.4-23.2l88 24C499.9 30.2 512 46 512 64c0 247.4-200.6 448-448 448c-18 0-33.8-12.1-38.6-29.5l-24-88c-5.3-19.4 4.6-39.7 23.2-47.4l96-40c16.3-6.8 35.2-2.1 46.3 11.6L207.3 368c70.4-33.3 127.4-90.3 160.7-160.7L318.7 167c-13.7-11.2-18.4-30-11.6-46.3l40-96z"
    ]
};
const $d8206b3ab2e65c05$export$a07a9b305deebf32 = $d8206b3ab2e65c05$export$d86c56ab43eb0deb;
const $d8206b3ab2e65c05$export$4a5a13c01d46357c = {
    prefix: 'fas',
    iconName: 'truck-front',
    icon: [
        512,
        512,
        [],
        "e2b7",
        "M0 80C0 35.8 35.8 0 80 0L432 0c44.2 0 80 35.8 80 80l0 288c0 26.2-12.6 49.4-32 64l0 48c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-32-256 0 0 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-48C12.6 417.4 0 394.2 0 368L0 80zm129.9 72.2L112 224l288 0-17.9-71.8C378.5 138 365.7 128 351 128l-190 0c-14.7 0-27.5 10-31 24.2zM128 320a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
const $d8206b3ab2e65c05$export$ab927dada03be4b3 = {
    prefix: 'fas',
    iconName: 'cat',
    icon: [
        576,
        512,
        [
            128008
        ],
        "f6be",
        "M320 192l17.1 0c22.1 38.3 63.5 64 110.9 64c11 0 21.8-1.4 32-4l0 4 0 32 0 192c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-140.8L280 448l56 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-144 0c-53 0-96-43-96-96l0-223.5c0-16.1-12-29.8-28-31.8l-7.9-1c-17.5-2.2-30-18.2-27.8-35.7s18.2-30 35.7-27.8l7.9 1c48 6 84.1 46.8 84.1 95.3l0 85.3c34.4-51.7 93.2-85.8 160-85.8zm160 26.5s0 0 0 0c-10 3.5-20.8 5.5-32 5.5c-28.4 0-54-12.4-71.6-32c0 0 0 0 0 0c-3.7-4.1-7-8.5-9.9-13.2C357.3 164 352 146.6 352 128c0 0 0 0 0 0l0-96 0-20 0-1.3C352 4.8 356.7 .1 362.6 0l.2 0c3.3 0 6.4 1.6 8.4 4.2c0 0 0 0 0 .1L384 21.3l27.2 36.3L416 64l64 0 4.8-6.4L512 21.3 524.8 4.3c0 0 0 0 0-.1c2-2.6 5.1-4.2 8.4-4.2l.2 0C539.3 .1 544 4.8 544 10.7l0 1.3 0 20 0 96c0 17.3-4.6 33.6-12.6 47.6c-11.3 19.8-29.6 35.2-51.4 42.9zM432 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
const $d8206b3ab2e65c05$export$61add9eca991b5ec = {
    prefix: 'fas',
    iconName: 'anchor-circle-exclamation',
    icon: [
        640,
        512,
        [],
        "e4ab",
        "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80L224 176c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 208-48 0c-53 0-96-43-96-96l0-6.1 7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7 0 6.1c0 88.4 71.6 160 160 160l80 0 80 0c8.2 0 16.3-.6 24.2-1.8c-22.2-16.2-40.4-37.5-53-62.2L320 448l0-80 0-128 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-10.9 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16z"
    ]
};
const $d8206b3ab2e65c05$export$f4419f7b2e53b340 = {
    prefix: 'fas',
    iconName: 'truck-field',
    icon: [
        640,
        512,
        [],
        "e58d",
        "M32 96c0-35.3 28.7-64 64-64l224 0c23.7 0 44.4 12.9 55.4 32l51.8 0c25.3 0 48.2 14.9 58.5 38l52.8 118.8c.5 1.1 .9 2.1 1.3 3.2l4.2 0c35.3 0 64 28.7 64 64l0 32c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c0 53-43 96-96 96s-96-43-96-96l-128 0c0 53-43 96-96 96s-96-43-96-96l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l0-32c-17.7 0-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32l0-32zM384 224l85.9 0-42.7-96L384 128l0 96zM160 432a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
    ]
};
const $d8206b3ab2e65c05$export$806c0a45a7ecd6e8 = {
    prefix: 'fas',
    iconName: 'route',
    icon: [
        512,
        512,
        [],
        "f4d7",
        "M512 96c0 50.2-59.1 125.1-84.6 155c-3.8 4.4-9.4 6.1-14.5 5L320 256c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c53 0 96 43 96 96s-43 96-96 96l-276.4 0c8.7-9.9 19.3-22.6 30-36.8c6.3-8.4 12.8-17.6 19-27.2L416 448c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0c-53 0-96-43-96-96s43-96 96-96l39.8 0c-21-31.5-39.8-67.7-39.8-96c0-53 43-96 96-96s96 43 96 96zM117.1 489.1c-3.8 4.3-7.2 8.1-10.1 11.3l-1.8 2-.2-.2c-6 4.6-14.6 4-20-1.8C59.8 473 0 402.5 0 352c0-53 43-96 96-96s96 43 96 96c0 30-21.1 67-43.5 97.9c-10.7 14.7-21.7 28-30.8 38.5l-.6 .7zM128 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM416 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
const $d8206b3ab2e65c05$export$d4aa151a4554b74e = {
    prefix: 'fas',
    iconName: 'clipboard-question',
    icon: [
        384,
        512,
        [],
        "e4e3",
        "M192 0c-41.8 0-77.4 26.7-90.5 64L64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-37.5 0C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM105.8 229.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L216 328.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM160 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
const $d8206b3ab2e65c05$export$5dd22dcb6e3ed369 = {
    prefix: 'fas',
    iconName: 'panorama',
    icon: [
        640,
        512,
        [],
        "e209",
        "M45.6 32C20.4 32 0 52.4 0 77.6L0 434.4C0 459.6 20.4 480 45.6 480c5.1 0 10-.8 14.7-2.4C74.6 472.8 177.6 440 320 440s245.4 32.8 259.6 37.6c4.7 1.6 9.7 2.4 14.7 2.4c25.2 0 45.6-20.4 45.6-45.6l0-356.7C640 52.4 619.6 32 594.4 32c-5 0-10 .8-14.7 2.4C565.4 39.2 462.4 72 320 72S74.6 39.2 60.4 34.4C55.6 32.8 50.7 32 45.6 32zM96 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm272 0c7.9 0 15.4 3.9 19.8 10.5L512.3 353c5.4 8 5.6 18.4 .4 26.5s-14.7 12.3-24.2 10.7C442.7 382.4 385.2 376 320 376c-65.6 0-123.4 6.5-169.3 14.4c-9.8 1.7-19.7-2.9-24.7-11.5s-4.3-19.4 1.9-27.2L197.3 265c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9l26.4 33.1 87-127.6c4.5-6.6 11.9-10.5 19.8-10.5z"
    ]
};
const $d8206b3ab2e65c05$export$101422b773924276 = {
    prefix: 'fas',
    iconName: 'comment-medical',
    icon: [
        512,
        512,
        [],
        "f7f5",
        "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM224 160c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z"
    ]
};
const $d8206b3ab2e65c05$export$c88ac21fe7c88ae6 = {
    prefix: 'fas',
    iconName: 'teeth-open',
    icon: [
        576,
        512,
        [],
        "f62f",
        "M96 32C43 32 0 75 0 128l0 64c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-64c0-53-43-96-96-96L96 32zM224 96c26.5 0 48 21.5 48 48l0 56c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-56c0-26.5 21.5-48 48-48zm80 48c0-26.5 21.5-48 48-48s48 21.5 48 48l0 56c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-56zM96 128c26.5 0 48 21.5 48 48l0 24c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-24c0-26.5 21.5-48 48-48zm336 48c0-26.5 21.5-48 48-48s48 21.5 48 48l0 24c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-24zM96 480l384 0c53 0 96-43 96-96l0-32c0-35.3-28.7-64-64-64L64 288c-35.3 0-64 28.7-64 64l0 32c0 53 43 96 96 96zm0-64c-26.5 0-48-21.5-48-48l0-24c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 24c0 26.5-21.5 48-48 48zm80-48l0-24c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 24c0 26.5-21.5 48-48 48s-48-21.5-48-48zm176 48c-26.5 0-48-21.5-48-48l0-24c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 24c0 26.5-21.5 48-48 48zm80-48l0-24c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 24c0 26.5-21.5 48-48 48s-48-21.5-48-48z"
    ]
};
const $d8206b3ab2e65c05$export$4b89fabf50a10951 = {
    prefix: 'fas',
    iconName: 'file-circle-minus',
    icon: [
        576,
        512,
        [],
        "e4ed",
        "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 0c0-8.8-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16z"
    ]
};
const $d8206b3ab2e65c05$export$d55778e3ab6c933f = {
    prefix: 'fas',
    iconName: 'tags',
    icon: [
        512,
        512,
        [],
        "f02c",
        "M345 39.1L472.8 168.4c52.4 53 52.4 138.2 0 191.2L360.8 472.9c-9.3 9.4-24.5 9.5-33.9 .2s-9.5-24.5-.2-33.9L438.6 325.9c33.9-34.3 33.9-89.4 0-123.7L310.9 72.9c-9.3-9.4-9.2-24.6 .2-33.9s24.6-9.2 33.9 .2zM0 229.5L0 80C0 53.5 21.5 32 48 32l149.5 0c17 0 33.3 6.7 45.3 18.7l168 168c25 25 25 65.5 0 90.5L277.3 442.7c-25 25-65.5 25-90.5 0l-168-168C6.7 262.7 0 246.5 0 229.5zM144 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
const $d8206b3ab2e65c05$export$e06d6607d3577d6e = {
    prefix: 'fas',
    iconName: 'wine-glass',
    icon: [
        320,
        512,
        [
            127863
        ],
        "f4e3",
        "M32.1 29.3C33.5 12.8 47.4 0 64 0L256 0c16.6 0 30.5 12.8 31.9 29.3l14 168.4c6 72-42.5 135.2-109.9 150.6l0 99.6 48 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-80 0-80 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l48 0 0-99.6C60.6 333 12.1 269.8 18.1 197.8l14-168.4zm56 98.7l143.8 0-5.3-64L93.4 64l-5.3 64z"
    ]
};
const $d8206b3ab2e65c05$export$dc9cc4280bee320d = {
    prefix: 'fas',
    iconName: 'forward-fast',
    icon: [
        512,
        512,
        [
            9197,
            "fast-forward"
        ],
        "f050",
        "M18.4 445c11.2 5.3 24.5 3.6 34.1-4.4L224 297.7 224 416c0 12.4 7.2 23.7 18.4 29s24.5 3.6 34.1-4.4L448 297.7 448 416c0 17.7 14.3 32 32 32s32-14.3 32-32l0-320c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 118.3L276.5 71.4c-9.5-7.9-22.8-9.7-34.1-4.4S224 83.6 224 96l0 118.3L52.5 71.4c-9.5-7.9-22.8-9.7-34.1-4.4S0 83.6 0 96L0 416c0 12.4 7.2 23.7 18.4 29z"
    ]
};
const $d8206b3ab2e65c05$export$61a8cdc53c2e078d = $d8206b3ab2e65c05$export$dc9cc4280bee320d;
const $d8206b3ab2e65c05$export$38c072b870a9e4ab = {
    prefix: 'fas',
    iconName: 'face-meh-blank',
    icon: [
        512,
        512,
        [
            128566,
            "meh-blank"
        ],
        "f5a4",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm208.4-48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
const $d8206b3ab2e65c05$export$e945435725f71e88 = $d8206b3ab2e65c05$export$38c072b870a9e4ab;
const $d8206b3ab2e65c05$export$f2cfa036d76f69ab = {
    prefix: 'fas',
    iconName: 'square-parking',
    icon: [
        448,
        512,
        [
            127359,
            "parking"
        ],
        "f540",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM192 256l48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-48 0 0 64zm48 64l-48 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64 0-120c0-22.1 17.9-40 40-40l72 0c53 0 96 43 96 96s-43 96-96 96z"
    ]
};
const $d8206b3ab2e65c05$export$fda29c8f99573a4e = $d8206b3ab2e65c05$export$f2cfa036d76f69ab;
const $d8206b3ab2e65c05$export$58845db8e7e9a199 = {
    prefix: 'fas',
    iconName: 'house-signal',
    icon: [
        576,
        512,
        [],
        "e012",
        "M357.7 8.5c-12.3-11.3-31.2-11.3-43.4 0l-208 192c-9.4 8.6-12.7 22-8.5 34c87.1 25.3 155.6 94.2 180.3 181.6L464 416c26.5 0 48-21.5 48-48l0-112 32 0c13.2 0 25-8.1 29.8-20.3s1.6-26.2-8.1-35.2l-208-192zM288 208c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-64zM24 256c-13.3 0-24 10.7-24 24s10.7 24 24 24c101.6 0 184 82.4 184 184c0 13.3 10.7 24 24 24s24-10.7 24-24c0-128.1-103.9-232-232-232zm8 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM0 376c0 13.3 10.7 24 24 24c48.6 0 88 39.4 88 88c0 13.3 10.7 24 24 24s24-10.7 24-24c0-75.1-60.9-136-136-136c-13.3 0-24 10.7-24 24z"
    ]
};
const $d8206b3ab2e65c05$export$ee3a02da18715b2 = {
    prefix: 'fas',
    iconName: 'bars-progress',
    icon: [
        512,
        512,
        [
            "tasks-alt"
        ],
        "f828",
        "M448 160l-128 0 0-32 128 0 0 32zM48 64C21.5 64 0 85.5 0 112l0 64c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48L48 64zM448 352l0 32-256 0 0-32 256 0zM48 288c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48L48 288z"
    ]
};
const $d8206b3ab2e65c05$export$bbc0784fc1578f7f = $d8206b3ab2e65c05$export$ee3a02da18715b2;
const $d8206b3ab2e65c05$export$7a255960242435f6 = {
    prefix: 'fas',
    iconName: 'faucet-drip',
    icon: [
        512,
        512,
        [
            128688
        ],
        "e006",
        "M224 0c17.7 0 32 14.3 32 32l0 12 96-12c17.7 0 32 14.3 32 32s-14.3 32-32 32L256 84l-31-3.9-1-.1-1 .1L192 84 96 96C78.3 96 64 81.7 64 64s14.3-32 32-32l96 12 0-12c0-17.7 14.3-32 32-32zM0 224c0-17.7 14.3-32 32-32l96 0 22.6-22.6c6-6 14.1-9.4 22.6-9.4l18.7 0 0-43.8 32-4 32 4 0 43.8 18.7 0c8.5 0 16.6 3.4 22.6 9.4L320 192l32 0c88.4 0 160 71.6 160 160c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32s-14.3-32-32-32l-36.1 0c-20.2 29-53.9 48-91.9 48s-71.7-19-91.9-48L32 320c-17.7 0-32-14.3-32-32l0-64zM436.8 423.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1l18.2-42.4z"
    ]
};
const $d8206b3ab2e65c05$export$df587aaf7765e1ce = {
    prefix: 'fas',
    iconName: 'cart-flatbed',
    icon: [
        640,
        512,
        [
            "dolly-flatbed"
        ],
        "f474",
        "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64l16 0c8.8 0 16 7.2 16 16l0 288c0 44.2 35.8 80 80 80l18.7 0c-1.8 5-2.7 10.4-2.7 16c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16l197.5 0c-1.8 5-2.7 10.4-2.7 16c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16l66.7 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-464 0c-8.8 0-16-7.2-16-16l0-288C128 35.8 92.2 0 48 0L32 0zM192 80l0 192c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48l0-192c0-26.5-21.5-48-48-48l-96 0 0 144c0 5.9-3.2 11.3-8.5 14.1s-11.5 2.5-16.4-.8L400 163.2l-39.1 26.1c-4.9 3.3-11.2 3.6-16.4 .8s-8.5-8.2-8.5-14.1l0-144-96 0c-26.5 0-48 21.5-48 48z"
    ]
};
const $d8206b3ab2e65c05$export$f7c6efb60c53b285 = $d8206b3ab2e65c05$export$df587aaf7765e1ce;
const $d8206b3ab2e65c05$export$130df7ed74437774 = {
    prefix: 'fas',
    iconName: 'ban-smoking',
    icon: [
        512,
        512,
        [
            128685,
            "smoking-ban"
        ],
        "f54d",
        "M99.5 144.8L178.7 224l96 96 92.5 92.5C335.9 434.9 297.5 448 256 448C150 448 64 362 64 256c0-41.5 13.1-79.9 35.5-111.2zM333.3 288l-32-32 82.7 0 0 32-50.7 0zm32 32l34.7 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-130.7 0L144.8 99.5C176.1 77.1 214.5 64 256 64c106 0 192 86 192 192c0 41.5-13.1 79.9-35.5 111.2L365.3 320zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM272 96c-8.8 0-16 7.2-16 16c0 26.5 21.5 48 48 48l32 0c8.8 0 16 7.2 16 16s7.2 16 16 16s16-7.2 16-16c0-26.5-21.5-48-48-48l-32 0c-8.8 0-16-7.2-16-16s-7.2-16-16-16zM229.5 320l-96-96L112 224c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l117.5 0z"
    ]
};
const $d8206b3ab2e65c05$export$e50452a49dec29f = $d8206b3ab2e65c05$export$130df7ed74437774;
const $d8206b3ab2e65c05$export$5e63e8b85b5f119c = {
    prefix: 'fas',
    iconName: 'terminal',
    icon: [
        576,
        512,
        [],
        "f120",
        "M9.4 86.6C-3.1 74.1-3.1 53.9 9.4 41.4s32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L178.7 256 9.4 86.6zM256 416l288 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
const $d8206b3ab2e65c05$export$c93d62849efbdd11 = {
    prefix: 'fas',
    iconName: 'mobile-button',
    icon: [
        384,
        512,
        [],
        "f10b",
        "M80 0C44.7 0 16 28.7 16 64l0 384c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L80 0zM192 400a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $d8206b3ab2e65c05$export$86c50f517be57a40 = {
    prefix: 'fas',
    iconName: 'house-medical-flag',
    icon: [
        640,
        512,
        [],
        "e514",
        "M480 0c17.7 0 32 14.3 32 32l112 0c8.8 0 16 7.2 16 16l0 128c0 8.8-7.2 16-16 16l-112 0 0 320-64 0 0-320 0-160c0-17.7 14.3-32 32-32zM276.8 39.7L416 159l0 353 1 0-.2 0L96 512c-17.7 0-32-14.3-32-32l0-192-32 0c-13.4 0-25.4-8.3-30-20.9s-1-26.7 9.2-35.4l224-192c12-10.3 29.7-10.3 41.7 0zM224 208l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z"
    ]
};
const $d8206b3ab2e65c05$export$1d307c13b511e8e1 = {
    prefix: 'fas',
    iconName: 'basket-shopping',
    icon: [
        576,
        512,
        [
            "shopping-basket"
        ],
        "f291",
        "M253.3 35.1c6.1-11.8 1.5-26.3-10.2-32.4s-26.3-1.5-32.4 10.2L117.6 192 32 192c-17.7 0-32 14.3-32 32s14.3 32 32 32L83.9 463.5C91 492 116.6 512 146 512L430 512c29.4 0 55-20 62.1-48.5L544 256c17.7 0 32-14.3 32-32s-14.3-32-32-32l-85.6 0L365.3 12.9C359.2 1.2 344.7-3.4 332.9 2.7s-16.3 20.6-10.2 32.4L404.3 192l-232.6 0L253.3 35.1zM192 304l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16s16 7.2 16 16zm96-16c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16zm128 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
const $d8206b3ab2e65c05$export$ca6d443595a6578f = $d8206b3ab2e65c05$export$1d307c13b511e8e1;
const $d8206b3ab2e65c05$export$b88ed5e1e0eac4c6 = {
    prefix: 'fas',
    iconName: 'tape',
    icon: [
        576,
        512,
        [],
        "f4db",
        "M380.8 416c41.5-40.7 67.2-97.3 67.2-160C448 132.3 347.7 32 224 32S0 132.3 0 256S100.3 480 224 480l320 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-163.2 0zM224 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm64 96a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
    ]
};
const $d8206b3ab2e65c05$export$d3724faf0c559353 = {
    prefix: 'fas',
    iconName: 'bus-simple',
    icon: [
        448,
        512,
        [
            "bus-alt"
        ],
        "f55e",
        "M224 0C348.8 0 448 35.2 448 80l0 16 0 320c0 17.7-14.3 32-32 32l0 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-32-192 0 0 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-32c-17.7 0-32-14.3-32-32L0 96 0 80C0 35.2 99.2 0 224 0zM64 128l0 128c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32L96 96c-17.7 0-32 14.3-32 32zM80 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
const $d8206b3ab2e65c05$export$40616edfab6d332a = $d8206b3ab2e65c05$export$d3724faf0c559353;
const $d8206b3ab2e65c05$export$b8c3e79e8c99c95b = {
    prefix: 'fas',
    iconName: 'eye',
    icon: [
        576,
        512,
        [
            128065
        ],
        "f06e",
        "M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"
    ]
};
const $d8206b3ab2e65c05$export$e8ea88c55e55be7c = {
    prefix: 'fas',
    iconName: 'face-sad-cry',
    icon: [
        512,
        512,
        [
            128557,
            "sad-cry"
        ],
        "f5b3",
        "M352 493.4c-29.6 12-62.1 18.6-96 18.6s-66.4-6.6-96-18.6L160 288c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 189.8C51.5 433.5 0 350.8 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 94.8-51.5 177.5-128 221.8L384 288c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 205.4zM195.2 233.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zm121.6 0c17.6-23.5 52.8-23.5 70.4 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2zM208 336l0 32c0 26.5 21.5 48 48 48s48-21.5 48-48l0-32c0-26.5-21.5-48-48-48s-48 21.5-48 48z"
    ]
};
const $d8206b3ab2e65c05$export$8e924e6bd422cef9 = $d8206b3ab2e65c05$export$e8ea88c55e55be7c;
const $d8206b3ab2e65c05$export$b6b464c98c009494 = {
    prefix: 'fas',
    iconName: 'audio-description',
    icon: [
        576,
        512,
        [],
        "f29e",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM213.5 173.3l72 144c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7l-9.4-18.9-82.2 0-9.4 18.9c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l72-144c4.1-8.1 12.4-13.3 21.5-13.3s17.4 5.1 21.5 13.3zm-.4 106.6L192 237.7l-21.1 42.2 42.2 0zM304 184c0-13.3 10.7-24 24-24l56 0c53 0 96 43 96 96s-43 96-96 96l-56 0c-13.3 0-24-10.7-24-24l0-144zm48 24l0 96 32 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-32 0z"
    ]
};
const $d8206b3ab2e65c05$export$41b1e14a6b0fe11b = {
    prefix: 'fas',
    iconName: 'person-military-to-person',
    icon: [
        512,
        512,
        [],
        "e54c",
        "M71 12.5c-8.6 1-15 8.2-15 16.8c0 9.3 7.5 16.8 16.7 16.9l111.4 0c8.8-.1 15.9-7.2 15.9-16L200 16c0-9.5-8.3-17-17.8-15.9L71 12.5zM189.5 78.1l-122.9 0C64.9 83.8 64 89.8 64 96c0 35.3 28.7 64 64 64s64-28.7 64-64c0-6.2-.9-12.2-2.5-17.9zM32 256l0 32c0 17.7 14.3 32 32 32l128 0c1.8 0 3.5-.1 5.2-.4L53 208.6C40.1 220.3 32 237.2 32 256zm190.2 42.5c1.1-3.3 1.8-6.8 1.8-10.5l0-32c0-35.3-28.7-64-64-64l-64 0c-3.7 0-7.4 .3-10.9 .9L222.2 298.5zM384 160a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-35.3 0-64 28.7-64 64l0 32c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-32c0-35.3-28.7-64-64-64l-64 0zM215.8 450.1c5.2-4.6 8.2-11.1 8.2-18.1s-3-13.5-8.2-18.1l-64-56c-7.1-6.2-17.1-7.7-25.7-3.8S112 366.6 112 376l0 32-88 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l88 0 0 32c0 9.4 5.5 18 14.1 21.9s18.6 2.4 25.7-3.8l64-56zM288 431.9c0 6.9 2.9 13.5 8.1 18.1l64 56.4c7.1 6.2 17.1 7.8 25.7 3.9s14.1-12.4 14.1-21.9l0-32.4 88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0 0-32c0-9.4-5.5-18-14.1-21.9s-18.6-2.4-25.7 3.8l-64 56c-5.2 4.5-8.2 11.1-8.2 18z"
    ]
};
const $d8206b3ab2e65c05$export$348a01df65a66c99 = {
    prefix: 'fas',
    iconName: 'file-shield',
    icon: [
        576,
        512,
        [],
        "e4f0",
        "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 47-92.8 37.1c-21.3 8.5-35.2 29.1-35.2 52c0 56.6 18.9 148 94.2 208.3c-9 4.8-19.3 7.6-30.2 7.6L64 512c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zm39.1 97.7c5.7-2.3 12.1-2.3 17.8 0l120 48C570 277.4 576 286.2 576 296c0 63.3-25.9 168.8-134.8 214.2c-5.9 2.5-12.6 2.5-18.5 0C313.9 464.8 288 359.3 288 296c0-9.8 6-18.6 15.1-22.3l120-48zM527.4 312L432 273.8l0 187.8c68.2-33 91.5-99 95.4-149.7z"
    ]
};
const $d8206b3ab2e65c05$export$3924ab4d3ef9b5ef = {
    prefix: 'fas',
    iconName: 'user-slash',
    icon: [
        640,
        512,
        [],
        "f506",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L353.3 251.6C407.9 237 448 187.2 448 128C448 57.3 390.7 0 320 0C250.2 0 193.5 55.8 192 125.2L38.8 5.1zM264.3 304.3C170.5 309.4 96 387.2 96 482.3c0 16.4 13.3 29.7 29.7 29.7l388.6 0c3.9 0 7.6-.7 11-2.1l-261-205.6z"
    ]
};
const $d8206b3ab2e65c05$export$8f4567331fb0d3bc = {
    prefix: 'fas',
    iconName: 'pen',
    icon: [
        512,
        512,
        [
            128394
        ],
        "f304",
        "M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z"
    ]
};
const $d8206b3ab2e65c05$export$5b2f0f631f559d51 = {
    prefix: 'fas',
    iconName: 'tower-observation',
    icon: [
        512,
        512,
        [],
        "e586",
        "M241.7 3.4c9-4.5 19.6-4.5 28.6 0l160 80c15.8 7.9 22.2 27.1 14.3 42.9C439 137.5 427.7 144 416 144l0 80c0 17.7-14.3 32-32 32l-4.9 0 32 192 68.9 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-95.5 0c-.4 0-.8 0-1.1 0l-254.8 0c-.4 0-.8 0-1.1 0L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l68.9 0 32-192-4.9 0c-17.7 0-32-14.3-32-32l0-80c-11.7 0-23-6.5-28.6-17.7c-7.9-15.8-1.5-35 14.3-42.9l160-80zM314.5 448L256 399.2 197.5 448l117 0zM197.8 256l-4.7 28.3L256 336.8l62.9-52.5L314.2 256l-116.5 0zm-13.9 83.2l-11.2 67L218.5 368l-34.6-28.8zM293.5 368l45.8 38.1-11.2-67L293.5 368zM176 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0z"
    ]
};
const $d8206b3ab2e65c05$export$143d0ca7d2200f20 = {
    prefix: 'fas',
    iconName: 'file-code',
    icon: [
        384,
        512,
        [],
        "f1c9",
        "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM153 289l-31 31 31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L71 337c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM265 255l48 48c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
    ]
};
const $d8206b3ab2e65c05$export$79046b073b6c584d = {
    prefix: 'fas',
    iconName: 'signal',
    icon: [
        640,
        512,
        [
            128246,
            "signal-5",
            "signal-perfect"
        ],
        "f012",
        "M576 0c17.7 0 32 14.3 32 32l0 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-448c0-17.7 14.3-32 32-32zM448 96c17.7 0 32 14.3 32 32l0 352c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-352c0-17.7 14.3-32 32-32zM352 224l0 256c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32s32 14.3 32 32zM192 288c17.7 0 32 14.3 32 32l0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-160c0-17.7 14.3-32 32-32zM96 416l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
const $d8206b3ab2e65c05$export$3417071118065933 = $d8206b3ab2e65c05$export$79046b073b6c584d;
const $d8206b3ab2e65c05$export$1aea50ab3e99cc95 = $d8206b3ab2e65c05$export$79046b073b6c584d;
const $d8206b3ab2e65c05$export$ce69441578ff2fdb = {
    prefix: 'fas',
    iconName: 'bus',
    icon: [
        576,
        512,
        [
            128653
        ],
        "f207",
        "M288 0C422.4 0 512 35.2 512 80l0 16 0 32c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l0 160c0 17.7-14.3 32-32 32l0 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-32-192 0 0 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-32c-17.7 0-32-14.3-32-32l0-160c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32c0 0 0 0 0 0l0-32s0 0 0 0l0-16C64 35.2 153.6 0 288 0zM128 160l0 96c0 17.7 14.3 32 32 32l112 0 0-160-112 0c-17.7 0-32 14.3-32 32zM304 288l112 0c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l-112 0 0 160zM144 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM384 80c0-8.8-7.2-16-16-16L208 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16z"
    ]
};
const $d8206b3ab2e65c05$export$742f89ae2f8d6b20 = {
    prefix: 'fas',
    iconName: 'heart-circle-xmark',
    icon: [
        576,
        512,
        [],
        "e501",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6l0-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1l0 5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
const $d8206b3ab2e65c05$export$af554427144a7e5c = {
    prefix: 'fas',
    iconName: 'house-chimney',
    icon: [
        576,
        512,
        [
            63499,
            "home-lg"
        ],
        "e3af",
        "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L512 185l0-121c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32l0 36.7L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1l32 0 0 69.7c-.1 .9-.1 1.8-.1 2.8l0 112c0 22.1 17.9 40 40 40l16 0c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2l31.9 0 24 0c22.1 0 40-17.9 40-40l0-24 0-64c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64 0 24c0 22.1 17.9 40 40 40l24 0 32.5 0c1.4 0 2.8 0 4.2-.1c1.1 .1 2.2 .1 3.3 .1l16 0c22.1 0 40-17.9 40-40l0-16.2c.3-2.6 .5-5.3 .5-8.1l-.7-160.2 32 0z"
    ]
};
const $d8206b3ab2e65c05$export$dbab81727ec94698 = $d8206b3ab2e65c05$export$af554427144a7e5c;
const $d8206b3ab2e65c05$export$703cd98be31ec905 = {
    prefix: 'fas',
    iconName: 'window-maximize',
    icon: [
        512,
        512,
        [
            128470
        ],
        "f2d0",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM96 96l320 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L96 160c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
const $d8206b3ab2e65c05$export$e5f78e87efbb0248 = {
    prefix: 'fas',
    iconName: 'face-frown',
    icon: [
        512,
        512,
        [
            9785,
            "frown"
        ],
        "f119",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM159.3 388.7c-2.6 8.4-11.6 13.2-20 10.5s-13.2-11.6-10.5-20C145.2 326.1 196.3 288 256 288s110.8 38.1 127.3 91.3c2.6 8.4-2.1 17.4-10.5 20s-17.4-2.1-20-10.5C340.5 349.4 302.1 320 256 320s-84.5 29.4-96.7 68.7zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $d8206b3ab2e65c05$export$43b7108508aecc5f = $d8206b3ab2e65c05$export$e5f78e87efbb0248;
const $d8206b3ab2e65c05$export$8767bafb19515ee4 = {
    prefix: 'fas',
    iconName: 'prescription',
    icon: [
        448,
        512,
        [],
        "f5b1",
        "M32 0C14.3 0 0 14.3 0 32L0 192l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64 50.7 0 128 128L137.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L288 397.3 393.4 502.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L333.3 352 438.6 246.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 306.7l-85.8-85.8C251.4 209.1 288 164.8 288 112C288 50.1 237.9 0 176 0L32 0zM176 160L64 160l0-96 112 0c26.5 0 48 21.5 48 48s-21.5 48-48 48z"
    ]
};
const $d8206b3ab2e65c05$export$78edc9b98453b6f7 = {
    prefix: 'fas',
    iconName: 'shop',
    icon: [
        640,
        512,
        [
            "store-alt"
        ],
        "f54f",
        "M36.8 192l566.3 0c20.3 0 36.8-16.5 36.8-36.8c0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0L121.7 0c-16 0-31 8-39.9 21.4L6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4C0 175.5 16.5 192 36.8 192zM64 224l0 160 0 80c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-80 0-160-64 0 0 160-192 0 0-160-64 0zm448 0l0 256c0 17.7 14.3 32 32 32s32-14.3 32-32l0-256-64 0z"
    ]
};
const $d8206b3ab2e65c05$export$1f1871dab9cec9d8 = $d8206b3ab2e65c05$export$78edc9b98453b6f7;
const $d8206b3ab2e65c05$export$f62f2879ccaea13f = {
    prefix: 'fas',
    iconName: 'floppy-disk',
    icon: [
        448,
        512,
        [
            128190,
            128426,
            "save"
        ],
        "f0c7",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-242.7c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32L64 32zm0 96c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L96 224c-17.7 0-32-14.3-32-32l0-64zM224 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
    ]
};
const $d8206b3ab2e65c05$export$1aaa83ff70706e1e = $d8206b3ab2e65c05$export$f62f2879ccaea13f;
const $d8206b3ab2e65c05$export$ee4b92e89fe0dfaf = {
    prefix: 'fas',
    iconName: 'vihara',
    icon: [
        640,
        512,
        [],
        "f6a7",
        "M281 22L305.8 4.7c1.3-.9 2.7-1.8 4.1-2.4C313.1 .7 316.6 0 320 0s6.9 .7 10.1 2.2c1.4 .7 2.8 1.5 4.1 2.4L359 22C393 45.8 430.8 63.5 470.8 74.4l23 6.3c1.8 .5 3.6 1.1 5.2 2c3.2 1.7 5.9 4 8.1 6.8c3.8 4.9 5.6 11.3 4.7 17.8c-.4 2.8-1.2 5.4-2.5 7.8c-1.7 3.2-4 5.9-6.8 8.1c-4.3 3.2-9.6 5.1-15.1 4.9l-7.5 0 0 56.1 6.4 5.1 5.2 4.1c21.1 16.7 45 29.6 70.5 38.1l28.9 9.6c1.6 .5 3.2 1.2 4.6 2c3.1 1.7 5.8 4.1 7.8 6.9s3.5 6.1 4.1 9.6c.5 2.7 .6 5.5 .1 8.3s-1.4 5.4-2.7 7.8c-1.7 3.1-4.1 5.8-6.9 7.8s-6.1 3.5-9.6 4.1c-1.6 .3-3.3 .4-5 .4L544 288l0 65.9c20.5 22.8 47.4 39.2 77.4 46.7C632 403 640 412.6 640 424c0 13.3-10.7 24-24 24l-40 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-160 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-160 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-40 0c-13.3 0-24-10.7-24-24c0-11.4 8-21 18.6-23.4c30-7.6 56.9-23.9 77.4-46.7L96 288l-39.4 0c-1.7 0-3.4-.1-5-.4c-3.5-.7-6.8-2.1-9.6-4.1s-5.2-4.7-7-7.8c-1.3-2.4-2.3-5-2.7-7.8s-.4-5.6 .1-8.3c.7-3.5 2.1-6.8 4.1-9.6s4.7-5.2 7.8-6.9c1.4-.8 3-1.5 4.6-2l28.9-9.6c25.5-8.5 49.4-21.4 70.5-38.1l5.2-4.1 6.4-5.1 0-8.1 0-48-7.5 0c-5.5 .1-10.8-1.7-15.1-4.9c-2.8-2.1-5.1-4.8-6.8-8.1c-1.2-2.4-2.1-5-2.5-7.8c-.9-6.5 .9-12.8 4.7-17.8c2.1-2.8 4.8-5.1 8.1-6.8c1.6-.8 3.4-1.5 5.2-2l23-6.3C209.2 63.5 247 45.8 281 22zM416 128l-96 0-96 0 0 64 72 0 48 0 72 0 0-64zM160 288l0 64 136 0 24 0 24 0 136 0 0-64-136 0-24 0s0 0 0 0l-24 0-136 0z"
    ]
};
const $d8206b3ab2e65c05$export$4d10bcc8d068f454 = {
    prefix: 'fas',
    iconName: 'scale-unbalanced',
    icon: [
        640,
        512,
        [
            "balance-scale-left"
        ],
        "f515",
        "M522.1 62.4c16.8-5.6 25.8-23.7 20.2-40.5S518.6-3.9 501.9 1.6l-113 37.7C375 15.8 349.3 0 320 0c-44.2 0-80 35.8-80 80c0 3 .2 5.9 .5 8.8L117.9 129.6c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l135.5-45.2c4.5 3.2 9.3 5.9 14.4 8.2L288 480c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-160 0 0-294.7c21-9.2 37.2-27 44.2-49l125.9-42zM439.6 288L512 163.8 584.4 288l-144.9 0zM512 384c62.9 0 115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1L536.1 109.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L392.7 273.1c-5.7 9.8-9.3 21.1-6.7 32.1C396.8 350 449.1 384 512 384zM129.2 291.8L201.6 416 56.7 416l72.4-124.2zM3.2 433.1C14 478 66.3 512 129.2 512s115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1L153.2 237.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L9.9 401.1c-5.7 9.8-9.3 21.1-6.7 32.1z"
    ]
};
const $d8206b3ab2e65c05$export$786cb0c775487f19 = $d8206b3ab2e65c05$export$4d10bcc8d068f454;
const $d8206b3ab2e65c05$export$f9dd5b1410e95035 = {
    prefix: 'fas',
    iconName: 'sort-up',
    icon: [
        320,
        512,
        [
            "sort-asc"
        ],
        "f0de",
        "M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l256 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"
    ]
};
const $d8206b3ab2e65c05$export$e4c8c924b1cc43a7 = $d8206b3ab2e65c05$export$f9dd5b1410e95035;
const $d8206b3ab2e65c05$export$63ffcb3d4e94cb92 = {
    prefix: 'fas',
    iconName: 'comment-dots',
    icon: [
        512,
        512,
        [
            128172,
            62075,
            "commenting"
        ],
        "f4ad",
        "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM128 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
const $d8206b3ab2e65c05$export$49ee382a2425e89c = $d8206b3ab2e65c05$export$63ffcb3d4e94cb92;
const $d8206b3ab2e65c05$export$77a38850ff8b0407 = {
    prefix: 'fas',
    iconName: 'plant-wilt',
    icon: [
        512,
        512,
        [],
        "e5aa",
        "M288 120c0-30.9 25.1-56 56-56s56 25.1 56 56l0 13c-29.3 10-48 34.5-48 70.1c0 27.9 25.3 74.8 66 111.6c3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6c0-35.6-18.7-60.2-48-70.1l0-13C464 53.7 410.3 0 344 0S224 53.7 224 120l0 21.8C207.3 133 188.2 128 168 128c-66.3 0-120 53.7-120 120l0 13c-29.3 10-48 34.5-48 70.1C0 359 25.3 405.9 66 442.7c3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6c0-35.6-18.7-60.2-48-70.1l0-13c0-30.9 25.1-56 56-56s56 25.1 56 56l0 32 0 200c0 17.7 14.3 32 32 32s32-14.3 32-32l0-200 0-32 0-128z"
    ]
};
const $d8206b3ab2e65c05$export$f214f827e0023247 = {
    prefix: 'fas',
    iconName: 'diamond',
    icon: [
        512,
        512,
        [
            9830
        ],
        "f219",
        "M284.3 11.7c-15.6-15.6-40.9-15.6-56.6 0l-216 216c-15.6 15.6-15.6 40.9 0 56.6l216 216c15.6 15.6 40.9 15.6 56.6 0l216-216c15.6-15.6 15.6-40.9 0-56.6l-216-216z"
    ]
};
const $d8206b3ab2e65c05$export$5d53da7627754bc6 = {
    prefix: 'fas',
    iconName: 'face-grin-squint',
    icon: [
        512,
        512,
        [
            128518,
            "grin-squint"
        ],
        "f585",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM133.5 146.7l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
    ]
};
const $d8206b3ab2e65c05$export$243ae757907b1580 = $d8206b3ab2e65c05$export$5d53da7627754bc6;
const $d8206b3ab2e65c05$export$61a67f5f8ab39be = {
    prefix: 'fas',
    iconName: 'hand-holding-dollar',
    icon: [
        576,
        512,
        [
            "hand-holding-usd"
        ],
        "f4c0",
        "M312 24l0 10.5c6.4 1.2 12.6 2.7 18.2 4.2c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17c-10.9-2.9-21.1-4.9-30.2-5c-7.3-.1-14.7 1.7-19.4 4.4c-2.1 1.3-3.1 2.4-3.5 3c-.3 .5-.7 1.2-.7 2.8c0 .3 0 .5 0 .6c.2 .2 .9 1.2 3.3 2.6c5.8 3.5 14.4 6.2 27.4 10.1l.9 .3s0 0 0 0c11.1 3.3 25.9 7.8 37.9 15.3c13.7 8.6 26.1 22.9 26.4 44.9c.3 22.5-11.4 38.9-26.7 48.5c-6.7 4.1-13.9 7-21.3 8.8l0 10.6c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-11.4c-9.5-2.3-18.2-5.3-25.6-7.8c-2.1-.7-4.1-1.4-6-2c-12.6-4.2-19.4-17.8-15.2-30.4s17.8-19.4 30.4-15.2c2.6 .9 5 1.7 7.3 2.5c13.6 4.6 23.4 7.9 33.9 8.3c8 .3 15.1-1.6 19.2-4.1c1.9-1.2 2.8-2.2 3.2-2.9c.4-.6 .9-1.8 .8-4.1l0-.2c0-1 0-2.1-4-4.6c-5.7-3.6-14.3-6.4-27.1-10.3l-1.9-.6c-10.8-3.2-25-7.5-36.4-14.4c-13.5-8.1-26.5-22-26.6-44.1c-.1-22.9 12.9-38.6 27.7-47.4c6.4-3.8 13.3-6.4 20.2-8.2L264 24c0-13.3 10.7-24 24-24s24 10.7 24 24zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5L192 512 32 512c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l36.8 0 44.9-36c22.7-18.2 50.9-28 80-28l78.3 0 16 0 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l120.6 0 119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384c0 0 0 0 0 0l-.9 0c.3 0 .6 0 .9 0z"
    ]
};
const $d8206b3ab2e65c05$export$47d27bc305b59690 = $d8206b3ab2e65c05$export$61a67f5f8ab39be;
const $d8206b3ab2e65c05$export$eae84dfa654882b1 = {
    prefix: 'fas',
    iconName: 'chart-diagram',
    icon: [
        512,
        512,
        [],
        "e695",
        "M80 32C53.5 32 32 53.5 32 80s21.5 48 48 48l152 0 0 40-48 48-56 0c-48.6 0-88 39.4-88 88l0 48-8 0c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-8 0 0-48c0-22.1 17.9-40 40-40l56 0 48 48 0 40-8 0c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-8 0 0-40 48-48 56 0c22.1 0 40 17.9 40 40l0 48-8 0c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-8 0 0-48c0-48.6-39.4-88-88-88l-56 0-48-48 0-40 152 0c26.5 0 48-21.5 48-48s-21.5-48-48-48L80 32z"
    ]
};
const $d8206b3ab2e65c05$export$b0babe4230e35ebe = {
    prefix: 'fas',
    iconName: 'bacterium',
    icon: [
        512,
        512,
        [],
        "e05a",
        "M423.1 30.6c3.6-12.7-3.7-26-16.5-29.7s-26 3.7-29.7 16.5l-4.2 14.7c-9.8-.4-19.9 .5-29.9 2.8c-12.1 2.8-23.7 5.9-34.9 9.4l-5.9-13.7c-5.2-12.2-19.3-17.8-31.5-12.6s-17.8 19.3-12.6 31.5l4.9 11.3c-22 9.4-42 20.1-60.2 31.8L196 82.7c-7.4-11-22.3-14-33.3-6.7s-14 22.3-6.7 33.3l7.8 11.6c-18 15-33.7 30.8-47.3 47.1L103 157.3c-10.4-8.3-25.5-6.6-33.7 3.7s-6.6 25.5 3.7 33.7l15 12c-2.1 3.2-4.1 6.5-6 9.7c-9.4 15.7-17 31-23.2 45.3l-9.9-3.9c-12.3-4.9-26.3 1.1-31.2 13.4s1.1 26.3 13.4 31.2l11.6 4.6c-.3 1.1-.6 2.1-.9 3.1c-3.5 12.5-5.7 23.2-7.1 31.3c-.7 4.1-1.2 7.5-1.6 10.3c-.2 1.4-.3 2.6-.4 3.6l-.1 1.4-.1 .6 0 .3 0 .1c0 0 0 .1 39.2 3.7c0 0 0 0 0 0l-39.2-3.6c-.5 5-.6 10-.4 14.9l-14.7 4.2C4.7 380.6-2.7 393.8 .9 406.6s16.9 20.1 29.7 16.5l13.8-3.9c10.6 20.7 27.6 37.8 48.5 48.5l-3.9 13.7c-3.6 12.7 3.7 26 16.5 29.7s26-3.7 29.7-16.5l4.2-14.7c23.8 1 46.3-5.5 65.1-17.6L215 473c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-10.6-10.6c9.1-14.1 15.1-30.5 17-48.3l.1-.8c.3-1.7 1-5.1 2.3-9.8l.2-.8 12.6 5.4c12.2 5.2 26.3-.4 31.5-12.6s-.4-26.3-12.6-31.5l-11.3-4.8c9.9-14.9 24.9-31.6 48.6-46l2.1 7.5c3.6 12.7 16.9 20.1 29.7 16.5s20.1-16.9 16.5-29.7L371 259.2c6.9-2.2 14.3-4.3 22.2-6.1c12.9-3 24.7-8 35.2-14.8L439 249c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-10.6-10.6c12.2-19 18.6-41.6 17.6-65.1l14.7-4.2c12.7-3.6 20.1-16.9 16.5-29.7s-16.9-20.1-29.7-16.5l-13.7 3.9c-10.8-21.2-28-38-48.5-48.5l3.9-13.8zM92.1 363.3s0 0 0 0L144 368l-51.9-4.7zM112 320a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM240 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
const $d8206b3ab2e65c05$export$d97ff927c450c87f = {
    prefix: 'fas',
    iconName: 'hand-pointer',
    icon: [
        448,
        512,
        [],
        "f25a",
        "M128 40c0-22.1 17.9-40 40-40s40 17.9 40 40l0 148.2c8.5-7.6 19.7-12.2 32-12.2c20.6 0 38.2 13 45 31.2c8.8-9.3 21.2-15.2 35-15.2c25.3 0 46 19.5 47.9 44.3c8.5-7.7 19.8-12.3 32.1-12.3c26.5 0 48 21.5 48 48l0 48 0 16 0 48c0 70.7-57.3 128-128 128l-16 0-64 0-.1 0-5.2 0c-5 0-9.9-.3-14.7-1c-55.3-5.6-106.2-34-140-79L8 336c-13.3-17.7-9.7-42.7 8-56s42.7-9.7 56 8l56 74.7L128 40zM240 304c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96zm48-16c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-8.8-7.2-16-16-16zm80 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96z"
    ]
};
const $d8206b3ab2e65c05$export$48d1206500db2e9d = {
    prefix: 'fas',
    iconName: 'drum-steelpan',
    icon: [
        576,
        512,
        [],
        "f56a",
        "M288 32c159.1 0 288 48 288 128l0 192c0 80-128.9 128-288 128S0 432 0 352L0 160C0 80 128.9 32 288 32zM528 160c0-9.9-8-29.9-55-49.8c-18.6-7.9-40.9-14.4-66-19.4l-27.8 43.6c-7.3 11.5-11.2 24.8-11.2 38.4c0 17.5 6.4 34.4 18.1 47.5l9.8 11c29.8-5.2 55.9-12.5 77.2-21.5c47.1-19.9 55-39.9 55-49.8zM349.2 237.3c-8-26.2-32.4-45.3-61.2-45.3s-53.3 19.1-61.2 45.3c19.4 1.7 39.9 2.7 61.2 2.7s41.8-.9 61.2-2.7zM169 90.8c-25.2 5-47.4 11.6-66 19.4C56 130.1 48 150.1 48 160s8 29.9 55 49.8c21.3 9 47.4 16.3 77.2 21.5l9.8-11c11.6-13.1 18.1-30 18.1-47.5c0-13.6-3.9-26.9-11.2-38.4L169 90.8zm56.3-8C224.5 87 224 91.5 224 96c0 35.3 28.7 64 64 64s64-28.7 64-64c0-4.5-.5-9-1.4-13.2C330.8 81 309.8 80 288 80s-42.8 1-62.6 2.8z"
    ]
};
const $d8206b3ab2e65c05$export$c578e919f2c5c135 = {
    prefix: 'fas',
    iconName: 'hand-scissors',
    icon: [
        512,
        512,
        [],
        "f257",
        "M40 208c-22.1 0-40 17.9-40 40s17.9 40 40 40l180.2 0c-7.6 8.5-12.2 19.7-12.2 32c0 25.3 19.5 46 44.3 47.9c-7.7 8.5-12.3 19.8-12.3 32.1c0 26.5 21.5 48 48 48l32 0 64 0c70.7 0 128-57.3 128-128l0-113.1c0-40.2-16-78.8-44.4-107.3C444.8 76.8 413.9 64 381.7 64L336 64c-21.3 0-39.3 13.9-45.6 33.1l74.5 23.7c8.4 2.7 13.1 11.7 10.4 20.1s-11.7 13.1-20.1 10.4L288 129.9c0 0 0 .1 0 .1L84 65.8C62.9 59.2 40.5 70.9 33.8 92s5.1 43.5 26.2 50.2L269.5 208 40 208z"
    ]
};
const $d8206b3ab2e65c05$export$a96374faedb12593 = {
    prefix: 'fas',
    iconName: 'hands-praying',
    icon: [
        640,
        512,
        [
            "praying-hands"
        ],
        "f684",
        "M351.2 4.8c3.2-2 6.6-3.3 10-4.1c4.7-1 9.6-.9 14.1 .1c7.7 1.8 14.8 6.5 19.4 13.6L514.6 194.2c8.8 13.1 13.4 28.6 13.4 44.4l0 73.5c0 6.9 4.4 13 10.9 15.2l79.2 26.4C631.2 358 640 370.2 640 384l0 96c0 9.9-4.6 19.3-12.5 25.4s-18.1 8.1-27.7 5.5L431 465.9c-56-14.9-95-65.7-95-123.7L336 224c0-17.7 14.3-32 32-32s32 14.3 32 32l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-84.9c0-7-1.8-13.8-5.3-19.8L340.3 48.1c-1.7-3-2.9-6.1-3.6-9.3c-1-4.7-1-9.6 .1-14.1c1.9-8 6.8-15.2 14.3-19.9zm-62.4 0c7.5 4.6 12.4 11.9 14.3 19.9c1.1 4.6 1.2 9.4 .1 14.1c-.7 3.2-1.9 6.3-3.6 9.3L213.3 199.3c-3.5 6-5.3 12.9-5.3 19.8l0 84.9c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-17.7 14.3-32 32-32s32 14.3 32 32l0 118.2c0 58-39 108.7-95 123.7l-168.7 45c-9.6 2.6-19.9 .5-27.7-5.5S0 490 0 480l0-96c0-13.8 8.8-26 21.9-30.4l79.2-26.4c6.5-2.2 10.9-8.3 10.9-15.2l0-73.5c0-15.8 4.7-31.2 13.4-44.4L245.2 14.5c4.6-7.1 11.7-11.8 19.4-13.6c4.6-1.1 9.4-1.2 14.1-.1c3.5 .8 6.9 2.1 10 4.1z"
    ]
};
const $d8206b3ab2e65c05$export$95e08e91b0929943 = $d8206b3ab2e65c05$export$a96374faedb12593;
const $d8206b3ab2e65c05$export$9c58ddc4b3356f98 = {
    prefix: 'fas',
    iconName: 'arrow-rotate-right',
    icon: [
        512,
        512,
        [
            8635,
            "arrow-right-rotate",
            "arrow-rotate-forward",
            "redo"
        ],
        "f01e",
        "M386.3 160L336 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 51.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0s-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3s163.8-62.5 226.3 0L386.3 160z"
    ]
};
const $d8206b3ab2e65c05$export$ffa1245982c1b28b = $d8206b3ab2e65c05$export$9c58ddc4b3356f98;
const $d8206b3ab2e65c05$export$89c59b5f47067f4c = $d8206b3ab2e65c05$export$9c58ddc4b3356f98;
const $d8206b3ab2e65c05$export$3d9f98aa1c24c776 = $d8206b3ab2e65c05$export$9c58ddc4b3356f98;
const $d8206b3ab2e65c05$export$5fa0ffae6770a0cc = {
    prefix: 'fas',
    iconName: 'web-awesome',
    icon: [
        640,
        512,
        [],
        "e682",
        "M372.2 52c0 20.9-12.4 39-30.2 47.2L448 192l104.4-20.9c-5.3-7.7-8.4-17.1-8.4-27.1c0-26.5 21.5-48 48-48s48 21.5 48 48c0 26-20.6 47.1-46.4 48L481 442.3c-10.3 23-33.2 37.7-58.4 37.7l-205.2 0c-25.2 0-48-14.8-58.4-37.7L46.4 192C20.6 191.1 0 170 0 144c0-26.5 21.5-48 48-48s48 21.5 48 48c0 10.1-3.1 19.4-8.4 27.1L192 192 298.1 99.1c-17.7-8.3-30-26.3-30-47.1c0-28.7 23.3-52 52-52s52 23.3 52 52z"
    ]
};
const $d8206b3ab2e65c05$export$ae3a453550dec95 = {
    prefix: 'fas',
    iconName: 'biohazard',
    icon: [
        576,
        512,
        [
            9763
        ],
        "f780",
        "M173.2 0c-1.8 0-3.5 .7-4.8 2C138.5 32.3 120 74 120 120c0 26.2 6 50.9 16.6 73c-22 2.4-43.8 9.1-64.2 20.5C37.9 232.8 13.3 262.4 .4 296c-.7 1.7-.5 3.7 .5 5.2c2.2 3.7 7.4 4.3 10.6 1.3C64.2 254.3 158 245.1 205 324s-8.1 153.1-77.6 173.2c-4.2 1.2-6.3 5.9-4.1 9.6c1 1.6 2.6 2.7 4.5 3c36.5 5.9 75.2 .1 109.7-19.2c20.4-11.4 37.4-26.5 50.5-43.8c13.1 17.3 30.1 32.4 50.5 43.8c34.5 19.3 73.3 25.2 109.7 19.2c1.9-.3 3.5-1.4 4.5-3c2.2-3.7 .1-8.4-4.1-9.6C379.1 477.1 324 403 371 324s140.7-69.8 193.5-21.4c3.2 2.9 8.4 2.3 10.6-1.3c1-1.6 1.1-3.5 .5-5.2c-12.9-33.6-37.5-63.2-72.1-82.5c-20.4-11.4-42.2-18.1-64.2-20.5C450 170.9 456 146.2 456 120c0-46-18.5-87.7-48.4-118c-1.3-1.3-3-2-4.8-2c-5 0-8.4 5.2-6.7 9.9C421.7 80.5 385.6 176 288 176S154.3 80.5 179.9 9.9c1.7-4.7-1.6-9.9-6.7-9.9zM240 272a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM181.7 417.6c6.3-11.8 9.8-25.1 8.6-39.8c-19.5-18-34-41.4-41.2-67.8c-12.5-8.1-26.2-11.8-40-12.4c-9-.4-18.1 .6-27.1 2.7c7.8 57.1 38.7 106.8 82.9 139.4c6.8-6.7 12.6-14.1 16.8-22.1zM288 64c-28.8 0-56.3 5.9-81.2 16.5c2 8.3 5 16.2 9 23.5c6.8 12.4 16.7 23.1 30.1 30.3c13.3-4.1 27.5-6.3 42.2-6.3s28.8 2.2 42.2 6.3c13.4-7.2 23.3-17.9 30.1-30.3c4-7.3 7-15.2 9-23.5C344.3 69.9 316.8 64 288 64zM426.9 310c-7.2 26.4-21.7 49.7-41.2 67.8c-1.2 14.7 2.2 28.1 8.6 39.8c4.3 8 10 15.4 16.8 22.1c44.3-32.6 75.2-82.3 82.9-139.4c-9-2.2-18.1-3.1-27.1-2.7c-13.8 .6-27.5 4.4-40 12.4z"
    ]
};
const $d8206b3ab2e65c05$export$14e1096ad1719098 = {
    prefix: 'fas',
    iconName: 'location-crosshairs',
    icon: [
        512,
        512,
        [
            "location"
        ],
        "f601",
        "M256 0c17.7 0 32 14.3 32 32l0 34.7C368.4 80.1 431.9 143.6 445.3 224l34.7 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-34.7 0C431.9 368.4 368.4 431.9 288 445.3l0 34.7c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-34.7C143.6 431.9 80.1 368.4 66.7 288L32 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l34.7 0C80.1 143.6 143.6 80.1 224 66.7L224 32c0-17.7 14.3-32 32-32zM128 256a128 128 0 1 0 256 0 128 128 0 1 0 -256 0zm128-80a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
    ]
};
const $d8206b3ab2e65c05$export$45e012c32174eb5d = $d8206b3ab2e65c05$export$14e1096ad1719098;
const $d8206b3ab2e65c05$export$2f8a28204bb4b86f = {
    prefix: 'fas',
    iconName: 'mars-double',
    icon: [
        640,
        512,
        [
            9891
        ],
        "f227",
        "M312 32c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l33.4 33.4L275.8 159c-28.4-19.5-62.7-31-99.8-31C78.8 128 0 206.8 0 304s78.8 176 176 176s176-78.8 176-176c0-37-11.4-71.4-31-99.8l52.6-52.6L407 185c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2l0-112c0-13.3-10.7-24-24-24L312 32zm88 48s0 0 0 0s0 0 0 0s0 0 0 0zM64 304a112 112 0 1 1 224 0A112 112 0 1 1 64 304zM368 480c97.2 0 176-78.8 176-176c0-37-11.4-71.4-31-99.8l52.6-52.6L599 185c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2l0-112c0-13.3-10.7-24-24-24L504 32c-9.7 0-18.5 5.8-22.2 14.8c-1.2 2.9-1.8 6-1.8 9l0 .2 0 .2c0 6.2 2.5 12.2 7 16.8l33.4 33.4L480 146.7l0 21.3c0 22.6-13.6 43.1-34.6 51.7c-.8 .3-1.7 .7-2.5 1C465.7 241.2 480 270.9 480 304c0 61.9-50.1 112-112 112c-5.4 0-10.8-.4-16-1.1c-12.9 20.4-29.1 38.3-48.1 53.1c19.8 7.8 41.4 12 64 12z"
    ]
};
const $d8206b3ab2e65c05$export$f31a37ecbfd4e707 = {
    prefix: 'fas',
    iconName: 'child-dress',
    icon: [
        320,
        512,
        [],
        "e59c",
        "M224 64A64 64 0 1 0 96 64a64 64 0 1 0 128 0zM88 400l0 80c0 17.7 14.3 32 32 32s32-14.3 32-32l0-80 16 0 0 80c0 17.7 14.3 32 32 32s32-14.3 32-32l0-80 17.8 0c10.9 0 18.6-10.7 15.2-21.1l-31.1-93.4 28.6 37.8c10.7 14.1 30.8 16.8 44.8 6.2s16.8-30.7 6.2-44.8L254.6 207c-22.4-29.6-57.5-47-94.6-47s-72.2 17.4-94.6 47L6.5 284.7c-10.7 14.1-7.9 34.2 6.2 44.8s34.2 7.9 44.8-6.2l28.7-37.8L55 378.9C51.6 389.3 59.3 400 70.2 400L88 400z"
    ]
};
const $d8206b3ab2e65c05$export$6ea1decf8bb3513d = {
    prefix: 'fas',
    iconName: 'users-between-lines',
    icon: [
        640,
        512,
        [],
        "e591",
        "M0 24C0 10.7 10.7 0 24 0L616 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 48C10.7 48 0 37.3 0 24zM0 488c0-13.3 10.7-24 24-24l592 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24zM83.2 160a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM32 320c0-35.3 28.7-64 64-64l96 0c12.2 0 23.7 3.4 33.4 9.4c-37.2 15.1-65.6 47.2-75.8 86.6L64 352c-17.7 0-32-14.3-32-32zm461.6 32c-10.3-40.1-39.6-72.6-77.7-87.4c9.4-5.5 20.4-8.6 32.1-8.6l96 0c35.3 0 64 28.7 64 64c0 17.7-14.3 32-32 32l-82.4 0zM391.2 290.4c32.1 7.4 58.1 30.9 68.9 61.6c3.5 10 5.5 20.8 5.5 32c0 17.7-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32c0-11.2 1.9-22 5.5-32c10.5-29.7 35.3-52.8 66.1-60.9c7.8-2.1 16-3.1 24.5-3.1l96 0c7.4 0 14.7 .8 21.6 2.4zm44-130.4a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM321.6 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
    ]
};
const $d8206b3ab2e65c05$export$895159d10626af74 = {
    prefix: 'fas',
    iconName: 'lungs-virus',
    icon: [
        640,
        512,
        [],
        "e067",
        "M320 0c17.7 0 32 14.3 32 32l0 124.2c-8.5-7.6-19.7-12.2-32-12.2s-23.5 4.6-32 12.2L288 32c0-17.7 14.3-32 32-32zM444.5 195.5c-16.4-16.4-41.8-18.5-60.5-6.1l0-24.1C384 127 415 96 453.3 96c21.7 0 42.8 10.2 55.8 28.8c15.4 22.1 44.3 65.4 71 116.9c26.5 50.9 52.4 112.5 59.6 170.3c.2 1.3 .2 2.6 .2 4l0 7c0 49.1-39.8 89-89 89c-7.3 0-14.5-.9-21.6-2.7l-72.7-18.2c-20.9-5.2-38.7-17.1-51.5-32.9c14 1.5 28.5-3 39.2-13.8l-22.6-22.6 22.6 22.6c18.7-18.7 18.7-49.1 0-67.9c-1.1-1.1-1.4-2-1.5-2.5c-.1-.8-.1-1.8 .4-2.9s1.2-1.9 1.8-2.3c.5-.3 1.3-.8 2.9-.8c26.5 0 48-21.5 48-48s-21.5-48-48-48c-1.6 0-2.4-.4-2.9-.8c-.6-.4-1.3-1.2-1.8-2.3s-.5-2.2-.4-2.9c.1-.6 .4-1.4 1.5-2.5c18.7-18.7 18.7-49.1 0-67.9zM421.8 421.8c-6.2 6.2-16.4 6.2-22.6 0C375.9 398.5 336 415 336 448c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C241.5 375.9 225 336 192 336c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C264.1 241.5 304 225 304 192c0-8.8 7.2-16 16-16s16 7.2 16 16c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C398.5 264.1 415 304 448 304c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6zM183.3 491.2l-72.7 18.2c-7.1 1.8-14.3 2.7-21.6 2.7c-49.1 0-89-39.8-89-89l0-7c0-1.3 .1-2.7 .2-4c7.2-57.9 33.1-119.4 59.6-170.3c26.8-51.5 55.6-94.8 71-116.9c13-18.6 34-28.8 55.8-28.8C225 96 256 127 256 165.3l0 24.1c-18.6-12.4-44-10.3-60.5 6.1c-18.7 18.7-18.7 49.1 0 67.9c1.1 1.1 1.4 2 1.5 2.5c.1 .8 .1 1.8-.4 2.9s-1.2 1.9-1.8 2.3c-.5 .3-1.3 .8-2.9 .8c-26.5 0-48 21.5-48 48s21.5 48 48 48c1.6 0 2.4 .4 2.9 .8c.6 .4 1.3 1.2 1.8 2.3s.5 2.2 .4 2.9c-.1 .6-.4 1.4-1.5 2.5c-18.7 18.7-18.7 49.1 0 67.9c10.7 10.7 25.3 15.3 39.2 13.8c-12.8 15.9-30.6 27.7-51.5 32.9zM296 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm72 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
    ]
};
const $d8206b3ab2e65c05$export$8ac6d81a3d5b40a1 = {
    prefix: 'fas',
    iconName: 'face-grin-tears',
    icon: [
        640,
        512,
        [
            128514,
            "grin-tears"
        ],
        "f588",
        "M548.6 371.4C506.4 454.8 419.9 512 320 512s-186.4-57.2-228.6-140.6c4.5-2.9 8.7-6.3 12.7-10.3c8.1-8.1 13.2-18.6 16.5-26.6c3.6-8.8 6.5-18.4 8.8-27.5c4.6-18.2 7.7-37 9.3-48.2c3.9-26.5-18.8-49.2-45.2-45.4c-6.8 .9-16.2 2.4-26.6 4.4C85.3 94.5 191.6 0 320 0S554.7 94.5 573.2 217.7c-10.3-2-19.8-3.5-26.6-4.4c-26.5-3.9-49.2 18.8-45.2 45.4c1.6 11.3 4.6 30 9.3 48.2c2.3 9.1 5.2 18.8 8.8 27.5c3.3 8.1 8.4 18.5 16.5 26.6c3.9 3.9 8.2 7.4 12.7 10.3zM107 254.1c-3.1 21.5-11.4 70.2-25.5 84.4c-.9 1-1.9 1.8-2.9 2.7C60 356.7 32 355.5 14.3 337.7c-18.7-18.7-19.1-48.8-.7-67.2c8.6-8.6 30.1-15.1 50.5-19.6c13-2.8 25.5-4.8 33.9-6c5.4-.8 9.9 3.7 9 9zm454.5 87.1c-.8-.6-1.5-1.3-2.3-2c-.2-.2-.5-.4-.7-.7c-14.1-14.1-22.5-62.9-25.5-84.4c-.8-5.4 3.7-9.9 9-9c1 .1 2.2 .3 3.3 .5c8.2 1.2 19.2 3 30.6 5.5c20.4 4.4 41.9 10.9 50.5 19.6c18.4 18.4 18 48.5-.7 67.2c-17.7 17.7-45.7 19-64.2 3.4zm-90.1-9.7c5-11.8-7-22.5-19.3-18.7c-39.7 12.2-84.5 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7c25 59.1 83.2 100.5 151.1 100.5s126.2-41.4 151.1-100.5zM281.6 228.8s0 0 0 0s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C190.7 188.4 184 206.1 184 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0zm160 0s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C350.7 188.4 344 206.1 344 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0c0 0 0 0 0 0z"
    ]
};
const $d8206b3ab2e65c05$export$b2f7512221512b5b = $d8206b3ab2e65c05$export$8ac6d81a3d5b40a1;
const $d8206b3ab2e65c05$export$ddab067855cf34cb = {
    prefix: 'fas',
    iconName: 'phone',
    icon: [
        512,
        512,
        [
            128222,
            128379
        ],
        "f095",
        "M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z"
    ]
};
const $d8206b3ab2e65c05$export$3c70ffe5660af060 = {
    prefix: 'fas',
    iconName: 'calendar-xmark',
    icon: [
        448,
        512,
        [
            "calendar-times"
        ],
        "f273",
        "M128 0c17.7 0 32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 48 0c26.5 0 48 21.5 48 48l0 48L0 160l0-48C0 85.5 21.5 64 48 64l48 0 0-32c0-17.7 14.3-32 32-32zM0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192zM305 305c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47z"
    ]
};
const $d8206b3ab2e65c05$export$99b20d7352fbcf08 = $d8206b3ab2e65c05$export$3c70ffe5660af060;
const $d8206b3ab2e65c05$export$84a2f9476730c40e = {
    prefix: 'fas',
    iconName: 'child-reaching',
    icon: [
        384,
        512,
        [],
        "e59d",
        "M256 64A64 64 0 1 0 128 64a64 64 0 1 0 128 0zM152.9 169.3c-23.7-8.4-44.5-24.3-58.8-45.8L74.6 94.2C64.8 79.5 45 75.6 30.2 85.4s-18.7 29.7-8.9 44.4L40.9 159c18.1 27.1 42.8 48.4 71.1 62.4L112 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96 32 0 0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-258.4c29.1-14.2 54.4-36.2 72.7-64.2l18.2-27.9c9.6-14.8 5.4-34.6-9.4-44.3s-34.6-5.5-44.3 9.4L291 122.4c-21.8 33.4-58.9 53.6-98.8 53.6c-12.6 0-24.9-2-36.6-5.8c-.9-.3-1.8-.7-2.7-.9z"
    ]
};
const $d8206b3ab2e65c05$export$5b64b916710da7c7 = {
    prefix: 'fas',
    iconName: 'head-side-virus',
    icon: [
        512,
        512,
        [],
        "e064",
        "M0 224.2C0 100.6 100.2 0 224 0l24 0c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8L448 320l0 64c0 35.3-28.7 64-64 64l-64 0 0 32c0 17.7-14.3 32-32 32L96 512c-17.7 0-32-14.3-32-32l0-72.7c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zM224 64c-8.8 0-16 7.2-16 16c0 33-39.9 49.5-63.2 26.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6C145.5 152.1 129 192 96 192c-8.8 0-16 7.2-16 16s7.2 16 16 16c33 0 49.5 39.9 26.2 63.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C168.1 286.5 208 303 208 336c0 8.8 7.2 16 16 16s16-7.2 16-16c0-33 39.9-49.5 63.2-26.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6C302.5 263.9 319 224 352 224c8.8 0 16-7.2 16-16s-7.2-16-16-16c-33 0-49.5-39.9-26.2-63.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C279.9 129.5 240 113 240 80c0-8.8-7.2-16-16-16zm-24 96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"
    ]
};
const $d8206b3ab2e65c05$export$f504a6909b677146 = {
    prefix: 'fas',
    iconName: 'user-gear',
    icon: [
        640,
        512,
        [
            "user-cog"
        ],
        "f4fe",
        "M224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM178.3 304l91.4 0c11.8 0 23.4 1.2 34.5 3.3c-2.1 18.5 7.4 35.6 21.8 44.8c-16.6 10.6-26.7 31.6-20 53.3c4 12.9 9.4 25.5 16.4 37.6s15.2 23.1 24.4 33c15.7 16.9 39.6 18.4 57.2 8.7l0 .9c0 9.2 2.7 18.5 7.9 26.3L29.7 512C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304zM436 218.2c0-7 4.5-13.3 11.3-14.8c10.5-2.4 21.5-3.7 32.7-3.7s22.2 1.3 32.7 3.7c6.8 1.5 11.3 7.8 11.3 14.8l0 30.6c7.9 3.4 15.4 7.7 22.3 12.8l24.9-14.3c6.1-3.5 13.7-2.7 18.5 2.4c7.6 8.1 14.3 17.2 20.1 27.2s10.3 20.4 13.5 31c2.1 6.7-1.1 13.7-7.2 17.2l-25 14.4c.4 4 .7 8.1 .7 12.3s-.2 8.2-.7 12.3l25 14.4c6.1 3.5 9.2 10.5 7.2 17.2c-3.3 10.6-7.8 21-13.5 31s-12.5 19.1-20.1 27.2c-4.8 5.1-12.5 5.9-18.5 2.4l-24.9-14.3c-6.9 5.1-14.3 9.4-22.3 12.8l0 30.6c0 7-4.5 13.3-11.3 14.8c-10.5 2.4-21.5 3.7-32.7 3.7s-22.2-1.3-32.7-3.7c-6.8-1.5-11.3-7.8-11.3-14.8l0-30.5c-8-3.4-15.6-7.7-22.5-12.9l-24.7 14.3c-6.1 3.5-13.7 2.7-18.5-2.4c-7.6-8.1-14.3-17.2-20.1-27.2s-10.3-20.4-13.5-31c-2.1-6.7 1.1-13.7 7.2-17.2l24.8-14.3c-.4-4.1-.7-8.2-.7-12.4s.2-8.3 .7-12.4L343.8 325c-6.1-3.5-9.2-10.5-7.2-17.2c3.3-10.6 7.7-21 13.5-31s12.5-19.1 20.1-27.2c4.8-5.1 12.4-5.9 18.5-2.4l24.8 14.3c6.9-5.1 14.5-9.4 22.5-12.9l0-30.5zm92.1 133.5a48.1 48.1 0 1 0 -96.1 0 48.1 48.1 0 1 0 96.1 0z"
    ]
};
const $d8206b3ab2e65c05$export$474108c2b86e730e = $d8206b3ab2e65c05$export$f504a6909b677146;
const $d8206b3ab2e65c05$export$bbbff45e04f4abab = {
    prefix: 'fas',
    iconName: 'arrow-up-1-9',
    icon: [
        576,
        512,
        [
            "sort-numeric-up"
        ],
        "f163",
        "M450.7 38c8.3 6 13.3 15.7 13.3 26l0 96 16 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-48 0-48 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l16 0 0-51.6-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16c9.8-3.3 20.5-1.6 28.8 4.4zM160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3 192 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-301.7L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32zM445.7 364.9A32 32 0 1 0 418.3 307a32 32 0 1 0 27.4 57.9zm-40.7 54.9C369.6 408.4 344 375.2 344 336c0-48.6 39.4-88 88-88s88 39.4 88 88c0 23.5-7.5 46.3-21.5 65.2L449.7 467c-10.5 14.2-30.6 17.2-44.8 6.7s-17.2-30.6-6.7-44.8l6.8-9.2z"
    ]
};
const $d8206b3ab2e65c05$export$d213a3ba3cabed48 = $d8206b3ab2e65c05$export$bbbff45e04f4abab;
const $d8206b3ab2e65c05$export$2c79e1a422528bba = {
    prefix: 'fas',
    iconName: 'door-closed',
    icon: [
        576,
        512,
        [
            128682
        ],
        "f52a",
        "M96 64c0-35.3 28.7-64 64-64L416 0c35.3 0 64 28.7 64 64l0 384 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-112 0-288 0L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0L96 64zM384 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
const $d8206b3ab2e65c05$export$bea811bbf570f05a = {
    prefix: 'fas',
    iconName: 'shield-virus',
    icon: [
        512,
        512,
        [],
        "e06c",
        "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM256 112c8.8 0 16 7.2 16 16c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C334.5 200.1 351 240 384 240c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C311.9 334.5 272 351 272 384c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C177.5 311.9 161 272 128 272c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C200.1 177.5 240 161 240 128c0-8.8 7.2-16 16-16zM232 256a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm72 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
    ]
};
const $d8206b3ab2e65c05$export$3397c7b4679acccc = {
    prefix: 'fas',
    iconName: 'dice-six',
    icon: [
        448,
        512,
        [
            9861
        ],
        "f526",
        "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm160 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
const $d8206b3ab2e65c05$export$f3858ce1b3218e2 = {
    prefix: 'fas',
    iconName: 'mosquito-net',
    icon: [
        640,
        512,
        [],
        "e52c",
        "M168.8 462.3c-7.9-4-11.1-13.6-7.2-21.5L192 380.2l0-44.2c0-4.2 1.7-8.3 4.7-11.3L256 265.4l0-23.1L139.2 344C87.8 395.3 0 358.9 0 286.3c0-41.1 30.6-75.8 71.4-80.9l159.9-23.9-49.6-41.3c-5.1-4.2-7-11.1-4.9-17.4l13.9-41.7-29-58.1c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l32 64c1.9 3.8 2.2 8.2 .9 12.2l-12.5 37.6L256 160.5l0-22.6c0-14.9 10.1-27.3 23.8-31l0-43.3c0-4.5 3.7-8.2 8.2-8.2s8.2 3.7 8.2 8.2l0 43.3c13.7 3.6 23.8 16.1 23.8 31l0 22.6 45.4-37.8L352.8 85.1c-1.3-4-1-8.4 .9-12.2l32-64c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-29 58.1 13.9 41.7c2.1 6.2 .1 13.1-4.9 17.4l-49.6 41.3 159.9 23.9c22.5 2.8 41.8 14.6 54.7 31.4c-2.7 2.6-5.2 5.4-7.3 8.6c-8.6-12.9-23.3-21.5-40-21.5s-31.4 8.5-40 21.5c-8.6-12.9-23.3-21.5-40-21.5c-21.7 0-40 14.3-45.9 34.1c-10.7 3.2-19.8 10.1-25.9 19.2l-40.2-35 0 23.1 32.4 32.4c-.3 2-.4 4.1-.4 6.2c0 16.7 8.5 31.4 21.5 40c-4 2.6-7.5 5.9-10.6 9.5L320 310.6l0 50c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-50-32 32 0 41.4c0 2.5-.6 4.9-1.7 7.2l-32 64c-4 7.9-13.6 11.1-21.5 7.2zM512 256c8.8 0 16 7.2 16 16l0 16 48 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 48 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 48 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-48 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-48 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-48-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-48-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16 48 0 0-16c0-8.8 7.2-16 16-16zm16 112l48 0 0-48-48 0 0 48zm0 80l48 0 0-48-48 0 0 48zM448 320l0 48 48 0 0-48-48 0zm0 80l0 48 48 0 0-48-48 0z"
    ]
};
const $d8206b3ab2e65c05$export$876f7406f579ec02 = {
    prefix: 'fas',
    iconName: 'file-fragment',
    icon: [
        384,
        512,
        [],
        "e697",
        "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64l-128 0 0-128c0-35.3-28.7-64-64-64L0 320 0 64zm384 64l-128 0L256 0 384 128zM32 352l96 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32z"
    ]
};
const $d8206b3ab2e65c05$export$154e99cb34841765 = {
    prefix: 'fas',
    iconName: 'bridge-water',
    icon: [
        576,
        512,
        [],
        "e4ce",
        "M0 96C0 78.3 14.3 64 32 64l512 0c17.7 0 32 14.3 32 32l0 35.6c0 15.7-12.7 28.4-28.4 28.4c-37.3 0-67.6 30.2-67.6 67.6l0 124.9c-12.9 0-25.8 3.9-36.8 11.7c-18 12.4-40.1 20.3-59.2 20.3c0 0 0 0 0 0l0-.5 0-128c0-53-43-96-96-96s-96 43-96 96l0 128 0 .5c-19 0-41.2-7.9-59.1-20.3c-11.1-7.8-24-11.7-36.9-11.7l0-124.9C96 190.2 65.8 160 28.4 160C12.7 160 0 147.3 0 131.6L0 96zM306.5 389.9C329 405.4 356.5 416 384 416c26.9 0 55.4-10.8 77.4-26.1c0 0 0 0 0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 469.7 417 480 384 480c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7c0 0 0 0 0 0C136.7 405.2 165.1 416 192 416c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
const $d8206b3ab2e65c05$export$2337c975289bdd84 = {
    prefix: 'fas',
    iconName: 'person-booth',
    icon: [
        576,
        512,
        [],
        "f756",
        "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 160 64 0 0-160zm320 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-448zM224 512c17.7 0 32-14.3 32-32l0-160-64 0 0 160c0 17.7 14.3 32 32 32zM320 0c-9.3 0-18.1 4-24.2 11s-8.8 16.3-7.5 25.5l31.2 218.6L288.6 409.7c-3.5 17.3 7.8 34.2 25.1 37.7s34.2-7.8 37.7-25.1l.7-3.6c1.3 16.4 15.1 29.4 31.9 29.4c17.7 0 32-14.3 32-32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-384c0-17.7-14.3-32-32-32L320 0zM112 80A48 48 0 1 0 16 80a48 48 0 1 0 96 0zm0 261.3l0-72.1 4.7 4.7c9 9 21.2 14.1 33.9 14.1l73.4 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-66.7 0-41.6-41.6c-14.3-14.3-33.8-22.4-54-22.4C27.6 160 0 187.6 0 221.6l0 55.7 0 .9L0 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96 32 42.7L96 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-58.7c0-10.4-3.4-20.5-9.6-28.8L112 341.3z"
    ]
};
const $d8206b3ab2e65c05$export$d8724cf433389700 = {
    prefix: 'fas',
    iconName: 'text-width',
    icon: [
        448,
        512,
        [],
        "f035",
        "M64 128l0-32 128 0 0 128-16 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0 0-128 128 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-48c0-26.5-21.5-48-48-48L224 32 48 32C21.5 32 0 53.5 0 80l0 48c0 17.7 14.3 32 32 32s32-14.3 32-32zM9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6l0-32 192 0 0 32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 32-192 0 0-32c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64z"
    ]
};
const $d8206b3ab2e65c05$export$7daa48199dcb2ad1 = {
    prefix: 'fas',
    iconName: 'hat-wizard',
    icon: [
        512,
        512,
        [],
        "f6e8",
        "M64 416L168.6 180.7c15.3-34.4 40.3-63.5 72-83.7l146.9-94c3-1.9 6.5-2.9 10-2.9C407.7 0 416 8.3 416 18.6l0 1.6c0 2.6-.5 5.1-1.4 7.5L354.8 176.9c-1.9 4.7-2.8 9.7-2.8 14.7c0 5.5 1.2 11 3.4 16.1L448 416l-207.1 0 11.8-35.4 40.4-13.5c6.5-2.2 10.9-8.3 10.9-15.2s-4.4-13-10.9-15.2l-40.4-13.5-13.5-40.4C237 276.4 230.9 272 224 272s-13 4.4-15.2 10.9l-13.5 40.4-40.4 13.5C148.4 339 144 345.1 144 352s4.4 13 10.9 15.2l40.4 13.5L207.1 416 64 416zM279.6 141.5c-1.1-3.3-4.1-5.5-7.6-5.5s-6.5 2.2-7.6 5.5l-6.7 20.2-20.2 6.7c-3.3 1.1-5.5 4.1-5.5 7.6s2.2 6.5 5.5 7.6l20.2 6.7 6.7 20.2c1.1 3.3 4.1 5.5 7.6 5.5s6.5-2.2 7.6-5.5l6.7-20.2 20.2-6.7c3.3-1.1 5.5-4.1 5.5-7.6s-2.2-6.5-5.5-7.6l-20.2-6.7-6.7-20.2zM32 448l448 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
const $d8206b3ab2e65c05$export$8bdfe14ac72a8b17 = {
    prefix: 'fas',
    iconName: 'pen-fancy',
    icon: [
        512,
        512,
        [
            128395,
            10002
        ],
        "f5ac",
        "M373.5 27.1C388.5 9.9 410.2 0 433 0c43.6 0 79 35.4 79 79c0 22.8-9.9 44.6-27.1 59.6L277.7 319l-10.3-10.3-64-64L193 234.3 373.5 27.1zM170.3 256.9l10.4 10.4 64 64 10.4 10.4-19.2 83.4c-3.9 17.1-16.9 30.7-33.8 35.4L24.3 510.3l95.4-95.4c2.6 .7 5.4 1.1 8.3 1.1c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32c0 2.9 .4 5.6 1.1 8.3L1.7 487.6 51.5 310c4.7-16.9 18.3-29.9 35.4-33.8l83.4-19.2z"
    ]
};
const $d8206b3ab2e65c05$export$f4d483fca19a4604 = {
    prefix: 'fas',
    iconName: 'person-digging',
    icon: [
        576,
        512,
        [
            "digging"
        ],
        "f85e",
        "M208 64a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM9.8 214.8c5.1-12.2 19.1-18 31.4-12.9L60.7 210l22.9-38.1C99.9 144.6 129.3 128 161 128c51.4 0 97 32.9 113.3 81.7l34.6 103.7 79.3 33.1 34.2-45.6c6.4-8.5 16.6-13.3 27.2-12.8s20.3 6.4 25.8 15.5l96 160c5.9 9.9 6.1 22.2 .4 32.2s-16.3 16.2-27.8 16.2l-256 0c-11.1 0-21.4-5.7-27.2-15.2s-6.4-21.2-1.4-31.1l16-32c5.4-10.8 16.5-17.7 28.6-17.7l32 0 22.5-30L22.8 246.2c-12.2-5.1-18-19.1-12.9-31.4zm82.8 91.8l112 48c11.8 5 19.4 16.6 19.4 29.4l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-74.9-60.6-26-37 111c-5.6 16.8-23.7 25.8-40.5 20.2S-3.9 486.6 1.6 469.9l48-144 11-33 32 13.7z"
    ]
};
const $d8206b3ab2e65c05$export$7bd93e3343bd5671 = $d8206b3ab2e65c05$export$f4d483fca19a4604;
const $d8206b3ab2e65c05$export$ed8c149a0ea54bb4 = {
    prefix: 'fas',
    iconName: 'trash',
    icon: [
        448,
        512,
        [],
        "f1f8",
        "M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"
    ]
};
const $d8206b3ab2e65c05$export$f3a0a4e6723a86d4 = {
    prefix: 'fas',
    iconName: 'gauge-simple',
    icon: [
        512,
        512,
        [
            "gauge-simple-med",
            "tachometer-average"
        ],
        "f629",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-26.9-16.5-49.9-40-59.3L280 88c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 204.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64s64-28.7 64-64z"
    ]
};
const $d8206b3ab2e65c05$export$ba8c12ff7cfa2521 = $d8206b3ab2e65c05$export$f3a0a4e6723a86d4;
const $d8206b3ab2e65c05$export$94fcfd6f6335431b = $d8206b3ab2e65c05$export$f3a0a4e6723a86d4;
const $d8206b3ab2e65c05$export$6feb44fec53ba30d = {
    prefix: 'fas',
    iconName: 'book-medical',
    icon: [
        448,
        512,
        [],
        "f7e6",
        "M0 96C0 43 43 0 96 0L384 0l32 0c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32l0 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0L96 512c-53 0-96-43-96-96L0 96zM64 416c0 17.7 14.3 32 32 32l256 0 0-64L96 384c-17.7 0-32 14.3-32 32zM208 112l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z"
    ]
};
const $d8206b3ab2e65c05$export$dd0ede1713d2d2f9 = {
    prefix: 'fas',
    iconName: 'poo',
    icon: [
        512,
        512,
        [
            128169
        ],
        "f2fe",
        "M268.9 .9c-5.5-.7-11 1.4-14.5 5.7s-4.6 10.1-2.8 15.4c2.8 8.2 4.3 16.9 4.3 26.1c0 44.1-35.7 79.9-79.8 80L160 128c-35.3 0-64 28.7-64 64c0 19.1 8.4 36.3 21.7 48L104 240c-39.8 0-72 32.2-72 72c0 23.2 11 43.8 28 57c-34.1 5.7-60 35.3-60 71c0 39.8 32.2 72 72 72l368 0c39.8 0 72-32.2 72-72c0-35.7-25.9-65.3-60-71c17-13.2 28-33.8 28-57c0-39.8-32.2-72-72-72l-13.7 0c13.3-11.7 21.7-28.9 21.7-48c0-35.3-28.7-64-64-64l-5.5 0c3.5-10 5.5-20.8 5.5-32c0-48.6-36.2-88.8-83.1-95.1zM192 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm64 108.3c0 2.4-.7 4.8-2.2 6.7c-8.2 10.5-39.5 45-93.8 45s-85.6-34.6-93.8-45c-1.5-1.9-2.2-4.3-2.2-6.7c0-6.8 5.5-12.3 12.3-12.3l167.4 0c6.8 0 12.3 5.5 12.3 12.3z"
    ]
};
const $d8206b3ab2e65c05$export$54e3a80c9875b74c = {
    prefix: 'fas',
    iconName: 'quote-right',
    icon: [
        448,
        512,
        [
            8221,
            "quote-right-alt"
        ],
        "f10e",
        "M448 296c0 66.3-53.7 120-120 120l-8 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l8 0c30.9 0 56-25.1 56-56l0-8-64 0c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l64 0c35.3 0 64 28.7 64 64l0 32 0 32 0 72zm-256 0c0 66.3-53.7 120-120 120l-8 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l8 0c30.9 0 56-25.1 56-56l0-8-64 0c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l64 0c35.3 0 64 28.7 64 64l0 32 0 32 0 72z"
    ]
};
const $d8206b3ab2e65c05$export$dd692f2e88bd4b1a = $d8206b3ab2e65c05$export$54e3a80c9875b74c;
const $d8206b3ab2e65c05$export$312f2c01c6fedca8 = {
    prefix: 'fas',
    iconName: 'shirt',
    icon: [
        640,
        512,
        [
            128085,
            "t-shirt",
            "tshirt"
        ],
        "f553",
        "M211.8 0c7.8 0 14.3 5.7 16.7 13.2C240.8 51.9 277.1 80 320 80s79.2-28.1 91.5-66.8C413.9 5.7 420.4 0 428.2 0l12.6 0c22.5 0 44.2 7.9 61.5 22.3L628.5 127.4c6.6 5.5 10.7 13.5 11.4 22.1s-2.1 17.1-7.8 23.6l-56 64c-11.4 13.1-31.2 14.6-44.6 3.5L480 197.7 480 448c0 35.3-28.7 64-64 64l-192 0c-35.3 0-64-28.7-64-64l0-250.3-51.5 42.9c-13.3 11.1-33.1 9.6-44.6-3.5l-56-64c-5.7-6.5-8.5-15-7.8-23.6s4.8-16.6 11.4-22.1L137.7 22.3C155 7.9 176.7 0 199.2 0l12.6 0z"
    ]
};
const $d8206b3ab2e65c05$export$144e5f8bc4d705a6 = $d8206b3ab2e65c05$export$312f2c01c6fedca8;
const $d8206b3ab2e65c05$export$36edce3ba87c2b17 = $d8206b3ab2e65c05$export$312f2c01c6fedca8;
const $d8206b3ab2e65c05$export$30523a9441a31e97 = {
    prefix: 'fas',
    iconName: 'cubes',
    icon: [
        576,
        512,
        [],
        "f1b3",
        "M290.8 48.6l78.4 29.7L288 109.5 206.8 78.3l78.4-29.7c1.8-.7 3.8-.7 5.7 0zM136 92.5l0 112.2c-1.3 .4-2.6 .8-3.9 1.3l-96 36.4C14.4 250.6 0 271.5 0 294.7L0 413.9c0 22.2 13.1 42.3 33.5 51.3l96 42.2c14.4 6.3 30.7 6.3 45.1 0L288 457.5l113.5 49.9c14.4 6.3 30.7 6.3 45.1 0l96-42.2c20.3-8.9 33.5-29.1 33.5-51.3l0-119.1c0-23.3-14.4-44.1-36.1-52.4l-96-36.4c-1.3-.5-2.6-.9-3.9-1.3l0-112.2c0-23.3-14.4-44.1-36.1-52.4l-96-36.4c-12.8-4.8-26.9-4.8-39.7 0l-96 36.4C150.4 48.4 136 69.3 136 92.5zM392 210.6l-82.4 31.2 0-89.2L392 121l0 89.6zM154.8 250.9l78.4 29.7L152 311.7 70.8 280.6l78.4-29.7c1.8-.7 3.8-.7 5.7 0zm18.8 204.4l0-100.5L256 323.2l0 95.9-82.4 36.2zM421.2 250.9c1.8-.7 3.8-.7 5.7 0l78.4 29.7L424 311.7l-81.2-31.1 78.4-29.7zM523.2 421.2l-77.6 34.1 0-100.5L528 323.2l0 90.7c0 3.2-1.9 6-4.8 7.3z"
    ]
};
const $d8206b3ab2e65c05$export$89fa217ec5503ac9 = {
    prefix: 'fas',
    iconName: 'divide',
    icon: [
        448,
        512,
        [
            10135,
            247
        ],
        "f529",
        "M272 96a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 320a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM400 288c17.7 0 32-14.3 32-32s-14.3-32-32-32L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l352 0z"
    ]
};
const $d8206b3ab2e65c05$export$c04e864469c1d117 = {
    prefix: 'fas',
    iconName: 'tenge-sign',
    icon: [
        384,
        512,
        [
            8376,
            "tenge"
        ],
        "f7d7",
        "M0 64C0 46.3 14.3 32 32 32l320 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64zM0 192c0-17.7 14.3-32 32-32l160 0 160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-128 0 0 224c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-224L32 224c-17.7 0-32-14.3-32-32z"
    ]
};
const $d8206b3ab2e65c05$export$af6ebee83047b793 = $d8206b3ab2e65c05$export$c04e864469c1d117;
const $d8206b3ab2e65c05$export$ad02dd8ca5816958 = {
    prefix: 'fas',
    iconName: 'headphones',
    icon: [
        512,
        512,
        [
            127911
        ],
        "f025",
        "M256 80C149.9 80 62.4 159.4 49.6 262c9.4-3.8 19.6-6 30.4-6c26.5 0 48 21.5 48 48l0 128c0 26.5-21.5 48-48 48c-44.2 0-80-35.8-80-80l0-16 0-48 0-48C0 146.6 114.6 32 256 32s256 114.6 256 256l0 48 0 48 0 16c0 44.2-35.8 80-80 80c-26.5 0-48-21.5-48-48l0-128c0-26.5 21.5-48 48-48c10.8 0 21 2.1 30.4 6C449.6 159.4 362.1 80 256 80z"
    ]
};
const $d8206b3ab2e65c05$export$96891bbcda1dbb7b = {
    prefix: 'fas',
    iconName: 'hands-holding',
    icon: [
        640,
        512,
        [],
        "f4c2",
        "M80 104c0-22.1-17.9-40-40-40S0 81.9 0 104l0 56 0 64L0 325.5c0 25.5 10.1 49.9 28.1 67.9L128 493.3c12 12 28.3 18.7 45.3 18.7l66.7 0c26.5 0 48-21.5 48-48l0-78.9c0-29.7-11.8-58.2-32.8-79.2l-25.3-25.3c0 0 0 0 0 0l-15.2-15.2-32-32c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l32 32 15.2 15.2c11 11 9.2 29.2-3.7 37.8c-9.7 6.5-22.7 5.2-31-3.1L98.7 309.5c-12-12-18.7-28.3-18.7-45.3L80 224l0-80 0-40zm480 0l0 40 0 80 0 40.2c0 17-6.7 33.3-18.7 45.3l-51.1 51.1c-8.3 8.3-21.3 9.6-31 3.1c-12.9-8.6-14.7-26.9-3.7-37.8l15.2-15.2 32-32c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-32 32-15.2 15.2c0 0 0 0 0 0l-25.3 25.3c-21 21-32.8 49.5-32.8 79.2l0 78.9c0 26.5 21.5 48 48 48l66.7 0c17 0 33.3-6.7 45.3-18.7l99.9-99.9c18-18 28.1-42.4 28.1-67.9L640 224l0-64 0-56c0-22.1-17.9-40-40-40s-40 17.9-40 40z"
    ]
};
const $d8206b3ab2e65c05$export$765c446e974b5e59 = {
    prefix: 'fas',
    iconName: 'hands-clapping',
    icon: [
        512,
        512,
        [],
        "e1a8",
        "M336 16l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16zm-98.7 7.1l32 48c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4l-32-48c-4.9-7.4-2.9-17.3 4.4-22.2s17.3-2.9 22.2 4.4zM135 119c9.4-9.4 24.6-9.4 33.9 0L292.7 242.7c10.1 10.1 27.3 2.9 27.3-11.3l0-39.4c0-17.7 14.3-32 32-32s32 14.3 32 32l0 153.6c0 57.1-30 110-78.9 139.4c-64 38.4-145.8 28.3-198.5-24.4L7 361c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l53 53c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1L23 265c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l93 93c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1L55 185c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l117 117c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1l-93-93c-9.4-9.4-9.4-24.6 0-33.9zM433.1 484.9c-24.2 14.5-50.9 22.1-77.7 23.1c48.1-39.6 76.6-99 76.6-162.4l0-98.1c8.2-.1 16-6.4 16-16l0-39.4c0-17.7 14.3-32 32-32s32 14.3 32 32l0 153.6c0 57.1-30 110-78.9 139.4zM424.9 18.7c7.4 4.9 9.3 14.8 4.4 22.2l-32 48c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2l32-48c4.9-7.4 14.8-9.3 22.2-4.4z"
    ]
};
const $d8206b3ab2e65c05$export$929518bb4b66a588 = {
    prefix: 'fas',
    iconName: 'republican',
    icon: [
        640,
        512,
        [],
        "f75e",
        "M0 192C0 103.6 71.6 32 160 32l224 0c88.4 0 160 71.6 160 160l0 64L0 256l0-64zm415.9-64c-2.4 0-4.7 1.3-5.7 3.4l-12.6 24.6-28.2 4c-2.4 .3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3 .6 4.7 2.5 6s4.6 1.6 6.7 .5l25.2-12.8 25.2 12.8c2.2 1.1 4.8 .9 6.7-.5s3-3.7 2.5-6l-4.8-27.1L466 170.5c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6c-1.1-2.1-3.3-3.4-5.7-3.4zm-138.3 3.4c-1.1-2.1-3.3-3.4-5.7-3.4s-4.7 1.3-5.7 3.4l-12.6 24.6-28.2 4c-2.4 .3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3 .6 4.7 2.5 6s4.6 1.6 6.7 .5l25.2-12.8 25.2 12.8c2.2 1.1 4.8 .9 6.7-.5s3-3.7 2.5-6l-4.8-27.1L322 170.5c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6zM127.9 128c-2.4 0-4.7 1.3-5.7 3.4l-12.6 24.6-28.2 4c-2.4 .3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3 .6 4.7 2.5 6s4.6 1.6 6.7 .5l25.2-12.8 25.2 12.8c2.2 1.1 4.8 .9 6.7-.5s3-3.7 2.5-6l-4.8-27.1L178 170.5c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6c-1.1-2.1-3.3-3.4-5.7-3.4zm.1 160l192 0 96 0 32 0 64 0 32 0 0 32 0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48c0-17.7 14.3-32 32-32s32 14.3 32 32l0 48c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-48-32 0 0 32 0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64-192 0 0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64 0-96 128 0z"
    ]
};
const $d8206b3ab2e65c05$export$b7fac681e7d09400 = {
    prefix: 'fas',
    iconName: 'arrow-left',
    icon: [
        448,
        512,
        [
            8592
        ],
        "f060",
        "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"
    ]
};
const $d8206b3ab2e65c05$export$16c9e0374c346c6e = {
    prefix: 'fas',
    iconName: 'person-circle-xmark',
    icon: [
        576,
        512,
        [],
        "e543",
        "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-223.1L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6l29.7 0c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9 232 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128-16 0zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"
    ]
};
const $d8206b3ab2e65c05$export$8e90575265a56cfc = {
    prefix: 'fas',
    iconName: 'ruler',
    icon: [
        512,
        512,
        [
            128207
        ],
        "f545",
        "M177.9 494.1c-18.7 18.7-49.1 18.7-67.9 0L17.9 401.9c-18.7-18.7-18.7-49.1 0-67.9l50.7-50.7 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 50.7-50.7c18.7-18.7 49.1-18.7 67.9 0l92.1 92.1c18.7 18.7 18.7 49.1 0 67.9L177.9 494.1z"
    ]
};
const $d8206b3ab2e65c05$export$e490f662af4d1c78 = {
    prefix: 'fas',
    iconName: 'align-left',
    icon: [
        448,
        512,
        [],
        "f036",
        "M288 64c0 17.7-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l224 0c17.7 0 32 14.3 32 32zm0 256c0 17.7-14.3 32-32 32L32 352c-17.7 0-32-14.3-32-32s14.3-32 32-32l224 0c17.7 0 32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 224c-17.7 0-32-14.3-32-32zM448 448c0 17.7-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z"
    ]
};
const $d8206b3ab2e65c05$export$64bfd48ed353c031 = {
    prefix: 'fas',
    iconName: 'dice-d6',
    icon: [
        448,
        512,
        [],
        "f6d1",
        "M201 10.3c14.3-7.8 31.6-7.8 46 0L422.3 106c5.1 2.8 8.3 8.2 8.3 14s-3.2 11.2-8.3 14L231.7 238c-4.8 2.6-10.5 2.6-15.3 0L25.7 134c-5.1-2.8-8.3-8.2-8.3-14s3.2-11.2 8.3-14L201 10.3zM23.7 170l176 96c5.1 2.8 8.3 8.2 8.3 14l0 216c0 5.6-3 10.9-7.8 13.8s-10.9 3-15.8 .3L25 423.1C9.6 414.7 0 398.6 0 381L0 184c0-5.6 3-10.9 7.8-13.8s10.9-3 15.8-.3zm400.7 0c5-2.7 11-2.6 15.8 .3s7.8 8.1 7.8 13.8l0 197c0 17.6-9.6 33.7-25 42.1L263.7 510c-5 2.7-11 2.6-15.8-.3s-7.8-8.1-7.8-13.8l0-216c0-5.9 3.2-11.2 8.3-14l176-96z"
    ]
};
const $d8206b3ab2e65c05$export$5fbcef35138741a5 = {
    prefix: 'fas',
    iconName: 'restroom',
    icon: [
        640,
        512,
        [],
        "f7bd",
        "M80 48a48 48 0 1 1 96 0A48 48 0 1 1 80 48zm40 304l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-154.8c-8.1 9.2-21.1 13.2-33.5 9.4c-16.9-5.3-26.3-23.2-21-40.1l30.9-99.1C44.9 155.3 82 128 124 128l8 0c42 0 79.1 27.3 91.6 67.4l30.9 99.1c5.3 16.9-4.1 34.8-21 40.1c-12.4 3.9-25.4-.2-33.5-9.4L200 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128-16 0zM320 0c13.3 0 24 10.7 24 24l0 464c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-464c0-13.3 10.7-24 24-24zM464 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM440 480l0-96-17.8 0c-10.9 0-18.6-10.7-15.2-21.1l9-26.9c-3.2 0-6.4-.5-9.5-1.5c-16.9-5.3-26.3-23.2-21-40.1l29.7-95.2C428.4 156.9 467.6 128 512 128s83.6 28.9 96.8 71.2l29.7 95.2c5.3 16.9-4.1 34.8-21 40.1c-3.2 1-6.4 1.5-9.5 1.5l9 26.9c3.5 10.4-4.3 21.1-15.2 21.1L584 384l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96-16 0 0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32z"
    ]
};
const $d8206b3ab2e65c05$export$bbf24078bd1f73e6 = {
    prefix: 'fas',
    iconName: 'j',
    icon: [
        320,
        512,
        [
            106
        ],
        "4a",
        "M288 32c17.7 0 32 14.3 32 32l0 256c0 88.4-71.6 160-160 160S0 408.4 0 320l0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32c0 53 43 96 96 96s96-43 96-96l0-256c0-17.7 14.3-32 32-32z"
    ]
};
const $d8206b3ab2e65c05$export$72b785dcfe44c69b = {
    prefix: 'fas',
    iconName: 'users-viewfinder',
    icon: [
        640,
        512,
        [],
        "e595",
        "M48 48l88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L32 0C14.3 0 0 14.3 0 32L0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-88zM175.8 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-26.5 32C119.9 256 96 279.9 96 309.3c0 14.7 11.9 26.7 26.7 26.7l56.1 0c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4l-69.3 0zm368 80c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3l-69.3 0c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6l56.1 0zm-89.4 0c-8.6-24.3-29.9-42.6-55.9-47c-3.9-.7-7.9-1-12-1l-80 0c-4.1 0-8.1 .3-12 1c-26 4.4-47.3 22.7-55.9 47c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24zM464 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-80-32a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM504 48l88 0 0 88c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104c0-17.7-14.3-32-32-32L504 0c-13.3 0-24 10.7-24 24s10.7 24 24 24zM48 464l0-88c0-13.3-10.7-24-24-24s-24 10.7-24 24L0 480c0 17.7 14.3 32 32 32l104 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0zm456 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l104 0c17.7 0 32-14.3 32-32l0-104c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 88-88 0z"
    ]
};
const $d8206b3ab2e65c05$export$b44eb38345c6a964 = {
    prefix: 'fas',
    iconName: 'file-video',
    icon: [
        384,
        512,
        [],
        "f1c8",
        "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM64 288c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32l0-96zM300.9 397.9L256 368l0-64 44.9-29.9c2-1.3 4.4-2.1 6.8-2.1c6.8 0 12.3 5.5 12.3 12.3l0 103.4c0 6.8-5.5 12.3-12.3 12.3c-2.4 0-4.8-.7-6.8-2.1z"
    ]
};
const $d8206b3ab2e65c05$export$c1a3ba061b4f60c4 = {
    prefix: 'fas',
    iconName: 'up-right-from-square',
    icon: [
        512,
        512,
        [
            "external-link-alt"
        ],
        "f35d",
        "M352 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9L370.7 96 201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L416 141.3l41.4 41.4c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6l0-128c0-17.7-14.3-32-32-32L352 0zM80 32C35.8 32 0 67.8 0 112L0 432c0 44.2 35.8 80 80 80l320 0c44.2 0 80-35.8 80-80l0-112c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 112c0 8.8-7.2 16-16 16L80 448c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l112 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 32z"
    ]
};
const $d8206b3ab2e65c05$export$d7f107e456ab0306 = $d8206b3ab2e65c05$export$c1a3ba061b4f60c4;
const $d8206b3ab2e65c05$export$c517dffc18db483f = {
    prefix: 'fas',
    iconName: 'table-cells',
    icon: [
        512,
        512,
        [
            "th"
        ],
        "f00a",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm88 64l0 64-88 0 0-64 88 0zm56 0l88 0 0 64-88 0 0-64zm240 0l0 64-88 0 0-64 88 0zM64 224l88 0 0 64-88 0 0-64zm232 0l0 64-88 0 0-64 88 0zm64 0l88 0 0 64-88 0 0-64zM152 352l0 64-88 0 0-64 88 0zm56 0l88 0 0 64-88 0 0-64zm240 0l0 64-88 0 0-64 88 0z"
    ]
};
const $d8206b3ab2e65c05$export$4d383c83efc0c819 = $d8206b3ab2e65c05$export$c517dffc18db483f;
const $d8206b3ab2e65c05$export$38611f1c776aba73 = {
    prefix: 'fas',
    iconName: 'file-pdf',
    icon: [
        512,
        512,
        [],
        "f1c1",
        "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z"
    ]
};
const $d8206b3ab2e65c05$export$df8194b081d34b27 = {
    prefix: 'fas',
    iconName: 'book-bible',
    icon: [
        448,
        512,
        [
            "bible"
        ],
        "f647",
        "M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-64c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L384 0 96 0zm0 384l256 0 0 64L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32zM208 80c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 112c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-112-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z"
    ]
};
const $d8206b3ab2e65c05$export$2eac809b0670d139 = $d8206b3ab2e65c05$export$df8194b081d34b27;
const $d8206b3ab2e65c05$export$9db87eabf605857e = {
    prefix: 'fas',
    iconName: 'o',
    icon: [
        448,
        512,
        [
            111
        ],
        "4f",
        "M224 96a160 160 0 1 0 0 320 160 160 0 1 0 0-320zM448 256A224 224 0 1 1 0 256a224 224 0 1 1 448 0z"
    ]
};
const $d8206b3ab2e65c05$export$25ea11267429d202 = {
    prefix: 'fas',
    iconName: 'suitcase-medical',
    icon: [
        512,
        512,
        [
            "medkit"
        ],
        "f0fa",
        "M184 48l144 0c4.4 0 8 3.6 8 8l0 40L176 96l0-40c0-4.4 3.6-8 8-8zm-56 8l0 40 0 32 0 352 256 0 0-352 0-32 0-40c0-30.9-25.1-56-56-56L184 0c-30.9 0-56 25.1-56 56zM96 96L64 96C28.7 96 0 124.7 0 160L0 416c0 35.3 28.7 64 64 64l32 0L96 96zM416 480l32 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-32 0 0 384zM224 208c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z"
    ]
};
const $d8206b3ab2e65c05$export$e75f02bae5b7d34b = $d8206b3ab2e65c05$export$25ea11267429d202;
const $d8206b3ab2e65c05$export$597826232327559b = {
    prefix: 'fas',
    iconName: 'user-secret',
    icon: [
        448,
        512,
        [
            128373
        ],
        "f21b",
        "M224 16c-6.7 0-10.8-2.8-15.5-6.1C201.9 5.4 194 0 176 0c-30.5 0-52 43.7-66 89.4C62.7 98.1 32 112.2 32 128c0 14.3 25 27.1 64.6 35.9c-.4 4-.6 8-.6 12.1c0 17 3.3 33.2 9.3 48l-59.9 0C38 224 32 230 32 237.4c0 1.7 .3 3.4 1 5l38.8 96.9C28.2 371.8 0 423.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7c0-58.5-28.2-110.4-71.7-143L415 242.4c.6-1.6 1-3.3 1-5c0-7.4-6-13.4-13.4-13.4l-59.9 0c6-14.8 9.3-31 9.3-48c0-4.1-.2-8.1-.6-12.1C391 155.1 416 142.3 416 128c0-15.8-30.7-29.9-78-38.6C324 43.7 302.5 0 272 0c-18 0-25.9 5.4-32.5 9.9c-4.8 3.3-8.8 6.1-15.5 6.1zm56 208l-12.4 0c-16.5 0-31.1-10.6-36.3-26.2c-2.3-7-12.2-7-14.5 0c-5.2 15.6-19.9 26.2-36.3 26.2L168 224c-22.1 0-40-17.9-40-40l0-14.4c28.2 4.1 61 6.4 96 6.4s67.8-2.3 96-6.4l0 14.4c0 22.1-17.9 40-40 40zm-88 96l16 32L176 480 128 288l64 32zm128-32L272 480 240 352l16-32 64-32z"
    ]
};
const $d8206b3ab2e65c05$export$743cce3ca4eb1d7d = {
    prefix: 'fas',
    iconName: 'otter',
    icon: [
        640,
        512,
        [
            129446
        ],
        "f700",
        "M181.5 197.1l12.9 6.4c5.9 3 12.4 4.5 19.1 4.5c23.5 0 42.6-19.1 42.6-42.6l0-21.4c0-35.3-28.7-64-64-64l-64 0c-35.3 0-64 28.7-64 64l0 21.4c0 23.5 19.1 42.6 42.6 42.6c6.6 0 13.1-1.5 19.1-4.5l12.9-6.4 8.4-4.2L135.1 185c-4.5-3-7.1-8-7.1-13.3l0-3.7c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24l0 3.7c0 5.3-2.7 10.3-7.1 13.3l-11.8 7.9 8.4 4.2zm-8.6 49.4L160 240l-12.9 6.4c-12.6 6.3-26.5 9.6-40.5 9.6c-3.6 0-7.1-.2-10.6-.6l0 .6c0 35.3 28.7 64 64 64l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l160 0 0-48 0-16c0-23.7 12.9-44.4 32-55.4c9.4-5.4 20.3-8.6 32-8.6l0-16c0-26.5 21.5-48 48-48c8.8 0 16 7.2 16 16l0 32 0 16 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-99.7c0-48.2-30.8-91-76.6-106.3l-8.5-2.8c-8-2.7-12.6-11.1-10.4-19.3s10.3-13.2 18.6-11.6l19.9 4C576 86.1 640 164.2 640 254.9l0 1.1s0 0 0 0c0 123.7-100.3 224-224 224l-1.1 0L256 480l-.6 0C132 480 32 380 32 256.6l0-.6 0-39.2c-10.1-14.6-16-32.3-16-51.4L16 144l0-1.4C6.7 139.3 0 130.5 0 120c0-13.3 10.7-24 24-24l2.8 0C44.8 58.2 83.3 32 128 32l64 0c44.7 0 83.2 26.2 101.2 64l2.8 0c13.3 0 24 10.7 24 24c0 10.5-6.7 19.3-16 22.6l0 1.4 0 21.4c0 1.4 0 2.8-.1 4.3c12-6.2 25.7-9.6 40.1-9.6l8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-8 0c-13.3 0-24 10.7-24 24l0 8 56.4 0c-15.2 17-24.4 39.4-24.4 64l-32 0c-42.3 0-78.2-27.4-91-65.3c-5.1 .9-10.3 1.3-15.6 1.3c-14.1 0-27.9-3.3-40.5-9.6zM96 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm112 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"
    ]
};
const $d8206b3ab2e65c05$export$27f7383b96c3f4b4 = {
    prefix: 'fas',
    iconName: 'person-dress',
    icon: [
        320,
        512,
        [
            "female"
        ],
        "f182",
        "M160 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM88 384l-17.8 0c-10.9 0-18.6-10.7-15.2-21.1L93.3 248.1 59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l53.6-89.2c20.3-33.7 56.7-54.3 96-54.3l11.6 0c39.3 0 75.7 20.6 96 54.3l53.6 89.2c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9l-33.9-56.3L265 362.9c3.5 10.4-4.3 21.1-15.2 21.1L232 384l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96-16 0 0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96z"
    ]
};
const $d8206b3ab2e65c05$export$70e8e75e61dd7169 = $d8206b3ab2e65c05$export$27f7383b96c3f4b4;
const $d8206b3ab2e65c05$export$7a088030853df12c = {
    prefix: 'fas',
    iconName: 'comment-dollar',
    icon: [
        512,
        512,
        [],
        "f651",
        "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zm20-312l0 13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9l0 13.8c0 11-9 20-20 20s-20-9-20-20l0-14.6c-10.3-2.2-20-5.5-28.2-8.4c0 0 0 0 0 0s0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c0 0 0 0 0 0c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5l0-14c0-11 9-20 20-20s20 9 20 20z"
    ]
};
const $d8206b3ab2e65c05$export$694b7e88782dec12 = {
    prefix: 'fas',
    iconName: 'business-time',
    icon: [
        640,
        512,
        [
            "briefcase-clock"
        ],
        "f64a",
        "M184 48l144 0c4.4 0 8 3.6 8 8l0 40L176 96l0-40c0-4.4 3.6-8 8-8zm-56 8l0 40L64 96C28.7 96 0 124.7 0 160l0 96 192 0 160 0 8.2 0c32.3-39.1 81.1-64 135.8-64c5.4 0 10.7 .2 16 .7l0-32.7c0-35.3-28.7-64-64-64l-64 0 0-40c0-30.9-25.1-56-56-56L184 0c-30.9 0-56 25.1-56 56zM320 352l-96 0c-17.7 0-32-14.3-32-32l0-32L0 288 0 416c0 35.3 28.7 64 64 64l296.2 0C335.1 449.6 320 410.5 320 368c0-5.4 .2-10.7 .7-16l-.7 0zm320 16a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 288c8.8 0 16 7.2 16 16l0 48 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16z"
    ]
};
const $d8206b3ab2e65c05$export$8b00ae94743552ce = $d8206b3ab2e65c05$export$694b7e88782dec12;
const $d8206b3ab2e65c05$export$d2bcaf492dfb3817 = {
    prefix: 'fas',
    iconName: 'table-cells-large',
    icon: [
        512,
        512,
        [
            "th-large"
        ],
        "f009",
        "M448 96l0 128-160 0 0-128 160 0zm0 192l0 128-160 0 0-128 160 0zM224 224L64 224 64 96l160 0 0 128zM64 288l160 0 0 128L64 416l0-128zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z"
    ]
};
const $d8206b3ab2e65c05$export$69782f333e90cdc6 = $d8206b3ab2e65c05$export$d2bcaf492dfb3817;
const $d8206b3ab2e65c05$export$24c764717169f536 = {
    prefix: 'fas',
    iconName: 'book-tanakh',
    icon: [
        448,
        512,
        [
            "tanakh"
        ],
        "f827",
        "M352 0c53 0 96 43 96 96l0 320c0 53-43 96-96 96L64 512l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l0-64c-17.7 0-32-14.3-32-32L0 32C0 14.3 14.3 0 32 0L64 0 352 0zm0 384L96 384l0 64 256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32zM138.7 208l13.9 24-27.7 0 13.9-24zm-13.9-24L97.1 232c-6.2 10.7 1.5 24 13.9 24l55.4 0 27.7 48c6.2 10.7 21.6 10.7 27.7 0l27.7-48 55.4 0c12.3 0 20-13.3 13.9-24l-27.7-48 27.7-48c6.2-10.7-1.5-24-13.9-24l-55.4 0L221.9 64c-6.2-10.7-21.6-10.7-27.7 0l-27.7 48L111 112c-12.3 0-20 13.3-13.9 24l27.7 48zm27.7 0l27.7-48 55.4 0 27.7 48-27.7 48-55.4 0-27.7-48zm0-48l-13.9 24-13.9-24 27.7 0zm41.6-24L208 88l13.9 24-27.7 0zm69.3 24l27.7 0-13.9 24-13.9-24zm13.9 72l13.9 24-27.7 0 13.9-24zm-55.4 48L208 280l-13.9-24 27.7 0z"
    ]
};
const $d8206b3ab2e65c05$export$7fd4a58929315448 = $d8206b3ab2e65c05$export$24c764717169f536;
const $d8206b3ab2e65c05$export$c377f240bb8b5d74 = {
    prefix: 'fas',
    iconName: 'phone-volume',
    icon: [
        512,
        512,
        [
            "volume-control-phone"
        ],
        "f2a0",
        "M280 0C408.1 0 512 103.9 512 232c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184c-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32-72c0-13.3 10.7-24 24-24c75.1 0 136 60.9 136 136c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88c-13.3 0-24-10.7-24-24zM117.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L144 207.3c33.3 70.4 90.3 127.4 160.7 160.7L345 318.7c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C481.8 499.9 466 512 448 512C200.6 512 0 311.4 0 64C0 46 12.1 30.2 29.5 25.4l88-24z"
    ]
};
const $d8206b3ab2e65c05$export$5358d004fa3d3be2 = $d8206b3ab2e65c05$export$c377f240bb8b5d74;
const $d8206b3ab2e65c05$export$ab6f71fd6878da90 = {
    prefix: 'fas',
    iconName: 'hat-cowboy-side',
    icon: [
        640,
        512,
        [],
        "f8c1",
        "M152.7 135.9l-10.4 57.2c6.8-.7 13.6-1.1 20.5-1.1l10.7 0c39.4 0 77.8 12.1 110.1 34.7L562.4 421.8l35.1 24.6c24.4-6 42.5-28.1 42.5-54.4c0-75.8-94.7-126.6-134.6-144.7L474 83.9C468.2 53.8 441.8 32 411.1 32l-2.7 0c-5.6 0-11.1 .7-16.5 2.2L199.2 85.5c-23.9 6.4-42 26-46.5 50.4zM0 384c0 35.3 28.7 64 64 64l480 0L265.3 252.9c-26.9-18.8-58.9-28.9-91.8-28.9l-10.7 0c-60.6 0-116 34.2-143.1 88.4L13.5 325C4.6 342.7 0 362.3 0 382.2L0 384z"
    ]
};
const $d8206b3ab2e65c05$export$1204f2d171424659 = {
    prefix: 'fas',
    iconName: 'clipboard-user',
    icon: [
        384,
        512,
        [],
        "f7f3",
        "M192 0c-41.8 0-77.4 26.7-90.5 64L64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-37.5 0C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM128 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM80 432c0-44.2 35.8-80 80-80l64 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16L96 448c-8.8 0-16-7.2-16-16z"
    ]
};
const $d8206b3ab2e65c05$export$60b41e3581d1739a = {
    prefix: 'fas',
    iconName: 'child',
    icon: [
        320,
        512,
        [],
        "f1ae",
        "M96 64a64 64 0 1 1 128 0A64 64 0 1 1 96 64zm48 320l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-192.2L59.1 321c-9.4 15-29.2 19.4-44.1 10S-4.5 301.9 4.9 287l39.9-63.3C69.7 184 113.2 160 160 160s90.3 24 115.2 63.6L315.1 287c9.4 15 4.9 34.7-10 44.1s-34.7 4.9-44.1-10L240 287.8 240 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96-32 0z"
    ]
};
const $d8206b3ab2e65c05$export$f0f37dbc60110b10 = {
    prefix: 'fas',
    iconName: 'lira-sign',
    icon: [
        320,
        512,
        [
            8356
        ],
        "f195",
        "M112 160.4c0-35.5 28.8-64.4 64.4-64.4c6.9 0 13.8 1.1 20.4 3.3l81.2 27.1c16.8 5.6 34.9-3.5 40.5-20.2s-3.5-34.9-20.2-40.5L217 38.6c-13.1-4.4-26.8-6.6-40.6-6.6C105.5 32 48 89.5 48 160.4L48 192l-16 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l16 0 0 32-16 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l14 0c-2.2 10.5-6.1 20.6-11.7 29.9L4.6 431.5c-5.9 9.9-6.1 22.2-.4 32.2S20.5 480 32 480l256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L88.5 416l.7-1.1c11.6-19.3 18.9-40.7 21.6-62.9L224 352c17.7 0 32-14.3 32-32s-14.3-32-32-32l-112 0 0-32 112 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-112 0 0-31.6z"
    ]
};
const $d8206b3ab2e65c05$export$da3f1730d013e224 = {
    prefix: 'fas',
    iconName: 'satellite',
    icon: [
        512,
        512,
        [
            128752
        ],
        "f7bf",
        "M233 7c-9.4-9.4-24.6-9.4-33.9 0l-96 96c-9.4 9.4-9.4 24.6 0 33.9l89.4 89.4-15.5 15.5C152.3 230.4 124.9 224 96 224c-31.7 0-61.5 7.7-87.8 21.2c-9 4.7-10.3 16.7-3.1 23.8L112.7 376.7 96.3 393.1c-2.6-.7-5.4-1.1-8.3-1.1c-17.7 0-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32c0-2.9-.4-5.6-1.1-8.3l16.4-16.4L242.9 506.9c7.2 7.2 19.2 5.9 23.8-3.1C280.3 477.5 288 447.7 288 416c0-28.9-6.4-56.3-17.8-80.9l15.5-15.5L375 409c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9l-89.4-89.4 55-55c12.5-12.5 12.5-32.8 0-45.3l-48-48c-12.5-12.5-32.8-12.5-45.3 0l-55 55L233 7zm159 351l-72.4-72.4 62.1-62.1L454.1 296 392 358.1zM226.3 192.4L153.9 120 216 57.9l72.4 72.4-62.1 62.1z"
    ]
};
const $d8206b3ab2e65c05$export$1125ac57be52258c = {
    prefix: 'fas',
    iconName: 'plane-lock',
    icon: [
        640,
        512,
        [],
        "e558",
        "M192 93.7C192 59.5 221 0 256 0c36 0 64 59.5 64 93.7l0 84.6 101.8 58.2C418 247.6 416 259.6 416 272l0 24.6c-17.9 10.4-30.3 29.1-31.8 50.9L320 329.1l0 70.9 57.6 43.2c4 3 6.4 7.8 6.4 12.8l0 24 0 18c0 7.8-6.3 14-14 14c-1.3 0-2.6-.2-3.9-.5L256 480 145.9 511.5c-1.3 .4-2.6 .5-3.9 .5c-7.8 0-14-6.3-14-14l0-42c0-5 2.4-9.8 6.4-12.8L192 400l0-70.9-171.6 49C10.2 381.1 0 373.4 0 362.8l0-65.5c0-5.7 3.1-11 8.1-13.9L192 178.3l0-84.6zM528 240c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48z"
    ]
};
const $d8206b3ab2e65c05$export$cb61f447f29887e = {
    prefix: 'fas',
    iconName: 'tag',
    icon: [
        448,
        512,
        [
            127991
        ],
        "f02b",
        "M0 80L0 229.5c0 17 6.7 33.3 18.7 45.3l176 176c25 25 65.5 25 90.5 0L418.7 317.3c25-25 25-65.5 0-90.5l-176-176c-12-12-28.3-18.7-45.3-18.7L48 32C21.5 32 0 53.5 0 80zm112 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $d8206b3ab2e65c05$export$805cd88398a70581 = {
    prefix: 'fas',
    iconName: 'comment',
    icon: [
        512,
        512,
        [
            128489,
            61669
        ],
        "f075",
        "M512 240c0 114.9-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6C73.6 471.1 44.7 480 16 480c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4c0 0 0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.3-.3c.3-.3 .7-.7 1.3-1.4c1.1-1.2 2.8-3.1 4.9-5.7c4.1-5 9.6-12.4 15.2-21.6c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208z"
    ]
};
const $d8206b3ab2e65c05$export$e4019fe302a972e1 = {
    prefix: 'fas',
    iconName: 'cake-candles',
    icon: [
        448,
        512,
        [
            127874,
            "birthday-cake",
            "cake"
        ],
        "f1fd",
        "M86.4 5.5L61.8 47.6C58 54.1 56 61.6 56 69.2L56 72c0 22.1 17.9 40 40 40s40-17.9 40-40l0-2.8c0-7.6-2-15-5.8-21.6L105.6 5.5C103.6 2.1 100 0 96 0s-7.6 2.1-9.6 5.5zm128 0L189.8 47.6c-3.8 6.5-5.8 14-5.8 21.6l0 2.8c0 22.1 17.9 40 40 40s40-17.9 40-40l0-2.8c0-7.6-2-15-5.8-21.6L233.6 5.5C231.6 2.1 228 0 224 0s-7.6 2.1-9.6 5.5zM317.8 47.6c-3.8 6.5-5.8 14-5.8 21.6l0 2.8c0 22.1 17.9 40 40 40s40-17.9 40-40l0-2.8c0-7.6-2-15-5.8-21.6L361.6 5.5C359.6 2.1 356 0 352 0s-7.6 2.1-9.6 5.5L317.8 47.6zM128 176c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 48c-35.3 0-64 28.7-64 64l0 71c8.3 5.2 18.1 9 28.8 9c13.5 0 27.2-6.1 38.4-13.4c5.4-3.5 9.9-7.1 13-9.7c1.5-1.3 2.7-2.4 3.5-3.1c.4-.4 .7-.6 .8-.8l.1-.1s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c3.1-3.2 7.4-4.9 11.9-4.8s8.6 2.1 11.6 5.4c0 0 0 0 0 0s0 0 0 0l.1 .1c.1 .1 .4 .4 .7 .7c.7 .7 1.7 1.7 3.1 3c2.8 2.6 6.8 6.1 11.8 9.5c10.2 7.1 23 13.1 36.3 13.1s26.1-6 36.3-13.1c5-3.5 9-6.9 11.8-9.5c1.4-1.3 2.4-2.3 3.1-3c.3-.3 .6-.6 .7-.7l.1-.1c3-3.5 7.4-5.4 12-5.4s9 2 12 5.4l.1 .1c.1 .1 .4 .4 .7 .7c.7 .7 1.7 1.7 3.1 3c2.8 2.6 6.8 6.1 11.8 9.5c10.2 7.1 23 13.1 36.3 13.1s26.1-6 36.3-13.1c5-3.5 9-6.9 11.8-9.5c1.4-1.3 2.4-2.3 3.1-3c.3-.3 .6-.6 .7-.7l.1-.1c2.9-3.4 7.1-5.3 11.6-5.4s8.7 1.6 11.9 4.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0l.1 .1c.2 .2 .4 .4 .8 .8c.8 .7 1.9 1.8 3.5 3.1c3.1 2.6 7.5 6.2 13 9.7c11.2 7.3 24.9 13.4 38.4 13.4c10.7 0 20.5-3.9 28.8-9l0-71c0-35.3-28.7-64-64-64l0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 48-64 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 48-64 0 0-48zM448 394.6c-8.5 3.3-18.2 5.4-28.8 5.4c-22.5 0-42.4-9.9-55.8-18.6c-4.1-2.7-7.8-5.4-10.9-7.8c-2.8 2.4-6.1 5-9.8 7.5C329.8 390 310.6 400 288 400s-41.8-10-54.6-18.9c-3.5-2.4-6.7-4.9-9.4-7.2c-2.7 2.3-5.9 4.7-9.4 7.2C201.8 390 182.6 400 160 400s-41.8-10-54.6-18.9c-3.7-2.6-7-5.2-9.8-7.5c-3.1 2.4-6.8 5.1-10.9 7.8C71.2 390.1 51.3 400 28.8 400c-10.6 0-20.3-2.2-28.8-5.4L0 480c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-85.4z"
    ]
};
const $d8206b3ab2e65c05$export$bdcf98f725a7241a = $d8206b3ab2e65c05$export$e4019fe302a972e1;
const $d8206b3ab2e65c05$export$707bc1c80c0177c1 = $d8206b3ab2e65c05$export$e4019fe302a972e1;
const $d8206b3ab2e65c05$export$6f095630677adc = {
    prefix: 'fas',
    iconName: 'envelope',
    icon: [
        512,
        512,
        [
            128386,
            9993,
            61443
        ],
        "f0e0",
        "M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48L48 64zM0 176L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-208L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z"
    ]
};
const $d8206b3ab2e65c05$export$152ef92a4f9d80a7 = {
    prefix: 'fas',
    iconName: 'angles-up',
    icon: [
        448,
        512,
        [
            "angle-double-up"
        ],
        "f102",
        "M246.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L224 109.3 361.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160zm160 352l-160-160c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L224 301.3 361.4 438.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3z"
    ]
};
const $d8206b3ab2e65c05$export$9bb51e1a2c07db7c = $d8206b3ab2e65c05$export$152ef92a4f9d80a7;
const $d8206b3ab2e65c05$export$4b24ca1552f410af = {
    prefix: 'fas',
    iconName: 'paperclip',
    icon: [
        448,
        512,
        [
            128206
        ],
        "f0c6",
        "M364.2 83.8c-24.4-24.4-64-24.4-88.4 0l-184 184c-42.1 42.1-42.1 110.3 0 152.4s110.3 42.1 152.4 0l152-152c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-152 152c-64 64-167.6 64-231.6 0s-64-167.6 0-231.6l184-184c46.3-46.3 121.3-46.3 167.6 0s46.3 121.3 0 167.6l-176 176c-28.6 28.6-75 28.6-103.6 0s-28.6-75 0-103.6l144-144c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-144 144c-6.7 6.7-6.7 17.7 0 24.4s17.7 6.7 24.4 0l176-176c24.4-24.4 24.4-64 0-88.4z"
    ]
};
const $d8206b3ab2e65c05$export$e201217e5046cd15 = {
    prefix: 'fas',
    iconName: 'arrow-right-to-city',
    icon: [
        640,
        512,
        [],
        "e4b3",
        "M288 48c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 144 40 0 0-72c0-13.3 10.7-24 24-24s24 10.7 24 24l0 72 24 0c26.5 0 48 21.5 48 48l0 224c0 26.5-21.5 48-48 48l-160 0-96 0c-26.5 0-48-21.5-48-48l0-416zm64 32l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM352 272l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm176-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM512 368l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM166.6 153.4l80 80c12.5 12.5 12.5 32.8 0 45.3l-80 80c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L146.7 288 32 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l114.7 0-25.4-25.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0z"
    ]
};
const $d8206b3ab2e65c05$export$838459d11f3971df = {
    prefix: 'fas',
    iconName: 'ribbon',
    icon: [
        448,
        512,
        [
            127895
        ],
        "f4d6",
        "M333.2 322.8s0 0 0 0l-133.9-146s0 0 0 0L146 118.6c7.8-5.1 37-22.6 78-22.6s70.2 17.4 78 22.6L245.7 180l85.6 93.4 27.4-29.8c16.3-17.7 25.3-40.9 25.3-65l0-29.5c0-19-5.6-37.5-16.1-53.3L327.8 35.6C312.9 13.4 287.9 0 261.2 0l-76 0c-25.8 0-50.1 12.5-65.1 33.5L81.9 87C70.3 103.2 64 122.8 64 142.8L64 164c0 23.2 8.4 45.6 23.6 63.1l56 64.2s0 0 0 0l83.3 95.6s0 0 0 0l91.8 105.3c10 11.5 26.8 14.3 40 6.8l54.5-31.1c17.8-10.2 21.6-34.3 7.7-49.4l-87.7-95.7zM205.2 410.6l-83.3-95.6L27.1 418.5c-13.9 15.1-10.1 39.2 7.7 49.4l55.1 31.5c13 7.4 29.3 4.9 39.4-6.1l75.9-82.6z"
    ]
};
const $d8206b3ab2e65c05$export$ba9b387e84727819 = {
    prefix: 'fas',
    iconName: 'lungs',
    icon: [
        640,
        512,
        [
            129729
        ],
        "f604",
        "M320 0c17.7 0 32 14.3 32 32l0 132.1c0 16.4 8.4 31.7 22.2 40.5l9.8 6.2 0-45.5C384 127 415 96 453.3 96c21.7 0 42.8 10.2 55.8 28.8c15.4 22.1 44.3 65.4 71 116.9c26.5 50.9 52.4 112.5 59.6 170.3c.2 1.3 .2 2.6 .2 4l0 7c0 49.1-39.8 89-89 89c-7.3 0-14.5-.9-21.6-2.7l-72.7-18.2C414 480.5 384 442.1 384 398l0-73 90.5 57.6c7.5 4.7 17.3 2.5 22.1-4.9s2.5-17.3-4.9-22.1L384 287.1l0-.4-44.1-28.1c-7.3-4.6-13.9-10.1-19.9-16.1c-5.9 6-12.6 11.5-19.9 16.1L256 286.7 161.2 347l-13.5 8.6c0 0 0 0-.1 0c-7.4 4.8-9.6 14.6-4.8 22.1c4.7 7.5 14.6 9.7 22.1 4.9l91.1-58 0 73.4c0 44.1-30 82.5-72.7 93.1l-72.7 18.2c-7.1 1.8-14.3 2.7-21.6 2.7c-49.1 0-89-39.8-89-89l0-7c0-1.3 .1-2.7 .2-4c7.2-57.9 33.1-119.4 59.6-170.3c26.8-51.5 55.6-94.8 71-116.9c13-18.6 34-28.8 55.8-28.8C225 96 256 127 256 165.3l0 45.5 9.8-6.2c13.8-8.8 22.2-24.1 22.2-40.5L288 32c0-17.7 14.3-32 32-32z"
    ]
};
const $d8206b3ab2e65c05$export$25218e5886296cb9 = {
    prefix: 'fas',
    iconName: 'arrow-up-9-1',
    icon: [
        576,
        512,
        [
            "sort-numeric-up-alt"
        ],
        "f887",
        "M160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3 192 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-301.7L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32zM450.7 294c8.3 6 13.3 15.7 13.3 26l0 96 16 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-48 0-48 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l16 0 0-51.6-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16c9.8-3.3 20.5-1.6 28.8 4.4zm-5-145.1A32 32 0 1 0 418.3 91a32 32 0 1 0 27.4 57.9zm-40.7 54.9C369.6 192.4 344 159.2 344 120c0-48.6 39.4-88 88-88s88 39.4 88 88c0 23.5-7.5 46.3-21.5 65.2L449.7 251c-10.5 14.2-30.6 17.2-44.8 6.7s-17.2-30.6-6.7-44.8l6.8-9.2z"
    ]
};
const $d8206b3ab2e65c05$export$d41859f1bbb9e086 = $d8206b3ab2e65c05$export$25218e5886296cb9;
const $d8206b3ab2e65c05$export$4a157bd81dcd8d80 = {
    prefix: 'fas',
    iconName: 'litecoin-sign',
    icon: [
        384,
        512,
        [],
        "e1d3",
        "M128 64c0-17.7-14.3-32-32-32S64 46.3 64 64l0 149.6L23.2 225.2c-17 4.9-26.8 22.6-22 39.6s22.6 26.8 39.6 22L64 280.1 64 448c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-224 0 0-154.1 136.8-39.1c17-4.9 26.8-22.6 22-39.6s-22.6-26.8-39.6-22L128 195.3 128 64z"
    ]
};
const $d8206b3ab2e65c05$export$2b488402ec335d97 = {
    prefix: 'fas',
    iconName: 'border-none',
    icon: [
        448,
        512,
        [],
        "f850",
        "M32 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM320 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-320a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM416 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM416 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm192 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM416 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"
    ]
};
const $d8206b3ab2e65c05$export$de462dd5a18e80d4 = {
    prefix: 'fas',
    iconName: 'circle-nodes',
    icon: [
        512,
        512,
        [],
        "e4e2",
        "M418.4 157.9c35.3-8.3 61.6-40 61.6-77.9c0-44.2-35.8-80-80-80c-43.4 0-78.7 34.5-80 77.5L136.2 151.1C121.7 136.8 101.9 128 80 128c-44.2 0-80 35.8-80 80s35.8 80 80 80c12.2 0 23.8-2.7 34.1-7.6L259.7 407.8c-2.4 7.6-3.7 15.8-3.7 24.2c0 44.2 35.8 80 80 80s80-35.8 80-80c0-27.7-14-52.1-35.4-66.4l37.8-207.7zM156.3 232.2c2.2-6.9 3.5-14.2 3.7-21.7l183.8-73.5c3.6 3.5 7.4 6.7 11.6 9.5L317.6 354.1c-5.5 1.3-10.8 3.1-15.8 5.5L156.3 232.2z"
    ]
};
const $d8206b3ab2e65c05$export$ca9e3368f1d9500a = {
    prefix: 'fas',
    iconName: 'parachute-box',
    icon: [
        512,
        512,
        [],
        "f4cd",
        "M383.5 192c.3-5.3 .5-10.6 .5-16c0-51-15.9-96-40.2-127.6C319.5 16.9 288.2 0 256 0s-63.5 16.9-87.8 48.4C143.9 80 128 125 128 176c0 5.4 .2 10.7 .5 16L240 192l0 128-32 0c-7 0-13.7 1.5-19.7 4.2L68.2 192l28.3 0c-.3-5.3-.5-10.6-.5-16c0-64 22.2-121.2 57.1-159.3C62 49.3 18.6 122.6 4.2 173.6C1.5 183.1 9 192 18.9 192l6 0L165.2 346.3c-3.3 6.5-5.2 13.9-5.2 21.7l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96c0-7.8-1.9-15.2-5.2-21.7L487.1 192l6 0c9.9 0 17.4-8.9 14.7-18.4C493.4 122.6 450 49.3 358.9 16.7C393.8 54.8 416 112.1 416 176c0 5.4-.2 10.7-.5 16l28.3 0L323.7 324.2c-6-2.7-12.7-4.2-19.7-4.2l-32 0 0-128 111.5 0z"
    ]
};
const $d8206b3ab2e65c05$export$318208bc30aeebcc = {
    prefix: 'fas',
    iconName: 'indent',
    icon: [
        448,
        512,
        [],
        "f03c",
        "M0 64C0 46.3 14.3 32 32 32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64zM192 192c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32zm32 96l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zM0 448c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32zM127.8 268.6L25.8 347.9C15.3 356.1 0 348.6 0 335.3L0 176.7c0-13.3 15.3-20.8 25.8-12.6l101.9 79.3c8.2 6.4 8.2 18.9 0 25.3z"
    ]
};
const $d8206b3ab2e65c05$export$40cb0a4a3a74dc03 = {
    prefix: 'fas',
    iconName: 'truck-field-un',
    icon: [
        640,
        512,
        [],
        "e58e",
        "M96 32C60.7 32 32 60.7 32 96l0 32c-17.7 0-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32l0 32c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0c0 53 43 96 96 96s96-43 96-96l128 0c0 53 43 96 96 96s96-43 96-96l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-32c0-35.3-28.7-64-64-64l-4.2 0c-.4-1.1-.9-2.1-1.3-3.2L485.7 102c-10.3-23.1-33.2-38-58.5-38l-51.8 0C364.4 44.9 343.7 32 320 32L96 32zm288 96l43.2 0 42.7 96L384 224l0-96zM112 384a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM253.3 135.1l34.7 52 0-43.2c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52 0 43.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM128 144l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
const $d8206b3ab2e65c05$export$b9098a890f61e022 = {
    prefix: 'fas',
    iconName: 'hourglass',
    icon: [
        384,
        512,
        [
            9203,
            62032,
            "hourglass-empty"
        ],
        "f254",
        "M0 32C0 14.3 14.3 0 32 0L64 0 320 0l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 11c0 42.4-16.9 83.1-46.9 113.1L237.3 256l67.9 67.9c30 30 46.9 70.7 46.9 113.1l0 11c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0L64 512l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l0-11c0-42.4 16.9-83.1 46.9-113.1L146.7 256 78.9 188.1C48.9 158.1 32 117.4 32 75l0-11C14.3 64 0 49.7 0 32zM96 64l0 11c0 25.5 10.1 49.9 28.1 67.9L192 210.7l67.9-67.9c18-18 28.1-42.4 28.1-67.9l0-11L96 64zm0 384l192 0 0-11c0-25.5-10.1-49.9-28.1-67.9L192 301.3l-67.9 67.9c-18 18-28.1 42.4-28.1 67.9l0 11z"
    ]
};
const $d8206b3ab2e65c05$export$a2f8176a0161e891 = $d8206b3ab2e65c05$export$b9098a890f61e022;
const $d8206b3ab2e65c05$export$64f9eb99c9749cce = {
    prefix: 'fas',
    iconName: 'mountain',
    icon: [
        512,
        512,
        [
            127956
        ],
        "f6fc",
        "M256 32c12.5 0 24.1 6.4 30.8 17L503.4 394.4c5.6 8.9 8.6 19.2 8.6 29.7c0 30.9-25 55.9-55.9 55.9L55.9 480C25 480 0 455 0 424.1c0-10.5 3-20.8 8.6-29.7L225.2 49c6.6-10.6 18.3-17 30.8-17zm65 192L256 120.4 176.9 246.5l18.3 24.4c6.4 8.5 19.2 8.5 25.6 0l25.6-34.1c6-8.1 15.5-12.8 25.6-12.8l49 0z"
    ]
};
const $d8206b3ab2e65c05$export$9884bf227eeb829 = {
    prefix: 'fas',
    iconName: 'user-doctor',
    icon: [
        448,
        512,
        [
            "user-md"
        ],
        "f0f0",
        "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-96 55.2C54 332.9 0 401.3 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7c0-81-54-149.4-128-171.1l0 50.8c27.6 7.1 48 32.2 48 62l0 40c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l0-24c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 24c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-40c0-29.8 20.4-54.9 48-62l0-57.1c-6-.6-12.1-.9-18.3-.9l-91.4 0c-6.2 0-12.3 .3-18.3 .9l0 65.4c23.1 6.9 40 28.3 40 53.7c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7l0-59.1zM144 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
const $d8206b3ab2e65c05$export$ab0d33a2c03f1794 = $d8206b3ab2e65c05$export$9884bf227eeb829;
const $d8206b3ab2e65c05$export$317f99f46b39906e = {
    prefix: 'fas',
    iconName: 'circle-info',
    icon: [
        512,
        512,
        [
            "info-circle"
        ],
        "f05a",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336l24 0 0-64-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $d8206b3ab2e65c05$export$aa9288aeadf882fa = $d8206b3ab2e65c05$export$317f99f46b39906e;
const $d8206b3ab2e65c05$export$5d120e8b87ad33f4 = {
    prefix: 'fas',
    iconName: 'cloud-meatball',
    icon: [
        512,
        512,
        [],
        "f73b",
        "M0 224c0 53 43 96 96 96l44.7 0c9.5-23.5 32.5-40 59.3-40c2 0 3.9 .1 5.8 .3C217.6 265.5 235.7 256 256 256s38.4 9.5 50.2 24.3c1.9-.2 3.9-.3 5.8-.3c26.9 0 49.9 16.5 59.3 40l44.7 0c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112c0 7.1 .7 14.1 1.9 20.8C27.6 145.4 0 181.5 0 224zm288 96c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 1 .1 2.1 .1 3.1c-.7-.8-1.4-1.6-2.1-2.3c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3c.7 .7 1.5 1.4 2.3 2.1c-1-.1-2.1-.1-3.1-.1c-17.7 0-32 14.3-32 32s14.3 32 32 32c1 0 2.1-.1 3.1-.1c-.8 .7-1.6 1.3-2.3 2.1c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0c.7-.7 1.4-1.5 2.1-2.3c-.1 1-.1 2.1-.1 3.1c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1-.1-2.1-.1-3.1c.7 .8 1.3 1.6 2.1 2.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3c-.7-.7-1.5-1.4-2.3-2.1c1 .1 2.1 .1 3.1 .1c17.7 0 32-14.3 32-32s-14.3-32-32-32c-1 0-2.1 .1-3.1 .1c.8-.7 1.6-1.3 2.3-2.1c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-.7 .7-1.4 1.5-2.1 2.3c.1-1 .1-2.1 .1-3.1zM48 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm416 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    ]
};
const $d8206b3ab2e65c05$export$84ffbd7161ca2008 = {
    prefix: 'fas',
    iconName: 'camera',
    icon: [
        512,
        512,
        [
            62258,
            "camera-alt"
        ],
        "f030",
        "M149.1 64.8L138.7 96 64 96C28.7 96 0 124.7 0 160L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-74.7 0L362.9 64.8C356.4 45.2 338.1 32 317.4 32L194.6 32c-20.7 0-39 13.2-45.5 32.8zM256 192a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
    ]
};
const $d8206b3ab2e65c05$export$8872b5664e88e793 = $d8206b3ab2e65c05$export$84ffbd7161ca2008;
const $d8206b3ab2e65c05$export$f9409a7b020dbec4 = {
    prefix: 'fas',
    iconName: 'square-virus',
    icon: [
        448,
        512,
        [],
        "e578",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM223.8 93.7c13.3 0 24 10.7 24 24c0 29.3 35.4 43.9 56.1 23.2c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-20.7 20.7-6 56.1 23.2 56.1c13.3 0 24 10.7 24 24s-10.7 24-24 24c-29.3 0-43.9 35.4-23.2 56.1c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-20.7-20.7-56.1-6-56.1 23.2c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-29.3-35.4-43.9-56.1-23.2c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9c20.7-20.7 6-56.1-23.2-56.1c-13.3 0-24-10.7-24-24s10.7-24 24-24c29.3 0 43.9-35.4 23.2-56.1c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0c20.7 20.7 56.1 6 56.1-23.2c0-13.3 10.7-24 24-24zM192 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm88 32a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
    ]
};
const $d8206b3ab2e65c05$export$1439f0d6365138da = {
    prefix: 'fas',
    iconName: 'meteor',
    icon: [
        512,
        512,
        [
            9732
        ],
        "f753",
        "M493.7 .9L299.4 75.6l2.3-29.3c1-12.8-12.8-21.5-24-15.1L101.3 133.4C38.6 169.7 0 236.6 0 309C0 421.1 90.9 512 203 512c72.4 0 139.4-38.6 175.7-101.3L480.8 234.3c6.5-11.1-2.2-25-15.1-24l-29.3 2.3L511.1 18.3c.6-1.5 .9-3.2 .9-4.8C512 6 506 0 498.5 0c-1.7 0-3.3 .3-4.8 .9zM192 192a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm16 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
const $d8206b3ab2e65c05$export$d901d50df5cf8d91 = {
    prefix: 'fas',
    iconName: 'car-on',
    icon: [
        512,
        512,
        [],
        "e4dd",
        "M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80zM185.8 224l140.3 0c6.8 0 12.8 4.3 15.1 10.6L360.3 288l-208.6 0 19.1-53.4c2.3-6.4 8.3-10.6 15.1-10.6zm-75.3-10.9L82.2 292.4C62.1 300.9 48 320.8 48 344l0 40 0 64 0 32c0 17.7 14.3 32 32 32l16 0c17.7 0 32-14.3 32-32l0-32 256 0 0 32c0 17.7 14.3 32 32 32l16 0c17.7 0 32-14.3 32-32l0-32 0-64 0-40c0-23.2-14.1-43.1-34.2-51.6l-28.3-79.3C390.1 181.3 360 160 326.2 160l-140.3 0c-33.8 0-64 21.3-75.3 53.1zM128 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm232 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM39 39c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L73 39c-9.4-9.4-24.6-9.4-33.9 0zm400 0L391 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z"
    ]
};
const $d8206b3ab2e65c05$export$26a8fd1143d2d6c0 = {
    prefix: 'fas',
    iconName: 'sleigh',
    icon: [
        640,
        512,
        [],
        "f7cc",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l0 160c0 53 43 96 96 96l0 32 64 0 0-32 192 0 0 32 64 0 0-32c53 0 96-43 96-96l0-96c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0-32 0c-17.7 0-32 14.3-32 32l0 41.3c0 30.2-24.5 54.7-54.7 54.7c-75.5 0-145.6-38.9-185.6-102.9l-4.3-6.9C174.2 67.6 125 37.6 70.7 32.7c-2.2-.5-4.4-.7-6.7-.7l-9 0L32 32zM640 384c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 8c0 13.3-10.7 24-24 24L64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l488 0c48.6 0 88-39.4 88-88l0-8z"
    ]
};
const $d8206b3ab2e65c05$export$9a40d582bd4628fb = {
    prefix: 'fas',
    iconName: 'arrow-down-1-9',
    icon: [
        576,
        512,
        [
            "sort-numeric-asc",
            "sort-numeric-down"
        ],
        "f162",
        "M450.7 38c-8.3-6-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2 0 51.6-16 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l48 0 48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0 0-96c0-10.3-4.9-19.9-13.3-26zM160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7 192 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 301.7L95.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C142.5 476.2 151 480 160 480zM418.3 307a32 32 0 1 1 27.4 57.9A32 32 0 1 1 418.3 307zM405.1 419.8l-6.8 9.2c-10.5 14.2-7.5 34.2 6.7 44.8s34.2 7.5 44.8-6.7l48.8-65.8c14-18.9 21.5-41.7 21.5-65.2c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 39.2 25.6 72.4 61.1 83.8z"
    ]
};
const $d8206b3ab2e65c05$export$a4fb1aa2cdfb18d7 = $d8206b3ab2e65c05$export$9a40d582bd4628fb;
const $d8206b3ab2e65c05$export$835db7eb35b3c29b = $d8206b3ab2e65c05$export$9a40d582bd4628fb;
const $d8206b3ab2e65c05$export$b9c3f9a906f96b82 = {
    prefix: 'fas',
    iconName: 'hand-holding-droplet',
    icon: [
        576,
        512,
        [
            "hand-holding-water"
        ],
        "f4c1",
        "M275.5 6.6C278.3 2.5 283 0 288 0s9.7 2.5 12.5 6.6L366.8 103C378 119.3 384 138.6 384 158.3l0 1.7c0 53-43 96-96 96s-96-43-96-96l0-1.7c0-19.8 6-39 17.2-55.3L275.5 6.6zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5L192 512 32 512c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l36.8 0 44.9-36c22.7-18.2 50.9-28 80-28l78.3 0 16 0 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l120.6 0 119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384c0 0 0 0 0 0l-.9 0c.3 0 .6 0 .9 0z"
    ]
};
const $d8206b3ab2e65c05$export$4265371b99d38b95 = $d8206b3ab2e65c05$export$b9c3f9a906f96b82;
const $d8206b3ab2e65c05$export$efaeddad0a6e901b = {
    prefix: 'fas',
    iconName: 'water',
    icon: [
        576,
        512,
        [],
        "f773",
        "M269.5 69.9c11.1-7.9 25.9-7.9 37 0C329 85.4 356.5 96 384 96c26.9 0 55.4-10.8 77.4-26.1c0 0 0 0 0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 149.7 417 160 384 160c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4C42.8 92.6 61 83.5 75.3 71.6c11.1-9.5 27.3-10.1 39.2-1.7c0 0 0 0 0 0C136.7 85.2 165.1 96 192 96c27.5 0 55-10.6 77.5-26.1zm37 288C329 373.4 356.5 384 384 384c26.9 0 55.4-10.8 77.4-26.1c0 0 0 0 0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 437.7 417 448 384 448c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7c0 0 0 0 0 0C136.7 373.2 165.1 384 192 384c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0zm0-144C329 229.4 356.5 240 384 240c26.9 0 55.4-10.8 77.4-26.1c0 0 0 0 0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 293.7 417 304 384 304c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.5 27.3-10.1 39.2-1.7c0 0 0 0 0 0C136.7 229.2 165.1 240 192 240c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
const $d8206b3ab2e65c05$export$5655108e1162ba45 = {
    prefix: 'fas',
    iconName: 'calendar-check',
    icon: [
        448,
        512,
        [],
        "f274",
        "M128 0c17.7 0 32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 48 0c26.5 0 48 21.5 48 48l0 48L0 160l0-48C0 85.5 21.5 64 48 64l48 0 0-32c0-17.7 14.3-32 32-32zM0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192zM329 305c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-95 95-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L329 305z"
    ]
};
const $d8206b3ab2e65c05$export$983e9c27cac7ed1c = {
    prefix: 'fas',
    iconName: 'braille',
    icon: [
        640,
        512,
        [],
        "f2a1",
        "M0 96a64 64 0 1 1 128 0A64 64 0 1 1 0 96zM224 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM80 416a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM0 416a64 64 0 1 1 128 0A64 64 0 1 1 0 416zm240 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM64 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM224 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM352 96a64 64 0 1 1 128 0A64 64 0 1 1 352 96zm240 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0A64 64 0 1 1 512 96zm64 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm16 224a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM416 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm16 224a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"
    ]
};
const $d8206b3ab2e65c05$export$99cfe064ff0b71c9 = {
    prefix: 'fas',
    iconName: 'prescription-bottle-medical',
    icon: [
        384,
        512,
        [
            "prescription-bottle-alt"
        ],
        "f486",
        "M0 32C0 14.3 14.3 0 32 0L352 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64L0 32zm32 96l320 0 0 320c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-320zM160 240l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z"
    ]
};
const $d8206b3ab2e65c05$export$65d1c884b8581d1a = $d8206b3ab2e65c05$export$99cfe064ff0b71c9;
const $d8206b3ab2e65c05$export$2bebc54c51db6505 = {
    prefix: 'fas',
    iconName: 'landmark',
    icon: [
        512,
        512,
        [
            127963
        ],
        "f66f",
        "M240.1 4.2c9.8-5.6 21.9-5.6 31.8 0l171.8 98.1L448 104l0 .9 47.9 27.4c12.6 7.2 18.8 22 15.1 36s-16.4 23.8-30.9 23.8L32 192c-14.5 0-27.2-9.8-30.9-23.8s2.5-28.8 15.1-36L64 104.9l0-.9 4.4-1.6L240.1 4.2zM64 224l64 0 0 192 40 0 0-192 64 0 0 192 48 0 0-192 64 0 0 192 40 0 0-192 64 0 0 196.3c.6 .3 1.2 .7 1.8 1.1l48 32c11.7 7.8 17 22.4 12.9 35.9S494.1 512 480 512L32 512c-14.1 0-26.5-9.2-30.6-22.7s1.1-28.1 12.9-35.9l48-32c.6-.4 1.2-.7 1.8-1.1L64 224z"
    ]
};
const $d8206b3ab2e65c05$export$d7895f386f8bd8b8 = {
    prefix: 'fas',
    iconName: 'truck',
    icon: [
        640,
        512,
        [
            128666,
            9951
        ],
        "f0d1",
        "M48 0C21.5 0 0 21.5 0 48L0 368c0 26.5 21.5 48 48 48l16 0c0 53 43 96 96 96s96-43 96-96l128 0c0 53 43 96 96 96s96-43 96-96l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-64 0-32 0-18.7c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7L416 96l0-48c0-26.5-21.5-48-48-48L48 0zM416 160l50.7 0L544 237.3l0 18.7-128 0 0-96zM112 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
const $d8206b3ab2e65c05$export$721c101130c40043 = {
    prefix: 'fas',
    iconName: 'crosshairs',
    icon: [
        512,
        512,
        [],
        "f05b",
        "M256 0c17.7 0 32 14.3 32 32l0 10.4c93.7 13.9 167.7 88 181.6 181.6l10.4 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-10.4 0c-13.9 93.7-88 167.7-181.6 181.6l0 10.4c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-10.4C130.3 455.7 56.3 381.7 42.4 288L32 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l10.4 0C56.3 130.3 130.3 56.3 224 42.4L224 32c0-17.7 14.3-32 32-32zM107.4 288c12.5 58.3 58.4 104.1 116.6 116.6l0-20.6c0-17.7 14.3-32 32-32s32 14.3 32 32l0 20.6c58.3-12.5 104.1-58.4 116.6-116.6L384 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l20.6 0C392.1 165.7 346.3 119.9 288 107.4l0 20.6c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-20.6C165.7 119.9 119.9 165.7 107.4 224l20.6 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-20.6 0zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $d8206b3ab2e65c05$export$c48422e9da776c1b = {
    prefix: 'fas',
    iconName: 'person-cane',
    icon: [
        448,
        512,
        [],
        "e53c",
        "M272 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-8 187.3l47.4 57.1c11.3 13.6 31.5 15.5 45.1 4.2s15.5-31.5 4.2-45.1l-73.7-88.9c-18.2-22-45.3-34.7-73.9-34.7l-35.9 0c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9 120 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 16 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-244.7zM352 376c0-4.4 3.6-8 8-8s8 3.6 8 8l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-30.9-25.1-56-56-56s-56 25.1-56 56l0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8z"
    ]
};
const $d8206b3ab2e65c05$export$e5075400db564e24 = {
    prefix: 'fas',
    iconName: 'tent',
    icon: [
        576,
        512,
        [],
        "e57d",
        "M269.4 6C280.5-2 295.5-2 306.6 6l224 160c7.4 5.3 12.2 13.5 13.2 22.5l32 288c1 9-1.9 18.1-8 24.9s-14.7 10.7-23.8 10.7l-80 0-28.2 0c-12.1 0-23.2-6.8-28.6-17.7L306.7 293.5c-1.7-3.4-5.1-5.5-8.8-5.5c-5.5 0-9.9 4.4-9.9 9.9L288 480c0 17.7-14.3 32-32 32l-16 0L32 512c-9.1 0-17.8-3.9-23.8-10.7s-9-15.8-8-24.9l32-288c1-9 5.8-17.2 13.2-22.5L269.4 6z"
    ]
};
const $d8206b3ab2e65c05$export$750a64470c2e0f3f = {
    prefix: 'fas',
    iconName: 'vest-patches',
    icon: [
        448,
        512,
        [],
        "e086",
        "M151.2 69.7l55.9 167.7-11 33.1c-2.7 8.2-4.1 16.7-4.1 25.3L192 464c0 14.5 3.9 28.2 10.7 39.9C195 509 185.9 512 176 512L48 512c-26.5 0-48-21.5-48-48L0 270.5c0-9.5 2.8-18.7 8.1-26.6l47.9-71.8c5.3-7.9 8.1-17.1 8.1-26.6L64 128l0-73.7L64 48C64 21.5 85.5 0 112 0l4.5 0c.2 0 .4 0 .6 0c.4 0 .8 0 1.2 0c18.8 0 34.1 9.7 44.1 18.8C171.6 27.2 190.8 40 224 40s52.4-12.8 61.7-21.2C295.7 9.7 311 0 329.7 0c.4 0 .8 0 1.2 0c.2 0 .4 0 .6 0L336 0c26.5 0 48 21.5 48 48l0 6.3 0 73.7 0 17.5c0 9.5 2.8 18.7 8.1 26.6l47.9 71.8c5.3 7.9 8.1 17.1 8.1 26.6L448 464c0 26.5-21.5 48-48 48l-128 0c-26.5 0-48-21.5-48-48l0-168.2c0-5.2 .8-10.3 2.5-15.2L296.8 69.7C279.4 79.7 255.4 88 224 88s-55.4-8.3-72.8-18.3zM96 456a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM63.5 255.5c-4.7 4.7-4.7 12.3 0 17L79 288 63.5 303.5c-4.7 4.7-4.7 12.3 0 17s12.3 4.7 17 0L96 305l15.5 15.5c4.7 4.7 12.3 4.7 17 0s4.7-12.3 0-17L113 288l15.5-15.5c4.7-4.7 4.7-12.3 0-17s-12.3-4.7-17 0L96 271 80.5 255.5c-4.7-4.7-12.3-4.7-17 0zM304 280l0 8 0 32c0 8.8 7.2 16 16 16l32 0 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
    ]
};
const $d8206b3ab2e65c05$export$f178c8c2ad3cc861 = {
    prefix: 'fas',
    iconName: 'check-double',
    icon: [
        448,
        512,
        [],
        "f560",
        "M342.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 178.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l80 80c12.5 12.5 32.8 12.5 45.3 0l160-160zm96 128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 402.7 54.6 297.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l256-256z"
    ]
};
const $d8206b3ab2e65c05$export$43b642fac7053978 = {
    prefix: 'fas',
    iconName: 'arrow-down-a-z',
    icon: [
        576,
        512,
        [
            "sort-alpha-asc",
            "sort-alpha-down"
        ],
        "f15d",
        "M183.6 469.6C177.5 476.2 169 480 160 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L128 365.7 128 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 301.7 32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 320c0-17.7 14.3-32 32-32l128 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9L429.3 416l50.7 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-128 0c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L402.7 352 352 352c-17.7 0-32-14.3-32-32zM416 32c12.1 0 23.2 6.8 28.6 17.7l64 128 16 32c7.9 15.8 1.5 35-14.3 42.9s-35 1.5-42.9-14.3L460.2 224l-88.4 0-7.2 14.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l16-32 64-128C392.8 38.8 403.9 32 416 32zM395.8 176l40.4 0L416 135.6 395.8 176z"
    ]
};
const $d8206b3ab2e65c05$export$cb87697f2fa77cfc = $d8206b3ab2e65c05$export$43b642fac7053978;
const $d8206b3ab2e65c05$export$7658045270aafde3 = $d8206b3ab2e65c05$export$43b642fac7053978;
const $d8206b3ab2e65c05$export$6a4ef2ef77625063 = {
    prefix: 'fas',
    iconName: 'money-bill-wheat',
    icon: [
        512,
        512,
        [],
        "e52a",
        "M176 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80c0-8.8 7.2-16 16-16zM56 16l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L56 64C42.7 64 32 53.3 32 40s10.7-24 24-24zM24 88l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 136c-13.3 0-24-10.7-24-24S10.7 88 24 88zm8 96c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24zM272 16c0-8.8 7.2-16 16-16c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80zM400 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80c0-8.8 7.2-16 16-16zm80 144c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM352 128c8.8 0 16 7.2 16 16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-96 16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM0 304c0-26.5 21.5-48 48-48l416 0c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 304zM48 416l0 48 48 0c0-26.5-21.5-48-48-48zM96 304l-48 0 0 48c26.5 0 48-21.5 48-48zM464 416c-26.5 0-48 21.5-48 48l48 0 0-48zM416 304c0 26.5 21.5 48 48 48l0-48-48 0zm-96 80a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
    ]
};
const $d8206b3ab2e65c05$export$b3e64f5f68c6623f = {
    prefix: 'fas',
    iconName: 'cookie',
    icon: [
        512,
        512,
        [
            127850
        ],
        "f563",
        "M247.2 17c-22.1-3.1-44.6 .9-64.4 11.4l-74 39.5C89.1 78.4 73.2 94.9 63.4 115L26.7 190.6c-9.8 20.1-13 42.9-9.1 64.9l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c22.1 3.1 44.6-.9 64.4-11.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c9.8-20.1 13-42.9 9.1-64.9l-14.6-82.8c-3.9-22.1-14.6-42.3-30.7-57.9L388.9 57.5c-16.1-15.6-36.6-25.6-58.7-28.7L247.2 17zM208 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM144 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $d8206b3ab2e65c05$export$89b706873769c180 = {
    prefix: 'fas',
    iconName: 'arrow-rotate-left',
    icon: [
        512,
        512,
        [
            8634,
            "arrow-left-rotate",
            "arrow-rotate-back",
            "arrow-rotate-backward",
            "undo"
        ],
        "f0e2",
        "M125.7 160l50.3 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L48 224c-17.7 0-32-14.3-32-32L16 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 51.2L97.6 97.6c87.5-87.5 229.3-87.5 316.8 0s87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3s-163.8-62.5-226.3 0L125.7 160z"
    ]
};
const $d8206b3ab2e65c05$export$1aea864c3e1d79b = $d8206b3ab2e65c05$export$89b706873769c180;
const $d8206b3ab2e65c05$export$a34701878babe5fc = $d8206b3ab2e65c05$export$89b706873769c180;
const $d8206b3ab2e65c05$export$fce381d12e4535cd = $d8206b3ab2e65c05$export$89b706873769c180;
const $d8206b3ab2e65c05$export$a5e5ba60b1dfe2b2 = $d8206b3ab2e65c05$export$89b706873769c180;
const $d8206b3ab2e65c05$export$4cb736b866cbb7ec = {
    prefix: 'fas',
    iconName: 'hard-drive',
    icon: [
        512,
        512,
        [
            128436,
            "hdd"
        ],
        "f0a0",
        "M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 184.4c-17-15.2-39.4-24.4-64-24.4L64 256c-24.6 0-47 9.2-64 24.4L0 96zM64 288l384 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64zM320 416a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
const $d8206b3ab2e65c05$export$62551e9c5ba7093f = $d8206b3ab2e65c05$export$4cb736b866cbb7ec;
const $d8206b3ab2e65c05$export$8ff56f5ebb8416a0 = {
    prefix: 'fas',
    iconName: 'face-grin-squint-tears',
    icon: [
        512,
        512,
        [
            129315,
            "grin-squint-tears"
        ],
        "f586",
        "M426.8 14.2C446-5 477.5-4.6 497.1 14.9s20 51 .7 70.3c-6.8 6.8-21.4 12.4-37.4 16.7c-16.3 4.4-34.1 7.5-46.3 9.3c-1.6 .2-3.1 .5-4.6 .6c-4.9 .8-9.1-2.8-9.5-7.4c-.1-.7 0-1.4 .1-2.1c1.6-11.2 4.6-29.6 9-47c.3-1.3 .7-2.6 1-3.9c4.3-15.9 9.8-30.5 16.7-37.4zm-44.7 19c-1.5 4.8-2.9 9.6-4.1 14.3c-4.8 18.9-8 38.5-9.7 50.3c-4 26.8 18.9 49.7 45.7 45.8c11.9-1.6 31.5-4.8 50.4-9.7c4.7-1.2 9.5-2.5 14.3-4.1C534.2 227.5 520.2 353.8 437 437c-83.2 83.2-209.5 97.2-307.2 41.8c1.5-4.8 2.8-9.6 4-14.3c4.8-18.9 8-38.5 9.7-50.3c4-26.8-18.9-49.7-45.7-45.8c-11.9 1.6-31.5 4.8-50.4 9.7c-4.7 1.2-9.5 2.5-14.3 4.1C-22.2 284.5-8.2 158.2 75 75C158.2-8.3 284.5-22.2 382.2 33.2zM51.5 410.1c18.5-5 38.8-8.3 50.9-10c.4-.1 .7-.1 1-.1c5.1-.2 9.2 4.3 8.4 9.6c-1.7 12.1-5 32.4-10 50.9C97.6 476.4 92 491 85.2 497.8C66 517 34.5 516.6 14.9 497.1s-20-51-.7-70.3c6.8-6.8 21.4-12.4 37.4-16.7zM416.9 209c-4.7-11.9-20.8-11-26.8 .3c-19 35.5-45 70.8-77.5 103.3S244.8 371.1 209.3 390c-11.3 6-12.2 22.1-.3 26.8c57.6 22.9 125.8 11 172.3-35.5s58.4-114.8 35.5-172.3zM87.1 285.1c2 2 4.6 3.2 7.3 3.4l56.1 5.1 5.1 56.1c.3 2.8 1.5 5.4 3.4 7.3c6.3 6.3 17.2 3.6 19.8-4.9l29.7-97.4c3.5-11.6-7.3-22.5-19-19L92 265.3c-8.6 2.6-11.3 13.4-4.9 19.8zM265.3 92l-29.7 97.4c-3.5 11.6 7.3 22.5 19 19l97.4-29.7c8.6-2.6 11.3-13.4 4.9-19.8c-2-2-4.6-3.2-7.3-3.4l-56.1-5.1-5.1-56.1c-.3-2.8-1.5-5.4-3.4-7.3c-6.3-6.3-17.2-3.6-19.8 4.9z"
    ]
};
const $d8206b3ab2e65c05$export$542206d6a85f3b42 = $d8206b3ab2e65c05$export$8ff56f5ebb8416a0;
const $d8206b3ab2e65c05$export$56700074cf37be5c = {
    prefix: 'fas',
    iconName: 'dumbbell',
    icon: [
        640,
        512,
        [],
        "f44b",
        "M96 64c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 160 0 64 0 160c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-64-32 0c-17.7 0-32-14.3-32-32l0-64c-17.7 0-32-14.3-32-32s14.3-32 32-32l0-64c0-17.7 14.3-32 32-32l32 0 0-64zm448 0l0 64 32 0c17.7 0 32 14.3 32 32l0 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 64c0 17.7-14.3 32-32 32l-32 0 0 64c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-160 0-64 0-160c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32zM416 224l0 64-192 0 0-64 192 0z"
    ]
};
const $d8206b3ab2e65c05$export$1f7600fa9fdb3978 = {
    prefix: 'fas',
    iconName: 'rectangle-list',
    icon: [
        576,
        512,
        [
            "list-alt"
        ],
        "f022",
        "M0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM128 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32-128a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-248c-13.3 0-24 10.7-24 24s10.7 24 24 24l224 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-224 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l224 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-224 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l224 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-224 0z"
    ]
};
const $d8206b3ab2e65c05$export$c6327a203ffc65a3 = $d8206b3ab2e65c05$export$1f7600fa9fdb3978;
const $d8206b3ab2e65c05$export$1585b7c3c7109751 = {
    prefix: 'fas',
    iconName: 'tarp-droplet',
    icon: [
        576,
        512,
        [],
        "e57c",
        "M288 160c-35.3 0-64-26.9-64-60c0-24 33.7-70.1 52.2-93.5c6.1-7.7 17.5-7.7 23.6 0C318.3 29.9 352 76 352 100c0 33.1-28.7 60-64 60zM64 128l133.5 0c13.2 37.3 48.7 64 90.5 64s77.4-26.7 90.5-64L512 128c35.3 0 64 28.7 64 64l0 160-128 0c-17.7 0-32 14.3-32 32l0 128L64 512c-35.3 0-64-28.7-64-64L0 192c0-35.3 28.7-64 64-64zM448 512l0-128 128 0L448 512zM96 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
const $d8206b3ab2e65c05$export$5d08d08f88a96aac = {
    prefix: 'fas',
    iconName: 'house-medical-circle-check',
    icon: [
        640,
        512,
        [],
        "e511",
        "M320 368c0 59.5 29.5 112.1 74.8 144l-266.7 0c-35.3 0-64-28.7-64-64l0-160.4-32 0c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L522.1 193.9c-8.5-1.3-17.3-1.9-26.1-1.9c-54.7 0-103.5 24.9-135.8 64L320 256l0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16zm32 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
    ]
};
const $d8206b3ab2e65c05$export$c8cd1786449517d3 = {
    prefix: 'fas',
    iconName: 'person-skiing-nordic',
    icon: [
        576,
        512,
        [
            "skiing-nordic"
        ],
        "f7ca",
        "M336 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM227.2 160c1.9 0 3.8 .1 5.6 .3L201.6 254c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9L291.3 464l-88.5 0 41.1-88.1-32.4-20.3c-7.8-4.9-14.7-10.7-20.6-17.3L132.2 464l-32.4 0 54.2-257.6c4.6-1.5 9-4.1 12.7-7.8l23.1-23.1c9.9-9.9 23.4-15.5 37.5-15.5zM121.4 198.6c.4 .4 .8 .8 1.3 1.2L67 464l-43 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l135.3 0c.5 0 .9 0 1.4 0l158.6 0c.5 0 1 0 1.4 0L504 512c39.8 0 72-32.2 72-72l0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8c0 13.3-10.7 24-24 24l-69.4 0 27.6-179.3c10.5-5.2 17.8-16.1 17.8-28.7c0-17.7-14.3-32-32-32l-21.3 0c-12.9 0-24.6-7.8-29.5-19.7l-6.3-15c-14.6-35.1-44.1-61.9-80.5-73.1l-48.7-15c-11.1-3.4-22.7-5.2-34.4-5.2c-31 0-60.8 12.3-82.7 34.3l-23.1 23.1c-12.5 12.5-12.5 32.8 0 45.3zm308 89.4L402.3 464l-44.4 0 21.6-75.6c5.9-20.6-2.6-42.6-20.7-53.9L302 299l30.9-82.4 5.1 12.3C353 264.7 387.9 288 426.7 288l2.7 0z"
    ]
};
const $d8206b3ab2e65c05$export$6ea48260d7d09b1b = $d8206b3ab2e65c05$export$c8cd1786449517d3;
const $d8206b3ab2e65c05$export$16768a660ae3ca9d = {
    prefix: 'fas',
    iconName: 'calendar-plus',
    icon: [
        448,
        512,
        [],
        "f271",
        "M96 32l0 32L48 64C21.5 64 0 85.5 0 112l0 48 448 0 0-48c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192L0 192 0 464c0 26.5 21.5 48 48 48l352 0c26.5 0 48-21.5 48-48l0-272zM224 248c13.3 0 24 10.7 24 24l0 56 56 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-56 0 0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56-56 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l56 0 0-56c0-13.3 10.7-24 24-24z"
    ]
};
const $d8206b3ab2e65c05$export$9b2dbe133273f284 = {
    prefix: 'fas',
    iconName: 'plane-arrival',
    icon: [
        640,
        512,
        [
            128748
        ],
        "f5af",
        "M.3 166.9L0 68C0 57.7 9.5 50.1 19.5 52.3l35.6 7.9c10.6 2.3 19.2 9.9 23 20L96 128l127.3 37.6L181.8 20.4C178.9 10.2 186.6 0 197.2 0l40.1 0c11.6 0 22.2 6.2 27.9 16.3l109 193.8 107.2 31.7c15.9 4.7 30.8 12.5 43.7 22.8l34.4 27.6c24 19.2 18.1 57.3-10.7 68.2c-41.2 15.6-86.2 18.1-128.8 7L121.7 289.8c-11.1-2.9-21.2-8.7-29.3-16.9L9.5 189.4c-5.9-6-9.3-14.1-9.3-22.5zM32 448l576 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32zm96-80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128-16a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $d8206b3ab2e65c05$export$5ae86b9da9cca3bd = {
    prefix: 'fas',
    iconName: 'circle-left',
    icon: [
        512,
        512,
        [
            61840,
            "arrow-alt-circle-left"
        ],
        "f359",
        "M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM116.7 244.7l112-112c4.6-4.6 11.5-5.9 17.4-3.5s9.9 8.3 9.9 14.8l0 64 96 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-96 0 0 64c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5l-112-112c-6.2-6.2-6.2-16.4 0-22.6z"
    ]
};
const $d8206b3ab2e65c05$export$5460a5b11a24996f = $d8206b3ab2e65c05$export$5ae86b9da9cca3bd;
const $d8206b3ab2e65c05$export$cda326cc3bce41c = {
    prefix: 'fas',
    iconName: 'train-subway',
    icon: [
        448,
        512,
        [
            "subway"
        ],
        "f239",
        "M96 0C43 0 0 43 0 96L0 352c0 48 35.2 87.7 81.1 94.9l-46 46C28.1 499.9 33.1 512 43 512l39.7 0c8.5 0 16.6-3.4 22.6-9.4L160 448l128 0 54.6 54.6c6 6 14.1 9.4 22.6 9.4l39.7 0c10 0 15-12.1 7.9-19.1l-46-46c46-7.1 81.1-46.9 81.1-94.9l0-256c0-53-43-96-96-96L96 0zM64 128c0-17.7 14.3-32 32-32l80 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-80 0c-17.7 0-32-14.3-32-32l0-96zM272 96l80 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-80 0c-17.7 0-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32zM64 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm288-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $d8206b3ab2e65c05$export$4cabc8a12d4e2f9 = $d8206b3ab2e65c05$export$cda326cc3bce41c;
const $d8206b3ab2e65c05$export$dce43b02b3fe0c18 = {
    prefix: 'fas',
    iconName: 'chart-gantt',
    icon: [
        512,
        512,
        [],
        "e0e4",
        "M32 32c17.7 0 32 14.3 32 32l0 336c0 8.8 7.2 16 16 16l400 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L80 480c-44.2 0-80-35.8-80-80L0 64C0 46.3 14.3 32 32 32zm96 96c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32zm96 64l128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zm160 96l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
const $d8206b3ab2e65c05$export$1d2b135cc5a2c852 = {
    prefix: 'fas',
    iconName: 'indian-rupee-sign',
    icon: [
        320,
        512,
        [
            "indian-rupee",
            "inr"
        ],
        "e1bc",
        "M0 64C0 46.3 14.3 32 32 32l64 0 16 0 176 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-56.2 0c9.6 14.4 16.7 30.6 20.7 48l35.6 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-35.6 0c-13.2 58.3-61.9 103.2-122.2 110.9L274.6 422c14.4 10.3 17.7 30.3 7.4 44.6s-30.3 17.7-44.6 7.4L13.4 314C2.1 306-2.7 291.5 1.5 278.2S18.1 256 32 256l80 0c32.8 0 61-19.7 73.3-48L32 208c-17.7 0-32-14.3-32-32s14.3-32 32-32l153.3 0C173 115.7 144.8 96 112 96L96 96 32 96C14.3 96 0 81.7 0 64z"
    ]
};
const $d8206b3ab2e65c05$export$be886a4def17c565 = $d8206b3ab2e65c05$export$1d2b135cc5a2c852;
const $d8206b3ab2e65c05$export$12c6d8b3e052490b = $d8206b3ab2e65c05$export$1d2b135cc5a2c852;
const $d8206b3ab2e65c05$export$c3605731beb92daf = {
    prefix: 'fas',
    iconName: 'crop-simple',
    icon: [
        512,
        512,
        [
            "crop-alt"
        ],
        "f565",
        "M128 32c0-17.7-14.3-32-32-32S64 14.3 64 32l0 32L32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l32 0 0 256c0 35.3 28.7 64 64 64l224 0 0-64-224 0 0-352zM384 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-256c0-35.3-28.7-64-64-64L160 64l0 64 224 0 0 352z"
    ]
};
const $d8206b3ab2e65c05$export$d932915fde4f1010 = $d8206b3ab2e65c05$export$c3605731beb92daf;
const $d8206b3ab2e65c05$export$a312c7d58dd44a75 = {
    prefix: 'fas',
    iconName: 'money-bill-1',
    icon: [
        576,
        512,
        [
            "money-bill-alt"
        ],
        "f3d1",
        "M64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64zm64 320l-64 0 0-64c35.3 0 64 28.7 64 64zM64 192l0-64 64 0c0 35.3-28.7 64-64 64zM448 384c0-35.3 28.7-64 64-64l0 64-64 0zm64-192c-35.3 0-64-28.7-64-64l64 0 0 64zM176 256a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm76-48c0 9.7 6.9 17.7 16 19.6l0 48.4-4 0c-11 0-20 9-20 20s9 20 20 20l24 0 24 0c11 0 20-9 20-20s-9-20-20-20l-4 0 0-68c0-11-9-20-20-20l-16 0c-11 0-20 9-20 20z"
    ]
};
const $d8206b3ab2e65c05$export$a35d573395884c3d = $d8206b3ab2e65c05$export$a312c7d58dd44a75;
const $d8206b3ab2e65c05$export$1db7e2ee10d36035 = {
    prefix: 'fas',
    iconName: 'left-long',
    icon: [
        512,
        512,
        [
            "long-arrow-alt-left"
        ],
        "f30a",
        "M177.5 414c-8.8 3.8-19 2-26-4.6l-144-136C2.7 268.9 0 262.6 0 256s2.7-12.9 7.5-17.4l144-136c7-6.6 17.2-8.4 26-4.6s14.5 12.5 14.5 22l0 72 288 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-288 0 0 72c0 9.6-5.7 18.2-14.5 22z"
    ]
};
const $d8206b3ab2e65c05$export$a8b3226b2bf323d = $d8206b3ab2e65c05$export$1db7e2ee10d36035;
const $d8206b3ab2e65c05$export$c062100d54a2da00 = {
    prefix: 'fas',
    iconName: 'dna',
    icon: [
        448,
        512,
        [
            129516
        ],
        "f471",
        "M416 0c17.7 0 32 14.3 32 32c0 59.8-30.3 107.5-69.4 146.6c-28 28-62.5 53.5-97.3 77.4l-2.5 1.7c-11.9 8.1-23.8 16.1-35.5 23.9c0 0 0 0 0 0s0 0 0 0s0 0 0 0l-1.6 1c-6 4-11.9 7.9-17.8 11.9c-20.9 14-40.8 27.7-59.3 41.5l118.5 0c-9.8-7.4-20.1-14.7-30.7-22.1l7-4.7 3-2c15.1-10.1 30.9-20.6 46.7-31.6c25 18.1 48.9 37.3 69.4 57.7C417.7 372.5 448 420.2 448 480c0 17.7-14.3 32-32 32s-32-14.3-32-32L64 480c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-59.8 30.3-107.5 69.4-146.6c28-28 62.5-53.5 97.3-77.4c-34.8-23.9-69.3-49.3-97.3-77.4C30.3 139.5 0 91.8 0 32C0 14.3 14.3 0 32 0S64 14.3 64 32l320 0c0-17.7 14.3-32 32-32zM338.6 384l-229.2 0c-10.1 10.6-18.6 21.3-25.5 32l280.2 0c-6.8-10.7-15.3-21.4-25.5-32zM109.4 128l229.2 0c10.1-10.7 18.6-21.3 25.5-32L83.9 96c6.8 10.7 15.3 21.3 25.5 32zm55.4 48c18.4 13.8 38.4 27.5 59.3 41.5c20.9-14 40.8-27.7 59.3-41.5l-118.5 0z"
    ]
};
const $d8206b3ab2e65c05$export$c4ff5306c5470939 = {
    prefix: 'fas',
    iconName: 'virus-slash',
    icon: [
        640,
        512,
        [],
        "e075",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-154.3-121c-2-30.1 20.8-60.1 56-60.1l11.5 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-11.5 0c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C412.3 118.4 352 93.4 352 43.5L352 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 11.5c0 49.9-60.3 74.9-95.6 39.6L184.2 75c-12.5-12.5-32.8-12.5-45.3 0c-1.6 1.6-3.1 3.4-4.3 5.3L38.8 5.1zm225.8 177c6.9-3.9 14.9-6.1 23.4-6.1c26.5 0 48 21.5 48 48c0 4.4-.6 8.7-1.7 12.7l-69.7-54.6zM402 412.7L144.7 210c-9.5 8.5-22.2 14-37.2 14L96 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l11.5 0c49.9 0 74.9 60.3 39.6 95.6l-8.2 8.2c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6l0 11.5c0 17.7 14.3 32 32 32s32-14.3 32-32l0-11.5c0-31.2 23.6-52.7 50-55.7z"
    ]
};
const $d8206b3ab2e65c05$export$fee0376c250cdef = {
    prefix: 'fas',
    iconName: 'minus',
    icon: [
        448,
        512,
        [
            8211,
            8722,
            10134,
            "subtract"
        ],
        "f068",
        "M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"
    ]
};
const $d8206b3ab2e65c05$export$f8cb2531ef1fc4a2 = $d8206b3ab2e65c05$export$fee0376c250cdef;
const $d8206b3ab2e65c05$export$442fddbbd741c590 = {
    prefix: 'fas',
    iconName: 'chess',
    icon: [
        512,
        512,
        [],
        "f439",
        "M144 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16L96 32c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 32L60.2 96C49.1 96 40 105.1 40 116.2c0 2.5 .5 4.9 1.3 7.3L73.8 208 72 208c-13.3 0-24 10.7-24 24s10.7 24 24 24l4 0L60 384l136 0L180 256l4 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-1.8 0 32.5-84.5c.9-2.3 1.3-4.8 1.3-7.3c0-11.2-9.1-20.2-20.2-20.2L144 96l0-32 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-16zM48 416L4.8 473.6C1.7 477.8 0 482.8 0 488c0 13.3 10.7 24 24 24l208 0c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L208 416 48 416zm288 0l-43.2 57.6c-3.1 4.2-4.8 9.2-4.8 14.4c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L464 416l-128 0zM304 208l0 51.9c0 7.8 2.8 15.3 8 21.1L339.2 312 337 384l125.5 0-3.3-72 28.3-30.8c5.4-5.9 8.5-13.6 8.5-21.7l0-51.5c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16l0 16-24 0 0-16c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16l0 16-24 0 0-16c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zm80 96c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32-32 0 0-32z"
    ]
};
const $d8206b3ab2e65c05$export$6e5225f0e6c0bacd = {
    prefix: 'fas',
    iconName: 'arrow-left-long',
    icon: [
        512,
        512,
        [
            "long-arrow-left"
        ],
        "f177",
        "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 288 480 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-370.7 0 73.4-73.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-128 128z"
    ]
};
const $d8206b3ab2e65c05$export$80896efc906118b4 = $d8206b3ab2e65c05$export$6e5225f0e6c0bacd;
const $d8206b3ab2e65c05$export$2bd45e99b9afa947 = {
    prefix: 'fas',
    iconName: 'plug-circle-check',
    icon: [
        576,
        512,
        [],
        "e55c",
        "M96 0C78.3 0 64 14.3 64 32l0 96 64 0 0-96c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32l0 96 64 0 0-96c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 32c0 77.4 55 142 128 156.8l0 67.2c0 17.7 14.3 32 32 32s32-14.3 32-32l0-67.2c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32L32 160zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
const $d8206b3ab2e65c05$export$6aab6c3359c2554c = {
    prefix: 'fas',
    iconName: 'street-view',
    icon: [
        512,
        512,
        [],
        "f21d",
        "M320 64A64 64 0 1 0 192 64a64 64 0 1 0 128 0zm-96 96c-35.3 0-64 28.7-64 64l0 48c0 17.7 14.3 32 32 32l1.8 0 11.1 99.5c1.8 16.2 15.5 28.5 31.8 28.5l38.7 0c16.3 0 30-12.3 31.8-28.5L318.2 304l1.8 0c17.7 0 32-14.3 32-32l0-48c0-35.3-28.7-64-64-64l-64 0zM132.3 394.2c13-2.4 21.7-14.9 19.3-27.9s-14.9-21.7-27.9-19.3c-32.4 5.9-60.9 14.2-82 24.8c-10.5 5.3-20.3 11.7-27.8 19.6C6.4 399.5 0 410.5 0 424c0 21.4 15.5 36.1 29.1 45c14.7 9.6 34.3 17.3 56.4 23.4C130.2 504.7 190.4 512 256 512s125.8-7.3 170.4-19.6c22.1-6.1 41.8-13.8 56.4-23.4c13.7-8.9 29.1-23.6 29.1-45c0-13.5-6.4-24.5-14-32.6c-7.5-7.9-17.3-14.3-27.8-19.6c-21-10.6-49.5-18.9-82-24.8c-13-2.4-25.5 6.3-27.9 19.3s6.3 25.5 19.3 27.9c30.2 5.5 53.7 12.8 69 20.5c3.2 1.6 5.8 3.1 7.9 4.5c3.6 2.4 3.6 7.2 0 9.6c-8.8 5.7-23.1 11.8-43 17.3C374.3 457 318.5 464 256 464s-118.3-7-157.7-17.9c-19.9-5.5-34.2-11.6-43-17.3c-3.6-2.4-3.6-7.2 0-9.6c2.1-1.4 4.8-2.9 7.9-4.5c15.3-7.7 38.8-14.9 69-20.5z"
    ]
};
const $d8206b3ab2e65c05$export$acef3e5c2029d285 = {
    prefix: 'fas',
    iconName: 'franc-sign',
    icon: [
        320,
        512,
        [],
        "e18f",
        "M80 32C62.3 32 48 46.3 48 64l0 160 0 96-16 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l16 0 0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64 80 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-80 0 0-64 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-96 176 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 32z"
    ]
};
const $d8206b3ab2e65c05$export$d94ba52e980ea0f1 = {
    prefix: 'fas',
    iconName: 'volume-off',
    icon: [
        320,
        512,
        [],
        "f026",
        "M320 64c0-12.6-7.4-24-18.9-29.2s-25-3.1-34.4 5.3L131.8 160 64 160c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l67.8 0L266.7 471.9c9.4 8.4 22.9 10.4 34.4 5.3S320 460.6 320 448l0-384z"
    ]
};
const $d8206b3ab2e65c05$export$bc43eb4655c78f49 = {
    prefix: 'fas',
    iconName: 'hands-asl-interpreting',
    icon: [
        640,
        512,
        [
            "american-sign-language-interpreting",
            "asl-interpreting",
            "hands-american-sign-language-interpreting"
        ],
        "f2a3",
        "M156.6 46.3c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3L13.5 189.4C4.6 207.2 0 226.8 0 246.7L0 256c0 70.7 57.3 128 128 128l72 0 8 0 0-.3c35.2-2.7 65.4-22.8 82.1-51.7c8.8-15.3 3.6-34.9-11.7-43.7s-34.9-3.6-43.7 11.7c-7 12-19.9 20-34.7 20c-22.1 0-40-17.9-40-40s17.9-40 40-40c14.8 0 27.7 8 34.7 20c8.8 15.3 28.4 20.5 43.7 11.7s20.5-28.4 11.7-43.7c-12.8-22.1-33.6-39.1-58.4-47.1l80.8-22c17-4.6 27.1-22.2 22.5-39.3s-22.2-27.1-39.3-22.5L194.9 124.6l81.6-68c13.6-11.3 15.4-31.5 4.1-45.1S249.1-3.9 235.5 7.4L133.6 92.3l23-46zM483.4 465.7c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l85.9-171.7c8.9-17.8 13.5-37.4 13.5-57.2l0-9.3c0-70.7-57.3-128-128-128l-72 0-8 0 0 .3c-35.2 2.7-65.4 22.8-82.1 51.7c-8.9 15.3-3.6 34.9 11.7 43.7s34.9 3.6 43.7-11.7c7-12 19.9-20 34.7-20c22.1 0 40 17.9 40 40s-17.9 40-40 40c-14.8 0-27.7-8-34.7-20c-8.9-15.3-28.4-20.5-43.7-11.7s-20.5 28.4-11.7 43.7c12.8 22.1 33.6 39.1 58.4 47.1l-80.8 22c-17.1 4.7-27.1 22.2-22.5 39.3s22.2 27.1 39.3 22.5l100.7-27.5-81.6 68c-13.6 11.3-15.4 31.5-4.1 45.1s31.5 15.4 45.1 4.1l101.9-84.9-23 46z"
    ]
};
const $d8206b3ab2e65c05$export$23a7517099ab1b86 = $d8206b3ab2e65c05$export$bc43eb4655c78f49;
const $d8206b3ab2e65c05$export$beb51abfb05a4eca = $d8206b3ab2e65c05$export$bc43eb4655c78f49;
const $d8206b3ab2e65c05$export$82846008645b0301 = $d8206b3ab2e65c05$export$bc43eb4655c78f49;
const $d8206b3ab2e65c05$export$ec05accb7226d001 = {
    prefix: 'fas',
    iconName: 'gear',
    icon: [
        512,
        512,
        [
            9881,
            "cog"
        ],
        "f013",
        "M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"
    ]
};
const $d8206b3ab2e65c05$export$d6298bbfd1912a78 = $d8206b3ab2e65c05$export$ec05accb7226d001;
const $d8206b3ab2e65c05$export$1d6c5a49025d720b = {
    prefix: 'fas',
    iconName: 'droplet-slash',
    icon: [
        640,
        512,
        [
            "tint-slash"
        ],
        "f5c7",
        "M320 512c53.2 0 101.4-21.6 136.1-56.6l-298.3-235C140 257.1 128 292.3 128 320c0 106 86 192 192 192zM505.2 370.7c4.4-16.2 6.8-33.1 6.8-50.7c0-91.2-130.2-262.3-166.6-308.3C339.4 4.2 330.5 0 320.9 0l-1.8 0c-9.6 0-18.5 4.2-24.5 11.7C277.8 33 240.7 81.3 205.8 136L38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L505.2 370.7zM224 336c0 44.2 35.8 80 80 80c8.8 0 16 7.2 16 16s-7.2 16-16 16c-61.9 0-112-50.1-112-112c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
const $d8206b3ab2e65c05$export$5d6f0943039b898f = $d8206b3ab2e65c05$export$1d6c5a49025d720b;
const $d8206b3ab2e65c05$export$4999586d7e1087fb = {
    prefix: 'fas',
    iconName: 'mosque',
    icon: [
        640,
        512,
        [
            128332
        ],
        "f678",
        "M400 0c5 0 9.8 2.4 12.8 6.4c34.7 46.3 78.1 74.9 133.5 111.5c0 0 0 0 0 0s0 0 0 0c5.2 3.4 10.5 7 16 10.6c28.9 19.2 45.7 51.7 45.7 86.1c0 28.6-11.3 54.5-29.8 73.4l-356.4 0c-18.4-19-29.8-44.9-29.8-73.4c0-34.4 16.7-66.9 45.7-86.1c5.4-3.6 10.8-7.1 16-10.6c0 0 0 0 0 0s0 0 0 0C309.1 81.3 352.5 52.7 387.2 6.4c3-4 7.8-6.4 12.8-6.4zM288 512l0-72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72-48 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l416 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-48 0 0-72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72-64 0 0-58c0-19-8.4-37-23-49.2L400 384l-25 20.8C360.4 417 352 435 352 454l0 58-64 0zM70.4 5.2c5.7-4.3 13.5-4.3 19.2 0l16 12C139.8 42.9 160 83.2 160 126l0 2L0 128l0-2C0 83.2 20.2 42.9 54.4 17.2l16-12zM0 160l160 0 0 136.6c-19.1 11.1-32 31.7-32 55.4l0 128c0 9.6 2.1 18.6 5.8 26.8c-6.6 3.4-14 5.2-21.8 5.2l-64 0c-26.5 0-48-21.5-48-48L0 176l0-16z"
    ]
};
const $d8206b3ab2e65c05$export$67c7a1518d0715ff = {
    prefix: 'fas',
    iconName: 'mosquito',
    icon: [
        640,
        512,
        [],
        "e52b",
        "M463.7 505.9c9.8-8.9 10.7-24.3 2.1-34.3l-42.1-49 0-54.7c0-5.5-1.8-10.8-5.1-15.1L352 266.3l0-.3L485.4 387.8C542.4 447.6 640 405.2 640 320.6c0-47.9-34-88.3-79.4-94.2l-153-23.9 40.8-40.9c7.8-7.8 9.4-20.1 3.9-29.8L428.5 90.1l38.2-50.9c8-10.6 6.1-25.9-4.3-34.1s-25.2-6.3-33.2 4.4l-48 63.9c-5.9 7.9-6.6 18.6-1.7 27.2L402.2 140 352 190.3l0-38.2c0-14.9-10.2-27.4-24-31l0-57.2c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 57.2c-13.8 3.6-24 16.1-24 31l0 38.1L237.8 140l22.6-39.5c4.9-8.6 4.2-19.3-1.7-27.2l-48-63.9c-8-10.6-22.8-12.6-33.2-4.4s-12.2 23.5-4.3 34.1l38.2 50.9-23.9 41.7c-5.5 9.7-3.9 22 3.9 29.8l40.8 40.9-153 23.9C34 232.3 0 272.7 0 320.6c0 84.6 97.6 127 154.6 67.1L288 266l0 .3-66.5 86.4c-3.3 4.3-5.1 9.6-5.1 15.1l0 54.7-42.1 49c-8.6 10.1-7.7 25.5 2.1 34.3s24.7 7.9 33.4-2.1l48-55.9c3.8-4.4 5.9-10.2 5.9-16.1l0-55.4L288 344.7l0 63.1c0 17.7 14.3 32 32 32s32-14.3 32-32l0-63.1 24.3 31.6 0 55.4c0 5.9 2.1 11.7 5.9 16.1l48 55.9c8.6 10.1 23.6 11 33.4 2.1z"
    ]
};
const $d8206b3ab2e65c05$export$f823fee3712b2601 = {
    prefix: 'fas',
    iconName: 'star-of-david',
    icon: [
        512,
        512,
        [
            10017
        ],
        "f69a",
        "M404.2 309.5L383.1 344l42.3 0-21.1-34.5zM371.4 256l-54-88-122.8 0-54 88 54 88 122.8 0 54-88zm65.7 0l53.4 87c3.6 5.9 5.5 12.7 5.5 19.6c0 20.7-16.8 37.4-37.4 37.4l-109.8 0-56.2 91.5C284.8 504.3 270.9 512 256 512s-28.8-7.7-36.6-20.5L163.3 400 53.4 400C32.8 400 16 383.2 16 362.6c0-6.9 1.9-13.7 5.5-19.6l53.4-87L21.5 169c-3.6-5.9-5.5-12.7-5.5-19.6C16 128.8 32.8 112 53.4 112l109.8 0 56.2-91.5C227.2 7.7 241.1 0 256 0s28.8 7.7 36.6 20.5L348.7 112l109.8 0c20.7 0 37.4 16.8 37.4 37.4c0 6.9-1.9 13.7-5.5 19.6l-53.4 87zm-54-88l21.1 34.5L425.4 168l-42.3 0zM283 112L256 68l-27 44 54 0zM128.9 168l-42.3 0 21.1 34.5L128.9 168zM107.8 309.5L86.6 344l42.3 0-21.1-34.5zM229 400l27 44 27-44-54 0z"
    ]
};
const $d8206b3ab2e65c05$export$842b988dae95ccb8 = {
    prefix: 'fas',
    iconName: 'person-military-rifle',
    icon: [
        512,
        512,
        [],
        "e54b",
        "M160 39c0-13 10-23.8 22.9-24.9L334.7 1.4C344 .7 352 8 352 17.4L352 48c0 8.8-7.2 16-16 16L185 64c-13.8 0-25-11.2-25-25zm17.6 57l156.8 0c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5 .6-10.8 1.6-16zm228 364.3L352 369.7 352 480c0 1.3-.1 2.5-.2 3.8L177.5 234.9c16.6-7.1 34.6-10.9 53.3-10.9l50.4 0c15.9 0 31.3 2.8 45.8 7.9L421.9 67.7c-7.7-4.4-10.3-14.2-5.9-21.9s14.2-10.3 21.9-5.9l13.9 8 13.9 8c7.7 4.4 10.3 14.2 5.9 21.9L416 173.9l1.6 .9c15.3 8.8 20.6 28.4 11.7 43.7L392.6 282c2 2.8 3.9 5.8 5.7 8.8l76.1 128.8c11.2 19 4.9 43.5-14.1 54.8s-43.5 4.9-54.8-14.1zM320 512l-128 0c-17.7 0-32-14.3-32-32l0-110.3-53.6 90.6c-11.2 19-35.8 25.3-54.8 14.1s-25.3-35.8-14.1-54.8l76.1-128.8c9.4-15.8 21.7-29.3 36-40L331.1 510c-3.5 1.3-7.2 2-11.1 2zM296 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
const $d8206b3ab2e65c05$export$c790b41dc166ae13 = {
    prefix: 'fas',
    iconName: 'cart-shopping',
    icon: [
        576,
        512,
        [
            128722,
            "shopping-cart"
        ],
        "f07a",
        "M0 24C0 10.7 10.7 0 24 0L69.5 0c22 0 41.5 12.8 50.6 32l411 0c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3l-288.5 0 5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5L488 336c13.3 0 24 10.7 24 24s-10.7 24-24 24l-288.3 0c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5L24 48C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
const $d8206b3ab2e65c05$export$51da406e5aa1388c = $d8206b3ab2e65c05$export$c790b41dc166ae13;
const $d8206b3ab2e65c05$export$507e8edd7676b2e9 = {
    prefix: 'fas',
    iconName: 'vials',
    icon: [
        512,
        512,
        [],
        "f493",
        "M0 64C0 46.3 14.3 32 32 32l56 0 48 0 56 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 304c0 44.2-35.8 80-80 80s-80-35.8-80-80L32 96C14.3 96 0 81.7 0 64zM136 96L88 96l0 160 48 0 0-160zM288 64c0-17.7 14.3-32 32-32l56 0 48 0 56 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 304c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-304c-17.7 0-32-14.3-32-32zM424 96l-48 0 0 160 48 0 0-160z"
    ]
};
const $d8206b3ab2e65c05$export$f193138a7d21971c = {
    prefix: 'fas',
    iconName: 'plug-circle-plus',
    icon: [
        576,
        512,
        [],
        "e55f",
        "M96 0C78.3 0 64 14.3 64 32l0 96 64 0 0-96c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32l0 96 64 0 0-96c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 32c0 77.4 55 142 128 156.8l0 67.2c0 17.7 14.3 32 32 32s32-14.3 32-32l0-67.2c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32L32 160zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208l0 48 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
const $d8206b3ab2e65c05$export$c5a9302c8c13c79a = {
    prefix: 'fas',
    iconName: 'place-of-worship',
    icon: [
        640,
        512,
        [],
        "f67f",
        "M224 109.3l0 108.3L183.3 242c-14.5 8.7-23.3 24.3-23.3 41.2L160 512l96 0 0-96c0-35.3 28.7-64 64-64s64 28.7 64 64l0 96 96 0 0-228.8c0-16.9-8.8-32.5-23.3-41.2L416 217.6l0-108.3c0-8.5-3.4-16.6-9.4-22.6L331.3 11.3c-6.2-6.2-16.4-6.2-22.6 0L233.4 86.6c-6 6-9.4 14.1-9.4 22.6zM24.9 330.3C9.5 338.8 0 354.9 0 372.4L0 464c0 26.5 21.5 48 48 48l80 0 0-238.4L24.9 330.3zM592 512c26.5 0 48-21.5 48-48l0-91.6c0-17.5-9.5-33.6-24.9-42.1L512 273.6 512 512l80 0z"
    ]
};
const $d8206b3ab2e65c05$export$cacbd95c283996ec = {
    prefix: 'fas',
    iconName: 'grip-vertical',
    icon: [
        320,
        512,
        [],
        "f58e",
        "M40 352l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zm192 0l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 320c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 192l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 160c-22.1 0-40-17.9-40-40L0 72C0 49.9 17.9 32 40 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40z"
    ]
};
const $d8206b3ab2e65c05$export$b75f0f1ba423de5f = {
    prefix: 'fas',
    iconName: 'hexagon-nodes',
    icon: [
        448,
        512,
        [],
        "e699",
        "M248 106.6c18.9-9 32-28.3 32-50.6c0-30.9-25.1-56-56-56s-56 25.1-56 56c0 22.3 13.1 41.6 32 50.6l0 98.8c-2.8 1.3-5.5 2.9-8 4.7l-80.1-45.8c1.6-20.8-8.6-41.6-27.9-52.8C57.2 96 23 105.2 7.5 132S1.2 193 28 208.5c1.3 .8 2.6 1.5 4 2.1l0 90.8c-1.3 .6-2.7 1.3-4 2.1C1.2 319-8 353.2 7.5 380S57.2 416 84 400.5c19.3-11.1 29.4-32 27.8-52.8l50.5-28.9c-11.5-11.2-19.9-25.6-23.8-41.7L88 306.1c-2.6-1.8-5.2-3.3-8-4.7l0-90.8c2.8-1.3 5.5-2.9 8-4.7l80.1 45.8c-.1 1.4-.2 2.8-.2 4.3c0 22.3 13.1 41.6 32 50.6l0 98.8c-18.9 9-32 28.3-32 50.6c0 30.9 25.1 56 56 56s56-25.1 56-56c0-22.3-13.1-41.6-32-50.6l0-98.8c2.8-1.3 5.5-2.9 8-4.7l80.1 45.8c-1.6 20.8 8.6 41.6 27.8 52.8c26.8 15.5 61 6.3 76.5-20.5s6.3-61-20.5-76.5c-1.3-.8-2.7-1.5-4-2.1l0-90.8c1.4-.6 2.7-1.3 4-2.1c26.8-15.5 36-49.7 20.5-76.5S390.8 96 364 111.5c-19.3 11.1-29.4 32-27.8 52.8l-50.6 28.9c11.5 11.2 19.9 25.6 23.8 41.7L360 205.9c2.6 1.8 5.2 3.3 8 4.7l0 90.8c-2.8 1.3-5.5 2.9-8 4.6l-80.1-45.8c.1-1.4 .2-2.8 .2-4.3c0-22.3-13.1-41.6-32-50.6l0-98.8z"
    ]
};
const $d8206b3ab2e65c05$export$2d3ccb9b2099f3fe = {
    prefix: 'fas',
    iconName: 'arrow-turn-up',
    icon: [
        384,
        512,
        [
            "level-up"
        ],
        "f148",
        "M32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c53 0 96-43 96-96l0-306.7 73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 109.3 160 416c0 17.7-14.3 32-32 32l-96 0z"
    ]
};
const $d8206b3ab2e65c05$export$c227d3ba1de97ceb = $d8206b3ab2e65c05$export$2d3ccb9b2099f3fe;
const $d8206b3ab2e65c05$export$4f39e8dbaf09ea8b = {
    prefix: 'fas',
    iconName: 'u',
    icon: [
        384,
        512,
        [
            117
        ],
        "55",
        "M32 32c17.7 0 32 14.3 32 32l0 224c0 70.7 57.3 128 128 128s128-57.3 128-128l0-224c0-17.7 14.3-32 32-32s32 14.3 32 32l0 224c0 106-86 192-192 192S0 394 0 288L0 64C0 46.3 14.3 32 32 32z"
    ]
};
const $d8206b3ab2e65c05$export$60b44cfa7af18422 = {
    prefix: 'fas',
    iconName: 'square-root-variable',
    icon: [
        576,
        512,
        [
            "square-root-alt"
        ],
        "f698",
        "M282.6 78.1c8-27.3 33-46.1 61.4-46.1l200 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L344 96 238.7 457c-3.6 12.3-14.1 21.2-26.8 22.8s-25.1-4.6-31.5-15.6L77.6 288 32 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l45.6 0c22.8 0 43.8 12.1 55.3 31.8l65.2 111.8L282.6 78.1zM393.4 233.4c12.5-12.5 32.8-12.5 45.3 0L480 274.7l41.4-41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L525.3 320l41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L480 365.3l-41.4 41.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L434.7 320l-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3z"
    ]
};
const $d8206b3ab2e65c05$export$28e4b96627e00057 = $d8206b3ab2e65c05$export$60b44cfa7af18422;
const $d8206b3ab2e65c05$export$95b9968e7fceb821 = {
    prefix: 'fas',
    iconName: 'clock',
    icon: [
        512,
        512,
        [
            128339,
            "clock-four"
        ],
        "f017",
        "M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120l0 136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2 280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
    ]
};
const $d8206b3ab2e65c05$export$9a575facf1cab48f = $d8206b3ab2e65c05$export$95b9968e7fceb821;
const $d8206b3ab2e65c05$export$5d2b6a700940df16 = {
    prefix: 'fas',
    iconName: 'backward-step',
    icon: [
        320,
        512,
        [
            "step-backward"
        ],
        "f048",
        "M267.5 440.6c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29l0-320c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4l-192 160L64 241 64 96c0-17.7-14.3-32-32-32S0 78.3 0 96L0 416c0 17.7 14.3 32 32 32s32-14.3 32-32l0-145 11.5 9.6 192 160z"
    ]
};
const $d8206b3ab2e65c05$export$2884e379aed297d4 = $d8206b3ab2e65c05$export$5d2b6a700940df16;
const $d8206b3ab2e65c05$export$d7ff2047dbc34562 = {
    prefix: 'fas',
    iconName: 'pallet',
    icon: [
        640,
        512,
        [],
        "f482",
        "M32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 64-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0 224 0 224 0 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-64 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0-224 0L96 320l-64 0zm96 64l160 0 0 64-160 0 0-64zm224 0l160 0 0 64-160 0 0-64z"
    ]
};
const $d8206b3ab2e65c05$export$a0856b225f3b0614 = {
    prefix: 'fas',
    iconName: 'faucet',
    icon: [
        512,
        512,
        [],
        "e005",
        "M192 96l0 12L96 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l96-12 31-3.9 1-.1 1 .1 31 3.9 96 12c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 12 0-12c0-17.7-14.3-32-32-32s-32 14.3-32 32zM32 256c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l100.1 0c20.2 29 53.9 48 91.9 48s71.7-19 91.9-48l36.1 0c17.7 0 32 14.3 32 32s14.3 32 32 32l64 0c17.7 0 32-14.3 32-32c0-88.4-71.6-160-160-160l-32 0-22.6-22.6c-6-6-14.1-9.4-22.6-9.4L256 224l0-43.8-32-4-32 4 0 43.8-18.7 0c-8.5 0-16.6 3.4-22.6 9.4L128 256l-96 0z"
    ]
};
const $d8206b3ab2e65c05$export$59669f486ab41d86 = {
    prefix: 'fas',
    iconName: 'baseball-bat-ball',
    icon: [
        512,
        512,
        [],
        "f432",
        "M424 0c-12.4 0-24.2 4.9-33 13.7L233.5 171.2c-10.5 10.5-19.8 22.1-27.7 34.6L132.7 321.6c-7.3 11.5-15.8 22.2-25.5 31.9L69.9 390.7l51.3 51.3 37.3-37.3c9.6-9.6 20.3-18.2 31.9-25.5l115.8-73.1c12.5-7.9 24.1-17.2 34.6-27.7L498.3 121c8.7-8.7 13.7-20.6 13.7-33s-4.9-24.2-13.7-33L457 13.7C448.2 4.9 436.4 0 424 0zm88 432a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM15 399c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L49 399c-9.4-9.4-24.6-9.4-33.9 0z"
    ]
};
const $d8206b3ab2e65c05$export$cb39585371b75720 = {
    prefix: 'fas',
    iconName: 's',
    icon: [
        320,
        512,
        [
            115
        ],
        "53",
        "M99.1 105.4C79 114 68.2 127.2 65.2 144.8c-2.4 14.1-.7 23.2 2 29.4c2.8 6.3 7.9 12.4 16.7 18.6c19.2 13.4 48.3 22.1 84.9 32.5c1 .3 1.9 .6 2.9 .8c32.7 9.3 72 20.6 100.9 40.7c15.7 10.9 29.9 25.5 38.6 45.1c8.8 19.8 10.8 42 6.6 66.3c-7.3 42.5-35.3 71.7-71.8 87.3c-35.4 15.2-79.1 17.9-123.7 10.9l-.2 0s0 0 0 0c-24-3.9-62.7-17.1-87.6-25.6c-4.8-1.7-9.2-3.1-12.8-4.3C5.1 440.8-3.9 422.7 1.6 405.9s23.7-25.8 40.5-20.3c4.9 1.6 10.2 3.4 15.9 5.4c25.4 8.6 56.4 19.2 74.4 22.1c36.8 5.7 67.5 2.5 88.5-6.5c20.1-8.6 30.8-21.8 33.9-39.4c2.4-14.1 .7-23.2-2-29.4c-2.8-6.3-7.9-12.4-16.7-18.6c-19.2-13.4-48.3-22.1-84.9-32.5c-1-.3-1.9-.6-2.9-.8c-32.7-9.3-72-20.6-100.9-40.7c-15.7-10.9-29.9-25.5-38.6-45.1c-8.8-19.8-10.8-42-6.6-66.3l31.5 5.5L2.1 133.9C9.4 91.4 37.4 62.2 73.9 46.6c35.4-15.2 79.1-17.9 123.7-10.9c13 2 52.4 9.6 66.6 13.4c17.1 4.5 27.2 22.1 22.7 39.2s-22.1 27.2-39.2 22.7c-11.2-3-48.1-10.2-60.1-12l4.9-31.5-4.9 31.5c-36.9-5.8-67.5-2.5-88.6 6.5z"
    ]
};
const $d8206b3ab2e65c05$export$5e239d90ef904a84 = {
    prefix: 'fas',
    iconName: 'timeline',
    icon: [
        640,
        512,
        [],
        "e29c",
        "M128 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm32 97.3c28.3-12.3 48-40.5 48-73.3c0-44.2-35.8-80-80-80S48 51.8 48 96c0 32.8 19.7 61 48 73.3L96 224l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l256 0 0 54.7c-28.3 12.3-48 40.5-48 73.3c0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3l0-54.7 256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-54.7c28.3-12.3 48-40.5 48-73.3c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 32.8 19.7 61 48 73.3l0 54.7-320 0 0-54.7zM488 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM320 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
const $d8206b3ab2e65c05$export$fb61df5d98785fa8 = {
    prefix: 'fas',
    iconName: 'keyboard',
    icon: [
        576,
        512,
        [
            9000
        ],
        "f11c",
        "M64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64zm16 64l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM64 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80-176c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM160 336c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16l0-32zM272 128l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM256 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM368 128l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM352 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM464 128l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM448 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16z"
    ]
};
const $d8206b3ab2e65c05$export$f9395ef707603e40 = {
    prefix: 'fas',
    iconName: 'caret-down',
    icon: [
        320,
        512,
        [],
        "f0d7",
        "M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"
    ]
};
const $d8206b3ab2e65c05$export$9c73560282dceccd = {
    prefix: 'fas',
    iconName: 'house-chimney-medical',
    icon: [
        576,
        512,
        [
            "clinic-medical"
        ],
        "f7f2",
        "M575.8 255.5c0 18-15 32.1-32 32.1l-32 0 .7 160.2c.2 35.5-28.5 64.3-64 64.3l-320.4 0c-35.3 0-64-28.7-64-64l0-160.4-32 0c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7 416 64c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 121 52.8 46.4c8 7 12 15 11 24zM272 192c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0z"
    ]
};
const $d8206b3ab2e65c05$export$20d8a680febc7434 = $d8206b3ab2e65c05$export$9c73560282dceccd;
const $d8206b3ab2e65c05$export$7ed2bad15ae6237f = {
    prefix: 'fas',
    iconName: 'temperature-three-quarters',
    icon: [
        320,
        512,
        [
            "temperature-3",
            "thermometer-3",
            "thermometer-three-quarters"
        ],
        "f2c8",
        "M160 64c-26.5 0-48 21.5-48 48l0 164.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5L208 112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112l0 164.4c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6L48 112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3L144 144c0-8.8 7.2-16 16-16s16 7.2 16 16l0 178.7c18.6 6.6 32 24.4 32 45.3z"
    ]
};
const $d8206b3ab2e65c05$export$89def3268ed9b4bc = $d8206b3ab2e65c05$export$7ed2bad15ae6237f;
const $d8206b3ab2e65c05$export$2f653125f4e6463 = $d8206b3ab2e65c05$export$7ed2bad15ae6237f;
const $d8206b3ab2e65c05$export$6c632d1dc30d4a77 = $d8206b3ab2e65c05$export$7ed2bad15ae6237f;
const $d8206b3ab2e65c05$export$8867e7da34bb8bf4 = {
    prefix: 'fas',
    iconName: 'mobile-screen',
    icon: [
        384,
        512,
        [
            "mobile-android-alt"
        ],
        "f3cf",
        "M16 64C16 28.7 44.7 0 80 0L304 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L80 512c-35.3 0-64-28.7-64-64L16 64zM144 448c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zM304 64L80 64l0 320 224 0 0-320z"
    ]
};
const $d8206b3ab2e65c05$export$cb39d7b468ba5838 = $d8206b3ab2e65c05$export$8867e7da34bb8bf4;
const $d8206b3ab2e65c05$export$a5f2976a01fdc970 = {
    prefix: 'fas',
    iconName: 'plane-up',
    icon: [
        512,
        512,
        [],
        "e22d",
        "M192 93.7C192 59.5 221 0 256 0c36 0 64 59.5 64 93.7l0 66.3L497.8 278.5c8.9 5.9 14.2 15.9 14.2 26.6l0 56.7c0 10.9-10.7 18.6-21.1 15.2L320 320l0 80 57.6 43.2c4 3 6.4 7.8 6.4 12.8l0 42c0 7.8-6.3 14-14 14c-1.3 0-2.6-.2-3.9-.5L256 480 145.9 511.5c-1.3 .4-2.6 .5-3.9 .5c-7.8 0-14-6.3-14-14l0-42c0-5 2.4-9.8 6.4-12.8L192 400l0-80L21.1 377C10.7 380.4 0 372.7 0 361.8l0-56.7c0-10.7 5.3-20.7 14.2-26.6L192 160l0-66.3z"
    ]
};
const $d8206b3ab2e65c05$export$46d49a6734c4872a = {
    prefix: 'fas',
    iconName: 'piggy-bank',
    icon: [
        576,
        512,
        [],
        "f4d3",
        "M400 96l0 .7c-5.3-.4-10.6-.7-16-.7L256 96c-16.5 0-32.5 2.1-47.8 6c-.1-2-.2-4-.2-6c0-53 43-96 96-96s96 43 96 96zm-16 32c3.5 0 7 .1 10.4 .3c4.2 .3 8.4 .7 12.6 1.3C424.6 109.1 450.8 96 480 96l11.5 0c10.4 0 18 9.8 15.5 19.9l-13.8 55.2c15.8 14.8 28.7 32.8 37.5 52.9l13.3 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-32 0c-9.1 12.1-19.9 22.9-32 32l0 64c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-32-128 0 0 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-64c-34.9-26.2-58.7-66.3-63.2-112L68 304c-37.6 0-68-30.4-68-68s30.4-68 68-68l4 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-4 0c-11 0-20 9-20 20s9 20 20 20l31.2 0c12.1-59.8 57.7-107.5 116.3-122.8c12.9-3.4 26.5-5.2 40.5-5.2l128 0zm64 136a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
    ]
};
const $d8206b3ab2e65c05$export$e6dadc1155c4ee48 = {
    prefix: 'fas',
    iconName: 'battery-half',
    icon: [
        576,
        512,
        [
            "battery-3"
        ],
        "f242",
        "M464 160c8.8 0 16 7.2 16 16l0 160c0 8.8-7.2 16-16 16L80 352c-8.8 0-16-7.2-16-16l0-160c0-8.8 7.2-16 16-16l384 0zM80 96C35.8 96 0 131.8 0 176L0 336c0 44.2 35.8 80 80 80l384 0c44.2 0 80-35.8 80-80l0-16c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l0-16c0-44.2-35.8-80-80-80L80 96zm208 96L96 192l0 128 192 0 0-128z"
    ]
};
const $d8206b3ab2e65c05$export$f9138caac2aedaed = $d8206b3ab2e65c05$export$e6dadc1155c4ee48;
const $d8206b3ab2e65c05$export$28f06bbf9c17c3af = {
    prefix: 'fas',
    iconName: 'mountain-city',
    icon: [
        640,
        512,
        [],
        "e52e",
        "M336 0c-26.5 0-48 21.5-48 48l0 92.1 71.4 118.4c2.5-1.6 5.4-2.5 8.6-2.5l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-3.5 0 73.8 122.4c12.4 20.6 12.9 46.3 1.2 67.3c-.4 .8-.9 1.6-1.4 2.3L592 512c26.5 0 48-21.5 48-48l0-224c0-26.5-21.5-48-48-48l-24 0 0-72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72-40 0 0-144c0-26.5-21.5-48-48-48L336 0zm32 64l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM352 176c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm160 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM224 188.9L283.8 288 223 288l-48 64-24.6-41.2L224 188.9zm29.4-44.2C247.1 134.3 236 128 224 128s-23.1 6.3-29.4 16.7L5.1 458.9c-6.5 10.8-6.7 24.3-.7 35.3S22 512 34.5 512l379.1 0c12.5 0 24-6.8 30.1-17.8s5.8-24.5-.7-35.3L253.4 144.7z"
    ]
};
const $d8206b3ab2e65c05$export$bc5da164799a0e = {
    prefix: 'fas',
    iconName: 'coins',
    icon: [
        512,
        512,
        [],
        "f51e",
        "M512 80c0 18-14.3 34.6-38.4 48c-29.1 16.1-72.5 27.5-122.3 30.9c-3.7-1.8-7.4-3.5-11.3-5C300.6 137.4 248.2 128 192 128c-8.3 0-16.4 .2-24.5 .6l-1.1-.6C142.3 114.6 128 98 128 80c0-44.2 86-80 192-80S512 35.8 512 80zM160.7 161.1c10.2-.7 20.7-1.1 31.3-1.1c62.2 0 117.4 12.3 152.5 31.4C369.3 204.9 384 221.7 384 240c0 4-.7 7.9-2.1 11.7c-4.6 13.2-17 25.3-35 35.5c0 0 0 0 0 0c-.1 .1-.3 .1-.4 .2c0 0 0 0 0 0s0 0 0 0c-.3 .2-.6 .3-.9 .5c-35 19.4-90.8 32-153.6 32c-59.6 0-112.9-11.3-148.2-29.1c-1.9-.9-3.7-1.9-5.5-2.9C14.3 274.6 0 258 0 240c0-34.8 53.4-64.5 128-75.4c10.5-1.5 21.4-2.7 32.7-3.5zM416 240c0-21.9-10.6-39.9-24.1-53.4c28.3-4.4 54.2-11.4 76.2-20.5c16.3-6.8 31.5-15.2 43.9-25.5l0 35.4c0 19.3-16.5 37.1-43.8 50.9c-14.6 7.4-32.4 13.7-52.4 18.5c.1-1.8 .2-3.5 .2-5.3zm-32 96c0 18-14.3 34.6-38.4 48c-1.8 1-3.6 1.9-5.5 2.9C304.9 404.7 251.6 416 192 416c-62.8 0-118.6-12.6-153.6-32C14.3 370.6 0 354 0 336l0-35.4c12.5 10.3 27.6 18.7 43.9 25.5C83.4 342.6 135.8 352 192 352s108.6-9.4 148.1-25.9c7.8-3.2 15.3-6.9 22.4-10.9c6.1-3.4 11.8-7.2 17.2-11.2c1.5-1.1 2.9-2.3 4.3-3.4l0 3.4 0 5.7 0 26.3zm32 0l0-32 0-25.9c19-4.2 36.5-9.5 52.1-16c16.3-6.8 31.5-15.2 43.9-25.5l0 35.4c0 10.5-5 21-14.9 30.9c-16.3 16.3-45 29.7-81.3 38.4c.1-1.7 .2-3.5 .2-5.3zM192 448c56.2 0 108.6-9.4 148.1-25.9c16.3-6.8 31.5-15.2 43.9-25.5l0 35.4c0 44.2-86 80-192 80S0 476.2 0 432l0-35.4c12.5 10.3 27.6 18.7 43.9 25.5C83.4 438.6 135.8 448 192 448z"
    ]
};
const $d8206b3ab2e65c05$export$8d41d1f1ba3f9217 = {
    prefix: 'fas',
    iconName: 'khanda',
    icon: [
        512,
        512,
        [
            9772
        ],
        "f66d",
        "M245.8 3.7c5.9-4.9 14.6-4.9 20.5 0l48 40c5.9 4.9 7.5 13.2 3.8 19.9c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0l-.1 .1-.3 .6c-.3 .5-.7 1.3-1.2 2.3c-1 2-2.6 5-4.4 8.6c-.5 .9-.9 1.9-1.4 2.9C344.9 97.4 368 134 368 176s-23.1 78.6-57.3 97.8c.5 1 1 2 1.4 2.9c1.8 3.7 3.3 6.6 4.4 8.6c.5 1 .9 1.8 1.2 2.3l.3 .6 .1 .1s0 0 0 0s0 0 0 0c3.6 6.7 2 15-3.8 19.9L272 343.5l0 19.8 35.6-24.5 41.1-28.2c42.8-29.4 68.4-78 68.4-130c0-31.1-9.2-61.6-26.5-87.5l-2.8-4.2c-4-6-3.5-14 1.3-19.5s12.7-7 19.2-3.7L401.1 80c7.2-14.3 7.2-14.3 7.2-14.3s0 0 0 0s0 0 0 0l.1 0 .3 .2 1 .5c.8 .4 2 1.1 3.5 1.9c2.9 1.7 7 4.1 11.8 7.3c9.6 6.4 22.5 16.1 35.4 29c25.7 25.7 52.7 65.6 52.7 119.3c0 53.1-26.4 100.5-51.2 133.6c-12.6 16.7-25.1 30.3-34.5 39.7c-4.7 4.7-8.7 8.4-11.5 10.9c-1.4 1.3-2.5 2.2-3.3 2.9l-.9 .8-.3 .2-.1 .1c0 0 0 0 0 0s0 0 0 0L401.1 400l10.2 12.3c-5.1 4.3-12.4 4.9-18.2 1.6l-75.6-43-32.7 22.5 45.5 31.3c1.8-.4 3.7-.7 5.7-.7c13.3 0 24 10.7 24 24s-10.7 24-24 24c-12.2 0-22.3-9.1-23.8-21L272 423.4l0 28.9c9.6 5.5 16 15.9 16 27.7c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-11.8 6.4-22.2 16-27.7l0-28.1-40.3 27.7C197.8 463.3 187.9 472 176 472c-13.3 0-24-10.7-24-24s10.7-24 24-24c2.2 0 4.4 .3 6.5 .9l45.8-31.5-32.7-22.5-75.6 43c-5.8 3.3-13 2.7-18.2-1.6L112 400c-10.2 12.3-10.2 12.3-10.3 12.3s0 0 0 0s0 0 0 0l-.1-.1-.3-.2-.9-.8c-.8-.7-1.9-1.7-3.3-2.9c-2.8-2.5-6.7-6.2-11.5-10.9c-9.4-9.4-21.9-23-34.5-39.7C26.4 324.5 0 277.1 0 224c0-53.7 26.9-93.6 52.7-119.3c12.9-12.9 25.8-22.6 35.4-29C93 72.5 97 70 99.9 68.4c1.5-.8 2.6-1.5 3.5-1.9l1-.5 .3-.2 .1 0c0 0 0 0 0 0s0 0 0 0L112 80l-7.2-14.3c6.5-3.2 14.3-1.7 19.2 3.7s5.3 13.4 1.3 19.5l-2.8 4.2C105.2 119 96 149.5 96 180.6c0 51.9 25.6 100.6 68.4 130l41.1 28.2L240 362.6l0-19.1-42.2-35.2c-5.9-4.9-7.5-13.2-3.8-19.9c0 0 0 0 0 0s0 0 0 0s0 0 0 0l.1-.1 .3-.6c.3-.5 .7-1.3 1.2-2.3c1-2 2.6-5 4.4-8.6c.5-.9 .9-1.9 1.4-2.9C167.1 254.6 144 218 144 176s23.1-78.6 57.3-97.8c-.5-1-1-2-1.4-2.9c-1.8-3.7-3.3-6.6-4.4-8.6c-.5-1-.9-1.8-1.2-2.3l-.3-.6-.1-.1s0 0 0 0s0 0 0 0s0 0 0 0c-3.6-6.7-2-15 3.8-19.9l48-40zM220.2 122.9c-17 11.5-28.2 31-28.2 53.1s11.2 41.6 28.2 53.1C227 210.2 232 190.9 232 176s-5-34.2-11.8-53.1zm71.5 106.2c17-11.5 28.2-31 28.2-53.1s-11.2-41.6-28.2-53.1C285 141.8 280 161.1 280 176s5 34.2 11.8 53.1z"
    ]
};
const $d8206b3ab2e65c05$export$ea6970ed5a15feb6 = {
    prefix: 'fas',
    iconName: 'sliders',
    icon: [
        512,
        512,
        [
            "sliders-h"
        ],
        "f1de",
        "M0 416c0 17.7 14.3 32 32 32l54.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 448c17.7 0 32-14.3 32-32s-14.3-32-32-32l-246.7 0c-12.3-28.3-40.5-48-73.3-48s-61 19.7-73.3 48L32 384c-17.7 0-32 14.3-32 32zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32-80c-32.8 0-61 19.7-73.3 48L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l246.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48l54.7 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-54.7 0c-12.3-28.3-40.5-48-73.3-48zM192 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm73.3-64C253 35.7 224.8 16 192 16s-61 19.7-73.3 48L32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l86.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 128c17.7 0 32-14.3 32-32s-14.3-32-32-32L265.3 64z"
    ]
};
const $d8206b3ab2e65c05$export$94d4dcb523f95563 = $d8206b3ab2e65c05$export$ea6970ed5a15feb6;
const $d8206b3ab2e65c05$export$54d16fa2e445d3fe = {
    prefix: 'fas',
    iconName: 'folder-tree',
    icon: [
        576,
        512,
        [],
        "f802",
        "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32l0 96L0 384c0 35.3 28.7 64 64 64l192 0 0-64L64 384l0-224 192 0 0-64L64 96l0-64zM288 192c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l-98.7 0c-8.5 0-16.6-3.4-22.6-9.4L409.4 9.4c-6-6-14.1-9.4-22.6-9.4L320 0c-17.7 0-32 14.3-32 32l0 160zm0 288c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l-98.7 0c-8.5 0-16.6-3.4-22.6-9.4l-13.3-13.3c-6-6-14.1-9.4-22.6-9.4L320 288c-17.7 0-32 14.3-32 32l0 160z"
    ]
};
const $d8206b3ab2e65c05$export$882cabd11f4943b8 = {
    prefix: 'fas',
    iconName: 'network-wired',
    icon: [
        640,
        512,
        [],
        "f6ff",
        "M256 64l128 0 0 64-128 0 0-64zM240 0c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l48 0 0 32L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0 0 32-48 0c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-48 0 0-32 256 0 0 32-48 0c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-48 0 0-32 96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-256 0 0-32 48 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48L240 0zM96 448l0-64 128 0 0 64L96 448zm320-64l128 0 0 64-128 0 0-64z"
    ]
};
const $d8206b3ab2e65c05$export$184725965b3402dc = {
    prefix: 'fas',
    iconName: 'map-pin',
    icon: [
        320,
        512,
        [
            128205
        ],
        "f276",
        "M16 144a144 144 0 1 1 288 0A144 144 0 1 1 16 144zM160 80c8.8 0 16-7.2 16-16s-7.2-16-16-16c-53 0-96 43-96 96c0 8.8 7.2 16 16 16s16-7.2 16-16c0-35.3 28.7-64 64-64zM128 480l0-162.9c10.4 1.9 21.1 2.9 32 2.9s21.6-1 32-2.9L192 480c0 17.7-14.3 32-32 32s-32-14.3-32-32z"
    ]
};
const $d8206b3ab2e65c05$export$38d20d399463edf9 = {
    prefix: 'fas',
    iconName: 'hamsa',
    icon: [
        512,
        512,
        [],
        "f665",
        "M34.6 288L80 288c8.8 0 16-7.2 16-16L96 72c0-22.1 17.9-40 40-40s40 17.9 40 40l0 132c0 11 9 20 20 20s20-9 20-20l0-164c0-22.1 17.9-40 40-40s40 17.9 40 40l0 164c0 11 9 20 20 20s20-9 20-20l0-132c0-22.1 17.9-40 40-40s40 17.9 40 40l0 200c0 8.8 7.2 16 16 16l45.4 0c19.1 0 34.6 15.5 34.6 34.6c0 8.6-3.2 16.9-9 23.3L416.6 441c-41.1 45.2-99.4 71-160.6 71s-119.4-25.8-160.6-71L9 345.9c-5.8-6.4-9-14.7-9-23.3C0 303.5 15.5 288 34.6 288zM256 288c-38.4 0-76.8 35.8-90.6 50.2c-3.6 3.7-5.4 8.7-5.4 13.8s1.8 10.1 5.4 13.8C179.2 380.2 217.6 416 256 416s76.8-35.8 90.6-50.2c3.6-3.7 5.4-8.7 5.4-13.8s-1.8-10.1-5.4-13.8C332.8 323.8 294.4 288 256 288zm0 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $d8206b3ab2e65c05$export$875b6c94a4b00ea8 = {
    prefix: 'fas',
    iconName: 'cent-sign',
    icon: [
        384,
        512,
        [],
        "e3f5",
        "M224 0c17.7 0 32 14.3 32 32l0 34.7c30.9 5.2 59.2 17.7 83.2 35.8c14.1 10.6 17 30.7 6.4 44.8s-30.7 17-44.8 6.4C279.4 137.5 252.9 128 224 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c28.9 0 55.4-9.5 76.8-25.6c14.1-10.6 34.2-7.8 44.8 6.4s7.8 34.2-6.4 44.8c-24 18-52.4 30.6-83.2 35.8l0 34.7c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-34.7C101.2 430.1 32 351.1 32 256s69.2-174.1 160-189.3L192 32c0-17.7 14.3-32 32-32z"
    ]
};
const $d8206b3ab2e65c05$export$f9b579ba06048af = {
    prefix: 'fas',
    iconName: 'flask',
    icon: [
        448,
        512,
        [],
        "f0c3",
        "M288 0L160 0 128 0C110.3 0 96 14.3 96 32s14.3 32 32 32l0 132.8c0 11.8-3.3 23.5-9.5 33.5L10.3 406.2C3.6 417.2 0 429.7 0 442.6C0 480.9 31.1 512 69.4 512l309.2 0c38.3 0 69.4-31.1 69.4-69.4c0-12.8-3.6-25.4-10.3-36.4L329.5 230.4c-6.2-10.1-9.5-21.7-9.5-33.5L320 64c17.7 0 32-14.3 32-32s-14.3-32-32-32L288 0zM192 196.8L192 64l64 0 0 132.8c0 23.7 6.6 46.9 19 67.1L309.5 320l-171 0L173 263.9c12.4-20.2 19-43.4 19-67.1z"
    ]
};
const $d8206b3ab2e65c05$export$e7b4c26b5857fe9c = {
    prefix: 'fas',
    iconName: 'person-pregnant',
    icon: [
        384,
        512,
        [],
        "e31e",
        "M192 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM120 383c-13.8-3.6-24-16.1-24-31l0-55.1-4.6 7.6c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c15-24.9 40.3-41.5 68.7-45.6c4.1-.6 8.2-1 12.5-1l1.1 0 12.5 0 2.4 0c1.4 0 2.8 .1 4.1 .3c35.7 2.9 65.4 29.3 72.1 65l6.1 32.5c44.3 8.6 77.7 47.5 77.7 94.3l0 32c0 17.7-14.3 32-32 32l-16 0-40 0 0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96-8 0-8 0 0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-97z"
    ]
};
const $d8206b3ab2e65c05$export$76cc39f249b6864e = {
    prefix: 'fas',
    iconName: 'wand-sparkles',
    icon: [
        512,
        512,
        [],
        "f72b",
        "M464 6.1c9.5-8.5 24-8.1 33 .9l8 8c9 9 9.4 23.5 .9 33l-85.8 95.9c-2.6 2.9-4.1 6.7-4.1 10.7l0 21.4c0 8.8-7.2 16-16 16l-15.8 0c-4.6 0-8.9 1.9-11.9 5.3L100.7 500.9C94.3 508 85.3 512 75.8 512c-8.8 0-17.3-3.5-23.5-9.8L9.7 459.7C3.5 453.4 0 445 0 436.2c0-9.5 4-18.5 11.1-24.8l111.6-99.8c3.4-3 5.3-7.4 5.3-11.9l0-27.6c0-8.8 7.2-16 16-16l34.6 0c3.9 0 7.7-1.5 10.7-4.1L464 6.1zM432 288c3.6 0 6.7 2.4 7.7 5.8l14.8 51.7 51.7 14.8c3.4 1 5.8 4.1 5.8 7.7s-2.4 6.7-5.8 7.7l-51.7 14.8-14.8 51.7c-1 3.4-4.1 5.8-7.7 5.8s-6.7-2.4-7.7-5.8l-14.8-51.7-51.7-14.8c-3.4-1-5.8-4.1-5.8-7.7s2.4-6.7 5.8-7.7l51.7-14.8 14.8-51.7c1-3.4 4.1-5.8 7.7-5.8zM87.7 69.8l14.8 51.7 51.7 14.8c3.4 1 5.8 4.1 5.8 7.7s-2.4 6.7-5.8 7.7l-51.7 14.8L87.7 218.2c-1 3.4-4.1 5.8-7.7 5.8s-6.7-2.4-7.7-5.8L57.5 166.5 5.8 151.7c-3.4-1-5.8-4.1-5.8-7.7s2.4-6.7 5.8-7.7l51.7-14.8L72.3 69.8c1-3.4 4.1-5.8 7.7-5.8s6.7 2.4 7.7 5.8zM208 0c3.7 0 6.9 2.5 7.8 6.1l6.8 27.3 27.3 6.8c3.6 .9 6.1 4.1 6.1 7.8s-2.5 6.9-6.1 7.8l-27.3 6.8-6.8 27.3c-.9 3.6-4.1 6.1-7.8 6.1s-6.9-2.5-7.8-6.1l-6.8-27.3-27.3-6.8c-3.6-.9-6.1-4.1-6.1-7.8s2.5-6.9 6.1-7.8l27.3-6.8 6.8-27.3c.9-3.6 4.1-6.1 7.8-6.1z"
    ]
};
const $d8206b3ab2e65c05$export$7480721bf113be3e = {
    prefix: 'fas',
    iconName: 'ellipsis-vertical',
    icon: [
        128,
        512,
        [
            "ellipsis-v"
        ],
        "f142",
        "M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z"
    ]
};
const $d8206b3ab2e65c05$export$e58494c7fcb5380 = $d8206b3ab2e65c05$export$7480721bf113be3e;
const $d8206b3ab2e65c05$export$3604f15924cf0b98 = {
    prefix: 'fas',
    iconName: 'ticket',
    icon: [
        576,
        512,
        [
            127903
        ],
        "f145",
        "M64 64C28.7 64 0 92.7 0 128l0 64c0 8.8 7.4 15.7 15.7 18.6C34.5 217.1 48 235 48 256s-13.5 38.9-32.3 45.4C7.4 304.3 0 311.2 0 320l0 64c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-64c0-8.8-7.4-15.7-15.7-18.6C541.5 294.9 528 277 528 256s13.5-38.9 32.3-45.4c8.3-2.9 15.7-9.8 15.7-18.6l0-64c0-35.3-28.7-64-64-64L64 64zm64 112l0 160c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16l0-160c0-8.8-7.2-16-16-16l-288 0c-8.8 0-16 7.2-16 16zM96 160c0-17.7 14.3-32 32-32l320 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32l-320 0c-17.7 0-32-14.3-32-32l0-192z"
    ]
};
const $d8206b3ab2e65c05$export$a1cca9928dcf9798 = {
    prefix: 'fas',
    iconName: 'power-off',
    icon: [
        512,
        512,
        [
            9211
        ],
        "f011",
        "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 224c0 17.7 14.3 32 32 32s32-14.3 32-32l0-224zM143.5 120.6c13.6-11.3 15.4-31.5 4.1-45.1s-31.5-15.4-45.1-4.1C49.7 115.4 16 181.8 16 256c0 132.5 107.5 240 240 240s240-107.5 240-240c0-74.2-33.8-140.6-86.6-184.6c-13.6-11.3-33.8-9.4-45.1 4.1s-9.4 33.8 4.1 45.1c38.9 32.3 63.5 81 63.5 135.4c0 97.2-78.8 176-176 176s-176-78.8-176-176c0-54.4 24.7-103.1 63.5-135.4z"
    ]
};
const $d8206b3ab2e65c05$export$b356b1dbe7d7f736 = {
    prefix: 'fas',
    iconName: 'right-long',
    icon: [
        512,
        512,
        [
            "long-arrow-alt-right"
        ],
        "f30b",
        "M334.5 414c8.8 3.8 19 2 26-4.6l144-136c4.8-4.5 7.5-10.8 7.5-17.4s-2.7-12.9-7.5-17.4l-144-136c-7-6.6-17.2-8.4-26-4.6s-14.5 12.5-14.5 22l0 72L32 192c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l288 0 0 72c0 9.6 5.7 18.2 14.5 22z"
    ]
};
const $d8206b3ab2e65c05$export$533e1f578f74c066 = $d8206b3ab2e65c05$export$b356b1dbe7d7f736;
const $d8206b3ab2e65c05$export$19357abad396e723 = {
    prefix: 'fas',
    iconName: 'flag-usa',
    icon: [
        448,
        512,
        [],
        "f74d",
        "M32 0C49.7 0 64 14.3 64 32l0 16 69-17.2c38.1-9.5 78.3-5.1 113.5 12.5c46.3 23.2 100.8 23.2 147.1 0l9.6-4.8C423.8 28.1 448 43.1 448 66.1l0 36.1-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-20.3-9-41.8-14.7-63.6-16.9l0 32.2c17.4 2.1 34.4 6.7 50.6 13.9l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4L448 136.3l0 62-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-40.2-17.9-85-22.5-128.1-13.3L64 203.1l0 32.7 70.2-15.1c36.4-7.8 74.3-3.9 108.4 11.3l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4L448 232.3l0 62-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-40.2-17.9-85-22.5-128.1-13.3L64 299.1l0 32.7 70.2-15.1c36.4-7.8 74.3-3.9 108.4 11.3l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4L448 328.3l0 33.5c0 13.3-8.3 25.3-20.8 30l-34.7 13c-46.2 17.3-97.6 14.6-141.7-7.4c-37.9-19-81.3-23.7-122.5-13.4L64 400l0 80c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64 0-70.5 0-32.7 0-63.3 0-32.7 0-63.3 0-32.7L0 64 0 32C0 14.3 14.3 0 32 0zm80 96A16 16 0 1 0 80 96a16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-32 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
const $d8206b3ab2e65c05$export$e1046cf83da9b7ef = {
    prefix: 'fas',
    iconName: 'laptop-file',
    icon: [
        640,
        512,
        [],
        "e51d",
        "M128 0C92.7 0 64 28.7 64 64l0 224-44.8 0C8.6 288 0 296.6 0 307.2C0 349.6 34.4 384 76.8 384L320 384l0-96-192 0 0-224 320 0 0 32 64 0 0-32c0-35.3-28.7-64-64-64L128 0zM512 128l-112 0c-26.5 0-48 21.5-48 48l0 288c0 26.5 21.5 48 48 48l192 0c26.5 0 48-21.5 48-48l0-208-96 0c-17.7 0-32-14.3-32-32l0-96zm32 0l0 96 96 0-96-96z"
    ]
};
const $d8206b3ab2e65c05$export$7c85aba0f9624b29 = {
    prefix: 'fas',
    iconName: 'tty',
    icon: [
        512,
        512,
        [
            "teletype"
        ],
        "f1e4",
        "M38.3 241.3L15.1 200.6c-9.2-16.2-8.4-36.5 4.5-50C61.4 106.8 144.7 48 256 48s194.6 58.8 236.4 102.6c12.9 13.5 13.7 33.8 4.5 50l-23.1 40.7c-7.5 13.2-23.3 19.3-37.8 14.6l-81.1-26.6c-13.1-4.3-22-16.6-22-30.4l0-54.8c-49.6-18.1-104-18.1-153.6 0l0 54.8c0 13.8-8.9 26.1-22 30.4L76.1 255.8c-14.5 4.7-30.3-1.4-37.8-14.6zM32 336c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM144 320l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm112-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM128 432c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16l0-32z"
    ]
};
const $d8206b3ab2e65c05$export$14bcd5c43dc736f9 = $d8206b3ab2e65c05$export$7c85aba0f9624b29;
const $d8206b3ab2e65c05$export$2faddf1690e14e11 = {
    prefix: 'fas',
    iconName: 'diagram-next',
    icon: [
        512,
        512,
        [],
        "e476",
        "M512 160c0 35.3-28.7 64-64 64l-168 0 0 64 46.1 0c21.4 0 32.1 25.9 17 41L273 399c-9.4 9.4-24.6 9.4-33.9 0L169 329c-15.1-15.1-4.4-41 17-41l46.1 0 0-64L64 224c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 64zM448 416l0-64-82.7 0 .4-.4c18.4-18.4 20.4-43.7 11-63.6l71.3 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l71.3 0c-9.4 19.9-7.4 45.2 11 63.6l.4 .4L64 352l0 64 146.7 0 5.7 5.7c21.9 21.9 57.3 21.9 79.2 0l5.7-5.7L448 416z"
    ]
};
const $d8206b3ab2e65c05$export$b16df914812cedbe = {
    prefix: 'fas',
    iconName: 'person-rifle',
    icon: [
        576,
        512,
        [],
        "e54e",
        "M265.2 192c25.4 0 49.8 7.1 70.8 19.9L336 512l-192 0 0-174.3L90.4 428.3c-11.2 19-35.8 25.3-54.8 14.1s-25.3-35.8-14.1-54.8L97.7 258.8c24.5-41.4 69-66.8 117.1-66.8l50.4 0zM160 80a80 80 0 1 1 160 0A80 80 0 1 1 160 80zM448 0c8.8 0 16 7.2 16 16l0 116.3c9.6 5.5 16 15.9 16 27.7l0 109.3 16-5.3 0-56c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 84.5c0 6.9-4.4 13-10.9 15.2L480 325.3l0 26.7 48 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-44 0 23 92.1c2.5 10.1-5.1 19.9-15.5 19.9L432 512c-8.8 0-16-7.2-16-16l0-96-16 0c-17.7 0-32-14.3-32-32l0-144c0-17.7 14.3-32 32-32l0-32c0-11.8 6.4-22.2 16-27.7L416 32c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 16 0z"
    ]
};
const $d8206b3ab2e65c05$export$bc50edea6e121df5 = {
    prefix: 'fas',
    iconName: 'house-medical-circle-exclamation',
    icon: [
        640,
        512,
        [],
        "e512",
        "M320 368c0 59.5 29.5 112.1 74.8 144l-266.7 0c-35.3 0-64-28.7-64-64l0-160.4-32 0c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L522.1 193.9c-8.5-1.3-17.3-1.9-26.1-1.9c-54.7 0-103.5 24.9-135.8 64L320 256l0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16z"
    ]
};
const $d8206b3ab2e65c05$export$8e047801a8603af7 = {
    prefix: 'fas',
    iconName: 'closed-captioning',
    icon: [
        576,
        512,
        [],
        "f20a",
        "M0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM200 208c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48s21.5-48 48-48zm144 48c0-26.5 21.5-48 48-48c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48z"
    ]
};
const $d8206b3ab2e65c05$export$baf9f153991b2ea = {
    prefix: 'fas',
    iconName: 'person-hiking',
    icon: [
        384,
        512,
        [
            "hiking"
        ],
        "f6ec",
        "M192 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm51.3 182.7L224.2 307l49.7 49.7c9 9 14.1 21.2 14.1 33.9l0 89.4c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-82.7-73.9-73.9c-15.8-15.8-22.2-38.6-16.9-60.3l20.4-84c8.3-34.1 42.7-54.9 76.7-46.4c19 4.8 35.6 16.4 46.4 32.7L305.1 208l30.9 0 0-24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 55.8c0 .1 0 .2 0 .2s0 .2 0 .2L384 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-216-39.4 0c-16 0-31-8-39.9-21.4l-13.3-20zM81.1 471.9L117.3 334c3 4.2 6.4 8.2 10.1 11.9l41.9 41.9L142.9 488.1c-4.5 17.1-22 27.3-39.1 22.8s-27.3-22-22.8-39.1zm55.5-346L101.4 266.5c-3 12.1-14.9 19.9-27.2 17.9l-47.9-8c-14-2.3-22.9-16.3-19.2-30L31.9 155c9.5-34.8 41.1-59 77.2-59l4.2 0c15.6 0 27.1 14.7 23.3 29.8z"
    ]
};
const $d8206b3ab2e65c05$export$b2ab0105a901499e = $d8206b3ab2e65c05$export$baf9f153991b2ea;
const $d8206b3ab2e65c05$export$6a6f9cba7a1e5fe4 = {
    prefix: 'fas',
    iconName: 'venus-double',
    icon: [
        640,
        512,
        [
            9890
        ],
        "f226",
        "M192 288a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM368 176c0 86.3-62.1 158.1-144 173.1l0 34.9 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-34.9C78.1 334.1 16 262.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176zM344 318c14.6-15.6 26.8-33.4 36-53c18.8 14.4 42.4 23 68 23c61.9 0 112-50.1 112-112s-50.1-112-112-112c-25.6 0-49.1 8.6-68 23c-9.3-19.5-21.5-37.4-36-53C373.1 12.6 409.1 0 448 0c97.2 0 176 78.8 176 176c0 86.3-62.1 158.1-144 173.1l0 34.9 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-34.9c-26.6-4.9-51.1-15.7-72-31.1z"
    ]
};
const $d8206b3ab2e65c05$export$74f06b41ed2ca28a = {
    prefix: 'fas',
    iconName: 'images',
    icon: [
        576,
        512,
        [],
        "f302",
        "M160 32c-35.3 0-64 28.7-64 64l0 224c0 35.3 28.7 64 64 64l352 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L160 32zM396 138.7l96 144c4.9 7.4 5.4 16.8 1.2 24.6S480.9 320 472 320l-144 0-48 0-80 0c-9.2 0-17.6-5.3-21.6-13.6s-2.9-18.2 2.9-25.4l64-80c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9l17.3 21.6 56-84C360.5 132 368 128 376 128s15.5 4 20 10.7zM192 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 344c0 75.1 60.9 136 136 136l320 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-320 0c-48.6 0-88-39.4-88-88l0-224z"
    ]
};
const $d8206b3ab2e65c05$export$693bd40950ed2c3a = {
    prefix: 'fas',
    iconName: 'calculator',
    icon: [
        384,
        512,
        [
            128425
        ],
        "f1ec",
        "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zM96 64l192 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32L96 160c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32zm32 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM96 352a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM64 416c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32zM192 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64-64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"
    ]
};
const $d8206b3ab2e65c05$export$dace56f632fecf6f = {
    prefix: 'fas',
    iconName: 'people-pulling',
    icon: [
        576,
        512,
        [],
        "e535",
        "M80 96A48 48 0 1 0 80 0a48 48 0 1 0 0 96zM64 128c-35.3 0-64 28.7-64 64L0 320c0 17.7 14.3 32 32 32c9.8 0 18.5-4.4 24.4-11.2L80.4 485.3c2.9 17.4 19.4 29.2 36.8 26.3s29.2-19.4 26.3-36.8L123.1 352l15.7 0 30 134.9c3.8 17.3 20.9 28.1 38.2 24.3s28.1-20.9 24.3-38.2l-57.3-258 116.3 53.8c.5 .3 1.1 .5 1.6 .7c8.6 3.6 18 3.1 25.9-.7c3.4-1.6 6.6-3.9 9.3-6.7c3.1-3.2 5.5-7 7.1-11.4c.1-.3 .2-.7 .3-1l2.5-7.5c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L537 232.7l-15.3-36.8C504.5 154.8 464.3 128 419.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-24.4 10.9-44.6 29-58.1 51.6L157.3 136.9C144.7 131 130.9 128 117 128l-53 0zM464 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM349.7 335.6l-25 62.4-59.4 59.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L372.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6z"
    ]
};
const $d8206b3ab2e65c05$export$328a9baf0f9e3405 = {
    prefix: 'fas',
    iconName: 'n',
    icon: [
        384,
        512,
        [
            110
        ],
        "4e",
        "M21.1 33.9c12.7-4.6 26.9-.7 35.5 9.6L320 359.6 320 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 384c0 13.5-8.4 25.5-21.1 30.1s-26.9 .7-35.5-9.6L64 152.4 64 448c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 64C0 50.5 8.4 38.5 21.1 33.9z"
    ]
};
const $d8206b3ab2e65c05$export$85cb04eaefaf2d8b = {
    prefix: 'fas',
    iconName: 'cable-car',
    icon: [
        512,
        512,
        [
            128673,
            57551,
            "tram"
        ],
        "f7da",
        "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM160 56a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32 288c0-35.3 28.7-64 64-64l136 0 0-66.5-203.1 42c-13 2.7-25.7-5.7-28.4-18.6s5.7-25.7 18.6-28.4l232-48 232-48c13-2.7 25.7 5.7 28.4 18.6s-5.7 25.7-18.6 28.4L280 147.5l0 76.5 136 0c35.3 0 64 28.7 64 64l0 160c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-160zm64 0c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-64 0zm112 16l0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-64 0z"
    ]
};
const $d8206b3ab2e65c05$export$a7a36674c079f293 = $d8206b3ab2e65c05$export$85cb04eaefaf2d8b;
const $d8206b3ab2e65c05$export$a6c308ee087b4ded = {
    prefix: 'fas',
    iconName: 'cloud-rain',
    icon: [
        512,
        512,
        [
            127783,
            9926
        ],
        "f73d",
        "M96 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96L96 320zm-6.8 52c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3l0 3c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-3c0-8.5 2.1-16.9 6.2-24.3L89.2 372zm160 0c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3l0 3c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-3c0-8.5 2.1-16.9 6.2-24.3L249.2 372zm124.9 64.6L409.2 372c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3l0 3c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-3c0-8.5 2.1-16.9 6.2-24.3z"
    ]
};
const $d8206b3ab2e65c05$export$c4c015418a1f24df = {
    prefix: 'fas',
    iconName: 'building-circle-xmark',
    icon: [
        640,
        512,
        [],
        "e4d4",
        "M48 0C21.5 0 0 21.5 0 48L0 464c0 26.5 21.5 48 48 48l96 0 0-80c0-26.5 21.5-48 48-48s48 21.5 48 48l0 80 96 0c15.1 0 28.5-6.9 37.3-17.8C340.4 462.2 320 417.5 320 368c0-54.7 24.9-103.5 64-135.8L384 48c0-26.5-21.5-48-48-48L48 0zM64 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm112-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM80 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM272 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
const $d8206b3ab2e65c05$export$6c645741140616af = {
    prefix: 'fas',
    iconName: 'ship',
    icon: [
        576,
        512,
        [
            128674
        ],
        "f21a",
        "M192 32c0-17.7 14.3-32 32-32L352 0c17.7 0 32 14.3 32 32l0 32 48 0c26.5 0 48 21.5 48 48l0 128 44.4 14.8c23.1 7.7 29.5 37.5 11.5 53.9l-101 92.6c-16.2 9.4-34.7 15.1-50.9 15.1c-19.6 0-40.8-7.7-59.2-20.3c-22.1-15.5-51.6-15.5-73.7 0c-17.1 11.8-38 20.3-59.2 20.3c-16.2 0-34.7-5.7-50.9-15.1l-101-92.6c-18-16.5-11.6-46.2 11.5-53.9L96 240l0-128c0-26.5 21.5-48 48-48l48 0 0-32zM160 218.7l107.8-35.9c13.1-4.4 27.3-4.4 40.5 0L416 218.7l0-90.7-256 0 0 90.7zM306.5 421.9C329 437.4 356.5 448 384 448c26.9 0 55.4-10.8 77.4-26.1c0 0 0 0 0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7c0 0 0 0 0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
const $d8206b3ab2e65c05$export$8f2463c7b2fc6ae4 = {
    prefix: 'fas',
    iconName: 'arrows-down-to-line',
    icon: [
        576,
        512,
        [],
        "e4b8",
        "M544 416L32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l512 0c17.7 0 32-14.3 32-32s-14.3-32-32-32zm22.6-137.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L480 274.7 480 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 210.7-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96zm-320-45.3c-12.5-12.5-32.8-12.5-45.3 0L160 274.7 160 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 210.7L54.6 233.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3z"
    ]
};
const $d8206b3ab2e65c05$export$8f734e51d72ca13a = {
    prefix: 'fas',
    iconName: 'download',
    icon: [
        512,
        512,
        [],
        "f019",
        "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 242.7-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7 288 32zM64 352c-35.3 0-64 28.7-64 64l0 32c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-32c0-35.3-28.7-64-64-64l-101.5 0-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352 64 352zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
const $d8206b3ab2e65c05$export$92292137ef3cf4c8 = {
    prefix: 'fas',
    iconName: 'face-grin',
    icon: [
        512,
        512,
        [
            128512,
            "grin"
        ],
        "f580",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $d8206b3ab2e65c05$export$37e1f10b6de76621 = $d8206b3ab2e65c05$export$92292137ef3cf4c8;
const $d8206b3ab2e65c05$export$bbcc9e0b6022772b = {
    prefix: 'fas',
    iconName: 'delete-left',
    icon: [
        576,
        512,
        [
            9003,
            "backspace"
        ],
        "f55a",
        "M576 128c0-35.3-28.7-64-64-64L205.3 64c-17 0-33.3 6.7-45.3 18.7L9.4 233.4c-6 6-9.4 14.1-9.4 22.6s3.4 16.6 9.4 22.6L160 429.3c12 12 28.3 18.7 45.3 18.7L512 448c35.3 0 64-28.7 64-64l0-256zM271 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
const $d8206b3ab2e65c05$export$e43e3f67102fc526 = $d8206b3ab2e65c05$export$bbcc9e0b6022772b;
const $d8206b3ab2e65c05$export$1bc3e0ad56dc9eb0 = {
    prefix: 'fas',
    iconName: 'eye-dropper',
    icon: [
        512,
        512,
        [
            "eye-dropper-empty",
            "eyedropper"
        ],
        "f1fb",
        "M341.6 29.2L240.1 130.8l-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4L482.8 170.4c39-39 39-102.2 0-141.1s-102.2-39-141.1 0zM55.4 323.3c-15 15-23.4 35.4-23.4 56.6l0 42.4L5.4 462.2c-8.5 12.7-6.8 29.6 4 40.4s27.7 12.5 40.4 4L89.7 480l42.4 0c21.2 0 41.6-8.4 56.6-23.4L309.4 335.9l-45.3-45.3L143.4 411.3c-3 3-7.1 4.7-11.3 4.7L96 416l0-36.1c0-4.2 1.7-8.3 4.7-11.3L221.4 247.9l-45.3-45.3L55.4 323.3z"
    ]
};
const $d8206b3ab2e65c05$export$ef304e9b7524c1f9 = $d8206b3ab2e65c05$export$1bc3e0ad56dc9eb0;
const $d8206b3ab2e65c05$export$91549a375c0b6d25 = $d8206b3ab2e65c05$export$1bc3e0ad56dc9eb0;
const $d8206b3ab2e65c05$export$8547e9f3a2ddab5b = {
    prefix: 'fas',
    iconName: 'file-circle-check',
    icon: [
        576,
        512,
        [],
        "e5a0",
        "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
    ]
};
const $d8206b3ab2e65c05$export$a8710cdb23198d53 = {
    prefix: 'fas',
    iconName: 'forward',
    icon: [
        512,
        512,
        [
            9193
        ],
        "f04e",
        "M52.5 440.6c-9.5 7.9-22.8 9.7-34.1 4.4S0 428.4 0 416L0 96C0 83.6 7.2 72.3 18.4 67s24.5-3.6 34.1 4.4L224 214.3l0 41.7 0 41.7L52.5 440.6zM256 352l0-96 0-128 0-32c0-12.4 7.2-23.7 18.4-29s24.5-3.6 34.1 4.4l192 160c7.3 6.1 11.5 15.1 11.5 24.6s-4.2 18.5-11.5 24.6l-192 160c-9.5 7.9-22.8 9.7-34.1 4.4s-18.4-16.6-18.4-29l0-64z"
    ]
};
const $d8206b3ab2e65c05$export$59edacfad04cd121 = {
    prefix: 'fas',
    iconName: 'mobile',
    icon: [
        384,
        512,
        [
            128241,
            "mobile-android",
            "mobile-phone"
        ],
        "f3ce",
        "M80 0C44.7 0 16 28.7 16 64l0 384c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L80 0zm80 432l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
const $d8206b3ab2e65c05$export$82f602311a698c32 = $d8206b3ab2e65c05$export$59edacfad04cd121;
const $d8206b3ab2e65c05$export$475a9be8da747e57 = $d8206b3ab2e65c05$export$59edacfad04cd121;
const $d8206b3ab2e65c05$export$dc130582748497c6 = {
    prefix: 'fas',
    iconName: 'face-meh',
    icon: [
        512,
        512,
        [
            128528,
            "meh"
        ],
        "f11a",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM160 336l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
const $d8206b3ab2e65c05$export$6d2db489aaeeecd2 = $d8206b3ab2e65c05$export$dc130582748497c6;
const $d8206b3ab2e65c05$export$70e29dd05344623e = {
    prefix: 'fas',
    iconName: 'align-center',
    icon: [
        448,
        512,
        [],
        "f037",
        "M352 64c0-17.7-14.3-32-32-32L128 32c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0c17.7 0 32-14.3 32-32zm96 128c0-17.7-14.3-32-32-32L32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32zM0 448c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 416c-17.7 0-32 14.3-32 32zM352 320c0-17.7-14.3-32-32-32l-192 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0c17.7 0 32-14.3 32-32z"
    ]
};
const $d8206b3ab2e65c05$export$a57d448e8969ce8a = {
    prefix: 'fas',
    iconName: 'book-skull',
    icon: [
        448,
        512,
        [
            "book-dead"
        ],
        "f6b7",
        "M0 96C0 43 43 0 96 0L384 0l32 0c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32l0 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0L96 512c-53 0-96-43-96-96L0 96zM64 416c0 17.7 14.3 32 32 32l256 0 0-64L96 384c-17.7 0-32 14.3-32 32zM320 112c0-35.3-35.8-64-80-64s-80 28.7-80 64c0 20.9 12.6 39.5 32 51.2l0 12.8c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16l0-12.8c19.4-11.7 32-30.3 32-51.2zM208 96a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM134.3 209.3c-8.1-3.5-17.5 .3-21 8.4s.3 17.5 8.4 21L199.4 272l-77.7 33.3c-8.1 3.5-11.9 12.9-8.4 21s12.9 11.9 21 8.4L240 289.4l105.7 45.3c8.1 3.5 17.5-.3 21-8.4s-.3-17.5-8.4-21L280.6 272l77.7-33.3c8.1-3.5 11.9-12.9 8.4-21s-12.9-11.9-21-8.4L240 254.6 134.3 209.3z"
    ]
};
const $d8206b3ab2e65c05$export$b98a3f8c3941a74a = $d8206b3ab2e65c05$export$a57d448e8969ce8a;
const $d8206b3ab2e65c05$export$782ac893fc22249b = {
    prefix: 'fas',
    iconName: 'id-card',
    icon: [
        576,
        512,
        [
            62147,
            "drivers-license"
        ],
        "f2c2",
        "M0 96l576 0c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm0 32L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-288L0 128zM64 405.3c0-29.5 23.9-53.3 53.3-53.3l117.3 0c29.5 0 53.3 23.9 53.3 53.3c0 5.9-4.8 10.7-10.7 10.7L74.7 416c-5.9 0-10.7-4.8-10.7-10.7zM176 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm176 16c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16z"
    ]
};
const $d8206b3ab2e65c05$export$8359c70e609eff64 = $d8206b3ab2e65c05$export$782ac893fc22249b;
const $d8206b3ab2e65c05$export$e21cfc4f23776bff = {
    prefix: 'fas',
    iconName: 'outdent',
    icon: [
        448,
        512,
        [
            "dedent"
        ],
        "f03b",
        "M0 64C0 46.3 14.3 32 32 32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64zM192 192c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32zm32 96l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zM0 448c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32zM.2 268.6c-8.2-6.4-8.2-18.9 0-25.3l101.9-79.3c10.5-8.2 25.8-.7 25.8 12.6l0 158.6c0 13.3-15.3 20.8-25.8 12.6L.2 268.6z"
    ]
};
const $d8206b3ab2e65c05$export$cbffb369d9299db7 = $d8206b3ab2e65c05$export$e21cfc4f23776bff;
const $d8206b3ab2e65c05$export$3772719b170306e2 = {
    prefix: 'fas',
    iconName: 'heart-circle-exclamation',
    icon: [
        576,
        512,
        [],
        "e4fe",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6l0-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1l0 5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16z"
    ]
};
const $d8206b3ab2e65c05$export$dcadc0d67468dfa8 = {
    prefix: 'fas',
    iconName: 'house',
    icon: [
        576,
        512,
        [
            127968,
            63498,
            63500,
            "home",
            "home-alt",
            "home-lg-alt"
        ],
        "f015",
        "M575.8 255.5c0 18-15 32.1-32 32.1l-32 0 .7 160.2c0 2.7-.2 5.4-.5 8.1l0 16.2c0 22.1-17.9 40-40 40l-16 0c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1L416 512l-24 0c-22.1 0-40-17.9-40-40l0-24 0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 64 0 24c0 22.1-17.9 40-40 40l-24 0-31.9 0c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2l-16 0c-22.1 0-40-17.9-40-40l0-112c0-.9 0-1.9 .1-2.8l0-69.7-32 0c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"
    ]
};
const $d8206b3ab2e65c05$export$48f10d71ec526479 = $d8206b3ab2e65c05$export$dcadc0d67468dfa8;
const $d8206b3ab2e65c05$export$279659c4b23dbedb = $d8206b3ab2e65c05$export$dcadc0d67468dfa8;
const $d8206b3ab2e65c05$export$20d6d52d45f53262 = $d8206b3ab2e65c05$export$dcadc0d67468dfa8;
const $d8206b3ab2e65c05$export$39be5cb4aed5a521 = {
    prefix: 'fas',
    iconName: 'calendar-week',
    icon: [
        448,
        512,
        [],
        "f784",
        "M128 0c17.7 0 32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 48 0c26.5 0 48 21.5 48 48l0 48L0 160l0-48C0 85.5 21.5 64 48 64l48 0 0-32c0-17.7 14.3-32 32-32zM0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192zm80 64c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16L80 256z"
    ]
};
const $d8206b3ab2e65c05$export$ba2fa38f7bcc6930 = {
    prefix: 'fas',
    iconName: 'laptop-medical',
    icon: [
        640,
        512,
        [],
        "f812",
        "M64 96c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 256-64 0 0-256L128 96l0 256-64 0L64 96zM0 403.2C0 392.6 8.6 384 19.2 384l601.6 0c10.6 0 19.2 8.6 19.2 19.2c0 42.4-34.4 76.8-76.8 76.8L76.8 480C34.4 480 0 445.6 0 403.2zM288 160c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z"
    ]
};
const $d8206b3ab2e65c05$export$fa30fcd1e0d0d8 = {
    prefix: 'fas',
    iconName: 'b',
    icon: [
        320,
        512,
        [
            98
        ],
        "42",
        "M64 32C28.7 32 0 60.7 0 96L0 256 0 416c0 35.3 28.7 64 64 64l128 0c70.7 0 128-57.3 128-128c0-46.5-24.8-87.3-62-109.7c18.7-22.3 30-51 30-82.3c0-70.7-57.3-128-128-128L64 32zm96 192l-96 0L64 96l96 0c35.3 0 64 28.7 64 64s-28.7 64-64 64zM64 288l96 0 32 0c35.3 0 64 28.7 64 64s-28.7 64-64 64L64 416l0-128z"
    ]
};
const $d8206b3ab2e65c05$export$56cbcd962389b090 = {
    prefix: 'fas',
    iconName: 'file-medical',
    icon: [
        384,
        512,
        [],
        "f477",
        "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM160 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z"
    ]
};
const $d8206b3ab2e65c05$export$d91800b7be5303b0 = {
    prefix: 'fas',
    iconName: 'dice-one',
    icon: [
        448,
        512,
        [
            9856
        ],
        "f525",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $d8206b3ab2e65c05$export$d9933d91e1314d02 = {
    prefix: 'fas',
    iconName: 'kiwi-bird',
    icon: [
        576,
        512,
        [],
        "f535",
        "M291.2 388.4c31.2-18.8 64.7-36.4 101.1-36.4l55.7 0c4.6 0 9.1-.2 13.6-.7l85.3 121.9c4 5.7 11.3 8.2 17.9 6.1s11.2-8.3 11.2-15.3l0-240c0-70.7-57.3-128-128-128l-55.7 0c-36.4 0-69.9-17.6-101.1-36.4C262.3 42.1 228.3 32 192 32C86 32 0 118 0 224c0 71.1 38.6 133.1 96 166.3L96 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-46c15.3 3.9 31.4 6 48 6c5.4 0 10.7-.2 16-.7l0 40.7c0 13.3 10.7 24 24 24s24-10.7 24-24l0-50.9c12.4-4.4 24.2-10 35.2-16.7zM448 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
const $d8206b3ab2e65c05$export$56b6d3d7d0e67a1c = {
    prefix: 'fas',
    iconName: 'arrow-right-arrow-left',
    icon: [
        448,
        512,
        [
            8644,
            "exchange"
        ],
        "f0ec",
        "M438.6 150.6c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.7 96 32 96C14.3 96 0 110.3 0 128s14.3 32 32 32l306.7 0-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l96-96zm-333.3 352c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 416 416 416c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0 41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96z"
    ]
};
const $d8206b3ab2e65c05$export$1aab915ca61b734a = $d8206b3ab2e65c05$export$56b6d3d7d0e67a1c;
const $d8206b3ab2e65c05$export$7f465bf410c6eff7 = {
    prefix: 'fas',
    iconName: 'rotate-right',
    icon: [
        512,
        512,
        [
            "redo-alt",
            "rotate-forward"
        ],
        "f2f9",
        "M463.5 224l8.5 0c13.3 0 24-10.7 24-24l0-128c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1c-87.5 87.5-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8l119.5 0z"
    ]
};
const $d8206b3ab2e65c05$export$50c037520c6cfdc1 = $d8206b3ab2e65c05$export$7f465bf410c6eff7;
const $d8206b3ab2e65c05$export$2507849a0fdd7f64 = $d8206b3ab2e65c05$export$7f465bf410c6eff7;
const $d8206b3ab2e65c05$export$750d52edc1dafc7 = {
    prefix: 'fas',
    iconName: 'utensils',
    icon: [
        448,
        512,
        [
            127860,
            61685,
            "cutlery"
        ],
        "f2e7",
        "M416 0C400 0 288 32 288 176l0 112c0 35.3 28.7 64 64 64l32 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 0-112 0-208c0-17.7-14.3-32-32-32zM64 16C64 7.8 57.9 1 49.7 .1S34.2 4.6 32.4 12.5L2.1 148.8C.7 155.1 0 161.5 0 167.9c0 45.9 35.1 83.6 80 87.7L80 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-224.4c44.9-4.1 80-41.8 80-87.7c0-6.4-.7-12.8-2.1-19.1L191.6 12.5c-1.8-8-9.3-13.3-17.4-12.4S160 7.8 160 16l0 134.2c0 5.4-4.4 9.8-9.8 9.8c-5.1 0-9.3-3.9-9.8-9L127.9 14.6C127.2 6.3 120.3 0 112 0s-15.2 6.3-15.9 14.6L83.7 151c-.5 5.1-4.7 9-9.8 9c-5.4 0-9.8-4.4-9.8-9.8L64 16zm48.3 152l-.3 0-.3 0 .3-.7 .3 .7z"
    ]
};
const $d8206b3ab2e65c05$export$7034e54a8036c5c8 = $d8206b3ab2e65c05$export$750d52edc1dafc7;
const $d8206b3ab2e65c05$export$63f4908401ded049 = {
    prefix: 'fas',
    iconName: 'arrow-up-wide-short',
    icon: [
        576,
        512,
        [
            "sort-amount-up"
        ],
        "f161",
        "M151.6 42.4C145.5 35.8 137 32 128 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L96 146.3 96 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-301.7 32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 480l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128l160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128l224 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32z"
    ]
};
const $d8206b3ab2e65c05$export$28ef3e933e4b5364 = $d8206b3ab2e65c05$export$63f4908401ded049;
const $d8206b3ab2e65c05$export$9b53510cf4010e4d = {
    prefix: 'fas',
    iconName: 'mill-sign',
    icon: [
        384,
        512,
        [],
        "e1ed",
        "M302.1 42.8c5.9-16.6-2.7-35-19.4-40.9s-35 2.7-40.9 19.4L208 116.1c-5.7 4-11.1 8.5-16 13.5C171.7 108.9 143.3 96 112 96c-19.5 0-37.8 5-53.7 13.7C52.5 101.4 42.9 96 32 96C14.3 96 0 110.3 0 128l0 80L0 416c0 17.7 14.3 32 32 32s32-14.3 32-32l0-208c0-26.5 21.5-48 48-48s48 21.5 48 48l0 42.5L81.9 469.2c-5.9 16.6 2.7 35 19.4 40.9s35-2.7 40.9-19.4l21.4-60C168.9 441 179.6 448 192 448c17.7 0 32-14.3 32-32l0-154.5 35.7-100c3.9-1 8.1-1.6 12.3-1.6c26.5 0 48 21.5 48 48l0 208c0 17.7 14.3 32 32 32s32-14.3 32-32l0-208c0-58.2-44.3-106-101.1-111.5l19.2-53.8z"
    ]
};
const $d8206b3ab2e65c05$export$86079bc65a716451 = {
    prefix: 'fas',
    iconName: 'bowl-rice',
    icon: [
        512,
        512,
        [],
        "e2eb",
        "M176 56c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24zm24 48l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM56 176l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM0 283.4C0 268.3 12.3 256 27.4 256l457.1 0c15.1 0 27.4 12.3 27.4 27.4c0 70.5-44.4 130.7-106.7 154.1L403.5 452c-2 16-15.6 28-31.8 28l-231.5 0c-16.1 0-29.8-12-31.8-28l-1.8-14.4C44.4 414.1 0 353.9 0 283.4zM224 200c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24zm-96 0c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24zm-24-96l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm216 96c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24zm-24-96l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm120 96c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24zm-24-96l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM296 32l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
const $d8206b3ab2e65c05$export$138b45e2afb1dfa4 = {
    prefix: 'fas',
    iconName: 'skull',
    icon: [
        512,
        512,
        [
            128128
        ],
        "f54c",
        "M416 398.9c58.5-41.1 96-104.1 96-174.9C512 100.3 397.4 0 256 0S0 100.3 0 224c0 70.7 37.5 133.8 96 174.9c0 .4 0 .7 0 1.1l0 64c0 26.5 21.5 48 48 48l48 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 64 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 48 0c26.5 0 48-21.5 48-48l0-64c0-.4 0-.7 0-1.1zM96 256a64 64 0 1 1 128 0A64 64 0 1 1 96 256zm256-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
    ]
};
const $d8206b3ab2e65c05$export$fd06ff4ce9799eb0 = {
    prefix: 'fas',
    iconName: 'tower-broadcast',
    icon: [
        576,
        512,
        [
            "broadcast-tower"
        ],
        "f519",
        "M80.3 44C69.8 69.9 64 98.2 64 128s5.8 58.1 16.3 84c6.6 16.4-1.3 35-17.7 41.7s-35-1.3-41.7-17.7C7.4 202.6 0 166.1 0 128S7.4 53.4 20.9 20C27.6 3.6 46.2-4.3 62.6 2.3S86.9 27.6 80.3 44zM555.1 20C568.6 53.4 576 89.9 576 128s-7.4 74.6-20.9 108c-6.6 16.4-25.3 24.3-41.7 17.7S489.1 228.4 495.7 212c10.5-25.9 16.3-54.2 16.3-84s-5.8-58.1-16.3-84C489.1 27.6 497 9 513.4 2.3s35 1.3 41.7 17.7zM352 128c0 23.7-12.9 44.4-32 55.4L320 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-296.6c-19.1-11.1-32-31.7-32-55.4c0-35.3 28.7-64 64-64s64 28.7 64 64zM170.6 76.8C163.8 92.4 160 109.7 160 128s3.8 35.6 10.6 51.2c7.1 16.2-.3 35.1-16.5 42.1s-35.1-.3-42.1-16.5c-10.3-23.6-16-49.6-16-76.8s5.7-53.2 16-76.8c7.1-16.2 25.9-23.6 42.1-16.5s23.6 25.9 16.5 42.1zM464 51.2c10.3 23.6 16 49.6 16 76.8s-5.7 53.2-16 76.8c-7.1 16.2-25.9 23.6-42.1 16.5s-23.6-25.9-16.5-42.1c6.8-15.6 10.6-32.9 10.6-51.2s-3.8-35.6-10.6-51.2c-7.1-16.2 .3-35.1 16.5-42.1s35.1 .3 42.1 16.5z"
    ]
};
const $d8206b3ab2e65c05$export$f68b38d51f5c0ed = $d8206b3ab2e65c05$export$fd06ff4ce9799eb0;
const $d8206b3ab2e65c05$export$f846b848b3ba3064 = {
    prefix: 'fas',
    iconName: 'truck-pickup',
    icon: [
        640,
        512,
        [
            128763
        ],
        "f63c",
        "M368.6 96l76.8 96L288 192l0-96 80.6 0zM224 80l0 112L64 192c-17.7 0-32 14.3-32 32l0 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l33.1 0c-.7 5.2-1.1 10.6-1.1 16c0 61.9 50.1 112 112 112s112-50.1 112-112c0-5.4-.4-10.8-1.1-16l66.3 0c-.7 5.2-1.1 10.6-1.1 16c0 61.9 50.1 112 112 112s112-50.1 112-112c0-5.4-.4-10.8-1.1-16l33.1 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-64c0-17.7-14.3-32-32-32l-48.6 0L418.6 56c-12.1-15.2-30.5-24-50-24L272 32c-26.5 0-48 21.5-48 48zm0 288a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm288 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z"
    ]
};
const $d8206b3ab2e65c05$export$5608156cc81126e7 = {
    prefix: 'fas',
    iconName: 'up-long',
    icon: [
        320,
        512,
        [
            "long-arrow-alt-up"
        ],
        "f30c",
        "M318 177.5c3.8-8.8 2-19-4.6-26l-136-144C172.9 2.7 166.6 0 160 0s-12.9 2.7-17.4 7.5l-136 144c-6.6 7-8.4 17.2-4.6 26S14.4 192 24 192l72 0 0 288c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-288 72 0c9.6 0 18.2-5.7 22-14.5z"
    ]
};
const $d8206b3ab2e65c05$export$43c8f2a46326c55f = $d8206b3ab2e65c05$export$5608156cc81126e7;
const $d8206b3ab2e65c05$export$51577929c676143b = {
    prefix: 'fas',
    iconName: 'stop',
    icon: [
        384,
        512,
        [
            9209
        ],
        "f04d",
        "M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"
    ]
};
const $d8206b3ab2e65c05$export$e151fe5abf6db993 = {
    prefix: 'fas',
    iconName: 'code-merge',
    icon: [
        448,
        512,
        [],
        "f387",
        "M80 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm32.4 97.2c28-12.4 47.6-40.5 47.6-73.2c0-44.2-35.8-80-80-80S0 35.8 0 80c0 32.8 19.7 61 48 73.3l0 205.3C19.7 371 0 399.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3l0-86.6c26.7 20.1 60 32 96 32l86.7 0c12.3 28.3 40.5 48 73.3 48c44.2 0 80-35.8 80-80s-35.8-80-80-80c-32.8 0-61 19.7-73.3 48L208 240c-49.9 0-91-38.1-95.6-86.8zM80 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM344 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
const $d8206b3ab2e65c05$export$a9578350255b2b79 = {
    prefix: 'fas',
    iconName: 'upload',
    icon: [
        512,
        512,
        [],
        "f093",
        "M288 109.3L288 352c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-242.7-73.4 73.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L288 109.3zM64 352l128 0c0 35.3 28.7 64 64 64s64-28.7 64-64l128 0c35.3 0 64 28.7 64 64l0 32c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64l0-32c0-35.3 28.7-64 64-64zM432 456a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
const $d8206b3ab2e65c05$export$4cf54a379be7e59a = {
    prefix: 'fas',
    iconName: 'hurricane',
    icon: [
        384,
        512,
        [],
        "f751",
        "M0 208C0 104.4 75.7 18.5 174.9 2.6C184 1.2 192 8.6 192 17.9l0 63.3c0 8.4 6.5 15.3 14.7 16.5C307 112.5 384 199 384 303.4c0 103.6-75.7 189.5-174.9 205.4c-9.2 1.5-17.1-5.9-17.1-15.2l0-63.3c0-8.4-6.5-15.3-14.7-16.5C77 398.9 0 312.4 0 208zm288 48A96 96 0 1 0 96 256a96 96 0 1 0 192 0zm-96-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $d8206b3ab2e65c05$export$ac54ffffdb218383 = {
    prefix: 'fas',
    iconName: 'mound',
    icon: [
        576,
        512,
        [],
        "e52d",
        "M144.1 179.2C173.8 127.7 228.6 96 288 96s114.2 31.7 143.9 83.2L540.4 368c12.3 21.3-3.1 48-27.7 48H63.3c-24.6 0-40-26.6-27.7-48L144.1 179.2z"
    ]
};
const $d8206b3ab2e65c05$export$a3a5de5f6e2513ba = {
    prefix: 'fas',
    iconName: 'toilet-portable',
    icon: [
        320,
        512,
        [],
        "e583",
        "M0 32L0 64l320 0 0-32c0-17.7-14.3-32-32-32L32 0C14.3 0 0 14.3 0 32zM24 96L0 96l0 24L0 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8 224 0 0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-368 0-24-24 0L24 96zM256 240l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
const $d8206b3ab2e65c05$export$84021631df0f831b = {
    prefix: 'fas',
    iconName: 'compact-disc',
    icon: [
        512,
        512,
        [
            128191,
            128192,
            128440
        ],
        "f51f",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-96-32a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zM96 240c0-35 17.5-71.1 45.2-98.8S205 96 240 96c8.8 0 16-7.2 16-16s-7.2-16-16-16c-45.4 0-89.2 22.3-121.5 54.5S64 194.6 64 240c0 8.8 7.2 16 16 16s16-7.2 16-16z"
    ]
};
const $d8206b3ab2e65c05$export$148bcede94488555 = {
    prefix: 'fas',
    iconName: 'file-arrow-down',
    icon: [
        384,
        512,
        [
            "file-download"
        ],
        "f56d",
        "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM216 232l0 102.1 31-31c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-72 72c-9.4 9.4-24.6 9.4-33.9 0l-72-72c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l31 31L168 232c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
const $d8206b3ab2e65c05$export$1013b9966d758343 = $d8206b3ab2e65c05$export$148bcede94488555;
const $d8206b3ab2e65c05$export$afb5d0eee7c1bdb = {
    prefix: 'fas',
    iconName: 'caravan',
    icon: [
        640,
        512,
        [],
        "f8ff",
        "M0 112C0 67.8 35.8 32 80 32l336 0c88.4 0 160 71.6 160 160l0 160 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0-288 0c0 53-43 96-96 96s-96-43-96-96l-16 0c-44.2 0-80-35.8-80-80L0 112zM320 352l128 0 0-96-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 192zM96 128c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L96 128zm96 336a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    ]
};
const $d8206b3ab2e65c05$export$1639f087457d4f58 = {
    prefix: 'fas',
    iconName: 'shield-cat',
    icon: [
        512,
        512,
        [],
        "e572",
        "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM160 154.4c0-5.8 4.7-10.4 10.4-10.4l.2 0c3.4 0 6.5 1.6 8.5 4.3l40 53.3c3 4 7.8 6.4 12.8 6.4l48 0c5 0 9.8-2.4 12.8-6.4l40-53.3c2-2.7 5.2-4.3 8.5-4.3l.2 0c5.8 0 10.4 4.7 10.4 10.4L352 272c0 53-43 96-96 96s-96-43-96-96l0-117.6zM216 288a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm96-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
    ]
};
const $d8206b3ab2e65c05$export$6869964aa308dd31 = {
    prefix: 'fas',
    iconName: 'bolt',
    icon: [
        448,
        512,
        [
            9889,
            "zap"
        ],
        "f0e7",
        "M349.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224c-10 8.8-13.6 22.9-8.9 35.3S50.7 288 64 288l111.5 0L98.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7l-111.5 0L349.4 44.6z"
    ]
};
const $d8206b3ab2e65c05$export$d62abb82664f55ca = $d8206b3ab2e65c05$export$6869964aa308dd31;
const $d8206b3ab2e65c05$export$b80f542550a05ea7 = {
    prefix: 'fas',
    iconName: 'glass-water',
    icon: [
        384,
        512,
        [],
        "e4f4",
        "M32 0C23.1 0 14.6 3.7 8.6 10.2S-.6 25.4 .1 34.3L28.9 437.7c3 41.9 37.8 74.3 79.8 74.3l166.6 0c42 0 76.8-32.4 79.8-74.3L383.9 34.3c.6-8.9-2.4-17.6-8.5-24.1S360.9 0 352 0L32 0zM73 156.5L66.4 64l251.3 0L311 156.5l-24.2 12.1c-19.4 9.7-42.2 9.7-61.6 0c-20.9-10.4-45.5-10.4-66.4 0c-19.4 9.7-42.2 9.7-61.6 0L73 156.5z"
    ]
};
const $d8206b3ab2e65c05$export$b69c6757012a2267 = {
    prefix: 'fas',
    iconName: 'oil-well',
    icon: [
        576,
        512,
        [],
        "e532",
        "M528.3 61.3c-11.4-42.7-55.3-68-98-56.6L414.9 8.8C397.8 13.4 387.7 31 392.3 48l24.5 91.4L308.5 167.5l-6.3-18.1C297.7 136.6 285.6 128 272 128s-25.7 8.6-30.2 21.4l-13.6 39L96 222.6 96 184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 264-16 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l512 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-137.3 0L340 257.5l-62.2 16.1L305.3 352l-66.6 0L265 277l-74.6 19.3L137.3 448 96 448l0-159.2 337.4-87.5 25.2 94c4.6 17.1 22.1 27.2 39.2 22.6l15.5-4.1c42.7-11.4 68-55.3 56.6-98L528.3 61.3zM205.1 448l11.2-32 111.4 0 11.2 32-133.8 0z"
    ]
};
const $d8206b3ab2e65c05$export$4689a147513594a7 = {
    prefix: 'fas',
    iconName: 'vault',
    icon: [
        576,
        512,
        [],
        "e2c5",
        "M64 0C28.7 0 0 28.7 0 64L0 416c0 35.3 28.7 64 64 64l16 0 16 32 64 0 16-32 224 0 16 32 64 0 16-32 16 0c35.3 0 64-28.7 64-64l0-352c0-35.3-28.7-64-64-64L64 0zM224 320a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-240a160 160 0 1 1 0 320 160 160 0 1 1 0-320zM480 221.3L480 336c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-114.7c-18.6-6.6-32-24.4-32-45.3c0-26.5 21.5-48 48-48s48 21.5 48 48c0 20.9-13.4 38.7-32 45.3z"
    ]
};
const $d8206b3ab2e65c05$export$a9f5c0b9c1e77a6f = {
    prefix: 'fas',
    iconName: 'mars',
    icon: [
        448,
        512,
        [
            9794
        ],
        "f222",
        "M289.8 46.8c3.7-9 12.5-14.8 22.2-14.8l112 0c13.3 0 24 10.7 24 24l0 112c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-33.4-33.4L321 204.2c19.5 28.4 31 62.7 31 99.8c0 97.2-78.8 176-176 176S0 401.2 0 304s78.8-176 176-176c37 0 71.4 11.4 99.8 31l52.6-52.6L295 73c-6.9-6.9-8.9-17.2-5.2-26.2zM400 80s0 0 0 0s0 0 0 0s0 0 0 0zM176 416a112 112 0 1 0 0-224 112 112 0 1 0 0 224z"
    ]
};
const $d8206b3ab2e65c05$export$505476859b9691c0 = {
    prefix: 'fas',
    iconName: 'toilet',
    icon: [
        448,
        512,
        [
            128701
        ],
        "f7d8",
        "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l8 0 0 148.9c-1.9 1.4-3.8 2.9-5.6 4.4C10.9 214.5 0 232.9 0 256c0 46.9 14.3 84.1 37 112.5c14.2 17.7 31.1 31.3 48.5 41.8L65.6 469.9c-3.3 9.8-1.6 20.5 4.4 28.8s15.7 13.3 26 13.3l256 0c10.3 0 19.9-4.9 26-13.3s7.7-19.1 4.4-28.8l-19.8-59.5c17.4-10.5 34.3-24.1 48.5-41.8c22.7-28.4 37-65.5 37-112.5c0-23.1-10.9-41.5-26.4-54.6c-1.8-1.5-3.7-3-5.6-4.4L416 48l8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 0zM384 256.3c0 1-.3 2.6-3.8 5.6c-4.8 4.1-14 9-29.3 13.4C320.5 284 276.1 288 224 288s-96.5-4-126.9-12.8c-15.3-4.4-24.5-9.3-29.3-13.4c-3.5-3-3.8-4.6-3.8-5.6l0-.3c0 0 0-.1 0-.1c0-1 0-2.5 3.8-5.8c4.8-4.1 14-9 29.3-13.4C127.5 228 171.9 224 224 224s96.5 4 126.9 12.8c15.3 4.4 24.5 9.3 29.3 13.4c3.8 3.2 3.8 4.8 3.8 5.8c0 0 0 .1 0 .1l0 .3zM328.2 384l-.2 .5 0-.5 .2 0zM112 64l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
const $d8206b3ab2e65c05$export$94ef668f5108e431 = {
    prefix: 'fas',
    iconName: 'plane-circle-xmark',
    icon: [
        640,
        512,
        [],
        "e557",
        "M256 0c-35 0-64 59.5-64 93.7l0 84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9l0 65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49 0 70.9-57.6 43.2c-4 3-6.4 7.8-6.4 12.8l0 42c0 7.8 6.3 14 14 14c1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3 .4 2.6 .5 3.9 .5c6 0 11.1-3.7 13.1-9C344.5 470.7 320 422.2 320 368c0-60.6 30.6-114 77.1-145.6L320 178.3l0-84.6C320 59.5 292 0 256 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
const $d8206b3ab2e65c05$export$30f1437f5a4e991d = {
    prefix: 'fas',
    iconName: 'yen-sign',
    icon: [
        320,
        512,
        [
            165,
            "cny",
            "jpy",
            "rmb",
            "yen"
        ],
        "f157",
        "M58.6 46.3C48.8 31.5 29 27.6 14.2 37.4S-4.4 67 5.4 81.8L100.2 224 48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l80 0 0 32-80 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l80 0 0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64 80 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-80 0 0-32 80 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-52.2 0L314.6 81.8c9.8-14.7 5.8-34.6-8.9-44.4s-34.6-5.8-44.4 8.9L160 198.3 58.6 46.3z"
    ]
};
const $d8206b3ab2e65c05$export$268a23eee8f089a2 = $d8206b3ab2e65c05$export$30f1437f5a4e991d;
const $d8206b3ab2e65c05$export$5460a9192eb79bf5 = $d8206b3ab2e65c05$export$30f1437f5a4e991d;
const $d8206b3ab2e65c05$export$e2a8016afc962883 = $d8206b3ab2e65c05$export$30f1437f5a4e991d;
const $d8206b3ab2e65c05$export$cf914b1afb9455a2 = $d8206b3ab2e65c05$export$30f1437f5a4e991d;
const $d8206b3ab2e65c05$export$1ae0a94c8ba4131a = {
    prefix: 'fas',
    iconName: 'ruble-sign',
    icon: [
        384,
        512,
        [
            8381,
            "rouble",
            "rub",
            "ruble"
        ],
        "f158",
        "M96 32C78.3 32 64 46.3 64 64l0 192-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 32-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-160 0 0-32 112 0c79.5 0 144-64.5 144-144s-64.5-144-144-144L96 32zM240 256l-112 0 0-160 112 0c44.2 0 80 35.8 80 80s-35.8 80-80 80z"
    ]
};
const $d8206b3ab2e65c05$export$c5dc3d98c4d8f2a5 = $d8206b3ab2e65c05$export$1ae0a94c8ba4131a;
const $d8206b3ab2e65c05$export$9c4d936240e1f0b1 = $d8206b3ab2e65c05$export$1ae0a94c8ba4131a;
const $d8206b3ab2e65c05$export$6c0cf65134387046 = $d8206b3ab2e65c05$export$1ae0a94c8ba4131a;
const $d8206b3ab2e65c05$export$2fa35dcbc038dbe9 = {
    prefix: 'fas',
    iconName: 'sun',
    icon: [
        512,
        512,
        [
            9728
        ],
        "f185",
        "M361.5 1.2c5 2.1 8.6 6.6 9.6 11.9L391 121l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L446.9 256l62.3 90.3c3.1 4.5 3.7 10.2 1.6 15.2s-6.6 8.6-11.9 9.6L391 391 371.1 498.9c-1 5.3-4.6 9.8-9.6 11.9s-10.7 1.5-15.2-1.6L256 446.9l-90.3 62.3c-4.5 3.1-10.2 3.7-15.2 1.6s-8.6-6.6-9.6-11.9L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121 140.9 13.1c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L256 65.1 346.3 2.8c4.5-3.1 10.2-3.7 15.2-1.6zM160 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z"
    ]
};
const $d8206b3ab2e65c05$export$790dd5b32282b6fb = {
    prefix: 'fas',
    iconName: 'guitar',
    icon: [
        512,
        512,
        [],
        "f7a6",
        "M465 7c-9.4-9.4-24.6-9.4-33.9 0L383 55c-2.4 2.4-4.3 5.3-5.5 8.5l-15.4 41-77.5 77.6c-45.1-29.4-99.3-30.2-131 1.6c-11 11-18 24.6-21.4 39.6c-3.7 16.6-19.1 30.7-36.1 31.6c-25.6 1.3-49.3 10.7-67.3 28.6C-16 328.4-7.6 409.4 47.5 464.5s136.1 63.5 180.9 18.7c17.9-17.9 27.4-41.7 28.6-67.3c.9-17 15-32.3 31.6-36.1c15-3.4 28.6-10.5 39.6-21.4c31.8-31.8 31-85.9 1.6-131l77.6-77.6 41-15.4c3.2-1.2 6.1-3.1 8.5-5.5l48-48c9.4-9.4 9.4-24.6 0-33.9L465 7zM208 256a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
const $d8206b3ab2e65c05$export$600a1b26b33c3d47 = {
    prefix: 'fas',
    iconName: 'face-laugh-wink',
    icon: [
        512,
        512,
        [
            "laugh-wink"
        ],
        "f59c",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1l275.2 0c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm156.4 25.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"
    ]
};
const $d8206b3ab2e65c05$export$77ac40095f39933e = $d8206b3ab2e65c05$export$600a1b26b33c3d47;
const $d8206b3ab2e65c05$export$5bcca85203ebd1e8 = {
    prefix: 'fas',
    iconName: 'horse-head',
    icon: [
        640,
        512,
        [],
        "f7ab",
        "M64 464l0-147.1c0-108.4 68.3-205.1 170.5-241.3L404.2 15.5C425.6 7.9 448 23.8 448 46.4c0 11-5.5 21.2-14.6 27.3L400 96c48.1 0 91.2 29.8 108.1 74.9l48.6 129.5c11.8 31.4 4.1 66.8-19.6 90.5c-16 16-37.8 25.1-60.5 25.1l-3.4 0c-26.1 0-50.9-11.6-67.6-31.7l-32.3-38.7c-11.7 4.1-24.2 6.4-37.3 6.4c0 0 0 0-.1 0c0 0 0 0 0 0c-6.3 0-12.5-.5-18.6-1.5c-3.6-.6-7.2-1.4-10.7-2.3c0 0 0 0 0 0c-28.9-7.8-53.1-26.8-67.8-52.2c-4.4-7.6-14.2-10.3-21.9-5.8s-10.3 14.2-5.8 21.9c24 41.5 68.3 70 119.3 71.9l47.2 70.8c4 6.1 6.2 13.2 6.2 20.4c0 20.3-16.5 36.8-36.8 36.8L112 512c-26.5 0-48-21.5-48-48zM392 224a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
const $d8206b3ab2e65c05$export$cd79eeea6201e9d4 = {
    prefix: 'fas',
    iconName: 'bore-hole',
    icon: [
        512,
        512,
        [],
        "e4c3",
        "M256 0c-17.7 0-32 14.3-32 32l0 264.6c-19.1 11.1-32 31.7-32 55.4c0 35.3 28.7 64 64 64s64-28.7 64-64c0-23.7-12.9-44.4-32-55.4L288 32c0-17.7-14.3-32-32-32zM48 128c-26.5 0-48 21.5-48 48L0 464c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48l-80 0c-17.7 0-32 14.3-32 32l0 192c0 53-43 96-96 96s-96-43-96-96l0-192c0-17.7-14.3-32-32-32l-80 0z"
    ]
};
const $d8206b3ab2e65c05$export$5548c3eb51060fa8 = {
    prefix: 'fas',
    iconName: 'industry',
    icon: [
        576,
        512,
        [],
        "f275",
        "M64 32C46.3 32 32 46.3 32 64l0 240 0 48 0 80c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48l0-128 0-151.8c0-18.2-19.4-29.7-35.4-21.1L352 215.4l0-63.2c0-18.2-19.4-29.7-35.4-21.1L160 215.4 160 64c0-17.7-14.3-32-32-32L64 32z"
    ]
};
const $d8206b3ab2e65c05$export$531badb89cf01312 = {
    prefix: 'fas',
    iconName: 'circle-down',
    icon: [
        512,
        512,
        [
            61466,
            "arrow-alt-circle-down"
        ],
        "f358",
        "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM244.7 395.3l-112-112c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9l64 0 0-96c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 96 64 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-112 112c-6.2 6.2-16.4 6.2-22.6 0z"
    ]
};
const $d8206b3ab2e65c05$export$ff3afbc8c0bc5d59 = $d8206b3ab2e65c05$export$531badb89cf01312;
const $d8206b3ab2e65c05$export$b9d8fdf63999a76d = {
    prefix: 'fas',
    iconName: 'arrows-turn-to-dots',
    icon: [
        512,
        512,
        [],
        "e4c1",
        "M249.4 25.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L269.3 96 416 96c53 0 96 43 96 96l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32c0-17.7-14.3-32-32-32l-146.7 0 25.4 25.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-80-80c-12.5-12.5-12.5-32.8 0-45.3l80-80zm13.3 256l80 80c12.5 12.5 12.5 32.8 0 45.3l-80 80c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 416 96 416c-17.7 0-32 14.3-32 32l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32c0-53 43-96 96-96l146.7 0-25.4-25.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0zM384 384a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM64 192A64 64 0 1 1 64 64a64 64 0 1 1 0 128z"
    ]
};
const $d8206b3ab2e65c05$export$6248ec7440b2ffcb = {
    prefix: 'fas',
    iconName: 'florin-sign',
    icon: [
        384,
        512,
        [],
        "e184",
        "M314.7 32c-38.8 0-73.7 23.3-88.6 59.1L170.7 224 64 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l80 0L98.9 396.3c-5 11.9-16.6 19.7-29.5 19.7L32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l37.3 0c38.8 0 73.7-23.3 88.6-59.1L213.3 288 320 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-80 0 45.1-108.3c5-11.9 16.6-19.7 29.5-19.7L352 96c17.7 0 32-14.3 32-32s-14.3-32-32-32l-37.3 0z"
    ]
};
const $d8206b3ab2e65c05$export$a51c464b699200ae = {
    prefix: 'fas',
    iconName: 'arrow-down-short-wide',
    icon: [
        576,
        512,
        [
            "sort-amount-desc",
            "sort-amount-down-alt"
        ],
        "f884",
        "M151.6 469.6C145.5 476.2 137 480 128 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L96 365.7 96 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 301.7 32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 32l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128l160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128l224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
const $d8206b3ab2e65c05$export$93835bc31892b5c3 = $d8206b3ab2e65c05$export$a51c464b699200ae;
const $d8206b3ab2e65c05$export$e7d80d8c226cb77 = $d8206b3ab2e65c05$export$a51c464b699200ae;
const $d8206b3ab2e65c05$export$7f24f1bf98af5411 = {
    prefix: 'fas',
    iconName: 'less-than',
    icon: [
        384,
        512,
        [
            62774
        ],
        "3c",
        "M380.6 81.7c7.9 15.8 1.5 35-14.3 42.9L103.6 256 366.3 387.4c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-320-160C6.8 279.2 0 268.1 0 256s6.8-23.2 17.7-28.6l320-160c15.8-7.9 35-1.5 42.9 14.3z"
    ]
};
const $d8206b3ab2e65c05$export$4b5be0142d10f342 = {
    prefix: 'fas',
    iconName: 'angle-down',
    icon: [
        448,
        512,
        [
            8964
        ],
        "f107",
        "M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
    ]
};
const $d8206b3ab2e65c05$export$ec5cfe409de2ed37 = {
    prefix: 'fas',
    iconName: 'car-tunnel',
    icon: [
        512,
        512,
        [],
        "e4de",
        "M256 0C114.6 0 0 114.6 0 256L0 448c0 35.3 28.7 64 64 64l42.8 0c-6.6-5.9-10.8-14.4-10.8-24l0-112c0-20.8 11.3-38.9 28.1-48.6l21-64.7c7.5-23.1 29-38.7 53.3-38.7l115.2 0c24.3 0 45.8 15.6 53.3 38.7l21 64.7c16.8 9.7 28.2 27.8 28.2 48.6l0 112c0 9.6-4.2 18.1-10.8 24l42.8 0c35.3 0 64-28.7 64-64l0-192C512 114.6 397.4 0 256 0zM362.8 512c-6.6-5.9-10.8-14.4-10.8-24l0-40-192 0 0 40c0 9.6-4.2 18.1-10.8 24l213.7 0zM190.8 277.5L177 320l158 0-13.8-42.5c-1.1-3.3-4.1-5.5-7.6-5.5l-115.2 0c-3.5 0-6.5 2.2-7.6 5.5zM168 408a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm200-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
    ]
};
const $d8206b3ab2e65c05$export$3cd04b7c1624f598 = {
    prefix: 'fas',
    iconName: 'head-side-cough',
    icon: [
        640,
        512,
        [],
        "e061",
        "M0 224.2C0 100.6 100.2 0 224 0l24 0c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8L448 320s0 0 0 0l0 32L339.2 365.6c-11 1.4-19.2 10.7-19.2 21.8c0 11.6 9 21.2 20.6 21.9L448 416l0 16c0 26.5-21.5 48-48 48l-80 0 0 8c0 13.3-10.7 24-24 24l-40 0s0 0 0 0L96 512c-17.7 0-32-14.3-32-32l0-72.7c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zm352-.2a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM464 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm152-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM592 480a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM552 312a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40-24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM552 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
const $d8206b3ab2e65c05$export$1412f35381064d7d = {
    prefix: 'fas',
    iconName: 'grip-lines',
    icon: [
        448,
        512,
        [],
        "f7a4",
        "M32 288c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 288zm0-128c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 160z"
    ]
};
const $d8206b3ab2e65c05$export$aba24ca305bbe8c1 = {
    prefix: 'fas',
    iconName: 'thumbs-down',
    icon: [
        512,
        512,
        [
            128078,
            61576
        ],
        "f165",
        "M313.4 479.1c26-5.2 42.9-30.5 37.7-56.5l-2.3-11.4c-5.3-26.7-15.1-52.1-28.8-75.2l144 0c26.5 0 48-21.5 48-48c0-18.5-10.5-34.6-25.9-42.6C497 236.6 504 223.1 504 208c0-23.4-16.8-42.9-38.9-47.1c4.4-7.3 6.9-15.8 6.9-24.9c0-21.3-13.9-39.4-33.1-45.6c.7-3.3 1.1-6.8 1.1-10.4c0-26.5-21.5-48-48-48l-97.5 0c-19 0-37.5 5.6-53.3 16.1L202.7 73.8C176 91.6 160 121.6 160 153.7l0 38.3 0 48 0 24.9c0 29.2 13.3 56.7 36 75l7.4 5.9c26.5 21.2 44.6 51 51.2 84.2l2.3 11.4c5.2 26 30.5 42.9 56.5 37.7zM32 384l64 0c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32L32 96C14.3 96 0 110.3 0 128L0 352c0 17.7 14.3 32 32 32z"
    ]
};
const $d8206b3ab2e65c05$export$d9b89b5872b67a4f = {
    prefix: 'fas',
    iconName: 'user-lock',
    icon: [
        640,
        512,
        [],
        "f502",
        "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l362.8 0c-5.4-9.4-8.6-20.3-8.6-32l0-128c0-2.1 .1-4.2 .3-6.3c-31-26-71-41.7-114.6-41.7l-91.4 0zM528 240c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
const $d8206b3ab2e65c05$export$becbc35d3541bcc = {
    prefix: 'fas',
    iconName: 'arrow-right-long',
    icon: [
        512,
        512,
        [
            "long-arrow-right"
        ],
        "f178",
        "M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"
    ]
};
const $d8206b3ab2e65c05$export$7ec6527cf8651899 = $d8206b3ab2e65c05$export$becbc35d3541bcc;
const $d8206b3ab2e65c05$export$f6773af4219eebd = {
    prefix: 'fas',
    iconName: 'anchor-circle-xmark',
    icon: [
        640,
        512,
        [],
        "e4ac",
        "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80L224 176c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 208-48 0c-53 0-96-43-96-96l0-6.1 7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7 0 6.1c0 88.4 71.6 160 160 160l80 0 80 0c8.2 0 16.3-.6 24.2-1.8c-22.2-16.2-40.4-37.5-53-62.2L320 448l0-80 0-128 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-10.9 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
const $d8206b3ab2e65c05$export$37fe3659ba7b6b54 = {
    prefix: 'fas',
    iconName: 'ellipsis',
    icon: [
        448,
        512,
        [
            "ellipsis-h"
        ],
        "f141",
        "M8 256a56 56 0 1 1 112 0A56 56 0 1 1 8 256zm160 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm216-56a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"
    ]
};
const $d8206b3ab2e65c05$export$c9f2fedd4489a2ee = $d8206b3ab2e65c05$export$37fe3659ba7b6b54;
const $d8206b3ab2e65c05$export$3db75d5ac9e98468 = {
    prefix: 'fas',
    iconName: 'chess-pawn',
    icon: [
        320,
        512,
        [
            9823
        ],
        "f443",
        "M215.5 224c29.2-18.4 48.5-50.9 48.5-88c0-57.4-46.6-104-104-104S56 78.6 56 136c0 37.1 19.4 69.6 48.5 88L96 224c-17.7 0-32 14.3-32 32c0 16.5 12.5 30 28.5 31.8L80 400l160 0L227.5 287.8c16-1.8 28.5-15.3 28.5-31.8c0-17.7-14.3-32-32-32l-8.5 0zM22.6 473.4c-4.2 4.2-6.6 10-6.6 16C16 501.9 26.1 512 38.6 512l242.7 0c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L256 432 64 432 22.6 473.4z"
    ]
};
const $d8206b3ab2e65c05$export$f04e7a0f1033a0cd = {
    prefix: 'fas',
    iconName: 'kit-medical',
    icon: [
        576,
        512,
        [
            "first-aid"
        ],
        "f479",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l32 0L96 32 64 32zm64 0l0 448 320 0 0-448L128 32zM512 480c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-32 0 0 448 32 0zM256 176c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z"
    ]
};
const $d8206b3ab2e65c05$export$5b01ccb2da4c4387 = $d8206b3ab2e65c05$export$f04e7a0f1033a0cd;
const $d8206b3ab2e65c05$export$a77a2f6da72f89e3 = {
    prefix: 'fas',
    iconName: 'person-through-window',
    icon: [
        640,
        512,
        [],
        "e5a9",
        "M64 64l224 0 0 9.8c0 39-23.7 74-59.9 88.4C167.6 186.5 128 245 128 310.2l0 73.8s0 0 0 0l-64 0L64 64zm288 0l224 0 0 320-67.7 0-3.7-4.5-75.2-90.2c-9.1-10.9-22.6-17.3-36.9-17.3l-71.1 0-41-63.1c-.3-.5-.6-1-1-1.4c44.7-29 72.5-79 72.5-133.6l0-9.8zm73 320l-45.8 0 42.7 64L592 448c26.5 0 48-21.5 48-48l0-352c0-26.5-21.5-48-48-48L48 0C21.5 0 0 21.5 0 48L0 400c0 26.5 21.5 48 48 48l260.2 0 33.2 49.8c9.8 14.7 29.7 18.7 44.4 8.9s18.7-29.7 8.9-44.4L310.5 336l74.6 0 40 48zm-159.5 0L192 384s0 0 0 0l0-73.8c0-10.2 1.6-20.1 4.7-29.5L265.5 384zM192 128a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
    ]
};
const $d8206b3ab2e65c05$export$b34d64c205c732a9 = {
    prefix: 'fas',
    iconName: 'toolbox',
    icon: [
        512,
        512,
        [
            129520
        ],
        "f552",
        "M176 88l0 40 160 0 0-40c0-4.4-3.6-8-8-8L184 80c-4.4 0-8 3.6-8 8zm-48 40l0-40c0-30.9 25.1-56 56-56l144 0c30.9 0 56 25.1 56 56l0 40 28.1 0c12.7 0 24.9 5.1 33.9 14.1l51.9 51.9c9 9 14.1 21.2 14.1 33.9l0 92.1-128 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32-128 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L0 320l0-92.1c0-12.7 5.1-24.9 14.1-33.9l51.9-51.9c9-9 21.2-14.1 33.9-14.1l28.1 0zM0 416l0-64 128 0c0 17.7 14.3 32 32 32s32-14.3 32-32l128 0c0 17.7 14.3 32 32 32s32-14.3 32-32l128 0 0 64c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64z"
    ]
};
const $d8206b3ab2e65c05$export$3aa81d0e606b08b6 = {
    prefix: 'fas',
    iconName: 'hands-holding-circle',
    icon: [
        640,
        512,
        [],
        "e4fb",
        "M320 0a128 128 0 1 1 0 256A128 128 0 1 1 320 0zM40 64c22.1 0 40 17.9 40 40l0 40 0 80 0 40.2c0 17 6.7 33.3 18.7 45.3l51.1 51.1c8.3 8.3 21.3 9.6 31 3.1c12.9-8.6 14.7-26.9 3.7-37.8l-15.2-15.2-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32 15.2 15.2c0 0 0 0 0 0l25.3 25.3c21 21 32.8 49.5 32.8 79.2l0 78.9c0 26.5-21.5 48-48 48l-66.7 0c-17 0-33.3-6.7-45.3-18.7L28.1 393.4C10.1 375.4 0 351 0 325.5L0 224l0-64 0-56C0 81.9 17.9 64 40 64zm560 0c22.1 0 40 17.9 40 40l0 56 0 64 0 101.5c0 25.5-10.1 49.9-28.1 67.9L512 493.3c-12 12-28.3 18.7-45.3 18.7L400 512c-26.5 0-48-21.5-48-48l0-78.9c0-29.7 11.8-58.2 32.8-79.2l25.3-25.3c0 0 0 0 0 0l15.2-15.2 32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32-15.2 15.2c-11 11-9.2 29.2 3.7 37.8c9.7 6.5 22.7 5.2 31-3.1l51.1-51.1c12-12 18.7-28.3 18.7-45.3l0-40.2 0-80 0-40c0-22.1 17.9-40 40-40z"
    ]
};
const $d8206b3ab2e65c05$export$a18cfac400116d9f = {
    prefix: 'fas',
    iconName: 'bug',
    icon: [
        512,
        512,
        [],
        "f188",
        "M256 0c53 0 96 43 96 96l0 3.6c0 15.7-12.7 28.4-28.4 28.4l-135.1 0c-15.7 0-28.4-12.7-28.4-28.4l0-3.6c0-53 43-96 96-96zM41.4 105.4c12.5-12.5 32.8-12.5 45.3 0l64 64c.7 .7 1.3 1.4 1.9 2.1c14.2-7.3 30.4-11.4 47.5-11.4l112 0c17.1 0 33.2 4.1 47.5 11.4c.6-.7 1.2-1.4 1.9-2.1l64-64c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-64 64c-.7 .7-1.4 1.3-2.1 1.9c6.2 12 10.1 25.3 11.1 39.5l64.3 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c0 24.6-5.5 47.8-15.4 68.6c2.2 1.3 4.2 2.9 6 4.8l64 64c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-63.1-63.1c-24.5 21.8-55.8 36.2-90.3 39.6L272 240c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 239.2c-34.5-3.4-65.8-17.8-90.3-39.6L86.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l64-64c1.9-1.9 3.9-3.4 6-4.8C101.5 367.8 96 344.6 96 320l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64.3 0c1.1-14.1 5-27.5 11.1-39.5c-.7-.6-1.4-1.2-2.1-1.9l-64-64c-12.5-12.5-12.5-32.8 0-45.3z"
    ]
};
const $d8206b3ab2e65c05$export$3e7437bf6535bef0 = {
    prefix: 'fas',
    iconName: 'credit-card',
    icon: [
        576,
        512,
        [
            128179,
            62083,
            "credit-card-alt"
        ],
        "f09d",
        "M64 32C28.7 32 0 60.7 0 96l0 32 576 0 0-32c0-35.3-28.7-64-64-64L64 32zM576 224L0 224 0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-192zM112 352l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16z"
    ]
};
const $d8206b3ab2e65c05$export$5fffe8e3c36964a2 = $d8206b3ab2e65c05$export$3e7437bf6535bef0;
const $d8206b3ab2e65c05$export$9eefe7fcdf123b76 = {
    prefix: 'fas',
    iconName: 'car',
    icon: [
        512,
        512,
        [
            128664,
            "automobile"
        ],
        "f1b9",
        "M135.2 117.4L109.1 192l293.8 0-26.1-74.6C372.3 104.6 360.2 96 346.6 96L165.4 96c-13.6 0-25.7 8.6-30.2 21.4zM39.6 196.8L74.8 96.3C88.3 57.8 124.6 32 165.4 32l181.2 0c40.8 0 77.1 25.8 90.6 64.3l35.2 100.5c23.2 9.6 39.6 32.5 39.6 59.2l0 144 0 48c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-48L96 400l0 48c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-48L0 256c0-26.7 16.4-49.6 39.6-59.2zM128 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
const $d8206b3ab2e65c05$export$240a6c53cf7ac525 = $d8206b3ab2e65c05$export$9eefe7fcdf123b76;
const $d8206b3ab2e65c05$export$6638511b28df3be5 = {
    prefix: 'fas',
    iconName: 'hand-holding-hand',
    icon: [
        576,
        512,
        [],
        "e4f7",
        "M7.8 207.7c-13.1-17.8-9.3-42.8 8.5-55.9L142.9 58.5C166.2 41.3 194.5 32 223.5 32L384 32l160 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-36.8 0-44.9 36c-22.7 18.2-50.9 28-80 28L304 224l-16 0-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-120.6 0L63.7 216.2c-17.8 13.1-42.8 9.3-55.9-8.5zM382.4 160c0 0 0 0 0 0l.9 0c-.3 0-.6 0-.9 0zM568.2 304.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 453.5c-23.4 17.2-51.6 26.5-80.7 26.5L192 480 32 480c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l36.8 0 44.9-36c22.7-18.2 50.9-28 80-28l78.3 0 16 0 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l120.6 0 119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 352c0 0 0 0 0 0l-.9 0c.3 0 .6 0 .9 0z"
    ]
};
const $d8206b3ab2e65c05$export$cb6e40528b98a5b = {
    prefix: 'fas',
    iconName: 'book-open-reader',
    icon: [
        512,
        512,
        [
            "book-reader"
        ],
        "f5da",
        "M160 96a96 96 0 1 1 192 0A96 96 0 1 1 160 96zm80 152l0 264-48.4-24.2c-20.9-10.4-43.5-17-66.8-19.3l-96-9.6C12.5 457.2 0 443.5 0 427L0 224c0-17.7 14.3-32 32-32l30.3 0c63.6 0 125.6 19.6 177.7 56zm32 264l0-264c52.1-36.4 114.1-56 177.7-56l30.3 0c17.7 0 32 14.3 32 32l0 203c0 16.4-12.5 30.2-28.8 31.8l-96 9.6c-23.2 2.3-45.9 8.9-66.8 19.3L272 512z"
    ]
};
const $d8206b3ab2e65c05$export$cee14fe33262fa7d = $d8206b3ab2e65c05$export$cb6e40528b98a5b;
const $d8206b3ab2e65c05$export$af9eaee7db3ba7a9 = {
    prefix: 'fas',
    iconName: 'mountain-sun',
    icon: [
        640,
        512,
        [],
        "e52f",
        "M560 160A80 80 0 1 0 560 0a80 80 0 1 0 0 160zM55.9 512l325.2 0 75 0 122.8 0c33.8 0 61.1-27.4 61.1-61.1c0-11.2-3.1-22.2-8.9-31.8l-132-216.3C495 196.1 487.8 192 480 192s-15 4.1-19.1 10.7l-48.2 79L286.8 81c-6.6-10.6-18.3-17-30.8-17s-24.1 6.4-30.8 17L8.6 426.4C3 435.3 0 445.6 0 456.1C0 487 25 512 55.9 512z"
    ]
};
const $d8206b3ab2e65c05$export$a63cecc8a4166c49 = {
    prefix: 'fas',
    iconName: 'arrows-left-right-to-line',
    icon: [
        640,
        512,
        [],
        "e4ba",
        "M32 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 96C0 78.3 14.3 64 32 64zm214.6 73.4c12.5 12.5 12.5 32.8 0 45.3L205.3 224l229.5 0-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L434.7 288l-229.5 0 41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0zM640 96l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-320c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
const $d8206b3ab2e65c05$export$b06003a02c9055bd = {
    prefix: 'fas',
    iconName: 'dice-d20',
    icon: [
        512,
        512,
        [],
        "f6cf",
        "M48.7 125.8l53.2 31.9c7.8 4.7 17.8 2 22.2-5.9L201.6 12.1c3-5.4-.9-12.1-7.1-12.1c-1.6 0-3.2 .5-4.6 1.4L47.9 98.8c-9.6 6.6-9.2 20.9 .8 26.9zM16 171.7l0 123.5c0 8 10.4 11 14.7 4.4l60-92c5-7.6 2.6-17.8-5.2-22.5L40.2 158C29.6 151.6 16 159.3 16 171.7zM310.4 12.1l77.6 139.6c4.4 7.9 14.5 10.6 22.2 5.9l53.2-31.9c10-6 10.4-20.3 .8-26.9L322.1 1.4c-1.4-.9-3-1.4-4.6-1.4c-6.2 0-10.1 6.7-7.1 12.1zM496 171.7c0-12.4-13.6-20.1-24.2-13.7l-45.3 27.2c-7.8 4.7-10.1 14.9-5.2 22.5l60 92c4.3 6.7 14.7 3.6 14.7-4.4l0-123.5zm-49.3 246L286.1 436.6c-8.1 .9-14.1 7.8-14.1 15.9l0 52.8c0 3.7 3 6.8 6.8 6.8c.8 0 1.6-.1 2.4-.4l172.7-64c6.1-2.2 10.1-8 10.1-14.5c0-9.3-8.1-16.5-17.3-15.4zM233.2 512c3.7 0 6.8-3 6.8-6.8l0-52.6c0-8.1-6.1-14.9-14.1-15.9l-160.6-19c-9.2-1.1-17.3 6.1-17.3 15.4c0 6.5 4 12.3 10.1 14.5l172.7 64c.8 .3 1.6 .4 2.4 .4zM41.7 382.9l170.9 20.2c7.8 .9 13.4-7.5 9.5-14.3l-85.7-150c-5.9-10.4-20.7-10.8-27.3-.8L30.2 358.2c-6.5 9.9-.3 23.3 11.5 24.7zm439.6-24.8L402.9 238.1c-6.5-10-21.4-9.6-27.3 .8L290.2 388.5c-3.9 6.8 1.6 15.2 9.5 14.3l170.1-20c11.8-1.4 18-14.7 11.5-24.6zm-216.9 11l78.4-137.2c6.1-10.7-1.6-23.9-13.9-23.9l-145.7 0c-12.3 0-20 13.3-13.9 23.9l78.4 137.2c3.7 6.4 13 6.4 16.7 0zM174.4 176l163.2 0c12.2 0 19.9-13.1 14-23.8l-80-144c-2.8-5.1-8.2-8.2-14-8.2l-3.2 0c-5.8 0-11.2 3.2-14 8.2l-80 144c-5.9 10.7 1.8 23.8 14 23.8z"
    ]
};
const $d8206b3ab2e65c05$export$41ce20639e8fef2b = {
    prefix: 'fas',
    iconName: 'truck-droplet',
    icon: [
        640,
        512,
        [],
        "e58c",
        "M0 48C0 21.5 21.5 0 48 0L368 0c26.5 0 48 21.5 48 48l0 48 50.7 0c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3l0 18.7 0 32 0 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c0 53-43 96-96 96s-96-43-96-96l-128 0c0 53-43 96-96 96s-96-43-96-96l-16 0c-26.5 0-48-21.5-48-48L0 48zM416 256l128 0 0-18.7L466.7 160 416 160l0 96zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM208 272c39.8 0 72-29.6 72-66c0-27-39.4-82.9-59.9-110.3c-6.1-8.2-18.1-8.2-24.2 0C175.4 123 136 179 136 206c0 36.5 32.2 66 72 66z"
    ]
};
const $d8206b3ab2e65c05$export$e4686afbe882e24a = {
    prefix: 'fas',
    iconName: 'file-circle-xmark',
    icon: [
        576,
        512,
        [],
        "e5a1",
        "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"
    ]
};
const $d8206b3ab2e65c05$export$d7a5da41ce01461d = {
    prefix: 'fas',
    iconName: 'temperature-arrow-up',
    icon: [
        576,
        512,
        [
            "temperature-up"
        ],
        "e040",
        "M128 112c0-26.5 21.5-48 48-48s48 21.5 48 48l0 164.5c0 17.3 7.1 31.9 15.3 42.5C249.8 332.6 256 349.5 256 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5L128 112zM176 0C114.1 0 64 50.1 64 112l0 164.4c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C43.2 304.2 32 334.8 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6L288 112C288 50.1 237.9 0 176 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3L192 112c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 210.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48zM480 160l32 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l32 0 0 288c0 17.7 14.3 32 32 32s32-14.3 32-32l0-288z"
    ]
};
const $d8206b3ab2e65c05$export$872345a0157330a3 = $d8206b3ab2e65c05$export$d7a5da41ce01461d;
const $d8206b3ab2e65c05$export$b48a5be96314835a = {
    prefix: 'fas',
    iconName: 'medal',
    icon: [
        512,
        512,
        [
            127941
        ],
        "f5a2",
        "M4.1 38.2C1.4 34.2 0 29.4 0 24.6C0 11 11 0 24.6 0L133.9 0c11.2 0 21.7 5.9 27.4 15.5l68.5 114.1c-48.2 6.1-91.3 28.6-123.4 61.9L4.1 38.2zm503.7 0L405.6 191.5c-32.1-33.3-75.2-55.8-123.4-61.9L350.7 15.5C356.5 5.9 366.9 0 378.1 0L487.4 0C501 0 512 11 512 24.6c0 4.8-1.4 9.6-4.1 13.6zM80 336a176 176 0 1 1 352 0A176 176 0 1 1 80 336zm184.4-94.9c-3.4-7-13.3-7-16.8 0l-22.4 45.4c-1.4 2.8-4 4.7-7 5.1L168 298.9c-7.7 1.1-10.7 10.5-5.2 16l36.3 35.4c2.2 2.2 3.2 5.2 2.7 8.3l-8.6 49.9c-1.3 7.6 6.7 13.5 13.6 9.9l44.8-23.6c2.7-1.4 6-1.4 8.7 0l44.8 23.6c6.9 3.6 14.9-2.2 13.6-9.9l-8.6-49.9c-.5-3 .5-6.1 2.7-8.3l36.3-35.4c5.6-5.4 2.5-14.8-5.2-16l-50.1-7.3c-3-.4-5.7-2.4-7-5.1l-22.4-45.4z"
    ]
};
const $d8206b3ab2e65c05$export$f24e0fce77994d4d = {
    prefix: 'fas',
    iconName: 'bed',
    icon: [
        640,
        512,
        [
            128716
        ],
        "f236",
        "M32 32c17.7 0 32 14.3 32 32l0 256 224 0 0-160c0-17.7 14.3-32 32-32l224 0c53 0 96 43 96 96l0 224c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-224 0-32 0L64 416l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 64C0 46.3 14.3 32 32 32zm144 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
    ]
};
const $d8206b3ab2e65c05$export$51e3c5be06a49e32 = {
    prefix: 'fas',
    iconName: 'square-h',
    icon: [
        448,
        512,
        [
            "h-square"
        ],
        "f0fd",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM336 152l0 104 0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80-128 0 0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24s24 10.7 24 24l0 80 128 0 0-80c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
const $d8206b3ab2e65c05$export$f08bbcf8f59eafc2 = $d8206b3ab2e65c05$export$51e3c5be06a49e32;
const $d8206b3ab2e65c05$export$5c0b4709125e92f8 = {
    prefix: 'fas',
    iconName: 'podcast',
    icon: [
        448,
        512,
        [],
        "f2ce",
        "M319.4 372c48.5-31.3 80.6-85.9 80.6-148c0-97.2-78.8-176-176-176S48 126.8 48 224c0 62.1 32.1 116.6 80.6 148c1.2 17.3 4 38 7.2 57.1l.2 1C56 395.8 0 316.5 0 224C0 100.3 100.3 0 224 0S448 100.3 448 224c0 92.5-56 171.9-136 206.1l.2-1.1c3.1-19.2 6-39.8 7.2-57zm-2.3-38.1c-1.6-5.7-3.9-11.1-7-16.2c-5.8-9.7-13.5-17-21.9-22.4c19.5-17.6 31.8-43 31.8-71.3c0-53-43-96-96-96s-96 43-96 96c0 28.3 12.3 53.8 31.8 71.3c-8.4 5.4-16.1 12.7-21.9 22.4c-3.1 5.1-5.4 10.5-7 16.2C99.8 307.5 80 268 80 224c0-79.5 64.5-144 144-144s144 64.5 144 144c0 44-19.8 83.5-50.9 109.9zM224 312c32.9 0 64 8.6 64 43.8c0 33-12.9 104.1-20.6 132.9c-5.1 19-24.5 23.4-43.4 23.4s-38.2-4.4-43.4-23.4c-7.8-28.5-20.6-99.7-20.6-132.8c0-35.1 31.1-43.8 64-43.8zm0-144a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"
    ]
};
const $d8206b3ab2e65c05$export$bf4d97a79734997f = {
    prefix: 'fas',
    iconName: 'temperature-full',
    icon: [
        320,
        512,
        [
            "temperature-4",
            "thermometer-4",
            "thermometer-full"
        ],
        "f2c7",
        "M160 64c-26.5 0-48 21.5-48 48l0 164.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5L208 112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112l0 164.4c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6L48 112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3L144 112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 210.7c18.6 6.6 32 24.4 32 45.3z"
    ]
};
const $d8206b3ab2e65c05$export$db946f8dc50a57ca = $d8206b3ab2e65c05$export$bf4d97a79734997f;
const $d8206b3ab2e65c05$export$92b2e2293472dd50 = $d8206b3ab2e65c05$export$bf4d97a79734997f;
const $d8206b3ab2e65c05$export$74e07083cef79a6f = $d8206b3ab2e65c05$export$bf4d97a79734997f;
const $d8206b3ab2e65c05$export$9b6162797ab1b255 = {
    prefix: 'fas',
    iconName: 'bell',
    icon: [
        448,
        512,
        [
            128276,
            61602
        ],
        "f0f3",
        "M224 0c-17.7 0-32 14.3-32 32l0 19.2C119 66 64 130.6 64 208l0 18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416l384 0c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C401.3 319.2 384 273.9 384 226.8l0-18.8c0-77.4-55-142-128-156.8L256 32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7z"
    ]
};
const $d8206b3ab2e65c05$export$4fa56a54e822dd25 = {
    prefix: 'fas',
    iconName: 'superscript',
    icon: [
        512,
        512,
        [],
        "f12b",
        "M480 32c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4l-32 16c-15.8 7.9-22.2 27.1-14.3 42.9C393 73.5 404.3 80 416 80l0 80c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-128zM32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l15.3 0 89.6 128L47.3 384 32 384c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0c10.4 0 20.2-5.1 26.2-13.6L176 311.8l85.8 122.6c6 8.6 15.8 13.6 26.2 13.6l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-15.3 0L215.1 256l89.6-128 15.3 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0c-10.4 0-20.2 5.1-26.2 13.6L176 200.2 90.2 77.6C84.2 69.1 74.4 64 64 64L32 64z"
    ]
};
const $d8206b3ab2e65c05$export$12ef959394d63192 = {
    prefix: 'fas',
    iconName: 'plug-circle-xmark',
    icon: [
        576,
        512,
        [],
        "e560",
        "M96 0C78.3 0 64 14.3 64 32l0 96 64 0 0-96c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32l0 96 64 0 0-96c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 32c0 77.4 55 142 128 156.8l0 67.2c0 17.7 14.3 32 32 32s32-14.3 32-32l0-67.2c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32L32 160zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
const $d8206b3ab2e65c05$export$aa3c4c1c5a47bf98 = {
    prefix: 'fas',
    iconName: 'star-of-life',
    icon: [
        512,
        512,
        [],
        "f621",
        "M208 32c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 140.9 122-70.4c15.3-8.8 34.9-3.6 43.7 11.7l16 27.7c8.8 15.3 3.6 34.9-11.7 43.7L352 256l122 70.4c15.3 8.8 20.6 28.4 11.7 43.7l-16 27.7c-8.8 15.3-28.4 20.6-43.7 11.7L304 339.1 304 480c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-140.9L86 409.6c-15.3 8.8-34.9 3.6-43.7-11.7l-16-27.7c-8.8-15.3-3.6-34.9 11.7-43.7L160 256 38 185.6c-15.3-8.8-20.5-28.4-11.7-43.7l16-27.7C51.1 98.8 70.7 93.6 86 102.4l122 70.4L208 32z"
    ]
};
const $d8206b3ab2e65c05$export$4c60a3aade08b6c2 = {
    prefix: 'fas',
    iconName: 'phone-slash',
    icon: [
        640,
        512,
        [],
        "f3dd",
        "M228.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C76.1 30.2 64 46 64 64c0 107.4 37.8 206 100.8 283.1L9.2 469.1c-10.4 8.2-12.3 23.3-4.1 33.7s23.3 12.3 33.7 4.1l592-464c10.4-8.2 12.3-23.3 4.1-33.7s-23.3-12.3-33.7-4.1L253 278c-17.8-21.5-32.9-45.2-45-70.7L257.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96zm96.8 319l-91.3 72C310.7 476 407.1 512 512 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L368.7 368c-15-7.1-29.3-15.2-43-24.3z"
    ]
};
const $d8206b3ab2e65c05$export$d1de8d1b815d6a5 = {
    prefix: 'fas',
    iconName: 'paint-roller',
    icon: [
        512,
        512,
        [],
        "f5aa",
        "M0 64C0 28.7 28.7 0 64 0L352 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64L64 192c-35.3 0-64-28.7-64-64L0 64zM160 352c0-17.7 14.3-32 32-32l0-16c0-44.2 35.8-80 80-80l144 0c17.7 0 32-14.3 32-32l0-32 0-90.5c37.3 13.2 64 48.7 64 90.5l0 32c0 53-43 96-96 96l-144 0c-8.8 0-16 7.2-16 16l0 16c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-128z"
    ]
};
const $d8206b3ab2e65c05$export$503f458ca5cf64c2 = {
    prefix: 'fas',
    iconName: 'handshake-angle',
    icon: [
        640,
        512,
        [
            "hands-helping"
        ],
        "f4c4",
        "M544 248l0 3.3 69.7-69.7c21.9-21.9 21.9-57.3 0-79.2L535.6 24.4c-21.9-21.9-57.3-21.9-79.2 0L416.3 64.5c-2.7-.3-5.5-.5-8.3-.5L296 64c-37.1 0-67.6 28-71.6 64l-.4 0 0 120c0 22.1 17.9 40 40 40s40-17.9 40-40l0-72c0 0 0-.1 0-.1l0-15.9 16 0 136 0c0 0 0 0 .1 0l7.9 0c44.2 0 80 35.8 80 80l0 8zM336 192l0 56c0 39.8-32.2 72-72 72s-72-32.2-72-72l0-118.6c-35.9 6.2-65.8 32.3-76 68.2L99.5 255.2 26.3 328.4c-21.9 21.9-21.9 57.3 0 79.2l78.1 78.1c21.9 21.9 57.3 21.9 79.2 0l37.7-37.7c.9 0 1.8 .1 2.7 .1l160 0c26.5 0 48-21.5 48-48c0-5.6-1-11-2.7-16l2.7 0c26.5 0 48-21.5 48-48c0-12.8-5-24.4-13.2-33c25.7-5 45.1-27.6 45.2-54.8l0-.4c-.1-30.8-25.1-55.8-56-55.8c0 0 0 0 0 0l-120 0z"
    ]
};
const $d8206b3ab2e65c05$export$287dbb1632da0d44 = $d8206b3ab2e65c05$export$503f458ca5cf64c2;
const $d8206b3ab2e65c05$export$90a475e93ff4bb8a = {
    prefix: 'fas',
    iconName: 'location-dot',
    icon: [
        384,
        512,
        [
            "map-marker-alt"
        ],
        "f3c5",
        "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
    ]
};
const $d8206b3ab2e65c05$export$4be92fa780613f93 = $d8206b3ab2e65c05$export$90a475e93ff4bb8a;
const $d8206b3ab2e65c05$export$cad54bead856a678 = {
    prefix: 'fas',
    iconName: 'file',
    icon: [
        384,
        512,
        [
            128196,
            128459,
            61462
        ],
        "f15b",
        "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128z"
    ]
};
const $d8206b3ab2e65c05$export$da07b6bc24a496ca = {
    prefix: 'fas',
    iconName: 'greater-than',
    icon: [
        384,
        512,
        [
            62769
        ],
        "3e",
        "M3.4 81.7c-7.9 15.8-1.5 35 14.3 42.9L280.5 256 17.7 387.4C1.9 395.3-4.5 414.5 3.4 430.3s27.1 22.2 42.9 14.3l320-160c10.8-5.4 17.7-16.5 17.7-28.6s-6.8-23.2-17.7-28.6l-320-160c-15.8-7.9-35-1.5-42.9 14.3z"
    ]
};
const $d8206b3ab2e65c05$export$3fb4da6af843d39f = {
    prefix: 'fas',
    iconName: 'person-swimming',
    icon: [
        576,
        512,
        [
            127946,
            "swimmer"
        ],
        "f5c4",
        "M309.5 178.4L447.9 297.1c-1.6 .9-3.2 2-4.8 3c-18 12.4-40.1 20.3-59.2 20.3c-19.6 0-40.8-7.7-59.2-20.3c-22.1-15.5-51.6-15.5-73.7 0c-17.1 11.8-38 20.3-59.2 20.3c-10.1 0-21.1-2.2-31.9-6.2C163.1 193.2 262.2 96 384 96l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-26.9 0-52.3 6.6-74.5 18.4zM160 160A64 64 0 1 1 32 160a64 64 0 1 1 128 0zM306.5 325.9C329 341.4 356.5 352 384 352c26.9 0 55.4-10.8 77.4-26.1c0 0 0 0 0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 405.7 417 416 384 416c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7c0 0 0 0 0 0C136.7 341.2 165.1 352 192 352c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
const $d8206b3ab2e65c05$export$67daf2e2f88c1365 = $d8206b3ab2e65c05$export$3fb4da6af843d39f;
const $d8206b3ab2e65c05$export$9686eff8d817f770 = {
    prefix: 'fas',
    iconName: 'arrow-down',
    icon: [
        384,
        512,
        [
            8595
        ],
        "f063",
        "M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
    ]
};
const $d8206b3ab2e65c05$export$cc1b6e60cb98fb90 = {
    prefix: 'fas',
    iconName: 'droplet',
    icon: [
        384,
        512,
        [
            128167,
            "tint"
        ],
        "f043",
        "M192 512C86 512 0 426 0 320C0 228.8 130.2 57.7 166.6 11.7C172.6 4.2 181.5 0 191.1 0l1.8 0c9.6 0 18.5 4.2 24.5 11.7C253.8 57.7 384 228.8 384 320c0 106-86 192-192 192zM96 336c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 61.9 50.1 112 112 112c8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80-35.8-80-80z"
    ]
};
const $d8206b3ab2e65c05$export$60dd975bd5938c15 = $d8206b3ab2e65c05$export$cc1b6e60cb98fb90;
const $d8206b3ab2e65c05$export$e7fc4fe34e767f28 = {
    prefix: 'fas',
    iconName: 'eraser',
    icon: [
        576,
        512,
        [],
        "f12d",
        "M290.7 57.4L57.4 290.7c-25 25-25 65.5 0 90.5l80 80c12 12 28.3 18.7 45.3 18.7L288 480l9.4 0L512 480c17.7 0 32-14.3 32-32s-14.3-32-32-32l-124.1 0L518.6 285.3c25-25 25-65.5 0-90.5L381.3 57.4c-25-25-65.5-25-90.5 0zM297.4 416l-9.4 0-105.4 0-80-80L227.3 211.3 364.7 348.7 297.4 416z"
    ]
};
const $d8206b3ab2e65c05$export$9c4218a898614082 = {
    prefix: 'fas',
    iconName: 'earth-americas',
    icon: [
        512,
        512,
        [
            127758,
            "earth",
            "earth-america",
            "globe-americas"
        ],
        "f57d",
        "M57.7 193l9.4 16.4c8.3 14.5 21.9 25.2 38 29.8L163 255.7c17.2 4.9 29 20.6 29 38.5l0 39.9c0 11 6.2 21 16 25.9s16 14.9 16 25.9l0 39c0 15.6 14.9 26.9 29.9 22.6c16.1-4.6 28.6-17.5 32.7-33.8l2.8-11.2c4.2-16.9 15.2-31.4 30.3-40l8.1-4.6c15-8.5 24.2-24.5 24.2-41.7l0-8.3c0-12.7-5.1-24.9-14.1-33.9l-3.9-3.9c-9-9-21.2-14.1-33.9-14.1L257 256c-11.1 0-22.1-2.9-31.8-8.4l-34.5-19.7c-4.3-2.5-7.6-6.5-9.2-11.2c-3.2-9.6 1.1-20 10.2-24.5l5.9-3c6.6-3.3 14.3-3.9 21.3-1.5l23.2 7.7c8.2 2.7 17.2-.4 21.9-7.5c4.7-7 4.2-16.3-1.2-22.8l-13.6-16.3c-10-12-9.9-29.5 .3-41.3l15.7-18.3c8.8-10.3 10.2-25 3.5-36.7l-2.4-4.2c-3.5-.2-6.9-.3-10.4-.3C163.1 48 84.4 108.9 57.7 193zM464 256c0-36.8-9.6-71.4-26.4-101.5L412 164.8c-15.7 6.3-23.8 23.8-18.5 39.8l16.9 50.7c3.5 10.4 12 18.3 22.6 20.9l29.1 7.3c1.2-9 1.8-18.2 1.8-27.5zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
    ]
};
const $d8206b3ab2e65c05$export$c2118d3775773870 = $d8206b3ab2e65c05$export$9c4218a898614082;
const $d8206b3ab2e65c05$export$8b0f3a26397cf632 = $d8206b3ab2e65c05$export$9c4218a898614082;
const $d8206b3ab2e65c05$export$e96bcc7bde9498db = $d8206b3ab2e65c05$export$9c4218a898614082;
const $d8206b3ab2e65c05$export$ae02241644924482 = {
    prefix: 'fas',
    iconName: 'person-burst',
    icon: [
        640,
        512,
        [],
        "e53b",
        "M480 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 384l0-128 16 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-223.1 28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6l-29.7 0c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L408 256.9 408 480c0 17.7 14.3 32 32 32s32-14.3 32-32zM190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6L176 286.1l58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 50.5-7.8 24.3-40.5-55.2-38L315 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3L220.3 92.1l-29.4-74z"
    ]
};
const $d8206b3ab2e65c05$export$a1ab1e69a300089f = {
    prefix: 'fas',
    iconName: 'dove',
    icon: [
        512,
        512,
        [
            128330
        ],
        "f4ba",
        "M160.8 96.5c14 17 31 30.9 49.5 42.2c25.9 15.8 53.7 25.9 77.7 31.6l0-31.5C265.8 108.5 250 71.5 248.6 28c-.4-11.3-7.5-21.5-18.4-24.4c-7.6-2-15.8-.2-21 5.8c-13.3 15.4-32.7 44.6-48.4 87.2zM320 144l0 30.6s0 0 0 0l0 1.3s0 0 0 0l0 32.1c-60.8-5.1-185-43.8-219.3-157.2C97.4 40 87.9 32 76.6 32c-7.9 0-15.3 3.9-18.8 11C46.8 65.9 32 112.1 32 176c0 116.9 80.1 180.5 118.4 202.8L11.8 416.6C6.7 418 2.6 421.8 .9 426.8s-.8 10.6 2.3 14.8C21.7 466.2 77.3 512 160 512c3.6 0 7.2-1.2 10-3.5L245.6 448l74.4 0c88.4 0 160-71.6 160-160l0-160 29.9-44.9c1.3-2 2.1-4.4 2.1-6.8c0-6.8-5.5-12.3-12.3-12.3L400 64c-44.2 0-80 35.8-80 80zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
    ]
};
const $d8206b3ab2e65c05$export$1344b64f6e922e12 = {
    prefix: 'fas',
    iconName: 'battery-empty',
    icon: [
        576,
        512,
        [
            "battery-0"
        ],
        "f244",
        "M80 160c-8.8 0-16 7.2-16 16l0 160c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-160c0-8.8-7.2-16-16-16L80 160zM0 176c0-44.2 35.8-80 80-80l384 0c44.2 0 80 35.8 80 80l0 16c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l0 16c0 44.2-35.8 80-80 80L80 416c-44.2 0-80-35.8-80-80L0 176z"
    ]
};
const $d8206b3ab2e65c05$export$de8d0338927394c1 = $d8206b3ab2e65c05$export$1344b64f6e922e12;
const $d8206b3ab2e65c05$export$8d36a54dbf1e6bce = {
    prefix: 'fas',
    iconName: 'socks',
    icon: [
        512,
        512,
        [
            129510
        ],
        "f696",
        "M175.2 476.6c-9.7-18-15.2-38.7-15.2-60.6c0-40.3 19-78.2 51.2-102.4l64-48c8.1-6 12.8-15.5 12.8-25.6l0-144L128 96l0 144c0 20.1-9.5 39.1-25.6 51.2l-64 48C14.2 357.3 0 385.8 0 416c0 53 43 96 96 96c20.8 0 41-6.7 57.6-19.2l21.6-16.2zM128 64l160 0 0-16c0-14.5 3.9-28.2 10.7-39.9C291 3 281.9 0 272 0L176 0c-26.5 0-48 21.5-48 48l0 16zM320 96l0 144c0 20.1-9.5 39.1-25.6 51.2l-64 48C206.2 357.3 192 385.8 192 416c0 53 43 96 96 96c20.8 0 41-6.7 57.6-19.2l115.2-86.4C493 382.2 512 344.3 512 304l0-208L320 96zM512 64l0-16c0-26.5-21.5-48-48-48L368 0c-26.5 0-48 21.5-48 48l0 16 192 0z"
    ]
};
const $d8206b3ab2e65c05$export$366b69cbdce46334 = {
    prefix: 'fas',
    iconName: 'inbox',
    icon: [
        512,
        512,
        [],
        "f01c",
        "M121 32C91.6 32 66 52 58.9 80.5L1.9 308.4C.6 313.5 0 318.7 0 323.9L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-92.1c0-5.2-.6-10.4-1.9-15.5l-57-227.9C446 52 420.4 32 391 32L121 32zm0 64l270 0 48 192-51.2 0c-12.1 0-23.2 6.8-28.6 17.7l-14.3 28.6c-5.4 10.8-16.5 17.7-28.6 17.7l-120.4 0c-12.1 0-23.2-6.8-28.6-17.7l-14.3-28.6c-5.4-10.8-16.5-17.7-28.6-17.7L73 288 121 96z"
    ]
};
const $d8206b3ab2e65c05$export$a6f4f4a005d91fbd = {
    prefix: 'fas',
    iconName: 'section',
    icon: [
        256,
        512,
        [],
        "e447",
        "M64.9 96C67.1 84.4 73.7 76.2 86 70.6c13.8-6.2 34.8-8.9 61.2-4.5c8.8 1.4 36.1 7.1 44.1 9.3c17 4.8 34.7-5.1 39.5-22.2s-5.1-34.7-22.2-39.5c-11.1-3.1-41-9.2-50.9-10.8C123-2.7 88.3-.6 59.7 12.3C29.9 25.8 7.5 50.9 1.6 86.5c-.1 .5-.2 1.1-.2 1.6c-2.2 19.7 .3 37.9 8.1 54.1c7.7 16.1 19.4 28 32 36.9c.6 .5 1.3 .9 2 1.4C22.3 194.2 6.5 215.1 1.7 243c-.1 .6-.2 1.1-.2 1.7c-2.3 19.3 .4 37.1 8.4 53c7.9 15.6 19.8 27 32.3 35.5c22.4 15.2 51.9 24 75.4 31c0 0 0 0 0 0l3.7 1.1c27.2 8.2 46.9 14.6 59.4 23.8c5.5 4 8.2 7.6 9.5 10.9c1.3 3.2 2.6 8.6 .9 18.1c-1.7 10.1-7.7 18-20.7 23.5c-14 6-35.4 8.5-62 4.4c-12.8-2.1-35.1-9.7-54.1-16.2c0 0 0 0 0 0c-4.3-1.5-8.5-2.9-12.3-4.2C25.3 420 7.2 429.1 1.6 445.8s3.5 34.9 20.3 40.5c2.6 .8 5.7 1.9 9.2 3.1c18.6 6.3 48.5 16.6 67.3 19.6c0 0 0 0 0 0l.2 0c34.5 5.4 68.8 3.4 97.2-8.7c29.4-12.6 52.5-36.5 58.5-71.5c3.3-19.3 1.9-37.4-5-53.9c-6.3-15-16.4-26.4-27.6-35.2c16.5-13.9 28.5-33.2 32.6-58.2c3.2-19.8 1.9-38.3-4.8-55.1c-6.7-16.8-17.8-29.4-30.2-39c-22.8-17.6-53.6-27.4-77.7-35l-1.4-.5c-27.4-8.7-47.8-15.3-61.5-25c-6.1-4.4-9.5-8.5-11.4-12.4c-1.8-3.7-3.2-9.3-2.3-18.5zm76.7 208.5l-.6-.2-1.4-.4c-27.4-8.2-47.9-14.5-61.7-23.8c-6.2-4.2-9.3-7.9-11-11.3c-1.5-3-2.9-7.7-2.1-15.7c1.9-9.7 7.9-17.3 20.5-22.7c14-6 35.4-8.5 62.1-4.3l16.4 2.6c6.3 2.9 11.7 6 16.2 9.5c5.5 4.2 8.4 8.2 10 12.2c1.6 4 2.8 10.4 1.1 20.9c-2.4 14.7-12.8 26.4-37.1 31l-12.4 2.3z"
    ]
};
const $d8206b3ab2e65c05$export$d262c1f5912046e6 = {
    prefix: 'fas',
    iconName: 'gauge-high',
    icon: [
        512,
        512,
        [
            62461,
            "tachometer-alt",
            "tachometer-alt-fast"
        ],
        "f625",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 416c35.3 0 64-28.7 64-64c0-17.4-6.9-33.1-18.1-44.6L366 161.7c5.3-12.1-.2-26.3-12.3-31.6s-26.3 .2-31.6 12.3L257.9 288c-.6 0-1.3 0-1.9 0c-35.3 0-64 28.7-64 64s28.7 64 64 64zM176 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm352-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
const $d8206b3ab2e65c05$export$38dd17b9f064c10f = $d8206b3ab2e65c05$export$d262c1f5912046e6;
const $d8206b3ab2e65c05$export$e99d8b85f35b8ca5 = $d8206b3ab2e65c05$export$d262c1f5912046e6;
const $d8206b3ab2e65c05$export$f5c53ce8ec380d11 = {
    prefix: 'fas',
    iconName: 'envelope-open-text',
    icon: [
        512,
        512,
        [],
        "f658",
        "M215.4 96L144 96l-36.2 0L96 96l0 8.8L96 144l0 40.4 0 89L.2 202.5c1.6-18.1 10.9-34.9 25.7-45.8L48 140.3 48 96c0-26.5 21.5-48 48-48l76.6 0 49.9-36.9C232.2 3.9 243.9 0 256 0s23.8 3.9 33.5 11L339.4 48 416 48c26.5 0 48 21.5 48 48l0 44.3 22.1 16.4c14.8 10.9 24.1 27.7 25.7 45.8L416 273.4l0-89 0-40.4 0-39.2 0-8.8-11.8 0L368 96l-71.4 0-81.3 0zM0 448L0 242.1 217.6 403.3c11.1 8.2 24.6 12.7 38.4 12.7s27.3-4.4 38.4-12.7L512 242.1 512 448s0 0 0 0c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64c0 0 0 0 0 0zM176 160l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
const $d8206b3ab2e65c05$export$7a76c9d35b42d691 = {
    prefix: 'fas',
    iconName: 'hospital',
    icon: [
        640,
        512,
        [
            127973,
            62589,
            "hospital-alt",
            "hospital-wide"
        ],
        "f0f8",
        "M192 48c0-26.5 21.5-48 48-48L400 0c26.5 0 48 21.5 48 48l0 464-80 0 0-80c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 80-80 0 0-464zM48 96l112 0 0 416L48 512c-26.5 0-48-21.5-48-48L0 320l80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L0 288l0-64 80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L0 192l0-48c0-26.5 21.5-48 48-48zm544 0c26.5 0 48 21.5 48 48l0 48-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0 64-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0 144c0 26.5-21.5 48-48 48l-112 0 0-416 112 0zM312 64c-8.8 0-16 7.2-16 16l0 24-24 0c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l24 0 0 24c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-24 24 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-24 0 0-24c0-8.8-7.2-16-16-16l-16 0z"
    ]
};
const $d8206b3ab2e65c05$export$cea7736417b94a3b = $d8206b3ab2e65c05$export$7a76c9d35b42d691;
const $d8206b3ab2e65c05$export$69c8cc0360f017e8 = $d8206b3ab2e65c05$export$7a76c9d35b42d691;
const $d8206b3ab2e65c05$export$770be8b3d5776043 = {
    prefix: 'fas',
    iconName: 'wine-bottle',
    icon: [
        512,
        512,
        [],
        "f72f",
        "M393.4 9.4c12.5-12.5 32.8-12.5 45.3 0l64 64c12.5 12.5 12.5 32.8 0 45.3c-11.8 11.8-30.7 12.5-43.2 1.9l-9.5 9.5-48.8 48.8c-9.2 9.2-11.5 22.9-8.6 35.6c9.4 40.9-1.9 85.6-33.8 117.5L197.3 493.3c-25 25-65.5 25-90.5 0l-88-88c-25-25-25-65.5 0-90.5L180.2 153.3c31.9-31.9 76.6-43.1 117.5-33.8c12.6 2.9 26.4 .5 35.5-8.6l48.8-48.8 9.5-9.5c-10.6-12.6-10-31.4 1.9-43.2zM99.3 347.3l65.4 65.4c6.2 6.2 16.4 6.2 22.6 0l97.4-97.4c6.2-6.2 6.2-16.4 0-22.6l-65.4-65.4c-6.2-6.2-16.4-6.2-22.6 0L99.3 324.7c-6.2 6.2-6.2 16.4 0 22.6z"
    ]
};
const $d8206b3ab2e65c05$export$5d65c40a109eb09c = {
    prefix: 'fas',
    iconName: 'chess-rook',
    icon: [
        448,
        512,
        [
            9820
        ],
        "f447",
        "M32 192L32 48c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 40c0 4.4 3.6 8 8 8l32 0c4.4 0 8-3.6 8-8l0-40c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 40c0 4.4 3.6 8 8 8l32 0c4.4 0 8-3.6 8-8l0-40c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 144c0 10.1-4.7 19.6-12.8 25.6L352 256l16 144L80 400 96 256 44.8 217.6C36.7 211.6 32 202.1 32 192zm176 96l32 0c8.8 0 16-7.2 16-16l0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 48c0 8.8 7.2 16 16 16zM22.6 473.4L64 432l320 0 41.4 41.4c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6L38.6 512C26.1 512 16 501.9 16 489.4c0-6 2.4-11.8 6.6-16z"
    ]
};
const $d8206b3ab2e65c05$export$2f8a7938c06a2142 = {
    prefix: 'fas',
    iconName: 'bars-staggered',
    icon: [
        512,
        512,
        [
            "reorder",
            "stream"
        ],
        "f550",
        "M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM64 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L96 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z"
    ]
};
const $d8206b3ab2e65c05$export$75d2bb378a2fc102 = $d8206b3ab2e65c05$export$2f8a7938c06a2142;
const $d8206b3ab2e65c05$export$ed81ab40fc4e904 = $d8206b3ab2e65c05$export$2f8a7938c06a2142;
const $d8206b3ab2e65c05$export$45cbd92c28deb2c7 = {
    prefix: 'fas',
    iconName: 'dharmachakra',
    icon: [
        512,
        512,
        [
            9784
        ],
        "f655",
        "M337.8 205.7l48.6-42.5c13.8 19.3 23.4 41.9 27.4 66.2l-64.4 4.3c-2.4-10.1-6.4-19.5-11.6-28zm140.1 19.5c-5.3-38.8-20.6-74.5-43.2-104.3l.8-.7C449 108.4 449.7 87.6 437 75s-33.4-12-45.2 1.5l-.7 .8c-29.8-22.6-65.5-37.9-104.3-43.2l.1-1.1c1.2-17.9-13-33-30.9-33s-32.1 15.2-30.9 33l.1 1.1c-38.8 5.3-74.5 20.6-104.3 43.2l-.7-.8C108.4 63 87.6 62.3 75 75s-12 33.4 1.5 45.2l.8 .7c-22.6 29.8-37.9 65.5-43.2 104.3l-1.1-.1c-17.9-1.2-33 13-33 30.9s15.2 32.1 33 30.9l1.1-.1c5.3 38.8 20.6 74.5 43.2 104.3l-.8 .7C63 403.6 62.3 424.4 75 437s33.4 12 45.2-1.5l.7-.8c29.8 22.6 65.5 37.9 104.3 43.2l-.1 1.1c-1.2 17.9 13 33 30.9 33s32.1-15.2 30.9-33l-.1-1.1c38.8-5.3 74.5-20.6 104.3-43.2l.7 .8c11.8 13.5 32.5 14.2 45.2 1.5s12-33.4-1.5-45.2l-.8-.7c22.6-29.8 37.9-65.5 43.2-104.3l1.1 .1c17.9 1.2 33-13 33-30.9s-15.2-32.1-33-30.9l-1.1 .1zM163.2 125.6c19.3-13.8 41.9-23.4 66.2-27.5l4.3 64.4c-10 2.4-19.5 6.4-28 11.6l-42.5-48.6zm-65 103.8c4.1-24.4 13.7-46.9 27.5-66.2l48.6 42.5c-5.3 8.5-9.2 18-11.6 28l-64.4-4.3zm27.5 119.4c-13.8-19.3-23.4-41.9-27.5-66.2l64.4-4.3c2.4 10 6.4 19.5 11.6 28l-48.6 42.5zm103.8 65c-24.4-4.1-46.9-13.7-66.2-27.4l42.5-48.6c8.5 5.3 18 9.2 28 11.6l-4.3 64.4zm119.4-27.4c-19.3 13.8-41.9 23.4-66.2 27.4l-4.3-64.4c10-2.4 19.5-6.4 28-11.6l42.5 48.6zm65-103.8c-4.1 24.4-13.7 46.9-27.4 66.2l-48.6-42.5c5.3-8.5 9.2-18 11.6-28l64.4 4.3zm-65-156.9l-42.5 48.6c-8.5-5.3-18-9.2-28-11.6l4.3-64.4c24.4 4.1 46.9 13.7 66.2 27.5zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $d8206b3ab2e65c05$export$9fae219b4d3ce0be = {
    prefix: 'fas',
    iconName: 'hotdog',
    icon: [
        512,
        512,
        [
            127789
        ],
        "f80f",
        "M488.6 23.4c31.2 31.2 31.2 81.9 0 113.1l-352 352c-31.2 31.2-81.9 31.2-113.1 0s-31.2-81.9 0-113.1l352-352c31.2-31.2 81.9-31.2 113.1 0zM443.3 92.7c-6.2-6.2-16.4-6.2-22.6 0c-12.5 12.5-23.8 15.1-37.5 17.6l-2.5 .4c-13.8 2.5-31.6 5.6-48 22c-16.7 16.7-20.9 36-24.1 50.9c0 0 0 0 0 0s0 0 0 0l-.2 1c-3.4 15.6-6 26.4-15.7 36.1s-20.5 12.3-36.1 15.7l-1 .2c-14.9 3.2-34.2 7.4-50.9 24.1s-20.9 36-24.1 50.9l-.2 1c-3.4 15.6-6 26.4-15.7 36.1c-9.2 9.2-18 10.8-32.7 13.4c0 0 0 0 0 0l-.9 .2c-15.6 2.8-34.9 6.9-54.4 26.4c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0c12.5-12.5 23.8-15.1 37.5-17.6l2.5-.4c13.8-2.5 31.6-5.6 48-22c16.7-16.7 20.9-36 24.1-50.9l.2-1c3.4-15.6 6-26.4 15.7-36.1s20.5-12.3 36.1-15.7l1-.2c14.9-3.2 34.2-7.4 50.9-24.1s20.9-36 24.1-50.9l.2-1c3.4-15.6 6-26.4 15.7-36.1c9.2-9.2 18-10.8 32.7-13.4l.9-.2c15.6-2.8 34.9-6.9 54.4-26.4c6.2-6.2 6.2-16.4 0-22.6zM191.2 479.2l288-288L495 207c10.9 10.9 17 25.6 17 41s-6.1 30.1-17 41L289 495c-10.9 10.9-25.6 17-41 17s-30.1-6.1-41-17l-15.8-15.8zM17 305C6.1 294.1 0 279.4 0 264s6.1-30.1 17-41L223 17C233.9 6.1 248.6 0 264 0s30.1 6.1 41 17l15.8 15.8-288 288L17 305z"
    ]
};
const $d8206b3ab2e65c05$export$2ffee5b2bc935c1f = {
    prefix: 'fas',
    iconName: 'person-walking-with-cane',
    icon: [
        512,
        512,
        [
            "blind"
        ],
        "f29d",
        "M176 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8.4 32c-36.4 0-69.6 20.5-85.9 53.1L35.4 273.7c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3L128 231.6l0 43.2c0 17 6.7 33.3 18.7 45.3L224 397.3l0 82.7c0 17.7 14.3 32 32 32s32-14.3 32-32l0-89.4c0-12.7-5.1-24.9-14.1-33.9L224 306.7l0-93.4 70.4 93.9c10.6 14.1 30.7 17 44.8 6.4s17-30.7 6.4-44.8L268.8 166.4C250.7 142.2 222.2 128 192 128l-24.4 0zM128.3 346.8L97 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l22-88.2-52.8-52.8zM450.8 505.1c5 7.3 15 9.1 22.3 4s9.1-15 4-22.3L358.9 316.1c-2.8 3.8-6.1 7.3-10.1 10.3c-5 3.8-10.5 6.4-16.2 7.9L450.8 505.1z"
    ]
};
const $d8206b3ab2e65c05$export$923de21def6ea9b6 = $d8206b3ab2e65c05$export$2ffee5b2bc935c1f;
const $d8206b3ab2e65c05$export$5b9205e1042594b7 = {
    prefix: 'fas',
    iconName: 'drum',
    icon: [
        512,
        512,
        [
            129345
        ],
        "f569",
        "M501.2 76.1c11.1-7.3 14.2-22.1 6.9-33.2s-22.1-14.2-33.2-6.9L370.2 104.5C335.8 98.7 297 96 256 96C114.6 96 0 128 0 208L0 368c0 31.3 27.4 58.8 72 78.7L72 344c0-13.3 10.7-24 24-24s24 10.7 24 24l0 119.4c33 8.9 71.1 14.5 112 16.1L232 376c0-13.3 10.7-24 24-24s24 10.7 24 24l0 103.5c40.9-1.6 79-7.2 112-16.1L392 344c0-13.3 10.7-24 24-24s24 10.7 24 24l0 102.7c44.6-19.9 72-47.4 72-78.7l0-160c0-41.1-30.2-69.5-78.8-87.4l67.9-44.5zM307.4 145.6l-64.6 42.3c-11.1 7.3-14.2 22.1-6.9 33.2s22.1 14.2 33.2 6.9l111.1-72.8c14.7 3.2 27.9 7 39.4 11.5C458.4 181.8 464 197.4 464 208c0 .8-2.7 17.2-46 35.9C379.1 260.7 322 272 256 272s-123.1-11.3-162-28.1C50.7 225.2 48 208.8 48 208c0-10.6 5.6-26.2 44.4-41.3C130.6 151.9 187.8 144 256 144c18 0 35.1 .5 51.4 1.6z"
    ]
};
const $d8206b3ab2e65c05$export$dd52741c60cc638f = {
    prefix: 'fas',
    iconName: 'ice-cream',
    icon: [
        448,
        512,
        [
            127848
        ],
        "f810",
        "M367.1 160c.6-5.3 .9-10.6 .9-16C368 64.5 303.5 0 224 0S80 64.5 80 144c0 5.4 .3 10.7 .9 16l-.9 0c-26.5 0-48 21.5-48 48s21.5 48 48 48l53.5 0 181 0 53.5 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-.9 0zM96 288L200.8 497.7c4.4 8.8 13.3 14.3 23.2 14.3s18.8-5.5 23.2-14.3L352 288 96 288z"
    ]
};
const $d8206b3ab2e65c05$export$2a376a9d0d8fee96 = {
    prefix: 'fas',
    iconName: 'heart-circle-bolt',
    icon: [
        576,
        512,
        [],
        "e4fc",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6l0-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1l0 5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm47.9-225c4.3 3.7 5.4 9.9 2.6 14.9L452.4 356l35.6 0c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9L411.6 380 376 380c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1 .6z"
    ]
};
const $d8206b3ab2e65c05$export$b5698497901d7197 = {
    prefix: 'fas',
    iconName: 'fax',
    icon: [
        512,
        512,
        [
            128224,
            128439
        ],
        "f1ac",
        "M128 64l0 96 64 0 0-96 194.7 0L416 93.3l0 66.7 64 0 0-66.7c0-17-6.7-33.3-18.7-45.3L432 18.7C420 6.7 403.7 0 386.7 0L192 0c-35.3 0-64 28.7-64 64zM0 160L0 480c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32zm480 32l-352 0 0 288c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32zM256 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
const $d8206b3ab2e65c05$export$dec46f8df1860e0 = {
    prefix: 'fas',
    iconName: 'paragraph',
    icon: [
        448,
        512,
        [
            182
        ],
        "f1dd",
        "M192 32l64 0 160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0 0 352c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-352-32 0 0 352c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96-32 0c-88.4 0-160-71.6-160-160s71.6-160 160-160z"
    ]
};
const $d8206b3ab2e65c05$export$6999832247e52c2b = {
    prefix: 'fas',
    iconName: 'check-to-slot',
    icon: [
        576,
        512,
        [
            "vote-yea"
        ],
        "f772",
        "M96 80c0-26.5 21.5-48 48-48l288 0c26.5 0 48 21.5 48 48l0 304L96 384 96 80zm313 47c-9.4-9.4-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L409 161c9.4-9.4 9.4-24.6 0-33.9zM0 336c0-26.5 21.5-48 48-48l16 0 0 128 448 0 0-128 16 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48L48 480c-26.5 0-48-21.5-48-48l0-96z"
    ]
};
const $d8206b3ab2e65c05$export$e87bb3db1608b850 = $d8206b3ab2e65c05$export$6999832247e52c2b;
const $d8206b3ab2e65c05$export$228008b5e11032fa = {
    prefix: 'fas',
    iconName: 'star-half',
    icon: [
        576,
        512,
        [
            61731
        ],
        "f089",
        "M288 0c-12.2 .1-23.3 7-28.6 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3L288 439.8 288 0zM429.9 512c1.1 .1 2.1 .1 3.2 0l-3.2 0z"
    ]
};
const $d8206b3ab2e65c05$export$2088efcf62cf3b1 = {
    prefix: 'fas',
    iconName: 'boxes-stacked',
    icon: [
        576,
        512,
        [
            62625,
            "boxes",
            "boxes-alt"
        ],
        "f468",
        "M248 0L208 0c-26.5 0-48 21.5-48 48l0 112c0 35.3 28.7 64 64 64l128 0c35.3 0 64-28.7 64-64l0-112c0-26.5-21.5-48-48-48L328 0l0 80c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-80zM64 256c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l160 0c35.3 0 64-28.7 64-64l0-128c0-35.3-28.7-64-64-64l-40 0 0 80c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-80-40 0zM352 512l160 0c35.3 0 64-28.7 64-64l0-128c0-35.3-28.7-64-64-64l-40 0 0 80c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-80-40 0c-15 0-28.8 5.1-39.7 13.8c4.9 10.4 7.7 22 7.7 34.2l0 160c0 12.2-2.8 23.8-7.7 34.2C323.2 506.9 337 512 352 512z"
    ]
};
const $d8206b3ab2e65c05$export$2007320dd6cde6db = $d8206b3ab2e65c05$export$2088efcf62cf3b1;
const $d8206b3ab2e65c05$export$e6ef1d896ed63b3e = $d8206b3ab2e65c05$export$2088efcf62cf3b1;
const $d8206b3ab2e65c05$export$88bc01ff8dbecc55 = {
    prefix: 'fas',
    iconName: 'link',
    icon: [
        640,
        512,
        [
            128279,
            "chain"
        ],
        "f0c1",
        "M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"
    ]
};
const $d8206b3ab2e65c05$export$b5d071e02a25554f = $d8206b3ab2e65c05$export$88bc01ff8dbecc55;
const $d8206b3ab2e65c05$export$837bc776b490934d = {
    prefix: 'fas',
    iconName: 'ear-listen',
    icon: [
        512,
        512,
        [
            "assistive-listening-systems"
        ],
        "f2a2",
        "M398.3 3.4c-15.8-7.9-35-1.5-42.9 14.3c-7.9 15.8-1.5 34.9 14.2 42.9l.4 .2c.4 .2 1.1 .6 2.1 1.2c2 1.2 5 3 8.7 5.6c7.5 5.2 17.6 13.2 27.7 24.2C428.5 113.4 448 146 448 192c0 17.7 14.3 32 32 32s32-14.3 32-32c0-66-28.5-113.4-56.5-143.7C441.6 33.2 427.7 22.2 417.3 15c-5.3-3.7-9.7-6.4-13-8.3c-1.6-1-3-1.7-4-2.2c-.5-.3-.9-.5-1.2-.7l-.4-.2-.2-.1c0 0 0 0-.1 0c0 0 0 0 0 0L384 32 398.3 3.4zM128.7 227.5c6.2-56 53.7-99.5 111.3-99.5c61.9 0 112 50.1 112 112c0 29.3-11.2 55.9-29.6 75.9c-17 18.4-34.4 45.1-34.4 78l0 6.1c0 26.5-21.5 48-48 48c-17.7 0-32 14.3-32 32s14.3 32 32 32c61.9 0 112-50.1 112-112l0-6.1c0-9.8 5.4-21.7 17.4-34.7C398.3 327.9 416 286 416 240c0-97.2-78.8-176-176-176C149.4 64 74.8 132.5 65.1 220.5c-1.9 17.6 10.7 33.4 28.3 35.3s33.4-10.7 35.3-28.3zM32 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM192 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64c-12.5-12.5-32.8-12.5-45.3 0zM208 240c0-17.7 14.3-32 32-32s32 14.3 32 32c0 13.3 10.7 24 24 24s24-10.7 24-24c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 13.3 10.7 24 24 24s24-10.7 24-24z"
    ]
};
const $d8206b3ab2e65c05$export$8eeef3dc0035b165 = $d8206b3ab2e65c05$export$837bc776b490934d;
const $d8206b3ab2e65c05$export$ad95e4f80f98ebe0 = {
    prefix: 'fas',
    iconName: 'tree-city',
    icon: [
        640,
        512,
        [],
        "e587",
        "M288 48c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 144 40 0 0-72c0-13.3 10.7-24 24-24s24 10.7 24 24l0 72 24 0c26.5 0 48 21.5 48 48l0 224c0 26.5-21.5 48-48 48l-160 0-96 0c-26.5 0-48-21.5-48-48l0-416zm64 32l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM352 272l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm176-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM512 368l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM224 160c0 6-1 11-2 16c20 14 34 38 34 64c0 45-36 80-80 80l-16 0 0 160c0 18-15 32-32 32c-18 0-32-14-32-32l0-160-16 0c-45 0-80-35-80-80c0-26 13-50 33-64c-1-5-1-10-1-16c0-53 42-96 96-96c53 0 96 43 96 96z"
    ]
};
const $d8206b3ab2e65c05$export$436587205947bca5 = {
    prefix: 'fas',
    iconName: 'play',
    icon: [
        384,
        512,
        [
            9654
        ],
        "f04b",
        "M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80L0 432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z"
    ]
};
const $d8206b3ab2e65c05$export$a5dc297d3f60936 = {
    prefix: 'fas',
    iconName: 'font',
    icon: [
        448,
        512,
        [],
        "f031",
        "M254 52.8C249.3 40.3 237.3 32 224 32s-25.3 8.3-30 20.8L57.8 416 32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-1.8 0 18-48 159.6 0 18 48-1.8 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-25.8 0L254 52.8zM279.8 304l-111.6 0L224 155.1 279.8 304z"
    ]
};
const $d8206b3ab2e65c05$export$2c0ab34218da6651 = {
    prefix: 'fas',
    iconName: 'table-cells-row-lock',
    icon: [
        640,
        512,
        [],
        "e67a",
        "M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 65.1c-37.8 5.4-69.4 29.6-85.2 62.9L360 224l0 64 56 0 0 8.6c-19.1 11.1-32 31.7-32 55.4l-24 0 0 64 24 0 0 64L64 480c-35.3 0-64-28.7-64-64L0 96zM64 224l0 64 88 0 0-64-88 0zm232 0l-88 0 0 64 88 0 0-64zM152 352l-88 0 0 64 88 0 0-64zm56 0l0 64 88 0 0-64-88 0zM528 240c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48z"
    ]
};
const $d8206b3ab2e65c05$export$fe44d4c71644ea0 = {
    prefix: 'fas',
    iconName: 'rupiah-sign',
    icon: [
        512,
        512,
        [],
        "e23d",
        "M0 64C0 46.3 14.3 32 32 32l80 0c79.5 0 144 64.5 144 144c0 58.8-35.2 109.3-85.7 131.7l51.4 128.4c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8L106.3 320 64 320l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 288 0 64zM64 256l48 0c44.2 0 80-35.8 80-80s-35.8-80-80-80L64 96l0 160zm256-96l80 0c61.9 0 112 50.1 112 112s-50.1 112-112 112l-48 0 0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128 0-160c0-17.7 14.3-32 32-32zm80 160c26.5 0 48-21.5 48-48s-21.5-48-48-48l-48 0 0 96 48 0z"
    ]
};
const $d8206b3ab2e65c05$export$34c8b97060c09ff = {
    prefix: 'fas',
    iconName: 'magnifying-glass',
    icon: [
        512,
        512,
        [
            128269,
            "search"
        ],
        "f002",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"
    ]
};
const $d8206b3ab2e65c05$export$871a78837687ffe8 = $d8206b3ab2e65c05$export$34c8b97060c09ff;
const $d8206b3ab2e65c05$export$eabe53838d45ac6a = {
    prefix: 'fas',
    iconName: 'table-tennis-paddle-ball',
    icon: [
        512,
        512,
        [
            127955,
            "ping-pong-paddle-ball",
            "table-tennis"
        ],
        "f45d",
        "M416 288c-50.1 0-93.6 28.8-114.6 70.8L68.9 126.3l.6-.6 60.1-60.1c87.5-87.5 229.3-87.5 316.8 0c67.1 67.1 82.7 166.3 46.8 248.3C471.8 297.6 445 288 416 288zM49.3 151.9L290.1 392.7c-1.4 7.5-2.1 15.3-2.1 23.3c0 23.2 6.2 44.9 16.9 63.7c-3 .2-6.1 .3-9.2 .3l-2.7 0c-33.9 0-66.5-13.5-90.5-37.5l-9.8-9.8c-13.1-13.1-34.6-12.4-46.8 1.7L88.2 501c-5.8 6.7-14.2 10.7-23 11s-17.5-3.1-23.8-9.4l-32-32C3.1 464.3-.3 455.7 0 446.9s4.3-17.2 11-23l66.6-57.7c14-12.2 14.8-33.7 1.7-46.8l-9.8-9.8C45.5 285.5 32 252.9 32 219l0-2.7c0-22.8 6.1-44.9 17.3-64.3zM416 320a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
    ]
};
const $d8206b3ab2e65c05$export$ebb246c621751737 = $d8206b3ab2e65c05$export$eabe53838d45ac6a;
const $d8206b3ab2e65c05$export$f378fbb4e0ef7edf = $d8206b3ab2e65c05$export$eabe53838d45ac6a;
const $d8206b3ab2e65c05$export$cdcec8ca7ec0d381 = {
    prefix: 'fas',
    iconName: 'person-dots-from-line',
    icon: [
        576,
        512,
        [
            "diagnoses"
        ],
        "f470",
        "M288 176A88 88 0 1 0 288 0a88 88 0 1 0 0 176zM78.7 372.9c15-12.5 50-34.4 97.3-50.1L176 432l224 0 0-109.3c47.3 15.8 82.3 37.7 97.3 50.1c20.4 17 50.6 14.2 67.6-6.1s14.2-50.6-6.1-67.6c-12-10-30.1-22.5-53.2-35C497.2 278.4 481.7 288 464 288c-26.5 0-48-21.5-48-48c0-4.3 .6-8.4 1.6-12.4C379.1 215.9 335.3 208 288 208c-60.2 0-114.9 12.9-160 29.9c0 .7 0 1.4 0 2.1c0 26.5-21.5 48-48 48c-11.8 0-22.7-4.3-31-11.4c-13.1 8.1-23.7 15.9-31.7 22.5c-20.4 17-23.1 47.2-6.1 67.6s47.2 23.1 67.6 6.1zM24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l528 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 464zM224 280a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM96 240a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm368 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
const $d8206b3ab2e65c05$export$68bad2b52a90d1fa = $d8206b3ab2e65c05$export$cdcec8ca7ec0d381;
const $d8206b3ab2e65c05$export$60430351cdb4ba89 = {
    prefix: 'fas',
    iconName: 'trash-can-arrow-up',
    icon: [
        448,
        512,
        [
            "trash-restore-alt"
        ],
        "f82a",
        "M163.8 0L284.2 0c12.1 0 23.2 6.8 28.6 17.7L320 32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l96 0 7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128l384 0 0 320c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-320zm192 64c-6.4 0-12.5 2.5-17 7l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39L200 408c0 13.3 10.7 24 24 24s24-10.7 24-24l0-134.1 39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-4.5-4.5-10.6-7-17-7z"
    ]
};
const $d8206b3ab2e65c05$export$d075b19b21cb9856 = $d8206b3ab2e65c05$export$60430351cdb4ba89;
const $d8206b3ab2e65c05$export$58b7558ca9822358 = {
    prefix: 'fas',
    iconName: 'naira-sign',
    icon: [
        448,
        512,
        [],
        "e1f6",
        "M122.6 46.3c-7.8-11.7-22.4-17-35.9-12.9S64 49.9 64 64l0 192-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 100.2 0 97.2 145.8c7.8 11.7 22.4 17 35.9 12.9s22.7-16.5 22.7-30.6l0-128 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-192c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 192-57.5 0L122.6 46.3zM305.1 320l14.9 0 0 22.3L305.1 320zM185.5 256L128 256l0-86.3L185.5 256z"
    ]
};
const $d8206b3ab2e65c05$export$9206260ff0c0c616 = {
    prefix: 'fas',
    iconName: 'cart-arrow-down',
    icon: [
        576,
        512,
        [],
        "f218",
        "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l45.5 0c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5L488 384c13.3 0 24-10.7 24-24s-10.7-24-24-24l-288.3 0c-11.5 0-21.4-8.2-23.6-19.5L170.7 288l288.5 0c32.6 0 61.1-21.8 69.5-53.3l41-152.3C576.6 57 557.4 32 531.1 32L360 32l0 102.1 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-64 64c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23L312 32 120.1 32C111 12.8 91.6 0 69.5 0L24 0zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
    ]
};
const $d8206b3ab2e65c05$export$8a322f740d64e9fc = {
    prefix: 'fas',
    iconName: 'walkie-talkie',
    icon: [
        384,
        512,
        [],
        "f8ef",
        "M112 24c0-13.3-10.7-24-24-24S64 10.7 64 24l0 72L48 96C21.5 96 0 117.5 0 144L0 300.1c0 12.7 5.1 24.9 14.1 33.9l3.9 3.9c9 9 14.1 21.2 14.1 33.9L32 464c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-92.1c0-12.7 5.1-24.9 14.1-33.9l3.9-3.9c9-9 14.1-21.2 14.1-33.9L384 144c0-26.5-21.5-48-48-48l-16 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l-32 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l-48 0 0-72zm0 136l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
const $d8206b3ab2e65c05$export$27f34878d8ed7a76 = {
    prefix: 'fas',
    iconName: 'file-pen',
    icon: [
        576,
        512,
        [
            128221,
            "file-edit"
        ],
        "f31c",
        "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 125.7-86.8 86.8c-10.3 10.3-17.5 23.1-21 37.2l-18.7 74.9c-2.3 9.2-1.8 18.8 1.3 27.5L64 512c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM549.8 235.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417L441.1 287.8l71 71L382.9 487.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"
    ]
};
const $d8206b3ab2e65c05$export$e343e19f1757c5ae = $d8206b3ab2e65c05$export$27f34878d8ed7a76;
const $d8206b3ab2e65c05$export$32b0cd6133c2742 = {
    prefix: 'fas',
    iconName: 'receipt',
    icon: [
        384,
        512,
        [
            129534
        ],
        "f543",
        "M14 2.2C22.5-1.7 32.5-.3 39.6 5.8L80 40.4 120.4 5.8c9-7.7 22.3-7.7 31.2 0L192 40.4 232.4 5.8c9-7.7 22.3-7.7 31.2 0L304 40.4 344.4 5.8c7.1-6.1 17.1-7.5 25.6-3.6s14 12.4 14 21.8l0 464c0 9.4-5.5 17.9-14 21.8s-18.5 2.5-25.6-3.6L304 471.6l-40.4 34.6c-9 7.7-22.3 7.7-31.2 0L192 471.6l-40.4 34.6c-9 7.7-22.3 7.7-31.2 0L80 471.6 39.6 506.2c-7.1 6.1-17.1 7.5-25.6 3.6S0 497.4 0 488L0 24C0 14.6 5.5 6.1 14 2.2zM96 144c-8.8 0-16 7.2-16 16s7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L96 144zM80 352c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L96 336c-8.8 0-16 7.2-16 16zM96 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L96 240z"
    ]
};
const $d8206b3ab2e65c05$export$3643b719db23d46e = {
    prefix: 'fas',
    iconName: 'square-pen',
    icon: [
        448,
        512,
        [
            "pen-square",
            "pencil-square"
        ],
        "f14b",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM325.8 139.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-21.4 21.4-71-71 21.4-21.4c15.6-15.6 40.9-15.6 56.6 0zM119.9 289L225.1 183.8l71 71L190.9 359.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"
    ]
};
const $d8206b3ab2e65c05$export$fbb231ccb3d960bc = $d8206b3ab2e65c05$export$3643b719db23d46e;
const $d8206b3ab2e65c05$export$35d253ecd249e771 = $d8206b3ab2e65c05$export$3643b719db23d46e;
const $d8206b3ab2e65c05$export$957e62a9b80ff4e3 = {
    prefix: 'fas',
    iconName: 'suitcase-rolling',
    icon: [
        384,
        512,
        [],
        "f5c1",
        "M144 56c0-4.4 3.6-8 8-8l80 0c4.4 0 8 3.6 8 8l0 72-96 0 0-72zm176 72l-32 0 0-72c0-30.9-25.1-56-56-56L152 0C121.1 0 96 25.1 96 56l0 72-32 0c-35.3 0-64 28.7-64 64L0 416c0 35.3 28.7 64 64 64c0 17.7 14.3 32 32 32s32-14.3 32-32l128 0c0 17.7 14.3 32 32 32s32-14.3 32-32c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64zM112 224l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 128l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
const $d8206b3ab2e65c05$export$38c8c32017dd9cc = {
    prefix: 'fas',
    iconName: 'person-circle-exclamation',
    icon: [
        576,
        512,
        [],
        "e53f",
        "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-223.1L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6l29.7 0c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9 232 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128-16 0zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16z"
    ]
};
const $d8206b3ab2e65c05$export$8db9bc521720fccd = {
    prefix: 'fas',
    iconName: 'chevron-down',
    icon: [
        512,
        512,
        [],
        "f078",
        "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"
    ]
};
const $d8206b3ab2e65c05$export$9338fc4614cfc0cf = {
    prefix: 'fas',
    iconName: 'battery-full',
    icon: [
        576,
        512,
        [
            128267,
            "battery",
            "battery-5"
        ],
        "f240",
        "M464 160c8.8 0 16 7.2 16 16l0 160c0 8.8-7.2 16-16 16L80 352c-8.8 0-16-7.2-16-16l0-160c0-8.8 7.2-16 16-16l384 0zM80 96C35.8 96 0 131.8 0 176L0 336c0 44.2 35.8 80 80 80l384 0c44.2 0 80-35.8 80-80l0-16c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l0-16c0-44.2-35.8-80-80-80L80 96zm368 96L96 192l0 128 352 0 0-128z"
    ]
};
const $d8206b3ab2e65c05$export$214720d39635cea8 = $d8206b3ab2e65c05$export$9338fc4614cfc0cf;
const $d8206b3ab2e65c05$export$e426617482c711a7 = $d8206b3ab2e65c05$export$9338fc4614cfc0cf;
const $d8206b3ab2e65c05$export$8717352b90217272 = {
    prefix: 'fas',
    iconName: 'skull-crossbones',
    icon: [
        448,
        512,
        [
            128369,
            9760
        ],
        "f714",
        "M368 128c0 44.4-25.4 83.5-64 106.4l0 21.6c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32l0-21.6c-38.6-23-64-62.1-64-106.4C80 57.3 144.5 0 224 0s144 57.3 144 128zM168 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm144-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM3.4 273.7c7.9-15.8 27.1-22.2 42.9-14.3L224 348.2l177.7-88.8c15.8-7.9 35-1.5 42.9 14.3s1.5 35-14.3 42.9L295.6 384l134.8 67.4c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L224 419.8 46.3 508.6c-15.8 7.9-35 1.5-42.9-14.3s-1.5-35 14.3-42.9L152.4 384 17.7 316.6C1.9 308.7-4.5 289.5 3.4 273.7z"
    ]
};
const $d8206b3ab2e65c05$export$ca4c5b4dcff58860 = {
    prefix: 'fas',
    iconName: 'code-compare',
    icon: [
        512,
        512,
        [],
        "e13a",
        "M320 488c0 9.5-5.6 18.1-14.2 21.9s-18.8 2.3-25.8-4.1l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c7-6.3 17.2-7.9 25.8-4.1s14.2 12.4 14.2 21.9l0 40 16 0c35.3 0 64-28.7 64-64l0-166.7C371.7 141 352 112.8 352 80c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3L464 320c0 70.7-57.3 128-128 128l-16 0 0 40zM456 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM192 24c0-9.5 5.6-18.1 14.2-21.9s18.8-2.3 25.8 4.1l80 72c5.1 4.6 7.9 11 7.9 17.8s-2.9 13.3-7.9 17.8l-80 72c-7 6.3-17.2 7.9-25.8 4.1s-14.2-12.4-14.2-21.9l0-40-16 0c-35.3 0-64 28.7-64 64l0 166.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3L48 192c0-70.7 57.3-128 128-128l16 0 0-40zM56 432a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z"
    ]
};
const $d8206b3ab2e65c05$export$f8a219cf4f516384 = {
    prefix: 'fas',
    iconName: 'list-ul',
    icon: [
        512,
        512,
        [
            "list-dots"
        ],
        "f0ca",
        "M64 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L192 64zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-288 0zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-288 0zM64 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48-208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
    ]
};
const $d8206b3ab2e65c05$export$e6f4ba30d84fa6ea = $d8206b3ab2e65c05$export$f8a219cf4f516384;
const $d8206b3ab2e65c05$export$8845cce2a763ee07 = {
    prefix: 'fas',
    iconName: 'school-lock',
    icon: [
        640,
        512,
        [],
        "e56f",
        "M302.2 5.4c10.7-7.2 24.8-7.2 35.5 0L473.7 96 592 96c26.5 0 48 21.5 48 48l0 128c0-61.9-50.1-112-112-112s-112 50.1-112 112l0 24.6c-19.1 11.1-32 31.7-32 55.4l-63.7 0-.3 0c-35.3 0-64 28.7-64 64l0 96 64 0s0 0 0 0L48 512c-26.5 0-48-21.5-48-48L0 144c0-26.5 21.5-48 48-48l118.3 0L302.2 5.4zM80 208l0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 128l0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm240-72a88 88 0 1 0 0-176 88 88 0 1 0 0 176zm16-120l0 16 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16s16 7.2 16 16zm192 96c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48z"
    ]
};
const $d8206b3ab2e65c05$export$f4b64c3a138c1b59 = {
    prefix: 'fas',
    iconName: 'tower-cell',
    icon: [
        576,
        512,
        [],
        "e585",
        "M62.6 2.3C46.2-4.3 27.6 3.6 20.9 20C7.4 53.4 0 89.9 0 128s7.4 74.6 20.9 108c6.6 16.4 25.3 24.3 41.7 17.7S86.9 228.4 80.3 212C69.8 186.1 64 157.8 64 128s5.8-58.1 16.3-84C86.9 27.6 79 9 62.6 2.3zm450.8 0C497 9 489.1 27.6 495.7 44C506.2 69.9 512 98.2 512 128s-5.8 58.1-16.3 84c-6.6 16.4 1.3 35 17.7 41.7s35-1.3 41.7-17.7c13.5-33.4 20.9-69.9 20.9-108s-7.4-74.6-20.9-108C548.4 3.6 529.8-4.3 513.4 2.3zM340.1 165.2c7.5-10.5 11.9-23.3 11.9-37.2c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 13.9 4.4 26.7 11.9 37.2L98.9 466.8c-7.3 16.1-.2 35.1 15.9 42.4s35.1 .2 42.4-15.9L177.7 448l220.6 0 20.6 45.2c7.3 16.1 26.3 23.2 42.4 15.9s23.2-26.3 15.9-42.4L340.1 165.2zM369.2 384l-162.4 0 14.5-32 133.3 0 14.5 32zM288 205.3L325.6 288l-75.2 0L288 205.3zM163.3 73.6c5.3-12.1-.2-26.3-12.4-31.6s-26.3 .2-31.6 12.4C109.5 77 104 101.9 104 128s5.5 51 15.3 73.6c5.3 12.1 19.5 17.7 31.6 12.4s17.7-19.5 12.4-31.6C156 165.8 152 147.4 152 128s4-37.8 11.3-54.4zM456.7 54.4c-5.3-12.1-19.5-17.7-31.6-12.4s-17.7 19.5-12.4 31.6C420 90.2 424 108.6 424 128s-4 37.8-11.3 54.4c-5.3 12.1 .2 26.3 12.4 31.6s26.3-.2 31.6-12.4C466.5 179 472 154.1 472 128s-5.5-51-15.3-73.6z"
    ]
};
const $d8206b3ab2e65c05$export$e88ba08d4f4d65b6 = {
    prefix: 'fas',
    iconName: 'down-long',
    icon: [
        320,
        512,
        [
            "long-arrow-alt-down"
        ],
        "f309",
        "M2 334.5c-3.8 8.8-2 19 4.6 26l136 144c4.5 4.8 10.8 7.5 17.4 7.5s12.9-2.7 17.4-7.5l136-144c6.6-7 8.4-17.2 4.6-26s-12.5-14.5-22-14.5l-72 0 0-288c0-17.7-14.3-32-32-32L128 0C110.3 0 96 14.3 96 32l0 288-72 0c-9.6 0-18.2 5.7-22 14.5z"
    ]
};
const $d8206b3ab2e65c05$export$8b92530ca6418c2f = $d8206b3ab2e65c05$export$e88ba08d4f4d65b6;
const $d8206b3ab2e65c05$export$e6fd420a918b43b5 = {
    prefix: 'fas',
    iconName: 'ranking-star',
    icon: [
        640,
        512,
        [],
        "e561",
        "M353.8 54.1L330.2 6.3c-3.9-8.3-16.1-8.6-20.4 0L286.2 54.1l-52.3 7.5c-9.3 1.4-13.3 12.9-6.4 19.8l38 37-9 52.1c-1.4 9.3 8.2 16.5 16.8 12.2l46.9-24.8 46.6 24.4c8.6 4.3 18.3-2.9 16.8-12.2l-9-52.1 38-36.6c6.8-6.8 2.9-18.3-6.4-19.8l-52.3-7.5zM256 256c-17.7 0-32 14.3-32 32l0 192c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-192c0-17.7-14.3-32-32-32l-128 0zM32 320c-17.7 0-32 14.3-32 32L0 480c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32L32 320zm416 96l0 64c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-128 0c-17.7 0-32 14.3-32 32z"
    ]
};
const $d8206b3ab2e65c05$export$d5713874f8fefe1b = {
    prefix: 'fas',
    iconName: 'chess-king',
    icon: [
        448,
        512,
        [
            9818
        ],
        "f43f",
        "M224 0c17.7 0 32 14.3 32 32l0 16 16 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-16 0 0 48 152 0c22.1 0 40 17.9 40 40c0 5.3-1 10.5-3.1 15.4L368 400 80 400 3.1 215.4C1 210.5 0 205.3 0 200c0-22.1 17.9-40 40-40l152 0 0-48-16 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l16 0 0-16c0-17.7 14.3-32 32-32zM38.6 473.4L80 432l288 0 41.4 41.4c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6L54.6 512C42.1 512 32 501.9 32 489.4c0-6 2.4-11.8 6.6-16z"
    ]
};
const $d8206b3ab2e65c05$export$dcd74f2821882a49 = {
    prefix: 'fas',
    iconName: 'person-harassing',
    icon: [
        576,
        512,
        [],
        "e549",
        "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM59.4 304.5L88 256.9 88 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 16 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-244.7 47.4 57.1c11.3 13.6 31.5 15.5 45.1 4.2s15.5-31.5 4.2-45.1l-73.7-88.9c-18.2-22-45.3-34.7-73.9-34.7l-35.9 0c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9zM480 240a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM464 344l0 58.7-41.4-41.4c-7.3-7.3-17.6-10.6-27.8-9s-18.9 8.1-23.5 17.3l-48 96c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3L408.8 438l54.7 54.7c12.4 12.4 29.1 19.3 46.6 19.3c36.4 0 65.9-29.5 65.9-65.9L576 344c0-30.9-25.1-56-56-56s-56 25.1-56 56zM288 48c0 8.8 7.2 16 16 16l56 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-56 0c-8.8 0-16 7.2-16 16zm-.8 49.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l48 24c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-48-24z"
    ]
};
const $d8206b3ab2e65c05$export$9d355b4e79216962 = {
    prefix: 'fas',
    iconName: 'brazilian-real-sign',
    icon: [
        512,
        512,
        [],
        "e46c",
        "M400 0c17.7 0 32 14.3 32 32l0 18.2c12.5 2.3 24.7 6.4 36.2 12.1l10.1 5.1c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-10.2-5.1c-9.9-5-20.9-7.5-32-7.5l-1.7 0c-29.8 0-53.9 24.1-53.9 53.9c0 22 13.4 41.8 33.9 50l52 20.8c44.7 17.9 74.1 61.2 74.1 109.4l0 3.4c0 51.2-33.6 94.6-80 109.2l0 21.3c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-19.4c-15-3.5-29.4-9.7-42.3-18.3l-23.4-15.6c-14.7-9.8-18.7-29.7-8.9-44.4s29.7-18.7 44.4-8.9L361.2 389c10.8 7.2 23.4 11 36.3 11c27.9 0 50.5-22.6 50.5-50.5l0-3.4c0-22-13.4-41.8-33.9-50l-52-20.8C317.3 257.4 288 214.1 288 165.9C288 114 321.5 70 368 54.2L368 32c0-17.7 14.3-32 32-32zM0 64C0 46.3 14.3 32 32 32l80 0c79.5 0 144 64.5 144 144c0 58.8-35.2 109.3-85.7 131.7l51.4 128.4c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8L106.3 320 64 320l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 288 0 64zM64 256l48 0c44.2 0 80-35.8 80-80s-35.8-80-80-80L64 96l0 160z"
    ]
};
const $d8206b3ab2e65c05$export$8a56136f40511e5d = {
    prefix: 'fas',
    iconName: 'landmark-dome',
    icon: [
        512,
        512,
        [
            "landmark-alt"
        ],
        "f752",
        "M248 0l16 0c13.3 0 24 10.7 24 24l0 10.7C368.4 48.1 431.9 111.6 445.3 192l2.7 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L64 256c-17.7 0-32-14.3-32-32s14.3-32 32-32l2.7 0C80.1 111.6 143.6 48.1 224 34.7L224 24c0-13.3 10.7-24 24-24zM64 288l64 0 0 128 40 0 0-128 64 0 0 128 48 0 0-128 64 0 0 128 40 0 0-128 64 0 0 132.3c.6 .3 1.2 .7 1.8 1.1l48 32c11.7 7.8 17 22.4 12.9 35.9S494.1 512 480 512L32 512c-14.1 0-26.5-9.2-30.6-22.7s1.1-28.1 12.9-35.9l48-32c.6-.4 1.2-.7 1.8-1.1L64 288z"
    ]
};
const $d8206b3ab2e65c05$export$8b9c180efffc50ab = $d8206b3ab2e65c05$export$8a56136f40511e5d;
const $d8206b3ab2e65c05$export$8e144ed4d52eef49 = {
    prefix: 'fas',
    iconName: 'arrow-up',
    icon: [
        384,
        512,
        [
            8593
        ],
        "f062",
        "M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 141.2 160 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-306.7L329.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160z"
    ]
};
const $d8206b3ab2e65c05$export$e0cfed4ba2fe562c = {
    prefix: 'fas',
    iconName: 'tv',
    icon: [
        640,
        512,
        [
            63717,
            "television",
            "tv-alt"
        ],
        "f26c",
        "M64 64l0 288 512 0 0-288L64 64zM0 64C0 28.7 28.7 0 64 0L576 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64L64 416c-35.3 0-64-28.7-64-64L0 64zM128 448l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-384 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
const $d8206b3ab2e65c05$export$9803b0176917be28 = $d8206b3ab2e65c05$export$e0cfed4ba2fe562c;
const $d8206b3ab2e65c05$export$6aa64ad5a1974ad7 = $d8206b3ab2e65c05$export$e0cfed4ba2fe562c;
const $d8206b3ab2e65c05$export$ac094c06f566cca3 = {
    prefix: 'fas',
    iconName: 'shrimp',
    icon: [
        512,
        512,
        [
            129424
        ],
        "e448",
        "M64 32C28.7 32 0 60.7 0 96s28.7 64 64 64l1 0c3.7 88.9 77 160 167 160l56 0 0-192-24 0L88.8 128 64 128c-17.7 0-32-14.3-32-32s14.3-32 32-32l400 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L64 32zM224 456c0 13.3 10.7 24 24 24l72 0 0-72.2-64.1-22.4c-12.5-4.4-26.2 2.2-30.6 14.7s2.2 26.2 14.7 30.6l4.5 1.6C233 433.9 224 443.9 224 456zm128 23.3c36.4-3.3 69.5-17.6 96.1-39.6l-86.5-34.6c-3 1.8-6.2 3.2-9.6 4.3l0 69.9zM472.6 415c24.6-30.3 39.4-68.9 39.4-111c0-12.3-1.3-24.3-3.7-35.9L382.8 355.1c.8 3.4 1.2 7 1.2 10.6c0 4.6-.7 9-1.9 13.1L472.6 415zM336 128l-16 0 0 192 18.3 0c9.9 0 19.1 3.2 26.6 8.5l133.5-92.4C471.8 172.6 409.1 128 336 128zM168 192a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
const $d8206b3ab2e65c05$export$350a84fd0f833f4d = {
    prefix: 'fas',
    iconName: 'list-check',
    icon: [
        512,
        512,
        [
            "tasks"
        ],
        "f0ae",
        "M152.1 38.2c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 113C-2.3 103.6-2.3 88.4 7 79s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zm0 160c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 273c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zM224 96c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32zM160 416c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32zM48 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
const $d8206b3ab2e65c05$export$2f6d5b2fec286d63 = $d8206b3ab2e65c05$export$350a84fd0f833f4d;
const $d8206b3ab2e65c05$export$3fe50bd8062cd141 = {
    prefix: 'fas',
    iconName: 'jug-detergent',
    icon: [
        384,
        512,
        [],
        "e519",
        "M96 24c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24l0 24 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L88 96C74.7 96 64 85.3 64 72s10.7-24 24-24l8 0 0-24zM0 256c0-70.7 57.3-128 128-128l128 0c70.7 0 128 57.3 128 128l0 192c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 256zm256 0l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
    ]
};
const $d8206b3ab2e65c05$export$9a5c11a5e3d7f1e7 = {
    prefix: 'fas',
    iconName: 'circle-user',
    icon: [
        512,
        512,
        [
            62142,
            "user-circle"
        ],
        "f2bd",
        "M399 384.2C376.9 345.8 335.4 320 288 320l-64 0c-47.4 0-88.9 25.8-111 64.2c35.2 39.2 86.2 63.8 143 63.8s107.8-24.7 143-63.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 16a72 72 0 1 0 0-144 72 72 0 1 0 0 144z"
    ]
};
const $d8206b3ab2e65c05$export$be7d974e9e0dba1a = $d8206b3ab2e65c05$export$9a5c11a5e3d7f1e7;
const $d8206b3ab2e65c05$export$d1886bc596424e6c = {
    prefix: 'fas',
    iconName: 'user-shield',
    icon: [
        640,
        512,
        [],
        "f505",
        "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c1.8 0 3.5-.2 5.3-.5c-76.3-55.1-99.8-141-103.1-200.2c-16.1-4.8-33.1-7.3-50.7-7.3l-91.4 0zm308.8-78.3l-120 48C358 277.4 352 286.2 352 296c0 63.3 25.9 168.8 134.8 214.2c5.9 2.5 12.6 2.5 18.5 0C614.1 464.8 640 359.3 640 296c0-9.8-6-18.6-15.1-22.3l-120-48c-5.7-2.3-12.1-2.3-17.8 0zM591.4 312c-3.9 50.7-27.2 116.7-95.4 149.7l0-187.8L591.4 312z"
    ]
};
const $d8206b3ab2e65c05$export$cc58cb0f2257a6a9 = {
    prefix: 'fas',
    iconName: 'wind',
    icon: [
        512,
        512,
        [],
        "f72e",
        "M288 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128c-17.7 0-32 14.3-32 32s14.3 32 32 32l320 0c53 0 96-43 96-96s-43-96-96-96L320 0c-17.7 0-32 14.3-32 32zm64 352c0 17.7 14.3 32 32 32l32 0c53 0 96-43 96-96s-43-96-96-96L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c-17.7 0-32 14.3-32 32zM128 512l32 0c53 0 96-43 96-96s-43-96-96-96L32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32z"
    ]
};
const $d8206b3ab2e65c05$export$6d2be7c5d395dd16 = {
    prefix: 'fas',
    iconName: 'car-burst',
    icon: [
        640,
        512,
        [
            "car-crash"
        ],
        "f5e1",
        "M176 8c-6.6 0-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6l35.3-32.5 9.5-35.4 10.4-38.6c8-29.9 30.5-52.1 57.9-60.9l41-59.2c11.3-16.3 26.4-28.9 43.5-37.2c-.4-.6-.8-1.2-1.3-1.8c-4.1-5.1-10.9-7.2-17.2-5.3L220.3 92.1l-29.4-74C188.4 12 182.6 8 176 8zM367.7 161.5l135.6 36.3c6.5 1.8 11.3 7.4 11.8 14.2l4.6 56.5-201.5-54 32.2-46.6c3.8-5.6 10.8-8.1 17.3-6.4zm-69.9-30l-47.9 69.3c-21.6 3-40.3 18.6-46.3 41l-10.4 38.6-16.6 61.8-8.3 30.9c-4.6 17.1 5.6 34.6 22.6 39.2l15.5 4.1c17.1 4.6 34.6-5.6 39.2-22.6l8.3-30.9 247.3 66.3-8.3 30.9c-4.6 17.1 5.6 34.6 22.6 39.2l15.5 4.1c17.1 4.6 34.6-5.6 39.2-22.6l8.3-30.9L595 388l10.4-38.6c6-22.4-2.5-45.2-19.6-58.7l-6.8-84c-2.7-33.7-26.4-62-59-70.8L384.2 99.7c-32.7-8.8-67.3 4-86.5 31.8zm-17 131a24 24 0 1 1 -12.4 46.4 24 24 0 1 1 12.4-46.4zm217.9 83.2A24 24 0 1 1 545 358.1a24 24 0 1 1 -46.4-12.4z"
    ]
};
const $d8206b3ab2e65c05$export$8ff55566398404cd = $d8206b3ab2e65c05$export$6d2be7c5d395dd16;
const $d8206b3ab2e65c05$export$b8c4c058fe7d193c = {
    prefix: 'fas',
    iconName: 'y',
    icon: [
        384,
        512,
        [
            121
        ],
        "59",
        "M58 45.4C47.8 31 27.8 27.7 13.4 38S-4.3 68.2 6 82.6L160 298.3 160 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-149.7L378 82.6c10.3-14.4 6.9-34.4-7.4-44.6S336.2 31 326 45.4L192 232.9 58 45.4z"
    ]
};
const $d8206b3ab2e65c05$export$22c642403aeeaeaf = {
    prefix: 'fas',
    iconName: 'person-snowboarding',
    icon: [
        512,
        512,
        [
            127938,
            "snowboarding"
        ],
        "f7ce",
        "M209.7 3.4c15.8-7.9 35-1.5 42.9 14.3l25 50 42.4 8.5c19.5 3.9 37.8 12.3 53.5 24.5l126.1 98.1c14 10.9 16.5 31 5.6 44.9s-31 16.5-44.9 5.6l-72.1-56.1-71.5 31.8 33.1 27.6c23.2 19.3 33.5 50 26.7 79.4l-17.4 75.2c-2.2 9.4-8.2 16.8-16.1 21l86.5 33.1c4.6 1.8 9.4 2.6 14.3 2.6l28.2 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-28.2 0c-10.8 0-21.4-2-31.5-5.8L60.1 371.3c-11.5-4.4-22-11.2-30.8-20L7 329c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.4 22.4c4 4 8.7 7.1 14 9.1l22.4 8.6c-.8-1.6-1.5-3.2-2.1-4.9c-5.6-16.8 3.5-34.9 20.2-40.5L192 264.9l0-53.2c0-24.2 13.7-46.4 35.4-57.2l45.2-22.6-7.5-1.5c-19.4-3.9-35.9-16.5-44.7-34.1l-25-50c-7.9-15.8-1.5-35 14.3-42.9zM139 350.1l159 60.9c-2.1-5.6-2.6-11.9-1.1-18.2l17.4-75.2c1.4-5.9-.7-12-5.3-15.9l-52.8-44 0 18.8c0 20.7-13.2 39-32.8 45.5L139 350.1zM432 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
const $d8206b3ab2e65c05$export$72683772d587302a = $d8206b3ab2e65c05$export$22c642403aeeaeaf;
const $d8206b3ab2e65c05$export$27de16299ddd171 = {
    prefix: 'fas',
    iconName: 'truck-fast',
    icon: [
        640,
        512,
        [
            "shipping-fast"
        ],
        "f48b",
        "M112 0C85.5 0 64 21.5 64 48l0 48L16 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 208 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L64 160l-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 176 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L64 224l-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 144 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L64 288l0 128c0 53 43 96 96 96s96-43 96-96l128 0c0 53 43 96 96 96s96-43 96-96l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-64 0-32 0-18.7c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7L416 96l0-48c0-26.5-21.5-48-48-48L112 0zM544 237.3l0 18.7-128 0 0-96 50.7 0L544 237.3zM160 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm272 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"
    ]
};
const $d8206b3ab2e65c05$export$5e419f47aaeb3c05 = $d8206b3ab2e65c05$export$27de16299ddd171;
const $d8206b3ab2e65c05$export$24228a855c5f6812 = {
    prefix: 'fas',
    iconName: 'fish',
    icon: [
        576,
        512,
        [
            128031
        ],
        "f578",
        "M180.5 141.5C219.7 108.5 272.6 80 336 80s116.3 28.5 155.5 61.5c39.1 33 66.9 72.4 81 99.8c4.7 9.2 4.7 20.1 0 29.3c-14.1 27.4-41.9 66.8-81 99.8C452.3 403.5 399.4 432 336 432s-116.3-28.5-155.5-61.5c-16.2-13.7-30.5-28.5-42.7-43.1L48.1 379.6c-12.5 7.3-28.4 5.3-38.7-4.9S-3 348.7 4.2 336.1L50 256 4.2 175.9c-7.2-12.6-5-28.4 5.3-38.6s26.1-12.2 38.7-4.9l89.7 52.3c12.2-14.6 26.5-29.4 42.7-43.1zM448 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
const $d8206b3ab2e65c05$export$10f5839059d22f7e = {
    prefix: 'fas',
    iconName: 'user-graduate',
    icon: [
        448,
        512,
        [],
        "f501",
        "M219.3 .5c3.1-.6 6.3-.6 9.4 0l200 40C439.9 42.7 448 52.6 448 64s-8.1 21.3-19.3 23.5L352 102.9l0 57.1c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-57.1L48 93.3l0 65.1 15.7 78.4c.9 4.7-.3 9.6-3.3 13.3s-7.6 5.9-12.4 5.9l-32 0c-4.8 0-9.3-2.1-12.4-5.9s-4.3-8.6-3.3-13.3L16 158.4l0-71.8C6.5 83.3 0 74.3 0 64C0 52.6 8.1 42.7 19.3 40.5l200-40zM111.9 327.7c10.5-3.4 21.8 .4 29.4 8.5l71 75.5c6.3 6.7 17 6.7 23.3 0l71-75.5c7.6-8.1 18.9-11.9 29.4-8.5C401 348.6 448 409.4 448 481.3c0 17-13.8 30.7-30.7 30.7L30.7 512C13.8 512 0 498.2 0 481.3c0-71.9 47-132.7 111.9-153.6z"
    ]
};
const $d8206b3ab2e65c05$export$625fb3848216f28c = {
    prefix: 'fas',
    iconName: 'circle-half-stroke',
    icon: [
        512,
        512,
        [
            9680,
            "adjust"
        ],
        "f042",
        "M448 256c0-106-86-192-192-192l0 384c106 0 192-86 192-192zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
    ]
};
const $d8206b3ab2e65c05$export$cfa06e4b68edca2d = $d8206b3ab2e65c05$export$625fb3848216f28c;
const $d8206b3ab2e65c05$export$add3b381ced12554 = {
    prefix: 'fas',
    iconName: 'clapperboard',
    icon: [
        512,
        512,
        [],
        "e131",
        "M448 32l-86.1 0-1 1-127 127 92.1 0 1-1L453.8 32.3c-1.9-.2-3.8-.3-5.8-.3zm64 128l0-64c0-15.1-5.3-29.1-14-40l-104 104L512 160zM294.1 32l-92.1 0-1 1L73.9 160l92.1 0 1-1 127-127zM64 32C28.7 32 0 60.7 0 96l0 64 6.1 0 1-1 127-127L64 32zM512 192L0 192 0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-224z"
    ]
};
const $d8206b3ab2e65c05$export$55c8e3afd9f6c0b4 = {
    prefix: 'fas',
    iconName: 'circle-radiation',
    icon: [
        512,
        512,
        [
            9762,
            "radiation-alt"
        ],
        "f7ba",
        "M256 64a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 448A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM200 256c0-20.7 11.3-38.8 28-48.5l-36-62.3c-8.8-15.3-28.7-20.8-42-9c-25.6 22.6-43.9 53.3-50.9 88.1C95.7 241.5 110.3 256 128 256l72 0zm28 48.5l-36 62.4c-8.8 15.3-3.6 35.2 13.1 40.8c16 5.4 33.1 8.3 50.9 8.3s34.9-2.9 50.9-8.3c16.7-5.6 21.9-25.5 13.1-40.8l-36-62.4c-8.2 4.8-17.8 7.5-28 7.5s-19.8-2.7-28-7.5zM312 256l72 0c17.7 0 32.3-14.5 28.8-31.8c-7-34.8-25.3-65.5-50.9-88.1c-13.2-11.7-33.1-6.3-42 9l-36 62.3c16.7 9.7 28 27.8 28 48.5zm-56 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
const $d8206b3ab2e65c05$export$2f048fa82bbddf6f = $d8206b3ab2e65c05$export$55c8e3afd9f6c0b4;
const $d8206b3ab2e65c05$export$dc3654cf8a596fbf = {
    prefix: 'fas',
    iconName: 'baseball',
    icon: [
        512,
        512,
        [
            129358,
            9918,
            "baseball-ball"
        ],
        "f433",
        "M62.7 223.4c-4.8 .4-9.7 .6-14.7 .6c-15.6 0-30.8-2-45.2-5.9C19.2 107.1 107.1 19.2 218.1 2.8C222 17.2 224 32.4 224 48c0 4.9-.2 9.8-.6 14.7c-.7 8.8 5.8 16.5 14.6 17.3s16.5-5.8 17.3-14.6c.5-5.7 .7-11.5 .7-17.3c0-16.5-1.9-32.6-5.6-47.9c1.8 0 3.7-.1 5.6-.1C397.4 0 512 114.6 512 256c0 1.9 0 3.7-.1 5.6c-15.4-3.6-31.4-5.6-47.9-5.6c-5.8 0-11.6 .2-17.3 .7c-8.8 .7-15.4 8.5-14.6 17.3s8.5 15.4 17.3 14.6c4.8-.4 9.7-.6 14.7-.6c15.6 0 30.8 2 45.2 5.9C492.8 404.9 404.9 492.8 293.9 509.2C290 494.8 288 479.6 288 464c0-4.9 .2-9.8 .6-14.7c.7-8.8-5.8-16.5-14.6-17.3s-16.5 5.8-17.3 14.6c-.5 5.7-.7 11.5-.7 17.3c0 16.5 1.9 32.6 5.6 47.9c-1.8 0-3.7 .1-5.6 .1C114.6 512 0 397.4 0 256c0-1.9 0-3.7 .1-5.6C15.4 254.1 31.5 256 48 256c5.8 0 11.6-.2 17.3-.7c8.8-.7 15.4-8.5 14.6-17.3s-8.5-15.4-17.3-14.6zM121.3 208c-8 3.7-11.6 13.2-7.9 21.2s13.2 11.6 21.2 7.9c45.2-20.8 81.7-57.2 102.5-102.5c3.7-8 .2-17.5-7.9-21.2s-17.5-.2-21.2 7.9c-17.6 38.3-48.5 69.2-86.7 86.7zm277.2 74.7c-3.7-8-13.2-11.6-21.2-7.9c-45.2 20.8-81.7 57.2-102.5 102.5c-3.7 8-.2 17.5 7.9 21.2s17.5 .2 21.2-7.9c17.6-38.3 48.5-69.2 86.7-86.7c8-3.7 11.6-13.2 7.9-21.2z"
    ]
};
const $d8206b3ab2e65c05$export$63a3f8ceae07c7f3 = $d8206b3ab2e65c05$export$dc3654cf8a596fbf;
const $d8206b3ab2e65c05$export$b024a52a4ccf5e69 = {
    prefix: 'fas',
    iconName: 'jet-fighter-up',
    icon: [
        512,
        512,
        [],
        "e518",
        "M270.7 9.7C268.2 3.8 262.4 0 256 0s-12.2 3.8-14.7 9.7L197.2 112.6c-3.4 8-5.2 16.5-5.2 25.2l0 77-144 84L48 280c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 56 0 32 0 24c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8 144 0 0 32.7L133.5 468c-3.5 3-5.5 7.4-5.5 12l0 16c0 8.8 7.2 16 16 16l96 0 0-64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64 96 0c8.8 0 16-7.2 16-16l0-16c0-4.6-2-9-5.5-12L320 416.7l0-32.7 144 0 0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-24 0-32 0-56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 18.8-144-84 0-77c0-8.7-1.8-17.2-5.2-25.2L270.7 9.7z"
    ]
};
const $d8206b3ab2e65c05$export$59c351869dc27435 = {
    prefix: 'fas',
    iconName: 'diagram-project',
    icon: [
        576,
        512,
        [
            "project-diagram"
        ],
        "f542",
        "M0 80C0 53.5 21.5 32 48 32l96 0c26.5 0 48 21.5 48 48l0 16 192 0 0-16c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-16-192 0 0 16c0 1.7-.1 3.4-.3 5L272 288l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96c0-1.7 .1-3.4 .3-5L144 224l-96 0c-26.5 0-48-21.5-48-48L0 80z"
    ]
};
const $d8206b3ab2e65c05$export$30bf9f5b96509df1 = $d8206b3ab2e65c05$export$59c351869dc27435;
const $d8206b3ab2e65c05$export$e9bd786d30cb716c = {
    prefix: 'fas',
    iconName: 'copy',
    icon: [
        448,
        512,
        [],
        "f0c5",
        "M208 0L332.1 0c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9L448 336c0 26.5-21.5 48-48 48l-192 0c-26.5 0-48-21.5-48-48l0-288c0-26.5 21.5-48 48-48zM48 128l80 0 0 64-64 0 0 256 192 0 0-32 64 0 0 48c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 176c0-26.5 21.5-48 48-48z"
    ]
};
const $d8206b3ab2e65c05$export$28cc565c11db6f2e = {
    prefix: 'fas',
    iconName: 'volume-xmark',
    icon: [
        576,
        512,
        [
            "volume-mute",
            "volume-times"
        ],
        "f6a9",
        "M301.1 34.8C312.6 40 320 51.4 320 64l0 384c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352 64 352c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l67.8 0L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zM425 167l55 55 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55 55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55-55 55c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l55-55-55-55c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
    ]
};
const $d8206b3ab2e65c05$export$aa8decd057dfd29b = $d8206b3ab2e65c05$export$28cc565c11db6f2e;
const $d8206b3ab2e65c05$export$a1c7b36ba71dbeca = $d8206b3ab2e65c05$export$28cc565c11db6f2e;
const $d8206b3ab2e65c05$export$72e2d874a963de0c = {
    prefix: 'fas',
    iconName: 'hand-sparkles',
    icon: [
        640,
        512,
        [],
        "e05d",
        "M320 0c17.7 0 32 14.3 32 32l0 208c0 8.8 7.2 16 16 16s16-7.2 16-16l0-176c0-17.7 14.3-32 32-32s32 14.3 32 32l0 176c0 8.8 7.2 16 16 16s16-7.2 16-16l0-112c0-17.7 14.3-32 32-32s32 14.3 32 32l0 195.1c-11.9 4.8-21.3 14.9-25 27.8l-8.9 31.2L478.9 391C460.6 396.3 448 413 448 432c0 18.9 12.5 35.6 30.6 40.9C448.4 497.4 409.9 512 368 512l-19.2 0c-59.6 0-116.9-22.9-160-64L76.4 341c-16-15.2-16.6-40.6-1.4-56.6s40.6-16.6 56.6-1.4l60.5 57.6c0-1.5-.1-3.1-.1-4.6l0-272c0-17.7 14.3-32 32-32s32 14.3 32 32l0 176c0 8.8 7.2 16 16 16s16-7.2 16-16l0-208c0-17.7 14.3-32 32-32zm-7.3 326.6c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L288 352l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L288 384l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L320 384l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L320 352l-7.3-25.4zM104 120l48.3 13.8c4.6 1.3 7.7 5.5 7.7 10.2s-3.1 8.9-7.7 10.2L104 168 90.2 216.3c-1.3 4.6-5.5 7.7-10.2 7.7s-8.9-3.1-10.2-7.7L56 168 7.7 154.2C3.1 152.9 0 148.7 0 144s3.1-8.9 7.7-10.2L56 120 69.8 71.7C71.1 67.1 75.3 64 80 64s8.9 3.1 10.2 7.7L104 120zM584 408l48.3 13.8c4.6 1.3 7.7 5.5 7.7 10.2s-3.1 8.9-7.7 10.2L584 456l-13.8 48.3c-1.3 4.6-5.5 7.7-10.2 7.7s-8.9-3.1-10.2-7.7L536 456l-48.3-13.8c-4.6-1.3-7.7-5.5-7.7-10.2s3.1-8.9 7.7-10.2L536 408l13.8-48.3c1.3-4.6 5.5-7.7 10.2-7.7s8.9 3.1 10.2 7.7L584 408z"
    ]
};
const $d8206b3ab2e65c05$export$eb83fb404127db75 = {
    prefix: 'fas',
    iconName: 'grip',
    icon: [
        448,
        512,
        [
            "grip-horizontal"
        ],
        "f58d",
        "M128 136c0-22.1-17.9-40-40-40L40 96C17.9 96 0 113.9 0 136l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48zm0 192c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48zm32-192l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zM288 328c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48zm32-192l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zM448 328c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48z"
    ]
};
const $d8206b3ab2e65c05$export$4a45308d6c8decc1 = $d8206b3ab2e65c05$export$eb83fb404127db75;
const $d8206b3ab2e65c05$export$928280bdd54fa173 = {
    prefix: 'fas',
    iconName: 'share-from-square',
    icon: [
        576,
        512,
        [
            61509,
            "share-square"
        ],
        "f14d",
        "M352 224l-46.5 0c-45 0-81.5 36.5-81.5 81.5c0 22.3 10.3 34.3 19.2 40.5c6.8 4.7 12.8 12 12.8 20.3c0 9.8-8 17.8-17.8 17.8l-2.5 0c-2.4 0-4.8-.4-7.1-1.4C210.8 374.8 128 333.4 128 240c0-79.5 64.5-144 144-144l80 0 0-61.3C352 15.5 367.5 0 386.7 0c8.6 0 16.8 3.2 23.2 8.9L548.1 133.3c7.6 6.8 11.9 16.5 11.9 26.7s-4.3 19.9-11.9 26.7l-139 125.1c-5.9 5.3-13.5 8.2-21.4 8.2l-3.7 0c-17.7 0-32-14.3-32-32l0-64zM80 96c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-48c0-17.7 14.3-32 32-32s32 14.3 32 32l0 48c0 44.2-35.8 80-80 80L80 512c-44.2 0-80-35.8-80-80L0 112C0 67.8 35.8 32 80 32l48 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L80 96z"
    ]
};
const $d8206b3ab2e65c05$export$ae9e1434571f373c = $d8206b3ab2e65c05$export$928280bdd54fa173;
const $d8206b3ab2e65c05$export$f7367a7301f2dc0f = {
    prefix: 'fas',
    iconName: 'child-combatant',
    icon: [
        576,
        512,
        [
            "child-rifle"
        ],
        "e4e0",
        "M176 128A64 64 0 1 0 176 0a64 64 0 1 0 0 128zm-8 352l0-128 16 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-179.5L260.9 321c9.4 15 29.2 19.4 44.1 10s19.4-29.2 10-44.1l-51.7-82.1c-17.6-27.9-48.3-44.9-81.2-44.9l-12.3 0c-33 0-63.7 16.9-81.2 44.9L36.9 287c-9.4 15-4.9 34.7 10 44.1s34.7 4.9 44.1-10L104 300.5 104 480c0 17.7 14.3 32 32 32s32-14.3 32-32zM448 0L432 0 416 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l0 100.3c-9.6 5.5-16 15.9-16 27.7l0 32c-17.7 0-32 14.3-32 32l0 144c0 17.7 14.3 32 32 32l16 0 0 96c0 8.8 7.2 16 16 16l59.5 0c10.4 0 18-9.8 15.5-19.9L484 400l44 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-48 0 0-26.7 53.1-17.7c6.5-2.2 10.9-8.3 10.9-15.2l0-84.5c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16l0 56-16 5.3L480 160c0-11.8-6.4-22.2-16-27.7L464 16c0-8.8-7.2-16-16-16z"
    ]
};
const $d8206b3ab2e65c05$export$9b027cdb5db3ae5c = $d8206b3ab2e65c05$export$f7367a7301f2dc0f;
const $d8206b3ab2e65c05$export$e18f576a7b31ba46 = {
    prefix: 'fas',
    iconName: 'gun',
    icon: [
        576,
        512,
        [],
        "e19b",
        "M528 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8L32 64C14.3 64 0 78.3 0 96L0 208c0 17.7 14.3 32 32 32l10 0c20.8 0 36.1 19.6 31 39.8L33 440.2c-2.4 9.6-.2 19.7 5.8 27.5S54.1 480 64 480l96 0c14.7 0 27.5-10 31-24.2L217 352l104.5 0c23.7 0 44.8-14.9 52.7-37.2L400.9 240l31.1 0c8.5 0 16.6-3.4 22.6-9.4L477.3 208l66.7 0c17.7 0 32-14.3 32-32l0-80c0-17.7-14.3-32-32-32l-16 0 0-8zM321.4 304L229 304l16-64 105 0-21 58.7c-1.1 3.2-4.2 5.3-7.5 5.3zM80 128l384 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 160c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
const $d8206b3ab2e65c05$export$318ed022991eef56 = {
    prefix: 'fas',
    iconName: 'square-phone',
    icon: [
        448,
        512,
        [
            "phone-square"
        ],
        "f098",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm90.7 96.7c9.7-2.6 19.9 2.3 23.7 11.6l20 48c3.4 8.2 1 17.6-5.8 23.2L168 231.7c16.6 35.2 45.1 63.7 80.3 80.3l20.2-24.7c5.6-6.8 15-9.2 23.2-5.8l48 20c9.3 3.9 14.2 14 11.6 23.7l-12 44C336.9 378 329 384 320 384C196.3 384 96 283.7 96 160c0-9 6-16.9 14.7-19.3l44-12z"
    ]
};
const $d8206b3ab2e65c05$export$8ba22605a641ebdf = $d8206b3ab2e65c05$export$318ed022991eef56;
const $d8206b3ab2e65c05$export$a105e7b44ca0eb9e = {
    prefix: 'fas',
    iconName: 'plus',
    icon: [
        448,
        512,
        [
            10133,
            61543,
            "add"
        ],
        "2b",
        "M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z"
    ]
};
const $d8206b3ab2e65c05$export$9e8f9a9d4ad32c0f = $d8206b3ab2e65c05$export$a105e7b44ca0eb9e;
const $d8206b3ab2e65c05$export$1fe4a9976a241685 = {
    prefix: 'fas',
    iconName: 'expand',
    icon: [
        448,
        512,
        [],
        "f065",
        "M32 32C14.3 32 0 46.3 0 64l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32zM64 352c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-64zM320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0 0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l-96 0zM448 352c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32l0-96z"
    ]
};
const $d8206b3ab2e65c05$export$9835883ce9d0fe78 = {
    prefix: 'fas',
    iconName: 'computer',
    icon: [
        640,
        512,
        [],
        "e4e5",
        "M384 96l0 224L64 320 64 96l320 0zM64 32C28.7 32 0 60.7 0 96L0 320c0 35.3 28.7 64 64 64l117.3 0-10.7 32L96 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-74.7 0-10.7-32L384 384c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L64 32zm464 0c-26.5 0-48 21.5-48 48l0 352c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-352c0-26.5-21.5-48-48-48l-64 0zm16 64l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-16 80c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $d8206b3ab2e65c05$export$e6e44779b2fa1a5c = {
    prefix: 'fas',
    iconName: 'xmark',
    icon: [
        384,
        512,
        [
            128473,
            10005,
            10006,
            10060,
            215,
            "close",
            "multiply",
            "remove",
            "times"
        ],
        "f00d",
        "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
    ]
};
const $d8206b3ab2e65c05$export$23c717133fd81476 = $d8206b3ab2e65c05$export$e6e44779b2fa1a5c;
const $d8206b3ab2e65c05$export$4ed4ff13d4dbc862 = $d8206b3ab2e65c05$export$e6e44779b2fa1a5c;
const $d8206b3ab2e65c05$export$34810740c1bd6c54 = $d8206b3ab2e65c05$export$e6e44779b2fa1a5c;
const $d8206b3ab2e65c05$export$174bd7f477b115b4 = $d8206b3ab2e65c05$export$e6e44779b2fa1a5c;
const $d8206b3ab2e65c05$export$ff9a43e3a9cb653c = {
    prefix: 'fas',
    iconName: 'arrows-up-down-left-right',
    icon: [
        512,
        512,
        [
            "arrows"
        ],
        "f047",
        "M278.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l9.4-9.4L224 224l-114.7 0 9.4-9.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4L224 288l0 114.7-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-9.4 9.4L288 288l114.7 0-9.4 9.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l9.4 9.4L288 224l0-114.7 9.4 9.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64z"
    ]
};
const $d8206b3ab2e65c05$export$d5ae09a305d70340 = $d8206b3ab2e65c05$export$ff9a43e3a9cb653c;
const $d8206b3ab2e65c05$export$fd7622d4b8d3674b = {
    prefix: 'fas',
    iconName: 'chalkboard-user',
    icon: [
        640,
        512,
        [
            "chalkboard-teacher"
        ],
        "f51c",
        "M160 64c0-35.3 28.7-64 64-64L576 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-239.2 0c-11.8-25.5-29.9-47.5-52.4-64l99.6 0 0-32c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 32 64 0 0-288L224 64l0 49.1C205.2 102.2 183.3 96 160 96l0-32zm0 64a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM133.3 352l53.3 0C260.3 352 320 411.7 320 485.3c0 14.7-11.9 26.7-26.7 26.7L26.7 512C11.9 512 0 500.1 0 485.3C0 411.7 59.7 352 133.3 352z"
    ]
};
const $d8206b3ab2e65c05$export$443fcf69b0155291 = $d8206b3ab2e65c05$export$fd7622d4b8d3674b;
const $d8206b3ab2e65c05$export$c8f99b9b5ea83555 = {
    prefix: 'fas',
    iconName: 'peso-sign',
    icon: [
        384,
        512,
        [],
        "e222",
        "M64 32C46.3 32 32 46.3 32 64l0 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 32c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 64 0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64 80 0c68.4 0 127.7-39 156.8-96l19.2 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-.7 0c.5-5.3 .7-10.6 .7-16s-.2-10.7-.7-16l.7 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-19.2 0C303.7 71 244.4 32 176 32L64 32zm190.4 96L96 128l0-32 80 0c30.5 0 58.2 12.2 78.4 32zM96 192l190.9 0c.7 5.2 1.1 10.6 1.1 16s-.4 10.8-1.1 16L96 224l0-32zm158.4 96c-20.2 19.8-47.9 32-78.4 32l-80 0 0-32 158.4 0z"
    ]
};
const $d8206b3ab2e65c05$export$18ba6a500873dba9 = {
    prefix: 'fas',
    iconName: 'building-shield',
    icon: [
        576,
        512,
        [],
        "e4d8",
        "M0 48C0 21.5 21.5 0 48 0L336 0c26.5 0 48 21.5 48 48l0 159-42.4 17L304 224l-32 0c-8.8 0-16 7.2-16 16l0 32 0 24.2 0 7.8c0 .9 .1 1.7 .2 2.6c2.3 58.1 24.1 144.8 98.7 201.5c-5.8 2.5-12.2 3.9-18.9 3.9l-96 0 0-80c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 80-96 0c-26.5 0-48-21.5-48-48L0 48zM80 224c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm80 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM64 112l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16L80 96c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm80 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM423.1 225.7c5.7-2.3 12.1-2.3 17.8 0l120 48C570 277.4 576 286.2 576 296c0 63.3-25.9 168.8-134.8 214.2c-5.9 2.5-12.6 2.5-18.5 0C313.9 464.8 288 359.3 288 296c0-9.8 6-18.6 15.1-22.3l120-48zM527.4 312L432 273.8l0 187.8c68.2-33 91.5-99 95.4-149.7z"
    ]
};
const $d8206b3ab2e65c05$export$8afab767536f59ad = {
    prefix: 'fas',
    iconName: 'baby',
    icon: [
        448,
        512,
        [],
        "f77c",
        "M152 88a72 72 0 1 1 144 0A72 72 0 1 1 152 88zM39.7 144.5c13-17.9 38-21.8 55.9-8.8L131.8 162c26.8 19.5 59.1 30 92.2 30s65.4-10.5 92.2-30l36.2-26.4c17.9-13 42.9-9 55.9 8.8s9 42.9-8.8 55.9l-36.2 26.4c-13.6 9.9-28.1 18.2-43.3 25l0 36.3-192 0 0-36.3c-15.2-6.7-29.7-15.1-43.3-25L48.5 200.3c-17.9-13-21.8-38-8.8-55.9zm89.8 184.8l60.6 53-26 37.2 24.3 24.3c15.6 15.6 15.6 40.9 0 56.6s-40.9 15.6-56.6 0l-48-48C70 438.6 68.1 417 79.2 401.1l50.2-71.8zm128.5 53l60.6-53 50.2 71.8c11.1 15.9 9.2 37.5-4.5 51.2l-48 48c-15.6 15.6-40.9 15.6-56.6 0s-15.6-40.9 0-56.6L284 419.4l-26-37.2z"
    ]
};
const $d8206b3ab2e65c05$export$d7e538fddb81da68 = {
    prefix: 'fas',
    iconName: 'users-line',
    icon: [
        640,
        512,
        [],
        "e592",
        "M211.2 96a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM32 256c0 17.7 14.3 32 32 32l85.6 0c10.1-39.4 38.6-71.5 75.8-86.6c-9.7-6-21.2-9.4-33.4-9.4l-96 0c-35.3 0-64 28.7-64 64zm461.6 32l82.4 0c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64l-96 0c-11.7 0-22.7 3.1-32.1 8.6c38.1 14.8 67.4 47.3 77.7 87.4zM391.2 226.4c-6.9-1.6-14.2-2.4-21.6-2.4l-96 0c-8.5 0-16.7 1.1-24.5 3.1c-30.8 8.1-55.6 31.1-66.1 60.9c-3.5 10-5.5 20.8-5.5 32c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32c0-11.2-1.9-22-5.5-32c-10.8-30.7-36.8-54.2-68.9-61.6zM563.2 96a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM321.6 192a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l576 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 416z"
    ]
};
const $d8206b3ab2e65c05$export$932a67a1b1a7a724 = {
    prefix: 'fas',
    iconName: 'quote-left',
    icon: [
        448,
        512,
        [
            8220,
            "quote-left-alt"
        ],
        "f10d",
        "M0 216C0 149.7 53.7 96 120 96l8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-8 0c-30.9 0-56 25.1-56 56l0 8 64 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64l0-32 0-32 0-72zm256 0c0-66.3 53.7-120 120-120l8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-8 0c-30.9 0-56 25.1-56 56l0 8 64 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64l0-32 0-32 0-72z"
    ]
};
const $d8206b3ab2e65c05$export$95bb9ad3aa35c741 = $d8206b3ab2e65c05$export$932a67a1b1a7a724;
const $d8206b3ab2e65c05$export$e87e41787bbedc98 = {
    prefix: 'fas',
    iconName: 'tractor',
    icon: [
        640,
        512,
        [
            128668
        ],
        "f722",
        "M96 64c0-35.3 28.7-64 64-64L266.3 0c26.2 0 49.7 15.9 59.4 40.2L373.7 160 480 160l0-33.8c0-24.8 5.8-49.3 16.9-71.6l2.5-5c7.9-15.8 27.1-22.2 42.9-14.3s22.2 27.1 14.3 42.9l-2.5 5c-6.7 13.3-10.1 28-10.1 42.9l0 33.8 56 0c22.1 0 40 17.9 40 40l0 45.4c0 16.5-8.5 31.9-22.6 40.7l-43.3 27.1c-14.2-5.9-29.8-9.2-46.1-9.2c-39.3 0-74.1 18.9-96 48l-80 0c0 17.7-14.3 32-32 32l-8.2 0c-1.7 4.8-3.7 9.5-5.8 14.1l5.8 5.8c12.5 12.5 12.5 32.8 0 45.3l-22.6 22.6c-12.5 12.5-32.8 12.5-45.3 0l-5.8-5.8c-4.6 2.2-9.3 4.1-14.1 5.8l0 8.2c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-8.2c-4.8-1.7-9.5-3.7-14.1-5.8l-5.8 5.8c-12.5 12.5-32.8 12.5-45.3 0L40.2 449.1c-12.5-12.5-12.5-32.8 0-45.3l5.8-5.8c-2.2-4.6-4.1-9.3-5.8-14.1L32 384c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32l8.2 0c1.7-4.8 3.7-9.5 5.8-14.1l-5.8-5.8c-12.5-12.5-12.5-32.8 0-45.3l22.6-22.6c9-9 21.9-11.5 33.1-7.6l0-.6 0-32 0-96zm170.3 0L160 64l0 96 32 0 112.7 0L266.3 64zM176 256a80 80 0 1 0 0 160 80 80 0 1 0 0-160zM528 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 64c-48.6 0-88-39.4-88-88c0-29.8 14.8-56.1 37.4-72c14.3-10.1 31.8-16 50.6-16c2.7 0 5.3 .1 7.9 .3c44.9 4 80.1 41.7 80.1 87.7c0 48.6-39.4 88-88 88z"
    ]
};
const $d8206b3ab2e65c05$export$940cea0f5451895c = {
    prefix: 'fas',
    iconName: 'trash-arrow-up',
    icon: [
        448,
        512,
        [
            "trash-restore"
        ],
        "f829",
        "M163.8 0L284.2 0c12.1 0 23.2 6.8 28.6 17.7L320 32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l96 0 7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128l384 0L394.8 467c-1.6 25.3-22.6 45-47.9 45l-245.8 0c-25.3 0-46.3-19.7-47.9-45L32 128zm192 64c-6.4 0-12.5 2.5-17 7l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39L200 408c0 13.3 10.7 24 24 24s24-10.7 24-24l0-134.1 39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-4.5-4.5-10.6-7-17-7z"
    ]
};
const $d8206b3ab2e65c05$export$d32f45a64ed40e8d = $d8206b3ab2e65c05$export$940cea0f5451895c;
const $d8206b3ab2e65c05$export$fc9f7bd981c34c45 = {
    prefix: 'fas',
    iconName: 'arrow-down-up-lock',
    icon: [
        640,
        512,
        [],
        "e4b0",
        "M150.6 502.6l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 402.7 160 288l256 0 0-16c0-17.2 3.9-33.5 10.8-48L352 224l0-114.7 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-6-6-14.1-9.4-22.6-9.4s-16.6 3.4-22.6 9.4l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L288 109.3 288 224l-128 0-64 0-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0 0 114.7L54.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0zM160 192l0-128c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 128 64 0zM288 320l0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128-64 0zm240-80c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
const $d8206b3ab2e65c05$export$4d384ffc907ddaff = {
    prefix: 'fas',
    iconName: 'lines-leaning',
    icon: [
        384,
        512,
        [],
        "e51e",
        "M190.4 74.1c5.6-16.8-3.5-34.9-20.2-40.5s-34.9 3.5-40.5 20.2l-128 384c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l128-384zm70.9-41.7c-17.4-2.9-33.9 8.9-36.8 26.3l-64 384c-2.9 17.4 8.9 33.9 26.3 36.8s33.9-8.9 36.8-26.3l64-384c2.9-17.4-8.9-33.9-26.3-36.8zM352 32c-17.7 0-32 14.3-32 32l0 384c0 17.7 14.3 32 32 32s32-14.3 32-32l0-384c0-17.7-14.3-32-32-32z"
    ]
};
const $d8206b3ab2e65c05$export$613f406c1b5802a8 = {
    prefix: 'fas',
    iconName: 'ruler-combined',
    icon: [
        512,
        512,
        [],
        "f546",
        "M.2 468.9C2.7 493.1 23.1 512 48 512l96 0 320 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-48 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-64-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-64-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-48c0-26.5-21.5-48-48-48L48 0C21.5 0 0 21.5 0 48L0 368l0 96c0 1.7 .1 3.3 .2 4.9z"
    ]
};
const $d8206b3ab2e65c05$export$da61665fff8aebfe = {
    prefix: 'fas',
    iconName: 'copyright',
    icon: [
        512,
        512,
        [
            169
        ],
        "f1f9",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM199.4 312.6c31.2 31.2 81.9 31.2 113.1 0c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-50 50-131 50-181 0s-50-131 0-181s131-50 181 0c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-31.2-31.2-81.9-31.2-113.1 0s-31.2 81.9 0 113.1z"
    ]
};
const $d8206b3ab2e65c05$export$a7c5f5e4805fdab = {
    prefix: 'fas',
    iconName: 'equals',
    icon: [
        448,
        512,
        [
            62764
        ],
        "3d",
        "M48 128c-17.7 0-32 14.3-32 32s14.3 32 32 32l352 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L48 128zm0 192c-17.7 0-32 14.3-32 32s14.3 32 32 32l352 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L48 320z"
    ]
};
const $d8206b3ab2e65c05$export$db34f7a6de38784f = {
    prefix: 'fas',
    iconName: 'blender',
    icon: [
        512,
        512,
        [],
        "f517",
        "M0 64C0 28.7 28.7 0 64 0l64 0 32 0L470.1 0c21.1 0 36.4 20.1 30.9 40.4L494.5 64 336 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l149.8 0-17.5 64L336 160c-8.8 0-16 7.2-16 16s7.2 16 16 16l123.6 0-17.5 64L336 256c-8.8 0-16 7.2-16 16s7.2 16 16 16l97.5 0L416 352l-256 0-8.7-96L64 256c-35.3 0-64-28.7-64-64L0 64zM145.5 192L133.8 64 64 64l0 128 81.5 0zM144 384l288 0c26.5 0 48 21.5 48 48l0 32c0 26.5-21.5 48-48 48l-288 0c-26.5 0-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48zm144 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
const $d8206b3ab2e65c05$export$b4619aeaf0b9d18e = {
    prefix: 'fas',
    iconName: 'teeth',
    icon: [
        576,
        512,
        [],
        "f62e",
        "M0 128C0 75 43 32 96 32l384 0c53 0 96 43 96 96l0 256c0 53-43 96-96 96L96 480c-53 0-96-43-96-96L0 128zm176 48l0 56c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-56c0-26.5-21.5-48-48-48s-48 21.5-48 48zm176-48c-26.5 0-48 21.5-48 48l0 56c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-56c0-26.5-21.5-48-48-48zM48 208l0 24c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-24c0-26.5-21.5-48-48-48s-48 21.5-48 48zM96 384c26.5 0 48-21.5 48-48l0-24c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l0 24c0 26.5 21.5 48 48 48zm80-48c0 26.5 21.5 48 48 48s48-21.5 48-48l0-24c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l0 24zm176 48c26.5 0 48-21.5 48-48l0-24c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l0 24c0 26.5 21.5 48 48 48zm80-176l0 24c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-24c0-26.5-21.5-48-48-48s-48 21.5-48 48zm48 176c26.5 0 48-21.5 48-48l0-24c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l0 24c0 26.5 21.5 48 48 48z"
    ]
};
const $d8206b3ab2e65c05$export$3570be7b68efb8db = {
    prefix: 'fas',
    iconName: 'shekel-sign',
    icon: [
        448,
        512,
        [
            8362,
            "ils",
            "shekel",
            "sheqel",
            "sheqel-sign"
        ],
        "f20b",
        "M32 32C14.3 32 0 46.3 0 64L0 448c0 17.7 14.3 32 32 32s32-14.3 32-32L64 96l128 0c35.3 0 64 28.7 64 64l0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160c0-70.7-57.3-128-128-128L32 32zM320 480c70.7 0 128-57.3 128-128l0-288c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 288c0 35.3-28.7 64-64 64l-128 0 0-224c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l160 0z"
    ]
};
const $d8206b3ab2e65c05$export$ecadeff45b05a451 = $d8206b3ab2e65c05$export$3570be7b68efb8db;
const $d8206b3ab2e65c05$export$27e0e10e74d98736 = $d8206b3ab2e65c05$export$3570be7b68efb8db;
const $d8206b3ab2e65c05$export$28b3b26a80030d4e = $d8206b3ab2e65c05$export$3570be7b68efb8db;
const $d8206b3ab2e65c05$export$d84993fb5e8c6edd = $d8206b3ab2e65c05$export$3570be7b68efb8db;
const $d8206b3ab2e65c05$export$fc82fb79180cd17c = {
    prefix: 'fas',
    iconName: 'map',
    icon: [
        576,
        512,
        [
            128506,
            62072
        ],
        "f279",
        "M384 476.1L192 421.2l0-385.3L384 90.8l0 385.3zm32-1.2l0-386.5L543.1 37.5c15.8-6.3 32.9 5.3 32.9 22.3l0 334.8c0 9.8-6 18.6-15.1 22.3L416 474.8zM15.1 95.1L160 37.2l0 386.5L32.9 474.5C17.1 480.8 0 469.2 0 452.2L0 117.4c0-9.8 6-18.6 15.1-22.3z"
    ]
};
const $d8206b3ab2e65c05$export$b24d84ed5657d89a = {
    prefix: 'fas',
    iconName: 'rocket',
    icon: [
        512,
        512,
        [],
        "f135",
        "M156.6 384.9L125.7 354c-8.5-8.5-11.5-20.8-7.7-32.2c3-8.9 7-20.5 11.8-33.8L24 288c-8.6 0-16.6-4.6-20.9-12.1s-4.2-16.7 .2-24.1l52.5-88.5c13-21.9 36.5-35.3 61.9-35.3l82.3 0c2.4-4 4.8-7.7 7.2-11.3C289.1-4.1 411.1-8.1 483.9 5.3c11.6 2.1 20.6 11.2 22.8 22.8c13.4 72.9 9.3 194.8-111.4 276.7c-3.5 2.4-7.3 4.8-11.3 7.2l0 82.3c0 25.4-13.4 49-35.3 61.9l-88.5 52.5c-7.4 4.4-16.6 4.5-24.1 .2s-12.1-12.2-12.1-20.9l0-107.2c-14.1 4.9-26.4 8.9-35.7 11.9c-11.2 3.6-23.4 .5-31.8-7.8zM384 168a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
    ]
};
const $d8206b3ab2e65c05$export$ed36ad335b36be22 = {
    prefix: 'fas',
    iconName: 'photo-film',
    icon: [
        640,
        512,
        [
            "photo-video"
        ],
        "f87c",
        "M256 0L576 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64l-320 0c-35.3 0-64-28.7-64-64l0-224c0-35.3 28.7-64 64-64zM476 106.7C471.5 100 464 96 456 96s-15.5 4-20 10.7l-56 84L362.7 169c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6l80 0 48 0 144 0c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144zM336 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM64 128l96 0 0 256 0 32c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-32 160 0 0 64c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192c0-35.3 28.7-64 64-64zm8 64c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0zm0 104c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0zm0 104c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0zm336 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16z"
    ]
};
const $d8206b3ab2e65c05$export$739f6a6a12dfb6ed = $d8206b3ab2e65c05$export$ed36ad335b36be22;
const $d8206b3ab2e65c05$export$758f1fb3784e4080 = {
    prefix: 'fas',
    iconName: 'folder-minus',
    icon: [
        512,
        512,
        [],
        "f65d",
        "M448 480L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l128 0c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8l160 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64zM184 272c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z"
    ]
};
const $d8206b3ab2e65c05$export$f0f9d0c0b0d511dd = {
    prefix: 'fas',
    iconName: 'hexagon-nodes-bolt',
    icon: [
        576,
        512,
        [],
        "e69a",
        "M248 106.6c18.9-9 32-28.3 32-50.6c0-30.9-25.1-56-56-56s-56 25.1-56 56c0 22.3 13.1 41.6 32 50.6l0 98.8c-2.8 1.3-5.5 2.9-8 4.7l-80.1-45.8c1.6-20.8-8.6-41.6-27.9-52.8C57.2 96 23 105.2 7.5 132S1.2 193 28 208.5c1.3 .8 2.6 1.5 4 2.1l0 90.8c-1.3 .6-2.7 1.3-4 2.1C1.2 319-8 353.2 7.5 380S57.2 416 84 400.5c19.3-11.1 29.4-32 27.8-52.8l50.5-28.9c-11.5-11.2-19.9-25.6-23.8-41.7L88 306.1c-2.6-1.8-5.2-3.3-8-4.7l0-90.8c2.8-1.3 5.5-2.9 8-4.7l80.1 45.8c-.1 1.4-.2 2.8-.2 4.3c0 22.3 13.1 41.6 32 50.6l0 98.8c-18.9 9-32 28.3-32 50.6c0 30.9 25.1 56 56 56c30.7 0 55.6-24.7 56-55.2c-7.5-12.9-13.5-26.8-17.6-41.5c-4.2-4-9.1-7.3-14.4-9.9l0-98.8c2.8-1.3 5.5-2.9 8-4.7l10.5 6c5.5-15.3 13.1-29.5 22.4-42.5l-9.1-5.2c.1-1.4 .2-2.8 .2-4.3c0-22.3-13.1-41.6-32-50.6l0-98.8zM440.5 132C425 105.2 390.8 96 364 111.5c-19.3 11.1-29.4 32-27.8 52.8l-50.6 28.9c11.5 11.2 19.9 25.6 23.8 41.7L360 205.9c.4 .3 .8 .6 1.3 .9c21.7-9.5 45.6-14.8 70.8-14.8c2 0 4 0 5.9 .1c12.1-17.3 13.8-40.6 2.6-60.1zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm47.9-225c4.3 3.7 5.4 9.9 2.6 14.9L452.4 356l35.6 0c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9L411.6 380 376 380c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1 .6z"
    ]
};
const $d8206b3ab2e65c05$export$de59c2657a8ace67 = {
    prefix: 'fas',
    iconName: 'store',
    icon: [
        576,
        512,
        [],
        "f54e",
        "M547.6 103.8L490.3 13.1C485.2 5 476.1 0 466.4 0L109.6 0C99.9 0 90.8 5 85.7 13.1L28.3 103.8c-29.6 46.8-3.4 111.9 51.9 119.4c4 .5 8.1 .8 12.1 .8c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c26.2 0 49.3-11.4 65.2-29c16 17.6 39.1 29 65.2 29c4.1 0 8.1-.3 12.1-.8c55.5-7.4 81.8-72.5 52.1-119.4zM499.7 254.9c0 0 0 0-.1 0c-5.3 .7-10.7 1.1-16.2 1.1c-12.4 0-24.3-1.9-35.4-5.3L448 384l-320 0 0-133.4c-11.2 3.5-23.2 5.4-35.6 5.4c-5.5 0-11-.4-16.3-1.1l-.1 0c-4.1-.6-8.1-1.3-12-2.3L64 384l0 64c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-64 0-131.4c-4 1-8 1.8-12.3 2.3z"
    ]
};
const $d8206b3ab2e65c05$export$cf36928a9c52e98a = {
    prefix: 'fas',
    iconName: 'arrow-trend-up',
    icon: [
        576,
        512,
        [],
        "e098",
        "M384 160c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0c17.7 0 32 14.3 32 32l0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-82.7L342.6 374.6c-12.5 12.5-32.8 12.5-45.3 0L192 269.3 54.6 406.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160c12.5-12.5 32.8-12.5 45.3 0L320 306.7 466.7 160 384 160z"
    ]
};
const $d8206b3ab2e65c05$export$2a44d62160972254 = {
    prefix: 'fas',
    iconName: 'plug-circle-minus',
    icon: [
        576,
        512,
        [],
        "e55e",
        "M96 0C78.3 0 64 14.3 64 32l0 96 64 0 0-96c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32l0 96 64 0 0-96c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 32c0 77.4 55 142 128 156.8l0 67.2c0 17.7 14.3 32 32 32s32-14.3 32-32l0-67.2c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32L32 160zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-64 0c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l128 0c8.8 0 16 7.2 16 16z"
    ]
};
const $d8206b3ab2e65c05$export$5c1f29f4c7cad367 = {
    prefix: 'fas',
    iconName: 'sign-hanging',
    icon: [
        512,
        512,
        [
            "sign"
        ],
        "f4d9",
        "M96 0c17.7 0 32 14.3 32 32l0 32 352 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-352 0 0 352c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-352-32 0C14.3 128 0 113.7 0 96S14.3 64 32 64l32 0 0-32C64 14.3 78.3 0 96 0zm96 160l256 0c17.7 0 32 14.3 32 32l0 160c0 17.7-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32l0-160c0-17.7 14.3-32 32-32z"
    ]
};
const $d8206b3ab2e65c05$export$d21d0d6c8e9e8bf9 = $d8206b3ab2e65c05$export$5c1f29f4c7cad367;
const $d8206b3ab2e65c05$export$a527a6267c55a54c = {
    prefix: 'fas',
    iconName: 'bezier-curve',
    icon: [
        640,
        512,
        [],
        "f55b",
        "M296 136l0-48 48 0 0 48-48 0zM288 32c-26.5 0-48 21.5-48 48l0 4L121.6 84C111.2 62.7 89.3 48 64 48C28.7 48 0 76.7 0 112s28.7 64 64 64c25.3 0 47.2-14.7 57.6-36l66.9 0c-58.9 39.6-98.9 105-104 180L80 320c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-3.3 0c5.9-67 48.5-123.4 107.5-149.1c8.6 12.7 23.2 21.1 39.8 21.1l64 0c16.6 0 31.1-8.4 39.8-21.1c59 25.7 101.6 82.1 107.5 149.1l-3.3 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-4.5 0c-5-75-45.1-140.4-104-180l66.9 0c10.4 21.3 32.3 36 57.6 36c35.3 0 64-28.7 64-64s-28.7-64-64-64c-25.3 0-47.2 14.7-57.6 36L400 84l0-4c0-26.5-21.5-48-48-48l-64 0zM88 376l48 0 0 48-48 0 0-48zm416 48l0-48 48 0 0 48-48 0z"
    ]
};
const $d8206b3ab2e65c05$export$6b31a1e5968b2378 = {
    prefix: 'fas',
    iconName: 'bell-slash',
    icon: [
        640,
        512,
        [
            128277,
            61943
        ],
        "f1f6",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-90.2-70.7c.2-.4 .4-.9 .6-1.3c5.2-11.5 3.1-25-5.3-34.4l-7.4-8.3C497.3 319.2 480 273.9 480 226.8l0-18.8c0-77.4-55-142-128-156.8L352 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 19.2c-42.6 8.6-79 34.2-102 69.3L38.8 5.1zM406.2 416L160 222.1l0 4.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S115.4 416 128 416l278.2 0zm-40.9 77.3c12-12 18.7-28.3 18.7-45.3l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7z"
    ]
};
const $d8206b3ab2e65c05$export$1c92b67c45a4b4fc = {
    prefix: 'fas',
    iconName: 'tablet',
    icon: [
        448,
        512,
        [
            "tablet-android"
        ],
        "f3fb",
        "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zM176 432l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
const $d8206b3ab2e65c05$export$5eddbb7c71278268 = $d8206b3ab2e65c05$export$1c92b67c45a4b4fc;
const $d8206b3ab2e65c05$export$9b263780a7312c8c = {
    prefix: 'fas',
    iconName: 'school-flag',
    icon: [
        576,
        512,
        [],
        "e56e",
        "M288 0L400 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-79.3 0 89.6 64L512 160c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64l-176 0 0-112c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 112L64 512c-35.3 0-64-28.7-64-64L0 224c0-35.3 28.7-64 64-64l101.7 0L256 95.5 256 32c0-17.7 14.3-32 32-32zm48 240a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM80 224c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-32 0zm368 16l0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM80 352c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-32 0zm384 0c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-32 0z"
    ]
};
const $d8206b3ab2e65c05$export$d3c2bcfd3b861e4a = {
    prefix: 'fas',
    iconName: 'fill',
    icon: [
        512,
        512,
        [],
        "f575",
        "M86.6 9.4C74.1-3.1 53.9-3.1 41.4 9.4s-12.5 32.8 0 45.3L122.7 136 30.6 228.1c-37.5 37.5-37.5 98.3 0 135.8L148.1 481.4c37.5 37.5 98.3 37.5 135.8 0L474.3 290.9c28.1-28.1 28.1-73.7 0-101.8L322.9 37.7c-28.1-28.1-73.7-28.1-101.8 0L168 90.7 86.6 9.4zM168 181.3l49.4 49.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L213.3 136l53.1-53.1c3.1-3.1 8.2-3.1 11.3 0L429.1 234.3c3.1 3.1 3.1 8.2 0 11.3L386.7 288 67.5 288c1.4-5.4 4.2-10.4 8.4-14.6L168 181.3z"
    ]
};
const $d8206b3ab2e65c05$export$887340269e6d6cac = {
    prefix: 'fas',
    iconName: 'angle-up',
    icon: [
        448,
        512,
        [
            8963
        ],
        "f106",
        "M201.4 137.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 205.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z"
    ]
};
const $d8206b3ab2e65c05$export$482976e9a4ab10f3 = {
    prefix: 'fas',
    iconName: 'drumstick-bite',
    icon: [
        512,
        512,
        [],
        "f6d7",
        "M160 265.2c0 8.5-3.4 16.6-9.4 22.6l-26.8 26.8c-12.3 12.3-32.5 11.4-49.4 7.2C69.8 320.6 65 320 60 320c-33.1 0-60 26.9-60 60s26.9 60 60 60c6.3 0 12 5.7 12 12c0 33.1 26.9 60 60 60s60-26.9 60-60c0-5-.6-9.8-1.8-14.5c-4.2-16.9-5.2-37.1 7.2-49.4l26.8-26.8c6-6 14.1-9.4 22.6-9.4l89.2 0c6.3 0 12.4-.3 18.5-1c11.9-1.2 16.4-15.5 10.8-26c-8.5-15.8-13.3-33.8-13.3-53c0-61.9 50.1-112 112-112c8 0 15.7 .8 23.2 2.4c11.7 2.5 24.1-5.9 22-17.6C494.5 62.5 422.5 0 336 0C238.8 0 160 78.8 160 176l0 89.2z"
    ]
};
const $d8206b3ab2e65c05$export$273296afacf93991 = {
    prefix: 'fas',
    iconName: 'holly-berry',
    icon: [
        512,
        512,
        [],
        "f7aa",
        "M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-80 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM276.8 383.8c1 .1 2.1 .2 3.2 .2c39.8 0 72 32.2 72 72l0 22.7c0 16.4 16 27.9 31.6 22.8l12.8-4.3c18-6 37.3-6.5 55.6-1.5l19.4 5.3c17.9 4.9 34.4-11.6 29.5-29.5L495.6 452c-5-18.3-4.4-37.6 1.5-55.6l4.3-12.8c5.2-15.5-6.4-31.6-22.8-31.6c-34.6 0-62.7-28.1-62.7-62.7l0-32c0-16.4-16-27.9-31.6-22.8l-12.8 4.3c-18 6-37.3 6.5-55.6 1.5l-29.6-8.1c-2.9-.8-5.9-1-8.7-.7c4.2 9.7 5.8 20.8 3.7 32.3L275 298.7c-1.5 8.4-1.4 17 .5 25.3l5.3 23.9c2.8 12.7 1.1 25.2-4 35.9zM127.6 234.5c-15.5-5.2-31.6 6.4-31.6 22.8l0 32C96 323.9 67.9 352 33.3 352c-16.4 0-27.9 16-22.8 31.6l4.3 12.8c6 18 6.5 37.3 1.5 55.6l-5.3 19.4C6.2 489.4 22.6 505.8 40.5 501L60 495.6c18.3-5 37.6-4.5 55.6 1.5l12.8 4.3c15.5 5.2 31.6-6.4 31.6-22.8l0-32c0-34.6 28.1-62.7 62.7-62.7c16.4 0 27.9-16 22.8-31.6l-4.3-12.8c-6-18-6.5-37.3-1.5-55.6l5.3-19.4c4.9-17.9-11.6-34.4-29.5-29.5L196 240.4c-18.3 5-37.6 4.4-55.6-1.5l-12.8-4.3zM384 144a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
    ]
};
const $d8206b3ab2e65c05$export$75702e3e3dd44a44 = {
    prefix: 'fas',
    iconName: 'chevron-left',
    icon: [
        320,
        512,
        [
            9001
        ],
        "f053",
        "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"
    ]
};
const $d8206b3ab2e65c05$export$7fc18cf2d526c341 = {
    prefix: 'fas',
    iconName: 'bacteria',
    icon: [
        640,
        512,
        [],
        "e059",
        "M304.9 .7c-9.6-2.7-19.5 2.8-22.3 12.4l-4.3 15.2c-8.3-.6-16.8 0-25.2 1.9c-7.3 1.7-14.3 3.5-21.1 5.5l-5.5-12.7c-3.9-9.1-14.5-13.4-23.6-9.5s-13.4 14.5-9.5 23.6l4.4 10.4c-16.6 6.7-31.7 14.4-45.4 22.8L147 62c-5.5-8.3-16.7-10.5-25-5s-10.5 16.7-5 25l6 9c-13.7 11-25.5 22.8-35.8 34.9l-10-8c-7.8-6.2-19.1-5-25.3 2.8s-5 19.1 2.8 25.3L65.9 155c-1.8 2.8-3.5 5.7-5.1 8.5c-6.6 11.4-11.8 22.6-16 33l-8-3.2c-9.2-3.7-19.7 .8-23.4 10s.8 19.7 10 23.4l10.4 4.2c-.2 .8-.4 1.5-.5 2.3c-2.2 9.3-3.4 17.3-4.1 23.4c-.4 3.1-.6 5.7-.8 7.8c-.1 1.1-.1 2-.2 2.8l-.1 1.1 0 .5 0 .2 0 .1c0 0 0 .1 29.1 1c0 0 0 0-.1 0L28 269.3c-.1 3.1 0 6.1 .2 9.1l-15.2 4.3C3.5 285.4-2 295.4 .7 304.9s12.7 15.1 22.3 12.4l15.6-4.5c7.6 13.6 18.9 25 32.6 32.6L66.7 361c-2.7 9.6 2.8 19.5 12.4 22.3s19.5-2.8 22.3-12.4l4.3-15.2c1.2 .1 2.4 .2 3.6 .2c15.6 .5 30.3-3.3 43-10.2l9 9c7 7 18.4 7 25.5 0s7-18.4 0-25.5l-7.2-7.2c9.3-12.6 15.2-27.8 16.3-44.5l7.1 3c9.1 3.9 19.7-.3 23.6-9.5s-.3-19.7-9.5-23.6l-8.6-3.7c6.4-9.9 17.3-22.4 36.9-33.3l1.3 4.4c2.7 9.6 12.7 15.1 22.3 12.4s15.1-12.7 12.4-22.3l-2.3-8.1c3.8-1.1 7.7-2.1 11.9-3.1c11.6-2.7 22.1-7.7 31.1-14.4l7.2 7.2c7 7 18.4 7 25.5 0s7-18.4 0-25.5l-9-9c7.6-13.9 11.3-30.1 10.1-46.6l15.2-4.3c9.6-2.7 15.1-12.7 12.4-22.3S370.6 64 361 66.7l-15.6 4.5c-7.7-13.9-19.1-25.1-32.6-32.6l4.5-15.6c2.7-9.6-2.8-19.5-12.4-22.3zM112 272l-48-1.5c0 0 0 0 0 0c11.7 .4 27.3 .9 48 1.6zm16-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64-48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM322.7 489c-2.7 9.6 2.8 19.5 12.4 22.3s19.5-2.8 22.2-12.4l4.3-15.2c8.3 .6 16.8 0 25.2-1.9c7.3-1.7 14.3-3.5 21.1-5.5l5.5 12.7c3.9 9.1 14.5 13.4 23.6 9.5s13.4-14.5 9.5-23.6l-4.4-10.4c16.6-6.7 31.7-14.4 45.4-22.8L493 450c5.5 8.3 16.7 10.5 25 5s10.5-16.7 5-25l-6-9c13.7-11 25.5-22.8 35.8-34.9l10 8c7.8 6.2 19.1 5 25.3-2.8s5-19.1-2.8-25.3L574.1 357c1.8-2.8 3.5-5.7 5.1-8.5c6.6-11.4 11.8-22.6 16-33l8 3.2c9.2 3.7 19.7-.8 23.4-10s-.8-19.7-10-23.4l-10.4-4.2c.2-.8 .4-1.5 .5-2.3c2.2-9.3 3.4-17.3 4.1-23.4c.4-3.1 .6-5.7 .8-7.8c.1-1.1 .1-2 .2-2.8l.1-1.1 0-.5 0-.2 0-.1c0 0 0-.1-29.1-1c0 0 0 0 .1 0l29.1 .9c.1-3.1 0-6.1-.2-9.1l15.2-4.3c9.6-2.7 15.1-12.7 12.4-22.3s-12.7-15.1-22.3-12.4l-15.6 4.5c-7.6-13.6-18.9-25-32.6-32.6l4.5-15.6c2.7-9.6-2.8-19.5-12.4-22.3s-19.5 2.8-22.3 12.4l-4.3 15.2c-1.2-.1-2.4-.2-3.6-.2c-15.6-.5-30.3 3.3-43 10.2l-9-9c-7-7-18.4-7-25.5 0s-7 18.4 0 25.5l7.2 7.2c-9.3 12.6-15.2 27.8-16.3 44.5l-7.1-3c-9.1-3.9-19.7 .3-23.6 9.5s.3 19.7 9.5 23.6l8.6 3.7c-6.4 9.9-17.3 22.4-36.9 33.3l-1.3-4.4c-2.7-9.6-12.7-15.1-22.3-12.4s-15.1 12.7-12.4 22.3l2.3 8.1c-3.8 1.1-7.7 2.1-11.9 3.1c-11.6 2.7-22.1 7.7-31.1 14.4l-7.2-7.2c-7-7-18.4-7-25.5 0s-7 18.4 0 25.5l9 9c-7.6 13.9-11.3 30.1-10.1 46.6l-15.2 4.3c-9.6 2.7-15.1 12.7-12.4 22.2s12.7 15.1 22.3 12.4l15.6-4.5c7.7 13.9 19.1 25.1 32.6 32.6L322.7 489zM576 241.5c0 0 0 0 0 0c-11.7-.4-27.3-.9-48-1.6l48 1.5zM448 384a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z"
    ]
};
const $d8206b3ab2e65c05$export$54608d0a883fea4d = {
    prefix: 'fas',
    iconName: 'hand-lizard',
    icon: [
        512,
        512,
        [],
        "f258",
        "M0 112C0 85.5 21.5 64 48 64l112 0 80 0 46.5 0c36.8 0 71.2 18 92.1 48.2l113.5 164c13 18.7 19.9 41 19.9 63.8l0 12 0 16 0 48c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32l0-13.8L273.9 352 240 352l-80 0-48 0c-26.5 0-48-21.5-48-48s21.5-48 48-48l48 0 80 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-80 0L48 160c-26.5 0-48-21.5-48-48z"
    ]
};
const $d8206b3ab2e65c05$export$3db5bca65a1be8dc = {
    prefix: 'fas',
    iconName: 'notdef',
    icon: [
        384,
        512,
        [],
        "e1fe",
        "M64 390.3L153.5 256 64 121.7l0 268.6zM102.5 448l179.1 0L192 313.7 102.5 448zm128-192L320 390.3l0-268.6L230.5 256zM281.5 64L102.5 64 192 198.3 281.5 64zM0 48C0 21.5 21.5 0 48 0L336 0c26.5 0 48 21.5 48 48l0 416c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 48z"
    ]
};
const $d8206b3ab2e65c05$export$c7675a37487adc45 = {
    prefix: 'fas',
    iconName: 'disease',
    icon: [
        512,
        512,
        [],
        "f7fa",
        "M236.4 61.4L227 75.5c-21.3 32-59.4 48.5-97.3 42.1l-59.6-9.9C33.4 101.6 0 129.9 .1 167.1c0 15.9 6.4 31.2 17.6 42.5l29.2 29.2c11 11 17.2 25.9 17.2 41.5c0 15.8-6.4 30.9-17.7 42L33.3 335.1C22.2 345.9 16 360.7 16 376.2c0 36.8 34.1 64.2 70.1 56.2l62.3-13.8c7.7-1.7 15.7-2.6 23.6-2.6l10 0c27.2 0 53.7 9.3 75 26.3L287.8 467c10.5 8.4 23.6 13 37 13c32.7 0 59.3-26.5 59.3-59.3l0-25.2c0-34.9 21.4-66.2 53.9-78.8l36.9-14.3c22.4-8.7 37.2-30.3 37.2-54.3c0-28.1-20.1-52.3-47.8-57.3l-28-5.1c-36.5-6.7-65.4-34.5-73.6-70.7l-7.1-31.5C348.9 53.4 322.1 32 291.3 32c-22 0-42.6 11-54.9 29.4zM160 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm0 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $d8206b3ab2e65c05$export$5000f52ca9819bf5 = {
    prefix: 'fas',
    iconName: 'briefcase-medical',
    icon: [
        512,
        512,
        [],
        "f469",
        "M184 48l144 0c4.4 0 8 3.6 8 8l0 40L176 96l0-40c0-4.4 3.6-8 8-8zm-56 8l0 40L64 96C28.7 96 0 124.7 0 160L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-64 0 0-40c0-30.9-25.1-56-56-56L184 0c-30.9 0-56 25.1-56 56zm96 152c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z"
    ]
};
const $d8206b3ab2e65c05$export$c093cc22e88981c2 = {
    prefix: 'fas',
    iconName: 'genderless',
    icon: [
        384,
        512,
        [],
        "f22d",
        "M192 144a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 288a176 176 0 1 0 0-352 176 176 0 1 0 0 352z"
    ]
};
const $d8206b3ab2e65c05$export$930de8c26eb20490 = {
    prefix: 'fas',
    iconName: 'chevron-right',
    icon: [
        320,
        512,
        [
            9002
        ],
        "f054",
        "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"
    ]
};
const $d8206b3ab2e65c05$export$cebc76f79478e40e = {
    prefix: 'fas',
    iconName: 'retweet',
    icon: [
        576,
        512,
        [],
        "f079",
        "M272 416c17.7 0 32-14.3 32-32s-14.3-32-32-32l-112 0c-17.7 0-32-14.3-32-32l0-128 32 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l32 0 0 128c0 53 43 96 96 96l112 0zM304 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l112 0c17.7 0 32 14.3 32 32l0 128-32 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8l-32 0 0-128c0-53-43-96-96-96L304 96z"
    ]
};
const $d8206b3ab2e65c05$export$ff2b8d5628da5f14 = {
    prefix: 'fas',
    iconName: 'car-rear',
    icon: [
        512,
        512,
        [
            "car-alt"
        ],
        "f5de",
        "M165.4 96l181.2 0c13.6 0 25.7 8.6 30.2 21.4L402.9 192l-293.8 0 26.1-74.6c4.5-12.8 16.6-21.4 30.2-21.4zm-90.6 .3L39.6 196.8C16.4 206.4 0 229.3 0 256l0 80c0 23.7 12.9 44.4 32 55.4L32 448c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-48 256 0 0 48c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-56.6c19.1-11.1 32-31.7 32-55.4l0-80c0-26.7-16.4-49.6-39.6-59.2L437.2 96.3C423.7 57.8 387.4 32 346.6 32L165.4 32c-40.8 0-77.1 25.8-90.6 64.3zM208 272l96 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM48 280c0-13.3 10.7-24 24-24l32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24zm360-24l32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
const $d8206b3ab2e65c05$export$7937ed2462a665c0 = $d8206b3ab2e65c05$export$ff2b8d5628da5f14;
const $d8206b3ab2e65c05$export$821aeede187f23c9 = {
    prefix: 'fas',
    iconName: 'pump-soap',
    icon: [
        448,
        512,
        [],
        "e06b",
        "M128 32l0 96 128 0 0-32 60.1 0c4.2 0 8.3 1.7 11.3 4.7l33.9 33.9c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L372.7 55.4c-15-15-35.4-23.4-56.6-23.4L256 32c0-17.7-14.3-32-32-32L160 0c-17.7 0-32 14.3-32 32zM117.4 160c-33.3 0-61 25.5-63.8 58.7L35 442.7C31.9 480 61.3 512 98.8 512l186.4 0c37.4 0 66.9-32 63.8-69.3l-18.7-224c-2.8-33.2-30.5-58.7-63.8-58.7l-149.1 0zM256 360c0 35.3-28.7 56-64 56s-64-20.7-64-56c0-32.5 37-80.9 50.9-97.9c3.2-3.9 8.1-6.1 13.1-6.1s9.9 2.2 13.1 6.1C219 279.1 256 327.5 256 360z"
    ]
};
const $d8206b3ab2e65c05$export$a714fc79f58cc9ef = {
    prefix: 'fas',
    iconName: 'video-slash',
    icon: [
        640,
        512,
        [],
        "f4e2",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.4-67.7 13.8 9.2c9.8 6.5 22.4 7.2 32.9 1.6s16.9-16.4 16.9-28.2l0-256c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.9 1.6l-96 64L448 174.9l0 17.1 0 128 0 5.8-32-25.1L416 128c0-35.3-28.7-64-64-64L113.9 64 38.8 5.1zM407 416.7L32.3 121.5c-.2 2.1-.3 4.3-.3 6.5l0 256c0 35.3 28.7 64 64 64l256 0c23.4 0 43.9-12.6 55-31.3z"
    ]
};
const $d8206b3ab2e65c05$export$acec92052ac2183 = {
    prefix: 'fas',
    iconName: 'battery-quarter',
    icon: [
        576,
        512,
        [
            "battery-2"
        ],
        "f243",
        "M464 160c8.8 0 16 7.2 16 16l0 160c0 8.8-7.2 16-16 16L80 352c-8.8 0-16-7.2-16-16l0-160c0-8.8 7.2-16 16-16l384 0zM80 96C35.8 96 0 131.8 0 176L0 336c0 44.2 35.8 80 80 80l384 0c44.2 0 80-35.8 80-80l0-16c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l0-16c0-44.2-35.8-80-80-80L80 96zm112 96l-96 0 0 128 96 0 0-128z"
    ]
};
const $d8206b3ab2e65c05$export$23ca8a94c555576 = $d8206b3ab2e65c05$export$acec92052ac2183;
const $d8206b3ab2e65c05$export$11b26516cae2104f = {
    prefix: 'fas',
    iconName: 'radio',
    icon: [
        512,
        512,
        [
            128251
        ],
        "f8d7",
        "M494.8 47c12.7-3.7 20-17.1 16.3-29.8S494-2.8 481.2 1L51.7 126.9c-9.4 2.7-17.9 7.3-25.1 13.2C10.5 151.7 0 170.6 0 192l0 4L0 304 0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-229.5 0L494.8 47zM368 240a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM80 256c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zM64 320c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 336c-8.8 0-16-7.2-16-16zm16 64c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16z"
    ]
};
const $d8206b3ab2e65c05$export$3b3ab4d86bad7d26 = {
    prefix: 'fas',
    iconName: 'baby-carriage',
    icon: [
        512,
        512,
        [
            "carriage-baby"
        ],
        "f77d",
        "M256 192L.1 192C2.7 117.9 41.3 52.9 99 14.1c13.3-8.9 30.8-4.3 39.9 8.8L256 192zm128-32c0-35.3 28.7-64 64-64l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0 0 64c0 25.2-5.8 50.2-17 73.5s-27.8 44.5-48.6 62.3s-45.5 32-72.7 41.6S253.4 416 224 416s-58.5-5-85.7-14.6s-51.9-23.8-72.7-41.6s-37.3-39-48.6-62.3S0 249.2 0 224l224 0 160 0 0-64zM80 416a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm240 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"
    ]
};
const $d8206b3ab2e65c05$export$9f117d92ccd36cf1 = $d8206b3ab2e65c05$export$3b3ab4d86bad7d26;
const $d8206b3ab2e65c05$export$bf0b19daceaec9c2 = {
    prefix: 'fas',
    iconName: 'traffic-light',
    icon: [
        320,
        512,
        [
            128678
        ],
        "f637",
        "M64 0C28.7 0 0 28.7 0 64L0 352c0 88.4 71.6 160 160 160s160-71.6 160-160l0-288c0-35.3-28.7-64-64-64L64 0zm96 416a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm48-176a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-80a48 48 0 1 1 0-96 48 48 0 1 1 0 96z"
    ]
};
const $d8206b3ab2e65c05$export$f576739e9b18ea4f = {
    prefix: 'fas',
    iconName: 'thermometer',
    icon: [
        512,
        512,
        [],
        "f491",
        "M96 382.1l0-88.8c0-14.9 5.9-29.1 16.4-39.6l27.3-27.3 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 41.4-41.4 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 41.4-41.4 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 45.5-45.5C355.2 10.9 381.4 0 408.8 0C465.8 0 512 46.2 512 103.2c0 27.4-10.9 53.6-30.2 73L258.3 399.6c-10.5 10.5-24.7 16.4-39.6 16.4l-88.8 0L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l89-89z"
    ]
};
const $d8206b3ab2e65c05$export$248171cb6dad4307 = {
    prefix: 'fas',
    iconName: 'vr-cardboard',
    icon: [
        640,
        512,
        [],
        "f729",
        "M576 64L64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l120.4 0c24.2 0 46.4-13.7 57.2-35.4l32-64c8.8-17.5 26.7-28.6 46.3-28.6s37.5 11.1 46.3 28.6l32 64c10.8 21.7 33 35.4 57.2 35.4L576 448c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64zM96 240a64 64 0 1 1 128 0A64 64 0 1 1 96 240zm384-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
    ]
};
const $d8206b3ab2e65c05$export$bd40d3a3a16fb147 = {
    prefix: 'fas',
    iconName: 'hand-middle-finger',
    icon: [
        448,
        512,
        [
            128405
        ],
        "f806",
        "M232 0c-22.1 0-40 17.9-40 40l0 164.2c-8.5-7.6-19.7-12.2-32-12.2c-26.5 0-48 21.5-48 48l0 7 0 73c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-55.7c-2 1.4-3.9 3-5.8 4.5L55 284.8C40.4 297 32 315 32 334L32 372c0 38 16.9 74 46.1 98.3l5.4 4.5c28.8 24 65 37.1 102.4 37.1L304 512c70.7 0 128-57.3 128-128l0-64 0-32c0-26.5-21.5-48-48-48c-12.4 0-23.6 4.7-32.1 12.3C350 227.5 329.3 208 304 208c-12.3 0-23.5 4.6-32 12.2L272 40c0-22.1-17.9-40-40-40z"
    ]
};
const $d8206b3ab2e65c05$export$89a1764fbb7ad2cb = {
    prefix: 'fas',
    iconName: 'percent',
    icon: [
        384,
        512,
        [
            62101,
            62785,
            "percentage"
        ],
        "25",
        "M374.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-320 320c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l320-320zM128 128A64 64 0 1 0 0 128a64 64 0 1 0 128 0zM384 384a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
    ]
};
const $d8206b3ab2e65c05$export$89333857fc063a2e = $d8206b3ab2e65c05$export$89a1764fbb7ad2cb;
const $d8206b3ab2e65c05$export$a06617a1a4ccea67 = {
    prefix: 'fas',
    iconName: 'truck-moving',
    icon: [
        640,
        512,
        [],
        "f4df",
        "M64 32C28.7 32 0 60.7 0 96L0 304l0 80 0 16c0 44.2 35.8 80 80 80c26.2 0 49.4-12.6 64-32c14.6 19.4 37.8 32 64 32c44.2 0 80-35.8 80-80c0-5.5-.6-10.8-1.6-16L416 384l33.6 0c-1 5.2-1.6 10.5-1.6 16c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16l1.6 0c17.7 0 32-14.3 32-32l0-64 0-16 0-10.3c0-9.2-3.2-18.2-9-25.3l-58.8-71.8c-10.6-13-26.5-20.5-43.3-20.5L480 144l0-48c0-35.3-28.7-64-64-64L64 32zM585 256l-105 0 0-64 48.8 0c2.4 0 4.7 1.1 6.2 2.9L585 256zM528 368a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM176 400a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM80 368a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $d8206b3ab2e65c05$export$b7ae54b4078b2060 = {
    prefix: 'fas',
    iconName: 'glass-water-droplet',
    icon: [
        384,
        512,
        [],
        "e4f5",
        "M32 0C23.1 0 14.6 3.7 8.6 10.2S-.6 25.4 .1 34.3L28.9 437.7c3 41.9 37.8 74.3 79.8 74.3l166.6 0c42 0 76.8-32.4 79.8-74.3L383.9 34.3c.6-8.9-2.4-17.6-8.5-24.1S360.9 0 352 0L32 0zM83 297.5L66.4 64l251.3 0L301 297.5 288 304c-20.1 10.1-43.9 10.1-64 0s-43.9-10.1-64 0s-43.9 10.1-64 0l-13-6.5zM256 196c0-24-33.7-70.1-52.2-93.5c-6.1-7.7-17.5-7.7-23.6 0C161.7 125.9 128 172 128 196c0 33.1 28.7 60 64 60s64-26.9 64-60z"
    ]
};
const $d8206b3ab2e65c05$export$e9d85839f7751f01 = {
    prefix: 'fas',
    iconName: 'display',
    icon: [
        576,
        512,
        [],
        "e163",
        "M64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l176 0-10.7 32L160 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-69.3 0L336 416l176 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0zM512 64l0 288L64 352 64 64l448 0z"
    ]
};
const $d8206b3ab2e65c05$export$b5023c446f10324 = {
    prefix: 'fas',
    iconName: 'face-smile',
    icon: [
        512,
        512,
        [
            128578,
            "smile"
        ],
        "f118",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.1 325.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $d8206b3ab2e65c05$export$c632b2334f0913bc = $d8206b3ab2e65c05$export$b5023c446f10324;
const $d8206b3ab2e65c05$export$b6314cdc01bb5c43 = {
    prefix: 'fas',
    iconName: 'thumbtack',
    icon: [
        384,
        512,
        [
            128204,
            128392,
            "thumb-tack"
        ],
        "f08d",
        "M32 32C32 14.3 46.3 0 64 0L320 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-29.5 0 11.4 148.2c36.7 19.9 65.7 53.2 79.5 94.7l1 3c3.3 9.8 1.6 20.5-4.4 28.8s-15.7 13.3-26 13.3L32 352c-10.3 0-19.9-4.9-26-13.3s-7.7-19.1-4.4-28.8l1-3c13.8-41.5 42.8-74.8 79.5-94.7L93.5 64 64 64C46.3 64 32 49.7 32 32zM160 384l64 0 0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96z"
    ]
};
const $d8206b3ab2e65c05$export$b63d0c7b519a9aae = $d8206b3ab2e65c05$export$b6314cdc01bb5c43;
const $d8206b3ab2e65c05$export$29c432d69ccf85a5 = {
    prefix: 'fas',
    iconName: 'trophy',
    icon: [
        576,
        512,
        [
            127942
        ],
        "f091",
        "M400 0L176 0c-26.5 0-48.1 21.8-47.1 48.2c.2 5.3 .4 10.6 .7 15.8L24 64C10.7 64 0 74.7 0 88c0 92.6 33.5 157 78.5 200.7c44.3 43.1 98.3 64.8 138.1 75.8c23.4 6.5 39.4 26 39.4 45.6c0 20.9-17 37.9-37.9 37.9L192 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-26.1 0C337 448 320 431 320 410.1c0-19.6 15.9-39.2 39.4-45.6c39.9-11 93.9-32.7 138.2-75.8C542.5 245 576 180.6 576 88c0-13.3-10.7-24-24-24L446.4 64c.3-5.2 .5-10.4 .7-15.8C448.1 21.8 426.5 0 400 0zM48.9 112l84.4 0c9.1 90.1 29.2 150.3 51.9 190.6c-24.9-11-50.8-26.5-73.2-48.3c-32-31.1-58-76-63-142.3zM464.1 254.3c-22.4 21.8-48.3 37.3-73.2 48.3c22.7-40.3 42.8-100.5 51.9-190.6l84.4 0c-5.1 66.3-31.1 111.2-63 142.3z"
    ]
};
const $d8206b3ab2e65c05$export$8ecd436ef91fc02e = {
    prefix: 'fas',
    iconName: 'person-praying',
    icon: [
        448,
        512,
        [
            128720,
            "pray"
        ],
        "f683",
        "M352 64A64 64 0 1 0 224 64a64 64 0 1 0 128 0zM232.7 264l22.9 31.5c6.5 8.9 16.3 14.7 27.2 16.1s21.9-1.7 30.4-8.7l88-72c17.1-14 19.6-39.2 5.6-56.3s-39.2-19.6-56.3-5.6l-55.2 45.2-26.2-36C253.6 156.7 228.6 144 202 144c-30.9 0-59.2 17.1-73.6 44.4L79.8 280.9c-20.2 38.5-9.4 85.9 25.6 111.8L158.6 432 72 432c-22.1 0-40 17.9-40 40s17.9 40 40 40l208 0c17.3 0 32.6-11.1 38-27.5s-.3-34.4-14.2-44.7L187.7 354l45-90z"
    ]
};
const $d8206b3ab2e65c05$export$3b32c982141cad51 = $d8206b3ab2e65c05$export$8ecd436ef91fc02e;
const $d8206b3ab2e65c05$export$6310f315e1ebbca5 = {
    prefix: 'fas',
    iconName: 'hammer',
    icon: [
        576,
        512,
        [
            128296
        ],
        "f6e3",
        "M413.5 237.5c-28.2 4.8-58.2-3.6-80-25.4l-38.1-38.1C280.4 159 272 138.8 272 117.6l0-12.1L192.3 62c-5.3-2.9-8.6-8.6-8.3-14.7s3.9-11.5 9.5-14l47.2-21C259.1 4.2 279 0 299.2 0l18.1 0c36.7 0 72 14 98.7 39.1l44.6 42c24.2 22.8 33.2 55.7 26.6 86L503 183l8-8c9.4-9.4 24.6-9.4 33.9 0l24 24c9.4 9.4 9.4 24.6 0 33.9l-88 88c-9.4 9.4-24.6 9.4-33.9 0l-24-24c-9.4-9.4-9.4-24.6 0-33.9l8-8-17.5-17.5zM27.4 377.1L260.9 182.6c3.5 4.9 7.5 9.6 11.8 14l38.1 38.1c6 6 12.4 11.2 19.2 15.7L134.9 484.6c-14.5 17.4-36 27.4-58.6 27.4C34.1 512 0 477.8 0 435.7c0-22.6 10.1-44.1 27.4-58.6z"
    ]
};
const $d8206b3ab2e65c05$export$e49e3cfceea441cc = {
    prefix: 'fas',
    iconName: 'hand-peace',
    icon: [
        512,
        512,
        [
            9996
        ],
        "f25b",
        "M224 0c17.7 0 32 14.3 32 32l0 208-64 0 0-208c0-17.7 14.3-32 32-32zm96 160c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm64 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64zM93.3 51.2L175.9 240l-69.9 0L34.7 76.8C27.6 60.6 35 41.8 51.2 34.7s35.1 .3 42.1 16.5zm27 221.3l-.2-.5 69.9 0 26.1 0c22.1 0 40 17.9 40 40s-17.9 40-40 40l-56 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l56 0c39.8 0 72-32.2 72-72l0-.6c9.4 5.4 20.3 8.6 32 8.6c13.2 0 25.4-4 35.6-10.8c8.7 24.9 32.5 42.8 60.4 42.8c11.7 0 22.6-3.1 32-8.6l0 8.6c0 88.4-71.6 160-160 160l-61.7 0c-42.4 0-83.1-16.9-113.1-46.9l-11.6-11.6C77.5 429.5 64 396.9 64 363l0-27c0-32.7 24.6-59.7 56.3-63.5z"
    ]
};
const $d8206b3ab2e65c05$export$decde496a29c5b23 = {
    prefix: 'fas',
    iconName: 'rotate',
    icon: [
        512,
        512,
        [
            128260,
            "sync-alt"
        ],
        "f2f1",
        "M142.9 142.9c-17.5 17.5-30.1 38-37.8 59.8c-5.9 16.7-24.2 25.4-40.8 19.5s-25.4-24.2-19.5-40.8C55.6 150.7 73.2 122 97.6 97.6c87.2-87.2 228.3-87.5 315.8-1L455 55c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2l0 128c0 13.3-10.7 24-24 24l-8.4 0c0 0 0 0 0 0L344 224c-9.7 0-18.5-5.8-22.2-14.8s-1.7-19.3 5.2-26.2l41.1-41.1c-62.6-61.5-163.1-61.2-225.3 1zM16 312c0-13.3 10.7-24 24-24l7.6 0 .7 0L168 288c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-41.1 41.1c62.6 61.5 163.1 61.2 225.3-1c17.5-17.5 30.1-38 37.8-59.8c5.9-16.7 24.2-25.4 40.8-19.5s25.4 24.2 19.5 40.8c-10.8 30.6-28.4 59.3-52.9 83.8c-87.2 87.2-228.3 87.5-315.8 1L57 457c-6.9 6.9-17.2 8.9-26.2 5.2S16 449.7 16 440l0-119.6 0-.7 0-7.6z"
    ]
};
const $d8206b3ab2e65c05$export$2ff2056be8c281e4 = $d8206b3ab2e65c05$export$decde496a29c5b23;
const $d8206b3ab2e65c05$export$1025ad641edb49c2 = {
    prefix: 'fas',
    iconName: 'spinner',
    icon: [
        512,
        512,
        [],
        "f110",
        "M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z"
    ]
};
const $d8206b3ab2e65c05$export$30a5bb4ad3fa716c = {
    prefix: 'fas',
    iconName: 'robot',
    icon: [
        640,
        512,
        [
            129302
        ],
        "f544",
        "M320 0c17.7 0 32 14.3 32 32l0 64 120 0c39.8 0 72 32.2 72 72l0 272c0 39.8-32.2 72-72 72l-304 0c-39.8 0-72-32.2-72-72l0-272c0-39.8 32.2-72 72-72l120 0 0-64c0-17.7 14.3-32 32-32zM208 384c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0zM264 256a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm152 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM48 224l16 0 0 192-16 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48zm544 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-16 0 0-192 16 0z"
    ]
};
const $d8206b3ab2e65c05$export$8614cb1326eacd7a = {
    prefix: 'fas',
    iconName: 'peace',
    icon: [
        512,
        512,
        [
            9774
        ],
        "f67c",
        "M224 445.3l0-121.8-94.3 77.1c26.1 22.8 58.5 38.7 94.3 44.7zM89.2 351.1L224 240.8l0-174.2C133.2 81.9 64 160.9 64 256c0 34.6 9.2 67.1 25.2 95.1zm293.1 49.5L288 323.5l0 121.8c35.7-6 68.1-21.9 94.3-44.7zm40.6-49.5c16-28 25.2-60.5 25.2-95.1c0-95.1-69.2-174.1-160-189.3l0 174.2L422.8 351.1zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
    ]
};
const $d8206b3ab2e65c05$export$4aac79b9ae3cfdb8 = {
    prefix: 'fas',
    iconName: 'gears',
    icon: [
        640,
        512,
        [
            "cogs"
        ],
        "f085",
        "M308.5 135.3c7.1-6.3 9.9-16.2 6.2-25c-2.3-5.3-4.8-10.5-7.6-15.5L304 89.4c-3-5-6.3-9.9-9.8-14.6c-5.7-7.6-15.7-10.1-24.7-7.1l-28.2 9.3c-10.7-8.8-23-16-36.2-20.9L199 27.1c-1.9-9.3-9.1-16.7-18.5-17.8C173.9 8.4 167.2 8 160.4 8l-.7 0c-6.8 0-13.5 .4-20.1 1.2c-9.4 1.1-16.6 8.6-18.5 17.8L115 56.1c-13.3 5-25.5 12.1-36.2 20.9L50.5 67.8c-9-3-19-.5-24.7 7.1c-3.5 4.7-6.8 9.6-9.9 14.6l-3 5.3c-2.8 5-5.3 10.2-7.6 15.6c-3.7 8.7-.9 18.6 6.2 25l22.2 19.8C32.6 161.9 32 168.9 32 176s.6 14.1 1.7 20.9L11.5 216.7c-7.1 6.3-9.9 16.2-6.2 25c2.3 5.3 4.8 10.5 7.6 15.6l3 5.2c3 5.1 6.3 9.9 9.9 14.6c5.7 7.6 15.7 10.1 24.7 7.1l28.2-9.3c10.7 8.8 23 16 36.2 20.9l6.1 29.1c1.9 9.3 9.1 16.7 18.5 17.8c6.7 .8 13.5 1.2 20.4 1.2s13.7-.4 20.4-1.2c9.4-1.1 16.6-8.6 18.5-17.8l6.1-29.1c13.3-5 25.5-12.1 36.2-20.9l28.2 9.3c9 3 19 .5 24.7-7.1c3.5-4.7 6.8-9.5 9.8-14.6l3.1-5.4c2.8-5 5.3-10.2 7.6-15.5c3.7-8.7 .9-18.6-6.2-25l-22.2-19.8c1.1-6.8 1.7-13.8 1.7-20.9s-.6-14.1-1.7-20.9l22.2-19.8zM112 176a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM504.7 500.5c6.3 7.1 16.2 9.9 25 6.2c5.3-2.3 10.5-4.8 15.5-7.6l5.4-3.1c5-3 9.9-6.3 14.6-9.8c7.6-5.7 10.1-15.7 7.1-24.7l-9.3-28.2c8.8-10.7 16-23 20.9-36.2l29.1-6.1c9.3-1.9 16.7-9.1 17.8-18.5c.8-6.7 1.2-13.5 1.2-20.4s-.4-13.7-1.2-20.4c-1.1-9.4-8.6-16.6-17.8-18.5L583.9 307c-5-13.3-12.1-25.5-20.9-36.2l9.3-28.2c3-9 .5-19-7.1-24.7c-4.7-3.5-9.6-6.8-14.6-9.9l-5.3-3c-5-2.8-10.2-5.3-15.6-7.6c-8.7-3.7-18.6-.9-25 6.2l-19.8 22.2c-6.8-1.1-13.8-1.7-20.9-1.7s-14.1 .6-20.9 1.7l-19.8-22.2c-6.3-7.1-16.2-9.9-25-6.2c-5.3 2.3-10.5 4.8-15.6 7.6l-5.2 3c-5.1 3-9.9 6.3-14.6 9.9c-7.6 5.7-10.1 15.7-7.1 24.7l9.3 28.2c-8.8 10.7-16 23-20.9 36.2L315.1 313c-9.3 1.9-16.7 9.1-17.8 18.5c-.8 6.7-1.2 13.5-1.2 20.4s.4 13.7 1.2 20.4c1.1 9.4 8.6 16.6 17.8 18.5l29.1 6.1c5 13.3 12.1 25.5 20.9 36.2l-9.3 28.2c-3 9-.5 19 7.1 24.7c4.7 3.5 9.5 6.8 14.6 9.8l5.4 3.1c5 2.8 10.2 5.3 15.5 7.6c8.7 3.7 18.6 .9 25-6.2l19.8-22.2c6.8 1.1 13.8 1.7 20.9 1.7s14.1-.6 20.9-1.7l19.8 22.2zM464 304a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
const $d8206b3ab2e65c05$export$af1575770afc9559 = $d8206b3ab2e65c05$export$4aac79b9ae3cfdb8;
const $d8206b3ab2e65c05$export$e3a174a50618c208 = {
    prefix: 'fas',
    iconName: 'warehouse',
    icon: [
        640,
        512,
        [],
        "f494",
        "M0 488L0 171.3c0-26.2 15.9-49.7 40.2-59.4L308.1 4.8c7.6-3.1 16.1-3.1 23.8 0L599.8 111.9c24.3 9.7 40.2 33.3 40.2 59.4L640 488c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-264c0-17.7-14.3-32-32-32l-384 0c-17.7 0-32 14.3-32 32l0 264c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24zm488 24l-336 0c-13.3 0-24-10.7-24-24l0-56 384 0 0 56c0 13.3-10.7 24-24 24zM128 400l0-64 384 0 0 64-384 0zm0-96l0-80 384 0 0 80-384 0z"
    ]
};
const $d8206b3ab2e65c05$export$bc804c6ab898f610 = {
    prefix: 'fas',
    iconName: 'arrow-up-right-dots',
    icon: [
        576,
        512,
        [],
        "e4b7",
        "M160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l50.7 0L9.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 109.3l0 50.7c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128c0-17.7-14.3-32-32-32L160 0zM576 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM448 208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM400 384a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm128 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM272 384a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM144 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM576 336a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-48-80a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    ]
};
const $d8206b3ab2e65c05$export$d6f21e17ea797702 = {
    prefix: 'fas',
    iconName: 'splotch',
    icon: [
        512,
        512,
        [],
        "f5bc",
        "M208.5 62.3l28.1-36.9C248.8 9.4 267.8 0 288 0c28.5 0 53.6 18.7 61.8 46l17.8 59.4c10.3 34.4 36.1 62 69.8 74.6l39.8 14.9c20.9 7.9 34.8 27.9 34.8 50.2c0 16.9-7.9 32.8-21.5 42.9l-67.3 50.5c-24.3 18.2-37.2 47.9-33.8 78.1l2.5 22.7c4.3 38.7-26 72.6-65 72.6c-14.8 0-29.3-5.1-40.8-14.3l-55.4-44.3c-4.5-3.6-9.3-6.7-14.5-9.2c-15.8-7.9-33.7-10.4-51-7.3L82.4 451.9C47.8 458.2 16 431.6 16 396.5c0-13.2 4.7-26 13.1-36.2l11.2-13.4c14.6-17.4 22.6-39.4 22.6-62.1c0-18.8-5.5-37.2-15.8-53L8.8 173.5C3.1 164.7 0 154.4 0 143.9c0-33.4 30.1-58.8 63-53.2l51.3 8.7c35.9 6.1 72.2-8.2 94.2-37.1z"
    ]
};
const $d8206b3ab2e65c05$export$fbb22081b65e4f33 = {
    prefix: 'fas',
    iconName: 'face-grin-hearts',
    icon: [
        512,
        512,
        [
            128525,
            "grin-hearts"
        ],
        "f584",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM199.3 129.1c17.8 4.8 28.4 23.1 23.6 40.8l-17.4 65c-2.3 8.5-11.1 13.6-19.6 11.3l-65.1-17.4c-17.8-4.8-28.4-23.1-23.6-40.8s23.1-28.4 40.8-23.6l16.1 4.3 4.3-16.1c4.8-17.8 23.1-28.4 40.8-23.6zm154.3 23.6l4.3 16.1 16.1-4.3c17.8-4.8 36.1 5.8 40.8 23.6s-5.8 36.1-23.6 40.8l-65.1 17.4c-8.5 2.3-17.3-2.8-19.6-11.3l-17.4-65c-4.8-17.8 5.8-36.1 23.6-40.8s36.1 5.8 40.9 23.6z"
    ]
};
const $d8206b3ab2e65c05$export$c56cf0e0c3bc5ed2 = $d8206b3ab2e65c05$export$fbb22081b65e4f33;
const $d8206b3ab2e65c05$export$2df6451abf70a6ff = {
    prefix: 'fas',
    iconName: 'dice-four',
    icon: [
        448,
        512,
        [
            9859
        ],
        "f524",
        "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm160 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM352 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
const $d8206b3ab2e65c05$export$3bee83bf278fddbe = {
    prefix: 'fas',
    iconName: 'sim-card',
    icon: [
        384,
        512,
        [],
        "f7c4",
        "M64 0L242.7 0c17 0 33.3 6.7 45.3 18.7L365.3 96c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0zM96 192c-17.7 0-32 14.3-32 32l0 32 64 0 0-64-32 0zM64 352l80 0 96 0 80 0 0-64-80 0-96 0-80 0 0 64zM320 224c0-17.7-14.3-32-32-32l-32 0 0 64 64 0 0-32zM160 192l0 64 64 0 0-64-64 0zM288 448c17.7 0 32-14.3 32-32l0-32-64 0 0 64 32 0zM160 384l0 64 64 0 0-64-64 0zM64 416c0 17.7 14.3 32 32 32l32 0 0-64-64 0 0 32z"
    ]
};
const $d8206b3ab2e65c05$export$7e3f1701aa95ef01 = {
    prefix: 'fas',
    iconName: 'transgender',
    icon: [
        512,
        512,
        [
            9895,
            "transgender-alt"
        ],
        "f225",
        "M112 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-31 31L112 78.1l7-7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-7 7 15.2 15.2C187.7 107.6 220.5 96 256 96s68.3 11.6 94.9 31.2l68.8-68.8-31-31c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9l96 0c8.8 0 16 7.2 16 16l0 96c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5l-31-31-68.8 68.8C404.4 187.7 416 220.5 416 256c0 80.2-59 146.6-136 158.2l0 17.8 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0 0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l16 0 0-17.8C155 402.6 96 336.2 96 256c0-35.5 11.6-68.3 31.2-94.9L112 145.9l-7 7c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l7-7L58.3 92.3l-31 31c-4.6 4.6-11.5 5.9-17.4 3.5S0 118.5 0 112L0 16C0 7.2 7.2 0 16 0l96 0zM352 256a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z"
    ]
};
const $d8206b3ab2e65c05$export$9c36cf9334c052f = $d8206b3ab2e65c05$export$7e3f1701aa95ef01;
const $d8206b3ab2e65c05$export$e134ecd00b622a47 = {
    prefix: 'fas',
    iconName: 'mercury',
    icon: [
        384,
        512,
        [
            9791
        ],
        "f223",
        "M72.1 7C85.8-4 106-1.8 117 12c17.6 22 44.7 36 75 36s57.3-14 75-36c11.1-13.8 31.2-16 45-5s16 31.2 5 45c-7.8 9.7-16.6 18.4-26.4 26.1C337.3 109.7 368 163.3 368 224c0 89.1-66.2 162.7-152 174.4l0 25.6 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0 0 16c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l32 0 0-25.6C82.2 386.7 16 313.1 16 224c0-60.7 30.7-114.3 77.5-145.9C83.7 70.5 74.9 61.7 67.1 52c-11.1-13.8-8.8-33.9 5-45zM80 224a112 112 0 1 0 224 0A112 112 0 1 0 80 224z"
    ]
};
const $d8206b3ab2e65c05$export$fd4d6cfd52703f50 = {
    prefix: 'fas',
    iconName: 'arrow-turn-down',
    icon: [
        384,
        512,
        [
            "level-down"
        ],
        "f149",
        "M32 64C14.3 64 0 49.7 0 32S14.3 0 32 0l96 0c53 0 96 43 96 96l0 306.7 73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 402.7 160 96c0-17.7-14.3-32-32-32L32 64z"
    ]
};
const $d8206b3ab2e65c05$export$3794c07e7a666c94 = $d8206b3ab2e65c05$export$fd4d6cfd52703f50;
const $d8206b3ab2e65c05$export$a75569baaf4a6c3a = {
    prefix: 'fas',
    iconName: 'person-falling-burst',
    icon: [
        640,
        512,
        [],
        "e547",
        "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 9.8c0 39-23.7 74-59.9 88.4C71.6 154.5 32 213 32 278.2L32 352c0 17.7 14.3 32 32 32s32-14.3 32-32l0-73.8c0-10 1.6-19.8 4.5-29L261.1 497.4c9.6 14.8 29.4 19.1 44.3 9.5s19.1-29.4 9.5-44.3L222.6 320l1.4 0 80 0 38.4 51.2c10.6 14.1 30.7 17 44.8 6.4s17-30.7 6.4-44.8l-43.2-57.6C341.3 263.1 327.1 256 312 256l-71.5 0-56.8-80.2-.2-.3c44.7-29 72.5-79 72.5-133.6l0-9.8zM96 80A48 48 0 1 0 0 80a48 48 0 1 0 96 0zM464 286.1l58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 78.7-12.2c6.5-1 11.7-5.9 13.1-12.2s-1.1-13-6.5-16.7l-65.6-45.1L603 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3L508.3 92.1l-29.4-74C476.4 12 470.6 8 464 8s-12.4 4-14.9 10.1l-29.4 74L343.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1-65.6 45.1c-5.4 3.7-8 10.3-6.5 16.7c.1 .3 .1 .6 .2 .8l19.4 0c20.1 0 39.2 7.5 53.8 20.8l18.4 2.9L383 265.3l36.2 48.3c2.1 2.8 3.9 5.7 5.5 8.6L464 286.1z"
    ]
};
const $d8206b3ab2e65c05$export$f8db2747dadd48f7 = {
    prefix: 'fas',
    iconName: 'award',
    icon: [
        384,
        512,
        [],
        "f559",
        "M173.8 5.5c11-7.3 25.4-7.3 36.4 0L228 17.2c6 3.9 13 5.8 20.1 5.4l21.3-1.3c13.2-.8 25.6 6.4 31.5 18.2l9.6 19.1c3.2 6.4 8.4 11.5 14.7 14.7L344.5 83c11.8 5.9 19 18.3 18.2 31.5l-1.3 21.3c-.4 7.1 1.5 14.2 5.4 20.1l11.8 17.8c7.3 11 7.3 25.4 0 36.4L366.8 228c-3.9 6-5.8 13-5.4 20.1l1.3 21.3c.8 13.2-6.4 25.6-18.2 31.5l-19.1 9.6c-6.4 3.2-11.5 8.4-14.7 14.7L301 344.5c-5.9 11.8-18.3 19-31.5 18.2l-21.3-1.3c-7.1-.4-14.2 1.5-20.1 5.4l-17.8 11.8c-11 7.3-25.4 7.3-36.4 0L156 366.8c-6-3.9-13-5.8-20.1-5.4l-21.3 1.3c-13.2 .8-25.6-6.4-31.5-18.2l-9.6-19.1c-3.2-6.4-8.4-11.5-14.7-14.7L39.5 301c-11.8-5.9-19-18.3-18.2-31.5l1.3-21.3c.4-7.1-1.5-14.2-5.4-20.1L5.5 210.2c-7.3-11-7.3-25.4 0-36.4L17.2 156c3.9-6 5.8-13 5.4-20.1l-1.3-21.3c-.8-13.2 6.4-25.6 18.2-31.5l19.1-9.6C65 70.2 70.2 65 73.4 58.6L83 39.5c5.9-11.8 18.3-19 31.5-18.2l21.3 1.3c7.1 .4 14.2-1.5 20.1-5.4L173.8 5.5zM272 192a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM1.3 441.8L44.4 339.3c.2 .1 .3 .2 .4 .4l9.6 19.1c11.7 23.2 36 37.3 62 35.8l21.3-1.3c.2 0 .5 0 .7 .2l17.8 11.8c5.1 3.3 10.5 5.9 16.1 7.7l-37.6 89.3c-2.3 5.5-7.4 9.2-13.3 9.7s-11.6-2.2-14.8-7.2L74.4 455.5l-56.1 8.3c-5.7 .8-11.4-1.5-15-6s-4.3-10.7-2.1-16zm248 60.4L211.7 413c5.6-1.8 11-4.3 16.1-7.7l17.8-11.8c.2-.1 .4-.2 .7-.2l21.3 1.3c26 1.5 50.3-12.6 62-35.8l9.6-19.1c.1-.2 .2-.3 .4-.4l43.2 102.5c2.2 5.3 1.4 11.4-2.1 16s-9.3 6.9-15 6l-56.1-8.3-32.2 49.2c-3.2 5-8.9 7.7-14.8 7.2s-11-4.3-13.3-9.7z"
    ]
};
const $d8206b3ab2e65c05$export$68ddda3b30ba09f0 = {
    prefix: 'fas',
    iconName: 'ticket-simple',
    icon: [
        576,
        512,
        [
            "ticket-alt"
        ],
        "f3ff",
        "M0 128C0 92.7 28.7 64 64 64l448 0c35.3 0 64 28.7 64 64l0 64c0 8.8-7.4 15.7-15.7 18.6C541.5 217.1 528 235 528 256s13.5 38.9 32.3 45.4c8.3 2.9 15.7 9.8 15.7 18.6l0 64c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64l0-64c0-8.8 7.4-15.7 15.7-18.6C34.5 294.9 48 277 48 256s-13.5-38.9-32.3-45.4C7.4 207.7 0 200.8 0 192l0-64z"
    ]
};
const $d8206b3ab2e65c05$export$75e38ba471fd89c4 = $d8206b3ab2e65c05$export$68ddda3b30ba09f0;
const $d8206b3ab2e65c05$export$f26673f8b10c3d46 = {
    prefix: 'fas',
    iconName: 'building',
    icon: [
        384,
        512,
        [
            127970,
            61687
        ],
        "f1ad",
        "M48 0C21.5 0 0 21.5 0 48L0 464c0 26.5 21.5 48 48 48l96 0 0-80c0-26.5 21.5-48 48-48s48 21.5 48 48l0 80 96 0c26.5 0 48-21.5 48-48l0-416c0-26.5-21.5-48-48-48L48 0zM64 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm112-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM80 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM272 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16z"
    ]
};
const $d8206b3ab2e65c05$export$2ebd565813951f81 = {
    prefix: 'fas',
    iconName: 'angles-left',
    icon: [
        512,
        512,
        [
            171,
            "angle-double-left"
        ],
        "f100",
        "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160zm352-160l-160 160c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L301.3 256 438.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0z"
    ]
};
const $d8206b3ab2e65c05$export$21b0833b3cf929a7 = $d8206b3ab2e65c05$export$2ebd565813951f81;
const $d8206b3ab2e65c05$export$fc19ca0fe15e73bc = {
    prefix: 'fas',
    iconName: 'qrcode',
    icon: [
        448,
        512,
        [],
        "f029",
        "M0 80C0 53.5 21.5 32 48 32l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48L0 80zM64 96l0 64 64 0 0-64L64 96zM0 336c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96zm64 16l0 64 64 0 0-64-64 0zM304 32l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48zm80 64l-64 0 0 64 64 0 0-64zM256 304c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s7.2-16 16-16s16 7.2 16 16l0 96c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-160zM368 480a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm64 0a16 16 0 1 1 0-32 16 16 0 1 1 0 32z"
    ]
};
const $d8206b3ab2e65c05$export$29be1665d1b36a3b = {
    prefix: 'fas',
    iconName: 'clock-rotate-left',
    icon: [
        512,
        512,
        [
            "history"
        ],
        "f1da",
        "M75 75L41 41C25.9 25.9 0 36.6 0 57.9L0 168c0 13.3 10.7 24 24 24l110.1 0c21.4 0 32.1-25.9 17-41l-30.8-30.8C155 85.5 203 64 256 64c106 0 192 86 192 192s-86 192-192 192c-40.8 0-78.6-12.7-109.7-34.4c-14.5-10.1-34.4-6.6-44.6 7.9s-6.6 34.4 7.9 44.6C151.2 495 201.7 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C185.3 0 121.3 28.7 75 75zm181 53c-13.3 0-24 10.7-24 24l0 104c0 6.4 2.5 12.5 7 17l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-65-65 0-94.1c0-13.3-10.7-24-24-24z"
    ]
};
const $d8206b3ab2e65c05$export$76d1986559ca7b7a = $d8206b3ab2e65c05$export$29be1665d1b36a3b;
const $d8206b3ab2e65c05$export$2ff38f330c834084 = {
    prefix: 'fas',
    iconName: 'face-grin-beam-sweat',
    icon: [
        512,
        512,
        [
            128517,
            "grin-beam-sweat"
        ],
        "f583",
        "M476.8 126.3c-4.1 1.1-8.4 1.7-12.8 1.7c-26.5 0-48-21-48-47c0-5 1.8-11.3 4.6-18.1c.3-.7 .6-1.4 .9-2.1c9-20.2 26.5-44.9 36-57.5c3.2-4.4 9.6-4.4 12.8 0C483.4 20.6 512 61 512 81c0 21.7-14.9 39.8-35.2 45.3zM256 0c51.4 0 99.3 15.2 139.4 41.2c-1.5 3.1-3 6.2-4.3 9.3c-3.4 8-7.1 19-7.1 30.5c0 44.3 36.6 79 80 79c9.6 0 18.8-1.7 27.4-4.8c13.3 30.9 20.6 65 20.6 100.8c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0zM383.8 317.8C345.3 329.4 301.9 336 256 336s-89.3-6.6-127.8-18.2c-12.3-3.7-24.3 7-19.2 18.7c24.5 56.9 81.1 96.7 147 96.7s122.5-39.8 147-96.7c5.1-11.8-6.9-22.4-19.2-18.7zm-166.2-89s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 188.4 120 206.1 120 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0c0 0 0 0 0 0zm160 0s0 0 0 0s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 188.4 280 206.1 280 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0z"
    ]
};
const $d8206b3ab2e65c05$export$14d0ccc54c5b6826 = $d8206b3ab2e65c05$export$2ff38f330c834084;
const $d8206b3ab2e65c05$export$364f19abcfac1b0a = {
    prefix: 'fas',
    iconName: 'file-export',
    icon: [
        576,
        512,
        [
            "arrow-right-from-file"
        ],
        "f56e",
        "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 128-168 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l168 0 0 112c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM384 336l0-48 110.1 0-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39L384 336zm0-208l-128 0L256 0 384 128z"
    ]
};
const $d8206b3ab2e65c05$export$b9c76255b38e1df1 = $d8206b3ab2e65c05$export$364f19abcfac1b0a;
const $d8206b3ab2e65c05$export$8241bd5b9163ca12 = {
    prefix: 'fas',
    iconName: 'shield',
    icon: [
        512,
        512,
        [
            128737,
            "shield-blank"
        ],
        "f132",
        "M256 0c4.6 0 9.2 1 13.4 2.9L457.7 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0z"
    ]
};
const $d8206b3ab2e65c05$export$64f54da8fbaba8ee = $d8206b3ab2e65c05$export$8241bd5b9163ca12;
const $d8206b3ab2e65c05$export$be9d5060a4bc3b4b = {
    prefix: 'fas',
    iconName: 'arrow-up-short-wide',
    icon: [
        576,
        512,
        [
            "sort-amount-up-alt"
        ],
        "f885",
        "M151.6 42.4C145.5 35.8 137 32 128 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L96 146.3 96 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-301.7 32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-160 0zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32l224 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-224 0z"
    ]
};
const $d8206b3ab2e65c05$export$6e87844b0f151b6a = $d8206b3ab2e65c05$export$be9d5060a4bc3b4b;
const $d8206b3ab2e65c05$export$6754d04baba2fe26 = {
    prefix: 'fas',
    iconName: 'comment-nodes',
    icon: [
        640,
        512,
        [],
        "e696",
        "M256 448c10.8 0 21.5-.5 32-1.6c.3-15.8 4.4-31.7 12.9-46.4c16-27.7 43.7-44.4 73.2-47.5l16.7-29.2c-4.3-11-6.7-22.9-6.7-35.4c0-53 43-96 96-96c9.1 0 17.8 1.3 26.2 3.6C481.1 102.1 378.6 32 256 32C114.6 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.2 .3-.4 .5-.6 .7c-.3 .3-.5 .5-.6 .7l-.3 .3c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zm72.6-32c-17.7 30.6-7.2 69.7 23.4 87.4s69.7 7.2 87.4-23.4c1.5-2.6 2.8-5.3 3.9-8l73.3 0c1.1 2.7 2.4 5.4 3.9 8c17.7 30.6 56.8 41.1 87.4 23.4s41.1-56.8 23.4-87.4c-13.4-23.2-39.1-34.8-64-31.4l-17.6-30.7c-11 11.7-25 20.6-40.6 25.6l16.5 28.9c-3.8 4.8-6.8 10-9 15.6l-73.4 0c-2.2-5.6-5.3-10.8-9-15.6l33-57.7c4.1 .8 8.4 1.3 12.8 1.3c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64c0 13.4 4.1 25.8 11.2 36.1l-34.6 60.5c-25-3.4-50.6 8.3-64 31.4z"
    ]
};
const $d8206b3ab2e65c05$export$2d077da983246a68 = {
    prefix: 'fas',
    iconName: 'house-medical',
    icon: [
        576,
        512,
        [],
        "e3b2",
        "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1l32 0 0 160.4c0 35.3 28.7 64 64 64l320.4 0c35.5 0 64.2-28.8 64-64.3l-.7-160.2 32 0zM256 208c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z"
    ]
};
const $d8206b3ab2e65c05$export$14c9f1d85e53ae99 = {
    prefix: 'fas',
    iconName: 'golf-ball-tee',
    icon: [
        384,
        512,
        [
            "golf-ball"
        ],
        "f450",
        "M384 192c0 66.8-34.1 125.6-85.8 160L85.8 352C34.1 317.6 0 258.8 0 192C0 86 86 0 192 0S384 86 384 192zM242.1 256.6c0 18.5-15 33.5-33.5 33.5c-4.9 0-9.1 5.1-5.4 8.4c5.9 5.2 13.7 8.4 22.1 8.4c18.5 0 33.5-15 33.5-33.5c0-8.5-3.2-16.2-8.4-22.1c-3.3-3.7-8.4 .5-8.4 5.4zm-52.3-49.3c-4.9 0-9.1 5.1-5.4 8.4c5.9 5.2 13.7 8.4 22.1 8.4c18.5 0 33.5-15 33.5-33.5c0-8.5-3.2-16.2-8.4-22.1c-3.3-3.7-8.4 .5-8.4 5.4c0 18.5-15 33.5-33.5 33.5zm113.5-17.5c0 18.5-15 33.5-33.5 33.5c-4.9 0-9.1 5.1-5.4 8.4c5.9 5.2 13.7 8.4 22.1 8.4c18.5 0 33.5-15 33.5-33.5c0-8.5-3.2-16.2-8.4-22.1c-3.3-3.7-8.4 .5-8.4 5.4zM96 416c0-17.7 14.3-32 32-32l64 0 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-16 0c-8.8 0-16 7.2-16 16l0 16c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-16c0-8.8-7.2-16-16-16l-16 0c-17.7 0-32-14.3-32-32z"
    ]
};
const $d8206b3ab2e65c05$export$2251487a9a33c682 = $d8206b3ab2e65c05$export$14c9f1d85e53ae99;
const $d8206b3ab2e65c05$export$f2b13ad44c03c40f = {
    prefix: 'fas',
    iconName: 'circle-chevron-left',
    icon: [
        512,
        512,
        [
            "chevron-circle-left"
        ],
        "f137",
        "M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM271 135c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-87 87 87 87c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L167 273c-9.4-9.4-9.4-24.6 0-33.9L271 135z"
    ]
};
const $d8206b3ab2e65c05$export$4a42c8c2451a33fd = $d8206b3ab2e65c05$export$f2b13ad44c03c40f;
const $d8206b3ab2e65c05$export$792391babe46862d = {
    prefix: 'fas',
    iconName: 'house-chimney-window',
    icon: [
        576,
        512,
        [],
        "e00d",
        "M575.8 255.5c0 18-15 32.1-32 32.1l-32 0 .7 160.2c.2 35.5-28.5 64.3-64 64.3l-320.4 0c-35.3 0-64-28.7-64-64l0-160.4-32 0c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7 416 64c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 121 52.8 46.4c8 7 12 15 11 24zM248 192c-13.3 0-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24l0-80c0-13.3-10.7-24-24-24l-80 0z"
    ]
};
const $d8206b3ab2e65c05$export$a82594dcc75a49f5 = {
    prefix: 'fas',
    iconName: 'pen-nib',
    icon: [
        512,
        512,
        [
            10001
        ],
        "f5ad",
        "M368.4 18.3L312.7 74.1 437.9 199.3l55.7-55.7c21.9-21.9 21.9-57.3 0-79.2L447.6 18.3c-21.9-21.9-57.3-21.9-79.2 0zM288 94.6l-9.2 2.8L134.7 140.6c-19.9 6-35.7 21.2-42.3 41L3.8 445.8c-3.8 11.3-1 23.9 7.3 32.4L164.7 324.7c-3-6.3-4.7-13.3-4.7-20.7c0-26.5 21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48c-7.4 0-14.4-1.7-20.7-4.7L33.7 500.9c8.6 8.3 21.1 11.2 32.4 7.3l264.3-88.6c19.7-6.6 35-22.4 41-42.3l43.2-144.1 2.7-9.2L288 94.6z"
    ]
};
const $d8206b3ab2e65c05$export$89af87b7d6c15adf = {
    prefix: 'fas',
    iconName: 'tent-arrow-turn-left',
    icon: [
        576,
        512,
        [],
        "e580",
        "M120.1 41.8c9.9-8.9 10.7-24 1.8-33.9S97.8-2.7 87.9 6.2l-80 72C2.9 82.7 0 89.2 0 96s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L86.5 120 456 120c39.8 0 72 32.2 72 72l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40c0-66.3-53.7-120-120-120L86.5 72l33.5-30.2zM307.4 166.5c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S86.7 512 96 512l144 0 16 0c17.7 0 32-14.3 32-32l0-118.1c0-5.5 4.4-9.9 9.9-9.9c3.7 0 7.2 2.1 8.8 5.5l68.4 136.8c5.4 10.8 16.5 17.7 28.6 17.7l60.2 0 16 0c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"
    ]
};
const $d8206b3ab2e65c05$export$c93b950e845a4ee7 = {
    prefix: 'fas',
    iconName: 'tents',
    icon: [
        640,
        512,
        [],
        "e582",
        "M396.6 6.5L235.8 129.1c9.6 1.8 18.9 5.8 27 12l168 128c13.2 10.1 22 24.9 24.5 41.4l6.2 41.5L608 352c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128c-11.5-8.7-27.3-8.7-38.8 0zm-153.2 160c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S22.7 512 32 512l144 0 16 0c17.7 0 32-14.3 32-32l0-118.1c0-5.5 4.4-9.9 9.9-9.9c3.7 0 7.2 2.1 8.8 5.5l68.4 136.8c5.4 10.8 16.5 17.7 28.6 17.7l60.2 0 16 0c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"
    ]
};
const $d8206b3ab2e65c05$export$8282f5f5dcf6b009 = {
    prefix: 'fas',
    iconName: 'wand-magic',
    icon: [
        512,
        512,
        [
            "magic"
        ],
        "f0d0",
        "M14.1 463.3c-18.7-18.7-18.7-49.1 0-67.9L395.4 14.1c18.7-18.7 49.1-18.7 67.9 0l34.6 34.6c18.7 18.7 18.7 49.1 0 67.9L116.5 497.9c-18.7 18.7-49.1 18.7-67.9 0L14.1 463.3zM347.6 187.6l105-105L429.4 59.3l-105 105 23.3 23.3z"
    ]
};
const $d8206b3ab2e65c05$export$e58f9b502d4dd52d = $d8206b3ab2e65c05$export$8282f5f5dcf6b009;
const $d8206b3ab2e65c05$export$c6406747800cf702 = {
    prefix: 'fas',
    iconName: 'dog',
    icon: [
        576,
        512,
        [
            128021
        ],
        "f6d3",
        "M309.6 158.5L332.7 19.8C334.6 8.4 344.5 0 356.1 0c7.5 0 14.5 3.5 19 9.5L392 32l52.1 0c12.7 0 24.9 5.1 33.9 14.1L496 64l56 0c13.3 0 24 10.7 24 24l0 24c0 44.2-35.8 80-80 80l-32 0-16 0-21.3 0-5.1 30.5-112-64zM416 256.1L416 480c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-115.2c-24 12.3-51.2 19.2-80 19.2s-56-6.9-80-19.2L160 480c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-230.2c-28.8-10.9-51.4-35.3-59.2-66.5L1 167.8c-4.3-17.1 6.1-34.5 23.3-38.8s34.5 6.1 38.8 23.3l3.9 15.5C70.5 182 83.3 192 98 192l30 0 16 0 159.8 0L416 256.1zM464 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
    ]
};
const $d8206b3ab2e65c05$export$28e93ec9f5e2ddf3 = {
    prefix: 'fas',
    iconName: 'carrot',
    icon: [
        512,
        512,
        [
            129365
        ],
        "f787",
        "M346.7 6C337.6 17 320 42.3 320 72c0 40 15.3 55.3 40 80s40 40 80 40c29.7 0 55-17.6 66-26.7c4-3.3 6-8.2 6-13.3s-2-10-6-13.2c-11.4-9.1-38.3-26.8-74-26.8c-32 0-40 8-40 8s8-8 8-40c0-35.7-17.7-62.6-26.8-74C370 2 365.1 0 360 0s-10 2-13.3 6zM244.6 136c-40 0-77.1 18.1-101.7 48.2l60.5 60.5c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-55.3-55.3 0 .1L2.2 477.9C-2 487-.1 497.8 7 505s17.9 9 27.1 4.8l134.7-62.4-52.1-52.1c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L199.7 433l100.2-46.4c46.4-21.5 76.2-68 76.2-119.2C376 194.8 317.2 136 244.6 136z"
    ]
};
const $d8206b3ab2e65c05$export$c4c2f69a53bab720 = {
    prefix: 'fas',
    iconName: 'moon',
    icon: [
        384,
        512,
        [
            127769,
            9214
        ],
        "f186",
        "M223.5 32C100 32 0 132.3 0 256S100 480 223.5 480c60.6 0 115.5-24.2 155.8-63.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6c-96.9 0-175.5-78.8-175.5-176c0-65.8 36-123.1 89.3-153.3c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.3-.5-12.6-.8-19-.8z"
    ]
};
const $d8206b3ab2e65c05$export$b86d7336e68a3f57 = {
    prefix: 'fas',
    iconName: 'wine-glass-empty',
    icon: [
        320,
        512,
        [
            "wine-glass-alt"
        ],
        "f5ce",
        "M64 0C47.4 0 33.5 12.8 32.1 29.3l-14 168.4c-6 72 42.5 135.2 109.9 150.6l0 99.6-48 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l80 0 80 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-48 0 0-99.6c67.4-15.4 115.9-78.6 109.9-150.6l-14-168.4C286.5 12.8 272.6 0 256 0L64 0zM81.9 203.1L93.4 64l133.1 0 11.6 139.1C242 248.8 205.9 288 160 288s-82-39.2-78.1-84.9z"
    ]
};
const $d8206b3ab2e65c05$export$b8ff3fe2b78aef2f = $d8206b3ab2e65c05$export$b86d7336e68a3f57;
const $d8206b3ab2e65c05$export$549b99473b7201e6 = {
    prefix: 'fas',
    iconName: 'cheese',
    icon: [
        512,
        512,
        [],
        "f7ef",
        "M512 240.2l0 15.8L0 256c0-20 10-38.7 26.6-49.8L274.9 40.7c8.6-5.7 18.6-8.7 28.9-8.7C418.8 32 512 125.2 512 240.2zm0 47.8l0 128c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 288l512 0z"
    ]
};
const $d8206b3ab2e65c05$export$6ec1acbf3f610b8f = {
    prefix: 'fas',
    iconName: 'yin-yang',
    icon: [
        512,
        512,
        [
            9775
        ],
        "f6ad",
        "M256 64c53 0 96 43 96 96s-43 96-96 96s-96 43-96 96s43 96 96 96C150 448 64 362 64 256S150 64 256 64zm0 448A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm32-352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
const $d8206b3ab2e65c05$export$fcb0647a5340b5b8 = {
    prefix: 'fas',
    iconName: 'music',
    icon: [
        512,
        512,
        [
            127925
        ],
        "f001",
        "M499.1 6.3c8.1 6 12.9 15.6 12.9 25.7l0 72 0 264c0 44.2-43 80-96 80s-96-35.8-96-80s43-80 96-80c11.2 0 22 1.6 32 4.6L448 147 192 223.8 192 432c0 44.2-43 80-96 80s-96-35.8-96-80s43-80 96-80c11.2 0 22 1.6 32 4.6L128 200l0-72c0-14.1 9.3-26.6 22.8-30.7l320-96c9.7-2.9 20.2-1.1 28.3 5z"
    ]
};
const $d8206b3ab2e65c05$export$d5d870c10bc9f1ce = {
    prefix: 'fas',
    iconName: 'code-commit',
    icon: [
        640,
        512,
        [],
        "f386",
        "M320 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm156.8-48C462 361 397.4 416 320 416s-142-55-156.8-128L32 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l131.2 0C178 151 242.6 96 320 96s142 55 156.8 128L608 224c17.7 0 32 14.3 32 32s-14.3 32-32 32l-131.2 0z"
    ]
};
const $d8206b3ab2e65c05$export$9e9af12b90a1abd2 = {
    prefix: 'fas',
    iconName: 'temperature-low',
    icon: [
        512,
        512,
        [],
        "f76b",
        "M448 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 96a96 96 0 1 1 192 0A96 96 0 1 1 320 96zM144 64c-26.5 0-48 21.5-48 48l0 164.5c0 17.3-7.1 31.9-15.3 42.5C70.2 332.6 64 349.5 64 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5L192 112c0-26.5-21.5-48-48-48zM32 112C32 50.2 82.1 0 144 0s112 50.1 112 112l0 164.4c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S0 447.5 0 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6L32 112zM192 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3l0-50.7c0-8.8 7.2-16 16-16s16 7.2 16 16l0 50.7c18.6 6.6 32 24.4 32 45.3z"
    ]
};
const $d8206b3ab2e65c05$export$cf152282d5de300d = {
    prefix: 'fas',
    iconName: 'person-biking',
    icon: [
        640,
        512,
        [
            128692,
            "biking"
        ],
        "f84a",
        "M400 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm27.2 64l-61.8-48.8c-17.3-13.6-41.7-13.8-59.1-.3l-83.1 64.2c-30.7 23.8-28.5 70.8 4.3 91.6L288 305.1 288 416c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128c0-10.7-5.3-20.7-14.2-26.6L295 232.9l60.3-48.5L396 217c5.7 4.5 12.7 7 20 7l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-52.8 0zM56 384a72 72 0 1 1 144 0A72 72 0 1 1 56 384zm200 0A128 128 0 1 0 0 384a128 128 0 1 0 256 0zm184 0a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zm200 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z"
    ]
};
const $d8206b3ab2e65c05$export$a5bcf835dbf9c0b = $d8206b3ab2e65c05$export$cf152282d5de300d;
const $d8206b3ab2e65c05$export$2a533051418ff4ca = {
    prefix: 'fas',
    iconName: 'broom',
    icon: [
        576,
        512,
        [
            129529
        ],
        "f51a",
        "M566.6 54.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192-34.7-34.7c-4.2-4.2-10-6.6-16-6.6c-12.5 0-22.6 10.1-22.6 22.6l0 29.1L364.3 320l29.1 0c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16l-34.7-34.7 192-192zM341.1 353.4L222.6 234.9c-42.7-3.7-85.2 11.7-115.8 42.3l-8 8C76.5 307.5 64 337.7 64 369.2c0 6.8 7.1 11.2 13.2 8.2l51.1-25.5c5-2.5 9.5 4.1 5.4 7.9L7.3 473.4C2.7 477.6 0 483.6 0 489.9C0 502.1 9.9 512 22.1 512l173.3 0c38.8 0 75.9-15.4 103.4-42.8c30.6-30.6 45.9-73.1 42.3-115.8z"
    ]
};
const $d8206b3ab2e65c05$export$7b96388ca2be471b = {
    prefix: 'fas',
    iconName: 'shield-heart',
    icon: [
        512,
        512,
        [],
        "e574",
        "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM144 221.3c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3z"
    ]
};
const $d8206b3ab2e65c05$export$31f89d8ac1d14ed6 = {
    prefix: 'fas',
    iconName: 'gopuram',
    icon: [
        512,
        512,
        [],
        "f664",
        "M120 0c13.3 0 24 10.7 24 24l0 8 40 0 0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8 48 0 0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8 40 0 0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8 0 32 0 64c17.7 0 32 14.3 32 32l0 64c17.7 0 32 14.3 32 32l0 96c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-64 0 0-160-32 0 0-128-32 0 0-96-32 0 0 96 32 0 0 128 32 0 0 160-80 0 0-48c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 48-80 0 0-160 32 0 0-128 32 0 0-96-32 0 0 96-32 0 0 128-32 0 0 160-64 0c-17.7 0-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32l0-96c0-17.7 14.3-32 32-32l0-64c0-17.7 14.3-32 32-32l0-64 0-32 0-8c0-13.3 10.7-24 24-24zM256 272c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-32-80l0 32 64 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
    ]
};
const $d8206b3ab2e65c05$export$bd931e906edf2f47 = {
    prefix: 'fas',
    iconName: 'earth-oceania',
    icon: [
        512,
        512,
        [
            "globe-oceania"
        ],
        "e47b",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208.6 357.3l-39-13.5c-6.5-2.2-13.6-2.3-20.1-.3l-15.3 4.9c-18.5 5.9-38.5-2.4-47.5-19.5l-3.3-6.2c-10.6-20.1-2.3-45 18.2-54.7l35.3-16.8c2.3-1.1 4.4-2.8 5.9-4.8l5.3-7c7.2-9.6 18.6-15.3 30.6-15.3s23.4 5.7 30.6 15.3l4.6 6.1c2 2.6 4.9 4.5 8.1 5.1c7.8 1.6 15.7-1.5 20.4-7.9l10.4-14.2c2-2.8 5.3-4.4 8.7-4.4c4.4 0 8.4 2.7 10 6.8l10.1 25.9c2.8 7.2 6.7 14 11.5 20.2L311 299.8c5.8 7.4 9 16.6 9 26s-3.2 18.6-9 26L299 367.2c-8.3 10.6-21 16.8-34.4 16.8c-8.4 0-16.6-2.4-23.7-7l-25.4-16.4c-2.2-1.4-4.5-2.5-6.9-3.4zm65.2-214.8L296 164.7c10.1 10.1 2.9 27.3-11.3 27.3l-29.9 0c-5.6 0-11.1-1.2-16.2-3.4l-42.8-19c-14.3-6.3-11.9-27.3 3.4-30.3l38.5-7.7c13.1-2.6 26.7 1.5 36.1 10.9zM248 432c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16zM431.2 298.9l8 24c2.8 8.4-1.7 17.4-10.1 20.2s-17.4-1.7-20.2-10.1l-8-24c-2.8-8.4 1.7-17.4 10.1-20.2s17.4 1.7 20.2 10.1zm-19.9 80.4l-32 32c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
const $d8206b3ab2e65c05$export$8ac3f5271448657d = $d8206b3ab2e65c05$export$bd931e906edf2f47;
const $d8206b3ab2e65c05$export$5a17e58bb7afb1d7 = {
    prefix: 'fas',
    iconName: 'square-xmark',
    icon: [
        448,
        512,
        [
            10062,
            "times-square",
            "xmark-square"
        ],
        "f2d3",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm79 143c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
const $d8206b3ab2e65c05$export$c0248ac97142ea2a = $d8206b3ab2e65c05$export$5a17e58bb7afb1d7;
const $d8206b3ab2e65c05$export$9a364781d6b7602b = $d8206b3ab2e65c05$export$5a17e58bb7afb1d7;
const $d8206b3ab2e65c05$export$c92c903bade56844 = {
    prefix: 'fas',
    iconName: 'hashtag',
    icon: [
        448,
        512,
        [
            62098
        ],
        "23",
        "M181.3 32.4c17.4 2.9 29.2 19.4 26.3 36.8L197.8 128l95.1 0 11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3s29.2 19.4 26.3 36.8L357.8 128l58.2 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-68.9 0L325.8 320l58.2 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-68.9 0-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l9.8-58.7-95.1 0-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8L90.2 384 32 384c-17.7 0-32-14.3-32-32s14.3-32 32-32l68.9 0 21.3-128L64 192c-17.7 0-32-14.3-32-32s14.3-32 32-32l68.9 0 11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3zM187.1 192L165.8 320l95.1 0 21.3-128-95.1 0z"
    ]
};
const $d8206b3ab2e65c05$export$95457ede07b81517 = {
    prefix: 'fas',
    iconName: 'up-right-and-down-left-from-center',
    icon: [
        512,
        512,
        [
            "expand-alt"
        ],
        "f424",
        "M344 0L488 0c13.3 0 24 10.7 24 24l0 144c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-87 87c-9.4 9.4-24.6 9.4-33.9 0l-32-32c-9.4-9.4-9.4-24.6 0-33.9l87-87L327 41c-6.9-6.9-8.9-17.2-5.2-26.2S334.3 0 344 0zM168 512L24 512c-13.3 0-24-10.7-24-24L0 344c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l39 39 87-87c9.4-9.4 24.6-9.4 33.9 0l32 32c9.4 9.4 9.4 24.6 0 33.9l-87 87 39 39c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8z"
    ]
};
const $d8206b3ab2e65c05$export$bcb8d86a3a1d6eb6 = $d8206b3ab2e65c05$export$95457ede07b81517;
const $d8206b3ab2e65c05$export$2599126c3a57f727 = {
    prefix: 'fas',
    iconName: 'oil-can',
    icon: [
        640,
        512,
        [],
        "f613",
        "M320 128c17.7 0 32-14.3 32-32s-14.3-32-32-32L192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 32-80 0-48 0-48 0c-26.5 0-48 21.5-48 48l0 64.8c0 19 11.2 36.2 28.5 43.9l67.5 30L96 368c0 26.5 21.5 48 48 48l259.1 0c18.4 0 35.8-7.9 48-21.7L633.5 187.7c12.3-13.9-.3-35.4-18.4-31.5L448 192l-50.5-25.2c-8.9-4.4-18.7-6.8-28.6-6.8L288 160l0-32 32 0zM96 208l0 86.1L48 272.8 48 208l48 0z"
    ]
};
const $d8206b3ab2e65c05$export$6e625d2e7790c860 = {
    prefix: 'fas',
    iconName: 't',
    icon: [
        384,
        512,
        [
            116
        ],
        "54",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l128 0 0 352c0 17.7 14.3 32 32 32s32-14.3 32-32l0-352 128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L192 32 32 32z"
    ]
};
const $d8206b3ab2e65c05$export$d4c909619093de2d = {
    prefix: 'fas',
    iconName: 'hippo',
    icon: [
        640,
        512,
        [
            129435
        ],
        "f6ed",
        "M407 47c9.4-9.4 24.6-9.4 33.9 0l17.2 17.2c1.9-.1 3.9-.2 5.8-.2l32 0c11.2 0 21.9 2.3 31.6 6.5L543 55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L564 101.9c7.6 12.2 12 26.7 12 42.1c0 10.2 7.4 18.8 16.7 23c27.9 12.5 47.3 40.5 47.3 73c0 26.2-12.6 49.4-32 64l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-16-64 0 0 16c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-17.6c-11.8-2.4-22.7-7.4-32-14.4c-1.5-1.1-2.9-2.3-4.3-3.5c-17-14.7-27.7-36.4-27.7-60.5c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 44.7 26.2 83.2 64 101.2l0 10.8c0 17.7 14.3 32 32 32l32 0 0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-76c-19.8 7.7-41.4 12-64 12s-44.2-4.3-64-12l0 76c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-118.9L45.9 369.7c-5.4 12.1-19.6 17.6-31.7 12.2S-3.3 362.4 2.1 350.3L24 300.9c5.3-11.9 8-24.7 8-37.7C32 155.7 117.2 68 223.8 64.1l.2-.1 7.2 0L256 64l32 0c41.7 0 83.4 12.1 117.2 25.7c1.7-1.8 3.5-3.6 5.3-5.2L407 81c-9.4-9.4-9.4-24.6 0-33.9zm73 185a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm88 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM480 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
const $d8206b3ab2e65c05$export$d01ddcc9efe7b149 = {
    prefix: 'fas',
    iconName: 'chart-column',
    icon: [
        512,
        512,
        [],
        "e0e3",
        "M32 32c17.7 0 32 14.3 32 32l0 336c0 8.8 7.2 16 16 16l400 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L80 480c-44.2 0-80-35.8-80-80L0 64C0 46.3 14.3 32 32 32zM160 224c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm128-64l0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-160c0-17.7 14.3-32 32-32s32 14.3 32 32zm64 32c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32zM480 96l0 224c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-224c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
const $d8206b3ab2e65c05$export$a590003279d671b8 = {
    prefix: 'fas',
    iconName: 'infinity',
    icon: [
        640,
        512,
        [
            8734,
            9854
        ],
        "f534",
        "M0 241.1C0 161 65 96 145.1 96c38.5 0 75.4 15.3 102.6 42.5L320 210.7l72.2-72.2C419.5 111.3 456.4 96 494.9 96C575 96 640 161 640 241.1l0 29.7C640 351 575 416 494.9 416c-38.5 0-75.4-15.3-102.6-42.5L320 301.3l-72.2 72.2C220.5 400.7 183.6 416 145.1 416C65 416 0 351 0 270.9l0-29.7zM274.7 256l-72.2-72.2c-15.2-15.2-35.9-23.8-57.4-23.8C100.3 160 64 196.3 64 241.1l0 29.7c0 44.8 36.3 81.1 81.1 81.1c21.5 0 42.2-8.5 57.4-23.8L274.7 256zm90.5 0l72.2 72.2c15.2 15.2 35.9 23.8 57.4 23.8c44.8 0 81.1-36.3 81.1-81.1l0-29.7c0-44.8-36.3-81.1-81.1-81.1c-21.5 0-42.2 8.5-57.4 23.8L365.3 256z"
    ]
};
const $d8206b3ab2e65c05$export$2db4f9712313eafa = {
    prefix: 'fas',
    iconName: 'vial-circle-check',
    icon: [
        512,
        512,
        [],
        "e596",
        "M0 64C0 46.3 14.3 32 32 32l64 0 64 0 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 170.8c-20.2 28.6-32 63.5-32 101.2c0 25.2 5.3 49.1 14.8 70.8C189.5 463.7 160.6 480 128 480c-53 0-96-43-96-96L32 96C14.3 96 0 81.7 0 64zM96 96l0 96 64 0 0-96L96 96zM224 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L352 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
    ]
};
const $d8206b3ab2e65c05$export$f9a5161975928326 = {
    prefix: 'fas',
    iconName: 'person-arrow-down-to-line',
    icon: [
        640,
        512,
        [],
        "e538",
        "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 352l0-96 16 0 0 96-16 0zm-64 0l-88 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l120 0 80 0 376 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-344 0 0-191.1 28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6l-29.7 0c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9 120 448zM464 64l0 242.7-25.4-25.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l80 80c12.5 12.5 32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L528 306.7 528 64c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
    ]
};
const $d8206b3ab2e65c05$export$4f1ce88b2b4cd5cd = {
    prefix: 'fas',
    iconName: 'voicemail',
    icon: [
        640,
        512,
        [],
        "f897",
        "M144 320a80 80 0 1 1 0-160 80 80 0 1 1 0 160zm119.8 0c15.3-22.9 24.2-50.4 24.2-80c0-79.5-64.5-144-144-144S0 160.5 0 240s64.5 144 144 144l352 0c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144c0 29.6 8.9 57.1 24.2 80l-112.5 0zM496 160a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
    ]
};
const $d8206b3ab2e65c05$export$55145a3dae4f984a = {
    prefix: 'fas',
    iconName: 'fan',
    icon: [
        512,
        512,
        [],
        "f863",
        "M258.6 0c-1.7 0-3.4 .1-5.1 .5C168 17 115.6 102.3 130.5 189.3c2.9 17 8.4 32.9 15.9 47.4L32 224l-2.6 0C13.2 224 0 237.2 0 253.4c0 1.7 .1 3.4 .5 5.1C17 344 102.3 396.4 189.3 381.5c17-2.9 32.9-8.4 47.4-15.9L224 480l0 2.6c0 16.2 13.2 29.4 29.4 29.4c1.7 0 3.4-.1 5.1-.5C344 495 396.4 409.7 381.5 322.7c-2.9-17-8.4-32.9-15.9-47.4L480 288l2.6 0c16.2 0 29.4-13.2 29.4-29.4c0-1.7-.1-3.4-.5-5.1C495 168 409.7 115.6 322.7 130.5c-17 2.9-32.9 8.4-47.4 15.9L288 32l0-2.6C288 13.2 274.8 0 258.6 0zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $d8206b3ab2e65c05$export$1ae0a37b36ace746 = {
    prefix: 'fas',
    iconName: 'person-walking-luggage',
    icon: [
        576,
        512,
        [],
        "e554",
        "M432 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM347.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L505 232.7l-15.3-36.8C472.5 154.8 432.3 128 387.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1l-25 62.4-59.4 59.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L340.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zM256 274.1c-7.7-4.4-17.4-1.8-21.9 5.9l-32 55.4L147.7 304c-15.3-8.8-34.9-3.6-43.7 11.7L40 426.6c-8.8 15.3-3.6 34.9 11.7 43.7l55.4 32c15.3 8.8 34.9 3.6 43.7-11.7l64-110.9c1.5-2.6 2.6-5.2 3.3-8L261.9 296c4.4-7.7 1.8-17.4-5.9-21.9z"
    ]
};
const $d8206b3ab2e65c05$export$e36c32dd5cba9b90 = {
    prefix: 'fas',
    iconName: 'up-down',
    icon: [
        256,
        512,
        [
            8597,
            11021,
            "arrows-alt-v"
        ],
        "f338",
        "M145.6 7.7C141 2.8 134.7 0 128 0s-13 2.8-17.6 7.7l-104 112c-6.5 7-8.2 17.2-4.4 25.9S14.5 160 24 160l56 0 0 192-56 0c-9.5 0-18.2 5.7-22 14.4s-2.1 18.9 4.4 25.9l104 112c4.5 4.9 10.9 7.7 17.6 7.7s13-2.8 17.6-7.7l104-112c6.5-7 8.2-17.2 4.4-25.9s-12.5-14.4-22-14.4l-56 0 0-192 56 0c9.5 0 18.2-5.7 22-14.4s2.1-18.9-4.4-25.9l-104-112z"
    ]
};
const $d8206b3ab2e65c05$export$138cb56a3f8f7040 = $d8206b3ab2e65c05$export$e36c32dd5cba9b90;
const $d8206b3ab2e65c05$export$301c3fab0c4545bd = {
    prefix: 'fas',
    iconName: 'cloud-moon-rain',
    icon: [
        576,
        512,
        [],
        "f73c",
        "M481.2 0C417 0 363.5 46.5 353.7 107.6c35.4 17.6 60.2 53.3 62.1 95.1c23.2 11 42 29.7 53.1 52.7c4 .4 8.1 .6 12.3 .6c34.9 0 66.7-13.8 89.9-36.1c5.1-4.9 6.4-12.5 3.2-18.7s-10.1-9.7-17-8.6c-4.9 .8-10 1.3-15.2 1.3c-49 0-88.4-39.3-88.4-87.4c0-32.6 18-61.1 44.9-76.1c6.1-3.4 9.3-10.5 7.8-17.4s-7.3-12-14.3-12.6c-3.6-.3-7.3-.5-10.9-.5zM367.9 383.9c44.2 0 80-35.8 80-80c0-39.3-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C241.3 114.6 210.8 96 176 96c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.6c0 53 43 96 96 96l271.9 0zM85.4 420.1c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3z"
    ]
};
const $d8206b3ab2e65c05$export$34f5c36a3e80efa2 = {
    prefix: 'fas',
    iconName: 'calendar',
    icon: [
        448,
        512,
        [
            128197,
            128198
        ],
        "f133",
        "M96 32l0 32L48 64C21.5 64 0 85.5 0 112l0 48 448 0 0-48c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192L0 192 0 464c0 26.5 21.5 48 48 48l352 0c26.5 0 48-21.5 48-48l0-272z"
    ]
};
const $d8206b3ab2e65c05$export$3a48b9820e92f5ab = {
    prefix: 'fas',
    iconName: 'trailer',
    icon: [
        640,
        512,
        [],
        "e041",
        "M48 32C21.5 32 0 53.5 0 80L0 336c0 26.5 21.5 48 48 48l17.1 0c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96L488 384l8 0 112 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-240c0-26.5-21.5-48-48-48L48 32zM80 96c8.8 0 16 7.2 16 16l0 131.2c-11.4 5.9-22.2 12.9-32 21L64 112c0-8.8 7.2-16 16-16zm96 128c-5.4 0-10.7 .2-16 .7L160 112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 112.7c-5.3-.5-10.6-.7-16-.7zm80 19.2L256 112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 152.2c-9.8-8.1-20.6-15.2-32-21zM368 96c8.8 0 16 7.2 16 16l0 192c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16zm112 16l0 192c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16s16 7.2 16 16zM176 480a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-112a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $d8206b3ab2e65c05$export$6d636565b3ec36b4 = {
    prefix: 'fas',
    iconName: 'bahai',
    icon: [
        576,
        512,
        [
            "haykal"
        ],
        "f666",
        "M288 0c14.5 0 27.2 9.7 30.9 23.8l23.9 89.6 75.9-53.3c11.9-8.3 27.8-7.6 39 1.7s14.6 24.9 8.4 38.1l-39.3 84 92.4 8c14.4 1.2 26.2 12 28.8 26.3s-4.9 28.5-18 34.6l-84.1 39.1 65.7 65.5c10.3 10.2 12.4 26.1 5.1 38.7s-22 18.7-36 14.9L391 386.8l8.2 92.4c1.3 14.4-7.3 27.9-20.9 32.9s-28.9 .1-37.2-11.7l-53.1-76-53.1 76c-8.3 11.9-23.6 16.7-37.2 11.7s-22.2-18.5-20.9-32.9l8.2-92.4L95.4 410.9c-14 3.8-28.8-2.3-36-14.9s-5.2-28.4 5.1-38.7l65.7-65.5L46 252.7c-13.1-6.1-20.5-20.3-18-34.6s14.3-25.1 28.8-26.3l92.4-8-39.3-84c-6.1-13.1-2.7-28.8 8.4-38.1s27.1-10 39-1.7l75.9 53.3 23.9-89.6C260.8 9.7 273.5 0 288 0zm0 156.2l-4.8 18c-2.7 10.1-10.2 18.2-20 21.8s-20.8 2.1-29.3-3.9l-15.2-10.7 7.9 16.8c4.4 9.5 4 20.5-1.3 29.6s-14.5 15-25 15.9l-18.5 1.6 16.8 7.8c9.5 4.4 16.2 13.2 18 23.5s-1.5 20.8-8.9 28.2l-13.2 13.1 17.9-4.8c10.1-2.7 20.9-.3 28.9 6.4s12.2 16.9 11.3 27.3l-1.6 18.5 10.6-15.2c6-8.6 15.8-13.7 26.2-13.7s20.2 5.1 26.2 13.7l10.6 15.2-1.6-18.5c-.9-10.4 3.3-20.6 11.3-27.3s18.8-9.1 28.9-6.4l17.9 4.8-13.2-13.1c-7.4-7.4-10.7-17.9-8.9-28.2s8.5-19.1 18-23.5l16.8-7.8-18.5-1.6c-10.4-.9-19.7-6.8-25-15.9s-5.7-20.1-1.3-29.6l7.9-16.8-15.2 10.7c-8.6 6-19.5 7.5-29.3 3.9s-17.3-11.7-20-21.8l-4.8-18z"
    ]
};
const $d8206b3ab2e65c05$export$5c15e34e0e43f15c = $d8206b3ab2e65c05$export$6d636565b3ec36b4;
const $d8206b3ab2e65c05$export$303efb6031da122 = {
    prefix: 'fas',
    iconName: 'sd-card',
    icon: [
        384,
        512,
        [],
        "f7c2",
        "M320 0L141.3 0C124.3 0 108 6.7 96 18.7L18.7 96C6.7 108 0 124.3 0 141.3L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64zM160 88l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24s24 10.7 24 24zm80 0l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24s24 10.7 24 24zm80 0l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
const $d8206b3ab2e65c05$export$ae1875ba975aa0e9 = {
    prefix: 'fas',
    iconName: 'dragon',
    icon: [
        640,
        512,
        [
            128009
        ],
        "f6d5",
        "M352 124.5l-51.9-13c-6.5-1.6-11.3-7.1-12-13.8s2.8-13.1 8.7-16.1l40.8-20.4L294.4 28.8c-5.5-4.1-7.8-11.3-5.6-17.9S297.1 0 304 0L416 0l32 0 16 0c30.2 0 58.7 14.2 76.8 38.4l57.6 76.8c6.2 8.3 9.6 18.4 9.6 28.8c0 26.5-21.5 48-48 48l-21.5 0c-17 0-33.3-6.7-45.3-18.7L480 160l-32 0 0 21.5c0 24.8 12.8 47.9 33.8 61.1l106.6 66.6c32.1 20.1 51.6 55.2 51.6 93.1C640 462.9 590.9 512 530.2 512L496 512l-64 0L32.3 512c-3.3 0-6.6-.4-9.6-1.4C13.5 507.8 6 501 2.4 492.1C1 488.7 .2 485.2 0 481.4c-.2-3.7 .3-7.3 1.3-10.7c2.8-9.2 9.6-16.7 18.6-20.4c3-1.2 6.2-2 9.5-2.2L433.3 412c8.3-.7 14.7-7.7 14.7-16.1c0-4.3-1.7-8.4-4.7-11.4l-44.4-44.4c-30-30-46.9-70.7-46.9-113.1l0-45.5 0-57zM512 72.3c0-.1 0-.2 0-.3s0-.2 0-.3l0 .6zm-1.3 7.4L464.3 68.1c-.2 1.3-.3 2.6-.3 3.9c0 13.3 10.7 24 24 24c10.6 0 19.5-6.8 22.7-16.3zM130.9 116.5c16.3-14.5 40.4-16.2 58.5-4.1l130.6 87 0 27.5c0 32.8 8.4 64.8 24 93l-232 0c-6.7 0-12.7-4.2-15-10.4s-.5-13.3 4.6-17.7L171 232.3 18.4 255.8c-7 1.1-13.9-2.6-16.9-9s-1.5-14.1 3.8-18.8L130.9 116.5z"
    ]
};
const $d8206b3ab2e65c05$export$cdbdd2118099ae07 = {
    prefix: 'fas',
    iconName: 'shoe-prints',
    icon: [
        640,
        512,
        [],
        "f54b",
        "M416 0C352.3 0 256 32 256 32l0 128c48 0 76 16 104 32s56 32 104 32c56.4 0 176-16 176-96S512 0 416 0zM128 96c0 35.3 28.7 64 64 64l32 0 0-128-32 0c-35.3 0-64 28.7-64 64zM288 512c96 0 224-48 224-128s-119.6-96-176-96c-48 0-76 16-104 32s-56 32-104 32l0 128s96.3 32 160 32zM0 416c0 35.3 28.7 64 64 64l32 0 0-128-32 0c-35.3 0-64 28.7-64 64z"
    ]
};
const $d8206b3ab2e65c05$export$eeda28b8ca4cb18e = {
    prefix: 'fas',
    iconName: 'circle-plus',
    icon: [
        512,
        512,
        [
            "plus-circle"
        ],
        "f055",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 344l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
    ]
};
const $d8206b3ab2e65c05$export$d9cc3a81499af48c = $d8206b3ab2e65c05$export$eeda28b8ca4cb18e;
const $d8206b3ab2e65c05$export$4272e56f2429da88 = {
    prefix: 'fas',
    iconName: 'face-grin-tongue-wink',
    icon: [
        512,
        512,
        [
            128540,
            "grin-tongue-wink"
        ],
        "f58b",
        "M174.5 498.8C73.1 464.7 0 368.9 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 112.9-73.1 208.7-174.5 242.8C346.7 484 352 466.6 352 448l0-46.9c24.3-17.5 43.6-41.6 55.4-69.6c5-11.8-7-22.5-19.3-18.7c-39.7 12.2-84.5 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7c11.7 27.8 30.8 51.7 54.8 69.2l0 47.3c0 18.6 5.3 36 14.5 50.8zm20.7-265.2c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zM336 272a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM320 402.6l0 45.4c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-45.4c0-14.7 11.9-26.6 26.6-26.6l2 0c11.3 0 21.1 7.9 23.6 18.9c2.8 12.6 20.8 12.6 23.6 0c2.5-11.1 12.3-18.9 23.6-18.9l2 0c14.7 0 26.6 11.9 26.6 26.6zM336 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
const $d8206b3ab2e65c05$export$58099903d50aefb3 = $d8206b3ab2e65c05$export$4272e56f2429da88;
const $d8206b3ab2e65c05$export$e6094d25274088ab = {
    prefix: 'fas',
    iconName: 'hand-holding',
    icon: [
        576,
        512,
        [],
        "f4bd",
        "M559.7 392.2c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416 272 416c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0-16 0-78.3 0c-29.1 0-57.3 9.9-80 28L68.8 384 32 384c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l160 0 160.5 0c29 0 57.3-9.3 80.7-26.5l126.6-93.3zm-367-8.2c.3 0 .6 0 .9 0c0 0 0 0 0 0c-.3 0-.6 0-.9 0z"
    ]
};
const $d8206b3ab2e65c05$export$d893dd9509763a17 = {
    prefix: 'fas',
    iconName: 'plug-circle-exclamation',
    icon: [
        576,
        512,
        [],
        "e55d",
        "M96 0C78.3 0 64 14.3 64 32l0 96 64 0 0-96c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32l0 96 64 0 0-96c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 32c0 77.4 55 142 128 156.8l0 67.2c0 17.7 14.3 32 32 32s32-14.3 32-32l0-67.2c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32L32 160zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16z"
    ]
};
const $d8206b3ab2e65c05$export$22965c7f4d903953 = {
    prefix: 'fas',
    iconName: 'link-slash',
    icon: [
        640,
        512,
        [
            "chain-broken",
            "chain-slash",
            "unlink"
        ],
        "f127",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L489.3 358.2l90.5-90.5c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114l-96 96-31.9-25C430.9 239.6 420.1 175.1 377 132c-52.2-52.3-134.5-56.2-191.3-11.7L38.8 5.1zM239 162c30.1-14.9 67.7-9.9 92.8 15.3c20 20 27.5 48.3 21.7 74.5L239 162zM406.6 416.4L220.9 270c-2.1 39.8 12.2 80.1 42.2 110c38.9 38.9 94.4 51 143.6 36.3zm-290-228.5L60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5l61.8-61.8-50.6-39.9z"
    ]
};
const $d8206b3ab2e65c05$export$382551e04f32620a = $d8206b3ab2e65c05$export$22965c7f4d903953;
const $d8206b3ab2e65c05$export$12f09d657be59586 = $d8206b3ab2e65c05$export$22965c7f4d903953;
const $d8206b3ab2e65c05$export$2f546f7d8ba01e18 = $d8206b3ab2e65c05$export$22965c7f4d903953;
const $d8206b3ab2e65c05$export$76c1aa4bf9a39458 = {
    prefix: 'fas',
    iconName: 'clone',
    icon: [
        512,
        512,
        [],
        "f24d",
        "M288 448L64 448l0-224 64 0 0-64-64 0c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-64-64 0 0 64zm-64-96l224 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L224 0c-35.3 0-64 28.7-64 64l0 224c0 35.3 28.7 64 64 64z"
    ]
};
const $d8206b3ab2e65c05$export$5a200e8504b7367a = {
    prefix: 'fas',
    iconName: 'person-walking-arrow-loop-left',
    icon: [
        640,
        512,
        [],
        "e551",
        "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM123.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8C248.5 154.8 208.3 128 163.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1L68.7 398 9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L116.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zm347.7 119c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L461.3 384l18.7 0c88.4 0 160-71.6 160-160s-71.6-160-160-160L352 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c53 0 96 43 96 96s-43 96-96 96l-18.7 0 25.4-25.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3l80 80z"
    ]
};
const $d8206b3ab2e65c05$export$a0a53d8e3c68e9f1 = {
    prefix: 'fas',
    iconName: 'arrow-up-z-a',
    icon: [
        576,
        512,
        [
            "sort-alpha-up-alt"
        ],
        "f882",
        "M183.6 42.4C177.5 35.8 169 32 160 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L128 146.3 128 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-301.7 32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 64c0 17.7 14.3 32 32 32l50.7 0-73.4 73.4c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-50.7 0 73.4-73.4c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L352 32c-17.7 0-32 14.3-32 32zm96 192c-12.1 0-23.2 6.8-28.6 17.7l-64 128-16 32c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l7.2-14.3 88.4 0 7.2 14.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9l-16-32-64-128C439.2 262.8 428.1 256 416 256zM395.8 400L416 359.6 436.2 400l-40.4 0z"
    ]
};
const $d8206b3ab2e65c05$export$95ef20828693fb0f = $d8206b3ab2e65c05$export$a0a53d8e3c68e9f1;
const $d8206b3ab2e65c05$export$769724fc1434d618 = {
    prefix: 'fas',
    iconName: 'fire-flame-curved',
    icon: [
        384,
        512,
        [
            "fire-alt"
        ],
        "f7e4",
        "M153.6 29.9l16-21.3C173.6 3.2 180 0 186.7 0C198.4 0 208 9.6 208 21.3V43.5c0 13.1 5.4 25.7 14.9 34.7L307.6 159C356.4 205.6 384 270.2 384 337.7C384 434 306 512 209.7 512H192C86 512 0 426 0 320v-3.8c0-48.8 19.4-95.6 53.9-130.1l3.5-3.5c4.2-4.2 10-6.6 16-6.6C85.9 176 96 186.1 96 198.6V288c0 35.3 28.7 64 64 64s64-28.7 64-64v-3.9c0-18-7.2-35.3-19.9-48l-38.6-38.6c-24-24-37.5-56.7-37.5-90.7c0-27.7 9-54.8 25.6-76.9z"
    ]
};
const $d8206b3ab2e65c05$export$70dc26b4926d0b1b = $d8206b3ab2e65c05$export$769724fc1434d618;
const $d8206b3ab2e65c05$export$6d274258ba4b0089 = {
    prefix: 'fas',
    iconName: 'tornado',
    icon: [
        448,
        512,
        [
            127786
        ],
        "f76f",
        "M0 32L0 45.6C0 62.7 1.7 79.6 5 96l352.8 0c3.2-6.9 7.5-13.3 13-18.8l38.6-38.6c4.2-4.2 6.6-10 6.6-16C416 10.1 405.9 0 393.4 0L32 0C14.3 0 0 14.3 0 32zm352.2 96L13.6 128c12.2 35.9 32.3 68.7 58.8 96L412 224l-47.2-62.9c-7.3-9.7-11.6-21.2-12.6-33.1zm-226 138.2l116.4 68.5c8.2 4.8 15.8 10.7 22.5 17.3L445 352c2-9.8 3-19.9 3-30.1c0-23-5.3-45.5-15.3-65.9l-322.5 0c5.2 3.6 10.5 7 16 10.2zM288 384c10.3 21.4 13.8 45.5 9.9 69l-5.9 35.7c-2 12.2 7.4 23.4 19.8 23.4c5.3 0 10.4-2.1 14.2-5.9l78.2-78.2c12.8-12.8 23.1-27.7 30.4-43.9L288 384z"
    ]
};
const $d8206b3ab2e65c05$export$430d63b54b1d4009 = {
    prefix: 'fas',
    iconName: 'file-circle-plus',
    icon: [
        576,
        512,
        [
            58606
        ],
        "e494",
        "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48z"
    ]
};
const $d8206b3ab2e65c05$export$ad3212bc3fa1595b = {
    prefix: 'fas',
    iconName: 'book-quran',
    icon: [
        448,
        512,
        [
            "quran"
        ],
        "f687",
        "M352 0c53 0 96 43 96 96l0 320c0 53-43 96-96 96L64 512l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l0-64c-17.7 0-32-14.3-32-32L0 32C0 14.3 14.3 0 32 0L64 0 352 0zm0 384L96 384l0 64 256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32zM274.1 150.2l-8.9 21.4-23.1 1.9c-5.7 .5-8 7.5-3.7 11.2L256 199.8l-5.4 22.6c-1.3 5.5 4.7 9.9 9.6 6.9L280 217.2l19.8 12.1c4.9 3 10.9-1.4 9.6-6.9L304 199.8l17.6-15.1c4.3-3.7 2-10.8-3.7-11.2l-23.1-1.9-8.9-21.4c-2.2-5.3-9.6-5.3-11.8 0zM96 192c0 70.7 57.3 128 128 128c25.6 0 49.5-7.5 69.5-20.5c3.2-2.1 4.5-6.2 3.1-9.7s-5.2-5.6-9-4.8c-6.1 1.2-12.5 1.9-19 1.9c-52.4 0-94.9-42.5-94.9-94.9s42.5-94.9 94.9-94.9c6.5 0 12.8 .7 19 1.9c3.8 .8 7.5-1.3 9-4.8s.2-7.6-3.1-9.7C273.5 71.5 249.6 64 224 64C153.3 64 96 121.3 96 192z"
    ]
};
const $d8206b3ab2e65c05$export$46f29ea84ed4c5f1 = $d8206b3ab2e65c05$export$ad3212bc3fa1595b;
const $d8206b3ab2e65c05$export$12a35719f889cd1 = {
    prefix: 'fas',
    iconName: 'anchor',
    icon: [
        576,
        512,
        [
            9875
        ],
        "f13d",
        "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80L224 176c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 208-48 0c-53 0-96-43-96-96l0-6.1 7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7 0 6.1c0 88.4 71.6 160 160 160l80 0 80 0c88.4 0 160-71.6 160-160l0-6.1 7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-56-56c-9.4-9.4-24.6-9.4-33.9 0l-56 56c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7 0 6.1c0 53-43 96-96 96l-48 0 0-208 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-10.9 0z"
    ]
};
const $d8206b3ab2e65c05$export$93a5eb721c9c0d25 = {
    prefix: 'fas',
    iconName: 'border-all',
    icon: [
        448,
        512,
        [],
        "f84c",
        "M384 96l0 128-128 0 0-128 128 0zm0 192l0 128-128 0 0-128 128 0zM192 224L64 224 64 96l128 0 0 128zM64 288l128 0 0 128L64 416l0-128zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z"
    ]
};
const $d8206b3ab2e65c05$export$67a047c738fb34da = {
    prefix: 'fas',
    iconName: 'face-angry',
    icon: [
        512,
        512,
        [
            128544,
            "angry"
        ],
        "f556",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM338.7 395.9c6.6-5.9 7.1-16 1.2-22.6C323.8 355.4 295.7 336 256 336s-67.8 19.4-83.9 37.3c-5.9 6.6-5.4 16.7 1.2 22.6s16.7 5.4 22.6-1.2c11.7-13 31.6-26.7 60.1-26.7s48.4 13.7 60.1 26.7c5.9 6.6 16 7.1 22.6 1.2zM176.4 272c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32z"
    ]
};
const $d8206b3ab2e65c05$export$3c96c08e234498c5 = $d8206b3ab2e65c05$export$67a047c738fb34da;
const $d8206b3ab2e65c05$export$317dde8664f7de71 = {
    prefix: 'fas',
    iconName: 'cookie-bite',
    icon: [
        512,
        512,
        [],
        "f564",
        "M257.5 27.6c-.8-5.4-4.9-9.8-10.3-10.6c-22.1-3.1-44.6 .9-64.4 11.4l-74 39.5C89.1 78.4 73.2 94.9 63.4 115L26.7 190.6c-9.8 20.1-13 42.9-9.1 64.9l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c22.1 3.1 44.6-.9 64.4-11.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c9.8-20.1 13-42.9 9.1-64.9c-.9-5.3-5.3-9.3-10.6-10.1c-51.5-8.2-92.8-47.1-104.5-97.4c-1.8-7.6-8-13.4-15.7-14.6c-54.6-8.7-97.7-52-106.2-106.8zM208 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM144 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $d8206b3ab2e65c05$export$d2caed5e37174c23 = {
    prefix: 'fas',
    iconName: 'arrow-trend-down',
    icon: [
        576,
        512,
        [],
        "e097",
        "M384 352c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-160c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 82.7L342.6 137.4c-12.5-12.5-32.8-12.5-45.3 0L192 242.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0L320 205.3 466.7 352 384 352z"
    ]
};
const $d8206b3ab2e65c05$export$7329a1ca27b90c5b = {
    prefix: 'fas',
    iconName: 'rss',
    icon: [
        448,
        512,
        [
            "feed"
        ],
        "f09e",
        "M0 64C0 46.3 14.3 32 32 32c229.8 0 416 186.2 416 416c0 17.7-14.3 32-32 32s-32-14.3-32-32C384 253.6 226.4 96 32 96C14.3 96 0 81.7 0 64zM0 416a64 64 0 1 1 128 0A64 64 0 1 1 0 416zM32 160c159.1 0 288 128.9 288 288c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-123.7-100.3-224-224-224c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
const $d8206b3ab2e65c05$export$67ad3d0233cd7b33 = $d8206b3ab2e65c05$export$7329a1ca27b90c5b;
const $d8206b3ab2e65c05$export$df9bd3777d1154d2 = {
    prefix: 'fas',
    iconName: 'draw-polygon',
    icon: [
        448,
        512,
        [],
        "f5ee",
        "M96 151.4l0 209.1c9.7 5.6 17.8 13.7 23.4 23.4l209.1 0c0-.1 .1-.2 .1-.3l-4.5-7.9-32-56s0 0 0 0c-1.4 .1-2.8 .1-4.2 .1c-35.3 0-64-28.7-64-64s28.7-64 64-64c1.4 0 2.8 0 4.2 .1c0 0 0 0 0 0l32-56 4.5-7.9-.1-.3-209.1 0c-5.6 9.7-13.7 17.8-23.4 23.4zM384.3 352c35.2 .2 63.7 28.7 63.7 64c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32l-209.1 0c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4l0-209.1C12.9 140.4 0 119.7 0 96C0 60.7 28.7 32 64 32c23.7 0 44.4 12.9 55.4 32l209.1 0c11.1-19.1 31.7-32 55.4-32c35.3 0 64 28.7 64 64c0 35.3-28.5 63.8-63.7 64l-4.5 7.9-32 56-2.3 4c4.2 8.5 6.5 18 6.5 28.1s-2.3 19.6-6.5 28.1l2.3 4 32 56 4.5 7.9z"
    ]
};
const $d8206b3ab2e65c05$export$33fb4280dc20f0dd = {
    prefix: 'fas',
    iconName: 'scale-balanced',
    icon: [
        640,
        512,
        [
            9878,
            "balance-scale"
        ],
        "f24e",
        "M384 32l128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L398.4 96c-5.2 25.8-22.9 47.1-46.4 57.3L352 448l160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0-192 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0 0-294.7c-23.5-10.3-41.2-31.6-46.4-57.3L128 96c-17.7 0-32-14.3-32-32s14.3-32 32-32l128 0c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32zm55.6 288l144.9 0L512 195.8 439.6 320zM512 416c-62.9 0-115.2-34-126-78.9c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1C627.2 382 574.9 416 512 416zM126.8 195.8L54.4 320l144.9 0L126.8 195.8zM.9 337.1c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1C242 382 189.7 416 126.8 416S11.7 382 .9 337.1z"
    ]
};
const $d8206b3ab2e65c05$export$fec323dcfd81d750 = $d8206b3ab2e65c05$export$33fb4280dc20f0dd;
const $d8206b3ab2e65c05$export$cc4351eb13da27d8 = {
    prefix: 'fas',
    iconName: 'gauge-simple-high',
    icon: [
        512,
        512,
        [
            61668,
            "tachometer",
            "tachometer-fast"
        ],
        "f62a",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-15.9-5.8-30.4-15.3-41.6l76.6-147.4c6.1-11.8 1.5-26.3-10.2-32.4s-26.2-1.5-32.4 10.2L262.1 288.3c-2-.2-4-.3-6.1-.3c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64z"
    ]
};
const $d8206b3ab2e65c05$export$362d0f652c3fbca2 = $d8206b3ab2e65c05$export$cc4351eb13da27d8;
const $d8206b3ab2e65c05$export$375b6a8680f980ed = $d8206b3ab2e65c05$export$cc4351eb13da27d8;
const $d8206b3ab2e65c05$export$f7f7c15f18cc19a1 = {
    prefix: 'fas',
    iconName: 'shower',
    icon: [
        512,
        512,
        [
            128703
        ],
        "f2cc",
        "M64 131.9C64 112.1 80.1 96 99.9 96c9.5 0 18.6 3.8 25.4 10.5l16.2 16.2c-21 38.9-17.4 87.5 10.9 123L151 247c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L345 121c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-1.3 1.3c-35.5-28.3-84.2-31.9-123-10.9L170.5 61.3C151.8 42.5 126.4 32 99.9 32C44.7 32 0 76.7 0 131.9L0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-316.1zM256 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm32-32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
const $d8206b3ab2e65c05$export$6e6ddc253102e596 = {
    prefix: 'fas',
    iconName: 'desktop',
    icon: [
        576,
        512,
        [
            128421,
            61704,
            "desktop-alt"
        ],
        "f390",
        "M64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l176 0-10.7 32L160 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-69.3 0L336 416l176 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0zM512 64l0 224L64 288 64 64l448 0z"
    ]
};
const $d8206b3ab2e65c05$export$ff09a62b9e0fa899 = $d8206b3ab2e65c05$export$6e6ddc253102e596;
const $d8206b3ab2e65c05$export$bd6a7788954842b5 = {
    prefix: 'fas',
    iconName: 'm',
    icon: [
        448,
        512,
        [
            109
        ],
        "4d",
        "M22.7 33.4c13.5-4.1 28.1 1.1 35.9 12.9L224 294.3 389.4 46.3c7.8-11.7 22.4-17 35.9-12.9S448 49.9 448 64l0 384c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-278.3L250.6 369.8c-5.9 8.9-15.9 14.2-26.6 14.2s-20.7-5.3-26.6-14.2L64 169.7 64 448c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 64C0 49.9 9.2 37.5 22.7 33.4z"
    ]
};
const $d8206b3ab2e65c05$export$6e989c3c7050dbb = {
    prefix: 'fas',
    iconName: 'table-list',
    icon: [
        512,
        512,
        [
            "th-list"
        ],
        "f00b",
        "M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm64 0l0 64 64 0 0-64L64 96zm384 0L192 96l0 64 256 0 0-64zM64 224l0 64 64 0 0-64-64 0zm384 0l-256 0 0 64 256 0 0-64zM64 352l0 64 64 0 0-64-64 0zm384 0l-256 0 0 64 256 0 0-64z"
    ]
};
const $d8206b3ab2e65c05$export$daf2614a457122c0 = $d8206b3ab2e65c05$export$6e989c3c7050dbb;
const $d8206b3ab2e65c05$export$435fe17e9d6170d6 = {
    prefix: 'fas',
    iconName: 'comment-sms',
    icon: [
        512,
        512,
        [
            "sms"
        ],
        "f7cd",
        "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM96 212.8c0-20.3 16.5-36.8 36.8-36.8l19.2 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-19.2 0c-2.7 0-4.8 2.2-4.8 4.8c0 1.6 .8 3.1 2.2 4l29.4 19.6c10.3 6.8 16.4 18.3 16.4 30.7c0 20.3-16.5 36.8-36.8 36.8L112 304c-8.8 0-16-7.2-16-16s7.2-16 16-16l27.2 0c2.7 0 4.8-2.2 4.8-4.8c0-1.6-.8-3.1-2.2-4l-29.4-19.6C102.2 236.7 96 225.2 96 212.8zM372.8 176l19.2 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-19.2 0c-2.7 0-4.8 2.2-4.8 4.8c0 1.6 .8 3.1 2.2 4l29.4 19.6c10.2 6.8 16.4 18.3 16.4 30.7c0 20.3-16.5 36.8-36.8 36.8L352 304c-8.8 0-16-7.2-16-16s7.2-16 16-16l27.2 0c2.7 0 4.8-2.2 4.8-4.8c0-1.6-.8-3.1-2.2-4l-29.4-19.6c-10.2-6.8-16.4-18.3-16.4-30.7c0-20.3 16.5-36.8 36.8-36.8zm-152 6.4L256 229.3l35.2-46.9c4.1-5.5 11.3-7.8 17.9-5.6s10.9 8.3 10.9 15.2l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-19.2 25.6c-3 4-7.8 6.4-12.8 6.4s-9.8-2.4-12.8-6.4L224 240l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-6.9 4.4-13 10.9-15.2s13.7 .1 17.9 5.6z"
    ]
};
const $d8206b3ab2e65c05$export$9dbcc3443daa7323 = $d8206b3ab2e65c05$export$435fe17e9d6170d6;
const $d8206b3ab2e65c05$export$c9d7ef726d1a8742 = {
    prefix: 'fas',
    iconName: 'book',
    icon: [
        448,
        512,
        [
            128212
        ],
        "f02d",
        "M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-64c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L384 0 96 0zm0 384l256 0 0 64L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32zm32-240c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16zm16 48l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
const $d8206b3ab2e65c05$export$4c17261776a709f2 = {
    prefix: 'fas',
    iconName: 'user-plus',
    icon: [
        640,
        512,
        [],
        "f234",
        "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3zM504 312l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
    ]
};
const $d8206b3ab2e65c05$export$62b2c752fccc6a9c = {
    prefix: 'fas',
    iconName: 'check',
    icon: [
        448,
        512,
        [
            10003,
            10004
        ],
        "f00c",
        "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"
    ]
};
const $d8206b3ab2e65c05$export$cfb37069d38f379e = {
    prefix: 'fas',
    iconName: 'battery-three-quarters',
    icon: [
        576,
        512,
        [
            "battery-4"
        ],
        "f241",
        "M464 160c8.8 0 16 7.2 16 16l0 160c0 8.8-7.2 16-16 16L80 352c-8.8 0-16-7.2-16-16l0-160c0-8.8 7.2-16 16-16l384 0zM80 96C35.8 96 0 131.8 0 176L0 336c0 44.2 35.8 80 80 80l384 0c44.2 0 80-35.8 80-80l0-16c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l0-16c0-44.2-35.8-80-80-80L80 96zm272 96L96 192l0 128 256 0 0-128z"
    ]
};
const $d8206b3ab2e65c05$export$35ffefed200d123c = $d8206b3ab2e65c05$export$cfb37069d38f379e;
const $d8206b3ab2e65c05$export$c9382fa3394ef53a = {
    prefix: 'fas',
    iconName: 'house-circle-check',
    icon: [
        640,
        512,
        [],
        "e509",
        "M320.7 352c8.1-89.7 83.5-160 175.3-160c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1l32 0 0 69.7c-.1 .9-.1 1.8-.1 2.8l0 112c0 22.1 17.9 40 40 40l16 0c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2l31.9 0 24 0c22.1 0 40-17.9 40-40l0-24 0-64c0-17.7 14.3-32 32-32l64 0 .7 0zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
const $d8206b3ab2e65c05$export$3cbcd1b7e35945d2 = {
    prefix: 'fas',
    iconName: 'angle-left',
    icon: [
        320,
        512,
        [
            8249
        ],
        "f104",
        "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"
    ]
};
const $d8206b3ab2e65c05$export$ff7f40159cadb0ac = {
    prefix: 'fas',
    iconName: 'diagram-successor',
    icon: [
        512,
        512,
        [],
        "e47a",
        "M512 416l0-64c0-35.3-28.7-64-64-64L64 288c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64zM64 160l0-64 144 0 16 0 0 64L64 160zm224 0l0-64 80 0c8.8 0 16 7.2 16 16l0 16-38.1 0c-21.4 0-32.1 25.9-17 41L399 239c9.4 9.4 24.6 9.4 33.9 0L503 169c15.1-15.1 4.4-41-17-41L448 128l0-16c0-44.2-35.8-80-80-80L224 32l-16 0L64 32C28.7 32 0 60.7 0 96l0 64c0 35.3 28.7 64 64 64l160 0c35.3 0 64-28.7 64-64z"
    ]
};
const $d8206b3ab2e65c05$export$d69fa2b7839ce76 = {
    prefix: 'fas',
    iconName: 'truck-arrow-right',
    icon: [
        640,
        512,
        [],
        "e58b",
        "M0 48C0 21.5 21.5 0 48 0L368 0c26.5 0 48 21.5 48 48l0 48 50.7 0c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3l0 18.7 0 32 0 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c0 53-43 96-96 96s-96-43-96-96l-128 0c0 53-43 96-96 96s-96-43-96-96l-16 0c-26.5 0-48-21.5-48-48L0 48zM416 256l128 0 0-18.7L466.7 160 416 160l0 96zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM257 95c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39L96 168c-13.3 0-24 10.7-24 24s10.7 24 24 24l166.1 0-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9L257 95z"
    ]
};
const $d8206b3ab2e65c05$export$7df274119d2469d1 = {
    prefix: 'fas',
    iconName: 'arrows-split-up-and-left',
    icon: [
        512,
        512,
        [],
        "e4bc",
        "M246.6 150.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L352 109.3 352 384c0 35.3 28.7 64 64 64l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-70.7 0-128-57.3-128-128c0-35.3-28.7-64-64-64l-114.7 0 41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L109.3 256 224 256c23.3 0 45.2 6.2 64 17.1l0-163.9-41.4 41.4z"
    ]
};
const $d8206b3ab2e65c05$export$ca492f58fe30a42f = {
    prefix: 'fas',
    iconName: 'hand-fist',
    icon: [
        448,
        512,
        [
            9994,
            "fist-raised"
        ],
        "f6de",
        "M192 0c17.7 0 32 14.3 32 32l0 112-64 0 0-112c0-17.7 14.3-32 32-32zM64 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 80-64 0 0-80zm192 0c0-17.7 14.3-32 32-32s32 14.3 32 32l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96zm96 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64zm-96 88l0-.6c9.4 5.4 20.3 8.6 32 8.6c13.2 0 25.4-4 35.6-10.8c8.7 24.9 32.5 42.8 60.4 42.8c11.7 0 22.6-3.1 32-8.6l0 8.6c0 52.3-25.1 98.8-64 128l0 96c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-78.4c-17.3-7.9-33.2-18.8-46.9-32.5L69.5 357.5C45.5 333.5 32 300.9 32 267l0-27c0-35.3 28.7-64 64-64l88 0c22.1 0 40 17.9 40 40s-17.9 40-40 40l-56 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l56 0c39.8 0 72-32.2 72-72z"
    ]
};
const $d8206b3ab2e65c05$export$fa0323a4d7489a8d = $d8206b3ab2e65c05$export$ca492f58fe30a42f;
const $d8206b3ab2e65c05$export$482eb125aaf0fbc2 = {
    prefix: 'fas',
    iconName: 'cloud-moon',
    icon: [
        640,
        512,
        [],
        "f6c3",
        "M495.8 0c5.5 0 10.9 .2 16.3 .7c7 .6 12.8 5.7 14.3 12.5s-1.6 13.9-7.7 17.3c-44.4 25.2-74.4 73-74.4 127.8c0 81 65.5 146.6 146.2 146.6c8.6 0 17-.7 25.1-2.1c6.9-1.2 13.8 2.2 17 8.5s1.9 13.8-3.1 18.7c-34.5 33.6-81.7 54.4-133.6 54.4c-9.3 0-18.4-.7-27.4-1.9c-11.2-22.6-29.8-40.9-52.6-51.7c-2.7-58.5-50.3-105.3-109.2-106.7c-1.7-10.4-2.6-21-2.6-31.8C304 86.1 389.8 0 495.8 0zM447.9 431.9c0 44.2-35.8 80-80 80L96 511.9c-53 0-96-43-96-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7z"
    ]
};
const $d8206b3ab2e65c05$export$8da450d063b0eb37 = {
    prefix: 'fas',
    iconName: 'briefcase',
    icon: [
        512,
        512,
        [
            128188
        ],
        "f0b1",
        "M184 48l144 0c4.4 0 8 3.6 8 8l0 40L176 96l0-40c0-4.4 3.6-8 8-8zm-56 8l0 40L64 96C28.7 96 0 124.7 0 160l0 96 192 0 128 0 192 0 0-96c0-35.3-28.7-64-64-64l-64 0 0-40c0-30.9-25.1-56-56-56L184 0c-30.9 0-56 25.1-56 56zM512 288l-192 0 0 32c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-32L0 288 0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-128z"
    ]
};
const $d8206b3ab2e65c05$export$e94ab3a30cf4aca5 = {
    prefix: 'fas',
    iconName: 'person-falling',
    icon: [
        512,
        512,
        [],
        "e546",
        "M288 0c17.7 0 32 14.3 32 32l0 9.8c0 54.6-27.9 104.6-72.5 133.6l.2 .3L304.5 256l87.5 0c15.1 0 29.3 7.1 38.4 19.2l43.2 57.6c10.6 14.1 7.7 34.2-6.4 44.8s-34.2 7.7-44.8-6.4L384 320l-96 0-1.4 0 92.3 142.6c9.6 14.8 5.4 34.6-9.5 44.3s-34.6 5.4-44.3-9.5L164.5 249.2c-2.9 9.2-4.5 19-4.5 29l0 73.8c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-73.8c0-65.1 39.6-123.7 100.1-147.9C232.3 115.8 256 80.8 256 41.8l0-9.8c0-17.7 14.3-32 32-32zM112 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
const $d8206b3ab2e65c05$export$c23fd8b91a7ed48 = {
    prefix: 'fas',
    iconName: 'image-portrait',
    icon: [
        384,
        512,
        [
            "portrait"
        ],
        "f3e0",
        "M384 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-384zM128 192a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM80 356.6c0-37.9 30.7-68.6 68.6-68.6l86.9 0c37.9 0 68.6 30.7 68.6 68.6c0 15.1-12.3 27.4-27.4 27.4l-169.1 0C92.3 384 80 371.7 80 356.6z"
    ]
};
const $d8206b3ab2e65c05$export$e3d25f819c7ee7d7 = $d8206b3ab2e65c05$export$c23fd8b91a7ed48;
const $d8206b3ab2e65c05$export$9eec597148166b36 = {
    prefix: 'fas',
    iconName: 'user-tag',
    icon: [
        640,
        512,
        [],
        "f507",
        "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c10 0 18.8-4.9 24.2-12.5l-99.2-99.2c-14.9-14.9-23.3-35.1-23.3-56.1l0-33c-15.9-4.7-32.8-7.2-50.3-7.2l-91.4 0zM384 224c-17.7 0-32 14.3-32 32l0 82.7c0 17 6.7 33.3 18.7 45.3L478.1 491.3c18.7 18.7 49.1 18.7 67.9 0l73.4-73.4c18.7-18.7 18.7-49.1 0-67.9L512 242.7c-12-12-28.3-18.7-45.3-18.7L384 224zm24 80a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
const $d8206b3ab2e65c05$export$7cee7480f25f5289 = {
    prefix: 'fas',
    iconName: 'rug',
    icon: [
        640,
        512,
        [],
        "e569",
        "M24 64l32 0 24 0 0 24 0 88 0 80 0 80 0 88 0 24-24 0-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 0-40-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 0-32-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 0-32-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 0-40-8 0C10.7 112 0 101.3 0 88S10.7 64 24 64zm88 0l416 0 0 384-416 0 0-384zM640 88c0 13.3-10.7 24-24 24l-8 0 0 40 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 32 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 32 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 40 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0-24 0 0-24 0-88 0-80 0-80 0-88 0-24 24 0 32 0c13.3 0 24 10.7 24 24z"
    ]
};
const $d8206b3ab2e65c05$export$7adefae4a1be1d97 = {
    prefix: 'fas',
    iconName: 'earth-europe',
    icon: [
        512,
        512,
        [
            "globe-europe"
        ],
        "f7a2",
        "M266.3 48.3L232.5 73.6c-5.4 4-8.5 10.4-8.5 17.1l0 9.1c0 6.8 5.5 12.3 12.3 12.3c2.4 0 4.8-.7 6.8-2.1l41.8-27.9c2-1.3 4.4-2.1 6.8-2.1l1 0c6.2 0 11.3 5.1 11.3 11.3c0 3-1.2 5.9-3.3 8l-19.9 19.9c-5.8 5.8-12.9 10.2-20.7 12.8l-26.5 8.8c-5.8 1.9-9.6 7.3-9.6 13.4c0 3.7-1.5 7.3-4.1 10l-17.9 17.9c-6.4 6.4-9.9 15-9.9 24l0 4.3c0 16.4 13.6 29.7 29.9 29.7c11 0 21.2-6.2 26.1-16l4-8.1c2.4-4.8 7.4-7.9 12.8-7.9c4.5 0 8.7 2.1 11.4 5.7l16.3 21.7c2.1 2.9 5.5 4.5 9.1 4.5c8.4 0 13.9-8.9 10.1-16.4l-1.1-2.3c-3.5-7 0-15.5 7.5-18l21.2-7.1c7.6-2.5 12.7-9.6 12.7-17.6c0-10.3 8.3-18.6 18.6-18.6l29.4 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-20.7 0c-7.2 0-14.2 2.9-19.3 8l-4.7 4.7c-2.1 2.1-3.3 5-3.3 8c0 6.2 5.1 11.3 11.3 11.3l11.3 0c6 0 11.8 2.4 16 6.6l6.5 6.5c1.8 1.8 2.8 4.3 2.8 6.8s-1 5-2.8 6.8l-7.5 7.5C386 262 384 266.9 384 272s2 10 5.7 13.7L408 304c10.2 10.2 24.1 16 38.6 16l7.3 0c6.5-20.2 10-41.7 10-64c0-111.4-87.6-202.4-197.7-207.7zm172 307.9c-3.7-2.6-8.2-4.1-13-4.1c-6 0-11.8-2.4-16-6.6L396 332c-7.7-7.7-18-12-28.9-12c-9.7 0-19.2-3.5-26.6-9.8L314 287.4c-11.6-9.9-26.4-15.4-41.7-15.4l-20.9 0c-12.6 0-25 3.7-35.5 10.7L188.5 301c-17.8 11.9-28.5 31.9-28.5 53.3l0 3.2c0 17 6.7 33.3 18.7 45.3l16 16c8.5 8.5 20 13.3 32 13.3l21.3 0c13.3 0 24 10.7 24 24c0 2.5 .4 5 1.1 7.3c71.3-5.8 132.5-47.6 165.2-107.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM187.3 100.7c-6.2-6.2-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6z"
    ]
};
const $d8206b3ab2e65c05$export$5318b8ede86cc96b = $d8206b3ab2e65c05$export$7adefae4a1be1d97;
const $d8206b3ab2e65c05$export$ab81ff863770d996 = {
    prefix: 'fas',
    iconName: 'cart-flatbed-suitcase',
    icon: [
        640,
        512,
        [
            "luggage-cart"
        ],
        "f59d",
        "M0 32C0 14.3 14.3 0 32 0L48 0c44.2 0 80 35.8 80 80l0 288c0 8.8 7.2 16 16 16l464 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-66.7 0c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16l-197.5 0c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16L144 448c-44.2 0-80-35.8-80-80L64 80c0-8.8-7.2-16-16-16L32 64C14.3 64 0 49.7 0 32zM432 96l0-40c0-4.4-3.6-8-8-8l-80 0c-4.4 0-8 3.6-8 8l0 40 96 0zM288 96l0-40c0-30.9 25.1-56 56-56l80 0c30.9 0 56 25.1 56 56l0 40 0 224-192 0 0-224zM512 320l0-224 16 0c26.5 0 48 21.5 48 48l0 128c0 26.5-21.5 48-48 48l-16 0zM240 96l16 0 0 224-16 0c-26.5 0-48-21.5-48-48l0-128c0-26.5 21.5-48 48-48z"
    ]
};
const $d8206b3ab2e65c05$export$bd1e24dd3cde8514 = $d8206b3ab2e65c05$export$ab81ff863770d996;
const $d8206b3ab2e65c05$export$3896694b3e81fba7 = {
    prefix: 'fas',
    iconName: 'rectangle-xmark',
    icon: [
        512,
        512,
        [
            62164,
            "rectangle-times",
            "times-rectangle",
            "window-close"
        ],
        "f410",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
const $d8206b3ab2e65c05$export$eaaf26416a51dc1 = $d8206b3ab2e65c05$export$3896694b3e81fba7;
const $d8206b3ab2e65c05$export$10147c0014152a3f = $d8206b3ab2e65c05$export$3896694b3e81fba7;
const $d8206b3ab2e65c05$export$18b7775f78a3e16 = $d8206b3ab2e65c05$export$3896694b3e81fba7;
const $d8206b3ab2e65c05$export$ffc7123046a28ee = {
    prefix: 'fas',
    iconName: 'baht-sign',
    icon: [
        320,
        512,
        [],
        "e0ac",
        "M144 0c-17.7 0-32 14.3-32 32l0 32L37.6 64C16.8 64 0 80.8 0 101.6L0 224l0 41.7L0 288 0 406.3c0 23 18.7 41.7 41.7 41.7l70.3 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 32 0c61.9 0 112-50.1 112-112c0-40.1-21.1-75.3-52.7-95.1C280.3 222.6 288 200.2 288 176c0-61.9-50.1-112-112-112l0-32c0-17.7-14.3-32-32-32zM112 128l0 96-48 0 0-96 48 0zm64 96l0-96c26.5 0 48 21.5 48 48s-21.5 48-48 48zm-64 64l0 96-48 0 0-96 48 0zm64 96l0-96 32 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-32 0z"
    ]
};
const $d8206b3ab2e65c05$export$8a3071811b2b7979 = {
    prefix: 'fas',
    iconName: 'book-open',
    icon: [
        576,
        512,
        [
            128214,
            128366
        ],
        "f518",
        "M249.6 471.5c10.8 3.8 22.4-4.1 22.4-15.5l0-377.4c0-4.2-1.6-8.4-5-11C247.4 52 202.4 32 144 32C93.5 32 46.3 45.3 18.1 56.1C6.8 60.5 0 71.7 0 83.8L0 454.1c0 11.9 12.8 20.2 24.1 16.5C55.6 460.1 105.5 448 144 448c33.9 0 79 14 105.6 23.5zm76.8 0C353 462 398.1 448 432 448c38.5 0 88.4 12.1 119.9 22.6c11.3 3.8 24.1-4.6 24.1-16.5l0-370.3c0-12.1-6.8-23.3-18.1-27.6C529.7 45.3 482.5 32 432 32c-58.4 0-103.4 20-123 35.6c-3.3 2.6-5 6.8-5 11L304 456c0 11.4 11.7 19.3 22.4 15.5z"
    ]
};
const $d8206b3ab2e65c05$export$d3d49030d557a09b = {
    prefix: 'fas',
    iconName: 'book-journal-whills',
    icon: [
        448,
        512,
        [
            "journal-whills"
        ],
        "f66a",
        "M0 96C0 43 43 0 96 0L384 0l32 0c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32l0 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0L96 512c-53 0-96-43-96-96L0 96zM64 416c0 17.7 14.3 32 32 32l256 0 0-64L96 384c-17.7 0-32 14.3-32 32zm90.4-234.4l-21.2-21.2c-3 10.1-5.1 20.6-5.1 31.6c0 .2 0 .5 .1 .8s.1 .5 .1 .8L165.2 226c2.5 2.1 3.4 5.8 2.3 8.9c-1.3 3-4.1 5.1-7.5 5.1c-1.9-.1-3.8-.8-5.2-2l-23.6-20.6C142.8 267 186.9 304 240 304s97.3-37 108.9-86.6L325.3 238c-1.4 1.2-3.3 2-5.3 2c-2.2-.1-4.4-1.1-6-2.8c-1.2-1.5-1.9-3.4-2-5.2c.1-2.2 1.1-4.4 2.8-6l37.1-32.5c0-.3 0-.5 .1-.8s.1-.5 .1-.8c0-11-2.1-21.5-5.1-31.6l-21.2 21.2c-3.1 3.1-8.1 3.1-11.3 0s-3.1-8.1 0-11.2l26.4-26.5c-8.2-17-20.5-31.7-35.9-42.6c-2.7-1.9-6.2 1.4-5 4.5c8.5 22.4 3.6 48-13 65.6c-3.2 3.4-3.6 8.9-.9 12.7c9.8 14 12.7 31.9 7.5 48.5c-5.9 19.4-22 34.1-41.9 38.3l-1.4-34.3 12.6 8.6c.6 .4 1.5 .6 2.3 .6c1.5 0 2.7-.8 3.5-2s.6-2.8-.1-4L260 225.4l18-3.6c1.8-.4 3.1-2.1 3.1-4s-1.4-3.5-3.1-3.9l-18-3.7 8.5-14.3c.8-1.2 .9-2.9 .1-4.1s-2-2-3.5-2l-.1 0c-.7 .1-1.5 .3-2.1 .7l-14.1 9.6L244 87.9c-.1-2.2-1.9-3.9-4-3.9s-3.9 1.6-4 3.9l-4.6 110.8-12-8.1c-1.5-1.1-3.6-.9-5 .4s-1.6 3.4-.8 5l8.6 14.3-18 3.7c-1.8 .4-3.1 2-3.1 3.9s1.4 3.6 3.1 4l18 3.8-8.6 14.2c-.2 .6-.5 1.4-.5 2c0 1.1 .5 2.1 1.2 3c.8 .6 1.8 1 2.8 1c.7 0 1.6-.2 2.2-.6l10.4-7.1-1.4 32.8c-19.9-4.1-36-18.9-41.9-38.3c-5.1-16.6-2.2-34.4 7.6-48.5c2.7-3.9 2.3-9.3-.9-12.7c-16.6-17.5-21.6-43.1-13.1-65.5c1.2-3.1-2.3-6.4-5-4.5c-15.3 10.9-27.6 25.6-35.8 42.6l26.4 26.5c3.1 3.1 3.1 8.1 0 11.2s-8.1 3.1-11.2 0z"
    ]
};
const $d8206b3ab2e65c05$export$66a0d8d45aab6631 = $d8206b3ab2e65c05$export$d3d49030d557a09b;
const $d8206b3ab2e65c05$export$74d1f89b5feb9d42 = {
    prefix: 'fas',
    iconName: 'handcuffs',
    icon: [
        640,
        512,
        [],
        "e4f8",
        "M240 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM192 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32 80c17.7 0 32 14.3 32 32l8 0c13.3 0 24 10.7 24 24l0 16c0 1.7-.2 3.4-.5 5.1C280.3 229.6 320 286.2 320 352c0 88.4-71.6 160-160 160S0 440.4 0 352c0-65.8 39.7-122.4 96.5-146.9c-.4-1.6-.5-3.3-.5-5.1l0-16c0-13.3 10.7-24 24-24l8 0c0-17.7 14.3-32 32-32zm0 320a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm192-96c0-25.9-5.1-50.5-14.4-73.1c16.9-32.9 44.8-59.1 78.9-73.9c-.4-1.6-.5-3.3-.5-5.1l0-16c0-13.3 10.7-24 24-24l8 0c0-17.7 14.3-32 32-32s32 14.3 32 32l8 0c13.3 0 24 10.7 24 24l0 16c0 1.7-.2 3.4-.5 5.1C600.3 229.6 640 286.2 640 352c0 88.4-71.6 160-160 160c-62 0-115.8-35.3-142.4-86.9c9.3-22.5 14.4-47.2 14.4-73.1zm224 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM368 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm80 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $d8206b3ab2e65c05$export$1cbf6e649ce86166 = {
    prefix: 'fas',
    iconName: 'triangle-exclamation',
    icon: [
        512,
        512,
        [
            9888,
            "exclamation-triangle",
            "warning"
        ],
        "f071",
        "M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480L40 480c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
const $d8206b3ab2e65c05$export$3d249b63b52cce7c = $d8206b3ab2e65c05$export$1cbf6e649ce86166;
const $d8206b3ab2e65c05$export$2e470a35c38b096a = $d8206b3ab2e65c05$export$1cbf6e649ce86166;
const $d8206b3ab2e65c05$export$24680dede86b1883 = {
    prefix: 'fas',
    iconName: 'database',
    icon: [
        448,
        512,
        [],
        "f1c0",
        "M448 80l0 48c0 44.2-100.3 80-224 80S0 172.2 0 128L0 80C0 35.8 100.3 0 224 0S448 35.8 448 80zM393.2 214.7c20.8-7.4 39.9-16.9 54.8-28.6L448 288c0 44.2-100.3 80-224 80S0 332.2 0 288L0 186.1c14.9 11.8 34 21.2 54.8 28.6C99.7 230.7 159.5 240 224 240s124.3-9.3 169.2-25.3zM0 346.1c14.9 11.8 34 21.2 54.8 28.6C99.7 390.7 159.5 400 224 400s124.3-9.3 169.2-25.3c20.8-7.4 39.9-16.9 54.8-28.6l0 85.9c0 44.2-100.3 80-224 80S0 476.2 0 432l0-85.9z"
    ]
};
const $d8206b3ab2e65c05$export$c08b4b0e2b0dc027 = {
    prefix: 'fas',
    iconName: 'share',
    icon: [
        512,
        512,
        [
            "mail-forward"
        ],
        "f064",
        "M307 34.8c-11.5 5.1-19 16.6-19 29.2l0 64-112 0C78.8 128 0 206.8 0 304C0 417.3 81.5 467.9 100.2 478.1c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-7.5-4.3-14.4-9.8-19.5C108.8 431.9 96 414.4 96 384c0-53 43-96 96-96l96 0 0 64c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4z"
    ]
};
const $d8206b3ab2e65c05$export$81df7693d3f2f8da = $d8206b3ab2e65c05$export$c08b4b0e2b0dc027;
const $d8206b3ab2e65c05$export$8f534e1e0ab75bfe = {
    prefix: 'fas',
    iconName: 'bottle-droplet',
    icon: [
        320,
        512,
        [],
        "e4c4",
        "M96 0C82.7 0 72 10.7 72 24s10.7 24 24 24c4.4 0 8 3.6 8 8l0 64.9c0 12.2-7.2 23.1-17.2 30.1C53.7 174.1 32 212.5 32 256l0 192c0 35.3 28.7 64 64 64l128 0c35.3 0 64-28.7 64-64l0-192c0-43.5-21.7-81.9-54.8-105c-10-7-17.2-17.9-17.2-30.1L216 56c0-4.4 3.6-8 8-8c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0s0 0 0 0s0 0 0 0L104 0s0 0 0 0s0 0 0 0L96 0zm64 382c-26.5 0-48-20.1-48-45c0-16.8 22.1-48.1 36.3-66.4c6-7.8 17.5-7.8 23.5 0C185.9 288.9 208 320.2 208 337c0 24.9-21.5 45-48 45z"
    ]
};
const $d8206b3ab2e65c05$export$140d4da0adbaf435 = {
    prefix: 'fas',
    iconName: 'mask-face',
    icon: [
        640,
        512,
        [],
        "e1d7",
        "M320 64c-27.2 0-53.8 8-76.4 23.1l-37.1 24.8c-15.8 10.5-34.3 16.1-53.3 16.1l-9.2 0-16 0-72 0c-30.9 0-56 25.1-56 56l0 85c0 55.1 37.5 103.1 90.9 116.4l108 27C233.8 435 275.4 448 320 448s86.2-13 121.1-35.5l108-27C602.5 372.1 640 324.1 640 269l0-85c0-30.9-25.1-56-56-56l-72 0-16 0-9.2 0c-19 0-37.5-5.6-53.3-16.1L396.4 87.1C373.8 72 347.2 64 320 64zM132.3 346.3l-29.8-7.4C70.5 330.9 48 302.1 48 269l0-85c0-4.4 3.6-8 8-8l40 0 0 48c0 45.1 13.4 87.2 36.3 122.3zm405.1-7.4l-29.8 7.4c23-35.2 36.3-77.2 36.3-122.3l0-48 40 0c4.4 0 8 3.6 8 8l0 85c0 33-22.5 61.8-54.5 69.9zM192 208c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16zm16 48l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 80c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16z"
    ]
};
const $d8206b3ab2e65c05$export$7ec15a32285f6c22 = {
    prefix: 'fas',
    iconName: 'hill-rockslide',
    icon: [
        576,
        512,
        [],
        "e508",
        "M252.4 103.8l27 48c2.8 5 8.2 8.2 13.9 8.2l53.3 0c5.8 0 11.1-3.1 13.9-8.2l27-48c2.7-4.9 2.7-10.8 0-15.7l-27-48c-2.8-5-8.2-8.2-13.9-8.2l-53.3 0c-5.8 0-11.1 3.1-13.9 8.2l-27 48c-2.7 4.9-2.7 10.8 0 15.7zM68.3 87C43.1 61.8 0 79.7 0 115.3L0 432c0 44.2 35.8 80 80 80l316.7 0c35.6 0 53.5-43.1 28.3-68.3L68.3 87zM504.2 403.6c4.9 2.7 10.8 2.7 15.7 0l48-27c5-2.8 8.2-8.2 8.2-13.9l0-53.3c0-5.8-3.1-11.1-8.2-13.9l-48-27c-4.9-2.7-10.8-2.7-15.7 0l-48 27c-5 2.8-8.2 8.2-8.2 13.9l0 53.3c0 5.8 3.1 11.1 8.2 13.9l48 27zM192 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM384 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
const $d8206b3ab2e65c05$export$a082af56be9786ae = {
    prefix: 'fas',
    iconName: 'right-left',
    icon: [
        512,
        512,
        [
            "exchange-alt"
        ],
        "f362",
        "M32 96l320 0 0-64c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l96 96c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-96 96c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6l0-64L32 160c-17.7 0-32-14.3-32-32s14.3-32 32-32zM480 352c17.7 0 32 14.3 32 32s-14.3 32-32 32l-320 0 0 64c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-96-96c-6-6-9.4-14.1-9.4-22.6s3.4-16.6 9.4-22.6l96-96c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 64 320 0z"
    ]
};
const $d8206b3ab2e65c05$export$f6c6fb20d374b128 = $d8206b3ab2e65c05$export$a082af56be9786ae;
const $d8206b3ab2e65c05$export$b5378818301da1be = {
    prefix: 'fas',
    iconName: 'paper-plane',
    icon: [
        512,
        512,
        [
            61913
        ],
        "f1d8",
        "M498.1 5.6c10.1 7 15.4 19.1 13.5 31.2l-64 416c-1.5 9.7-7.4 18.2-16 23s-18.9 5.4-28 1.6L284 427.7l-68.5 74.1c-8.9 9.7-22.9 12.9-35.2 8.1S160 493.2 160 480l0-83.6c0-4 1.5-7.8 4.2-10.8L331.8 202.8c5.8-6.3 5.6-16-.4-22s-15.7-6.4-22-.7L106 360.8 17.7 316.6C7.1 311.3 .3 300.7 0 288.9s5.9-22.8 16.1-28.7l448-256c10.7-6.1 23.9-5.5 34 1.4z"
    ]
};
const $d8206b3ab2e65c05$export$79753c2153535b01 = {
    prefix: 'fas',
    iconName: 'road-circle-exclamation',
    icon: [
        640,
        512,
        [],
        "e565",
        "M213.2 32L288 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64 74.8 0c27.1 0 51.3 17.1 60.3 42.6l42.7 120.6c-10.9-2.1-22.2-3.2-33.8-3.2c-59.5 0-112.1 29.6-144 74.8l0-42.8c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32c2.3 0 4.6-.3 6.8-.7c-4.5 15.5-6.8 31.8-6.8 48.7c0 5.4 .2 10.7 .7 16l-.7 0c-17.7 0-32 14.3-32 32l0 64L86.6 480C56.5 480 32 455.5 32 425.4c0-6.2 1.1-12.4 3.1-18.2L152.9 74.6C162 49.1 186.1 32 213.2 32zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16z"
    ]
};
const $d8206b3ab2e65c05$export$1156dc6acb0058bd = {
    prefix: 'fas',
    iconName: 'dungeon',
    icon: [
        512,
        512,
        [],
        "f6d9",
        "M336.6 156.5c1.3 1.1 2.7 2.2 3.9 3.3c9.3 8.2 23 10.5 33.4 3.6l67.6-45.1c11.4-7.6 14.2-23.2 5.1-33.4C430 66.6 410.9 50.6 389.7 37.6c-11.9-7.3-26.9-1.4-32.1 11.6l-30.5 76.2c-4.5 11.1 .2 23.6 9.5 31.2zM328 36.8c5.1-12.8-1.6-27.4-15-30.5C294.7 2.2 275.6 0 256 0s-38.7 2.2-57 6.4C185.5 9.4 178.8 24 184 36.8l30.3 75.8c4.5 11.3 16.8 17.2 29 16c4.2-.4 8.4-.6 12.7-.6s8.6 .2 12.7 .6c12.1 1.2 24.4-4.7 29-16L328 36.8zM65.5 85c-9.1 10.2-6.3 25.8 5.1 33.4l67.6 45.1c10.3 6.9 24.1 4.6 33.4-3.6c1.3-1.1 2.6-2.3 4-3.3c9.3-7.5 13.9-20.1 9.5-31.2L154.4 49.2c-5.2-12.9-20.3-18.8-32.1-11.6C101.1 50.6 82 66.6 65.5 85zm314 137.1c.9 3.3 1.7 6.6 2.3 10c2.5 13 13 23.9 26.2 23.9l80 0c13.3 0 24.1-10.8 22.9-24c-2.5-27.2-9.3-53.2-19.7-77.3c-5.5-12.9-21.4-16.6-33.1-8.9l-68.6 45.7c-9.8 6.5-13.2 19.2-10 30.5zM53.9 145.8c-11.6-7.8-27.6-4-33.1 8.9C10.4 178.8 3.6 204.8 1.1 232c-1.2 13.2 9.6 24 22.9 24l80 0c13.3 0 23.8-10.8 26.2-23.9c.6-3.4 1.4-6.7 2.3-10c3.1-11.4-.2-24-10-30.5L53.9 145.8zM104 288l-80 0c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24zm304 0c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-80 0zM24 416c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-80 0zm384 0c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-80 0zM272 192c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 272c0 8.8 7.2 16 16 16s16-7.2 16-16l0-272zm-64 32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 240c0 8.8 7.2 16 16 16s16-7.2 16-16l0-240zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 240c0 8.8 7.2 16 16 16s16-7.2 16-16l0-240z"
    ]
};
const $d8206b3ab2e65c05$export$7370f36a39a38737 = {
    prefix: 'fas',
    iconName: 'align-right',
    icon: [
        448,
        512,
        [],
        "f038",
        "M448 64c0 17.7-14.3 32-32 32L192 96c-17.7 0-32-14.3-32-32s14.3-32 32-32l224 0c17.7 0 32 14.3 32 32zm0 256c0 17.7-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l224 0c17.7 0 32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 224c-17.7 0-32-14.3-32-32zM448 448c0 17.7-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z"
    ]
};
const $d8206b3ab2e65c05$export$52e3e96cd1564779 = {
    prefix: 'fas',
    iconName: 'money-bill-1-wave',
    icon: [
        576,
        512,
        [
            "money-bill-wave-alt"
        ],
        "f53b",
        "M0 112.5L0 422.3c0 18 10.1 35 27 41.3c87 32.5 174 10.3 261-11.9c79.8-20.3 159.6-40.7 239.3-18.9c23 6.3 48.7-9.5 48.7-33.4l0-309.9c0-18-10.1-35-27-41.3C462 15.9 375 38.1 288 60.3C208.2 80.6 128.4 100.9 48.7 79.1C25.6 72.8 0 88.6 0 112.5zM128 416l-64 0 0-64c35.3 0 64 28.7 64 64zM64 224l0-64 64 0c0 35.3-28.7 64-64 64zM448 352c0-35.3 28.7-64 64-64l0 64-64 0zm64-192c-35.3 0-64-28.7-64-64l64 0 0 64zM384 256c0 61.9-43 112-96 112s-96-50.1-96-112s43-112 96-112s96 50.1 96 112zM252 208c0 9.7 6.9 17.7 16 19.6l0 48.4-4 0c-11 0-20 9-20 20s9 20 20 20l24 0 24 0c11 0 20-9 20-20s-9-20-20-20l-4 0 0-68c0-11-9-20-20-20l-16 0c-11 0-20 9-20 20z"
    ]
};
const $d8206b3ab2e65c05$export$1613858e873cbb3e = $d8206b3ab2e65c05$export$52e3e96cd1564779;
const $d8206b3ab2e65c05$export$53dd2cacf674142a = {
    prefix: 'fas',
    iconName: 'life-ring',
    icon: [
        512,
        512,
        [],
        "f1cd",
        "M367.2 412.5C335.9 434.9 297.5 448 256 448s-79.9-13.1-111.2-35.5l58-58c15.8 8.6 34 13.5 53.3 13.5s37.4-4.9 53.3-13.5l58 58zm90.7 .8c33.8-43.4 54-98 54-157.3s-20.2-113.9-54-157.3c9-12.5 7.9-30.1-3.4-41.3S425.8 45 413.3 54C369.9 20.2 315.3 0 256 0S142.1 20.2 98.7 54c-12.5-9-30.1-7.9-41.3 3.4S45 86.2 54 98.7C20.2 142.1 0 196.7 0 256s20.2 113.9 54 157.3c-9 12.5-7.9 30.1 3.4 41.3S86.2 467 98.7 458c43.4 33.8 98 54 157.3 54s113.9-20.2 157.3-54c12.5 9 30.1 7.9 41.3-3.4s12.4-28.8 3.4-41.3zm-45.5-46.1l-58-58c8.6-15.8 13.5-34 13.5-53.3s-4.9-37.4-13.5-53.3l58-58C434.9 176.1 448 214.5 448 256s-13.1 79.9-35.5 111.2zM367.2 99.5l-58 58c-15.8-8.6-34-13.5-53.3-13.5s-37.4 4.9-53.3 13.5l-58-58C176.1 77.1 214.5 64 256 64s79.9 13.1 111.2 35.5zM157.5 309.3l-58 58C77.1 335.9 64 297.5 64 256s13.1-79.9 35.5-111.2l58 58c-8.6 15.8-13.5 34-13.5 53.3s4.9 37.4 13.5 53.3zM208 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"
    ]
};
const $d8206b3ab2e65c05$export$f9712d0cf5150f0c = {
    prefix: 'fas',
    iconName: 'hands',
    icon: [
        576,
        512,
        [
            "sign-language",
            "signing"
        ],
        "f2a7",
        "M544 160l-.1 72.6c-.1 52.2-24 101-64 133.1c.1-1.9 .1-3.8 .1-5.7l0-8c0-71.8-37-138.6-97.9-176.7l-60.2-37.6c-8.6-5.4-17.9-8.4-27.3-9.4L248.7 48.8c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8l78 135.1c3.3 5.7 10.7 7.7 16.4 4.4s7.7-10.7 4.4-16.4l-62-107.4c-6.6-11.5-2.7-26.2 8.8-32.8S362 5 368.6 16.5l68 117.8s0 0 0 0s0 0 0 0l43.3 75L480 160c0-17.7 14.4-32 32-32s32 14.4 32 32zM243.9 88.5L268.5 131c-13.9 4.5-26.4 13.7-34.7 27c-.9 1.4-1.7 2.9-2.5 4.4l-28.9-50c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8zm-46.4 63.7l26.8 46.4c.6 6 2.1 11.8 4.3 17.4l-4.7 0-13.3 0s0 0 0 0L179 216l-23-39.8c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8zM260.9 175c9.4-15 29.1-19.5 44.1-10.2l60.2 37.6C416.7 234.7 448 291.2 448 352l0 8c0 83.9-68.1 152-152 152l-176 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l92 0c6.6 0 12-5.4 12-12s-5.4-12-12-12L88 440c-13.3 0-24-10.7-24-24s10.7-24 24-24l124 0c6.6 0 12-5.4 12-12s-5.4-12-12-12L56 368c-13.3 0-24-10.7-24-24s10.7-24 24-24l156 0c6.6 0 12-5.4 12-12s-5.4-12-12-12L88 296c-13.3 0-24-10.7-24-24s10.7-24 24-24l136 0s0 0 0 0s0 0 0 0l93.2 0L271 219.1c-15-9.4-19.5-29.1-10.2-44.1z"
    ]
};
const $d8206b3ab2e65c05$export$20993813350f9671 = $d8206b3ab2e65c05$export$f9712d0cf5150f0c;
const $d8206b3ab2e65c05$export$5cc0e6f5191f4f02 = $d8206b3ab2e65c05$export$f9712d0cf5150f0c;
const $d8206b3ab2e65c05$export$80968bcfef6481ca = {
    prefix: 'fas',
    iconName: 'calendar-day',
    icon: [
        448,
        512,
        [],
        "f783",
        "M128 0c17.7 0 32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 48 0c26.5 0 48 21.5 48 48l0 48L0 160l0-48C0 85.5 21.5 64 48 64l48 0 0-32c0-17.7 14.3-32 32-32zM0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192zm80 64c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16l-96 0z"
    ]
};
const $d8206b3ab2e65c05$export$5930e9bdfd790d77 = {
    prefix: 'fas',
    iconName: 'water-ladder',
    icon: [
        576,
        512,
        [
            "ladder-water",
            "swimming-pool"
        ],
        "f5c5",
        "M128 127.7C128 74.9 170.9 32 223.7 32c48.3 0 89 36 95 83.9l1 8.2c2.2 17.5-10.2 33.5-27.8 35.7s-33.5-10.2-35.7-27.8l-1-8.2c-2-15.9-15.5-27.8-31.5-27.8c-17.5 0-31.7 14.2-31.7 31.7l0 96.3 192 0 0-96.3C384 74.9 426.9 32 479.7 32c48.3 0 89 36 95 83.9l1 8.2c2.2 17.5-10.2 33.5-27.8 35.7s-33.5-10.2-35.7-27.8l-1-8.2c-2-15.9-15.5-27.8-31.5-27.8c-17.5 0-31.7 14.2-31.7 31.7L448 361c-1.6 1-3.3 2-4.8 3.1c-18 12.4-40.1 20.3-59.2 20.3c0 0 0 0 0 0l0-96.5-192 0 0 96.5c-19 0-41.2-7.9-59.1-20.3c-1.6-1.1-3.2-2.2-4.9-3.1l0-233.3zM306.5 389.9C329 405.4 356.5 416 384 416c26.9 0 55.4-10.8 77.4-26.1c0 0 0 0 0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 469.7 417 480 384 480c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7c0 0 0 0 0 0C136.7 405.2 165.1 416 192 416c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
const $d8206b3ab2e65c05$export$c5ea6eeef2db2b3b = $d8206b3ab2e65c05$export$5930e9bdfd790d77;
const $d8206b3ab2e65c05$export$4dee691631c67d5c = $d8206b3ab2e65c05$export$5930e9bdfd790d77;
const $d8206b3ab2e65c05$export$64185f27d82c259f = {
    prefix: 'fas',
    iconName: 'arrows-up-down',
    icon: [
        320,
        512,
        [
            "arrows-v"
        ],
        "f07d",
        "M182.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L128 109.3l0 293.5L86.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 402.7l0-293.5 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96z"
    ]
};
const $d8206b3ab2e65c05$export$cec5f1bc9e068e48 = $d8206b3ab2e65c05$export$64185f27d82c259f;
const $d8206b3ab2e65c05$export$bd5bd2ef56b793b1 = {
    prefix: 'fas',
    iconName: 'face-grimace',
    icon: [
        512,
        512,
        [
            128556,
            "grimace"
        ],
        "f57f",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm96-112l-8 0 0-40 55.3 0c-3.8 22.7-23.6 40-47.3 40zm47.3-56L344 344l0-40 8 0c23.8 0 43.5 17.3 47.3 40zM328 344l-64 0 0-40 64 0 0 40zm0 56l-64 0 0-40 64 0 0 40zm-80-96l0 40-64 0 0-40 64 0zm0 56l0 40-64 0 0-40 64 0zm-80-16l-55.3 0c3.8-22.7 23.6-40 47.3-40l8 0 0 40zm0 56l-8 0c-23.8 0-43.5-17.3-47.3-40l55.3 0 0 40zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $d8206b3ab2e65c05$export$3d08cd36ac1ef231 = $d8206b3ab2e65c05$export$bd5bd2ef56b793b1;
const $d8206b3ab2e65c05$export$1482162f7fe04ac = {
    prefix: 'fas',
    iconName: 'wheelchair-move',
    icon: [
        448,
        512,
        [
            "wheelchair-alt"
        ],
        "e2ce",
        "M320 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM204.5 121.3c-5.4-2.5-11.7-1.9-16.4 1.7l-40.9 30.7c-14.1 10.6-34.2 7.7-44.8-6.4s-7.7-34.2 6.4-44.8l40.9-30.7c23.7-17.8 55.3-21 82.1-8.4l90.4 42.5c29.1 13.7 36.8 51.6 15.2 75.5L299.1 224l97.4 0c30.3 0 53 27.7 47.1 57.4L415.4 422.3c-3.5 17.3-20.3 28.6-37.7 25.1s-28.6-20.3-25.1-37.7L377 288l-70.3 0c8.6 19.6 13.3 41.2 13.3 64c0 88.4-71.6 160-160 160S0 440.4 0 352s71.6-160 160-160c11.1 0 22 1.1 32.4 3.3l54.2-54.2-42.1-19.8zM160 448a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"
    ]
};
const $d8206b3ab2e65c05$export$7db9460785019040 = $d8206b3ab2e65c05$export$1482162f7fe04ac;
const $d8206b3ab2e65c05$export$b5dc9dd0347bbb6 = {
    prefix: 'fas',
    iconName: 'turn-down',
    icon: [
        384,
        512,
        [
            10549,
            "level-down-alt"
        ],
        "f3be",
        "M350 334.5c3.8 8.8 2 19-4.6 26l-136 144c-4.5 4.8-10.8 7.5-17.4 7.5s-12.9-2.7-17.4-7.5l-136-144c-6.6-7-8.4-17.2-4.6-26s12.5-14.5 22-14.5l88 0 0-192c0-17.7-14.3-32-32-32L32 96C14.3 96 0 81.7 0 64L0 32C0 14.3 14.3 0 32 0l80 0c70.7 0 128 57.3 128 128l0 192 88 0c9.6 0 18.2 5.7 22 14.5z"
    ]
};
const $d8206b3ab2e65c05$export$c07eb6ff5a382cbd = $d8206b3ab2e65c05$export$b5dc9dd0347bbb6;
const $d8206b3ab2e65c05$export$3e15790fe68c095b = {
    prefix: 'fas',
    iconName: 'person-walking-arrow-right',
    icon: [
        640,
        512,
        [],
        "e552",
        "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM123.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8C248.5 154.8 208.3 128 163.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1L68.7 398 9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L116.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zM550.6 153.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L530.7 224 384 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l146.7 0-25.4 25.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3l-80-80z"
    ]
};
const $d8206b3ab2e65c05$export$15da4ef8c0fb20d6 = {
    prefix: 'fas',
    iconName: 'square-envelope',
    icon: [
        448,
        512,
        [
            "envelope-square"
        ],
        "f199",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM218 271.7L64.2 172.4C66 156.4 79.5 144 96 144l256 0c16.5 0 30 12.4 31.8 28.4L230 271.7c-1.8 1.2-3.9 1.8-6 1.8s-4.2-.6-6-1.8zm29.4 26.9L384 210.4 384 336c0 17.7-14.3 32-32 32L96 368c-17.7 0-32-14.3-32-32l0-125.6 136.6 88.2c7 4.5 15.1 6.9 23.4 6.9s16.4-2.4 23.4-6.9z"
    ]
};
const $d8206b3ab2e65c05$export$354e159473e73552 = $d8206b3ab2e65c05$export$15da4ef8c0fb20d6;
const $d8206b3ab2e65c05$export$4ed8206e6619cc8f = {
    prefix: 'fas',
    iconName: 'dice',
    icon: [
        640,
        512,
        [
            127922
        ],
        "f522",
        "M274.9 34.3c-28.1-28.1-73.7-28.1-101.8 0L34.3 173.1c-28.1 28.1-28.1 73.7 0 101.8L173.1 413.7c28.1 28.1 73.7 28.1 101.8 0L413.7 274.9c28.1-28.1 28.1-73.7 0-101.8L274.9 34.3zM200 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM96 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM224 376a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM352 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM224 120a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm96 328c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64l-114.3 0c11.6 36 3.1 77-25.4 105.5L320 413.8l0 34.2zM480 328a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
const $d8206b3ab2e65c05$export$5ee2640fe105312d = {
    prefix: 'fas',
    iconName: 'bowling-ball',
    icon: [
        512,
        512,
        [],
        "f436",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM240 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM208 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-64-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $d8206b3ab2e65c05$export$97fa4f4c1006ab1 = {
    prefix: 'fas',
    iconName: 'brain',
    icon: [
        512,
        512,
        [
            129504
        ],
        "f5dc",
        "M184 0c30.9 0 56 25.1 56 56l0 400c0 30.9-25.1 56-56 56c-28.9 0-52.7-21.9-55.7-50.1c-5.2 1.4-10.7 2.1-16.3 2.1c-35.3 0-64-28.7-64-64c0-7.4 1.3-14.6 3.6-21.2C21.4 367.4 0 338.2 0 304c0-31.9 18.7-59.5 45.8-72.3C37.1 220.8 32 207 32 192c0-30.7 21.6-56.3 50.4-62.6C80.8 123.9 80 118 80 112c0-29.9 20.6-55.1 48.3-62.1C131.3 21.9 155.1 0 184 0zM328 0c28.9 0 52.6 21.9 55.7 49.9c27.8 7 48.3 32.1 48.3 62.1c0 6-.8 11.9-2.4 17.4c28.8 6.2 50.4 31.9 50.4 62.6c0 15-5.1 28.8-13.8 39.7C493.3 244.5 512 272.1 512 304c0 34.2-21.4 63.4-51.6 74.8c2.3 6.6 3.6 13.8 3.6 21.2c0 35.3-28.7 64-64 64c-5.6 0-11.1-.7-16.3-2.1c-3 28.2-26.8 50.1-55.7 50.1c-30.9 0-56-25.1-56-56l0-400c0-30.9 25.1-56 56-56z"
    ]
};
const $d8206b3ab2e65c05$export$658a137d3845bca7 = {
    prefix: 'fas',
    iconName: 'bandage',
    icon: [
        640,
        512,
        [
            129657,
            "band-aid"
        ],
        "f462",
        "M480 416l96 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64l-96 0 0 320zM448 96L192 96l0 320 256 0 0-320zM64 96C28.7 96 0 124.7 0 160L0 352c0 35.3 28.7 64 64 64l96 0 0-320L64 96zM248 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM248 304a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
const $d8206b3ab2e65c05$export$b14a1014df2fdf46 = $d8206b3ab2e65c05$export$658a137d3845bca7;
const $d8206b3ab2e65c05$export$23e8b4955c2d951b = {
    prefix: 'fas',
    iconName: 'calendar-minus',
    icon: [
        448,
        512,
        [],
        "f272",
        "M128 0c17.7 0 32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 48 0c26.5 0 48 21.5 48 48l0 48L0 160l0-48C0 85.5 21.5 64 48 64l48 0 0-32c0-17.7 14.3-32 32-32zM0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192zM312 376c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l176 0z"
    ]
};
const $d8206b3ab2e65c05$export$30262489773a79a3 = {
    prefix: 'fas',
    iconName: 'circle-xmark',
    icon: [
        512,
        512,
        [
            61532,
            "times-circle",
            "xmark-circle"
        ],
        "f057",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
const $d8206b3ab2e65c05$export$ab0ec50720a747eb = $d8206b3ab2e65c05$export$30262489773a79a3;
const $d8206b3ab2e65c05$export$90ac4096df8efdee = $d8206b3ab2e65c05$export$30262489773a79a3;
const $d8206b3ab2e65c05$export$de9a67b55dbe819a = {
    prefix: 'fas',
    iconName: 'gifts',
    icon: [
        640,
        512,
        [],
        "f79c",
        "M200.6 32C205 19.5 198.5 5.8 186 1.4S159.8 3.5 155.4 16L144.7 46.2l-9.9-29.8C130.6 3.8 117-3 104.4 1.2S85 19 89.2 31.6l8.3 25-27.4-20c-10.7-7.8-25.7-5.4-33.5 5.3s-5.4 25.7 5.3 33.5L70.2 96 48 96C21.5 96 0 117.5 0 144L0 464c0 26.5 21.5 48 48 48l152.6 0c-5.4-9.4-8.6-20.3-8.6-32l0-224c0-29.9 20.5-55 48.2-62c1.8-31 17.1-58.2 40.1-76.1C271.7 104.7 256.9 96 240 96l-22.2 0 28.3-20.6c10.7-7.8 13.1-22.8 5.3-33.5s-22.8-13.1-33.5-5.3L192.5 55.1 200.6 32zM363.5 185.5L393.1 224 344 224c-13.3 0-24-10.7-24-24c0-13.1 10.8-24 24.2-24c7.6 0 14.7 3.5 19.3 9.5zM272 200c0 8.4 1.4 16.5 4.1 24l-4.1 0c-26.5 0-48 21.5-48 48l0 80 192 0 0-96 32 0 0 96 192 0 0-80c0-26.5-21.5-48-48-48l-4.1 0c2.7-7.5 4.1-15.6 4.1-24c0-39.9-32.5-72-72.2-72c-22.4 0-43.6 10.4-57.3 28.2L432 195.8l-30.5-39.6c-13.7-17.8-35-28.2-57.3-28.2c-39.7 0-72.2 32.1-72.2 72zM224 464c0 26.5 21.5 48 48 48l144 0 0-128-192 0 0 80zm224 48l144 0c26.5 0 48-21.5 48-48l0-80-192 0 0 128zm96-312c0 13.3-10.7 24-24 24l-49.1 0 29.6-38.5c4.6-5.9 11.7-9.5 19.3-9.5c13.4 0 24.2 10.9 24.2 24z"
    ]
};
const $d8206b3ab2e65c05$export$c402efcf01d5ca07 = {
    prefix: 'fas',
    iconName: 'hotel',
    icon: [
        512,
        512,
        [
            127976
        ],
        "f594",
        "M0 32C0 14.3 14.3 0 32 0L480 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 384c17.7 0 32 14.3 32 32s-14.3 32-32 32l-176 0 0-48c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 48L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32L32 64C14.3 64 0 49.7 0 32zm96 80l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM240 96c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm112 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM112 192c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm112 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM328 384c13.3 0 24.3-10.9 21-23.8c-10.6-41.5-48.2-72.2-93-72.2s-82.5 30.7-93 72.2c-3.3 12.8 7.8 23.8 21 23.8l144 0z"
    ]
};
const $d8206b3ab2e65c05$export$807cdd395fe012cb = {
    prefix: 'fas',
    iconName: 'earth-asia',
    icon: [
        512,
        512,
        [
            127759,
            "globe-asia"
        ],
        "f57e",
        "M51.7 295.1l31.7 6.3c7.9 1.6 16-.9 21.7-6.6l15.4-15.4c11.6-11.6 31.1-8.4 38.4 6.2l9.3 18.5c4.8 9.6 14.6 15.7 25.4 15.7c15.2 0 26.1-14.6 21.7-29.2l-6-19.9c-4.6-15.4 6.9-30.9 23-30.9l2.3 0c13.4 0 25.9-6.7 33.3-17.8l10.7-16.1c5.6-8.5 5.3-19.6-.8-27.7l-16.1-21.5c-10.3-13.7-3.3-33.5 13.4-37.7l17-4.3c7.5-1.9 13.6-7.2 16.5-14.4l16.4-40.9C303.4 52.1 280.2 48 256 48C141.1 48 48 141.1 48 256c0 13.4 1.3 26.5 3.7 39.1zm407.7 4.6c-3-.3-6-.1-9 .8l-15.8 4.4c-6.7 1.9-13.8-.9-17.5-6.7l-2-3.1c-6-9.4-16.4-15.1-27.6-15.1s-21.6 5.7-27.6 15.1l-6.1 9.5c-1.4 2.2-3.4 4.1-5.7 5.3L312 330.1c-18.1 10.1-25.5 32.4-17 51.3l5.5 12.4c8.6 19.2 30.7 28.5 50.5 21.1l2.6-1c10-3.7 21.3-2.2 29.9 4.1l1.5 1.1c37.2-29.5 64.1-71.4 74.4-119.5zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm144.5 92.1c-2.1 8.6 3.1 17.3 11.6 19.4l32 8c8.6 2.1 17.3-3.1 19.4-11.6s-3.1-17.3-11.6-19.4l-32-8c-8.6-2.1-17.3 3.1-19.4 11.6zm92-20c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6l8-32c2.1-8.6-3.1-17.3-11.6-19.4s-17.3 3.1-19.4 11.6l-8 32zM343.2 113.7c-7.9-4-17.5-.7-21.5 7.2l-16 32c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l16-32c4-7.9 .7-17.5-7.2-21.5z"
    ]
};
const $d8206b3ab2e65c05$export$796fdfc909e603f4 = $d8206b3ab2e65c05$export$807cdd395fe012cb;
const $d8206b3ab2e65c05$export$31e6961064ddac7b = {
    prefix: 'fas',
    iconName: 'id-card-clip',
    icon: [
        576,
        512,
        [
            "id-card-alt"
        ],
        "f47f",
        "M256 0l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zM64 64l128 0 0 48c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-48 128 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 128C0 92.7 28.7 64 64 64zM176 437.3c0 5.9 4.8 10.7 10.7 10.7l202.7 0c5.9 0 10.7-4.8 10.7-10.7c0-29.5-23.9-53.3-53.3-53.3l-117.3 0c-29.5 0-53.3 23.9-53.3 53.3zM288 352a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"
    ]
};
const $d8206b3ab2e65c05$export$dc37ebbac31f6c6c = $d8206b3ab2e65c05$export$31e6961064ddac7b;
const $d8206b3ab2e65c05$export$f48a3ba52a0a9e56 = {
    prefix: 'fas',
    iconName: 'magnifying-glass-plus',
    icon: [
        512,
        512,
        [
            "search-plus"
        ],
        "f00e",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM184 296c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64z"
    ]
};
const $d8206b3ab2e65c05$export$378f00e6b1a8185 = $d8206b3ab2e65c05$export$f48a3ba52a0a9e56;
const $d8206b3ab2e65c05$export$47e4e0d519d33497 = {
    prefix: 'fas',
    iconName: 'thumbs-up',
    icon: [
        512,
        512,
        [
            128077,
            61575
        ],
        "f164",
        "M313.4 32.9c26 5.2 42.9 30.5 37.7 56.5l-2.3 11.4c-5.3 26.7-15.1 52.1-28.8 75.2l144 0c26.5 0 48 21.5 48 48c0 18.5-10.5 34.6-25.9 42.6C497 275.4 504 288.9 504 304c0 23.4-16.8 42.9-38.9 47.1c4.4 7.3 6.9 15.8 6.9 24.9c0 21.3-13.9 39.4-33.1 45.6c.7 3.3 1.1 6.8 1.1 10.4c0 26.5-21.5 48-48 48l-97.5 0c-19 0-37.5-5.6-53.3-16.1l-38.5-25.7C176 420.4 160 390.4 160 358.3l0-38.3 0-48 0-24.9c0-29.2 13.3-56.7 36-75l7.4-5.9c26.5-21.2 44.6-51 51.2-84.2l2.3-11.4c5.2-26 30.5-42.9 56.5-37.7zM32 192l64 0c17.7 0 32 14.3 32 32l0 224c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32L0 224c0-17.7 14.3-32 32-32z"
    ]
};
const $d8206b3ab2e65c05$export$b00596a09aa07311 = {
    prefix: 'fas',
    iconName: 'user-clock',
    icon: [
        640,
        512,
        [],
        "f4fd",
        "M224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM178.3 304l91.4 0c20.6 0 40.4 3.5 58.8 9.9C323 331 320 349.1 320 368c0 59.5 29.5 112.1 74.8 144L29.7 512C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-48c0-8.8-7.2-16-16-16z"
    ]
};
const $d8206b3ab2e65c05$export$8846d49caaed1c0a = {
    prefix: 'fas',
    iconName: 'hand-dots',
    icon: [
        512,
        512,
        [
            "allergies"
        ],
        "f461",
        "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-176c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 272c0 1.5 0 3.1 .1 4.6L67.6 283c-16-15.2-41.3-14.6-56.6 1.4s-14.6 41.3 1.4 56.6L124.8 448c43.1 41.1 100.4 64 160 64l19.2 0c97.2 0 176-78.8 176-176l0-208c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-176c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 176c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208zM240 336a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80 16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48-16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-16 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM240 432a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-48-48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
    ]
};
const $d8206b3ab2e65c05$export$dcae2101babbffff = $d8206b3ab2e65c05$export$8846d49caaed1c0a;
const $d8206b3ab2e65c05$export$bef39294aed2281a = {
    prefix: 'fas',
    iconName: 'file-invoice',
    icon: [
        384,
        512,
        [],
        "f570",
        "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM80 64l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 96l192 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L96 352c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm0 32l0 64 192 0 0-64L96 256zM240 416l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
const $d8206b3ab2e65c05$export$26a3f9d2784b90d8 = {
    prefix: 'fas',
    iconName: 'window-minimize',
    icon: [
        512,
        512,
        [
            128469
        ],
        "f2d1",
        "M32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l448 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 416z"
    ]
};
const $d8206b3ab2e65c05$export$60048819854688c5 = {
    prefix: 'fas',
    iconName: 'mug-saucer',
    icon: [
        640,
        512,
        [
            "coffee"
        ],
        "f0f4",
        "M96 64c0-17.7 14.3-32 32-32l320 0 64 0c70.7 0 128 57.3 128 128s-57.3 128-128 128l-32 0c0 53-43 96-96 96l-192 0c-53 0-96-43-96-96L96 64zM480 224l32 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-32 0 0 128zM32 416l512 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
const $d8206b3ab2e65c05$export$1d24a9e457278011 = $d8206b3ab2e65c05$export$60048819854688c5;
const $d8206b3ab2e65c05$export$5824ffe6f8983c83 = {
    prefix: 'fas',
    iconName: 'brush',
    icon: [
        384,
        512,
        [],
        "f55d",
        "M162.4 6c-1.5-3.6-5-6-8.9-6l-19 0c-3.9 0-7.5 2.4-8.9 6L104.9 57.7c-3.2 8-14.6 8-17.8 0L66.4 6c-1.5-3.6-5-6-8.9-6L48 0C21.5 0 0 21.5 0 48L0 224l0 22.4L0 256l9.6 0 364.8 0 9.6 0 0-9.6 0-22.4 0-176c0-26.5-21.5-48-48-48L230.5 0c-3.9 0-7.5 2.4-8.9 6L200.9 57.7c-3.2 8-14.6 8-17.8 0L162.4 6zM0 288l0 32c0 35.3 28.7 64 64 64l64 0 0 64c0 35.3 28.7 64 64 64s64-28.7 64-64l0-64 64 0c35.3 0 64-28.7 64-64l0-32L0 288zM192 432a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
    ]
};
const $d8206b3ab2e65c05$export$a8fabd50d8cb3ffd = {
    prefix: 'fas',
    iconName: 'file-half-dashed',
    icon: [
        384,
        512,
        [],
        "e698",
        "M64 0C28.7 0 0 28.7 0 64L0 320l384 0 0-160-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM0 416l64 0 0-64L0 352l0 64zm288 32l-80 0 0 64 80 0 0-64zm-112 0l-80 0 0 64 80 0 0-64zM64 448L0 448c0 35.3 28.7 64 64 64l0-64zm256 0l0 64c35.3 0 64-28.7 64-64l-64 0zm64-32l0-64-64 0 0 64 64 0z"
    ]
};
const $d8206b3ab2e65c05$export$7b028758c03b9655 = {
    prefix: 'fas',
    iconName: 'mask',
    icon: [
        576,
        512,
        [],
        "f6fa",
        "M288 64C64 64 0 160 0 272S80 448 176 448l8.4 0c24.2 0 46.4-13.7 57.2-35.4l23.2-46.3c4.4-8.8 13.3-14.3 23.2-14.3s18.8 5.5 23.2 14.3l23.2 46.3c10.8 21.7 33 35.4 57.2 35.4l8.4 0c96 0 176-64 176-176s-64-208-288-208zM96 256a64 64 0 1 1 128 0A64 64 0 1 1 96 256zm320-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
    ]
};
const $d8206b3ab2e65c05$export$56d810b9ab2e30bc = {
    prefix: 'fas',
    iconName: 'magnifying-glass-minus',
    icon: [
        512,
        512,
        [
            "search-minus"
        ],
        "f010",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM136 184c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z"
    ]
};
const $d8206b3ab2e65c05$export$efca97eef6a7a17d = $d8206b3ab2e65c05$export$56d810b9ab2e30bc;
const $d8206b3ab2e65c05$export$a6ad5df9d9f29553 = {
    prefix: 'fas',
    iconName: 'ruler-vertical',
    icon: [
        256,
        512,
        [],
        "f548",
        "M0 48C0 21.5 21.5 0 48 0L208 0c26.5 0 48 21.5 48 48l0 48-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0 64-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0 64-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0 64-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0 48c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 48z"
    ]
};
const $d8206b3ab2e65c05$export$50a28538498238f = {
    prefix: 'fas',
    iconName: 'user-large',
    icon: [
        512,
        512,
        [
            "user-alt"
        ],
        "f406",
        "M256 288A144 144 0 1 0 256 0a144 144 0 1 0 0 288zm-94.7 32C72.2 320 0 392.2 0 481.3c0 17 13.8 30.7 30.7 30.7l450.6 0c17 0 30.7-13.8 30.7-30.7C512 392.2 439.8 320 350.7 320l-189.4 0z"
    ]
};
const $d8206b3ab2e65c05$export$ae9b19c2ac726cfc = $d8206b3ab2e65c05$export$50a28538498238f;
const $d8206b3ab2e65c05$export$d401d4aeba21cdf3 = {
    prefix: 'fas',
    iconName: 'train-tram',
    icon: [
        448,
        512,
        [
            128650
        ],
        "e5b4",
        "M86.8 48c-12.2 0-23.6 5.5-31.2 15L42.7 79C34.5 89.3 19.4 91 9 82.7S-3 59.4 5.3 49L18 33C34.7 12.2 60 0 86.8 0L361.2 0c26.7 0 52 12.2 68.7 33l12.8 16c8.3 10.4 6.6 25.5-3.8 33.7s-25.5 6.6-33.7-3.7L392.5 63c-7.6-9.5-19.1-15-31.2-15L248 48l0 48 40 0c53 0 96 43 96 96l0 160c0 30.6-14.3 57.8-36.6 75.4l65.5 65.5c7.1 7.1 2.1 19.1-7.9 19.1l-39.7 0c-8.5 0-16.6-3.4-22.6-9.4L288 448l-128 0-54.6 54.6c-6 6-14.1 9.4-22.6 9.4L43 512c-10 0-15-12.1-7.9-19.1l65.5-65.5C78.3 409.8 64 382.6 64 352l0-160c0-53 43-96 96-96l40 0 0-48L86.8 48zM160 160c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-128 0zm32 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
const $d8206b3ab2e65c05$export$ab9af5aa013d2162 = {
    prefix: 'fas',
    iconName: 'user-nurse',
    icon: [
        448,
        512,
        [],
        "f82f",
        "M96 128l0-57.8c0-13.3 8.3-25.3 20.8-30l96-36c7.2-2.7 15.2-2.7 22.5 0l96 36c12.5 4.7 20.8 16.6 20.8 30l0 57.8-.3 0c.2 2.6 .3 5.3 .3 8l0 40c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-40c0-2.7 .1-5.4 .3-8l-.3 0zm48 48c0 44.2 35.8 80 80 80s80-35.8 80-80l0-16-160 0 0 16zM111.9 327.7c10.5-3.4 21.8 .4 29.4 8.5l71 75.5c6.3 6.7 17 6.7 23.3 0l71-75.5c7.6-8.1 18.9-11.9 29.4-8.5C401 348.6 448 409.4 448 481.3c0 17-13.8 30.7-30.7 30.7L30.7 512C13.8 512 0 498.2 0 481.3c0-71.9 47-132.7 111.9-153.6zM208 48l0 16-16 0c-4.4 0-8 3.6-8 8l0 16c0 4.4 3.6 8 8 8l16 0 0 16c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-16 16 0c4.4 0 8-3.6 8-8l0-16c0-4.4-3.6-8-8-8l-16 0 0-16c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8z"
    ]
};
const $d8206b3ab2e65c05$export$1aa9423ec6b1d609 = {
    prefix: 'fas',
    iconName: 'syringe',
    icon: [
        512,
        512,
        [
            128137
        ],
        "f48e",
        "M441 7l32 32 32 32c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15L417.9 128l55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-72-72L295 73c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l55 55L422.1 56 407 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zM210.3 155.7l61.1-61.1c.3 .3 .6 .7 1 1l16 16 56 56 56 56 16 16c.3 .3 .6 .6 1 1l-191 191c-10.5 10.5-24.7 16.4-39.6 16.4l-88.8 0L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l57-57 0-88.8c0-14.9 5.9-29.1 16.4-39.6l43.3-43.3 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 41.4-41.4 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57z"
    ]
};
const $d8206b3ab2e65c05$export$dcaadfd9c98e42a1 = {
    prefix: 'fas',
    iconName: 'cloud-sun',
    icon: [
        640,
        512,
        [
            9925
        ],
        "f6c4",
        "M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l14.1 84.7 84.7 14.1c5.4 .9 10 4.5 12.1 9.6s1.5 10.9-1.6 15.4l-38.5 55c-2.2-.1-4.4-.2-6.7-.2c-23.3 0-45.1 6.2-64 17.1l0-1.1c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c8.1 0 15.9-1 23.4-2.9c-36.6 18.1-63.3 53.1-69.8 94.9l-24.4 17c-4.5 3.2-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1L98.1 317.9 13.4 303.8c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6L98.1 98.1l14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5 278.8 2.9c4.5-3.2 10.3-3.8 15.4-1.6zM144 208a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM639.9 431.9c0 44.2-35.8 80-80 80l-271.9 0c-53 0-96-43-96-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7z"
    ]
};
const $d8206b3ab2e65c05$export$df6244b0501f2112 = {
    prefix: 'fas',
    iconName: 'stopwatch-20',
    icon: [
        448,
        512,
        [],
        "e06f",
        "M176 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l16 0 0 34.4C92.3 113.8 16 200 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-41.8-12.3-80.7-33.5-113.2l24.1-24.1c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L355.7 143c-28.1-23-62.2-38.8-99.7-44.6L256 64l16 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L176 0zM288 204c28.7 0 52 23.3 52 52l0 96c0 28.7-23.3 52-52 52s-52-23.3-52-52l0-96c0-28.7 23.3-52 52-52zm-12 52l0 96c0 6.6 5.4 12 12 12s12-5.4 12-12l0-96c0-6.6-5.4-12-12-12s-12 5.4-12 12zM159.5 244c-5.4 0-10.2 3.5-11.9 8.6l-.6 1.7c-3.5 10.5-14.8 16.1-25.3 12.6s-16.1-14.8-12.6-25.3l.6-1.7c7.2-21.5 27.2-35.9 49.8-35.9c29 0 52.5 23.5 52.5 52.5l0 2.2c0 13.4-4.9 26.4-13.8 36.4l-39 43.9c-6.2 7-10 15.7-10.9 24.9l43.8 0c11 0 20 9 20 20s-9 20-20 20l-64 0c-11 0-20-9-20-20l0-15.7c0-20.6 7.5-40.4 21.2-55.8l39-43.9c2.4-2.7 3.7-6.2 3.7-9.8l0-2.2c0-6.9-5.6-12.5-12.5-12.5z"
    ]
};
const $d8206b3ab2e65c05$export$7ec6541fee081990 = {
    prefix: 'fas',
    iconName: 'square-full',
    icon: [
        512,
        512,
        [
            128997,
            128998,
            128999,
            129000,
            129001,
            129002,
            129003,
            11035,
            11036
        ],
        "f45c",
        "M0 0H512V512H0V0z"
    ]
};
const $d8206b3ab2e65c05$export$78932e9c9abea6b7 = {
    prefix: 'fas',
    iconName: 'magnet',
    icon: [
        448,
        512,
        [
            129522
        ],
        "f076",
        "M0 160l0 96C0 379.7 100.3 480 224 480s224-100.3 224-224l0-96-128 0 0 96c0 53-43 96-96 96s-96-43-96-96l0-96L0 160zm0-32l128 0 0-64c0-17.7-14.3-32-32-32L32 32C14.3 32 0 46.3 0 64l0 64zm320 0l128 0 0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 64z"
    ]
};
const $d8206b3ab2e65c05$export$53583b459a87a01 = {
    prefix: 'fas',
    iconName: 'jar',
    icon: [
        320,
        512,
        [],
        "e516",
        "M32 32C32 14.3 46.3 0 64 0L256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L64 64C46.3 64 32 49.7 32 32zM0 160c0-35.3 28.7-64 64-64l192 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 160zm96 64c-17.7 0-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32L96 224z"
    ]
};
const $d8206b3ab2e65c05$export$4a4e034527c933f5 = {
    prefix: 'fas',
    iconName: 'note-sticky',
    icon: [
        448,
        512,
        [
            62026,
            "sticky-note"
        ],
        "f249",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l224 0 0-112c0-26.5 21.5-48 48-48l112 0 0-224c0-35.3-28.7-64-64-64L64 32zM448 352l-45.3 0L336 352c-8.8 0-16 7.2-16 16l0 66.7 0 45.3 32-32 64-64 32-32z"
    ]
};
const $d8206b3ab2e65c05$export$80889adc5d98bf4a = $d8206b3ab2e65c05$export$4a4e034527c933f5;
const $d8206b3ab2e65c05$export$fc4dd5feed8df23 = {
    prefix: 'fas',
    iconName: 'bug-slash',
    icon: [
        640,
        512,
        [],
        "e490",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L477.4 348.9c1.7-9.4 2.6-19 2.6-28.9l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64.3 0c-1.1-14.1-5-27.5-11.1-39.5c.7-.6 1.4-1.2 2.1-1.9l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64c-.7 .7-1.3 1.4-1.9 2.1C409.2 164.1 393.1 160 376 160l-112 0c-8.3 0-16.3 1-24 2.8L38.8 5.1zM320 0c-53 0-96 43-96 96l0 3.6c0 15.7 12.7 28.4 28.4 28.4l135.1 0c15.7 0 28.4-12.7 28.4-28.4l0-3.6c0-53-43-96-96-96zM160.3 256L96 256c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c0 24.6 5.5 47.8 15.4 68.6c-2.2 1.3-4.2 2.9-6 4.8l-64 64c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l63.1-63.1c24.5 21.8 55.8 36.2 90.3 39.6l0-143.7L166.7 227.3c-3.4 9-5.6 18.7-6.4 28.7zM336 479.2c36.6-3.6 69.7-19.6 94.8-43.8L336 360.7l0 118.5z"
    ]
};
const $d8206b3ab2e65c05$export$1a093e7861c5e48f = {
    prefix: 'fas',
    iconName: 'arrow-up-from-water-pump',
    icon: [
        576,
        512,
        [],
        "e4b6",
        "M112 0C85.5 0 64 21.5 64 48l0 208-16 0c-26.5 0-48 21.5-48 48l0 96c0 8 2 15.6 5.4 22.2c3.8-1.7 7.8-3.1 12-4.1c13.1-3.1 26.7-9.8 37.3-18.6c22.2-18.7 54.3-20.1 78.1-3.4c18 12.4 40.1 20.3 59.2 20.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.3 78.1 3.4c10.6 8.8 24.2 15.6 37.3 18.6c4.2 1 8.2 2.4 12 4.1C574 415.6 576 408 576 400l0-96c0-26.5-21.5-48-48-48l-48 0 0-146.7 25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L416 109.3 416 256l-128 0 0-208c0-26.5-21.5-48-48-48L112 0zM306.5 421.9c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1c0 0 0 0 0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7c0 0 0 0 0 0C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1z"
    ]
};
const $d8206b3ab2e65c05$export$5902c007d5703f2d = {
    prefix: 'fas',
    iconName: 'bone',
    icon: [
        576,
        512,
        [
            129460
        ],
        "f5d7",
        "M153.7 144.8c6.9 16.3 20.6 31.2 38.3 31.2l192 0c17.7 0 31.4-14.9 38.3-31.2C434.4 116.1 462.9 96 496 96c44.2 0 80 35.8 80 80c0 30.4-17 56.9-42 70.4c-3.6 1.9-6 5.5-6 9.6s2.4 7.7 6 9.6c25 13.5 42 40 42 70.4c0 44.2-35.8 80-80 80c-33.1 0-61.6-20.1-73.7-48.8C415.4 350.9 401.7 336 384 336l-192 0c-17.7 0-31.4 14.9-38.3 31.2C141.6 395.9 113.1 416 80 416c-44.2 0-80-35.8-80-80c0-30.4 17-56.9 42-70.4c3.6-1.9 6-5.5 6-9.6s-2.4-7.7-6-9.6C17 232.9 0 206.4 0 176c0-44.2 35.8-80 80-80c33.1 0 61.6 20.1 73.7 48.8z"
    ]
};
const $d8206b3ab2e65c05$export$59ce5ca5da74ff72 = {
    prefix: 'fas',
    iconName: 'table-cells-row-unlock',
    icon: [
        640,
        512,
        [],
        "e691",
        "M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 65.1c-37.8 5.4-69.4 29.6-85.2 62.9L360 224l0 64 56 0 0 8.6c-19.1 11.1-32 31.7-32 55.4l-24 0 0 64 24 0 0 64L64 480c-35.3 0-64-28.7-64-64L0 96zM64 224l0 64 88 0 0-64-88 0zm232 0l-88 0 0 64 88 0 0-64zM152 352l-88 0 0 64 88 0 0-64zm56 0l0 64 88 0 0-64-88 0zm288-80l0 48 32 0 32 0 48 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l-48 0c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
    ]
};
const $d8206b3ab2e65c05$export$c950c1ba7f227d5b = {
    prefix: 'fas',
    iconName: 'user-injured',
    icon: [
        448,
        512,
        [],
        "f728",
        "M240 80l102.7 0c-7.9-19.5-20.4-36.5-36.2-49.9L240 80zm37.7-68.2C261.3 4.2 243.2 0 224 0c-53.7 0-99.7 33.1-118.7 80l81.4 0 91-68.2zM224 256c70.7 0 128-57.3 128-128c0-5.4-.3-10.8-1-16L97 112c-.7 5.2-1 10.6-1 16c0 70.7 57.3 128 128 128zM124 312.4c-9.7 3.1-19.1 7-28 11.7L96 512l147.7 0L181.5 408.2 124 312.4zm33-7.2L204.3 384l67.7 0c44.2 0 80 35.8 80 80c0 18-6 34.6-16 48l82.3 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0c-7.2 0-14.3 .4-21.3 1.3zM0 482.3C0 498.7 13.3 512 29.7 512L64 512l0-166.6C24.9 378.1 0 427.3 0 482.3zM320 464c0-26.5-21.5-48-48-48l-48.5 0 57.1 95.2C303 507.2 320 487.6 320 464z"
    ]
};
const $d8206b3ab2e65c05$export$8a5a0dbb2a17e253 = {
    prefix: 'fas',
    iconName: 'face-sad-tear',
    icon: [
        512,
        512,
        [
            128546,
            "sad-tear"
        ],
        "f5b4",
        "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm240 80c0-8.8 7.2-16 16-16c45 0 85.6 20.5 115.7 53.1c6 6.5 5.6 16.6-.9 22.6s-16.6 5.6-22.6-.9c-25-27.1-57.4-42.9-92.3-42.9c-8.8 0-16-7.2-16-16zm-80 80c-26.5 0-48-21-48-47c0-20 28.6-60.4 41.6-77.7c3.2-4.4 9.6-4.4 12.8 0C179.6 308.6 208 349 208 369c0 26-21.5 47-48 47zM367.6 208a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $d8206b3ab2e65c05$export$4b5241926f692f91 = $d8206b3ab2e65c05$export$8a5a0dbb2a17e253;
const $d8206b3ab2e65c05$export$f654c69e66b466c0 = {
    prefix: 'fas',
    iconName: 'plane',
    icon: [
        576,
        512,
        [],
        "f072",
        "M482.3 192c34.2 0 93.7 29 93.7 64c0 36-59.5 64-93.7 64l-116.6 0L265.2 495.9c-5.7 10-16.3 16.1-27.8 16.1l-56.2 0c-10.6 0-18.3-10.2-15.4-20.4l49-171.6L112 320 68.8 377.6c-3 4-7.8 6.4-12.8 6.4l-42 0c-7.8 0-14-6.3-14-14c0-1.3 .2-2.6 .5-3.9L32 256 .5 145.9c-.4-1.3-.5-2.6-.5-3.9c0-7.8 6.3-14 14-14l42 0c5 0 9.8 2.4 12.8 6.4L112 192l102.9 0-49-171.6C162.9 10.2 170.6 0 181.2 0l56.2 0c11.5 0 22.1 6.2 27.8 16.1L365.7 192l116.6 0z"
    ]
};
const $d8206b3ab2e65c05$export$51adfe7c9ee4f428 = {
    prefix: 'fas',
    iconName: 'tent-arrows-down',
    icon: [
        576,
        512,
        [],
        "e581",
        "M209.8 111.9c-8.9-9.9-24-10.7-33.9-1.8l-39.9 36L136 24c0-13.3-10.7-24-24-24S88 10.7 88 24l0 122.1-39.9-36c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9l80 72c9.1 8.2 23 8.2 32.1 0l80-72c9.9-8.9 10.7-24 1.8-33.9zm352 0c-8.9-9.9-24-10.7-33.9-1.8l-39.9 36L488 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 122.1-39.9-36c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9l80 72c9.1 8.2 23 8.2 32.1 0l80-72c9.9-8.9 10.7-24 1.8-33.9zM307.4 166.5c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S86.7 512 96 512l144 0 16 0c17.7 0 32-14.3 32-32l0-118.1c0-5.5 4.4-9.9 9.9-9.9c3.7 0 7.2 2.1 8.8 5.5l68.4 136.8c5.4 10.8 16.5 17.7 28.6 17.7l60.2 0 16 0c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"
    ]
};
const $d8206b3ab2e65c05$export$de6218b649cbb6a9 = {
    prefix: 'fas',
    iconName: 'exclamation',
    icon: [
        128,
        512,
        [
            10069,
            10071,
            61738
        ],
        "21",
        "M96 64c0-17.7-14.3-32-32-32S32 46.3 32 64l0 256c0 17.7 14.3 32 32 32s32-14.3 32-32L96 64zM64 480a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
    ]
};
const $d8206b3ab2e65c05$export$7e05388be208e313 = {
    prefix: 'fas',
    iconName: 'arrows-spin',
    icon: [
        512,
        512,
        [],
        "e4bb",
        "M256 96c38.4 0 73.7 13.5 101.3 36.1l-32.6 32.6c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9l112 0c8.8 0 16-7.2 16-16l0-112c0-6.5-3.9-12.3-9.9-14.8s-12.9-1.1-17.4 3.5l-34 34C363.4 52.6 312.1 32 256 32c-10.9 0-21.5 .8-32 2.3l0 64.9c10.3-2.1 21-3.2 32-3.2zM132.1 154.7l32.6 32.6c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8l0-112c0-8.8-7.2-16-16-16L64 48c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l34 34C52.6 148.6 32 199.9 32 256c0 10.9 .8 21.5 2.3 32l64.9 0c-2.1-10.3-3.2-21-3.2-32c0-38.4 13.5-73.7 36.1-101.3zM477.7 224l-64.9 0c2.1 10.3 3.2 21 3.2 32c0 38.4-13.5 73.7-36.1 101.3l-32.6-32.6c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8l0 112c0 8.8 7.2 16 16 16l112 0c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-34-34C459.4 363.4 480 312.1 480 256c0-10.9-.8-21.5-2.3-32zM256 416c-38.4 0-73.7-13.5-101.3-36.1l32.6-32.6c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9L64 320c-8.8 0-16 7.2-16 16l0 112c0 6.5 3.9 12.3 9.9 14.8s12.9 1.1 17.4-3.5l34-34C148.6 459.4 199.9 480 256 480c10.9 0 21.5-.8 32-2.3l0-64.9c-10.3 2.1-21 3.2-32 3.2z"
    ]
};
const $d8206b3ab2e65c05$export$ae64371e02ee8e56 = {
    prefix: 'fas',
    iconName: 'print',
    icon: [
        512,
        512,
        [
            128424,
            128438,
            9113
        ],
        "f02f",
        "M128 0C92.7 0 64 28.7 64 64l0 96 64 0 0-96 226.7 0L384 93.3l0 66.7 64 0 0-66.7c0-17-6.7-33.3-18.7-45.3L400 18.7C388 6.7 371.7 0 354.7 0L128 0zM384 352l0 32 0 64-256 0 0-64 0-16 0-16 256 0zm64 32l32 0c17.7 0 32-14.3 32-32l0-96c0-35.3-28.7-64-64-64L64 192c-35.3 0-64 28.7-64 64l0 96c0 17.7 14.3 32 32 32l32 0 0 64c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-64zM432 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
const $d8206b3ab2e65c05$export$b458d393151b6960 = {
    prefix: 'fas',
    iconName: 'turkish-lira-sign',
    icon: [
        384,
        512,
        [
            "try",
            "turkish-lira"
        ],
        "e2bb",
        "M96 32c17.7 0 32 14.3 32 32l0 35.3L247.2 65.2c17-4.9 34.7 5 39.6 22s-5 34.7-22 39.6L128 165.9l0 29.4 119.2-34.1c17-4.9 34.7 5 39.6 22s-5 34.7-22 39.6L128 261.9 128 416l63.8 0c68.2 0 124.4-53.5 127.8-121.6l.4-8c.9-17.7 15.9-31.2 33.6-30.4s31.2 15.9 30.4 33.6l-.4 8C378.5 399.8 294.1 480 191.8 480L96 480c-17.7 0-32-14.3-32-32l0-167.9-23.2 6.6c-17 4.9-34.7-5-39.6-22s5-34.7 22-39.6L64 213.6l0-29.4-23.2 6.6c-17 4.9-34.7-5-39.6-22s5-34.7 22-39.6L64 117.6 64 64c0-17.7 14.3-32 32-32z"
    ]
};
const $d8206b3ab2e65c05$export$970dda513e46c41f = $d8206b3ab2e65c05$export$b458d393151b6960;
const $d8206b3ab2e65c05$export$40e66e5966827199 = $d8206b3ab2e65c05$export$b458d393151b6960;
const $d8206b3ab2e65c05$export$fb420d3e4d8c6a18 = {
    prefix: 'fas',
    iconName: 'dollar-sign',
    icon: [
        320,
        512,
        [
            128178,
            61781,
            "dollar",
            "usd"
        ],
        "24",
        "M160 0c17.7 0 32 14.3 32 32l0 35.7c1.6 .2 3.1 .4 4.7 .7c.4 .1 .7 .1 1.1 .2l48 8.8c17.4 3.2 28.9 19.9 25.7 37.2s-19.9 28.9-37.2 25.7l-47.5-8.7c-31.3-4.6-58.9-1.5-78.3 6.2s-27.2 18.3-29 28.1c-2 10.7-.5 16.7 1.2 20.4c1.8 3.9 5.5 8.3 12.8 13.2c16.3 10.7 41.3 17.7 73.7 26.3l2.9 .8c28.6 7.6 63.6 16.8 89.6 33.8c14.2 9.3 27.6 21.9 35.9 39.5c8.5 17.9 10.3 37.9 6.4 59.2c-6.9 38-33.1 63.4-65.6 76.7c-13.7 5.6-28.6 9.2-44.4 11l0 33.4c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-34.9c-.4-.1-.9-.1-1.3-.2l-.2 0s0 0 0 0c-24.4-3.8-64.5-14.3-91.5-26.3c-16.1-7.2-23.4-26.1-16.2-42.2s26.1-23.4 42.2-16.2c20.9 9.3 55.3 18.5 75.2 21.6c31.9 4.7 58.2 2 76-5.3c16.9-6.9 24.6-16.9 26.8-28.9c1.9-10.6 .4-16.7-1.3-20.4c-1.9-4-5.6-8.4-13-13.3c-16.4-10.7-41.5-17.7-74-26.3l-2.8-.7s0 0 0 0C119.4 279.3 84.4 270 58.4 253c-14.2-9.3-27.5-22-35.8-39.6c-8.4-17.9-10.1-37.9-6.1-59.2C23.7 116 52.3 91.2 84.8 78.3c13.3-5.3 27.9-8.9 43.2-11L128 32c0-17.7 14.3-32 32-32z"
    ]
};
const $d8206b3ab2e65c05$export$a4ffb0775547fcdf = $d8206b3ab2e65c05$export$fb420d3e4d8c6a18;
const $d8206b3ab2e65c05$export$72cca07d38a28589 = $d8206b3ab2e65c05$export$fb420d3e4d8c6a18;
const $d8206b3ab2e65c05$export$476af662c0c32cbc = {
    prefix: 'fas',
    iconName: 'x',
    icon: [
        384,
        512,
        [
            120
        ],
        "58",
        "M376.6 84.5c11.3-13.6 9.5-33.8-4.1-45.1s-33.8-9.5-45.1 4.1L192 206 56.6 43.5C45.3 29.9 25.1 28.1 11.5 39.4S-3.9 70.9 7.4 84.5L150.3 256 7.4 427.5c-11.3 13.6-9.5 33.8 4.1 45.1s33.8 9.5 45.1-4.1L192 306 327.4 468.5c11.3 13.6 31.5 15.4 45.1 4.1s15.4-31.5 4.1-45.1L233.7 256 376.6 84.5z"
    ]
};
const $d8206b3ab2e65c05$export$fa4f1ead37dc1dce = {
    prefix: 'fas',
    iconName: 'magnifying-glass-dollar',
    icon: [
        512,
        512,
        [
            "search-dollar"
        ],
        "f688",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM228 104c0-11-9-20-20-20s-20 9-20 20l0 14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1c0 0 0 0 0 0s0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4l0 14.6c0 11 9 20 20 20s20-9 20-20l0-13.8c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7l0-13.9z"
    ]
};
const $d8206b3ab2e65c05$export$65b49a6767630708 = $d8206b3ab2e65c05$export$fa4f1ead37dc1dce;
const $d8206b3ab2e65c05$export$3a18218720110fc0 = {
    prefix: 'fas',
    iconName: 'users-gear',
    icon: [
        640,
        512,
        [
            "users-cog"
        ],
        "f509",
        "M144 160A80 80 0 1 0 144 0a80 80 0 1 0 0 160zm368 0A80 80 0 1 0 512 0a80 80 0 1 0 0 160zM0 298.7C0 310.4 9.6 320 21.3 320l213.3 0c.2 0 .4 0 .7 0c-26.6-23.5-43.3-57.8-43.3-96c0-7.6 .7-15 1.9-22.3c-13.6-6.3-28.7-9.7-44.6-9.7l-42.7 0C47.8 192 0 239.8 0 298.7zM320 320c24 0 45.9-8.8 62.7-23.3c2.5-3.7 5.2-7.3 8-10.7c2.7-3.3 5.7-6.1 9-8.3C410 262.3 416 243.9 416 224c0-53-43-96-96-96s-96 43-96 96s43 96 96 96zm65.4 60.2c-10.3-5.9-18.1-16.2-20.8-28.2l-103.2 0C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7l300.6 0c-2.1-5.2-3.2-10.9-3.2-16.4l0-3c-1.3-.7-2.7-1.5-4-2.3l-2.6 1.5c-16.8 9.7-40.5 8-54.7-9.7c-4.5-5.6-8.6-11.5-12.4-17.6l-.1-.2-.1-.2-2.4-4.1-.1-.2-.1-.2c-3.4-6.2-6.4-12.6-9-19.3c-8.2-21.2 2.2-42.6 19-52.3l2.7-1.5c0-.8 0-1.5 0-2.3s0-1.5 0-2.3l-2.7-1.5zM533.3 192l-42.7 0c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 17.4-3.5 33.9-9.7 49c2.5 .9 4.9 2 7.1 3.3l2.6 1.5c1.3-.8 2.6-1.6 4-2.3l0-3c0-19.4 13.3-39.1 35.8-42.6c7.9-1.2 16-1.9 24.2-1.9s16.3 .6 24.2 1.9c22.5 3.5 35.8 23.2 35.8 42.6l0 3c1.3 .7 2.7 1.5 4 2.3l2.6-1.5c16.8-9.7 40.5-8 54.7 9.7c2.3 2.8 4.5 5.8 6.6 8.7c-2.1-57.1-49-102.7-106.6-102.7zm91.3 163.9c6.3-3.6 9.5-11.1 6.8-18c-2.1-5.5-4.6-10.8-7.4-15.9l-2.3-4c-3.1-5.1-6.5-9.9-10.2-14.5c-4.6-5.7-12.7-6.7-19-3l-2.9 1.7c-9.2 5.3-20.4 4-29.6-1.3s-16.1-14.5-16.1-25.1l0-3.4c0-7.3-4.9-13.8-12.1-14.9c-6.5-1-13.1-1.5-19.9-1.5s-13.4 .5-19.9 1.5c-7.2 1.1-12.1 7.6-12.1 14.9l0 3.4c0 10.6-6.9 19.8-16.1 25.1s-20.4 6.6-29.6 1.3l-2.9-1.7c-6.3-3.6-14.4-2.6-19 3c-3.7 4.6-7.1 9.5-10.2 14.6l-2.3 3.9c-2.8 5.1-5.3 10.4-7.4 15.9c-2.6 6.8 .5 14.3 6.8 17.9l2.9 1.7c9.2 5.3 13.7 15.8 13.7 26.4s-4.5 21.1-13.7 26.4l-3 1.7c-6.3 3.6-9.5 11.1-6.8 17.9c2.1 5.5 4.6 10.7 7.4 15.8l2.4 4.1c3 5.1 6.4 9.9 10.1 14.5c4.6 5.7 12.7 6.7 19 3l2.9-1.7c9.2-5.3 20.4-4 29.6 1.3s16.1 14.5 16.1 25.1l0 3.4c0 7.3 4.9 13.8 12.1 14.9c6.5 1 13.1 1.5 19.9 1.5s13.4-.5 19.9-1.5c7.2-1.1 12.1-7.6 12.1-14.9l0-3.4c0-10.6 6.9-19.8 16.1-25.1s20.4-6.6 29.6-1.3l2.9 1.7c6.3 3.6 14.4 2.6 19-3c3.7-4.6 7.1-9.4 10.1-14.5l2.4-4.2c2.8-5.1 5.3-10.3 7.4-15.8c2.6-6.8-.5-14.3-6.8-17.9l-3-1.7c-9.2-5.3-13.7-15.8-13.7-26.4s4.5-21.1 13.7-26.4l3-1.7zM472 384a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z"
    ]
};
const $d8206b3ab2e65c05$export$5e0b06753fc69b81 = $d8206b3ab2e65c05$export$3a18218720110fc0;
const $d8206b3ab2e65c05$export$50b6dcaa9ec03439 = {
    prefix: 'fas',
    iconName: 'person-military-pointing',
    icon: [
        576,
        512,
        [],
        "e54a",
        "M246.9 14.1C234 15.2 224 26 224 39c0 13.8 11.2 25 25 25l151 0c8.8 0 16-7.2 16-16l0-30.6C416 8 408 .7 398.7 1.4L246.9 14.1zM240 112c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16L241.6 96c-1 5.2-1.6 10.5-1.6 16zM72 224c-22.1 0-40 17.9-40 40s17.9 40 40 40l152 0 0 89.4L386.8 230.5c-13.3-4.3-27.3-6.5-41.6-6.5L240 224 72 224zm345.7 20.9L246.6 416 416 416l0-46.3 53.6 90.6c11.2 19 35.8 25.3 54.8 14.1s25.3-35.8 14.1-54.8L462.3 290.8c-11.2-18.9-26.6-34.5-44.6-45.9zM224 448l0 32c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-32-192 0z"
    ]
};
const $d8206b3ab2e65c05$export$a411e7e26cb63d5e = {
    prefix: 'fas',
    iconName: 'building-columns',
    icon: [
        512,
        512,
        [
            "bank",
            "institution",
            "museum",
            "university"
        ],
        "f19c",
        "M243.4 2.6l-224 96c-14 6-21.8 21-18.7 35.8S16.8 160 32 160l0 8c0 13.3 10.7 24 24 24l400 0c13.3 0 24-10.7 24-24l0-8c15.2 0 28.3-10.7 31.3-25.6s-4.8-29.9-18.7-35.8l-224-96c-8-3.4-17.2-3.4-25.2 0zM128 224l-64 0 0 196.3c-.6 .3-1.2 .7-1.8 1.1l-48 32c-11.7 7.8-17 22.4-12.9 35.9S17.9 512 32 512l448 0c14.1 0 26.5-9.2 30.6-22.7s-1.1-28.1-12.9-35.9l-48-32c-.6-.4-1.2-.7-1.8-1.1L448 224l-64 0 0 192-40 0 0-192-64 0 0 192-48 0 0-192-64 0 0 192-40 0 0-192zM256 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
const $d8206b3ab2e65c05$export$6e379b829ea8b99 = $d8206b3ab2e65c05$export$a411e7e26cb63d5e;
const $d8206b3ab2e65c05$export$1dba320226a34c1f = $d8206b3ab2e65c05$export$a411e7e26cb63d5e;
const $d8206b3ab2e65c05$export$9b3953adff472ad2 = $d8206b3ab2e65c05$export$a411e7e26cb63d5e;
const $d8206b3ab2e65c05$export$f2e1460ebe1a8cb0 = $d8206b3ab2e65c05$export$a411e7e26cb63d5e;
const $d8206b3ab2e65c05$export$9ff64ffae70e08c0 = {
    prefix: 'fas',
    iconName: 'umbrella',
    icon: [
        576,
        512,
        [],
        "f0e9",
        "M288 0c17.7 0 32 14.3 32 32l0 17.7C451.8 63.4 557.7 161 573.9 285.9c2 15.6-17.3 24.4-27.8 12.7C532.1 283 504.8 272 480 272c-38.7 0-71 27.5-78.4 64.1c-1.7 8.7-8.7 15.9-17.6 15.9s-15.8-7.2-17.6-15.9C359 299.5 326.7 272 288 272s-71 27.5-78.4 64.1c-1.7 8.7-8.7 15.9-17.6 15.9s-15.8-7.2-17.6-15.9C167 299.5 134.7 272 96 272c-24.8 0-52.1 11-66.1 26.7C19.4 310.4 .1 301.5 2.1 285.9C18.3 161 124.2 63.4 256 49.7L256 32c0-17.7 14.3-32 32-32zm0 304c12.3 0 23.5 4.6 32 12.2l0 114.3c0 45-36.5 81.4-81.4 81.4c-30.8 0-59-17.4-72.8-45l-2.3-4.7c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l2.3 4.7c3 5.9 9 9.6 15.6 9.6c9.6 0 17.4-7.8 17.4-17.4l0-114.3c8.5-7.6 19.7-12.2 32-12.2z"
    ]
};
const $d8206b3ab2e65c05$export$12ca996a6f686fe1 = {
    prefix: 'fas',
    iconName: 'trowel',
    icon: [
        512,
        512,
        [],
        "e589",
        "M343.9 213.4L245.3 312l65.4 65.4c7.9 7.9 11.1 19.4 8.4 30.3s-10.8 19.6-21.5 22.9l-256 80c-11.4 3.5-23.8 .5-32.2-7.9S-2.1 481.8 1.5 470.5l80-256c3.3-10.7 12-18.9 22.9-21.5s22.4 .5 30.3 8.4L200 266.7l98.6-98.6c-14.3-14.6-14.2-38 .3-52.5l95.4-95.4c26.9-26.9 70.5-26.9 97.5 0s26.9 70.5 0 97.5l-95.4 95.4c-14.5 14.5-37.9 14.6-52.5 .3z"
    ]
};
const $d8206b3ab2e65c05$export$56c73b799aac2555 = {
    prefix: 'fas',
    iconName: 'd',
    icon: [
        384,
        512,
        [
            100
        ],
        "44",
        "M0 96C0 60.7 28.7 32 64 32l96 0c123.7 0 224 100.3 224 224s-100.3 224-224 224l-96 0c-35.3 0-64-28.7-64-64L0 96zm160 0L64 96l0 320 96 0c88.4 0 160-71.6 160-160s-71.6-160-160-160z"
    ]
};
const $d8206b3ab2e65c05$export$c7e014b7e3ac3d83 = {
    prefix: 'fas',
    iconName: 'stapler',
    icon: [
        640,
        512,
        [],
        "e5af",
        "M640 299.3l0 4.7 0 128c0 26.5-21.5 48-48 48l-80 0-64 0L64 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0 0-48L96 368c-17.7 0-32-14.3-32-32l0-116.6L33.8 214C14.2 210.5 0 193.5 0 173.7c0-8.9 2.9-17.5 8.2-24.6l35.6-47.5C76.7 57.8 128.2 32 182.9 32c27 0 53.6 6.3 77.8 18.4L586.9 213.5C619.5 229.7 640 263 640 299.3zM448 304l0-16L128 230.9l0 73.1 320 0z"
    ]
};
const $d8206b3ab2e65c05$export$bf5896cc1ce4d55 = {
    prefix: 'fas',
    iconName: 'masks-theater',
    icon: [
        640,
        512,
        [
            127917,
            "theater-masks"
        ],
        "f630",
        "M74.6 373.2c41.7 36.1 108 82.5 166.1 73.7c6.1-.9 12.1-2.5 18-4.5c-9.2-12.3-17.3-24.4-24.2-35.4c-21.9-35-28.8-75.2-25.9-113.6c-20.6 4.1-39.2 13-54.7 25.4c-6.5 5.2-16.3 1.3-14.8-7c6.4-33.5 33-60.9 68.2-66.3c2.6-.4 5.3-.7 7.9-.8l19.4-131.3c2-13.8 8-32.7 25-45.9C278.2 53.2 310.5 37 363.2 32.2c-.8-.7-1.6-1.4-2.4-2.1C340.6 14.5 288.4-11.5 175.7 5.6S20.5 63 5.7 83.9C0 91.9-.8 102 .6 111.8L24.8 276.1c5.5 37.3 21.5 72.6 49.8 97.2zm87.7-219.6c4.4-3.1 10.8-2 11.8 3.3c.1 .5 .2 1.1 .3 1.6c3.2 21.8-11.6 42-33.1 45.3s-41.5-11.8-44.7-33.5c-.1-.5-.1-1.1-.2-1.6c-.6-5.4 5.2-8.4 10.3-6.7c9 3 18.8 3.9 28.7 2.4s19.1-5.3 26.8-10.8zM261.6 390c29.4 46.9 79.5 110.9 137.6 119.7s124.5-37.5 166.1-73.7c28.3-24.5 44.3-59.8 49.8-97.2l24.2-164.3c1.4-9.8 .6-19.9-5.1-27.9c-14.8-20.9-57.3-61.2-170-78.3S299.4 77.2 279.2 92.8c-7.8 6-11.5 15.4-12.9 25.2L242.1 282.3c-5.5 37.3-.4 75.8 19.6 107.7zM404.5 235.3c-7.7-5.5-16.8-9.3-26.8-10.8s-19.8-.6-28.7 2.4c-5.1 1.7-10.9-1.3-10.3-6.7c.1-.5 .1-1.1 .2-1.6c3.2-21.8 23.2-36.8 44.7-33.5s36.3 23.5 33.1 45.3c-.1 .5-.2 1.1-.3 1.6c-1 5.3-7.4 6.4-11.8 3.3zm136.2 15.5c-1 5.3-7.4 6.4-11.8 3.3c-7.7-5.5-16.8-9.3-26.8-10.8s-19.8-.6-28.7 2.4c-5.1 1.7-10.9-1.3-10.3-6.7c.1-.5 .1-1.1 .2-1.6c3.2-21.8 23.2-36.8 44.7-33.5s36.3 23.5 33.1 45.3c-.1 .5-.2 1.1-.3 1.6zM530 350.2c-19.6 44.7-66.8 72.5-116.8 64.9s-87.1-48.2-93-96.7c-1-8.3 8.9-12.1 15.2-6.7c23.9 20.8 53.6 35.3 87 40.3s66.1 .1 94.9-12.8c7.6-3.4 16 3.2 12.6 10.9z"
    ]
};
const $d8206b3ab2e65c05$export$3dbedc487b0159ac = $d8206b3ab2e65c05$export$bf5896cc1ce4d55;
const $d8206b3ab2e65c05$export$a6df39524c41472c = {
    prefix: 'fas',
    iconName: 'kip-sign',
    icon: [
        384,
        512,
        [],
        "e1c4",
        "M340.8 88.3c13.4-11.5 15-31.7 3.5-45.1s-31.7-15-45.1-3.5L128 186.4 128 64c0-17.7-14.3-32-32-32S64 46.3 64 64l0 160-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-122.4L299.2 472.3c13.4 11.5 33.6 9.9 45.1-3.5s9.9-33.6-3.5-45.1L182.5 288 352 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-169.5 0L340.8 88.3z"
    ]
};
const $d8206b3ab2e65c05$export$b276ec3dc9760d39 = {
    prefix: 'fas',
    iconName: 'hand-point-left',
    icon: [
        512,
        512,
        [],
        "f0a5",
        "M32 96C14.3 96 0 110.3 0 128s14.3 32 32 32l208 0 0-64L32 96zM192 288c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0zm-64-64c0 17.7 14.3 32 32 32l48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-48 0c-17.7 0-32 14.3-32 32zm96 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0zm88-96l-.6 0c5.4 9.4 8.6 20.3 8.6 32c0 13.2-4 25.4-10.8 35.6c24.9 8.7 42.8 32.5 42.8 60.4c0 11.7-3.1 22.6-8.6 32l8.6 0c88.4 0 160-71.6 160-160l0-61.7c0-42.4-16.9-83.1-46.9-113.1l-11.6-11.6C429.5 77.5 396.9 64 363 64l-27 0c-35.3 0-64 28.7-64 64l0 88c0 22.1 17.9 40 40 40s40-17.9 40-40l0-56c0-8.8 7.2-16 16-16s16 7.2 16 16l0 56c0 39.8-32.2 72-72 72z"
    ]
};
const $d8206b3ab2e65c05$export$e8485db4dab0ab30 = {
    prefix: 'fas',
    iconName: 'handshake-simple',
    icon: [
        640,
        512,
        [
            129309,
            "handshake-alt"
        ],
        "f4c6",
        "M323.4 85.2l-96.8 78.4c-16.1 13-19.2 36.4-7 53.1c12.9 17.8 38 21.3 55.3 7.8l99.3-77.2c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L550.2 352l41.8 0c26.5 0 48-21.5 48-48l0-128c0-26.5-21.5-48-48-48l-76 0-4 0-.7 0-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2zm22.8 124.4l-51.7 40.2C263 274.4 217.3 268 193.7 235.6c-22.2-30.5-16.6-73.1 12.7-96.8l83.2-67.3c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-72 48-80 0c-26.5 0-48 21.5-48 48L0 304c0 26.5 21.5 48 48 48l108.2 0 91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c4.5-4.9 7.8-10.6 9.9-16.5c19.4 13 45.8 10.3 62.1-7.5c17.9-19.5 16.6-49.9-2.9-67.8l-134.2-123z"
    ]
};
const $d8206b3ab2e65c05$export$e9aa3c6f9f47aa1a = $d8206b3ab2e65c05$export$e8485db4dab0ab30;
const $d8206b3ab2e65c05$export$2130e629ab767ab3 = {
    prefix: 'fas',
    iconName: 'jet-fighter',
    icon: [
        640,
        512,
        [
            "fighter-jet"
        ],
        "f0fb",
        "M160 24c0-13.3 10.7-24 24-24L296 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0L384 192l116.4 0c7.7 0 15.3 1.4 22.5 4.1L625 234.4c9 3.4 15 12 15 21.6s-6 18.2-15 21.6L522.9 315.9c-7.2 2.7-14.8 4.1-22.5 4.1L384 320 280 464l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 0-144-32 0-54.6 54.6c-6 6-14.1 9.4-22.6 9.4L64 384c-17.7 0-32-14.3-32-32l0-64c-17.7 0-32-14.3-32-32s14.3-32 32-32l0-64c0-17.7 14.3-32 32-32l18.7 0c8.5 0 16.6 3.4 22.6 9.4L160 192l32 0 0-144-8 0c-13.3 0-24-10.7-24-24zM80 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0z"
    ]
};
const $d8206b3ab2e65c05$export$102b809faf56e033 = $d8206b3ab2e65c05$export$2130e629ab767ab3;
const $d8206b3ab2e65c05$export$1bdb0ec5af3fea99 = {
    prefix: 'fas',
    iconName: 'square-share-nodes',
    icon: [
        448,
        512,
        [
            "share-alt-square"
        ],
        "f1e1",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM384 160c0 35.3-28.7 64-64 64c-15.4 0-29.5-5.4-40.6-14.5L194.1 256l85.3 46.5c11-9.1 25.2-14.5 40.6-14.5c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-2.5 .1-4.9 .4-7.3L174.5 300c-11.7 12.3-28.2 20-46.5 20c-35.3 0-64-28.7-64-64s28.7-64 64-64c18.3 0 34.8 7.7 46.5 20l81.9-44.7c-.3-2.4-.4-4.9-.4-7.3c0-35.3 28.7-64 64-64s64 28.7 64 64z"
    ]
};
const $d8206b3ab2e65c05$export$3799c2d8fd7e493b = $d8206b3ab2e65c05$export$1bdb0ec5af3fea99;
const $d8206b3ab2e65c05$export$3825a842b5afc5aa = {
    prefix: 'fas',
    iconName: 'barcode',
    icon: [
        512,
        512,
        [],
        "f02a",
        "M24 32C10.7 32 0 42.7 0 56L0 456c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24L64 56c0-13.3-10.7-24-24-24L24 32zm88 0c-8.8 0-16 7.2-16 16l0 416c0 8.8 7.2 16 16 16s16-7.2 16-16l0-416c0-8.8-7.2-16-16-16zm72 0c-13.3 0-24 10.7-24 24l0 400c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24l0-400c0-13.3-10.7-24-24-24l-16 0zm96 0c-13.3 0-24 10.7-24 24l0 400c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24l0-400c0-13.3-10.7-24-24-24l-16 0zM448 56l0 400c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24l0-400c0-13.3-10.7-24-24-24l-16 0c-13.3 0-24 10.7-24 24zm-64-8l0 416c0 8.8 7.2 16 16 16s16-7.2 16-16l0-416c0-8.8-7.2-16-16-16s-16 7.2-16 16z"
    ]
};
const $d8206b3ab2e65c05$export$37bd38cf96417095 = {
    prefix: 'fas',
    iconName: 'plus-minus',
    icon: [
        384,
        512,
        [],
        "e43c",
        "M224 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 112L48 144c-17.7 0-32 14.3-32 32s14.3 32 32 32l112 0 0 112c0 17.7 14.3 32 32 32s32-14.3 32-32l0-112 112 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-112 0 0-112zM0 480c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 448c-17.7 0-32 14.3-32 32z"
    ]
};
const $d8206b3ab2e65c05$export$5c6bd8729527871b = {
    prefix: 'fas',
    iconName: 'video',
    icon: [
        576,
        512,
        [
            "video-camera"
        ],
        "f03d",
        "M0 128C0 92.7 28.7 64 64 64l256 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zM559.1 99.8c10.4 5.6 16.9 16.4 16.9 28.2l0 256c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6l-96-64L416 337.1l0-17.1 0-128 0-17.1 14.2-9.5 96-64c9.8-6.5 22.4-7.2 32.9-1.6z"
    ]
};
const $d8206b3ab2e65c05$export$3a530df752193ccf = $d8206b3ab2e65c05$export$5c6bd8729527871b;
const $d8206b3ab2e65c05$export$874e305fd7920cce = {
    prefix: 'fas',
    iconName: 'graduation-cap',
    icon: [
        640,
        512,
        [
            127891,
            "mortar-board"
        ],
        "f19d",
        "M320 32c-8.1 0-16.1 1.4-23.7 4.1L15.8 137.4C6.3 140.9 0 149.9 0 160s6.3 19.1 15.8 22.6l57.9 20.9C57.3 229.3 48 259.8 48 291.9l0 28.1c0 28.4-10.8 57.7-22.3 80.8c-6.5 13-13.9 25.8-22.5 37.6C0 442.7-.9 448.3 .9 453.4s6 8.9 11.2 10.2l64 16c4.2 1.1 8.7 .3 12.4-2s6.3-6.1 7.1-10.4c8.6-42.8 4.3-81.2-2.1-108.7C90.3 344.3 86 329.8 80 316.5l0-24.6c0-30.2 10.2-58.7 27.9-81.5c12.9-15.5 29.6-28 49.2-35.7l157-61.7c8.2-3.2 17.5 .8 20.7 9s-.8 17.5-9 20.7l-157 61.7c-12.4 4.9-23.3 12.4-32.2 21.6l159.6 57.6c7.6 2.7 15.6 4.1 23.7 4.1s16.1-1.4 23.7-4.1L624.2 182.6c9.5-3.4 15.8-12.5 15.8-22.6s-6.3-19.1-15.8-22.6L343.7 36.1C336.1 33.4 328.1 32 320 32zM128 408c0 35.3 86 72 192 72s192-36.7 192-72L496.7 262.6 354.5 314c-11.1 4-22.8 6-34.5 6s-23.5-2-34.5-6L143.3 262.6 128 408z"
    ]
};
const $d8206b3ab2e65c05$export$dd0a013bf23a9d86 = $d8206b3ab2e65c05$export$874e305fd7920cce;
const $d8206b3ab2e65c05$export$bb2a6b1b5e852300 = {
    prefix: 'fas',
    iconName: 'hand-holding-medical',
    icon: [
        576,
        512,
        [],
        "e05c",
        "M224 24l0 56-56 0c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l56 0 0 56c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-56 56 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-56 0 0-56c0-13.3-10.7-24-24-24L248 0c-13.3 0-24 10.7-24 24zM559.7 392.2c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416 272 416c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0-16 0-78.3 0c-29.1 0-57.3 9.9-80 28L68.8 384 32 384c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l160 0 160.5 0c29 0 57.3-9.3 80.7-26.5l126.6-93.3zm-367-8.2l.9 0c0 0 0 0 0 0c-.3 0-.6 0-.9 0z"
    ]
};
const $d8206b3ab2e65c05$export$30294c81ac4031ca = {
    prefix: 'fas',
    iconName: 'person-circle-check',
    icon: [
        576,
        512,
        [],
        "e53e",
        "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-223.1L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6l29.7 0c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9 232 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128-16 0zm136 16a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
    ]
};
const $d8206b3ab2e65c05$export$314f5cab62fc6968 = {
    prefix: 'fas',
    iconName: 'turn-up',
    icon: [
        384,
        512,
        [
            10548,
            "level-up-alt"
        ],
        "f3bf",
        "M350 177.5c3.8-8.8 2-19-4.6-26l-136-144C204.9 2.7 198.6 0 192 0s-12.9 2.7-17.4 7.5l-136 144c-6.6 7-8.4 17.2-4.6 26s12.5 14.5 22 14.5l88 0 0 192c0 17.7-14.3 32-32 32l-80 0c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l80 0c70.7 0 128-57.3 128-128l0-192 88 0c9.6 0 18.2-5.7 22-14.5z"
    ]
};
const $d8206b3ab2e65c05$export$d6f21a309b179c3d = $d8206b3ab2e65c05$export$314f5cab62fc6968;
var $d8206b3ab2e65c05$export$da048c47c8dcd50a = {
    fa0: $d8206b3ab2e65c05$export$f22454595d96c106,
    fa1: $d8206b3ab2e65c05$export$8398cb2addc9e182,
    fa2: $d8206b3ab2e65c05$export$ed1a0ff7bd680a1d,
    fa3: $d8206b3ab2e65c05$export$74b7ff79ce1818d6,
    fa4: $d8206b3ab2e65c05$export$969b2215780d58fd,
    fa5: $d8206b3ab2e65c05$export$3919f68a5b3825a9,
    fa6: $d8206b3ab2e65c05$export$580ac17b31ffb5c3,
    fa7: $d8206b3ab2e65c05$export$ee79cab31be16d23,
    fa8: $d8206b3ab2e65c05$export$45d84c4b2c560d2f,
    fa9: $d8206b3ab2e65c05$export$a120f1e4223629f2,
    faFillDrip: $d8206b3ab2e65c05$export$38320138fc0262d0,
    faArrowsToCircle: $d8206b3ab2e65c05$export$917a3d30f6cd766,
    faCircleChevronRight: $d8206b3ab2e65c05$export$a39bab13d51abfd0,
    faChevronCircleRight: $d8206b3ab2e65c05$export$2a5db4f6eba6f2b,
    faAt: $d8206b3ab2e65c05$export$c115e8063ee02632,
    faTrashCan: $d8206b3ab2e65c05$export$864bb8d6c21fb792,
    faTrashAlt: $d8206b3ab2e65c05$export$88df7ff7eb32f9dc,
    faTextHeight: $d8206b3ab2e65c05$export$3313bce3924ea7da,
    faUserXmark: $d8206b3ab2e65c05$export$e585697127cda27,
    faUserTimes: $d8206b3ab2e65c05$export$45b996d071667753,
    faStethoscope: $d8206b3ab2e65c05$export$acb2d72d28cd92d9,
    faMessage: $d8206b3ab2e65c05$export$6563a67224e7f879,
    faCommentAlt: $d8206b3ab2e65c05$export$6e96904d9af0ec4a,
    faInfo: $d8206b3ab2e65c05$export$d469b770895f47ac,
    faDownLeftAndUpRightToCenter: $d8206b3ab2e65c05$export$d56736f5800b3f0d,
    faCompressAlt: $d8206b3ab2e65c05$export$a05650ebe54bede,
    faExplosion: $d8206b3ab2e65c05$export$36b5fbeae4855055,
    faFileLines: $d8206b3ab2e65c05$export$ef565d07efe2b5e9,
    faFileAlt: $d8206b3ab2e65c05$export$243b47dca32bf0b8,
    faFileText: $d8206b3ab2e65c05$export$f466100bf9bf37a5,
    faWaveSquare: $d8206b3ab2e65c05$export$c38cf504b3bc58a2,
    faRing: $d8206b3ab2e65c05$export$a95486586631edc7,
    faBuildingUn: $d8206b3ab2e65c05$export$fbbc7601eb465ac7,
    faDiceThree: $d8206b3ab2e65c05$export$221059e0d5fd8958,
    faCalendarDays: $d8206b3ab2e65c05$export$31c6cf6f5d38dc0,
    faCalendarAlt: $d8206b3ab2e65c05$export$cbc139f33cff356,
    faAnchorCircleCheck: $d8206b3ab2e65c05$export$8bce49e6ae597af8,
    faBuildingCircleArrowRight: $d8206b3ab2e65c05$export$37584b1a5e175b47,
    faVolleyball: $d8206b3ab2e65c05$export$cc519c9529a46c5c,
    faVolleyballBall: $d8206b3ab2e65c05$export$a15e6fc8e68a76b0,
    faArrowsUpToLine: $d8206b3ab2e65c05$export$159982ce2622211e,
    faSortDown: $d8206b3ab2e65c05$export$58e2577a373e7d4,
    faSortDesc: $d8206b3ab2e65c05$export$e24f016f5f78af6a,
    faCircleMinus: $d8206b3ab2e65c05$export$d0163707993a8110,
    faMinusCircle: $d8206b3ab2e65c05$export$f3979b49bf57313c,
    faDoorOpen: $d8206b3ab2e65c05$export$41821b9a6fd703de,
    faRightFromBracket: $d8206b3ab2e65c05$export$122a80ae0f87f726,
    faSignOutAlt: $d8206b3ab2e65c05$export$c844d6923b7096c2,
    faAtom: $d8206b3ab2e65c05$export$b5bb295e8ad4ab31,
    faSoap: $d8206b3ab2e65c05$export$64f1c53b21f310ac,
    faIcons: $d8206b3ab2e65c05$export$7fe2894454d8eb8a,
    faHeartMusicCameraBolt: $d8206b3ab2e65c05$export$ec74c13cedb0791d,
    faMicrophoneLinesSlash: $d8206b3ab2e65c05$export$4be1b324ac8a71ba,
    faMicrophoneAltSlash: $d8206b3ab2e65c05$export$d2a53a388f30780,
    faBridgeCircleCheck: $d8206b3ab2e65c05$export$ea908d3d80c57d08,
    faPumpMedical: $d8206b3ab2e65c05$export$f1b881c73328720c,
    faFingerprint: $d8206b3ab2e65c05$export$614dc068d88655af,
    faHandPointRight: $d8206b3ab2e65c05$export$f7bc8714c970afa4,
    faMagnifyingGlassLocation: $d8206b3ab2e65c05$export$234a18b2b4d530a3,
    faSearchLocation: $d8206b3ab2e65c05$export$c33aba6c251a898a,
    faForwardStep: $d8206b3ab2e65c05$export$908d699be6717adc,
    faStepForward: $d8206b3ab2e65c05$export$b303329afce5de18,
    faFaceSmileBeam: $d8206b3ab2e65c05$export$e3c56ed54f074063,
    faSmileBeam: $d8206b3ab2e65c05$export$54ada6dc9690e0ca,
    faFlagCheckered: $d8206b3ab2e65c05$export$92fad97e19a9fea,
    faFootball: $d8206b3ab2e65c05$export$e15f65e77f717c29,
    faFootballBall: $d8206b3ab2e65c05$export$e8fd664711e31704,
    faSchoolCircleExclamation: $d8206b3ab2e65c05$export$f629fdee00932a01,
    faCrop: $d8206b3ab2e65c05$export$afa58590dfb6fca2,
    faAnglesDown: $d8206b3ab2e65c05$export$52783a541b1bb03,
    faAngleDoubleDown: $d8206b3ab2e65c05$export$fd504117f273ca92,
    faUsersRectangle: $d8206b3ab2e65c05$export$a28757068b9a3a9a,
    faPeopleRoof: $d8206b3ab2e65c05$export$b96e695bdcf3f3f5,
    faPeopleLine: $d8206b3ab2e65c05$export$d12c2d6def120efe,
    faBeerMugEmpty: $d8206b3ab2e65c05$export$b957c27bc5330472,
    faBeer: $d8206b3ab2e65c05$export$f74725691538983b,
    faDiagramPredecessor: $d8206b3ab2e65c05$export$1852c99deca7bee8,
    faArrowUpLong: $d8206b3ab2e65c05$export$92c58defe6e4c5a7,
    faLongArrowUp: $d8206b3ab2e65c05$export$ede1d50ec4b01670,
    faFireFlameSimple: $d8206b3ab2e65c05$export$9ebfff5c90672059,
    faBurn: $d8206b3ab2e65c05$export$80ed4535efc60402,
    faPerson: $d8206b3ab2e65c05$export$e6619e43cb090a16,
    faMale: $d8206b3ab2e65c05$export$2e21f9dba1630651,
    faLaptop: $d8206b3ab2e65c05$export$c2dee3bd177275a2,
    faFileCsv: $d8206b3ab2e65c05$export$82cea4f586f6ec9,
    faMenorah: $d8206b3ab2e65c05$export$232452c59d77c56e,
    faTruckPlane: $d8206b3ab2e65c05$export$e1d5ceed99060d76,
    faRecordVinyl: $d8206b3ab2e65c05$export$fe2d5012d9982673,
    faFaceGrinStars: $d8206b3ab2e65c05$export$1d1fbac384a76a12,
    faGrinStars: $d8206b3ab2e65c05$export$64347a5c8c402ef4,
    faBong: $d8206b3ab2e65c05$export$e74974fac77c468e,
    faSpaghettiMonsterFlying: $d8206b3ab2e65c05$export$3c8d5c62d76c33b8,
    faPastafarianism: $d8206b3ab2e65c05$export$733efdaec97447be,
    faArrowDownUpAcrossLine: $d8206b3ab2e65c05$export$9fe0c42ede2dd003,
    faSpoon: $d8206b3ab2e65c05$export$faf854a434ce6d0c,
    faUtensilSpoon: $d8206b3ab2e65c05$export$fb7af5d245fb9053,
    faJarWheat: $d8206b3ab2e65c05$export$8b503c1d76716ddd,
    faEnvelopesBulk: $d8206b3ab2e65c05$export$dc2cce064a1e70bb,
    faMailBulk: $d8206b3ab2e65c05$export$dd24f40c5337e2e1,
    faFileCircleExclamation: $d8206b3ab2e65c05$export$61fa9809253098e5,
    faCircleH: $d8206b3ab2e65c05$export$bf5674308c61894f,
    faHospitalSymbol: $d8206b3ab2e65c05$export$c8a3c78d99c23fed,
    faPager: $d8206b3ab2e65c05$export$e1611f373a10a98c,
    faAddressBook: $d8206b3ab2e65c05$export$853fd1561789e3bb,
    faContactBook: $d8206b3ab2e65c05$export$594b5a5d4d2e156b,
    faStrikethrough: $d8206b3ab2e65c05$export$eff51ea25b4de135,
    faK: $d8206b3ab2e65c05$export$3f85413cb67e7f67,
    faLandmarkFlag: $d8206b3ab2e65c05$export$f4d472cf47be4096,
    faPencil: $d8206b3ab2e65c05$export$c72de95adaca18b8,
    faPencilAlt: $d8206b3ab2e65c05$export$8210adc172262df,
    faBackward: $d8206b3ab2e65c05$export$ae65f96ea7a4078d,
    faCaretRight: $d8206b3ab2e65c05$export$f1011352b01c1c0,
    faComments: $d8206b3ab2e65c05$export$932912e74adb8939,
    faPaste: $d8206b3ab2e65c05$export$6f95f90dd1f6d86b,
    faFileClipboard: $d8206b3ab2e65c05$export$ca3229c47de163fa,
    faCodePullRequest: $d8206b3ab2e65c05$export$37576dfab037d8bf,
    faClipboardList: $d8206b3ab2e65c05$export$2c5a9d8548d8810e,
    faTruckRampBox: $d8206b3ab2e65c05$export$37396c36c76937bc,
    faTruckLoading: $d8206b3ab2e65c05$export$f00c152db7d44638,
    faUserCheck: $d8206b3ab2e65c05$export$76de2a120043c9f8,
    faVialVirus: $d8206b3ab2e65c05$export$a56b2b0a1073620c,
    faSheetPlastic: $d8206b3ab2e65c05$export$57f2bcd070bff91a,
    faBlog: $d8206b3ab2e65c05$export$890d5e011054935a,
    faUserNinja: $d8206b3ab2e65c05$export$a9174995732e03c5,
    faPersonArrowUpFromLine: $d8206b3ab2e65c05$export$5709329dd2b70bdc,
    faScrollTorah: $d8206b3ab2e65c05$export$4e3fe5b42a6cd494,
    faTorah: $d8206b3ab2e65c05$export$54d07baabd8c2acb,
    faBroomBall: $d8206b3ab2e65c05$export$3e1327487ce53231,
    faQuidditch: $d8206b3ab2e65c05$export$c00c446e6db1605f,
    faQuidditchBroomBall: $d8206b3ab2e65c05$export$791bfe29b97b4d42,
    faToggleOff: $d8206b3ab2e65c05$export$d20aaceb882ca545,
    faBoxArchive: $d8206b3ab2e65c05$export$2a0fcb66c3d79d00,
    faArchive: $d8206b3ab2e65c05$export$26b3e1c454273f34,
    faPersonDrowning: $d8206b3ab2e65c05$export$bac321083217fd4,
    faArrowDown91: $d8206b3ab2e65c05$export$6cc91ce23eb3fae1,
    faSortNumericDesc: $d8206b3ab2e65c05$export$99f058110e2c82a8,
    faSortNumericDownAlt: $d8206b3ab2e65c05$export$857385fda7a5a98e,
    faFaceGrinTongueSquint: $d8206b3ab2e65c05$export$8eee2c17ff89e724,
    faGrinTongueSquint: $d8206b3ab2e65c05$export$4edf34c3def09a31,
    faSprayCan: $d8206b3ab2e65c05$export$4952c502f544cf85,
    faTruckMonster: $d8206b3ab2e65c05$export$24b8a0147653649a,
    faW: $d8206b3ab2e65c05$export$c7f24bdea332f90a,
    faEarthAfrica: $d8206b3ab2e65c05$export$11afa141d42099d0,
    faGlobeAfrica: $d8206b3ab2e65c05$export$64af36f3b403a57c,
    faRainbow: $d8206b3ab2e65c05$export$92ab27739d3a91b2,
    faCircleNotch: $d8206b3ab2e65c05$export$9429fd8df55155d,
    faTabletScreenButton: $d8206b3ab2e65c05$export$df1e253fc358ade4,
    faTabletAlt: $d8206b3ab2e65c05$export$db0cac088255eacc,
    faPaw: $d8206b3ab2e65c05$export$7bc6e4d977673e69,
    faCloud: $d8206b3ab2e65c05$export$8bb3c4d5c2f50243,
    faTrowelBricks: $d8206b3ab2e65c05$export$b6c20c10ddbd9898,
    faFaceFlushed: $d8206b3ab2e65c05$export$ba5dc4287853ecbd,
    faFlushed: $d8206b3ab2e65c05$export$dfd2bd012685aeac,
    faHospitalUser: $d8206b3ab2e65c05$export$684703c93d630cc5,
    faTentArrowLeftRight: $d8206b3ab2e65c05$export$fa95eb7418c0e2b8,
    faGavel: $d8206b3ab2e65c05$export$c36fb40057e2c3aa,
    faLegal: $d8206b3ab2e65c05$export$59d593c2dacb3781,
    faBinoculars: $d8206b3ab2e65c05$export$8a910017964bb8c2,
    faMicrophoneSlash: $d8206b3ab2e65c05$export$843f63d64e6f7951,
    faBoxTissue: $d8206b3ab2e65c05$export$f2adc06617bc0c7,
    faMotorcycle: $d8206b3ab2e65c05$export$f26017bdca99338d,
    faBellConcierge: $d8206b3ab2e65c05$export$e433538b78718fb3,
    faConciergeBell: $d8206b3ab2e65c05$export$ad92ffbbfbc0fcf3,
    faPenRuler: $d8206b3ab2e65c05$export$85ba06027671d290,
    faPencilRuler: $d8206b3ab2e65c05$export$e3a7a1affea005f5,
    faPeopleArrows: $d8206b3ab2e65c05$export$804bfc5c390e1a2a,
    faPeopleArrowsLeftRight: $d8206b3ab2e65c05$export$da01f044c59e3598,
    faMarsAndVenusBurst: $d8206b3ab2e65c05$export$1dc6221efb867885,
    faSquareCaretRight: $d8206b3ab2e65c05$export$5b1d41cdd118ea6d,
    faCaretSquareRight: $d8206b3ab2e65c05$export$ae86c9de7e0f62fa,
    faScissors: $d8206b3ab2e65c05$export$b2a906a5928c6404,
    faCut: $d8206b3ab2e65c05$export$66847f2a71b260e7,
    faSunPlantWilt: $d8206b3ab2e65c05$export$8db7f2f70484e17e,
    faToiletsPortable: $d8206b3ab2e65c05$export$c00f55f36d386cb7,
    faHockeyPuck: $d8206b3ab2e65c05$export$a274b02dc75663dc,
    faTable: $d8206b3ab2e65c05$export$36583f5d3d5a971f,
    faMagnifyingGlassArrowRight: $d8206b3ab2e65c05$export$382d3376c7fc7fc5,
    faTachographDigital: $d8206b3ab2e65c05$export$73f2bf302381c86a,
    faDigitalTachograph: $d8206b3ab2e65c05$export$b3bf1994f0fefe98,
    faUsersSlash: $d8206b3ab2e65c05$export$b71a093b86e3da1f,
    faClover: $d8206b3ab2e65c05$export$57813571c0e10a0a,
    faReply: $d8206b3ab2e65c05$export$bb06d4a7bb6736fe,
    faMailReply: $d8206b3ab2e65c05$export$12e45ff70d2646a1,
    faStarAndCrescent: $d8206b3ab2e65c05$export$cafa834c96ebcb1a,
    faHouseFire: $d8206b3ab2e65c05$export$947ee033a6942aa8,
    faSquareMinus: $d8206b3ab2e65c05$export$814c9edba7b84aa4,
    faMinusSquare: $d8206b3ab2e65c05$export$ffe9387966b3e681,
    faHelicopter: $d8206b3ab2e65c05$export$612d3e1afaf45fa5,
    faCompass: $d8206b3ab2e65c05$export$b4d344633433e50e,
    faSquareCaretDown: $d8206b3ab2e65c05$export$a1ab39cd66c4e50e,
    faCaretSquareDown: $d8206b3ab2e65c05$export$61aea18df1c84401,
    faFileCircleQuestion: $d8206b3ab2e65c05$export$877d3692c1f94bda,
    faLaptopCode: $d8206b3ab2e65c05$export$94100f4c6ee29932,
    faSwatchbook: $d8206b3ab2e65c05$export$c74a20c81b957b6a,
    faPrescriptionBottle: $d8206b3ab2e65c05$export$214f9ce665590486,
    faBars: $d8206b3ab2e65c05$export$36e9cf7887265da2,
    faNavicon: $d8206b3ab2e65c05$export$409fa7bcaa0e4cd9,
    faPeopleGroup: $d8206b3ab2e65c05$export$be015e72863c3635,
    faHourglassEnd: $d8206b3ab2e65c05$export$52757ecc5b1e25b9,
    faHourglass3: $d8206b3ab2e65c05$export$1ec43c81fef8ffd6,
    faHeartCrack: $d8206b3ab2e65c05$export$8e521ef33062b00e,
    faHeartBroken: $d8206b3ab2e65c05$export$4a565395cb65b282,
    faSquareUpRight: $d8206b3ab2e65c05$export$a47a20ab7bde8c67,
    faExternalLinkSquareAlt: $d8206b3ab2e65c05$export$e4cdf2977151ee26,
    faFaceKissBeam: $d8206b3ab2e65c05$export$eca99665af566fe1,
    faKissBeam: $d8206b3ab2e65c05$export$d6ff8a73c0812e63,
    faFilm: $d8206b3ab2e65c05$export$c03de0cc616e77bb,
    faRulerHorizontal: $d8206b3ab2e65c05$export$46c6347bff3e04a,
    faPeopleRobbery: $d8206b3ab2e65c05$export$75ce8513e1f1c5c4,
    faLightbulb: $d8206b3ab2e65c05$export$1e80f89fe84a215b,
    faCaretLeft: $d8206b3ab2e65c05$export$85a918a11b7643c2,
    faCircleExclamation: $d8206b3ab2e65c05$export$59573943f9eebbd5,
    faExclamationCircle: $d8206b3ab2e65c05$export$220e07e14c5d7e5d,
    faSchoolCircleXmark: $d8206b3ab2e65c05$export$5e17b20e0f6b132b,
    faArrowRightFromBracket: $d8206b3ab2e65c05$export$ca14f1b4d6afb7aa,
    faSignOut: $d8206b3ab2e65c05$export$33e2b60243ca6d92,
    faCircleChevronDown: $d8206b3ab2e65c05$export$aca07924996218d8,
    faChevronCircleDown: $d8206b3ab2e65c05$export$9926124d75b2ecab,
    faUnlockKeyhole: $d8206b3ab2e65c05$export$c98fdd5082b333ec,
    faUnlockAlt: $d8206b3ab2e65c05$export$b19f508797f3d9c3,
    faCloudShowersHeavy: $d8206b3ab2e65c05$export$af51c741ee9cc090,
    faHeadphonesSimple: $d8206b3ab2e65c05$export$ca47801915e5a685,
    faHeadphonesAlt: $d8206b3ab2e65c05$export$6f0433fa527dd5be,
    faSitemap: $d8206b3ab2e65c05$export$b2ce5e79d0eccaf8,
    faCircleDollarToSlot: $d8206b3ab2e65c05$export$5f92ac3e804644e3,
    faDonate: $d8206b3ab2e65c05$export$40050ae52860cde7,
    faMemory: $d8206b3ab2e65c05$export$5f9bd9f6df021f93,
    faRoadSpikes: $d8206b3ab2e65c05$export$b372a24046126ad8,
    faFireBurner: $d8206b3ab2e65c05$export$e4e44f7b1886fef,
    faFlag: $d8206b3ab2e65c05$export$6591b1ea509be9da,
    faHanukiah: $d8206b3ab2e65c05$export$3dcd4ca3f7108a82,
    faFeather: $d8206b3ab2e65c05$export$5e19aea195b31816,
    faVolumeLow: $d8206b3ab2e65c05$export$2b1464e7557b18eb,
    faVolumeDown: $d8206b3ab2e65c05$export$69fdf57632b6cc29,
    faCommentSlash: $d8206b3ab2e65c05$export$3786a0422a3f33ea,
    faCloudSunRain: $d8206b3ab2e65c05$export$dd9dc9b4227dbe94,
    faCompress: $d8206b3ab2e65c05$export$83632d1150d3541f,
    faWheatAwn: $d8206b3ab2e65c05$export$79d4dac715a51fdf,
    faWheatAlt: $d8206b3ab2e65c05$export$deaf03a29aa05e3a,
    faAnkh: $d8206b3ab2e65c05$export$8736909014b15ca9,
    faHandsHoldingChild: $d8206b3ab2e65c05$export$bfb254bf3c0bc50b,
    faAsterisk: $d8206b3ab2e65c05$export$19eff32c0fd4f99f,
    faSquareCheck: $d8206b3ab2e65c05$export$5bb6a0c94ad2f4bb,
    faCheckSquare: $d8206b3ab2e65c05$export$f0c8040f596df7fe,
    faPesetaSign: $d8206b3ab2e65c05$export$a6f8654bcd49a39f,
    faHeading: $d8206b3ab2e65c05$export$4805b8d175aeb9fb,
    faHeader: $d8206b3ab2e65c05$export$579f9604bb10a61a,
    faGhost: $d8206b3ab2e65c05$export$1a989eb1919c64c1,
    faList: $d8206b3ab2e65c05$export$6cfc59842fedbc16,
    faListSquares: $d8206b3ab2e65c05$export$e3f160fc949c2b9d,
    faSquarePhoneFlip: $d8206b3ab2e65c05$export$b627121801cad756,
    faPhoneSquareAlt: $d8206b3ab2e65c05$export$a41e77f0de98bba7,
    faCartPlus: $d8206b3ab2e65c05$export$6675e2bf21fdb87e,
    faGamepad: $d8206b3ab2e65c05$export$6a66b1b639455bef,
    faCircleDot: $d8206b3ab2e65c05$export$aa13d9234890e8d3,
    faDotCircle: $d8206b3ab2e65c05$export$92bc269cb244d66a,
    faFaceDizzy: $d8206b3ab2e65c05$export$635e4d8cc8428961,
    faDizzy: $d8206b3ab2e65c05$export$89a2b10dabc487e8,
    faEgg: $d8206b3ab2e65c05$export$1199a8ce85311ab5,
    faHouseMedicalCircleXmark: $d8206b3ab2e65c05$export$bf221f0e8296233e,
    faCampground: $d8206b3ab2e65c05$export$295287303c0e9c7c,
    faFolderPlus: $d8206b3ab2e65c05$export$e18e05ffa2045d3b,
    faFutbol: $d8206b3ab2e65c05$export$65a345b33858a655,
    faFutbolBall: $d8206b3ab2e65c05$export$51a344ca0a215620,
    faSoccerBall: $d8206b3ab2e65c05$export$f4a29712c724ba2d,
    faPaintbrush: $d8206b3ab2e65c05$export$7c8b56f3f296a814,
    faPaintBrush: $d8206b3ab2e65c05$export$594db3339e212bc9,
    faLock: $d8206b3ab2e65c05$export$7aa08ad5d562578a,
    faGasPump: $d8206b3ab2e65c05$export$84666c793cb2a347,
    faHotTubPerson: $d8206b3ab2e65c05$export$6e6bd68568c17bbf,
    faHotTub: $d8206b3ab2e65c05$export$4842af92b516c40b,
    faMapLocation: $d8206b3ab2e65c05$export$9a8788ec0e4a9a0b,
    faMapMarked: $d8206b3ab2e65c05$export$df04458e7e32352c,
    faHouseFloodWater: $d8206b3ab2e65c05$export$70fd6006b4e54a5,
    faTree: $d8206b3ab2e65c05$export$1744430f718caf6b,
    faBridgeLock: $d8206b3ab2e65c05$export$cffe7d85a82d8116,
    faSackDollar: $d8206b3ab2e65c05$export$15854c4475080853,
    faPenToSquare: $d8206b3ab2e65c05$export$ba236543926e3569,
    faEdit: $d8206b3ab2e65c05$export$7be713e57d023733,
    faCarSide: $d8206b3ab2e65c05$export$6f7218565b1b8d0e,
    faShareNodes: $d8206b3ab2e65c05$export$cdaf45d4e50ac035,
    faShareAlt: $d8206b3ab2e65c05$export$f8e8bb0b3aa8c658,
    faHeartCircleMinus: $d8206b3ab2e65c05$export$24c21c3ca00f3625,
    faHourglassHalf: $d8206b3ab2e65c05$export$703272eebf5e3eea,
    faHourglass2: $d8206b3ab2e65c05$export$f1052bbf6bf361c0,
    faMicroscope: $d8206b3ab2e65c05$export$6a99139787bf9967,
    faSink: $d8206b3ab2e65c05$export$2a9dda2096ce792e,
    faBagShopping: $d8206b3ab2e65c05$export$b0137b4600e9ab12,
    faShoppingBag: $d8206b3ab2e65c05$export$5745f8adbc11eb01,
    faArrowDownZA: $d8206b3ab2e65c05$export$cf79d63ad07d943a,
    faSortAlphaDesc: $d8206b3ab2e65c05$export$7caf99612a55d427,
    faSortAlphaDownAlt: $d8206b3ab2e65c05$export$e12d23d82d5c8a89,
    faMitten: $d8206b3ab2e65c05$export$5030322c5fc886d7,
    faPersonRays: $d8206b3ab2e65c05$export$49577f913f0fe4d2,
    faUsers: $d8206b3ab2e65c05$export$e5a8f011aef571ac,
    faEyeSlash: $d8206b3ab2e65c05$export$ed3f2918429d029a,
    faFlaskVial: $d8206b3ab2e65c05$export$a25a266ce0c95019,
    faHand: $d8206b3ab2e65c05$export$f69db0b876f7d753,
    faHandPaper: $d8206b3ab2e65c05$export$6e6216c8b50471bb,
    faOm: $d8206b3ab2e65c05$export$8de8eb94230028a5,
    faWorm: $d8206b3ab2e65c05$export$2571e33fa6c25993,
    faHouseCircleXmark: $d8206b3ab2e65c05$export$423555e8708eb4c7,
    faPlug: $d8206b3ab2e65c05$export$cae5752c3e3b6545,
    faChevronUp: $d8206b3ab2e65c05$export$877e5ae47a854215,
    faHandSpock: $d8206b3ab2e65c05$export$2262d6b626de1120,
    faStopwatch: $d8206b3ab2e65c05$export$b85a7300fc7960b6,
    faFaceKiss: $d8206b3ab2e65c05$export$5a54c83033a0a56a,
    faKiss: $d8206b3ab2e65c05$export$c762a77aabf64fd0,
    faBridgeCircleXmark: $d8206b3ab2e65c05$export$834071278537f121,
    faFaceGrinTongue: $d8206b3ab2e65c05$export$95a7394c24f57943,
    faGrinTongue: $d8206b3ab2e65c05$export$ef222816a43a4b3a,
    faChessBishop: $d8206b3ab2e65c05$export$a831eedd2f59c62f,
    faFaceGrinWink: $d8206b3ab2e65c05$export$1dd161850c5bc64e,
    faGrinWink: $d8206b3ab2e65c05$export$2397fcd34eb12177,
    faEarDeaf: $d8206b3ab2e65c05$export$c9c5b76ec992eab4,
    faDeaf: $d8206b3ab2e65c05$export$4b666adf83f0de01,
    faDeafness: $d8206b3ab2e65c05$export$85c6a9ab2fa2631e,
    faHardOfHearing: $d8206b3ab2e65c05$export$ebecf90a5676e17a,
    faRoadCircleCheck: $d8206b3ab2e65c05$export$3f22db9ae9b6be1c,
    faDiceFive: $d8206b3ab2e65c05$export$d9769fb795c2db82,
    faSquareRss: $d8206b3ab2e65c05$export$97d1903b1e012ff7,
    faRssSquare: $d8206b3ab2e65c05$export$89c9b1cca2c11484,
    faLandMineOn: $d8206b3ab2e65c05$export$567a897fc092e403,
    faICursor: $d8206b3ab2e65c05$export$7fddf76ec23943d8,
    faStamp: $d8206b3ab2e65c05$export$722e92d2d93ffc68,
    faStairs: $d8206b3ab2e65c05$export$68b3af7444c89df7,
    faI: $d8206b3ab2e65c05$export$aee03ca0815b7c38,
    faHryvniaSign: $d8206b3ab2e65c05$export$22a9491150c64fef,
    faHryvnia: $d8206b3ab2e65c05$export$33d5f94bd6f75f59,
    faPills: $d8206b3ab2e65c05$export$6380e2ed6e69d350,
    faFaceGrinWide: $d8206b3ab2e65c05$export$bdbabf493c478cde,
    faGrinAlt: $d8206b3ab2e65c05$export$b4abebfe416d36ba,
    faTooth: $d8206b3ab2e65c05$export$3a1fa2d16f90d635,
    faV: $d8206b3ab2e65c05$export$6fb446f784f6b9b3,
    faBangladeshiTakaSign: $d8206b3ab2e65c05$export$469d376940e10d37,
    faBicycle: $d8206b3ab2e65c05$export$36cb1885ad7a570f,
    faStaffSnake: $d8206b3ab2e65c05$export$76d998742bc186eb,
    faRodAsclepius: $d8206b3ab2e65c05$export$f2c3e92ee37a8d89,
    faRodSnake: $d8206b3ab2e65c05$export$5d61dcb598296af0,
    faStaffAesculapius: $d8206b3ab2e65c05$export$97c8a2cdba3b7700,
    faHeadSideCoughSlash: $d8206b3ab2e65c05$export$b293ee8fb8e6b0c4,
    faTruckMedical: $d8206b3ab2e65c05$export$fb6bd43f079f72e2,
    faAmbulance: $d8206b3ab2e65c05$export$f5c7042778b51765,
    faWheatAwnCircleExclamation: $d8206b3ab2e65c05$export$e23367e54f665590,
    faSnowman: $d8206b3ab2e65c05$export$b23df6bafb174693,
    faMortarPestle: $d8206b3ab2e65c05$export$55ceb5d0c144580a,
    faRoadBarrier: $d8206b3ab2e65c05$export$f3e925217e396f44,
    faSchool: $d8206b3ab2e65c05$export$51e9b8434982947d,
    faIgloo: $d8206b3ab2e65c05$export$4a284575edd6f1af,
    faJoint: $d8206b3ab2e65c05$export$e5a289fb22ffb8cb,
    faAngleRight: $d8206b3ab2e65c05$export$6bce1afb61f2eb66,
    faHorse: $d8206b3ab2e65c05$export$5b05f097fa38352a,
    faQ: $d8206b3ab2e65c05$export$5a2b164552deda9f,
    faG: $d8206b3ab2e65c05$export$9f5c2b0db8eedeac,
    faNotesMedical: $d8206b3ab2e65c05$export$b2d79133c81d6697,
    faTemperatureHalf: $d8206b3ab2e65c05$export$a3f1d7f13c202adc,
    faTemperature2: $d8206b3ab2e65c05$export$8176e649df45b32c,
    faThermometer2: $d8206b3ab2e65c05$export$4dd764ac8d512682,
    faThermometerHalf: $d8206b3ab2e65c05$export$2090f040324b4449,
    faDongSign: $d8206b3ab2e65c05$export$18659308f17918a5,
    faCapsules: $d8206b3ab2e65c05$export$ba6fd4a436804a48,
    faPooStorm: $d8206b3ab2e65c05$export$48a38da471b097a2,
    faPooBolt: $d8206b3ab2e65c05$export$9a24e77f74d9cbd9,
    faFaceFrownOpen: $d8206b3ab2e65c05$export$c8a28356e07b9ccb,
    faFrownOpen: $d8206b3ab2e65c05$export$c4775e66bed5d96,
    faHandPointUp: $d8206b3ab2e65c05$export$cdc9f5e7e94e76da,
    faMoneyBill: $d8206b3ab2e65c05$export$608138a7337b5d1a,
    faBookmark: $d8206b3ab2e65c05$export$4ed9da5c3cca0ef1,
    faAlignJustify: $d8206b3ab2e65c05$export$97c42b56d462df72,
    faUmbrellaBeach: $d8206b3ab2e65c05$export$20932e4d438e4e4c,
    faHelmetUn: $d8206b3ab2e65c05$export$5e975cb293c48461,
    faBullseye: $d8206b3ab2e65c05$export$554720e3bf74fe90,
    faBacon: $d8206b3ab2e65c05$export$ab07061fe21a3a8e,
    faHandPointDown: $d8206b3ab2e65c05$export$f6dcbf0a940428f4,
    faArrowUpFromBracket: $d8206b3ab2e65c05$export$c2af1be14cd87640,
    faFolder: $d8206b3ab2e65c05$export$72b780186370e953,
    faFolderBlank: $d8206b3ab2e65c05$export$9ef114244d26da0,
    faFileWaveform: $d8206b3ab2e65c05$export$5e0c19cf315ac1bf,
    faFileMedicalAlt: $d8206b3ab2e65c05$export$ef02a0f5b39aa61f,
    faRadiation: $d8206b3ab2e65c05$export$4c4e509518093d6d,
    faChartSimple: $d8206b3ab2e65c05$export$8760a1de19ea40b9,
    faMarsStroke: $d8206b3ab2e65c05$export$aa05fce255a5d269,
    faVial: $d8206b3ab2e65c05$export$aa014b06d2d70598,
    faGauge: $d8206b3ab2e65c05$export$dbfb0a9f89ad94a4,
    faDashboard: $d8206b3ab2e65c05$export$b7ce24136743d0f1,
    faGaugeMed: $d8206b3ab2e65c05$export$f948a9dd257979f3,
    faTachometerAltAverage: $d8206b3ab2e65c05$export$6f22c345e5a92d1a,
    faWandMagicSparkles: $d8206b3ab2e65c05$export$5325fc72e75360b4,
    faMagicWandSparkles: $d8206b3ab2e65c05$export$c93286938249f0da,
    faE: $d8206b3ab2e65c05$export$86923e6fe1b42f5e,
    faPenClip: $d8206b3ab2e65c05$export$eff4bdcafd3b8d1c,
    faPenAlt: $d8206b3ab2e65c05$export$a3d3e92e430d3beb,
    faBridgeCircleExclamation: $d8206b3ab2e65c05$export$4f25939fdf728c27,
    faUser: $d8206b3ab2e65c05$export$f5699fa0844e0188,
    faSchoolCircleCheck: $d8206b3ab2e65c05$export$c8c95c2f9937bf6a,
    faDumpster: $d8206b3ab2e65c05$export$3b934e22d1851a3b,
    faVanShuttle: $d8206b3ab2e65c05$export$ecbd233b96906ee1,
    faShuttleVan: $d8206b3ab2e65c05$export$9d63d851db698c09,
    faBuildingUser: $d8206b3ab2e65c05$export$d65aef1ed7db1dae,
    faSquareCaretLeft: $d8206b3ab2e65c05$export$2c5163541229363,
    faCaretSquareLeft: $d8206b3ab2e65c05$export$d0c8ba444f1f9581,
    faHighlighter: $d8206b3ab2e65c05$export$73801ed54b42fabe,
    faKey: $d8206b3ab2e65c05$export$fa6ecc35e7315db,
    faBullhorn: $d8206b3ab2e65c05$export$dacae2b4ec565333,
    faGlobe: $d8206b3ab2e65c05$export$b1b1cdce4a19c682,
    faSynagogue: $d8206b3ab2e65c05$export$20d991385719b5b4,
    faPersonHalfDress: $d8206b3ab2e65c05$export$f3d75c19191f1688,
    faRoadBridge: $d8206b3ab2e65c05$export$4d6835e7175dec24,
    faLocationArrow: $d8206b3ab2e65c05$export$4ac9c4c370f7b157,
    faC: $d8206b3ab2e65c05$export$a2c1c457834fc6d8,
    faTabletButton: $d8206b3ab2e65c05$export$2d33c367b2b091ac,
    faBuildingLock: $d8206b3ab2e65c05$export$6f08294ba8a2459c,
    faPizzaSlice: $d8206b3ab2e65c05$export$c9f93c4667edc585,
    faMoneyBillWave: $d8206b3ab2e65c05$export$53e23123cc9a6796,
    faChartArea: $d8206b3ab2e65c05$export$2acab8312b7a999b,
    faAreaChart: $d8206b3ab2e65c05$export$fc2e595f0e0612cb,
    faHouseFlag: $d8206b3ab2e65c05$export$9a3d31c75a465b9a,
    faPersonCircleMinus: $d8206b3ab2e65c05$export$d7ccc6651f90f7cc,
    faBan: $d8206b3ab2e65c05$export$76f704d256def3c7,
    faCancel: $d8206b3ab2e65c05$export$6d25ef56192f6d69,
    faCameraRotate: $d8206b3ab2e65c05$export$e0ce7d1aba7105e7,
    faSprayCanSparkles: $d8206b3ab2e65c05$export$43832c90c10a7a31,
    faAirFreshener: $d8206b3ab2e65c05$export$a5e63e89b5ccee83,
    faStar: $d8206b3ab2e65c05$export$a3b0eb2cd7942125,
    faRepeat: $d8206b3ab2e65c05$export$cb8434288c91ae83,
    faCross: $d8206b3ab2e65c05$export$9d0a89fcd084abb,
    faBox: $d8206b3ab2e65c05$export$6e7cf270cda52323,
    faVenusMars: $d8206b3ab2e65c05$export$63f2d9e5f4689aa8,
    faArrowPointer: $d8206b3ab2e65c05$export$e4f903bc63db445,
    faMousePointer: $d8206b3ab2e65c05$export$2e19a69cc26b147,
    faMaximize: $d8206b3ab2e65c05$export$8d2b1b230601e804,
    faExpandArrowsAlt: $d8206b3ab2e65c05$export$6219dcd88b5fa6c2,
    faChargingStation: $d8206b3ab2e65c05$export$bab2cd86f8c65657,
    faShapes: $d8206b3ab2e65c05$export$b17d50542d1fc340,
    faTriangleCircleSquare: $d8206b3ab2e65c05$export$34261e5aea24fc1d,
    faShuffle: $d8206b3ab2e65c05$export$ee94b652453ad208,
    faRandom: $d8206b3ab2e65c05$export$8357bf8cc666d5f0,
    faPersonRunning: $d8206b3ab2e65c05$export$f48814ae62850c74,
    faRunning: $d8206b3ab2e65c05$export$5dfd1cb43dc9eadb,
    faMobileRetro: $d8206b3ab2e65c05$export$7955f08360418647,
    faGripLinesVertical: $d8206b3ab2e65c05$export$523960de087f5198,
    faSpider: $d8206b3ab2e65c05$export$6daa96b1986e2ef0,
    faHandsBound: $d8206b3ab2e65c05$export$740142a89118fbc0,
    faFileInvoiceDollar: $d8206b3ab2e65c05$export$a3dced32d48cb1ea,
    faPlaneCircleExclamation: $d8206b3ab2e65c05$export$f201ba865ea1b8dc,
    faXRay: $d8206b3ab2e65c05$export$8cf137aceaaf4de0,
    faSpellCheck: $d8206b3ab2e65c05$export$761e747b06ed2e1f,
    faSlash: $d8206b3ab2e65c05$export$f54d004dd5f1cb5e,
    faComputerMouse: $d8206b3ab2e65c05$export$72cf138e5ddda6eb,
    faMouse: $d8206b3ab2e65c05$export$198b96b894c66074,
    faArrowRightToBracket: $d8206b3ab2e65c05$export$a02c5909359525be,
    faSignIn: $d8206b3ab2e65c05$export$a55eff0ca4f9c3df,
    faShopSlash: $d8206b3ab2e65c05$export$b3d636689da4a3e5,
    faStoreAltSlash: $d8206b3ab2e65c05$export$b932a586f6ff48b4,
    faServer: $d8206b3ab2e65c05$export$1bf820d499b6202e,
    faVirusCovidSlash: $d8206b3ab2e65c05$export$61c2a6b698f55df6,
    faShopLock: $d8206b3ab2e65c05$export$452410c103c2403b,
    faHourglassStart: $d8206b3ab2e65c05$export$f0c28584caa8f4b,
    faHourglass1: $d8206b3ab2e65c05$export$87929336ab5c59cd,
    faBlenderPhone: $d8206b3ab2e65c05$export$f35a116a762ef8fc,
    faBuildingWheat: $d8206b3ab2e65c05$export$6c0cfe6d58faf860,
    faPersonBreastfeeding: $d8206b3ab2e65c05$export$9b94ed8d16d281f9,
    faRightToBracket: $d8206b3ab2e65c05$export$a5fd2acfcb5247c6,
    faSignInAlt: $d8206b3ab2e65c05$export$e6709746115bd2ea,
    faVenus: $d8206b3ab2e65c05$export$f89d028573ffc0a6,
    faPassport: $d8206b3ab2e65c05$export$2c31ca0d9bee400f,
    faThumbtackSlash: $d8206b3ab2e65c05$export$e1ef956136031821,
    faThumbTackSlash: $d8206b3ab2e65c05$export$e7a52e4a0831fa96,
    faHeartPulse: $d8206b3ab2e65c05$export$a6d8e50dcd4b4294,
    faHeartbeat: $d8206b3ab2e65c05$export$ca880e19206e80aa,
    faPeopleCarryBox: $d8206b3ab2e65c05$export$7754cc6d5559ff38,
    faPeopleCarry: $d8206b3ab2e65c05$export$35fbd4ff1265acd5,
    faTemperatureHigh: $d8206b3ab2e65c05$export$15d012277c3ecf9a,
    faMicrochip: $d8206b3ab2e65c05$export$4a7bb4be15f35178,
    faCrown: $d8206b3ab2e65c05$export$dc1083dcd1d7b9d6,
    faWeightHanging: $d8206b3ab2e65c05$export$43d1fa6671908715,
    faXmarksLines: $d8206b3ab2e65c05$export$f4595f012786d346,
    faFilePrescription: $d8206b3ab2e65c05$export$a20cb90865b6beb8,
    faWeightScale: $d8206b3ab2e65c05$export$e521c542d18b85c3,
    faWeight: $d8206b3ab2e65c05$export$cf3bafa68a60bae4,
    faUserGroup: $d8206b3ab2e65c05$export$3d626cfc365a7e36,
    faUserFriends: $d8206b3ab2e65c05$export$46073bec205635d9,
    faArrowUpAZ: $d8206b3ab2e65c05$export$fb00fdd8857804c7,
    faSortAlphaUp: $d8206b3ab2e65c05$export$3c4115b156be730d,
    faChessKnight: $d8206b3ab2e65c05$export$861b1f13085cf122,
    faFaceLaughSquint: $d8206b3ab2e65c05$export$67ca89c1ca38d559,
    faLaughSquint: $d8206b3ab2e65c05$export$b206e700cf7084e1,
    faWheelchair: $d8206b3ab2e65c05$export$76a9413fbe130a53,
    faCircleArrowUp: $d8206b3ab2e65c05$export$a29c8ea43e92771d,
    faArrowCircleUp: $d8206b3ab2e65c05$export$a2f6f3baa50af0b1,
    faToggleOn: $d8206b3ab2e65c05$export$5cffc34afa81e517,
    faPersonWalking: $d8206b3ab2e65c05$export$6af1cc5998ca52bc,
    faWalking: $d8206b3ab2e65c05$export$4886811b7174ec35,
    faL: $d8206b3ab2e65c05$export$be32b10ce70a09df,
    faFire: $d8206b3ab2e65c05$export$7b24b34ef6cc130c,
    faBedPulse: $d8206b3ab2e65c05$export$580ae0d0bbd809fb,
    faProcedures: $d8206b3ab2e65c05$export$5f9e1870e1866dde,
    faShuttleSpace: $d8206b3ab2e65c05$export$76d92e7f30d064c5,
    faSpaceShuttle: $d8206b3ab2e65c05$export$4d1c12ba2b4ca565,
    faFaceLaugh: $d8206b3ab2e65c05$export$2f203616c892d415,
    faLaugh: $d8206b3ab2e65c05$export$6c74e314e801a4fe,
    faFolderOpen: $d8206b3ab2e65c05$export$ff7e93418af88b78,
    faHeartCirclePlus: $d8206b3ab2e65c05$export$2a155a6e20f64134,
    faCodeFork: $d8206b3ab2e65c05$export$f54081bdbf6d4eb5,
    faCity: $d8206b3ab2e65c05$export$a9947c2888b3c8fd,
    faMicrophoneLines: $d8206b3ab2e65c05$export$417391ae30b5922e,
    faMicrophoneAlt: $d8206b3ab2e65c05$export$f08ef94fea14f5ac,
    faPepperHot: $d8206b3ab2e65c05$export$4894bf28f771e1f3,
    faUnlock: $d8206b3ab2e65c05$export$db1382cd406cc506,
    faColonSign: $d8206b3ab2e65c05$export$dec10d4c2c113312,
    faHeadset: $d8206b3ab2e65c05$export$23b086400a31acfe,
    faStoreSlash: $d8206b3ab2e65c05$export$4ab2f33219630bad,
    faRoadCircleXmark: $d8206b3ab2e65c05$export$2ffc88a4d31e8ffc,
    faUserMinus: $d8206b3ab2e65c05$export$d6e17c0df8ed1bf7,
    faMarsStrokeUp: $d8206b3ab2e65c05$export$efc6d53e0dedceee,
    faMarsStrokeV: $d8206b3ab2e65c05$export$ed7aa1c25104f333,
    faChampagneGlasses: $d8206b3ab2e65c05$export$7df1926e9eef8cc3,
    faGlassCheers: $d8206b3ab2e65c05$export$20007d7d74cb98fe,
    faClipboard: $d8206b3ab2e65c05$export$97d84347d71ba297,
    faHouseCircleExclamation: $d8206b3ab2e65c05$export$8403e4b31e8aa805,
    faFileArrowUp: $d8206b3ab2e65c05$export$929df388c07f293d,
    faFileUpload: $d8206b3ab2e65c05$export$dd55ded1264643d2,
    faWifi: $d8206b3ab2e65c05$export$1642419fe3db2857,
    faWifi3: $d8206b3ab2e65c05$export$2349bb04a04f4b2d,
    faWifiStrong: $d8206b3ab2e65c05$export$4b3167c852f4c4aa,
    faBath: $d8206b3ab2e65c05$export$1ea66a88b8f620c9,
    faBathtub: $d8206b3ab2e65c05$export$40ae013b5e6269d8,
    faUnderline: $d8206b3ab2e65c05$export$22346afd6a3cddf8,
    faUserPen: $d8206b3ab2e65c05$export$3842882ea09b25af,
    faUserEdit: $d8206b3ab2e65c05$export$a68a6960fc8eef82,
    faSignature: $d8206b3ab2e65c05$export$afa7b53ac8ebcb5d,
    faStroopwafel: $d8206b3ab2e65c05$export$195780ddabd8e0c6,
    faBold: $d8206b3ab2e65c05$export$7e0c7fd2a2e88823,
    faAnchorLock: $d8206b3ab2e65c05$export$217195c80db39097,
    faBuildingNgo: $d8206b3ab2e65c05$export$374e1dce366a2175,
    faManatSign: $d8206b3ab2e65c05$export$1ff755b523ab2851,
    faNotEqual: $d8206b3ab2e65c05$export$6a15ccae09bbaf93,
    faBorderTopLeft: $d8206b3ab2e65c05$export$cf897c3e0abd59e4,
    faBorderStyle: $d8206b3ab2e65c05$export$c2867ca78120d644,
    faMapLocationDot: $d8206b3ab2e65c05$export$757f50b8af780c19,
    faMapMarkedAlt: $d8206b3ab2e65c05$export$a977d47c74d8e86c,
    faJedi: $d8206b3ab2e65c05$export$859f204e59641ca4,
    faSquarePollVertical: $d8206b3ab2e65c05$export$91d747e5aabe6fe8,
    faPoll: $d8206b3ab2e65c05$export$bc8ca14ab51f93db,
    faMugHot: $d8206b3ab2e65c05$export$47a822c30184e8af,
    faCarBattery: $d8206b3ab2e65c05$export$a44d0c11093d9c1e,
    faBatteryCar: $d8206b3ab2e65c05$export$9133165ca669dd4b,
    faGift: $d8206b3ab2e65c05$export$b2727de8ccdbb5ec,
    faDiceTwo: $d8206b3ab2e65c05$export$4d85df590065572f,
    faChessQueen: $d8206b3ab2e65c05$export$7b8ce73615739d30,
    faGlasses: $d8206b3ab2e65c05$export$58d7d709c0a8ca5f,
    faChessBoard: $d8206b3ab2e65c05$export$bd301515df6246af,
    faBuildingCircleCheck: $d8206b3ab2e65c05$export$5559de5f969b9590,
    faPersonChalkboard: $d8206b3ab2e65c05$export$c9dc1583b207b7ff,
    faMarsStrokeRight: $d8206b3ab2e65c05$export$321e84e6a900c2d6,
    faMarsStrokeH: $d8206b3ab2e65c05$export$5cb0daeafbcdabe3,
    faHandBackFist: $d8206b3ab2e65c05$export$be38a892fe9b4098,
    faHandRock: $d8206b3ab2e65c05$export$97a81eba394c8c44,
    faSquareCaretUp: $d8206b3ab2e65c05$export$66068918abb14406,
    faCaretSquareUp: $d8206b3ab2e65c05$export$307ae80b26533ce5,
    faCloudShowersWater: $d8206b3ab2e65c05$export$b416056e795d2eac,
    faChartBar: $d8206b3ab2e65c05$export$b532f5d25de97633,
    faBarChart: $d8206b3ab2e65c05$export$2d5f754a5e5738b,
    faHandsBubbles: $d8206b3ab2e65c05$export$2f78563e14e49916,
    faHandsWash: $d8206b3ab2e65c05$export$996b5dea53b124e3,
    faLessThanEqual: $d8206b3ab2e65c05$export$b2c723344cff0d8,
    faTrain: $d8206b3ab2e65c05$export$17cde74bf6f1ee89,
    faEyeLowVision: $d8206b3ab2e65c05$export$23a892b1a4b994bd,
    faLowVision: $d8206b3ab2e65c05$export$7a65d2aa54cb4e93,
    faCrow: $d8206b3ab2e65c05$export$bfa312207b788ed9,
    faSailboat: $d8206b3ab2e65c05$export$e363e74e36cce80c,
    faWindowRestore: $d8206b3ab2e65c05$export$eccfff9bfd585652,
    faSquarePlus: $d8206b3ab2e65c05$export$eaf727acca5a35e4,
    faPlusSquare: $d8206b3ab2e65c05$export$b6359eebfe900c35,
    faToriiGate: $d8206b3ab2e65c05$export$75825a4c2b3375e,
    faFrog: $d8206b3ab2e65c05$export$fe2358263efac504,
    faBucket: $d8206b3ab2e65c05$export$2124c7628e573b84,
    faImage: $d8206b3ab2e65c05$export$7e9f0928967e03b,
    faMicrophone: $d8206b3ab2e65c05$export$eed3c491effe6d12,
    faCow: $d8206b3ab2e65c05$export$1da3b2e53dcafa2d,
    faCaretUp: $d8206b3ab2e65c05$export$7de776bdab4e536d,
    faScrewdriver: $d8206b3ab2e65c05$export$7484ff654cd6474f,
    faFolderClosed: $d8206b3ab2e65c05$export$5e30548b7f8eeb95,
    faHouseTsunami: $d8206b3ab2e65c05$export$197b9567e88a0b1d,
    faSquareNfi: $d8206b3ab2e65c05$export$5498258519fc5b72,
    faArrowUpFromGroundWater: $d8206b3ab2e65c05$export$cbe485a104805f4f,
    faMartiniGlass: $d8206b3ab2e65c05$export$98401bb29cff68e0,
    faGlassMartiniAlt: $d8206b3ab2e65c05$export$2258439b8f4e7acb,
    faSquareBinary: $d8206b3ab2e65c05$export$3cbda23149da6f11,
    faRotateLeft: $d8206b3ab2e65c05$export$7adaa412bd8eb08f,
    faRotateBack: $d8206b3ab2e65c05$export$9706706f1bc7b12,
    faRotateBackward: $d8206b3ab2e65c05$export$4ceb0b05fed961a9,
    faUndoAlt: $d8206b3ab2e65c05$export$c8197b992c46c4a6,
    faTableColumns: $d8206b3ab2e65c05$export$ccaa019a3fd4563f,
    faColumns: $d8206b3ab2e65c05$export$bb861166644ac28a,
    faLemon: $d8206b3ab2e65c05$export$4fbda8f64648f3b5,
    faHeadSideMask: $d8206b3ab2e65c05$export$280300af4baa1a3e,
    faHandshake: $d8206b3ab2e65c05$export$b4c63e9bfc7906f1,
    faGem: $d8206b3ab2e65c05$export$31ee86ac717db552,
    faDolly: $d8206b3ab2e65c05$export$5879d0bca1aa497b,
    faDollyBox: $d8206b3ab2e65c05$export$461bbb9e92cc531b,
    faSmoking: $d8206b3ab2e65c05$export$c4ab83701fc591a5,
    faMinimize: $d8206b3ab2e65c05$export$e0601b1f239fec74,
    faCompressArrowsAlt: $d8206b3ab2e65c05$export$39205db0ea980efd,
    faMonument: $d8206b3ab2e65c05$export$6f9b0bfc012deb25,
    faSnowplow: $d8206b3ab2e65c05$export$695fae58f55c3a87,
    faAnglesRight: $d8206b3ab2e65c05$export$48b60f1720e09944,
    faAngleDoubleRight: $d8206b3ab2e65c05$export$792931403404faf0,
    faCannabis: $d8206b3ab2e65c05$export$8ec2f752344b69bd,
    faCirclePlay: $d8206b3ab2e65c05$export$86c4e45dc3302d15,
    faPlayCircle: $d8206b3ab2e65c05$export$cf04333781061c5e,
    faTablets: $d8206b3ab2e65c05$export$bed2b0ed4ae45e0d,
    faEthernet: $d8206b3ab2e65c05$export$6bad2c9f317b52e5,
    faEuroSign: $d8206b3ab2e65c05$export$902a3969bb113dff,
    faEur: $d8206b3ab2e65c05$export$4b859160cfeb12ff,
    faEuro: $d8206b3ab2e65c05$export$bdabbefede2d3a2,
    faChair: $d8206b3ab2e65c05$export$a339864ee3df7e9a,
    faCircleCheck: $d8206b3ab2e65c05$export$c2e9877668862374,
    faCheckCircle: $d8206b3ab2e65c05$export$be9e388158c74f29,
    faCircleStop: $d8206b3ab2e65c05$export$229de76dfef2687f,
    faStopCircle: $d8206b3ab2e65c05$export$47af2aad60ab3e7c,
    faCompassDrafting: $d8206b3ab2e65c05$export$aaaddd2cf7e20f64,
    faDraftingCompass: $d8206b3ab2e65c05$export$c8c2b127d13b9d79,
    faPlateWheat: $d8206b3ab2e65c05$export$2eff9f6cbe00a643,
    faIcicles: $d8206b3ab2e65c05$export$78792ed87d92a3ad,
    faPersonShelter: $d8206b3ab2e65c05$export$d359c2cc7640953c,
    faNeuter: $d8206b3ab2e65c05$export$771cf879fba0cf93,
    faIdBadge: $d8206b3ab2e65c05$export$a75288855ea05282,
    faMarker: $d8206b3ab2e65c05$export$e6789173649caa25,
    faFaceLaughBeam: $d8206b3ab2e65c05$export$3f2d51c0547bf984,
    faLaughBeam: $d8206b3ab2e65c05$export$a88d1f4073ea9369,
    faHelicopterSymbol: $d8206b3ab2e65c05$export$2a66e6044c1f7036,
    faUniversalAccess: $d8206b3ab2e65c05$export$e119aada7f690d05,
    faCircleChevronUp: $d8206b3ab2e65c05$export$7b69b3617b84259b,
    faChevronCircleUp: $d8206b3ab2e65c05$export$b786cf5db03f2c36,
    faLariSign: $d8206b3ab2e65c05$export$d317bc452442782d,
    faVolcano: $d8206b3ab2e65c05$export$bae30a76735500e1,
    faPersonWalkingDashedLineArrowRight: $d8206b3ab2e65c05$export$a1d09c95bee8043b,
    faSterlingSign: $d8206b3ab2e65c05$export$170c56774c8e7961,
    faGbp: $d8206b3ab2e65c05$export$3d9479ec1d1ae83e,
    faPoundSign: $d8206b3ab2e65c05$export$9ce041dfec8319b,
    faViruses: $d8206b3ab2e65c05$export$ee194b18f5c6f6b6,
    faSquarePersonConfined: $d8206b3ab2e65c05$export$8aaca358568da0e0,
    faUserTie: $d8206b3ab2e65c05$export$48c51dda34e9f04c,
    faArrowDownLong: $d8206b3ab2e65c05$export$5977e8de7e65b20,
    faLongArrowDown: $d8206b3ab2e65c05$export$52ecf90b62f3f030,
    faTentArrowDownToLine: $d8206b3ab2e65c05$export$8a4f323f00a91606,
    faCertificate: $d8206b3ab2e65c05$export$a881f37164b11fbf,
    faReplyAll: $d8206b3ab2e65c05$export$ca6fd367f31ecbc5,
    faMailReplyAll: $d8206b3ab2e65c05$export$8274334f3a2c1841,
    faSuitcase: $d8206b3ab2e65c05$export$60710f3921019268,
    faPersonSkating: $d8206b3ab2e65c05$export$f3854553fe688388,
    faSkating: $d8206b3ab2e65c05$export$21bd1d54bd4f2c5a,
    faFilterCircleDollar: $d8206b3ab2e65c05$export$3300e4b4d1d1936f,
    faFunnelDollar: $d8206b3ab2e65c05$export$cebe38ad8f0a143d,
    faCameraRetro: $d8206b3ab2e65c05$export$41dbdadc07a89b05,
    faCircleArrowDown: $d8206b3ab2e65c05$export$a30c52cde32bec7e,
    faArrowCircleDown: $d8206b3ab2e65c05$export$6cfa36bbb3a057,
    faFileImport: $d8206b3ab2e65c05$export$d796c05153b1255c,
    faArrowRightToFile: $d8206b3ab2e65c05$export$32f14beaf6294476,
    faSquareArrowUpRight: $d8206b3ab2e65c05$export$38150b61dfd06fff,
    faExternalLinkSquare: $d8206b3ab2e65c05$export$e04d83fed5ebcebf,
    faBoxOpen: $d8206b3ab2e65c05$export$9010ed816a8b9c97,
    faScroll: $d8206b3ab2e65c05$export$7c265716d4399676,
    faSpa: $d8206b3ab2e65c05$export$f9a38ef7b046ab51,
    faLocationPinLock: $d8206b3ab2e65c05$export$db853fbb474326cc,
    faPause: $d8206b3ab2e65c05$export$da79f048408b1722,
    faHillAvalanche: $d8206b3ab2e65c05$export$50d11c98c99e3b2d,
    faTemperatureEmpty: $d8206b3ab2e65c05$export$ac389bf5cc37feb5,
    faTemperature0: $d8206b3ab2e65c05$export$e99b7d2ccc282383,
    faThermometer0: $d8206b3ab2e65c05$export$4c13a186ecce3b80,
    faThermometerEmpty: $d8206b3ab2e65c05$export$81a2f8298cf523f9,
    faBomb: $d8206b3ab2e65c05$export$d59078f6e80b4a67,
    faRegistered: $d8206b3ab2e65c05$export$5f519e9ac15ab8c3,
    faAddressCard: $d8206b3ab2e65c05$export$6ea408c7266ed557,
    faContactCard: $d8206b3ab2e65c05$export$4ac51eb0b298b190,
    faVcard: $d8206b3ab2e65c05$export$91228257deb1bf18,
    faScaleUnbalancedFlip: $d8206b3ab2e65c05$export$f4d7840209109993,
    faBalanceScaleRight: $d8206b3ab2e65c05$export$2238e05f8920005a,
    faSubscript: $d8206b3ab2e65c05$export$34c1e678c32ed646,
    faDiamondTurnRight: $d8206b3ab2e65c05$export$99749ac517cbef07,
    faDirections: $d8206b3ab2e65c05$export$6a6973de44442fe5,
    faBurst: $d8206b3ab2e65c05$export$ea2986b45ba5d2cf,
    faHouseLaptop: $d8206b3ab2e65c05$export$6486d62e77b910,
    faLaptopHouse: $d8206b3ab2e65c05$export$efd983de5e4d6ad3,
    faFaceTired: $d8206b3ab2e65c05$export$5352cbdc070ce8d,
    faTired: $d8206b3ab2e65c05$export$3d016d62cda18371,
    faMoneyBills: $d8206b3ab2e65c05$export$a822dad6e586ee9e,
    faSmog: $d8206b3ab2e65c05$export$aa11b8edb09fed14,
    faCrutch: $d8206b3ab2e65c05$export$e94134641c0e2,
    faFontAwesome: $d8206b3ab2e65c05$export$aa4baaed1c60f58d,
    faFontAwesomeFlag: $d8206b3ab2e65c05$export$102c25fde54d4843,
    faFontAwesomeLogoFull: $d8206b3ab2e65c05$export$6e20d421a2e0f320,
    faCloudArrowUp: $d8206b3ab2e65c05$export$3507214fff1cc655,
    faCloudUpload: $d8206b3ab2e65c05$export$a48720e6366f5d9a,
    faCloudUploadAlt: $d8206b3ab2e65c05$export$e73b3e819b9d14a5,
    faPalette: $d8206b3ab2e65c05$export$5c390baea5db4f77,
    faArrowsTurnRight: $d8206b3ab2e65c05$export$db9f783f15682c4a,
    faVest: $d8206b3ab2e65c05$export$c8370e53051a657,
    faFerry: $d8206b3ab2e65c05$export$fd312949b97346ae,
    faArrowsDownToPeople: $d8206b3ab2e65c05$export$cfb044c7d35060bb,
    faSeedling: $d8206b3ab2e65c05$export$d7b60b8dbd03cfe4,
    faSprout: $d8206b3ab2e65c05$export$9f3035e3a8c62323,
    faLeftRight: $d8206b3ab2e65c05$export$47d93e9001818ee7,
    faArrowsAltH: $d8206b3ab2e65c05$export$7937ea574fb1389,
    faBoxesPacking: $d8206b3ab2e65c05$export$e81e7f3390fe84fe,
    faCircleArrowLeft: $d8206b3ab2e65c05$export$827fbb87bdbe1028,
    faArrowCircleLeft: $d8206b3ab2e65c05$export$728262abb9f58d0a,
    faGroupArrowsRotate: $d8206b3ab2e65c05$export$88a8383ecdd39a54,
    faBowlFood: $d8206b3ab2e65c05$export$8b89ca3201039376,
    faCandyCane: $d8206b3ab2e65c05$export$14d66ba7571ae0b9,
    faArrowDownWideShort: $d8206b3ab2e65c05$export$4229d00802c33062,
    faSortAmountAsc: $d8206b3ab2e65c05$export$ddf8b8dd5983367d,
    faSortAmountDown: $d8206b3ab2e65c05$export$4b2a02d50e417b5f,
    faCloudBolt: $d8206b3ab2e65c05$export$cdd116afa0309c17,
    faThunderstorm: $d8206b3ab2e65c05$export$bbf9e3d433f8f6de,
    faTextSlash: $d8206b3ab2e65c05$export$ec658c0f040c3e1a,
    faRemoveFormat: $d8206b3ab2e65c05$export$d91179f327329532,
    faFaceSmileWink: $d8206b3ab2e65c05$export$6143da800b0e6626,
    faSmileWink: $d8206b3ab2e65c05$export$f5dbb37f6801ee3f,
    faFileWord: $d8206b3ab2e65c05$export$f0858dff6e769cf6,
    faFilePowerpoint: $d8206b3ab2e65c05$export$c341daeecdea449a,
    faArrowsLeftRight: $d8206b3ab2e65c05$export$672e2f590b189583,
    faArrowsH: $d8206b3ab2e65c05$export$de517642cdb40354,
    faHouseLock: $d8206b3ab2e65c05$export$aa54b16c409e882f,
    faCloudArrowDown: $d8206b3ab2e65c05$export$542a9676c5286e01,
    faCloudDownload: $d8206b3ab2e65c05$export$b318977f29260464,
    faCloudDownloadAlt: $d8206b3ab2e65c05$export$351357a14c41f824,
    faChildren: $d8206b3ab2e65c05$export$f2819bf60df55912,
    faChalkboard: $d8206b3ab2e65c05$export$49a36efd66df775,
    faBlackboard: $d8206b3ab2e65c05$export$f497e01bf522fd9c,
    faUserLargeSlash: $d8206b3ab2e65c05$export$ae7fc6b7f0534be9,
    faUserAltSlash: $d8206b3ab2e65c05$export$46185fab4772ada6,
    faEnvelopeOpen: $d8206b3ab2e65c05$export$c6c3bd5f7d9b8bf2,
    faHandshakeSimpleSlash: $d8206b3ab2e65c05$export$e99ae494101c5e91,
    faHandshakeAltSlash: $d8206b3ab2e65c05$export$ca302f956ae9f1bf,
    faMattressPillow: $d8206b3ab2e65c05$export$f042d3e458efa721,
    faGuaraniSign: $d8206b3ab2e65c05$export$b731a51acb74b00c,
    faArrowsRotate: $d8206b3ab2e65c05$export$2fd091cb98dc8ab8,
    faRefresh: $d8206b3ab2e65c05$export$fd4359e93d7b3d14,
    faSync: $d8206b3ab2e65c05$export$ff87319002e3dae9,
    faFireExtinguisher: $d8206b3ab2e65c05$export$d75fb6743634a0a,
    faCruzeiroSign: $d8206b3ab2e65c05$export$64dd1b27affb6572,
    faGreaterThanEqual: $d8206b3ab2e65c05$export$7bf8dfe2e6661a54,
    faShieldHalved: $d8206b3ab2e65c05$export$36e034ccc72554a9,
    faShieldAlt: $d8206b3ab2e65c05$export$d6508d18a824f291,
    faBookAtlas: $d8206b3ab2e65c05$export$7fb8daedae341012,
    faAtlas: $d8206b3ab2e65c05$export$380a9050e42fe5d7,
    faVirus: $d8206b3ab2e65c05$export$37c67e0b3dc6bd1b,
    faEnvelopeCircleCheck: $d8206b3ab2e65c05$export$74d890536dbd21b7,
    faLayerGroup: $d8206b3ab2e65c05$export$a137712e11e257dd,
    faArrowsToDot: $d8206b3ab2e65c05$export$ab3a06d4b53c0fc0,
    faArchway: $d8206b3ab2e65c05$export$d56753dd2eb5c323,
    faHeartCircleCheck: $d8206b3ab2e65c05$export$5e4b6785eedecc1a,
    faHouseChimneyCrack: $d8206b3ab2e65c05$export$e824540f5a6a8a57,
    faHouseDamage: $d8206b3ab2e65c05$export$8d7e943005ce0b49,
    faFileZipper: $d8206b3ab2e65c05$export$7a4a0e4caa1e4e6f,
    faFileArchive: $d8206b3ab2e65c05$export$bf2047a9946b5c3f,
    faSquare: $d8206b3ab2e65c05$export$90b4406457aae8cc,
    faMartiniGlassEmpty: $d8206b3ab2e65c05$export$a8a0de30198815a3,
    faGlassMartini: $d8206b3ab2e65c05$export$e96f280e39af4a91,
    faCouch: $d8206b3ab2e65c05$export$ce96e32767a7dd51,
    faCediSign: $d8206b3ab2e65c05$export$66c557f70914132c,
    faItalic: $d8206b3ab2e65c05$export$16e344bae4d495ed,
    faTableCellsColumnLock: $d8206b3ab2e65c05$export$257af4c5fc557105,
    faChurch: $d8206b3ab2e65c05$export$16a3f12c6ae9650,
    faCommentsDollar: $d8206b3ab2e65c05$export$d477129b070e5ac4,
    faDemocrat: $d8206b3ab2e65c05$export$a1672d808fbed0bd,
    faZ: $d8206b3ab2e65c05$export$3481c1aa28972f9b,
    faPersonSkiing: $d8206b3ab2e65c05$export$5ebd3cd0630e3ae7,
    faSkiing: $d8206b3ab2e65c05$export$eae1acab6fb96708,
    faRoadLock: $d8206b3ab2e65c05$export$b81a894d5bc3eb17,
    faA: $d8206b3ab2e65c05$export$406fe05808a3753e,
    faTemperatureArrowDown: $d8206b3ab2e65c05$export$4520eb1840c4e110,
    faTemperatureDown: $d8206b3ab2e65c05$export$f0b2aca3866f00f6,
    faFeatherPointed: $d8206b3ab2e65c05$export$2a9d3e120019c92d,
    faFeatherAlt: $d8206b3ab2e65c05$export$68cf766c786bcd78,
    faP: $d8206b3ab2e65c05$export$bcb419f1cd5beac3,
    faSnowflake: $d8206b3ab2e65c05$export$bab8f3647c394f48,
    faNewspaper: $d8206b3ab2e65c05$export$d91b374112d4f8c1,
    faRectangleAd: $d8206b3ab2e65c05$export$d0ccaddca9e06d1e,
    faAd: $d8206b3ab2e65c05$export$7af266c3465b1ff2,
    faCircleArrowRight: $d8206b3ab2e65c05$export$2f1e22e081a1ad05,
    faArrowCircleRight: $d8206b3ab2e65c05$export$7d3d828103aa3be7,
    faFilterCircleXmark: $d8206b3ab2e65c05$export$fb5ab619c34ea613,
    faLocust: $d8206b3ab2e65c05$export$4982360d3b844c19,
    faSort: $d8206b3ab2e65c05$export$4941c5969d5399b,
    faUnsorted: $d8206b3ab2e65c05$export$418597748f0fe52d,
    faListOl: $d8206b3ab2e65c05$export$3db8f67cd0fc963b,
    faList12: $d8206b3ab2e65c05$export$7e3d894cd55296b,
    faListNumeric: $d8206b3ab2e65c05$export$cf51408faadac277,
    faPersonDressBurst: $d8206b3ab2e65c05$export$523180e731928397,
    faMoneyCheckDollar: $d8206b3ab2e65c05$export$eeb59dd1825c6a65,
    faMoneyCheckAlt: $d8206b3ab2e65c05$export$8c6ccc9745897cb2,
    faVectorSquare: $d8206b3ab2e65c05$export$567d5631a7b0599f,
    faBreadSlice: $d8206b3ab2e65c05$export$d78e8b0681279167,
    faLanguage: $d8206b3ab2e65c05$export$8a7bee49fdf8c954,
    faFaceKissWinkHeart: $d8206b3ab2e65c05$export$611ae61f02de0aa,
    faKissWinkHeart: $d8206b3ab2e65c05$export$ebba617701dfb917,
    faFilter: $d8206b3ab2e65c05$export$f253a38d7142e29f,
    faQuestion: $d8206b3ab2e65c05$export$d96973f90e8f6e47,
    faFileSignature: $d8206b3ab2e65c05$export$d0de575ac166712b,
    faUpDownLeftRight: $d8206b3ab2e65c05$export$cd7b22f4e6e3834b,
    faArrowsAlt: $d8206b3ab2e65c05$export$3cdabfff52cfc73a,
    faHouseChimneyUser: $d8206b3ab2e65c05$export$1ddbaebce033a0d,
    faHandHoldingHeart: $d8206b3ab2e65c05$export$97e5ef3e80a0fbef,
    faPuzzlePiece: $d8206b3ab2e65c05$export$7ee0dbd1e92e2859,
    faMoneyCheck: $d8206b3ab2e65c05$export$be069f641c85d0b3,
    faStarHalfStroke: $d8206b3ab2e65c05$export$3e4892d8bf919edd,
    faStarHalfAlt: $d8206b3ab2e65c05$export$c13575f42532efb3,
    faCode: $d8206b3ab2e65c05$export$eba095993e51cc97,
    faWhiskeyGlass: $d8206b3ab2e65c05$export$f1304dd34ea2afbd,
    faGlassWhiskey: $d8206b3ab2e65c05$export$fdec0f5f1a169419,
    faBuildingCircleExclamation: $d8206b3ab2e65c05$export$c49f030b19083ebe,
    faMagnifyingGlassChart: $d8206b3ab2e65c05$export$6a1e4cdbb8ca10c5,
    faArrowUpRightFromSquare: $d8206b3ab2e65c05$export$5ad84e891223f2c3,
    faExternalLink: $d8206b3ab2e65c05$export$f4c613289034e5ef,
    faCubesStacked: $d8206b3ab2e65c05$export$b1f00c433aabac05,
    faWonSign: $d8206b3ab2e65c05$export$51790ddd26e431bc,
    faKrw: $d8206b3ab2e65c05$export$2f65e07a45b95b50,
    faWon: $d8206b3ab2e65c05$export$5a1fd3ed9564d7fa,
    faVirusCovid: $d8206b3ab2e65c05$export$1df4e031b8ee4f84,
    faAustralSign: $d8206b3ab2e65c05$export$299c200ad3db97b4,
    faF: $d8206b3ab2e65c05$export$a2f384a559654618,
    faLeaf: $d8206b3ab2e65c05$export$7c497bae2754a087,
    faRoad: $d8206b3ab2e65c05$export$f224567a4851a5e9,
    faTaxi: $d8206b3ab2e65c05$export$9958afcdfece1b58,
    faCab: $d8206b3ab2e65c05$export$7bf12d9380f0971b,
    faPersonCirclePlus: $d8206b3ab2e65c05$export$55686b1eb7d00307,
    faChartPie: $d8206b3ab2e65c05$export$1de7b9cf7d1b153b,
    faPieChart: $d8206b3ab2e65c05$export$7877286cd337de81,
    faBoltLightning: $d8206b3ab2e65c05$export$b16dcd08f3da1ba2,
    faSackXmark: $d8206b3ab2e65c05$export$2bad98c38bea5994,
    faFileExcel: $d8206b3ab2e65c05$export$77cb1a465c4fe84,
    faFileContract: $d8206b3ab2e65c05$export$70fde3f3fdaa6a6a,
    faFishFins: $d8206b3ab2e65c05$export$e7af4f0123222b6f,
    faBuildingFlag: $d8206b3ab2e65c05$export$592422b29ab0a914,
    faFaceGrinBeam: $d8206b3ab2e65c05$export$3de52eeb00462407,
    faGrinBeam: $d8206b3ab2e65c05$export$734da5249381ec7e,
    faObjectUngroup: $d8206b3ab2e65c05$export$887f6345573abcac,
    faPoop: $d8206b3ab2e65c05$export$bb45b6b87d1adf27,
    faLocationPin: $d8206b3ab2e65c05$export$c0b7617de95c0c05,
    faMapMarker: $d8206b3ab2e65c05$export$10d360e4f1a554dd,
    faKaaba: $d8206b3ab2e65c05$export$ab1408bfbe914cc9,
    faToiletPaper: $d8206b3ab2e65c05$export$c8cc083ccc72b17,
    faHelmetSafety: $d8206b3ab2e65c05$export$aacaf42fba617981,
    faHardHat: $d8206b3ab2e65c05$export$7b72177558a98b6f,
    faHatHard: $d8206b3ab2e65c05$export$c0e235dbf1644a2f,
    faEject: $d8206b3ab2e65c05$export$8484041d5b209494,
    faCircleRight: $d8206b3ab2e65c05$export$1fec48c8bdd69c1d,
    faArrowAltCircleRight: $d8206b3ab2e65c05$export$88962ffdad8b856d,
    faPlaneCircleCheck: $d8206b3ab2e65c05$export$9cbf8612c6cadc74,
    faFaceRollingEyes: $d8206b3ab2e65c05$export$a6d72a9a068392b5,
    faMehRollingEyes: $d8206b3ab2e65c05$export$fdc62a1bea767cc2,
    faObjectGroup: $d8206b3ab2e65c05$export$40cdac24aa94a57a,
    faChartLine: $d8206b3ab2e65c05$export$e022f62a119e1d93,
    faLineChart: $d8206b3ab2e65c05$export$f729617a20de475b,
    faMaskVentilator: $d8206b3ab2e65c05$export$122c8413a0dc5ff6,
    faArrowRight: $d8206b3ab2e65c05$export$b4da69a0247f3620,
    faSignsPost: $d8206b3ab2e65c05$export$905f45f8ffd6b8e5,
    faMapSigns: $d8206b3ab2e65c05$export$743f4b1071b3333a,
    faCashRegister: $d8206b3ab2e65c05$export$6357093f67788b33,
    faPersonCircleQuestion: $d8206b3ab2e65c05$export$c8f8a597ffd676c0,
    faH: $d8206b3ab2e65c05$export$d762b7b66d5875e1,
    faTarp: $d8206b3ab2e65c05$export$2305b1a41b3f914,
    faScrewdriverWrench: $d8206b3ab2e65c05$export$158a12f36bbecf9,
    faTools: $d8206b3ab2e65c05$export$646e4e7a8c6172aa,
    faArrowsToEye: $d8206b3ab2e65c05$export$9adae865350879af,
    faPlugCircleBolt: $d8206b3ab2e65c05$export$4f3b3144ce966486,
    faHeart: $d8206b3ab2e65c05$export$e4b51a47a2f8b9db,
    faMarsAndVenus: $d8206b3ab2e65c05$export$808b88e8735e31e8,
    faHouseUser: $d8206b3ab2e65c05$export$9a513ee921e8e885,
    faHomeUser: $d8206b3ab2e65c05$export$e732fa55ae5bbdf0,
    faDumpsterFire: $d8206b3ab2e65c05$export$25e9b29b3f2230b5,
    faHouseCrack: $d8206b3ab2e65c05$export$baa3c215534dbf2a,
    faMartiniGlassCitrus: $d8206b3ab2e65c05$export$c6e76550bdc0255d,
    faCocktail: $d8206b3ab2e65c05$export$4be708f1e41d387b,
    faFaceSurprise: $d8206b3ab2e65c05$export$c938968e28178994,
    faSurprise: $d8206b3ab2e65c05$export$46647c72213f53ba,
    faBottleWater: $d8206b3ab2e65c05$export$3ee278c67519eeeb,
    faCirclePause: $d8206b3ab2e65c05$export$fbeef2513e05ad08,
    faPauseCircle: $d8206b3ab2e65c05$export$d8cf08a0362da8db,
    faToiletPaperSlash: $d8206b3ab2e65c05$export$7a494edbf9b65575,
    faAppleWhole: $d8206b3ab2e65c05$export$12de8220d30453a3,
    faAppleAlt: $d8206b3ab2e65c05$export$bcdd94f3977a0884,
    faKitchenSet: $d8206b3ab2e65c05$export$64c1570509eaf40d,
    faR: $d8206b3ab2e65c05$export$eb4c616de6eef46f,
    faTemperatureQuarter: $d8206b3ab2e65c05$export$f9d1c19925fd7fa8,
    faTemperature1: $d8206b3ab2e65c05$export$d4f1cd380bde2129,
    faThermometer1: $d8206b3ab2e65c05$export$3f77fbe2dabe285b,
    faThermometerQuarter: $d8206b3ab2e65c05$export$ed05754fcbec6e46,
    faCube: $d8206b3ab2e65c05$export$973ae4f1e4d2ce78,
    faBitcoinSign: $d8206b3ab2e65c05$export$441bfc8058328ce8,
    faShieldDog: $d8206b3ab2e65c05$export$2a5c6f182c0cbcb,
    faSolarPanel: $d8206b3ab2e65c05$export$b9c649c5e37017f3,
    faLockOpen: $d8206b3ab2e65c05$export$84b5acad4436d02a,
    faElevator: $d8206b3ab2e65c05$export$c7a833ce065e0ea4,
    faMoneyBillTransfer: $d8206b3ab2e65c05$export$1b71392d9effbe,
    faMoneyBillTrendUp: $d8206b3ab2e65c05$export$18ab80cba7d5044f,
    faHouseFloodWaterCircleArrowRight: $d8206b3ab2e65c05$export$30d3e64480aa266b,
    faSquarePollHorizontal: $d8206b3ab2e65c05$export$287bdd70ab874659,
    faPollH: $d8206b3ab2e65c05$export$456a238f0144d430,
    faCircle: $d8206b3ab2e65c05$export$4280b2387fbdad12,
    faBackwardFast: $d8206b3ab2e65c05$export$662cbc6ed5a3c5e8,
    faFastBackward: $d8206b3ab2e65c05$export$e6246a3279a379b8,
    faRecycle: $d8206b3ab2e65c05$export$a65c441f12cb6bd,
    faUserAstronaut: $d8206b3ab2e65c05$export$94363e983c225a04,
    faPlaneSlash: $d8206b3ab2e65c05$export$cfee4df0d5df6d21,
    faTrademark: $d8206b3ab2e65c05$export$9c9b2fbddd59047d,
    faBasketball: $d8206b3ab2e65c05$export$44dee69e3a29b0e,
    faBasketballBall: $d8206b3ab2e65c05$export$36550ab8ffcc5b28,
    faSatelliteDish: $d8206b3ab2e65c05$export$219ccae0e4da3c92,
    faCircleUp: $d8206b3ab2e65c05$export$72ea8a5e4e86cd69,
    faArrowAltCircleUp: $d8206b3ab2e65c05$export$3747a8ef0995eadf,
    faMobileScreenButton: $d8206b3ab2e65c05$export$da39ed20699ee2d7,
    faMobileAlt: $d8206b3ab2e65c05$export$e9599bc6cd92234d,
    faVolumeHigh: $d8206b3ab2e65c05$export$39461921e738be65,
    faVolumeUp: $d8206b3ab2e65c05$export$5940d3e475d90cc4,
    faUsersRays: $d8206b3ab2e65c05$export$9c0b63b698611d06,
    faWallet: $d8206b3ab2e65c05$export$79204db8777905c8,
    faClipboardCheck: $d8206b3ab2e65c05$export$7babcb2c90eb609a,
    faFileAudio: $d8206b3ab2e65c05$export$b8d24c57c9e64933,
    faBurger: $d8206b3ab2e65c05$export$128a6cab12423493,
    faHamburger: $d8206b3ab2e65c05$export$bab3bb9f4f59363,
    faWrench: $d8206b3ab2e65c05$export$3c6c0c8185296ac5,
    faBugs: $d8206b3ab2e65c05$export$f5bfd1271b8b71d1,
    faRupeeSign: $d8206b3ab2e65c05$export$8bf9e3f7f57d486a,
    faRupee: $d8206b3ab2e65c05$export$9da25a46cfcb6fa4,
    faFileImage: $d8206b3ab2e65c05$export$6440b286d3cbac9b,
    faCircleQuestion: $d8206b3ab2e65c05$export$d7cf0978afd90002,
    faQuestionCircle: $d8206b3ab2e65c05$export$5ba67d7f2265c1a5,
    faPlaneDeparture: $d8206b3ab2e65c05$export$6ccbeeccfea6dc8a,
    faHandshakeSlash: $d8206b3ab2e65c05$export$2cef3f81ad90fb76,
    faBookBookmark: $d8206b3ab2e65c05$export$3d177ecdf7fc50ec,
    faCodeBranch: $d8206b3ab2e65c05$export$aa054a78ab078db3,
    faHatCowboy: $d8206b3ab2e65c05$export$37672611144b857b,
    faBridge: $d8206b3ab2e65c05$export$f402c7c97f3383f0,
    faPhoneFlip: $d8206b3ab2e65c05$export$d86c56ab43eb0deb,
    faPhoneAlt: $d8206b3ab2e65c05$export$a07a9b305deebf32,
    faTruckFront: $d8206b3ab2e65c05$export$4a5a13c01d46357c,
    faCat: $d8206b3ab2e65c05$export$ab927dada03be4b3,
    faAnchorCircleExclamation: $d8206b3ab2e65c05$export$61add9eca991b5ec,
    faTruckField: $d8206b3ab2e65c05$export$f4419f7b2e53b340,
    faRoute: $d8206b3ab2e65c05$export$806c0a45a7ecd6e8,
    faClipboardQuestion: $d8206b3ab2e65c05$export$d4aa151a4554b74e,
    faPanorama: $d8206b3ab2e65c05$export$5dd22dcb6e3ed369,
    faCommentMedical: $d8206b3ab2e65c05$export$101422b773924276,
    faTeethOpen: $d8206b3ab2e65c05$export$c88ac21fe7c88ae6,
    faFileCircleMinus: $d8206b3ab2e65c05$export$4b89fabf50a10951,
    faTags: $d8206b3ab2e65c05$export$d55778e3ab6c933f,
    faWineGlass: $d8206b3ab2e65c05$export$e06d6607d3577d6e,
    faForwardFast: $d8206b3ab2e65c05$export$dc9cc4280bee320d,
    faFastForward: $d8206b3ab2e65c05$export$61a8cdc53c2e078d,
    faFaceMehBlank: $d8206b3ab2e65c05$export$38c072b870a9e4ab,
    faMehBlank: $d8206b3ab2e65c05$export$e945435725f71e88,
    faSquareParking: $d8206b3ab2e65c05$export$f2cfa036d76f69ab,
    faParking: $d8206b3ab2e65c05$export$fda29c8f99573a4e,
    faHouseSignal: $d8206b3ab2e65c05$export$58845db8e7e9a199,
    faBarsProgress: $d8206b3ab2e65c05$export$ee3a02da18715b2,
    faTasksAlt: $d8206b3ab2e65c05$export$bbc0784fc1578f7f,
    faFaucetDrip: $d8206b3ab2e65c05$export$7a255960242435f6,
    faCartFlatbed: $d8206b3ab2e65c05$export$df587aaf7765e1ce,
    faDollyFlatbed: $d8206b3ab2e65c05$export$f7c6efb60c53b285,
    faBanSmoking: $d8206b3ab2e65c05$export$130df7ed74437774,
    faSmokingBan: $d8206b3ab2e65c05$export$e50452a49dec29f,
    faTerminal: $d8206b3ab2e65c05$export$5e63e8b85b5f119c,
    faMobileButton: $d8206b3ab2e65c05$export$c93d62849efbdd11,
    faHouseMedicalFlag: $d8206b3ab2e65c05$export$86c50f517be57a40,
    faBasketShopping: $d8206b3ab2e65c05$export$1d307c13b511e8e1,
    faShoppingBasket: $d8206b3ab2e65c05$export$ca6d443595a6578f,
    faTape: $d8206b3ab2e65c05$export$b88ed5e1e0eac4c6,
    faBusSimple: $d8206b3ab2e65c05$export$d3724faf0c559353,
    faBusAlt: $d8206b3ab2e65c05$export$40616edfab6d332a,
    faEye: $d8206b3ab2e65c05$export$b8c3e79e8c99c95b,
    faFaceSadCry: $d8206b3ab2e65c05$export$e8ea88c55e55be7c,
    faSadCry: $d8206b3ab2e65c05$export$8e924e6bd422cef9,
    faAudioDescription: $d8206b3ab2e65c05$export$b6b464c98c009494,
    faPersonMilitaryToPerson: $d8206b3ab2e65c05$export$41b1e14a6b0fe11b,
    faFileShield: $d8206b3ab2e65c05$export$348a01df65a66c99,
    faUserSlash: $d8206b3ab2e65c05$export$3924ab4d3ef9b5ef,
    faPen: $d8206b3ab2e65c05$export$8f4567331fb0d3bc,
    faTowerObservation: $d8206b3ab2e65c05$export$5b2f0f631f559d51,
    faFileCode: $d8206b3ab2e65c05$export$143d0ca7d2200f20,
    faSignal: $d8206b3ab2e65c05$export$79046b073b6c584d,
    faSignal5: $d8206b3ab2e65c05$export$3417071118065933,
    faSignalPerfect: $d8206b3ab2e65c05$export$1aea50ab3e99cc95,
    faBus: $d8206b3ab2e65c05$export$ce69441578ff2fdb,
    faHeartCircleXmark: $d8206b3ab2e65c05$export$742f89ae2f8d6b20,
    faHouseChimney: $d8206b3ab2e65c05$export$af554427144a7e5c,
    faHomeLg: $d8206b3ab2e65c05$export$dbab81727ec94698,
    faWindowMaximize: $d8206b3ab2e65c05$export$703cd98be31ec905,
    faFaceFrown: $d8206b3ab2e65c05$export$e5f78e87efbb0248,
    faFrown: $d8206b3ab2e65c05$export$43b7108508aecc5f,
    faPrescription: $d8206b3ab2e65c05$export$8767bafb19515ee4,
    faShop: $d8206b3ab2e65c05$export$78edc9b98453b6f7,
    faStoreAlt: $d8206b3ab2e65c05$export$1f1871dab9cec9d8,
    faFloppyDisk: $d8206b3ab2e65c05$export$f62f2879ccaea13f,
    faSave: $d8206b3ab2e65c05$export$1aaa83ff70706e1e,
    faVihara: $d8206b3ab2e65c05$export$ee4b92e89fe0dfaf,
    faScaleUnbalanced: $d8206b3ab2e65c05$export$4d10bcc8d068f454,
    faBalanceScaleLeft: $d8206b3ab2e65c05$export$786cb0c775487f19,
    faSortUp: $d8206b3ab2e65c05$export$f9dd5b1410e95035,
    faSortAsc: $d8206b3ab2e65c05$export$e4c8c924b1cc43a7,
    faCommentDots: $d8206b3ab2e65c05$export$63ffcb3d4e94cb92,
    faCommenting: $d8206b3ab2e65c05$export$49ee382a2425e89c,
    faPlantWilt: $d8206b3ab2e65c05$export$77a38850ff8b0407,
    faDiamond: $d8206b3ab2e65c05$export$f214f827e0023247,
    faFaceGrinSquint: $d8206b3ab2e65c05$export$5d53da7627754bc6,
    faGrinSquint: $d8206b3ab2e65c05$export$243ae757907b1580,
    faHandHoldingDollar: $d8206b3ab2e65c05$export$61a67f5f8ab39be,
    faHandHoldingUsd: $d8206b3ab2e65c05$export$47d27bc305b59690,
    faChartDiagram: $d8206b3ab2e65c05$export$eae84dfa654882b1,
    faBacterium: $d8206b3ab2e65c05$export$b0babe4230e35ebe,
    faHandPointer: $d8206b3ab2e65c05$export$d97ff927c450c87f,
    faDrumSteelpan: $d8206b3ab2e65c05$export$48d1206500db2e9d,
    faHandScissors: $d8206b3ab2e65c05$export$c578e919f2c5c135,
    faHandsPraying: $d8206b3ab2e65c05$export$a96374faedb12593,
    faPrayingHands: $d8206b3ab2e65c05$export$95e08e91b0929943,
    faArrowRotateRight: $d8206b3ab2e65c05$export$9c58ddc4b3356f98,
    faArrowRightRotate: $d8206b3ab2e65c05$export$ffa1245982c1b28b,
    faArrowRotateForward: $d8206b3ab2e65c05$export$89c59b5f47067f4c,
    faRedo: $d8206b3ab2e65c05$export$3d9f98aa1c24c776,
    faWebAwesome: $d8206b3ab2e65c05$export$5fa0ffae6770a0cc,
    faBiohazard: $d8206b3ab2e65c05$export$ae3a453550dec95,
    faLocationCrosshairs: $d8206b3ab2e65c05$export$14e1096ad1719098,
    faLocation: $d8206b3ab2e65c05$export$45e012c32174eb5d,
    faMarsDouble: $d8206b3ab2e65c05$export$2f8a28204bb4b86f,
    faChildDress: $d8206b3ab2e65c05$export$f31a37ecbfd4e707,
    faUsersBetweenLines: $d8206b3ab2e65c05$export$6ea1decf8bb3513d,
    faLungsVirus: $d8206b3ab2e65c05$export$895159d10626af74,
    faFaceGrinTears: $d8206b3ab2e65c05$export$8ac6d81a3d5b40a1,
    faGrinTears: $d8206b3ab2e65c05$export$b2f7512221512b5b,
    faPhone: $d8206b3ab2e65c05$export$ddab067855cf34cb,
    faCalendarXmark: $d8206b3ab2e65c05$export$3c70ffe5660af060,
    faCalendarTimes: $d8206b3ab2e65c05$export$99b20d7352fbcf08,
    faChildReaching: $d8206b3ab2e65c05$export$84a2f9476730c40e,
    faHeadSideVirus: $d8206b3ab2e65c05$export$5b64b916710da7c7,
    faUserGear: $d8206b3ab2e65c05$export$f504a6909b677146,
    faUserCog: $d8206b3ab2e65c05$export$474108c2b86e730e,
    faArrowUp19: $d8206b3ab2e65c05$export$bbbff45e04f4abab,
    faSortNumericUp: $d8206b3ab2e65c05$export$d213a3ba3cabed48,
    faDoorClosed: $d8206b3ab2e65c05$export$2c79e1a422528bba,
    faShieldVirus: $d8206b3ab2e65c05$export$bea811bbf570f05a,
    faDiceSix: $d8206b3ab2e65c05$export$3397c7b4679acccc,
    faMosquitoNet: $d8206b3ab2e65c05$export$f3858ce1b3218e2,
    faFileFragment: $d8206b3ab2e65c05$export$876f7406f579ec02,
    faBridgeWater: $d8206b3ab2e65c05$export$154e99cb34841765,
    faPersonBooth: $d8206b3ab2e65c05$export$2337c975289bdd84,
    faTextWidth: $d8206b3ab2e65c05$export$d8724cf433389700,
    faHatWizard: $d8206b3ab2e65c05$export$7daa48199dcb2ad1,
    faPenFancy: $d8206b3ab2e65c05$export$8bdfe14ac72a8b17,
    faPersonDigging: $d8206b3ab2e65c05$export$f4d483fca19a4604,
    faDigging: $d8206b3ab2e65c05$export$7bd93e3343bd5671,
    faTrash: $d8206b3ab2e65c05$export$ed8c149a0ea54bb4,
    faGaugeSimple: $d8206b3ab2e65c05$export$f3a0a4e6723a86d4,
    faGaugeSimpleMed: $d8206b3ab2e65c05$export$ba8c12ff7cfa2521,
    faTachometerAverage: $d8206b3ab2e65c05$export$94fcfd6f6335431b,
    faBookMedical: $d8206b3ab2e65c05$export$6feb44fec53ba30d,
    faPoo: $d8206b3ab2e65c05$export$dd0ede1713d2d2f9,
    faQuoteRight: $d8206b3ab2e65c05$export$54e3a80c9875b74c,
    faQuoteRightAlt: $d8206b3ab2e65c05$export$dd692f2e88bd4b1a,
    faShirt: $d8206b3ab2e65c05$export$312f2c01c6fedca8,
    faTShirt: $d8206b3ab2e65c05$export$144e5f8bc4d705a6,
    faTshirt: $d8206b3ab2e65c05$export$36edce3ba87c2b17,
    faCubes: $d8206b3ab2e65c05$export$30523a9441a31e97,
    faDivide: $d8206b3ab2e65c05$export$89fa217ec5503ac9,
    faTengeSign: $d8206b3ab2e65c05$export$c04e864469c1d117,
    faTenge: $d8206b3ab2e65c05$export$af6ebee83047b793,
    faHeadphones: $d8206b3ab2e65c05$export$ad02dd8ca5816958,
    faHandsHolding: $d8206b3ab2e65c05$export$96891bbcda1dbb7b,
    faHandsClapping: $d8206b3ab2e65c05$export$765c446e974b5e59,
    faRepublican: $d8206b3ab2e65c05$export$929518bb4b66a588,
    faArrowLeft: $d8206b3ab2e65c05$export$b7fac681e7d09400,
    faPersonCircleXmark: $d8206b3ab2e65c05$export$16c9e0374c346c6e,
    faRuler: $d8206b3ab2e65c05$export$8e90575265a56cfc,
    faAlignLeft: $d8206b3ab2e65c05$export$e490f662af4d1c78,
    faDiceD6: $d8206b3ab2e65c05$export$64bfd48ed353c031,
    faRestroom: $d8206b3ab2e65c05$export$5fbcef35138741a5,
    faJ: $d8206b3ab2e65c05$export$bbf24078bd1f73e6,
    faUsersViewfinder: $d8206b3ab2e65c05$export$72b785dcfe44c69b,
    faFileVideo: $d8206b3ab2e65c05$export$b44eb38345c6a964,
    faUpRightFromSquare: $d8206b3ab2e65c05$export$c1a3ba061b4f60c4,
    faExternalLinkAlt: $d8206b3ab2e65c05$export$d7f107e456ab0306,
    faTableCells: $d8206b3ab2e65c05$export$c517dffc18db483f,
    faTh: $d8206b3ab2e65c05$export$4d383c83efc0c819,
    faFilePdf: $d8206b3ab2e65c05$export$38611f1c776aba73,
    faBookBible: $d8206b3ab2e65c05$export$df8194b081d34b27,
    faBible: $d8206b3ab2e65c05$export$2eac809b0670d139,
    faO: $d8206b3ab2e65c05$export$9db87eabf605857e,
    faSuitcaseMedical: $d8206b3ab2e65c05$export$25ea11267429d202,
    faMedkit: $d8206b3ab2e65c05$export$e75f02bae5b7d34b,
    faUserSecret: $d8206b3ab2e65c05$export$597826232327559b,
    faOtter: $d8206b3ab2e65c05$export$743cce3ca4eb1d7d,
    faPersonDress: $d8206b3ab2e65c05$export$27f7383b96c3f4b4,
    faFemale: $d8206b3ab2e65c05$export$70e8e75e61dd7169,
    faCommentDollar: $d8206b3ab2e65c05$export$7a088030853df12c,
    faBusinessTime: $d8206b3ab2e65c05$export$694b7e88782dec12,
    faBriefcaseClock: $d8206b3ab2e65c05$export$8b00ae94743552ce,
    faTableCellsLarge: $d8206b3ab2e65c05$export$d2bcaf492dfb3817,
    faThLarge: $d8206b3ab2e65c05$export$69782f333e90cdc6,
    faBookTanakh: $d8206b3ab2e65c05$export$24c764717169f536,
    faTanakh: $d8206b3ab2e65c05$export$7fd4a58929315448,
    faPhoneVolume: $d8206b3ab2e65c05$export$c377f240bb8b5d74,
    faVolumeControlPhone: $d8206b3ab2e65c05$export$5358d004fa3d3be2,
    faHatCowboySide: $d8206b3ab2e65c05$export$ab6f71fd6878da90,
    faClipboardUser: $d8206b3ab2e65c05$export$1204f2d171424659,
    faChild: $d8206b3ab2e65c05$export$60b41e3581d1739a,
    faLiraSign: $d8206b3ab2e65c05$export$f0f37dbc60110b10,
    faSatellite: $d8206b3ab2e65c05$export$da3f1730d013e224,
    faPlaneLock: $d8206b3ab2e65c05$export$1125ac57be52258c,
    faTag: $d8206b3ab2e65c05$export$cb61f447f29887e,
    faComment: $d8206b3ab2e65c05$export$805cd88398a70581,
    faCakeCandles: $d8206b3ab2e65c05$export$e4019fe302a972e1,
    faBirthdayCake: $d8206b3ab2e65c05$export$bdcf98f725a7241a,
    faCake: $d8206b3ab2e65c05$export$707bc1c80c0177c1,
    faEnvelope: $d8206b3ab2e65c05$export$6f095630677adc,
    faAnglesUp: $d8206b3ab2e65c05$export$152ef92a4f9d80a7,
    faAngleDoubleUp: $d8206b3ab2e65c05$export$9bb51e1a2c07db7c,
    faPaperclip: $d8206b3ab2e65c05$export$4b24ca1552f410af,
    faArrowRightToCity: $d8206b3ab2e65c05$export$e201217e5046cd15,
    faRibbon: $d8206b3ab2e65c05$export$838459d11f3971df,
    faLungs: $d8206b3ab2e65c05$export$ba9b387e84727819,
    faArrowUp91: $d8206b3ab2e65c05$export$25218e5886296cb9,
    faSortNumericUpAlt: $d8206b3ab2e65c05$export$d41859f1bbb9e086,
    faLitecoinSign: $d8206b3ab2e65c05$export$4a157bd81dcd8d80,
    faBorderNone: $d8206b3ab2e65c05$export$2b488402ec335d97,
    faCircleNodes: $d8206b3ab2e65c05$export$de462dd5a18e80d4,
    faParachuteBox: $d8206b3ab2e65c05$export$ca9e3368f1d9500a,
    faIndent: $d8206b3ab2e65c05$export$318208bc30aeebcc,
    faTruckFieldUn: $d8206b3ab2e65c05$export$40cb0a4a3a74dc03,
    faHourglass: $d8206b3ab2e65c05$export$b9098a890f61e022,
    faHourglassEmpty: $d8206b3ab2e65c05$export$a2f8176a0161e891,
    faMountain: $d8206b3ab2e65c05$export$64f9eb99c9749cce,
    faUserDoctor: $d8206b3ab2e65c05$export$9884bf227eeb829,
    faUserMd: $d8206b3ab2e65c05$export$ab0d33a2c03f1794,
    faCircleInfo: $d8206b3ab2e65c05$export$317f99f46b39906e,
    faInfoCircle: $d8206b3ab2e65c05$export$aa9288aeadf882fa,
    faCloudMeatball: $d8206b3ab2e65c05$export$5d120e8b87ad33f4,
    faCamera: $d8206b3ab2e65c05$export$84ffbd7161ca2008,
    faCameraAlt: $d8206b3ab2e65c05$export$8872b5664e88e793,
    faSquareVirus: $d8206b3ab2e65c05$export$f9409a7b020dbec4,
    faMeteor: $d8206b3ab2e65c05$export$1439f0d6365138da,
    faCarOn: $d8206b3ab2e65c05$export$d901d50df5cf8d91,
    faSleigh: $d8206b3ab2e65c05$export$26a8fd1143d2d6c0,
    faArrowDown19: $d8206b3ab2e65c05$export$9a40d582bd4628fb,
    faSortNumericAsc: $d8206b3ab2e65c05$export$a4fb1aa2cdfb18d7,
    faSortNumericDown: $d8206b3ab2e65c05$export$835db7eb35b3c29b,
    faHandHoldingDroplet: $d8206b3ab2e65c05$export$b9c3f9a906f96b82,
    faHandHoldingWater: $d8206b3ab2e65c05$export$4265371b99d38b95,
    faWater: $d8206b3ab2e65c05$export$efaeddad0a6e901b,
    faCalendarCheck: $d8206b3ab2e65c05$export$5655108e1162ba45,
    faBraille: $d8206b3ab2e65c05$export$983e9c27cac7ed1c,
    faPrescriptionBottleMedical: $d8206b3ab2e65c05$export$99cfe064ff0b71c9,
    faPrescriptionBottleAlt: $d8206b3ab2e65c05$export$65d1c884b8581d1a,
    faLandmark: $d8206b3ab2e65c05$export$2bebc54c51db6505,
    faTruck: $d8206b3ab2e65c05$export$d7895f386f8bd8b8,
    faCrosshairs: $d8206b3ab2e65c05$export$721c101130c40043,
    faPersonCane: $d8206b3ab2e65c05$export$c48422e9da776c1b,
    faTent: $d8206b3ab2e65c05$export$e5075400db564e24,
    faVestPatches: $d8206b3ab2e65c05$export$750a64470c2e0f3f,
    faCheckDouble: $d8206b3ab2e65c05$export$f178c8c2ad3cc861,
    faArrowDownAZ: $d8206b3ab2e65c05$export$43b642fac7053978,
    faSortAlphaAsc: $d8206b3ab2e65c05$export$cb87697f2fa77cfc,
    faSortAlphaDown: $d8206b3ab2e65c05$export$7658045270aafde3,
    faMoneyBillWheat: $d8206b3ab2e65c05$export$6a4ef2ef77625063,
    faCookie: $d8206b3ab2e65c05$export$b3e64f5f68c6623f,
    faArrowRotateLeft: $d8206b3ab2e65c05$export$89b706873769c180,
    faArrowLeftRotate: $d8206b3ab2e65c05$export$1aea864c3e1d79b,
    faArrowRotateBack: $d8206b3ab2e65c05$export$a34701878babe5fc,
    faArrowRotateBackward: $d8206b3ab2e65c05$export$fce381d12e4535cd,
    faUndo: $d8206b3ab2e65c05$export$a5e5ba60b1dfe2b2,
    faHardDrive: $d8206b3ab2e65c05$export$4cb736b866cbb7ec,
    faHdd: $d8206b3ab2e65c05$export$62551e9c5ba7093f,
    faFaceGrinSquintTears: $d8206b3ab2e65c05$export$8ff56f5ebb8416a0,
    faGrinSquintTears: $d8206b3ab2e65c05$export$542206d6a85f3b42,
    faDumbbell: $d8206b3ab2e65c05$export$56700074cf37be5c,
    faRectangleList: $d8206b3ab2e65c05$export$1f7600fa9fdb3978,
    faListAlt: $d8206b3ab2e65c05$export$c6327a203ffc65a3,
    faTarpDroplet: $d8206b3ab2e65c05$export$1585b7c3c7109751,
    faHouseMedicalCircleCheck: $d8206b3ab2e65c05$export$5d08d08f88a96aac,
    faPersonSkiingNordic: $d8206b3ab2e65c05$export$c8cd1786449517d3,
    faSkiingNordic: $d8206b3ab2e65c05$export$6ea48260d7d09b1b,
    faCalendarPlus: $d8206b3ab2e65c05$export$16768a660ae3ca9d,
    faPlaneArrival: $d8206b3ab2e65c05$export$9b2dbe133273f284,
    faCircleLeft: $d8206b3ab2e65c05$export$5ae86b9da9cca3bd,
    faArrowAltCircleLeft: $d8206b3ab2e65c05$export$5460a5b11a24996f,
    faTrainSubway: $d8206b3ab2e65c05$export$cda326cc3bce41c,
    faSubway: $d8206b3ab2e65c05$export$4cabc8a12d4e2f9,
    faChartGantt: $d8206b3ab2e65c05$export$dce43b02b3fe0c18,
    faIndianRupeeSign: $d8206b3ab2e65c05$export$1d2b135cc5a2c852,
    faIndianRupee: $d8206b3ab2e65c05$export$be886a4def17c565,
    faInr: $d8206b3ab2e65c05$export$12c6d8b3e052490b,
    faCropSimple: $d8206b3ab2e65c05$export$c3605731beb92daf,
    faCropAlt: $d8206b3ab2e65c05$export$d932915fde4f1010,
    faMoneyBill1: $d8206b3ab2e65c05$export$a312c7d58dd44a75,
    faMoneyBillAlt: $d8206b3ab2e65c05$export$a35d573395884c3d,
    faLeftLong: $d8206b3ab2e65c05$export$1db7e2ee10d36035,
    faLongArrowAltLeft: $d8206b3ab2e65c05$export$a8b3226b2bf323d,
    faDna: $d8206b3ab2e65c05$export$c062100d54a2da00,
    faVirusSlash: $d8206b3ab2e65c05$export$c4ff5306c5470939,
    faMinus: $d8206b3ab2e65c05$export$fee0376c250cdef,
    faSubtract: $d8206b3ab2e65c05$export$f8cb2531ef1fc4a2,
    faChess: $d8206b3ab2e65c05$export$442fddbbd741c590,
    faArrowLeftLong: $d8206b3ab2e65c05$export$6e5225f0e6c0bacd,
    faLongArrowLeft: $d8206b3ab2e65c05$export$80896efc906118b4,
    faPlugCircleCheck: $d8206b3ab2e65c05$export$2bd45e99b9afa947,
    faStreetView: $d8206b3ab2e65c05$export$6aab6c3359c2554c,
    faFrancSign: $d8206b3ab2e65c05$export$acef3e5c2029d285,
    faVolumeOff: $d8206b3ab2e65c05$export$d94ba52e980ea0f1,
    faHandsAslInterpreting: $d8206b3ab2e65c05$export$bc43eb4655c78f49,
    faAmericanSignLanguageInterpreting: $d8206b3ab2e65c05$export$23a7517099ab1b86,
    faAslInterpreting: $d8206b3ab2e65c05$export$beb51abfb05a4eca,
    faHandsAmericanSignLanguageInterpreting: $d8206b3ab2e65c05$export$82846008645b0301,
    faGear: $d8206b3ab2e65c05$export$ec05accb7226d001,
    faCog: $d8206b3ab2e65c05$export$d6298bbfd1912a78,
    faDropletSlash: $d8206b3ab2e65c05$export$1d6c5a49025d720b,
    faTintSlash: $d8206b3ab2e65c05$export$5d6f0943039b898f,
    faMosque: $d8206b3ab2e65c05$export$4999586d7e1087fb,
    faMosquito: $d8206b3ab2e65c05$export$67c7a1518d0715ff,
    faStarOfDavid: $d8206b3ab2e65c05$export$f823fee3712b2601,
    faPersonMilitaryRifle: $d8206b3ab2e65c05$export$842b988dae95ccb8,
    faCartShopping: $d8206b3ab2e65c05$export$c790b41dc166ae13,
    faShoppingCart: $d8206b3ab2e65c05$export$51da406e5aa1388c,
    faVials: $d8206b3ab2e65c05$export$507e8edd7676b2e9,
    faPlugCirclePlus: $d8206b3ab2e65c05$export$f193138a7d21971c,
    faPlaceOfWorship: $d8206b3ab2e65c05$export$c5a9302c8c13c79a,
    faGripVertical: $d8206b3ab2e65c05$export$cacbd95c283996ec,
    faHexagonNodes: $d8206b3ab2e65c05$export$b75f0f1ba423de5f,
    faArrowTurnUp: $d8206b3ab2e65c05$export$2d3ccb9b2099f3fe,
    faLevelUp: $d8206b3ab2e65c05$export$c227d3ba1de97ceb,
    faU: $d8206b3ab2e65c05$export$4f39e8dbaf09ea8b,
    faSquareRootVariable: $d8206b3ab2e65c05$export$60b44cfa7af18422,
    faSquareRootAlt: $d8206b3ab2e65c05$export$28e4b96627e00057,
    faClock: $d8206b3ab2e65c05$export$95b9968e7fceb821,
    faClockFour: $d8206b3ab2e65c05$export$9a575facf1cab48f,
    faBackwardStep: $d8206b3ab2e65c05$export$5d2b6a700940df16,
    faStepBackward: $d8206b3ab2e65c05$export$2884e379aed297d4,
    faPallet: $d8206b3ab2e65c05$export$d7ff2047dbc34562,
    faFaucet: $d8206b3ab2e65c05$export$a0856b225f3b0614,
    faBaseballBatBall: $d8206b3ab2e65c05$export$59669f486ab41d86,
    faS: $d8206b3ab2e65c05$export$cb39585371b75720,
    faTimeline: $d8206b3ab2e65c05$export$5e239d90ef904a84,
    faKeyboard: $d8206b3ab2e65c05$export$fb61df5d98785fa8,
    faCaretDown: $d8206b3ab2e65c05$export$f9395ef707603e40,
    faHouseChimneyMedical: $d8206b3ab2e65c05$export$9c73560282dceccd,
    faClinicMedical: $d8206b3ab2e65c05$export$20d8a680febc7434,
    faTemperatureThreeQuarters: $d8206b3ab2e65c05$export$7ed2bad15ae6237f,
    faTemperature3: $d8206b3ab2e65c05$export$89def3268ed9b4bc,
    faThermometer3: $d8206b3ab2e65c05$export$2f653125f4e6463,
    faThermometerThreeQuarters: $d8206b3ab2e65c05$export$6c632d1dc30d4a77,
    faMobileScreen: $d8206b3ab2e65c05$export$8867e7da34bb8bf4,
    faMobileAndroidAlt: $d8206b3ab2e65c05$export$cb39d7b468ba5838,
    faPlaneUp: $d8206b3ab2e65c05$export$a5f2976a01fdc970,
    faPiggyBank: $d8206b3ab2e65c05$export$46d49a6734c4872a,
    faBatteryHalf: $d8206b3ab2e65c05$export$e6dadc1155c4ee48,
    faBattery3: $d8206b3ab2e65c05$export$f9138caac2aedaed,
    faMountainCity: $d8206b3ab2e65c05$export$28f06bbf9c17c3af,
    faCoins: $d8206b3ab2e65c05$export$bc5da164799a0e,
    faKhanda: $d8206b3ab2e65c05$export$8d41d1f1ba3f9217,
    faSliders: $d8206b3ab2e65c05$export$ea6970ed5a15feb6,
    faSlidersH: $d8206b3ab2e65c05$export$94d4dcb523f95563,
    faFolderTree: $d8206b3ab2e65c05$export$54d16fa2e445d3fe,
    faNetworkWired: $d8206b3ab2e65c05$export$882cabd11f4943b8,
    faMapPin: $d8206b3ab2e65c05$export$184725965b3402dc,
    faHamsa: $d8206b3ab2e65c05$export$38d20d399463edf9,
    faCentSign: $d8206b3ab2e65c05$export$875b6c94a4b00ea8,
    faFlask: $d8206b3ab2e65c05$export$f9b579ba06048af,
    faPersonPregnant: $d8206b3ab2e65c05$export$e7b4c26b5857fe9c,
    faWandSparkles: $d8206b3ab2e65c05$export$76cc39f249b6864e,
    faEllipsisVertical: $d8206b3ab2e65c05$export$7480721bf113be3e,
    faEllipsisV: $d8206b3ab2e65c05$export$e58494c7fcb5380,
    faTicket: $d8206b3ab2e65c05$export$3604f15924cf0b98,
    faPowerOff: $d8206b3ab2e65c05$export$a1cca9928dcf9798,
    faRightLong: $d8206b3ab2e65c05$export$b356b1dbe7d7f736,
    faLongArrowAltRight: $d8206b3ab2e65c05$export$533e1f578f74c066,
    faFlagUsa: $d8206b3ab2e65c05$export$19357abad396e723,
    faLaptopFile: $d8206b3ab2e65c05$export$e1046cf83da9b7ef,
    faTty: $d8206b3ab2e65c05$export$7c85aba0f9624b29,
    faTeletype: $d8206b3ab2e65c05$export$14bcd5c43dc736f9,
    faDiagramNext: $d8206b3ab2e65c05$export$2faddf1690e14e11,
    faPersonRifle: $d8206b3ab2e65c05$export$b16df914812cedbe,
    faHouseMedicalCircleExclamation: $d8206b3ab2e65c05$export$bc50edea6e121df5,
    faClosedCaptioning: $d8206b3ab2e65c05$export$8e047801a8603af7,
    faPersonHiking: $d8206b3ab2e65c05$export$baf9f153991b2ea,
    faHiking: $d8206b3ab2e65c05$export$b2ab0105a901499e,
    faVenusDouble: $d8206b3ab2e65c05$export$6a6f9cba7a1e5fe4,
    faImages: $d8206b3ab2e65c05$export$74f06b41ed2ca28a,
    faCalculator: $d8206b3ab2e65c05$export$693bd40950ed2c3a,
    faPeoplePulling: $d8206b3ab2e65c05$export$dace56f632fecf6f,
    faN: $d8206b3ab2e65c05$export$328a9baf0f9e3405,
    faCableCar: $d8206b3ab2e65c05$export$85cb04eaefaf2d8b,
    faTram: $d8206b3ab2e65c05$export$a7a36674c079f293,
    faCloudRain: $d8206b3ab2e65c05$export$a6c308ee087b4ded,
    faBuildingCircleXmark: $d8206b3ab2e65c05$export$c4c015418a1f24df,
    faShip: $d8206b3ab2e65c05$export$6c645741140616af,
    faArrowsDownToLine: $d8206b3ab2e65c05$export$8f2463c7b2fc6ae4,
    faDownload: $d8206b3ab2e65c05$export$8f734e51d72ca13a,
    faFaceGrin: $d8206b3ab2e65c05$export$92292137ef3cf4c8,
    faGrin: $d8206b3ab2e65c05$export$37e1f10b6de76621,
    faDeleteLeft: $d8206b3ab2e65c05$export$bbcc9e0b6022772b,
    faBackspace: $d8206b3ab2e65c05$export$e43e3f67102fc526,
    faEyeDropper: $d8206b3ab2e65c05$export$1bc3e0ad56dc9eb0,
    faEyeDropperEmpty: $d8206b3ab2e65c05$export$ef304e9b7524c1f9,
    faEyedropper: $d8206b3ab2e65c05$export$91549a375c0b6d25,
    faFileCircleCheck: $d8206b3ab2e65c05$export$8547e9f3a2ddab5b,
    faForward: $d8206b3ab2e65c05$export$a8710cdb23198d53,
    faMobile: $d8206b3ab2e65c05$export$59edacfad04cd121,
    faMobileAndroid: $d8206b3ab2e65c05$export$82f602311a698c32,
    faMobilePhone: $d8206b3ab2e65c05$export$475a9be8da747e57,
    faFaceMeh: $d8206b3ab2e65c05$export$dc130582748497c6,
    faMeh: $d8206b3ab2e65c05$export$6d2db489aaeeecd2,
    faAlignCenter: $d8206b3ab2e65c05$export$70e29dd05344623e,
    faBookSkull: $d8206b3ab2e65c05$export$a57d448e8969ce8a,
    faBookDead: $d8206b3ab2e65c05$export$b98a3f8c3941a74a,
    faIdCard: $d8206b3ab2e65c05$export$782ac893fc22249b,
    faDriversLicense: $d8206b3ab2e65c05$export$8359c70e609eff64,
    faOutdent: $d8206b3ab2e65c05$export$e21cfc4f23776bff,
    faDedent: $d8206b3ab2e65c05$export$cbffb369d9299db7,
    faHeartCircleExclamation: $d8206b3ab2e65c05$export$3772719b170306e2,
    faHouse: $d8206b3ab2e65c05$export$dcadc0d67468dfa8,
    faHome: $d8206b3ab2e65c05$export$48f10d71ec526479,
    faHomeAlt: $d8206b3ab2e65c05$export$279659c4b23dbedb,
    faHomeLgAlt: $d8206b3ab2e65c05$export$20d6d52d45f53262,
    faCalendarWeek: $d8206b3ab2e65c05$export$39be5cb4aed5a521,
    faLaptopMedical: $d8206b3ab2e65c05$export$ba2fa38f7bcc6930,
    faB: $d8206b3ab2e65c05$export$fa30fcd1e0d0d8,
    faFileMedical: $d8206b3ab2e65c05$export$56cbcd962389b090,
    faDiceOne: $d8206b3ab2e65c05$export$d91800b7be5303b0,
    faKiwiBird: $d8206b3ab2e65c05$export$d9933d91e1314d02,
    faArrowRightArrowLeft: $d8206b3ab2e65c05$export$56b6d3d7d0e67a1c,
    faExchange: $d8206b3ab2e65c05$export$1aab915ca61b734a,
    faRotateRight: $d8206b3ab2e65c05$export$7f465bf410c6eff7,
    faRedoAlt: $d8206b3ab2e65c05$export$50c037520c6cfdc1,
    faRotateForward: $d8206b3ab2e65c05$export$2507849a0fdd7f64,
    faUtensils: $d8206b3ab2e65c05$export$750d52edc1dafc7,
    faCutlery: $d8206b3ab2e65c05$export$7034e54a8036c5c8,
    faArrowUpWideShort: $d8206b3ab2e65c05$export$63f4908401ded049,
    faSortAmountUp: $d8206b3ab2e65c05$export$28ef3e933e4b5364,
    faMillSign: $d8206b3ab2e65c05$export$9b53510cf4010e4d,
    faBowlRice: $d8206b3ab2e65c05$export$86079bc65a716451,
    faSkull: $d8206b3ab2e65c05$export$138b45e2afb1dfa4,
    faTowerBroadcast: $d8206b3ab2e65c05$export$fd06ff4ce9799eb0,
    faBroadcastTower: $d8206b3ab2e65c05$export$f68b38d51f5c0ed,
    faTruckPickup: $d8206b3ab2e65c05$export$f846b848b3ba3064,
    faUpLong: $d8206b3ab2e65c05$export$5608156cc81126e7,
    faLongArrowAltUp: $d8206b3ab2e65c05$export$43c8f2a46326c55f,
    faStop: $d8206b3ab2e65c05$export$51577929c676143b,
    faCodeMerge: $d8206b3ab2e65c05$export$e151fe5abf6db993,
    faUpload: $d8206b3ab2e65c05$export$a9578350255b2b79,
    faHurricane: $d8206b3ab2e65c05$export$4cf54a379be7e59a,
    faMound: $d8206b3ab2e65c05$export$ac54ffffdb218383,
    faToiletPortable: $d8206b3ab2e65c05$export$a3a5de5f6e2513ba,
    faCompactDisc: $d8206b3ab2e65c05$export$84021631df0f831b,
    faFileArrowDown: $d8206b3ab2e65c05$export$148bcede94488555,
    faFileDownload: $d8206b3ab2e65c05$export$1013b9966d758343,
    faCaravan: $d8206b3ab2e65c05$export$afb5d0eee7c1bdb,
    faShieldCat: $d8206b3ab2e65c05$export$1639f087457d4f58,
    faBolt: $d8206b3ab2e65c05$export$6869964aa308dd31,
    faZap: $d8206b3ab2e65c05$export$d62abb82664f55ca,
    faGlassWater: $d8206b3ab2e65c05$export$b80f542550a05ea7,
    faOilWell: $d8206b3ab2e65c05$export$b69c6757012a2267,
    faVault: $d8206b3ab2e65c05$export$4689a147513594a7,
    faMars: $d8206b3ab2e65c05$export$a9f5c0b9c1e77a6f,
    faToilet: $d8206b3ab2e65c05$export$505476859b9691c0,
    faPlaneCircleXmark: $d8206b3ab2e65c05$export$94ef668f5108e431,
    faYenSign: $d8206b3ab2e65c05$export$30f1437f5a4e991d,
    faCny: $d8206b3ab2e65c05$export$268a23eee8f089a2,
    faJpy: $d8206b3ab2e65c05$export$5460a9192eb79bf5,
    faRmb: $d8206b3ab2e65c05$export$e2a8016afc962883,
    faYen: $d8206b3ab2e65c05$export$cf914b1afb9455a2,
    faRubleSign: $d8206b3ab2e65c05$export$1ae0a94c8ba4131a,
    faRouble: $d8206b3ab2e65c05$export$c5dc3d98c4d8f2a5,
    faRub: $d8206b3ab2e65c05$export$9c4d936240e1f0b1,
    faRuble: $d8206b3ab2e65c05$export$6c0cf65134387046,
    faSun: $d8206b3ab2e65c05$export$2fa35dcbc038dbe9,
    faGuitar: $d8206b3ab2e65c05$export$790dd5b32282b6fb,
    faFaceLaughWink: $d8206b3ab2e65c05$export$600a1b26b33c3d47,
    faLaughWink: $d8206b3ab2e65c05$export$77ac40095f39933e,
    faHorseHead: $d8206b3ab2e65c05$export$5bcca85203ebd1e8,
    faBoreHole: $d8206b3ab2e65c05$export$cd79eeea6201e9d4,
    faIndustry: $d8206b3ab2e65c05$export$5548c3eb51060fa8,
    faCircleDown: $d8206b3ab2e65c05$export$531badb89cf01312,
    faArrowAltCircleDown: $d8206b3ab2e65c05$export$ff3afbc8c0bc5d59,
    faArrowsTurnToDots: $d8206b3ab2e65c05$export$b9d8fdf63999a76d,
    faFlorinSign: $d8206b3ab2e65c05$export$6248ec7440b2ffcb,
    faArrowDownShortWide: $d8206b3ab2e65c05$export$a51c464b699200ae,
    faSortAmountDesc: $d8206b3ab2e65c05$export$93835bc31892b5c3,
    faSortAmountDownAlt: $d8206b3ab2e65c05$export$e7d80d8c226cb77,
    faLessThan: $d8206b3ab2e65c05$export$7f24f1bf98af5411,
    faAngleDown: $d8206b3ab2e65c05$export$4b5be0142d10f342,
    faCarTunnel: $d8206b3ab2e65c05$export$ec5cfe409de2ed37,
    faHeadSideCough: $d8206b3ab2e65c05$export$3cd04b7c1624f598,
    faGripLines: $d8206b3ab2e65c05$export$1412f35381064d7d,
    faThumbsDown: $d8206b3ab2e65c05$export$aba24ca305bbe8c1,
    faUserLock: $d8206b3ab2e65c05$export$d9b89b5872b67a4f,
    faArrowRightLong: $d8206b3ab2e65c05$export$becbc35d3541bcc,
    faLongArrowRight: $d8206b3ab2e65c05$export$7ec6527cf8651899,
    faAnchorCircleXmark: $d8206b3ab2e65c05$export$f6773af4219eebd,
    faEllipsis: $d8206b3ab2e65c05$export$37fe3659ba7b6b54,
    faEllipsisH: $d8206b3ab2e65c05$export$c9f2fedd4489a2ee,
    faChessPawn: $d8206b3ab2e65c05$export$3db75d5ac9e98468,
    faKitMedical: $d8206b3ab2e65c05$export$f04e7a0f1033a0cd,
    faFirstAid: $d8206b3ab2e65c05$export$5b01ccb2da4c4387,
    faPersonThroughWindow: $d8206b3ab2e65c05$export$a77a2f6da72f89e3,
    faToolbox: $d8206b3ab2e65c05$export$b34d64c205c732a9,
    faHandsHoldingCircle: $d8206b3ab2e65c05$export$3aa81d0e606b08b6,
    faBug: $d8206b3ab2e65c05$export$a18cfac400116d9f,
    faCreditCard: $d8206b3ab2e65c05$export$3e7437bf6535bef0,
    faCreditCardAlt: $d8206b3ab2e65c05$export$5fffe8e3c36964a2,
    faCar: $d8206b3ab2e65c05$export$9eefe7fcdf123b76,
    faAutomobile: $d8206b3ab2e65c05$export$240a6c53cf7ac525,
    faHandHoldingHand: $d8206b3ab2e65c05$export$6638511b28df3be5,
    faBookOpenReader: $d8206b3ab2e65c05$export$cb6e40528b98a5b,
    faBookReader: $d8206b3ab2e65c05$export$cee14fe33262fa7d,
    faMountainSun: $d8206b3ab2e65c05$export$af9eaee7db3ba7a9,
    faArrowsLeftRightToLine: $d8206b3ab2e65c05$export$a63cecc8a4166c49,
    faDiceD20: $d8206b3ab2e65c05$export$b06003a02c9055bd,
    faTruckDroplet: $d8206b3ab2e65c05$export$41ce20639e8fef2b,
    faFileCircleXmark: $d8206b3ab2e65c05$export$e4686afbe882e24a,
    faTemperatureArrowUp: $d8206b3ab2e65c05$export$d7a5da41ce01461d,
    faTemperatureUp: $d8206b3ab2e65c05$export$872345a0157330a3,
    faMedal: $d8206b3ab2e65c05$export$b48a5be96314835a,
    faBed: $d8206b3ab2e65c05$export$f24e0fce77994d4d,
    faSquareH: $d8206b3ab2e65c05$export$51e3c5be06a49e32,
    faHSquare: $d8206b3ab2e65c05$export$f08bbcf8f59eafc2,
    faPodcast: $d8206b3ab2e65c05$export$5c0b4709125e92f8,
    faTemperatureFull: $d8206b3ab2e65c05$export$bf4d97a79734997f,
    faTemperature4: $d8206b3ab2e65c05$export$db946f8dc50a57ca,
    faThermometer4: $d8206b3ab2e65c05$export$92b2e2293472dd50,
    faThermometerFull: $d8206b3ab2e65c05$export$74e07083cef79a6f,
    faBell: $d8206b3ab2e65c05$export$9b6162797ab1b255,
    faSuperscript: $d8206b3ab2e65c05$export$4fa56a54e822dd25,
    faPlugCircleXmark: $d8206b3ab2e65c05$export$12ef959394d63192,
    faStarOfLife: $d8206b3ab2e65c05$export$aa3c4c1c5a47bf98,
    faPhoneSlash: $d8206b3ab2e65c05$export$4c60a3aade08b6c2,
    faPaintRoller: $d8206b3ab2e65c05$export$d1de8d1b815d6a5,
    faHandshakeAngle: $d8206b3ab2e65c05$export$503f458ca5cf64c2,
    faHandsHelping: $d8206b3ab2e65c05$export$287dbb1632da0d44,
    faLocationDot: $d8206b3ab2e65c05$export$90a475e93ff4bb8a,
    faMapMarkerAlt: $d8206b3ab2e65c05$export$4be92fa780613f93,
    faFile: $d8206b3ab2e65c05$export$cad54bead856a678,
    faGreaterThan: $d8206b3ab2e65c05$export$da07b6bc24a496ca,
    faPersonSwimming: $d8206b3ab2e65c05$export$3fb4da6af843d39f,
    faSwimmer: $d8206b3ab2e65c05$export$67daf2e2f88c1365,
    faArrowDown: $d8206b3ab2e65c05$export$9686eff8d817f770,
    faDroplet: $d8206b3ab2e65c05$export$cc1b6e60cb98fb90,
    faTint: $d8206b3ab2e65c05$export$60dd975bd5938c15,
    faEraser: $d8206b3ab2e65c05$export$e7fc4fe34e767f28,
    faEarthAmericas: $d8206b3ab2e65c05$export$9c4218a898614082,
    faEarth: $d8206b3ab2e65c05$export$c2118d3775773870,
    faEarthAmerica: $d8206b3ab2e65c05$export$8b0f3a26397cf632,
    faGlobeAmericas: $d8206b3ab2e65c05$export$e96bcc7bde9498db,
    faPersonBurst: $d8206b3ab2e65c05$export$ae02241644924482,
    faDove: $d8206b3ab2e65c05$export$a1ab1e69a300089f,
    faBatteryEmpty: $d8206b3ab2e65c05$export$1344b64f6e922e12,
    faBattery0: $d8206b3ab2e65c05$export$de8d0338927394c1,
    faSocks: $d8206b3ab2e65c05$export$8d36a54dbf1e6bce,
    faInbox: $d8206b3ab2e65c05$export$366b69cbdce46334,
    faSection: $d8206b3ab2e65c05$export$a6f4f4a005d91fbd,
    faGaugeHigh: $d8206b3ab2e65c05$export$d262c1f5912046e6,
    faTachometerAlt: $d8206b3ab2e65c05$export$38dd17b9f064c10f,
    faTachometerAltFast: $d8206b3ab2e65c05$export$e99d8b85f35b8ca5,
    faEnvelopeOpenText: $d8206b3ab2e65c05$export$f5c53ce8ec380d11,
    faHospital: $d8206b3ab2e65c05$export$7a76c9d35b42d691,
    faHospitalAlt: $d8206b3ab2e65c05$export$cea7736417b94a3b,
    faHospitalWide: $d8206b3ab2e65c05$export$69c8cc0360f017e8,
    faWineBottle: $d8206b3ab2e65c05$export$770be8b3d5776043,
    faChessRook: $d8206b3ab2e65c05$export$5d65c40a109eb09c,
    faBarsStaggered: $d8206b3ab2e65c05$export$2f8a7938c06a2142,
    faReorder: $d8206b3ab2e65c05$export$75d2bb378a2fc102,
    faStream: $d8206b3ab2e65c05$export$ed81ab40fc4e904,
    faDharmachakra: $d8206b3ab2e65c05$export$45cbd92c28deb2c7,
    faHotdog: $d8206b3ab2e65c05$export$9fae219b4d3ce0be,
    faPersonWalkingWithCane: $d8206b3ab2e65c05$export$2ffee5b2bc935c1f,
    faBlind: $d8206b3ab2e65c05$export$923de21def6ea9b6,
    faDrum: $d8206b3ab2e65c05$export$5b9205e1042594b7,
    faIceCream: $d8206b3ab2e65c05$export$dd52741c60cc638f,
    faHeartCircleBolt: $d8206b3ab2e65c05$export$2a376a9d0d8fee96,
    faFax: $d8206b3ab2e65c05$export$b5698497901d7197,
    faParagraph: $d8206b3ab2e65c05$export$dec46f8df1860e0,
    faCheckToSlot: $d8206b3ab2e65c05$export$6999832247e52c2b,
    faVoteYea: $d8206b3ab2e65c05$export$e87bb3db1608b850,
    faStarHalf: $d8206b3ab2e65c05$export$228008b5e11032fa,
    faBoxesStacked: $d8206b3ab2e65c05$export$2088efcf62cf3b1,
    faBoxes: $d8206b3ab2e65c05$export$2007320dd6cde6db,
    faBoxesAlt: $d8206b3ab2e65c05$export$e6ef1d896ed63b3e,
    faLink: $d8206b3ab2e65c05$export$88bc01ff8dbecc55,
    faChain: $d8206b3ab2e65c05$export$b5d071e02a25554f,
    faEarListen: $d8206b3ab2e65c05$export$837bc776b490934d,
    faAssistiveListeningSystems: $d8206b3ab2e65c05$export$8eeef3dc0035b165,
    faTreeCity: $d8206b3ab2e65c05$export$ad95e4f80f98ebe0,
    faPlay: $d8206b3ab2e65c05$export$436587205947bca5,
    faFont: $d8206b3ab2e65c05$export$a5dc297d3f60936,
    faTableCellsRowLock: $d8206b3ab2e65c05$export$2c0ab34218da6651,
    faRupiahSign: $d8206b3ab2e65c05$export$fe44d4c71644ea0,
    faMagnifyingGlass: $d8206b3ab2e65c05$export$34c8b97060c09ff,
    faSearch: $d8206b3ab2e65c05$export$871a78837687ffe8,
    faTableTennisPaddleBall: $d8206b3ab2e65c05$export$eabe53838d45ac6a,
    faPingPongPaddleBall: $d8206b3ab2e65c05$export$ebb246c621751737,
    faTableTennis: $d8206b3ab2e65c05$export$f378fbb4e0ef7edf,
    faPersonDotsFromLine: $d8206b3ab2e65c05$export$cdcec8ca7ec0d381,
    faDiagnoses: $d8206b3ab2e65c05$export$68bad2b52a90d1fa,
    faTrashCanArrowUp: $d8206b3ab2e65c05$export$60430351cdb4ba89,
    faTrashRestoreAlt: $d8206b3ab2e65c05$export$d075b19b21cb9856,
    faNairaSign: $d8206b3ab2e65c05$export$58b7558ca9822358,
    faCartArrowDown: $d8206b3ab2e65c05$export$9206260ff0c0c616,
    faWalkieTalkie: $d8206b3ab2e65c05$export$8a322f740d64e9fc,
    faFilePen: $d8206b3ab2e65c05$export$27f34878d8ed7a76,
    faFileEdit: $d8206b3ab2e65c05$export$e343e19f1757c5ae,
    faReceipt: $d8206b3ab2e65c05$export$32b0cd6133c2742,
    faSquarePen: $d8206b3ab2e65c05$export$3643b719db23d46e,
    faPenSquare: $d8206b3ab2e65c05$export$fbb231ccb3d960bc,
    faPencilSquare: $d8206b3ab2e65c05$export$35d253ecd249e771,
    faSuitcaseRolling: $d8206b3ab2e65c05$export$957e62a9b80ff4e3,
    faPersonCircleExclamation: $d8206b3ab2e65c05$export$38c8c32017dd9cc,
    faChevronDown: $d8206b3ab2e65c05$export$8db9bc521720fccd,
    faBatteryFull: $d8206b3ab2e65c05$export$9338fc4614cfc0cf,
    faBattery: $d8206b3ab2e65c05$export$214720d39635cea8,
    faBattery5: $d8206b3ab2e65c05$export$e426617482c711a7,
    faSkullCrossbones: $d8206b3ab2e65c05$export$8717352b90217272,
    faCodeCompare: $d8206b3ab2e65c05$export$ca4c5b4dcff58860,
    faListUl: $d8206b3ab2e65c05$export$f8a219cf4f516384,
    faListDots: $d8206b3ab2e65c05$export$e6f4ba30d84fa6ea,
    faSchoolLock: $d8206b3ab2e65c05$export$8845cce2a763ee07,
    faTowerCell: $d8206b3ab2e65c05$export$f4b64c3a138c1b59,
    faDownLong: $d8206b3ab2e65c05$export$e88ba08d4f4d65b6,
    faLongArrowAltDown: $d8206b3ab2e65c05$export$8b92530ca6418c2f,
    faRankingStar: $d8206b3ab2e65c05$export$e6fd420a918b43b5,
    faChessKing: $d8206b3ab2e65c05$export$d5713874f8fefe1b,
    faPersonHarassing: $d8206b3ab2e65c05$export$dcd74f2821882a49,
    faBrazilianRealSign: $d8206b3ab2e65c05$export$9d355b4e79216962,
    faLandmarkDome: $d8206b3ab2e65c05$export$8a56136f40511e5d,
    faLandmarkAlt: $d8206b3ab2e65c05$export$8b9c180efffc50ab,
    faArrowUp: $d8206b3ab2e65c05$export$8e144ed4d52eef49,
    faTv: $d8206b3ab2e65c05$export$e0cfed4ba2fe562c,
    faTelevision: $d8206b3ab2e65c05$export$9803b0176917be28,
    faTvAlt: $d8206b3ab2e65c05$export$6aa64ad5a1974ad7,
    faShrimp: $d8206b3ab2e65c05$export$ac094c06f566cca3,
    faListCheck: $d8206b3ab2e65c05$export$350a84fd0f833f4d,
    faTasks: $d8206b3ab2e65c05$export$2f6d5b2fec286d63,
    faJugDetergent: $d8206b3ab2e65c05$export$3fe50bd8062cd141,
    faCircleUser: $d8206b3ab2e65c05$export$9a5c11a5e3d7f1e7,
    faUserCircle: $d8206b3ab2e65c05$export$be7d974e9e0dba1a,
    faUserShield: $d8206b3ab2e65c05$export$d1886bc596424e6c,
    faWind: $d8206b3ab2e65c05$export$cc58cb0f2257a6a9,
    faCarBurst: $d8206b3ab2e65c05$export$6d2be7c5d395dd16,
    faCarCrash: $d8206b3ab2e65c05$export$8ff55566398404cd,
    faY: $d8206b3ab2e65c05$export$b8c4c058fe7d193c,
    faPersonSnowboarding: $d8206b3ab2e65c05$export$22c642403aeeaeaf,
    faSnowboarding: $d8206b3ab2e65c05$export$72683772d587302a,
    faTruckFast: $d8206b3ab2e65c05$export$27de16299ddd171,
    faShippingFast: $d8206b3ab2e65c05$export$5e419f47aaeb3c05,
    faFish: $d8206b3ab2e65c05$export$24228a855c5f6812,
    faUserGraduate: $d8206b3ab2e65c05$export$10f5839059d22f7e,
    faCircleHalfStroke: $d8206b3ab2e65c05$export$625fb3848216f28c,
    faAdjust: $d8206b3ab2e65c05$export$cfa06e4b68edca2d,
    faClapperboard: $d8206b3ab2e65c05$export$add3b381ced12554,
    faCircleRadiation: $d8206b3ab2e65c05$export$55c8e3afd9f6c0b4,
    faRadiationAlt: $d8206b3ab2e65c05$export$2f048fa82bbddf6f,
    faBaseball: $d8206b3ab2e65c05$export$dc3654cf8a596fbf,
    faBaseballBall: $d8206b3ab2e65c05$export$63a3f8ceae07c7f3,
    faJetFighterUp: $d8206b3ab2e65c05$export$b024a52a4ccf5e69,
    faDiagramProject: $d8206b3ab2e65c05$export$59c351869dc27435,
    faProjectDiagram: $d8206b3ab2e65c05$export$30bf9f5b96509df1,
    faCopy: $d8206b3ab2e65c05$export$e9bd786d30cb716c,
    faVolumeXmark: $d8206b3ab2e65c05$export$28cc565c11db6f2e,
    faVolumeMute: $d8206b3ab2e65c05$export$aa8decd057dfd29b,
    faVolumeTimes: $d8206b3ab2e65c05$export$a1c7b36ba71dbeca,
    faHandSparkles: $d8206b3ab2e65c05$export$72e2d874a963de0c,
    faGrip: $d8206b3ab2e65c05$export$eb83fb404127db75,
    faGripHorizontal: $d8206b3ab2e65c05$export$4a45308d6c8decc1,
    faShareFromSquare: $d8206b3ab2e65c05$export$928280bdd54fa173,
    faShareSquare: $d8206b3ab2e65c05$export$ae9e1434571f373c,
    faChildCombatant: $d8206b3ab2e65c05$export$f7367a7301f2dc0f,
    faChildRifle: $d8206b3ab2e65c05$export$9b027cdb5db3ae5c,
    faGun: $d8206b3ab2e65c05$export$e18f576a7b31ba46,
    faSquarePhone: $d8206b3ab2e65c05$export$318ed022991eef56,
    faPhoneSquare: $d8206b3ab2e65c05$export$8ba22605a641ebdf,
    faPlus: $d8206b3ab2e65c05$export$a105e7b44ca0eb9e,
    faAdd: $d8206b3ab2e65c05$export$9e8f9a9d4ad32c0f,
    faExpand: $d8206b3ab2e65c05$export$1fe4a9976a241685,
    faComputer: $d8206b3ab2e65c05$export$9835883ce9d0fe78,
    faXmark: $d8206b3ab2e65c05$export$e6e44779b2fa1a5c,
    faClose: $d8206b3ab2e65c05$export$23c717133fd81476,
    faMultiply: $d8206b3ab2e65c05$export$4ed4ff13d4dbc862,
    faRemove: $d8206b3ab2e65c05$export$34810740c1bd6c54,
    faTimes: $d8206b3ab2e65c05$export$174bd7f477b115b4,
    faArrowsUpDownLeftRight: $d8206b3ab2e65c05$export$ff9a43e3a9cb653c,
    faArrows: $d8206b3ab2e65c05$export$d5ae09a305d70340,
    faChalkboardUser: $d8206b3ab2e65c05$export$fd7622d4b8d3674b,
    faChalkboardTeacher: $d8206b3ab2e65c05$export$443fcf69b0155291,
    faPesoSign: $d8206b3ab2e65c05$export$c8f99b9b5ea83555,
    faBuildingShield: $d8206b3ab2e65c05$export$18ba6a500873dba9,
    faBaby: $d8206b3ab2e65c05$export$8afab767536f59ad,
    faUsersLine: $d8206b3ab2e65c05$export$d7e538fddb81da68,
    faQuoteLeft: $d8206b3ab2e65c05$export$932a67a1b1a7a724,
    faQuoteLeftAlt: $d8206b3ab2e65c05$export$95bb9ad3aa35c741,
    faTractor: $d8206b3ab2e65c05$export$e87e41787bbedc98,
    faTrashArrowUp: $d8206b3ab2e65c05$export$940cea0f5451895c,
    faTrashRestore: $d8206b3ab2e65c05$export$d32f45a64ed40e8d,
    faArrowDownUpLock: $d8206b3ab2e65c05$export$fc9f7bd981c34c45,
    faLinesLeaning: $d8206b3ab2e65c05$export$4d384ffc907ddaff,
    faRulerCombined: $d8206b3ab2e65c05$export$613f406c1b5802a8,
    faCopyright: $d8206b3ab2e65c05$export$da61665fff8aebfe,
    faEquals: $d8206b3ab2e65c05$export$a7c5f5e4805fdab,
    faBlender: $d8206b3ab2e65c05$export$db34f7a6de38784f,
    faTeeth: $d8206b3ab2e65c05$export$b4619aeaf0b9d18e,
    faShekelSign: $d8206b3ab2e65c05$export$3570be7b68efb8db,
    faIls: $d8206b3ab2e65c05$export$ecadeff45b05a451,
    faShekel: $d8206b3ab2e65c05$export$27e0e10e74d98736,
    faSheqel: $d8206b3ab2e65c05$export$28b3b26a80030d4e,
    faSheqelSign: $d8206b3ab2e65c05$export$d84993fb5e8c6edd,
    faMap: $d8206b3ab2e65c05$export$fc82fb79180cd17c,
    faRocket: $d8206b3ab2e65c05$export$b24d84ed5657d89a,
    faPhotoFilm: $d8206b3ab2e65c05$export$ed36ad335b36be22,
    faPhotoVideo: $d8206b3ab2e65c05$export$739f6a6a12dfb6ed,
    faFolderMinus: $d8206b3ab2e65c05$export$758f1fb3784e4080,
    faHexagonNodesBolt: $d8206b3ab2e65c05$export$f0f9d0c0b0d511dd,
    faStore: $d8206b3ab2e65c05$export$de59c2657a8ace67,
    faArrowTrendUp: $d8206b3ab2e65c05$export$cf36928a9c52e98a,
    faPlugCircleMinus: $d8206b3ab2e65c05$export$2a44d62160972254,
    faSignHanging: $d8206b3ab2e65c05$export$5c1f29f4c7cad367,
    faSign: $d8206b3ab2e65c05$export$d21d0d6c8e9e8bf9,
    faBezierCurve: $d8206b3ab2e65c05$export$a527a6267c55a54c,
    faBellSlash: $d8206b3ab2e65c05$export$6b31a1e5968b2378,
    faTablet: $d8206b3ab2e65c05$export$1c92b67c45a4b4fc,
    faTabletAndroid: $d8206b3ab2e65c05$export$5eddbb7c71278268,
    faSchoolFlag: $d8206b3ab2e65c05$export$9b263780a7312c8c,
    faFill: $d8206b3ab2e65c05$export$d3c2bcfd3b861e4a,
    faAngleUp: $d8206b3ab2e65c05$export$887340269e6d6cac,
    faDrumstickBite: $d8206b3ab2e65c05$export$482976e9a4ab10f3,
    faHollyBerry: $d8206b3ab2e65c05$export$273296afacf93991,
    faChevronLeft: $d8206b3ab2e65c05$export$75702e3e3dd44a44,
    faBacteria: $d8206b3ab2e65c05$export$7fc18cf2d526c341,
    faHandLizard: $d8206b3ab2e65c05$export$54608d0a883fea4d,
    faNotdef: $d8206b3ab2e65c05$export$3db5bca65a1be8dc,
    faDisease: $d8206b3ab2e65c05$export$c7675a37487adc45,
    faBriefcaseMedical: $d8206b3ab2e65c05$export$5000f52ca9819bf5,
    faGenderless: $d8206b3ab2e65c05$export$c093cc22e88981c2,
    faChevronRight: $d8206b3ab2e65c05$export$930de8c26eb20490,
    faRetweet: $d8206b3ab2e65c05$export$cebc76f79478e40e,
    faCarRear: $d8206b3ab2e65c05$export$ff2b8d5628da5f14,
    faCarAlt: $d8206b3ab2e65c05$export$7937ed2462a665c0,
    faPumpSoap: $d8206b3ab2e65c05$export$821aeede187f23c9,
    faVideoSlash: $d8206b3ab2e65c05$export$a714fc79f58cc9ef,
    faBatteryQuarter: $d8206b3ab2e65c05$export$acec92052ac2183,
    faBattery2: $d8206b3ab2e65c05$export$23ca8a94c555576,
    faRadio: $d8206b3ab2e65c05$export$11b26516cae2104f,
    faBabyCarriage: $d8206b3ab2e65c05$export$3b3ab4d86bad7d26,
    faCarriageBaby: $d8206b3ab2e65c05$export$9f117d92ccd36cf1,
    faTrafficLight: $d8206b3ab2e65c05$export$bf0b19daceaec9c2,
    faThermometer: $d8206b3ab2e65c05$export$f576739e9b18ea4f,
    faVrCardboard: $d8206b3ab2e65c05$export$248171cb6dad4307,
    faHandMiddleFinger: $d8206b3ab2e65c05$export$bd40d3a3a16fb147,
    faPercent: $d8206b3ab2e65c05$export$89a1764fbb7ad2cb,
    faPercentage: $d8206b3ab2e65c05$export$89333857fc063a2e,
    faTruckMoving: $d8206b3ab2e65c05$export$a06617a1a4ccea67,
    faGlassWaterDroplet: $d8206b3ab2e65c05$export$b7ae54b4078b2060,
    faDisplay: $d8206b3ab2e65c05$export$e9d85839f7751f01,
    faFaceSmile: $d8206b3ab2e65c05$export$b5023c446f10324,
    faSmile: $d8206b3ab2e65c05$export$c632b2334f0913bc,
    faThumbtack: $d8206b3ab2e65c05$export$b6314cdc01bb5c43,
    faThumbTack: $d8206b3ab2e65c05$export$b63d0c7b519a9aae,
    faTrophy: $d8206b3ab2e65c05$export$29c432d69ccf85a5,
    faPersonPraying: $d8206b3ab2e65c05$export$8ecd436ef91fc02e,
    faPray: $d8206b3ab2e65c05$export$3b32c982141cad51,
    faHammer: $d8206b3ab2e65c05$export$6310f315e1ebbca5,
    faHandPeace: $d8206b3ab2e65c05$export$e49e3cfceea441cc,
    faRotate: $d8206b3ab2e65c05$export$decde496a29c5b23,
    faSyncAlt: $d8206b3ab2e65c05$export$2ff2056be8c281e4,
    faSpinner: $d8206b3ab2e65c05$export$1025ad641edb49c2,
    faRobot: $d8206b3ab2e65c05$export$30a5bb4ad3fa716c,
    faPeace: $d8206b3ab2e65c05$export$8614cb1326eacd7a,
    faGears: $d8206b3ab2e65c05$export$4aac79b9ae3cfdb8,
    faCogs: $d8206b3ab2e65c05$export$af1575770afc9559,
    faWarehouse: $d8206b3ab2e65c05$export$e3a174a50618c208,
    faArrowUpRightDots: $d8206b3ab2e65c05$export$bc804c6ab898f610,
    faSplotch: $d8206b3ab2e65c05$export$d6f21e17ea797702,
    faFaceGrinHearts: $d8206b3ab2e65c05$export$fbb22081b65e4f33,
    faGrinHearts: $d8206b3ab2e65c05$export$c56cf0e0c3bc5ed2,
    faDiceFour: $d8206b3ab2e65c05$export$2df6451abf70a6ff,
    faSimCard: $d8206b3ab2e65c05$export$3bee83bf278fddbe,
    faTransgender: $d8206b3ab2e65c05$export$7e3f1701aa95ef01,
    faTransgenderAlt: $d8206b3ab2e65c05$export$9c36cf9334c052f,
    faMercury: $d8206b3ab2e65c05$export$e134ecd00b622a47,
    faArrowTurnDown: $d8206b3ab2e65c05$export$fd4d6cfd52703f50,
    faLevelDown: $d8206b3ab2e65c05$export$3794c07e7a666c94,
    faPersonFallingBurst: $d8206b3ab2e65c05$export$a75569baaf4a6c3a,
    faAward: $d8206b3ab2e65c05$export$f8db2747dadd48f7,
    faTicketSimple: $d8206b3ab2e65c05$export$68ddda3b30ba09f0,
    faTicketAlt: $d8206b3ab2e65c05$export$75e38ba471fd89c4,
    faBuilding: $d8206b3ab2e65c05$export$f26673f8b10c3d46,
    faAnglesLeft: $d8206b3ab2e65c05$export$2ebd565813951f81,
    faAngleDoubleLeft: $d8206b3ab2e65c05$export$21b0833b3cf929a7,
    faQrcode: $d8206b3ab2e65c05$export$fc19ca0fe15e73bc,
    faClockRotateLeft: $d8206b3ab2e65c05$export$29be1665d1b36a3b,
    faHistory: $d8206b3ab2e65c05$export$76d1986559ca7b7a,
    faFaceGrinBeamSweat: $d8206b3ab2e65c05$export$2ff38f330c834084,
    faGrinBeamSweat: $d8206b3ab2e65c05$export$14d0ccc54c5b6826,
    faFileExport: $d8206b3ab2e65c05$export$364f19abcfac1b0a,
    faArrowRightFromFile: $d8206b3ab2e65c05$export$b9c76255b38e1df1,
    faShield: $d8206b3ab2e65c05$export$8241bd5b9163ca12,
    faShieldBlank: $d8206b3ab2e65c05$export$64f54da8fbaba8ee,
    faArrowUpShortWide: $d8206b3ab2e65c05$export$be9d5060a4bc3b4b,
    faSortAmountUpAlt: $d8206b3ab2e65c05$export$6e87844b0f151b6a,
    faCommentNodes: $d8206b3ab2e65c05$export$6754d04baba2fe26,
    faHouseMedical: $d8206b3ab2e65c05$export$2d077da983246a68,
    faGolfBallTee: $d8206b3ab2e65c05$export$14c9f1d85e53ae99,
    faGolfBall: $d8206b3ab2e65c05$export$2251487a9a33c682,
    faCircleChevronLeft: $d8206b3ab2e65c05$export$f2b13ad44c03c40f,
    faChevronCircleLeft: $d8206b3ab2e65c05$export$4a42c8c2451a33fd,
    faHouseChimneyWindow: $d8206b3ab2e65c05$export$792391babe46862d,
    faPenNib: $d8206b3ab2e65c05$export$a82594dcc75a49f5,
    faTentArrowTurnLeft: $d8206b3ab2e65c05$export$89af87b7d6c15adf,
    faTents: $d8206b3ab2e65c05$export$c93b950e845a4ee7,
    faWandMagic: $d8206b3ab2e65c05$export$8282f5f5dcf6b009,
    faMagic: $d8206b3ab2e65c05$export$e58f9b502d4dd52d,
    faDog: $d8206b3ab2e65c05$export$c6406747800cf702,
    faCarrot: $d8206b3ab2e65c05$export$28e93ec9f5e2ddf3,
    faMoon: $d8206b3ab2e65c05$export$c4c2f69a53bab720,
    faWineGlassEmpty: $d8206b3ab2e65c05$export$b86d7336e68a3f57,
    faWineGlassAlt: $d8206b3ab2e65c05$export$b8ff3fe2b78aef2f,
    faCheese: $d8206b3ab2e65c05$export$549b99473b7201e6,
    faYinYang: $d8206b3ab2e65c05$export$6ec1acbf3f610b8f,
    faMusic: $d8206b3ab2e65c05$export$fcb0647a5340b5b8,
    faCodeCommit: $d8206b3ab2e65c05$export$d5d870c10bc9f1ce,
    faTemperatureLow: $d8206b3ab2e65c05$export$9e9af12b90a1abd2,
    faPersonBiking: $d8206b3ab2e65c05$export$cf152282d5de300d,
    faBiking: $d8206b3ab2e65c05$export$a5bcf835dbf9c0b,
    faBroom: $d8206b3ab2e65c05$export$2a533051418ff4ca,
    faShieldHeart: $d8206b3ab2e65c05$export$7b96388ca2be471b,
    faGopuram: $d8206b3ab2e65c05$export$31f89d8ac1d14ed6,
    faEarthOceania: $d8206b3ab2e65c05$export$bd931e906edf2f47,
    faGlobeOceania: $d8206b3ab2e65c05$export$8ac3f5271448657d,
    faSquareXmark: $d8206b3ab2e65c05$export$5a17e58bb7afb1d7,
    faTimesSquare: $d8206b3ab2e65c05$export$c0248ac97142ea2a,
    faXmarkSquare: $d8206b3ab2e65c05$export$9a364781d6b7602b,
    faHashtag: $d8206b3ab2e65c05$export$c92c903bade56844,
    faUpRightAndDownLeftFromCenter: $d8206b3ab2e65c05$export$95457ede07b81517,
    faExpandAlt: $d8206b3ab2e65c05$export$bcb8d86a3a1d6eb6,
    faOilCan: $d8206b3ab2e65c05$export$2599126c3a57f727,
    faT: $d8206b3ab2e65c05$export$6e625d2e7790c860,
    faHippo: $d8206b3ab2e65c05$export$d4c909619093de2d,
    faChartColumn: $d8206b3ab2e65c05$export$d01ddcc9efe7b149,
    faInfinity: $d8206b3ab2e65c05$export$a590003279d671b8,
    faVialCircleCheck: $d8206b3ab2e65c05$export$2db4f9712313eafa,
    faPersonArrowDownToLine: $d8206b3ab2e65c05$export$f9a5161975928326,
    faVoicemail: $d8206b3ab2e65c05$export$4f1ce88b2b4cd5cd,
    faFan: $d8206b3ab2e65c05$export$55145a3dae4f984a,
    faPersonWalkingLuggage: $d8206b3ab2e65c05$export$1ae0a37b36ace746,
    faUpDown: $d8206b3ab2e65c05$export$e36c32dd5cba9b90,
    faArrowsAltV: $d8206b3ab2e65c05$export$138cb56a3f8f7040,
    faCloudMoonRain: $d8206b3ab2e65c05$export$301c3fab0c4545bd,
    faCalendar: $d8206b3ab2e65c05$export$34f5c36a3e80efa2,
    faTrailer: $d8206b3ab2e65c05$export$3a48b9820e92f5ab,
    faBahai: $d8206b3ab2e65c05$export$6d636565b3ec36b4,
    faHaykal: $d8206b3ab2e65c05$export$5c15e34e0e43f15c,
    faSdCard: $d8206b3ab2e65c05$export$303efb6031da122,
    faDragon: $d8206b3ab2e65c05$export$ae1875ba975aa0e9,
    faShoePrints: $d8206b3ab2e65c05$export$cdbdd2118099ae07,
    faCirclePlus: $d8206b3ab2e65c05$export$eeda28b8ca4cb18e,
    faPlusCircle: $d8206b3ab2e65c05$export$d9cc3a81499af48c,
    faFaceGrinTongueWink: $d8206b3ab2e65c05$export$4272e56f2429da88,
    faGrinTongueWink: $d8206b3ab2e65c05$export$58099903d50aefb3,
    faHandHolding: $d8206b3ab2e65c05$export$e6094d25274088ab,
    faPlugCircleExclamation: $d8206b3ab2e65c05$export$d893dd9509763a17,
    faLinkSlash: $d8206b3ab2e65c05$export$22965c7f4d903953,
    faChainBroken: $d8206b3ab2e65c05$export$382551e04f32620a,
    faChainSlash: $d8206b3ab2e65c05$export$12f09d657be59586,
    faUnlink: $d8206b3ab2e65c05$export$2f546f7d8ba01e18,
    faClone: $d8206b3ab2e65c05$export$76c1aa4bf9a39458,
    faPersonWalkingArrowLoopLeft: $d8206b3ab2e65c05$export$5a200e8504b7367a,
    faArrowUpZA: $d8206b3ab2e65c05$export$a0a53d8e3c68e9f1,
    faSortAlphaUpAlt: $d8206b3ab2e65c05$export$95ef20828693fb0f,
    faFireFlameCurved: $d8206b3ab2e65c05$export$769724fc1434d618,
    faFireAlt: $d8206b3ab2e65c05$export$70dc26b4926d0b1b,
    faTornado: $d8206b3ab2e65c05$export$6d274258ba4b0089,
    faFileCirclePlus: $d8206b3ab2e65c05$export$430d63b54b1d4009,
    faBookQuran: $d8206b3ab2e65c05$export$ad3212bc3fa1595b,
    faQuran: $d8206b3ab2e65c05$export$46f29ea84ed4c5f1,
    faAnchor: $d8206b3ab2e65c05$export$12a35719f889cd1,
    faBorderAll: $d8206b3ab2e65c05$export$93a5eb721c9c0d25,
    faFaceAngry: $d8206b3ab2e65c05$export$67a047c738fb34da,
    faAngry: $d8206b3ab2e65c05$export$3c96c08e234498c5,
    faCookieBite: $d8206b3ab2e65c05$export$317dde8664f7de71,
    faArrowTrendDown: $d8206b3ab2e65c05$export$d2caed5e37174c23,
    faRss: $d8206b3ab2e65c05$export$7329a1ca27b90c5b,
    faFeed: $d8206b3ab2e65c05$export$67ad3d0233cd7b33,
    faDrawPolygon: $d8206b3ab2e65c05$export$df9bd3777d1154d2,
    faScaleBalanced: $d8206b3ab2e65c05$export$33fb4280dc20f0dd,
    faBalanceScale: $d8206b3ab2e65c05$export$fec323dcfd81d750,
    faGaugeSimpleHigh: $d8206b3ab2e65c05$export$cc4351eb13da27d8,
    faTachometer: $d8206b3ab2e65c05$export$362d0f652c3fbca2,
    faTachometerFast: $d8206b3ab2e65c05$export$375b6a8680f980ed,
    faShower: $d8206b3ab2e65c05$export$f7f7c15f18cc19a1,
    faDesktop: $d8206b3ab2e65c05$export$6e6ddc253102e596,
    faDesktopAlt: $d8206b3ab2e65c05$export$ff09a62b9e0fa899,
    faM: $d8206b3ab2e65c05$export$bd6a7788954842b5,
    faTableList: $d8206b3ab2e65c05$export$6e989c3c7050dbb,
    faThList: $d8206b3ab2e65c05$export$daf2614a457122c0,
    faCommentSms: $d8206b3ab2e65c05$export$435fe17e9d6170d6,
    faSms: $d8206b3ab2e65c05$export$9dbcc3443daa7323,
    faBook: $d8206b3ab2e65c05$export$c9d7ef726d1a8742,
    faUserPlus: $d8206b3ab2e65c05$export$4c17261776a709f2,
    faCheck: $d8206b3ab2e65c05$export$62b2c752fccc6a9c,
    faBatteryThreeQuarters: $d8206b3ab2e65c05$export$cfb37069d38f379e,
    faBattery4: $d8206b3ab2e65c05$export$35ffefed200d123c,
    faHouseCircleCheck: $d8206b3ab2e65c05$export$c9382fa3394ef53a,
    faAngleLeft: $d8206b3ab2e65c05$export$3cbcd1b7e35945d2,
    faDiagramSuccessor: $d8206b3ab2e65c05$export$ff7f40159cadb0ac,
    faTruckArrowRight: $d8206b3ab2e65c05$export$d69fa2b7839ce76,
    faArrowsSplitUpAndLeft: $d8206b3ab2e65c05$export$7df274119d2469d1,
    faHandFist: $d8206b3ab2e65c05$export$ca492f58fe30a42f,
    faFistRaised: $d8206b3ab2e65c05$export$fa0323a4d7489a8d,
    faCloudMoon: $d8206b3ab2e65c05$export$482eb125aaf0fbc2,
    faBriefcase: $d8206b3ab2e65c05$export$8da450d063b0eb37,
    faPersonFalling: $d8206b3ab2e65c05$export$e94ab3a30cf4aca5,
    faImagePortrait: $d8206b3ab2e65c05$export$c23fd8b91a7ed48,
    faPortrait: $d8206b3ab2e65c05$export$e3d25f819c7ee7d7,
    faUserTag: $d8206b3ab2e65c05$export$9eec597148166b36,
    faRug: $d8206b3ab2e65c05$export$7cee7480f25f5289,
    faEarthEurope: $d8206b3ab2e65c05$export$7adefae4a1be1d97,
    faGlobeEurope: $d8206b3ab2e65c05$export$5318b8ede86cc96b,
    faCartFlatbedSuitcase: $d8206b3ab2e65c05$export$ab81ff863770d996,
    faLuggageCart: $d8206b3ab2e65c05$export$bd1e24dd3cde8514,
    faRectangleXmark: $d8206b3ab2e65c05$export$3896694b3e81fba7,
    faRectangleTimes: $d8206b3ab2e65c05$export$eaaf26416a51dc1,
    faTimesRectangle: $d8206b3ab2e65c05$export$10147c0014152a3f,
    faWindowClose: $d8206b3ab2e65c05$export$18b7775f78a3e16,
    faBahtSign: $d8206b3ab2e65c05$export$ffc7123046a28ee,
    faBookOpen: $d8206b3ab2e65c05$export$8a3071811b2b7979,
    faBookJournalWhills: $d8206b3ab2e65c05$export$d3d49030d557a09b,
    faJournalWhills: $d8206b3ab2e65c05$export$66a0d8d45aab6631,
    faHandcuffs: $d8206b3ab2e65c05$export$74d1f89b5feb9d42,
    faTriangleExclamation: $d8206b3ab2e65c05$export$1cbf6e649ce86166,
    faExclamationTriangle: $d8206b3ab2e65c05$export$3d249b63b52cce7c,
    faWarning: $d8206b3ab2e65c05$export$2e470a35c38b096a,
    faDatabase: $d8206b3ab2e65c05$export$24680dede86b1883,
    faShare: $d8206b3ab2e65c05$export$c08b4b0e2b0dc027,
    faMailForward: $d8206b3ab2e65c05$export$81df7693d3f2f8da,
    faBottleDroplet: $d8206b3ab2e65c05$export$8f534e1e0ab75bfe,
    faMaskFace: $d8206b3ab2e65c05$export$140d4da0adbaf435,
    faHillRockslide: $d8206b3ab2e65c05$export$7ec15a32285f6c22,
    faRightLeft: $d8206b3ab2e65c05$export$a082af56be9786ae,
    faExchangeAlt: $d8206b3ab2e65c05$export$f6c6fb20d374b128,
    faPaperPlane: $d8206b3ab2e65c05$export$b5378818301da1be,
    faRoadCircleExclamation: $d8206b3ab2e65c05$export$79753c2153535b01,
    faDungeon: $d8206b3ab2e65c05$export$1156dc6acb0058bd,
    faAlignRight: $d8206b3ab2e65c05$export$7370f36a39a38737,
    faMoneyBill1Wave: $d8206b3ab2e65c05$export$52e3e96cd1564779,
    faMoneyBillWaveAlt: $d8206b3ab2e65c05$export$1613858e873cbb3e,
    faLifeRing: $d8206b3ab2e65c05$export$53dd2cacf674142a,
    faHands: $d8206b3ab2e65c05$export$f9712d0cf5150f0c,
    faSignLanguage: $d8206b3ab2e65c05$export$20993813350f9671,
    faSigning: $d8206b3ab2e65c05$export$5cc0e6f5191f4f02,
    faCalendarDay: $d8206b3ab2e65c05$export$80968bcfef6481ca,
    faWaterLadder: $d8206b3ab2e65c05$export$5930e9bdfd790d77,
    faLadderWater: $d8206b3ab2e65c05$export$c5ea6eeef2db2b3b,
    faSwimmingPool: $d8206b3ab2e65c05$export$4dee691631c67d5c,
    faArrowsUpDown: $d8206b3ab2e65c05$export$64185f27d82c259f,
    faArrowsV: $d8206b3ab2e65c05$export$cec5f1bc9e068e48,
    faFaceGrimace: $d8206b3ab2e65c05$export$bd5bd2ef56b793b1,
    faGrimace: $d8206b3ab2e65c05$export$3d08cd36ac1ef231,
    faWheelchairMove: $d8206b3ab2e65c05$export$1482162f7fe04ac,
    faWheelchairAlt: $d8206b3ab2e65c05$export$7db9460785019040,
    faTurnDown: $d8206b3ab2e65c05$export$b5dc9dd0347bbb6,
    faLevelDownAlt: $d8206b3ab2e65c05$export$c07eb6ff5a382cbd,
    faPersonWalkingArrowRight: $d8206b3ab2e65c05$export$3e15790fe68c095b,
    faSquareEnvelope: $d8206b3ab2e65c05$export$15da4ef8c0fb20d6,
    faEnvelopeSquare: $d8206b3ab2e65c05$export$354e159473e73552,
    faDice: $d8206b3ab2e65c05$export$4ed8206e6619cc8f,
    faBowlingBall: $d8206b3ab2e65c05$export$5ee2640fe105312d,
    faBrain: $d8206b3ab2e65c05$export$97fa4f4c1006ab1,
    faBandage: $d8206b3ab2e65c05$export$658a137d3845bca7,
    faBandAid: $d8206b3ab2e65c05$export$b14a1014df2fdf46,
    faCalendarMinus: $d8206b3ab2e65c05$export$23e8b4955c2d951b,
    faCircleXmark: $d8206b3ab2e65c05$export$30262489773a79a3,
    faTimesCircle: $d8206b3ab2e65c05$export$ab0ec50720a747eb,
    faXmarkCircle: $d8206b3ab2e65c05$export$90ac4096df8efdee,
    faGifts: $d8206b3ab2e65c05$export$de9a67b55dbe819a,
    faHotel: $d8206b3ab2e65c05$export$c402efcf01d5ca07,
    faEarthAsia: $d8206b3ab2e65c05$export$807cdd395fe012cb,
    faGlobeAsia: $d8206b3ab2e65c05$export$796fdfc909e603f4,
    faIdCardClip: $d8206b3ab2e65c05$export$31e6961064ddac7b,
    faIdCardAlt: $d8206b3ab2e65c05$export$dc37ebbac31f6c6c,
    faMagnifyingGlassPlus: $d8206b3ab2e65c05$export$f48a3ba52a0a9e56,
    faSearchPlus: $d8206b3ab2e65c05$export$378f00e6b1a8185,
    faThumbsUp: $d8206b3ab2e65c05$export$47e4e0d519d33497,
    faUserClock: $d8206b3ab2e65c05$export$b00596a09aa07311,
    faHandDots: $d8206b3ab2e65c05$export$8846d49caaed1c0a,
    faAllergies: $d8206b3ab2e65c05$export$dcae2101babbffff,
    faFileInvoice: $d8206b3ab2e65c05$export$bef39294aed2281a,
    faWindowMinimize: $d8206b3ab2e65c05$export$26a3f9d2784b90d8,
    faMugSaucer: $d8206b3ab2e65c05$export$60048819854688c5,
    faCoffee: $d8206b3ab2e65c05$export$1d24a9e457278011,
    faBrush: $d8206b3ab2e65c05$export$5824ffe6f8983c83,
    faFileHalfDashed: $d8206b3ab2e65c05$export$a8fabd50d8cb3ffd,
    faMask: $d8206b3ab2e65c05$export$7b028758c03b9655,
    faMagnifyingGlassMinus: $d8206b3ab2e65c05$export$56d810b9ab2e30bc,
    faSearchMinus: $d8206b3ab2e65c05$export$efca97eef6a7a17d,
    faRulerVertical: $d8206b3ab2e65c05$export$a6ad5df9d9f29553,
    faUserLarge: $d8206b3ab2e65c05$export$50a28538498238f,
    faUserAlt: $d8206b3ab2e65c05$export$ae9b19c2ac726cfc,
    faTrainTram: $d8206b3ab2e65c05$export$d401d4aeba21cdf3,
    faUserNurse: $d8206b3ab2e65c05$export$ab9af5aa013d2162,
    faSyringe: $d8206b3ab2e65c05$export$1aa9423ec6b1d609,
    faCloudSun: $d8206b3ab2e65c05$export$dcaadfd9c98e42a1,
    faStopwatch20: $d8206b3ab2e65c05$export$df6244b0501f2112,
    faSquareFull: $d8206b3ab2e65c05$export$7ec6541fee081990,
    faMagnet: $d8206b3ab2e65c05$export$78932e9c9abea6b7,
    faJar: $d8206b3ab2e65c05$export$53583b459a87a01,
    faNoteSticky: $d8206b3ab2e65c05$export$4a4e034527c933f5,
    faStickyNote: $d8206b3ab2e65c05$export$80889adc5d98bf4a,
    faBugSlash: $d8206b3ab2e65c05$export$fc4dd5feed8df23,
    faArrowUpFromWaterPump: $d8206b3ab2e65c05$export$1a093e7861c5e48f,
    faBone: $d8206b3ab2e65c05$export$5902c007d5703f2d,
    faTableCellsRowUnlock: $d8206b3ab2e65c05$export$59ce5ca5da74ff72,
    faUserInjured: $d8206b3ab2e65c05$export$c950c1ba7f227d5b,
    faFaceSadTear: $d8206b3ab2e65c05$export$8a5a0dbb2a17e253,
    faSadTear: $d8206b3ab2e65c05$export$4b5241926f692f91,
    faPlane: $d8206b3ab2e65c05$export$f654c69e66b466c0,
    faTentArrowsDown: $d8206b3ab2e65c05$export$51adfe7c9ee4f428,
    faExclamation: $d8206b3ab2e65c05$export$de6218b649cbb6a9,
    faArrowsSpin: $d8206b3ab2e65c05$export$7e05388be208e313,
    faPrint: $d8206b3ab2e65c05$export$ae64371e02ee8e56,
    faTurkishLiraSign: $d8206b3ab2e65c05$export$b458d393151b6960,
    faTry: $d8206b3ab2e65c05$export$970dda513e46c41f,
    faTurkishLira: $d8206b3ab2e65c05$export$40e66e5966827199,
    faDollarSign: $d8206b3ab2e65c05$export$fb420d3e4d8c6a18,
    faDollar: $d8206b3ab2e65c05$export$a4ffb0775547fcdf,
    faUsd: $d8206b3ab2e65c05$export$72cca07d38a28589,
    faX: $d8206b3ab2e65c05$export$476af662c0c32cbc,
    faMagnifyingGlassDollar: $d8206b3ab2e65c05$export$fa4f1ead37dc1dce,
    faSearchDollar: $d8206b3ab2e65c05$export$65b49a6767630708,
    faUsersGear: $d8206b3ab2e65c05$export$3a18218720110fc0,
    faUsersCog: $d8206b3ab2e65c05$export$5e0b06753fc69b81,
    faPersonMilitaryPointing: $d8206b3ab2e65c05$export$50b6dcaa9ec03439,
    faBuildingColumns: $d8206b3ab2e65c05$export$a411e7e26cb63d5e,
    faBank: $d8206b3ab2e65c05$export$6e379b829ea8b99,
    faInstitution: $d8206b3ab2e65c05$export$1dba320226a34c1f,
    faMuseum: $d8206b3ab2e65c05$export$9b3953adff472ad2,
    faUniversity: $d8206b3ab2e65c05$export$f2e1460ebe1a8cb0,
    faUmbrella: $d8206b3ab2e65c05$export$9ff64ffae70e08c0,
    faTrowel: $d8206b3ab2e65c05$export$12ca996a6f686fe1,
    faD: $d8206b3ab2e65c05$export$56c73b799aac2555,
    faStapler: $d8206b3ab2e65c05$export$c7e014b7e3ac3d83,
    faMasksTheater: $d8206b3ab2e65c05$export$bf5896cc1ce4d55,
    faTheaterMasks: $d8206b3ab2e65c05$export$3dbedc487b0159ac,
    faKipSign: $d8206b3ab2e65c05$export$a6df39524c41472c,
    faHandPointLeft: $d8206b3ab2e65c05$export$b276ec3dc9760d39,
    faHandshakeSimple: $d8206b3ab2e65c05$export$e8485db4dab0ab30,
    faHandshakeAlt: $d8206b3ab2e65c05$export$e9aa3c6f9f47aa1a,
    faJetFighter: $d8206b3ab2e65c05$export$2130e629ab767ab3,
    faFighterJet: $d8206b3ab2e65c05$export$102b809faf56e033,
    faSquareShareNodes: $d8206b3ab2e65c05$export$1bdb0ec5af3fea99,
    faShareAltSquare: $d8206b3ab2e65c05$export$3799c2d8fd7e493b,
    faBarcode: $d8206b3ab2e65c05$export$3825a842b5afc5aa,
    faPlusMinus: $d8206b3ab2e65c05$export$37bd38cf96417095,
    faVideo: $d8206b3ab2e65c05$export$5c6bd8729527871b,
    faVideoCamera: $d8206b3ab2e65c05$export$3a530df752193ccf,
    faGraduationCap: $d8206b3ab2e65c05$export$874e305fd7920cce,
    faMortarBoard: $d8206b3ab2e65c05$export$dd0a013bf23a9d86,
    faHandHoldingMedical: $d8206b3ab2e65c05$export$bb2a6b1b5e852300,
    faPersonCircleCheck: $d8206b3ab2e65c05$export$30294c81ac4031ca,
    faTurnUp: $d8206b3ab2e65c05$export$314f5cab62fc6968,
    faLevelUpAlt: $d8206b3ab2e65c05$export$d6f21a309b179c3d
};


function $bd8d6d84c8bdc892$export$2e2bcd8739ae039() {
    (0, $a43d996a7aa8a839$export$b839f963c7dc0e34).add((0, $d8206b3ab2e65c05$export$b4da69a0247f3620), (0, $d8206b3ab2e65c05$export$62b2c752fccc6a9c), (0, $d8206b3ab2e65c05$export$877e5ae47a854215), (0, $d8206b3ab2e65c05$export$8db9bc521720fccd), (0, $7435a4b2c8a749a5$export$d7cf0978afd90002), (0, $d8206b3ab2e65c05$export$c1a3ba061b4f60c4), (0, $7435a4b2c8a749a5$export$30262489773a79a3), (0, $d8206b3ab2e65c05$export$88bc01ff8dbecc55), (0, $d8206b3ab2e65c05$export$34c8b97060c09ff), (0, $7435a4b2c8a749a5$export$90b4406457aae8cc), (0, $d8206b3ab2e65c05$export$5bb6a0c94ad2f4bb), (0, $d8206b3ab2e65c05$export$ea6970ed5a15feb6), (0, $d8206b3ab2e65c05$export$36583f5d3d5a971f), (0, $d8206b3ab2e65c05$export$9c4218a898614082), (0, $d8206b3ab2e65c05$export$1cbf6e649ce86166));
    (0, $a43d996a7aa8a839$export$df3a06d6289f983e).watch();
}


var $65d191346d2f0e85$exports = {};
/* @preserve
 * Leaflet 1.9.4, a JS library for interactive maps. https://leafletjs.com
 * (c) 2010-2023 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */ (function(global, factory) {
    factory($65d191346d2f0e85$exports);
})($65d191346d2f0e85$exports, function(exports1) {
    'use strict';
    var version = "1.9.4";
    /*
   * @namespace Util
   *
   * Various utility functions, used by Leaflet internally.
   */ // @function extend(dest: Object, src?: Object): Object
    // Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
    function extend(dest) {
        var i, j, len, src;
        for(j = 1, len = arguments.length; j < len; j++){
            src = arguments[j];
            for(i in src)dest[i] = src[i];
        }
        return dest;
    }
    // @function create(proto: Object, properties?: Object): Object
    // Compatibility polyfill for [Object.create](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/create)
    var create$2 = Object.create || function() {
        function F() {}
        return function(proto) {
            F.prototype = proto;
            return new F();
        };
    }();
    // @function bind(fn: Function, …): Function
    // Returns a new function bound to the arguments passed, like [Function.prototype.bind](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
    // Has a `L.bind()` shortcut.
    function bind(fn, obj) {
        var slice = Array.prototype.slice;
        if (fn.bind) return fn.bind.apply(fn, slice.call(arguments, 1));
        var args = slice.call(arguments, 2);
        return function() {
            return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
        };
    }
    // @property lastId: Number
    // Last unique ID used by [`stamp()`](#util-stamp)
    var lastId = 0;
    // @function stamp(obj: Object): Number
    // Returns the unique ID of an object, assigning it one if it doesn't have it.
    function stamp(obj) {
        if (!('_leaflet_id' in obj)) obj['_leaflet_id'] = ++lastId;
        return obj._leaflet_id;
    }
    // @function throttle(fn: Function, time: Number, context: Object): Function
    // Returns a function which executes function `fn` with the given scope `context`
    // (so that the `this` keyword refers to `context` inside `fn`'s code). The function
    // `fn` will be called no more than one time per given amount of `time`. The arguments
    // received by the bound function will be any arguments passed when binding the
    // function, followed by any arguments passed when invoking the bound function.
    // Has an `L.throttle` shortcut.
    function throttle(fn, time, context) {
        var lock, args, wrapperFn, later;
        later = function() {
            // reset lock and call if queued
            lock = false;
            if (args) {
                wrapperFn.apply(context, args);
                args = false;
            }
        };
        wrapperFn = function() {
            if (lock) // called too soon, queue to call later
            args = arguments;
            else {
                // call and lock until later
                fn.apply(context, arguments);
                setTimeout(later, time);
                lock = true;
            }
        };
        return wrapperFn;
    }
    // @function wrapNum(num: Number, range: Number[], includeMax?: Boolean): Number
    // Returns the number `num` modulo `range` in such a way so it lies within
    // `range[0]` and `range[1]`. The returned value will be always smaller than
    // `range[1]` unless `includeMax` is set to `true`.
    function wrapNum(x, range, includeMax) {
        var max = range[1], min = range[0], d = max - min;
        return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
    }
    // @function falseFn(): Function
    // Returns a function which always returns `false`.
    function falseFn() {
        return false;
    }
    // @function formatNum(num: Number, precision?: Number|false): Number
    // Returns the number `num` rounded with specified `precision`.
    // The default `precision` value is 6 decimal places.
    // `false` can be passed to skip any processing (can be useful to avoid round-off errors).
    function formatNum(num, precision) {
        if (precision === false) return num;
        var pow = Math.pow(10, precision === undefined ? 6 : precision);
        return Math.round(num * pow) / pow;
    }
    // @function trim(str: String): String
    // Compatibility polyfill for [String.prototype.trim](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim)
    function trim(str) {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
    }
    // @function splitWords(str: String): String[]
    // Trims and splits the string on whitespace and returns the array of parts.
    function splitWords(str) {
        return trim(str).split(/\s+/);
    }
    // @function setOptions(obj: Object, options: Object): Object
    // Merges the given properties to the `options` of the `obj` object, returning the resulting options. See `Class options`. Has an `L.setOptions` shortcut.
    function setOptions(obj, options) {
        if (!Object.prototype.hasOwnProperty.call(obj, 'options')) obj.options = obj.options ? create$2(obj.options) : {};
        for(var i in options)obj.options[i] = options[i];
        return obj.options;
    }
    // @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
    // Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
    // translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
    // be appended at the end. If `uppercase` is `true`, the parameter names will
    // be uppercased (e.g. `'?A=foo&B=bar'`)
    function getParamString(obj, existingUrl, uppercase) {
        var params = [];
        for(var i in obj)params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + '=' + encodeURIComponent(obj[i]));
        return (!existingUrl || existingUrl.indexOf('?') === -1 ? '?' : '&') + params.join('&');
    }
    var templateRe = /\{ *([\w_ -]+) *\}/g;
    // @function template(str: String, data: Object): String
    // Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
    // and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
    // `('Hello foo, bar')`. You can also specify functions instead of strings for
    // data values — they will be evaluated passing `data` as an argument.
    function template(str, data) {
        return str.replace(templateRe, function(str, key) {
            var value = data[key];
            if (value === undefined) throw new Error('No value provided for variable ' + str);
            else if (typeof value === 'function') value = value(data);
            return value;
        });
    }
    // @function isArray(obj): Boolean
    // Compatibility polyfill for [Array.isArray](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray)
    var isArray = Array.isArray || function(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };
    // @function indexOf(array: Array, el: Object): Number
    // Compatibility polyfill for [Array.prototype.indexOf](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf)
    function indexOf(array, el) {
        for(var i = 0; i < array.length; i++){
            if (array[i] === el) return i;
        }
        return -1;
    }
    // @property emptyImageUrl: String
    // Data URI string containing a base64-encoded empty GIF image.
    // Used as a hack to free memory from unused images on WebKit-powered
    // mobile devices (by setting image `src` to this string).
    var emptyImageUrl = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
    // inspired by https://paulirish.com/2011/requestanimationframe-for-smart-animating/
    function getPrefixed(name) {
        return window['webkit' + name] || window['moz' + name] || window['ms' + name];
    }
    var lastTime = 0;
    // fallback for IE 7-8
    function timeoutDefer(fn) {
        var time = +new Date(), timeToCall = Math.max(0, 16 - (time - lastTime));
        lastTime = time + timeToCall;
        return window.setTimeout(fn, timeToCall);
    }
    var requestFn = window.requestAnimationFrame || getPrefixed('RequestAnimationFrame') || timeoutDefer;
    var cancelFn = window.cancelAnimationFrame || getPrefixed('CancelAnimationFrame') || getPrefixed('CancelRequestAnimationFrame') || function(id) {
        window.clearTimeout(id);
    };
    // @function requestAnimFrame(fn: Function, context?: Object, immediate?: Boolean): Number
    // Schedules `fn` to be executed when the browser repaints. `fn` is bound to
    // `context` if given. When `immediate` is set, `fn` is called immediately if
    // the browser doesn't have native support for
    // [`window.requestAnimationFrame`](https://developer.mozilla.org/docs/Web/API/window/requestAnimationFrame),
    // otherwise it's delayed. Returns a request ID that can be used to cancel the request.
    function requestAnimFrame(fn, context, immediate) {
        if (immediate && requestFn === timeoutDefer) fn.call(context);
        else return requestFn.call(window, bind(fn, context));
    }
    // @function cancelAnimFrame(id: Number): undefined
    // Cancels a previous `requestAnimFrame`. See also [window.cancelAnimationFrame](https://developer.mozilla.org/docs/Web/API/window/cancelAnimationFrame).
    function cancelAnimFrame(id) {
        if (id) cancelFn.call(window, id);
    }
    var Util = {
        __proto__: null,
        extend: extend,
        create: create$2,
        bind: bind,
        get lastId () {
            return lastId;
        },
        stamp: stamp,
        throttle: throttle,
        wrapNum: wrapNum,
        falseFn: falseFn,
        formatNum: formatNum,
        trim: trim,
        splitWords: splitWords,
        setOptions: setOptions,
        getParamString: getParamString,
        template: template,
        isArray: isArray,
        indexOf: indexOf,
        emptyImageUrl: emptyImageUrl,
        requestFn: requestFn,
        cancelFn: cancelFn,
        requestAnimFrame: requestAnimFrame,
        cancelAnimFrame: cancelAnimFrame
    };
    // @class Class
    // @aka L.Class
    // @section
    // @uninheritable
    // Thanks to John Resig and Dean Edwards for inspiration!
    function Class() {}
    Class.extend = function(props) {
        // @function extend(props: Object): Function
        // [Extends the current class](#class-inheritance) given the properties to be included.
        // Returns a Javascript function that is a class constructor (to be called with `new`).
        var NewClass = function() {
            setOptions(this);
            // call the constructor
            if (this.initialize) this.initialize.apply(this, arguments);
            // call all constructor hooks
            this.callInitHooks();
        };
        var parentProto = NewClass.__super__ = this.prototype;
        var proto = create$2(parentProto);
        proto.constructor = NewClass;
        NewClass.prototype = proto;
        // inherit parent's statics
        for(var i in this)if (Object.prototype.hasOwnProperty.call(this, i) && i !== 'prototype' && i !== '__super__') NewClass[i] = this[i];
        // mix static properties into the class
        if (props.statics) extend(NewClass, props.statics);
        // mix includes into the prototype
        if (props.includes) {
            checkDeprecatedMixinEvents(props.includes);
            extend.apply(null, [
                proto
            ].concat(props.includes));
        }
        // mix given properties into the prototype
        extend(proto, props);
        delete proto.statics;
        delete proto.includes;
        // merge options
        if (proto.options) {
            proto.options = parentProto.options ? create$2(parentProto.options) : {};
            extend(proto.options, props.options);
        }
        proto._initHooks = [];
        // add method for calling all hooks
        proto.callInitHooks = function() {
            if (this._initHooksCalled) return;
            if (parentProto.callInitHooks) parentProto.callInitHooks.call(this);
            this._initHooksCalled = true;
            for(var i = 0, len = proto._initHooks.length; i < len; i++)proto._initHooks[i].call(this);
        };
        return NewClass;
    };
    // @function include(properties: Object): this
    // [Includes a mixin](#class-includes) into the current class.
    Class.include = function(props) {
        var parentOptions = this.prototype.options;
        extend(this.prototype, props);
        if (props.options) {
            this.prototype.options = parentOptions;
            this.mergeOptions(props.options);
        }
        return this;
    };
    // @function mergeOptions(options: Object): this
    // [Merges `options`](#class-options) into the defaults of the class.
    Class.mergeOptions = function(options) {
        extend(this.prototype.options, options);
        return this;
    };
    // @function addInitHook(fn: Function): this
    // Adds a [constructor hook](#class-constructor-hooks) to the class.
    Class.addInitHook = function(fn) {
        var args = Array.prototype.slice.call(arguments, 1);
        var init = typeof fn === 'function' ? fn : function() {
            this[fn].apply(this, args);
        };
        this.prototype._initHooks = this.prototype._initHooks || [];
        this.prototype._initHooks.push(init);
        return this;
    };
    function checkDeprecatedMixinEvents(includes) {
        /* global L: true */ if (typeof L === 'undefined' || !L || !L.Mixin) return;
        includes = isArray(includes) ? includes : [
            includes
        ];
        for(var i = 0; i < includes.length; i++)if (includes[i] === L.Mixin.Events) console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.", new Error().stack);
    }
    /*
   * @class Evented
   * @aka L.Evented
   * @inherits Class
   *
   * A set of methods shared between event-powered classes (like `Map` and `Marker`). Generally, events allow you to execute some function when something happens with an object (e.g. the user clicks on the map, causing the map to fire `'click'` event).
   *
   * @example
   *
   * ```js
   * map.on('click', function(e) {
   * 	alert(e.latlng);
   * } );
   * ```
   *
   * Leaflet deals with event listeners by reference, so if you want to add a listener and then remove it, define it as a function:
   *
   * ```js
   * function onClick(e) { ... }
   *
   * map.on('click', onClick);
   * map.off('click', onClick);
   * ```
   */ var Events = {
        /* @method on(type: String, fn: Function, context?: Object): this
  	 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
  	 *
  	 * @alternative
  	 * @method on(eventMap: Object): this
  	 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
  	 */ on: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === 'object') for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context);
            }
            return this;
        },
        /* @method off(type: String, fn?: Function, context?: Object): this
  	 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
  	 *
  	 * @alternative
  	 * @method off(eventMap: Object): this
  	 * Removes a set of type/listener pairs.
  	 *
  	 * @alternative
  	 * @method off: this
  	 * Removes all listeners to all events on the object. This includes implicitly attached events.
  	 */ off: function(types, fn, context) {
            if (!arguments.length) // clear all listeners if called without arguments
            delete this._events;
            else if (typeof types === 'object') for(var type in types)this._off(type, types[type], fn);
            else {
                types = splitWords(types);
                var removeAll = arguments.length === 1;
                for(var i = 0, len = types.length; i < len; i++)if (removeAll) this._off(types[i]);
                else this._off(types[i], fn, context);
            }
            return this;
        },
        // attach listener (without syntactic sugar now)
        _on: function(type, fn, context, _once) {
            if (typeof fn !== 'function') {
                console.warn('wrong listener type: ' + typeof fn);
                return;
            }
            // check if fn already there
            if (this._listens(type, fn, context) !== false) return;
            if (context === this) // Less memory footprint.
            context = undefined;
            var newListener = {
                fn: fn,
                ctx: context
            };
            if (_once) newListener.once = true;
            this._events = this._events || {};
            this._events[type] = this._events[type] || [];
            this._events[type].push(newListener);
        },
        _off: function(type, fn, context) {
            var listeners, i, len;
            if (!this._events) return;
            listeners = this._events[type];
            if (!listeners) return;
            if (arguments.length === 1) {
                if (this._firingCount) // Set all removed listeners to noop
                // so they are not called if remove happens in fire
                for(i = 0, len = listeners.length; i < len; i++)listeners[i].fn = falseFn;
                // clear all listeners for a type if function isn't specified
                delete this._events[type];
                return;
            }
            if (typeof fn !== 'function') {
                console.warn('wrong listener type: ' + typeof fn);
                return;
            }
            // find fn and remove it
            var index = this._listens(type, fn, context);
            if (index !== false) {
                var listener = listeners[index];
                if (this._firingCount) {
                    // set the removed listener to noop so that's not called if remove happens in fire
                    listener.fn = falseFn;
                    /* copy array in case events are being fired */ this._events[type] = listeners = listeners.slice();
                }
                listeners.splice(index, 1);
            }
        },
        // @method fire(type: String, data?: Object, propagate?: Boolean): this
        // Fires an event of the specified type. You can optionally provide a data
        // object — the first argument of the listener function will contain its
        // properties. The event can optionally be propagated to event parents.
        fire: function(type, data, propagate) {
            if (!this.listens(type, propagate)) return this;
            var event = extend({}, data, {
                type: type,
                target: this,
                sourceTarget: data && data.sourceTarget || this
            });
            if (this._events) {
                var listeners = this._events[type];
                if (listeners) {
                    this._firingCount = this._firingCount + 1 || 1;
                    for(var i = 0, len = listeners.length; i < len; i++){
                        var l = listeners[i];
                        // off overwrites l.fn, so we need to copy fn to a var
                        var fn = l.fn;
                        if (l.once) this.off(type, fn, l.ctx);
                        fn.call(l.ctx || this, event);
                    }
                    this._firingCount--;
                }
            }
            if (propagate) // propagate the event to parents (set with addEventParent)
            this._propagateEvent(event);
            return this;
        },
        // @method listens(type: String, propagate?: Boolean): Boolean
        // @method listens(type: String, fn: Function, context?: Object, propagate?: Boolean): Boolean
        // Returns `true` if a particular event type has any listeners attached to it.
        // The verification can optionally be propagated, it will return `true` if parents have the listener attached to it.
        listens: function(type, fn, context, propagate) {
            if (typeof type !== 'string') console.warn('"string" type argument expected');
            // we don't overwrite the input `fn` value, because we need to use it for propagation
            var _fn = fn;
            if (typeof fn !== 'function') {
                propagate = !!fn;
                _fn = undefined;
                context = undefined;
            }
            var listeners = this._events && this._events[type];
            if (listeners && listeners.length) {
                if (this._listens(type, _fn, context) !== false) return true;
            }
            if (propagate) // also check parents for listeners if event propagates
            for(var id in this._eventParents){
                if (this._eventParents[id].listens(type, fn, context, propagate)) return true;
            }
            return false;
        },
        // returns the index (number) or false
        _listens: function(type, fn, context) {
            if (!this._events) return false;
            var listeners = this._events[type] || [];
            if (!fn) return !!listeners.length;
            if (context === this) // Less memory footprint.
            context = undefined;
            for(var i = 0, len = listeners.length; i < len; i++){
                if (listeners[i].fn === fn && listeners[i].ctx === context) return i;
            }
            return false;
        },
        // @method once(…): this
        // Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
        once: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === 'object') for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn, true);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context, true);
            }
            return this;
        },
        // @method addEventParent(obj: Evented): this
        // Adds an event parent - an `Evented` that will receive propagated events
        addEventParent: function(obj) {
            this._eventParents = this._eventParents || {};
            this._eventParents[stamp(obj)] = obj;
            return this;
        },
        // @method removeEventParent(obj: Evented): this
        // Removes an event parent, so it will stop receiving propagated events
        removeEventParent: function(obj) {
            if (this._eventParents) delete this._eventParents[stamp(obj)];
            return this;
        },
        _propagateEvent: function(e) {
            for(var id in this._eventParents)this._eventParents[id].fire(e.type, extend({
                layer: e.target,
                propagatedFrom: e.target
            }, e), true);
        }
    };
    // aliases; we should ditch those eventually
    // @method addEventListener(…): this
    // Alias to [`on(…)`](#evented-on)
    Events.addEventListener = Events.on;
    // @method removeEventListener(…): this
    // Alias to [`off(…)`](#evented-off)
    // @method clearAllEventListeners(…): this
    // Alias to [`off()`](#evented-off)
    Events.removeEventListener = Events.clearAllEventListeners = Events.off;
    // @method addOneTimeEventListener(…): this
    // Alias to [`once(…)`](#evented-once)
    Events.addOneTimeEventListener = Events.once;
    // @method fireEvent(…): this
    // Alias to [`fire(…)`](#evented-fire)
    Events.fireEvent = Events.fire;
    // @method hasEventListeners(…): Boolean
    // Alias to [`listens(…)`](#evented-listens)
    Events.hasEventListeners = Events.listens;
    var Evented = Class.extend(Events);
    /*
   * @class Point
   * @aka L.Point
   *
   * Represents a point with `x` and `y` coordinates in pixels.
   *
   * @example
   *
   * ```js
   * var point = L.point(200, 300);
   * ```
   *
   * All Leaflet methods and options that accept `Point` objects also accept them in a simple Array form (unless noted otherwise), so these lines are equivalent:
   *
   * ```js
   * map.panBy([200, 300]);
   * map.panBy(L.point(200, 300));
   * ```
   *
   * Note that `Point` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Point(x, y, round) {
        // @property x: Number; The `x` coordinate of the point
        this.x = round ? Math.round(x) : x;
        // @property y: Number; The `y` coordinate of the point
        this.y = round ? Math.round(y) : y;
    }
    var trunc = Math.trunc || function(v) {
        return v > 0 ? Math.floor(v) : Math.ceil(v);
    };
    Point.prototype = {
        // @method clone(): Point
        // Returns a copy of the current point.
        clone: function() {
            return new Point(this.x, this.y);
        },
        // @method add(otherPoint: Point): Point
        // Returns the result of addition of the current and the given points.
        add: function(point) {
            // non-destructive, returns a new point
            return this.clone()._add(toPoint(point));
        },
        _add: function(point) {
            // destructive, used directly for performance in situations where it's safe to modify existing point
            this.x += point.x;
            this.y += point.y;
            return this;
        },
        // @method subtract(otherPoint: Point): Point
        // Returns the result of subtraction of the given point from the current.
        subtract: function(point) {
            return this.clone()._subtract(toPoint(point));
        },
        _subtract: function(point) {
            this.x -= point.x;
            this.y -= point.y;
            return this;
        },
        // @method divideBy(num: Number): Point
        // Returns the result of division of the current point by the given number.
        divideBy: function(num) {
            return this.clone()._divideBy(num);
        },
        _divideBy: function(num) {
            this.x /= num;
            this.y /= num;
            return this;
        },
        // @method multiplyBy(num: Number): Point
        // Returns the result of multiplication of the current point by the given number.
        multiplyBy: function(num) {
            return this.clone()._multiplyBy(num);
        },
        _multiplyBy: function(num) {
            this.x *= num;
            this.y *= num;
            return this;
        },
        // @method scaleBy(scale: Point): Point
        // Multiply each coordinate of the current point by each coordinate of
        // `scale`. In linear algebra terms, multiply the point by the
        // [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
        // defined by `scale`.
        scaleBy: function(point) {
            return new Point(this.x * point.x, this.y * point.y);
        },
        // @method unscaleBy(scale: Point): Point
        // Inverse of `scaleBy`. Divide each coordinate of the current point by
        // each coordinate of `scale`.
        unscaleBy: function(point) {
            return new Point(this.x / point.x, this.y / point.y);
        },
        // @method round(): Point
        // Returns a copy of the current point with rounded coordinates.
        round: function() {
            return this.clone()._round();
        },
        _round: function() {
            this.x = Math.round(this.x);
            this.y = Math.round(this.y);
            return this;
        },
        // @method floor(): Point
        // Returns a copy of the current point with floored coordinates (rounded down).
        floor: function() {
            return this.clone()._floor();
        },
        _floor: function() {
            this.x = Math.floor(this.x);
            this.y = Math.floor(this.y);
            return this;
        },
        // @method ceil(): Point
        // Returns a copy of the current point with ceiled coordinates (rounded up).
        ceil: function() {
            return this.clone()._ceil();
        },
        _ceil: function() {
            this.x = Math.ceil(this.x);
            this.y = Math.ceil(this.y);
            return this;
        },
        // @method trunc(): Point
        // Returns a copy of the current point with truncated coordinates (rounded towards zero).
        trunc: function() {
            return this.clone()._trunc();
        },
        _trunc: function() {
            this.x = trunc(this.x);
            this.y = trunc(this.y);
            return this;
        },
        // @method distanceTo(otherPoint: Point): Number
        // Returns the cartesian distance between the current and the given points.
        distanceTo: function(point) {
            point = toPoint(point);
            var x = point.x - this.x, y = point.y - this.y;
            return Math.sqrt(x * x + y * y);
        },
        // @method equals(otherPoint: Point): Boolean
        // Returns `true` if the given point has the same coordinates.
        equals: function(point) {
            point = toPoint(point);
            return point.x === this.x && point.y === this.y;
        },
        // @method contains(otherPoint: Point): Boolean
        // Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
        contains: function(point) {
            point = toPoint(point);
            return Math.abs(point.x) <= Math.abs(this.x) && Math.abs(point.y) <= Math.abs(this.y);
        },
        // @method toString(): String
        // Returns a string representation of the point for debugging purposes.
        toString: function() {
            return 'Point(' + formatNum(this.x) + ', ' + formatNum(this.y) + ')';
        }
    };
    // @factory L.point(x: Number, y: Number, round?: Boolean)
    // Creates a Point object with the given `x` and `y` coordinates. If optional `round` is set to true, rounds the `x` and `y` values.
    // @alternative
    // @factory L.point(coords: Number[])
    // Expects an array of the form `[x, y]` instead.
    // @alternative
    // @factory L.point(coords: Object)
    // Expects a plain object of the form `{x: Number, y: Number}` instead.
    function toPoint(x, y, round) {
        if (x instanceof Point) return x;
        if (isArray(x)) return new Point(x[0], x[1]);
        if (x === undefined || x === null) return x;
        if (typeof x === 'object' && 'x' in x && 'y' in x) return new Point(x.x, x.y);
        return new Point(x, y, round);
    }
    /*
   * @class Bounds
   * @aka L.Bounds
   *
   * Represents a rectangular area in pixel coordinates.
   *
   * @example
   *
   * ```js
   * var p1 = L.point(10, 10),
   * p2 = L.point(40, 60),
   * bounds = L.bounds(p1, p2);
   * ```
   *
   * All Leaflet methods that accept `Bounds` objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * otherBounds.intersects([[10, 10], [40, 60]]);
   * ```
   *
   * Note that `Bounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Bounds(a, b) {
        if (!a) return;
        var points = b ? [
            a,
            b
        ] : a;
        for(var i = 0, len = points.length; i < len; i++)this.extend(points[i]);
    }
    Bounds.prototype = {
        // @method extend(point: Point): this
        // Extends the bounds to contain the given point.
        // @alternative
        // @method extend(otherBounds: Bounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var min2, max2;
            if (!obj) return this;
            if (obj instanceof Point || typeof obj[0] === 'number' || 'x' in obj) min2 = max2 = toPoint(obj);
            else {
                obj = toBounds(obj);
                min2 = obj.min;
                max2 = obj.max;
                if (!min2 || !max2) return this;
            }
            // @property min: Point
            // The top left corner of the rectangle.
            // @property max: Point
            // The bottom right corner of the rectangle.
            if (!this.min && !this.max) {
                this.min = min2.clone();
                this.max = max2.clone();
            } else {
                this.min.x = Math.min(min2.x, this.min.x);
                this.max.x = Math.max(max2.x, this.max.x);
                this.min.y = Math.min(min2.y, this.min.y);
                this.max.y = Math.max(max2.y, this.max.y);
            }
            return this;
        },
        // @method getCenter(round?: Boolean): Point
        // Returns the center point of the bounds.
        getCenter: function(round) {
            return toPoint((this.min.x + this.max.x) / 2, (this.min.y + this.max.y) / 2, round);
        },
        // @method getBottomLeft(): Point
        // Returns the bottom-left point of the bounds.
        getBottomLeft: function() {
            return toPoint(this.min.x, this.max.y);
        },
        // @method getTopRight(): Point
        // Returns the top-right point of the bounds.
        getTopRight: function() {
            return toPoint(this.max.x, this.min.y);
        },
        // @method getTopLeft(): Point
        // Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
        getTopLeft: function() {
            return this.min; // left, top
        },
        // @method getBottomRight(): Point
        // Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
        getBottomRight: function() {
            return this.max; // right, bottom
        },
        // @method getSize(): Point
        // Returns the size of the given bounds
        getSize: function() {
            return this.max.subtract(this.min);
        },
        // @method contains(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains(point: Point): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            var min, max;
            if (typeof obj[0] === 'number' || obj instanceof Point) obj = toPoint(obj);
            else obj = toBounds(obj);
            if (obj instanceof Bounds) {
                min = obj.min;
                max = obj.max;
            } else min = max = obj;
            return min.x >= this.min.x && max.x <= this.max.x && min.y >= this.min.y && max.y <= this.max.y;
        },
        // @method intersects(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds
        // intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xIntersects = max2.x >= min.x && min2.x <= max.x, yIntersects = max2.y >= min.y && min2.y <= max.y;
            return xIntersects && yIntersects;
        },
        // @method overlaps(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds
        // overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xOverlaps = max2.x > min.x && min2.x < max.x, yOverlaps = max2.y > min.y && min2.y < max.y;
            return xOverlaps && yOverlaps;
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this.min && this.max);
        },
        // @method pad(bufferRatio: Number): Bounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var min = this.min, max = this.max, heightBuffer = Math.abs(min.x - max.x) * bufferRatio, widthBuffer = Math.abs(min.y - max.y) * bufferRatio;
            return toBounds(toPoint(min.x - heightBuffer, min.y - widthBuffer), toPoint(max.x + heightBuffer, max.y + widthBuffer));
        },
        // @method equals(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle is equivalent to the given bounds.
        equals: function(bounds) {
            if (!bounds) return false;
            bounds = toBounds(bounds);
            return this.min.equals(bounds.getTopLeft()) && this.max.equals(bounds.getBottomRight());
        }
    };
    // @factory L.bounds(corner1: Point, corner2: Point)
    // Creates a Bounds object from two corners coordinate pairs.
    // @alternative
    // @factory L.bounds(points: Point[])
    // Creates a Bounds object from the given array of points.
    function toBounds(a, b) {
        if (!a || a instanceof Bounds) return a;
        return new Bounds(a, b);
    }
    /*
   * @class LatLngBounds
   * @aka L.LatLngBounds
   *
   * Represents a rectangular geographical area on a map.
   *
   * @example
   *
   * ```js
   * var corner1 = L.latLng(40.712, -74.227),
   * corner2 = L.latLng(40.774, -74.125),
   * bounds = L.latLngBounds(corner1, corner2);
   * ```
   *
   * All Leaflet methods that accept LatLngBounds objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * map.fitBounds([
   * 	[40.712, -74.227],
   * 	[40.774, -74.125]
   * ]);
   * ```
   *
   * Caution: if the area crosses the antimeridian (often confused with the International Date Line), you must specify corners _outside_ the [-180, 180] degrees longitude range.
   *
   * Note that `LatLngBounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLngBounds(corner1, corner2) {
        if (!corner1) return;
        var latlngs = corner2 ? [
            corner1,
            corner2
        ] : corner1;
        for(var i = 0, len = latlngs.length; i < len; i++)this.extend(latlngs[i]);
    }
    LatLngBounds.prototype = {
        // @method extend(latlng: LatLng): this
        // Extend the bounds to contain the given point
        // @alternative
        // @method extend(otherBounds: LatLngBounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLng) {
                sw2 = obj;
                ne2 = obj;
            } else if (obj instanceof LatLngBounds) {
                sw2 = obj._southWest;
                ne2 = obj._northEast;
                if (!sw2 || !ne2) return this;
            } else return obj ? this.extend(toLatLng(obj) || toLatLngBounds(obj)) : this;
            if (!sw && !ne) {
                this._southWest = new LatLng(sw2.lat, sw2.lng);
                this._northEast = new LatLng(ne2.lat, ne2.lng);
            } else {
                sw.lat = Math.min(sw2.lat, sw.lat);
                sw.lng = Math.min(sw2.lng, sw.lng);
                ne.lat = Math.max(ne2.lat, ne.lat);
                ne.lng = Math.max(ne2.lng, ne.lng);
            }
            return this;
        },
        // @method pad(bufferRatio: Number): LatLngBounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var sw = this._southWest, ne = this._northEast, heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio, widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
            return new LatLngBounds(new LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer), new LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
        },
        // @method getCenter(): LatLng
        // Returns the center point of the bounds.
        getCenter: function() {
            return new LatLng((this._southWest.lat + this._northEast.lat) / 2, (this._southWest.lng + this._northEast.lng) / 2);
        },
        // @method getSouthWest(): LatLng
        // Returns the south-west point of the bounds.
        getSouthWest: function() {
            return this._southWest;
        },
        // @method getNorthEast(): LatLng
        // Returns the north-east point of the bounds.
        getNorthEast: function() {
            return this._northEast;
        },
        // @method getNorthWest(): LatLng
        // Returns the north-west point of the bounds.
        getNorthWest: function() {
            return new LatLng(this.getNorth(), this.getWest());
        },
        // @method getSouthEast(): LatLng
        // Returns the south-east point of the bounds.
        getSouthEast: function() {
            return new LatLng(this.getSouth(), this.getEast());
        },
        // @method getWest(): Number
        // Returns the west longitude of the bounds
        getWest: function() {
            return this._southWest.lng;
        },
        // @method getSouth(): Number
        // Returns the south latitude of the bounds
        getSouth: function() {
            return this._southWest.lat;
        },
        // @method getEast(): Number
        // Returns the east longitude of the bounds
        getEast: function() {
            return this._northEast.lng;
        },
        // @method getNorth(): Number
        // Returns the north latitude of the bounds
        getNorth: function() {
            return this._northEast.lat;
        },
        // @method contains(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains (latlng: LatLng): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            if (typeof obj[0] === 'number' || obj instanceof LatLng || 'lat' in obj) obj = toLatLng(obj);
            else obj = toLatLngBounds(obj);
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLngBounds) {
                sw2 = obj.getSouthWest();
                ne2 = obj.getNorthEast();
            } else sw2 = ne2 = obj;
            return sw2.lat >= sw.lat && ne2.lat <= ne.lat && sw2.lng >= sw.lng && ne2.lng <= ne.lng;
        },
        // @method intersects(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latIntersects = ne2.lat >= sw.lat && sw2.lat <= ne.lat, lngIntersects = ne2.lng >= sw.lng && sw2.lng <= ne.lng;
            return latIntersects && lngIntersects;
        },
        // @method overlaps(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latOverlaps = ne2.lat > sw.lat && sw2.lat < ne.lat, lngOverlaps = ne2.lng > sw.lng && sw2.lng < ne.lng;
            return latOverlaps && lngOverlaps;
        },
        // @method toBBoxString(): String
        // Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
        toBBoxString: function() {
            return [
                this.getWest(),
                this.getSouth(),
                this.getEast(),
                this.getNorth()
            ].join(',');
        },
        // @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
        // Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(bounds, maxMargin) {
            if (!bounds) return false;
            bounds = toLatLngBounds(bounds);
            return this._southWest.equals(bounds.getSouthWest(), maxMargin) && this._northEast.equals(bounds.getNorthEast(), maxMargin);
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this._southWest && this._northEast);
        }
    };
    // TODO International date line?
    // @factory L.latLngBounds(corner1: LatLng, corner2: LatLng)
    // Creates a `LatLngBounds` object by defining two diagonally opposite corners of the rectangle.
    // @alternative
    // @factory L.latLngBounds(latlngs: LatLng[])
    // Creates a `LatLngBounds` object defined by the geographical points it contains. Very useful for zooming the map to fit a particular set of locations with [`fitBounds`](#map-fitbounds).
    function toLatLngBounds(a, b) {
        if (a instanceof LatLngBounds) return a;
        return new LatLngBounds(a, b);
    }
    /* @class LatLng
   * @aka L.LatLng
   *
   * Represents a geographical point with a certain latitude and longitude.
   *
   * @example
   *
   * ```
   * var latlng = L.latLng(50.5, 30.5);
   * ```
   *
   * All Leaflet methods that accept LatLng objects also accept them in a simple Array form and simple object form (unless noted otherwise), so these lines are equivalent:
   *
   * ```
   * map.panTo([50, 30]);
   * map.panTo({lon: 30, lat: 50});
   * map.panTo({lat: 50, lng: 30});
   * map.panTo(L.latLng(50, 30));
   * ```
   *
   * Note that `LatLng` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLng(lat, lng, alt) {
        if (isNaN(lat) || isNaN(lng)) throw new Error('Invalid LatLng object: (' + lat + ', ' + lng + ')');
        // @property lat: Number
        // Latitude in degrees
        this.lat = +lat;
        // @property lng: Number
        // Longitude in degrees
        this.lng = +lng;
        // @property alt: Number
        // Altitude in meters (optional)
        if (alt !== undefined) this.alt = +alt;
    }
    LatLng.prototype = {
        // @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
        // Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(obj, maxMargin) {
            if (!obj) return false;
            obj = toLatLng(obj);
            var margin = Math.max(Math.abs(this.lat - obj.lat), Math.abs(this.lng - obj.lng));
            return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
        },
        // @method toString(): String
        // Returns a string representation of the point (for debugging purposes).
        toString: function(precision) {
            return 'LatLng(' + formatNum(this.lat, precision) + ', ' + formatNum(this.lng, precision) + ')';
        },
        // @method distanceTo(otherLatLng: LatLng): Number
        // Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
        distanceTo: function(other) {
            return Earth.distance(this, toLatLng(other));
        },
        // @method wrap(): LatLng
        // Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
        wrap: function() {
            return Earth.wrapLatLng(this);
        },
        // @method toBounds(sizeInMeters: Number): LatLngBounds
        // Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
        toBounds: function(sizeInMeters) {
            var latAccuracy = 180 * sizeInMeters / 40075017, lngAccuracy = latAccuracy / Math.cos(Math.PI / 180 * this.lat);
            return toLatLngBounds([
                this.lat - latAccuracy,
                this.lng - lngAccuracy
            ], [
                this.lat + latAccuracy,
                this.lng + lngAccuracy
            ]);
        },
        clone: function() {
            return new LatLng(this.lat, this.lng, this.alt);
        }
    };
    // @factory L.latLng(latitude: Number, longitude: Number, altitude?: Number): LatLng
    // Creates an object representing a geographical point with the given latitude and longitude (and optionally altitude).
    // @alternative
    // @factory L.latLng(coords: Array): LatLng
    // Expects an array of the form `[Number, Number]` or `[Number, Number, Number]` instead.
    // @alternative
    // @factory L.latLng(coords: Object): LatLng
    // Expects an plain object of the form `{lat: Number, lng: Number}` or `{lat: Number, lng: Number, alt: Number}` instead.
    function toLatLng(a, b, c) {
        if (a instanceof LatLng) return a;
        if (isArray(a) && typeof a[0] !== 'object') {
            if (a.length === 3) return new LatLng(a[0], a[1], a[2]);
            if (a.length === 2) return new LatLng(a[0], a[1]);
            return null;
        }
        if (a === undefined || a === null) return a;
        if (typeof a === 'object' && 'lat' in a) return new LatLng(a.lat, 'lng' in a ? a.lng : a.lon, a.alt);
        if (b === undefined) return null;
        return new LatLng(a, b, c);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.Base
   * Object that defines coordinate reference systems for projecting
   * geographical points into pixel (screen) coordinates and back (and to
   * coordinates in other units for [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services). See
   * [spatial reference system](https://en.wikipedia.org/wiki/Spatial_reference_system).
   *
   * Leaflet defines the most usual CRSs by default. If you want to use a
   * CRS not defined by default, take a look at the
   * [Proj4Leaflet](https://github.com/kartena/Proj4Leaflet) plugin.
   *
   * Note that the CRS instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.
   */ var CRS = {
        // @method latLngToPoint(latlng: LatLng, zoom: Number): Point
        // Projects geographical coordinates into pixel coordinates for a given zoom.
        latLngToPoint: function(latlng, zoom) {
            var projectedPoint = this.projection.project(latlng), scale = this.scale(zoom);
            return this.transformation._transform(projectedPoint, scale);
        },
        // @method pointToLatLng(point: Point, zoom: Number): LatLng
        // The inverse of `latLngToPoint`. Projects pixel coordinates on a given
        // zoom into geographical coordinates.
        pointToLatLng: function(point, zoom) {
            var scale = this.scale(zoom), untransformedPoint = this.transformation.untransform(point, scale);
            return this.projection.unproject(untransformedPoint);
        },
        // @method project(latlng: LatLng): Point
        // Projects geographical coordinates into coordinates in units accepted for
        // this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
        project: function(latlng) {
            return this.projection.project(latlng);
        },
        // @method unproject(point: Point): LatLng
        // Given a projected coordinate returns the corresponding LatLng.
        // The inverse of `project`.
        unproject: function(point) {
            return this.projection.unproject(point);
        },
        // @method scale(zoom: Number): Number
        // Returns the scale used when transforming projected coordinates into
        // pixel coordinates for a particular zoom. For example, it returns
        // `256 * 2^zoom` for Mercator-based CRS.
        scale: function(zoom) {
            return 256 * Math.pow(2, zoom);
        },
        // @method zoom(scale: Number): Number
        // Inverse of `scale()`, returns the zoom level corresponding to a scale
        // factor of `scale`.
        zoom: function(scale) {
            return Math.log(scale / 256) / Math.LN2;
        },
        // @method getProjectedBounds(zoom: Number): Bounds
        // Returns the projection's bounds scaled and transformed for the provided `zoom`.
        getProjectedBounds: function(zoom) {
            if (this.infinite) return null;
            var b = this.projection.bounds, s = this.scale(zoom), min = this.transformation.transform(b.min, s), max = this.transformation.transform(b.max, s);
            return new Bounds(min, max);
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates.
        // @property code: String
        // Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
        //
        // @property wrapLng: Number[]
        // An array of two numbers defining whether the longitude (horizontal) coordinate
        // axis wraps around a given range and how. Defaults to `[-180, 180]` in most
        // geographical CRSs. If `undefined`, the longitude axis does not wrap around.
        //
        // @property wrapLat: Number[]
        // Like `wrapLng`, but for the latitude (vertical) axis.
        // wrapLng: [min, max],
        // wrapLat: [min, max],
        // @property infinite: Boolean
        // If true, the coordinate space will be unbounded (infinite in both axes)
        infinite: false,
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where lat and lng has been wrapped according to the
        // CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
        wrapLatLng: function(latlng) {
            var lng = this.wrapLng ? wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng, lat = this.wrapLat ? wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat, alt = latlng.alt;
            return new LatLng(lat, lng, alt);
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring
        // that its center is within the CRS's bounds.
        // Only accepts actual `L.LatLngBounds` instances, not arrays.
        wrapLatLngBounds: function(bounds) {
            var center = bounds.getCenter(), newCenter = this.wrapLatLng(center), latShift = center.lat - newCenter.lat, lngShift = center.lng - newCenter.lng;
            if (latShift === 0 && lngShift === 0) return bounds;
            var sw = bounds.getSouthWest(), ne = bounds.getNorthEast(), newSw = new LatLng(sw.lat - latShift, sw.lng - lngShift), newNe = new LatLng(ne.lat - latShift, ne.lng - lngShift);
            return new LatLngBounds(newSw, newNe);
        }
    };
    /*
   * @namespace CRS
   * @crs L.CRS.Earth
   *
   * Serves as the base for CRS that are global such that they cover the earth.
   * Can only be used as the base for other CRS and cannot be used directly,
   * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
   * meters.
   */ var Earth = extend({}, CRS, {
        wrapLng: [
            -180,
            180
        ],
        // Mean Earth Radius, as recommended for use by
        // the International Union of Geodesy and Geophysics,
        // see https://rosettacode.org/wiki/Haversine_formula
        R: 6371000,
        // distance between two geographical points using spherical law of cosines approximation
        distance: function(latlng1, latlng2) {
            var rad = Math.PI / 180, lat1 = latlng1.lat * rad, lat2 = latlng2.lat * rad, sinDLat = Math.sin((latlng2.lat - latlng1.lat) * rad / 2), sinDLon = Math.sin((latlng2.lng - latlng1.lng) * rad / 2), a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon, c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return this.R * c;
        }
    });
    /*
   * @namespace Projection
   * @projection L.Projection.SphericalMercator
   *
   * Spherical Mercator projection — the most common projection for online maps,
   * used by almost all free and commercial tile providers. Assumes that Earth is
   * a sphere. Used by the `EPSG:3857` CRS.
   */ var earthRadius = 6378137;
    var SphericalMercator = {
        R: earthRadius,
        MAX_LATITUDE: 85.0511287798,
        project: function(latlng) {
            var d = Math.PI / 180, max = this.MAX_LATITUDE, lat = Math.max(Math.min(max, latlng.lat), -max), sin = Math.sin(lat * d);
            return new Point(this.R * latlng.lng * d, this.R * Math.log((1 + sin) / (1 - sin)) / 2);
        },
        unproject: function(point) {
            var d = 180 / Math.PI;
            return new LatLng((2 * Math.atan(Math.exp(point.y / this.R)) - Math.PI / 2) * d, point.x * d / this.R);
        },
        bounds: function() {
            var d = earthRadius * Math.PI;
            return new Bounds([
                -d,
                -d
            ], [
                d,
                d
            ]);
        }()
    };
    /*
   * @class Transformation
   * @aka L.Transformation
   *
   * Represents an affine transformation: a set of coefficients `a`, `b`, `c`, `d`
   * for transforming a point of a form `(x, y)` into `(a*x + b, c*y + d)` and doing
   * the reverse. Used by Leaflet in its projections code.
   *
   * @example
   *
   * ```js
   * var transformation = L.transformation(2, 5, -1, 10),
   * 	p = L.point(1, 2),
   * 	p2 = transformation.transform(p), //  L.point(7, 8)
   * 	p3 = transformation.untransform(p2); //  L.point(1, 2)
   * ```
   */ // factory new L.Transformation(a: Number, b: Number, c: Number, d: Number)
    // Creates a `Transformation` object with the given coefficients.
    function Transformation(a, b, c, d) {
        if (isArray(a)) {
            // use array properties
            this._a = a[0];
            this._b = a[1];
            this._c = a[2];
            this._d = a[3];
            return;
        }
        this._a = a;
        this._b = b;
        this._c = c;
        this._d = d;
    }
    Transformation.prototype = {
        // @method transform(point: Point, scale?: Number): Point
        // Returns a transformed point, optionally multiplied by the given scale.
        // Only accepts actual `L.Point` instances, not arrays.
        transform: function(point, scale) {
            return this._transform(point.clone(), scale);
        },
        // destructive transform (faster)
        _transform: function(point, scale) {
            scale = scale || 1;
            point.x = scale * (this._a * point.x + this._b);
            point.y = scale * (this._c * point.y + this._d);
            return point;
        },
        // @method untransform(point: Point, scale?: Number): Point
        // Returns the reverse transformation of the given point, optionally divided
        // by the given scale. Only accepts actual `L.Point` instances, not arrays.
        untransform: function(point, scale) {
            scale = scale || 1;
            return new Point((point.x / scale - this._b) / this._a, (point.y / scale - this._d) / this._c);
        }
    };
    // factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // @factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // Instantiates a Transformation object with the given coefficients.
    // @alternative
    // @factory L.transformation(coefficients: Array): Transformation
    // Expects an coefficients array of the form
    // `[a: Number, b: Number, c: Number, d: Number]`.
    function toTransformation(a, b, c, d) {
        return new Transformation(a, b, c, d);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3857
   *
   * The most common CRS for online maps, used by almost all free and commercial
   * tile providers. Uses Spherical Mercator projection. Set in by default in
   * Map's `crs` option.
   */ var EPSG3857 = extend({}, Earth, {
        code: 'EPSG:3857',
        projection: SphericalMercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * SphericalMercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    var EPSG900913 = extend({}, EPSG3857, {
        code: 'EPSG:900913'
    });
    // @namespace SVG; @section
    // There are several static functions which can be called without instantiating L.SVG:
    // @function create(name: String): SVGElement
    // Returns a instance of [SVGElement](https://developer.mozilla.org/docs/Web/API/SVGElement),
    // corresponding to the class name passed. For example, using 'line' will return
    // an instance of [SVGLineElement](https://developer.mozilla.org/docs/Web/API/SVGLineElement).
    function svgCreate(name) {
        return document.createElementNS('http://www.w3.org/2000/svg', name);
    }
    // @function pointsToPath(rings: Point[], closed: Boolean): String
    // Generates a SVG path string for multiple rings, with each ring turning
    // into "M..L..L.." instructions
    function pointsToPath(rings, closed) {
        var str = '', i, j, len, len2, points, p;
        for(i = 0, len = rings.length; i < len; i++){
            points = rings[i];
            for(j = 0, len2 = points.length; j < len2; j++){
                p = points[j];
                str += (j ? 'L' : 'M') + p.x + ' ' + p.y;
            }
            // closes the ring for polygons; "x" is VML syntax
            str += closed ? Browser.svg ? 'z' : 'x' : '';
        }
        // SVG complains about empty path strings
        return str || 'M0 0';
    }
    /*
   * @namespace Browser
   * @aka L.Browser
   *
   * A namespace with static properties for browser/feature detection used by Leaflet internally.
   *
   * @example
   *
   * ```js
   * if (L.Browser.ielt9) {
   *   alert('Upgrade your browser, dude!');
   * }
   * ```
   */ var style = document.documentElement.style;
    // @property ie: Boolean; `true` for all Internet Explorer versions (not Edge).
    var ie = 'ActiveXObject' in window;
    // @property ielt9: Boolean; `true` for Internet Explorer versions less than 9.
    var ielt9 = ie && !document.addEventListener;
    // @property edge: Boolean; `true` for the Edge web browser.
    var edge = 'msLaunchUri' in navigator && !('documentMode' in document);
    // @property webkit: Boolean;
    // `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
    var webkit = userAgentContains('webkit');
    // @property android: Boolean
    // **Deprecated.** `true` for any browser running on an Android platform.
    var android = userAgentContains('android');
    // @property android23: Boolean; **Deprecated.** `true` for browsers running on Android 2 or Android 3.
    var android23 = userAgentContains('android 2') || userAgentContains('android 3');
    /* See https://stackoverflow.com/a/17961266 for details on detecting stock Android */ var webkitVer = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10); // also matches AppleWebKit
    // @property androidStock: Boolean; **Deprecated.** `true` for the Android stock browser (i.e. not Chrome)
    var androidStock = android && userAgentContains('Google') && webkitVer < 537 && !('AudioNode' in window);
    // @property opera: Boolean; `true` for the Opera browser
    var opera = !!window.opera;
    // @property chrome: Boolean; `true` for the Chrome browser.
    var chrome = !edge && userAgentContains('chrome');
    // @property gecko: Boolean; `true` for gecko-based browsers like Firefox.
    var gecko = userAgentContains('gecko') && !webkit && !opera && !ie;
    // @property safari: Boolean; `true` for the Safari browser.
    var safari = !chrome && userAgentContains('safari');
    var phantom = userAgentContains('phantom');
    // @property opera12: Boolean
    // `true` for the Opera browser supporting CSS transforms (version 12 or later).
    var opera12 = 'OTransition' in style;
    // @property win: Boolean; `true` when the browser is running in a Windows platform
    var win = navigator.platform.indexOf('Win') === 0;
    // @property ie3d: Boolean; `true` for all Internet Explorer versions supporting CSS transforms.
    var ie3d = ie && 'transition' in style;
    // @property webkit3d: Boolean; `true` for webkit-based browsers supporting CSS transforms.
    var webkit3d = 'WebKitCSSMatrix' in window && 'm11' in new window.WebKitCSSMatrix() && !android23;
    // @property gecko3d: Boolean; `true` for gecko-based browsers supporting CSS transforms.
    var gecko3d = 'MozPerspective' in style;
    // @property any3d: Boolean
    // `true` for all browsers supporting CSS transforms.
    var any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantom;
    // @property mobile: Boolean; `true` for all browsers running in a mobile device.
    var mobile = typeof orientation !== 'undefined' || userAgentContains('mobile');
    // @property mobileWebkit: Boolean; `true` for all webkit-based browsers in a mobile device.
    var mobileWebkit = mobile && webkit;
    // @property mobileWebkit3d: Boolean
    // `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
    var mobileWebkit3d = mobile && webkit3d;
    // @property msPointer: Boolean
    // `true` for browsers implementing the Microsoft touch events model (notably IE10).
    var msPointer = !window.PointerEvent && window.MSPointerEvent;
    // @property pointer: Boolean
    // `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
    var pointer = !!(window.PointerEvent || msPointer);
    // @property touchNative: Boolean
    // `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
    // **This does not necessarily mean** that the browser is running in a computer with
    // a touchscreen, it only means that the browser is capable of understanding
    // touch events.
    var touchNative = 'ontouchstart' in window || !!window.TouchEvent;
    // @property touch: Boolean
    // `true` for all browsers supporting either [touch](#browser-touch) or [pointer](#browser-pointer) events.
    // Note: pointer events will be preferred (if available), and processed for all `touch*` listeners.
    var touch = !window.L_NO_TOUCH && (touchNative || pointer);
    // @property mobileOpera: Boolean; `true` for the Opera browser in a mobile device.
    var mobileOpera = mobile && opera;
    // @property mobileGecko: Boolean
    // `true` for gecko-based browsers running in a mobile device.
    var mobileGecko = mobile && gecko;
    // @property retina: Boolean
    // `true` for browsers on a high-resolution "retina" screen or on any screen when browser's display zoom is more than 100%.
    var retina = (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI) > 1;
    // @property passiveEvents: Boolean
    // `true` for browsers that support passive events.
    var passiveEvents = function() {
        var supportsPassiveOption = false;
        try {
            var opts = Object.defineProperty({}, 'passive', {
                get: function() {
                    supportsPassiveOption = true;
                }
            });
            window.addEventListener('testPassiveEventSupport', falseFn, opts);
            window.removeEventListener('testPassiveEventSupport', falseFn, opts);
        } catch (e) {
        // Errors can safely be ignored since this is only a browser support test.
        }
        return supportsPassiveOption;
    }();
    // @property canvas: Boolean
    // `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
    var canvas$1 = function() {
        return !!document.createElement('canvas').getContext;
    }();
    // @property svg: Boolean
    // `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
    var svg$1 = !!(document.createElementNS && svgCreate('svg').createSVGRect);
    var inlineSvg = !!svg$1 && function() {
        var div = document.createElement('div');
        div.innerHTML = '<svg/>';
        return (div.firstChild && div.firstChild.namespaceURI) === 'http://www.w3.org/2000/svg';
    }();
    // @property vml: Boolean
    // `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
    var vml = !svg$1 && function() {
        try {
            var div = document.createElement('div');
            div.innerHTML = '<v:shape adj="1"/>';
            var shape = div.firstChild;
            shape.style.behavior = 'url(#default#VML)';
            return shape && typeof shape.adj === 'object';
        } catch (e) {
            return false;
        }
    }();
    // @property mac: Boolean; `true` when the browser is running in a Mac platform
    var mac = navigator.platform.indexOf('Mac') === 0;
    // @property mac: Boolean; `true` when the browser is running in a Linux platform
    var linux = navigator.platform.indexOf('Linux') === 0;
    function userAgentContains(str) {
        return navigator.userAgent.toLowerCase().indexOf(str) >= 0;
    }
    var Browser = {
        ie: ie,
        ielt9: ielt9,
        edge: edge,
        webkit: webkit,
        android: android,
        android23: android23,
        androidStock: androidStock,
        opera: opera,
        chrome: chrome,
        gecko: gecko,
        safari: safari,
        phantom: phantom,
        opera12: opera12,
        win: win,
        ie3d: ie3d,
        webkit3d: webkit3d,
        gecko3d: gecko3d,
        any3d: any3d,
        mobile: mobile,
        mobileWebkit: mobileWebkit,
        mobileWebkit3d: mobileWebkit3d,
        msPointer: msPointer,
        pointer: pointer,
        touch: touch,
        touchNative: touchNative,
        mobileOpera: mobileOpera,
        mobileGecko: mobileGecko,
        retina: retina,
        passiveEvents: passiveEvents,
        canvas: canvas$1,
        svg: svg$1,
        vml: vml,
        inlineSvg: inlineSvg,
        mac: mac,
        linux: linux
    };
    /*
   * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
   */ var POINTER_DOWN = Browser.msPointer ? 'MSPointerDown' : 'pointerdown';
    var POINTER_MOVE = Browser.msPointer ? 'MSPointerMove' : 'pointermove';
    var POINTER_UP = Browser.msPointer ? 'MSPointerUp' : 'pointerup';
    var POINTER_CANCEL = Browser.msPointer ? 'MSPointerCancel' : 'pointercancel';
    var pEvent = {
        touchstart: POINTER_DOWN,
        touchmove: POINTER_MOVE,
        touchend: POINTER_UP,
        touchcancel: POINTER_CANCEL
    };
    var handle = {
        touchstart: _onPointerStart,
        touchmove: _handlePointer,
        touchend: _handlePointer,
        touchcancel: _handlePointer
    };
    var _pointers = {};
    var _pointerDocListener = false;
    // Provides a touch events wrapper for (ms)pointer events.
    // ref https://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890
    function addPointerListener(obj, type, handler) {
        if (type === 'touchstart') _addPointerDocListener();
        if (!handle[type]) {
            console.warn('wrong event specified:', type);
            return falseFn;
        }
        handler = handle[type].bind(this, handler);
        obj.addEventListener(pEvent[type], handler, false);
        return handler;
    }
    function removePointerListener(obj, type, handler) {
        if (!pEvent[type]) {
            console.warn('wrong event specified:', type);
            return;
        }
        obj.removeEventListener(pEvent[type], handler, false);
    }
    function _globalPointerDown(e) {
        _pointers[e.pointerId] = e;
    }
    function _globalPointerMove(e) {
        if (_pointers[e.pointerId]) _pointers[e.pointerId] = e;
    }
    function _globalPointerUp(e) {
        delete _pointers[e.pointerId];
    }
    function _addPointerDocListener() {
        // need to keep track of what pointers and how many are active to provide e.touches emulation
        if (!_pointerDocListener) {
            // we listen document as any drags that end by moving the touch off the screen get fired there
            document.addEventListener(POINTER_DOWN, _globalPointerDown, true);
            document.addEventListener(POINTER_MOVE, _globalPointerMove, true);
            document.addEventListener(POINTER_UP, _globalPointerUp, true);
            document.addEventListener(POINTER_CANCEL, _globalPointerUp, true);
            _pointerDocListener = true;
        }
    }
    function _handlePointer(handler, e) {
        if (e.pointerType === (e.MSPOINTER_TYPE_MOUSE || 'mouse')) return;
        e.touches = [];
        for(var i in _pointers)e.touches.push(_pointers[i]);
        e.changedTouches = [
            e
        ];
        handler(e);
    }
    function _onPointerStart(handler, e) {
        // IE10 specific: MsTouch needs preventDefault. See #2000
        if (e.MSPOINTER_TYPE_TOUCH && e.pointerType === e.MSPOINTER_TYPE_TOUCH) preventDefault(e);
        _handlePointer(handler, e);
    }
    /*
   * Extends the event handling code with double tap support for mobile browsers.
   *
   * Note: currently most browsers fire native dblclick, with only a few exceptions
   * (see https://github.com/Leaflet/Leaflet/issues/7012#issuecomment-595087386)
   */ function makeDblclick(event) {
        // in modern browsers `type` cannot be just overridden:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only
        var newEvent = {}, prop, i;
        for(i in event){
            prop = event[i];
            newEvent[i] = prop && prop.bind ? prop.bind(event) : prop;
        }
        event = newEvent;
        newEvent.type = 'dblclick';
        newEvent.detail = 2;
        newEvent.isTrusted = false;
        newEvent._simulated = true; // for debug purposes
        return newEvent;
    }
    var delay = 200;
    function addDoubleTapListener(obj, handler) {
        // Most browsers handle double tap natively
        obj.addEventListener('dblclick', handler);
        // On some platforms the browser doesn't fire native dblclicks for touch events.
        // It seems that in all such cases `detail` property of `click` event is always `1`.
        // So here we rely on that fact to avoid excessive 'dblclick' simulation when not needed.
        var last = 0, detail;
        function simDblclick(e) {
            if (e.detail !== 1) {
                detail = e.detail; // keep in sync to avoid false dblclick in some cases
                return;
            }
            if (e.pointerType === 'mouse' || e.sourceCapabilities && !e.sourceCapabilities.firesTouchEvents) return;
            // When clicking on an <input>, the browser generates a click on its
            // <label> (and vice versa) triggering two clicks in quick succession.
            // This ignores clicks on elements which are a label with a 'for'
            // attribute (or children of such a label), but not children of
            // a <input>.
            var path = getPropagationPath(e);
            if (path.some(function(el) {
                return el instanceof HTMLLabelElement && el.attributes.for;
            }) && !path.some(function(el) {
                return el instanceof HTMLInputElement || el instanceof HTMLSelectElement;
            })) return;
            var now = Date.now();
            if (now - last <= delay) {
                detail++;
                if (detail === 2) handler(makeDblclick(e));
            } else detail = 1;
            last = now;
        }
        obj.addEventListener('click', simDblclick);
        return {
            dblclick: handler,
            simDblclick: simDblclick
        };
    }
    function removeDoubleTapListener(obj, handlers) {
        obj.removeEventListener('dblclick', handlers.dblclick);
        obj.removeEventListener('click', handlers.simDblclick);
    }
    /*
   * @namespace DomUtil
   *
   * Utility functions to work with the [DOM](https://developer.mozilla.org/docs/Web/API/Document_Object_Model)
   * tree, used by Leaflet internally.
   *
   * Most functions expecting or returning a `HTMLElement` also work for
   * SVG elements. The only difference is that classes refer to CSS classes
   * in HTML and SVG classes in SVG.
   */ // @property TRANSFORM: String
    // Vendor-prefixed transform style name (e.g. `'webkitTransform'` for WebKit).
    var TRANSFORM = testProp([
        'transform',
        'webkitTransform',
        'OTransform',
        'MozTransform',
        'msTransform'
    ]);
    // webkitTransition comes first because some browser versions that drop vendor prefix don't do
    // the same for the transitionend event, in particular the Android 4.1 stock browser
    // @property TRANSITION: String
    // Vendor-prefixed transition style name.
    var TRANSITION = testProp([
        'webkitTransition',
        'transition',
        'OTransition',
        'MozTransition',
        'msTransition'
    ]);
    // @property TRANSITION_END: String
    // Vendor-prefixed transitionend event name.
    var TRANSITION_END = TRANSITION === 'webkitTransition' || TRANSITION === 'OTransition' ? TRANSITION + 'End' : 'transitionend';
    // @function get(id: String|HTMLElement): HTMLElement
    // Returns an element given its DOM id, or returns the element itself
    // if it was passed directly.
    function get(id) {
        return typeof id === 'string' ? document.getElementById(id) : id;
    }
    // @function getStyle(el: HTMLElement, styleAttrib: String): String
    // Returns the value for a certain style attribute on an element,
    // including computed values or values set through CSS.
    function getStyle(el, style) {
        var value = el.style[style] || el.currentStyle && el.currentStyle[style];
        if ((!value || value === 'auto') && document.defaultView) {
            var css = document.defaultView.getComputedStyle(el, null);
            value = css ? css[style] : null;
        }
        return value === 'auto' ? null : value;
    }
    // @function create(tagName: String, className?: String, container?: HTMLElement): HTMLElement
    // Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
    function create$1(tagName, className, container) {
        var el = document.createElement(tagName);
        el.className = className || '';
        if (container) container.appendChild(el);
        return el;
    }
    // @function remove(el: HTMLElement)
    // Removes `el` from its parent element
    function remove(el) {
        var parent = el.parentNode;
        if (parent) parent.removeChild(el);
    }
    // @function empty(el: HTMLElement)
    // Removes all of `el`'s children elements from `el`
    function empty(el) {
        while(el.firstChild)el.removeChild(el.firstChild);
    }
    // @function toFront(el: HTMLElement)
    // Makes `el` the last child of its parent, so it renders in front of the other children.
    function toFront(el) {
        var parent = el.parentNode;
        if (parent && parent.lastChild !== el) parent.appendChild(el);
    }
    // @function toBack(el: HTMLElement)
    // Makes `el` the first child of its parent, so it renders behind the other children.
    function toBack(el) {
        var parent = el.parentNode;
        if (parent && parent.firstChild !== el) parent.insertBefore(el, parent.firstChild);
    }
    // @function hasClass(el: HTMLElement, name: String): Boolean
    // Returns `true` if the element's class attribute contains `name`.
    function hasClass(el, name) {
        if (el.classList !== undefined) return el.classList.contains(name);
        var className = getClass(el);
        return className.length > 0 && new RegExp('(^|\\s)' + name + '(\\s|$)').test(className);
    }
    // @function addClass(el: HTMLElement, name: String)
    // Adds `name` to the element's class attribute.
    function addClass(el, name) {
        if (el.classList !== undefined) {
            var classes = splitWords(name);
            for(var i = 0, len = classes.length; i < len; i++)el.classList.add(classes[i]);
        } else if (!hasClass(el, name)) {
            var className = getClass(el);
            setClass(el, (className ? className + ' ' : '') + name);
        }
    }
    // @function removeClass(el: HTMLElement, name: String)
    // Removes `name` from the element's class attribute.
    function removeClass(el, name) {
        if (el.classList !== undefined) el.classList.remove(name);
        else setClass(el, trim((' ' + getClass(el) + ' ').replace(' ' + name + ' ', ' ')));
    }
    // @function setClass(el: HTMLElement, name: String)
    // Sets the element's class.
    function setClass(el, name) {
        if (el.className.baseVal === undefined) el.className = name;
        else // in case of SVG element
        el.className.baseVal = name;
    }
    // @function getClass(el: HTMLElement): String
    // Returns the element's class.
    function getClass(el) {
        // Check if the element is an SVGElementInstance and use the correspondingElement instead
        // (Required for linked SVG elements in IE11.)
        if (el.correspondingElement) el = el.correspondingElement;
        return el.className.baseVal === undefined ? el.className : el.className.baseVal;
    }
    // @function setOpacity(el: HTMLElement, opacity: Number)
    // Set the opacity of an element (including old IE support).
    // `opacity` must be a number from `0` to `1`.
    function setOpacity(el, value) {
        if ('opacity' in el.style) el.style.opacity = value;
        else if ('filter' in el.style) _setOpacityIE(el, value);
    }
    function _setOpacityIE(el, value) {
        var filter = false, filterName = 'DXImageTransform.Microsoft.Alpha';
        // filters collection throws an error if we try to retrieve a filter that doesn't exist
        try {
            filter = el.filters.item(filterName);
        } catch (e) {
            // don't set opacity to 1 if we haven't already set an opacity,
            // it isn't needed and breaks transparent pngs.
            if (value === 1) return;
        }
        value = Math.round(value * 100);
        if (filter) {
            filter.Enabled = value !== 100;
            filter.Opacity = value;
        } else el.style.filter += ' progid:' + filterName + '(opacity=' + value + ')';
    }
    // @function testProp(props: String[]): String|false
    // Goes through the array of style names and returns the first name
    // that is a valid style name for an element. If no such name is found,
    // it returns false. Useful for vendor-prefixed styles like `transform`.
    function testProp(props) {
        var style = document.documentElement.style;
        for(var i = 0; i < props.length; i++){
            if (props[i] in style) return props[i];
        }
        return false;
    }
    // @function setTransform(el: HTMLElement, offset: Point, scale?: Number)
    // Resets the 3D CSS transform of `el` so it is translated by `offset` pixels
    // and optionally scaled by `scale`. Does not have an effect if the
    // browser doesn't support 3D CSS transforms.
    function setTransform(el, offset, scale) {
        var pos = offset || new Point(0, 0);
        el.style[TRANSFORM] = (Browser.ie3d ? 'translate(' + pos.x + 'px,' + pos.y + 'px)' : 'translate3d(' + pos.x + 'px,' + pos.y + 'px,0)') + (scale ? ' scale(' + scale + ')' : '');
    }
    // @function setPosition(el: HTMLElement, position: Point)
    // Sets the position of `el` to coordinates specified by `position`,
    // using CSS translate or top/left positioning depending on the browser
    // (used by Leaflet internally to position its layers).
    function setPosition(el, point) {
        /*eslint-disable */ el._leaflet_pos = point;
        /* eslint-enable */ if (Browser.any3d) setTransform(el, point);
        else {
            el.style.left = point.x + 'px';
            el.style.top = point.y + 'px';
        }
    }
    // @function getPosition(el: HTMLElement): Point
    // Returns the coordinates of an element previously positioned with setPosition.
    function getPosition(el) {
        // this method is only used for elements previously positioned using setPosition,
        // so it's safe to cache the position for performance
        return el._leaflet_pos || new Point(0, 0);
    }
    // @function disableTextSelection()
    // Prevents the user from generating `selectstart` DOM events, usually generated
    // when the user drags the mouse through a page with text. Used internally
    // by Leaflet to override the behaviour of any click-and-drag interaction on
    // the map. Affects drag interactions on the whole document.
    // @function enableTextSelection()
    // Cancels the effects of a previous [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection).
    var disableTextSelection;
    var enableTextSelection;
    var _userSelect;
    if ('onselectstart' in document) {
        disableTextSelection = function() {
            on(window, 'selectstart', preventDefault);
        };
        enableTextSelection = function() {
            off(window, 'selectstart', preventDefault);
        };
    } else {
        var userSelectProperty = testProp([
            'userSelect',
            'WebkitUserSelect',
            'OUserSelect',
            'MozUserSelect',
            'msUserSelect'
        ]);
        disableTextSelection = function() {
            if (userSelectProperty) {
                var style = document.documentElement.style;
                _userSelect = style[userSelectProperty];
                style[userSelectProperty] = 'none';
            }
        };
        enableTextSelection = function() {
            if (userSelectProperty) {
                document.documentElement.style[userSelectProperty] = _userSelect;
                _userSelect = undefined;
            }
        };
    }
    // @function disableImageDrag()
    // As [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection), but
    // for `dragstart` DOM events, usually generated when the user drags an image.
    function disableImageDrag() {
        on(window, 'dragstart', preventDefault);
    }
    // @function enableImageDrag()
    // Cancels the effects of a previous [`L.DomUtil.disableImageDrag`](#domutil-disabletextselection).
    function enableImageDrag() {
        off(window, 'dragstart', preventDefault);
    }
    var _outlineElement, _outlineStyle;
    // @function preventOutline(el: HTMLElement)
    // Makes the [outline](https://developer.mozilla.org/docs/Web/CSS/outline)
    // of the element `el` invisible. Used internally by Leaflet to prevent
    // focusable elements from displaying an outline when the user performs a
    // drag interaction on them.
    function preventOutline(element) {
        while(element.tabIndex === -1)element = element.parentNode;
        if (!element.style) return;
        restoreOutline();
        _outlineElement = element;
        _outlineStyle = element.style.outlineStyle;
        element.style.outlineStyle = 'none';
        on(window, 'keydown', restoreOutline);
    }
    // @function restoreOutline()
    // Cancels the effects of a previous [`L.DomUtil.preventOutline`]().
    function restoreOutline() {
        if (!_outlineElement) return;
        _outlineElement.style.outlineStyle = _outlineStyle;
        _outlineElement = undefined;
        _outlineStyle = undefined;
        off(window, 'keydown', restoreOutline);
    }
    // @function getSizedParentNode(el: HTMLElement): HTMLElement
    // Finds the closest parent node which size (width and height) is not null.
    function getSizedParentNode(element) {
        do element = element.parentNode;
        while ((!element.offsetWidth || !element.offsetHeight) && element !== document.body);
        return element;
    }
    // @function getScale(el: HTMLElement): Object
    // Computes the CSS scale currently applied on the element.
    // Returns an object with `x` and `y` members as horizontal and vertical scales respectively,
    // and `boundingClientRect` as the result of [`getBoundingClientRect()`](https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect).
    function getScale(element) {
        var rect = element.getBoundingClientRect(); // Read-only in old browsers.
        return {
            x: rect.width / element.offsetWidth || 1,
            y: rect.height / element.offsetHeight || 1,
            boundingClientRect: rect
        };
    }
    var DomUtil = {
        __proto__: null,
        TRANSFORM: TRANSFORM,
        TRANSITION: TRANSITION,
        TRANSITION_END: TRANSITION_END,
        get: get,
        getStyle: getStyle,
        create: create$1,
        remove: remove,
        empty: empty,
        toFront: toFront,
        toBack: toBack,
        hasClass: hasClass,
        addClass: addClass,
        removeClass: removeClass,
        setClass: setClass,
        getClass: getClass,
        setOpacity: setOpacity,
        testProp: testProp,
        setTransform: setTransform,
        setPosition: setPosition,
        getPosition: getPosition,
        get disableTextSelection () {
            return disableTextSelection;
        },
        get enableTextSelection () {
            return enableTextSelection;
        },
        disableImageDrag: disableImageDrag,
        enableImageDrag: enableImageDrag,
        preventOutline: preventOutline,
        restoreOutline: restoreOutline,
        getSizedParentNode: getSizedParentNode,
        getScale: getScale
    };
    /*
   * @namespace DomEvent
   * Utility functions to work with the [DOM events](https://developer.mozilla.org/docs/Web/API/Event), used by Leaflet internally.
   */ // Inspired by John Resig, Dean Edwards and YUI addEvent implementations.
    // @function on(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Adds a listener function (`fn`) to a particular DOM event type of the
    // element `el`. You can optionally specify the context of the listener
    // (object the `this` keyword will point to). You can also pass several
    // space-separated types (e.g. `'click dblclick'`).
    // @alternative
    // @function on(el: HTMLElement, eventMap: Object, context?: Object): this
    // Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    function on(obj, types, fn, context) {
        if (types && typeof types === 'object') for(var type in types)addOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            for(var i = 0, len = types.length; i < len; i++)addOne(obj, types[i], fn, context);
        }
        return this;
    }
    var eventsKey = '_leaflet_events';
    // @function off(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Removes a previously added listener function.
    // Note that if you passed a custom context to on, you must pass the same
    // context to `off` in order to remove the listener.
    // @alternative
    // @function off(el: HTMLElement, eventMap: Object, context?: Object): this
    // Removes a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    // @alternative
    // @function off(el: HTMLElement, types: String): this
    // Removes all previously added listeners of given types.
    // @alternative
    // @function off(el: HTMLElement): this
    // Removes all previously added listeners from given HTMLElement
    function off(obj, types, fn, context) {
        if (arguments.length === 1) {
            batchRemove(obj);
            delete obj[eventsKey];
        } else if (types && typeof types === 'object') for(var type in types)removeOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            if (arguments.length === 2) batchRemove(obj, function(type) {
                return indexOf(types, type) !== -1;
            });
            else for(var i = 0, len = types.length; i < len; i++)removeOne(obj, types[i], fn, context);
        }
        return this;
    }
    function batchRemove(obj, filterFn) {
        for(var id in obj[eventsKey]){
            var type = id.split(/\d/)[0];
            if (!filterFn || filterFn(type)) removeOne(obj, type, null, null, id);
        }
    }
    var mouseSubst = {
        mouseenter: 'mouseover',
        mouseleave: 'mouseout',
        wheel: !('onwheel' in window) && 'mousewheel'
    };
    function addOne(obj, type, fn, context) {
        var id = type + stamp(fn) + (context ? '_' + stamp(context) : '');
        if (obj[eventsKey] && obj[eventsKey][id]) return this;
        var handler = function(e) {
            return fn.call(context || obj, e || window.event);
        };
        var originalHandler = handler;
        if (!Browser.touchNative && Browser.pointer && type.indexOf('touch') === 0) // Needs DomEvent.Pointer.js
        handler = addPointerListener(obj, type, handler);
        else if (Browser.touch && type === 'dblclick') handler = addDoubleTapListener(obj, handler);
        else if ('addEventListener' in obj) {
            if (type === 'touchstart' || type === 'touchmove' || type === 'wheel' || type === 'mousewheel') obj.addEventListener(mouseSubst[type] || type, handler, Browser.passiveEvents ? {
                passive: false
            } : false);
            else if (type === 'mouseenter' || type === 'mouseleave') {
                handler = function(e) {
                    e = e || window.event;
                    if (isExternalTarget(obj, e)) originalHandler(e);
                };
                obj.addEventListener(mouseSubst[type], handler, false);
            } else obj.addEventListener(type, originalHandler, false);
        } else obj.attachEvent('on' + type, handler);
        obj[eventsKey] = obj[eventsKey] || {};
        obj[eventsKey][id] = handler;
    }
    function removeOne(obj, type, fn, context, id) {
        id = id || type + stamp(fn) + (context ? '_' + stamp(context) : '');
        var handler = obj[eventsKey] && obj[eventsKey][id];
        if (!handler) return this;
        if (!Browser.touchNative && Browser.pointer && type.indexOf('touch') === 0) removePointerListener(obj, type, handler);
        else if (Browser.touch && type === 'dblclick') removeDoubleTapListener(obj, handler);
        else if ('removeEventListener' in obj) obj.removeEventListener(mouseSubst[type] || type, handler, false);
        else obj.detachEvent('on' + type, handler);
        obj[eventsKey][id] = null;
    }
    // @function stopPropagation(ev: DOMEvent): this
    // Stop the given event from propagation to parent elements. Used inside the listener functions:
    // ```js
    // L.DomEvent.on(div, 'click', function (ev) {
    // 	L.DomEvent.stopPropagation(ev);
    // });
    // ```
    function stopPropagation(e) {
        if (e.stopPropagation) e.stopPropagation();
        else if (e.originalEvent) e.originalEvent._stopped = true;
        else e.cancelBubble = true;
        return this;
    }
    // @function disableScrollPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'wheel'` events (plus browser variants).
    function disableScrollPropagation(el) {
        addOne(el, 'wheel', stopPropagation);
        return this;
    }
    // @function disableClickPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'click'`, `'dblclick'`, `'contextmenu'`,
    // `'mousedown'` and `'touchstart'` events (plus browser variants).
    function disableClickPropagation(el) {
        on(el, 'mousedown touchstart dblclick contextmenu', stopPropagation);
        el['_leaflet_disable_click'] = true;
        return this;
    }
    // @function preventDefault(ev: DOMEvent): this
    // Prevents the default action of the DOM Event `ev` from happening (such as
    // following a link in the href of the a element, or doing a POST request
    // with page reload when a `<form>` is submitted).
    // Use it inside listener functions.
    function preventDefault(e) {
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return this;
    }
    // @function stop(ev: DOMEvent): this
    // Does `stopPropagation` and `preventDefault` at the same time.
    function stop(e) {
        preventDefault(e);
        stopPropagation(e);
        return this;
    }
    // @function getPropagationPath(ev: DOMEvent): Array
    // Compatibility polyfill for [`Event.composedPath()`](https://developer.mozilla.org/en-US/docs/Web/API/Event/composedPath).
    // Returns an array containing the `HTMLElement`s that the given DOM event
    // should propagate to (if not stopped).
    function getPropagationPath(ev) {
        if (ev.composedPath) return ev.composedPath();
        var path = [];
        var el = ev.target;
        while(el){
            path.push(el);
            el = el.parentNode;
        }
        return path;
    }
    // @function getMousePosition(ev: DOMEvent, container?: HTMLElement): Point
    // Gets normalized mouse position from a DOM event relative to the
    // `container` (border excluded) or to the whole page if not specified.
    function getMousePosition(e, container) {
        if (!container) return new Point(e.clientX, e.clientY);
        var scale = getScale(container), offset = scale.boundingClientRect; // left and top  values are in page scale (like the event clientX/Y)
        return new Point(// offset.left/top values are in page scale (like clientX/Y),
        // whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
        (e.clientX - offset.left) / scale.x - container.clientLeft, (e.clientY - offset.top) / scale.y - container.clientTop);
    }
    //  except , Safari and
    // We need double the scroll pixels (see #7403 and #4538) for all Browsers
    // except OSX (Mac) -> 3x, Chrome running on Linux 1x
    var wheelPxFactor = Browser.linux && Browser.chrome ? window.devicePixelRatio : Browser.mac ? window.devicePixelRatio * 3 : window.devicePixelRatio > 0 ? 2 * window.devicePixelRatio : 1;
    // @function getWheelDelta(ev: DOMEvent): Number
    // Gets normalized wheel delta from a wheel DOM event, in vertical
    // pixels scrolled (negative if scrolling down).
    // Events from pointing devices without precise scrolling are mapped to
    // a best guess of 60 pixels.
    function getWheelDelta(e) {
        return Browser.edge ? e.wheelDeltaY / 2 : e.deltaY && e.deltaMode === 0 ? -e.deltaY / wheelPxFactor : e.deltaY && e.deltaMode === 1 ? -e.deltaY * 20 : e.deltaY && e.deltaMode === 2 ? -e.deltaY * 60 : e.deltaX || e.deltaZ ? 0 : e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : e.detail && Math.abs(e.detail) < 32765 ? -e.detail * 20 : e.detail ? e.detail / -32765 * 60 : 0;
    }
    // check if element really left/entered the event target (for mouseenter/mouseleave)
    function isExternalTarget(el, e) {
        var related = e.relatedTarget;
        if (!related) return true;
        try {
            while(related && related !== el)related = related.parentNode;
        } catch (err) {
            return false;
        }
        return related !== el;
    }
    var DomEvent = {
        __proto__: null,
        on: on,
        off: off,
        stopPropagation: stopPropagation,
        disableScrollPropagation: disableScrollPropagation,
        disableClickPropagation: disableClickPropagation,
        preventDefault: preventDefault,
        stop: stop,
        getPropagationPath: getPropagationPath,
        getMousePosition: getMousePosition,
        getWheelDelta: getWheelDelta,
        isExternalTarget: isExternalTarget,
        addListener: on,
        removeListener: off
    };
    /*
   * @class PosAnimation
   * @aka L.PosAnimation
   * @inherits Evented
   * Used internally for panning animations, utilizing CSS3 Transitions for modern browsers and a timer fallback for IE6-9.
   *
   * @example
   * ```js
   * var myPositionMarker = L.marker([48.864716, 2.294694]).addTo(map);
   *
   * myPositionMarker.on("click", function() {
   * 	var pos = map.latLngToLayerPoint(myPositionMarker.getLatLng());
   * 	pos.y -= 25;
   * 	var fx = new L.PosAnimation();
   *
   * 	fx.once('end',function() {
   * 		pos.y += 25;
   * 		fx.run(myPositionMarker._icon, pos, 0.8);
   * 	});
   *
   * 	fx.run(myPositionMarker._icon, pos, 0.3);
   * });
   *
   * ```
   *
   * @constructor L.PosAnimation()
   * Creates a `PosAnimation` object.
   *
   */ var PosAnimation = Evented.extend({
        // @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
        // Run an animation of a given element to a new position, optionally setting
        // duration in seconds (`0.25` by default) and easing linearity factor (3rd
        // argument of the [cubic bezier curve](https://cubic-bezier.com/#0,0,.5,1),
        // `0.5` by default).
        run: function(el, newPos, duration, easeLinearity) {
            this.stop();
            this._el = el;
            this._inProgress = true;
            this._duration = duration || 0.25;
            this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
            this._startPos = getPosition(el);
            this._offset = newPos.subtract(this._startPos);
            this._startTime = +new Date();
            // @event start: Event
            // Fired when the animation starts
            this.fire('start');
            this._animate();
        },
        // @method stop()
        // Stops the animation (if currently running).
        stop: function() {
            if (!this._inProgress) return;
            this._step(true);
            this._complete();
        },
        _animate: function() {
            // animation loop
            this._animId = requestAnimFrame(this._animate, this);
            this._step();
        },
        _step: function(round) {
            var elapsed = +new Date() - this._startTime, duration = this._duration * 1000;
            if (elapsed < duration) this._runFrame(this._easeOut(elapsed / duration), round);
            else {
                this._runFrame(1);
                this._complete();
            }
        },
        _runFrame: function(progress, round) {
            var pos = this._startPos.add(this._offset.multiplyBy(progress));
            if (round) pos._round();
            setPosition(this._el, pos);
            // @event step: Event
            // Fired continuously during the animation.
            this.fire('step');
        },
        _complete: function() {
            cancelAnimFrame(this._animId);
            this._inProgress = false;
            // @event end: Event
            // Fired when the animation ends.
            this.fire('end');
        },
        _easeOut: function(t) {
            return 1 - Math.pow(1 - t, this._easeOutPower);
        }
    });
    /*
   * @class Map
   * @aka L.Map
   * @inherits Evented
   *
   * The central class of the API — it is used to create a map on a page and manipulate it.
   *
   * @example
   *
   * ```js
   * // initialize the map on the "map" div with a given center and zoom
   * var map = L.map('map', {
   * 	center: [51.505, -0.09],
   * 	zoom: 13
   * });
   * ```
   *
   */ var Map = Evented.extend({
        options: {
            // @section Map State Options
            // @option crs: CRS = L.CRS.EPSG3857
            // The [Coordinate Reference System](#crs) to use. Don't change this if you're not
            // sure what it means.
            crs: EPSG3857,
            // @option center: LatLng = undefined
            // Initial geographic center of the map
            center: undefined,
            // @option zoom: Number = undefined
            // Initial map zoom level
            zoom: undefined,
            // @option minZoom: Number = *
            // Minimum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the lowest of their `minZoom` options will be used instead.
            minZoom: undefined,
            // @option maxZoom: Number = *
            // Maximum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the highest of their `maxZoom` options will be used instead.
            maxZoom: undefined,
            // @option layers: Layer[] = []
            // Array of layers that will be added to the map initially
            layers: [],
            // @option maxBounds: LatLngBounds = null
            // When this option is set, the map restricts the view to the given
            // geographical bounds, bouncing the user back if the user tries to pan
            // outside the view. To set the restriction dynamically, use
            // [`setMaxBounds`](#map-setmaxbounds) method.
            maxBounds: undefined,
            // @option renderer: Renderer = *
            // The default method for drawing vector layers on the map. `L.SVG`
            // or `L.Canvas` by default depending on browser support.
            renderer: undefined,
            // @section Animation Options
            // @option zoomAnimation: Boolean = true
            // Whether the map zoom animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            zoomAnimation: true,
            // @option zoomAnimationThreshold: Number = 4
            // Won't animate zoom if the zoom difference exceeds this value.
            zoomAnimationThreshold: 4,
            // @option fadeAnimation: Boolean = true
            // Whether the tile fade animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            fadeAnimation: true,
            // @option markerZoomAnimation: Boolean = true
            // Whether markers animate their zoom with the zoom animation, if disabled
            // they will disappear for the length of the animation. By default it's
            // enabled in all browsers that support CSS3 Transitions except Android.
            markerZoomAnimation: true,
            // @option transform3DLimit: Number = 2^23
            // Defines the maximum size of a CSS translation transform. The default
            // value should not be changed unless a web browser positions layers in
            // the wrong place after doing a large `panBy`.
            transform3DLimit: 8388608,
            // @section Interaction Options
            // @option zoomSnap: Number = 1
            // Forces the map's zoom level to always be a multiple of this, particularly
            // right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
            // By default, the zoom level snaps to the nearest integer; lower values
            // (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
            // means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
            zoomSnap: 1,
            // @option zoomDelta: Number = 1
            // Controls how much the map's zoom level will change after a
            // [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
            // or `-` on the keyboard, or using the [zoom controls](#control-zoom).
            // Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
            zoomDelta: 1,
            // @option trackResize: Boolean = true
            // Whether the map automatically handles browser window resize to update itself.
            trackResize: true
        },
        initialize: function(id, options) {
            options = setOptions(this, options);
            // Make sure to assign internal flags at the beginning,
            // to avoid inconsistent state in some edge cases.
            this._handlers = [];
            this._layers = {};
            this._zoomBoundLayers = {};
            this._sizeChanged = true;
            this._initContainer(id);
            this._initLayout();
            // hack for https://github.com/Leaflet/Leaflet/issues/1980
            this._onResize = bind(this._onResize, this);
            this._initEvents();
            if (options.maxBounds) this.setMaxBounds(options.maxBounds);
            if (options.zoom !== undefined) this._zoom = this._limitZoom(options.zoom);
            if (options.center && options.zoom !== undefined) this.setView(toLatLng(options.center), options.zoom, {
                reset: true
            });
            this.callInitHooks();
            // don't animate on browsers without hardware-accelerated transitions or old Android/Opera
            this._zoomAnimated = TRANSITION && Browser.any3d && !Browser.mobileOpera && this.options.zoomAnimation;
            // zoom transitions run with the same duration for all layers, so if one of transitionend events
            // happens after starting zoom animation (propagating to the map pane), we know that it ended globally
            if (this._zoomAnimated) {
                this._createAnimProxy();
                on(this._proxy, TRANSITION_END, this._catchTransitionEnd, this);
            }
            this._addLayers(this.options.layers);
        },
        // @section Methods for modifying map state
        // @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) with the given
        // animation options.
        setView: function(center, zoom, options) {
            zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
            center = this._limitCenter(toLatLng(center), zoom, this.options.maxBounds);
            options = options || {};
            this._stop();
            if (this._loaded && !options.reset && options !== true) {
                if (options.animate !== undefined) {
                    options.zoom = extend({
                        animate: options.animate
                    }, options.zoom);
                    options.pan = extend({
                        animate: options.animate,
                        duration: options.duration
                    }, options.pan);
                }
                // try animating pan or zoom
                var moved = this._zoom !== zoom ? this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) : this._tryAnimatedPan(center, options.pan);
                if (moved) {
                    // prevent resize handler call, the view will refresh after animation anyway
                    clearTimeout(this._sizeTimer);
                    return this;
                }
            }
            // animation didn't start, just reset the map view
            this._resetView(center, zoom, options.pan && options.pan.noMoveStart);
            return this;
        },
        // @method setZoom(zoom: Number, options?: Zoom/pan options): this
        // Sets the zoom of the map.
        setZoom: function(zoom, options) {
            if (!this._loaded) {
                this._zoom = zoom;
                return this;
            }
            return this.setView(this.getCenter(), zoom, {
                zoom: options
            });
        },
        // @method zoomIn(delta?: Number, options?: Zoom options): this
        // Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomIn: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom + delta, options);
        },
        // @method zoomOut(delta?: Number, options?: Zoom options): this
        // Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomOut: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom - delta, options);
        },
        // @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified geographical point on the map
        // stationary (e.g. used internally for scroll zoom and double-click zoom).
        // @alternative
        // @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
        setZoomAround: function(latlng, zoom, options) {
            var scale = this.getZoomScale(zoom), viewHalf = this.getSize().divideBy(2), containerPoint = latlng instanceof Point ? latlng : this.latLngToContainerPoint(latlng), centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale), newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
            return this.setView(newCenter, zoom, {
                zoom: options
            });
        },
        _getBoundsCenterZoom: function(bounds, options) {
            options = options || {};
            bounds = bounds.getBounds ? bounds.getBounds() : toLatLngBounds(bounds);
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
            zoom = typeof options.maxZoom === 'number' ? Math.min(options.maxZoom, zoom) : zoom;
            if (zoom === Infinity) return {
                center: bounds.getCenter(),
                zoom: zoom
            };
            var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2), swPoint = this.project(bounds.getSouthWest(), zoom), nePoint = this.project(bounds.getNorthEast(), zoom), center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);
            return {
                center: center,
                zoom: zoom
            };
        },
        // @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets a map view that contains the given geographical bounds with the
        // maximum zoom level possible.
        fitBounds: function(bounds, options) {
            bounds = toLatLngBounds(bounds);
            if (!bounds.isValid()) throw new Error('Bounds are not valid.');
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.setView(target.center, target.zoom, options);
        },
        // @method fitWorld(options?: fitBounds options): this
        // Sets a map view that mostly contains the whole world with the maximum
        // zoom level possible.
        fitWorld: function(options) {
            return this.fitBounds([
                [
                    -90,
                    -180
                ],
                [
                    90,
                    180
                ]
            ], options);
        },
        // @method panTo(latlng: LatLng, options?: Pan options): this
        // Pans the map to a given center.
        panTo: function(center, options) {
            return this.setView(center, this._zoom, {
                pan: options
            });
        },
        // @method panBy(offset: Point, options?: Pan options): this
        // Pans the map by a given number of pixels (animated).
        panBy: function(offset, options) {
            offset = toPoint(offset).round();
            options = options || {};
            if (!offset.x && !offset.y) return this.fire('moveend');
            // If we pan too far, Chrome gets issues with tiles
            // and makes them disappear or appear in the wrong place (slightly offset) #2602
            if (options.animate !== true && !this.getSize().contains(offset)) {
                this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
                return this;
            }
            if (!this._panAnim) {
                this._panAnim = new PosAnimation();
                this._panAnim.on({
                    'step': this._onPanTransitionStep,
                    'end': this._onPanTransitionEnd
                }, this);
            }
            // don't fire movestart if animating inertia
            if (!options.noMoveStart) this.fire('movestart');
            // animate pan unless animate: false specified
            if (options.animate !== false) {
                addClass(this._mapPane, 'leaflet-pan-anim');
                var newPos = this._getMapPanePos().subtract(offset).round();
                this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
            } else {
                this._rawPanBy(offset);
                this.fire('move').fire('moveend');
            }
            return this;
        },
        // @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) performing a smooth
        // pan-zoom animation.
        flyTo: function(targetCenter, targetZoom, options) {
            options = options || {};
            if (options.animate === false || !Browser.any3d) return this.setView(targetCenter, targetZoom, options);
            this._stop();
            var from = this.project(this.getCenter()), to = this.project(targetCenter), size = this.getSize(), startZoom = this._zoom;
            targetCenter = toLatLng(targetCenter);
            targetZoom = targetZoom === undefined ? startZoom : targetZoom;
            var w0 = Math.max(size.x, size.y), w1 = w0 * this.getZoomScale(startZoom, targetZoom), u1 = to.distanceTo(from) || 1, rho = 1.42, rho2 = rho * rho;
            function r(i) {
                var s1 = i ? -1 : 1, s2 = i ? w1 : w0, t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1, b1 = 2 * s2 * rho2 * u1, b = t1 / b1, sq = Math.sqrt(b * b + 1) - b;
                // workaround for floating point precision bug when sq = 0, log = -Infinite,
                // thus triggering an infinite loop in flyTo
                var log = sq < 0.000000001 ? -18 : Math.log(sq);
                return log;
            }
            function sinh(n) {
                return (Math.exp(n) - Math.exp(-n)) / 2;
            }
            function cosh(n) {
                return (Math.exp(n) + Math.exp(-n)) / 2;
            }
            function tanh(n) {
                return sinh(n) / cosh(n);
            }
            var r0 = r(0);
            function w(s) {
                return w0 * (cosh(r0) / cosh(r0 + rho * s));
            }
            function u(s) {
                return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2;
            }
            function easeOut(t) {
                return 1 - Math.pow(1 - t, 1.5);
            }
            var start = Date.now(), S = (r(1) - r0) / rho, duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;
            function frame() {
                var t = (Date.now() - start) / duration, s = easeOut(t) * S;
                if (t <= 1) {
                    this._flyToFrame = requestAnimFrame(frame, this);
                    this._move(this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom), this.getScaleZoom(w0 / w(s), startZoom), {
                        flyTo: true
                    });
                } else this._move(targetCenter, targetZoom)._moveEnd(true);
            }
            this._moveStart(true, options.noMoveStart);
            frame.call(this);
            return this;
        },
        // @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
        // but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
        flyToBounds: function(bounds, options) {
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.flyTo(target.center, target.zoom, options);
        },
        // @method setMaxBounds(bounds: LatLngBounds): this
        // Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
        setMaxBounds: function(bounds) {
            bounds = toLatLngBounds(bounds);
            if (this.listens('moveend', this._panInsideMaxBounds)) this.off('moveend', this._panInsideMaxBounds);
            if (!bounds.isValid()) {
                this.options.maxBounds = null;
                return this;
            }
            this.options.maxBounds = bounds;
            if (this._loaded) this._panInsideMaxBounds();
            return this.on('moveend', this._panInsideMaxBounds);
        },
        // @method setMinZoom(zoom: Number): this
        // Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
        setMinZoom: function(zoom) {
            var oldZoom = this.options.minZoom;
            this.options.minZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire('zoomlevelschange');
                if (this.getZoom() < this.options.minZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method setMaxZoom(zoom: Number): this
        // Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
        setMaxZoom: function(zoom) {
            var oldZoom = this.options.maxZoom;
            this.options.maxZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire('zoomlevelschange');
                if (this.getZoom() > this.options.maxZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
        // Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
        panInsideBounds: function(bounds, options) {
            this._enforcingBounds = true;
            var center = this.getCenter(), newCenter = this._limitCenter(center, this._zoom, toLatLngBounds(bounds));
            if (!center.equals(newCenter)) this.panTo(newCenter, options);
            this._enforcingBounds = false;
            return this;
        },
        // @method panInside(latlng: LatLng, options?: padding options): this
        // Pans the map the minimum amount to make the `latlng` visible. Use
        // padding options to fit the display to more restricted bounds.
        // If `latlng` is already within the (optionally padded) display bounds,
        // the map will not be panned.
        panInside: function(latlng, options) {
            options = options || {};
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), pixelCenter = this.project(this.getCenter()), pixelPoint = this.project(latlng), pixelBounds = this.getPixelBounds(), paddedBounds = toBounds([
                pixelBounds.min.add(paddingTL),
                pixelBounds.max.subtract(paddingBR)
            ]), paddedSize = paddedBounds.getSize();
            if (!paddedBounds.contains(pixelPoint)) {
                this._enforcingBounds = true;
                var centerOffset = pixelPoint.subtract(paddedBounds.getCenter());
                var offset = paddedBounds.extend(pixelPoint).getSize().subtract(paddedSize);
                pixelCenter.x += centerOffset.x < 0 ? -offset.x : offset.x;
                pixelCenter.y += centerOffset.y < 0 ? -offset.y : offset.y;
                this.panTo(this.unproject(pixelCenter), options);
                this._enforcingBounds = false;
            }
            return this;
        },
        // @method invalidateSize(options: Zoom/pan options): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default. If `options.pan` is `false`, panning will not occur.
        // If `options.debounceMoveend` is `true`, it will delay `moveend` event so
        // that it doesn't happen often even if the method is called many
        // times in a row.
        // @alternative
        // @method invalidateSize(animate: Boolean): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default.
        invalidateSize: function(options) {
            if (!this._loaded) return this;
            options = extend({
                animate: false,
                pan: true
            }, options === true ? {
                animate: true
            } : options);
            var oldSize = this.getSize();
            this._sizeChanged = true;
            this._lastCenter = null;
            var newSize = this.getSize(), oldCenter = oldSize.divideBy(2).round(), newCenter = newSize.divideBy(2).round(), offset = oldCenter.subtract(newCenter);
            if (!offset.x && !offset.y) return this;
            if (options.animate && options.pan) this.panBy(offset);
            else {
                if (options.pan) this._rawPanBy(offset);
                this.fire('move');
                if (options.debounceMoveend) {
                    clearTimeout(this._sizeTimer);
                    this._sizeTimer = setTimeout(bind(this.fire, this, 'moveend'), 200);
                } else this.fire('moveend');
            }
            // @section Map state change events
            // @event resize: ResizeEvent
            // Fired when the map is resized.
            return this.fire('resize', {
                oldSize: oldSize,
                newSize: newSize
            });
        },
        // @section Methods for modifying map state
        // @method stop(): this
        // Stops the currently running `panTo` or `flyTo` animation, if any.
        stop: function() {
            this.setZoom(this._limitZoom(this._zoom));
            if (!this.options.zoomSnap) this.fire('viewreset');
            return this._stop();
        },
        // @section Geolocation methods
        // @method locate(options?: Locate options): this
        // Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
        // event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
        // and optionally sets the map view to the user's location with respect to
        // detection accuracy (or to the world view if geolocation failed).
        // Note that, if your page doesn't use HTTPS, this method will fail in
        // modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
        // See `Locate options` for more details.
        locate: function(options) {
            options = this._locateOptions = extend({
                timeout: 10000,
                watch: false
            }, options);
            if (!('geolocation' in navigator)) {
                this._handleGeolocationError({
                    code: 0,
                    message: 'Geolocation not supported.'
                });
                return this;
            }
            var onResponse = bind(this._handleGeolocationResponse, this), onError = bind(this._handleGeolocationError, this);
            if (options.watch) this._locationWatchId = navigator.geolocation.watchPosition(onResponse, onError, options);
            else navigator.geolocation.getCurrentPosition(onResponse, onError, options);
            return this;
        },
        // @method stopLocate(): this
        // Stops watching location previously initiated by `map.locate({watch: true})`
        // and aborts resetting the map view if map.locate was called with
        // `{setView: true}`.
        stopLocate: function() {
            if (navigator.geolocation && navigator.geolocation.clearWatch) navigator.geolocation.clearWatch(this._locationWatchId);
            if (this._locateOptions) this._locateOptions.setView = false;
            return this;
        },
        _handleGeolocationError: function(error) {
            if (!this._container._leaflet_id) return;
            var c = error.code, message = error.message || (c === 1 ? 'permission denied' : c === 2 ? 'position unavailable' : 'timeout');
            if (this._locateOptions.setView && !this._loaded) this.fitWorld();
            // @section Location events
            // @event locationerror: ErrorEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method) failed.
            this.fire('locationerror', {
                code: c,
                message: 'Geolocation error: ' + message + '.'
            });
        },
        _handleGeolocationResponse: function(pos) {
            if (!this._container._leaflet_id) return;
            var lat = pos.coords.latitude, lng = pos.coords.longitude, latlng = new LatLng(lat, lng), bounds = latlng.toBounds(pos.coords.accuracy * 2), options = this._locateOptions;
            if (options.setView) {
                var zoom = this.getBoundsZoom(bounds);
                this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
            }
            var data = {
                latlng: latlng,
                bounds: bounds,
                timestamp: pos.timestamp
            };
            for(var i in pos.coords)if (typeof pos.coords[i] === 'number') data[i] = pos.coords[i];
            // @event locationfound: LocationEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method)
            // went successfully.
            this.fire('locationfound', data);
        },
        // TODO Appropriate docs section?
        // @section Other Methods
        // @method addHandler(name: String, HandlerClass: Function): this
        // Adds a new `Handler` to the map, given its name and constructor function.
        addHandler: function(name, HandlerClass) {
            if (!HandlerClass) return this;
            var handler = this[name] = new HandlerClass(this);
            this._handlers.push(handler);
            if (this.options[name]) handler.enable();
            return this;
        },
        // @method remove(): this
        // Destroys the map and clears all related event listeners.
        remove: function() {
            this._initEvents(true);
            if (this.options.maxBounds) this.off('moveend', this._panInsideMaxBounds);
            if (this._containerId !== this._container._leaflet_id) throw new Error('Map container is being reused by another instance');
            try {
                // throws error in IE6-8
                delete this._container._leaflet_id;
                delete this._containerId;
            } catch (e) {
                /*eslint-disable */ this._container._leaflet_id = undefined;
                /* eslint-enable */ this._containerId = undefined;
            }
            if (this._locationWatchId !== undefined) this.stopLocate();
            this._stop();
            remove(this._mapPane);
            if (this._clearControlPos) this._clearControlPos();
            if (this._resizeRequest) {
                cancelAnimFrame(this._resizeRequest);
                this._resizeRequest = null;
            }
            this._clearHandlers();
            if (this._loaded) // @section Map state change events
            // @event unload: Event
            // Fired when the map is destroyed with [remove](#map-remove) method.
            this.fire('unload');
            var i;
            for(i in this._layers)this._layers[i].remove();
            for(i in this._panes)remove(this._panes[i]);
            this._layers = [];
            this._panes = [];
            delete this._mapPane;
            delete this._renderer;
            return this;
        },
        // @section Other Methods
        // @method createPane(name: String, container?: HTMLElement): HTMLElement
        // Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
        // then returns it. The pane is created as a child of `container`, or
        // as a child of the main map pane if not set.
        createPane: function(name, container) {
            var className = 'leaflet-pane' + (name ? ' leaflet-' + name.replace('Pane', '') + '-pane' : ''), pane = create$1('div', className, container || this._mapPane);
            if (name) this._panes[name] = pane;
            return pane;
        },
        // @section Methods for Getting Map State
        // @method getCenter(): LatLng
        // Returns the geographical center of the map view
        getCenter: function() {
            this._checkIfLoaded();
            if (this._lastCenter && !this._moved()) return this._lastCenter.clone();
            return this.layerPointToLatLng(this._getCenterLayerPoint());
        },
        // @method getZoom(): Number
        // Returns the current zoom level of the map view
        getZoom: function() {
            return this._zoom;
        },
        // @method getBounds(): LatLngBounds
        // Returns the geographical bounds visible in the current map view
        getBounds: function() {
            var bounds = this.getPixelBounds(), sw = this.unproject(bounds.getBottomLeft()), ne = this.unproject(bounds.getTopRight());
            return new LatLngBounds(sw, ne);
        },
        // @method getMinZoom(): Number
        // Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
        getMinZoom: function() {
            return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
        },
        // @method getMaxZoom(): Number
        // Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
        getMaxZoom: function() {
            return this.options.maxZoom === undefined ? this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom : this.options.maxZoom;
        },
        // @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
        // Returns the maximum zoom level on which the given bounds fit to the map
        // view in its entirety. If `inside` (optional) is set to `true`, the method
        // instead returns the minimum zoom level on which the map view fits into
        // the given bounds in its entirety.
        getBoundsZoom: function(bounds, inside, padding) {
            bounds = toLatLngBounds(bounds);
            padding = toPoint(padding || [
                0,
                0
            ]);
            var zoom = this.getZoom() || 0, min = this.getMinZoom(), max = this.getMaxZoom(), nw = bounds.getNorthWest(), se = bounds.getSouthEast(), size = this.getSize().subtract(padding), boundsSize = toBounds(this.project(se, zoom), this.project(nw, zoom)).getSize(), snap = Browser.any3d ? this.options.zoomSnap : 1, scalex = size.x / boundsSize.x, scaley = size.y / boundsSize.y, scale = inside ? Math.max(scalex, scaley) : Math.min(scalex, scaley);
            zoom = this.getScaleZoom(scale, zoom);
            if (snap) {
                zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
                zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
            }
            return Math.max(min, Math.min(max, zoom));
        },
        // @method getSize(): Point
        // Returns the current size of the map container (in pixels).
        getSize: function() {
            if (!this._size || this._sizeChanged) {
                this._size = new Point(this._container.clientWidth || 0, this._container.clientHeight || 0);
                this._sizeChanged = false;
            }
            return this._size.clone();
        },
        // @method getPixelBounds(): Bounds
        // Returns the bounds of the current map view in projected pixel
        // coordinates (sometimes useful in layer and overlay implementations).
        getPixelBounds: function(center, zoom) {
            var topLeftPoint = this._getTopLeftPoint(center, zoom);
            return new Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
        },
        // TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
        // the map pane? "left point of the map layer" can be confusing, specially
        // since there can be negative offsets.
        // @method getPixelOrigin(): Point
        // Returns the projected pixel coordinates of the top left point of
        // the map layer (useful in custom layer and overlay implementations).
        getPixelOrigin: function() {
            this._checkIfLoaded();
            return this._pixelOrigin;
        },
        // @method getPixelWorldBounds(zoom?: Number): Bounds
        // Returns the world's bounds in pixel coordinates for zoom level `zoom`.
        // If `zoom` is omitted, the map's current zoom level is used.
        getPixelWorldBounds: function(zoom) {
            return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
        },
        // @section Other Methods
        // @method getPane(pane: String|HTMLElement): HTMLElement
        // Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
        getPane: function(pane) {
            return typeof pane === 'string' ? this._panes[pane] : pane;
        },
        // @method getPanes(): Object
        // Returns a plain object containing the names of all [panes](#map-pane) as keys and
        // the panes as values.
        getPanes: function() {
            return this._panes;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the map.
        getContainer: function() {
            return this._container;
        },
        // @section Conversion Methods
        // @method getZoomScale(toZoom: Number, fromZoom: Number): Number
        // Returns the scale factor to be applied to a map transition from zoom level
        // `fromZoom` to `toZoom`. Used internally to help with zoom animations.
        getZoomScale: function(toZoom, fromZoom) {
            // TODO replace with universal implementation after refactoring projections
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            return crs.scale(toZoom) / crs.scale(fromZoom);
        },
        // @method getScaleZoom(scale: Number, fromZoom: Number): Number
        // Returns the zoom level that the map would end up at, if it is at `fromZoom`
        // level and everything is scaled by a factor of `scale`. Inverse of
        // [`getZoomScale`](#map-getZoomScale).
        getScaleZoom: function(scale, fromZoom) {
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            var zoom = crs.zoom(scale * crs.scale(fromZoom));
            return isNaN(zoom) ? Infinity : zoom;
        },
        // @method project(latlng: LatLng, zoom: Number): Point
        // Projects a geographical coordinate `LatLng` according to the projection
        // of the map's CRS, then scales it according to `zoom` and the CRS's
        // `Transformation`. The result is pixel coordinate relative to
        // the CRS origin.
        project: function(latlng, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.latLngToPoint(toLatLng(latlng), zoom);
        },
        // @method unproject(point: Point, zoom: Number): LatLng
        // Inverse of [`project`](#map-project).
        unproject: function(point, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.pointToLatLng(toPoint(point), zoom);
        },
        // @method layerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding geographical coordinate (for the current zoom level).
        layerPointToLatLng: function(point) {
            var projectedPoint = toPoint(point).add(this.getPixelOrigin());
            return this.unproject(projectedPoint);
        },
        // @method latLngToLayerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the [origin pixel](#map-getpixelorigin).
        latLngToLayerPoint: function(latlng) {
            var projectedPoint = this.project(toLatLng(latlng))._round();
            return projectedPoint._subtract(this.getPixelOrigin());
        },
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
        // map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
        // CRS's bounds.
        // By default this means longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees.
        wrapLatLng: function(latlng) {
            return this.options.crs.wrapLatLng(toLatLng(latlng));
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring that
        // its center is within the CRS's bounds.
        // By default this means the center longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees, and the majority of the bounds
        // overlaps the CRS's bounds.
        wrapLatLngBounds: function(latlng) {
            return this.options.crs.wrapLatLngBounds(toLatLngBounds(latlng));
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates according to
        // the map's CRS. By default this measures distance in meters.
        distance: function(latlng1, latlng2) {
            return this.options.crs.distance(toLatLng(latlng1), toLatLng(latlng2));
        },
        // @method containerPointToLayerPoint(point: Point): Point
        // Given a pixel coordinate relative to the map container, returns the corresponding
        // pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
        containerPointToLayerPoint: function(point) {
            return toPoint(point).subtract(this._getMapPanePos());
        },
        // @method layerPointToContainerPoint(point: Point): Point
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding pixel coordinate relative to the map container.
        layerPointToContainerPoint: function(point) {
            return toPoint(point).add(this._getMapPanePos());
        },
        // @method containerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the map container, returns
        // the corresponding geographical coordinate (for the current zoom level).
        containerPointToLatLng: function(point) {
            var layerPoint = this.containerPointToLayerPoint(toPoint(point));
            return this.layerPointToLatLng(layerPoint);
        },
        // @method latLngToContainerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the map container.
        latLngToContainerPoint: function(latlng) {
            return this.layerPointToContainerPoint(this.latLngToLayerPoint(toLatLng(latlng)));
        },
        // @method mouseEventToContainerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to the
        // map container where the event took place.
        mouseEventToContainerPoint: function(e) {
            return getMousePosition(e, this._container);
        },
        // @method mouseEventToLayerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to
        // the [origin pixel](#map-getpixelorigin) where the event took place.
        mouseEventToLayerPoint: function(e) {
            return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
        },
        // @method mouseEventToLatLng(ev: MouseEvent): LatLng
        // Given a MouseEvent object, returns geographical coordinate where the
        // event took place.
        mouseEventToLatLng: function(e) {
            return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
        },
        // map initialization methods
        _initContainer: function(id) {
            var container = this._container = get(id);
            if (!container) throw new Error('Map container not found.');
            else if (container._leaflet_id) throw new Error('Map container is already initialized.');
            on(container, 'scroll', this._onScroll, this);
            this._containerId = stamp(container);
        },
        _initLayout: function() {
            var container = this._container;
            this._fadeAnimated = this.options.fadeAnimation && Browser.any3d;
            addClass(container, 'leaflet-container' + (Browser.touch ? ' leaflet-touch' : '') + (Browser.retina ? ' leaflet-retina' : '') + (Browser.ielt9 ? ' leaflet-oldie' : '') + (Browser.safari ? ' leaflet-safari' : '') + (this._fadeAnimated ? ' leaflet-fade-anim' : ''));
            var position = getStyle(container, 'position');
            if (position !== 'absolute' && position !== 'relative' && position !== 'fixed' && position !== 'sticky') container.style.position = 'relative';
            this._initPanes();
            if (this._initControlPos) this._initControlPos();
        },
        _initPanes: function() {
            var panes = this._panes = {};
            this._paneRenderers = {};
            // @section
            //
            // Panes are DOM elements used to control the ordering of layers on the map. You
            // can access panes with [`map.getPane`](#map-getpane) or
            // [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
            // [`map.createPane`](#map-createpane) method.
            //
            // Every map has the following default panes that differ only in zIndex.
            //
            // @pane mapPane: HTMLElement = 'auto'
            // Pane that contains all other map panes
            this._mapPane = this.createPane('mapPane', this._container);
            setPosition(this._mapPane, new Point(0, 0));
            // @pane tilePane: HTMLElement = 200
            // Pane for `GridLayer`s and `TileLayer`s
            this.createPane('tilePane');
            // @pane overlayPane: HTMLElement = 400
            // Pane for vectors (`Path`s, like `Polyline`s and `Polygon`s), `ImageOverlay`s and `VideoOverlay`s
            this.createPane('overlayPane');
            // @pane shadowPane: HTMLElement = 500
            // Pane for overlay shadows (e.g. `Marker` shadows)
            this.createPane('shadowPane');
            // @pane markerPane: HTMLElement = 600
            // Pane for `Icon`s of `Marker`s
            this.createPane('markerPane');
            // @pane tooltipPane: HTMLElement = 650
            // Pane for `Tooltip`s.
            this.createPane('tooltipPane');
            // @pane popupPane: HTMLElement = 700
            // Pane for `Popup`s.
            this.createPane('popupPane');
            if (!this.options.markerZoomAnimation) {
                addClass(panes.markerPane, 'leaflet-zoom-hide');
                addClass(panes.shadowPane, 'leaflet-zoom-hide');
            }
        },
        // private methods that modify map state
        // @section Map state change events
        _resetView: function(center, zoom, noMoveStart) {
            setPosition(this._mapPane, new Point(0, 0));
            var loading = !this._loaded;
            this._loaded = true;
            zoom = this._limitZoom(zoom);
            this.fire('viewprereset');
            var zoomChanged = this._zoom !== zoom;
            this._moveStart(zoomChanged, noMoveStart)._move(center, zoom)._moveEnd(zoomChanged);
            // @event viewreset: Event
            // Fired when the map needs to redraw its content (this usually happens
            // on map zoom or load). Very useful for creating custom overlays.
            this.fire('viewreset');
            // @event load: Event
            // Fired when the map is initialized (when its center and zoom are set
            // for the first time).
            if (loading) this.fire('load');
        },
        _moveStart: function(zoomChanged, noMoveStart) {
            // @event zoomstart: Event
            // Fired when the map zoom is about to change (e.g. before zoom animation).
            // @event movestart: Event
            // Fired when the view of the map starts changing (e.g. user starts dragging the map).
            if (zoomChanged) this.fire('zoomstart');
            if (!noMoveStart) this.fire('movestart');
            return this;
        },
        _move: function(center, zoom, data, supressEvent) {
            if (zoom === undefined) zoom = this._zoom;
            var zoomChanged = this._zoom !== zoom;
            this._zoom = zoom;
            this._lastCenter = center;
            this._pixelOrigin = this._getNewPixelOrigin(center);
            if (!supressEvent) {
                // @event zoom: Event
                // Fired repeatedly during any change in zoom level,
                // including zoom and fly animations.
                if (zoomChanged || data && data.pinch) this.fire('zoom', data);
                // @event move: Event
                // Fired repeatedly during any movement of the map,
                // including pan and fly animations.
                this.fire('move', data);
            } else if (data && data.pinch) this.fire('zoom', data);
            return this;
        },
        _moveEnd: function(zoomChanged) {
            // @event zoomend: Event
            // Fired when the map zoom changed, after any animations.
            if (zoomChanged) this.fire('zoomend');
            // @event moveend: Event
            // Fired when the center of the map stops changing
            // (e.g. user stopped dragging the map or after non-centered zoom).
            return this.fire('moveend');
        },
        _stop: function() {
            cancelAnimFrame(this._flyToFrame);
            if (this._panAnim) this._panAnim.stop();
            return this;
        },
        _rawPanBy: function(offset) {
            setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
        },
        _getZoomSpan: function() {
            return this.getMaxZoom() - this.getMinZoom();
        },
        _panInsideMaxBounds: function() {
            if (!this._enforcingBounds) this.panInsideBounds(this.options.maxBounds);
        },
        _checkIfLoaded: function() {
            if (!this._loaded) throw new Error('Set map center and zoom first.');
        },
        // DOM event handling
        // @section Interaction events
        _initEvents: function(remove) {
            this._targets = {};
            this._targets[stamp(this._container)] = this;
            var onOff = remove ? off : on;
            // @event click: MouseEvent
            // Fired when the user clicks (or taps) the map.
            // @event dblclick: MouseEvent
            // Fired when the user double-clicks (or double-taps) the map.
            // @event mousedown: MouseEvent
            // Fired when the user pushes the mouse button on the map.
            // @event mouseup: MouseEvent
            // Fired when the user releases the mouse button on the map.
            // @event mouseover: MouseEvent
            // Fired when the mouse enters the map.
            // @event mouseout: MouseEvent
            // Fired when the mouse leaves the map.
            // @event mousemove: MouseEvent
            // Fired while the mouse moves over the map.
            // @event contextmenu: MouseEvent
            // Fired when the user pushes the right mouse button on the map, prevents
            // default browser context menu from showing if there are listeners on
            // this event. Also fired on mobile when the user holds a single touch
            // for a second (also called long press).
            // @event keypress: KeyboardEvent
            // Fired when the user presses a key from the keyboard that produces a character value while the map is focused.
            // @event keydown: KeyboardEvent
            // Fired when the user presses a key from the keyboard while the map is focused. Unlike the `keypress` event,
            // the `keydown` event is fired for keys that produce a character value and for keys
            // that do not produce a character value.
            // @event keyup: KeyboardEvent
            // Fired when the user releases a key from the keyboard while the map is focused.
            onOff(this._container, "click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup", this._handleDOMEvent, this);
            if (this.options.trackResize) onOff(window, 'resize', this._onResize, this);
            if (Browser.any3d && this.options.transform3DLimit) (remove ? this.off : this.on).call(this, 'moveend', this._onMoveEnd);
        },
        _onResize: function() {
            cancelAnimFrame(this._resizeRequest);
            this._resizeRequest = requestAnimFrame(function() {
                this.invalidateSize({
                    debounceMoveend: true
                });
            }, this);
        },
        _onScroll: function() {
            this._container.scrollTop = 0;
            this._container.scrollLeft = 0;
        },
        _onMoveEnd: function() {
            var pos = this._getMapPanePos();
            if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) // https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
            // a pixel offset on very high values, see: https://jsfiddle.net/dg6r5hhb/
            this._resetView(this.getCenter(), this.getZoom());
        },
        _findEventTargets: function(e, type) {
            var targets = [], target, isHover = type === 'mouseout' || type === 'mouseover', src = e.target || e.srcElement, dragging = false;
            while(src){
                target = this._targets[stamp(src)];
                if (target && (type === 'click' || type === 'preclick') && this._draggableMoved(target)) {
                    // Prevent firing click after you just dragged an object.
                    dragging = true;
                    break;
                }
                if (target && target.listens(type, true)) {
                    if (isHover && !isExternalTarget(src, e)) break;
                    targets.push(target);
                    if (isHover) break;
                }
                if (src === this._container) break;
                src = src.parentNode;
            }
            if (!targets.length && !dragging && !isHover && this.listens(type, true)) targets = [
                this
            ];
            return targets;
        },
        _isClickDisabled: function(el) {
            while(el && el !== this._container){
                if (el['_leaflet_disable_click']) return true;
                el = el.parentNode;
            }
        },
        _handleDOMEvent: function(e) {
            var el = e.target || e.srcElement;
            if (!this._loaded || el['_leaflet_disable_events'] || e.type === 'click' && this._isClickDisabled(el)) return;
            var type = e.type;
            if (type === 'mousedown') // prevents outline when clicking on keyboard-focusable element
            preventOutline(el);
            this._fireDOMEvent(e, type);
        },
        _mouseEvents: [
            'click',
            'dblclick',
            'mouseover',
            'mouseout',
            'contextmenu'
        ],
        _fireDOMEvent: function(e, type, canvasTargets) {
            if (e.type === 'click') {
                // Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
                // @event preclick: MouseEvent
                // Fired before mouse click on the map (sometimes useful when you
                // want something to happen on click before any existing click
                // handlers start running).
                var synth = extend({}, e);
                synth.type = 'preclick';
                this._fireDOMEvent(synth, synth.type, canvasTargets);
            }
            // Find the layer the event is propagating from and its parents.
            var targets = this._findEventTargets(e, type);
            if (canvasTargets) {
                var filtered = []; // pick only targets with listeners
                for(var i = 0; i < canvasTargets.length; i++)if (canvasTargets[i].listens(type, true)) filtered.push(canvasTargets[i]);
                targets = filtered.concat(targets);
            }
            if (!targets.length) return;
            if (type === 'contextmenu') preventDefault(e);
            var target = targets[0];
            var data = {
                originalEvent: e
            };
            if (e.type !== 'keypress' && e.type !== 'keydown' && e.type !== 'keyup') {
                var isMarker = target.getLatLng && (!target._radius || target._radius <= 10);
                data.containerPoint = isMarker ? this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
                data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
                data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
            }
            for(i = 0; i < targets.length; i++){
                targets[i].fire(type, data, true);
                if (data.originalEvent._stopped || targets[i].options.bubblingMouseEvents === false && indexOf(this._mouseEvents, type) !== -1) return;
            }
        },
        _draggableMoved: function(obj) {
            obj = obj.dragging && obj.dragging.enabled() ? obj : this;
            return obj.dragging && obj.dragging.moved() || this.boxZoom && this.boxZoom.moved();
        },
        _clearHandlers: function() {
            for(var i = 0, len = this._handlers.length; i < len; i++)this._handlers[i].disable();
        },
        // @section Other Methods
        // @method whenReady(fn: Function, context?: Object): this
        // Runs the given function `fn` when the map gets initialized with
        // a view (center and zoom) and at least one layer, or immediately
        // if it's already initialized, optionally passing a function context.
        whenReady: function(callback, context) {
            if (this._loaded) callback.call(context || this, {
                target: this
            });
            else this.on('load', callback, context);
            return this;
        },
        // private methods for getting map state
        _getMapPanePos: function() {
            return getPosition(this._mapPane) || new Point(0, 0);
        },
        _moved: function() {
            var pos = this._getMapPanePos();
            return pos && !pos.equals([
                0,
                0
            ]);
        },
        _getTopLeftPoint: function(center, zoom) {
            var pixelOrigin = center && zoom !== undefined ? this._getNewPixelOrigin(center, zoom) : this.getPixelOrigin();
            return pixelOrigin.subtract(this._getMapPanePos());
        },
        _getNewPixelOrigin: function(center, zoom) {
            var viewHalf = this.getSize()._divideBy(2);
            return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
        },
        _latLngToNewLayerPoint: function(latlng, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return this.project(latlng, zoom)._subtract(topLeft);
        },
        _latLngBoundsToNewLayerBounds: function(latLngBounds, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return toBounds([
                this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)
            ]);
        },
        // layer point of the current center
        _getCenterLayerPoint: function() {
            return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
        },
        // offset of the specified place to the current center in pixels
        _getCenterOffset: function(latlng) {
            return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
        },
        // adjust center for view to get inside bounds
        _limitCenter: function(center, zoom, bounds) {
            if (!bounds) return center;
            var centerPoint = this.project(center, zoom), viewHalf = this.getSize().divideBy(2), viewBounds = new Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)), offset = this._getBoundsOffset(viewBounds, bounds, zoom);
            // If offset is less than a pixel, ignore.
            // This prevents unstable projections from getting into
            // an infinite loop of tiny offsets.
            if (Math.abs(offset.x) <= 1 && Math.abs(offset.y) <= 1) return center;
            return this.unproject(centerPoint.add(offset), zoom);
        },
        // adjust offset for view to get inside bounds
        _limitOffset: function(offset, bounds) {
            if (!bounds) return offset;
            var viewBounds = this.getPixelBounds(), newBounds = new Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));
            return offset.add(this._getBoundsOffset(newBounds, bounds));
        },
        // returns offset needed for pxBounds to get inside maxBounds at a specified zoom
        _getBoundsOffset: function(pxBounds, maxBounds, zoom) {
            var projectedMaxBounds = toBounds(this.project(maxBounds.getNorthEast(), zoom), this.project(maxBounds.getSouthWest(), zoom)), minOffset = projectedMaxBounds.min.subtract(pxBounds.min), maxOffset = projectedMaxBounds.max.subtract(pxBounds.max), dx = this._rebound(minOffset.x, -maxOffset.x), dy = this._rebound(minOffset.y, -maxOffset.y);
            return new Point(dx, dy);
        },
        _rebound: function(left, right) {
            return left + right > 0 ? Math.round(left - right) / 2 : Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
        },
        _limitZoom: function(zoom) {
            var min = this.getMinZoom(), max = this.getMaxZoom(), snap = Browser.any3d ? this.options.zoomSnap : 1;
            if (snap) zoom = Math.round(zoom / snap) * snap;
            return Math.max(min, Math.min(max, zoom));
        },
        _onPanTransitionStep: function() {
            this.fire('move');
        },
        _onPanTransitionEnd: function() {
            removeClass(this._mapPane, 'leaflet-pan-anim');
            this.fire('moveend');
        },
        _tryAnimatedPan: function(center, options) {
            // difference between the new and current centers in pixels
            var offset = this._getCenterOffset(center)._trunc();
            // don't animate too far unless animate: true specified in options
            if ((options && options.animate) !== true && !this.getSize().contains(offset)) return false;
            this.panBy(offset, options);
            return true;
        },
        _createAnimProxy: function() {
            var proxy = this._proxy = create$1('div', 'leaflet-proxy leaflet-zoom-animated');
            this._panes.mapPane.appendChild(proxy);
            this.on('zoomanim', function(e) {
                var prop = TRANSFORM, transform = this._proxy.style[prop];
                setTransform(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));
                // workaround for case when transform is the same and so transitionend event is not fired
                if (transform === this._proxy.style[prop] && this._animatingZoom) this._onZoomTransitionEnd();
            }, this);
            this.on('load moveend', this._animMoveEnd, this);
            this._on('unload', this._destroyAnimProxy, this);
        },
        _destroyAnimProxy: function() {
            remove(this._proxy);
            this.off('load moveend', this._animMoveEnd, this);
            delete this._proxy;
        },
        _animMoveEnd: function() {
            var c = this.getCenter(), z = this.getZoom();
            setTransform(this._proxy, this.project(c, z), this.getZoomScale(z, 1));
        },
        _catchTransitionEnd: function(e) {
            if (this._animatingZoom && e.propertyName.indexOf('transform') >= 0) this._onZoomTransitionEnd();
        },
        _nothingToAnimate: function() {
            return !this._container.getElementsByClassName('leaflet-zoom-animated').length;
        },
        _tryAnimatedZoom: function(center, zoom, options) {
            if (this._animatingZoom) return true;
            options = options || {};
            // don't animate if disabled, not supported or zoom difference is too large
            if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() || Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) return false;
            // offset is the pixel coords of the zoom origin relative to the current center
            var scale = this.getZoomScale(zoom), offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);
            // don't animate if the zoom origin isn't within one screen from the current center, unless forced
            if (options.animate !== true && !this.getSize().contains(offset)) return false;
            requestAnimFrame(function() {
                this._moveStart(true, options.noMoveStart || false)._animateZoom(center, zoom, true);
            }, this);
            return true;
        },
        _animateZoom: function(center, zoom, startAnim, noUpdate) {
            if (!this._mapPane) return;
            if (startAnim) {
                this._animatingZoom = true;
                // remember what center/zoom to set after animation
                this._animateToCenter = center;
                this._animateToZoom = zoom;
                addClass(this._mapPane, 'leaflet-zoom-anim');
            }
            // @section Other Events
            // @event zoomanim: ZoomAnimEvent
            // Fired at least once per zoom animation. For continuous zoom, like pinch zooming, fired once per frame during zoom.
            this.fire('zoomanim', {
                center: center,
                zoom: zoom,
                noUpdate: noUpdate
            });
            if (!this._tempFireZoomEvent) this._tempFireZoomEvent = this._zoom !== this._animateToZoom;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            // Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
            setTimeout(bind(this._onZoomTransitionEnd, this), 250);
        },
        _onZoomTransitionEnd: function() {
            if (!this._animatingZoom) return;
            if (this._mapPane) removeClass(this._mapPane, 'leaflet-zoom-anim');
            this._animatingZoom = false;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            if (this._tempFireZoomEvent) this.fire('zoom');
            delete this._tempFireZoomEvent;
            this.fire('move');
            this._moveEnd(true);
        }
    });
    // @section
    // @factory L.map(id: String, options?: Map options)
    // Instantiates a map object given the DOM ID of a `<div>` element
    // and optionally an object literal with `Map options`.
    //
    // @alternative
    // @factory L.map(el: HTMLElement, options?: Map options)
    // Instantiates a map object given an instance of a `<div>` HTML element
    // and optionally an object literal with `Map options`.
    function createMap(id, options) {
        return new Map(id, options);
    }
    /*
   * @class Control
   * @aka L.Control
   * @inherits Class
   *
   * L.Control is a base class for implementing map controls. Handles positioning.
   * All other controls extend from this class.
   */ var Control = Class.extend({
        // @section
        // @aka Control Options
        options: {
            // @option position: String = 'topright'
            // The position of the control (one of the map corners). Possible values are `'topleft'`,
            // `'topright'`, `'bottomleft'` or `'bottomright'`
            position: 'topright'
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        /* @section
  	 * Classes extending L.Control will inherit the following methods:
  	 *
  	 * @method getPosition: string
  	 * Returns the position of the control.
  	 */ getPosition: function() {
            return this.options.position;
        },
        // @method setPosition(position: string): this
        // Sets the position of the control.
        setPosition: function(position) {
            var map = this._map;
            if (map) map.removeControl(this);
            this.options.position = position;
            if (map) map.addControl(this);
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTMLElement that contains the control.
        getContainer: function() {
            return this._container;
        },
        // @method addTo(map: Map): this
        // Adds the control to the given map.
        addTo: function(map) {
            this.remove();
            this._map = map;
            var container = this._container = this.onAdd(map), pos = this.getPosition(), corner = map._controlCorners[pos];
            addClass(container, 'leaflet-control');
            if (pos.indexOf('bottom') !== -1) corner.insertBefore(container, corner.firstChild);
            else corner.appendChild(container);
            this._map.on('unload', this.remove, this);
            return this;
        },
        // @method remove: this
        // Removes the control from the map it is currently active on.
        remove: function() {
            if (!this._map) return this;
            remove(this._container);
            if (this.onRemove) this.onRemove(this._map);
            this._map.off('unload', this.remove, this);
            this._map = null;
            return this;
        },
        _refocusOnMap: function(e) {
            // if map exists and event is not a keyboard event
            if (this._map && e && e.screenX > 0 && e.screenY > 0) this._map.getContainer().focus();
        }
    });
    var control = function(options) {
        return new Control(options);
    };
    /* @section Extension methods
   * @uninheritable
   *
   * Every control should extend from `L.Control` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): HTMLElement
   * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
   *
   * @method onRemove(map: Map)
   * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
   */ /* @namespace Map
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addControl(control: Control): this
        // Adds the given control to the map
        addControl: function(control) {
            control.addTo(this);
            return this;
        },
        // @method removeControl(control: Control): this
        // Removes the given control from the map
        removeControl: function(control) {
            control.remove();
            return this;
        },
        _initControlPos: function() {
            var corners = this._controlCorners = {}, l = 'leaflet-', container = this._controlContainer = create$1('div', l + 'control-container', this._container);
            function createCorner(vSide, hSide) {
                var className = l + vSide + ' ' + l + hSide;
                corners[vSide + hSide] = create$1('div', className, container);
            }
            createCorner('top', 'left');
            createCorner('top', 'right');
            createCorner('bottom', 'left');
            createCorner('bottom', 'right');
        },
        _clearControlPos: function() {
            for(var i in this._controlCorners)remove(this._controlCorners[i]);
            remove(this._controlContainer);
            delete this._controlCorners;
            delete this._controlContainer;
        }
    });
    /*
   * @class Control.Layers
   * @aka L.Control.Layers
   * @inherits Control
   *
   * The layers control gives users the ability to switch between different base layers and switch overlays on/off (check out the [detailed example](https://leafletjs.com/examples/layers-control/)). Extends `Control`.
   *
   * @example
   *
   * ```js
   * var baseLayers = {
   * 	"Mapbox": mapbox,
   * 	"OpenStreetMap": osm
   * };
   *
   * var overlays = {
   * 	"Marker": marker,
   * 	"Roads": roadsLayer
   * };
   *
   * L.control.layers(baseLayers, overlays).addTo(map);
   * ```
   *
   * The `baseLayers` and `overlays` parameters are object literals with layer names as keys and `Layer` objects as values:
   *
   * ```js
   * {
   *     "<someName1>": layer1,
   *     "<someName2>": layer2
   * }
   * ```
   *
   * The layer names can contain HTML, which allows you to add additional styling to the items:
   *
   * ```js
   * {"<img src='my-layer-icon' /> <span class='my-layer-item'>My Layer</span>": myLayer}
   * ```
   */ var Layers = Control.extend({
        // @section
        // @aka Control.Layers options
        options: {
            // @option collapsed: Boolean = true
            // If `true`, the control will be collapsed into an icon and expanded on mouse hover, touch, or keyboard activation.
            collapsed: true,
            position: 'topright',
            // @option autoZIndex: Boolean = true
            // If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
            autoZIndex: true,
            // @option hideSingleBase: Boolean = false
            // If `true`, the base layers in the control will be hidden when there is only one.
            hideSingleBase: false,
            // @option sortLayers: Boolean = false
            // Whether to sort the layers. When `false`, layers will keep the order
            // in which they were added to the control.
            sortLayers: false,
            // @option sortFunction: Function = *
            // A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
            // that will be used for sorting the layers, when `sortLayers` is `true`.
            // The function receives both the `L.Layer` instances and their names, as in
            // `sortFunction(layerA, layerB, nameA, nameB)`.
            // By default, it sorts layers alphabetically by their name.
            sortFunction: function(layerA, layerB, nameA, nameB) {
                return nameA < nameB ? -1 : nameB < nameA ? 1 : 0;
            }
        },
        initialize: function(baseLayers, overlays, options) {
            setOptions(this, options);
            this._layerControlInputs = [];
            this._layers = [];
            this._lastZIndex = 0;
            this._handlingClick = false;
            this._preventClick = false;
            for(var i in baseLayers)this._addLayer(baseLayers[i], i);
            for(i in overlays)this._addLayer(overlays[i], i, true);
        },
        onAdd: function(map) {
            this._initLayout();
            this._update();
            this._map = map;
            map.on('zoomend', this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.on('add remove', this._onLayerChange, this);
            return this._container;
        },
        addTo: function(map) {
            Control.prototype.addTo.call(this, map);
            // Trigger expand after Layers Control has been inserted into DOM so that is now has an actual height.
            return this._expandIfNotCollapsed();
        },
        onRemove: function() {
            this._map.off('zoomend', this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.off('add remove', this._onLayerChange, this);
        },
        // @method addBaseLayer(layer: Layer, name: String): this
        // Adds a base layer (radio button entry) with the given name to the control.
        addBaseLayer: function(layer, name) {
            this._addLayer(layer, name);
            return this._map ? this._update() : this;
        },
        // @method addOverlay(layer: Layer, name: String): this
        // Adds an overlay (checkbox entry) with the given name to the control.
        addOverlay: function(layer, name) {
            this._addLayer(layer, name, true);
            return this._map ? this._update() : this;
        },
        // @method removeLayer(layer: Layer): this
        // Remove the given layer from the control.
        removeLayer: function(layer) {
            layer.off('add remove', this._onLayerChange, this);
            var obj = this._getLayer(stamp(layer));
            if (obj) this._layers.splice(this._layers.indexOf(obj), 1);
            return this._map ? this._update() : this;
        },
        // @method expand(): this
        // Expand the control container if collapsed.
        expand: function() {
            addClass(this._container, 'leaflet-control-layers-expanded');
            this._section.style.height = null;
            var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
            if (acceptableHeight < this._section.clientHeight) {
                addClass(this._section, 'leaflet-control-layers-scrollbar');
                this._section.style.height = acceptableHeight + 'px';
            } else removeClass(this._section, 'leaflet-control-layers-scrollbar');
            this._checkDisabledLayers();
            return this;
        },
        // @method collapse(): this
        // Collapse the control container if expanded.
        collapse: function() {
            removeClass(this._container, 'leaflet-control-layers-expanded');
            return this;
        },
        _initLayout: function() {
            var className = 'leaflet-control-layers', container = this._container = create$1('div', className), collapsed = this.options.collapsed;
            // makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
            container.setAttribute('aria-haspopup', true);
            disableClickPropagation(container);
            disableScrollPropagation(container);
            var section = this._section = create$1('section', className + '-list');
            if (collapsed) {
                this._map.on('click', this.collapse, this);
                on(container, {
                    mouseenter: this._expandSafely,
                    mouseleave: this.collapse
                }, this);
            }
            var link = this._layersLink = create$1('a', className + '-toggle', container);
            link.href = '#';
            link.title = 'Layers';
            link.setAttribute('role', 'button');
            on(link, {
                keydown: function(e) {
                    if (e.keyCode === 13) this._expandSafely();
                },
                // Certain screen readers intercept the key event and instead send a click event
                click: function(e) {
                    preventDefault(e);
                    this._expandSafely();
                }
            }, this);
            if (!collapsed) this.expand();
            this._baseLayersList = create$1('div', className + '-base', section);
            this._separator = create$1('div', className + '-separator', section);
            this._overlaysList = create$1('div', className + '-overlays', section);
            container.appendChild(section);
        },
        _getLayer: function(id) {
            for(var i = 0; i < this._layers.length; i++){
                if (this._layers[i] && stamp(this._layers[i].layer) === id) return this._layers[i];
            }
        },
        _addLayer: function(layer, name, overlay) {
            if (this._map) layer.on('add remove', this._onLayerChange, this);
            this._layers.push({
                layer: layer,
                name: name,
                overlay: overlay
            });
            if (this.options.sortLayers) this._layers.sort(bind(function(a, b) {
                return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
            }, this));
            if (this.options.autoZIndex && layer.setZIndex) {
                this._lastZIndex++;
                layer.setZIndex(this._lastZIndex);
            }
            this._expandIfNotCollapsed();
        },
        _update: function() {
            if (!this._container) return this;
            empty(this._baseLayersList);
            empty(this._overlaysList);
            this._layerControlInputs = [];
            var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;
            for(i = 0; i < this._layers.length; i++){
                obj = this._layers[i];
                this._addItem(obj);
                overlaysPresent = overlaysPresent || obj.overlay;
                baseLayersPresent = baseLayersPresent || !obj.overlay;
                baseLayersCount += !obj.overlay ? 1 : 0;
            }
            // Hide base layers section if there's only one layer.
            if (this.options.hideSingleBase) {
                baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
                this._baseLayersList.style.display = baseLayersPresent ? '' : 'none';
            }
            this._separator.style.display = overlaysPresent && baseLayersPresent ? '' : 'none';
            return this;
        },
        _onLayerChange: function(e) {
            if (!this._handlingClick) this._update();
            var obj = this._getLayer(stamp(e.target));
            // @namespace Map
            // @section Layer events
            // @event baselayerchange: LayersControlEvent
            // Fired when the base layer is changed through the [layers control](#control-layers).
            // @event overlayadd: LayersControlEvent
            // Fired when an overlay is selected through the [layers control](#control-layers).
            // @event overlayremove: LayersControlEvent
            // Fired when an overlay is deselected through the [layers control](#control-layers).
            // @namespace Control.Layers
            var type = obj.overlay ? e.type === 'add' ? 'overlayadd' : 'overlayremove' : e.type === 'add' ? 'baselayerchange' : null;
            if (type) this._map.fire(type, obj);
        },
        // IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see https://stackoverflow.com/a/119079)
        _createRadioElement: function(name, checked) {
            var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' + name + '"' + (checked ? ' checked="checked"' : '') + '/>';
            var radioFragment = document.createElement('div');
            radioFragment.innerHTML = radioHtml;
            return radioFragment.firstChild;
        },
        _addItem: function(obj) {
            var label = document.createElement('label'), checked = this._map.hasLayer(obj.layer), input;
            if (obj.overlay) {
                input = document.createElement('input');
                input.type = 'checkbox';
                input.className = 'leaflet-control-layers-selector';
                input.defaultChecked = checked;
            } else input = this._createRadioElement('leaflet-base-layers_' + stamp(this), checked);
            this._layerControlInputs.push(input);
            input.layerId = stamp(obj.layer);
            on(input, 'click', this._onInputClick, this);
            var name = document.createElement('span');
            name.innerHTML = ' ' + obj.name;
            // Helps from preventing layer control flicker when checkboxes are disabled
            // https://github.com/Leaflet/Leaflet/issues/2771
            var holder = document.createElement('span');
            label.appendChild(holder);
            holder.appendChild(input);
            holder.appendChild(name);
            var container = obj.overlay ? this._overlaysList : this._baseLayersList;
            container.appendChild(label);
            this._checkDisabledLayers();
            return label;
        },
        _onInputClick: function() {
            // expanding the control on mobile with a click can cause adding a layer - we don't want this
            if (this._preventClick) return;
            var inputs = this._layerControlInputs, input, layer;
            var addedLayers = [], removedLayers = [];
            this._handlingClick = true;
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                if (input.checked) addedLayers.push(layer);
                else if (!input.checked) removedLayers.push(layer);
            }
            // Bugfix issue 2318: Should remove all old layers before readding new ones
            for(i = 0; i < removedLayers.length; i++)if (this._map.hasLayer(removedLayers[i])) this._map.removeLayer(removedLayers[i]);
            for(i = 0; i < addedLayers.length; i++)if (!this._map.hasLayer(addedLayers[i])) this._map.addLayer(addedLayers[i]);
            this._handlingClick = false;
            this._refocusOnMap();
        },
        _checkDisabledLayers: function() {
            var inputs = this._layerControlInputs, input, layer, zoom = this._map.getZoom();
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                input.disabled = layer.options.minZoom !== undefined && zoom < layer.options.minZoom || layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom;
            }
        },
        _expandIfNotCollapsed: function() {
            if (this._map && !this.options.collapsed) this.expand();
            return this;
        },
        _expandSafely: function() {
            var section = this._section;
            this._preventClick = true;
            on(section, 'click', preventDefault);
            this.expand();
            var that = this;
            setTimeout(function() {
                off(section, 'click', preventDefault);
                that._preventClick = false;
            });
        }
    });
    // @factory L.control.layers(baselayers?: Object, overlays?: Object, options?: Control.Layers options)
    // Creates a layers control with the given layers. Base layers will be switched with radio buttons, while overlays will be switched with checkboxes. Note that all base layers should be passed in the base layers object, but only one should be added to the map during map instantiation.
    var layers = function(baseLayers, overlays, options) {
        return new Layers(baseLayers, overlays, options);
    };
    /*
   * @class Control.Zoom
   * @aka L.Control.Zoom
   * @inherits Control
   *
   * A basic zoom control with two buttons (zoom in and zoom out). It is put on the map by default unless you set its [`zoomControl` option](#map-zoomcontrol) to `false`. Extends `Control`.
   */ var Zoom = Control.extend({
        // @section
        // @aka Control.Zoom options
        options: {
            position: 'topleft',
            // @option zoomInText: String = '<span aria-hidden="true">+</span>'
            // The text set on the 'zoom in' button.
            zoomInText: '<span aria-hidden="true">+</span>',
            // @option zoomInTitle: String = 'Zoom in'
            // The title set on the 'zoom in' button.
            zoomInTitle: 'Zoom in',
            // @option zoomOutText: String = '<span aria-hidden="true">&#x2212;</span>'
            // The text set on the 'zoom out' button.
            zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
            // @option zoomOutTitle: String = 'Zoom out'
            // The title set on the 'zoom out' button.
            zoomOutTitle: 'Zoom out'
        },
        onAdd: function(map) {
            var zoomName = 'leaflet-control-zoom', container = create$1('div', zoomName + ' leaflet-bar'), options = this.options;
            this._zoomInButton = this._createButton(options.zoomInText, options.zoomInTitle, zoomName + '-in', container, this._zoomIn);
            this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle, zoomName + '-out', container, this._zoomOut);
            this._updateDisabled();
            map.on('zoomend zoomlevelschange', this._updateDisabled, this);
            return container;
        },
        onRemove: function(map) {
            map.off('zoomend zoomlevelschange', this._updateDisabled, this);
        },
        disable: function() {
            this._disabled = true;
            this._updateDisabled();
            return this;
        },
        enable: function() {
            this._disabled = false;
            this._updateDisabled();
            return this;
        },
        _zoomIn: function(e) {
            if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _zoomOut: function(e) {
            if (!this._disabled && this._map._zoom > this._map.getMinZoom()) this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _createButton: function(html, title, className, container, fn) {
            var link = create$1('a', className, container);
            link.innerHTML = html;
            link.href = '#';
            link.title = title;
            /*
  		 * Will force screen readers like VoiceOver to read this as "Zoom in - button"
  		 */ link.setAttribute('role', 'button');
            link.setAttribute('aria-label', title);
            disableClickPropagation(link);
            on(link, 'click', stop);
            on(link, 'click', fn, this);
            on(link, 'click', this._refocusOnMap, this);
            return link;
        },
        _updateDisabled: function() {
            var map = this._map, className = 'leaflet-disabled';
            removeClass(this._zoomInButton, className);
            removeClass(this._zoomOutButton, className);
            this._zoomInButton.setAttribute('aria-disabled', 'false');
            this._zoomOutButton.setAttribute('aria-disabled', 'false');
            if (this._disabled || map._zoom === map.getMinZoom()) {
                addClass(this._zoomOutButton, className);
                this._zoomOutButton.setAttribute('aria-disabled', 'true');
            }
            if (this._disabled || map._zoom === map.getMaxZoom()) {
                addClass(this._zoomInButton, className);
                this._zoomInButton.setAttribute('aria-disabled', 'true');
            }
        }
    });
    // @namespace Map
    // @section Control options
    // @option zoomControl: Boolean = true
    // Whether a [zoom control](#control-zoom) is added to the map by default.
    Map.mergeOptions({
        zoomControl: true
    });
    Map.addInitHook(function() {
        if (this.options.zoomControl) {
            // @section Controls
            // @property zoomControl: Control.Zoom
            // The default zoom control (only available if the
            // [`zoomControl` option](#map-zoomcontrol) was `true` when creating the map).
            this.zoomControl = new Zoom();
            this.addControl(this.zoomControl);
        }
    });
    // @namespace Control.Zoom
    // @factory L.control.zoom(options: Control.Zoom options)
    // Creates a zoom control
    var zoom = function(options) {
        return new Zoom(options);
    };
    /*
   * @class Control.Scale
   * @aka L.Control.Scale
   * @inherits Control
   *
   * A simple scale control that shows the scale of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
   *
   * @example
   *
   * ```js
   * L.control.scale().addTo(map);
   * ```
   */ var Scale = Control.extend({
        // @section
        // @aka Control.Scale options
        options: {
            position: 'bottomleft',
            // @option maxWidth: Number = 100
            // Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
            maxWidth: 100,
            // @option metric: Boolean = True
            // Whether to show the metric scale line (m/km).
            metric: true,
            // @option imperial: Boolean = True
            // Whether to show the imperial scale line (mi/ft).
            imperial: true
        },
        onAdd: function(map) {
            var className = 'leaflet-control-scale', container = create$1('div', className), options = this.options;
            this._addScales(options, className + '-line', container);
            map.on(options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
            map.whenReady(this._update, this);
            return container;
        },
        onRemove: function(map) {
            map.off(this.options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
        },
        _addScales: function(options, className, container) {
            if (options.metric) this._mScale = create$1('div', className, container);
            if (options.imperial) this._iScale = create$1('div', className, container);
        },
        _update: function() {
            var map = this._map, y = map.getSize().y / 2;
            var maxMeters = map.distance(map.containerPointToLatLng([
                0,
                y
            ]), map.containerPointToLatLng([
                this.options.maxWidth,
                y
            ]));
            this._updateScales(maxMeters);
        },
        _updateScales: function(maxMeters) {
            if (this.options.metric && maxMeters) this._updateMetric(maxMeters);
            if (this.options.imperial && maxMeters) this._updateImperial(maxMeters);
        },
        _updateMetric: function(maxMeters) {
            var meters = this._getRoundNum(maxMeters), label = meters < 1000 ? meters + ' m' : meters / 1000 + ' km';
            this._updateScale(this._mScale, label, meters / maxMeters);
        },
        _updateImperial: function(maxMeters) {
            var maxFeet = maxMeters * 3.2808399, maxMiles, miles, feet;
            if (maxFeet > 5280) {
                maxMiles = maxFeet / 5280;
                miles = this._getRoundNum(maxMiles);
                this._updateScale(this._iScale, miles + ' mi', miles / maxMiles);
            } else {
                feet = this._getRoundNum(maxFeet);
                this._updateScale(this._iScale, feet + ' ft', feet / maxFeet);
            }
        },
        _updateScale: function(scale, text, ratio) {
            scale.style.width = Math.round(this.options.maxWidth * ratio) + 'px';
            scale.innerHTML = text;
        },
        _getRoundNum: function(num) {
            var pow10 = Math.pow(10, (Math.floor(num) + '').length - 1), d = num / pow10;
            d = d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : 1;
            return pow10 * d;
        }
    });
    // @factory L.control.scale(options?: Control.Scale options)
    // Creates an scale control with the given options.
    var scale = function(options) {
        return new Scale(options);
    };
    var ukrainianFlag = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="leaflet-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg>';
    /*
   * @class Control.Attribution
   * @aka L.Control.Attribution
   * @inherits Control
   *
   * The attribution control allows you to display attribution data in a small text box on a map. It is put on the map by default unless you set its [`attributionControl` option](#map-attributioncontrol) to `false`, and it fetches attribution texts from layers with the [`getAttribution` method](#layer-getattribution) automatically. Extends Control.
   */ var Attribution = Control.extend({
        // @section
        // @aka Control.Attribution options
        options: {
            position: 'bottomright',
            // @option prefix: String|false = 'Leaflet'
            // The HTML text shown before the attributions. Pass `false` to disable.
            prefix: '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">' + (Browser.inlineSvg ? ukrainianFlag + ' ' : '') + 'Leaflet</a>'
        },
        initialize: function(options) {
            setOptions(this, options);
            this._attributions = {};
        },
        onAdd: function(map) {
            map.attributionControl = this;
            this._container = create$1('div', 'leaflet-control-attribution');
            disableClickPropagation(this._container);
            // TODO ugly, refactor
            for(var i in map._layers)if (map._layers[i].getAttribution) this.addAttribution(map._layers[i].getAttribution());
            this._update();
            map.on('layeradd', this._addAttribution, this);
            return this._container;
        },
        onRemove: function(map) {
            map.off('layeradd', this._addAttribution, this);
        },
        _addAttribution: function(ev) {
            if (ev.layer.getAttribution) {
                this.addAttribution(ev.layer.getAttribution());
                ev.layer.once('remove', function() {
                    this.removeAttribution(ev.layer.getAttribution());
                }, this);
            }
        },
        // @method setPrefix(prefix: String|false): this
        // The HTML text shown before the attributions. Pass `false` to disable.
        setPrefix: function(prefix) {
            this.options.prefix = prefix;
            this._update();
            return this;
        },
        // @method addAttribution(text: String): this
        // Adds an attribution text (e.g. `'&copy; OpenStreetMap contributors'`).
        addAttribution: function(text) {
            if (!text) return this;
            if (!this._attributions[text]) this._attributions[text] = 0;
            this._attributions[text]++;
            this._update();
            return this;
        },
        // @method removeAttribution(text: String): this
        // Removes an attribution text.
        removeAttribution: function(text) {
            if (!text) return this;
            if (this._attributions[text]) {
                this._attributions[text]--;
                this._update();
            }
            return this;
        },
        _update: function() {
            if (!this._map) return;
            var attribs = [];
            for(var i in this._attributions)if (this._attributions[i]) attribs.push(i);
            var prefixAndAttribs = [];
            if (this.options.prefix) prefixAndAttribs.push(this.options.prefix);
            if (attribs.length) prefixAndAttribs.push(attribs.join(', '));
            this._container.innerHTML = prefixAndAttribs.join(' <span aria-hidden="true">|</span> ');
        }
    });
    // @namespace Map
    // @section Control options
    // @option attributionControl: Boolean = true
    // Whether a [attribution control](#control-attribution) is added to the map by default.
    Map.mergeOptions({
        attributionControl: true
    });
    Map.addInitHook(function() {
        if (this.options.attributionControl) new Attribution().addTo(this);
    });
    // @namespace Control.Attribution
    // @factory L.control.attribution(options: Control.Attribution options)
    // Creates an attribution control.
    var attribution = function(options) {
        return new Attribution(options);
    };
    Control.Layers = Layers;
    Control.Zoom = Zoom;
    Control.Scale = Scale;
    Control.Attribution = Attribution;
    control.layers = layers;
    control.zoom = zoom;
    control.scale = scale;
    control.attribution = attribution;
    /*
  	L.Handler is a base class for handler classes that are used internally to inject
  	interaction features like dragging to classes like Map and Marker.
  */ // @class Handler
    // @aka L.Handler
    // Abstract class for map interaction handlers
    var Handler = Class.extend({
        initialize: function(map) {
            this._map = map;
        },
        // @method enable(): this
        // Enables the handler
        enable: function() {
            if (this._enabled) return this;
            this._enabled = true;
            this.addHooks();
            return this;
        },
        // @method disable(): this
        // Disables the handler
        disable: function() {
            if (!this._enabled) return this;
            this._enabled = false;
            this.removeHooks();
            return this;
        },
        // @method enabled(): Boolean
        // Returns `true` if the handler is enabled
        enabled: function() {
            return !!this._enabled;
        }
    });
    // @section There is static function which can be called without instantiating L.Handler:
    // @function addTo(map: Map, name: String): this
    // Adds a new Handler to the given map with the given name.
    Handler.addTo = function(map, name) {
        map.addHandler(name, this);
        return this;
    };
    var Mixin = {
        Events: Events
    };
    /*
   * @class Draggable
   * @aka L.Draggable
   * @inherits Evented
   *
   * A class for making DOM elements draggable (including touch support).
   * Used internally for map and marker dragging. Only works for elements
   * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
   *
   * @example
   * ```js
   * var draggable = new L.Draggable(elementToDrag);
   * draggable.enable();
   * ```
   */ var START = Browser.touch ? 'touchstart mousedown' : 'mousedown';
    var Draggable = Evented.extend({
        options: {
            // @section
            // @aka Draggable options
            // @option clickTolerance: Number = 3
            // The max number of pixels a user can shift the mouse pointer during a click
            // for it to be considered a valid click (as opposed to a mouse drag).
            clickTolerance: 3
        },
        // @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
        // Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
        initialize: function(element, dragStartTarget, preventOutline, options) {
            setOptions(this, options);
            this._element = element;
            this._dragStartTarget = dragStartTarget || element;
            this._preventOutline = preventOutline;
        },
        // @method enable()
        // Enables the dragging ability
        enable: function() {
            if (this._enabled) return;
            on(this._dragStartTarget, START, this._onDown, this);
            this._enabled = true;
        },
        // @method disable()
        // Disables the dragging ability
        disable: function() {
            if (!this._enabled) return;
            // If we're currently dragging this draggable,
            // disabling it counts as first ending the drag.
            if (Draggable._dragging === this) this.finishDrag(true);
            off(this._dragStartTarget, START, this._onDown, this);
            this._enabled = false;
            this._moved = false;
        },
        _onDown: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this._moved = false;
            if (hasClass(this._element, 'leaflet-zoom-anim')) return;
            if (e.touches && e.touches.length !== 1) {
                // Finish dragging to avoid conflict with touchZoom
                if (Draggable._dragging === this) this.finishDrag();
                return;
            }
            if (Draggable._dragging || e.shiftKey || e.which !== 1 && e.button !== 1 && !e.touches) return;
            Draggable._dragging = this; // Prevent dragging multiple objects at once.
            if (this._preventOutline) preventOutline(this._element);
            disableImageDrag();
            disableTextSelection();
            if (this._moving) return;
            // @event down: Event
            // Fired when a drag is about to start.
            this.fire('down');
            var first = e.touches ? e.touches[0] : e, sizedParent = getSizedParentNode(this._element);
            this._startPoint = new Point(first.clientX, first.clientY);
            this._startPos = getPosition(this._element);
            // Cache the scale, so that we can continuously compensate for it during drag (_onMove).
            this._parentScale = getScale(sizedParent);
            var mouseevent = e.type === 'mousedown';
            on(document, mouseevent ? 'mousemove' : 'touchmove', this._onMove, this);
            on(document, mouseevent ? 'mouseup' : 'touchend touchcancel', this._onUp, this);
        },
        _onMove: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            if (e.touches && e.touches.length > 1) {
                this._moved = true;
                return;
            }
            var first = e.touches && e.touches.length === 1 ? e.touches[0] : e, offset = new Point(first.clientX, first.clientY)._subtract(this._startPoint);
            if (!offset.x && !offset.y) return;
            if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) return;
            // We assume that the parent container's position, border and scale do not change for the duration of the drag.
            // Therefore there is no need to account for the position and border (they are eliminated by the subtraction)
            // and we can use the cached value for the scale.
            offset.x /= this._parentScale.x;
            offset.y /= this._parentScale.y;
            preventDefault(e);
            if (!this._moved) {
                // @event dragstart: Event
                // Fired when a drag starts
                this.fire('dragstart');
                this._moved = true;
                addClass(document.body, 'leaflet-dragging');
                this._lastTarget = e.target || e.srcElement;
                // IE and Edge do not give the <use> element, so fetch it
                // if necessary
                if (window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance) this._lastTarget = this._lastTarget.correspondingUseElement;
                addClass(this._lastTarget, 'leaflet-drag-target');
            }
            this._newPos = this._startPos.add(offset);
            this._moving = true;
            this._lastEvent = e;
            this._updatePosition();
        },
        _updatePosition: function() {
            var e = {
                originalEvent: this._lastEvent
            };
            // @event predrag: Event
            // Fired continuously during dragging *before* each corresponding
            // update of the element's position.
            this.fire('predrag', e);
            setPosition(this._element, this._newPos);
            // @event drag: Event
            // Fired continuously during dragging.
            this.fire('drag', e);
        },
        _onUp: function() {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this.finishDrag();
        },
        finishDrag: function(noInertia) {
            removeClass(document.body, 'leaflet-dragging');
            if (this._lastTarget) {
                removeClass(this._lastTarget, 'leaflet-drag-target');
                this._lastTarget = null;
            }
            off(document, 'mousemove touchmove', this._onMove, this);
            off(document, 'mouseup touchend touchcancel', this._onUp, this);
            enableImageDrag();
            enableTextSelection();
            var fireDragend = this._moved && this._moving;
            this._moving = false;
            Draggable._dragging = false;
            if (fireDragend) // @event dragend: DragEndEvent
            // Fired when the drag ends.
            this.fire('dragend', {
                noInertia: noInertia,
                distance: this._newPos.distanceTo(this._startPos)
            });
        }
    });
    /*
   * @namespace PolyUtil
   * Various utility functions for polygon geometries.
   */ /* @function clipPolygon(points: Point[], bounds: Bounds, round?: Boolean): Point[]
   * Clips the polygon geometry defined by the given `points` by the given bounds (using the [Sutherland-Hodgman algorithm](https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm)).
   * Used by Leaflet to only show polygon points that are on the screen or near, increasing
   * performance. Note that polygon points needs different algorithm for clipping
   * than polyline, so there's a separate method for it.
   */ function clipPolygon(points, bounds, round) {
        var clippedPoints, edges = [
            1,
            4,
            2,
            8
        ], i, j, k, a, b, len, edge, p;
        for(i = 0, len = points.length; i < len; i++)points[i]._code = _getBitCode(points[i], bounds);
        // for each edge (left, bottom, right, top)
        for(k = 0; k < 4; k++){
            edge = edges[k];
            clippedPoints = [];
            for(i = 0, len = points.length, j = len - 1; i < len; j = i++){
                a = points[i];
                b = points[j];
                // if a is inside the clip window
                if (!(a._code & edge)) {
                    // if b is outside the clip window (a->b goes out of screen)
                    if (b._code & edge) {
                        p = _getEdgeIntersection(b, a, edge, bounds, round);
                        p._code = _getBitCode(p, bounds);
                        clippedPoints.push(p);
                    }
                    clippedPoints.push(a);
                // else if b is inside the clip window (a->b enters the screen)
                } else if (!(b._code & edge)) {
                    p = _getEdgeIntersection(b, a, edge, bounds, round);
                    p._code = _getBitCode(p, bounds);
                    clippedPoints.push(p);
                }
            }
            points = clippedPoints;
        }
        return points;
    }
    /* @function polygonCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polygon.
   */ function polygonCenter(latlngs, crs) {
        var i, j, p1, p2, f, area, x, y, center;
        if (!latlngs || latlngs.length === 0) throw new Error('latlngs not passed');
        if (!isFlat(latlngs)) {
            console.warn('latlngs are not flat! Only the first ring will be used');
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        area = x = y = 0;
        // polygon centroid algorithm;
        for(i = 0, j = len - 1; i < len; j = i++){
            p1 = points[i];
            p2 = points[j];
            f = p1.y * p2.x - p2.y * p1.x;
            x += (p1.x + p2.x) * f;
            y += (p1.y + p2.y) * f;
            area += f * 3;
        }
        if (area === 0) // Polygon is so small that all points are on same pixel.
        center = points[0];
        else center = [
            x / area,
            y / area
        ];
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    /* @function centroid(latlngs: LatLng[]): LatLng
   * Returns the 'center of mass' of the passed LatLngs.
   */ function centroid(coords) {
        var latSum = 0;
        var lngSum = 0;
        var len = 0;
        for(var i = 0; i < coords.length; i++){
            var latlng = toLatLng(coords[i]);
            latSum += latlng.lat;
            lngSum += latlng.lng;
            len++;
        }
        return toLatLng([
            latSum / len,
            lngSum / len
        ]);
    }
    var PolyUtil = {
        __proto__: null,
        clipPolygon: clipPolygon,
        polygonCenter: polygonCenter,
        centroid: centroid
    };
    /*
   * @namespace LineUtil
   *
   * Various utility functions for polyline points processing, used by Leaflet internally to make polylines lightning-fast.
   */ // Simplify polyline with vertex reduction and Douglas-Peucker simplification.
    // Improves rendering performance dramatically by lessening the number of points to draw.
    // @function simplify(points: Point[], tolerance: Number): Point[]
    // Dramatically reduces the number of points in a polyline while retaining
    // its shape and returns a new array of simplified points, using the
    // [Ramer-Douglas-Peucker algorithm](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm).
    // Used for a huge performance boost when processing/displaying Leaflet polylines for
    // each zoom level and also reducing visual noise. tolerance affects the amount of
    // simplification (lesser value means higher quality but slower and with more points).
    // Also released as a separated micro-library [Simplify.js](https://mourner.github.io/simplify-js/).
    function simplify(points, tolerance) {
        if (!tolerance || !points.length) return points.slice();
        var sqTolerance = tolerance * tolerance;
        // stage 1: vertex reduction
        points = _reducePoints(points, sqTolerance);
        // stage 2: Douglas-Peucker simplification
        points = _simplifyDP(points, sqTolerance);
        return points;
    }
    // @function pointToSegmentDistance(p: Point, p1: Point, p2: Point): Number
    // Returns the distance between point `p` and segment `p1` to `p2`.
    function pointToSegmentDistance(p, p1, p2) {
        return Math.sqrt(_sqClosestPointOnSegment(p, p1, p2, true));
    }
    // @function closestPointOnSegment(p: Point, p1: Point, p2: Point): Number
    // Returns the closest point from a point `p` on a segment `p1` to `p2`.
    function closestPointOnSegment(p, p1, p2) {
        return _sqClosestPointOnSegment(p, p1, p2);
    }
    // Ramer-Douglas-Peucker simplification, see https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm
    function _simplifyDP(points, sqTolerance) {
        var len = points.length, ArrayConstructor = typeof Uint8Array !== "undefined" ? Uint8Array : Array, markers = new ArrayConstructor(len);
        markers[0] = markers[len - 1] = 1;
        _simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
        var i, newPoints = [];
        for(i = 0; i < len; i++)if (markers[i]) newPoints.push(points[i]);
        return newPoints;
    }
    function _simplifyDPStep(points, markers, sqTolerance, first, last) {
        var maxSqDist = 0, index, i, sqDist;
        for(i = first + 1; i <= last - 1; i++){
            sqDist = _sqClosestPointOnSegment(points[i], points[first], points[last], true);
            if (sqDist > maxSqDist) {
                index = i;
                maxSqDist = sqDist;
            }
        }
        if (maxSqDist > sqTolerance) {
            markers[index] = 1;
            _simplifyDPStep(points, markers, sqTolerance, first, index);
            _simplifyDPStep(points, markers, sqTolerance, index, last);
        }
    }
    // reduce points that are too close to each other to a single point
    function _reducePoints(points, sqTolerance) {
        var reducedPoints = [
            points[0]
        ];
        for(var i = 1, prev = 0, len = points.length; i < len; i++)if (_sqDist(points[i], points[prev]) > sqTolerance) {
            reducedPoints.push(points[i]);
            prev = i;
        }
        if (prev < len - 1) reducedPoints.push(points[len - 1]);
        return reducedPoints;
    }
    var _lastCode;
    // @function clipSegment(a: Point, b: Point, bounds: Bounds, useLastCode?: Boolean, round?: Boolean): Point[]|Boolean
    // Clips the segment a to b by rectangular bounds with the
    // [Cohen-Sutherland algorithm](https://en.wikipedia.org/wiki/Cohen%E2%80%93Sutherland_algorithm)
    // (modifying the segment points directly!). Used by Leaflet to only show polyline
    // points that are on the screen or near, increasing performance.
    function clipSegment(a, b, bounds, useLastCode, round) {
        var codeA = useLastCode ? _lastCode : _getBitCode(a, bounds), codeB = _getBitCode(b, bounds), codeOut, p, newCode;
        // save 2nd code to avoid calculating it on the next segment
        _lastCode = codeB;
        while(true){
            // if a,b is inside the clip window (trivial accept)
            if (!(codeA | codeB)) return [
                a,
                b
            ];
            // if a,b is outside the clip window (trivial reject)
            if (codeA & codeB) return false;
            // other cases
            codeOut = codeA || codeB;
            p = _getEdgeIntersection(a, b, codeOut, bounds, round);
            newCode = _getBitCode(p, bounds);
            if (codeOut === codeA) {
                a = p;
                codeA = newCode;
            } else {
                b = p;
                codeB = newCode;
            }
        }
    }
    function _getEdgeIntersection(a, b, code, bounds, round) {
        var dx = b.x - a.x, dy = b.y - a.y, min = bounds.min, max = bounds.max, x, y;
        if (code & 8) {
            x = a.x + dx * (max.y - a.y) / dy;
            y = max.y;
        } else if (code & 4) {
            x = a.x + dx * (min.y - a.y) / dy;
            y = min.y;
        } else if (code & 2) {
            x = max.x;
            y = a.y + dy * (max.x - a.x) / dx;
        } else if (code & 1) {
            x = min.x;
            y = a.y + dy * (min.x - a.x) / dx;
        }
        return new Point(x, y, round);
    }
    function _getBitCode(p, bounds) {
        var code = 0;
        if (p.x < bounds.min.x) code |= 1;
        else if (p.x > bounds.max.x) code |= 2;
        if (p.y < bounds.min.y) code |= 4;
        else if (p.y > bounds.max.y) code |= 8;
        return code;
    }
    // square distance (to avoid unnecessary Math.sqrt calls)
    function _sqDist(p1, p2) {
        var dx = p2.x - p1.x, dy = p2.y - p1.y;
        return dx * dx + dy * dy;
    }
    // return closest point on segment or distance to that point
    function _sqClosestPointOnSegment(p, p1, p2, sqDist) {
        var x = p1.x, y = p1.y, dx = p2.x - x, dy = p2.y - y, dot = dx * dx + dy * dy, t;
        if (dot > 0) {
            t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
            if (t > 1) {
                x = p2.x;
                y = p2.y;
            } else if (t > 0) {
                x += dx * t;
                y += dy * t;
            }
        }
        dx = p.x - x;
        dy = p.y - y;
        return sqDist ? dx * dx + dy * dy : new Point(x, y);
    }
    // @function isFlat(latlngs: LatLng[]): Boolean
    // Returns true if `latlngs` is a flat array, false is nested.
    function isFlat(latlngs) {
        return !isArray(latlngs[0]) || typeof latlngs[0][0] !== 'object' && typeof latlngs[0][0] !== 'undefined';
    }
    function _flat(latlngs) {
        console.warn('Deprecated use of _flat, please use L.LineUtil.isFlat instead.');
        return isFlat(latlngs);
    }
    /* @function polylineCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polyline.
   */ function polylineCenter(latlngs, crs) {
        var i, halfDist, segDist, dist, p1, p2, ratio, center;
        if (!latlngs || latlngs.length === 0) throw new Error('latlngs not passed');
        if (!isFlat(latlngs)) {
            console.warn('latlngs are not flat! Only the first ring will be used');
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        for(i = 0, halfDist = 0; i < len - 1; i++)halfDist += points[i].distanceTo(points[i + 1]) / 2;
        // The line is so small in the current view that all points are on the same pixel.
        if (halfDist === 0) center = points[0];
        else for(i = 0, dist = 0; i < len - 1; i++){
            p1 = points[i];
            p2 = points[i + 1];
            segDist = p1.distanceTo(p2);
            dist += segDist;
            if (dist > halfDist) {
                ratio = (dist - halfDist) / segDist;
                center = [
                    p2.x - ratio * (p2.x - p1.x),
                    p2.y - ratio * (p2.y - p1.y)
                ];
                break;
            }
        }
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    var LineUtil = {
        __proto__: null,
        simplify: simplify,
        pointToSegmentDistance: pointToSegmentDistance,
        closestPointOnSegment: closestPointOnSegment,
        clipSegment: clipSegment,
        _getEdgeIntersection: _getEdgeIntersection,
        _getBitCode: _getBitCode,
        _sqClosestPointOnSegment: _sqClosestPointOnSegment,
        isFlat: isFlat,
        _flat: _flat,
        polylineCenter: polylineCenter
    };
    /*
   * @namespace Projection
   * @section
   * Leaflet comes with a set of already defined Projections out of the box:
   *
   * @projection L.Projection.LonLat
   *
   * Equirectangular, or Plate Carree projection — the most simple projection,
   * mostly used by GIS enthusiasts. Directly maps `x` as longitude, and `y` as
   * latitude. Also suitable for flat worlds, e.g. game maps. Used by the
   * `EPSG:4326` and `Simple` CRS.
   */ var LonLat = {
        project: function(latlng) {
            return new Point(latlng.lng, latlng.lat);
        },
        unproject: function(point) {
            return new LatLng(point.y, point.x);
        },
        bounds: new Bounds([
            -180,
            -90
        ], [
            180,
            90
        ])
    };
    /*
   * @namespace Projection
   * @projection L.Projection.Mercator
   *
   * Elliptical Mercator projection — more complex than Spherical Mercator. Assumes that Earth is an ellipsoid. Used by the EPSG:3395 CRS.
   */ var Mercator = {
        R: 6378137,
        R_MINOR: 6356752.314245179,
        bounds: new Bounds([
            -20037508.34279,
            -15496570.73972
        ], [
            20037508.34279,
            18764656.23138
        ]),
        project: function(latlng) {
            var d = Math.PI / 180, r = this.R, y = latlng.lat * d, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), con = e * Math.sin(y);
            var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
            y = -r * Math.log(Math.max(ts, 1E-10));
            return new Point(latlng.lng * d * r, y);
        },
        unproject: function(point) {
            var d = 180 / Math.PI, r = this.R, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), ts = Math.exp(-point.y / r), phi = Math.PI / 2 - 2 * Math.atan(ts);
            for(var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++){
                con = e * Math.sin(phi);
                con = Math.pow((1 - con) / (1 + con), e / 2);
                dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
                phi += dphi;
            }
            return new LatLng(phi * d, point.x * d / r);
        }
    };
    /*
   * @class Projection

   * An object with methods for projecting geographical coordinates of the world onto
   * a flat surface (and back). See [Map projection](https://en.wikipedia.org/wiki/Map_projection).

   * @property bounds: Bounds
   * The bounds (specified in CRS units) where the projection is valid

   * @method project(latlng: LatLng): Point
   * Projects geographical coordinates into a 2D point.
   * Only accepts actual `L.LatLng` instances, not arrays.

   * @method unproject(point: Point): LatLng
   * The inverse of `project`. Projects a 2D point into a geographical location.
   * Only accepts actual `L.Point` instances, not arrays.

   * Note that the projection instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.

   */ var index = {
        __proto__: null,
        LonLat: LonLat,
        Mercator: Mercator,
        SphericalMercator: SphericalMercator
    };
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3395
   *
   * Rarely used by some commercial tile providers. Uses Elliptical Mercator projection.
   */ var EPSG3395 = extend({}, Earth, {
        code: 'EPSG:3395',
        projection: Mercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * Mercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG4326
   *
   * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
   *
   * Leaflet 1.0.x complies with the [TMS coordinate scheme for EPSG:4326](https://wiki.osgeo.org/wiki/Tile_Map_Service_Specification#global-geodetic),
   * which is a breaking change from 0.7.x behaviour.  If you are using a `TileLayer`
   * with this CRS, ensure that there are two 256x256 pixel tiles covering the
   * whole earth at zoom level zero, and that the tile coordinate origin is (-180,+90),
   * or (-180,-90) for `TileLayer`s with [the `tms` option](#tilelayer-tms) set.
   */ var EPSG4326 = extend({}, Earth, {
        code: 'EPSG:4326',
        projection: LonLat,
        transformation: toTransformation(1 / 180, 1, -1 / 180, 0.5)
    });
    /*
   * @namespace CRS
   * @crs L.CRS.Simple
   *
   * A simple CRS that maps longitude and latitude into `x` and `y` directly.
   * May be used for maps of flat surfaces (e.g. game maps). Note that the `y`
   * axis should still be inverted (going from bottom to top). `distance()` returns
   * simple euclidean distance.
   */ var Simple = extend({}, CRS, {
        projection: LonLat,
        transformation: toTransformation(1, 0, -1, 0),
        scale: function(zoom) {
            return Math.pow(2, zoom);
        },
        zoom: function(scale) {
            return Math.log(scale) / Math.LN2;
        },
        distance: function(latlng1, latlng2) {
            var dx = latlng2.lng - latlng1.lng, dy = latlng2.lat - latlng1.lat;
            return Math.sqrt(dx * dx + dy * dy);
        },
        infinite: true
    });
    CRS.Earth = Earth;
    CRS.EPSG3395 = EPSG3395;
    CRS.EPSG3857 = EPSG3857;
    CRS.EPSG900913 = EPSG900913;
    CRS.EPSG4326 = EPSG4326;
    CRS.Simple = Simple;
    /*
   * @class Layer
   * @inherits Evented
   * @aka L.Layer
   * @aka ILayer
   *
   * A set of methods from the Layer base class that all Leaflet layers use.
   * Inherits all methods, options and events from `L.Evented`.
   *
   * @example
   *
   * ```js
   * var layer = L.marker(latlng).addTo(map);
   * layer.addTo(map);
   * layer.remove();
   * ```
   *
   * @event add: Event
   * Fired after the layer is added to a map
   *
   * @event remove: Event
   * Fired after the layer is removed from a map
   */ var Layer = Evented.extend({
        // Classes extending `L.Layer` will inherit the following options:
        options: {
            // @option pane: String = 'overlayPane'
            // By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
            pane: 'overlayPane',
            // @option attribution: String = null
            // String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
            attribution: null,
            bubblingMouseEvents: true
        },
        /* @section
  	 * Classes extending `L.Layer` will inherit the following methods:
  	 *
  	 * @method addTo(map: Map|LayerGroup): this
  	 * Adds the layer to the given map or layer group.
  	 */ addTo: function(map) {
            map.addLayer(this);
            return this;
        },
        // @method remove: this
        // Removes the layer from the map it is currently active on.
        remove: function() {
            return this.removeFrom(this._map || this._mapToAdd);
        },
        // @method removeFrom(map: Map): this
        // Removes the layer from the given map
        //
        // @alternative
        // @method removeFrom(group: LayerGroup): this
        // Removes the layer from the given `LayerGroup`
        removeFrom: function(obj) {
            if (obj) obj.removeLayer(this);
            return this;
        },
        // @method getPane(name? : String): HTMLElement
        // Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
        getPane: function(name) {
            return this._map.getPane(name ? this.options[name] || name : this.options.pane);
        },
        addInteractiveTarget: function(targetEl) {
            this._map._targets[stamp(targetEl)] = this;
            return this;
        },
        removeInteractiveTarget: function(targetEl) {
            delete this._map._targets[stamp(targetEl)];
            return this;
        },
        // @method getAttribution: String
        // Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
        getAttribution: function() {
            return this.options.attribution;
        },
        _layerAdd: function(e) {
            var map = e.target;
            // check in case layer gets added and then removed before the map is ready
            if (!map.hasLayer(this)) return;
            this._map = map;
            this._zoomAnimated = map._zoomAnimated;
            if (this.getEvents) {
                var events = this.getEvents();
                map.on(events, this);
                this.once('remove', function() {
                    map.off(events, this);
                }, this);
            }
            this.onAdd(map);
            this.fire('add');
            map.fire('layeradd', {
                layer: this
            });
        }
    });
    /* @section Extension methods
   * @uninheritable
   *
   * Every layer should extend from `L.Layer` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): this
   * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
   *
   * @method onRemove(map: Map): this
   * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
   *
   * @method getEvents(): Object
   * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
   *
   * @method getAttribution(): String
   * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
   *
   * @method beforeAdd(map: Map): this
   * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
   */ /* @namespace Map
   * @section Layer events
   *
   * @event layeradd: LayerEvent
   * Fired when a new layer is added to the map.
   *
   * @event layerremove: LayerEvent
   * Fired when some layer is removed from the map
   *
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the map
        addLayer: function(layer) {
            if (!layer._layerAdd) throw new Error('The provided object is not a Layer.');
            var id = stamp(layer);
            if (this._layers[id]) return this;
            this._layers[id] = layer;
            layer._mapToAdd = this;
            if (layer.beforeAdd) layer.beforeAdd(this);
            this.whenReady(layer._layerAdd, layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the map.
        removeLayer: function(layer) {
            var id = stamp(layer);
            if (!this._layers[id]) return this;
            if (this._loaded) layer.onRemove(this);
            delete this._layers[id];
            if (this._loaded) {
                this.fire('layerremove', {
                    layer: layer
                });
                layer.fire('remove');
            }
            layer._map = layer._mapToAdd = null;
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the map
        hasLayer: function(layer) {
            return stamp(layer) in this._layers;
        },
        /* @method eachLayer(fn: Function, context?: Object): this
  	 * Iterates over the layers of the map, optionally specifying context of the iterator function.
  	 * ```
  	 * map.eachLayer(function(layer){
  	 *     layer.bindPopup('Hello');
  	 * });
  	 * ```
  	 */ eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        _addLayers: function(layers) {
            layers = layers ? isArray(layers) ? layers : [
                layers
            ] : [];
            for(var i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        _addZoomLimit: function(layer) {
            if (!isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
                this._zoomBoundLayers[stamp(layer)] = layer;
                this._updateZoomLevels();
            }
        },
        _removeZoomLimit: function(layer) {
            var id = stamp(layer);
            if (this._zoomBoundLayers[id]) {
                delete this._zoomBoundLayers[id];
                this._updateZoomLevels();
            }
        },
        _updateZoomLevels: function() {
            var minZoom = Infinity, maxZoom = -Infinity, oldZoomSpan = this._getZoomSpan();
            for(var i in this._zoomBoundLayers){
                var options = this._zoomBoundLayers[i].options;
                minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
                maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
            }
            this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
            this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;
            // @section Map state change events
            // @event zoomlevelschange: Event
            // Fired when the number of zoomlevels on the map is changed due
            // to adding or removing a layer.
            if (oldZoomSpan !== this._getZoomSpan()) this.fire('zoomlevelschange');
            if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) this.setZoom(this._layersMaxZoom);
            if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) this.setZoom(this._layersMinZoom);
        }
    });
    /*
   * @class LayerGroup
   * @aka L.LayerGroup
   * @inherits Interactive layer
   *
   * Used to group several layers and handle them as one. If you add it to the map,
   * any layers added or removed from the group will be added/removed on the map as
   * well. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.layerGroup([marker1, marker2])
   * 	.addLayer(polyline)
   * 	.addTo(map);
   * ```
   */ var LayerGroup = Layer.extend({
        initialize: function(layers, options) {
            setOptions(this, options);
            this._layers = {};
            var i, len;
            if (layers) for(i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the group.
        addLayer: function(layer) {
            var id = this.getLayerId(layer);
            this._layers[id] = layer;
            if (this._map) this._map.addLayer(layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the group.
        // @alternative
        // @method removeLayer(id: Number): this
        // Removes the layer with the given internal ID from the group.
        removeLayer: function(layer) {
            var id = layer in this._layers ? layer : this.getLayerId(layer);
            if (this._map && this._layers[id]) this._map.removeLayer(this._layers[id]);
            delete this._layers[id];
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the group.
        // @alternative
        // @method hasLayer(id: Number): Boolean
        // Returns `true` if the given internal ID is currently added to the group.
        hasLayer: function(layer) {
            var layerId = typeof layer === 'number' ? layer : this.getLayerId(layer);
            return layerId in this._layers;
        },
        // @method clearLayers(): this
        // Removes all the layers from the group.
        clearLayers: function() {
            return this.eachLayer(this.removeLayer, this);
        },
        // @method invoke(methodName: String, …): this
        // Calls `methodName` on every layer contained in this group, passing any
        // additional parameters. Has no effect if the layers contained do not
        // implement `methodName`.
        invoke: function(methodName) {
            var args = Array.prototype.slice.call(arguments, 1), i, layer;
            for(i in this._layers){
                layer = this._layers[i];
                if (layer[methodName]) layer[methodName].apply(layer, args);
            }
            return this;
        },
        onAdd: function(map) {
            this.eachLayer(map.addLayer, map);
        },
        onRemove: function(map) {
            this.eachLayer(map.removeLayer, map);
        },
        // @method eachLayer(fn: Function, context?: Object): this
        // Iterates over the layers of the group, optionally specifying context of the iterator function.
        // ```js
        // group.eachLayer(function (layer) {
        // 	layer.bindPopup('Hello');
        // });
        // ```
        eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        // @method getLayer(id: Number): Layer
        // Returns the layer with the given internal ID.
        getLayer: function(id) {
            return this._layers[id];
        },
        // @method getLayers(): Layer[]
        // Returns an array of all the layers added to the group.
        getLayers: function() {
            var layers = [];
            this.eachLayer(layers.push, layers);
            return layers;
        },
        // @method setZIndex(zIndex: Number): this
        // Calls `setZIndex` on every layer contained in this group, passing the z-index.
        setZIndex: function(zIndex) {
            return this.invoke('setZIndex', zIndex);
        },
        // @method getLayerId(layer: Layer): Number
        // Returns the internal ID for a layer
        getLayerId: function(layer) {
            return stamp(layer);
        }
    });
    // @factory L.layerGroup(layers?: Layer[], options?: Object)
    // Create a layer group, optionally given an initial set of layers and an `options` object.
    var layerGroup = function(layers, options) {
        return new LayerGroup(layers, options);
    };
    /*
   * @class FeatureGroup
   * @aka L.FeatureGroup
   * @inherits LayerGroup
   *
   * Extended `LayerGroup` that makes it easier to do the same thing to all its member layers:
   *  * [`bindPopup`](#layer-bindpopup) binds a popup to all of the layers at once (likewise with [`bindTooltip`](#layer-bindtooltip))
   *  * Events are propagated to the `FeatureGroup`, so if the group has an event
   * handler, it will handle events from any of the layers. This includes mouse events
   * and custom events.
   *  * Has `layeradd` and `layerremove` events
   *
   * @example
   *
   * ```js
   * L.featureGroup([marker1, marker2, polyline])
   * 	.bindPopup('Hello world!')
   * 	.on('click', function() { alert('Clicked on a member of the group!'); })
   * 	.addTo(map);
   * ```
   */ var FeatureGroup = LayerGroup.extend({
        addLayer: function(layer) {
            if (this.hasLayer(layer)) return this;
            layer.addEventParent(this);
            LayerGroup.prototype.addLayer.call(this, layer);
            // @event layeradd: LayerEvent
            // Fired when a layer is added to this `FeatureGroup`
            return this.fire('layeradd', {
                layer: layer
            });
        },
        removeLayer: function(layer) {
            if (!this.hasLayer(layer)) return this;
            if (layer in this._layers) layer = this._layers[layer];
            layer.removeEventParent(this);
            LayerGroup.prototype.removeLayer.call(this, layer);
            // @event layerremove: LayerEvent
            // Fired when a layer is removed from this `FeatureGroup`
            return this.fire('layerremove', {
                layer: layer
            });
        },
        // @method setStyle(style: Path options): this
        // Sets the given path options to each layer of the group that has a `setStyle` method.
        setStyle: function(style) {
            return this.invoke('setStyle', style);
        },
        // @method bringToFront(): this
        // Brings the layer group to the top of all other layers
        bringToFront: function() {
            return this.invoke('bringToFront');
        },
        // @method bringToBack(): this
        // Brings the layer group to the back of all other layers
        bringToBack: function() {
            return this.invoke('bringToBack');
        },
        // @method getBounds(): LatLngBounds
        // Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
        getBounds: function() {
            var bounds = new LatLngBounds();
            for(var id in this._layers){
                var layer = this._layers[id];
                bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
            }
            return bounds;
        }
    });
    // @factory L.featureGroup(layers?: Layer[], options?: Object)
    // Create a feature group, optionally given an initial set of layers and an `options` object.
    var featureGroup = function(layers, options) {
        return new FeatureGroup(layers, options);
    };
    /*
   * @class Icon
   * @aka L.Icon
   *
   * Represents an icon to provide when creating a marker.
   *
   * @example
   *
   * ```js
   * var myIcon = L.icon({
   *     iconUrl: 'my-icon.png',
   *     iconRetinaUrl: 'my-icon@2x.png',
   *     iconSize: [38, 95],
   *     iconAnchor: [22, 94],
   *     popupAnchor: [-3, -76],
   *     shadowUrl: 'my-icon-shadow.png',
   *     shadowRetinaUrl: 'my-icon-shadow@2x.png',
   *     shadowSize: [68, 95],
   *     shadowAnchor: [22, 94]
   * });
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * `L.Icon.Default` extends `L.Icon` and is the blue icon Leaflet uses for markers by default.
   *
   */ var Icon = Class.extend({
        /* @section
  	 * @aka Icon options
  	 *
  	 * @option iconUrl: String = null
  	 * **(required)** The URL to the icon image (absolute or relative to your script path).
  	 *
  	 * @option iconRetinaUrl: String = null
  	 * The URL to a retina sized version of the icon image (absolute or relative to your
  	 * script path). Used for Retina screen devices.
  	 *
  	 * @option iconSize: Point = null
  	 * Size of the icon image in pixels.
  	 *
  	 * @option iconAnchor: Point = null
  	 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
  	 * will be aligned so that this point is at the marker's geographical location. Centered
  	 * by default if size is specified, also can be set in CSS with negative margins.
  	 *
  	 * @option popupAnchor: Point = [0, 0]
  	 * The coordinates of the point from which popups will "open", relative to the icon anchor.
  	 *
  	 * @option tooltipAnchor: Point = [0, 0]
  	 * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
  	 *
  	 * @option shadowUrl: String = null
  	 * The URL to the icon shadow image. If not specified, no shadow image will be created.
  	 *
  	 * @option shadowRetinaUrl: String = null
  	 *
  	 * @option shadowSize: Point = null
  	 * Size of the shadow image in pixels.
  	 *
  	 * @option shadowAnchor: Point = null
  	 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
  	 * as iconAnchor if not specified).
  	 *
  	 * @option className: String = ''
  	 * A custom class name to assign to both icon and shadow images. Empty by default.
  	 */ options: {
            popupAnchor: [
                0,
                0
            ],
            tooltipAnchor: [
                0,
                0
            ],
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        // @method createIcon(oldIcon?: HTMLElement): HTMLElement
        // Called internally when the icon has to be shown, returns a `<img>` HTML element
        // styled according to the options.
        createIcon: function(oldIcon) {
            return this._createIcon('icon', oldIcon);
        },
        // @method createShadow(oldIcon?: HTMLElement): HTMLElement
        // As `createIcon`, but for the shadow beneath it.
        createShadow: function(oldIcon) {
            return this._createIcon('shadow', oldIcon);
        },
        _createIcon: function(name, oldIcon) {
            var src = this._getIconUrl(name);
            if (!src) {
                if (name === 'icon') throw new Error('iconUrl not set in Icon options (see the docs).');
                return null;
            }
            var img = this._createImg(src, oldIcon && oldIcon.tagName === 'IMG' ? oldIcon : null);
            this._setIconStyles(img, name);
            if (this.options.crossOrigin || this.options.crossOrigin === '') img.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            return img;
        },
        _setIconStyles: function(img, name) {
            var options = this.options;
            var sizeOption = options[name + 'Size'];
            if (typeof sizeOption === 'number') sizeOption = [
                sizeOption,
                sizeOption
            ];
            var size = toPoint(sizeOption), anchor = toPoint(name === 'shadow' && options.shadowAnchor || options.iconAnchor || size && size.divideBy(2, true));
            img.className = 'leaflet-marker-' + name + ' ' + (options.className || '');
            if (anchor) {
                img.style.marginLeft = -anchor.x + 'px';
                img.style.marginTop = -anchor.y + 'px';
            }
            if (size) {
                img.style.width = size.x + 'px';
                img.style.height = size.y + 'px';
            }
        },
        _createImg: function(src, el) {
            el = el || document.createElement('img');
            el.src = src;
            return el;
        },
        _getIconUrl: function(name) {
            return Browser.retina && this.options[name + 'RetinaUrl'] || this.options[name + 'Url'];
        }
    });
    // @factory L.icon(options: Icon options)
    // Creates an icon instance with the given options.
    function icon(options) {
        return new Icon(options);
    }
    /*
   * @miniclass Icon.Default (Icon)
   * @aka L.Icon.Default
   * @section
   *
   * A trivial subclass of `Icon`, represents the icon to use in `Marker`s when
   * no icon is specified. Points to the blue marker image distributed with Leaflet
   * releases.
   *
   * In order to customize the default icon, just change the properties of `L.Icon.Default.prototype.options`
   * (which is a set of `Icon options`).
   *
   * If you want to _completely_ replace the default icon, override the
   * `L.Marker.prototype.options.icon` with your own icon instead.
   */ var IconDefault = Icon.extend({
        options: {
            iconUrl: 'marker-icon.png',
            iconRetinaUrl: 'marker-icon-2x.png',
            shadowUrl: 'marker-shadow.png',
            iconSize: [
                25,
                41
            ],
            iconAnchor: [
                12,
                41
            ],
            popupAnchor: [
                1,
                -34
            ],
            tooltipAnchor: [
                16,
                -28
            ],
            shadowSize: [
                41,
                41
            ]
        },
        _getIconUrl: function(name) {
            if (typeof IconDefault.imagePath !== 'string') IconDefault.imagePath = this._detectIconPath();
            // @option imagePath: String
            // `Icon.Default` will try to auto-detect the location of the
            // blue icon images. If you are placing these images in a non-standard
            // way, set this option to point to the right path.
            return (this.options.imagePath || IconDefault.imagePath) + Icon.prototype._getIconUrl.call(this, name);
        },
        _stripUrl: function(path) {
            var strip = function(str, re, idx) {
                var match = re.exec(str);
                return match && match[idx];
            };
            path = strip(path, /^url\((['"])?(.+)\1\)$/, 2);
            return path && strip(path, /^(.*)marker-icon\.png$/, 1);
        },
        _detectIconPath: function() {
            var el = create$1('div', 'leaflet-default-icon-path', document.body);
            var path = getStyle(el, 'background-image') || getStyle(el, 'backgroundImage'); // IE8
            document.body.removeChild(el);
            path = this._stripUrl(path);
            if (path) return path;
            var link = document.querySelector('link[href$="leaflet.css"]');
            if (!link) return '';
            return link.href.substring(0, link.href.length - 11 - 1);
        }
    });
    /*
   * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
   */ /* @namespace Marker
   * @section Interaction handlers
   *
   * Interaction handlers are properties of a marker instance that allow you to control interaction behavior in runtime, enabling or disabling certain features such as dragging (see `Handler` methods). Example:
   *
   * ```js
   * marker.dragging.disable();
   * ```
   *
   * @property dragging: Handler
   * Marker dragging handler (by both mouse and touch). Only valid when the marker is on the map (Otherwise set [`marker.options.draggable`](#marker-draggable)).
   */ var MarkerDrag = Handler.extend({
        initialize: function(marker) {
            this._marker = marker;
        },
        addHooks: function() {
            var icon = this._marker._icon;
            if (!this._draggable) this._draggable = new Draggable(icon, icon, true);
            this._draggable.on({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).enable();
            addClass(icon, 'leaflet-marker-draggable');
        },
        removeHooks: function() {
            this._draggable.off({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).disable();
            if (this._marker._icon) removeClass(this._marker._icon, 'leaflet-marker-draggable');
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        _adjustPan: function(e) {
            var marker = this._marker, map = marker._map, speed = this._marker.options.autoPanSpeed, padding = this._marker.options.autoPanPadding, iconPos = getPosition(marker._icon), bounds = map.getPixelBounds(), origin = map.getPixelOrigin();
            var panBounds = toBounds(bounds.min._subtract(origin).add(padding), bounds.max._subtract(origin).subtract(padding));
            if (!panBounds.contains(iconPos)) {
                // Compute incremental movement
                var movement = toPoint((Math.max(panBounds.max.x, iconPos.x) - panBounds.max.x) / (bounds.max.x - panBounds.max.x) - (Math.min(panBounds.min.x, iconPos.x) - panBounds.min.x) / (bounds.min.x - panBounds.min.x), (Math.max(panBounds.max.y, iconPos.y) - panBounds.max.y) / (bounds.max.y - panBounds.max.y) - (Math.min(panBounds.min.y, iconPos.y) - panBounds.min.y) / (bounds.min.y - panBounds.min.y)).multiplyBy(speed);
                map.panBy(movement, {
                    animate: false
                });
                this._draggable._newPos._add(movement);
                this._draggable._startPos._add(movement);
                setPosition(marker._icon, this._draggable._newPos);
                this._onDrag(e);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDragStart: function() {
            // @section Dragging events
            // @event dragstart: Event
            // Fired when the user starts dragging the marker.
            // @event movestart: Event
            // Fired when the marker starts moving (because of dragging).
            this._oldLatLng = this._marker.getLatLng();
            // When using ES6 imports it could not be set when `Popup` was not imported as well
            this._marker.closePopup && this._marker.closePopup();
            this._marker.fire('movestart').fire('dragstart');
        },
        _onPreDrag: function(e) {
            if (this._marker.options.autoPan) {
                cancelAnimFrame(this._panRequest);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDrag: function(e) {
            var marker = this._marker, shadow = marker._shadow, iconPos = getPosition(marker._icon), latlng = marker._map.layerPointToLatLng(iconPos);
            // update shadow position
            if (shadow) setPosition(shadow, iconPos);
            marker._latlng = latlng;
            e.latlng = latlng;
            e.oldLatLng = this._oldLatLng;
            // @event drag: Event
            // Fired repeatedly while the user drags the marker.
            marker.fire('move', e).fire('drag', e);
        },
        _onDragEnd: function(e) {
            // @event dragend: DragEndEvent
            // Fired when the user stops dragging the marker.
            cancelAnimFrame(this._panRequest);
            // @event moveend: Event
            // Fired when the marker stops moving (because of dragging).
            delete this._oldLatLng;
            this._marker.fire('moveend').fire('dragend', e);
        }
    });
    /*
   * @class Marker
   * @inherits Interactive layer
   * @aka L.Marker
   * L.Marker is used to display clickable/draggable icons on the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.marker([50.5, 30.5]).addTo(map);
   * ```
   */ var Marker = Layer.extend({
        // @section
        // @aka Marker options
        options: {
            // @option icon: Icon = *
            // Icon instance to use for rendering the marker.
            // See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
            // If not specified, a common instance of `L.Icon.Default` is used.
            icon: new IconDefault(),
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option keyboard: Boolean = true
            // Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
            keyboard: true,
            // @option title: String = ''
            // Text for the browser tooltip that appear on marker hover (no tooltip by default).
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            title: '',
            // @option alt: String = 'Marker'
            // Text for the `alt` attribute of the icon image.
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            alt: 'Marker',
            // @option zIndexOffset: Number = 0
            // By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
            zIndexOffset: 0,
            // @option opacity: Number = 1.0
            // The opacity of the marker.
            opacity: 1,
            // @option riseOnHover: Boolean = false
            // If `true`, the marker will get on top of others when you hover the mouse over it.
            riseOnHover: false,
            // @option riseOffset: Number = 250
            // The z-index offset used for the `riseOnHover` feature.
            riseOffset: 250,
            // @option pane: String = 'markerPane'
            // `Map pane` where the markers icon will be added.
            pane: 'markerPane',
            // @option shadowPane: String = 'shadowPane'
            // `Map pane` where the markers shadow will be added.
            shadowPane: 'shadowPane',
            // @option bubblingMouseEvents: Boolean = false
            // When `true`, a mouse event on this marker will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: false,
            // @option autoPanOnFocus: Boolean = true
            // When `true`, the map will pan whenever the marker is focused (via
            // e.g. pressing `tab` on the keyboard) to ensure the marker is
            // visible within the map's bounds
            autoPanOnFocus: true,
            // @section Draggable marker options
            // @option draggable: Boolean = false
            // Whether the marker is draggable with mouse/touch or not.
            draggable: false,
            // @option autoPan: Boolean = false
            // Whether to pan the map when dragging this marker near its edge or not.
            autoPan: false,
            // @option autoPanPadding: Point = Point(50, 50)
            // Distance (in pixels to the left/right and to the top/bottom) of the
            // map edge to start panning the map.
            autoPanPadding: [
                50,
                50
            ],
            // @option autoPanSpeed: Number = 10
            // Number of pixels the map should pan by.
            autoPanSpeed: 10
        },
        /* @section
  	 *
  	 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
  	 */ initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
        },
        onAdd: function(map) {
            this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;
            if (this._zoomAnimated) map.on('zoomanim', this._animateZoom, this);
            this._initIcon();
            this.update();
        },
        onRemove: function(map) {
            if (this.dragging && this.dragging.enabled()) {
                this.options.draggable = true;
                this.dragging.removeHooks();
            }
            delete this.dragging;
            if (this._zoomAnimated) map.off('zoomanim', this._animateZoom, this);
            this._removeIcon();
            this._removeShadow();
        },
        getEvents: function() {
            return {
                zoom: this.update,
                viewreset: this.update
            };
        },
        // @method getLatLng: LatLng
        // Returns the current geographical position of the marker.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Changes the marker position to the given point.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.update();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire('move', {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method setZIndexOffset(offset: Number): this
        // Changes the [zIndex offset](#marker-zindexoffset) of the marker.
        setZIndexOffset: function(offset) {
            this.options.zIndexOffset = offset;
            return this.update();
        },
        // @method getIcon: Icon
        // Returns the current icon used by the marker
        getIcon: function() {
            return this.options.icon;
        },
        // @method setIcon(icon: Icon): this
        // Changes the marker icon.
        setIcon: function(icon) {
            this.options.icon = icon;
            if (this._map) {
                this._initIcon();
                this.update();
            }
            if (this._popup) this.bindPopup(this._popup, this._popup.options);
            return this;
        },
        getElement: function() {
            return this._icon;
        },
        update: function() {
            if (this._icon && this._map) {
                var pos = this._map.latLngToLayerPoint(this._latlng).round();
                this._setPos(pos);
            }
            return this;
        },
        _initIcon: function() {
            var options = this.options, classToAdd = 'leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
            var icon = options.icon.createIcon(this._icon), addIcon = false;
            // if we're not reusing the icon, remove the old one and init new one
            if (icon !== this._icon) {
                if (this._icon) this._removeIcon();
                addIcon = true;
                if (options.title) icon.title = options.title;
                if (icon.tagName === 'IMG') icon.alt = options.alt || '';
            }
            addClass(icon, classToAdd);
            if (options.keyboard) {
                icon.tabIndex = '0';
                icon.setAttribute('role', 'button');
            }
            this._icon = icon;
            if (options.riseOnHover) this.on({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) on(icon, 'focus', this._panOnFocus, this);
            var newShadow = options.icon.createShadow(this._shadow), addShadow = false;
            if (newShadow !== this._shadow) {
                this._removeShadow();
                addShadow = true;
            }
            if (newShadow) {
                addClass(newShadow, classToAdd);
                newShadow.alt = '';
            }
            this._shadow = newShadow;
            if (options.opacity < 1) this._updateOpacity();
            if (addIcon) this.getPane().appendChild(this._icon);
            this._initInteraction();
            if (newShadow && addShadow) this.getPane(options.shadowPane).appendChild(this._shadow);
        },
        _removeIcon: function() {
            if (this.options.riseOnHover) this.off({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) off(this._icon, 'focus', this._panOnFocus, this);
            remove(this._icon);
            this.removeInteractiveTarget(this._icon);
            this._icon = null;
        },
        _removeShadow: function() {
            if (this._shadow) remove(this._shadow);
            this._shadow = null;
        },
        _setPos: function(pos) {
            if (this._icon) setPosition(this._icon, pos);
            if (this._shadow) setPosition(this._shadow, pos);
            this._zIndex = pos.y + this.options.zIndexOffset;
            this._resetZIndex();
        },
        _updateZIndex: function(offset) {
            if (this._icon) this._icon.style.zIndex = this._zIndex + offset;
        },
        _animateZoom: function(opt) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
            this._setPos(pos);
        },
        _initInteraction: function() {
            if (!this.options.interactive) return;
            addClass(this._icon, 'leaflet-interactive');
            this.addInteractiveTarget(this._icon);
            if (MarkerDrag) {
                var draggable = this.options.draggable;
                if (this.dragging) {
                    draggable = this.dragging.enabled();
                    this.dragging.disable();
                }
                this.dragging = new MarkerDrag(this);
                if (draggable) this.dragging.enable();
            }
        },
        // @method setOpacity(opacity: Number): this
        // Changes the opacity of the marker.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._map) this._updateOpacity();
            return this;
        },
        _updateOpacity: function() {
            var opacity = this.options.opacity;
            if (this._icon) setOpacity(this._icon, opacity);
            if (this._shadow) setOpacity(this._shadow, opacity);
        },
        _bringToFront: function() {
            this._updateZIndex(this.options.riseOffset);
        },
        _resetZIndex: function() {
            this._updateZIndex(0);
        },
        _panOnFocus: function() {
            var map = this._map;
            if (!map) return;
            var iconOpts = this.options.icon.options;
            var size = iconOpts.iconSize ? toPoint(iconOpts.iconSize) : toPoint(0, 0);
            var anchor = iconOpts.iconAnchor ? toPoint(iconOpts.iconAnchor) : toPoint(0, 0);
            map.panInside(this._latlng, {
                paddingTopLeft: anchor,
                paddingBottomRight: size.subtract(anchor)
            });
        },
        _getPopupAnchor: function() {
            return this.options.icon.options.popupAnchor;
        },
        _getTooltipAnchor: function() {
            return this.options.icon.options.tooltipAnchor;
        }
    });
    // factory L.marker(latlng: LatLng, options? : Marker options)
    // @factory L.marker(latlng: LatLng, options? : Marker options)
    // Instantiates a Marker object given a geographical point and optionally an options object.
    function marker(latlng, options) {
        return new Marker(latlng, options);
    }
    /*
   * @class Path
   * @aka L.Path
   * @inherits Interactive layer
   *
   * An abstract class that contains options and constants shared between vector
   * overlays (Polygon, Polyline, Circle). Do not use it directly. Extends `Layer`.
   */ var Path = Layer.extend({
        // @section
        // @aka Path options
        options: {
            // @option stroke: Boolean = true
            // Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
            stroke: true,
            // @option color: String = '#3388ff'
            // Stroke color
            color: '#3388ff',
            // @option weight: Number = 3
            // Stroke width in pixels
            weight: 3,
            // @option opacity: Number = 1.0
            // Stroke opacity
            opacity: 1,
            // @option lineCap: String= 'round'
            // A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
            lineCap: 'round',
            // @option lineJoin: String = 'round'
            // A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
            lineJoin: 'round',
            // @option dashArray: String = null
            // A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashArray: null,
            // @option dashOffset: String = null
            // A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashOffset: null,
            // @option fill: Boolean = depends
            // Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
            fill: false,
            // @option fillColor: String = *
            // Fill color. Defaults to the value of the [`color`](#path-color) option
            fillColor: null,
            // @option fillOpacity: Number = 0.2
            // Fill opacity.
            fillOpacity: 0.2,
            // @option fillRule: String = 'evenodd'
            // A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
            fillRule: 'evenodd',
            // className: '',
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option bubblingMouseEvents: Boolean = true
            // When `true`, a mouse event on this path will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: true
        },
        beforeAdd: function(map) {
            // Renderer is set here because we need to call renderer.getEvents
            // before this.getEvents.
            this._renderer = map.getRenderer(this);
        },
        onAdd: function() {
            this._renderer._initPath(this);
            this._reset();
            this._renderer._addPath(this);
        },
        onRemove: function() {
            this._renderer._removePath(this);
        },
        // @method redraw(): this
        // Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
        redraw: function() {
            if (this._map) this._renderer._updatePath(this);
            return this;
        },
        // @method setStyle(style: Path options): this
        // Changes the appearance of a Path based on the options in the `Path options` object.
        setStyle: function(style) {
            setOptions(this, style);
            if (this._renderer) {
                this._renderer._updateStyle(this);
                if (this.options.stroke && style && Object.prototype.hasOwnProperty.call(style, 'weight')) this._updateBounds();
            }
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all path layers.
        bringToFront: function() {
            if (this._renderer) this._renderer._bringToFront(this);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all path layers.
        bringToBack: function() {
            if (this._renderer) this._renderer._bringToBack(this);
            return this;
        },
        getElement: function() {
            return this._path;
        },
        _reset: function() {
            // defined in child classes
            this._project();
            this._update();
        },
        _clickTolerance: function() {
            // used when doing hit detection for Canvas layers
            return (this.options.stroke ? this.options.weight / 2 : 0) + (this._renderer.options.tolerance || 0);
        }
    });
    /*
   * @class CircleMarker
   * @aka L.CircleMarker
   * @inherits Path
   *
   * A circle of a fixed size with radius specified in pixels. Extends `Path`.
   */ var CircleMarker = Path.extend({
        // @section
        // @aka CircleMarker options
        options: {
            fill: true,
            // @option radius: Number = 10
            // Radius of the circle marker, in pixels
            radius: 10
        },
        initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            this._radius = this.options.radius;
        },
        // @method setLatLng(latLng: LatLng): this
        // Sets the position of a circle marker to a new location.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.redraw();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#circlemarker-setlatlng). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire('move', {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method getLatLng(): LatLng
        // Returns the current geographical position of the circle marker
        getLatLng: function() {
            return this._latlng;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle marker. Units are in pixels.
        setRadius: function(radius) {
            this.options.radius = this._radius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of the circle
        getRadius: function() {
            return this._radius;
        },
        setStyle: function(options) {
            var radius = options && options.radius || this._radius;
            Path.prototype.setStyle.call(this, options);
            this.setRadius(radius);
            return this;
        },
        _project: function() {
            this._point = this._map.latLngToLayerPoint(this._latlng);
            this._updateBounds();
        },
        _updateBounds: function() {
            var r = this._radius, r2 = this._radiusY || r, w = this._clickTolerance(), p = [
                r + w,
                r2 + w
            ];
            this._pxBounds = new Bounds(this._point.subtract(p), this._point.add(p));
        },
        _update: function() {
            if (this._map) this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updateCircle(this);
        },
        _empty: function() {
            return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
        }
    });
    // @factory L.circleMarker(latlng: LatLng, options?: CircleMarker options)
    // Instantiates a circle marker object given a geographical point, and an optional options object.
    function circleMarker(latlng, options) {
        return new CircleMarker(latlng, options);
    }
    /*
   * @class Circle
   * @aka L.Circle
   * @inherits CircleMarker
   *
   * A class for drawing circle overlays on a map. Extends `CircleMarker`.
   *
   * It's an approximation and starts to diverge from a real circle closer to poles (due to projection distortion).
   *
   * @example
   *
   * ```js
   * L.circle([50.5, 30.5], {radius: 200}).addTo(map);
   * ```
   */ var Circle = CircleMarker.extend({
        initialize: function(latlng, options, legacyOptions) {
            if (typeof options === 'number') // Backwards compatibility with 0.7.x factory (latlng, radius, options?)
            options = extend({}, legacyOptions, {
                radius: options
            });
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            if (isNaN(this.options.radius)) throw new Error('Circle radius cannot be NaN');
            // @section
            // @aka Circle options
            // @option radius: Number; Radius of the circle, in meters.
            this._mRadius = this.options.radius;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle. Units are in meters.
        setRadius: function(radius) {
            this._mRadius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of a circle. Units are in meters.
        getRadius: function() {
            return this._mRadius;
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            var half = [
                this._radius,
                this._radiusY || this._radius
            ];
            return new LatLngBounds(this._map.layerPointToLatLng(this._point.subtract(half)), this._map.layerPointToLatLng(this._point.add(half)));
        },
        setStyle: Path.prototype.setStyle,
        _project: function() {
            var lng = this._latlng.lng, lat = this._latlng.lat, map = this._map, crs = map.options.crs;
            if (crs.distance === Earth.distance) {
                var d = Math.PI / 180, latR = this._mRadius / Earth.R / d, top = map.project([
                    lat + latR,
                    lng
                ]), bottom = map.project([
                    lat - latR,
                    lng
                ]), p = top.add(bottom).divideBy(2), lat2 = map.unproject(p).lat, lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) / (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;
                if (isNaN(lngR) || lngR === 0) lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
                this._point = p.subtract(map.getPixelOrigin());
                this._radius = isNaN(lngR) ? 0 : p.x - map.project([
                    lat2,
                    lng - lngR
                ]).x;
                this._radiusY = p.y - top.y;
            } else {
                var latlng2 = crs.unproject(crs.project(this._latlng).subtract([
                    this._mRadius,
                    0
                ]));
                this._point = map.latLngToLayerPoint(this._latlng);
                this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
            }
            this._updateBounds();
        }
    });
    // @factory L.circle(latlng: LatLng, options?: Circle options)
    // Instantiates a circle object given a geographical point, and an options object
    // which contains the circle radius.
    // @alternative
    // @factory L.circle(latlng: LatLng, radius: Number, options?: Circle options)
    // Obsolete way of instantiating a circle, for compatibility with 0.7.x code.
    // Do not use in new applications or plugins.
    function circle(latlng, options, legacyOptions) {
        return new Circle(latlng, options, legacyOptions);
    }
    /*
   * @class Polyline
   * @aka L.Polyline
   * @inherits Path
   *
   * A class for drawing polyline overlays on a map. Extends `Path`.
   *
   * @example
   *
   * ```js
   * // create a red polyline from an array of LatLng points
   * var latlngs = [
   * 	[45.51, -122.68],
   * 	[37.77, -122.43],
   * 	[34.04, -118.2]
   * ];
   *
   * var polyline = L.polyline(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polyline
   * map.fitBounds(polyline.getBounds());
   * ```
   *
   * You can also pass a multi-dimensional array to represent a `MultiPolyline` shape:
   *
   * ```js
   * // create a red polyline from an array of arrays of LatLng points
   * var latlngs = [
   * 	[[45.51, -122.68],
   * 	 [37.77, -122.43],
   * 	 [34.04, -118.2]],
   * 	[[40.78, -73.91],
   * 	 [41.83, -87.62],
   * 	 [32.76, -96.72]]
   * ];
   * ```
   */ var Polyline = Path.extend({
        // @section
        // @aka Polyline options
        options: {
            // @option smoothFactor: Number = 1.0
            // How much to simplify the polyline on each zoom level. More means
            // better performance and smoother look, and less means more accurate representation.
            smoothFactor: 1.0,
            // @option noClip: Boolean = false
            // Disable polyline clipping.
            noClip: false
        },
        initialize: function(latlngs, options) {
            setOptions(this, options);
            this._setLatLngs(latlngs);
        },
        // @method getLatLngs(): LatLng[]
        // Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
        getLatLngs: function() {
            return this._latlngs;
        },
        // @method setLatLngs(latlngs: LatLng[]): this
        // Replaces all the points in the polyline with the given array of geographical points.
        setLatLngs: function(latlngs) {
            this._setLatLngs(latlngs);
            return this.redraw();
        },
        // @method isEmpty(): Boolean
        // Returns `true` if the Polyline has no LatLngs.
        isEmpty: function() {
            return !this._latlngs.length;
        },
        // @method closestLayerPoint(p: Point): Point
        // Returns the point closest to `p` on the Polyline.
        closestLayerPoint: function(p) {
            var minDistance = Infinity, minPoint = null, closest = _sqClosestPointOnSegment, p1, p2;
            for(var j = 0, jLen = this._parts.length; j < jLen; j++){
                var points = this._parts[j];
                for(var i = 1, len = points.length; i < len; i++){
                    p1 = points[i - 1];
                    p2 = points[i];
                    var sqDist = closest(p, p1, p2, true);
                    if (sqDist < minDistance) {
                        minDistance = sqDist;
                        minPoint = closest(p, p1, p2);
                    }
                }
            }
            if (minPoint) minPoint.distance = Math.sqrt(minDistance);
            return minPoint;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](https://en.wikipedia.org/wiki/Centroid)) of the polyline.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error('Must add layer to map before using getCenter()');
            return polylineCenter(this._defaultShape(), this._map.options.crs);
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            return this._bounds;
        },
        // @method addLatLng(latlng: LatLng, latlngs?: LatLng[]): this
        // Adds a given point to the polyline. By default, adds to the first ring of
        // the polyline in case of a multi-polyline, but can be overridden by passing
        // a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
        addLatLng: function(latlng, latlngs) {
            latlngs = latlngs || this._defaultShape();
            latlng = toLatLng(latlng);
            latlngs.push(latlng);
            this._bounds.extend(latlng);
            return this.redraw();
        },
        _setLatLngs: function(latlngs) {
            this._bounds = new LatLngBounds();
            this._latlngs = this._convertLatLngs(latlngs);
        },
        _defaultShape: function() {
            return isFlat(this._latlngs) ? this._latlngs : this._latlngs[0];
        },
        // recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
        _convertLatLngs: function(latlngs) {
            var result = [], flat = isFlat(latlngs);
            for(var i = 0, len = latlngs.length; i < len; i++)if (flat) {
                result[i] = toLatLng(latlngs[i]);
                this._bounds.extend(result[i]);
            } else result[i] = this._convertLatLngs(latlngs[i]);
            return result;
        },
        _project: function() {
            var pxBounds = new Bounds();
            this._rings = [];
            this._projectLatlngs(this._latlngs, this._rings, pxBounds);
            if (this._bounds.isValid() && pxBounds.isValid()) {
                this._rawPxBounds = pxBounds;
                this._updateBounds();
            }
        },
        _updateBounds: function() {
            var w = this._clickTolerance(), p = new Point(w, w);
            if (!this._rawPxBounds) return;
            this._pxBounds = new Bounds([
                this._rawPxBounds.min.subtract(p),
                this._rawPxBounds.max.add(p)
            ]);
        },
        // recursively turns latlngs into a set of rings with projected coordinates
        _projectLatlngs: function(latlngs, result, projectedBounds) {
            var flat = latlngs[0] instanceof LatLng, len = latlngs.length, i, ring;
            if (flat) {
                ring = [];
                for(i = 0; i < len; i++){
                    ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
                    projectedBounds.extend(ring[i]);
                }
                result.push(ring);
            } else for(i = 0; i < len; i++)this._projectLatlngs(latlngs[i], result, projectedBounds);
        },
        // clip polyline by renderer bounds so that we have less to render for performance
        _clipPoints: function() {
            var bounds = this._renderer._bounds;
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            var parts = this._parts, i, j, k, len, len2, segment, points;
            for(i = 0, k = 0, len = this._rings.length; i < len; i++){
                points = this._rings[i];
                for(j = 0, len2 = points.length; j < len2 - 1; j++){
                    segment = clipSegment(points[j], points[j + 1], bounds, j, true);
                    if (!segment) continue;
                    parts[k] = parts[k] || [];
                    parts[k].push(segment[0]);
                    // if segment goes out of screen, or it's the last one, it's the end of the line part
                    if (segment[1] !== points[j + 1] || j === len2 - 2) {
                        parts[k].push(segment[1]);
                        k++;
                    }
                }
            }
        },
        // simplify each clipped part of the polyline for performance
        _simplifyPoints: function() {
            var parts = this._parts, tolerance = this.options.smoothFactor;
            for(var i = 0, len = parts.length; i < len; i++)parts[i] = simplify(parts[i], tolerance);
        },
        _update: function() {
            if (!this._map) return;
            this._clipPoints();
            this._simplifyPoints();
            this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updatePoly(this);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p, closed) {
            var i, j, k, len, len2, part, w = this._clickTolerance();
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // hit detection for polylines
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    if (!closed && j === 0) continue;
                    if (pointToSegmentDistance(p, part[k], part[j]) <= w) return true;
                }
            }
            return false;
        }
    });
    // @factory L.polyline(latlngs: LatLng[], options?: Polyline options)
    // Instantiates a polyline object given an array of geographical points and
    // optionally an options object. You can create a `Polyline` object with
    // multiple separate lines (`MultiPolyline`) by passing an array of arrays
    // of geographic points.
    function polyline(latlngs, options) {
        return new Polyline(latlngs, options);
    }
    // Retrocompat. Allow plugins to support Leaflet versions before and after 1.1.
    Polyline._flat = _flat;
    /*
   * @class Polygon
   * @aka L.Polygon
   * @inherits Polyline
   *
   * A class for drawing polygon overlays on a map. Extends `Polyline`.
   *
   * Note that points you pass when creating a polygon shouldn't have an additional last point equal to the first one — it's better to filter out such points.
   *
   *
   * @example
   *
   * ```js
   * // create a red polygon from an array of LatLng points
   * var latlngs = [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]];
   *
   * var polygon = L.polygon(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polygon
   * map.fitBounds(polygon.getBounds());
   * ```
   *
   * You can also pass an array of arrays of latlngs, with the first array representing the outer shape and the other arrays representing holes in the outer shape:
   *
   * ```js
   * var latlngs = [
   *   [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *   [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   * ];
   * ```
   *
   * Additionally, you can pass a multi-dimensional array to represent a MultiPolygon shape.
   *
   * ```js
   * var latlngs = [
   *   [ // first polygon
   *     [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *     [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   *   ],
   *   [ // second polygon
   *     [[41, -111.03],[45, -111.04],[45, -104.05],[41, -104.05]]
   *   ]
   * ];
   * ```
   */ var Polygon = Polyline.extend({
        options: {
            fill: true
        },
        isEmpty: function() {
            return !this._latlngs.length || !this._latlngs[0].length;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the Polygon.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error('Must add layer to map before using getCenter()');
            return polygonCenter(this._defaultShape(), this._map.options.crs);
        },
        _convertLatLngs: function(latlngs) {
            var result = Polyline.prototype._convertLatLngs.call(this, latlngs), len = result.length;
            // remove last point if it equals first one
            if (len >= 2 && result[0] instanceof LatLng && result[0].equals(result[len - 1])) result.pop();
            return result;
        },
        _setLatLngs: function(latlngs) {
            Polyline.prototype._setLatLngs.call(this, latlngs);
            if (isFlat(this._latlngs)) this._latlngs = [
                this._latlngs
            ];
        },
        _defaultShape: function() {
            return isFlat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
        },
        _clipPoints: function() {
            // polygons need a different clipping algorithm so we redefine that
            var bounds = this._renderer._bounds, w = this.options.weight, p = new Point(w, w);
            // increase clip padding by stroke width to avoid stroke on clip edges
            bounds = new Bounds(bounds.min.subtract(p), bounds.max.add(p));
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            for(var i = 0, len = this._rings.length, clipped; i < len; i++){
                clipped = clipPolygon(this._rings[i], bounds, true);
                if (clipped.length) this._parts.push(clipped);
            }
        },
        _updatePath: function() {
            this._renderer._updatePoly(this, true);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            var inside = false, part, p1, p2, i, j, k, len, len2;
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // ray casting algorithm for detecting if point is in polygon
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    p1 = part[j];
                    p2 = part[k];
                    if (p1.y > p.y !== p2.y > p.y && p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x) inside = !inside;
                }
            }
            // also check if it's on polygon stroke
            return inside || Polyline.prototype._containsPoint.call(this, p, true);
        }
    });
    // @factory L.polygon(latlngs: LatLng[], options?: Polyline options)
    function polygon(latlngs, options) {
        return new Polygon(latlngs, options);
    }
    /*
   * @class GeoJSON
   * @aka L.GeoJSON
   * @inherits FeatureGroup
   *
   * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to parse
   * GeoJSON data and display it on the map. Extends `FeatureGroup`.
   *
   * @example
   *
   * ```js
   * L.geoJSON(data, {
   * 	style: function (feature) {
   * 		return {color: feature.properties.color};
   * 	}
   * }).bindPopup(function (layer) {
   * 	return layer.feature.properties.description;
   * }).addTo(map);
   * ```
   */ var GeoJSON = FeatureGroup.extend({
        /* @section
  	 * @aka GeoJSON options
  	 *
  	 * @option pointToLayer: Function = *
  	 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
  	 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
  	 * The default is to spawn a default `Marker`:
  	 * ```js
  	 * function(geoJsonPoint, latlng) {
  	 * 	return L.marker(latlng);
  	 * }
  	 * ```
  	 *
  	 * @option style: Function = *
  	 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
  	 * called internally when data is added.
  	 * The default value is to not override any defaults:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return {}
  	 * }
  	 * ```
  	 *
  	 * @option onEachFeature: Function = *
  	 * A `Function` that will be called once for each created `Feature`, after it has
  	 * been created and styled. Useful for attaching events and popups to features.
  	 * The default is to do nothing with the newly created layers:
  	 * ```js
  	 * function (feature, layer) {}
  	 * ```
  	 *
  	 * @option filter: Function = *
  	 * A `Function` that will be used to decide whether to include a feature or not.
  	 * The default is to include all features:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return true;
  	 * }
  	 * ```
  	 * Note: dynamically changing the `filter` option will have effect only on newly
  	 * added data. It will _not_ re-evaluate already included features.
  	 *
  	 * @option coordsToLatLng: Function = *
  	 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
  	 * The default is the `coordsToLatLng` static method.
  	 *
  	 * @option markersInheritOptions: Boolean = false
  	 * Whether default Markers for "Point" type Features inherit from group options.
  	 */ initialize: function(geojson, options) {
            setOptions(this, options);
            this._layers = {};
            if (geojson) this.addData(geojson);
        },
        // @method addData( <GeoJSON> data ): this
        // Adds a GeoJSON object to the layer.
        addData: function(geojson) {
            var features = isArray(geojson) ? geojson : geojson.features, i, len, feature;
            if (features) {
                for(i = 0, len = features.length; i < len; i++){
                    // only add this if geometry or geometries are set and not null
                    feature = features[i];
                    if (feature.geometries || feature.geometry || feature.features || feature.coordinates) this.addData(feature);
                }
                return this;
            }
            var options = this.options;
            if (options.filter && !options.filter(geojson)) return this;
            var layer = geometryToLayer(geojson, options);
            if (!layer) return this;
            layer.feature = asFeature(geojson);
            layer.defaultOptions = layer.options;
            this.resetStyle(layer);
            if (options.onEachFeature) options.onEachFeature(geojson, layer);
            return this.addLayer(layer);
        },
        // @method resetStyle( <Path> layer? ): this
        // Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
        // If `layer` is omitted, the style of all features in the current layer is reset.
        resetStyle: function(layer) {
            if (layer === undefined) return this.eachLayer(this.resetStyle, this);
            // reset any custom styles
            layer.options = extend({}, layer.defaultOptions);
            this._setLayerStyle(layer, this.options.style);
            return this;
        },
        // @method setStyle( <Function> style ): this
        // Changes styles of GeoJSON vector layers with the given style function.
        setStyle: function(style) {
            return this.eachLayer(function(layer) {
                this._setLayerStyle(layer, style);
            }, this);
        },
        _setLayerStyle: function(layer, style) {
            if (layer.setStyle) {
                if (typeof style === 'function') style = style(layer.feature);
                layer.setStyle(style);
            }
        }
    });
    // @section
    // There are several static functions which can be called without instantiating L.GeoJSON:
    // @function geometryToLayer(featureData: Object, options?: GeoJSON options): Layer
    // Creates a `Layer` from a given GeoJSON feature. Can use a custom
    // [`pointToLayer`](#geojson-pointtolayer) and/or [`coordsToLatLng`](#geojson-coordstolatlng)
    // functions if provided as options.
    function geometryToLayer(geojson, options) {
        var geometry = geojson.type === 'Feature' ? geojson.geometry : geojson, coords = geometry ? geometry.coordinates : null, layers = [], pointToLayer = options && options.pointToLayer, _coordsToLatLng = options && options.coordsToLatLng || coordsToLatLng, latlng, latlngs, i, len;
        if (!coords && !geometry) return null;
        switch(geometry.type){
            case 'Point':
                latlng = _coordsToLatLng(coords);
                return _pointToLayer(pointToLayer, geojson, latlng, options);
            case 'MultiPoint':
                for(i = 0, len = coords.length; i < len; i++){
                    latlng = _coordsToLatLng(coords[i]);
                    layers.push(_pointToLayer(pointToLayer, geojson, latlng, options));
                }
                return new FeatureGroup(layers);
            case 'LineString':
            case 'MultiLineString':
                latlngs = coordsToLatLngs(coords, geometry.type === 'LineString' ? 0 : 1, _coordsToLatLng);
                return new Polyline(latlngs, options);
            case 'Polygon':
            case 'MultiPolygon':
                latlngs = coordsToLatLngs(coords, geometry.type === 'Polygon' ? 1 : 2, _coordsToLatLng);
                return new Polygon(latlngs, options);
            case 'GeometryCollection':
                for(i = 0, len = geometry.geometries.length; i < len; i++){
                    var geoLayer = geometryToLayer({
                        geometry: geometry.geometries[i],
                        type: 'Feature',
                        properties: geojson.properties
                    }, options);
                    if (geoLayer) layers.push(geoLayer);
                }
                return new FeatureGroup(layers);
            case 'FeatureCollection':
                for(i = 0, len = geometry.features.length; i < len; i++){
                    var featureLayer = geometryToLayer(geometry.features[i], options);
                    if (featureLayer) layers.push(featureLayer);
                }
                return new FeatureGroup(layers);
            default:
                throw new Error('Invalid GeoJSON object.');
        }
    }
    function _pointToLayer(pointToLayerFn, geojson, latlng, options) {
        return pointToLayerFn ? pointToLayerFn(geojson, latlng) : new Marker(latlng, options && options.markersInheritOptions && options);
    }
    // @function coordsToLatLng(coords: Array): LatLng
    // Creates a `LatLng` object from an array of 2 numbers (longitude, latitude)
    // or 3 numbers (longitude, latitude, altitude) used in GeoJSON for points.
    function coordsToLatLng(coords) {
        return new LatLng(coords[1], coords[0], coords[2]);
    }
    // @function coordsToLatLngs(coords: Array, levelsDeep?: Number, coordsToLatLng?: Function): Array
    // Creates a multidimensional array of `LatLng`s from a GeoJSON coordinates array.
    // `levelsDeep` specifies the nesting level (0 is for an array of points, 1 for an array of arrays of points, etc., 0 by default).
    // Can use a custom [`coordsToLatLng`](#geojson-coordstolatlng) function.
    function coordsToLatLngs(coords, levelsDeep, _coordsToLatLng) {
        var latlngs = [];
        for(var i = 0, len = coords.length, latlng; i < len; i++){
            latlng = levelsDeep ? coordsToLatLngs(coords[i], levelsDeep - 1, _coordsToLatLng) : (_coordsToLatLng || coordsToLatLng)(coords[i]);
            latlngs.push(latlng);
        }
        return latlngs;
    }
    // @function latLngToCoords(latlng: LatLng, precision?: Number|false): Array
    // Reverse of [`coordsToLatLng`](#geojson-coordstolatlng)
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngToCoords(latlng, precision) {
        latlng = toLatLng(latlng);
        return latlng.alt !== undefined ? [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision),
            formatNum(latlng.alt, precision)
        ] : [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision)
        ];
    }
    // @function latLngsToCoords(latlngs: Array, levelsDeep?: Number, closed?: Boolean, precision?: Number|false): Array
    // Reverse of [`coordsToLatLngs`](#geojson-coordstolatlngs)
    // `closed` determines whether the first point should be appended to the end of the array to close the feature, only used when `levelsDeep` is 0. False by default.
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngsToCoords(latlngs, levelsDeep, closed, precision) {
        var coords = [];
        for(var i = 0, len = latlngs.length; i < len; i++)// Check for flat arrays required to ensure unbalanced arrays are correctly converted in recursion
        coords.push(levelsDeep ? latLngsToCoords(latlngs[i], isFlat(latlngs[i]) ? 0 : levelsDeep - 1, closed, precision) : latLngToCoords(latlngs[i], precision));
        if (!levelsDeep && closed && coords.length > 0) coords.push(coords[0].slice());
        return coords;
    }
    function getFeature(layer, newGeometry) {
        return layer.feature ? extend({}, layer.feature, {
            geometry: newGeometry
        }) : asFeature(newGeometry);
    }
    // @function asFeature(geojson: Object): Object
    // Normalize GeoJSON geometries/features into GeoJSON features.
    function asFeature(geojson) {
        if (geojson.type === 'Feature' || geojson.type === 'FeatureCollection') return geojson;
        return {
            type: 'Feature',
            properties: {},
            geometry: geojson
        };
    }
    var PointToGeoJSON = {
        toGeoJSON: function(precision) {
            return getFeature(this, {
                type: 'Point',
                coordinates: latLngToCoords(this.getLatLng(), precision)
            });
        }
    };
    // @namespace Marker
    // @section Other methods
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
    Marker.include(PointToGeoJSON);
    // @namespace CircleMarker
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
    Circle.include(PointToGeoJSON);
    CircleMarker.include(PointToGeoJSON);
    // @namespace Polyline
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
    Polyline.include({
        toGeoJSON: function(precision) {
            var multi = !isFlat(this._latlngs);
            var coords = latLngsToCoords(this._latlngs, multi ? 1 : 0, false, precision);
            return getFeature(this, {
                type: (multi ? 'Multi' : '') + 'LineString',
                coordinates: coords
            });
        }
    });
    // @namespace Polygon
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
    Polygon.include({
        toGeoJSON: function(precision) {
            var holes = !isFlat(this._latlngs), multi = holes && !isFlat(this._latlngs[0]);
            var coords = latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true, precision);
            if (!holes) coords = [
                coords
            ];
            return getFeature(this, {
                type: (multi ? 'Multi' : '') + 'Polygon',
                coordinates: coords
            });
        }
    });
    // @namespace LayerGroup
    LayerGroup.include({
        toMultiPoint: function(precision) {
            var coords = [];
            this.eachLayer(function(layer) {
                coords.push(layer.toGeoJSON(precision).geometry.coordinates);
            });
            return getFeature(this, {
                type: 'MultiPoint',
                coordinates: coords
            });
        },
        // @method toGeoJSON(precision?: Number|false): Object
        // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
        // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
        toGeoJSON: function(precision) {
            var type = this.feature && this.feature.geometry && this.feature.geometry.type;
            if (type === 'MultiPoint') return this.toMultiPoint(precision);
            var isGeometryCollection = type === 'GeometryCollection', jsons = [];
            this.eachLayer(function(layer) {
                if (layer.toGeoJSON) {
                    var json = layer.toGeoJSON(precision);
                    if (isGeometryCollection) jsons.push(json.geometry);
                    else {
                        var feature = asFeature(json);
                        // Squash nested feature collections
                        if (feature.type === 'FeatureCollection') jsons.push.apply(jsons, feature.features);
                        else jsons.push(feature);
                    }
                }
            });
            if (isGeometryCollection) return getFeature(this, {
                geometries: jsons,
                type: 'GeometryCollection'
            });
            return {
                type: 'FeatureCollection',
                features: jsons
            };
        }
    });
    // @namespace GeoJSON
    // @factory L.geoJSON(geojson?: Object, options?: GeoJSON options)
    // Creates a GeoJSON layer. Optionally accepts an object in
    // [GeoJSON format](https://tools.ietf.org/html/rfc7946) to display on the map
    // (you can alternatively add it later with `addData` method) and an `options` object.
    function geoJSON(geojson, options) {
        return new GeoJSON(geojson, options);
    }
    // Backward compatibility.
    var geoJson = geoJSON;
    /*
   * @class ImageOverlay
   * @aka L.ImageOverlay
   * @inherits Interactive layer
   *
   * Used to load and display a single image over specific bounds of the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * var imageUrl = 'https://maps.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
   * 	imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
   * L.imageOverlay(imageUrl, imageBounds).addTo(map);
   * ```
   */ var ImageOverlay = Layer.extend({
        // @section
        // @aka ImageOverlay options
        options: {
            // @option opacity: Number = 1.0
            // The opacity of the image overlay.
            opacity: 1,
            // @option alt: String = ''
            // Text for the `alt` attribute of the image (useful for accessibility).
            alt: '',
            // @option interactive: Boolean = false
            // If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
            interactive: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the image.
            // If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option errorOverlayUrl: String = ''
            // URL to the overlay image to show in place of the overlay that failed to load.
            errorOverlayUrl: '',
            // @option zIndex: Number = 1
            // The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
            zIndex: 1,
            // @option className: String = ''
            // A custom class name to assign to the image. Empty by default.
            className: ''
        },
        initialize: function(url, bounds, options) {
            this._url = url;
            this._bounds = toLatLngBounds(bounds);
            setOptions(this, options);
        },
        onAdd: function() {
            if (!this._image) {
                this._initImage();
                if (this.options.opacity < 1) this._updateOpacity();
            }
            if (this.options.interactive) {
                addClass(this._image, 'leaflet-interactive');
                this.addInteractiveTarget(this._image);
            }
            this.getPane().appendChild(this._image);
            this._reset();
        },
        onRemove: function() {
            remove(this._image);
            if (this.options.interactive) this.removeInteractiveTarget(this._image);
        },
        // @method setOpacity(opacity: Number): this
        // Sets the opacity of the overlay.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._image) this._updateOpacity();
            return this;
        },
        setStyle: function(styleOpts) {
            if (styleOpts.opacity) this.setOpacity(styleOpts.opacity);
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all overlays.
        bringToFront: function() {
            if (this._map) toFront(this._image);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all overlays.
        bringToBack: function() {
            if (this._map) toBack(this._image);
            return this;
        },
        // @method setUrl(url: String): this
        // Changes the URL of the image.
        setUrl: function(url) {
            this._url = url;
            if (this._image) this._image.src = url;
            return this;
        },
        // @method setBounds(bounds: LatLngBounds): this
        // Update the bounds that this ImageOverlay covers
        setBounds: function(bounds) {
            this._bounds = toLatLngBounds(bounds);
            if (this._map) this._reset();
            return this;
        },
        getEvents: function() {
            var events = {
                zoom: this._reset,
                viewreset: this._reset
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method setZIndex(value: Number): this
        // Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
        setZIndex: function(value) {
            this.options.zIndex = value;
            this._updateZIndex();
            return this;
        },
        // @method getBounds(): LatLngBounds
        // Get the bounds that this ImageOverlay covers
        getBounds: function() {
            return this._bounds;
        },
        // @method getElement(): HTMLElement
        // Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
        // used by this overlay.
        getElement: function() {
            return this._image;
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === 'IMG';
            var img = this._image = wasElementSupplied ? this._url : create$1('img');
            addClass(img, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(img, 'leaflet-zoom-animated');
            if (this.options.className) addClass(img, this.options.className);
            img.onselectstart = falseFn;
            img.onmousemove = falseFn;
            // @event load: Event
            // Fired when the ImageOverlay layer has loaded its image
            img.onload = bind(this.fire, this, 'load');
            img.onerror = bind(this._overlayOnError, this, 'error');
            if (this.options.crossOrigin || this.options.crossOrigin === '') img.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            if (this.options.zIndex) this._updateZIndex();
            if (wasElementSupplied) {
                this._url = img.src;
                return;
            }
            img.src = this._url;
            img.alt = this.options.alt;
        },
        _animateZoom: function(e) {
            var scale = this._map.getZoomScale(e.zoom), offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
            setTransform(this._image, offset, scale);
        },
        _reset: function() {
            var image = this._image, bounds = new Bounds(this._map.latLngToLayerPoint(this._bounds.getNorthWest()), this._map.latLngToLayerPoint(this._bounds.getSouthEast())), size = bounds.getSize();
            setPosition(image, bounds.min);
            image.style.width = size.x + 'px';
            image.style.height = size.y + 'px';
        },
        _updateOpacity: function() {
            setOpacity(this._image, this.options.opacity);
        },
        _updateZIndex: function() {
            if (this._image && this.options.zIndex !== undefined && this.options.zIndex !== null) this._image.style.zIndex = this.options.zIndex;
        },
        _overlayOnError: function() {
            // @event error: Event
            // Fired when the ImageOverlay layer fails to load its image
            this.fire('error');
            var errorUrl = this.options.errorOverlayUrl;
            if (errorUrl && this._url !== errorUrl) {
                this._url = errorUrl;
                this._image.src = errorUrl;
            }
        },
        // @method getCenter(): LatLng
        // Returns the center of the ImageOverlay.
        getCenter: function() {
            return this._bounds.getCenter();
        }
    });
    // @factory L.imageOverlay(imageUrl: String, bounds: LatLngBounds, options?: ImageOverlay options)
    // Instantiates an image overlay object given the URL of the image and the
    // geographical bounds it is tied to.
    var imageOverlay = function(url, bounds, options) {
        return new ImageOverlay(url, bounds, options);
    };
    /*
   * @class VideoOverlay
   * @aka L.VideoOverlay
   * @inherits ImageOverlay
   *
   * Used to load and display a video player over specific bounds of the map. Extends `ImageOverlay`.
   *
   * A video overlay uses the [`<video>`](https://developer.mozilla.org/docs/Web/HTML/Element/video)
   * HTML5 element.
   *
   * @example
   *
   * ```js
   * var videoUrl = 'https://www.mapbox.com/bites/00188/patricia_nasa.webm',
   * 	videoBounds = [[ 32, -130], [ 13, -100]];
   * L.videoOverlay(videoUrl, videoBounds ).addTo(map);
   * ```
   */ var VideoOverlay = ImageOverlay.extend({
        // @section
        // @aka VideoOverlay options
        options: {
            // @option autoplay: Boolean = true
            // Whether the video starts playing automatically when loaded.
            // On some browsers autoplay will only work with `muted: true`
            autoplay: true,
            // @option loop: Boolean = true
            // Whether the video will loop back to the beginning when played.
            loop: true,
            // @option keepAspectRatio: Boolean = true
            // Whether the video will save aspect ratio after the projection.
            // Relevant for supported browsers. See [browser compatibility](https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit)
            keepAspectRatio: true,
            // @option muted: Boolean = false
            // Whether the video starts on mute when loaded.
            muted: false,
            // @option playsInline: Boolean = true
            // Mobile browsers will play the video right where it is instead of open it up in fullscreen mode.
            playsInline: true
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === 'VIDEO';
            var vid = this._image = wasElementSupplied ? this._url : create$1('video');
            addClass(vid, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(vid, 'leaflet-zoom-animated');
            if (this.options.className) addClass(vid, this.options.className);
            vid.onselectstart = falseFn;
            vid.onmousemove = falseFn;
            // @event load: Event
            // Fired when the video has finished loading the first frame
            vid.onloadeddata = bind(this.fire, this, 'load');
            if (wasElementSupplied) {
                var sourceElements = vid.getElementsByTagName('source');
                var sources = [];
                for(var j = 0; j < sourceElements.length; j++)sources.push(sourceElements[j].src);
                this._url = sourceElements.length > 0 ? sources : [
                    vid.src
                ];
                return;
            }
            if (!isArray(this._url)) this._url = [
                this._url
            ];
            if (!this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(vid.style, 'objectFit')) vid.style['objectFit'] = 'fill';
            vid.autoplay = !!this.options.autoplay;
            vid.loop = !!this.options.loop;
            vid.muted = !!this.options.muted;
            vid.playsInline = !!this.options.playsInline;
            for(var i = 0; i < this._url.length; i++){
                var source = create$1('source');
                source.src = this._url[i];
                vid.appendChild(source);
            }
        }
    });
    // @factory L.videoOverlay(video: String|Array|HTMLVideoElement, bounds: LatLngBounds, options?: VideoOverlay options)
    // Instantiates an image overlay object given the URL of the video (or array of URLs, or even a video element) and the
    // geographical bounds it is tied to.
    function videoOverlay(video, bounds, options) {
        return new VideoOverlay(video, bounds, options);
    }
    /*
   * @class SVGOverlay
   * @aka L.SVGOverlay
   * @inherits ImageOverlay
   *
   * Used to load, display and provide DOM access to an SVG file over specific bounds of the map. Extends `ImageOverlay`.
   *
   * An SVG overlay uses the [`<svg>`](https://developer.mozilla.org/docs/Web/SVG/Element/svg) element.
   *
   * @example
   *
   * ```js
   * var svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
   * svgElement.setAttribute('xmlns', "http://www.w3.org/2000/svg");
   * svgElement.setAttribute('viewBox', "0 0 200 200");
   * svgElement.innerHTML = '<rect width="200" height="200"/><rect x="75" y="23" width="50" height="50" style="fill:red"/><rect x="75" y="123" width="50" height="50" style="fill:#0013ff"/>';
   * var svgElementBounds = [ [ 32, -130 ], [ 13, -100 ] ];
   * L.svgOverlay(svgElement, svgElementBounds).addTo(map);
   * ```
   */ var SVGOverlay = ImageOverlay.extend({
        _initImage: function() {
            var el = this._image = this._url;
            addClass(el, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(el, 'leaflet-zoom-animated');
            if (this.options.className) addClass(el, this.options.className);
            el.onselectstart = falseFn;
            el.onmousemove = falseFn;
        }
    });
    // @factory L.svgOverlay(svg: String|SVGElement, bounds: LatLngBounds, options?: SVGOverlay options)
    // Instantiates an image overlay object given an SVG element and the geographical bounds it is tied to.
    // A viewBox attribute is required on the SVG element to zoom in and out properly.
    function svgOverlay(el, bounds, options) {
        return new SVGOverlay(el, bounds, options);
    }
    /*
   * @class DivOverlay
   * @inherits Interactive layer
   * @aka L.DivOverlay
   * Base model for L.Popup and L.Tooltip. Inherit from it for custom overlays like plugins.
   */ // @namespace DivOverlay
    var DivOverlay = Layer.extend({
        // @section
        // @aka DivOverlay options
        options: {
            // @option interactive: Boolean = false
            // If true, the popup/tooltip will listen to the mouse events.
            interactive: false,
            // @option offset: Point = Point(0, 0)
            // The offset of the overlay position.
            offset: [
                0,
                0
            ],
            // @option className: String = ''
            // A custom CSS class name to assign to the overlay.
            className: '',
            // @option pane: String = undefined
            // `Map pane` where the overlay will be added.
            pane: undefined,
            // @option content: String|HTMLElement|Function = ''
            // Sets the HTML content of the overlay while initializing. If a function is passed the source layer will be
            // passed to the function. The function should return a `String` or `HTMLElement` to be used in the overlay.
            content: ''
        },
        initialize: function(options, source) {
            if (options && (options instanceof LatLng || isArray(options))) {
                this._latlng = toLatLng(options);
                setOptions(this, source);
            } else {
                setOptions(this, options);
                this._source = source;
            }
            if (this.options.content) this._content = this.options.content;
        },
        // @method openOn(map: Map): this
        // Adds the overlay to the map.
        // Alternative to `map.openPopup(popup)`/`.openTooltip(tooltip)`.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this)) map.addLayer(this);
            return this;
        },
        // @method close(): this
        // Closes the overlay.
        // Alternative to `map.closePopup(popup)`/`.closeTooltip(tooltip)`
        // and `layer.closePopup()`/`.closeTooltip()`.
        close: function() {
            if (this._map) this._map.removeLayer(this);
            return this;
        },
        // @method toggle(layer?: Layer): this
        // Opens or closes the overlay bound to layer depending on its current state.
        // Argument may be omitted only for overlay bound to layer.
        // Alternative to `layer.togglePopup()`/`.toggleTooltip()`.
        toggle: function(layer) {
            if (this._map) this.close();
            else {
                if (arguments.length) this._source = layer;
                else layer = this._source;
                this._prepareOpen();
                // open the overlay on the map
                this.openOn(layer._map);
            }
            return this;
        },
        onAdd: function(map) {
            this._zoomAnimated = map._zoomAnimated;
            if (!this._container) this._initLayout();
            if (map._fadeAnimated) setOpacity(this._container, 0);
            clearTimeout(this._removeTimeout);
            this.getPane().appendChild(this._container);
            this.update();
            if (map._fadeAnimated) setOpacity(this._container, 1);
            this.bringToFront();
            if (this.options.interactive) {
                addClass(this._container, 'leaflet-interactive');
                this.addInteractiveTarget(this._container);
            }
        },
        onRemove: function(map) {
            if (map._fadeAnimated) {
                setOpacity(this._container, 0);
                this._removeTimeout = setTimeout(bind(remove, undefined, this._container), 200);
            } else remove(this._container);
            if (this.options.interactive) {
                removeClass(this._container, 'leaflet-interactive');
                this.removeInteractiveTarget(this._container);
            }
        },
        // @namespace DivOverlay
        // @method getLatLng: LatLng
        // Returns the geographical point of the overlay.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Sets the geographical point where the overlay will open.
        setLatLng: function(latlng) {
            this._latlng = toLatLng(latlng);
            if (this._map) {
                this._updatePosition();
                this._adjustPan();
            }
            return this;
        },
        // @method getContent: String|HTMLElement
        // Returns the content of the overlay.
        getContent: function() {
            return this._content;
        },
        // @method setContent(htmlContent: String|HTMLElement|Function): this
        // Sets the HTML content of the overlay. If a function is passed the source layer will be passed to the function.
        // The function should return a `String` or `HTMLElement` to be used in the overlay.
        setContent: function(content) {
            this._content = content;
            this.update();
            return this;
        },
        // @method getElement: String|HTMLElement
        // Returns the HTML container of the overlay.
        getElement: function() {
            return this._container;
        },
        // @method update: null
        // Updates the overlay content, layout and position. Useful for updating the overlay after something inside changed, e.g. image loaded.
        update: function() {
            if (!this._map) return;
            this._container.style.visibility = 'hidden';
            this._updateContent();
            this._updateLayout();
            this._updatePosition();
            this._container.style.visibility = '';
            this._adjustPan();
        },
        getEvents: function() {
            var events = {
                zoom: this._updatePosition,
                viewreset: this._updatePosition
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method isOpen: Boolean
        // Returns `true` when the overlay is visible on the map.
        isOpen: function() {
            return !!this._map && this._map.hasLayer(this);
        },
        // @method bringToFront: this
        // Brings this overlay in front of other overlays (in the same map pane).
        bringToFront: function() {
            if (this._map) toFront(this._container);
            return this;
        },
        // @method bringToBack: this
        // Brings this overlay to the back of other overlays (in the same map pane).
        bringToBack: function() {
            if (this._map) toBack(this._container);
            return this;
        },
        // prepare bound overlay to open: update latlng pos / content source (for FeatureGroup)
        _prepareOpen: function(latlng) {
            var source = this._source;
            if (!source._map) return false;
            if (source instanceof FeatureGroup) {
                source = null;
                var layers = this._source._layers;
                for(var id in layers)if (layers[id]._map) {
                    source = layers[id];
                    break;
                }
                if (!source) return false;
                 // Unable to get source layer.
                // set overlay source to this layer
                this._source = source;
            }
            if (!latlng) {
                if (source.getCenter) latlng = source.getCenter();
                else if (source.getLatLng) latlng = source.getLatLng();
                else if (source.getBounds) latlng = source.getBounds().getCenter();
                else throw new Error('Unable to get source layer LatLng.');
            }
            this.setLatLng(latlng);
            if (this._map) // update the overlay (content, layout, etc...)
            this.update();
            return true;
        },
        _updateContent: function() {
            if (!this._content) return;
            var node = this._contentNode;
            var content = typeof this._content === 'function' ? this._content(this._source || this) : this._content;
            if (typeof content === 'string') node.innerHTML = content;
            else {
                while(node.hasChildNodes())node.removeChild(node.firstChild);
                node.appendChild(content);
            }
            // @namespace DivOverlay
            // @section DivOverlay events
            // @event contentupdate: Event
            // Fired when the content of the overlay is updated
            this.fire('contentupdate');
        },
        _updatePosition: function() {
            if (!this._map) return;
            var pos = this._map.latLngToLayerPoint(this._latlng), offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (this._zoomAnimated) setPosition(this._container, pos.add(anchor));
            else offset = offset.add(pos).add(anchor);
            var bottom = this._containerBottom = -offset.y, left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;
            // bottom position the overlay in case the height of the overlay changes (images loading etc)
            this._container.style.bottom = bottom + 'px';
            this._container.style.left = left + 'px';
        },
        _getAnchor: function() {
            return [
                0,
                0
            ];
        }
    });
    Map.include({
        _initOverlay: function(OverlayClass, content, latlng, options) {
            var overlay = content;
            if (!(overlay instanceof OverlayClass)) overlay = new OverlayClass(options).setContent(content);
            if (latlng) overlay.setLatLng(latlng);
            return overlay;
        }
    });
    Layer.include({
        _initOverlay: function(OverlayClass, old, content, options) {
            var overlay = content;
            if (overlay instanceof OverlayClass) {
                setOptions(overlay, options);
                overlay._source = this;
            } else {
                overlay = old && !options ? old : new OverlayClass(options, this);
                overlay.setContent(content);
            }
            return overlay;
        }
    });
    /*
   * @class Popup
   * @inherits DivOverlay
   * @aka L.Popup
   * Used to open popups in certain places of the map. Use [Map.openPopup](#map-openpopup) to
   * open popups while making sure that only one popup is open at one time
   * (recommended for usability), or use [Map.addLayer](#map-addlayer) to open as many as you want.
   *
   * @example
   *
   * If you want to just bind a popup to marker click and then open it, it's really easy:
   *
   * ```js
   * marker.bindPopup(popupContent).openPopup();
   * ```
   * Path overlays like polylines also have a `bindPopup` method.
   *
   * A popup can be also standalone:
   *
   * ```js
   * var popup = L.popup()
   * 	.setLatLng(latlng)
   * 	.setContent('<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   * or
   * ```js
   * var popup = L.popup(latlng, {content: '<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   */ // @namespace Popup
    var Popup = DivOverlay.extend({
        // @section
        // @aka Popup options
        options: {
            // @option pane: String = 'popupPane'
            // `Map pane` where the popup will be added.
            pane: 'popupPane',
            // @option offset: Point = Point(0, 7)
            // The offset of the popup position.
            offset: [
                0,
                7
            ],
            // @option maxWidth: Number = 300
            // Max width of the popup, in pixels.
            maxWidth: 300,
            // @option minWidth: Number = 50
            // Min width of the popup, in pixels.
            minWidth: 50,
            // @option maxHeight: Number = null
            // If set, creates a scrollable container of the given height
            // inside a popup if its content exceeds it.
            // The scrollable container can be styled using the
            // `leaflet-popup-scrolled` CSS class selector.
            maxHeight: null,
            // @option autoPan: Boolean = true
            // Set it to `false` if you don't want the map to do panning animation
            // to fit the opened popup.
            autoPan: true,
            // @option autoPanPaddingTopLeft: Point = null
            // The margin between the popup and the top left corner of the map
            // view after autopanning was performed.
            autoPanPaddingTopLeft: null,
            // @option autoPanPaddingBottomRight: Point = null
            // The margin between the popup and the bottom right corner of the map
            // view after autopanning was performed.
            autoPanPaddingBottomRight: null,
            // @option autoPanPadding: Point = Point(5, 5)
            // Equivalent of setting both top left and bottom right autopan padding to the same value.
            autoPanPadding: [
                5,
                5
            ],
            // @option keepInView: Boolean = false
            // Set it to `true` if you want to prevent users from panning the popup
            // off of the screen while it is open.
            keepInView: false,
            // @option closeButton: Boolean = true
            // Controls the presence of a close button in the popup.
            closeButton: true,
            // @option autoClose: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the popup closing when another popup is opened.
            autoClose: true,
            // @option closeOnEscapeKey: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the ESC key for closing of the popup.
            closeOnEscapeKey: true,
            // @option closeOnClick: Boolean = *
            // Set it if you want to override the default behavior of the popup closing when user clicks
            // on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
            // @option className: String = ''
            // A custom CSS class name to assign to the popup.
            className: ''
        },
        // @namespace Popup
        // @method openOn(map: Map): this
        // Alternative to `map.openPopup(popup)`.
        // Adds the popup to the map and closes the previous one.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this) && map._popup && map._popup.options.autoClose) map.removeLayer(map._popup);
            map._popup = this;
            return DivOverlay.prototype.openOn.call(this, map);
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupopen: PopupEvent
            // Fired when a popup is opened in the map
            map.fire('popupopen', {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupopen: PopupEvent
                // Fired when a popup bound to this layer is opened
                this._source.fire('popupopen', {
                    popup: this
                }, true);
                // For non-path layers, we toggle the popup when clicking
                // again the layer, so prevent the map to reopen it.
                if (!(this._source instanceof Path)) this._source.on('preclick', stopPropagation);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupclose: PopupEvent
            // Fired when a popup in the map is closed
            map.fire('popupclose', {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupclose: PopupEvent
                // Fired when a popup bound to this layer is closed
                this._source.fire('popupclose', {
                    popup: this
                }, true);
                if (!(this._source instanceof Path)) this._source.off('preclick', stopPropagation);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (this.options.closeOnClick !== undefined ? this.options.closeOnClick : this._map.options.closePopupOnClick) events.preclick = this.close;
            if (this.options.keepInView) events.moveend = this._adjustPan;
            return events;
        },
        _initLayout: function() {
            var prefix = 'leaflet-popup', container = this._container = create$1('div', prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-animated');
            var wrapper = this._wrapper = create$1('div', prefix + '-content-wrapper', container);
            this._contentNode = create$1('div', prefix + '-content', wrapper);
            disableClickPropagation(container);
            disableScrollPropagation(this._contentNode);
            on(container, 'contextmenu', stopPropagation);
            this._tipContainer = create$1('div', prefix + '-tip-container', container);
            this._tip = create$1('div', prefix + '-tip', this._tipContainer);
            if (this.options.closeButton) {
                var closeButton = this._closeButton = create$1('a', prefix + '-close-button', container);
                closeButton.setAttribute('role', 'button'); // overrides the implicit role=link of <a> elements #7399
                closeButton.setAttribute('aria-label', 'Close popup');
                closeButton.href = '#close';
                closeButton.innerHTML = '<span aria-hidden="true">&#215;</span>';
                on(closeButton, 'click', function(ev) {
                    preventDefault(ev);
                    this.close();
                }, this);
            }
        },
        _updateLayout: function() {
            var container = this._contentNode, style = container.style;
            style.width = '';
            style.whiteSpace = 'nowrap';
            var width = container.offsetWidth;
            width = Math.min(width, this.options.maxWidth);
            width = Math.max(width, this.options.minWidth);
            style.width = width + 1 + 'px';
            style.whiteSpace = '';
            style.height = '';
            var height = container.offsetHeight, maxHeight = this.options.maxHeight, scrolledClass = 'leaflet-popup-scrolled';
            if (maxHeight && height > maxHeight) {
                style.height = maxHeight + 'px';
                addClass(container, scrolledClass);
            } else removeClass(container, scrolledClass);
            this._containerWidth = this._container.offsetWidth;
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center), anchor = this._getAnchor();
            setPosition(this._container, pos.add(anchor));
        },
        _adjustPan: function() {
            if (!this.options.autoPan) return;
            if (this._map._panAnim) this._map._panAnim.stop();
            // We can endlessly recurse if keepInView is set and the view resets.
            // Let's guard against that by exiting early if we're responding to our own autopan.
            if (this._autopanning) {
                this._autopanning = false;
                return;
            }
            var map = this._map, marginBottom = parseInt(getStyle(this._container, 'marginBottom'), 10) || 0, containerHeight = this._container.offsetHeight + marginBottom, containerWidth = this._containerWidth, layerPos = new Point(this._containerLeft, -containerHeight - this._containerBottom);
            layerPos._add(getPosition(this._container));
            var containerPos = map.layerPointToContainerPoint(layerPos), padding = toPoint(this.options.autoPanPadding), paddingTL = toPoint(this.options.autoPanPaddingTopLeft || padding), paddingBR = toPoint(this.options.autoPanPaddingBottomRight || padding), size = map.getSize(), dx = 0, dy = 0;
            if (containerPos.x + containerWidth + paddingBR.x > size.x) dx = containerPos.x + containerWidth - size.x + paddingBR.x;
            if (containerPos.x - dx - paddingTL.x < 0) dx = containerPos.x - paddingTL.x;
            if (containerPos.y + containerHeight + paddingBR.y > size.y) dy = containerPos.y + containerHeight - size.y + paddingBR.y;
            if (containerPos.y - dy - paddingTL.y < 0) dy = containerPos.y - paddingTL.y;
            // @namespace Map
            // @section Popup events
            // @event autopanstart: Event
            // Fired when the map starts autopanning when opening a popup.
            if (dx || dy) {
                // Track that we're autopanning, as this function will be re-ran on moveend
                if (this.options.keepInView) this._autopanning = true;
                map.fire('autopanstart').panBy([
                    dx,
                    dy
                ]);
            }
        },
        _getAnchor: function() {
            // Where should we anchor the popup on the source layer?
            return toPoint(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Popup
    // @factory L.popup(options?: Popup options, source?: Layer)
    // Instantiates a `Popup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.popup(latlng: LatLng, options?: Popup options)
    // Instantiates a `Popup` object given `latlng` where the popup will open and an optional `options` object that describes its appearance and location.
    var popup = function(options, source) {
        return new Popup(options, source);
    };
    /* @namespace Map
   * @section Interaction Options
   * @option closePopupOnClick: Boolean = true
   * Set it to `false` if you don't want popups to close when user clicks the map.
   */ Map.mergeOptions({
        closePopupOnClick: true
    });
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openPopup(popup: Popup): this
        // Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
        // @alternative
        // @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
        // Creates a popup with the specified content and options and opens it in the given point on a map.
        openPopup: function(popup, latlng, options) {
            this._initOverlay(Popup, popup, latlng, options).openOn(this);
            return this;
        },
        // @method closePopup(popup?: Popup): this
        // Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
        closePopup: function(popup) {
            popup = arguments.length ? popup : this._popup;
            if (popup) popup.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Popup methods example
   *
   * All layers share a set of methods convenient for binding popups to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
   * layer.openPopup();
   * layer.closePopup();
   * ```
   *
   * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
   */ // @section Popup methods
    Layer.include({
        // @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
        // Binds a popup to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindPopup: function(content, options) {
            this._popup = this._initOverlay(Popup, this._popup, content, options);
            if (!this._popupHandlersAdded) {
                this.on({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = true;
            }
            return this;
        },
        // @method unbindPopup(): this
        // Removes the popup previously bound with `bindPopup`.
        unbindPopup: function() {
            if (this._popup) {
                this.off({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = false;
                this._popup = null;
            }
            return this;
        },
        // @method openPopup(latlng?: LatLng): this
        // Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
        openPopup: function(latlng) {
            if (this._popup) {
                if (!(this instanceof FeatureGroup)) this._popup._source = this;
                if (this._popup._prepareOpen(latlng || this._latlng)) // open the popup on the map
                this._popup.openOn(this._map);
            }
            return this;
        },
        // @method closePopup(): this
        // Closes the popup bound to this layer if it is open.
        closePopup: function() {
            if (this._popup) this._popup.close();
            return this;
        },
        // @method togglePopup(): this
        // Opens or closes the popup bound to this layer depending on its current state.
        togglePopup: function() {
            if (this._popup) this._popup.toggle(this);
            return this;
        },
        // @method isPopupOpen(): boolean
        // Returns `true` if the popup bound to this layer is currently open.
        isPopupOpen: function() {
            return this._popup ? this._popup.isOpen() : false;
        },
        // @method setPopupContent(content: String|HTMLElement|Popup): this
        // Sets the content of the popup bound to this layer.
        setPopupContent: function(content) {
            if (this._popup) this._popup.setContent(content);
            return this;
        },
        // @method getPopup(): Popup
        // Returns the popup bound to this layer.
        getPopup: function() {
            return this._popup;
        },
        _openPopup: function(e) {
            if (!this._popup || !this._map) return;
            // prevent map click
            stop(e);
            var target = e.layer || e.target;
            if (this._popup._source === target && !(target instanceof Path)) {
                // treat it like a marker and figure out
                // if we should toggle it open/closed
                if (this._map.hasLayer(this._popup)) this.closePopup();
                else this.openPopup(e.latlng);
                return;
            }
            this._popup._source = target;
            this.openPopup(e.latlng);
        },
        _movePopup: function(e) {
            this._popup.setLatLng(e.latlng);
        },
        _onKeyPress: function(e) {
            if (e.originalEvent.keyCode === 13) this._openPopup(e);
        }
    });
    /*
   * @class Tooltip
   * @inherits DivOverlay
   * @aka L.Tooltip
   * Used to display small texts on top of map layers.
   *
   * @example
   * If you want to just bind a tooltip to marker:
   *
   * ```js
   * marker.bindTooltip("my tooltip text").openTooltip();
   * ```
   * Path overlays like polylines also have a `bindTooltip` method.
   *
   * A tooltip can be also standalone:
   *
   * ```js
   * var tooltip = L.tooltip()
   * 	.setLatLng(latlng)
   * 	.setContent('Hello world!<br />This is a nice tooltip.')
   * 	.addTo(map);
   * ```
   * or
   * ```js
   * var tooltip = L.tooltip(latlng, {content: 'Hello world!<br />This is a nice tooltip.'})
   * 	.addTo(map);
   * ```
   *
   *
   * Note about tooltip offset. Leaflet takes two options in consideration
   * for computing tooltip offsetting:
   * - the `offset` Tooltip option: it defaults to [0, 0], and it's specific to one tooltip.
   *   Add a positive x offset to move the tooltip to the right, and a positive y offset to
   *   move it to the bottom. Negatives will move to the left and top.
   * - the `tooltipAnchor` Icon option: this will only be considered for Marker. You
   *   should adapt this value if you use a custom icon.
   */ // @namespace Tooltip
    var Tooltip = DivOverlay.extend({
        // @section
        // @aka Tooltip options
        options: {
            // @option pane: String = 'tooltipPane'
            // `Map pane` where the tooltip will be added.
            pane: 'tooltipPane',
            // @option offset: Point = Point(0, 0)
            // Optional offset of the tooltip position.
            offset: [
                0,
                0
            ],
            // @option direction: String = 'auto'
            // Direction where to open the tooltip. Possible values are: `right`, `left`,
            // `top`, `bottom`, `center`, `auto`.
            // `auto` will dynamically switch between `right` and `left` according to the tooltip
            // position on the map.
            direction: 'auto',
            // @option permanent: Boolean = false
            // Whether to open the tooltip permanently or only on mouseover.
            permanent: false,
            // @option sticky: Boolean = false
            // If true, the tooltip will follow the mouse instead of being fixed at the feature center.
            sticky: false,
            // @option opacity: Number = 0.9
            // Tooltip container opacity.
            opacity: 0.9
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            this.setOpacity(this.options.opacity);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipopen: TooltipEvent
            // Fired when a tooltip is opened in the map.
            map.fire('tooltipopen', {
                tooltip: this
            });
            if (this._source) {
                this.addEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipopen: TooltipEvent
                // Fired when a tooltip bound to this layer is opened.
                this._source.fire('tooltipopen', {
                    tooltip: this
                }, true);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipclose: TooltipEvent
            // Fired when a tooltip in the map is closed.
            map.fire('tooltipclose', {
                tooltip: this
            });
            if (this._source) {
                this.removeEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipclose: TooltipEvent
                // Fired when a tooltip bound to this layer is closed.
                this._source.fire('tooltipclose', {
                    tooltip: this
                }, true);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (!this.options.permanent) events.preclick = this.close;
            return events;
        },
        _initLayout: function() {
            var prefix = 'leaflet-tooltip', className = prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
            this._contentNode = this._container = create$1('div', className);
            this._container.setAttribute('role', 'tooltip');
            this._container.setAttribute('id', 'leaflet-tooltip-' + stamp(this));
        },
        _updateLayout: function() {},
        _adjustPan: function() {},
        _setPosition: function(pos) {
            var subX, subY, map = this._map, container = this._container, centerPoint = map.latLngToContainerPoint(map.getCenter()), tooltipPoint = map.layerPointToContainerPoint(pos), direction = this.options.direction, tooltipWidth = container.offsetWidth, tooltipHeight = container.offsetHeight, offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (direction === 'top') {
                subX = tooltipWidth / 2;
                subY = tooltipHeight;
            } else if (direction === 'bottom') {
                subX = tooltipWidth / 2;
                subY = 0;
            } else if (direction === 'center') {
                subX = tooltipWidth / 2;
                subY = tooltipHeight / 2;
            } else if (direction === 'right') {
                subX = 0;
                subY = tooltipHeight / 2;
            } else if (direction === 'left') {
                subX = tooltipWidth;
                subY = tooltipHeight / 2;
            } else if (tooltipPoint.x < centerPoint.x) {
                direction = 'right';
                subX = 0;
                subY = tooltipHeight / 2;
            } else {
                direction = 'left';
                subX = tooltipWidth + (offset.x + anchor.x) * 2;
                subY = tooltipHeight / 2;
            }
            pos = pos.subtract(toPoint(subX, subY, true)).add(offset).add(anchor);
            removeClass(container, 'leaflet-tooltip-right');
            removeClass(container, 'leaflet-tooltip-left');
            removeClass(container, 'leaflet-tooltip-top');
            removeClass(container, 'leaflet-tooltip-bottom');
            addClass(container, 'leaflet-tooltip-' + direction);
            setPosition(container, pos);
        },
        _updatePosition: function() {
            var pos = this._map.latLngToLayerPoint(this._latlng);
            this._setPosition(pos);
        },
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._container) setOpacity(this._container, opacity);
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
            this._setPosition(pos);
        },
        _getAnchor: function() {
            // Where should we anchor the tooltip on the source layer?
            return toPoint(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Tooltip
    // @factory L.tooltip(options?: Tooltip options, source?: Layer)
    // Instantiates a `Tooltip` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the tooltip with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.tooltip(latlng: LatLng, options?: Tooltip options)
    // Instantiates a `Tooltip` object given `latlng` where the tooltip will open and an optional `options` object that describes its appearance and location.
    var tooltip = function(options, source) {
        return new Tooltip(options, source);
    };
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openTooltip(tooltip: Tooltip): this
        // Opens the specified tooltip.
        // @alternative
        // @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
        // Creates a tooltip with the specified content and options and open it.
        openTooltip: function(tooltip, latlng, options) {
            this._initOverlay(Tooltip, tooltip, latlng, options).openOn(this);
            return this;
        },
        // @method closeTooltip(tooltip: Tooltip): this
        // Closes the tooltip given as parameter.
        closeTooltip: function(tooltip) {
            tooltip.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Tooltip methods example
   *
   * All layers share a set of methods convenient for binding tooltips to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
   * layer.openTooltip();
   * layer.closeTooltip();
   * ```
   */ // @section Tooltip methods
    Layer.include({
        // @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
        // Binds a tooltip to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindTooltip: function(content, options) {
            if (this._tooltip && this.isTooltipOpen()) this.unbindTooltip();
            this._tooltip = this._initOverlay(Tooltip, this._tooltip, content, options);
            this._initTooltipInteractions();
            if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) this.openTooltip();
            return this;
        },
        // @method unbindTooltip(): this
        // Removes the tooltip previously bound with `bindTooltip`.
        unbindTooltip: function() {
            if (this._tooltip) {
                this._initTooltipInteractions(true);
                this.closeTooltip();
                this._tooltip = null;
            }
            return this;
        },
        _initTooltipInteractions: function(remove) {
            if (!remove && this._tooltipHandlersAdded) return;
            var onOff = remove ? 'off' : 'on', events = {
                remove: this.closeTooltip,
                move: this._moveTooltip
            };
            if (!this._tooltip.options.permanent) {
                events.mouseover = this._openTooltip;
                events.mouseout = this.closeTooltip;
                events.click = this._openTooltip;
                if (this._map) this._addFocusListeners();
                else events.add = this._addFocusListeners;
            } else events.add = this._openTooltip;
            if (this._tooltip.options.sticky) events.mousemove = this._moveTooltip;
            this[onOff](events);
            this._tooltipHandlersAdded = !remove;
        },
        // @method openTooltip(latlng?: LatLng): this
        // Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
        openTooltip: function(latlng) {
            if (this._tooltip) {
                if (!(this instanceof FeatureGroup)) this._tooltip._source = this;
                if (this._tooltip._prepareOpen(latlng)) {
                    // open the tooltip on the map
                    this._tooltip.openOn(this._map);
                    if (this.getElement) this._setAriaDescribedByOnLayer(this);
                    else if (this.eachLayer) this.eachLayer(this._setAriaDescribedByOnLayer, this);
                }
            }
            return this;
        },
        // @method closeTooltip(): this
        // Closes the tooltip bound to this layer if it is open.
        closeTooltip: function() {
            if (this._tooltip) return this._tooltip.close();
        },
        // @method toggleTooltip(): this
        // Opens or closes the tooltip bound to this layer depending on its current state.
        toggleTooltip: function() {
            if (this._tooltip) this._tooltip.toggle(this);
            return this;
        },
        // @method isTooltipOpen(): boolean
        // Returns `true` if the tooltip bound to this layer is currently open.
        isTooltipOpen: function() {
            return this._tooltip.isOpen();
        },
        // @method setTooltipContent(content: String|HTMLElement|Tooltip): this
        // Sets the content of the tooltip bound to this layer.
        setTooltipContent: function(content) {
            if (this._tooltip) this._tooltip.setContent(content);
            return this;
        },
        // @method getTooltip(): Tooltip
        // Returns the tooltip bound to this layer.
        getTooltip: function() {
            return this._tooltip;
        },
        _addFocusListeners: function() {
            if (this.getElement) this._addFocusListenersOnLayer(this);
            else if (this.eachLayer) this.eachLayer(this._addFocusListenersOnLayer, this);
        },
        _addFocusListenersOnLayer: function(layer) {
            var el = typeof layer.getElement === 'function' && layer.getElement();
            if (el) {
                on(el, 'focus', function() {
                    this._tooltip._source = layer;
                    this.openTooltip();
                }, this);
                on(el, 'blur', this.closeTooltip, this);
            }
        },
        _setAriaDescribedByOnLayer: function(layer) {
            var el = typeof layer.getElement === 'function' && layer.getElement();
            if (el) el.setAttribute('aria-describedby', this._tooltip._container.id);
        },
        _openTooltip: function(e) {
            if (!this._tooltip || !this._map) return;
            // If the map is moving, we will show the tooltip after it's done.
            if (this._map.dragging && this._map.dragging.moving() && !this._openOnceFlag) {
                this._openOnceFlag = true;
                var that = this;
                this._map.once('moveend', function() {
                    that._openOnceFlag = false;
                    that._openTooltip(e);
                });
                return;
            }
            this._tooltip._source = e.layer || e.target;
            this.openTooltip(this._tooltip.options.sticky ? e.latlng : undefined);
        },
        _moveTooltip: function(e) {
            var latlng = e.latlng, containerPoint, layerPoint;
            if (this._tooltip.options.sticky && e.originalEvent) {
                containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
                layerPoint = this._map.containerPointToLayerPoint(containerPoint);
                latlng = this._map.layerPointToLatLng(layerPoint);
            }
            this._tooltip.setLatLng(latlng);
        }
    });
    /*
   * @class DivIcon
   * @aka L.DivIcon
   * @inherits Icon
   *
   * Represents a lightweight icon for markers that uses a simple `<div>`
   * element instead of an image. Inherits from `Icon` but ignores the `iconUrl` and shadow options.
   *
   * @example
   * ```js
   * var myIcon = L.divIcon({className: 'my-div-icon'});
   * // you can set .my-div-icon styles in CSS
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * By default, it has a 'leaflet-div-icon' CSS class and is styled as a little white square with a shadow.
   */ var DivIcon = Icon.extend({
        options: {
            // @section
            // @aka DivIcon options
            iconSize: [
                12,
                12
            ],
            // iconAnchor: (Point),
            // popupAnchor: (Point),
            // @option html: String|HTMLElement = ''
            // Custom HTML code to put inside the div element, empty by default. Alternatively,
            // an instance of `HTMLElement`.
            html: false,
            // @option bgPos: Point = [0, 0]
            // Optional relative position of the background, in pixels
            bgPos: null,
            className: 'leaflet-div-icon'
        },
        createIcon: function(oldIcon) {
            var div = oldIcon && oldIcon.tagName === 'DIV' ? oldIcon : document.createElement('div'), options = this.options;
            if (options.html instanceof Element) {
                empty(div);
                div.appendChild(options.html);
            } else div.innerHTML = options.html !== false ? options.html : '';
            if (options.bgPos) {
                var bgPos = toPoint(options.bgPos);
                div.style.backgroundPosition = -bgPos.x + 'px ' + -bgPos.y + 'px';
            }
            this._setIconStyles(div, 'icon');
            return div;
        },
        createShadow: function() {
            return null;
        }
    });
    // @factory L.divIcon(options: DivIcon options)
    // Creates a `DivIcon` instance with the given options.
    function divIcon(options) {
        return new DivIcon(options);
    }
    Icon.Default = IconDefault;
    /*
   * @class GridLayer
   * @inherits Layer
   * @aka L.GridLayer
   *
   * Generic class for handling a tiled grid of HTML elements. This is the base class for all tile layers and replaces `TileLayer.Canvas`.
   * GridLayer can be extended to create a tiled grid of HTML elements like `<canvas>`, `<img>` or `<div>`. GridLayer will handle creating and animating these DOM elements for you.
   *
   *
   * @section Synchronous usage
   * @example
   *
   * To create a custom layer, extend GridLayer and implement the `createTile()` method, which will be passed a `Point` object with the `x`, `y`, and `z` (zoom level) coordinates to draw your tile.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords){
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // get a canvas context and draw something on it using coords.x, coords.y and coords.z
   *         var ctx = tile.getContext('2d');
   *
   *         // return the tile so it can be rendered on screen
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section Asynchronous usage
   * @example
   *
   * Tile creation can also be asynchronous, this is useful when using a third-party drawing library. Once the tile is finished drawing it can be passed to the `done()` callback.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords, done){
   *         var error;
   *
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // draw something asynchronously and pass the tile to the done() callback
   *         setTimeout(function() {
   *             done(error, tile);
   *         }, 1000);
   *
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section
   */ var GridLayer = Layer.extend({
        // @section
        // @aka GridLayer options
        options: {
            // @option tileSize: Number|Point = 256
            // Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
            tileSize: 256,
            // @option opacity: Number = 1.0
            // Opacity of the tiles. Can be used in the `createTile()` function.
            opacity: 1,
            // @option updateWhenIdle: Boolean = (depends)
            // Load new tiles only when panning ends.
            // `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
            // `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
            // [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
            updateWhenIdle: Browser.mobile,
            // @option updateWhenZooming: Boolean = true
            // By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
            updateWhenZooming: true,
            // @option updateInterval: Number = 200
            // Tiles will not update more than once every `updateInterval` milliseconds when panning.
            updateInterval: 200,
            // @option zIndex: Number = 1
            // The explicit zIndex of the tile layer.
            zIndex: 1,
            // @option bounds: LatLngBounds = undefined
            // If set, tiles will only be loaded inside the set `LatLngBounds`.
            bounds: null,
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = undefined
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: undefined,
            // @option maxNativeZoom: Number = undefined
            // Maximum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
            // from `maxNativeZoom` level and auto-scaled.
            maxNativeZoom: undefined,
            // @option minNativeZoom: Number = undefined
            // Minimum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels lower than `minNativeZoom` will be loaded
            // from `minNativeZoom` level and auto-scaled.
            minNativeZoom: undefined,
            // @option noWrap: Boolean = false
            // Whether the layer is wrapped around the antimeridian. If `true`, the
            // GridLayer will only be displayed once at low zoom levels. Has no
            // effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
            // in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
            // tiles outside the CRS limits.
            noWrap: false,
            // @option pane: String = 'tilePane'
            // `Map pane` where the grid layer will be added.
            pane: 'tilePane',
            // @option className: String = ''
            // A custom class name to assign to the tile layer. Empty by default.
            className: '',
            // @option keepBuffer: Number = 2
            // When panning the map, keep this many rows and columns of tiles before unloading them.
            keepBuffer: 2
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        onAdd: function() {
            this._initContainer();
            this._levels = {};
            this._tiles = {};
            this._resetView(); // implicit _update() call
        },
        beforeAdd: function(map) {
            map._addZoomLimit(this);
        },
        onRemove: function(map) {
            this._removeAllTiles();
            remove(this._container);
            map._removeZoomLimit(this);
            this._container = null;
            this._tileZoom = undefined;
        },
        // @method bringToFront: this
        // Brings the tile layer to the top of all tile layers.
        bringToFront: function() {
            if (this._map) {
                toFront(this._container);
                this._setAutoZIndex(Math.max);
            }
            return this;
        },
        // @method bringToBack: this
        // Brings the tile layer to the bottom of all tile layers.
        bringToBack: function() {
            if (this._map) {
                toBack(this._container);
                this._setAutoZIndex(Math.min);
            }
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the tiles for this layer.
        getContainer: function() {
            return this._container;
        },
        // @method setOpacity(opacity: Number): this
        // Changes the [opacity](#gridlayer-opacity) of the grid layer.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            this._updateOpacity();
            return this;
        },
        // @method setZIndex(zIndex: Number): this
        // Changes the [zIndex](#gridlayer-zindex) of the grid layer.
        setZIndex: function(zIndex) {
            this.options.zIndex = zIndex;
            this._updateZIndex();
            return this;
        },
        // @method isLoading: Boolean
        // Returns `true` if any tile in the grid layer has not finished loading.
        isLoading: function() {
            return this._loading;
        },
        // @method redraw: this
        // Causes the layer to clear all the tiles and request them again.
        redraw: function() {
            if (this._map) {
                this._removeAllTiles();
                var tileZoom = this._clampZoom(this._map.getZoom());
                if (tileZoom !== this._tileZoom) {
                    this._tileZoom = tileZoom;
                    this._updateLevels();
                }
                this._update();
            }
            return this;
        },
        getEvents: function() {
            var events = {
                viewprereset: this._invalidateAll,
                viewreset: this._resetView,
                zoom: this._resetView,
                moveend: this._onMoveEnd
            };
            if (!this.options.updateWhenIdle) {
                // update tiles on move, but not more often than once per given interval
                if (!this._onMove) this._onMove = throttle(this._onMoveEnd, this.options.updateInterval, this);
                events.move = this._onMove;
            }
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @section Extension methods
        // Layers extending `GridLayer` shall reimplement the following method.
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, must be overridden by classes extending `GridLayer`.
        // Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
        // is specified, it must be called when the tile has finished loading and drawing.
        createTile: function() {
            return document.createElement('div');
        },
        // @section
        // @method getTileSize: Point
        // Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
        getTileSize: function() {
            var s = this.options.tileSize;
            return s instanceof Point ? s : new Point(s, s);
        },
        _updateZIndex: function() {
            if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) this._container.style.zIndex = this.options.zIndex;
        },
        _setAutoZIndex: function(compare) {
            // go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)
            var layers = this.getPane().children, edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min
            for(var i = 0, len = layers.length, zIndex; i < len; i++){
                zIndex = layers[i].style.zIndex;
                if (layers[i] !== this._container && zIndex) edgeZIndex = compare(edgeZIndex, +zIndex);
            }
            if (isFinite(edgeZIndex)) {
                this.options.zIndex = edgeZIndex + compare(-1, 1);
                this._updateZIndex();
            }
        },
        _updateOpacity: function() {
            if (!this._map) return;
            // IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
            if (Browser.ielt9) return;
            setOpacity(this._container, this.options.opacity);
            var now = +new Date(), nextFrame = false, willPrune = false;
            for(var key in this._tiles){
                var tile = this._tiles[key];
                if (!tile.current || !tile.loaded) continue;
                var fade = Math.min(1, (now - tile.loaded) / 200);
                setOpacity(tile.el, fade);
                if (fade < 1) nextFrame = true;
                else {
                    if (tile.active) willPrune = true;
                    else this._onOpaqueTile(tile);
                    tile.active = true;
                }
            }
            if (willPrune && !this._noPrune) this._pruneTiles();
            if (nextFrame) {
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            }
        },
        _onOpaqueTile: falseFn,
        _initContainer: function() {
            if (this._container) return;
            this._container = create$1('div', 'leaflet-layer ' + (this.options.className || ''));
            this._updateZIndex();
            if (this.options.opacity < 1) this._updateOpacity();
            this.getPane().appendChild(this._container);
        },
        _updateLevels: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom;
            if (zoom === undefined) return undefined;
            for(var z in this._levels){
                z = Number(z);
                if (this._levels[z].el.children.length || z === zoom) {
                    this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
                    this._onUpdateLevel(z);
                } else {
                    remove(this._levels[z].el);
                    this._removeTilesAtZoom(z);
                    this._onRemoveLevel(z);
                    delete this._levels[z];
                }
            }
            var level = this._levels[zoom], map = this._map;
            if (!level) {
                level = this._levels[zoom] = {};
                level.el = create$1('div', 'leaflet-tile-container leaflet-zoom-animated', this._container);
                level.el.style.zIndex = maxZoom;
                level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
                level.zoom = zoom;
                this._setZoomTransform(level, map.getCenter(), map.getZoom());
                // force the browser to consider the newly added element for transition
                falseFn(level.el.offsetWidth);
                this._onCreateLevel(level);
            }
            this._level = level;
            return level;
        },
        _onUpdateLevel: falseFn,
        _onRemoveLevel: falseFn,
        _onCreateLevel: falseFn,
        _pruneTiles: function() {
            if (!this._map) return;
            var key, tile;
            var zoom = this._map.getZoom();
            if (zoom > this.options.maxZoom || zoom < this.options.minZoom) {
                this._removeAllTiles();
                return;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                tile.retain = tile.current;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                if (tile.current && !tile.active) {
                    var coords = tile.coords;
                    if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
                }
            }
            for(key in this._tiles)if (!this._tiles[key].retain) this._removeTile(key);
        },
        _removeTilesAtZoom: function(zoom) {
            for(var key in this._tiles){
                if (this._tiles[key].coords.z !== zoom) continue;
                this._removeTile(key);
            }
        },
        _removeAllTiles: function() {
            for(var key in this._tiles)this._removeTile(key);
        },
        _invalidateAll: function() {
            for(var z in this._levels){
                remove(this._levels[z].el);
                this._onRemoveLevel(Number(z));
                delete this._levels[z];
            }
            this._removeAllTiles();
            this._tileZoom = undefined;
        },
        _retainParent: function(x, y, z, minZoom) {
            var x2 = Math.floor(x / 2), y2 = Math.floor(y / 2), z2 = z - 1, coords2 = new Point(+x2, +y2);
            coords2.z = +z2;
            var key = this._tileCoordsToKey(coords2), tile = this._tiles[key];
            if (tile && tile.active) {
                tile.retain = true;
                return true;
            } else if (tile && tile.loaded) tile.retain = true;
            if (z2 > minZoom) return this._retainParent(x2, y2, z2, minZoom);
            return false;
        },
        _retainChildren: function(x, y, z, maxZoom) {
            for(var i = 2 * x; i < 2 * x + 2; i++)for(var j = 2 * y; j < 2 * y + 2; j++){
                var coords = new Point(i, j);
                coords.z = z + 1;
                var key = this._tileCoordsToKey(coords), tile = this._tiles[key];
                if (tile && tile.active) {
                    tile.retain = true;
                    continue;
                } else if (tile && tile.loaded) tile.retain = true;
                if (z + 1 < maxZoom) this._retainChildren(i, j, z + 1, maxZoom);
            }
        },
        _resetView: function(e) {
            var animating = e && (e.pinch || e.flyTo);
            this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
        },
        _animateZoom: function(e) {
            this._setView(e.center, e.zoom, true, e.noUpdate);
        },
        _clampZoom: function(zoom) {
            var options = this.options;
            if (undefined !== options.minNativeZoom && zoom < options.minNativeZoom) return options.minNativeZoom;
            if (undefined !== options.maxNativeZoom && options.maxNativeZoom < zoom) return options.maxNativeZoom;
            return zoom;
        },
        _setView: function(center, zoom, noPrune, noUpdate) {
            var tileZoom = Math.round(zoom);
            if (this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom || this.options.minZoom !== undefined && tileZoom < this.options.minZoom) tileZoom = undefined;
            else tileZoom = this._clampZoom(tileZoom);
            var tileZoomChanged = this.options.updateWhenZooming && tileZoom !== this._tileZoom;
            if (!noUpdate || tileZoomChanged) {
                this._tileZoom = tileZoom;
                if (this._abortLoading) this._abortLoading();
                this._updateLevels();
                this._resetGrid();
                if (tileZoom !== undefined) this._update(center);
                if (!noPrune) this._pruneTiles();
                // Flag to prevent _updateOpacity from pruning tiles during
                // a zoom anim or a pinch gesture
                this._noPrune = !!noPrune;
            }
            this._setZoomTransforms(center, zoom);
        },
        _setZoomTransforms: function(center, zoom) {
            for(var i in this._levels)this._setZoomTransform(this._levels[i], center, zoom);
        },
        _setZoomTransform: function(level, center, zoom) {
            var scale = this._map.getZoomScale(zoom, level.zoom), translate = level.origin.multiplyBy(scale).subtract(this._map._getNewPixelOrigin(center, zoom)).round();
            if (Browser.any3d) setTransform(level.el, translate, scale);
            else setPosition(level.el, translate);
        },
        _resetGrid: function() {
            var map = this._map, crs = map.options.crs, tileSize = this._tileSize = this.getTileSize(), tileZoom = this._tileZoom;
            var bounds = this._map.getPixelWorldBounds(this._tileZoom);
            if (bounds) this._globalTileRange = this._pxBoundsToTileRange(bounds);
            this._wrapX = crs.wrapLng && !this.options.noWrap && [
                Math.floor(map.project([
                    0,
                    crs.wrapLng[0]
                ], tileZoom).x / tileSize.x),
                Math.ceil(map.project([
                    0,
                    crs.wrapLng[1]
                ], tileZoom).x / tileSize.y)
            ];
            this._wrapY = crs.wrapLat && !this.options.noWrap && [
                Math.floor(map.project([
                    crs.wrapLat[0],
                    0
                ], tileZoom).y / tileSize.x),
                Math.ceil(map.project([
                    crs.wrapLat[1],
                    0
                ], tileZoom).y / tileSize.y)
            ];
        },
        _onMoveEnd: function() {
            if (!this._map || this._map._animatingZoom) return;
            this._update();
        },
        _getTiledPixelBounds: function(center) {
            var map = this._map, mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(), scale = map.getZoomScale(mapZoom, this._tileZoom), pixelCenter = map.project(center, this._tileZoom).floor(), halfSize = map.getSize().divideBy(scale * 2);
            return new Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
        },
        // Private method to load tiles in the grid's active zoom level according to map bounds
        _update: function(center) {
            var map = this._map;
            if (!map) return;
            var zoom = this._clampZoom(map.getZoom());
            if (center === undefined) center = map.getCenter();
            if (this._tileZoom === undefined) return;
             // if out of minzoom/maxzoom
            var pixelBounds = this._getTiledPixelBounds(center), tileRange = this._pxBoundsToTileRange(pixelBounds), tileCenter = tileRange.getCenter(), queue = [], margin = this.options.keepBuffer, noPruneRange = new Bounds(tileRange.getBottomLeft().subtract([
                margin,
                -margin
            ]), tileRange.getTopRight().add([
                margin,
                -margin
            ]));
            // Sanity check: panic if the tile range contains Infinity somewhere.
            if (!(isFinite(tileRange.min.x) && isFinite(tileRange.min.y) && isFinite(tileRange.max.x) && isFinite(tileRange.max.y))) throw new Error('Attempted to load an infinite number of tiles');
            for(var key in this._tiles){
                var c = this._tiles[key].coords;
                if (c.z !== this._tileZoom || !noPruneRange.contains(new Point(c.x, c.y))) this._tiles[key].current = false;
            }
            // _update just loads more tiles. If the tile zoom level differs too much
            // from the map's, let _setView reset levels and prune old tiles.
            if (Math.abs(zoom - this._tileZoom) > 1) {
                this._setView(center, zoom);
                return;
            }
            // create a queue of coordinates to load tiles from
            for(var j = tileRange.min.y; j <= tileRange.max.y; j++)for(var i = tileRange.min.x; i <= tileRange.max.x; i++){
                var coords = new Point(i, j);
                coords.z = this._tileZoom;
                if (!this._isValidTile(coords)) continue;
                var tile = this._tiles[this._tileCoordsToKey(coords)];
                if (tile) tile.current = true;
                else queue.push(coords);
            }
            // sort tile queue to load tiles in order of their distance to center
            queue.sort(function(a, b) {
                return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
            });
            if (queue.length !== 0) {
                // if it's the first batch of tiles to load
                if (!this._loading) {
                    this._loading = true;
                    // @event loading: Event
                    // Fired when the grid layer starts loading tiles.
                    this.fire('loading');
                }
                // create DOM fragment to append tiles in one batch
                var fragment = document.createDocumentFragment();
                for(i = 0; i < queue.length; i++)this._addTile(queue[i], fragment);
                this._level.el.appendChild(fragment);
            }
        },
        _isValidTile: function(coords) {
            var crs = this._map.options.crs;
            if (!crs.infinite) {
                // don't load tile if it's out of bounds and not wrapped
                var bounds = this._globalTileRange;
                if (!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x) || !crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y)) return false;
            }
            if (!this.options.bounds) return true;
            // don't load tile if it doesn't intersect the bounds in options
            var tileBounds = this._tileCoordsToBounds(coords);
            return toLatLngBounds(this.options.bounds).overlaps(tileBounds);
        },
        _keyToBounds: function(key) {
            return this._tileCoordsToBounds(this._keyToTileCoords(key));
        },
        _tileCoordsToNwSe: function(coords) {
            var map = this._map, tileSize = this.getTileSize(), nwPoint = coords.scaleBy(tileSize), sePoint = nwPoint.add(tileSize), nw = map.unproject(nwPoint, coords.z), se = map.unproject(sePoint, coords.z);
            return [
                nw,
                se
            ];
        },
        // converts tile coordinates to its geographical bounds
        _tileCoordsToBounds: function(coords) {
            var bp = this._tileCoordsToNwSe(coords), bounds = new LatLngBounds(bp[0], bp[1]);
            if (!this.options.noWrap) bounds = this._map.wrapLatLngBounds(bounds);
            return bounds;
        },
        // converts tile coordinates to key for the tile cache
        _tileCoordsToKey: function(coords) {
            return coords.x + ':' + coords.y + ':' + coords.z;
        },
        // converts tile cache key to coordinates
        _keyToTileCoords: function(key) {
            var k = key.split(':'), coords = new Point(+k[0], +k[1]);
            coords.z = +k[2];
            return coords;
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            remove(tile.el);
            delete this._tiles[key];
            // @event tileunload: TileEvent
            // Fired when a tile is removed (e.g. when a tile goes off the screen).
            this.fire('tileunload', {
                tile: tile.el,
                coords: this._keyToTileCoords(key)
            });
        },
        _initTile: function(tile) {
            addClass(tile, 'leaflet-tile');
            var tileSize = this.getTileSize();
            tile.style.width = tileSize.x + 'px';
            tile.style.height = tileSize.y + 'px';
            tile.onselectstart = falseFn;
            tile.onmousemove = falseFn;
            // update opacity on tiles in IE7-8 because of filter inheritance problems
            if (Browser.ielt9 && this.options.opacity < 1) setOpacity(tile, this.options.opacity);
        },
        _addTile: function(coords, container) {
            var tilePos = this._getTilePos(coords), key = this._tileCoordsToKey(coords);
            var tile = this.createTile(this._wrapCoords(coords), bind(this._tileReady, this, coords));
            this._initTile(tile);
            // if createTile is defined with a second argument ("done" callback),
            // we know that tile is async and will be ready later; otherwise
            if (this.createTile.length < 2) // mark tile as ready, but delay one frame for opacity animation to happen
            requestAnimFrame(bind(this._tileReady, this, coords, null, tile));
            setPosition(tile, tilePos);
            // save tile in cache
            this._tiles[key] = {
                el: tile,
                coords: coords,
                current: true
            };
            container.appendChild(tile);
            // @event tileloadstart: TileEvent
            // Fired when a tile is requested and starts loading.
            this.fire('tileloadstart', {
                tile: tile,
                coords: coords
            });
        },
        _tileReady: function(coords, err, tile) {
            if (err) // @event tileerror: TileErrorEvent
            // Fired when there is an error loading a tile.
            this.fire('tileerror', {
                error: err,
                tile: tile,
                coords: coords
            });
            var key = this._tileCoordsToKey(coords);
            tile = this._tiles[key];
            if (!tile) return;
            tile.loaded = +new Date();
            if (this._map._fadeAnimated) {
                setOpacity(tile.el, 0);
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            } else {
                tile.active = true;
                this._pruneTiles();
            }
            if (!err) {
                addClass(tile.el, 'leaflet-tile-loaded');
                // @event tileload: TileEvent
                // Fired when a tile loads.
                this.fire('tileload', {
                    tile: tile.el,
                    coords: coords
                });
            }
            if (this._noTilesToLoad()) {
                this._loading = false;
                // @event load: Event
                // Fired when the grid layer loaded all visible tiles.
                this.fire('load');
                if (Browser.ielt9 || !this._map._fadeAnimated) requestAnimFrame(this._pruneTiles, this);
                else // Wait a bit more than 0.2 secs (the duration of the tile fade-in)
                // to trigger a pruning.
                setTimeout(bind(this._pruneTiles, this), 250);
            }
        },
        _getTilePos: function(coords) {
            return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
        },
        _wrapCoords: function(coords) {
            var newCoords = new Point(this._wrapX ? wrapNum(coords.x, this._wrapX) : coords.x, this._wrapY ? wrapNum(coords.y, this._wrapY) : coords.y);
            newCoords.z = coords.z;
            return newCoords;
        },
        _pxBoundsToTileRange: function(bounds) {
            var tileSize = this.getTileSize();
            return new Bounds(bounds.min.unscaleBy(tileSize).floor(), bounds.max.unscaleBy(tileSize).ceil().subtract([
                1,
                1
            ]));
        },
        _noTilesToLoad: function() {
            for(var key in this._tiles){
                if (!this._tiles[key].loaded) return false;
            }
            return true;
        }
    });
    // @factory L.gridLayer(options?: GridLayer options)
    // Creates a new instance of GridLayer with the supplied options.
    function gridLayer(options) {
        return new GridLayer(options);
    }
    /*
   * @class TileLayer
   * @inherits GridLayer
   * @aka L.TileLayer
   * Used to load and display tile layers on the map. Note that most tile servers require attribution, which you can set under `Layer`. Extends `GridLayer`.
   *
   * @example
   *
   * ```js
   * L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar', attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'}).addTo(map);
   * ```
   *
   * @section URL template
   * @example
   *
   * A string of the following form:
   *
   * ```
   * 'https://{s}.somedomain.com/blabla/{z}/{x}/{y}{r}.png'
   * ```
   *
   * `{s}` means one of the available subdomains (used sequentially to help with browser parallel requests per domain limitation; subdomain values are specified in options; `a`, `b` or `c` by default, can be omitted), `{z}` — zoom level, `{x}` and `{y}` — tile coordinates. `{r}` can be used to add "&commat;2x" to the URL to load retina tiles.
   *
   * You can use custom keys in the template, which will be [evaluated](#util-template) from TileLayer options, like this:
   *
   * ```
   * L.tileLayer('https://{s}.somedomain.com/{foo}/{z}/{x}/{y}.png', {foo: 'bar'});
   * ```
   */ var TileLayer = GridLayer.extend({
        // @section
        // @aka TileLayer options
        options: {
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = 18
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: 18,
            // @option subdomains: String|String[] = 'abc'
            // Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
            subdomains: 'abc',
            // @option errorTileUrl: String = ''
            // URL to the tile image to show in place of the tile that failed to load.
            errorTileUrl: '',
            // @option zoomOffset: Number = 0
            // The zoom number used in tile URLs will be offset with this value.
            zoomOffset: 0,
            // @option tms: Boolean = false
            // If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
            tms: false,
            // @option zoomReverse: Boolean = false
            // If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
            zoomReverse: false,
            // @option detectRetina: Boolean = false
            // If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
            detectRetina: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option referrerPolicy: Boolean|String = false
            // Whether the referrerPolicy attribute will be added to the tiles.
            // If a String is provided, all tiles will have their referrerPolicy attribute set to the String provided.
            // This may be needed if your map's rendering context has a strict default but your tile provider expects a valid referrer
            // (e.g. to validate an API token).
            // Refer to [HTMLImageElement.referrerPolicy](https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/referrerPolicy) for valid String values.
            referrerPolicy: false
        },
        initialize: function(url, options) {
            this._url = url;
            options = setOptions(this, options);
            // detecting retina displays, adjusting tileSize and zoom levels
            if (options.detectRetina && Browser.retina && options.maxZoom > 0) {
                options.tileSize = Math.floor(options.tileSize / 2);
                if (!options.zoomReverse) {
                    options.zoomOffset++;
                    options.maxZoom = Math.max(options.minZoom, options.maxZoom - 1);
                } else {
                    options.zoomOffset--;
                    options.minZoom = Math.min(options.maxZoom, options.minZoom + 1);
                }
                options.minZoom = Math.max(0, options.minZoom);
            } else if (!options.zoomReverse) // make sure maxZoom is gte minZoom
            options.maxZoom = Math.max(options.minZoom, options.maxZoom);
            else // make sure minZoom is lte maxZoom
            options.minZoom = Math.min(options.maxZoom, options.minZoom);
            if (typeof options.subdomains === 'string') options.subdomains = options.subdomains.split('');
            this.on('tileunload', this._onTileRemove);
        },
        // @method setUrl(url: String, noRedraw?: Boolean): this
        // Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
        // If the URL does not change, the layer will not be redrawn unless
        // the noRedraw parameter is set to false.
        setUrl: function(url, noRedraw) {
            if (this._url === url && noRedraw === undefined) noRedraw = true;
            this._url = url;
            if (!noRedraw) this.redraw();
            return this;
        },
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
        // to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
        // callback is called when the tile has been loaded.
        createTile: function(coords, done) {
            var tile = document.createElement('img');
            on(tile, 'load', bind(this._tileOnLoad, this, done, tile));
            on(tile, 'error', bind(this._tileOnError, this, done, tile));
            if (this.options.crossOrigin || this.options.crossOrigin === '') tile.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            // for this new option we follow the documented behavior
            // more closely by only setting the property when string
            if (typeof this.options.referrerPolicy === 'string') tile.referrerPolicy = this.options.referrerPolicy;
            // The alt attribute is set to the empty string,
            // allowing screen readers to ignore the decorative image tiles.
            // https://www.w3.org/WAI/tutorials/images/decorative/
            // https://www.w3.org/TR/html-aria/#el-img-empty-alt
            tile.alt = '';
            tile.src = this.getTileUrl(coords);
            return tile;
        },
        // @section Extension methods
        // @uninheritable
        // Layers extending `TileLayer` might reimplement the following method.
        // @method getTileUrl(coords: Object): String
        // Called only internally, returns the URL for a tile given its coordinates.
        // Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
        getTileUrl: function(coords) {
            var data = {
                r: Browser.retina ? '@2x' : '',
                s: this._getSubdomain(coords),
                x: coords.x,
                y: coords.y,
                z: this._getZoomForUrl()
            };
            if (this._map && !this._map.options.crs.infinite) {
                var invertedY = this._globalTileRange.max.y - coords.y;
                if (this.options.tms) data['y'] = invertedY;
                data['-y'] = invertedY;
            }
            return template(this._url, extend(data, this.options));
        },
        _tileOnLoad: function(done, tile) {
            // For https://github.com/Leaflet/Leaflet/issues/3332
            if (Browser.ielt9) setTimeout(bind(done, this, null, tile), 0);
            else done(null, tile);
        },
        _tileOnError: function(done, tile, e) {
            var errorUrl = this.options.errorTileUrl;
            if (errorUrl && tile.getAttribute('src') !== errorUrl) tile.src = errorUrl;
            done(e, tile);
        },
        _onTileRemove: function(e) {
            e.tile.onload = null;
        },
        _getZoomForUrl: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom, zoomReverse = this.options.zoomReverse, zoomOffset = this.options.zoomOffset;
            if (zoomReverse) zoom = maxZoom - zoom;
            return zoom + zoomOffset;
        },
        _getSubdomain: function(tilePoint) {
            var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
            return this.options.subdomains[index];
        },
        // stops loading all tiles in the background layer
        _abortLoading: function() {
            var i, tile;
            for(i in this._tiles)if (this._tiles[i].coords.z !== this._tileZoom) {
                tile = this._tiles[i].el;
                tile.onload = falseFn;
                tile.onerror = falseFn;
                if (!tile.complete) {
                    tile.src = emptyImageUrl;
                    var coords = this._tiles[i].coords;
                    remove(tile);
                    delete this._tiles[i];
                    // @event tileabort: TileEvent
                    // Fired when a tile was loading but is now not wanted.
                    this.fire('tileabort', {
                        tile: tile,
                        coords: coords
                    });
                }
            }
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            // Cancels any pending http requests associated with the tile
            tile.el.setAttribute('src', emptyImageUrl);
            return GridLayer.prototype._removeTile.call(this, key);
        },
        _tileReady: function(coords, err, tile) {
            if (!this._map || tile && tile.getAttribute('src') === emptyImageUrl) return;
            return GridLayer.prototype._tileReady.call(this, coords, err, tile);
        }
    });
    // @factory L.tilelayer(urlTemplate: String, options?: TileLayer options)
    // Instantiates a tile layer object given a `URL template` and optionally an options object.
    function tileLayer(url, options) {
        return new TileLayer(url, options);
    }
    /*
   * @class TileLayer.WMS
   * @inherits TileLayer
   * @aka L.TileLayer.WMS
   * Used to display [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services as tile layers on the map. Extends `TileLayer`.
   *
   * @example
   *
   * ```js
   * var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
   * 	layers: 'nexrad-n0r-900913',
   * 	format: 'image/png',
   * 	transparent: true,
   * 	attribution: "Weather data © 2012 IEM Nexrad"
   * });
   * ```
   */ var TileLayerWMS = TileLayer.extend({
        // @section
        // @aka TileLayer.WMS options
        // If any custom options not documented here are used, they will be sent to the
        // WMS server as extra parameters in each request URL. This can be useful for
        // [non-standard vendor WMS parameters](https://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
        defaultWmsParams: {
            service: 'WMS',
            request: 'GetMap',
            // @option layers: String = ''
            // **(required)** Comma-separated list of WMS layers to show.
            layers: '',
            // @option styles: String = ''
            // Comma-separated list of WMS styles.
            styles: '',
            // @option format: String = 'image/jpeg'
            // WMS image format (use `'image/png'` for layers with transparency).
            format: 'image/jpeg',
            // @option transparent: Boolean = false
            // If `true`, the WMS service will return images with transparency.
            transparent: false,
            // @option version: String = '1.1.1'
            // Version of the WMS service to use
            version: '1.1.1'
        },
        options: {
            // @option crs: CRS = null
            // Coordinate Reference System to use for the WMS requests, defaults to
            // map CRS. Don't change this if you're not sure what it means.
            crs: null,
            // @option uppercase: Boolean = false
            // If `true`, WMS request parameter keys will be uppercase.
            uppercase: false
        },
        initialize: function(url, options) {
            this._url = url;
            var wmsParams = extend({}, this.defaultWmsParams);
            // all keys that are not TileLayer options go to WMS params
            for(var i in options)if (!(i in this.options)) wmsParams[i] = options[i];
            options = setOptions(this, options);
            var realRetina = options.detectRetina && Browser.retina ? 2 : 1;
            var tileSize = this.getTileSize();
            wmsParams.width = tileSize.x * realRetina;
            wmsParams.height = tileSize.y * realRetina;
            this.wmsParams = wmsParams;
        },
        onAdd: function(map) {
            this._crs = this.options.crs || map.options.crs;
            this._wmsVersion = parseFloat(this.wmsParams.version);
            var projectionKey = this._wmsVersion >= 1.3 ? 'crs' : 'srs';
            this.wmsParams[projectionKey] = this._crs.code;
            TileLayer.prototype.onAdd.call(this, map);
        },
        getTileUrl: function(coords) {
            var tileBounds = this._tileCoordsToNwSe(coords), crs = this._crs, bounds = toBounds(crs.project(tileBounds[0]), crs.project(tileBounds[1])), min = bounds.min, max = bounds.max, bbox = (this._wmsVersion >= 1.3 && this._crs === EPSG4326 ? [
                min.y,
                min.x,
                max.y,
                max.x
            ] : [
                min.x,
                min.y,
                max.x,
                max.y
            ]).join(','), url = TileLayer.prototype.getTileUrl.call(this, coords);
            return url + getParamString(this.wmsParams, url, this.options.uppercase) + (this.options.uppercase ? '&BBOX=' : '&bbox=') + bbox;
        },
        // @method setParams(params: Object, noRedraw?: Boolean): this
        // Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
        setParams: function(params, noRedraw) {
            extend(this.wmsParams, params);
            if (!noRedraw) this.redraw();
            return this;
        }
    });
    // @factory L.tileLayer.wms(baseUrl: String, options: TileLayer.WMS options)
    // Instantiates a WMS tile layer object given a base URL of the WMS service and a WMS parameters/options object.
    function tileLayerWMS(url, options) {
        return new TileLayerWMS(url, options);
    }
    TileLayer.WMS = TileLayerWMS;
    tileLayer.wms = tileLayerWMS;
    /*
   * @class Renderer
   * @inherits Layer
   * @aka L.Renderer
   *
   * Base class for vector renderer implementations (`SVG`, `Canvas`). Handles the
   * DOM container of the renderer, its bounds, and its zoom animation.
   *
   * A `Renderer` works as an implicit layer group for all `Path`s - the renderer
   * itself can be added or removed to the map. All paths use a renderer, which can
   * be implicit (the map will decide the type of renderer and use it automatically)
   * or explicit (using the [`renderer`](#path-renderer) option of the path).
   *
   * Do not use this class directly, use `SVG` and `Canvas` instead.
   *
   * @event update: Event
   * Fired when the renderer updates its bounds, center and zoom, for example when
   * its map has moved
   */ var Renderer = Layer.extend({
        // @section
        // @aka Renderer options
        options: {
            // @option padding: Number = 0.1
            // How much to extend the clip area around the map view (relative to its size)
            // e.g. 0.1 would be 10% of map view in each direction
            padding: 0.1
        },
        initialize: function(options) {
            setOptions(this, options);
            stamp(this);
            this._layers = this._layers || {};
        },
        onAdd: function() {
            if (!this._container) {
                this._initContainer(); // defined by renderer implementations
                // always keep transform-origin as 0 0
                addClass(this._container, 'leaflet-zoom-animated');
            }
            this.getPane().appendChild(this._container);
            this._update();
            this.on('update', this._updatePaths, this);
        },
        onRemove: function() {
            this.off('update', this._updatePaths, this);
            this._destroyContainer();
        },
        getEvents: function() {
            var events = {
                viewreset: this._reset,
                zoom: this._onZoom,
                moveend: this._update,
                zoomend: this._onZoomEnd
            };
            if (this._zoomAnimated) events.zoomanim = this._onAnimZoom;
            return events;
        },
        _onAnimZoom: function(ev) {
            this._updateTransform(ev.center, ev.zoom);
        },
        _onZoom: function() {
            this._updateTransform(this._map.getCenter(), this._map.getZoom());
        },
        _updateTransform: function(center, zoom) {
            var scale = this._map.getZoomScale(zoom, this._zoom), viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding), currentCenterPoint = this._map.project(this._center, zoom), topLeftOffset = viewHalf.multiplyBy(-scale).add(currentCenterPoint).subtract(this._map._getNewPixelOrigin(center, zoom));
            if (Browser.any3d) setTransform(this._container, topLeftOffset, scale);
            else setPosition(this._container, topLeftOffset);
        },
        _reset: function() {
            this._update();
            this._updateTransform(this._center, this._zoom);
            for(var id in this._layers)this._layers[id]._reset();
        },
        _onZoomEnd: function() {
            for(var id in this._layers)this._layers[id]._project();
        },
        _updatePaths: function() {
            for(var id in this._layers)this._layers[id]._update();
        },
        _update: function() {
            // Update pixel bounds of renderer container (for positioning/sizing/clipping later)
            // Subclasses are responsible of firing the 'update' event.
            var p = this.options.padding, size = this._map.getSize(), min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();
            this._bounds = new Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());
            this._center = this._map.getCenter();
            this._zoom = this._map.getZoom();
        }
    });
    /*
   * @class Canvas
   * @inherits Renderer
   * @aka L.Canvas
   *
   * Allows vector layers to be displayed with [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/canvas), Canvas is not
   * available in all web browsers, notably IE8, and overlapping geometries might
   * not display properly in some edge cases.
   *
   * @example
   *
   * Use Canvas by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.canvas()
   * });
   * ```
   *
   * Use a Canvas renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.canvas({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var Canvas = Renderer.extend({
        // @section
        // @aka Canvas options
        options: {
            // @option tolerance: Number = 0
            // How much to extend the click tolerance around a path/object on the map.
            tolerance: 0
        },
        getEvents: function() {
            var events = Renderer.prototype.getEvents.call(this);
            events.viewprereset = this._onViewPreReset;
            return events;
        },
        _onViewPreReset: function() {
            // Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
            this._postponeUpdatePaths = true;
        },
        onAdd: function() {
            Renderer.prototype.onAdd.call(this);
            // Redraw vectors since canvas is cleared upon removal,
            // in case of removing the renderer itself from the map.
            this._draw();
        },
        _initContainer: function() {
            var container = this._container = document.createElement('canvas');
            on(container, 'mousemove', this._onMouseMove, this);
            on(container, 'click dblclick mousedown mouseup contextmenu', this._onClick, this);
            on(container, 'mouseout', this._handleMouseOut, this);
            container['_leaflet_disable_events'] = true;
            this._ctx = container.getContext('2d');
        },
        _destroyContainer: function() {
            cancelAnimFrame(this._redrawRequest);
            delete this._ctx;
            remove(this._container);
            off(this._container);
            delete this._container;
        },
        _updatePaths: function() {
            if (this._postponeUpdatePaths) return;
            var layer;
            this._redrawBounds = null;
            for(var id in this._layers){
                layer = this._layers[id];
                layer._update();
            }
            this._redraw();
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, container = this._container, size = b.getSize(), m = Browser.retina ? 2 : 1;
            setPosition(container, b.min);
            // set canvas size (also clearing it); use double size on retina
            container.width = m * size.x;
            container.height = m * size.y;
            container.style.width = size.x + 'px';
            container.style.height = size.y + 'px';
            if (Browser.retina) this._ctx.scale(2, 2);
            // translate so we use the same path coordinates after canvas element moves
            this._ctx.translate(-b.min.x, -b.min.y);
            // Tell paths to redraw themselves
            this.fire('update');
        },
        _reset: function() {
            Renderer.prototype._reset.call(this);
            if (this._postponeUpdatePaths) {
                this._postponeUpdatePaths = false;
                this._updatePaths();
            }
        },
        _initPath: function(layer) {
            this._updateDashArray(layer);
            this._layers[stamp(layer)] = layer;
            var order = layer._order = {
                layer: layer,
                prev: this._drawLast,
                next: null
            };
            if (this._drawLast) this._drawLast.next = order;
            this._drawLast = order;
            this._drawFirst = this._drawFirst || this._drawLast;
        },
        _addPath: function(layer) {
            this._requestRedraw(layer);
        },
        _removePath: function(layer) {
            var order = layer._order;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else this._drawLast = prev;
            if (prev) prev.next = next;
            else this._drawFirst = next;
            delete layer._order;
            delete this._layers[stamp(layer)];
            this._requestRedraw(layer);
        },
        _updatePath: function(layer) {
            // Redraw the union of the layer's old pixel
            // bounds and the new pixel bounds.
            this._extendRedrawBounds(layer);
            layer._project();
            layer._update();
            // The redraw will extend the redraw bounds
            // with the new pixel bounds.
            this._requestRedraw(layer);
        },
        _updateStyle: function(layer) {
            this._updateDashArray(layer);
            this._requestRedraw(layer);
        },
        _updateDashArray: function(layer) {
            if (typeof layer.options.dashArray === 'string') {
                var parts = layer.options.dashArray.split(/[, ]+/), dashArray = [], dashValue, i;
                for(i = 0; i < parts.length; i++){
                    dashValue = Number(parts[i]);
                    // Ignore dash array containing invalid lengths
                    if (isNaN(dashValue)) return;
                    dashArray.push(dashValue);
                }
                layer.options._dashArray = dashArray;
            } else layer.options._dashArray = layer.options.dashArray;
        },
        _requestRedraw: function(layer) {
            if (!this._map) return;
            this._extendRedrawBounds(layer);
            this._redrawRequest = this._redrawRequest || requestAnimFrame(this._redraw, this);
        },
        _extendRedrawBounds: function(layer) {
            if (layer._pxBounds) {
                var padding = (layer.options.weight || 0) + 1;
                this._redrawBounds = this._redrawBounds || new Bounds();
                this._redrawBounds.extend(layer._pxBounds.min.subtract([
                    padding,
                    padding
                ]));
                this._redrawBounds.extend(layer._pxBounds.max.add([
                    padding,
                    padding
                ]));
            }
        },
        _redraw: function() {
            this._redrawRequest = null;
            if (this._redrawBounds) {
                this._redrawBounds.min._floor();
                this._redrawBounds.max._ceil();
            }
            this._clear(); // clear layers in redraw bounds
            this._draw(); // draw layers
            this._redrawBounds = null;
        },
        _clear: function() {
            var bounds = this._redrawBounds;
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
            } else {
                this._ctx.save();
                this._ctx.setTransform(1, 0, 0, 1, 0, 0);
                this._ctx.clearRect(0, 0, this._container.width, this._container.height);
                this._ctx.restore();
            }
        },
        _draw: function() {
            var layer, bounds = this._redrawBounds;
            this._ctx.save();
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.beginPath();
                this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
                this._ctx.clip();
            }
            this._drawing = true;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (!bounds || layer._pxBounds && layer._pxBounds.intersects(bounds)) layer._updatePath();
            }
            this._drawing = false;
            this._ctx.restore(); // Restore state before clipping.
        },
        _updatePoly: function(layer, closed) {
            if (!this._drawing) return;
            var i, j, len2, p, parts = layer._parts, len = parts.length, ctx = this._ctx;
            if (!len) return;
            ctx.beginPath();
            for(i = 0; i < len; i++){
                for(j = 0, len2 = parts[i].length; j < len2; j++){
                    p = parts[i][j];
                    ctx[j ? 'lineTo' : 'moveTo'](p.x, p.y);
                }
                if (closed) ctx.closePath();
            }
            this._fillStroke(ctx, layer);
        // TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
        },
        _updateCircle: function(layer) {
            if (!this._drawing || layer._empty()) return;
            var p = layer._point, ctx = this._ctx, r = Math.max(Math.round(layer._radius), 1), s = (Math.max(Math.round(layer._radiusY), 1) || r) / r;
            if (s !== 1) {
                ctx.save();
                ctx.scale(1, s);
            }
            ctx.beginPath();
            ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);
            if (s !== 1) ctx.restore();
            this._fillStroke(ctx, layer);
        },
        _fillStroke: function(ctx, layer) {
            var options = layer.options;
            if (options.fill) {
                ctx.globalAlpha = options.fillOpacity;
                ctx.fillStyle = options.fillColor || options.color;
                ctx.fill(options.fillRule || 'evenodd');
            }
            if (options.stroke && options.weight !== 0) {
                if (ctx.setLineDash) ctx.setLineDash(layer.options && layer.options._dashArray || []);
                ctx.globalAlpha = options.opacity;
                ctx.lineWidth = options.weight;
                ctx.strokeStyle = options.color;
                ctx.lineCap = options.lineCap;
                ctx.lineJoin = options.lineJoin;
                ctx.stroke();
            }
        },
        // Canvas obviously doesn't have mouse events for individual drawn objects,
        // so we emulate that by calculating what's under the mouse on mousemove/click manually
        _onClick: function(e) {
            var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) {
                    if (!(e.type === 'click' || e.type === 'preclick') || !this._map._draggableMoved(layer)) clickedLayer = layer;
                }
            }
            this._fireEvent(clickedLayer ? [
                clickedLayer
            ] : false, e);
        },
        _onMouseMove: function(e) {
            if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) return;
            var point = this._map.mouseEventToLayerPoint(e);
            this._handleMouseHover(e, point);
        },
        _handleMouseOut: function(e) {
            var layer = this._hoveredLayer;
            if (layer) {
                // if we're leaving the layer, fire mouseout
                removeClass(this._container, 'leaflet-interactive');
                this._fireEvent([
                    layer
                ], e, 'mouseout');
                this._hoveredLayer = null;
                this._mouseHoverThrottled = false;
            }
        },
        _handleMouseHover: function(e, point) {
            if (this._mouseHoverThrottled) return;
            var layer, candidateHoveredLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) candidateHoveredLayer = layer;
            }
            if (candidateHoveredLayer !== this._hoveredLayer) {
                this._handleMouseOut(e);
                if (candidateHoveredLayer) {
                    addClass(this._container, 'leaflet-interactive'); // change cursor
                    this._fireEvent([
                        candidateHoveredLayer
                    ], e, 'mouseover');
                    this._hoveredLayer = candidateHoveredLayer;
                }
            }
            this._fireEvent(this._hoveredLayer ? [
                this._hoveredLayer
            ] : false, e);
            this._mouseHoverThrottled = true;
            setTimeout(bind(function() {
                this._mouseHoverThrottled = false;
            }, this), 32);
        },
        _fireEvent: function(layers, e, type) {
            this._map._fireDOMEvent(e, type || e.type, layers);
        },
        _bringToFront: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else // Already last
            return;
            if (prev) prev.next = next;
            else if (next) // Update first entry unless this is the
            // single entry
            this._drawFirst = next;
            order.prev = this._drawLast;
            this._drawLast.next = order;
            order.next = null;
            this._drawLast = order;
            this._requestRedraw(layer);
        },
        _bringToBack: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (prev) prev.next = next;
            else // Already first
            return;
            if (next) next.prev = prev;
            else if (prev) // Update last entry unless this is the
            // single entry
            this._drawLast = prev;
            order.prev = null;
            order.next = this._drawFirst;
            this._drawFirst.prev = order;
            this._drawFirst = order;
            this._requestRedraw(layer);
        }
    });
    // @factory L.canvas(options?: Renderer options)
    // Creates a Canvas renderer with the given options.
    function canvas(options) {
        return Browser.canvas ? new Canvas(options) : null;
    }
    /*
   * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
   */ var vmlCreate = function() {
        try {
            document.namespaces.add('lvml', 'urn:schemas-microsoft-com:vml');
            return function(name) {
                return document.createElement('<lvml:' + name + ' class="lvml">');
            };
        } catch (e) {
        // Do not return fn from catch block so `e` can be garbage collected
        // See https://github.com/Leaflet/Leaflet/pull/7279
        }
        return function(name) {
            return document.createElement('<' + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
        };
    }();
    /*
   * @class SVG
   *
   *
   * VML was deprecated in 2012, which means VML functionality exists only for backwards compatibility
   * with old versions of Internet Explorer.
   */ // mixin to redefine some SVG methods to handle VML syntax which is similar but with some differences
    var vmlMixin = {
        _initContainer: function() {
            this._container = create$1('div', 'leaflet-vml-container');
        },
        _update: function() {
            if (this._map._animatingZoom) return;
            Renderer.prototype._update.call(this);
            this.fire('update');
        },
        _initPath: function(layer) {
            var container = layer._container = vmlCreate('shape');
            addClass(container, 'leaflet-vml-shape ' + (this.options.className || ''));
            container.coordsize = '1 1';
            layer._path = vmlCreate('path');
            container.appendChild(layer._path);
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            var container = layer._container;
            this._container.appendChild(container);
            if (layer.options.interactive) layer.addInteractiveTarget(container);
        },
        _removePath: function(layer) {
            var container = layer._container;
            remove(container);
            layer.removeInteractiveTarget(container);
            delete this._layers[stamp(layer)];
        },
        _updateStyle: function(layer) {
            var stroke = layer._stroke, fill = layer._fill, options = layer.options, container = layer._container;
            container.stroked = !!options.stroke;
            container.filled = !!options.fill;
            if (options.stroke) {
                if (!stroke) stroke = layer._stroke = vmlCreate('stroke');
                container.appendChild(stroke);
                stroke.weight = options.weight + 'px';
                stroke.color = options.color;
                stroke.opacity = options.opacity;
                if (options.dashArray) stroke.dashStyle = isArray(options.dashArray) ? options.dashArray.join(' ') : options.dashArray.replace(/( *, *)/g, ' ');
                else stroke.dashStyle = '';
                stroke.endcap = options.lineCap.replace('butt', 'flat');
                stroke.joinstyle = options.lineJoin;
            } else if (stroke) {
                container.removeChild(stroke);
                layer._stroke = null;
            }
            if (options.fill) {
                if (!fill) fill = layer._fill = vmlCreate('fill');
                container.appendChild(fill);
                fill.color = options.fillColor || options.color;
                fill.opacity = options.fillOpacity;
            } else if (fill) {
                container.removeChild(fill);
                layer._fill = null;
            }
        },
        _updateCircle: function(layer) {
            var p = layer._point.round(), r = Math.round(layer._radius), r2 = Math.round(layer._radiusY || r);
            this._setPath(layer, layer._empty() ? 'M0 0' : 'AL ' + p.x + ',' + p.y + ' ' + r + ',' + r2 + ' 0,' + 23592600);
        },
        _setPath: function(layer, path) {
            layer._path.v = path;
        },
        _bringToFront: function(layer) {
            toFront(layer._container);
        },
        _bringToBack: function(layer) {
            toBack(layer._container);
        }
    };
    var create = Browser.vml ? vmlCreate : svgCreate;
    /*
   * @class SVG
   * @inherits Renderer
   * @aka L.SVG
   *
   * Allows vector layers to be displayed with [SVG](https://developer.mozilla.org/docs/Web/SVG).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/svg), SVG is not
   * available in all web browsers, notably Android 2.x and 3.x.
   *
   * Although SVG is not available on IE7 and IE8, these browsers support
   * [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language)
   * (a now deprecated technology), and the SVG renderer will fall back to VML in
   * this case.
   *
   * @example
   *
   * Use SVG by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.svg()
   * });
   * ```
   *
   * Use a SVG renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.svg({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var SVG = Renderer.extend({
        _initContainer: function() {
            this._container = create('svg');
            // makes it possible to click through svg root; we'll reset it back in individual paths
            this._container.setAttribute('pointer-events', 'none');
            this._rootGroup = create('g');
            this._container.appendChild(this._rootGroup);
        },
        _destroyContainer: function() {
            remove(this._container);
            off(this._container);
            delete this._container;
            delete this._rootGroup;
            delete this._svgSize;
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, size = b.getSize(), container = this._container;
            // set size of svg-container if changed
            if (!this._svgSize || !this._svgSize.equals(size)) {
                this._svgSize = size;
                container.setAttribute('width', size.x);
                container.setAttribute('height', size.y);
            }
            // movement: update container viewBox so that we don't have to change coordinates of individual layers
            setPosition(container, b.min);
            container.setAttribute('viewBox', [
                b.min.x,
                b.min.y,
                size.x,
                size.y
            ].join(' '));
            this.fire('update');
        },
        // methods below are called by vector layers implementations
        _initPath: function(layer) {
            var path = layer._path = create('path');
            // @namespace Path
            // @option className: String = null
            // Custom class name set on an element. Only for SVG renderer.
            if (layer.options.className) addClass(path, layer.options.className);
            if (layer.options.interactive) addClass(path, 'leaflet-interactive');
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            if (!this._rootGroup) this._initContainer();
            this._rootGroup.appendChild(layer._path);
            layer.addInteractiveTarget(layer._path);
        },
        _removePath: function(layer) {
            remove(layer._path);
            layer.removeInteractiveTarget(layer._path);
            delete this._layers[stamp(layer)];
        },
        _updatePath: function(layer) {
            layer._project();
            layer._update();
        },
        _updateStyle: function(layer) {
            var path = layer._path, options = layer.options;
            if (!path) return;
            if (options.stroke) {
                path.setAttribute('stroke', options.color);
                path.setAttribute('stroke-opacity', options.opacity);
                path.setAttribute('stroke-width', options.weight);
                path.setAttribute('stroke-linecap', options.lineCap);
                path.setAttribute('stroke-linejoin', options.lineJoin);
                if (options.dashArray) path.setAttribute('stroke-dasharray', options.dashArray);
                else path.removeAttribute('stroke-dasharray');
                if (options.dashOffset) path.setAttribute('stroke-dashoffset', options.dashOffset);
                else path.removeAttribute('stroke-dashoffset');
            } else path.setAttribute('stroke', 'none');
            if (options.fill) {
                path.setAttribute('fill', options.fillColor || options.color);
                path.setAttribute('fill-opacity', options.fillOpacity);
                path.setAttribute('fill-rule', options.fillRule || 'evenodd');
            } else path.setAttribute('fill', 'none');
        },
        _updatePoly: function(layer, closed) {
            this._setPath(layer, pointsToPath(layer._parts, closed));
        },
        _updateCircle: function(layer) {
            var p = layer._point, r = Math.max(Math.round(layer._radius), 1), r2 = Math.max(Math.round(layer._radiusY), 1) || r, arc = 'a' + r + ',' + r2 + ' 0 1,0 ';
            // drawing a circle with two half-arcs
            var d = layer._empty() ? 'M0 0' : 'M' + (p.x - r) + ',' + p.y + arc + r * 2 + ',0 ' + arc + -r * 2 + ',0 ';
            this._setPath(layer, d);
        },
        _setPath: function(layer, path) {
            layer._path.setAttribute('d', path);
        },
        // SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
        _bringToFront: function(layer) {
            toFront(layer._path);
        },
        _bringToBack: function(layer) {
            toBack(layer._path);
        }
    });
    if (Browser.vml) SVG.include(vmlMixin);
    // @namespace SVG
    // @factory L.svg(options?: Renderer options)
    // Creates a SVG renderer with the given options.
    function svg(options) {
        return Browser.svg || Browser.vml ? new SVG(options) : null;
    }
    Map.include({
        // @namespace Map; @method getRenderer(layer: Path): Renderer
        // Returns the instance of `Renderer` that should be used to render the given
        // `Path`. It will ensure that the `renderer` options of the map and paths
        // are respected, and that the renderers do exist on the map.
        getRenderer: function(layer) {
            // @namespace Path; @option renderer: Renderer
            // Use this specific instance of `Renderer` for this path. Takes
            // precedence over the map's [default renderer](#map-renderer).
            var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;
            if (!renderer) renderer = this._renderer = this._createRenderer();
            if (!this.hasLayer(renderer)) this.addLayer(renderer);
            return renderer;
        },
        _getPaneRenderer: function(name) {
            if (name === 'overlayPane' || name === undefined) return false;
            var renderer = this._paneRenderers[name];
            if (renderer === undefined) {
                renderer = this._createRenderer({
                    pane: name
                });
                this._paneRenderers[name] = renderer;
            }
            return renderer;
        },
        _createRenderer: function(options) {
            // @namespace Map; @option preferCanvas: Boolean = false
            // Whether `Path`s should be rendered on a `Canvas` renderer.
            // By default, all `Path`s are rendered in a `SVG` renderer.
            return this.options.preferCanvas && canvas(options) || svg(options);
        }
    });
    /*
   * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
   */ /*
   * @class Rectangle
   * @aka L.Rectangle
   * @inherits Polygon
   *
   * A class for drawing rectangle overlays on a map. Extends `Polygon`.
   *
   * @example
   *
   * ```js
   * // define rectangle geographical bounds
   * var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
   *
   * // create an orange rectangle
   * L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
   *
   * // zoom the map to the rectangle bounds
   * map.fitBounds(bounds);
   * ```
   *
   */ var Rectangle = Polygon.extend({
        initialize: function(latLngBounds, options) {
            Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
        },
        // @method setBounds(latLngBounds: LatLngBounds): this
        // Redraws the rectangle with the passed bounds.
        setBounds: function(latLngBounds) {
            return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
        },
        _boundsToLatLngs: function(latLngBounds) {
            latLngBounds = toLatLngBounds(latLngBounds);
            return [
                latLngBounds.getSouthWest(),
                latLngBounds.getNorthWest(),
                latLngBounds.getNorthEast(),
                latLngBounds.getSouthEast()
            ];
        }
    });
    // @factory L.rectangle(latLngBounds: LatLngBounds, options?: Polyline options)
    function rectangle(latLngBounds, options) {
        return new Rectangle(latLngBounds, options);
    }
    SVG.create = create;
    SVG.pointsToPath = pointsToPath;
    GeoJSON.geometryToLayer = geometryToLayer;
    GeoJSON.coordsToLatLng = coordsToLatLng;
    GeoJSON.coordsToLatLngs = coordsToLatLngs;
    GeoJSON.latLngToCoords = latLngToCoords;
    GeoJSON.latLngsToCoords = latLngsToCoords;
    GeoJSON.getFeature = getFeature;
    GeoJSON.asFeature = asFeature;
    /*
   * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
   * (zoom to a selected bounding box), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option boxZoom: Boolean = true
        // Whether the map can be zoomed to a rectangular area specified by
        // dragging the mouse while pressing the shift key.
        boxZoom: true
    });
    var BoxZoom = Handler.extend({
        initialize: function(map) {
            this._map = map;
            this._container = map._container;
            this._pane = map._panes.overlayPane;
            this._resetStateTimeout = 0;
            map.on('unload', this._destroy, this);
        },
        addHooks: function() {
            on(this._container, 'mousedown', this._onMouseDown, this);
        },
        removeHooks: function() {
            off(this._container, 'mousedown', this._onMouseDown, this);
        },
        moved: function() {
            return this._moved;
        },
        _destroy: function() {
            remove(this._pane);
            delete this._pane;
        },
        _resetState: function() {
            this._resetStateTimeout = 0;
            this._moved = false;
        },
        _clearDeferredResetState: function() {
            if (this._resetStateTimeout !== 0) {
                clearTimeout(this._resetStateTimeout);
                this._resetStateTimeout = 0;
            }
        },
        _onMouseDown: function(e) {
            if (!e.shiftKey || e.which !== 1 && e.button !== 1) return false;
            // Clear the deferred resetState if it hasn't executed yet, otherwise it
            // will interrupt the interaction and orphan a box element in the container.
            this._clearDeferredResetState();
            this._resetState();
            disableTextSelection();
            disableImageDrag();
            this._startPoint = this._map.mouseEventToContainerPoint(e);
            on(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseMove: function(e) {
            if (!this._moved) {
                this._moved = true;
                this._box = create$1('div', 'leaflet-zoom-box', this._container);
                addClass(this._container, 'leaflet-crosshair');
                this._map.fire('boxzoomstart');
            }
            this._point = this._map.mouseEventToContainerPoint(e);
            var bounds = new Bounds(this._point, this._startPoint), size = bounds.getSize();
            setPosition(this._box, bounds.min);
            this._box.style.width = size.x + 'px';
            this._box.style.height = size.y + 'px';
        },
        _finish: function() {
            if (this._moved) {
                remove(this._box);
                removeClass(this._container, 'leaflet-crosshair');
            }
            enableTextSelection();
            enableImageDrag();
            off(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseUp: function(e) {
            if (e.which !== 1 && e.button !== 1) return;
            this._finish();
            if (!this._moved) return;
            // Postpone to next JS tick so internal click event handling
            // still see it as "moved".
            this._clearDeferredResetState();
            this._resetStateTimeout = setTimeout(bind(this._resetState, this), 0);
            var bounds = new LatLngBounds(this._map.containerPointToLatLng(this._startPoint), this._map.containerPointToLatLng(this._point));
            this._map.fitBounds(bounds).fire('boxzoomend', {
                boxZoomBounds: bounds
            });
        },
        _onKeyDown: function(e) {
            if (e.keyCode === 27) {
                this._finish();
                this._clearDeferredResetState();
                this._resetState();
            }
        }
    });
    // @section Handlers
    // @property boxZoom: Handler
    // Box (shift-drag with mouse) zoom handler.
    Map.addInitHook('addHandler', 'boxZoom', BoxZoom);
    /*
   * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option doubleClickZoom: Boolean|String = true
        // Whether the map can be zoomed in by double clicking on it and
        // zoomed out by double clicking while holding shift. If passed
        // `'center'`, double-click zoom will zoom to the center of the
        //  view regardless of where the mouse was.
        doubleClickZoom: true
    });
    var DoubleClickZoom = Handler.extend({
        addHooks: function() {
            this._map.on('dblclick', this._onDoubleClick, this);
        },
        removeHooks: function() {
            this._map.off('dblclick', this._onDoubleClick, this);
        },
        _onDoubleClick: function(e) {
            var map = this._map, oldZoom = map.getZoom(), delta = map.options.zoomDelta, zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;
            if (map.options.doubleClickZoom === 'center') map.setZoom(zoom);
            else map.setZoomAround(e.containerPoint, zoom);
        }
    });
    // @section Handlers
    //
    // Map properties include interaction handlers that allow you to control
    // interaction behavior in runtime, enabling or disabling certain features such
    // as dragging or touch zoom (see `Handler` methods). For example:
    //
    // ```js
    // map.doubleClickZoom.disable();
    // ```
    //
    // @property doubleClickZoom: Handler
    // Double click zoom handler.
    Map.addInitHook('addHandler', 'doubleClickZoom', DoubleClickZoom);
    /*
   * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option dragging: Boolean = true
        // Whether the map is draggable with mouse/touch or not.
        dragging: true,
        // @section Panning Inertia Options
        // @option inertia: Boolean = *
        // If enabled, panning of the map will have an inertia effect where
        // the map builds momentum while dragging and continues moving in
        // the same direction for some time. Feels especially nice on touch
        // devices. Enabled by default.
        inertia: true,
        // @option inertiaDeceleration: Number = 3000
        // The rate with which the inertial movement slows down, in pixels/second².
        inertiaDeceleration: 3400,
        // @option inertiaMaxSpeed: Number = Infinity
        // Max speed of the inertial movement, in pixels/second.
        inertiaMaxSpeed: Infinity,
        // @option easeLinearity: Number = 0.2
        easeLinearity: 0.2,
        // TODO refactor, move to CRS
        // @option worldCopyJump: Boolean = false
        // With this option enabled, the map tracks when you pan to another "copy"
        // of the world and seamlessly jumps to the original one so that all overlays
        // like markers and vector layers are still visible.
        worldCopyJump: false,
        // @option maxBoundsViscosity: Number = 0.0
        // If `maxBounds` is set, this option will control how solid the bounds
        // are when dragging the map around. The default value of `0.0` allows the
        // user to drag outside the bounds at normal speed, higher values will
        // slow down map dragging outside bounds, and `1.0` makes the bounds fully
        // solid, preventing the user from dragging outside the bounds.
        maxBoundsViscosity: 0.0
    });
    var Drag = Handler.extend({
        addHooks: function() {
            if (!this._draggable) {
                var map = this._map;
                this._draggable = new Draggable(map._mapPane, map._container);
                this._draggable.on({
                    dragstart: this._onDragStart,
                    drag: this._onDrag,
                    dragend: this._onDragEnd
                }, this);
                this._draggable.on('predrag', this._onPreDragLimit, this);
                if (map.options.worldCopyJump) {
                    this._draggable.on('predrag', this._onPreDragWrap, this);
                    map.on('zoomend', this._onZoomEnd, this);
                    map.whenReady(this._onZoomEnd, this);
                }
            }
            addClass(this._map._container, 'leaflet-grab leaflet-touch-drag');
            this._draggable.enable();
            this._positions = [];
            this._times = [];
        },
        removeHooks: function() {
            removeClass(this._map._container, 'leaflet-grab');
            removeClass(this._map._container, 'leaflet-touch-drag');
            this._draggable.disable();
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        moving: function() {
            return this._draggable && this._draggable._moving;
        },
        _onDragStart: function() {
            var map = this._map;
            map._stop();
            if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
                var bounds = toLatLngBounds(this._map.options.maxBounds);
                this._offsetLimit = toBounds(this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1), this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1).add(this._map.getSize()));
                this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
            } else this._offsetLimit = null;
            map.fire('movestart').fire('dragstart');
            if (map.options.inertia) {
                this._positions = [];
                this._times = [];
            }
        },
        _onDrag: function(e) {
            if (this._map.options.inertia) {
                var time = this._lastTime = +new Date(), pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;
                this._positions.push(pos);
                this._times.push(time);
                this._prunePositions(time);
            }
            this._map.fire('move', e).fire('drag', e);
        },
        _prunePositions: function(time) {
            while(this._positions.length > 1 && time - this._times[0] > 50){
                this._positions.shift();
                this._times.shift();
            }
        },
        _onZoomEnd: function() {
            var pxCenter = this._map.getSize().divideBy(2), pxWorldCenter = this._map.latLngToLayerPoint([
                0,
                0
            ]);
            this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
            this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
        },
        _viscousLimit: function(value, threshold) {
            return value - (value - threshold) * this._viscosity;
        },
        _onPreDragLimit: function() {
            if (!this._viscosity || !this._offsetLimit) return;
            var offset = this._draggable._newPos.subtract(this._draggable._startPos);
            var limit = this._offsetLimit;
            if (offset.x < limit.min.x) offset.x = this._viscousLimit(offset.x, limit.min.x);
            if (offset.y < limit.min.y) offset.y = this._viscousLimit(offset.y, limit.min.y);
            if (offset.x > limit.max.x) offset.x = this._viscousLimit(offset.x, limit.max.x);
            if (offset.y > limit.max.y) offset.y = this._viscousLimit(offset.y, limit.max.y);
            this._draggable._newPos = this._draggable._startPos.add(offset);
        },
        _onPreDragWrap: function() {
            // TODO refactor to be able to adjust map pane position after zoom
            var worldWidth = this._worldWidth, halfWidth = Math.round(worldWidth / 2), dx = this._initialWorldOffset, x = this._draggable._newPos.x, newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx, newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx, newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
            this._draggable._absPos = this._draggable._newPos.clone();
            this._draggable._newPos.x = newX;
        },
        _onDragEnd: function(e) {
            var map = this._map, options = map.options, noInertia = !options.inertia || e.noInertia || this._times.length < 2;
            map.fire('dragend', e);
            if (noInertia) map.fire('moveend');
            else {
                this._prunePositions(+new Date());
                var direction = this._lastPos.subtract(this._positions[0]), duration = (this._lastTime - this._times[0]) / 1000, ease = options.easeLinearity, speedVector = direction.multiplyBy(ease / duration), speed = speedVector.distanceTo([
                    0,
                    0
                ]), limitedSpeed = Math.min(options.inertiaMaxSpeed, speed), limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed), decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease), offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
                if (!offset.x && !offset.y) map.fire('moveend');
                else {
                    offset = map._limitOffset(offset, map.options.maxBounds);
                    requestAnimFrame(function() {
                        map.panBy(offset, {
                            duration: decelerationDuration,
                            easeLinearity: ease,
                            noMoveStart: true,
                            animate: true
                        });
                    });
                }
            }
        }
    });
    // @section Handlers
    // @property dragging: Handler
    // Map dragging handler (by both mouse and touch).
    Map.addInitHook('addHandler', 'dragging', Drag);
    /*
   * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
   */ // @namespace Map
    // @section Keyboard Navigation Options
    Map.mergeOptions({
        // @option keyboard: Boolean = true
        // Makes the map focusable and allows users to navigate the map with keyboard
        // arrows and `+`/`-` keys.
        keyboard: true,
        // @option keyboardPanDelta: Number = 80
        // Amount of pixels to pan when pressing an arrow key.
        keyboardPanDelta: 80
    });
    var Keyboard = Handler.extend({
        keyCodes: {
            left: [
                37
            ],
            right: [
                39
            ],
            down: [
                40
            ],
            up: [
                38
            ],
            zoomIn: [
                187,
                107,
                61,
                171
            ],
            zoomOut: [
                189,
                109,
                54,
                173
            ]
        },
        initialize: function(map) {
            this._map = map;
            this._setPanDelta(map.options.keyboardPanDelta);
            this._setZoomDelta(map.options.zoomDelta);
        },
        addHooks: function() {
            var container = this._map._container;
            // make the container focusable by tabbing
            if (container.tabIndex <= 0) container.tabIndex = '0';
            on(container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.on({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        removeHooks: function() {
            this._removeHooks();
            off(this._map._container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.off({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        _onMouseDown: function() {
            if (this._focused) return;
            var body = document.body, docEl = document.documentElement, top = body.scrollTop || docEl.scrollTop, left = body.scrollLeft || docEl.scrollLeft;
            this._map._container.focus();
            window.scrollTo(left, top);
        },
        _onFocus: function() {
            this._focused = true;
            this._map.fire('focus');
        },
        _onBlur: function() {
            this._focused = false;
            this._map.fire('blur');
        },
        _setPanDelta: function(panDelta) {
            var keys = this._panKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.left.length; i < len; i++)keys[codes.left[i]] = [
                -1 * panDelta,
                0
            ];
            for(i = 0, len = codes.right.length; i < len; i++)keys[codes.right[i]] = [
                panDelta,
                0
            ];
            for(i = 0, len = codes.down.length; i < len; i++)keys[codes.down[i]] = [
                0,
                panDelta
            ];
            for(i = 0, len = codes.up.length; i < len; i++)keys[codes.up[i]] = [
                0,
                -1 * panDelta
            ];
        },
        _setZoomDelta: function(zoomDelta) {
            var keys = this._zoomKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.zoomIn.length; i < len; i++)keys[codes.zoomIn[i]] = zoomDelta;
            for(i = 0, len = codes.zoomOut.length; i < len; i++)keys[codes.zoomOut[i]] = -zoomDelta;
        },
        _addHooks: function() {
            on(document, 'keydown', this._onKeyDown, this);
        },
        _removeHooks: function() {
            off(document, 'keydown', this._onKeyDown, this);
        },
        _onKeyDown: function(e) {
            if (e.altKey || e.ctrlKey || e.metaKey) return;
            var key = e.keyCode, map = this._map, offset;
            if (key in this._panKeys) {
                if (!map._panAnim || !map._panAnim._inProgress) {
                    offset = this._panKeys[key];
                    if (e.shiftKey) offset = toPoint(offset).multiplyBy(3);
                    if (map.options.maxBounds) offset = map._limitOffset(toPoint(offset), map.options.maxBounds);
                    if (map.options.worldCopyJump) {
                        var newLatLng = map.wrapLatLng(map.unproject(map.project(map.getCenter()).add(offset)));
                        map.panTo(newLatLng);
                    } else map.panBy(offset);
                }
            } else if (key in this._zoomKeys) map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);
            else if (key === 27 && map._popup && map._popup.options.closeOnEscapeKey) map.closePopup();
            else return;
            stop(e);
        }
    });
    // @section Handlers
    // @section Handlers
    // @property keyboard: Handler
    // Keyboard navigation handler.
    Map.addInitHook('addHandler', 'keyboard', Keyboard);
    /*
   * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Mouse wheel options
        // @option scrollWheelZoom: Boolean|String = true
        // Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
        // it will zoom to the center of the view regardless of where the mouse was.
        scrollWheelZoom: true,
        // @option wheelDebounceTime: Number = 40
        // Limits the rate at which a wheel can fire (in milliseconds). By default
        // user can't zoom via wheel more often than once per 40 ms.
        wheelDebounceTime: 40,
        // @option wheelPxPerZoomLevel: Number = 60
        // How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
        // mean a change of one full zoom level. Smaller values will make wheel-zooming
        // faster (and vice versa).
        wheelPxPerZoomLevel: 60
    });
    var ScrollWheelZoom = Handler.extend({
        addHooks: function() {
            on(this._map._container, 'wheel', this._onWheelScroll, this);
            this._delta = 0;
        },
        removeHooks: function() {
            off(this._map._container, 'wheel', this._onWheelScroll, this);
        },
        _onWheelScroll: function(e) {
            var delta = getWheelDelta(e);
            var debounce = this._map.options.wheelDebounceTime;
            this._delta += delta;
            this._lastMousePos = this._map.mouseEventToContainerPoint(e);
            if (!this._startTime) this._startTime = +new Date();
            var left = Math.max(debounce - (+new Date() - this._startTime), 0);
            clearTimeout(this._timer);
            this._timer = setTimeout(bind(this._performZoom, this), left);
            stop(e);
        },
        _performZoom: function() {
            var map = this._map, zoom = map.getZoom(), snap = this._map.options.zoomSnap || 0;
            map._stop(); // stop panning and fly animations if any
            // map the delta with a sigmoid function to -4..4 range leaning on -1..1
            var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4), d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2, d4 = snap ? Math.ceil(d3 / snap) * snap : d3, delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;
            this._delta = 0;
            this._startTime = null;
            if (!delta) return;
            if (map.options.scrollWheelZoom === 'center') map.setZoom(zoom + delta);
            else map.setZoomAround(this._lastMousePos, zoom + delta);
        }
    });
    // @section Handlers
    // @property scrollWheelZoom: Handler
    // Scroll wheel zoom handler.
    Map.addInitHook('addHandler', 'scrollWheelZoom', ScrollWheelZoom);
    /*
   * L.Map.TapHold is used to simulate `contextmenu` event on long hold,
   * which otherwise is not fired by mobile Safari.
   */ var tapHoldDelay = 600;
    // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option tapHold: Boolean
        // Enables simulation of `contextmenu` event, default is `true` for mobile Safari.
        tapHold: Browser.touchNative && Browser.safari && Browser.mobile,
        // @option tapTolerance: Number = 15
        // The max number of pixels a user can shift his finger during touch
        // for it to be considered a valid tap.
        tapTolerance: 15
    });
    var TapHold = Handler.extend({
        addHooks: function() {
            on(this._map._container, 'touchstart', this._onDown, this);
        },
        removeHooks: function() {
            off(this._map._container, 'touchstart', this._onDown, this);
        },
        _onDown: function(e) {
            clearTimeout(this._holdTimeout);
            if (e.touches.length !== 1) return;
            var first = e.touches[0];
            this._startPos = this._newPos = new Point(first.clientX, first.clientY);
            this._holdTimeout = setTimeout(bind(function() {
                this._cancel();
                if (!this._isTapValid()) return;
                // prevent simulated mouse events https://w3c.github.io/touch-events/#mouse-events
                on(document, 'touchend', preventDefault);
                on(document, 'touchend touchcancel', this._cancelClickPrevent);
                this._simulateEvent('contextmenu', first);
            }, this), tapHoldDelay);
            on(document, 'touchend touchcancel contextmenu', this._cancel, this);
            on(document, 'touchmove', this._onMove, this);
        },
        _cancelClickPrevent: function cancelClickPrevent() {
            off(document, 'touchend', preventDefault);
            off(document, 'touchend touchcancel', cancelClickPrevent);
        },
        _cancel: function() {
            clearTimeout(this._holdTimeout);
            off(document, 'touchend touchcancel contextmenu', this._cancel, this);
            off(document, 'touchmove', this._onMove, this);
        },
        _onMove: function(e) {
            var first = e.touches[0];
            this._newPos = new Point(first.clientX, first.clientY);
        },
        _isTapValid: function() {
            return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
        },
        _simulateEvent: function(type, e) {
            var simulatedEvent = new MouseEvent(type, {
                bubbles: true,
                cancelable: true,
                view: window,
                // detail: 1,
                screenX: e.screenX,
                screenY: e.screenY,
                clientX: e.clientX,
                clientY: e.clientY
            });
            simulatedEvent._simulated = true;
            e.target.dispatchEvent(simulatedEvent);
        }
    });
    // @section Handlers
    // @property tapHold: Handler
    // Long tap handler to simulate `contextmenu` event (useful in mobile Safari).
    Map.addInitHook('addHandler', 'tapHold', TapHold);
    /*
   * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option touchZoom: Boolean|String = *
        // Whether the map can be zoomed by touch-dragging with two fingers. If
        // passed `'center'`, it will zoom to the center of the view regardless of
        // where the touch events (fingers) were. Enabled for touch-capable web
        // browsers.
        touchZoom: Browser.touch,
        // @option bounceAtZoomLimits: Boolean = true
        // Set it to false if you don't want the map to zoom beyond min/max zoom
        // and then bounce back when pinch-zooming.
        bounceAtZoomLimits: true
    });
    var TouchZoom = Handler.extend({
        addHooks: function() {
            addClass(this._map._container, 'leaflet-touch-zoom');
            on(this._map._container, 'touchstart', this._onTouchStart, this);
        },
        removeHooks: function() {
            removeClass(this._map._container, 'leaflet-touch-zoom');
            off(this._map._container, 'touchstart', this._onTouchStart, this);
        },
        _onTouchStart: function(e) {
            var map = this._map;
            if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) return;
            var p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]);
            this._centerPoint = map.getSize()._divideBy(2);
            this._startLatLng = map.containerPointToLatLng(this._centerPoint);
            if (map.options.touchZoom !== 'center') this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
            this._startDist = p1.distanceTo(p2);
            this._startZoom = map.getZoom();
            this._moved = false;
            this._zooming = true;
            map._stop();
            on(document, 'touchmove', this._onTouchMove, this);
            on(document, 'touchend touchcancel', this._onTouchEnd, this);
            preventDefault(e);
        },
        _onTouchMove: function(e) {
            if (!e.touches || e.touches.length !== 2 || !this._zooming) return;
            var map = this._map, p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]), scale = p1.distanceTo(p2) / this._startDist;
            this._zoom = map.getScaleZoom(scale, this._startZoom);
            if (!map.options.bounceAtZoomLimits && (this._zoom < map.getMinZoom() && scale < 1 || this._zoom > map.getMaxZoom() && scale > 1)) this._zoom = map._limitZoom(this._zoom);
            if (map.options.touchZoom === 'center') {
                this._center = this._startLatLng;
                if (scale === 1) return;
            } else {
                // Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
                var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
                if (scale === 1 && delta.x === 0 && delta.y === 0) return;
                this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
            }
            if (!this._moved) {
                map._moveStart(true, false);
                this._moved = true;
            }
            cancelAnimFrame(this._animRequest);
            var moveFn = bind(map._move, map, this._center, this._zoom, {
                pinch: true,
                round: false
            }, undefined);
            this._animRequest = requestAnimFrame(moveFn, this, true);
            preventDefault(e);
        },
        _onTouchEnd: function() {
            if (!this._moved || !this._zooming) {
                this._zooming = false;
                return;
            }
            this._zooming = false;
            cancelAnimFrame(this._animRequest);
            off(document, 'touchmove', this._onTouchMove, this);
            off(document, 'touchend touchcancel', this._onTouchEnd, this);
            // Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
            if (this._map.options.zoomAnimation) this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
            else this._map._resetView(this._center, this._map._limitZoom(this._zoom));
        }
    });
    // @section Handlers
    // @property touchZoom: Handler
    // Touch zoom handler.
    Map.addInitHook('addHandler', 'touchZoom', TouchZoom);
    Map.BoxZoom = BoxZoom;
    Map.DoubleClickZoom = DoubleClickZoom;
    Map.Drag = Drag;
    Map.Keyboard = Keyboard;
    Map.ScrollWheelZoom = ScrollWheelZoom;
    Map.TapHold = TapHold;
    Map.TouchZoom = TouchZoom;
    exports1.Bounds = Bounds;
    exports1.Browser = Browser;
    exports1.CRS = CRS;
    exports1.Canvas = Canvas;
    exports1.Circle = Circle;
    exports1.CircleMarker = CircleMarker;
    exports1.Class = Class;
    exports1.Control = Control;
    exports1.DivIcon = DivIcon;
    exports1.DivOverlay = DivOverlay;
    exports1.DomEvent = DomEvent;
    exports1.DomUtil = DomUtil;
    exports1.Draggable = Draggable;
    exports1.Evented = Evented;
    exports1.FeatureGroup = FeatureGroup;
    exports1.GeoJSON = GeoJSON;
    exports1.GridLayer = GridLayer;
    exports1.Handler = Handler;
    exports1.Icon = Icon;
    exports1.ImageOverlay = ImageOverlay;
    exports1.LatLng = LatLng;
    exports1.LatLngBounds = LatLngBounds;
    exports1.Layer = Layer;
    exports1.LayerGroup = LayerGroup;
    exports1.LineUtil = LineUtil;
    exports1.Map = Map;
    exports1.Marker = Marker;
    exports1.Mixin = Mixin;
    exports1.Path = Path;
    exports1.Point = Point;
    exports1.PolyUtil = PolyUtil;
    exports1.Polygon = Polygon;
    exports1.Polyline = Polyline;
    exports1.Popup = Popup;
    exports1.PosAnimation = PosAnimation;
    exports1.Projection = index;
    exports1.Rectangle = Rectangle;
    exports1.Renderer = Renderer;
    exports1.SVG = SVG;
    exports1.SVGOverlay = SVGOverlay;
    exports1.TileLayer = TileLayer;
    exports1.Tooltip = Tooltip;
    exports1.Transformation = Transformation;
    exports1.Util = Util;
    exports1.VideoOverlay = VideoOverlay;
    exports1.bind = bind;
    exports1.bounds = toBounds;
    exports1.canvas = canvas;
    exports1.circle = circle;
    exports1.circleMarker = circleMarker;
    exports1.control = control;
    exports1.divIcon = divIcon;
    exports1.extend = extend;
    exports1.featureGroup = featureGroup;
    exports1.geoJSON = geoJSON;
    exports1.geoJson = geoJson;
    exports1.gridLayer = gridLayer;
    exports1.icon = icon;
    exports1.imageOverlay = imageOverlay;
    exports1.latLng = toLatLng;
    exports1.latLngBounds = toLatLngBounds;
    exports1.layerGroup = layerGroup;
    exports1.map = createMap;
    exports1.marker = marker;
    exports1.point = toPoint;
    exports1.polygon = polygon;
    exports1.polyline = polyline;
    exports1.popup = popup;
    exports1.rectangle = rectangle;
    exports1.setOptions = setOptions;
    exports1.stamp = stamp;
    exports1.svg = svg;
    exports1.svgOverlay = svgOverlay;
    exports1.tileLayer = tileLayer;
    exports1.tooltip = tooltip;
    exports1.transformation = toTransformation;
    exports1.version = version;
    exports1.videoOverlay = videoOverlay;
    var oldL = window.L;
    exports1.noConflict = function() {
        window.L = oldL;
        return this;
    };
    // Always export us to window global (see #2364)
    window.L = exports1;
});


const $b55fa19645e7687c$export$c94d53a8b082db8b = "noMandatesMarkers";
const $b55fa19645e7687c$var$MIN_ZOOM = 3;
const $b55fa19645e7687c$var$MAX_ZOOM = 10;
const $b55fa19645e7687c$var$BASE_LAYER = new (0, $65d191346d2f0e85$exports.TileLayer)("https://tiles.stadiamaps.com/tiles/stamen_toner_lite/{z}/{x}/{y}{r}.png", {
    attribution: `&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>
        &copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a>
        &copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a>
        &copy; <a href="https://www.stamen.com/" target="_blank">Stamen Design</a>`,
    subdomains: "abcd",
    minZoom: $b55fa19645e7687c$var$MIN_ZOOM,
    maxZoom: $b55fa19645e7687c$var$MAX_ZOOM
});
function $b55fa19645e7687c$export$2e2bcd8739ae039() {
    const map = new (0, $65d191346d2f0e85$exports.Map)("map", {
        layers: [
            $b55fa19645e7687c$var$BASE_LAYER
        ],
        worldCopyJump: true
    });
    // Set default view show all the US on mobile. While this is fairly zoomed out,
    // the main purpose of the map on initial load is to tell the narrative that parking
    // reform is popular, i.e. there are a lot of dots. Search, filter, and table view are
    // meant for power users doing actual research.
    map.setView([
        40,
        -96
    ], 3);
    map.attributionControl.setPrefix('<a href="https://parkingreform.org/support/">Parking Reform Network</a>');
    // Workaround for no mandates markers appearing at the top of the map
    // https://stackoverflow.com/a/49501320
    map.createPane($b55fa19645e7687c$export$c94d53a8b082db8b);
    map.getPane($b55fa19645e7687c$export$c94d53a8b082db8b).style.zIndex = "900";
    return map;
}


/* eslint-disable no-underscore-dangle */ const $cc4b70f67be6e72e$var$SLOW_CALLBACK_THRESHOLD_MS = 2;
class $cc4b70f67be6e72e$export$2e2bcd8739ae039 {
    id;
    value;
    subscribers = [];
    _isInitialized = false;
    constructor(id, initialValue){
        this.id = id;
        this.value = initialValue;
    }
    get isInitialized() {
        return this._isInitialized;
    }
    getValue() {
        return this.value;
    }
    setValue(newValue) {
        this.value = newValue;
        this.notify();
    }
    subscribe(callback, id) {
        if (this.isInitialized) throw new Error("Cannot add subscribers after initialization");
        this.subscribers.push({
            callback: callback,
            id: id
        });
    }
    initialize() {
        if (this.isInitialized) throw new Error("Observable is already initialized");
        this.notify();
        this._isInitialized = true;
    }
    notify() {
        this.subscribers.forEach(({ callback: callback, id: id })=>{
            callback(this.value);
            return;
            const start = performance.now();
            callback(this.value);
            const duration = performance.now() - start;
            if (duration < $cc4b70f67be6e72e$var$SLOW_CALLBACK_THRESHOLD_MS) return;
            const callbackLabel = id ?? "anonymous";
            // eslint-disable-next-line no-console
            console.warn(`Slow callback detected: Observable(${this.id}) - Subscriber(${callbackLabel}) (${duration.toFixed(0)}ms)`);
        });
    }
}


function $c3cfe4cae09d8cf2$var$updateFilterPopupUI(isVisible) {
    const popup = document.querySelector(".filter-popup");
    const icon = document.querySelector(".header-filter-icon-container");
    if (!popup || !icon) return;
    popup.hidden = !isVisible;
    icon.ariaExpanded = isVisible.toString();
}
function $c3cfe4cae09d8cf2$export$2e2bcd8739ae039() {
    const isVisible = new (0, $cc4b70f67be6e72e$export$2e2bcd8739ae039)("filter popup", false);
    isVisible.subscribe($c3cfe4cae09d8cf2$var$updateFilterPopupUI, "toggle filter popup");
    const popup = document.querySelector(".filter-popup");
    const icon = document.querySelector(".header-filter-icon-container");
    if (!icon) throw new Error("icon not found");
    icon.addEventListener("click", ()=>{
        isVisible.setValue(!isVisible.getValue());
    });
    // Clicks outside the popup close it.
    window.addEventListener("click", (event)=>{
        if (isVisible.getValue() === true && event.target instanceof Element && !icon?.contains(event.target) && !popup?.contains(event.target)) isVisible.setValue(false);
    });
    isVisible.initialize();
}


function $307247af3eff64a9$var$isIFrame() {
    try {
        return window.self !== window.top;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
        return false;
    }
}
function $307247af3eff64a9$export$2e2bcd8739ae039() {
    if ($307247af3eff64a9$var$isIFrame()) return;
    const iconContainer = document.querySelector(".header-full-screen-icon-container");
    if (!(iconContainer instanceof HTMLAnchorElement)) return;
    iconContainer.style.display = "none";
}


/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $cb8ececfecd0309c$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $cb8ececfecd0309c$export$2e2bcd8739ae039 = $cb8ececfecd0309c$var$listCacheClear;


/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $fa799df2e830873c$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $fa799df2e830873c$export$2e2bcd8739ae039 = $fa799df2e830873c$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $ae20ab4a6778d088$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $fa799df2e830873c$export$2e2bcd8739ae039)(array[length][0], key)) return length;
    }
    return -1;
}
var $ae20ab4a6778d088$export$2e2bcd8739ae039 = $ae20ab4a6778d088$var$assocIndexOf;


/** Used for built-in method references. */ var $9f105a2cb198cf75$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $9f105a2cb198cf75$var$splice = $9f105a2cb198cf75$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $9f105a2cb198cf75$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $ae20ab4a6778d088$export$2e2bcd8739ae039)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $9f105a2cb198cf75$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $9f105a2cb198cf75$export$2e2bcd8739ae039 = $9f105a2cb198cf75$var$listCacheDelete;



/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $a69a48810b4d495b$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $ae20ab4a6778d088$export$2e2bcd8739ae039)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $a69a48810b4d495b$export$2e2bcd8739ae039 = $a69a48810b4d495b$var$listCacheGet;



/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $40b84863e34edf18$var$listCacheHas(key) {
    return (0, $ae20ab4a6778d088$export$2e2bcd8739ae039)(this.__data__, key) > -1;
}
var $40b84863e34edf18$export$2e2bcd8739ae039 = $40b84863e34edf18$var$listCacheHas;



/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $474f7d7f66ed40d6$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $ae20ab4a6778d088$export$2e2bcd8739ae039)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $474f7d7f66ed40d6$export$2e2bcd8739ae039 = $474f7d7f66ed40d6$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $f3bb2bde4f3d2e10$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$f3bb2bde4f3d2e10$var$ListCache.prototype.clear = (0, $cb8ececfecd0309c$export$2e2bcd8739ae039);
$f3bb2bde4f3d2e10$var$ListCache.prototype['delete'] = (0, $9f105a2cb198cf75$export$2e2bcd8739ae039);
$f3bb2bde4f3d2e10$var$ListCache.prototype.get = (0, $a69a48810b4d495b$export$2e2bcd8739ae039);
$f3bb2bde4f3d2e10$var$ListCache.prototype.has = (0, $40b84863e34edf18$export$2e2bcd8739ae039);
$f3bb2bde4f3d2e10$var$ListCache.prototype.set = (0, $474f7d7f66ed40d6$export$2e2bcd8739ae039);
var $f3bb2bde4f3d2e10$export$2e2bcd8739ae039 = $f3bb2bde4f3d2e10$var$ListCache;



/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $926693c1c5aa1b3b$var$stackClear() {
    this.__data__ = new (0, $f3bb2bde4f3d2e10$export$2e2bcd8739ae039);
    this.size = 0;
}
var $926693c1c5aa1b3b$export$2e2bcd8739ae039 = $926693c1c5aa1b3b$var$stackClear;


/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $44217bb0c3913906$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
var $44217bb0c3913906$export$2e2bcd8739ae039 = $44217bb0c3913906$var$stackDelete;


/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $fabb8c13d7ec2da0$var$stackGet(key) {
    return this.__data__.get(key);
}
var $fabb8c13d7ec2da0$export$2e2bcd8739ae039 = $fabb8c13d7ec2da0$var$stackGet;


/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $8121243fb2037ab0$var$stackHas(key) {
    return this.__data__.has(key);
}
var $8121243fb2037ab0$export$2e2bcd8739ae039 = $8121243fb2037ab0$var$stackHas;




var $2mpFt = parcelRequire("2mpFt");
/** Built-in value references. */ var $f302ffc9a48734c4$var$Symbol = (0, $2mpFt.default).Symbol;
var $f302ffc9a48734c4$export$2e2bcd8739ae039 = $f302ffc9a48734c4$var$Symbol;



/** Used for built-in method references. */ var $59fc01f5e412f819$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $59fc01f5e412f819$var$hasOwnProperty = $59fc01f5e412f819$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $59fc01f5e412f819$var$nativeObjectToString = $59fc01f5e412f819$var$objectProto.toString;
/** Built-in value references. */ var $59fc01f5e412f819$var$symToStringTag = (0, $f302ffc9a48734c4$export$2e2bcd8739ae039) ? (0, $f302ffc9a48734c4$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $59fc01f5e412f819$var$getRawTag(value) {
    var isOwn = $59fc01f5e412f819$var$hasOwnProperty.call(value, $59fc01f5e412f819$var$symToStringTag), tag = value[$59fc01f5e412f819$var$symToStringTag];
    try {
        value[$59fc01f5e412f819$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $59fc01f5e412f819$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$59fc01f5e412f819$var$symToStringTag] = tag;
        else delete value[$59fc01f5e412f819$var$symToStringTag];
    }
    return result;
}
var $59fc01f5e412f819$export$2e2bcd8739ae039 = $59fc01f5e412f819$var$getRawTag;


/** Used for built-in method references. */ var $94199a1861e07064$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $94199a1861e07064$var$nativeObjectToString = $94199a1861e07064$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $94199a1861e07064$var$objectToString(value) {
    return $94199a1861e07064$var$nativeObjectToString.call(value);
}
var $94199a1861e07064$export$2e2bcd8739ae039 = $94199a1861e07064$var$objectToString;


/** `Object#toString` result references. */ var $ccdb19c7f0a62300$var$nullTag = '[object Null]', $ccdb19c7f0a62300$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $ccdb19c7f0a62300$var$symToStringTag = (0, $f302ffc9a48734c4$export$2e2bcd8739ae039) ? (0, $f302ffc9a48734c4$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $ccdb19c7f0a62300$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $ccdb19c7f0a62300$var$undefinedTag : $ccdb19c7f0a62300$var$nullTag;
    return $ccdb19c7f0a62300$var$symToStringTag && $ccdb19c7f0a62300$var$symToStringTag in Object(value) ? (0, $59fc01f5e412f819$export$2e2bcd8739ae039)(value) : (0, $94199a1861e07064$export$2e2bcd8739ae039)(value);
}
var $ccdb19c7f0a62300$export$2e2bcd8739ae039 = $ccdb19c7f0a62300$var$baseGetTag;


/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $dd0c70c8150db920$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var $dd0c70c8150db920$export$2e2bcd8739ae039 = $dd0c70c8150db920$var$isObject;


/** `Object#toString` result references. */ var $397b12740d7995ef$var$asyncTag = '[object AsyncFunction]', $397b12740d7995ef$var$funcTag = '[object Function]', $397b12740d7995ef$var$genTag = '[object GeneratorFunction]', $397b12740d7995ef$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $397b12740d7995ef$var$isFunction(value) {
    if (!(0, $dd0c70c8150db920$export$2e2bcd8739ae039)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $ccdb19c7f0a62300$export$2e2bcd8739ae039)(value);
    return tag == $397b12740d7995ef$var$funcTag || tag == $397b12740d7995ef$var$genTag || tag == $397b12740d7995ef$var$asyncTag || tag == $397b12740d7995ef$var$proxyTag;
}
var $397b12740d7995ef$export$2e2bcd8739ae039 = $397b12740d7995ef$var$isFunction;



var $2mpFt = parcelRequire("2mpFt");
/** Used to detect overreaching core-js shims. */ var $bfc02efb2c4f5b86$var$coreJsData = (0, $2mpFt.default)['__core-js_shared__'];
var $bfc02efb2c4f5b86$export$2e2bcd8739ae039 = $bfc02efb2c4f5b86$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $b7e8b9239f02cfcb$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $bfc02efb2c4f5b86$export$2e2bcd8739ae039) && (0, $bfc02efb2c4f5b86$export$2e2bcd8739ae039).keys && (0, $bfc02efb2c4f5b86$export$2e2bcd8739ae039).keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $b7e8b9239f02cfcb$var$isMasked(func) {
    return !!$b7e8b9239f02cfcb$var$maskSrcKey && $b7e8b9239f02cfcb$var$maskSrcKey in func;
}
var $b7e8b9239f02cfcb$export$2e2bcd8739ae039 = $b7e8b9239f02cfcb$var$isMasked;



/** Used for built-in method references. */ var $3c5a435f91273845$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $3c5a435f91273845$var$funcToString = $3c5a435f91273845$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $3c5a435f91273845$var$toSource(func) {
    if (func != null) {
        try {
            return $3c5a435f91273845$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
var $3c5a435f91273845$export$2e2bcd8739ae039 = $3c5a435f91273845$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $ce7d4e19db8c5f74$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $ce7d4e19db8c5f74$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $ce7d4e19db8c5f74$var$funcProto = Function.prototype, $ce7d4e19db8c5f74$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $ce7d4e19db8c5f74$var$funcToString = $ce7d4e19db8c5f74$var$funcProto.toString;
/** Used to check objects for own properties. */ var $ce7d4e19db8c5f74$var$hasOwnProperty = $ce7d4e19db8c5f74$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $ce7d4e19db8c5f74$var$reIsNative = RegExp('^' + $ce7d4e19db8c5f74$var$funcToString.call($ce7d4e19db8c5f74$var$hasOwnProperty).replace($ce7d4e19db8c5f74$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $ce7d4e19db8c5f74$var$baseIsNative(value) {
    if (!(0, $dd0c70c8150db920$export$2e2bcd8739ae039)(value) || (0, $b7e8b9239f02cfcb$export$2e2bcd8739ae039)(value)) return false;
    var pattern = (0, $397b12740d7995ef$export$2e2bcd8739ae039)(value) ? $ce7d4e19db8c5f74$var$reIsNative : $ce7d4e19db8c5f74$var$reIsHostCtor;
    return pattern.test((0, $3c5a435f91273845$export$2e2bcd8739ae039)(value));
}
var $ce7d4e19db8c5f74$export$2e2bcd8739ae039 = $ce7d4e19db8c5f74$var$baseIsNative;


/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $8048bad1174acf1d$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $8048bad1174acf1d$export$2e2bcd8739ae039 = $8048bad1174acf1d$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $e64d313d457435ee$var$getNative(object, key) {
    var value = (0, $8048bad1174acf1d$export$2e2bcd8739ae039)(object, key);
    return (0, $ce7d4e19db8c5f74$export$2e2bcd8739ae039)(value) ? value : undefined;
}
var $e64d313d457435ee$export$2e2bcd8739ae039 = $e64d313d457435ee$var$getNative;



var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $b3fc56271887eaf3$var$Map = (0, $e64d313d457435ee$export$2e2bcd8739ae039)((0, $2mpFt.default), 'Map');
var $b3fc56271887eaf3$export$2e2bcd8739ae039 = $b3fc56271887eaf3$var$Map;



/* Built-in method references that are verified to be native. */ var $8e057c2da47d85b2$var$nativeCreate = (0, $e64d313d457435ee$export$2e2bcd8739ae039)(Object, 'create');
var $8e057c2da47d85b2$export$2e2bcd8739ae039 = $8e057c2da47d85b2$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $f37803ed33a1d3d1$var$hashClear() {
    this.__data__ = (0, $8e057c2da47d85b2$export$2e2bcd8739ae039) ? (0, $8e057c2da47d85b2$export$2e2bcd8739ae039)(null) : {};
    this.size = 0;
}
var $f37803ed33a1d3d1$export$2e2bcd8739ae039 = $f37803ed33a1d3d1$var$hashClear;


/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $2c3b841be68d9967$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $2c3b841be68d9967$export$2e2bcd8739ae039 = $2c3b841be68d9967$var$hashDelete;



/** Used to stand-in for `undefined` hash values. */ var $fb1e2001932a20de$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $fb1e2001932a20de$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $fb1e2001932a20de$var$hasOwnProperty = $fb1e2001932a20de$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $fb1e2001932a20de$var$hashGet(key) {
    var data = this.__data__;
    if (0, $8e057c2da47d85b2$export$2e2bcd8739ae039) {
        var result = data[key];
        return result === $fb1e2001932a20de$var$HASH_UNDEFINED ? undefined : result;
    }
    return $fb1e2001932a20de$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $fb1e2001932a20de$export$2e2bcd8739ae039 = $fb1e2001932a20de$var$hashGet;



/** Used for built-in method references. */ var $fdba09ea24ad742a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $fdba09ea24ad742a$var$hasOwnProperty = $fdba09ea24ad742a$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $fdba09ea24ad742a$var$hashHas(key) {
    var data = this.__data__;
    return (0, $8e057c2da47d85b2$export$2e2bcd8739ae039) ? data[key] !== undefined : $fdba09ea24ad742a$var$hasOwnProperty.call(data, key);
}
var $fdba09ea24ad742a$export$2e2bcd8739ae039 = $fdba09ea24ad742a$var$hashHas;



/** Used to stand-in for `undefined` hash values. */ var $7d2e036616ad2fb6$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $7d2e036616ad2fb6$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $8e057c2da47d85b2$export$2e2bcd8739ae039) && value === undefined ? $7d2e036616ad2fb6$var$HASH_UNDEFINED : value;
    return this;
}
var $7d2e036616ad2fb6$export$2e2bcd8739ae039 = $7d2e036616ad2fb6$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $fed14e894961a2f6$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$fed14e894961a2f6$var$Hash.prototype.clear = (0, $f37803ed33a1d3d1$export$2e2bcd8739ae039);
$fed14e894961a2f6$var$Hash.prototype['delete'] = (0, $2c3b841be68d9967$export$2e2bcd8739ae039);
$fed14e894961a2f6$var$Hash.prototype.get = (0, $fb1e2001932a20de$export$2e2bcd8739ae039);
$fed14e894961a2f6$var$Hash.prototype.has = (0, $fdba09ea24ad742a$export$2e2bcd8739ae039);
$fed14e894961a2f6$var$Hash.prototype.set = (0, $7d2e036616ad2fb6$export$2e2bcd8739ae039);
var $fed14e894961a2f6$export$2e2bcd8739ae039 = $fed14e894961a2f6$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $8708ff73733b2f97$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new (0, $fed14e894961a2f6$export$2e2bcd8739ae039),
        'map': new ((0, $b3fc56271887eaf3$export$2e2bcd8739ae039) || (0, $f3bb2bde4f3d2e10$export$2e2bcd8739ae039)),
        'string': new (0, $fed14e894961a2f6$export$2e2bcd8739ae039)
    };
}
var $8708ff73733b2f97$export$2e2bcd8739ae039 = $8708ff73733b2f97$var$mapCacheClear;


/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $399fee9a556f4b4d$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
var $399fee9a556f4b4d$export$2e2bcd8739ae039 = $399fee9a556f4b4d$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $6ec4556484e81801$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $399fee9a556f4b4d$export$2e2bcd8739ae039)(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
var $6ec4556484e81801$export$2e2bcd8739ae039 = $6ec4556484e81801$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $3b6f39a956fe6a39$var$mapCacheDelete(key) {
    var result = (0, $6ec4556484e81801$export$2e2bcd8739ae039)(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $3b6f39a956fe6a39$export$2e2bcd8739ae039 = $3b6f39a956fe6a39$var$mapCacheDelete;



/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $2efdcea83805e55c$var$mapCacheGet(key) {
    return (0, $6ec4556484e81801$export$2e2bcd8739ae039)(this, key).get(key);
}
var $2efdcea83805e55c$export$2e2bcd8739ae039 = $2efdcea83805e55c$var$mapCacheGet;



/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e8a97a3ac9920cdd$var$mapCacheHas(key) {
    return (0, $6ec4556484e81801$export$2e2bcd8739ae039)(this, key).has(key);
}
var $e8a97a3ac9920cdd$export$2e2bcd8739ae039 = $e8a97a3ac9920cdd$var$mapCacheHas;



/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $457a144fcd79754e$var$mapCacheSet(key, value) {
    var data = (0, $6ec4556484e81801$export$2e2bcd8739ae039)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $457a144fcd79754e$export$2e2bcd8739ae039 = $457a144fcd79754e$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $55dda8022ba8f51a$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$55dda8022ba8f51a$var$MapCache.prototype.clear = (0, $8708ff73733b2f97$export$2e2bcd8739ae039);
$55dda8022ba8f51a$var$MapCache.prototype['delete'] = (0, $3b6f39a956fe6a39$export$2e2bcd8739ae039);
$55dda8022ba8f51a$var$MapCache.prototype.get = (0, $2efdcea83805e55c$export$2e2bcd8739ae039);
$55dda8022ba8f51a$var$MapCache.prototype.has = (0, $e8a97a3ac9920cdd$export$2e2bcd8739ae039);
$55dda8022ba8f51a$var$MapCache.prototype.set = (0, $457a144fcd79754e$export$2e2bcd8739ae039);
var $55dda8022ba8f51a$export$2e2bcd8739ae039 = $55dda8022ba8f51a$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $d350707940985b27$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $d350707940985b27$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $f3bb2bde4f3d2e10$export$2e2bcd8739ae039)) {
        var pairs = data.__data__;
        if (!(0, $b3fc56271887eaf3$export$2e2bcd8739ae039) || pairs.length < $d350707940985b27$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $55dda8022ba8f51a$export$2e2bcd8739ae039)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $d350707940985b27$export$2e2bcd8739ae039 = $d350707940985b27$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $73c8979051c99f66$var$Stack(entries) {
    var data = this.__data__ = new (0, $f3bb2bde4f3d2e10$export$2e2bcd8739ae039)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$73c8979051c99f66$var$Stack.prototype.clear = (0, $926693c1c5aa1b3b$export$2e2bcd8739ae039);
$73c8979051c99f66$var$Stack.prototype['delete'] = (0, $44217bb0c3913906$export$2e2bcd8739ae039);
$73c8979051c99f66$var$Stack.prototype.get = (0, $fabb8c13d7ec2da0$export$2e2bcd8739ae039);
$73c8979051c99f66$var$Stack.prototype.has = (0, $8121243fb2037ab0$export$2e2bcd8739ae039);
$73c8979051c99f66$var$Stack.prototype.set = (0, $d350707940985b27$export$2e2bcd8739ae039);
var $73c8979051c99f66$export$2e2bcd8739ae039 = $73c8979051c99f66$var$Stack;



/** Used to stand-in for `undefined` hash values. */ var $ddf12460e0325b87$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $ddf12460e0325b87$var$setCacheAdd(value) {
    this.__data__.set(value, $ddf12460e0325b87$var$HASH_UNDEFINED);
    return this;
}
var $ddf12460e0325b87$export$2e2bcd8739ae039 = $ddf12460e0325b87$var$setCacheAdd;


/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $a5400587c2b0dcec$var$setCacheHas(value) {
    return this.__data__.has(value);
}
var $a5400587c2b0dcec$export$2e2bcd8739ae039 = $a5400587c2b0dcec$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $a1e9a2ddf37e1e25$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new (0, $55dda8022ba8f51a$export$2e2bcd8739ae039);
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$a1e9a2ddf37e1e25$var$SetCache.prototype.add = $a1e9a2ddf37e1e25$var$SetCache.prototype.push = (0, $ddf12460e0325b87$export$2e2bcd8739ae039);
$a1e9a2ddf37e1e25$var$SetCache.prototype.has = (0, $a5400587c2b0dcec$export$2e2bcd8739ae039);
var $a1e9a2ddf37e1e25$export$2e2bcd8739ae039 = $a1e9a2ddf37e1e25$var$SetCache;


/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $63023a486d78f8d1$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
var $63023a486d78f8d1$export$2e2bcd8739ae039 = $63023a486d78f8d1$var$arraySome;


/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $fc33292595196d6a$var$cacheHas(cache, key) {
    return cache.has(key);
}
var $fc33292595196d6a$export$2e2bcd8739ae039 = $fc33292595196d6a$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $a88d7e53afca3b5f$var$COMPARE_PARTIAL_FLAG = 1, $a88d7e53afca3b5f$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $a88d7e53afca3b5f$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $a88d7e53afca3b5f$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $a88d7e53afca3b5f$var$COMPARE_UNORDERED_FLAG ? new (0, $a1e9a2ddf37e1e25$export$2e2bcd8739ae039) : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!(0, $63023a486d78f8d1$export$2e2bcd8739ae039)(other, function(othValue, othIndex) {
                if (!(0, $fc33292595196d6a$export$2e2bcd8739ae039)(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
var $a88d7e53afca3b5f$export$2e2bcd8739ae039 = $a88d7e53afca3b5f$var$equalArrays;




var $2mpFt = parcelRequire("2mpFt");
/** Built-in value references. */ var $a00bfcf041d47533$var$Uint8Array = (0, $2mpFt.default).Uint8Array;
var $a00bfcf041d47533$export$2e2bcd8739ae039 = $a00bfcf041d47533$var$Uint8Array;




/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $5cf92809ef98e399$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
var $5cf92809ef98e399$export$2e2bcd8739ae039 = $5cf92809ef98e399$var$mapToArray;


/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $5d94aa434317cc8a$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
var $5d94aa434317cc8a$export$2e2bcd8739ae039 = $5d94aa434317cc8a$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $788b9615ccc4ea9d$var$COMPARE_PARTIAL_FLAG = 1, $788b9615ccc4ea9d$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $788b9615ccc4ea9d$var$boolTag = '[object Boolean]', $788b9615ccc4ea9d$var$dateTag = '[object Date]', $788b9615ccc4ea9d$var$errorTag = '[object Error]', $788b9615ccc4ea9d$var$mapTag = '[object Map]', $788b9615ccc4ea9d$var$numberTag = '[object Number]', $788b9615ccc4ea9d$var$regexpTag = '[object RegExp]', $788b9615ccc4ea9d$var$setTag = '[object Set]', $788b9615ccc4ea9d$var$stringTag = '[object String]', $788b9615ccc4ea9d$var$symbolTag = '[object Symbol]';
var $788b9615ccc4ea9d$var$arrayBufferTag = '[object ArrayBuffer]', $788b9615ccc4ea9d$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $788b9615ccc4ea9d$var$symbolProto = (0, $f302ffc9a48734c4$export$2e2bcd8739ae039) ? (0, $f302ffc9a48734c4$export$2e2bcd8739ae039).prototype : undefined, $788b9615ccc4ea9d$var$symbolValueOf = $788b9615ccc4ea9d$var$symbolProto ? $788b9615ccc4ea9d$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $788b9615ccc4ea9d$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $788b9615ccc4ea9d$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $788b9615ccc4ea9d$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new (0, $a00bfcf041d47533$export$2e2bcd8739ae039)(object), new (0, $a00bfcf041d47533$export$2e2bcd8739ae039)(other))) return false;
            return true;
        case $788b9615ccc4ea9d$var$boolTag:
        case $788b9615ccc4ea9d$var$dateTag:
        case $788b9615ccc4ea9d$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return (0, $fa799df2e830873c$export$2e2bcd8739ae039)(+object, +other);
        case $788b9615ccc4ea9d$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $788b9615ccc4ea9d$var$regexpTag:
        case $788b9615ccc4ea9d$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $788b9615ccc4ea9d$var$mapTag:
            var convert = (0, $5cf92809ef98e399$export$2e2bcd8739ae039);
        case $788b9615ccc4ea9d$var$setTag:
            var isPartial = bitmask & $788b9615ccc4ea9d$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = (0, $5d94aa434317cc8a$export$2e2bcd8739ae039));
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $788b9615ccc4ea9d$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = (0, $a88d7e53afca3b5f$export$2e2bcd8739ae039)(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $788b9615ccc4ea9d$var$symbolTag:
            if ($788b9615ccc4ea9d$var$symbolValueOf) return $788b9615ccc4ea9d$var$symbolValueOf.call(object) == $788b9615ccc4ea9d$var$symbolValueOf.call(other);
    }
    return false;
}
var $788b9615ccc4ea9d$export$2e2bcd8739ae039 = $788b9615ccc4ea9d$var$equalByTag;


/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $4e7ed5991d883ad6$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $4e7ed5991d883ad6$export$2e2bcd8739ae039 = $4e7ed5991d883ad6$var$arrayPush;


/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $c8d4506109b88831$var$isArray = Array.isArray;
var $c8d4506109b88831$export$2e2bcd8739ae039 = $c8d4506109b88831$var$isArray;


/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $cf47ca2fc3f4de6e$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $c8d4506109b88831$export$2e2bcd8739ae039)(object) ? result : (0, $4e7ed5991d883ad6$export$2e2bcd8739ae039)(result, symbolsFunc(object));
}
var $cf47ca2fc3f4de6e$export$2e2bcd8739ae039 = $cf47ca2fc3f4de6e$var$baseGetAllKeys;


/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $84dbc91852227c49$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $84dbc91852227c49$export$2e2bcd8739ae039 = $84dbc91852227c49$var$arrayFilter;


/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $245eab4238d1191b$var$stubArray() {
    return [];
}
var $245eab4238d1191b$export$2e2bcd8739ae039 = $245eab4238d1191b$var$stubArray;


/** Used for built-in method references. */ var $02956b8552c88dad$var$objectProto = Object.prototype;
/** Built-in value references. */ var $02956b8552c88dad$var$propertyIsEnumerable = $02956b8552c88dad$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $02956b8552c88dad$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $02956b8552c88dad$var$getSymbols = !$02956b8552c88dad$var$nativeGetSymbols ? (0, $245eab4238d1191b$export$2e2bcd8739ae039) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $84dbc91852227c49$export$2e2bcd8739ae039)($02956b8552c88dad$var$nativeGetSymbols(object), function(symbol) {
        return $02956b8552c88dad$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $02956b8552c88dad$export$2e2bcd8739ae039 = $02956b8552c88dad$var$getSymbols;


/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $25c66d2c4e8fadd1$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $25c66d2c4e8fadd1$export$2e2bcd8739ae039 = $25c66d2c4e8fadd1$var$baseTimes;



/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $af254ed7460d123e$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $af254ed7460d123e$export$2e2bcd8739ae039 = $af254ed7460d123e$var$isObjectLike;


/** `Object#toString` result references. */ var $ddc0844e7eecdb52$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $ddc0844e7eecdb52$var$baseIsArguments(value) {
    return (0, $af254ed7460d123e$export$2e2bcd8739ae039)(value) && (0, $ccdb19c7f0a62300$export$2e2bcd8739ae039)(value) == $ddc0844e7eecdb52$var$argsTag;
}
var $ddc0844e7eecdb52$export$2e2bcd8739ae039 = $ddc0844e7eecdb52$var$baseIsArguments;



/** Used for built-in method references. */ var $44fca59879666c41$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $44fca59879666c41$var$hasOwnProperty = $44fca59879666c41$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $44fca59879666c41$var$propertyIsEnumerable = $44fca59879666c41$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $44fca59879666c41$var$isArguments = (0, $ddc0844e7eecdb52$export$2e2bcd8739ae039)(function() {
    return arguments;
}()) ? (0, $ddc0844e7eecdb52$export$2e2bcd8739ae039) : function(value) {
    return (0, $af254ed7460d123e$export$2e2bcd8739ae039)(value) && $44fca59879666c41$var$hasOwnProperty.call(value, 'callee') && !$44fca59879666c41$var$propertyIsEnumerable.call(value, 'callee');
};
var $44fca59879666c41$export$2e2bcd8739ae039 = $44fca59879666c41$var$isArguments;




var $f3ZL4 = parcelRequire("f3ZL4");
/** Used as references for various `Number` constants. */ var $92e841cef318fb91$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $92e841cef318fb91$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $92e841cef318fb91$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $92e841cef318fb91$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $92e841cef318fb91$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $92e841cef318fb91$export$2e2bcd8739ae039 = $92e841cef318fb91$var$isIndex;



/** Used as references for various `Number` constants. */ var $d43fbbcf5bc665de$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $d43fbbcf5bc665de$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $d43fbbcf5bc665de$var$MAX_SAFE_INTEGER;
}
var $d43fbbcf5bc665de$export$2e2bcd8739ae039 = $d43fbbcf5bc665de$var$isLength;



/** `Object#toString` result references. */ var $a51ff94e4fd33486$var$argsTag = '[object Arguments]', $a51ff94e4fd33486$var$arrayTag = '[object Array]', $a51ff94e4fd33486$var$boolTag = '[object Boolean]', $a51ff94e4fd33486$var$dateTag = '[object Date]', $a51ff94e4fd33486$var$errorTag = '[object Error]', $a51ff94e4fd33486$var$funcTag = '[object Function]', $a51ff94e4fd33486$var$mapTag = '[object Map]', $a51ff94e4fd33486$var$numberTag = '[object Number]', $a51ff94e4fd33486$var$objectTag = '[object Object]', $a51ff94e4fd33486$var$regexpTag = '[object RegExp]', $a51ff94e4fd33486$var$setTag = '[object Set]', $a51ff94e4fd33486$var$stringTag = '[object String]', $a51ff94e4fd33486$var$weakMapTag = '[object WeakMap]';
var $a51ff94e4fd33486$var$arrayBufferTag = '[object ArrayBuffer]', $a51ff94e4fd33486$var$dataViewTag = '[object DataView]', $a51ff94e4fd33486$var$float32Tag = '[object Float32Array]', $a51ff94e4fd33486$var$float64Tag = '[object Float64Array]', $a51ff94e4fd33486$var$int8Tag = '[object Int8Array]', $a51ff94e4fd33486$var$int16Tag = '[object Int16Array]', $a51ff94e4fd33486$var$int32Tag = '[object Int32Array]', $a51ff94e4fd33486$var$uint8Tag = '[object Uint8Array]', $a51ff94e4fd33486$var$uint8ClampedTag = '[object Uint8ClampedArray]', $a51ff94e4fd33486$var$uint16Tag = '[object Uint16Array]', $a51ff94e4fd33486$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $a51ff94e4fd33486$var$typedArrayTags = {};
$a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$float32Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$float64Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$int8Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$int16Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$int32Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$uint8Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$uint8ClampedTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$uint16Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$uint32Tag] = true;
$a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$argsTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$arrayTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$arrayBufferTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$boolTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$dataViewTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$dateTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$errorTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$funcTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$mapTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$numberTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$objectTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$regexpTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$setTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$stringTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $a51ff94e4fd33486$var$baseIsTypedArray(value) {
    return (0, $af254ed7460d123e$export$2e2bcd8739ae039)(value) && (0, $d43fbbcf5bc665de$export$2e2bcd8739ae039)(value.length) && !!$a51ff94e4fd33486$var$typedArrayTags[(0, $ccdb19c7f0a62300$export$2e2bcd8739ae039)(value)];
}
var $a51ff94e4fd33486$export$2e2bcd8739ae039 = $a51ff94e4fd33486$var$baseIsTypedArray;


/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $c8139f05a61e038a$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $c8139f05a61e038a$export$2e2bcd8739ae039 = $c8139f05a61e038a$var$baseUnary;



var $lFXqE = parcelRequire("lFXqE");
/* Node.js helper references. */ var $901262b1d4441a58$var$nodeIsTypedArray = (0, $lFXqE.default) && (0, $lFXqE.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $901262b1d4441a58$var$isTypedArray = $901262b1d4441a58$var$nodeIsTypedArray ? (0, $c8139f05a61e038a$export$2e2bcd8739ae039)($901262b1d4441a58$var$nodeIsTypedArray) : (0, $a51ff94e4fd33486$export$2e2bcd8739ae039);
var $901262b1d4441a58$export$2e2bcd8739ae039 = $901262b1d4441a58$var$isTypedArray;


/** Used for built-in method references. */ var $09822de5e5cf749f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $09822de5e5cf749f$var$hasOwnProperty = $09822de5e5cf749f$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $09822de5e5cf749f$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $c8d4506109b88831$export$2e2bcd8739ae039)(value), isArg = !isArr && (0, $44fca59879666c41$export$2e2bcd8739ae039)(value), isBuff = !isArr && !isArg && (0, $f3ZL4.default)(value), isType = !isArr && !isArg && !isBuff && (0, $901262b1d4441a58$export$2e2bcd8739ae039)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $25c66d2c4e8fadd1$export$2e2bcd8739ae039)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $09822de5e5cf749f$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    (0, $92e841cef318fb91$export$2e2bcd8739ae039)(key, length)))) result.push(key);
    return result;
}
var $09822de5e5cf749f$export$2e2bcd8739ae039 = $09822de5e5cf749f$var$arrayLikeKeys;


/** Used for built-in method references. */ var $5271b3ac6403835d$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $5271b3ac6403835d$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $5271b3ac6403835d$var$objectProto;
    return value === proto;
}
var $5271b3ac6403835d$export$2e2bcd8739ae039 = $5271b3ac6403835d$var$isPrototype;


/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $5abe0bf7e062106b$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $5abe0bf7e062106b$export$2e2bcd8739ae039 = $5abe0bf7e062106b$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $329b8ad85e05c8eb$var$nativeKeys = (0, $5abe0bf7e062106b$export$2e2bcd8739ae039)(Object.keys, Object);
var $329b8ad85e05c8eb$export$2e2bcd8739ae039 = $329b8ad85e05c8eb$var$nativeKeys;


/** Used for built-in method references. */ var $ff094f04b4f9f6ca$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ff094f04b4f9f6ca$var$hasOwnProperty = $ff094f04b4f9f6ca$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $ff094f04b4f9f6ca$var$baseKeys(object) {
    if (!(0, $5271b3ac6403835d$export$2e2bcd8739ae039)(object)) return (0, $329b8ad85e05c8eb$export$2e2bcd8739ae039)(object);
    var result = [];
    for(var key in Object(object))if ($ff094f04b4f9f6ca$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
var $ff094f04b4f9f6ca$export$2e2bcd8739ae039 = $ff094f04b4f9f6ca$var$baseKeys;




/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $fb8472aba17743fc$var$isArrayLike(value) {
    return value != null && (0, $d43fbbcf5bc665de$export$2e2bcd8739ae039)(value.length) && !(0, $397b12740d7995ef$export$2e2bcd8739ae039)(value);
}
var $fb8472aba17743fc$export$2e2bcd8739ae039 = $fb8472aba17743fc$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $6105a42c6332ca51$var$keys(object) {
    return (0, $fb8472aba17743fc$export$2e2bcd8739ae039)(object) ? (0, $09822de5e5cf749f$export$2e2bcd8739ae039)(object) : (0, $ff094f04b4f9f6ca$export$2e2bcd8739ae039)(object);
}
var $6105a42c6332ca51$export$2e2bcd8739ae039 = $6105a42c6332ca51$var$keys;


/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $04a5ed8d1a69f13e$var$getAllKeys(object) {
    return (0, $cf47ca2fc3f4de6e$export$2e2bcd8739ae039)(object, (0, $6105a42c6332ca51$export$2e2bcd8739ae039), (0, $02956b8552c88dad$export$2e2bcd8739ae039));
}
var $04a5ed8d1a69f13e$export$2e2bcd8739ae039 = $04a5ed8d1a69f13e$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $3a72e1a244e07566$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $3a72e1a244e07566$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3a72e1a244e07566$var$hasOwnProperty = $3a72e1a244e07566$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $3a72e1a244e07566$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $3a72e1a244e07566$var$COMPARE_PARTIAL_FLAG, objProps = (0, $04a5ed8d1a69f13e$export$2e2bcd8739ae039)(object), objLength = objProps.length, othProps = (0, $04a5ed8d1a69f13e$export$2e2bcd8739ae039)(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $3a72e1a244e07566$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
var $3a72e1a244e07566$export$2e2bcd8739ae039 = $3a72e1a244e07566$var$equalObjects;




var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $a1648453896f67d2$var$DataView = (0, $e64d313d457435ee$export$2e2bcd8739ae039)((0, $2mpFt.default), 'DataView');
var $a1648453896f67d2$export$2e2bcd8739ae039 = $a1648453896f67d2$var$DataView;





var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $768c3ff3ee4df356$var$Promise = (0, $e64d313d457435ee$export$2e2bcd8739ae039)((0, $2mpFt.default), 'Promise');
var $768c3ff3ee4df356$export$2e2bcd8739ae039 = $768c3ff3ee4df356$var$Promise;




var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $d81f7aa452e6e637$var$Set = (0, $e64d313d457435ee$export$2e2bcd8739ae039)((0, $2mpFt.default), 'Set');
var $d81f7aa452e6e637$export$2e2bcd8739ae039 = $d81f7aa452e6e637$var$Set;




var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $11f94673ff7d99d8$var$WeakMap = (0, $e64d313d457435ee$export$2e2bcd8739ae039)((0, $2mpFt.default), 'WeakMap');
var $11f94673ff7d99d8$export$2e2bcd8739ae039 = $11f94673ff7d99d8$var$WeakMap;




/** `Object#toString` result references. */ var $34aa59a61c7ccccb$var$mapTag = '[object Map]', $34aa59a61c7ccccb$var$objectTag = '[object Object]', $34aa59a61c7ccccb$var$promiseTag = '[object Promise]', $34aa59a61c7ccccb$var$setTag = '[object Set]', $34aa59a61c7ccccb$var$weakMapTag = '[object WeakMap]';
var $34aa59a61c7ccccb$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $34aa59a61c7ccccb$var$dataViewCtorString = (0, $3c5a435f91273845$export$2e2bcd8739ae039)((0, $a1648453896f67d2$export$2e2bcd8739ae039)), $34aa59a61c7ccccb$var$mapCtorString = (0, $3c5a435f91273845$export$2e2bcd8739ae039)((0, $b3fc56271887eaf3$export$2e2bcd8739ae039)), $34aa59a61c7ccccb$var$promiseCtorString = (0, $3c5a435f91273845$export$2e2bcd8739ae039)((0, $768c3ff3ee4df356$export$2e2bcd8739ae039)), $34aa59a61c7ccccb$var$setCtorString = (0, $3c5a435f91273845$export$2e2bcd8739ae039)((0, $d81f7aa452e6e637$export$2e2bcd8739ae039)), $34aa59a61c7ccccb$var$weakMapCtorString = (0, $3c5a435f91273845$export$2e2bcd8739ae039)((0, $11f94673ff7d99d8$export$2e2bcd8739ae039));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $34aa59a61c7ccccb$var$getTag = (0, $ccdb19c7f0a62300$export$2e2bcd8739ae039);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $a1648453896f67d2$export$2e2bcd8739ae039) && $34aa59a61c7ccccb$var$getTag(new (0, $a1648453896f67d2$export$2e2bcd8739ae039)(new ArrayBuffer(1))) != $34aa59a61c7ccccb$var$dataViewTag || (0, $b3fc56271887eaf3$export$2e2bcd8739ae039) && $34aa59a61c7ccccb$var$getTag(new (0, $b3fc56271887eaf3$export$2e2bcd8739ae039)) != $34aa59a61c7ccccb$var$mapTag || (0, $768c3ff3ee4df356$export$2e2bcd8739ae039) && $34aa59a61c7ccccb$var$getTag((0, $768c3ff3ee4df356$export$2e2bcd8739ae039).resolve()) != $34aa59a61c7ccccb$var$promiseTag || (0, $d81f7aa452e6e637$export$2e2bcd8739ae039) && $34aa59a61c7ccccb$var$getTag(new (0, $d81f7aa452e6e637$export$2e2bcd8739ae039)) != $34aa59a61c7ccccb$var$setTag || (0, $11f94673ff7d99d8$export$2e2bcd8739ae039) && $34aa59a61c7ccccb$var$getTag(new (0, $11f94673ff7d99d8$export$2e2bcd8739ae039)) != $34aa59a61c7ccccb$var$weakMapTag) $34aa59a61c7ccccb$var$getTag = function(value) {
    var result = (0, $ccdb19c7f0a62300$export$2e2bcd8739ae039)(value), Ctor = result == $34aa59a61c7ccccb$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $3c5a435f91273845$export$2e2bcd8739ae039)(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $34aa59a61c7ccccb$var$dataViewCtorString:
            return $34aa59a61c7ccccb$var$dataViewTag;
        case $34aa59a61c7ccccb$var$mapCtorString:
            return $34aa59a61c7ccccb$var$mapTag;
        case $34aa59a61c7ccccb$var$promiseCtorString:
            return $34aa59a61c7ccccb$var$promiseTag;
        case $34aa59a61c7ccccb$var$setCtorString:
            return $34aa59a61c7ccccb$var$setTag;
        case $34aa59a61c7ccccb$var$weakMapCtorString:
            return $34aa59a61c7ccccb$var$weakMapTag;
    }
    return result;
};
var $34aa59a61c7ccccb$export$2e2bcd8739ae039 = $34aa59a61c7ccccb$var$getTag;




var $f3ZL4 = parcelRequire("f3ZL4");

/** Used to compose bitmasks for value comparisons. */ var $e1ab537c68aa36d5$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $e1ab537c68aa36d5$var$argsTag = '[object Arguments]', $e1ab537c68aa36d5$var$arrayTag = '[object Array]', $e1ab537c68aa36d5$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $e1ab537c68aa36d5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e1ab537c68aa36d5$var$hasOwnProperty = $e1ab537c68aa36d5$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $e1ab537c68aa36d5$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = (0, $c8d4506109b88831$export$2e2bcd8739ae039)(object), othIsArr = (0, $c8d4506109b88831$export$2e2bcd8739ae039)(other), objTag = objIsArr ? $e1ab537c68aa36d5$var$arrayTag : (0, $34aa59a61c7ccccb$export$2e2bcd8739ae039)(object), othTag = othIsArr ? $e1ab537c68aa36d5$var$arrayTag : (0, $34aa59a61c7ccccb$export$2e2bcd8739ae039)(other);
    objTag = objTag == $e1ab537c68aa36d5$var$argsTag ? $e1ab537c68aa36d5$var$objectTag : objTag;
    othTag = othTag == $e1ab537c68aa36d5$var$argsTag ? $e1ab537c68aa36d5$var$objectTag : othTag;
    var objIsObj = objTag == $e1ab537c68aa36d5$var$objectTag, othIsObj = othTag == $e1ab537c68aa36d5$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && (0, $f3ZL4.default)(object)) {
        if (!(0, $f3ZL4.default)(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new (0, $73c8979051c99f66$export$2e2bcd8739ae039));
        return objIsArr || (0, $901262b1d4441a58$export$2e2bcd8739ae039)(object) ? (0, $a88d7e53afca3b5f$export$2e2bcd8739ae039)(object, other, bitmask, customizer, equalFunc, stack) : (0, $788b9615ccc4ea9d$export$2e2bcd8739ae039)(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $e1ab537c68aa36d5$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $e1ab537c68aa36d5$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $e1ab537c68aa36d5$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new (0, $73c8979051c99f66$export$2e2bcd8739ae039));
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new (0, $73c8979051c99f66$export$2e2bcd8739ae039));
    return (0, $3a72e1a244e07566$export$2e2bcd8739ae039)(object, other, bitmask, customizer, equalFunc, stack);
}
var $e1ab537c68aa36d5$export$2e2bcd8739ae039 = $e1ab537c68aa36d5$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $c670de299407e555$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !(0, $af254ed7460d123e$export$2e2bcd8739ae039)(value) && !(0, $af254ed7460d123e$export$2e2bcd8739ae039)(other)) return value !== value && other !== other;
    return (0, $e1ab537c68aa36d5$export$2e2bcd8739ae039)(value, other, bitmask, customizer, $c670de299407e555$var$baseIsEqual, stack);
}
var $c670de299407e555$export$2e2bcd8739ae039 = $c670de299407e555$var$baseIsEqual;


/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $07a598d7bdcdfb03$var$isEqual(value, other) {
    return (0, $c670de299407e555$export$2e2bcd8739ae039)(value, other);
}
var $07a598d7bdcdfb03$export$2e2bcd8739ae039 = $07a598d7bdcdfb03$var$isEqual;



/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $7757f4c9b8d2d7a9$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $7757f4c9b8d2d7a9$export$2e2bcd8739ae039 = $7757f4c9b8d2d7a9$var$arrayMap;





/** `Object#toString` result references. */ var $16b138b0231026b6$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $16b138b0231026b6$var$isSymbol(value) {
    return typeof value == 'symbol' || (0, $af254ed7460d123e$export$2e2bcd8739ae039)(value) && (0, $ccdb19c7f0a62300$export$2e2bcd8739ae039)(value) == $16b138b0231026b6$var$symbolTag;
}
var $16b138b0231026b6$export$2e2bcd8739ae039 = $16b138b0231026b6$var$isSymbol;


/** Used as references for various `Number` constants. */ var $3fa2e3fba0ff938d$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $3fa2e3fba0ff938d$var$symbolProto = (0, $f302ffc9a48734c4$export$2e2bcd8739ae039) ? (0, $f302ffc9a48734c4$export$2e2bcd8739ae039).prototype : undefined, $3fa2e3fba0ff938d$var$symbolToString = $3fa2e3fba0ff938d$var$symbolProto ? $3fa2e3fba0ff938d$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $3fa2e3fba0ff938d$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ((0, $c8d4506109b88831$export$2e2bcd8739ae039)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $7757f4c9b8d2d7a9$export$2e2bcd8739ae039)(value, $3fa2e3fba0ff938d$var$baseToString) + '';
    if ((0, $16b138b0231026b6$export$2e2bcd8739ae039)(value)) return $3fa2e3fba0ff938d$var$symbolToString ? $3fa2e3fba0ff938d$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$3fa2e3fba0ff938d$var$INFINITY ? '-0' : result;
}
var $3fa2e3fba0ff938d$export$2e2bcd8739ae039 = $3fa2e3fba0ff938d$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $0e8974ff738aca49$var$toString(value) {
    return value == null ? '' : (0, $3fa2e3fba0ff938d$export$2e2bcd8739ae039)(value);
}
var $0e8974ff738aca49$export$2e2bcd8739ae039 = $0e8974ff738aca49$var$toString;


/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $632aa29c87e61531$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
var $632aa29c87e61531$export$2e2bcd8739ae039 = $632aa29c87e61531$var$baseSlice;


/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $9883175c52fe19da$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : (0, $632aa29c87e61531$export$2e2bcd8739ae039)(array, start, end);
}
var $9883175c52fe19da$export$2e2bcd8739ae039 = $9883175c52fe19da$var$castSlice;


/** Used to compose unicode character classes. */ var $4f0567e72dd9ce2b$var$rsAstralRange = '\\ud800-\\udfff', $4f0567e72dd9ce2b$var$rsComboMarksRange = '\\u0300-\\u036f', $4f0567e72dd9ce2b$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $4f0567e72dd9ce2b$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $4f0567e72dd9ce2b$var$rsComboRange = $4f0567e72dd9ce2b$var$rsComboMarksRange + $4f0567e72dd9ce2b$var$reComboHalfMarksRange + $4f0567e72dd9ce2b$var$rsComboSymbolsRange, $4f0567e72dd9ce2b$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $4f0567e72dd9ce2b$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $4f0567e72dd9ce2b$var$reHasUnicode = RegExp('[' + $4f0567e72dd9ce2b$var$rsZWJ + $4f0567e72dd9ce2b$var$rsAstralRange + $4f0567e72dd9ce2b$var$rsComboRange + $4f0567e72dd9ce2b$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $4f0567e72dd9ce2b$var$hasUnicode(string) {
    return $4f0567e72dd9ce2b$var$reHasUnicode.test(string);
}
var $4f0567e72dd9ce2b$export$2e2bcd8739ae039 = $4f0567e72dd9ce2b$var$hasUnicode;


/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $7c2aa7f8f772b324$var$asciiToArray(string) {
    return string.split('');
}
var $7c2aa7f8f772b324$export$2e2bcd8739ae039 = $7c2aa7f8f772b324$var$asciiToArray;



/** Used to compose unicode character classes. */ var $f89d02de0bef2564$var$rsAstralRange = '\\ud800-\\udfff', $f89d02de0bef2564$var$rsComboMarksRange = '\\u0300-\\u036f', $f89d02de0bef2564$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $f89d02de0bef2564$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $f89d02de0bef2564$var$rsComboRange = $f89d02de0bef2564$var$rsComboMarksRange + $f89d02de0bef2564$var$reComboHalfMarksRange + $f89d02de0bef2564$var$rsComboSymbolsRange, $f89d02de0bef2564$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $f89d02de0bef2564$var$rsAstral = '[' + $f89d02de0bef2564$var$rsAstralRange + ']', $f89d02de0bef2564$var$rsCombo = '[' + $f89d02de0bef2564$var$rsComboRange + ']', $f89d02de0bef2564$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $f89d02de0bef2564$var$rsModifier = '(?:' + $f89d02de0bef2564$var$rsCombo + '|' + $f89d02de0bef2564$var$rsFitz + ')', $f89d02de0bef2564$var$rsNonAstral = '[^' + $f89d02de0bef2564$var$rsAstralRange + ']', $f89d02de0bef2564$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $f89d02de0bef2564$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $f89d02de0bef2564$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $f89d02de0bef2564$var$reOptMod = $f89d02de0bef2564$var$rsModifier + '?', $f89d02de0bef2564$var$rsOptVar = '[' + $f89d02de0bef2564$var$rsVarRange + ']?', $f89d02de0bef2564$var$rsOptJoin = '(?:' + $f89d02de0bef2564$var$rsZWJ + '(?:' + [
    $f89d02de0bef2564$var$rsNonAstral,
    $f89d02de0bef2564$var$rsRegional,
    $f89d02de0bef2564$var$rsSurrPair
].join('|') + ')' + $f89d02de0bef2564$var$rsOptVar + $f89d02de0bef2564$var$reOptMod + ')*', $f89d02de0bef2564$var$rsSeq = $f89d02de0bef2564$var$rsOptVar + $f89d02de0bef2564$var$reOptMod + $f89d02de0bef2564$var$rsOptJoin, $f89d02de0bef2564$var$rsSymbol = '(?:' + [
    $f89d02de0bef2564$var$rsNonAstral + $f89d02de0bef2564$var$rsCombo + '?',
    $f89d02de0bef2564$var$rsCombo,
    $f89d02de0bef2564$var$rsRegional,
    $f89d02de0bef2564$var$rsSurrPair,
    $f89d02de0bef2564$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $f89d02de0bef2564$var$reUnicode = RegExp($f89d02de0bef2564$var$rsFitz + '(?=' + $f89d02de0bef2564$var$rsFitz + ')|' + $f89d02de0bef2564$var$rsSymbol + $f89d02de0bef2564$var$rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $f89d02de0bef2564$var$unicodeToArray(string) {
    return string.match($f89d02de0bef2564$var$reUnicode) || [];
}
var $f89d02de0bef2564$export$2e2bcd8739ae039 = $f89d02de0bef2564$var$unicodeToArray;


/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $c71eef9ea1732fba$var$stringToArray(string) {
    return (0, $4f0567e72dd9ce2b$export$2e2bcd8739ae039)(string) ? (0, $f89d02de0bef2564$export$2e2bcd8739ae039)(string) : (0, $7c2aa7f8f772b324$export$2e2bcd8739ae039)(string);
}
var $c71eef9ea1732fba$export$2e2bcd8739ae039 = $c71eef9ea1732fba$var$stringToArray;



/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $750ad476ec58e06d$var$createCaseFirst(methodName) {
    return function(string) {
        string = (0, $0e8974ff738aca49$export$2e2bcd8739ae039)(string);
        var strSymbols = (0, $4f0567e72dd9ce2b$export$2e2bcd8739ae039)(string) ? (0, $c71eef9ea1732fba$export$2e2bcd8739ae039)(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? (0, $9883175c52fe19da$export$2e2bcd8739ae039)(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
var $750ad476ec58e06d$export$2e2bcd8739ae039 = $750ad476ec58e06d$var$createCaseFirst;


/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $cd07bab7cc5d99bb$var$upperFirst = (0, $750ad476ec58e06d$export$2e2bcd8739ae039)('toUpperCase');
var $cd07bab7cc5d99bb$export$2e2bcd8739ae039 = $cd07bab7cc5d99bb$var$upperFirst;


/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $0ff7d71e45d9103c$var$capitalize(string) {
    return (0, $cd07bab7cc5d99bb$export$2e2bcd8739ae039)((0, $0e8974ff738aca49$export$2e2bcd8739ae039)(string).toLowerCase());
}
var $0ff7d71e45d9103c$export$2e2bcd8739ae039 = $0ff7d71e45d9103c$var$capitalize;



var $63618293c58b5f80$exports = {};
'use strict';
Object.defineProperty($63618293c58b5f80$exports, '__esModule', {
    value: true
});
function $63618293c58b5f80$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $63618293c58b5f80$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $63618293c58b5f80$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $63618293c58b5f80$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $63618293c58b5f80$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $63618293c58b5f80$var$_extends() {
    $63618293c58b5f80$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $63618293c58b5f80$var$_extends.apply(this, arguments);
}
function $63618293c58b5f80$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $63618293c58b5f80$var$_setPrototypeOf(subClass, superClass);
}
function $63618293c58b5f80$var$_getPrototypeOf(o) {
    $63618293c58b5f80$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $63618293c58b5f80$var$_getPrototypeOf(o);
}
function $63618293c58b5f80$var$_setPrototypeOf(o, p) {
    $63618293c58b5f80$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $63618293c58b5f80$var$_setPrototypeOf(o, p);
}
function $63618293c58b5f80$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $63618293c58b5f80$var$_construct(Parent, args, Class) {
    if ($63618293c58b5f80$var$_isNativeReflectConstruct()) $63618293c58b5f80$var$_construct = Reflect.construct.bind();
    else $63618293c58b5f80$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $63618293c58b5f80$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $63618293c58b5f80$var$_construct.apply(null, arguments);
}
function $63618293c58b5f80$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $63618293c58b5f80$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $63618293c58b5f80$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$63618293c58b5f80$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $63618293c58b5f80$var$_construct(Class, arguments, $63618293c58b5f80$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $63618293c58b5f80$var$_setPrototypeOf(Wrapper, Class);
    };
    return $63618293c58b5f80$var$_wrapNativeSuper(Class);
}
function $63618293c58b5f80$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $63618293c58b5f80$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $63618293c58b5f80$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $63618293c58b5f80$var$_arrayLikeToArray(o, minLen);
}
function $63618293c58b5f80$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $63618293c58b5f80$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $63618293c58b5f80$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $63618293c58b5f80$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $63618293c58b5f80$var$_toPropertyKey(arg) {
    var key = $63618293c58b5f80$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
// these aren't really private, but nor are they really useful to document
/**
 * @private
 */ var $63618293c58b5f80$var$LuxonError = /*#__PURE__*/ function(_Error) {
    $63618293c58b5f80$var$_inheritsLoose(LuxonError, _Error);
    function LuxonError() {
        return _Error.apply(this, arguments) || this;
    }
    return LuxonError;
}(/*#__PURE__*/ $63618293c58b5f80$var$_wrapNativeSuper(Error));
/**
 * @private
 */ var $63618293c58b5f80$var$InvalidDateTimeError = /*#__PURE__*/ function(_LuxonError) {
    $63618293c58b5f80$var$_inheritsLoose(InvalidDateTimeError, _LuxonError);
    function InvalidDateTimeError(reason) {
        return _LuxonError.call(this, "Invalid DateTime: " + reason.toMessage()) || this;
    }
    return InvalidDateTimeError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$InvalidIntervalError = /*#__PURE__*/ function(_LuxonError2) {
    $63618293c58b5f80$var$_inheritsLoose(InvalidIntervalError, _LuxonError2);
    function InvalidIntervalError(reason) {
        return _LuxonError2.call(this, "Invalid Interval: " + reason.toMessage()) || this;
    }
    return InvalidIntervalError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$InvalidDurationError = /*#__PURE__*/ function(_LuxonError3) {
    $63618293c58b5f80$var$_inheritsLoose(InvalidDurationError, _LuxonError3);
    function InvalidDurationError(reason) {
        return _LuxonError3.call(this, "Invalid Duration: " + reason.toMessage()) || this;
    }
    return InvalidDurationError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$ConflictingSpecificationError = /*#__PURE__*/ function(_LuxonError4) {
    $63618293c58b5f80$var$_inheritsLoose(ConflictingSpecificationError, _LuxonError4);
    function ConflictingSpecificationError() {
        return _LuxonError4.apply(this, arguments) || this;
    }
    return ConflictingSpecificationError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$InvalidUnitError = /*#__PURE__*/ function(_LuxonError5) {
    $63618293c58b5f80$var$_inheritsLoose(InvalidUnitError, _LuxonError5);
    function InvalidUnitError(unit) {
        return _LuxonError5.call(this, "Invalid unit " + unit) || this;
    }
    return InvalidUnitError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$InvalidArgumentError = /*#__PURE__*/ function(_LuxonError6) {
    $63618293c58b5f80$var$_inheritsLoose(InvalidArgumentError, _LuxonError6);
    function InvalidArgumentError() {
        return _LuxonError6.apply(this, arguments) || this;
    }
    return InvalidArgumentError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$ZoneIsAbstractError = /*#__PURE__*/ function(_LuxonError7) {
    $63618293c58b5f80$var$_inheritsLoose(ZoneIsAbstractError, _LuxonError7);
    function ZoneIsAbstractError() {
        return _LuxonError7.call(this, "Zone is an abstract class") || this;
    }
    return ZoneIsAbstractError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$n = "numeric", $63618293c58b5f80$var$s = "short", $63618293c58b5f80$var$l = "long";
var $63618293c58b5f80$var$DATE_SHORT = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$n,
    day: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATE_MED = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$s,
    day: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATE_MED_WITH_WEEKDAY = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$s,
    day: $63618293c58b5f80$var$n,
    weekday: $63618293c58b5f80$var$s
};
var $63618293c58b5f80$var$DATE_FULL = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$l,
    day: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATE_HUGE = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$l,
    day: $63618293c58b5f80$var$n,
    weekday: $63618293c58b5f80$var$l
};
var $63618293c58b5f80$var$TIME_SIMPLE = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$TIME_WITH_SECONDS = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$TIME_WITH_SHORT_OFFSET = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    timeZoneName: $63618293c58b5f80$var$s
};
var $63618293c58b5f80$var$TIME_WITH_LONG_OFFSET = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    timeZoneName: $63618293c58b5f80$var$l
};
var $63618293c58b5f80$var$TIME_24_SIMPLE = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    hourCycle: "h23"
};
var $63618293c58b5f80$var$TIME_24_WITH_SECONDS = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    hourCycle: "h23"
};
var $63618293c58b5f80$var$TIME_24_WITH_SHORT_OFFSET = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    hourCycle: "h23",
    timeZoneName: $63618293c58b5f80$var$s
};
var $63618293c58b5f80$var$TIME_24_WITH_LONG_OFFSET = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    hourCycle: "h23",
    timeZoneName: $63618293c58b5f80$var$l
};
var $63618293c58b5f80$var$DATETIME_SHORT = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$n,
    day: $63618293c58b5f80$var$n,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATETIME_SHORT_WITH_SECONDS = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$n,
    day: $63618293c58b5f80$var$n,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATETIME_MED = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$s,
    day: $63618293c58b5f80$var$n,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATETIME_MED_WITH_SECONDS = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$s,
    day: $63618293c58b5f80$var$n,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATETIME_MED_WITH_WEEKDAY = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$s,
    day: $63618293c58b5f80$var$n,
    weekday: $63618293c58b5f80$var$s,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATETIME_FULL = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$l,
    day: $63618293c58b5f80$var$n,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    timeZoneName: $63618293c58b5f80$var$s
};
var $63618293c58b5f80$var$DATETIME_FULL_WITH_SECONDS = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$l,
    day: $63618293c58b5f80$var$n,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    timeZoneName: $63618293c58b5f80$var$s
};
var $63618293c58b5f80$var$DATETIME_HUGE = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$l,
    day: $63618293c58b5f80$var$n,
    weekday: $63618293c58b5f80$var$l,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    timeZoneName: $63618293c58b5f80$var$l
};
var $63618293c58b5f80$var$DATETIME_HUGE_WITH_SECONDS = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$l,
    day: $63618293c58b5f80$var$n,
    weekday: $63618293c58b5f80$var$l,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    timeZoneName: $63618293c58b5f80$var$l
};
/**
 * @interface
 */ var $63618293c58b5f80$var$Zone = /*#__PURE__*/ function() {
    function Zone() {}
    var _proto = Zone.prototype;
    /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */ _proto.offsetName = function offsetName(ts, opts) {
        throw new $63618293c58b5f80$var$ZoneIsAbstractError();
    } /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */ ;
    _proto.formatOffset = function formatOffset(ts, format) {
        throw new $63618293c58b5f80$var$ZoneIsAbstractError();
    } /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */ ;
    _proto.offset = function offset(ts) {
        throw new $63618293c58b5f80$var$ZoneIsAbstractError();
    } /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */ ;
    _proto.equals = function equals(otherZone) {
        throw new $63618293c58b5f80$var$ZoneIsAbstractError();
    } /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */ ;
    $63618293c58b5f80$var$_createClass(Zone, [
        {
            key: "type",
            get: /**
     * The type of zone
     * @abstract
     * @type {string}
     */ function get() {
                throw new $63618293c58b5f80$var$ZoneIsAbstractError();
            }
        },
        {
            key: "name",
            get: function get() {
                throw new $63618293c58b5f80$var$ZoneIsAbstractError();
            }
        },
        {
            key: "ianaName",
            get: function get() {
                return this.name;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                throw new $63618293c58b5f80$var$ZoneIsAbstractError();
            }
        },
        {
            key: "isValid",
            get: function get() {
                throw new $63618293c58b5f80$var$ZoneIsAbstractError();
            }
        }
    ]);
    return Zone;
}();
var $63618293c58b5f80$var$singleton$1 = null;
/**
 * Represents the local zone for this JavaScript environment.
 * @implements {Zone}
 */ var $63618293c58b5f80$var$SystemZone = /*#__PURE__*/ function(_Zone) {
    $63618293c58b5f80$var$_inheritsLoose(SystemZone, _Zone);
    function SystemZone() {
        return _Zone.apply(this, arguments) || this;
    }
    var _proto = SystemZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName(ts, _ref) {
        var format = _ref.format, locale = _ref.locale;
        return $63618293c58b5f80$var$parseZoneInfo(ts, format, locale);
    } /** @override **/ ;
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $63618293c58b5f80$var$formatOffset(this.offset(ts), format);
    } /** @override **/ ;
    _proto.offset = function offset(ts) {
        return -new Date(ts).getTimezoneOffset();
    } /** @override **/ ;
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "system";
    } /** @override **/ ;
    $63618293c58b5f80$var$_createClass(SystemZone, [
        {
            key: "type",
            get: /** @override **/ function get() {
                return "system";
            }
        },
        {
            key: "name",
            get: function get() {
                return new Intl.DateTimeFormat().resolvedOptions().timeZone;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return true;
            }
        }
    ], [
        {
            key: "instance",
            get: /**
     * Get a singleton instance of the local zone
     * @return {SystemZone}
     */ function get() {
                if ($63618293c58b5f80$var$singleton$1 === null) $63618293c58b5f80$var$singleton$1 = new SystemZone();
                return $63618293c58b5f80$var$singleton$1;
            }
        }
    ]);
    return SystemZone;
}($63618293c58b5f80$var$Zone);
var $63618293c58b5f80$var$dtfCache = new Map();
function $63618293c58b5f80$var$makeDTF(zoneName) {
    var dtf = $63618293c58b5f80$var$dtfCache.get(zoneName);
    if (dtf === undefined) {
        dtf = new Intl.DateTimeFormat("en-US", {
            hour12: false,
            timeZone: zoneName,
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            era: "short"
        });
        $63618293c58b5f80$var$dtfCache.set(zoneName, dtf);
    }
    return dtf;
}
var $63618293c58b5f80$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    era: 3,
    hour: 4,
    minute: 5,
    second: 6
};
function $63618293c58b5f80$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, ""), parsed = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted), fMonth = parsed[1], fDay = parsed[2], fYear = parsed[3], fadOrBc = parsed[4], fHour = parsed[5], fMinute = parsed[6], fSecond = parsed[7];
    return [
        fYear,
        fMonth,
        fDay,
        fadOrBc,
        fHour,
        fMinute,
        fSecond
    ];
}
function $63618293c58b5f80$var$partsOffset(dtf, date) {
    var formatted = dtf.formatToParts(date);
    var filled = [];
    for(var i = 0; i < formatted.length; i++){
        var _formatted$i = formatted[i], type = _formatted$i.type, value = _formatted$i.value;
        var pos = $63618293c58b5f80$var$typeToPos[type];
        if (type === "era") filled[pos] = value;
        else if (!$63618293c58b5f80$var$isUndefined(pos)) filled[pos] = parseInt(value, 10);
    }
    return filled;
}
var $63618293c58b5f80$var$ianaZoneCache = new Map();
/**
 * A zone identified by an IANA identifier, like America/New_York
 * @implements {Zone}
 */ var $63618293c58b5f80$var$IANAZone = /*#__PURE__*/ function(_Zone) {
    $63618293c58b5f80$var$_inheritsLoose(IANAZone, _Zone);
    /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */ IANAZone.create = function create(name) {
        var zone = $63618293c58b5f80$var$ianaZoneCache.get(name);
        if (zone === undefined) $63618293c58b5f80$var$ianaZoneCache.set(name, zone = new IANAZone(name));
        return zone;
    } /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */ ;
    IANAZone.resetCache = function resetCache() {
        $63618293c58b5f80$var$ianaZoneCache.clear();
        $63618293c58b5f80$var$dtfCache.clear();
    } /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated For backward compatibility, this forwards to isValidZone, better use `isValidZone()` directly instead.
   * @return {boolean}
   */ ;
    IANAZone.isValidSpecifier = function isValidSpecifier(s) {
        return this.isValidZone(s);
    } /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */ ;
    IANAZone.isValidZone = function isValidZone(zone) {
        if (!zone) return false;
        try {
            new Intl.DateTimeFormat("en-US", {
                timeZone: zone
            }).format();
            return true;
        } catch (e) {
            return false;
        }
    };
    function IANAZone(name) {
        var _this;
        _this = _Zone.call(this) || this;
        /** @private **/ _this.zoneName = name;
        /** @private **/ _this.valid = IANAZone.isValidZone(name);
        return _this;
    }
    /**
   * The type of zone. `iana` for all instances of `IANAZone`.
   * @override
   * @type {string}
   */ var _proto = IANAZone.prototype;
    /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */ _proto.offsetName = function offsetName(ts, _ref) {
        var format = _ref.format, locale = _ref.locale;
        return $63618293c58b5f80$var$parseZoneInfo(ts, format, locale, this.name);
    } /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */ ;
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $63618293c58b5f80$var$formatOffset(this.offset(ts), format);
    } /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @override
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */ ;
    _proto.offset = function offset(ts) {
        if (!this.valid) return NaN;
        var date = new Date(ts);
        if (isNaN(date)) return NaN;
        var dtf = $63618293c58b5f80$var$makeDTF(this.name);
        var _ref2 = dtf.formatToParts ? $63618293c58b5f80$var$partsOffset(dtf, date) : $63618293c58b5f80$var$hackyOffset(dtf, date), year = _ref2[0], month = _ref2[1], day = _ref2[2], adOrBc = _ref2[3], hour = _ref2[4], minute = _ref2[5], second = _ref2[6];
        if (adOrBc === "BC") year = -Math.abs(year) + 1;
        // because we're using hour12 and https://bugs.chromium.org/p/chromium/issues/detail?id=1025564&can=2&q=%2224%3A00%22%20datetimeformat
        var adjustedHour = hour === 24 ? 0 : hour;
        var asUTC = $63618293c58b5f80$var$objToLocalTS({
            year: year,
            month: month,
            day: day,
            hour: adjustedHour,
            minute: minute,
            second: second,
            millisecond: 0
        });
        var asTS = +date;
        var over = asTS % 1000;
        asTS -= over >= 0 ? over : 1000 + over;
        return (asUTC - asTS) / 60000;
    } /**
   * Return whether this Zone is equal to another zone
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */ ;
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "iana" && otherZone.name === this.name;
    } /**
   * Return whether this Zone is valid.
   * @override
   * @type {boolean}
   */ ;
    $63618293c58b5f80$var$_createClass(IANAZone, [
        {
            key: "type",
            get: function get() {
                return "iana";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.zoneName;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.valid;
            }
        }
    ]);
    return IANAZone;
}($63618293c58b5f80$var$Zone);
var $63618293c58b5f80$var$_excluded = [
    "base"
], $63618293c58b5f80$var$_excluded2 = [
    "padTo",
    "floor"
];
// todo - remap caching
var $63618293c58b5f80$var$intlLFCache = {};
function $63618293c58b5f80$var$getCachedLF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var dtf = $63618293c58b5f80$var$intlLFCache[key];
    if (!dtf) {
        dtf = new Intl.ListFormat(locString, opts);
        $63618293c58b5f80$var$intlLFCache[key] = dtf;
    }
    return dtf;
}
var $63618293c58b5f80$var$intlDTCache = new Map();
function $63618293c58b5f80$var$getCachedDTF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var dtf = $63618293c58b5f80$var$intlDTCache.get(key);
    if (dtf === undefined) {
        dtf = new Intl.DateTimeFormat(locString, opts);
        $63618293c58b5f80$var$intlDTCache.set(key, dtf);
    }
    return dtf;
}
var $63618293c58b5f80$var$intlNumCache = new Map();
function $63618293c58b5f80$var$getCachedINF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var inf = $63618293c58b5f80$var$intlNumCache.get(key);
    if (inf === undefined) {
        inf = new Intl.NumberFormat(locString, opts);
        $63618293c58b5f80$var$intlNumCache.set(key, inf);
    }
    return inf;
}
var $63618293c58b5f80$var$intlRelCache = new Map();
function $63618293c58b5f80$var$getCachedRTF(locString, opts) {
    if (opts === void 0) opts = {};
    var _opts = opts;
    _opts.base;
    var cacheKeyOpts = $63618293c58b5f80$var$_objectWithoutPropertiesLoose(_opts, $63618293c58b5f80$var$_excluded); // exclude `base` from the options
    var key = JSON.stringify([
        locString,
        cacheKeyOpts
    ]);
    var inf = $63618293c58b5f80$var$intlRelCache.get(key);
    if (inf === undefined) {
        inf = new Intl.RelativeTimeFormat(locString, opts);
        $63618293c58b5f80$var$intlRelCache.set(key, inf);
    }
    return inf;
}
var $63618293c58b5f80$var$sysLocaleCache = null;
function $63618293c58b5f80$var$systemLocale() {
    if ($63618293c58b5f80$var$sysLocaleCache) return $63618293c58b5f80$var$sysLocaleCache;
    else {
        $63618293c58b5f80$var$sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
        return $63618293c58b5f80$var$sysLocaleCache;
    }
}
var $63618293c58b5f80$var$intlResolvedOptionsCache = new Map();
function $63618293c58b5f80$var$getCachedIntResolvedOptions(locString) {
    var opts = $63618293c58b5f80$var$intlResolvedOptionsCache.get(locString);
    if (opts === undefined) {
        opts = new Intl.DateTimeFormat(locString).resolvedOptions();
        $63618293c58b5f80$var$intlResolvedOptionsCache.set(locString, opts);
    }
    return opts;
}
var $63618293c58b5f80$var$weekInfoCache = new Map();
function $63618293c58b5f80$var$getCachedWeekInfo(locString) {
    var data = $63618293c58b5f80$var$weekInfoCache.get(locString);
    if (!data) {
        var locale = new Intl.Locale(locString);
        // browsers currently implement this as a property, but spec says it should be a getter function
        data = "getWeekInfo" in locale ? locale.getWeekInfo() : locale.weekInfo;
        // minimalDays was removed from WeekInfo: https://github.com/tc39/proposal-intl-locale-info/issues/86
        if (!("minimalDays" in data)) data = $63618293c58b5f80$var$_extends({}, $63618293c58b5f80$var$fallbackWeekSettings, data);
        $63618293c58b5f80$var$weekInfoCache.set(locString, data);
    }
    return data;
}
function $63618293c58b5f80$var$parseLocaleString(localeStr) {
    // I really want to avoid writing a BCP 47 parser
    // see, e.g. https://github.com/wooorm/bcp-47
    // Instead, we'll do this:
    // a) if the string has no -u extensions, just leave it alone
    // b) if it does, use Intl to resolve everything
    // c) if Intl fails, try again without the -u
    // private subtags and unicode subtags have ordering requirements,
    // and we're not properly parsing this, so just strip out the
    // private ones if they exist.
    var xIndex = localeStr.indexOf("-x-");
    if (xIndex !== -1) localeStr = localeStr.substring(0, xIndex);
    var uIndex = localeStr.indexOf("-u-");
    if (uIndex === -1) return [
        localeStr
    ];
    else {
        var options;
        var selectedStr;
        try {
            options = $63618293c58b5f80$var$getCachedDTF(localeStr).resolvedOptions();
            selectedStr = localeStr;
        } catch (e) {
            var smaller = localeStr.substring(0, uIndex);
            options = $63618293c58b5f80$var$getCachedDTF(smaller).resolvedOptions();
            selectedStr = smaller;
        }
        var _options = options, numberingSystem = _options.numberingSystem, calendar = _options.calendar;
        return [
            selectedStr,
            numberingSystem,
            calendar
        ];
    }
}
function $63618293c58b5f80$var$intlConfigString(localeStr, numberingSystem, outputCalendar) {
    if (outputCalendar || numberingSystem) {
        if (!localeStr.includes("-u-")) localeStr += "-u";
        if (outputCalendar) localeStr += "-ca-" + outputCalendar;
        if (numberingSystem) localeStr += "-nu-" + numberingSystem;
        return localeStr;
    } else return localeStr;
}
function $63618293c58b5f80$var$mapMonths(f) {
    var ms = [];
    for(var i = 1; i <= 12; i++){
        var dt = $63618293c58b5f80$var$DateTime.utc(2009, i, 1);
        ms.push(f(dt));
    }
    return ms;
}
function $63618293c58b5f80$var$mapWeekdays(f) {
    var ms = [];
    for(var i = 1; i <= 7; i++){
        var dt = $63618293c58b5f80$var$DateTime.utc(2016, 11, 13 + i);
        ms.push(f(dt));
    }
    return ms;
}
function $63618293c58b5f80$var$listStuff(loc, length, englishFn, intlFn) {
    var mode = loc.listingMode();
    if (mode === "error") return null;
    else if (mode === "en") return englishFn(length);
    else return intlFn(length);
}
function $63618293c58b5f80$var$supportsFastNumbers(loc) {
    if (loc.numberingSystem && loc.numberingSystem !== "latn") return false;
    else return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || $63618293c58b5f80$var$getCachedIntResolvedOptions(loc.locale).numberingSystem === "latn";
}
/**
 * @private
 */ var $63618293c58b5f80$var$PolyNumberFormatter = /*#__PURE__*/ function() {
    function PolyNumberFormatter(intl, forceSimple, opts) {
        this.padTo = opts.padTo || 0;
        this.floor = opts.floor || false;
        opts.padTo;
        opts.floor;
        var otherOpts = $63618293c58b5f80$var$_objectWithoutPropertiesLoose(opts, $63618293c58b5f80$var$_excluded2);
        if (!forceSimple || Object.keys(otherOpts).length > 0) {
            var intlOpts = $63618293c58b5f80$var$_extends({
                useGrouping: false
            }, opts);
            if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
            this.inf = $63618293c58b5f80$var$getCachedINF(intl, intlOpts);
        }
    }
    var _proto = PolyNumberFormatter.prototype;
    _proto.format = function format(i) {
        if (this.inf) {
            var fixed = this.floor ? Math.floor(i) : i;
            return this.inf.format(fixed);
        } else {
            // to match the browser's numberformatter defaults
            var _fixed = this.floor ? Math.floor(i) : $63618293c58b5f80$var$roundTo(i, 3);
            return $63618293c58b5f80$var$padStart(_fixed, this.padTo);
        }
    };
    return PolyNumberFormatter;
}();
/**
 * @private
 */ var $63618293c58b5f80$var$PolyDateFormatter = /*#__PURE__*/ function() {
    function PolyDateFormatter(dt, intl, opts) {
        this.opts = opts;
        this.originalZone = undefined;
        var z = undefined;
        if (this.opts.timeZone) // Don't apply any workarounds if a timeZone is explicitly provided in opts
        this.dt = dt;
        else if (dt.zone.type === "fixed") {
            // UTC-8 or Etc/UTC-8 are not part of tzdata, only Etc/GMT+8 and the like.
            // That is why fixed-offset TZ is set to that unless it is:
            // 1. Representing offset 0 when UTC is used to maintain previous behavior and does not become GMT.
            // 2. Unsupported by the browser:
            //    - some do not support Etc/
            //    - < Etc/GMT-14, > Etc/GMT+12, and 30-minute or 45-minute offsets are not part of tzdata
            var gmtOffset = -1 * (dt.offset / 60);
            var offsetZ = gmtOffset >= 0 ? "Etc/GMT+" + gmtOffset : "Etc/GMT" + gmtOffset;
            if (dt.offset !== 0 && $63618293c58b5f80$var$IANAZone.create(offsetZ).valid) {
                z = offsetZ;
                this.dt = dt;
            } else {
                // Not all fixed-offset zones like Etc/+4:30 are present in tzdata so
                // we manually apply the offset and substitute the zone as needed.
                z = "UTC";
                this.dt = dt.offset === 0 ? dt : dt.setZone("UTC").plus({
                    minutes: dt.offset
                });
                this.originalZone = dt.zone;
            }
        } else if (dt.zone.type === "system") this.dt = dt;
        else if (dt.zone.type === "iana") {
            this.dt = dt;
            z = dt.zone.name;
        } else {
            // Custom zones can have any offset / offsetName so we just manually
            // apply the offset and substitute the zone as needed.
            z = "UTC";
            this.dt = dt.setZone("UTC").plus({
                minutes: dt.offset
            });
            this.originalZone = dt.zone;
        }
        var intlOpts = $63618293c58b5f80$var$_extends({}, this.opts);
        intlOpts.timeZone = intlOpts.timeZone || z;
        this.dtf = $63618293c58b5f80$var$getCachedDTF(intl, intlOpts);
    }
    var _proto2 = PolyDateFormatter.prototype;
    _proto2.format = function format() {
        if (this.originalZone) // If we have to substitute in the actual zone name, we have to use
        // formatToParts so that the timezone can be replaced.
        return this.formatToParts().map(function(_ref) {
            var value = _ref.value;
            return value;
        }).join("");
        return this.dtf.format(this.dt.toJSDate());
    };
    _proto2.formatToParts = function formatToParts() {
        var _this = this;
        var parts = this.dtf.formatToParts(this.dt.toJSDate());
        if (this.originalZone) return parts.map(function(part) {
            if (part.type === "timeZoneName") {
                var offsetName = _this.originalZone.offsetName(_this.dt.ts, {
                    locale: _this.dt.locale,
                    format: _this.opts.timeZoneName
                });
                return $63618293c58b5f80$var$_extends({}, part, {
                    value: offsetName
                });
            } else return part;
        });
        return parts;
    };
    _proto2.resolvedOptions = function resolvedOptions() {
        return this.dtf.resolvedOptions();
    };
    return PolyDateFormatter;
}();
/**
 * @private
 */ var $63618293c58b5f80$var$PolyRelFormatter = /*#__PURE__*/ function() {
    function PolyRelFormatter(intl, isEnglish, opts) {
        this.opts = $63618293c58b5f80$var$_extends({
            style: "long"
        }, opts);
        if (!isEnglish && $63618293c58b5f80$var$hasRelative()) this.rtf = $63618293c58b5f80$var$getCachedRTF(intl, opts);
    }
    var _proto3 = PolyRelFormatter.prototype;
    _proto3.format = function format(count, unit) {
        if (this.rtf) return this.rtf.format(count, unit);
        else return $63618293c58b5f80$var$formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    };
    _proto3.formatToParts = function formatToParts(count, unit) {
        if (this.rtf) return this.rtf.formatToParts(count, unit);
        else return [];
    };
    return PolyRelFormatter;
}();
var $63618293c58b5f80$var$fallbackWeekSettings = {
    firstDay: 1,
    minimalDays: 4,
    weekend: [
        6,
        7
    ]
};
/**
 * @private
 */ var $63618293c58b5f80$var$Locale = /*#__PURE__*/ function() {
    Locale.fromOpts = function fromOpts(opts) {
        return Locale.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.weekSettings, opts.defaultToEN);
    };
    Locale.create = function create(locale, numberingSystem, outputCalendar, weekSettings, defaultToEN) {
        if (defaultToEN === void 0) defaultToEN = false;
        var specifiedLocale = locale || $63618293c58b5f80$var$Settings.defaultLocale;
        // the system locale is useful for human-readable strings but annoying for parsing/formatting known formats
        var localeR = specifiedLocale || (defaultToEN ? "en-US" : $63618293c58b5f80$var$systemLocale());
        var numberingSystemR = numberingSystem || $63618293c58b5f80$var$Settings.defaultNumberingSystem;
        var outputCalendarR = outputCalendar || $63618293c58b5f80$var$Settings.defaultOutputCalendar;
        var weekSettingsR = $63618293c58b5f80$var$validateWeekSettings(weekSettings) || $63618293c58b5f80$var$Settings.defaultWeekSettings;
        return new Locale(localeR, numberingSystemR, outputCalendarR, weekSettingsR, specifiedLocale);
    };
    Locale.resetCache = function resetCache() {
        $63618293c58b5f80$var$sysLocaleCache = null;
        $63618293c58b5f80$var$intlDTCache.clear();
        $63618293c58b5f80$var$intlNumCache.clear();
        $63618293c58b5f80$var$intlRelCache.clear();
        $63618293c58b5f80$var$intlResolvedOptionsCache.clear();
        $63618293c58b5f80$var$weekInfoCache.clear();
    };
    Locale.fromObject = function fromObject(_temp) {
        var _ref2 = _temp === void 0 ? {} : _temp, locale = _ref2.locale, numberingSystem = _ref2.numberingSystem, outputCalendar = _ref2.outputCalendar, weekSettings = _ref2.weekSettings;
        return Locale.create(locale, numberingSystem, outputCalendar, weekSettings);
    };
    function Locale(locale, numbering, outputCalendar, weekSettings, specifiedLocale) {
        var _parseLocaleString = $63618293c58b5f80$var$parseLocaleString(locale), parsedLocale = _parseLocaleString[0], parsedNumberingSystem = _parseLocaleString[1], parsedOutputCalendar = _parseLocaleString[2];
        this.locale = parsedLocale;
        this.numberingSystem = numbering || parsedNumberingSystem || null;
        this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
        this.weekSettings = weekSettings;
        this.intl = $63618293c58b5f80$var$intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
        this.weekdaysCache = {
            format: {},
            standalone: {}
        };
        this.monthsCache = {
            format: {},
            standalone: {}
        };
        this.meridiemCache = null;
        this.eraCache = {};
        this.specifiedLocale = specifiedLocale;
        this.fastNumbersCached = null;
    }
    var _proto4 = Locale.prototype;
    _proto4.listingMode = function listingMode() {
        var isActuallyEn = this.isEnglish();
        var hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
        return isActuallyEn && hasNoWeirdness ? "en" : "intl";
    };
    _proto4.clone = function clone(alts) {
        if (!alts || Object.getOwnPropertyNames(alts).length === 0) return this;
        else return Locale.create(alts.locale || this.specifiedLocale, alts.numberingSystem || this.numberingSystem, alts.outputCalendar || this.outputCalendar, $63618293c58b5f80$var$validateWeekSettings(alts.weekSettings) || this.weekSettings, alts.defaultToEN || false);
    };
    _proto4.redefaultToEN = function redefaultToEN(alts) {
        if (alts === void 0) alts = {};
        return this.clone($63618293c58b5f80$var$_extends({}, alts, {
            defaultToEN: true
        }));
    };
    _proto4.redefaultToSystem = function redefaultToSystem(alts) {
        if (alts === void 0) alts = {};
        return this.clone($63618293c58b5f80$var$_extends({}, alts, {
            defaultToEN: false
        }));
    };
    _proto4.months = function months$1(length, format) {
        var _this2 = this;
        if (format === void 0) format = false;
        return $63618293c58b5f80$var$listStuff(this, length, $63618293c58b5f80$var$months, function() {
            // Workaround for "ja" locale: formatToParts does not label all parts of the month
            // as "month" and for this locale there is no difference between "format" and "non-format".
            // As such, just use format() instead of formatToParts() and take the whole string
            var monthSpecialCase = _this2.intl === "ja" || _this2.intl.startsWith("ja-");
            format &= !monthSpecialCase;
            var intl = format ? {
                month: length,
                day: "numeric"
            } : {
                month: length
            }, formatStr = format ? "format" : "standalone";
            if (!_this2.monthsCache[formatStr][length]) {
                var mapper = !monthSpecialCase ? function(dt) {
                    return _this2.extract(dt, intl, "month");
                } : function(dt) {
                    return _this2.dtFormatter(dt, intl).format();
                };
                _this2.monthsCache[formatStr][length] = $63618293c58b5f80$var$mapMonths(mapper);
            }
            return _this2.monthsCache[formatStr][length];
        });
    };
    _proto4.weekdays = function weekdays$1(length, format) {
        var _this3 = this;
        if (format === void 0) format = false;
        return $63618293c58b5f80$var$listStuff(this, length, $63618293c58b5f80$var$weekdays, function() {
            var intl = format ? {
                weekday: length,
                year: "numeric",
                month: "long",
                day: "numeric"
            } : {
                weekday: length
            }, formatStr = format ? "format" : "standalone";
            if (!_this3.weekdaysCache[formatStr][length]) _this3.weekdaysCache[formatStr][length] = $63618293c58b5f80$var$mapWeekdays(function(dt) {
                return _this3.extract(dt, intl, "weekday");
            });
            return _this3.weekdaysCache[formatStr][length];
        });
    };
    _proto4.meridiems = function meridiems$1() {
        var _this4 = this;
        return $63618293c58b5f80$var$listStuff(this, undefined, function() {
            return $63618293c58b5f80$var$meridiems;
        }, function() {
            // In theory there could be aribitrary day periods. We're gonna assume there are exactly two
            // for AM and PM. This is probably wrong, but it's makes parsing way easier.
            if (!_this4.meridiemCache) {
                var intl = {
                    hour: "numeric",
                    hourCycle: "h12"
                };
                _this4.meridiemCache = [
                    $63618293c58b5f80$var$DateTime.utc(2016, 11, 13, 9),
                    $63618293c58b5f80$var$DateTime.utc(2016, 11, 13, 19)
                ].map(function(dt) {
                    return _this4.extract(dt, intl, "dayperiod");
                });
            }
            return _this4.meridiemCache;
        });
    };
    _proto4.eras = function eras$1(length) {
        var _this5 = this;
        return $63618293c58b5f80$var$listStuff(this, length, $63618293c58b5f80$var$eras, function() {
            var intl = {
                era: length
            };
            // This is problematic. Different calendars are going to define eras totally differently. What I need is the minimum set of dates
            // to definitely enumerate them.
            if (!_this5.eraCache[length]) _this5.eraCache[length] = [
                $63618293c58b5f80$var$DateTime.utc(-40, 1, 1),
                $63618293c58b5f80$var$DateTime.utc(2017, 1, 1)
            ].map(function(dt) {
                return _this5.extract(dt, intl, "era");
            });
            return _this5.eraCache[length];
        });
    };
    _proto4.extract = function extract(dt, intlOpts, field) {
        var df = this.dtFormatter(dt, intlOpts), results = df.formatToParts(), matching = results.find(function(m) {
            return m.type.toLowerCase() === field;
        });
        return matching ? matching.value : null;
    };
    _proto4.numberFormatter = function numberFormatter(opts) {
        if (opts === void 0) opts = {};
        // this forcesimple option is never used (the only caller short-circuits on it, but it seems safer to leave)
        // (in contrast, the rest of the condition is used heavily)
        return new $63618293c58b5f80$var$PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
    };
    _proto4.dtFormatter = function dtFormatter(dt, intlOpts) {
        if (intlOpts === void 0) intlOpts = {};
        return new $63618293c58b5f80$var$PolyDateFormatter(dt, this.intl, intlOpts);
    };
    _proto4.relFormatter = function relFormatter(opts) {
        if (opts === void 0) opts = {};
        return new $63618293c58b5f80$var$PolyRelFormatter(this.intl, this.isEnglish(), opts);
    };
    _proto4.listFormatter = function listFormatter(opts) {
        if (opts === void 0) opts = {};
        return $63618293c58b5f80$var$getCachedLF(this.intl, opts);
    };
    _proto4.isEnglish = function isEnglish() {
        return this.locale === "en" || this.locale.toLowerCase() === "en-us" || $63618293c58b5f80$var$getCachedIntResolvedOptions(this.intl).locale.startsWith("en-us");
    };
    _proto4.getWeekSettings = function getWeekSettings() {
        if (this.weekSettings) return this.weekSettings;
        else if (!$63618293c58b5f80$var$hasLocaleWeekInfo()) return $63618293c58b5f80$var$fallbackWeekSettings;
        else return $63618293c58b5f80$var$getCachedWeekInfo(this.locale);
    };
    _proto4.getStartOfWeek = function getStartOfWeek() {
        return this.getWeekSettings().firstDay;
    };
    _proto4.getMinDaysInFirstWeek = function getMinDaysInFirstWeek() {
        return this.getWeekSettings().minimalDays;
    };
    _proto4.getWeekendDays = function getWeekendDays() {
        return this.getWeekSettings().weekend;
    };
    _proto4.equals = function equals(other) {
        return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
    };
    _proto4.toString = function toString() {
        return "Locale(" + this.locale + ", " + this.numberingSystem + ", " + this.outputCalendar + ")";
    };
    $63618293c58b5f80$var$_createClass(Locale, [
        {
            key: "fastNumbers",
            get: function get() {
                if (this.fastNumbersCached == null) this.fastNumbersCached = $63618293c58b5f80$var$supportsFastNumbers(this);
                return this.fastNumbersCached;
            }
        }
    ]);
    return Locale;
}();
var $63618293c58b5f80$var$singleton = null;
/**
 * A zone with a fixed offset (meaning no DST)
 * @implements {Zone}
 */ var $63618293c58b5f80$var$FixedOffsetZone = /*#__PURE__*/ function(_Zone) {
    $63618293c58b5f80$var$_inheritsLoose(FixedOffsetZone, _Zone);
    /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */ FixedOffsetZone.instance = function instance(offset) {
        return offset === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset);
    } /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */ ;
    FixedOffsetZone.parseSpecifier = function parseSpecifier(s) {
        if (s) {
            var r = s.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
            if (r) return new FixedOffsetZone($63618293c58b5f80$var$signedOffset(r[1], r[2]));
        }
        return null;
    };
    function FixedOffsetZone(offset) {
        var _this;
        _this = _Zone.call(this) || this;
        /** @private **/ _this.fixed = offset;
        return _this;
    }
    /**
   * The type of zone. `fixed` for all instances of `FixedOffsetZone`.
   * @override
   * @type {string}
   */ var _proto = FixedOffsetZone.prototype;
    /**
   * Returns the offset's common name at the specified timestamp.
   *
   * For fixed offset zones this equals to the zone name.
   * @override
   */ _proto.offsetName = function offsetName() {
        return this.name;
    } /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */ ;
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $63618293c58b5f80$var$formatOffset(this.fixed, format);
    } /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns true for all fixed offset zones.
   * @override
   * @type {boolean}
   */ ;
    /**
   * Return the offset in minutes for this zone at the specified timestamp.
   *
   * For fixed offset zones, this is constant and does not depend on a timestamp.
   * @override
   * @return {number}
   */ _proto.offset = function offset() {
        return this.fixed;
    } /**
   * Return whether this Zone is equal to another zone (i.e. also fixed and same offset)
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */ ;
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
    } /**
   * Return whether this Zone is valid:
   * All fixed offset zones are valid.
   * @override
   * @type {boolean}
   */ ;
    $63618293c58b5f80$var$_createClass(FixedOffsetZone, [
        {
            key: "type",
            get: function get() {
                return "fixed";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.fixed === 0 ? "UTC" : "UTC" + $63618293c58b5f80$var$formatOffset(this.fixed, "narrow");
            }
        },
        {
            key: "ianaName",
            get: function get() {
                if (this.fixed === 0) return "Etc/UTC";
                else return "Etc/GMT" + $63618293c58b5f80$var$formatOffset(-this.fixed, "narrow");
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return true;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return true;
            }
        }
    ], [
        {
            key: "utcInstance",
            get: /**
     * Get a singleton instance of UTC
     * @return {FixedOffsetZone}
     */ function get() {
                if ($63618293c58b5f80$var$singleton === null) $63618293c58b5f80$var$singleton = new FixedOffsetZone(0);
                return $63618293c58b5f80$var$singleton;
            }
        }
    ]);
    return FixedOffsetZone;
}($63618293c58b5f80$var$Zone);
/**
 * A zone that failed to parse. You should never need to instantiate this.
 * @implements {Zone}
 */ var $63618293c58b5f80$var$InvalidZone = /*#__PURE__*/ function(_Zone) {
    $63618293c58b5f80$var$_inheritsLoose(InvalidZone, _Zone);
    function InvalidZone(zoneName) {
        var _this;
        _this = _Zone.call(this) || this;
        /**  @private */ _this.zoneName = zoneName;
        return _this;
    }
    /** @override **/ var _proto = InvalidZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName() {
        return null;
    } /** @override **/ ;
    _proto.formatOffset = function formatOffset() {
        return "";
    } /** @override **/ ;
    _proto.offset = function offset() {
        return NaN;
    } /** @override **/ ;
    _proto.equals = function equals() {
        return false;
    } /** @override **/ ;
    $63618293c58b5f80$var$_createClass(InvalidZone, [
        {
            key: "type",
            get: function get() {
                return "invalid";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.zoneName;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return false;
            }
        }
    ]);
    return InvalidZone;
}($63618293c58b5f80$var$Zone);
/**
 * @private
 */ function $63618293c58b5f80$var$normalizeZone(input, defaultZone) {
    if ($63618293c58b5f80$var$isUndefined(input) || input === null) return defaultZone;
    else if (input instanceof $63618293c58b5f80$var$Zone) return input;
    else if ($63618293c58b5f80$var$isString(input)) {
        var lowered = input.toLowerCase();
        if (lowered === "default") return defaultZone;
        else if (lowered === "local" || lowered === "system") return $63618293c58b5f80$var$SystemZone.instance;
        else if (lowered === "utc" || lowered === "gmt") return $63618293c58b5f80$var$FixedOffsetZone.utcInstance;
        else return $63618293c58b5f80$var$FixedOffsetZone.parseSpecifier(lowered) || $63618293c58b5f80$var$IANAZone.create(input);
    } else if ($63618293c58b5f80$var$isNumber(input)) return $63618293c58b5f80$var$FixedOffsetZone.instance(input);
    else if (typeof input === "object" && "offset" in input && typeof input.offset === "function") // This is dumb, but the instanceof check above doesn't seem to really work
    // so we're duck checking it
    return input;
    else return new $63618293c58b5f80$var$InvalidZone(input);
}
var $63618293c58b5f80$var$numberingSystems = {
    arab: "[\u0660-\u0669]",
    arabext: "[\u06F0-\u06F9]",
    bali: "[\u1B50-\u1B59]",
    beng: "[\u09E6-\u09EF]",
    deva: "[\u0966-\u096F]",
    fullwide: "[\uFF10-\uFF19]",
    gujr: "[\u0AE6-\u0AEF]",
    hanidec: "[\u3007|\u4E00|\u4E8C|\u4E09|\u56DB|\u4E94|\u516D|\u4E03|\u516B|\u4E5D]",
    khmr: "[\u17E0-\u17E9]",
    knda: "[\u0CE6-\u0CEF]",
    laoo: "[\u0ED0-\u0ED9]",
    limb: "[\u1946-\u194F]",
    mlym: "[\u0D66-\u0D6F]",
    mong: "[\u1810-\u1819]",
    mymr: "[\u1040-\u1049]",
    orya: "[\u0B66-\u0B6F]",
    tamldec: "[\u0BE6-\u0BEF]",
    telu: "[\u0C66-\u0C6F]",
    thai: "[\u0E50-\u0E59]",
    tibt: "[\u0F20-\u0F29]",
    latn: "\\d"
};
var $63618293c58b5f80$var$numberingSystemsUTF16 = {
    arab: [
        1632,
        1641
    ],
    arabext: [
        1776,
        1785
    ],
    bali: [
        6992,
        7001
    ],
    beng: [
        2534,
        2543
    ],
    deva: [
        2406,
        2415
    ],
    fullwide: [
        65296,
        65303
    ],
    gujr: [
        2790,
        2799
    ],
    khmr: [
        6112,
        6121
    ],
    knda: [
        3302,
        3311
    ],
    laoo: [
        3792,
        3801
    ],
    limb: [
        6470,
        6479
    ],
    mlym: [
        3430,
        3439
    ],
    mong: [
        6160,
        6169
    ],
    mymr: [
        4160,
        4169
    ],
    orya: [
        2918,
        2927
    ],
    tamldec: [
        3046,
        3055
    ],
    telu: [
        3174,
        3183
    ],
    thai: [
        3664,
        3673
    ],
    tibt: [
        3872,
        3881
    ]
};
var $63618293c58b5f80$var$hanidecChars = $63618293c58b5f80$var$numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function $63618293c58b5f80$var$parseDigits(str) {
    var value = parseInt(str, 10);
    if (isNaN(value)) {
        value = "";
        for(var i = 0; i < str.length; i++){
            var code = str.charCodeAt(i);
            if (str[i].search($63618293c58b5f80$var$numberingSystems.hanidec) !== -1) value += $63618293c58b5f80$var$hanidecChars.indexOf(str[i]);
            else for(var key in $63618293c58b5f80$var$numberingSystemsUTF16){
                var _numberingSystemsUTF = $63618293c58b5f80$var$numberingSystemsUTF16[key], min = _numberingSystemsUTF[0], max = _numberingSystemsUTF[1];
                if (code >= min && code <= max) value += code - min;
            }
        }
        return parseInt(value, 10);
    } else return value;
}
// cache of {numberingSystem: {append: regex}}
var $63618293c58b5f80$var$digitRegexCache = new Map();
function $63618293c58b5f80$var$resetDigitRegexCache() {
    $63618293c58b5f80$var$digitRegexCache.clear();
}
function $63618293c58b5f80$var$digitRegex(_ref, append) {
    var numberingSystem = _ref.numberingSystem;
    if (append === void 0) append = "";
    var ns = numberingSystem || "latn";
    var appendCache = $63618293c58b5f80$var$digitRegexCache.get(ns);
    if (appendCache === undefined) {
        appendCache = new Map();
        $63618293c58b5f80$var$digitRegexCache.set(ns, appendCache);
    }
    var regex = appendCache.get(append);
    if (regex === undefined) {
        regex = new RegExp("" + $63618293c58b5f80$var$numberingSystems[ns] + append);
        appendCache.set(append, regex);
    }
    return regex;
}
var $63618293c58b5f80$var$now = function now() {
    return Date.now();
}, $63618293c58b5f80$var$defaultZone = "system", $63618293c58b5f80$var$defaultLocale = null, $63618293c58b5f80$var$defaultNumberingSystem = null, $63618293c58b5f80$var$defaultOutputCalendar = null, $63618293c58b5f80$var$twoDigitCutoffYear = 60, $63618293c58b5f80$var$throwOnInvalid, $63618293c58b5f80$var$defaultWeekSettings = null;
/**
 * Settings contains static getters and setters that control Luxon's overall behavior. Luxon is a simple library with few options, but the ones it does have live here.
 */ var $63618293c58b5f80$var$Settings = /*#__PURE__*/ function() {
    function Settings() {}
    /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */ Settings.resetCaches = function resetCaches() {
        $63618293c58b5f80$var$Locale.resetCache();
        $63618293c58b5f80$var$IANAZone.resetCache();
        $63618293c58b5f80$var$DateTime.resetCache();
        $63618293c58b5f80$var$resetDigitRegexCache();
    };
    $63618293c58b5f80$var$_createClass(Settings, null, [
        {
            key: "now",
            get: /**
     * Get the callback for returning the current timestamp.
     * @type {function}
     */ function get() {
                return $63618293c58b5f80$var$now;
            },
            set: function set(n) {
                $63618293c58b5f80$var$now = n;
            }
        },
        {
            key: "defaultZone",
            get: /**
     * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
     * The default value is the system's time zone (the one set on the machine that runs this code).
     * @type {Zone}
     */ function get() {
                return $63618293c58b5f80$var$normalizeZone($63618293c58b5f80$var$defaultZone, $63618293c58b5f80$var$SystemZone.instance);
            },
            set: function set(zone) {
                $63618293c58b5f80$var$defaultZone = zone;
            }
        },
        {
            key: "defaultLocale",
            get: function get() {
                return $63618293c58b5f80$var$defaultLocale;
            },
            set: function set(locale) {
                $63618293c58b5f80$var$defaultLocale = locale;
            }
        },
        {
            key: "defaultNumberingSystem",
            get: function get() {
                return $63618293c58b5f80$var$defaultNumberingSystem;
            },
            set: function set(numberingSystem) {
                $63618293c58b5f80$var$defaultNumberingSystem = numberingSystem;
            }
        },
        {
            key: "defaultOutputCalendar",
            get: function get() {
                return $63618293c58b5f80$var$defaultOutputCalendar;
            },
            set: function set(outputCalendar) {
                $63618293c58b5f80$var$defaultOutputCalendar = outputCalendar;
            }
        },
        {
            key: "defaultWeekSettings",
            get: function get() {
                return $63618293c58b5f80$var$defaultWeekSettings;
            },
            set: function set(weekSettings) {
                $63618293c58b5f80$var$defaultWeekSettings = $63618293c58b5f80$var$validateWeekSettings(weekSettings);
            }
        },
        {
            key: "twoDigitCutoffYear",
            get: function get() {
                return $63618293c58b5f80$var$twoDigitCutoffYear;
            },
            set: function set(cutoffYear) {
                $63618293c58b5f80$var$twoDigitCutoffYear = cutoffYear % 100;
            }
        },
        {
            key: "throwOnInvalid",
            get: function get() {
                return $63618293c58b5f80$var$throwOnInvalid;
            },
            set: function set(t) {
                $63618293c58b5f80$var$throwOnInvalid = t;
            }
        }
    ]);
    return Settings;
}();
var $63618293c58b5f80$var$Invalid = /*#__PURE__*/ function() {
    function Invalid(reason, explanation) {
        this.reason = reason;
        this.explanation = explanation;
    }
    var _proto = Invalid.prototype;
    _proto.toMessage = function toMessage() {
        if (this.explanation) return this.reason + ": " + this.explanation;
        else return this.reason;
    };
    return Invalid;
}();
var $63618293c58b5f80$var$nonLeapLadder = [
    0,
    31,
    59,
    90,
    120,
    151,
    181,
    212,
    243,
    273,
    304,
    334
], $63618293c58b5f80$var$leapLadder = [
    0,
    31,
    60,
    91,
    121,
    152,
    182,
    213,
    244,
    274,
    305,
    335
];
function $63618293c58b5f80$var$unitOutOfRange(unit, value) {
    return new $63618293c58b5f80$var$Invalid("unit out of range", "you specified " + value + " (of type " + typeof value + ") as a " + unit + ", which is invalid");
}
function $63618293c58b5f80$var$dayOfWeek(year, month, day) {
    var d = new Date(Date.UTC(year, month - 1, day));
    if (year < 100 && year >= 0) d.setUTCFullYear(d.getUTCFullYear() - 1900);
    var js = d.getUTCDay();
    return js === 0 ? 7 : js;
}
function $63618293c58b5f80$var$computeOrdinal(year, month, day) {
    return day + ($63618293c58b5f80$var$isLeapYear(year) ? $63618293c58b5f80$var$leapLadder : $63618293c58b5f80$var$nonLeapLadder)[month - 1];
}
function $63618293c58b5f80$var$uncomputeOrdinal(year, ordinal) {
    var table = $63618293c58b5f80$var$isLeapYear(year) ? $63618293c58b5f80$var$leapLadder : $63618293c58b5f80$var$nonLeapLadder, month0 = table.findIndex(function(i) {
        return i < ordinal;
    }), day = ordinal - table[month0];
    return {
        month: month0 + 1,
        day: day
    };
}
function $63618293c58b5f80$var$isoWeekdayToLocal(isoWeekday, startOfWeek) {
    return (isoWeekday - startOfWeek + 7) % 7 + 1;
}
/**
 * @private
 */ function $63618293c58b5f80$var$gregorianToWeek(gregObj, minDaysInFirstWeek, startOfWeek) {
    if (minDaysInFirstWeek === void 0) minDaysInFirstWeek = 4;
    if (startOfWeek === void 0) startOfWeek = 1;
    var year = gregObj.year, month = gregObj.month, day = gregObj.day, ordinal = $63618293c58b5f80$var$computeOrdinal(year, month, day), weekday = $63618293c58b5f80$var$isoWeekdayToLocal($63618293c58b5f80$var$dayOfWeek(year, month, day), startOfWeek);
    var weekNumber = Math.floor((ordinal - weekday + 14 - minDaysInFirstWeek) / 7), weekYear;
    if (weekNumber < 1) {
        weekYear = year - 1;
        weekNumber = $63618293c58b5f80$var$weeksInWeekYear(weekYear, minDaysInFirstWeek, startOfWeek);
    } else if (weekNumber > $63618293c58b5f80$var$weeksInWeekYear(year, minDaysInFirstWeek, startOfWeek)) {
        weekYear = year + 1;
        weekNumber = 1;
    } else weekYear = year;
    return $63618293c58b5f80$var$_extends({
        weekYear: weekYear,
        weekNumber: weekNumber,
        weekday: weekday
    }, $63618293c58b5f80$var$timeObject(gregObj));
}
function $63618293c58b5f80$var$weekToGregorian(weekData, minDaysInFirstWeek, startOfWeek) {
    if (minDaysInFirstWeek === void 0) minDaysInFirstWeek = 4;
    if (startOfWeek === void 0) startOfWeek = 1;
    var weekYear = weekData.weekYear, weekNumber = weekData.weekNumber, weekday = weekData.weekday, weekdayOfJan4 = $63618293c58b5f80$var$isoWeekdayToLocal($63618293c58b5f80$var$dayOfWeek(weekYear, 1, minDaysInFirstWeek), startOfWeek), yearInDays = $63618293c58b5f80$var$daysInYear(weekYear);
    var ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 7 + minDaysInFirstWeek, year;
    if (ordinal < 1) {
        year = weekYear - 1;
        ordinal += $63618293c58b5f80$var$daysInYear(year);
    } else if (ordinal > yearInDays) {
        year = weekYear + 1;
        ordinal -= $63618293c58b5f80$var$daysInYear(weekYear);
    } else year = weekYear;
    var _uncomputeOrdinal = $63618293c58b5f80$var$uncomputeOrdinal(year, ordinal), month = _uncomputeOrdinal.month, day = _uncomputeOrdinal.day;
    return $63618293c58b5f80$var$_extends({
        year: year,
        month: month,
        day: day
    }, $63618293c58b5f80$var$timeObject(weekData));
}
function $63618293c58b5f80$var$gregorianToOrdinal(gregData) {
    var year = gregData.year, month = gregData.month, day = gregData.day;
    var ordinal = $63618293c58b5f80$var$computeOrdinal(year, month, day);
    return $63618293c58b5f80$var$_extends({
        year: year,
        ordinal: ordinal
    }, $63618293c58b5f80$var$timeObject(gregData));
}
function $63618293c58b5f80$var$ordinalToGregorian(ordinalData) {
    var year = ordinalData.year, ordinal = ordinalData.ordinal;
    var _uncomputeOrdinal2 = $63618293c58b5f80$var$uncomputeOrdinal(year, ordinal), month = _uncomputeOrdinal2.month, day = _uncomputeOrdinal2.day;
    return $63618293c58b5f80$var$_extends({
        year: year,
        month: month,
        day: day
    }, $63618293c58b5f80$var$timeObject(ordinalData));
}
/**
 * Check if local week units like localWeekday are used in obj.
 * If so, validates that they are not mixed with ISO week units and then copies them to the normal week unit properties.
 * Modifies obj in-place!
 * @param obj the object values
 */ function $63618293c58b5f80$var$usesLocalWeekValues(obj, loc) {
    var hasLocaleWeekData = !$63618293c58b5f80$var$isUndefined(obj.localWeekday) || !$63618293c58b5f80$var$isUndefined(obj.localWeekNumber) || !$63618293c58b5f80$var$isUndefined(obj.localWeekYear);
    if (hasLocaleWeekData) {
        var hasIsoWeekData = !$63618293c58b5f80$var$isUndefined(obj.weekday) || !$63618293c58b5f80$var$isUndefined(obj.weekNumber) || !$63618293c58b5f80$var$isUndefined(obj.weekYear);
        if (hasIsoWeekData) throw new $63618293c58b5f80$var$ConflictingSpecificationError("Cannot mix locale-based week fields with ISO-based week fields");
        if (!$63618293c58b5f80$var$isUndefined(obj.localWeekday)) obj.weekday = obj.localWeekday;
        if (!$63618293c58b5f80$var$isUndefined(obj.localWeekNumber)) obj.weekNumber = obj.localWeekNumber;
        if (!$63618293c58b5f80$var$isUndefined(obj.localWeekYear)) obj.weekYear = obj.localWeekYear;
        delete obj.localWeekday;
        delete obj.localWeekNumber;
        delete obj.localWeekYear;
        return {
            minDaysInFirstWeek: loc.getMinDaysInFirstWeek(),
            startOfWeek: loc.getStartOfWeek()
        };
    } else return {
        minDaysInFirstWeek: 4,
        startOfWeek: 1
    };
}
function $63618293c58b5f80$var$hasInvalidWeekData(obj, minDaysInFirstWeek, startOfWeek) {
    if (minDaysInFirstWeek === void 0) minDaysInFirstWeek = 4;
    if (startOfWeek === void 0) startOfWeek = 1;
    var validYear = $63618293c58b5f80$var$isInteger(obj.weekYear), validWeek = $63618293c58b5f80$var$integerBetween(obj.weekNumber, 1, $63618293c58b5f80$var$weeksInWeekYear(obj.weekYear, minDaysInFirstWeek, startOfWeek)), validWeekday = $63618293c58b5f80$var$integerBetween(obj.weekday, 1, 7);
    if (!validYear) return $63618293c58b5f80$var$unitOutOfRange("weekYear", obj.weekYear);
    else if (!validWeek) return $63618293c58b5f80$var$unitOutOfRange("week", obj.weekNumber);
    else if (!validWeekday) return $63618293c58b5f80$var$unitOutOfRange("weekday", obj.weekday);
    else return false;
}
function $63618293c58b5f80$var$hasInvalidOrdinalData(obj) {
    var validYear = $63618293c58b5f80$var$isInteger(obj.year), validOrdinal = $63618293c58b5f80$var$integerBetween(obj.ordinal, 1, $63618293c58b5f80$var$daysInYear(obj.year));
    if (!validYear) return $63618293c58b5f80$var$unitOutOfRange("year", obj.year);
    else if (!validOrdinal) return $63618293c58b5f80$var$unitOutOfRange("ordinal", obj.ordinal);
    else return false;
}
function $63618293c58b5f80$var$hasInvalidGregorianData(obj) {
    var validYear = $63618293c58b5f80$var$isInteger(obj.year), validMonth = $63618293c58b5f80$var$integerBetween(obj.month, 1, 12), validDay = $63618293c58b5f80$var$integerBetween(obj.day, 1, $63618293c58b5f80$var$daysInMonth(obj.year, obj.month));
    if (!validYear) return $63618293c58b5f80$var$unitOutOfRange("year", obj.year);
    else if (!validMonth) return $63618293c58b5f80$var$unitOutOfRange("month", obj.month);
    else if (!validDay) return $63618293c58b5f80$var$unitOutOfRange("day", obj.day);
    else return false;
}
function $63618293c58b5f80$var$hasInvalidTimeData(obj) {
    var hour = obj.hour, minute = obj.minute, second = obj.second, millisecond = obj.millisecond;
    var validHour = $63618293c58b5f80$var$integerBetween(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0, validMinute = $63618293c58b5f80$var$integerBetween(minute, 0, 59), validSecond = $63618293c58b5f80$var$integerBetween(second, 0, 59), validMillisecond = $63618293c58b5f80$var$integerBetween(millisecond, 0, 999);
    if (!validHour) return $63618293c58b5f80$var$unitOutOfRange("hour", hour);
    else if (!validMinute) return $63618293c58b5f80$var$unitOutOfRange("minute", minute);
    else if (!validSecond) return $63618293c58b5f80$var$unitOutOfRange("second", second);
    else if (!validMillisecond) return $63618293c58b5f80$var$unitOutOfRange("millisecond", millisecond);
    else return false;
}
/**
 * @private
 */ // TYPES
function $63618293c58b5f80$var$isUndefined(o) {
    return typeof o === "undefined";
}
function $63618293c58b5f80$var$isNumber(o) {
    return typeof o === "number";
}
function $63618293c58b5f80$var$isInteger(o) {
    return typeof o === "number" && o % 1 === 0;
}
function $63618293c58b5f80$var$isString(o) {
    return typeof o === "string";
}
function $63618293c58b5f80$var$isDate(o) {
    return Object.prototype.toString.call(o) === "[object Date]";
}
// CAPABILITIES
function $63618293c58b5f80$var$hasRelative() {
    try {
        return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
    } catch (e) {
        return false;
    }
}
function $63618293c58b5f80$var$hasLocaleWeekInfo() {
    try {
        return typeof Intl !== "undefined" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
    } catch (e) {
        return false;
    }
}
// OBJECTS AND ARRAYS
function $63618293c58b5f80$var$maybeArray(thing) {
    return Array.isArray(thing) ? thing : [
        thing
    ];
}
function $63618293c58b5f80$var$bestBy(arr, by, compare) {
    if (arr.length === 0) return undefined;
    return arr.reduce(function(best, next) {
        var pair = [
            by(next),
            next
        ];
        if (!best) return pair;
        else if (compare(best[0], pair[0]) === best[0]) return best;
        else return pair;
    }, null)[1];
}
function $63618293c58b5f80$var$pick(obj, keys) {
    return keys.reduce(function(a, k) {
        a[k] = obj[k];
        return a;
    }, {});
}
function $63618293c58b5f80$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
function $63618293c58b5f80$var$validateWeekSettings(settings) {
    if (settings == null) return null;
    else if (typeof settings !== "object") throw new $63618293c58b5f80$var$InvalidArgumentError("Week settings must be an object");
    else {
        if (!$63618293c58b5f80$var$integerBetween(settings.firstDay, 1, 7) || !$63618293c58b5f80$var$integerBetween(settings.minimalDays, 1, 7) || !Array.isArray(settings.weekend) || settings.weekend.some(function(v) {
            return !$63618293c58b5f80$var$integerBetween(v, 1, 7);
        })) throw new $63618293c58b5f80$var$InvalidArgumentError("Invalid week settings");
        return {
            firstDay: settings.firstDay,
            minimalDays: settings.minimalDays,
            weekend: Array.from(settings.weekend)
        };
    }
}
// NUMBERS AND STRINGS
function $63618293c58b5f80$var$integerBetween(thing, bottom, top) {
    return $63618293c58b5f80$var$isInteger(thing) && thing >= bottom && thing <= top;
}
// x % n but takes the sign of n instead of x
function $63618293c58b5f80$var$floorMod(x, n) {
    return x - n * Math.floor(x / n);
}
function $63618293c58b5f80$var$padStart(input, n) {
    if (n === void 0) n = 2;
    var isNeg = input < 0;
    var padded;
    if (isNeg) padded = "-" + ("" + -input).padStart(n, "0");
    else padded = ("" + input).padStart(n, "0");
    return padded;
}
function $63618293c58b5f80$var$parseInteger(string) {
    if ($63618293c58b5f80$var$isUndefined(string) || string === null || string === "") return undefined;
    else return parseInt(string, 10);
}
function $63618293c58b5f80$var$parseFloating(string) {
    if ($63618293c58b5f80$var$isUndefined(string) || string === null || string === "") return undefined;
    else return parseFloat(string);
}
function $63618293c58b5f80$var$parseMillis(fraction) {
    // Return undefined (instead of 0) in these cases, where fraction is not set
    if ($63618293c58b5f80$var$isUndefined(fraction) || fraction === null || fraction === "") return undefined;
    else {
        var f = parseFloat("0." + fraction) * 1000;
        return Math.floor(f);
    }
}
function $63618293c58b5f80$var$roundTo(number, digits, rounding) {
    if (rounding === void 0) rounding = "round";
    var factor = Math.pow(10, digits);
    switch(rounding){
        case "expand":
            return number > 0 ? Math.ceil(number * factor) / factor : Math.floor(number * factor) / factor;
        case "trunc":
            return Math.trunc(number * factor) / factor;
        case "round":
            return Math.round(number * factor) / factor;
        case "floor":
            return Math.floor(number * factor) / factor;
        case "ceil":
            return Math.ceil(number * factor) / factor;
        default:
            throw new RangeError("Value rounding " + rounding + " is out of range");
    }
}
// DATE BASICS
function $63618293c58b5f80$var$isLeapYear(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function $63618293c58b5f80$var$daysInYear(year) {
    return $63618293c58b5f80$var$isLeapYear(year) ? 366 : 365;
}
function $63618293c58b5f80$var$daysInMonth(year, month) {
    var modMonth = $63618293c58b5f80$var$floorMod(month - 1, 12) + 1, modYear = year + (month - modMonth) / 12;
    if (modMonth === 2) return $63618293c58b5f80$var$isLeapYear(modYear) ? 29 : 28;
    else return [
        31,
        null,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][modMonth - 1];
}
// convert a calendar object to a local timestamp (epoch, but with the offset baked in)
function $63618293c58b5f80$var$objToLocalTS(obj) {
    var d = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond);
    // for legacy reasons, years between 0 and 99 are interpreted as 19XX; revert that
    if (obj.year < 100 && obj.year >= 0) {
        d = new Date(d);
        // set the month and day again, this is necessary because year 2000 is a leap year, but year 100 is not
        // so if obj.year is in 99, but obj.day makes it roll over into year 100,
        // the calculations done by Date.UTC are using year 2000 - which is incorrect
        d.setUTCFullYear(obj.year, obj.month - 1, obj.day);
    }
    return +d;
}
// adapted from moment.js: https://github.com/moment/moment/blob/000ac1800e620f770f4eb31b5ae908f6167b0ab2/src/lib/units/week-calendar-utils.js
function $63618293c58b5f80$var$firstWeekOffset(year, minDaysInFirstWeek, startOfWeek) {
    var fwdlw = $63618293c58b5f80$var$isoWeekdayToLocal($63618293c58b5f80$var$dayOfWeek(year, 1, minDaysInFirstWeek), startOfWeek);
    return -fwdlw + minDaysInFirstWeek - 1;
}
function $63618293c58b5f80$var$weeksInWeekYear(weekYear, minDaysInFirstWeek, startOfWeek) {
    if (minDaysInFirstWeek === void 0) minDaysInFirstWeek = 4;
    if (startOfWeek === void 0) startOfWeek = 1;
    var weekOffset = $63618293c58b5f80$var$firstWeekOffset(weekYear, minDaysInFirstWeek, startOfWeek);
    var weekOffsetNext = $63618293c58b5f80$var$firstWeekOffset(weekYear + 1, minDaysInFirstWeek, startOfWeek);
    return ($63618293c58b5f80$var$daysInYear(weekYear) - weekOffset + weekOffsetNext) / 7;
}
function $63618293c58b5f80$var$untruncateYear(year) {
    if (year > 99) return year;
    else return year > $63618293c58b5f80$var$Settings.twoDigitCutoffYear ? 1900 + year : 2000 + year;
}
// PARSING
function $63618293c58b5f80$var$parseZoneInfo(ts, offsetFormat, locale, timeZone) {
    if (timeZone === void 0) timeZone = null;
    var date = new Date(ts), intlOpts = {
        hourCycle: "h23",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
    };
    if (timeZone) intlOpts.timeZone = timeZone;
    var modified = $63618293c58b5f80$var$_extends({
        timeZoneName: offsetFormat
    }, intlOpts);
    var parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find(function(m) {
        return m.type.toLowerCase() === "timezonename";
    });
    return parsed ? parsed.value : null;
}
// signedOffset('-5', '30') -> -330
function $63618293c58b5f80$var$signedOffset(offHourStr, offMinuteStr) {
    var offHour = parseInt(offHourStr, 10);
    // don't || this because we want to preserve -0
    if (Number.isNaN(offHour)) offHour = 0;
    var offMin = parseInt(offMinuteStr, 10) || 0, offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
    return offHour * 60 + offMinSigned;
}
// COERCION
function $63618293c58b5f80$var$asNumber(value) {
    var numericValue = Number(value);
    if (typeof value === "boolean" || value === "" || !Number.isFinite(numericValue)) throw new $63618293c58b5f80$var$InvalidArgumentError("Invalid unit value " + value);
    return numericValue;
}
function $63618293c58b5f80$var$normalizeObject(obj, normalizer) {
    var normalized = {};
    for(var u in obj)if ($63618293c58b5f80$var$hasOwnProperty(obj, u)) {
        var v = obj[u];
        if (v === undefined || v === null) continue;
        normalized[normalizer(u)] = $63618293c58b5f80$var$asNumber(v);
    }
    return normalized;
}
/**
 * Returns the offset's value as a string
 * @param {number} ts - Epoch milliseconds for which to get the offset
 * @param {string} format - What style of offset to return.
 *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
 * @return {string}
 */ function $63618293c58b5f80$var$formatOffset(offset, format) {
    var hours = Math.trunc(Math.abs(offset / 60)), minutes = Math.trunc(Math.abs(offset % 60)), sign = offset >= 0 ? "+" : "-";
    switch(format){
        case "short":
            return "" + sign + $63618293c58b5f80$var$padStart(hours, 2) + ":" + $63618293c58b5f80$var$padStart(minutes, 2);
        case "narrow":
            return "" + sign + hours + (minutes > 0 ? ":" + minutes : "");
        case "techie":
            return "" + sign + $63618293c58b5f80$var$padStart(hours, 2) + $63618293c58b5f80$var$padStart(minutes, 2);
        default:
            throw new RangeError("Value format " + format + " is out of range for property format");
    }
}
function $63618293c58b5f80$var$timeObject(obj) {
    return $63618293c58b5f80$var$pick(obj, [
        "hour",
        "minute",
        "second",
        "millisecond"
    ]);
}
/**
 * @private
 */ var $63618293c58b5f80$var$monthsLong = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
var $63618293c58b5f80$var$monthsShort = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
var $63618293c58b5f80$var$monthsNarrow = [
    "J",
    "F",
    "M",
    "A",
    "M",
    "J",
    "J",
    "A",
    "S",
    "O",
    "N",
    "D"
];
function $63618293c58b5f80$var$months(length) {
    switch(length){
        case "narrow":
            return [].concat($63618293c58b5f80$var$monthsNarrow);
        case "short":
            return [].concat($63618293c58b5f80$var$monthsShort);
        case "long":
            return [].concat($63618293c58b5f80$var$monthsLong);
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                "10",
                "11",
                "12"
            ];
        case "2-digit":
            return [
                "01",
                "02",
                "03",
                "04",
                "05",
                "06",
                "07",
                "08",
                "09",
                "10",
                "11",
                "12"
            ];
        default:
            return null;
    }
}
var $63618293c58b5f80$var$weekdaysLong = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
];
var $63618293c58b5f80$var$weekdaysShort = [
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat",
    "Sun"
];
var $63618293c58b5f80$var$weekdaysNarrow = [
    "M",
    "T",
    "W",
    "T",
    "F",
    "S",
    "S"
];
function $63618293c58b5f80$var$weekdays(length) {
    switch(length){
        case "narrow":
            return [].concat($63618293c58b5f80$var$weekdaysNarrow);
        case "short":
            return [].concat($63618293c58b5f80$var$weekdaysShort);
        case "long":
            return [].concat($63618293c58b5f80$var$weekdaysLong);
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7"
            ];
        default:
            return null;
    }
}
var $63618293c58b5f80$var$meridiems = [
    "AM",
    "PM"
];
var $63618293c58b5f80$var$erasLong = [
    "Before Christ",
    "Anno Domini"
];
var $63618293c58b5f80$var$erasShort = [
    "BC",
    "AD"
];
var $63618293c58b5f80$var$erasNarrow = [
    "B",
    "A"
];
function $63618293c58b5f80$var$eras(length) {
    switch(length){
        case "narrow":
            return [].concat($63618293c58b5f80$var$erasNarrow);
        case "short":
            return [].concat($63618293c58b5f80$var$erasShort);
        case "long":
            return [].concat($63618293c58b5f80$var$erasLong);
        default:
            return null;
    }
}
function $63618293c58b5f80$var$meridiemForDateTime(dt) {
    return $63618293c58b5f80$var$meridiems[dt.hour < 12 ? 0 : 1];
}
function $63618293c58b5f80$var$weekdayForDateTime(dt, length) {
    return $63618293c58b5f80$var$weekdays(length)[dt.weekday - 1];
}
function $63618293c58b5f80$var$monthForDateTime(dt, length) {
    return $63618293c58b5f80$var$months(length)[dt.month - 1];
}
function $63618293c58b5f80$var$eraForDateTime(dt, length) {
    return $63618293c58b5f80$var$eras(length)[dt.year < 0 ? 0 : 1];
}
function $63618293c58b5f80$var$formatRelativeTime(unit, count, numeric, narrow) {
    if (numeric === void 0) numeric = "always";
    if (narrow === void 0) narrow = false;
    var units = {
        years: [
            "year",
            "yr."
        ],
        quarters: [
            "quarter",
            "qtr."
        ],
        months: [
            "month",
            "mo."
        ],
        weeks: [
            "week",
            "wk."
        ],
        days: [
            "day",
            "day",
            "days"
        ],
        hours: [
            "hour",
            "hr."
        ],
        minutes: [
            "minute",
            "min."
        ],
        seconds: [
            "second",
            "sec."
        ]
    };
    var lastable = [
        "hours",
        "minutes",
        "seconds"
    ].indexOf(unit) === -1;
    if (numeric === "auto" && lastable) {
        var isDay = unit === "days";
        switch(count){
            case 1:
                return isDay ? "tomorrow" : "next " + units[unit][0];
            case -1:
                return isDay ? "yesterday" : "last " + units[unit][0];
            case 0:
                return isDay ? "today" : "this " + units[unit][0];
        }
    }
    var isInPast = Object.is(count, -0) || count < 0, fmtValue = Math.abs(count), singular = fmtValue === 1, lilUnits = units[unit], fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
    return isInPast ? fmtValue + " " + fmtUnit + " ago" : "in " + fmtValue + " " + fmtUnit;
}
function $63618293c58b5f80$var$stringifyTokens(splits, tokenToString) {
    var s = "";
    for(var _iterator = $63618293c58b5f80$var$_createForOfIteratorHelperLoose(splits), _step; !(_step = _iterator()).done;){
        var token = _step.value;
        if (token.literal) s += token.val;
        else s += tokenToString(token.val);
    }
    return s;
}
var $63618293c58b5f80$var$_macroTokenToFormatOpts = {
    D: $63618293c58b5f80$var$DATE_SHORT,
    DD: $63618293c58b5f80$var$DATE_MED,
    DDD: $63618293c58b5f80$var$DATE_FULL,
    DDDD: $63618293c58b5f80$var$DATE_HUGE,
    t: $63618293c58b5f80$var$TIME_SIMPLE,
    tt: $63618293c58b5f80$var$TIME_WITH_SECONDS,
    ttt: $63618293c58b5f80$var$TIME_WITH_SHORT_OFFSET,
    tttt: $63618293c58b5f80$var$TIME_WITH_LONG_OFFSET,
    T: $63618293c58b5f80$var$TIME_24_SIMPLE,
    TT: $63618293c58b5f80$var$TIME_24_WITH_SECONDS,
    TTT: $63618293c58b5f80$var$TIME_24_WITH_SHORT_OFFSET,
    TTTT: $63618293c58b5f80$var$TIME_24_WITH_LONG_OFFSET,
    f: $63618293c58b5f80$var$DATETIME_SHORT,
    ff: $63618293c58b5f80$var$DATETIME_MED,
    fff: $63618293c58b5f80$var$DATETIME_FULL,
    ffff: $63618293c58b5f80$var$DATETIME_HUGE,
    F: $63618293c58b5f80$var$DATETIME_SHORT_WITH_SECONDS,
    FF: $63618293c58b5f80$var$DATETIME_MED_WITH_SECONDS,
    FFF: $63618293c58b5f80$var$DATETIME_FULL_WITH_SECONDS,
    FFFF: $63618293c58b5f80$var$DATETIME_HUGE_WITH_SECONDS
};
/**
 * @private
 */ var $63618293c58b5f80$var$Formatter = /*#__PURE__*/ function() {
    Formatter.create = function create(locale, opts) {
        if (opts === void 0) opts = {};
        return new Formatter(locale, opts);
    };
    Formatter.parseFormat = function parseFormat(fmt) {
        // white-space is always considered a literal in user-provided formats
        // the " " token has a special meaning (see unitForToken)
        var current = null, currentFull = "", bracketed = false;
        var splits = [];
        for(var i = 0; i < fmt.length; i++){
            var c = fmt.charAt(i);
            if (c === "'") {
                // turn '' into a literal signal quote instead of just skipping the empty literal
                if (currentFull.length > 0 || bracketed) splits.push({
                    literal: bracketed || /^\s+$/.test(currentFull),
                    val: currentFull === "" ? "'" : currentFull
                });
                current = null;
                currentFull = "";
                bracketed = !bracketed;
            } else if (bracketed) currentFull += c;
            else if (c === current) currentFull += c;
            else {
                if (currentFull.length > 0) splits.push({
                    literal: /^\s+$/.test(currentFull),
                    val: currentFull
                });
                currentFull = c;
                current = c;
            }
        }
        if (currentFull.length > 0) splits.push({
            literal: bracketed || /^\s+$/.test(currentFull),
            val: currentFull
        });
        return splits;
    };
    Formatter.macroTokenToFormatOpts = function macroTokenToFormatOpts(token) {
        return $63618293c58b5f80$var$_macroTokenToFormatOpts[token];
    };
    function Formatter(locale, formatOpts) {
        this.opts = formatOpts;
        this.loc = locale;
        this.systemLoc = null;
    }
    var _proto = Formatter.prototype;
    _proto.formatWithSystemDefault = function formatWithSystemDefault(dt, opts) {
        if (this.systemLoc === null) this.systemLoc = this.loc.redefaultToSystem();
        var df = this.systemLoc.dtFormatter(dt, $63618293c58b5f80$var$_extends({}, this.opts, opts));
        return df.format();
    };
    _proto.dtFormatter = function dtFormatter(dt, opts) {
        if (opts === void 0) opts = {};
        return this.loc.dtFormatter(dt, $63618293c58b5f80$var$_extends({}, this.opts, opts));
    };
    _proto.formatDateTime = function formatDateTime(dt, opts) {
        return this.dtFormatter(dt, opts).format();
    };
    _proto.formatDateTimeParts = function formatDateTimeParts(dt, opts) {
        return this.dtFormatter(dt, opts).formatToParts();
    };
    _proto.formatInterval = function formatInterval(interval, opts) {
        var df = this.dtFormatter(interval.start, opts);
        return df.dtf.formatRange(interval.start.toJSDate(), interval.end.toJSDate());
    };
    _proto.resolvedOptions = function resolvedOptions(dt, opts) {
        return this.dtFormatter(dt, opts).resolvedOptions();
    };
    _proto.num = function num(n, p, signDisplay) {
        if (p === void 0) p = 0;
        if (signDisplay === void 0) signDisplay = undefined;
        // we get some perf out of doing this here, annoyingly
        if (this.opts.forceSimple) return $63618293c58b5f80$var$padStart(n, p);
        var opts = $63618293c58b5f80$var$_extends({}, this.opts);
        if (p > 0) opts.padTo = p;
        if (signDisplay) opts.signDisplay = signDisplay;
        return this.loc.numberFormatter(opts).format(n);
    };
    _proto.formatDateTimeFromString = function formatDateTimeFromString(dt, fmt) {
        var _this = this;
        var knownEnglish = this.loc.listingMode() === "en", useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", string = function string(opts, extract) {
            return _this.loc.extract(dt, opts, extract);
        }, formatOffset = function formatOffset(opts) {
            if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) return "Z";
            return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
        }, meridiem = function meridiem() {
            return knownEnglish ? $63618293c58b5f80$var$meridiemForDateTime(dt) : string({
                hour: "numeric",
                hourCycle: "h12"
            }, "dayperiod");
        }, month = function month(length, standalone) {
            return knownEnglish ? $63618293c58b5f80$var$monthForDateTime(dt, length) : string(standalone ? {
                month: length
            } : {
                month: length,
                day: "numeric"
            }, "month");
        }, weekday = function weekday(length, standalone) {
            return knownEnglish ? $63618293c58b5f80$var$weekdayForDateTime(dt, length) : string(standalone ? {
                weekday: length
            } : {
                weekday: length,
                month: "long",
                day: "numeric"
            }, "weekday");
        }, maybeMacro = function maybeMacro(token) {
            var formatOpts = Formatter.macroTokenToFormatOpts(token);
            if (formatOpts) return _this.formatWithSystemDefault(dt, formatOpts);
            else return token;
        }, era = function era(length) {
            return knownEnglish ? $63618293c58b5f80$var$eraForDateTime(dt, length) : string({
                era: length
            }, "era");
        }, tokenToString = function tokenToString(token) {
            // Where possible: https://cldr.unicode.org/translation/date-time/date-time-symbols
            switch(token){
                // ms
                case "S":
                    return _this.num(dt.millisecond);
                case "u":
                // falls through
                case "SSS":
                    return _this.num(dt.millisecond, 3);
                // seconds
                case "s":
                    return _this.num(dt.second);
                case "ss":
                    return _this.num(dt.second, 2);
                // fractional seconds
                case "uu":
                    return _this.num(Math.floor(dt.millisecond / 10), 2);
                case "uuu":
                    return _this.num(Math.floor(dt.millisecond / 100));
                // minutes
                case "m":
                    return _this.num(dt.minute);
                case "mm":
                    return _this.num(dt.minute, 2);
                // hours
                case "h":
                    return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
                case "hh":
                    return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
                case "H":
                    return _this.num(dt.hour);
                case "HH":
                    return _this.num(dt.hour, 2);
                // offset
                case "Z":
                    // like +6
                    return formatOffset({
                        format: "narrow",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZ":
                    // like +06:00
                    return formatOffset({
                        format: "short",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZZ":
                    // like +0600
                    return formatOffset({
                        format: "techie",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZZZ":
                    // like EST
                    return dt.zone.offsetName(dt.ts, {
                        format: "short",
                        locale: _this.loc.locale
                    });
                case "ZZZZZ":
                    // like Eastern Standard Time
                    return dt.zone.offsetName(dt.ts, {
                        format: "long",
                        locale: _this.loc.locale
                    });
                // zone
                case "z":
                    // like America/New_York
                    return dt.zoneName;
                // meridiems
                case "a":
                    return meridiem();
                // dates
                case "d":
                    return useDateTimeFormatter ? string({
                        day: "numeric"
                    }, "day") : _this.num(dt.day);
                case "dd":
                    return useDateTimeFormatter ? string({
                        day: "2-digit"
                    }, "day") : _this.num(dt.day, 2);
                // weekdays - standalone
                case "c":
                    // like 1
                    return _this.num(dt.weekday);
                case "ccc":
                    // like 'Tues'
                    return weekday("short", true);
                case "cccc":
                    // like 'Tuesday'
                    return weekday("long", true);
                case "ccccc":
                    // like 'T'
                    return weekday("narrow", true);
                // weekdays - format
                case "E":
                    // like 1
                    return _this.num(dt.weekday);
                case "EEE":
                    // like 'Tues'
                    return weekday("short", false);
                case "EEEE":
                    // like 'Tuesday'
                    return weekday("long", false);
                case "EEEEE":
                    // like 'T'
                    return weekday("narrow", false);
                // months - standalone
                case "L":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric",
                        day: "numeric"
                    }, "month") : _this.num(dt.month);
                case "LL":
                    // like 01, doesn't seem to work
                    return useDateTimeFormatter ? string({
                        month: "2-digit",
                        day: "numeric"
                    }, "month") : _this.num(dt.month, 2);
                case "LLL":
                    // like Jan
                    return month("short", true);
                case "LLLL":
                    // like January
                    return month("long", true);
                case "LLLLL":
                    // like J
                    return month("narrow", true);
                // months - format
                case "M":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric"
                    }, "month") : _this.num(dt.month);
                case "MM":
                    // like 01
                    return useDateTimeFormatter ? string({
                        month: "2-digit"
                    }, "month") : _this.num(dt.month, 2);
                case "MMM":
                    // like Jan
                    return month("short", false);
                case "MMMM":
                    // like January
                    return month("long", false);
                case "MMMMM":
                    // like J
                    return month("narrow", false);
                // years
                case "y":
                    // like 2014
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year);
                case "yy":
                    // like 14
                    return useDateTimeFormatter ? string({
                        year: "2-digit"
                    }, "year") : _this.num(dt.year.toString().slice(-2), 2);
                case "yyyy":
                    // like 0012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year, 4);
                case "yyyyyy":
                    // like 000012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year, 6);
                // eras
                case "G":
                    // like AD
                    return era("short");
                case "GG":
                    // like Anno Domini
                    return era("long");
                case "GGGGG":
                    return era("narrow");
                case "kk":
                    return _this.num(dt.weekYear.toString().slice(-2), 2);
                case "kkkk":
                    return _this.num(dt.weekYear, 4);
                case "W":
                    return _this.num(dt.weekNumber);
                case "WW":
                    return _this.num(dt.weekNumber, 2);
                case "n":
                    return _this.num(dt.localWeekNumber);
                case "nn":
                    return _this.num(dt.localWeekNumber, 2);
                case "ii":
                    return _this.num(dt.localWeekYear.toString().slice(-2), 2);
                case "iiii":
                    return _this.num(dt.localWeekYear, 4);
                case "o":
                    return _this.num(dt.ordinal);
                case "ooo":
                    return _this.num(dt.ordinal, 3);
                case "q":
                    // like 1
                    return _this.num(dt.quarter);
                case "qq":
                    // like 01
                    return _this.num(dt.quarter, 2);
                case "X":
                    return _this.num(Math.floor(dt.ts / 1000));
                case "x":
                    return _this.num(dt.ts);
                default:
                    return maybeMacro(token);
            }
        };
        return $63618293c58b5f80$var$stringifyTokens(Formatter.parseFormat(fmt), tokenToString);
    };
    _proto.formatDurationFromString = function formatDurationFromString(dur, fmt) {
        var _this2 = this;
        var invertLargest = this.opts.signMode === "negativeLargestOnly" ? -1 : 1;
        var tokenToField = function tokenToField(token) {
            switch(token[0]){
                case "S":
                    return "milliseconds";
                case "s":
                    return "seconds";
                case "m":
                    return "minutes";
                case "h":
                    return "hours";
                case "d":
                    return "days";
                case "w":
                    return "weeks";
                case "M":
                    return "months";
                case "y":
                    return "years";
                default:
                    return null;
            }
        }, tokenToString = function tokenToString(lildur, info) {
            return function(token) {
                var mapped = tokenToField(token);
                if (mapped) {
                    var inversionFactor = info.isNegativeDuration && mapped !== info.largestUnit ? invertLargest : 1;
                    var signDisplay;
                    if (_this2.opts.signMode === "negativeLargestOnly" && mapped !== info.largestUnit) signDisplay = "never";
                    else if (_this2.opts.signMode === "all") signDisplay = "always";
                    else // "auto" and "negative" are the same, but "auto" has better support
                    signDisplay = "auto";
                    return _this2.num(lildur.get(mapped) * inversionFactor, token.length, signDisplay);
                } else return token;
            };
        }, tokens = Formatter.parseFormat(fmt), realTokens = tokens.reduce(function(found, _ref) {
            var literal = _ref.literal, val = _ref.val;
            return literal ? found : found.concat(val);
        }, []), collapsed = dur.shiftTo.apply(dur, realTokens.map(tokenToField).filter(function(t) {
            return t;
        })), durationInfo = {
            isNegativeDuration: collapsed < 0,
            // this relies on "collapsed" being based on "shiftTo", which builds up the object
            // in order
            largestUnit: Object.keys(collapsed.values)[0]
        };
        return $63618293c58b5f80$var$stringifyTokens(tokens, tokenToString(collapsed, durationInfo));
    };
    return Formatter;
}();
/*
 * This file handles parsing for well-specified formats. Here's how it works:
 * Two things go into parsing: a regex to match with and an extractor to take apart the groups in the match.
 * An extractor is just a function that takes a regex match array and returns a { year: ..., month: ... } object
 * parse() does the work of executing the regex and applying the extractor. It takes multiple regex/extractor pairs to try in sequence.
 * Extractors can take a "cursor" representing the offset in the match to look at. This makes it easy to combine extractors.
 * combineExtractors() does the work of combining them, keeping track of the cursor through multiple extractions.
 * Some extractions are super dumb and simpleParse and fromStrings help DRY them.
 */ var $63618293c58b5f80$var$ianaRegex = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function $63618293c58b5f80$var$combineRegexes() {
    for(var _len = arguments.length, regexes = new Array(_len), _key = 0; _key < _len; _key++)regexes[_key] = arguments[_key];
    var full = regexes.reduce(function(f, r) {
        return f + r.source;
    }, "");
    return RegExp("^" + full + "$");
}
function $63618293c58b5f80$var$combineExtractors() {
    for(var _len2 = arguments.length, extractors = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)extractors[_key2] = arguments[_key2];
    return function(m) {
        return extractors.reduce(function(_ref, ex) {
            var mergedVals = _ref[0], mergedZone = _ref[1], cursor = _ref[2];
            var _ex = ex(m, cursor), val = _ex[0], zone = _ex[1], next = _ex[2];
            return [
                $63618293c58b5f80$var$_extends({}, mergedVals, val),
                zone || mergedZone,
                next
            ];
        }, [
            {},
            null,
            1
        ]).slice(0, 2);
    };
}
function $63618293c58b5f80$var$parse(s) {
    if (s == null) return [
        null,
        null
    ];
    for(var _len3 = arguments.length, patterns = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)patterns[_key3 - 1] = arguments[_key3];
    for(var _i = 0, _patterns = patterns; _i < _patterns.length; _i++){
        var _patterns$_i = _patterns[_i], regex = _patterns$_i[0], extractor = _patterns$_i[1];
        var m = regex.exec(s);
        if (m) return extractor(m);
    }
    return [
        null,
        null
    ];
}
function $63618293c58b5f80$var$simpleParse() {
    for(var _len4 = arguments.length, keys = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)keys[_key4] = arguments[_key4];
    return function(match, cursor) {
        var ret = {};
        var i;
        for(i = 0; i < keys.length; i++)ret[keys[i]] = $63618293c58b5f80$var$parseInteger(match[cursor + i]);
        return [
            ret,
            null,
            cursor + i
        ];
    };
}
// ISO and SQL parsing
var $63618293c58b5f80$var$offsetRegex = /(?:([Zz])|([+-]\d\d)(?::?(\d\d))?)/;
var $63618293c58b5f80$var$isoExtendedZone = "(?:" + $63618293c58b5f80$var$offsetRegex.source + "?(?:\\[(" + $63618293c58b5f80$var$ianaRegex.source + ")\\])?)?";
var $63618293c58b5f80$var$isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/;
var $63618293c58b5f80$var$isoTimeRegex = RegExp("" + $63618293c58b5f80$var$isoTimeBaseRegex.source + $63618293c58b5f80$var$isoExtendedZone);
var $63618293c58b5f80$var$isoTimeExtensionRegex = RegExp("(?:[Tt]" + $63618293c58b5f80$var$isoTimeRegex.source + ")?");
var $63618293c58b5f80$var$isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/;
var $63618293c58b5f80$var$isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/;
var $63618293c58b5f80$var$isoOrdinalRegex = /(\d{4})-?(\d{3})/;
var $63618293c58b5f80$var$extractISOWeekData = $63618293c58b5f80$var$simpleParse("weekYear", "weekNumber", "weekDay");
var $63618293c58b5f80$var$extractISOOrdinalData = $63618293c58b5f80$var$simpleParse("year", "ordinal");
var $63618293c58b5f80$var$sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/; // dumbed-down version of the ISO one
var $63618293c58b5f80$var$sqlTimeRegex = RegExp($63618293c58b5f80$var$isoTimeBaseRegex.source + " ?(?:" + $63618293c58b5f80$var$offsetRegex.source + "|(" + $63618293c58b5f80$var$ianaRegex.source + "))?");
var $63618293c58b5f80$var$sqlTimeExtensionRegex = RegExp("(?: " + $63618293c58b5f80$var$sqlTimeRegex.source + ")?");
function $63618293c58b5f80$var$int(match, pos, fallback) {
    var m = match[pos];
    return $63618293c58b5f80$var$isUndefined(m) ? fallback : $63618293c58b5f80$var$parseInteger(m);
}
function $63618293c58b5f80$var$extractISOYmd(match, cursor) {
    var item = {
        year: $63618293c58b5f80$var$int(match, cursor),
        month: $63618293c58b5f80$var$int(match, cursor + 1, 1),
        day: $63618293c58b5f80$var$int(match, cursor + 2, 1)
    };
    return [
        item,
        null,
        cursor + 3
    ];
}
function $63618293c58b5f80$var$extractISOTime(match, cursor) {
    var item = {
        hours: $63618293c58b5f80$var$int(match, cursor, 0),
        minutes: $63618293c58b5f80$var$int(match, cursor + 1, 0),
        seconds: $63618293c58b5f80$var$int(match, cursor + 2, 0),
        milliseconds: $63618293c58b5f80$var$parseMillis(match[cursor + 3])
    };
    return [
        item,
        null,
        cursor + 4
    ];
}
function $63618293c58b5f80$var$extractISOOffset(match, cursor) {
    var local = !match[cursor] && !match[cursor + 1], fullOffset = $63618293c58b5f80$var$signedOffset(match[cursor + 1], match[cursor + 2]), zone = local ? null : $63618293c58b5f80$var$FixedOffsetZone.instance(fullOffset);
    return [
        {},
        zone,
        cursor + 3
    ];
}
function $63618293c58b5f80$var$extractIANAZone(match, cursor) {
    var zone = match[cursor] ? $63618293c58b5f80$var$IANAZone.create(match[cursor]) : null;
    return [
        {},
        zone,
        cursor + 1
    ];
}
// ISO time parsing
var $63618293c58b5f80$var$isoTimeOnly = RegExp("^T?" + $63618293c58b5f80$var$isoTimeBaseRegex.source + "$");
// ISO duration parsing
var $63618293c58b5f80$var$isoDuration = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function $63618293c58b5f80$var$extractISODuration(match) {
    var s = match[0], yearStr = match[1], monthStr = match[2], weekStr = match[3], dayStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], millisecondsStr = match[8];
    var hasNegativePrefix = s[0] === "-";
    var negativeSeconds = secondStr && secondStr[0] === "-";
    var maybeNegate = function maybeNegate(num, force) {
        if (force === void 0) force = false;
        return num !== undefined && (force || num && hasNegativePrefix) ? -num : num;
    };
    return [
        {
            years: maybeNegate($63618293c58b5f80$var$parseFloating(yearStr)),
            months: maybeNegate($63618293c58b5f80$var$parseFloating(monthStr)),
            weeks: maybeNegate($63618293c58b5f80$var$parseFloating(weekStr)),
            days: maybeNegate($63618293c58b5f80$var$parseFloating(dayStr)),
            hours: maybeNegate($63618293c58b5f80$var$parseFloating(hourStr)),
            minutes: maybeNegate($63618293c58b5f80$var$parseFloating(minuteStr)),
            seconds: maybeNegate($63618293c58b5f80$var$parseFloating(secondStr), secondStr === "-0"),
            milliseconds: maybeNegate($63618293c58b5f80$var$parseMillis(millisecondsStr), negativeSeconds)
        }
    ];
}
// These are a little braindead. EDT *should* tell us that we're in, say, America/New_York
// and not just that we're in -240 *right now*. But since I don't think these are used that often
// I'm just going to ignore that
var $63618293c58b5f80$var$obsOffsets = {
    GMT: 0,
    EDT: -240,
    EST: -300,
    CDT: -300,
    CST: -360,
    MDT: -360,
    MST: -420,
    PDT: -420,
    PST: -480
};
function $63618293c58b5f80$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = {
        year: yearStr.length === 2 ? $63618293c58b5f80$var$untruncateYear($63618293c58b5f80$var$parseInteger(yearStr)) : $63618293c58b5f80$var$parseInteger(yearStr),
        month: $63618293c58b5f80$var$monthsShort.indexOf(monthStr) + 1,
        day: $63618293c58b5f80$var$parseInteger(dayStr),
        hour: $63618293c58b5f80$var$parseInteger(hourStr),
        minute: $63618293c58b5f80$var$parseInteger(minuteStr)
    };
    if (secondStr) result.second = $63618293c58b5f80$var$parseInteger(secondStr);
    if (weekdayStr) result.weekday = weekdayStr.length > 3 ? $63618293c58b5f80$var$weekdaysLong.indexOf(weekdayStr) + 1 : $63618293c58b5f80$var$weekdaysShort.indexOf(weekdayStr) + 1;
    return result;
}
// RFC 2822/5322
var $63618293c58b5f80$var$rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function $63618293c58b5f80$var$extractRFC2822(match) {
    var weekdayStr = match[1], dayStr = match[2], monthStr = match[3], yearStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], obsOffset = match[8], milOffset = match[9], offHourStr = match[10], offMinuteStr = match[11], result = $63618293c58b5f80$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    var offset;
    if (obsOffset) offset = $63618293c58b5f80$var$obsOffsets[obsOffset];
    else if (milOffset) offset = 0;
    else offset = $63618293c58b5f80$var$signedOffset(offHourStr, offMinuteStr);
    return [
        result,
        new $63618293c58b5f80$var$FixedOffsetZone(offset)
    ];
}
function $63618293c58b5f80$var$preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
// http date
var $63618293c58b5f80$var$rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, $63618293c58b5f80$var$rfc850 = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, $63618293c58b5f80$var$ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function $63618293c58b5f80$var$extractRFC1123Or850(match) {
    var weekdayStr = match[1], dayStr = match[2], monthStr = match[3], yearStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], result = $63618293c58b5f80$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        $63618293c58b5f80$var$FixedOffsetZone.utcInstance
    ];
}
function $63618293c58b5f80$var$extractASCII(match) {
    var weekdayStr = match[1], monthStr = match[2], dayStr = match[3], hourStr = match[4], minuteStr = match[5], secondStr = match[6], yearStr = match[7], result = $63618293c58b5f80$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        $63618293c58b5f80$var$FixedOffsetZone.utcInstance
    ];
}
var $63618293c58b5f80$var$isoYmdWithTimeExtensionRegex = $63618293c58b5f80$var$combineRegexes($63618293c58b5f80$var$isoYmdRegex, $63618293c58b5f80$var$isoTimeExtensionRegex);
var $63618293c58b5f80$var$isoWeekWithTimeExtensionRegex = $63618293c58b5f80$var$combineRegexes($63618293c58b5f80$var$isoWeekRegex, $63618293c58b5f80$var$isoTimeExtensionRegex);
var $63618293c58b5f80$var$isoOrdinalWithTimeExtensionRegex = $63618293c58b5f80$var$combineRegexes($63618293c58b5f80$var$isoOrdinalRegex, $63618293c58b5f80$var$isoTimeExtensionRegex);
var $63618293c58b5f80$var$isoTimeCombinedRegex = $63618293c58b5f80$var$combineRegexes($63618293c58b5f80$var$isoTimeRegex);
var $63618293c58b5f80$var$extractISOYmdTimeAndOffset = $63618293c58b5f80$var$combineExtractors($63618293c58b5f80$var$extractISOYmd, $63618293c58b5f80$var$extractISOTime, $63618293c58b5f80$var$extractISOOffset, $63618293c58b5f80$var$extractIANAZone);
var $63618293c58b5f80$var$extractISOWeekTimeAndOffset = $63618293c58b5f80$var$combineExtractors($63618293c58b5f80$var$extractISOWeekData, $63618293c58b5f80$var$extractISOTime, $63618293c58b5f80$var$extractISOOffset, $63618293c58b5f80$var$extractIANAZone);
var $63618293c58b5f80$var$extractISOOrdinalDateAndTime = $63618293c58b5f80$var$combineExtractors($63618293c58b5f80$var$extractISOOrdinalData, $63618293c58b5f80$var$extractISOTime, $63618293c58b5f80$var$extractISOOffset, $63618293c58b5f80$var$extractIANAZone);
var $63618293c58b5f80$var$extractISOTimeAndOffset = $63618293c58b5f80$var$combineExtractors($63618293c58b5f80$var$extractISOTime, $63618293c58b5f80$var$extractISOOffset, $63618293c58b5f80$var$extractIANAZone);
/*
 * @private
 */ function $63618293c58b5f80$var$parseISODate(s) {
    return $63618293c58b5f80$var$parse(s, [
        $63618293c58b5f80$var$isoYmdWithTimeExtensionRegex,
        $63618293c58b5f80$var$extractISOYmdTimeAndOffset
    ], [
        $63618293c58b5f80$var$isoWeekWithTimeExtensionRegex,
        $63618293c58b5f80$var$extractISOWeekTimeAndOffset
    ], [
        $63618293c58b5f80$var$isoOrdinalWithTimeExtensionRegex,
        $63618293c58b5f80$var$extractISOOrdinalDateAndTime
    ], [
        $63618293c58b5f80$var$isoTimeCombinedRegex,
        $63618293c58b5f80$var$extractISOTimeAndOffset
    ]);
}
function $63618293c58b5f80$var$parseRFC2822Date(s) {
    return $63618293c58b5f80$var$parse($63618293c58b5f80$var$preprocessRFC2822(s), [
        $63618293c58b5f80$var$rfc2822,
        $63618293c58b5f80$var$extractRFC2822
    ]);
}
function $63618293c58b5f80$var$parseHTTPDate(s) {
    return $63618293c58b5f80$var$parse(s, [
        $63618293c58b5f80$var$rfc1123,
        $63618293c58b5f80$var$extractRFC1123Or850
    ], [
        $63618293c58b5f80$var$rfc850,
        $63618293c58b5f80$var$extractRFC1123Or850
    ], [
        $63618293c58b5f80$var$ascii,
        $63618293c58b5f80$var$extractASCII
    ]);
}
function $63618293c58b5f80$var$parseISODuration(s) {
    return $63618293c58b5f80$var$parse(s, [
        $63618293c58b5f80$var$isoDuration,
        $63618293c58b5f80$var$extractISODuration
    ]);
}
var $63618293c58b5f80$var$extractISOTimeOnly = $63618293c58b5f80$var$combineExtractors($63618293c58b5f80$var$extractISOTime);
function $63618293c58b5f80$var$parseISOTimeOnly(s) {
    return $63618293c58b5f80$var$parse(s, [
        $63618293c58b5f80$var$isoTimeOnly,
        $63618293c58b5f80$var$extractISOTimeOnly
    ]);
}
var $63618293c58b5f80$var$sqlYmdWithTimeExtensionRegex = $63618293c58b5f80$var$combineRegexes($63618293c58b5f80$var$sqlYmdRegex, $63618293c58b5f80$var$sqlTimeExtensionRegex);
var $63618293c58b5f80$var$sqlTimeCombinedRegex = $63618293c58b5f80$var$combineRegexes($63618293c58b5f80$var$sqlTimeRegex);
var $63618293c58b5f80$var$extractISOTimeOffsetAndIANAZone = $63618293c58b5f80$var$combineExtractors($63618293c58b5f80$var$extractISOTime, $63618293c58b5f80$var$extractISOOffset, $63618293c58b5f80$var$extractIANAZone);
function $63618293c58b5f80$var$parseSQL(s) {
    return $63618293c58b5f80$var$parse(s, [
        $63618293c58b5f80$var$sqlYmdWithTimeExtensionRegex,
        $63618293c58b5f80$var$extractISOYmdTimeAndOffset
    ], [
        $63618293c58b5f80$var$sqlTimeCombinedRegex,
        $63618293c58b5f80$var$extractISOTimeOffsetAndIANAZone
    ]);
}
var $63618293c58b5f80$var$INVALID$2 = "Invalid Duration";
// unit conversion constants
var $63618293c58b5f80$var$lowOrderMatrix = {
    weeks: {
        days: 7,
        hours: 168,
        minutes: 10080,
        seconds: 604800,
        milliseconds: 604800000
    },
    days: {
        hours: 24,
        minutes: 1440,
        seconds: 86400,
        milliseconds: 86400000
    },
    hours: {
        minutes: 60,
        seconds: 3600,
        milliseconds: 3600000
    },
    minutes: {
        seconds: 60,
        milliseconds: 60000
    },
    seconds: {
        milliseconds: 1000
    }
}, $63618293c58b5f80$var$casualMatrix = $63618293c58b5f80$var$_extends({
    years: {
        quarters: 4,
        months: 12,
        weeks: 52,
        days: 365,
        hours: 8760,
        minutes: 525600,
        seconds: 31536000,
        milliseconds: 31536000000
    },
    quarters: {
        months: 3,
        weeks: 13,
        days: 91,
        hours: 2184,
        minutes: 131040,
        seconds: 7862400,
        milliseconds: 7862400000
    },
    months: {
        weeks: 4,
        days: 30,
        hours: 720,
        minutes: 43200,
        seconds: 2592000,
        milliseconds: 2592000000
    }
}, $63618293c58b5f80$var$lowOrderMatrix), $63618293c58b5f80$var$daysInYearAccurate = 365.2425, $63618293c58b5f80$var$daysInMonthAccurate = 30.436875, $63618293c58b5f80$var$accurateMatrix = $63618293c58b5f80$var$_extends({
    years: {
        quarters: 4,
        months: 12,
        weeks: $63618293c58b5f80$var$daysInYearAccurate / 7,
        days: $63618293c58b5f80$var$daysInYearAccurate,
        hours: $63618293c58b5f80$var$daysInYearAccurate * 24,
        minutes: $63618293c58b5f80$var$daysInYearAccurate * 1440,
        seconds: $63618293c58b5f80$var$daysInYearAccurate * 86400,
        milliseconds: $63618293c58b5f80$var$daysInYearAccurate * 86400000
    },
    quarters: {
        months: 3,
        weeks: $63618293c58b5f80$var$daysInYearAccurate / 28,
        days: $63618293c58b5f80$var$daysInYearAccurate / 4,
        hours: $63618293c58b5f80$var$daysInYearAccurate * 24 / 4,
        minutes: $63618293c58b5f80$var$daysInYearAccurate * 1440 / 4,
        seconds: $63618293c58b5f80$var$daysInYearAccurate * 86400 / 4,
        milliseconds: $63618293c58b5f80$var$daysInYearAccurate * 86400000 / 4
    },
    months: {
        weeks: $63618293c58b5f80$var$daysInMonthAccurate / 7,
        days: $63618293c58b5f80$var$daysInMonthAccurate,
        hours: $63618293c58b5f80$var$daysInMonthAccurate * 24,
        minutes: $63618293c58b5f80$var$daysInMonthAccurate * 1440,
        seconds: $63618293c58b5f80$var$daysInMonthAccurate * 86400,
        milliseconds: $63618293c58b5f80$var$daysInMonthAccurate * 86400000
    }
}, $63618293c58b5f80$var$lowOrderMatrix);
// units ordered by size
var $63618293c58b5f80$var$orderedUnits$1 = [
    "years",
    "quarters",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds",
    "milliseconds"
];
var $63618293c58b5f80$var$reverseUnits = $63618293c58b5f80$var$orderedUnits$1.slice(0).reverse();
// clone really means "create another instance just like this one, but with these changes"
function $63618293c58b5f80$var$clone$1(dur, alts, clear) {
    if (clear === void 0) clear = false;
    // deep merge for vals
    var conf = {
        values: clear ? alts.values : $63618293c58b5f80$var$_extends({}, dur.values, alts.values || {}),
        loc: dur.loc.clone(alts.loc),
        conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy,
        matrix: alts.matrix || dur.matrix
    };
    return new $63618293c58b5f80$var$Duration(conf);
}
function $63618293c58b5f80$var$durationToMillis(matrix, vals) {
    var _vals$milliseconds;
    var sum = (_vals$milliseconds = vals.milliseconds) != null ? _vals$milliseconds : 0;
    for(var _iterator = $63618293c58b5f80$var$_createForOfIteratorHelperLoose($63618293c58b5f80$var$reverseUnits.slice(1)), _step; !(_step = _iterator()).done;){
        var unit = _step.value;
        if (vals[unit]) sum += vals[unit] * matrix[unit]["milliseconds"];
    }
    return sum;
}
// NB: mutates parameters
function $63618293c58b5f80$var$normalizeValues(matrix, vals) {
    // the logic below assumes the overall value of the duration is positive
    // if this is not the case, factor is used to make it so
    var factor = $63618293c58b5f80$var$durationToMillis(matrix, vals) < 0 ? -1 : 1;
    $63618293c58b5f80$var$orderedUnits$1.reduceRight(function(previous, current) {
        if (!$63618293c58b5f80$var$isUndefined(vals[current])) {
            if (previous) {
                var previousVal = vals[previous] * factor;
                var conv = matrix[current][previous];
                // if (previousVal < 0):
                // lower order unit is negative (e.g. { years: 2, days: -2 })
                // normalize this by reducing the higher order unit by the appropriate amount
                // and increasing the lower order unit
                // this can never make the higher order unit negative, because this function only operates
                // on positive durations, so the amount of time represented by the lower order unit cannot
                // be larger than the higher order unit
                // else:
                // lower order unit is positive (e.g. { years: 2, days: 450 } or { years: -2, days: 450 })
                // in this case we attempt to convert as much as possible from the lower order unit into
                // the higher order one
                //
                // Math.floor takes care of both of these cases, rounding away from 0
                // if previousVal < 0 it makes the absolute value larger
                // if previousVal >= it makes the absolute value smaller
                var rollUp = Math.floor(previousVal / conv);
                vals[current] += rollUp * factor;
                vals[previous] -= rollUp * conv * factor;
            }
            return current;
        } else return previous;
    }, null);
    // try to convert any decimals into smaller units if possible
    // for example for { years: 2.5, days: 0, seconds: 0 } we want to get { years: 2, days: 182, hours: 12 }
    $63618293c58b5f80$var$orderedUnits$1.reduce(function(previous, current) {
        if (!$63618293c58b5f80$var$isUndefined(vals[current])) {
            if (previous) {
                var fraction = vals[previous] % 1;
                vals[previous] -= fraction;
                vals[current] += fraction * matrix[previous][current];
            }
            return current;
        } else return previous;
    }, null);
}
// Remove all properties with a value of 0 from an object
function $63618293c58b5f80$var$removeZeroes(vals) {
    var newVals = {};
    for(var _i = 0, _Object$entries = Object.entries(vals); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = _Object$entries[_i], key = _Object$entries$_i[0], value = _Object$entries$_i[1];
        if (value !== 0) newVals[key] = value;
    }
    return newVals;
}
/**
 * A Duration object represents a period of time, like "2 months" or "1 day, 1 hour". Conceptually, it's just a map of units to their quantities, accompanied by some additional configuration and methods for creating, parsing, interrogating, transforming, and formatting them. They can be used on their own or in conjunction with other Luxon types; for example, you can use {@link DateTime#plus} to add a Duration object to a DateTime, producing another DateTime.
 *
 * Here is a brief overview of commonly used methods and getters in Duration:
 *
 * * **Creation** To create a Duration, use {@link Duration.fromMillis}, {@link Duration.fromObject}, or {@link Duration.fromISO}.
 * * **Unit values** See the {@link Duration#years}, {@link Duration#months}, {@link Duration#weeks}, {@link Duration#days}, {@link Duration#hours}, {@link Duration#minutes}, {@link Duration#seconds}, {@link Duration#milliseconds} accessors.
 * * **Configuration** See  {@link Duration#locale} and {@link Duration#numberingSystem} accessors.
 * * **Transformation** To create new Durations out of old ones use {@link Duration#plus}, {@link Duration#minus}, {@link Duration#normalize}, {@link Duration#set}, {@link Duration#reconfigure}, {@link Duration#shiftTo}, and {@link Duration#negate}.
 * * **Output** To convert the Duration into other representations, see {@link Duration#as}, {@link Duration#toISO}, {@link Duration#toFormat}, and {@link Duration#toJSON}
 *
 * There's are more methods documented below. In addition, for more information on subtler topics like internationalization and validity, see the external documentation.
 */ var $63618293c58b5f80$var$Duration = /*#__PURE__*/ function(_Symbol$for) {
    /**
   * @private
   */ function Duration(config) {
        var accurate = config.conversionAccuracy === "longterm" || false;
        var matrix = accurate ? $63618293c58b5f80$var$accurateMatrix : $63618293c58b5f80$var$casualMatrix;
        if (config.matrix) matrix = config.matrix;
        /**
     * @access private
     */ this.values = config.values;
        /**
     * @access private
     */ this.loc = config.loc || $63618293c58b5f80$var$Locale.create();
        /**
     * @access private
     */ this.conversionAccuracy = accurate ? "longterm" : "casual";
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.matrix = matrix;
        /**
     * @access private
     */ this.isLuxonDuration = true;
    }
    /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */ Duration.fromMillis = function fromMillis(count, opts) {
        return Duration.fromObject({
            milliseconds: count
        }, opts);
    } /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */ ;
    Duration.fromObject = function fromObject(obj, opts) {
        if (opts === void 0) opts = {};
        if (obj == null || typeof obj !== "object") throw new $63618293c58b5f80$var$InvalidArgumentError("Duration.fromObject: argument expected to be an object, got " + (obj === null ? "null" : typeof obj));
        return new Duration({
            values: $63618293c58b5f80$var$normalizeObject(obj, Duration.normalizeUnit),
            loc: $63618293c58b5f80$var$Locale.fromObject(opts),
            conversionAccuracy: opts.conversionAccuracy,
            matrix: opts.matrix
        });
    } /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */ ;
    Duration.fromDurationLike = function fromDurationLike(durationLike) {
        if ($63618293c58b5f80$var$isNumber(durationLike)) return Duration.fromMillis(durationLike);
        else if (Duration.isDuration(durationLike)) return durationLike;
        else if (typeof durationLike === "object") return Duration.fromObject(durationLike);
        else throw new $63618293c58b5f80$var$InvalidArgumentError("Unknown duration argument " + durationLike + " of type " + typeof durationLike);
    } /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */ ;
    Duration.fromISO = function fromISO(text, opts) {
        var _parseISODuration = $63618293c58b5f80$var$parseISODuration(text), parsed = _parseISODuration[0];
        if (parsed) return Duration.fromObject(parsed, opts);
        else return Duration.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    } /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */ ;
    Duration.fromISOTime = function fromISOTime(text, opts) {
        var _parseISOTimeOnly = $63618293c58b5f80$var$parseISOTimeOnly(text), parsed = _parseISOTimeOnly[0];
        if (parsed) return Duration.fromObject(parsed, opts);
        else return Duration.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    } /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */ ;
    Duration.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $63618293c58b5f80$var$InvalidArgumentError("need to specify a reason the Duration is invalid");
        var invalid = reason instanceof $63618293c58b5f80$var$Invalid ? reason : new $63618293c58b5f80$var$Invalid(reason, explanation);
        if ($63618293c58b5f80$var$Settings.throwOnInvalid) throw new $63618293c58b5f80$var$InvalidDurationError(invalid);
        else return new Duration({
            invalid: invalid
        });
    } /**
   * @private
   */ ;
    Duration.normalizeUnit = function normalizeUnit(unit) {
        var normalized = {
            year: "years",
            years: "years",
            quarter: "quarters",
            quarters: "quarters",
            month: "months",
            months: "months",
            week: "weeks",
            weeks: "weeks",
            day: "days",
            days: "days",
            hour: "hours",
            hours: "hours",
            minute: "minutes",
            minutes: "minutes",
            second: "seconds",
            seconds: "seconds",
            millisecond: "milliseconds",
            milliseconds: "milliseconds"
        }[unit ? unit.toLowerCase() : unit];
        if (!normalized) throw new $63618293c58b5f80$var$InvalidUnitError(unit);
        return normalized;
    } /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ ;
    Duration.isDuration = function isDuration(o) {
        return o && o.isLuxonDuration || false;
    } /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */ ;
    var _proto = Duration.prototype;
    /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @param {'negative'|'all'|'negativeLargestOnly'} [opts.signMode=negative] - How to handle signs
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @example Duration.fromObject({ days: 6, seconds: 2 }).toFormat("d s", { signMode: "all" }) //=> "+6 +2"
   * @example Duration.fromObject({ days: -6, seconds: -2 }).toFormat("d s", { signMode: "all" }) //=> "-6 -2"
   * @example Duration.fromObject({ days: -6, seconds: -2 }).toFormat("d s", { signMode: "negativeLargestOnly" }) //=> "-6 2"
   * @return {string}
   */ _proto.toFormat = function toFormat(fmt, opts) {
        if (opts === void 0) opts = {};
        // reverse-compat since 1.2; we always round down now, never up, and we do it by default
        var fmtOpts = $63618293c58b5f80$var$_extends({}, opts, {
            floor: opts.round !== false && opts.floor !== false
        });
        return this.isValid ? $63618293c58b5f80$var$Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : $63618293c58b5f80$var$INVALID$2;
    } /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior, use `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
   * @param {Object} opts - Formatting options. Accepts the same keys as the options parameter of the native `Intl.NumberFormat` constructor, as well as `listStyle`.
   * @param {string} [opts.listStyle='narrow'] - How to format the merged list. Corresponds to the `style` property of the options parameter of the native `Intl.ListFormat` constructor.
   * @param {boolean} [opts.showZeros=true] - Show all units previously used by the duration even if they are zero
   * @example
   * ```js
   * var dur = Duration.fromObject({ months: 1, weeks: 0, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 month, 0 weeks, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 month, 0 weeks, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 mth, 0 wks, 5 hr, 6 min'
   * dur.toHuman({ showZeros: false }) //=> '1 month, 5 hours, 6 minutes'
   * ```
   */ ;
    _proto.toHuman = function toHuman(opts) {
        var _this = this;
        if (opts === void 0) opts = {};
        if (!this.isValid) return $63618293c58b5f80$var$INVALID$2;
        var showZeros = opts.showZeros !== false;
        var l = $63618293c58b5f80$var$orderedUnits$1.map(function(unit) {
            var val = _this.values[unit];
            if ($63618293c58b5f80$var$isUndefined(val) || val === 0 && !showZeros) return null;
            return _this.loc.numberFormatter($63618293c58b5f80$var$_extends({
                style: "unit",
                unitDisplay: "long"
            }, opts, {
                unit: unit.slice(0, -1)
            })).format(val);
        }).filter(function(n) {
            return n;
        });
        return this.loc.listFormatter($63618293c58b5f80$var$_extends({
            type: "conjunction",
            style: opts.listStyle || "narrow"
        }, opts)).format(l);
    } /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */ ;
    _proto.toObject = function toObject() {
        if (!this.isValid) return {};
        return $63618293c58b5f80$var$_extends({}, this.values);
    } /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */ ;
    _proto.toISO = function toISO() {
        // we could use the formatter, but this is an easier way to get the minimum string
        if (!this.isValid) return null;
        var s = "P";
        if (this.years !== 0) s += this.years + "Y";
        if (this.months !== 0 || this.quarters !== 0) s += this.months + this.quarters * 3 + "M";
        if (this.weeks !== 0) s += this.weeks + "W";
        if (this.days !== 0) s += this.days + "D";
        if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) s += "T";
        if (this.hours !== 0) s += this.hours + "H";
        if (this.minutes !== 0) s += this.minutes + "M";
        if (this.seconds !== 0 || this.milliseconds !== 0) // this will handle "floating point madness" by removing extra decimal places
        // https://stackoverflow.com/questions/588004/is-floating-point-math-broken
        s += $63618293c58b5f80$var$roundTo(this.seconds + this.milliseconds / 1000, 3) + "S";
        if (s === "P") s += "T0S";
        return s;
    } /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */ ;
    _proto.toISOTime = function toISOTime(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return null;
        var millis = this.toMillis();
        if (millis < 0 || millis >= 86400000) return null;
        opts = $63618293c58b5f80$var$_extends({
            suppressMilliseconds: false,
            suppressSeconds: false,
            includePrefix: false,
            format: "extended"
        }, opts, {
            includeOffset: false
        });
        var dateTime = $63618293c58b5f80$var$DateTime.fromMillis(millis, {
            zone: "UTC"
        });
        return dateTime.toISOTime(opts);
    } /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */ ;
    _proto.toJSON = function toJSON() {
        return this.toISO();
    } /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */ ;
    _proto.toString = function toString() {
        return this.toISO();
    } /**
   * Returns a string representation of this Duration appropriate for the REPL.
   * @return {string}
   */ ;
    _proto[_Symbol$for] = function() {
        if (this.isValid) return "Duration { values: " + JSON.stringify(this.values) + " }";
        else return "Duration { Invalid, reason: " + this.invalidReason + " }";
    } /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */ ;
    _proto.toMillis = function toMillis() {
        if (!this.isValid) return NaN;
        return $63618293c58b5f80$var$durationToMillis(this.matrix, this.values);
    } /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */ ;
    _proto.valueOf = function valueOf() {
        return this.toMillis();
    } /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */ ;
    _proto.plus = function plus(duration) {
        if (!this.isValid) return this;
        var dur = Duration.fromDurationLike(duration), result = {};
        for(var _i2 = 0, _orderedUnits = $63618293c58b5f80$var$orderedUnits$1; _i2 < _orderedUnits.length; _i2++){
            var k = _orderedUnits[_i2];
            if ($63618293c58b5f80$var$hasOwnProperty(dur.values, k) || $63618293c58b5f80$var$hasOwnProperty(this.values, k)) result[k] = dur.get(k) + this.get(k);
        }
        return $63618293c58b5f80$var$clone$1(this, {
            values: result
        }, true);
    } /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */ ;
    _proto.minus = function minus(duration) {
        if (!this.isValid) return this;
        var dur = Duration.fromDurationLike(duration);
        return this.plus(dur.negate());
    } /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */ ;
    _proto.mapUnits = function mapUnits(fn) {
        if (!this.isValid) return this;
        var result = {};
        for(var _i3 = 0, _Object$keys = Object.keys(this.values); _i3 < _Object$keys.length; _i3++){
            var k = _Object$keys[_i3];
            result[k] = $63618293c58b5f80$var$asNumber(fn(this.values[k], k));
        }
        return $63618293c58b5f80$var$clone$1(this, {
            values: result
        }, true);
    } /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */ ;
    _proto.get = function get(unit) {
        return this[Duration.normalizeUnit(unit)];
    } /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */ ;
    _proto.set = function set(values) {
        if (!this.isValid) return this;
        var mixed = $63618293c58b5f80$var$_extends({}, this.values, $63618293c58b5f80$var$normalizeObject(values, Duration.normalizeUnit));
        return $63618293c58b5f80$var$clone$1(this, {
            values: mixed
        });
    } /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */ ;
    _proto.reconfigure = function reconfigure(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, locale = _ref.locale, numberingSystem = _ref.numberingSystem, conversionAccuracy = _ref.conversionAccuracy, matrix = _ref.matrix;
        var loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem
        });
        var opts = {
            loc: loc,
            matrix: matrix,
            conversionAccuracy: conversionAccuracy
        };
        return $63618293c58b5f80$var$clone$1(this, opts);
    } /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */ ;
    _proto.as = function as(unit) {
        return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
    } /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see third example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */ ;
    _proto.normalize = function normalize() {
        if (!this.isValid) return this;
        var vals = this.toObject();
        $63618293c58b5f80$var$normalizeValues(this.matrix, vals);
        return $63618293c58b5f80$var$clone$1(this, {
            values: vals
        }, true);
    } /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */ ;
    _proto.rescale = function rescale() {
        if (!this.isValid) return this;
        var vals = $63618293c58b5f80$var$removeZeroes(this.normalize().shiftToAll().toObject());
        return $63618293c58b5f80$var$clone$1(this, {
            values: vals
        }, true);
    } /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */ ;
    _proto.shiftTo = function shiftTo() {
        for(var _len = arguments.length, units = new Array(_len), _key = 0; _key < _len; _key++)units[_key] = arguments[_key];
        if (!this.isValid) return this;
        if (units.length === 0) return this;
        units = units.map(function(u) {
            return Duration.normalizeUnit(u);
        });
        var built = {}, accumulated = {}, vals = this.toObject();
        var lastUnit;
        for(var _i4 = 0, _orderedUnits2 = $63618293c58b5f80$var$orderedUnits$1; _i4 < _orderedUnits2.length; _i4++){
            var k = _orderedUnits2[_i4];
            if (units.indexOf(k) >= 0) {
                lastUnit = k;
                var own = 0;
                // anything we haven't boiled down yet should get boiled to this unit
                for(var ak in accumulated){
                    own += this.matrix[ak][k] * accumulated[ak];
                    accumulated[ak] = 0;
                }
                // plus anything that's already in this unit
                if ($63618293c58b5f80$var$isNumber(vals[k])) own += vals[k];
                // only keep the integer part for now in the hopes of putting any decimal part
                // into a smaller unit later
                var i = Math.trunc(own);
                built[k] = i;
                accumulated[k] = (own * 1000 - i * 1000) / 1000;
            // otherwise, keep it in the wings to boil it later
            } else if ($63618293c58b5f80$var$isNumber(vals[k])) accumulated[k] = vals[k];
        }
        // anything leftover becomes the decimal for the last unit
        // lastUnit must be defined since units is not empty
        for(var key in accumulated)if (accumulated[key] !== 0) built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
        $63618293c58b5f80$var$normalizeValues(this.matrix, built);
        return $63618293c58b5f80$var$clone$1(this, {
            values: built
        }, true);
    } /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */ ;
    _proto.shiftToAll = function shiftToAll() {
        if (!this.isValid) return this;
        return this.shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds");
    } /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */ ;
    _proto.negate = function negate() {
        if (!this.isValid) return this;
        var negated = {};
        for(var _i5 = 0, _Object$keys2 = Object.keys(this.values); _i5 < _Object$keys2.length; _i5++){
            var k = _Object$keys2[_i5];
            negated[k] = this.values[k] === 0 ? 0 : -this.values[k];
        }
        return $63618293c58b5f80$var$clone$1(this, {
            values: negated
        }, true);
    } /**
   * Removes all units with values equal to 0 from this Duration.
   * @example Duration.fromObject({ years: 2, days: 0, hours: 0, minutes: 0 }).removeZeros().toObject() //=> { years: 2 }
   * @return {Duration}
   */ ;
    _proto.removeZeros = function removeZeros() {
        if (!this.isValid) return this;
        var vals = $63618293c58b5f80$var$removeZeroes(this.values);
        return $63618293c58b5f80$var$clone$1(this, {
            values: vals
        }, true);
    } /**
   * Get the years.
   * @type {number}
   */ ;
    /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */ _proto.equals = function equals(other) {
        if (!this.isValid || !other.isValid) return false;
        if (!this.loc.equals(other.loc)) return false;
        function eq(v1, v2) {
            // Consider 0 and undefined as equal
            if (v1 === undefined || v1 === 0) return v2 === undefined || v2 === 0;
            return v1 === v2;
        }
        for(var _i6 = 0, _orderedUnits3 = $63618293c58b5f80$var$orderedUnits$1; _i6 < _orderedUnits3.length; _i6++){
            var u = _orderedUnits3[_i6];
            if (!eq(this.values[u], other.values[u])) return false;
        }
        return true;
    };
    $63618293c58b5f80$var$_createClass(Duration, [
        {
            key: "locale",
            get: function get() {
                return this.isValid ? this.loc.locale : null;
            }
        },
        {
            key: "numberingSystem",
            get: function get() {
                return this.isValid ? this.loc.numberingSystem : null;
            }
        },
        {
            key: "years",
            get: function get() {
                return this.isValid ? this.values.years || 0 : NaN;
            }
        },
        {
            key: "quarters",
            get: function get() {
                return this.isValid ? this.values.quarters || 0 : NaN;
            }
        },
        {
            key: "months",
            get: function get() {
                return this.isValid ? this.values.months || 0 : NaN;
            }
        },
        {
            key: "weeks",
            get: function get() {
                return this.isValid ? this.values.weeks || 0 : NaN;
            }
        },
        {
            key: "days",
            get: function get() {
                return this.isValid ? this.values.days || 0 : NaN;
            }
        },
        {
            key: "hours",
            get: function get() {
                return this.isValid ? this.values.hours || 0 : NaN;
            }
        },
        {
            key: "minutes",
            get: function get() {
                return this.isValid ? this.values.minutes || 0 : NaN;
            }
        },
        {
            key: "seconds",
            get: function get() {
                return this.isValid ? this.values.seconds || 0 : NaN;
            }
        },
        {
            key: "milliseconds",
            get: function get() {
                return this.isValid ? this.values.milliseconds || 0 : NaN;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.invalid === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        }
    ]);
    return Duration;
}(Symbol.for("nodejs.util.inspect.custom"));
var $63618293c58b5f80$var$INVALID$1 = "Invalid Interval";
// checks if the start is equal to or before the end
function $63618293c58b5f80$var$validateStartEnd(start, end) {
    if (!start || !start.isValid) return $63618293c58b5f80$var$Interval.invalid("missing or invalid start");
    else if (!end || !end.isValid) return $63618293c58b5f80$var$Interval.invalid("missing or invalid end");
    else if (end < start) return $63618293c58b5f80$var$Interval.invalid("end before start", "The end of an interval must be after its start, but you had start=" + start.toISO() + " and end=" + end.toISO());
    else return null;
}
/**
 * An Interval object represents a half-open interval of time, where each endpoint is a {@link DateTime}. Conceptually, it's a container for those two endpoints, accompanied by methods for creating, parsing, interrogating, comparing, transforming, and formatting them.
 *
 * Here is a brief overview of the most commonly used methods and getters in Interval:
 *
 * * **Creation** To create an Interval, use {@link Interval.fromDateTimes}, {@link Interval.after}, {@link Interval.before}, or {@link Interval.fromISO}.
 * * **Accessors** Use {@link Interval#start} and {@link Interval#end} to get the start and end.
 * * **Interrogation** To analyze the Interval, use {@link Interval#count}, {@link Interval#length}, {@link Interval#hasSame}, {@link Interval#contains}, {@link Interval#isAfter}, or {@link Interval#isBefore}.
 * * **Transformation** To create other Intervals out of this one, use {@link Interval#set}, {@link Interval#splitAt}, {@link Interval#splitBy}, {@link Interval#divideEqually}, {@link Interval.merge}, {@link Interval.xor}, {@link Interval#union}, {@link Interval#intersection}, or {@link Interval#difference}.
 * * **Comparison** To compare this Interval to another one, use {@link Interval#equals}, {@link Interval#overlaps}, {@link Interval#abutsStart}, {@link Interval#abutsEnd}, {@link Interval#engulfs}
 * * **Output** To convert the Interval into other representations, see {@link Interval#toString}, {@link Interval#toLocaleString}, {@link Interval#toISO}, {@link Interval#toISODate}, {@link Interval#toISOTime}, {@link Interval#toFormat}, and {@link Interval#toDuration}.
 */ var $63618293c58b5f80$var$Interval = /*#__PURE__*/ function(_Symbol$for) {
    /**
   * @private
   */ function Interval(config) {
        /**
     * @access private
     */ this.s = config.start;
        /**
     * @access private
     */ this.e = config.end;
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.isLuxonInterval = true;
    }
    /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */ Interval.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $63618293c58b5f80$var$InvalidArgumentError("need to specify a reason the Interval is invalid");
        var invalid = reason instanceof $63618293c58b5f80$var$Invalid ? reason : new $63618293c58b5f80$var$Invalid(reason, explanation);
        if ($63618293c58b5f80$var$Settings.throwOnInvalid) throw new $63618293c58b5f80$var$InvalidIntervalError(invalid);
        else return new Interval({
            invalid: invalid
        });
    } /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */ ;
    Interval.fromDateTimes = function fromDateTimes(start, end) {
        var builtStart = $63618293c58b5f80$var$friendlyDateTime(start), builtEnd = $63618293c58b5f80$var$friendlyDateTime(end);
        var validateError = $63618293c58b5f80$var$validateStartEnd(builtStart, builtEnd);
        if (validateError == null) return new Interval({
            start: builtStart,
            end: builtEnd
        });
        else return validateError;
    } /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */ ;
    Interval.after = function after(start, duration) {
        var dur = $63618293c58b5f80$var$Duration.fromDurationLike(duration), dt = $63618293c58b5f80$var$friendlyDateTime(start);
        return Interval.fromDateTimes(dt, dt.plus(dur));
    } /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */ ;
    Interval.before = function before(end, duration) {
        var dur = $63618293c58b5f80$var$Duration.fromDurationLike(duration), dt = $63618293c58b5f80$var$friendlyDateTime(end);
        return Interval.fromDateTimes(dt.minus(dur), dt);
    } /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */ ;
    Interval.fromISO = function fromISO(text, opts) {
        var _split = (text || "").split("/", 2), s = _split[0], e = _split[1];
        if (s && e) {
            var start, startIsValid;
            try {
                start = $63618293c58b5f80$var$DateTime.fromISO(s, opts);
                startIsValid = start.isValid;
            } catch (e) {
                startIsValid = false;
            }
            var end, endIsValid;
            try {
                end = $63618293c58b5f80$var$DateTime.fromISO(e, opts);
                endIsValid = end.isValid;
            } catch (e) {
                endIsValid = false;
            }
            if (startIsValid && endIsValid) return Interval.fromDateTimes(start, end);
            if (startIsValid) {
                var dur = $63618293c58b5f80$var$Duration.fromISO(e, opts);
                if (dur.isValid) return Interval.after(start, dur);
            } else if (endIsValid) {
                var _dur = $63618293c58b5f80$var$Duration.fromISO(s, opts);
                if (_dur.isValid) return Interval.before(end, _dur);
            }
        }
        return Interval.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    } /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ ;
    Interval.isInterval = function isInterval(o) {
        return o && o.isLuxonInterval || false;
    } /**
   * Returns the start of the Interval
   * @type {DateTime}
   */ ;
    var _proto = Interval.prototype;
    /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */ _proto.length = function length(unit) {
        if (unit === void 0) unit = "milliseconds";
        return this.isValid ? this.toDuration.apply(this, [
            unit
        ]).get(unit) : NaN;
    } /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; this operation will always use the locale of the start DateTime
   * @return {number}
   */ ;
    _proto.count = function count(unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (!this.isValid) return NaN;
        var start = this.start.startOf(unit, opts);
        var end;
        if (opts != null && opts.useLocaleWeeks) end = this.end.reconfigure({
            locale: start.locale
        });
        else end = this.end;
        end = end.startOf(unit, opts);
        return Math.floor(end.diff(start, unit).get(unit)) + (end.valueOf() !== this.end.valueOf());
    } /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */ ;
    _proto.hasSame = function hasSame(unit) {
        return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
    } /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */ ;
    _proto.isEmpty = function isEmpty() {
        return this.s.valueOf() === this.e.valueOf();
    } /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ ;
    _proto.isAfter = function isAfter(dateTime) {
        if (!this.isValid) return false;
        return this.s > dateTime;
    } /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ ;
    _proto.isBefore = function isBefore(dateTime) {
        if (!this.isValid) return false;
        return this.e <= dateTime;
    } /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ ;
    _proto.contains = function contains(dateTime) {
        if (!this.isValid) return false;
        return this.s <= dateTime && this.e > dateTime;
    } /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */ ;
    _proto.set = function set(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, start = _ref.start, end = _ref.end;
        if (!this.isValid) return this;
        return Interval.fromDateTimes(start || this.s, end || this.e);
    } /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */ ;
    _proto.splitAt = function splitAt() {
        var _this = this;
        if (!this.isValid) return [];
        for(var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++)dateTimes[_key] = arguments[_key];
        var sorted = dateTimes.map($63618293c58b5f80$var$friendlyDateTime).filter(function(d) {
            return _this.contains(d);
        }).sort(function(a, b) {
            return a.toMillis() - b.toMillis();
        }), results = [];
        var s = this.s, i = 0;
        while(s < this.e){
            var added = sorted[i] || this.e, next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            i += 1;
        }
        return results;
    } /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */ ;
    _proto.splitBy = function splitBy(duration) {
        var dur = $63618293c58b5f80$var$Duration.fromDurationLike(duration);
        if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) return [];
        var s = this.s, idx = 1, next;
        var results = [];
        while(s < this.e){
            var added = this.start.plus(dur.mapUnits(function(x) {
                return x * idx;
            }));
            next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            idx += 1;
        }
        return results;
    } /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */ ;
    _proto.divideEqually = function divideEqually(numberOfParts) {
        if (!this.isValid) return [];
        return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
    } /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.overlaps = function overlaps(other) {
        return this.e > other.s && this.s < other.e;
    } /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.abutsStart = function abutsStart(other) {
        if (!this.isValid) return false;
        return +this.e === +other.s;
    } /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.abutsEnd = function abutsEnd(other) {
        if (!this.isValid) return false;
        return +other.e === +this.s;
    } /**
   * Returns true if this Interval fully contains the specified Interval, specifically if the intersect (of this Interval and the other Interval) is equal to the other Interval; false otherwise.
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.engulfs = function engulfs(other) {
        if (!this.isValid) return false;
        return this.s <= other.s && this.e >= other.e;
    } /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.equals = function equals(other) {
        if (!this.isValid || !other.isValid) return false;
        return this.s.equals(other.s) && this.e.equals(other.e);
    } /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */ ;
    _proto.intersection = function intersection(other) {
        if (!this.isValid) return this;
        var s = this.s > other.s ? this.s : other.s, e = this.e < other.e ? this.e : other.e;
        if (s >= e) return null;
        else return Interval.fromDateTimes(s, e);
    } /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */ ;
    _proto.union = function union(other) {
        if (!this.isValid) return this;
        var s = this.s < other.s ? this.s : other.s, e = this.e > other.e ? this.e : other.e;
        return Interval.fromDateTimes(s, e);
    } /**
   * Merge an array of Intervals into an equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * The resulting array will contain the Intervals in ascending order, that is, starting with the earliest Interval
   * and ending with the latest.
   *
   * @param {Array} intervals
   * @return {Array}
   */ ;
    Interval.merge = function merge(intervals) {
        var _intervals$sort$reduc = intervals.sort(function(a, b) {
            return a.s - b.s;
        }).reduce(function(_ref2, item) {
            var sofar = _ref2[0], current = _ref2[1];
            if (!current) return [
                sofar,
                item
            ];
            else if (current.overlaps(item) || current.abutsStart(item)) return [
                sofar,
                current.union(item)
            ];
            else return [
                sofar.concat([
                    current
                ]),
                item
            ];
        }, [
            [],
            null
        ]), found = _intervals$sort$reduc[0], final = _intervals$sort$reduc[1];
        if (final) found.push(final);
        return found;
    } /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */ ;
    Interval.xor = function xor(intervals) {
        var _Array$prototype;
        var start = null, currentCount = 0;
        var results = [], ends = intervals.map(function(i) {
            return [
                {
                    time: i.s,
                    type: "s"
                },
                {
                    time: i.e,
                    type: "e"
                }
            ];
        }), flattened = (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, ends), arr = flattened.sort(function(a, b) {
            return a.time - b.time;
        });
        for(var _iterator = $63618293c58b5f80$var$_createForOfIteratorHelperLoose(arr), _step; !(_step = _iterator()).done;){
            var i = _step.value;
            currentCount += i.type === "s" ? 1 : -1;
            if (currentCount === 1) start = i.time;
            else {
                if (start && +start !== +i.time) results.push(Interval.fromDateTimes(start, i.time));
                start = null;
            }
        }
        return Interval.merge(results);
    } /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */ ;
    _proto.difference = function difference() {
        var _this2 = this;
        for(var _len2 = arguments.length, intervals = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)intervals[_key2] = arguments[_key2];
        return Interval.xor([
            this
        ].concat(intervals)).map(function(i) {
            return _this2.intersection(i);
        }).filter(function(i) {
            return i && !i.isEmpty();
        });
    } /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */ ;
    _proto.toString = function toString() {
        if (!this.isValid) return $63618293c58b5f80$var$INVALID$1;
        return "[" + this.s.toISO() + " \u2013 " + this.e.toISO() + ")";
    } /**
   * Returns a string representation of this Interval appropriate for the REPL.
   * @return {string}
   */ ;
    _proto[_Symbol$for] = function() {
        if (this.isValid) return "Interval { start: " + this.s.toISO() + ", end: " + this.e.toISO() + " }";
        else return "Interval { Invalid, reason: " + this.invalidReason + " }";
    } /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */ ;
    _proto.toLocaleString = function toLocaleString(formatOpts, opts) {
        if (formatOpts === void 0) formatOpts = $63618293c58b5f80$var$DATE_SHORT;
        if (opts === void 0) opts = {};
        return this.isValid ? $63618293c58b5f80$var$Formatter.create(this.s.loc.clone(opts), formatOpts).formatInterval(this) : $63618293c58b5f80$var$INVALID$1;
    } /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */ ;
    _proto.toISO = function toISO(opts) {
        if (!this.isValid) return $63618293c58b5f80$var$INVALID$1;
        return this.s.toISO(opts) + "/" + this.e.toISO(opts);
    } /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */ ;
    _proto.toISODate = function toISODate() {
        if (!this.isValid) return $63618293c58b5f80$var$INVALID$1;
        return this.s.toISODate() + "/" + this.e.toISODate();
    } /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */ ;
    _proto.toISOTime = function toISOTime(opts) {
        if (!this.isValid) return $63618293c58b5f80$var$INVALID$1;
        return this.s.toISOTime(opts) + "/" + this.e.toISOTime(opts);
    } /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */ ;
    _proto.toFormat = function toFormat(dateFormat, _temp2) {
        var _ref3 = _temp2 === void 0 ? {} : _temp2, _ref3$separator = _ref3.separator, separator = _ref3$separator === void 0 ? " \u2013 " : _ref3$separator;
        if (!this.isValid) return $63618293c58b5f80$var$INVALID$1;
        return "" + this.s.toFormat(dateFormat) + separator + this.e.toFormat(dateFormat);
    } /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */ ;
    _proto.toDuration = function toDuration(unit, opts) {
        if (!this.isValid) return $63618293c58b5f80$var$Duration.invalid(this.invalidReason);
        return this.e.diff(this.s, unit, opts);
    } /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */ ;
    _proto.mapEndpoints = function mapEndpoints(mapFn) {
        return Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
    };
    $63618293c58b5f80$var$_createClass(Interval, [
        {
            key: "start",
            get: function get() {
                return this.isValid ? this.s : null;
            }
        },
        {
            key: "end",
            get: function get() {
                return this.isValid ? this.e : null;
            }
        },
        {
            key: "lastDateTime",
            get: function get() {
                return this.isValid ? this.e ? this.e.minus(1) : null : null;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.invalidReason === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        }
    ]);
    return Interval;
}(Symbol.for("nodejs.util.inspect.custom"));
/**
 * The Info class contains static methods for retrieving general time and date related data. For example, it has methods for finding out if a time zone has a DST, for listing the months in any supported locale, and for discovering which of Luxon features are available in the current environment.
 */ var $63618293c58b5f80$var$Info = /*#__PURE__*/ function() {
    function Info() {}
    /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */ Info.hasDST = function hasDST(zone) {
        if (zone === void 0) zone = $63618293c58b5f80$var$Settings.defaultZone;
        var proto = $63618293c58b5f80$var$DateTime.now().setZone(zone).set({
            month: 12
        });
        return !zone.isUniversal && proto.offset !== proto.set({
            month: 6
        }).offset;
    } /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */ ;
    Info.isValidIANAZone = function isValidIANAZone(zone) {
        return $63618293c58b5f80$var$IANAZone.isValidZone(zone);
    } /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */ ;
    Info.normalizeZone = function normalizeZone$1(input) {
        return $63618293c58b5f80$var$normalizeZone(input, $63618293c58b5f80$var$Settings.defaultZone);
    } /**
   * Get the weekday on which the week starts according to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number} the start of the week, 1 for Monday through 7 for Sunday
   */ ;
    Info.getStartOfWeek = function getStartOfWeek(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, _ref$locale = _ref.locale, locale = _ref$locale === void 0 ? null : _ref$locale, _ref$locObj = _ref.locObj, locObj = _ref$locObj === void 0 ? null : _ref$locObj;
        return (locObj || $63618293c58b5f80$var$Locale.create(locale)).getStartOfWeek();
    } /**
   * Get the minimum number of days necessary in a week before it is considered part of the next year according
   * to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number}
   */ ;
    Info.getMinimumDaysInFirstWeek = function getMinimumDaysInFirstWeek(_temp2) {
        var _ref2 = _temp2 === void 0 ? {} : _temp2, _ref2$locale = _ref2.locale, locale = _ref2$locale === void 0 ? null : _ref2$locale, _ref2$locObj = _ref2.locObj, locObj = _ref2$locObj === void 0 ? null : _ref2$locObj;
        return (locObj || $63618293c58b5f80$var$Locale.create(locale)).getMinDaysInFirstWeek();
    } /**
   * Get the weekdays, which are considered the weekend according to the given locale
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number[]} an array of weekdays, 1 for Monday through 7 for Sunday
   */ ;
    Info.getWeekendWeekdays = function getWeekendWeekdays(_temp3) {
        var _ref3 = _temp3 === void 0 ? {} : _temp3, _ref3$locale = _ref3.locale, locale = _ref3$locale === void 0 ? null : _ref3$locale, _ref3$locObj = _ref3.locObj, locObj = _ref3$locObj === void 0 ? null : _ref3$locObj;
        // copy the array, because we cache it internally
        return (locObj || $63618293c58b5f80$var$Locale.create(locale)).getWeekendDays().slice();
    } /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */ ;
    Info.months = function months(length, _temp4) {
        if (length === void 0) length = "long";
        var _ref4 = _temp4 === void 0 ? {} : _temp4, _ref4$locale = _ref4.locale, locale = _ref4$locale === void 0 ? null : _ref4$locale, _ref4$numberingSystem = _ref4.numberingSystem, numberingSystem = _ref4$numberingSystem === void 0 ? null : _ref4$numberingSystem, _ref4$locObj = _ref4.locObj, locObj = _ref4$locObj === void 0 ? null : _ref4$locObj, _ref4$outputCalendar = _ref4.outputCalendar, outputCalendar = _ref4$outputCalendar === void 0 ? "gregory" : _ref4$outputCalendar;
        return (locObj || $63618293c58b5f80$var$Locale.create(locale, numberingSystem, outputCalendar)).months(length);
    } /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */ ;
    Info.monthsFormat = function monthsFormat(length, _temp5) {
        if (length === void 0) length = "long";
        var _ref5 = _temp5 === void 0 ? {} : _temp5, _ref5$locale = _ref5.locale, locale = _ref5$locale === void 0 ? null : _ref5$locale, _ref5$numberingSystem = _ref5.numberingSystem, numberingSystem = _ref5$numberingSystem === void 0 ? null : _ref5$numberingSystem, _ref5$locObj = _ref5.locObj, locObj = _ref5$locObj === void 0 ? null : _ref5$locObj, _ref5$outputCalendar = _ref5.outputCalendar, outputCalendar = _ref5$outputCalendar === void 0 ? "gregory" : _ref5$outputCalendar;
        return (locObj || $63618293c58b5f80$var$Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
    } /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */ ;
    Info.weekdays = function weekdays(length, _temp6) {
        if (length === void 0) length = "long";
        var _ref6 = _temp6 === void 0 ? {} : _temp6, _ref6$locale = _ref6.locale, locale = _ref6$locale === void 0 ? null : _ref6$locale, _ref6$numberingSystem = _ref6.numberingSystem, numberingSystem = _ref6$numberingSystem === void 0 ? null : _ref6$numberingSystem, _ref6$locObj = _ref6.locObj, locObj = _ref6$locObj === void 0 ? null : _ref6$locObj;
        return (locObj || $63618293c58b5f80$var$Locale.create(locale, numberingSystem, null)).weekdays(length);
    } /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */ ;
    Info.weekdaysFormat = function weekdaysFormat(length, _temp7) {
        if (length === void 0) length = "long";
        var _ref7 = _temp7 === void 0 ? {} : _temp7, _ref7$locale = _ref7.locale, locale = _ref7$locale === void 0 ? null : _ref7$locale, _ref7$numberingSystem = _ref7.numberingSystem, numberingSystem = _ref7$numberingSystem === void 0 ? null : _ref7$numberingSystem, _ref7$locObj = _ref7.locObj, locObj = _ref7$locObj === void 0 ? null : _ref7$locObj;
        return (locObj || $63618293c58b5f80$var$Locale.create(locale, numberingSystem, null)).weekdays(length, true);
    } /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */ ;
    Info.meridiems = function meridiems(_temp8) {
        var _ref8 = _temp8 === void 0 ? {} : _temp8, _ref8$locale = _ref8.locale, locale = _ref8$locale === void 0 ? null : _ref8$locale;
        return $63618293c58b5f80$var$Locale.create(locale).meridiems();
    } /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */ ;
    Info.eras = function eras(length, _temp9) {
        if (length === void 0) length = "short";
        var _ref9 = _temp9 === void 0 ? {} : _temp9, _ref9$locale = _ref9.locale, locale = _ref9$locale === void 0 ? null : _ref9$locale;
        return $63618293c58b5f80$var$Locale.create(locale, null, "gregory").eras(length);
    } /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * * `localeWeek`: whether this environment supports different weekdays for the start of the week based on the locale
   * @example Info.features() //=> { relative: false, localeWeek: true }
   * @return {Object}
   */ ;
    Info.features = function features() {
        return {
            relative: $63618293c58b5f80$var$hasRelative(),
            localeWeek: $63618293c58b5f80$var$hasLocaleWeekInfo()
        };
    };
    return Info;
}();
function $63618293c58b5f80$var$dayDiff(earlier, later) {
    var utcDayStart = function utcDayStart(dt) {
        return dt.toUTC(0, {
            keepLocalTime: true
        }).startOf("day").valueOf();
    }, ms = utcDayStart(later) - utcDayStart(earlier);
    return Math.floor($63618293c58b5f80$var$Duration.fromMillis(ms).as("days"));
}
function $63618293c58b5f80$var$highOrderDiffs(cursor, later, units) {
    var differs = [
        [
            "years",
            function(a, b) {
                return b.year - a.year;
            }
        ],
        [
            "quarters",
            function(a, b) {
                return b.quarter - a.quarter + (b.year - a.year) * 4;
            }
        ],
        [
            "months",
            function(a, b) {
                return b.month - a.month + (b.year - a.year) * 12;
            }
        ],
        [
            "weeks",
            function(a, b) {
                var days = $63618293c58b5f80$var$dayDiff(a, b);
                return (days - days % 7) / 7;
            }
        ],
        [
            "days",
            $63618293c58b5f80$var$dayDiff
        ]
    ];
    var results = {};
    var earlier = cursor;
    var lowestOrder, highWater;
    /* This loop tries to diff using larger units first.
     If we overshoot, we backtrack and try the next smaller unit.
     "cursor" starts out at the earlier timestamp and moves closer and closer to "later"
     as we use smaller and smaller units.
     highWater keeps track of where we would be if we added one more of the smallest unit,
     this is used later to potentially convert any difference smaller than the smallest higher order unit
     into a fraction of that smallest higher order unit
  */ for(var _i = 0, _differs = differs; _i < _differs.length; _i++){
        var _differs$_i = _differs[_i], unit = _differs$_i[0], differ = _differs$_i[1];
        if (units.indexOf(unit) >= 0) {
            lowestOrder = unit;
            results[unit] = differ(cursor, later);
            highWater = earlier.plus(results);
            if (highWater > later) {
                // we overshot the end point, backtrack cursor by 1
                results[unit]--;
                cursor = earlier.plus(results);
                // if we are still overshooting now, we need to backtrack again
                // this happens in certain situations when diffing times in different zones,
                // because this calculation ignores time zones
                if (cursor > later) {
                    // keep the "overshot by 1" around as highWater
                    highWater = cursor;
                    // backtrack cursor by 1
                    results[unit]--;
                    cursor = earlier.plus(results);
                }
            } else cursor = highWater;
        }
    }
    return [
        cursor,
        results,
        highWater,
        lowestOrder
    ];
}
function $63618293c58b5f80$var$_diff(earlier, later, units, opts) {
    var _highOrderDiffs = $63618293c58b5f80$var$highOrderDiffs(earlier, later, units), cursor = _highOrderDiffs[0], results = _highOrderDiffs[1], highWater = _highOrderDiffs[2], lowestOrder = _highOrderDiffs[3];
    var remainingMillis = later - cursor;
    var lowerOrderUnits = units.filter(function(u) {
        return [
            "hours",
            "minutes",
            "seconds",
            "milliseconds"
        ].indexOf(u) >= 0;
    });
    if (lowerOrderUnits.length === 0) {
        if (highWater < later) {
            var _cursor$plus;
            highWater = cursor.plus((_cursor$plus = {}, _cursor$plus[lowestOrder] = 1, _cursor$plus));
        }
        if (highWater !== cursor) results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
    var duration = $63618293c58b5f80$var$Duration.fromObject(results, opts);
    if (lowerOrderUnits.length > 0) {
        var _Duration$fromMillis;
        return (_Duration$fromMillis = $63618293c58b5f80$var$Duration.fromMillis(remainingMillis, opts)).shiftTo.apply(_Duration$fromMillis, lowerOrderUnits).plus(duration);
    } else return duration;
}
var $63618293c58b5f80$var$MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
function $63618293c58b5f80$var$intUnit(regex, post) {
    if (post === void 0) post = function post(i) {
        return i;
    };
    return {
        regex: regex,
        deser: function deser(_ref) {
            var s = _ref[0];
            return post($63618293c58b5f80$var$parseDigits(s));
        }
    };
}
var $63618293c58b5f80$var$NBSP = String.fromCharCode(160);
var $63618293c58b5f80$var$spaceOrNBSP = "[ " + $63618293c58b5f80$var$NBSP + "]";
var $63618293c58b5f80$var$spaceOrNBSPRegExp = new RegExp($63618293c58b5f80$var$spaceOrNBSP, "g");
function $63618293c58b5f80$var$fixListRegex(s) {
    // make dots optional and also make them literal
    // make space and non breakable space characters interchangeable
    return s.replace(/\./g, "\\.?").replace($63618293c58b5f80$var$spaceOrNBSPRegExp, $63618293c58b5f80$var$spaceOrNBSP);
}
function $63618293c58b5f80$var$stripInsensitivities(s) {
    return s.replace(/\./g, "") // ignore dots that were made optional
    .replace($63618293c58b5f80$var$spaceOrNBSPRegExp, " ") // interchange space and nbsp
    .toLowerCase();
}
function $63618293c58b5f80$var$oneOf(strings, startIndex) {
    if (strings === null) return null;
    else return {
        regex: RegExp(strings.map($63618293c58b5f80$var$fixListRegex).join("|")),
        deser: function deser(_ref2) {
            var s = _ref2[0];
            return strings.findIndex(function(i) {
                return $63618293c58b5f80$var$stripInsensitivities(s) === $63618293c58b5f80$var$stripInsensitivities(i);
            }) + startIndex;
        }
    };
}
function $63618293c58b5f80$var$offset(regex, groups) {
    return {
        regex: regex,
        deser: function deser(_ref3) {
            var h = _ref3[1], m = _ref3[2];
            return $63618293c58b5f80$var$signedOffset(h, m);
        },
        groups: groups
    };
}
function $63618293c58b5f80$var$simple(regex) {
    return {
        regex: regex,
        deser: function deser(_ref4) {
            var s = _ref4[0];
            return s;
        }
    };
}
function $63618293c58b5f80$var$escapeToken(value) {
    return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
/**
 * @param token
 * @param {Locale} loc
 */ function $63618293c58b5f80$var$unitForToken(token, loc) {
    var one = $63618293c58b5f80$var$digitRegex(loc), two = $63618293c58b5f80$var$digitRegex(loc, "{2}"), three = $63618293c58b5f80$var$digitRegex(loc, "{3}"), four = $63618293c58b5f80$var$digitRegex(loc, "{4}"), six = $63618293c58b5f80$var$digitRegex(loc, "{6}"), oneOrTwo = $63618293c58b5f80$var$digitRegex(loc, "{1,2}"), oneToThree = $63618293c58b5f80$var$digitRegex(loc, "{1,3}"), oneToSix = $63618293c58b5f80$var$digitRegex(loc, "{1,6}"), oneToNine = $63618293c58b5f80$var$digitRegex(loc, "{1,9}"), twoToFour = $63618293c58b5f80$var$digitRegex(loc, "{2,4}"), fourToSix = $63618293c58b5f80$var$digitRegex(loc, "{4,6}"), literal = function literal(t) {
        return {
            regex: RegExp($63618293c58b5f80$var$escapeToken(t.val)),
            deser: function deser(_ref5) {
                var s = _ref5[0];
                return s;
            },
            literal: true
        };
    }, unitate = function unitate(t) {
        if (token.literal) return literal(t);
        switch(t.val){
            // era
            case "G":
                return $63618293c58b5f80$var$oneOf(loc.eras("short"), 0);
            case "GG":
                return $63618293c58b5f80$var$oneOf(loc.eras("long"), 0);
            // years
            case "y":
                return $63618293c58b5f80$var$intUnit(oneToSix);
            case "yy":
                return $63618293c58b5f80$var$intUnit(twoToFour, $63618293c58b5f80$var$untruncateYear);
            case "yyyy":
                return $63618293c58b5f80$var$intUnit(four);
            case "yyyyy":
                return $63618293c58b5f80$var$intUnit(fourToSix);
            case "yyyyyy":
                return $63618293c58b5f80$var$intUnit(six);
            // months
            case "M":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "MM":
                return $63618293c58b5f80$var$intUnit(two);
            case "MMM":
                return $63618293c58b5f80$var$oneOf(loc.months("short", true), 1);
            case "MMMM":
                return $63618293c58b5f80$var$oneOf(loc.months("long", true), 1);
            case "L":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "LL":
                return $63618293c58b5f80$var$intUnit(two);
            case "LLL":
                return $63618293c58b5f80$var$oneOf(loc.months("short", false), 1);
            case "LLLL":
                return $63618293c58b5f80$var$oneOf(loc.months("long", false), 1);
            // dates
            case "d":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "dd":
                return $63618293c58b5f80$var$intUnit(two);
            // ordinals
            case "o":
                return $63618293c58b5f80$var$intUnit(oneToThree);
            case "ooo":
                return $63618293c58b5f80$var$intUnit(three);
            // time
            case "HH":
                return $63618293c58b5f80$var$intUnit(two);
            case "H":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "hh":
                return $63618293c58b5f80$var$intUnit(two);
            case "h":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "mm":
                return $63618293c58b5f80$var$intUnit(two);
            case "m":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "q":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "qq":
                return $63618293c58b5f80$var$intUnit(two);
            case "s":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "ss":
                return $63618293c58b5f80$var$intUnit(two);
            case "S":
                return $63618293c58b5f80$var$intUnit(oneToThree);
            case "SSS":
                return $63618293c58b5f80$var$intUnit(three);
            case "u":
                return $63618293c58b5f80$var$simple(oneToNine);
            case "uu":
                return $63618293c58b5f80$var$simple(oneOrTwo);
            case "uuu":
                return $63618293c58b5f80$var$intUnit(one);
            // meridiem
            case "a":
                return $63618293c58b5f80$var$oneOf(loc.meridiems(), 0);
            // weekYear (k)
            case "kkkk":
                return $63618293c58b5f80$var$intUnit(four);
            case "kk":
                return $63618293c58b5f80$var$intUnit(twoToFour, $63618293c58b5f80$var$untruncateYear);
            // weekNumber (W)
            case "W":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "WW":
                return $63618293c58b5f80$var$intUnit(two);
            // weekdays
            case "E":
            case "c":
                return $63618293c58b5f80$var$intUnit(one);
            case "EEE":
                return $63618293c58b5f80$var$oneOf(loc.weekdays("short", false), 1);
            case "EEEE":
                return $63618293c58b5f80$var$oneOf(loc.weekdays("long", false), 1);
            case "ccc":
                return $63618293c58b5f80$var$oneOf(loc.weekdays("short", true), 1);
            case "cccc":
                return $63618293c58b5f80$var$oneOf(loc.weekdays("long", true), 1);
            // offset/zone
            case "Z":
            case "ZZ":
                return $63618293c58b5f80$var$offset(new RegExp("([+-]" + oneOrTwo.source + ")(?::(" + two.source + "))?"), 2);
            case "ZZZ":
                return $63618293c58b5f80$var$offset(new RegExp("([+-]" + oneOrTwo.source + ")(" + two.source + ")?"), 2);
            // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
            // because we don't have any way to figure out what they are
            case "z":
                return $63618293c58b5f80$var$simple(/[a-z_+-/]{1,256}?/i);
            // this special-case "token" represents a place where a macro-token expanded into a white-space literal
            // in this case we accept any non-newline white-space
            case " ":
                return $63618293c58b5f80$var$simple(/[^\S\n\r]/);
            default:
                return literal(t);
        }
    };
    var unit = unitate(token) || {
        invalidReason: $63618293c58b5f80$var$MISSING_FTP
    };
    unit.token = token;
    return unit;
}
var $63618293c58b5f80$var$partTypeStyleToTokenVal = {
    year: {
        "2-digit": "yy",
        numeric: "yyyyy"
    },
    month: {
        numeric: "M",
        "2-digit": "MM",
        short: "MMM",
        long: "MMMM"
    },
    day: {
        numeric: "d",
        "2-digit": "dd"
    },
    weekday: {
        short: "EEE",
        long: "EEEE"
    },
    dayperiod: "a",
    dayPeriod: "a",
    hour12: {
        numeric: "h",
        "2-digit": "hh"
    },
    hour24: {
        numeric: "H",
        "2-digit": "HH"
    },
    minute: {
        numeric: "m",
        "2-digit": "mm"
    },
    second: {
        numeric: "s",
        "2-digit": "ss"
    },
    timeZoneName: {
        long: "ZZZZZ",
        short: "ZZZ"
    }
};
function $63618293c58b5f80$var$tokenForPart(part, formatOpts, resolvedOpts) {
    var type = part.type, value = part.value;
    if (type === "literal") {
        var isSpace = /^\s+$/.test(value);
        return {
            literal: !isSpace,
            val: isSpace ? " " : value
        };
    }
    var style = formatOpts[type];
    // The user might have explicitly specified hour12 or hourCycle
    // if so, respect their decision
    // if not, refer back to the resolvedOpts, which are based on the locale
    var actualType = type;
    if (type === "hour") {
        if (formatOpts.hour12 != null) actualType = formatOpts.hour12 ? "hour12" : "hour24";
        else if (formatOpts.hourCycle != null) {
            if (formatOpts.hourCycle === "h11" || formatOpts.hourCycle === "h12") actualType = "hour12";
            else actualType = "hour24";
        } else // tokens only differentiate between 24 hours or not,
        // so we do not need to check hourCycle here, which is less supported anyways
        actualType = resolvedOpts.hour12 ? "hour12" : "hour24";
    }
    var val = $63618293c58b5f80$var$partTypeStyleToTokenVal[actualType];
    if (typeof val === "object") val = val[style];
    if (val) return {
        literal: false,
        val: val
    };
    return undefined;
}
function $63618293c58b5f80$var$buildRegex(units) {
    var re = units.map(function(u) {
        return u.regex;
    }).reduce(function(f, r) {
        return f + "(" + r.source + ")";
    }, "");
    return [
        "^" + re + "$",
        units
    ];
}
function $63618293c58b5f80$var$match(input, regex, handlers) {
    var matches = input.match(regex);
    if (matches) {
        var all = {};
        var matchIndex = 1;
        for(var i in handlers)if ($63618293c58b5f80$var$hasOwnProperty(handlers, i)) {
            var h = handlers[i], groups = h.groups ? h.groups + 1 : 1;
            if (!h.literal && h.token) all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
            matchIndex += groups;
        }
        return [
            matches,
            all
        ];
    } else return [
        matches,
        {}
    ];
}
function $63618293c58b5f80$var$dateTimeFromMatches(matches) {
    var toField = function toField(token) {
        switch(token){
            case "S":
                return "millisecond";
            case "s":
                return "second";
            case "m":
                return "minute";
            case "h":
            case "H":
                return "hour";
            case "d":
                return "day";
            case "o":
                return "ordinal";
            case "L":
            case "M":
                return "month";
            case "y":
                return "year";
            case "E":
            case "c":
                return "weekday";
            case "W":
                return "weekNumber";
            case "k":
                return "weekYear";
            case "q":
                return "quarter";
            default:
                return null;
        }
    };
    var zone = null;
    var specificOffset;
    if (!$63618293c58b5f80$var$isUndefined(matches.z)) zone = $63618293c58b5f80$var$IANAZone.create(matches.z);
    if (!$63618293c58b5f80$var$isUndefined(matches.Z)) {
        if (!zone) zone = new $63618293c58b5f80$var$FixedOffsetZone(matches.Z);
        specificOffset = matches.Z;
    }
    if (!$63618293c58b5f80$var$isUndefined(matches.q)) matches.M = (matches.q - 1) * 3 + 1;
    if (!$63618293c58b5f80$var$isUndefined(matches.h)) {
        if (matches.h < 12 && matches.a === 1) matches.h += 12;
        else if (matches.h === 12 && matches.a === 0) matches.h = 0;
    }
    if (matches.G === 0 && matches.y) matches.y = -matches.y;
    if (!$63618293c58b5f80$var$isUndefined(matches.u)) matches.S = $63618293c58b5f80$var$parseMillis(matches.u);
    var vals = Object.keys(matches).reduce(function(r, k) {
        var f = toField(k);
        if (f) r[f] = matches[k];
        return r;
    }, {});
    return [
        vals,
        zone,
        specificOffset
    ];
}
var $63618293c58b5f80$var$dummyDateTimeCache = null;
function $63618293c58b5f80$var$getDummyDateTime() {
    if (!$63618293c58b5f80$var$dummyDateTimeCache) $63618293c58b5f80$var$dummyDateTimeCache = $63618293c58b5f80$var$DateTime.fromMillis(1555555555555);
    return $63618293c58b5f80$var$dummyDateTimeCache;
}
function $63618293c58b5f80$var$maybeExpandMacroToken(token, locale) {
    if (token.literal) return token;
    var formatOpts = $63618293c58b5f80$var$Formatter.macroTokenToFormatOpts(token.val);
    var tokens = $63618293c58b5f80$var$formatOptsToTokens(formatOpts, locale);
    if (tokens == null || tokens.includes(undefined)) return token;
    return tokens;
}
function $63618293c58b5f80$var$expandMacroTokens(tokens, locale) {
    var _Array$prototype;
    return (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, tokens.map(function(t) {
        return $63618293c58b5f80$var$maybeExpandMacroToken(t, locale);
    }));
}
/**
 * @private
 */ var $63618293c58b5f80$var$TokenParser = /*#__PURE__*/ function() {
    function TokenParser(locale, format) {
        this.locale = locale;
        this.format = format;
        this.tokens = $63618293c58b5f80$var$expandMacroTokens($63618293c58b5f80$var$Formatter.parseFormat(format), locale);
        this.units = this.tokens.map(function(t) {
            return $63618293c58b5f80$var$unitForToken(t, locale);
        });
        this.disqualifyingUnit = this.units.find(function(t) {
            return t.invalidReason;
        });
        if (!this.disqualifyingUnit) {
            var _buildRegex = $63618293c58b5f80$var$buildRegex(this.units), regexString = _buildRegex[0], handlers = _buildRegex[1];
            this.regex = RegExp(regexString, "i");
            this.handlers = handlers;
        }
    }
    var _proto = TokenParser.prototype;
    _proto.explainFromTokens = function explainFromTokens(input) {
        if (!this.isValid) return {
            input: input,
            tokens: this.tokens,
            invalidReason: this.invalidReason
        };
        else {
            var _match = $63618293c58b5f80$var$match(input, this.regex, this.handlers), rawMatches = _match[0], matches = _match[1], _ref6 = matches ? $63618293c58b5f80$var$dateTimeFromMatches(matches) : [
                null,
                null,
                undefined
            ], result = _ref6[0], zone = _ref6[1], specificOffset = _ref6[2];
            if ($63618293c58b5f80$var$hasOwnProperty(matches, "a") && $63618293c58b5f80$var$hasOwnProperty(matches, "H")) throw new $63618293c58b5f80$var$ConflictingSpecificationError("Can't include meridiem when specifying 24-hour format");
            return {
                input: input,
                tokens: this.tokens,
                regex: this.regex,
                rawMatches: rawMatches,
                matches: matches,
                result: result,
                zone: zone,
                specificOffset: specificOffset
            };
        }
    };
    $63618293c58b5f80$var$_createClass(TokenParser, [
        {
            key: "isValid",
            get: function get() {
                return !this.disqualifyingUnit;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.disqualifyingUnit ? this.disqualifyingUnit.invalidReason : null;
            }
        }
    ]);
    return TokenParser;
}();
function $63618293c58b5f80$var$explainFromTokens(locale, input, format) {
    var parser = new $63618293c58b5f80$var$TokenParser(locale, format);
    return parser.explainFromTokens(input);
}
function $63618293c58b5f80$var$parseFromTokens(locale, input, format) {
    var _explainFromTokens = $63618293c58b5f80$var$explainFromTokens(locale, input, format), result = _explainFromTokens.result, zone = _explainFromTokens.zone, specificOffset = _explainFromTokens.specificOffset, invalidReason = _explainFromTokens.invalidReason;
    return [
        result,
        zone,
        specificOffset,
        invalidReason
    ];
}
function $63618293c58b5f80$var$formatOptsToTokens(formatOpts, locale) {
    if (!formatOpts) return null;
    var formatter = $63618293c58b5f80$var$Formatter.create(locale, formatOpts);
    var df = formatter.dtFormatter($63618293c58b5f80$var$getDummyDateTime());
    var parts = df.formatToParts();
    var resolvedOpts = df.resolvedOptions();
    return parts.map(function(p) {
        return $63618293c58b5f80$var$tokenForPart(p, formatOpts, resolvedOpts);
    });
}
var $63618293c58b5f80$var$INVALID = "Invalid DateTime";
var $63618293c58b5f80$var$MAX_DATE = 8.64e15;
function $63618293c58b5f80$var$unsupportedZone(zone) {
    return new $63618293c58b5f80$var$Invalid("unsupported zone", "the zone \"" + zone.name + "\" is not supported");
}
// we cache week data on the DT object and this intermediates the cache
/**
 * @param {DateTime} dt
 */ function $63618293c58b5f80$var$possiblyCachedWeekData(dt) {
    if (dt.weekData === null) dt.weekData = $63618293c58b5f80$var$gregorianToWeek(dt.c);
    return dt.weekData;
}
/**
 * @param {DateTime} dt
 */ function $63618293c58b5f80$var$possiblyCachedLocalWeekData(dt) {
    if (dt.localWeekData === null) dt.localWeekData = $63618293c58b5f80$var$gregorianToWeek(dt.c, dt.loc.getMinDaysInFirstWeek(), dt.loc.getStartOfWeek());
    return dt.localWeekData;
}
// clone really means, "make a new object with these modifications". all "setters" really use this
// to create a new object while only changing some of the properties
function $63618293c58b5f80$var$clone(inst, alts) {
    var current = {
        ts: inst.ts,
        zone: inst.zone,
        c: inst.c,
        o: inst.o,
        loc: inst.loc,
        invalid: inst.invalid
    };
    return new $63618293c58b5f80$var$DateTime($63618293c58b5f80$var$_extends({}, current, alts, {
        old: current
    }));
}
// find the right offset a given local time. The o input is our guess, which determines which
// offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)
function $63618293c58b5f80$var$fixOffset(localTS, o, tz) {
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - o * 60000;
    // Test whether the zone matches the offset for this ts
    var o2 = tz.offset(utcGuess);
    // If so, offset didn't change and we're done
    if (o === o2) return [
        utcGuess,
        o
    ];
    // If not, change the ts by the difference in the offset
    utcGuess -= (o2 - o) * 60000;
    // If that gives us the local time we want, we're done
    var o3 = tz.offset(utcGuess);
    if (o2 === o3) return [
        utcGuess,
        o2
    ];
    // If it's different, we're in a hole time. The offset has changed, but the we don't adjust the time
    return [
        localTS - Math.min(o2, o3) * 60000,
        Math.max(o2, o3)
    ];
}
// convert an epoch timestamp into a calendar object with the given offset
function $63618293c58b5f80$var$tsToObj(ts, offset) {
    ts += offset * 60000;
    var d = new Date(ts);
    return {
        year: d.getUTCFullYear(),
        month: d.getUTCMonth() + 1,
        day: d.getUTCDate(),
        hour: d.getUTCHours(),
        minute: d.getUTCMinutes(),
        second: d.getUTCSeconds(),
        millisecond: d.getUTCMilliseconds()
    };
}
// convert a calendar object to a epoch timestamp
function $63618293c58b5f80$var$objToTS(obj, offset, zone) {
    return $63618293c58b5f80$var$fixOffset($63618293c58b5f80$var$objToLocalTS(obj), offset, zone);
}
// create a new DT instance by adding a duration, adjusting for DSTs
function $63618293c58b5f80$var$adjustTime(inst, dur) {
    var oPre = inst.o, year = inst.c.year + Math.trunc(dur.years), month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3, c = $63618293c58b5f80$var$_extends({}, inst.c, {
        year: year,
        month: month,
        day: Math.min(inst.c.day, $63618293c58b5f80$var$daysInMonth(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
    }), millisToAdd = $63618293c58b5f80$var$Duration.fromObject({
        years: dur.years - Math.trunc(dur.years),
        quarters: dur.quarters - Math.trunc(dur.quarters),
        months: dur.months - Math.trunc(dur.months),
        weeks: dur.weeks - Math.trunc(dur.weeks),
        days: dur.days - Math.trunc(dur.days),
        hours: dur.hours,
        minutes: dur.minutes,
        seconds: dur.seconds,
        milliseconds: dur.milliseconds
    }).as("milliseconds"), localTS = $63618293c58b5f80$var$objToLocalTS(c);
    var _fixOffset = $63618293c58b5f80$var$fixOffset(localTS, oPre, inst.zone), ts = _fixOffset[0], o = _fixOffset[1];
    if (millisToAdd !== 0) {
        ts += millisToAdd;
        // that could have changed the offset by going over a DST, but we want to keep the ts the same
        o = inst.zone.offset(ts);
    }
    return {
        ts: ts,
        o: o
    };
}
// helper useful in turning the results of parsing into real dates
// by handling the zone options
function $63618293c58b5f80$var$parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
    var setZone = opts.setZone, zone = opts.zone;
    if (parsed && Object.keys(parsed).length !== 0 || parsedZone) {
        var interpretationZone = parsedZone || zone, inst = $63618293c58b5f80$var$DateTime.fromObject(parsed, $63618293c58b5f80$var$_extends({}, opts, {
            zone: interpretationZone,
            specificOffset: specificOffset
        }));
        return setZone ? inst : inst.setZone(zone);
    } else return $63618293c58b5f80$var$DateTime.invalid(new $63618293c58b5f80$var$Invalid("unparsable", "the input \"" + text + "\" can't be parsed as " + format));
}
// if you want to output a technical format (e.g. RFC 2822), this helper
// helps handle the details
function $63618293c58b5f80$var$toTechFormat(dt, format, allowZ) {
    if (allowZ === void 0) allowZ = true;
    return dt.isValid ? $63618293c58b5f80$var$Formatter.create($63618293c58b5f80$var$Locale.create("en-US"), {
        allowZ: allowZ,
        forceSimple: true
    }).formatDateTimeFromString(dt, format) : null;
}
function $63618293c58b5f80$var$_toISODate(o, extended, precision) {
    var longFormat = o.c.year > 9999 || o.c.year < 0;
    var c = "";
    if (longFormat && o.c.year >= 0) c += "+";
    c += $63618293c58b5f80$var$padStart(o.c.year, longFormat ? 6 : 4);
    if (precision === "year") return c;
    if (extended) {
        c += "-";
        c += $63618293c58b5f80$var$padStart(o.c.month);
        if (precision === "month") return c;
        c += "-";
    } else {
        c += $63618293c58b5f80$var$padStart(o.c.month);
        if (precision === "month") return c;
    }
    c += $63618293c58b5f80$var$padStart(o.c.day);
    return c;
}
function $63618293c58b5f80$var$_toISOTime(o, extended, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone, precision) {
    var showSeconds = !suppressSeconds || o.c.millisecond !== 0 || o.c.second !== 0, c = "";
    switch(precision){
        case "day":
        case "month":
        case "year":
            break;
        default:
            c += $63618293c58b5f80$var$padStart(o.c.hour);
            if (precision === "hour") break;
            if (extended) {
                c += ":";
                c += $63618293c58b5f80$var$padStart(o.c.minute);
                if (precision === "minute") break;
                if (showSeconds) {
                    c += ":";
                    c += $63618293c58b5f80$var$padStart(o.c.second);
                }
            } else {
                c += $63618293c58b5f80$var$padStart(o.c.minute);
                if (precision === "minute") break;
                if (showSeconds) c += $63618293c58b5f80$var$padStart(o.c.second);
            }
            if (precision === "second") break;
            if (showSeconds && (!suppressMilliseconds || o.c.millisecond !== 0)) {
                c += ".";
                c += $63618293c58b5f80$var$padStart(o.c.millisecond, 3);
            }
    }
    if (includeOffset) {
        if (o.isOffsetFixed && o.offset === 0 && !extendedZone) c += "Z";
        else if (o.o < 0) {
            c += "-";
            c += $63618293c58b5f80$var$padStart(Math.trunc(-o.o / 60));
            c += ":";
            c += $63618293c58b5f80$var$padStart(Math.trunc(-o.o % 60));
        } else {
            c += "+";
            c += $63618293c58b5f80$var$padStart(Math.trunc(o.o / 60));
            c += ":";
            c += $63618293c58b5f80$var$padStart(Math.trunc(o.o % 60));
        }
    }
    if (extendedZone) c += "[" + o.zone.ianaName + "]";
    return c;
}
// defaults for unspecified units in the supported calendars
var $63618293c58b5f80$var$defaultUnitValues = {
    month: 1,
    day: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $63618293c58b5f80$var$defaultWeekUnitValues = {
    weekNumber: 1,
    weekday: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $63618293c58b5f80$var$defaultOrdinalUnitValues = {
    ordinal: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
};
// Units in the supported calendars, sorted by bigness
var $63618293c58b5f80$var$orderedUnits = [
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "millisecond"
], $63618293c58b5f80$var$orderedWeekUnits = [
    "weekYear",
    "weekNumber",
    "weekday",
    "hour",
    "minute",
    "second",
    "millisecond"
], $63618293c58b5f80$var$orderedOrdinalUnits = [
    "year",
    "ordinal",
    "hour",
    "minute",
    "second",
    "millisecond"
];
// standardize case and plurality in units
function $63618293c58b5f80$var$normalizeUnit(unit) {
    var normalized = {
        year: "year",
        years: "year",
        month: "month",
        months: "month",
        day: "day",
        days: "day",
        hour: "hour",
        hours: "hour",
        minute: "minute",
        minutes: "minute",
        quarter: "quarter",
        quarters: "quarter",
        second: "second",
        seconds: "second",
        millisecond: "millisecond",
        milliseconds: "millisecond",
        weekday: "weekday",
        weekdays: "weekday",
        weeknumber: "weekNumber",
        weeksnumber: "weekNumber",
        weeknumbers: "weekNumber",
        weekyear: "weekYear",
        weekyears: "weekYear",
        ordinal: "ordinal"
    }[unit.toLowerCase()];
    if (!normalized) throw new $63618293c58b5f80$var$InvalidUnitError(unit);
    return normalized;
}
function $63618293c58b5f80$var$normalizeUnitWithLocalWeeks(unit) {
    switch(unit.toLowerCase()){
        case "localweekday":
        case "localweekdays":
            return "localWeekday";
        case "localweeknumber":
        case "localweeknumbers":
            return "localWeekNumber";
        case "localweekyear":
        case "localweekyears":
            return "localWeekYear";
        default:
            return $63618293c58b5f80$var$normalizeUnit(unit);
    }
}
// cache offsets for zones based on the current timestamp when this function is
// first called. When we are handling a datetime from components like (year,
// month, day, hour) in a time zone, we need a guess about what the timezone
// offset is so that we can convert into a UTC timestamp. One way is to find the
// offset of now in the zone. The actual date may have a different offset (for
// example, if we handle a date in June while we're in December in a zone that
// observes DST), but we can check and adjust that.
//
// When handling many dates, calculating the offset for now every time is
// expensive. It's just a guess, so we can cache the offset to use even if we
// are right on a time change boundary (we'll just correct in the other
// direction). Using a timestamp from first read is a slight optimization for
// handling dates close to the current date, since those dates will usually be
// in the same offset (we could set the timestamp statically, instead). We use a
// single timestamp for all zones to make things a bit more predictable.
//
// This is safe for quickDT (used by local() and utc()) because we don't fill in
// higher-order units from tsNow (as we do in fromObject, this requires that
// offset is calculated from tsNow).
/**
 * @param {Zone} zone
 * @return {number}
 */ function $63618293c58b5f80$var$guessOffsetForZone(zone) {
    if ($63618293c58b5f80$var$zoneOffsetTs === undefined) $63618293c58b5f80$var$zoneOffsetTs = $63618293c58b5f80$var$Settings.now();
    // Do not cache anything but IANA zones, because it is not safe to do so.
    // Guessing an offset which is not present in the zone can cause wrong results from fixOffset
    if (zone.type !== "iana") return zone.offset($63618293c58b5f80$var$zoneOffsetTs);
    var zoneName = zone.name;
    var offsetGuess = $63618293c58b5f80$var$zoneOffsetGuessCache.get(zoneName);
    if (offsetGuess === undefined) {
        offsetGuess = zone.offset($63618293c58b5f80$var$zoneOffsetTs);
        $63618293c58b5f80$var$zoneOffsetGuessCache.set(zoneName, offsetGuess);
    }
    return offsetGuess;
}
// this is a dumbed down version of fromObject() that runs about 60% faster
// but doesn't do any validation, makes a bunch of assumptions about what units
// are present, and so on.
function $63618293c58b5f80$var$quickDT(obj, opts) {
    var zone = $63618293c58b5f80$var$normalizeZone(opts.zone, $63618293c58b5f80$var$Settings.defaultZone);
    if (!zone.isValid) return $63618293c58b5f80$var$DateTime.invalid($63618293c58b5f80$var$unsupportedZone(zone));
    var loc = $63618293c58b5f80$var$Locale.fromObject(opts);
    var ts, o;
    // assume we have the higher-order units
    if (!$63618293c58b5f80$var$isUndefined(obj.year)) {
        for(var _i = 0, _orderedUnits = $63618293c58b5f80$var$orderedUnits; _i < _orderedUnits.length; _i++){
            var u = _orderedUnits[_i];
            if ($63618293c58b5f80$var$isUndefined(obj[u])) obj[u] = $63618293c58b5f80$var$defaultUnitValues[u];
        }
        var invalid = $63618293c58b5f80$var$hasInvalidGregorianData(obj) || $63618293c58b5f80$var$hasInvalidTimeData(obj);
        if (invalid) return $63618293c58b5f80$var$DateTime.invalid(invalid);
        var offsetProvis = $63618293c58b5f80$var$guessOffsetForZone(zone);
        var _objToTS = $63618293c58b5f80$var$objToTS(obj, offsetProvis, zone);
        ts = _objToTS[0];
        o = _objToTS[1];
    } else ts = $63618293c58b5f80$var$Settings.now();
    return new $63618293c58b5f80$var$DateTime({
        ts: ts,
        zone: zone,
        loc: loc,
        o: o
    });
}
function $63618293c58b5f80$var$diffRelative(start, end, opts) {
    var round = $63618293c58b5f80$var$isUndefined(opts.round) ? true : opts.round, rounding = $63618293c58b5f80$var$isUndefined(opts.rounding) ? "trunc" : opts.rounding, format = function format(c, unit) {
        c = $63618293c58b5f80$var$roundTo(c, round || opts.calendary ? 0 : 2, opts.calendary ? "round" : rounding);
        var formatter = end.loc.clone(opts).relFormatter(opts);
        return formatter.format(c, unit);
    }, differ = function differ(unit) {
        if (opts.calendary) {
            if (!end.hasSame(start, unit)) return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
            else return 0;
        } else return end.diff(start, unit).get(unit);
    };
    if (opts.unit) return format(differ(opts.unit), opts.unit);
    for(var _iterator = $63618293c58b5f80$var$_createForOfIteratorHelperLoose(opts.units), _step; !(_step = _iterator()).done;){
        var unit = _step.value;
        var count = differ(unit);
        if (Math.abs(count) >= 1) return format(count, unit);
    }
    return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
function $63618293c58b5f80$var$lastOpts(argList) {
    var opts = {}, args;
    if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
        opts = argList[argList.length - 1];
        args = Array.from(argList).slice(0, argList.length - 1);
    } else args = Array.from(argList);
    return [
        opts,
        args
    ];
}
/**
 * Timestamp to use for cached zone offset guesses (exposed for test)
 */ var $63618293c58b5f80$var$zoneOffsetTs;
/**
 * Cache for zone offset guesses (exposed for test).
 *
 * This optimizes quickDT via guessOffsetForZone to avoid repeated calls of
 * zone.offset().
 */ var $63618293c58b5f80$var$zoneOffsetGuessCache = new Map();
/**
 * A DateTime is an immutable data structure representing a specific date and time and accompanying methods. It contains class and instance methods for creating, parsing, interrogating, transforming, and formatting them.
 *
 * A DateTime comprises of:
 * * A timestamp. Each DateTime instance refers to a specific millisecond of the Unix epoch.
 * * A time zone. Each instance is considered in the context of a specific zone (by default the local system's zone).
 * * Configuration properties that effect how output strings are formatted, such as `locale`, `numberingSystem`, and `outputCalendar`.
 *
 * Here is a brief overview of the most commonly used functionality it provides:
 *
 * * **Creation**: To create a DateTime from its components, use one of its factory class methods: {@link DateTime.local}, {@link DateTime.utc}, and (most flexibly) {@link DateTime.fromObject}. To create one from a standard string format, use {@link DateTime.fromISO}, {@link DateTime.fromHTTP}, and {@link DateTime.fromRFC2822}. To create one from a custom string format, use {@link DateTime.fromFormat}. To create one from a native JS date, use {@link DateTime.fromJSDate}.
 * * **Gregorian calendar and time**: To examine the Gregorian properties of a DateTime individually (i.e as opposed to collectively through {@link DateTime#toObject}), use the {@link DateTime#year}, {@link DateTime#month},
 * {@link DateTime#day}, {@link DateTime#hour}, {@link DateTime#minute}, {@link DateTime#second}, {@link DateTime#millisecond} accessors.
 * * **Week calendar**: For ISO week calendar attributes, see the {@link DateTime#weekYear}, {@link DateTime#weekNumber}, and {@link DateTime#weekday} accessors.
 * * **Configuration** See the {@link DateTime#locale} and {@link DateTime#numberingSystem} accessors.
 * * **Transformation**: To transform the DateTime into other DateTimes, use {@link DateTime#set}, {@link DateTime#reconfigure}, {@link DateTime#setZone}, {@link DateTime#setLocale}, {@link DateTime.plus}, {@link DateTime#minus}, {@link DateTime#endOf}, {@link DateTime#startOf}, {@link DateTime#toUTC}, and {@link DateTime#toLocal}.
 * * **Output**: To convert the DateTime to other representations, use the {@link DateTime#toRelative}, {@link DateTime#toRelativeCalendar}, {@link DateTime#toJSON}, {@link DateTime#toISO}, {@link DateTime#toHTTP}, {@link DateTime#toObject}, {@link DateTime#toRFC2822}, {@link DateTime#toString}, {@link DateTime#toLocaleString}, {@link DateTime#toFormat}, {@link DateTime#toMillis} and {@link DateTime#toJSDate}.
 *
 * There's plenty others documented below. In addition, for more information on subtler topics like internationalization, time zones, alternative calendars, validity, and so on, see the external documentation.
 */ var $63618293c58b5f80$var$DateTime = /*#__PURE__*/ function(_Symbol$for) {
    /**
   * @access private
   */ function DateTime(config) {
        var zone = config.zone || $63618293c58b5f80$var$Settings.defaultZone;
        var invalid = config.invalid || (Number.isNaN(config.ts) ? new $63618293c58b5f80$var$Invalid("invalid input") : null) || (!zone.isValid ? $63618293c58b5f80$var$unsupportedZone(zone) : null);
        /**
     * @access private
     */ this.ts = $63618293c58b5f80$var$isUndefined(config.ts) ? $63618293c58b5f80$var$Settings.now() : config.ts;
        var c = null, o = null;
        if (!invalid) {
            var unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);
            if (unchanged) {
                var _ref = [
                    config.old.c,
                    config.old.o
                ];
                c = _ref[0];
                o = _ref[1];
            } else {
                // If an offset has been passed and we have not been called from
                // clone(), we can trust it and avoid the offset calculation.
                var ot = $63618293c58b5f80$var$isNumber(config.o) && !config.old ? config.o : zone.offset(this.ts);
                c = $63618293c58b5f80$var$tsToObj(this.ts, ot);
                invalid = Number.isNaN(c.year) ? new $63618293c58b5f80$var$Invalid("invalid input") : null;
                c = invalid ? null : c;
                o = invalid ? null : ot;
            }
        }
        /**
     * @access private
     */ this._zone = zone;
        /**
     * @access private
     */ this.loc = config.loc || $63618293c58b5f80$var$Locale.create();
        /**
     * @access private
     */ this.invalid = invalid;
        /**
     * @access private
     */ this.weekData = null;
        /**
     * @access private
     */ this.localWeekData = null;
        /**
     * @access private
     */ this.c = c;
        /**
     * @access private
     */ this.o = o;
        /**
     * @access private
     */ this.isLuxonDateTime = true;
    }
    // CONSTRUCT
    /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */ DateTime.now = function now() {
        return new DateTime({});
    } /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */ ;
    DateTime.local = function local() {
        var _lastOpts = $63618293c58b5f80$var$lastOpts(arguments), opts = _lastOpts[0], args = _lastOpts[1], year = args[0], month = args[1], day = args[2], hour = args[3], minute = args[4], second = args[5], millisecond = args[6];
        return $63618293c58b5f80$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    } /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [options.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */ ;
    DateTime.utc = function utc() {
        var _lastOpts2 = $63618293c58b5f80$var$lastOpts(arguments), opts = _lastOpts2[0], args = _lastOpts2[1], year = args[0], month = args[1], day = args[2], hour = args[3], minute = args[4], second = args[5], millisecond = args[6];
        opts.zone = $63618293c58b5f80$var$FixedOffsetZone.utcInstance;
        return $63618293c58b5f80$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    } /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */ ;
    DateTime.fromJSDate = function fromJSDate(date, options) {
        if (options === void 0) options = {};
        var ts = $63618293c58b5f80$var$isDate(date) ? date.valueOf() : NaN;
        if (Number.isNaN(ts)) return DateTime.invalid("invalid input");
        var zoneToUse = $63618293c58b5f80$var$normalizeZone(options.zone, $63618293c58b5f80$var$Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid($63618293c58b5f80$var$unsupportedZone(zoneToUse));
        return new DateTime({
            ts: ts,
            zone: zoneToUse,
            loc: $63618293c58b5f80$var$Locale.fromObject(options)
        });
    } /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */ ;
    DateTime.fromMillis = function fromMillis(milliseconds, options) {
        if (options === void 0) options = {};
        if (!$63618293c58b5f80$var$isNumber(milliseconds)) throw new $63618293c58b5f80$var$InvalidArgumentError("fromMillis requires a numerical input, but received a " + typeof milliseconds + " with value " + milliseconds);
        else if (milliseconds < -$63618293c58b5f80$var$MAX_DATE || milliseconds > $63618293c58b5f80$var$MAX_DATE) // this isn't perfect because we can still end up out of range because of additional shifting, but it's a start
        return DateTime.invalid("Timestamp out of range");
        else return new DateTime({
            ts: milliseconds,
            zone: $63618293c58b5f80$var$normalizeZone(options.zone, $63618293c58b5f80$var$Settings.defaultZone),
            loc: $63618293c58b5f80$var$Locale.fromObject(options)
        });
    } /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */ ;
    DateTime.fromSeconds = function fromSeconds(seconds, options) {
        if (options === void 0) options = {};
        if (!$63618293c58b5f80$var$isNumber(seconds)) throw new $63618293c58b5f80$var$InvalidArgumentError("fromSeconds requires a numerical input");
        else return new DateTime({
            ts: seconds * 1000,
            zone: $63618293c58b5f80$var$normalizeZone(options.zone, $63618293c58b5f80$var$Settings.defaultZone),
            loc: $63618293c58b5f80$var$Locale.fromObject(options)
        });
    } /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.localWeekYear - a week year, according to the locale
   * @param {number} obj.localWeekNumber - a week number, between 1 and 52 or 53, depending on the year, according to the locale
   * @param {number} obj.localWeekday - a weekday, 1-7, where 1 is the first and 7 is the last day of the week, according to the locale
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system\'s locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @example DateTime.fromObject({ localWeekYear: 2022, localWeekNumber: 1, localWeekday: 1 }, { locale: "en-US" }).toISODate() //=> '2021-12-26'
   * @return {DateTime}
   */ ;
    DateTime.fromObject = function fromObject(obj, opts) {
        if (opts === void 0) opts = {};
        obj = obj || {};
        var zoneToUse = $63618293c58b5f80$var$normalizeZone(opts.zone, $63618293c58b5f80$var$Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid($63618293c58b5f80$var$unsupportedZone(zoneToUse));
        var loc = $63618293c58b5f80$var$Locale.fromObject(opts);
        var normalized = $63618293c58b5f80$var$normalizeObject(obj, $63618293c58b5f80$var$normalizeUnitWithLocalWeeks);
        var _usesLocalWeekValues = $63618293c58b5f80$var$usesLocalWeekValues(normalized, loc), minDaysInFirstWeek = _usesLocalWeekValues.minDaysInFirstWeek, startOfWeek = _usesLocalWeekValues.startOfWeek;
        var tsNow = $63618293c58b5f80$var$Settings.now(), offsetProvis = !$63618293c58b5f80$var$isUndefined(opts.specificOffset) ? opts.specificOffset : zoneToUse.offset(tsNow), containsOrdinal = !$63618293c58b5f80$var$isUndefined(normalized.ordinal), containsGregorYear = !$63618293c58b5f80$var$isUndefined(normalized.year), containsGregorMD = !$63618293c58b5f80$var$isUndefined(normalized.month) || !$63618293c58b5f80$var$isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
        // cases:
        // just a weekday -> this week's instance of that weekday, no worries
        // (gregorian data or ordinal) + (weekYear or weekNumber) -> error
        // (gregorian month or day) + ordinal -> error
        // otherwise just use weeks or ordinals or gregorian, depending on what's specified
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new $63618293c58b5f80$var$ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new $63618293c58b5f80$var$ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        var useWeekData = definiteWeekDef || normalized.weekday && !containsGregor;
        // configure ourselves to deal with gregorian dates or week stuff
        var units, defaultValues, objNow = $63618293c58b5f80$var$tsToObj(tsNow, offsetProvis);
        if (useWeekData) {
            units = $63618293c58b5f80$var$orderedWeekUnits;
            defaultValues = $63618293c58b5f80$var$defaultWeekUnitValues;
            objNow = $63618293c58b5f80$var$gregorianToWeek(objNow, minDaysInFirstWeek, startOfWeek);
        } else if (containsOrdinal) {
            units = $63618293c58b5f80$var$orderedOrdinalUnits;
            defaultValues = $63618293c58b5f80$var$defaultOrdinalUnitValues;
            objNow = $63618293c58b5f80$var$gregorianToOrdinal(objNow);
        } else {
            units = $63618293c58b5f80$var$orderedUnits;
            defaultValues = $63618293c58b5f80$var$defaultUnitValues;
        }
        // set default values for missing stuff
        var foundFirst = false;
        for(var _iterator2 = $63618293c58b5f80$var$_createForOfIteratorHelperLoose(units), _step2; !(_step2 = _iterator2()).done;){
            var u = _step2.value;
            var v = normalized[u];
            if (!$63618293c58b5f80$var$isUndefined(v)) foundFirst = true;
            else if (foundFirst) normalized[u] = defaultValues[u];
            else normalized[u] = objNow[u];
        }
        // make sure the values we have are in range
        var higherOrderInvalid = useWeekData ? $63618293c58b5f80$var$hasInvalidWeekData(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? $63618293c58b5f80$var$hasInvalidOrdinalData(normalized) : $63618293c58b5f80$var$hasInvalidGregorianData(normalized), invalid = higherOrderInvalid || $63618293c58b5f80$var$hasInvalidTimeData(normalized);
        if (invalid) return DateTime.invalid(invalid);
        // compute the actual time
        var gregorian = useWeekData ? $63618293c58b5f80$var$weekToGregorian(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? $63618293c58b5f80$var$ordinalToGregorian(normalized) : normalized, _objToTS2 = $63618293c58b5f80$var$objToTS(gregorian, offsetProvis, zoneToUse), tsFinal = _objToTS2[0], offsetFinal = _objToTS2[1], inst = new DateTime({
            ts: tsFinal,
            zone: zoneToUse,
            o: offsetFinal,
            loc: loc
        });
        // gregorian data + weekday serves only to validate
        if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) return DateTime.invalid("mismatched weekday", "you can't specify both a weekday of " + normalized.weekday + " and a date of " + inst.toISO());
        if (!inst.isValid) return DateTime.invalid(inst.invalid);
        return inst;
    } /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [opts.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */ ;
    DateTime.fromISO = function fromISO(text, opts) {
        if (opts === void 0) opts = {};
        var _parseISODate = $63618293c58b5f80$var$parseISODate(text), vals = _parseISODate[0], parsedZone = _parseISODate[1];
        return $63618293c58b5f80$var$parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
    } /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */ ;
    DateTime.fromRFC2822 = function fromRFC2822(text, opts) {
        if (opts === void 0) opts = {};
        var _parseRFC2822Date = $63618293c58b5f80$var$parseRFC2822Date(text), vals = _parseRFC2822Date[0], parsedZone = _parseRFC2822Date[1];
        return $63618293c58b5f80$var$parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
    } /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */ ;
    DateTime.fromHTTP = function fromHTTP(text, opts) {
        if (opts === void 0) opts = {};
        var _parseHTTPDate = $63618293c58b5f80$var$parseHTTPDate(text), vals = _parseHTTPDate[0], parsedZone = _parseHTTPDate[1];
        return $63618293c58b5f80$var$parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
    } /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */ ;
    DateTime.fromFormat = function fromFormat(text, fmt, opts) {
        if (opts === void 0) opts = {};
        if ($63618293c58b5f80$var$isUndefined(text) || $63618293c58b5f80$var$isUndefined(fmt)) throw new $63618293c58b5f80$var$InvalidArgumentError("fromFormat requires an input string and a format");
        var _opts = opts, _opts$locale = _opts.locale, locale = _opts$locale === void 0 ? null : _opts$locale, _opts$numberingSystem = _opts.numberingSystem, numberingSystem = _opts$numberingSystem === void 0 ? null : _opts$numberingSystem, localeToUse = $63618293c58b5f80$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        }), _parseFromTokens = $63618293c58b5f80$var$parseFromTokens(localeToUse, text, fmt), vals = _parseFromTokens[0], parsedZone = _parseFromTokens[1], specificOffset = _parseFromTokens[2], invalid = _parseFromTokens[3];
        if (invalid) return DateTime.invalid(invalid);
        else return $63618293c58b5f80$var$parseDataToDateTime(vals, parsedZone, opts, "format " + fmt, text, specificOffset);
    } /**
   * @deprecated use fromFormat instead
   */ ;
    DateTime.fromString = function fromString(text, fmt, opts) {
        if (opts === void 0) opts = {};
        return DateTime.fromFormat(text, fmt, opts);
    } /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */ ;
    DateTime.fromSQL = function fromSQL(text, opts) {
        if (opts === void 0) opts = {};
        var _parseSQL = $63618293c58b5f80$var$parseSQL(text), vals = _parseSQL[0], parsedZone = _parseSQL[1];
        return $63618293c58b5f80$var$parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
    } /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */ ;
    DateTime.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $63618293c58b5f80$var$InvalidArgumentError("need to specify a reason the DateTime is invalid");
        var invalid = reason instanceof $63618293c58b5f80$var$Invalid ? reason : new $63618293c58b5f80$var$Invalid(reason, explanation);
        if ($63618293c58b5f80$var$Settings.throwOnInvalid) throw new $63618293c58b5f80$var$InvalidDateTimeError(invalid);
        else return new DateTime({
            invalid: invalid
        });
    } /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ ;
    DateTime.isDateTime = function isDateTime(o) {
        return o && o.isLuxonDateTime || false;
    } /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */ ;
    DateTime.parseFormatForOpts = function parseFormatForOpts(formatOpts, localeOpts) {
        if (localeOpts === void 0) localeOpts = {};
        var tokenList = $63618293c58b5f80$var$formatOptsToTokens(formatOpts, $63618293c58b5f80$var$Locale.fromObject(localeOpts));
        return !tokenList ? null : tokenList.map(function(t) {
            return t ? t.val : null;
        }).join("");
    } /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */ ;
    DateTime.expandFormat = function expandFormat(fmt, localeOpts) {
        if (localeOpts === void 0) localeOpts = {};
        var expanded = $63618293c58b5f80$var$expandMacroTokens($63618293c58b5f80$var$Formatter.parseFormat(fmt), $63618293c58b5f80$var$Locale.fromObject(localeOpts));
        return expanded.map(function(t) {
            return t.val;
        }).join("");
    };
    DateTime.resetCache = function resetCache() {
        $63618293c58b5f80$var$zoneOffsetTs = undefined;
        $63618293c58b5f80$var$zoneOffsetGuessCache.clear();
    } /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */ ;
    var _proto = DateTime.prototype;
    _proto.get = function get(unit) {
        return this[unit];
    } /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */ ;
    /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */ _proto.getPossibleOffsets = function getPossibleOffsets() {
        if (!this.isValid || this.isOffsetFixed) return [
            this
        ];
        var dayMs = 86400000;
        var minuteMs = 60000;
        var localTS = $63618293c58b5f80$var$objToLocalTS(this.c);
        var oEarlier = this.zone.offset(localTS - dayMs);
        var oLater = this.zone.offset(localTS + dayMs);
        var o1 = this.zone.offset(localTS - oEarlier * minuteMs);
        var o2 = this.zone.offset(localTS - oLater * minuteMs);
        if (o1 === o2) return [
            this
        ];
        var ts1 = localTS - o1 * minuteMs;
        var ts2 = localTS - o2 * minuteMs;
        var c1 = $63618293c58b5f80$var$tsToObj(ts1, o1);
        var c2 = $63618293c58b5f80$var$tsToObj(ts2, o2);
        if (c1.hour === c2.hour && c1.minute === c2.minute && c1.second === c2.second && c1.millisecond === c2.millisecond) return [
            $63618293c58b5f80$var$clone(this, {
                ts: ts1
            }),
            $63618293c58b5f80$var$clone(this, {
                ts: ts2
            })
        ];
        return [
            this
        ];
    } /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */ ;
    /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */ _proto.resolvedLocaleOptions = function resolvedLocaleOptions(opts) {
        if (opts === void 0) opts = {};
        var _Formatter$create$res = $63618293c58b5f80$var$Formatter.create(this.loc.clone(opts), opts).resolvedOptions(this), locale = _Formatter$create$res.locale, numberingSystem = _Formatter$create$res.numberingSystem, calendar = _Formatter$create$res.calendar;
        return {
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: calendar
        };
    } /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */ ;
    _proto.toUTC = function toUTC(offset, opts) {
        if (offset === void 0) offset = 0;
        if (opts === void 0) opts = {};
        return this.setZone($63618293c58b5f80$var$FixedOffsetZone.instance(offset), opts);
    } /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */ ;
    _proto.toLocal = function toLocal() {
        return this.setZone($63618293c58b5f80$var$Settings.defaultZone);
    } /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */ ;
    _proto.setZone = function setZone(zone, _temp) {
        var _ref2 = _temp === void 0 ? {} : _temp, _ref2$keepLocalTime = _ref2.keepLocalTime, keepLocalTime = _ref2$keepLocalTime === void 0 ? false : _ref2$keepLocalTime, _ref2$keepCalendarTim = _ref2.keepCalendarTime, keepCalendarTime = _ref2$keepCalendarTim === void 0 ? false : _ref2$keepCalendarTim;
        zone = $63618293c58b5f80$var$normalizeZone(zone, $63618293c58b5f80$var$Settings.defaultZone);
        if (zone.equals(this.zone)) return this;
        else if (!zone.isValid) return DateTime.invalid($63618293c58b5f80$var$unsupportedZone(zone));
        else {
            var newTS = this.ts;
            if (keepLocalTime || keepCalendarTime) {
                var offsetGuess = zone.offset(this.ts);
                var asObj = this.toObject();
                var _objToTS3 = $63618293c58b5f80$var$objToTS(asObj, offsetGuess, zone);
                newTS = _objToTS3[0];
            }
            return $63618293c58b5f80$var$clone(this, {
                ts: newTS,
                zone: zone
            });
        }
    } /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */ ;
    _proto.reconfigure = function reconfigure(_temp2) {
        var _ref3 = _temp2 === void 0 ? {} : _temp2, locale = _ref3.locale, numberingSystem = _ref3.numberingSystem, outputCalendar = _ref3.outputCalendar;
        var loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: outputCalendar
        });
        return $63618293c58b5f80$var$clone(this, {
            loc: loc
        });
    } /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */ ;
    _proto.setLocale = function setLocale(locale) {
        return this.reconfigure({
            locale: locale
        });
    } /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   *
   * This method also supports setting locale-based week units, i.e. `localWeekday`, `localWeekNumber` and `localWeekYear`.
   * They cannot be mixed with ISO-week units like `weekday`.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */ ;
    _proto.set = function set(values) {
        if (!this.isValid) return this;
        var normalized = $63618293c58b5f80$var$normalizeObject(values, $63618293c58b5f80$var$normalizeUnitWithLocalWeeks);
        var _usesLocalWeekValues2 = $63618293c58b5f80$var$usesLocalWeekValues(normalized, this.loc), minDaysInFirstWeek = _usesLocalWeekValues2.minDaysInFirstWeek, startOfWeek = _usesLocalWeekValues2.startOfWeek;
        var settingWeekStuff = !$63618293c58b5f80$var$isUndefined(normalized.weekYear) || !$63618293c58b5f80$var$isUndefined(normalized.weekNumber) || !$63618293c58b5f80$var$isUndefined(normalized.weekday), containsOrdinal = !$63618293c58b5f80$var$isUndefined(normalized.ordinal), containsGregorYear = !$63618293c58b5f80$var$isUndefined(normalized.year), containsGregorMD = !$63618293c58b5f80$var$isUndefined(normalized.month) || !$63618293c58b5f80$var$isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new $63618293c58b5f80$var$ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new $63618293c58b5f80$var$ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        var mixed;
        if (settingWeekStuff) mixed = $63618293c58b5f80$var$weekToGregorian($63618293c58b5f80$var$_extends({}, $63618293c58b5f80$var$gregorianToWeek(this.c, minDaysInFirstWeek, startOfWeek), normalized), minDaysInFirstWeek, startOfWeek);
        else if (!$63618293c58b5f80$var$isUndefined(normalized.ordinal)) mixed = $63618293c58b5f80$var$ordinalToGregorian($63618293c58b5f80$var$_extends({}, $63618293c58b5f80$var$gregorianToOrdinal(this.c), normalized));
        else {
            mixed = $63618293c58b5f80$var$_extends({}, this.toObject(), normalized);
            // if we didn't set the day but we ended up on an overflow date,
            // use the last day of the right month
            if ($63618293c58b5f80$var$isUndefined(normalized.day)) mixed.day = Math.min($63618293c58b5f80$var$daysInMonth(mixed.year, mixed.month), mixed.day);
        }
        var _objToTS4 = $63618293c58b5f80$var$objToTS(mixed, this.o, this.zone), ts = _objToTS4[0], o = _objToTS4[1];
        return $63618293c58b5f80$var$clone(this, {
            ts: ts,
            o: o
        });
    } /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */ ;
    _proto.plus = function plus(duration) {
        if (!this.isValid) return this;
        var dur = $63618293c58b5f80$var$Duration.fromDurationLike(duration);
        return $63618293c58b5f80$var$clone(this, $63618293c58b5f80$var$adjustTime(this, dur));
    } /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */ ;
    _proto.minus = function minus(duration) {
        if (!this.isValid) return this;
        var dur = $63618293c58b5f80$var$Duration.fromDurationLike(duration).negate();
        return $63618293c58b5f80$var$clone(this, $63618293c58b5f80$var$adjustTime(this, dur));
    } /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */ ;
    _proto.startOf = function startOf(unit, _temp3) {
        var _ref4 = _temp3 === void 0 ? {} : _temp3, _ref4$useLocaleWeeks = _ref4.useLocaleWeeks, useLocaleWeeks = _ref4$useLocaleWeeks === void 0 ? false : _ref4$useLocaleWeeks;
        if (!this.isValid) return this;
        var o = {}, normalizedUnit = $63618293c58b5f80$var$Duration.normalizeUnit(unit);
        switch(normalizedUnit){
            case "years":
                o.month = 1;
            // falls through
            case "quarters":
            case "months":
                o.day = 1;
            // falls through
            case "weeks":
            case "days":
                o.hour = 0;
            // falls through
            case "hours":
                o.minute = 0;
            // falls through
            case "minutes":
                o.second = 0;
            // falls through
            case "seconds":
                o.millisecond = 0;
                break;
        }
        if (normalizedUnit === "weeks") {
            if (useLocaleWeeks) {
                var startOfWeek = this.loc.getStartOfWeek();
                var weekday = this.weekday;
                if (weekday < startOfWeek) o.weekNumber = this.weekNumber - 1;
                o.weekday = startOfWeek;
            } else o.weekday = 1;
        }
        if (normalizedUnit === "quarters") {
            var q = Math.ceil(this.month / 3);
            o.month = (q - 1) * 3 + 1;
        }
        return this.set(o);
    } /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */ ;
    _proto.endOf = function endOf(unit, opts) {
        var _this$plus;
        return this.isValid ? this.plus((_this$plus = {}, _this$plus[unit] = 1, _this$plus)).startOf(unit, opts).minus(1) : this;
    } /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */ ;
    _proto.toFormat = function toFormat(fmt, opts) {
        if (opts === void 0) opts = {};
        return this.isValid ? $63618293c58b5f80$var$Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : $63618293c58b5f80$var$INVALID;
    } /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */ ;
    _proto.toLocaleString = function toLocaleString(formatOpts, opts) {
        if (formatOpts === void 0) formatOpts = $63618293c58b5f80$var$DATE_SHORT;
        if (opts === void 0) opts = {};
        return this.isValid ? $63618293c58b5f80$var$Formatter.create(this.loc.clone(opts), formatOpts).formatDateTime(this) : $63618293c58b5f80$var$INVALID;
    } /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */ ;
    _proto.toLocaleParts = function toLocaleParts(opts) {
        if (opts === void 0) opts = {};
        return this.isValid ? $63618293c58b5f80$var$Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
    } /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='milliseconds'] - truncate output to desired presicion: 'years', 'months', 'days', 'hours', 'minutes', 'seconds' or 'milliseconds'. When precision and suppressSeconds or suppressMilliseconds are used together, precision sets the maximum unit shown in the output, however seconds or milliseconds will still be suppressed if they are 0.
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @example DateTime.now().toISO({ precision: 'day' }) //=> '2017-04-22Z'
   * @example DateTime.now().toISO({ precision: 'minute' }) //=> '2017-04-22T20:47Z'
   * @return {string|null}
   */ ;
    _proto.toISO = function toISO(_temp4) {
        var _ref5 = _temp4 === void 0 ? {} : _temp4, _ref5$format = _ref5.format, format = _ref5$format === void 0 ? "extended" : _ref5$format, _ref5$suppressSeconds = _ref5.suppressSeconds, suppressSeconds = _ref5$suppressSeconds === void 0 ? false : _ref5$suppressSeconds, _ref5$suppressMillise = _ref5.suppressMilliseconds, suppressMilliseconds = _ref5$suppressMillise === void 0 ? false : _ref5$suppressMillise, _ref5$includeOffset = _ref5.includeOffset, includeOffset = _ref5$includeOffset === void 0 ? true : _ref5$includeOffset, _ref5$extendedZone = _ref5.extendedZone, extendedZone = _ref5$extendedZone === void 0 ? false : _ref5$extendedZone, _ref5$precision = _ref5.precision, precision = _ref5$precision === void 0 ? "milliseconds" : _ref5$precision;
        if (!this.isValid) return null;
        precision = $63618293c58b5f80$var$normalizeUnit(precision);
        var ext = format === "extended";
        var c = $63618293c58b5f80$var$_toISODate(this, ext, precision);
        if ($63618293c58b5f80$var$orderedUnits.indexOf(precision) >= 3) c += "T";
        c += $63618293c58b5f80$var$_toISOTime(this, ext, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone, precision);
        return c;
    } /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='day'] - truncate output to desired precision: 'years', 'months', or 'days'.
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @example DateTime.utc(1982, 5, 25).toISODate({ precision: 'month' }) //=> '1982-05'
   * @return {string|null}
   */ ;
    _proto.toISODate = function toISODate(_temp5) {
        var _ref6 = _temp5 === void 0 ? {} : _temp5, _ref6$format = _ref6.format, format = _ref6$format === void 0 ? "extended" : _ref6$format, _ref6$precision = _ref6.precision, precision = _ref6$precision === void 0 ? "day" : _ref6$precision;
        if (!this.isValid) return null;
        return $63618293c58b5f80$var$_toISODate(this, format === "extended", $63618293c58b5f80$var$normalizeUnit(precision));
    } /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */ ;
    _proto.toISOWeekDate = function toISOWeekDate() {
        return $63618293c58b5f80$var$toTechFormat(this, "kkkk-'W'WW-c");
    } /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='milliseconds'] - truncate output to desired presicion: 'hours', 'minutes', 'seconds' or 'milliseconds'. When precision and suppressSeconds or suppressMilliseconds are used together, precision sets the maximum unit shown in the output, however seconds or milliseconds will still be suppressed if they are 0.
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, second: 56 }).toISOTime({ precision: 'minute' }) //=> '07:34Z'
   * @return {string}
   */ ;
    _proto.toISOTime = function toISOTime(_temp6) {
        var _ref7 = _temp6 === void 0 ? {} : _temp6, _ref7$suppressMillise = _ref7.suppressMilliseconds, suppressMilliseconds = _ref7$suppressMillise === void 0 ? false : _ref7$suppressMillise, _ref7$suppressSeconds = _ref7.suppressSeconds, suppressSeconds = _ref7$suppressSeconds === void 0 ? false : _ref7$suppressSeconds, _ref7$includeOffset = _ref7.includeOffset, includeOffset = _ref7$includeOffset === void 0 ? true : _ref7$includeOffset, _ref7$includePrefix = _ref7.includePrefix, includePrefix = _ref7$includePrefix === void 0 ? false : _ref7$includePrefix, _ref7$extendedZone = _ref7.extendedZone, extendedZone = _ref7$extendedZone === void 0 ? false : _ref7$extendedZone, _ref7$format = _ref7.format, format = _ref7$format === void 0 ? "extended" : _ref7$format, _ref7$precision = _ref7.precision, precision = _ref7$precision === void 0 ? "milliseconds" : _ref7$precision;
        if (!this.isValid) return null;
        precision = $63618293c58b5f80$var$normalizeUnit(precision);
        var c = includePrefix && $63618293c58b5f80$var$orderedUnits.indexOf(precision) >= 3 ? "T" : "";
        return c + $63618293c58b5f80$var$_toISOTime(this, format === "extended", suppressSeconds, suppressMilliseconds, includeOffset, extendedZone, precision);
    } /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */ ;
    _proto.toRFC2822 = function toRFC2822() {
        return $63618293c58b5f80$var$toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
    } /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */ ;
    _proto.toHTTP = function toHTTP() {
        return $63618293c58b5f80$var$toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
    } /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string|null}
   */ ;
    _proto.toSQLDate = function toSQLDate() {
        if (!this.isValid) return null;
        return $63618293c58b5f80$var$_toISODate(this, true);
    } /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */ ;
    _proto.toSQLTime = function toSQLTime(_temp7) {
        var _ref8 = _temp7 === void 0 ? {} : _temp7, _ref8$includeOffset = _ref8.includeOffset, includeOffset = _ref8$includeOffset === void 0 ? true : _ref8$includeOffset, _ref8$includeZone = _ref8.includeZone, includeZone = _ref8$includeZone === void 0 ? false : _ref8$includeZone, _ref8$includeOffsetSp = _ref8.includeOffsetSpace, includeOffsetSpace = _ref8$includeOffsetSp === void 0 ? true : _ref8$includeOffsetSp;
        var fmt = "HH:mm:ss.SSS";
        if (includeZone || includeOffset) {
            if (includeOffsetSpace) fmt += " ";
            if (includeZone) fmt += "z";
            else if (includeOffset) fmt += "ZZ";
        }
        return $63618293c58b5f80$var$toTechFormat(this, fmt, true);
    } /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */ ;
    _proto.toSQL = function toSQL(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return null;
        return this.toSQLDate() + " " + this.toSQLTime(opts);
    } /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */ ;
    _proto.toString = function toString() {
        return this.isValid ? this.toISO() : $63618293c58b5f80$var$INVALID;
    } /**
   * Returns a string representation of this DateTime appropriate for the REPL.
   * @return {string}
   */ ;
    _proto[_Symbol$for] = function() {
        if (this.isValid) return "DateTime { ts: " + this.toISO() + ", zone: " + this.zone.name + ", locale: " + this.locale + " }";
        else return "DateTime { Invalid, reason: " + this.invalidReason + " }";
    } /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */ ;
    _proto.valueOf = function valueOf() {
        return this.toMillis();
    } /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */ ;
    _proto.toMillis = function toMillis() {
        return this.isValid ? this.ts : NaN;
    } /**
   * Returns the epoch seconds (including milliseconds in the fractional part) of this DateTime.
   * @return {number}
   */ ;
    _proto.toSeconds = function toSeconds() {
        return this.isValid ? this.ts / 1000 : NaN;
    } /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */ ;
    _proto.toUnixInteger = function toUnixInteger() {
        return this.isValid ? Math.floor(this.ts / 1000) : NaN;
    } /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */ ;
    _proto.toJSON = function toJSON() {
        return this.toISO();
    } /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */ ;
    _proto.toBSON = function toBSON() {
        return this.toJSDate();
    } /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */ ;
    _proto.toObject = function toObject(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return {};
        var base = $63618293c58b5f80$var$_extends({}, this.c);
        if (opts.includeConfig) {
            base.outputCalendar = this.outputCalendar;
            base.numberingSystem = this.loc.numberingSystem;
            base.locale = this.loc.locale;
        }
        return base;
    } /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */ ;
    _proto.toJSDate = function toJSDate() {
        return new Date(this.isValid ? this.ts : NaN);
    } /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */ ;
    _proto.diff = function diff(otherDateTime, unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (opts === void 0) opts = {};
        if (!this.isValid || !otherDateTime.isValid) return $63618293c58b5f80$var$Duration.invalid("created by diffing an invalid DateTime");
        var durOpts = $63618293c58b5f80$var$_extends({
            locale: this.locale,
            numberingSystem: this.numberingSystem
        }, opts);
        var units = $63618293c58b5f80$var$maybeArray(unit).map($63618293c58b5f80$var$Duration.normalizeUnit), otherIsLater = otherDateTime.valueOf() > this.valueOf(), earlier = otherIsLater ? this : otherDateTime, later = otherIsLater ? otherDateTime : this, diffed = $63618293c58b5f80$var$_diff(earlier, later, units, durOpts);
        return otherIsLater ? diffed.negate() : diffed;
    } /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */ ;
    _proto.diffNow = function diffNow(unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (opts === void 0) opts = {};
        return this.diff(DateTime.now(), unit, opts);
    } /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval|DateTime}
   */ ;
    _proto.until = function until(otherDateTime) {
        return this.isValid ? $63618293c58b5f80$var$Interval.fromDateTimes(this, otherDateTime) : this;
    } /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; only the locale of this DateTime is used
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */ ;
    _proto.hasSame = function hasSame(otherDateTime, unit, opts) {
        if (!this.isValid) return false;
        var inputMs = otherDateTime.valueOf();
        var adjustedToZone = this.setZone(otherDateTime.zone, {
            keepLocalTime: true
        });
        return adjustedToZone.startOf(unit, opts) <= inputMs && inputMs <= adjustedToZone.endOf(unit, opts);
    } /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */ ;
    _proto.equals = function equals(other) {
        return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
    } /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds towards zero by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {string} [options.rounding="trunc"] - rounding method to use when rounding the numbers in the output. Can be "trunc" (toward zero), "expand" (away from zero), "round", "floor", or "ceil".
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */ ;
    _proto.toRelative = function toRelative(options) {
        if (options === void 0) options = {};
        if (!this.isValid) return null;
        var base = options.base || DateTime.fromObject({}, {
            zone: this.zone
        }), padding = options.padding ? this < base ? -options.padding : options.padding : 0;
        var units = [
            "years",
            "months",
            "days",
            "hours",
            "minutes",
            "seconds"
        ];
        var unit = options.unit;
        if (Array.isArray(options.unit)) {
            units = options.unit;
            unit = undefined;
        }
        return $63618293c58b5f80$var$diffRelative(base, this.plus(padding), $63618293c58b5f80$var$_extends({}, options, {
            numeric: "always",
            units: units,
            unit: unit
        }));
    } /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */ ;
    _proto.toRelativeCalendar = function toRelativeCalendar(options) {
        if (options === void 0) options = {};
        if (!this.isValid) return null;
        return $63618293c58b5f80$var$diffRelative(options.base || DateTime.fromObject({}, {
            zone: this.zone
        }), this, $63618293c58b5f80$var$_extends({}, options, {
            numeric: "auto",
            units: [
                "years",
                "months",
                "days"
            ],
            calendary: true
        }));
    } /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */ ;
    DateTime.min = function min() {
        for(var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++)dateTimes[_key] = arguments[_key];
        if (!dateTimes.every(DateTime.isDateTime)) throw new $63618293c58b5f80$var$InvalidArgumentError("min requires all arguments be DateTimes");
        return $63618293c58b5f80$var$bestBy(dateTimes, function(i) {
            return i.valueOf();
        }, Math.min);
    } /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */ ;
    DateTime.max = function max() {
        for(var _len2 = arguments.length, dateTimes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)dateTimes[_key2] = arguments[_key2];
        if (!dateTimes.every(DateTime.isDateTime)) throw new $63618293c58b5f80$var$InvalidArgumentError("max requires all arguments be DateTimes");
        return $63618293c58b5f80$var$bestBy(dateTimes, function(i) {
            return i.valueOf();
        }, Math.max);
    } /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */ ;
    DateTime.fromFormatExplain = function fromFormatExplain(text, fmt, options) {
        if (options === void 0) options = {};
        var _options = options, _options$locale = _options.locale, locale = _options$locale === void 0 ? null : _options$locale, _options$numberingSys = _options.numberingSystem, numberingSystem = _options$numberingSys === void 0 ? null : _options$numberingSys, localeToUse = $63618293c58b5f80$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        return $63618293c58b5f80$var$explainFromTokens(localeToUse, text, fmt);
    } /**
   * @deprecated use fromFormatExplain instead
   */ ;
    DateTime.fromStringExplain = function fromStringExplain(text, fmt, options) {
        if (options === void 0) options = {};
        return DateTime.fromFormatExplain(text, fmt, options);
    } /**
   * Build a parser for `fmt` using the given locale. This parser can be passed
   * to {@link DateTime.fromFormatParser} to a parse a date in this format. This
   * can be used to optimize cases where many dates need to be parsed in a
   * specific format.
   *
   * @param {String} fmt - the format the string is expected to be in (see
   * description)
   * @param {Object} options - options used to set locale and numberingSystem
   * for parser
   * @returns {TokenParser} - opaque object to be used
   */ ;
    DateTime.buildFormatParser = function buildFormatParser(fmt, options) {
        if (options === void 0) options = {};
        var _options2 = options, _options2$locale = _options2.locale, locale = _options2$locale === void 0 ? null : _options2$locale, _options2$numberingSy = _options2.numberingSystem, numberingSystem = _options2$numberingSy === void 0 ? null : _options2$numberingSy, localeToUse = $63618293c58b5f80$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        return new $63618293c58b5f80$var$TokenParser(localeToUse, fmt);
    } /**
   * Create a DateTime from an input string and format parser.
   *
   * The format parser must have been created with the same locale as this call.
   *
   * @param {String} text - the string to parse
   * @param {TokenParser} formatParser - parser from {@link DateTime.buildFormatParser}
   * @param {Object} opts - options taken by fromFormat()
   * @returns {DateTime}
   */ ;
    DateTime.fromFormatParser = function fromFormatParser(text, formatParser, opts) {
        if (opts === void 0) opts = {};
        if ($63618293c58b5f80$var$isUndefined(text) || $63618293c58b5f80$var$isUndefined(formatParser)) throw new $63618293c58b5f80$var$InvalidArgumentError("fromFormatParser requires an input string and a format parser");
        var _opts2 = opts, _opts2$locale = _opts2.locale, locale = _opts2$locale === void 0 ? null : _opts2$locale, _opts2$numberingSyste = _opts2.numberingSystem, numberingSystem = _opts2$numberingSyste === void 0 ? null : _opts2$numberingSyste, localeToUse = $63618293c58b5f80$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        if (!localeToUse.equals(formatParser.locale)) throw new $63618293c58b5f80$var$InvalidArgumentError("fromFormatParser called with a locale of " + localeToUse + ", " + ("but the format parser was created for " + formatParser.locale));
        var _formatParser$explain = formatParser.explainFromTokens(text), result = _formatParser$explain.result, zone = _formatParser$explain.zone, specificOffset = _formatParser$explain.specificOffset, invalidReason = _formatParser$explain.invalidReason;
        if (invalidReason) return DateTime.invalid(invalidReason);
        else return $63618293c58b5f80$var$parseDataToDateTime(result, zone, opts, "format " + formatParser.format, text, specificOffset);
    } /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */ ;
    $63618293c58b5f80$var$_createClass(DateTime, [
        {
            key: "isValid",
            get: function get() {
                return this.invalid === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        },
        {
            key: "locale",
            get: function get() {
                return this.isValid ? this.loc.locale : null;
            }
        },
        {
            key: "numberingSystem",
            get: function get() {
                return this.isValid ? this.loc.numberingSystem : null;
            }
        },
        {
            key: "outputCalendar",
            get: function get() {
                return this.isValid ? this.loc.outputCalendar : null;
            }
        },
        {
            key: "zone",
            get: function get() {
                return this._zone;
            }
        },
        {
            key: "zoneName",
            get: function get() {
                return this.isValid ? this.zone.name : null;
            }
        },
        {
            key: "year",
            get: function get() {
                return this.isValid ? this.c.year : NaN;
            }
        },
        {
            key: "quarter",
            get: function get() {
                return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
            }
        },
        {
            key: "month",
            get: function get() {
                return this.isValid ? this.c.month : NaN;
            }
        },
        {
            key: "day",
            get: function get() {
                return this.isValid ? this.c.day : NaN;
            }
        },
        {
            key: "hour",
            get: function get() {
                return this.isValid ? this.c.hour : NaN;
            }
        },
        {
            key: "minute",
            get: function get() {
                return this.isValid ? this.c.minute : NaN;
            }
        },
        {
            key: "second",
            get: function get() {
                return this.isValid ? this.c.second : NaN;
            }
        },
        {
            key: "millisecond",
            get: function get() {
                return this.isValid ? this.c.millisecond : NaN;
            }
        },
        {
            key: "weekYear",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$possiblyCachedWeekData(this).weekYear : NaN;
            }
        },
        {
            key: "weekNumber",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$possiblyCachedWeekData(this).weekNumber : NaN;
            }
        },
        {
            key: "weekday",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$possiblyCachedWeekData(this).weekday : NaN;
            }
        },
        {
            key: "isWeekend",
            get: function get() {
                return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
            }
        },
        {
            key: "localWeekday",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$possiblyCachedLocalWeekData(this).weekday : NaN;
            }
        },
        {
            key: "localWeekNumber",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$possiblyCachedLocalWeekData(this).weekNumber : NaN;
            }
        },
        {
            key: "localWeekYear",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$possiblyCachedLocalWeekData(this).weekYear : NaN;
            }
        },
        {
            key: "ordinal",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$gregorianToOrdinal(this.c).ordinal : NaN;
            }
        },
        {
            key: "monthShort",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$Info.months("short", {
                    locObj: this.loc
                })[this.month - 1] : null;
            }
        },
        {
            key: "monthLong",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$Info.months("long", {
                    locObj: this.loc
                })[this.month - 1] : null;
            }
        },
        {
            key: "weekdayShort",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$Info.weekdays("short", {
                    locObj: this.loc
                })[this.weekday - 1] : null;
            }
        },
        {
            key: "weekdayLong",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$Info.weekdays("long", {
                    locObj: this.loc
                })[this.weekday - 1] : null;
            }
        },
        {
            key: "offset",
            get: function get() {
                return this.isValid ? +this.o : NaN;
            }
        },
        {
            key: "offsetNameShort",
            get: function get() {
                if (this.isValid) return this.zone.offsetName(this.ts, {
                    format: "short",
                    locale: this.locale
                });
                else return null;
            }
        },
        {
            key: "offsetNameLong",
            get: function get() {
                if (this.isValid) return this.zone.offsetName(this.ts, {
                    format: "long",
                    locale: this.locale
                });
                else return null;
            }
        },
        {
            key: "isOffsetFixed",
            get: function get() {
                return this.isValid ? this.zone.isUniversal : null;
            }
        },
        {
            key: "isInDST",
            get: function get() {
                if (this.isOffsetFixed) return false;
                else return this.offset > this.set({
                    month: 1,
                    day: 1
                }).offset || this.offset > this.set({
                    month: 5
                }).offset;
            }
        },
        {
            key: "isInLeapYear",
            get: function get() {
                return $63618293c58b5f80$var$isLeapYear(this.year);
            }
        },
        {
            key: "daysInMonth",
            get: function get() {
                return $63618293c58b5f80$var$daysInMonth(this.year, this.month);
            }
        },
        {
            key: "daysInYear",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$daysInYear(this.year) : NaN;
            }
        },
        {
            key: "weeksInWeekYear",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$weeksInWeekYear(this.weekYear) : NaN;
            }
        },
        {
            key: "weeksInLocalWeekYear",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$weeksInWeekYear(this.localWeekYear, this.loc.getMinDaysInFirstWeek(), this.loc.getStartOfWeek()) : NaN;
            }
        }
    ], [
        {
            key: "DATE_SHORT",
            get: function get() {
                return $63618293c58b5f80$var$DATE_SHORT;
            }
        },
        {
            key: "DATE_MED",
            get: function get() {
                return $63618293c58b5f80$var$DATE_MED;
            }
        },
        {
            key: "DATE_MED_WITH_WEEKDAY",
            get: function get() {
                return $63618293c58b5f80$var$DATE_MED_WITH_WEEKDAY;
            }
        },
        {
            key: "DATE_FULL",
            get: function get() {
                return $63618293c58b5f80$var$DATE_FULL;
            }
        },
        {
            key: "DATE_HUGE",
            get: function get() {
                return $63618293c58b5f80$var$DATE_HUGE;
            }
        },
        {
            key: "TIME_SIMPLE",
            get: function get() {
                return $63618293c58b5f80$var$TIME_SIMPLE;
            }
        },
        {
            key: "TIME_WITH_SECONDS",
            get: function get() {
                return $63618293c58b5f80$var$TIME_WITH_SECONDS;
            }
        },
        {
            key: "TIME_WITH_SHORT_OFFSET",
            get: function get() {
                return $63618293c58b5f80$var$TIME_WITH_SHORT_OFFSET;
            }
        },
        {
            key: "TIME_WITH_LONG_OFFSET",
            get: function get() {
                return $63618293c58b5f80$var$TIME_WITH_LONG_OFFSET;
            }
        },
        {
            key: "TIME_24_SIMPLE",
            get: function get() {
                return $63618293c58b5f80$var$TIME_24_SIMPLE;
            }
        },
        {
            key: "TIME_24_WITH_SECONDS",
            get: function get() {
                return $63618293c58b5f80$var$TIME_24_WITH_SECONDS;
            }
        },
        {
            key: "TIME_24_WITH_SHORT_OFFSET",
            get: function get() {
                return $63618293c58b5f80$var$TIME_24_WITH_SHORT_OFFSET;
            }
        },
        {
            key: "TIME_24_WITH_LONG_OFFSET",
            get: function get() {
                return $63618293c58b5f80$var$TIME_24_WITH_LONG_OFFSET;
            }
        },
        {
            key: "DATETIME_SHORT",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_SHORT;
            }
        },
        {
            key: "DATETIME_SHORT_WITH_SECONDS",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_SHORT_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_MED",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_MED;
            }
        },
        {
            key: "DATETIME_MED_WITH_SECONDS",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_MED_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_MED_WITH_WEEKDAY",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_MED_WITH_WEEKDAY;
            }
        },
        {
            key: "DATETIME_FULL",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_FULL;
            }
        },
        {
            key: "DATETIME_FULL_WITH_SECONDS",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_FULL_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_HUGE",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_HUGE;
            }
        },
        {
            key: "DATETIME_HUGE_WITH_SECONDS",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_HUGE_WITH_SECONDS;
            }
        }
    ]);
    return DateTime;
}(Symbol.for("nodejs.util.inspect.custom"));
function $63618293c58b5f80$var$friendlyDateTime(dateTimeish) {
    if ($63618293c58b5f80$var$DateTime.isDateTime(dateTimeish)) return dateTimeish;
    else if (dateTimeish && dateTimeish.valueOf && $63618293c58b5f80$var$isNumber(dateTimeish.valueOf())) return $63618293c58b5f80$var$DateTime.fromJSDate(dateTimeish);
    else if (dateTimeish && typeof dateTimeish === "object") return $63618293c58b5f80$var$DateTime.fromObject(dateTimeish);
    else throw new $63618293c58b5f80$var$InvalidArgumentError("Unknown datetime argument: " + dateTimeish + ", of type " + typeof dateTimeish);
}
var $63618293c58b5f80$var$VERSION = "3.7.2";
$63618293c58b5f80$exports.DateTime = $63618293c58b5f80$var$DateTime;
$63618293c58b5f80$exports.Duration = $63618293c58b5f80$var$Duration;
$63618293c58b5f80$exports.FixedOffsetZone = $63618293c58b5f80$var$FixedOffsetZone;
$63618293c58b5f80$exports.IANAZone = $63618293c58b5f80$var$IANAZone;
$63618293c58b5f80$exports.Info = $63618293c58b5f80$var$Info;
$63618293c58b5f80$exports.Interval = $63618293c58b5f80$var$Interval;
$63618293c58b5f80$exports.InvalidZone = $63618293c58b5f80$var$InvalidZone;
$63618293c58b5f80$exports.Settings = $63618293c58b5f80$var$Settings;
$63618293c58b5f80$exports.SystemZone = $63618293c58b5f80$var$SystemZone;
$63618293c58b5f80$exports.VERSION = $63618293c58b5f80$var$VERSION;
$63618293c58b5f80$exports.Zone = $63618293c58b5f80$var$Zone;


class $87fb6b45cbec1b35$export$6341f9a885713487 {
    raw;
    parsed;
    constructor(raw){
        this.raw = raw;
        const parsed = (0, $63618293c58b5f80$exports.DateTime).fromISO(raw);
        if (!parsed.isValid) throw new Error(`Invalid date string: ${raw}`);
        this.parsed = parsed;
    }
    static fromNullable(dateStr) {
        return dateStr ? new this(dateStr) : undefined;
    }
    format() {
        if (this.raw.length === 4) return this.raw;
        if (this.raw.length === 7) return this.parsed.toFormat("LLL yyyy");
        return this.parsed.toFormat("LLL d, yyyy");
    }
    preposition() {
        return this.raw.length === 10 ? "on" : "in";
    }
}
const $87fb6b45cbec1b35$export$9b4babcb2601ee14 = [
    "city",
    "county",
    "state",
    "country"
];
const $87fb6b45cbec1b35$var$LAND_USE_POLICY_TYPE = [
    "add parking maximums",
    "reduce parking minimums",
    "remove parking minimums"
];
const $87fb6b45cbec1b35$export$8b870380ed23050a = [
    ...$87fb6b45cbec1b35$var$LAND_USE_POLICY_TYPE,
    "parking benefit district"
];
const $87fb6b45cbec1b35$export$81407a4013322c35 = [
    "adopted",
    "proposed",
    "repealed"
];
const $87fb6b45cbec1b35$export$eed2facac47d517c = "unknown";



/* eslint-disable camelcase */ 
function $5b2db79250e23091$export$73266bbb012b6bae(place) {
    const { name: name, state: state, country_code: country_code, type: type } = place;
    const country = (0, $b073965913779e61$export$35016c3166f10230)[country_code];
    if (!country) throw new Error(`Missing country in COUNTRY_MAPPING in data.ts: ${country_code}`);
    if (type === "country" && name === country) return name;
    return state ? `${name}, ${state}, ${country}` : `${name}, ${country}`;
}
function $5b2db79250e23091$export$2a6d3d49f650c5cb(place) {
    const { name: name, state: state, country: country, type: type } = place;
    if (type === "country" && name === country) return null;
    return state ? `${state}, ${country}` : country;
}
function $5b2db79250e23091$export$da6b3dcd53e78e95(place) {
    const { name: name, state: state } = place;
    return state ? `${name}, ${state}` : name;
}
function $5b2db79250e23091$export$e50b5874ee027a1b(placeId) {
    return placeId.normalize("NFD") // Decompose characters (ã → a + ˜)
    .replace(/[\u0300-\u036f]/g, "") // Remove combining diacritics
    .toLowerCase().replace(/'/g, "") // Remove '
    .replace(/[^a-z0-9]+/g, "-") // Replace non-alphanumeric with hyphens
    .replace(/^-+|-+$/g, ""); // Trim hyphens
}
function $5b2db79250e23091$export$e2a94b6b5508320(encodedPlace) {
    return `https://parkingreform.org/mandates-map/city_detail/${encodedPlace}.html`;
}



const $b073965913779e61$export$ccd6918840d0afb5 = new Set([
    "United States",
    "United Kingdom",
    "Netherlands"
]);
const $b073965913779e61$export$35016c3166f10230 = {
    AU: "Australia",
    AT: "Austria",
    BR: "Brazil",
    CA: "Canada",
    CH: "Switzerland",
    CK: "Cook Islands",
    CN: "China",
    DE: "Germany",
    DK: "Denmark",
    FI: "Finland",
    FR: "France",
    IE: "Ireland",
    IN: "India",
    IL: "Israel",
    IS: "Iceland",
    KR: "Korea",
    MX: "Mexico",
    NL: "Netherlands",
    NZ: "New Zealand",
    SE: "Sweden",
    SG: "Singapore",
    UK: "United Kingdom",
    US: "United States",
    ZA: "South Africa"
};
function $b073965913779e61$export$afcdeffb3d7e2205(raw) {
    return {
        ...raw,
        url: (0, $5b2db79250e23091$export$e2a94b6b5508320)(raw.encoded)
    };
}
function $b073965913779e61$export$8edda515ca9656ca(entry, status) {
    const hasPolicy = (policies)=>!!policies?.filter((policy)=>policy.status === status).length;
    const result = [];
    if (hasPolicy(entry.add_max)) result.push("add parking maximums");
    if (hasPolicy(entry.reduce_min)) result.push("reduce parking minimums");
    if (hasPolicy(entry.rm_min)) result.push("remove parking minimums");
    if (hasPolicy(entry.benefit_district)) result.push("parking benefit district");
    return result;
}
function $b073965913779e61$export$5cd154a4b5b202c7(entry) {
    const getStatuses = (policies)=>new Set(policies?.map((policy)=>policy.status) ?? []);
    return {
        "add parking maximums": getStatuses(entry.add_max),
        "reduce parking minimums": getStatuses(entry.reduce_min),
        "remove parking minimums": getStatuses(entry.rm_min),
        "parking benefit district": getStatuses(entry.benefit_district)
    };
}
function $b073965913779e61$var$processLandUsePolicy(raw) {
    return {
        ...raw,
        date: (0, $87fb6b45cbec1b35$export$6341f9a885713487).fromNullable(raw.date)
    };
}
function $b073965913779e61$var$processBenefitDistrict(raw) {
    return {
        ...raw,
        date: (0, $87fb6b45cbec1b35$export$6341f9a885713487).fromNullable(raw.date)
    };
}
function $b073965913779e61$export$bb23fe9efc5acd72(raw) {
    const result = {
        place: $b073965913779e61$export$afcdeffb3d7e2205(raw.place)
    };
    if (raw.add_max) result.add_max = raw.add_max.map($b073965913779e61$var$processLandUsePolicy);
    if (raw.reduce_min) result.reduce_min = raw.reduce_min.map($b073965913779e61$var$processLandUsePolicy);
    if (raw.rm_min) result.rm_min = raw.rm_min.map($b073965913779e61$var$processLandUsePolicy);
    if (raw.benefit_district) result.benefit_district = raw.benefit_district.map($b073965913779e61$var$processBenefitDistrict);
    return result;
}

async function $b073965913779e61$export$2e2bcd8739ae039() {
    const rawData = await (parcelRequire("39AN4"));
    return Object.fromEntries(Object.entries(rawData).map(([placeId, entry])=>[
            placeId,
            $b073965913779e61$export$bb23fe9efc5acd72(entry)
        ]));
}
function $b073965913779e61$export$93c58db10be137ea(array, predicate) {
    return array.reduce((indexes, currentValue, currentIndex)=>{
        if (predicate(currentValue)) indexes.push(currentIndex);
        return indexes;
    }, []);
}


const $924e72120b481a6c$export$b2341593fdbbb0b7 = [
    [
        "100",
        100
    ],
    [
        "5k",
        5000
    ],
    [
        "25k",
        25000
    ],
    [
        "50k",
        50000
    ],
    [
        "100k",
        100000
    ],
    [
        "500k",
        500000
    ],
    [
        "1M",
        1000000
    ],
    [
        "75M",
        750000000
    ]
];
const $924e72120b481a6c$export$e68f611676b33aaa = [
    "any parking reform",
    ...(0, $87fb6b45cbec1b35$export$8b870380ed23050a)
];
function $924e72120b481a6c$export$9e7fa3578a5a2a3f(filterState) {
    return filterState.policyTypeFilter === "remove parking minimums" && filterState.status === "adopted";
}
function $924e72120b481a6c$export$177f84df50af9f16(filterState) {
    return filterState.allMinimumsRemovedToggle && $924e72120b481a6c$export$9e7fa3578a5a2a3f(filterState);
}
class $924e72120b481a6c$export$eade628d430495c7 {
    state;
    entries;
    cache = null;
    constructor(entries, initialState){
        this.entries = entries;
        this.state = new (0, $cc4b70f67be6e72e$export$2e2bcd8739ae039)("FilterState", initialState);
    }
    get totalNumPlaces() {
        return Object.keys(this.entries).length;
    }
    get matchedPlaces() {
        return this.ensureCache().matchedPlaces;
    }
    get placeIds() {
        return new Set(Object.keys(this.matchedPlaces));
    }
    get matchedCountries() {
        return this.ensureCache().matchedCountries;
    }
    get matchedPlaceTypes() {
        return this.ensureCache().matchedPlaceTypes;
    }
    /// The policy types the matched places have.
    ///
    /// This is only set when the policy type is 'any parking reform'.
    ///
    /// Stores all policy types belonging to matched places, even if the
    /// filter state is set to ignore that policy type.
    get matchedPolicyTypes() {
        return this.ensureCache().matchedPolicyTypesForAnyPolicy;
    }
    getState() {
        return this.state.getValue();
    }
    update(changes) {
        const priorState = this.state.getValue();
        this.state.setValue({
            ...priorState,
            ...changes
        });
    }
    subscribe(id, observer) {
        this.state.subscribe(observer, id);
    }
    initialize() {
        this.state.initialize();
    }
    /// Recompute the CacheEntry if FilterState has changed.
    ensureCache() {
        const currentState = this.state.getValue();
        if (this.cache && (0, $07a598d7bdcdfb03$export$2e2bcd8739ae039)(currentState, this.cache.state)) return this.cache;
        const matchedPlaces = {};
        const matchedCountries = new Set();
        const matchedPolicyTypes = new Set();
        const matchedPlaceTypes = new Set();
        for (const placeId of Object.keys(this.entries)){
            const match = this.getPlaceMatch(placeId);
            if (!match) continue;
            matchedPlaces[placeId] = match;
            matchedCountries.add(this.entries[placeId].place.country);
            matchedPlaceTypes.add(this.entries[placeId].place.type);
            if (match.type === "any") {
                if (match.hasAddMax) matchedPolicyTypes.add("add parking maximums");
                if (match.hasReduceMin) matchedPolicyTypes.add("reduce parking minimums");
                if (match.hasRmMin) matchedPolicyTypes.add("remove parking minimums");
                if (match.hasBenefitDistrict) matchedPolicyTypes.add("parking benefit district");
            }
        }
        this.cache = {
            state: currentState,
            matchedPlaces: matchedPlaces,
            matchedCountries: matchedCountries,
            matchedPolicyTypesForAnyPolicy: matchedPolicyTypes,
            matchedPlaceTypes: matchedPlaceTypes
        };
        return this.cache;
    }
    matchesPlace(place) {
        const filterState = this.state.getValue();
        const isPlaceType = filterState.placeType.has(place.type);
        if (!isPlaceType) return false;
        const isCountry = filterState.country.has(place.country);
        if (!isCountry) return false;
        const isAllMinimumsRepealed = !$924e72120b481a6c$export$177f84df50af9f16(filterState) || place.repeal;
        if (!isAllMinimumsRepealed) return false;
        const [sliderLeftIndex, sliderRightIndex] = filterState.populationSliderIndexes;
        const isPopulation = place.pop >= $924e72120b481a6c$export$b2341593fdbbb0b7[sliderLeftIndex][1] && place.pop <= $924e72120b481a6c$export$b2341593fdbbb0b7[sliderRightIndex][1];
        return isPopulation;
    }
    matchesLandUsePolicy(policyRecord, options) {
        const filterState = this.state.getValue();
        const isStatus = policyRecord.status === filterState.status;
        if (!isStatus) return false;
        const isYear = filterState.year.has(policyRecord.date?.parsed.year.toString() || (0, $87fb6b45cbec1b35$export$eed2facac47d517c));
        if (!isYear) return false;
        if (!options.ignoreScope) {
            const isScope = policyRecord.scope.some((v)=>filterState.scope.has(v));
            if (!isScope) return false;
        }
        if (!options.ignoreLand) {
            const isLand = policyRecord.land.some((v)=>filterState.landUse.has(v));
            if (!isLand) return false;
        }
        return true;
    }
    matchesBenefitDistrict(record) {
        const filterState = this.state.getValue();
        const isStatus = record.status === filterState.status;
        if (!isStatus) return false;
        const isYear = filterState.year.has(record.date?.parsed.year.toString() || (0, $87fb6b45cbec1b35$export$eed2facac47d517c));
        if (!isYear) return false;
        return true;
    }
    getPlaceMatch(placeId) {
        const filterState = this.state.getValue();
        const entry = this.entries[placeId];
        // Search overrides filter config.
        if (filterState.searchInput) return filterState.searchInput === placeId ? {
            type: "search"
        } : null;
        const isPlace = this.matchesPlace(entry.place);
        if (!isPlace) return null;
        if (filterState.policyTypeFilter === "any parking reform") {
            const policyTypes = (0, $b073965913779e61$export$8edda515ca9656ca)(entry, filterState.status);
            const isPolicyType = policyTypes.some((v)=>filterState.includedPolicyChanges.has(v));
            return isPolicyType ? {
                type: "any",
                hasAddMax: policyTypes.includes("add parking maximums"),
                hasReduceMin: policyTypes.includes("reduce parking minimums"),
                hasRmMin: policyTypes.includes("remove parking minimums"),
                hasBenefitDistrict: policyTypes.includes("parking benefit district")
            } : null;
        }
        if (filterState.policyTypeFilter === "add parking maximums") {
            const matchingPolicies = (0, $b073965913779e61$export$93c58db10be137ea)(entry.add_max ?? [], (policyRecord)=>this.matchesLandUsePolicy(policyRecord, {}));
            return matchingPolicies.length ? {
                type: "single policy",
                policyType: "add parking maximums",
                matchingIndexes: matchingPolicies
            } : null;
        }
        if (filterState.policyTypeFilter === "reduce parking minimums") {
            const matchingPolicies = (0, $b073965913779e61$export$93c58db10be137ea)(entry.reduce_min ?? [], (policyRecord)=>this.matchesLandUsePolicy(policyRecord, {}));
            return matchingPolicies.length ? {
                type: "single policy",
                policyType: "reduce parking minimums",
                matchingIndexes: matchingPolicies
            } : null;
        }
        if (filterState.policyTypeFilter === "remove parking minimums") {
            // If 'all minimums removed' is in effect, then 'land use' and 'scope' are irrelevent:
            //  - the place will only have a single policy record for minimum removal
            //  - that policy record must be set to "All uses" and "Citywide"
            const allMinimumsInEffect = $924e72120b481a6c$export$177f84df50af9f16(filterState);
            const options = {
                ignoreScope: allMinimumsInEffect,
                ignoreLand: allMinimumsInEffect
            };
            const matchingPolicies = (0, $b073965913779e61$export$93c58db10be137ea)(entry.rm_min ?? [], (policyRecord)=>this.matchesLandUsePolicy(policyRecord, options));
            return matchingPolicies.length ? {
                type: "single policy",
                policyType: "remove parking minimums",
                matchingIndexes: matchingPolicies
            } : null;
        }
        if (filterState.policyTypeFilter === "parking benefit district") {
            const matchingPolicies = (0, $b073965913779e61$export$93c58db10be137ea)(entry.benefit_district ?? [], (record)=>this.matchesBenefitDistrict(record));
            return matchingPolicies.length ? {
                type: "single policy",
                policyType: "parking benefit district",
                matchingIndexes: matchingPolicies
            } : null;
        }
        throw new Error(`Unrecognized policy type`);
    }
}



function $cee5810d0adc6215$export$21a9821bbe457cb0(elements, state) {
    // eslint-disable-next-line no-param-reassign
    elements.outerContainer.hidden = state.hidden;
    // eslint-disable-next-line no-param-reassign
    elements.accordionTitle.textContent = `${state.title}${state.supplementalTitle ?? ""}`;
    const upIcon = elements.accordionButton.querySelector(".fa-chevron-up");
    const downIcon = elements.accordionButton.querySelector(".fa-chevron-down");
    if (!upIcon || !downIcon) return;
    elements.accordionButton.setAttribute("aria-expanded", state.expanded.toString());
    // eslint-disable-next-line no-param-reassign
    elements.contentContainer.hidden = !state.expanded;
    upIcon.style.display = state.expanded ? "block" : "none";
    downIcon.style.display = state.expanded ? "none" : "block";
}
function $cee5810d0adc6215$export$da2458c7aedbc821(inputId, inputName, checked, description) {
    const label = document.createElement("label");
    label.className = "filter-checkbox";
    label.htmlFor = inputId;
    const input = document.createElement("input");
    input.type = "checkbox";
    input.name = inputName;
    input.id = inputId;
    input.checked = checked;
    const squareIcon = document.createElement("i");
    squareIcon.className = "fa-regular fa-square";
    squareIcon.ariaHidden = "true";
    const checkedIcon = document.createElement("i");
    checkedIcon.className = "fa-solid fa-square-check";
    checkedIcon.ariaHidden = "true";
    const span = document.createElement("span");
    span.textContent = description;
    label.appendChild(input);
    label.appendChild(squareIcon);
    label.appendChild(checkedIcon);
    label.appendChild(span);
    return [
        label,
        input
    ];
}
function $cee5810d0adc6215$export$4d3a0044e7678a67(htmlName) {
    const outerContainer = document.createElement("div");
    outerContainer.className = "filter-accordion";
    const buttonId = `filter-accordion-toggle-${htmlName}`;
    const contentId = `filter-accordion-content-${htmlName}`;
    const titleId = `filter-accordion-title-${htmlName}`;
    const accordionButton = document.createElement("button");
    // Turn off clicking "submitting" the form, which reloads the page.
    accordionButton.type = "button";
    accordionButton.id = buttonId;
    accordionButton.className = "filter-accordion-toggle";
    accordionButton.ariaExpanded = "false";
    accordionButton.setAttribute("aria-controls", contentId);
    const accordionTitle = document.createElement("span");
    accordionTitle.id = titleId;
    accordionTitle.className = "filter-accordion-title";
    accordionButton.appendChild(accordionTitle);
    const accordionIconContainer = document.createElement("div");
    accordionIconContainer.className = "filter-accordion-icon-container";
    accordionIconContainer.ariaHidden = "true";
    const downIcon = document.createElement("i");
    downIcon.className = "fa-solid fa-chevron-down";
    downIcon.title = "expand option checkboxes";
    const upIcon = document.createElement("i");
    upIcon.className = "fa-solid fa-chevron-up";
    upIcon.title = "collapse option checkboxes";
    accordionIconContainer.appendChild(downIcon);
    accordionIconContainer.appendChild(upIcon);
    accordionButton.appendChild(accordionIconContainer);
    outerContainer.appendChild(accordionButton);
    const contentContainer = document.createElement("div");
    contentContainer.id = contentId;
    contentContainer.className = "filter-accordion-content";
    contentContainer.setAttribute("aria-describedby", titleId);
    outerContainer.appendChild(contentContainer);
    return {
        outerContainer: outerContainer,
        accordionTitle: accordionTitle,
        accordionButton: accordionButton,
        contentContainer: contentContainer
    };
}





const $2f73981580161403$var$THUMBSIZE = 24;
const $2f73981580161403$export$74d78e896cd7f00b = (0, $924e72120b481a6c$export$b2341593fdbbb0b7).length - 1;
function $2f73981580161403$var$determineSupplementalTitle(populationSliderIndexes) {
    const [leftIndex, rightIndex] = populationSliderIndexes;
    const leftLabel = (0, $924e72120b481a6c$export$b2341593fdbbb0b7)[leftIndex][0];
    const rightLabel = (0, $924e72120b481a6c$export$b2341593fdbbb0b7)[rightIndex][0];
    return ` (${leftLabel}-${rightLabel})`;
}
function $2f73981580161403$var$generateSliders(initialPopulationSliderIndexes, optionsContainer) {
    const accordionElements = (0, $cee5810d0adc6215$export$4d3a0044e7678a67)("population-slider");
    const container = document.createElement("div");
    container.className = "population-slider-container";
    const label = document.createElement("div");
    label.id = "population-slider-label";
    container.append(label);
    const controls = document.createElement("div");
    controls.className = "population-slider-controls";
    container.append(controls);
    const left = document.createElement("input");
    left.setAttribute("aria-labelledby", "population-slider-label");
    left.className = "population-slider-left";
    left.name = "min";
    left.type = "range";
    left.step = "0.5";
    left.min = "0";
    left.value = "0";
    controls.append(left);
    const right = document.createElement("input");
    right.setAttribute("aria-labelledby", "population-slider-label");
    right.className = "population-slider-right";
    right.name = "max";
    right.type = "range";
    right.step = "0.5";
    right.min = "0";
    controls.append(right);
    const accordionState = new (0, $cc4b70f67be6e72e$export$2e2bcd8739ae039)(`filter accordion population`, {
        hidden: false,
        expanded: false,
        title: "Population",
        supplementalTitle: $2f73981580161403$var$determineSupplementalTitle(initialPopulationSliderIndexes)
    });
    accordionState.subscribe((state)=>(0, $cee5810d0adc6215$export$21a9821bbe457cb0)(accordionElements, state));
    accordionElements.accordionButton.addEventListener("click", ()=>{
        const priorState = accordionState.getValue();
        accordionState.setValue({
            ...priorState,
            expanded: !priorState.expanded
        });
    });
    accordionElements.contentContainer.append(container);
    optionsContainer.append(accordionElements.outerContainer);
    return [
        {
            controls: controls,
            label: label,
            left: left,
            right: right
        },
        accordionState
    ];
}
function $2f73981580161403$var$updateSlidersUI(populationSliderIndexes, sliders) {
    const [leftIndex, rightIndex] = populationSliderIndexes;
    // eslint-disable-next-line no-param-reassign
    sliders.left.value = leftIndex.toString();
    // eslint-disable-next-line no-param-reassign
    sliders.right.value = rightIndex.toString();
    sliders.left.setAttribute("value", leftIndex.toString());
    sliders.right.setAttribute("value", rightIndex.toString());
    // We dynamically change the sliders so that they cannot extend past each other.
    const inBetween = (rightIndex - leftIndex) / 2;
    const newLeftMax = leftIndex + inBetween;
    const newRightMin = rightIndex - inBetween;
    sliders.left.setAttribute("max", newLeftMax.toString());
    sliders.right.setAttribute("min", newRightMin.toString());
    const intervalSizePx = Math.round((sliders.controls.offsetWidth + $2f73981580161403$var$THUMBSIZE / 2) / (0, $924e72120b481a6c$export$b2341593fdbbb0b7).length);
    const leftWidth = newLeftMax * intervalSizePx;
    const rightWidth = ($2f73981580161403$export$74d78e896cd7f00b - newRightMin) * intervalSizePx;
    // eslint-disable-next-line no-param-reassign
    sliders.left.style.width = `${leftWidth + $2f73981580161403$var$THUMBSIZE / 2}px`;
    // eslint-disable-next-line no-param-reassign
    sliders.right.style.width = `${rightWidth + $2f73981580161403$var$THUMBSIZE / 2}px`;
    // The left slider has a fixed anchor. However, the right slider has to move
    // everytime the range of the slider changes.
    // eslint-disable-next-line no-param-reassign
    sliders.right.style.left = `${leftWidth + $2f73981580161403$var$THUMBSIZE}px`;
    const leftLabel = (0, $924e72120b481a6c$export$b2341593fdbbb0b7)[leftIndex][0];
    const rightLabel = (0, $924e72120b481a6c$export$b2341593fdbbb0b7)[rightIndex][0];
    // eslint-disable-next-line no-param-reassign
    sliders.label.innerHTML = `${leftLabel} - ${rightLabel} residents`;
}
function $2f73981580161403$export$e80c029a0181b2d1(filterManager, optionsContainer) {
    const { populationSliderIndexes: populationSliderIndexes } = filterManager.getState();
    const [sliders, accordionStateObservable] = $2f73981580161403$var$generateSliders(populationSliderIndexes, optionsContainer);
    // Set initial state.
    const maxIndex = $2f73981580161403$export$74d78e896cd7f00b.toString();
    sliders.left.setAttribute("max", maxIndex);
    sliders.right.setAttribute("max", maxIndex);
    sliders.right.setAttribute("value", populationSliderIndexes[1].toString());
    // Add event listeners.
    const onChange = ()=>{
        const leftIndex = Math.floor(parseFloat(sliders.left.value));
        const rightIndex = Math.ceil(parseFloat(sliders.right.value));
        filterManager.update({
            populationSliderIndexes: [
                leftIndex,
                rightIndex
            ]
        });
    };
    sliders.left.addEventListener("input", onChange);
    sliders.right.addEventListener("input", onChange);
    // Update UI whenever accordion is expanded. Note that the accordion
    // must be visible for the width calculations to work.
    accordionStateObservable.subscribe(({ hidden: hidden })=>{
        if (!hidden && !optionsContainer.hidden) $2f73981580161403$var$updateSlidersUI(filterManager.getState().populationSliderIndexes, sliders);
    }, "render population slider");
    // Also update UI when values change
    filterManager.subscribe("update population sliders", (state)=>{
        const accordionPriorState = accordionStateObservable.getValue();
        accordionStateObservable.setValue({
            ...accordionPriorState,
            supplementalTitle: $2f73981580161403$var$determineSupplementalTitle(state.populationSliderIndexes)
        });
        if (!accordionStateObservable.getValue().hidden && !optionsContainer.hidden) $2f73981580161403$var$updateSlidersUI(state.populationSliderIndexes, sliders);
    });
    accordionStateObservable.initialize();
}


var $4d47eec48a4bad18$exports = {};
$4d47eec48a4bad18$exports = JSON.parse("{\"merged\":{\"placeType\":[\"city\",\"country\",\"county\",\"state\"],\"country\":[\"United States\",\"Australia\",\"Austria\",\"Brazil\",\"Canada\",\"China\",\"Cook Islands\",\"Denmark\",\"Finland\",\"France\",\"Germany\",\"Iceland\",\"India\",\"Ireland\",\"Israel\",\"Korea\",\"Mexico\",\"Netherlands\",\"New Zealand\",\"Singapore\",\"South Africa\",\"Sweden\",\"Switzerland\",\"United Kingdom\"],\"scope\":[\"city center / business district\",\"citywide\",\"main street / special\",\"regional\",\"transit-oriented\"],\"landUse\":[\"all uses\",\"commercial\",\"industrial\",\"medical\",\"other\",\"residential, all uses\",\"residential, low-density\",\"residential, multi-family\"],\"year\":[\"unknown\",\"2026\",\"2025\",\"2024\",\"2023\",\"2022\",\"2021\",\"2020\",\"2019\",\"2018\",\"2017\",\"2016\",\"2015\",\"2014\",\"2013\",\"2012\",\"2011\",\"2010\",\"2009\",\"2008\",\"2007\",\"2006\",\"2005\",\"2004\",\"2003\",\"2002\",\"2001\",\"2000\",\"1999\",\"1998\",\"1997\",\"1995\",\"1994\",\"1993\",\"1992\",\"1991\",\"1989\",\"1988\",\"1987\",\"1986\",\"1985\",\"1984\",\"1982\",\"1980\",\"1979\",\"1976\",\"1970\",\"1967\",\"1966\",\"1964\",\"1962\",\"1960\",\"1958\",\"1957\",\"1952\",\"1940\"]},\"anyAdopted\":{\"placeType\":[\"city\",\"country\",\"county\",\"state\"],\"country\":[\"United States\",\"Australia\",\"Austria\",\"Brazil\",\"Canada\",\"China\",\"Denmark\",\"France\",\"Germany\",\"Iceland\",\"India\",\"Ireland\",\"Israel\",\"Korea\",\"Mexico\",\"Netherlands\",\"New Zealand\",\"Singapore\",\"South Africa\",\"Sweden\",\"Switzerland\",\"United Kingdom\"],\"scope\":[\"city center / business district\",\"citywide\",\"main street / special\",\"regional\",\"transit-oriented\"],\"landUse\":[\"all uses\",\"commercial\",\"industrial\",\"medical\",\"other\",\"residential, all uses\",\"residential, low-density\",\"residential, multi-family\"],\"year\":[\"unknown\",\"2026\",\"2025\",\"2024\",\"2023\",\"2022\",\"2021\",\"2020\",\"2019\",\"2018\",\"2017\",\"2016\",\"2015\",\"2014\",\"2013\",\"2012\",\"2011\",\"2010\",\"2009\",\"2008\",\"2007\",\"2006\",\"2005\",\"2004\",\"2003\",\"2002\",\"2001\",\"2000\",\"1999\",\"1998\",\"1997\",\"1995\",\"1994\",\"1993\",\"1992\",\"1991\",\"1989\",\"1988\",\"1987\",\"1986\",\"1985\",\"1984\",\"1982\",\"1980\",\"1979\",\"1976\",\"1970\",\"1967\",\"1966\",\"1964\",\"1962\",\"1960\",\"1958\",\"1957\",\"1952\",\"1940\"]},\"anyProposed\":{\"placeType\":[\"city\",\"country\",\"state\"],\"country\":[\"United States\",\"Australia\",\"Canada\",\"Cook Islands\",\"Finland\"],\"scope\":[\"city center / business district\",\"citywide\",\"main street / special\",\"regional\",\"transit-oriented\"],\"landUse\":[\"all uses\",\"commercial\",\"industrial\",\"medical\",\"other\",\"residential, all uses\",\"residential, low-density\",\"residential, multi-family\"],\"year\":[\"unknown\",\"2026\",\"2025\",\"2024\",\"2023\",\"2022\",\"2021\",\"2020\",\"2019\",\"2018\",\"2017\",\"2016\",\"2015\",\"2014\",\"2013\",\"2012\",\"2011\",\"2010\",\"2009\",\"2008\",\"2007\",\"2003\",\"2002\"]},\"anyRepealed\":{\"placeType\":[\"city\",\"state\"],\"country\":[\"United States\",\"China\"],\"scope\":[\"city center / business district\",\"citywide\",\"main street / special\",\"transit-oriented\"],\"landUse\":[\"all uses\",\"commercial\",\"industrial\",\"residential, all uses\"],\"year\":[\"unknown\",\"2023\"]},\"addMaxAdopted\":{\"placeType\":[\"city\",\"country\",\"county\",\"state\"],\"country\":[\"United States\",\"Australia\",\"Austria\",\"Brazil\",\"Canada\",\"China\",\"Denmark\",\"Germany\",\"Iceland\",\"India\",\"Ireland\",\"Israel\",\"Korea\",\"Mexico\",\"Netherlands\",\"Singapore\",\"Sweden\",\"Switzerland\",\"United Kingdom\"],\"scope\":[\"city center / business district\",\"citywide\",\"main street / special\",\"regional\",\"transit-oriented\"],\"landUse\":[\"all uses\",\"commercial\",\"industrial\",\"medical\",\"other\",\"residential, all uses\",\"residential, low-density\",\"residential, multi-family\"],\"year\":[\"unknown\",\"2026\",\"2025\",\"2024\",\"2023\",\"2022\",\"2021\",\"2020\",\"2019\",\"2018\",\"2017\",\"2015\",\"2013\",\"2009\",\"2008\",\"2007\",\"2006\",\"2000\",\"1998\",\"1997\",\"1995\",\"1967\",\"1964\",\"1958\"]},\"addMaxProposed\":{\"placeType\":[\"city\"],\"country\":[\"United States\",\"Canada\"],\"scope\":[\"city center / business district\",\"citywide\",\"main street / special\",\"transit-oriented\"],\"landUse\":[\"all uses\",\"commercial\",\"industrial\",\"medical\",\"other\",\"residential, all uses\"],\"year\":[\"unknown\",\"2026\",\"2025\",\"2024\",\"2023\",\"2022\",\"2021\",\"2020\",\"2019\",\"2018\",\"2017\",\"2016\",\"2015\",\"2014\",\"2013\",\"2012\",\"2011\",\"2010\",\"2009\",\"2008\",\"2007\",\"2003\"]},\"addMaxRepealed\":{\"placeType\":[\"city\",\"state\"],\"country\":[\"United States\",\"China\"],\"scope\":[\"citywide\"],\"landUse\":[\"all uses\",\"commercial\",\"industrial\",\"residential, all uses\"],\"year\":[\"unknown\"]},\"reduceMinAdopted\":{\"placeType\":[\"city\",\"country\",\"county\",\"state\"],\"country\":[\"United States\",\"Australia\",\"Austria\",\"Canada\",\"Denmark\",\"France\",\"Germany\",\"Iceland\",\"Ireland\",\"Israel\",\"Singapore\",\"South Africa\",\"Sweden\",\"Switzerland\"],\"scope\":[\"city center / business district\",\"citywide\",\"main street / special\",\"regional\",\"transit-oriented\"],\"landUse\":[\"all uses\",\"commercial\",\"industrial\",\"medical\",\"other\",\"residential, all uses\",\"residential, low-density\",\"residential, multi-family\"],\"year\":[\"unknown\",\"2026\",\"2025\",\"2024\",\"2023\",\"2022\",\"2021\",\"2020\",\"2019\",\"2018\",\"2017\",\"2016\",\"2014\",\"2013\",\"2011\",\"2010\",\"2008\",\"2007\",\"2006\",\"2004\",\"2003\",\"2000\",\"1999\",\"1998\",\"1997\",\"1994\",\"1991\",\"1989\",\"1987\",\"1984\",\"1982\",\"1970\",\"1960\",\"1957\"]},\"reduceMinProposed\":{\"placeType\":[\"city\",\"country\"],\"country\":[\"United States\",\"Australia\",\"Canada\",\"Cook Islands\"],\"scope\":[\"city center / business district\",\"citywide\",\"main street / special\",\"regional\"],\"landUse\":[\"all uses\",\"commercial\",\"other\",\"residential, all uses\",\"residential, low-density\",\"residential, multi-family\"],\"year\":[\"unknown\",\"2026\",\"2025\",\"2024\",\"2023\",\"2022\",\"2021\",\"2017\",\"2016\",\"2015\",\"2007\"]},\"reduceMinRepealed\":{\"placeType\":[\"city\"],\"country\":[\"United States\"],\"scope\":[\"city center / business district\",\"transit-oriented\"],\"landUse\":[\"all uses\",\"commercial\"],\"year\":[\"unknown\"]},\"rmMinAdopted\":{\"placeType\":[\"city\",\"country\",\"county\",\"state\"],\"country\":[\"United States\",\"Australia\",\"Brazil\",\"Canada\",\"China\",\"France\",\"Germany\",\"India\",\"Ireland\",\"Israel\",\"Mexico\",\"New Zealand\",\"Singapore\",\"South Africa\",\"Sweden\",\"Switzerland\",\"United Kingdom\"],\"scope\":[\"city center / business district\",\"citywide\",\"main street / special\",\"regional\",\"transit-oriented\"],\"landUse\":[\"all uses\",\"commercial\",\"industrial\",\"medical\",\"other\",\"residential, all uses\",\"residential, low-density\",\"residential, multi-family\"],\"year\":[\"unknown\",\"2026\",\"2025\",\"2024\",\"2023\",\"2022\",\"2021\",\"2020\",\"2019\",\"2018\",\"2017\",\"2016\",\"2015\",\"2014\",\"2013\",\"2012\",\"2011\",\"2010\",\"2009\",\"2008\",\"2007\",\"2006\",\"2005\",\"2002\",\"2001\",\"2000\",\"1999\",\"1998\",\"1997\",\"1995\",\"1992\",\"1989\",\"1988\",\"1986\",\"1985\",\"1984\",\"1980\",\"1979\",\"1976\",\"1970\",\"1966\",\"1962\",\"1957\",\"1952\",\"1940\"]},\"rmMinProposed\":{\"placeType\":[\"city\",\"state\"],\"country\":[\"United States\",\"Canada\",\"Finland\"],\"scope\":[\"city center / business district\",\"citywide\",\"main street / special\",\"regional\",\"transit-oriented\"],\"landUse\":[\"all uses\",\"commercial\",\"industrial\",\"medical\",\"other\",\"residential, all uses\",\"residential, low-density\",\"residential, multi-family\"],\"year\":[\"unknown\",\"2026\",\"2025\",\"2024\",\"2023\",\"2022\",\"2021\",\"2020\",\"2019\",\"2018\",\"2017\",\"2016\",\"2015\",\"2013\",\"2012\",\"2009\",\"2008\",\"2007\",\"2002\"]},\"rmMinRepealed\":{\"placeType\":[\"city\"],\"country\":[\"United States\"],\"scope\":[\"city center / business district\",\"citywide\",\"main street / special\"],\"landUse\":[\"all uses\",\"residential, all uses\"],\"year\":[\"unknown\",\"2023\"]},\"benefitDistrictAdopted\":{\"placeType\":[\"city\"],\"country\":[\"United States\"],\"scope\":[],\"landUse\":[],\"year\":[\"2023\",\"2019\",\"1993\"]},\"benefitDistrictProposed\":{\"placeType\":[\"city\"],\"country\":[\"United States\"],\"scope\":[],\"landUse\":[],\"year\":[\"2025\",\"2020\",\"2019\",\"2013\",\"2009\",\"2007\"]},\"benefitDistrictRepealed\":{\"placeType\":[],\"country\":[],\"scope\":[],\"landUse\":[],\"year\":[]}}");



const $7d90c7ac1787964b$export$453542b5fbc69a48 = {
    merged: {
        includedPolicyChanges: (0, $87fb6b45cbec1b35$export$8b870380ed23050a),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($4d47eec48a4bad18$exports))).merged
    },
    datasets: {
        "any parking reform": {
            adopted: {
                includedPolicyChanges: (0, $87fb6b45cbec1b35$export$8b870380ed23050a),
                ...(0, (/*@__PURE__*/$parcel$interopDefault($4d47eec48a4bad18$exports))).anyAdopted
            },
            proposed: {
                includedPolicyChanges: (0, $87fb6b45cbec1b35$export$8b870380ed23050a),
                ...(0, (/*@__PURE__*/$parcel$interopDefault($4d47eec48a4bad18$exports))).anyProposed
            },
            repealed: {
                includedPolicyChanges: (0, $87fb6b45cbec1b35$export$8b870380ed23050a),
                ...(0, (/*@__PURE__*/$parcel$interopDefault($4d47eec48a4bad18$exports))).anyRepealed
            }
        },
        "add parking maximums": {
            adopted: {
                includedPolicyChanges: [],
                ...(0, (/*@__PURE__*/$parcel$interopDefault($4d47eec48a4bad18$exports))).addMaxAdopted
            },
            proposed: {
                includedPolicyChanges: [],
                ...(0, (/*@__PURE__*/$parcel$interopDefault($4d47eec48a4bad18$exports))).addMaxProposed
            },
            repealed: {
                includedPolicyChanges: [],
                ...(0, (/*@__PURE__*/$parcel$interopDefault($4d47eec48a4bad18$exports))).addMaxRepealed
            }
        },
        "reduce parking minimums": {
            adopted: {
                includedPolicyChanges: [],
                ...(0, (/*@__PURE__*/$parcel$interopDefault($4d47eec48a4bad18$exports))).reduceMinAdopted
            },
            proposed: {
                includedPolicyChanges: [],
                ...(0, (/*@__PURE__*/$parcel$interopDefault($4d47eec48a4bad18$exports))).reduceMinProposed
            },
            repealed: {
                includedPolicyChanges: [],
                ...(0, (/*@__PURE__*/$parcel$interopDefault($4d47eec48a4bad18$exports))).reduceMinRepealed
            }
        },
        "remove parking minimums": {
            adopted: {
                includedPolicyChanges: [],
                ...(0, (/*@__PURE__*/$parcel$interopDefault($4d47eec48a4bad18$exports))).rmMinAdopted
            },
            proposed: {
                includedPolicyChanges: [],
                ...(0, (/*@__PURE__*/$parcel$interopDefault($4d47eec48a4bad18$exports))).rmMinProposed
            },
            repealed: {
                includedPolicyChanges: [],
                ...(0, (/*@__PURE__*/$parcel$interopDefault($4d47eec48a4bad18$exports))).rmMinRepealed
            }
        },
        "parking benefit district": {
            adopted: {
                includedPolicyChanges: [],
                ...(0, (/*@__PURE__*/$parcel$interopDefault($4d47eec48a4bad18$exports))).benefitDistrictAdopted
            },
            proposed: {
                includedPolicyChanges: [],
                ...(0, (/*@__PURE__*/$parcel$interopDefault($4d47eec48a4bad18$exports))).benefitDistrictProposed
            },
            repealed: {
                includedPolicyChanges: [],
                ...(0, (/*@__PURE__*/$parcel$interopDefault($4d47eec48a4bad18$exports))).benefitDistrictRepealed
            }
        }
    },
    getOptions (policyType, status) {
        return this.datasets[policyType][status];
    },
    enabled (policyType, status) {
        return this.datasets[policyType][status].placeType.length > 0;
    }
};
function $7d90c7ac1787964b$var$getVisibleCheckboxes(fieldset) {
    const allCheckboxes = fieldset.querySelectorAll('input[type="checkbox"]');
    return Array.from(allCheckboxes).filter((checkbox)=>!checkbox.parentElement?.hidden);
}
function $7d90c7ac1787964b$var$extractLabel(input, preserveCapitalization) {
    const text = input.parentElement?.textContent?.trim();
    return preserveCapitalization ? text : text?.toLowerCase();
}
function $7d90c7ac1787964b$export$1842d958cb35ba79(fieldset, preserveCapitalization) {
    return new Set(Array.from(fieldset.querySelectorAll('input[type="checkbox"]:checked')).map((input)=>$7d90c7ac1787964b$var$extractLabel(input, preserveCapitalization)).filter((x)=>x !== undefined));
}
function $7d90c7ac1787964b$export$4b55ecd9a5df8f6f(fieldset) {
    const visibleCheckboxes = $7d90c7ac1787964b$var$getVisibleCheckboxes(fieldset);
    const total = visibleCheckboxes.length;
    const checked = visibleCheckboxes.filter((checkbox)=>checkbox.checked).length;
    return ` (${checked}/${total})`;
}
function $7d90c7ac1787964b$var$generateAccordionForFilterGroup(filterState, params) {
    const baseElements = (0, $cee5810d0adc6215$export$4d3a0044e7678a67)(params.htmlName);
    const fieldSet = document.createElement("fieldset");
    fieldSet.className = `filter-${params.htmlName}`;
    baseElements.contentContainer.appendChild(fieldSet);
    const groupSelectorButtons = document.createElement("div");
    groupSelectorButtons.className = "filter-group-selectors-container";
    fieldSet.appendChild(groupSelectorButtons);
    const checkAllButton = document.createElement("button");
    checkAllButton.type = "button";
    checkAllButton.textContent = "Check all";
    checkAllButton.id = `filter-${params.htmlName}-check-all`;
    groupSelectorButtons.appendChild(checkAllButton);
    const uncheckAllButton = document.createElement("button");
    uncheckAllButton.type = "button";
    uncheckAllButton.textContent = "Uncheck all";
    uncheckAllButton.id = `filter-${params.htmlName}-uncheck-all`;
    groupSelectorButtons.appendChild(uncheckAllButton);
    const filterOptionsContainer = document.createElement("div");
    filterOptionsContainer.className = "filter-checkbox-options-container";
    if (params.useTwoColumns) filterOptionsContainer.className = "filter-checkbox-options-two-columns";
    fieldSet.appendChild(filterOptionsContainer);
    // When setting up the filter group, we use `merged` to add every option in the universe.
    // However, we use the initial filterState to determine if it should be checked.
    $7d90c7ac1787964b$export$453542b5fbc69a48.merged[params.filterStateKey].forEach((val, i)=>{
        const inputId = `filter-${params.htmlName}-option-${i}`;
        const checked = filterState[params.filterStateKey].has(val);
        const description = params.preserveCapitalization ? val : (0, $0ff7d71e45d9103c$export$2e2bcd8739ae039)(val);
        const [label] = (0, $cee5810d0adc6215$export$da2458c7aedbc821)(inputId, params.htmlName, checked, description);
        filterOptionsContainer.appendChild(label);
    });
    const elements = {
        ...baseElements,
        fieldSet: fieldSet,
        checkAllButton: checkAllButton,
        uncheckAllButton: uncheckAllButton
    };
    const accordionState = new (0, $cc4b70f67be6e72e$export$2e2bcd8739ae039)(`filter accordion ${params.htmlName}`, {
        hidden: false,
        expanded: false,
        title: typeof params.legend === "string" ? params.legend : params.legend(filterState),
        supplementalTitle: $7d90c7ac1787964b$export$4b55ecd9a5df8f6f(fieldSet)
    });
    accordionState.subscribe((state)=>(0, $cee5810d0adc6215$export$21a9821bbe457cb0)(elements, state));
    baseElements.accordionButton.addEventListener("click", ()=>{
        const priorState = accordionState.getValue();
        accordionState.setValue({
            ...priorState,
            expanded: !priorState.expanded
        });
    });
    accordionState.initialize();
    return [
        elements,
        accordionState
    ];
}
function $7d90c7ac1787964b$var$updateCheckboxStats(observable, fieldSet) {
    const accordionPriorState = observable.getValue();
    observable.setValue({
        ...accordionPriorState,
        supplementalTitle: $7d90c7ac1787964b$export$4b55ecd9a5df8f6f(fieldSet)
    });
}
/**
 * Hide all options not in the dataset.
 */ function $7d90c7ac1787964b$var$updateCheckboxVisibility(optionsInDataset, fieldSet, preserveCapitalization) {
    const validOptions = new Set(optionsInDataset);
    fieldSet.querySelectorAll('input[type="checkbox"]').forEach((checkbox)=>{
        const label = $7d90c7ac1787964b$var$extractLabel(checkbox, preserveCapitalization);
        // eslint-disable-next-line no-param-reassign
        checkbox.parentElement.hidden = !label || !validOptions.has(label);
    });
}
function $7d90c7ac1787964b$var$initFilterGroup(filterManager, optionsContainer, params) {
    const [accordionElements, accordionState] = $7d90c7ac1787964b$var$generateAccordionForFilterGroup(filterManager.getState(), params);
    optionsContainer.appendChild(accordionElements.outerContainer);
    accordionElements.fieldSet.addEventListener("change", ()=>{
        $7d90c7ac1787964b$var$updateCheckboxStats(accordionState, accordionElements.fieldSet);
        const checkedLabels = $7d90c7ac1787964b$export$1842d958cb35ba79(accordionElements.fieldSet, params.preserveCapitalization);
        filterManager.update({
            [params.filterStateKey]: checkedLabels
        });
    });
    accordionElements.checkAllButton.addEventListener("click", ()=>{
        const visibleCheckboxes = $7d90c7ac1787964b$var$getVisibleCheckboxes(accordionElements.fieldSet);
        visibleCheckboxes.forEach((input)=>{
            // eslint-disable-next-line no-param-reassign
            input.checked = true;
        });
        $7d90c7ac1787964b$var$updateCheckboxStats(accordionState, accordionElements.fieldSet);
        const checkedLabels = $7d90c7ac1787964b$export$1842d958cb35ba79(accordionElements.fieldSet, params.preserveCapitalization);
        filterManager.update({
            [params.filterStateKey]: checkedLabels
        });
    });
    accordionElements.uncheckAllButton.addEventListener("click", ()=>{
        const visibleCheckboxes = $7d90c7ac1787964b$var$getVisibleCheckboxes(accordionElements.fieldSet);
        visibleCheckboxes.forEach((input)=>{
            // eslint-disable-next-line no-param-reassign
            input.checked = false;
        });
        $7d90c7ac1787964b$var$updateCheckboxStats(accordionState, accordionElements.fieldSet);
        const checkedLabels = $7d90c7ac1787964b$export$1842d958cb35ba79(accordionElements.fieldSet, params.preserveCapitalization);
        filterManager.update({
            [params.filterStateKey]: checkedLabels
        });
    });
    filterManager.subscribe(`possibly update ${params.htmlName} filter UI`, (state)=>{
        $7d90c7ac1787964b$var$updateCheckboxVisibility($7d90c7ac1787964b$export$453542b5fbc69a48.getOptions(state.policyTypeFilter, state.status)[params.filterStateKey], accordionElements.fieldSet, params.preserveCapitalization);
        $7d90c7ac1787964b$var$updateCheckboxStats(accordionState, accordionElements.fieldSet);
        const priorAccordionState = accordionState.getValue();
        const hidden = params.hide ? params.hide(state) : false;
        const title = typeof params.legend === "string" ? params.legend : params.legend(state);
        accordionState.setValue({
            ...priorAccordionState,
            title: title,
            hidden: hidden
        });
    });
}
function $7d90c7ac1787964b$var$initOutermostContainers(filterManager, filterPopup) {
    const datasetDiv = document.createElement("div");
    const disabledDatasetDiv = document.createElement("div");
    disabledDatasetDiv.classList.add("filter-illegal-dataset-container");
    disabledDatasetDiv.hidden = true;
    const warningIcon = document.createElement("i");
    warningIcon.classList.add("fa-solid", "fa-triangle-exclamation");
    warningIcon.ariaHidden = "true";
    const warningText = document.createElement("span");
    warningText.textContent = " This dataset has no entries. To fix, change either the 'reform type' or 'status'.";
    disabledDatasetDiv.append(warningIcon);
    disabledDatasetDiv.append(warningText);
    const optionsDiv = document.createElement("div");
    filterManager.subscribe(`possibly disable dataset`, ({ policyTypeFilter: policyTypeFilter, status: status })=>{
        const enabled = $7d90c7ac1787964b$export$453542b5fbc69a48.enabled(policyTypeFilter, status);
        disabledDatasetDiv.hidden = enabled;
        optionsDiv.hidden = !enabled;
    });
    filterPopup.append(datasetDiv);
    filterPopup.append(disabledDatasetDiv);
    filterPopup.append(optionsDiv);
    return {
        datasetDiv: datasetDiv,
        optionsDiv: optionsDiv
    };
}
function $7d90c7ac1787964b$var$initAllMinimumsToggle(filterManager, optionsContainer) {
    const outerContainer = document.createElement("div");
    const [label, input] = (0, $cee5810d0adc6215$export$da2458c7aedbc821)("filter-all-minimums-toggle", "filter-all-minimums-toggle", filterManager.getState().allMinimumsRemovedToggle, "Only places with all parking minimums removed");
    label.id = "filter-all-minimums-toggle-label";
    outerContainer.append(label);
    optionsContainer.append(outerContainer);
    input.addEventListener("change", ()=>{
        filterManager.update({
            allMinimumsRemovedToggle: input.checked
        });
    });
    filterManager.subscribe(`possibly hide all minimums toggle`, (filterState)=>{
        outerContainer.hidden = !(0, $924e72120b481a6c$export$9e7fa3578a5a2a3f)(filterState);
    });
}
function $7d90c7ac1787964b$var$initPolicyTypeFilterDropdown(filterManager, dropdownContainer) {
    const id = "filter-policy-type-dropdown";
    const container = document.createElement("div");
    container.className = "filter-policy-type-dropdown-container";
    const label = document.createElement("label");
    label.htmlFor = id;
    label.textContent = "Reform type";
    const select = document.createElement("select");
    select.id = id;
    select.name = id;
    (0, $924e72120b481a6c$export$e68f611676b33aaa).forEach((option)=>{
        const element = document.createElement("option");
        element.value = option;
        element.textContent = (0, $0ff7d71e45d9103c$export$2e2bcd8739ae039)(option);
        select.append(element);
    });
    // Set initial value.
    select.value = filterManager.getState().policyTypeFilter;
    select.addEventListener("change", ()=>{
        const policyTypeFilter = select.value;
        filterManager.update({
            policyTypeFilter: policyTypeFilter
        });
    });
    container.append(label);
    container.append(select);
    dropdownContainer.append(container);
}
function $7d90c7ac1787964b$var$initStatusDropdown(filterManager, dropdownContainer) {
    const id = "filter-status-dropdown";
    const container = document.createElement("div");
    container.className = "filter-status-dropdown-container";
    const label = document.createElement("label");
    label.htmlFor = id;
    label.textContent = "Status";
    const select = document.createElement("select");
    select.id = id;
    select.name = id;
    (0, $87fb6b45cbec1b35$export$81407a4013322c35).forEach((option)=>{
        const element = document.createElement("option");
        element.value = option;
        element.textContent = (0, $0ff7d71e45d9103c$export$2e2bcd8739ae039)(option);
        select.append(element);
    });
    // Set initial value.
    select.value = filterManager.getState().status;
    select.addEventListener("change", ()=>{
        const status = select.value;
        filterManager.update({
            status: status
        });
    });
    container.append(label);
    container.append(select);
    dropdownContainer.append(container);
}
function $7d90c7ac1787964b$export$7dc75e8b568dd691(filterManager) {
    // Note that the order of this function determines the order of the filter.
    const filterPopup = document.querySelector("#filter-popup");
    if (!filterPopup) return;
    const { datasetDiv: datasetDiv, optionsDiv: optionsDiv } = $7d90c7ac1787964b$var$initOutermostContainers(filterManager, filterPopup);
    // Top-level options that change profoundly the app.
    $7d90c7ac1787964b$var$initPolicyTypeFilterDropdown(filterManager, datasetDiv);
    $7d90c7ac1787964b$var$initStatusDropdown(filterManager, datasetDiv);
    $7d90c7ac1787964b$var$initAllMinimumsToggle(filterManager, optionsDiv);
    // Options about the reform
    $7d90c7ac1787964b$var$initFilterGroup(filterManager, optionsDiv, {
        htmlName: "policy-change",
        filterStateKey: "includedPolicyChanges",
        legend: "Reform types",
        hide: ({ policyTypeFilter: policyTypeFilter })=>policyTypeFilter !== "any parking reform"
    });
    $7d90c7ac1787964b$var$initFilterGroup(filterManager, optionsDiv, {
        htmlName: "scope",
        filterStateKey: "scope",
        legend: "Reform scopes",
        hide: (filterState)=>filterState.policyTypeFilter === "any parking reform" || filterState.policyTypeFilter === "parking benefit district" || (0, $924e72120b481a6c$export$177f84df50af9f16)(filterState)
    });
    $7d90c7ac1787964b$var$initFilterGroup(filterManager, optionsDiv, {
        htmlName: "land-use",
        filterStateKey: "landUse",
        legend: "Affected land uses",
        hide: (filterState)=>filterState.policyTypeFilter === "any parking reform" || filterState.policyTypeFilter === "parking benefit district" || (0, $924e72120b481a6c$export$177f84df50af9f16)(filterState)
    });
    $7d90c7ac1787964b$var$initFilterGroup(filterManager, optionsDiv, {
        htmlName: "year",
        filterStateKey: "year",
        legend: ({ status: status })=>{
            const mapping = {
                adopted: "Adoption years",
                proposed: "Proposal years",
                repealed: "Repeal years"
            };
            return mapping[status];
        },
        useTwoColumns: true,
        hide: ({ policyTypeFilter: policyTypeFilter })=>policyTypeFilter === "any parking reform"
    });
    // Options about the Place
    $7d90c7ac1787964b$var$initFilterGroup(filterManager, optionsDiv, {
        htmlName: "country",
        filterStateKey: "country",
        legend: "Countries",
        preserveCapitalization: true
    });
    $7d90c7ac1787964b$var$initFilterGroup(filterManager, optionsDiv, {
        htmlName: "place-type",
        filterStateKey: "placeType",
        legend: "Jurisdictions",
        useTwoColumns: true
    });
    (0, $2f73981580161403$export$e80c029a0181b2d1)(filterManager, optionsDiv);
}




const $56eb3cba434809a6$export$64756f07e0d63a3b = {
    placeType: new Set((0, $7d90c7ac1787964b$export$453542b5fbc69a48).merged.placeType),
    includedPolicyChanges: new Set((0, $7d90c7ac1787964b$export$453542b5fbc69a48).merged.includedPolicyChanges),
    scope: new Set((0, $7d90c7ac1787964b$export$453542b5fbc69a48).merged.scope),
    landUse: new Set((0, $7d90c7ac1787964b$export$453542b5fbc69a48).merged.landUse),
    country: new Set((0, $7d90c7ac1787964b$export$453542b5fbc69a48).merged.country),
    year: new Set((0, $7d90c7ac1787964b$export$453542b5fbc69a48).merged.year)
};
const $56eb3cba434809a6$export$ae0929f76be56c71 = {
    searchInput: null,
    policyTypeFilter: "any parking reform",
    status: "adopted",
    allMinimumsRemovedToggle: false,
    ...$56eb3cba434809a6$export$64756f07e0d63a3b,
    populationSliderIndexes: [
        0,
        (0, $2f73981580161403$export$74d78e896cd7f00b)
    ]
};
const $56eb3cba434809a6$var$ARRAY_DELIMITER = ".";
const $56eb3cba434809a6$var$BOOL_TRUE = "y";
const $56eb3cba434809a6$var$BOOL_FALSE = "n";
class $56eb3cba434809a6$var$BidirectionalMap {
    encodeMap;
    decodeMap;
    constructor(encodeMap, decodeMap){
        this.encodeMap = encodeMap;
        this.decodeMap = decodeMap;
        this.encodeMap = encodeMap;
        this.decodeMap = decodeMap;
    }
    static from(entries) {
        const encodeMap = Object.fromEntries(entries);
        const decodeMap = Object.fromEntries(entries.map(([a, b])=>[
                b,
                a
            ]));
        return new $56eb3cba434809a6$var$BidirectionalMap(encodeMap, decodeMap);
    }
    keys() {
        return new Set(Object.keys(this.encodeMap));
    }
    encode(key) {
        return this.encodeMap[key];
    }
    encodeSet(keys) {
        return Array.from(keys).map((key)=>this.encode(key)).join($56eb3cba434809a6$var$ARRAY_DELIMITER);
    }
    decode(value) {
        if (value === null) return null;
        return this.decodeMap[value] ?? null;
    }
    decodeSet(value, fallback) {
        if (value === null) return fallback;
        const parsed = new Set(value.split($56eb3cba434809a6$var$ARRAY_DELIMITER).map((v)=>this.decode(v)).filter((v)=>v !== null));
        return parsed.size ? parsed : fallback;
    }
}
const $56eb3cba434809a6$export$d81b04b40f15a1cf = "reform";
const $56eb3cba434809a6$export$f1bfa4661c486005 = "status";
const $56eb3cba434809a6$export$85aca654a91b7936 = "repeal";
const $56eb3cba434809a6$export$4b27086f74bdcff6 = "yr";
const $56eb3cba434809a6$export$aa125781c1530acc = "cntry";
const $56eb3cba434809a6$export$930b12c9472fb898 = "juris";
const $56eb3cba434809a6$export$ff3784b8cc383d5f = "reforms";
const $56eb3cba434809a6$export$fcb29e93189513d8 = "lnd";
const $56eb3cba434809a6$export$2f8c369e711b0e93 = "scp";
const $56eb3cba434809a6$export$466b3d13d83e99c6 = "pop";
const $56eb3cba434809a6$export$79926a7152ef8993 = $56eb3cba434809a6$var$BidirectionalMap.from([
    [
        "any parking reform",
        "any"
    ],
    [
        "add parking maximums",
        "mx"
    ],
    [
        "reduce parking minimums",
        "rd"
    ],
    [
        "remove parking minimums",
        "rm"
    ],
    [
        "parking benefit district",
        "bd"
    ]
]);
const $56eb3cba434809a6$export$2344a301308c0556 = $56eb3cba434809a6$var$BidirectionalMap.from([
    [
        "adopted",
        "a"
    ],
    [
        "proposed",
        "p"
    ],
    [
        "repealed",
        "r"
    ]
]);
const $56eb3cba434809a6$export$a9121e6bde958d18 = $56eb3cba434809a6$var$BidirectionalMap.from([
    [
        "city",
        "cty"
    ],
    [
        "state",
        "st"
    ],
    [
        "county",
        "cnty"
    ],
    [
        "country",
        "cntry"
    ]
]);
const $56eb3cba434809a6$export$afc1451879b538b9 = $56eb3cba434809a6$var$BidirectionalMap.from([
    [
        "all uses",
        "all"
    ],
    [
        "commercial",
        "com"
    ],
    [
        "industrial",
        "ind"
    ],
    [
        "medical",
        "med"
    ],
    [
        "other",
        "oth"
    ],
    [
        "residential, all uses",
        "res-all"
    ],
    [
        "residential, low-density",
        "res-low"
    ],
    [
        "residential, multi-family",
        "fam"
    ]
]);
const $56eb3cba434809a6$export$2eef0ba0e371a161 = $56eb3cba434809a6$var$BidirectionalMap.from([
    [
        "city center / business district",
        "cntr"
    ],
    [
        "citywide",
        "cty"
    ],
    [
        "main street / special",
        "main"
    ],
    [
        "regional",
        "reg"
    ],
    [
        "transit-oriented",
        "trns"
    ]
]);
const $56eb3cba434809a6$export$97ac4765ed78759f = $56eb3cba434809a6$var$BidirectionalMap.from(Object.entries((0, $b073965913779e61$export$35016c3166f10230)).map(([code, country])=>[
        country,
        code.toLowerCase()
    ]));
const $56eb3cba434809a6$export$785c1f11a82f263 = $56eb3cba434809a6$var$BidirectionalMap.from(Array.from($56eb3cba434809a6$export$64756f07e0d63a3b.year).map((year)=>[
        year,
        year
    ]));
function $56eb3cba434809a6$export$ddf17000877a996c(filterState) {
    const result = new URLSearchParams();
    if (filterState.policyTypeFilter !== $56eb3cba434809a6$export$ae0929f76be56c71.policyTypeFilter) result.append($56eb3cba434809a6$export$d81b04b40f15a1cf, $56eb3cba434809a6$export$79926a7152ef8993.encode(filterState.policyTypeFilter));
    if (filterState.status !== $56eb3cba434809a6$export$ae0929f76be56c71.status) result.append($56eb3cba434809a6$export$f1bfa4661c486005, $56eb3cba434809a6$export$2344a301308c0556.encode(filterState.status));
    if (filterState.allMinimumsRemovedToggle !== $56eb3cba434809a6$export$ae0929f76be56c71.allMinimumsRemovedToggle) result.append($56eb3cba434809a6$export$85aca654a91b7936, filterState.allMinimumsRemovedToggle ? $56eb3cba434809a6$var$BOOL_TRUE : $56eb3cba434809a6$var$BOOL_FALSE);
    if (!(0, $07a598d7bdcdfb03$export$2e2bcd8739ae039)(filterState.includedPolicyChanges, $56eb3cba434809a6$export$ae0929f76be56c71.includedPolicyChanges)) result.append($56eb3cba434809a6$export$ff3784b8cc383d5f, $56eb3cba434809a6$export$79926a7152ef8993.encodeSet(filterState.includedPolicyChanges));
    if (!(0, $07a598d7bdcdfb03$export$2e2bcd8739ae039)(filterState.placeType, $56eb3cba434809a6$export$ae0929f76be56c71.placeType)) result.append($56eb3cba434809a6$export$930b12c9472fb898, $56eb3cba434809a6$export$a9121e6bde958d18.encodeSet(filterState.placeType));
    if (!(0, $07a598d7bdcdfb03$export$2e2bcd8739ae039)(filterState.country, $56eb3cba434809a6$export$ae0929f76be56c71.country)) result.append($56eb3cba434809a6$export$aa125781c1530acc, $56eb3cba434809a6$export$97ac4765ed78759f.encodeSet(filterState.country));
    if (!(0, $07a598d7bdcdfb03$export$2e2bcd8739ae039)(filterState.year, $56eb3cba434809a6$export$ae0929f76be56c71.year)) result.append($56eb3cba434809a6$export$4b27086f74bdcff6, $56eb3cba434809a6$export$785c1f11a82f263.encodeSet(filterState.year));
    if (!(0, $07a598d7bdcdfb03$export$2e2bcd8739ae039)(filterState.landUse, $56eb3cba434809a6$export$ae0929f76be56c71.landUse)) result.append($56eb3cba434809a6$export$fcb29e93189513d8, $56eb3cba434809a6$export$afc1451879b538b9.encodeSet(filterState.landUse));
    if (!(0, $07a598d7bdcdfb03$export$2e2bcd8739ae039)(filterState.scope, $56eb3cba434809a6$export$ae0929f76be56c71.scope)) result.append($56eb3cba434809a6$export$2f8c369e711b0e93, $56eb3cba434809a6$export$2eef0ba0e371a161.encodeSet(filterState.scope));
    if (!(0, $07a598d7bdcdfb03$export$2e2bcd8739ae039)(filterState.populationSliderIndexes, $56eb3cba434809a6$export$ae0929f76be56c71.populationSliderIndexes)) result.append($56eb3cba434809a6$export$466b3d13d83e99c6, filterState.populationSliderIndexes.join($56eb3cba434809a6$var$ARRAY_DELIMITER));
    result.sort();
    return result;
}
function $56eb3cba434809a6$var$decodeAllMinimumsRepealed(v) {
    if (v === $56eb3cba434809a6$var$BOOL_TRUE) return true;
    if (v === $56eb3cba434809a6$var$BOOL_FALSE) return false;
    return $56eb3cba434809a6$export$ae0929f76be56c71.allMinimumsRemovedToggle;
}
function $56eb3cba434809a6$export$94fb258ef1c7529e(str) {
    if (str === null) return $56eb3cba434809a6$export$ae0929f76be56c71.populationSliderIndexes;
    let left;
    let right;
    try {
        const split = str.split($56eb3cba434809a6$var$ARRAY_DELIMITER);
        if (split.length !== 2) return $56eb3cba434809a6$export$ae0929f76be56c71.populationSliderIndexes;
        left = Number.parseInt(split[0], 10);
        right = Number.parseInt(split[1], 10);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
        return $56eb3cba434809a6$export$ae0929f76be56c71.populationSliderIndexes;
    }
    const isValid = left >= 0 && right <= (0, $2f73981580161403$export$74d78e896cd7f00b) && left < right;
    return isValid ? [
        left,
        right
    ] : $56eb3cba434809a6$export$ae0929f76be56c71.populationSliderIndexes;
}
function $56eb3cba434809a6$export$1f83a75cfed78df9(queryString) {
    const cleanQuery = queryString.startsWith("?") ? queryString.slice(1) : queryString;
    return new URLSearchParams(cleanQuery);
}
function $56eb3cba434809a6$export$742a972d8a0c6161(queryString) {
    const params = $56eb3cba434809a6$export$1f83a75cfed78df9(queryString);
    return {
        searchInput: $56eb3cba434809a6$export$ae0929f76be56c71.searchInput,
        policyTypeFilter: $56eb3cba434809a6$export$79926a7152ef8993.decode(params.get($56eb3cba434809a6$export$d81b04b40f15a1cf)) ?? $56eb3cba434809a6$export$ae0929f76be56c71.policyTypeFilter,
        status: $56eb3cba434809a6$export$2344a301308c0556.decode(params.get($56eb3cba434809a6$export$f1bfa4661c486005)) ?? $56eb3cba434809a6$export$ae0929f76be56c71.status,
        allMinimumsRemovedToggle: $56eb3cba434809a6$var$decodeAllMinimumsRepealed(params.get($56eb3cba434809a6$export$85aca654a91b7936)),
        includedPolicyChanges: $56eb3cba434809a6$export$79926a7152ef8993.decodeSet(params.get($56eb3cba434809a6$export$ff3784b8cc383d5f), $56eb3cba434809a6$export$ae0929f76be56c71.includedPolicyChanges),
        year: $56eb3cba434809a6$export$785c1f11a82f263.decodeSet(params.get($56eb3cba434809a6$export$4b27086f74bdcff6), $56eb3cba434809a6$export$ae0929f76be56c71.year),
        country: $56eb3cba434809a6$export$97ac4765ed78759f.decodeSet(params.get($56eb3cba434809a6$export$aa125781c1530acc), $56eb3cba434809a6$export$ae0929f76be56c71.country),
        placeType: $56eb3cba434809a6$export$a9121e6bde958d18.decodeSet(params.get($56eb3cba434809a6$export$930b12c9472fb898), $56eb3cba434809a6$export$ae0929f76be56c71.placeType),
        landUse: $56eb3cba434809a6$export$afc1451879b538b9.decodeSet(params.get($56eb3cba434809a6$export$fcb29e93189513d8), $56eb3cba434809a6$export$ae0929f76be56c71.landUse),
        scope: $56eb3cba434809a6$export$2eef0ba0e371a161.decodeSet(params.get($56eb3cba434809a6$export$2f8c369e711b0e93), $56eb3cba434809a6$export$ae0929f76be56c71.scope),
        populationSliderIndexes: $56eb3cba434809a6$export$94fb258ef1c7529e(params.get($56eb3cba434809a6$export$466b3d13d83e99c6))
    };
}


function $a4deed459da56e8e$export$2e2bcd8739ae039(queryString) {
    const params = (0, $56eb3cba434809a6$export$1f83a75cfed78df9)(queryString);
    if (!params.has("hide-map-overlays")) return;
    // We cannot use `.hidden` because viewToggle already uses hidden to control if the elements are shown,
    // and that gets re-set every time viewToggle is called.
    document.querySelector(".prn-logo-map").style.display = "none";
    document.querySelector("#map-counter").style.display = "none";
    document.querySelector(".leaflet-control-zoom").hidden = true;
    document.querySelector(".leaflet-control-attribution").hidden = true;
}



async function $c9a412278fd027ee$var$copyToClipboard(value) {
    try {
        await navigator.clipboard.writeText(value);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error("Failed to write to clipboard: ", err);
    }
}
function $c9a412278fd027ee$var$switchShareIcons(shareIcon) {
    const linkIcon = shareIcon.querySelector("svg.share-link-icon");
    const checkIcon = shareIcon.querySelector("svg.share-check-icon");
    if (!linkIcon || !checkIcon) return;
    linkIcon.style.display = "none";
    checkIcon.style.display = "inline-block";
    setTimeout(()=>{
        linkIcon.style.display = "inline-block";
        checkIcon.style.display = "none";
    }, 1000);
}
function $c9a412278fd027ee$export$7138c24907de3954(searchParams) {
    const url = new URL(window.location.href);
    url.search = searchParams.toString();
    return url.toString();
}
function $c9a412278fd027ee$export$2e2bcd8739ae039(filterManager) {
    filterManager.subscribe("update share link", (filterState)=>{
        const shareIcon = document.querySelector(".header-share-icon-container");
        const fullScreenIcon = document.querySelector(".header-full-screen-icon-container");
        if (!shareIcon || !fullScreenIcon) return;
        const shareUrl = $c9a412278fd027ee$export$7138c24907de3954((0, $56eb3cba434809a6$export$ddf17000877a996c)(filterState));
        shareIcon.addEventListener("click", async ()=>{
            await $c9a412278fd027ee$var$copyToClipboard(shareUrl);
            $c9a412278fd027ee$var$switchShareIcons(shareIcon);
        });
        fullScreenIcon.href = shareUrl;
    });
}



function $9c0340c7c89ecadd$var$updatePopupUI(visible) {
    const popup = document.querySelector(".about-popup");
    const icon = document.querySelector(".header-about-icon-container");
    if (!popup || !icon) return;
    popup.hidden = !visible;
    icon.setAttribute("aria-expanded", visible.toString());
}
function $9c0340c7c89ecadd$export$2e2bcd8739ae039() {
    const isVisible = new (0, $cc4b70f67be6e72e$export$2e2bcd8739ae039)("about popup", false);
    isVisible.subscribe($9c0340c7c89ecadd$var$updatePopupUI);
    const popup = document.querySelector(".about-popup");
    const headerIcon = document.querySelector(".header-about-icon-container");
    const closeIcon = document.querySelector(".about-popup-close-icon-container");
    headerIcon?.addEventListener("click", ()=>isVisible.setValue(!isVisible.getValue()));
    closeIcon?.addEventListener("click", ()=>isVisible.setValue(false));
    // Clicks outside the popup close it.
    window.addEventListener("click", (event)=>{
        if (isVisible.getValue() === true && event.target instanceof Element && !headerIcon?.contains(event.target) && !popup?.contains(event.target)) isVisible.setValue(false);
    });
    isVisible.initialize();
}



function $03248c494acf54bf$var$updateUI(table, state) {
    const tableIcon = document.querySelector(".header-table-icon-container");
    const mapIcon = document.querySelector(".header-map-icon-container");
    const tableView = document.querySelector("#table-view");
    const mapView = document.querySelector("#map");
    const mapCounter = document.querySelector("#map-counter");
    const prnLogo = document.querySelector(".prn-logo-map");
    if (!mapIcon || !tableIcon || !tableView || !mapView || !mapCounter || !prnLogo) return;
    if (state === "map") {
        tableIcon.style.display = "inline-flex";
        mapIcon.style.display = "none";
        tableView.hidden = true;
        mapView.hidden = false;
        mapCounter.hidden = false;
        prnLogo.hidden = false;
    } else {
        tableIcon.style.display = "none";
        mapIcon.style.display = "inline-flex";
        tableView.hidden = false;
        mapView.hidden = true;
        mapCounter.hidden = true;
        prnLogo.hidden = true;
        table.redraw();
    }
}
function $03248c494acf54bf$var$updateOnIconClick(observable) {
    const tableIcon = document.querySelector(".header-table-icon-container");
    const mapIcon = document.querySelector(".header-map-icon-container");
    if (!mapIcon || !tableIcon) return;
    tableIcon.addEventListener("click", ()=>observable.setValue("table"));
    mapIcon.addEventListener("click", ()=>observable.setValue("map"));
}
function $03248c494acf54bf$export$ccd129d907a77f1b() {
    const viewToggle = new (0, $cc4b70f67be6e72e$export$2e2bcd8739ae039)("view toggle", "map");
    $03248c494acf54bf$var$updateOnIconClick(viewToggle);
    return viewToggle;
}
function $03248c494acf54bf$export$51c63440b0a0743(observable, table) {
    observable.subscribe((state)=>$03248c494acf54bf$var$updateUI(table, state), "switch app view");
}










function $441f0ff734ef5ef9$export$2b92fb942e3a44df(numPlaces, matchedCountries, matchedPlaceTypes) {
    let country = matchedCountries.size === 1 ? Array.from(matchedCountries)[0] : `${matchedCountries.size} countries`;
    if ((0, $b073965913779e61$export$ccd6918840d0afb5).has(country)) country = `the ${country}`;
    if ((0, $07a598d7bdcdfb03$export$2e2bcd8739ae039)(matchedPlaceTypes, new Set([
        "city"
    ]))) {
        const label = numPlaces === 1 ? "city" : "cities";
        return `${numPlaces} ${label} in ${country}`;
    }
    if ((0, $07a598d7bdcdfb03$export$2e2bcd8739ae039)(matchedPlaceTypes, new Set([
        "county"
    ]))) {
        const label = numPlaces === 1 ? "county" : "counties";
        return `${numPlaces} ${label} in ${country}`;
    }
    if ((0, $07a598d7bdcdfb03$export$2e2bcd8739ae039)(matchedPlaceTypes, new Set([
        "state"
    ]))) {
        const label = numPlaces === 1 ? "state" : "states";
        return `${numPlaces} ${label} in ${country}`;
    }
    if ((0, $07a598d7bdcdfb03$export$2e2bcd8739ae039)(matchedPlaceTypes, new Set([
        "country"
    ]))) return numPlaces === 1 ? "1 country" : `${numPlaces} countries`;
    const label = numPlaces === 1 ? "place" : "places";
    return `${numPlaces} ${label} in ${country}`;
}
const $441f0ff734ef5ef9$export$6ecda6f5b430c2c8 = `<button class="counter-search-reset" role="button" aria-label="reset search">reset search</button>`;
const $441f0ff734ef5ef9$export$e16008ae612cec5d = `<button class="counter-table-download" role="button" aria-label="download table as CSV">download as CSV</button>`;
function $441f0ff734ef5ef9$export$d2a40f0065a2fc62(view, placeId, encodedPlace, policyType, status) {
    const placeLink = `<a class="external-link" target="_blank" href=${(0, $5b2db79250e23091$export$e2a94b6b5508320)(encodedPlace)}>${placeId} <i aria-hidden="true" class="fa-solid fa-arrow-right"></i></a>`;
    if (view === "map") return `Showing ${placeLink} \u{2014} ${$441f0ff734ef5ef9$export$6ecda6f5b430c2c8}`;
    const suffix = `in ${placeLink} \u{2014} ${$441f0ff734ef5ef9$export$6ecda6f5b430c2c8}`;
    switch(policyType){
        case "any parking reform":
            return `Showing an overview of ${status} parking reforms ${suffix}`;
        case "add parking maximums":
            return `Showing details about ${status} parking maximums ${suffix}`;
        case "reduce parking minimums":
            return `Showing details about ${status} parking minimum reductions ${suffix}`;
        case "remove parking minimums":
            return `Showing details about ${status} parking minimum removals ${suffix}`;
        default:
            throw new Error(`Unexpected policy type: ${policyType}`);
    }
}
function $441f0ff734ef5ef9$export$ac93de7699e8cbdc(view, placeDescription, matchedPolicyTypes, statePolicyTypes, state) {
    if (view === "table") return `Showing an overview of ${state} parking reforms in ${placeDescription} - ${$441f0ff734ef5ef9$export$e16008ae612cec5d}`;
    const prefix = `Showing ${placeDescription} with`;
    const policyDescriptionMap = {
        "add parking maximums": {
            singlePolicy: "parking maximums",
            multiplePolicies: "maximums"
        },
        "reduce parking minimums": {
            singlePolicy: "parking minimum reductions",
            multiplePolicies: "minimum reductions"
        },
        "remove parking minimums": {
            singlePolicy: "parking minimum removals",
            multiplePolicies: "minimum removals"
        },
        "parking benefit district": {
            singlePolicy: "parking benefit districts",
            multiplePolicies: "benefit district"
        }
    };
    const policyDescriptions = Array.from(statePolicyTypes).filter((policy)=>matchedPolicyTypes.has(policy)).map((policy)=>policyDescriptionMap[policy]);
    if (!policyDescriptions.length) throw new Error(`Expected state.includedPolicyChanges to be set`);
    if (policyDescriptions.length === 1) return `${prefix} ${state} ${policyDescriptions[0].singlePolicy}`;
    // Else, multiple policies. Format as a list.
    const listItems = policyDescriptions.map((description)=>`<li>${description.multiplePolicies}</li>`).sort().join("");
    return `${prefix} 1+ ${state} parking reforms:<ul>${listItems}</ul>`;
}
function $441f0ff734ef5ef9$export$c00bcca80a53f364(view, placeDescription, status) {
    return view === "map" ? `Showing ${placeDescription} with ${status} parking minimum reductions` : `Showing details about ${status} parking minimum reductions for ${placeDescription} - ${$441f0ff734ef5ef9$export$e16008ae612cec5d}`;
}
function $441f0ff734ef5ef9$export$8194fa57c1ee7ae0(view, placeDescription, status) {
    return view === "map" ? `Showing ${placeDescription} with ${status} parking maximums` : `Showing details about ${status} parking maximums for ${placeDescription} - ${$441f0ff734ef5ef9$export$e16008ae612cec5d}`;
}
function $441f0ff734ef5ef9$export$3bff33750e4b243c(view, placeDescription, allMinimumsRemovedToggle, status) {
    // The checkbox for "all minimums removed" dramatically changes what the user sees.
    const allMinimumsInEffect = (0, $924e72120b481a6c$export$177f84df50af9f16)({
        policyTypeFilter: "remove parking minimums",
        status: status,
        allMinimumsRemovedToggle: allMinimumsRemovedToggle
    });
    if (view === "map") {
        const suffix = allMinimumsInEffect ? `all parking minimums removed` : `${status} parking minimum removals`;
        return `Showing ${placeDescription} with ${suffix}`;
    }
    const prefix = `Showing details about ${status} parking minimum removals for ${placeDescription}`;
    const summary = allMinimumsInEffect ? `${prefix} that removed all parking minimums` : prefix;
    return `${summary} - ${$441f0ff734ef5ef9$export$e16008ae612cec5d}`;
}
function $441f0ff734ef5ef9$export$6e12624c92375d40(view, placeDescription, status) {
    return view === "map" ? `Showing ${placeDescription} with ${status} parking benefit districts` : `Showing details about ${status} parking benefit districts for ${placeDescription} - ${$441f0ff734ef5ef9$export$e16008ae612cec5d}`;
}
function $441f0ff734ef5ef9$export$cd8f00992f5eef3d(view, state, entries, numPlaces, matchedPolicyTypes, matchedCountries, matchedPlaceTypes) {
    if (!numPlaces) return "No places selected \u2014 use the filter or search icons";
    if (state.searchInput) {
        const placeId = state.searchInput;
        return $441f0ff734ef5ef9$export$d2a40f0065a2fc62(view, placeId, entries[placeId].place.encoded, state.policyTypeFilter, state.status);
    }
    const placeDescription = $441f0ff734ef5ef9$export$2b92fb942e3a44df(numPlaces, matchedCountries, matchedPlaceTypes);
    switch(state.policyTypeFilter){
        case "any parking reform":
            return $441f0ff734ef5ef9$export$ac93de7699e8cbdc(view, placeDescription, matchedPolicyTypes, state.includedPolicyChanges, state.status);
        case "reduce parking minimums":
            return $441f0ff734ef5ef9$export$c00bcca80a53f364(view, placeDescription, state.status);
        case "add parking maximums":
            return $441f0ff734ef5ef9$export$8194fa57c1ee7ae0(view, placeDescription, state.status);
        case "remove parking minimums":
            return $441f0ff734ef5ef9$export$3bff33750e4b243c(view, placeDescription, state.allMinimumsRemovedToggle, state.status);
        case "parking benefit district":
            return $441f0ff734ef5ef9$export$6e12624c92375d40(view, placeDescription, state.status);
        default:
            throw new Error(`Unexpected policy type: ${state.policyTypeFilter}`);
    }
}
function $441f0ff734ef5ef9$var$setUpResetButton(counterContainer, manager) {
    counterContainer.addEventListener("click", (event)=>{
        if (event.target instanceof Element && event.target.matches(".counter-search-reset")) manager.update({
            searchInput: null
        });
    });
}
function $441f0ff734ef5ef9$export$2e2bcd8739ae039(manager) {
    const mapCounter = document.getElementById("map-counter");
    const tableCounter = document.getElementById("table-counter");
    if (!mapCounter || !tableCounter) return;
    $441f0ff734ef5ef9$var$setUpResetButton(mapCounter, manager);
    $441f0ff734ef5ef9$var$setUpResetButton(tableCounter, manager);
    manager.subscribe("update counters", (state)=>{
        mapCounter.innerHTML = $441f0ff734ef5ef9$export$cd8f00992f5eef3d("map", state, manager.entries, manager.placeIds.size, manager.matchedPolicyTypes, manager.matchedCountries, manager.matchedPlaceTypes);
        tableCounter.innerHTML = $441f0ff734ef5ef9$export$cd8f00992f5eef3d("table", state, manager.entries, manager.placeIds.size, manager.matchedPolicyTypes, manager.matchedCountries, manager.matchedPlaceTypes);
    });
}


function $eced37d3792d94dd$export$2e2bcd8739ae039(manager, map) {
    manager.subscribe("move map on search", ({ searchInput: searchInput })=>{
        if (searchInput) {
            const [long, lat] = manager.entries[searchInput].place.coord;
            map.setView([
                lat,
                long
            ], 6);
        }
    });
}




function $b6ac2a2c93e59d61$export$bc1adee6399f86a8(entry) {
    if (entry.place.repeal) return true;
    const numAdoptedBenefitDistricts = entry.benefit_district?.filter((record)=>record.status === "adopted").length ?? 0;
    return numAdoptedBenefitDistricts > 0;
}
function $b6ac2a2c93e59d61$export$b67be20583cf6ae2(options) {
    const { zoom: zoom, isPrimary: isPrimary } = options;
    // This formula comes from Claude to go from radius 5 to 21 between zoom 3 to 10
    // with roughly linear growth.
    //
    // 21px radius => 42px diameter + 2px stroke == 4px. That meets the accessibility
    // requirement of 44px touch target size, while balancing the dot not being too big
    // on the screen when zoomed out.
    const base = Math.round(2.37 * zoom - 2.29);
    return isPrimary ? base + 2 : base;
}



const $b607d558aa74de54$var$PRIMARY_MARKER_STYLE = {
    weight: 1,
    color: "white",
    fillColor: "#d7191c",
    fillOpacity: 1,
    pane: (0, $b55fa19645e7687c$export$c94d53a8b082db8b)
};
const $b607d558aa74de54$var$SECONDARY_MARKER_STYLE = {
    weight: 1,
    color: "white",
    fillColor: "#fdae61",
    fillOpacity: 1
};
function $b607d558aa74de54$var$updatePlaceVisibility(currentlyVisiblePlaceIds, newVisiblePlaceIds, placesToMarkers, markerGroup) {
    // Remove markers no longer visible.
    for (const placeId of currentlyVisiblePlaceIds)if (!newVisiblePlaceIds.has(placeId)) // @ts-expect-error the API allows passing a LayerGroup, but the type hint doesn't show this.
    placesToMarkers[placeId].removeFrom(markerGroup);
    // Add new markers not yet visible.
    for (const placeId of newVisiblePlaceIds)if (!currentlyVisiblePlaceIds.has(placeId)) placesToMarkers[placeId].addTo(markerGroup);
}
function $b607d558aa74de54$export$2e2bcd8739ae039(filterManager, map, viewToggle) {
    const placesToMarkers = Object.entries(filterManager.entries).reduce((acc, [placeId, entry])=>{
        const [long, lat] = entry.place.coord;
        const isPrimary = (0, $b6ac2a2c93e59d61$export$bc1adee6399f86a8)(entry);
        const style = isPrimary ? $b607d558aa74de54$var$PRIMARY_MARKER_STYLE : $b607d558aa74de54$var$SECONDARY_MARKER_STYLE;
        const marker = new (0, $65d191346d2f0e85$exports.CircleMarker)([
            lat,
            long
        ], {
            ...style,
            radius: (0, $b6ac2a2c93e59d61$export$b67be20583cf6ae2)({
                zoom: map.getZoom(),
                isPrimary: isPrimary
            })
        });
        marker.placeId = placeId;
        // The tooltip is the text shown on hover. We strip the country
        // to make it less verbose.
        marker.bindTooltip((0, $5b2db79250e23091$export$da6b3dcd53e78e95)(entry.place));
        acc[placeId] = marker;
        return acc;
    }, {});
    const markerGroup = new (0, $65d191346d2f0e85$exports.FeatureGroup)();
    let currentlyVisiblePlaceIds = new Set();
    // When on table view, we should only lazily update the map the next time
    // we switch to map view.
    let dataRefreshQueued = false;
    filterManager.subscribe("update map markers", ()=>{
        if (viewToggle.getValue() === "table") {
            dataRefreshQueued = true;
            return;
        }
        $b607d558aa74de54$var$updatePlaceVisibility(currentlyVisiblePlaceIds, filterManager.placeIds, placesToMarkers, markerGroup);
        currentlyVisiblePlaceIds = filterManager.placeIds;
    });
    viewToggle.subscribe((view)=>{
        if (view === "map" && dataRefreshQueued) {
            $b607d558aa74de54$var$updatePlaceVisibility(currentlyVisiblePlaceIds, filterManager.placeIds, placesToMarkers, markerGroup);
            currentlyVisiblePlaceIds = filterManager.placeIds;
            dataRefreshQueued = false;
        }
    }, "apply queued map data refresh");
    // Adjust marker size on zoom changes.
    map.addEventListener("zoomend", ()=>{
        const zoom = map.getZoom();
        Object.entries(placesToMarkers).forEach(([placeId, marker])=>{
            const newRadius = (0, $b6ac2a2c93e59d61$export$b67be20583cf6ae2)({
                zoom: zoom,
                isPrimary: (0, $b6ac2a2c93e59d61$export$bc1adee6399f86a8)(filterManager.entries[placeId])
            });
            marker.setRadius(newRadius);
        });
    });
    markerGroup.addTo(map);
    return markerGroup;
}






function $8153ad3722c60d25$export$f582b7ff5a1564a5(entry) {
    const supplementalPlace = (0, $5b2db79250e23091$export$2a6d3d49f650c5cb)(entry.place);
    const titleContents = supplementalPlace ? `${entry.place.name}<br/><span class="scorecard-supplemental-place-info">${supplementalPlace}</span>` : entry.place.name;
    const policyToStatuses = (0, $b073965913779e61$export$5cd154a4b5b202c7)(entry);
    // If at least one policy record is proposed or repealed, we mention
    // the ReformStatus with every policy type so that people don't incorrectly
    // think a record was adopted when it wasn't.
    const needsStatusLabels = Object.values(policyToStatuses).some((statuses)=>statuses.has("proposed") || statuses.has("repealed"));
    const policies = Object.entries(policyToStatuses).filter(([, statuses])=>statuses.size).map(([policyType, statusesSet])=>{
        let suffix = "";
        if (needsStatusLabels) {
            const statuses = new Intl.ListFormat("en").format(Array.from(statusesSet).sort());
            suffix = ` (${statuses})`;
        }
        const val = (0, $0ff7d71e45d9103c$export$2e2bcd8739ae039)(`${policyType}${suffix}`);
        return `<li>${val}</li>`;
    }).join("");
    const policyTypesHtml = `<div>Reform types:</div><ul>${policies}</ul>`;
    const allMinimumsRemoved = entry.place.repeal ? "<li>All parking minimums removed</li>" : "";
    return `
    <header class="scorecard-header">
      <h2 class="scorecard-title">${titleContents}</h2>
      <button
        class="scorecard-close-icon-container"
        title="close the place details popup"
        aria-label="close the place details popup"
      >
        <i class="fa-regular fa-circle-xmark" aria-hidden="true"></i>
      </button>
    </header>
    <ul>
      <li>${entry.place.pop.toLocaleString()} residents</li>
      ${allMinimumsRemoved}
    </ul>
    ${policyTypesHtml}
    <a class="external-link" target="_blank" href=${entry.place.url}>Details and citations <i aria-hidden="true" class="fa-solid fa-arrow-right"></i></a>
    `;
}
function $8153ad3722c60d25$var$updateScorecardUI(state) {
    const scorecardContainer = document.querySelector("#scorecard-container");
    if (!scorecardContainer) return;
    switch(state.type){
        case "hidden":
            scorecardContainer.hidden = true;
            break;
        case "visible":
            scorecardContainer.innerHTML = $8153ad3722c60d25$export$f582b7ff5a1564a5(state.entry);
            scorecardContainer.hidden = false;
            break;
        default:
            throw new Error(`Unexpected state.type: ${state}`);
    }
}
function $8153ad3722c60d25$export$2e2bcd8739ae039(filterManager, viewToggle, markerGroup, data) {
    const scorecardState = new (0, $cc4b70f67be6e72e$export$2e2bcd8739ae039)("scorecard", {
        type: "hidden"
    });
    scorecardState.subscribe((state)=>$8153ad3722c60d25$var$updateScorecardUI(state));
    const scorecardContainer = document.querySelector("#scorecard-container");
    const header = document.querySelector(".top-header");
    // Clicking a city marker opens up the scorecard.
    markerGroup.on("click", (e)=>{
        const { placeId: placeId } = e.sourceTarget;
        scorecardState.setValue({
            type: "visible",
            placeId: placeId,
            entry: data[placeId]
        });
    });
    // Searching for a city opens up the scorecard if in map view.
    filterManager.subscribe("open scorecard on search", (state)=>{
        const search = state.searchInput;
        if (search && viewToggle.getValue() === "map") scorecardState.setValue({
            type: "visible",
            placeId: search,
            entry: data[search]
        });
    });
    // Clicks outside the popup close it.
    window.addEventListener("click", (event)=>{
        if (scorecardState.getValue().type === "visible" && event.target instanceof Element && // Clicks on map dots should not trigger this event.
        !(event.target instanceof SVGPathElement) && // Clicks on the header also should not trigger the event.
        !header?.contains(event.target) && !scorecardContainer?.contains(event.target)) scorecardState.setValue({
            type: "hidden"
        });
    });
    // The scorecard close button closes the popup.
    //
    // The event listener is on `#scorecard-container` because it is never erased,
    // unlike the scorecard contents being recreated every time the city changes.
    // This is called "event delegation".
    scorecardContainer?.addEventListener("click", (event)=>{
        const clicked = event.target;
        if (!(clicked instanceof Element)) return;
        const closeIcon = clicked.closest(".scorecard-close-icon-container");
        if (!closeIcon) return;
        scorecardState.setValue({
            type: "hidden"
        });
    });
    // Closing the scorecard resets search.
    scorecardState.subscribe(({ type: type })=>{
        // Don't run this code when initializing the scorecardState observable.
        if (!scorecardState.isInitialized) return;
        if (type === "hidden") filterManager.update({
            searchInput: null
        });
    }, "reset search FilterState when scorecard closed");
    scorecardState.initialize();
}


var $125d88de280575d0$exports = {};
/*! choices.js v10.2.0 | © 2022 Josh Johnson | https://github.com/jshjohnson/Choices#readme */ (function webpackUniversalModuleDefinition(root, factory) {
    $125d88de280575d0$exports = factory();
})(window, function() {
    return /******/ function() {
        /******/ "use strict";
        /******/ var __webpack_modules__ = {
            /***/ 282: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.clearChoices = exports.activateChoices = exports.filterChoices = exports.addChoice = void 0;
                var constants_1 = __webpack_require__(883);
                var addChoice = function(_a) {
                    var value = _a.value, label = _a.label, id = _a.id, groupId = _a.groupId, disabled = _a.disabled, elementId = _a.elementId, customProperties = _a.customProperties, placeholder = _a.placeholder, keyCode = _a.keyCode;
                    return {
                        type: constants_1.ACTION_TYPES.ADD_CHOICE,
                        value: value,
                        label: label,
                        id: id,
                        groupId: groupId,
                        disabled: disabled,
                        elementId: elementId,
                        customProperties: customProperties,
                        placeholder: placeholder,
                        keyCode: keyCode
                    };
                };
                exports.addChoice = addChoice;
                var filterChoices = function(results) {
                    return {
                        type: constants_1.ACTION_TYPES.FILTER_CHOICES,
                        results: results
                    };
                };
                exports.filterChoices = filterChoices;
                var activateChoices = function(active) {
                    if (active === void 0) active = true;
                    return {
                        type: constants_1.ACTION_TYPES.ACTIVATE_CHOICES,
                        active: active
                    };
                };
                exports.activateChoices = activateChoices;
                var clearChoices = function() {
                    return {
                        type: constants_1.ACTION_TYPES.CLEAR_CHOICES
                    };
                };
                exports.clearChoices = clearChoices;
            /***/ },
            /***/ 783: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.addGroup = void 0;
                var constants_1 = __webpack_require__(883);
                var addGroup = function(_a) {
                    var value = _a.value, id = _a.id, active = _a.active, disabled = _a.disabled;
                    return {
                        type: constants_1.ACTION_TYPES.ADD_GROUP,
                        value: value,
                        id: id,
                        active: active,
                        disabled: disabled
                    };
                };
                exports.addGroup = addGroup;
            /***/ },
            /***/ 464: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.highlightItem = exports.removeItem = exports.addItem = void 0;
                var constants_1 = __webpack_require__(883);
                var addItem = function(_a) {
                    var value = _a.value, label = _a.label, id = _a.id, choiceId = _a.choiceId, groupId = _a.groupId, customProperties = _a.customProperties, placeholder = _a.placeholder, keyCode = _a.keyCode;
                    return {
                        type: constants_1.ACTION_TYPES.ADD_ITEM,
                        value: value,
                        label: label,
                        id: id,
                        choiceId: choiceId,
                        groupId: groupId,
                        customProperties: customProperties,
                        placeholder: placeholder,
                        keyCode: keyCode
                    };
                };
                exports.addItem = addItem;
                var removeItem = function(id, choiceId) {
                    return {
                        type: constants_1.ACTION_TYPES.REMOVE_ITEM,
                        id: id,
                        choiceId: choiceId
                    };
                };
                exports.removeItem = removeItem;
                var highlightItem = function(id, highlighted) {
                    return {
                        type: constants_1.ACTION_TYPES.HIGHLIGHT_ITEM,
                        id: id,
                        highlighted: highlighted
                    };
                };
                exports.highlightItem = highlightItem;
            /***/ },
            /***/ 137: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.setIsLoading = exports.resetTo = exports.clearAll = void 0;
                var constants_1 = __webpack_require__(883);
                var clearAll = function() {
                    return {
                        type: constants_1.ACTION_TYPES.CLEAR_ALL
                    };
                };
                exports.clearAll = clearAll;
                var resetTo = function(state) {
                    return {
                        type: constants_1.ACTION_TYPES.RESET_TO,
                        state: state
                    };
                };
                exports.resetTo = resetTo;
                var setIsLoading = function(isLoading) {
                    return {
                        type: constants_1.ACTION_TYPES.SET_IS_LOADING,
                        isLoading: isLoading
                    };
                };
                exports.setIsLoading = setIsLoading;
            /***/ },
            /***/ 373: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
                    if (pack || arguments.length === 2) {
                        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                            ar[i] = from[i];
                        }
                    }
                    return to.concat(ar || Array.prototype.slice.call(from));
                };
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var deepmerge_1 = __importDefault(__webpack_require__(996));
                /* eslint-disable @typescript-eslint/no-explicit-any */ var fuse_js_1 = __importDefault(__webpack_require__(221));
                var choices_1 = __webpack_require__(282);
                var groups_1 = __webpack_require__(783);
                var items_1 = __webpack_require__(464);
                var misc_1 = __webpack_require__(137);
                var components_1 = __webpack_require__(520);
                var constants_1 = __webpack_require__(883);
                var defaults_1 = __webpack_require__(789);
                var utils_1 = __webpack_require__(799);
                var reducers_1 = __webpack_require__(655);
                var store_1 = __importDefault(__webpack_require__(744));
                var templates_1 = __importDefault(__webpack_require__(686));
                /** @see {@link http://browserhacks.com/#hack-acea075d0ac6954f275a70023906050c} */ var IS_IE11 = '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style;
                var USER_DEFAULTS = {};
                /**
 * Choices
 * @author Josh Johnson<josh@joshuajohnson.co.uk>
 */ var Choices = /** @class */ function() {
                    function Choices(element, userConfig) {
                        if (element === void 0) element = '[data-choice]';
                        if (userConfig === void 0) userConfig = {};
                        var _this = this;
                        if (userConfig.allowHTML === undefined) console.warn('Deprecation warning: allowHTML will default to false in a future release. To render HTML in Choices, you will need to set it to true. Setting allowHTML will suppress this message.');
                        this.config = deepmerge_1.default.all([
                            defaults_1.DEFAULT_CONFIG,
                            Choices.defaults.options,
                            userConfig
                        ], // When merging array configs, replace with a copy of the userConfig array,
                        // instead of concatenating with the default array
                        {
                            arrayMerge: function(_, sourceArray) {
                                return __spreadArray([], sourceArray, true);
                            }
                        });
                        var invalidConfigOptions = (0, utils_1.diff)(this.config, defaults_1.DEFAULT_CONFIG);
                        if (invalidConfigOptions.length) console.warn('Unknown config option(s) passed', invalidConfigOptions.join(', '));
                        var passedElement = typeof element === 'string' ? document.querySelector(element) : element;
                        if (!(passedElement instanceof HTMLInputElement || passedElement instanceof HTMLSelectElement)) throw TypeError('Expected one of the following types text|select-one|select-multiple');
                        this._isTextElement = passedElement.type === constants_1.TEXT_TYPE;
                        this._isSelectOneElement = passedElement.type === constants_1.SELECT_ONE_TYPE;
                        this._isSelectMultipleElement = passedElement.type === constants_1.SELECT_MULTIPLE_TYPE;
                        this._isSelectElement = this._isSelectOneElement || this._isSelectMultipleElement;
                        this.config.searchEnabled = this._isSelectMultipleElement || this.config.searchEnabled;
                        if (![
                            'auto',
                            'always'
                        ].includes("".concat(this.config.renderSelectedChoices))) this.config.renderSelectedChoices = 'auto';
                        if (userConfig.addItemFilter && typeof userConfig.addItemFilter !== 'function') {
                            var re = userConfig.addItemFilter instanceof RegExp ? userConfig.addItemFilter : new RegExp(userConfig.addItemFilter);
                            this.config.addItemFilter = re.test.bind(re);
                        }
                        if (this._isTextElement) this.passedElement = new components_1.WrappedInput({
                            element: passedElement,
                            classNames: this.config.classNames,
                            delimiter: this.config.delimiter
                        });
                        else this.passedElement = new components_1.WrappedSelect({
                            element: passedElement,
                            classNames: this.config.classNames,
                            template: function(data) {
                                return _this._templates.option(data);
                            }
                        });
                        this.initialised = false;
                        this._store = new store_1.default();
                        this._initialState = reducers_1.defaultState;
                        this._currentState = reducers_1.defaultState;
                        this._prevState = reducers_1.defaultState;
                        this._currentValue = '';
                        this._canSearch = !!this.config.searchEnabled;
                        this._isScrollingOnIe = false;
                        this._highlightPosition = 0;
                        this._wasTap = true;
                        this._placeholderValue = this._generatePlaceholderValue();
                        this._baseId = (0, utils_1.generateId)(this.passedElement.element, 'choices-');
                        /**
     * setting direction in cases where it's explicitly set on passedElement
     * or when calculated direction is different from the document
     */ this._direction = this.passedElement.dir;
                        if (!this._direction) {
                            var elementDirection = window.getComputedStyle(this.passedElement.element).direction;
                            var documentDirection = window.getComputedStyle(document.documentElement).direction;
                            if (elementDirection !== documentDirection) this._direction = elementDirection;
                        }
                        this._idNames = {
                            itemChoice: 'item-choice'
                        };
                        if (this._isSelectElement) {
                            // Assign preset groups from passed element
                            this._presetGroups = this.passedElement.optionGroups;
                            // Assign preset options from passed element
                            this._presetOptions = this.passedElement.options;
                        }
                        // Assign preset choices from passed object
                        this._presetChoices = this.config.choices;
                        // Assign preset items from passed object first
                        this._presetItems = this.config.items;
                        // Add any values passed from attribute
                        if (this.passedElement.value && this._isTextElement) {
                            var splitValues = this.passedElement.value.split(this.config.delimiter);
                            this._presetItems = this._presetItems.concat(splitValues);
                        }
                        // Create array of choices from option elements
                        if (this.passedElement.options) this.passedElement.options.forEach(function(option) {
                            _this._presetChoices.push({
                                value: option.value,
                                label: option.innerHTML,
                                selected: !!option.selected,
                                disabled: option.disabled || option.parentNode.disabled,
                                placeholder: option.value === '' || option.hasAttribute('placeholder'),
                                customProperties: (0, utils_1.parseCustomProperties)(option.dataset.customProperties)
                            });
                        });
                        this._render = this._render.bind(this);
                        this._onFocus = this._onFocus.bind(this);
                        this._onBlur = this._onBlur.bind(this);
                        this._onKeyUp = this._onKeyUp.bind(this);
                        this._onKeyDown = this._onKeyDown.bind(this);
                        this._onClick = this._onClick.bind(this);
                        this._onTouchMove = this._onTouchMove.bind(this);
                        this._onTouchEnd = this._onTouchEnd.bind(this);
                        this._onMouseDown = this._onMouseDown.bind(this);
                        this._onMouseOver = this._onMouseOver.bind(this);
                        this._onFormReset = this._onFormReset.bind(this);
                        this._onSelectKey = this._onSelectKey.bind(this);
                        this._onEnterKey = this._onEnterKey.bind(this);
                        this._onEscapeKey = this._onEscapeKey.bind(this);
                        this._onDirectionKey = this._onDirectionKey.bind(this);
                        this._onDeleteKey = this._onDeleteKey.bind(this);
                        // If element has already been initialised with Choices, fail silently
                        if (this.passedElement.isActive) {
                            if (!this.config.silent) console.warn('Trying to initialise Choices on element already initialised', {
                                element: element
                            });
                            this.initialised = true;
                            return;
                        }
                        // Let's go
                        this.init();
                    }
                    Object.defineProperty(Choices, "defaults", {
                        get: function() {
                            return Object.preventExtensions({
                                get options () {
                                    return USER_DEFAULTS;
                                },
                                get templates () {
                                    return templates_1.default;
                                }
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Choices.prototype.init = function() {
                        if (this.initialised) return;
                        this._createTemplates();
                        this._createElements();
                        this._createStructure();
                        this._store.subscribe(this._render);
                        this._render();
                        this._addEventListeners();
                        var shouldDisable = !this.config.addItems || this.passedElement.element.hasAttribute('disabled');
                        if (shouldDisable) this.disable();
                        this.initialised = true;
                        var callbackOnInit = this.config.callbackOnInit;
                        // Run callback if it is a function
                        if (callbackOnInit && typeof callbackOnInit === 'function') callbackOnInit.call(this);
                    };
                    Choices.prototype.destroy = function() {
                        if (!this.initialised) return;
                        this._removeEventListeners();
                        this.passedElement.reveal();
                        this.containerOuter.unwrap(this.passedElement.element);
                        this.clearStore();
                        if (this._isSelectElement) this.passedElement.options = this._presetOptions;
                        this._templates = templates_1.default;
                        this.initialised = false;
                    };
                    Choices.prototype.enable = function() {
                        if (this.passedElement.isDisabled) this.passedElement.enable();
                        if (this.containerOuter.isDisabled) {
                            this._addEventListeners();
                            this.input.enable();
                            this.containerOuter.enable();
                        }
                        return this;
                    };
                    Choices.prototype.disable = function() {
                        if (!this.passedElement.isDisabled) this.passedElement.disable();
                        if (!this.containerOuter.isDisabled) {
                            this._removeEventListeners();
                            this.input.disable();
                            this.containerOuter.disable();
                        }
                        return this;
                    };
                    Choices.prototype.highlightItem = function(item, runEvent) {
                        if (runEvent === void 0) runEvent = true;
                        if (!item || !item.id) return this;
                        var id = item.id, _a = item.groupId, groupId = _a === void 0 ? -1 : _a, _b = item.value, value = _b === void 0 ? '' : _b, _c = item.label, label = _c === void 0 ? '' : _c;
                        var group = groupId >= 0 ? this._store.getGroupById(groupId) : null;
                        this._store.dispatch((0, items_1.highlightItem)(id, true));
                        if (runEvent) this.passedElement.triggerEvent(constants_1.EVENTS.highlightItem, {
                            id: id,
                            value: value,
                            label: label,
                            groupValue: group && group.value ? group.value : null
                        });
                        return this;
                    };
                    Choices.prototype.unhighlightItem = function(item) {
                        if (!item || !item.id) return this;
                        var id = item.id, _a = item.groupId, groupId = _a === void 0 ? -1 : _a, _b = item.value, value = _b === void 0 ? '' : _b, _c = item.label, label = _c === void 0 ? '' : _c;
                        var group = groupId >= 0 ? this._store.getGroupById(groupId) : null;
                        this._store.dispatch((0, items_1.highlightItem)(id, false));
                        this.passedElement.triggerEvent(constants_1.EVENTS.highlightItem, {
                            id: id,
                            value: value,
                            label: label,
                            groupValue: group && group.value ? group.value : null
                        });
                        return this;
                    };
                    Choices.prototype.highlightAll = function() {
                        var _this = this;
                        this._store.items.forEach(function(item) {
                            return _this.highlightItem(item);
                        });
                        return this;
                    };
                    Choices.prototype.unhighlightAll = function() {
                        var _this = this;
                        this._store.items.forEach(function(item) {
                            return _this.unhighlightItem(item);
                        });
                        return this;
                    };
                    Choices.prototype.removeActiveItemsByValue = function(value) {
                        var _this = this;
                        this._store.activeItems.filter(function(item) {
                            return item.value === value;
                        }).forEach(function(item) {
                            return _this._removeItem(item);
                        });
                        return this;
                    };
                    Choices.prototype.removeActiveItems = function(excludedId) {
                        var _this = this;
                        this._store.activeItems.filter(function(_a) {
                            var id = _a.id;
                            return id !== excludedId;
                        }).forEach(function(item) {
                            return _this._removeItem(item);
                        });
                        return this;
                    };
                    Choices.prototype.removeHighlightedItems = function(runEvent) {
                        var _this = this;
                        if (runEvent === void 0) runEvent = false;
                        this._store.highlightedActiveItems.forEach(function(item) {
                            _this._removeItem(item);
                            // If this action was performed by the user
                            // trigger the event
                            if (runEvent) _this._triggerChange(item.value);
                        });
                        return this;
                    };
                    Choices.prototype.showDropdown = function(preventInputFocus) {
                        var _this = this;
                        if (this.dropdown.isActive) return this;
                        requestAnimationFrame(function() {
                            _this.dropdown.show();
                            _this.containerOuter.open(_this.dropdown.distanceFromTopWindow);
                            if (!preventInputFocus && _this._canSearch) _this.input.focus();
                            _this.passedElement.triggerEvent(constants_1.EVENTS.showDropdown, {});
                        });
                        return this;
                    };
                    Choices.prototype.hideDropdown = function(preventInputBlur) {
                        var _this = this;
                        if (!this.dropdown.isActive) return this;
                        requestAnimationFrame(function() {
                            _this.dropdown.hide();
                            _this.containerOuter.close();
                            if (!preventInputBlur && _this._canSearch) {
                                _this.input.removeActiveDescendant();
                                _this.input.blur();
                            }
                            _this.passedElement.triggerEvent(constants_1.EVENTS.hideDropdown, {});
                        });
                        return this;
                    };
                    Choices.prototype.getValue = function(valueOnly) {
                        if (valueOnly === void 0) valueOnly = false;
                        var values = this._store.activeItems.reduce(function(selectedItems, item) {
                            var itemValue = valueOnly ? item.value : item;
                            selectedItems.push(itemValue);
                            return selectedItems;
                        }, []);
                        return this._isSelectOneElement ? values[0] : values;
                    };
                    Choices.prototype.setValue = function(items) {
                        var _this = this;
                        if (!this.initialised) return this;
                        items.forEach(function(value) {
                            return _this._setChoiceOrItem(value);
                        });
                        return this;
                    };
                    Choices.prototype.setChoiceByValue = function(value) {
                        var _this = this;
                        if (!this.initialised || this._isTextElement) return this;
                        // If only one value has been passed, convert to array
                        var choiceValue = Array.isArray(value) ? value : [
                            value
                        ];
                        // Loop through each value and
                        choiceValue.forEach(function(val) {
                            return _this._findAndSelectChoiceByValue(val);
                        });
                        return this;
                    };
                    /**
   * Set choices of select input via an array of objects (or function that returns array of object or promise of it),
   * a value field name and a label field name.
   * This behaves the same as passing items via the choices option but can be called after initialising Choices.
   * This can also be used to add groups of choices (see example 2); Optionally pass a true `replaceChoices` value to remove any existing choices.
   * Optionally pass a `customProperties` object to add additional data to your choices (useful when searching/filtering etc).
   *
   * **Input types affected:** select-one, select-multiple
   *
   * @example
   * ```js
   * const example = new Choices(element);
   *
   * example.setChoices([
   *   {value: 'One', label: 'Label One', disabled: true},
   *   {value: 'Two', label: 'Label Two', selected: true},
   *   {value: 'Three', label: 'Label Three'},
   * ], 'value', 'label', false);
   * ```
   *
   * @example
   * ```js
   * const example = new Choices(element);
   *
   * example.setChoices(async () => {
   *   try {
   *      const items = await fetch('/items');
   *      return items.json()
   *   } catch(err) {
   *      console.error(err)
   *   }
   * });
   * ```
   *
   * @example
   * ```js
   * const example = new Choices(element);
   *
   * example.setChoices([{
   *   label: 'Group one',
   *   id: 1,
   *   disabled: false,
   *   choices: [
   *     {value: 'Child One', label: 'Child One', selected: true},
   *     {value: 'Child Two', label: 'Child Two',  disabled: true},
   *     {value: 'Child Three', label: 'Child Three'},
   *   ]
   * },
   * {
   *   label: 'Group two',
   *   id: 2,
   *   disabled: false,
   *   choices: [
   *     {value: 'Child Four', label: 'Child Four', disabled: true},
   *     {value: 'Child Five', label: 'Child Five'},
   *     {value: 'Child Six', label: 'Child Six', customProperties: {
   *       description: 'Custom description about child six',
   *       random: 'Another random custom property'
   *     }},
   *   ]
   * }], 'value', 'label', false);
   * ```
   */ Choices.prototype.setChoices = function(choicesArrayOrFetcher, value, label, replaceChoices) {
                        var _this = this;
                        if (choicesArrayOrFetcher === void 0) choicesArrayOrFetcher = [];
                        if (value === void 0) value = 'value';
                        if (label === void 0) label = 'label';
                        if (replaceChoices === void 0) replaceChoices = false;
                        if (!this.initialised) throw new ReferenceError("setChoices was called on a non-initialized instance of Choices");
                        if (!this._isSelectElement) throw new TypeError("setChoices can't be used with INPUT based Choices");
                        if (typeof value !== 'string' || !value) throw new TypeError("value parameter must be a name of 'value' field in passed objects");
                        // Clear choices if needed
                        if (replaceChoices) this.clearChoices();
                        if (typeof choicesArrayOrFetcher === 'function') {
                            // it's a choices fetcher function
                            var fetcher_1 = choicesArrayOrFetcher(this);
                            if (typeof Promise === 'function' && fetcher_1 instanceof Promise) // that's a promise
                            // eslint-disable-next-line no-promise-executor-return
                            return new Promise(function(resolve) {
                                return requestAnimationFrame(resolve);
                            }).then(function() {
                                return _this._handleLoadingState(true);
                            }).then(function() {
                                return fetcher_1;
                            }).then(function(data) {
                                return _this.setChoices(data, value, label, replaceChoices);
                            }).catch(function(err) {
                                if (!_this.config.silent) console.error(err);
                            }).then(function() {
                                return _this._handleLoadingState(false);
                            }).then(function() {
                                return _this;
                            });
                            // function returned something else than promise, let's check if it's an array of choices
                            if (!Array.isArray(fetcher_1)) throw new TypeError(".setChoices first argument function must return either array of choices or Promise, got: ".concat(typeof fetcher_1));
                            // recursion with results, it's sync and choices were cleared already
                            return this.setChoices(fetcher_1, value, label, false);
                        }
                        if (!Array.isArray(choicesArrayOrFetcher)) throw new TypeError(".setChoices must be called either with array of choices with a function resulting into Promise of array of choices");
                        this.containerOuter.removeLoadingState();
                        this._startLoading();
                        choicesArrayOrFetcher.forEach(function(groupOrChoice) {
                            if (groupOrChoice.choices) _this._addGroup({
                                id: groupOrChoice.id ? parseInt("".concat(groupOrChoice.id), 10) : null,
                                group: groupOrChoice,
                                valueKey: value,
                                labelKey: label
                            });
                            else {
                                var choice = groupOrChoice;
                                _this._addChoice({
                                    value: choice[value],
                                    label: choice[label],
                                    isSelected: !!choice.selected,
                                    isDisabled: !!choice.disabled,
                                    placeholder: !!choice.placeholder,
                                    customProperties: choice.customProperties
                                });
                            }
                        });
                        this._stopLoading();
                        return this;
                    };
                    Choices.prototype.clearChoices = function() {
                        this._store.dispatch((0, choices_1.clearChoices)());
                        return this;
                    };
                    Choices.prototype.clearStore = function() {
                        this._store.dispatch((0, misc_1.clearAll)());
                        return this;
                    };
                    Choices.prototype.clearInput = function() {
                        var shouldSetInputWidth = !this._isSelectOneElement;
                        this.input.clear(shouldSetInputWidth);
                        if (!this._isTextElement && this._canSearch) {
                            this._isSearching = false;
                            this._store.dispatch((0, choices_1.activateChoices)(true));
                        }
                        return this;
                    };
                    Choices.prototype._render = function() {
                        if (this._store.isLoading()) return;
                        this._currentState = this._store.state;
                        var stateChanged = this._currentState.choices !== this._prevState.choices || this._currentState.groups !== this._prevState.groups || this._currentState.items !== this._prevState.items;
                        var shouldRenderChoices = this._isSelectElement;
                        var shouldRenderItems = this._currentState.items !== this._prevState.items;
                        if (!stateChanged) return;
                        if (shouldRenderChoices) this._renderChoices();
                        if (shouldRenderItems) this._renderItems();
                        this._prevState = this._currentState;
                    };
                    Choices.prototype._renderChoices = function() {
                        var _this = this;
                        var _a = this._store, activeGroups = _a.activeGroups, activeChoices = _a.activeChoices;
                        var choiceListFragment = document.createDocumentFragment();
                        this.choiceList.clear();
                        if (this.config.resetScrollPosition) requestAnimationFrame(function() {
                            return _this.choiceList.scrollToTop();
                        });
                        // If we have grouped options
                        if (activeGroups.length >= 1 && !this._isSearching) {
                            // If we have a placeholder choice along with groups
                            var activePlaceholders = activeChoices.filter(function(activeChoice) {
                                return activeChoice.placeholder === true && activeChoice.groupId === -1;
                            });
                            if (activePlaceholders.length >= 1) choiceListFragment = this._createChoicesFragment(activePlaceholders, choiceListFragment);
                            choiceListFragment = this._createGroupsFragment(activeGroups, activeChoices, choiceListFragment);
                        } else if (activeChoices.length >= 1) choiceListFragment = this._createChoicesFragment(activeChoices, choiceListFragment);
                        // If we have choices to show
                        if (choiceListFragment.childNodes && choiceListFragment.childNodes.length > 0) {
                            var activeItems = this._store.activeItems;
                            var canAddItem = this._canAddItem(activeItems, this.input.value);
                            // ...and we can select them
                            if (canAddItem.response) {
                                // ...append them and highlight the first choice
                                this.choiceList.append(choiceListFragment);
                                this._highlightChoice();
                            } else {
                                var notice = this._getTemplate('notice', canAddItem.notice);
                                this.choiceList.append(notice);
                            }
                        } else {
                            // Otherwise show a notice
                            var dropdownItem = void 0;
                            var notice = void 0;
                            if (this._isSearching) {
                                notice = typeof this.config.noResultsText === 'function' ? this.config.noResultsText() : this.config.noResultsText;
                                dropdownItem = this._getTemplate('notice', notice, 'no-results');
                            } else {
                                notice = typeof this.config.noChoicesText === 'function' ? this.config.noChoicesText() : this.config.noChoicesText;
                                dropdownItem = this._getTemplate('notice', notice, 'no-choices');
                            }
                            this.choiceList.append(dropdownItem);
                        }
                    };
                    Choices.prototype._renderItems = function() {
                        var activeItems = this._store.activeItems || [];
                        this.itemList.clear();
                        // Create a fragment to store our list items
                        // (so we don't have to update the DOM for each item)
                        var itemListFragment = this._createItemsFragment(activeItems);
                        // If we have items to add, append them
                        if (itemListFragment.childNodes) this.itemList.append(itemListFragment);
                    };
                    Choices.prototype._createGroupsFragment = function(groups, choices, fragment) {
                        var _this = this;
                        if (fragment === void 0) fragment = document.createDocumentFragment();
                        var getGroupChoices = function(group) {
                            return choices.filter(function(choice) {
                                if (_this._isSelectOneElement) return choice.groupId === group.id;
                                return choice.groupId === group.id && (_this.config.renderSelectedChoices === 'always' || !choice.selected);
                            });
                        };
                        // If sorting is enabled, filter groups
                        if (this.config.shouldSort) groups.sort(this.config.sorter);
                        groups.forEach(function(group) {
                            var groupChoices = getGroupChoices(group);
                            if (groupChoices.length >= 1) {
                                var dropdownGroup = _this._getTemplate('choiceGroup', group);
                                fragment.appendChild(dropdownGroup);
                                _this._createChoicesFragment(groupChoices, fragment, true);
                            }
                        });
                        return fragment;
                    };
                    Choices.prototype._createChoicesFragment = function(choices, fragment, withinGroup) {
                        var _this = this;
                        if (fragment === void 0) fragment = document.createDocumentFragment();
                        if (withinGroup === void 0) withinGroup = false;
                        // Create a fragment to store our list items (so we don't have to update the DOM for each item)
                        var _a = this.config, renderSelectedChoices = _a.renderSelectedChoices, searchResultLimit = _a.searchResultLimit, renderChoiceLimit = _a.renderChoiceLimit;
                        var filter = this._isSearching ? utils_1.sortByScore : this.config.sorter;
                        var appendChoice = function(choice) {
                            var shouldRender = renderSelectedChoices === 'auto' ? _this._isSelectOneElement || !choice.selected : true;
                            if (shouldRender) {
                                var dropdownItem = _this._getTemplate('choice', choice, _this.config.itemSelectText);
                                fragment.appendChild(dropdownItem);
                            }
                        };
                        var rendererableChoices = choices;
                        if (renderSelectedChoices === 'auto' && !this._isSelectOneElement) rendererableChoices = choices.filter(function(choice) {
                            return !choice.selected;
                        });
                        // Split array into placeholders and "normal" choices
                        var _b = rendererableChoices.reduce(function(acc, choice) {
                            if (choice.placeholder) acc.placeholderChoices.push(choice);
                            else acc.normalChoices.push(choice);
                            return acc;
                        }, {
                            placeholderChoices: [],
                            normalChoices: []
                        }), placeholderChoices = _b.placeholderChoices, normalChoices = _b.normalChoices;
                        // If sorting is enabled or the user is searching, filter choices
                        if (this.config.shouldSort || this._isSearching) normalChoices.sort(filter);
                        var choiceLimit = rendererableChoices.length;
                        // Prepend placeholeder
                        var sortedChoices = this._isSelectOneElement ? __spreadArray(__spreadArray([], placeholderChoices, true), normalChoices, true) : normalChoices;
                        if (this._isSearching) choiceLimit = searchResultLimit;
                        else if (renderChoiceLimit && renderChoiceLimit > 0 && !withinGroup) choiceLimit = renderChoiceLimit;
                        // Add each choice to dropdown within range
                        for(var i = 0; i < choiceLimit; i += 1)if (sortedChoices[i]) appendChoice(sortedChoices[i]);
                        return fragment;
                    };
                    Choices.prototype._createItemsFragment = function(items, fragment) {
                        var _this = this;
                        if (fragment === void 0) fragment = document.createDocumentFragment();
                        // Create fragment to add elements to
                        var _a = this.config, shouldSortItems = _a.shouldSortItems, sorter = _a.sorter, removeItemButton = _a.removeItemButton;
                        // If sorting is enabled, filter items
                        if (shouldSortItems && !this._isSelectOneElement) items.sort(sorter);
                        if (this._isTextElement) // Update the value of the hidden input
                        this.passedElement.value = items.map(function(_a) {
                            var value = _a.value;
                            return value;
                        }).join(this.config.delimiter);
                        else // Update the options of the hidden input
                        this.passedElement.options = items;
                        var addItemToFragment = function(item) {
                            // Create new list element
                            var listItem = _this._getTemplate('item', item, removeItemButton);
                            // Append it to list
                            fragment.appendChild(listItem);
                        };
                        // Add each list item to list
                        items.forEach(addItemToFragment);
                        return fragment;
                    };
                    Choices.prototype._triggerChange = function(value) {
                        if (value === undefined || value === null) return;
                        this.passedElement.triggerEvent(constants_1.EVENTS.change, {
                            value: value
                        });
                    };
                    Choices.prototype._selectPlaceholderChoice = function(placeholderChoice) {
                        this._addItem({
                            value: placeholderChoice.value,
                            label: placeholderChoice.label,
                            choiceId: placeholderChoice.id,
                            groupId: placeholderChoice.groupId,
                            placeholder: placeholderChoice.placeholder
                        });
                        this._triggerChange(placeholderChoice.value);
                    };
                    Choices.prototype._handleButtonAction = function(activeItems, element) {
                        if (!activeItems || !element || !this.config.removeItems || !this.config.removeItemButton) return;
                        var itemId = element.parentNode && element.parentNode.dataset.id;
                        var itemToRemove = itemId && activeItems.find(function(item) {
                            return item.id === parseInt(itemId, 10);
                        });
                        if (!itemToRemove) return;
                        // Remove item associated with button
                        this._removeItem(itemToRemove);
                        this._triggerChange(itemToRemove.value);
                        if (this._isSelectOneElement && this._store.placeholderChoice) this._selectPlaceholderChoice(this._store.placeholderChoice);
                    };
                    Choices.prototype._handleItemAction = function(activeItems, element, hasShiftKey) {
                        var _this = this;
                        if (hasShiftKey === void 0) hasShiftKey = false;
                        if (!activeItems || !element || !this.config.removeItems || this._isSelectOneElement) return;
                        var passedId = element.dataset.id;
                        // We only want to select one item with a click
                        // so we deselect any items that aren't the target
                        // unless shift is being pressed
                        activeItems.forEach(function(item) {
                            if (item.id === parseInt("".concat(passedId), 10) && !item.highlighted) _this.highlightItem(item);
                            else if (!hasShiftKey && item.highlighted) _this.unhighlightItem(item);
                        });
                        // Focus input as without focus, a user cannot do anything with a
                        // highlighted item
                        this.input.focus();
                    };
                    Choices.prototype._handleChoiceAction = function(activeItems, element) {
                        if (!activeItems || !element) return;
                        // If we are clicking on an option
                        var id = element.dataset.id;
                        var choice = id && this._store.getChoiceById(id);
                        if (!choice) return;
                        var passedKeyCode = activeItems[0] && activeItems[0].keyCode ? activeItems[0].keyCode : undefined;
                        var hasActiveDropdown = this.dropdown.isActive;
                        // Update choice keyCode
                        choice.keyCode = passedKeyCode;
                        this.passedElement.triggerEvent(constants_1.EVENTS.choice, {
                            choice: choice
                        });
                        if (!choice.selected && !choice.disabled) {
                            var canAddItem = this._canAddItem(activeItems, choice.value);
                            if (canAddItem.response) {
                                this._addItem({
                                    value: choice.value,
                                    label: choice.label,
                                    choiceId: choice.id,
                                    groupId: choice.groupId,
                                    customProperties: choice.customProperties,
                                    placeholder: choice.placeholder,
                                    keyCode: choice.keyCode
                                });
                                this._triggerChange(choice.value);
                            }
                        }
                        this.clearInput();
                        // We want to close the dropdown if we are dealing with a single select box
                        if (hasActiveDropdown && this._isSelectOneElement) {
                            this.hideDropdown(true);
                            this.containerOuter.focus();
                        }
                    };
                    Choices.prototype._handleBackspace = function(activeItems) {
                        if (!this.config.removeItems || !activeItems) return;
                        var lastItem = activeItems[activeItems.length - 1];
                        var hasHighlightedItems = activeItems.some(function(item) {
                            return item.highlighted;
                        });
                        // If editing the last item is allowed and there are not other selected items,
                        // we can edit the item value. Otherwise if we can remove items, remove all selected items
                        if (this.config.editItems && !hasHighlightedItems && lastItem) {
                            this.input.value = lastItem.value;
                            this.input.setWidth();
                            this._removeItem(lastItem);
                            this._triggerChange(lastItem.value);
                        } else {
                            if (!hasHighlightedItems) // Highlight last item if none already highlighted
                            this.highlightItem(lastItem, false);
                            this.removeHighlightedItems(true);
                        }
                    };
                    Choices.prototype._startLoading = function() {
                        this._store.dispatch((0, misc_1.setIsLoading)(true));
                    };
                    Choices.prototype._stopLoading = function() {
                        this._store.dispatch((0, misc_1.setIsLoading)(false));
                    };
                    Choices.prototype._handleLoadingState = function(setLoading) {
                        if (setLoading === void 0) setLoading = true;
                        var placeholderItem = this.itemList.getChild(".".concat(this.config.classNames.placeholder));
                        if (setLoading) {
                            this.disable();
                            this.containerOuter.addLoadingState();
                            if (this._isSelectOneElement) {
                                if (!placeholderItem) {
                                    placeholderItem = this._getTemplate('placeholder', this.config.loadingText);
                                    if (placeholderItem) this.itemList.append(placeholderItem);
                                } else placeholderItem.innerHTML = this.config.loadingText;
                            } else this.input.placeholder = this.config.loadingText;
                        } else {
                            this.enable();
                            this.containerOuter.removeLoadingState();
                            if (this._isSelectOneElement) {
                                if (placeholderItem) placeholderItem.innerHTML = this._placeholderValue || '';
                            } else this.input.placeholder = this._placeholderValue || '';
                        }
                    };
                    Choices.prototype._handleSearch = function(value) {
                        if (!this.input.isFocussed) return;
                        var choices = this._store.choices;
                        var _a = this.config, searchFloor = _a.searchFloor, searchChoices = _a.searchChoices;
                        var hasUnactiveChoices = choices.some(function(option) {
                            return !option.active;
                        });
                        // Check that we have a value to search and the input was an alphanumeric character
                        if (value !== null && typeof value !== 'undefined' && value.length >= searchFloor) {
                            var resultCount = searchChoices ? this._searchChoices(value) : 0;
                            // Trigger search event
                            this.passedElement.triggerEvent(constants_1.EVENTS.search, {
                                value: value,
                                resultCount: resultCount
                            });
                        } else if (hasUnactiveChoices) {
                            // Otherwise reset choices to active
                            this._isSearching = false;
                            this._store.dispatch((0, choices_1.activateChoices)(true));
                        }
                    };
                    Choices.prototype._canAddItem = function(activeItems, value) {
                        var canAddItem = true;
                        var notice = typeof this.config.addItemText === 'function' ? this.config.addItemText(value) : this.config.addItemText;
                        if (!this._isSelectOneElement) {
                            var isDuplicateValue = (0, utils_1.existsInArray)(activeItems, value);
                            if (this.config.maxItemCount > 0 && this.config.maxItemCount <= activeItems.length) {
                                // If there is a max entry limit and we have reached that limit
                                // don't update
                                canAddItem = false;
                                notice = typeof this.config.maxItemText === 'function' ? this.config.maxItemText(this.config.maxItemCount) : this.config.maxItemText;
                            }
                            if (!this.config.duplicateItemsAllowed && isDuplicateValue && canAddItem) {
                                canAddItem = false;
                                notice = typeof this.config.uniqueItemText === 'function' ? this.config.uniqueItemText(value) : this.config.uniqueItemText;
                            }
                            if (this._isTextElement && this.config.addItems && canAddItem && typeof this.config.addItemFilter === 'function' && !this.config.addItemFilter(value)) {
                                canAddItem = false;
                                notice = typeof this.config.customAddItemText === 'function' ? this.config.customAddItemText(value) : this.config.customAddItemText;
                            }
                        }
                        return {
                            response: canAddItem,
                            notice: notice
                        };
                    };
                    Choices.prototype._searchChoices = function(value) {
                        var newValue = typeof value === 'string' ? value.trim() : value;
                        var currentValue = typeof this._currentValue === 'string' ? this._currentValue.trim() : this._currentValue;
                        if (newValue.length < 1 && newValue === "".concat(currentValue, " ")) return 0;
                        // If new value matches the desired length and is not the same as the current value with a space
                        var haystack = this._store.searchableChoices;
                        var needle = newValue;
                        var options = Object.assign(this.config.fuseOptions, {
                            keys: __spreadArray([], this.config.searchFields, true),
                            includeMatches: true
                        });
                        var fuse = new fuse_js_1.default(haystack, options);
                        var results = fuse.search(needle); // see https://github.com/krisk/Fuse/issues/303
                        this._currentValue = newValue;
                        this._highlightPosition = 0;
                        this._isSearching = true;
                        this._store.dispatch((0, choices_1.filterChoices)(results));
                        return results.length;
                    };
                    Choices.prototype._addEventListeners = function() {
                        var documentElement = document.documentElement;
                        // capture events - can cancel event processing or propagation
                        documentElement.addEventListener('touchend', this._onTouchEnd, true);
                        this.containerOuter.element.addEventListener('keydown', this._onKeyDown, true);
                        this.containerOuter.element.addEventListener('mousedown', this._onMouseDown, true);
                        // passive events - doesn't call `preventDefault` or `stopPropagation`
                        documentElement.addEventListener('click', this._onClick, {
                            passive: true
                        });
                        documentElement.addEventListener('touchmove', this._onTouchMove, {
                            passive: true
                        });
                        this.dropdown.element.addEventListener('mouseover', this._onMouseOver, {
                            passive: true
                        });
                        if (this._isSelectOneElement) {
                            this.containerOuter.element.addEventListener('focus', this._onFocus, {
                                passive: true
                            });
                            this.containerOuter.element.addEventListener('blur', this._onBlur, {
                                passive: true
                            });
                        }
                        this.input.element.addEventListener('keyup', this._onKeyUp, {
                            passive: true
                        });
                        this.input.element.addEventListener('focus', this._onFocus, {
                            passive: true
                        });
                        this.input.element.addEventListener('blur', this._onBlur, {
                            passive: true
                        });
                        if (this.input.element.form) this.input.element.form.addEventListener('reset', this._onFormReset, {
                            passive: true
                        });
                        this.input.addEventListeners();
                    };
                    Choices.prototype._removeEventListeners = function() {
                        var documentElement = document.documentElement;
                        documentElement.removeEventListener('touchend', this._onTouchEnd, true);
                        this.containerOuter.element.removeEventListener('keydown', this._onKeyDown, true);
                        this.containerOuter.element.removeEventListener('mousedown', this._onMouseDown, true);
                        documentElement.removeEventListener('click', this._onClick);
                        documentElement.removeEventListener('touchmove', this._onTouchMove);
                        this.dropdown.element.removeEventListener('mouseover', this._onMouseOver);
                        if (this._isSelectOneElement) {
                            this.containerOuter.element.removeEventListener('focus', this._onFocus);
                            this.containerOuter.element.removeEventListener('blur', this._onBlur);
                        }
                        this.input.element.removeEventListener('keyup', this._onKeyUp);
                        this.input.element.removeEventListener('focus', this._onFocus);
                        this.input.element.removeEventListener('blur', this._onBlur);
                        if (this.input.element.form) this.input.element.form.removeEventListener('reset', this._onFormReset);
                        this.input.removeEventListeners();
                    };
                    Choices.prototype._onKeyDown = function(event) {
                        var keyCode = event.keyCode;
                        var activeItems = this._store.activeItems;
                        var hasFocusedInput = this.input.isFocussed;
                        var hasActiveDropdown = this.dropdown.isActive;
                        var hasItems = this.itemList.hasChildren();
                        var keyString = String.fromCharCode(keyCode);
                        // eslint-disable-next-line no-control-regex
                        var wasPrintableChar = /[^\x00-\x1F]/.test(keyString);
                        var BACK_KEY = constants_1.KEY_CODES.BACK_KEY, DELETE_KEY = constants_1.KEY_CODES.DELETE_KEY, ENTER_KEY = constants_1.KEY_CODES.ENTER_KEY, A_KEY = constants_1.KEY_CODES.A_KEY, ESC_KEY = constants_1.KEY_CODES.ESC_KEY, UP_KEY = constants_1.KEY_CODES.UP_KEY, DOWN_KEY = constants_1.KEY_CODES.DOWN_KEY, PAGE_UP_KEY = constants_1.KEY_CODES.PAGE_UP_KEY, PAGE_DOWN_KEY = constants_1.KEY_CODES.PAGE_DOWN_KEY;
                        if (!this._isTextElement && !hasActiveDropdown && wasPrintableChar) {
                            this.showDropdown();
                            if (!this.input.isFocussed) /*
          We update the input value with the pressed key as
          the input was not focussed at the time of key press
          therefore does not have the value of the key.
        */ this.input.value += event.key.toLowerCase();
                        }
                        switch(keyCode){
                            case A_KEY:
                                return this._onSelectKey(event, hasItems);
                            case ENTER_KEY:
                                return this._onEnterKey(event, activeItems, hasActiveDropdown);
                            case ESC_KEY:
                                return this._onEscapeKey(hasActiveDropdown);
                            case UP_KEY:
                            case PAGE_UP_KEY:
                            case DOWN_KEY:
                            case PAGE_DOWN_KEY:
                                return this._onDirectionKey(event, hasActiveDropdown);
                            case DELETE_KEY:
                            case BACK_KEY:
                                return this._onDeleteKey(event, activeItems, hasFocusedInput);
                            default:
                        }
                    };
                    Choices.prototype._onKeyUp = function(_a) {
                        var target = _a.target, keyCode = _a.keyCode;
                        var value = this.input.value;
                        var activeItems = this._store.activeItems;
                        var canAddItem = this._canAddItem(activeItems, value);
                        var backKey = constants_1.KEY_CODES.BACK_KEY, deleteKey = constants_1.KEY_CODES.DELETE_KEY;
                        // We are typing into a text input and have a value, we want to show a dropdown
                        // notice. Otherwise hide the dropdown
                        if (this._isTextElement) {
                            var canShowDropdownNotice = canAddItem.notice && value;
                            if (canShowDropdownNotice) {
                                var dropdownItem = this._getTemplate('notice', canAddItem.notice);
                                this.dropdown.element.innerHTML = dropdownItem.outerHTML;
                                this.showDropdown(true);
                            } else this.hideDropdown(true);
                        } else {
                            var wasRemovalKeyCode = keyCode === backKey || keyCode === deleteKey;
                            var userHasRemovedValue = wasRemovalKeyCode && target && !target.value;
                            var canReactivateChoices = !this._isTextElement && this._isSearching;
                            var canSearch = this._canSearch && canAddItem.response;
                            if (userHasRemovedValue && canReactivateChoices) {
                                this._isSearching = false;
                                this._store.dispatch((0, choices_1.activateChoices)(true));
                            } else if (canSearch) this._handleSearch(this.input.rawValue);
                        }
                        this._canSearch = this.config.searchEnabled;
                    };
                    Choices.prototype._onSelectKey = function(event, hasItems) {
                        var ctrlKey = event.ctrlKey, metaKey = event.metaKey;
                        var hasCtrlDownKeyPressed = ctrlKey || metaKey;
                        // If CTRL + A or CMD + A have been pressed and there are items to select
                        if (hasCtrlDownKeyPressed && hasItems) {
                            this._canSearch = false;
                            var shouldHightlightAll = this.config.removeItems && !this.input.value && this.input.element === document.activeElement;
                            if (shouldHightlightAll) this.highlightAll();
                        }
                    };
                    Choices.prototype._onEnterKey = function(event, activeItems, hasActiveDropdown) {
                        var target = event.target;
                        var enterKey = constants_1.KEY_CODES.ENTER_KEY;
                        var targetWasButton = target && target.hasAttribute('data-button');
                        if (this._isTextElement && target && target.value) {
                            var value = this.input.value;
                            var canAddItem = this._canAddItem(activeItems, value);
                            if (canAddItem.response) {
                                this.hideDropdown(true);
                                this._addItem({
                                    value: value
                                });
                                this._triggerChange(value);
                                this.clearInput();
                            }
                        }
                        if (targetWasButton) {
                            this._handleButtonAction(activeItems, target);
                            event.preventDefault();
                        }
                        if (hasActiveDropdown) {
                            var highlightedChoice = this.dropdown.getChild(".".concat(this.config.classNames.highlightedState));
                            if (highlightedChoice) {
                                // add enter keyCode value
                                if (activeItems[0]) activeItems[0].keyCode = enterKey; // eslint-disable-line no-param-reassign
                                this._handleChoiceAction(activeItems, highlightedChoice);
                            }
                            event.preventDefault();
                        } else if (this._isSelectOneElement) {
                            this.showDropdown();
                            event.preventDefault();
                        }
                    };
                    Choices.prototype._onEscapeKey = function(hasActiveDropdown) {
                        if (hasActiveDropdown) {
                            this.hideDropdown(true);
                            this.containerOuter.focus();
                        }
                    };
                    Choices.prototype._onDirectionKey = function(event, hasActiveDropdown) {
                        var keyCode = event.keyCode, metaKey = event.metaKey;
                        var downKey = constants_1.KEY_CODES.DOWN_KEY, pageUpKey = constants_1.KEY_CODES.PAGE_UP_KEY, pageDownKey = constants_1.KEY_CODES.PAGE_DOWN_KEY;
                        // If up or down key is pressed, traverse through options
                        if (hasActiveDropdown || this._isSelectOneElement) {
                            this.showDropdown();
                            this._canSearch = false;
                            var directionInt = keyCode === downKey || keyCode === pageDownKey ? 1 : -1;
                            var skipKey = metaKey || keyCode === pageDownKey || keyCode === pageUpKey;
                            var selectableChoiceIdentifier = '[data-choice-selectable]';
                            var nextEl = void 0;
                            if (skipKey) {
                                if (directionInt > 0) nextEl = this.dropdown.element.querySelector("".concat(selectableChoiceIdentifier, ":last-of-type"));
                                else nextEl = this.dropdown.element.querySelector(selectableChoiceIdentifier);
                            } else {
                                var currentEl = this.dropdown.element.querySelector(".".concat(this.config.classNames.highlightedState));
                                if (currentEl) nextEl = (0, utils_1.getAdjacentEl)(currentEl, selectableChoiceIdentifier, directionInt);
                                else nextEl = this.dropdown.element.querySelector(selectableChoiceIdentifier);
                            }
                            if (nextEl) {
                                // We prevent default to stop the cursor moving
                                // when pressing the arrow
                                if (!(0, utils_1.isScrolledIntoView)(nextEl, this.choiceList.element, directionInt)) this.choiceList.scrollToChildElement(nextEl, directionInt);
                                this._highlightChoice(nextEl);
                            }
                            // Prevent default to maintain cursor position whilst
                            // traversing dropdown options
                            event.preventDefault();
                        }
                    };
                    Choices.prototype._onDeleteKey = function(event, activeItems, hasFocusedInput) {
                        var target = event.target;
                        // If backspace or delete key is pressed and the input has no value
                        if (!this._isSelectOneElement && !target.value && hasFocusedInput) {
                            this._handleBackspace(activeItems);
                            event.preventDefault();
                        }
                    };
                    Choices.prototype._onTouchMove = function() {
                        if (this._wasTap) this._wasTap = false;
                    };
                    Choices.prototype._onTouchEnd = function(event) {
                        var target = (event || event.touches[0]).target;
                        var touchWasWithinContainer = this._wasTap && this.containerOuter.element.contains(target);
                        if (touchWasWithinContainer) {
                            var containerWasExactTarget = target === this.containerOuter.element || target === this.containerInner.element;
                            if (containerWasExactTarget) {
                                if (this._isTextElement) this.input.focus();
                                else if (this._isSelectMultipleElement) this.showDropdown();
                            }
                            // Prevents focus event firing
                            event.stopPropagation();
                        }
                        this._wasTap = true;
                    };
                    /**
   * Handles mousedown event in capture mode for containetOuter.element
   */ Choices.prototype._onMouseDown = function(event) {
                        var target = event.target;
                        if (!(target instanceof HTMLElement)) return;
                        // If we have our mouse down on the scrollbar and are on IE11...
                        if (IS_IE11 && this.choiceList.element.contains(target)) {
                            // check if click was on a scrollbar area
                            var firstChoice = this.choiceList.element.firstElementChild;
                            var isOnScrollbar = this._direction === 'ltr' ? event.offsetX >= firstChoice.offsetWidth : event.offsetX < firstChoice.offsetLeft;
                            this._isScrollingOnIe = isOnScrollbar;
                        }
                        if (target === this.input.element) return;
                        var item = target.closest('[data-button],[data-item],[data-choice]');
                        if (item instanceof HTMLElement) {
                            var hasShiftKey = event.shiftKey;
                            var activeItems = this._store.activeItems;
                            var dataset = item.dataset;
                            if ('button' in dataset) this._handleButtonAction(activeItems, item);
                            else if ('item' in dataset) this._handleItemAction(activeItems, item, hasShiftKey);
                            else if ('choice' in dataset) this._handleChoiceAction(activeItems, item);
                        }
                        event.preventDefault();
                    };
                    /**
   * Handles mouseover event over this.dropdown
   * @param {MouseEvent} event
   */ Choices.prototype._onMouseOver = function(_a) {
                        var target = _a.target;
                        if (target instanceof HTMLElement && 'choice' in target.dataset) this._highlightChoice(target);
                    };
                    Choices.prototype._onClick = function(_a) {
                        var target = _a.target;
                        var clickWasWithinContainer = this.containerOuter.element.contains(target);
                        if (clickWasWithinContainer) {
                            if (!this.dropdown.isActive && !this.containerOuter.isDisabled) {
                                if (this._isTextElement) {
                                    if (document.activeElement !== this.input.element) this.input.focus();
                                } else {
                                    this.showDropdown();
                                    this.containerOuter.focus();
                                }
                            } else if (this._isSelectOneElement && target !== this.input.element && !this.dropdown.element.contains(target)) this.hideDropdown();
                        } else {
                            var hasHighlightedItems = this._store.highlightedActiveItems.length > 0;
                            if (hasHighlightedItems) this.unhighlightAll();
                            this.containerOuter.removeFocusState();
                            this.hideDropdown(true);
                        }
                    };
                    Choices.prototype._onFocus = function(_a) {
                        var _b;
                        var _this = this;
                        var target = _a.target;
                        var focusWasWithinContainer = target && this.containerOuter.element.contains(target);
                        if (!focusWasWithinContainer) return;
                        var focusActions = (_b = {}, _b[constants_1.TEXT_TYPE] = function() {
                            if (target === _this.input.element) _this.containerOuter.addFocusState();
                        }, _b[constants_1.SELECT_ONE_TYPE] = function() {
                            _this.containerOuter.addFocusState();
                            if (target === _this.input.element) _this.showDropdown(true);
                        }, _b[constants_1.SELECT_MULTIPLE_TYPE] = function() {
                            if (target === _this.input.element) {
                                _this.showDropdown(true);
                                // If element is a select box, the focused element is the container and the dropdown
                                // isn't already open, focus and show dropdown
                                _this.containerOuter.addFocusState();
                            }
                        }, _b);
                        focusActions[this.passedElement.element.type]();
                    };
                    Choices.prototype._onBlur = function(_a) {
                        var _b;
                        var _this = this;
                        var target = _a.target;
                        var blurWasWithinContainer = target && this.containerOuter.element.contains(target);
                        if (blurWasWithinContainer && !this._isScrollingOnIe) {
                            var activeItems = this._store.activeItems;
                            var hasHighlightedItems_1 = activeItems.some(function(item) {
                                return item.highlighted;
                            });
                            var blurActions = (_b = {}, _b[constants_1.TEXT_TYPE] = function() {
                                if (target === _this.input.element) {
                                    _this.containerOuter.removeFocusState();
                                    if (hasHighlightedItems_1) _this.unhighlightAll();
                                    _this.hideDropdown(true);
                                }
                            }, _b[constants_1.SELECT_ONE_TYPE] = function() {
                                _this.containerOuter.removeFocusState();
                                if (target === _this.input.element || target === _this.containerOuter.element && !_this._canSearch) _this.hideDropdown(true);
                            }, _b[constants_1.SELECT_MULTIPLE_TYPE] = function() {
                                if (target === _this.input.element) {
                                    _this.containerOuter.removeFocusState();
                                    _this.hideDropdown(true);
                                    if (hasHighlightedItems_1) _this.unhighlightAll();
                                }
                            }, _b);
                            blurActions[this.passedElement.element.type]();
                        } else {
                            // On IE11, clicking the scollbar blurs our input and thus
                            // closes the dropdown. To stop this, we refocus our input
                            // if we know we are on IE *and* are scrolling.
                            this._isScrollingOnIe = false;
                            this.input.element.focus();
                        }
                    };
                    Choices.prototype._onFormReset = function() {
                        this._store.dispatch((0, misc_1.resetTo)(this._initialState));
                    };
                    Choices.prototype._highlightChoice = function(el) {
                        var _this = this;
                        if (el === void 0) el = null;
                        var choices = Array.from(this.dropdown.element.querySelectorAll('[data-choice-selectable]'));
                        if (!choices.length) return;
                        var passedEl = el;
                        var highlightedChoices = Array.from(this.dropdown.element.querySelectorAll(".".concat(this.config.classNames.highlightedState)));
                        // Remove any highlighted choices
                        highlightedChoices.forEach(function(choice) {
                            choice.classList.remove(_this.config.classNames.highlightedState);
                            choice.setAttribute('aria-selected', 'false');
                        });
                        if (passedEl) this._highlightPosition = choices.indexOf(passedEl);
                        else {
                            // Highlight choice based on last known highlight location
                            if (choices.length > this._highlightPosition) // If we have an option to highlight
                            passedEl = choices[this._highlightPosition];
                            else // Otherwise highlight the option before
                            passedEl = choices[choices.length - 1];
                            if (!passedEl) passedEl = choices[0];
                        }
                        passedEl.classList.add(this.config.classNames.highlightedState);
                        passedEl.setAttribute('aria-selected', 'true');
                        this.passedElement.triggerEvent(constants_1.EVENTS.highlightChoice, {
                            el: passedEl
                        });
                        if (this.dropdown.isActive) {
                            // IE11 ignores aria-label and blocks virtual keyboard
                            // if aria-activedescendant is set without a dropdown
                            this.input.setActiveDescendant(passedEl.id);
                            this.containerOuter.setActiveDescendant(passedEl.id);
                        }
                    };
                    Choices.prototype._addItem = function(_a) {
                        var value = _a.value, _b = _a.label, label = _b === void 0 ? null : _b, _c = _a.choiceId, choiceId = _c === void 0 ? -1 : _c, _d = _a.groupId, groupId = _d === void 0 ? -1 : _d, _e = _a.customProperties, customProperties = _e === void 0 ? {} : _e, _f = _a.placeholder, placeholder = _f === void 0 ? false : _f, _g = _a.keyCode, keyCode = _g === void 0 ? -1 : _g;
                        var passedValue = typeof value === 'string' ? value.trim() : value;
                        var items = this._store.items;
                        var passedLabel = label || passedValue;
                        var passedOptionId = choiceId || -1;
                        var group = groupId >= 0 ? this._store.getGroupById(groupId) : null;
                        var id = items ? items.length + 1 : 1;
                        // If a prepended value has been passed, prepend it
                        if (this.config.prependValue) passedValue = this.config.prependValue + passedValue.toString();
                        // If an appended value has been passed, append it
                        if (this.config.appendValue) passedValue += this.config.appendValue.toString();
                        this._store.dispatch((0, items_1.addItem)({
                            value: passedValue,
                            label: passedLabel,
                            id: id,
                            choiceId: passedOptionId,
                            groupId: groupId,
                            customProperties: customProperties,
                            placeholder: placeholder,
                            keyCode: keyCode
                        }));
                        if (this._isSelectOneElement) this.removeActiveItems(id);
                        // Trigger change event
                        this.passedElement.triggerEvent(constants_1.EVENTS.addItem, {
                            id: id,
                            value: passedValue,
                            label: passedLabel,
                            customProperties: customProperties,
                            groupValue: group && group.value ? group.value : null,
                            keyCode: keyCode
                        });
                    };
                    Choices.prototype._removeItem = function(item) {
                        var id = item.id, value = item.value, label = item.label, customProperties = item.customProperties, choiceId = item.choiceId, groupId = item.groupId;
                        var group = groupId && groupId >= 0 ? this._store.getGroupById(groupId) : null;
                        if (!id || !choiceId) return;
                        this._store.dispatch((0, items_1.removeItem)(id, choiceId));
                        this.passedElement.triggerEvent(constants_1.EVENTS.removeItem, {
                            id: id,
                            value: value,
                            label: label,
                            customProperties: customProperties,
                            groupValue: group && group.value ? group.value : null
                        });
                    };
                    Choices.prototype._addChoice = function(_a) {
                        var value = _a.value, _b = _a.label, label = _b === void 0 ? null : _b, _c = _a.isSelected, isSelected = _c === void 0 ? false : _c, _d = _a.isDisabled, isDisabled = _d === void 0 ? false : _d, _e = _a.groupId, groupId = _e === void 0 ? -1 : _e, _f = _a.customProperties, customProperties = _f === void 0 ? {} : _f, _g = _a.placeholder, placeholder = _g === void 0 ? false : _g, _h = _a.keyCode, keyCode = _h === void 0 ? -1 : _h;
                        if (typeof value === 'undefined' || value === null) return;
                        // Generate unique id
                        var choices = this._store.choices;
                        var choiceLabel = label || value;
                        var choiceId = choices ? choices.length + 1 : 1;
                        var choiceElementId = "".concat(this._baseId, "-").concat(this._idNames.itemChoice, "-").concat(choiceId);
                        this._store.dispatch((0, choices_1.addChoice)({
                            id: choiceId,
                            groupId: groupId,
                            elementId: choiceElementId,
                            value: value,
                            label: choiceLabel,
                            disabled: isDisabled,
                            customProperties: customProperties,
                            placeholder: placeholder,
                            keyCode: keyCode
                        }));
                        if (isSelected) this._addItem({
                            value: value,
                            label: choiceLabel,
                            choiceId: choiceId,
                            customProperties: customProperties,
                            placeholder: placeholder,
                            keyCode: keyCode
                        });
                    };
                    Choices.prototype._addGroup = function(_a) {
                        var _this = this;
                        var group = _a.group, id = _a.id, _b = _a.valueKey, valueKey = _b === void 0 ? 'value' : _b, _c = _a.labelKey, labelKey = _c === void 0 ? 'label' : _c;
                        var groupChoices = (0, utils_1.isType)('Object', group) ? group.choices : Array.from(group.getElementsByTagName('OPTION'));
                        var groupId = id || Math.floor(new Date().valueOf() * Math.random());
                        var isDisabled = group.disabled ? group.disabled : false;
                        if (groupChoices) {
                            this._store.dispatch((0, groups_1.addGroup)({
                                value: group.label,
                                id: groupId,
                                active: true,
                                disabled: isDisabled
                            }));
                            var addGroupChoices = function(choice) {
                                var isOptDisabled = choice.disabled || choice.parentNode && choice.parentNode.disabled;
                                _this._addChoice({
                                    value: choice[valueKey],
                                    label: (0, utils_1.isType)('Object', choice) ? choice[labelKey] : choice.innerHTML,
                                    isSelected: choice.selected,
                                    isDisabled: isOptDisabled,
                                    groupId: groupId,
                                    customProperties: choice.customProperties,
                                    placeholder: choice.placeholder
                                });
                            };
                            groupChoices.forEach(addGroupChoices);
                        } else this._store.dispatch((0, groups_1.addGroup)({
                            value: group.label,
                            id: group.id,
                            active: false,
                            disabled: group.disabled
                        }));
                    };
                    Choices.prototype._getTemplate = function(template) {
                        var _a;
                        var args = [];
                        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
                        return (_a = this._templates[template]).call.apply(_a, __spreadArray([
                            this,
                            this.config
                        ], args, false));
                    };
                    Choices.prototype._createTemplates = function() {
                        var callbackOnCreateTemplates = this.config.callbackOnCreateTemplates;
                        var userTemplates = {};
                        if (callbackOnCreateTemplates && typeof callbackOnCreateTemplates === 'function') userTemplates = callbackOnCreateTemplates.call(this, utils_1.strToEl);
                        this._templates = (0, deepmerge_1.default)(templates_1.default, userTemplates);
                    };
                    Choices.prototype._createElements = function() {
                        this.containerOuter = new components_1.Container({
                            element: this._getTemplate('containerOuter', this._direction, this._isSelectElement, this._isSelectOneElement, this.config.searchEnabled, this.passedElement.element.type, this.config.labelId),
                            classNames: this.config.classNames,
                            type: this.passedElement.element.type,
                            position: this.config.position
                        });
                        this.containerInner = new components_1.Container({
                            element: this._getTemplate('containerInner'),
                            classNames: this.config.classNames,
                            type: this.passedElement.element.type,
                            position: this.config.position
                        });
                        this.input = new components_1.Input({
                            element: this._getTemplate('input', this._placeholderValue),
                            classNames: this.config.classNames,
                            type: this.passedElement.element.type,
                            preventPaste: !this.config.paste
                        });
                        this.choiceList = new components_1.List({
                            element: this._getTemplate('choiceList', this._isSelectOneElement)
                        });
                        this.itemList = new components_1.List({
                            element: this._getTemplate('itemList', this._isSelectOneElement)
                        });
                        this.dropdown = new components_1.Dropdown({
                            element: this._getTemplate('dropdown'),
                            classNames: this.config.classNames,
                            type: this.passedElement.element.type
                        });
                    };
                    Choices.prototype._createStructure = function() {
                        // Hide original element
                        this.passedElement.conceal();
                        // Wrap input in container preserving DOM ordering
                        this.containerInner.wrap(this.passedElement.element);
                        // Wrapper inner container with outer container
                        this.containerOuter.wrap(this.containerInner.element);
                        if (this._isSelectOneElement) this.input.placeholder = this.config.searchPlaceholderValue || '';
                        else if (this._placeholderValue) {
                            this.input.placeholder = this._placeholderValue;
                            this.input.setWidth();
                        }
                        this.containerOuter.element.appendChild(this.containerInner.element);
                        this.containerOuter.element.appendChild(this.dropdown.element);
                        this.containerInner.element.appendChild(this.itemList.element);
                        if (!this._isTextElement) this.dropdown.element.appendChild(this.choiceList.element);
                        if (!this._isSelectOneElement) this.containerInner.element.appendChild(this.input.element);
                        else if (this.config.searchEnabled) this.dropdown.element.insertBefore(this.input.element, this.dropdown.element.firstChild);
                        if (this._isSelectElement) {
                            this._highlightPosition = 0;
                            this._isSearching = false;
                            this._startLoading();
                            if (this._presetGroups.length) this._addPredefinedGroups(this._presetGroups);
                            else this._addPredefinedChoices(this._presetChoices);
                            this._stopLoading();
                        }
                        if (this._isTextElement) this._addPredefinedItems(this._presetItems);
                    };
                    Choices.prototype._addPredefinedGroups = function(groups) {
                        var _this = this;
                        // If we have a placeholder option
                        var placeholderChoice = this.passedElement.placeholderOption;
                        if (placeholderChoice && placeholderChoice.parentNode && placeholderChoice.parentNode.tagName === 'SELECT') this._addChoice({
                            value: placeholderChoice.value,
                            label: placeholderChoice.innerHTML,
                            isSelected: placeholderChoice.selected,
                            isDisabled: placeholderChoice.disabled,
                            placeholder: true
                        });
                        groups.forEach(function(group) {
                            return _this._addGroup({
                                group: group,
                                id: group.id || null
                            });
                        });
                    };
                    Choices.prototype._addPredefinedChoices = function(choices) {
                        var _this = this;
                        // If sorting is enabled or the user is searching, filter choices
                        if (this.config.shouldSort) choices.sort(this.config.sorter);
                        var hasSelectedChoice = choices.some(function(choice) {
                            return choice.selected;
                        });
                        var firstEnabledChoiceIndex = choices.findIndex(function(choice) {
                            return choice.disabled === undefined || !choice.disabled;
                        });
                        choices.forEach(function(choice, index) {
                            var _a = choice.value, value = _a === void 0 ? '' : _a, label = choice.label, customProperties = choice.customProperties, placeholder = choice.placeholder;
                            if (_this._isSelectElement) {
                                // If the choice is actually a group
                                if (choice.choices) _this._addGroup({
                                    group: choice,
                                    id: choice.id || null
                                });
                                else {
                                    /**
           * If there is a selected choice already or the choice is not the first in
           * the array, add each choice normally.
           *
           * Otherwise we pre-select the first enabled choice in the array ("select-one" only)
           */ var shouldPreselect = _this._isSelectOneElement && !hasSelectedChoice && index === firstEnabledChoiceIndex;
                                    var isSelected = shouldPreselect ? true : choice.selected;
                                    var isDisabled = choice.disabled;
                                    _this._addChoice({
                                        value: value,
                                        label: label,
                                        isSelected: !!isSelected,
                                        isDisabled: !!isDisabled,
                                        placeholder: !!placeholder,
                                        customProperties: customProperties
                                    });
                                }
                            } else _this._addChoice({
                                value: value,
                                label: label,
                                isSelected: !!choice.selected,
                                isDisabled: !!choice.disabled,
                                placeholder: !!choice.placeholder,
                                customProperties: customProperties
                            });
                        });
                    };
                    Choices.prototype._addPredefinedItems = function(items) {
                        var _this = this;
                        items.forEach(function(item) {
                            if (typeof item === 'object' && item.value) _this._addItem({
                                value: item.value,
                                label: item.label,
                                choiceId: item.id,
                                customProperties: item.customProperties,
                                placeholder: item.placeholder
                            });
                            if (typeof item === 'string') _this._addItem({
                                value: item
                            });
                        });
                    };
                    Choices.prototype._setChoiceOrItem = function(item) {
                        var _this = this;
                        var itemType = (0, utils_1.getType)(item).toLowerCase();
                        var handleType = {
                            object: function() {
                                if (!item.value) return;
                                // If we are dealing with a select input, we need to create an option first
                                // that is then selected. For text inputs we can just add items normally.
                                if (!_this._isTextElement) _this._addChoice({
                                    value: item.value,
                                    label: item.label,
                                    isSelected: true,
                                    isDisabled: false,
                                    customProperties: item.customProperties,
                                    placeholder: item.placeholder
                                });
                                else _this._addItem({
                                    value: item.value,
                                    label: item.label,
                                    choiceId: item.id,
                                    customProperties: item.customProperties,
                                    placeholder: item.placeholder
                                });
                            },
                            string: function() {
                                if (!_this._isTextElement) _this._addChoice({
                                    value: item,
                                    label: item,
                                    isSelected: true,
                                    isDisabled: false
                                });
                                else _this._addItem({
                                    value: item
                                });
                            }
                        };
                        handleType[itemType]();
                    };
                    Choices.prototype._findAndSelectChoiceByValue = function(value) {
                        var _this = this;
                        var choices = this._store.choices;
                        // Check 'value' property exists and the choice isn't already selected
                        var foundChoice = choices.find(function(choice) {
                            return _this.config.valueComparer(choice.value, value);
                        });
                        if (foundChoice && !foundChoice.selected) this._addItem({
                            value: foundChoice.value,
                            label: foundChoice.label,
                            choiceId: foundChoice.id,
                            groupId: foundChoice.groupId,
                            customProperties: foundChoice.customProperties,
                            placeholder: foundChoice.placeholder,
                            keyCode: foundChoice.keyCode
                        });
                    };
                    Choices.prototype._generatePlaceholderValue = function() {
                        if (this._isSelectElement && this.passedElement.placeholderOption) {
                            var placeholderOption = this.passedElement.placeholderOption;
                            return placeholderOption ? placeholderOption.text : null;
                        }
                        var _a = this.config, placeholder = _a.placeholder, placeholderValue = _a.placeholderValue;
                        var dataset = this.passedElement.element.dataset;
                        if (placeholder) {
                            if (placeholderValue) return placeholderValue;
                            if (dataset.placeholder) return dataset.placeholder;
                        }
                        return null;
                    };
                    return Choices;
                }();
                exports["default"] = Choices;
            /***/ },
            /***/ 613: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var utils_1 = __webpack_require__(799);
                var constants_1 = __webpack_require__(883);
                var Container = /** @class */ function() {
                    function Container(_a) {
                        var element = _a.element, type = _a.type, classNames = _a.classNames, position = _a.position;
                        this.element = element;
                        this.classNames = classNames;
                        this.type = type;
                        this.position = position;
                        this.isOpen = false;
                        this.isFlipped = false;
                        this.isFocussed = false;
                        this.isDisabled = false;
                        this.isLoading = false;
                        this._onFocus = this._onFocus.bind(this);
                        this._onBlur = this._onBlur.bind(this);
                    }
                    Container.prototype.addEventListeners = function() {
                        this.element.addEventListener('focus', this._onFocus);
                        this.element.addEventListener('blur', this._onBlur);
                    };
                    Container.prototype.removeEventListeners = function() {
                        this.element.removeEventListener('focus', this._onFocus);
                        this.element.removeEventListener('blur', this._onBlur);
                    };
                    /**
   * Determine whether container should be flipped based on passed
   * dropdown position
   */ Container.prototype.shouldFlip = function(dropdownPos) {
                        if (typeof dropdownPos !== 'number') return false;
                        // If flip is enabled and the dropdown bottom position is
                        // greater than the window height flip the dropdown.
                        var shouldFlip = false;
                        if (this.position === 'auto') shouldFlip = !window.matchMedia("(min-height: ".concat(dropdownPos + 1, "px)")).matches;
                        else if (this.position === 'top') shouldFlip = true;
                        return shouldFlip;
                    };
                    Container.prototype.setActiveDescendant = function(activeDescendantID) {
                        this.element.setAttribute('aria-activedescendant', activeDescendantID);
                    };
                    Container.prototype.removeActiveDescendant = function() {
                        this.element.removeAttribute('aria-activedescendant');
                    };
                    Container.prototype.open = function(dropdownPos) {
                        this.element.classList.add(this.classNames.openState);
                        this.element.setAttribute('aria-expanded', 'true');
                        this.isOpen = true;
                        if (this.shouldFlip(dropdownPos)) {
                            this.element.classList.add(this.classNames.flippedState);
                            this.isFlipped = true;
                        }
                    };
                    Container.prototype.close = function() {
                        this.element.classList.remove(this.classNames.openState);
                        this.element.setAttribute('aria-expanded', 'false');
                        this.removeActiveDescendant();
                        this.isOpen = false;
                        // A dropdown flips if it does not have space within the page
                        if (this.isFlipped) {
                            this.element.classList.remove(this.classNames.flippedState);
                            this.isFlipped = false;
                        }
                    };
                    Container.prototype.focus = function() {
                        if (!this.isFocussed) this.element.focus();
                    };
                    Container.prototype.addFocusState = function() {
                        this.element.classList.add(this.classNames.focusState);
                    };
                    Container.prototype.removeFocusState = function() {
                        this.element.classList.remove(this.classNames.focusState);
                    };
                    Container.prototype.enable = function() {
                        this.element.classList.remove(this.classNames.disabledState);
                        this.element.removeAttribute('aria-disabled');
                        if (this.type === constants_1.SELECT_ONE_TYPE) this.element.setAttribute('tabindex', '0');
                        this.isDisabled = false;
                    };
                    Container.prototype.disable = function() {
                        this.element.classList.add(this.classNames.disabledState);
                        this.element.setAttribute('aria-disabled', 'true');
                        if (this.type === constants_1.SELECT_ONE_TYPE) this.element.setAttribute('tabindex', '-1');
                        this.isDisabled = true;
                    };
                    Container.prototype.wrap = function(element) {
                        (0, utils_1.wrap)(element, this.element);
                    };
                    Container.prototype.unwrap = function(element) {
                        if (this.element.parentNode) {
                            // Move passed element outside this element
                            this.element.parentNode.insertBefore(element, this.element);
                            // Remove this element
                            this.element.parentNode.removeChild(this.element);
                        }
                    };
                    Container.prototype.addLoadingState = function() {
                        this.element.classList.add(this.classNames.loadingState);
                        this.element.setAttribute('aria-busy', 'true');
                        this.isLoading = true;
                    };
                    Container.prototype.removeLoadingState = function() {
                        this.element.classList.remove(this.classNames.loadingState);
                        this.element.removeAttribute('aria-busy');
                        this.isLoading = false;
                    };
                    Container.prototype._onFocus = function() {
                        this.isFocussed = true;
                    };
                    Container.prototype._onBlur = function() {
                        this.isFocussed = false;
                    };
                    return Container;
                }();
                exports["default"] = Container;
            /***/ },
            /***/ 217: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var Dropdown = /** @class */ function() {
                    function Dropdown(_a) {
                        var element = _a.element, type = _a.type, classNames = _a.classNames;
                        this.element = element;
                        this.classNames = classNames;
                        this.type = type;
                        this.isActive = false;
                    }
                    Object.defineProperty(Dropdown.prototype, "distanceFromTopWindow", {
                        /**
     * Bottom position of dropdown in viewport coordinates
     */ get: function() {
                            return this.element.getBoundingClientRect().bottom;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Dropdown.prototype.getChild = function(selector) {
                        return this.element.querySelector(selector);
                    };
                    /**
   * Show dropdown to user by adding active state class
   */ Dropdown.prototype.show = function() {
                        this.element.classList.add(this.classNames.activeState);
                        this.element.setAttribute('aria-expanded', 'true');
                        this.isActive = true;
                        return this;
                    };
                    /**
   * Hide dropdown from user
   */ Dropdown.prototype.hide = function() {
                        this.element.classList.remove(this.classNames.activeState);
                        this.element.setAttribute('aria-expanded', 'false');
                        this.isActive = false;
                        return this;
                    };
                    return Dropdown;
                }();
                exports["default"] = Dropdown;
            /***/ },
            /***/ 520: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.WrappedSelect = exports.WrappedInput = exports.List = exports.Input = exports.Container = exports.Dropdown = void 0;
                var dropdown_1 = __importDefault(__webpack_require__(217));
                exports.Dropdown = dropdown_1.default;
                var container_1 = __importDefault(__webpack_require__(613));
                exports.Container = container_1.default;
                var input_1 = __importDefault(__webpack_require__(11));
                exports.Input = input_1.default;
                var list_1 = __importDefault(__webpack_require__(624));
                exports.List = list_1.default;
                var wrapped_input_1 = __importDefault(__webpack_require__(541));
                exports.WrappedInput = wrapped_input_1.default;
                var wrapped_select_1 = __importDefault(__webpack_require__(982));
                exports.WrappedSelect = wrapped_select_1.default;
            /***/ },
            /***/ 11: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var utils_1 = __webpack_require__(799);
                var constants_1 = __webpack_require__(883);
                var Input = /** @class */ function() {
                    function Input(_a) {
                        var element = _a.element, type = _a.type, classNames = _a.classNames, preventPaste = _a.preventPaste;
                        this.element = element;
                        this.type = type;
                        this.classNames = classNames;
                        this.preventPaste = preventPaste;
                        this.isFocussed = this.element.isEqualNode(document.activeElement);
                        this.isDisabled = element.disabled;
                        this._onPaste = this._onPaste.bind(this);
                        this._onInput = this._onInput.bind(this);
                        this._onFocus = this._onFocus.bind(this);
                        this._onBlur = this._onBlur.bind(this);
                    }
                    Object.defineProperty(Input.prototype, "placeholder", {
                        set: function(placeholder) {
                            this.element.placeholder = placeholder;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Input.prototype, "value", {
                        get: function() {
                            return (0, utils_1.sanitise)(this.element.value);
                        },
                        set: function(value) {
                            this.element.value = value;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Input.prototype, "rawValue", {
                        get: function() {
                            return this.element.value;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Input.prototype.addEventListeners = function() {
                        this.element.addEventListener('paste', this._onPaste);
                        this.element.addEventListener('input', this._onInput, {
                            passive: true
                        });
                        this.element.addEventListener('focus', this._onFocus, {
                            passive: true
                        });
                        this.element.addEventListener('blur', this._onBlur, {
                            passive: true
                        });
                    };
                    Input.prototype.removeEventListeners = function() {
                        this.element.removeEventListener('input', this._onInput);
                        this.element.removeEventListener('paste', this._onPaste);
                        this.element.removeEventListener('focus', this._onFocus);
                        this.element.removeEventListener('blur', this._onBlur);
                    };
                    Input.prototype.enable = function() {
                        this.element.removeAttribute('disabled');
                        this.isDisabled = false;
                    };
                    Input.prototype.disable = function() {
                        this.element.setAttribute('disabled', '');
                        this.isDisabled = true;
                    };
                    Input.prototype.focus = function() {
                        if (!this.isFocussed) this.element.focus();
                    };
                    Input.prototype.blur = function() {
                        if (this.isFocussed) this.element.blur();
                    };
                    Input.prototype.clear = function(setWidth) {
                        if (setWidth === void 0) setWidth = true;
                        if (this.element.value) this.element.value = '';
                        if (setWidth) this.setWidth();
                        return this;
                    };
                    /**
   * Set the correct input width based on placeholder
   * value or input value
   */ Input.prototype.setWidth = function() {
                        // Resize input to contents or placeholder
                        var _a = this.element, style = _a.style, value = _a.value, placeholder = _a.placeholder;
                        style.minWidth = "".concat(placeholder.length + 1, "ch");
                        style.width = "".concat(value.length + 1, "ch");
                    };
                    Input.prototype.setActiveDescendant = function(activeDescendantID) {
                        this.element.setAttribute('aria-activedescendant', activeDescendantID);
                    };
                    Input.prototype.removeActiveDescendant = function() {
                        this.element.removeAttribute('aria-activedescendant');
                    };
                    Input.prototype._onInput = function() {
                        if (this.type !== constants_1.SELECT_ONE_TYPE) this.setWidth();
                    };
                    Input.prototype._onPaste = function(event) {
                        if (this.preventPaste) event.preventDefault();
                    };
                    Input.prototype._onFocus = function() {
                        this.isFocussed = true;
                    };
                    Input.prototype._onBlur = function() {
                        this.isFocussed = false;
                    };
                    return Input;
                }();
                exports["default"] = Input;
            /***/ },
            /***/ 624: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var constants_1 = __webpack_require__(883);
                var List = /** @class */ function() {
                    function List(_a) {
                        var element = _a.element;
                        this.element = element;
                        this.scrollPos = this.element.scrollTop;
                        this.height = this.element.offsetHeight;
                    }
                    List.prototype.clear = function() {
                        this.element.innerHTML = '';
                    };
                    List.prototype.append = function(node) {
                        this.element.appendChild(node);
                    };
                    List.prototype.getChild = function(selector) {
                        return this.element.querySelector(selector);
                    };
                    List.prototype.hasChildren = function() {
                        return this.element.hasChildNodes();
                    };
                    List.prototype.scrollToTop = function() {
                        this.element.scrollTop = 0;
                    };
                    List.prototype.scrollToChildElement = function(element, direction) {
                        var _this = this;
                        if (!element) return;
                        var listHeight = this.element.offsetHeight;
                        // Scroll position of dropdown
                        var listScrollPosition = this.element.scrollTop + listHeight;
                        var elementHeight = element.offsetHeight;
                        // Distance from bottom of element to top of parent
                        var elementPos = element.offsetTop + elementHeight;
                        // Difference between the element and scroll position
                        var destination = direction > 0 ? this.element.scrollTop + elementPos - listScrollPosition : element.offsetTop;
                        requestAnimationFrame(function() {
                            _this._animateScroll(destination, direction);
                        });
                    };
                    List.prototype._scrollDown = function(scrollPos, strength, destination) {
                        var easing = (destination - scrollPos) / strength;
                        var distance = easing > 1 ? easing : 1;
                        this.element.scrollTop = scrollPos + distance;
                    };
                    List.prototype._scrollUp = function(scrollPos, strength, destination) {
                        var easing = (scrollPos - destination) / strength;
                        var distance = easing > 1 ? easing : 1;
                        this.element.scrollTop = scrollPos - distance;
                    };
                    List.prototype._animateScroll = function(destination, direction) {
                        var _this = this;
                        var strength = constants_1.SCROLLING_SPEED;
                        var choiceListScrollTop = this.element.scrollTop;
                        var continueAnimation = false;
                        if (direction > 0) {
                            this._scrollDown(choiceListScrollTop, strength, destination);
                            if (choiceListScrollTop < destination) continueAnimation = true;
                        } else {
                            this._scrollUp(choiceListScrollTop, strength, destination);
                            if (choiceListScrollTop > destination) continueAnimation = true;
                        }
                        if (continueAnimation) requestAnimationFrame(function() {
                            _this._animateScroll(destination, direction);
                        });
                    };
                    return List;
                }();
                exports["default"] = List;
            /***/ },
            /***/ 730: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var utils_1 = __webpack_require__(799);
                var WrappedElement = /** @class */ function() {
                    function WrappedElement(_a) {
                        var element = _a.element, classNames = _a.classNames;
                        this.element = element;
                        this.classNames = classNames;
                        if (!(element instanceof HTMLInputElement) && !(element instanceof HTMLSelectElement)) throw new TypeError('Invalid element passed');
                        this.isDisabled = false;
                    }
                    Object.defineProperty(WrappedElement.prototype, "isActive", {
                        get: function() {
                            return this.element.dataset.choice === 'active';
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(WrappedElement.prototype, "dir", {
                        get: function() {
                            return this.element.dir;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(WrappedElement.prototype, "value", {
                        get: function() {
                            return this.element.value;
                        },
                        set: function(value) {
                            // you must define setter here otherwise it will be readonly property
                            this.element.value = value;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    WrappedElement.prototype.conceal = function() {
                        // Hide passed input
                        this.element.classList.add(this.classNames.input);
                        this.element.hidden = true;
                        // Remove element from tab index
                        this.element.tabIndex = -1;
                        // Backup original styles if any
                        var origStyle = this.element.getAttribute('style');
                        if (origStyle) this.element.setAttribute('data-choice-orig-style', origStyle);
                        this.element.setAttribute('data-choice', 'active');
                    };
                    WrappedElement.prototype.reveal = function() {
                        // Reinstate passed element
                        this.element.classList.remove(this.classNames.input);
                        this.element.hidden = false;
                        this.element.removeAttribute('tabindex');
                        // Recover original styles if any
                        var origStyle = this.element.getAttribute('data-choice-orig-style');
                        if (origStyle) {
                            this.element.removeAttribute('data-choice-orig-style');
                            this.element.setAttribute('style', origStyle);
                        } else this.element.removeAttribute('style');
                        this.element.removeAttribute('data-choice');
                        // Re-assign values - this is weird, I know
                        // @todo Figure out why we need to do this
                        this.element.value = this.element.value; // eslint-disable-line no-self-assign
                    };
                    WrappedElement.prototype.enable = function() {
                        this.element.removeAttribute('disabled');
                        this.element.disabled = false;
                        this.isDisabled = false;
                    };
                    WrappedElement.prototype.disable = function() {
                        this.element.setAttribute('disabled', '');
                        this.element.disabled = true;
                        this.isDisabled = true;
                    };
                    WrappedElement.prototype.triggerEvent = function(eventType, data) {
                        (0, utils_1.dispatchEvent)(this.element, eventType, data);
                    };
                    return WrappedElement;
                }();
                exports["default"] = WrappedElement;
            /***/ },
            /***/ 541: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var wrapped_element_1 = __importDefault(__webpack_require__(730));
                var WrappedInput = /** @class */ function(_super) {
                    __extends(WrappedInput, _super);
                    function WrappedInput(_a) {
                        var element = _a.element, classNames = _a.classNames, delimiter = _a.delimiter;
                        var _this = _super.call(this, {
                            element: element,
                            classNames: classNames
                        }) || this;
                        _this.delimiter = delimiter;
                        return _this;
                    }
                    Object.defineProperty(WrappedInput.prototype, "value", {
                        get: function() {
                            return this.element.value;
                        },
                        set: function(value) {
                            this.element.setAttribute('value', value);
                            this.element.value = value;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    return WrappedInput;
                }(wrapped_element_1.default);
                exports["default"] = WrappedInput;
            /***/ },
            /***/ 982: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var wrapped_element_1 = __importDefault(__webpack_require__(730));
                var WrappedSelect = /** @class */ function(_super) {
                    __extends(WrappedSelect, _super);
                    function WrappedSelect(_a) {
                        var element = _a.element, classNames = _a.classNames, template = _a.template;
                        var _this = _super.call(this, {
                            element: element,
                            classNames: classNames
                        }) || this;
                        _this.template = template;
                        return _this;
                    }
                    Object.defineProperty(WrappedSelect.prototype, "placeholderOption", {
                        get: function() {
                            return this.element.querySelector('option[value=""]') || // Backward compatibility layer for the non-standard placeholder attribute supported in older versions.
                            this.element.querySelector('option[placeholder]');
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(WrappedSelect.prototype, "optionGroups", {
                        get: function() {
                            return Array.from(this.element.getElementsByTagName('OPTGROUP'));
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(WrappedSelect.prototype, "options", {
                        get: function() {
                            return Array.from(this.element.options);
                        },
                        set: function(options) {
                            var _this = this;
                            var fragment = document.createDocumentFragment();
                            var addOptionToFragment = function(data) {
                                // Create a standard select option
                                var option = _this.template(data);
                                // Append it to fragment
                                fragment.appendChild(option);
                            };
                            // Add each list item to list
                            options.forEach(function(optionData) {
                                return addOptionToFragment(optionData);
                            });
                            this.appendDocFragment(fragment);
                        },
                        enumerable: false,
                        configurable: true
                    });
                    WrappedSelect.prototype.appendDocFragment = function(fragment) {
                        this.element.innerHTML = '';
                        this.element.appendChild(fragment);
                    };
                    return WrappedSelect;
                }(wrapped_element_1.default);
                exports["default"] = WrappedSelect;
            /***/ },
            /***/ 883: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.SCROLLING_SPEED = exports.SELECT_MULTIPLE_TYPE = exports.SELECT_ONE_TYPE = exports.TEXT_TYPE = exports.KEY_CODES = exports.ACTION_TYPES = exports.EVENTS = void 0;
                exports.EVENTS = {
                    showDropdown: 'showDropdown',
                    hideDropdown: 'hideDropdown',
                    change: 'change',
                    choice: 'choice',
                    search: 'search',
                    addItem: 'addItem',
                    removeItem: 'removeItem',
                    highlightItem: 'highlightItem',
                    highlightChoice: 'highlightChoice',
                    unhighlightItem: 'unhighlightItem'
                };
                exports.ACTION_TYPES = {
                    ADD_CHOICE: 'ADD_CHOICE',
                    FILTER_CHOICES: 'FILTER_CHOICES',
                    ACTIVATE_CHOICES: 'ACTIVATE_CHOICES',
                    CLEAR_CHOICES: 'CLEAR_CHOICES',
                    ADD_GROUP: 'ADD_GROUP',
                    ADD_ITEM: 'ADD_ITEM',
                    REMOVE_ITEM: 'REMOVE_ITEM',
                    HIGHLIGHT_ITEM: 'HIGHLIGHT_ITEM',
                    CLEAR_ALL: 'CLEAR_ALL',
                    RESET_TO: 'RESET_TO',
                    SET_IS_LOADING: 'SET_IS_LOADING'
                };
                exports.KEY_CODES = {
                    BACK_KEY: 46,
                    DELETE_KEY: 8,
                    ENTER_KEY: 13,
                    A_KEY: 65,
                    ESC_KEY: 27,
                    UP_KEY: 38,
                    DOWN_KEY: 40,
                    PAGE_UP_KEY: 33,
                    PAGE_DOWN_KEY: 34
                };
                exports.TEXT_TYPE = 'text';
                exports.SELECT_ONE_TYPE = 'select-one';
                exports.SELECT_MULTIPLE_TYPE = 'select-multiple';
                exports.SCROLLING_SPEED = 4;
            /***/ },
            /***/ 789: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.DEFAULT_CONFIG = exports.DEFAULT_CLASSNAMES = void 0;
                var utils_1 = __webpack_require__(799);
                exports.DEFAULT_CLASSNAMES = {
                    containerOuter: 'choices',
                    containerInner: 'choices__inner',
                    input: 'choices__input',
                    inputCloned: 'choices__input--cloned',
                    list: 'choices__list',
                    listItems: 'choices__list--multiple',
                    listSingle: 'choices__list--single',
                    listDropdown: 'choices__list--dropdown',
                    item: 'choices__item',
                    itemSelectable: 'choices__item--selectable',
                    itemDisabled: 'choices__item--disabled',
                    itemChoice: 'choices__item--choice',
                    placeholder: 'choices__placeholder',
                    group: 'choices__group',
                    groupHeading: 'choices__heading',
                    button: 'choices__button',
                    activeState: 'is-active',
                    focusState: 'is-focused',
                    openState: 'is-open',
                    disabledState: 'is-disabled',
                    highlightedState: 'is-highlighted',
                    selectedState: 'is-selected',
                    flippedState: 'is-flipped',
                    loadingState: 'is-loading',
                    noResults: 'has-no-results',
                    noChoices: 'has-no-choices'
                };
                exports.DEFAULT_CONFIG = {
                    items: [],
                    choices: [],
                    silent: false,
                    renderChoiceLimit: -1,
                    maxItemCount: -1,
                    addItems: true,
                    addItemFilter: null,
                    removeItems: true,
                    removeItemButton: false,
                    editItems: false,
                    allowHTML: true,
                    duplicateItemsAllowed: true,
                    delimiter: ',',
                    paste: true,
                    searchEnabled: true,
                    searchChoices: true,
                    searchFloor: 1,
                    searchResultLimit: 4,
                    searchFields: [
                        'label',
                        'value'
                    ],
                    position: 'auto',
                    resetScrollPosition: true,
                    shouldSort: true,
                    shouldSortItems: false,
                    sorter: utils_1.sortByAlpha,
                    placeholder: true,
                    placeholderValue: null,
                    searchPlaceholderValue: null,
                    prependValue: null,
                    appendValue: null,
                    renderSelectedChoices: 'auto',
                    loadingText: 'Loading...',
                    noResultsText: 'No results found',
                    noChoicesText: 'No choices to choose from',
                    itemSelectText: 'Press to select',
                    uniqueItemText: 'Only unique values can be added',
                    customAddItemText: 'Only values matching specific conditions can be added',
                    addItemText: function(value) {
                        return "Press Enter to add <b>\"".concat((0, utils_1.sanitise)(value), "\"</b>");
                    },
                    maxItemText: function(maxItemCount) {
                        return "Only ".concat(maxItemCount, " values can be added");
                    },
                    valueComparer: function(value1, value2) {
                        return value1 === value2;
                    },
                    fuseOptions: {
                        includeScore: true
                    },
                    labelId: '',
                    callbackOnInit: null,
                    callbackOnCreateTemplates: null,
                    classNames: exports.DEFAULT_CLASSNAMES
                };
            /***/ },
            /***/ 18: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 978: /***/ function(__unused_webpack_module, exports) {
                /* eslint-disable @typescript-eslint/no-explicit-any */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 948: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 359: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 285: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 533: /***/ function(__unused_webpack_module, exports) {
                /* eslint-disable @typescript-eslint/no-explicit-any */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 187: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
                    if (k2 === undefined) k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
                        enumerable: true,
                        get: function() {
                            return m[k];
                        }
                    };
                    Object.defineProperty(o, k2, desc);
                } : function(o, m, k, k2) {
                    if (k2 === undefined) k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function(m, exports) {
                    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                __exportStar(__webpack_require__(18), exports);
                __exportStar(__webpack_require__(978), exports);
                __exportStar(__webpack_require__(948), exports);
                __exportStar(__webpack_require__(359), exports);
                __exportStar(__webpack_require__(285), exports);
                __exportStar(__webpack_require__(533), exports);
                __exportStar(__webpack_require__(287), exports);
                __exportStar(__webpack_require__(132), exports);
                __exportStar(__webpack_require__(837), exports);
                __exportStar(__webpack_require__(598), exports);
                __exportStar(__webpack_require__(369), exports);
                __exportStar(__webpack_require__(37), exports);
                __exportStar(__webpack_require__(47), exports);
                __exportStar(__webpack_require__(923), exports);
                __exportStar(__webpack_require__(876), exports);
            /***/ },
            /***/ 287: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 132: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 837: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 598: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 37: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 369: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 47: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 923: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 876: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 799: /***/ function(__unused_webpack_module, exports) {
                /* eslint-disable @typescript-eslint/no-explicit-any */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.parseCustomProperties = exports.diff = exports.cloneObject = exports.existsInArray = exports.dispatchEvent = exports.sortByScore = exports.sortByAlpha = exports.strToEl = exports.sanitise = exports.isScrolledIntoView = exports.getAdjacentEl = exports.wrap = exports.isType = exports.getType = exports.generateId = exports.generateChars = exports.getRandomNumber = void 0;
                var getRandomNumber = function(min, max) {
                    return Math.floor(Math.random() * (max - min) + min);
                };
                exports.getRandomNumber = getRandomNumber;
                var generateChars = function(length) {
                    return Array.from({
                        length: length
                    }, function() {
                        return (0, exports.getRandomNumber)(0, 36).toString(36);
                    }).join('');
                };
                exports.generateChars = generateChars;
                var generateId = function(element, prefix) {
                    var id = element.id || element.name && "".concat(element.name, "-").concat((0, exports.generateChars)(2)) || (0, exports.generateChars)(4);
                    id = id.replace(/(:|\.|\[|\]|,)/g, '');
                    id = "".concat(prefix, "-").concat(id);
                    return id;
                };
                exports.generateId = generateId;
                var getType = function(obj) {
                    return Object.prototype.toString.call(obj).slice(8, -1);
                };
                exports.getType = getType;
                var isType = function(type, obj) {
                    return obj !== undefined && obj !== null && (0, exports.getType)(obj) === type;
                };
                exports.isType = isType;
                var wrap = function(element, wrapper) {
                    if (wrapper === void 0) wrapper = document.createElement('div');
                    if (element.parentNode) {
                        if (element.nextSibling) element.parentNode.insertBefore(wrapper, element.nextSibling);
                        else element.parentNode.appendChild(wrapper);
                    }
                    return wrapper.appendChild(element);
                };
                exports.wrap = wrap;
                var getAdjacentEl = function(startEl, selector, direction) {
                    if (direction === void 0) direction = 1;
                    var prop = "".concat(direction > 0 ? 'next' : 'previous', "ElementSibling");
                    var sibling = startEl[prop];
                    while(sibling){
                        if (sibling.matches(selector)) return sibling;
                        sibling = sibling[prop];
                    }
                    return sibling;
                };
                exports.getAdjacentEl = getAdjacentEl;
                var isScrolledIntoView = function(element, parent, direction) {
                    if (direction === void 0) direction = 1;
                    if (!element) return false;
                    var isVisible;
                    if (direction > 0) // In view from bottom
                    isVisible = parent.scrollTop + parent.offsetHeight >= element.offsetTop + element.offsetHeight;
                    else // In view from top
                    isVisible = element.offsetTop >= parent.scrollTop;
                    return isVisible;
                };
                exports.isScrolledIntoView = isScrolledIntoView;
                var sanitise = function(value) {
                    if (typeof value !== 'string') return value;
                    return value.replace(/&/g, '&amp;').replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
                };
                exports.sanitise = sanitise;
                exports.strToEl = function() {
                    var tmpEl = document.createElement('div');
                    return function(str) {
                        var cleanedInput = str.trim();
                        tmpEl.innerHTML = cleanedInput;
                        var firldChild = tmpEl.children[0];
                        while(tmpEl.firstChild)tmpEl.removeChild(tmpEl.firstChild);
                        return firldChild;
                    };
                }();
                var sortByAlpha = function(_a, _b) {
                    var value = _a.value, _c = _a.label, label = _c === void 0 ? value : _c;
                    var value2 = _b.value, _d = _b.label, label2 = _d === void 0 ? value2 : _d;
                    return label.localeCompare(label2, [], {
                        sensitivity: 'base',
                        ignorePunctuation: true,
                        numeric: true
                    });
                };
                exports.sortByAlpha = sortByAlpha;
                var sortByScore = function(a, b) {
                    var _a = a.score, scoreA = _a === void 0 ? 0 : _a;
                    var _b = b.score, scoreB = _b === void 0 ? 0 : _b;
                    return scoreA - scoreB;
                };
                exports.sortByScore = sortByScore;
                var dispatchEvent = function(element, type, customArgs) {
                    if (customArgs === void 0) customArgs = null;
                    var event = new CustomEvent(type, {
                        detail: customArgs,
                        bubbles: true,
                        cancelable: true
                    });
                    return element.dispatchEvent(event);
                };
                exports.dispatchEvent = dispatchEvent;
                var existsInArray = function(array, value, key) {
                    if (key === void 0) key = 'value';
                    return array.some(function(item) {
                        if (typeof value === 'string') return item[key] === value.trim();
                        return item[key] === value;
                    });
                };
                exports.existsInArray = existsInArray;
                var cloneObject = function(obj) {
                    return JSON.parse(JSON.stringify(obj));
                };
                exports.cloneObject = cloneObject;
                /**
 * Returns an array of keys present on the first but missing on the second object
 */ var diff = function(a, b) {
                    var aKeys = Object.keys(a).sort();
                    var bKeys = Object.keys(b).sort();
                    return aKeys.filter(function(i) {
                        return bKeys.indexOf(i) < 0;
                    });
                };
                exports.diff = diff;
                var parseCustomProperties = function(customProperties) {
                    if (typeof customProperties !== 'undefined') try {
                        return JSON.parse(customProperties);
                    } catch (e) {
                        return customProperties;
                    }
                    return {};
                };
                exports.parseCustomProperties = parseCustomProperties;
            /***/ },
            /***/ 273: /***/ function(__unused_webpack_module, exports) {
                var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
                    if (pack || arguments.length === 2) {
                        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                            ar[i] = from[i];
                        }
                    }
                    return to.concat(ar || Array.prototype.slice.call(from));
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.defaultState = void 0;
                exports.defaultState = [];
                function choices(state, action) {
                    if (state === void 0) state = exports.defaultState;
                    if (action === void 0) action = {};
                    switch(action.type){
                        case 'ADD_CHOICE':
                            var addChoiceAction = action;
                            var choice = {
                                id: addChoiceAction.id,
                                elementId: addChoiceAction.elementId,
                                groupId: addChoiceAction.groupId,
                                value: addChoiceAction.value,
                                label: addChoiceAction.label || addChoiceAction.value,
                                disabled: addChoiceAction.disabled || false,
                                selected: false,
                                active: true,
                                score: 9999,
                                customProperties: addChoiceAction.customProperties,
                                placeholder: addChoiceAction.placeholder || false
                            };
                            /*
          A disabled choice appears in the choice dropdown but cannot be selected
          A selected choice has been added to the passed input's value (added as an item)
          An active choice appears within the choice dropdown
        */ return __spreadArray(__spreadArray([], state, true), [
                                choice
                            ], false);
                        case 'ADD_ITEM':
                            var addItemAction_1 = action;
                            // When an item is added and it has an associated choice,
                            // we want to disable it so it can't be chosen again
                            if (addItemAction_1.choiceId > -1) return state.map(function(obj) {
                                var choice = obj;
                                if (choice.id === parseInt("".concat(addItemAction_1.choiceId), 10)) choice.selected = true;
                                return choice;
                            });
                            return state;
                        case 'REMOVE_ITEM':
                            var removeItemAction_1 = action;
                            // When an item is removed and it has an associated choice,
                            // we want to re-enable it so it can be chosen again
                            if (removeItemAction_1.choiceId && removeItemAction_1.choiceId > -1) return state.map(function(obj) {
                                var choice = obj;
                                if (choice.id === parseInt("".concat(removeItemAction_1.choiceId), 10)) choice.selected = false;
                                return choice;
                            });
                            return state;
                        case 'FILTER_CHOICES':
                            var filterChoicesAction_1 = action;
                            return state.map(function(obj) {
                                var choice = obj;
                                // Set active state based on whether choice is
                                // within filtered results
                                choice.active = filterChoicesAction_1.results.some(function(_a) {
                                    var item = _a.item, score = _a.score;
                                    if (item.id === choice.id) {
                                        choice.score = score;
                                        return true;
                                    }
                                    return false;
                                });
                                return choice;
                            });
                        case 'ACTIVATE_CHOICES':
                            var activateChoicesAction_1 = action;
                            return state.map(function(obj) {
                                var choice = obj;
                                choice.active = activateChoicesAction_1.active;
                                return choice;
                            });
                        case 'CLEAR_CHOICES':
                            return exports.defaultState;
                        default:
                            return state;
                    }
                }
                exports["default"] = choices;
            /***/ },
            /***/ 871: /***/ function(__unused_webpack_module, exports) {
                var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
                    if (pack || arguments.length === 2) {
                        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                            ar[i] = from[i];
                        }
                    }
                    return to.concat(ar || Array.prototype.slice.call(from));
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.defaultState = void 0;
                exports.defaultState = [];
                function groups(state, action) {
                    if (state === void 0) state = exports.defaultState;
                    if (action === void 0) action = {};
                    switch(action.type){
                        case 'ADD_GROUP':
                            var addGroupAction = action;
                            return __spreadArray(__spreadArray([], state, true), [
                                {
                                    id: addGroupAction.id,
                                    value: addGroupAction.value,
                                    active: addGroupAction.active,
                                    disabled: addGroupAction.disabled
                                }
                            ], false);
                        case 'CLEAR_CHOICES':
                            return [];
                        default:
                            return state;
                    }
                }
                exports["default"] = groups;
            /***/ },
            /***/ 655: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.defaultState = void 0;
                var redux_1 = __webpack_require__(791);
                var items_1 = __importDefault(__webpack_require__(52));
                var groups_1 = __importDefault(__webpack_require__(871));
                var choices_1 = __importDefault(__webpack_require__(273));
                var loading_1 = __importDefault(__webpack_require__(502));
                var utils_1 = __webpack_require__(799);
                exports.defaultState = {
                    groups: [],
                    items: [],
                    choices: [],
                    loading: false
                };
                var appReducer = (0, redux_1.combineReducers)({
                    items: items_1.default,
                    groups: groups_1.default,
                    choices: choices_1.default,
                    loading: loading_1.default
                });
                var rootReducer = function(passedState, action) {
                    var state = passedState;
                    // If we are clearing all items, groups and options we reassign
                    // state and then pass that state to our proper reducer. This isn't
                    // mutating our actual state
                    // See: http://stackoverflow.com/a/35641992
                    if (action.type === 'CLEAR_ALL') state = exports.defaultState;
                    else if (action.type === 'RESET_TO') return (0, utils_1.cloneObject)(action.state);
                    return appReducer(state, action);
                };
                exports["default"] = rootReducer;
            /***/ },
            /***/ 52: /***/ function(__unused_webpack_module, exports) {
                var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
                    if (pack || arguments.length === 2) {
                        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                            ar[i] = from[i];
                        }
                    }
                    return to.concat(ar || Array.prototype.slice.call(from));
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.defaultState = void 0;
                exports.defaultState = [];
                function items(state, action) {
                    if (state === void 0) state = exports.defaultState;
                    if (action === void 0) action = {};
                    switch(action.type){
                        case 'ADD_ITEM':
                            var addItemAction = action;
                            // Add object to items array
                            var newState = __spreadArray(__spreadArray([], state, true), [
                                {
                                    id: addItemAction.id,
                                    choiceId: addItemAction.choiceId,
                                    groupId: addItemAction.groupId,
                                    value: addItemAction.value,
                                    label: addItemAction.label,
                                    active: true,
                                    highlighted: false,
                                    customProperties: addItemAction.customProperties,
                                    placeholder: addItemAction.placeholder || false,
                                    keyCode: null
                                }
                            ], false);
                            return newState.map(function(obj) {
                                var item = obj;
                                item.highlighted = false;
                                return item;
                            });
                        case 'REMOVE_ITEM':
                            // Set item to inactive
                            return state.map(function(obj) {
                                var item = obj;
                                if (item.id === action.id) item.active = false;
                                return item;
                            });
                        case 'HIGHLIGHT_ITEM':
                            var highlightItemAction_1 = action;
                            return state.map(function(obj) {
                                var item = obj;
                                if (item.id === highlightItemAction_1.id) item.highlighted = highlightItemAction_1.highlighted;
                                return item;
                            });
                        default:
                            return state;
                    }
                }
                exports["default"] = items;
            /***/ },
            /***/ 502: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.defaultState = void 0;
                exports.defaultState = false;
                var general = function(state, action) {
                    if (state === void 0) state = exports.defaultState;
                    if (action === void 0) action = {};
                    switch(action.type){
                        case 'SET_IS_LOADING':
                            return action.isLoading;
                        default:
                            return state;
                    }
                };
                exports["default"] = general;
            /***/ },
            /***/ 744: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
                    if (pack || arguments.length === 2) {
                        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                            ar[i] = from[i];
                        }
                    }
                    return to.concat(ar || Array.prototype.slice.call(from));
                };
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                /* eslint-disable @typescript-eslint/no-explicit-any */ var redux_1 = __webpack_require__(791);
                var index_1 = __importDefault(__webpack_require__(655));
                var Store = /** @class */ function() {
                    function Store() {
                        this._store = (0, redux_1.createStore)(index_1.default, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
                    }
                    /**
   * Subscribe store to function call (wrapped Redux method)
   */ Store.prototype.subscribe = function(onChange) {
                        this._store.subscribe(onChange);
                    };
                    /**
   * Dispatch event to store (wrapped Redux method)
   */ Store.prototype.dispatch = function(action) {
                        this._store.dispatch(action);
                    };
                    Object.defineProperty(Store.prototype, "state", {
                        /**
     * Get store object (wrapping Redux method)
     */ get: function() {
                            return this._store.getState();
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "items", {
                        /**
     * Get items from store
     */ get: function() {
                            return this.state.items;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "activeItems", {
                        /**
     * Get active items from store
     */ get: function() {
                            return this.items.filter(function(item) {
                                return item.active === true;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "highlightedActiveItems", {
                        /**
     * Get highlighted items from store
     */ get: function() {
                            return this.items.filter(function(item) {
                                return item.active && item.highlighted;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "choices", {
                        /**
     * Get choices from store
     */ get: function() {
                            return this.state.choices;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "activeChoices", {
                        /**
     * Get active choices from store
     */ get: function() {
                            return this.choices.filter(function(choice) {
                                return choice.active === true;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "selectableChoices", {
                        /**
     * Get selectable choices from store
     */ get: function() {
                            return this.choices.filter(function(choice) {
                                return choice.disabled !== true;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "searchableChoices", {
                        /**
     * Get choices that can be searched (excluding placeholders)
     */ get: function() {
                            return this.selectableChoices.filter(function(choice) {
                                return choice.placeholder !== true;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "placeholderChoice", {
                        /**
     * Get placeholder choice from store
     */ get: function() {
                            return __spreadArray([], this.choices, true).reverse().find(function(choice) {
                                return choice.placeholder === true;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "groups", {
                        /**
     * Get groups from store
     */ get: function() {
                            return this.state.groups;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "activeGroups", {
                        /**
     * Get active groups from store
     */ get: function() {
                            var _a = this, groups = _a.groups, choices = _a.choices;
                            return groups.filter(function(group) {
                                var isActive = group.active === true && group.disabled === false;
                                var hasActiveOptions = choices.some(function(choice) {
                                    return choice.active === true && choice.disabled === false;
                                });
                                return isActive && hasActiveOptions;
                            }, []);
                        },
                        enumerable: false,
                        configurable: true
                    });
                    /**
   * Get loading state from store
   */ Store.prototype.isLoading = function() {
                        return this.state.loading;
                    };
                    /**
   * Get single choice by it's ID
   */ Store.prototype.getChoiceById = function(id) {
                        return this.activeChoices.find(function(choice) {
                            return choice.id === parseInt(id, 10);
                        });
                    };
                    /**
   * Get group by group id
   */ Store.prototype.getGroupById = function(id) {
                        return this.groups.find(function(group) {
                            return group.id === id;
                        });
                    };
                    return Store;
                }();
                exports["default"] = Store;
            /***/ },
            /***/ 686: /***/ function(__unused_webpack_module, exports) {
                /**
 * Helpers to create HTML elements used by Choices
 * Can be overridden by providing `callbackOnCreateTemplates` option
 */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var templates = {
                    containerOuter: function(_a, dir, isSelectElement, isSelectOneElement, searchEnabled, passedElementType, labelId) {
                        var containerOuter = _a.classNames.containerOuter;
                        var div = Object.assign(document.createElement('div'), {
                            className: containerOuter
                        });
                        div.dataset.type = passedElementType;
                        if (dir) div.dir = dir;
                        if (isSelectOneElement) div.tabIndex = 0;
                        if (isSelectElement) {
                            div.setAttribute('role', searchEnabled ? 'combobox' : 'listbox');
                            if (searchEnabled) div.setAttribute('aria-autocomplete', 'list');
                        }
                        div.setAttribute('aria-haspopup', 'true');
                        div.setAttribute('aria-expanded', 'false');
                        if (labelId) div.setAttribute('aria-labelledby', labelId);
                        return div;
                    },
                    containerInner: function(_a) {
                        var containerInner = _a.classNames.containerInner;
                        return Object.assign(document.createElement('div'), {
                            className: containerInner
                        });
                    },
                    itemList: function(_a, isSelectOneElement) {
                        var _b = _a.classNames, list = _b.list, listSingle = _b.listSingle, listItems = _b.listItems;
                        return Object.assign(document.createElement('div'), {
                            className: "".concat(list, " ").concat(isSelectOneElement ? listSingle : listItems)
                        });
                    },
                    placeholder: function(_a, value) {
                        var _b;
                        var allowHTML = _a.allowHTML, placeholder = _a.classNames.placeholder;
                        return Object.assign(document.createElement('div'), (_b = {
                            className: placeholder
                        }, _b[allowHTML ? 'innerHTML' : 'innerText'] = value, _b));
                    },
                    item: function(_a, _b, removeItemButton) {
                        var _c, _d;
                        var allowHTML = _a.allowHTML, _e = _a.classNames, item = _e.item, button = _e.button, highlightedState = _e.highlightedState, itemSelectable = _e.itemSelectable, placeholder = _e.placeholder;
                        var id = _b.id, value = _b.value, label = _b.label, customProperties = _b.customProperties, active = _b.active, disabled = _b.disabled, highlighted = _b.highlighted, isPlaceholder = _b.placeholder;
                        var div = Object.assign(document.createElement('div'), (_c = {
                            className: item
                        }, _c[allowHTML ? 'innerHTML' : 'innerText'] = label, _c));
                        Object.assign(div.dataset, {
                            item: '',
                            id: id,
                            value: value,
                            customProperties: customProperties
                        });
                        if (active) div.setAttribute('aria-selected', 'true');
                        if (disabled) div.setAttribute('aria-disabled', 'true');
                        if (isPlaceholder) div.classList.add(placeholder);
                        div.classList.add(highlighted ? highlightedState : itemSelectable);
                        if (removeItemButton) {
                            if (disabled) div.classList.remove(itemSelectable);
                            div.dataset.deletable = '';
                            /** @todo This MUST be localizable, not hardcoded! */ var REMOVE_ITEM_TEXT = 'Remove item';
                            var removeButton = Object.assign(document.createElement('button'), (_d = {
                                type: 'button',
                                className: button
                            }, _d[allowHTML ? 'innerHTML' : 'innerText'] = REMOVE_ITEM_TEXT, _d));
                            removeButton.setAttribute('aria-label', "".concat(REMOVE_ITEM_TEXT, ": '").concat(value, "'"));
                            removeButton.dataset.button = '';
                            div.appendChild(removeButton);
                        }
                        return div;
                    },
                    choiceList: function(_a, isSelectOneElement) {
                        var list = _a.classNames.list;
                        var div = Object.assign(document.createElement('div'), {
                            className: list
                        });
                        if (!isSelectOneElement) div.setAttribute('aria-multiselectable', 'true');
                        div.setAttribute('role', 'listbox');
                        return div;
                    },
                    choiceGroup: function(_a, _b) {
                        var _c;
                        var allowHTML = _a.allowHTML, _d = _a.classNames, group = _d.group, groupHeading = _d.groupHeading, itemDisabled = _d.itemDisabled;
                        var id = _b.id, value = _b.value, disabled = _b.disabled;
                        var div = Object.assign(document.createElement('div'), {
                            className: "".concat(group, " ").concat(disabled ? itemDisabled : '')
                        });
                        div.setAttribute('role', 'group');
                        Object.assign(div.dataset, {
                            group: '',
                            id: id,
                            value: value
                        });
                        if (disabled) div.setAttribute('aria-disabled', 'true');
                        div.appendChild(Object.assign(document.createElement('div'), (_c = {
                            className: groupHeading
                        }, _c[allowHTML ? 'innerHTML' : 'innerText'] = value, _c)));
                        return div;
                    },
                    choice: function(_a, _b, selectText) {
                        var _c;
                        var allowHTML = _a.allowHTML, _d = _a.classNames, item = _d.item, itemChoice = _d.itemChoice, itemSelectable = _d.itemSelectable, selectedState = _d.selectedState, itemDisabled = _d.itemDisabled, placeholder = _d.placeholder;
                        var id = _b.id, value = _b.value, label = _b.label, groupId = _b.groupId, elementId = _b.elementId, isDisabled = _b.disabled, isSelected = _b.selected, isPlaceholder = _b.placeholder;
                        var div = Object.assign(document.createElement('div'), (_c = {
                            id: elementId
                        }, _c[allowHTML ? 'innerHTML' : 'innerText'] = label, _c.className = "".concat(item, " ").concat(itemChoice), _c));
                        if (isSelected) div.classList.add(selectedState);
                        if (isPlaceholder) div.classList.add(placeholder);
                        div.setAttribute('role', groupId && groupId > 0 ? 'treeitem' : 'option');
                        Object.assign(div.dataset, {
                            choice: '',
                            id: id,
                            value: value,
                            selectText: selectText
                        });
                        if (isDisabled) {
                            div.classList.add(itemDisabled);
                            div.dataset.choiceDisabled = '';
                            div.setAttribute('aria-disabled', 'true');
                        } else {
                            div.classList.add(itemSelectable);
                            div.dataset.choiceSelectable = '';
                        }
                        return div;
                    },
                    input: function(_a, placeholderValue) {
                        var _b = _a.classNames, input = _b.input, inputCloned = _b.inputCloned;
                        var inp = Object.assign(document.createElement('input'), {
                            type: 'search',
                            name: 'search_terms',
                            className: "".concat(input, " ").concat(inputCloned),
                            autocomplete: 'off',
                            autocapitalize: 'off',
                            spellcheck: false
                        });
                        inp.setAttribute('role', 'textbox');
                        inp.setAttribute('aria-autocomplete', 'list');
                        inp.setAttribute('aria-label', placeholderValue);
                        return inp;
                    },
                    dropdown: function(_a) {
                        var _b = _a.classNames, list = _b.list, listDropdown = _b.listDropdown;
                        var div = document.createElement('div');
                        div.classList.add(list, listDropdown);
                        div.setAttribute('aria-expanded', 'false');
                        return div;
                    },
                    notice: function(_a, innerText, type) {
                        var _b;
                        var allowHTML = _a.allowHTML, _c = _a.classNames, item = _c.item, itemChoice = _c.itemChoice, noResults = _c.noResults, noChoices = _c.noChoices;
                        if (type === void 0) type = '';
                        var classes = [
                            item,
                            itemChoice
                        ];
                        if (type === 'no-choices') classes.push(noChoices);
                        else if (type === 'no-results') classes.push(noResults);
                        return Object.assign(document.createElement('div'), (_b = {}, _b[allowHTML ? 'innerHTML' : 'innerText'] = innerText, _b.className = classes.join(' '), _b));
                    },
                    option: function(_a) {
                        var label = _a.label, value = _a.value, customProperties = _a.customProperties, active = _a.active, disabled = _a.disabled;
                        var opt = new Option(label, value, false, active);
                        if (customProperties) opt.dataset.customProperties = "".concat(customProperties);
                        opt.disabled = !!disabled;
                        return opt;
                    }
                };
                exports["default"] = templates;
            /***/ },
            /***/ 996: /***/ function(module1) {
                var isMergeableObject = function isMergeableObject(value) {
                    return isNonNullObject(value) && !isSpecial(value);
                };
                function isNonNullObject(value) {
                    return !!value && typeof value === 'object';
                }
                function isSpecial(value) {
                    var stringValue = Object.prototype.toString.call(value);
                    return stringValue === '[object RegExp]' || stringValue === '[object Date]' || isReactElement(value);
                }
                // see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
                var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
                var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;
                function isReactElement(value) {
                    return value.$$typeof === REACT_ELEMENT_TYPE;
                }
                function emptyTarget(val) {
                    return Array.isArray(val) ? [] : {};
                }
                function cloneUnlessOtherwiseSpecified(value, options) {
                    return options.clone !== false && options.isMergeableObject(value) ? deepmerge(emptyTarget(value), value, options) : value;
                }
                function defaultArrayMerge(target, source, options) {
                    return target.concat(source).map(function(element) {
                        return cloneUnlessOtherwiseSpecified(element, options);
                    });
                }
                function getMergeFunction(key, options) {
                    if (!options.customMerge) return deepmerge;
                    var customMerge = options.customMerge(key);
                    return typeof customMerge === 'function' ? customMerge : deepmerge;
                }
                function getEnumerableOwnPropertySymbols(target) {
                    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
                        return target.propertyIsEnumerable(symbol);
                    }) : [];
                }
                function getKeys(target) {
                    return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target));
                }
                function propertyIsOnObject(object, property) {
                    try {
                        return property in object;
                    } catch (_) {
                        return false;
                    }
                }
                // Protects from prototype poisoning and unexpected merging up the prototype chain.
                function propertyIsUnsafe(target, key) {
                    return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
                     && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
                     && Object.propertyIsEnumerable.call(target, key) // and also unsafe if they're nonenumerable.
                    );
                }
                function mergeObject(target, source, options) {
                    var destination = {};
                    if (options.isMergeableObject(target)) getKeys(target).forEach(function(key) {
                        destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
                    });
                    getKeys(source).forEach(function(key) {
                        if (propertyIsUnsafe(target, key)) return;
                        if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
                        else destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
                    });
                    return destination;
                }
                function deepmerge(target, source, options) {
                    options = options || {};
                    options.arrayMerge = options.arrayMerge || defaultArrayMerge;
                    options.isMergeableObject = options.isMergeableObject || isMergeableObject;
                    // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
                    // implementations can use it. The caller may not replace it.
                    options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
                    var sourceIsArray = Array.isArray(source);
                    var targetIsArray = Array.isArray(target);
                    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
                    if (!sourceAndTargetTypesMatch) return cloneUnlessOtherwiseSpecified(source, options);
                    else if (sourceIsArray) return options.arrayMerge(target, source, options);
                    else return mergeObject(target, source, options);
                }
                deepmerge.all = function deepmergeAll(array, options) {
                    if (!Array.isArray(array)) throw new Error('first argument should be an array');
                    return array.reduce(function(prev, next) {
                        return deepmerge(prev, next, options);
                    }, {});
                };
                var deepmerge_1 = deepmerge;
                module1.exports = deepmerge_1;
            /***/ },
            /***/ 221: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ "default": function() {
                        return /* binding */ Fuse;
                    }
                });
                /**
 * Fuse.js v6.6.2 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2022 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ function isArray(value) {
                    return !Array.isArray ? getTag(value) === '[object Array]' : Array.isArray(value);
                }
                // Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
                const INFINITY = 1 / 0;
                function baseToString(value) {
                    // Exit early for strings to avoid a performance hit in some environments.
                    if (typeof value == 'string') return value;
                    let result = value + '';
                    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
                }
                function toString(value) {
                    return value == null ? '' : baseToString(value);
                }
                function isString(value) {
                    return typeof value === 'string';
                }
                function isNumber(value) {
                    return typeof value === 'number';
                }
                // Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
                function isBoolean(value) {
                    return value === true || value === false || isObjectLike(value) && getTag(value) == '[object Boolean]';
                }
                function isObject(value) {
                    return typeof value === 'object';
                }
                // Checks if `value` is object-like.
                function isObjectLike(value) {
                    return isObject(value) && value !== null;
                }
                function isDefined(value) {
                    return value !== undefined && value !== null;
                }
                function isBlank(value) {
                    return !value.trim().length;
                }
                // Gets the `toStringTag` of `value`.
                // Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
                function getTag(value) {
                    return value == null ? value === undefined ? '[object Undefined]' : '[object Null]' : Object.prototype.toString.call(value);
                }
                const EXTENDED_SEARCH_UNAVAILABLE = 'Extended search is not available';
                const INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
                const LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key)=>`Invalid value for key ${key}`;
                const PATTERN_LENGTH_TOO_LARGE = (max)=>`Pattern length exceeds max of ${max}.`;
                const MISSING_KEY_PROPERTY = (name)=>`Missing ${name} property in key`;
                const INVALID_KEY_WEIGHT_VALUE = (key)=>`Property 'weight' in key '${key}' must be a positive integer`;
                const hasOwn = Object.prototype.hasOwnProperty;
                class KeyStore {
                    constructor(keys){
                        this._keys = [];
                        this._keyMap = {};
                        let totalWeight = 0;
                        keys.forEach((key)=>{
                            let obj = createKey(key);
                            totalWeight += obj.weight;
                            this._keys.push(obj);
                            this._keyMap[obj.id] = obj;
                            totalWeight += obj.weight;
                        });
                        // Normalize weights so that their sum is equal to 1
                        this._keys.forEach((key)=>{
                            key.weight /= totalWeight;
                        });
                    }
                    get(keyId) {
                        return this._keyMap[keyId];
                    }
                    keys() {
                        return this._keys;
                    }
                    toJSON() {
                        return JSON.stringify(this._keys);
                    }
                }
                function createKey(key) {
                    let path = null;
                    let id = null;
                    let src = null;
                    let weight = 1;
                    let getFn = null;
                    if (isString(key) || isArray(key)) {
                        src = key;
                        path = createKeyPath(key);
                        id = createKeyId(key);
                    } else {
                        if (!hasOwn.call(key, 'name')) throw new Error(MISSING_KEY_PROPERTY('name'));
                        const name = key.name;
                        src = name;
                        if (hasOwn.call(key, 'weight')) {
                            weight = key.weight;
                            if (weight <= 0) throw new Error(INVALID_KEY_WEIGHT_VALUE(name));
                        }
                        path = createKeyPath(name);
                        id = createKeyId(name);
                        getFn = key.getFn;
                    }
                    return {
                        path: path,
                        id: id,
                        weight: weight,
                        src: src,
                        getFn: getFn
                    };
                }
                function createKeyPath(key) {
                    return isArray(key) ? key : key.split('.');
                }
                function createKeyId(key) {
                    return isArray(key) ? key.join('.') : key;
                }
                function get(obj, path) {
                    let list = [];
                    let arr = false;
                    const deepGet = (obj, path, index)=>{
                        if (!isDefined(obj)) return;
                        if (!path[index]) // If there's no path left, we've arrived at the object we care about.
                        list.push(obj);
                        else {
                            let key = path[index];
                            const value = obj[key];
                            if (!isDefined(value)) return;
                            // If we're at the last value in the path, and if it's a string/number/bool,
                            // add it to the list
                            if (index === path.length - 1 && (isString(value) || isNumber(value) || isBoolean(value))) list.push(toString(value));
                            else if (isArray(value)) {
                                arr = true;
                                // Search each item in the array.
                                for(let i = 0, len = value.length; i < len; i += 1)deepGet(value[i], path, index + 1);
                            } else if (path.length) // An object. Recurse further.
                            deepGet(value, path, index + 1);
                        }
                    };
                    // Backwards compatibility (since path used to be a string)
                    deepGet(obj, isString(path) ? path.split('.') : path, 0);
                    return arr ? list : list[0];
                }
                const MatchOptions = {
                    // Whether the matches should be included in the result set. When `true`, each record in the result
                    // set will include the indices of the matched characters.
                    // These can consequently be used for highlighting purposes.
                    includeMatches: false,
                    // When `true`, the matching function will continue to the end of a search pattern even if
                    // a perfect match has already been located in the string.
                    findAllMatches: false,
                    // Minimum number of characters that must be matched before a result is considered a match
                    minMatchCharLength: 1
                };
                const BasicOptions = {
                    // When `true`, the algorithm continues searching to the end of the input even if a perfect
                    // match is found before the end of the same input.
                    isCaseSensitive: false,
                    // When true, the matching function will continue to the end of a search pattern even if
                    includeScore: false,
                    // List of properties that will be searched. This also supports nested properties.
                    keys: [],
                    // Whether to sort the result list, by score
                    shouldSort: true,
                    // Default sort function: sort by ascending score, ascending index
                    sortFn: (a, b)=>a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
                };
                const FuzzyOptions = {
                    // Approximately where in the text is the pattern expected to be found?
                    location: 0,
                    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
                    // (of both letters and location), a threshold of '1.0' would match anything.
                    threshold: 0.6,
                    // Determines how close the match must be to the fuzzy location (specified above).
                    // An exact letter match which is 'distance' characters away from the fuzzy location
                    // would score as a complete mismatch. A distance of '0' requires the match be at
                    // the exact location specified, a threshold of '1000' would require a perfect match
                    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
                    distance: 100
                };
                const AdvancedOptions = {
                    // When `true`, it enables the use of unix-like search commands
                    useExtendedSearch: false,
                    // The get function to use when fetching an object's properties.
                    // The default will search nested paths *ie foo.bar.baz*
                    getFn: get,
                    // When `true`, search will ignore `location` and `distance`, so it won't matter
                    // where in the string the pattern appears.
                    // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
                    ignoreLocation: false,
                    // When `true`, the calculation for the relevance score (used for sorting) will
                    // ignore the field-length norm.
                    // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
                    ignoreFieldNorm: false,
                    // The weight to determine how much field length norm effects scoring.
                    fieldNormWeight: 1
                };
                var Config = {
                    ...BasicOptions,
                    ...MatchOptions,
                    ...FuzzyOptions,
                    ...AdvancedOptions
                };
                const SPACE = /[^ ]+/g;
                // Field-length norm: the shorter the field, the higher the weight.
                // Set to 3 decimals to reduce index size.
                function norm(weight = 1, mantissa = 3) {
                    const cache = new Map();
                    const m = Math.pow(10, mantissa);
                    return {
                        get (value) {
                            const numTokens = value.match(SPACE).length;
                            if (cache.has(numTokens)) return cache.get(numTokens);
                            // Default function is 1/sqrt(x), weight makes that variable
                            const norm = 1 / Math.pow(numTokens, 0.5 * weight);
                            // In place of `toFixed(mantissa)`, for faster computation
                            const n = parseFloat(Math.round(norm * m) / m);
                            cache.set(numTokens, n);
                            return n;
                        },
                        clear () {
                            cache.clear();
                        }
                    };
                }
                class FuseIndex {
                    constructor({ getFn: getFn = Config.getFn, fieldNormWeight: fieldNormWeight = Config.fieldNormWeight } = {}){
                        this.norm = norm(fieldNormWeight, 3);
                        this.getFn = getFn;
                        this.isCreated = false;
                        this.setIndexRecords();
                    }
                    setSources(docs = []) {
                        this.docs = docs;
                    }
                    setIndexRecords(records = []) {
                        this.records = records;
                    }
                    setKeys(keys = []) {
                        this.keys = keys;
                        this._keysMap = {};
                        keys.forEach((key, idx)=>{
                            this._keysMap[key.id] = idx;
                        });
                    }
                    create() {
                        if (this.isCreated || !this.docs.length) return;
                        this.isCreated = true;
                        // List is Array<String>
                        if (isString(this.docs[0])) this.docs.forEach((doc, docIndex)=>{
                            this._addString(doc, docIndex);
                        });
                        else // List is Array<Object>
                        this.docs.forEach((doc, docIndex)=>{
                            this._addObject(doc, docIndex);
                        });
                        this.norm.clear();
                    }
                    // Adds a doc to the end of the index
                    add(doc) {
                        const idx = this.size();
                        if (isString(doc)) this._addString(doc, idx);
                        else this._addObject(doc, idx);
                    }
                    // Removes the doc at the specified index of the index
                    removeAt(idx) {
                        this.records.splice(idx, 1);
                        // Change ref index of every subsquent doc
                        for(let i = idx, len = this.size(); i < len; i += 1)this.records[i].i -= 1;
                    }
                    getValueForItemAtKeyId(item, keyId) {
                        return item[this._keysMap[keyId]];
                    }
                    size() {
                        return this.records.length;
                    }
                    _addString(doc, docIndex) {
                        if (!isDefined(doc) || isBlank(doc)) return;
                        let record = {
                            v: doc,
                            i: docIndex,
                            n: this.norm.get(doc)
                        };
                        this.records.push(record);
                    }
                    _addObject(doc, docIndex) {
                        let record = {
                            i: docIndex,
                            $: {}
                        };
                        // Iterate over every key (i.e, path), and fetch the value at that key
                        this.keys.forEach((key, keyIndex)=>{
                            let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
                            if (!isDefined(value)) return;
                            if (isArray(value)) {
                                let subRecords = [];
                                const stack = [
                                    {
                                        nestedArrIndex: -1,
                                        value: value
                                    }
                                ];
                                while(stack.length){
                                    const { nestedArrIndex: nestedArrIndex, value: value } = stack.pop();
                                    if (!isDefined(value)) continue;
                                    if (isString(value) && !isBlank(value)) {
                                        let subRecord = {
                                            v: value,
                                            i: nestedArrIndex,
                                            n: this.norm.get(value)
                                        };
                                        subRecords.push(subRecord);
                                    } else if (isArray(value)) value.forEach((item, k)=>{
                                        stack.push({
                                            nestedArrIndex: k,
                                            value: item
                                        });
                                    });
                                }
                                record.$[keyIndex] = subRecords;
                            } else if (isString(value) && !isBlank(value)) {
                                let subRecord = {
                                    v: value,
                                    n: this.norm.get(value)
                                };
                                record.$[keyIndex] = subRecord;
                            }
                        });
                        this.records.push(record);
                    }
                    toJSON() {
                        return {
                            keys: this.keys,
                            records: this.records
                        };
                    }
                }
                function createIndex(keys, docs, { getFn: getFn = Config.getFn, fieldNormWeight: fieldNormWeight = Config.fieldNormWeight } = {}) {
                    const myIndex = new FuseIndex({
                        getFn: getFn,
                        fieldNormWeight: fieldNormWeight
                    });
                    myIndex.setKeys(keys.map(createKey));
                    myIndex.setSources(docs);
                    myIndex.create();
                    return myIndex;
                }
                function parseIndex(data, { getFn: getFn = Config.getFn, fieldNormWeight: fieldNormWeight = Config.fieldNormWeight } = {}) {
                    const { keys: keys, records: records } = data;
                    const myIndex = new FuseIndex({
                        getFn: getFn,
                        fieldNormWeight: fieldNormWeight
                    });
                    myIndex.setKeys(keys);
                    myIndex.setIndexRecords(records);
                    return myIndex;
                }
                function computeScore$1(pattern, { errors: errors = 0, currentLocation: currentLocation = 0, expectedLocation: expectedLocation = 0, distance: distance = Config.distance, ignoreLocation: ignoreLocation = Config.ignoreLocation } = {}) {
                    const accuracy = errors / pattern.length;
                    if (ignoreLocation) return accuracy;
                    const proximity = Math.abs(expectedLocation - currentLocation);
                    if (!distance) // Dodge divide by zero error.
                    return proximity ? 1.0 : accuracy;
                    return accuracy + proximity / distance;
                }
                function convertMaskToIndices(matchmask = [], minMatchCharLength = Config.minMatchCharLength) {
                    let indices = [];
                    let start = -1;
                    let end = -1;
                    let i = 0;
                    for(let len = matchmask.length; i < len; i += 1){
                        let match = matchmask[i];
                        if (match && start === -1) start = i;
                        else if (!match && start !== -1) {
                            end = i - 1;
                            if (end - start + 1 >= minMatchCharLength) indices.push([
                                start,
                                end
                            ]);
                            start = -1;
                        }
                    }
                    // (i-1 - start) + 1 => i - start
                    if (matchmask[i - 1] && i - start >= minMatchCharLength) indices.push([
                        start,
                        i - 1
                    ]);
                    return indices;
                }
                // Machine word size
                const MAX_BITS = 32;
                function search(text, pattern, patternAlphabet, { location: location = Config.location, distance: distance = Config.distance, threshold: threshold = Config.threshold, findAllMatches: findAllMatches = Config.findAllMatches, minMatchCharLength: minMatchCharLength = Config.minMatchCharLength, includeMatches: includeMatches = Config.includeMatches, ignoreLocation: ignoreLocation = Config.ignoreLocation } = {}) {
                    if (pattern.length > MAX_BITS) throw new Error(PATTERN_LENGTH_TOO_LARGE(MAX_BITS));
                    const patternLen = pattern.length;
                    // Set starting location at beginning text and initialize the alphabet.
                    const textLen = text.length;
                    // Handle the case when location > text.length
                    const expectedLocation = Math.max(0, Math.min(location, textLen));
                    // Highest score beyond which we give up.
                    let currentThreshold = threshold;
                    // Is there a nearby exact match? (speedup)
                    let bestLocation = expectedLocation;
                    // Performance: only computer matches when the minMatchCharLength > 1
                    // OR if `includeMatches` is true.
                    const computeMatches = minMatchCharLength > 1 || includeMatches;
                    // A mask of the matches, used for building the indices
                    const matchMask = computeMatches ? Array(textLen) : [];
                    let index;
                    // Get all exact matches, here for speed up
                    while((index = text.indexOf(pattern, bestLocation)) > -1){
                        let score = computeScore$1(pattern, {
                            currentLocation: index,
                            expectedLocation: expectedLocation,
                            distance: distance,
                            ignoreLocation: ignoreLocation
                        });
                        currentThreshold = Math.min(score, currentThreshold);
                        bestLocation = index + patternLen;
                        if (computeMatches) {
                            let i = 0;
                            while(i < patternLen){
                                matchMask[index + i] = 1;
                                i += 1;
                            }
                        }
                    }
                    // Reset the best location
                    bestLocation = -1;
                    let lastBitArr = [];
                    let finalScore = 1;
                    let binMax = patternLen + textLen;
                    const mask = 1 << patternLen - 1;
                    for(let i = 0; i < patternLen; i += 1){
                        // Scan for the best match; each iteration allows for one more error.
                        // Run a binary search to determine how far from the match location we can stray
                        // at this error level.
                        let binMin = 0;
                        let binMid = binMax;
                        while(binMin < binMid){
                            const score = computeScore$1(pattern, {
                                errors: i,
                                currentLocation: expectedLocation + binMid,
                                expectedLocation: expectedLocation,
                                distance: distance,
                                ignoreLocation: ignoreLocation
                            });
                            if (score <= currentThreshold) binMin = binMid;
                            else binMax = binMid;
                            binMid = Math.floor((binMax - binMin) / 2 + binMin);
                        }
                        // Use the result from this iteration as the maximum for the next.
                        binMax = binMid;
                        let start = Math.max(1, expectedLocation - binMid + 1);
                        let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
                        // Initialize the bit array
                        let bitArr = Array(finish + 2);
                        bitArr[finish + 1] = (1 << i) - 1;
                        for(let j = finish; j >= start; j -= 1){
                            let currentLocation = j - 1;
                            let charMatch = patternAlphabet[text.charAt(currentLocation)];
                            if (computeMatches) // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
                            matchMask[currentLocation] = +!!charMatch;
                            // First pass: exact match
                            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
                            // Subsequent passes: fuzzy match
                            if (i) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
                            if (bitArr[j] & mask) {
                                finalScore = computeScore$1(pattern, {
                                    errors: i,
                                    currentLocation: currentLocation,
                                    expectedLocation: expectedLocation,
                                    distance: distance,
                                    ignoreLocation: ignoreLocation
                                });
                                // This match will almost certainly be better than any existing match.
                                // But check anyway.
                                if (finalScore <= currentThreshold) {
                                    // Indeed it is
                                    currentThreshold = finalScore;
                                    bestLocation = currentLocation;
                                    // Already passed `loc`, downhill from here on in.
                                    if (bestLocation <= expectedLocation) break;
                                    // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                                }
                            }
                        }
                        // No hope for a (better) match at greater error levels.
                        const score = computeScore$1(pattern, {
                            errors: i + 1,
                            currentLocation: expectedLocation,
                            expectedLocation: expectedLocation,
                            distance: distance,
                            ignoreLocation: ignoreLocation
                        });
                        if (score > currentThreshold) break;
                        lastBitArr = bitArr;
                    }
                    const result = {
                        isMatch: bestLocation >= 0,
                        // Count exact matches (those with a score of 0) to be "almost" exact
                        score: Math.max(0.001, finalScore)
                    };
                    if (computeMatches) {
                        const indices = convertMaskToIndices(matchMask, minMatchCharLength);
                        if (!indices.length) result.isMatch = false;
                        else if (includeMatches) result.indices = indices;
                    }
                    return result;
                }
                function createPatternAlphabet(pattern) {
                    let mask = {};
                    for(let i = 0, len = pattern.length; i < len; i += 1){
                        const char = pattern.charAt(i);
                        mask[char] = (mask[char] || 0) | 1 << len - i - 1;
                    }
                    return mask;
                }
                class BitapSearch {
                    constructor(pattern, { location: location = Config.location, threshold: threshold = Config.threshold, distance: distance = Config.distance, includeMatches: includeMatches = Config.includeMatches, findAllMatches: findAllMatches = Config.findAllMatches, minMatchCharLength: minMatchCharLength = Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = Config.isCaseSensitive, ignoreLocation: ignoreLocation = Config.ignoreLocation } = {}){
                        this.options = {
                            location: location,
                            threshold: threshold,
                            distance: distance,
                            includeMatches: includeMatches,
                            findAllMatches: findAllMatches,
                            minMatchCharLength: minMatchCharLength,
                            isCaseSensitive: isCaseSensitive,
                            ignoreLocation: ignoreLocation
                        };
                        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
                        this.chunks = [];
                        if (!this.pattern.length) return;
                        const addChunk = (pattern, startIndex)=>{
                            this.chunks.push({
                                pattern: pattern,
                                alphabet: createPatternAlphabet(pattern),
                                startIndex: startIndex
                            });
                        };
                        const len = this.pattern.length;
                        if (len > MAX_BITS) {
                            let i = 0;
                            const remainder = len % MAX_BITS;
                            const end = len - remainder;
                            while(i < end){
                                addChunk(this.pattern.substr(i, MAX_BITS), i);
                                i += MAX_BITS;
                            }
                            if (remainder) {
                                const startIndex = len - MAX_BITS;
                                addChunk(this.pattern.substr(startIndex), startIndex);
                            }
                        } else addChunk(this.pattern, 0);
                    }
                    searchIn(text) {
                        const { isCaseSensitive: isCaseSensitive, includeMatches: includeMatches } = this.options;
                        if (!isCaseSensitive) text = text.toLowerCase();
                        // Exact match
                        if (this.pattern === text) {
                            let result = {
                                isMatch: true,
                                score: 0
                            };
                            if (includeMatches) result.indices = [
                                [
                                    0,
                                    text.length - 1
                                ]
                            ];
                            return result;
                        }
                        // Otherwise, use Bitap algorithm
                        const { location: location, distance: distance, threshold: threshold, findAllMatches: findAllMatches, minMatchCharLength: minMatchCharLength, ignoreLocation: ignoreLocation } = this.options;
                        let allIndices = [];
                        let totalScore = 0;
                        let hasMatches = false;
                        this.chunks.forEach(({ pattern: pattern, alphabet: alphabet, startIndex: startIndex })=>{
                            const { isMatch: isMatch, score: score, indices: indices } = search(text, pattern, alphabet, {
                                location: location + startIndex,
                                distance: distance,
                                threshold: threshold,
                                findAllMatches: findAllMatches,
                                minMatchCharLength: minMatchCharLength,
                                includeMatches: includeMatches,
                                ignoreLocation: ignoreLocation
                            });
                            if (isMatch) hasMatches = true;
                            totalScore += score;
                            if (isMatch && indices) allIndices = [
                                ...allIndices,
                                ...indices
                            ];
                        });
                        let result = {
                            isMatch: hasMatches,
                            score: hasMatches ? totalScore / this.chunks.length : 1
                        };
                        if (hasMatches && includeMatches) result.indices = allIndices;
                        return result;
                    }
                }
                class BaseMatch {
                    constructor(pattern){
                        this.pattern = pattern;
                    }
                    static isMultiMatch(pattern) {
                        return getMatch(pattern, this.multiRegex);
                    }
                    static isSingleMatch(pattern) {
                        return getMatch(pattern, this.singleRegex);
                    }
                    search() {}
                }
                function getMatch(pattern, exp) {
                    const matches = pattern.match(exp);
                    return matches ? matches[1] : null;
                }
                // Token: 'file
                class ExactMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return 'exact';
                    }
                    static get multiRegex() {
                        return /^="(.*)"$/;
                    }
                    static get singleRegex() {
                        return /^=(.*)$/;
                    }
                    search(text) {
                        const isMatch = text === this.pattern;
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: [
                                0,
                                this.pattern.length - 1
                            ]
                        };
                    }
                }
                // Token: !fire
                class InverseExactMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return 'inverse-exact';
                    }
                    static get multiRegex() {
                        return /^!"(.*)"$/;
                    }
                    static get singleRegex() {
                        return /^!(.*)$/;
                    }
                    search(text) {
                        const index = text.indexOf(this.pattern);
                        const isMatch = index === -1;
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: [
                                0,
                                text.length - 1
                            ]
                        };
                    }
                }
                // Token: ^file
                class PrefixExactMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return 'prefix-exact';
                    }
                    static get multiRegex() {
                        return /^\^"(.*)"$/;
                    }
                    static get singleRegex() {
                        return /^\^(.*)$/;
                    }
                    search(text) {
                        const isMatch = text.startsWith(this.pattern);
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: [
                                0,
                                this.pattern.length - 1
                            ]
                        };
                    }
                }
                // Token: !^fire
                class InversePrefixExactMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return 'inverse-prefix-exact';
                    }
                    static get multiRegex() {
                        return /^!\^"(.*)"$/;
                    }
                    static get singleRegex() {
                        return /^!\^(.*)$/;
                    }
                    search(text) {
                        const isMatch = !text.startsWith(this.pattern);
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: [
                                0,
                                text.length - 1
                            ]
                        };
                    }
                }
                // Token: .file$
                class SuffixExactMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return 'suffix-exact';
                    }
                    static get multiRegex() {
                        return /^"(.*)"\$$/;
                    }
                    static get singleRegex() {
                        return /^(.*)\$$/;
                    }
                    search(text) {
                        const isMatch = text.endsWith(this.pattern);
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: [
                                text.length - this.pattern.length,
                                text.length - 1
                            ]
                        };
                    }
                }
                // Token: !.file$
                class InverseSuffixExactMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return 'inverse-suffix-exact';
                    }
                    static get multiRegex() {
                        return /^!"(.*)"\$$/;
                    }
                    static get singleRegex() {
                        return /^!(.*)\$$/;
                    }
                    search(text) {
                        const isMatch = !text.endsWith(this.pattern);
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: [
                                0,
                                text.length - 1
                            ]
                        };
                    }
                }
                class FuzzyMatch extends BaseMatch {
                    constructor(pattern, { location: location = Config.location, threshold: threshold = Config.threshold, distance: distance = Config.distance, includeMatches: includeMatches = Config.includeMatches, findAllMatches: findAllMatches = Config.findAllMatches, minMatchCharLength: minMatchCharLength = Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = Config.isCaseSensitive, ignoreLocation: ignoreLocation = Config.ignoreLocation } = {}){
                        super(pattern);
                        this._bitapSearch = new BitapSearch(pattern, {
                            location: location,
                            threshold: threshold,
                            distance: distance,
                            includeMatches: includeMatches,
                            findAllMatches: findAllMatches,
                            minMatchCharLength: minMatchCharLength,
                            isCaseSensitive: isCaseSensitive,
                            ignoreLocation: ignoreLocation
                        });
                    }
                    static get type() {
                        return 'fuzzy';
                    }
                    static get multiRegex() {
                        return /^"(.*)"$/;
                    }
                    static get singleRegex() {
                        return /^(.*)$/;
                    }
                    search(text) {
                        return this._bitapSearch.searchIn(text);
                    }
                }
                // Token: 'file
                class IncludeMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return 'include';
                    }
                    static get multiRegex() {
                        return /^'"(.*)"$/;
                    }
                    static get singleRegex() {
                        return /^'(.*)$/;
                    }
                    search(text) {
                        let location = 0;
                        let index;
                        const indices = [];
                        const patternLen = this.pattern.length;
                        // Get all exact matches
                        while((index = text.indexOf(this.pattern, location)) > -1){
                            location = index + patternLen;
                            indices.push([
                                index,
                                location - 1
                            ]);
                        }
                        const isMatch = !!indices.length;
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: indices
                        };
                    }
                }
                // ❗Order is important. DO NOT CHANGE.
                const searchers = [
                    ExactMatch,
                    IncludeMatch,
                    PrefixExactMatch,
                    InversePrefixExactMatch,
                    InverseSuffixExactMatch,
                    SuffixExactMatch,
                    InverseExactMatch,
                    FuzzyMatch
                ];
                const searchersLen = searchers.length;
                // Regex to split by spaces, but keep anything in quotes together
                const SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
                const OR_TOKEN = '|';
                // Return a 2D array representation of the query, for simpler parsing.
                // Example:
                // "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
                function parseQuery(pattern, options = {}) {
                    return pattern.split(OR_TOKEN).map((item)=>{
                        let query = item.trim().split(SPACE_RE).filter((item)=>item && !!item.trim());
                        let results = [];
                        for(let i = 0, len = query.length; i < len; i += 1){
                            const queryItem = query[i];
                            // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
                            let found = false;
                            let idx = -1;
                            while(!found && ++idx < searchersLen){
                                const searcher = searchers[idx];
                                let token = searcher.isMultiMatch(queryItem);
                                if (token) {
                                    results.push(new searcher(token, options));
                                    found = true;
                                }
                            }
                            if (found) continue;
                            // 2. Handle single query matches (i.e, once that are *not* quoted)
                            idx = -1;
                            while(++idx < searchersLen){
                                const searcher = searchers[idx];
                                let token = searcher.isSingleMatch(queryItem);
                                if (token) {
                                    results.push(new searcher(token, options));
                                    break;
                                }
                            }
                        }
                        return results;
                    });
                }
                // These extended matchers can return an array of matches, as opposed
                // to a singl match
                const MultiMatchSet = new Set([
                    FuzzyMatch.type,
                    IncludeMatch.type
                ]);
                /**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */ class ExtendedSearch {
                    constructor(pattern, { isCaseSensitive: isCaseSensitive = Config.isCaseSensitive, includeMatches: includeMatches = Config.includeMatches, minMatchCharLength: minMatchCharLength = Config.minMatchCharLength, ignoreLocation: ignoreLocation = Config.ignoreLocation, findAllMatches: findAllMatches = Config.findAllMatches, location: location = Config.location, threshold: threshold = Config.threshold, distance: distance = Config.distance } = {}){
                        this.query = null;
                        this.options = {
                            isCaseSensitive: isCaseSensitive,
                            includeMatches: includeMatches,
                            minMatchCharLength: minMatchCharLength,
                            findAllMatches: findAllMatches,
                            ignoreLocation: ignoreLocation,
                            location: location,
                            threshold: threshold,
                            distance: distance
                        };
                        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
                        this.query = parseQuery(this.pattern, this.options);
                    }
                    static condition(_, options) {
                        return options.useExtendedSearch;
                    }
                    searchIn(text) {
                        const query = this.query;
                        if (!query) return {
                            isMatch: false,
                            score: 1
                        };
                        const { includeMatches: includeMatches, isCaseSensitive: isCaseSensitive } = this.options;
                        text = isCaseSensitive ? text : text.toLowerCase();
                        let numMatches = 0;
                        let allIndices = [];
                        let totalScore = 0;
                        // ORs
                        for(let i = 0, qLen = query.length; i < qLen; i += 1){
                            const searchers = query[i];
                            // Reset indices
                            allIndices.length = 0;
                            numMatches = 0;
                            // ANDs
                            for(let j = 0, pLen = searchers.length; j < pLen; j += 1){
                                const searcher = searchers[j];
                                const { isMatch: isMatch, indices: indices, score: score } = searcher.search(text);
                                if (isMatch) {
                                    numMatches += 1;
                                    totalScore += score;
                                    if (includeMatches) {
                                        const type = searcher.constructor.type;
                                        if (MultiMatchSet.has(type)) allIndices = [
                                            ...allIndices,
                                            ...indices
                                        ];
                                        else allIndices.push(indices);
                                    }
                                } else {
                                    totalScore = 0;
                                    numMatches = 0;
                                    allIndices.length = 0;
                                    break;
                                }
                            }
                            // OR condition, so if TRUE, return
                            if (numMatches) {
                                let result = {
                                    isMatch: true,
                                    score: totalScore / numMatches
                                };
                                if (includeMatches) result.indices = allIndices;
                                return result;
                            }
                        }
                        // Nothing was matched
                        return {
                            isMatch: false,
                            score: 1
                        };
                    }
                }
                const registeredSearchers = [];
                function register(...args) {
                    registeredSearchers.push(...args);
                }
                function createSearcher(pattern, options) {
                    for(let i = 0, len = registeredSearchers.length; i < len; i += 1){
                        let searcherClass = registeredSearchers[i];
                        if (searcherClass.condition(pattern, options)) return new searcherClass(pattern, options);
                    }
                    return new BitapSearch(pattern, options);
                }
                const LogicalOperator = {
                    AND: '$and',
                    OR: '$or'
                };
                const KeyType = {
                    PATH: '$path',
                    PATTERN: '$val'
                };
                const isExpression = (query)=>!!(query[LogicalOperator.AND] || query[LogicalOperator.OR]);
                const isPath = (query)=>!!query[KeyType.PATH];
                const isLeaf = (query)=>!isArray(query) && isObject(query) && !isExpression(query);
                const convertToExplicit = (query)=>({
                        [LogicalOperator.AND]: Object.keys(query).map((key)=>({
                                [key]: query[key]
                            }))
                    });
                // When `auto` is `true`, the parse function will infer and initialize and add
                // the appropriate `Searcher` instance
                function parse(query, options, { auto: auto = true } = {}) {
                    const next = (query)=>{
                        let keys = Object.keys(query);
                        const isQueryPath = isPath(query);
                        if (!isQueryPath && keys.length > 1 && !isExpression(query)) return next(convertToExplicit(query));
                        if (isLeaf(query)) {
                            const key = isQueryPath ? query[KeyType.PATH] : keys[0];
                            const pattern = isQueryPath ? query[KeyType.PATTERN] : query[key];
                            if (!isString(pattern)) throw new Error(LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
                            const obj = {
                                keyId: createKeyId(key),
                                pattern: pattern
                            };
                            if (auto) obj.searcher = createSearcher(pattern, options);
                            return obj;
                        }
                        let node = {
                            children: [],
                            operator: keys[0]
                        };
                        keys.forEach((key)=>{
                            const value = query[key];
                            if (isArray(value)) value.forEach((item)=>{
                                node.children.push(next(item));
                            });
                        });
                        return node;
                    };
                    if (!isExpression(query)) query = convertToExplicit(query);
                    return next(query);
                }
                // Practical scoring function
                function computeScore(results, { ignoreFieldNorm: ignoreFieldNorm = Config.ignoreFieldNorm }) {
                    results.forEach((result)=>{
                        let totalScore = 1;
                        result.matches.forEach(({ key: key, norm: norm, score: score })=>{
                            const weight = key ? key.weight : null;
                            totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
                        });
                        result.score = totalScore;
                    });
                }
                function transformMatches(result, data) {
                    const matches = result.matches;
                    data.matches = [];
                    if (!isDefined(matches)) return;
                    matches.forEach((match)=>{
                        if (!isDefined(match.indices) || !match.indices.length) return;
                        const { indices: indices, value: value } = match;
                        let obj = {
                            indices: indices,
                            value: value
                        };
                        if (match.key) obj.key = match.key.src;
                        if (match.idx > -1) obj.refIndex = match.idx;
                        data.matches.push(obj);
                    });
                }
                function transformScore(result, data) {
                    data.score = result.score;
                }
                function format(results, docs, { includeMatches: includeMatches = Config.includeMatches, includeScore: includeScore = Config.includeScore } = {}) {
                    const transformers = [];
                    if (includeMatches) transformers.push(transformMatches);
                    if (includeScore) transformers.push(transformScore);
                    return results.map((result)=>{
                        const { idx: idx } = result;
                        const data = {
                            item: docs[idx],
                            refIndex: idx
                        };
                        if (transformers.length) transformers.forEach((transformer)=>{
                            transformer(result, data);
                        });
                        return data;
                    });
                }
                class Fuse {
                    constructor(docs, options = {}, index){
                        this.options = {
                            ...Config,
                            ...options
                        };
                        this.options.useExtendedSearch;
                        this._keyStore = new KeyStore(this.options.keys);
                        this.setCollection(docs, index);
                    }
                    setCollection(docs, index) {
                        this._docs = docs;
                        if (index && !(index instanceof FuseIndex)) throw new Error(INCORRECT_INDEX_TYPE);
                        this._myIndex = index || createIndex(this.options.keys, this._docs, {
                            getFn: this.options.getFn,
                            fieldNormWeight: this.options.fieldNormWeight
                        });
                    }
                    add(doc) {
                        if (!isDefined(doc)) return;
                        this._docs.push(doc);
                        this._myIndex.add(doc);
                    }
                    remove(predicate = ()=>false) {
                        const results = [];
                        for(let i = 0, len = this._docs.length; i < len; i += 1){
                            const doc = this._docs[i];
                            if (predicate(doc, i)) {
                                this.removeAt(i);
                                i -= 1;
                                len -= 1;
                                results.push(doc);
                            }
                        }
                        return results;
                    }
                    removeAt(idx) {
                        this._docs.splice(idx, 1);
                        this._myIndex.removeAt(idx);
                    }
                    getIndex() {
                        return this._myIndex;
                    }
                    search(query, { limit: limit = -1 } = {}) {
                        const { includeMatches: includeMatches, includeScore: includeScore, shouldSort: shouldSort, sortFn: sortFn, ignoreFieldNorm: ignoreFieldNorm } = this.options;
                        let results = isString(query) ? isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
                        computeScore(results, {
                            ignoreFieldNorm: ignoreFieldNorm
                        });
                        if (shouldSort) results.sort(sortFn);
                        if (isNumber(limit) && limit > -1) results = results.slice(0, limit);
                        return format(results, this._docs, {
                            includeMatches: includeMatches,
                            includeScore: includeScore
                        });
                    }
                    _searchStringList(query) {
                        const searcher = createSearcher(query, this.options);
                        const { records: records } = this._myIndex;
                        const results = [];
                        // Iterate over every string in the index
                        records.forEach(({ v: text, i: idx, n: norm })=>{
                            if (!isDefined(text)) return;
                            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
                            if (isMatch) results.push({
                                item: text,
                                idx: idx,
                                matches: [
                                    {
                                        score: score,
                                        value: text,
                                        norm: norm,
                                        indices: indices
                                    }
                                ]
                            });
                        });
                        return results;
                    }
                    _searchLogical(query) {
                        const expression = parse(query, this.options);
                        const evaluate = (node, item, idx)=>{
                            if (!node.children) {
                                const { keyId: keyId, searcher: searcher } = node;
                                const matches = this._findMatches({
                                    key: this._keyStore.get(keyId),
                                    value: this._myIndex.getValueForItemAtKeyId(item, keyId),
                                    searcher: searcher
                                });
                                if (matches && matches.length) return [
                                    {
                                        idx: idx,
                                        item: item,
                                        matches: matches
                                    }
                                ];
                                return [];
                            }
                            const res = [];
                            for(let i = 0, len = node.children.length; i < len; i += 1){
                                const child = node.children[i];
                                const result = evaluate(child, item, idx);
                                if (result.length) res.push(...result);
                                else if (node.operator === LogicalOperator.AND) return [];
                            }
                            return res;
                        };
                        const records = this._myIndex.records;
                        const resultMap = {};
                        const results = [];
                        records.forEach(({ $: item, i: idx })=>{
                            if (isDefined(item)) {
                                let expResults = evaluate(expression, item, idx);
                                if (expResults.length) {
                                    // Dedupe when adding
                                    if (!resultMap[idx]) {
                                        resultMap[idx] = {
                                            idx: idx,
                                            item: item,
                                            matches: []
                                        };
                                        results.push(resultMap[idx]);
                                    }
                                    expResults.forEach(({ matches: matches })=>{
                                        resultMap[idx].matches.push(...matches);
                                    });
                                }
                            }
                        });
                        return results;
                    }
                    _searchObjectList(query) {
                        const searcher = createSearcher(query, this.options);
                        const { keys: keys, records: records } = this._myIndex;
                        const results = [];
                        // List is Array<Object>
                        records.forEach(({ $: item, i: idx })=>{
                            if (!isDefined(item)) return;
                            let matches = [];
                            // Iterate over every key (i.e, path), and fetch the value at that key
                            keys.forEach((key, keyIndex)=>{
                                matches.push(...this._findMatches({
                                    key: key,
                                    value: item[keyIndex],
                                    searcher: searcher
                                }));
                            });
                            if (matches.length) results.push({
                                idx: idx,
                                item: item,
                                matches: matches
                            });
                        });
                        return results;
                    }
                    _findMatches({ key: key, value: value, searcher: searcher }) {
                        if (!isDefined(value)) return [];
                        let matches = [];
                        if (isArray(value)) value.forEach(({ v: text, i: idx, n: norm })=>{
                            if (!isDefined(text)) return;
                            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
                            if (isMatch) matches.push({
                                score: score,
                                key: key,
                                value: text,
                                idx: idx,
                                norm: norm,
                                indices: indices
                            });
                        });
                        else {
                            const { v: text, n: norm } = value;
                            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
                            if (isMatch) matches.push({
                                score: score,
                                key: key,
                                value: text,
                                norm: norm,
                                indices: indices
                            });
                        }
                        return matches;
                    }
                }
                Fuse.version = '6.6.2';
                Fuse.createIndex = createIndex;
                Fuse.parseIndex = parseIndex;
                Fuse.config = Config;
                Fuse.parseQuery = parse;
                register(ExtendedSearch);
            /***/ },
            /***/ 791: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                // ESM COMPAT FLAG
                __webpack_require__.r(__webpack_exports__);
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    "__DO_NOT_USE__ActionTypes": function() {
                        return /* binding */ ActionTypes;
                    },
                    "applyMiddleware": function() {
                        return /* binding */ applyMiddleware;
                    },
                    "bindActionCreators": function() {
                        return /* binding */ bindActionCreators;
                    },
                    "combineReducers": function() {
                        return /* binding */ combineReducers;
                    },
                    "compose": function() {
                        return /* binding */ compose;
                    },
                    "createStore": function() {
                        return /* binding */ createStore;
                    },
                    "legacy_createStore": function() {
                        return /* binding */ legacy_createStore;
                    }
                });
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                        return typeof obj;
                    } : function(obj) {
                        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    }, _typeof(obj);
                }
                function _toPrimitive(input, hint) {
                    if (_typeof(input) !== "object" || input === null) return input;
                    var prim = input[Symbol.toPrimitive];
                    if (prim !== undefined) {
                        var res = prim.call(input, hint || "default");
                        if (_typeof(res) !== "object") return res;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (hint === "string" ? String : Number)(input);
                }
                function _toPropertyKey(arg) {
                    var key = _toPrimitive(arg, "string");
                    return _typeof(key) === "symbol" ? key : String(key);
                }
                function _defineProperty(obj, key, value) {
                    key = _toPropertyKey(key);
                    if (key in obj) Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                    else obj[key] = value;
                    return obj;
                }
                function ownKeys(object, enumerableOnly) {
                    var keys = Object.keys(object);
                    if (Object.getOwnPropertySymbols) {
                        var symbols = Object.getOwnPropertySymbols(object);
                        enumerableOnly && (symbols = symbols.filter(function(sym) {
                            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                        })), keys.push.apply(keys, symbols);
                    }
                    return keys;
                }
                function _objectSpread2(target) {
                    for(var i = 1; i < arguments.length; i++){
                        var source = null != arguments[i] ? arguments[i] : {};
                        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
                            _defineProperty(target, key, source[key]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                        });
                    }
                    return target;
                }
                /**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function formatProdErrorMessage(code) {
                    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
                }
                // Inlined version of the `symbol-observable` polyfill
                var $$observable = function() {
                    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
                }();
                /**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var randomString = function randomString() {
                    return Math.random().toString(36).substring(7).split('').join('.');
                };
                var ActionTypes = {
                    INIT: "@@redux/INIT" + randomString(),
                    REPLACE: "@@redux/REPLACE" + randomString(),
                    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
                        return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
                    }
                };
                /**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function isPlainObject(obj) {
                    if (typeof obj !== 'object' || obj === null) return false;
                    var proto = obj;
                    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
                    return Object.getPrototypeOf(obj) === proto;
                }
                // Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
                function miniKindOf(val) {
                    if (val === void 0) return 'undefined';
                    if (val === null) return 'null';
                    var type = typeof val;
                    switch(type){
                        case 'boolean':
                        case 'string':
                        case 'number':
                        case 'symbol':
                        case 'function':
                            return type;
                    }
                    if (Array.isArray(val)) return 'array';
                    if (isDate(val)) return 'date';
                    if (isError(val)) return 'error';
                    var constructorName = ctorName(val);
                    switch(constructorName){
                        case 'Symbol':
                        case 'Promise':
                        case 'WeakMap':
                        case 'WeakSet':
                        case 'Map':
                        case 'Set':
                            return constructorName;
                    } // other
                    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
                }
                function ctorName(val) {
                    return typeof val.constructor === 'function' ? val.constructor.name : null;
                }
                function isError(val) {
                    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
                }
                function isDate(val) {
                    if (val instanceof Date) return true;
                    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
                }
                function kindOf(val) {
                    var typeOfVal = typeof val;
                    return typeOfVal;
                }
                /**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function createStore(reducer, preloadedState, enhancer) {
                    var _ref2;
                    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error(formatProdErrorMessage(0));
                    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
                        enhancer = preloadedState;
                        preloadedState = undefined;
                    }
                    if (typeof enhancer !== 'undefined') {
                        if (typeof enhancer !== 'function') throw new Error(formatProdErrorMessage(1));
                        return enhancer(createStore)(reducer, preloadedState);
                    }
                    if (typeof reducer !== 'function') throw new Error(formatProdErrorMessage(2));
                    var currentReducer = reducer;
                    var currentState = preloadedState;
                    var currentListeners = [];
                    var nextListeners = currentListeners;
                    var isDispatching = false;
                    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
                        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
                    }
                    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
                        if (isDispatching) throw new Error(formatProdErrorMessage(3));
                        return currentState;
                    }
                    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
                        if (typeof listener !== 'function') throw new Error(formatProdErrorMessage(4));
                        if (isDispatching) throw new Error(formatProdErrorMessage(5));
                        var isSubscribed = true;
                        ensureCanMutateNextListeners();
                        nextListeners.push(listener);
                        return function unsubscribe() {
                            if (!isSubscribed) return;
                            if (isDispatching) throw new Error(formatProdErrorMessage(6));
                            isSubscribed = false;
                            ensureCanMutateNextListeners();
                            var index = nextListeners.indexOf(listener);
                            nextListeners.splice(index, 1);
                            currentListeners = null;
                        };
                    }
                    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
                        if (!isPlainObject(action)) throw new Error(formatProdErrorMessage(7));
                        if (typeof action.type === 'undefined') throw new Error(formatProdErrorMessage(8));
                        if (isDispatching) throw new Error(formatProdErrorMessage(9));
                        try {
                            isDispatching = true;
                            currentState = currentReducer(currentState, action);
                        } finally{
                            isDispatching = false;
                        }
                        var listeners = currentListeners = nextListeners;
                        for(var i = 0; i < listeners.length; i++){
                            var listener = listeners[i];
                            listener();
                        }
                        return action;
                    }
                    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
                        if (typeof nextReducer !== 'function') throw new Error(formatProdErrorMessage(10));
                        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
                        // Any reducers that existed in both the new and old rootReducer
                        // will receive the previous state. This effectively populates
                        // the new state tree with any relevant data from the old one.
                        dispatch({
                            type: ActionTypes.REPLACE
                        });
                    }
                    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
                        var _ref;
                        var outerSubscribe = subscribe;
                        return _ref = {
                            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                                if (typeof observer !== 'object' || observer === null) throw new Error(formatProdErrorMessage(11));
                                function observeState() {
                                    if (observer.next) observer.next(getState());
                                }
                                observeState();
                                var unsubscribe = outerSubscribe(observeState);
                                return {
                                    unsubscribe: unsubscribe
                                };
                            }
                        }, _ref[$$observable] = function() {
                            return this;
                        }, _ref;
                    } // When a store is created, an "INIT" action is dispatched so that every
                    // reducer returns their initial state. This effectively populates
                    // the initial state tree.
                    dispatch({
                        type: ActionTypes.INIT
                    });
                    return _ref2 = {
                        dispatch: dispatch,
                        subscribe: subscribe,
                        getState: getState,
                        replaceReducer: replaceReducer
                    }, _ref2[$$observable] = observable, _ref2;
                }
                /**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var legacy_createStore = createStore;
                /**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function warning(message) {
                    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
                    /* eslint-enable no-console */ try {
                        // This error was thrown as a convenience so that if you enable
                        // "break on all exceptions" in your console,
                        // it would pause the execution at this line.
                        throw new Error(message);
                    } catch (e) {} // eslint-disable-line no-empty
                }
                function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
                    var reducerKeys = Object.keys(reducers);
                    var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
                    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
                    if (!isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
                    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
                        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
                    });
                    unexpectedKeys.forEach(function(key) {
                        unexpectedKeyCache[key] = true;
                    });
                    if (action && action.type === ActionTypes.REPLACE) return;
                    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
                }
                function assertReducerShape(reducers) {
                    Object.keys(reducers).forEach(function(key) {
                        var reducer = reducers[key];
                        var initialState = reducer(undefined, {
                            type: ActionTypes.INIT
                        });
                        if (typeof initialState === 'undefined') throw new Error(formatProdErrorMessage(12));
                        if (typeof reducer(undefined, {
                            type: ActionTypes.PROBE_UNKNOWN_ACTION()
                        }) === 'undefined') throw new Error(formatProdErrorMessage(13));
                    });
                }
                /**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function combineReducers(reducers) {
                    var reducerKeys = Object.keys(reducers);
                    var finalReducers = {};
                    for(var i = 0; i < reducerKeys.length; i++){
                        var key = reducerKeys[i];
                        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
                    }
                    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
                    // keys multiple times.
                    var unexpectedKeyCache;
                    var shapeAssertionError;
                    try {
                        assertReducerShape(finalReducers);
                    } catch (e) {
                        shapeAssertionError = e;
                    }
                    return function combination(state, action) {
                        if (state === void 0) state = {};
                        if (shapeAssertionError) throw shapeAssertionError;
                        var warningMessage;
                        var hasChanged = false;
                        var nextState = {};
                        for(var _i = 0; _i < finalReducerKeys.length; _i++){
                            var _key = finalReducerKeys[_i];
                            var reducer = finalReducers[_key];
                            var previousStateForKey = state[_key];
                            var nextStateForKey = reducer(previousStateForKey, action);
                            if (typeof nextStateForKey === 'undefined') {
                                var actionType = action && action.type;
                                throw new Error(formatProdErrorMessage(14));
                            }
                            nextState[_key] = nextStateForKey;
                            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
                        }
                        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
                        return hasChanged ? nextState : state;
                    };
                }
                function bindActionCreator(actionCreator, dispatch) {
                    return function() {
                        return dispatch(actionCreator.apply(this, arguments));
                    };
                }
                /**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function bindActionCreators(actionCreators, dispatch) {
                    if (typeof actionCreators === 'function') return bindActionCreator(actionCreators, dispatch);
                    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error(formatProdErrorMessage(16));
                    var boundActionCreators = {};
                    for(var key in actionCreators){
                        var actionCreator = actionCreators[key];
                        if (typeof actionCreator === 'function') boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
                    }
                    return boundActionCreators;
                }
                /**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function compose() {
                    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
                    if (funcs.length === 0) return function(arg) {
                        return arg;
                    };
                    if (funcs.length === 1) return funcs[0];
                    return funcs.reduce(function(a, b) {
                        return function() {
                            return a(b.apply(void 0, arguments));
                        };
                    });
                }
                /**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function applyMiddleware() {
                    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
                    return function(createStore) {
                        return function() {
                            var store = createStore.apply(void 0, arguments);
                            var _dispatch = function dispatch() {
                                throw new Error(formatProdErrorMessage(15));
                            };
                            var middlewareAPI = {
                                getState: store.getState,
                                dispatch: function dispatch() {
                                    return _dispatch.apply(void 0, arguments);
                                }
                            };
                            var chain = middlewares.map(function(middleware) {
                                return middleware(middlewareAPI);
                            });
                            _dispatch = compose.apply(void 0, chain)(store.dispatch);
                            return _objectSpread2(_objectSpread2({}, store), {}, {
                                dispatch: _dispatch
                            });
                        };
                    };
                }
                /*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */ function isCrushed() {}
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/compat get default export */ /******/ !function() {
            /******/ // getDefaultExport function for compatibility with non-harmony modules
            /******/ __webpack_require__.n = function(module1) {
                /******/ var getter = module1 && module1.__esModule ? /******/ function() {
                    return module1['default'];
                } : /******/ function() {
                    return module1;
                };
                /******/ __webpack_require__.d(getter, {
                    a: getter
                });
                /******/ return getter;
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/define property getters */ /******/ !function() {
            /******/ // define getter functions for harmony exports
            /******/ __webpack_require__.d = function(exports, definition) {
                /******/ for(var key in definition)/******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key]
                });
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ !function() {
            /******/ __webpack_require__.o = function(obj, prop) {
                return Object.prototype.hasOwnProperty.call(obj, prop);
            };
        /******/ }();
        /******/ /******/ /* webpack/runtime/make namespace object */ /******/ !function() {
            /******/ // define __esModule on exports
            /******/ __webpack_require__.r = function(exports) {
                /******/ if (typeof Symbol !== 'undefined' && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                    value: 'Module'
                });
                /******/ Object.defineProperty(exports, '__esModule', {
                    value: true
                });
            /******/ };
        /******/ }();
        /******/ /************************************************************************/ var __webpack_exports__ = {};
        // This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
        !function() {
            /* harmony import */ var _scripts_choices__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(373);
            /* harmony import */ var _scripts_choices__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_scripts_choices__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _scripts_interfaces__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(187);
            /* harmony import */ var _scripts_interfaces__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(_scripts_interfaces__WEBPACK_IMPORTED_MODULE_1__);
            /* harmony import */ var _scripts_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(883);
            /* harmony import */ var _scripts_defaults__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(789);
            /* harmony import */ var _scripts_templates__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(686);
            /* harmony default export */ __webpack_exports__["default"] = _scripts_choices__WEBPACK_IMPORTED_MODULE_0___default();
        }();
        __webpack_exports__ = __webpack_exports__["default"];
        /******/ return __webpack_exports__;
    /******/ }();
});



function $d2fbdb601ef9b65c$var$updateSearchPopupUI(isVisible) {
    const popup = document.querySelector("#search-popup");
    const icon = document.querySelector(".header-search-icon-container");
    if (!popup || !icon) return;
    popup.hidden = !isVisible;
    icon.ariaExpanded = isVisible.toString();
}
function $d2fbdb601ef9b65c$var$initSearchPopup() {
    const isVisible = new (0, $cc4b70f67be6e72e$export$2e2bcd8739ae039)("search popup", false);
    isVisible.subscribe($d2fbdb601ef9b65c$var$updateSearchPopupUI);
    const popup = document.querySelector("#search-popup");
    const selectElement = document.querySelector("div.choices");
    const icon = document.querySelector(".header-search-icon-container");
    if (!icon) throw new Error("icon not found");
    icon.addEventListener("click", ()=>{
        isVisible.setValue(!isVisible.getValue());
        setTimeout(()=>selectElement?.click(), 100);
    });
    // Clicks outside the popup close it.
    window.addEventListener("click", (event)=>{
        if (isVisible.getValue() === true && event.target instanceof Element && !icon?.contains(event.target) && !popup?.contains(event.target)) isVisible.setValue(false);
    });
    isVisible.initialize();
    return isVisible;
}
function $d2fbdb601ef9b65c$export$2e2bcd8739ae039(filterManager) {
    const places = Object.entries(filterManager.entries).map(([placeId, entry])=>({
            value: placeId,
            label: placeId,
            customProperties: {
                place: entry.place.name,
                state: entry.place.state ?? "",
                country: entry.place.country
            }
        }));
    const htmlElement = document.querySelector(".search");
    if (!htmlElement) return;
    const choices = new (0, (/*@__PURE__*/$parcel$interopDefault($125d88de280575d0$exports)))(htmlElement, {
        position: "bottom",
        choices: places,
        placeholderValue: "Search",
        removeItemButton: true,
        allowHTML: false,
        itemSelectText: "",
        searchEnabled: true,
        searchFields: [
            "customProperties.place",
            "customProperties.state",
            "customProperties.country"
        ]
    });
    // Set initial state.
    choices.setChoiceByValue(filterManager.getState().searchInput || "");
    // Also set up the popup.
    const popupIsVisible = $d2fbdb601ef9b65c$var$initSearchPopup();
    // Ensure that programmatic changes that set FilterState.searchInput to null
    // update the UI element too.
    filterManager.subscribe("reset search UI when search is cleared", (state)=>{
        if (state.searchInput === null) choices.setChoiceByValue("");
    });
    // User-driven inputs to search should update the FilterState.
    htmlElement.addEventListener("change", ()=>{
        filterManager.update({
            searchInput: choices.getValue(true) || null
        });
        popupIsVisible.setValue(false);
    });
}


/* Tabulator v6.3.0 (c) Oliver Folkerd 2024 */ class $c2a9788f40f9c90a$var$CoreFeature {
    constructor(table){
        this.table = table;
    }
    //////////////////////////////////////////
    /////////////// DataLoad /////////////////
    //////////////////////////////////////////
    reloadData(data, silent, columnsChanged) {
        return this.table.dataLoader.load(data, undefined, undefined, undefined, silent, columnsChanged);
    }
    //////////////////////////////////////////
    ///////////// Localization ///////////////
    //////////////////////////////////////////
    langText() {
        return this.table.modules.localize.getText(...arguments);
    }
    langBind() {
        return this.table.modules.localize.bind(...arguments);
    }
    langLocale() {
        return this.table.modules.localize.getLocale(...arguments);
    }
    //////////////////////////////////////////
    ////////// Inter Table Comms /////////////
    //////////////////////////////////////////
    commsConnections() {
        return this.table.modules.comms.getConnections(...arguments);
    }
    commsSend() {
        return this.table.modules.comms.send(...arguments);
    }
    //////////////////////////////////////////
    //////////////// Layout  /////////////////
    //////////////////////////////////////////
    layoutMode() {
        return this.table.modules.layout.getMode();
    }
    layoutRefresh(force) {
        return this.table.modules.layout.layout(force);
    }
    //////////////////////////////////////////
    /////////////// Event Bus ////////////////
    //////////////////////////////////////////
    subscribe() {
        return this.table.eventBus.subscribe(...arguments);
    }
    unsubscribe() {
        return this.table.eventBus.unsubscribe(...arguments);
    }
    subscribed(key) {
        return this.table.eventBus.subscribed(key);
    }
    subscriptionChange() {
        return this.table.eventBus.subscriptionChange(...arguments);
    }
    dispatch() {
        return this.table.eventBus.dispatch(...arguments);
    }
    chain() {
        return this.table.eventBus.chain(...arguments);
    }
    confirm() {
        return this.table.eventBus.confirm(...arguments);
    }
    dispatchExternal() {
        return this.table.externalEvents.dispatch(...arguments);
    }
    subscribedExternal(key) {
        return this.table.externalEvents.subscribed(key);
    }
    subscriptionChangeExternal() {
        return this.table.externalEvents.subscriptionChange(...arguments);
    }
    //////////////////////////////////////////
    //////////////// Options /////////////////
    //////////////////////////////////////////
    options(key) {
        return this.table.options[key];
    }
    setOption(key, value) {
        if (typeof value !== "undefined") this.table.options[key] = value;
        return this.table.options[key];
    }
    //////////////////////////////////////////
    /////////// Deprecation Checks ///////////
    //////////////////////////////////////////
    deprecationCheck(oldOption, newOption, convert) {
        return this.table.deprecationAdvisor.check(oldOption, newOption, convert);
    }
    deprecationCheckMsg(oldOption, msg) {
        return this.table.deprecationAdvisor.checkMsg(oldOption, msg);
    }
    deprecationMsg(msg) {
        return this.table.deprecationAdvisor.msg(msg);
    }
    //////////////////////////////////////////
    //////////////// Modules /////////////////
    //////////////////////////////////////////
    module(key) {
        return this.table.module(key);
    }
}
class $c2a9788f40f9c90a$var$Helpers {
    static elVisible(el) {
        return !(el.offsetWidth <= 0 && el.offsetHeight <= 0);
    }
    static elOffset(el) {
        var box = el.getBoundingClientRect();
        return {
            top: box.top + window.pageYOffset - document.documentElement.clientTop,
            left: box.left + window.pageXOffset - document.documentElement.clientLeft
        };
    }
    static retrieveNestedData(separator, field, data) {
        var structure = separator ? field.split(separator) : [
            field
        ], length = structure.length, output;
        for(let i = 0; i < length; i++){
            data = data[structure[i]];
            output = data;
            if (!data) break;
        }
        return output;
    }
    static deepClone(obj, clone, list = []) {
        var objectProto = {}.__proto__, arrayProto = [].__proto__;
        if (!clone) clone = Object.assign(Array.isArray(obj) ? [] : {}, obj);
        for(var i in obj){
            let subject = obj[i], match, copy;
            if (subject != null && typeof subject === "object" && (subject.__proto__ === objectProto || subject.__proto__ === arrayProto)) {
                match = list.findIndex((item)=>{
                    return item.subject === subject;
                });
                if (match > -1) clone[i] = list[match].copy;
                else {
                    copy = Object.assign(Array.isArray(subject) ? [] : {}, subject);
                    list.unshift({
                        subject: subject,
                        copy: copy
                    });
                    clone[i] = this.deepClone(subject, copy, list);
                }
            }
        }
        return clone;
    }
}
let $c2a9788f40f9c90a$var$Popup$1 = class Popup extends $c2a9788f40f9c90a$var$CoreFeature {
    constructor(table, element, parent){
        super(table);
        this.element = element;
        this.container = this._lookupContainer();
        this.parent = parent;
        this.reversedX = false;
        this.childPopup = null;
        this.blurable = false;
        this.blurCallback = null;
        this.blurEventsBound = false;
        this.renderedCallback = null;
        this.visible = false;
        this.hideable = true;
        this.element.classList.add("tabulator-popup-container");
        this.blurEvent = this.hide.bind(this, false);
        this.escEvent = this._escapeCheck.bind(this);
        this.destroyBinding = this.tableDestroyed.bind(this);
        this.destroyed = false;
    }
    tableDestroyed() {
        this.destroyed = true;
        this.hide(true);
    }
    _lookupContainer() {
        var container = this.table.options.popupContainer;
        if (typeof container === "string") {
            container = document.querySelector(container);
            if (!container) console.warn("Menu Error - no container element found matching selector:", this.table.options.popupContainer, "(defaulting to document body)");
        } else if (container === true) container = this.table.element;
        if (container && !this._checkContainerIsParent(container)) {
            container = false;
            console.warn("Menu Error - container element does not contain this table:", this.table.options.popupContainer, "(defaulting to document body)");
        }
        if (!container) container = document.body;
        return container;
    }
    _checkContainerIsParent(container, element = this.table.element) {
        if (container === element) return true;
        else return element.parentNode ? this._checkContainerIsParent(container, element.parentNode) : false;
    }
    renderCallback(callback) {
        this.renderedCallback = callback;
    }
    containerEventCoords(e) {
        var touch = !(e instanceof MouseEvent);
        var x = touch ? e.touches[0].pageX : e.pageX;
        var y = touch ? e.touches[0].pageY : e.pageY;
        if (this.container !== document.body) {
            let parentOffset = $c2a9788f40f9c90a$var$Helpers.elOffset(this.container);
            x -= parentOffset.left;
            y -= parentOffset.top;
        }
        return {
            x: x,
            y: y
        };
    }
    elementPositionCoords(element, position = "right") {
        var offset = $c2a9788f40f9c90a$var$Helpers.elOffset(element), containerOffset, x, y;
        if (this.container !== document.body) {
            containerOffset = $c2a9788f40f9c90a$var$Helpers.elOffset(this.container);
            offset.left -= containerOffset.left;
            offset.top -= containerOffset.top;
        }
        switch(position){
            case "right":
                x = offset.left + element.offsetWidth;
                y = offset.top - 1;
                break;
            case "bottom":
                x = offset.left;
                y = offset.top + element.offsetHeight;
                break;
            case "left":
                x = offset.left;
                y = offset.top - 1;
                break;
            case "top":
                x = offset.left;
                y = offset.top;
                break;
            case "center":
                x = offset.left + element.offsetWidth / 2;
                y = offset.top + element.offsetHeight / 2;
                break;
        }
        return {
            x: x,
            y: y,
            offset: offset
        };
    }
    show(origin, position) {
        var x, y, parentEl, parentOffset, coords;
        if (this.destroyed || this.table.destroyed) return this;
        if (origin instanceof HTMLElement) {
            parentEl = origin;
            coords = this.elementPositionCoords(origin, position);
            parentOffset = coords.offset;
            x = coords.x;
            y = coords.y;
        } else if (typeof origin === "number") {
            parentOffset = {
                top: 0,
                left: 0
            };
            x = origin;
            y = position;
        } else {
            coords = this.containerEventCoords(origin);
            x = coords.x;
            y = coords.y;
            this.reversedX = false;
        }
        this.element.style.top = y + "px";
        this.element.style.left = x + "px";
        this.container.appendChild(this.element);
        if (typeof this.renderedCallback === "function") this.renderedCallback();
        this._fitToScreen(x, y, parentEl, parentOffset, position);
        this.visible = true;
        this.subscribe("table-destroy", this.destroyBinding);
        this.element.addEventListener("mousedown", (e)=>{
            e.stopPropagation();
        });
        return this;
    }
    _fitToScreen(x, y, parentEl, parentOffset, position) {
        var scrollTop = this.container === document.body ? document.documentElement.scrollTop : this.container.scrollTop;
        //move menu to start on right edge if it is too close to the edge of the screen
        if (x + this.element.offsetWidth >= this.container.offsetWidth || this.reversedX) {
            this.element.style.left = "";
            if (parentEl) this.element.style.right = this.container.offsetWidth - parentOffset.left + "px";
            else this.element.style.right = this.container.offsetWidth - x + "px";
            this.reversedX = true;
        }
        //move menu to start on bottom edge if it is too close to the edge of the screen
        let offsetHeight = Math.max(this.container.offsetHeight, scrollTop ? this.container.scrollHeight : 0);
        if (y + this.element.offsetHeight > offsetHeight) {
            if (parentEl) switch(position){
                case "bottom":
                    this.element.style.top = parseInt(this.element.style.top) - this.element.offsetHeight - parentEl.offsetHeight - 1 + "px";
                    break;
                default:
                    this.element.style.top = parseInt(this.element.style.top) - this.element.offsetHeight + parentEl.offsetHeight + 1 + "px";
            }
            else this.element.style.height = offsetHeight + "px";
        }
    }
    isVisible() {
        return this.visible;
    }
    hideOnBlur(callback) {
        this.blurable = true;
        if (this.visible) {
            setTimeout(()=>{
                if (this.visible) {
                    this.table.rowManager.element.addEventListener("scroll", this.blurEvent);
                    this.subscribe("cell-editing", this.blurEvent);
                    document.body.addEventListener("click", this.blurEvent);
                    document.body.addEventListener("contextmenu", this.blurEvent);
                    document.body.addEventListener("mousedown", this.blurEvent);
                    window.addEventListener("resize", this.blurEvent);
                    document.body.addEventListener("keydown", this.escEvent);
                    this.blurEventsBound = true;
                }
            }, 100);
            this.blurCallback = callback;
        }
        return this;
    }
    _escapeCheck(e) {
        if (e.keyCode == 27) this.hide();
    }
    blockHide() {
        this.hideable = false;
    }
    restoreHide() {
        this.hideable = true;
    }
    hide(silent = false) {
        if (this.visible && this.hideable) {
            if (this.blurable && this.blurEventsBound) {
                document.body.removeEventListener("keydown", this.escEvent);
                document.body.removeEventListener("click", this.blurEvent);
                document.body.removeEventListener("contextmenu", this.blurEvent);
                document.body.removeEventListener("mousedown", this.blurEvent);
                window.removeEventListener("resize", this.blurEvent);
                this.table.rowManager.element.removeEventListener("scroll", this.blurEvent);
                this.unsubscribe("cell-editing", this.blurEvent);
                this.blurEventsBound = false;
            }
            if (this.childPopup) this.childPopup.hide();
            if (this.parent) this.parent.childPopup = null;
            if (this.element.parentNode) this.element.parentNode.removeChild(this.element);
            this.visible = false;
            if (this.blurCallback && !silent) this.blurCallback();
            this.unsubscribe("table-destroy", this.destroyBinding);
        }
        return this;
    }
    child(element) {
        if (this.childPopup) this.childPopup.hide();
        this.childPopup = new Popup(this.table, element, this);
        return this.childPopup;
    }
};
class $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed extends $c2a9788f40f9c90a$var$CoreFeature {
    constructor(table, name){
        super(table);
        this._handler = null;
    }
    initialize() {
    // setup module when table is initialized, to be overridden in module
    }
    ///////////////////////////////////
    ////// Options Registration ///////
    ///////////////////////////////////
    registerTableOption(key, value) {
        this.table.optionsList.register(key, value);
    }
    registerColumnOption(key, value) {
        this.table.columnManager.optionsList.register(key, value);
    }
    ///////////////////////////////////
    /// Public Function Registration ///
    ///////////////////////////////////
    registerTableFunction(name, func) {
        if (typeof this.table[name] === "undefined") this.table[name] = (...args)=>{
            this.table.initGuard(name);
            return func(...args);
        };
        else console.warn("Unable to bind table function, name already in use", name);
    }
    registerComponentFunction(component, func, handler) {
        return this.table.componentFunctionBinder.bind(component, func, handler);
    }
    ///////////////////////////////////
    ////////// Data Pipeline //////////
    ///////////////////////////////////
    registerDataHandler(handler, priority) {
        this.table.rowManager.registerDataPipelineHandler(handler, priority);
        this._handler = handler;
    }
    registerDisplayHandler(handler, priority) {
        this.table.rowManager.registerDisplayPipelineHandler(handler, priority);
        this._handler = handler;
    }
    displayRows(adjust) {
        var index = this.table.rowManager.displayRows.length - 1, lookupIndex;
        if (this._handler) {
            lookupIndex = this.table.rowManager.displayPipeline.findIndex((item)=>{
                return item.handler === this._handler;
            });
            if (lookupIndex > -1) index = lookupIndex;
        }
        if (adjust) index = index + adjust;
        if (this._handler) {
            if (index > -1) return this.table.rowManager.getDisplayRows(index);
            else return this.activeRows();
        }
    }
    activeRows() {
        return this.table.rowManager.activeRows;
    }
    refreshData(renderInPosition, handler) {
        if (!handler) handler = this._handler;
        if (handler) this.table.rowManager.refreshActiveData(handler, false, renderInPosition);
    }
    ///////////////////////////////////
    //////// Footer Management ////////
    ///////////////////////////////////
    footerAppend(element) {
        return this.table.footerManager.append(element);
    }
    footerPrepend(element) {
        return this.table.footerManager.prepend(element);
    }
    footerRemove(element) {
        return this.table.footerManager.remove(element);
    }
    ///////////////////////////////////
    //////// Popups Management ////////
    ///////////////////////////////////
    popup(menuEl, menuContainer) {
        return new $c2a9788f40f9c90a$var$Popup$1(this.table, menuEl, menuContainer);
    }
    ///////////////////////////////////
    //////// Alert Management ////////
    ///////////////////////////////////
    alert(content, type) {
        return this.table.alertManager.alert(content, type);
    }
    clearAlert() {
        return this.table.alertManager.clear();
    }
}
var $c2a9788f40f9c90a$var$defaultAccessors = {
    rownum: function(value, data, type, params, column, row) {
        return row.getPosition();
    }
};
class $c2a9788f40f9c90a$export$bf9f5472bce61c69 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "accessor";
    //load defaults
    static accessors = $c2a9788f40f9c90a$var$defaultAccessors;
    constructor(table){
        super(table);
        this.allowedTypes = [
            "",
            "data",
            "download",
            "clipboard",
            "print",
            "htmlOutput"
        ]; //list of accessor types
        this.registerColumnOption("accessor");
        this.registerColumnOption("accessorParams");
        this.registerColumnOption("accessorData");
        this.registerColumnOption("accessorDataParams");
        this.registerColumnOption("accessorDownload");
        this.registerColumnOption("accessorDownloadParams");
        this.registerColumnOption("accessorClipboard");
        this.registerColumnOption("accessorClipboardParams");
        this.registerColumnOption("accessorPrint");
        this.registerColumnOption("accessorPrintParams");
        this.registerColumnOption("accessorHtmlOutput");
        this.registerColumnOption("accessorHtmlOutputParams");
    }
    initialize() {
        this.subscribe("column-layout", this.initializeColumn.bind(this));
        this.subscribe("row-data-retrieve", this.transformRow.bind(this));
    }
    //initialize column accessor
    initializeColumn(column) {
        var match = false, config = {};
        this.allowedTypes.forEach((type)=>{
            var key = "accessor" + (type.charAt(0).toUpperCase() + type.slice(1)), accessor;
            if (column.definition[key]) {
                accessor = this.lookupAccessor(column.definition[key]);
                if (accessor) {
                    match = true;
                    config[key] = {
                        accessor: accessor,
                        params: column.definition[key + "Params"] || {}
                    };
                }
            }
        });
        if (match) column.modules.accessor = config;
    }
    lookupAccessor(value) {
        var accessor = false;
        //set column accessor
        switch(typeof value){
            case "string":
                if ($c2a9788f40f9c90a$export$bf9f5472bce61c69.accessors[value]) accessor = $c2a9788f40f9c90a$export$bf9f5472bce61c69.accessors[value];
                else console.warn("Accessor Error - No such accessor found, ignoring: ", value);
                break;
            case "function":
                accessor = value;
                break;
        }
        return accessor;
    }
    //apply accessor to row
    transformRow(row, type) {
        var key = "accessor" + (type.charAt(0).toUpperCase() + type.slice(1)), rowComponent = row.getComponent();
        //clone data object with deep copy to isolate internal data from returned result
        var data = $c2a9788f40f9c90a$var$Helpers.deepClone(row.data || {});
        this.table.columnManager.traverse(function(column) {
            var value, accessor, params, colComponent;
            if (column.modules.accessor) {
                accessor = column.modules.accessor[key] || column.modules.accessor.accessor || false;
                if (accessor) {
                    value = column.getFieldValue(data);
                    if (value != "undefined") {
                        colComponent = column.getComponent();
                        params = typeof accessor.params === "function" ? accessor.params(value, data, type, colComponent, rowComponent) : accessor.params;
                        column.setFieldValue(data, accessor.accessor(value, data, type, params, colComponent, rowComponent));
                    }
                }
            }
        });
        return data;
    }
}
var $c2a9788f40f9c90a$var$defaultConfig = {
    method: "GET"
};
function $c2a9788f40f9c90a$var$generateParamsList$1(data, prefix) {
    var output = [];
    prefix = prefix || "";
    if (Array.isArray(data)) data.forEach((item, i)=>{
        output = output.concat($c2a9788f40f9c90a$var$generateParamsList$1(item, prefix ? prefix + "[" + i + "]" : i));
    });
    else if (typeof data === "object") for(var key in data)output = output.concat($c2a9788f40f9c90a$var$generateParamsList$1(data[key], prefix ? prefix + "[" + key + "]" : key));
    else output.push({
        key: prefix,
        value: data
    });
    return output;
}
function $c2a9788f40f9c90a$var$serializeParams(params) {
    var output = $c2a9788f40f9c90a$var$generateParamsList$1(params), encoded = [];
    output.forEach(function(item) {
        encoded.push(encodeURIComponent(item.key) + "=" + encodeURIComponent(item.value));
    });
    return encoded.join("&");
}
function $c2a9788f40f9c90a$var$urlBuilder(url, config, params) {
    if (url) {
        if (params && Object.keys(params).length) {
            if (!config.method || config.method.toLowerCase() == "get") {
                config.method = "get";
                url += (url.includes("?") ? "&" : "?") + $c2a9788f40f9c90a$var$serializeParams(params);
            }
        }
    }
    return url;
}
function $c2a9788f40f9c90a$var$defaultLoaderPromise(url, config, params) {
    var contentType;
    return new Promise((resolve, reject)=>{
        //set url
        url = this.urlGenerator.call(this.table, url, config, params);
        //set body content if not GET request
        if (config.method.toUpperCase() != "GET") {
            contentType = typeof this.table.options.ajaxContentType === "object" ? this.table.options.ajaxContentType : this.contentTypeFormatters[this.table.options.ajaxContentType];
            if (contentType) {
                for(var key in contentType.headers){
                    if (!config.headers) config.headers = {};
                    if (typeof config.headers[key] === "undefined") config.headers[key] = contentType.headers[key];
                }
                config.body = contentType.body.call(this, url, config, params);
            } else console.warn("Ajax Error - Invalid ajaxContentType value:", this.table.options.ajaxContentType);
        }
        if (url) {
            //configure headers
            if (typeof config.headers === "undefined") config.headers = {};
            if (typeof config.headers.Accept === "undefined") config.headers.Accept = "application/json";
            if (typeof config.headers["X-Requested-With"] === "undefined") config.headers["X-Requested-With"] = "XMLHttpRequest";
            if (typeof config.mode === "undefined") config.mode = "cors";
            if (config.mode == "cors") {
                if (typeof config.headers["Origin"] === "undefined") config.headers["Origin"] = window.location.origin;
                if (typeof config.credentials === "undefined") config.credentials = 'same-origin';
            } else if (typeof config.credentials === "undefined") config.credentials = 'include';
            //send request
            fetch(url, config).then((response)=>{
                if (response.ok) response.json().then((data)=>{
                    resolve(data);
                }).catch((error)=>{
                    reject(error);
                    console.warn("Ajax Load Error - Invalid JSON returned", error);
                });
                else {
                    console.error("Ajax Load Error - Connection Error: " + response.status, response.statusText);
                    reject(response);
                }
            }).catch((error)=>{
                console.error("Ajax Load Error - Connection Error: ", error);
                reject(error);
            });
        } else {
            console.warn("Ajax Load Error - No URL Set");
            resolve([]);
        }
    });
}
function $c2a9788f40f9c90a$var$generateParamsList(data, prefix) {
    var output = [];
    prefix = prefix || "";
    if (Array.isArray(data)) data.forEach((item, i)=>{
        output = output.concat($c2a9788f40f9c90a$var$generateParamsList(item, prefix ? prefix + "[" + i + "]" : i));
    });
    else if (typeof data === "object") for(var key in data)output = output.concat($c2a9788f40f9c90a$var$generateParamsList(data[key], prefix ? prefix + "[" + key + "]" : key));
    else output.push({
        key: prefix,
        value: data
    });
    return output;
}
var $c2a9788f40f9c90a$var$defaultContentTypeFormatters = {
    "json": {
        headers: {
            'Content-Type': 'application/json'
        },
        body: function(url, config, params) {
            return JSON.stringify(params);
        }
    },
    "form": {
        headers: {},
        body: function(url, config, params) {
            var output = $c2a9788f40f9c90a$var$generateParamsList(params), form = new FormData();
            output.forEach(function(item) {
                form.append(item.key, item.value);
            });
            return form;
        }
    }
};
class $c2a9788f40f9c90a$export$b25c9f93be571d3a extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "ajax";
    //load defaults
    static defaultConfig = $c2a9788f40f9c90a$var$defaultConfig;
    static defaultURLGenerator = $c2a9788f40f9c90a$var$urlBuilder;
    static defaultLoaderPromise = $c2a9788f40f9c90a$var$defaultLoaderPromise;
    static contentTypeFormatters = $c2a9788f40f9c90a$var$defaultContentTypeFormatters;
    constructor(table){
        super(table);
        this.config = {}; //hold config object for ajax request
        this.url = ""; //request URL
        this.urlGenerator = false;
        this.params = false; //request parameters
        this.loaderPromise = false;
        this.registerTableOption("ajaxURL", false); //url for ajax loading
        this.registerTableOption("ajaxURLGenerator", false);
        this.registerTableOption("ajaxParams", {}); //params for ajax loading
        this.registerTableOption("ajaxConfig", "get"); //ajax request type
        this.registerTableOption("ajaxContentType", "form"); //ajax request type
        this.registerTableOption("ajaxRequestFunc", false); //promise function
        this.registerTableOption("ajaxRequesting", function() {});
        this.registerTableOption("ajaxResponse", false);
        this.contentTypeFormatters = $c2a9788f40f9c90a$export$b25c9f93be571d3a.contentTypeFormatters;
    }
    //initialize setup options
    initialize() {
        this.loaderPromise = this.table.options.ajaxRequestFunc || $c2a9788f40f9c90a$export$b25c9f93be571d3a.defaultLoaderPromise;
        this.urlGenerator = this.table.options.ajaxURLGenerator || $c2a9788f40f9c90a$export$b25c9f93be571d3a.defaultURLGenerator;
        if (this.table.options.ajaxURL) this.setUrl(this.table.options.ajaxURL);
        this.setDefaultConfig(this.table.options.ajaxConfig);
        this.registerTableFunction("getAjaxUrl", this.getUrl.bind(this));
        this.subscribe("data-loading", this.requestDataCheck.bind(this));
        this.subscribe("data-params", this.requestParams.bind(this));
        this.subscribe("data-load", this.requestData.bind(this));
    }
    requestParams(data, config, silent, params) {
        var ajaxParams = this.table.options.ajaxParams;
        if (ajaxParams) {
            if (typeof ajaxParams === "function") ajaxParams = ajaxParams.call(this.table);
            params = Object.assign(Object.assign({}, ajaxParams), params);
        }
        return params;
    }
    requestDataCheck(data, params, config, silent) {
        return !!(!data && this.url || typeof data === "string");
    }
    requestData(url, params, config, silent, previousData) {
        var ajaxConfig;
        if (!previousData && this.requestDataCheck(url)) {
            if (url) this.setUrl(url);
            ajaxConfig = this.generateConfig(config);
            return this.sendRequest(this.url, params, ajaxConfig);
        } else return previousData;
    }
    setDefaultConfig(config = {}) {
        this.config = Object.assign({}, $c2a9788f40f9c90a$export$b25c9f93be571d3a.defaultConfig);
        if (typeof config == "string") this.config.method = config;
        else Object.assign(this.config, config);
    }
    //load config object
    generateConfig(config = {}) {
        var ajaxConfig = Object.assign({}, this.config);
        if (typeof config == "string") ajaxConfig.method = config;
        else Object.assign(ajaxConfig, config);
        return ajaxConfig;
    }
    //set request url
    setUrl(url) {
        this.url = url;
    }
    //get request url
    getUrl() {
        return this.url;
    }
    //send ajax request
    sendRequest(url, params, config) {
        if (this.table.options.ajaxRequesting.call(this.table, url, params) !== false) return this.loaderPromise(url, config, params).then((data)=>{
            if (this.table.options.ajaxResponse) data = this.table.options.ajaxResponse.call(this.table, url, params, data);
            return data;
        });
        else return Promise.reject();
    }
}
var $c2a9788f40f9c90a$var$defaultPasteActions = {
    replace: function(data) {
        return this.table.setData(data);
    },
    update: function(data) {
        return this.table.updateOrAddData(data);
    },
    insert: function(data) {
        return this.table.addData(data);
    }
};
var $c2a9788f40f9c90a$var$defaultPasteParsers = {
    table: function(clipboard) {
        var data = [], headerFindSuccess = true, columns = this.table.columnManager.columns, columnMap = [], rows = [];
        //get data from clipboard into array of columns and rows.
        clipboard = clipboard.split("\n");
        clipboard.forEach(function(row) {
            data.push(row.split("\t"));
        });
        if (data.length && !(data.length === 1 && data[0].length < 2)) {
            //check if headers are present by title
            data[0].forEach(function(value) {
                var column = columns.find(function(column) {
                    return value && column.definition.title && value.trim() && column.definition.title.trim() === value.trim();
                });
                if (column) columnMap.push(column);
                else headerFindSuccess = false;
            });
            //check if column headers are present by field
            if (!headerFindSuccess) {
                headerFindSuccess = true;
                columnMap = [];
                data[0].forEach(function(value) {
                    var column = columns.find(function(column) {
                        return value && column.field && value.trim() && column.field.trim() === value.trim();
                    });
                    if (column) columnMap.push(column);
                    else headerFindSuccess = false;
                });
                if (!headerFindSuccess) columnMap = this.table.columnManager.columnsByIndex;
            }
            //remove header row if found
            if (headerFindSuccess) data.shift();
            data.forEach(function(item) {
                var row = {};
                item.forEach(function(value, i) {
                    if (columnMap[i]) row[columnMap[i].field] = value;
                });
                rows.push(row);
            });
            return rows;
        } else return false;
    }
};
var $c2a9788f40f9c90a$var$bindings$2 = {
    copyToClipboard: [
        "ctrl + 67",
        "meta + 67"
    ]
};
var $c2a9788f40f9c90a$var$actions$2 = {
    copyToClipboard: function(e) {
        if (!this.table.modules.edit.currentCell) {
            if (this.table.modExists("clipboard", true)) this.table.modules.clipboard.copy(false, true);
        }
    }
};
var $c2a9788f40f9c90a$var$extensions$4 = {
    keybindings: {
        bindings: $c2a9788f40f9c90a$var$bindings$2,
        actions: $c2a9788f40f9c90a$var$actions$2
    }
};
class $c2a9788f40f9c90a$export$3a36bd45ca02edda extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "clipboard";
    static moduleExtensions = $c2a9788f40f9c90a$var$extensions$4;
    //load defaults
    static pasteActions = $c2a9788f40f9c90a$var$defaultPasteActions;
    static pasteParsers = $c2a9788f40f9c90a$var$defaultPasteParsers;
    constructor(table){
        super(table);
        this.mode = true;
        this.pasteParser = function() {};
        this.pasteAction = function() {};
        this.customSelection = false;
        this.rowRange = false;
        this.blocked = true; //block copy actions not originating from this command
        this.registerTableOption("clipboard", false); //enable clipboard
        this.registerTableOption("clipboardCopyStyled", true); //formatted table data
        this.registerTableOption("clipboardCopyConfig", false); //clipboard config
        this.registerTableOption("clipboardCopyFormatter", false); //DEPRECATED - REMOVE in 5.0
        this.registerTableOption("clipboardCopyRowRange", "active"); //restrict clipboard to visible rows only
        this.registerTableOption("clipboardPasteParser", "table"); //convert pasted clipboard data to rows
        this.registerTableOption("clipboardPasteAction", "insert"); //how to insert pasted data into the table
        this.registerColumnOption("clipboard");
        this.registerColumnOption("titleClipboard");
    }
    initialize() {
        this.mode = this.table.options.clipboard;
        this.rowRange = this.table.options.clipboardCopyRowRange;
        if (this.mode === true || this.mode === "copy") this.table.element.addEventListener("copy", (e)=>{
            var plain, html, list;
            if (!this.blocked) {
                e.preventDefault();
                if (this.customSelection) {
                    plain = this.customSelection;
                    if (this.table.options.clipboardCopyFormatter) plain = this.table.options.clipboardCopyFormatter("plain", plain);
                } else {
                    list = this.table.modules.export.generateExportList(this.table.options.clipboardCopyConfig, this.table.options.clipboardCopyStyled, this.rowRange, "clipboard");
                    html = this.table.modules.export.generateHTMLTable(list);
                    plain = html ? this.generatePlainContent(list) : "";
                    if (this.table.options.clipboardCopyFormatter) {
                        plain = this.table.options.clipboardCopyFormatter("plain", plain);
                        html = this.table.options.clipboardCopyFormatter("html", html);
                    }
                }
                if (window.clipboardData && window.clipboardData.setData) window.clipboardData.setData('Text', plain);
                else if (e.clipboardData && e.clipboardData.setData) {
                    e.clipboardData.setData('text/plain', plain);
                    if (html) e.clipboardData.setData('text/html', html);
                } else if (e.originalEvent && e.originalEvent.clipboardData.setData) {
                    e.originalEvent.clipboardData.setData('text/plain', plain);
                    if (html) e.originalEvent.clipboardData.setData('text/html', html);
                }
                this.dispatchExternal("clipboardCopied", plain, html);
                this.reset();
            }
        });
        if (this.mode === true || this.mode === "paste") this.table.element.addEventListener("paste", (e)=>{
            this.paste(e);
        });
        this.setPasteParser(this.table.options.clipboardPasteParser);
        this.setPasteAction(this.table.options.clipboardPasteAction);
        this.registerTableFunction("copyToClipboard", this.copy.bind(this));
    }
    reset() {
        this.blocked = true;
        this.customSelection = false;
    }
    generatePlainContent(list) {
        var output = [];
        list.forEach((row)=>{
            var rowData = [];
            row.columns.forEach((col)=>{
                var value = "";
                if (col) {
                    if (row.type === "group") col.value = col.component.getKey();
                    if (col.value === null) value = "";
                    else switch(typeof col.value){
                        case "object":
                            value = JSON.stringify(col.value);
                            break;
                        case "undefined":
                            value = "";
                            break;
                        default:
                            value = col.value;
                    }
                }
                rowData.push(value);
            });
            output.push(rowData.join("\t"));
        });
        return output.join("\n");
    }
    copy(range, internal) {
        var sel, textRange;
        this.blocked = false;
        this.customSelection = false;
        if (this.mode === true || this.mode === "copy") {
            this.rowRange = range || this.table.options.clipboardCopyRowRange;
            if (typeof window.getSelection != "undefined" && typeof document.createRange != "undefined") {
                range = document.createRange();
                range.selectNodeContents(this.table.element);
                sel = window.getSelection();
                if (sel.toString() && internal) this.customSelection = sel.toString();
                sel.removeAllRanges();
                sel.addRange(range);
            } else if (typeof document.selection != "undefined" && typeof document.body.createTextRange != "undefined") {
                textRange = document.body.createTextRange();
                textRange.moveToElementText(this.table.element);
                textRange.select();
            }
            document.execCommand('copy');
            if (sel) sel.removeAllRanges();
        }
    }
    //PASTE EVENT HANDLING
    setPasteAction(action) {
        switch(typeof action){
            case "string":
                this.pasteAction = $c2a9788f40f9c90a$export$3a36bd45ca02edda.pasteActions[action];
                if (!this.pasteAction) console.warn("Clipboard Error - No such paste action found:", action);
                break;
            case "function":
                this.pasteAction = action;
                break;
        }
    }
    setPasteParser(parser) {
        switch(typeof parser){
            case "string":
                this.pasteParser = $c2a9788f40f9c90a$export$3a36bd45ca02edda.pasteParsers[parser];
                if (!this.pasteParser) console.warn("Clipboard Error - No such paste parser found:", parser);
                break;
            case "function":
                this.pasteParser = parser;
                break;
        }
    }
    paste(e) {
        var data, rowData, rows;
        if (this.checkPasteOrigin(e)) {
            data = this.getPasteData(e);
            rowData = this.pasteParser.call(this, data);
            if (rowData) {
                e.preventDefault();
                if (this.table.modExists("mutator")) rowData = this.mutateData(rowData);
                rows = this.pasteAction.call(this, rowData);
                this.dispatchExternal("clipboardPasted", data, rowData, rows);
            } else this.dispatchExternal("clipboardPasteError", data);
        }
    }
    mutateData(data) {
        var output = [];
        if (Array.isArray(data)) data.forEach((row)=>{
            output.push(this.table.modules.mutator.transformRow(row, "clipboard"));
        });
        else output = data;
        return output;
    }
    checkPasteOrigin(e) {
        var valid = true;
        var blocked = this.confirm("clipboard-paste", [
            e
        ]);
        if (blocked || ![
            "DIV",
            "SPAN"
        ].includes(e.target.tagName)) valid = false;
        return valid;
    }
    getPasteData(e) {
        var data;
        if (window.clipboardData && window.clipboardData.getData) data = window.clipboardData.getData('Text');
        else if (e.clipboardData && e.clipboardData.getData) data = e.clipboardData.getData('text/plain');
        else if (e.originalEvent && e.originalEvent.clipboardData.getData) data = e.originalEvent.clipboardData.getData('text/plain');
        return data;
    }
}
class $c2a9788f40f9c90a$export$3ef2519bf7055551 {
    constructor(row){
        this._row = row;
        return new Proxy(this, {
            get: function(target, name, receiver) {
                if (typeof target[name] !== "undefined") return target[name];
                else return target._row.table.componentFunctionBinder.handle("row", target._row, name);
            }
        });
    }
    getData(transform) {
        return this._row.getData(transform);
    }
    getElement() {
        return this._row.getElement();
    }
    getTable() {
        return this._row.table;
    }
    getCells() {
        var cells = [];
        this._row.getCells().forEach(function(cell) {
            cells.push(cell.getComponent());
        });
        return cells;
    }
    getCell(column) {
        var cell = this._row.getCell(column);
        return cell ? cell.getComponent() : false;
    }
    _getSelf() {
        return this._row;
    }
}
//public cell object
class $c2a9788f40f9c90a$export$1919f52c249c72c9 {
    constructor(cell){
        this._cell = cell;
        return new Proxy(this, {
            get: function(target, name, receiver) {
                if (typeof target[name] !== "undefined") return target[name];
                else return target._cell.table.componentFunctionBinder.handle("cell", target._cell, name);
            }
        });
    }
    getValue() {
        return this._cell.getValue();
    }
    getOldValue() {
        return this._cell.getOldValue();
    }
    getInitialValue() {
        return this._cell.initialValue;
    }
    getElement() {
        return this._cell.getElement();
    }
    getRow() {
        return this._cell.row.getComponent();
    }
    getData(transform) {
        return this._cell.row.getData(transform);
    }
    getType() {
        return "cell";
    }
    getField() {
        return this._cell.column.getField();
    }
    getColumn() {
        return this._cell.column.getComponent();
    }
    setValue(value, mutate) {
        if (typeof mutate == "undefined") mutate = true;
        this._cell.setValue(value, mutate);
    }
    restoreOldValue() {
        this._cell.setValueActual(this._cell.getOldValue());
    }
    restoreInitialValue() {
        this._cell.setValueActual(this._cell.initialValue);
    }
    checkHeight() {
        this._cell.checkHeight();
    }
    getTable() {
        return this._cell.table;
    }
    _getSelf() {
        return this._cell;
    }
}
class $c2a9788f40f9c90a$var$Cell extends $c2a9788f40f9c90a$var$CoreFeature {
    constructor(column, row){
        super(column.table);
        this.table = column.table;
        this.column = column;
        this.row = row;
        this.element = null;
        this.value = null;
        this.initialValue;
        this.oldValue = null;
        this.modules = {};
        this.height = null;
        this.width = null;
        this.minWidth = null;
        this.component = null;
        this.loaded = false; //track if the cell has been added to the DOM yet
        this.build();
    }
    //////////////// Setup Functions /////////////////
    //generate element
    build() {
        this.generateElement();
        this.setWidth();
        this._configureCell();
        this.setValueActual(this.column.getFieldValue(this.row.data));
        this.initialValue = this.value;
    }
    generateElement() {
        this.element = document.createElement('div');
        this.element.className = "tabulator-cell";
        this.element.setAttribute("role", "gridcell");
        if (this.column.isRowHeader) this.element.classList.add("tabulator-row-header");
    }
    _configureCell() {
        var element = this.element, field = this.column.getField(), vertAligns = {
            top: "flex-start",
            bottom: "flex-end",
            middle: "center"
        }, hozAligns = {
            left: "flex-start",
            right: "flex-end",
            center: "center"
        };
        //set text alignment
        element.style.textAlign = this.column.hozAlign;
        if (this.column.vertAlign) {
            element.style.display = "inline-flex";
            element.style.alignItems = vertAligns[this.column.vertAlign] || "";
            if (this.column.hozAlign) element.style.justifyContent = hozAligns[this.column.hozAlign] || "";
        }
        if (field) element.setAttribute("tabulator-field", field);
        //add class to cell if needed
        if (this.column.definition.cssClass) {
            var classNames = this.column.definition.cssClass.split(" ");
            classNames.forEach((className)=>{
                element.classList.add(className);
            });
        }
        this.dispatch("cell-init", this);
        //hide cell if not visible
        if (!this.column.visible) this.hide();
    }
    //generate cell contents
    _generateContents() {
        var val;
        val = this.chain("cell-format", this, null, ()=>{
            return this.element.innerHTML = this.value;
        });
        switch(typeof val){
            case "object":
                if (val instanceof Node) {
                    //clear previous cell contents
                    while(this.element.firstChild)this.element.removeChild(this.element.firstChild);
                    this.element.appendChild(val);
                } else {
                    this.element.innerHTML = "";
                    if (val != null) console.warn("Format Error - Formatter has returned a type of object, the only valid formatter object return is an instance of Node, the formatter returned:", val);
                }
                break;
            case "undefined":
                this.element.innerHTML = "";
                break;
            default:
                this.element.innerHTML = val;
        }
    }
    cellRendered() {
        this.dispatch("cell-rendered", this);
    }
    //////////////////// Getters ////////////////////
    getElement(containerOnly) {
        if (!this.loaded) {
            this.loaded = true;
            if (!containerOnly) this.layoutElement();
        }
        return this.element;
    }
    getValue() {
        return this.value;
    }
    getOldValue() {
        return this.oldValue;
    }
    //////////////////// Actions ////////////////////
    setValue(value, mutate, force) {
        var changed = this.setValueProcessData(value, mutate, force);
        if (changed) {
            this.dispatch("cell-value-updated", this);
            this.cellRendered();
            if (this.column.definition.cellEdited) this.column.definition.cellEdited.call(this.table, this.getComponent());
            this.dispatchExternal("cellEdited", this.getComponent());
            if (this.subscribedExternal("dataChanged")) this.dispatchExternal("dataChanged", this.table.rowManager.getData());
        }
    }
    setValueProcessData(value, mutate, force) {
        var changed = false;
        if (this.value !== value || force) {
            changed = true;
            if (mutate) value = this.chain("cell-value-changing", [
                this,
                value
            ], null, value);
        }
        this.setValueActual(value);
        if (changed) this.dispatch("cell-value-changed", this);
        return changed;
    }
    setValueActual(value) {
        this.oldValue = this.value;
        this.value = value;
        this.dispatch("cell-value-save-before", this);
        this.column.setFieldValue(this.row.data, value);
        this.dispatch("cell-value-save-after", this);
        if (this.loaded) this.layoutElement();
    }
    layoutElement() {
        this._generateContents();
        this.dispatch("cell-layout", this);
    }
    setWidth() {
        this.width = this.column.width;
        this.element.style.width = this.column.widthStyled;
    }
    clearWidth() {
        this.width = "";
        this.element.style.width = "";
    }
    getWidth() {
        return this.width || this.element.offsetWidth;
    }
    setMinWidth() {
        this.minWidth = this.column.minWidth;
        this.element.style.minWidth = this.column.minWidthStyled;
    }
    setMaxWidth() {
        this.maxWidth = this.column.maxWidth;
        this.element.style.maxWidth = this.column.maxWidthStyled;
    }
    checkHeight() {
        // var height = this.element.css("height");
        this.row.reinitializeHeight();
    }
    clearHeight() {
        this.element.style.height = "";
        this.height = null;
        this.dispatch("cell-height", this, "");
    }
    setHeight() {
        this.height = this.row.height;
        this.element.style.height = this.row.heightStyled;
        this.dispatch("cell-height", this, this.row.heightStyled);
    }
    getHeight() {
        return this.height || this.element.offsetHeight;
    }
    show() {
        this.element.style.display = this.column.vertAlign ? "inline-flex" : "";
    }
    hide() {
        this.element.style.display = "none";
    }
    delete() {
        this.dispatch("cell-delete", this);
        if (!this.table.rowManager.redrawBlock && this.element.parentNode) this.element.parentNode.removeChild(this.element);
        this.element = false;
        this.column.deleteCell(this);
        this.row.deleteCell(this);
        this.calcs = {};
    }
    getIndex() {
        return this.row.getCellIndex(this);
    }
    //////////////// Object Generation /////////////////
    getComponent() {
        if (!this.component) this.component = new $c2a9788f40f9c90a$export$1919f52c249c72c9(this);
        return this.component;
    }
}
//public column object
class $c2a9788f40f9c90a$export$11bb209ad3a8e411 {
    constructor(column){
        this._column = column;
        this.type = "ColumnComponent";
        return new Proxy(this, {
            get: function(target, name, receiver) {
                if (typeof target[name] !== "undefined") return target[name];
                else return target._column.table.componentFunctionBinder.handle("column", target._column, name);
            }
        });
    }
    getElement() {
        return this._column.getElement();
    }
    getDefinition() {
        return this._column.getDefinition();
    }
    getField() {
        return this._column.getField();
    }
    getTitleDownload() {
        return this._column.getTitleDownload();
    }
    getCells() {
        var cells = [];
        this._column.cells.forEach(function(cell) {
            cells.push(cell.getComponent());
        });
        return cells;
    }
    isVisible() {
        return this._column.visible;
    }
    show() {
        if (this._column.isGroup) this._column.columns.forEach(function(column) {
            column.show();
        });
        else this._column.show();
    }
    hide() {
        if (this._column.isGroup) this._column.columns.forEach(function(column) {
            column.hide();
        });
        else this._column.hide();
    }
    toggle() {
        if (this._column.visible) this.hide();
        else this.show();
    }
    delete() {
        return this._column.delete();
    }
    getSubColumns() {
        var output = [];
        if (this._column.columns.length) this._column.columns.forEach(function(column) {
            output.push(column.getComponent());
        });
        return output;
    }
    getParentColumn() {
        return this._column.getParentComponent();
    }
    _getSelf() {
        return this._column;
    }
    scrollTo(position, ifVisible) {
        return this._column.table.columnManager.scrollToColumn(this._column, position, ifVisible);
    }
    getTable() {
        return this._column.table;
    }
    move(to, after) {
        var toColumn = this._column.table.columnManager.findColumn(to);
        if (toColumn) this._column.table.columnManager.moveColumn(this._column, toColumn, after);
        else console.warn("Move Error - No matching column found:", toColumn);
    }
    getNextColumn() {
        var nextCol = this._column.nextColumn();
        return nextCol ? nextCol.getComponent() : false;
    }
    getPrevColumn() {
        var prevCol = this._column.prevColumn();
        return prevCol ? prevCol.getComponent() : false;
    }
    updateDefinition(updates) {
        return this._column.updateDefinition(updates);
    }
    getWidth() {
        return this._column.getWidth();
    }
    setWidth(width) {
        var result;
        if (width === true) result = this._column.reinitializeWidth(true);
        else result = this._column.setWidth(width);
        this._column.table.columnManager.rerenderColumns(true);
        return result;
    }
}
var $c2a9788f40f9c90a$var$defaultColumnOptions = {
    "title": undefined,
    "field": undefined,
    "columns": undefined,
    "visible": undefined,
    "hozAlign": undefined,
    "vertAlign": undefined,
    "width": undefined,
    "minWidth": 40,
    "maxWidth": undefined,
    "maxInitialWidth": undefined,
    "cssClass": undefined,
    "variableHeight": undefined,
    "headerVertical": undefined,
    "headerHozAlign": undefined,
    "headerWordWrap": false,
    "editableTitle": undefined
};
class $c2a9788f40f9c90a$var$Column extends $c2a9788f40f9c90a$var$CoreFeature {
    static defaultOptionList = $c2a9788f40f9c90a$var$defaultColumnOptions;
    constructor(def, parent, rowHeader){
        super(parent.table);
        this.definition = def; //column definition
        this.parent = parent; //hold parent object
        this.type = "column"; //type of element
        this.columns = []; //child columns
        this.cells = []; //cells bound to this column
        this.isGroup = false;
        this.isRowHeader = rowHeader;
        this.element = this.createElement(); //column header element
        this.contentElement = false;
        this.titleHolderElement = false;
        this.titleElement = false;
        this.groupElement = this.createGroupElement(); //column group holder element
        this.hozAlign = ""; //horizontal text alignment
        this.vertAlign = ""; //vert text alignment
        //multi dimensional filed handling
        this.field = "";
        this.fieldStructure = "";
        this.getFieldValue = "";
        this.setFieldValue = "";
        this.titleDownload = null;
        this.titleFormatterRendered = false;
        this.mapDefinitions();
        this.setField(this.definition.field);
        this.modules = {}; //hold module variables;
        this.width = null; //column width
        this.widthStyled = ""; //column width pre-styled to improve render efficiency
        this.maxWidth = null; //column maximum width
        this.maxWidthStyled = ""; //column maximum pre-styled to improve render efficiency
        this.maxInitialWidth = null;
        this.minWidth = null; //column minimum width
        this.minWidthStyled = ""; //column minimum pre-styled to improve render efficiency
        this.widthFixed = false; //user has specified a width for this column
        this.visible = true; //default visible state
        this.component = null;
        //initialize column
        if (this.definition.columns) {
            this.isGroup = true;
            this.definition.columns.forEach((def, i)=>{
                var newCol = new $c2a9788f40f9c90a$var$Column(def, this);
                this.attachColumn(newCol);
            });
            this.checkColumnVisibility();
        } else parent.registerColumnField(this);
        this._initialize();
    }
    createElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-col");
        el.setAttribute("role", "columnheader");
        el.setAttribute("aria-sort", "none");
        if (this.isRowHeader) el.classList.add("tabulator-row-header");
        switch(this.table.options.columnHeaderVertAlign){
            case "middle":
                el.style.justifyContent = "center";
                break;
            case "bottom":
                el.style.justifyContent = "flex-end";
                break;
        }
        return el;
    }
    createGroupElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-col-group-cols");
        return el;
    }
    mapDefinitions() {
        var defaults = this.table.options.columnDefaults;
        //map columnDefaults onto column definitions
        if (defaults) {
            for(let key in defaults)if (typeof this.definition[key] === "undefined") this.definition[key] = defaults[key];
        }
        this.definition = this.table.columnManager.optionsList.generate($c2a9788f40f9c90a$var$Column.defaultOptionList, this.definition);
    }
    checkDefinition() {
        Object.keys(this.definition).forEach((key)=>{
            if ($c2a9788f40f9c90a$var$Column.defaultOptionList.indexOf(key) === -1) console.warn("Invalid column definition option in '" + (this.field || this.definition.title) + "' column:", key);
        });
    }
    setField(field) {
        this.field = field;
        this.fieldStructure = field ? this.table.options.nestedFieldSeparator ? field.split(this.table.options.nestedFieldSeparator) : [
            field
        ] : [];
        this.getFieldValue = this.fieldStructure.length > 1 ? this._getNestedData : this._getFlatData;
        this.setFieldValue = this.fieldStructure.length > 1 ? this._setNestedData : this._setFlatData;
    }
    //register column position with column manager
    registerColumnPosition(column) {
        this.parent.registerColumnPosition(column);
    }
    //register column position with column manager
    registerColumnField(column) {
        this.parent.registerColumnField(column);
    }
    //trigger position registration
    reRegisterPosition() {
        if (this.isGroup) this.columns.forEach(function(column) {
            column.reRegisterPosition();
        });
        else this.registerColumnPosition(this);
    }
    //build header element
    _initialize() {
        var def = this.definition;
        while(this.element.firstChild)this.element.removeChild(this.element.firstChild);
        if (def.headerVertical) {
            this.element.classList.add("tabulator-col-vertical");
            if (def.headerVertical === "flip") this.element.classList.add("tabulator-col-vertical-flip");
        }
        this.contentElement = this._buildColumnHeaderContent();
        this.element.appendChild(this.contentElement);
        if (this.isGroup) this._buildGroupHeader();
        else this._buildColumnHeader();
        this.dispatch("column-init", this);
    }
    //build header element for header
    _buildColumnHeader() {
        var def = this.definition;
        this.dispatch("column-layout", this);
        //set column visibility
        if (typeof def.visible != "undefined") {
            if (def.visible) this.show(true);
            else this.hide(true);
        }
        //assign additional css classes to column header
        if (def.cssClass) {
            var classNames = def.cssClass.split(" ");
            classNames.forEach((className)=>{
                this.element.classList.add(className);
            });
        }
        if (def.field) this.element.setAttribute("tabulator-field", def.field);
        //set min width if present
        this.setMinWidth(parseInt(def.minWidth));
        if (def.maxInitialWidth) this.maxInitialWidth = parseInt(def.maxInitialWidth);
        if (def.maxWidth) this.setMaxWidth(parseInt(def.maxWidth));
        this.reinitializeWidth();
        //set horizontal text alignment
        this.hozAlign = this.definition.hozAlign;
        this.vertAlign = this.definition.vertAlign;
        this.titleElement.style.textAlign = this.definition.headerHozAlign;
    }
    _buildColumnHeaderContent() {
        var contentElement = document.createElement("div");
        contentElement.classList.add("tabulator-col-content");
        this.titleHolderElement = document.createElement("div");
        this.titleHolderElement.classList.add("tabulator-col-title-holder");
        contentElement.appendChild(this.titleHolderElement);
        this.titleElement = this._buildColumnHeaderTitle();
        this.titleHolderElement.appendChild(this.titleElement);
        return contentElement;
    }
    //build title element of column
    _buildColumnHeaderTitle() {
        var def = this.definition;
        var titleHolderElement = document.createElement("div");
        titleHolderElement.classList.add("tabulator-col-title");
        if (def.headerWordWrap) titleHolderElement.classList.add("tabulator-col-title-wrap");
        if (def.editableTitle) {
            var titleElement = document.createElement("input");
            titleElement.classList.add("tabulator-title-editor");
            titleElement.addEventListener("click", (e)=>{
                e.stopPropagation();
                titleElement.focus();
            });
            titleElement.addEventListener("mousedown", (e)=>{
                e.stopPropagation();
            });
            titleElement.addEventListener("change", ()=>{
                def.title = titleElement.value;
                this.dispatchExternal("columnTitleChanged", this.getComponent());
            });
            titleHolderElement.appendChild(titleElement);
            if (def.field) this.langBind("columns|" + def.field, (text)=>{
                titleElement.value = text || def.title || "&nbsp;";
            });
            else titleElement.value = def.title || "&nbsp;";
        } else if (def.field) this.langBind("columns|" + def.field, (text)=>{
            this._formatColumnHeaderTitle(titleHolderElement, text || def.title || "&nbsp;");
        });
        else this._formatColumnHeaderTitle(titleHolderElement, def.title || "&nbsp;");
        return titleHolderElement;
    }
    _formatColumnHeaderTitle(el, title) {
        var contents = this.chain("column-format", [
            this,
            title,
            el
        ], null, ()=>{
            return title;
        });
        switch(typeof contents){
            case "object":
                if (contents instanceof Node) el.appendChild(contents);
                else {
                    el.innerHTML = "";
                    console.warn("Format Error - Title formatter has returned a type of object, the only valid formatter object return is an instance of Node, the formatter returned:", contents);
                }
                break;
            case "undefined":
                el.innerHTML = "";
                break;
            default:
                el.innerHTML = contents;
        }
    }
    //build header element for column group
    _buildGroupHeader() {
        this.element.classList.add("tabulator-col-group");
        this.element.setAttribute("role", "columngroup");
        this.element.setAttribute("aria-title", this.definition.title);
        //asign additional css classes to column header
        if (this.definition.cssClass) {
            var classNames = this.definition.cssClass.split(" ");
            classNames.forEach((className)=>{
                this.element.classList.add(className);
            });
        }
        this.titleElement.style.textAlign = this.definition.headerHozAlign;
        this.element.appendChild(this.groupElement);
    }
    //flat field lookup
    _getFlatData(data) {
        return data[this.field];
    }
    //nested field lookup
    _getNestedData(data) {
        var dataObj = data, structure = this.fieldStructure, length = structure.length, output;
        for(let i = 0; i < length; i++){
            dataObj = dataObj[structure[i]];
            output = dataObj;
            if (!dataObj) break;
        }
        return output;
    }
    //flat field set
    _setFlatData(data, value) {
        if (this.field) data[this.field] = value;
    }
    //nested field set
    _setNestedData(data, value) {
        var dataObj = data, structure = this.fieldStructure, length = structure.length;
        for(let i = 0; i < length; i++)if (i == length - 1) dataObj[structure[i]] = value;
        else {
            if (!dataObj[structure[i]]) {
                if (typeof value !== "undefined") dataObj[structure[i]] = {};
                else break;
            }
            dataObj = dataObj[structure[i]];
        }
    }
    //attach column to this group
    attachColumn(column) {
        if (this.groupElement) {
            this.columns.push(column);
            this.groupElement.appendChild(column.getElement());
            column.columnRendered();
        } else console.warn("Column Warning - Column being attached to another column instead of column group");
    }
    //vertically align header in column
    verticalAlign(alignment, height) {
        //calculate height of column header and group holder element
        var parentHeight = this.parent.isGroup ? this.parent.getGroupElement().clientHeight : height || this.parent.getHeadersElement().clientHeight;
        // var parentHeight = this.parent.isGroup ? this.parent.getGroupElement().clientHeight : this.parent.getHeadersElement().clientHeight;
        this.element.style.height = parentHeight + "px";
        this.dispatch("column-height", this, this.element.style.height);
        if (this.isGroup) this.groupElement.style.minHeight = parentHeight - this.contentElement.offsetHeight + "px";
        //vertically align cell contents
        // if(!this.isGroup && alignment !== "top"){
        // 	if(alignment === "bottom"){
        // 		this.element.style.paddingTop = (this.element.clientHeight - this.contentElement.offsetHeight) + "px";
        // 	}else{
        // 		this.element.style.paddingTop = ((this.element.clientHeight - this.contentElement.offsetHeight) / 2) + "px";
        // 	}
        // }
        this.columns.forEach(function(column) {
            column.verticalAlign(alignment);
        });
    }
    //clear vertical alignment
    clearVerticalAlign() {
        this.element.style.paddingTop = "";
        this.element.style.height = "";
        this.element.style.minHeight = "";
        this.groupElement.style.minHeight = "";
        this.columns.forEach(function(column) {
            column.clearVerticalAlign();
        });
        this.dispatch("column-height", this, "");
    }
    //// Retrieve Column Information ////
    //return column header element
    getElement() {
        return this.element;
    }
    //return column group element
    getGroupElement() {
        return this.groupElement;
    }
    //return field name
    getField() {
        return this.field;
    }
    getTitleDownload() {
        return this.titleDownload;
    }
    //return the first column in a group
    getFirstColumn() {
        if (!this.isGroup) return this;
        else {
            if (this.columns.length) return this.columns[0].getFirstColumn();
            else return false;
        }
    }
    //return the last column in a group
    getLastColumn() {
        if (!this.isGroup) return this;
        else {
            if (this.columns.length) return this.columns[this.columns.length - 1].getLastColumn();
            else return false;
        }
    }
    //return all columns in a group
    getColumns(traverse) {
        var columns = [];
        if (traverse) this.columns.forEach((column)=>{
            columns.push(column);
            columns = columns.concat(column.getColumns(true));
        });
        else columns = this.columns;
        return columns;
    }
    //return all columns in a group
    getCells() {
        return this.cells;
    }
    //retrieve the top column in a group of columns
    getTopColumn() {
        if (this.parent.isGroup) return this.parent.getTopColumn();
        else return this;
    }
    //return column definition object
    getDefinition(updateBranches) {
        var colDefs = [];
        if (this.isGroup && updateBranches) {
            this.columns.forEach(function(column) {
                colDefs.push(column.getDefinition(true));
            });
            this.definition.columns = colDefs;
        }
        return this.definition;
    }
    //////////////////// Actions ////////////////////
    checkColumnVisibility() {
        var visible = false;
        this.columns.forEach(function(column) {
            if (column.visible) visible = true;
        });
        if (visible) {
            this.show();
            this.dispatchExternal("columnVisibilityChanged", this.getComponent(), false);
        } else this.hide();
    }
    //show column
    show(silent, responsiveToggle) {
        if (!this.visible) {
            this.visible = true;
            this.element.style.display = "";
            if (this.parent.isGroup) this.parent.checkColumnVisibility();
            this.cells.forEach(function(cell) {
                cell.show();
            });
            if (!this.isGroup && this.width === null) this.reinitializeWidth();
            this.table.columnManager.verticalAlignHeaders();
            this.dispatch("column-show", this, responsiveToggle);
            if (!silent) this.dispatchExternal("columnVisibilityChanged", this.getComponent(), true);
            if (this.parent.isGroup) this.parent.matchChildWidths();
            if (!this.silent) this.table.columnManager.rerenderColumns();
        }
    }
    //hide column
    hide(silent, responsiveToggle) {
        if (this.visible) {
            this.visible = false;
            this.element.style.display = "none";
            this.table.columnManager.verticalAlignHeaders();
            if (this.parent.isGroup) this.parent.checkColumnVisibility();
            this.cells.forEach(function(cell) {
                cell.hide();
            });
            this.dispatch("column-hide", this, responsiveToggle);
            if (!silent) this.dispatchExternal("columnVisibilityChanged", this.getComponent(), false);
            if (this.parent.isGroup) this.parent.matchChildWidths();
            if (!this.silent) this.table.columnManager.rerenderColumns();
        }
    }
    matchChildWidths() {
        var childWidth = 0;
        if (this.contentElement && this.columns.length) {
            this.columns.forEach(function(column) {
                if (column.visible) childWidth += column.getWidth();
            });
            this.contentElement.style.maxWidth = childWidth - 1 + "px";
            if (this.table.initialized) this.element.style.width = childWidth + "px";
            if (this.parent.isGroup) this.parent.matchChildWidths();
        }
    }
    removeChild(child) {
        var index = this.columns.indexOf(child);
        if (index > -1) this.columns.splice(index, 1);
        if (!this.columns.length) this.delete();
    }
    setWidth(width) {
        this.widthFixed = true;
        this.setWidthActual(width);
    }
    setWidthActual(width) {
        if (isNaN(width)) width = Math.floor(this.table.element.clientWidth / 100 * parseInt(width));
        width = Math.max(this.minWidth, width);
        if (this.maxWidth) width = Math.min(this.maxWidth, width);
        this.width = width;
        this.widthStyled = width ? width + "px" : "";
        this.element.style.width = this.widthStyled;
        if (!this.isGroup) this.cells.forEach(function(cell) {
            cell.setWidth();
        });
        if (this.parent.isGroup) this.parent.matchChildWidths();
        this.dispatch("column-width", this);
        if (this.subscribedExternal("columnWidth")) this.dispatchExternal("columnWidth", this.getComponent());
    }
    checkCellHeights() {
        var rows = [];
        this.cells.forEach(function(cell) {
            if (cell.row.heightInitialized) {
                if (cell.row.getElement().offsetParent !== null) {
                    rows.push(cell.row);
                    cell.row.clearCellHeight();
                } else cell.row.heightInitialized = false;
            }
        });
        rows.forEach(function(row) {
            row.calcHeight();
        });
        rows.forEach(function(row) {
            row.setCellHeight();
        });
    }
    getWidth() {
        var width = 0;
        if (this.isGroup) this.columns.forEach(function(column) {
            if (column.visible) width += column.getWidth();
        });
        else width = this.width;
        return width;
    }
    getLeftOffset() {
        var offset = this.element.offsetLeft;
        if (this.parent.isGroup) offset += this.parent.getLeftOffset();
        return offset;
    }
    getHeight() {
        return Math.ceil(this.element.getBoundingClientRect().height);
    }
    setMinWidth(minWidth) {
        if (this.maxWidth && minWidth > this.maxWidth) {
            minWidth = this.maxWidth;
            console.warn("the minWidth (" + minWidth + "px) for column '" + this.field + "' cannot be bigger that its maxWidth (" + this.maxWidthStyled + ")");
        }
        this.minWidth = minWidth;
        this.minWidthStyled = minWidth ? minWidth + "px" : "";
        this.element.style.minWidth = this.minWidthStyled;
        this.cells.forEach(function(cell) {
            cell.setMinWidth();
        });
    }
    setMaxWidth(maxWidth) {
        if (this.minWidth && maxWidth < this.minWidth) {
            maxWidth = this.minWidth;
            console.warn("the maxWidth (" + maxWidth + "px) for column '" + this.field + "' cannot be smaller that its minWidth (" + this.minWidthStyled + ")");
        }
        this.maxWidth = maxWidth;
        this.maxWidthStyled = maxWidth ? maxWidth + "px" : "";
        this.element.style.maxWidth = this.maxWidthStyled;
        this.cells.forEach(function(cell) {
            cell.setMaxWidth();
        });
    }
    delete() {
        return new Promise((resolve, reject)=>{
            if (this.isGroup) this.columns.forEach(function(column) {
                column.delete();
            });
            this.dispatch("column-delete", this);
            var cellCount = this.cells.length;
            for(let i = 0; i < cellCount; i++)this.cells[0].delete();
            if (this.element.parentNode) this.element.parentNode.removeChild(this.element);
            this.element = false;
            this.contentElement = false;
            this.titleElement = false;
            this.groupElement = false;
            if (this.parent.isGroup) this.parent.removeChild(this);
            this.table.columnManager.deregisterColumn(this);
            this.table.columnManager.rerenderColumns(true);
            this.dispatch("column-deleted", this);
            resolve();
        });
    }
    columnRendered() {
        if (this.titleFormatterRendered) this.titleFormatterRendered();
        this.dispatch("column-rendered", this);
    }
    //////////////// Cell Management /////////////////
    //generate cell for this column
    generateCell(row) {
        var cell = new $c2a9788f40f9c90a$var$Cell(this, row);
        this.cells.push(cell);
        return cell;
    }
    nextColumn() {
        var index = this.table.columnManager.findColumnIndex(this);
        return index > -1 ? this._nextVisibleColumn(index + 1) : false;
    }
    _nextVisibleColumn(index) {
        var column = this.table.columnManager.getColumnByIndex(index);
        return !column || column.visible ? column : this._nextVisibleColumn(index + 1);
    }
    prevColumn() {
        var index = this.table.columnManager.findColumnIndex(this);
        return index > -1 ? this._prevVisibleColumn(index - 1) : false;
    }
    _prevVisibleColumn(index) {
        var column = this.table.columnManager.getColumnByIndex(index);
        return !column || column.visible ? column : this._prevVisibleColumn(index - 1);
    }
    reinitializeWidth(force) {
        this.widthFixed = false;
        //set width if present
        if (typeof this.definition.width !== "undefined" && !force) // maxInitialWidth ignored here as width specified
        this.setWidth(this.definition.width);
        this.dispatch("column-width-fit-before", this);
        this.fitToData(force);
        this.dispatch("column-width-fit-after", this);
    }
    //set column width to maximum cell width for non group columns
    fitToData(force) {
        if (this.isGroup) return;
        if (!this.widthFixed) {
            this.element.style.width = "";
            this.cells.forEach((cell)=>{
                cell.clearWidth();
            });
        }
        var maxWidth = this.element.offsetWidth;
        if (!this.width || !this.widthFixed) {
            this.cells.forEach((cell)=>{
                var width = cell.getWidth();
                if (width > maxWidth) maxWidth = width;
            });
            if (maxWidth) {
                var setTo = maxWidth + 1;
                if (this.maxInitialWidth && !force) setTo = Math.min(setTo, this.maxInitialWidth);
                this.setWidthActual(setTo);
            }
        }
    }
    updateDefinition(updates) {
        var definition;
        if (!this.isGroup) {
            if (!this.parent.isGroup) {
                definition = Object.assign({}, this.getDefinition());
                definition = Object.assign(definition, updates);
                return this.table.columnManager.addColumn(definition, false, this).then((column)=>{
                    if (definition.field == this.field) this.field = false; //clear field name to prevent deletion of duplicate column from arrays
                    return this.delete().then(()=>{
                        return column.getComponent();
                    });
                });
            } else {
                console.error("Column Update Error - The updateDefinition function is only available on ungrouped columns");
                return Promise.reject("Column Update Error - The updateDefinition function is only available on columns, not column groups");
            }
        } else {
            console.error("Column Update Error - The updateDefinition function is only available on ungrouped columns");
            return Promise.reject("Column Update Error - The updateDefinition function is only available on columns, not column groups");
        }
    }
    deleteCell(cell) {
        var index = this.cells.indexOf(cell);
        if (index > -1) this.cells.splice(index, 1);
    }
    //////////////// Object Generation /////////////////
    getComponent() {
        if (!this.component) this.component = new $c2a9788f40f9c90a$export$11bb209ad3a8e411(this);
        return this.component;
    }
    getPosition() {
        return this.table.columnManager.getVisibleColumnsByIndex().indexOf(this) + 1;
    }
    getParentComponent() {
        return this.parent instanceof $c2a9788f40f9c90a$var$Column ? this.parent.getComponent() : false;
    }
}
//public row object
class $c2a9788f40f9c90a$export$5df91075f5ba4651 {
    constructor(row){
        this._row = row;
        return new Proxy(this, {
            get: function(target, name, receiver) {
                if (typeof target[name] !== "undefined") return target[name];
                else return target._row.table.componentFunctionBinder.handle("row", target._row, name);
            }
        });
    }
    getData(transform) {
        return this._row.getData(transform);
    }
    getElement() {
        return this._row.getElement();
    }
    getCells() {
        var cells = [];
        this._row.getCells().forEach(function(cell) {
            cells.push(cell.getComponent());
        });
        return cells;
    }
    getCell(column) {
        var cell = this._row.getCell(column);
        return cell ? cell.getComponent() : false;
    }
    getIndex() {
        return this._row.getData("data")[this._row.table.options.index];
    }
    getPosition() {
        return this._row.getPosition();
    }
    watchPosition(callback) {
        return this._row.watchPosition(callback);
    }
    delete() {
        return this._row.delete();
    }
    scrollTo(position, ifVisible) {
        return this._row.table.rowManager.scrollToRow(this._row, position, ifVisible);
    }
    move(to, after) {
        this._row.moveToRow(to, after);
    }
    update(data) {
        return this._row.updateData(data);
    }
    normalizeHeight() {
        this._row.normalizeHeight(true);
    }
    _getSelf() {
        return this._row;
    }
    reformat() {
        return this._row.reinitialize();
    }
    getTable() {
        return this._row.table;
    }
    getNextRow() {
        var row = this._row.nextRow();
        return row ? row.getComponent() : row;
    }
    getPrevRow() {
        var row = this._row.prevRow();
        return row ? row.getComponent() : row;
    }
}
class $c2a9788f40f9c90a$var$Row extends $c2a9788f40f9c90a$var$CoreFeature {
    constructor(data, parent, type = "row"){
        super(parent.table);
        this.parent = parent;
        this.data = {};
        this.type = type; //type of element
        this.element = false;
        this.modules = {}; //hold module variables;
        this.cells = [];
        this.height = 0; //hold element height
        this.heightStyled = ""; //hold element height pre-styled to improve render efficiency
        this.manualHeight = false; //user has manually set row height
        this.outerHeight = 0; //hold elements outer height
        this.initialized = false; //element has been rendered
        this.heightInitialized = false; //element has resized cells to fit
        this.position = 0; //store position of element in row list
        this.positionWatchers = [];
        this.component = null;
        this.created = false;
        this.setData(data);
    }
    create() {
        if (!this.created) {
            this.created = true;
            this.generateElement();
        }
    }
    createElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-row");
        el.setAttribute("role", "row");
        this.element = el;
    }
    getElement() {
        this.create();
        return this.element;
    }
    detachElement() {
        if (this.element && this.element.parentNode) this.element.parentNode.removeChild(this.element);
    }
    generateElement() {
        this.createElement();
        this.dispatch("row-init", this);
    }
    generateCells() {
        this.cells = this.table.columnManager.generateCells(this);
    }
    //functions to setup on first render
    initialize(force, inFragment) {
        this.create();
        if (!this.initialized || force) {
            this.deleteCells();
            while(this.element.firstChild)this.element.removeChild(this.element.firstChild);
            this.dispatch("row-layout-before", this);
            this.generateCells();
            this.initialized = true;
            this.table.columnManager.renderer.renderRowCells(this, inFragment);
            if (force) this.normalizeHeight();
            this.dispatch("row-layout", this);
            if (this.table.options.rowFormatter) this.table.options.rowFormatter(this.getComponent());
            this.dispatch("row-layout-after", this);
        } else this.table.columnManager.renderer.rerenderRowCells(this, inFragment);
    }
    rendered() {
        this.cells.forEach((cell)=>{
            cell.cellRendered();
        });
    }
    reinitializeHeight() {
        this.heightInitialized = false;
        if (this.element && this.element.offsetParent !== null) this.normalizeHeight(true);
    }
    deinitialize() {
        this.initialized = false;
    }
    deinitializeHeight() {
        this.heightInitialized = false;
    }
    reinitialize(children) {
        this.initialized = false;
        this.heightInitialized = false;
        if (!this.manualHeight) {
            this.height = 0;
            this.heightStyled = "";
        }
        if (this.element && this.element.offsetParent !== null) this.initialize(true);
        this.dispatch("row-relayout", this);
    }
    //get heights when doing bulk row style calcs in virtual DOM
    calcHeight(force) {
        var maxHeight = 0, minHeight = 0;
        if (this.table.options.rowHeight) this.height = this.table.options.rowHeight;
        else {
            minHeight = this.calcMinHeight();
            maxHeight = this.calcMaxHeight();
            if (force) this.height = Math.max(maxHeight, minHeight);
            else this.height = this.manualHeight ? this.height : Math.max(maxHeight, minHeight);
        }
        this.heightStyled = this.height ? this.height + "px" : "";
        this.outerHeight = this.element.offsetHeight;
    }
    calcMinHeight() {
        return this.table.options.resizableRows ? this.element.clientHeight : 0;
    }
    calcMaxHeight() {
        var maxHeight = 0;
        this.cells.forEach(function(cell) {
            var height = cell.getHeight();
            if (height > maxHeight) maxHeight = height;
        });
        return maxHeight;
    }
    //set of cells
    setCellHeight() {
        this.cells.forEach(function(cell) {
            cell.setHeight();
        });
        this.heightInitialized = true;
    }
    clearCellHeight() {
        this.cells.forEach(function(cell) {
            cell.clearHeight();
        });
    }
    //normalize the height of elements in the row
    normalizeHeight(force) {
        if (force && !this.table.options.rowHeight) this.clearCellHeight();
        this.calcHeight(force);
        this.setCellHeight();
    }
    //set height of rows
    setHeight(height, force) {
        if (this.height != height || force) {
            this.manualHeight = true;
            this.height = height;
            this.heightStyled = height ? height + "px" : "";
            this.setCellHeight();
            // this.outerHeight = this.element.outerHeight();
            this.outerHeight = this.element.offsetHeight;
            if (this.subscribedExternal("rowHeight")) this.dispatchExternal("rowHeight", this.getComponent());
        }
    }
    //return rows outer height
    getHeight() {
        return this.outerHeight;
    }
    //return rows outer Width
    getWidth() {
        return this.element.offsetWidth;
    }
    //////////////// Cell Management /////////////////
    deleteCell(cell) {
        var index = this.cells.indexOf(cell);
        if (index > -1) this.cells.splice(index, 1);
    }
    //////////////// Data Management /////////////////
    setData(data) {
        this.data = this.chain("row-data-init-before", [
            this,
            data
        ], undefined, data);
        this.dispatch("row-data-init-after", this);
    }
    //update the rows data
    updateData(updatedData) {
        var visible = this.element && $c2a9788f40f9c90a$var$Helpers.elVisible(this.element), tempData = {}, newRowData;
        return new Promise((resolve, reject)=>{
            if (typeof updatedData === "string") updatedData = JSON.parse(updatedData);
            this.dispatch("row-data-save-before", this);
            if (this.subscribed("row-data-changing")) {
                tempData = Object.assign(tempData, this.data);
                tempData = Object.assign(tempData, updatedData);
            }
            newRowData = this.chain("row-data-changing", [
                this,
                tempData,
                updatedData
            ], null, updatedData);
            //set data
            for(let attrname in newRowData)this.data[attrname] = newRowData[attrname];
            this.dispatch("row-data-save-after", this);
            //update affected cells only
            for(let attrname in updatedData){
                let columns = this.table.columnManager.getColumnsByFieldRoot(attrname);
                columns.forEach((column)=>{
                    let cell = this.getCell(column.getField());
                    if (cell) {
                        let value = column.getFieldValue(newRowData);
                        if (cell.getValue() !== value) {
                            cell.setValueProcessData(value);
                            if (visible) cell.cellRendered();
                        }
                    }
                });
            }
            //Partial reinitialization if visible
            if (visible) {
                this.normalizeHeight(true);
                if (this.table.options.rowFormatter) this.table.options.rowFormatter(this.getComponent());
            } else {
                this.initialized = false;
                this.height = 0;
                this.heightStyled = "";
            }
            this.dispatch("row-data-changed", this, visible, updatedData);
            //this.reinitialize();
            this.dispatchExternal("rowUpdated", this.getComponent());
            if (this.subscribedExternal("dataChanged")) this.dispatchExternal("dataChanged", this.table.rowManager.getData());
            resolve();
        });
    }
    getData(transform) {
        if (transform) return this.chain("row-data-retrieve", [
            this,
            transform
        ], null, this.data);
        return this.data;
    }
    getCell(column) {
        var match = false;
        column = this.table.columnManager.findColumn(column);
        if (!this.initialized && this.cells.length === 0) this.generateCells();
        match = this.cells.find(function(cell) {
            return cell.column === column;
        });
        return match;
    }
    getCellIndex(findCell) {
        return this.cells.findIndex(function(cell) {
            return cell === findCell;
        });
    }
    findCell(subject) {
        return this.cells.find((cell)=>{
            return cell.element === subject;
        });
    }
    getCells() {
        if (!this.initialized && this.cells.length === 0) this.generateCells();
        return this.cells;
    }
    nextRow() {
        var row = this.table.rowManager.nextDisplayRow(this, true);
        return row || false;
    }
    prevRow() {
        var row = this.table.rowManager.prevDisplayRow(this, true);
        return row || false;
    }
    moveToRow(to, before) {
        var toRow = this.table.rowManager.findRow(to);
        if (toRow) {
            this.table.rowManager.moveRowActual(this, toRow, !before);
            this.table.rowManager.refreshActiveData("display", false, true);
        } else console.warn("Move Error - No matching row found:", to);
    }
    ///////////////////// Actions  /////////////////////
    delete() {
        this.dispatch("row-delete", this);
        this.deleteActual();
        return Promise.resolve();
    }
    deleteActual(blockRedraw) {
        this.detachModules();
        this.table.rowManager.deleteRow(this, blockRedraw);
        this.deleteCells();
        this.initialized = false;
        this.heightInitialized = false;
        this.element = false;
        this.dispatch("row-deleted", this);
    }
    detachModules() {
        this.dispatch("row-deleting", this);
    }
    deleteCells() {
        var cellCount = this.cells.length;
        for(let i = 0; i < cellCount; i++)this.cells[0].delete();
    }
    wipe() {
        this.detachModules();
        this.deleteCells();
        if (this.element) {
            while(this.element.firstChild)this.element.removeChild(this.element.firstChild);
            if (this.element.parentNode) this.element.parentNode.removeChild(this.element);
        }
        this.element = false;
        this.modules = {};
    }
    isDisplayed() {
        return this.table.rowManager.getDisplayRows().includes(this);
    }
    getPosition() {
        return this.isDisplayed() ? this.position : false;
    }
    setPosition(position) {
        if (position != this.position) {
            this.position = position;
            this.positionWatchers.forEach((callback)=>{
                callback(this.position);
            });
        }
    }
    watchPosition(callback) {
        this.positionWatchers.push(callback);
        callback(this.position);
    }
    getGroup() {
        return this.modules.group || false;
    }
    //////////////// Object Generation /////////////////
    getComponent() {
        if (!this.component) this.component = new $c2a9788f40f9c90a$export$5df91075f5ba4651(this);
        return this.component;
    }
}
var $c2a9788f40f9c90a$var$defaultCalculations = {
    "avg": function(values, data, calcParams) {
        var output = 0, precision = typeof calcParams.precision !== "undefined" ? calcParams.precision : 2;
        if (values.length) {
            output = values.reduce(function(sum, value) {
                return Number(sum) + Number(value);
            });
            output = output / values.length;
            output = precision !== false ? output.toFixed(precision) : output;
        }
        return parseFloat(output).toString();
    },
    "max": function(values, data, calcParams) {
        var output = null, precision = typeof calcParams.precision !== "undefined" ? calcParams.precision : false;
        values.forEach(function(value) {
            value = Number(value);
            if (value > output || output === null) output = value;
        });
        return output !== null ? precision !== false ? output.toFixed(precision) : output : "";
    },
    "min": function(values, data, calcParams) {
        var output = null, precision = typeof calcParams.precision !== "undefined" ? calcParams.precision : false;
        values.forEach(function(value) {
            value = Number(value);
            if (value < output || output === null) output = value;
        });
        return output !== null ? precision !== false ? output.toFixed(precision) : output : "";
    },
    "sum": function(values, data, calcParams) {
        var output = 0, precision = typeof calcParams.precision !== "undefined" ? calcParams.precision : false;
        if (values.length) values.forEach(function(value) {
            value = Number(value);
            output += !isNaN(value) ? Number(value) : 0;
        });
        return precision !== false ? output.toFixed(precision) : output;
    },
    "concat": function(values, data, calcParams) {
        var output = 0;
        if (values.length) output = values.reduce(function(sum, value) {
            return String(sum) + String(value);
        });
        return output;
    },
    "count": function(values, data, calcParams) {
        var output = 0;
        if (values.length) values.forEach(function(value) {
            if (value) output++;
        });
        return output;
    },
    "unique": function(values, data, calcParams) {
        var unique = values.filter((value, index)=>{
            return (values || value === 0) && values.indexOf(value) === index;
        });
        return unique.length;
    }
};
class $c2a9788f40f9c90a$export$840b3bc55b30dec6 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "columnCalcs";
    //load defaults
    static calculations = $c2a9788f40f9c90a$var$defaultCalculations;
    constructor(table){
        super(table);
        this.topCalcs = [];
        this.botCalcs = [];
        this.genColumn = false;
        this.topElement = this.createElement();
        this.botElement = this.createElement();
        this.topRow = false;
        this.botRow = false;
        this.topInitialized = false;
        this.botInitialized = false;
        this.blocked = false;
        this.recalcAfterBlock = false;
        this.registerTableOption("columnCalcs", true);
        this.registerColumnOption("topCalc");
        this.registerColumnOption("topCalcParams");
        this.registerColumnOption("topCalcFormatter");
        this.registerColumnOption("topCalcFormatterParams");
        this.registerColumnOption("bottomCalc");
        this.registerColumnOption("bottomCalcParams");
        this.registerColumnOption("bottomCalcFormatter");
        this.registerColumnOption("bottomCalcFormatterParams");
    }
    createElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-calcs-holder");
        return el;
    }
    initialize() {
        this.genColumn = new $c2a9788f40f9c90a$var$Column({
            field: "value"
        }, this);
        this.subscribe("cell-value-changed", this.cellValueChanged.bind(this));
        this.subscribe("column-init", this.initializeColumnCheck.bind(this));
        this.subscribe("row-deleted", this.rowsUpdated.bind(this));
        this.subscribe("scroll-horizontal", this.scrollHorizontal.bind(this));
        this.subscribe("row-added", this.rowsUpdated.bind(this));
        this.subscribe("column-moved", this.recalcActiveRows.bind(this));
        this.subscribe("column-add", this.recalcActiveRows.bind(this));
        this.subscribe("data-refreshed", this.recalcActiveRowsRefresh.bind(this));
        this.subscribe("table-redraw", this.tableRedraw.bind(this));
        this.subscribe("rows-visible", this.visibleRows.bind(this));
        this.subscribe("scrollbar-vertical", this.adjustForScrollbar.bind(this));
        this.subscribe("redraw-blocked", this.blockRedraw.bind(this));
        this.subscribe("redraw-restored", this.restoreRedraw.bind(this));
        this.subscribe("table-redrawing", this.resizeHolderWidth.bind(this));
        this.subscribe("column-resized", this.resizeHolderWidth.bind(this));
        this.subscribe("column-show", this.resizeHolderWidth.bind(this));
        this.subscribe("column-hide", this.resizeHolderWidth.bind(this));
        this.registerTableFunction("getCalcResults", this.getResults.bind(this));
        this.registerTableFunction("recalc", this.userRecalc.bind(this));
        this.resizeHolderWidth();
    }
    resizeHolderWidth() {
        this.topElement.style.minWidth = this.table.columnManager.headersElement.offsetWidth + "px";
    }
    tableRedraw(force) {
        this.recalc(this.table.rowManager.activeRows);
        if (force) this.redraw();
    }
    blockRedraw() {
        this.blocked = true;
        this.recalcAfterBlock = false;
    }
    restoreRedraw() {
        this.blocked = false;
        if (this.recalcAfterBlock) {
            this.recalcAfterBlock = false;
            this.recalcActiveRowsRefresh();
        }
    }
    ///////////////////////////////////
    ///////// Table Functions /////////
    ///////////////////////////////////
    userRecalc() {
        this.recalc(this.table.rowManager.activeRows);
    }
    ///////////////////////////////////
    ///////// Internal Logic //////////
    ///////////////////////////////////
    blockCheck() {
        if (this.blocked) this.recalcAfterBlock = true;
        return this.blocked;
    }
    visibleRows(viewable, rows) {
        if (this.topRow) rows.unshift(this.topRow);
        if (this.botRow) rows.push(this.botRow);
        return rows;
    }
    rowsUpdated(row) {
        if (this.table.options.groupBy) this.recalcRowGroup(row);
        else this.recalcActiveRows();
    }
    recalcActiveRowsRefresh() {
        if (this.table.options.groupBy && this.table.options.dataTreeStartExpanded && this.table.options.dataTree) this.recalcAll();
        else this.recalcActiveRows();
    }
    recalcActiveRows() {
        this.recalc(this.table.rowManager.activeRows);
    }
    cellValueChanged(cell) {
        if (cell.column.definition.topCalc || cell.column.definition.bottomCalc) {
            if (this.table.options.groupBy) {
                if (this.table.options.columnCalcs == "table" || this.table.options.columnCalcs == "both") this.recalcActiveRows();
                if (this.table.options.columnCalcs != "table") this.recalcRowGroup(cell.row);
            } else this.recalcActiveRows();
        }
    }
    initializeColumnCheck(column) {
        if (column.definition.topCalc || column.definition.bottomCalc) this.initializeColumn(column);
    }
    //initialize column calcs
    initializeColumn(column) {
        var def = column.definition;
        var config = {
            topCalcParams: def.topCalcParams || {},
            botCalcParams: def.bottomCalcParams || {}
        };
        if (def.topCalc) {
            switch(typeof def.topCalc){
                case "string":
                    if ($c2a9788f40f9c90a$export$840b3bc55b30dec6.calculations[def.topCalc]) config.topCalc = $c2a9788f40f9c90a$export$840b3bc55b30dec6.calculations[def.topCalc];
                    else console.warn("Column Calc Error - No such calculation found, ignoring: ", def.topCalc);
                    break;
                case "function":
                    config.topCalc = def.topCalc;
                    break;
            }
            if (config.topCalc) {
                column.modules.columnCalcs = config;
                this.topCalcs.push(column);
                if (this.table.options.columnCalcs != "group") this.initializeTopRow();
            }
        }
        if (def.bottomCalc) {
            switch(typeof def.bottomCalc){
                case "string":
                    if ($c2a9788f40f9c90a$export$840b3bc55b30dec6.calculations[def.bottomCalc]) config.botCalc = $c2a9788f40f9c90a$export$840b3bc55b30dec6.calculations[def.bottomCalc];
                    else console.warn("Column Calc Error - No such calculation found, ignoring: ", def.bottomCalc);
                    break;
                case "function":
                    config.botCalc = def.bottomCalc;
                    break;
            }
            if (config.botCalc) {
                column.modules.columnCalcs = config;
                this.botCalcs.push(column);
                if (this.table.options.columnCalcs != "group") this.initializeBottomRow();
            }
        }
    }
    //dummy functions to handle being mock column manager
    registerColumnField() {}
    removeCalcs() {
        var changed = false;
        if (this.topInitialized) {
            this.topInitialized = false;
            this.topElement.parentNode.removeChild(this.topElement);
            changed = true;
        }
        if (this.botInitialized) {
            this.botInitialized = false;
            this.footerRemove(this.botElement);
            changed = true;
        }
        if (changed) this.table.rowManager.adjustTableSize();
    }
    reinitializeCalcs() {
        if (this.topCalcs.length) this.initializeTopRow();
        if (this.botCalcs.length) this.initializeBottomRow();
    }
    initializeTopRow() {
        var fragment = document.createDocumentFragment();
        if (!this.topInitialized) {
            fragment.appendChild(document.createElement("br"));
            fragment.appendChild(this.topElement);
            this.table.columnManager.getContentsElement().insertBefore(fragment, this.table.columnManager.headersElement.nextSibling);
            this.topInitialized = true;
        }
    }
    initializeBottomRow() {
        if (!this.botInitialized) {
            this.footerPrepend(this.botElement);
            this.botInitialized = true;
        }
    }
    scrollHorizontal(left) {
        if (this.botInitialized && this.botRow) this.botElement.scrollLeft = left;
    }
    recalc(rows) {
        var data, row;
        if (!this.blockCheck()) {
            if (this.topInitialized || this.botInitialized) {
                data = this.rowsToData(rows);
                if (this.topInitialized) {
                    if (this.topRow) this.topRow.deleteCells();
                    row = this.generateRow("top", data);
                    this.topRow = row;
                    while(this.topElement.firstChild)this.topElement.removeChild(this.topElement.firstChild);
                    this.topElement.appendChild(row.getElement());
                    row.initialize(true);
                }
                if (this.botInitialized) {
                    if (this.botRow) this.botRow.deleteCells();
                    row = this.generateRow("bottom", data);
                    this.botRow = row;
                    while(this.botElement.firstChild)this.botElement.removeChild(this.botElement.firstChild);
                    this.botElement.appendChild(row.getElement());
                    row.initialize(true);
                }
                this.table.rowManager.adjustTableSize();
                //set resizable handles
                if (this.table.modExists("frozenColumns")) this.table.modules.frozenColumns.layout();
            }
        }
    }
    recalcRowGroup(row) {
        this.recalcGroup(this.table.modules.groupRows.getRowGroup(row));
    }
    recalcAll() {
        if (this.topCalcs.length || this.botCalcs.length) {
            if (this.table.options.columnCalcs !== "group") this.recalcActiveRows();
            if (this.table.options.groupBy && this.table.options.columnCalcs !== "table") {
                var groups = this.table.modules.groupRows.getChildGroups();
                groups.forEach((group)=>{
                    this.recalcGroup(group);
                });
            }
        }
    }
    recalcGroup(group) {
        var data, rowData;
        if (!this.blockCheck()) {
            if (group) {
                if (group.calcs) {
                    if (group.calcs.bottom) {
                        data = this.rowsToData(group.rows);
                        rowData = this.generateRowData("bottom", data);
                        group.calcs.bottom.updateData(rowData);
                        group.calcs.bottom.reinitialize();
                    }
                    if (group.calcs.top) {
                        data = this.rowsToData(group.rows);
                        rowData = this.generateRowData("top", data);
                        group.calcs.top.updateData(rowData);
                        group.calcs.top.reinitialize();
                    }
                }
            }
        }
    }
    //generate top stats row
    generateTopRow(rows) {
        return this.generateRow("top", this.rowsToData(rows));
    }
    //generate bottom stats row
    generateBottomRow(rows) {
        return this.generateRow("bottom", this.rowsToData(rows));
    }
    rowsToData(rows) {
        var data = [], hasDataTreeColumnCalcs = this.table.options.dataTree && this.table.options.dataTreeChildColumnCalcs, dataTree = this.table.modules.dataTree;
        rows.forEach((row)=>{
            data.push(row.getData());
            if (hasDataTreeColumnCalcs && row.modules.dataTree?.open) this.rowsToData(dataTree.getFilteredTreeChildren(row)).forEach((dataRow)=>{
                data.push(row);
            });
        });
        return data;
    }
    //generate stats row
    generateRow(pos, data) {
        var rowData = this.generateRowData(pos, data), row;
        if (this.table.modExists("mutator")) this.table.modules.mutator.disable();
        row = new $c2a9788f40f9c90a$var$Row(rowData, this, "calc");
        if (this.table.modExists("mutator")) this.table.modules.mutator.enable();
        row.getElement().classList.add("tabulator-calcs", "tabulator-calcs-" + pos);
        row.component = false;
        row.getComponent = ()=>{
            if (!row.component) row.component = new $c2a9788f40f9c90a$export$3ef2519bf7055551(row);
            return row.component;
        };
        row.generateCells = ()=>{
            var cells = [];
            this.table.columnManager.columnsByIndex.forEach((column)=>{
                //set field name of mock column
                this.genColumn.setField(column.getField());
                this.genColumn.hozAlign = column.hozAlign;
                if (column.definition[pos + "CalcFormatter"] && this.table.modExists("format")) this.genColumn.modules.format = {
                    formatter: this.table.modules.format.lookupFormatter(column.definition[pos + "CalcFormatter"]),
                    params: column.definition[pos + "CalcFormatterParams"] || {}
                };
                else this.genColumn.modules.format = {
                    formatter: this.table.modules.format.lookupFormatter("plaintext"),
                    params: {}
                };
                //ensure css class definition is replicated to calculation cell
                this.genColumn.definition.cssClass = column.definition.cssClass;
                //generate cell and assign to correct column
                var cell = new $c2a9788f40f9c90a$var$Cell(this.genColumn, row);
                cell.getElement();
                cell.column = column;
                cell.setWidth();
                column.cells.push(cell);
                cells.push(cell);
                if (!column.visible) cell.hide();
            });
            row.cells = cells;
        };
        return row;
    }
    //generate stats row
    generateRowData(pos, data) {
        var rowData = {}, calcs = pos == "top" ? this.topCalcs : this.botCalcs, type = pos == "top" ? "topCalc" : "botCalc", params, paramKey;
        calcs.forEach(function(column) {
            var values = [];
            if (column.modules.columnCalcs && column.modules.columnCalcs[type]) {
                data.forEach(function(item) {
                    values.push(column.getFieldValue(item));
                });
                paramKey = type + "Params";
                params = typeof column.modules.columnCalcs[paramKey] === "function" ? column.modules.columnCalcs[paramKey](values, data) : column.modules.columnCalcs[paramKey];
                column.setFieldValue(rowData, column.modules.columnCalcs[type](values, data, params));
            }
        });
        return rowData;
    }
    hasTopCalcs() {
        return !!this.topCalcs.length;
    }
    hasBottomCalcs() {
        return !!this.botCalcs.length;
    }
    //handle table redraw
    redraw() {
        if (this.topRow) this.topRow.normalizeHeight(true);
        if (this.botRow) this.botRow.normalizeHeight(true);
    }
    //return the calculated
    getResults() {
        var results = {}, groups;
        if (this.table.options.groupBy && this.table.modExists("groupRows")) {
            groups = this.table.modules.groupRows.getGroups(true);
            groups.forEach((group)=>{
                results[group.getKey()] = this.getGroupResults(group);
            });
        } else results = {
            top: this.topRow ? this.topRow.getData() : {},
            bottom: this.botRow ? this.botRow.getData() : {}
        };
        return results;
    }
    //get results from a group
    getGroupResults(group) {
        var groupObj = group._getSelf(), subGroups = group.getSubGroups(), subGroupResults = {}, results = {};
        subGroups.forEach((subgroup)=>{
            subGroupResults[subgroup.getKey()] = this.getGroupResults(subgroup);
        });
        results = {
            top: groupObj.calcs.top ? groupObj.calcs.top.getData() : {},
            bottom: groupObj.calcs.bottom ? groupObj.calcs.bottom.getData() : {},
            groups: subGroupResults
        };
        return results;
    }
    adjustForScrollbar(width) {
        if (this.botRow) {
            if (this.table.rtl) this.botElement.style.paddingLeft = width + "px";
            else this.botElement.style.paddingRight = width + "px";
        }
    }
}
class $c2a9788f40f9c90a$export$a5a9878f12569c04 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "dataTree";
    constructor(table){
        super(table);
        this.indent = 10;
        this.field = "";
        this.collapseEl = null;
        this.expandEl = null;
        this.branchEl = null;
        this.elementField = false;
        this.startOpen = function() {};
        this.registerTableOption("dataTree", false); //enable data tree
        this.registerTableOption("dataTreeFilter", true); //filter child rows
        this.registerTableOption("dataTreeSort", true); //sort child rows
        this.registerTableOption("dataTreeElementColumn", false);
        this.registerTableOption("dataTreeBranchElement", true); //show data tree branch element
        this.registerTableOption("dataTreeChildIndent", 9); //data tree child indent in px
        this.registerTableOption("dataTreeChildField", "_children"); //data tre column field to look for child rows
        this.registerTableOption("dataTreeCollapseElement", false); //data tree row collapse element
        this.registerTableOption("dataTreeExpandElement", false); //data tree row expand element
        this.registerTableOption("dataTreeStartExpanded", false);
        this.registerTableOption("dataTreeChildColumnCalcs", false); //include visible data tree rows in column calculations
        this.registerTableOption("dataTreeSelectPropagate", false); //selecting a parent row selects its children
        //register component functions
        this.registerComponentFunction("row", "treeCollapse", this.collapseRow.bind(this));
        this.registerComponentFunction("row", "treeExpand", this.expandRow.bind(this));
        this.registerComponentFunction("row", "treeToggle", this.toggleRow.bind(this));
        this.registerComponentFunction("row", "getTreeParent", this.getTreeParent.bind(this));
        this.registerComponentFunction("row", "getTreeChildren", this.getRowChildren.bind(this));
        this.registerComponentFunction("row", "addTreeChild", this.addTreeChildRow.bind(this));
        this.registerComponentFunction("row", "isTreeExpanded", this.isRowExpanded.bind(this));
    }
    initialize() {
        if (this.table.options.dataTree) {
            var dummyEl = null, options = this.table.options;
            this.field = options.dataTreeChildField;
            this.indent = options.dataTreeChildIndent;
            if (this.options("movableRows")) console.warn("The movableRows option is not available with dataTree enabled, moving of child rows could result in unpredictable behavior");
            if (options.dataTreeBranchElement) {
                if (options.dataTreeBranchElement === true) {
                    this.branchEl = document.createElement("div");
                    this.branchEl.classList.add("tabulator-data-tree-branch");
                } else if (typeof options.dataTreeBranchElement === "string") {
                    dummyEl = document.createElement("div");
                    dummyEl.innerHTML = options.dataTreeBranchElement;
                    this.branchEl = dummyEl.firstChild;
                } else this.branchEl = options.dataTreeBranchElement;
            } else {
                this.branchEl = document.createElement("div");
                this.branchEl.classList.add("tabulator-data-tree-branch-empty");
            }
            if (options.dataTreeCollapseElement) {
                if (typeof options.dataTreeCollapseElement === "string") {
                    dummyEl = document.createElement("div");
                    dummyEl.innerHTML = options.dataTreeCollapseElement;
                    this.collapseEl = dummyEl.firstChild;
                } else this.collapseEl = options.dataTreeCollapseElement;
            } else {
                this.collapseEl = document.createElement("div");
                this.collapseEl.classList.add("tabulator-data-tree-control");
                this.collapseEl.tabIndex = 0;
                this.collapseEl.innerHTML = "<div class='tabulator-data-tree-control-collapse'></div>";
            }
            if (options.dataTreeExpandElement) {
                if (typeof options.dataTreeExpandElement === "string") {
                    dummyEl = document.createElement("div");
                    dummyEl.innerHTML = options.dataTreeExpandElement;
                    this.expandEl = dummyEl.firstChild;
                } else this.expandEl = options.dataTreeExpandElement;
            } else {
                this.expandEl = document.createElement("div");
                this.expandEl.classList.add("tabulator-data-tree-control");
                this.expandEl.tabIndex = 0;
                this.expandEl.innerHTML = "<div class='tabulator-data-tree-control-expand'></div>";
            }
            switch(typeof options.dataTreeStartExpanded){
                case "boolean":
                    this.startOpen = function(row, index) {
                        return options.dataTreeStartExpanded;
                    };
                    break;
                case "function":
                    this.startOpen = options.dataTreeStartExpanded;
                    break;
                default:
                    this.startOpen = function(row, index) {
                        return options.dataTreeStartExpanded[index];
                    };
                    break;
            }
            this.subscribe("row-init", this.initializeRow.bind(this));
            this.subscribe("row-layout-after", this.layoutRow.bind(this));
            this.subscribe("row-deleted", this.rowDelete.bind(this), 0);
            this.subscribe("row-data-changed", this.rowDataChanged.bind(this), 10);
            this.subscribe("cell-value-updated", this.cellValueChanged.bind(this));
            this.subscribe("edit-cancelled", this.cellValueChanged.bind(this));
            this.subscribe("column-moving-rows", this.columnMoving.bind(this));
            this.subscribe("table-built", this.initializeElementField.bind(this));
            this.subscribe("table-redrawing", this.tableRedrawing.bind(this));
            this.registerDisplayHandler(this.getRows.bind(this), 30);
        }
    }
    tableRedrawing(force) {
        var rows;
        if (force) {
            rows = this.table.rowManager.getRows();
            rows.forEach((row)=>{
                this.reinitializeRowChildren(row);
            });
        }
    }
    initializeElementField() {
        var firstCol = this.table.columnManager.getFirstVisibleColumn();
        this.elementField = this.table.options.dataTreeElementColumn || (firstCol ? firstCol.field : false);
    }
    getRowChildren(row) {
        return this.getTreeChildren(row, true);
    }
    columnMoving() {
        var rows = [];
        this.table.rowManager.rows.forEach((row)=>{
            rows = rows.concat(this.getTreeChildren(row, false, true));
        });
        return rows;
    }
    rowDataChanged(row, visible, updatedData) {
        if (this.redrawNeeded(updatedData)) {
            this.initializeRow(row);
            if (visible) {
                this.layoutRow(row);
                this.refreshData(true);
            }
        }
    }
    cellValueChanged(cell) {
        var field = cell.column.getField();
        if (field === this.elementField) this.layoutRow(cell.row);
    }
    initializeRow(row) {
        var childArray = row.getData()[this.field];
        var isArray = Array.isArray(childArray);
        var children = isArray || !isArray && typeof childArray === "object" && childArray !== null;
        if (!children && row.modules.dataTree && row.modules.dataTree.branchEl) row.modules.dataTree.branchEl.parentNode.removeChild(row.modules.dataTree.branchEl);
        if (!children && row.modules.dataTree && row.modules.dataTree.controlEl) row.modules.dataTree.controlEl.parentNode.removeChild(row.modules.dataTree.controlEl);
        row.modules.dataTree = {
            index: row.modules.dataTree ? row.modules.dataTree.index : 0,
            open: children ? row.modules.dataTree ? row.modules.dataTree.open : this.startOpen(row.getComponent(), 0) : false,
            controlEl: row.modules.dataTree && children ? row.modules.dataTree.controlEl : false,
            branchEl: row.modules.dataTree && children ? row.modules.dataTree.branchEl : false,
            parent: row.modules.dataTree ? row.modules.dataTree.parent : false,
            children: children
        };
    }
    reinitializeRowChildren(row) {
        var children = this.getTreeChildren(row, false, true);
        children.forEach(function(child) {
            child.reinitialize(true);
        });
    }
    layoutRow(row) {
        var cell = this.elementField ? row.getCell(this.elementField) : row.getCells()[0], el = cell.getElement(), config = row.modules.dataTree;
        if (config.branchEl) {
            if (config.branchEl.parentNode) config.branchEl.parentNode.removeChild(config.branchEl);
            config.branchEl = false;
        }
        if (config.controlEl) {
            if (config.controlEl.parentNode) config.controlEl.parentNode.removeChild(config.controlEl);
            config.controlEl = false;
        }
        this.generateControlElement(row, el);
        row.getElement().classList.add("tabulator-tree-level-" + config.index);
        if (config.index) {
            if (this.branchEl) {
                config.branchEl = this.branchEl.cloneNode(true);
                el.insertBefore(config.branchEl, el.firstChild);
                if (this.table.rtl) config.branchEl.style.marginRight = (config.branchEl.offsetWidth + config.branchEl.style.marginLeft) * (config.index - 1) + config.index * this.indent + "px";
                else config.branchEl.style.marginLeft = (config.branchEl.offsetWidth + config.branchEl.style.marginRight) * (config.index - 1) + config.index * this.indent + "px";
            } else if (this.table.rtl) el.style.paddingRight = parseInt(window.getComputedStyle(el, null).getPropertyValue('padding-right')) + config.index * this.indent + "px";
            else el.style.paddingLeft = parseInt(window.getComputedStyle(el, null).getPropertyValue('padding-left')) + config.index * this.indent + "px";
        }
    }
    generateControlElement(row, el) {
        var config = row.modules.dataTree, oldControl = config.controlEl;
        el = el || row.getCells()[0].getElement();
        if (config.children !== false) {
            if (config.open) {
                config.controlEl = this.collapseEl.cloneNode(true);
                config.controlEl.addEventListener("click", (e)=>{
                    e.stopPropagation();
                    this.collapseRow(row);
                });
            } else {
                config.controlEl = this.expandEl.cloneNode(true);
                config.controlEl.addEventListener("click", (e)=>{
                    e.stopPropagation();
                    this.expandRow(row);
                });
            }
            config.controlEl.addEventListener("mousedown", (e)=>{
                e.stopPropagation();
            });
            if (oldControl && oldControl.parentNode === el) oldControl.parentNode.replaceChild(config.controlEl, oldControl);
            else el.insertBefore(config.controlEl, el.firstChild);
        }
    }
    getRows(rows) {
        var output = [];
        rows.forEach((row, i)=>{
            var config, children;
            output.push(row);
            if (row instanceof $c2a9788f40f9c90a$var$Row) {
                row.create();
                config = row.modules.dataTree;
                if (!config.index && config.children !== false) {
                    children = this.getChildren(row, false, true);
                    children.forEach((child)=>{
                        child.create();
                        output.push(child);
                    });
                }
            }
        });
        return output;
    }
    getChildren(row, allChildren, sortOnly) {
        var config = row.modules.dataTree, children = [], output = [];
        if (config.children !== false && (config.open || allChildren)) {
            if (!Array.isArray(config.children)) config.children = this.generateChildren(row);
            if (this.table.modExists("filter") && this.table.options.dataTreeFilter) children = this.table.modules.filter.filter(config.children);
            else children = config.children;
            if (this.table.modExists("sort") && this.table.options.dataTreeSort) this.table.modules.sort.sort(children, sortOnly);
            children.forEach((child)=>{
                output.push(child);
                var subChildren = this.getChildren(child, false, true);
                subChildren.forEach((sub)=>{
                    output.push(sub);
                });
            });
        }
        return output;
    }
    generateChildren(row) {
        var children = [];
        var childArray = row.getData()[this.field];
        if (!Array.isArray(childArray)) childArray = [
            childArray
        ];
        childArray.forEach((childData)=>{
            var childRow = new $c2a9788f40f9c90a$var$Row(childData || {}, this.table.rowManager);
            childRow.create();
            childRow.modules.dataTree.index = row.modules.dataTree.index + 1;
            childRow.modules.dataTree.parent = row;
            if (childRow.modules.dataTree.children) childRow.modules.dataTree.open = this.startOpen(childRow.getComponent(), childRow.modules.dataTree.index);
            children.push(childRow);
        });
        return children;
    }
    expandRow(row, silent) {
        var config = row.modules.dataTree;
        if (config.children !== false) {
            config.open = true;
            row.reinitialize();
            this.refreshData(true);
            this.dispatchExternal("dataTreeRowExpanded", row.getComponent(), row.modules.dataTree.index);
        }
    }
    collapseRow(row) {
        var config = row.modules.dataTree;
        if (config.children !== false) {
            config.open = false;
            row.reinitialize();
            this.refreshData(true);
            this.dispatchExternal("dataTreeRowCollapsed", row.getComponent(), row.modules.dataTree.index);
        }
    }
    toggleRow(row) {
        var config = row.modules.dataTree;
        if (config.children !== false) {
            if (config.open) this.collapseRow(row);
            else this.expandRow(row);
        }
    }
    isRowExpanded(row) {
        return row.modules.dataTree.open;
    }
    getTreeParent(row) {
        return row.modules.dataTree.parent ? row.modules.dataTree.parent.getComponent() : false;
    }
    getTreeParentRoot(row) {
        return row.modules.dataTree && row.modules.dataTree.parent ? this.getTreeParentRoot(row.modules.dataTree.parent) : row;
    }
    getFilteredTreeChildren(row) {
        var config = row.modules.dataTree, output = [], children;
        if (config.children) {
            if (!Array.isArray(config.children)) config.children = this.generateChildren(row);
            if (this.table.modExists("filter") && this.table.options.dataTreeFilter) children = this.table.modules.filter.filter(config.children);
            else children = config.children;
            children.forEach((childRow)=>{
                if (childRow instanceof $c2a9788f40f9c90a$var$Row) output.push(childRow);
            });
        }
        return output;
    }
    rowDelete(row) {
        var parent = row.modules.dataTree.parent, childIndex;
        if (parent) {
            childIndex = this.findChildIndex(row, parent);
            if (childIndex !== false) parent.data[this.field].splice(childIndex, 1);
            if (!parent.data[this.field].length) delete parent.data[this.field];
            this.initializeRow(parent);
            this.layoutRow(parent);
        }
        this.refreshData(true);
    }
    addTreeChildRow(row, data, top, index) {
        var childIndex = false;
        if (typeof data === "string") data = JSON.parse(data);
        if (!Array.isArray(row.data[this.field])) {
            row.data[this.field] = [];
            row.modules.dataTree.open = this.startOpen(row.getComponent(), row.modules.dataTree.index);
        }
        if (typeof index !== "undefined") {
            childIndex = this.findChildIndex(index, row);
            if (childIndex !== false) row.data[this.field].splice(top ? childIndex : childIndex + 1, 0, data);
        }
        if (childIndex === false) {
            if (top) row.data[this.field].unshift(data);
            else row.data[this.field].push(data);
        }
        this.initializeRow(row);
        this.layoutRow(row);
        this.refreshData(true);
    }
    findChildIndex(subject, parent) {
        var match = false;
        if (typeof subject == "object") {
            if (subject instanceof $c2a9788f40f9c90a$var$Row) //subject is row element
            match = subject.data;
            else if (subject instanceof $c2a9788f40f9c90a$export$5df91075f5ba4651) //subject is public row component
            match = subject._getSelf().data;
            else if (typeof HTMLElement !== "undefined" && subject instanceof HTMLElement) {
                if (parent.modules.dataTree) {
                    match = parent.modules.dataTree.children.find((childRow)=>{
                        return childRow instanceof $c2a9788f40f9c90a$var$Row ? childRow.element === subject : false;
                    });
                    if (match) match = match.data;
                }
            } else if (subject === null) match = false;
        } else if (typeof subject == "undefined") match = false;
        else //subject should be treated as the index of the row
        match = parent.data[this.field].find((row)=>{
            return row.data[this.table.options.index] == subject;
        });
        if (match) {
            if (Array.isArray(parent.data[this.field])) match = parent.data[this.field].indexOf(match);
            if (match == -1) match = false;
        }
        //catch all for any other type of input
        return match;
    }
    getTreeChildren(row, component, recurse) {
        var config = row.modules.dataTree, output = [];
        if (config && config.children) {
            if (!Array.isArray(config.children)) config.children = this.generateChildren(row);
            config.children.forEach((childRow)=>{
                if (childRow instanceof $c2a9788f40f9c90a$var$Row) {
                    output.push(component ? childRow.getComponent() : childRow);
                    if (recurse) this.getTreeChildren(childRow, component, recurse).forEach((child)=>{
                        output.push(child);
                    });
                }
            });
        }
        return output;
    }
    getChildField() {
        return this.field;
    }
    redrawNeeded(data) {
        return (this.field ? typeof data[this.field] !== "undefined" : false) || (this.elementField ? typeof data[this.elementField] !== "undefined" : false);
    }
}
function $c2a9788f40f9c90a$var$csv$1(list, options = {}, setFileContents) {
    var delimiter = options.delimiter ? options.delimiter : ",", fileContents = [], headers = [];
    list.forEach((row)=>{
        var item = [];
        switch(row.type){
            case "group":
                console.warn("Download Warning - CSV downloader cannot process row groups");
                break;
            case "calc":
                console.warn("Download Warning - CSV downloader cannot process column calculations");
                break;
            case "header":
                row.columns.forEach((col, i)=>{
                    if (col && col.depth === 1) headers[i] = typeof col.value == "undefined" || col.value === null ? "" : '"' + String(col.value).split('"').join('""') + '"';
                });
                break;
            case "row":
                row.columns.forEach((col)=>{
                    if (col) {
                        switch(typeof col.value){
                            case "object":
                                col.value = col.value !== null ? JSON.stringify(col.value) : "";
                                break;
                            case "undefined":
                                col.value = "";
                                break;
                        }
                        item.push('"' + String(col.value).split('"').join('""') + '"');
                    }
                });
                fileContents.push(item.join(delimiter));
                break;
        }
    });
    if (headers.length) fileContents.unshift(headers.join(delimiter));
    fileContents = fileContents.join("\n");
    if (options.bom) fileContents = "\ufeff" + fileContents;
    setFileContents(fileContents, "text/csv");
}
function $c2a9788f40f9c90a$var$json$2(list, options, setFileContents) {
    var fileContents = [];
    list.forEach((row)=>{
        var item = {};
        switch(row.type){
            case "header":
                break;
            case "group":
                console.warn("Download Warning - JSON downloader cannot process row groups");
                break;
            case "calc":
                console.warn("Download Warning - JSON downloader cannot process column calculations");
                break;
            case "row":
                row.columns.forEach((col)=>{
                    if (col) item[col.component.getTitleDownload() || col.component.getField()] = col.value;
                });
                fileContents.push(item);
                break;
        }
    });
    fileContents = JSON.stringify(fileContents, null, '\t');
    setFileContents(fileContents, "application/json");
}
function $c2a9788f40f9c90a$var$pdf(list, options = {}, setFileContents) {
    var header = [], body = [], autoTableParams = {}, rowGroupStyles = options.rowGroupStyles || {
        fontStyle: "bold",
        fontSize: 12,
        cellPadding: 6,
        fillColor: 220
    }, rowCalcStyles = options.rowCalcStyles || {
        fontStyle: "bold",
        fontSize: 10,
        cellPadding: 4,
        fillColor: 232
    }, jsPDFParams = options.jsPDF || {}, title = options.title ? options.title : "", jspdfLib, doc;
    if (!jsPDFParams.orientation) jsPDFParams.orientation = options.orientation || "landscape";
    if (!jsPDFParams.unit) jsPDFParams.unit = "pt";
    //parse row list
    list.forEach((row)=>{
        switch(row.type){
            case "header":
                header.push(parseRow(row));
                break;
            case "group":
                body.push(parseRow(row, rowGroupStyles));
                break;
            case "calc":
                body.push(parseRow(row, rowCalcStyles));
                break;
            case "row":
                body.push(parseRow(row));
                break;
        }
    });
    function parseRow(row, styles) {
        var rowData = [];
        row.columns.forEach((col)=>{
            var cell;
            if (col) {
                switch(typeof col.value){
                    case "object":
                        col.value = col.value !== null ? JSON.stringify(col.value) : "";
                        break;
                    case "undefined":
                        col.value = "";
                        break;
                }
                cell = {
                    content: col.value,
                    colSpan: col.width,
                    rowSpan: col.height
                };
                if (styles) cell.styles = styles;
                rowData.push(cell);
            }
        });
        return rowData;
    }
    //configure PDF
    jspdfLib = this.dependencyRegistry.lookup("jspdf", "jsPDF");
    doc = new jspdfLib(jsPDFParams); //set document to landscape, better for most tables
    if (options.autoTable) {
        if (typeof options.autoTable === "function") autoTableParams = options.autoTable(doc) || {};
        else autoTableParams = options.autoTable;
    }
    if (title) autoTableParams.didDrawPage = function(data) {
        doc.text(title, 40, 30);
    };
    autoTableParams.head = header;
    autoTableParams.body = body;
    doc.autoTable(autoTableParams);
    if (options.documentProcessing) options.documentProcessing(doc);
    setFileContents(doc.output("arraybuffer"), "application/pdf");
}
function $c2a9788f40f9c90a$var$xlsx$1(list, options, setFileContents) {
    var self = this, sheetName = options.sheetName || "Sheet1", XLSXLib = this.dependencyRegistry.lookup("XLSX"), workbook = XLSXLib.utils.book_new(), tableFeatures = new $c2a9788f40f9c90a$var$CoreFeature(this), compression = 'compress' in options ? options.compress : true, writeOptions = options.writeOptions || {
        bookType: 'xlsx',
        bookSST: true,
        compression: compression
    }, output;
    writeOptions.type = 'binary';
    workbook.SheetNames = [];
    workbook.Sheets = {};
    function generateSheet() {
        var rows = [], merges = [], worksheet = {}, range = {
            s: {
                c: 0,
                r: 0
            },
            e: {
                c: list[0] ? list[0].columns.reduce((a, b)=>a + (b && b.width ? b.width : 1), 0) : 0,
                r: list.length
            }
        };
        //parse row list
        list.forEach((row, i)=>{
            var rowData = [];
            row.columns.forEach(function(col, j) {
                if (col) {
                    rowData.push(!(col.value instanceof Date) && typeof col.value === "object" ? JSON.stringify(col.value) : col.value);
                    if (col.width > 1 || col.height > -1) {
                        if (col.height > 1 || col.width > 1) merges.push({
                            s: {
                                r: i,
                                c: j
                            },
                            e: {
                                r: i + col.height - 1,
                                c: j + col.width - 1
                            }
                        });
                    }
                } else rowData.push("");
            });
            rows.push(rowData);
        });
        //convert rows to worksheet
        XLSXLib.utils.sheet_add_aoa(worksheet, rows);
        worksheet['!ref'] = XLSXLib.utils.encode_range(range);
        if (merges.length) worksheet["!merges"] = merges;
        return worksheet;
    }
    if (options.sheetOnly) {
        setFileContents(generateSheet());
        return;
    }
    if (options.sheets) {
        for(var sheet in options.sheets)if (options.sheets[sheet] === true) {
            workbook.SheetNames.push(sheet);
            workbook.Sheets[sheet] = generateSheet();
        } else {
            workbook.SheetNames.push(sheet);
            tableFeatures.commsSend(options.sheets[sheet], "download", "intercept", {
                type: "xlsx",
                options: {
                    sheetOnly: true
                },
                active: self.active,
                intercept: function(data) {
                    workbook.Sheets[sheet] = data;
                }
            });
        }
    } else {
        workbook.SheetNames.push(sheetName);
        workbook.Sheets[sheetName] = generateSheet();
    }
    if (options.documentProcessing) workbook = options.documentProcessing(workbook);
    //convert workbook to binary array
    function s2ab(s) {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for(var i = 0; i != s.length; ++i)view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
    }
    output = XLSXLib.write(workbook, writeOptions);
    setFileContents(s2ab(output), "application/octet-stream");
}
function $c2a9788f40f9c90a$var$html$1(list, options, setFileContents) {
    if (this.modExists("export", true)) setFileContents(this.modules.export.generateHTMLTable(list), "text/html");
}
function $c2a9788f40f9c90a$var$jsonLines(list, options, setFileContents) {
    const fileContents = [];
    list.forEach((row)=>{
        const item = {};
        switch(row.type){
            case "header":
                break;
            case "group":
                console.warn("Download Warning - JSON downloader cannot process row groups");
                break;
            case "calc":
                console.warn("Download Warning - JSON downloader cannot process column calculations");
                break;
            case "row":
                row.columns.forEach((col)=>{
                    if (col) item[col.component.getTitleDownload() || col.component.getField()] = col.value;
                });
                fileContents.push(JSON.stringify(item));
                break;
        }
    });
    setFileContents(fileContents.join("\n"), "application/x-ndjson");
}
var $c2a9788f40f9c90a$var$defaultDownloaders = {
    csv: $c2a9788f40f9c90a$var$csv$1,
    json: $c2a9788f40f9c90a$var$json$2,
    jsonLines: $c2a9788f40f9c90a$var$jsonLines,
    pdf: $c2a9788f40f9c90a$var$pdf,
    xlsx: $c2a9788f40f9c90a$var$xlsx$1,
    html: $c2a9788f40f9c90a$var$html$1
};
class $c2a9788f40f9c90a$export$6dd96c6d41f32a97 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "download";
    //load defaults
    static downloaders = $c2a9788f40f9c90a$var$defaultDownloaders;
    constructor(table){
        super(table);
        this.registerTableOption("downloadEncoder", function(data, mimeType) {
            return new Blob([
                data
            ], {
                type: mimeType
            });
        }); //function to manipulate download data
        // this.registerTableOption("downloadReady", undefined); //warn of function deprecation
        this.registerTableOption("downloadConfig", {}); //download config
        this.registerTableOption("downloadRowRange", "active"); //restrict download to active rows only
        this.registerColumnOption("download");
        this.registerColumnOption("titleDownload");
    }
    initialize() {
        this.deprecatedOptionsCheck();
        this.registerTableFunction("download", this.download.bind(this));
        this.registerTableFunction("downloadToTab", this.downloadToTab.bind(this));
    }
    deprecatedOptionsCheck() {
    // this.deprecationCheck("downloadReady", "downloadEncoder");
    }
    ///////////////////////////////////
    ///////// Table Functions /////////
    ///////////////////////////////////
    downloadToTab(type, filename, options, active) {
        this.download(type, filename, options, active, true);
    }
    ///////////////////////////////////
    ///////// Internal Logic //////////
    ///////////////////////////////////
    //trigger file download
    download(type, filename, options, range, interceptCallback) {
        var downloadFunc = false;
        function buildLink(data, mime) {
            if (interceptCallback) {
                if (interceptCallback === true) this.triggerDownload(data, mime, type, filename, true);
                else interceptCallback(data);
            } else this.triggerDownload(data, mime, type, filename);
        }
        if (typeof type == "function") downloadFunc = type;
        else if ($c2a9788f40f9c90a$export$6dd96c6d41f32a97.downloaders[type]) downloadFunc = $c2a9788f40f9c90a$export$6dd96c6d41f32a97.downloaders[type];
        else console.warn("Download Error - No such download type found: ", type);
        if (downloadFunc) {
            var list = this.generateExportList(range);
            downloadFunc.call(this.table, list, options || {}, buildLink.bind(this));
        }
    }
    generateExportList(range) {
        var list = this.table.modules.export.generateExportList(this.table.options.downloadConfig, false, range || this.table.options.downloadRowRange, "download");
        //assign group header formatter
        var groupHeader = this.table.options.groupHeaderDownload;
        if (groupHeader && !Array.isArray(groupHeader)) groupHeader = [
            groupHeader
        ];
        list.forEach((row)=>{
            var group;
            if (row.type === "group") {
                group = row.columns[0];
                if (groupHeader && groupHeader[row.indent]) group.value = groupHeader[row.indent](group.value, row.component._group.getRowCount(), row.component._group.getData(), row.component);
            }
        });
        return list;
    }
    triggerDownload(data, mime, type, filename, newTab) {
        var element = document.createElement('a'), blob = this.table.options.downloadEncoder(data, mime);
        if (blob) {
            if (newTab) window.open(window.URL.createObjectURL(blob));
            else {
                filename = filename || "Tabulator." + (typeof type === "function" ? "txt" : type);
                if (navigator.msSaveOrOpenBlob) navigator.msSaveOrOpenBlob(blob, filename);
                else {
                    element.setAttribute('href', window.URL.createObjectURL(blob));
                    //set file title
                    element.setAttribute('download', filename);
                    //trigger download
                    element.style.display = 'none';
                    document.body.appendChild(element);
                    element.click();
                    //remove temporary link element
                    document.body.removeChild(element);
                }
            }
            this.dispatchExternal("downloadComplete");
        }
    }
    commsReceived(table, action, data) {
        switch(action){
            case "intercept":
                this.download(data.type, "", data.options, data.active, data.intercept);
                break;
        }
    }
}
function $c2a9788f40f9c90a$var$maskInput(el, options) {
    var mask = options.mask, maskLetter = typeof options.maskLetterChar !== "undefined" ? options.maskLetterChar : "A", maskNumber = typeof options.maskNumberChar !== "undefined" ? options.maskNumberChar : "9", maskWildcard = typeof options.maskWildcardChar !== "undefined" ? options.maskWildcardChar : "*";
    function fillSymbols(index) {
        var symbol = mask[index];
        if (typeof symbol !== "undefined" && symbol !== maskWildcard && symbol !== maskLetter && symbol !== maskNumber) {
            el.value = el.value + "" + symbol;
            fillSymbols(index + 1);
        }
    }
    el.addEventListener("keydown", (e)=>{
        var index = el.value.length, char = e.key;
        if (e.keyCode > 46 && !e.ctrlKey && !e.metaKey) {
            if (index >= mask.length) {
                e.preventDefault();
                e.stopPropagation();
                return false;
            } else switch(mask[index]){
                case maskLetter:
                    if (char.toUpperCase() == char.toLowerCase()) {
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                    }
                    break;
                case maskNumber:
                    if (isNaN(char)) {
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                    }
                    break;
                case maskWildcard:
                    break;
                default:
                    if (char !== mask[index]) {
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                    }
            }
        }
        return;
    });
    el.addEventListener("keyup", (e)=>{
        if (e.keyCode > 46) {
            if (options.maskAutoFill) fillSymbols(el.value.length);
        }
    });
    if (!el.placeholder) el.placeholder = mask;
    if (options.maskAutoFill) fillSymbols(el.value.length);
}
//input element
function $c2a9788f40f9c90a$var$input(cell, onRendered, success, cancel, editorParams) {
    //create and style input
    var cellValue = cell.getValue(), input = document.createElement("input");
    input.setAttribute("type", editorParams.search ? "search" : "text");
    input.style.padding = "4px";
    input.style.width = "100%";
    input.style.boxSizing = "border-box";
    if (editorParams.elementAttributes && typeof editorParams.elementAttributes == "object") {
        for(let key in editorParams.elementAttributes)if (key.charAt(0) == "+") {
            key = key.slice(1);
            input.setAttribute(key, input.getAttribute(key) + editorParams.elementAttributes["+" + key]);
        } else input.setAttribute(key, editorParams.elementAttributes[key]);
    }
    input.value = typeof cellValue !== "undefined" ? cellValue : "";
    onRendered(function() {
        if (cell.getType() === "cell") {
            input.focus({
                preventScroll: true
            });
            input.style.height = "100%";
            if (editorParams.selectContents) input.select();
        }
    });
    function onChange(e) {
        if ((cellValue === null || typeof cellValue === "undefined") && input.value !== "" || input.value !== cellValue) {
            if (success(input.value)) cellValue = input.value; //persist value if successfully validated incase editor is used as header filter
        } else cancel();
    }
    //submit new value on blur or change
    input.addEventListener("change", onChange);
    input.addEventListener("blur", onChange);
    //submit new value on enter
    input.addEventListener("keydown", function(e) {
        switch(e.keyCode){
            // case 9:
            case 13:
                onChange();
                break;
            case 27:
                cancel();
                break;
            case 35:
            case 36:
                e.stopPropagation();
                break;
        }
    });
    if (editorParams.mask) $c2a9788f40f9c90a$var$maskInput(input, editorParams);
    return input;
}
//resizable text area element
function $c2a9788f40f9c90a$var$textarea$1(cell, onRendered, success, cancel, editorParams) {
    var cellValue = cell.getValue(), vertNav = editorParams.verticalNavigation || "hybrid", value = String(cellValue !== null && typeof cellValue !== "undefined" ? cellValue : ""), input = document.createElement("textarea"), scrollHeight = 0;
    //create and style input
    input.style.display = "block";
    input.style.padding = "2px";
    input.style.height = "100%";
    input.style.width = "100%";
    input.style.boxSizing = "border-box";
    input.style.whiteSpace = "pre-wrap";
    input.style.resize = "none";
    if (editorParams.elementAttributes && typeof editorParams.elementAttributes == "object") {
        for(let key in editorParams.elementAttributes)if (key.charAt(0) == "+") {
            key = key.slice(1);
            input.setAttribute(key, input.getAttribute(key) + editorParams.elementAttributes["+" + key]);
        } else input.setAttribute(key, editorParams.elementAttributes[key]);
    }
    input.value = value;
    onRendered(function() {
        if (cell.getType() === "cell") {
            input.focus({
                preventScroll: true
            });
            input.style.height = "100%";
            input.scrollHeight;
            input.style.height = input.scrollHeight + "px";
            cell.getRow().normalizeHeight();
            if (editorParams.selectContents) input.select();
        }
    });
    function onChange(e) {
        if ((cellValue === null || typeof cellValue === "undefined") && input.value !== "" || input.value !== cellValue) {
            if (success(input.value)) cellValue = input.value; //persist value if successfully validated incase editor is used as header filter
            setTimeout(function() {
                cell.getRow().normalizeHeight();
            }, 300);
        } else cancel();
    }
    //submit new value on blur or change
    input.addEventListener("change", onChange);
    input.addEventListener("blur", onChange);
    input.addEventListener("keyup", function() {
        input.style.height = "";
        var heightNow = input.scrollHeight;
        input.style.height = heightNow + "px";
        if (heightNow != scrollHeight) {
            scrollHeight = heightNow;
            cell.getRow().normalizeHeight();
        }
    });
    input.addEventListener("keydown", function(e) {
        switch(e.keyCode){
            case 13:
                if (e.shiftKey && editorParams.shiftEnterSubmit) onChange();
                break;
            case 27:
                cancel();
                break;
            case 38:
                if (vertNav == "editor" || vertNav == "hybrid" && input.selectionStart) {
                    e.stopImmediatePropagation();
                    e.stopPropagation();
                }
                break;
            case 40:
                if (vertNav == "editor" || vertNav == "hybrid" && input.selectionStart !== input.value.length) {
                    e.stopImmediatePropagation();
                    e.stopPropagation();
                }
                break;
            case 35:
            case 36:
                e.stopPropagation();
                break;
        }
    });
    if (editorParams.mask) $c2a9788f40f9c90a$var$maskInput(input, editorParams);
    return input;
}
//input element with type of number
function $c2a9788f40f9c90a$var$number$1(cell, onRendered, success, cancel, editorParams) {
    var cellValue = cell.getValue(), vertNav = editorParams.verticalNavigation || "editor", input = document.createElement("input");
    input.setAttribute("type", "number");
    if (typeof editorParams.max != "undefined") input.setAttribute("max", editorParams.max);
    if (typeof editorParams.min != "undefined") input.setAttribute("min", editorParams.min);
    if (typeof editorParams.step != "undefined") input.setAttribute("step", editorParams.step);
    //create and style input
    input.style.padding = "4px";
    input.style.width = "100%";
    input.style.boxSizing = "border-box";
    if (editorParams.elementAttributes && typeof editorParams.elementAttributes == "object") {
        for(let key in editorParams.elementAttributes)if (key.charAt(0) == "+") {
            key = key.slice(1);
            input.setAttribute(key, input.getAttribute(key) + editorParams.elementAttributes["+" + key]);
        } else input.setAttribute(key, editorParams.elementAttributes[key]);
    }
    input.value = cellValue;
    var blurFunc = function(e) {
        onChange();
    };
    onRendered(function() {
        if (cell.getType() === "cell") {
            //submit new value on blur
            input.removeEventListener("blur", blurFunc);
            input.focus({
                preventScroll: true
            });
            input.style.height = "100%";
            //submit new value on blur
            input.addEventListener("blur", blurFunc);
            if (editorParams.selectContents) input.select();
        }
    });
    function onChange() {
        var value = input.value;
        if (!isNaN(value) && value !== "") value = Number(value);
        if (value !== cellValue) {
            if (success(value)) cellValue = value; //persist value if successfully validated incase editor is used as header filter
        } else cancel();
    }
    //submit new value on enter
    input.addEventListener("keydown", function(e) {
        switch(e.keyCode){
            case 13:
                // case 9:
                onChange();
                break;
            case 27:
                cancel();
                break;
            case 38:
            case 40:
                if (vertNav == "editor") {
                    e.stopImmediatePropagation();
                    e.stopPropagation();
                }
                break;
            case 35:
            case 36:
                e.stopPropagation();
                break;
        }
    });
    if (editorParams.mask) $c2a9788f40f9c90a$var$maskInput(input, editorParams);
    return input;
}
//input element with type of number
function $c2a9788f40f9c90a$var$range(cell, onRendered, success, cancel, editorParams) {
    var cellValue = cell.getValue(), input = document.createElement("input");
    input.setAttribute("type", "range");
    if (typeof editorParams.max != "undefined") input.setAttribute("max", editorParams.max);
    if (typeof editorParams.min != "undefined") input.setAttribute("min", editorParams.min);
    if (typeof editorParams.step != "undefined") input.setAttribute("step", editorParams.step);
    //create and style input
    input.style.padding = "4px";
    input.style.width = "100%";
    input.style.boxSizing = "border-box";
    if (editorParams.elementAttributes && typeof editorParams.elementAttributes == "object") {
        for(let key in editorParams.elementAttributes)if (key.charAt(0) == "+") {
            key = key.slice(1);
            input.setAttribute(key, input.getAttribute(key) + editorParams.elementAttributes["+" + key]);
        } else input.setAttribute(key, editorParams.elementAttributes[key]);
    }
    input.value = cellValue;
    onRendered(function() {
        if (cell.getType() === "cell") {
            input.focus({
                preventScroll: true
            });
            input.style.height = "100%";
        }
    });
    function onChange() {
        var value = input.value;
        if (!isNaN(value) && value !== "") value = Number(value);
        if (value != cellValue) {
            if (success(value)) cellValue = value; //persist value if successfully validated incase editor is used as header filter
        } else cancel();
    }
    //submit new value on blur
    input.addEventListener("blur", function(e) {
        onChange();
    });
    //submit new value on enter
    input.addEventListener("keydown", function(e) {
        switch(e.keyCode){
            case 13:
                // case 9:
                onChange();
                break;
            case 27:
                cancel();
                break;
        }
    });
    return input;
}
//input element
function $c2a9788f40f9c90a$var$date$1(cell, onRendered, success, cancel, editorParams) {
    var inputFormat = editorParams.format, vertNav = editorParams.verticalNavigation || "editor", DT = inputFormat ? window.DateTime || luxon.DateTime : null;
    //create and style input
    var cellValue = cell.getValue(), input = document.createElement("input");
    function convertDate(value) {
        var newDatetime;
        if (DT.isDateTime(value)) newDatetime = value;
        else if (inputFormat === "iso") newDatetime = DT.fromISO(String(value));
        else newDatetime = DT.fromFormat(String(value), inputFormat);
        return newDatetime.toFormat("yyyy-MM-dd");
    }
    input.type = "date";
    input.style.padding = "4px";
    input.style.width = "100%";
    input.style.boxSizing = "border-box";
    if (editorParams.max) input.setAttribute("max", inputFormat ? convertDate(editorParams.max) : editorParams.max);
    if (editorParams.min) input.setAttribute("min", inputFormat ? convertDate(editorParams.min) : editorParams.min);
    if (editorParams.elementAttributes && typeof editorParams.elementAttributes == "object") {
        for(let key in editorParams.elementAttributes)if (key.charAt(0) == "+") {
            key = key.slice(1);
            input.setAttribute(key, input.getAttribute(key) + editorParams.elementAttributes["+" + key]);
        } else input.setAttribute(key, editorParams.elementAttributes[key]);
    }
    cellValue = typeof cellValue !== "undefined" ? cellValue : "";
    if (inputFormat) {
        if (DT) cellValue = convertDate(cellValue);
        else console.error("Editor Error - 'date' editor 'format' param is dependant on luxon.js");
    }
    input.value = cellValue;
    onRendered(function() {
        if (cell.getType() === "cell") {
            input.focus({
                preventScroll: true
            });
            input.style.height = "100%";
            if (editorParams.selectContents) input.select();
        }
    });
    function onChange() {
        var value = input.value, luxDate;
        if ((cellValue === null || typeof cellValue === "undefined") && value !== "" || value !== cellValue) {
            if (value && inputFormat) {
                luxDate = DT.fromFormat(String(value), "yyyy-MM-dd");
                switch(inputFormat){
                    case true:
                        value = luxDate;
                        break;
                    case "iso":
                        value = luxDate.toISO();
                        break;
                    default:
                        value = luxDate.toFormat(inputFormat);
                }
            }
            if (success(value)) cellValue = input.value; //persist value if successfully validated incase editor is used as header filter
        } else cancel();
    }
    //submit new value on blur
    input.addEventListener("blur", function(e) {
        if (e.relatedTarget || e.rangeParent || e.explicitOriginalTarget !== input) onChange(); // only on a "true" blur; not when focusing browser's date/time picker
    });
    //submit new value on enter
    input.addEventListener("keydown", function(e) {
        switch(e.keyCode){
            // case 9:
            case 13:
                onChange();
                break;
            case 27:
                cancel();
                break;
            case 35:
            case 36:
                e.stopPropagation();
                break;
            case 38:
            case 40:
                if (vertNav == "editor") {
                    e.stopImmediatePropagation();
                    e.stopPropagation();
                }
                break;
        }
    });
    return input;
}
//input element
function $c2a9788f40f9c90a$var$time$1(cell, onRendered, success, cancel, editorParams) {
    var inputFormat = editorParams.format, vertNav = editorParams.verticalNavigation || "editor", DT = inputFormat ? window.DateTime || luxon.DateTime : null, newDatetime;
    //create and style input
    var cellValue = cell.getValue(), input = document.createElement("input");
    input.type = "time";
    input.style.padding = "4px";
    input.style.width = "100%";
    input.style.boxSizing = "border-box";
    if (editorParams.elementAttributes && typeof editorParams.elementAttributes == "object") {
        for(let key in editorParams.elementAttributes)if (key.charAt(0) == "+") {
            key = key.slice(1);
            input.setAttribute(key, input.getAttribute(key) + editorParams.elementAttributes["+" + key]);
        } else input.setAttribute(key, editorParams.elementAttributes[key]);
    }
    cellValue = typeof cellValue !== "undefined" ? cellValue : "";
    if (inputFormat) {
        if (DT) {
            if (DT.isDateTime(cellValue)) newDatetime = cellValue;
            else if (inputFormat === "iso") newDatetime = DT.fromISO(String(cellValue));
            else newDatetime = DT.fromFormat(String(cellValue), inputFormat);
            cellValue = newDatetime.toFormat("HH:mm");
        } else console.error("Editor Error - 'date' editor 'format' param is dependant on luxon.js");
    }
    input.value = cellValue;
    onRendered(function() {
        if (cell.getType() == "cell") {
            input.focus({
                preventScroll: true
            });
            input.style.height = "100%";
            if (editorParams.selectContents) input.select();
        }
    });
    function onChange() {
        var value = input.value, luxTime;
        if ((cellValue === null || typeof cellValue === "undefined") && value !== "" || value !== cellValue) {
            if (value && inputFormat) {
                luxTime = DT.fromFormat(String(value), "hh:mm");
                switch(inputFormat){
                    case true:
                        value = luxTime;
                        break;
                    case "iso":
                        value = luxTime.toISO();
                        break;
                    default:
                        value = luxTime.toFormat(inputFormat);
                }
            }
            if (success(value)) cellValue = input.value; //persist value if successfully validated incase editor is used as header filter
        } else cancel();
    }
    //submit new value on blur
    input.addEventListener("blur", function(e) {
        if (e.relatedTarget || e.rangeParent || e.explicitOriginalTarget !== input) onChange(); // only on a "true" blur; not when focusing browser's date/time picker
    });
    //submit new value on enter
    input.addEventListener("keydown", function(e) {
        switch(e.keyCode){
            // case 9:
            case 13:
                onChange();
                break;
            case 27:
                cancel();
                break;
            case 35:
            case 36:
                e.stopPropagation();
                break;
            case 38:
            case 40:
                if (vertNav == "editor") {
                    e.stopImmediatePropagation();
                    e.stopPropagation();
                }
                break;
        }
    });
    return input;
}
//input element
function $c2a9788f40f9c90a$var$datetime$2(cell, onRendered, success, cancel, editorParams) {
    var inputFormat = editorParams.format, vertNav = editorParams.verticalNavigation || "editor", DT = inputFormat ? this.table.dependencyRegistry.lookup([
        "luxon",
        "DateTime"
    ], "DateTime") : null, newDatetime;
    //create and style input
    var cellValue = cell.getValue(), input = document.createElement("input");
    input.type = "datetime-local";
    input.style.padding = "4px";
    input.style.width = "100%";
    input.style.boxSizing = "border-box";
    if (editorParams.elementAttributes && typeof editorParams.elementAttributes == "object") {
        for(let key in editorParams.elementAttributes)if (key.charAt(0) == "+") {
            key = key.slice(1);
            input.setAttribute(key, input.getAttribute(key) + editorParams.elementAttributes["+" + key]);
        } else input.setAttribute(key, editorParams.elementAttributes[key]);
    }
    cellValue = typeof cellValue !== "undefined" ? cellValue : "";
    if (inputFormat) {
        if (DT) {
            if (DT.isDateTime(cellValue)) newDatetime = cellValue;
            else if (inputFormat === "iso") newDatetime = DT.fromISO(String(cellValue));
            else newDatetime = DT.fromFormat(String(cellValue), inputFormat);
            cellValue = newDatetime.toFormat("yyyy-MM-dd") + "T" + newDatetime.toFormat("HH:mm");
        } else console.error("Editor Error - 'date' editor 'format' param is dependant on luxon.js");
    }
    input.value = cellValue;
    onRendered(function() {
        if (cell.getType() === "cell") {
            input.focus({
                preventScroll: true
            });
            input.style.height = "100%";
            if (editorParams.selectContents) input.select();
        }
    });
    function onChange() {
        var value = input.value, luxDateTime;
        if ((cellValue === null || typeof cellValue === "undefined") && value !== "" || value !== cellValue) {
            if (value && inputFormat) {
                luxDateTime = DT.fromISO(String(value));
                switch(inputFormat){
                    case true:
                        value = luxDateTime;
                        break;
                    case "iso":
                        value = luxDateTime.toISO();
                        break;
                    default:
                        value = luxDateTime.toFormat(inputFormat);
                }
            }
            if (success(value)) cellValue = input.value; //persist value if successfully validated incase editor is used as header filter
        } else cancel();
    }
    //submit new value on blur
    input.addEventListener("blur", function(e) {
        if (e.relatedTarget || e.rangeParent || e.explicitOriginalTarget !== input) onChange(); // only on a "true" blur; not when focusing browser's date/time picker
    });
    //submit new value on enter
    input.addEventListener("keydown", function(e) {
        switch(e.keyCode){
            // case 9:
            case 13:
                onChange();
                break;
            case 27:
                cancel();
                break;
            case 35:
            case 36:
                e.stopPropagation();
                break;
            case 38:
            case 40:
                if (vertNav == "editor") {
                    e.stopImmediatePropagation();
                    e.stopPropagation();
                }
                break;
        }
    });
    return input;
}
let $c2a9788f40f9c90a$var$Edit$1 = class Edit {
    constructor(editor, cell, onRendered, success, cancel, editorParams){
        this.edit = editor;
        this.table = editor.table;
        this.cell = cell;
        this.params = this._initializeParams(editorParams);
        this.data = [];
        this.displayItems = [];
        this.currentItems = [];
        this.focusedItem = null;
        this.input = this._createInputElement();
        this.listEl = this._createListElement();
        this.initialValues = null;
        this.isFilter = cell.getType() === "header";
        this.filterTimeout = null;
        this.filtered = false;
        this.typing = false;
        this.values = [];
        this.popup = null;
        this.listIteration = 0;
        this.lastAction = "";
        this.filterTerm = "";
        this.blurable = true;
        this.actions = {
            success: success,
            cancel: cancel
        };
        this._deprecatedOptionsCheck();
        this._initializeValue();
        onRendered(this._onRendered.bind(this));
    }
    _deprecatedOptionsCheck() {
    // if(this.params.listItemFormatter){
    // 	this.cell.getTable().deprecationAdvisor.msg("The listItemFormatter editor param has been deprecated, please see the latest editor documentation for updated options");
    // }
    // if(this.params.sortValuesList){
    // 	this.cell.getTable().deprecationAdvisor.msg("The sortValuesList editor param has been deprecated, please see the latest editor documentation for updated options");
    // }
    // if(this.params.searchFunc){
    // 	this.cell.getTable().deprecationAdvisor.msg("The searchFunc editor param has been deprecated, please see the latest editor documentation for updated options");
    // }
    // if(this.params.searchingPlaceholder){
    // 	this.cell.getTable().deprecationAdvisor.msg("The searchingPlaceholder editor param has been deprecated, please see the latest editor documentation for updated options");
    // }
    }
    _initializeValue() {
        var initialValue = this.cell.getValue();
        if (typeof initialValue === "undefined" && typeof this.params.defaultValue !== "undefined") initialValue = this.params.defaultValue;
        this.initialValues = this.params.multiselect ? initialValue : [
            initialValue
        ];
        if (this.isFilter) {
            this.input.value = this.initialValues ? this.initialValues.join(",") : "";
            this.headerFilterInitialListGen();
        }
    }
    _onRendered() {
        var cellEl = this.cell.getElement();
        function clickStop(e) {
            e.stopPropagation();
        }
        if (!this.isFilter) {
            this.input.style.height = "100%";
            this.input.focus({
                preventScroll: true
            });
        }
        cellEl.addEventListener("click", clickStop);
        setTimeout(()=>{
            cellEl.removeEventListener("click", clickStop);
        }, 1000);
        this.input.addEventListener("mousedown", this._preventPopupBlur.bind(this));
    }
    _createListElement() {
        var listEl = document.createElement("div");
        listEl.classList.add("tabulator-edit-list");
        listEl.addEventListener("mousedown", this._preventBlur.bind(this));
        listEl.addEventListener("keydown", this._inputKeyDown.bind(this));
        return listEl;
    }
    _setListWidth() {
        var element = this.isFilter ? this.input : this.cell.getElement();
        this.listEl.style.minWidth = element.offsetWidth + "px";
        if (this.params.maxWidth) {
            if (this.params.maxWidth === true) this.listEl.style.maxWidth = element.offsetWidth + "px";
            else if (typeof this.params.maxWidth === "number") this.listEl.style.maxWidth = this.params.maxWidth + "px";
            else this.listEl.style.maxWidth = this.params.maxWidth;
        }
    }
    _createInputElement() {
        var attribs = this.params.elementAttributes;
        var input = document.createElement("input");
        input.setAttribute("type", this.params.clearable ? "search" : "text");
        input.style.padding = "4px";
        input.style.width = "100%";
        input.style.boxSizing = "border-box";
        if (!this.params.autocomplete) {
            input.style.cursor = "default";
            input.style.caretColor = "transparent";
        // input.readOnly = (this.edit.currentCell != false);
        }
        if (attribs && typeof attribs == "object") {
            for(let key in attribs)if (key.charAt(0) == "+") {
                key = key.slice(1);
                input.setAttribute(key, input.getAttribute(key) + attribs["+" + key]);
            } else input.setAttribute(key, attribs[key]);
        }
        if (this.params.mask) $c2a9788f40f9c90a$var$maskInput(input, this.params);
        this._bindInputEvents(input);
        return input;
    }
    _initializeParams(params) {
        var valueKeys = [
            "values",
            "valuesURL",
            "valuesLookup"
        ], valueCheck;
        params = Object.assign({}, params);
        params.verticalNavigation = params.verticalNavigation || "editor";
        params.placeholderLoading = typeof params.placeholderLoading === "undefined" ? "Searching ..." : params.placeholderLoading;
        params.placeholderEmpty = typeof params.placeholderEmpty === "undefined" ? "No Results Found" : params.placeholderEmpty;
        params.filterDelay = typeof params.filterDelay === "undefined" ? 300 : params.filterDelay;
        params.emptyValue = Object.keys(params).includes("emptyValue") ? params.emptyValue : "";
        valueCheck = Object.keys(params).filter((key)=>valueKeys.includes(key)).length;
        if (!valueCheck) console.warn("list editor config error - either the values, valuesURL, or valuesLookup option must be set");
        else if (valueCheck > 1) console.warn("list editor config error - only one of the values, valuesURL, or valuesLookup options can be set on the same editor");
        if (params.autocomplete) {
            if (params.multiselect) {
                params.multiselect = false;
                console.warn("list editor config error - multiselect option is not available when autocomplete is enabled");
            }
        } else {
            if (params.freetext) {
                params.freetext = false;
                console.warn("list editor config error - freetext option is only available when autocomplete is enabled");
            }
            if (params.filterFunc) {
                params.filterFunc = false;
                console.warn("list editor config error - filterFunc option is only available when autocomplete is enabled");
            }
            if (params.filterRemote) {
                params.filterRemote = false;
                console.warn("list editor config error - filterRemote option is only available when autocomplete is enabled");
            }
            if (params.mask) {
                params.mask = false;
                console.warn("list editor config error - mask option is only available when autocomplete is enabled");
            }
            if (params.allowEmpty) {
                params.allowEmpty = false;
                console.warn("list editor config error - allowEmpty option is only available when autocomplete is enabled");
            }
            if (params.listOnEmpty) {
                params.listOnEmpty = false;
                console.warn("list editor config error - listOnEmpty option is only available when autocomplete is enabled");
            }
        }
        if (params.filterRemote && !(typeof params.valuesLookup === "function" || params.valuesURL)) {
            params.filterRemote = false;
            console.warn("list editor config error - filterRemote option should only be used when values list is populated from a remote source");
        }
        return params;
    }
    //////////////////////////////////////
    ////////// Event Handling ////////////
    //////////////////////////////////////
    _bindInputEvents(input) {
        input.addEventListener("focus", this._inputFocus.bind(this));
        input.addEventListener("click", this._inputClick.bind(this));
        input.addEventListener("blur", this._inputBlur.bind(this));
        input.addEventListener("keydown", this._inputKeyDown.bind(this));
        input.addEventListener("search", this._inputSearch.bind(this));
        if (this.params.autocomplete) input.addEventListener("keyup", this._inputKeyUp.bind(this));
    }
    _inputFocus(e) {
        this.rebuildOptionsList();
    }
    _filter() {
        if (this.params.filterRemote) {
            clearTimeout(this.filterTimeout);
            this.filterTimeout = setTimeout(()=>{
                this.rebuildOptionsList();
            }, this.params.filterDelay);
        } else this._filterList();
    }
    _inputClick(e) {
        e.stopPropagation();
    }
    _inputBlur(e) {
        if (this.blurable) {
            if (this.popup) this.popup.hide();
            else this._resolveValue(true);
        }
    }
    _inputSearch() {
        this._clearChoices();
    }
    _inputKeyDown(e) {
        switch(e.keyCode){
            case 38:
                this._keyUp(e);
                break;
            case 40:
                this._keyDown(e);
                break;
            case 37:
            case 39:
                this._keySide(e);
                break;
            case 13:
                this._keyEnter();
                break;
            case 27:
                this._keyEsc();
                break;
            case 36:
            case 35:
                this._keyHomeEnd(e);
                break;
            case 9:
                this._keyTab(e);
                break;
            default:
                this._keySelectLetter(e);
        }
    }
    _inputKeyUp(e) {
        switch(e.keyCode){
            case 38:
            case 37:
            case 39:
            case 40:
            case 13:
            case 27:
                break;
            default:
                this._keyAutoCompLetter(e);
        }
    }
    _preventPopupBlur() {
        if (this.popup) this.popup.blockHide();
        setTimeout(()=>{
            if (this.popup) this.popup.restoreHide();
        }, 10);
    }
    _preventBlur() {
        this.blurable = false;
        setTimeout(()=>{
            this.blurable = true;
        }, 10);
    }
    //////////////////////////////////////
    //////// Keyboard Navigation /////////
    //////////////////////////////////////
    _keyTab(e) {
        if (this.params.autocomplete && this.lastAction === "typing") this._resolveValue(true);
        else if (this.focusedItem) this._chooseItem(this.focusedItem, true);
    }
    _keyUp(e) {
        var index = this.displayItems.indexOf(this.focusedItem);
        if (this.params.verticalNavigation == "editor" || this.params.verticalNavigation == "hybrid" && index) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            e.preventDefault();
            if (index > 0) this._focusItem(this.displayItems[index - 1]);
        }
    }
    _keyDown(e) {
        var index = this.displayItems.indexOf(this.focusedItem);
        if (this.params.verticalNavigation == "editor" || this.params.verticalNavigation == "hybrid" && index < this.displayItems.length - 1) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            e.preventDefault();
            if (index < this.displayItems.length - 1) {
                if (index == -1) this._focusItem(this.displayItems[0]);
                else this._focusItem(this.displayItems[index + 1]);
            }
        }
    }
    _keySide(e) {
        if (!this.params.autocomplete) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            e.preventDefault();
        }
    }
    _keyEnter(e) {
        if (this.params.autocomplete && this.lastAction === "typing") this._resolveValue(true);
        else if (this.focusedItem) this._chooseItem(this.focusedItem);
    }
    _keyEsc(e) {
        this._cancel();
    }
    _keyHomeEnd(e) {
        if (this.params.autocomplete) //prevent table navigation while using input element
        e.stopImmediatePropagation();
    }
    _keySelectLetter(e) {
        if (!this.params.autocomplete) {
            // if(this.edit.currentCell === false){
            e.preventDefault();
            // }
            if (e.keyCode >= 38 && e.keyCode <= 90) this._scrollToValue(e.keyCode);
        }
    }
    _keyAutoCompLetter(e) {
        this._filter();
        this.lastAction = "typing";
        this.typing = true;
    }
    _scrollToValue(char) {
        clearTimeout(this.filterTimeout);
        var character = String.fromCharCode(char).toLowerCase();
        this.filterTerm += character.toLowerCase();
        var match = this.displayItems.find((item)=>{
            return typeof item.label !== "undefined" && item.label.toLowerCase().startsWith(this.filterTerm);
        });
        if (match) this._focusItem(match);
        this.filterTimeout = setTimeout(()=>{
            this.filterTerm = "";
        }, 800);
    }
    _focusItem(item) {
        this.lastAction = "focus";
        if (this.focusedItem && this.focusedItem.element) this.focusedItem.element.classList.remove("focused");
        this.focusedItem = item;
        if (item && item.element) {
            item.element.classList.add("focused");
            item.element.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'start'
            });
        }
    }
    //////////////////////////////////////
    /////// Data List Generation /////////
    //////////////////////////////////////
    headerFilterInitialListGen() {
        this._generateOptions(true);
    }
    rebuildOptionsList() {
        this._generateOptions().then(this._sortOptions.bind(this)).then(this._buildList.bind(this)).then(this._showList.bind(this)).catch((e)=>{
            if (!Number.isInteger(e)) console.error("List generation error", e);
        });
    }
    _filterList() {
        this._buildList(this._filterOptions());
        this._showList();
    }
    _generateOptions(silent) {
        var values = [];
        var iteration = ++this.listIteration;
        this.filtered = false;
        if (this.params.values) values = this.params.values;
        else if (this.params.valuesURL) values = this._ajaxRequest(this.params.valuesURL, this.input.value);
        else {
            if (typeof this.params.valuesLookup === "function") values = this.params.valuesLookup(this.cell, this.input.value);
            else if (this.params.valuesLookup) values = this._uniqueColumnValues(this.params.valuesLookupField);
        }
        if (values instanceof Promise) {
            if (!silent) this._addPlaceholder(this.params.placeholderLoading);
            return values.then().then((responseValues)=>{
                if (this.listIteration === iteration) return this._parseList(responseValues);
                else return Promise.reject(iteration);
            });
        } else return Promise.resolve(this._parseList(values));
    }
    _addPlaceholder(contents) {
        var placeholder = document.createElement("div");
        if (typeof contents === "function") contents = contents(this.cell.getComponent(), this.listEl);
        if (contents) {
            this._clearList();
            if (contents instanceof HTMLElement) placeholder = contents;
            else {
                placeholder.classList.add("tabulator-edit-list-placeholder");
                placeholder.innerHTML = contents;
            }
            this.listEl.appendChild(placeholder);
            this._showList();
        }
    }
    _ajaxRequest(url, term) {
        var params = this.params.filterRemote ? {
            term: term
        } : {};
        url = $c2a9788f40f9c90a$var$urlBuilder(url, {}, params);
        return fetch(url).then((response)=>{
            if (response.ok) return response.json().catch((error)=>{
                console.warn("List Ajax Load Error - Invalid JSON returned", error);
                return Promise.reject(error);
            });
            else {
                console.error("List Ajax Load Error - Connection Error: " + response.status, response.statusText);
                return Promise.reject(response);
            }
        }).catch((error)=>{
            console.error("List Ajax Load Error - Connection Error: ", error);
            return Promise.reject(error);
        });
    }
    _uniqueColumnValues(field) {
        var output = {}, data = this.table.getData(this.params.valuesLookup), column;
        if (field) column = this.table.columnManager.getColumnByField(field);
        else column = this.cell.getColumn()._getSelf();
        if (column) data.forEach((row)=>{
            var val = column.getFieldValue(row);
            if (!this._emptyValueCheck(val)) {
                if (this.params.multiselect && Array.isArray(val)) val.forEach((item)=>{
                    if (!this._emptyValueCheck(item)) output[item] = true;
                });
                else output[val] = true;
            }
        });
        else {
            console.warn("unable to find matching column to create select lookup list:", field);
            output = [];
        }
        return Object.keys(output);
    }
    _emptyValueCheck(value) {
        return value === null || typeof value === "undefined" || value === "";
    }
    _parseList(inputValues) {
        var data = [];
        if (!Array.isArray(inputValues)) inputValues = Object.entries(inputValues).map(([key, value])=>{
            return {
                label: value,
                value: key
            };
        });
        inputValues.forEach((value)=>{
            if (typeof value !== "object") value = {
                label: value,
                value: value
            };
            this._parseListItem(value, data, 0);
        });
        if (!this.currentItems.length && this.params.freetext) {
            this.input.value = this.initialValues;
            this.typing = true;
            this.lastAction = "typing";
        }
        this.data = data;
        return data;
    }
    _parseListItem(option, data, level) {
        var item = {};
        if (option.options) item = this._parseListGroup(option, level + 1);
        else {
            item = {
                label: option.label,
                value: option.value,
                itemParams: option.itemParams,
                elementAttributes: option.elementAttributes,
                element: false,
                selected: false,
                visible: true,
                level: level,
                original: option
            };
            if (this.initialValues && this.initialValues.indexOf(option.value) > -1) this._chooseItem(item, true);
        }
        data.push(item);
    }
    _parseListGroup(option, level) {
        var item = {
            label: option.label,
            group: true,
            itemParams: option.itemParams,
            elementAttributes: option.elementAttributes,
            element: false,
            visible: true,
            level: level,
            options: [],
            original: option
        };
        option.options.forEach((child)=>{
            this._parseListItem(child, item.options, level);
        });
        return item;
    }
    _sortOptions(options) {
        var sorter;
        if (this.params.sort) {
            sorter = typeof this.params.sort === "function" ? this.params.sort : this._defaultSortFunction.bind(this);
            this._sortGroup(sorter, options);
        }
        return options;
    }
    _sortGroup(sorter, options) {
        options.sort((a, b)=>{
            return sorter(a.label, b.label, a.value, b.value, a.original, b.original);
        });
        options.forEach((option)=>{
            if (option.group) this._sortGroup(sorter, option.options);
        });
    }
    _defaultSortFunction(as, bs) {
        var a, b, a1, b1, i = 0, L, rx = /(\d+)|(\D+)/g, rd = /\d/;
        var emptyAlign = 0;
        if (this.params.sort === "desc") [as, bs] = [
            bs,
            as
        ];
        //handle empty values
        if (!as && as !== 0) emptyAlign = !bs && bs !== 0 ? 0 : -1;
        else if (!bs && bs !== 0) emptyAlign = 1;
        else {
            if (isFinite(as) && isFinite(bs)) return as - bs;
            a = String(as).toLowerCase();
            b = String(bs).toLowerCase();
            if (a === b) return 0;
            if (!(rd.test(a) && rd.test(b))) return a > b ? 1 : -1;
            a = a.match(rx);
            b = b.match(rx);
            L = a.length > b.length ? b.length : a.length;
            while(i < L){
                a1 = a[i];
                b1 = b[i++];
                if (a1 !== b1) {
                    if (isFinite(a1) && isFinite(b1)) {
                        if (a1.charAt(0) === "0") a1 = "." + a1;
                        if (b1.charAt(0) === "0") b1 = "." + b1;
                        return a1 - b1;
                    } else return a1 > b1 ? 1 : -1;
                }
            }
            return a.length > b.length;
        }
        return emptyAlign;
    }
    _filterOptions() {
        var filterFunc = this.params.filterFunc || this._defaultFilterFunc, term = this.input.value;
        if (term) {
            this.filtered = true;
            this.data.forEach((item)=>{
                this._filterItem(filterFunc, term, item);
            });
        } else this.filtered = false;
        return this.data;
    }
    _filterItem(func, term, item) {
        var matches = false;
        if (!item.group) item.visible = func(term, item.label, item.value, item.original);
        else {
            item.options.forEach((option)=>{
                if (this._filterItem(func, term, option)) matches = true;
            });
            item.visible = matches;
        }
        return item.visible;
    }
    _defaultFilterFunc(term, label, value, item) {
        term = String(term).toLowerCase();
        if (label !== null && typeof label !== "undefined") {
            if (String(label).toLowerCase().indexOf(term) > -1 || String(value).toLowerCase().indexOf(term) > -1) return true;
        }
        return false;
    }
    //////////////////////////////////////
    /////////// Display List /////////////
    //////////////////////////////////////
    _clearList() {
        while(this.listEl.firstChild)this.listEl.removeChild(this.listEl.firstChild);
        this.displayItems = [];
    }
    _buildList(data) {
        this._clearList();
        data.forEach((option)=>{
            this._buildItem(option);
        });
        if (!this.displayItems.length) this._addPlaceholder(this.params.placeholderEmpty);
    }
    _buildItem(item) {
        var el = item.element, contents;
        if (!this.filtered || item.visible) {
            if (!el) {
                el = document.createElement("div");
                el.tabIndex = 0;
                contents = this.params.itemFormatter ? this.params.itemFormatter(item.label, item.value, item.original, el) : item.label;
                if (contents instanceof HTMLElement) el.appendChild(contents);
                else el.innerHTML = contents;
                if (item.group) el.classList.add("tabulator-edit-list-group");
                else el.classList.add("tabulator-edit-list-item");
                el.classList.add("tabulator-edit-list-group-level-" + item.level);
                if (item.elementAttributes && typeof item.elementAttributes == "object") {
                    for(let key in item.elementAttributes)if (key.charAt(0) == "+") {
                        key = key.slice(1);
                        el.setAttribute(key, this.input.getAttribute(key) + item.elementAttributes["+" + key]);
                    } else el.setAttribute(key, item.elementAttributes[key]);
                }
                if (item.group) el.addEventListener("click", this._groupClick.bind(this, item));
                else el.addEventListener("click", this._itemClick.bind(this, item));
                el.addEventListener("mousedown", this._preventBlur.bind(this));
                item.element = el;
            }
            this._styleItem(item);
            this.listEl.appendChild(el);
            if (item.group) item.options.forEach((option)=>{
                this._buildItem(option);
            });
            else this.displayItems.push(item);
        }
    }
    _showList() {
        var startVis = this.popup && this.popup.isVisible();
        if (this.input.parentNode) {
            if (this.params.autocomplete && this.input.value === "" && !this.params.listOnEmpty) {
                if (this.popup) this.popup.hide(true);
                return;
            }
            this._setListWidth();
            if (!this.popup) this.popup = this.edit.popup(this.listEl);
            this.popup.show(this.cell.getElement(), "bottom");
            if (!startVis) setTimeout(()=>{
                this.popup.hideOnBlur(this._resolveValue.bind(this, true));
            }, 10);
        }
    }
    _styleItem(item) {
        if (item && item.element) {
            if (item.selected) item.element.classList.add("active");
            else item.element.classList.remove("active");
        }
    }
    //////////////////////////////////////
    ///////// User Interaction ///////////
    //////////////////////////////////////
    _itemClick(item, e) {
        e.stopPropagation();
        this._chooseItem(item);
    }
    _groupClick(item, e) {
        e.stopPropagation();
    }
    //////////////////////////////////////
    ////// Current Item Management ///////
    //////////////////////////////////////
    _cancel() {
        this.popup.hide(true);
        this.actions.cancel();
    }
    _clearChoices() {
        this.typing = true;
        this.currentItems.forEach((item)=>{
            item.selected = false;
            this._styleItem(item);
        });
        this.currentItems = [];
        this.focusedItem = null;
    }
    _chooseItem(item, silent) {
        var index;
        this.typing = false;
        if (this.params.multiselect) {
            index = this.currentItems.indexOf(item);
            if (index > -1) {
                this.currentItems.splice(index, 1);
                item.selected = false;
            } else {
                this.currentItems.push(item);
                item.selected = true;
            }
            this.input.value = this.currentItems.map((item)=>item.label).join(",");
            this._styleItem(item);
        } else {
            this.currentItems = [
                item
            ];
            item.selected = true;
            this.input.value = item.label;
            this._styleItem(item);
            if (!silent) this._resolveValue();
        }
        this._focusItem(item);
    }
    _resolveValue(blur) {
        var output, initialValue;
        if (this.popup) this.popup.hide(true);
        if (this.params.multiselect) output = this.currentItems.map((item)=>item.value);
        else {
            if (blur && this.params.autocomplete && this.typing) {
                if (this.params.freetext || this.params.allowEmpty && this.input.value === "") output = this.input.value;
                else {
                    this.actions.cancel();
                    return;
                }
            } else if (this.currentItems[0]) output = this.currentItems[0].value;
            else {
                initialValue = Array.isArray(this.initialValues) ? this.initialValues[0] : this.initialValues;
                if (initialValue === null || typeof initialValue === "undefined" || initialValue === "") output = initialValue;
                else output = this.params.emptyValue;
            }
        }
        if (output === "") output = this.params.emptyValue;
        this.actions.success(output);
        if (this.isFilter) {
            this.initialValues = output && !Array.isArray(output) ? [
                output
            ] : output;
            this.currentItems = [];
        }
    }
};
function $c2a9788f40f9c90a$var$list(cell, onRendered, success, cancel, editorParams) {
    var list = new $c2a9788f40f9c90a$var$Edit$1(this, cell, onRendered, success, cancel, editorParams);
    return list.input;
}
//star rating
function $c2a9788f40f9c90a$var$star$1(cell, onRendered, success, cancel, editorParams) {
    var self = this, element = cell.getElement(), value = cell.getValue(), maxStars = element.getElementsByTagName("svg").length || 5, size = element.getElementsByTagName("svg")[0] ? element.getElementsByTagName("svg")[0].getAttribute("width") : 14, stars = [], starsHolder = document.createElement("div"), star = document.createElementNS('http://www.w3.org/2000/svg', "svg");
    //change star type
    function starChange(val) {
        stars.forEach(function(star, i) {
            if (i < val) {
                if (self.table.browser == "ie") star.setAttribute("class", "tabulator-star-active");
                else star.classList.replace("tabulator-star-inactive", "tabulator-star-active");
                star.innerHTML = '<polygon fill="#488CE9" stroke="#014AAE" stroke-width="37.6152" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="259.216,29.942 330.27,173.919 489.16,197.007 374.185,309.08 401.33,467.31 259.216,392.612 117.104,467.31 144.25,309.08 29.274,197.007 188.165,173.919 "/>';
            } else {
                if (self.table.browser == "ie") star.setAttribute("class", "tabulator-star-inactive");
                else star.classList.replace("tabulator-star-active", "tabulator-star-inactive");
                star.innerHTML = '<polygon fill="#010155" stroke="#686868" stroke-width="37.6152" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="259.216,29.942 330.27,173.919 489.16,197.007 374.185,309.08 401.33,467.31 259.216,392.612 117.104,467.31 144.25,309.08 29.274,197.007 188.165,173.919 "/>';
            }
        });
    }
    //build stars
    function buildStar(i) {
        var starHolder = document.createElement("span");
        var nextStar = star.cloneNode(true);
        stars.push(nextStar);
        starHolder.addEventListener("mouseenter", function(e) {
            e.stopPropagation();
            e.stopImmediatePropagation();
            starChange(i);
        });
        starHolder.addEventListener("mousemove", function(e) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        });
        starHolder.addEventListener("click", function(e) {
            e.stopPropagation();
            e.stopImmediatePropagation();
            success(i);
            element.blur();
        });
        starHolder.appendChild(nextStar);
        starsHolder.appendChild(starHolder);
    }
    //handle keyboard navigation value change
    function changeValue(val) {
        value = val;
        starChange(val);
    }
    //style cell
    element.style.whiteSpace = "nowrap";
    element.style.overflow = "hidden";
    element.style.textOverflow = "ellipsis";
    //style holding element
    starsHolder.style.verticalAlign = "middle";
    starsHolder.style.display = "inline-block";
    starsHolder.style.padding = "4px";
    //style star
    star.setAttribute("width", size);
    star.setAttribute("height", size);
    star.setAttribute("viewBox", "0 0 512 512");
    star.setAttribute("xml:space", "preserve");
    star.style.padding = "0 1px";
    if (editorParams.elementAttributes && typeof editorParams.elementAttributes == "object") {
        for(let key in editorParams.elementAttributes)if (key.charAt(0) == "+") {
            key = key.slice(1);
            starsHolder.setAttribute(key, starsHolder.getAttribute(key) + editorParams.elementAttributes["+" + key]);
        } else starsHolder.setAttribute(key, editorParams.elementAttributes[key]);
    }
    //create correct number of stars
    for(var i = 1; i <= maxStars; i++)buildStar(i);
    //ensure value does not exceed number of stars
    value = Math.min(parseInt(value), maxStars);
    // set initial styling of stars
    starChange(value);
    starsHolder.addEventListener("mousemove", function(e) {
        starChange(0);
    });
    starsHolder.addEventListener("click", function(e) {
        success(0);
    });
    element.addEventListener("blur", function(e) {
        cancel();
    });
    //allow key based navigation
    element.addEventListener("keydown", function(e) {
        switch(e.keyCode){
            case 39:
                changeValue(value + 1);
                break;
            case 37:
                changeValue(value - 1);
                break;
            case 13:
                success(value);
                break;
            case 27:
                cancel();
                break;
        }
    });
    return starsHolder;
}
//draggable progress bar
function $c2a9788f40f9c90a$var$progress$1(cell, onRendered, success, cancel, editorParams) {
    var element = cell.getElement(), max = typeof editorParams.max === "undefined" ? element.getElementsByTagName("div")[0] && element.getElementsByTagName("div")[0].getAttribute("max") || 100 : editorParams.max, min = typeof editorParams.min === "undefined" ? element.getElementsByTagName("div")[0] && element.getElementsByTagName("div")[0].getAttribute("min") || 0 : editorParams.min, percent = (max - min) / 100, value = cell.getValue() || 0, handle = document.createElement("div"), bar = document.createElement("div"), mouseDrag, mouseDragWidth;
    //set new value
    function updateValue() {
        var style = window.getComputedStyle(element, null);
        var calcVal = percent * Math.round(bar.offsetWidth / ((element.clientWidth - parseInt(style.getPropertyValue("padding-left")) - parseInt(style.getPropertyValue("padding-right"))) / 100)) + min;
        success(calcVal);
        element.setAttribute("aria-valuenow", calcVal);
        element.setAttribute("aria-label", value);
    }
    //style handle
    handle.style.position = "absolute";
    handle.style.right = "0";
    handle.style.top = "0";
    handle.style.bottom = "0";
    handle.style.width = "5px";
    handle.classList.add("tabulator-progress-handle");
    //style bar
    bar.style.display = "inline-block";
    bar.style.position = "relative";
    // bar.style.top = "8px";
    // bar.style.bottom = "8px";
    // bar.style.left = "4px";
    // bar.style.marginRight = "4px";
    bar.style.height = "100%";
    bar.style.backgroundColor = "#488CE9";
    bar.style.maxWidth = "100%";
    bar.style.minWidth = "0%";
    if (editorParams.elementAttributes && typeof editorParams.elementAttributes == "object") {
        for(let key in editorParams.elementAttributes)if (key.charAt(0) == "+") {
            key = key.slice(1);
            bar.setAttribute(key, bar.getAttribute(key) + editorParams.elementAttributes["+" + key]);
        } else bar.setAttribute(key, editorParams.elementAttributes[key]);
    }
    //style cell
    element.style.padding = "4px 4px";
    //make sure value is in range
    value = Math.min(parseFloat(value), max);
    value = Math.max(parseFloat(value), min);
    //workout percentage
    value = Math.round((value - min) / percent);
    // bar.style.right = value + "%";
    bar.style.width = value + "%";
    element.setAttribute("aria-valuemin", min);
    element.setAttribute("aria-valuemax", max);
    bar.appendChild(handle);
    handle.addEventListener("mousedown", function(e) {
        mouseDrag = e.screenX;
        mouseDragWidth = bar.offsetWidth;
    });
    handle.addEventListener("mouseover", function() {
        handle.style.cursor = "ew-resize";
    });
    element.addEventListener("mousemove", function(e) {
        if (mouseDrag) bar.style.width = mouseDragWidth + e.screenX - mouseDrag + "px";
    });
    element.addEventListener("mouseup", function(e) {
        if (mouseDrag) {
            e.stopPropagation();
            e.stopImmediatePropagation();
            mouseDrag = false;
            mouseDragWidth = false;
            updateValue();
        }
    });
    //allow key based navigation
    element.addEventListener("keydown", function(e) {
        switch(e.keyCode){
            case 39:
                e.preventDefault();
                bar.style.width = bar.clientWidth + element.clientWidth / 100 + "px";
                break;
            case 37:
                e.preventDefault();
                bar.style.width = bar.clientWidth - element.clientWidth / 100 + "px";
                break;
            case 9:
            case 13:
                updateValue();
                break;
            case 27:
                cancel();
                break;
        }
    });
    element.addEventListener("blur", function() {
        cancel();
    });
    return bar;
}
//checkbox
function $c2a9788f40f9c90a$var$tickCross$1(cell, onRendered, success, cancel, editorParams) {
    var value = cell.getValue(), input = document.createElement("input"), tristate = editorParams.tristate, indetermValue = typeof editorParams.indeterminateValue === "undefined" ? null : editorParams.indeterminateValue, indetermState = false, trueValueSet = Object.keys(editorParams).includes("trueValue"), falseValueSet = Object.keys(editorParams).includes("falseValue");
    input.setAttribute("type", "checkbox");
    input.style.marginTop = "5px";
    input.style.boxSizing = "border-box";
    if (editorParams.elementAttributes && typeof editorParams.elementAttributes == "object") {
        for(let key in editorParams.elementAttributes)if (key.charAt(0) == "+") {
            key = key.slice(1);
            input.setAttribute(key, input.getAttribute(key) + editorParams.elementAttributes["+" + key]);
        } else input.setAttribute(key, editorParams.elementAttributes[key]);
    }
    input.value = value;
    if (tristate && (typeof value === "undefined" || value === indetermValue || value === "")) {
        indetermState = true;
        input.indeterminate = true;
    }
    if (this.table.browser != "firefox" && this.table.browser != "safari") onRendered(function() {
        if (cell.getType() === "cell") input.focus({
            preventScroll: true
        });
    });
    input.checked = trueValueSet ? value === editorParams.trueValue : value === true || value === "true" || value === "True" || value === 1;
    function setValue(blur) {
        var checkedValue = input.checked;
        if (trueValueSet && checkedValue) checkedValue = editorParams.trueValue;
        else if (falseValueSet && !checkedValue) checkedValue = editorParams.falseValue;
        if (tristate) {
            if (!blur) {
                if (input.checked && !indetermState) {
                    input.checked = false;
                    input.indeterminate = true;
                    indetermState = true;
                    return indetermValue;
                } else {
                    indetermState = false;
                    return checkedValue;
                }
            } else {
                if (indetermState) return indetermValue;
                else return checkedValue;
            }
        } else return checkedValue;
    }
    //submit new value on blur
    input.addEventListener("change", function(e) {
        success(setValue());
    });
    input.addEventListener("blur", function(e) {
        success(setValue(true));
    });
    //submit new value on enter
    input.addEventListener("keydown", function(e) {
        if (e.keyCode == 13) success(setValue());
        if (e.keyCode == 27) cancel();
    });
    return input;
}
function $c2a9788f40f9c90a$var$adaptable$1(cell, onRendered, success, cancel, params) {
    var column = cell._getSelf().column, lookup, editorFunc, editorParams;
    function defaultLookup(cell) {
        var value = cell.getValue(), editor = "input";
        switch(typeof value){
            case "number":
                editor = "number";
                break;
            case "boolean":
                editor = "tickCross";
                break;
            case "string":
                if (value.includes("\n")) editor = "textarea";
                break;
        }
        return editor;
    }
    lookup = params.editorLookup ? params.editorLookup(cell) : defaultLookup(cell);
    if (params.paramsLookup) editorParams = typeof params.paramsLookup === "function" ? params.paramsLookup(lookup, cell) : params.paramsLookup[lookup];
    editorFunc = this.table.modules.edit.lookupEditor(lookup, column);
    return editorFunc.call(this, cell, onRendered, success, cancel, editorParams || {});
}
var $c2a9788f40f9c90a$var$defaultEditors = {
    input: $c2a9788f40f9c90a$var$input,
    textarea: $c2a9788f40f9c90a$var$textarea$1,
    number: $c2a9788f40f9c90a$var$number$1,
    range: $c2a9788f40f9c90a$var$range,
    date: $c2a9788f40f9c90a$var$date$1,
    time: $c2a9788f40f9c90a$var$time$1,
    datetime: $c2a9788f40f9c90a$var$datetime$2,
    list: $c2a9788f40f9c90a$var$list,
    star: $c2a9788f40f9c90a$var$star$1,
    progress: $c2a9788f40f9c90a$var$progress$1,
    tickCross: $c2a9788f40f9c90a$var$tickCross$1,
    adaptable: $c2a9788f40f9c90a$var$adaptable$1
};
class $c2a9788f40f9c90a$export$2394e2d3d2175314 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "edit";
    //load defaults
    static editors = $c2a9788f40f9c90a$var$defaultEditors;
    constructor(table){
        super(table);
        this.currentCell = false; //hold currently editing cell
        this.mouseClick = false; //hold mousedown state to prevent click binding being overridden by editor opening
        this.recursionBlock = false; //prevent focus recursion
        this.invalidEdit = false;
        this.editedCells = [];
        this.convertEmptyValues = false;
        this.editors = $c2a9788f40f9c90a$export$2394e2d3d2175314.editors;
        this.registerTableOption("editTriggerEvent", "focus");
        this.registerTableOption("editorEmptyValue");
        this.registerTableOption("editorEmptyValueFunc", this.emptyValueCheck.bind(this));
        this.registerColumnOption("editable");
        this.registerColumnOption("editor");
        this.registerColumnOption("editorParams");
        this.registerColumnOption("editorEmptyValue");
        this.registerColumnOption("editorEmptyValueFunc");
        this.registerColumnOption("cellEditing");
        this.registerColumnOption("cellEdited");
        this.registerColumnOption("cellEditCancelled");
        this.registerTableFunction("getEditedCells", this.getEditedCells.bind(this));
        this.registerTableFunction("clearCellEdited", this.clearCellEdited.bind(this));
        this.registerTableFunction("navigatePrev", this.navigatePrev.bind(this));
        this.registerTableFunction("navigateNext", this.navigateNext.bind(this));
        this.registerTableFunction("navigateLeft", this.navigateLeft.bind(this));
        this.registerTableFunction("navigateRight", this.navigateRight.bind(this));
        this.registerTableFunction("navigateUp", this.navigateUp.bind(this));
        this.registerTableFunction("navigateDown", this.navigateDown.bind(this));
        this.registerComponentFunction("cell", "isEdited", this.cellIsEdited.bind(this));
        this.registerComponentFunction("cell", "clearEdited", this.clearEdited.bind(this));
        this.registerComponentFunction("cell", "edit", this.editCell.bind(this));
        this.registerComponentFunction("cell", "cancelEdit", this.cellCancelEdit.bind(this));
        this.registerComponentFunction("cell", "navigatePrev", this.navigatePrev.bind(this));
        this.registerComponentFunction("cell", "navigateNext", this.navigateNext.bind(this));
        this.registerComponentFunction("cell", "navigateLeft", this.navigateLeft.bind(this));
        this.registerComponentFunction("cell", "navigateRight", this.navigateRight.bind(this));
        this.registerComponentFunction("cell", "navigateUp", this.navigateUp.bind(this));
        this.registerComponentFunction("cell", "navigateDown", this.navigateDown.bind(this));
    }
    initialize() {
        this.subscribe("cell-init", this.bindEditor.bind(this));
        this.subscribe("cell-delete", this.clearEdited.bind(this));
        this.subscribe("cell-value-changed", this.updateCellClass.bind(this));
        this.subscribe("column-layout", this.initializeColumnCheck.bind(this));
        this.subscribe("column-delete", this.columnDeleteCheck.bind(this));
        this.subscribe("row-deleting", this.rowDeleteCheck.bind(this));
        this.subscribe("row-layout", this.rowEditableCheck.bind(this));
        this.subscribe("data-refreshing", this.cancelEdit.bind(this));
        this.subscribe("clipboard-paste", this.pasteBlocker.bind(this));
        this.subscribe("keybinding-nav-prev", this.navigatePrev.bind(this, undefined));
        this.subscribe("keybinding-nav-next", this.keybindingNavigateNext.bind(this));
        // this.subscribe("keybinding-nav-left", this.navigateLeft.bind(this, undefined));
        // this.subscribe("keybinding-nav-right", this.navigateRight.bind(this, undefined));
        this.subscribe("keybinding-nav-up", this.navigateUp.bind(this, undefined));
        this.subscribe("keybinding-nav-down", this.navigateDown.bind(this, undefined));
        if (Object.keys(this.table.options).includes("editorEmptyValue")) this.convertEmptyValues = true;
    }
    ///////////////////////////////////
    ///////// Paste Negation //////////
    ///////////////////////////////////
    pasteBlocker(e) {
        if (this.currentCell) return true;
    }
    ///////////////////////////////////
    ////// Keybinding Functions ///////
    ///////////////////////////////////
    keybindingNavigateNext(e) {
        var cell = this.currentCell, newRow = this.options("tabEndNewRow");
        if (cell) {
            if (!this.navigateNext(cell, e)) {
                if (newRow) {
                    cell.getElement().firstChild.blur();
                    if (!this.invalidEdit) {
                        if (newRow === true) newRow = this.table.addRow({});
                        else if (typeof newRow == "function") newRow = this.table.addRow(newRow(cell.row.getComponent()));
                        else newRow = this.table.addRow(Object.assign({}, newRow));
                        newRow.then(()=>{
                            setTimeout(()=>{
                                cell.getComponent().navigateNext();
                            });
                        });
                    }
                }
            }
        }
    }
    ///////////////////////////////////
    ///////// Cell Functions //////////
    ///////////////////////////////////
    cellIsEdited(cell) {
        return !!cell.modules.edit && cell.modules.edit.edited;
    }
    cellCancelEdit(cell) {
        if (cell === this.currentCell) this.table.modules.edit.cancelEdit();
        else console.warn("Cancel Editor Error - This cell is not currently being edited ");
    }
    ///////////////////////////////////
    ///////// Table Functions /////////
    ///////////////////////////////////
    updateCellClass(cell) {
        if (this.allowEdit(cell)) cell.getElement().classList.add("tabulator-editable");
        else cell.getElement().classList.remove("tabulator-editable");
    }
    clearCellEdited(cells) {
        if (!cells) cells = this.table.modules.edit.getEditedCells();
        if (!Array.isArray(cells)) cells = [
            cells
        ];
        cells.forEach((cell)=>{
            this.table.modules.edit.clearEdited(cell._getSelf());
        });
    }
    navigatePrev(cell = this.currentCell, e) {
        var nextCell, prevRow;
        if (cell) {
            if (e) e.preventDefault();
            nextCell = this.navigateLeft();
            if (nextCell) return true;
            else {
                prevRow = this.table.rowManager.prevDisplayRow(cell.row, true);
                if (prevRow) {
                    nextCell = this.findPrevEditableCell(prevRow, prevRow.cells.length);
                    if (nextCell) {
                        nextCell.getComponent().edit();
                        return true;
                    }
                }
            }
        }
        return false;
    }
    navigateNext(cell = this.currentCell, e) {
        var nextCell, nextRow;
        if (cell) {
            if (e) e.preventDefault();
            nextCell = this.navigateRight();
            if (nextCell) return true;
            else {
                nextRow = this.table.rowManager.nextDisplayRow(cell.row, true);
                if (nextRow) {
                    nextCell = this.findNextEditableCell(nextRow, -1);
                    if (nextCell) {
                        nextCell.getComponent().edit();
                        return true;
                    }
                }
            }
        }
        return false;
    }
    navigateLeft(cell = this.currentCell, e) {
        var index, nextCell;
        if (cell) {
            if (e) e.preventDefault();
            index = cell.getIndex();
            nextCell = this.findPrevEditableCell(cell.row, index);
            if (nextCell) {
                nextCell.getComponent().edit();
                return true;
            }
        }
        return false;
    }
    navigateRight(cell = this.currentCell, e) {
        var index, nextCell;
        if (cell) {
            if (e) e.preventDefault();
            index = cell.getIndex();
            nextCell = this.findNextEditableCell(cell.row, index);
            if (nextCell) {
                nextCell.getComponent().edit();
                return true;
            }
        }
        return false;
    }
    navigateUp(cell = this.currentCell, e) {
        var index, nextRow;
        if (cell) {
            if (e) e.preventDefault();
            index = cell.getIndex();
            nextRow = this.table.rowManager.prevDisplayRow(cell.row, true);
            if (nextRow) {
                nextRow.cells[index].getComponent().edit();
                return true;
            }
        }
        return false;
    }
    navigateDown(cell = this.currentCell, e) {
        var index, nextRow;
        if (cell) {
            if (e) e.preventDefault();
            index = cell.getIndex();
            nextRow = this.table.rowManager.nextDisplayRow(cell.row, true);
            if (nextRow) {
                nextRow.cells[index].getComponent().edit();
                return true;
            }
        }
        return false;
    }
    findNextEditableCell(row, index) {
        var nextCell = false;
        if (index < row.cells.length - 1) for(var i = index + 1; i < row.cells.length; i++){
            let cell = row.cells[i];
            if (cell.column.modules.edit && $c2a9788f40f9c90a$var$Helpers.elVisible(cell.getElement())) {
                let allowEdit = this.allowEdit(cell);
                if (allowEdit) {
                    nextCell = cell;
                    break;
                }
            }
        }
        return nextCell;
    }
    findPrevEditableCell(row, index) {
        var prevCell = false;
        if (index > 0) for(var i = index - 1; i >= 0; i--){
            let cell = row.cells[i];
            if (cell.column.modules.edit && $c2a9788f40f9c90a$var$Helpers.elVisible(cell.getElement())) {
                let allowEdit = this.allowEdit(cell);
                if (allowEdit) {
                    prevCell = cell;
                    break;
                }
            }
        }
        return prevCell;
    }
    ///////////////////////////////////
    ///////// Internal Logic //////////
    ///////////////////////////////////
    initializeColumnCheck(column) {
        if (typeof column.definition.editor !== "undefined") this.initializeColumn(column);
    }
    columnDeleteCheck(column) {
        if (this.currentCell && this.currentCell.column === column) this.cancelEdit();
    }
    rowDeleteCheck(row) {
        if (this.currentCell && this.currentCell.row === row) this.cancelEdit();
    }
    rowEditableCheck(row) {
        row.getCells().forEach((cell)=>{
            if (cell.column.modules.edit && typeof cell.column.modules.edit.check === "function") this.updateCellClass(cell);
        });
    }
    //initialize column editor
    initializeColumn(column) {
        var convertEmpty = Object.keys(column.definition).includes("editorEmptyValue");
        var config = {
            editor: false,
            blocked: false,
            check: column.definition.editable,
            params: column.definition.editorParams || {},
            convertEmptyValues: convertEmpty,
            editorEmptyValue: column.definition.editorEmptyValue,
            editorEmptyValueFunc: column.definition.editorEmptyValueFunc
        };
        //set column editor
        config.editor = this.lookupEditor(column.definition.editor, column);
        if (config.editor) column.modules.edit = config;
    }
    lookupEditor(editor, column) {
        var editorFunc;
        switch(typeof editor){
            case "string":
                if (this.editors[editor]) editorFunc = this.editors[editor];
                else console.warn("Editor Error - No such editor found: ", editor);
                break;
            case "function":
                editorFunc = editor;
                break;
            case "boolean":
                if (editor === true) {
                    if (typeof column.definition.formatter !== "function") {
                        if (this.editors[column.definition.formatter]) editorFunc = this.editors[column.definition.formatter];
                        else editorFunc = this.editors["input"];
                    } else console.warn("Editor Error - Cannot auto lookup editor for a custom formatter: ", column.definition.formatter);
                }
                break;
        }
        return editorFunc;
    }
    getCurrentCell() {
        return this.currentCell ? this.currentCell.getComponent() : false;
    }
    clearEditor(cancel) {
        var cell = this.currentCell, cellEl;
        this.invalidEdit = false;
        if (cell) {
            this.currentCell = false;
            cellEl = cell.getElement();
            this.dispatch("edit-editor-clear", cell, cancel);
            cellEl.classList.remove("tabulator-editing");
            while(cellEl.firstChild)cellEl.removeChild(cellEl.firstChild);
            cell.row.getElement().classList.remove("tabulator-editing");
            cell.table.element.classList.remove("tabulator-editing");
        }
    }
    cancelEdit() {
        if (this.currentCell) {
            var cell = this.currentCell;
            var component = this.currentCell.getComponent();
            this.clearEditor(true);
            cell.setValueActual(cell.getValue());
            cell.cellRendered();
            if (cell.column.definition.editor == "textarea" || cell.column.definition.variableHeight) cell.row.normalizeHeight(true);
            if (cell.column.definition.cellEditCancelled) cell.column.definition.cellEditCancelled.call(this.table, component);
            this.dispatch("edit-cancelled", cell);
            this.dispatchExternal("cellEditCancelled", component);
        }
    }
    //return a formatted value for a cell
    bindEditor(cell) {
        if (cell.column.modules.edit) {
            var self = this, element = cell.getElement(true);
            this.updateCellClass(cell);
            element.setAttribute("tabindex", 0);
            element.addEventListener("mousedown", function(e) {
                if (e.button === 2) e.preventDefault();
                else self.mouseClick = true;
            });
            if (this.options("editTriggerEvent") === "dblclick") element.addEventListener("dblclick", function(e) {
                if (!element.classList.contains("tabulator-editing")) {
                    element.focus({
                        preventScroll: true
                    });
                    self.edit(cell, e, false);
                }
            });
            if (this.options("editTriggerEvent") === "focus" || this.options("editTriggerEvent") === "click") element.addEventListener("click", function(e) {
                if (!element.classList.contains("tabulator-editing")) {
                    element.focus({
                        preventScroll: true
                    });
                    self.edit(cell, e, false);
                }
            });
            if (this.options("editTriggerEvent") === "focus") element.addEventListener("focus", function(e) {
                if (!self.recursionBlock) self.edit(cell, e, false);
            });
        }
    }
    focusCellNoEvent(cell, block) {
        this.recursionBlock = true;
        if (!(block && this.table.browser === "ie")) cell.getElement().focus({
            preventScroll: true
        });
        this.recursionBlock = false;
    }
    editCell(cell, forceEdit) {
        this.focusCellNoEvent(cell);
        this.edit(cell, false, forceEdit);
    }
    focusScrollAdjust(cell) {
        if (this.table.rowManager.getRenderMode() == "virtual") {
            var topEdge = this.table.rowManager.element.scrollTop, bottomEdge = this.table.rowManager.element.clientHeight + this.table.rowManager.element.scrollTop, rowEl = cell.row.getElement();
            if (rowEl.offsetTop < topEdge) this.table.rowManager.element.scrollTop -= topEdge - rowEl.offsetTop;
            else if (rowEl.offsetTop + rowEl.offsetHeight > bottomEdge) this.table.rowManager.element.scrollTop += rowEl.offsetTop + rowEl.offsetHeight - bottomEdge;
            var leftEdge = this.table.rowManager.element.scrollLeft, rightEdge = this.table.rowManager.element.clientWidth + this.table.rowManager.element.scrollLeft, cellEl = cell.getElement();
            if (this.table.modExists("frozenColumns")) {
                leftEdge += parseInt(this.table.modules.frozenColumns.leftMargin || 0);
                rightEdge -= parseInt(this.table.modules.frozenColumns.rightMargin || 0);
            }
            if (this.table.options.renderHorizontal === "virtual") {
                leftEdge -= parseInt(this.table.columnManager.renderer.vDomPadLeft);
                rightEdge -= parseInt(this.table.columnManager.renderer.vDomPadLeft);
            }
            if (cellEl.offsetLeft < leftEdge) this.table.rowManager.element.scrollLeft -= leftEdge - cellEl.offsetLeft;
            else if (cellEl.offsetLeft + cellEl.offsetWidth > rightEdge) this.table.rowManager.element.scrollLeft += cellEl.offsetLeft + cellEl.offsetWidth - rightEdge;
        }
    }
    allowEdit(cell) {
        var check = cell.column.modules.edit ? true : false;
        if (cell.column.modules.edit) switch(typeof cell.column.modules.edit.check){
            case "function":
                if (cell.row.initialized) check = cell.column.modules.edit.check(cell.getComponent());
                break;
            case "string":
                check = !!cell.row.data[cell.column.modules.edit.check];
                break;
            case "boolean":
                check = cell.column.modules.edit.check;
                break;
        }
        return check;
    }
    edit(cell, e, forceEdit) {
        var self = this, allowEdit = true, rendered = function() {}, element = cell.getElement(), editFinished = false, cellEditor, component, params;
        //prevent editing if another cell is refusing to leave focus (eg. validation fail)
        if (this.currentCell) {
            if (!this.invalidEdit && this.currentCell !== cell) this.cancelEdit();
            return;
        }
        //handle successful value change
        function success(value) {
            if (self.currentCell === cell && !editFinished) {
                var valid = self.chain("edit-success", [
                    cell,
                    value
                ], true, true);
                if (valid === true || self.table.options.validationMode === "highlight") {
                    editFinished = true;
                    self.clearEditor();
                    if (!cell.modules.edit) cell.modules.edit = {};
                    cell.modules.edit.edited = true;
                    if (self.editedCells.indexOf(cell) == -1) self.editedCells.push(cell);
                    value = self.transformEmptyValues(value, cell);
                    cell.setValue(value, true);
                    return valid === true;
                } else {
                    editFinished = true;
                    self.invalidEdit = true;
                    self.focusCellNoEvent(cell, true);
                    rendered();
                    setTimeout(()=>{
                        editFinished = false;
                    }, 10);
                    return false;
                }
            }
        }
        //handle aborted edit
        function cancel() {
            // editFinished = true;
            if (self.currentCell === cell && !editFinished) self.cancelEdit();
        }
        function onRendered(callback) {
            rendered = callback;
        }
        if (!cell.column.modules.edit.blocked) {
            if (e) e.stopPropagation();
            allowEdit = this.allowEdit(cell);
            if (allowEdit || forceEdit) {
                self.cancelEdit();
                self.currentCell = cell;
                this.focusScrollAdjust(cell);
                component = cell.getComponent();
                if (this.mouseClick) {
                    this.mouseClick = false;
                    if (cell.column.definition.cellClick) cell.column.definition.cellClick.call(this.table, e, component);
                }
                if (cell.column.definition.cellEditing) cell.column.definition.cellEditing.call(this.table, component);
                this.dispatch("cell-editing", cell);
                this.dispatchExternal("cellEditing", component);
                params = typeof cell.column.modules.edit.params === "function" ? cell.column.modules.edit.params(component) : cell.column.modules.edit.params;
                cellEditor = cell.column.modules.edit.editor.call(self, component, onRendered, success, cancel, params);
                //if editor returned, add to DOM, if false, abort edit
                if (this.currentCell && cellEditor !== false) {
                    if (cellEditor instanceof Node) {
                        element.classList.add("tabulator-editing");
                        cell.row.getElement().classList.add("tabulator-editing");
                        cell.table.element.classList.add("tabulator-editing");
                        while(element.firstChild)element.removeChild(element.firstChild);
                        element.appendChild(cellEditor);
                        //trigger onRendered Callback
                        rendered();
                        //prevent editing from triggering rowClick event
                        var children = element.children;
                        for(var i = 0; i < children.length; i++)children[i].addEventListener("click", function(e) {
                            e.stopPropagation();
                        });
                    } else {
                        console.warn("Edit Error - Editor should return an instance of Node, the editor returned:", cellEditor);
                        this.blur(element);
                        return false;
                    }
                } else {
                    this.blur(element);
                    return false;
                }
                return true;
            } else {
                this.mouseClick = false;
                this.blur(element);
                return false;
            }
        } else {
            this.mouseClick = false;
            this.blur(element);
            return false;
        }
    }
    emptyValueCheck(value) {
        return value === "" || value === null || typeof value === "undefined";
    }
    transformEmptyValues(value, cell) {
        var mod = cell.column.modules.edit, convert = mod.convertEmptyValues || this.convertEmptyValues, checkFunc;
        if (convert) {
            checkFunc = mod.editorEmptyValueFunc || this.options("editorEmptyValueFunc");
            if (checkFunc && checkFunc(value)) value = mod.convertEmptyValues ? mod.editorEmptyValue : this.options("editorEmptyValue");
        }
        return value;
    }
    blur(element) {
        if (!this.confirm("edit-blur", [
            element
        ])) element.blur();
    }
    getEditedCells() {
        var output = [];
        this.editedCells.forEach((cell)=>{
            output.push(cell.getComponent());
        });
        return output;
    }
    clearEdited(cell) {
        var editIndex;
        if (cell.modules.edit && cell.modules.edit.edited) {
            cell.modules.edit.edited = false;
            this.dispatch("edit-edited-clear", cell);
        }
        editIndex = this.editedCells.indexOf(cell);
        if (editIndex > -1) this.editedCells.splice(editIndex, 1);
    }
}
class $c2a9788f40f9c90a$var$ExportRow {
    constructor(type, columns, component, indent){
        this.type = type;
        this.columns = columns;
        this.component = component || false;
        this.indent = indent || 0;
    }
}
class $c2a9788f40f9c90a$var$ExportColumn {
    constructor(value, component, width, height, depth){
        this.value = value;
        this.component = component || false;
        this.width = width;
        this.height = height;
        this.depth = depth;
    }
}
var $c2a9788f40f9c90a$var$columnLookups$1 = {};
var $c2a9788f40f9c90a$var$rowLookups$1 = {
    visible: function() {
        return this.rowManager.getVisibleRows(false, true);
    },
    all: function() {
        return this.rowManager.rows;
    },
    selected: function() {
        return this.modules.selectRow.selectedRows;
    },
    active: function() {
        if (this.options.pagination) return this.rowManager.getDisplayRows(this.rowManager.displayRows.length - 2);
        else return this.rowManager.getDisplayRows();
    }
};
class $c2a9788f40f9c90a$export$4e0f34fd9829977c extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "export";
    static columnLookups = $c2a9788f40f9c90a$var$columnLookups$1;
    static rowLookups = $c2a9788f40f9c90a$var$rowLookups$1;
    constructor(table){
        super(table);
        this.config = {};
        this.cloneTableStyle = true;
        this.colVisProp = "";
        this.colVisPropAttach = "";
        this.registerTableOption("htmlOutputConfig", false); //html output config
        this.registerColumnOption("htmlOutput");
        this.registerColumnOption("titleHtmlOutput");
    }
    initialize() {
        this.registerTableFunction("getHtml", this.getHtml.bind(this));
    }
    ///////////////////////////////////
    ///////// Internal Logic //////////
    ///////////////////////////////////
    generateExportList(config, style, range, colVisProp) {
        var headers, body, columns, colLookup;
        this.cloneTableStyle = style;
        this.config = config || {};
        this.colVisProp = colVisProp;
        this.colVisPropAttach = this.colVisProp.charAt(0).toUpperCase() + this.colVisProp.slice(1);
        colLookup = $c2a9788f40f9c90a$export$4e0f34fd9829977c.columnLookups[range];
        if (colLookup) {
            columns = colLookup.call(this.table);
            columns = columns.filter((col)=>this.columnVisCheck(col));
        }
        headers = this.config.columnHeaders !== false ? this.headersToExportRows(this.generateColumnGroupHeaders(columns)) : [];
        if (columns) columns = columns.map((col)=>col.getComponent());
        body = this.bodyToExportRows(this.rowLookup(range), columns);
        return headers.concat(body);
    }
    generateTable(config, style, range, colVisProp) {
        var list = this.generateExportList(config, style, range, colVisProp);
        return this.generateTableElement(list);
    }
    rowLookup(range) {
        var rows = [], rowLookup;
        if (typeof range == "function") range.call(this.table).forEach((row)=>{
            row = this.table.rowManager.findRow(row);
            if (row) rows.push(row);
        });
        else {
            rowLookup = $c2a9788f40f9c90a$export$4e0f34fd9829977c.rowLookups[range] || $c2a9788f40f9c90a$export$4e0f34fd9829977c.rowLookups["active"];
            rows = rowLookup.call(this.table);
        }
        return Object.assign([], rows);
    }
    generateColumnGroupHeaders(columns) {
        var output = [];
        if (!columns) columns = this.config.columnGroups !== false ? this.table.columnManager.columns : this.table.columnManager.columnsByIndex;
        columns.forEach((column)=>{
            var colData = this.processColumnGroup(column);
            if (colData) output.push(colData);
        });
        return output;
    }
    processColumnGroup(column) {
        var subGroups = column.columns, maxDepth = 0, title = column.definition["title" + this.colVisPropAttach] || column.definition.title;
        var groupData = {
            title: title,
            column: column,
            depth: 1
        };
        if (subGroups.length) {
            groupData.subGroups = [];
            groupData.width = 0;
            subGroups.forEach((subGroup)=>{
                var subGroupData = this.processColumnGroup(subGroup);
                if (subGroupData) {
                    groupData.width += subGroupData.width;
                    groupData.subGroups.push(subGroupData);
                    if (subGroupData.depth > maxDepth) maxDepth = subGroupData.depth;
                }
            });
            groupData.depth += maxDepth;
            if (!groupData.width) return false;
        } else {
            if (this.columnVisCheck(column)) groupData.width = 1;
            else return false;
        }
        return groupData;
    }
    columnVisCheck(column) {
        var visProp = column.definition[this.colVisProp];
        if (this.config.rowHeaders === false && column.isRowHeader) return false;
        if (typeof visProp === "function") visProp = visProp.call(this.table, column.getComponent());
        if (visProp === false || visProp === true) return visProp;
        return column.visible && column.field;
    }
    headersToExportRows(columns) {
        var headers = [], headerDepth = 0, exportRows = [];
        function parseColumnGroup(column, level) {
            var depth = headerDepth - level;
            if (typeof headers[level] === "undefined") headers[level] = [];
            column.height = column.subGroups ? 1 : depth - column.depth + 1;
            headers[level].push(column);
            if (column.height > 1) for(let i = 1; i < column.height; i++){
                if (typeof headers[level + i] === "undefined") headers[level + i] = [];
                headers[level + i].push(false);
            }
            if (column.width > 1) for(let i = 1; i < column.width; i++)headers[level].push(false);
            if (column.subGroups) column.subGroups.forEach(function(subGroup) {
                parseColumnGroup(subGroup, level + 1);
            });
        }
        //calculate maximum header depth
        columns.forEach(function(column) {
            if (column.depth > headerDepth) headerDepth = column.depth;
        });
        columns.forEach(function(column) {
            parseColumnGroup(column, 0);
        });
        headers.forEach((header)=>{
            var columns = [];
            header.forEach((col)=>{
                if (col) {
                    let title = typeof col.title === "undefined" ? "" : col.title;
                    columns.push(new $c2a9788f40f9c90a$var$ExportColumn(title, col.column.getComponent(), col.width, col.height, col.depth));
                } else columns.push(null);
            });
            exportRows.push(new $c2a9788f40f9c90a$var$ExportRow("header", columns));
        });
        return exportRows;
    }
    bodyToExportRows(rows, columns = []) {
        var exportRows = [];
        if (columns.length === 0) this.table.columnManager.columnsByIndex.forEach((column)=>{
            if (this.columnVisCheck(column)) columns.push(column.getComponent());
        });
        if (this.config.columnCalcs !== false && this.table.modExists("columnCalcs")) {
            if (this.table.modules.columnCalcs.topInitialized) rows.unshift(this.table.modules.columnCalcs.topRow);
            if (this.table.modules.columnCalcs.botInitialized) rows.push(this.table.modules.columnCalcs.botRow);
        }
        rows = rows.filter((row)=>{
            switch(row.type){
                case "group":
                    return this.config.rowGroups !== false;
                case "calc":
                    return this.config.columnCalcs !== false;
                case "row":
                    return !(this.table.options.dataTree && this.config.dataTree === false && row.modules.dataTree.parent);
            }
            return true;
        });
        rows.forEach((row, i)=>{
            var rowData = row.getData(this.colVisProp);
            var exportCols = [];
            var indent = 0;
            switch(row.type){
                case "group":
                    indent = row.level;
                    exportCols.push(new $c2a9788f40f9c90a$var$ExportColumn(row.key, row.getComponent(), columns.length, 1));
                    break;
                case "calc":
                case "row":
                    columns.forEach((col)=>{
                        exportCols.push(new $c2a9788f40f9c90a$var$ExportColumn(col._column.getFieldValue(rowData), col, 1, 1));
                    });
                    if (this.table.options.dataTree && this.config.dataTree !== false) indent = row.modules.dataTree.index;
                    break;
            }
            exportRows.push(new $c2a9788f40f9c90a$var$ExportRow(row.type, exportCols, row.getComponent(), indent));
        });
        return exportRows;
    }
    generateTableElement(list) {
        var table = document.createElement("table"), headerEl = document.createElement("thead"), bodyEl = document.createElement("tbody"), styles = this.lookupTableStyles(), rowFormatter = this.table.options["rowFormatter" + this.colVisPropAttach], setup = {};
        setup.rowFormatter = rowFormatter !== null ? rowFormatter : this.table.options.rowFormatter;
        if (this.table.options.dataTree && this.config.dataTree !== false && this.table.modExists("columnCalcs")) setup.treeElementField = this.table.modules.dataTree.elementField;
        //assign group header formatter
        setup.groupHeader = this.table.options["groupHeader" + this.colVisPropAttach];
        if (setup.groupHeader && !Array.isArray(setup.groupHeader)) setup.groupHeader = [
            setup.groupHeader
        ];
        table.classList.add("tabulator-print-table");
        this.mapElementStyles(this.table.columnManager.getHeadersElement(), headerEl, [
            "border-top",
            "border-left",
            "border-right",
            "border-bottom",
            "background-color",
            "color",
            "font-weight",
            "font-family",
            "font-size"
        ]);
        if (list.length > 1000) console.warn("It may take a long time to render an HTML table with more than 1000 rows");
        list.forEach((row, i)=>{
            let rowEl;
            switch(row.type){
                case "header":
                    headerEl.appendChild(this.generateHeaderElement(row, setup, styles));
                    break;
                case "group":
                    bodyEl.appendChild(this.generateGroupElement(row, setup, styles));
                    break;
                case "calc":
                    bodyEl.appendChild(this.generateCalcElement(row, setup, styles));
                    break;
                case "row":
                    rowEl = this.generateRowElement(row, setup, styles);
                    this.mapElementStyles(i % 2 && styles.evenRow ? styles.evenRow : styles.oddRow, rowEl, [
                        "border-top",
                        "border-left",
                        "border-right",
                        "border-bottom",
                        "color",
                        "font-weight",
                        "font-family",
                        "font-size",
                        "background-color"
                    ]);
                    bodyEl.appendChild(rowEl);
                    break;
            }
        });
        if (headerEl.innerHTML) table.appendChild(headerEl);
        table.appendChild(bodyEl);
        this.mapElementStyles(this.table.element, table, [
            "border-top",
            "border-left",
            "border-right",
            "border-bottom"
        ]);
        return table;
    }
    lookupTableStyles() {
        var styles = {};
        //lookup row styles
        if (this.cloneTableStyle && window.getComputedStyle) {
            styles.oddRow = this.table.element.querySelector(".tabulator-row-odd:not(.tabulator-group):not(.tabulator-calcs)");
            styles.evenRow = this.table.element.querySelector(".tabulator-row-even:not(.tabulator-group):not(.tabulator-calcs)");
            styles.calcRow = this.table.element.querySelector(".tabulator-row.tabulator-calcs");
            styles.firstRow = this.table.element.querySelector(".tabulator-row:not(.tabulator-group):not(.tabulator-calcs)");
            styles.firstGroup = this.table.element.getElementsByClassName("tabulator-group")[0];
            if (styles.firstRow) {
                styles.styleCells = styles.firstRow.getElementsByClassName("tabulator-cell");
                styles.styleRowHeader = styles.firstRow.getElementsByClassName("tabulator-row-header")[0];
                styles.firstCell = styles.styleCells[0];
                styles.lastCell = styles.styleCells[styles.styleCells.length - 1];
            }
        }
        return styles;
    }
    generateHeaderElement(row, setup, styles) {
        var rowEl = document.createElement("tr");
        row.columns.forEach((column)=>{
            if (column) {
                var cellEl = document.createElement("th");
                var classNames = column.component._column.definition.cssClass ? column.component._column.definition.cssClass.split(" ") : [];
                cellEl.colSpan = column.width;
                cellEl.rowSpan = column.height;
                cellEl.innerHTML = column.value;
                if (this.cloneTableStyle) cellEl.style.boxSizing = "border-box";
                classNames.forEach(function(className) {
                    cellEl.classList.add(className);
                });
                this.mapElementStyles(column.component.getElement(), cellEl, [
                    "text-align",
                    "border-left",
                    "border-right",
                    "background-color",
                    "color",
                    "font-weight",
                    "font-family",
                    "font-size"
                ]);
                this.mapElementStyles(column.component._column.contentElement, cellEl, [
                    "padding-top",
                    "padding-left",
                    "padding-right",
                    "padding-bottom"
                ]);
                if (column.component._column.visible) this.mapElementStyles(column.component.getElement(), cellEl, [
                    "width"
                ]);
                else if (column.component._column.definition.width) cellEl.style.width = column.component._column.definition.width + "px";
                if (column.component._column.parent && column.component._column.parent.isGroup) this.mapElementStyles(column.component._column.parent.groupElement, cellEl, [
                    "border-top"
                ]);
                else this.mapElementStyles(column.component.getElement(), cellEl, [
                    "border-top"
                ]);
                if (column.component._column.isGroup) this.mapElementStyles(column.component.getElement(), cellEl, [
                    "border-bottom"
                ]);
                else this.mapElementStyles(this.table.columnManager.getElement(), cellEl, [
                    "border-bottom"
                ]);
                rowEl.appendChild(cellEl);
            }
        });
        return rowEl;
    }
    generateGroupElement(row, setup, styles) {
        var rowEl = document.createElement("tr"), cellEl = document.createElement("td"), group = row.columns[0];
        rowEl.classList.add("tabulator-print-table-row");
        if (setup.groupHeader && setup.groupHeader[row.indent]) group.value = setup.groupHeader[row.indent](group.value, row.component._group.getRowCount(), row.component._group.getData(), row.component);
        else if (setup.groupHeader !== false) group.value = row.component._group.generator(group.value, row.component._group.getRowCount(), row.component._group.getData(), row.component);
        cellEl.colSpan = group.width;
        cellEl.innerHTML = group.value;
        rowEl.classList.add("tabulator-print-table-group");
        rowEl.classList.add("tabulator-group-level-" + row.indent);
        if (group.component.isVisible()) rowEl.classList.add("tabulator-group-visible");
        this.mapElementStyles(styles.firstGroup, rowEl, [
            "border-top",
            "border-left",
            "border-right",
            "border-bottom",
            "color",
            "font-weight",
            "font-family",
            "font-size",
            "background-color"
        ]);
        this.mapElementStyles(styles.firstGroup, cellEl, [
            "padding-top",
            "padding-left",
            "padding-right",
            "padding-bottom"
        ]);
        rowEl.appendChild(cellEl);
        return rowEl;
    }
    generateCalcElement(row, setup, styles) {
        var rowEl = this.generateRowElement(row, setup, styles);
        rowEl.classList.add("tabulator-print-table-calcs");
        this.mapElementStyles(styles.calcRow, rowEl, [
            "border-top",
            "border-left",
            "border-right",
            "border-bottom",
            "color",
            "font-weight",
            "font-family",
            "font-size",
            "background-color"
        ]);
        return rowEl;
    }
    generateRowElement(row, setup, styles) {
        var rowEl = document.createElement("tr");
        rowEl.classList.add("tabulator-print-table-row");
        row.columns.forEach((col, i)=>{
            if (col) {
                var cellEl = document.createElement("td"), column = col.component._column, table = this.table, index = table.columnManager.findColumnIndex(column), value = col.value, cellStyle, styleProps;
                var cellWrapper = {
                    modules: {},
                    getValue: function() {
                        return value;
                    },
                    getField: function() {
                        return column.definition.field;
                    },
                    getElement: function() {
                        return cellEl;
                    },
                    getType: function() {
                        return "cell";
                    },
                    getColumn: function() {
                        return column.getComponent();
                    },
                    getData: function() {
                        return row.component.getData();
                    },
                    getRow: function() {
                        return row.component;
                    },
                    getTable: function() {
                        return table;
                    },
                    getComponent: function() {
                        return cellWrapper;
                    },
                    column: column
                };
                var classNames = column.definition.cssClass ? column.definition.cssClass.split(" ") : [];
                classNames.forEach(function(className) {
                    cellEl.classList.add(className);
                });
                if (this.table.modExists("format") && this.config.formatCells !== false) value = this.table.modules.format.formatExportValue(cellWrapper, this.colVisProp);
                else switch(typeof value){
                    case "object":
                        value = value !== null ? JSON.stringify(value) : "";
                        break;
                    case "undefined":
                        value = "";
                        break;
                }
                if (value instanceof Node) cellEl.appendChild(value);
                else cellEl.innerHTML = value;
                styleProps = [
                    "padding-top",
                    "padding-left",
                    "padding-right",
                    "padding-bottom",
                    "border-top",
                    "border-left",
                    "border-right",
                    "border-bottom",
                    "color",
                    "font-weight",
                    "font-family",
                    "font-size",
                    "text-align"
                ];
                if (column.isRowHeader) {
                    cellStyle = styles.styleRowHeader;
                    styleProps.push("background-color");
                } else cellStyle = styles.styleCells && styles.styleCells[index] ? styles.styleCells[index] : styles.firstCell;
                if (cellStyle) {
                    this.mapElementStyles(cellStyle, cellEl, styleProps);
                    if (column.definition.align) cellEl.style.textAlign = column.definition.align;
                }
                if (this.table.options.dataTree && this.config.dataTree !== false) {
                    if (setup.treeElementField && setup.treeElementField == column.field || !setup.treeElementField && i == 0) {
                        if (row.component._row.modules.dataTree.controlEl) cellEl.insertBefore(row.component._row.modules.dataTree.controlEl.cloneNode(true), cellEl.firstChild);
                        if (row.component._row.modules.dataTree.branchEl) cellEl.insertBefore(row.component._row.modules.dataTree.branchEl.cloneNode(true), cellEl.firstChild);
                    }
                }
                rowEl.appendChild(cellEl);
                if (cellWrapper.modules.format && cellWrapper.modules.format.renderedCallback) cellWrapper.modules.format.renderedCallback();
            }
        });
        if (setup.rowFormatter && row.type === "row" && this.config.formatCells !== false) {
            let formatComponent = Object.assign(row.component);
            formatComponent.getElement = function() {
                return rowEl;
            };
            setup.rowFormatter(row.component);
        }
        return rowEl;
    }
    generateHTMLTable(list) {
        var holder = document.createElement("div");
        holder.appendChild(this.generateTableElement(list));
        return holder.innerHTML;
    }
    getHtml(visible, style, config, colVisProp) {
        var list = this.generateExportList(config || this.table.options.htmlOutputConfig, style, visible, colVisProp || "htmlOutput");
        return this.generateHTMLTable(list);
    }
    mapElementStyles(from, to, props) {
        if (this.cloneTableStyle && from && to) {
            var lookup = {
                "background-color": "backgroundColor",
                "color": "fontColor",
                "width": "width",
                "font-weight": "fontWeight",
                "font-family": "fontFamily",
                "font-size": "fontSize",
                "text-align": "textAlign",
                "border-top": "borderTop",
                "border-left": "borderLeft",
                "border-right": "borderRight",
                "border-bottom": "borderBottom",
                "padding-top": "paddingTop",
                "padding-left": "paddingLeft",
                "padding-right": "paddingRight",
                "padding-bottom": "paddingBottom"
            };
            if (window.getComputedStyle) {
                var fromStyle = window.getComputedStyle(from);
                props.forEach(function(prop) {
                    if (!to.style[lookup[prop]]) to.style[lookup[prop]] = fromStyle.getPropertyValue(prop);
                });
            }
        }
    }
}
var $c2a9788f40f9c90a$var$defaultFilters = {
    //equal to
    "=": function(filterVal, rowVal, rowData, filterParams) {
        return rowVal == filterVal ? true : false;
    },
    //less than
    "<": function(filterVal, rowVal, rowData, filterParams) {
        return rowVal < filterVal ? true : false;
    },
    //less than or equal to
    "<=": function(filterVal, rowVal, rowData, filterParams) {
        return rowVal <= filterVal ? true : false;
    },
    //greater than
    ">": function(filterVal, rowVal, rowData, filterParams) {
        return rowVal > filterVal ? true : false;
    },
    //greater than or equal to
    ">=": function(filterVal, rowVal, rowData, filterParams) {
        return rowVal >= filterVal ? true : false;
    },
    //not equal to
    "!=": function(filterVal, rowVal, rowData, filterParams) {
        return rowVal != filterVal ? true : false;
    },
    "regex": function(filterVal, rowVal, rowData, filterParams) {
        if (typeof filterVal == "string") filterVal = new RegExp(filterVal);
        return filterVal.test(rowVal);
    },
    //contains the string
    "like": function(filterVal, rowVal, rowData, filterParams) {
        if (filterVal === null || typeof filterVal === "undefined") return rowVal === filterVal ? true : false;
        else {
            if (typeof rowVal !== 'undefined' && rowVal !== null) return String(rowVal).toLowerCase().indexOf(filterVal.toLowerCase()) > -1;
            else return false;
        }
    },
    //contains the keywords
    "keywords": function(filterVal, rowVal, rowData, filterParams) {
        var keywords = filterVal.toLowerCase().split(typeof filterParams.separator === "undefined" ? " " : filterParams.separator), value = String(rowVal === null || typeof rowVal === "undefined" ? "" : rowVal).toLowerCase(), matches = [];
        keywords.forEach((keyword)=>{
            if (value.includes(keyword)) matches.push(true);
        });
        return filterParams.matchAll ? matches.length === keywords.length : !!matches.length;
    },
    //starts with the string
    "starts": function(filterVal, rowVal, rowData, filterParams) {
        if (filterVal === null || typeof filterVal === "undefined") return rowVal === filterVal ? true : false;
        else {
            if (typeof rowVal !== 'undefined' && rowVal !== null) return String(rowVal).toLowerCase().startsWith(filterVal.toLowerCase());
            else return false;
        }
    },
    //ends with the string
    "ends": function(filterVal, rowVal, rowData, filterParams) {
        if (filterVal === null || typeof filterVal === "undefined") return rowVal === filterVal ? true : false;
        else {
            if (typeof rowVal !== 'undefined' && rowVal !== null) return String(rowVal).toLowerCase().endsWith(filterVal.toLowerCase());
            else return false;
        }
    },
    //in array
    "in": function(filterVal, rowVal, rowData, filterParams) {
        if (Array.isArray(filterVal)) return filterVal.length ? filterVal.indexOf(rowVal) > -1 : true;
        else {
            console.warn("Filter Error - filter value is not an array:", filterVal);
            return false;
        }
    }
};
class $c2a9788f40f9c90a$export$2e3bebbdf3339a4e extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "filter";
    //load defaults
    static filters = $c2a9788f40f9c90a$var$defaultFilters;
    constructor(table){
        super(table);
        this.filterList = []; //hold filter list
        this.headerFilters = {}; //hold column filters
        this.headerFilterColumns = []; //hold columns that use header filters
        this.prevHeaderFilterChangeCheck = "";
        this.prevHeaderFilterChangeCheck = "{}";
        this.changed = false; //has filtering changed since last render
        this.tableInitialized = false;
        this.registerTableOption("filterMode", "local"); //local or remote filtering
        this.registerTableOption("initialFilter", false); //initial filtering criteria
        this.registerTableOption("initialHeaderFilter", false); //initial header filtering criteria
        this.registerTableOption("headerFilterLiveFilterDelay", 300); //delay before updating column after user types in header filter
        this.registerTableOption("placeholderHeaderFilter", false); //placeholder when header filter is empty
        this.registerColumnOption("headerFilter");
        this.registerColumnOption("headerFilterPlaceholder");
        this.registerColumnOption("headerFilterParams");
        this.registerColumnOption("headerFilterEmptyCheck");
        this.registerColumnOption("headerFilterFunc");
        this.registerColumnOption("headerFilterFuncParams");
        this.registerColumnOption("headerFilterLiveFilter");
        this.registerTableFunction("searchRows", this.searchRows.bind(this));
        this.registerTableFunction("searchData", this.searchData.bind(this));
        this.registerTableFunction("setFilter", this.userSetFilter.bind(this));
        this.registerTableFunction("refreshFilter", this.userRefreshFilter.bind(this));
        this.registerTableFunction("addFilter", this.userAddFilter.bind(this));
        this.registerTableFunction("getFilters", this.getFilters.bind(this));
        this.registerTableFunction("setHeaderFilterFocus", this.userSetHeaderFilterFocus.bind(this));
        this.registerTableFunction("getHeaderFilterValue", this.userGetHeaderFilterValue.bind(this));
        this.registerTableFunction("setHeaderFilterValue", this.userSetHeaderFilterValue.bind(this));
        this.registerTableFunction("getHeaderFilters", this.getHeaderFilters.bind(this));
        this.registerTableFunction("removeFilter", this.userRemoveFilter.bind(this));
        this.registerTableFunction("clearFilter", this.userClearFilter.bind(this));
        this.registerTableFunction("clearHeaderFilter", this.userClearHeaderFilter.bind(this));
        this.registerComponentFunction("column", "headerFilterFocus", this.setHeaderFilterFocus.bind(this));
        this.registerComponentFunction("column", "reloadHeaderFilter", this.reloadHeaderFilter.bind(this));
        this.registerComponentFunction("column", "getHeaderFilterValue", this.getHeaderFilterValue.bind(this));
        this.registerComponentFunction("column", "setHeaderFilterValue", this.setHeaderFilterValue.bind(this));
    }
    initialize() {
        this.subscribe("column-init", this.initializeColumnHeaderFilter.bind(this));
        this.subscribe("column-width-fit-before", this.hideHeaderFilterElements.bind(this));
        this.subscribe("column-width-fit-after", this.showHeaderFilterElements.bind(this));
        this.subscribe("table-built", this.tableBuilt.bind(this));
        this.subscribe("placeholder", this.generatePlaceholder.bind(this));
        if (this.table.options.filterMode === "remote") this.subscribe("data-params", this.remoteFilterParams.bind(this));
        this.registerDataHandler(this.filter.bind(this), 10);
    }
    tableBuilt() {
        if (this.table.options.initialFilter) this.setFilter(this.table.options.initialFilter);
        if (this.table.options.initialHeaderFilter) this.table.options.initialHeaderFilter.forEach((item)=>{
            var column = this.table.columnManager.findColumn(item.field);
            if (column) this.setHeaderFilterValue(column, item.value);
            else {
                console.warn("Column Filter Error - No matching column found:", item.field);
                return false;
            }
        });
        this.tableInitialized = true;
    }
    remoteFilterParams(data, config, silent, params) {
        params.filter = this.getFilters(true, true);
        return params;
    }
    generatePlaceholder(text) {
        if (this.table.options.placeholderHeaderFilter && Object.keys(this.headerFilters).length) return this.table.options.placeholderHeaderFilter;
    }
    ///////////////////////////////////
    ///////// Table Functions /////////
    ///////////////////////////////////
    //set standard filters
    userSetFilter(field, type, value, params) {
        this.setFilter(field, type, value, params);
        this.refreshFilter();
    }
    //set standard filters
    userRefreshFilter() {
        this.refreshFilter();
    }
    //add filter to array
    userAddFilter(field, type, value, params) {
        this.addFilter(field, type, value, params);
        this.refreshFilter();
    }
    userSetHeaderFilterFocus(field) {
        var column = this.table.columnManager.findColumn(field);
        if (column) this.setHeaderFilterFocus(column);
        else {
            console.warn("Column Filter Focus Error - No matching column found:", field);
            return false;
        }
    }
    userGetHeaderFilterValue(field) {
        var column = this.table.columnManager.findColumn(field);
        if (column) return this.getHeaderFilterValue(column);
        else console.warn("Column Filter Error - No matching column found:", field);
    }
    userSetHeaderFilterValue(field, value) {
        var column = this.table.columnManager.findColumn(field);
        if (column) this.setHeaderFilterValue(column, value);
        else {
            console.warn("Column Filter Error - No matching column found:", field);
            return false;
        }
    }
    //remove filter from array
    userRemoveFilter(field, type, value) {
        this.removeFilter(field, type, value);
        this.refreshFilter();
    }
    //clear filters
    userClearFilter(all) {
        this.clearFilter(all);
        this.refreshFilter();
    }
    //clear header filters
    userClearHeaderFilter() {
        this.clearHeaderFilter();
        this.refreshFilter();
    }
    //search for specific row components
    searchRows(field, type, value) {
        return this.search("rows", field, type, value);
    }
    //search for specific data
    searchData(field, type, value) {
        return this.search("data", field, type, value);
    }
    ///////////////////////////////////
    ///////// Internal Logic //////////
    ///////////////////////////////////
    initializeColumnHeaderFilter(column) {
        var def = column.definition;
        if (def.headerFilter) this.initializeColumn(column);
    }
    //initialize column header filter
    initializeColumn(column, value) {
        var self = this, field = column.getField();
        //handle successfully value change
        function success(value) {
            var filterType = column.modules.filter.tagType == "input" && column.modules.filter.attrType == "text" || column.modules.filter.tagType == "textarea" ? "partial" : "match", type = "", filterChangeCheck = "", filterFunc;
            if (typeof column.modules.filter.prevSuccess === "undefined" || column.modules.filter.prevSuccess !== value) {
                column.modules.filter.prevSuccess = value;
                if (!column.modules.filter.emptyFunc(value)) {
                    column.modules.filter.value = value;
                    switch(typeof column.definition.headerFilterFunc){
                        case "string":
                            if ($c2a9788f40f9c90a$export$2e3bebbdf3339a4e.filters[column.definition.headerFilterFunc]) {
                                type = column.definition.headerFilterFunc;
                                filterFunc = function(data) {
                                    var params = column.definition.headerFilterFuncParams || {};
                                    var fieldVal = column.getFieldValue(data);
                                    params = typeof params === "function" ? params(value, fieldVal, data) : params;
                                    return $c2a9788f40f9c90a$export$2e3bebbdf3339a4e.filters[column.definition.headerFilterFunc](value, fieldVal, data, params);
                                };
                            } else console.warn("Header Filter Error - Matching filter function not found: ", column.definition.headerFilterFunc);
                            break;
                        case "function":
                            filterFunc = function(data) {
                                var params = column.definition.headerFilterFuncParams || {};
                                var fieldVal = column.getFieldValue(data);
                                params = typeof params === "function" ? params(value, fieldVal, data) : params;
                                return column.definition.headerFilterFunc(value, fieldVal, data, params);
                            };
                            type = filterFunc;
                            break;
                    }
                    if (!filterFunc) switch(filterType){
                        case "partial":
                            filterFunc = function(data) {
                                var colVal = column.getFieldValue(data);
                                if (typeof colVal !== 'undefined' && colVal !== null) return String(colVal).toLowerCase().indexOf(String(value).toLowerCase()) > -1;
                                else return false;
                            };
                            type = "like";
                            break;
                        default:
                            filterFunc = function(data) {
                                return column.getFieldValue(data) == value;
                            };
                            type = "=";
                    }
                    self.headerFilters[field] = {
                        value: value,
                        func: filterFunc,
                        type: type
                    };
                } else delete self.headerFilters[field];
                column.modules.filter.value = value;
                filterChangeCheck = JSON.stringify(self.headerFilters);
                if (self.prevHeaderFilterChangeCheck !== filterChangeCheck) {
                    self.prevHeaderFilterChangeCheck = filterChangeCheck;
                    self.trackChanges();
                    self.refreshFilter();
                }
            }
            return true;
        }
        column.modules.filter = {
            success: success,
            attrType: false,
            tagType: false,
            emptyFunc: false
        };
        this.generateHeaderFilterElement(column);
    }
    generateHeaderFilterElement(column, initialValue, reinitialize) {
        var self = this, success = column.modules.filter.success, field = column.getField(), filterElement, editor, editorElement, cellWrapper, typingTimer, searchTrigger, params, onRenderedCallback;
        column.modules.filter.value = initialValue;
        //handle aborted edit
        function cancel() {}
        function onRendered(callback) {
            onRenderedCallback = callback;
        }
        if (column.modules.filter.headerElement && column.modules.filter.headerElement.parentNode) column.contentElement.removeChild(column.modules.filter.headerElement.parentNode);
        if (field) {
            //set empty value function
            column.modules.filter.emptyFunc = column.definition.headerFilterEmptyCheck || function(value) {
                return !value && value !== 0;
            };
            filterElement = document.createElement("div");
            filterElement.classList.add("tabulator-header-filter");
            //set column editor
            switch(typeof column.definition.headerFilter){
                case "string":
                    if (self.table.modules.edit.editors[column.definition.headerFilter]) {
                        editor = self.table.modules.edit.editors[column.definition.headerFilter];
                        if ((column.definition.headerFilter === "tick" || column.definition.headerFilter === "tickCross") && !column.definition.headerFilterEmptyCheck) column.modules.filter.emptyFunc = function(value) {
                            return value !== true && value !== false;
                        };
                    } else console.warn("Filter Error - Cannot build header filter, No such editor found: ", column.definition.editor);
                    break;
                case "function":
                    editor = column.definition.headerFilter;
                    break;
                case "boolean":
                    if (column.modules.edit && column.modules.edit.editor) editor = column.modules.edit.editor;
                    else if (column.definition.formatter && self.table.modules.edit.editors[column.definition.formatter]) {
                        editor = self.table.modules.edit.editors[column.definition.formatter];
                        if ((column.definition.formatter === "tick" || column.definition.formatter === "tickCross") && !column.definition.headerFilterEmptyCheck) column.modules.filter.emptyFunc = function(value) {
                            return value !== true && value !== false;
                        };
                    } else editor = self.table.modules.edit.editors["input"];
                    break;
            }
            if (editor) {
                cellWrapper = {
                    getValue: function() {
                        return typeof initialValue !== "undefined" ? initialValue : "";
                    },
                    getField: function() {
                        return column.definition.field;
                    },
                    getElement: function() {
                        return filterElement;
                    },
                    getColumn: function() {
                        return column.getComponent();
                    },
                    getTable: ()=>{
                        return this.table;
                    },
                    getType: ()=>{
                        return "header";
                    },
                    getRow: function() {
                        return {
                            normalizeHeight: function() {}
                        };
                    }
                };
                params = column.definition.headerFilterParams || {};
                params = typeof params === "function" ? params.call(self.table, cellWrapper) : params;
                editorElement = editor.call(this.table.modules.edit, cellWrapper, onRendered, success, cancel, params);
                if (!editorElement) {
                    console.warn("Filter Error - Cannot add filter to " + field + " column, editor returned a value of false");
                    return;
                }
                if (!(editorElement instanceof Node)) {
                    console.warn("Filter Error - Cannot add filter to " + field + " column, editor should return an instance of Node, the editor returned:", editorElement);
                    return;
                }
                //set Placeholder Text
                self.langBind("headerFilters|columns|" + column.definition.field, function(value) {
                    editorElement.setAttribute("placeholder", typeof value !== "undefined" && value ? value : column.definition.headerFilterPlaceholder || self.langText("headerFilters|default"));
                });
                //focus on element on click
                editorElement.addEventListener("click", function(e) {
                    e.stopPropagation();
                    editorElement.focus();
                });
                editorElement.addEventListener("focus", (e)=>{
                    var left = this.table.columnManager.contentsElement.scrollLeft;
                    var headerPos = this.table.rowManager.element.scrollLeft;
                    if (left !== headerPos) {
                        this.table.rowManager.scrollHorizontal(left);
                        this.table.columnManager.scrollHorizontal(left);
                    }
                });
                //live update filters as user types
                typingTimer = false;
                searchTrigger = function(e) {
                    if (typingTimer) clearTimeout(typingTimer);
                    typingTimer = setTimeout(function() {
                        success(editorElement.value);
                    }, self.table.options.headerFilterLiveFilterDelay);
                };
                column.modules.filter.headerElement = editorElement;
                column.modules.filter.attrType = editorElement.hasAttribute("type") ? editorElement.getAttribute("type").toLowerCase() : "";
                column.modules.filter.tagType = editorElement.tagName.toLowerCase();
                if (column.definition.headerFilterLiveFilter !== false) {
                    if (!(column.definition.headerFilter === 'autocomplete' || column.definition.headerFilter === 'tickCross' || (column.definition.editor === 'autocomplete' || column.definition.editor === 'tickCross') && column.definition.headerFilter === true)) {
                        editorElement.addEventListener("keyup", searchTrigger);
                        editorElement.addEventListener("search", searchTrigger);
                        //update number filtered columns on change
                        if (column.modules.filter.attrType == "number") editorElement.addEventListener("change", function(e) {
                            success(editorElement.value);
                        });
                        //change text inputs to search inputs to allow for clearing of field
                        if (column.modules.filter.attrType == "text" && this.table.browser !== "ie") editorElement.setAttribute("type", "search");
                    }
                    //prevent input and select elements from propagating click to column sorters etc
                    if (column.modules.filter.tagType == "input" || column.modules.filter.tagType == "select" || column.modules.filter.tagType == "textarea") editorElement.addEventListener("mousedown", function(e) {
                        e.stopPropagation();
                    });
                }
                filterElement.appendChild(editorElement);
                column.contentElement.appendChild(filterElement);
                if (!reinitialize) self.headerFilterColumns.push(column);
                if (onRenderedCallback) onRenderedCallback();
            }
        } else console.warn("Filter Error - Cannot add header filter, column has no field set:", column.definition.title);
    }
    //hide all header filter elements (used to ensure correct column widths in "fitData" layout mode)
    hideHeaderFilterElements() {
        this.headerFilterColumns.forEach(function(column) {
            if (column.modules.filter && column.modules.filter.headerElement) column.modules.filter.headerElement.style.display = 'none';
        });
    }
    //show all header filter elements (used to ensure correct column widths in "fitData" layout mode)
    showHeaderFilterElements() {
        this.headerFilterColumns.forEach(function(column) {
            if (column.modules.filter && column.modules.filter.headerElement) column.modules.filter.headerElement.style.display = '';
        });
    }
    //programmatically set focus of header filter
    setHeaderFilterFocus(column) {
        if (column.modules.filter && column.modules.filter.headerElement) column.modules.filter.headerElement.focus();
        else console.warn("Column Filter Focus Error - No header filter set on column:", column.getField());
    }
    //programmatically get value of header filter
    getHeaderFilterValue(column) {
        if (column.modules.filter && column.modules.filter.headerElement) return column.modules.filter.value;
        else console.warn("Column Filter Error - No header filter set on column:", column.getField());
    }
    //programmatically set value of header filter
    setHeaderFilterValue(column, value) {
        if (column) {
            if (column.modules.filter && column.modules.filter.headerElement) {
                this.generateHeaderFilterElement(column, value, true);
                column.modules.filter.success(value);
            } else console.warn("Column Filter Error - No header filter set on column:", column.getField());
        }
    }
    reloadHeaderFilter(column) {
        if (column) {
            if (column.modules.filter && column.modules.filter.headerElement) this.generateHeaderFilterElement(column, column.modules.filter.value, true);
            else console.warn("Column Filter Error - No header filter set on column:", column.getField());
        }
    }
    refreshFilter() {
        if (this.tableInitialized) {
            if (this.table.options.filterMode === "remote") this.reloadData(null, false, false);
            else this.refreshData(true);
        }
    //TODO - Persist left position of row manager
    // left = this.scrollLeft;
    // this.scrollHorizontal(left);
    }
    //check if the filters has changed since last use
    trackChanges() {
        this.changed = true;
        this.dispatch("filter-changed");
    }
    //check if the filters has changed since last use
    hasChanged() {
        var changed = this.changed;
        this.changed = false;
        return changed;
    }
    //set standard filters
    setFilter(field, type, value, params) {
        this.filterList = [];
        if (!Array.isArray(field)) field = [
            {
                field: field,
                type: type,
                value: value,
                params: params
            }
        ];
        this.addFilter(field);
    }
    //add filter to array
    addFilter(field, type, value, params) {
        var changed = false;
        if (!Array.isArray(field)) field = [
            {
                field: field,
                type: type,
                value: value,
                params: params
            }
        ];
        field.forEach((filter)=>{
            filter = this.findFilter(filter);
            if (filter) {
                this.filterList.push(filter);
                changed = true;
            }
        });
        if (changed) this.trackChanges();
    }
    findFilter(filter) {
        var column;
        if (Array.isArray(filter)) return this.findSubFilters(filter);
        var filterFunc = false;
        if (typeof filter.field == "function") filterFunc = function(data) {
            return filter.field(data, filter.type || {}); // pass params to custom filter function
        };
        else if ($c2a9788f40f9c90a$export$2e3bebbdf3339a4e.filters[filter.type]) {
            column = this.table.columnManager.getColumnByField(filter.field);
            if (column) filterFunc = function(data) {
                return $c2a9788f40f9c90a$export$2e3bebbdf3339a4e.filters[filter.type](filter.value, column.getFieldValue(data), data, filter.params || {});
            };
            else filterFunc = function(data) {
                return $c2a9788f40f9c90a$export$2e3bebbdf3339a4e.filters[filter.type](filter.value, data[filter.field], data, filter.params || {});
            };
        } else console.warn("Filter Error - No such filter type found, ignoring: ", filter.type);
        filter.func = filterFunc;
        return filter.func ? filter : false;
    }
    findSubFilters(filters) {
        var output = [];
        filters.forEach((filter)=>{
            filter = this.findFilter(filter);
            if (filter) output.push(filter);
        });
        return output.length ? output : false;
    }
    //get all filters
    getFilters(all, ajax) {
        var output = [];
        if (all) output = this.getHeaderFilters();
        if (ajax) output.forEach(function(item) {
            if (typeof item.type == "function") item.type = "function";
        });
        output = output.concat(this.filtersToArray(this.filterList, ajax));
        return output;
    }
    //filter to Object
    filtersToArray(filterList, ajax) {
        var output = [];
        filterList.forEach((filter)=>{
            var item;
            if (Array.isArray(filter)) output.push(this.filtersToArray(filter, ajax));
            else {
                item = {
                    field: filter.field,
                    type: filter.type,
                    value: filter.value
                };
                if (ajax) {
                    if (typeof item.type == "function") item.type = "function";
                }
                output.push(item);
            }
        });
        return output;
    }
    //get all filters
    getHeaderFilters() {
        var output = [];
        for(var key in this.headerFilters)output.push({
            field: key,
            type: this.headerFilters[key].type,
            value: this.headerFilters[key].value
        });
        return output;
    }
    //remove filter from array
    removeFilter(field, type, value) {
        if (!Array.isArray(field)) field = [
            {
                field: field,
                type: type,
                value: value
            }
        ];
        field.forEach((filter)=>{
            var index = -1;
            if (typeof filter.field == "object") index = this.filterList.findIndex((element)=>{
                return filter === element;
            });
            else index = this.filterList.findIndex((element)=>{
                return filter.field === element.field && filter.type === element.type && filter.value === element.value;
            });
            if (index > -1) this.filterList.splice(index, 1);
            else console.warn("Filter Error - No matching filter type found, ignoring: ", filter.type);
        });
        this.trackChanges();
    }
    //clear filters
    clearFilter(all) {
        this.filterList = [];
        if (all) this.clearHeaderFilter();
        this.trackChanges();
    }
    //clear header filters
    clearHeaderFilter() {
        this.headerFilters = {};
        this.prevHeaderFilterChangeCheck = "{}";
        this.headerFilterColumns.forEach((column)=>{
            if (typeof column.modules.filter.value !== "undefined") delete column.modules.filter.value;
            column.modules.filter.prevSuccess = undefined;
            this.reloadHeaderFilter(column);
        });
        this.trackChanges();
    }
    //search data and return matching rows
    search(searchType, field, type, value) {
        var activeRows = [], filterList = [];
        if (!Array.isArray(field)) field = [
            {
                field: field,
                type: type,
                value: value
            }
        ];
        field.forEach((filter)=>{
            filter = this.findFilter(filter);
            if (filter) filterList.push(filter);
        });
        this.table.rowManager.rows.forEach((row)=>{
            var match = true;
            filterList.forEach((filter)=>{
                if (!this.filterRecurse(filter, row.getData())) match = false;
            });
            if (match) activeRows.push(searchType === "data" ? row.getData("data") : row.getComponent());
        });
        return activeRows;
    }
    //filter row array
    filter(rowList, filters) {
        var activeRows = [], activeRowComponents = [];
        if (this.subscribedExternal("dataFiltering")) this.dispatchExternal("dataFiltering", this.getFilters(true));
        if (this.table.options.filterMode !== "remote" && (this.filterList.length || Object.keys(this.headerFilters).length)) rowList.forEach((row)=>{
            if (this.filterRow(row)) activeRows.push(row);
        });
        else activeRows = rowList.slice(0);
        if (this.subscribedExternal("dataFiltered")) {
            activeRows.forEach((row)=>{
                activeRowComponents.push(row.getComponent());
            });
            this.dispatchExternal("dataFiltered", this.getFilters(true), activeRowComponents);
        }
        return activeRows;
    }
    //filter individual row
    filterRow(row, filters) {
        var match = true, data = row.getData();
        this.filterList.forEach((filter)=>{
            if (!this.filterRecurse(filter, data)) match = false;
        });
        for(var field in this.headerFilters)if (!this.headerFilters[field].func(data)) match = false;
        return match;
    }
    filterRecurse(filter, data) {
        var match = false;
        if (Array.isArray(filter)) filter.forEach((subFilter)=>{
            if (this.filterRecurse(subFilter, data)) match = true;
        });
        else match = filter.func(data);
        return match;
    }
}
function $c2a9788f40f9c90a$var$plaintext(cell, formatterParams, onRendered) {
    return this.emptyToSpace(this.sanitizeHTML(cell.getValue()));
}
function $c2a9788f40f9c90a$var$html(cell, formatterParams, onRendered) {
    return cell.getValue();
}
function $c2a9788f40f9c90a$var$textarea(cell, formatterParams, onRendered) {
    cell.getElement().style.whiteSpace = "pre-wrap";
    return this.emptyToSpace(this.sanitizeHTML(cell.getValue()));
}
function $c2a9788f40f9c90a$var$money(cell, formatterParams, onRendered) {
    var floatVal = parseFloat(cell.getValue()), sign = "", number, integer, decimal, rgx, value;
    var decimalSym = formatterParams.decimal || ".";
    var thousandSym = formatterParams.thousand || ",";
    var negativeSign = formatterParams.negativeSign || "-";
    var symbol = formatterParams.symbol || "";
    var after = !!formatterParams.symbolAfter;
    var precision = typeof formatterParams.precision !== "undefined" ? formatterParams.precision : 2;
    if (isNaN(floatVal)) return this.emptyToSpace(this.sanitizeHTML(cell.getValue()));
    if (floatVal < 0) {
        floatVal = Math.abs(floatVal);
        sign = negativeSign;
    }
    number = precision !== false ? floatVal.toFixed(precision) : floatVal;
    number = String(number).split(".");
    integer = number[0];
    decimal = number.length > 1 ? decimalSym + number[1] : "";
    if (formatterParams.thousand !== false) {
        rgx = /(\d+)(\d{3})/;
        while(rgx.test(integer))integer = integer.replace(rgx, "$1" + thousandSym + "$2");
    }
    value = integer + decimal;
    if (sign === true) {
        value = "(" + value + ")";
        return after ? value + symbol : symbol + value;
    } else return after ? sign + value + symbol : sign + symbol + value;
}
function $c2a9788f40f9c90a$var$link(cell, formatterParams, onRendered) {
    var value = cell.getValue(), urlPrefix = formatterParams.urlPrefix || "", download = formatterParams.download, label = value, el = document.createElement("a"), data;
    function labelTraverse(path, data) {
        var item = path.shift(), value = data[item];
        if (path.length && typeof value === "object") return labelTraverse(path, value);
        return value;
    }
    if (formatterParams.labelField) {
        data = cell.getData();
        label = labelTraverse(formatterParams.labelField.split(this.table.options.nestedFieldSeparator), data);
    }
    if (formatterParams.label) switch(typeof formatterParams.label){
        case "string":
            label = formatterParams.label;
            break;
        case "function":
            label = formatterParams.label(cell);
            break;
    }
    if (label) {
        if (formatterParams.urlField) {
            data = cell.getData();
            value = $c2a9788f40f9c90a$var$Helpers.retrieveNestedData(this.table.options.nestedFieldSeparator, formatterParams.urlField, data);
        }
        if (formatterParams.url) switch(typeof formatterParams.url){
            case "string":
                value = formatterParams.url;
                break;
            case "function":
                value = formatterParams.url(cell);
                break;
        }
        el.setAttribute("href", urlPrefix + value);
        if (formatterParams.target) el.setAttribute("target", formatterParams.target);
        if (formatterParams.download) {
            if (typeof download == "function") download = download(cell);
            else download = download === true ? "" : download;
            el.setAttribute("download", download);
        }
        el.innerHTML = this.emptyToSpace(this.sanitizeHTML(label));
        return el;
    } else return "&nbsp;";
}
function $c2a9788f40f9c90a$var$image(cell, formatterParams, onRendered) {
    var el = document.createElement("img"), src = cell.getValue();
    if (formatterParams.urlPrefix) src = formatterParams.urlPrefix + cell.getValue();
    if (formatterParams.urlSuffix) src = src + formatterParams.urlSuffix;
    el.setAttribute("src", src);
    switch(typeof formatterParams.height){
        case "number":
            el.style.height = formatterParams.height + "px";
            break;
        case "string":
            el.style.height = formatterParams.height;
            break;
    }
    switch(typeof formatterParams.width){
        case "number":
            el.style.width = formatterParams.width + "px";
            break;
        case "string":
            el.style.width = formatterParams.width;
            break;
    }
    el.addEventListener("load", function() {
        cell.getRow().normalizeHeight();
    });
    return el;
}
function $c2a9788f40f9c90a$var$tickCross(cell, formatterParams, onRendered) {
    var value = cell.getValue(), element = cell.getElement(), empty = formatterParams.allowEmpty, truthy = formatterParams.allowTruthy, trueValueSet = Object.keys(formatterParams).includes("trueValue"), tick = typeof formatterParams.tickElement !== "undefined" ? formatterParams.tickElement : '<svg enable-background="new 0 0 24 24" height="14" width="14" viewBox="0 0 24 24" xml:space="preserve" ><path fill="#2DC214" clip-rule="evenodd" d="M21.652,3.211c-0.293-0.295-0.77-0.295-1.061,0L9.41,14.34  c-0.293,0.297-0.771,0.297-1.062,0L3.449,9.351C3.304,9.203,3.114,9.13,2.923,9.129C2.73,9.128,2.534,9.201,2.387,9.351  l-2.165,1.946C0.078,11.445,0,11.63,0,11.823c0,0.194,0.078,0.397,0.223,0.544l4.94,5.184c0.292,0.296,0.771,0.776,1.062,1.07  l2.124,2.141c0.292,0.293,0.769,0.293,1.062,0l14.366-14.34c0.293-0.294,0.293-0.777,0-1.071L21.652,3.211z" fill-rule="evenodd"/></svg>', cross = typeof formatterParams.crossElement !== "undefined" ? formatterParams.crossElement : '<svg enable-background="new 0 0 24 24" height="14" width="14"  viewBox="0 0 24 24" xml:space="preserve" ><path fill="#CE1515" d="M22.245,4.015c0.313,0.313,0.313,0.826,0,1.139l-6.276,6.27c-0.313,0.312-0.313,0.826,0,1.14l6.273,6.272  c0.313,0.313,0.313,0.826,0,1.14l-2.285,2.277c-0.314,0.312-0.828,0.312-1.142,0l-6.271-6.271c-0.313-0.313-0.828-0.313-1.141,0  l-6.276,6.267c-0.313,0.313-0.828,0.313-1.141,0l-2.282-2.28c-0.313-0.313-0.313-0.826,0-1.14l6.278-6.269  c0.313-0.312,0.313-0.826,0-1.14L1.709,5.147c-0.314-0.313-0.314-0.827,0-1.14l2.284-2.278C4.308,1.417,4.821,1.417,5.135,1.73  L11.405,8c0.314,0.314,0.828,0.314,1.141,0.001l6.276-6.267c0.312-0.312,0.826-0.312,1.141,0L22.245,4.015z"/></svg>';
    if (trueValueSet && value === formatterParams.trueValue || !trueValueSet && (truthy && value || value === true || value === "true" || value === "True" || value === 1 || value === "1")) {
        element.setAttribute("aria-checked", true);
        return tick || "";
    } else if (empty && (value === "null" || value === "" || value === null || typeof value === "undefined")) {
        element.setAttribute("aria-checked", "mixed");
        return "";
    } else {
        element.setAttribute("aria-checked", false);
        return cross || "";
    }
}
function $c2a9788f40f9c90a$var$datetime$1(cell, formatterParams, onRendered) {
    var DT = this.table.dependencyRegistry.lookup([
        "luxon",
        "DateTime"
    ], "DateTime");
    var inputFormat = formatterParams.inputFormat || "yyyy-MM-dd HH:mm:ss";
    var outputFormat = formatterParams.outputFormat || "dd/MM/yyyy HH:mm:ss";
    var invalid = typeof formatterParams.invalidPlaceholder !== "undefined" ? formatterParams.invalidPlaceholder : "";
    var value = cell.getValue();
    if (typeof DT != "undefined") {
        var newDatetime;
        if (DT.isDateTime(value)) newDatetime = value;
        else if (inputFormat === "iso") newDatetime = DT.fromISO(String(value));
        else newDatetime = DT.fromFormat(String(value), inputFormat);
        if (newDatetime.isValid) {
            if (formatterParams.timezone) newDatetime = newDatetime.setZone(formatterParams.timezone);
            return newDatetime.toFormat(outputFormat);
        } else {
            if (invalid === true || !value) return value;
            else if (typeof invalid === "function") return invalid(value);
            else return invalid;
        }
    } else console.error("Format Error - 'datetime' formatter is dependant on luxon.js");
}
function $c2a9788f40f9c90a$var$datetimediff(cell, formatterParams, onRendered) {
    var DT = this.table.dependencyRegistry.lookup([
        "luxon",
        "DateTime"
    ], "DateTime");
    var inputFormat = formatterParams.inputFormat || "yyyy-MM-dd HH:mm:ss";
    var invalid = typeof formatterParams.invalidPlaceholder !== "undefined" ? formatterParams.invalidPlaceholder : "";
    var suffix = typeof formatterParams.suffix !== "undefined" ? formatterParams.suffix : false;
    var unit = typeof formatterParams.unit !== "undefined" ? formatterParams.unit : "days";
    var humanize = typeof formatterParams.humanize !== "undefined" ? formatterParams.humanize : false;
    var date = typeof formatterParams.date !== "undefined" ? formatterParams.date : DT.now();
    var value = cell.getValue();
    if (typeof DT != "undefined") {
        var newDatetime;
        if (DT.isDateTime(value)) newDatetime = value;
        else if (inputFormat === "iso") newDatetime = DT.fromISO(String(value));
        else newDatetime = DT.fromFormat(String(value), inputFormat);
        if (newDatetime.isValid) {
            if (humanize) return newDatetime.diff(date, unit).toHuman() + (suffix ? " " + suffix : "");
            else return parseInt(newDatetime.diff(date, unit)[unit]) + (suffix ? " " + suffix : "");
        } else {
            if (invalid === true) return value;
            else if (typeof invalid === "function") return invalid(value);
            else return invalid;
        }
    } else console.error("Format Error - 'datetimediff' formatter is dependant on luxon.js");
}
function $c2a9788f40f9c90a$var$lookup(cell, formatterParams, onRendered) {
    var value = cell.getValue();
    if (typeof formatterParams[value] === "undefined") {
        console.warn('Missing display value for ' + value);
        return value;
    }
    return formatterParams[value];
}
function $c2a9788f40f9c90a$var$star(cell, formatterParams, onRendered) {
    var value = cell.getValue(), element = cell.getElement(), maxStars = formatterParams && formatterParams.stars ? formatterParams.stars : 5, stars = document.createElement("span"), star = document.createElementNS('http://www.w3.org/2000/svg', "svg"), starActive = '<polygon fill="#FFEA00" stroke="#C1AB60" stroke-width="37.6152" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="259.216,29.942 330.27,173.919 489.16,197.007 374.185,309.08 401.33,467.31 259.216,392.612 117.104,467.31 144.25,309.08 29.274,197.007 188.165,173.919 "/>', starInactive = '<polygon fill="#D2D2D2" stroke="#686868" stroke-width="37.6152" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="259.216,29.942 330.27,173.919 489.16,197.007 374.185,309.08 401.33,467.31 259.216,392.612 117.104,467.31 144.25,309.08 29.274,197.007 188.165,173.919 "/>';
    //style stars holder
    stars.style.verticalAlign = "middle";
    //style star
    star.setAttribute("width", "14");
    star.setAttribute("height", "14");
    star.setAttribute("viewBox", "0 0 512 512");
    star.setAttribute("xml:space", "preserve");
    star.style.padding = "0 1px";
    value = value && !isNaN(value) ? parseInt(value) : 0;
    value = Math.max(0, Math.min(value, maxStars));
    for(var i = 1; i <= maxStars; i++){
        var nextStar = star.cloneNode(true);
        nextStar.innerHTML = i <= value ? starActive : starInactive;
        stars.appendChild(nextStar);
    }
    element.style.whiteSpace = "nowrap";
    element.style.overflow = "hidden";
    element.style.textOverflow = "ellipsis";
    element.setAttribute("aria-label", value);
    return stars;
}
function $c2a9788f40f9c90a$var$traffic(cell, formatterParams, onRendered) {
    var value = this.sanitizeHTML(cell.getValue()) || 0, el = document.createElement("span"), max = formatterParams && formatterParams.max ? formatterParams.max : 100, min = formatterParams && formatterParams.min ? formatterParams.min : 0, colors = formatterParams && typeof formatterParams.color !== "undefined" ? formatterParams.color : [
        "red",
        "orange",
        "green"
    ], color = "#666666", percent, percentValue;
    if (isNaN(value) || typeof cell.getValue() === "undefined") return;
    el.classList.add("tabulator-traffic-light");
    //make sure value is in range
    percentValue = parseFloat(value) <= max ? parseFloat(value) : max;
    percentValue = parseFloat(percentValue) >= min ? parseFloat(percentValue) : min;
    //workout percentage
    percent = (max - min) / 100;
    percentValue = Math.round((percentValue - min) / percent);
    //set color
    switch(typeof colors){
        case "string":
            color = colors;
            break;
        case "function":
            color = colors(value);
            break;
        case "object":
            if (Array.isArray(colors)) {
                var unit = 100 / colors.length;
                var index = Math.floor(percentValue / unit);
                index = Math.min(index, colors.length - 1);
                index = Math.max(index, 0);
                color = colors[index];
                break;
            }
    }
    el.style.backgroundColor = color;
    return el;
}
function $c2a9788f40f9c90a$var$progress(cell, formatterParams = {}, onRendered) {
    var value = this.sanitizeHTML(cell.getValue()) || 0, element = cell.getElement(), max = formatterParams.max ? formatterParams.max : 100, min = formatterParams.min ? formatterParams.min : 0, legendAlign = formatterParams.legendAlign ? formatterParams.legendAlign : "center", percent, percentValue, color, legend, legendColor;
    //make sure value is in range
    percentValue = parseFloat(value) <= max ? parseFloat(value) : max;
    percentValue = parseFloat(percentValue) >= min ? parseFloat(percentValue) : min;
    //workout percentage
    percent = (max - min) / 100;
    percentValue = Math.round((percentValue - min) / percent);
    //set bar color
    switch(typeof formatterParams.color){
        case "string":
            color = formatterParams.color;
            break;
        case "function":
            color = formatterParams.color(value);
            break;
        case "object":
            if (Array.isArray(formatterParams.color)) {
                let unit = 100 / formatterParams.color.length;
                let index = Math.floor(percentValue / unit);
                index = Math.min(index, formatterParams.color.length - 1);
                index = Math.max(index, 0);
                color = formatterParams.color[index];
                break;
            }
        default:
            color = "#2DC214";
    }
    //generate legend
    switch(typeof formatterParams.legend){
        case "string":
            legend = formatterParams.legend;
            break;
        case "function":
            legend = formatterParams.legend(value);
            break;
        case "boolean":
            legend = value;
            break;
        default:
            legend = false;
    }
    //set legend color
    switch(typeof formatterParams.legendColor){
        case "string":
            legendColor = formatterParams.legendColor;
            break;
        case "function":
            legendColor = formatterParams.legendColor(value);
            break;
        case "object":
            if (Array.isArray(formatterParams.legendColor)) {
                let unit = 100 / formatterParams.legendColor.length;
                let index = Math.floor(percentValue / unit);
                index = Math.min(index, formatterParams.legendColor.length - 1);
                index = Math.max(index, 0);
                legendColor = formatterParams.legendColor[index];
            }
            break;
        default:
            legendColor = "#000";
    }
    element.style.minWidth = "30px";
    element.style.position = "relative";
    element.setAttribute("aria-label", percentValue);
    var barEl = document.createElement("div");
    barEl.style.display = "inline-block";
    barEl.style.width = percentValue + "%";
    barEl.style.backgroundColor = color;
    barEl.style.height = "100%";
    barEl.setAttribute('data-max', max);
    barEl.setAttribute('data-min', min);
    var barContainer = document.createElement("div");
    barContainer.style.position = "relative";
    barContainer.style.width = "100%";
    barContainer.style.height = "100%";
    if (legend) {
        var legendEl = document.createElement("div");
        legendEl.style.position = "absolute";
        legendEl.style.top = 0;
        legendEl.style.left = 0;
        legendEl.style.textAlign = legendAlign;
        legendEl.style.width = "100%";
        legendEl.style.color = legendColor;
        legendEl.innerHTML = legend;
    }
    onRendered(function() {
        //handle custom element needed if formatter is to be included in printed/downloaded output
        if (!(cell instanceof $c2a9788f40f9c90a$export$1919f52c249c72c9)) {
            var holderEl = document.createElement("div");
            holderEl.style.position = "absolute";
            holderEl.style.top = "4px";
            holderEl.style.bottom = "4px";
            holderEl.style.left = "4px";
            holderEl.style.right = "4px";
            element.appendChild(holderEl);
            element = holderEl;
        }
        element.appendChild(barContainer);
        barContainer.appendChild(barEl);
        if (legend) barContainer.appendChild(legendEl);
    });
    return "";
}
function $c2a9788f40f9c90a$var$color(cell, formatterParams, onRendered) {
    cell.getElement().style.backgroundColor = this.sanitizeHTML(cell.getValue());
    return "";
}
function $c2a9788f40f9c90a$var$buttonTick(cell, formatterParams, onRendered) {
    return '<svg enable-background="new 0 0 24 24" height="14" width="14" viewBox="0 0 24 24" xml:space="preserve" ><path fill="#2DC214" clip-rule="evenodd" d="M21.652,3.211c-0.293-0.295-0.77-0.295-1.061,0L9.41,14.34  c-0.293,0.297-0.771,0.297-1.062,0L3.449,9.351C3.304,9.203,3.114,9.13,2.923,9.129C2.73,9.128,2.534,9.201,2.387,9.351  l-2.165,1.946C0.078,11.445,0,11.63,0,11.823c0,0.194,0.078,0.397,0.223,0.544l4.94,5.184c0.292,0.296,0.771,0.776,1.062,1.07  l2.124,2.141c0.292,0.293,0.769,0.293,1.062,0l14.366-14.34c0.293-0.294,0.293-0.777,0-1.071L21.652,3.211z" fill-rule="evenodd"/></svg>';
}
function $c2a9788f40f9c90a$var$buttonCross(cell, formatterParams, onRendered) {
    return '<svg enable-background="new 0 0 24 24" height="14" width="14" viewBox="0 0 24 24" xml:space="preserve" ><path fill="#CE1515" d="M22.245,4.015c0.313,0.313,0.313,0.826,0,1.139l-6.276,6.27c-0.313,0.312-0.313,0.826,0,1.14l6.273,6.272  c0.313,0.313,0.313,0.826,0,1.14l-2.285,2.277c-0.314,0.312-0.828,0.312-1.142,0l-6.271-6.271c-0.313-0.313-0.828-0.313-1.141,0  l-6.276,6.267c-0.313,0.313-0.828,0.313-1.141,0l-2.282-2.28c-0.313-0.313-0.313-0.826,0-1.14l6.278-6.269  c0.313-0.312,0.313-0.826,0-1.14L1.709,5.147c-0.314-0.313-0.314-0.827,0-1.14l2.284-2.278C4.308,1.417,4.821,1.417,5.135,1.73  L11.405,8c0.314,0.314,0.828,0.314,1.141,0.001l6.276-6.267c0.312-0.312,0.826-0.312,1.141,0L22.245,4.015z"/></svg>';
}
function $c2a9788f40f9c90a$var$toggle(cell, formatterParams, onRendered) {
    var value = cell.getValue(), size = formatterParams.size || 15, sizePx = size + "px", containEl, switchEl, onValue = formatterParams.hasOwnProperty("onValue") ? formatterParams.onValue : true, offValue = formatterParams.hasOwnProperty("offValue") ? formatterParams.offValue : false, state = formatterParams.onTruthy ? value : value === onValue;
    containEl = document.createElement("div");
    containEl.classList.add("tabulator-toggle");
    if (state) {
        containEl.classList.add("tabulator-toggle-on");
        containEl.style.flexDirection = "row-reverse";
        if (formatterParams.onColor) containEl.style.background = formatterParams.onColor;
    } else if (formatterParams.offColor) containEl.style.background = formatterParams.offColor;
    containEl.style.width = 2.5 * size + "px";
    containEl.style.borderRadius = sizePx;
    if (formatterParams.clickable) containEl.addEventListener("click", (e)=>{
        cell.setValue(state ? offValue : onValue);
    });
    switchEl = document.createElement("div");
    switchEl.classList.add("tabulator-toggle-switch");
    switchEl.style.height = sizePx;
    switchEl.style.width = sizePx;
    switchEl.style.borderRadius = sizePx;
    containEl.appendChild(switchEl);
    return containEl;
}
function $c2a9788f40f9c90a$var$rownum(cell, formatterParams, onRendered) {
    var content = document.createElement("span");
    var row = cell.getRow();
    var table = cell.getTable();
    row.watchPosition((position)=>{
        if (formatterParams.relativeToPage) position += table.modules.page.getPageSize() * (table.modules.page.getPage() - 1);
        content.innerText = position;
    });
    return content;
}
function $c2a9788f40f9c90a$var$handle(cell, formatterParams, onRendered) {
    cell.getElement().classList.add("tabulator-row-handle");
    return "<div class='tabulator-row-handle-box'><div class='tabulator-row-handle-bar'></div><div class='tabulator-row-handle-bar'></div><div class='tabulator-row-handle-bar'></div></div>";
}
function $c2a9788f40f9c90a$var$adaptable(cell, params, onRendered) {
    var lookup, formatterFunc, formatterParams;
    function defaultLookup(cell) {
        var value = cell.getValue(), formatter = "plaintext";
        switch(typeof value){
            case "boolean":
                formatter = "tickCross";
                break;
            case "string":
                if (value.includes("\n")) formatter = "textarea";
                break;
        }
        return formatter;
    }
    lookup = params.formatterLookup ? params.formatterLookup(cell) : defaultLookup(cell);
    if (params.paramsLookup) formatterParams = typeof params.paramsLookup === "function" ? params.paramsLookup(lookup, cell) : params.paramsLookup[lookup];
    formatterFunc = this.table.modules.format.lookupFormatter(lookup);
    return formatterFunc.call(this, cell, formatterParams || {}, onRendered);
}
function $c2a9788f40f9c90a$var$array$2(cell, formatterParams, onRendered) {
    var delimiter = formatterParams.delimiter || ",", value = cell.getValue(), table = this.table, valueMap;
    if (formatterParams.valueMap) {
        if (typeof formatterParams.valueMap === "string") valueMap = function(value) {
            return value.map((item)=>{
                return $c2a9788f40f9c90a$var$Helpers.retrieveNestedData(table.options.nestedFieldSeparator, formatterParams.valueMap, item);
            });
        };
        else valueMap = formatterParams.valueMap;
    }
    if (Array.isArray(value)) {
        if (valueMap) value = valueMap(value);
        return value.join(delimiter);
    } else return value;
}
function $c2a9788f40f9c90a$var$json$1(cell, formatterParams, onRendered) {
    var indent = formatterParams.indent || "\t", multiline = typeof formatterParams.multiline === "undefined" ? true : formatterParams.multiline, replacer = formatterParams.replacer || null, value = cell.getValue();
    if (multiline) cell.getElement().style.whiteSpace = "pre-wrap";
    return JSON.stringify(value, replacer, indent);
}
var $c2a9788f40f9c90a$var$defaultFormatters = {
    plaintext: $c2a9788f40f9c90a$var$plaintext,
    html: $c2a9788f40f9c90a$var$html,
    textarea: $c2a9788f40f9c90a$var$textarea,
    money: $c2a9788f40f9c90a$var$money,
    link: $c2a9788f40f9c90a$var$link,
    image: $c2a9788f40f9c90a$var$image,
    tickCross: $c2a9788f40f9c90a$var$tickCross,
    datetime: $c2a9788f40f9c90a$var$datetime$1,
    datetimediff: $c2a9788f40f9c90a$var$datetimediff,
    lookup: $c2a9788f40f9c90a$var$lookup,
    star: $c2a9788f40f9c90a$var$star,
    traffic: $c2a9788f40f9c90a$var$traffic,
    progress: $c2a9788f40f9c90a$var$progress,
    color: $c2a9788f40f9c90a$var$color,
    buttonTick: $c2a9788f40f9c90a$var$buttonTick,
    buttonCross: $c2a9788f40f9c90a$var$buttonCross,
    toggle: $c2a9788f40f9c90a$var$toggle,
    rownum: $c2a9788f40f9c90a$var$rownum,
    handle: $c2a9788f40f9c90a$var$handle,
    adaptable: $c2a9788f40f9c90a$var$adaptable,
    array: $c2a9788f40f9c90a$var$array$2,
    json: $c2a9788f40f9c90a$var$json$1
};
class $c2a9788f40f9c90a$export$5634f967e02d772d extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "format";
    //load defaults
    static formatters = $c2a9788f40f9c90a$var$defaultFormatters;
    constructor(table){
        super(table);
        this.registerColumnOption("formatter");
        this.registerColumnOption("formatterParams");
        this.registerColumnOption("formatterPrint");
        this.registerColumnOption("formatterPrintParams");
        this.registerColumnOption("formatterClipboard");
        this.registerColumnOption("formatterClipboardParams");
        this.registerColumnOption("formatterHtmlOutput");
        this.registerColumnOption("formatterHtmlOutputParams");
        this.registerColumnOption("titleFormatter");
        this.registerColumnOption("titleFormatterParams");
    }
    initialize() {
        this.subscribe("cell-format", this.formatValue.bind(this));
        this.subscribe("cell-rendered", this.cellRendered.bind(this));
        this.subscribe("column-layout", this.initializeColumn.bind(this));
        this.subscribe("column-format", this.formatHeader.bind(this));
    }
    //initialize column formatter
    initializeColumn(column) {
        column.modules.format = this.lookupTypeFormatter(column, "");
        if (typeof column.definition.formatterPrint !== "undefined") column.modules.format.print = this.lookupTypeFormatter(column, "Print");
        if (typeof column.definition.formatterClipboard !== "undefined") column.modules.format.clipboard = this.lookupTypeFormatter(column, "Clipboard");
        if (typeof column.definition.formatterHtmlOutput !== "undefined") column.modules.format.htmlOutput = this.lookupTypeFormatter(column, "HtmlOutput");
    }
    lookupTypeFormatter(column, type) {
        var config = {
            params: column.definition["formatter" + type + "Params"] || {}
        }, formatter = column.definition["formatter" + type];
        config.formatter = this.lookupFormatter(formatter);
        return config;
    }
    lookupFormatter(formatter) {
        var formatterFunc;
        //set column formatter
        switch(typeof formatter){
            case "string":
                if ($c2a9788f40f9c90a$export$5634f967e02d772d.formatters[formatter]) formatterFunc = $c2a9788f40f9c90a$export$5634f967e02d772d.formatters[formatter];
                else {
                    console.warn("Formatter Error - No such formatter found: ", formatter);
                    formatterFunc = $c2a9788f40f9c90a$export$5634f967e02d772d.formatters.plaintext;
                }
                break;
            case "function":
                formatterFunc = formatter;
                break;
            default:
                formatterFunc = $c2a9788f40f9c90a$export$5634f967e02d772d.formatters.plaintext;
                break;
        }
        return formatterFunc;
    }
    cellRendered(cell) {
        if (cell.modules.format && cell.modules.format.renderedCallback && !cell.modules.format.rendered) {
            cell.modules.format.renderedCallback();
            cell.modules.format.rendered = true;
        }
    }
    //return a formatted value for a column header
    formatHeader(column, title, el) {
        var formatter, params, onRendered, mockCell;
        if (column.definition.titleFormatter) {
            formatter = this.lookupFormatter(column.definition.titleFormatter);
            onRendered = (callback)=>{
                column.titleFormatterRendered = callback;
            };
            mockCell = {
                getValue: function() {
                    return title;
                },
                getElement: function() {
                    return el;
                },
                getType: function() {
                    return "header";
                },
                getColumn: function() {
                    return column.getComponent();
                },
                getTable: ()=>{
                    return this.table;
                }
            };
            params = column.definition.titleFormatterParams || {};
            params = typeof params === "function" ? params() : params;
            return formatter.call(this, mockCell, params, onRendered);
        } else return title;
    }
    //return a formatted value for a cell
    formatValue(cell) {
        var component = cell.getComponent(), params = typeof cell.column.modules.format.params === "function" ? cell.column.modules.format.params(component) : cell.column.modules.format.params;
        function onRendered(callback) {
            if (!cell.modules.format) cell.modules.format = {};
            cell.modules.format.renderedCallback = callback;
            cell.modules.format.rendered = false;
        }
        return cell.column.modules.format.formatter.call(this, component, params, onRendered);
    }
    formatExportValue(cell, type) {
        var formatter = cell.column.modules.format[type], params;
        if (formatter) {
            params = typeof formatter.params === "function" ? formatter.params(cell.getComponent()) : formatter.params;
            function onRendered(callback) {
                if (!cell.modules.format) cell.modules.format = {};
                cell.modules.format.renderedCallback = callback;
                cell.modules.format.rendered = false;
            }
            return formatter.formatter.call(this, cell.getComponent(), params, onRendered);
        } else return this.formatValue(cell);
    }
    sanitizeHTML(value) {
        if (value) {
            var entityMap = {
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                "'": '&#39;',
                '/': '&#x2F;',
                '`': '&#x60;',
                '=': '&#x3D;'
            };
            return String(value).replace(/[&<>"'`=/]/g, function(s) {
                return entityMap[s];
            });
        } else return value;
    }
    emptyToSpace(value) {
        return value === null || typeof value === "undefined" || value === "" ? "&nbsp;" : value;
    }
}
class $c2a9788f40f9c90a$export$c00c4e95a253fbf9 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "frozenColumns";
    constructor(table){
        super(table);
        this.leftColumns = [];
        this.rightColumns = [];
        this.initializationMode = "left";
        this.active = false;
        this.blocked = true;
        this.registerColumnOption("frozen");
    }
    //reset initial state
    reset() {
        this.initializationMode = "left";
        this.leftColumns = [];
        this.rightColumns = [];
        this.active = false;
    }
    initialize() {
        this.subscribe("cell-layout", this.layoutCell.bind(this));
        this.subscribe("column-init", this.initializeColumn.bind(this));
        this.subscribe("column-width", this.layout.bind(this));
        this.subscribe("row-layout-after", this.layoutRow.bind(this));
        this.subscribe("table-layout", this.layout.bind(this));
        this.subscribe("columns-loading", this.reset.bind(this));
        this.subscribe("column-add", this.reinitializeColumns.bind(this));
        this.subscribe("column-deleted", this.reinitializeColumns.bind(this));
        this.subscribe("column-hide", this.reinitializeColumns.bind(this));
        this.subscribe("column-show", this.reinitializeColumns.bind(this));
        this.subscribe("columns-loaded", this.reinitializeColumns.bind(this));
        this.subscribe("table-redraw", this.layout.bind(this));
        this.subscribe("layout-refreshing", this.blockLayout.bind(this));
        this.subscribe("layout-refreshed", this.unblockLayout.bind(this));
        this.subscribe("scrollbar-vertical", this.adjustForScrollbar.bind(this));
    }
    blockLayout() {
        this.blocked = true;
    }
    unblockLayout() {
        this.blocked = false;
    }
    layoutCell(cell) {
        this.layoutElement(cell.element, cell.column);
    }
    reinitializeColumns() {
        this.reset();
        this.table.columnManager.columnsByIndex.forEach((column)=>{
            this.initializeColumn(column);
        });
        this.layout();
    }
    //initialize specific column
    initializeColumn(column) {
        var config = {
            margin: 0,
            edge: false
        };
        if (!column.isGroup) {
            if (this.frozenCheck(column)) {
                config.position = this.initializationMode;
                if (this.initializationMode == "left") this.leftColumns.push(column);
                else this.rightColumns.unshift(column);
                this.active = true;
                column.modules.frozen = config;
            } else this.initializationMode = "right";
        }
    }
    frozenCheck(column) {
        if (column.parent.isGroup && column.definition.frozen) console.warn("Frozen Column Error - Parent column group must be frozen, not individual columns or sub column groups");
        if (column.parent.isGroup) return this.frozenCheck(column.parent);
        else return column.definition.frozen;
    }
    //layout calculation rows
    layoutCalcRows() {
        if (this.table.modExists("columnCalcs")) {
            if (this.table.modules.columnCalcs.topInitialized && this.table.modules.columnCalcs.topRow) this.layoutRow(this.table.modules.columnCalcs.topRow);
            if (this.table.modules.columnCalcs.botInitialized && this.table.modules.columnCalcs.botRow) this.layoutRow(this.table.modules.columnCalcs.botRow);
            if (this.table.modExists("groupRows")) this.layoutGroupCalcs(this.table.modules.groupRows.getGroups());
        }
    }
    layoutGroupCalcs(groups) {
        groups.forEach((group)=>{
            if (group.calcs.top) this.layoutRow(group.calcs.top);
            if (group.calcs.bottom) this.layoutRow(group.calcs.bottom);
            if (group.groupList && group.groupList.length) this.layoutGroupCalcs(group.groupList);
        });
    }
    //calculate column positions and layout headers
    layoutColumnPosition(allCells) {
        var leftParents = [];
        var leftMargin = 0;
        var rightMargin = 0;
        this.leftColumns.forEach((column, i)=>{
            column.modules.frozen.marginValue = leftMargin;
            column.modules.frozen.margin = column.modules.frozen.marginValue + "px";
            if (column.visible) leftMargin += column.getWidth();
            if (i == this.leftColumns.length - 1) column.modules.frozen.edge = true;
            else column.modules.frozen.edge = false;
            if (column.parent.isGroup) {
                var parentEl = this.getColGroupParentElement(column);
                if (!leftParents.includes(parentEl)) {
                    this.layoutElement(parentEl, column);
                    leftParents.push(parentEl);
                }
                parentEl.classList.toggle("tabulator-frozen-left", column.modules.frozen.edge && column.modules.frozen.position === "left");
                parentEl.classList.toggle("tabulator-frozen-right", column.modules.frozen.edge && column.modules.frozen.position === "right");
            } else this.layoutElement(column.getElement(), column);
            if (allCells) column.cells.forEach((cell)=>{
                this.layoutElement(cell.getElement(true), column);
            });
        });
        this.rightColumns.forEach((column, i)=>{
            column.modules.frozen.marginValue = rightMargin;
            column.modules.frozen.margin = column.modules.frozen.marginValue + "px";
            if (column.visible) rightMargin += column.getWidth();
            if (i == this.rightColumns.length - 1) column.modules.frozen.edge = true;
            else column.modules.frozen.edge = false;
            if (column.parent.isGroup) this.layoutElement(this.getColGroupParentElement(column), column);
            else this.layoutElement(column.getElement(), column);
            if (allCells) column.cells.forEach((cell)=>{
                this.layoutElement(cell.getElement(true), column);
            });
        });
    }
    getColGroupParentElement(column) {
        return column.parent.isGroup ? this.getColGroupParentElement(column.parent) : column.getElement();
    }
    //layout columns appropriately
    layout() {
        if (this.active && !this.blocked) {
            //calculate left columns
            this.layoutColumnPosition();
            this.reinitializeRows();
            this.layoutCalcRows();
        }
    }
    reinitializeRows() {
        var visibleRows = this.table.rowManager.getVisibleRows(true);
        var otherRows = this.table.rowManager.getRows().filter((row)=>!visibleRows.includes(row));
        otherRows.forEach((row)=>{
            row.deinitialize();
        });
        visibleRows.forEach((row)=>{
            if (row.type === "row") this.layoutRow(row);
        });
    }
    layoutRow(row) {
        if (this.table.options.layout === "fitDataFill" && this.rightColumns.length) this.table.rowManager.getTableElement().style.minWidth = "calc(100% - " + this.rightMargin + ")";
        this.leftColumns.forEach((column)=>{
            var cell = row.getCell(column);
            if (cell) this.layoutElement(cell.getElement(true), column);
        });
        this.rightColumns.forEach((column)=>{
            var cell = row.getCell(column);
            if (cell) this.layoutElement(cell.getElement(true), column);
        });
    }
    layoutElement(element, column) {
        var position;
        if (column.modules.frozen && element) {
            element.style.position = "sticky";
            if (this.table.rtl) position = column.modules.frozen.position === "left" ? "right" : "left";
            else position = column.modules.frozen.position;
            element.style[position] = column.modules.frozen.margin;
            element.classList.add("tabulator-frozen");
            element.classList.toggle("tabulator-frozen-left", column.modules.frozen.edge && column.modules.frozen.position === "left");
            element.classList.toggle("tabulator-frozen-right", column.modules.frozen.edge && column.modules.frozen.position === "right");
        }
    }
    adjustForScrollbar(width) {
        if (this.rightColumns.length) this.table.columnManager.getContentsElement().style.width = "calc(100% - " + width + "px)";
    }
    getFrozenColumns() {
        return this.leftColumns.concat(this.rightColumns);
    }
    _calcSpace(columns, index) {
        var width = 0;
        for(let i = 0; i < index; i++)if (columns[i].visible) width += columns[i].getWidth();
        return width;
    }
}
class $c2a9788f40f9c90a$export$6e51ce5331c5fffa extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "frozenRows";
    constructor(table){
        super(table);
        this.topElement = document.createElement("div");
        this.rows = [];
        //register component functions
        this.registerComponentFunction("row", "freeze", this.freezeRow.bind(this));
        this.registerComponentFunction("row", "unfreeze", this.unfreezeRow.bind(this));
        this.registerComponentFunction("row", "isFrozen", this.isRowFrozen.bind(this));
        //register table options
        this.registerTableOption("frozenRowsField", "id"); //field to choose frozen rows by
        this.registerTableOption("frozenRows", false); //holder for frozen row identifiers
    }
    initialize() {
        var fragment = document.createDocumentFragment();
        this.rows = [];
        this.topElement.classList.add("tabulator-frozen-rows-holder");
        fragment.appendChild(document.createElement("br"));
        fragment.appendChild(this.topElement);
        // this.table.columnManager.element.append(this.topElement);
        this.table.columnManager.getContentsElement().insertBefore(fragment, this.table.columnManager.headersElement.nextSibling);
        this.subscribe("row-deleting", this.detachRow.bind(this));
        this.subscribe("rows-visible", this.visibleRows.bind(this));
        this.registerDisplayHandler(this.getRows.bind(this), 10);
        if (this.table.options.frozenRows) {
            this.subscribe("data-processed", this.initializeRows.bind(this));
            this.subscribe("row-added", this.initializeRow.bind(this));
            this.subscribe("table-redrawing", this.resizeHolderWidth.bind(this));
            this.subscribe("column-resized", this.resizeHolderWidth.bind(this));
            this.subscribe("column-show", this.resizeHolderWidth.bind(this));
            this.subscribe("column-hide", this.resizeHolderWidth.bind(this));
        }
        this.resizeHolderWidth();
    }
    resizeHolderWidth() {
        this.topElement.style.minWidth = this.table.columnManager.headersElement.offsetWidth + "px";
    }
    initializeRows() {
        this.table.rowManager.getRows().forEach((row)=>{
            this.initializeRow(row);
        });
    }
    initializeRow(row) {
        var frozenRows = this.table.options.frozenRows, rowType = typeof frozenRows;
        if (rowType === "number") {
            if (row.getPosition() && row.getPosition() + this.rows.length <= frozenRows) this.freezeRow(row);
        } else if (rowType === "function") {
            if (frozenRows.call(this.table, row.getComponent())) this.freezeRow(row);
        } else if (Array.isArray(frozenRows)) {
            if (frozenRows.includes(row.data[this.options("frozenRowsField")])) this.freezeRow(row);
        }
    }
    isRowFrozen(row) {
        var index = this.rows.indexOf(row);
        return index > -1;
    }
    isFrozen() {
        return !!this.rows.length;
    }
    visibleRows(viewable, rows) {
        this.rows.forEach((row)=>{
            rows.push(row);
        });
        return rows;
    }
    //filter frozen rows out of display data
    getRows(rows) {
        var output = rows.slice(0);
        this.rows.forEach(function(row) {
            var index = output.indexOf(row);
            if (index > -1) output.splice(index, 1);
        });
        return output;
    }
    freezeRow(row) {
        if (!row.modules.frozen) {
            row.modules.frozen = true;
            this.topElement.appendChild(row.getElement());
            row.initialize();
            row.normalizeHeight();
            this.rows.push(row);
            this.refreshData(false, "display");
            this.table.rowManager.adjustTableSize();
            this.styleRows();
        } else console.warn("Freeze Error - Row is already frozen");
    }
    unfreezeRow(row) {
        if (row.modules.frozen) {
            row.modules.frozen = false;
            this.detachRow(row);
            this.table.rowManager.adjustTableSize();
            this.refreshData(false, "display");
            if (this.rows.length) this.styleRows();
        } else console.warn("Freeze Error - Row is already unfrozen");
    }
    detachRow(row) {
        var index = this.rows.indexOf(row);
        if (index > -1) {
            var rowEl = row.getElement();
            if (rowEl.parentNode) rowEl.parentNode.removeChild(rowEl);
            this.rows.splice(index, 1);
        }
    }
    styleRows(row) {
        this.rows.forEach((row, i)=>{
            this.table.rowManager.styleRow(row, i);
        });
    }
}
//public group object
class $c2a9788f40f9c90a$export$450247cd99a94b80 {
    constructor(group){
        this._group = group;
        this.type = "GroupComponent";
        return new Proxy(this, {
            get: function(target, name, receiver) {
                if (typeof target[name] !== "undefined") return target[name];
                else return target._group.groupManager.table.componentFunctionBinder.handle("group", target._group, name);
            }
        });
    }
    getKey() {
        return this._group.key;
    }
    getField() {
        return this._group.field;
    }
    getElement() {
        return this._group.element;
    }
    getRows() {
        return this._group.getRows(true);
    }
    getSubGroups() {
        return this._group.getSubGroups(true);
    }
    getParentGroup() {
        return this._group.parent ? this._group.parent.getComponent() : false;
    }
    isVisible() {
        return this._group.visible;
    }
    show() {
        this._group.show();
    }
    hide() {
        this._group.hide();
    }
    toggle() {
        this._group.toggleVisibility();
    }
    scrollTo(position, ifVisible) {
        return this._group.groupManager.table.rowManager.scrollToRow(this._group, position, ifVisible);
    }
    _getSelf() {
        return this._group;
    }
    getTable() {
        return this._group.groupManager.table;
    }
}
//Group functions
class $c2a9788f40f9c90a$var$Group {
    constructor(groupManager, parent, level, key, field, generator, oldGroup){
        this.groupManager = groupManager;
        this.parent = parent;
        this.key = key;
        this.level = level;
        this.field = field;
        this.hasSubGroups = level < groupManager.groupIDLookups.length - 1;
        this.addRow = this.hasSubGroups ? this._addRowToGroup : this._addRow;
        this.type = "group"; //type of element
        this.old = oldGroup;
        this.rows = [];
        this.groups = [];
        this.groupList = [];
        this.generator = generator;
        this.element = false;
        this.elementContents = false;
        this.height = 0;
        this.outerHeight = 0;
        this.initialized = false;
        this.calcs = {};
        this.initialized = false;
        this.modules = {};
        this.arrowElement = false;
        this.visible = oldGroup ? oldGroup.visible : typeof groupManager.startOpen[level] !== "undefined" ? groupManager.startOpen[level] : groupManager.startOpen[0];
        this.component = null;
        this.createElements();
        this.addBindings();
        this.createValueGroups();
    }
    wipe(elementsOnly) {
        if (!elementsOnly) {
            if (this.groupList.length) this.groupList.forEach(function(group) {
                group.wipe();
            });
            else this.rows.forEach((row)=>{
                if (row.modules) delete row.modules.group;
            });
        }
        this.element = false;
        this.arrowElement = false;
        this.elementContents = false;
    }
    createElements() {
        var arrow = document.createElement("div");
        arrow.classList.add("tabulator-arrow");
        this.element = document.createElement("div");
        this.element.classList.add("tabulator-row");
        this.element.classList.add("tabulator-group");
        this.element.classList.add("tabulator-group-level-" + this.level);
        this.element.setAttribute("role", "rowgroup");
        this.arrowElement = document.createElement("div");
        this.arrowElement.classList.add("tabulator-group-toggle");
        this.arrowElement.appendChild(arrow);
        //setup movable rows
        if (this.groupManager.table.options.movableRows !== false && this.groupManager.table.modExists("moveRow")) this.groupManager.table.modules.moveRow.initializeGroupHeader(this);
    }
    createValueGroups() {
        var level = this.level + 1;
        if (this.groupManager.allowedValues && this.groupManager.allowedValues[level]) this.groupManager.allowedValues[level].forEach((value)=>{
            this._createGroup(value, level);
        });
    }
    addBindings() {
        var toggleElement;
        if (this.groupManager.table.options.groupToggleElement) {
            toggleElement = this.groupManager.table.options.groupToggleElement == "arrow" ? this.arrowElement : this.element;
            toggleElement.addEventListener("click", (e)=>{
                if (this.groupManager.table.options.groupToggleElement === "arrow") {
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                }
                //allow click event to propagate before toggling visibility
                setTimeout(()=>{
                    this.toggleVisibility();
                });
            });
        }
    }
    _createGroup(groupID, level) {
        var groupKey = level + "_" + groupID;
        var group = new $c2a9788f40f9c90a$var$Group(this.groupManager, this, level, groupID, this.groupManager.groupIDLookups[level].field, this.groupManager.headerGenerator[level] || this.groupManager.headerGenerator[0], this.old ? this.old.groups[groupKey] : false);
        this.groups[groupKey] = group;
        this.groupList.push(group);
    }
    _addRowToGroup(row) {
        var level = this.level + 1;
        if (this.hasSubGroups) {
            var groupID = this.groupManager.groupIDLookups[level].func(row.getData()), groupKey = level + "_" + groupID;
            if (this.groupManager.allowedValues && this.groupManager.allowedValues[level]) {
                if (this.groups[groupKey]) this.groups[groupKey].addRow(row);
            } else {
                if (!this.groups[groupKey]) this._createGroup(groupID, level);
                this.groups[groupKey].addRow(row);
            }
        }
    }
    _addRow(row) {
        this.rows.push(row);
        row.modules.group = this;
    }
    insertRow(row, to, after) {
        var data = this.conformRowData({});
        row.updateData(data);
        var toIndex = this.rows.indexOf(to);
        if (toIndex > -1) {
            if (after) this.rows.splice(toIndex + 1, 0, row);
            else this.rows.splice(toIndex, 0, row);
        } else if (after) this.rows.push(row);
        else this.rows.unshift(row);
        row.modules.group = this;
        // this.generateGroupHeaderContents();
        if (this.groupManager.table.modExists("columnCalcs") && this.groupManager.table.options.columnCalcs != "table") this.groupManager.table.modules.columnCalcs.recalcGroup(this);
        this.groupManager.updateGroupRows(true);
    }
    scrollHeader(left) {
        if (this.arrowElement) {
            this.arrowElement.style.marginLeft = left;
            this.groupList.forEach(function(child) {
                child.scrollHeader(left);
            });
        }
    }
    getRowIndex(row) {}
    //update row data to match grouping constraints
    conformRowData(data) {
        if (this.field) data[this.field] = this.key;
        else console.warn("Data Conforming Error - Cannot conform row data to match new group as groupBy is a function");
        if (this.parent) data = this.parent.conformRowData(data);
        return data;
    }
    removeRow(row) {
        var index = this.rows.indexOf(row);
        var el = row.getElement();
        if (index > -1) this.rows.splice(index, 1);
        if (!this.groupManager.table.options.groupValues && !this.rows.length) {
            if (this.parent) this.parent.removeGroup(this);
            else this.groupManager.removeGroup(this);
            this.groupManager.updateGroupRows(true);
        } else {
            if (el.parentNode) el.parentNode.removeChild(el);
            if (!this.groupManager.blockRedraw) {
                this.generateGroupHeaderContents();
                if (this.groupManager.table.modExists("columnCalcs") && this.groupManager.table.options.columnCalcs != "table") this.groupManager.table.modules.columnCalcs.recalcGroup(this);
            }
        }
    }
    removeGroup(group) {
        var groupKey = group.level + "_" + group.key, index;
        if (this.groups[groupKey]) {
            delete this.groups[groupKey];
            index = this.groupList.indexOf(group);
            if (index > -1) this.groupList.splice(index, 1);
            if (!this.groupList.length) {
                if (this.parent) this.parent.removeGroup(this);
                else this.groupManager.removeGroup(this);
            }
        }
    }
    getHeadersAndRows() {
        var output = [];
        output.push(this);
        this._visSet();
        if (this.calcs.top) {
            this.calcs.top.detachElement();
            this.calcs.top.deleteCells();
        }
        if (this.calcs.bottom) {
            this.calcs.bottom.detachElement();
            this.calcs.bottom.deleteCells();
        }
        if (this.visible) {
            if (this.groupList.length) this.groupList.forEach(function(group) {
                output = output.concat(group.getHeadersAndRows());
            });
            else {
                if (this.groupManager.table.options.columnCalcs != "table" && this.groupManager.table.modExists("columnCalcs") && this.groupManager.table.modules.columnCalcs.hasTopCalcs()) {
                    this.calcs.top = this.groupManager.table.modules.columnCalcs.generateTopRow(this.rows);
                    output.push(this.calcs.top);
                }
                output = output.concat(this.rows);
                if (this.groupManager.table.options.columnCalcs != "table" && this.groupManager.table.modExists("columnCalcs") && this.groupManager.table.modules.columnCalcs.hasBottomCalcs()) {
                    this.calcs.bottom = this.groupManager.table.modules.columnCalcs.generateBottomRow(this.rows);
                    output.push(this.calcs.bottom);
                }
            }
        } else {
            if (!this.groupList.length && this.groupManager.table.options.columnCalcs != "table") {
                if (this.groupManager.table.modExists("columnCalcs")) {
                    if (this.groupManager.table.modules.columnCalcs.hasTopCalcs()) {
                        if (this.groupManager.table.options.groupClosedShowCalcs) {
                            this.calcs.top = this.groupManager.table.modules.columnCalcs.generateTopRow(this.rows);
                            output.push(this.calcs.top);
                        }
                    }
                    if (this.groupManager.table.modules.columnCalcs.hasBottomCalcs()) {
                        if (this.groupManager.table.options.groupClosedShowCalcs) {
                            this.calcs.bottom = this.groupManager.table.modules.columnCalcs.generateBottomRow(this.rows);
                            output.push(this.calcs.bottom);
                        }
                    }
                }
            }
        }
        return output;
    }
    getData(visible, transform) {
        var output = [];
        this._visSet();
        if (!visible || visible && this.visible) this.rows.forEach((row)=>{
            output.push(row.getData(transform || "data"));
        });
        return output;
    }
    getRowCount() {
        var count = 0;
        if (this.groupList.length) this.groupList.forEach((group)=>{
            count += group.getRowCount();
        });
        else count = this.rows.length;
        return count;
    }
    toggleVisibility() {
        if (this.visible) this.hide();
        else this.show();
    }
    hide() {
        this.visible = false;
        if (this.groupManager.table.rowManager.getRenderMode() == "basic" && !this.groupManager.table.options.pagination) {
            this.element.classList.remove("tabulator-group-visible");
            if (this.groupList.length) this.groupList.forEach((group)=>{
                var rows = group.getHeadersAndRows();
                rows.forEach((row)=>{
                    row.detachElement();
                });
            });
            else this.rows.forEach((row)=>{
                var rowEl = row.getElement();
                rowEl.parentNode.removeChild(rowEl);
            });
            this.groupManager.updateGroupRows(true);
        } else this.groupManager.updateGroupRows(true);
        this.groupManager.table.externalEvents.dispatch("groupVisibilityChanged", this.getComponent(), false);
    }
    show() {
        this.visible = true;
        if (this.groupManager.table.rowManager.getRenderMode() == "basic" && !this.groupManager.table.options.pagination) {
            this.element.classList.add("tabulator-group-visible");
            var prev = this.generateElement();
            if (this.groupList.length) this.groupList.forEach((group)=>{
                var rows = group.getHeadersAndRows();
                rows.forEach((row)=>{
                    var rowEl = row.getElement();
                    prev.parentNode.insertBefore(rowEl, prev.nextSibling);
                    row.initialize();
                    prev = rowEl;
                });
            });
            else this.rows.forEach((row)=>{
                var rowEl = row.getElement();
                prev.parentNode.insertBefore(rowEl, prev.nextSibling);
                row.initialize();
                prev = rowEl;
            });
            this.groupManager.updateGroupRows(true);
        } else this.groupManager.updateGroupRows(true);
        this.groupManager.table.externalEvents.dispatch("groupVisibilityChanged", this.getComponent(), true);
    }
    _visSet() {
        var data = [];
        if (typeof this.visible == "function") {
            this.rows.forEach(function(row) {
                data.push(row.getData());
            });
            this.visible = this.visible(this.key, this.getRowCount(), data, this.getComponent());
        }
    }
    getRowGroup(row) {
        var match = false;
        if (this.groupList.length) this.groupList.forEach(function(group) {
            var result = group.getRowGroup(row);
            if (result) match = result;
        });
        else if (this.rows.find(function(item) {
            return item === row;
        })) match = this;
        return match;
    }
    getSubGroups(component) {
        var output = [];
        this.groupList.forEach(function(child) {
            output.push(component ? child.getComponent() : child);
        });
        return output;
    }
    getRows(component, includeChildren) {
        var output = [];
        if (includeChildren && this.groupList.length) this.groupList.forEach((group)=>{
            output = output.concat(group.getRows(component, includeChildren));
        });
        else this.rows.forEach(function(row) {
            output.push(component ? row.getComponent() : row);
        });
        return output;
    }
    generateGroupHeaderContents() {
        var data = [];
        var rows = this.getRows(false, true);
        rows.forEach(function(row) {
            data.push(row.getData());
        });
        this.elementContents = this.generator(this.key, this.getRowCount(), data, this.getComponent());
        while(this.element.firstChild)this.element.removeChild(this.element.firstChild);
        if (typeof this.elementContents === "string") this.element.innerHTML = this.elementContents;
        else this.element.appendChild(this.elementContents);
        this.element.insertBefore(this.arrowElement, this.element.firstChild);
    }
    getPath(path = []) {
        path.unshift(this.key);
        if (this.parent) this.parent.getPath(path);
        return path;
    }
    ////////////// Standard Row Functions //////////////
    getElement() {
        return this.elementContents ? this.element : this.generateElement();
    }
    generateElement() {
        this.addBindings = false;
        this._visSet();
        if (this.visible) this.element.classList.add("tabulator-group-visible");
        else this.element.classList.remove("tabulator-group-visible");
        for(var i = 0; i < this.element.childNodes.length; ++i)this.element.childNodes[i].parentNode.removeChild(this.element.childNodes[i]);
        this.generateGroupHeaderContents();
        // this.addBindings();
        return this.element;
    }
    detachElement() {
        if (this.element && this.element.parentNode) this.element.parentNode.removeChild(this.element);
    }
    //normalize the height of elements in the row
    normalizeHeight() {
        this.setHeight(this.element.clientHeight);
    }
    initialize(force) {
        if (!this.initialized || force) {
            this.normalizeHeight();
            this.initialized = true;
        }
    }
    reinitialize() {
        this.initialized = false;
        this.height = 0;
        if ($c2a9788f40f9c90a$var$Helpers.elVisible(this.element)) this.initialize(true);
    }
    setHeight(height) {
        if (this.height != height) {
            this.height = height;
            this.outerHeight = this.element.offsetHeight;
        }
    }
    //return rows outer height
    getHeight() {
        return this.outerHeight;
    }
    getGroup() {
        return this;
    }
    reinitializeHeight() {}
    calcHeight() {}
    setCellHeight() {}
    clearCellHeight() {}
    deinitializeHeight() {}
    rendered() {}
    //////////////// Object Generation /////////////////
    getComponent() {
        if (!this.component) this.component = new $c2a9788f40f9c90a$export$450247cd99a94b80(this);
        return this.component;
    }
}
class $c2a9788f40f9c90a$export$41e6b6ec902cbe0a extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "groupRows";
    constructor(table){
        super(table);
        this.groupIDLookups = false; //enable table grouping and set field to group by
        this.startOpen = [
            function() {
                return false;
            }
        ]; //starting state of group
        this.headerGenerator = [
            function() {
                return "";
            }
        ];
        this.groupList = []; //ordered list of groups
        this.allowedValues = false;
        this.groups = {}; //hold row groups
        this.displayHandler = this.getRows.bind(this);
        this.blockRedraw = false;
        //register table options
        this.registerTableOption("groupBy", false); //enable table grouping and set field to group by
        this.registerTableOption("groupStartOpen", true); //starting state of group
        this.registerTableOption("groupValues", false);
        this.registerTableOption("groupUpdateOnCellEdit", false);
        this.registerTableOption("groupHeader", false); //header generation function
        this.registerTableOption("groupHeaderPrint", null);
        this.registerTableOption("groupHeaderClipboard", null);
        this.registerTableOption("groupHeaderHtmlOutput", null);
        this.registerTableOption("groupHeaderDownload", null);
        this.registerTableOption("groupToggleElement", "arrow");
        this.registerTableOption("groupClosedShowCalcs", false);
        //register table functions
        this.registerTableFunction("setGroupBy", this.setGroupBy.bind(this));
        this.registerTableFunction("setGroupValues", this.setGroupValues.bind(this));
        this.registerTableFunction("setGroupStartOpen", this.setGroupStartOpen.bind(this));
        this.registerTableFunction("setGroupHeader", this.setGroupHeader.bind(this));
        this.registerTableFunction("getGroups", this.userGetGroups.bind(this));
        this.registerTableFunction("getGroupedData", this.userGetGroupedData.bind(this));
        //register component functions
        this.registerComponentFunction("row", "getGroup", this.rowGetGroup.bind(this));
    }
    //initialize group configuration
    initialize() {
        this.subscribe("table-destroy", this._blockRedrawing.bind(this));
        this.subscribe("rows-wipe", this._blockRedrawing.bind(this));
        this.subscribe("rows-wiped", this._restore_redrawing.bind(this));
        if (this.table.options.groupBy) {
            if (this.table.options.groupUpdateOnCellEdit) {
                this.subscribe("cell-value-updated", this.cellUpdated.bind(this));
                this.subscribe("row-data-changed", this.reassignRowToGroup.bind(this), 0);
            }
            this.subscribe("table-built", this.configureGroupSetup.bind(this));
            this.subscribe("row-deleting", this.rowDeleting.bind(this));
            this.subscribe("row-deleted", this.rowsUpdated.bind(this));
            this.subscribe("scroll-horizontal", this.scrollHeaders.bind(this));
            this.subscribe("rows-wipe", this.wipe.bind(this));
            this.subscribe("rows-added", this.rowsUpdated.bind(this));
            this.subscribe("row-moving", this.rowMoving.bind(this));
            this.subscribe("row-adding-index", this.rowAddingIndex.bind(this));
            this.subscribe("rows-sample", this.rowSample.bind(this));
            this.subscribe("render-virtual-fill", this.virtualRenderFill.bind(this));
            this.registerDisplayHandler(this.displayHandler, 20);
            this.initialized = true;
        }
    }
    _blockRedrawing() {
        this.blockRedraw = true;
    }
    _restore_redrawing() {
        this.blockRedraw = false;
    }
    configureGroupSetup() {
        if (this.table.options.groupBy) {
            var groupBy = this.table.options.groupBy, startOpen = this.table.options.groupStartOpen, groupHeader = this.table.options.groupHeader;
            this.allowedValues = this.table.options.groupValues;
            if (Array.isArray(groupBy) && Array.isArray(groupHeader) && groupBy.length > groupHeader.length) console.warn("Error creating group headers, groupHeader array is shorter than groupBy array");
            this.headerGenerator = [
                function() {
                    return "";
                }
            ];
            this.startOpen = [
                function() {
                    return false;
                }
            ]; //starting state of group
            this.langBind("groups|item", (langValue, lang)=>{
                this.headerGenerator[0] = (value, count, data)=>{
                    return (typeof value === "undefined" ? "" : value) + "<span>(" + count + " " + (count === 1 ? langValue : lang.groups.items) + ")</span>";
                };
            });
            this.groupIDLookups = [];
            if (groupBy) {
                if (this.table.modExists("columnCalcs") && this.table.options.columnCalcs != "table" && this.table.options.columnCalcs != "both") this.table.modules.columnCalcs.removeCalcs();
            } else if (this.table.modExists("columnCalcs") && this.table.options.columnCalcs != "group") {
                var cols = this.table.columnManager.getRealColumns();
                cols.forEach((col)=>{
                    if (col.definition.topCalc) this.table.modules.columnCalcs.initializeTopRow();
                    if (col.definition.bottomCalc) this.table.modules.columnCalcs.initializeBottomRow();
                });
            }
            if (!Array.isArray(groupBy)) groupBy = [
                groupBy
            ];
            groupBy.forEach((group, i)=>{
                var lookupFunc, column;
                if (typeof group == "function") lookupFunc = group;
                else {
                    column = this.table.columnManager.getColumnByField(group);
                    if (column) lookupFunc = function(data) {
                        return column.getFieldValue(data);
                    };
                    else lookupFunc = function(data) {
                        return data[group];
                    };
                }
                this.groupIDLookups.push({
                    field: typeof group === "function" ? false : group,
                    func: lookupFunc,
                    values: this.allowedValues ? this.allowedValues[i] : false
                });
            });
            if (startOpen) {
                if (!Array.isArray(startOpen)) startOpen = [
                    startOpen
                ];
                startOpen.forEach((level)=>{});
                this.startOpen = startOpen;
            }
            if (groupHeader) this.headerGenerator = Array.isArray(groupHeader) ? groupHeader : [
                groupHeader
            ];
        } else {
            this.groupList = [];
            this.groups = {};
        }
    }
    rowSample(rows, prevValue) {
        if (this.table.options.groupBy) {
            var group = this.getGroups(false)[0];
            prevValue.push(group.getRows(false)[0]);
        }
        return prevValue;
    }
    virtualRenderFill() {
        var el = this.table.rowManager.tableElement;
        var rows = this.table.rowManager.getVisibleRows();
        if (this.table.options.groupBy) {
            rows = rows.filter((row)=>{
                return row.type !== "group";
            });
            el.style.minWidth = !rows.length ? this.table.columnManager.getWidth() + "px" : "";
        } else return rows;
    }
    rowAddingIndex(row, index, top) {
        if (this.table.options.groupBy) {
            this.assignRowToGroup(row);
            var groupRows = row.modules.group.rows;
            if (groupRows.length > 1) {
                if (!index || index && groupRows.indexOf(index) == -1) {
                    if (top) {
                        if (groupRows[0] !== row) {
                            index = groupRows[0];
                            this.table.rowManager.moveRowInArray(row.modules.group.rows, row, index, !top);
                        }
                    } else if (groupRows[groupRows.length - 1] !== row) {
                        index = groupRows[groupRows.length - 1];
                        this.table.rowManager.moveRowInArray(row.modules.group.rows, row, index, !top);
                    }
                } else this.table.rowManager.moveRowInArray(row.modules.group.rows, row, index, !top);
            }
            return index;
        }
    }
    trackChanges() {
        this.dispatch("group-changed");
    }
    ///////////////////////////////////
    ///////// Table Functions /////////
    ///////////////////////////////////
    setGroupBy(groups) {
        this.table.options.groupBy = groups;
        if (!this.initialized) this.initialize();
        this.configureGroupSetup();
        if (!groups && this.table.modExists("columnCalcs") && this.table.options.columnCalcs === true) this.table.modules.columnCalcs.reinitializeCalcs();
        this.refreshData();
        this.trackChanges();
    }
    setGroupValues(groupValues) {
        this.table.options.groupValues = groupValues;
        this.configureGroupSetup();
        this.refreshData();
        this.trackChanges();
    }
    setGroupStartOpen(values) {
        this.table.options.groupStartOpen = values;
        this.configureGroupSetup();
        if (this.table.options.groupBy) {
            this.refreshData();
            this.trackChanges();
        } else console.warn("Grouping Update - cant refresh view, no groups have been set");
    }
    setGroupHeader(values) {
        this.table.options.groupHeader = values;
        this.configureGroupSetup();
        if (this.table.options.groupBy) {
            this.refreshData();
            this.trackChanges();
        } else console.warn("Grouping Update - cant refresh view, no groups have been set");
    }
    userGetGroups(values) {
        return this.getGroups(true);
    }
    // get grouped table data in the same format as getData()
    userGetGroupedData() {
        return this.table.options.groupBy ? this.getGroupedData() : this.getData();
    }
    ///////////////////////////////////////
    ///////// Component Functions /////////
    ///////////////////////////////////////
    rowGetGroup(row) {
        return row.modules.group ? row.modules.group.getComponent() : false;
    }
    ///////////////////////////////////
    ///////// Internal Logic //////////
    ///////////////////////////////////
    rowMoving(from, to, after) {
        if (this.table.options.groupBy) {
            if (!after && to instanceof $c2a9788f40f9c90a$var$Group) to = this.table.rowManager.prevDisplayRow(from) || to;
            var toGroup = to instanceof $c2a9788f40f9c90a$var$Group ? to : to.modules.group;
            var fromGroup = from instanceof $c2a9788f40f9c90a$var$Group ? from : from.modules.group;
            if (toGroup === fromGroup) this.table.rowManager.moveRowInArray(toGroup.rows, from, to, after);
            else {
                if (fromGroup) fromGroup.removeRow(from);
                toGroup.insertRow(from, to, after);
            }
        }
    }
    rowDeleting(row) {
        //remove from group
        if (this.table.options.groupBy && row.modules.group) row.modules.group.removeRow(row);
    }
    rowsUpdated(row) {
        if (this.table.options.groupBy) this.updateGroupRows(true);
    }
    cellUpdated(cell) {
        if (this.table.options.groupBy) this.reassignRowToGroup(cell.row);
    }
    //return appropriate rows with group headers
    getRows(rows) {
        if (this.table.options.groupBy && this.groupIDLookups.length) {
            this.dispatchExternal("dataGrouping");
            this.generateGroups(rows);
            if (this.subscribedExternal("dataGrouped")) this.dispatchExternal("dataGrouped", this.getGroups(true));
            return this.updateGroupRows();
        } else return rows.slice(0);
    }
    getGroups(component) {
        var groupComponents = [];
        this.groupList.forEach(function(group) {
            groupComponents.push(component ? group.getComponent() : group);
        });
        return groupComponents;
    }
    getChildGroups(group) {
        var groupComponents = [];
        if (!group) group = this;
        group.groupList.forEach((child)=>{
            if (child.groupList.length) groupComponents = groupComponents.concat(this.getChildGroups(child));
            else groupComponents.push(child);
        });
        return groupComponents;
    }
    wipe() {
        if (this.table.options.groupBy) {
            this.groupList.forEach(function(group) {
                group.wipe();
            });
            this.groupList = [];
            this.groups = {};
        }
    }
    pullGroupListData(groupList) {
        var groupListData = [];
        groupList.forEach((group)=>{
            var groupHeader = {};
            groupHeader.level = 0;
            groupHeader.rowCount = 0;
            groupHeader.headerContent = "";
            var childData = [];
            if (group.hasSubGroups) {
                childData = this.pullGroupListData(group.groupList);
                groupHeader.level = group.level;
                groupHeader.rowCount = childData.length - group.groupList.length; // data length minus number of sub-headers
                groupHeader.headerContent = group.generator(group.key, groupHeader.rowCount, group.rows, group);
                groupListData.push(groupHeader);
                groupListData = groupListData.concat(childData);
            } else {
                groupHeader.level = group.level;
                groupHeader.headerContent = group.generator(group.key, group.rows.length, group.rows, group);
                groupHeader.rowCount = group.getRows().length;
                groupListData.push(groupHeader);
                group.getRows().forEach((row)=>{
                    groupListData.push(row.getData("data"));
                });
            }
        });
        return groupListData;
    }
    getGroupedData() {
        return this.pullGroupListData(this.groupList);
    }
    getRowGroup(row) {
        var match = false;
        if (this.options("dataTree")) row = this.table.modules.dataTree.getTreeParentRoot(row);
        this.groupList.forEach((group)=>{
            var result = group.getRowGroup(row);
            if (result) match = result;
        });
        return match;
    }
    countGroups() {
        return this.groupList.length;
    }
    generateGroups(rows) {
        var oldGroups = this.groups;
        this.groups = {};
        this.groupList = [];
        if (this.allowedValues && this.allowedValues[0]) {
            this.allowedValues[0].forEach((value)=>{
                this.createGroup(value, 0, oldGroups);
            });
            rows.forEach((row)=>{
                this.assignRowToExistingGroup(row, oldGroups);
            });
        } else rows.forEach((row)=>{
            this.assignRowToGroup(row, oldGroups);
        });
        Object.values(oldGroups).forEach((group)=>{
            group.wipe(true);
        });
    }
    createGroup(groupID, level, oldGroups) {
        var groupKey = level + "_" + groupID, group;
        oldGroups = oldGroups || [];
        group = new $c2a9788f40f9c90a$var$Group(this, false, level, groupID, this.groupIDLookups[0].field, this.headerGenerator[0], oldGroups[groupKey]);
        this.groups[groupKey] = group;
        this.groupList.push(group);
    }
    assignRowToExistingGroup(row, oldGroups) {
        var groupID = this.groupIDLookups[0].func(row.getData()), groupKey = "0_" + groupID;
        if (this.groups[groupKey]) this.groups[groupKey].addRow(row);
    }
    assignRowToGroup(row, oldGroups) {
        var groupID = this.groupIDLookups[0].func(row.getData()), newGroupNeeded = !this.groups["0_" + groupID];
        if (newGroupNeeded) this.createGroup(groupID, 0, oldGroups);
        this.groups["0_" + groupID].addRow(row);
        return !newGroupNeeded;
    }
    reassignRowToGroup(row) {
        if (row.type === "row") {
            var oldRowGroup = row.modules.group, oldGroupPath = oldRowGroup.getPath(), newGroupPath = this.getExpectedPath(row), samePath;
            // figure out if new group path is the same as old group path
            samePath = oldGroupPath.length == newGroupPath.length && oldGroupPath.every((element, index)=>{
                return element === newGroupPath[index];
            });
            // refresh if they new path and old path aren't the same (aka the row's groupings have changed)
            if (!samePath) {
                oldRowGroup.removeRow(row);
                this.assignRowToGroup(row, this.groups);
                this.refreshData(true);
            }
        }
    }
    getExpectedPath(row) {
        var groupPath = [], rowData = row.getData();
        this.groupIDLookups.forEach((groupId)=>{
            groupPath.push(groupId.func(rowData));
        });
        return groupPath;
    }
    updateGroupRows(force) {
        var output = [];
        if (!this.blockRedraw) {
            this.groupList.forEach((group)=>{
                output = output.concat(group.getHeadersAndRows());
            });
            if (force) this.refreshData(true);
        }
        return output;
    }
    scrollHeaders(left) {
        if (this.table.options.groupBy) {
            if (this.table.options.renderHorizontal === "virtual") left -= this.table.columnManager.renderer.vDomPadLeft;
            left = left + "px";
            this.groupList.forEach((group)=>{
                group.scrollHeader(left);
            });
        }
    }
    removeGroup(group) {
        var groupKey = group.level + "_" + group.key, index;
        if (this.groups[groupKey]) {
            delete this.groups[groupKey];
            index = this.groupList.indexOf(group);
            if (index > -1) this.groupList.splice(index, 1);
        }
    }
    checkBasicModeGroupHeaderWidth() {
        var element = this.table.rowManager.tableElement, onlyGroupHeaders = true;
        this.table.rowManager.getDisplayRows().forEach((row, index)=>{
            this.table.rowManager.styleRow(row, index);
            element.appendChild(row.getElement());
            row.initialize(true);
            if (row.type !== "group") onlyGroupHeaders = false;
        });
        if (onlyGroupHeaders) element.style.minWidth = this.table.columnManager.getWidth() + "px";
        else element.style.minWidth = "";
    }
}
var $c2a9788f40f9c90a$var$defaultUndoers = {
    cellEdit: function(action) {
        action.component.setValueProcessData(action.data.oldValue);
        action.component.cellRendered();
    },
    rowAdd: function(action) {
        action.component.deleteActual();
        this.table.rowManager.checkPlaceholder();
    },
    rowDelete: function(action) {
        var newRow = this.table.rowManager.addRowActual(action.data.data, action.data.pos, action.data.index);
        if (this.table.options.groupBy && this.table.modExists("groupRows")) this.table.modules.groupRows.updateGroupRows(true);
        this._rebindRow(action.component, newRow);
        this.table.rowManager.checkPlaceholder();
    },
    rowMove: function(action) {
        var after = action.data.posFrom - action.data.posTo > 0;
        this.table.rowManager.moveRowActual(action.component, this.table.rowManager.getRowFromPosition(action.data.posFrom), after);
        this.table.rowManager.regenerateRowPositions();
        this.table.rowManager.reRenderInPosition();
    }
};
var $c2a9788f40f9c90a$var$defaultRedoers = {
    cellEdit: function(action) {
        action.component.setValueProcessData(action.data.newValue);
        action.component.cellRendered();
    },
    rowAdd: function(action) {
        var newRow = this.table.rowManager.addRowActual(action.data.data, action.data.pos, action.data.index);
        if (this.table.options.groupBy && this.table.modExists("groupRows")) this.table.modules.groupRows.updateGroupRows(true);
        this._rebindRow(action.component, newRow);
        this.table.rowManager.checkPlaceholder();
    },
    rowDelete: function(action) {
        action.component.deleteActual();
        this.table.rowManager.checkPlaceholder();
    },
    rowMove: function(action) {
        this.table.rowManager.moveRowActual(action.component, this.table.rowManager.getRowFromPosition(action.data.posTo), action.data.after);
        this.table.rowManager.regenerateRowPositions();
        this.table.rowManager.reRenderInPosition();
    }
};
var $c2a9788f40f9c90a$var$bindings$1 = {
    undo: [
        "ctrl + 90",
        "meta + 90"
    ],
    redo: [
        "ctrl + 89",
        "meta + 89"
    ]
};
var $c2a9788f40f9c90a$var$actions$1 = {
    undo: function(e) {
        var cell = false;
        if (this.table.options.history && this.table.modExists("history") && this.table.modExists("edit")) {
            cell = this.table.modules.edit.currentCell;
            if (!cell) {
                e.preventDefault();
                this.table.modules.history.undo();
            }
        }
    },
    redo: function(e) {
        var cell = false;
        if (this.table.options.history && this.table.modExists("history") && this.table.modExists("edit")) {
            cell = this.table.modules.edit.currentCell;
            if (!cell) {
                e.preventDefault();
                this.table.modules.history.redo();
            }
        }
    }
};
var $c2a9788f40f9c90a$var$extensions$3 = {
    keybindings: {
        bindings: $c2a9788f40f9c90a$var$bindings$1,
        actions: $c2a9788f40f9c90a$var$actions$1
    }
};
class $c2a9788f40f9c90a$export$173658fc60691186 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "history";
    static moduleExtensions = $c2a9788f40f9c90a$var$extensions$3;
    //load defaults
    static undoers = $c2a9788f40f9c90a$var$defaultUndoers;
    static redoers = $c2a9788f40f9c90a$var$defaultRedoers;
    constructor(table){
        super(table);
        this.history = [];
        this.index = -1;
        this.registerTableOption("history", false); //enable edit history
    }
    initialize() {
        if (this.table.options.history) {
            this.subscribe("cell-value-updated", this.cellUpdated.bind(this));
            this.subscribe("cell-delete", this.clearComponentHistory.bind(this));
            this.subscribe("row-delete", this.rowDeleted.bind(this));
            this.subscribe("rows-wipe", this.clear.bind(this));
            this.subscribe("row-added", this.rowAdded.bind(this));
            this.subscribe("row-move", this.rowMoved.bind(this));
        }
        this.registerTableFunction("undo", this.undo.bind(this));
        this.registerTableFunction("redo", this.redo.bind(this));
        this.registerTableFunction("getHistoryUndoSize", this.getHistoryUndoSize.bind(this));
        this.registerTableFunction("getHistoryRedoSize", this.getHistoryRedoSize.bind(this));
        this.registerTableFunction("clearHistory", this.clear.bind(this));
    }
    rowMoved(from, to, after) {
        this.action("rowMove", from, {
            posFrom: from.getPosition(),
            posTo: to.getPosition(),
            to: to,
            after: after
        });
    }
    rowAdded(row, data, pos, index) {
        this.action("rowAdd", row, {
            data: data,
            pos: pos,
            index: index
        });
    }
    rowDeleted(row) {
        var index, rows;
        if (this.table.options.groupBy) {
            rows = row.getComponent().getGroup()._getSelf().rows;
            index = rows.indexOf(row);
            if (index) index = rows[index - 1];
        } else {
            index = row.table.rowManager.getRowIndex(row);
            if (index) index = row.table.rowManager.rows[index - 1];
        }
        this.action("rowDelete", row, {
            data: row.getData(),
            pos: !index,
            index: index
        });
    }
    cellUpdated(cell) {
        this.action("cellEdit", cell, {
            oldValue: cell.oldValue,
            newValue: cell.value
        });
    }
    clear() {
        this.history = [];
        this.index = -1;
    }
    action(type, component, data) {
        this.history = this.history.slice(0, this.index + 1);
        this.history.push({
            type: type,
            component: component,
            data: data
        });
        this.index++;
    }
    getHistoryUndoSize() {
        return this.index + 1;
    }
    getHistoryRedoSize() {
        return this.history.length - (this.index + 1);
    }
    clearComponentHistory(component) {
        var index = this.history.findIndex(function(item) {
            return item.component === component;
        });
        if (index > -1) {
            this.history.splice(index, 1);
            if (index <= this.index) this.index--;
            this.clearComponentHistory(component);
        }
    }
    undo() {
        if (this.index > -1) {
            let action = this.history[this.index];
            $c2a9788f40f9c90a$export$173658fc60691186.undoers[action.type].call(this, action);
            this.index--;
            this.dispatchExternal("historyUndo", action.type, action.component.getComponent(), action.data);
            return true;
        } else {
            console.warn(this.options("history") ? "History Undo Error - No more history to undo" : "History module not enabled");
            return false;
        }
    }
    redo() {
        if (this.history.length - 1 > this.index) {
            this.index++;
            let action = this.history[this.index];
            $c2a9788f40f9c90a$export$173658fc60691186.redoers[action.type].call(this, action);
            this.dispatchExternal("historyRedo", action.type, action.component.getComponent(), action.data);
            return true;
        } else {
            console.warn(this.options("history") ? "History Redo Error - No more history to redo" : "History module not enabled");
            return false;
        }
    }
    //rebind rows to new element after deletion
    _rebindRow(oldRow, newRow) {
        this.history.forEach(function(action) {
            if (action.component instanceof $c2a9788f40f9c90a$var$Row) {
                if (action.component === oldRow) action.component = newRow;
            } else if (action.component instanceof $c2a9788f40f9c90a$var$Cell) {
                if (action.component.row === oldRow) {
                    var field = action.component.column.getField();
                    if (field) action.component = newRow.getCell(field);
                }
            }
        });
    }
}
class $c2a9788f40f9c90a$export$b0b448c470bac827 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "htmlTableImport";
    constructor(table){
        super(table);
        this.fieldIndex = [];
        this.hasIndex = false;
    }
    initialize() {
        this.tableElementCheck();
    }
    tableElementCheck() {
        if (this.table.originalElement && this.table.originalElement.tagName === "TABLE") {
            if (this.table.originalElement.childNodes.length) this.parseTable();
            else console.warn("Unable to parse data from empty table tag, Tabulator should be initialized on a div tag unless importing data from a table element.");
        }
    }
    parseTable() {
        var element = this.table.originalElement, options = this.table.options, headers = element.getElementsByTagName("th"), rows = element.getElementsByTagName("tbody")[0], data = [];
        this.hasIndex = false;
        this.dispatchExternal("htmlImporting");
        rows = rows ? rows.getElementsByTagName("tr") : [];
        //check for Tabulator inline options
        this._extractOptions(element, options);
        if (headers.length) this._extractHeaders(headers, rows);
        else this._generateBlankHeaders(headers, rows);
        //iterate through table rows and build data set
        for(var index = 0; index < rows.length; index++){
            var row = rows[index], cells = row.getElementsByTagName("td"), item = {};
            //create index if the don't exist in table
            if (!this.hasIndex) item[options.index] = index;
            for(var i = 0; i < cells.length; i++){
                var cell = cells[i];
                if (typeof this.fieldIndex[i] !== "undefined") item[this.fieldIndex[i]] = cell.innerHTML;
            }
            //add row data to item
            data.push(item);
        }
        options.data = data;
        this.dispatchExternal("htmlImported");
    }
    //extract tabulator attribute options
    _extractOptions(element, options, defaultOptions) {
        var attributes = element.attributes;
        var optionsArr = defaultOptions ? Object.keys(defaultOptions) : Object.keys(options);
        var optionsList = {};
        optionsArr.forEach((item)=>{
            optionsList[item.toLowerCase()] = item;
        });
        for(var index in attributes){
            var attrib = attributes[index];
            var name;
            if (attrib && typeof attrib == "object" && attrib.name && attrib.name.indexOf("tabulator-") === 0) {
                name = attrib.name.replace("tabulator-", "");
                if (typeof optionsList[name] !== "undefined") options[optionsList[name]] = this._attribValue(attrib.value);
            }
        }
    }
    //get value of attribute
    _attribValue(value) {
        if (value === "true") return true;
        if (value === "false") return false;
        return value;
    }
    //find column if it has already been defined
    _findCol(title) {
        var match = this.table.options.columns.find((column)=>{
            return column.title === title;
        });
        return match || false;
    }
    //extract column from headers
    _extractHeaders(headers, rows) {
        for(var index = 0; index < headers.length; index++){
            var header = headers[index], exists = false, col = this._findCol(header.textContent), width;
            if (col) exists = true;
            else col = {
                title: header.textContent.trim()
            };
            if (!col.field) col.field = header.textContent.trim().toLowerCase().replaceAll(" ", "_");
            width = header.getAttribute("width");
            if (width && !col.width) col.width = width;
            //check for Tabulator inline options
            this._extractOptions(header, col, this.table.columnManager.optionsList.registeredDefaults);
            this.fieldIndex[index] = col.field;
            if (col.field == this.table.options.index) this.hasIndex = true;
            if (!exists) this.table.options.columns.push(col);
        }
    }
    //generate blank headers
    _generateBlankHeaders(headers, rows) {
        for(var index = 0; index < headers.length; index++){
            var header = headers[index], col = {
                title: "",
                field: "col" + index
            };
            this.fieldIndex[index] = col.field;
            var width = header.getAttribute("width");
            if (width) col.width = width;
            this.table.options.columns.push(col);
        }
    }
}
function $c2a9788f40f9c90a$var$csv(input) {
    var data = [], row = 0, col = 0, inQuote = false;
    //Iterate over each character
    for(let index = 0; index < input.length; index++){
        let char = input[index], nextChar = input[index + 1];
        //Initialize empty row
        if (!data[row]) data[row] = [];
        //Initialize empty column
        if (!data[row][col]) data[row][col] = "";
        //Handle quotation mark inside string
        if (char == '"' && inQuote && nextChar == '"') {
            data[row][col] += char;
            index++;
            continue;
        }
        //Begin / End Quote
        if (char == '"') {
            inQuote = !inQuote;
            continue;
        }
        //Next column (if not in quote)
        if (char == ',' && !inQuote) {
            col++;
            continue;
        }
        //New row if new line and not in quote (CRLF) 
        if (char == '\r' && nextChar == '\n' && !inQuote) {
            col = 0;
            row++;
            index++;
            continue;
        }
        //New row if new line and not in quote (CR or LF) 
        if ((char == '\r' || char == '\n') && !inQuote) {
            col = 0;
            row++;
            continue;
        }
        //Normal Character, append to column
        data[row][col] += char;
    }
    return data;
}
function $c2a9788f40f9c90a$var$json(input) {
    try {
        return JSON.parse(input);
    } catch (e) {
        console.warn("JSON Import Error - File contents is invalid JSON", e);
        return Promise.reject();
    }
}
function $c2a9788f40f9c90a$var$array$1(input) {
    return input;
}
function $c2a9788f40f9c90a$var$xlsx(input) {
    var XLSXLib = this.dependencyRegistry.lookup("XLSX"), workbook2 = XLSXLib.read(input), sheet = workbook2.Sheets[workbook2.SheetNames[0]];
    return XLSXLib.utils.sheet_to_json(sheet, {
        header: 1
    });
}
var $c2a9788f40f9c90a$var$defaultImporters = {
    csv: $c2a9788f40f9c90a$var$csv,
    json: $c2a9788f40f9c90a$var$json,
    array: $c2a9788f40f9c90a$var$array$1,
    xlsx: $c2a9788f40f9c90a$var$xlsx
};
class $c2a9788f40f9c90a$export$bceca318c211ca25 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "import";
    //load defaults
    static importers = $c2a9788f40f9c90a$var$defaultImporters;
    constructor(table){
        super(table);
        this.registerTableOption("importFormat");
        this.registerTableOption("importReader", "text");
        this.registerTableOption("importHeaderTransform");
        this.registerTableOption("importValueTransform");
        this.registerTableOption("importDataValidator");
        this.registerTableOption("importFileValidator");
    }
    initialize() {
        this.registerTableFunction("import", this.importFromFile.bind(this));
        if (this.table.options.importFormat) {
            this.subscribe("data-loading", this.loadDataCheck.bind(this), 10);
            this.subscribe("data-load", this.loadData.bind(this), 10);
        }
    }
    loadDataCheck(data) {
        return this.table.options.importFormat && (typeof data === "string" || Array.isArray(data) && data.length && Array.isArray(data));
    }
    loadData(data, params, config, silent, previousData) {
        return this.importData(this.lookupImporter(), data).then(this.structureData.bind(this)).catch((err)=>{
            console.error("Import Error:", err || "Unable to import data");
            return Promise.reject(err);
        });
    }
    lookupImporter(importFormat) {
        var importer;
        if (!importFormat) importFormat = this.table.options.importFormat;
        if (typeof importFormat === "string") importer = $c2a9788f40f9c90a$export$bceca318c211ca25.importers[importFormat];
        else importer = importFormat;
        if (!importer) console.error("Import Error - Importer not found:", importFormat);
        return importer;
    }
    importFromFile(importFormat, extension, importReader) {
        var importer = this.lookupImporter(importFormat);
        if (importer) return this.pickFile(extension, importReader).then(this.importData.bind(this, importer)).then(this.structureData.bind(this)).then(this.mutateData.bind(this)).then(this.validateData.bind(this)).then(this.setData.bind(this)).catch((err)=>{
            this.dispatch("import-error", err);
            this.dispatchExternal("importError", err);
            console.error("Import Error:", err || "Unable to import file");
            this.table.dataLoader.alertError();
            setTimeout(()=>{
                this.table.dataLoader.clearAlert();
            }, 3000);
            return Promise.reject(err);
        });
    }
    pickFile(extensions, importReader) {
        return new Promise((resolve, reject)=>{
            var input = document.createElement("input");
            input.type = "file";
            input.accept = extensions;
            input.addEventListener("change", (e)=>{
                var file = input.files[0], reader = new FileReader(), valid = this.validateFile(file);
                if (valid === true) {
                    this.dispatch("import-importing", input.files);
                    this.dispatchExternal("importImporting", input.files);
                    switch(importReader || this.table.options.importReader){
                        case "buffer":
                            reader.readAsArrayBuffer(file);
                            break;
                        case "binary":
                            reader.readAsBinaryString(file);
                            break;
                        case "url":
                            reader.readAsDataURL(file);
                            break;
                        case "text":
                        default:
                            reader.readAsText(file);
                    }
                    reader.onload = (e)=>{
                        resolve(reader.result);
                    };
                    reader.onerror = (e)=>{
                        console.warn("File Load Error - Unable to read file");
                        reject(e);
                    };
                } else reject(valid);
            });
            this.dispatch("import-choose");
            this.dispatchExternal("importChoose");
            input.click();
        });
    }
    importData(importer, fileContents) {
        var data;
        this.table.dataLoader.alertLoader();
        return new Promise((resolve, reject)=>{
            setTimeout(()=>{
                data = importer.call(this.table, fileContents);
                if (data instanceof Promise) resolve(data);
                else data ? resolve(data) : reject();
            }, 10);
        });
    }
    structureData(parsedData) {
        var data = [];
        if (Array.isArray(parsedData) && parsedData.length && Array.isArray(parsedData[0])) {
            if (this.table.options.autoColumns) data = this.structureArrayToObject(parsedData);
            else data = this.structureArrayToColumns(parsedData);
            return data;
        } else return parsedData;
    }
    mutateData(data) {
        var output = [];
        if (Array.isArray(data)) data.forEach((row)=>{
            output.push(this.table.modules.mutator.transformRow(row, "import"));
        });
        else output = data;
        return output;
    }
    transformHeader(headers) {
        var output = [];
        if (this.table.options.importHeaderTransform) headers.forEach((item)=>{
            output.push(this.table.options.importHeaderTransform.call(this.table, item, headers));
        });
        else return headers;
        return output;
    }
    transformData(row) {
        var output = [];
        if (this.table.options.importValueTransform) row.forEach((item)=>{
            output.push(this.table.options.importValueTransform.call(this.table, item, row));
        });
        else return row;
        return output;
    }
    structureArrayToObject(parsedData) {
        var columns = this.transformHeader(parsedData.shift());
        var data = parsedData.map((values)=>{
            var row = {};
            values = this.transformData(values);
            columns.forEach((key, i)=>{
                row[key] = values[i];
            });
            return row;
        });
        return data;
    }
    structureArrayToColumns(parsedData) {
        var data = [], firstRow = this.transformHeader(parsedData[0]), columns = this.table.getColumns();
        //remove first row if it is the column names
        if (columns[0] && firstRow[0]) {
            if (columns[0].getDefinition().title === firstRow[0]) parsedData.shift();
        }
        //convert row arrays to objects
        parsedData.forEach((rowData)=>{
            var row = {};
            rowData = this.transformData(rowData);
            rowData.forEach((value, index)=>{
                var column = columns[index];
                if (column) row[column.getField()] = value;
            });
            data.push(row);
        });
        return data;
    }
    validateFile(file) {
        if (this.table.options.importFileValidator) return this.table.options.importFileValidator.call(this.table, file);
        return true;
    }
    validateData(data) {
        var result;
        if (this.table.options.importDataValidator) {
            result = this.table.options.importDataValidator.call(this.table, data);
            if (result === true) return data;
            else return Promise.reject(result);
        }
        return data;
    }
    setData(data) {
        this.dispatch("import-imported", data);
        this.dispatchExternal("importImported", data);
        this.table.dataLoader.clearAlert();
        return this.table.setData(data);
    }
}
class $c2a9788f40f9c90a$export$69fa60f71dd0541a extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "interaction";
    constructor(table){
        super(table);
        this.eventMap = {
            //row events
            rowClick: "row-click",
            rowDblClick: "row-dblclick",
            rowContext: "row-contextmenu",
            rowMouseEnter: "row-mouseenter",
            rowMouseLeave: "row-mouseleave",
            rowMouseOver: "row-mouseover",
            rowMouseOut: "row-mouseout",
            rowMouseMove: "row-mousemove",
            rowMouseDown: "row-mousedown",
            rowMouseUp: "row-mouseup",
            rowTap: "row",
            rowDblTap: "row",
            rowTapHold: "row",
            //cell events
            cellClick: "cell-click",
            cellDblClick: "cell-dblclick",
            cellContext: "cell-contextmenu",
            cellMouseEnter: "cell-mouseenter",
            cellMouseLeave: "cell-mouseleave",
            cellMouseOver: "cell-mouseover",
            cellMouseOut: "cell-mouseout",
            cellMouseMove: "cell-mousemove",
            cellMouseDown: "cell-mousedown",
            cellMouseUp: "cell-mouseup",
            cellTap: "cell",
            cellDblTap: "cell",
            cellTapHold: "cell",
            //column header events
            headerClick: "column-click",
            headerDblClick: "column-dblclick",
            headerContext: "column-contextmenu",
            headerMouseEnter: "column-mouseenter",
            headerMouseLeave: "column-mouseleave",
            headerMouseOver: "column-mouseover",
            headerMouseOut: "column-mouseout",
            headerMouseMove: "column-mousemove",
            headerMouseDown: "column-mousedown",
            headerMouseUp: "column-mouseup",
            headerTap: "column",
            headerDblTap: "column",
            headerTapHold: "column",
            //group header
            groupClick: "group-click",
            groupDblClick: "group-dblclick",
            groupContext: "group-contextmenu",
            groupMouseEnter: "group-mouseenter",
            groupMouseLeave: "group-mouseleave",
            groupMouseOver: "group-mouseover",
            groupMouseOut: "group-mouseout",
            groupMouseMove: "group-mousemove",
            groupMouseDown: "group-mousedown",
            groupMouseUp: "group-mouseup",
            groupTap: "group",
            groupDblTap: "group",
            groupTapHold: "group"
        };
        this.subscribers = {};
        this.touchSubscribers = {};
        this.columnSubscribers = {};
        this.touchWatchers = {
            row: {
                tap: null,
                tapDbl: null,
                tapHold: null
            },
            cell: {
                tap: null,
                tapDbl: null,
                tapHold: null
            },
            column: {
                tap: null,
                tapDbl: null,
                tapHold: null
            },
            group: {
                tap: null,
                tapDbl: null,
                tapHold: null
            }
        };
        this.registerColumnOption("headerClick");
        this.registerColumnOption("headerDblClick");
        this.registerColumnOption("headerContext");
        this.registerColumnOption("headerMouseEnter");
        this.registerColumnOption("headerMouseLeave");
        this.registerColumnOption("headerMouseOver");
        this.registerColumnOption("headerMouseOut");
        this.registerColumnOption("headerMouseMove");
        this.registerColumnOption("headerMouseDown");
        this.registerColumnOption("headerMouseUp");
        this.registerColumnOption("headerTap");
        this.registerColumnOption("headerDblTap");
        this.registerColumnOption("headerTapHold");
        this.registerColumnOption("cellClick");
        this.registerColumnOption("cellDblClick");
        this.registerColumnOption("cellContext");
        this.registerColumnOption("cellMouseEnter");
        this.registerColumnOption("cellMouseLeave");
        this.registerColumnOption("cellMouseOver");
        this.registerColumnOption("cellMouseOut");
        this.registerColumnOption("cellMouseMove");
        this.registerColumnOption("cellMouseDown");
        this.registerColumnOption("cellMouseUp");
        this.registerColumnOption("cellTap");
        this.registerColumnOption("cellDblTap");
        this.registerColumnOption("cellTapHold");
    }
    initialize() {
        this.initializeExternalEvents();
        this.subscribe("column-init", this.initializeColumn.bind(this));
        this.subscribe("cell-dblclick", this.cellContentsSelectionFixer.bind(this));
        this.subscribe("scroll-horizontal", this.clearTouchWatchers.bind(this));
        this.subscribe("scroll-vertical", this.clearTouchWatchers.bind(this));
    }
    clearTouchWatchers() {
        var types = Object.values(this.touchWatchers);
        types.forEach((type)=>{
            for(let key in type)type[key] = null;
        });
    }
    cellContentsSelectionFixer(e, cell) {
        var range;
        if (this.table.modExists("edit")) {
            if (this.table.modules.edit.currentCell === cell) return; //prevent instant selection of editor content
        }
        e.preventDefault();
        try {
            if (document.selection) {
                range = document.body.createTextRange();
                range.moveToElementText(cell.getElement());
                range.select();
            } else if (window.getSelection) {
                range = document.createRange();
                range.selectNode(cell.getElement());
                window.getSelection().removeAllRanges();
                window.getSelection().addRange(range);
            }
        } catch (e) {}
    }
    initializeExternalEvents() {
        for(let key in this.eventMap)this.subscriptionChangeExternal(key, this.subscriptionChanged.bind(this, key));
    }
    subscriptionChanged(key, added) {
        if (added) {
            if (!this.subscribers[key]) {
                if (this.eventMap[key].includes("-")) {
                    this.subscribers[key] = this.handle.bind(this, key);
                    this.subscribe(this.eventMap[key], this.subscribers[key]);
                } else this.subscribeTouchEvents(key);
            }
        } else {
            if (this.eventMap[key].includes("-")) {
                if (this.subscribers[key] && !this.columnSubscribers[key] && !this.subscribedExternal(key)) {
                    this.unsubscribe(this.eventMap[key], this.subscribers[key]);
                    delete this.subscribers[key];
                }
            } else this.unsubscribeTouchEvents(key);
        }
    }
    subscribeTouchEvents(key) {
        var type = this.eventMap[key];
        if (!this.touchSubscribers[type + "-touchstart"]) {
            this.touchSubscribers[type + "-touchstart"] = this.handleTouch.bind(this, type, "start");
            this.touchSubscribers[type + "-touchend"] = this.handleTouch.bind(this, type, "end");
            this.subscribe(type + "-touchstart", this.touchSubscribers[type + "-touchstart"]);
            this.subscribe(type + "-touchend", this.touchSubscribers[type + "-touchend"]);
        }
        this.subscribers[key] = true;
    }
    unsubscribeTouchEvents(key) {
        var noTouch = true, type = this.eventMap[key];
        if (this.subscribers[key] && !this.subscribedExternal(key)) {
            delete this.subscribers[key];
            for(let i in this.eventMap){
                if (this.eventMap[i] === type) {
                    if (this.subscribers[i]) noTouch = false;
                }
            }
            if (noTouch) {
                this.unsubscribe(type + "-touchstart", this.touchSubscribers[type + "-touchstart"]);
                this.unsubscribe(type + "-touchend", this.touchSubscribers[type + "-touchend"]);
                delete this.touchSubscribers[type + "-touchstart"];
                delete this.touchSubscribers[type + "-touchend"];
            }
        }
    }
    initializeColumn(column) {
        var def = column.definition;
        for(let key in this.eventMap)if (def[key]) {
            this.subscriptionChanged(key, true);
            if (!this.columnSubscribers[key]) this.columnSubscribers[key] = [];
            this.columnSubscribers[key].push(column);
        }
    }
    handle(action, e, component) {
        this.dispatchEvent(action, e, component);
    }
    handleTouch(type, action, e, component) {
        var watchers = this.touchWatchers[type];
        if (type === "column") type = "header";
        switch(action){
            case "start":
                watchers.tap = true;
                clearTimeout(watchers.tapHold);
                watchers.tapHold = setTimeout(()=>{
                    clearTimeout(watchers.tapHold);
                    watchers.tapHold = null;
                    watchers.tap = null;
                    clearTimeout(watchers.tapDbl);
                    watchers.tapDbl = null;
                    this.dispatchEvent(type + "TapHold", e, component);
                }, 1000);
                break;
            case "end":
                if (watchers.tap) {
                    watchers.tap = null;
                    this.dispatchEvent(type + "Tap", e, component);
                }
                if (watchers.tapDbl) {
                    clearTimeout(watchers.tapDbl);
                    watchers.tapDbl = null;
                    this.dispatchEvent(type + "DblTap", e, component);
                } else watchers.tapDbl = setTimeout(()=>{
                    clearTimeout(watchers.tapDbl);
                    watchers.tapDbl = null;
                }, 300);
                clearTimeout(watchers.tapHold);
                watchers.tapHold = null;
                break;
        }
    }
    dispatchEvent(action, e, component) {
        var componentObj = component.getComponent(), callback;
        if (this.columnSubscribers[action]) {
            if (component instanceof $c2a9788f40f9c90a$var$Cell) callback = component.column.definition[action];
            else if (component instanceof $c2a9788f40f9c90a$var$Column) callback = component.definition[action];
            if (callback) callback(e, componentObj);
        }
        this.dispatchExternal(action, e, componentObj);
    }
}
var $c2a9788f40f9c90a$var$defaultBindings = {
    navPrev: "shift + 9",
    navNext: 9,
    navUp: 38,
    navDown: 40,
    navLeft: 37,
    navRight: 39,
    scrollPageUp: 33,
    scrollPageDown: 34,
    scrollToStart: 36,
    scrollToEnd: 35
};
var $c2a9788f40f9c90a$var$defaultActions = {
    keyBlock: function(e) {
        e.stopPropagation();
        e.preventDefault();
    },
    scrollPageUp: function(e) {
        var rowManager = this.table.rowManager, newPos = rowManager.scrollTop - rowManager.element.clientHeight;
        e.preventDefault();
        if (rowManager.displayRowsCount) {
            if (newPos >= 0) rowManager.element.scrollTop = newPos;
            else rowManager.scrollToRow(rowManager.getDisplayRows()[0]);
        }
        this.table.element.focus();
    },
    scrollPageDown: function(e) {
        var rowManager = this.table.rowManager, newPos = rowManager.scrollTop + rowManager.element.clientHeight, scrollMax = rowManager.element.scrollHeight;
        e.preventDefault();
        if (rowManager.displayRowsCount) {
            if (newPos <= scrollMax) rowManager.element.scrollTop = newPos;
            else rowManager.scrollToRow(rowManager.getDisplayRows()[rowManager.displayRowsCount - 1]);
        }
        this.table.element.focus();
    },
    scrollToStart: function(e) {
        var rowManager = this.table.rowManager;
        e.preventDefault();
        if (rowManager.displayRowsCount) rowManager.scrollToRow(rowManager.getDisplayRows()[0]);
        this.table.element.focus();
    },
    scrollToEnd: function(e) {
        var rowManager = this.table.rowManager;
        e.preventDefault();
        if (rowManager.displayRowsCount) rowManager.scrollToRow(rowManager.getDisplayRows()[rowManager.displayRowsCount - 1]);
        this.table.element.focus();
    },
    navPrev: function(e) {
        this.dispatch("keybinding-nav-prev", e);
    },
    navNext: function(e) {
        this.dispatch("keybinding-nav-next", e);
    },
    navLeft: function(e) {
        this.dispatch("keybinding-nav-left", e);
    },
    navRight: function(e) {
        this.dispatch("keybinding-nav-right", e);
    },
    navUp: function(e) {
        this.dispatch("keybinding-nav-up", e);
    },
    navDown: function(e) {
        this.dispatch("keybinding-nav-down", e);
    }
};
class $c2a9788f40f9c90a$export$a0ff4f1c226a7cef extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "keybindings";
    //load defaults
    static bindings = $c2a9788f40f9c90a$var$defaultBindings;
    static actions = $c2a9788f40f9c90a$var$defaultActions;
    constructor(table){
        super(table);
        this.watchKeys = null;
        this.pressedKeys = null;
        this.keyupBinding = false;
        this.keydownBinding = false;
        this.registerTableOption("keybindings", {}); //array for keybindings
        this.registerTableOption("tabEndNewRow", false); //create new row when tab to end of table
    }
    initialize() {
        var bindings = this.table.options.keybindings, mergedBindings = {};
        this.watchKeys = {};
        this.pressedKeys = [];
        if (bindings !== false) {
            Object.assign(mergedBindings, $c2a9788f40f9c90a$export$a0ff4f1c226a7cef.bindings);
            Object.assign(mergedBindings, bindings);
            this.mapBindings(mergedBindings);
            this.bindEvents();
        }
        this.subscribe("table-destroy", this.clearBindings.bind(this));
    }
    mapBindings(bindings) {
        for(let key in bindings){
            if ($c2a9788f40f9c90a$export$a0ff4f1c226a7cef.actions[key]) {
                if (bindings[key]) {
                    if (typeof bindings[key] !== "object") bindings[key] = [
                        bindings[key]
                    ];
                    bindings[key].forEach((binding)=>{
                        var bindingList = Array.isArray(binding) ? binding : [
                            binding
                        ];
                        bindingList.forEach((item)=>{
                            this.mapBinding(key, item);
                        });
                    });
                }
            } else console.warn("Key Binding Error - no such action:", key);
        }
    }
    mapBinding(action, symbolsList) {
        var binding = {
            action: $c2a9788f40f9c90a$export$a0ff4f1c226a7cef.actions[action],
            keys: [],
            ctrl: false,
            shift: false,
            meta: false
        };
        var symbols = symbolsList.toString().toLowerCase().split(" ").join("").split("+");
        symbols.forEach((symbol)=>{
            switch(symbol){
                case "ctrl":
                    binding.ctrl = true;
                    break;
                case "shift":
                    binding.shift = true;
                    break;
                case "meta":
                    binding.meta = true;
                    break;
                default:
                    symbol = isNaN(symbol) ? symbol.toUpperCase().charCodeAt(0) : parseInt(symbol);
                    binding.keys.push(symbol);
                    if (!this.watchKeys[symbol]) this.watchKeys[symbol] = [];
                    this.watchKeys[symbol].push(binding);
            }
        });
    }
    bindEvents() {
        var self = this;
        this.keyupBinding = function(e) {
            var code = e.keyCode;
            var bindings = self.watchKeys[code];
            if (bindings) {
                self.pressedKeys.push(code);
                bindings.forEach(function(binding) {
                    self.checkBinding(e, binding);
                });
            }
        };
        this.keydownBinding = function(e) {
            var code = e.keyCode;
            var bindings = self.watchKeys[code];
            if (bindings) {
                var index = self.pressedKeys.indexOf(code);
                if (index > -1) self.pressedKeys.splice(index, 1);
            }
        };
        this.table.element.addEventListener("keydown", this.keyupBinding);
        this.table.element.addEventListener("keyup", this.keydownBinding);
    }
    clearBindings() {
        if (this.keyupBinding) this.table.element.removeEventListener("keydown", this.keyupBinding);
        if (this.keydownBinding) this.table.element.removeEventListener("keyup", this.keydownBinding);
    }
    checkBinding(e, binding) {
        var match = true;
        if (e.ctrlKey == binding.ctrl && e.shiftKey == binding.shift && e.metaKey == binding.meta) {
            binding.keys.forEach((key)=>{
                var index = this.pressedKeys.indexOf(key);
                if (index == -1) match = false;
            });
            if (match) binding.action.call(this, e);
            return true;
        }
        return false;
    }
}
class $c2a9788f40f9c90a$export$f1ab43fc4c3c5ce0 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "menu";
    constructor(table){
        super(table);
        this.menuContainer = null;
        this.nestedMenuBlock = false;
        this.currentComponent = null;
        this.rootPopup = null;
        this.columnSubscribers = {};
        // this.registerTableOption("menuContainer", undefined); //deprecated
        this.registerTableOption("rowContextMenu", false);
        this.registerTableOption("rowClickMenu", false);
        this.registerTableOption("rowDblClickMenu", false);
        this.registerTableOption("groupContextMenu", false);
        this.registerTableOption("groupClickMenu", false);
        this.registerTableOption("groupDblClickMenu", false);
        this.registerColumnOption("headerContextMenu");
        this.registerColumnOption("headerClickMenu");
        this.registerColumnOption("headerDblClickMenu");
        this.registerColumnOption("headerMenu");
        this.registerColumnOption("headerMenuIcon");
        this.registerColumnOption("contextMenu");
        this.registerColumnOption("clickMenu");
        this.registerColumnOption("dblClickMenu");
    }
    initialize() {
        this.deprecatedOptionsCheck();
        this.initializeRowWatchers();
        this.initializeGroupWatchers();
        this.subscribe("column-init", this.initializeColumn.bind(this));
    }
    deprecatedOptionsCheck() {
    // if(!this.deprecationCheck("menuContainer", "popupContainer")){
    // 	this.table.options.popupContainer = this.table.options.menuContainer;
    // }
    }
    initializeRowWatchers() {
        if (this.table.options.rowContextMenu) {
            this.subscribe("row-contextmenu", this.loadMenuEvent.bind(this, this.table.options.rowContextMenu));
            this.table.on("rowTapHold", this.loadMenuEvent.bind(this, this.table.options.rowContextMenu));
        }
        if (this.table.options.rowClickMenu) this.subscribe("row-click", this.loadMenuEvent.bind(this, this.table.options.rowClickMenu));
        if (this.table.options.rowDblClickMenu) this.subscribe("row-dblclick", this.loadMenuEvent.bind(this, this.table.options.rowDblClickMenu));
    }
    initializeGroupWatchers() {
        if (this.table.options.groupContextMenu) {
            this.subscribe("group-contextmenu", this.loadMenuEvent.bind(this, this.table.options.groupContextMenu));
            this.table.on("groupTapHold", this.loadMenuEvent.bind(this, this.table.options.groupContextMenu));
        }
        if (this.table.options.groupClickMenu) this.subscribe("group-click", this.loadMenuEvent.bind(this, this.table.options.groupClickMenu));
        if (this.table.options.groupDblClickMenu) this.subscribe("group-dblclick", this.loadMenuEvent.bind(this, this.table.options.groupDblClickMenu));
    }
    initializeColumn(column) {
        var def = column.definition;
        //handle column events
        if (def.headerContextMenu && !this.columnSubscribers.headerContextMenu) {
            this.columnSubscribers.headerContextMenu = this.loadMenuTableColumnEvent.bind(this, "headerContextMenu");
            this.subscribe("column-contextmenu", this.columnSubscribers.headerContextMenu);
            this.table.on("headerTapHold", this.loadMenuTableColumnEvent.bind(this, "headerContextMenu"));
        }
        if (def.headerClickMenu && !this.columnSubscribers.headerClickMenu) {
            this.columnSubscribers.headerClickMenu = this.loadMenuTableColumnEvent.bind(this, "headerClickMenu");
            this.subscribe("column-click", this.columnSubscribers.headerClickMenu);
        }
        if (def.headerDblClickMenu && !this.columnSubscribers.headerDblClickMenu) {
            this.columnSubscribers.headerDblClickMenu = this.loadMenuTableColumnEvent.bind(this, "headerDblClickMenu");
            this.subscribe("column-dblclick", this.columnSubscribers.headerDblClickMenu);
        }
        if (def.headerMenu) this.initializeColumnHeaderMenu(column);
        //handle cell events
        if (def.contextMenu && !this.columnSubscribers.contextMenu) {
            this.columnSubscribers.contextMenu = this.loadMenuTableCellEvent.bind(this, "contextMenu");
            this.subscribe("cell-contextmenu", this.columnSubscribers.contextMenu);
            this.table.on("cellTapHold", this.loadMenuTableCellEvent.bind(this, "contextMenu"));
        }
        if (def.clickMenu && !this.columnSubscribers.clickMenu) {
            this.columnSubscribers.clickMenu = this.loadMenuTableCellEvent.bind(this, "clickMenu");
            this.subscribe("cell-click", this.columnSubscribers.clickMenu);
        }
        if (def.dblClickMenu && !this.columnSubscribers.dblClickMenu) {
            this.columnSubscribers.dblClickMenu = this.loadMenuTableCellEvent.bind(this, "dblClickMenu");
            this.subscribe("cell-dblclick", this.columnSubscribers.dblClickMenu);
        }
    }
    initializeColumnHeaderMenu(column) {
        var icon = column.definition.headerMenuIcon, headerMenuEl;
        headerMenuEl = document.createElement("span");
        headerMenuEl.classList.add("tabulator-header-popup-button");
        if (icon) {
            if (typeof icon === "function") icon = icon(column.getComponent());
            if (icon instanceof HTMLElement) headerMenuEl.appendChild(icon);
            else headerMenuEl.innerHTML = icon;
        } else headerMenuEl.innerHTML = "&vellip;";
        headerMenuEl.addEventListener("click", (e)=>{
            e.stopPropagation();
            e.preventDefault();
            this.loadMenuEvent(column.definition.headerMenu, e, column);
        });
        column.titleElement.insertBefore(headerMenuEl, column.titleElement.firstChild);
    }
    loadMenuTableCellEvent(option, e, cell) {
        if (cell._cell) cell = cell._cell;
        if (cell.column.definition[option]) this.loadMenuEvent(cell.column.definition[option], e, cell);
    }
    loadMenuTableColumnEvent(option, e, column) {
        if (column._column) column = column._column;
        if (column.definition[option]) this.loadMenuEvent(column.definition[option], e, column);
    }
    loadMenuEvent(menu, e, component) {
        if (component._group) component = component._group;
        else if (component._row) component = component._row;
        menu = typeof menu == "function" ? menu.call(this.table, e, component.getComponent()) : menu;
        this.loadMenu(e, component, menu);
    }
    loadMenu(e, component, menu, parentEl, parentPopup) {
        var touch = !(e instanceof MouseEvent), menuEl = document.createElement("div"), popup;
        menuEl.classList.add("tabulator-menu");
        if (!touch) e.preventDefault();
        //abort if no menu set
        if (!menu || !menu.length) return;
        if (!parentEl) {
            if (this.nestedMenuBlock) {
                //abort if child menu already open
                if (this.rootPopup) return;
            } else this.nestedMenuBlock = setTimeout(()=>{
                this.nestedMenuBlock = false;
            }, 100);
            if (this.rootPopup) this.rootPopup.hide();
            this.rootPopup = popup = this.popup(menuEl);
        } else popup = parentPopup.child(menuEl);
        menu.forEach((item)=>{
            var itemEl = document.createElement("div"), label = item.label, disabled = item.disabled;
            if (item.separator) itemEl.classList.add("tabulator-menu-separator");
            else {
                itemEl.classList.add("tabulator-menu-item");
                if (typeof label == "function") label = label.call(this.table, component.getComponent());
                if (label instanceof Node) itemEl.appendChild(label);
                else itemEl.innerHTML = label;
                if (typeof disabled == "function") disabled = disabled.call(this.table, component.getComponent());
                if (disabled) {
                    itemEl.classList.add("tabulator-menu-item-disabled");
                    itemEl.addEventListener("click", (e)=>{
                        e.stopPropagation();
                    });
                } else {
                    if (item.menu && item.menu.length) itemEl.addEventListener("click", (e)=>{
                        e.stopPropagation();
                        this.loadMenu(e, component, item.menu, itemEl, popup);
                    });
                    else if (item.action) itemEl.addEventListener("click", (e)=>{
                        item.action(e, component.getComponent());
                    });
                }
                if (item.menu && item.menu.length) itemEl.classList.add("tabulator-menu-item-submenu");
            }
            menuEl.appendChild(itemEl);
        });
        menuEl.addEventListener("click", (e)=>{
            if (this.rootPopup) this.rootPopup.hide();
        });
        popup.show(parentEl || e);
        if (popup === this.rootPopup) {
            this.rootPopup.hideOnBlur(()=>{
                this.rootPopup = null;
                if (this.currentComponent) {
                    this.dispatch("menu-closed", menu, popup);
                    this.dispatchExternal("menuClosed", this.currentComponent.getComponent());
                    this.currentComponent = null;
                }
            });
            this.currentComponent = component;
            this.dispatch("menu-opened", menu, popup);
            this.dispatchExternal("menuOpened", component.getComponent());
        }
    }
}
class $c2a9788f40f9c90a$export$9ab7496e9b38c128 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "moveColumn";
    constructor(table){
        super(table);
        this.placeholderElement = this.createPlaceholderElement();
        this.hoverElement = false; //floating column header element
        this.checkTimeout = false; //click check timeout holder
        this.checkPeriod = 250; //period to wait on mousedown to consider this a move and not a click
        this.moving = false; //currently moving column
        this.toCol = false; //destination column
        this.toColAfter = false; //position of moving column relative to the destination column
        this.startX = 0; //starting position within header element
        this.autoScrollMargin = 40; //auto scroll on edge when within margin
        this.autoScrollStep = 5; //auto scroll distance in pixels
        this.autoScrollTimeout = false; //auto scroll timeout
        this.touchMove = false;
        this.moveHover = this.moveHover.bind(this);
        this.endMove = this.endMove.bind(this);
        this.registerTableOption("movableColumns", false); //enable movable columns
    }
    createPlaceholderElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-col");
        el.classList.add("tabulator-col-placeholder");
        return el;
    }
    initialize() {
        if (this.table.options.movableColumns) {
            this.subscribe("column-init", this.initializeColumn.bind(this));
            this.subscribe("alert-show", this.abortMove.bind(this));
        }
    }
    abortMove() {
        clearTimeout(this.checkTimeout);
    }
    initializeColumn(column) {
        var self = this, config = {}, colEl;
        if (!column.modules.frozen && !column.isGroup && !column.isRowHeader) {
            colEl = column.getElement();
            config.mousemove = (function(e) {
                if (column.parent === self.moving.parent) {
                    if ((self.touchMove ? e.touches[0].pageX : e.pageX) - $c2a9788f40f9c90a$var$Helpers.elOffset(colEl).left + self.table.columnManager.contentsElement.scrollLeft > column.getWidth() / 2) {
                        if (self.toCol !== column || !self.toColAfter) {
                            colEl.parentNode.insertBefore(self.placeholderElement, colEl.nextSibling);
                            self.moveColumn(column, true);
                        }
                    } else if (self.toCol !== column || self.toColAfter) {
                        colEl.parentNode.insertBefore(self.placeholderElement, colEl);
                        self.moveColumn(column, false);
                    }
                }
            }).bind(self);
            colEl.addEventListener("mousedown", function(e) {
                self.touchMove = false;
                if (e.which === 1) self.checkTimeout = setTimeout(function() {
                    self.startMove(e, column);
                }, self.checkPeriod);
            });
            colEl.addEventListener("mouseup", function(e) {
                if (e.which === 1) {
                    if (self.checkTimeout) clearTimeout(self.checkTimeout);
                }
            });
            self.bindTouchEvents(column);
        }
        column.modules.moveColumn = config;
    }
    bindTouchEvents(column) {
        var colEl = column.getElement(), startXMove = false, nextCol, prevCol, nextColWidth, prevColWidth, nextColWidthLast, prevColWidthLast;
        colEl.addEventListener("touchstart", (e)=>{
            this.checkTimeout = setTimeout(()=>{
                this.touchMove = true;
                nextCol = column.nextColumn();
                nextColWidth = nextCol ? nextCol.getWidth() / 2 : 0;
                prevCol = column.prevColumn();
                prevColWidth = prevCol ? prevCol.getWidth() / 2 : 0;
                nextColWidthLast = 0;
                prevColWidthLast = 0;
                startXMove = false;
                this.startMove(e, column);
            }, this.checkPeriod);
        }, {
            passive: true
        });
        colEl.addEventListener("touchmove", (e)=>{
            var diff, moveToCol;
            if (this.moving) {
                this.moveHover(e);
                if (!startXMove) startXMove = e.touches[0].pageX;
                diff = e.touches[0].pageX - startXMove;
                if (diff > 0) {
                    if (nextCol && diff - nextColWidthLast > nextColWidth) {
                        moveToCol = nextCol;
                        if (moveToCol !== column) {
                            startXMove = e.touches[0].pageX;
                            moveToCol.getElement().parentNode.insertBefore(this.placeholderElement, moveToCol.getElement().nextSibling);
                            this.moveColumn(moveToCol, true);
                        }
                    }
                } else if (prevCol && -diff - prevColWidthLast > prevColWidth) {
                    moveToCol = prevCol;
                    if (moveToCol !== column) {
                        startXMove = e.touches[0].pageX;
                        moveToCol.getElement().parentNode.insertBefore(this.placeholderElement, moveToCol.getElement());
                        this.moveColumn(moveToCol, false);
                    }
                }
                if (moveToCol) {
                    nextCol = moveToCol.nextColumn();
                    nextColWidthLast = nextColWidth;
                    nextColWidth = nextCol ? nextCol.getWidth() / 2 : 0;
                    prevCol = moveToCol.prevColumn();
                    prevColWidthLast = prevColWidth;
                    prevColWidth = prevCol ? prevCol.getWidth() / 2 : 0;
                }
            }
        }, {
            passive: true
        });
        colEl.addEventListener("touchend", (e)=>{
            if (this.checkTimeout) clearTimeout(this.checkTimeout);
            if (this.moving) this.endMove(e);
        });
    }
    startMove(e, column) {
        var element = column.getElement(), headerElement = this.table.columnManager.getContentsElement(), headersElement = this.table.columnManager.getHeadersElement();
        //Prevent moving columns when range selection is active
        if (this.table.modules.selectRange && this.table.modules.selectRange.columnSelection) {
            if (this.table.modules.selectRange.mousedown && this.table.modules.selectRange.selecting === "column") return;
        }
        this.moving = column;
        this.startX = (this.touchMove ? e.touches[0].pageX : e.pageX) - $c2a9788f40f9c90a$var$Helpers.elOffset(element).left;
        this.table.element.classList.add("tabulator-block-select");
        //create placeholder
        this.placeholderElement.style.width = column.getWidth() + "px";
        this.placeholderElement.style.height = column.getHeight() + "px";
        element.parentNode.insertBefore(this.placeholderElement, element);
        element.parentNode.removeChild(element);
        //create hover element
        this.hoverElement = element.cloneNode(true);
        this.hoverElement.classList.add("tabulator-moving");
        headerElement.appendChild(this.hoverElement);
        this.hoverElement.style.left = "0";
        this.hoverElement.style.bottom = headerElement.clientHeight - headersElement.offsetHeight + "px";
        if (!this.touchMove) {
            this._bindMouseMove();
            document.body.addEventListener("mousemove", this.moveHover);
            document.body.addEventListener("mouseup", this.endMove);
        }
        this.moveHover(e);
        this.dispatch("column-moving", e, this.moving);
    }
    _bindMouseMove() {
        this.table.columnManager.columnsByIndex.forEach(function(column) {
            if (column.modules.moveColumn.mousemove) column.getElement().addEventListener("mousemove", column.modules.moveColumn.mousemove);
        });
    }
    _unbindMouseMove() {
        this.table.columnManager.columnsByIndex.forEach(function(column) {
            if (column.modules.moveColumn.mousemove) column.getElement().removeEventListener("mousemove", column.modules.moveColumn.mousemove);
        });
    }
    moveColumn(column, after) {
        var movingCells = this.moving.getCells();
        this.toCol = column;
        this.toColAfter = after;
        if (after) column.getCells().forEach(function(cell, i) {
            var cellEl = cell.getElement(true);
            if (cellEl.parentNode && movingCells[i]) cellEl.parentNode.insertBefore(movingCells[i].getElement(), cellEl.nextSibling);
        });
        else column.getCells().forEach(function(cell, i) {
            var cellEl = cell.getElement(true);
            if (cellEl.parentNode && movingCells[i]) cellEl.parentNode.insertBefore(movingCells[i].getElement(), cellEl);
        });
    }
    endMove(e) {
        if (e.which === 1 || this.touchMove) {
            this._unbindMouseMove();
            this.placeholderElement.parentNode.insertBefore(this.moving.getElement(), this.placeholderElement.nextSibling);
            this.placeholderElement.parentNode.removeChild(this.placeholderElement);
            this.hoverElement.parentNode.removeChild(this.hoverElement);
            this.table.element.classList.remove("tabulator-block-select");
            if (this.toCol) this.table.columnManager.moveColumnActual(this.moving, this.toCol, this.toColAfter);
            this.moving = false;
            this.toCol = false;
            this.toColAfter = false;
            if (!this.touchMove) {
                document.body.removeEventListener("mousemove", this.moveHover);
                document.body.removeEventListener("mouseup", this.endMove);
            }
        }
    }
    moveHover(e) {
        var columnHolder = this.table.columnManager.getContentsElement(), scrollLeft = columnHolder.scrollLeft, xPos = (this.touchMove ? e.touches[0].pageX : e.pageX) - $c2a9788f40f9c90a$var$Helpers.elOffset(columnHolder).left + scrollLeft, scrollPos;
        this.hoverElement.style.left = xPos - this.startX + "px";
        if (xPos - scrollLeft < this.autoScrollMargin) {
            if (!this.autoScrollTimeout) this.autoScrollTimeout = setTimeout(()=>{
                scrollPos = Math.max(0, scrollLeft - 5);
                this.table.rowManager.getElement().scrollLeft = scrollPos;
                this.autoScrollTimeout = false;
            }, 1);
        }
        if (scrollLeft + columnHolder.clientWidth - xPos < this.autoScrollMargin) {
            if (!this.autoScrollTimeout) this.autoScrollTimeout = setTimeout(()=>{
                scrollPos = Math.min(columnHolder.clientWidth, scrollLeft + 5);
                this.table.rowManager.getElement().scrollLeft = scrollPos;
                this.autoScrollTimeout = false;
            }, 1);
        }
    }
}
var $c2a9788f40f9c90a$var$defaultSenders = {
    delete: function(fromRow, toRow, toTable) {
        fromRow.delete();
    }
};
var $c2a9788f40f9c90a$var$defaultReceivers = {
    insert: function(fromRow, toRow, fromTable) {
        this.table.addRow(fromRow.getData(), undefined, toRow);
        return true;
    },
    add: function(fromRow, toRow, fromTable) {
        this.table.addRow(fromRow.getData());
        return true;
    },
    update: function(fromRow, toRow, fromTable) {
        if (toRow) {
            toRow.update(fromRow.getData());
            return true;
        }
        return false;
    },
    replace: function(fromRow, toRow, fromTable) {
        if (toRow) {
            this.table.addRow(fromRow.getData(), undefined, toRow);
            toRow.delete();
            return true;
        }
        return false;
    }
};
class $c2a9788f40f9c90a$export$7815d73158f0bb2d extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "moveRow";
    //load defaults
    static senders = $c2a9788f40f9c90a$var$defaultSenders;
    static receivers = $c2a9788f40f9c90a$var$defaultReceivers;
    constructor(table){
        super(table);
        this.placeholderElement = this.createPlaceholderElement();
        this.hoverElement = false; //floating row header element
        this.checkTimeout = false; //click check timeout holder
        this.checkPeriod = 150; //period to wait on mousedown to consider this a move and not a click
        this.moving = false; //currently moving row
        this.toRow = false; //destination row
        this.toRowAfter = false; //position of moving row relative to the destination row
        this.hasHandle = false; //row has handle instead of fully movable row
        this.startY = 0; //starting Y position within header element
        this.startX = 0; //starting X position within header element
        this.moveHover = this.moveHover.bind(this);
        this.endMove = this.endMove.bind(this);
        this.tableRowDropEvent = false;
        this.touchMove = false;
        this.connection = false;
        this.connectionSelectorsTables = false;
        this.connectionSelectorsElements = false;
        this.connectionElements = [];
        this.connections = [];
        this.connectedTable = false;
        this.connectedRow = false;
        this.registerTableOption("movableRows", false); //enable movable rows
        this.registerTableOption("movableRowsConnectedTables", false); //tables for movable rows to be connected to
        this.registerTableOption("movableRowsConnectedElements", false); //other elements for movable rows to be connected to
        this.registerTableOption("movableRowsSender", false);
        this.registerTableOption("movableRowsReceiver", "insert");
        this.registerColumnOption("rowHandle");
    }
    createPlaceholderElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-row");
        el.classList.add("tabulator-row-placeholder");
        return el;
    }
    initialize() {
        if (this.table.options.movableRows) {
            this.connectionSelectorsTables = this.table.options.movableRowsConnectedTables;
            this.connectionSelectorsElements = this.table.options.movableRowsConnectedElements;
            this.connection = this.connectionSelectorsTables || this.connectionSelectorsElements;
            this.subscribe("cell-init", this.initializeCell.bind(this));
            this.subscribe("column-init", this.initializeColumn.bind(this));
            this.subscribe("row-init", this.initializeRow.bind(this));
        }
    }
    initializeGroupHeader(group) {
        var self = this, config = {};
        //inter table drag drop
        config.mouseup = (function(e) {
            self.tableRowDrop(e, group);
        }).bind(self);
        //same table drag drop
        config.mousemove = (function(e) {
            var rowEl;
            if (e.pageY - $c2a9788f40f9c90a$var$Helpers.elOffset(group.element).top + self.table.rowManager.element.scrollTop > group.getHeight() / 2) {
                if (self.toRow !== group || !self.toRowAfter) {
                    rowEl = group.getElement();
                    rowEl.parentNode.insertBefore(self.placeholderElement, rowEl.nextSibling);
                    self.moveRow(group, true);
                }
            } else if (self.toRow !== group || self.toRowAfter) {
                rowEl = group.getElement();
                if (rowEl.previousSibling) {
                    rowEl.parentNode.insertBefore(self.placeholderElement, rowEl);
                    self.moveRow(group, false);
                }
            }
        }).bind(self);
        group.modules.moveRow = config;
    }
    initializeRow(row) {
        var self = this, config = {}, rowEl;
        //inter table drag drop
        config.mouseup = (function(e) {
            self.tableRowDrop(e, row);
        }).bind(self);
        //same table drag drop
        config.mousemove = (function(e) {
            var rowEl = row.getElement();
            if (e.pageY - $c2a9788f40f9c90a$var$Helpers.elOffset(rowEl).top + self.table.rowManager.element.scrollTop > row.getHeight() / 2) {
                if (self.toRow !== row || !self.toRowAfter) {
                    rowEl.parentNode.insertBefore(self.placeholderElement, rowEl.nextSibling);
                    self.moveRow(row, true);
                }
            } else if (self.toRow !== row || self.toRowAfter) {
                rowEl.parentNode.insertBefore(self.placeholderElement, rowEl);
                self.moveRow(row, false);
            }
        }).bind(self);
        if (!this.hasHandle) {
            rowEl = row.getElement();
            rowEl.addEventListener("mousedown", function(e) {
                if (e.which === 1) self.checkTimeout = setTimeout(function() {
                    self.startMove(e, row);
                }, self.checkPeriod);
            });
            rowEl.addEventListener("mouseup", function(e) {
                if (e.which === 1) {
                    if (self.checkTimeout) clearTimeout(self.checkTimeout);
                }
            });
            this.bindTouchEvents(row, row.getElement());
        }
        row.modules.moveRow = config;
    }
    initializeColumn(column) {
        if (column.definition.rowHandle && this.table.options.movableRows !== false) this.hasHandle = true;
    }
    initializeCell(cell) {
        if (cell.column.definition.rowHandle && this.table.options.movableRows !== false) {
            var self = this, cellEl = cell.getElement(true);
            cellEl.addEventListener("mousedown", function(e) {
                if (e.which === 1) self.checkTimeout = setTimeout(function() {
                    self.startMove(e, cell.row);
                }, self.checkPeriod);
            });
            cellEl.addEventListener("mouseup", function(e) {
                if (e.which === 1) {
                    if (self.checkTimeout) clearTimeout(self.checkTimeout);
                }
            });
            this.bindTouchEvents(cell.row, cellEl);
        }
    }
    bindTouchEvents(row, element) {
        var startYMove = false, nextRow, prevRow, nextRowHeight, prevRowHeight, nextRowHeightLast, prevRowHeightLast;
        element.addEventListener("touchstart", (e)=>{
            this.checkTimeout = setTimeout(()=>{
                this.touchMove = true;
                nextRow = row.nextRow();
                nextRowHeight = nextRow ? nextRow.getHeight() / 2 : 0;
                prevRow = row.prevRow();
                prevRowHeight = prevRow ? prevRow.getHeight() / 2 : 0;
                nextRowHeightLast = 0;
                prevRowHeightLast = 0;
                startYMove = false;
                this.startMove(e, row);
            }, this.checkPeriod);
        }, {
            passive: true
        });
        this.moving, this.toRow, this.toRowAfter;
        element.addEventListener("touchmove", (e)=>{
            var diff, moveToRow;
            if (this.moving) {
                e.preventDefault();
                this.moveHover(e);
                if (!startYMove) startYMove = e.touches[0].pageY;
                diff = e.touches[0].pageY - startYMove;
                if (diff > 0) {
                    if (nextRow && diff - nextRowHeightLast > nextRowHeight) {
                        moveToRow = nextRow;
                        if (moveToRow !== row) {
                            startYMove = e.touches[0].pageY;
                            moveToRow.getElement().parentNode.insertBefore(this.placeholderElement, moveToRow.getElement().nextSibling);
                            this.moveRow(moveToRow, true);
                        }
                    }
                } else if (prevRow && -diff - prevRowHeightLast > prevRowHeight) {
                    moveToRow = prevRow;
                    if (moveToRow !== row) {
                        startYMove = e.touches[0].pageY;
                        moveToRow.getElement().parentNode.insertBefore(this.placeholderElement, moveToRow.getElement());
                        this.moveRow(moveToRow, false);
                    }
                }
                if (moveToRow) {
                    nextRow = moveToRow.nextRow();
                    nextRowHeightLast = nextRowHeight;
                    nextRowHeight = nextRow ? nextRow.getHeight() / 2 : 0;
                    prevRow = moveToRow.prevRow();
                    prevRowHeightLast = prevRowHeight;
                    prevRowHeight = prevRow ? prevRow.getHeight() / 2 : 0;
                }
            }
        });
        element.addEventListener("touchend", (e)=>{
            if (this.checkTimeout) clearTimeout(this.checkTimeout);
            if (this.moving) {
                this.endMove(e);
                this.touchMove = false;
            }
        });
    }
    _bindMouseMove() {
        this.table.rowManager.getDisplayRows().forEach((row)=>{
            if ((row.type === "row" || row.type === "group") && row.modules.moveRow && row.modules.moveRow.mousemove) row.getElement().addEventListener("mousemove", row.modules.moveRow.mousemove);
        });
    }
    _unbindMouseMove() {
        this.table.rowManager.getDisplayRows().forEach((row)=>{
            if ((row.type === "row" || row.type === "group") && row.modules.moveRow && row.modules.moveRow.mousemove) row.getElement().removeEventListener("mousemove", row.modules.moveRow.mousemove);
        });
    }
    startMove(e, row) {
        var element = row.getElement();
        this.setStartPosition(e, row);
        this.moving = row;
        this.table.element.classList.add("tabulator-block-select");
        //create placeholder
        this.placeholderElement.style.width = row.getWidth() + "px";
        this.placeholderElement.style.height = row.getHeight() + "px";
        if (!this.connection) {
            element.parentNode.insertBefore(this.placeholderElement, element);
            element.parentNode.removeChild(element);
        } else {
            this.table.element.classList.add("tabulator-movingrow-sending");
            this.connectToTables(row);
        }
        //create hover element
        this.hoverElement = element.cloneNode(true);
        this.hoverElement.classList.add("tabulator-moving");
        if (this.connection) {
            document.body.appendChild(this.hoverElement);
            this.hoverElement.style.left = "0";
            this.hoverElement.style.top = "0";
            this.hoverElement.style.width = this.table.element.clientWidth + "px";
            this.hoverElement.style.whiteSpace = "nowrap";
            this.hoverElement.style.overflow = "hidden";
            this.hoverElement.style.pointerEvents = "none";
        } else {
            this.table.rowManager.getTableElement().appendChild(this.hoverElement);
            this.hoverElement.style.left = "0";
            this.hoverElement.style.top = "0";
            this._bindMouseMove();
        }
        document.body.addEventListener("mousemove", this.moveHover);
        document.body.addEventListener("mouseup", this.endMove);
        this.dispatchExternal("rowMoving", row.getComponent());
        this.moveHover(e);
    }
    setStartPosition(e, row) {
        var pageX = this.touchMove ? e.touches[0].pageX : e.pageX, pageY = this.touchMove ? e.touches[0].pageY : e.pageY, element, position;
        element = row.getElement();
        if (this.connection) {
            position = element.getBoundingClientRect();
            this.startX = position.left - pageX + window.pageXOffset;
            this.startY = position.top - pageY + window.pageYOffset;
        } else this.startY = pageY - element.getBoundingClientRect().top;
    }
    endMove(e) {
        if (!e || e.which === 1 || this.touchMove) {
            this._unbindMouseMove();
            if (!this.connection) {
                this.placeholderElement.parentNode.insertBefore(this.moving.getElement(), this.placeholderElement.nextSibling);
                this.placeholderElement.parentNode.removeChild(this.placeholderElement);
            }
            this.hoverElement.parentNode.removeChild(this.hoverElement);
            this.table.element.classList.remove("tabulator-block-select");
            if (this.toRow) this.table.rowManager.moveRow(this.moving, this.toRow, this.toRowAfter);
            else this.dispatchExternal("rowMoveCancelled", this.moving.getComponent());
            this.moving = false;
            this.toRow = false;
            this.toRowAfter = false;
            document.body.removeEventListener("mousemove", this.moveHover);
            document.body.removeEventListener("mouseup", this.endMove);
            if (this.connection) {
                this.table.element.classList.remove("tabulator-movingrow-sending");
                this.disconnectFromTables();
            }
        }
    }
    moveRow(row, after) {
        this.toRow = row;
        this.toRowAfter = after;
    }
    moveHover(e) {
        if (this.connection) this.moveHoverConnections.call(this, e);
        else this.moveHoverTable.call(this, e);
    }
    moveHoverTable(e) {
        var rowHolder = this.table.rowManager.getElement(), scrollTop = rowHolder.scrollTop, yPos = (this.touchMove ? e.touches[0].pageY : e.pageY) - rowHolder.getBoundingClientRect().top + scrollTop;
        this.hoverElement.style.top = Math.min(yPos - this.startY, this.table.rowManager.element.scrollHeight - this.hoverElement.offsetHeight) + "px";
    }
    moveHoverConnections(e) {
        this.hoverElement.style.left = this.startX + (this.touchMove ? e.touches[0].pageX : e.pageX) + "px";
        this.hoverElement.style.top = this.startY + (this.touchMove ? e.touches[0].pageY : e.pageY) + "px";
    }
    elementRowDrop(e, element, row) {
        this.dispatchExternal("movableRowsElementDrop", e, element, row ? row.getComponent() : false);
    }
    //establish connection with other tables
    connectToTables(row) {
        var connectionTables;
        if (this.connectionSelectorsTables) {
            connectionTables = this.commsConnections(this.connectionSelectorsTables);
            this.dispatchExternal("movableRowsSendingStart", connectionTables);
            this.commsSend(this.connectionSelectorsTables, "moveRow", "connect", {
                row: row
            });
        }
        if (this.connectionSelectorsElements) {
            this.connectionElements = [];
            if (!Array.isArray(this.connectionSelectorsElements)) this.connectionSelectorsElements = [
                this.connectionSelectorsElements
            ];
            this.connectionSelectorsElements.forEach((query)=>{
                if (typeof query === "string") this.connectionElements = this.connectionElements.concat(Array.prototype.slice.call(document.querySelectorAll(query)));
                else this.connectionElements.push(query);
            });
            this.connectionElements.forEach((element)=>{
                var dropEvent = (e)=>{
                    this.elementRowDrop(e, element, this.moving);
                };
                element.addEventListener("mouseup", dropEvent);
                element.tabulatorElementDropEvent = dropEvent;
                element.classList.add("tabulator-movingrow-receiving");
            });
        }
    }
    //disconnect from other tables
    disconnectFromTables() {
        var connectionTables;
        if (this.connectionSelectorsTables) {
            connectionTables = this.commsConnections(this.connectionSelectorsTables);
            this.dispatchExternal("movableRowsSendingStop", connectionTables);
            this.commsSend(this.connectionSelectorsTables, "moveRow", "disconnect");
        }
        this.connectionElements.forEach((element)=>{
            element.classList.remove("tabulator-movingrow-receiving");
            element.removeEventListener("mouseup", element.tabulatorElementDropEvent);
            delete element.tabulatorElementDropEvent;
        });
    }
    //accept incomming connection
    connect(table, row) {
        if (!this.connectedTable) {
            this.connectedTable = table;
            this.connectedRow = row;
            this.table.element.classList.add("tabulator-movingrow-receiving");
            this.table.rowManager.getDisplayRows().forEach((row)=>{
                if (row.type === "row" && row.modules.moveRow && row.modules.moveRow.mouseup) row.getElement().addEventListener("mouseup", row.modules.moveRow.mouseup);
            });
            this.tableRowDropEvent = this.tableRowDrop.bind(this);
            this.table.element.addEventListener("mouseup", this.tableRowDropEvent);
            this.dispatchExternal("movableRowsReceivingStart", row, table);
            return true;
        } else {
            console.warn("Move Row Error - Table cannot accept connection, already connected to table:", this.connectedTable);
            return false;
        }
    }
    //close incoming connection
    disconnect(table) {
        if (table === this.connectedTable) {
            this.connectedTable = false;
            this.connectedRow = false;
            this.table.element.classList.remove("tabulator-movingrow-receiving");
            this.table.rowManager.getDisplayRows().forEach((row)=>{
                if (row.type === "row" && row.modules.moveRow && row.modules.moveRow.mouseup) row.getElement().removeEventListener("mouseup", row.modules.moveRow.mouseup);
            });
            this.table.element.removeEventListener("mouseup", this.tableRowDropEvent);
            this.dispatchExternal("movableRowsReceivingStop", table);
        } else console.warn("Move Row Error - trying to disconnect from non connected table");
    }
    dropComplete(table, row, success) {
        var sender = false;
        if (success) {
            switch(typeof this.table.options.movableRowsSender){
                case "string":
                    sender = $c2a9788f40f9c90a$export$7815d73158f0bb2d.senders[this.table.options.movableRowsSender];
                    break;
                case "function":
                    sender = this.table.options.movableRowsSender;
                    break;
            }
            if (sender) sender.call(this, this.moving ? this.moving.getComponent() : undefined, row ? row.getComponent() : undefined, table);
            else if (this.table.options.movableRowsSender) console.warn("Mover Row Error - no matching sender found:", this.table.options.movableRowsSender);
            this.dispatchExternal("movableRowsSent", this.moving.getComponent(), row ? row.getComponent() : undefined, table);
        } else this.dispatchExternal("movableRowsSentFailed", this.moving.getComponent(), row ? row.getComponent() : undefined, table);
        this.endMove();
    }
    tableRowDrop(e, row) {
        var receiver = false, success = false;
        e.stopImmediatePropagation();
        switch(typeof this.table.options.movableRowsReceiver){
            case "string":
                receiver = $c2a9788f40f9c90a$export$7815d73158f0bb2d.receivers[this.table.options.movableRowsReceiver];
                break;
            case "function":
                receiver = this.table.options.movableRowsReceiver;
                break;
        }
        if (receiver) success = receiver.call(this, this.connectedRow.getComponent(), row ? row.getComponent() : undefined, this.connectedTable);
        else console.warn("Mover Row Error - no matching receiver found:", this.table.options.movableRowsReceiver);
        if (success) this.dispatchExternal("movableRowsReceived", this.connectedRow.getComponent(), row ? row.getComponent() : undefined, this.connectedTable);
        else this.dispatchExternal("movableRowsReceivedFailed", this.connectedRow.getComponent(), row ? row.getComponent() : undefined, this.connectedTable);
        this.commsSend(this.connectedTable, "moveRow", "dropcomplete", {
            row: row,
            success: success
        });
    }
    commsReceived(table, action, data) {
        switch(action){
            case "connect":
                return this.connect(table, data.row);
            case "disconnect":
                return this.disconnect(table);
            case "dropcomplete":
                return this.dropComplete(table, data.row, data.success);
        }
    }
}
var $c2a9788f40f9c90a$var$defaultMutators = {};
class $c2a9788f40f9c90a$export$d0f669567356cabd extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "mutator";
    //load defaults
    static mutators = $c2a9788f40f9c90a$var$defaultMutators;
    constructor(table){
        super(table);
        this.allowedTypes = [
            "",
            "data",
            "edit",
            "clipboard",
            "import"
        ]; //list of mutation types
        this.enabled = true;
        this.registerColumnOption("mutator");
        this.registerColumnOption("mutatorParams");
        this.registerColumnOption("mutatorData");
        this.registerColumnOption("mutatorDataParams");
        this.registerColumnOption("mutatorEdit");
        this.registerColumnOption("mutatorEditParams");
        this.registerColumnOption("mutatorClipboard");
        this.registerColumnOption("mutatorClipboardParams");
        this.registerColumnOption("mutatorImport");
        this.registerColumnOption("mutatorImportParams");
        this.registerColumnOption("mutateLink");
    }
    initialize() {
        this.subscribe("cell-value-changing", this.transformCell.bind(this));
        this.subscribe("cell-value-changed", this.mutateLink.bind(this));
        this.subscribe("column-layout", this.initializeColumn.bind(this));
        this.subscribe("row-data-init-before", this.rowDataChanged.bind(this));
        this.subscribe("row-data-changing", this.rowDataChanged.bind(this));
    }
    rowDataChanged(row, tempData, updatedData) {
        return this.transformRow(tempData, "data", updatedData);
    }
    //initialize column mutator
    initializeColumn(column) {
        var match = false, config = {};
        this.allowedTypes.forEach((type)=>{
            var key = "mutator" + (type.charAt(0).toUpperCase() + type.slice(1)), mutator;
            if (column.definition[key]) {
                mutator = this.lookupMutator(column.definition[key]);
                if (mutator) {
                    match = true;
                    config[key] = {
                        mutator: mutator,
                        params: column.definition[key + "Params"] || {}
                    };
                }
            }
        });
        if (match) column.modules.mutate = config;
    }
    lookupMutator(value) {
        var mutator = false;
        //set column mutator
        switch(typeof value){
            case "string":
                if ($c2a9788f40f9c90a$export$d0f669567356cabd.mutators[value]) mutator = $c2a9788f40f9c90a$export$d0f669567356cabd.mutators[value];
                else console.warn("Mutator Error - No such mutator found, ignoring: ", value);
                break;
            case "function":
                mutator = value;
                break;
        }
        return mutator;
    }
    //apply mutator to row
    transformRow(data, type, updatedData) {
        var key = "mutator" + (type.charAt(0).toUpperCase() + type.slice(1)), value;
        // console.log("key", key)
        if (this.enabled) this.table.columnManager.traverse((column)=>{
            var mutator, params, component;
            if (column.modules.mutate) {
                mutator = column.modules.mutate[key] || column.modules.mutate.mutator || false;
                if (mutator) {
                    value = column.getFieldValue(typeof updatedData !== "undefined" ? updatedData : data);
                    if (type == "data" && !updatedData || typeof value !== "undefined") {
                        component = column.getComponent();
                        params = typeof mutator.params === "function" ? mutator.params(value, data, type, component) : mutator.params;
                        column.setFieldValue(data, mutator.mutator(value, data, type, params, component));
                    }
                }
            }
        });
        return data;
    }
    //apply mutator to new cell value
    transformCell(cell, value) {
        if (cell.column.modules.mutate) {
            var mutator = cell.column.modules.mutate.mutatorEdit || cell.column.modules.mutate.mutator || false, tempData = {};
            if (mutator) {
                tempData = Object.assign(tempData, cell.row.getData());
                cell.column.setFieldValue(tempData, value);
                return mutator.mutator(value, tempData, "edit", mutator.params, cell.getComponent());
            }
        }
        return value;
    }
    mutateLink(cell) {
        var links = cell.column.definition.mutateLink;
        if (links) {
            if (!Array.isArray(links)) links = [
                links
            ];
            links.forEach((link)=>{
                var linkCell = cell.row.getCell(link);
                if (linkCell) linkCell.setValue(linkCell.getValue(), true, true);
            });
        }
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
}
function $c2a9788f40f9c90a$var$rows(pageSize, currentRow, currentPage, totalRows, totalPages) {
    var el = document.createElement("span"), showingEl = document.createElement("span"), valueEl = document.createElement("span"), ofEl = document.createElement("span"), totalEl = document.createElement("span"), rowsEl = document.createElement("span");
    this.table.modules.localize.langBind("pagination|counter|showing", (value)=>{
        showingEl.innerHTML = value;
    });
    this.table.modules.localize.langBind("pagination|counter|of", (value)=>{
        ofEl.innerHTML = value;
    });
    this.table.modules.localize.langBind("pagination|counter|rows", (value)=>{
        rowsEl.innerHTML = value;
    });
    if (totalRows) {
        valueEl.innerHTML = " " + currentRow + "-" + Math.min(currentRow + pageSize - 1, totalRows) + " ";
        totalEl.innerHTML = " " + totalRows + " ";
        el.appendChild(showingEl);
        el.appendChild(valueEl);
        el.appendChild(ofEl);
        el.appendChild(totalEl);
        el.appendChild(rowsEl);
    } else {
        valueEl.innerHTML = " 0 ";
        el.appendChild(showingEl);
        el.appendChild(valueEl);
        el.appendChild(rowsEl);
    }
    return el;
}
function $c2a9788f40f9c90a$var$pages(pageSize, currentRow, currentPage, totalRows, totalPages) {
    var el = document.createElement("span"), showingEl = document.createElement("span"), valueEl = document.createElement("span"), ofEl = document.createElement("span"), totalEl = document.createElement("span"), rowsEl = document.createElement("span");
    this.table.modules.localize.langBind("pagination|counter|showing", (value)=>{
        showingEl.innerHTML = value;
    });
    valueEl.innerHTML = " " + currentPage + " ";
    this.table.modules.localize.langBind("pagination|counter|of", (value)=>{
        ofEl.innerHTML = value;
    });
    totalEl.innerHTML = " " + totalPages + " ";
    this.table.modules.localize.langBind("pagination|counter|pages", (value)=>{
        rowsEl.innerHTML = value;
    });
    el.appendChild(showingEl);
    el.appendChild(valueEl);
    el.appendChild(ofEl);
    el.appendChild(totalEl);
    el.appendChild(rowsEl);
    return el;
}
var $c2a9788f40f9c90a$var$defaultPageCounters = {
    rows: $c2a9788f40f9c90a$var$rows,
    pages: $c2a9788f40f9c90a$var$pages
};
class $c2a9788f40f9c90a$export$7eba6c45a494ceac extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "page";
    //load defaults
    static pageCounters = $c2a9788f40f9c90a$var$defaultPageCounters;
    constructor(table){
        super(table);
        this.mode = "local";
        this.progressiveLoad = false;
        this.element = null;
        this.pageCounterElement = null;
        this.pageCounter = null;
        this.size = 0;
        this.page = 1;
        this.count = 5;
        this.max = 1;
        this.remoteRowCountEstimate = null;
        this.initialLoad = true;
        this.dataChanging = false; //flag to check if data is being changed by this module
        this.pageSizes = [];
        this.registerTableOption("pagination", false); //set pagination type
        this.registerTableOption("paginationMode", "local"); //local or remote pagination
        this.registerTableOption("paginationSize", false); //set number of rows to a page
        this.registerTableOption("paginationInitialPage", 1); //initial page to show on load
        this.registerTableOption("paginationCounter", false); // set pagination counter
        this.registerTableOption("paginationCounterElement", false); // set pagination counter
        this.registerTableOption("paginationButtonCount", 5); // set count of page button
        this.registerTableOption("paginationSizeSelector", false); //add pagination size selector element
        this.registerTableOption("paginationElement", false); //element to hold pagination numbers
        // this.registerTableOption("paginationDataSent", {}); //pagination data sent to the server
        // this.registerTableOption("paginationDataReceived", {}); //pagination data received from the server
        this.registerTableOption("paginationAddRow", "page"); //add rows on table or page
        this.registerTableOption("paginationOutOfRange", false); //reset the current page when the last page < this.page, values: false|function|any value accepted by setPage()
        this.registerTableOption("progressiveLoad", false); //progressive loading
        this.registerTableOption("progressiveLoadDelay", 0); //delay between requests
        this.registerTableOption("progressiveLoadScrollMargin", 0); //margin before scroll begins
        this.registerTableFunction("setMaxPage", this.setMaxPage.bind(this));
        this.registerTableFunction("setPage", this.setPage.bind(this));
        this.registerTableFunction("setPageToRow", this.userSetPageToRow.bind(this));
        this.registerTableFunction("setPageSize", this.userSetPageSize.bind(this));
        this.registerTableFunction("getPageSize", this.getPageSize.bind(this));
        this.registerTableFunction("previousPage", this.previousPage.bind(this));
        this.registerTableFunction("nextPage", this.nextPage.bind(this));
        this.registerTableFunction("getPage", this.getPage.bind(this));
        this.registerTableFunction("getPageMax", this.getPageMax.bind(this));
        //register component functions
        this.registerComponentFunction("row", "pageTo", this.setPageToRow.bind(this));
    }
    initialize() {
        if (this.table.options.pagination) {
            this.subscribe("row-deleted", this.rowsUpdated.bind(this));
            this.subscribe("row-added", this.rowsUpdated.bind(this));
            this.subscribe("data-processed", this.initialLoadComplete.bind(this));
            this.subscribe("table-built", this.calculatePageSizes.bind(this));
            this.subscribe("footer-redraw", this.footerRedraw.bind(this));
            if (this.table.options.paginationAddRow == "page") this.subscribe("row-adding-position", this.rowAddingPosition.bind(this));
            if (this.table.options.paginationMode === "remote") {
                this.subscribe("data-params", this.remotePageParams.bind(this));
                this.subscribe("data-loaded", this._parseRemoteData.bind(this));
            }
            if (this.table.options.progressiveLoad) console.error("Progressive Load Error - Pagination and progressive load cannot be used at the same time");
            this.registerDisplayHandler(this.restOnRenderBefore.bind(this), 40);
            this.registerDisplayHandler(this.getRows.bind(this), 50);
            this.createElements();
            this.initializePageCounter();
            this.initializePaginator();
        } else if (this.table.options.progressiveLoad) {
            this.subscribe("data-params", this.remotePageParams.bind(this));
            this.subscribe("data-loaded", this._parseRemoteData.bind(this));
            this.subscribe("table-built", this.calculatePageSizes.bind(this));
            this.subscribe("data-processed", this.initialLoadComplete.bind(this));
            this.initializeProgressive(this.table.options.progressiveLoad);
            if (this.table.options.progressiveLoad === "scroll") this.subscribe("scroll-vertical", this.scrollVertical.bind(this));
        }
    }
    rowAddingPosition(row, top) {
        var rowManager = this.table.rowManager, displayRows = rowManager.getDisplayRows(), index;
        if (top) {
            if (displayRows.length) index = displayRows[0];
            else if (rowManager.activeRows.length) {
                index = rowManager.activeRows[rowManager.activeRows.length - 1];
                top = false;
            }
        } else if (displayRows.length) {
            index = displayRows[displayRows.length - 1];
            top = displayRows.length < this.size ? false : true;
        }
        return {
            index: index,
            top: top
        };
    }
    calculatePageSizes() {
        var testElRow, testElCell;
        if (this.table.options.paginationSize) this.size = this.table.options.paginationSize;
        else {
            testElRow = document.createElement("div");
            testElRow.classList.add("tabulator-row");
            testElRow.style.visibility = "hidden";
            testElCell = document.createElement("div");
            testElCell.classList.add("tabulator-cell");
            testElCell.innerHTML = "Page Row Test";
            testElRow.appendChild(testElCell);
            this.table.rowManager.getTableElement().appendChild(testElRow);
            this.size = Math.floor(this.table.rowManager.getElement().clientHeight / testElRow.offsetHeight);
            this.table.rowManager.getTableElement().removeChild(testElRow);
        }
        this.dispatchExternal("pageSizeChanged", this.size);
        this.generatePageSizeSelectList();
    }
    initialLoadComplete() {
        this.initialLoad = false;
    }
    remotePageParams(data, config, silent, params) {
        if (!this.initialLoad) {
            if (this.progressiveLoad && !silent || !this.progressiveLoad && !this.dataChanging) this.reset(true);
        }
        //configure request params
        params.page = this.page;
        //set page size if defined
        if (this.size) params.size = this.size;
        return params;
    }
    ///////////////////////////////////
    ///////// Table Functions /////////
    ///////////////////////////////////
    userSetPageToRow(row) {
        if (this.table.options.pagination) {
            row = this.table.rowManager.findRow(row);
            if (row) return this.setPageToRow(row);
        }
        return Promise.reject();
    }
    userSetPageSize(size) {
        if (this.table.options.pagination) {
            this.setPageSize(size);
            return this.setPage(1);
        } else return false;
    }
    ///////////////////////////////////
    ///////// Internal Logic //////////
    ///////////////////////////////////
    scrollVertical(top, dir) {
        var element, diff, margin;
        if (!dir && !this.table.dataLoader.loading) {
            element = this.table.rowManager.getElement();
            diff = element.scrollHeight - element.clientHeight - top;
            margin = this.table.options.progressiveLoadScrollMargin || element.clientHeight * 2;
            if (diff < margin) this.nextPage().catch(()=>{}); //consume the exception thrown when on the last page
        }
    }
    restOnRenderBefore(rows, renderInPosition) {
        if (!renderInPosition) {
            if (this.mode === "local") this.reset();
        }
        return rows;
    }
    rowsUpdated() {
        this.refreshData(true, "all");
    }
    createElements() {
        var button;
        this.element = document.createElement("span");
        this.element.classList.add("tabulator-paginator");
        this.pagesElement = document.createElement("span");
        this.pagesElement.classList.add("tabulator-pages");
        button = document.createElement("button");
        button.classList.add("tabulator-page");
        button.setAttribute("type", "button");
        button.setAttribute("role", "button");
        button.setAttribute("aria-label", "");
        button.setAttribute("title", "");
        this.firstBut = button.cloneNode(true);
        this.firstBut.setAttribute("data-page", "first");
        this.prevBut = button.cloneNode(true);
        this.prevBut.setAttribute("data-page", "prev");
        this.nextBut = button.cloneNode(true);
        this.nextBut.setAttribute("data-page", "next");
        this.lastBut = button.cloneNode(true);
        this.lastBut.setAttribute("data-page", "last");
        if (this.table.options.paginationSizeSelector) {
            this.pageSizeSelect = document.createElement("select");
            this.pageSizeSelect.classList.add("tabulator-page-size");
        }
    }
    generatePageSizeSelectList() {
        var pageSizes = [];
        if (this.pageSizeSelect) {
            if (Array.isArray(this.table.options.paginationSizeSelector)) {
                pageSizes = this.table.options.paginationSizeSelector;
                this.pageSizes = pageSizes;
                if (this.pageSizes.indexOf(this.size) == -1) pageSizes.unshift(this.size);
            } else if (this.pageSizes.indexOf(this.size) == -1) {
                pageSizes = [];
                for(let i = 1; i < 5; i++)pageSizes.push(this.size * i);
                this.pageSizes = pageSizes;
            } else pageSizes = this.pageSizes;
            while(this.pageSizeSelect.firstChild)this.pageSizeSelect.removeChild(this.pageSizeSelect.firstChild);
            pageSizes.forEach((item)=>{
                var itemEl = document.createElement("option");
                itemEl.value = item;
                if (item === true) this.langBind("pagination|all", function(value) {
                    itemEl.innerHTML = value;
                });
                else itemEl.innerHTML = item;
                this.pageSizeSelect.appendChild(itemEl);
            });
            this.pageSizeSelect.value = this.size;
        }
    }
    initializePageCounter() {
        var counter = this.table.options.paginationCounter, pageCounter = null;
        if (counter) {
            if (typeof counter === "function") pageCounter = counter;
            else pageCounter = $c2a9788f40f9c90a$export$7eba6c45a494ceac.pageCounters[counter];
            if (pageCounter) {
                this.pageCounter = pageCounter;
                this.pageCounterElement = document.createElement("span");
                this.pageCounterElement.classList.add("tabulator-page-counter");
            } else console.warn("Pagination Error - No such page counter found: ", counter);
        }
    }
    //setup pagination
    initializePaginator(hidden) {
        var pageSelectLabel, paginationCounterHolder;
        if (!hidden) {
            //build pagination element
            //bind localizations
            this.langBind("pagination|first", (value)=>{
                this.firstBut.innerHTML = value;
            });
            this.langBind("pagination|first_title", (value)=>{
                this.firstBut.setAttribute("aria-label", value);
                this.firstBut.setAttribute("title", value);
            });
            this.langBind("pagination|prev", (value)=>{
                this.prevBut.innerHTML = value;
            });
            this.langBind("pagination|prev_title", (value)=>{
                this.prevBut.setAttribute("aria-label", value);
                this.prevBut.setAttribute("title", value);
            });
            this.langBind("pagination|next", (value)=>{
                this.nextBut.innerHTML = value;
            });
            this.langBind("pagination|next_title", (value)=>{
                this.nextBut.setAttribute("aria-label", value);
                this.nextBut.setAttribute("title", value);
            });
            this.langBind("pagination|last", (value)=>{
                this.lastBut.innerHTML = value;
            });
            this.langBind("pagination|last_title", (value)=>{
                this.lastBut.setAttribute("aria-label", value);
                this.lastBut.setAttribute("title", value);
            });
            //click bindings
            this.firstBut.addEventListener("click", ()=>{
                this.setPage(1);
            });
            this.prevBut.addEventListener("click", ()=>{
                this.previousPage();
            });
            this.nextBut.addEventListener("click", ()=>{
                this.nextPage();
            });
            this.lastBut.addEventListener("click", ()=>{
                this.setPage(this.max);
            });
            if (this.table.options.paginationElement) this.element = this.table.options.paginationElement;
            if (this.pageSizeSelect) {
                pageSelectLabel = document.createElement("label");
                this.langBind("pagination|page_size", (value)=>{
                    this.pageSizeSelect.setAttribute("aria-label", value);
                    this.pageSizeSelect.setAttribute("title", value);
                    pageSelectLabel.innerHTML = value;
                });
                this.element.appendChild(pageSelectLabel);
                this.element.appendChild(this.pageSizeSelect);
                this.pageSizeSelect.addEventListener("change", (e)=>{
                    this.setPageSize(this.pageSizeSelect.value == "true" ? true : this.pageSizeSelect.value);
                    this.setPage(1);
                });
            }
            //append to DOM
            this.element.appendChild(this.firstBut);
            this.element.appendChild(this.prevBut);
            this.element.appendChild(this.pagesElement);
            this.element.appendChild(this.nextBut);
            this.element.appendChild(this.lastBut);
            if (!this.table.options.paginationElement) {
                if (this.table.options.paginationCounter) {
                    if (this.table.options.paginationCounterElement) {
                        if (this.table.options.paginationCounterElement instanceof HTMLElement) this.table.options.paginationCounterElement.appendChild(this.pageCounterElement);
                        else if (typeof this.table.options.paginationCounterElement === "string") {
                            paginationCounterHolder = document.querySelector(this.table.options.paginationCounterElement);
                            if (paginationCounterHolder) paginationCounterHolder.appendChild(this.pageCounterElement);
                            else console.warn("Pagination Error - Unable to find element matching paginationCounterElement selector:", this.table.options.paginationCounterElement);
                        }
                    } else this.footerAppend(this.pageCounterElement);
                }
                this.footerAppend(this.element);
            }
            this.page = this.table.options.paginationInitialPage;
            this.count = this.table.options.paginationButtonCount;
        }
        //set default values
        this.mode = this.table.options.paginationMode;
    }
    initializeProgressive(mode) {
        this.initializePaginator(true);
        this.mode = "progressive_" + mode;
        this.progressiveLoad = true;
    }
    trackChanges() {
        this.dispatch("page-changed");
    }
    //calculate maximum page from number of rows
    setMaxRows(rowCount) {
        if (!rowCount) this.max = 1;
        else this.max = this.size === true ? 1 : Math.ceil(rowCount / this.size);
        if (this.page > this.max) this.page = this.max;
    }
    //reset to first page without triggering action
    reset(force) {
        if (!this.initialLoad) {
            if (this.mode == "local" || force) {
                this.page = 1;
                this.trackChanges();
            }
        }
    }
    //set the maximum page
    setMaxPage(max) {
        max = parseInt(max);
        this.max = max || 1;
        if (this.page > this.max) {
            this.page = this.max;
            this.trigger();
        }
    }
    //set current page number
    setPage(page) {
        switch(page){
            case "first":
                return this.setPage(1);
            case "prev":
                return this.previousPage();
            case "next":
                return this.nextPage();
            case "last":
                return this.setPage(this.max);
        }
        page = parseInt(page);
        if (page > 0 && page <= this.max || this.mode !== "local") {
            this.page = page;
            this.trackChanges();
            return this.trigger();
        } else {
            console.warn("Pagination Error - Requested page is out of range of 1 - " + this.max + ":", page);
            return Promise.reject();
        }
    }
    setPageToRow(row) {
        var rows = this.displayRows(-1);
        var index = rows.indexOf(row);
        if (index > -1) {
            var page = this.size === true ? 1 : Math.ceil((index + 1) / this.size);
            return this.setPage(page);
        } else {
            console.warn("Pagination Error - Requested row is not visible");
            return Promise.reject();
        }
    }
    setPageSize(size) {
        if (size !== true) size = parseInt(size);
        if (size > 0) {
            this.size = size;
            this.dispatchExternal("pageSizeChanged", size);
        }
        if (this.pageSizeSelect) // this.pageSizeSelect.value = size;
        this.generatePageSizeSelectList();
        this.trackChanges();
    }
    _setPageCounter(totalRows, size, currentRow) {
        var content;
        if (this.pageCounter) {
            if (this.mode === "remote") {
                size = this.size;
                currentRow = (this.page - 1) * this.size + 1;
                totalRows = this.remoteRowCountEstimate;
            }
            content = this.pageCounter.call(this, size, currentRow, this.page, totalRows, this.max);
            switch(typeof content){
                case "object":
                    if (content instanceof Node) {
                        //clear previous cell contents
                        while(this.pageCounterElement.firstChild)this.pageCounterElement.removeChild(this.pageCounterElement.firstChild);
                        this.pageCounterElement.appendChild(content);
                    } else {
                        this.pageCounterElement.innerHTML = "";
                        if (content != null) console.warn("Page Counter Error - Page Counter has returned a type of object, the only valid page counter object return is an instance of Node, the page counter returned:", content);
                    }
                    break;
                case "undefined":
                    this.pageCounterElement.innerHTML = "";
                    break;
                default:
                    this.pageCounterElement.innerHTML = content;
            }
        }
    }
    //setup the pagination buttons
    _setPageButtons() {
        let leftSize = Math.floor((this.count - 1) / 2);
        let rightSize = Math.ceil((this.count - 1) / 2);
        let min = this.max - this.page + leftSize + 1 < this.count ? this.max - this.count + 1 : Math.max(this.page - leftSize, 1);
        let max = this.page <= rightSize ? Math.min(this.count, this.max) : Math.min(this.page + rightSize, this.max);
        while(this.pagesElement.firstChild)this.pagesElement.removeChild(this.pagesElement.firstChild);
        if (this.page == 1) {
            this.firstBut.disabled = true;
            this.prevBut.disabled = true;
        } else {
            this.firstBut.disabled = false;
            this.prevBut.disabled = false;
        }
        if (this.page == this.max) {
            this.lastBut.disabled = true;
            this.nextBut.disabled = true;
        } else {
            this.lastBut.disabled = false;
            this.nextBut.disabled = false;
        }
        for(let i = min; i <= max; i++)if (i > 0 && i <= this.max) this.pagesElement.appendChild(this._generatePageButton(i));
        this.footerRedraw();
    }
    _generatePageButton(page) {
        var button = document.createElement("button");
        button.classList.add("tabulator-page");
        if (page == this.page) button.classList.add("active");
        button.setAttribute("type", "button");
        button.setAttribute("role", "button");
        this.langBind("pagination|page_title", (value)=>{
            button.setAttribute("aria-label", value + " " + page);
            button.setAttribute("title", value + " " + page);
        });
        button.setAttribute("data-page", page);
        button.textContent = page;
        button.addEventListener("click", (e)=>{
            this.setPage(page);
        });
        return button;
    }
    //previous page
    previousPage() {
        if (this.page > 1) {
            this.page--;
            this.trackChanges();
            return this.trigger();
        } else {
            console.warn("Pagination Error - Previous page would be less than page 1:", 0);
            return Promise.reject();
        }
    }
    //next page
    nextPage() {
        if (this.page < this.max) {
            this.page++;
            this.trackChanges();
            return this.trigger();
        } else {
            if (!this.progressiveLoad) console.warn("Pagination Error - Next page would be greater than maximum page of " + this.max + ":", this.max + 1);
            return Promise.reject();
        }
    }
    //return current page number
    getPage() {
        return this.page;
    }
    //return max page number
    getPageMax() {
        return this.max;
    }
    getPageSize(size) {
        return this.size;
    }
    getMode() {
        return this.mode;
    }
    //return appropriate rows for current page
    getRows(data) {
        var actualRowPageSize = 0, output, start, end, actualStartRow;
        var actualRows = data.filter((row)=>{
            return row.type === "row";
        });
        if (this.mode == "local") {
            output = [];
            this.setMaxRows(data.length);
            if (this.size === true) {
                start = 0;
                end = data.length;
            } else {
                start = this.size * (this.page - 1);
                end = start + parseInt(this.size);
            }
            this._setPageButtons();
            for(let i = start; i < end; i++){
                let row = data[i];
                if (row) {
                    output.push(row);
                    if (row.type === "row") {
                        if (!actualStartRow) actualStartRow = row;
                        actualRowPageSize++;
                    }
                }
            }
            this._setPageCounter(actualRows.length, actualRowPageSize, actualStartRow ? actualRows.indexOf(actualStartRow) + 1 : 0);
            return output;
        } else {
            this._setPageButtons();
            this._setPageCounter(actualRows.length);
            return data.slice(0);
        }
    }
    trigger() {
        var left;
        switch(this.mode){
            case "local":
                left = this.table.rowManager.scrollLeft;
                this.refreshData();
                this.table.rowManager.scrollHorizontal(left);
                this.dispatchExternal("pageLoaded", this.getPage());
                return Promise.resolve();
            case "remote":
                this.dataChanging = true;
                return this.reloadData(null).finally(()=>{
                    this.dataChanging = false;
                });
            case "progressive_load":
            case "progressive_scroll":
                return this.reloadData(null, true);
            default:
                console.warn("Pagination Error - no such pagination mode:", this.mode);
                return Promise.reject();
        }
    }
    _parseRemoteData(data) {
        var margin, paginationOutOfRange;
        if (typeof data.last_page === "undefined") console.warn("Remote Pagination Error - Server response missing '" + (this.options("dataReceiveParams").last_page || "last_page") + "' property");
        if (data.data) {
            this.max = parseInt(data.last_page) || 1;
            this.remoteRowCountEstimate = typeof data.last_row !== "undefined" ? data.last_row : data.last_page * this.size - (this.page == data.last_page ? this.size - data.data.length : 0);
            if (this.progressiveLoad) {
                switch(this.mode){
                    case "progressive_load":
                        if (this.page == 1) this.table.rowManager.setData(data.data, false, this.page == 1);
                        else this.table.rowManager.addRows(data.data);
                        if (this.page < this.max) setTimeout(()=>{
                            this.nextPage();
                        }, this.table.options.progressiveLoadDelay);
                        break;
                    case "progressive_scroll":
                        data = this.page === 1 ? data.data : this.table.rowManager.getData().concat(data.data);
                        this.table.rowManager.setData(data, this.page !== 1, this.page == 1);
                        margin = this.table.options.progressiveLoadScrollMargin || this.table.rowManager.element.clientHeight * 2;
                        if (this.table.rowManager.element.scrollHeight <= this.table.rowManager.element.clientHeight + margin) {
                            if (this.page < this.max) setTimeout(()=>{
                                this.nextPage();
                            });
                        }
                        break;
                }
                return false;
            } else {
                if (this.page > this.max) {
                    console.warn("Remote Pagination Error - Server returned last page value lower than the current page");
                    paginationOutOfRange = this.options('paginationOutOfRange');
                    if (paginationOutOfRange) return this.setPage(typeof paginationOutOfRange === 'function' ? paginationOutOfRange.call(this, this.page, this.max) : paginationOutOfRange);
                }
                // left = this.table.rowManager.scrollLeft;
                this.dispatchExternal("pageLoaded", this.getPage());
            // this.table.rowManager.scrollHorizontal(left);
            // this.table.columnManager.scrollHorizontal(left);
            }
        } else console.warn("Remote Pagination Error - Server response missing '" + (this.options("dataReceiveParams").data || "data") + "' property");
        return data.data;
    }
    //handle the footer element being redrawn
    footerRedraw() {
        var footer = this.table.footerManager.containerElement;
        if (Math.ceil(footer.clientWidth) - footer.scrollWidth < 0) this.pagesElement.style.display = 'none';
        else {
            this.pagesElement.style.display = '';
            if (Math.ceil(footer.clientWidth) - footer.scrollWidth < 0) this.pagesElement.style.display = 'none';
        }
    }
}
// read persistance information from storage
var $c2a9788f40f9c90a$var$defaultReaders = {
    local: function(id, type) {
        var data = localStorage.getItem(id + "-" + type);
        return data ? JSON.parse(data) : false;
    },
    cookie: function(id, type) {
        var cookie = document.cookie, key = id + "-" + type, cookiePos = cookie.indexOf(key + "="), end, data;
        //if cookie exists, decode and load column data into tabulator
        if (cookiePos > -1) {
            cookie = cookie.slice(cookiePos);
            end = cookie.indexOf(";");
            if (end > -1) cookie = cookie.slice(0, end);
            data = cookie.replace(key + "=", "");
        }
        return data ? JSON.parse(data) : false;
    }
};
//write persistence information to storage
var $c2a9788f40f9c90a$var$defaultWriters = {
    local: function(id, type, data) {
        localStorage.setItem(id + "-" + type, JSON.stringify(data));
    },
    cookie: function(id, type, data) {
        var expireDate = new Date();
        expireDate.setDate(expireDate.getDate() + 10000);
        document.cookie = id + "-" + type + "=" + JSON.stringify(data) + "; expires=" + expireDate.toUTCString();
    }
};
class $c2a9788f40f9c90a$export$6ce0215a06bec981 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "persistence";
    static moduleInitOrder = -10;
    //load defaults
    static readers = $c2a9788f40f9c90a$var$defaultReaders;
    static writers = $c2a9788f40f9c90a$var$defaultWriters;
    constructor(table){
        super(table);
        this.mode = "";
        this.id = "";
        // this.persistProps = ["field", "width", "visible"];
        this.defWatcherBlock = false;
        this.config = {};
        this.readFunc = false;
        this.writeFunc = false;
        this.registerTableOption("persistence", false);
        this.registerTableOption("persistenceID", ""); //key for persistent storage
        this.registerTableOption("persistenceMode", true); //mode for storing persistence information
        this.registerTableOption("persistenceReaderFunc", false); //function for handling persistence data reading
        this.registerTableOption("persistenceWriterFunc", false); //function for handling persistence data writing
    }
    // Test for whether localStorage is available for use.
    localStorageTest() {
        var testKey = "_tabulator_test";
        try {
            window.localStorage.setItem(testKey, testKey);
            window.localStorage.removeItem(testKey);
            return true;
        } catch (e) {
            return false;
        }
    }
    //setup parameters
    initialize() {
        if (this.table.options.persistence) {
            //determine persistent layout storage type
            var mode = this.table.options.persistenceMode, id = this.table.options.persistenceID, retrievedData;
            this.mode = mode !== true ? mode : this.localStorageTest() ? "local" : "cookie";
            if (this.table.options.persistenceReaderFunc) {
                if (typeof this.table.options.persistenceReaderFunc === "function") this.readFunc = this.table.options.persistenceReaderFunc;
                else if ($c2a9788f40f9c90a$export$6ce0215a06bec981.readers[this.table.options.persistenceReaderFunc]) this.readFunc = $c2a9788f40f9c90a$export$6ce0215a06bec981.readers[this.table.options.persistenceReaderFunc];
                else console.warn("Persistence Read Error - invalid reader set", this.table.options.persistenceReaderFunc);
            } else if ($c2a9788f40f9c90a$export$6ce0215a06bec981.readers[this.mode]) this.readFunc = $c2a9788f40f9c90a$export$6ce0215a06bec981.readers[this.mode];
            else console.warn("Persistence Read Error - invalid reader set", this.mode);
            if (this.table.options.persistenceWriterFunc) {
                if (typeof this.table.options.persistenceWriterFunc === "function") this.writeFunc = this.table.options.persistenceWriterFunc;
                else if ($c2a9788f40f9c90a$export$6ce0215a06bec981.writers[this.table.options.persistenceWriterFunc]) this.writeFunc = $c2a9788f40f9c90a$export$6ce0215a06bec981.writers[this.table.options.persistenceWriterFunc];
                else console.warn("Persistence Write Error - invalid reader set", this.table.options.persistenceWriterFunc);
            } else if ($c2a9788f40f9c90a$export$6ce0215a06bec981.writers[this.mode]) this.writeFunc = $c2a9788f40f9c90a$export$6ce0215a06bec981.writers[this.mode];
            else console.warn("Persistence Write Error - invalid writer set", this.mode);
            //set storage tag
            this.id = "tabulator-" + (id || this.table.element.getAttribute("id") || "");
            this.config = {
                sort: this.table.options.persistence === true || this.table.options.persistence.sort,
                filter: this.table.options.persistence === true || this.table.options.persistence.filter,
                headerFilter: this.table.options.persistence === true || this.table.options.persistence.headerFilter,
                group: this.table.options.persistence === true || this.table.options.persistence.group,
                page: this.table.options.persistence === true || this.table.options.persistence.page,
                columns: this.table.options.persistence === true ? [
                    "title",
                    "width",
                    "visible"
                ] : this.table.options.persistence.columns
            };
            //load pagination data if needed
            if (this.config.page) {
                retrievedData = this.retrieveData("page");
                if (retrievedData) {
                    if (typeof retrievedData.paginationSize !== "undefined" && (this.config.page === true || this.config.page.size)) this.table.options.paginationSize = retrievedData.paginationSize;
                    if (typeof retrievedData.paginationInitialPage !== "undefined" && (this.config.page === true || this.config.page.page)) this.table.options.paginationInitialPage = retrievedData.paginationInitialPage;
                }
            }
            //load group data if needed
            if (this.config.group) {
                retrievedData = this.retrieveData("group");
                if (retrievedData) {
                    if (typeof retrievedData.groupBy !== "undefined" && (this.config.group === true || this.config.group.groupBy)) this.table.options.groupBy = retrievedData.groupBy;
                    if (typeof retrievedData.groupStartOpen !== "undefined" && (this.config.group === true || this.config.group.groupStartOpen)) this.table.options.groupStartOpen = retrievedData.groupStartOpen;
                    if (typeof retrievedData.groupHeader !== "undefined" && (this.config.group === true || this.config.group.groupHeader)) this.table.options.groupHeader = retrievedData.groupHeader;
                }
            }
            if (this.config.columns) {
                this.table.options.columns = this.load("columns", this.table.options.columns);
                this.subscribe("column-init", this.initializeColumn.bind(this));
                this.subscribe("column-show", this.save.bind(this, "columns"));
                this.subscribe("column-hide", this.save.bind(this, "columns"));
                this.subscribe("column-moved", this.save.bind(this, "columns"));
            }
            this.subscribe("table-built", this.tableBuilt.bind(this), 0);
            this.subscribe("table-redraw", this.tableRedraw.bind(this));
            this.subscribe("filter-changed", this.eventSave.bind(this, "filter"));
            this.subscribe("filter-changed", this.eventSave.bind(this, "headerFilter"));
            this.subscribe("sort-changed", this.eventSave.bind(this, "sort"));
            this.subscribe("group-changed", this.eventSave.bind(this, "group"));
            this.subscribe("page-changed", this.eventSave.bind(this, "page"));
            this.subscribe("column-resized", this.eventSave.bind(this, "columns"));
            this.subscribe("column-width", this.eventSave.bind(this, "columns"));
            this.subscribe("layout-refreshed", this.eventSave.bind(this, "columns"));
        }
        this.registerTableFunction("getColumnLayout", this.getColumnLayout.bind(this));
        this.registerTableFunction("setColumnLayout", this.setColumnLayout.bind(this));
    }
    eventSave(type) {
        if (this.config[type]) this.save(type);
    }
    tableBuilt() {
        var sorters, filters, headerFilters;
        if (this.config.sort) {
            sorters = this.load("sort");
            if (!sorters === false) this.table.options.initialSort = sorters;
        }
        if (this.config.filter) {
            filters = this.load("filter");
            if (!filters === false) this.table.options.initialFilter = filters;
        }
        if (this.config.headerFilter) {
            headerFilters = this.load("headerFilter");
            if (!headerFilters === false) this.table.options.initialHeaderFilter = headerFilters;
        }
    }
    tableRedraw(force) {
        if (force && this.config.columns) this.save("columns");
    }
    ///////////////////////////////////
    ///////// Table Functions /////////
    ///////////////////////////////////
    getColumnLayout() {
        return this.parseColumns(this.table.columnManager.getColumns());
    }
    setColumnLayout(layout) {
        this.table.columnManager.setColumns(this.mergeDefinition(this.table.options.columns, layout, true));
        return true;
    }
    ///////////////////////////////////
    ///////// Internal Logic //////////
    ///////////////////////////////////
    initializeColumn(column) {
        var def, keys;
        if (this.config.columns) {
            this.defWatcherBlock = true;
            def = column.getDefinition();
            keys = this.config.columns === true ? Object.keys(def) : this.config.columns;
            keys.forEach((key)=>{
                var props = Object.getOwnPropertyDescriptor(def, key);
                var value = def[key];
                if (props) Object.defineProperty(def, key, {
                    set: (newValue)=>{
                        value = newValue;
                        if (!this.defWatcherBlock) this.save("columns");
                        if (props.set) props.set(newValue);
                    },
                    get: ()=>{
                        if (props.get) props.get();
                        return value;
                    }
                });
            });
            this.defWatcherBlock = false;
        }
    }
    //load saved definitions
    load(type, current) {
        var data = this.retrieveData(type);
        if (current) data = data ? this.mergeDefinition(current, data) : current;
        return data;
    }
    //retrieve data from memory
    retrieveData(type) {
        return this.readFunc ? this.readFunc(this.id, type) : false;
    }
    //merge old and new column definitions
    mergeDefinition(oldCols, newCols, mergeAllNew) {
        var output = [];
        newCols = newCols || [];
        newCols.forEach((column, to)=>{
            var from = this._findColumn(oldCols, column), keys;
            if (from) {
                if (mergeAllNew) keys = Object.keys(column);
                else if (this.config.columns === true || this.config.columns == undefined) {
                    keys = Object.keys(from);
                    keys.push("width");
                } else keys = this.config.columns;
                keys.forEach((key)=>{
                    if (key !== "columns" && typeof column[key] !== "undefined") from[key] = column[key];
                });
                if (from.columns) from.columns = this.mergeDefinition(from.columns, column.columns);
                output.push(from);
            }
        });
        oldCols.forEach((column, i)=>{
            var from = this._findColumn(newCols, column);
            if (!from) {
                if (output.length > i) output.splice(i, 0, column);
                else output.push(column);
            }
        });
        return output;
    }
    //find matching columns
    _findColumn(columns, subject) {
        var type = subject.columns ? "group" : subject.field ? "field" : "object";
        return columns.find(function(col) {
            switch(type){
                case "group":
                    return col.title === subject.title && col.columns.length === subject.columns.length;
                case "field":
                    return col.field === subject.field;
                case "object":
                    return col === subject;
            }
        });
    }
    //save data
    save(type) {
        var data = {};
        switch(type){
            case "columns":
                data = this.parseColumns(this.table.columnManager.getColumns());
                break;
            case "filter":
                data = this.table.modules.filter.getFilters();
                break;
            case "headerFilter":
                data = this.table.modules.filter.getHeaderFilters();
                break;
            case "sort":
                data = this.validateSorters(this.table.modules.sort.getSort());
                break;
            case "group":
                data = this.getGroupConfig();
                break;
            case "page":
                data = this.getPageConfig();
                break;
        }
        if (this.writeFunc) this.writeFunc(this.id, type, data);
    }
    //ensure sorters contain no function data
    validateSorters(data) {
        data.forEach(function(item) {
            item.column = item.field;
            delete item.field;
        });
        return data;
    }
    getGroupConfig() {
        var data = {};
        if (this.config.group) {
            if (this.config.group === true || this.config.group.groupBy) data.groupBy = this.table.options.groupBy;
            if (this.config.group === true || this.config.group.groupStartOpen) data.groupStartOpen = this.table.options.groupStartOpen;
            if (this.config.group === true || this.config.group.groupHeader) data.groupHeader = this.table.options.groupHeader;
        }
        return data;
    }
    getPageConfig() {
        var data = {};
        if (this.config.page) {
            if (this.config.page === true || this.config.page.size) data.paginationSize = this.table.modules.page.getPageSize();
            if (this.config.page === true || this.config.page.page) data.paginationInitialPage = this.table.modules.page.getPage();
        }
        return data;
    }
    //parse columns for data to store
    parseColumns(columns) {
        var definitions = [], excludedKeys = [
            "headerContextMenu",
            "headerMenu",
            "contextMenu",
            "clickMenu"
        ];
        columns.forEach((column)=>{
            var defStore = {}, colDef = column.getDefinition(), keys;
            if (column.isGroup) {
                defStore.title = colDef.title;
                defStore.columns = this.parseColumns(column.getColumns());
            } else {
                defStore.field = column.getField();
                if (this.config.columns === true || this.config.columns == undefined) {
                    keys = Object.keys(colDef);
                    keys.push("width");
                    keys.push("visible");
                } else keys = this.config.columns;
                keys.forEach((key)=>{
                    switch(key){
                        case "width":
                            defStore.width = column.getWidth();
                            break;
                        case "visible":
                            defStore.visible = column.visible;
                            break;
                        default:
                            if (typeof colDef[key] !== "function" && excludedKeys.indexOf(key) === -1) defStore[key] = colDef[key];
                    }
                });
            }
            definitions.push(defStore);
        });
        return definitions;
    }
}
class $c2a9788f40f9c90a$export$5a0eb14a9c37d425 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "popup";
    constructor(table){
        super(table);
        this.columnSubscribers = {};
        this.registerTableOption("rowContextPopup", false);
        this.registerTableOption("rowClickPopup", false);
        this.registerTableOption("rowDblClickPopup", false);
        this.registerTableOption("groupContextPopup", false);
        this.registerTableOption("groupClickPopup", false);
        this.registerTableOption("groupDblClickPopup", false);
        this.registerColumnOption("headerContextPopup");
        this.registerColumnOption("headerClickPopup");
        this.registerColumnOption("headerDblClickPopup");
        this.registerColumnOption("headerPopup");
        this.registerColumnOption("headerPopupIcon");
        this.registerColumnOption("contextPopup");
        this.registerColumnOption("clickPopup");
        this.registerColumnOption("dblClickPopup");
        this.registerComponentFunction("cell", "popup", this._componentPopupCall.bind(this));
        this.registerComponentFunction("column", "popup", this._componentPopupCall.bind(this));
        this.registerComponentFunction("row", "popup", this._componentPopupCall.bind(this));
        this.registerComponentFunction("group", "popup", this._componentPopupCall.bind(this));
    }
    initialize() {
        this.initializeRowWatchers();
        this.initializeGroupWatchers();
        this.subscribe("column-init", this.initializeColumn.bind(this));
    }
    _componentPopupCall(component, contents, position) {
        this.loadPopupEvent(contents, null, component, position);
    }
    initializeRowWatchers() {
        if (this.table.options.rowContextPopup) {
            this.subscribe("row-contextmenu", this.loadPopupEvent.bind(this, this.table.options.rowContextPopup));
            this.table.on("rowTapHold", this.loadPopupEvent.bind(this, this.table.options.rowContextPopup));
        }
        if (this.table.options.rowClickPopup) this.subscribe("row-click", this.loadPopupEvent.bind(this, this.table.options.rowClickPopup));
        if (this.table.options.rowDblClickPopup) this.subscribe("row-dblclick", this.loadPopupEvent.bind(this, this.table.options.rowDblClickPopup));
    }
    initializeGroupWatchers() {
        if (this.table.options.groupContextPopup) {
            this.subscribe("group-contextmenu", this.loadPopupEvent.bind(this, this.table.options.groupContextPopup));
            this.table.on("groupTapHold", this.loadPopupEvent.bind(this, this.table.options.groupContextPopup));
        }
        if (this.table.options.groupClickPopup) this.subscribe("group-click", this.loadPopupEvent.bind(this, this.table.options.groupClickPopup));
        if (this.table.options.groupDblClickPopup) this.subscribe("group-dblclick", this.loadPopupEvent.bind(this, this.table.options.groupDblClickPopup));
    }
    initializeColumn(column) {
        var def = column.definition;
        //handle column events
        if (def.headerContextPopup && !this.columnSubscribers.headerContextPopup) {
            this.columnSubscribers.headerContextPopup = this.loadPopupTableColumnEvent.bind(this, "headerContextPopup");
            this.subscribe("column-contextmenu", this.columnSubscribers.headerContextPopup);
            this.table.on("headerTapHold", this.loadPopupTableColumnEvent.bind(this, "headerContextPopup"));
        }
        if (def.headerClickPopup && !this.columnSubscribers.headerClickPopup) {
            this.columnSubscribers.headerClickPopup = this.loadPopupTableColumnEvent.bind(this, "headerClickPopup");
            this.subscribe("column-click", this.columnSubscribers.headerClickPopup);
        }
        if (def.headerDblClickPopup && !this.columnSubscribers.headerDblClickPopup) {
            this.columnSubscribers.headerDblClickPopup = this.loadPopupTableColumnEvent.bind(this, "headerDblClickPopup");
            this.subscribe("column-dblclick", this.columnSubscribers.headerDblClickPopup);
        }
        if (def.headerPopup) this.initializeColumnHeaderPopup(column);
        //handle cell events
        if (def.contextPopup && !this.columnSubscribers.contextPopup) {
            this.columnSubscribers.contextPopup = this.loadPopupTableCellEvent.bind(this, "contextPopup");
            this.subscribe("cell-contextmenu", this.columnSubscribers.contextPopup);
            this.table.on("cellTapHold", this.loadPopupTableCellEvent.bind(this, "contextPopup"));
        }
        if (def.clickPopup && !this.columnSubscribers.clickPopup) {
            this.columnSubscribers.clickPopup = this.loadPopupTableCellEvent.bind(this, "clickPopup");
            this.subscribe("cell-click", this.columnSubscribers.clickPopup);
        }
        if (def.dblClickPopup && !this.columnSubscribers.dblClickPopup) {
            this.columnSubscribers.dblClickPopup = this.loadPopupTableCellEvent.bind(this, "dblClickPopup");
            this.subscribe("cell-click", this.columnSubscribers.dblClickPopup);
        }
    }
    initializeColumnHeaderPopup(column) {
        var icon = column.definition.headerPopupIcon, headerPopupEl;
        headerPopupEl = document.createElement("span");
        headerPopupEl.classList.add("tabulator-header-popup-button");
        if (icon) {
            if (typeof icon === "function") icon = icon(column.getComponent());
            if (icon instanceof HTMLElement) headerPopupEl.appendChild(icon);
            else headerPopupEl.innerHTML = icon;
        } else headerPopupEl.innerHTML = "&vellip;";
        headerPopupEl.addEventListener("click", (e)=>{
            e.stopPropagation();
            e.preventDefault();
            this.loadPopupEvent(column.definition.headerPopup, e, column);
        });
        column.titleElement.insertBefore(headerPopupEl, column.titleElement.firstChild);
    }
    loadPopupTableCellEvent(option, e, cell) {
        if (cell._cell) cell = cell._cell;
        if (cell.column.definition[option]) this.loadPopupEvent(cell.column.definition[option], e, cell);
    }
    loadPopupTableColumnEvent(option, e, column) {
        if (column._column) column = column._column;
        if (column.definition[option]) this.loadPopupEvent(column.definition[option], e, column);
    }
    loadPopupEvent(contents, e, component, position) {
        var renderedCallback;
        function onRendered(callback) {
            renderedCallback = callback;
        }
        if (component._group) component = component._group;
        else if (component._row) component = component._row;
        contents = typeof contents == "function" ? contents.call(this.table, e, component.getComponent(), onRendered) : contents;
        this.loadPopup(e, component, contents, renderedCallback, position);
    }
    loadPopup(e, component, contents, renderedCallback, position) {
        var touch = !(e instanceof MouseEvent), contentsEl, popup;
        if (contents instanceof HTMLElement) contentsEl = contents;
        else {
            contentsEl = document.createElement("div");
            contentsEl.innerHTML = contents;
        }
        contentsEl.classList.add("tabulator-popup");
        contentsEl.addEventListener("click", (e)=>{
            e.stopPropagation();
        });
        if (!touch) e.preventDefault();
        popup = this.popup(contentsEl);
        if (typeof renderedCallback === "function") popup.renderCallback(renderedCallback);
        if (e) popup.show(e);
        else popup.show(component.getElement(), position || "center");
        popup.hideOnBlur(()=>{
            this.dispatchExternal("popupClosed", component.getComponent());
        });
        this.dispatchExternal("popupOpened", component.getComponent());
    }
}
class $c2a9788f40f9c90a$export$94fbe99c03f5a051 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "print";
    constructor(table){
        super(table);
        this.element = false;
        this.manualBlock = false;
        this.beforeprintEventHandler = null;
        this.afterprintEventHandler = null;
        this.registerTableOption("printAsHtml", false); //enable print as html
        this.registerTableOption("printFormatter", false); //printing page formatter
        this.registerTableOption("printHeader", false); //page header contents
        this.registerTableOption("printFooter", false); //page footer contents
        this.registerTableOption("printStyled", true); //enable print as html styling
        this.registerTableOption("printRowRange", "visible"); //restrict print to visible rows only
        this.registerTableOption("printConfig", {}); //print config options
        this.registerColumnOption("print");
        this.registerColumnOption("titlePrint");
    }
    initialize() {
        if (this.table.options.printAsHtml) {
            this.beforeprintEventHandler = this.replaceTable.bind(this);
            this.afterprintEventHandler = this.cleanup.bind(this);
            window.addEventListener("beforeprint", this.beforeprintEventHandler);
            window.addEventListener("afterprint", this.afterprintEventHandler);
            this.subscribe("table-destroy", this.destroy.bind(this));
        }
        this.registerTableFunction("print", this.printFullscreen.bind(this));
    }
    destroy() {
        if (this.table.options.printAsHtml) {
            window.removeEventListener("beforeprint", this.beforeprintEventHandler);
            window.removeEventListener("afterprint", this.afterprintEventHandler);
        }
    }
    ///////////////////////////////////
    ///////// Table Functions /////////
    ///////////////////////////////////
    ///////////////////////////////////
    ///////// Internal Logic //////////
    ///////////////////////////////////
    replaceTable() {
        if (!this.manualBlock) {
            this.element = document.createElement("div");
            this.element.classList.add("tabulator-print-table");
            this.element.appendChild(this.table.modules.export.generateTable(this.table.options.printConfig, this.table.options.printStyled, this.table.options.printRowRange, "print"));
            this.table.element.style.display = "none";
            this.table.element.parentNode.insertBefore(this.element, this.table.element);
        }
    }
    cleanup() {
        document.body.classList.remove("tabulator-print-fullscreen-hide");
        if (this.element && this.element.parentNode) {
            this.element.parentNode.removeChild(this.element);
            this.table.element.style.display = "";
        }
    }
    printFullscreen(visible, style, config) {
        var scrollX = window.scrollX, scrollY = window.scrollY, headerEl = document.createElement("div"), footerEl = document.createElement("div"), tableEl = this.table.modules.export.generateTable(typeof config != "undefined" ? config : this.table.options.printConfig, typeof style != "undefined" ? style : this.table.options.printStyled, visible || this.table.options.printRowRange, "print"), headerContent, footerContent;
        this.manualBlock = true;
        this.element = document.createElement("div");
        this.element.classList.add("tabulator-print-fullscreen");
        if (this.table.options.printHeader) {
            headerEl.classList.add("tabulator-print-header");
            headerContent = typeof this.table.options.printHeader == "function" ? this.table.options.printHeader.call(this.table) : this.table.options.printHeader;
            if (typeof headerContent == "string") headerEl.innerHTML = headerContent;
            else headerEl.appendChild(headerContent);
            this.element.appendChild(headerEl);
        }
        this.element.appendChild(tableEl);
        if (this.table.options.printFooter) {
            footerEl.classList.add("tabulator-print-footer");
            footerContent = typeof this.table.options.printFooter == "function" ? this.table.options.printFooter.call(this.table) : this.table.options.printFooter;
            if (typeof footerContent == "string") footerEl.innerHTML = footerContent;
            else footerEl.appendChild(footerContent);
            this.element.appendChild(footerEl);
        }
        document.body.classList.add("tabulator-print-fullscreen-hide");
        document.body.appendChild(this.element);
        if (this.table.options.printFormatter) this.table.options.printFormatter(this.element, tableEl);
        window.print();
        this.cleanup();
        window.scrollTo(scrollX, scrollY);
        this.manualBlock = false;
    }
}
class $c2a9788f40f9c90a$export$1806fba60a0e8399 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "reactiveData";
    constructor(table){
        super(table);
        this.data = false;
        this.blocked = false; //block reactivity while performing update
        this.origFuncs = {}; // hold original data array functions to allow replacement after data is done with
        this.currentVersion = 0;
        this.registerTableOption("reactiveData", false); //enable data reactivity
    }
    initialize() {
        if (this.table.options.reactiveData) {
            this.subscribe("cell-value-save-before", this.block.bind(this, "cellsave"));
            this.subscribe("cell-value-save-after", this.unblock.bind(this, "cellsave"));
            this.subscribe("row-data-save-before", this.block.bind(this, "rowsave"));
            this.subscribe("row-data-save-after", this.unblock.bind(this, "rowsave"));
            this.subscribe("row-data-init-after", this.watchRow.bind(this));
            this.subscribe("data-processing", this.watchData.bind(this));
            this.subscribe("table-destroy", this.unwatchData.bind(this));
        }
    }
    watchData(data) {
        var self = this, version;
        this.currentVersion++;
        version = this.currentVersion;
        this.unwatchData();
        this.data = data;
        //override array push function
        this.origFuncs.push = data.push;
        Object.defineProperty(this.data, "push", {
            enumerable: false,
            configurable: true,
            value: function() {
                var args = Array.from(arguments), result;
                if (!self.blocked && version === self.currentVersion) {
                    self.block("data-push");
                    args.forEach((arg)=>{
                        self.table.rowManager.addRowActual(arg, false);
                    });
                    result = self.origFuncs.push.apply(data, arguments);
                    self.unblock("data-push");
                }
                return result;
            }
        });
        //override array unshift function
        this.origFuncs.unshift = data.unshift;
        Object.defineProperty(this.data, "unshift", {
            enumerable: false,
            configurable: true,
            value: function() {
                var args = Array.from(arguments), result;
                if (!self.blocked && version === self.currentVersion) {
                    self.block("data-unshift");
                    args.forEach((arg)=>{
                        self.table.rowManager.addRowActual(arg, true);
                    });
                    result = self.origFuncs.unshift.apply(data, arguments);
                    self.unblock("data-unshift");
                }
                return result;
            }
        });
        //override array shift function
        this.origFuncs.shift = data.shift;
        Object.defineProperty(this.data, "shift", {
            enumerable: false,
            configurable: true,
            value: function() {
                var row, result;
                if (!self.blocked && version === self.currentVersion) {
                    self.block("data-shift");
                    if (self.data.length) {
                        row = self.table.rowManager.getRowFromDataObject(self.data[0]);
                        if (row) row.deleteActual();
                    }
                    result = self.origFuncs.shift.call(data);
                    self.unblock("data-shift");
                }
                return result;
            }
        });
        //override array pop function
        this.origFuncs.pop = data.pop;
        Object.defineProperty(this.data, "pop", {
            enumerable: false,
            configurable: true,
            value: function() {
                var row, result;
                if (!self.blocked && version === self.currentVersion) {
                    self.block("data-pop");
                    if (self.data.length) {
                        row = self.table.rowManager.getRowFromDataObject(self.data[self.data.length - 1]);
                        if (row) row.deleteActual();
                    }
                    result = self.origFuncs.pop.call(data);
                    self.unblock("data-pop");
                }
                return result;
            }
        });
        //override array splice function
        this.origFuncs.splice = data.splice;
        Object.defineProperty(this.data, "splice", {
            enumerable: false,
            configurable: true,
            value: function() {
                var args = Array.from(arguments), start = args[0] < 0 ? data.length + args[0] : args[0], end = args[1], newRows = args[2] ? args.slice(2) : false, startRow, result;
                if (!self.blocked && version === self.currentVersion) {
                    self.block("data-splice");
                    //add new rows
                    if (newRows) {
                        startRow = data[start] ? self.table.rowManager.getRowFromDataObject(data[start]) : false;
                        if (startRow) newRows.forEach((rowData)=>{
                            self.table.rowManager.addRowActual(rowData, true, startRow, true);
                        });
                        else {
                            newRows = newRows.slice().reverse();
                            newRows.forEach((rowData)=>{
                                self.table.rowManager.addRowActual(rowData, true, false, true);
                            });
                        }
                    }
                    //delete removed rows
                    if (end !== 0) {
                        var oldRows = data.slice(start, typeof args[1] === "undefined" ? args[1] : start + end);
                        oldRows.forEach((rowData, i)=>{
                            var row = self.table.rowManager.getRowFromDataObject(rowData);
                            if (row) row.deleteActual(i !== oldRows.length - 1);
                        });
                    }
                    if (newRows || end !== 0) self.table.rowManager.reRenderInPosition();
                    result = self.origFuncs.splice.apply(data, arguments);
                    self.unblock("data-splice");
                }
                return result;
            }
        });
    }
    unwatchData() {
        if (this.data !== false) for(var key in this.origFuncs)Object.defineProperty(this.data, key, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: this.origFuncs.key
        });
    }
    watchRow(row) {
        var data = row.getData();
        for(var key in data)this.watchKey(row, data, key);
        if (this.table.options.dataTree) this.watchTreeChildren(row);
    }
    watchTreeChildren(row) {
        var self = this, childField = row.getData()[this.table.options.dataTreeChildField], origFuncs = {};
        if (childField) {
            origFuncs.push = childField.push;
            Object.defineProperty(childField, "push", {
                enumerable: false,
                configurable: true,
                value: ()=>{
                    if (!self.blocked) {
                        self.block("tree-push");
                        var result = origFuncs.push.apply(childField, arguments);
                        this.rebuildTree(row);
                        self.unblock("tree-push");
                    }
                    return result;
                }
            });
            origFuncs.unshift = childField.unshift;
            Object.defineProperty(childField, "unshift", {
                enumerable: false,
                configurable: true,
                value: ()=>{
                    if (!self.blocked) {
                        self.block("tree-unshift");
                        var result = origFuncs.unshift.apply(childField, arguments);
                        this.rebuildTree(row);
                        self.unblock("tree-unshift");
                    }
                    return result;
                }
            });
            origFuncs.shift = childField.shift;
            Object.defineProperty(childField, "shift", {
                enumerable: false,
                configurable: true,
                value: ()=>{
                    if (!self.blocked) {
                        self.block("tree-shift");
                        var result = origFuncs.shift.call(childField);
                        this.rebuildTree(row);
                        self.unblock("tree-shift");
                    }
                    return result;
                }
            });
            origFuncs.pop = childField.pop;
            Object.defineProperty(childField, "pop", {
                enumerable: false,
                configurable: true,
                value: ()=>{
                    if (!self.blocked) {
                        self.block("tree-pop");
                        var result = origFuncs.pop.call(childField);
                        this.rebuildTree(row);
                        self.unblock("tree-pop");
                    }
                    return result;
                }
            });
            origFuncs.splice = childField.splice;
            Object.defineProperty(childField, "splice", {
                enumerable: false,
                configurable: true,
                value: ()=>{
                    if (!self.blocked) {
                        self.block("tree-splice");
                        var result = origFuncs.splice.apply(childField, arguments);
                        this.rebuildTree(row);
                        self.unblock("tree-splice");
                    }
                    return result;
                }
            });
        }
    }
    rebuildTree(row) {
        this.table.modules.dataTree.initializeRow(row);
        this.table.modules.dataTree.layoutRow(row);
        this.table.rowManager.refreshActiveData("tree", false, true);
    }
    watchKey(row, data, key) {
        var self = this, props = Object.getOwnPropertyDescriptor(data, key), value = data[key], version = this.currentVersion;
        Object.defineProperty(data, key, {
            set: (newValue)=>{
                value = newValue;
                if (!self.blocked && version === self.currentVersion) {
                    self.block("key");
                    var update = {};
                    update[key] = newValue;
                    row.updateData(update);
                    self.unblock("key");
                }
                if (props.set) props.set(newValue);
            },
            get: ()=>{
                if (props.get) props.get();
                return value;
            }
        });
    }
    unwatchRow(row) {
        var data = row.getData();
        for(var key in data)Object.defineProperty(data, key, {
            value: data[key]
        });
    }
    block(key) {
        if (!this.blocked) this.blocked = key;
    }
    unblock(key) {
        if (this.blocked === key) this.blocked = false;
    }
}
class $c2a9788f40f9c90a$export$3a1ca422b395df54 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "resizeColumns";
    constructor(table){
        super(table);
        this.startColumn = false;
        this.startX = false;
        this.startWidth = false;
        this.latestX = false;
        this.handle = null;
        this.initialNextColumn = null;
        this.nextColumn = null;
        this.initialized = false;
        this.registerColumnOption("resizable", true);
        this.registerTableOption("resizableColumnFit", false);
        this.registerTableOption("resizableColumnGuide", false);
    }
    initialize() {
        this.subscribe("column-rendered", this.layoutColumnHeader.bind(this));
    }
    initializeEventWatchers() {
        if (!this.initialized) {
            this.subscribe("cell-rendered", this.layoutCellHandles.bind(this));
            this.subscribe("cell-delete", this.deInitializeComponent.bind(this));
            this.subscribe("cell-height", this.resizeHandle.bind(this));
            this.subscribe("column-moved", this.columnLayoutUpdated.bind(this));
            this.subscribe("column-hide", this.deInitializeColumn.bind(this));
            this.subscribe("column-show", this.columnLayoutUpdated.bind(this));
            this.subscribe("column-width", this.columnWidthUpdated.bind(this));
            this.subscribe("column-delete", this.deInitializeComponent.bind(this));
            this.subscribe("column-height", this.resizeHandle.bind(this));
            this.initialized = true;
        }
    }
    layoutCellHandles(cell) {
        if (cell.row.type === "row") {
            this.deInitializeComponent(cell);
            this.initializeColumn("cell", cell, cell.column, cell.element);
        }
    }
    layoutColumnHeader(column) {
        if (column.definition.resizable) {
            this.initializeEventWatchers();
            this.deInitializeComponent(column);
            this.initializeColumn("header", column, column, column.element);
        }
    }
    columnLayoutUpdated(column) {
        var prev = column.prevColumn();
        this.reinitializeColumn(column);
        if (prev) this.reinitializeColumn(prev);
    }
    columnWidthUpdated(column) {
        if (column.modules.frozen) {
            if (this.table.modules.frozenColumns.leftColumns.includes(column)) this.table.modules.frozenColumns.leftColumns.forEach((col)=>{
                this.reinitializeColumn(col);
            });
            else if (this.table.modules.frozenColumns.rightColumns.includes(column)) this.table.modules.frozenColumns.rightColumns.forEach((col)=>{
                this.reinitializeColumn(col);
            });
        }
    }
    frozenColumnOffset(column) {
        var offset = false;
        if (column.modules.frozen) {
            offset = column.modules.frozen.marginValue;
            if (column.modules.frozen.position === "left") offset += column.getWidth() - 3;
            else if (offset) offset -= 3;
        }
        return offset !== false ? offset + "px" : false;
    }
    reinitializeColumn(column) {
        var frozenOffset = this.frozenColumnOffset(column);
        column.cells.forEach((cell)=>{
            if (cell.modules.resize && cell.modules.resize.handleEl) {
                if (frozenOffset) {
                    cell.modules.resize.handleEl.style[column.modules.frozen.position] = frozenOffset;
                    cell.modules.resize.handleEl.style["z-index"] = 11;
                }
                cell.element.after(cell.modules.resize.handleEl);
            }
        });
        if (column.modules.resize && column.modules.resize.handleEl) {
            if (frozenOffset) column.modules.resize.handleEl.style[column.modules.frozen.position] = frozenOffset;
            column.element.after(column.modules.resize.handleEl);
        }
    }
    initializeColumn(type, component, column, element) {
        var self = this, variableHeight = false, mode = column.definition.resizable, config = {}, nearestColumn = column.getLastColumn();
        //set column resize mode
        if (type === "header") {
            variableHeight = column.definition.formatter == "textarea" || column.definition.variableHeight;
            config = {
                variableHeight: variableHeight
            };
        }
        if ((mode === true || mode == type) && this._checkResizability(nearestColumn)) {
            var handle = document.createElement('span');
            handle.className = "tabulator-col-resize-handle";
            handle.addEventListener("click", function(e) {
                e.stopPropagation();
            });
            var handleDown = function(e) {
                self.startColumn = column;
                self.initialNextColumn = self.nextColumn = nearestColumn.nextColumn();
                self._mouseDown(e, nearestColumn, handle);
            };
            handle.addEventListener("mousedown", handleDown);
            handle.addEventListener("touchstart", handleDown, {
                passive: true
            });
            //resize column on  double click
            handle.addEventListener("dblclick", (e)=>{
                var oldWidth = nearestColumn.getWidth();
                e.stopPropagation();
                nearestColumn.reinitializeWidth(true);
                if (oldWidth !== nearestColumn.getWidth()) {
                    self.dispatch("column-resized", nearestColumn);
                    self.dispatchExternal("columnResized", nearestColumn.getComponent());
                }
            });
            if (column.modules.frozen) {
                handle.style.position = "sticky";
                handle.style[column.modules.frozen.position] = this.frozenColumnOffset(column);
            }
            config.handleEl = handle;
            if (element.parentNode && column.visible) element.after(handle);
        }
        component.modules.resize = config;
    }
    deInitializeColumn(column) {
        this.deInitializeComponent(column);
        column.cells.forEach((cell)=>{
            this.deInitializeComponent(cell);
        });
    }
    deInitializeComponent(component) {
        var handleEl;
        if (component.modules.resize) {
            handleEl = component.modules.resize.handleEl;
            if (handleEl && handleEl.parentElement) handleEl.parentElement.removeChild(handleEl);
        }
    }
    resizeHandle(component, height) {
        if (component.modules.resize && component.modules.resize.handleEl) component.modules.resize.handleEl.style.height = height;
    }
    resize(e, column) {
        var x = typeof e.clientX === "undefined" ? e.touches[0].clientX : e.clientX, startDiff = x - this.startX, moveDiff = x - this.latestX, blockedBefore, blockedAfter;
        this.latestX = x;
        if (this.table.rtl) {
            startDiff = -startDiff;
            moveDiff = -moveDiff;
        }
        blockedBefore = column.width == column.minWidth || column.width == column.maxWidth;
        column.setWidth(this.startWidth + startDiff);
        blockedAfter = column.width == column.minWidth || column.width == column.maxWidth;
        if (moveDiff < 0) this.nextColumn = this.initialNextColumn;
        if (this.table.options.resizableColumnFit && this.nextColumn && !(blockedBefore && blockedAfter)) {
            let colWidth = this.nextColumn.getWidth();
            if (moveDiff > 0) {
                if (colWidth <= this.nextColumn.minWidth) this.nextColumn = this.nextColumn.nextColumn();
            }
            if (this.nextColumn) this.nextColumn.setWidth(this.nextColumn.getWidth() - moveDiff);
        }
        this.table.columnManager.rerenderColumns(true);
        if (!this.table.browserSlow && column.modules.resize && column.modules.resize.variableHeight) column.checkCellHeights();
    }
    calcGuidePosition(e, column, handle) {
        var mouseX = typeof e.clientX === "undefined" ? e.touches[0].clientX : e.clientX, handleX = handle.getBoundingClientRect().x - this.table.element.getBoundingClientRect().x, tableX = this.table.element.getBoundingClientRect().x, columnX = column.element.getBoundingClientRect().left - tableX, mouseDiff = mouseX - this.startX, pos = Math.max(handleX + mouseDiff, columnX + column.minWidth);
        if (column.maxWidth) pos = Math.min(pos, columnX + column.maxWidth);
        return pos;
    }
    _checkResizability(column) {
        return column.definition.resizable;
    }
    _mouseDown(e, column, handle) {
        var self = this, guideEl;
        this.dispatchExternal("columnResizing", column.getComponent());
        if (self.table.options.resizableColumnGuide) {
            guideEl = document.createElement("span");
            guideEl.classList.add('tabulator-col-resize-guide');
            self.table.element.appendChild(guideEl);
            setTimeout(()=>{
                guideEl.style.left = self.calcGuidePosition(e, column, handle) + "px";
            });
        }
        self.table.element.classList.add("tabulator-block-select");
        function mouseMove(e) {
            if (self.table.options.resizableColumnGuide) guideEl.style.left = self.calcGuidePosition(e, column, handle) + "px";
            else self.resize(e, column);
        }
        function mouseUp(e) {
            if (self.table.options.resizableColumnGuide) {
                self.resize(e, column);
                guideEl.remove();
            }
            //block editor from taking action while resizing is taking place
            if (self.startColumn.modules.edit) self.startColumn.modules.edit.blocked = false;
            if (self.table.browserSlow && column.modules.resize && column.modules.resize.variableHeight) column.checkCellHeights();
            document.body.removeEventListener("mouseup", mouseUp);
            document.body.removeEventListener("mousemove", mouseMove);
            handle.removeEventListener("touchmove", mouseMove);
            handle.removeEventListener("touchend", mouseUp);
            self.table.element.classList.remove("tabulator-block-select");
            if (self.startWidth !== column.getWidth()) {
                self.table.columnManager.verticalAlignHeaders();
                self.dispatch("column-resized", column);
                self.dispatchExternal("columnResized", column.getComponent());
            }
        }
        e.stopPropagation(); //prevent resize from interfering with movable columns
        //block editor from taking action while resizing is taking place
        if (self.startColumn.modules.edit) self.startColumn.modules.edit.blocked = true;
        self.startX = typeof e.clientX === "undefined" ? e.touches[0].clientX : e.clientX;
        self.latestX = self.startX;
        self.startWidth = column.getWidth();
        document.body.addEventListener("mousemove", mouseMove);
        document.body.addEventListener("mouseup", mouseUp);
        handle.addEventListener("touchmove", mouseMove, {
            passive: true
        });
        handle.addEventListener("touchend", mouseUp);
    }
}
class $c2a9788f40f9c90a$export$5651a6c35bd86023 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "resizeRows";
    constructor(table){
        super(table);
        this.startColumn = false;
        this.startY = false;
        this.startHeight = false;
        this.handle = null;
        this.prevHandle = null;
        this.registerTableOption("resizableRows", false); //resizable rows
        this.registerTableOption("resizableRowGuide", false);
    }
    initialize() {
        if (this.table.options.resizableRows) this.subscribe("row-layout-after", this.initializeRow.bind(this));
    }
    initializeRow(row) {
        var self = this, rowEl = row.getElement();
        var handle = document.createElement('div');
        handle.className = "tabulator-row-resize-handle";
        var prevHandle = document.createElement('div');
        prevHandle.className = "tabulator-row-resize-handle prev";
        handle.addEventListener("click", function(e) {
            e.stopPropagation();
        });
        var handleDown = function(e) {
            self.startRow = row;
            self._mouseDown(e, row, handle);
        };
        handle.addEventListener("mousedown", handleDown);
        handle.addEventListener("touchstart", handleDown, {
            passive: true
        });
        prevHandle.addEventListener("click", function(e) {
            e.stopPropagation();
        });
        var prevHandleDown = function(e) {
            var prevRow = self.table.rowManager.prevDisplayRow(row);
            if (prevRow) {
                self.startRow = prevRow;
                self._mouseDown(e, prevRow, prevHandle);
            }
        };
        prevHandle.addEventListener("mousedown", prevHandleDown);
        prevHandle.addEventListener("touchstart", prevHandleDown, {
            passive: true
        });
        rowEl.appendChild(handle);
        rowEl.appendChild(prevHandle);
    }
    resize(e, row) {
        row.setHeight(this.startHeight + ((typeof e.screenY === "undefined" ? e.touches[0].screenY : e.screenY) - this.startY));
    }
    calcGuidePosition(e, row, handle) {
        var mouseY = typeof e.screenY === "undefined" ? e.touches[0].screenY : e.screenY, handleY = handle.getBoundingClientRect().y - this.table.element.getBoundingClientRect().y, tableY = this.table.element.getBoundingClientRect().y, rowY = row.element.getBoundingClientRect().top - tableY, mouseDiff = mouseY - this.startY;
        return Math.max(handleY + mouseDiff, rowY);
    }
    _mouseDown(e, row, handle) {
        var self = this, guideEl;
        self.dispatchExternal("rowResizing", row.getComponent());
        if (self.table.options.resizableRowGuide) {
            guideEl = document.createElement("span");
            guideEl.classList.add('tabulator-row-resize-guide');
            self.table.element.appendChild(guideEl);
            setTimeout(()=>{
                guideEl.style.top = self.calcGuidePosition(e, row, handle) + "px";
            });
        }
        self.table.element.classList.add("tabulator-block-select");
        function mouseMove(e) {
            if (self.table.options.resizableRowGuide) guideEl.style.top = self.calcGuidePosition(e, row, handle) + "px";
            else self.resize(e, row);
        }
        function mouseUp(e) {
            if (self.table.options.resizableRowGuide) {
                self.resize(e, row);
                guideEl.remove();
            }
            // //block editor from taking action while resizing is taking place
            // if(self.startColumn.modules.edit){
            // 	self.startColumn.modules.edit.blocked = false;
            // }
            document.body.removeEventListener("mouseup", mouseMove);
            document.body.removeEventListener("mousemove", mouseMove);
            handle.removeEventListener("touchmove", mouseMove);
            handle.removeEventListener("touchend", mouseUp);
            self.table.element.classList.remove("tabulator-block-select");
            self.dispatchExternal("rowResized", row.getComponent());
        }
        e.stopPropagation(); //prevent resize from interfering with movable columns
        //block editor from taking action while resizing is taking place
        // if(self.startColumn.modules.edit){
        // 	self.startColumn.modules.edit.blocked = true;
        // }
        self.startY = typeof e.screenY === "undefined" ? e.touches[0].screenY : e.screenY;
        self.startHeight = row.getHeight();
        document.body.addEventListener("mousemove", mouseMove);
        document.body.addEventListener("mouseup", mouseUp);
        handle.addEventListener("touchmove", mouseMove, {
            passive: true
        });
        handle.addEventListener("touchend", mouseUp);
    }
}
class $c2a9788f40f9c90a$export$977e646a85a63aba extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "resizeTable";
    constructor(table){
        super(table);
        this.binding = false;
        this.visibilityObserver = false;
        this.resizeObserver = false;
        this.containerObserver = false;
        this.tableHeight = 0;
        this.tableWidth = 0;
        this.containerHeight = 0;
        this.containerWidth = 0;
        this.autoResize = false;
        this.visible = false;
        this.initialized = false;
        this.initialRedraw = false;
        this.registerTableOption("autoResize", true); //auto resize table
    }
    initialize() {
        if (this.table.options.autoResize) {
            var table = this.table, tableStyle;
            this.tableHeight = table.element.clientHeight;
            this.tableWidth = table.element.clientWidth;
            if (table.element.parentNode) {
                this.containerHeight = table.element.parentNode.clientHeight;
                this.containerWidth = table.element.parentNode.clientWidth;
            }
            if (typeof IntersectionObserver !== "undefined" && typeof ResizeObserver !== "undefined" && table.rowManager.getRenderMode() === "virtual") {
                this.initializeVisibilityObserver();
                this.autoResize = true;
                this.resizeObserver = new ResizeObserver((entry)=>{
                    if (!table.browserMobile || table.browserMobile && (!table.modules.edit || table.modules.edit && !table.modules.edit.currentCell)) {
                        var nodeHeight = Math.floor(entry[0].contentRect.height);
                        var nodeWidth = Math.floor(entry[0].contentRect.width);
                        if (this.tableHeight != nodeHeight || this.tableWidth != nodeWidth) {
                            this.tableHeight = nodeHeight;
                            this.tableWidth = nodeWidth;
                            if (table.element.parentNode) {
                                this.containerHeight = table.element.parentNode.clientHeight;
                                this.containerWidth = table.element.parentNode.clientWidth;
                            }
                            this.redrawTable();
                        }
                    }
                });
                this.resizeObserver.observe(table.element);
                tableStyle = window.getComputedStyle(table.element);
                if (this.table.element.parentNode && !this.table.rowManager.fixedHeight && (tableStyle.getPropertyValue("max-height") || tableStyle.getPropertyValue("min-height"))) {
                    this.containerObserver = new ResizeObserver((entry)=>{
                        if (!table.browserMobile || table.browserMobile && (!table.modules.edit || table.modules.edit && !table.modules.edit.currentCell)) {
                            var nodeHeight = Math.floor(entry[0].contentRect.height);
                            var nodeWidth = Math.floor(entry[0].contentRect.width);
                            if (this.containerHeight != nodeHeight || this.containerWidth != nodeWidth) {
                                this.containerHeight = nodeHeight;
                                this.containerWidth = nodeWidth;
                                this.tableHeight = table.element.clientHeight;
                                this.tableWidth = table.element.clientWidth;
                            }
                            this.redrawTable();
                        }
                    });
                    this.containerObserver.observe(this.table.element.parentNode);
                }
                this.subscribe("table-resize", this.tableResized.bind(this));
            } else {
                this.binding = function() {
                    if (!table.browserMobile || table.browserMobile && (!table.modules.edit || table.modules.edit && !table.modules.edit.currentCell)) {
                        table.columnManager.rerenderColumns(true);
                        table.redraw();
                    }
                };
                window.addEventListener("resize", this.binding);
            }
            this.subscribe("table-destroy", this.clearBindings.bind(this));
        }
    }
    initializeVisibilityObserver() {
        this.visibilityObserver = new IntersectionObserver((entries)=>{
            this.visible = entries[0].isIntersecting;
            if (!this.initialized) {
                this.initialized = true;
                this.initialRedraw = !this.visible;
            } else if (this.visible) {
                this.redrawTable(this.initialRedraw);
                this.initialRedraw = false;
            }
        });
        this.visibilityObserver.observe(this.table.element);
    }
    redrawTable(force) {
        if (this.initialized && this.visible) {
            this.table.columnManager.rerenderColumns(true);
            this.table.redraw(force);
        }
    }
    tableResized() {
        this.table.rowManager.redraw();
    }
    clearBindings() {
        if (this.binding) window.removeEventListener("resize", this.binding);
        if (this.resizeObserver) this.resizeObserver.unobserve(this.table.element);
        if (this.visibilityObserver) this.visibilityObserver.unobserve(this.table.element);
        if (this.containerObserver) this.containerObserver.unobserve(this.table.element.parentNode);
    }
}
function $c2a9788f40f9c90a$var$responsiveCollapse(cell, formatterParams, onRendered) {
    var el = document.createElement("div"), config = cell.getRow()._row.modules.responsiveLayout;
    el.classList.add("tabulator-responsive-collapse-toggle");
    el.innerHTML = `<svg class='tabulator-responsive-collapse-toggle-open' viewbox="0 0 24 24">
  <line x1="7" y1="12" x2="17" y2="12" fill="none" stroke-width="3" stroke-linecap="round" />
  <line y1="7" x1="12" y2="17" x2="12" fill="none" stroke-width="3" stroke-linecap="round" />
</svg>

<svg class='tabulator-responsive-collapse-toggle-close' viewbox="0 0 24 24">
  <line x1="7" y1="12" x2="17" y2="12"  fill="none" stroke-width="3" stroke-linecap="round" />
</svg>`;
    cell.getElement().classList.add("tabulator-row-handle");
    function toggleList(isOpen) {
        var collapseEl = config.element;
        config.open = isOpen;
        if (collapseEl) {
            if (config.open) {
                el.classList.add("open");
                collapseEl.style.display = '';
            } else {
                el.classList.remove("open");
                collapseEl.style.display = 'none';
            }
        }
    }
    el.addEventListener("click", function(e) {
        e.stopImmediatePropagation();
        toggleList(!config.open);
        cell.getTable().rowManager.adjustTableSize();
    });
    toggleList(config.open);
    return el;
}
var $c2a9788f40f9c90a$var$extensions$2 = {
    format: {
        formatters: {
            responsiveCollapse: $c2a9788f40f9c90a$var$responsiveCollapse
        }
    }
};
class $c2a9788f40f9c90a$export$cc8706005768c818 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "responsiveLayout";
    static moduleExtensions = $c2a9788f40f9c90a$var$extensions$2;
    constructor(table){
        super(table);
        this.columns = [];
        this.hiddenColumns = [];
        this.mode = "";
        this.index = 0;
        this.collapseFormatter = [];
        this.collapseStartOpen = true;
        this.collapseHandleColumn = false;
        this.registerTableOption("responsiveLayout", false); //responsive layout flags
        this.registerTableOption("responsiveLayoutCollapseStartOpen", true); //start showing collapsed data
        this.registerTableOption("responsiveLayoutCollapseUseFormatters", true); //responsive layout collapse formatter
        this.registerTableOption("responsiveLayoutCollapseFormatter", false); //responsive layout collapse formatter
        this.registerColumnOption("responsive");
    }
    //generate responsive columns list
    initialize() {
        if (this.table.options.responsiveLayout) {
            this.subscribe("column-layout", this.initializeColumn.bind(this));
            this.subscribe("column-show", this.updateColumnVisibility.bind(this));
            this.subscribe("column-hide", this.updateColumnVisibility.bind(this));
            this.subscribe("columns-loaded", this.initializeResponsivity.bind(this));
            this.subscribe("column-moved", this.initializeResponsivity.bind(this));
            this.subscribe("column-add", this.initializeResponsivity.bind(this));
            this.subscribe("column-delete", this.initializeResponsivity.bind(this));
            this.subscribe("table-redrawing", this.tableRedraw.bind(this));
            if (this.table.options.responsiveLayout === "collapse") {
                this.subscribe("row-data-changed", this.generateCollapsedRowContent.bind(this));
                this.subscribe("row-init", this.initializeRow.bind(this));
                this.subscribe("row-layout", this.layoutRow.bind(this));
            }
        }
    }
    tableRedraw(force) {
        if ([
            "fitColumns",
            "fitDataStretch"
        ].indexOf(this.layoutMode()) === -1) {
            if (!force) this.update();
        }
    }
    initializeResponsivity() {
        var columns = [];
        this.mode = this.table.options.responsiveLayout;
        this.collapseFormatter = this.table.options.responsiveLayoutCollapseFormatter || this.formatCollapsedData;
        this.collapseStartOpen = this.table.options.responsiveLayoutCollapseStartOpen;
        this.hiddenColumns = [];
        if (this.collapseFormatter) this.collapseFormatter = this.collapseFormatter.bind(this.table);
        //determine level of responsivity for each column
        this.table.columnManager.columnsByIndex.forEach((column, i)=>{
            if (column.modules.responsive) {
                if (column.modules.responsive.order && column.modules.responsive.visible) {
                    column.modules.responsive.index = i;
                    columns.push(column);
                    if (!column.visible && this.mode === "collapse") this.hiddenColumns.push(column);
                }
            }
        });
        //sort list by responsivity
        columns = columns.reverse();
        columns = columns.sort((a, b)=>{
            var diff = b.modules.responsive.order - a.modules.responsive.order;
            return diff || b.modules.responsive.index - a.modules.responsive.index;
        });
        this.columns = columns;
        if (this.mode === "collapse") this.generateCollapsedContent();
        //assign collapse column
        for (let col of this.table.columnManager.columnsByIndex)if (col.definition.formatter == "responsiveCollapse") {
            this.collapseHandleColumn = col;
            break;
        }
        if (this.collapseHandleColumn) {
            if (this.hiddenColumns.length) this.collapseHandleColumn.show();
            else this.collapseHandleColumn.hide();
        }
    }
    //define layout information
    initializeColumn(column) {
        var def = column.getDefinition();
        column.modules.responsive = {
            order: typeof def.responsive === "undefined" ? 1 : def.responsive,
            visible: def.visible === false ? false : true
        };
    }
    initializeRow(row) {
        var el;
        if (row.type !== "calc") {
            el = document.createElement("div");
            el.classList.add("tabulator-responsive-collapse");
            row.modules.responsiveLayout = {
                element: el,
                open: this.collapseStartOpen
            };
            if (!this.collapseStartOpen) el.style.display = 'none';
        }
    }
    layoutRow(row) {
        var rowEl = row.getElement();
        if (row.modules.responsiveLayout) {
            rowEl.appendChild(row.modules.responsiveLayout.element);
            this.generateCollapsedRowContent(row);
        }
    }
    //update column visibility
    updateColumnVisibility(column, responsiveToggle) {
        if (!responsiveToggle && column.modules.responsive) {
            column.modules.responsive.visible = column.visible;
            this.initializeResponsivity();
        }
    }
    hideColumn(column) {
        var colCount = this.hiddenColumns.length;
        column.hide(false, true);
        if (this.mode === "collapse") {
            this.hiddenColumns.unshift(column);
            this.generateCollapsedContent();
            if (this.collapseHandleColumn && !colCount) this.collapseHandleColumn.show();
        }
    }
    showColumn(column) {
        var index;
        column.show(false, true);
        //set column width to prevent calculation loops on uninitialized columns
        column.setWidth(column.getWidth());
        if (this.mode === "collapse") {
            index = this.hiddenColumns.indexOf(column);
            if (index > -1) this.hiddenColumns.splice(index, 1);
            this.generateCollapsedContent();
            if (this.collapseHandleColumn && !this.hiddenColumns.length) this.collapseHandleColumn.hide();
        }
    }
    //redraw columns to fit space
    update() {
        var working = true;
        while(working){
            let width = this.table.modules.layout.getMode() == "fitColumns" ? this.table.columnManager.getFlexBaseWidth() : this.table.columnManager.getWidth();
            let diff = (this.table.options.headerVisible ? this.table.columnManager.element.clientWidth : this.table.element.clientWidth) - width;
            if (diff < 0) {
                //table is too wide
                let column = this.columns[this.index];
                if (column) {
                    this.hideColumn(column);
                    this.index++;
                } else working = false;
            } else {
                //table has spare space
                let column = this.columns[this.index - 1];
                if (column) {
                    if (diff > 0) {
                        if (diff >= column.getWidth()) {
                            this.showColumn(column);
                            this.index--;
                        } else working = false;
                    } else working = false;
                } else working = false;
            }
            if (!this.table.rowManager.activeRowsCount) this.table.rowManager.renderEmptyScroll();
        }
    }
    generateCollapsedContent() {
        var rows = this.table.rowManager.getDisplayRows();
        rows.forEach((row)=>{
            this.generateCollapsedRowContent(row);
        });
    }
    generateCollapsedRowContent(row) {
        var el, contents;
        if (row.modules.responsiveLayout) {
            el = row.modules.responsiveLayout.element;
            while(el.firstChild)el.removeChild(el.firstChild);
            contents = this.collapseFormatter(this.generateCollapsedRowData(row));
            if (contents) el.appendChild(contents);
            row.calcHeight(true);
        }
    }
    generateCollapsedRowData(row) {
        var data = row.getData(), output = [], mockCellComponent;
        this.hiddenColumns.forEach((column)=>{
            var value = column.getFieldValue(data);
            if (column.definition.title && column.field) {
                if (column.modules.format && this.table.options.responsiveLayoutCollapseUseFormatters) {
                    mockCellComponent = {
                        value: false,
                        data: {},
                        getValue: function() {
                            return value;
                        },
                        getData: function() {
                            return data;
                        },
                        getType: function() {
                            return "cell";
                        },
                        getElement: function() {
                            return document.createElement("div");
                        },
                        getRow: function() {
                            return row.getComponent();
                        },
                        getColumn: function() {
                            return column.getComponent();
                        },
                        getTable: ()=>{
                            return this.table;
                        }
                    };
                    function onRendered(callback) {
                        callback();
                    }
                    output.push({
                        field: column.field,
                        title: column.definition.title,
                        value: column.modules.format.formatter.call(this.table.modules.format, mockCellComponent, column.modules.format.params, onRendered)
                    });
                } else output.push({
                    field: column.field,
                    title: column.definition.title,
                    value: value
                });
            }
        });
        return output;
    }
    formatCollapsedData(data) {
        var list = document.createElement("table");
        data.forEach((item)=>{
            var row = document.createElement("tr");
            var titleData = document.createElement("td");
            var valueData = document.createElement("td");
            var node_content;
            var titleHighlight = document.createElement("strong");
            titleData.appendChild(titleHighlight);
            this.modules.localize.bind("columns|" + item.field, function(text) {
                titleHighlight.innerHTML = text || item.title;
            });
            if (item.value instanceof Node) {
                node_content = document.createElement("div");
                node_content.appendChild(item.value);
                valueData.appendChild(node_content);
            } else valueData.innerHTML = item.value;
            row.appendChild(titleData);
            row.appendChild(valueData);
            list.appendChild(row);
        });
        return Object.keys(data).length ? list : "";
    }
}
function $c2a9788f40f9c90a$var$rowSelection(cell, formatterParams, onRendered) {
    var checkbox = document.createElement("input");
    var blocked = false;
    checkbox.type = 'checkbox';
    checkbox.setAttribute("aria-label", "Select Row");
    if (this.table.modExists("selectRow", true)) {
        checkbox.addEventListener("click", (e)=>{
            e.stopPropagation();
        });
        if (typeof cell.getRow == 'function') {
            var row = cell.getRow();
            if (row instanceof $c2a9788f40f9c90a$export$5df91075f5ba4651) {
                checkbox.addEventListener("change", (e)=>{
                    if (this.table.options.selectableRowsRangeMode === "click") {
                        if (!blocked) row.toggleSelect();
                        else blocked = false;
                    } else row.toggleSelect();
                });
                if (this.table.options.selectableRowsRangeMode === "click") checkbox.addEventListener("click", (e)=>{
                    blocked = true;
                    this.table.modules.selectRow.handleComplexRowClick(row._row, e);
                });
                checkbox.checked = row.isSelected && row.isSelected();
                this.table.modules.selectRow.registerRowSelectCheckbox(row, checkbox);
            } else checkbox = "";
        } else {
            checkbox.addEventListener("change", (e)=>{
                if (this.table.modules.selectRow.selectedRows.length) this.table.deselectRow();
                else this.table.selectRow(formatterParams.rowRange);
            });
            this.table.modules.selectRow.registerHeaderSelectCheckbox(checkbox);
        }
    }
    return checkbox;
}
var $c2a9788f40f9c90a$var$extensions$1 = {
    format: {
        formatters: {
            rowSelection: $c2a9788f40f9c90a$var$rowSelection
        }
    }
};
class $c2a9788f40f9c90a$export$2e4fadc5338e55f5 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "selectRow";
    static moduleExtensions = $c2a9788f40f9c90a$var$extensions$1;
    constructor(table){
        super(table);
        this.selecting = false; //flag selecting in progress
        this.lastClickedRow = false; //last clicked row
        this.selectPrev = []; //hold previously selected element for drag drop selection
        this.selectedRows = []; //hold selected rows
        this.headerCheckboxElement = null; // hold header select element
        this.registerTableOption("selectableRows", "highlight"); //highlight rows on hover
        this.registerTableOption("selectableRowsRangeMode", "drag"); //highlight rows on hover
        this.registerTableOption("selectableRowsRollingSelection", true); //roll selection once maximum number of selectable rows is reached
        this.registerTableOption("selectableRowsPersistence", true); // maintain selection when table view is updated
        this.registerTableOption("selectableRowsCheck", function(data, row) {
            return true;
        }); //check whether row is selectable
        this.registerTableFunction("selectRow", this.selectRows.bind(this));
        this.registerTableFunction("deselectRow", this.deselectRows.bind(this));
        this.registerTableFunction("toggleSelectRow", this.toggleRow.bind(this));
        this.registerTableFunction("getSelectedRows", this.getSelectedRows.bind(this));
        this.registerTableFunction("getSelectedData", this.getSelectedData.bind(this));
        //register component functions
        this.registerComponentFunction("row", "select", this.selectRows.bind(this));
        this.registerComponentFunction("row", "deselect", this.deselectRows.bind(this));
        this.registerComponentFunction("row", "toggleSelect", this.toggleRow.bind(this));
        this.registerComponentFunction("row", "isSelected", this.isRowSelected.bind(this));
    }
    initialize() {
        this.deprecatedOptionsCheck();
        if (this.table.options.selectableRows === "highlight" && this.table.options.selectableRange) this.table.options.selectableRows = false;
        if (this.table.options.selectableRows !== false) {
            this.subscribe("row-init", this.initializeRow.bind(this));
            this.subscribe("row-deleting", this.rowDeleted.bind(this));
            this.subscribe("rows-wipe", this.clearSelectionData.bind(this));
            this.subscribe("rows-retrieve", this.rowRetrieve.bind(this));
            if (this.table.options.selectableRows && !this.table.options.selectableRowsPersistence) this.subscribe("data-refreshing", this.deselectRows.bind(this));
        }
    }
    deprecatedOptionsCheck() {
    // this.deprecationCheck("selectable", "selectableRows", true);
    // this.deprecationCheck("selectableRollingSelection", "selectableRowsRollingSelection", true);
    // this.deprecationCheck("selectableRangeMode", "selectableRowsRangeMode", true);
    // this.deprecationCheck("selectablePersistence", "selectableRowsPersistence", true);
    // this.deprecationCheck("selectableCheck", "selectableRowsCheck", true);
    }
    rowRetrieve(type, prevValue) {
        return type === "selected" ? this.selectedRows : prevValue;
    }
    rowDeleted(row) {
        this._deselectRow(row, true);
    }
    clearSelectionData(silent) {
        var prevSelected = this.selectedRows.length;
        this.selecting = false;
        this.lastClickedRow = false;
        this.selectPrev = [];
        this.selectedRows = [];
        if (prevSelected && silent !== true) this._rowSelectionChanged();
    }
    initializeRow(row) {
        var self = this, selectable = self.checkRowSelectability(row), element = row.getElement();
        // trigger end of row selection
        var endSelect = function() {
            setTimeout(function() {
                self.selecting = false;
            }, 50);
            document.body.removeEventListener("mouseup", endSelect);
        };
        row.modules.select = {
            selected: false
        };
        element.classList.toggle("tabulator-selectable", selectable);
        element.classList.toggle("tabulator-unselectable", !selectable);
        //set row selection class
        if (self.checkRowSelectability(row)) {
            if (self.table.options.selectableRows && self.table.options.selectableRows != "highlight") {
                if (self.table.options.selectableRowsRangeMode === "click") element.addEventListener("click", this.handleComplexRowClick.bind(this, row));
                else {
                    element.addEventListener("click", function(e) {
                        if (!self.table.modExists("edit") || !self.table.modules.edit.getCurrentCell()) self.table._clearSelection();
                        if (!self.selecting) self.toggleRow(row);
                    });
                    element.addEventListener("mousedown", function(e) {
                        if (e.shiftKey) {
                            self.table._clearSelection();
                            self.selecting = true;
                            self.selectPrev = [];
                            document.body.addEventListener("mouseup", endSelect);
                            document.body.addEventListener("keyup", endSelect);
                            self.toggleRow(row);
                            return false;
                        }
                    });
                    element.addEventListener("mouseenter", function(e) {
                        if (self.selecting) {
                            self.table._clearSelection();
                            self.toggleRow(row);
                            if (self.selectPrev[1] == row) self.toggleRow(self.selectPrev[0]);
                        }
                    });
                    element.addEventListener("mouseout", function(e) {
                        if (self.selecting) {
                            self.table._clearSelection();
                            self.selectPrev.unshift(row);
                        }
                    });
                }
            }
        }
    }
    handleComplexRowClick(row, e) {
        if (e.shiftKey) {
            this.table._clearSelection();
            this.lastClickedRow = this.lastClickedRow || row;
            var lastClickedRowIdx = this.table.rowManager.getDisplayRowIndex(this.lastClickedRow);
            var rowIdx = this.table.rowManager.getDisplayRowIndex(row);
            var fromRowIdx = lastClickedRowIdx <= rowIdx ? lastClickedRowIdx : rowIdx;
            var toRowIdx = lastClickedRowIdx >= rowIdx ? lastClickedRowIdx : rowIdx;
            var rows = this.table.rowManager.getDisplayRows().slice(0);
            var toggledRows = rows.splice(fromRowIdx, toRowIdx - fromRowIdx + 1);
            if (e.ctrlKey || e.metaKey) {
                toggledRows.forEach((toggledRow)=>{
                    if (toggledRow !== this.lastClickedRow) {
                        if (this.table.options.selectableRows !== true && !this.isRowSelected(row)) {
                            if (this.selectedRows.length < this.table.options.selectableRows) this.toggleRow(toggledRow);
                        } else this.toggleRow(toggledRow);
                    }
                });
                this.lastClickedRow = row;
            } else {
                this.deselectRows(undefined, true);
                if (this.table.options.selectableRows !== true) {
                    if (toggledRows.length > this.table.options.selectableRows) toggledRows = toggledRows.slice(0, this.table.options.selectableRows);
                }
                this.selectRows(toggledRows);
            }
            this.table._clearSelection();
        } else if (e.ctrlKey || e.metaKey) {
            this.toggleRow(row);
            this.lastClickedRow = row;
        } else {
            this.deselectRows(undefined, true);
            this.selectRows(row);
            this.lastClickedRow = row;
        }
    }
    checkRowSelectability(row) {
        if (row && row.type === "row") return this.table.options.selectableRowsCheck.call(this.table, row.getComponent());
        return false;
    }
    //toggle row selection
    toggleRow(row) {
        if (this.checkRowSelectability(row)) {
            if (row.modules.select && row.modules.select.selected) this._deselectRow(row);
            else this._selectRow(row);
        }
    }
    //select a number of rows
    selectRows(rows) {
        var changes = [], rowMatch, change;
        switch(typeof rows){
            case "undefined":
                rowMatch = this.table.rowManager.rows;
                break;
            case "number":
                rowMatch = this.table.rowManager.findRow(rows);
                break;
            case "string":
                rowMatch = this.table.rowManager.findRow(rows);
                if (!rowMatch) rowMatch = this.table.rowManager.getRows(rows);
                break;
            default:
                rowMatch = rows;
                break;
        }
        if (Array.isArray(rowMatch)) {
            if (rowMatch.length) {
                rowMatch.forEach((row)=>{
                    change = this._selectRow(row, true, true);
                    if (change) changes.push(change);
                });
                this._rowSelectionChanged(false, changes);
            }
        } else if (rowMatch) this._selectRow(rowMatch, false, true);
    }
    //select an individual row
    _selectRow(rowInfo, silent, force) {
        //handle max row count
        if (!isNaN(this.table.options.selectableRows) && this.table.options.selectableRows !== true && !force) {
            if (this.selectedRows.length >= this.table.options.selectableRows) {
                if (this.table.options.selectableRowsRollingSelection) this._deselectRow(this.selectedRows[0]);
                else return false;
            }
        }
        var row = this.table.rowManager.findRow(rowInfo);
        if (row) {
            if (this.selectedRows.indexOf(row) == -1) {
                row.getElement().classList.add("tabulator-selected");
                if (!row.modules.select) row.modules.select = {};
                row.modules.select.selected = true;
                if (row.modules.select.checkboxEl) row.modules.select.checkboxEl.checked = true;
                this.selectedRows.push(row);
                if (this.table.options.dataTreeSelectPropagate) this.childRowSelection(row, true);
                this.dispatchExternal("rowSelected", row.getComponent());
                this._rowSelectionChanged(silent, row);
                return row;
            }
        } else if (!silent) console.warn("Selection Error - No such row found, ignoring selection:" + rowInfo);
    }
    isRowSelected(row) {
        return this.selectedRows.indexOf(row) !== -1;
    }
    //deselect a number of rows
    deselectRows(rows, silent) {
        var changes = [], rowMatch, change;
        switch(typeof rows){
            case "undefined":
                rowMatch = Object.assign([], this.selectedRows);
                break;
            case "number":
                rowMatch = this.table.rowManager.findRow(rows);
                break;
            case "string":
                rowMatch = this.table.rowManager.findRow(rows);
                if (!rowMatch) rowMatch = this.table.rowManager.getRows(rows);
                break;
            default:
                rowMatch = rows;
                break;
        }
        if (Array.isArray(rowMatch)) {
            if (rowMatch.length) {
                rowMatch.forEach((row)=>{
                    change = this._deselectRow(row, true, true);
                    if (change) changes.push(change);
                });
                this._rowSelectionChanged(silent, [], changes);
            }
        } else if (rowMatch) this._deselectRow(rowMatch, silent, true);
    }
    //deselect an individual row
    _deselectRow(rowInfo, silent) {
        var self = this, row = self.table.rowManager.findRow(rowInfo), index, element;
        if (row) {
            index = self.selectedRows.findIndex(function(selectedRow) {
                return selectedRow == row;
            });
            if (index > -1) {
                element = row.getElement();
                if (element) element.classList.remove("tabulator-selected");
                if (!row.modules.select) row.modules.select = {};
                row.modules.select.selected = false;
                if (row.modules.select.checkboxEl) row.modules.select.checkboxEl.checked = false;
                self.selectedRows.splice(index, 1);
                if (this.table.options.dataTreeSelectPropagate) this.childRowSelection(row, false);
                this.dispatchExternal("rowDeselected", row.getComponent());
                self._rowSelectionChanged(silent, undefined, row);
                return row;
            }
        } else if (!silent) console.warn("Deselection Error - No such row found, ignoring selection:" + rowInfo);
    }
    getSelectedData() {
        var data = [];
        this.selectedRows.forEach(function(row) {
            data.push(row.getData());
        });
        return data;
    }
    getSelectedRows() {
        var rows = [];
        this.selectedRows.forEach(function(row) {
            rows.push(row.getComponent());
        });
        return rows;
    }
    _rowSelectionChanged(silent, selected = [], deselected = []) {
        if (this.headerCheckboxElement) {
            if (this.selectedRows.length === 0) {
                this.headerCheckboxElement.checked = false;
                this.headerCheckboxElement.indeterminate = false;
            } else if (this.table.rowManager.rows.length === this.selectedRows.length) {
                this.headerCheckboxElement.checked = true;
                this.headerCheckboxElement.indeterminate = false;
            } else {
                this.headerCheckboxElement.indeterminate = true;
                this.headerCheckboxElement.checked = false;
            }
        }
        if (!silent) {
            if (!Array.isArray(selected)) selected = [
                selected
            ];
            selected = selected.map((row)=>row.getComponent());
            if (!Array.isArray(deselected)) deselected = [
                deselected
            ];
            deselected = deselected.map((row)=>row.getComponent());
            this.dispatchExternal("rowSelectionChanged", this.getSelectedData(), this.getSelectedRows(), selected, deselected);
        }
    }
    registerRowSelectCheckbox(row, element) {
        if (!row._row.modules.select) row._row.modules.select = {};
        row._row.modules.select.checkboxEl = element;
    }
    registerHeaderSelectCheckbox(element) {
        this.headerCheckboxElement = element;
    }
    childRowSelection(row, select) {
        var children = this.table.modules.dataTree.getChildren(row, true, true);
        if (select) for (let child of children)this._selectRow(child, true);
        else for (let child of children)this._deselectRow(child, true);
    }
}
class $c2a9788f40f9c90a$export$433bfdbc52491af1 {
    constructor(range){
        this._range = range;
        return new Proxy(this, {
            get: function(target, name, receiver) {
                if (typeof target[name] !== "undefined") return target[name];
                else return target._range.table.componentFunctionBinder.handle("range", target._range, name);
            }
        });
    }
    getElement() {
        return this._range.element;
    }
    getData() {
        return this._range.getData();
    }
    getCells() {
        return this._range.getCells(true, true);
    }
    getStructuredCells() {
        return this._range.getStructuredCells();
    }
    getRows() {
        return this._range.getRows().map((row)=>row.getComponent());
    }
    getColumns() {
        return this._range.getColumns().map((column)=>column.getComponent());
    }
    getBounds() {
        return this._range.getBounds();
    }
    getTopEdge() {
        return this._range.top;
    }
    getBottomEdge() {
        return this._range.bottom;
    }
    getLeftEdge() {
        return this._range.left;
    }
    getRightEdge() {
        return this._range.right;
    }
    setBounds(start, end) {
        if (this._range.destroyedGuard("setBounds")) this._range.setBounds(start ? start._cell : start, end ? end._cell : end);
    }
    setStartBound(start) {
        if (this._range.destroyedGuard("setStartBound")) {
            this._range.setEndBound(start ? start._cell : start);
            this._range.rangeManager.layoutElement();
        }
    }
    setEndBound(end) {
        if (this._range.destroyedGuard("setEndBound")) {
            this._range.setEndBound(end ? end._cell : end);
            this._range.rangeManager.layoutElement();
        }
    }
    clearValues() {
        if (this._range.destroyedGuard("clearValues")) this._range.clearValues();
    }
    remove() {
        if (this._range.destroyedGuard("remove")) this._range.destroy(true);
    }
}
class $c2a9788f40f9c90a$var$Range extends $c2a9788f40f9c90a$var$CoreFeature {
    constructor(table, rangeManager, start, end){
        super(table);
        this.rangeManager = rangeManager;
        this.element = null;
        this.initialized = false;
        this.initializing = {
            start: false,
            end: false
        };
        this.destroyed = false;
        this.top = 0;
        this.bottom = 0;
        this.left = 0;
        this.right = 0;
        this.table = table;
        this.start = {
            row: 0,
            col: 0
        };
        this.end = {
            row: 0,
            col: 0
        };
        if (this.rangeManager.rowHeader) {
            this.left = 1;
            this.right = 1;
            this.start.col = 1;
            this.end.col = 1;
        }
        this.initElement();
        setTimeout(()=>{
            this.initBounds(start, end);
        });
    }
    initElement() {
        this.element = document.createElement("div");
        this.element.classList.add("tabulator-range");
    }
    initBounds(start, end) {
        this._updateMinMax();
        if (start) this.setBounds(start, end || start);
    }
    ///////////////////////////////////
    ///////   Boundary Setup    ///////
    ///////////////////////////////////
    setStart(row, col) {
        if (this.start.row !== row || this.start.col !== col) {
            this.start.row = row;
            this.start.col = col;
            this.initializing.start = true;
            this._updateMinMax();
        }
    }
    setEnd(row, col) {
        if (this.end.row !== row || this.end.col !== col) {
            this.end.row = row;
            this.end.col = col;
            this.initializing.end = true;
            this._updateMinMax();
        }
    }
    setBounds(start, end, visibleRows) {
        if (start) this.setStartBound(start);
        this.setEndBound(end || start);
        this.rangeManager.layoutElement(visibleRows);
    }
    setStartBound(element) {
        var row, col;
        if (element.type === "column") {
            if (this.rangeManager.columnSelection) this.setStart(0, element.getPosition() - 1);
        } else {
            row = element.row.position - 1;
            col = element.column.getPosition() - 1;
            if (element.column === this.rangeManager.rowHeader) this.setStart(row, 1);
            else this.setStart(row, col);
        }
    }
    setEndBound(element) {
        var rowsCount = this._getTableRows().length, row, col, isRowHeader;
        if (element.type === "column") {
            if (this.rangeManager.columnSelection) {
                if (this.rangeManager.selecting === "column") this.setEnd(rowsCount - 1, element.getPosition() - 1);
                else if (this.rangeManager.selecting === "cell") this.setEnd(0, element.getPosition() - 1);
            }
        } else {
            row = element.row.position - 1;
            col = element.column.getPosition() - 1;
            isRowHeader = element.column === this.rangeManager.rowHeader;
            if (this.rangeManager.selecting === "row") this.setEnd(row, this._getTableColumns().length - 1);
            else if (this.rangeManager.selecting !== "row" && isRowHeader) this.setEnd(row, 0);
            else if (this.rangeManager.selecting === "column") this.setEnd(rowsCount - 1, col);
            else this.setEnd(row, col);
        }
    }
    _updateMinMax() {
        this.top = Math.min(this.start.row, this.end.row);
        this.bottom = Math.max(this.start.row, this.end.row);
        this.left = Math.min(this.start.col, this.end.col);
        this.right = Math.max(this.start.col, this.end.col);
        if (this.initialized) this.dispatchExternal("rangeChanged", this.getComponent());
        else if (this.initializing.start && this.initializing.end) {
            this.initialized = true;
            this.dispatchExternal("rangeAdded", this.getComponent());
        }
    }
    _getTableColumns() {
        return this.table.columnManager.getVisibleColumnsByIndex();
    }
    _getTableRows() {
        return this.table.rowManager.getDisplayRows().filter((row)=>row.type === "row");
    }
    ///////////////////////////////////
    ///////      Rendering      ///////
    ///////////////////////////////////
    layout() {
        var _vDomTop = this.table.rowManager.renderer.vDomTop, _vDomBottom = this.table.rowManager.renderer.vDomBottom, _vDomLeft = this.table.columnManager.renderer.leftCol, _vDomRight = this.table.columnManager.renderer.rightCol, top, bottom, left, right, topLeftCell, bottomRightCell, topLeftCellEl, bottomRightCellEl, topLeftRowEl, bottomRightRowEl;
        if (this.table.options.renderHorizontal === "virtual" && this.rangeManager.rowHeader) _vDomRight += 1;
        if (_vDomTop == null) _vDomTop = 0;
        if (_vDomBottom == null) _vDomBottom = Infinity;
        if (_vDomLeft == null) _vDomLeft = 0;
        if (_vDomRight == null) _vDomRight = Infinity;
        if (this.overlaps(_vDomLeft, _vDomTop, _vDomRight, _vDomBottom)) {
            top = Math.max(this.top, _vDomTop);
            bottom = Math.min(this.bottom, _vDomBottom);
            left = Math.max(this.left, _vDomLeft);
            right = Math.min(this.right, _vDomRight);
            topLeftCell = this.rangeManager.getCell(top, left);
            bottomRightCell = this.rangeManager.getCell(bottom, right);
            topLeftCellEl = topLeftCell.getElement();
            bottomRightCellEl = bottomRightCell.getElement();
            topLeftRowEl = topLeftCell.row.getElement();
            bottomRightRowEl = bottomRightCell.row.getElement();
            this.element.classList.add("tabulator-range-active");
            // this.element.classList.toggle("tabulator-range-active", this === this.rangeManager.activeRange);
            if (this.table.rtl) {
                this.element.style.right = topLeftRowEl.offsetWidth - topLeftCellEl.offsetLeft - topLeftCellEl.offsetWidth + "px";
                this.element.style.width = topLeftCellEl.offsetLeft + topLeftCellEl.offsetWidth - bottomRightCellEl.offsetLeft + "px";
            } else {
                this.element.style.left = topLeftRowEl.offsetLeft + topLeftCellEl.offsetLeft + "px";
                this.element.style.width = bottomRightCellEl.offsetLeft + bottomRightCellEl.offsetWidth - topLeftCellEl.offsetLeft + "px";
            }
            this.element.style.top = topLeftRowEl.offsetTop + "px";
            this.element.style.height = bottomRightRowEl.offsetTop + bottomRightRowEl.offsetHeight - topLeftRowEl.offsetTop + "px";
        }
    }
    atTopLeft(cell) {
        return cell.row.position - 1 === this.top && cell.column.getPosition() - 1 === this.left;
    }
    atBottomRight(cell) {
        return cell.row.position - 1 === this.bottom && cell.column.getPosition() - 1 === this.right;
    }
    occupies(cell) {
        return this.occupiesRow(cell.row) && this.occupiesColumn(cell.column);
    }
    occupiesRow(row) {
        return this.top <= row.position - 1 && row.position - 1 <= this.bottom;
    }
    occupiesColumn(col) {
        return this.left <= col.getPosition() - 1 && col.getPosition() - 1 <= this.right;
    }
    overlaps(left, top, right, bottom) {
        if (this.left > right || left > this.right || this.top > bottom || top > this.bottom) return false;
        return true;
    }
    getData() {
        var data = [], rows = this.getRows(), columns = this.getColumns();
        rows.forEach((row)=>{
            var rowData = row.getData(), result = {};
            columns.forEach((column)=>{
                result[column.field] = rowData[column.field];
            });
            data.push(result);
        });
        return data;
    }
    getCells(structured, component) {
        var cells = [], rows = this.getRows(), columns = this.getColumns();
        if (structured) cells = rows.map((row)=>{
            var arr = [];
            row.getCells().forEach((cell)=>{
                if (columns.includes(cell.column)) arr.push(component ? cell.getComponent() : cell);
            });
            return arr;
        });
        else rows.forEach((row)=>{
            row.getCells().forEach((cell)=>{
                if (columns.includes(cell.column)) cells.push(component ? cell.getComponent() : cell);
            });
        });
        return cells;
    }
    getStructuredCells() {
        return this.getCells(true, true);
    }
    getRows() {
        return this._getTableRows().slice(this.top, this.bottom + 1);
    }
    getColumns() {
        return this._getTableColumns().slice(this.left, this.right + 1);
    }
    clearValues() {
        var cells = this.getCells();
        var clearValue = this.table.options.selectableRangeClearCellsValue;
        this.table.blockRedraw();
        cells.forEach((cell)=>{
            cell.setValue(clearValue);
        });
        this.table.restoreRedraw();
    }
    getBounds(component) {
        var cells = this.getCells(false, component), output = {
            start: null,
            end: null
        };
        if (cells.length) {
            output.start = cells[0];
            output.end = cells[cells.length - 1];
        } else console.warn("No bounds defined on range");
        return output;
    }
    getComponent() {
        if (!this.component) this.component = new $c2a9788f40f9c90a$export$433bfdbc52491af1(this);
        return this.component;
    }
    destroy(notify) {
        this.destroyed = true;
        this.element.remove();
        if (notify) this.rangeManager.rangeRemoved(this);
        if (this.initialized) this.dispatchExternal("rangeRemoved", this.getComponent());
    }
    destroyedGuard(func) {
        if (this.destroyed) console.warn("You cannot call the " + func + " function on a destroyed range");
        return !this.destroyed;
    }
}
var $c2a9788f40f9c90a$var$bindings = {
    rangeJumpUp: [
        "ctrl + 38",
        "meta + 38"
    ],
    rangeJumpDown: [
        "ctrl + 40",
        "meta + 40"
    ],
    rangeJumpLeft: [
        "ctrl + 37",
        "meta + 37"
    ],
    rangeJumpRight: [
        "ctrl + 39",
        "meta + 39"
    ],
    rangeExpandUp: "shift + 38",
    rangeExpandDown: "shift + 40",
    rangeExpandLeft: "shift + 37",
    rangeExpandRight: "shift + 39",
    rangeExpandJumpUp: [
        "ctrl + shift + 38",
        "meta + shift + 38"
    ],
    rangeExpandJumpDown: [
        "ctrl + shift + 40",
        "meta + shift + 40"
    ],
    rangeExpandJumpLeft: [
        "ctrl + shift + 37",
        "meta + shift + 37"
    ],
    rangeExpandJumpRight: [
        "ctrl + shift + 39",
        "meta + shift + 39"
    ]
};
var $c2a9788f40f9c90a$var$actions = {
    rangeJumpLeft: function(e) {
        this.dispatch("keybinding-nav-range", e, "left", true, false);
    },
    rangeJumpRight: function(e) {
        this.dispatch("keybinding-nav-range", e, "right", true, false);
    },
    rangeJumpUp: function(e) {
        this.dispatch("keybinding-nav-range", e, "up", true, false);
    },
    rangeJumpDown: function(e) {
        this.dispatch("keybinding-nav-range", e, "down", true, false);
    },
    rangeExpandLeft: function(e) {
        this.dispatch("keybinding-nav-range", e, "left", false, true);
    },
    rangeExpandRight: function(e) {
        this.dispatch("keybinding-nav-range", e, "right", false, true);
    },
    rangeExpandUp: function(e) {
        this.dispatch("keybinding-nav-range", e, "up", false, true);
    },
    rangeExpandDown: function(e) {
        this.dispatch("keybinding-nav-range", e, "down", false, true);
    },
    rangeExpandJumpLeft: function(e) {
        this.dispatch("keybinding-nav-range", e, "left", true, true);
    },
    rangeExpandJumpRight: function(e) {
        this.dispatch("keybinding-nav-range", e, "right", true, true);
    },
    rangeExpandJumpUp: function(e) {
        this.dispatch("keybinding-nav-range", e, "up", true, true);
    },
    rangeExpandJumpDown: function(e) {
        this.dispatch("keybinding-nav-range", e, "down", true, true);
    }
};
var $c2a9788f40f9c90a$var$pasteActions = {
    range: function(data) {
        var rows = [], range = this.table.modules.selectRange.activeRange, singleCell = false, bounds, startCell, startRow, rowWidth, dataLength;
        dataLength = data.length;
        if (range) {
            bounds = range.getBounds();
            startCell = bounds.start;
            if (bounds.start === bounds.end) singleCell = true;
            if (startCell) {
                rows = this.table.rowManager.activeRows.slice();
                startRow = rows.indexOf(startCell.row);
                if (singleCell) rowWidth = data.length;
                else rowWidth = rows.indexOf(bounds.end.row) - startRow + 1;
                if (startRow > -1) {
                    this.table.blockRedraw();
                    rows = rows.slice(startRow, startRow + rowWidth);
                    rows.forEach((row, i)=>{
                        row.updateData(data[i % dataLength]);
                    });
                    this.table.restoreRedraw();
                }
            }
        }
        return rows;
    }
};
var $c2a9788f40f9c90a$var$pasteParsers = {
    range: function(clipboard) {
        var data = [], rows = [], range = this.table.modules.selectRange.activeRange, singleCell = false, bounds, startCell, colWidth, columnMap, startCol;
        if (range) {
            bounds = range.getBounds();
            startCell = bounds.start;
            if (bounds.start === bounds.end) singleCell = true;
            if (startCell) {
                //get data from clipboard into array of columns and rows.
                clipboard = clipboard.split("\n");
                clipboard.forEach(function(row) {
                    data.push(row.split("\t"));
                });
                if (data.length) {
                    columnMap = this.table.columnManager.getVisibleColumnsByIndex();
                    startCol = columnMap.indexOf(startCell.column);
                    if (startCol > -1) {
                        if (singleCell) colWidth = data[0].length;
                        else colWidth = columnMap.indexOf(bounds.end.column) - startCol + 1;
                        columnMap = columnMap.slice(startCol, startCol + colWidth);
                        data.forEach((item)=>{
                            var row = {};
                            var itemLength = item.length;
                            columnMap.forEach(function(col, i) {
                                row[col.field] = item[i % itemLength];
                            });
                            rows.push(row);
                        });
                        return rows;
                    }
                }
            }
        }
        return false;
    }
};
var $c2a9788f40f9c90a$var$columnLookups = {
    range: function() {
        var columns = this.modules.selectRange.selectedColumns();
        if (this.columnManager.rowHeader) columns.unshift(this.columnManager.rowHeader);
        return columns;
    }
};
var $c2a9788f40f9c90a$var$rowLookups = {
    range: function() {
        return this.modules.selectRange.selectedRows();
    }
};
var $c2a9788f40f9c90a$var$extensions = {
    keybindings: {
        bindings: $c2a9788f40f9c90a$var$bindings,
        actions: $c2a9788f40f9c90a$var$actions
    },
    clipboard: {
        pasteActions: $c2a9788f40f9c90a$var$pasteActions,
        pasteParsers: $c2a9788f40f9c90a$var$pasteParsers
    },
    export: {
        columnLookups: $c2a9788f40f9c90a$var$columnLookups,
        rowLookups: $c2a9788f40f9c90a$var$rowLookups
    }
};
class $c2a9788f40f9c90a$export$cd9e469b2c8c819c extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "selectRange";
    static moduleInitOrder = 1;
    static moduleExtensions = $c2a9788f40f9c90a$var$extensions;
    constructor(table){
        super(table);
        this.selecting = "cell";
        this.mousedown = false;
        this.ranges = [];
        this.overlay = null;
        this.rowHeader = null;
        this.layoutChangeTimeout = null;
        this.columnSelection = false;
        this.rowSelection = false;
        this.maxRanges = 0;
        this.activeRange = false;
        this.blockKeydown = false;
        this.keyDownEvent = this._handleKeyDown.bind(this);
        this.mouseUpEvent = this._handleMouseUp.bind(this);
        this.registerTableOption("selectableRange", false); //enable selectable range
        this.registerTableOption("selectableRangeColumns", false); //enable selectable range
        this.registerTableOption("selectableRangeRows", false); //enable selectable range
        this.registerTableOption("selectableRangeClearCells", false); //allow clearing of active range
        this.registerTableOption("selectableRangeClearCellsValue", undefined); //value for cleared active range
        this.registerTableOption("selectableRangeAutoFocus", true); //focus on a cell after resetRanges
        this.registerTableFunction("getRangesData", this.getRangesData.bind(this));
        this.registerTableFunction("getRanges", this.getRanges.bind(this));
        this.registerTableFunction("addRange", this.addRangeFromComponent.bind(this));
        this.registerComponentFunction("cell", "getRanges", this.cellGetRanges.bind(this));
        this.registerComponentFunction("row", "getRanges", this.rowGetRanges.bind(this));
        this.registerComponentFunction("column", "getRanges", this.colGetRanges.bind(this));
    }
    ///////////////////////////////////
    ///////    Initialization   ///////
    ///////////////////////////////////
    initialize() {
        if (this.options("selectableRange")) {
            if (!this.options("selectableRows")) {
                this.maxRanges = this.options("selectableRange");
                this.initializeTable();
                this.initializeWatchers();
            } else console.warn("SelectRange functionality cannot be used in conjunction with row selection");
            if (this.options('columns').findIndex((column)=>column.frozen) > 0) console.warn("Having frozen column in arbitrary position with selectRange option may result in unpredictable behavior.");
            if (this.options('columns').filter((column)=>column.frozen) > 1) console.warn("Having multiple frozen columns with selectRange option may result in unpredictable behavior.");
        }
    }
    initializeTable() {
        this.overlay = document.createElement("div");
        this.overlay.classList.add("tabulator-range-overlay");
        this.rangeContainer = document.createElement("div");
        this.rangeContainer.classList.add("tabulator-range-container");
        this.activeRangeCellElement = document.createElement("div");
        this.activeRangeCellElement.classList.add("tabulator-range-cell-active");
        this.overlay.appendChild(this.rangeContainer);
        this.overlay.appendChild(this.activeRangeCellElement);
        this.table.rowManager.element.addEventListener("keydown", this.keyDownEvent);
        this.resetRanges();
        this.table.rowManager.element.appendChild(this.overlay);
        this.table.columnManager.element.setAttribute("tabindex", 0);
        this.table.element.classList.add("tabulator-ranges");
    }
    initializeWatchers() {
        this.columnSelection = this.options("selectableRangeColumns");
        this.rowSelection = this.options("selectableRangeRows");
        this.subscribe("column-init", this.initializeColumn.bind(this));
        this.subscribe("column-mousedown", this.handleColumnMouseDown.bind(this));
        this.subscribe("column-mousemove", this.handleColumnMouseMove.bind(this));
        this.subscribe("column-resized", this.handleColumnResized.bind(this));
        this.subscribe("column-moving", this.handleColumnMoving.bind(this));
        this.subscribe("column-moved", this.handleColumnMoved.bind(this));
        this.subscribe("column-width", this.layoutChange.bind(this));
        this.subscribe("column-height", this.layoutChange.bind(this));
        this.subscribe("column-resized", this.layoutChange.bind(this));
        this.subscribe("columns-loaded", this.updateHeaderColumn.bind(this));
        this.subscribe("cell-height", this.layoutChange.bind(this));
        this.subscribe("cell-rendered", this.renderCell.bind(this));
        this.subscribe("cell-mousedown", this.handleCellMouseDown.bind(this));
        this.subscribe("cell-mousemove", this.handleCellMouseMove.bind(this));
        this.subscribe("cell-click", this.handleCellClick.bind(this));
        this.subscribe("cell-editing", this.handleEditingCell.bind(this));
        this.subscribe("page-changed", this.redraw.bind(this));
        this.subscribe("scroll-vertical", this.layoutChange.bind(this));
        this.subscribe("scroll-horizontal", this.layoutChange.bind(this));
        this.subscribe("data-destroy", this.tableDestroyed.bind(this));
        this.subscribe("data-processed", this.resetRanges.bind(this));
        this.subscribe("table-layout", this.layoutElement.bind(this));
        this.subscribe("table-redraw", this.redraw.bind(this));
        this.subscribe("table-destroy", this.tableDestroyed.bind(this));
        this.subscribe("edit-editor-clear", this.finishEditingCell.bind(this));
        this.subscribe("edit-blur", this.restoreFocus.bind(this));
        this.subscribe("keybinding-nav-prev", this.keyNavigate.bind(this, "left"));
        this.subscribe("keybinding-nav-next", this.keyNavigate.bind(this, "right"));
        this.subscribe("keybinding-nav-left", this.keyNavigate.bind(this, "left"));
        this.subscribe("keybinding-nav-right", this.keyNavigate.bind(this, "right"));
        this.subscribe("keybinding-nav-up", this.keyNavigate.bind(this, "up"));
        this.subscribe("keybinding-nav-down", this.keyNavigate.bind(this, "down"));
        this.subscribe("keybinding-nav-range", this.keyNavigateRange.bind(this));
    }
    initializeColumn(column) {
        if (this.columnSelection && column.definition.headerSort && this.options("headerSortClickElement") !== "icon") console.warn("Using column headerSort with selectableRangeColumns option may result in unpredictable behavior. Consider using headerSortClickElement: 'icon'.");
        column.modules.edit;
    }
    updateHeaderColumn() {
        var frozenCols;
        if (this.rowSelection) {
            this.rowHeader = this.table.columnManager.getVisibleColumnsByIndex()[0];
            if (this.rowHeader) {
                this.rowHeader.definition.cssClass = this.rowHeader.definition.cssClass + " tabulator-range-row-header";
                if (this.rowHeader.definition.headerSort) console.warn("Using column headerSort with selectableRangeRows option may result in unpredictable behavior");
                if (this.rowHeader.definition.editor) console.warn("Using column editor with selectableRangeRows option may result in unpredictable behavior");
            }
        }
        //warn if invalid frozen column configuration detected
        if (this.table.modules.frozenColumns && this.table.modules.frozenColumns.active) {
            frozenCols = this.table.modules.frozenColumns.getFrozenColumns();
            if (frozenCols.length > 1 || frozenCols.length === 1 && frozenCols[0] !== this.rowHeader) console.warn("Using frozen columns that are not the range header in combination with the selectRange option may result in unpredictable behavior");
        }
    }
    ///////////////////////////////////
    ///////   Table Functions   ///////
    ///////////////////////////////////
    getRanges() {
        return this.ranges.map((range)=>range.getComponent());
    }
    getRangesData() {
        return this.ranges.map((range)=>range.getData());
    }
    addRangeFromComponent(start, end) {
        start = start ? start._cell : null;
        end = end ? end._cell : null;
        return this.addRange(start, end);
    }
    ///////////////////////////////////
    /////// Component Functions ///////
    ///////////////////////////////////
    cellGetRanges(cell) {
        var ranges = [];
        if (cell.column === this.rowHeader) ranges = this.ranges.filter((range)=>range.occupiesRow(cell.row));
        else ranges = this.ranges.filter((range)=>range.occupies(cell));
        return ranges.map((range)=>range.getComponent());
    }
    rowGetRanges(row) {
        var ranges = this.ranges.filter((range)=>range.occupiesRow(row));
        return ranges.map((range)=>range.getComponent());
    }
    colGetRanges(col) {
        var ranges = this.ranges.filter((range)=>range.occupiesColumn(col));
        return ranges.map((range)=>range.getComponent());
    }
    ///////////////////////////////////
    ////////// Event Handlers /////////
    ///////////////////////////////////
    _handleMouseUp(e) {
        this.mousedown = false;
        document.removeEventListener("mouseup", this.mouseUpEvent);
    }
    _handleKeyDown(e) {
        if (!this.blockKeydown && (!this.table.modules.edit || this.table.modules.edit && !this.table.modules.edit.currentCell)) {
            if (e.key === "Enter") {
                // is editing a cell?
                if (this.table.modules.edit && this.table.modules.edit.currentCell) return;
                this.table.modules.edit.editCell(this.getActiveCell());
                e.preventDefault();
            }
            if ((e.key === "Backspace" || e.key === "Delete") && this.options("selectableRangeClearCells")) {
                if (this.activeRange) this.activeRange.clearValues();
            }
        }
    }
    initializeFocus(cell) {
        var range;
        this.restoreFocus();
        try {
            if (document.selection) {
                range = document.body.createTextRange();
                range.moveToElementText(cell.getElement());
                range.select();
            } else if (window.getSelection) {
                range = document.createRange();
                range.selectNode(cell.getElement());
                window.getSelection().removeAllRanges();
                window.getSelection().addRange(range);
            }
        } catch (e) {}
    }
    restoreFocus(element) {
        this.table.rowManager.element.focus();
        return true;
    }
    ///////////////////////////////////
    ////// Column Functionality ///////
    ///////////////////////////////////
    handleColumnResized(column) {
        var selected;
        if (this.selecting !== "column" && this.selecting !== "all") return;
        selected = this.ranges.some((range)=>range.occupiesColumn(column));
        if (!selected) return;
        this.ranges.forEach((range)=>{
            var selectedColumns = range.getColumns(true);
            selectedColumns.forEach((selectedColumn)=>{
                if (selectedColumn !== column) selectedColumn.setWidth(column.width);
            });
        });
    }
    handleColumnMoving(_event, column) {
        this.resetRanges().setBounds(column);
        this.overlay.style.visibility = "hidden";
    }
    handleColumnMoved(from, _to, _after) {
        this.activeRange.setBounds(from);
        this.layoutElement();
    }
    handleColumnMouseDown(event, column) {
        if (event.button === 2 && (this.selecting === "column" || this.selecting === "all") && this.activeRange.occupiesColumn(column)) return;
        //If columns are movable, allow dragging columns only if they are not
        //selected. Dragging selected columns should move the columns instead.
        if (this.table.options.movableColumns && this.selecting === "column" && this.activeRange.occupiesColumn(column)) return;
        this.mousedown = true;
        document.addEventListener("mouseup", this.mouseUpEvent);
        this.newSelection(event, column);
    }
    handleColumnMouseMove(e, column) {
        if (column === this.rowHeader || !this.mousedown || this.selecting === 'all') return;
        this.activeRange.setBounds(false, column, true);
    }
    ///////////////////////////////////
    //////// Cell Functionality ///////
    ///////////////////////////////////
    renderCell(cell) {
        var el = cell.getElement(), rangeIdx = this.ranges.findIndex((range)=>range.occupies(cell));
        el.classList.toggle("tabulator-range-selected", rangeIdx !== -1);
        el.classList.toggle("tabulator-range-only-cell-selected", this.ranges.length === 1 && this.ranges[0].atTopLeft(cell) && this.ranges[0].atBottomRight(cell));
        el.dataset.range = rangeIdx;
    }
    handleCellMouseDown(event, cell) {
        if (event.button === 2 && (this.activeRange.occupies(cell) || (this.selecting === "row" || this.selecting === "all") && this.activeRange.occupiesRow(cell.row))) return;
        this.mousedown = true;
        document.addEventListener("mouseup", this.mouseUpEvent);
        this.newSelection(event, cell);
    }
    handleCellMouseMove(e, cell) {
        if (!this.mousedown || this.selecting === "all") return;
        this.activeRange.setBounds(false, cell, true);
    }
    handleCellClick(e, cell) {
        this.initializeFocus(cell);
    }
    handleEditingCell(cell) {
        if (this.activeRange) this.activeRange.setBounds(cell);
    }
    finishEditingCell() {
        this.blockKeydown = true;
        this.table.rowManager.element.focus();
        setTimeout(()=>{
            this.blockKeydown = false;
        }, 10);
    }
    ///////////////////////////////////
    ///////     Navigation      ///////
    ///////////////////////////////////
    keyNavigate(dir, e) {
        this.navigate(false, false, dir);
        e.preventDefault();
    }
    keyNavigateRange(e, dir, jump, expand) {
        this.navigate(jump, expand, dir);
        e.preventDefault();
    }
    navigate(jump, expand, dir) {
        var moved = false, range, rangeEdge, prevRect, nextRow, nextCol, row, column, rowRect, rowManagerRect, columnRect, columnManagerRect;
        // Don't navigate while editing
        if (this.table.modules.edit && this.table.modules.edit.currentCell) return false;
        // If there are more than 1 range, use the active range and destroy the others
        if (this.ranges.length > 1) this.ranges = this.ranges.filter((range)=>{
            if (range === this.activeRange) {
                range.setEnd(range.start.row, range.start.col);
                return true;
            }
            range.destroy();
            return false;
        });
        range = this.activeRange;
        prevRect = {
            top: range.top,
            bottom: range.bottom,
            left: range.left,
            right: range.right
        };
        rangeEdge = expand ? range.end : range.start;
        nextRow = rangeEdge.row;
        nextCol = rangeEdge.col;
        if (jump) switch(dir){
            case "left":
                nextCol = this.findJumpCellLeft(range.start.row, rangeEdge.col);
                break;
            case "right":
                nextCol = this.findJumpCellRight(range.start.row, rangeEdge.col);
                break;
            case "up":
                nextRow = this.findJumpCellUp(rangeEdge.row, range.start.col);
                break;
            case "down":
                nextRow = this.findJumpCellDown(rangeEdge.row, range.start.col);
                break;
        }
        else {
            if (expand) {
                if (this.selecting === 'row' && (dir === 'left' || dir === 'right') || this.selecting === 'column' && (dir === 'up' || dir === 'down')) return;
            }
            switch(dir){
                case "left":
                    nextCol = Math.max(nextCol - 1, 0);
                    break;
                case "right":
                    nextCol = Math.min(nextCol + 1, this.getTableColumns().length - 1);
                    break;
                case "up":
                    nextRow = Math.max(nextRow - 1, 0);
                    break;
                case "down":
                    nextRow = Math.min(nextRow + 1, this.getTableRows().length - 1);
                    break;
            }
        }
        if (this.rowHeader && nextCol === 0) nextCol = 1;
        if (!expand) range.setStart(nextRow, nextCol);
        range.setEnd(nextRow, nextCol);
        if (!expand) this.selecting = "cell";
        moved = prevRect.top !== range.top || prevRect.bottom !== range.bottom || prevRect.left !== range.left || prevRect.right !== range.right;
        if (moved) {
            row = this.getRowByRangePos(range.end.row);
            column = this.getColumnByRangePos(range.end.col);
            rowRect = row.getElement().getBoundingClientRect();
            columnRect = column.getElement().getBoundingClientRect();
            rowManagerRect = this.table.rowManager.getElement().getBoundingClientRect();
            columnManagerRect = this.table.columnManager.getElement().getBoundingClientRect();
            if (!(rowRect.top >= rowManagerRect.top && rowRect.bottom <= rowManagerRect.bottom)) {
                if (row.getElement().parentNode && column.getElement().parentNode) // Use faster autoScroll when the elements are on the DOM
                this.autoScroll(range, row.getElement(), column.getElement());
                else row.getComponent().scrollTo(undefined, false);
            }
            if (!(columnRect.left >= columnManagerRect.left + this.getRowHeaderWidth() && columnRect.right <= columnManagerRect.right)) {
                if (row.getElement().parentNode && column.getElement().parentNode) // Use faster autoScroll when the elements are on the DOM
                this.autoScroll(range, row.getElement(), column.getElement());
                else column.getComponent().scrollTo(undefined, false);
            }
            this.layoutElement();
            return true;
        }
    }
    rangeRemoved(removed) {
        this.ranges = this.ranges.filter((range)=>range !== removed);
        if (this.activeRange === removed) {
            if (this.ranges.length) this.activeRange = this.ranges[this.ranges.length - 1];
            else this.addRange();
        }
        this.layoutElement();
    }
    findJumpRow(column, rows, reverse, emptyStart, emptySide) {
        if (reverse) rows = rows.reverse();
        return this.findJumpItem(emptyStart, emptySide, rows, function(row) {
            return row.getData()[column.getField()];
        });
    }
    findJumpCol(row, columns, reverse, emptyStart, emptySide) {
        if (reverse) columns = columns.reverse();
        return this.findJumpItem(emptyStart, emptySide, columns, function(column) {
            return row.getData()[column.getField()];
        });
    }
    findJumpItem(emptyStart, emptySide, items, valueResolver) {
        var nextItem;
        for (let currentItem of items){
            let currentValue = valueResolver(currentItem);
            if (emptyStart) {
                nextItem = currentItem;
                if (currentValue) break;
            } else if (emptySide) {
                nextItem = currentItem;
                if (currentValue) break;
            } else {
                if (currentValue) nextItem = currentItem;
                else break;
            }
        }
        return nextItem;
    }
    findJumpCellLeft(rowPos, colPos) {
        var row = this.getRowByRangePos(rowPos), columns = this.getTableColumns(), isStartingCellEmpty = this.isEmpty(row.getData()[columns[colPos].getField()]), isLeftOfStartingCellEmpty = columns[colPos - 1] ? this.isEmpty(row.getData()[columns[colPos - 1].getField()]) : false, targetCols = this.rowHeader ? columns.slice(1, colPos) : columns.slice(0, colPos), jumpCol = this.findJumpCol(row, targetCols, true, isStartingCellEmpty, isLeftOfStartingCellEmpty);
        if (jumpCol) return jumpCol.getPosition() - 1;
        return colPos;
    }
    findJumpCellRight(rowPos, colPos) {
        var row = this.getRowByRangePos(rowPos), columns = this.getTableColumns(), isStartingCellEmpty = this.isEmpty(row.getData()[columns[colPos].getField()]), isRightOfStartingCellEmpty = columns[colPos + 1] ? this.isEmpty(row.getData()[columns[colPos + 1].getField()]) : false, jumpCol = this.findJumpCol(row, columns.slice(colPos + 1, columns.length), false, isStartingCellEmpty, isRightOfStartingCellEmpty);
        if (jumpCol) return jumpCol.getPosition() - 1;
        return colPos;
    }
    findJumpCellUp(rowPos, colPos) {
        var column = this.getColumnByRangePos(colPos), rows = this.getTableRows(), isStartingCellEmpty = this.isEmpty(rows[rowPos].getData()[column.getField()]), isTopOfStartingCellEmpty = rows[rowPos - 1] ? this.isEmpty(rows[rowPos - 1].getData()[column.getField()]) : false, jumpRow = this.findJumpRow(column, rows.slice(0, rowPos), true, isStartingCellEmpty, isTopOfStartingCellEmpty);
        if (jumpRow) return jumpRow.position - 1;
        return rowPos;
    }
    findJumpCellDown(rowPos, colPos) {
        var column = this.getColumnByRangePos(colPos), rows = this.getTableRows(), isStartingCellEmpty = this.isEmpty(rows[rowPos].getData()[column.getField()]), isBottomOfStartingCellEmpty = rows[rowPos + 1] ? this.isEmpty(rows[rowPos + 1].getData()[column.getField()]) : false, jumpRow = this.findJumpRow(column, rows.slice(rowPos + 1, rows.length), false, isStartingCellEmpty, isBottomOfStartingCellEmpty);
        if (jumpRow) return jumpRow.position - 1;
        return rowPos;
    }
    ///////////////////////////////////
    ///////      Selection      ///////
    ///////////////////////////////////
    newSelection(event, element) {
        var range;
        if (element.type === "column") {
            if (!this.columnSelection) return;
            if (element === this.rowHeader) {
                range = this.resetRanges();
                this.selecting = "all";
                var topLeftCell, bottomRightCell = this.getCell(-1, -1);
                if (this.rowHeader) topLeftCell = this.getCell(0, 1);
                else topLeftCell = this.getCell(0, 0);
                range.setBounds(topLeftCell, bottomRightCell);
                return;
            } else this.selecting = "column";
        } else if (element.column === this.rowHeader) this.selecting = "row";
        else this.selecting = "cell";
        if (event.shiftKey) this.activeRange.setBounds(false, element);
        else if (event.ctrlKey) this.addRange().setBounds(element);
        else this.resetRanges().setBounds(element);
    }
    autoScroll(range, row, column) {
        var tableHolder = this.table.rowManager.element, rect, view, withinHorizontalView, withinVerticalView;
        if (typeof row === 'undefined') row = this.getRowByRangePos(range.end.row).getElement();
        if (typeof column === 'undefined') column = this.getColumnByRangePos(range.end.col).getElement();
        rect = {
            left: column.offsetLeft,
            right: column.offsetLeft + column.offsetWidth,
            top: row.offsetTop,
            bottom: row.offsetTop + row.offsetHeight
        };
        view = {
            left: tableHolder.scrollLeft + this.getRowHeaderWidth(),
            right: Math.ceil(tableHolder.scrollLeft + tableHolder.clientWidth),
            top: tableHolder.scrollTop,
            bottom: tableHolder.scrollTop + tableHolder.offsetHeight - this.table.rowManager.scrollbarWidth
        };
        withinHorizontalView = view.left < rect.left && rect.left < view.right && view.left < rect.right && rect.right < view.right;
        withinVerticalView = view.top < rect.top && rect.top < view.bottom && view.top < rect.bottom && rect.bottom < view.bottom;
        if (!withinHorizontalView) {
            if (rect.left < view.left) tableHolder.scrollLeft = rect.left - this.getRowHeaderWidth();
            else if (rect.right > view.right) tableHolder.scrollLeft = Math.min(rect.right - tableHolder.clientWidth, rect.left - this.getRowHeaderWidth());
        }
        if (!withinVerticalView) {
            if (rect.top < view.top) tableHolder.scrollTop = rect.top;
            else if (rect.bottom > view.bottom) tableHolder.scrollTop = rect.bottom - tableHolder.clientHeight;
        }
    }
    ///////////////////////////////////
    ///////       Layout        ///////
    ///////////////////////////////////
    layoutChange() {
        this.overlay.style.visibility = "hidden";
        clearTimeout(this.layoutChangeTimeout);
        this.layoutChangeTimeout = setTimeout(this.layoutRanges.bind(this), 200);
    }
    redraw(force) {
        if (force) {
            this.selecting = 'cell';
            this.resetRanges();
            this.layoutElement();
        }
    }
    layoutElement(visibleRows) {
        var rows;
        if (visibleRows) rows = this.table.rowManager.getVisibleRows(true);
        else rows = this.table.rowManager.getRows();
        rows.forEach((row)=>{
            if (row.type === "row") {
                this.layoutRow(row);
                row.cells.forEach((cell)=>this.renderCell(cell));
            }
        });
        this.getTableColumns().forEach((column)=>{
            this.layoutColumn(column);
        });
        this.layoutRanges();
    }
    layoutRow(row) {
        var el = row.getElement(), selected = false, occupied = this.ranges.some((range)=>range.occupiesRow(row));
        if (this.selecting === "row") selected = occupied;
        else if (this.selecting === "all") selected = true;
        el.classList.toggle("tabulator-range-selected", selected);
        el.classList.toggle("tabulator-range-highlight", occupied);
    }
    layoutColumn(column) {
        var el = column.getElement(), selected = false, occupied = this.ranges.some((range)=>range.occupiesColumn(column));
        if (this.selecting === "column") selected = occupied;
        else if (this.selecting === "all") selected = true;
        el.classList.toggle("tabulator-range-selected", selected);
        el.classList.toggle("tabulator-range-highlight", occupied);
    }
    layoutRanges() {
        var activeCell, activeCellEl, activeRowEl;
        if (!this.table.initialized) return;
        activeCell = this.getActiveCell();
        if (!activeCell) return;
        activeCellEl = activeCell.getElement();
        activeRowEl = activeCell.row.getElement();
        if (this.table.rtl) this.activeRangeCellElement.style.right = activeRowEl.offsetWidth - activeCellEl.offsetLeft - activeCellEl.offsetWidth + "px";
        else this.activeRangeCellElement.style.left = activeRowEl.offsetLeft + activeCellEl.offsetLeft + "px";
        this.activeRangeCellElement.style.top = activeRowEl.offsetTop + "px";
        this.activeRangeCellElement.style.width = activeCellEl.offsetWidth + "px";
        this.activeRangeCellElement.style.height = activeRowEl.offsetHeight + "px";
        this.ranges.forEach((range)=>range.layout());
        this.overlay.style.visibility = "visible";
    }
    ///////////////////////////////////
    ///////  Helper Functions   ///////
    ///////////////////////////////////	
    getCell(rowIdx, colIdx) {
        var row;
        if (colIdx < 0) {
            colIdx = this.getTableColumns().length + colIdx;
            if (colIdx < 0) return null;
        }
        if (rowIdx < 0) rowIdx = this.getTableRows().length + rowIdx;
        row = this.table.rowManager.getRowFromPosition(rowIdx + 1);
        return row ? row.getCells(false, true).filter((cell)=>cell.column.visible)[colIdx] : null;
    }
    getActiveCell() {
        return this.getCell(this.activeRange.start.row, this.activeRange.start.col);
    }
    getRowByRangePos(pos) {
        return this.getTableRows()[pos];
    }
    getColumnByRangePos(pos) {
        return this.getTableColumns()[pos];
    }
    getTableRows() {
        return this.table.rowManager.getDisplayRows().filter((row)=>row.type === "row");
    }
    getTableColumns() {
        return this.table.columnManager.getVisibleColumnsByIndex();
    }
    addRange(start, end) {
        var range;
        if (this.maxRanges !== true && this.ranges.length >= this.maxRanges) this.ranges.shift().destroy();
        range = new $c2a9788f40f9c90a$var$Range(this.table, this, start, end);
        this.activeRange = range;
        this.ranges.push(range);
        this.rangeContainer.appendChild(range.element);
        return range;
    }
    resetRanges() {
        var range, cell, visibleCells;
        this.ranges.forEach((range)=>range.destroy());
        this.ranges = [];
        range = this.addRange();
        if (this.table.rowManager.activeRows.length) {
            visibleCells = this.table.rowManager.activeRows[0].cells.filter((cell)=>cell.column.visible);
            cell = visibleCells[this.rowHeader ? 1 : 0];
            if (cell) {
                range.setBounds(cell);
                if (this.options("selectableRangeAutoFocus")) this.initializeFocus(cell);
            }
        }
        return range;
    }
    tableDestroyed() {
        document.removeEventListener("mouseup", this.mouseUpEvent);
        this.table.rowManager.element.removeEventListener("keydown", this.keyDownEvent);
    }
    selectedRows(component) {
        return component ? this.activeRange.getRows().map((row)=>row.getComponent()) : this.activeRange.getRows();
    }
    selectedColumns(component) {
        return component ? this.activeRange.getColumns().map((col)=>col.getComponent()) : this.activeRange.getColumns();
    }
    getRowHeaderWidth() {
        if (!this.rowHeader) return 0;
        return this.rowHeader.getElement().offsetWidth;
    }
    isEmpty(value) {
        return value === null || value === undefined || value === "";
    }
}
//sort numbers
function $c2a9788f40f9c90a$var$number(a, b, aRow, bRow, column, dir, params) {
    var alignEmptyValues = params.alignEmptyValues;
    var decimal = params.decimalSeparator;
    var thousand = params.thousandSeparator;
    var emptyAlign = 0;
    a = String(a);
    b = String(b);
    if (thousand) {
        a = a.split(thousand).join("");
        b = b.split(thousand).join("");
    }
    if (decimal) {
        a = a.split(decimal).join(".");
        b = b.split(decimal).join(".");
    }
    a = parseFloat(a);
    b = parseFloat(b);
    //handle non numeric values
    if (isNaN(a)) emptyAlign = isNaN(b) ? 0 : -1;
    else if (isNaN(b)) emptyAlign = 1;
    else //compare valid values
    return a - b;
    //fix empty values in position
    if (alignEmptyValues === "top" && dir === "desc" || alignEmptyValues === "bottom" && dir === "asc") emptyAlign *= -1;
    return emptyAlign;
}
//sort strings
function $c2a9788f40f9c90a$var$string(a, b, aRow, bRow, column, dir, params) {
    var alignEmptyValues = params.alignEmptyValues;
    var emptyAlign = 0;
    var locale;
    //handle empty values
    if (!a) emptyAlign = !b ? 0 : -1;
    else if (!b) emptyAlign = 1;
    else {
        //compare valid values
        switch(typeof params.locale){
            case "boolean":
                if (params.locale) locale = this.langLocale();
                break;
            case "string":
                locale = params.locale;
                break;
        }
        return String(a).toLowerCase().localeCompare(String(b).toLowerCase(), locale);
    }
    //fix empty values in position
    if (alignEmptyValues === "top" && dir === "desc" || alignEmptyValues === "bottom" && dir === "asc") emptyAlign *= -1;
    return emptyAlign;
}
//sort datetime
function $c2a9788f40f9c90a$var$datetime(a, b, aRow, bRow, column, dir, params) {
    var DT = this.table.dependencyRegistry.lookup([
        "luxon",
        "DateTime"
    ], "DateTime");
    var format = params.format || "dd/MM/yyyy HH:mm:ss", alignEmptyValues = params.alignEmptyValues, emptyAlign = 0;
    if (typeof DT != "undefined") {
        if (!DT.isDateTime(a)) {
            if (format === "iso") a = DT.fromISO(String(a));
            else a = DT.fromFormat(String(a), format);
        }
        if (!DT.isDateTime(b)) {
            if (format === "iso") b = DT.fromISO(String(b));
            else b = DT.fromFormat(String(b), format);
        }
        if (!a.isValid) emptyAlign = !b.isValid ? 0 : -1;
        else if (!b.isValid) emptyAlign = 1;
        else //compare valid values
        return a - b;
        //fix empty values in position
        if (alignEmptyValues === "top" && dir === "desc" || alignEmptyValues === "bottom" && dir === "asc") emptyAlign *= -1;
        return emptyAlign;
    } else console.error("Sort Error - 'datetime' sorter is dependant on luxon.js");
}
//sort date
function $c2a9788f40f9c90a$var$date(a, b, aRow, bRow, column, dir, params) {
    if (!params.format) params.format = "dd/MM/yyyy";
    return $c2a9788f40f9c90a$var$datetime.call(this, a, b, aRow, bRow, column, dir, params);
}
//sort times
function $c2a9788f40f9c90a$var$time(a, b, aRow, bRow, column, dir, params) {
    if (!params.format) params.format = "HH:mm";
    return $c2a9788f40f9c90a$var$datetime.call(this, a, b, aRow, bRow, column, dir, params);
}
//sort booleans
function $c2a9788f40f9c90a$var$boolean(a, b, aRow, bRow, column, dir, params) {
    var el1 = a === true || a === "true" || a === "True" || a === 1 ? 1 : 0;
    var el2 = b === true || b === "true" || b === "True" || b === 1 ? 1 : 0;
    return el1 - el2;
}
//sort if element contains any data
function $c2a9788f40f9c90a$var$array(a, b, aRow, bRow, column, dir, params) {
    var type = params.type || "length", alignEmptyValues = params.alignEmptyValues, emptyAlign = 0, table = this.table, valueMap;
    if (params.valueMap) {
        if (typeof params.valueMap === "string") valueMap = function(value) {
            return value.map((item)=>{
                return $c2a9788f40f9c90a$var$Helpers.retrieveNestedData(table.options.nestedFieldSeparator, params.valueMap, item);
            });
        };
        else valueMap = params.valueMap;
    }
    function calc(value) {
        var result;
        if (valueMap) value = valueMap(value);
        switch(type){
            case "length":
                result = value.length;
                break;
            case "sum":
                result = value.reduce(function(c, d) {
                    return c + d;
                });
                break;
            case "max":
                result = Math.max.apply(null, value);
                break;
            case "min":
                result = Math.min.apply(null, value);
                break;
            case "avg":
                result = value.reduce(function(c, d) {
                    return c + d;
                }) / value.length;
                break;
            case "string":
                result = value.join("");
                break;
        }
        return result;
    }
    //handle non array values
    if (!Array.isArray(a)) emptyAlign = !Array.isArray(b) ? 0 : -1;
    else if (!Array.isArray(b)) emptyAlign = 1;
    else {
        if (type === "string") return String(calc(a)).toLowerCase().localeCompare(String(calc(b)).toLowerCase());
        else return calc(b) - calc(a);
    }
    //fix empty values in position
    if (alignEmptyValues === "top" && dir === "desc" || alignEmptyValues === "bottom" && dir === "asc") emptyAlign *= -1;
    return emptyAlign;
}
//sort if element contains any data
function $c2a9788f40f9c90a$var$exists(a, b, aRow, bRow, column, dir, params) {
    var el1 = typeof a == "undefined" ? 0 : 1;
    var el2 = typeof b == "undefined" ? 0 : 1;
    return el1 - el2;
}
//sort alpha numeric strings
function $c2a9788f40f9c90a$var$alphanum(as, bs, aRow, bRow, column, dir, params) {
    var a, b, a1, b1, i = 0, L, rx = /(\d+)|(\D+)/g, rd = /\d/;
    var alignEmptyValues = params.alignEmptyValues;
    var emptyAlign = 0;
    //handle empty values
    if (!as && as !== 0) emptyAlign = !bs && bs !== 0 ? 0 : -1;
    else if (!bs && bs !== 0) emptyAlign = 1;
    else {
        if (isFinite(as) && isFinite(bs)) return as - bs;
        a = String(as).toLowerCase();
        b = String(bs).toLowerCase();
        if (a === b) return 0;
        if (!(rd.test(a) && rd.test(b))) return a > b ? 1 : -1;
        a = a.match(rx);
        b = b.match(rx);
        L = a.length > b.length ? b.length : a.length;
        while(i < L){
            a1 = a[i];
            b1 = b[i++];
            if (a1 !== b1) {
                if (isFinite(a1) && isFinite(b1)) {
                    if (a1.charAt(0) === "0") a1 = "." + a1;
                    if (b1.charAt(0) === "0") b1 = "." + b1;
                    return a1 - b1;
                } else return a1 > b1 ? 1 : -1;
            }
        }
        return a.length > b.length;
    }
    //fix empty values in position
    if (alignEmptyValues === "top" && dir === "desc" || alignEmptyValues === "bottom" && dir === "asc") emptyAlign *= -1;
    return emptyAlign;
}
var $c2a9788f40f9c90a$var$defaultSorters = {
    number: $c2a9788f40f9c90a$var$number,
    string: $c2a9788f40f9c90a$var$string,
    date: $c2a9788f40f9c90a$var$date,
    time: $c2a9788f40f9c90a$var$time,
    datetime: $c2a9788f40f9c90a$var$datetime,
    boolean: $c2a9788f40f9c90a$var$boolean,
    array: $c2a9788f40f9c90a$var$array,
    exists: $c2a9788f40f9c90a$var$exists,
    alphanum: $c2a9788f40f9c90a$var$alphanum
};
class $c2a9788f40f9c90a$export$5b492eb49d632e3f extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "sort";
    //load defaults
    static sorters = $c2a9788f40f9c90a$var$defaultSorters;
    constructor(table){
        super(table);
        this.sortList = []; //holder current sort
        this.changed = false; //has the sort changed since last render
        this.registerTableOption("sortMode", "local"); //local or remote sorting
        this.registerTableOption("initialSort", false); //initial sorting criteria
        this.registerTableOption("columnHeaderSortMulti", true); //multiple or single column sorting
        this.registerTableOption("sortOrderReverse", false); //reverse internal sort ordering
        this.registerTableOption("headerSortElement", "<div class='tabulator-arrow'></div>"); //header sort element
        this.registerTableOption("headerSortClickElement", "header"); //element which triggers sort when clicked
        this.registerColumnOption("sorter");
        this.registerColumnOption("sorterParams");
        this.registerColumnOption("headerSort", true);
        this.registerColumnOption("headerSortStartingDir");
        this.registerColumnOption("headerSortTristate");
    }
    initialize() {
        this.subscribe("column-layout", this.initializeColumn.bind(this));
        this.subscribe("table-built", this.tableBuilt.bind(this));
        this.registerDataHandler(this.sort.bind(this), 20);
        this.registerTableFunction("setSort", this.userSetSort.bind(this));
        this.registerTableFunction("getSorters", this.getSort.bind(this));
        this.registerTableFunction("clearSort", this.clearSort.bind(this));
        if (this.table.options.sortMode === "remote") this.subscribe("data-params", this.remoteSortParams.bind(this));
    }
    tableBuilt() {
        if (this.table.options.initialSort) this.setSort(this.table.options.initialSort);
    }
    remoteSortParams(data, config, silent, params) {
        var sorters = this.getSort();
        sorters.forEach((item)=>{
            delete item.column;
        });
        params.sort = sorters;
        return params;
    }
    ///////////////////////////////////
    ///////// Table Functions /////////
    ///////////////////////////////////
    userSetSort(sortList, dir) {
        this.setSort(sortList, dir);
        // this.table.rowManager.sorterRefresh();
        this.refreshSort();
    }
    clearSort() {
        this.clear();
        // this.table.rowManager.sorterRefresh();
        this.refreshSort();
    }
    ///////////////////////////////////
    ///////// Internal Logic //////////
    ///////////////////////////////////
    //initialize column header for sorting
    initializeColumn(column) {
        var sorter = false, colEl, arrowEl;
        switch(typeof column.definition.sorter){
            case "string":
                if ($c2a9788f40f9c90a$export$5b492eb49d632e3f.sorters[column.definition.sorter]) sorter = $c2a9788f40f9c90a$export$5b492eb49d632e3f.sorters[column.definition.sorter];
                else console.warn("Sort Error - No such sorter found: ", column.definition.sorter);
                break;
            case "function":
                sorter = column.definition.sorter;
                break;
        }
        column.modules.sort = {
            sorter: sorter,
            dir: "none",
            params: column.definition.sorterParams || {},
            startingDir: column.definition.headerSortStartingDir || "asc",
            tristate: column.definition.headerSortTristate
        };
        if (column.definition.headerSort !== false) {
            colEl = column.getElement();
            colEl.classList.add("tabulator-sortable");
            arrowEl = document.createElement("div");
            arrowEl.classList.add("tabulator-col-sorter");
            switch(this.table.options.headerSortClickElement){
                case "icon":
                    arrowEl.classList.add("tabulator-col-sorter-element");
                    break;
                case "header":
                    colEl.classList.add("tabulator-col-sorter-element");
                    break;
                default:
                    colEl.classList.add("tabulator-col-sorter-element");
                    break;
            }
            switch(this.table.options.headerSortElement){
                case "function":
                    break;
                case "object":
                    arrowEl.appendChild(this.table.options.headerSortElement);
                    break;
                default:
                    arrowEl.innerHTML = this.table.options.headerSortElement;
            }
            //create sorter arrow
            column.titleHolderElement.appendChild(arrowEl);
            column.modules.sort.element = arrowEl;
            this.setColumnHeaderSortIcon(column, "none");
            if (this.table.options.headerSortClickElement === "icon") arrowEl.addEventListener("mousedown", (e)=>{
                e.stopPropagation();
            });
            //sort on click
            (this.table.options.headerSortClickElement === "icon" ? arrowEl : colEl).addEventListener("click", (e)=>{
                var dir = "", sorters = [], match = false;
                if (column.modules.sort) {
                    if (column.modules.sort.tristate) {
                        if (column.modules.sort.dir == "none") dir = column.modules.sort.startingDir;
                        else if (column.modules.sort.dir == column.modules.sort.startingDir) dir = column.modules.sort.dir == "asc" ? "desc" : "asc";
                        else dir = "none";
                    } else switch(column.modules.sort.dir){
                        case "asc":
                            dir = "desc";
                            break;
                        case "desc":
                            dir = "asc";
                            break;
                        default:
                            dir = column.modules.sort.startingDir;
                    }
                    if (this.table.options.columnHeaderSortMulti && (e.shiftKey || e.ctrlKey)) {
                        sorters = this.getSort();
                        match = sorters.findIndex((sorter)=>{
                            return sorter.field === column.getField();
                        });
                        if (match > -1) {
                            sorters[match].dir = dir;
                            match = sorters.splice(match, 1)[0];
                            if (dir != "none") sorters.push(match);
                        } else if (dir != "none") sorters.push({
                            column: column,
                            dir: dir
                        });
                        //add to existing sort
                        this.setSort(sorters);
                    } else if (dir == "none") this.clear();
                    else //sort by column only
                    this.setSort(column, dir);
                    // this.table.rowManager.sorterRefresh(!this.sortList.length);
                    this.refreshSort();
                }
            });
        }
    }
    refreshSort() {
        if (this.table.options.sortMode === "remote") this.reloadData(null, false, false);
        else this.refreshData(true);
    //TODO - Persist left position of row manager
    // left = this.scrollLeft;
    // this.scrollHorizontal(left);
    }
    //check if the sorters have changed since last use
    hasChanged() {
        var changed = this.changed;
        this.changed = false;
        return changed;
    }
    //return current sorters
    getSort() {
        var self = this, sorters = [];
        self.sortList.forEach(function(item) {
            if (item.column) sorters.push({
                column: item.column.getComponent(),
                field: item.column.getField(),
                dir: item.dir
            });
        });
        return sorters;
    }
    //change sort list and trigger sort
    setSort(sortList, dir) {
        var self = this, newSortList = [];
        if (!Array.isArray(sortList)) sortList = [
            {
                column: sortList,
                dir: dir
            }
        ];
        sortList.forEach(function(item) {
            var column;
            column = self.table.columnManager.findColumn(item.column);
            if (column) {
                item.column = column;
                newSortList.push(item);
                self.changed = true;
            } else console.warn("Sort Warning - Sort field does not exist and is being ignored: ", item.column);
        });
        self.sortList = newSortList;
        this.dispatch("sort-changed");
    }
    //clear sorters
    clear() {
        this.setSort([]);
    }
    //find appropriate sorter for column
    findSorter(column) {
        var row = this.table.rowManager.activeRows[0], sorter = "string", field, value;
        if (row) {
            row = row.getData();
            field = column.getField();
            if (field) {
                value = column.getFieldValue(row);
                switch(typeof value){
                    case "undefined":
                        sorter = "string";
                        break;
                    case "boolean":
                        sorter = "boolean";
                        break;
                    default:
                        if (!isNaN(value) && value !== "") sorter = "number";
                        else if (value.match(/((^[0-9]+[a-z]+)|(^[a-z]+[0-9]+))+$/i)) sorter = "alphanum";
                        break;
                }
            }
        }
        return $c2a9788f40f9c90a$export$5b492eb49d632e3f.sorters[sorter];
    }
    //work through sort list sorting data
    sort(data, sortOnly) {
        var self = this, sortList = this.table.options.sortOrderReverse ? self.sortList.slice().reverse() : self.sortList, sortListActual = [], rowComponents = [];
        if (this.subscribedExternal("dataSorting")) this.dispatchExternal("dataSorting", self.getSort());
        if (!sortOnly) self.clearColumnHeaders();
        if (this.table.options.sortMode !== "remote") {
            //build list of valid sorters and trigger column specific callbacks before sort begins
            sortList.forEach(function(item, i) {
                var sortObj;
                if (item.column) {
                    sortObj = item.column.modules.sort;
                    if (sortObj) {
                        //if no sorter has been defined, take a guess
                        if (!sortObj.sorter) sortObj.sorter = self.findSorter(item.column);
                        item.params = typeof sortObj.params === "function" ? sortObj.params(item.column.getComponent(), item.dir) : sortObj.params;
                        sortListActual.push(item);
                    }
                    if (!sortOnly) self.setColumnHeader(item.column, item.dir);
                }
            });
            //sort data
            if (sortListActual.length) self._sortItems(data, sortListActual);
        } else if (!sortOnly) sortList.forEach(function(item, i) {
            self.setColumnHeader(item.column, item.dir);
        });
        if (this.subscribedExternal("dataSorted")) {
            data.forEach((row)=>{
                rowComponents.push(row.getComponent());
            });
            this.dispatchExternal("dataSorted", self.getSort(), rowComponents);
        }
        return data;
    }
    //clear sort arrows on columns
    clearColumnHeaders() {
        this.table.columnManager.getRealColumns().forEach((column)=>{
            if (column.modules.sort) {
                column.modules.sort.dir = "none";
                column.getElement().setAttribute("aria-sort", "none");
                this.setColumnHeaderSortIcon(column, "none");
            }
        });
    }
    //set the column header sort direction
    setColumnHeader(column, dir) {
        column.modules.sort.dir = dir;
        column.getElement().setAttribute("aria-sort", dir === "asc" ? "ascending" : "descending");
        this.setColumnHeaderSortIcon(column, dir);
    }
    setColumnHeaderSortIcon(column, dir) {
        var sortEl = column.modules.sort.element, arrowEl;
        if (column.definition.headerSort && typeof this.table.options.headerSortElement === "function") {
            while(sortEl.firstChild)sortEl.removeChild(sortEl.firstChild);
            arrowEl = this.table.options.headerSortElement.call(this.table, column.getComponent(), dir);
            if (typeof arrowEl === "object") sortEl.appendChild(arrowEl);
            else sortEl.innerHTML = arrowEl;
        }
    }
    //sort each item in sort list
    _sortItems(data, sortList) {
        var sorterCount = sortList.length - 1;
        data.sort((a, b)=>{
            var result;
            for(var i = sorterCount; i >= 0; i--){
                let sortItem = sortList[i];
                result = this._sortRow(a, b, sortItem.column, sortItem.dir, sortItem.params);
                if (result !== 0) break;
            }
            return result;
        });
    }
    //process individual rows for a sort function on active data
    _sortRow(a, b, column, dir, params) {
        var el1Comp, el2Comp;
        //switch elements depending on search direction
        var el1 = dir == "asc" ? a : b;
        var el2 = dir == "asc" ? b : a;
        a = column.getFieldValue(el1.getData());
        b = column.getFieldValue(el2.getData());
        a = typeof a !== "undefined" ? a : "";
        b = typeof b !== "undefined" ? b : "";
        el1Comp = el1.getComponent();
        el2Comp = el2.getComponent();
        return column.modules.sort.sorter.call(this, a, b, el1Comp, el2Comp, column.getComponent(), dir, params);
    }
}
class $c2a9788f40f9c90a$var$GridCalculator {
    constructor(columns, rows){
        this.columnCount = columns;
        this.rowCount = rows;
        this.columnString = [];
        this.columns = [];
        this.rows = [];
    }
    genColumns(data) {
        var colCount = Math.max(this.columnCount, Math.max(...data.map((item)=>item.length)));
        this.columnString = [];
        this.columns = [];
        for(let i = 1; i <= colCount; i++){
            this.incrementChar(this.columnString.length - 1);
            this.columns.push(this.columnString.join(""));
        }
        return this.columns;
    }
    genRows(data) {
        var rowCount = Math.max(this.rowCount, data.length);
        this.rows = [];
        for(let i = 1; i <= rowCount; i++)this.rows.push(i);
        return this.rows;
    }
    incrementChar(i) {
        let char = this.columnString[i];
        if (char) {
            if (char !== "Z") this.columnString[i] = String.fromCharCode(this.columnString[i].charCodeAt(0) + 1);
            else {
                this.columnString[i] = "A";
                if (i) this.incrementChar(i - 1);
                else this.columnString.push("A");
            }
        } else this.columnString.push("A");
    }
    setRowCount(count) {
        this.rowCount = count;
    }
    setColumnCount(count) {
        this.columnCount = count;
    }
}
class $c2a9788f40f9c90a$export$bcf87d11d46ea94f {
    constructor(sheet){
        this._sheet = sheet;
        return new Proxy(this, {
            get: function(target, name, receiver) {
                if (typeof target[name] !== "undefined") return target[name];
                else return target._sheet.table.componentFunctionBinder.handle("sheet", target._sheet, name);
            }
        });
    }
    getTitle() {
        return this._sheet.title;
    }
    getKey() {
        return this._sheet.key;
    }
    getDefinition() {
        return this._sheet.getDefinition();
    }
    getData() {
        return this._sheet.getData();
    }
    setData(data) {
        return this._sheet.setData(data);
    }
    clear() {
        return this._sheet.clear();
    }
    remove() {
        return this._sheet.remove();
    }
    active() {
        return this._sheet.active();
    }
    setTitle(title) {
        return this._sheet.setTitle(title);
    }
    setRows(rows) {
        return this._sheet.setRows(rows);
    }
    setColumns(columns) {
        return this._sheet.setColumns(columns);
    }
}
class $c2a9788f40f9c90a$var$Sheet extends $c2a9788f40f9c90a$var$CoreFeature {
    constructor(spreadsheetManager, definition){
        super(spreadsheetManager.table);
        this.spreadsheetManager = spreadsheetManager;
        this.definition = definition;
        this.title = this.definition.title || "";
        this.key = this.definition.key || this.definition.title;
        this.rowCount = this.definition.rows;
        this.columnCount = this.definition.columns;
        this.data = this.definition.data || [];
        this.element = null;
        this.isActive = false;
        this.grid = new $c2a9788f40f9c90a$var$GridCalculator(this.columnCount, this.rowCount);
        this.defaultColumnDefinition = {
            width: 100,
            headerHozAlign: "center",
            headerSort: false
        };
        this.columnDefinition = Object.assign(this.defaultColumnDefinition, this.options("spreadsheetColumnDefinition"));
        this.columnDefs = [];
        this.rowDefs = [];
        this.columnFields = [];
        this.columns = [];
        this.rows = [];
        this.scrollTop = null;
        this.scrollLeft = null;
        this.initialize();
        this.dispatchExternal("sheetAdded", this.getComponent());
    }
    ///////////////////////////////////
    ///////// Initialization //////////
    ///////////////////////////////////
    initialize() {
        this.initializeElement();
        this.initializeColumns();
        this.initializeRows();
    }
    reinitialize() {
        this.initializeColumns();
        this.initializeRows();
    }
    initializeElement() {
        this.element = document.createElement("div");
        this.element.classList.add("tabulator-spreadsheet-tab");
        this.element.innerText = this.title;
        this.element.addEventListener("click", ()=>{
            this.spreadsheetManager.loadSheet(this);
        });
    }
    initializeColumns() {
        this.grid.setColumnCount(this.columnCount);
        this.columnFields = this.grid.genColumns(this.data);
        this.columnDefs = [];
        this.columnFields.forEach((ref)=>{
            var def = Object.assign({}, this.columnDefinition);
            def.field = ref;
            def.title = ref;
            this.columnDefs.push(def);
        });
    }
    initializeRows() {
        var refs;
        this.grid.setRowCount(this.rowCount);
        refs = this.grid.genRows(this.data);
        this.rowDefs = [];
        refs.forEach((ref, i)=>{
            var def = {
                "_id": ref
            };
            var data = this.data[i];
            if (data) data.forEach((val, j)=>{
                var field = this.columnFields[j];
                if (field) def[field] = val;
            });
            this.rowDefs.push(def);
        });
    }
    unload() {
        this.isActive = false;
        this.scrollTop = this.table.rowManager.scrollTop;
        this.scrollLeft = this.table.rowManager.scrollLeft;
        this.data = this.getData(true);
        this.element.classList.remove("tabulator-spreadsheet-tab-active");
    }
    load() {
        var wasInactive = !this.isActive;
        this.isActive = true;
        this.table.blockRedraw();
        this.table.setData([]);
        this.table.setColumns(this.columnDefs);
        this.table.setData(this.rowDefs);
        this.table.restoreRedraw();
        if (wasInactive && this.scrollTop !== null) {
            this.table.rowManager.element.scrollLeft = this.scrollLeft;
            this.table.rowManager.element.scrollTop = this.scrollTop;
        }
        this.element.classList.add("tabulator-spreadsheet-tab-active");
        this.dispatchExternal("sheetLoaded", this.getComponent());
    }
    ///////////////////////////////////
    //////// Helper Functions /////////
    ///////////////////////////////////
    getComponent() {
        return new $c2a9788f40f9c90a$export$bcf87d11d46ea94f(this);
    }
    getDefinition() {
        return {
            title: this.title,
            key: this.key,
            rows: this.rowCount,
            columns: this.columnCount,
            data: this.getData()
        };
    }
    getData(full) {
        var output = [], rowWidths, outputWidth, outputHeight;
        //map data to array format
        this.rowDefs.forEach((rowData)=>{
            var row = [];
            this.columnFields.forEach((field)=>{
                row.push(rowData[field]);
            });
            output.push(row);
        });
        //trim output
        if (!full && !this.options("spreadsheetOutputFull")) {
            //calculate used area of data
            rowWidths = output.map((row)=>row.findLastIndex((val)=>typeof val !== 'undefined') + 1);
            outputWidth = Math.max(...rowWidths);
            outputHeight = rowWidths.findLastIndex((width)=>width > 0) + 1;
            output = output.slice(0, outputHeight);
            output = output.map((row)=>row.slice(0, outputWidth));
        }
        return output;
    }
    setData(data) {
        this.data = data;
        this.reinitialize();
        this.dispatchExternal("sheetUpdated", this.getComponent());
        if (this.isActive) this.load();
    }
    clear() {
        this.setData([]);
    }
    setTitle(title) {
        this.title = title;
        this.element.innerText = title;
        this.dispatchExternal("sheetUpdated", this.getComponent());
    }
    setRows(rows) {
        this.rowCount = rows;
        this.initializeRows();
        this.dispatchExternal("sheetUpdated", this.getComponent());
        if (this.isActive) this.load();
    }
    setColumns(columns) {
        this.columnCount = columns;
        this.reinitialize();
        this.dispatchExternal("sheetUpdated", this.getComponent());
        if (this.isActive) this.load();
    }
    remove() {
        this.spreadsheetManager.removeSheet(this);
    }
    destroy() {
        if (this.element.parentNode) this.element.parentNode.removeChild(this.element);
        this.dispatchExternal("sheetRemoved", this.getComponent());
    }
    active() {
        this.spreadsheetManager.loadSheet(this);
    }
}
class $c2a9788f40f9c90a$export$bbb96e34680d7364 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "spreadsheet";
    constructor(table){
        super(table);
        this.sheets = [];
        this.element = null;
        this.registerTableOption("spreadsheet", false);
        this.registerTableOption("spreadsheetRows", 50);
        this.registerTableOption("spreadsheetColumns", 50);
        this.registerTableOption("spreadsheetColumnDefinition", {});
        this.registerTableOption("spreadsheetOutputFull", false);
        this.registerTableOption("spreadsheetData", false);
        this.registerTableOption("spreadsheetSheets", false);
        this.registerTableOption("spreadsheetSheetTabs", false);
        this.registerTableOption("spreadsheetSheetTabsElement", false);
        this.registerTableFunction("setSheets", this.setSheets.bind(this));
        this.registerTableFunction("addSheet", this.addSheet.bind(this));
        this.registerTableFunction("getSheets", this.getSheets.bind(this));
        this.registerTableFunction("getSheetDefinitions", this.getSheetDefinitions.bind(this));
        this.registerTableFunction("setSheetData", this.setSheetData.bind(this));
        this.registerTableFunction("getSheet", this.getSheet.bind(this));
        this.registerTableFunction("getSheetData", this.getSheetData.bind(this));
        this.registerTableFunction("clearSheet", this.clearSheet.bind(this));
        this.registerTableFunction("removeSheet", this.removeSheetFunc.bind(this));
        this.registerTableFunction("activeSheet", this.activeSheetFunc.bind(this));
    }
    ///////////////////////////////////
    ////// Module Initialization //////
    ///////////////////////////////////
    initialize() {
        if (this.options("spreadsheet")) {
            this.subscribe("table-initialized", this.tableInitialized.bind(this));
            this.subscribe("data-loaded", this.loadRemoteData.bind(this));
            this.table.options.index = "_id";
            if (this.options("spreadsheetData") && this.options("spreadsheetSheets")) {
                console.warn("You cannot use spreadsheetData and spreadsheetSheets at the same time, ignoring spreadsheetData");
                this.table.options.spreadsheetData = false;
            }
            this.compatibilityCheck();
            if (this.options("spreadsheetSheetTabs")) this.initializeTabset();
        }
    }
    compatibilityCheck() {
        if (this.options("data")) console.warn("Do not use the data option when working with spreadsheets, use either spreadsheetData or spreadsheetSheets to pass data into the table");
        if (this.options("pagination")) console.warn("The spreadsheet module is not compatible with the pagination module");
        if (this.options("groupBy")) console.warn("The spreadsheet module is not compatible with the row grouping module");
        if (this.options("responsiveCollapse")) console.warn("The spreadsheet module is not compatible with the responsive collapse module");
    }
    initializeTabset() {
        this.element = document.createElement("div");
        this.element.classList.add("tabulator-spreadsheet-tabs");
        var altContainer = this.options("spreadsheetSheetTabsElement");
        if (altContainer && !(altContainer instanceof HTMLElement)) {
            altContainer = document.querySelector(altContainer);
            if (!altContainer) console.warn("Unable to find element matching spreadsheetSheetTabsElement selector:", this.options("spreadsheetSheetTabsElement"));
        }
        if (altContainer) altContainer.appendChild(this.element);
        else this.footerAppend(this.element);
    }
    tableInitialized() {
        if (this.sheets.length) this.loadSheet(this.sheets[0]);
        else {
            if (this.options("spreadsheetSheets")) this.loadSheets(this.options("spreadsheetSheets"));
            else if (this.options("spreadsheetData")) this.loadData(this.options("spreadsheetData"));
        }
    }
    ///////////////////////////////////
    /////////// Ajax Parsing //////////
    ///////////////////////////////////
    loadRemoteData(data, data1, data2) {
        console.log("data", data, data1, data2);
        if (Array.isArray(data)) {
            this.table.dataLoader.clearAlert();
            this.dispatchExternal("dataLoaded", data);
            if (!data.length || Array.isArray(data[0])) this.loadData(data);
            else this.loadSheets(data);
        } else console.error("Spreadsheet Loading Error - Unable to process remote data due to invalid data type \nExpecting: array \nReceived: ", typeof data, "\nData:     ", data);
        return false;
    }
    ///////////////////////////////////
    ///////// Sheet Management ////////
    ///////////////////////////////////
    loadData(data) {
        var def = {
            data: data
        };
        this.loadSheet(this.newSheet(def));
    }
    destroySheets() {
        this.sheets.forEach((sheet)=>{
            sheet.destroy();
        });
        this.sheets = [];
        this.activeSheet = null;
    }
    loadSheets(sheets) {
        if (!Array.isArray(sheets)) sheets = [];
        this.destroySheets();
        sheets.forEach((def)=>{
            this.newSheet(def);
        });
        this.loadSheet(this.sheets[0]);
    }
    loadSheet(sheet) {
        if (this.activeSheet !== sheet) {
            if (this.activeSheet) this.activeSheet.unload();
            this.activeSheet = sheet;
            sheet.load();
        }
    }
    newSheet(definition = {}) {
        var sheet;
        if (!definition.rows) definition.rows = this.options("spreadsheetRows");
        if (!definition.columns) definition.columns = this.options("spreadsheetColumns");
        sheet = new $c2a9788f40f9c90a$var$Sheet(this, definition);
        this.sheets.push(sheet);
        if (this.element) this.element.appendChild(sheet.element);
        return sheet;
    }
    removeSheet(sheet) {
        var index = this.sheets.indexOf(sheet), prevSheet;
        if (this.sheets.length > 1) {
            if (index > -1) {
                this.sheets.splice(index, 1);
                sheet.destroy();
                if (this.activeSheet === sheet) {
                    prevSheet = this.sheets[index - 1] || this.sheets[0];
                    if (prevSheet) this.loadSheet(prevSheet);
                    else this.activeSheet = null;
                }
            }
        } else console.warn("Unable to remove sheet, at least one sheet must be active");
    }
    lookupSheet(key) {
        if (!key) return this.activeSheet;
        else if (key instanceof $c2a9788f40f9c90a$var$Sheet) return key;
        else if (key instanceof $c2a9788f40f9c90a$export$bcf87d11d46ea94f) return key._sheet;
        else return this.sheets.find((sheet)=>sheet.key === key) || false;
    }
    ///////////////////////////////////
    //////// Public Functions /////////
    ///////////////////////////////////
    setSheets(sheets) {
        this.loadSheets(sheets);
        return this.getSheets();
    }
    addSheet(sheet) {
        return this.newSheet(sheet).getComponent();
    }
    getSheetDefinitions() {
        return this.sheets.map((sheet)=>sheet.getDefinition());
    }
    getSheets() {
        return this.sheets.map((sheet)=>sheet.getComponent());
    }
    getSheet(key) {
        var sheet = this.lookupSheet(key);
        return sheet ? sheet.getComponent() : false;
    }
    setSheetData(key, data) {
        if (key && !data) {
            data = key;
            key = false;
        }
        var sheet = this.lookupSheet(key);
        return sheet ? sheet.setData(data) : false;
    }
    getSheetData(key) {
        var sheet = this.lookupSheet(key);
        return sheet ? sheet.getData() : false;
    }
    clearSheet(key) {
        var sheet = this.lookupSheet(key);
        return sheet ? sheet.clear() : false;
    }
    removeSheetFunc(key) {
        var sheet = this.lookupSheet(key);
        if (sheet) this.removeSheet(sheet);
    }
    activeSheetFunc(key) {
        var sheet = this.lookupSheet(key);
        return sheet ? this.loadSheet(sheet) : false;
    }
}
class $c2a9788f40f9c90a$export$d0c662c133b8814e extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "tooltip";
    constructor(table){
        super(table);
        this.tooltipSubscriber = null, this.headerSubscriber = null, this.timeout = null;
        this.popupInstance = null;
        // this.registerTableOption("tooltipGenerationMode", undefined);  //deprecated
        this.registerTableOption("tooltipDelay", 300);
        this.registerColumnOption("tooltip");
        this.registerColumnOption("headerTooltip");
    }
    initialize() {
        this.deprecatedOptionsCheck();
        this.subscribe("column-init", this.initializeColumn.bind(this));
    }
    deprecatedOptionsCheck() {
    // this.deprecationCheckMsg("tooltipGenerationMode", "This option is no longer needed as tooltips are always generated on hover now");
    }
    initializeColumn(column) {
        if (column.definition.headerTooltip && !this.headerSubscriber) {
            this.headerSubscriber = true;
            this.subscribe("column-mousemove", this.mousemoveCheck.bind(this, "headerTooltip"));
            this.subscribe("column-mouseout", this.mouseoutCheck.bind(this, "headerTooltip"));
        }
        if (column.definition.tooltip && !this.tooltipSubscriber) {
            this.tooltipSubscriber = true;
            this.subscribe("cell-mousemove", this.mousemoveCheck.bind(this, "tooltip"));
            this.subscribe("cell-mouseout", this.mouseoutCheck.bind(this, "tooltip"));
        }
    }
    mousemoveCheck(action, e, component) {
        var tooltip = action === "tooltip" ? component.column.definition.tooltip : component.definition.headerTooltip;
        if (tooltip) {
            this.clearPopup();
            this.timeout = setTimeout(this.loadTooltip.bind(this, e, component, tooltip), this.table.options.tooltipDelay);
        }
    }
    mouseoutCheck(action, e, component) {
        if (!this.popupInstance) this.clearPopup();
    }
    clearPopup(action, e, component) {
        clearTimeout(this.timeout);
        this.timeout = null;
        if (this.popupInstance) this.popupInstance.hide();
    }
    loadTooltip(e, component, tooltip) {
        var contentsEl, renderedCallback, coords;
        function onRendered(callback) {
            renderedCallback = callback;
        }
        if (typeof tooltip === "function") tooltip = tooltip(e, component.getComponent(), onRendered);
        if (tooltip instanceof HTMLElement) contentsEl = tooltip;
        else {
            contentsEl = document.createElement("div");
            if (tooltip === true) {
                if (component instanceof $c2a9788f40f9c90a$var$Cell) tooltip = component.value;
                else if (component.definition.field) this.langBind("columns|" + component.definition.field, (value)=>{
                    contentsEl.innerHTML = tooltip = value || component.definition.title;
                });
                else tooltip = component.definition.title;
            }
            contentsEl.innerHTML = tooltip;
        }
        if (tooltip || tooltip === 0 || tooltip === false) {
            contentsEl.classList.add("tabulator-tooltip");
            contentsEl.addEventListener("mousemove", (e)=>e.preventDefault());
            this.popupInstance = this.popup(contentsEl);
            if (typeof renderedCallback === "function") this.popupInstance.renderCallback(renderedCallback);
            coords = this.popupInstance.containerEventCoords(e);
            this.popupInstance.show(coords.x + 15, coords.y + 15).hideOnBlur(()=>{
                this.dispatchExternal("TooltipClosed", component.getComponent());
                this.popupInstance = null;
            });
            this.dispatchExternal("TooltipOpened", component.getComponent());
        }
    }
}
var $c2a9788f40f9c90a$var$defaultValidators = {
    //is integer
    integer: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        value = Number(value);
        return !isNaN(value) && isFinite(value) && Math.floor(value) === value;
    },
    //is float
    float: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        value = Number(value);
        return !isNaN(value) && isFinite(value) && value % 1 !== 0;
    },
    //must be a number
    numeric: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        return !isNaN(value);
    },
    //must be a string
    string: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        return isNaN(value);
    },
    //must be alphanumeric
    alphanumeric: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        var reg = new RegExp(/^[a-z0-9]+$/i);
        return reg.test(value);
    },
    //maximum value
    max: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        return parseFloat(value) <= parameters;
    },
    //minimum value
    min: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        return parseFloat(value) >= parameters;
    },
    //starts with  value
    starts: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        return String(value).toLowerCase().startsWith(String(parameters).toLowerCase());
    },
    //ends with  value
    ends: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        return String(value).toLowerCase().endsWith(String(parameters).toLowerCase());
    },
    //minimum string length
    minLength: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        return String(value).length >= parameters;
    },
    //maximum string length
    maxLength: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        return String(value).length <= parameters;
    },
    //in provided value list
    in: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        if (typeof parameters == "string") parameters = parameters.split("|");
        return parameters.indexOf(value) > -1;
    },
    //must match provided regex
    regex: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        var reg = new RegExp(parameters);
        return reg.test(value);
    },
    //value must be unique in this column
    unique: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        var unique = true;
        var cellData = cell.getData();
        var column = cell.getColumn()._getSelf();
        this.table.rowManager.rows.forEach(function(row) {
            var data = row.getData();
            if (data !== cellData) {
                if (value == column.getFieldValue(data)) unique = false;
            }
        });
        return unique;
    },
    //must have a value
    required: function(cell, value, parameters) {
        return value !== "" && value !== null && typeof value !== "undefined";
    }
};
class $c2a9788f40f9c90a$export$db48c5a2fa1f03d4 extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "validate";
    //load defaults
    static validators = $c2a9788f40f9c90a$var$defaultValidators;
    constructor(table){
        super(table);
        this.invalidCells = [];
        this.registerTableOption("validationMode", "blocking");
        this.registerColumnOption("validator");
        this.registerTableFunction("getInvalidCells", this.getInvalidCells.bind(this));
        this.registerTableFunction("clearCellValidation", this.userClearCellValidation.bind(this));
        this.registerTableFunction("validate", this.userValidate.bind(this));
        this.registerComponentFunction("cell", "isValid", this.cellIsValid.bind(this));
        this.registerComponentFunction("cell", "clearValidation", this.clearValidation.bind(this));
        this.registerComponentFunction("cell", "validate", this.cellValidate.bind(this));
        this.registerComponentFunction("column", "validate", this.columnValidate.bind(this));
        this.registerComponentFunction("row", "validate", this.rowValidate.bind(this));
    }
    initialize() {
        this.subscribe("cell-delete", this.clearValidation.bind(this));
        this.subscribe("column-layout", this.initializeColumnCheck.bind(this));
        this.subscribe("edit-success", this.editValidate.bind(this));
        this.subscribe("edit-editor-clear", this.editorClear.bind(this));
        this.subscribe("edit-edited-clear", this.editedClear.bind(this));
    }
    ///////////////////////////////////
    ///////// Event Handling //////////
    ///////////////////////////////////
    editValidate(cell, value, previousValue) {
        var valid = this.table.options.validationMode !== "manual" ? this.validate(cell.column.modules.validate, cell, value) : true;
        // allow time for editor to make render changes then style cell
        if (valid !== true) setTimeout(()=>{
            cell.getElement().classList.add("tabulator-validation-fail");
            this.dispatchExternal("validationFailed", cell.getComponent(), value, valid);
        });
        return valid;
    }
    editorClear(cell, cancelled) {
        if (cancelled) {
            if (cell.column.modules.validate) this.cellValidate(cell);
        }
        cell.getElement().classList.remove("tabulator-validation-fail");
    }
    editedClear(cell) {
        if (cell.modules.validate) cell.modules.validate.invalid = false;
    }
    ///////////////////////////////////
    ////////// Cell Functions /////////
    ///////////////////////////////////
    cellIsValid(cell) {
        return cell.modules.validate ? cell.modules.validate.invalid || true : true;
    }
    cellValidate(cell) {
        return this.validate(cell.column.modules.validate, cell, cell.getValue());
    }
    ///////////////////////////////////
    ///////// Column Functions ////////
    ///////////////////////////////////
    columnValidate(column) {
        var invalid = [];
        column.cells.forEach((cell)=>{
            if (this.cellValidate(cell) !== true) invalid.push(cell.getComponent());
        });
        return invalid.length ? invalid : true;
    }
    ///////////////////////////////////
    ////////// Row Functions //////////
    ///////////////////////////////////
    rowValidate(row) {
        var invalid = [];
        row.cells.forEach((cell)=>{
            if (this.cellValidate(cell) !== true) invalid.push(cell.getComponent());
        });
        return invalid.length ? invalid : true;
    }
    ///////////////////////////////////
    ///////// Table Functions /////////
    ///////////////////////////////////
    userClearCellValidation(cells) {
        if (!cells) cells = this.getInvalidCells();
        if (!Array.isArray(cells)) cells = [
            cells
        ];
        cells.forEach((cell)=>{
            this.clearValidation(cell._getSelf());
        });
    }
    userValidate(cells) {
        var output = [];
        //clear row data
        this.table.rowManager.rows.forEach((row)=>{
            row = row.getComponent();
            var valid = row.validate();
            if (valid !== true) output = output.concat(valid);
        });
        return output.length ? output : true;
    }
    ///////////////////////////////////
    ///////// Internal Logic //////////
    ///////////////////////////////////
    initializeColumnCheck(column) {
        if (typeof column.definition.validator !== "undefined") this.initializeColumn(column);
    }
    //validate
    initializeColumn(column) {
        var self = this, config = [], validator;
        if (column.definition.validator) {
            if (Array.isArray(column.definition.validator)) column.definition.validator.forEach((item)=>{
                validator = self._extractValidator(item);
                if (validator) config.push(validator);
            });
            else {
                validator = this._extractValidator(column.definition.validator);
                if (validator) config.push(validator);
            }
            column.modules.validate = config.length ? config : false;
        }
    }
    _extractValidator(value) {
        var type, params, pos;
        switch(typeof value){
            case "string":
                pos = value.indexOf(':');
                if (pos > -1) {
                    type = value.substring(0, pos);
                    params = value.substring(pos + 1);
                } else type = value;
                return this._buildValidator(type, params);
            case "function":
                return this._buildValidator(value);
            case "object":
                return this._buildValidator(value.type, value.parameters);
        }
    }
    _buildValidator(type, params) {
        var func = typeof type == "function" ? type : $c2a9788f40f9c90a$export$db48c5a2fa1f03d4.validators[type];
        if (!func) {
            console.warn("Validator Setup Error - No matching validator found:", type);
            return false;
        } else return {
            type: typeof type == "function" ? "function" : type,
            func: func,
            params: params
        };
    }
    validate(validators, cell, value) {
        var self = this, failedValidators = [], invalidIndex = this.invalidCells.indexOf(cell);
        if (validators) validators.forEach((item)=>{
            if (!item.func.call(self, cell.getComponent(), value, item.params)) failedValidators.push({
                type: item.type,
                parameters: item.params
            });
        });
        if (!cell.modules.validate) cell.modules.validate = {};
        if (!failedValidators.length) {
            cell.modules.validate.invalid = false;
            cell.getElement().classList.remove("tabulator-validation-fail");
            if (invalidIndex > -1) this.invalidCells.splice(invalidIndex, 1);
        } else {
            cell.modules.validate.invalid = failedValidators;
            if (this.table.options.validationMode !== "manual") cell.getElement().classList.add("tabulator-validation-fail");
            if (invalidIndex == -1) this.invalidCells.push(cell);
        }
        return failedValidators.length ? failedValidators : true;
    }
    getInvalidCells() {
        var output = [];
        this.invalidCells.forEach((cell)=>{
            output.push(cell.getComponent());
        });
        return output;
    }
    clearValidation(cell) {
        var invalidIndex;
        if (cell.modules.validate && cell.modules.validate.invalid) {
            cell.getElement().classList.remove("tabulator-validation-fail");
            cell.modules.validate.invalid = false;
            invalidIndex = this.invalidCells.indexOf(cell);
            if (invalidIndex > -1) this.invalidCells.splice(invalidIndex, 1);
        }
    }
}
var $c2a9788f40f9c90a$var$allModules = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    AccessorModule: $c2a9788f40f9c90a$export$bf9f5472bce61c69,
    AjaxModule: $c2a9788f40f9c90a$export$b25c9f93be571d3a,
    ClipboardModule: $c2a9788f40f9c90a$export$3a36bd45ca02edda,
    ColumnCalcsModule: $c2a9788f40f9c90a$export$840b3bc55b30dec6,
    DataTreeModule: $c2a9788f40f9c90a$export$a5a9878f12569c04,
    DownloadModule: $c2a9788f40f9c90a$export$6dd96c6d41f32a97,
    EditModule: $c2a9788f40f9c90a$export$2394e2d3d2175314,
    ExportModule: $c2a9788f40f9c90a$export$4e0f34fd9829977c,
    FilterModule: $c2a9788f40f9c90a$export$2e3bebbdf3339a4e,
    FormatModule: $c2a9788f40f9c90a$export$5634f967e02d772d,
    FrozenColumnsModule: $c2a9788f40f9c90a$export$c00c4e95a253fbf9,
    FrozenRowsModule: $c2a9788f40f9c90a$export$6e51ce5331c5fffa,
    GroupRowsModule: $c2a9788f40f9c90a$export$41e6b6ec902cbe0a,
    HistoryModule: $c2a9788f40f9c90a$export$173658fc60691186,
    HtmlTableImportModule: $c2a9788f40f9c90a$export$b0b448c470bac827,
    ImportModule: $c2a9788f40f9c90a$export$bceca318c211ca25,
    InteractionModule: $c2a9788f40f9c90a$export$69fa60f71dd0541a,
    KeybindingsModule: $c2a9788f40f9c90a$export$a0ff4f1c226a7cef,
    MenuModule: $c2a9788f40f9c90a$export$f1ab43fc4c3c5ce0,
    MoveColumnsModule: $c2a9788f40f9c90a$export$9ab7496e9b38c128,
    MoveRowsModule: $c2a9788f40f9c90a$export$7815d73158f0bb2d,
    MutatorModule: $c2a9788f40f9c90a$export$d0f669567356cabd,
    PageModule: $c2a9788f40f9c90a$export$7eba6c45a494ceac,
    PersistenceModule: $c2a9788f40f9c90a$export$6ce0215a06bec981,
    PopupModule: $c2a9788f40f9c90a$export$5a0eb14a9c37d425,
    PrintModule: $c2a9788f40f9c90a$export$94fbe99c03f5a051,
    ReactiveDataModule: $c2a9788f40f9c90a$export$1806fba60a0e8399,
    ResizeColumnsModule: $c2a9788f40f9c90a$export$3a1ca422b395df54,
    ResizeRowsModule: $c2a9788f40f9c90a$export$5651a6c35bd86023,
    ResizeTableModule: $c2a9788f40f9c90a$export$977e646a85a63aba,
    ResponsiveLayoutModule: $c2a9788f40f9c90a$export$cc8706005768c818,
    SelectRangeModule: $c2a9788f40f9c90a$export$cd9e469b2c8c819c,
    SelectRowModule: $c2a9788f40f9c90a$export$2e4fadc5338e55f5,
    SortModule: $c2a9788f40f9c90a$export$5b492eb49d632e3f,
    SpreadsheetModule: $c2a9788f40f9c90a$export$bbb96e34680d7364,
    TooltipModule: $c2a9788f40f9c90a$export$d0c662c133b8814e,
    ValidateModule: $c2a9788f40f9c90a$export$db48c5a2fa1f03d4
});
var $c2a9788f40f9c90a$var$defaultOptions = {
    debugEventsExternal: false,
    debugEventsInternal: false,
    debugInvalidOptions: true,
    debugInvalidComponentFuncs: true,
    debugInitialization: true,
    debugDeprecation: true,
    height: false,
    minHeight: false,
    maxHeight: false,
    columnHeaderVertAlign: "top",
    popupContainer: false,
    columns: [],
    columnDefaults: {},
    rowHeader: false,
    data: false,
    autoColumns: false,
    autoColumnsDefinitions: false,
    nestedFieldSeparator: ".",
    footerElement: false,
    index: "id",
    textDirection: "auto",
    addRowPos: "bottom",
    headerVisible: true,
    renderVertical: "virtual",
    renderHorizontal: "basic",
    renderVerticalBuffer: 0,
    scrollToRowPosition: "top",
    scrollToRowIfVisible: true,
    scrollToColumnPosition: "left",
    scrollToColumnIfVisible: true,
    rowFormatter: false,
    rowFormatterPrint: null,
    rowFormatterClipboard: null,
    rowFormatterHtmlOutput: null,
    rowHeight: null,
    placeholder: false,
    dataLoader: true,
    dataLoaderLoading: false,
    dataLoaderError: false,
    dataLoaderErrorTimeout: 3000,
    dataSendParams: {},
    dataReceiveParams: {},
    dependencies: {}
};
class $c2a9788f40f9c90a$var$OptionsList {
    constructor(table, msgType, defaults = {}){
        this.table = table;
        this.msgType = msgType;
        this.registeredDefaults = Object.assign({}, defaults);
    }
    register(option, value) {
        this.registeredDefaults[option] = value;
    }
    generate(defaultOptions, userOptions = {}) {
        var output = Object.assign({}, this.registeredDefaults), warn = this.table.options.debugInvalidOptions || userOptions.debugInvalidOptions === true;
        Object.assign(output, defaultOptions);
        for(let key in userOptions)if (!output.hasOwnProperty(key)) {
            if (warn) console.warn("Invalid " + this.msgType + " option:", key);
            output[key] = userOptions.key;
        }
        for(let key in output)if (key in userOptions) output[key] = userOptions[key];
        else {
            if (Array.isArray(output[key])) output[key] = Object.assign([], output[key]);
            else if (typeof output[key] === "object" && output[key] !== null) output[key] = Object.assign({}, output[key]);
            else if (typeof output[key] === "undefined") delete output[key];
        }
        return output;
    }
}
class $c2a9788f40f9c90a$export$88530751e3977073 extends $c2a9788f40f9c90a$var$CoreFeature {
    constructor(table){
        super(table);
        this.elementVertical = table.rowManager.element;
        this.elementHorizontal = table.columnManager.element;
        this.tableElement = table.rowManager.tableElement;
        this.verticalFillMode = "fit"; // used by row manager to determine how to size the render area ("fit" - fits container to the contents, "fill" - fills the container without resizing it)
    }
    ///////////////////////////////////
    /////// Internal Bindings /////////
    ///////////////////////////////////
    initialize() {
    //initialize core functionality
    }
    clearRows() {
    //clear down existing rows layout
    }
    clearColumns() {
    //clear down existing columns layout
    }
    reinitializeColumnWidths(columns) {
    //resize columns to fit data
    }
    renderRows() {
    //render rows from a clean slate
    }
    renderColumns() {
    //render columns from a clean slate
    }
    rerenderRows(callback) {
        // rerender rows and keep position
        if (callback) callback();
    }
    rerenderColumns(update, blockRedraw) {
    //rerender columns
    }
    renderRowCells(row) {
    //render the cells in a row
    }
    rerenderRowCells(row, force) {
    //rerender the cells in a row
    }
    scrollColumns(left, dir) {
    //handle horizontal scrolling
    }
    scrollRows(top, dir) {
    //handle vertical scrolling
    }
    resize() {
    //container has resized, carry out any needed recalculations (DO NOT RERENDER IN THIS FUNCTION)
    }
    scrollToRow(row) {
    //scroll to a specific row
    }
    scrollToRowNearestTop(row) {
    //determine weather the row is nearest the top or bottom of the table, return true for top or false for bottom
    }
    visibleRows(includingBuffer) {
        //return the visible rows
        return [];
    }
    ///////////////////////////////////
    //////// Helper Functions /////////
    ///////////////////////////////////
    rows() {
        return this.table.rowManager.getDisplayRows();
    }
    styleRow(row, index) {
        var rowEl = row.getElement();
        if (index % 2) {
            rowEl.classList.add("tabulator-row-even");
            rowEl.classList.remove("tabulator-row-odd");
        } else {
            rowEl.classList.add("tabulator-row-odd");
            rowEl.classList.remove("tabulator-row-even");
        }
    }
    ///////////////////////////////////
    /////// External Triggers /////////
    /////// (DO NOT OVERRIDE) /////////
    ///////////////////////////////////
    clear() {
        //clear down existing layout
        this.clearRows();
        this.clearColumns();
    }
    render() {
        //render from a clean slate
        this.renderRows();
        this.renderColumns();
    }
    rerender(callback) {
        // rerender and keep position
        this.rerenderRows();
        this.rerenderColumns();
    }
    scrollToRowPosition(row, position, ifVisible) {
        var rowIndex = this.rows().indexOf(row), rowEl = row.getElement(), offset = 0;
        return new Promise((resolve, reject)=>{
            if (rowIndex > -1) {
                if (typeof ifVisible === "undefined") ifVisible = this.table.options.scrollToRowIfVisible;
                //check row visibility
                if (!ifVisible) {
                    if ($c2a9788f40f9c90a$var$Helpers.elVisible(rowEl)) {
                        offset = $c2a9788f40f9c90a$var$Helpers.elOffset(rowEl).top - $c2a9788f40f9c90a$var$Helpers.elOffset(this.elementVertical).top;
                        if (offset > 0 && offset < this.elementVertical.clientHeight - rowEl.offsetHeight) {
                            resolve();
                            return false;
                        }
                    }
                }
                if (typeof position === "undefined") position = this.table.options.scrollToRowPosition;
                if (position === "nearest") position = this.scrollToRowNearestTop(row) ? "top" : "bottom";
                //scroll to row
                this.scrollToRow(row);
                //align to correct position
                switch(position){
                    case "middle":
                    case "center":
                        if (this.elementVertical.scrollHeight - this.elementVertical.scrollTop == this.elementVertical.clientHeight) this.elementVertical.scrollTop = this.elementVertical.scrollTop + (rowEl.offsetTop - this.elementVertical.scrollTop) - (this.elementVertical.scrollHeight - rowEl.offsetTop) / 2;
                        else this.elementVertical.scrollTop = this.elementVertical.scrollTop - this.elementVertical.clientHeight / 2;
                        break;
                    case "bottom":
                        if (this.elementVertical.scrollHeight - this.elementVertical.scrollTop == this.elementVertical.clientHeight) this.elementVertical.scrollTop = this.elementVertical.scrollTop - (this.elementVertical.scrollHeight - rowEl.offsetTop) + rowEl.offsetHeight;
                        else this.elementVertical.scrollTop = this.elementVertical.scrollTop - this.elementVertical.clientHeight + rowEl.offsetHeight;
                        break;
                    case "top":
                        this.elementVertical.scrollTop = rowEl.offsetTop;
                        break;
                }
                resolve();
            } else {
                console.warn("Scroll Error - Row not visible");
                reject("Scroll Error - Row not visible");
            }
        });
    }
}
class $c2a9788f40f9c90a$var$BasicHorizontal extends $c2a9788f40f9c90a$export$88530751e3977073 {
    constructor(table){
        super(table);
    }
    renderRowCells(row, inFragment) {
        const rowFrag = document.createDocumentFragment();
        row.cells.forEach((cell)=>{
            rowFrag.appendChild(cell.getElement());
        });
        row.element.appendChild(rowFrag);
        if (!inFragment) row.cells.forEach((cell)=>{
            cell.cellRendered();
        });
    }
    reinitializeColumnWidths(columns) {
        columns.forEach(function(column) {
            column.reinitializeWidth();
        });
    }
}
class $c2a9788f40f9c90a$var$VirtualDomHorizontal extends $c2a9788f40f9c90a$export$88530751e3977073 {
    constructor(table){
        super(table);
        this.leftCol = 0;
        this.rightCol = 0;
        this.scrollLeft = 0;
        this.vDomScrollPosLeft = 0;
        this.vDomScrollPosRight = 0;
        this.vDomPadLeft = 0;
        this.vDomPadRight = 0;
        this.fitDataColAvg = 0;
        this.windowBuffer = 200; //pixel margin to make column visible before it is shown on screen
        this.visibleRows = null;
        this.initialized = false;
        this.isFitData = false;
        this.columns = [];
    }
    initialize() {
        this.compatibilityCheck();
        this.layoutCheck();
        this.vertScrollListen();
    }
    compatibilityCheck() {
        if (this.options("layout") == "fitDataTable") console.warn("Horizontal Virtual DOM is not compatible with fitDataTable layout mode");
        if (this.options("responsiveLayout")) console.warn("Horizontal Virtual DOM is not compatible with responsive columns");
        if (this.options("rtl")) console.warn("Horizontal Virtual DOM is not currently compatible with RTL text direction");
    }
    layoutCheck() {
        this.isFitData = this.options("layout").startsWith('fitData');
    }
    vertScrollListen() {
        this.subscribe("scroll-vertical", this.clearVisRowCache.bind(this));
        this.subscribe("data-refreshed", this.clearVisRowCache.bind(this));
    }
    clearVisRowCache() {
        this.visibleRows = null;
    }
    //////////////////////////////////////
    ///////// Public Functions ///////////
    //////////////////////////////////////
    renderColumns(row, force) {
        this.dataChange();
    }
    scrollColumns(left, dir) {
        if (this.scrollLeft != left) {
            this.scrollLeft = left;
            this.scroll(left - (this.vDomScrollPosLeft + this.windowBuffer));
        }
    }
    calcWindowBuffer() {
        var buffer = this.elementVertical.clientWidth;
        this.table.columnManager.columnsByIndex.forEach((column)=>{
            if (column.visible) {
                var width = column.getWidth();
                if (width > buffer) buffer = width;
            }
        });
        this.windowBuffer = buffer * 2;
    }
    rerenderColumns(update, blockRedraw) {
        var old = {
            cols: this.columns,
            leftCol: this.leftCol,
            rightCol: this.rightCol
        }, colPos = 0;
        if (update && !this.initialized) return;
        this.clear();
        this.calcWindowBuffer();
        this.scrollLeft = this.elementVertical.scrollLeft;
        this.vDomScrollPosLeft = this.scrollLeft - this.windowBuffer;
        this.vDomScrollPosRight = this.scrollLeft + this.elementVertical.clientWidth + this.windowBuffer;
        this.table.columnManager.columnsByIndex.forEach((column)=>{
            var config = {}, width;
            if (column.visible) {
                if (!column.modules.frozen) {
                    width = column.getWidth();
                    config.leftPos = colPos;
                    config.rightPos = colPos + width;
                    config.width = width;
                    if (this.isFitData) config.fitDataCheck = column.modules.vdomHoz ? column.modules.vdomHoz.fitDataCheck : true;
                    if (colPos + width > this.vDomScrollPosLeft && colPos < this.vDomScrollPosRight) {
                        //column is visible
                        if (this.leftCol == -1) {
                            this.leftCol = this.columns.length;
                            this.vDomPadLeft = colPos;
                        }
                        this.rightCol = this.columns.length;
                    } else // column is hidden
                    if (this.leftCol !== -1) this.vDomPadRight += width;
                    this.columns.push(column);
                    column.modules.vdomHoz = config;
                    colPos += width;
                }
            }
        });
        this.tableElement.style.paddingLeft = this.vDomPadLeft + "px";
        this.tableElement.style.paddingRight = this.vDomPadRight + "px";
        this.initialized = true;
        if (!blockRedraw) {
            if (!update || this.reinitChanged(old)) this.reinitializeRows();
        }
        this.elementVertical.scrollLeft = this.scrollLeft;
    }
    renderRowCells(row) {
        if (this.initialized) this.initializeRow(row);
        else {
            const rowFrag = document.createDocumentFragment();
            row.cells.forEach((cell)=>{
                rowFrag.appendChild(cell.getElement());
            });
            row.element.appendChild(rowFrag);
            row.cells.forEach((cell)=>{
                cell.cellRendered();
            });
        }
    }
    rerenderRowCells(row, force) {
        this.reinitializeRow(row, force);
    }
    reinitializeColumnWidths(columns) {
        for(let i = this.leftCol; i <= this.rightCol; i++)this.columns[i].reinitializeWidth();
    }
    //////////////////////////////////////
    //////// Internal Rendering //////////
    //////////////////////////////////////
    deinitialize() {
        this.initialized = false;
    }
    clear() {
        this.columns = [];
        this.leftCol = -1;
        this.rightCol = 0;
        this.vDomScrollPosLeft = 0;
        this.vDomScrollPosRight = 0;
        this.vDomPadLeft = 0;
        this.vDomPadRight = 0;
    }
    dataChange() {
        var change = false, row, rowEl;
        if (this.isFitData) {
            this.table.columnManager.columnsByIndex.forEach((column)=>{
                if (!column.definition.width && column.visible) change = true;
            });
            if (change && this.table.rowManager.getDisplayRows().length) {
                this.vDomScrollPosRight = this.scrollLeft + this.elementVertical.clientWidth + this.windowBuffer;
                row = this.chain("rows-sample", [
                    1
                ], [], ()=>{
                    return this.table.rowManager.getDisplayRows();
                })[0];
                if (row) {
                    rowEl = row.getElement();
                    row.generateCells();
                    this.tableElement.appendChild(rowEl);
                    for(let colEnd = 0; colEnd < row.cells.length; colEnd++){
                        let cell = row.cells[colEnd];
                        rowEl.appendChild(cell.getElement());
                        cell.column.reinitializeWidth();
                    }
                    rowEl.parentNode.removeChild(rowEl);
                    this.rerenderColumns(false, true);
                }
            }
        } else if (this.options("layout") === "fitColumns") {
            this.layoutRefresh();
            this.rerenderColumns(false, true);
        }
    }
    reinitChanged(old) {
        var match = true;
        if (old.cols.length !== this.columns.length || old.leftCol !== this.leftCol || old.rightCol !== this.rightCol) return true;
        old.cols.forEach((col, i)=>{
            if (col !== this.columns[i]) match = false;
        });
        return !match;
    }
    reinitializeRows() {
        var visibleRows = this.getVisibleRows(), otherRows = this.table.rowManager.getRows().filter((row)=>!visibleRows.includes(row));
        visibleRows.forEach((row)=>{
            this.reinitializeRow(row, true);
        });
        otherRows.forEach((row)=>{
            row.deinitialize();
        });
    }
    getVisibleRows() {
        if (!this.visibleRows) this.visibleRows = this.table.rowManager.getVisibleRows();
        return this.visibleRows;
    }
    scroll(diff) {
        this.vDomScrollPosLeft += diff;
        this.vDomScrollPosRight += diff;
        if (Math.abs(diff) > this.windowBuffer / 2) this.rerenderColumns();
        else if (diff > 0) {
            //scroll right
            this.addColRight();
            this.removeColLeft();
        } else {
            //scroll left
            this.addColLeft();
            this.removeColRight();
        }
    }
    colPositionAdjust(start, end, diff) {
        for(let i = start; i < end; i++){
            let column = this.columns[i];
            column.modules.vdomHoz.leftPos += diff;
            column.modules.vdomHoz.rightPos += diff;
        }
    }
    addColRight() {
        var changes = false, working = true;
        while(working){
            let column = this.columns[this.rightCol + 1];
            if (column) {
                if (column.modules.vdomHoz.leftPos <= this.vDomScrollPosRight) {
                    changes = true;
                    this.getVisibleRows().forEach((row)=>{
                        if (row.type !== "group") {
                            var cell = row.getCell(column);
                            row.getElement().insertBefore(cell.getElement(), row.getCell(this.columns[this.rightCol]).getElement().nextSibling);
                            cell.cellRendered();
                        }
                    });
                    this.fitDataColActualWidthCheck(column);
                    this.rightCol++; // Don't move this below the >= check below
                    this.getVisibleRows().forEach((row)=>{
                        if (row.type !== "group") row.modules.vdomHoz.rightCol = this.rightCol;
                    });
                    if (this.rightCol >= this.columns.length - 1) this.vDomPadRight = 0;
                    else this.vDomPadRight -= column.getWidth();
                } else working = false;
            } else working = false;
        }
        if (changes) this.tableElement.style.paddingRight = this.vDomPadRight + "px";
    }
    addColLeft() {
        var changes = false, working = true;
        while(working){
            let column = this.columns[this.leftCol - 1];
            if (column) {
                if (column.modules.vdomHoz.rightPos >= this.vDomScrollPosLeft) {
                    changes = true;
                    this.getVisibleRows().forEach((row)=>{
                        if (row.type !== "group") {
                            var cell = row.getCell(column);
                            row.getElement().insertBefore(cell.getElement(), row.getCell(this.columns[this.leftCol]).getElement());
                            cell.cellRendered();
                        }
                    });
                    this.leftCol--; // don't move this below the <= check below
                    this.getVisibleRows().forEach((row)=>{
                        if (row.type !== "group") row.modules.vdomHoz.leftCol = this.leftCol;
                    });
                    if (this.leftCol <= 0) this.vDomPadLeft = 0;
                    else this.vDomPadLeft -= column.getWidth();
                    let diff = this.fitDataColActualWidthCheck(column);
                    if (diff) {
                        this.scrollLeft = this.elementVertical.scrollLeft = this.elementVertical.scrollLeft + diff;
                        this.vDomPadRight -= diff;
                    }
                } else working = false;
            } else working = false;
        }
        if (changes) this.tableElement.style.paddingLeft = this.vDomPadLeft + "px";
    }
    removeColRight() {
        var changes = false, working = true;
        while(working){
            let column = this.columns[this.rightCol];
            if (column) {
                if (column.modules.vdomHoz.leftPos > this.vDomScrollPosRight) {
                    changes = true;
                    this.getVisibleRows().forEach((row)=>{
                        if (row.type !== "group") {
                            var cell = row.getCell(column);
                            try {
                                row.getElement().removeChild(cell.getElement());
                            } catch (ex) {
                                console.warn("Could not removeColRight", ex.message);
                            }
                        }
                    });
                    this.vDomPadRight += column.getWidth();
                    this.rightCol--;
                    this.getVisibleRows().forEach((row)=>{
                        if (row.type !== "group") row.modules.vdomHoz.rightCol = this.rightCol;
                    });
                } else working = false;
            } else working = false;
        }
        if (changes) this.tableElement.style.paddingRight = this.vDomPadRight + "px";
    }
    removeColLeft() {
        var changes = false, working = true;
        while(working){
            let column = this.columns[this.leftCol];
            if (column) {
                if (column.modules.vdomHoz.rightPos < this.vDomScrollPosLeft) {
                    changes = true;
                    this.getVisibleRows().forEach((row)=>{
                        if (row.type !== "group") {
                            var cell = row.getCell(column);
                            try {
                                row.getElement().removeChild(cell.getElement());
                            } catch (ex) {
                                console.warn("Could not removeColLeft", ex.message);
                            }
                        }
                    });
                    this.vDomPadLeft += column.getWidth();
                    this.leftCol++;
                    this.getVisibleRows().forEach((row)=>{
                        if (row.type !== "group") row.modules.vdomHoz.leftCol = this.leftCol;
                    });
                } else working = false;
            } else working = false;
        }
        if (changes) this.tableElement.style.paddingLeft = this.vDomPadLeft + "px";
    }
    fitDataColActualWidthCheck(column) {
        var newWidth, widthDiff;
        if (column.modules.vdomHoz.fitDataCheck) {
            column.reinitializeWidth();
            newWidth = column.getWidth();
            widthDiff = newWidth - column.modules.vdomHoz.width;
            if (widthDiff) {
                column.modules.vdomHoz.rightPos += widthDiff;
                column.modules.vdomHoz.width = newWidth;
                this.colPositionAdjust(this.columns.indexOf(column) + 1, this.columns.length, widthDiff);
            }
            column.modules.vdomHoz.fitDataCheck = false;
        }
        return widthDiff;
    }
    initializeRow(row) {
        if (row.type !== "group") {
            row.modules.vdomHoz = {
                leftCol: this.leftCol,
                rightCol: this.rightCol
            };
            if (this.table.modules.frozenColumns) this.table.modules.frozenColumns.leftColumns.forEach((column)=>{
                this.appendCell(row, column);
            });
            for(let i = this.leftCol; i <= this.rightCol; i++)this.appendCell(row, this.columns[i]);
            if (this.table.modules.frozenColumns) this.table.modules.frozenColumns.rightColumns.forEach((column)=>{
                this.appendCell(row, column);
            });
        }
    }
    appendCell(row, column) {
        if (column && column.visible) {
            let cell = row.getCell(column);
            row.getElement().appendChild(cell.getElement());
            cell.cellRendered();
        }
    }
    reinitializeRow(row, force) {
        if (row.type !== "group") {
            if (force || !row.modules.vdomHoz || row.modules.vdomHoz.leftCol !== this.leftCol || row.modules.vdomHoz.rightCol !== this.rightCol) {
                var rowEl = row.getElement();
                while(rowEl.firstChild)rowEl.removeChild(rowEl.firstChild);
                this.initializeRow(row);
            }
        }
    }
}
class $c2a9788f40f9c90a$var$ColumnManager extends $c2a9788f40f9c90a$var$CoreFeature {
    constructor(table){
        super(table);
        this.blockHozScrollEvent = false;
        this.headersElement = null;
        this.contentsElement = null;
        this.rowHeader = null;
        this.element = null; //containing element
        this.columns = []; // column definition object
        this.columnsByIndex = []; //columns by index
        this.columnsByField = {}; //columns by field
        this.scrollLeft = 0;
        this.optionsList = new $c2a9788f40f9c90a$var$OptionsList(this.table, "column definition", $c2a9788f40f9c90a$var$defaultColumnOptions);
        this.redrawBlock = false; //prevent redraws to allow multiple data manipulations before continuing
        this.redrawBlockUpdate = null; //store latest redraw update only status
        this.renderer = null;
    }
    ////////////// Setup Functions /////////////////
    initialize() {
        this.initializeRenderer();
        this.headersElement = this.createHeadersElement();
        this.contentsElement = this.createHeaderContentsElement();
        this.element = this.createHeaderElement();
        this.contentsElement.insertBefore(this.headersElement, this.contentsElement.firstChild);
        this.element.insertBefore(this.contentsElement, this.element.firstChild);
        this.initializeScrollWheelWatcher();
        this.subscribe("scroll-horizontal", this.scrollHorizontal.bind(this));
        this.subscribe("scrollbar-vertical", this.padVerticalScrollbar.bind(this));
    }
    padVerticalScrollbar(width) {
        if (this.table.rtl) this.headersElement.style.marginLeft = width + "px";
        else this.headersElement.style.marginRight = width + "px";
    }
    initializeRenderer() {
        var renderClass;
        var renderers = {
            "virtual": $c2a9788f40f9c90a$var$VirtualDomHorizontal,
            "basic": $c2a9788f40f9c90a$var$BasicHorizontal
        };
        if (typeof this.table.options.renderHorizontal === "string") renderClass = renderers[this.table.options.renderHorizontal];
        else renderClass = this.table.options.renderHorizontal;
        if (renderClass) {
            this.renderer = new renderClass(this.table, this.element, this.tableElement);
            this.renderer.initialize();
        } else console.error("Unable to find matching renderer:", this.table.options.renderHorizontal);
    }
    createHeadersElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-headers");
        el.setAttribute("role", "row");
        return el;
    }
    createHeaderContentsElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-header-contents");
        el.setAttribute("role", "rowgroup");
        return el;
    }
    createHeaderElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-header");
        el.setAttribute("role", "rowgroup");
        if (!this.table.options.headerVisible) el.classList.add("tabulator-header-hidden");
        return el;
    }
    //return containing element
    getElement() {
        return this.element;
    }
    //return containing contents element
    getContentsElement() {
        return this.contentsElement;
    }
    //return header containing element
    getHeadersElement() {
        return this.headersElement;
    }
    //scroll horizontally to match table body
    scrollHorizontal(left) {
        this.contentsElement.scrollLeft = left;
        this.scrollLeft = left;
        this.renderer.scrollColumns(left);
    }
    initializeScrollWheelWatcher() {
        this.contentsElement.addEventListener("wheel", (e)=>{
            var left;
            if (e.deltaX) {
                left = this.contentsElement.scrollLeft + e.deltaX;
                this.table.rowManager.scrollHorizontal(left);
                this.table.columnManager.scrollHorizontal(left);
            }
        });
    }
    ///////////// Column Setup Functions /////////////
    generateColumnsFromRowData(data) {
        var cols = [], collProgress = {}, rowSample = this.table.options.autoColumns === "full" ? data : [
            data[0]
        ], definitions = this.table.options.autoColumnsDefinitions;
        if (data && data.length) {
            rowSample.forEach((row)=>{
                Object.keys(row).forEach((key, index)=>{
                    let value = row[key], col;
                    if (!collProgress[key]) {
                        col = {
                            field: key,
                            title: key,
                            sorter: this.calculateSorterFromValue(value)
                        };
                        cols.splice(index, 0, col);
                        collProgress[key] = typeof value === "undefined" ? col : true;
                    } else if (collProgress[key] !== true) {
                        if (typeof value !== "undefined") {
                            collProgress[key].sorter = this.calculateSorterFromValue(value);
                            collProgress[key] = true;
                        }
                    }
                });
            });
            if (definitions) switch(typeof definitions){
                case "function":
                    this.table.options.columns = definitions.call(this.table, cols);
                    break;
                case "object":
                    if (Array.isArray(definitions)) cols.forEach((col)=>{
                        var match = definitions.find((def)=>{
                            return def.field === col.field;
                        });
                        if (match) Object.assign(col, match);
                    });
                    else cols.forEach((col)=>{
                        if (definitions[col.field]) Object.assign(col, definitions[col.field]);
                    });
                    this.table.options.columns = cols;
                    break;
            }
            else this.table.options.columns = cols;
            this.setColumns(this.table.options.columns);
        }
    }
    calculateSorterFromValue(value) {
        var sorter;
        switch(typeof value){
            case "undefined":
                sorter = "string";
                break;
            case "boolean":
                sorter = "boolean";
                break;
            case "number":
                sorter = "number";
                break;
            case "object":
                if (Array.isArray(value)) sorter = "array";
                else sorter = "string";
                break;
            default:
                if (!isNaN(value) && value !== "") sorter = "number";
                else if (value.match(/((^[0-9]+[a-z]+)|(^[a-z]+[0-9]+))+$/i)) sorter = "alphanum";
                else sorter = "string";
                break;
        }
        return sorter;
    }
    setColumns(cols, row) {
        while(this.headersElement.firstChild)this.headersElement.removeChild(this.headersElement.firstChild);
        this.columns = [];
        this.columnsByIndex = [];
        this.columnsByField = {};
        this.dispatch("columns-loading");
        this.dispatchExternal("columnsLoading");
        if (this.table.options.rowHeader) {
            this.rowHeader = new $c2a9788f40f9c90a$var$Column(this.table.options.rowHeader === true ? {} : this.table.options.rowHeader, this, true);
            this.columns.push(this.rowHeader);
            this.headersElement.appendChild(this.rowHeader.getElement());
            this.rowHeader.columnRendered();
        }
        cols.forEach((def, i)=>{
            this._addColumn(def);
        });
        this._reIndexColumns();
        this.dispatch("columns-loaded");
        if (this.subscribedExternal("columnsLoaded")) this.dispatchExternal("columnsLoaded", this.getComponents());
        this.rerenderColumns(false, true);
        this.redraw(true);
    }
    _addColumn(definition, before, nextToColumn) {
        var column = new $c2a9788f40f9c90a$var$Column(definition, this), colEl = column.getElement(), index = nextToColumn ? this.findColumnIndex(nextToColumn) : nextToColumn;
        //prevent adding of rows in front of row header
        if (before && this.rowHeader && (!nextToColumn || nextToColumn === this.rowHeader)) {
            before = false;
            nextToColumn = this.rowHeader;
            index = 0;
        }
        if (nextToColumn && index > -1) {
            var topColumn = nextToColumn.getTopColumn();
            var parentIndex = this.columns.indexOf(topColumn);
            var nextEl = topColumn.getElement();
            if (before) {
                this.columns.splice(parentIndex, 0, column);
                nextEl.parentNode.insertBefore(colEl, nextEl);
            } else {
                this.columns.splice(parentIndex + 1, 0, column);
                nextEl.parentNode.insertBefore(colEl, nextEl.nextSibling);
            }
        } else if (before) {
            this.columns.unshift(column);
            this.headersElement.insertBefore(column.getElement(), this.headersElement.firstChild);
        } else {
            this.columns.push(column);
            this.headersElement.appendChild(column.getElement());
        }
        column.columnRendered();
        return column;
    }
    registerColumnField(col) {
        if (col.definition.field) this.columnsByField[col.definition.field] = col;
    }
    registerColumnPosition(col) {
        this.columnsByIndex.push(col);
    }
    _reIndexColumns() {
        this.columnsByIndex = [];
        this.columns.forEach(function(column) {
            column.reRegisterPosition();
        });
    }
    //ensure column headers take up the correct amount of space in column groups
    verticalAlignHeaders() {
        var minHeight = 0;
        if (!this.redrawBlock) {
            this.headersElement.style.height = "";
            this.columns.forEach((column)=>{
                column.clearVerticalAlign();
            });
            this.columns.forEach((column)=>{
                var height = column.getHeight();
                if (height > minHeight) minHeight = height;
            });
            this.headersElement.style.height = minHeight + "px";
            this.columns.forEach((column)=>{
                column.verticalAlign(this.table.options.columnHeaderVertAlign, minHeight);
            });
            this.table.rowManager.adjustTableSize();
        }
    }
    //////////////// Column Details /////////////////
    findColumn(subject) {
        var columns;
        if (typeof subject == "object") {
            if (subject instanceof $c2a9788f40f9c90a$var$Column) //subject is column element
            return subject;
            else if (subject instanceof $c2a9788f40f9c90a$export$11bb209ad3a8e411) //subject is public column component
            return subject._getSelf() || false;
            else if (typeof HTMLElement !== "undefined" && subject instanceof HTMLElement) {
                columns = [];
                this.columns.forEach((column)=>{
                    columns.push(column);
                    columns = columns.concat(column.getColumns(true));
                });
                //subject is a HTML element of the column header
                let match = columns.find((column)=>{
                    return column.element === subject;
                });
                return match || false;
            }
        } else //subject should be treated as the field name of the column
        return this.columnsByField[subject] || false;
        //catch all for any other type of input
        return false;
    }
    getColumnByField(field) {
        return this.columnsByField[field];
    }
    getColumnsByFieldRoot(root) {
        var matches = [];
        Object.keys(this.columnsByField).forEach((field)=>{
            var fieldRoot = this.table.options.nestedFieldSeparator ? field.split(this.table.options.nestedFieldSeparator)[0] : field;
            if (fieldRoot === root) matches.push(this.columnsByField[field]);
        });
        return matches;
    }
    getColumnByIndex(index) {
        return this.columnsByIndex[index];
    }
    getFirstVisibleColumn() {
        var index = this.columnsByIndex.findIndex((col)=>{
            return col.visible;
        });
        return index > -1 ? this.columnsByIndex[index] : false;
    }
    getVisibleColumnsByIndex() {
        return this.columnsByIndex.filter((col)=>col.visible);
    }
    getColumns() {
        return this.columns;
    }
    findColumnIndex(column) {
        return this.columnsByIndex.findIndex((col)=>{
            return column === col;
        });
    }
    //return all columns that are not groups
    getRealColumns() {
        return this.columnsByIndex;
    }
    //traverse across columns and call action
    traverse(callback) {
        this.columnsByIndex.forEach((column, i)=>{
            callback(column, i);
        });
    }
    //get definitions of actual columns
    getDefinitions(active) {
        var output = [];
        this.columnsByIndex.forEach((column)=>{
            if (!active || active && column.visible) output.push(column.getDefinition());
        });
        return output;
    }
    //get full nested definition tree
    getDefinitionTree() {
        var output = [];
        this.columns.forEach((column)=>{
            output.push(column.getDefinition(true));
        });
        return output;
    }
    getComponents(structured) {
        var output = [], columns = structured ? this.columns : this.columnsByIndex;
        columns.forEach((column)=>{
            output.push(column.getComponent());
        });
        return output;
    }
    getWidth() {
        var width = 0;
        this.columnsByIndex.forEach((column)=>{
            if (column.visible) width += column.getWidth();
        });
        return width;
    }
    moveColumn(from, to, after) {
        to.element.parentNode.insertBefore(from.element, to.element);
        if (after) to.element.parentNode.insertBefore(to.element, from.element);
        this.moveColumnActual(from, to, after);
        this.verticalAlignHeaders();
        this.table.rowManager.reinitialize();
    }
    moveColumnActual(from, to, after) {
        if (from.parent.isGroup) this._moveColumnInArray(from.parent.columns, from, to, after);
        else this._moveColumnInArray(this.columns, from, to, after);
        this._moveColumnInArray(this.columnsByIndex, from, to, after, true);
        this.rerenderColumns(true);
        this.dispatch("column-moved", from, to, after);
        if (this.subscribedExternal("columnMoved")) this.dispatchExternal("columnMoved", from.getComponent(), this.table.columnManager.getComponents());
    }
    _moveColumnInArray(columns, from, to, after, updateRows) {
        var fromIndex = columns.indexOf(from), toIndex, rows = [];
        if (fromIndex > -1) {
            columns.splice(fromIndex, 1);
            toIndex = columns.indexOf(to);
            if (toIndex > -1) {
                if (after) toIndex = toIndex + 1;
            } else toIndex = fromIndex;
            columns.splice(toIndex, 0, from);
            if (updateRows) {
                rows = this.chain("column-moving-rows", [
                    from,
                    to,
                    after
                ], null, []) || [];
                rows = rows.concat(this.table.rowManager.rows);
                rows.forEach(function(row) {
                    if (row.cells.length) {
                        var cell = row.cells.splice(fromIndex, 1)[0];
                        row.cells.splice(toIndex, 0, cell);
                    }
                });
            }
        }
    }
    scrollToColumn(column, position, ifVisible) {
        var left = 0, offset = column.getLeftOffset(), adjust = 0, colEl = column.getElement();
        return new Promise((resolve, reject)=>{
            if (typeof position === "undefined") position = this.table.options.scrollToColumnPosition;
            if (typeof ifVisible === "undefined") ifVisible = this.table.options.scrollToColumnIfVisible;
            if (column.visible) {
                //align to correct position
                switch(position){
                    case "middle":
                    case "center":
                        adjust = -this.element.clientWidth / 2;
                        break;
                    case "right":
                        adjust = colEl.clientWidth - this.headersElement.clientWidth;
                        break;
                }
                //check column visibility
                if (!ifVisible) {
                    if (offset > 0 && offset + colEl.offsetWidth < this.element.clientWidth) return false;
                }
                //calculate scroll position
                left = offset + adjust;
                left = Math.max(Math.min(left, this.table.rowManager.element.scrollWidth - this.table.rowManager.element.clientWidth), 0);
                this.table.rowManager.scrollHorizontal(left);
                this.scrollHorizontal(left);
                resolve();
            } else {
                console.warn("Scroll Error - Column not visible");
                reject("Scroll Error - Column not visible");
            }
        });
    }
    //////////////// Cell Management /////////////////
    generateCells(row) {
        var cells = [];
        this.columnsByIndex.forEach((column)=>{
            cells.push(column.generateCell(row));
        });
        return cells;
    }
    //////////////// Column Management /////////////////
    getFlexBaseWidth() {
        var totalWidth = this.table.element.clientWidth, fixedWidth = 0;
        //adjust for vertical scrollbar if present
        if (this.table.rowManager.element.scrollHeight > this.table.rowManager.element.clientHeight) totalWidth -= this.table.rowManager.element.offsetWidth - this.table.rowManager.element.clientWidth;
        this.columnsByIndex.forEach(function(column) {
            var width, minWidth, colWidth;
            if (column.visible) {
                width = column.definition.width || 0;
                minWidth = parseInt(column.minWidth);
                if (typeof width == "string") {
                    if (width.indexOf("%") > -1) colWidth = totalWidth / 100 * parseInt(width);
                    else colWidth = parseInt(width);
                } else colWidth = width;
                fixedWidth += colWidth > minWidth ? colWidth : minWidth;
            }
        });
        return fixedWidth;
    }
    addColumn(definition, before, nextToColumn) {
        return new Promise((resolve, reject)=>{
            var column = this._addColumn(definition, before, nextToColumn);
            this._reIndexColumns();
            this.dispatch("column-add", definition, before, nextToColumn);
            if (this.layoutMode() != "fitColumns") column.reinitializeWidth();
            this.redraw(true);
            this.table.rowManager.reinitialize();
            this.rerenderColumns();
            resolve(column);
        });
    }
    //remove column from system
    deregisterColumn(column) {
        var field = column.getField(), index;
        //remove from field list
        if (field) delete this.columnsByField[field];
        //remove from index list
        index = this.columnsByIndex.indexOf(column);
        if (index > -1) this.columnsByIndex.splice(index, 1);
        //remove from column list
        index = this.columns.indexOf(column);
        if (index > -1) this.columns.splice(index, 1);
        this.verticalAlignHeaders();
        this.redraw();
    }
    rerenderColumns(update, silent) {
        if (!this.redrawBlock) this.renderer.rerenderColumns(update, silent);
        else if (update === false || update === true && this.redrawBlockUpdate === null) this.redrawBlockUpdate = update;
    }
    blockRedraw() {
        this.redrawBlock = true;
        this.redrawBlockUpdate = null;
    }
    restoreRedraw() {
        this.redrawBlock = false;
        this.verticalAlignHeaders();
        this.renderer.rerenderColumns(this.redrawBlockUpdate);
    }
    //redraw columns
    redraw(force) {
        if ($c2a9788f40f9c90a$var$Helpers.elVisible(this.element)) this.verticalAlignHeaders();
        if (force) {
            this.table.rowManager.resetScroll();
            this.table.rowManager.reinitialize();
        }
        if (!this.confirm("table-redrawing", force)) this.layoutRefresh(force);
        this.dispatch("table-redraw", force);
        this.table.footerManager.redraw();
    }
}
class $c2a9788f40f9c90a$var$BasicVertical extends $c2a9788f40f9c90a$export$88530751e3977073 {
    constructor(table){
        super(table);
        this.verticalFillMode = "fill";
        this.scrollTop = 0;
        this.scrollLeft = 0;
        this.scrollTop = 0;
        this.scrollLeft = 0;
    }
    clearRows() {
        var element = this.tableElement;
        // element.children.detach();
        while(element.firstChild)element.removeChild(element.firstChild);
        element.scrollTop = 0;
        element.scrollLeft = 0;
        element.style.minWidth = "";
        element.style.minHeight = "";
        element.style.display = "";
        element.style.visibility = "";
    }
    renderRows() {
        var element = this.tableElement, onlyGroupHeaders = true, tableFrag = document.createDocumentFragment(), rows = this.rows();
        rows.forEach((row, index)=>{
            this.styleRow(row, index);
            row.initialize(false, true);
            if (row.type !== "group") onlyGroupHeaders = false;
            tableFrag.appendChild(row.getElement());
        });
        element.appendChild(tableFrag);
        rows.forEach((row)=>{
            row.rendered();
            if (!row.heightInitialized) row.calcHeight(true);
        });
        rows.forEach((row)=>{
            if (!row.heightInitialized) row.setCellHeight();
        });
        if (onlyGroupHeaders) element.style.minWidth = this.table.columnManager.getWidth() + "px";
        else element.style.minWidth = "";
    }
    rerenderRows(callback) {
        this.clearRows();
        if (callback) callback();
        this.renderRows();
        if (!this.rows().length) this.table.rowManager.tableEmpty();
    }
    scrollToRowNearestTop(row) {
        var rowTop = $c2a9788f40f9c90a$var$Helpers.elOffset(row.getElement()).top;
        return !(Math.abs(this.elementVertical.scrollTop - rowTop) > Math.abs(this.elementVertical.scrollTop + this.elementVertical.clientHeight - rowTop));
    }
    scrollToRow(row) {
        var rowEl = row.getElement();
        this.elementVertical.scrollTop = $c2a9788f40f9c90a$var$Helpers.elOffset(rowEl).top - $c2a9788f40f9c90a$var$Helpers.elOffset(this.elementVertical).top + this.elementVertical.scrollTop;
    }
    visibleRows(includingBuffer) {
        return this.rows();
    }
}
class $c2a9788f40f9c90a$var$VirtualDomVertical extends $c2a9788f40f9c90a$export$88530751e3977073 {
    constructor(table){
        super(table);
        this.verticalFillMode = "fill";
        this.scrollTop = 0;
        this.scrollLeft = 0;
        this.vDomRowHeight = 20; //approximation of row heights for padding
        this.vDomTop = 0; //hold position for first rendered row in the virtual DOM
        this.vDomBottom = 0; //hold position for last rendered row in the virtual DOM
        this.vDomScrollPosTop = 0; //last scroll position of the vDom top;
        this.vDomScrollPosBottom = 0; //last scroll position of the vDom bottom;
        this.vDomTopPad = 0; //hold value of padding for top of virtual DOM
        this.vDomBottomPad = 0; //hold value of padding for bottom of virtual DOM
        this.vDomMaxRenderChain = 90; //the maximum number of dom elements that can be rendered in 1 go
        this.vDomWindowBuffer = 0; //window row buffer before removing elements, to smooth scrolling
        this.vDomWindowMinTotalRows = 20; //minimum number of rows to be generated in virtual dom (prevent buffering issues on tables with tall rows)
        this.vDomWindowMinMarginRows = 5; //minimum number of rows to be generated in virtual dom margin
        this.vDomTopNewRows = []; //rows to normalize after appending to optimize render speed
        this.vDomBottomNewRows = []; //rows to normalize after appending to optimize render speed
    }
    //////////////////////////////////////
    ///////// Public Functions ///////////
    //////////////////////////////////////
    clearRows() {
        var element = this.tableElement;
        // element.children.detach();
        while(element.firstChild)element.removeChild(element.firstChild);
        element.style.paddingTop = "";
        element.style.paddingBottom = "";
        element.style.minHeight = "";
        element.style.display = "";
        element.style.visibility = "";
        this.elementVertical.scrollTop = 0;
        this.elementVertical.scrollLeft = 0;
        this.scrollTop = 0;
        this.scrollLeft = 0;
        this.vDomTop = 0;
        this.vDomBottom = 0;
        this.vDomTopPad = 0;
        this.vDomBottomPad = 0;
        this.vDomScrollPosTop = 0;
        this.vDomScrollPosBottom = 0;
    }
    renderRows() {
        this._virtualRenderFill();
    }
    rerenderRows(callback) {
        var scrollTop = this.elementVertical.scrollTop;
        var topRow = false;
        var topOffset = false;
        var left = this.table.rowManager.scrollLeft;
        var rows = this.rows();
        for(var i = this.vDomTop; i <= this.vDomBottom; i++)if (rows[i]) {
            var diff = scrollTop - rows[i].getElement().offsetTop;
            if (topOffset === false || Math.abs(diff) < topOffset) {
                topOffset = diff;
                topRow = i;
            } else break;
        }
        rows.forEach((row)=>{
            row.deinitializeHeight();
        });
        if (callback) callback();
        if (this.rows().length) this._virtualRenderFill(topRow === false ? this.rows.length - 1 : topRow, true, topOffset || 0);
        else {
            this.clear();
            this.table.rowManager.tableEmpty();
        }
        this.scrollColumns(left);
    }
    scrollColumns(left) {
        this.table.rowManager.scrollHorizontal(left);
    }
    scrollRows(top, dir) {
        var topDiff = top - this.vDomScrollPosTop;
        var bottomDiff = top - this.vDomScrollPosBottom;
        var margin = this.vDomWindowBuffer * 2;
        var rows = this.rows();
        this.scrollTop = top;
        if (-topDiff > margin || bottomDiff > margin) {
            //if big scroll redraw table;
            var left = this.table.rowManager.scrollLeft;
            this._virtualRenderFill(Math.floor(this.elementVertical.scrollTop / this.elementVertical.scrollHeight * rows.length));
            this.scrollColumns(left);
        } else if (dir) {
            //scrolling up
            if (topDiff < 0) this._addTopRow(rows, -topDiff);
            if (bottomDiff < 0) {
                //hide bottom row if needed
                if (this.vDomScrollHeight - this.scrollTop > this.vDomWindowBuffer) this._removeBottomRow(rows, -bottomDiff);
                else this.vDomScrollPosBottom = this.scrollTop;
            }
        } else {
            if (bottomDiff >= 0) this._addBottomRow(rows, bottomDiff);
            //scrolling down
            if (topDiff >= 0) {
                //hide top row if needed
                if (this.scrollTop > this.vDomWindowBuffer) this._removeTopRow(rows, topDiff);
                else this.vDomScrollPosTop = this.scrollTop;
            }
        }
    }
    resize() {
        this.vDomWindowBuffer = this.table.options.renderVerticalBuffer || this.elementVertical.clientHeight;
    }
    scrollToRowNearestTop(row) {
        var rowIndex = this.rows().indexOf(row);
        return !(Math.abs(this.vDomTop - rowIndex) > Math.abs(this.vDomBottom - rowIndex));
    }
    scrollToRow(row) {
        var index = this.rows().indexOf(row);
        if (index > -1) this._virtualRenderFill(index, true);
    }
    visibleRows(includingBuffer) {
        var topEdge = this.elementVertical.scrollTop, bottomEdge = this.elementVertical.clientHeight + topEdge, topFound = false, topRow = 0, bottomRow = 0, rows = this.rows();
        if (includingBuffer) {
            topRow = this.vDomTop;
            bottomRow = this.vDomBottom;
        } else {
            for(var i = this.vDomTop; i <= this.vDomBottom; i++)if (rows[i]) {
                if (!topFound) {
                    if (topEdge - rows[i].getElement().offsetTop >= 0) topRow = i;
                    else {
                        topFound = true;
                        if (bottomEdge - rows[i].getElement().offsetTop >= 0) bottomRow = i;
                        else break;
                    }
                } else {
                    if (bottomEdge - rows[i].getElement().offsetTop >= 0) bottomRow = i;
                    else break;
                }
            }
        }
        return rows.slice(topRow, bottomRow + 1);
    }
    //////////////////////////////////////
    //////// Internal Rendering //////////
    //////////////////////////////////////
    //full virtual render
    _virtualRenderFill(position, forceMove, offset) {
        var element = this.tableElement, holder = this.elementVertical, topPad = 0, rowsHeight = 0, rowHeight = 0, heightOccupied = 0, topPadHeight = 0, i = 0, rows = this.rows(), rowsCount = rows.length, index = 0, row, rowFragment, renderedRows = [], totalRowsRendered = 0, rowsToRender = 0, fixedHeight = this.table.rowManager.fixedHeight, containerHeight = this.elementVertical.clientHeight, avgRowHeight = this.table.options.rowHeight, resized = true;
        position = position || 0;
        offset = offset || 0;
        if (!position) this.clear();
        else {
            while(element.firstChild)element.removeChild(element.firstChild);
            //check if position is too close to bottom of table
            heightOccupied = (rowsCount - position + 1) * this.vDomRowHeight;
            if (heightOccupied < containerHeight) {
                position -= Math.ceil((containerHeight - heightOccupied) / this.vDomRowHeight);
                if (position < 0) position = 0;
            }
            //calculate initial pad
            topPad = Math.min(Math.max(Math.floor(this.vDomWindowBuffer / this.vDomRowHeight), this.vDomWindowMinMarginRows), position);
            position -= topPad;
        }
        if (rowsCount && $c2a9788f40f9c90a$var$Helpers.elVisible(this.elementVertical)) {
            this.vDomTop = position;
            this.vDomBottom = position - 1;
            if (fixedHeight || this.table.options.maxHeight) {
                if (avgRowHeight) rowsToRender = containerHeight / avgRowHeight + this.vDomWindowBuffer / avgRowHeight;
                rowsToRender = Math.max(this.vDomWindowMinTotalRows, Math.ceil(rowsToRender));
            } else rowsToRender = rowsCount;
            while((rowsToRender == rowsCount || rowsHeight <= containerHeight + this.vDomWindowBuffer || totalRowsRendered < this.vDomWindowMinTotalRows) && this.vDomBottom < rowsCount - 1){
                renderedRows = [];
                rowFragment = document.createDocumentFragment();
                i = 0;
                while(i < rowsToRender && this.vDomBottom < rowsCount - 1){
                    index = this.vDomBottom + 1, row = rows[index];
                    this.styleRow(row, index);
                    row.initialize(false, true);
                    if (!row.heightInitialized && !this.table.options.rowHeight) row.clearCellHeight();
                    rowFragment.appendChild(row.getElement());
                    renderedRows.push(row);
                    this.vDomBottom++;
                    i++;
                }
                if (!renderedRows.length) break;
                element.appendChild(rowFragment);
                // NOTE: The next 3 loops are separate on purpose
                // This is to batch up the dom writes and reads which drastically improves performance 
                renderedRows.forEach((row)=>{
                    row.rendered();
                    if (!row.heightInitialized) row.calcHeight(true);
                });
                renderedRows.forEach((row)=>{
                    if (!row.heightInitialized) row.setCellHeight();
                });
                renderedRows.forEach((row)=>{
                    rowHeight = row.getHeight();
                    if (totalRowsRendered < topPad) topPadHeight += rowHeight;
                    else rowsHeight += rowHeight;
                    if (rowHeight > this.vDomWindowBuffer) this.vDomWindowBuffer = rowHeight * 2;
                    totalRowsRendered++;
                });
                resized = this.table.rowManager.adjustTableSize();
                containerHeight = this.elementVertical.clientHeight;
                if (resized && (fixedHeight || this.table.options.maxHeight)) {
                    avgRowHeight = rowsHeight / totalRowsRendered;
                    rowsToRender = Math.max(this.vDomWindowMinTotalRows, Math.ceil(containerHeight / avgRowHeight + this.vDomWindowBuffer / avgRowHeight));
                }
            }
            if (!position) {
                this.vDomTopPad = 0;
                //adjust row height to match average of rendered elements
                this.vDomRowHeight = Math.floor((rowsHeight + topPadHeight) / totalRowsRendered);
                this.vDomBottomPad = this.vDomRowHeight * (rowsCount - this.vDomBottom - 1);
                this.vDomScrollHeight = topPadHeight + rowsHeight + this.vDomBottomPad - containerHeight;
            } else {
                this.vDomTopPad = !forceMove ? this.scrollTop - topPadHeight : this.vDomRowHeight * this.vDomTop + offset;
                this.vDomBottomPad = this.vDomBottom == rowsCount - 1 ? 0 : Math.max(this.vDomScrollHeight - this.vDomTopPad - rowsHeight - topPadHeight, 0);
            }
            element.style.paddingTop = this.vDomTopPad + "px";
            element.style.paddingBottom = this.vDomBottomPad + "px";
            if (forceMove) this.scrollTop = this.vDomTopPad + topPadHeight + offset - (this.elementVertical.scrollWidth > this.elementVertical.clientWidth ? this.elementVertical.offsetHeight - containerHeight : 0);
            this.scrollTop = Math.min(this.scrollTop, this.elementVertical.scrollHeight - containerHeight);
            //adjust for horizontal scrollbar if present (and not at top of table)
            if (this.elementVertical.scrollWidth > this.elementVertical.clientWidth && forceMove) this.scrollTop += this.elementVertical.offsetHeight - containerHeight;
            this.vDomScrollPosTop = this.scrollTop;
            this.vDomScrollPosBottom = this.scrollTop;
            holder.scrollTop = this.scrollTop;
            this.dispatch("render-virtual-fill");
        }
    }
    _addTopRow(rows, fillableSpace) {
        var table = this.tableElement, addedRows = [], paddingAdjust = 0, index = this.vDomTop - 1, i = 0, working = true;
        while(working)if (this.vDomTop) {
            let row = rows[index], rowHeight, initialized;
            if (row && i < this.vDomMaxRenderChain) {
                rowHeight = row.getHeight() || this.vDomRowHeight;
                initialized = row.initialized;
                if (fillableSpace >= rowHeight) {
                    this.styleRow(row, index);
                    table.insertBefore(row.getElement(), table.firstChild);
                    if (!row.initialized || !row.heightInitialized) addedRows.push(row);
                    row.initialize();
                    if (!initialized) {
                        rowHeight = row.getElement().offsetHeight;
                        if (rowHeight > this.vDomWindowBuffer) this.vDomWindowBuffer = rowHeight * 2;
                    }
                    fillableSpace -= rowHeight;
                    paddingAdjust += rowHeight;
                    this.vDomTop--;
                    index--;
                    i++;
                } else working = false;
            } else working = false;
        } else working = false;
        for (let row of addedRows)row.clearCellHeight();
        this._quickNormalizeRowHeight(addedRows);
        if (paddingAdjust) {
            this.vDomTopPad -= paddingAdjust;
            if (this.vDomTopPad < 0) this.vDomTopPad = index * this.vDomRowHeight;
            if (index < 1) this.vDomTopPad = 0;
            table.style.paddingTop = this.vDomTopPad + "px";
            this.vDomScrollPosTop -= paddingAdjust;
        }
    }
    _removeTopRow(rows, fillableSpace) {
        var removableRows = [], paddingAdjust = 0, i = 0, working = true;
        while(working){
            let row = rows[this.vDomTop], rowHeight;
            if (row && i < this.vDomMaxRenderChain) {
                rowHeight = row.getHeight() || this.vDomRowHeight;
                if (fillableSpace >= rowHeight) {
                    this.vDomTop++;
                    fillableSpace -= rowHeight;
                    paddingAdjust += rowHeight;
                    removableRows.push(row);
                    i++;
                } else working = false;
            } else working = false;
        }
        for (let row of removableRows){
            let rowEl = row.getElement();
            if (rowEl.parentNode) rowEl.parentNode.removeChild(rowEl);
        }
        if (paddingAdjust) {
            this.vDomTopPad += paddingAdjust;
            this.tableElement.style.paddingTop = this.vDomTopPad + "px";
            this.vDomScrollPosTop += this.vDomTop ? paddingAdjust : paddingAdjust + this.vDomWindowBuffer;
        }
    }
    _addBottomRow(rows, fillableSpace) {
        var table = this.tableElement, addedRows = [], paddingAdjust = 0, index = this.vDomBottom + 1, i = 0, working = true;
        while(working){
            let row = rows[index], rowHeight, initialized;
            if (row && i < this.vDomMaxRenderChain) {
                rowHeight = row.getHeight() || this.vDomRowHeight;
                initialized = row.initialized;
                if (fillableSpace >= rowHeight) {
                    this.styleRow(row, index);
                    table.appendChild(row.getElement());
                    if (!row.initialized || !row.heightInitialized) addedRows.push(row);
                    row.initialize();
                    if (!initialized) {
                        rowHeight = row.getElement().offsetHeight;
                        if (rowHeight > this.vDomWindowBuffer) this.vDomWindowBuffer = rowHeight * 2;
                    }
                    fillableSpace -= rowHeight;
                    paddingAdjust += rowHeight;
                    this.vDomBottom++;
                    index++;
                    i++;
                } else working = false;
            } else working = false;
        }
        for (let row of addedRows)row.clearCellHeight();
        this._quickNormalizeRowHeight(addedRows);
        if (paddingAdjust) {
            this.vDomBottomPad -= paddingAdjust;
            if (this.vDomBottomPad < 0 || index == rows.length - 1) this.vDomBottomPad = 0;
            table.style.paddingBottom = this.vDomBottomPad + "px";
            this.vDomScrollPosBottom += paddingAdjust;
        }
    }
    _removeBottomRow(rows, fillableSpace) {
        var removableRows = [], paddingAdjust = 0, i = 0, working = true;
        while(working){
            let row = rows[this.vDomBottom], rowHeight;
            if (row && i < this.vDomMaxRenderChain) {
                rowHeight = row.getHeight() || this.vDomRowHeight;
                if (fillableSpace >= rowHeight) {
                    this.vDomBottom--;
                    fillableSpace -= rowHeight;
                    paddingAdjust += rowHeight;
                    removableRows.push(row);
                    i++;
                } else working = false;
            } else working = false;
        }
        for (let row of removableRows){
            let rowEl = row.getElement();
            if (rowEl.parentNode) rowEl.parentNode.removeChild(rowEl);
        }
        if (paddingAdjust) {
            this.vDomBottomPad += paddingAdjust;
            if (this.vDomBottomPad < 0) this.vDomBottomPad = 0;
            this.tableElement.style.paddingBottom = this.vDomBottomPad + "px";
            this.vDomScrollPosBottom -= paddingAdjust;
        }
    }
    _quickNormalizeRowHeight(rows) {
        for (let row of rows)row.calcHeight();
        for (let row of rows)row.setCellHeight();
    }
}
class $c2a9788f40f9c90a$var$RowManager extends $c2a9788f40f9c90a$var$CoreFeature {
    constructor(table){
        super(table);
        this.element = this.createHolderElement(); //containing element
        this.tableElement = this.createTableElement(); //table element
        this.heightFixer = this.createTableElement(); //table element
        this.placeholder = null; //placeholder element
        this.placeholderContents = null; //placeholder element
        this.firstRender = false; //handle first render
        this.renderMode = "virtual"; //current rendering mode
        this.fixedHeight = false; //current rendering mode
        this.rows = []; //hold row data objects
        this.activeRowsPipeline = []; //hold calculation of active rows
        this.activeRows = []; //rows currently available to on display in the table
        this.activeRowsCount = 0; //count of active rows
        this.displayRows = []; //rows currently on display in the table
        this.displayRowsCount = 0; //count of display rows
        this.scrollTop = 0;
        this.scrollLeft = 0;
        this.redrawBlock = false; //prevent redraws to allow multiple data manipulations before continuing
        this.redrawBlockRestoreConfig = false; //store latest redraw function calls for when redraw is needed
        this.redrawBlockRenderInPosition = false; //store latest redraw function calls for when redraw is needed
        this.dataPipeline = []; //hold data pipeline tasks
        this.displayPipeline = []; //hold data display pipeline tasks
        this.scrollbarWidth = 0;
        this.renderer = null;
    }
    //////////////// Setup Functions /////////////////
    createHolderElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-tableholder");
        el.setAttribute("tabindex", 0);
        // el.setAttribute("role", "rowgroup");
        return el;
    }
    createTableElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-table");
        el.setAttribute("role", "rowgroup");
        return el;
    }
    initializePlaceholder() {
        var placeholder = this.table.options.placeholder;
        if (typeof placeholder === "function") placeholder = placeholder.call(this.table);
        placeholder = this.chain("placeholder", [
            placeholder
        ], placeholder, placeholder) || placeholder;
        //configure placeholder element
        if (placeholder) {
            let el = document.createElement("div");
            el.classList.add("tabulator-placeholder");
            if (typeof placeholder == "string") {
                let contents = document.createElement("div");
                contents.classList.add("tabulator-placeholder-contents");
                contents.innerHTML = placeholder;
                el.appendChild(contents);
                this.placeholderContents = contents;
            } else if (typeof HTMLElement !== "undefined" && placeholder instanceof HTMLElement) {
                el.appendChild(placeholder);
                this.placeholderContents = placeholder;
            } else {
                console.warn("Invalid placeholder provided, must be string or HTML Element", placeholder);
                this.el = null;
            }
            this.placeholder = el;
        }
    }
    //return containing element
    getElement() {
        return this.element;
    }
    //return table element
    getTableElement() {
        return this.tableElement;
    }
    initialize() {
        this.initializePlaceholder();
        this.initializeRenderer();
        //initialize manager
        this.element.appendChild(this.tableElement);
        this.firstRender = true;
        //scroll header along with table body
        this.element.addEventListener("scroll", ()=>{
            var left = this.element.scrollLeft, leftDir = this.scrollLeft > left, top = this.element.scrollTop, topDir = this.scrollTop > top;
            //handle horizontal scrolling
            if (this.scrollLeft != left) {
                this.scrollLeft = left;
                this.dispatch("scroll-horizontal", left, leftDir);
                this.dispatchExternal("scrollHorizontal", left, leftDir);
                this._positionPlaceholder();
            }
            //handle vertical scrolling
            if (this.scrollTop != top) {
                this.scrollTop = top;
                this.renderer.scrollRows(top, topDir);
                this.dispatch("scroll-vertical", top, topDir);
                this.dispatchExternal("scrollVertical", top, topDir);
            }
        });
    }
    ////////////////// Row Manipulation //////////////////
    findRow(subject) {
        if (typeof subject == "object") {
            if (subject instanceof $c2a9788f40f9c90a$var$Row) //subject is row element
            return subject;
            else if (subject instanceof $c2a9788f40f9c90a$export$5df91075f5ba4651) //subject is public row component
            return subject._getSelf() || false;
            else if (typeof HTMLElement !== "undefined" && subject instanceof HTMLElement) {
                //subject is a HTML element of the row
                let match = this.rows.find((row)=>{
                    return row.getElement() === subject;
                });
                return match || false;
            } else if (subject === null) return false;
        } else if (typeof subject == "undefined") return false;
        else {
            //subject should be treated as the index of the row
            let match = this.rows.find((row)=>{
                return row.data[this.table.options.index] == subject;
            });
            return match || false;
        }
        //catch all for any other type of input
        return false;
    }
    getRowFromDataObject(data) {
        var match = this.rows.find((row)=>{
            return row.data === data;
        });
        return match || false;
    }
    getRowFromPosition(position) {
        return this.getDisplayRows().find((row)=>{
            return row.type === "row" && row.getPosition() === position && row.isDisplayed();
        });
    }
    scrollToRow(row, position, ifVisible) {
        return this.renderer.scrollToRowPosition(row, position, ifVisible);
    }
    ////////////////// Data Handling //////////////////
    setData(data, renderInPosition, columnsChanged) {
        return new Promise((resolve, reject)=>{
            if (renderInPosition && this.getDisplayRows().length) {
                if (this.table.options.pagination) this._setDataActual(data, true);
                else this.reRenderInPosition(()=>{
                    this._setDataActual(data);
                });
            } else {
                if (this.table.options.autoColumns && columnsChanged && this.table.initialized) this.table.columnManager.generateColumnsFromRowData(data);
                this.resetScroll();
                this._setDataActual(data);
            }
            resolve();
        });
    }
    _setDataActual(data, renderInPosition) {
        this.dispatchExternal("dataProcessing", data);
        this._wipeElements();
        if (Array.isArray(data)) {
            this.dispatch("data-processing", data);
            data.forEach((def, i)=>{
                if (def && typeof def === "object") {
                    var row = new $c2a9788f40f9c90a$var$Row(def, this);
                    this.rows.push(row);
                } else console.warn("Data Loading Warning - Invalid row data detected and ignored, expecting object but received:", def);
            });
            this.refreshActiveData(false, false, renderInPosition);
            this.dispatch("data-processed", data);
            this.dispatchExternal("dataProcessed", data);
        } else console.error("Data Loading Error - Unable to process data due to invalid data type \nExpecting: array \nReceived: ", typeof data, "\nData:     ", data);
    }
    _wipeElements() {
        this.dispatch("rows-wipe");
        this.destroy();
        this.adjustTableSize();
        this.dispatch("rows-wiped");
    }
    destroy() {
        this.rows.forEach((row)=>{
            row.wipe();
        });
        this.rows = [];
        this.activeRows = [];
        this.activeRowsPipeline = [];
        this.activeRowsCount = 0;
        this.displayRows = [];
        this.displayRowsCount = 0;
    }
    deleteRow(row, blockRedraw) {
        var allIndex = this.rows.indexOf(row), activeIndex = this.activeRows.indexOf(row);
        if (activeIndex > -1) this.activeRows.splice(activeIndex, 1);
        if (allIndex > -1) this.rows.splice(allIndex, 1);
        this.setActiveRows(this.activeRows);
        this.displayRowIterator((rows)=>{
            var displayIndex = rows.indexOf(row);
            if (displayIndex > -1) rows.splice(displayIndex, 1);
        });
        if (!blockRedraw) this.reRenderInPosition();
        this.regenerateRowPositions();
        this.dispatchExternal("rowDeleted", row.getComponent());
        if (!this.displayRowsCount) this.tableEmpty();
        if (this.subscribedExternal("dataChanged")) this.dispatchExternal("dataChanged", this.getData());
    }
    addRow(data, pos, index, blockRedraw) {
        var row = this.addRowActual(data, pos, index, blockRedraw);
        return row;
    }
    //add multiple rows
    addRows(data, pos, index, refreshDisplayOnly) {
        var rows = [];
        return new Promise((resolve, reject)=>{
            pos = this.findAddRowPos(pos);
            if (!Array.isArray(data)) data = [
                data
            ];
            if (typeof index == "undefined" && pos || typeof index !== "undefined" && !pos) data.reverse();
            data.forEach((item, i)=>{
                var row = this.addRow(item, pos, index, true);
                rows.push(row);
                this.dispatch("row-added", row, item, pos, index);
            });
            this.refreshActiveData(refreshDisplayOnly ? "displayPipeline" : false, false, true);
            this.regenerateRowPositions();
            if (this.displayRowsCount) this._clearPlaceholder();
            resolve(rows);
        });
    }
    findAddRowPos(pos) {
        if (typeof pos === "undefined") pos = this.table.options.addRowPos;
        if (pos === "pos") pos = true;
        if (pos === "bottom") pos = false;
        return pos;
    }
    addRowActual(data, pos, index, blockRedraw) {
        var row = data instanceof $c2a9788f40f9c90a$var$Row ? data : new $c2a9788f40f9c90a$var$Row(data || {}, this), top = this.findAddRowPos(pos), allIndex = -1, activeIndex, chainResult;
        if (!index) {
            chainResult = this.chain("row-adding-position", [
                row,
                top
            ], null, {
                index: index,
                top: top
            });
            index = chainResult.index;
            top = chainResult.top;
        }
        if (typeof index !== "undefined") index = this.findRow(index);
        index = this.chain("row-adding-index", [
            row,
            index,
            top
        ], null, index);
        if (index) allIndex = this.rows.indexOf(index);
        if (index && allIndex > -1) {
            activeIndex = this.activeRows.indexOf(index);
            this.displayRowIterator(function(rows) {
                var displayIndex = rows.indexOf(index);
                if (displayIndex > -1) rows.splice(top ? displayIndex : displayIndex + 1, 0, row);
            });
            if (activeIndex > -1) this.activeRows.splice(top ? activeIndex : activeIndex + 1, 0, row);
            this.rows.splice(top ? allIndex : allIndex + 1, 0, row);
        } else if (top) {
            this.displayRowIterator(function(rows) {
                rows.unshift(row);
            });
            this.activeRows.unshift(row);
            this.rows.unshift(row);
        } else {
            this.displayRowIterator(function(rows) {
                rows.push(row);
            });
            this.activeRows.push(row);
            this.rows.push(row);
        }
        this.setActiveRows(this.activeRows);
        this.dispatchExternal("rowAdded", row.getComponent());
        if (this.subscribedExternal("dataChanged")) this.dispatchExternal("dataChanged", this.table.rowManager.getData());
        if (!blockRedraw) this.reRenderInPosition();
        return row;
    }
    moveRow(from, to, after) {
        this.dispatch("row-move", from, to, after);
        this.moveRowActual(from, to, after);
        this.regenerateRowPositions();
        this.dispatch("row-moved", from, to, after);
        this.dispatchExternal("rowMoved", from.getComponent());
    }
    moveRowActual(from, to, after) {
        this.moveRowInArray(this.rows, from, to, after);
        this.moveRowInArray(this.activeRows, from, to, after);
        this.displayRowIterator((rows)=>{
            this.moveRowInArray(rows, from, to, after);
        });
        this.dispatch("row-moving", from, to, after);
    }
    moveRowInArray(rows, from, to, after) {
        var fromIndex, toIndex, start, end;
        if (from !== to) {
            fromIndex = rows.indexOf(from);
            if (fromIndex > -1) {
                rows.splice(fromIndex, 1);
                toIndex = rows.indexOf(to);
                if (toIndex > -1) {
                    if (after) rows.splice(toIndex + 1, 0, from);
                    else rows.splice(toIndex, 0, from);
                } else rows.splice(fromIndex, 0, from);
            }
            //restyle rows
            if (rows === this.getDisplayRows()) {
                start = fromIndex < toIndex ? fromIndex : toIndex;
                end = toIndex > fromIndex ? toIndex : fromIndex + 1;
                for(let i = start; i <= end; i++)if (rows[i]) this.styleRow(rows[i], i);
            }
        }
    }
    clearData() {
        this.setData([]);
    }
    getRowIndex(row) {
        return this.findRowIndex(row, this.rows);
    }
    getDisplayRowIndex(row) {
        var index = this.getDisplayRows().indexOf(row);
        return index > -1 ? index : false;
    }
    nextDisplayRow(row, rowOnly) {
        var index = this.getDisplayRowIndex(row), nextRow = false;
        if (index !== false && index < this.displayRowsCount - 1) nextRow = this.getDisplayRows()[index + 1];
        if (nextRow && (!(nextRow instanceof $c2a9788f40f9c90a$var$Row) || nextRow.type != "row")) return this.nextDisplayRow(nextRow, rowOnly);
        return nextRow;
    }
    prevDisplayRow(row, rowOnly) {
        var index = this.getDisplayRowIndex(row), prevRow = false;
        if (index) prevRow = this.getDisplayRows()[index - 1];
        if (rowOnly && prevRow && (!(prevRow instanceof $c2a9788f40f9c90a$var$Row) || prevRow.type != "row")) return this.prevDisplayRow(prevRow, rowOnly);
        return prevRow;
    }
    findRowIndex(row, list) {
        var rowIndex;
        row = this.findRow(row);
        if (row) {
            rowIndex = list.indexOf(row);
            if (rowIndex > -1) return rowIndex;
        }
        return false;
    }
    getData(active, transform) {
        var output = [], rows = this.getRows(active);
        rows.forEach(function(row) {
            if (row.type == "row") output.push(row.getData(transform || "data"));
        });
        return output;
    }
    getComponents(active) {
        var output = [], rows = this.getRows(active);
        rows.forEach(function(row) {
            output.push(row.getComponent());
        });
        return output;
    }
    getDataCount(active) {
        var rows = this.getRows(active);
        return rows.length;
    }
    scrollHorizontal(left) {
        this.scrollLeft = left;
        this.element.scrollLeft = left;
        this.dispatch("scroll-horizontal", left);
    }
    registerDataPipelineHandler(handler, priority) {
        if (typeof priority !== "undefined") {
            this.dataPipeline.push({
                handler: handler,
                priority: priority
            });
            this.dataPipeline.sort((a, b)=>{
                return a.priority - b.priority;
            });
        } else console.error("Data pipeline handlers must have a priority in order to be registered");
    }
    registerDisplayPipelineHandler(handler, priority) {
        if (typeof priority !== "undefined") {
            this.displayPipeline.push({
                handler: handler,
                priority: priority
            });
            this.displayPipeline.sort((a, b)=>{
                return a.priority - b.priority;
            });
        } else console.error("Display pipeline handlers must have a priority in order to be registered");
    }
    //set active data set
    refreshActiveData(handler, skipStage, renderInPosition) {
        var table = this.table, stage = "", index = 0, cascadeOrder = [
            "all",
            "dataPipeline",
            "display",
            "displayPipeline",
            "end"
        ];
        if (!this.table.destroyed) {
            if (typeof handler === "function") {
                index = this.dataPipeline.findIndex((item)=>{
                    return item.handler === handler;
                });
                if (index > -1) {
                    stage = "dataPipeline";
                    if (skipStage) {
                        if (index == this.dataPipeline.length - 1) stage = "display";
                        else index++;
                    }
                } else {
                    index = this.displayPipeline.findIndex((item)=>{
                        return item.handler === handler;
                    });
                    if (index > -1) {
                        stage = "displayPipeline";
                        if (skipStage) {
                            if (index == this.displayPipeline.length - 1) stage = "end";
                            else index++;
                        }
                    } else {
                        console.error("Unable to refresh data, invalid handler provided", handler);
                        return;
                    }
                }
            } else {
                stage = handler || "all";
                index = 0;
            }
            if (this.redrawBlock) {
                if (!this.redrawBlockRestoreConfig || this.redrawBlockRestoreConfig && (this.redrawBlockRestoreConfig.stage === stage && index < this.redrawBlockRestoreConfig.index || cascadeOrder.indexOf(stage) < cascadeOrder.indexOf(this.redrawBlockRestoreConfig.stage))) this.redrawBlockRestoreConfig = {
                    handler: handler,
                    skipStage: skipStage,
                    renderInPosition: renderInPosition,
                    stage: stage,
                    index: index
                };
                return;
            } else {
                if ($c2a9788f40f9c90a$var$Helpers.elVisible(this.element)) {
                    if (renderInPosition) this.reRenderInPosition(this.refreshPipelines.bind(this, handler, stage, index, renderInPosition));
                    else {
                        this.refreshPipelines(handler, stage, index, renderInPosition);
                        if (!handler) this.table.columnManager.renderer.renderColumns();
                        this.renderTable();
                        if (table.options.layoutColumnsOnNewData) this.table.columnManager.redraw(true);
                    }
                } else this.refreshPipelines(handler, stage, index, renderInPosition);
                this.dispatch("data-refreshed");
            }
        }
    }
    refreshPipelines(handler, stage, index, renderInPosition) {
        this.dispatch("data-refreshing");
        if (!handler || !this.activeRowsPipeline[0]) this.activeRowsPipeline[0] = this.rows.slice(0);
        //cascade through data refresh stages
        switch(stage){
            case "all":
            //handle case where all data needs refreshing
            case "dataPipeline":
                for(let i = index; i < this.dataPipeline.length; i++){
                    let result = this.dataPipeline[i].handler(this.activeRowsPipeline[i].slice(0));
                    this.activeRowsPipeline[i + 1] = result || this.activeRowsPipeline[i].slice(0);
                }
                this.setActiveRows(this.activeRowsPipeline[this.dataPipeline.length]);
            case "display":
                index = 0;
                this.resetDisplayRows();
            case "displayPipeline":
                for(let i = index; i < this.displayPipeline.length; i++){
                    let result = this.displayPipeline[i].handler((i ? this.getDisplayRows(i - 1) : this.activeRows).slice(0), renderInPosition);
                    this.setDisplayRows(result || this.getDisplayRows(i - 1).slice(0), i);
                }
            case "end":
                //case to handle scenario when trying to skip past end stage
                this.regenerateRowPositions();
        }
        if (this.getDisplayRows().length) this._clearPlaceholder();
    }
    //regenerate row positions
    regenerateRowPositions() {
        var rows = this.getDisplayRows();
        var index = 1;
        rows.forEach((row)=>{
            if (row.type === "row") {
                row.setPosition(index);
                index++;
            }
        });
    }
    setActiveRows(activeRows) {
        this.activeRows = this.activeRows = Object.assign([], activeRows);
        this.activeRowsCount = this.activeRows.length;
    }
    //reset display rows array
    resetDisplayRows() {
        this.displayRows = [];
        this.displayRows.push(this.activeRows.slice(0));
        this.displayRowsCount = this.displayRows[0].length;
    }
    //set display row pipeline data
    setDisplayRows(displayRows, index) {
        this.displayRows[index] = displayRows;
        if (index == this.displayRows.length - 1) this.displayRowsCount = this.displayRows[this.displayRows.length - 1].length;
    }
    getDisplayRows(index) {
        if (typeof index == "undefined") return this.displayRows.length ? this.displayRows[this.displayRows.length - 1] : [];
        else return this.displayRows[index] || [];
    }
    getVisibleRows(chain, viewable) {
        var rows = Object.assign([], this.renderer.visibleRows(!viewable));
        if (chain) rows = this.chain("rows-visible", [
            viewable
        ], rows, rows);
        return rows;
    }
    //repeat action across display rows
    displayRowIterator(callback) {
        this.activeRowsPipeline.forEach(callback);
        this.displayRows.forEach(callback);
        this.displayRowsCount = this.displayRows[this.displayRows.length - 1].length;
    }
    //return only actual rows (not group headers etc)
    getRows(type) {
        var rows = [];
        switch(type){
            case "active":
                rows = this.activeRows;
                break;
            case "display":
                rows = this.table.rowManager.getDisplayRows();
                break;
            case "visible":
                rows = this.getVisibleRows(false, true);
                break;
            default:
                rows = this.chain("rows-retrieve", type, null, this.rows) || this.rows;
        }
        return rows;
    }
    ///////////////// Table Rendering /////////////////
    //trigger rerender of table in current position
    reRenderInPosition(callback) {
        if (this.redrawBlock) {
            if (callback) callback();
            else this.redrawBlockRenderInPosition = true;
        } else {
            this.dispatchExternal("renderStarted");
            this.renderer.rerenderRows(callback);
            if (!this.fixedHeight) this.adjustTableSize();
            this.scrollBarCheck();
            this.dispatchExternal("renderComplete");
        }
    }
    scrollBarCheck() {
        var scrollbarWidth = 0;
        //adjust for vertical scrollbar moving table when present
        if (this.element.scrollHeight > this.element.clientHeight) scrollbarWidth = this.element.offsetWidth - this.element.clientWidth;
        if (scrollbarWidth !== this.scrollbarWidth) {
            this.scrollbarWidth = scrollbarWidth;
            this.dispatch("scrollbar-vertical", scrollbarWidth);
        }
    }
    initializeRenderer() {
        var renderClass;
        var renderers = {
            "virtual": $c2a9788f40f9c90a$var$VirtualDomVertical,
            "basic": $c2a9788f40f9c90a$var$BasicVertical
        };
        if (typeof this.table.options.renderVertical === "string") renderClass = renderers[this.table.options.renderVertical];
        else renderClass = this.table.options.renderVertical;
        if (renderClass) {
            this.renderMode = this.table.options.renderVertical;
            this.renderer = new renderClass(this.table, this.element, this.tableElement);
            this.renderer.initialize();
            if ((this.table.element.clientHeight || this.table.options.height) && !(this.table.options.minHeight && this.table.options.maxHeight)) this.fixedHeight = true;
            else this.fixedHeight = false;
        } else console.error("Unable to find matching renderer:", this.table.options.renderVertical);
    }
    getRenderMode() {
        return this.renderMode;
    }
    renderTable() {
        this.dispatchExternal("renderStarted");
        this.element.scrollTop = 0;
        this._clearTable();
        if (this.displayRowsCount) {
            this.renderer.renderRows();
            if (this.firstRender) {
                this.firstRender = false;
                if (!this.fixedHeight) this.adjustTableSize();
                this.layoutRefresh(true);
            }
        } else this.renderEmptyScroll();
        if (!this.fixedHeight) this.adjustTableSize();
        this.dispatch("table-layout");
        if (!this.displayRowsCount) this._showPlaceholder();
        this.scrollBarCheck();
        this.dispatchExternal("renderComplete");
    }
    //show scrollbars on empty table div
    renderEmptyScroll() {
        if (this.placeholder) this.tableElement.style.display = "none";
        else this.tableElement.style.minWidth = this.table.columnManager.getWidth() + "px";
    }
    _clearTable() {
        this._clearPlaceholder();
        this.scrollTop = 0;
        this.scrollLeft = 0;
        this.renderer.clearRows();
    }
    tableEmpty() {
        this.renderEmptyScroll();
        this._showPlaceholder();
    }
    checkPlaceholder() {
        if (this.displayRowsCount) this._clearPlaceholder();
        else this.tableEmpty();
    }
    _showPlaceholder() {
        if (this.placeholder) {
            if (this.placeholder && this.placeholder.parentNode) this.placeholder.parentNode.removeChild(this.placeholder);
            this.initializePlaceholder();
            this.placeholder.setAttribute("tabulator-render-mode", this.renderMode);
            this.getElement().appendChild(this.placeholder);
            this._positionPlaceholder();
            this.adjustTableSize();
        }
    }
    _clearPlaceholder() {
        if (this.placeholder && this.placeholder.parentNode) this.placeholder.parentNode.removeChild(this.placeholder);
        // clear empty table placeholder min
        this.tableElement.style.minWidth = "";
        this.tableElement.style.display = "";
    }
    _positionPlaceholder() {
        if (this.placeholder && this.placeholder.parentNode) {
            this.placeholder.style.width = this.table.columnManager.getWidth() + "px";
            this.placeholderContents.style.width = this.table.rowManager.element.clientWidth + "px";
            this.placeholderContents.style.marginLeft = this.scrollLeft + "px";
        }
    }
    styleRow(row, index) {
        var rowEl = row.getElement();
        if (index % 2) {
            rowEl.classList.add("tabulator-row-even");
            rowEl.classList.remove("tabulator-row-odd");
        } else {
            rowEl.classList.add("tabulator-row-odd");
            rowEl.classList.remove("tabulator-row-even");
        }
    }
    //normalize height of active rows
    normalizeHeight(force) {
        this.activeRows.forEach(function(row) {
            row.normalizeHeight(force);
        });
    }
    //adjust the height of the table holder to fit in the Tabulator element
    adjustTableSize() {
        let initialHeight = this.element.clientHeight, minHeight;
        let resized = false;
        if (this.renderer.verticalFillMode === "fill") {
            let otherHeight = Math.floor(this.table.columnManager.getElement().getBoundingClientRect().height + (this.table.footerManager && this.table.footerManager.active && !this.table.footerManager.external ? this.table.footerManager.getElement().getBoundingClientRect().height : 0));
            if (this.fixedHeight) {
                minHeight = isNaN(this.table.options.minHeight) ? this.table.options.minHeight : this.table.options.minHeight + "px";
                const height = "calc(100% - " + otherHeight + "px)";
                this.element.style.minHeight = minHeight || "calc(100% - " + otherHeight + "px)";
                this.element.style.height = height;
                this.element.style.maxHeight = height;
            } else {
                this.element.style.height = "";
                this.element.style.height = this.table.element.clientHeight - otherHeight + "px";
                this.element.scrollTop = this.scrollTop;
            }
            this.renderer.resize();
            //check if the table has changed size when dealing with variable height tables
            if (!this.fixedHeight && initialHeight != this.element.clientHeight) {
                resized = true;
                if (this.subscribed("table-resize")) this.dispatch("table-resize");
                else this.redraw();
            }
            this.scrollBarCheck();
        }
        this._positionPlaceholder();
        return resized;
    }
    //reinitialize all rows
    reinitialize() {
        this.rows.forEach(function(row) {
            row.reinitialize(true);
        });
    }
    //prevent table from being redrawn
    blockRedraw() {
        this.redrawBlock = true;
        this.redrawBlockRestoreConfig = false;
    }
    //restore table redrawing
    restoreRedraw() {
        this.redrawBlock = false;
        if (this.redrawBlockRestoreConfig) {
            this.refreshActiveData(this.redrawBlockRestoreConfig.handler, this.redrawBlockRestoreConfig.skipStage, this.redrawBlockRestoreConfig.renderInPosition);
            this.redrawBlockRestoreConfig = false;
        } else if (this.redrawBlockRenderInPosition) this.reRenderInPosition();
        this.redrawBlockRenderInPosition = false;
    }
    //redraw table
    redraw(force) {
        this.adjustTableSize();
        this.table.tableWidth = this.table.element.clientWidth;
        if (!force) {
            this.reRenderInPosition();
            this.scrollHorizontal(this.scrollLeft);
        } else this.renderTable();
    }
    resetScroll() {
        this.element.scrollLeft = 0;
        this.element.scrollTop = 0;
        if (this.table.browser === "ie") {
            var event = document.createEvent("Event");
            event.initEvent("scroll", false, true);
            this.element.dispatchEvent(event);
        } else this.element.dispatchEvent(new Event('scroll'));
    }
}
class $c2a9788f40f9c90a$var$FooterManager extends $c2a9788f40f9c90a$var$CoreFeature {
    constructor(table){
        super(table);
        this.active = false;
        this.element = this.createElement(); //containing element
        this.containerElement = this.createContainerElement(); //containing element
        this.external = false;
    }
    initialize() {
        this.initializeElement();
    }
    createElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-footer");
        return el;
    }
    createContainerElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-footer-contents");
        this.element.appendChild(el);
        return el;
    }
    initializeElement() {
        if (this.table.options.footerElement) switch(typeof this.table.options.footerElement){
            case "string":
                if (this.table.options.footerElement[0] === "<") this.containerElement.innerHTML = this.table.options.footerElement;
                else {
                    this.external = true;
                    this.containerElement = document.querySelector(this.table.options.footerElement);
                }
                break;
            default:
                this.element = this.table.options.footerElement;
                break;
        }
    }
    getElement() {
        return this.element;
    }
    append(element) {
        this.activate();
        this.containerElement.appendChild(element);
        this.table.rowManager.adjustTableSize();
    }
    prepend(element) {
        this.activate();
        this.element.insertBefore(element, this.element.firstChild);
        this.table.rowManager.adjustTableSize();
    }
    remove(element) {
        element.parentNode.removeChild(element);
        this.deactivate();
    }
    deactivate(force) {
        if (!this.element.firstChild || force) {
            if (!this.external) this.element.parentNode.removeChild(this.element);
            this.active = false;
        }
    }
    activate() {
        if (!this.active) {
            this.active = true;
            if (!this.external) {
                this.table.element.appendChild(this.getElement());
                this.table.element.style.display = '';
            }
        }
    }
    redraw() {
        this.dispatch("footer-redraw");
    }
}
class $c2a9788f40f9c90a$var$InteractionManager extends $c2a9788f40f9c90a$var$CoreFeature {
    constructor(table){
        super(table);
        this.el = null;
        this.abortClasses = [
            "tabulator-headers",
            "tabulator-table"
        ];
        this.previousTargets = {};
        this.listeners = [
            "click",
            "dblclick",
            "contextmenu",
            "mouseenter",
            "mouseleave",
            "mouseover",
            "mouseout",
            "mousemove",
            "mouseup",
            "mousedown",
            "touchstart",
            "touchend"
        ];
        this.componentMap = {
            "tabulator-cell": "cell",
            "tabulator-row": "row",
            "tabulator-group": "group",
            "tabulator-col": "column"
        };
        this.pseudoTrackers = {
            "row": {
                subscriber: null,
                target: null
            },
            "cell": {
                subscriber: null,
                target: null
            },
            "group": {
                subscriber: null,
                target: null
            },
            "column": {
                subscriber: null,
                target: null
            }
        };
        this.pseudoTracking = false;
    }
    initialize() {
        this.el = this.table.element;
        this.buildListenerMap();
        this.bindSubscriptionWatchers();
    }
    buildListenerMap() {
        var listenerMap = {};
        this.listeners.forEach((listener)=>{
            listenerMap[listener] = {
                handler: null,
                components: []
            };
        });
        this.listeners = listenerMap;
    }
    bindPseudoEvents() {
        Object.keys(this.pseudoTrackers).forEach((key)=>{
            this.pseudoTrackers[key].subscriber = this.pseudoMouseEnter.bind(this, key);
            this.subscribe(key + "-mouseover", this.pseudoTrackers[key].subscriber);
        });
        this.pseudoTracking = true;
    }
    pseudoMouseEnter(key, e, target) {
        if (this.pseudoTrackers[key].target !== target) {
            if (this.pseudoTrackers[key].target) this.dispatch(key + "-mouseleave", e, this.pseudoTrackers[key].target);
            this.pseudoMouseLeave(key, e);
            this.pseudoTrackers[key].target = target;
            this.dispatch(key + "-mouseenter", e, target);
        }
    }
    pseudoMouseLeave(key, e) {
        var leaveList = Object.keys(this.pseudoTrackers), linkedKeys = {
            "row": [
                "cell"
            ],
            "cell": [
                "row"
            ]
        };
        leaveList = leaveList.filter((item)=>{
            var links = linkedKeys[key];
            return item !== key && (!links || links && !links.includes(item));
        });
        leaveList.forEach((key)=>{
            var target = this.pseudoTrackers[key].target;
            if (this.pseudoTrackers[key].target) {
                this.dispatch(key + "-mouseleave", e, target);
                this.pseudoTrackers[key].target = null;
            }
        });
    }
    bindSubscriptionWatchers() {
        var listeners = Object.keys(this.listeners), components = Object.values(this.componentMap);
        for (let comp of components)for (let listener of listeners){
            let key = comp + "-" + listener;
            this.subscriptionChange(key, this.subscriptionChanged.bind(this, comp, listener));
        }
        this.subscribe("table-destroy", this.clearWatchers.bind(this));
    }
    subscriptionChanged(component, key, added) {
        var listener = this.listeners[key].components, index = listener.indexOf(component), changed = false;
        if (added) {
            if (index === -1) {
                listener.push(component);
                changed = true;
            }
        } else {
            if (!this.subscribed(component + "-" + key)) {
                if (index > -1) {
                    listener.splice(index, 1);
                    changed = true;
                }
            }
        }
        if ((key === "mouseenter" || key === "mouseleave") && !this.pseudoTracking) this.bindPseudoEvents();
        if (changed) this.updateEventListeners();
    }
    updateEventListeners() {
        for(let key in this.listeners){
            let listener = this.listeners[key];
            if (listener.components.length) {
                if (!listener.handler) {
                    listener.handler = this.track.bind(this, key);
                    this.el.addEventListener(key, listener.handler);
                // this.el.addEventListener(key, listener.handler, {passive: true})
                }
            } else if (listener.handler) {
                this.el.removeEventListener(key, listener.handler);
                listener.handler = null;
            }
        }
    }
    track(type, e) {
        var path = e.composedPath && e.composedPath() || e.path;
        var targets = this.findTargets(path);
        targets = this.bindComponents(type, targets);
        this.triggerEvents(type, e, targets);
        if (this.pseudoTracking && (type == "mouseover" || type == "mouseleave") && !Object.keys(targets).length) this.pseudoMouseLeave("none", e);
    }
    findTargets(path) {
        var targets = {};
        let componentMap = Object.keys(this.componentMap);
        for (let el of path){
            let classList = el.classList ? [
                ...el.classList
            ] : [];
            let abort = classList.filter((item)=>{
                return this.abortClasses.includes(item);
            });
            if (abort.length) break;
            let elTargets = classList.filter((item)=>{
                return componentMap.includes(item);
            });
            for (let target of elTargets)if (!targets[this.componentMap[target]]) targets[this.componentMap[target]] = el;
        }
        if (targets.group && targets.group === targets.row) delete targets.row;
        return targets;
    }
    bindComponents(type, targets) {
        //ensure row component is looked up before cell
        var keys = Object.keys(targets).reverse(), listener = this.listeners[type], matches = {}, targetMatches = {};
        for (let key of keys){
            let component, target = targets[key], previousTarget = this.previousTargets[key];
            if (previousTarget && previousTarget.target === target) component = previousTarget.component;
            else switch(key){
                case "row":
                case "group":
                    if (listener.components.includes("row") || listener.components.includes("cell") || listener.components.includes("group")) {
                        let rows = this.table.rowManager.getVisibleRows(true);
                        component = rows.find((row)=>{
                            return row.getElement() === target;
                        });
                        if (targets["row"] && targets["row"].parentNode && targets["row"].parentNode.closest(".tabulator-row")) targets[key] = false;
                    }
                    break;
                case "column":
                    if (listener.components.includes("column")) component = this.table.columnManager.findColumn(target);
                    break;
                case "cell":
                    if (listener.components.includes("cell")) {
                        if (matches["row"] instanceof $c2a9788f40f9c90a$var$Row) component = matches["row"].findCell(target);
                        else if (targets["row"]) console.warn("Event Target Lookup Error - The row this cell is attached to cannot be found, has the table been reinitialized without being destroyed first?");
                    }
                    break;
            }
            if (component) {
                matches[key] = component;
                targetMatches[key] = {
                    target: target,
                    component: component
                };
            }
        }
        this.previousTargets = targetMatches;
        return matches;
    }
    triggerEvents(type, e, targets) {
        var listener = this.listeners[type];
        for(let key in targets)if (targets[key] && listener.components.includes(key)) this.dispatch(key + "-" + type, e, targets[key]);
    }
    clearWatchers() {
        for(let key in this.listeners){
            let listener = this.listeners[key];
            if (listener.handler) {
                this.el.removeEventListener(key, listener.handler);
                listener.handler = null;
            }
        }
    }
}
class $c2a9788f40f9c90a$var$ComponentFunctionBinder {
    constructor(table){
        this.table = table;
        this.bindings = {};
    }
    bind(type, funcName, handler) {
        if (!this.bindings[type]) this.bindings[type] = {};
        if (this.bindings[type][funcName]) console.warn("Unable to bind component handler, a matching function name is already bound", type, funcName, handler);
        else this.bindings[type][funcName] = handler;
    }
    handle(type, component, name) {
        if (this.bindings[type] && this.bindings[type][name] && typeof this.bindings[type][name].bind === 'function') return this.bindings[type][name].bind(null, component);
        else {
            if (name !== "then" && typeof name === "string" && !name.startsWith("_")) {
                if (this.table.options.debugInvalidComponentFuncs) console.error("The " + type + " component does not have a " + name + " function, have you checked that you have the correct Tabulator module installed?");
            }
        }
    }
}
class $c2a9788f40f9c90a$var$DataLoader extends $c2a9788f40f9c90a$var$CoreFeature {
    constructor(table){
        super(table);
        this.requestOrder = 0; //prevent requests coming out of sequence if overridden by another load request
        this.loading = false;
    }
    initialize() {}
    load(data, params, config, replace, silent, columnsChanged) {
        var requestNo = ++this.requestOrder;
        if (this.table.destroyed) return Promise.resolve();
        this.dispatchExternal("dataLoading", data);
        //parse json data to array
        if (data && (data.indexOf("{") == 0 || data.indexOf("[") == 0)) data = JSON.parse(data);
        if (this.confirm("data-loading", [
            data,
            params,
            config,
            silent
        ])) {
            this.loading = true;
            if (!silent) this.alertLoader();
            //get params for request
            params = this.chain("data-params", [
                data,
                config,
                silent
            ], params || {}, params || {});
            params = this.mapParams(params, this.table.options.dataSendParams);
            var result = this.chain("data-load", [
                data,
                params,
                config,
                silent
            ], false, Promise.resolve([]));
            return result.then((response)=>{
                if (!this.table.destroyed) {
                    if (!Array.isArray(response) && typeof response == "object") response = this.mapParams(response, this.objectInvert(this.table.options.dataReceiveParams));
                    var rowData = this.chain("data-loaded", [
                        response
                    ], null, response);
                    if (requestNo == this.requestOrder) {
                        this.clearAlert();
                        if (rowData !== false) {
                            this.dispatchExternal("dataLoaded", rowData);
                            this.table.rowManager.setData(rowData, replace, typeof columnsChanged === "undefined" ? !replace : columnsChanged);
                        }
                    } else console.warn("Data Load Response Blocked - An active data load request was blocked by an attempt to change table data while the request was being made");
                } else console.warn("Data Load Response Blocked - Table has been destroyed");
            }).catch((error)=>{
                console.error("Data Load Error: ", error);
                this.dispatchExternal("dataLoadError", error);
                if (!silent) this.alertError();
                setTimeout(()=>{
                    this.clearAlert();
                }, this.table.options.dataLoaderErrorTimeout);
            }).finally(()=>{
                this.loading = false;
            });
        } else {
            this.dispatchExternal("dataLoaded", data);
            if (!data) data = [];
            this.table.rowManager.setData(data, replace, typeof columnsChanged === "undefined" ? !replace : columnsChanged);
            return Promise.resolve();
        }
    }
    mapParams(params, map) {
        var output = {};
        for(let key in params)output[map.hasOwnProperty(key) ? map[key] : key] = params[key];
        return output;
    }
    objectInvert(obj) {
        var output = {};
        for(let key in obj)output[obj[key]] = key;
        return output;
    }
    blockActiveLoad() {
        this.requestOrder++;
    }
    alertLoader() {
        var shouldLoad = typeof this.table.options.dataLoader === "function" ? this.table.options.dataLoader() : this.table.options.dataLoader;
        if (shouldLoad) this.table.alertManager.alert(this.table.options.dataLoaderLoading || this.langText("data|loading"));
    }
    alertError() {
        this.table.alertManager.alert(this.table.options.dataLoaderError || this.langText("data|error"), "error");
    }
    clearAlert() {
        this.table.alertManager.clear();
    }
}
class $c2a9788f40f9c90a$var$ExternalEventBus {
    constructor(table, optionsList, debug){
        this.table = table;
        this.events = {};
        this.optionsList = optionsList || {};
        this.subscriptionNotifiers = {};
        this.dispatch = debug ? this._debugDispatch.bind(this) : this._dispatch.bind(this);
        this.debug = debug;
    }
    subscriptionChange(key, callback) {
        if (!this.subscriptionNotifiers[key]) this.subscriptionNotifiers[key] = [];
        this.subscriptionNotifiers[key].push(callback);
        if (this.subscribed(key)) this._notifySubscriptionChange(key, true);
    }
    subscribe(key, callback) {
        if (!this.events[key]) this.events[key] = [];
        this.events[key].push(callback);
        this._notifySubscriptionChange(key, true);
    }
    unsubscribe(key, callback) {
        var index;
        if (this.events[key]) {
            if (callback) {
                index = this.events[key].findIndex((item)=>{
                    return item === callback;
                });
                if (index > -1) this.events[key].splice(index, 1);
                else {
                    console.warn("Cannot remove event, no matching event found:", key, callback);
                    return;
                }
            } else delete this.events[key];
        } else {
            console.warn("Cannot remove event, no events set on:", key);
            return;
        }
        this._notifySubscriptionChange(key, false);
    }
    subscribed(key) {
        return this.events[key] && this.events[key].length;
    }
    _notifySubscriptionChange(key, subscribed) {
        var notifiers = this.subscriptionNotifiers[key];
        if (notifiers) notifiers.forEach((callback)=>{
            callback(subscribed);
        });
    }
    _dispatch() {
        var args = Array.from(arguments), key = args.shift(), result;
        if (this.events[key]) this.events[key].forEach((callback, i)=>{
            let callResult = callback.apply(this.table, args);
            if (!i) result = callResult;
        });
        return result;
    }
    _debugDispatch() {
        var args = Array.from(arguments), key = args[0];
        args[0] = "ExternalEvent:" + args[0];
        if (this.debug === true || this.debug.includes(key)) console.log(...args);
        return this._dispatch(...arguments);
    }
}
class $c2a9788f40f9c90a$var$InternalEventBus {
    constructor(debug){
        this.events = {};
        this.subscriptionNotifiers = {};
        this.dispatch = debug ? this._debugDispatch.bind(this) : this._dispatch.bind(this);
        this.chain = debug ? this._debugChain.bind(this) : this._chain.bind(this);
        this.confirm = debug ? this._debugConfirm.bind(this) : this._confirm.bind(this);
        this.debug = debug;
    }
    subscriptionChange(key, callback) {
        if (!this.subscriptionNotifiers[key]) this.subscriptionNotifiers[key] = [];
        this.subscriptionNotifiers[key].push(callback);
        if (this.subscribed(key)) this._notifySubscriptionChange(key, true);
    }
    subscribe(key, callback, priority = 10000) {
        if (!this.events[key]) this.events[key] = [];
        this.events[key].push({
            callback: callback,
            priority: priority
        });
        this.events[key].sort((a, b)=>{
            return a.priority - b.priority;
        });
        this._notifySubscriptionChange(key, true);
    }
    unsubscribe(key, callback) {
        var index;
        if (this.events[key]) {
            if (callback) {
                index = this.events[key].findIndex((item)=>{
                    return item.callback === callback;
                });
                if (index > -1) this.events[key].splice(index, 1);
                else {
                    console.warn("Cannot remove event, no matching event found:", key, callback);
                    return;
                }
            }
        } else {
            console.warn("Cannot remove event, no events set on:", key);
            return;
        }
        this._notifySubscriptionChange(key, false);
    }
    subscribed(key) {
        return this.events[key] && this.events[key].length;
    }
    _chain(key, args, initialValue, fallback) {
        var value = initialValue;
        if (!Array.isArray(args)) args = [
            args
        ];
        if (this.subscribed(key)) {
            this.events[key].forEach((subscriber, i)=>{
                value = subscriber.callback.apply(this, args.concat([
                    value
                ]));
            });
            return value;
        } else return typeof fallback === "function" ? fallback() : fallback;
    }
    _confirm(key, args) {
        var confirmed = false;
        if (!Array.isArray(args)) args = [
            args
        ];
        if (this.subscribed(key)) this.events[key].forEach((subscriber, i)=>{
            if (subscriber.callback.apply(this, args)) confirmed = true;
        });
        return confirmed;
    }
    _notifySubscriptionChange(key, subscribed) {
        var notifiers = this.subscriptionNotifiers[key];
        if (notifiers) notifiers.forEach((callback)=>{
            callback(subscribed);
        });
    }
    _dispatch() {
        var args = Array.from(arguments), key = args.shift();
        if (this.events[key]) this.events[key].forEach((subscriber)=>{
            subscriber.callback.apply(this, args);
        });
    }
    _debugDispatch() {
        var args = Array.from(arguments), key = args[0];
        args[0] = "InternalEvent:" + key;
        if (this.debug === true || this.debug.includes(key)) console.log(...args);
        return this._dispatch(...arguments);
    }
    _debugChain() {
        var args = Array.from(arguments), key = args[0];
        args[0] = "InternalEvent:" + key;
        if (this.debug === true || this.debug.includes(key)) console.log(...args);
        return this._chain(...arguments);
    }
    _debugConfirm() {
        var args = Array.from(arguments), key = args[0];
        args[0] = "InternalEvent:" + key;
        if (this.debug === true || this.debug.includes(key)) console.log(...args);
        return this._confirm(...arguments);
    }
}
class $c2a9788f40f9c90a$var$DeprecationAdvisor extends $c2a9788f40f9c90a$var$CoreFeature {
    constructor(table){
        super(table);
    }
    _warnUser() {
        if (this.options("debugDeprecation")) console.warn(...arguments);
    }
    check(oldOption, newOption, convert) {
        var msg = "";
        if (typeof this.options(oldOption) !== "undefined") {
            msg = "Deprecated Setup Option - Use of the %c" + oldOption + "%c option is now deprecated";
            if (newOption) {
                msg = msg + ", Please use the %c" + newOption + "%c option instead";
                this._warnUser(msg, 'font-weight: bold;', 'font-weight: normal;', 'font-weight: bold;', 'font-weight: normal;');
                if (convert) this.table.options[newOption] = this.table.options[oldOption];
            } else this._warnUser(msg, 'font-weight: bold;', 'font-weight: normal;');
            return false;
        } else return true;
    }
    checkMsg(oldOption, msg) {
        if (typeof this.options(oldOption) !== "undefined") {
            this._warnUser("%cDeprecated Setup Option - Use of the %c" + oldOption + " %c option is now deprecated, " + msg, 'font-weight: normal;', 'font-weight: bold;', 'font-weight: normal;');
            return false;
        } else return true;
    }
    msg(msg) {
        this._warnUser(msg);
    }
}
class $c2a9788f40f9c90a$var$DependencyRegistry extends $c2a9788f40f9c90a$var$CoreFeature {
    constructor(table){
        super(table);
        this.deps = {};
        this.props = {};
    }
    initialize() {
        this.deps = Object.assign({}, this.options("dependencies"));
    }
    lookup(key, prop, silent) {
        if (Array.isArray(key)) {
            for (const item of key){
                var match = this.lookup(item, prop, true);
                if (match) break;
            }
            if (match) return match;
            else this.error(key);
        } else {
            if (prop) return this.lookupProp(key, prop, silent);
            else return this.lookupKey(key, silent);
        }
    }
    lookupProp(key, prop, silent) {
        var dependency;
        if (this.props[key] && this.props[key][prop]) return this.props[key][prop];
        else {
            dependency = this.lookupKey(key, silent);
            if (dependency) {
                if (!this.props[key]) this.props[key] = {};
                this.props[key][prop] = dependency[prop] || dependency;
                return this.props[key][prop];
            }
        }
    }
    lookupKey(key, silent) {
        var dependency;
        if (this.deps[key]) dependency = this.deps[key];
        else if (window[key]) {
            this.deps[key] = window[key];
            dependency = this.deps[key];
        } else if (!silent) this.error(key);
        return dependency;
    }
    error(key) {
        console.error("Unable to find dependency", key, "Please check documentation and ensure you have imported the required library into your project");
    }
}
//resize columns to fit data they contain
function $c2a9788f40f9c90a$var$fitData(columns, forced) {
    if (forced) this.table.columnManager.renderer.reinitializeColumnWidths(columns);
    if (this.table.options.responsiveLayout && this.table.modExists("responsiveLayout", true)) this.table.modules.responsiveLayout.update();
}
//resize columns to fit data they contain and stretch row to fill table, also used for fitDataTable
function $c2a9788f40f9c90a$var$fitDataGeneral(columns, forced) {
    columns.forEach(function(column) {
        column.reinitializeWidth();
    });
    if (this.table.options.responsiveLayout && this.table.modExists("responsiveLayout", true)) this.table.modules.responsiveLayout.update();
}
//resize columns to fit data the contain and stretch last column to fill table
function $c2a9788f40f9c90a$var$fitDataStretch(columns, forced) {
    var colsWidth = 0, tableWidth = this.table.rowManager.element.clientWidth, gap = 0, lastCol = false;
    columns.forEach((column, i)=>{
        if (!column.widthFixed) column.reinitializeWidth();
        if (this.table.options.responsiveLayout ? column.modules.responsive.visible : column.visible) lastCol = column;
        if (column.visible) colsWidth += column.getWidth();
    });
    if (lastCol) {
        gap = tableWidth - colsWidth + lastCol.getWidth();
        if (this.table.options.responsiveLayout && this.table.modExists("responsiveLayout", true)) {
            lastCol.setWidth(0);
            this.table.modules.responsiveLayout.update();
        }
        if (gap > 0) lastCol.setWidth(gap);
        else lastCol.reinitializeWidth();
    } else if (this.table.options.responsiveLayout && this.table.modExists("responsiveLayout", true)) this.table.modules.responsiveLayout.update();
}
//resize columns to fit
function $c2a9788f40f9c90a$var$fitColumns(columns, forced) {
    var totalWidth = this.table.rowManager.element.getBoundingClientRect().width; //table element width
    var fixedWidth = 0; //total width of columns with a defined width
    var flexWidth = 0; //total width available to flexible columns
    var flexGrowUnits = 0; //total number of widthGrow blocks across all columns
    var flexColWidth = 0; //desired width of flexible columns
    var flexColumns = []; //array of flexible width columns
    var fixedShrinkColumns = []; //array of fixed width columns that can shrink
    var flexShrinkUnits = 0; //total number of widthShrink blocks across all columns
    var overflowWidth = 0; //horizontal overflow width
    var gapFill = 0; //number of pixels to be added to final column to close and half pixel gaps
    function calcWidth(width) {
        var colWidth;
        if (typeof width == "string") {
            if (width.indexOf("%") > -1) colWidth = totalWidth / 100 * parseInt(width);
            else colWidth = parseInt(width);
        } else colWidth = width;
        return colWidth;
    }
    //ensure columns resize to take up the correct amount of space
    function scaleColumns(columns, freeSpace, colWidth, shrinkCols) {
        var oversizeCols = [], oversizeSpace = 0, remainingSpace = 0, nextColWidth = 0, remainingFlexGrowUnits = flexGrowUnits, gap = 0, changeUnits = 0, undersizeCols = [];
        function calcGrow(col) {
            return colWidth * (col.column.definition.widthGrow || 1);
        }
        function calcShrink(col) {
            return calcWidth(col.width) - colWidth * (col.column.definition.widthShrink || 0);
        }
        columns.forEach(function(col, i) {
            var width = shrinkCols ? calcShrink(col) : calcGrow(col);
            if (col.column.minWidth >= width) oversizeCols.push(col);
            else if (col.column.maxWidth && col.column.maxWidth < width) {
                col.width = col.column.maxWidth;
                freeSpace -= col.column.maxWidth;
                remainingFlexGrowUnits -= shrinkCols ? col.column.definition.widthShrink || 1 : col.column.definition.widthGrow || 1;
                if (remainingFlexGrowUnits) colWidth = Math.floor(freeSpace / remainingFlexGrowUnits);
            } else {
                undersizeCols.push(col);
                changeUnits += shrinkCols ? col.column.definition.widthShrink || 1 : col.column.definition.widthGrow || 1;
            }
        });
        if (oversizeCols.length) {
            oversizeCols.forEach(function(col) {
                oversizeSpace += shrinkCols ? col.width - col.column.minWidth : col.column.minWidth;
                col.width = col.column.minWidth;
            });
            remainingSpace = freeSpace - oversizeSpace;
            nextColWidth = changeUnits ? Math.floor(remainingSpace / changeUnits) : remainingSpace;
            gap = scaleColumns(undersizeCols, remainingSpace, nextColWidth, shrinkCols);
        } else {
            gap = changeUnits ? freeSpace - Math.floor(freeSpace / changeUnits) * changeUnits : freeSpace;
            undersizeCols.forEach(function(column) {
                column.width = shrinkCols ? calcShrink(column) : calcGrow(column);
            });
        }
        return gap;
    }
    if (this.table.options.responsiveLayout && this.table.modExists("responsiveLayout", true)) this.table.modules.responsiveLayout.update();
    //adjust for vertical scrollbar if present
    if (this.table.rowManager.element.scrollHeight > this.table.rowManager.element.clientHeight) totalWidth -= this.table.rowManager.element.offsetWidth - this.table.rowManager.element.clientWidth;
    columns.forEach(function(column) {
        var width, minWidth, colWidth;
        if (column.visible) {
            width = column.definition.width;
            minWidth = parseInt(column.minWidth);
            if (width) {
                colWidth = calcWidth(width);
                fixedWidth += colWidth > minWidth ? colWidth : minWidth;
                if (column.definition.widthShrink) {
                    fixedShrinkColumns.push({
                        column: column,
                        width: colWidth > minWidth ? colWidth : minWidth
                    });
                    flexShrinkUnits += column.definition.widthShrink;
                }
            } else {
                flexColumns.push({
                    column: column,
                    width: 0
                });
                flexGrowUnits += column.definition.widthGrow || 1;
            }
        }
    });
    //calculate available space
    flexWidth = totalWidth - fixedWidth;
    //calculate correct column size
    flexColWidth = Math.floor(flexWidth / flexGrowUnits);
    //generate column widths
    gapFill = scaleColumns(flexColumns, flexWidth, flexColWidth, false);
    //increase width of last column to account for rounding errors
    if (flexColumns.length && gapFill > 0) flexColumns[flexColumns.length - 1].width += gapFill;
    //calculate space for columns to be shrunk into
    flexColumns.forEach(function(col) {
        flexWidth -= col.width;
    });
    overflowWidth = Math.abs(gapFill) + flexWidth;
    //shrink oversize columns if there is no available space
    if (overflowWidth > 0 && flexShrinkUnits) gapFill = scaleColumns(fixedShrinkColumns, overflowWidth, Math.floor(overflowWidth / flexShrinkUnits), true);
    //decrease width of last column to account for rounding errors
    if (gapFill && fixedShrinkColumns.length) fixedShrinkColumns[fixedShrinkColumns.length - 1].width -= gapFill;
    flexColumns.forEach(function(col) {
        col.column.setWidth(col.width);
    });
    fixedShrinkColumns.forEach(function(col) {
        col.column.setWidth(col.width);
    });
}
var $c2a9788f40f9c90a$var$defaultModes = {
    fitData: $c2a9788f40f9c90a$var$fitData,
    fitDataFill: $c2a9788f40f9c90a$var$fitDataGeneral,
    fitDataTable: $c2a9788f40f9c90a$var$fitDataGeneral,
    fitDataStretch: $c2a9788f40f9c90a$var$fitDataStretch,
    fitColumns: $c2a9788f40f9c90a$var$fitColumns
};
class $c2a9788f40f9c90a$var$Layout extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "layout";
    //load defaults
    static modes = $c2a9788f40f9c90a$var$defaultModes;
    constructor(table){
        super(table, "layout");
        this.mode = null;
        this.registerTableOption("layout", "fitData"); //layout type
        this.registerTableOption("layoutColumnsOnNewData", false); //update column widths on setData
        this.registerColumnOption("widthGrow");
        this.registerColumnOption("widthShrink");
    }
    //initialize layout system
    initialize() {
        var layout = this.table.options.layout;
        if ($c2a9788f40f9c90a$var$Layout.modes[layout]) this.mode = layout;
        else {
            console.warn("Layout Error - invalid mode set, defaulting to 'fitData' : " + layout);
            this.mode = 'fitData';
        }
        this.table.element.setAttribute("tabulator-layout", this.mode);
        this.subscribe("column-init", this.initializeColumn.bind(this));
    }
    initializeColumn(column) {
        if (column.definition.widthGrow) column.definition.widthGrow = Number(column.definition.widthGrow);
        if (column.definition.widthShrink) column.definition.widthShrink = Number(column.definition.widthShrink);
    }
    getMode() {
        return this.mode;
    }
    //trigger table layout
    layout(dataChanged) {
        var variableHeight = this.table.columnManager.columnsByIndex.find((column)=>column.definition.variableHeight || column.definition.formatter === "textarea");
        this.dispatch("layout-refreshing");
        $c2a9788f40f9c90a$var$Layout.modes[this.mode].call(this, this.table.columnManager.columnsByIndex, dataChanged);
        if (variableHeight) this.table.rowManager.normalizeHeight(true);
        this.dispatch("layout-refreshed");
    }
}
var $c2a9788f40f9c90a$var$defaultLangs = {
    "default": {
        "groups": {
            "item": "item",
            "items": "items"
        },
        "columns": {},
        "data": {
            "loading": "Loading",
            "error": "Error"
        },
        "pagination": {
            "page_size": "Page Size",
            "page_title": "Show Page",
            "first": "First",
            "first_title": "First Page",
            "last": "Last",
            "last_title": "Last Page",
            "prev": "Prev",
            "prev_title": "Prev Page",
            "next": "Next",
            "next_title": "Next Page",
            "all": "All",
            "counter": {
                "showing": "Showing",
                "of": "of",
                "rows": "rows",
                "pages": "pages"
            }
        },
        "headerFilters": {
            "default": "filter column...",
            "columns": {}
        }
    }
};
class $c2a9788f40f9c90a$var$Localize extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "localize";
    //load defaults
    static langs = $c2a9788f40f9c90a$var$defaultLangs;
    constructor(table){
        super(table);
        this.locale = "default"; //current locale
        this.lang = false; //current language
        this.bindings = {}; //update events to call when locale is changed
        this.langList = {};
        this.registerTableOption("locale", false); //current system language
        this.registerTableOption("langs", {});
    }
    initialize() {
        this.langList = $c2a9788f40f9c90a$var$Helpers.deepClone($c2a9788f40f9c90a$var$Localize.langs);
        if (this.table.options.columnDefaults.headerFilterPlaceholder !== false) this.setHeaderFilterPlaceholder(this.table.options.columnDefaults.headerFilterPlaceholder);
        for(let locale in this.table.options.langs)this.installLang(locale, this.table.options.langs[locale]);
        this.setLocale(this.table.options.locale);
        this.registerTableFunction("setLocale", this.setLocale.bind(this));
        this.registerTableFunction("getLocale", this.getLocale.bind(this));
        this.registerTableFunction("getLang", this.getLang.bind(this));
    }
    //set header placeholder
    setHeaderFilterPlaceholder(placeholder) {
        this.langList.default.headerFilters.default = placeholder;
    }
    //setup a lang description object
    installLang(locale, lang) {
        if (this.langList[locale]) this._setLangProp(this.langList[locale], lang);
        else this.langList[locale] = lang;
    }
    _setLangProp(lang, values) {
        for(let key in values)if (lang[key] && typeof lang[key] == "object") this._setLangProp(lang[key], values[key]);
        else lang[key] = values[key];
    }
    //set current locale
    setLocale(desiredLocale) {
        desiredLocale = desiredLocale || "default";
        //fill in any matching language values
        function traverseLang(trans, path) {
            for(var prop in trans)if (typeof trans[prop] == "object") {
                if (!path[prop]) path[prop] = {};
                traverseLang(trans[prop], path[prop]);
            } else path[prop] = trans[prop];
        }
        //determining correct locale to load
        if (desiredLocale === true && navigator.language) //get local from system
        desiredLocale = navigator.language.toLowerCase();
        if (desiredLocale) //if locale is not set, check for matching top level locale else use default
        {
            if (!this.langList[desiredLocale]) {
                let prefix = desiredLocale.split("-")[0];
                if (this.langList[prefix]) {
                    console.warn("Localization Error - Exact matching locale not found, using closest match: ", desiredLocale, prefix);
                    desiredLocale = prefix;
                } else {
                    console.warn("Localization Error - Matching locale not found, using default: ", desiredLocale);
                    desiredLocale = "default";
                }
            }
        }
        this.locale = desiredLocale;
        //load default lang template
        this.lang = $c2a9788f40f9c90a$var$Helpers.deepClone(this.langList.default || {});
        if (desiredLocale != "default") traverseLang(this.langList[desiredLocale], this.lang);
        this.dispatchExternal("localized", this.locale, this.lang);
        this._executeBindings();
    }
    //get current locale
    getLocale(locale) {
        return this.locale;
    }
    //get lang object for given local or current if none provided
    getLang(locale) {
        return locale ? this.langList[locale] : this.lang;
    }
    //get text for current locale
    getText(path, value) {
        var fillPath = value ? path + "|" + value : path, pathArray = fillPath.split("|"), text = this._getLangElement(pathArray, this.locale);
        // if(text === false){
        // 	console.warn("Localization Error - Matching localized text not found for given path: ", path);
        // }
        return text || "";
    }
    //traverse langs object and find localized copy
    _getLangElement(path, locale) {
        var root = this.lang;
        path.forEach(function(level) {
            var rootPath;
            if (root) {
                rootPath = root[level];
                if (typeof rootPath != "undefined") root = rootPath;
                else root = false;
            }
        });
        return root;
    }
    //set update binding
    bind(path, callback) {
        if (!this.bindings[path]) this.bindings[path] = [];
        this.bindings[path].push(callback);
        callback(this.getText(path), this.lang);
    }
    //iterate through bindings and trigger updates
    _executeBindings() {
        for(let path in this.bindings)this.bindings[path].forEach((binding)=>{
            binding(this.getText(path), this.lang);
        });
    }
}
class $c2a9788f40f9c90a$var$Comms extends $c2a9788f40f9c90a$export$c3a9d7ff17e4f3ed {
    static moduleName = "comms";
    constructor(table){
        super(table);
    }
    initialize() {
        this.registerTableFunction("tableComms", this.receive.bind(this));
    }
    getConnections(selectors) {
        var connections = [], connection;
        connection = this.table.constructor.registry.lookupTable(selectors);
        connection.forEach((con)=>{
            if (this.table !== con) connections.push(con);
        });
        return connections;
    }
    send(selectors, module, action, data) {
        var connections = this.getConnections(selectors);
        connections.forEach((connection)=>{
            connection.tableComms(this.table.element, module, action, data);
        });
        if (!connections.length && selectors) console.warn("Table Connection Error - No tables matching selector found", selectors);
    }
    receive(table, module, action, data) {
        if (this.table.modExists(module)) return this.table.modules[module].commsReceived(table, action, data);
        else console.warn("Inter-table Comms Error - no such module:", module);
    }
}
var $c2a9788f40f9c90a$var$coreModules = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CommsModule: $c2a9788f40f9c90a$var$Comms,
    LayoutModule: $c2a9788f40f9c90a$var$Layout,
    LocalizeModule: $c2a9788f40f9c90a$var$Localize
});
class $c2a9788f40f9c90a$var$TableRegistry {
    static registry = {
        tables: [],
        register (table) {
            $c2a9788f40f9c90a$var$TableRegistry.registry.tables.push(table);
        },
        deregister (table) {
            var index = $c2a9788f40f9c90a$var$TableRegistry.registry.tables.indexOf(table);
            if (index > -1) $c2a9788f40f9c90a$var$TableRegistry.registry.tables.splice(index, 1);
        },
        lookupTable (query, silent) {
            var results = [], matches, match;
            if (typeof query === "string") {
                matches = document.querySelectorAll(query);
                if (matches.length) for(var i = 0; i < matches.length; i++){
                    match = $c2a9788f40f9c90a$var$TableRegistry.registry.matchElement(matches[i]);
                    if (match) results.push(match);
                }
            } else if (typeof HTMLElement !== "undefined" && query instanceof HTMLElement || query instanceof $c2a9788f40f9c90a$var$TableRegistry) {
                match = $c2a9788f40f9c90a$var$TableRegistry.registry.matchElement(query);
                if (match) results.push(match);
            } else if (Array.isArray(query)) query.forEach(function(item) {
                results = results.concat($c2a9788f40f9c90a$var$TableRegistry.registry.lookupTable(item));
            });
            else if (!silent) console.warn("Table Connection Error - Invalid Selector", query);
            return results;
        },
        matchElement (element) {
            return $c2a9788f40f9c90a$var$TableRegistry.registry.tables.find(function(table) {
                return element instanceof $c2a9788f40f9c90a$var$TableRegistry ? table === element : table.element === element;
            });
        }
    };
    static findTable(query) {
        var results = $c2a9788f40f9c90a$var$TableRegistry.registry.lookupTable(query, true);
        return Array.isArray(results) && !results.length ? false : results;
    }
}
class $c2a9788f40f9c90a$var$ModuleBinder extends $c2a9788f40f9c90a$var$TableRegistry {
    static moduleBindings = {};
    static moduleExtensions = {};
    static modulesRegistered = false;
    static defaultModules = false;
    constructor(){
        super();
    }
    static initializeModuleBinder(defaultModules) {
        if (!$c2a9788f40f9c90a$var$ModuleBinder.modulesRegistered) {
            $c2a9788f40f9c90a$var$ModuleBinder.modulesRegistered = true;
            $c2a9788f40f9c90a$var$ModuleBinder._registerModules($c2a9788f40f9c90a$var$coreModules, true);
            if (defaultModules) $c2a9788f40f9c90a$var$ModuleBinder._registerModules(defaultModules);
        }
    }
    static _extendModule(name, property, values) {
        if ($c2a9788f40f9c90a$var$ModuleBinder.moduleBindings[name]) {
            var source = $c2a9788f40f9c90a$var$ModuleBinder.moduleBindings[name][property];
            if (source) {
                if (typeof values == "object") for(let key in values)source[key] = values[key];
                else console.warn("Module Error - Invalid value type, it must be an object");
            } else console.warn("Module Error - property does not exist:", property);
        } else console.warn("Module Error - module does not exist:", name);
    }
    static _registerModules(modules, core) {
        var mods = Object.values(modules);
        if (core) mods.forEach((mod)=>{
            mod.prototype.moduleCore = true;
        });
        $c2a9788f40f9c90a$var$ModuleBinder._registerModule(mods);
    }
    static _registerModule(modules) {
        if (!Array.isArray(modules)) modules = [
            modules
        ];
        modules.forEach((mod)=>{
            $c2a9788f40f9c90a$var$ModuleBinder._registerModuleBinding(mod);
            $c2a9788f40f9c90a$var$ModuleBinder._registerModuleExtensions(mod);
        });
    }
    static _registerModuleBinding(mod) {
        if (mod.moduleName) $c2a9788f40f9c90a$var$ModuleBinder.moduleBindings[mod.moduleName] = mod;
        else console.error("Unable to bind module, no moduleName defined", mod.moduleName);
    }
    static _registerModuleExtensions(mod) {
        var extensions = mod.moduleExtensions;
        if (mod.moduleExtensions) for(let modKey in extensions){
            let ext = extensions[modKey];
            if ($c2a9788f40f9c90a$var$ModuleBinder.moduleBindings[modKey]) for(let propKey in ext)$c2a9788f40f9c90a$var$ModuleBinder._extendModule(modKey, propKey, ext[propKey]);
            else {
                if (!$c2a9788f40f9c90a$var$ModuleBinder.moduleExtensions[modKey]) $c2a9788f40f9c90a$var$ModuleBinder.moduleExtensions[modKey] = {};
                for(let propKey in ext){
                    if (!$c2a9788f40f9c90a$var$ModuleBinder.moduleExtensions[modKey][propKey]) $c2a9788f40f9c90a$var$ModuleBinder.moduleExtensions[modKey][propKey] = {};
                    Object.assign($c2a9788f40f9c90a$var$ModuleBinder.moduleExtensions[modKey][propKey], ext[propKey]);
                }
            }
        }
        $c2a9788f40f9c90a$var$ModuleBinder._extendModuleFromQueue(mod);
    }
    static _extendModuleFromQueue(mod) {
        var extensions = $c2a9788f40f9c90a$var$ModuleBinder.moduleExtensions[mod.moduleName];
        if (extensions) for(let propKey in extensions)$c2a9788f40f9c90a$var$ModuleBinder._extendModule(mod.moduleName, propKey, extensions[propKey]);
    }
    //ensure that module are bound to instantiated function
    _bindModules() {
        var orderedStartMods = [], orderedEndMods = [], unOrderedMods = [];
        this.modules = {};
        for(var name in $c2a9788f40f9c90a$var$ModuleBinder.moduleBindings){
            let mod = $c2a9788f40f9c90a$var$ModuleBinder.moduleBindings[name];
            let module = new mod(this);
            this.modules[name] = module;
            if (mod.prototype.moduleCore) this.modulesCore.push(module);
            else if (mod.moduleInitOrder) {
                if (mod.moduleInitOrder < 0) orderedStartMods.push(module);
                else orderedEndMods.push(module);
            } else unOrderedMods.push(module);
        }
        orderedStartMods.sort((a, b)=>a.moduleInitOrder > b.moduleInitOrder ? 1 : -1);
        orderedEndMods.sort((a, b)=>a.moduleInitOrder > b.moduleInitOrder ? 1 : -1);
        this.modulesRegular = orderedStartMods.concat(unOrderedMods.concat(orderedEndMods));
    }
}
class $c2a9788f40f9c90a$var$Alert extends $c2a9788f40f9c90a$var$CoreFeature {
    constructor(table){
        super(table);
        this.element = this._createAlertElement();
        this.msgElement = this._createMsgElement();
        this.type = null;
        this.element.appendChild(this.msgElement);
    }
    _createAlertElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-alert");
        return el;
    }
    _createMsgElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-alert-msg");
        el.setAttribute("role", "alert");
        return el;
    }
    _typeClass() {
        return "tabulator-alert-state-" + this.type;
    }
    alert(content, type = "msg") {
        if (content) {
            this.clear();
            this.dispatch("alert-show", type);
            this.type = type;
            while(this.msgElement.firstChild)this.msgElement.removeChild(this.msgElement.firstChild);
            this.msgElement.classList.add(this._typeClass());
            if (typeof content === "function") content = content();
            if (content instanceof HTMLElement) this.msgElement.appendChild(content);
            else this.msgElement.innerHTML = content;
            this.table.element.appendChild(this.element);
        }
    }
    clear() {
        this.dispatch("alert-hide", this.type);
        if (this.element.parentNode) this.element.parentNode.removeChild(this.element);
        this.msgElement.classList.remove(this._typeClass());
    }
}
class $c2a9788f40f9c90a$var$Tabulator extends $c2a9788f40f9c90a$var$ModuleBinder {
    //default setup options
    static defaultOptions = $c2a9788f40f9c90a$var$defaultOptions;
    static extendModule() {
        $c2a9788f40f9c90a$var$Tabulator.initializeModuleBinder();
        $c2a9788f40f9c90a$var$Tabulator._extendModule(...arguments);
    }
    static registerModule() {
        $c2a9788f40f9c90a$var$Tabulator.initializeModuleBinder();
        $c2a9788f40f9c90a$var$Tabulator._registerModule(...arguments);
    }
    constructor(element, options, modules){
        super();
        $c2a9788f40f9c90a$var$Tabulator.initializeModuleBinder(modules);
        this.options = {};
        this.columnManager = null; // hold Column Manager
        this.rowManager = null; //hold Row Manager
        this.footerManager = null; //holder Footer Manager
        this.alertManager = null; //hold Alert Manager
        this.vdomHoz = null; //holder horizontal virtual dom
        this.externalEvents = null; //handle external event messaging
        this.eventBus = null; //handle internal event messaging
        this.interactionMonitor = false; //track user interaction
        this.browser = ""; //hold current browser type
        this.browserSlow = false; //handle reduced functionality for slower browsers
        this.browserMobile = false; //check if running on mobile, prevent resize cancelling edit on keyboard appearance
        this.rtl = false; //check if the table is in RTL mode
        this.originalElement = null; //hold original table element if it has been replaced
        this.componentFunctionBinder = new $c2a9788f40f9c90a$var$ComponentFunctionBinder(this); //bind component functions
        this.dataLoader = false; //bind component functions
        this.modules = {}; //hold all modules bound to this table
        this.modulesCore = []; //hold core modules bound to this table (for initialization purposes)
        this.modulesRegular = []; //hold regular modules bound to this table (for initialization purposes)
        this.deprecationAdvisor = new $c2a9788f40f9c90a$var$DeprecationAdvisor(this);
        this.optionsList = new $c2a9788f40f9c90a$var$OptionsList(this, "table constructor");
        this.dependencyRegistry = new $c2a9788f40f9c90a$var$DependencyRegistry(this);
        this.initialized = false;
        this.destroyed = false;
        if (this.initializeElement(element)) {
            this.initializeCoreSystems(options);
            //delay table creation to allow event bindings immediately after the constructor
            setTimeout(()=>{
                this._create();
            });
        }
        this.constructor.registry.register(this); //register table for inter-device communication
    }
    initializeElement(element) {
        if (typeof HTMLElement !== "undefined" && element instanceof HTMLElement) {
            this.element = element;
            return true;
        } else if (typeof element === "string") {
            this.element = document.querySelector(element);
            if (this.element) return true;
            else {
                console.error("Tabulator Creation Error - no element found matching selector: ", element);
                return false;
            }
        } else {
            console.error("Tabulator Creation Error - Invalid element provided:", element);
            return false;
        }
    }
    initializeCoreSystems(options) {
        this.columnManager = new $c2a9788f40f9c90a$var$ColumnManager(this);
        this.rowManager = new $c2a9788f40f9c90a$var$RowManager(this);
        this.footerManager = new $c2a9788f40f9c90a$var$FooterManager(this);
        this.dataLoader = new $c2a9788f40f9c90a$var$DataLoader(this);
        this.alertManager = new $c2a9788f40f9c90a$var$Alert(this);
        this._bindModules();
        this.options = this.optionsList.generate($c2a9788f40f9c90a$var$Tabulator.defaultOptions, options);
        this._clearObjectPointers();
        this._mapDeprecatedFunctionality();
        this.externalEvents = new $c2a9788f40f9c90a$var$ExternalEventBus(this, this.options, this.options.debugEventsExternal);
        this.eventBus = new $c2a9788f40f9c90a$var$InternalEventBus(this.options.debugEventsInternal);
        this.interactionMonitor = new $c2a9788f40f9c90a$var$InteractionManager(this);
        this.dataLoader.initialize();
        this.footerManager.initialize();
        this.dependencyRegistry.initialize();
    }
    //convert deprecated functionality to new functions
    _mapDeprecatedFunctionality() {
    //all previously deprecated functionality removed in the 6.0 release
    }
    _clearSelection() {
        this.element.classList.add("tabulator-block-select");
        if (window.getSelection) {
            if (window.getSelection().empty) window.getSelection().empty();
            else if (window.getSelection().removeAllRanges) window.getSelection().removeAllRanges();
        } else if (document.selection) document.selection.empty();
        this.element.classList.remove("tabulator-block-select");
    }
    //create table
    _create() {
        this.externalEvents.dispatch("tableBuilding");
        this.eventBus.dispatch("table-building");
        this._rtlCheck();
        this._buildElement();
        this._initializeTable();
        this.initialized = true;
        this._loadInitialData().finally(()=>{
            this.eventBus.dispatch("table-initialized");
            this.externalEvents.dispatch("tableBuilt");
        });
    }
    _rtlCheck() {
        var style = window.getComputedStyle(this.element);
        switch(this.options.textDirection){
            case "auto":
                if (style.direction !== "rtl") break;
            case "rtl":
                this.element.classList.add("tabulator-rtl");
                this.rtl = true;
                break;
            case "ltr":
                this.element.classList.add("tabulator-ltr");
            default:
                this.rtl = false;
        }
    }
    //clear pointers to objects in default config object
    _clearObjectPointers() {
        this.options.columns = this.options.columns.slice(0);
        if (Array.isArray(this.options.data) && !this.options.reactiveData) this.options.data = this.options.data.slice(0);
    }
    //build tabulator element
    _buildElement() {
        var element = this.element, options = this.options, newElement;
        if (element.tagName === "TABLE") {
            this.originalElement = this.element;
            newElement = document.createElement("div");
            //transfer attributes to new element
            var attributes = element.attributes;
            // loop through attributes and apply them on div
            for(var i in attributes)if (typeof attributes[i] == "object") newElement.setAttribute(attributes[i].name, attributes[i].value);
            // replace table with div element
            element.parentNode.replaceChild(newElement, element);
            this.element = element = newElement;
        }
        element.classList.add("tabulator");
        element.setAttribute("role", "grid");
        //empty element
        while(element.firstChild)element.removeChild(element.firstChild);
        //set table height
        if (options.height) {
            options.height = isNaN(options.height) ? options.height : options.height + "px";
            element.style.height = options.height;
        }
        //set table min height
        if (options.minHeight !== false) {
            options.minHeight = isNaN(options.minHeight) ? options.minHeight : options.minHeight + "px";
            element.style.minHeight = options.minHeight;
        }
        //set table maxHeight
        if (options.maxHeight !== false) {
            options.maxHeight = isNaN(options.maxHeight) ? options.maxHeight : options.maxHeight + "px";
            element.style.maxHeight = options.maxHeight;
        }
    }
    //initialize core systems and modules
    _initializeTable() {
        var element = this.element, options = this.options;
        this.interactionMonitor.initialize();
        this.columnManager.initialize();
        this.rowManager.initialize();
        this._detectBrowser();
        //initialize core modules
        this.modulesCore.forEach((mod)=>{
            mod.initialize();
        });
        //build table elements
        element.appendChild(this.columnManager.getElement());
        element.appendChild(this.rowManager.getElement());
        if (options.footerElement) this.footerManager.activate();
        if (options.autoColumns && options.data) this.columnManager.generateColumnsFromRowData(this.options.data);
        //initialize regular modules
        this.modulesRegular.forEach((mod)=>{
            mod.initialize();
        });
        this.columnManager.setColumns(options.columns);
        this.eventBus.dispatch("table-built");
    }
    _loadInitialData() {
        return this.dataLoader.load(this.options.data).finally(()=>{
            this.columnManager.verticalAlignHeaders();
        });
    }
    //deconstructor
    destroy() {
        var element = this.element;
        this.destroyed = true;
        this.constructor.registry.deregister(this); //deregister table from inter-device communication
        this.eventBus.dispatch("table-destroy");
        //clear row data
        this.rowManager.destroy();
        //clear DOM
        while(element.firstChild)element.removeChild(element.firstChild);
        element.classList.remove("tabulator");
        this.externalEvents.dispatch("tableDestroyed");
    }
    _detectBrowser() {
        var ua = navigator.userAgent || navigator.vendor || window.opera;
        if (ua.indexOf("Trident") > -1) {
            this.browser = "ie";
            this.browserSlow = true;
        } else if (ua.indexOf("Edge") > -1) {
            this.browser = "edge";
            this.browserSlow = true;
        } else if (ua.indexOf("Firefox") > -1) {
            this.browser = "firefox";
            this.browserSlow = false;
        } else if (ua.indexOf("Mac OS") > -1) {
            this.browser = "safari";
            this.browserSlow = false;
        } else {
            this.browser = "other";
            this.browserSlow = false;
        }
        this.browserMobile = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(ua) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(ua.slice(0, 4));
    }
    initGuard(func, msg) {
        var stack, line;
        if (this.options.debugInitialization && !this.initialized) {
            if (!func) {
                stack = new Error().stack.split("\n");
                line = stack[0] == "Error" ? stack[2] : stack[1];
                if (line[0] == " ") func = line.trim().split(" ")[1].split(".")[1];
                else func = line.trim().split("@")[0];
            }
            console.warn("Table Not Initialized - Calling the " + func + " function before the table is initialized may result in inconsistent behavior, Please wait for the `tableBuilt` event before calling this function." + (msg ? " " + msg : ""));
        }
        return this.initialized;
    }
    ////////////////// Data Handling //////////////////
    //block table redrawing
    blockRedraw() {
        this.initGuard();
        this.eventBus.dispatch("redraw-blocking");
        this.rowManager.blockRedraw();
        this.columnManager.blockRedraw();
        this.eventBus.dispatch("redraw-blocked");
    }
    //restore table redrawing
    restoreRedraw() {
        this.initGuard();
        this.eventBus.dispatch("redraw-restoring");
        this.rowManager.restoreRedraw();
        this.columnManager.restoreRedraw();
        this.eventBus.dispatch("redraw-restored");
    }
    //load data
    setData(data, params, config) {
        this.initGuard(false, "To set initial data please use the 'data' property in the table constructor.");
        return this.dataLoader.load(data, params, config, false);
    }
    //clear data
    clearData() {
        this.initGuard();
        this.dataLoader.blockActiveLoad();
        this.rowManager.clearData();
    }
    //get table data array
    getData(active) {
        return this.rowManager.getData(active);
    }
    //get table data array count
    getDataCount(active) {
        return this.rowManager.getDataCount(active);
    }
    //replace data, keeping table in position with same sort
    replaceData(data, params, config) {
        this.initGuard();
        return this.dataLoader.load(data, params, config, true, true);
    }
    //update table data
    updateData(data) {
        var responses = 0;
        this.initGuard();
        return new Promise((resolve, reject)=>{
            this.dataLoader.blockActiveLoad();
            if (typeof data === "string") data = JSON.parse(data);
            if (data && data.length > 0) data.forEach((item)=>{
                var row = this.rowManager.findRow(item[this.options.index]);
                if (row) {
                    responses++;
                    row.updateData(item).then(()=>{
                        responses--;
                        if (!responses) resolve();
                    }).catch((e)=>{
                        reject("Update Error - Unable to update row", item, e);
                    });
                } else reject("Update Error - Unable to find row", item);
            });
            else {
                console.warn("Update Error - No data provided");
                reject("Update Error - No data provided");
            }
        });
    }
    addData(data, pos, index) {
        this.initGuard();
        return new Promise((resolve, reject)=>{
            this.dataLoader.blockActiveLoad();
            if (typeof data === "string") data = JSON.parse(data);
            if (data) this.rowManager.addRows(data, pos, index).then((rows)=>{
                var output = [];
                rows.forEach(function(row) {
                    output.push(row.getComponent());
                });
                resolve(output);
            });
            else {
                console.warn("Update Error - No data provided");
                reject("Update Error - No data provided");
            }
        });
    }
    //update table data
    updateOrAddData(data) {
        var rows = [], responses = 0;
        this.initGuard();
        return new Promise((resolve, reject)=>{
            this.dataLoader.blockActiveLoad();
            if (typeof data === "string") data = JSON.parse(data);
            if (data && data.length > 0) data.forEach((item)=>{
                var row = this.rowManager.findRow(item[this.options.index]);
                responses++;
                if (row) row.updateData(item).then(()=>{
                    responses--;
                    rows.push(row.getComponent());
                    if (!responses) resolve(rows);
                });
                else this.rowManager.addRows(item).then((newRows)=>{
                    responses--;
                    rows.push(newRows[0].getComponent());
                    if (!responses) resolve(rows);
                });
            });
            else {
                console.warn("Update Error - No data provided");
                reject("Update Error - No data provided");
            }
        });
    }
    //get row object
    getRow(index) {
        var row = this.rowManager.findRow(index);
        if (row) return row.getComponent();
        else {
            console.warn("Find Error - No matching row found:", index);
            return false;
        }
    }
    //get row object
    getRowFromPosition(position) {
        var row = this.rowManager.getRowFromPosition(position);
        if (row) return row.getComponent();
        else {
            console.warn("Find Error - No matching row found:", position);
            return false;
        }
    }
    //delete row from table
    deleteRow(index) {
        var foundRows = [];
        this.initGuard();
        if (!Array.isArray(index)) index = [
            index
        ];
        //find matching rows
        for (let item of index){
            let row = this.rowManager.findRow(item, true);
            if (row) foundRows.push(row);
            else {
                console.error("Delete Error - No matching row found:", item);
                return Promise.reject("Delete Error - No matching row found");
            }
        }
        //sort rows into correct order to ensure smooth delete from table
        foundRows.sort((a, b)=>{
            return this.rowManager.rows.indexOf(a) > this.rowManager.rows.indexOf(b) ? 1 : -1;
        });
        //delete rows
        foundRows.forEach((row)=>{
            row.delete();
        });
        this.rowManager.reRenderInPosition();
        return Promise.resolve();
    }
    //add row to table
    addRow(data, pos, index) {
        this.initGuard();
        if (typeof data === "string") data = JSON.parse(data);
        return this.rowManager.addRows(data, pos, index, true).then((rows)=>{
            return rows[0].getComponent();
        });
    }
    //update a row if it exists otherwise create it
    updateOrAddRow(index, data) {
        var row = this.rowManager.findRow(index);
        this.initGuard();
        if (typeof data === "string") data = JSON.parse(data);
        if (row) return row.updateData(data).then(()=>{
            return row.getComponent();
        });
        else return this.rowManager.addRows(data).then((rows)=>{
            return rows[0].getComponent();
        });
    }
    //update row data
    updateRow(index, data) {
        var row = this.rowManager.findRow(index);
        this.initGuard();
        if (typeof data === "string") data = JSON.parse(data);
        if (row) return row.updateData(data).then(()=>{
            return Promise.resolve(row.getComponent());
        });
        else {
            console.warn("Update Error - No matching row found:", index);
            return Promise.reject("Update Error - No matching row found");
        }
    }
    //scroll to row in DOM
    scrollToRow(index, position, ifVisible) {
        var row = this.rowManager.findRow(index);
        if (row) return this.rowManager.scrollToRow(row, position, ifVisible);
        else {
            console.warn("Scroll Error - No matching row found:", index);
            return Promise.reject("Scroll Error - No matching row found");
        }
    }
    moveRow(from, to, after) {
        var fromRow = this.rowManager.findRow(from);
        this.initGuard();
        if (fromRow) fromRow.moveToRow(to, after);
        else console.warn("Move Error - No matching row found:", from);
    }
    getRows(active) {
        return this.rowManager.getComponents(active);
    }
    //get position of row in table
    getRowPosition(index) {
        var row = this.rowManager.findRow(index);
        if (row) return row.getPosition();
        else {
            console.warn("Position Error - No matching row found:", index);
            return false;
        }
    }
    /////////////// Column Functions  ///////////////
    setColumns(definition) {
        this.initGuard(false, "To set initial columns please use the 'columns' property in the table constructor");
        this.columnManager.setColumns(definition);
    }
    getColumns(structured) {
        return this.columnManager.getComponents(structured);
    }
    getColumn(field) {
        var column = this.columnManager.findColumn(field);
        if (column) return column.getComponent();
        else {
            console.warn("Find Error - No matching column found:", field);
            return false;
        }
    }
    getColumnDefinitions() {
        return this.columnManager.getDefinitionTree();
    }
    showColumn(field) {
        var column = this.columnManager.findColumn(field);
        this.initGuard();
        if (column) column.show();
        else {
            console.warn("Column Show Error - No matching column found:", field);
            return false;
        }
    }
    hideColumn(field) {
        var column = this.columnManager.findColumn(field);
        this.initGuard();
        if (column) column.hide();
        else {
            console.warn("Column Hide Error - No matching column found:", field);
            return false;
        }
    }
    toggleColumn(field) {
        var column = this.columnManager.findColumn(field);
        this.initGuard();
        if (column) {
            if (column.visible) column.hide();
            else column.show();
        } else {
            console.warn("Column Visibility Toggle Error - No matching column found:", field);
            return false;
        }
    }
    addColumn(definition, before, field) {
        var column = this.columnManager.findColumn(field);
        this.initGuard();
        return this.columnManager.addColumn(definition, before, column).then((column)=>{
            return column.getComponent();
        });
    }
    deleteColumn(field) {
        var column = this.columnManager.findColumn(field);
        this.initGuard();
        if (column) return column.delete();
        else {
            console.warn("Column Delete Error - No matching column found:", field);
            return Promise.reject();
        }
    }
    updateColumnDefinition(field, definition) {
        var column = this.columnManager.findColumn(field);
        this.initGuard();
        if (column) return column.updateDefinition(definition);
        else {
            console.warn("Column Update Error - No matching column found:", field);
            return Promise.reject();
        }
    }
    moveColumn(from, to, after) {
        var fromColumn = this.columnManager.findColumn(from), toColumn = this.columnManager.findColumn(to);
        this.initGuard();
        if (fromColumn) {
            if (toColumn) this.columnManager.moveColumn(fromColumn, toColumn, after);
            else console.warn("Move Error - No matching column found:", toColumn);
        } else console.warn("Move Error - No matching column found:", from);
    }
    //scroll to column in DOM
    scrollToColumn(field, position, ifVisible) {
        return new Promise((resolve, reject)=>{
            var column = this.columnManager.findColumn(field);
            if (column) return this.columnManager.scrollToColumn(column, position, ifVisible);
            else {
                console.warn("Scroll Error - No matching column found:", field);
                return Promise.reject("Scroll Error - No matching column found");
            }
        });
    }
    //////////// General Public Functions ////////////
    //redraw list without updating data
    redraw(force) {
        this.initGuard();
        this.columnManager.redraw(force);
        this.rowManager.redraw(force);
    }
    setHeight(height) {
        this.options.height = isNaN(height) ? height : height + "px";
        this.element.style.height = this.options.height;
        this.rowManager.initializeRenderer();
        this.rowManager.redraw(true);
    }
    //////////////////// Event Bus ///////////////////
    on(key, callback) {
        this.externalEvents.subscribe(key, callback);
    }
    off(key, callback) {
        this.externalEvents.unsubscribe(key, callback);
    }
    dispatchEvent() {
        var args = Array.from(arguments);
        args.shift();
        this.externalEvents.dispatch(...arguments);
    }
    //////////////////// Alerts ///////////////////
    alert(contents, type) {
        this.initGuard();
        this.alertManager.alert(contents, type);
    }
    clearAlert() {
        this.initGuard();
        this.alertManager.clear();
    }
    ////////////// Extension Management //////////////
    modExists(plugin, required) {
        if (this.modules[plugin]) return true;
        else {
            if (required) console.error("Tabulator Module Not Installed: " + plugin);
            return false;
        }
    }
    module(key) {
        var mod = this.modules[key];
        if (!mod) console.error("Tabulator module not installed: " + key);
        return mod;
    }
}
var $c2a9788f40f9c90a$export$cd7cfffa934dc7d2 = $c2a9788f40f9c90a$var$Tabulator;
//tabulator with all modules installed
class $c2a9788f40f9c90a$var$TabulatorFull extends $c2a9788f40f9c90a$export$cd7cfffa934dc7d2 {
    static extendModule() {
        $c2a9788f40f9c90a$export$cd7cfffa934dc7d2.initializeModuleBinder($c2a9788f40f9c90a$var$allModules);
        $c2a9788f40f9c90a$export$cd7cfffa934dc7d2._extendModule(...arguments);
    }
    static registerModule() {
        $c2a9788f40f9c90a$export$cd7cfffa934dc7d2.initializeModuleBinder($c2a9788f40f9c90a$var$allModules);
        $c2a9788f40f9c90a$export$cd7cfffa934dc7d2._registerModule(...arguments);
    }
    constructor(element, options, modules){
        super(element, options, $c2a9788f40f9c90a$var$allModules);
    }
}
var $c2a9788f40f9c90a$export$62676a0a2827a643 = $c2a9788f40f9c90a$var$TabulatorFull;
class $c2a9788f40f9c90a$export$8d0cd4d1f07aaaa6 {
    constructor(type){
        this.type = type;
        this.element = this._createElement();
    }
    _createElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-row");
        return el;
    }
    getElement() {
        return this.element;
    }
    getComponent() {
        return false;
    }
    getData() {
        return {};
    }
    getHeight() {
        return this.element.outerHeight;
    }
    initialize() {}
    reinitialize() {}
    normalizeHeight() {}
    generateCells() {}
    reinitializeHeight() {}
    calcHeight() {}
    setCellHeight() {}
    clearCellHeight() {}
    rendered() {}
}



function $a5180036a01fc904$var$formatBoolean(cell) {
    const v = cell.getValue();
    return v ? "\u2713" : "";
}
function $a5180036a01fc904$var$formatDate(cell) {
    const v = cell.getValue();
    return v ? v.format() : "";
}
function $a5180036a01fc904$export$c4c806e061935577(a, b, _aRow, _bRow, _col, dir) {
    if (a === b) return 0;
    if (dir === "asc") {
        if (!a) return 1;
        if (!b) return -1;
    } else {
        if (!a) return -1;
        if (!b) return 1;
    }
    return a.parsed.valueOf() - b.parsed.valueOf();
}
function $a5180036a01fc904$var$compareStringArrays(a, b) {
    return a.join(",").localeCompare(b.join(","));
}
function $a5180036a01fc904$var$formatStringArrays(cell) {
    const v = cell.getValue();
    return v ? v.join("; ") : "";
}
const $a5180036a01fc904$var$PLACE_COLUMNS = [
    {
        title: "Place",
        field: "place",
        width: 180,
        frozen: true,
        formatter: "link",
        formatterParams: {
            urlField: "url",
            labelField: "place",
            target: "_blank"
        }
    },
    {
        title: "State",
        field: "state",
        width: 120
    },
    {
        title: "Country",
        field: "country",
        width: 120
    },
    {
        title: "Jurisdiction",
        field: "placeType",
        width: 80
    },
    {
        title: "Population",
        field: "population",
        sorter: "number",
        sorterParams: {
            // @ts-expect-error type hint is wrong
            thousandSeparator: ","
        },
        width: 90
    }
];
const $a5180036a01fc904$var$DATE_COLUMN = {
    title: "Date",
    field: "date",
    width: 110,
    formatter: $a5180036a01fc904$var$formatDate,
    sorter: $a5180036a01fc904$export$c4c806e061935577
};
const $a5180036a01fc904$var$BENEFIT_DISTRICT_COLUMNS = [
    ...$a5180036a01fc904$var$PLACE_COLUMNS,
    $a5180036a01fc904$var$DATE_COLUMN
];
const $a5180036a01fc904$var$LAND_USE_COLUMNS = [
    ...$a5180036a01fc904$var$PLACE_COLUMNS,
    $a5180036a01fc904$var$DATE_COLUMN,
    {
        title: "Scope",
        field: "scope",
        width: 260,
        formatter: $a5180036a01fc904$var$formatStringArrays,
        sorter: $a5180036a01fc904$var$compareStringArrays
    },
    {
        title: "Land use",
        field: "landUse",
        width: 160,
        formatter: $a5180036a01fc904$var$formatStringArrays,
        sorter: $a5180036a01fc904$var$compareStringArrays
    }
];
const $a5180036a01fc904$var$ANY_REFORM_COLUMNS = [
    ...$a5180036a01fc904$var$PLACE_COLUMNS,
    {
        title: "Reduce minimums",
        field: "reduceMin",
        width: 120,
        formatter: $a5180036a01fc904$var$formatBoolean,
        hozAlign: "center"
    },
    {
        title: "Remove minimums",
        field: "rmMin",
        width: 120,
        formatter: $a5180036a01fc904$var$formatBoolean,
        hozAlign: "center"
    },
    {
        title: "Add maximums",
        field: "addMax",
        width: 120,
        formatter: $a5180036a01fc904$var$formatBoolean,
        hozAlign: "center"
    },
    {
        title: "Benefit district",
        field: "benefitDistrict",
        width: 120,
        formatter: $a5180036a01fc904$var$formatBoolean,
        hozAlign: "center"
    }
];
function $a5180036a01fc904$export$9b6821122b46212c(policyType, status) {
    const policy = {
        "any parking reform": "overview",
        "add parking maximums": "maximums",
        "remove parking minimums": "remove-minimums",
        "reduce parking minimums": "reduce-minimums",
        "parking benefit district": "benefit-district"
    }[policyType];
    return `parking-reforms--${policy}--${status}.csv`;
}
function $a5180036a01fc904$var$updateCounterDownload(table, policyType, status) {
    const button = document.querySelector(".counter-table-download");
    if (!button) return;
    button.addEventListener("click", ()=>table.download("csv", $a5180036a01fc904$export$9b6821122b46212c(policyType, status)));
}
function $a5180036a01fc904$export$2e2bcd8739ae039(filterManager, viewToggle) {
    (0, $c2a9788f40f9c90a$export$cd7cfffa934dc7d2).registerModule([
        (0, $c2a9788f40f9c90a$export$2e3bebbdf3339a4e),
        (0, $c2a9788f40f9c90a$export$5634f967e02d772d),
        (0, $c2a9788f40f9c90a$export$c00c4e95a253fbf9),
        (0, $c2a9788f40f9c90a$export$5b492eb49d632e3f),
        (0, $c2a9788f40f9c90a$export$3a1ca422b395df54),
        (0, $c2a9788f40f9c90a$export$9ab7496e9b38c128),
        (0, $c2a9788f40f9c90a$export$7eba6c45a494ceac),
        (0, $c2a9788f40f9c90a$export$4e0f34fd9829977c),
        (0, $c2a9788f40f9c90a$export$6dd96c6d41f32a97)
    ]);
    // For "any parking reform", we need distinct datasets for each ReformStatus because the
    // column values change. Whereas for the policy record datasets, we can use a
    // single dataset for all the statuses because the filter code (from FilterState)
    // will already filter out records that don't match the current status.
    const dataAnyAdopted = [];
    const dataAnyProposed = [];
    const dataAnyRepealed = [];
    const dataReduceMin = [];
    const dataRmMin = [];
    const dataAddMax = [];
    const dataBenefitDistrict = [];
    Object.entries(filterManager.entries).forEach(([placeId, entry])=>{
        const common = {
            placeId: placeId,
            place: entry.place.name,
            state: entry.place.state,
            country: entry.place.country,
            placeType: entry.place.type,
            population: entry.place.pop.toLocaleString("en-us"),
            url: entry.place.url
        };
        const adopted = (0, $b073965913779e61$export$8edda515ca9656ca)(entry, "adopted");
        dataAnyAdopted.push({
            ...common,
            reduceMin: adopted.includes("reduce parking minimums"),
            rmMin: adopted.includes("remove parking minimums"),
            addMax: adopted.includes("add parking maximums"),
            benefitDistrict: adopted.includes("parking benefit district")
        });
        const proposed = (0, $b073965913779e61$export$8edda515ca9656ca)(entry, "proposed");
        dataAnyProposed.push({
            ...common,
            reduceMin: proposed.includes("reduce parking minimums"),
            rmMin: proposed.includes("remove parking minimums"),
            addMax: proposed.includes("add parking maximums"),
            benefitDistrict: proposed.includes("parking benefit district")
        });
        const repealed = (0, $b073965913779e61$export$8edda515ca9656ca)(entry, "repealed");
        dataAnyRepealed.push({
            ...common,
            reduceMin: repealed.includes("reduce parking minimums"),
            rmMin: repealed.includes("remove parking minimums"),
            addMax: repealed.includes("add parking maximums"),
            benefitDistrict: repealed.includes("parking benefit district")
        });
        const saveLandUsePolicies = (collection, policies)=>policies?.forEach((policy, i)=>collection.push({
                    ...common,
                    policyIdx: i,
                    date: policy.date,
                    status: policy.status,
                    landUse: policy.land,
                    scope: policy.scope
                }));
        const saveParkingBenefit = (collection, policies)=>policies?.forEach((policy, i)=>collection.push({
                    ...common,
                    policyIdx: i,
                    date: policy.date,
                    status: policy.status
                }));
        saveLandUsePolicies(dataAddMax, entry.add_max);
        saveLandUsePolicies(dataReduceMin, entry.reduce_min);
        saveLandUsePolicies(dataRmMin, entry.rm_min);
        saveParkingBenefit(dataBenefitDistrict, entry.benefit_district);
    });
    const filterStateToConfig = {
        "any parking reform": {
            adopted: [
                $a5180036a01fc904$var$ANY_REFORM_COLUMNS,
                dataAnyAdopted
            ],
            proposed: [
                $a5180036a01fc904$var$ANY_REFORM_COLUMNS,
                dataAnyProposed
            ],
            repealed: [
                $a5180036a01fc904$var$ANY_REFORM_COLUMNS,
                dataAnyRepealed
            ]
        },
        "reduce parking minimums": {
            adopted: [
                $a5180036a01fc904$var$LAND_USE_COLUMNS,
                dataReduceMin
            ],
            proposed: [
                $a5180036a01fc904$var$LAND_USE_COLUMNS,
                dataReduceMin
            ],
            repealed: [
                $a5180036a01fc904$var$LAND_USE_COLUMNS,
                dataReduceMin
            ]
        },
        "remove parking minimums": {
            adopted: [
                $a5180036a01fc904$var$LAND_USE_COLUMNS,
                dataRmMin
            ],
            proposed: [
                $a5180036a01fc904$var$LAND_USE_COLUMNS,
                dataRmMin
            ],
            repealed: [
                $a5180036a01fc904$var$LAND_USE_COLUMNS,
                dataRmMin
            ]
        },
        "add parking maximums": {
            adopted: [
                $a5180036a01fc904$var$LAND_USE_COLUMNS,
                dataAddMax
            ],
            proposed: [
                $a5180036a01fc904$var$LAND_USE_COLUMNS,
                dataAddMax
            ],
            repealed: [
                $a5180036a01fc904$var$LAND_USE_COLUMNS,
                dataAddMax
            ]
        },
        "parking benefit district": {
            adopted: [
                $a5180036a01fc904$var$BENEFIT_DISTRICT_COLUMNS,
                dataBenefitDistrict
            ],
            proposed: [
                $a5180036a01fc904$var$BENEFIT_DISTRICT_COLUMNS,
                dataBenefitDistrict
            ],
            repealed: [
                $a5180036a01fc904$var$BENEFIT_DISTRICT_COLUMNS,
                dataBenefitDistrict
            ]
        }
    };
    // We track what the filter is currently set to. When the filter changes,
    // we need to load the new columns and data.
    let currentPolicyTypeFilter = filterManager.getState().policyTypeFilter;
    let currentStatus = filterManager.getState().status;
    const [columns, data] = filterStateToConfig[currentPolicyTypeFilter][currentStatus];
    const table = new (0, $c2a9788f40f9c90a$export$cd7cfffa934dc7d2)("#table", {
        data: data,
        columns: columns,
        layout: "fitColumns",
        movableColumns: true,
        // We use pagination to avoid performance issues.
        pagination: true,
        paginationSize: 100,
        paginationCounter: (_pageSize, _currentRow, currentPage, _totalRows, totalPages)=>`Page ${currentPage} of ${totalPages}`
    });
    // We use Tabulator's filter to add/remove records based on FilterState,
    // as it's much faster than resetting the data.
    //
    // Note that the same filter works for every PolicyTypeFilter, meaning we
    // don't need to re-set this up based on which is chosen.
    let tableBuilt = false;
    table.on("tableBuilt", ()=>{
        tableBuilt = true;
        table.setFilter((row)=>{
            const entry = filterManager.matchedPlaces[row.placeId];
            if (!entry) return false;
            if (entry.type === "any") return true;
            // With search, we ignore the normal filters like jurisdiction. However,
            // we do still have to pay attention to what dataset is loaded
            // (policy type x status).
            if (entry.type === "search") {
                // With 'any parking reform', each reform status has a different dataset already.
                // So, it's safe to include the entry from search.
                if (currentPolicyTypeFilter === "any parking reform") return true;
                return row.status === currentStatus;
            }
            return entry.matchingIndexes.includes(row.policyIdx);
        });
    });
    // Either re-filter the data or load an entirely new dataset.
    const updateData = (newPolicyTypeFilter, newStatus)=>{
        if (newPolicyTypeFilter === currentPolicyTypeFilter && newStatus === currentStatus) table.refreshFilter();
        else {
            currentPolicyTypeFilter = newPolicyTypeFilter;
            currentStatus = newStatus;
            const [columns2, data2] = filterStateToConfig[newPolicyTypeFilter][newStatus];
            table.setColumns(columns2);
            table.setData(data2);
        }
    };
    // When on map view, we should only lazily update the table the next time
    // we switch to table view.
    let dataRefreshQueued = false;
    filterManager.subscribe("update table's records", ({ policyTypeFilter: policyTypeFilter, status: status })=>{
        $a5180036a01fc904$var$updateCounterDownload(table, policyTypeFilter, status);
        if (!tableBuilt) return;
        if (viewToggle.getValue() === "map") {
            dataRefreshQueued = true;
            return;
        }
        updateData(policyTypeFilter, status);
    });
    viewToggle.subscribe((view)=>{
        if (view === "map" || !dataRefreshQueued) return;
        dataRefreshQueued = false;
        const state = filterManager.getState();
        updateData(state.policyTypeFilter, state.status);
    }, "apply queued table data refresh");
    return table;
}


async function $6bcee6a4989673ce$export$2e2bcd8739ae039() {
    (0, $bd8d6d84c8bdc892$export$2e2bcd8739ae039)();
    (0, $307247af3eff64a9$export$2e2bcd8739ae039)();
    (0, $9c0340c7c89ecadd$export$2e2bcd8739ae039)();
    (0, $c3cfe4cae09d8cf2$export$2e2bcd8739ae039)();
    const viewToggle = (0, $03248c494acf54bf$export$ccd129d907a77f1b)();
    const map = (0, $b55fa19645e7687c$export$2e2bcd8739ae039)();
    (0, $a4deed459da56e8e$export$2e2bcd8739ae039)(window.location.search);
    const data = await (0, $b073965913779e61$export$2e2bcd8739ae039)();
    const initialState = (0, $56eb3cba434809a6$export$742a972d8a0c6161)(window.location.search);
    const filterManager = new (0, $924e72120b481a6c$export$eade628d430495c7)(data, initialState);
    const markerGroup = (0, $b607d558aa74de54$export$2e2bcd8739ae039)(filterManager, map, viewToggle);
    (0, $eced37d3792d94dd$export$2e2bcd8739ae039)(filterManager, map);
    (0, $441f0ff734ef5ef9$export$2e2bcd8739ae039)(filterManager);
    (0, $d2fbdb601ef9b65c$export$2e2bcd8739ae039)(filterManager);
    (0, $7d90c7ac1787964b$export$7dc75e8b568dd691)(filterManager);
    (0, $c9a412278fd027ee$export$2e2bcd8739ae039)(filterManager);
    const table = (0, $a5180036a01fc904$export$2e2bcd8739ae039)(filterManager, viewToggle);
    (0, $03248c494acf54bf$export$51c63440b0a0743)(viewToggle, table);
    (0, $8153ad3722c60d25$export$2e2bcd8739ae039)(filterManager, viewToggle, markerGroup, data);
    viewToggle.initialize();
    filterManager.initialize();
}
window.onload = async ()=>{
    await $6bcee6a4989673ce$export$2e2bcd8739ae039();
};


//# sourceMappingURL=index.8310665f.js.map
